var MM = Object.defineProperty;
var XM = (s, t, e) => t in s ? MM(s, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : s[t] = e;
var Jt = (s, t, e) => (XM(s, typeof t != "symbol" ? t + "" : t, e), e), GM = (s, t, e) => {
  if (!t.has(s))
    throw TypeError("Cannot " + e);
};
var wb = (s, t, e) => {
  if (t.has(s))
    throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(s) : t.set(s, e);
};
var Vp = (s, t, e) => (GM(s, t, "access private method"), e);
import { Configs as Ne, Cookies as $L, Token as Vo, PensionCompany as Is, SettingsLogic as C0, Role as SL, Translations as L, AuthorizationType as HM, WebSiteUserRole as Ws, OData as qo, Dates as I, Texts as ti, ExportMethod as Ta, Tables as Ko, TableFormat as Ab, JsonSchemaCache as UM, JsonSchemaUtils as ol, SitemapVisibility as _a, Arrays as ie, Objects as Qe, RoleLogic as Md, EmploymentRelationTaxcard as Xa, TaxcardKind as ma, TaxCard2019Logic as La, EmploymentLogic as Ma, Numeric as se, Payrolls as Cw, CalculatorLogic as Da, PaymentChannel as At, InvoicesLogic as ne, InvoiceStatus as Ft, InvoiceType as ce, LegalEntityType as Xi, PayrollStatus as Ua, SalaryDateKind as $n, SalaryDateLogic as gc, CalculationStatus as le, CalculationResultLogic as Vy, Payrolls4 as Pl, ReportsLogic as vv, AccountingReportTableType as Cb, PeriodType as Wi, CalcRowsLogic as Gi, CalculationRowType as Wt, CalculationRowSource as On, Years as gr, OAuthSalaxyAuthorizeMode as kL, Language as Me, OnboardingLogic as TL, UsecaseStatus as Ni, ApiItemType as Rn, StorageLogic as LL, AvatarPictureType as is, SystemRole as qy, HrSuuntiImportLogic as qp, DataMapper as br, FileParser as $w, ValidationHelper as FM, Brand as oc, HouseholdUsecasesLogic as hi, CalculationRowUnit as xv, UnionPaymentType as zM, BootstrapStyle as cc, AbsenceCauseCode as Ge, IncomeTypesLogic as Tn, IrRowSourceType as BM, Unit as as, ReportType as Xd, HolidaysLogic as dn, HolidayCode as Se, WageBasis as qs, HolidayPayCalculation as Be, CostAccountingDimensionScope as gs, RowsUsecaseLogic as Jo, UserDefinedRowLogic as $0, EnumerationsLogic as He, BicHelper as Ky, Iban as Sw, MessageThreadStatus as eu, MessageFrom as Xn, ThreadedMessageType as ja, ContactType as js, ApiValidationErrorType as Ra, kevaEmploymentRegCodes as S0, HolidayBonusPaymentMethod as Yh, PensionCalculation as DL, cbaCodes as WM, Occupations as dc, DateTimes as ys, CellRenderingLogic as k0, Calculations as nm, DataMappersLogic as yc, Culture as T0, ImportBatch as jM, ExportLogic as VM, ApiImportStatus as Pn, RowMergeOption as $b, DataMapperSelector as L0, ApiCheckStatus as D0, WorktimeApiConnector as IL, InvoicePaymentType as qM, PaymentChannelApi as wv, Promises as KM, SharingUriType as Po, HouseholdYearProcessingStatus as JM, TaxDeductionWorkCategories as QM, TimesheetInputModification as kd, PeriodDateKind as _u, AccountingTargetLogic as ZM, AccountingChannel as Ks, irepr as ea, irpsr as Kp, DatasetStatus as PL, DatasetType as EL, PaidSickLeaveKind as uc, TrainingKind as pc, NonProfitOrgKind as NL, OtherCompensationKind as An, RemunerationKind as Eo, WorkingTimeCompensationKind as Ls, EmploymentTerminationKind as gd, AllowanceCode as Jp, DailyAllowanceKind as yd, AccountantType as $l, AccountingTargets as I0, FileLogic as Qp, FileDelimiter as tX, SettingsStatus as RL, WorkerSalarySlipDeliveryMethod as ps, LocalTapiolaInsuranceOrderType as Sb, TranslationsInstance as Zp, FormHelpers as Gd, Country as P0, EmploymentRelationSalaryPaymentMethod as eX, Validation as cn, HolidayAccrualSource as th, AnnualLeavePaymentKind as aX, TaxCardIncomeType as jr, RecurringEventCreateMode as YL, CalendarActionType as No, ActionExecutor as Av, UsecaseActionType as nX, CustomerInvoices as sX, Absences as iX, Accounts as rX, AccountSettings as lX, AuthorizedAccounts as oX, BeneficialOwnersApi as cX, Calculator as dX, CalendarEvents as uX, Certificates as pX, Client as hX, Credentials as mX, Datasets as gX, Employments as yX, Files as fX, HolidayYears as bX, Imports as vX, Invoices as xX, IrEarningsPayments as wX, IrPayerSummaries as AX, MessageThreads as CX, OAuth2 as $X, Onboardings as SX, Overview as kX, PartnerServices as TX, ProApi as LX, Records as DX, ReferenceObjects as IX, Reports as PX, Session as EX, Taxcards as NX, Test as RX, Usecases as YX, Workers as _X, ServiceModels as OX, HouseholdYears as MX } from "../core/salaxy-lib-core.js";
import { TotalsReportConfigGenerator as E0, ESalaryMapper as XX, CalculationMapper as or, Templates as io, RowsReportConfigGenerator as _L, IrRowsReportConfigGenerator as N0, Barcodes as tl, QrCodes as Jy, InvoiceMapper as eh, AccountingMapper as kb, SummaryMapper as hc, WorkerSummaryMapper as Tb } from "../reports/salaxy-lib-reports.js";
const Il = class Il {
  /**
   * Creates a new instance of AjaxNg1
   * @param $http - Angular http
   * @param $q - Angular q
   * @param config - Optional config containing keys which override the corresponding global Config keys.
   */
  constructor(t, e, a = null) {
    this.$http = t, this.$q = e, this.useCookie = !0, this.useCredentials = !1, this.serverAddress = "https://test-api.salaxy.com";
    const n = Ne.current;
    if (n || a) {
      const i = a?.apiServer ?? n.apiServer;
      i && (this.serverAddress = i);
      const r = a?.useCredentials ?? n.useCredentials;
      r != null && (this.useCredentials = r);
      const l = a?.useCookie ?? n.useCookie;
      l != null && (this.useCookie = l);
    }
  }
  /**
   * Gets the API address with version information. E.g. 'https://test-api.salaxy.com/v03/api'.
   * Default version, as of writing 2.0
   */
  getApiAddress() {
    return this.serverAddress + "/v03/api";
  }
  /** Gets the Server address that is used as bases to the HTML queries. E.g. 'https://test-api.salaxy.com' */
  getServerAddress() {
    return this.serverAddress;
  }
  /**
   * Gets a JSON-message from server using the API
   * @param method The API method is the url path after the api version segments (e.g. '/v03/api')
   * and starts with a forward slash, e.g. '/calculator/new'.
   * @returns A Promise with result data. Standard Promise rejection to be used for error handling.
   */
  getJSON(t) {
    const e = {}, a = this.getCurrentToken();
    return a && (e.headers = { Authorization: "Bearer " + a }), e.url = this.getUrl(t), e.method = "GET", e.responseType = "json", e.withCredentials = a ? !1 : this.useCredentials, this.$http(e).then(
      (n) => n.data,
      (n) => this.handleError(n)
    );
  }
  /**
   * Gets a HTML-message from server using the API
   * @param method - The API method is the url path after the api version segments (e.g. '/v03/api')
   * and starts with a forward slash, e.g. '/calculator/new'.
   * @returns A Promise with result data. Standard Promise rejection to be used for error handling.
   */
  getHTML(t) {
    const e = {}, a = this.getCurrentToken();
    return a && (e.headers = { Authorization: "Bearer " + a }), e.url = this.getUrl(t), e.method = "GET", e.responseType = "text", e.withCredentials = a ? !1 : this.useCredentials, this.$http(e).then(
      (n) => n.data,
      (n) => this.handleError(n)
    );
  }
  /**
   * Gets a blob (binary data) from the server using the API.
   * @param method - The API method is the url path after the api version segments (e.g. '/v03/api')
   * and starts with a forward slash, e.g. '/calculator/new'.
   * @returns A Promise that resolves to an object containing:
   * - data: The blob data from the response
   * - headers: An object containing the response headers as key-value pairs
   */
  getBlob(t) {
    const e = {}, a = this.getCurrentToken();
    return a && (e.headers = { Authorization: "Bearer " + a }), e.url = this.getUrl(t), e.method = "GET", e.responseType = "blob", e.withCredentials = a ? !1 : this.useCredentials, this.$http(e).then(
      (n) => {
        const i = {}, r = n.headers();
        return Object.keys(r).forEach((l) => {
          i[l] = r[l];
        }), { data: n.data, headers: i };
      },
      (n) => this.handleError(n)
    );
  }
  /**
   * POSTS data to server and receives back a blob (binary data).
   * @param method - The API method is the url path after the api version segments (e.g. '/v03/api')
   * and starts with a forward slash, e.g. '/calculator/new'.
   * @param data - The data that is posted to the server.
   * @returns A Promise that resolves to an object containing:
   * - data: The blob data from the response
   * - headers: An object containing the response headers as key-value pairs
   */
  postBlob(t, e) {
    const a = {}, n = this.getCurrentToken();
    return n && (a.headers = { Authorization: "Bearer " + n }), a.url = this.getUrl(t), a.method = "POST", a.data = e, a.responseType = "blob", a.withCredentials = n ? !1 : this.useCredentials, this.$http(a).then(
      (i) => {
        const r = {}, l = i.headers();
        return Object.keys(l).forEach((o) => {
          r[o] = l[o];
        }), { data: i.data, headers: r };
      },
      (i) => this.handleError(i)
    );
  }
  /**
   * POSTS data to server and receives back a JSON-message.
   * @param method - The API method is the url path after the api version segments (e.g. '/v03/api')
   * and starts with a forward slash, e.g. '/calculator/new'.
   * @param data - The data that is posted to the server.
   * @returns A Promise with result data. Standard Promise rejection to be used for error handling.
   */
  postJSON(t, e) {
    const a = {}, n = this.getCurrentToken();
    return n && (a.headers = { Authorization: "Bearer " + n }), a.url = this.getUrl(t), a.method = "POST", a.data = e, a.responseType = "json", a.withCredentials = n ? !1 : this.useCredentials, this.$http(a).then(
      (i) => i.data,
      (i) => this.handleError(i)
    );
  }
  /**
   * POSTS data to server and receives back HTML.
   * @param method - The API method is the url path after the api version segments (e.g. '/v03/api')
   * and starts with a forward slash, e.g. '/calculator/new'.
   * @param data - The data that is posted to the server.
   * @returns A Promise with result data. Standard Promise rejection to be used for error handling.
   */
  postHTML(t, e) {
    const a = {}, n = this.getCurrentToken();
    return n && (a.headers = { Authorization: "Bearer " + n }), a.url = this.getUrl(t), a.method = "POST", a.data = e, a.responseType = "text", a.withCredentials = n ? !1 : this.useCredentials, this.$http(a).then(
      (i) => i.data,
      (i) => this.handleError(i)
    );
  }
  /**
   * Sends a DELETE-message to server using the API
   * @param method - The API method is the url path after the api version segments (e.g. '/v03/api')
   * and starts with a forward slash, e.g. '/calculator/new'.
   * @returns A Promise with result data. Standard Promise rejection to be used for error handling.
   */
  remove(t) {
    const e = {}, a = this.getCurrentToken();
    return a && (e.headers = { Authorization: "Bearer " + a }), e.url = this.getUrl(t), e.method = "DELETE", e.responseType = "json", e.withCredentials = a ? !1 : this.useCredentials, this.$http(e).then(
      (n) => n.data,
      (n) => this.handleError(n)
    );
  }
  /**
   * Gets the current token.
   * Will check the salaxy-token cookie if the token is persisted there
   */
  getCurrentToken() {
    return !this.token && this.useCookie && (this.token = new $L().get("salaxy-token") || ""), this.token;
  }
  /** Gets the status of the current token. */
  getTokenStatus() {
    const t = this.getCurrentToken();
    return Vo.validate(t);
  }
  /**
   * Sets the current token. Persists it to cookie until the browser window
   * @param token - the authentication token to persist.
   */
  setCurrentToken(t) {
    this.useCookie && new $L().setCookie("salaxy-token", t || ""), this.token = t;
  }
  /** If missing, append the API server address to the given url method string */
  getUrl(t) {
    return !t || t.trim() === "" ? null : t.toLowerCase().startsWith("http") ? t : t.toLowerCase().startsWith("/v") ? this.getServerAddress() + t : this.getApiAddress() + t;
  }
  handleError(t) {
    let e;
    if (t ? t.data && t.data.messageHtml ? e = `<b>${t.data.error}:</b><br/>${t.data.messageHtml}` : t.data && t.data.message ? e = t.data.message : e = `HTTP error: ${t.statusText} (${t.status})` : e = "Unexpected error in HTTP request", Il.alertService) {
      if (Il.alertService.catchError)
        return Il.alertService.catchError(t);
      Il.alertService.addError(e);
    }
    return this.$q.reject(t);
  }
};
Il.$inject = ["$http", "$q"];
let sm = Il;
const rC = class rC {
  /**
   * Creates a new WizardController
   * @param $scope - The Angular scope
   * @param wizardService - Maintains the state of the wizard
   * @param data - Any data to the controller
   * @ignore
   */
  constructor(t, e, a = null) {
    this.$scope = t, this.wizardService = e, this.data = a, this.colWidthClasses = ["col-sm-12", "col-sm-12", "col-sm-6", "col-sm-4", "col-sm-3", "col-sm-fifth", "col-sm-2"];
  }
  /**
   * Implement IController
   */
  $onInit() {
  }
  /** Gets all the steps in the Wizard */
  get steps() {
    return this.wizardService.getSteps();
  }
  /** Gets the number of the currently active step */
  get step() {
    return this.wizardService.activeStepNumber;
  }
  /** Sets the number of the currently active step */
  set step(t) {
    this.wizardService.activeStepNumber = t;
  }
  /** The currently selected step object */
  get currentStep() {
    return this.wizardService.getCurrentStepObject();
  }
  /** Active styling properties */
  get style() {
    return {
      colWidthClass: this.colWidthClasses[this.steps.length]
    };
  }
  /** Returns true if goNext is enabled  */
  get canGoNext() {
    return !!(this.steps.length > this.step && this.steps[this.step] && !this.steps[this.step].disabled);
  }
  /** Returns true if goNext is enabled  */
  get canGoPrevious() {
    return this.step > 1 && !this.steps[this.step - 2].disabled;
  }
  /**
   * Navigates to the next step if possible
   */
  goNext() {
    this.canGoNext && this.step++;
  }
  /** Navigates to the previous step if possible */
  goPrevious() {
    this.canGoPrevious && this.step--;
  }
};
rC.$inject = ["$scope", "WizardService", "data"];
let bi = rC;
const lC = class lC extends bi {
  constructor(t, e, a, n, i, r, l, o) {
    super(t, e, o), this.onboardingService = a, this.sessionService = n, this.authorizedAccountService = i, this.ajax = r, this.$location = l, this.isStepProceeding = !1, this.linkCopied = !1;
  }
  /**
   * Implement IController
   */
  $onInit() {
    this.wizardService.setSteps(this.getWizardSteps()), this.model && this.model.company.resolvedId && this.model.signature.personalId != null ? this.wizardService.activeStepNumber = this.wizardService.getSteps().length : this.wizardService.activeStepNumber = 1;
  }
  /** Company wizard configuration */
  getWizardSteps() {
    const t = [];
    return t.push(
      {
        title: "SALAXY.NG1.CustomerOnboardingComponent.stepUserInfo.title",
        heading: "",
        intro: "",
        view: "salaxy-components/modals/onboarding/customer/user.html",
        buttonsView: "salaxy-components/modals/onboarding/customer/user-buttons.html"
      },
      {
        title: "SALAXY.NG1.CustomerOnboardingComponent.stepCompanyInfo.title",
        heading: "",
        intro: "",
        view: "salaxy-components/modals/onboarding/customer/company.html",
        buttonsView: "salaxy-components/modals/onboarding/customer/buttons.html"
      },
      {
        title: "SALAXY.NG1.CustomerOnboardingComponent.stepCompanyLegal.title",
        heading: "",
        intro: "",
        view: "salaxy-components/modals/onboarding/customer/company-legal.html",
        buttonsView: "salaxy-components/modals/onboarding/customer/buttons.html"
      },
      {
        title: "SALAXY.NG1.CustomerOnboardingComponent.stepInsurance.title",
        heading: "",
        intro: "",
        view: "salaxy-components/modals/onboarding/customer/insurance.html",
        buttonsView: "salaxy-components/modals/onboarding/customer/commit-buttons.html"
      },
      {
        title: "SALAXY.NG1.CustomerOnboardingComponent.stepInviteCompany.title",
        heading: "",
        intro: "",
        view: "salaxy-components/modals/onboarding/customer/finish.html",
        buttonsView: "salaxy-components/modals/onboarding/customer/finish-buttons.html"
      }
    ), t;
  }
  /**
   * The onboarding model is provided by the onboarding service.
   *
   */
  get model() {
    return this.onboardingService.model;
  }
  /**
   * Navigates to the next step if possible and saves the data.
   */
  goNext() {
    this.isStepProceeding || (this.isStepProceeding = !0, this.save().then(() => {
      super.goNext(), this.isStepProceeding = !1;
    }).catch((t) => {
      this.isStepProceeding = !1;
    }));
  }
  /**
   * Navigates to the previous step if possible and saves the data.
   */
  goPrevious() {
    this.isStepProceeding || (this.isStepProceeding = !0, this.save().then(() => {
      super.goPrevious(), this.isStepProceeding = !1;
    }).catch((t) => {
      this.isStepProceeding = !1;
    }));
  }
  /** Returns true if user can go forward in wizard  */
  get canGoNext() {
    return !!(this.steps.length > this.step && this.steps[this.step] && !this.steps[this.step].disabled && this.formDataValidity);
  }
  /** Sharing link for singing. */
  get signingLink() {
    return this.model ? Ne.current.wwwServer + "/share/signing/" + encodeURIComponent(this.model.owner) + "/" + this.model.id : "";
  }
  /** Sharing link for authorization mail. */
  get sharingLink() {
    return this.model ? Ne.current.wwwServer + "/share/authorization/" + encodeURIComponent(this.model.owner) + "/" + this.model.id : "";
  }
  /** Copies link to clipboard */
  copyLink(t) {
    navigator.clipboard.writeText(t), this.linkCopied = !0;
  }
  /** Mailto-link with sharing link. */
  get mailtoLink() {
    if (!this.model || !this.model.person)
      return "";
    let t = "mailto:";
    t += this.model.person.contact.email, t += "?subject=" + encodeURIComponent("Palkkaus.fi-palvelun valtakirjan allekirjoitus");
    let e = "Hei " + this.model.person.firstName + " " + this.model.person.lastName + `,

`;
    return e += "Olemme ottamassa käyttöön Palkkaus.fi-palvelun yrityksesi palkanmaksuun.", e += " Jotta he voivat hoitaa kaikki viranomaisvelvoitteet, tarvitaan allekirjoitus sinulta.", e += " Se hoituu helposti pankkitunnuksilla seuraamalla tätä linkkiä: ", e += this.sharingLink + `. 

`, e += `Ystävällisin terveisin, 
`, e += this.sessionService.getAvatar().displayName, t += "&body=" + encodeURIComponent(e), t;
  }
  /**
   * Existing company alert.
   */
  get existingCompanyAlert() {
    const t = this.sessionService.session?.currentAccount?.id;
    return this.model?.company?.resolvedId && this.model.company.resolvedId != t;
  }
  /**
   * Proceeds to company selection in e-authorization service.
   */
  goToCompanySelection() {
    this.model.company.doYtjUpdate = !0, this.goNext();
  }
  /** Commit onboarding */
  commit() {
    this.isStepProceeding || (this.isStepProceeding = !0, this.model.signature.email = this.model.person.contact.email, this.model.signature.telephone = this.model.person.contact.telephone, this.model.signature.personName = (this.model.person.firstName + " " + this.model.person.lastName).trim(), this.onboardingService.commit().then(() => {
      this.authorizedAccountService.reloadAuthorizingAccounts(), super.goNext(), this.isStepProceeding = !1;
    }).catch((t) => {
      this.isStepProceeding = !1;
    }));
  }
  /** Sets pension fields (defaults) after user input. */
  checkPensionCompanySelection() {
    this.model.products.pension.isPensionContractDone || (this.model.products.pension.pensionCompany = Is.None, this.model.products.pension.pensionContractNumber = null);
    const t = this.model.products.pension.pensionCompany;
    this.model.products.pension.isPensionContractDone && t === Is.Varma && (this.model.products.pension.isPendingContract = !1), (t === Is.Veritas || t === Is.Apteekkien || t === Is.Verso || t === Is.Valio || (t ?? "").startsWith("keva") || t === Is.Other) && (this.model.products.pension.isPensionSelfHandling = !0), this.model.products.pension.isPendingContract && (this.model.products.pension.isPensionSelfHandling = !1);
  }
  /** Sets insurance fields (defaults) after user input. */
  checkInsuranceCompanySelection() {
    this.model.products.insurance.isInsuranceContractDone || (this.model.products.insurance.insuranceCompany = null, this.model.products.insurance.insuranceContractNumber = null);
  }
  /**
   * Saves the data to server
   */
  save() {
    return this.onboardingService.save();
  }
  /**
   * Sets the pension contract number as a test number according to the selected company.
   */
  setPensionNumberForTest() {
    this.model.products.pension.pensionContractNumber = C0.getPensionNumberForTest(this.model.products.pension.pensionCompany);
  }
  /**
   * Launches the wizard.
   * @param accountId Optional account id.
   */
  launch(t = null) {
    return this.onboardingService.launchCustomerOnboarding(t);
  }
};
lC.$inject = ["$scope", "WizardService", "OnboardingService", "SessionService", "AuthorizedAccountService", "AjaxNg1", "$location", "data"];
let Cv = lC;
const oC = class oC extends bi {
  constructor(t, e, a, n, i, r) {
    super(t, e), this.onboardingService = a, this.sessionService = n, this.uiHelpers = i, this.signatureService = r, this.wizardSteps = [
      {
        title: "SALAXY.NG1.WorkerOnboardingComponent.stepUserInfo.title",
        heading: "SALAXY.NG1.WorkerOnboardingComponent.stepUserInfo.heading",
        intro: "",
        active: !0,
        view: "salaxy-components/modals/onboarding/worker/user-info.html",
        buttonsView: "salaxy-components/modals/onboarding/worker/firstPageButtons.html"
      },
      /*
      {
        title: "SALAXY.NG1.WorkerOnboardingComponent.stepPhoneNumberVerify.title",
        heading: "SALAXY.NG1.WorkerOnboardingComponent.stepPhoneNumberVerify.heading",
        intro: "SALAXY.NG1.WorkerOnboardingComponent.stepPhoneNumberVerify.intro",
        view: "salaxy-components/modals/onboarding/worker/phonenumber-verify.html",
        buttonsView: "salaxy-components/modals/onboarding/worker/phoneNumberVerifyButtons.html",
      },
      */
      {
        title: "SALAXY.NG1.WorkerOnboardingComponent.stepContract.stepTitle",
        heading: "SALAXY.NG1.WorkerOnboardingComponent.stepContract.heading",
        intro: "SALAXY.NG1.WorkerOnboardingComponent.stepContract.intro",
        view: "salaxy-components/modals/onboarding/worker/contract-worker.html",
        buttonsView: "salaxy-components/modals/onboarding/worker/contractButtons.html"
      }
    ], this.isStepProceeding = !1;
  }
  /**
   * Implement IController
   */
  $onInit() {
    this.wizardService.setSteps(this.wizardSteps), this.wizardService.activeStepNumber = 1, this.getSignatureMethods();
  }
  /**
   * Navigates to the next step if possible and saves the data.
   */
  goNext() {
    return this.isStepProceeding ? Promise.resolve(!1) : (this.isStepProceeding = !0, this.save().then(() => (super.goNext(), this.isStepProceeding = !1, !0)).catch((t) => (this.isStepProceeding = !1, !1)));
  }
  /** Returns true if user can go forward in wizard  */
  get canGoNext() {
    return !!(this.steps.length > this.step && this.steps[this.step] && !this.steps[this.step].disabled && this.formDataValidity);
  }
  /** Runs a check function before going forward */
  goNextIf(t) {
    t(() => this.goNext());
  }
  /**
   * Navigates to the previous step if possible and saves the data.
   */
  goPrevious() {
    this.isStepProceeding || (this.isStepProceeding = !0, this.save().then(() => {
      super.goPrevious(), this.isStepProceeding = !1;
    }).catch((t) => {
      this.isStepProceeding = !1;
    }));
  }
  /**
   * Saves the data to server
   */
  save() {
    return this.model.signature.email = this.model.person.contact.email, this.model.signature.telephone = this.model.person.contact.telephone, this.model.signature.personName = (this.model.person.firstName + " " + this.model.person.lastName).trim(), this.onboardingService.save();
  }
  /**
   * Returns signing url.
   */
  get vismaSignUrl() {
    const t = this.model.signature.method;
    return this.onboardingService.getDigitalSignUrl(t);
  }
  /**
   * The onboarding model is provided by the onboarding service.
   */
  get model() {
    return this.onboardingService.model;
  }
  /** Returns the PDF preview address for the authorization pdf. */
  getPdfPreviewAddress() {
    return this.onboardingService.getPdfPreviewAddress();
  }
  /**
   * Returns validation error for key if exists.
   * @param key - Validation error key.
   */
  getValidationError(t) {
    return this.model && this.model.validation ? this.model.validation.errors.find((e) => e.key === t) : null;
  }
  /**
   * Resets validation error for key if exists.
   * @param key - Validation error key.
   */
  removeValidationError(t) {
    this.model && this.model.validation && (this.model.validation.errors = this.model.validation.errors.filter((e) => e.key !== t));
  }
  /**
   * Checks if the given string is other identifier than Finnish Personal Identification Number
   * @param ssn given social security number
   */
  isOtherIdentifier(t) {
    return /^.{7}[9]/.test((t || "").trim());
  }
  /**
   * Launches the wizard.
   * @param id Optional onboarding id.
   */
  launch(t = null) {
    return this.onboardingService.launchWorkerOnboarding(t);
  }
  getSignatureMethods() {
    const t = this.signatureService.getMethods("telia");
    this.signatureMethods = t.map((e) => ({
      value: e.value,
      label: e.title,
      imgSrc: e.img
    }));
  }
};
oC.$inject = ["$scope", "WizardService", "OnboardingService", "SessionService", "UiHelpers", "SignatureService"];
let $v = oC;
const cC = class cC extends bi {
  constructor(t, e, a, n, i, r) {
    super(t, e, r), this.onboardingService = a, this.sessionService = n, this.signatureService = i, this.wizardSteps = [
      {
        title: "Käyttäjän tiedot",
        heading: "Tervetuloa, Palkkamyllyyn!",
        intro: `Palkkamyllyn tarjoaa Rakennusliitto ry, joka toimii henkilötietojen käsittelijänä ja vastaa myös asiakaspalvelusta.

Palvelun tuottajana, teknisenä toteuttajana ja myös henkilötietojen käsittelijä toimii Suomen Palkanlaskenta Oy (Palkkaus.fi).`,
        active: !0,
        view: "salaxy-components/modals/onboarding/household/wizard_index.html",
        buttonsView: "salaxy-components/modals/onboarding/household/firstPageButtons.html"
      },
      /*
      {
        title: "Puhelinnumero",
        heading: "Puhelinnumero",
        intro: "Puhelinnumeroa tarvitsemme yhteydenpitoa varten. Jos rekisteröit Siirto-palvelussa olevan puhelinnumeron, voit maksaa ja vastaanottaa palkkoja mobiilimaksuilla. Vahvistamme antamasi numeron.",
        view: "salaxy-components/modals/onboarding/household/phoneNumber.html",
        buttonsView: "salaxy-components/modals/onboarding/household/phoneNumberButtons.html",
      },
      {
        title: "Puhelinnumeron vahvistaminen",
        heading: "Puhelinnumeron vahvistaminen",
        intro: "Olemme lähettäneet sinulle SMS-viestin varmistaaksemme numerosi. Syötä viestissä oleva vahvistuskoodi tähän.",
        view: "salaxy-components/modals/onboarding/household/phoneNumberVerify.html",
        buttonsView: "salaxy-components/modals/onboarding/household/phoneNumberVerifyButtons.html",
      },
      */
      {
        title: "Palkanmaksun tiedot",
        heading: "Palkanmaksun tiedot",
        view: "salaxy-components/modals/onboarding/household/household.html",
        buttonsView: "salaxy-components/modals/onboarding/household/householdButtons.html"
      },
      {
        title: "Palvelusopimus",
        heading: "Palvelusopimus ja valtuutus",
        view: "salaxy-components/modals/onboarding/household/contract.html",
        buttonsView: "salaxy-components/modals/onboarding/household/contractButtons.html"
      }
    ], this.isStepProceeding = !1;
  }
  /**
   * Implement IController
   */
  $onInit() {
    this.wizardService.setSteps(this.wizardSteps), this.wizardService.activeStepNumber = 1;
    const t = this.signatureService.getMethods("telia");
    this.visibleSignatureMethods = t.filter((e) => e.isPopular).map((e) => ({
      value: e.value,
      label: e.title,
      imgSrc: e.img
    }));
  }
  /**
   * Navigates to the next step if possible and saves the data.
   */
  goNext() {
    return this.isStepProceeding ? Promise.resolve(!1) : (this.isStepProceeding = !0, this.save().then(() => (super.goNext(), this.isStepProceeding = !1, !0)).catch((t) => (this.isStepProceeding = !1, !1)));
  }
  /** Returns true if user can go forward in wizard  */
  get canGoNext() {
    return !!(this.steps.length > this.step && this.steps[this.step] && !this.steps[this.step].disabled && this.formDataValidity);
  }
  /** Runs a check function before going forward */
  goNextIf(t) {
    t(() => this.goNext());
  }
  /**
   * Navigates to the previous step if possible and saves the data.
   */
  goPrevious() {
    this.isStepProceeding || (this.isStepProceeding = !0, this.save().then(() => {
      super.goPrevious(), this.isStepProceeding = !1;
    }).catch((t) => {
      this.isStepProceeding = !1;
    }));
  }
  /**
   * Saves the data to server
   */
  save() {
    return this.model.signature.email = this.model.person.contact.email, this.model.signature.telephone = this.model.person.contact.telephone, this.model.signature.personName = (this.model.person.firstName + " " + this.model.person.lastName).trim(), this.onboardingService.save();
  }
  /**
   * Returns signing url.
   */
  get vismaSignUrl() {
    const t = this.model.signature.method;
    return this.onboardingService.getDigitalSignUrl(t);
  }
  /**
   * The onboarding model is provided by the onboarding service.
   */
  get model() {
    return this.onboardingService.model;
  }
  /** Returns the PDF preview address for the authorization pdf. */
  getPdfPreviewAddress() {
    return this.onboardingService.getPdfPreviewAddress();
  }
  /**
   * Returns validation error for key if exists.
   * @param key - Validation error key.
   */
  getValidationError(t) {
    return this.model && this.model.validation ? this.model.validation.errors.find((e) => e.key === t) : null;
  }
  /**
   * Resets validation error for key if exists.
   * @param key - Validation error key.
   */
  removeValidationError(t) {
    this.model && this.model.validation && (this.model.validation.errors = this.model.validation.errors.filter((e) => e.key !== t));
  }
  /**
   * Launches the wizard.
   * @param id Optional onboarding id.
   */
  launch(t = null) {
    return this.onboardingService.launchHouseholdOnboarding(t);
  }
};
cC.$inject = ["$scope", "WizardService", "OnboardingService", "SessionService", "SignatureService", "data"];
let Sv = cC;
const dC = class dC extends bi {
  constructor(t, e, a, n, i, r, l, o) {
    super(t, e, l), this.onboardingService = a, this.sessionService = n, this.ajax = i, this.$location = r, this.uiHelpers = o, this.isStepProceeding = !1;
  }
  /**
   * Implement IController
   */
  $onInit() {
    this.wizardService.setSteps(this.getWizardSteps()), this.model && this.model.signature.isProcura ? this.wizardService.activeStepNumber = 3 : this.wizardService.activeStepNumber = 1;
  }
  /** Company wizard configuration */
  getWizardSteps() {
    const t = [];
    return t.push(
      {
        title: "SALAXY.NG1.CompanyOnboardingComponent.step1.title",
        intro: "SALAXY.NG1.CompanyOnboardingComponent.step1.intro",
        active: !0,
        view: "salaxy-components/modals/onboarding/company/wizard_index.html",
        buttonsView: "salaxy-components/modals/onboarding/company/firstPageButtons.html"
      }
    ), this.showCompanySelection && t.push(
      {
        title: "SALAXY.NG1.CompanyOnboardingComponent.stepSuomiFi.title",
        intro: "SALAXY.NG1.CompanyOnboardingComponent.stepSuomiFi.intro",
        view: "salaxy-components/modals/onboarding/company/suomifi.html",
        buttonsView: "salaxy-components/modals/onboarding/company/suomifiButtons.html"
      }
    ), t.push(
      {
        title: "SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.title",
        intro: "SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.intro",
        view: "salaxy-components/modals/onboarding/company/company.html",
        buttonsView: "salaxy-components/modals/onboarding/company/defaultWizardButtons.html"
      },
      /*
      {
        title: "SALAXY.NG1.CompanyOnboardingComponent.stepCompanyLegal.title",
        view: "salaxy-components/modals/onboarding/company/company-legal.html",
        buttonsView: "salaxy-components/modals/onboarding/company/defaultWizardButtons.html",
      },
      */
      {
        title: "SALAXY.NG1.CompanyOnboardingComponent.stepContract.title",
        view: "salaxy-components/modals/onboarding/company/contract.html",
        buttonsView: "salaxy-components/modals/onboarding/company/contractButtons.html"
      }
    ), t;
  }
  /**
   * Navigates to the next step if possible and saves the data.
   */
  goNext() {
    return this.isStepProceeding ? Promise.resolve(!1) : (this.isStepProceeding = !0, this.save().then(() => (super.goNext(), this.isStepProceeding = !1, !0)).catch((t) => (this.isStepProceeding = !1, !1)));
  }
  /** Returns true if user can go forward in wizard  */
  get canGoNext() {
    return !!(this.steps.length > this.step && this.steps[this.step] && !this.steps[this.step].disabled && this.formDataValidity);
  }
  /**
   * Navigates to the previous step if possible and saves the data.
   */
  goPrevious() {
    this.isStepProceeding || (this.isStepProceeding = !0, this.save().then(() => {
      super.goPrevious(), this.isStepProceeding = !1;
    }).catch((t) => {
      this.isStepProceeding = !1;
    }));
  }
  /**
   * Saves the data to server
   */
  save() {
    return this.model.signature.email = this.model.person.contact.email, this.model.signature.telephone = this.model.person.contact.telephone, this.model.signature.personName = (this.model.person.firstName + " " + this.model.person.lastName).trim(), this.onboardingService.save();
  }
  /**
   * Returns signing url.
   */
  get vismaSignUrl() {
    return this.onboardingService.getDigitalSignUrl();
  }
  /**
   * The onboarding model is provided by the onboarding service.
   */
  get model() {
    return this.onboardingService.model;
  }
  /** IF true, the Suomi.fi company selection is used. */
  get showCompanySelection() {
    return this.model && this.model.company && this.model.company.roles && this.model.company.roles.some((e) => e === SL.Accountant || e === SL.AccountantCandidate);
  }
  /** Returns the PDF preview address for the authorization pdf. */
  getPdfPreviewAddress() {
    return this.onboardingService.getPdfPreviewAddress();
  }
  /**
   * Existing company alert.
   */
  get existingCompanyAlert() {
    const t = this.sessionService.session?.currentAccount?.id;
    return this.model?.company?.resolvedId && this.model.company.resolvedId != t;
  }
  /** Go to suomi fi ypa */
  goToSuomifi() {
    const t = this.$location.url();
    let e = this.$location.absUrl();
    t.length > 1 && (e = e.substring(0, e.indexOf(t))), e = e.replace(/\/$/, "").trim();
    const a = this.ajax.getCurrentToken(), n = a ? `${encodeURIComponent(a)}` : "", i = e.indexOf("&") >= 0 || e.indexOf("?") >= 0 ? "&url=" : "", r = `${e}${i}/onboarding/company/${this.model.id}${n ? "&ob_token=" + n : ""}`, l = `${e}${i}/onboarding/company/${this.model.id}${n ? "&ob_token=" + n : ""}`;
    this.save().then(() => {
      window.location.assign(`${this.ajax.getServerAddress()}/Onboarding/CompanySelection?OnboardingId=${encodeURIComponent(this.model.id)}&Language=${encodeURIComponent(L.getLanguage())}&SuccessUrl=${encodeURIComponent(l)}&CancelUrl=${encodeURIComponent(r)}${n ? "&access_token=" + n : ""}`);
    });
  }
  /**
   * Launches the wizard.
   * @param id Optional onboarding id.
   */
  launch(t = null) {
    return this.onboardingService.launchCompanyOnboarding(t);
  }
  /**
   * Sets the company's business id, clears the YTJ search results fetches other company info's via YTJ search and saves
   * @param businessId The business id that is set as the company's business id
   */
  chooseBusinessId(t) {
    this.model.company.businessId = t, this.model.company.ytjSearch = null, this.searchYtj();
  }
  /**
   * Sets the DoYtjUpdate flag to true and saves.
   * @param searchType - If true, sets the business ID to null
   * Use this option to force a YTJ name search, even if there already is something written in business ID field.
   */
  searchYtj(t) {
    this.model.company.companyType = null, this.model.company.contact.street = null, this.model.company.contact.city = null, this.model.company.contact.postalCode = null, this.model.company.ytjSearch = null, this.model.company.doYtjUpdate = !0, t === "name" && (this.model.company.businessId = null), t === "businessId" && (this.model.company.name = null), this.save();
  }
  /**
   * Returns validation error for key if exists.
   * @param key - Validation error key.
   */
  getValidationError(t) {
    return this.model && this.model.validation ? this.model.validation.errors.find((e) => e.key === t) : null;
  }
  /** Opens wizard as modal dialog */
  openSigningWizardDialog(t = null) {
    const e = this.sessionService.getCurrentCss(), a = this.sessionService.getOrigin(), n = a + (e ? `popup.html#settings/signing?skin=${e}&lang=${L.getLanguage()}&id=${this.onboardingService.model?.id ?? ""}#access_token=${this.ajax.getCurrentToken()}` : `popup.html#settings/signing?lang=${L.getLanguage()}&id=${this.onboardingService.model?.id ?? ""}#access_token=${this.ajax.getCurrentToken()}`);
    return this.uiHelpers.showExternalDialog(t, n, { id: t, origin: a }, { width: 1080, height: 800 }).then((i) => {
      if (i?.action != "cancel")
        return this.checkSession();
    });
  }
  /** Launches company wizard. */
  launchSigningWizard() {
    const t = this.readTokenFromUrl(this.$location.absUrl(), "data="), e = JSON.parse(atob(decodeURIComponent(t)))?.id, a = JSON.parse(atob(decodeURIComponent(t)))?.origin;
    return this.onboardingService.getOnboardingData(e).then(() => {
      const n = this.sessionService.getCurrentCss();
      return this.onboardingService.model.ui.successUrl = a + (n ? `popup.html#settings/signing-success?skin=${n}&lang=${L.getLanguage()}&id=${this.onboardingService.model?.id ?? ""}#access_token=${this.ajax.getCurrentToken()}` : `popup.html#settings/signing-success?lang=${L.getLanguage()}&id=${this.onboardingService.model?.id ?? ""}#access_token=${this.ajax.getCurrentToken()}`), this.onboardingService.model.ui.cancelUrl = this.onboardingService.model.ui.successUrl.replace("/signing-success?", "/signing-cancel?"), this.onboardingService.save().then(() => this.onboardingService.launchCompanyOnboarding(this.onboardingService.model.id));
    });
  }
  /** Reloads the current session*/
  checkSession() {
    return this.sessionService.checkSession();
  }
  readTokenFromUrl(t, e) {
    const a = t.toLowerCase().indexOf(e);
    if (a >= 0) {
      const n = t.indexOf("&", a);
      return n >= 0 ? t.substring(a + e.length, n) : t.substring(a + e.length);
    }
    return null;
  }
};
dC.$inject = ["$scope", "WizardService", "OnboardingService", "SessionService", "AjaxNg1", "$location", "data", "UiHelpers"];
let kv = dC;
const uC = class uC {
  constructor(t, e, a, n, i, r, l, o) {
    this.$scope = t, this.onboardingService = e, this.sessionService = a, this.signatureService = n, this.$sce = i, this.uiHelpers = r, this.ajax = l, this.$timeout = o, this.showInPopup = !1, this.isSigninStarted = !1, this.$onInit = () => {
      this.init(), this.sessionService.subscribe(this.$scope, () => {
        this.init();
      }), this.isContactPersonSigner = !0;
    };
  }
  /** Saves the current onboarding model. */
  save() {
    return this.isContactPersonSigner && (this.model.company.contact.email = this.model.signature.email, this.model.company.contact.telephone = this.model.signature.telephone), this.onboardingService.save().then((t) => (this.pdfPreviewUrl = null, t));
  }
  /**
   * The onboarding model is provided by the onboarding service.
   */
  get model() {
    return this.onboardingService.model?.company && (this.onboardingService.model.company.language = L.getLanguage()), this.onboardingService.model?.person && (this.onboardingService.model.person.language = L.getLanguage()), this.onboardingService.model;
  }
  /** Returns the PDF preview address for the authorization pdf. */
  getPdfPreviewAddress() {
    return !this.pdfPreviewUrl && this.model?.id && (this.pdfPreviewUrl = this.$sce.trustAsResourceUrl(this.onboardingService.getPdfPreviewAddress(!0) + "&t=" + (/* @__PURE__ */ new Date()).getTime() + "&language=" + this.model.company.language)), this.pdfPreviewUrl;
  }
  /**
   * Starts Visma sign
   * If this.showInPopup is false, saves the model and starts the signature.
   * If this.showInPopup is true, saves the model, starts the signature and then opens success dialog.
   * @param authMethod Method of authentication (bank selection).
   * Only used for Persons (Telia methods), ignored for companies.
   */
  startDigitalSignature(t) {
    this.isSigninStarted = !0, this.showInPopup ? this.save().then(() => {
      let e = this.sessionService.getCurrentCss() || "";
      e && (e = `skin=${e}&`);
      const a = this.sessionService.getOrigin() + `popup.html#settings/signing-success?${e}lang=${L.getLanguage()}&id=${this.onboardingService.model?.id ?? ""}#access_token=${this.ajax.getCurrentToken()}`, n = this.onboardingService.getDigitalSignUrl(t, null, null, a, a.replace("/signing-success?", "/signing-cancel?"));
      return this.$timeout(() => this.isSigninStarted = !1, 2e3), this.uiHelpers.showExternalDialog("vismaSignPopup", n, {}, { width: 1080, height: 800 }).then((i) => {
        if (i?.action != "cancel")
          return this.sessionService.checkSession();
      });
    }) : (this.uiHelpers.showLoading("SALAXY.NG1.SigningComponent.dialog.header", `Siirrytään allekirjoitukseen (${t})`), this.save().then(() => {
      window.top.location.href = this.onboardingService.getDigitalSignUrl(t);
    }));
  }
  /** List of supported Signature methods */
  get methods() {
    return this.signatureService.getMethods();
  }
  /**
   * Returns the SignatureMethod for given value.
   * @param value - value for SignatureMethod, e.g. tupas-nordea.
   */
  getMethod(t) {
    const e = this.methods.filter((a) => a.value === t);
    return e.length > 0 ? e[0] : null;
  }
  /**
   * Signs the authorization contract for the current user.
   * Creates a partner contract authorization and updates the session.
   * This is used when authorizing a partner account to access the current account.
   * @returns Promise that resolves when the contract is signed and session is updated
   * @throws Error if the contract signing fails
   */
  async signPartnerContract() {
    const t = {
      authorizationType: HM.PartnerContract,
      authorizedBy: this.sessionService.session.currentCredential
    }, e = this.uiHelpers.showLoading("SALAXY.UI_Terms.wait");
    try {
      await this.ajax.postJSON("/onboarding/contract", t), await this.sessionService.checkSession();
    } catch (a) {
      console.error("Failed to sign partner contract:", a);
    } finally {
      e.dismiss();
    }
  }
  init() {
    if (this.isSigningOk = this.sessionService.isSigningOk(), this.pdfPreviewUrl = null, this.isSigningRequired = !this.sessionService.isSigningOk(), this.sessionService.isSessionChecked && this.sessionService.isAuthenticated) {
      const t = this.sessionService.session.currentAccount.id;
      if (this.onboardingService.model && this.onboardingService.model.company.resolvedId === t)
        return;
      this.onboardingService.model = null, this.onboardingService.id = null, this.onboardingService.getOnboardingDataForAccount(this.sessionService.session.currentAccount.id).then(() => {
        if (this.onboardingService.model) {
          this.onboardingService.model.signature.isPep = null, this.onboardingService.model.company.ownership.isRequiredTracking = null, this.onboardingService.model.id || this.onboardingService.save();
          return;
        } else
          this.onboardingService.model = {
            accountType: Ws.Company,
            signature: {}
          }, this.onboardingService.save();
      });
    }
  }
};
uC.$inject = ["$scope", "OnboardingService", "SessionService", "SignatureService", "$sce", "UiHelpers", "AjaxNg1", "$timeout"];
let im = uC;
const pC = class pC {
  /**
   * Creates a new SignatureController
   * @param signatureService - Service that handles the communication to the server
   * @ignore
   */
  constructor(t) {
    this.signatureService = t, this.$onInit = () => {
    };
  }
  /**
   * Legacy list of supported Visma Sign Signature methods.
   */
  get methods() {
    return this.getMethods("tupas");
  }
  /**
   * List of supported Signature methods
   * @param methodGroup - Method group "telia" for Telia Tunnistus and "tupas" for Visma Sign. Default is "tupas".
   */
  getMethods(t = "tupas") {
    return this.signatureService.getMethods(t);
  }
  /**
   * Returns the SignatureMethod for given value.
   * @param value - value for SignatureMethod, e.g. tupas-nordea.
   */
  getMethod(t) {
    return this.signatureService.getMethods("tupas").find((e) => e.value === t) ?? this.signatureService.getMethods("telia").find((e) => e.value === t);
  }
};
pC.$inject = [
  "SignatureService"
];
let Tv = pC;
const hC = class hC {
  /**
   * Creates a new CrudControllerBase.
   * @param crudService The the BaseService instance that is used for communicating to server.
   * @param $location Angular.js Location service that is used for navigation. Especially the list views.
   * @param $attrs Angular.js Attisbutes for determining whether events have been bound to.
   * @param uiHelpers - Salaxy ui helpers service.
   */
  constructor(t, e, a, n) {
    if (this.crudService = t, this.$location = e, this.$attrs = a, this.uiHelpers = n, this.copyIdAsNew = (i) => {
      const r = this.list.find((l) => l.id === i);
      return r ? this.copyAsNew(r) : null;
    }, this.listSelect = (i) => {
      this.$attrs.onListSelect ? this.onListSelect({ item: i }) : this.detailsUrl ? this.$location.url(this.detailsUrl + (i.id || i.rowIndex)) : this.setCurrent(i);
    }, this.listSelectId = (i) => {
      const r = this.list.find((l) => l.id === i);
      r && this.listSelect(r);
    }, this.delete = (i, r) => this.uiHelpers.showConfirm(r || "SALAXY.NG1.ApiCrudObjectComponent.deleteDialog").then((l) => l ? this.$attrs.onDelete ? this.onDelete({ deleteResult: this.deleteNoConfirm(i) }) : (this.listUrl && this.$location.url(this.listUrl), this.deleteNoConfirm(i)) : Promise.resolve(!1)), !t)
      throw new Error("crudService is undefined in CrudControllerBase");
    if (!e)
      throw new Error("$location is undefined in CrudControllerBase");
    if (!n)
      throw new Error("uiHelpers is undefined in CrudControllerBase");
    if (!a)
      throw new Error("$attrs is undefined in CrudControllerBase");
  }
  /**
   * Implement IController by providing onInit method.
   * We currently do nothing here, but if you override this function,
   * you should call this method in base class for future compatibility.
   */
  $onInit() {
  }
  /** Gets the Current selected item. */
  get current() {
    return this.getBindingMode() === "model" ? this.model.$viewValue : this.crudService.current;
  }
  /** Gets the list of all CRUD objects listed. */
  get list() {
    return this.crudService.list;
  }
  /**
   * Creates a new item. The item is not saved in this process yet.
   * Item is set as current unless onCreateNew is specified => Then you are responsible for doing it yourself.
   * If detailsUrl is specified, the browser is redirectedted there.
   * Current item is set also in this case (as opposed to listSelect) because the new item does not yet have an id
   * and passing it in current item is the only way using router.
   * Use onCreateNew event or crudService.getBlank() if you do not want to set the current item.
   * @param newItem Specify the new item if you want to initialize it with specific values.
   * In most cases, you should let the system create it with defaults.
   */
  createNew(t = null) {
    return t || (t = this.crudService.getBlank()), this.$attrs.onCreateNew ? this.onCreateNew({ item: t }) : (this.setCurrent(t), this.detailsUrl && this.$location.url(this.detailsUrl + "new#" + (/* @__PURE__ */ new Date()).getTime())), t;
  }
  /** Copies the current item and sets it as the new current */
  copyCurrent() {
    this.current && this.setCurrent(this.crudService.copyAsNew(this.current));
  }
  /**
   * Creates a copy of a given item and sets it as current
   * unless onCreateNew is specified => Then you are responsible for doing it yourself.
   * If detailsUrl is specified, the browser is redirectedted there.
   * Current item is set also in this case (as opposed to listSelect) because the new item does not yet have an id
   * and passing it in current item is the only way using router.
   * Use onCreateNew event or crudService.copyAsNew() if you do not want to set the current item.
   * @param copySource The item to copy as new.
   * @returns The new item that is created.
   */
  copyAsNew(t) {
    const e = this.crudService.copyAsNew(t);
    return this.createNew(e);
  }
  /**
   * Mode for data binding is "singleton" by default.
   * This means that this.current is bound to crudService.current.
   * If ng-model is defined for the component (this.ngModelController),
   * this.current is bound to ngModelController view value (as with form controls).
   */
  getBindingMode() {
    return this.model ? "model" : "singleton";
  }
  /** Saves the current item. */
  saveCurrent() {
    return this.crudService.saveCurrent();
  }
  /**
   * Sets the current item: Either to ng-model view value or crudService.setCurrent().
   * @param item The item to set as Current.
   */
  setCurrent(t) {
    this.getBindingMode() === "model" ? this.model.$setViewValue(t) : this.crudService.setCurrent(t);
  }
  /**
   * Deletes an item without showing the confirm dialog.
   * The method shows the "Please wait..." loader, but does not call onDelete
   * or move the browser to listUrl. The caller should take care
   * of the UX actions after delete if necessary.
   * @param id Identifier of the item to be deleted.
   * @returns Promise that resolves to true (never false). Fails if the deletion fails.
   */
  deleteNoConfirm(t) {
    const e = this.uiHelpers.showLoading("SALAXY.UI_Terms.wait");
    return this.crudService.delete(t).then(() => (e.dismiss(), !0));
  }
};
hC.crudBindings = {
  /**
   * Function that is called when user selects an item in the list.
   * The selected item is the parameter of the function call.
   * @example <salaxy-payroll-list on-list-select="$ctrl.myCustomSelectFunc(item)"></salaxy-payroll-list>
   */
  onListSelect: "&",
  /**
   * Function that is called when an item is deleted.
   * The event is intended for user interface logic after delete (promise resolve)
   * and potentially when waiting for server to respond (from function call until promise resolve).
   * It is not meant for delete validation and/or for preventing deletion.
   * If onDelete is not specified, the browser is redirected to listUrl if specified.
   * @example <salaxy-payroll-list on-delete="$ctrl.resetUiAfterDeleteFunc"></salaxy-payroll-list>
   */
  onDelete: "&",
  /**
   * Function that is called after a new item has been created.
   * At this point, the item has been created, but not yet selected as current.
   * If onCreateNew is not specified the browser is redirected to detailsUrl if specified and if not, only current item is set.
   * @example <salaxy-payroll-list on-create-new="$ctrl.startMyCustomWizardFunc"></salaxy-payroll-list>
   */
  onCreateNew: "&",
  /**
   * URL to which the component navigates when an item is clicked.
   * The "id" or "rowIndex" property of the selected item is added to the URL.
   * URL is ignored if onListSelect is set. In this case, you may navigate yourself in that method.
   * @example <salaxy-payroll-list details-url="/myCustomRoute/"></salaxy-payroll-list>
   */
  detailsUrl: "@",
  /**
   * URL for the list view. At the moment, if specified, the browser is redirected here after delete.
   * @example
   * <!-- Main worker list is in the front page in this case -->
   * <salaxy-employment-details list-url="/home"></salaxy-employment-details>
   */
  listUrl: "@"
};
let fc = hC;
const mC = class mC extends fc {
  constructor(t, e, a, n, i, r) {
    super(t, e, a, n), this.authorizedAccountService = t, this.sessionService = i, this.ajax = r;
  }
  /**
   * Returns the list of Integration partner sites available and the status of each partner.
   */
  get partnerIntegrationSites() {
    return this.authorizedAccountService.getPartnerIntegrationSiteList();
  }
  /**
   * Gets a specific partner site for the current user
   * @param id Identifier of the site
   */
  getPartnerSite(t) {
    return this.authorizedAccountService.getPartnerSite(t);
  }
  /**
   * Returns the current partner site
   */
  get currentPartnerSite() {
    return this.authorizedAccountService.getCurrentPartnerSite();
  }
  /**
   * Shows a dialog for adding / removing authorizations from known partners that
   * frequently require authorizations. These are typically integrated software
   * that are added without Primary Partner flag.
   * @param id - The id of the partner site for which the dialog is shown.
   */
  showPartnerSiteDialog(t) {
    const e = this.getPartnerSite(t);
    this.authorizedAccountService.setCurrentPartnerSite(e), this.uiHelpers.showDialog("salaxy-components/modals/account/Authorization.html", "AccountAuthorizationController");
  }
  /** Toggles the authorization option and makes the corresponding api call. */
  switchAuthorization() {
    const t = this.currentPartnerSite;
    if (this.disabled !== !0 && !t.disabled) {
      if (t.enabled == !1 && t.accountId)
        this.authorizedAccountService.delete(t.accountId);
      else if (t.enabled == !0 && t.accountId) {
        const e = this.authorizedAccountService.getBlank();
        e.id = t.accountId, this.authorizedAccountService.save(e);
      }
    }
  }
  /**
   * Returns the authorizing accounts for the current account
   */
  get authorizingAccounts() {
    return this.authorizedAccountService.getAuthorizingAccounts();
  }
  /** Deletes the account. Only in test. */
  deleteAccount(t) {
    this.uiHelpers.showConfirm("Haluatko varmasti poistaa tilin, tiliä ei voi palauttaa?").then((e) => {
      if (e) {
        const a = this.uiHelpers.showLoading("SALAXY.UI_Terms.wait");
        this.ajax.remove("/accounts/authorizingAccount/" + t).then(() => {
          this.authorizedAccountService.reloadAuthorizingAccounts().then(() => {
            a.dismiss();
          });
        });
      }
    });
  }
  /**
   * Shows a dialog for adding any new authorized account.
   */
  showAuthorizedAccountAddDialog() {
    super.createNew(), this.uiHelpers.showDialog("salaxy-components/modals/account/AuthorizedAccountAdd.html", "AccountAuthorizationController");
  }
  /** Adds authorized account */
  saveCurrent(t = null) {
    const e = this.uiHelpers.showLoading("SALAXY.UI_Terms.wait");
    return super.saveCurrent().then((a) => (e.dismiss(), t && t(a), a));
  }
  /**
   * Adds access token to url.
   * @param accountId - Account id to login as.
   */
  getLoginAsUrl(t) {
    let e = this.ajax.getServerAddress() + "/Security/LoginAs/" + t;
    return e = e + "?access_token=" + encodeURIComponent(this.ajax.getCurrentToken()), e;
  }
  /**
   * Checks whether the user is in a given role
   * @param role - One of the known roles
   */
  isInRole(t) {
    return this.sessionService.isInRole(t);
  }
};
mC.$inject = [
  "AuthorizedAccountService",
  "$location",
  "$attrs",
  "UiHelpers",
  "SessionService",
  "AjaxNg1"
];
let Hl = mC;
const gC = class gC extends fc {
  constructor(t, e, a, n, i) {
    super(t, e, a, n), this.certificateService = t, this.certificateApi = i, this.result = void 0, this.certFormat = "pfx", this.certFormats = [
      {
        value: "pfx",
        text: "Windows-sertifikaatti (pfx / pkcs12)",
        ui: {
          mime: "application/x-pkcs12",
          suffix: "pfx"
        }
      },
      {
        value: "pem",
        text: "Yleinen sertifikaatti (zip / pem)",
        ui: {
          mime: "application/zip",
          suffix: "zip"
        }
      }
    ];
  }
  /** Creates a new certificate */
  createNew() {
    return super.createNew(), this.current.title = L.get("SALAXY.NG1.CertificatesComponent.newCertificate"), this.current;
  }
  /** Returns the metadata for the certFrmat */
  get currentCertFormat() {
    return this.certFormats.find((t) => t.value === this.certFormat) || this.certFormats[0];
  }
  /**
   * Shows a dialog for adding nw certificate.
   */
  showCertificateAddDialog() {
    this.createNew(), this.uiHelpers.showDialog("salaxy-components/modals/account/CertificateAdd.html", "CertificateController");
  }
  /** Creates a new certificate */
  createCert() {
    const t = this.uiHelpers.showLoading("SALAXY.UI_Terms.wait");
    this.certFormat === "pem" ? this.certificateApi.issuePemCertificate(this.current).then((e) => {
      this.result = {
        blob: this.uiHelpers.bytes2Blob(e.bytes, this.currentCertFormat.ui.mime),
        text: e.cert + `

` + e.key,
        thumbprint: e.thumbprint
      }, t.dismiss();
    }) : super.saveCurrent().then((e) => {
      this.result = {
        blob: this.uiHelpers.bytes2Blob(e.bytes, this.currentCertFormat.ui.mime),
        text: e.bytes,
        thumbprint: e.thumbprint
      }, t.dismiss();
    });
  }
  /**
   * Downloads current.blob as pfx and sets current.id as name
   */
  downloadCertFile() {
    this.uiHelpers.downloadFile(this.result.blob, `${this.result.thumbprint}.${this.currentCertFormat.ui.suffix}`);
  }
};
gC.$inject = ["CertificateService", "$location", "$attrs", "UiHelpers", "Certificates"];
let au = gC;
var Rs = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Hs(s) {
  return s && s.__esModule && Object.prototype.hasOwnProperty.call(s, "default") ? s.default : s;
}
/**
 * @license AngularJS v1.8.3
 * (c) 2010-2020 Google LLC. http://angularjs.org
 * License: MIT
 */
(function(s) {
  var t = {
    objectMaxDepth: 5,
    urlErrorParamsEnabled: !0
  };
  function e(u) {
    if (lt(u))
      tt(u.objectMaxDepth) && (t.objectMaxDepth = a(u.objectMaxDepth) ? u.objectMaxDepth : NaN), tt(u.urlErrorParamsEnabled) && _t(u.urlErrorParamsEnabled) && (t.urlErrorParamsEnabled = u.urlErrorParamsEnabled);
    else
      return t;
  }
  function a(u) {
    return yt(u) && u > 0;
  }
  function n(u, m) {
    m = m || Error;
    var y = "https://errors.angularjs.org/1.8.3/", f = y.replace(".", "\\.") + "[\\s\\S]*", w = new RegExp(f, "g");
    return function() {
      var D = arguments[0], k = arguments[1], S = "[" + (u ? u + ":" : "") + D + "] ", $ = sn(arguments, 2).map(function(X) {
        return ed(X, t.objectMaxDepth);
      }), E, Y;
      if (S += k.replace(/\{\d+\}/g, function(X) {
        var z = +X.slice(1, -1);
        return z < $.length ? $[z].replace(w, "") : X;
      }), S += `
` + y + (u ? u + "/" : "") + D, t.urlErrorParamsEnabled)
        for (Y = 0, E = "?"; Y < $.length; Y++, E = "&")
          S += E + "p" + Y + "=" + encodeURIComponent($[Y]);
      return new m(S);
    };
  }
  var i = /^\/(.+)\/([a-z]*)$/, r = "validity", l = Object.prototype.hasOwnProperty, o = function(u) {
    return nt(u) ? u.toLowerCase() : u;
  }, c = function(u) {
    return nt(u) ? u.toUpperCase() : u;
  }, d, p, h, g = [].slice, x = [].splice, b = [].push, A = Object.prototype.toString, T = Object.getPrototypeOf, R = n("ng"), C = s.angular || (s.angular = {}), v, P = 0;
  d = s.document.documentMode;
  function O(u) {
    if (u == null || G(u))
      return !1;
    if (Yt(u) || nt(u) || p && u instanceof p)
      return !0;
    var m = "length" in Object(u) && u.length;
    return yt(m) && (m >= 0 && m - 1 in u || typeof u.item == "function");
  }
  function N(u, m, y) {
    var f, w;
    if (u)
      if (_(u))
        for (f in u)
          f !== "prototype" && f !== "length" && f !== "name" && u.hasOwnProperty(f) && m.call(y, u[f], f, u);
      else if (Yt(u) || O(u)) {
        var D = typeof u != "object";
        for (f = 0, w = u.length; f < w; f++)
          (D || f in u) && m.call(y, u[f], f, u);
      } else if (u.forEach && u.forEach !== N)
        u.forEach(m, y, u);
      else if (at(u))
        for (f in u)
          m.call(y, u[f], f, u);
      else if (typeof u.hasOwnProperty == "function")
        for (f in u)
          u.hasOwnProperty(f) && m.call(y, u[f], f, u);
      else
        for (f in u)
          l.call(u, f) && m.call(y, u[f], f, u);
    return u;
  }
  function H(u, m, y) {
    for (var f = Object.keys(u).sort(), w = 0; w < f.length; w++)
      m.call(y, u[f[w]], f[w]);
    return f;
  }
  function F(u) {
    return function(m, y) {
      u(y, m);
    };
  }
  function B() {
    return ++P;
  }
  function Q(u, m) {
    m ? u.$$hashKey = m : delete u.$$hashKey;
  }
  function it(u, m, y) {
    for (var f = u.$$hashKey, w = 0, D = m.length; w < D; ++w) {
      var k = m[w];
      if (!(!lt(k) && !_(k)))
        for (var S = Object.keys(k), $ = 0, E = S.length; $ < E; $++) {
          var Y = S[$], X = k[Y];
          y && lt(X) ? Rt(X) ? u[Y] = new Date(X.valueOf()) : V(X) ? u[Y] = new RegExp(X) : X.nodeName ? u[Y] = X.cloneNode(!0) : ze(X) ? u[Y] = X.clone() : Y !== "__proto__" && (lt(u[Y]) || (u[Y] = Yt(X) ? [] : {}), it(u[Y], [X], !0)) : u[Y] = X;
        }
    }
    return Q(u, f), u;
  }
  function et(u) {
    return it(u, g.call(arguments, 1), !1);
  }
  function rt(u) {
    return it(u, g.call(arguments, 1), !0);
  }
  function U(u) {
    return parseInt(u, 10);
  }
  var M = Number.isNaN || function(m) {
    return m !== m;
  };
  function W(u, m) {
    return et(Object.create(u), m);
  }
  function J() {
  }
  J.$inject = [];
  function vt(u) {
    return u;
  }
  vt.$inject = [];
  function St(u) {
    return function() {
      return u;
    };
  }
  function zt(u) {
    return _(u.toString) && u.toString !== A;
  }
  function j(u) {
    return typeof u > "u";
  }
  function tt(u) {
    return typeof u < "u";
  }
  function lt(u) {
    return u !== null && typeof u == "object";
  }
  function at(u) {
    return u !== null && typeof u == "object" && !T(u);
  }
  function nt(u) {
    return typeof u == "string";
  }
  function yt(u) {
    return typeof u == "number";
  }
  function Rt(u) {
    return A.call(u) === "[object Date]";
  }
  function Yt(u) {
    return Array.isArray(u) || u instanceof Array;
  }
  function K(u) {
    var m = A.call(u);
    switch (m) {
      case "[object Error]":
        return !0;
      case "[object Exception]":
        return !0;
      case "[object DOMException]":
        return !0;
      default:
        return u instanceof Error;
    }
  }
  function _(u) {
    return typeof u == "function";
  }
  function V(u) {
    return A.call(u) === "[object RegExp]";
  }
  function G(u) {
    return u && u.window === u;
  }
  function dt(u) {
    return u && u.$evalAsync && u.$watch;
  }
  function ht(u) {
    return A.call(u) === "[object File]";
  }
  function ot(u) {
    return A.call(u) === "[object FormData]";
  }
  function $t(u) {
    return A.call(u) === "[object Blob]";
  }
  function _t(u) {
    return typeof u == "boolean";
  }
  function qt(u) {
    return u && _(u.then);
  }
  var de = /^\[object (?:Uint8|Uint8Clamped|Uint16|Uint32|Int8|Int16|Int32|Float32|Float64)Array]$/;
  function me(u) {
    return u && yt(u.length) && de.test(A.call(u));
  }
  function Ht(u) {
    return A.call(u) === "[object ArrayBuffer]";
  }
  var oe = function(u) {
    return nt(u) ? u.trim() : u;
  }, Ye = function(u) {
    return u.replace(/([-()[\]{}+?*.$^|,:#<!\\])/g, "\\$1").replace(/\x08/g, "\\x08");
  };
  function ze(u) {
    return !!(u && (u.nodeName || u.prop && u.attr && u.find));
  }
  function Lt(u) {
    var m = {}, y = u.split(","), f;
    for (f = 0; f < y.length; f++)
      m[y[f]] = !0;
    return m;
  }
  function ye(u) {
    return o(u.nodeName || u[0] && u[0].nodeName);
  }
  function ue(u, m) {
    return Array.prototype.indexOf.call(u, m) !== -1;
  }
  function _e(u, m) {
    var y = u.indexOf(m);
    return y >= 0 && u.splice(y, 1), y;
  }
  function la(u, m, y) {
    var f = [], w = [];
    if (y = a(y) ? y : NaN, m) {
      if (me(m) || Ht(m))
        throw R("cpta", "Can't copy! TypedArray destination cannot be mutated.");
      if (u === m)
        throw R("cpi", "Can't copy! Source and destination are identical.");
      return Yt(m) ? m.length = 0 : N(m, function($, E) {
        E !== "$$hashKey" && delete m[E];
      }), f.push(u), w.push(m), D(u, m, y);
    }
    return k(u, y);
    function D($, E, Y) {
      if (Y--, Y < 0)
        return "...";
      var X = E.$$hashKey, z;
      if (Yt($))
        for (var st = 0, ct = $.length; st < ct; st++)
          E.push(k($[st], Y));
      else if (at($))
        for (z in $)
          E[z] = k($[z], Y);
      else if ($ && typeof $.hasOwnProperty == "function")
        for (z in $)
          $.hasOwnProperty(z) && (E[z] = k($[z], Y));
      else
        for (z in $)
          l.call($, z) && (E[z] = k($[z], Y));
      return Q(E, X), E;
    }
    function k($, E) {
      if (!lt($))
        return $;
      var Y = f.indexOf($);
      if (Y !== -1)
        return w[Y];
      if (G($) || dt($))
        throw R(
          "cpws",
          "Can't copy! Making copies of Window or Scope instances is not supported."
        );
      var X = !1, z = S($);
      return z === void 0 && (z = Yt($) ? [] : Object.create(T($)), X = !0), f.push($), w.push(z), X ? D($, z, E) : z;
    }
    function S($) {
      switch (A.call($)) {
        case "[object Int8Array]":
        case "[object Int16Array]":
        case "[object Int32Array]":
        case "[object Float32Array]":
        case "[object Float64Array]":
        case "[object Uint8Array]":
        case "[object Uint8ClampedArray]":
        case "[object Uint16Array]":
        case "[object Uint32Array]":
          return new $.constructor(k($.buffer), $.byteOffset, $.length);
        case "[object ArrayBuffer]":
          if (!$.slice) {
            var E = new ArrayBuffer($.byteLength);
            return new Uint8Array(E).set(new Uint8Array($)), E;
          }
          return $.slice(0);
        case "[object Boolean]":
        case "[object Number]":
        case "[object String]":
        case "[object Date]":
          return new $.constructor($.valueOf());
        case "[object RegExp]":
          var Y = new RegExp($.source, $.toString().match(/[^/]*$/)[0]);
          return Y.lastIndex = $.lastIndex, Y;
        case "[object Blob]":
          return new $.constructor([$], { type: $.type });
      }
      if (_($.cloneNode))
        return $.cloneNode(!0);
    }
  }
  function qa(u, m) {
    return u === m || u !== u && m !== m;
  }
  function je(u, m) {
    if (u === m)
      return !0;
    if (u === null || m === null)
      return !1;
    if (u !== u && m !== m)
      return !0;
    var y = typeof u, f = typeof m, w, D, k;
    if (y === f && y === "object")
      if (Yt(u)) {
        if (!Yt(m))
          return !1;
        if ((w = u.length) === m.length) {
          for (D = 0; D < w; D++)
            if (!je(u[D], m[D]))
              return !1;
          return !0;
        }
      } else {
        if (Rt(u))
          return Rt(m) ? qa(u.getTime(), m.getTime()) : !1;
        if (V(u))
          return V(m) ? u.toString() === m.toString() : !1;
        if (dt(u) || dt(m) || G(u) || G(m) || Yt(m) || Rt(m) || V(m))
          return !1;
        k = Ee();
        for (D in u)
          if (!(D.charAt(0) === "$" || _(u[D]))) {
            if (!je(u[D], m[D]))
              return !1;
            k[D] = !0;
          }
        for (D in m)
          if (!(D in k) && D.charAt(0) !== "$" && tt(m[D]) && !_(m[D]))
            return !1;
        return !0;
      }
    return !1;
  }
  var Aa = function() {
    if (!tt(Aa.rules)) {
      var u = s.document.querySelector("[ng-csp]") || s.document.querySelector("[data-ng-csp]");
      if (u) {
        var m = u.getAttribute("ng-csp") || u.getAttribute("data-ng-csp");
        Aa.rules = {
          noUnsafeEval: !m || m.indexOf("no-unsafe-eval") !== -1,
          noInlineStyle: !m || m.indexOf("no-inline-style") !== -1
        };
      } else
        Aa.rules = {
          noUnsafeEval: y(),
          noInlineStyle: !1
        };
    }
    return Aa.rules;
    function y() {
      try {
        return new Function(""), !1;
      } catch {
        return !0;
      }
    }
  }, ge = function() {
    if (tt(ge.name_))
      return ge.name_;
    var u, m, y = Qi.length, f, w;
    for (m = 0; m < y; ++m)
      if (f = Qi[m], u = s.document.querySelector("[" + f.replace(":", "\\:") + "jq]"), u) {
        w = u.getAttribute(f + "jq");
        break;
      }
    return ge.name_ = w;
  };
  function Ka(u, m, y) {
    return u.concat(g.call(m, y));
  }
  function sn(u, m) {
    return g.call(u, m || 0);
  }
  function Ie(u, m) {
    var y = arguments.length > 2 ? sn(arguments, 2) : [];
    return _(m) && !(m instanceof RegExp) ? y.length ? function() {
      return arguments.length ? m.apply(u, Ka(y, arguments, 0)) : m.apply(u, y);
    } : function() {
      return arguments.length ? m.apply(u, arguments) : m.call(u);
    } : m;
  }
  function Ss(u, m) {
    var y = m;
    return typeof u == "string" && u.charAt(0) === "$" && u.charAt(1) === "$" ? y = void 0 : G(m) ? y = "$WINDOW" : m && s.document === m ? y = "$DOCUMENT" : dt(m) && (y = "$SCOPE"), y;
  }
  function ks(u, m) {
    if (!j(u))
      return yt(m) || (m = m ? 2 : null), JSON.stringify(u, Ss, m);
  }
  function Tr(u) {
    return nt(u) ? JSON.parse(u) : u;
  }
  var pp = /:/g;
  function jc(u, m) {
    u = u.replace(pp, "");
    var y = Date.parse("Jan 01, 1970 00:00:00 " + u) / 6e4;
    return M(y) ? m : y;
  }
  function Vc(u, m) {
    return u = new Date(u.getTime()), u.setMinutes(u.getMinutes() + m), u;
  }
  function hl(u, m, y) {
    y = y ? -1 : 1;
    var f = u.getTimezoneOffset(), w = jc(m, f);
    return Vc(u, y * (w - f));
  }
  function Kn(u) {
    u = p(u).clone().empty();
    var m = p("<div></div>").append(u).html();
    try {
      return u[0].nodeType === Ja ? o(m) : m.match(/^(<[^>]+>)/)[1].replace(/^<([\w-]+)/, function(y, f) {
        return "<" + o(f);
      });
    } catch {
      return o(m);
    }
  }
  function qc(u) {
    try {
      return decodeURIComponent(u);
    } catch {
    }
  }
  function mo(u) {
    var m = {};
    return N((u || "").split("&"), function(y) {
      var f, w, D;
      y && (w = y = y.replace(/\+/g, "%20"), f = y.indexOf("="), f !== -1 && (w = y.substring(0, f), D = y.substring(f + 1)), w = qc(w), tt(w) && (D = tt(D) ? qc(D) : !0, l.call(m, w) ? Yt(m[w]) ? m[w].push(D) : m[w] = [m[w], D] : m[w] = D));
    }), m;
  }
  function Lf(u) {
    var m = [];
    return N(u, function(y, f) {
      Yt(y) ? N(y, function(w) {
        m.push(Jn(f, !0) + (w === !0 ? "" : "=" + Jn(w, !0)));
      }) : m.push(Jn(f, !0) + (y === !0 ? "" : "=" + Jn(y, !0)));
    }), m.length ? m.join("&") : "";
  }
  function Kc(u) {
    return Jn(u, !0).replace(/%26/gi, "&").replace(/%3D/gi, "=").replace(/%2B/gi, "+");
  }
  function Jn(u, m) {
    return encodeURIComponent(u).replace(/%40/gi, "@").replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%3B/gi, ";").replace(/%20/g, m ? "%20" : "+");
  }
  var Qi = ["ng-", "data-ng-", "ng:", "x-ng-"];
  function Df(u, m) {
    var y, f, w = Qi.length;
    for (f = 0; f < w; ++f)
      if (y = Qi[f] + m, nt(y = u.getAttribute(y)))
        return y;
    return null;
  }
  function go(u) {
    var m = u.currentScript;
    if (!m)
      return !0;
    if (!(m instanceof s.HTMLScriptElement || m instanceof s.SVGScriptElement))
      return !1;
    var y = m.attributes, f = [y.getNamedItem("src"), y.getNamedItem("href"), y.getNamedItem("xlink:href")];
    return f.every(function(w) {
      if (!w)
        return !0;
      if (!w.value)
        return !1;
      var D = u.createElement("a");
      if (D.href = w.value, u.location.origin === D.origin)
        return !0;
      switch (D.protocol) {
        case "http:":
        case "https:":
        case "ftp:":
        case "blob:":
        case "file:":
        case "data:":
          return !0;
        default:
          return !1;
      }
    });
  }
  var hp = go(s.document);
  function yo(u, m) {
    var y, f, w = {};
    if (N(Qi, function(D) {
      var k = D + "app";
      !y && u.hasAttribute && u.hasAttribute(k) && (y = u, f = u.getAttribute(k));
    }), N(Qi, function(D) {
      var k = D + "app", S;
      !y && (S = u.querySelector("[" + k.replace(":", "\\:") + "]")) && (y = S, f = S.getAttribute(k));
    }), y) {
      if (!hp) {
        s.console.error("AngularJS: disabling automatic bootstrap. <script> protocol indicates an extension, document.location.href does not match.");
        return;
      }
      w.strictDi = Df(y, "strict-di") !== null, m(y, f ? [f] : [], w);
    }
  }
  function Jc(u, m, y) {
    lt(y) || (y = {});
    var f = {
      strictDi: !1
    };
    y = et(f, y);
    var w = function() {
      if (u = p(u), u.injector()) {
        var S = u[0] === s.document ? "document" : Kn(u);
        throw R(
          "btstrpd",
          "App already bootstrapped with this element '{0}'",
          S.replace(/</, "&lt;").replace(/>/, "&gt;")
        );
      }
      m = m || [], m.unshift(["$provide", function(E) {
        E.value("$rootElement", u);
      }]), y.debugInfoEnabled && m.push(["$compileProvider", function(E) {
        E.debugInfoEnabled(!0);
      }]), m.unshift("ng");
      var $ = nd(m, y.strictDi);
      return $.invoke(
        [
          "$rootScope",
          "$rootElement",
          "$compile",
          "$injector",
          function(Y, X, z, st) {
            Y.$apply(function() {
              X.data("$injector", st), z(X)(Y);
            });
          }
        ]
      ), $;
    }, D = /^NG_ENABLE_DEBUG_INFO!/, k = /^NG_DEFER_BOOTSTRAP!/;
    if (s && D.test(s.name) && (y.debugInfoEnabled = !0, s.name = s.name.replace(D, "")), s && !k.test(s.name))
      return w();
    s.name = s.name.replace(k, ""), C.resumeBootstrap = function(S) {
      return N(S, function($) {
        m.push($);
      }), w();
    }, _(C.resumeDeferredBootstrap) && C.resumeDeferredBootstrap();
  }
  function mp() {
    s.name = "NG_ENABLE_DEBUG_INFO!" + s.name, s.location.reload();
  }
  function If(u) {
    var m = C.element(u).injector();
    if (!m)
      throw R(
        "test",
        "no injector found for element argument to getTestability"
      );
    return m.get("$$testability");
  }
  var Qc = /[A-Z]/g;
  function gp(u, m) {
    return m = m || "_", u.replace(Qc, function(y, f) {
      return (f ? m : "") + y.toLowerCase();
    });
  }
  var fo = !1;
  function Pt() {
    var u;
    if (!fo) {
      var m = ge();
      h = j(m) ? s.jQuery : (
        // use jQuery (if present)
        m ? (
          // use jqLite
          s[m]
        ) : void 0
      ), h && h.fn.on ? (p = h, et(h.fn, {
        scope: vo.scope,
        isolateScope: vo.isolateScope,
        controller: (
          /** @type {?} */
          vo.controller
        ),
        injector: vo.injector,
        inheritedData: vo.inheritedData
      })) : p = rn, u = p.cleanData, p.cleanData = function(y) {
        for (var f, w = 0, D; (D = y[w]) != null; w++)
          f = (p._data(D) || {}).events, f && f.$destroy && p(D).triggerHandler("$destroy");
        u(y);
      }, C.element = p, fo = !0;
    }
  }
  function jt() {
    rn.legacyXHTMLReplacement = !0;
  }
  function ke(u, m, y) {
    if (!u)
      throw R("areq", "Argument '{0}' is {1}", m || "?", y || "required");
    return u;
  }
  function pe(u, m, y) {
    return y && Yt(u) && (u = u[u.length - 1]), ke(_(u), m, "not a function, got " + (u && typeof u == "object" ? u.constructor.name || "Object" : typeof u)), u;
  }
  function Pe(u, m) {
    if (u === "hasOwnProperty")
      throw R("badname", "hasOwnProperty is not a valid {0} name", m);
  }
  function Te(u, m, y) {
    if (!m)
      return u;
    for (var f = m.split("."), w, D = u, k = f.length, S = 0; S < k; S++)
      w = f[S], u && (u = (D = u)[w]);
    return !y && _(u) ? Ie(D, u) : u;
  }
  function Ce(u) {
    for (var m = u[0], y = u[u.length - 1], f, w = 1; m !== y && (m = m.nextSibling); w++)
      (f || u[w] !== m) && (f || (f = p(g.call(u, 0, w))), f.push(m));
    return f || u;
  }
  function Ee() {
    return /* @__PURE__ */ Object.create(null);
  }
  function Ea(u) {
    if (u == null)
      return "";
    switch (typeof u) {
      case "string":
        break;
      case "number":
        u = "" + u;
        break;
      default:
        zt(u) && !Yt(u) && !Rt(u) ? u = u.toString() : u = ks(u);
    }
    return u;
  }
  var na = 1, Qn = 2, Ja = 3, _n = 8, ci = 9, Zi = 11;
  function Zc(u) {
    var m = n("$injector"), y = n("ng");
    function f(D, k, S) {
      return D[k] || (D[k] = S());
    }
    var w = f(u, "angular", Object);
    return w.$$minErr = w.$$minErr || n, f(w, "module", function() {
      var D = {};
      return function(S, $, E) {
        var Y = {}, X = function(z, st) {
          if (z === "hasOwnProperty")
            throw y("badname", "hasOwnProperty is not a valid {0} name", st);
        };
        return X(S, "module"), $ && D.hasOwnProperty(S) && (D[S] = null), f(D, S, function() {
          if (!$)
            throw m("nomod", "Module '{0}' is not available! You either misspelled the module name or forgot to load it. If registering a module ensure that you specify the dependencies as the second argument.", S);
          var z = [], st = [], ct = [], It = Et("$injector", "invoke", "push", st), Ut = {
            // Private state
            _invokeQueue: z,
            _configBlocks: st,
            _runBlocks: ct,
            /**
             * @ngdoc method
             * @name angular.Module#info
             * @module ng
             *
             * @param {Object=} info Information about the module
             * @returns {Object|Module} The current info object for this module if called as a getter,
             *                          or `this` if called as a setter.
             *
             * @description
             * Read and write custom information about this module.
             * For example you could put the version of the module in here.
             *
             * ```js
             * angular.module('myModule', []).info({ version: '1.0.0' });
             * ```
             *
             * The version could then be read back out by accessing the module elsewhere:
             *
             * ```
             * var version = angular.module('myModule').info().version;
             * ```
             *
             * You can also retrieve this information during runtime via the
             * {@link $injector#modules `$injector.modules`} property:
             *
             * ```js
             * var version = $injector.modules['myModule'].info().version;
             * ```
             */
            info: function(Tt) {
              if (tt(Tt)) {
                if (!lt(Tt))
                  throw y("aobj", "Argument '{0}' must be an object", "value");
                return Y = Tt, this;
              }
              return Y;
            },
            /**
             * @ngdoc property
             * @name angular.Module#requires
             * @module ng
             *
             * @description
             * Holds the list of modules which the injector will load before the current module is
             * loaded.
             */
            requires: $,
            /**
             * @ngdoc property
             * @name angular.Module#name
             * @module ng
             *
             * @description
             * Name of the module.
             */
            name: S,
            /**
             * @ngdoc method
             * @name angular.Module#provider
             * @module ng
             * @param {string} name service name
             * @param {Function} providerType Construction function for creating new instance of the
             *                                service.
             * @description
             * See {@link auto.$provide#provider $provide.provider()}.
             */
            provider: Dt("$provide", "provider"),
            /**
             * @ngdoc method
             * @name angular.Module#factory
             * @module ng
             * @param {string} name service name
             * @param {Function} providerFunction Function for creating new instance of the service.
             * @description
             * See {@link auto.$provide#factory $provide.factory()}.
             */
            factory: Dt("$provide", "factory"),
            /**
             * @ngdoc method
             * @name angular.Module#service
             * @module ng
             * @param {string} name service name
             * @param {Function} constructor A constructor function that will be instantiated.
             * @description
             * See {@link auto.$provide#service $provide.service()}.
             */
            service: Dt("$provide", "service"),
            /**
             * @ngdoc method
             * @name angular.Module#value
             * @module ng
             * @param {string} name service name
             * @param {*} object Service instance object.
             * @description
             * See {@link auto.$provide#value $provide.value()}.
             */
            value: Et("$provide", "value"),
            /**
             * @ngdoc method
             * @name angular.Module#constant
             * @module ng
             * @param {string} name constant name
             * @param {*} object Constant value.
             * @description
             * Because the constants are fixed, they get applied before other provide methods.
             * See {@link auto.$provide#constant $provide.constant()}.
             */
            constant: Et("$provide", "constant", "unshift"),
            /**
            * @ngdoc method
            * @name angular.Module#decorator
            * @module ng
            * @param {string} name The name of the service to decorate.
            * @param {Function} decorFn This function will be invoked when the service needs to be
            *                           instantiated and should return the decorated service instance.
            * @description
            * See {@link auto.$provide#decorator $provide.decorator()}.
            */
            decorator: Dt("$provide", "decorator", st),
            /**
             * @ngdoc method
             * @name angular.Module#animation
             * @module ng
             * @param {string} name animation name
             * @param {Function} animationFactory Factory function for creating new instance of an
             *                                    animation.
             * @description
             *
             * **NOTE**: animations take effect only if the **ngAnimate** module is loaded.
             *
             *
             * Defines an animation hook that can be later used with
             * {@link $animate $animate} service and directives that use this service.
             *
             * ```js
             * module.animation('.animation-name', function($inject1, $inject2) {
             *   return {
             *     eventName : function(element, done) {
             *       //code to run the animation
             *       //once complete, then run done()
             *       return function cancellationFunction(element) {
             *         //code to cancel the animation
             *       }
             *     }
             *   }
             * })
             * ```
             *
             * See {@link ng.$animateProvider#register $animateProvider.register()} and
             * {@link ngAnimate ngAnimate module} for more information.
             */
            animation: Dt("$animateProvider", "register"),
            /**
             * @ngdoc method
             * @name angular.Module#filter
             * @module ng
             * @param {string} name Filter name - this must be a valid AngularJS expression identifier
             * @param {Function} filterFactory Factory function for creating new instance of filter.
             * @description
             * See {@link ng.$filterProvider#register $filterProvider.register()}.
             *
             * <div class="alert alert-warning">
             * **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
             * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
             * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
             * (`myapp_subsection_filterx`).
             * </div>
             */
            filter: Dt("$filterProvider", "register"),
            /**
             * @ngdoc method
             * @name angular.Module#controller
             * @module ng
             * @param {string|Object} name Controller name, or an object map of controllers where the
             *    keys are the names and the values are the constructors.
             * @param {Function} constructor Controller constructor function.
             * @description
             * See {@link ng.$controllerProvider#register $controllerProvider.register()}.
             */
            controller: Dt("$controllerProvider", "register"),
            /**
             * @ngdoc method
             * @name angular.Module#directive
             * @module ng
             * @param {string|Object} name Directive name, or an object map of directives where the
             *    keys are the names and the values are the factories.
             * @param {Function} directiveFactory Factory function for creating new instance of
             * directives.
             * @description
             * See {@link ng.$compileProvider#directive $compileProvider.directive()}.
             */
            directive: Dt("$compileProvider", "directive"),
            /**
             * @ngdoc method
             * @name angular.Module#component
             * @module ng
             * @param {string|Object} name Name of the component in camelCase (i.e. `myComp` which will match `<my-comp>`),
             *    or an object map of components where the keys are the names and the values are the component definition objects.
             * @param {Object} options Component definition object (a simplified
             *    {@link ng.$compile#directive-definition-object directive definition object})
             *
             * @description
             * See {@link ng.$compileProvider#component $compileProvider.component()}.
             */
            component: Dt("$compileProvider", "component"),
            /**
             * @ngdoc method
             * @name angular.Module#config
             * @module ng
             * @param {Function} configFn Execute this function on module load. Useful for service
             *    configuration.
             * @description
             * Use this method to configure services by injecting their
             * {@link angular.Module#provider `providers`}, e.g. for adding routes to the
             * {@link ngRoute.$routeProvider $routeProvider}.
             *
             * Note that you can only inject {@link angular.Module#provider `providers`} and
             * {@link angular.Module#constant `constants`} into this function.
             *
             * For more about how to configure services, see
             * {@link providers#provider-recipe Provider Recipe}.
             */
            config: It,
            /**
             * @ngdoc method
             * @name angular.Module#run
             * @module ng
             * @param {Function} initializationFn Execute this function after injector creation.
             *    Useful for application initialization.
             * @description
             * Use this method to register work which should be performed when the injector is done
             * loading all modules.
             */
            run: function(Tt) {
              return ct.push(Tt), this;
            }
          };
          return E && It(E), Ut;
          function Et(Tt, Ot, mt, ft) {
            return ft || (ft = z), function() {
              return ft[mt || "push"]([Tt, Ot, arguments]), Ut;
            };
          }
          function Dt(Tt, Ot, mt) {
            return mt || (mt = z), function(ft, Z) {
              return Z && _(Z) && (Z.$$moduleName = S), mt.push([Tt, Ot, arguments]), Ut;
            };
          }
        });
      };
    });
  }
  function Ts(u, m) {
    if (Yt(u)) {
      m = m || [];
      for (var y = 0, f = u.length; y < f; y++)
        m[y] = u[y];
    } else if (lt(u)) {
      m = m || {};
      for (var w in u)
        w.charAt(0) === "$" && w.charAt(1) === "$" || (m[w] = u[w]);
    }
    return m || u;
  }
  function td(u, m) {
    var y = [];
    return a(m) && (u = C.copy(u, null, m)), JSON.stringify(u, function(f, w) {
      if (w = Ss(f, w), lt(w)) {
        if (y.indexOf(w) >= 0)
          return "...";
        y.push(w);
      }
      return w;
    });
  }
  function ed(u, m) {
    return typeof u == "function" ? u.toString().replace(/ \{[\s\S]*$/, "") : j(u) ? "undefined" : typeof u != "string" ? td(u, m) : u;
  }
  var yp = {
    // These placeholder strings will be replaced by grunt's `build` task.
    // They need to be double- or single-quoted.
    full: "1.8.3",
    major: 1,
    minor: 8,
    dot: 3,
    codeName: "ultimate-farewell"
  };
  function fp(u) {
    et(u, {
      errorHandlingConfig: e,
      bootstrap: Jc,
      copy: la,
      extend: et,
      merge: rt,
      equals: je,
      element: p,
      forEach: N,
      injector: nd,
      noop: J,
      bind: Ie,
      toJson: ks,
      fromJson: Tr,
      identity: vt,
      isUndefined: j,
      isDefined: tt,
      isString: nt,
      isFunction: _,
      isObject: lt,
      isNumber: yt,
      isElement: ze,
      isArray: Yt,
      version: yp,
      isDate: Rt,
      callbacks: { $$counter: 0 },
      getTestability: If,
      reloadWithDebugInfo: mp,
      UNSAFE_restoreLegacyJqLiteXHTMLReplacement: jt,
      $$minErr: n,
      $$csp: Aa,
      $$encodeUriSegment: Kc,
      $$encodeUriQuery: Jn,
      $$lowercase: o,
      $$stringify: Ea,
      $$uppercase: c
    }), v = Zc(s), v("ng", ["ngLocale"], [
      "$provide",
      function(y) {
        y.provider({
          $$sanitizeUri: __
        }), y.provider("$compile", qk).directive({
          a: fO,
          input: qT,
          textarea: qT,
          form: vO,
          script: fM,
          select: xM,
          option: wM,
          ngBind: OO,
          ngBindHtml: XO,
          ngBindTemplate: MO,
          ngClass: HO,
          ngClassEven: FO,
          ngClassOdd: UO,
          ngCloak: zO,
          ngController: BO,
          ngForm: xO,
          ngHide: dM,
          ngIf: jO,
          ngInclude: VO,
          ngInit: KO,
          ngNonBindable: aM,
          ngPluralize: rM,
          ngRef: lM,
          ngRepeat: oM,
          ngShow: cM,
          ngStyle: uM,
          ngSwitch: pM,
          ngSwitchWhen: hM,
          ngSwitchDefault: mM,
          ngOptions: iM,
          ngTransclude: yM,
          ngModel: ZO,
          ngList: JO,
          ngChange: GO,
          pattern: lL,
          ngPattern: lL,
          required: rL,
          ngRequired: rL,
          minlength: cL,
          ngMinlength: cL,
          maxlength: oL,
          ngMaxlength: oL,
          ngValue: _O,
          ngModelOptions: eM
        }).directive({
          ngInclude: qO,
          input: RO
        }).directive(_p).directive(KT), y.provider({
          $anchorScroll: LY,
          $animate: RY,
          $animateCss: OY,
          $$animateJs: EY,
          $$animateQueue: NY,
          $$AnimateRunner: _Y,
          $$animateAsyncRun: YY,
          $browser: HY,
          $cacheFactory: UY,
          $controller: jY,
          $document: VY,
          $$isDocumentHidden: qY,
          $exceptionHandler: KY,
          $filter: $T,
          $$forceReflow: JY,
          $interpolate: o_,
          $interval: d_,
          $$intervalFactory: u_,
          $http: s_,
          $httpParamSerializer: e_,
          $httpParamSerializerJQLike: a_,
          $httpBackend: r_,
          $xhrFactory: i_,
          $jsonpCallbacks: p_,
          $location: A_,
          $log: C_,
          $parse: P_,
          $rootScope: Y_,
          $q: E_,
          $$q: N_,
          $sce: G_,
          $sceDelegate: X_,
          $sniffer: H_,
          $$taskTrackerFactory: U_,
          $templateCache: FY,
          $templateRequest: B_,
          $$testability: W_,
          $timeout: V_,
          $window: tO,
          $$rAF: R_,
          $$jqLite: bY,
          $$Map: xY,
          $$cookieReader: eO
        });
      }
    ]).info({ angularVersion: "1.8.3" });
  }
  rn.expando = "ng339";
  var bo = rn.cache = {}, tY = 1;
  rn._data = function(u) {
    return this.cache[u[this.expando]] || {};
  };
  function eY() {
    return ++tY;
  }
  var aY = /-([a-z])/g, nY = /^-ms-/, bp = { mouseleave: "mouseout", mouseenter: "mouseover" }, Pf = n("jqLite");
  function sY(u) {
    return vp(u.replace(nY, "ms-"));
  }
  function Ik(u, m) {
    return m.toUpperCase();
  }
  function vp(u) {
    return u.replace(aY, Ik);
  }
  var iY = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/, rY = /<|&#?\w+;/, lY = /<([\w:-]+)/, oY = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi, $i = {
    thead: ["table"],
    col: ["colgroup", "table"],
    tr: ["tbody", "table"],
    td: ["tr", "tbody", "table"]
  };
  $i.tbody = $i.tfoot = $i.colgroup = $i.caption = $i.thead, $i.th = $i.td;
  var ad = {
    option: [1, '<select multiple="multiple">', "</select>"],
    _default: [0, "", ""]
  };
  for (var Pk in $i) {
    var Ek = $i[Pk], Nk = Ek.slice().reverse();
    ad[Pk] = [Nk.length, "<" + Nk.join("><") + ">", "</" + Ek.join("></") + ">"];
  }
  ad.optgroup = ad.option;
  function Ef(u) {
    return !rY.test(u);
  }
  function Nf(u) {
    var m = u.nodeType;
    return m === na || !m || m === ci;
  }
  function cY(u) {
    for (var m in bo[u.ng339])
      return !0;
    return !1;
  }
  function Rk(u, m) {
    var y, f, w, D, k = m.createDocumentFragment(), S = [], $;
    if (Ef(u))
      S.push(m.createTextNode(u));
    else {
      if (y = k.appendChild(m.createElement("div")), f = (lY.exec(u) || ["", ""])[1].toLowerCase(), D = rn.legacyXHTMLReplacement ? u.replace(oY, "<$1></$2>") : u, d < 10)
        for (w = ad[f] || ad._default, y.innerHTML = w[1] + D + w[2], $ = w[0]; $--; )
          y = y.firstChild;
      else {
        for (w = $i[f] || [], $ = w.length; --$ > -1; )
          y.appendChild(s.document.createElement(w[$])), y = y.firstChild;
        y.innerHTML = D;
      }
      S = Ka(S, y.childNodes), y = k.firstChild, y.textContent = "";
    }
    return k.textContent = "", k.innerHTML = "", N(S, function(E) {
      k.appendChild(E);
    }), k;
  }
  function dY(u, m) {
    m = m || s.document;
    var y;
    return (y = iY.exec(u)) ? [m.createElement(y[1])] : (y = Rk(u, m)) ? y.childNodes : [];
  }
  function uY(u, m) {
    var y = u.parentNode;
    y && y.replaceChild(m, u), m.appendChild(u);
  }
  var pY = s.Node.prototype.contains || /** @this */
  function(u) {
    return !!(this.compareDocumentPosition(u) & 16);
  };
  function rn(u) {
    if (u instanceof rn)
      return u;
    var m;
    if (nt(u) && (u = oe(u), m = !0), !(this instanceof rn)) {
      if (m && u.charAt(0) !== "<")
        throw Pf("nosel", "Looking up elements via selectors is not supported by jqLite! See: http://docs.angularjs.org/api/angular.element");
      return new rn(u);
    }
    m ? Of(this, dY(u)) : _(u) ? Gk(u) : Of(this, u);
  }
  function Rf(u) {
    return u.cloneNode(!0);
  }
  function xp(u, m) {
    !m && Nf(u) && p.cleanData([u]), u.querySelectorAll && p.cleanData(u.querySelectorAll("*"));
  }
  function Yk(u) {
    var m;
    for (m in u)
      return !1;
    return !0;
  }
  function _k(u) {
    var m = u.ng339, y = m && bo[m], f = y && y.events, w = y && y.data;
    (!w || Yk(w)) && (!f || Yk(f)) && (delete bo[m], u.ng339 = void 0);
  }
  function Ok(u, m, y, f) {
    if (tt(f))
      throw Pf("offargs", "jqLite#off() does not support the `selector` argument");
    var w = wp(u), D = w && w.events, k = w && w.handle;
    if (k) {
      if (m) {
        var S = function($) {
          var E = D[$];
          tt(y) && _e(E || [], y), tt(y) && E && E.length > 0 || (u.removeEventListener($, k), delete D[$]);
        };
        N(m.split(" "), function($) {
          S($), bp[$] && S(bp[$]);
        });
      } else
        for (m in D)
          m !== "$destroy" && u.removeEventListener(m, k), delete D[m];
      _k(u);
    }
  }
  function Yf(u, m) {
    var y = u.ng339, f = y && bo[y];
    f && (m ? delete f.data[m] : f.data = {}, _k(u));
  }
  function wp(u, m) {
    var y = u.ng339, f = y && bo[y];
    return m && !f && (u.ng339 = y = eY(), f = bo[y] = { events: {}, data: {}, handle: void 0 }), f;
  }
  function _f(u, m, y) {
    if (Nf(u)) {
      var f, w = tt(y), D = !w && m && !lt(m), k = !m, S = wp(u, !D), $ = S && S.data;
      if (w)
        $[vp(m)] = y;
      else {
        if (k)
          return $;
        if (D)
          return $ && $[vp(m)];
        for (f in m)
          $[vp(f)] = m[f];
      }
    }
  }
  function Ap(u, m) {
    return u.getAttribute ? (" " + (u.getAttribute("class") || "") + " ").replace(/[\n\t]/g, " ").indexOf(" " + m + " ") > -1 : !1;
  }
  function Cp(u, m) {
    if (m && u.setAttribute) {
      var y = (" " + (u.getAttribute("class") || "") + " ").replace(/[\n\t]/g, " "), f = y;
      N(m.split(" "), function(w) {
        w = oe(w), f = f.replace(" " + w + " ", " ");
      }), f !== y && u.setAttribute("class", oe(f));
    }
  }
  function $p(u, m) {
    if (m && u.setAttribute) {
      var y = (" " + (u.getAttribute("class") || "") + " ").replace(/[\n\t]/g, " "), f = y;
      N(m.split(" "), function(w) {
        w = oe(w), f.indexOf(" " + w + " ") === -1 && (f += w + " ");
      }), f !== y && u.setAttribute("class", oe(f));
    }
  }
  function Of(u, m) {
    if (m)
      if (m.nodeType)
        u[u.length++] = m;
      else {
        var y = m.length;
        if (typeof y == "number" && m.window !== m) {
          if (y)
            for (var f = 0; f < y; f++)
              u[u.length++] = m[f];
        } else
          u[u.length++] = m;
      }
  }
  function Mk(u, m) {
    return Sp(u, "$" + (m || "ngController") + "Controller");
  }
  function Sp(u, m, y) {
    u.nodeType === ci && (u = u.documentElement);
    for (var f = Yt(m) ? m : [m]; u; ) {
      for (var w = 0, D = f.length; w < D; w++)
        if (tt(y = p.data(u, f[w])))
          return y;
      u = u.parentNode || u.nodeType === Zi && u.host;
    }
  }
  function Xk(u) {
    for (xp(u, !0); u.firstChild; )
      u.removeChild(u.firstChild);
  }
  function kp(u, m) {
    m || xp(u);
    var y = u.parentNode;
    y && y.removeChild(u);
  }
  function hY(u, m) {
    m = m || s, m.document.readyState === "complete" ? m.setTimeout(u) : p(m).on("load", u);
  }
  function Gk(u) {
    function m() {
      s.document.removeEventListener("DOMContentLoaded", m), s.removeEventListener("load", m), u();
    }
    s.document.readyState === "complete" ? s.setTimeout(u) : (s.document.addEventListener("DOMContentLoaded", m), s.addEventListener("load", m));
  }
  var vo = rn.prototype = {
    ready: Gk,
    toString: function() {
      var u = [];
      return N(this, function(m) {
        u.push("" + m);
      }), "[" + u.join(", ") + "]";
    },
    eq: function(u) {
      return u >= 0 ? p(this[u]) : p(this[this.length + u]);
    },
    length: 0,
    push: b,
    sort: [].sort,
    splice: [].splice
  }, Tp = {};
  N("multiple,selected,checked,disabled,readOnly,required,open".split(","), function(u) {
    Tp[o(u)] = u;
  });
  var Hk = {};
  N("input,select,option,textarea,button,form,details".split(","), function(u) {
    Hk[u] = !0;
  });
  var Uk = {
    ngMinlength: "minlength",
    ngMaxlength: "maxlength",
    ngMin: "min",
    ngMax: "max",
    ngPattern: "pattern",
    ngStep: "step"
  };
  function Fk(u, m) {
    var y = Tp[m.toLowerCase()];
    return y && Hk[ye(u)] && y;
  }
  function mY(u) {
    return Uk[u];
  }
  N({
    data: _f,
    removeData: Yf,
    hasData: cY,
    cleanData: function(m) {
      for (var y = 0, f = m.length; y < f; y++)
        Yf(m[y]), Ok(m[y]);
    }
  }, function(u, m) {
    rn[m] = u;
  }), N({
    data: _f,
    inheritedData: Sp,
    scope: function(u) {
      return p.data(u, "$scope") || Sp(u.parentNode || u, ["$isolateScope", "$scope"]);
    },
    isolateScope: function(u) {
      return p.data(u, "$isolateScope") || p.data(u, "$isolateScopeNoTemplate");
    },
    controller: Mk,
    injector: function(u) {
      return Sp(u, "$injector");
    },
    removeAttr: function(u, m) {
      u.removeAttribute(m);
    },
    hasClass: Ap,
    css: function(u, m, y) {
      if (m = sY(m), tt(y))
        u.style[m] = y;
      else
        return u.style[m];
    },
    attr: function(u, m, y) {
      var f, w = u.nodeType;
      if (!(w === Ja || w === Qn || w === _n || !u.getAttribute)) {
        var D = o(m), k = Tp[D];
        if (tt(y))
          y === null || y === !1 && k ? u.removeAttribute(m) : u.setAttribute(m, k ? D : y);
        else
          return f = u.getAttribute(m), k && f !== null && (f = D), f === null ? void 0 : f;
      }
    },
    prop: function(u, m, y) {
      if (tt(y))
        u[m] = y;
      else
        return u[m];
    },
    text: function() {
      return u.$dv = "", u;
      function u(m, y) {
        if (j(y)) {
          var f = m.nodeType;
          return f === na || f === Ja ? m.textContent : "";
        }
        m.textContent = y;
      }
    }(),
    val: function(u, m) {
      if (j(m)) {
        if (u.multiple && ye(u) === "select") {
          var y = [];
          return N(u.options, function(f) {
            f.selected && y.push(f.value || f.text);
          }), y;
        }
        return u.value;
      }
      u.value = m;
    },
    html: function(u, m) {
      if (j(m))
        return u.innerHTML;
      xp(u, !0), u.innerHTML = m;
    },
    empty: Xk
  }, function(u, m) {
    rn.prototype[m] = function(y, f) {
      var w, D, k = this.length;
      if (u !== Xk && j(u.length === 2 && u !== Ap && u !== Mk ? y : f))
        if (lt(y)) {
          for (w = 0; w < k; w++)
            if (u === _f)
              u(this[w], y);
            else
              for (D in y)
                u(this[w], D, y[D]);
          return this;
        } else {
          for (var S = u.$dv, $ = j(S) ? Math.min(k, 1) : k, E = 0; E < $; E++) {
            var Y = u(this[E], y, f);
            S = S ? S + Y : Y;
          }
          return S;
        }
      else {
        for (w = 0; w < k; w++)
          u(this[w], y, f);
        return this;
      }
    };
  });
  function gY(u, m) {
    var y = function(f, w) {
      f.isDefaultPrevented = function() {
        return f.defaultPrevented;
      };
      var D = m[w || f.type], k = D ? D.length : 0;
      if (k) {
        if (j(f.immediatePropagationStopped)) {
          var S = f.stopImmediatePropagation;
          f.stopImmediatePropagation = function() {
            f.immediatePropagationStopped = !0, f.stopPropagation && f.stopPropagation(), S && S.call(f);
          };
        }
        f.isImmediatePropagationStopped = function() {
          return f.immediatePropagationStopped === !0;
        };
        var $ = D.specialHandlerWrapper || yY;
        k > 1 && (D = Ts(D));
        for (var E = 0; E < k; E++)
          f.isImmediatePropagationStopped() || $(u, f, D[E]);
      }
    };
    return y.elem = u, y;
  }
  function yY(u, m, y) {
    y.call(u, m);
  }
  function fY(u, m, y) {
    var f = m.relatedTarget;
    (!f || f !== u && !pY.call(u, f)) && y.call(u, m);
  }
  N({
    removeData: Yf,
    on: function(m, y, f, w) {
      if (tt(w))
        throw Pf("onargs", "jqLite#on() does not support the `selector` or `eventData` parameters");
      if (Nf(m)) {
        var D = wp(m, !0), k = D.events, S = D.handle;
        S || (S = D.handle = gY(m, k));
        for (var $ = y.indexOf(" ") >= 0 ? y.split(" ") : [y], E = $.length, Y = function(X, z, st) {
          var ct = k[X];
          ct || (ct = k[X] = [], ct.specialHandlerWrapper = z, X !== "$destroy" && !st && m.addEventListener(X, S)), ct.push(f);
        }; E--; )
          y = $[E], bp[y] ? (Y(bp[y], fY), Y(y, void 0, !0)) : Y(y);
      }
    },
    off: Ok,
    one: function(u, m, y) {
      u = p(u), u.on(m, function f() {
        u.off(m, y), u.off(m, f);
      }), u.on(m, y);
    },
    replaceWith: function(u, m) {
      var y, f = u.parentNode;
      xp(u), N(new rn(m), function(w) {
        y ? f.insertBefore(w, y.nextSibling) : f.replaceChild(w, u), y = w;
      });
    },
    children: function(u) {
      var m = [];
      return N(u.childNodes, function(y) {
        y.nodeType === na && m.push(y);
      }), m;
    },
    contents: function(u) {
      return u.contentDocument || u.childNodes || [];
    },
    append: function(u, m) {
      var y = u.nodeType;
      if (!(y !== na && y !== Zi)) {
        m = new rn(m);
        for (var f = 0, w = m.length; f < w; f++) {
          var D = m[f];
          u.appendChild(D);
        }
      }
    },
    prepend: function(u, m) {
      if (u.nodeType === na) {
        var y = u.firstChild;
        N(new rn(m), function(f) {
          u.insertBefore(f, y);
        });
      }
    },
    wrap: function(u, m) {
      uY(u, p(m).eq(0).clone()[0]);
    },
    remove: kp,
    detach: function(u) {
      kp(u, !0);
    },
    after: function(u, m) {
      var y = u, f = u.parentNode;
      if (f) {
        m = new rn(m);
        for (var w = 0, D = m.length; w < D; w++) {
          var k = m[w];
          f.insertBefore(k, y.nextSibling), y = k;
        }
      }
    },
    addClass: $p,
    removeClass: Cp,
    toggleClass: function(u, m, y) {
      m && N(m.split(" "), function(f) {
        var w = y;
        j(w) && (w = !Ap(u, f)), (w ? $p : Cp)(u, f);
      });
    },
    parent: function(u) {
      var m = u.parentNode;
      return m && m.nodeType !== Zi ? m : null;
    },
    next: function(u) {
      return u.nextElementSibling;
    },
    find: function(u, m) {
      return u.getElementsByTagName ? u.getElementsByTagName(m) : [];
    },
    clone: Rf,
    triggerHandler: function(u, m, y) {
      var f, w, D, k = m.type || m, S = wp(u), $ = S && S.events, E = $ && $[k];
      E && (f = {
        preventDefault: function() {
          this.defaultPrevented = !0;
        },
        isDefaultPrevented: function() {
          return this.defaultPrevented === !0;
        },
        stopImmediatePropagation: function() {
          this.immediatePropagationStopped = !0;
        },
        isImmediatePropagationStopped: function() {
          return this.immediatePropagationStopped === !0;
        },
        stopPropagation: J,
        type: k,
        target: u
      }, m.type && (f = et(f, m)), w = Ts(E), D = y ? [f].concat(y) : [f], N(w, function(Y) {
        f.isImmediatePropagationStopped() || Y.apply(u, D);
      }));
    }
  }, function(u, m) {
    rn.prototype[m] = function(y, f, w) {
      for (var D, k = 0, S = this.length; k < S; k++)
        j(D) ? (D = u(this[k], y, f, w), tt(D) && (D = p(D))) : Of(D, u(this[k], y, f, w));
      return tt(D) ? D : this;
    };
  }), rn.prototype.bind = rn.prototype.on, rn.prototype.unbind = rn.prototype.off;
  function bY() {
    this.$get = function() {
      return et(rn, {
        hasClass: function(m, y) {
          return m.attr && (m = m[0]), Ap(m, y);
        },
        addClass: function(m, y) {
          return m.attr && (m = m[0]), $p(m, y);
        },
        removeClass: function(m, y) {
          return m.attr && (m = m[0]), Cp(m, y);
        }
      });
    };
  }
  function xo(u, m) {
    var y = u && u.$$hashKey;
    if (y)
      return typeof y == "function" && (y = u.$$hashKey()), y;
    var f = typeof u;
    return f === "function" || f === "object" && u !== null ? y = u.$$hashKey = f + ":" + (m || B)() : y = f + ":" + u, y;
  }
  var vY = /* @__PURE__ */ Object.create(null);
  function zk() {
    this._keys = [], this._values = [], this._lastKey = NaN, this._lastIndex = -1;
  }
  zk.prototype = {
    _idx: function(u) {
      return u !== this._lastKey && (this._lastKey = u, this._lastIndex = this._keys.indexOf(u)), this._lastIndex;
    },
    _transformKey: function(u) {
      return M(u) ? vY : u;
    },
    get: function(u) {
      u = this._transformKey(u);
      var m = this._idx(u);
      if (m !== -1)
        return this._values[m];
    },
    has: function(u) {
      u = this._transformKey(u);
      var m = this._idx(u);
      return m !== -1;
    },
    set: function(u, m) {
      u = this._transformKey(u);
      var y = this._idx(u);
      y === -1 && (y = this._lastIndex = this._keys.length), this._keys[y] = u, this._values[y] = m;
    },
    delete: function(u) {
      u = this._transformKey(u);
      var m = this._idx(u);
      return m === -1 ? !1 : (this._keys.splice(m, 1), this._values.splice(m, 1), this._lastKey = NaN, this._lastIndex = -1, !0);
    }
  };
  var Lp = zk, xY = [
    /** @this */
    function() {
      this.$get = [function() {
        return Lp;
      }];
    }
  ], wY = /^([^(]+?)=>/, AY = /^[^(]*\(\s*([^)]*)\)/m, CY = /,/, $Y = /^\s*(_?)(\S+?)\1\s*$/, SY = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg, ml = n("$injector");
  function Bk(u) {
    return Function.prototype.toString.call(u);
  }
  function Wk(u) {
    var m = Bk(u).replace(SY, ""), y = m.match(wY) || m.match(AY);
    return y;
  }
  function kY(u) {
    var m = Wk(u);
    return m ? "function(" + (m[1] || "").replace(/[\s\r\n]+/, " ") + ")" : "fn";
  }
  function TY(u, m, y) {
    var f, w, D;
    if (typeof u == "function") {
      if (!(f = u.$inject)) {
        if (f = [], u.length) {
          if (m)
            throw (!nt(y) || !y) && (y = u.name || kY(u)), ml(
              "strictdi",
              "{0} is not using explicit annotation and cannot be invoked in strict mode",
              y
            );
          w = Wk(u), N(w[1].split(CY), function(k) {
            k.replace($Y, function(S, $, E) {
              f.push(E);
            });
          });
        }
        u.$inject = f;
      }
    } else
      Yt(u) ? (D = u.length - 1, pe(u[D], "fn"), f = u.slice(0, D)) : pe(u, "fn", !0);
    return f;
  }
  function nd(u, m) {
    m = m === !0;
    var y = {}, f = "Provider", w = [], D = new Lp(), k = {
      $provide: {
        provider: z(st),
        factory: z(It),
        service: z(Ut),
        value: z(Et),
        constant: z(Dt),
        decorator: Tt
      }
    }, S = k.$injector = mt(k, function(ft, Z) {
      throw C.isString(Z) && w.push(Z), ml("unpr", "Unknown provider: {0}", w.join(" <- "));
    }), $ = {}, E = mt($, function(ft, Z) {
      var q = S.get(ft + f, Z);
      return Y.invoke(
        q.$get,
        q,
        void 0,
        ft
      );
    }), Y = E;
    k["$injector" + f] = { $get: St(E) }, Y.modules = S.modules = Ee();
    var X = Ot(u);
    return Y = E.get("$injector"), Y.strictDi = m, N(X, function(ft) {
      ft && Y.invoke(ft);
    }), Y.loadNewModules = function(ft) {
      N(Ot(ft), function(Z) {
        Z && Y.invoke(Z);
      });
    }, Y;
    function z(ft) {
      return function(Z, q) {
        if (lt(Z))
          N(Z, F(ft));
        else
          return ft(Z, q);
      };
    }
    function st(ft, Z) {
      if (Pe(ft, "service"), (_(Z) || Yt(Z)) && (Z = S.instantiate(Z)), !Z.$get)
        throw ml("pget", "Provider '{0}' must define $get factory method.", ft);
      return k[ft + f] = Z;
    }
    function ct(ft, Z) {
      return (
        /** @this */
        function() {
          var ut = Y.invoke(Z, this);
          if (j(ut))
            throw ml("undef", "Provider '{0}' must return a value from $get factory method.", ft);
          return ut;
        }
      );
    }
    function It(ft, Z, q) {
      return st(ft, {
        $get: q !== !1 ? ct(ft, Z) : Z
      });
    }
    function Ut(ft, Z) {
      return It(ft, ["$injector", function(q) {
        return q.instantiate(Z);
      }]);
    }
    function Et(ft, Z) {
      return It(ft, St(Z), !1);
    }
    function Dt(ft, Z) {
      Pe(ft, "constant"), k[ft] = Z, $[ft] = Z;
    }
    function Tt(ft, Z) {
      var q = S.get(ft + f), ut = q.$get;
      q.$get = function() {
        var pt = Y.invoke(ut, q);
        return Y.invoke(Z, null, { $delegate: pt });
      };
    }
    function Ot(ft) {
      ke(j(ft) || Yt(ft), "modulesToLoad", "not an array");
      var Z = [], q;
      return N(ft, function(ut) {
        if (D.get(ut))
          return;
        D.set(ut, !0);
        function pt(xt) {
          var Mt, kt;
          for (Mt = 0, kt = xt.length; Mt < kt; Mt++) {
            var Gt = xt[Mt], Vt = S.get(Gt[0]);
            Vt[Gt[1]].apply(Vt, Gt[2]);
          }
        }
        try {
          nt(ut) ? (q = v(ut), Y.modules[ut] = q, Z = Z.concat(Ot(q.requires)).concat(q._runBlocks), pt(q._invokeQueue), pt(q._configBlocks)) : _(ut) || Yt(ut) ? Z.push(S.invoke(ut)) : pe(ut, "module");
        } catch (xt) {
          throw Yt(ut) && (ut = ut[ut.length - 1]), xt.message && xt.stack && xt.stack.indexOf(xt.message) === -1 && (xt = xt.message + `
` + xt.stack), ml(
            "modulerr",
            `Failed to instantiate module {0} due to:
{1}`,
            ut,
            xt.stack || xt.message || xt
          );
        }
      }), Z;
    }
    function mt(ft, Z) {
      function q(kt, Gt) {
        if (ft.hasOwnProperty(kt)) {
          if (ft[kt] === y)
            throw ml(
              "cdep",
              "Circular dependency found: {0}",
              kt + " <- " + w.join(" <- ")
            );
          return ft[kt];
        } else
          try {
            return w.unshift(kt), ft[kt] = y, ft[kt] = Z(kt, Gt), ft[kt];
          } catch (Vt) {
            throw ft[kt] === y && delete ft[kt], Vt;
          } finally {
            w.shift();
          }
      }
      function ut(kt, Gt, Vt) {
        for (var ee = [], Bt = nd.$$annotate(kt, m, Vt), re = 0, Le = Bt.length; re < Le; re++) {
          var $e = Bt[re];
          if (typeof $e != "string")
            throw ml(
              "itkn",
              "Incorrect injection token! Expected service name as string, got {0}",
              $e
            );
          ee.push(Gt && Gt.hasOwnProperty($e) ? Gt[$e] : q($e, Vt));
        }
        return ee;
      }
      function pt(kt) {
        if (d || typeof kt != "function")
          return !1;
        var Gt = kt.$$ngIsClass;
        return _t(Gt) || (Gt = kt.$$ngIsClass = /^class\b/.test(Bk(kt))), Gt;
      }
      function xt(kt, Gt, Vt, ee) {
        typeof Vt == "string" && (ee = Vt, Vt = null);
        var Bt = ut(kt, Vt, ee);
        return Yt(kt) && (kt = kt[kt.length - 1]), pt(kt) ? (Bt.unshift(null), new (Function.prototype.bind.apply(kt, Bt))()) : kt.apply(Gt, Bt);
      }
      function Mt(kt, Gt, Vt) {
        var ee = Yt(kt) ? kt[kt.length - 1] : kt, Bt = ut(kt, Gt, Vt);
        return Bt.unshift(null), new (Function.prototype.bind.apply(ee, Bt))();
      }
      return {
        invoke: xt,
        instantiate: Mt,
        get: q,
        annotate: nd.$$annotate,
        has: function(kt) {
          return k.hasOwnProperty(kt + f) || ft.hasOwnProperty(kt);
        }
      };
    }
  }
  nd.$$annotate = TY;
  function LY() {
    var u = !0;
    this.disableAutoScrolling = function() {
      u = !1;
    }, this.$get = ["$window", "$location", "$rootScope", function(m, y, f) {
      var w = m.document;
      function D(E) {
        var Y = null;
        return Array.prototype.some.call(E, function(X) {
          if (ye(X) === "a")
            return Y = X, !0;
        }), Y;
      }
      function k() {
        var E = $.yOffset;
        if (_(E))
          E = E();
        else if (ze(E)) {
          var Y = E[0], X = m.getComputedStyle(Y);
          X.position !== "fixed" ? E = 0 : E = Y.getBoundingClientRect().bottom;
        } else
          yt(E) || (E = 0);
        return E;
      }
      function S(E) {
        if (E) {
          E.scrollIntoView();
          var Y = k();
          if (Y) {
            var X = E.getBoundingClientRect().top;
            m.scrollBy(0, X - Y);
          }
        } else
          m.scrollTo(0, 0);
      }
      function $(E) {
        E = nt(E) ? E : yt(E) ? E.toString() : y.hash();
        var Y;
        E ? (Y = w.getElementById(E)) || (Y = D(w.getElementsByName(E))) ? S(Y) : E === "top" && S(null) : S(null);
      }
      return u && f.$watch(
        function() {
          return y.hash();
        },
        function(Y, X) {
          Y === X && Y === "" || hY(function() {
            f.$evalAsync($);
          });
        }
      ), $;
    }];
  }
  var jk = n("$animate"), DY = 1, Vk = "ng-animate";
  function sd(u, m) {
    return !u && !m ? "" : u ? m ? (Yt(u) && (u = u.join(" ")), Yt(m) && (m = m.join(" ")), u + " " + m) : u : m;
  }
  function IY(u) {
    for (var m = 0; m < u.length; m++) {
      var y = u[m];
      if (y.nodeType === DY)
        return y;
    }
  }
  function PY(u) {
    nt(u) && (u = u.split(" "));
    var m = Ee();
    return N(u, function(y) {
      y.length && (m[y] = !0);
    }), m;
  }
  function gl(u) {
    return lt(u) ? u : {};
  }
  var EY = (
    /** @this */
    function() {
      this.$get = J;
    }
  ), NY = (
    /** @this */
    function() {
      var u = new Lp(), m = [];
      this.$get = [
        "$$AnimateRunner",
        "$rootScope",
        function(y, f) {
          return {
            enabled: J,
            on: J,
            off: J,
            pin: J,
            push: function(S, $, E, Y) {
              Y && Y(), E = E || {}, E.from && S.css(E.from), E.to && S.css(E.to), (E.addClass || E.removeClass) && k(S, E.addClass, E.removeClass);
              var X = new y();
              return X.complete(), X;
            }
          };
          function w(S, $, E) {
            var Y = !1;
            return $ && ($ = nt($) ? $.split(" ") : Yt($) ? $ : [], N($, function(X) {
              X && (Y = !0, S[X] = E);
            })), Y;
          }
          function D() {
            N(m, function(S) {
              var $ = u.get(S);
              if ($) {
                var E = PY(S.attr("class")), Y = "", X = "";
                N($, function(z, st) {
                  var ct = !!E[st];
                  z !== ct && (z ? Y += (Y.length ? " " : "") + st : X += (X.length ? " " : "") + st);
                }), N(S, function(z) {
                  Y && $p(z, Y), X && Cp(z, X);
                }), u.delete(S);
              }
            }), m.length = 0;
          }
          function k(S, $, E) {
            var Y = u.get(S) || {}, X = w(Y, $, !0), z = w(Y, E, !1);
            (X || z) && (u.set(S, Y), m.push(S), m.length === 1 && f.$$postDigest(D));
          }
        }
      ];
    }
  ), RY = [
    "$provide",
    /** @this */
    function(u) {
      var m = this, y = null, f = null;
      this.$$registeredAnimations = /* @__PURE__ */ Object.create(null), this.register = function(w, D) {
        if (w && w.charAt(0) !== ".")
          throw jk("notcsel", "Expecting class selector starting with '.' got '{0}'.", w);
        var k = w + "-animation";
        m.$$registeredAnimations[w.substr(1)] = k, u.factory(k, D);
      }, this.customFilter = function(w) {
        return arguments.length === 1 && (f = _(w) ? w : null), f;
      }, this.classNameFilter = function(w) {
        if (arguments.length === 1 && (y = w instanceof RegExp ? w : null, y)) {
          var D = new RegExp("[(\\s|\\/)]" + Vk + "[(\\s|\\/)]");
          if (D.test(y.toString()))
            throw y = null, jk("nongcls", '$animateProvider.classNameFilter(regex) prohibits accepting a regex value which matches/contains the "{0}" CSS class.', Vk);
        }
        return y;
      }, this.$get = ["$$animateQueue", function(w) {
        function D(k, S, $) {
          if ($) {
            var E = IY($);
            E && !E.parentNode && !E.previousElementSibling && ($ = null);
          }
          $ ? $.after(k) : S.prepend(k);
        }
        return {
          // we don't call it directly since non-existant arguments may
          // be interpreted as null within the sub enabled function
          /**
           *
           * @ngdoc method
           * @name $animate#on
           * @kind function
           * @description Sets up an event listener to fire whenever the animation event (enter, leave, move, etc...)
           *    has fired on the given element or among any of its children. Once the listener is fired, the provided callback
           *    is fired with the following params:
           *
           * ```js
           * $animate.on('enter', container,
           *    function callback(element, phase) {
           *      // cool we detected an enter animation within the container
           *    }
           * );
           * ```
           *
           * <div class="alert alert-warning">
           * **Note**: Generally, the events that are fired correspond 1:1 to `$animate` method names,
           * e.g. {@link ng.$animate#addClass addClass()} will fire `addClass`, and {@link ng.ngClass}
           * will fire `addClass` if classes are added, and `removeClass` if classes are removed.
           * However, there are two exceptions:
           *
           * <ul>
           *   <li>if both an {@link ng.$animate#addClass addClass()} and a
           *   {@link ng.$animate#removeClass removeClass()} action are performed during the same
           *   animation, the event fired will be `setClass`. This is true even for `ngClass`.</li>
           *   <li>an {@link ng.$animate#animate animate()} call that adds and removes classes will fire
           *   the `setClass` event, but if it either removes or adds classes,
           *   it will fire `animate` instead.</li>
           * </ul>
           *
           * </div>
           *
           * @param {string} event the animation event that will be captured (e.g. enter, leave, move, addClass, removeClass, etc...)
           * @param {DOMElement} container the container element that will capture each of the animation events that are fired on itself
           *     as well as among its children
           * @param {Function} callback the callback function that will be fired when the listener is triggered.
           *
           * The arguments present in the callback function are:
           * * `element` - The captured DOM element that the animation was fired on.
           * * `phase` - The phase of the animation. The two possible phases are **start** (when the animation starts) and **close** (when it ends).
           * * `data` - an object with these properties:
           *     * addClass - `{string|null}` - space-separated CSS classes to add to the element
           *     * removeClass - `{string|null}` - space-separated CSS classes to remove from the element
           *     * from - `{Object|null}` - CSS properties & values at the beginning of the animation
           *     * to - `{Object|null}` - CSS properties & values at the end of the animation
           *
           * Note that the callback does not trigger a scope digest. Wrap your call into a
           * {@link $rootScope.Scope#$apply scope.$apply} to propagate changes to the scope.
           */
          on: w.on,
          /**
           *
           * @ngdoc method
           * @name $animate#off
           * @kind function
           * @description Deregisters an event listener based on the event which has been associated with the provided element. This method
           * can be used in three different ways depending on the arguments:
           *
           * ```js
           * // remove all the animation event listeners listening for `enter`
           * $animate.off('enter');
           *
           * // remove listeners for all animation events from the container element
           * $animate.off(container);
           *
           * // remove all the animation event listeners listening for `enter` on the given element and its children
           * $animate.off('enter', container);
           *
           * // remove the event listener function provided by `callback` that is set
           * // to listen for `enter` on the given `container` as well as its children
           * $animate.off('enter', container, callback);
           * ```
           *
           * @param {string|DOMElement} event|container the animation event (e.g. enter, leave, move,
           * addClass, removeClass, etc...), or the container element. If it is the element, all other
           * arguments are ignored.
           * @param {DOMElement=} container the container element the event listener was placed on
           * @param {Function=} callback the callback function that was registered as the listener
           */
          off: w.off,
          /**
           * @ngdoc method
           * @name $animate#pin
           * @kind function
           * @description Associates the provided element with a host parent element to allow the element to be animated even if it exists
           *    outside of the DOM structure of the AngularJS application. By doing so, any animation triggered via `$animate` can be issued on the
           *    element despite being outside the realm of the application or within another application. Say for example if the application
           *    was bootstrapped on an element that is somewhere inside of the `<body>` tag, but we wanted to allow for an element to be situated
           *    as a direct child of `document.body`, then this can be achieved by pinning the element via `$animate.pin(element)`. Keep in mind
           *    that calling `$animate.pin(element, parentElement)` will not actually insert into the DOM anywhere; it will just create the association.
           *
           *    Note that this feature is only active when the `ngAnimate` module is used.
           *
           * @param {DOMElement} element the external element that will be pinned
           * @param {DOMElement} parentElement the host parent element that will be associated with the external element
           */
          pin: w.pin,
          /**
           *
           * @ngdoc method
           * @name $animate#enabled
           * @kind function
           * @description Used to get and set whether animations are enabled or not on the entire application or on an element and its children. This
           * function can be called in four ways:
           *
           * ```js
           * // returns true or false
           * $animate.enabled();
           *
           * // changes the enabled state for all animations
           * $animate.enabled(false);
           * $animate.enabled(true);
           *
           * // returns true or false if animations are enabled for an element
           * $animate.enabled(element);
           *
           * // changes the enabled state for an element and its children
           * $animate.enabled(element, true);
           * $animate.enabled(element, false);
           * ```
           *
           * @param {DOMElement=} element the element that will be considered for checking/setting the enabled state
           * @param {boolean=} enabled whether or not the animations will be enabled for the element
           *
           * @return {boolean} whether or not animations are enabled
           */
          enabled: w.enabled,
          /**
                 * @ngdoc method
                 * @name $animate#cancel
                 * @kind function
                 * @description Cancels the provided animation and applies the end state of the animation.
                 * Note that this does not cancel the underlying operation, e.g. the setting of classes or
                 * adding the element to the DOM.
                 *
                 * @param {animationRunner} animationRunner An animation runner returned by an $animate function.
                 *
                 * @example
                  <example module="animationExample" deps="angular-animate.js" animations="true" name="animate-cancel">
                    <file name="app.js">
                      angular.module('animationExample', ['ngAnimate']).component('cancelExample', {
                        templateUrl: 'template.html',
                        controller: function($element, $animate) {
                          this.runner = null;
          
                          this.addClass = function() {
                            this.runner = $animate.addClass($element.find('div'), 'red');
                            var ctrl = this;
                            this.runner.finally(function() {
                              ctrl.runner = null;
                            });
                          };
          
                          this.removeClass = function() {
                            this.runner = $animate.removeClass($element.find('div'), 'red');
                            var ctrl = this;
                            this.runner.finally(function() {
                              ctrl.runner = null;
                            });
                          };
          
                          this.cancel = function() {
                            $animate.cancel(this.runner);
                          };
                        }
                      });
                    </file>
                    <file name="template.html">
                      <p>
                        <button id="add" ng-click="$ctrl.addClass()">Add</button>
                        <button ng-click="$ctrl.removeClass()">Remove</button>
                        <br>
                        <button id="cancel" ng-click="$ctrl.cancel()" ng-disabled="!$ctrl.runner">Cancel</button>
                        <br>
                        <div id="target">CSS-Animated Text</div>
                      </p>
                    </file>
                    <file name="index.html">
                      <cancel-example></cancel-example>
                    </file>
                    <file name="style.css">
                      .red-add, .red-remove {
                        transition: all 4s cubic-bezier(0.250, 0.460, 0.450, 0.940);
                      }
          
                      .red,
                      .red-add.red-add-active {
                        color: #FF0000;
                        font-size: 40px;
                      }
          
                      .red-remove.red-remove-active {
                        font-size: 10px;
                        color: black;
                      }
          
                    </file>
                  </example>
                 */
          cancel: function(k) {
            k.cancel && k.cancel();
          },
          /**
           *
           * @ngdoc method
           * @name $animate#enter
           * @kind function
           * @description Inserts the element into the DOM either after the `after` element (if provided) or
           *   as the first child within the `parent` element and then triggers an animation.
           *   A promise is returned that will be resolved during the next digest once the animation
           *   has completed.
           *
           * @param {DOMElement} element the element which will be inserted into the DOM
           * @param {DOMElement} parent the parent element which will append the element as
           *   a child (so long as the after element is not present)
           * @param {DOMElement=} after the sibling element after which the element will be appended
           * @param {object=} options an optional collection of options/styles that will be applied to the element.
           *   The object can have the following properties:
           *
           *   - **addClass** - `{string}` - space-separated CSS classes to add to element
           *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
           *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
           *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
           *
           * @return {Runner} the animation runner
           */
          enter: function(k, S, $, E) {
            return S = S && p(S), $ = $ && p($), S = S || $.parent(), D(k, S, $), w.push(k, "enter", gl(E));
          },
          /**
           *
           * @ngdoc method
           * @name $animate#move
           * @kind function
           * @description Inserts (moves) the element into its new position in the DOM either after
           *   the `after` element (if provided) or as the first child within the `parent` element
           *   and then triggers an animation. A promise is returned that will be resolved
           *   during the next digest once the animation has completed.
           *
           * @param {DOMElement} element the element which will be moved into the new DOM position
           * @param {DOMElement} parent the parent element which will append the element as
           *   a child (so long as the after element is not present)
           * @param {DOMElement=} after the sibling element after which the element will be appended
           * @param {object=} options an optional collection of options/styles that will be applied to the element.
           *   The object can have the following properties:
           *
           *   - **addClass** - `{string}` - space-separated CSS classes to add to element
           *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
           *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
           *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
           *
           * @return {Runner} the animation runner
           */
          move: function(k, S, $, E) {
            return S = S && p(S), $ = $ && p($), S = S || $.parent(), D(k, S, $), w.push(k, "move", gl(E));
          },
          /**
           * @ngdoc method
           * @name $animate#leave
           * @kind function
           * @description Triggers an animation and then removes the element from the DOM.
           * When the function is called a promise is returned that will be resolved during the next
           * digest once the animation has completed.
           *
           * @param {DOMElement} element the element which will be removed from the DOM
           * @param {object=} options an optional collection of options/styles that will be applied to the element.
           *   The object can have the following properties:
           *
           *   - **addClass** - `{string}` - space-separated CSS classes to add to element
           *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
           *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
           *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
           *
           * @return {Runner} the animation runner
           */
          leave: function(k, S) {
            return w.push(k, "leave", gl(S), function() {
              k.remove();
            });
          },
          /**
           * @ngdoc method
           * @name $animate#addClass
           * @kind function
           *
           * @description Triggers an addClass animation surrounding the addition of the provided CSS class(es). Upon
           *   execution, the addClass operation will only be handled after the next digest and it will not trigger an
           *   animation if element already contains the CSS class or if the class is removed at a later step.
           *   Note that class-based animations are treated differently compared to structural animations
           *   (like enter, move and leave) since the CSS classes may be added/removed at different points
           *   depending if CSS or JavaScript animations are used.
           *
           * @param {DOMElement} element the element which the CSS classes will be applied to
           * @param {string} className the CSS class(es) that will be added (multiple classes are separated via spaces)
           * @param {object=} options an optional collection of options/styles that will be applied to the element.
           *   The object can have the following properties:
           *
           *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
           *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
           *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
           *
           * @return {Runner} animationRunner the animation runner
           */
          addClass: function(k, S, $) {
            return $ = gl($), $.addClass = sd($.addclass, S), w.push(k, "addClass", $);
          },
          /**
           * @ngdoc method
           * @name $animate#removeClass
           * @kind function
           *
           * @description Triggers a removeClass animation surrounding the removal of the provided CSS class(es). Upon
           *   execution, the removeClass operation will only be handled after the next digest and it will not trigger an
           *   animation if element does not contain the CSS class or if the class is added at a later step.
           *   Note that class-based animations are treated differently compared to structural animations
           *   (like enter, move and leave) since the CSS classes may be added/removed at different points
           *   depending if CSS or JavaScript animations are used.
           *
           * @param {DOMElement} element the element which the CSS classes will be applied to
           * @param {string} className the CSS class(es) that will be removed (multiple classes are separated via spaces)
           * @param {object=} options an optional collection of options/styles that will be applied to the element.
           *   The object can have the following properties:
           *
           *   - **addClass** - `{string}` - space-separated CSS classes to add to element
           *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
           *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
           *
           * @return {Runner} the animation runner
           */
          removeClass: function(k, S, $) {
            return $ = gl($), $.removeClass = sd($.removeClass, S), w.push(k, "removeClass", $);
          },
          /**
           * @ngdoc method
           * @name $animate#setClass
           * @kind function
           *
           * @description Performs both the addition and removal of a CSS classes on an element and (during the process)
           *    triggers an animation surrounding the class addition/removal. Much like `$animate.addClass` and
           *    `$animate.removeClass`, `setClass` will only evaluate the classes being added/removed once a digest has
           *    passed. Note that class-based animations are treated differently compared to structural animations
           *    (like enter, move and leave) since the CSS classes may be added/removed at different points
           *    depending if CSS or JavaScript animations are used.
           *
           * @param {DOMElement} element the element which the CSS classes will be applied to
           * @param {string} add the CSS class(es) that will be added (multiple classes are separated via spaces)
           * @param {string} remove the CSS class(es) that will be removed (multiple classes are separated via spaces)
           * @param {object=} options an optional collection of options/styles that will be applied to the element.
           *   The object can have the following properties:
           *
           *   - **addClass** - `{string}` - space-separated CSS classes to add to element
           *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
           *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
           *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
           *
           * @return {Runner} the animation runner
           */
          setClass: function(k, S, $, E) {
            return E = gl(E), E.addClass = sd(E.addClass, S), E.removeClass = sd(E.removeClass, $), w.push(k, "setClass", E);
          },
          /**
           * @ngdoc method
           * @name $animate#animate
           * @kind function
           *
           * @description Performs an inline animation on the element which applies the provided to and from CSS styles to the element.
           * If any detected CSS transition, keyframe or JavaScript matches the provided className value, then the animation will take
           * on the provided styles. For example, if a transition animation is set for the given className, then the provided `from` and
           * `to` styles will be applied alongside the given transition. If the CSS style provided in `from` does not have a corresponding
           * style in `to`, the style in `from` is applied immediately, and no animation is run.
           * If a JavaScript animation is detected then the provided styles will be given in as function parameters into the `animate`
           * method (or as part of the `options` parameter):
           *
           * ```js
           * ngModule.animation('.my-inline-animation', function() {
           *   return {
           *     animate : function(element, from, to, done, options) {
           *       //animation
           *       done();
           *     }
           *   }
           * });
           * ```
           *
           * @param {DOMElement} element the element which the CSS styles will be applied to
           * @param {object} from the from (starting) CSS styles that will be applied to the element and across the animation.
           * @param {object} to the to (destination) CSS styles that will be applied to the element and across the animation.
           * @param {string=} className an optional CSS class that will be applied to the element for the duration of the animation. If
           *    this value is left as empty then a CSS class of `ng-inline-animate` will be applied to the element.
           *    (Note that if no animation is detected then this value will not be applied to the element.)
           * @param {object=} options an optional collection of options/styles that will be applied to the element.
           *   The object can have the following properties:
           *
           *   - **addClass** - `{string}` - space-separated CSS classes to add to element
           *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
           *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
           *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
           *
           * @return {Runner} the animation runner
           */
          animate: function(k, S, $, E, Y) {
            return Y = gl(Y), Y.from = Y.from ? et(Y.from, S) : S, Y.to = Y.to ? et(Y.to, $) : $, E = E || "ng-inline-animate", Y.tempClasses = sd(Y.tempClasses, E), w.push(k, "animate", Y);
          }
        };
      }];
    }
  ], YY = (
    /** @this */
    function() {
      this.$get = ["$$rAF", function(u) {
        var m = [];
        function y(f) {
          m.push(f), !(m.length > 1) && u(function() {
            for (var w = 0; w < m.length; w++)
              m[w]();
            m = [];
          });
        }
        return function() {
          var f = !1;
          return y(function() {
            f = !0;
          }), function(w) {
            f ? w() : y(w);
          };
        };
      }];
    }
  ), _Y = (
    /** @this */
    function() {
      this.$get = [
        "$q",
        "$sniffer",
        "$$animateAsyncRun",
        "$$isDocumentHidden",
        "$timeout",
        function(u, m, y, f, w) {
          var D = 0, k = 1, S = 2;
          $.chain = function(E, Y) {
            var X = 0;
            z();
            function z() {
              if (X === E.length) {
                Y(!0);
                return;
              }
              E[X](function(st) {
                if (st === !1) {
                  Y(!1);
                  return;
                }
                X++, z();
              });
            }
          }, $.all = function(E, Y) {
            var X = 0, z = !0;
            N(E, function(ct) {
              ct.done(st);
            });
            function st(ct) {
              z = z && ct, ++X === E.length && Y(z);
            }
          };
          function $(E) {
            this.setHost(E);
            var Y = y(), X = function(z) {
              w(z, 0, !1);
            };
            this._doneCallbacks = [], this._tick = function(z) {
              f() ? X(z) : Y(z);
            }, this._state = 0;
          }
          return $.prototype = {
            setHost: function(E) {
              this.host = E || {};
            },
            done: function(E) {
              this._state === S ? E() : this._doneCallbacks.push(E);
            },
            progress: J,
            getPromise: function() {
              if (!this.promise) {
                var E = this;
                this.promise = u(function(Y, X) {
                  E.done(function(z) {
                    z === !1 ? X() : Y();
                  });
                });
              }
              return this.promise;
            },
            then: function(E, Y) {
              return this.getPromise().then(E, Y);
            },
            catch: function(E) {
              return this.getPromise().catch(E);
            },
            finally: function(E) {
              return this.getPromise().finally(E);
            },
            pause: function() {
              this.host.pause && this.host.pause();
            },
            resume: function() {
              this.host.resume && this.host.resume();
            },
            end: function() {
              this.host.end && this.host.end(), this._resolve(!0);
            },
            cancel: function() {
              this.host.cancel && this.host.cancel(), this._resolve(!1);
            },
            complete: function(E) {
              var Y = this;
              Y._state === D && (Y._state = k, Y._tick(function() {
                Y._resolve(E);
              }));
            },
            _resolve: function(E) {
              this._state !== S && (N(this._doneCallbacks, function(Y) {
                Y(E);
              }), this._doneCallbacks.length = 0, this._state = S);
            }
          }, $;
        }
      ];
    }
  ), OY = function() {
    this.$get = ["$$rAF", "$q", "$$AnimateRunner", function(u, m, y) {
      return function(f, w) {
        var D = w || {};
        D.$$prepared || (D = la(D)), D.cleanupStyles && (D.from = D.to = null), D.from && (f.css(D.from), D.from = null);
        var k, S = new y();
        return {
          start: $,
          end: $
        };
        function $() {
          return u(function() {
            E(), k || S.complete(), k = !0;
          }), S;
        }
        function E() {
          D.addClass && (f.addClass(D.addClass), D.addClass = null), D.removeClass && (f.removeClass(D.removeClass), D.removeClass = null), D.to && (f.css(D.to), D.to = null);
        }
      };
    }];
  };
  function MY(u) {
    var m = u.indexOf("#");
    return m === -1 ? "" : u.substr(m);
  }
  function XY(u) {
    return u.replace(/#$/, "");
  }
  function GY(u, m, y, f, w) {
    var D = this, k = u.location, S = u.history, $ = u.setTimeout, E = u.clearTimeout, Y = {}, X = w(y);
    D.isMock = !1, D.$$completeOutstandingRequest = X.completeTask, D.$$incOutstandingRequestCount = X.incTaskCount, D.notifyWhenNoOutstandingRequests = X.notifyWhenNoPendingTasks;
    var z, st, ct = k.href, It = m.find("base"), Ut = null, Et = f.history ? function() {
      try {
        return S.state;
      } catch {
      }
    } : J;
    ft(), D.url = function(q, ut, pt) {
      if (j(pt) && (pt = null), k !== u.location && (k = u.location), S !== u.history && (S = u.history), q) {
        var xt = st === pt;
        if (q = us(q).href, ct === q && (!f.history || xt))
          return D;
        var Mt = ct && fl(ct) === fl(q);
        return ct = q, st = pt, f.history && (!Mt || !xt) ? (S[ut ? "replaceState" : "pushState"](pt, "", q), ft()) : (Mt || (Ut = q), ut ? k.replace(q) : Mt ? k.hash = MY(q) : k.href = q, k.href !== q && (Ut = q)), Ut && (Ut = q), D;
      } else
        return XY(Ut || k.href);
    }, D.state = function() {
      return z;
    };
    var Dt = [], Tt = !1;
    function Ot() {
      Ut = null, Z();
    }
    var mt = null;
    function ft() {
      z = Et(), z = j(z) ? null : z, je(z, mt) && (z = mt), mt = z, st = z;
    }
    function Z() {
      var q = st;
      ft(), !(ct === D.url() && q === z) && (ct = D.url(), st = z, N(Dt, function(ut) {
        ut(D.url(), z);
      }));
    }
    D.onUrlChange = function(q) {
      return Tt || (f.history && p(u).on("popstate", Ot), p(u).on("hashchange", Ot), Tt = !0), Dt.push(q), q;
    }, D.$$applicationDestroyed = function() {
      p(u).off("hashchange popstate", Ot);
    }, D.$$checkUrlChange = Z, D.baseHref = function() {
      var q = It.attr("href");
      return q ? q.replace(/^(https?:)?\/\/[^/]*/, "") : "";
    }, D.defer = function(q, ut, pt) {
      var xt;
      return ut = ut || 0, pt = pt || X.DEFAULT_TASK_TYPE, X.incTaskCount(pt), xt = $(function() {
        delete Y[xt], X.completeTask(q, pt);
      }, ut), Y[xt] = pt, xt;
    }, D.defer.cancel = function(q) {
      if (Y.hasOwnProperty(q)) {
        var ut = Y[q];
        return delete Y[q], E(q), X.completeTask(J, ut), !0;
      }
      return !1;
    };
  }
  function HY() {
    this.$get = [
      "$window",
      "$log",
      "$sniffer",
      "$document",
      "$$taskTrackerFactory",
      function(u, m, y, f, w) {
        return new GY(u, f, m, y, w);
      }
    ];
  }
  function UY() {
    this.$get = function() {
      var u = {};
      function m(y, f) {
        if (y in u)
          throw n("$cacheFactory")("iid", "CacheId '{0}' is already taken!", y);
        var w = 0, D = et({}, f, { id: y }), k = Ee(), S = f && f.capacity || Number.MAX_VALUE, $ = Ee(), E = null, Y = null;
        return u[y] = {
          /**
           * @ngdoc method
           * @name $cacheFactory.Cache#put
           * @kind function
           *
           * @description
           * Inserts a named entry into the {@link $cacheFactory.Cache Cache} object to be
           * retrieved later, and incrementing the size of the cache if the key was not already
           * present in the cache. If behaving like an LRU cache, it will also remove stale
           * entries from the set.
           *
           * It will not insert undefined values into the cache.
           *
           * @param {string} key the key under which the cached data is stored.
           * @param {*} value the value to store alongside the key. If it is undefined, the key
           *    will not be stored.
           * @returns {*} the value stored.
           */
          put: function(st, ct) {
            if (!j(ct)) {
              if (S < Number.MAX_VALUE) {
                var It = $[st] || ($[st] = { key: st });
                X(It);
              }
              return st in k || w++, k[st] = ct, w > S && this.remove(Y.key), ct;
            }
          },
          /**
           * @ngdoc method
           * @name $cacheFactory.Cache#get
           * @kind function
           *
           * @description
           * Retrieves named data stored in the {@link $cacheFactory.Cache Cache} object.
           *
           * @param {string} key the key of the data to be retrieved
           * @returns {*} the value stored.
           */
          get: function(st) {
            if (S < Number.MAX_VALUE) {
              var ct = $[st];
              if (!ct)
                return;
              X(ct);
            }
            return k[st];
          },
          /**
           * @ngdoc method
           * @name $cacheFactory.Cache#remove
           * @kind function
           *
           * @description
           * Removes an entry from the {@link $cacheFactory.Cache Cache} object.
           *
           * @param {string} key the key of the entry to be removed
           */
          remove: function(st) {
            if (S < Number.MAX_VALUE) {
              var ct = $[st];
              if (!ct)
                return;
              ct === E && (E = ct.p), ct === Y && (Y = ct.n), z(ct.n, ct.p), delete $[st];
            }
            st in k && (delete k[st], w--);
          },
          /**
           * @ngdoc method
           * @name $cacheFactory.Cache#removeAll
           * @kind function
           *
           * @description
           * Clears the cache object of any entries.
           */
          removeAll: function() {
            k = Ee(), w = 0, $ = Ee(), E = Y = null;
          },
          /**
           * @ngdoc method
           * @name $cacheFactory.Cache#destroy
           * @kind function
           *
           * @description
           * Destroys the {@link $cacheFactory.Cache Cache} object entirely,
           * removing it from the {@link $cacheFactory $cacheFactory} set.
           */
          destroy: function() {
            k = null, D = null, $ = null, delete u[y];
          },
          /**
           * @ngdoc method
           * @name $cacheFactory.Cache#info
           * @kind function
           *
           * @description
           * Retrieve information regarding a particular {@link $cacheFactory.Cache Cache}.
           *
           * @returns {object} an object with the following properties:
           *   <ul>
           *     <li>**id**: the id of the cache instance</li>
           *     <li>**size**: the number of entries kept in the cache instance</li>
           *     <li>**...**: any additional properties from the options object when creating the
           *       cache.</li>
           *   </ul>
           */
          info: function() {
            return et({}, D, { size: w });
          }
        };
        function X(st) {
          st !== E && (Y ? Y === st && (Y = st.n) : Y = st, z(st.n, st.p), z(st, E), E = st, E.n = null);
        }
        function z(st, ct) {
          st !== ct && (st && (st.p = ct), ct && (ct.n = st));
        }
      }
      return m.info = function() {
        var y = {};
        return N(u, function(f, w) {
          y[w] = f.info();
        }), y;
      }, m.get = function(y) {
        return u[y];
      }, m;
    };
  }
  function FY() {
    this.$get = ["$cacheFactory", function(u) {
      return u("templates");
    }];
  }
  var pn = n("$compile");
  function zY() {
  }
  var Mf = new zY();
  qk.$inject = ["$provide", "$$sanitizeUriProvider"];
  function qk(u, m) {
    var y = {}, f = "Directive", w = /^\s*directive:\s*([\w-]+)\s+(.*)$/, D = /(([\w-]+)(?::([^;]+))?;?)/, k = Lt("ngSrc,ngSrcset,src,srcset"), S = /^(?:(\^\^?)?(\?)?(\^\^?)?)?/, $ = /^(on[a-z]+|formaction)$/, E = Ee();
    function Y(mt, ft, Z) {
      var q = /^([@&]|[=<](\*?))(\??)\s*([\w$]*)$/, ut = Ee();
      return N(mt, function(pt, xt) {
        if (pt = pt.trim(), pt in E) {
          ut[xt] = E[pt];
          return;
        }
        var Mt = pt.match(q);
        if (!Mt)
          throw pn(
            "iscp",
            "Invalid {3} for directive '{0}'. Definition: {... {1}: '{2}' ...}",
            ft,
            xt,
            pt,
            Z ? "controller bindings definition" : "isolate scope definition"
          );
        ut[xt] = {
          mode: Mt[1][0],
          collection: Mt[2] === "*",
          optional: Mt[3] === "?",
          attrName: Mt[4] || xt
        }, Mt[4] && (E[pt] = ut[xt]);
      }), ut;
    }
    function X(mt, ft) {
      var Z = {
        isolateScope: null,
        bindToController: null
      };
      if (lt(mt.scope) && (mt.bindToController === !0 ? (Z.bindToController = Y(
        mt.scope,
        ft,
        !0
      ), Z.isolateScope = {}) : Z.isolateScope = Y(
        mt.scope,
        ft,
        !1
      )), lt(mt.bindToController) && (Z.bindToController = Y(mt.bindToController, ft, !0)), Z.bindToController && !mt.controller)
        throw pn(
          "noctrl",
          "Cannot bind to controller without directive '{0}'s controller.",
          ft
        );
      return Z;
    }
    function z(mt) {
      var ft = mt.charAt(0);
      if (!ft || ft !== o(ft))
        throw pn("baddir", "Directive/Component name '{0}' is invalid. The first character must be a lowercase letter", mt);
      if (mt !== mt.trim())
        throw pn(
          "baddir",
          "Directive/Component name '{0}' is invalid. The name should not contain leading or trailing whitespaces",
          mt
        );
    }
    function st(mt) {
      var ft = mt.require || mt.controller && mt.name;
      return !Yt(ft) && lt(ft) && N(ft, function(Z, q) {
        var ut = Z.match(S), pt = Z.substring(ut[0].length);
        pt || (ft[q] = ut[0] + q);
      }), ft;
    }
    function ct(mt, ft) {
      if (mt && !(nt(mt) && /[EACM]/.test(mt)))
        throw pn(
          "badrestrict",
          "Restrict property '{0}' of directive '{1}' is invalid",
          mt,
          ft
        );
      return mt || "EA";
    }
    this.directive = function mt(ft, Z) {
      return ke(ft, "name"), Pe(ft, "directive"), nt(ft) ? (z(ft), ke(Z, "directiveFactory"), y.hasOwnProperty(ft) || (y[ft] = [], u.factory(ft + f, [
        "$injector",
        "$exceptionHandler",
        function(q, ut) {
          var pt = [];
          return N(y[ft], function(xt, Mt) {
            try {
              var kt = q.invoke(xt);
              _(kt) ? kt = { compile: St(kt) } : !kt.compile && kt.link && (kt.compile = St(kt.link)), kt.priority = kt.priority || 0, kt.index = Mt, kt.name = kt.name || ft, kt.require = st(kt), kt.restrict = ct(kt.restrict, ft), kt.$$moduleName = xt.$$moduleName, pt.push(kt);
            } catch (Gt) {
              ut(Gt);
            }
          }), pt;
        }
      ])), y[ft].push(Z)) : N(ft, F(mt)), this;
    }, this.component = function mt(ft, Z) {
      if (!nt(ft))
        return N(ft, F(Ie(this, mt))), this;
      var q = Z.controller || function() {
      };
      function ut(pt) {
        function xt(Gt) {
          return _(Gt) || Yt(Gt) ? (
            /** @this */
            function(Vt, ee) {
              return pt.invoke(Gt, this, { $element: Vt, $attrs: ee });
            }
          ) : Gt;
        }
        var Mt = !Z.template && !Z.templateUrl ? "" : Z.template, kt = {
          controller: q,
          controllerAs: WY(Z.controller) || Z.controllerAs || "$ctrl",
          template: xt(Mt),
          templateUrl: xt(Z.templateUrl),
          transclude: Z.transclude,
          scope: {},
          bindToController: Z.bindings || {},
          restrict: "E",
          require: Z.require
        };
        return N(Z, function(Gt, Vt) {
          Vt.charAt(0) === "$" && (kt[Vt] = Gt);
        }), kt;
      }
      return N(Z, function(pt, xt) {
        xt.charAt(0) === "$" && (ut[xt] = pt, _(q) && (q[xt] = pt));
      }), ut.$inject = ["$injector"], this.directive(ft, ut);
    }, this.aHrefSanitizationTrustedUrlList = function(mt) {
      return tt(mt) ? (m.aHrefSanitizationTrustedUrlList(mt), this) : m.aHrefSanitizationTrustedUrlList();
    }, Object.defineProperty(this, "aHrefSanitizationWhitelist", {
      get: function() {
        return this.aHrefSanitizationTrustedUrlList;
      },
      set: function(mt) {
        this.aHrefSanitizationTrustedUrlList = mt;
      }
    }), this.imgSrcSanitizationTrustedUrlList = function(mt) {
      return tt(mt) ? (m.imgSrcSanitizationTrustedUrlList(mt), this) : m.imgSrcSanitizationTrustedUrlList();
    }, Object.defineProperty(this, "imgSrcSanitizationWhitelist", {
      get: function() {
        return this.imgSrcSanitizationTrustedUrlList;
      },
      set: function(mt) {
        this.imgSrcSanitizationTrustedUrlList = mt;
      }
    });
    var It = !0;
    this.debugInfoEnabled = function(mt) {
      return tt(mt) ? (It = mt, this) : It;
    };
    var Ut = !1;
    this.strictComponentBindingsEnabled = function(mt) {
      return tt(mt) ? (Ut = mt, this) : Ut;
    };
    var Et = 10;
    this.onChangesTtl = function(mt) {
      return arguments.length ? (Et = mt, this) : Et;
    };
    var Dt = !0;
    this.commentDirectivesEnabled = function(mt) {
      return arguments.length ? (Dt = mt, this) : Dt;
    };
    var Tt = !0;
    this.cssClassDirectivesEnabled = function(mt) {
      return arguments.length ? (Tt = mt, this) : Tt;
    };
    var Ot = Ee();
    this.addPropertySecurityContext = function(mt, ft, Z) {
      var q = mt.toLowerCase() + "|" + ft.toLowerCase();
      if (q in Ot && Ot[q] !== Z)
        throw pn("ctxoverride", "Property context '{0}.{1}' already set to '{2}', cannot override to '{3}'.", mt, ft, Ot[q], Z);
      return Ot[q] = Z, this;
    }, function() {
      function ft(Z, q) {
        N(q, function(ut) {
          Ot[ut.toLowerCase()] = Z;
        });
      }
      ft(hn.HTML, [
        "iframe|srcdoc",
        "*|innerHTML",
        "*|outerHTML"
      ]), ft(hn.CSS, ["*|style"]), ft(hn.URL, [
        "area|href",
        "area|ping",
        "a|href",
        "a|ping",
        "blockquote|cite",
        "body|background",
        "del|cite",
        "input|src",
        "ins|cite",
        "q|cite"
      ]), ft(hn.MEDIA_URL, [
        "audio|src",
        "img|src",
        "img|srcset",
        "source|src",
        "source|srcset",
        "track|src",
        "video|src",
        "video|poster"
      ]), ft(hn.RESOURCE_URL, [
        "*|formAction",
        "applet|code",
        "applet|codebase",
        "base|href",
        "embed|src",
        "frame|src",
        "form|action",
        "head|profile",
        "html|manifest",
        "iframe|src",
        "link|href",
        "media|src",
        "object|codebase",
        "object|data",
        "script|src"
      ]);
    }(), this.$get = [
      "$injector",
      "$interpolate",
      "$exceptionHandler",
      "$templateRequest",
      "$parse",
      "$controller",
      "$rootScope",
      "$sce",
      "$animate",
      function(mt, ft, Z, q, ut, pt, xt, Mt, kt) {
        var Gt = /^\w/, Vt = s.document.createElement("div"), ee = Dt, Bt = Tt, re = Et, Le;
        function $e() {
          try {
            if (!--re)
              throw Le = void 0, pn("infchng", `{0} $onChanges() iterations reached. Aborting!
`, Et);
            xt.$apply(function() {
              for (var gt = 0, bt = Le.length; gt < bt; ++gt)
                try {
                  Le[gt]();
                } catch (Nt) {
                  Z(Nt);
                }
              Le = void 0;
            });
          } finally {
            re++;
          }
        }
        function Xe(gt, bt) {
          if (!gt)
            return gt;
          if (!nt(gt))
            throw pn("srcset", 'Can\'t pass trusted values to `{0}`: "{1}"', bt, gt.toString());
          for (var Nt = "", Xt = oe(gt), Kt = /(\s+\d+x\s*,|\s+\d+w\s*,|\s+,|,\s+)/, Qt = /\s/.test(Xt) ? Kt : /(,)/, he = Xt.split(Qt), Oe = Math.floor(he.length / 2), fe = 0; fe < Oe; fe++) {
            var ve = fe * 2;
            Nt += Mt.getTrustedMediaUrl(oe(he[ve])), Nt += " " + oe(he[ve + 1]);
          }
          var xe = oe(he[fe * 2]).split(/\s/);
          return Nt += Mt.getTrustedMediaUrl(oe(xe[0])), xe.length === 2 && (Nt += " " + oe(xe[1])), Nt;
        }
        function ta(gt, bt) {
          if (bt) {
            var Nt = Object.keys(bt), Xt, Kt, Qt;
            for (Xt = 0, Kt = Nt.length; Xt < Kt; Xt++)
              Qt = Nt[Xt], this[Qt] = bt[Qt];
          } else
            this.$attr = {};
          this.$$element = gt;
        }
        ta.prototype = {
          /**
           * @ngdoc method
           * @name $compile.directive.Attributes#$normalize
           * @kind function
           *
           * @description
           * Converts an attribute name (e.g. dash/colon/underscore-delimited string, optionally prefixed with `x-` or
           * `data-`) to its normalized, camelCase form.
           *
           * Also there is special case for Moz prefix starting with upper case letter.
           *
           * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
           *
           * @param {string} name Name to normalize
           */
          $normalize: di,
          /**
           * @ngdoc method
           * @name $compile.directive.Attributes#$addClass
           * @kind function
           *
           * @description
           * Adds the CSS class value specified by the classVal parameter to the element. If animations
           * are enabled then an animation will be triggered for the class addition.
           *
           * @param {string} classVal The className value that will be added to the element
           */
          $addClass: function(gt) {
            gt && gt.length > 0 && kt.addClass(this.$$element, gt);
          },
          /**
           * @ngdoc method
           * @name $compile.directive.Attributes#$removeClass
           * @kind function
           *
           * @description
           * Removes the CSS class value specified by the classVal parameter from the element. If
           * animations are enabled then an animation will be triggered for the class removal.
           *
           * @param {string} classVal The className value that will be removed from the element
           */
          $removeClass: function(gt) {
            gt && gt.length > 0 && kt.removeClass(this.$$element, gt);
          },
          /**
           * @ngdoc method
           * @name $compile.directive.Attributes#$updateClass
           * @kind function
           *
           * @description
           * Adds and removes the appropriate CSS class values to the element based on the difference
           * between the new and old CSS class values (specified as newClasses and oldClasses).
           *
           * @param {string} newClasses The current CSS className value
           * @param {string} oldClasses The former CSS className value
           */
          $updateClass: function(gt, bt) {
            var Nt = Jk(gt, bt);
            Nt && Nt.length && kt.addClass(this.$$element, Nt);
            var Xt = Jk(bt, gt);
            Xt && Xt.length && kt.removeClass(this.$$element, Xt);
          },
          /**
           * Set a normalized attribute on the element in a way such that all directives
           * can share the attribute. This function properly handles boolean attributes.
           * @param {string} key Normalized key. (ie ngAttribute)
           * @param {string|boolean} value The value to set. If `null` attribute will be deleted.
           * @param {boolean=} writeAttr If false, does not write the value to DOM element attribute.
           *     Defaults to true.
           * @param {string=} attrName Optional none normalized name. Defaults to key.
           */
          $set: function(gt, bt, Nt, Xt) {
            var Kt = this.$$element[0], Qt = Fk(Kt, gt), he = mY(gt), Oe = gt, fe;
            Qt ? (this.$$element.prop(gt, bt), Xt = Qt) : he && (this[he] = bt, Oe = he), this[gt] = bt, Xt ? this.$attr[gt] = Xt : (Xt = this.$attr[gt], Xt || (this.$attr[gt] = Xt = gp(gt, "-"))), fe = ye(this.$$element), fe === "img" && gt === "srcset" && (this[gt] = bt = Xe(bt, "$set('srcset', value)")), Nt !== !1 && (bt === null || j(bt) ? this.$$element.removeAttr(Xt) : Gt.test(Xt) ? Qt && bt === !1 ? this.$$element.removeAttr(Xt) : this.$$element.attr(Xt, bt) : sa(this.$$element[0], Xt, bt));
            var ve = this.$$observers;
            ve && N(ve[Oe], function(xe) {
              try {
                xe(bt);
              } catch (Ae) {
                Z(Ae);
              }
            });
          },
          /**
           * @ngdoc method
           * @name $compile.directive.Attributes#$observe
           * @kind function
           *
           * @description
           * Observes an interpolated attribute.
           *
           * The observer function will be invoked once during the next `$digest` following
           * compilation. The observer is then invoked whenever the interpolated value
           * changes.
           *
           * @param {string} key Normalized key. (ie ngAttribute) .
           * @param {function(interpolatedValue)} fn Function that will be called whenever
                    the interpolated value of the attribute changes.
           *        See the {@link guide/interpolation#how-text-and-attribute-bindings-work Interpolation
           *        guide} for more info.
           * @returns {function()} Returns a deregistration function for this observer.
           */
          $observe: function(gt, bt) {
            var Nt = this, Xt = Nt.$$observers || (Nt.$$observers = Ee()), Kt = Xt[gt] || (Xt[gt] = []);
            return Kt.push(bt), xt.$evalAsync(function() {
              !Kt.$$inter && Nt.hasOwnProperty(gt) && !j(Nt[gt]) && bt(Nt[gt]);
            }), function() {
              _e(Kt, bt);
            };
          }
        };
        function sa(gt, bt, Nt) {
          Vt.innerHTML = "<span " + bt + ">";
          var Xt = Vt.firstChild.attributes, Kt = Xt[0];
          Xt.removeNamedItem(Kt.name), Kt.value = Nt, gt.attributes.setNamedItem(Kt);
        }
        function ba(gt, bt) {
          try {
            gt.addClass(bt);
          } catch {
          }
        }
        var Qa = ft.startSymbol(), Ya = ft.endSymbol(), Dn = Qa === "{{" && Ya === "}}" ? vt : function(bt) {
          return bt.replace(/\{\{/g, Qa).replace(/}}/g, Ya);
        }, mn = /^ng(Attr|Prop|On)([A-Z].*)$/, wn = /^(.+)Start$/;
        return Ba.$$addBindingInfo = It ? function(bt, Nt) {
          var Xt = bt.data("$binding") || [];
          Yt(Nt) ? Xt = Xt.concat(Nt) : Xt.push(Nt), bt.data("$binding", Xt);
        } : J, Ba.$$addBindingClass = It ? function(bt) {
          ba(bt, "ng-binding");
        } : J, Ba.$$addScopeInfo = It ? function(bt, Nt, Xt, Kt) {
          var Qt = Xt ? Kt ? "$isolateScopeNoTemplate" : "$isolateScope" : "$scope";
          bt.data(Qt, Nt);
        } : J, Ba.$$addScopeClass = It ? function(bt, Nt) {
          ba(bt, Nt ? "ng-isolate-scope" : "ng-scope");
        } : J, Ba.$$createComment = function(gt, bt) {
          var Nt = "";
          return It && (Nt = " " + (gt || "") + ": ", bt && (Nt += bt + " ")), s.document.createComment(Nt);
        }, Ba;
        function Ba(gt, bt, Nt, Xt, Kt) {
          gt instanceof p || (gt = p(gt));
          var Qt = wl(
            gt,
            bt,
            gt,
            Nt,
            Xt,
            Kt
          );
          Ba.$$addScopeClass(gt);
          var he = null;
          return function(fe, ve, xe) {
            if (!gt)
              throw pn("multilink", "This element has already been linked.");
            ke(fe, "scope"), Kt && Kt.needsNewScope && (fe = fe.$parent.$new()), xe = xe || {};
            var Ae = xe.parentBoundTranscludeFn, ae = xe.transcludeControllers, De = xe.futureParentElement;
            Ae && Ae.$$boundTransclude && (Ae = Ae.$$boundTransclude), he || (he = xl(De));
            var qe;
            if (he !== "html" ? qe = p(
              ub(he, p("<div></div>").append(gt).html())
            ) : ve ? qe = vo.clone.call(gt) : qe = gt, ae)
              for (var va in ae)
                qe.data("$" + va + "Controller", ae[va].instance);
            return Ba.$$addScopeInfo(qe, fe), ve && ve(qe, fe), Qt && Qt(fe, qe, qe, Ae), ve || (gt = Qt = null), qe;
          };
        }
        function xl(gt) {
          var bt = gt && gt[0];
          return bt && ye(bt) !== "foreignobject" && A.call(bt).match(/SVG/) ? "svg" : "html";
        }
        function wl(gt, bt, Nt, Xt, Kt, Qt) {
          for (var he = [], Oe = Yt(gt) || gt instanceof p, fe, ve, xe, Ae, ae, De, qe, va = 0; va < gt.length; va++)
            fe = new ta(), d === 11 && ob(gt, va, Oe), ve = Dr(
              gt[va],
              [],
              fe,
              va === 0 ? Xt : void 0,
              Kt
            ), xe = ve.length ? pL(
              ve,
              gt[va],
              fe,
              bt,
              Nt,
              null,
              [],
              [],
              Qt
            ) : null, xe && xe.scope && Ba.$$addScopeClass(fe.$$element), ae = xe && xe.terminal || !(Ae = gt[va].childNodes) || !Ae.length ? null : wl(
              Ae,
              xe ? (xe.transcludeOnThisElement || !xe.templateOnThisElement) && xe.transclude : bt
            ), (xe || ae) && (he.push(va, xe, ae), De = !0, qe = qe || xe), Qt = null;
          return De ? da : null;
          function da(Ke, Je, we, ca) {
            var ia, ln, on, Za, Ca, In, gn, zn, Si;
            if (qe) {
              var To = Je.length;
              for (Si = new Array(To), Ca = 0; Ca < he.length; Ca += 3)
                gn = he[Ca], Si[gn] = Je[gn];
            } else
              Si = Je;
            for (Ca = 0, In = he.length; Ca < In; )
              on = Si[he[Ca++]], ia = he[Ca++], ln = he[Ca++], ia ? (ia.scope ? (Za = Ke.$new(), Ba.$$addScopeInfo(p(on), Za)) : Za = Ke, ia.transcludeOnThisElement ? zn = ui(
                Ke,
                ia.transclude,
                ca
              ) : !ia.templateOnThisElement && ca ? zn = ca : !ca && bt ? zn = ui(Ke, bt) : zn = null, ia(ln, Za, on, we, zn)) : ln && ln(Ke, on.childNodes, void 0, ca);
          }
        }
        function ob(gt, bt, Nt) {
          var Xt = gt[bt], Kt = Xt.parentNode, Qt;
          if (Xt.nodeType === Ja)
            for (; Qt = Kt ? Xt.nextSibling : gt[bt + 1], !(!Qt || Qt.nodeType !== Ja); )
              Xt.nodeValue = Xt.nodeValue + Qt.nodeValue, Qt.parentNode && Qt.parentNode.removeChild(Qt), Nt && Qt === gt[bt + 1] && gt.splice(bt + 1, 1);
        }
        function ui(gt, bt, Nt) {
          function Xt(he, Oe, fe, ve, xe) {
            return he || (he = gt.$new(!1, xe), he.$$transcluded = !0), bt(he, Oe, {
              parentBoundTranscludeFn: Nt,
              transcludeControllers: fe,
              futureParentElement: ve
            });
          }
          var Kt = Xt.$$slots = Ee();
          for (var Qt in bt.$$slots)
            bt.$$slots[Qt] ? Kt[Qt] = ui(gt, bt.$$slots[Qt], Nt) : Kt[Qt] = null;
          return Xt;
        }
        function Dr(gt, bt, Nt, Xt, Kt) {
          var Qt = gt.nodeType, he = Nt.$attr, Oe, fe, ve;
          switch (Qt) {
            case na:
              fe = ye(gt), Fp(
                bt,
                di(fe),
                "E",
                Xt,
                Kt
              );
              for (var xe, Ae, ae, De, qe, va = gt.attributes, da = 0, Ke = va && va.length; da < Ke; da++) {
                var Je = !1, we = !1, ca = !1, ia = !1, ln = !1, on;
                xe = va[da], Ae = xe.name, De = xe.value, ae = di(Ae.toLowerCase()), (qe = ae.match(mn)) ? (ca = qe[1] === "Attr", ia = qe[1] === "Prop", ln = qe[1] === "On", Ae = Ae.replace(Kk, "").toLowerCase().substr(4 + qe[1].length).replace(/_(.)/g, function(Za, Ca) {
                  return Ca.toUpperCase();
                })) : (on = ae.match(wn)) && CM(on[1]) && (Je = Ae, we = Ae.substr(0, Ae.length - 5) + "end", Ae = Ae.substr(0, Ae.length - 6)), ia || ln ? (Nt[ae] = De, he[ae] = xe.name, ia ? IM(gt, bt, ae, Ae) : PM(bt, ae, Ae)) : (ae = di(Ae.toLowerCase()), he[ae] = Ae, (ca || !Nt.hasOwnProperty(ae)) && (Nt[ae] = De, Fk(gt, ae) && (Nt[ae] = !0)), EM(gt, bt, De, ae, ca), Fp(
                  bt,
                  ae,
                  "A",
                  Xt,
                  Kt,
                  Je,
                  we
                ));
              }
              if (fe === "input" && gt.getAttribute("type") === "hidden" && gt.setAttribute("autocomplete", "off"), !Bt)
                break;
              if (ve = gt.className, lt(ve) && (ve = ve.animVal), nt(ve) && ve !== "")
                for (; Oe = D.exec(ve); )
                  ae = di(Oe[2]), Fp(bt, ae, "C", Xt, Kt) && (Nt[ae] = oe(Oe[3])), ve = ve.substr(Oe.index + Oe[0].length);
              break;
            case Ja:
              kM(bt, gt.nodeValue);
              break;
            case _n:
              if (!ee)
                break;
              cb(gt, bt, Nt, Xt, Kt);
              break;
          }
          return bt.sort(SM), bt;
        }
        function cb(gt, bt, Nt, Xt, Kt) {
          try {
            var Qt = w.exec(gt.nodeValue);
            if (Qt) {
              var he = di(Qt[1]);
              Fp(bt, he, "M", Xt, Kt) && (Nt[he] = oe(Qt[2]));
            }
          } catch {
          }
        }
        function ud(gt, bt, Nt) {
          var Xt = [], Kt = 0;
          if (bt && gt.hasAttribute && gt.hasAttribute(bt))
            do {
              if (!gt)
                throw pn(
                  "uterdir",
                  "Unterminated attribute, found '{0}' but no matching '{1}' found.",
                  bt,
                  Nt
                );
              gt.nodeType === na && (gt.hasAttribute(bt) && Kt++, gt.hasAttribute(Nt) && Kt--), Xt.push(gt), gt = gt.nextSibling;
            } while (Kt > 0);
          else
            Xt.push(gt);
          return p(Xt);
        }
        function uL(gt, bt, Nt) {
          return function(Kt, Qt, he, Oe, fe) {
            return Qt = ud(Qt[0], bt, Nt), gt(Kt, Qt, he, Oe, fe);
          };
        }
        function db(gt, bt, Nt, Xt, Kt, Qt) {
          var he;
          return gt ? Ba(bt, Nt, Xt, Kt, Qt) : (
            /** @this */
            function() {
              return he || (he = Ba(bt, Nt, Xt, Kt, Qt), bt = Nt = Qt = null), he.apply(this, arguments);
            }
          );
        }
        function pL(gt, bt, Nt, Xt, Kt, Qt, he, Oe, fe) {
          fe = fe || {};
          for (var ve = -Number.MAX_VALUE, xe = fe.newScopeDirective, Ae = fe.controllerDirectives, ae = fe.newIsolateScopeDirective, De = fe.templateDirective, qe = fe.nonTlbTranscludeDirective, va = !1, da = !1, Ke = fe.hasElementTranscludeDirective, Je = Nt.$$element = p(bt), we, ca, ia, ln = Qt, on = Xt, Za, Ca = !1, In = !1, gn, zn = 0, Si = gt.length; zn < Si; zn++) {
            we = gt[zn];
            var To = we.$$start, pb = we.$$end;
            if (To && (Je = ud(bt, To, pb)), ia = void 0, ve > we.priority)
              break;
            if (gn = we.scope, gn && (we.templateUrl || (lt(gn) ? (ko(
              "new/isolated scope",
              ae || xe,
              we,
              Je
            ), ae = we) : ko(
              "new/isolated scope",
              ae,
              we,
              Je
            )), xe = xe || we), ca = we.name, !Ca && (we.replace && (we.templateUrl || we.template) || we.transclude && !we.$$tlb)) {
              for (var Lo, NM = zn + 1; Lo = gt[NM++]; )
                if (Lo.transclude && !Lo.$$tlb || Lo.replace && (Lo.templateUrl || Lo.template)) {
                  In = !0;
                  break;
                }
              Ca = !0;
            }
            if (!we.templateUrl && we.controller && (Ae = Ae || Ee(), ko(
              "'" + ca + "' controller",
              Ae[ca],
              we,
              Je
            ), Ae[ca] = we), gn = we.transclude, gn)
              if (va = !0, we.$$tlb || (ko("transclusion", qe, we, Je), qe = we), gn === "element")
                Ke = !0, ve = we.priority, ia = Je, Je = Nt.$$element = p(Ba.$$createComment(ca, Nt[ca])), bt = Je[0], zp(Kt, sn(ia), bt), on = db(
                  In,
                  ia,
                  Xt,
                  ve,
                  ln && ln.name,
                  {
                    // Don't pass in:
                    // - controllerDirectives - otherwise we'll create duplicates controllers
                    // - newIsolateScopeDirective or templateDirective - combining templates with
                    //   element transclusion doesn't make sense.
                    //
                    // We need only nonTlbTranscludeDirective so that we prevent putting transclusion
                    // on the same element more than once.
                    nonTlbTranscludeDirective: qe
                  }
                );
              else {
                var er = Ee();
                if (!lt(gn))
                  ia = p(Rf(bt)).contents();
                else {
                  ia = s.document.createDocumentFragment();
                  var bL = Ee(), hb = Ee();
                  N(gn, function(Ha, $a) {
                    var pi = Ha.charAt(0) === "?";
                    Ha = pi ? Ha.substring(1) : Ha, bL[Ha] = $a, er[$a] = null, hb[$a] = pi;
                  }), N(Je.contents(), function(Ha) {
                    var $a = bL[di(ye(Ha))];
                    $a ? (hb[$a] = !0, er[$a] = er[$a] || s.document.createDocumentFragment(), er[$a].appendChild(Ha)) : ia.appendChild(Ha);
                  }), N(hb, function(Ha, $a) {
                    if (!Ha)
                      throw pn("reqslot", "Required transclusion slot `{0}` was not filled.", $a);
                  });
                  for (var mb in er)
                    if (er[mb]) {
                      var RM = p(er[mb].childNodes);
                      er[mb] = db(In, RM, Xt);
                    }
                  ia = p(ia.childNodes);
                }
                Je.empty(), on = db(
                  In,
                  ia,
                  Xt,
                  void 0,
                  void 0,
                  { needsNewScope: we.$$isolateScope || we.$$newScope }
                ), on.$$slots = er;
              }
            if (we.template)
              if (da = !0, ko("template", De, we, Je), De = we, gn = _(we.template) ? we.template(Je, Nt) : we.template, gn = Dn(gn), we.replace) {
                if (ln = we, Ef(gn) ? ia = [] : ia = Qk(ub(we.templateNamespace, oe(gn))), bt = ia[0], ia.length !== 1 || bt.nodeType !== na)
                  throw pn(
                    "tplrt",
                    "Template for directive '{0}' must have exactly one root element. {1}",
                    ca,
                    ""
                  );
                zp(Kt, Je, bt);
                var vL = { $attr: {} }, xL = Dr(bt, [], vL), YM = gt.splice(zn + 1, gt.length - (zn + 1));
                (ae || xe) && hL(xL, ae, xe), gt = gt.concat(xL).concat(YM), mL(Nt, vL), Si = gt.length;
              } else
                Je.html(gn);
            if (we.templateUrl)
              da = !0, ko("template", De, we, Je), De = we, we.replace && (ln = we), Al = $M(
                gt.splice(zn, gt.length - zn),
                Je,
                Nt,
                Kt,
                va && on,
                he,
                Oe,
                {
                  controllerDirectives: Ae,
                  newScopeDirective: xe !== we && xe,
                  newIsolateScopeDirective: ae,
                  templateDirective: De,
                  nonTlbTranscludeDirective: qe
                }
              ), Si = gt.length;
            else if (we.compile)
              try {
                Za = we.compile(Je, Nt, on);
                var gb = we.$$originalDirective || we;
                _(Za) ? wL(null, Ie(gb, Za), To, pb) : Za && wL(Ie(gb, Za.pre), Ie(gb, Za.post), To, pb);
              } catch (Ha) {
                Z(Ha, Kn(Je));
              }
            we.terminal && (Al.terminal = !0, ve = Math.max(ve, we.priority));
          }
          return Al.scope = xe && xe.scope === !0, Al.transcludeOnThisElement = va, Al.templateOnThisElement = da, Al.transclude = on, fe.hasElementTranscludeDirective = Ke, Al;
          function wL(Ha, $a, pi, yb) {
            Ha && (pi && (Ha = uL(Ha, pi, yb)), Ha.require = we.require, Ha.directiveName = ca, (ae === we || we.$$isolateScope) && (Ha = gL(Ha, { isolateScope: !0 })), he.push(Ha)), $a && (pi && ($a = uL($a, pi, yb)), $a.require = we.require, $a.directiveName = ca, (ae === we || we.$$isolateScope) && ($a = gL($a, { isolateScope: !0 })), Oe.push($a));
          }
          function Al(Ha, $a, pi, yb, Do) {
            var Ir, AL, zs, ki, hd, Ti, Io, Zn, Cl, fb;
            bt === pi ? (Cl = Nt, Zn = Nt.$$element) : (Zn = p(pi), Cl = new ta(Zn, Nt)), hd = $a, ae ? ki = $a.$new(!0) : xe && (hd = $a.$parent), Do && (Io = OM, Io.$$boundTransclude = Do, Io.isSlotFilled = function(ts) {
              return !!Do.$$slots[ts];
            }), Ae && (Ti = AM(Zn, Cl, Io, Ae, ki, $a, ae)), ae && (Ba.$$addScopeInfo(Zn, ki, !0, !(De && (De === ae || De === ae.$$originalDirective))), Ba.$$addScopeClass(Zn, !0), ki.$$isolateBindings = ae.$$isolateBindings, fb = fL(
              $a,
              Cl,
              ki,
              ki.$$isolateBindings,
              ae
            ), fb.removeWatches && ki.$on("$destroy", fb.removeWatches));
            for (var CL in Ti) {
              var bb = Ae[CL], md = Ti[CL], _M = bb.$$bindings.bindToController;
              md.instance = md(), Zn.data("$" + bb.name + "Controller", md.instance), md.bindingInfo = fL(hd, Cl, md.instance, _M, bb);
            }
            for (N(Ae, function(ts, yn) {
              var es = ts.require;
              ts.bindToController && !Yt(es) && lt(es) && et(Ti[yn].instance, pd(yn, es, Zn, Ti));
            }), N(Ti, function(ts) {
              var yn = ts.instance;
              if (_(yn.$onChanges))
                try {
                  yn.$onChanges(ts.bindingInfo.initialChanges);
                } catch (es) {
                  Z(es);
                }
              if (_(yn.$onInit))
                try {
                  yn.$onInit();
                } catch (es) {
                  Z(es);
                }
              _(yn.$doCheck) && (hd.$watch(function() {
                yn.$doCheck();
              }), yn.$doCheck()), _(yn.$onDestroy) && hd.$on("$destroy", function() {
                yn.$onDestroy();
              });
            }), Ir = 0, AL = he.length; Ir < AL; Ir++)
              zs = he[Ir], yL(
                zs,
                zs.isolateScope ? ki : $a,
                Zn,
                Cl,
                zs.require && pd(zs.directiveName, zs.require, Zn, Ti),
                Io
              );
            var Wp = $a;
            for (ae && (ae.template || ae.templateUrl === null) && (Wp = ki), Ha && Ha(Wp, pi.childNodes, void 0, Do), Ir = Oe.length - 1; Ir >= 0; Ir--)
              zs = Oe[Ir], yL(
                zs,
                zs.isolateScope ? ki : $a,
                Zn,
                Cl,
                zs.require && pd(zs.directiveName, zs.require, Zn, Ti),
                Io
              );
            N(Ti, function(ts) {
              var yn = ts.instance;
              _(yn.$postLink) && yn.$postLink();
            });
            function OM(ts, yn, es, jp) {
              var vb;
              if (dt(ts) || (jp = es, es = yn, yn = ts, ts = void 0), Ke && (vb = Ti), es || (es = Ke ? Zn.parent() : Zn), jp) {
                var xb = Do.$$slots[jp];
                if (xb)
                  return xb(ts, yn, vb, es, Wp);
                if (j(xb))
                  throw pn(
                    "noslot",
                    'No parent directive that requires a transclusion with slot name "{0}". Element: {1}',
                    jp,
                    Kn(Zn)
                  );
              } else
                return Do(ts, yn, vb, es, Wp);
            }
          }
        }
        function pd(gt, bt, Nt, Xt) {
          var Kt;
          if (nt(bt)) {
            var Qt = bt.match(S), he = bt.substring(Qt[0].length), Oe = Qt[1] || Qt[3], fe = Qt[2] === "?";
            if (Oe === "^^" ? Nt = Nt.parent() : (Kt = Xt && Xt[he], Kt = Kt && Kt.instance), !Kt) {
              var ve = "$" + he + "Controller";
              Oe === "^^" && Nt[0] && Nt[0].nodeType === ci ? Kt = null : Kt = Oe ? Nt.inheritedData(ve) : Nt.data(ve);
            }
            if (!Kt && !fe)
              throw pn(
                "ctreq",
                "Controller '{0}', required by directive '{1}', can't be found!",
                he,
                gt
              );
          } else if (Yt(bt)) {
            Kt = [];
            for (var xe = 0, Ae = bt.length; xe < Ae; xe++)
              Kt[xe] = pd(gt, bt[xe], Nt, Xt);
          } else
            lt(bt) && (Kt = {}, N(bt, function(ae, De) {
              Kt[De] = pd(gt, ae, Nt, Xt);
            }));
          return Kt || null;
        }
        function AM(gt, bt, Nt, Xt, Kt, Qt, he) {
          var Oe = Ee();
          for (var fe in Xt) {
            var ve = Xt[fe], xe = {
              $scope: ve === he || ve.$$isolateScope ? Kt : Qt,
              $element: gt,
              $attrs: bt,
              $transclude: Nt
            }, Ae = ve.controller;
            Ae === "@" && (Ae = bt[ve.name]);
            var ae = pt(Ae, xe, !0, ve.controllerAs);
            Oe[ve.name] = ae, gt.data("$" + ve.name + "Controller", ae.instance);
          }
          return Oe;
        }
        function hL(gt, bt, Nt) {
          for (var Xt = 0, Kt = gt.length; Xt < Kt; Xt++)
            gt[Xt] = W(gt[Xt], { $$isolateScope: bt, $$newScope: Nt });
        }
        function Fp(gt, bt, Nt, Xt, Kt, Qt, he) {
          if (bt === Kt)
            return null;
          var Oe = null;
          if (y.hasOwnProperty(bt)) {
            for (var fe, ve = mt.get(bt + f), xe = 0, Ae = ve.length; xe < Ae; xe++)
              if (fe = ve[xe], (j(Xt) || Xt > fe.priority) && fe.restrict.indexOf(Nt) !== -1) {
                if (Qt && (fe = W(fe, { $$start: Qt, $$end: he })), !fe.$$bindings) {
                  var ae = fe.$$bindings = X(fe, fe.name);
                  lt(ae.isolateScope) && (fe.$$isolateBindings = ae.isolateScope);
                }
                gt.push(fe), Oe = fe;
              }
          }
          return Oe;
        }
        function CM(gt) {
          if (y.hasOwnProperty(gt)) {
            for (var bt, Nt = mt.get(gt + f), Xt = 0, Kt = Nt.length; Xt < Kt; Xt++)
              if (bt = Nt[Xt], bt.multiElement)
                return !0;
          }
          return !1;
        }
        function mL(gt, bt) {
          var Nt = bt.$attr, Xt = gt.$attr;
          N(gt, function(Kt, Qt) {
            Qt.charAt(0) !== "$" && (bt[Qt] && bt[Qt] !== Kt && (Kt.length ? Kt += (Qt === "style" ? ";" : " ") + bt[Qt] : Kt = bt[Qt]), gt.$set(Qt, Kt, !0, Nt[Qt]));
          }), N(bt, function(Kt, Qt) {
            !gt.hasOwnProperty(Qt) && Qt.charAt(0) !== "$" && (gt[Qt] = Kt, Qt !== "class" && Qt !== "style" && (Xt[Qt] = Nt[Qt]));
          });
        }
        function $M(gt, bt, Nt, Xt, Kt, Qt, he, Oe) {
          var fe = [], ve, xe, Ae = bt[0], ae = gt.shift(), De = W(ae, {
            templateUrl: null,
            transclude: null,
            replace: null,
            $$originalDirective: ae
          }), qe = _(ae.templateUrl) ? ae.templateUrl(bt, Nt) : ae.templateUrl, va = ae.templateNamespace;
          return bt.empty(), q(qe).then(function(da) {
            var Ke, Je, we, ca;
            if (da = Dn(da), ae.replace) {
              if (Ef(da) ? we = [] : we = Qk(ub(va, oe(da))), Ke = we[0], we.length !== 1 || Ke.nodeType !== na)
                throw pn(
                  "tplrt",
                  "Template for directive '{0}' must have exactly one root element. {1}",
                  ae.name,
                  qe
                );
              Je = { $attr: {} }, zp(Xt, bt, Ke);
              var ia = Dr(Ke, [], Je);
              lt(ae.scope) && hL(ia, !0), gt = ia.concat(gt), mL(Nt, Je);
            } else
              Ke = Ae, bt.html(da);
            for (gt.unshift(De), ve = pL(
              gt,
              Ke,
              Nt,
              Kt,
              bt,
              ae,
              Qt,
              he,
              Oe
            ), N(Xt, function(zn, Si) {
              zn === Ke && (Xt[Si] = bt[0]);
            }), xe = wl(bt[0].childNodes, Kt); fe.length; ) {
              var ln = fe.shift(), on = fe.shift(), Za = fe.shift(), Ca = fe.shift(), In = bt[0];
              if (!ln.$$destroyed) {
                if (on !== Ae) {
                  var gn = on.className;
                  Oe.hasElementTranscludeDirective && ae.replace || (In = Rf(Ke)), zp(Za, p(on), In), ba(p(In), gn);
                }
                ve.transcludeOnThisElement ? ca = ui(ln, ve.transclude, Ca) : ca = Ca, ve(
                  xe,
                  ln,
                  In,
                  Xt,
                  ca
                );
              }
            }
            fe = null;
          }).catch(function(da) {
            K(da) && Z(da);
          }), function(Ke, Je, we, ca, ia) {
            var ln = ia;
            Je.$$destroyed || (fe ? fe.push(
              Je,
              we,
              ca,
              ln
            ) : (ve.transcludeOnThisElement && (ln = ui(Je, ve.transclude, ia)), ve(xe, Je, we, ca, ln)));
          };
        }
        function SM(gt, bt) {
          var Nt = bt.priority - gt.priority;
          return Nt !== 0 ? Nt : gt.name !== bt.name ? gt.name < bt.name ? -1 : 1 : gt.index - bt.index;
        }
        function ko(gt, bt, Nt, Xt) {
          function Kt(Qt) {
            return Qt ? " (module: " + Qt + ")" : "";
          }
          if (bt)
            throw pn(
              "multidir",
              "Multiple directives [{0}{1}, {2}{3}] asking for {4} on: {5}",
              bt.name,
              Kt(bt.$$moduleName),
              Nt.name,
              Kt(Nt.$$moduleName),
              gt,
              Kn(Xt)
            );
        }
        function kM(gt, bt) {
          var Nt = ft(bt, !0);
          Nt && gt.push({
            priority: 0,
            compile: function(Kt) {
              var Qt = Kt.parent(), he = !!Qt.length;
              return he && Ba.$$addBindingClass(Qt), function(fe, ve) {
                var xe = ve.parent();
                he || Ba.$$addBindingClass(xe), Ba.$$addBindingInfo(xe, Nt.expressions), fe.$watch(Nt, function(ae) {
                  ve[0].nodeValue = ae;
                });
              };
            }
          });
        }
        function ub(gt, bt) {
          switch (gt = o(gt || "html"), gt) {
            case "svg":
            case "math":
              var Nt = s.document.createElement("div");
              return Nt.innerHTML = "<" + gt + ">" + bt + "</" + gt + ">", Nt.childNodes[0].childNodes;
            default:
              return bt;
          }
        }
        function TM(gt, bt) {
          if (bt === "srcdoc")
            return Mt.HTML;
          if (bt === "src" || bt === "ngSrc")
            return ["img", "video", "audio", "source", "track"].indexOf(gt) === -1 ? Mt.RESOURCE_URL : Mt.MEDIA_URL;
          if (bt === "xlinkHref")
            return gt === "image" ? Mt.MEDIA_URL : gt === "a" ? Mt.URL : Mt.RESOURCE_URL;
          if (
            // Formaction
            gt === "form" && bt === "action" || // If relative URLs can go where they are not expected to, then
            // all sorts of trust issues can arise.
            gt === "base" && bt === "href" || // links can be stylesheets or imports, which can run script in the current origin
            gt === "link" && bt === "href"
          )
            return Mt.RESOURCE_URL;
          if (gt === "a" && (bt === "href" || bt === "ngHref"))
            return Mt.URL;
        }
        function LM(gt, bt) {
          var Nt = bt.toLowerCase();
          return Ot[gt + "|" + Nt] || Ot["*|" + Nt];
        }
        function DM(gt) {
          return Xe(Mt.valueOf(gt), "ng-prop-srcset");
        }
        function IM(gt, bt, Nt, Xt) {
          if ($.test(Xt))
            throw pn("nodomevents", "Property bindings for HTML DOM event properties are disallowed");
          var Kt = ye(gt), Qt = LM(Kt, Xt), he = vt;
          Xt === "srcset" && (Kt === "img" || Kt === "source") ? he = DM : Qt && (he = Mt.getTrusted.bind(Mt, Qt)), bt.push({
            priority: 100,
            compile: function(fe, ve) {
              var xe = ut(ve[Nt]), Ae = ut(ve[Nt], function(De) {
                return Mt.valueOf(De);
              });
              return {
                pre: function(De, qe) {
                  function va() {
                    var da = xe(De);
                    qe[0][Xt] = he(da);
                  }
                  va(), De.$watch(Ae, va);
                }
              };
            }
          });
        }
        function PM(gt, bt, Nt) {
          gt.push(
            JT(
              ut,
              xt,
              Z,
              bt,
              Nt,
              /*forceAsync=*/
              !1
            )
          );
        }
        function EM(gt, bt, Nt, Xt, Kt) {
          var Qt = ye(gt), he = TM(Qt, Xt), Oe = !Kt, fe = k[Xt] || Kt, ve = ft(Nt, Oe, he, fe);
          if (ve) {
            if (Xt === "multiple" && Qt === "select")
              throw pn(
                "selmulti",
                "Binding to the 'multiple' attribute is not supported. Element: {0}",
                Kn(gt)
              );
            if ($.test(Xt))
              throw pn("nodomevents", "Interpolations for HTML DOM event attributes are disallowed");
            bt.push({
              priority: 100,
              compile: function() {
                return {
                  pre: function(Ae, ae, De) {
                    var qe = De.$$observers || (De.$$observers = Ee()), va = De[Xt];
                    va !== Nt && (ve = va && ft(va, !0, he, fe), Nt = va), ve && (De[Xt] = ve(Ae), (qe[Xt] || (qe[Xt] = [])).$$inter = !0, (De.$$observers && De.$$observers[Xt].$$scope || Ae).$watch(ve, function(Ke, Je) {
                      Xt === "class" && Ke !== Je ? De.$updateClass(Ke, Je) : De.$set(Xt, Ke);
                    }));
                  }
                };
              }
            });
          }
        }
        function zp(gt, bt, Nt) {
          var Xt = bt[0], Kt = bt.length, Qt = Xt.parentNode, he, Oe;
          if (gt) {
            for (he = 0, Oe = gt.length; he < Oe; he++)
              if (gt[he] === Xt) {
                gt[he++] = Nt;
                for (var fe = he, ve = fe + Kt - 1, xe = gt.length; fe < xe; fe++, ve++)
                  ve < xe ? gt[fe] = gt[ve] : delete gt[fe];
                gt.length -= Kt - 1, gt.context === Xt && (gt.context = Nt);
                break;
              }
          }
          Qt && Qt.replaceChild(Nt, Xt);
          var Ae = s.document.createDocumentFragment();
          for (he = 0; he < Kt; he++)
            Ae.appendChild(bt[he]);
          for (p.hasData(Xt) && (p.data(Nt, p.data(Xt)), p(Xt).off("$destroy")), p.cleanData(Ae.querySelectorAll("*")), he = 1; he < Kt; he++)
            delete bt[he];
          bt[0] = Nt, bt.length = 1;
        }
        function gL(gt, bt) {
          return et(function() {
            return gt.apply(null, arguments);
          }, gt, bt);
        }
        function yL(gt, bt, Nt, Xt, Kt, Qt) {
          try {
            gt(bt, Nt, Xt, Kt, Qt);
          } catch (he) {
            Z(he, Kn(Nt));
          }
        }
        function Bp(gt, bt) {
          if (Ut)
            throw pn(
              "missingattr",
              "Attribute '{0}' of '{1}' is non-optional and must be set!",
              gt,
              bt
            );
        }
        function fL(gt, bt, Nt, Xt, Kt) {
          var Qt = [], he = {}, Oe;
          N(Xt, function(Ae, ae) {
            var De = Ae.attrName, qe = Ae.optional, va = Ae.mode, da, Ke, Je, we, ca;
            switch (va) {
              case "@":
                !qe && !l.call(bt, De) && (Bp(De, Kt.name), Nt[ae] = bt[De] = void 0), ca = bt.$observe(De, function(Za) {
                  if (nt(Za) || _t(Za)) {
                    var Ca = Nt[ae];
                    fe(ae, Za, Ca), Nt[ae] = Za;
                  }
                }), bt.$$observers[De].$$scope = gt, da = bt[De], nt(da) ? Nt[ae] = ft(da)(gt) : _t(da) && (Nt[ae] = da), he[ae] = new Dp(Mf, Nt[ae]), Qt.push(ca);
                break;
              case "=":
                if (!l.call(bt, De)) {
                  if (qe)
                    break;
                  Bp(De, Kt.name), bt[De] = void 0;
                }
                if (qe && !bt[De])
                  break;
                Ke = ut(bt[De]), Ke.literal ? we = je : we = qa, Je = Ke.assign || function() {
                  throw da = Nt[ae] = Ke(gt), pn(
                    "nonassign",
                    "Expression '{0}' in attribute '{1}' used with directive '{2}' is non-assignable!",
                    bt[De],
                    De,
                    Kt.name
                  );
                }, da = Nt[ae] = Ke(gt);
                var ia = function(Ca) {
                  return we(Ca, Nt[ae]) || (we(Ca, da) ? Je(gt, Ca = Nt[ae]) : Nt[ae] = Ca), da = Ca, da;
                };
                ia.$stateful = !0, Ae.collection ? ca = gt.$watchCollection(bt[De], ia) : ca = gt.$watch(ut(bt[De], ia), null, Ke.literal), Qt.push(ca);
                break;
              case "<":
                if (!l.call(bt, De)) {
                  if (qe)
                    break;
                  Bp(De, Kt.name), bt[De] = void 0;
                }
                if (qe && !bt[De])
                  break;
                Ke = ut(bt[De]);
                var ln = Ke.literal, on = Nt[ae] = Ke(gt);
                he[ae] = new Dp(Mf, Nt[ae]), ca = gt[Ae.collection ? "$watchCollection" : "$watch"](Ke, function(Ca, In) {
                  if (In === Ca) {
                    if (In === on || ln && je(In, on))
                      return;
                    In = on;
                  }
                  fe(ae, Ca, In), Nt[ae] = Ca;
                }), Qt.push(ca);
                break;
              case "&":
                if (!qe && !l.call(bt, De) && Bp(De, Kt.name), Ke = bt.hasOwnProperty(De) ? ut(bt[De]) : J, Ke === J && qe)
                  break;
                Nt[ae] = function(Za) {
                  return Ke(gt, Za);
                };
                break;
            }
          });
          function fe(xe, Ae, ae) {
            _(Nt.$onChanges) && !qa(Ae, ae) && (Le || (gt.$$postDigest($e), Le = []), Oe || (Oe = {}, Le.push(ve)), Oe[xe] && (ae = Oe[xe].previousValue), Oe[xe] = new Dp(ae, Ae));
          }
          function ve() {
            Nt.$onChanges(Oe), Oe = void 0;
          }
          return {
            initialChanges: he,
            removeWatches: Qt.length && function() {
              for (var Ae = 0, ae = Qt.length; Ae < ae; ++Ae)
                Qt[Ae]();
            }
          };
        }
      }
    ];
  }
  function Dp(u, m) {
    this.previousValue = u, this.currentValue = m;
  }
  Dp.prototype.isFirstChange = function() {
    return this.previousValue === Mf;
  };
  var Kk = /^((?:x|data)[:\-_])/i, BY = /[:\-_]+(.)/g;
  function di(u) {
    return u.replace(Kk, "").replace(BY, function(m, y, f) {
      return f ? y.toUpperCase() : y;
    });
  }
  function Jk(u, m) {
    var y = "", f = u.split(/\s+/), w = m.split(/\s+/);
    t:
      for (var D = 0; D < f.length; D++) {
        for (var k = f[D], S = 0; S < w.length; S++)
          if (k === w[S])
            continue t;
        y += (y.length > 0 ? " " : "") + k;
      }
    return y;
  }
  function Qk(u) {
    u = p(u);
    var m = u.length;
    if (m <= 1)
      return u;
    for (; m--; ) {
      var y = u[m];
      (y.nodeType === _n || y.nodeType === Ja && y.nodeValue.trim() === "") && x.call(u, m, 1);
    }
    return u;
  }
  var Zk = n("$controller"), tT = /^(\S+)(\s+as\s+([\w$]+))?$/;
  function WY(u, m) {
    if (m && nt(m))
      return m;
    if (nt(u)) {
      var y = tT.exec(u);
      if (y)
        return y[3];
    }
  }
  function jY() {
    var u = {};
    this.has = function(m) {
      return u.hasOwnProperty(m);
    }, this.register = function(m, y) {
      Pe(m, "controller"), lt(m) ? et(u, m) : u[m] = y;
    }, this.$get = ["$injector", function(m) {
      return function(w, D, k, S) {
        var $, E, Y, X;
        if (k = k === !0, S && nt(S) && (X = S), nt(w)) {
          if (E = w.match(tT), !E)
            throw Zk(
              "ctrlfmt",
              "Badly formed controller string '{0}'. Must match `__name__ as __id__` or `__name__`.",
              w
            );
          if (Y = E[1], X = X || E[3], w = u.hasOwnProperty(Y) ? u[Y] : Te(D.$scope, Y, !0), !w)
            throw Zk(
              "ctrlreg",
              "The controller with the name '{0}' is not registered.",
              Y
            );
          pe(w, Y, !0);
        }
        if (k) {
          var z = (Yt(w) ? w[w.length - 1] : w).prototype;
          return $ = Object.create(z || null), X && y(D, X, $, Y || w.name), et(function() {
            var ct = m.invoke(w, $, D, Y);
            return ct !== $ && (lt(ct) || _(ct)) && ($ = ct, X && y(D, X, $, Y || w.name)), $;
          }, {
            instance: $,
            identifier: X
          });
        }
        return $ = m.instantiate(w, D, Y), X && y(D, X, $, Y || w.name), $;
      };
      function y(f, w, D, k) {
        if (!(f && lt(f.$scope)))
          throw n("$controller")(
            "noscp",
            "Cannot export controller '{0}' as '{1}'! No $scope object provided via `locals`.",
            k,
            w
          );
        f.$scope[w] = D;
      }
    }];
  }
  function VY() {
    this.$get = ["$window", function(u) {
      return p(u.document);
    }];
  }
  function qY() {
    this.$get = ["$document", "$rootScope", function(u, m) {
      var y = u[0], f = y && y.hidden;
      u.on("visibilitychange", w), m.$on("$destroy", function() {
        u.off("visibilitychange", w);
      });
      function w() {
        f = y.hidden;
      }
      return function() {
        return f;
      };
    }];
  }
  function KY() {
    this.$get = ["$log", function(u) {
      return function(m, y) {
        u.error.apply(u, arguments);
      };
    }];
  }
  var JY = (
    /** @this */
    function() {
      this.$get = ["$document", function(u) {
        return function(m) {
          return m ? !m.nodeType && m instanceof p && (m = m[0]) : m = u[0].body, m.offsetWidth + 1;
        };
      }];
    }
  ), eT = "application/json", Xf = { "Content-Type": eT + ";charset=utf-8" }, QY = /^\[|^\{(?!\{)/, ZY = {
    "[": /]$/,
    "{": /}$/
  }, t_ = /^\)]\}',?\n/, Ip = n("$http");
  function Gf(u) {
    return lt(u) ? Rt(u) ? u.toISOString() : ks(u) : u;
  }
  function e_() {
    this.$get = function() {
      return function(m) {
        if (!m)
          return "";
        var y = [];
        return H(m, function(f, w) {
          f === null || j(f) || _(f) || (Yt(f) ? N(f, function(D) {
            y.push(Jn(w) + "=" + Jn(Gf(D)));
          }) : y.push(Jn(w) + "=" + Jn(Gf(f))));
        }), y.join("&");
      };
    };
  }
  function a_() {
    this.$get = function() {
      return function(m) {
        if (!m)
          return "";
        var y = [];
        return f(m, "", !0), y.join("&");
        function f(w, D, k) {
          Yt(w) ? N(w, function(S, $) {
            f(S, D + "[" + (lt(S) ? $ : "") + "]");
          }) : lt(w) && !Rt(w) ? H(w, function(S, $) {
            f(S, D + (k ? "" : "[") + $ + (k ? "" : "]"));
          }) : (_(w) && (w = w()), y.push(Jn(D) + "=" + (w == null ? "" : Jn(Gf(w)))));
        }
      };
    };
  }
  function Hf(u, m) {
    if (nt(u)) {
      var y = u.replace(t_, "").trim();
      if (y) {
        var f = m("Content-Type"), w = f && f.indexOf(eT) === 0;
        if (w || n_(y))
          try {
            u = Tr(y);
          } catch (D) {
            if (!w)
              return u;
            throw Ip("baddata", 'Data must be a valid JSON object. Received: "{0}". Parse error: "{1}"', u, D);
          }
      }
    }
    return u;
  }
  function n_(u) {
    var m = u.match(QY);
    return m && ZY[m[0]].test(u);
  }
  function aT(u) {
    var m = Ee(), y;
    function f(w, D) {
      w && (m[w] = m[w] ? m[w] + ", " + D : D);
    }
    return nt(u) ? N(u.split(`
`), function(w) {
      y = w.indexOf(":"), f(o(oe(w.substr(0, y))), oe(w.substr(y + 1)));
    }) : lt(u) && N(u, function(w, D) {
      f(o(D), oe(w));
    }), m;
  }
  function nT(u) {
    var m;
    return function(y) {
      if (m || (m = aT(u)), y) {
        var f = m[o(y)];
        return f === void 0 && (f = null), f;
      }
      return m;
    };
  }
  function sT(u, m, y, f) {
    return _(f) ? f(u, m, y) : (N(f, function(w) {
      u = w(u, m, y);
    }), u);
  }
  function Uf(u) {
    return 200 <= u && u < 300;
  }
  function s_() {
    var u = this.defaults = {
      // transform incoming response data
      transformResponse: [Hf],
      // transform outgoing request data
      transformRequest: [function(w) {
        return lt(w) && !ht(w) && !$t(w) && !ot(w) ? ks(w) : w;
      }],
      // default headers
      headers: {
        common: {
          Accept: "application/json, text/plain, */*"
        },
        post: Ts(Xf),
        put: Ts(Xf),
        patch: Ts(Xf)
      },
      xsrfCookieName: "XSRF-TOKEN",
      xsrfHeaderName: "X-XSRF-TOKEN",
      paramSerializer: "$httpParamSerializer",
      jsonpCallbackParam: "callback"
    }, m = !1;
    this.useApplyAsync = function(w) {
      return tt(w) ? (m = !!w, this) : m;
    };
    var y = this.interceptors = [], f = this.xsrfTrustedOrigins = [];
    Object.defineProperty(this, "xsrfWhitelistedOrigins", {
      get: function() {
        return this.xsrfTrustedOrigins;
      },
      set: function(w) {
        this.xsrfTrustedOrigins = w;
      }
    }), this.$get = [
      "$browser",
      "$httpBackend",
      "$$cookieReader",
      "$cacheFactory",
      "$rootScope",
      "$q",
      "$injector",
      "$sce",
      function(w, D, k, S, $, E, Y, X) {
        var z = S("$http");
        u.paramSerializer = nt(u.paramSerializer) ? Y.get(u.paramSerializer) : u.paramSerializer;
        var st = [];
        N(y, function(mt) {
          st.unshift(nt(mt) ? Y.get(mt) : Y.invoke(mt));
        });
        var ct = Q_(f);
        function It(mt) {
          if (!lt(mt))
            throw n("$http")("badreq", "Http request configuration must be an object.  Received: {0}", mt);
          if (!nt(X.valueOf(mt.url)))
            throw n("$http")("badreq", "Http request configuration url must be a string or a $sce trusted object.  Received: {0}", mt.url);
          var ft = et({
            method: "get",
            transformRequest: u.transformRequest,
            transformResponse: u.transformResponse,
            paramSerializer: u.paramSerializer,
            jsonpCallbackParam: u.jsonpCallbackParam
          }, mt);
          ft.headers = kt(mt), ft.method = c(ft.method), ft.paramSerializer = nt(ft.paramSerializer) ? Y.get(ft.paramSerializer) : ft.paramSerializer, w.$$incOutstandingRequestCount("$http");
          var Z = [], q = [], ut = E.resolve(ft);
          return N(st, function(ee) {
            (ee.request || ee.requestError) && Z.unshift(ee.request, ee.requestError), (ee.response || ee.responseError) && q.push(ee.response, ee.responseError);
          }), ut = pt(ut, Z), ut = ut.then(Gt), ut = pt(ut, q), ut = ut.finally(xt), ut;
          function pt(ee, Bt) {
            for (var re = 0, Le = Bt.length; re < Le; ) {
              var $e = Bt[re++], Xe = Bt[re++];
              ee = ee.then($e, Xe);
            }
            return Bt.length = 0, ee;
          }
          function xt() {
            w.$$completeOutstandingRequest(J, "$http");
          }
          function Mt(ee, Bt) {
            var re, Le = {};
            return N(ee, function($e, Xe) {
              _($e) ? (re = $e(Bt), re != null && (Le[Xe] = re)) : Le[Xe] = $e;
            }), Le;
          }
          function kt(ee) {
            var Bt = u.headers, re = et({}, ee.headers), Le, $e, Xe;
            Bt = et({}, Bt.common, Bt[o(ee.method)]);
            t:
              for (Le in Bt) {
                $e = o(Le);
                for (Xe in re)
                  if (o(Xe) === $e)
                    continue t;
                re[Le] = Bt[Le];
              }
            return Mt(re, Ts(ee));
          }
          function Gt(ee) {
            var Bt = ee.headers, re = sT(ee.data, nT(Bt), void 0, ee.transformRequest);
            return j(re) && N(Bt, function(Le, $e) {
              o($e) === "content-type" && delete Bt[$e];
            }), j(ee.withCredentials) && !j(u.withCredentials) && (ee.withCredentials = u.withCredentials), Dt(ee, re).then(Vt, Vt);
          }
          function Vt(ee) {
            var Bt = et({}, ee);
            return Bt.data = sT(
              ee.data,
              ee.headers,
              ee.status,
              ft.transformResponse
            ), Uf(ee.status) ? Bt : E.reject(Bt);
          }
        }
        return It.pendingRequests = [], Ut("get", "delete", "head", "jsonp"), Et("post", "put", "patch"), It.defaults = u, It;
        function Ut(mt) {
          N(arguments, function(ft) {
            It[ft] = function(Z, q) {
              return It(et({}, q || {}, {
                method: ft,
                url: Z
              }));
            };
          });
        }
        function Et(mt) {
          N(arguments, function(ft) {
            It[ft] = function(Z, q, ut) {
              return It(et({}, ut || {}, {
                method: ft,
                url: Z,
                data: q
              }));
            };
          });
        }
        function Dt(mt, ft) {
          var Z = E.defer(), q = Z.promise, ut, pt, xt = mt.headers, Mt = o(mt.method) === "jsonp", kt = mt.url;
          if (Mt ? kt = X.getTrustedResourceUrl(kt) : nt(kt) || (kt = X.valueOf(kt)), kt = Tt(kt, mt.paramSerializer(mt.params)), Mt && (kt = Ot(kt, mt.jsonpCallbackParam)), It.pendingRequests.push(mt), q.then(Le, Le), (mt.cache || u.cache) && mt.cache !== !1 && (mt.method === "GET" || mt.method === "JSONP") && (ut = lt(mt.cache) ? mt.cache : lt(
            /** @type {?} */
            u.cache
          ) ? (
            /** @type {?} */
            u.cache
          ) : z), ut && (pt = ut.get(kt), tt(pt) ? qt(pt) ? pt.then(re, re) : Yt(pt) ? Bt(pt[1], pt[0], Ts(pt[2]), pt[3], pt[4]) : Bt(pt, 200, {}, "OK", "complete") : ut.put(kt, q)), j(pt)) {
            var Gt = ct(mt.url) ? k()[mt.xsrfCookieName || u.xsrfCookieName] : void 0;
            Gt && (xt[mt.xsrfHeaderName || u.xsrfHeaderName] = Gt), D(
              mt.method,
              kt,
              ft,
              ee,
              xt,
              mt.timeout,
              mt.withCredentials,
              mt.responseType,
              Vt(mt.eventHandlers),
              Vt(mt.uploadEventHandlers)
            );
          }
          return q;
          function Vt($e) {
            if ($e) {
              var Xe = {};
              return N($e, function(ta, sa) {
                Xe[sa] = function(ba) {
                  m ? $.$applyAsync(Qa) : $.$$phase ? Qa() : $.$apply(Qa);
                  function Qa() {
                    ta(ba);
                  }
                };
              }), Xe;
            }
          }
          function ee($e, Xe, ta, sa, ba) {
            ut && (Uf($e) ? ut.put(kt, [$e, Xe, aT(ta), sa, ba]) : ut.remove(kt));
            function Qa() {
              Bt(Xe, $e, ta, sa, ba);
            }
            m ? $.$applyAsync(Qa) : (Qa(), $.$$phase || $.$apply());
          }
          function Bt($e, Xe, ta, sa, ba) {
            Xe = Xe >= -1 ? Xe : 0, (Uf(Xe) ? Z.resolve : Z.reject)({
              data: $e,
              status: Xe,
              headers: nT(ta),
              config: mt,
              statusText: sa,
              xhrStatus: ba
            });
          }
          function re($e) {
            Bt($e.data, $e.status, Ts($e.headers()), $e.statusText, $e.xhrStatus);
          }
          function Le() {
            var $e = It.pendingRequests.indexOf(mt);
            $e !== -1 && It.pendingRequests.splice($e, 1);
          }
        }
        function Tt(mt, ft) {
          return ft.length > 0 && (mt += (mt.indexOf("?") === -1 ? "?" : "&") + ft), mt;
        }
        function Ot(mt, ft) {
          var Z = mt.split("?");
          if (Z.length > 2)
            throw Ip("badjsonp", 'Illegal use more than one "?", in url, "{1}"', mt);
          var q = mo(Z[1]);
          return N(q, function(ut, pt) {
            if (ut === "JSON_CALLBACK")
              throw Ip("badjsonp", 'Illegal use of JSON_CALLBACK in url, "{0}"', mt);
            if (pt === ft)
              throw Ip("badjsonp", 'Illegal use of callback param, "{0}", in url, "{1}"', ft, mt);
          }), mt += (mt.indexOf("?") === -1 ? "?" : "&") + ft + "=JSON_CALLBACK", mt;
        }
      }
    ];
  }
  function i_() {
    this.$get = function() {
      return function() {
        return new s.XMLHttpRequest();
      };
    };
  }
  function r_() {
    this.$get = ["$browser", "$jsonpCallbacks", "$document", "$xhrFactory", function(u, m, y, f) {
      return l_(u, f, u.defer, m, y[0]);
    }];
  }
  function l_(u, m, y, f, w) {
    return function(k, S, $, E, Y, X, z, st, ct, It) {
      if (S = S || u.url(), o(k) === "jsonp")
        var Ut = f.createCallback(S), Et = D(S, Ut, function(pt, xt) {
          var Mt = pt === 200 && f.getResponse(Ut);
          ut(E, pt, Mt, "", xt, "complete"), f.removeCallback(Ut);
        });
      else {
        var Dt = m(k, S), Tt = !1;
        Dt.open(k, S, !0), N(Y, function(pt, xt) {
          tt(pt) && Dt.setRequestHeader(xt, pt);
        }), Dt.onload = function() {
          var xt = Dt.statusText || "", Mt = "response" in Dt ? Dt.response : Dt.responseText, kt = Dt.status === 1223 ? 204 : Dt.status;
          kt === 0 && (kt = Mt ? 200 : us(S).protocol === "file" ? 404 : 0), ut(
            E,
            kt,
            Mt,
            Dt.getAllResponseHeaders(),
            xt,
            "complete"
          );
        };
        var Ot = function() {
          ut(E, -1, null, null, "", "error");
        }, mt = function() {
          ut(E, -1, null, null, "", Tt ? "timeout" : "abort");
        }, ft = function() {
          ut(E, -1, null, null, "", "timeout");
        };
        if (Dt.onerror = Ot, Dt.ontimeout = ft, Dt.onabort = mt, N(ct, function(pt, xt) {
          Dt.addEventListener(xt, pt);
        }), N(It, function(pt, xt) {
          Dt.upload.addEventListener(xt, pt);
        }), z && (Dt.withCredentials = !0), st)
          try {
            Dt.responseType = st;
          } catch (pt) {
            if (st !== "json")
              throw pt;
          }
        Dt.send(j($) ? null : $);
      }
      if (X > 0)
        var Z = y(function() {
          q("timeout");
        }, X);
      else
        qt(X) && X.then(function() {
          q(tt(X.$$timeoutId) ? "timeout" : "abort");
        });
      function q(pt) {
        Tt = pt === "timeout", Et && Et(), Dt && Dt.abort();
      }
      function ut(pt, xt, Mt, kt, Gt, Vt) {
        tt(Z) && y.cancel(Z), Et = Dt = null, pt(xt, Mt, kt, Gt, Vt);
      }
    };
    function D(k, S, $) {
      k = k.replace("JSON_CALLBACK", S);
      var E = w.createElement("script"), Y = null;
      return E.type = "text/javascript", E.src = k, E.async = !0, Y = function(X) {
        E.removeEventListener("load", Y), E.removeEventListener("error", Y), w.body.removeChild(E), E = null;
        var z = -1, st = "unknown";
        X && (X.type === "load" && !f.wasCalled(S) && (X = { type: "error" }), st = X.type, z = X.type === "error" ? 404 : 200), $ && $(z, st);
      }, E.addEventListener("load", Y), E.addEventListener("error", Y), w.body.appendChild(E), Y;
    }
  }
  var yl = C.$interpolateMinErr = n("$interpolate");
  yl.throwNoconcat = function(u) {
    throw yl(
      "noconcat",
      `Error while interpolating: {0}
Strict Contextual Escaping disallows interpolations that concatenate multiple expressions when a trusted value is required.  See http://docs.angularjs.org/api/ng.$sce`,
      u
    );
  }, yl.interr = function(u, m) {
    return yl("interr", `Can't interpolate: {0}
{1}`, u, m.toString());
  };
  function o_() {
    var u = "{{", m = "}}";
    this.startSymbol = function(y) {
      return y ? (u = y, this) : u;
    }, this.endSymbol = function(y) {
      return y ? (m = y, this) : m;
    }, this.$get = ["$parse", "$exceptionHandler", "$sce", function(y, f, w) {
      var D = u.length, k = m.length, S = new RegExp(u.replace(/./g, E), "g"), $ = new RegExp(m.replace(/./g, E), "g");
      function E(st) {
        return "\\\\\\" + st;
      }
      function Y(st) {
        return st.replace(S, u).replace($, m);
      }
      function X(st, ct, It, Ut) {
        var Et = st.$watch(function(Tt) {
          return Et(), Ut(Tt);
        }, ct, It);
        return Et;
      }
      function z(st, ct, It, Ut) {
        var Et = It === w.URL || It === w.MEDIA_URL;
        if (!st.length || st.indexOf(u) === -1) {
          if (ct)
            return;
          var Dt = Y(st);
          Et && (Dt = w.getTrusted(It, Dt));
          var Tt = St(Dt);
          return Tt.exp = st, Tt.expressions = [], Tt.$$watchDelegate = X, Tt;
        }
        Ut = !!Ut;
        for (var Ot, mt, ft = 0, Z = [], q, ut = st.length, pt, xt = [], Mt = [], kt; ft < ut; )
          if ((Ot = st.indexOf(u, ft)) !== -1 && (mt = st.indexOf(m, Ot + D)) !== -1)
            ft !== Ot && xt.push(Y(st.substring(ft, Ot))), pt = st.substring(Ot + D, mt), Z.push(pt), ft = mt + k, Mt.push(xt.length), xt.push("");
          else {
            ft !== ut && xt.push(Y(st.substring(ft)));
            break;
          }
        kt = xt.length === 1 && Mt.length === 1;
        var Gt = Et && kt ? void 0 : ee;
        if (q = Z.map(function(Bt) {
          return y(Bt, Gt);
        }), !ct || Z.length) {
          var Vt = function(Bt) {
            for (var re = 0, Le = Z.length; re < Le; re++) {
              if (Ut && j(Bt[re]))
                return;
              xt[Mt[re]] = Bt[re];
            }
            return Et ? w.getTrusted(It, kt ? xt[0] : xt.join("")) : (It && xt.length > 1 && yl.throwNoconcat(st), xt.join(""));
          };
          return et(function(re) {
            var Le = 0, $e = Z.length, Xe = new Array($e);
            try {
              for (; Le < $e; Le++)
                Xe[Le] = q[Le](re);
              return Vt(Xe);
            } catch (ta) {
              f(yl.interr(st, ta));
            }
          }, {
            // all of these properties are undocumented for now
            exp: st,
            //just for compatibility with regular watchers created via $watch
            expressions: Z,
            $$watchDelegate: function(Bt, re) {
              var Le;
              return Bt.$watchGroup(
                q,
                /** @this */
                function(Xe, ta) {
                  var sa = Vt(Xe);
                  re.call(this, sa, Xe !== ta ? Le : sa, Bt), Le = sa;
                }
              );
            }
          });
        }
        function ee(Bt) {
          try {
            return Bt = It && !Et ? w.getTrusted(It, Bt) : w.valueOf(Bt), Ut && !tt(Bt) ? Bt : Ea(Bt);
          } catch (re) {
            f(yl.interr(st, re));
          }
        }
      }
      return z.startSymbol = function() {
        return u;
      }, z.endSymbol = function() {
        return m;
      }, z;
    }];
  }
  var c_ = n("$interval");
  function d_() {
    this.$get = [
      "$$intervalFactory",
      "$window",
      function(u, m) {
        var y = {}, f = function(k, S, $) {
          var E = m.setInterval(k, S);
          return y[E] = $, E;
        }, w = function(k) {
          m.clearInterval(k), delete y[k];
        }, D = u(f, w);
        return D.cancel = function(k) {
          if (!k)
            return !1;
          if (!k.hasOwnProperty("$$intervalId"))
            throw c_(
              "badprom",
              "`$interval.cancel()` called with a promise that was not generated by `$interval()`."
            );
          if (!y.hasOwnProperty(k.$$intervalId))
            return !1;
          var S = k.$$intervalId, $ = y[S];
          return xT($.promise), $.reject("canceled"), w(S), !0;
        }, D;
      }
    ];
  }
  function u_() {
    this.$get = [
      "$browser",
      "$q",
      "$$q",
      "$rootScope",
      function(u, m, y, f) {
        return function(D, k) {
          return function($, E, Y, X) {
            var z = arguments.length > 4, st = z ? sn(arguments, 4) : [], ct = 0, It = tt(X) && !X, Ut = (It ? y : m).defer(), Et = Ut.promise;
            Y = tt(Y) ? Y : 0;
            function Dt() {
              z ? $.apply(null, st) : $(ct);
            }
            function Tt() {
              It ? u.defer(Dt) : f.$evalAsync(Dt), Ut.notify(ct++), Y > 0 && ct >= Y && (Ut.resolve(ct), k(Et.$$intervalId)), It || f.$apply();
            }
            return Et.$$intervalId = D(Tt, E, Ut, It), Et;
          };
        };
      }
    ];
  }
  var p_ = (
    /** @this */
    function() {
      this.$get = function() {
        var u = C.callbacks, m = {};
        function y(f) {
          var w = function(D) {
            w.data = D, w.called = !0;
          };
          return w.id = f, w;
        }
        return {
          /**
           * @ngdoc method
           * @name $jsonpCallbacks#createCallback
           * @param {string} url the url of the JSONP request
           * @returns {string} the callback path to send to the server as part of the JSONP request
           * @description
           * {@link $httpBackend} calls this method to create a callback and get hold of the path to the callback
           * to pass to the server, which will be used to call the callback with its payload in the JSONP response.
           */
          createCallback: function(f) {
            var w = "_" + (u.$$counter++).toString(36), D = "angular.callbacks." + w, k = y(w);
            return m[D] = u[w] = k, D;
          },
          /**
           * @ngdoc method
           * @name $jsonpCallbacks#wasCalled
           * @param {string} callbackPath the path to the callback that was sent in the JSONP request
           * @returns {boolean} whether the callback has been called, as a result of the JSONP response
           * @description
           * {@link $httpBackend} calls this method to find out whether the JSONP response actually called the
           * callback that was passed in the request.
           */
          wasCalled: function(f) {
            return m[f].called;
          },
          /**
           * @ngdoc method
           * @name $jsonpCallbacks#getResponse
           * @param {string} callbackPath the path to the callback that was sent in the JSONP request
           * @returns {*} the data received from the response via the registered callback
           * @description
           * {@link $httpBackend} calls this method to get hold of the data that was provided to the callback
           * in the JSONP response.
           */
          getResponse: function(f) {
            return m[f].data;
          },
          /**
           * @ngdoc method
           * @name $jsonpCallbacks#removeCallback
           * @param {string} callbackPath the path to the callback that was sent in the JSONP request
           * @description
           * {@link $httpBackend} calls this method to remove the callback after the JSONP request has
           * completed or timed-out.
           */
          removeCallback: function(f) {
            var w = m[f];
            delete u[w.id], delete m[f];
          }
        };
      };
    }
  ), h_ = /^([^?#]*)(\?([^#]*))?(#(.*))?$/, m_ = { http: 80, https: 443, ftp: 21 }, id = n("$location");
  function g_(u) {
    for (var m = u.split("/"), y = m.length; y--; )
      m[y] = Kc(m[y].replace(/%2F/g, "/"));
    return m.join("/");
  }
  function y_(u, m) {
    for (var y = u.split("/"), f = y.length; f--; )
      y[f] = decodeURIComponent(y[f]), m && (y[f] = y[f].replace(/\//g, "%2F"));
    return y.join("/");
  }
  function f_(u, m, y) {
    var f = Lf(m), w = y ? "#" + Kc(y) : "", D = g_(u);
    return D + (f ? "?" + f : "") + w;
  }
  function iT(u, m) {
    var y = us(u);
    m.$$protocol = y.protocol, m.$$host = y.hostname, m.$$port = U(y.port) || m_[y.protocol] || null;
  }
  var b_ = /^\s*[\\/]{2,}/;
  function rT(u, m, y) {
    if (b_.test(u))
      throw id("badpath", 'Invalid url "{0}".', u);
    var f = u.charAt(0) !== "/";
    f && (u = "/" + u);
    var w = us(u), D = f && w.pathname.charAt(0) === "/" ? w.pathname.substring(1) : w.pathname;
    m.$$path = y_(D, y), m.$$search = mo(w.search), m.$$hash = decodeURIComponent(w.hash), m.$$path && m.$$path.charAt(0) !== "/" && (m.$$path = "/" + m.$$path);
  }
  function Ff(u, m) {
    return u.slice(0, m.length) === m;
  }
  function tr(u, m) {
    if (Ff(m, u))
      return m.substr(u.length);
  }
  function fl(u) {
    var m = u.indexOf("#");
    return m === -1 ? u : u.substr(0, m);
  }
  function v_(u) {
    return u.substr(0, fl(u).lastIndexOf("/") + 1);
  }
  function x_(u) {
    return u.substring(0, u.indexOf("/", u.indexOf("//") + 2));
  }
  function zf(u, m, y) {
    this.$$html5 = !0, y = y || "", iT(u, this), this.$$parse = function(f) {
      var w = tr(m, f);
      if (!nt(w))
        throw id(
          "ipthprfx",
          'Invalid url "{0}", missing path prefix "{1}".',
          f,
          m
        );
      rT(w, this, !0), this.$$path || (this.$$path = "/"), this.$$compose();
    }, this.$$normalizeUrl = function(f) {
      return m + f.substr(1);
    }, this.$$parseLinkUrl = function(f, w) {
      if (w && w[0] === "#")
        return this.hash(w.slice(1)), !0;
      var D, k, S;
      return tt(D = tr(u, f)) ? (k = D, y && tt(D = tr(y, D)) ? S = m + (tr("/", D) || D) : S = u + k) : tt(D = tr(m, f)) ? S = m + D : m === f + "/" && (S = m), S && this.$$parse(S), !!S;
    };
  }
  function Bf(u, m, y) {
    iT(u, this), this.$$parse = function(f) {
      var w = tr(u, f) || tr(m, f), D;
      !j(w) && w.charAt(0) === "#" ? (D = tr(y, w), j(D) && (D = w)) : this.$$html5 ? D = w : (D = "", j(w) && (u = f, this.replace())), rT(D, this, !1), this.$$path = k(this.$$path, D, u), this.$$compose();
      function k(S, $, E) {
        var Y = /^\/[A-Z]:(\/.*)/, X;
        return Ff($, E) && ($ = $.replace(E, "")), Y.exec($) ? S : (X = Y.exec(S), X ? X[1] : S);
      }
    }, this.$$normalizeUrl = function(f) {
      return u + (f ? y + f : "");
    }, this.$$parseLinkUrl = function(f, w) {
      return fl(u) === fl(f) ? (this.$$parse(f), !0) : !1;
    };
  }
  function lT(u, m, y) {
    this.$$html5 = !0, Bf.apply(this, arguments), this.$$parseLinkUrl = function(f, w) {
      if (w && w[0] === "#")
        return this.hash(w.slice(1)), !0;
      var D, k;
      return u === fl(f) ? D = f : (k = tr(m, f)) ? D = u + y + k : m === f + "/" && (D = m), D && this.$$parse(D), !!D;
    }, this.$$normalizeUrl = function(f) {
      return u + y + f;
    };
  }
  var w_ = {
    /**
     * Ensure absolute URL is initialized.
     * @private
     */
    $$absUrl: "",
    /**
     * Are we in html5 mode?
     * @private
     */
    $$html5: !1,
    /**
     * Has any change been replacing?
     * @private
     */
    $$replace: !1,
    /**
     * Compose url and update `url` and `absUrl` property
     * @private
     */
    $$compose: function() {
      this.$$url = f_(this.$$path, this.$$search, this.$$hash), this.$$absUrl = this.$$normalizeUrl(this.$$url), this.$$urlUpdatedByLocation = !0;
    },
    /**
     * @ngdoc method
     * @name $location#absUrl
     *
     * @description
     * This method is getter only.
     *
     * Return full URL representation with all segments encoded according to rules specified in
     * [RFC 3986](http://www.ietf.org/rfc/rfc3986.txt).
     *
     *
     * ```js
     * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
     * var absUrl = $location.absUrl();
     * // => "http://example.com/#/some/path?foo=bar&baz=xoxo"
     * ```
     *
     * @return {string} full URL
     */
    absUrl: Pp("$$absUrl"),
    /**
     * @ngdoc method
     * @name $location#url
     *
     * @description
     * This method is getter / setter.
     *
     * Return URL (e.g. `/path?a=b#hash`) when called without any parameter.
     *
     * Change path, search and hash, when called with parameter and return `$location`.
     *
     *
     * ```js
     * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
     * var url = $location.url();
     * // => "/some/path?foo=bar&baz=xoxo"
     * ```
     *
     * @param {string=} url New URL without base prefix (e.g. `/path?a=b#hash`)
     * @return {string} url
     */
    url: function(u) {
      if (j(u))
        return this.$$url;
      var m = h_.exec(u);
      return (m[1] || u === "") && this.path(decodeURIComponent(m[1])), (m[2] || m[1] || u === "") && this.search(m[3] || ""), this.hash(m[5] || ""), this;
    },
    /**
     * @ngdoc method
     * @name $location#protocol
     *
     * @description
     * This method is getter only.
     *
     * Return protocol of current URL.
     *
     *
     * ```js
     * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
     * var protocol = $location.protocol();
     * // => "http"
     * ```
     *
     * @return {string} protocol of current URL
     */
    protocol: Pp("$$protocol"),
    /**
     * @ngdoc method
     * @name $location#host
     *
     * @description
     * This method is getter only.
     *
     * Return host of current URL.
     *
     * Note: compared to the non-AngularJS version `location.host` which returns `hostname:port`, this returns the `hostname` portion only.
     *
     *
     * ```js
     * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
     * var host = $location.host();
     * // => "example.com"
     *
     * // given URL http://user:password@example.com:8080/#/some/path?foo=bar&baz=xoxo
     * host = $location.host();
     * // => "example.com"
     * host = location.host;
     * // => "example.com:8080"
     * ```
     *
     * @return {string} host of current URL.
     */
    host: Pp("$$host"),
    /**
     * @ngdoc method
     * @name $location#port
     *
     * @description
     * This method is getter only.
     *
     * Return port of current URL.
     *
     *
     * ```js
     * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
     * var port = $location.port();
     * // => 80
     * ```
     *
     * @return {Number} port
     */
    port: Pp("$$port"),
    /**
     * @ngdoc method
     * @name $location#path
     *
     * @description
     * This method is getter / setter.
     *
     * Return path of current URL when called without any parameter.
     *
     * Change path when called with parameter and return `$location`.
     *
     * Note: Path should always begin with forward slash (/), this method will add the forward slash
     * if it is missing.
     *
     *
     * ```js
     * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
     * var path = $location.path();
     * // => "/some/path"
     * ```
     *
     * @param {(string|number)=} path New path
     * @return {(string|object)} path if called with no parameters, or `$location` if called with a parameter
     */
    path: oT("$$path", function(u) {
      return u = u !== null ? u.toString() : "", u.charAt(0) === "/" ? u : "/" + u;
    }),
    /**
     * @ngdoc method
     * @name $location#search
     *
     * @description
     * This method is getter / setter.
     *
     * Return search part (as object) of current URL when called without any parameter.
     *
     * Change search part when called with parameter and return `$location`.
     *
     *
     * ```js
     * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
     * var searchObject = $location.search();
     * // => {foo: 'bar', baz: 'xoxo'}
     *
     * // set foo to 'yipee'
     * $location.search('foo', 'yipee');
     * // $location.search() => {foo: 'yipee', baz: 'xoxo'}
     * ```
     *
     * @param {string|Object.<string>|Object.<Array.<string>>} search New search params - string or
     * hash object.
     *
     * When called with a single argument the method acts as a setter, setting the `search` component
     * of `$location` to the specified value.
     *
     * If the argument is a hash object containing an array of values, these values will be encoded
     * as duplicate search parameters in the URL.
     *
     * @param {(string|Number|Array<string>|boolean)=} paramValue If `search` is a string or number, then `paramValue`
     * will override only a single search property.
     *
     * If `paramValue` is an array, it will override the property of the `search` component of
     * `$location` specified via the first argument.
     *
     * If `paramValue` is `null`, the property specified via the first argument will be deleted.
     *
     * If `paramValue` is `true`, the property specified via the first argument will be added with no
     * value nor trailing equal sign.
     *
     * @return {Object} If called with no arguments returns the parsed `search` object. If called with
     * one or more arguments returns `$location` object itself.
     */
    search: function(u, m) {
      switch (arguments.length) {
        case 0:
          return this.$$search;
        case 1:
          if (nt(u) || yt(u))
            u = u.toString(), this.$$search = mo(u);
          else if (lt(u))
            u = la(u, {}), N(u, function(y, f) {
              y == null && delete u[f];
            }), this.$$search = u;
          else
            throw id(
              "isrcharg",
              "The first argument of the `$location#search()` call must be a string or an object."
            );
          break;
        default:
          j(m) || m === null ? delete this.$$search[u] : this.$$search[u] = m;
      }
      return this.$$compose(), this;
    },
    /**
     * @ngdoc method
     * @name $location#hash
     *
     * @description
     * This method is getter / setter.
     *
     * Returns the hash fragment when called without any parameters.
     *
     * Changes the hash fragment when called with a parameter and returns `$location`.
     *
     *
     * ```js
     * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo#hashValue
     * var hash = $location.hash();
     * // => "hashValue"
     * ```
     *
     * @param {(string|number)=} hash New hash fragment
     * @return {string} hash
     */
    hash: oT("$$hash", function(u) {
      return u !== null ? u.toString() : "";
    }),
    /**
     * @ngdoc method
     * @name $location#replace
     *
     * @description
     * If called, all changes to $location during the current `$digest` will replace the current history
     * record, instead of adding a new one.
     */
    replace: function() {
      return this.$$replace = !0, this;
    }
  };
  N([lT, Bf, zf], function(u) {
    u.prototype = Object.create(w_), u.prototype.state = function(m) {
      if (!arguments.length)
        return this.$$state;
      if (u !== zf || !this.$$html5)
        throw id("nostate", "History API state support is available only in HTML5 mode and only in browsers supporting HTML5 History API");
      return this.$$state = j(m) ? null : m, this.$$urlUpdatedByLocation = !0, this;
    };
  });
  function Pp(u) {
    return (
      /** @this */
      function() {
        return this[u];
      }
    );
  }
  function oT(u, m) {
    return (
      /** @this */
      function(y) {
        return j(y) ? this[u] : (this[u] = m(y), this.$$compose(), this);
      }
    );
  }
  function A_() {
    var u = "!", m = {
      enabled: !1,
      requireBase: !0,
      rewriteLinks: !0
    };
    this.hashPrefix = function(y) {
      return tt(y) ? (u = y, this) : u;
    }, this.html5Mode = function(y) {
      return _t(y) ? (m.enabled = y, this) : lt(y) ? (_t(y.enabled) && (m.enabled = y.enabled), _t(y.requireBase) && (m.requireBase = y.requireBase), (_t(y.rewriteLinks) || nt(y.rewriteLinks)) && (m.rewriteLinks = y.rewriteLinks), this) : m;
    }, this.$get = [
      "$rootScope",
      "$browser",
      "$sniffer",
      "$rootElement",
      "$window",
      function(y, f, w, D, k) {
        var S, $, E = f.baseHref(), Y = f.url(), X;
        if (m.enabled) {
          if (!E && m.requireBase)
            throw id(
              "nobase",
              "$location in HTML5 mode requires a <base> tag to be present!"
            );
          X = x_(Y) + (E || "/"), $ = w.history ? zf : lT;
        } else
          X = fl(Y), $ = Bf;
        var z = v_(X);
        S = new $(X, z, "#" + u), S.$$parseLinkUrl(Y, Y), S.$$state = f.state();
        var st = /^\s*(javascript|mailto):/i;
        function ct(Dt, Tt) {
          return Dt === Tt || us(Dt).href === us(Tt).href;
        }
        function It(Dt, Tt, Ot) {
          var mt = S.url(), ft = S.$$state;
          try {
            f.url(Dt, Tt, Ot), S.$$state = f.state();
          } catch (Z) {
            throw S.url(mt), S.$$state = ft, Z;
          }
        }
        D.on("click", function(Dt) {
          var Tt = m.rewriteLinks;
          if (!(!Tt || Dt.ctrlKey || Dt.metaKey || Dt.shiftKey || Dt.which === 2 || Dt.button === 2)) {
            for (var Ot = p(Dt.target); ye(Ot[0]) !== "a"; )
              if (Ot[0] === D[0] || !(Ot = Ot.parent())[0])
                return;
            if (!(nt(Tt) && j(Ot.attr(Tt)))) {
              var mt = Ot.prop("href"), ft = Ot.attr("href") || Ot.attr("xlink:href");
              lt(mt) && mt.toString() === "[object SVGAnimatedString]" && (mt = us(mt.animVal).href), !st.test(mt) && mt && !Ot.attr("target") && !Dt.isDefaultPrevented() && S.$$parseLinkUrl(mt, ft) && (Dt.preventDefault(), S.absUrl() !== f.url() && y.$apply());
            }
          }
        }), S.absUrl() !== Y && f.url(S.absUrl(), !0);
        var Ut = !0;
        return f.onUrlChange(function(Dt, Tt) {
          if (!Ff(Dt, z)) {
            k.location.href = Dt;
            return;
          }
          y.$evalAsync(function() {
            var Ot = S.absUrl(), mt = S.$$state, ft;
            S.$$parse(Dt), S.$$state = Tt, ft = y.$broadcast(
              "$locationChangeStart",
              Dt,
              Ot,
              Tt,
              mt
            ).defaultPrevented, S.absUrl() === Dt && (ft ? (S.$$parse(Ot), S.$$state = mt, It(Ot, !1, mt)) : (Ut = !1, Et(Ot, mt)));
          }), y.$$phase || y.$digest();
        }), y.$watch(function() {
          if (Ut || S.$$urlUpdatedByLocation) {
            S.$$urlUpdatedByLocation = !1;
            var Tt = f.url(), Ot = S.absUrl(), mt = f.state(), ft = S.$$replace, Z = !ct(Tt, Ot) || S.$$html5 && w.history && mt !== S.$$state;
            (Ut || Z) && (Ut = !1, y.$evalAsync(function() {
              var q = S.absUrl(), ut = y.$broadcast(
                "$locationChangeStart",
                q,
                Tt,
                S.$$state,
                mt
              ).defaultPrevented;
              S.absUrl() === q && (ut ? (S.$$parse(Tt), S.$$state = mt) : (Z && It(
                q,
                ft,
                mt === S.$$state ? null : S.$$state
              ), Et(Tt, mt)));
            }));
          }
          S.$$replace = !1;
        }), S;
        function Et(Dt, Tt) {
          y.$broadcast(
            "$locationChangeSuccess",
            S.absUrl(),
            Dt,
            S.$$state,
            Tt
          );
        }
      }
    ];
  }
  function C_() {
    var u = !0, m = this;
    this.debugEnabled = function(y) {
      return tt(y) ? (u = y, this) : u;
    }, this.$get = ["$window", function(y) {
      var f = d || /\bEdge\//.test(y.navigator && y.navigator.userAgent);
      return {
        /**
         * @ngdoc method
         * @name $log#log
         *
         * @description
         * Write a log message
         */
        log: D("log"),
        /**
         * @ngdoc method
         * @name $log#info
         *
         * @description
         * Write an information message
         */
        info: D("info"),
        /**
         * @ngdoc method
         * @name $log#warn
         *
         * @description
         * Write a warning message
         */
        warn: D("warn"),
        /**
         * @ngdoc method
         * @name $log#error
         *
         * @description
         * Write an error message
         */
        error: D("error"),
        /**
         * @ngdoc method
         * @name $log#debug
         *
         * @description
         * Write a debug message
         */
        debug: function() {
          var k = D("debug");
          return function() {
            u && k.apply(m, arguments);
          };
        }()
      };
      function w(k) {
        return K(k) && (k.stack && f ? k = k.message && k.stack.indexOf(k.message) === -1 ? "Error: " + k.message + `
` + k.stack : k.stack : k.sourceURL && (k = k.message + `
` + k.sourceURL + ":" + k.line)), k;
      }
      function D(k) {
        var S = y.console || {}, $ = S[k] || S.log || J;
        return function() {
          var E = [];
          return N(arguments, function(Y) {
            E.push(w(Y));
          }), Function.prototype.apply.call($, S, E);
        };
      }
    }];
  }
  var wo = n("$parse"), $_ = {}.constructor.prototype.valueOf;
  function cT(u) {
    return u + "";
  }
  var Ep = Ee();
  N("+ - * / % === !== == != < > <= >= && || ! = |".split(" "), function(u) {
    Ep[u] = !0;
  });
  var S_ = { n: `
`, f: "\f", r: "\r", t: "	", v: "\v", "'": "'", '"': '"' }, Np = function(m) {
    this.options = m;
  };
  Np.prototype = {
    constructor: Np,
    lex: function(u) {
      for (this.text = u, this.index = 0, this.tokens = []; this.index < this.text.length; ) {
        var m = this.text.charAt(this.index);
        if (m === '"' || m === "'")
          this.readString(m);
        else if (this.isNumber(m) || m === "." && this.isNumber(this.peek()))
          this.readNumber();
        else if (this.isIdentifierStart(this.peekMultichar()))
          this.readIdent();
        else if (this.is(m, "(){}[].,;:?"))
          this.tokens.push({ index: this.index, text: m }), this.index++;
        else if (this.isWhitespace(m))
          this.index++;
        else {
          var y = m + this.peek(), f = y + this.peek(2), w = Ep[m], D = Ep[y], k = Ep[f];
          if (w || D || k) {
            var S = k ? f : D ? y : m;
            this.tokens.push({ index: this.index, text: S, operator: !0 }), this.index += S.length;
          } else
            this.throwError("Unexpected next character ", this.index, this.index + 1);
        }
      }
      return this.tokens;
    },
    is: function(u, m) {
      return m.indexOf(u) !== -1;
    },
    peek: function(u) {
      var m = u || 1;
      return this.index + m < this.text.length ? this.text.charAt(this.index + m) : !1;
    },
    isNumber: function(u) {
      return "0" <= u && u <= "9" && typeof u == "string";
    },
    isWhitespace: function(u) {
      return u === " " || u === "\r" || u === "	" || u === `
` || u === "\v" || u === " ";
    },
    isIdentifierStart: function(u) {
      return this.options.isIdentifierStart ? this.options.isIdentifierStart(u, this.codePointAt(u)) : this.isValidIdentifierStart(u);
    },
    isValidIdentifierStart: function(u) {
      return "a" <= u && u <= "z" || "A" <= u && u <= "Z" || u === "_" || u === "$";
    },
    isIdentifierContinue: function(u) {
      return this.options.isIdentifierContinue ? this.options.isIdentifierContinue(u, this.codePointAt(u)) : this.isValidIdentifierContinue(u);
    },
    isValidIdentifierContinue: function(u, m) {
      return this.isValidIdentifierStart(u, m) || this.isNumber(u);
    },
    codePointAt: function(u) {
      return u.length === 1 ? u.charCodeAt(0) : (u.charCodeAt(0) << 10) + u.charCodeAt(1) - 56613888;
    },
    peekMultichar: function() {
      var u = this.text.charAt(this.index), m = this.peek();
      if (!m)
        return u;
      var y = u.charCodeAt(0), f = m.charCodeAt(0);
      return y >= 55296 && y <= 56319 && f >= 56320 && f <= 57343 ? u + m : u;
    },
    isExpOperator: function(u) {
      return u === "-" || u === "+" || this.isNumber(u);
    },
    throwError: function(u, m, y) {
      y = y || this.index;
      var f = tt(m) ? "s " + m + "-" + this.index + " [" + this.text.substring(m, y) + "]" : " " + y;
      throw wo(
        "lexerr",
        "Lexer Error: {0} at column{1} in expression [{2}].",
        u,
        f,
        this.text
      );
    },
    readNumber: function() {
      for (var u = "", m = this.index; this.index < this.text.length; ) {
        var y = o(this.text.charAt(this.index));
        if (y === "." || this.isNumber(y))
          u += y;
        else {
          var f = this.peek();
          if (y === "e" && this.isExpOperator(f))
            u += y;
          else if (this.isExpOperator(y) && f && this.isNumber(f) && u.charAt(u.length - 1) === "e")
            u += y;
          else if (this.isExpOperator(y) && (!f || !this.isNumber(f)) && u.charAt(u.length - 1) === "e")
            this.throwError("Invalid exponent");
          else
            break;
        }
        this.index++;
      }
      this.tokens.push({
        index: m,
        text: u,
        constant: !0,
        value: Number(u)
      });
    },
    readIdent: function() {
      var u = this.index;
      for (this.index += this.peekMultichar().length; this.index < this.text.length; ) {
        var m = this.peekMultichar();
        if (!this.isIdentifierContinue(m))
          break;
        this.index += m.length;
      }
      this.tokens.push({
        index: u,
        text: this.text.slice(u, this.index),
        identifier: !0
      });
    },
    readString: function(u) {
      var m = this.index;
      this.index++;
      for (var y = "", f = u, w = !1; this.index < this.text.length; ) {
        var D = this.text.charAt(this.index);
        if (f += D, w) {
          if (D === "u") {
            var k = this.text.substring(this.index + 1, this.index + 5);
            k.match(/[\da-f]{4}/i) || this.throwError("Invalid unicode escape [\\u" + k + "]"), this.index += 4, y += String.fromCharCode(parseInt(k, 16));
          } else {
            var S = S_[D];
            y = y + (S || D);
          }
          w = !1;
        } else if (D === "\\")
          w = !0;
        else if (D === u) {
          this.index++, this.tokens.push({
            index: m,
            text: f,
            constant: !0,
            value: y
          });
          return;
        } else
          y += D;
        this.index++;
      }
      this.throwError("Unterminated quote", m);
    }
  };
  var te = function(m, y) {
    this.lexer = m, this.options = y;
  };
  te.Program = "Program", te.ExpressionStatement = "ExpressionStatement", te.AssignmentExpression = "AssignmentExpression", te.ConditionalExpression = "ConditionalExpression", te.LogicalExpression = "LogicalExpression", te.BinaryExpression = "BinaryExpression", te.UnaryExpression = "UnaryExpression", te.CallExpression = "CallExpression", te.MemberExpression = "MemberExpression", te.Identifier = "Identifier", te.Literal = "Literal", te.ArrayExpression = "ArrayExpression", te.Property = "Property", te.ObjectExpression = "ObjectExpression", te.ThisExpression = "ThisExpression", te.LocalsExpression = "LocalsExpression", te.NGValueParameter = "NGValueParameter", te.prototype = {
    ast: function(u) {
      this.text = u, this.tokens = this.lexer.lex(u);
      var m = this.program();
      return this.tokens.length !== 0 && this.throwError("is an unexpected token", this.tokens[0]), m;
    },
    program: function() {
      for (var u = []; ; )
        if (this.tokens.length > 0 && !this.peek("}", ")", ";", "]") && u.push(this.expressionStatement()), !this.expect(";"))
          return { type: te.Program, body: u };
    },
    expressionStatement: function() {
      return { type: te.ExpressionStatement, expression: this.filterChain() };
    },
    filterChain: function() {
      for (var u = this.expression(); this.expect("|"); )
        u = this.filter(u);
      return u;
    },
    expression: function() {
      return this.assignment();
    },
    assignment: function() {
      var u = this.ternary();
      if (this.expect("=")) {
        if (!mT(u))
          throw wo("lval", "Trying to assign a value to a non l-value");
        u = { type: te.AssignmentExpression, left: u, right: this.assignment(), operator: "=" };
      }
      return u;
    },
    ternary: function() {
      var u = this.logicalOR(), m, y;
      return this.expect("?") && (m = this.expression(), this.consume(":")) ? (y = this.expression(), { type: te.ConditionalExpression, test: u, alternate: m, consequent: y }) : u;
    },
    logicalOR: function() {
      for (var u = this.logicalAND(); this.expect("||"); )
        u = { type: te.LogicalExpression, operator: "||", left: u, right: this.logicalAND() };
      return u;
    },
    logicalAND: function() {
      for (var u = this.equality(); this.expect("&&"); )
        u = { type: te.LogicalExpression, operator: "&&", left: u, right: this.equality() };
      return u;
    },
    equality: function() {
      for (var u = this.relational(), m; m = this.expect("==", "!=", "===", "!=="); )
        u = { type: te.BinaryExpression, operator: m.text, left: u, right: this.relational() };
      return u;
    },
    relational: function() {
      for (var u = this.additive(), m; m = this.expect("<", ">", "<=", ">="); )
        u = { type: te.BinaryExpression, operator: m.text, left: u, right: this.additive() };
      return u;
    },
    additive: function() {
      for (var u = this.multiplicative(), m; m = this.expect("+", "-"); )
        u = { type: te.BinaryExpression, operator: m.text, left: u, right: this.multiplicative() };
      return u;
    },
    multiplicative: function() {
      for (var u = this.unary(), m; m = this.expect("*", "/", "%"); )
        u = { type: te.BinaryExpression, operator: m.text, left: u, right: this.unary() };
      return u;
    },
    unary: function() {
      var u;
      return (u = this.expect("+", "-", "!")) ? { type: te.UnaryExpression, operator: u.text, prefix: !0, argument: this.unary() } : this.primary();
    },
    primary: function() {
      var u;
      this.expect("(") ? (u = this.filterChain(), this.consume(")")) : this.expect("[") ? u = this.arrayDeclaration() : this.expect("{") ? u = this.object() : this.selfReferential.hasOwnProperty(this.peek().text) ? u = la(this.selfReferential[this.consume().text]) : this.options.literals.hasOwnProperty(this.peek().text) ? u = { type: te.Literal, value: this.options.literals[this.consume().text] } : this.peek().identifier ? u = this.identifier() : this.peek().constant ? u = this.constant() : this.throwError("not a primary expression", this.peek());
      for (var m; m = this.expect("(", "[", "."); )
        m.text === "(" ? (u = { type: te.CallExpression, callee: u, arguments: this.parseArguments() }, this.consume(")")) : m.text === "[" ? (u = { type: te.MemberExpression, object: u, property: this.expression(), computed: !0 }, this.consume("]")) : m.text === "." ? u = { type: te.MemberExpression, object: u, property: this.identifier(), computed: !1 } : this.throwError("IMPOSSIBLE");
      return u;
    },
    filter: function(u) {
      for (var m = [u], y = { type: te.CallExpression, callee: this.identifier(), arguments: m, filter: !0 }; this.expect(":"); )
        m.push(this.expression());
      return y;
    },
    parseArguments: function() {
      var u = [];
      if (this.peekToken().text !== ")")
        do
          u.push(this.filterChain());
        while (this.expect(","));
      return u;
    },
    identifier: function() {
      var u = this.consume();
      return u.identifier || this.throwError("is not a valid identifier", u), { type: te.Identifier, name: u.text };
    },
    constant: function() {
      return { type: te.Literal, value: this.consume().value };
    },
    arrayDeclaration: function() {
      var u = [];
      if (this.peekToken().text !== "]")
        do {
          if (this.peek("]"))
            break;
          u.push(this.expression());
        } while (this.expect(","));
      return this.consume("]"), { type: te.ArrayExpression, elements: u };
    },
    object: function() {
      var u = [], m;
      if (this.peekToken().text !== "}")
        do {
          if (this.peek("}"))
            break;
          m = { type: te.Property, kind: "init" }, this.peek().constant ? (m.key = this.constant(), m.computed = !1, this.consume(":"), m.value = this.expression()) : this.peek().identifier ? (m.key = this.identifier(), m.computed = !1, this.peek(":") ? (this.consume(":"), m.value = this.expression()) : m.value = m.key) : this.peek("[") ? (this.consume("["), m.key = this.expression(), this.consume("]"), m.computed = !0, this.consume(":"), m.value = this.expression()) : this.throwError("invalid key", this.peek()), u.push(m);
        } while (this.expect(","));
      return this.consume("}"), { type: te.ObjectExpression, properties: u };
    },
    throwError: function(u, m) {
      throw wo(
        "syntax",
        "Syntax Error: Token '{0}' {1} at column {2} of the expression [{3}] starting at [{4}].",
        m.text,
        u,
        m.index + 1,
        this.text,
        this.text.substring(m.index)
      );
    },
    consume: function(u) {
      if (this.tokens.length === 0)
        throw wo("ueoe", "Unexpected end of expression: {0}", this.text);
      var m = this.expect(u);
      return m || this.throwError("is unexpected, expecting [" + u + "]", this.peek()), m;
    },
    peekToken: function() {
      if (this.tokens.length === 0)
        throw wo("ueoe", "Unexpected end of expression: {0}", this.text);
      return this.tokens[0];
    },
    peek: function(u, m, y, f) {
      return this.peekAhead(0, u, m, y, f);
    },
    peekAhead: function(u, m, y, f, w) {
      if (this.tokens.length > u) {
        var D = this.tokens[u], k = D.text;
        if (k === m || k === y || k === f || k === w || !m && !y && !f && !w)
          return D;
      }
      return !1;
    },
    expect: function(u, m, y, f) {
      var w = this.peek(u, m, y, f);
      return w ? (this.tokens.shift(), w) : !1;
    },
    selfReferential: {
      this: { type: te.ThisExpression },
      $locals: { type: te.LocalsExpression }
    }
  };
  function k_(u, m) {
    return typeof u < "u" ? u : m;
  }
  function dT(u, m) {
    return typeof u > "u" ? m : typeof m > "u" ? u : u + m;
  }
  function T_(u, m) {
    var y = u(m);
    return !y.$stateful;
  }
  var uT = 1, pT = 2;
  function L_(u, m) {
    switch (u.type) {
      case te.MemberExpression:
        if (u.computed)
          return !1;
        break;
      case te.UnaryExpression:
        return uT;
      case te.BinaryExpression:
        return u.operator !== "+" ? uT : !1;
      case te.CallExpression:
        return !1;
    }
    return m === void 0 ? pT : m;
  }
  function xn(u, m, y) {
    var f, w, D, k = u.isPure = L_(u, y);
    switch (u.type) {
      case te.Program:
        f = !0, N(u.body, function(S) {
          xn(S.expression, m, k), f = f && S.expression.constant;
        }), u.constant = f;
        break;
      case te.Literal:
        u.constant = !0, u.toWatch = [];
        break;
      case te.UnaryExpression:
        xn(u.argument, m, k), u.constant = u.argument.constant, u.toWatch = u.argument.toWatch;
        break;
      case te.BinaryExpression:
        xn(u.left, m, k), xn(u.right, m, k), u.constant = u.left.constant && u.right.constant, u.toWatch = u.left.toWatch.concat(u.right.toWatch);
        break;
      case te.LogicalExpression:
        xn(u.left, m, k), xn(u.right, m, k), u.constant = u.left.constant && u.right.constant, u.toWatch = u.constant ? [] : [u];
        break;
      case te.ConditionalExpression:
        xn(u.test, m, k), xn(u.alternate, m, k), xn(u.consequent, m, k), u.constant = u.test.constant && u.alternate.constant && u.consequent.constant, u.toWatch = u.constant ? [] : [u];
        break;
      case te.Identifier:
        u.constant = !1, u.toWatch = [u];
        break;
      case te.MemberExpression:
        xn(u.object, m, k), u.computed && xn(u.property, m, k), u.constant = u.object.constant && (!u.computed || u.property.constant), u.toWatch = u.constant ? [] : [u];
        break;
      case te.CallExpression:
        D = u.filter ? T_(m, u.callee.name) : !1, f = D, w = [], N(u.arguments, function(S) {
          xn(S, m, k), f = f && S.constant, w.push.apply(w, S.toWatch);
        }), u.constant = f, u.toWatch = D ? w : [u];
        break;
      case te.AssignmentExpression:
        xn(u.left, m, k), xn(u.right, m, k), u.constant = u.left.constant && u.right.constant, u.toWatch = [u];
        break;
      case te.ArrayExpression:
        f = !0, w = [], N(u.elements, function(S) {
          xn(S, m, k), f = f && S.constant, w.push.apply(w, S.toWatch);
        }), u.constant = f, u.toWatch = w;
        break;
      case te.ObjectExpression:
        f = !0, w = [], N(u.properties, function(S) {
          xn(S.value, m, k), f = f && S.value.constant, w.push.apply(w, S.value.toWatch), S.computed && (xn(
            S.key,
            m,
            /*parentIsPure=*/
            !1
          ), f = f && S.key.constant, w.push.apply(w, S.key.toWatch));
        }), u.constant = f, u.toWatch = w;
        break;
      case te.ThisExpression:
        u.constant = !1, u.toWatch = [];
        break;
      case te.LocalsExpression:
        u.constant = !1, u.toWatch = [];
        break;
    }
  }
  function hT(u) {
    if (u.length === 1) {
      var m = u[0].expression, y = m.toWatch;
      return y.length !== 1 || y[0] !== m ? y : void 0;
    }
  }
  function mT(u) {
    return u.type === te.Identifier || u.type === te.MemberExpression;
  }
  function gT(u) {
    if (u.body.length === 1 && mT(u.body[0].expression))
      return { type: te.AssignmentExpression, left: u.body[0].expression, right: { type: te.NGValueParameter }, operator: "=" };
  }
  function D_(u) {
    return u.body.length === 0 || u.body.length === 1 && (u.body[0].expression.type === te.Literal || u.body[0].expression.type === te.ArrayExpression || u.body[0].expression.type === te.ObjectExpression);
  }
  function I_(u) {
    return u.constant;
  }
  function yT(u) {
    this.$filter = u;
  }
  yT.prototype = {
    compile: function(u) {
      var m = this;
      this.state = {
        nextId: 0,
        filters: {},
        fn: { vars: [], body: [], own: {} },
        assign: { vars: [], body: [], own: {} },
        inputs: []
      }, xn(u, m.$filter);
      var y = "", f;
      if (this.stage = "assign", f = gT(u)) {
        this.state.computing = "assign";
        var w = this.nextId();
        this.recurse(f, w), this.return_(w), y = "fn.assign=" + this.generateFunction("assign", "s,v,l");
      }
      var D = hT(u.body);
      m.stage = "inputs", N(D, function($, E) {
        var Y = "fn" + E;
        m.state[Y] = { vars: [], body: [], own: {} }, m.state.computing = Y;
        var X = m.nextId();
        m.recurse($, X), m.return_(X), m.state.inputs.push({ name: Y, isPure: $.isPure }), $.watchId = E;
      }), this.state.computing = "fn", this.stage = "main", this.recurse(u);
      var k = (
        // The build and minification steps remove the string "use strict" from the code, but this is done using a regex.
        // This is a workaround for this until we do a better job at only removing the prefix only when we should.
        '"' + this.USE + " " + this.STRICT + `";
` + this.filterPrefix() + "var fn=" + this.generateFunction("fn", "s,l,a,i") + y + this.watchFns() + "return fn;"
      ), S = new Function(
        "$filter",
        "getStringValue",
        "ifDefined",
        "plus",
        k
      )(
        this.$filter,
        cT,
        k_,
        dT
      );
      return this.state = this.stage = void 0, S;
    },
    USE: "use",
    STRICT: "strict",
    watchFns: function() {
      var u = [], m = this.state.inputs, y = this;
      return N(m, function(f) {
        u.push("var " + f.name + "=" + y.generateFunction(f.name, "s")), f.isPure && u.push(f.name, ".isPure=" + JSON.stringify(f.isPure) + ";");
      }), m.length && u.push("fn.inputs=[" + m.map(function(f) {
        return f.name;
      }).join(",") + "];"), u.join("");
    },
    generateFunction: function(u, m) {
      return "function(" + m + "){" + this.varsPrefix(u) + this.body(u) + "};";
    },
    filterPrefix: function() {
      var u = [], m = this;
      return N(this.state.filters, function(y, f) {
        u.push(y + "=$filter(" + m.escape(f) + ")");
      }), u.length ? "var " + u.join(",") + ";" : "";
    },
    varsPrefix: function(u) {
      return this.state[u].vars.length ? "var " + this.state[u].vars.join(",") + ";" : "";
    },
    body: function(u) {
      return this.state[u].body.join("");
    },
    recurse: function(u, m, y, f, w, D) {
      var k, S, $ = this, E, Y, X;
      if (f = f || J, !D && tt(u.watchId)) {
        m = m || this.nextId(), this.if_(
          "i",
          this.lazyAssign(m, this.computedMember("i", u.watchId)),
          this.lazyRecurse(u, m, y, f, w, !0)
        );
        return;
      }
      switch (u.type) {
        case te.Program:
          N(u.body, function(z, st) {
            $.recurse(z.expression, void 0, void 0, function(ct) {
              S = ct;
            }), st !== u.body.length - 1 ? $.current().body.push(S, ";") : $.return_(S);
          });
          break;
        case te.Literal:
          Y = this.escape(u.value), this.assign(m, Y), f(m || Y);
          break;
        case te.UnaryExpression:
          this.recurse(u.argument, void 0, void 0, function(z) {
            S = z;
          }), Y = u.operator + "(" + this.ifDefined(S, 0) + ")", this.assign(m, Y), f(Y);
          break;
        case te.BinaryExpression:
          this.recurse(u.left, void 0, void 0, function(z) {
            k = z;
          }), this.recurse(u.right, void 0, void 0, function(z) {
            S = z;
          }), u.operator === "+" ? Y = this.plus(k, S) : u.operator === "-" ? Y = this.ifDefined(k, 0) + u.operator + this.ifDefined(S, 0) : Y = "(" + k + ")" + u.operator + "(" + S + ")", this.assign(m, Y), f(Y);
          break;
        case te.LogicalExpression:
          m = m || this.nextId(), $.recurse(u.left, m), $.if_(u.operator === "&&" ? m : $.not(m), $.lazyRecurse(u.right, m)), f(m);
          break;
        case te.ConditionalExpression:
          m = m || this.nextId(), $.recurse(u.test, m), $.if_(m, $.lazyRecurse(u.alternate, m), $.lazyRecurse(u.consequent, m)), f(m);
          break;
        case te.Identifier:
          m = m || this.nextId(), y && (y.context = $.stage === "inputs" ? "s" : this.assign(this.nextId(), this.getHasOwnProperty("l", u.name) + "?l:s"), y.computed = !1, y.name = u.name), $.if_(
            $.stage === "inputs" || $.not($.getHasOwnProperty("l", u.name)),
            function() {
              $.if_($.stage === "inputs" || "s", function() {
                w && w !== 1 && $.if_(
                  $.isNull($.nonComputedMember("s", u.name)),
                  $.lazyAssign($.nonComputedMember("s", u.name), "{}")
                ), $.assign(m, $.nonComputedMember("s", u.name));
              });
            },
            m && $.lazyAssign(m, $.nonComputedMember("l", u.name))
          ), f(m);
          break;
        case te.MemberExpression:
          k = y && (y.context = this.nextId()) || this.nextId(), m = m || this.nextId(), $.recurse(u.object, k, void 0, function() {
            $.if_($.notNull(k), function() {
              u.computed ? (S = $.nextId(), $.recurse(u.property, S), $.getStringValue(S), w && w !== 1 && $.if_($.not($.computedMember(k, S)), $.lazyAssign($.computedMember(k, S), "{}")), Y = $.computedMember(k, S), $.assign(m, Y), y && (y.computed = !0, y.name = S)) : (w && w !== 1 && $.if_($.isNull($.nonComputedMember(k, u.property.name)), $.lazyAssign($.nonComputedMember(k, u.property.name), "{}")), Y = $.nonComputedMember(k, u.property.name), $.assign(m, Y), y && (y.computed = !1, y.name = u.property.name));
            }, function() {
              $.assign(m, "undefined");
            }), f(m);
          }, !!w);
          break;
        case te.CallExpression:
          m = m || this.nextId(), u.filter ? (S = $.filter(u.callee.name), E = [], N(u.arguments, function(z) {
            var st = $.nextId();
            $.recurse(z, st), E.push(st);
          }), Y = S + "(" + E.join(",") + ")", $.assign(m, Y), f(m)) : (S = $.nextId(), k = {}, E = [], $.recurse(u.callee, S, k, function() {
            $.if_($.notNull(S), function() {
              N(u.arguments, function(z) {
                $.recurse(z, u.constant ? void 0 : $.nextId(), void 0, function(st) {
                  E.push(st);
                });
              }), k.name ? Y = $.member(k.context, k.name, k.computed) + "(" + E.join(",") + ")" : Y = S + "(" + E.join(",") + ")", $.assign(m, Y);
            }, function() {
              $.assign(m, "undefined");
            }), f(m);
          }));
          break;
        case te.AssignmentExpression:
          S = this.nextId(), k = {}, this.recurse(u.left, void 0, k, function() {
            $.if_($.notNull(k.context), function() {
              $.recurse(u.right, S), Y = $.member(k.context, k.name, k.computed) + u.operator + S, $.assign(m, Y), f(m || Y);
            });
          }, 1);
          break;
        case te.ArrayExpression:
          E = [], N(u.elements, function(z) {
            $.recurse(z, u.constant ? void 0 : $.nextId(), void 0, function(st) {
              E.push(st);
            });
          }), Y = "[" + E.join(",") + "]", this.assign(m, Y), f(m || Y);
          break;
        case te.ObjectExpression:
          E = [], X = !1, N(u.properties, function(z) {
            z.computed && (X = !0);
          }), X ? (m = m || this.nextId(), this.assign(m, "{}"), N(u.properties, function(z) {
            z.computed ? (k = $.nextId(), $.recurse(z.key, k)) : k = z.key.type === te.Identifier ? z.key.name : "" + z.key.value, S = $.nextId(), $.recurse(z.value, S), $.assign($.member(m, k, z.computed), S);
          })) : (N(u.properties, function(z) {
            $.recurse(z.value, u.constant ? void 0 : $.nextId(), void 0, function(st) {
              E.push($.escape(
                z.key.type === te.Identifier ? z.key.name : "" + z.key.value
              ) + ":" + st);
            });
          }), Y = "{" + E.join(",") + "}", this.assign(m, Y)), f(m || Y);
          break;
        case te.ThisExpression:
          this.assign(m, "s"), f(m || "s");
          break;
        case te.LocalsExpression:
          this.assign(m, "l"), f(m || "l");
          break;
        case te.NGValueParameter:
          this.assign(m, "v"), f(m || "v");
          break;
      }
    },
    getHasOwnProperty: function(u, m) {
      var y = u + "." + m, f = this.current().own;
      return f.hasOwnProperty(y) || (f[y] = this.nextId(!1, u + "&&(" + this.escape(m) + " in " + u + ")")), f[y];
    },
    assign: function(u, m) {
      if (u)
        return this.current().body.push(u, "=", m, ";"), u;
    },
    filter: function(u) {
      return this.state.filters.hasOwnProperty(u) || (this.state.filters[u] = this.nextId(!0)), this.state.filters[u];
    },
    ifDefined: function(u, m) {
      return "ifDefined(" + u + "," + this.escape(m) + ")";
    },
    plus: function(u, m) {
      return "plus(" + u + "," + m + ")";
    },
    return_: function(u) {
      this.current().body.push("return ", u, ";");
    },
    if_: function(u, m, y) {
      if (u === !0)
        m();
      else {
        var f = this.current().body;
        f.push("if(", u, "){"), m(), f.push("}"), y && (f.push("else{"), y(), f.push("}"));
      }
    },
    not: function(u) {
      return "!(" + u + ")";
    },
    isNull: function(u) {
      return u + "==null";
    },
    notNull: function(u) {
      return u + "!=null";
    },
    nonComputedMember: function(u, m) {
      var y = /^[$_a-zA-Z][$_a-zA-Z0-9]*$/, f = /[^$_a-zA-Z0-9]/g;
      return y.test(m) ? u + "." + m : u + '["' + m.replace(f, this.stringEscapeFn) + '"]';
    },
    computedMember: function(u, m) {
      return u + "[" + m + "]";
    },
    member: function(u, m, y) {
      return y ? this.computedMember(u, m) : this.nonComputedMember(u, m);
    },
    getStringValue: function(u) {
      this.assign(u, "getStringValue(" + u + ")");
    },
    lazyRecurse: function(u, m, y, f, w, D) {
      var k = this;
      return function() {
        k.recurse(u, m, y, f, w, D);
      };
    },
    lazyAssign: function(u, m) {
      var y = this;
      return function() {
        y.assign(u, m);
      };
    },
    stringEscapeRegex: /[^ a-zA-Z0-9]/g,
    stringEscapeFn: function(u) {
      return "\\u" + ("0000" + u.charCodeAt(0).toString(16)).slice(-4);
    },
    escape: function(u) {
      if (nt(u))
        return "'" + u.replace(this.stringEscapeRegex, this.stringEscapeFn) + "'";
      if (yt(u))
        return u.toString();
      if (u === !0)
        return "true";
      if (u === !1)
        return "false";
      if (u === null)
        return "null";
      if (typeof u > "u")
        return "undefined";
      throw wo("esc", "IMPOSSIBLE");
    },
    nextId: function(u, m) {
      var y = "v" + this.state.nextId++;
      return u || this.current().vars.push(y + (m ? "=" + m : "")), y;
    },
    current: function() {
      return this.state[this.state.computing];
    }
  };
  function fT(u) {
    this.$filter = u;
  }
  fT.prototype = {
    compile: function(u) {
      var m = this;
      xn(u, m.$filter);
      var y, f;
      (y = gT(u)) && (f = this.recurse(y));
      var w = hT(u.body), D;
      w && (D = [], N(w, function($, E) {
        var Y = m.recurse($);
        Y.isPure = $.isPure, $.input = Y, D.push(Y), $.watchId = E;
      }));
      var k = [];
      N(u.body, function($) {
        k.push(m.recurse($.expression));
      });
      var S = u.body.length === 0 ? J : u.body.length === 1 ? k[0] : function($, E) {
        var Y;
        return N(k, function(X) {
          Y = X($, E);
        }), Y;
      };
      return f && (S.assign = function($, E, Y) {
        return f($, Y, E);
      }), D && (S.inputs = D), S;
    },
    recurse: function(u, m, y) {
      var f, w, D = this, k;
      if (u.input)
        return this.inputs(u.input, u.watchId);
      switch (u.type) {
        case te.Literal:
          return this.value(u.value, m);
        case te.UnaryExpression:
          return w = this.recurse(u.argument), this["unary" + u.operator](w, m);
        case te.BinaryExpression:
          return f = this.recurse(u.left), w = this.recurse(u.right), this["binary" + u.operator](f, w, m);
        case te.LogicalExpression:
          return f = this.recurse(u.left), w = this.recurse(u.right), this["binary" + u.operator](f, w, m);
        case te.ConditionalExpression:
          return this["ternary?:"](
            this.recurse(u.test),
            this.recurse(u.alternate),
            this.recurse(u.consequent),
            m
          );
        case te.Identifier:
          return D.identifier(u.name, m, y);
        case te.MemberExpression:
          return f = this.recurse(u.object, !1, !!y), u.computed || (w = u.property.name), u.computed && (w = this.recurse(u.property)), u.computed ? this.computedMember(f, w, m, y) : this.nonComputedMember(f, w, m, y);
        case te.CallExpression:
          return k = [], N(u.arguments, function(S) {
            k.push(D.recurse(S));
          }), u.filter && (w = this.$filter(u.callee.name)), u.filter || (w = this.recurse(u.callee, !0)), u.filter ? function(S, $, E, Y) {
            for (var X = [], z = 0; z < k.length; ++z)
              X.push(k[z](S, $, E, Y));
            var st = w.apply(void 0, X, Y);
            return m ? { context: void 0, name: void 0, value: st } : st;
          } : function(S, $, E, Y) {
            var X = w(S, $, E, Y), z;
            if (X.value != null) {
              for (var st = [], ct = 0; ct < k.length; ++ct)
                st.push(k[ct](S, $, E, Y));
              z = X.value.apply(X.context, st);
            }
            return m ? { value: z } : z;
          };
        case te.AssignmentExpression:
          return f = this.recurse(u.left, !0, 1), w = this.recurse(u.right), function(S, $, E, Y) {
            var X = f(S, $, E, Y), z = w(S, $, E, Y);
            return X.context[X.name] = z, m ? { value: z } : z;
          };
        case te.ArrayExpression:
          return k = [], N(u.elements, function(S) {
            k.push(D.recurse(S));
          }), function(S, $, E, Y) {
            for (var X = [], z = 0; z < k.length; ++z)
              X.push(k[z](S, $, E, Y));
            return m ? { value: X } : X;
          };
        case te.ObjectExpression:
          return k = [], N(u.properties, function(S) {
            S.computed ? k.push({
              key: D.recurse(S.key),
              computed: !0,
              value: D.recurse(S.value)
            }) : k.push({
              key: S.key.type === te.Identifier ? S.key.name : "" + S.key.value,
              computed: !1,
              value: D.recurse(S.value)
            });
          }), function(S, $, E, Y) {
            for (var X = {}, z = 0; z < k.length; ++z)
              k[z].computed ? X[k[z].key(S, $, E, Y)] = k[z].value(S, $, E, Y) : X[k[z].key] = k[z].value(S, $, E, Y);
            return m ? { value: X } : X;
          };
        case te.ThisExpression:
          return function(S) {
            return m ? { value: S } : S;
          };
        case te.LocalsExpression:
          return function(S, $) {
            return m ? { value: $ } : $;
          };
        case te.NGValueParameter:
          return function(S, $, E) {
            return m ? { value: E } : E;
          };
      }
    },
    "unary+": function(u, m) {
      return function(y, f, w, D) {
        var k = u(y, f, w, D);
        return tt(k) ? k = +k : k = 0, m ? { value: k } : k;
      };
    },
    "unary-": function(u, m) {
      return function(y, f, w, D) {
        var k = u(y, f, w, D);
        return tt(k) ? k = -k : k = -0, m ? { value: k } : k;
      };
    },
    "unary!": function(u, m) {
      return function(y, f, w, D) {
        var k = !u(y, f, w, D);
        return m ? { value: k } : k;
      };
    },
    "binary+": function(u, m, y) {
      return function(f, w, D, k) {
        var S = u(f, w, D, k), $ = m(f, w, D, k), E = dT(S, $);
        return y ? { value: E } : E;
      };
    },
    "binary-": function(u, m, y) {
      return function(f, w, D, k) {
        var S = u(f, w, D, k), $ = m(f, w, D, k), E = (tt(S) ? S : 0) - (tt($) ? $ : 0);
        return y ? { value: E } : E;
      };
    },
    "binary*": function(u, m, y) {
      return function(f, w, D, k) {
        var S = u(f, w, D, k) * m(f, w, D, k);
        return y ? { value: S } : S;
      };
    },
    "binary/": function(u, m, y) {
      return function(f, w, D, k) {
        var S = u(f, w, D, k) / m(f, w, D, k);
        return y ? { value: S } : S;
      };
    },
    "binary%": function(u, m, y) {
      return function(f, w, D, k) {
        var S = u(f, w, D, k) % m(f, w, D, k);
        return y ? { value: S } : S;
      };
    },
    "binary===": function(u, m, y) {
      return function(f, w, D, k) {
        var S = u(f, w, D, k) === m(f, w, D, k);
        return y ? { value: S } : S;
      };
    },
    "binary!==": function(u, m, y) {
      return function(f, w, D, k) {
        var S = u(f, w, D, k) !== m(f, w, D, k);
        return y ? { value: S } : S;
      };
    },
    "binary==": function(u, m, y) {
      return function(f, w, D, k) {
        var S = u(f, w, D, k) == m(f, w, D, k);
        return y ? { value: S } : S;
      };
    },
    "binary!=": function(u, m, y) {
      return function(f, w, D, k) {
        var S = u(f, w, D, k) != m(f, w, D, k);
        return y ? { value: S } : S;
      };
    },
    "binary<": function(u, m, y) {
      return function(f, w, D, k) {
        var S = u(f, w, D, k) < m(f, w, D, k);
        return y ? { value: S } : S;
      };
    },
    "binary>": function(u, m, y) {
      return function(f, w, D, k) {
        var S = u(f, w, D, k) > m(f, w, D, k);
        return y ? { value: S } : S;
      };
    },
    "binary<=": function(u, m, y) {
      return function(f, w, D, k) {
        var S = u(f, w, D, k) <= m(f, w, D, k);
        return y ? { value: S } : S;
      };
    },
    "binary>=": function(u, m, y) {
      return function(f, w, D, k) {
        var S = u(f, w, D, k) >= m(f, w, D, k);
        return y ? { value: S } : S;
      };
    },
    "binary&&": function(u, m, y) {
      return function(f, w, D, k) {
        var S = u(f, w, D, k) && m(f, w, D, k);
        return y ? { value: S } : S;
      };
    },
    "binary||": function(u, m, y) {
      return function(f, w, D, k) {
        var S = u(f, w, D, k) || m(f, w, D, k);
        return y ? { value: S } : S;
      };
    },
    "ternary?:": function(u, m, y, f) {
      return function(w, D, k, S) {
        var $ = u(w, D, k, S) ? m(w, D, k, S) : y(w, D, k, S);
        return f ? { value: $ } : $;
      };
    },
    value: function(u, m) {
      return function() {
        return m ? { context: void 0, name: void 0, value: u } : u;
      };
    },
    identifier: function(u, m, y) {
      return function(f, w, D, k) {
        var S = w && u in w ? w : f;
        y && y !== 1 && S && S[u] == null && (S[u] = {});
        var $ = S ? S[u] : void 0;
        return m ? { context: S, name: u, value: $ } : $;
      };
    },
    computedMember: function(u, m, y, f) {
      return function(w, D, k, S) {
        var $ = u(w, D, k, S), E, Y;
        return $ != null && (E = m(w, D, k, S), E = cT(E), f && f !== 1 && $ && !$[E] && ($[E] = {}), Y = $[E]), y ? { context: $, name: E, value: Y } : Y;
      };
    },
    nonComputedMember: function(u, m, y, f) {
      return function(w, D, k, S) {
        var $ = u(w, D, k, S);
        f && f !== 1 && $ && $[m] == null && ($[m] = {});
        var E = $?.[m];
        return y ? { context: $, name: m, value: E } : E;
      };
    },
    inputs: function(u, m) {
      return function(y, f, w, D) {
        return D ? D[m] : u(y, f, w);
      };
    }
  };
  function Rp(u, m, y) {
    this.ast = new te(u, y), this.astCompiler = y.csp ? new fT(m) : new yT(m);
  }
  Rp.prototype = {
    constructor: Rp,
    parse: function(u) {
      var m = this.getAst(u), y = this.astCompiler.compile(m.ast);
      return y.literal = D_(m.ast), y.constant = I_(m.ast), y.oneTime = m.oneTime, y;
    },
    getAst: function(u) {
      var m = !1;
      return u = u.trim(), u.charAt(0) === ":" && u.charAt(1) === ":" && (m = !0, u = u.substring(2)), {
        ast: this.ast.ast(u),
        oneTime: m
      };
    }
  };
  function Wf(u) {
    return _(u.valueOf) ? u.valueOf() : $_.call(u);
  }
  function P_() {
    var u = Ee(), m = {
      true: !0,
      false: !1,
      null: null,
      undefined: void 0
    }, y, f;
    this.addLiteral = function(w, D) {
      m[w] = D;
    }, this.setIdentifierFns = function(w, D) {
      return y = w, f = D, this;
    }, this.$get = ["$filter", function(w) {
      var D = Aa().noUnsafeEval, k = {
        csp: D,
        literals: la(m),
        isIdentifierStart: _(y) && y,
        isIdentifierContinue: _(f) && f
      };
      return S.$$getAst = $, S;
      function S(Et, Dt) {
        var Tt, Ot;
        switch (typeof Et) {
          case "string":
            if (Et = Et.trim(), Ot = Et, Tt = u[Ot], !Tt) {
              var mt = new Np(k), ft = new Rp(mt, w, k);
              Tt = ft.parse(Et), u[Ot] = ct(Tt);
            }
            return Ut(Tt, Dt);
          case "function":
            return Ut(Et, Dt);
          default:
            return Ut(J, Dt);
        }
      }
      function $(Et) {
        var Dt = new Np(k), Tt = new Rp(Dt, w, k);
        return Tt.getAst(Et).ast;
      }
      function E(Et, Dt, Tt) {
        return Et == null || Dt == null ? Et === Dt : typeof Et == "object" && (Et = Wf(Et), typeof Et == "object" && !Tt) ? !1 : Et === Dt || Et !== Et && Dt !== Dt;
      }
      function Y(Et, Dt, Tt, Ot, mt) {
        var ft = Ot.inputs, Z;
        if (ft.length === 1) {
          var q = E;
          return ft = ft[0], Et.$watch(function(Gt) {
            var Vt = ft(Gt);
            return E(Vt, q, ft.isPure) || (Z = Ot(Gt, void 0, void 0, [Vt]), q = Vt && Wf(Vt)), Z;
          }, Dt, Tt, mt);
        }
        for (var ut = [], pt = [], xt = 0, Mt = ft.length; xt < Mt; xt++)
          ut[xt] = E, pt[xt] = null;
        return Et.$watch(function(Gt) {
          for (var Vt = !1, ee = 0, Bt = ft.length; ee < Bt; ee++) {
            var re = ft[ee](Gt);
            (Vt || (Vt = !E(re, ut[ee], ft[ee].isPure))) && (pt[ee] = re, ut[ee] = re && Wf(re));
          }
          return Vt && (Z = Ot(Gt, void 0, void 0, pt)), Z;
        }, Dt, Tt, mt);
      }
      function X(Et, Dt, Tt, Ot, mt) {
        var ft = Ot.literal ? z : tt, Z, q, ut = Ot.$$intercepted || Ot, pt = Ot.$$interceptor || vt, xt = Ot.inputs && !ut.inputs;
        return kt.literal = Ot.literal, kt.constant = Ot.constant, kt.inputs = Ot.inputs, ct(kt), Z = Et.$watch(kt, Dt, Tt, mt), Z;
        function Mt() {
          ft(q) && Z();
        }
        function kt(Gt, Vt, ee, Bt) {
          return q = xt && Bt ? Bt[0] : ut(Gt, Vt, ee, Bt), ft(q) && Gt.$$postDigest(Mt), pt(q);
        }
      }
      function z(Et) {
        var Dt = !0;
        return N(Et, function(Tt) {
          tt(Tt) || (Dt = !1);
        }), Dt;
      }
      function st(Et, Dt, Tt, Ot) {
        var mt = Et.$watch(function(Z) {
          return mt(), Ot(Z);
        }, Dt, Tt);
        return mt;
      }
      function ct(Et) {
        return Et.constant ? Et.$$watchDelegate = st : Et.oneTime ? Et.$$watchDelegate = X : Et.inputs && (Et.$$watchDelegate = Y), Et;
      }
      function It(Et, Dt) {
        function Tt(Ot) {
          return Dt(Et(Ot));
        }
        return Tt.$stateful = Et.$stateful || Dt.$stateful, Tt.$$pure = Et.$$pure && Dt.$$pure, Tt;
      }
      function Ut(Et, Dt) {
        if (!Dt)
          return Et;
        Et.$$interceptor && (Dt = It(Et.$$interceptor, Dt), Et = Et.$$intercepted);
        var Tt = !1, Ot = function(ft, Z, q, ut) {
          var pt = Tt && ut ? ut[0] : Et(ft, Z, q, ut);
          return Dt(pt);
        };
        return Ot.$$intercepted = Et, Ot.$$interceptor = Dt, Ot.literal = Et.literal, Ot.oneTime = Et.oneTime, Ot.constant = Et.constant, Dt.$stateful || (Tt = !Et.inputs, Ot.inputs = Et.inputs ? Et.inputs : [Et], Dt.$$pure || (Ot.inputs = Ot.inputs.map(function(mt) {
          return mt.isPure === pT ? function(Z) {
            return mt(Z);
          } : mt;
        }))), ct(Ot);
      }
    }];
  }
  function E_() {
    var u = !0;
    this.$get = ["$rootScope", "$exceptionHandler", function(m, y) {
      return bT(function(f) {
        m.$evalAsync(f);
      }, y, u);
    }], this.errorOnUnhandledRejections = function(m) {
      return tt(m) ? (u = m, this) : u;
    };
  }
  function N_() {
    var u = !0;
    this.$get = ["$browser", "$exceptionHandler", function(m, y) {
      return bT(function(f) {
        m.defer(f);
      }, y, u);
    }], this.errorOnUnhandledRejections = function(m) {
      return tt(m) ? (u = m, this) : u;
    };
  }
  function bT(u, m, y) {
    var f = n("$q", TypeError), w = 0, D = [];
    function k() {
      return new S();
    }
    function S() {
      var q = this.promise = new $();
      this.resolve = function(ut) {
        z(q, ut);
      }, this.reject = function(ut) {
        ct(q, ut);
      }, this.notify = function(ut) {
        Ut(q, ut);
      };
    }
    function $() {
      this.$$state = { status: 0 };
    }
    et($.prototype, {
      then: function(q, ut, pt) {
        if (j(q) && j(ut) && j(pt))
          return this;
        var xt = new $();
        return this.$$state.pending = this.$$state.pending || [], this.$$state.pending.push([xt, q, ut, pt]), this.$$state.status > 0 && X(this.$$state), xt;
      },
      catch: function(q) {
        return this.then(null, q);
      },
      finally: function(q, ut) {
        return this.then(function(pt) {
          return Dt(pt, Ot, q);
        }, function(pt) {
          return Dt(pt, Et, q);
        }, ut);
      }
    });
    function E(q) {
      var ut, pt, xt;
      xt = q.pending, q.processScheduled = !1, q.pending = void 0;
      try {
        for (var Mt = 0, kt = xt.length; Mt < kt; ++Mt) {
          jf(q), pt = xt[Mt][0], ut = xt[Mt][q.status];
          try {
            _(ut) ? z(pt, ut(q.value)) : q.status === 1 ? z(pt, q.value) : ct(pt, q.value);
          } catch (Gt) {
            ct(pt, Gt), Gt && Gt.$$passToExceptionHandler === !0 && m(Gt);
          }
        }
      } finally {
        --w, y && w === 0 && u(Y);
      }
    }
    function Y() {
      for (; !w && D.length; ) {
        var q = D.shift();
        if (!vT(q)) {
          jf(q);
          var ut = "Possibly unhandled rejection: " + ed(q.value);
          K(q.value) ? m(q.value, ut) : m(ut);
        }
      }
    }
    function X(q) {
      y && !q.pending && q.status === 2 && !vT(q) && (w === 0 && D.length === 0 && u(Y), D.push(q)), !(q.processScheduled || !q.pending) && (q.processScheduled = !0, ++w, u(function() {
        E(q);
      }));
    }
    function z(q, ut) {
      q.$$state.status || (ut === q ? It(q, f(
        "qcycle",
        "Expected promise to be resolved with value other than itself '{0}'",
        ut
      )) : st(q, ut));
    }
    function st(q, ut) {
      var pt, xt = !1;
      try {
        (lt(ut) || _(ut)) && (pt = ut.then), _(pt) ? (q.$$state.status = -1, pt.call(ut, Mt, kt, Gt)) : (q.$$state.value = ut, q.$$state.status = 1, X(q.$$state));
      } catch (Vt) {
        kt(Vt);
      }
      function Mt(Vt) {
        xt || (xt = !0, st(q, Vt));
      }
      function kt(Vt) {
        xt || (xt = !0, It(q, Vt));
      }
      function Gt(Vt) {
        Ut(q, Vt);
      }
    }
    function ct(q, ut) {
      q.$$state.status || It(q, ut);
    }
    function It(q, ut) {
      q.$$state.value = ut, q.$$state.status = 2, X(q.$$state);
    }
    function Ut(q, ut) {
      var pt = q.$$state.pending;
      q.$$state.status <= 0 && pt && pt.length && u(function() {
        for (var xt, Mt, kt = 0, Gt = pt.length; kt < Gt; kt++) {
          Mt = pt[kt][0], xt = pt[kt][3];
          try {
            Ut(Mt, _(xt) ? xt(ut) : ut);
          } catch (Vt) {
            m(Vt);
          }
        }
      });
    }
    function Et(q) {
      var ut = new $();
      return ct(ut, q), ut;
    }
    function Dt(q, ut, pt) {
      var xt = null;
      try {
        _(pt) && (xt = pt());
      } catch (Mt) {
        return Et(Mt);
      }
      return qt(xt) ? xt.then(function() {
        return ut(q);
      }, Et) : ut(q);
    }
    function Tt(q, ut, pt, xt) {
      var Mt = new $();
      return z(Mt, q), Mt.then(ut, pt, xt);
    }
    var Ot = Tt;
    function mt(q) {
      var ut = new $(), pt = 0, xt = Yt(q) ? [] : {};
      return N(q, function(Mt, kt) {
        pt++, Tt(Mt).then(function(Gt) {
          xt[kt] = Gt, --pt || z(ut, xt);
        }, function(Gt) {
          ct(ut, Gt);
        });
      }), pt === 0 && z(ut, xt), ut;
    }
    function ft(q) {
      var ut = k();
      return N(q, function(pt) {
        Tt(pt).then(ut.resolve, ut.reject);
      }), ut.promise;
    }
    function Z(q) {
      if (!_(q))
        throw f("norslvr", "Expected resolverFn, got '{0}'", q);
      var ut = new $();
      function pt(Mt) {
        z(ut, Mt);
      }
      function xt(Mt) {
        ct(ut, Mt);
      }
      return q(pt, xt), ut;
    }
    return Z.prototype = $.prototype, Z.defer = k, Z.reject = Et, Z.when = Tt, Z.resolve = Ot, Z.all = mt, Z.race = ft, Z;
  }
  function vT(u) {
    return !!u.pur;
  }
  function jf(u) {
    u.pur = !0;
  }
  function xT(u) {
    u.$$state && jf(u.$$state);
  }
  function R_() {
    this.$get = ["$window", "$timeout", function(u, m) {
      var y = u.requestAnimationFrame || u.webkitRequestAnimationFrame, f = u.cancelAnimationFrame || u.webkitCancelAnimationFrame || u.webkitCancelRequestAnimationFrame, w = !!y, D = w ? function(k) {
        var S = y(k);
        return function() {
          f(S);
        };
      } : function(k) {
        var S = m(k, 16.66, !1);
        return function() {
          m.cancel(S);
        };
      };
      return D.supported = w, D;
    }];
  }
  function Y_() {
    var u = 10, m = n("$rootScope"), y = null, f = null;
    this.digestTtl = function(D) {
      return arguments.length && (u = D), u;
    };
    function w(D) {
      function k() {
        this.$$watchers = this.$$nextSibling = this.$$childHead = this.$$childTail = null, this.$$listeners = {}, this.$$listenerCount = {}, this.$$watchersCount = 0, this.$id = B(), this.$$ChildScope = null, this.$$suspended = !1;
      }
      return k.prototype = D, k;
    }
    this.$get = [
      "$exceptionHandler",
      "$parse",
      "$browser",
      function(D, k, S) {
        function $(Z) {
          Z.currentScope.$$destroyed = !0;
        }
        function E(Z) {
          d === 9 && (Z.$$childHead && E(Z.$$childHead), Z.$$nextSibling && E(Z.$$nextSibling)), Z.$parent = Z.$$nextSibling = Z.$$prevSibling = Z.$$childHead = Z.$$childTail = Z.$root = Z.$$watchers = null;
        }
        function Y() {
          this.$id = B(), this.$$phase = this.$parent = this.$$watchers = this.$$nextSibling = this.$$prevSibling = this.$$childHead = this.$$childTail = null, this.$root = this, this.$$destroyed = !1, this.$$suspended = !1, this.$$listeners = {}, this.$$listenerCount = {}, this.$$watchersCount = 0, this.$$isolateBindings = null;
        }
        Y.prototype = {
          constructor: Y,
          /**
           * @ngdoc method
           * @name $rootScope.Scope#$new
           * @kind function
           *
           * @description
           * Creates a new child {@link ng.$rootScope.Scope scope}.
           *
           * The parent scope will propagate the {@link ng.$rootScope.Scope#$digest $digest()} event.
           * The scope can be removed from the scope hierarchy using {@link ng.$rootScope.Scope#$destroy $destroy()}.
           *
           * {@link ng.$rootScope.Scope#$destroy $destroy()} must be called on a scope when it is
           * desired for the scope and its child scopes to be permanently detached from the parent and
           * thus stop participating in model change detection and listener notification by invoking.
           *
           * @param {boolean} isolate If true, then the scope does not prototypically inherit from the
           *         parent scope. The scope is isolated, as it can not see parent scope properties.
           *         When creating widgets, it is useful for the widget to not accidentally read parent
           *         state.
           *
           * @param {Scope} [parent=this] The {@link ng.$rootScope.Scope `Scope`} that will be the `$parent`
           *                              of the newly created scope. Defaults to `this` scope if not provided.
           *                              This is used when creating a transclude scope to correctly place it
           *                              in the scope hierarchy while maintaining the correct prototypical
           *                              inheritance.
           *
           * @returns {Object} The newly created child scope.
           *
           */
          $new: function(Z, q) {
            var ut;
            return q = q || this, Z ? (ut = new Y(), ut.$root = this.$root) : (this.$$ChildScope || (this.$$ChildScope = w(this)), ut = new this.$$ChildScope()), ut.$parent = q, ut.$$prevSibling = q.$$childTail, q.$$childHead ? (q.$$childTail.$$nextSibling = ut, q.$$childTail = ut) : q.$$childHead = q.$$childTail = ut, (Z || q !== this) && ut.$on("$destroy", $), ut;
          },
          /**
                 * @ngdoc method
                 * @name $rootScope.Scope#$watch
                 * @kind function
                 *
                 * @description
                 * Registers a `listener` callback to be executed whenever the `watchExpression` changes.
                 *
                 * - The `watchExpression` is called on every call to {@link ng.$rootScope.Scope#$digest
                 *   $digest()} and should return the value that will be watched. (`watchExpression` should not change
                 *   its value when executed multiple times with the same input because it may be executed multiple
                 *   times by {@link ng.$rootScope.Scope#$digest $digest()}. That is, `watchExpression` should be
                 *   [idempotent](http://en.wikipedia.org/wiki/Idempotence).)
                 * - The `listener` is called only when the value from the current `watchExpression` and the
                 *   previous call to `watchExpression` are not equal (with the exception of the initial run,
                 *   see below). Inequality is determined according to reference inequality,
                 *   [strict comparison](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Comparison_Operators)
                 *    via the `!==` Javascript operator, unless `objectEquality == true`
                 *   (see next point)
                 * - When `objectEquality == true`, inequality of the `watchExpression` is determined
                 *   according to the {@link angular.equals} function. To save the value of the object for
                 *   later comparison, the {@link angular.copy} function is used. This therefore means that
                 *   watching complex objects will have adverse memory and performance implications.
                 * - This should not be used to watch for changes in objects that are (or contain)
                 *   [File](https://developer.mozilla.org/docs/Web/API/File) objects due to limitations with {@link angular.copy `angular.copy`}.
                 * - The watch `listener` may change the model, which may trigger other `listener`s to fire.
                 *   This is achieved by rerunning the watchers until no changes are detected. The rerun
                 *   iteration limit is 10 to prevent an infinite loop deadlock.
                 *
                 *
                 * If you want to be notified whenever {@link ng.$rootScope.Scope#$digest $digest} is called,
                 * you can register a `watchExpression` function with no `listener`. (Be prepared for
                 * multiple calls to your `watchExpression` because it will execute multiple times in a
                 * single {@link ng.$rootScope.Scope#$digest $digest} cycle if a change is detected.)
                 *
                 * After a watcher is registered with the scope, the `listener` fn is called asynchronously
                 * (via {@link ng.$rootScope.Scope#$evalAsync $evalAsync}) to initialize the
                 * watcher. In rare cases, this is undesirable because the listener is called when the result
                 * of `watchExpression` didn't change. To detect this scenario within the `listener` fn, you
                 * can compare the `newVal` and `oldVal`. If these two values are identical (`===`) then the
                 * listener was called due to initialization.
                 *
                 *
                 *
                 * @example
                 * ```js
                     // let's assume that scope was dependency injected as the $rootScope
                     var scope = $rootScope;
                     scope.name = 'misko';
                     scope.counter = 0;
          
                     expect(scope.counter).toEqual(0);
                     scope.$watch('name', function(newValue, oldValue) {
                       scope.counter = scope.counter + 1;
                     });
                     expect(scope.counter).toEqual(0);
          
                     scope.$digest();
                     // the listener is always called during the first $digest loop after it was registered
                     expect(scope.counter).toEqual(1);
          
                     scope.$digest();
                     // but now it will not be called unless the value changes
                     expect(scope.counter).toEqual(1);
          
                     scope.name = 'adam';
                     scope.$digest();
                     expect(scope.counter).toEqual(2);
          
          
          
                     // Using a function as a watchExpression
                     var food;
                     scope.foodCounter = 0;
                     expect(scope.foodCounter).toEqual(0);
                     scope.$watch(
                       // This function returns the value being watched. It is called for each turn of the $digest loop
                       function() { return food; },
                       // This is the change listener, called when the value returned from the above function changes
                       function(newValue, oldValue) {
                         if ( newValue !== oldValue ) {
                           // Only increment the counter if the value changed
                           scope.foodCounter = scope.foodCounter + 1;
                         }
                       }
                     );
                     // No digest has been run so the counter will be zero
                     expect(scope.foodCounter).toEqual(0);
          
                     // Run the digest but since food has not changed count will still be zero
                     scope.$digest();
                     expect(scope.foodCounter).toEqual(0);
          
                     // Update food and run digest.  Now the counter will increment
                     food = 'cheeseburger';
                     scope.$digest();
                     expect(scope.foodCounter).toEqual(1);
          
                 * ```
                 *
                 *
                 *
                 * @param {(function()|string)} watchExpression Expression that is evaluated on each
                 *    {@link ng.$rootScope.Scope#$digest $digest} cycle. A change in the return value triggers
                 *    a call to the `listener`.
                 *
                 *    - `string`: Evaluated as {@link guide/expression expression}
                 *    - `function(scope)`: called with current `scope` as a parameter.
                 * @param {function(newVal, oldVal, scope)} listener Callback called whenever the value
                 *    of `watchExpression` changes.
                 *
                 *    - `newVal` contains the current value of the `watchExpression`
                 *    - `oldVal` contains the previous value of the `watchExpression`
                 *    - `scope` refers to the current scope
                 * @param {boolean=} [objectEquality=false] Compare for object equality using {@link angular.equals} instead of
                 *     comparing for reference equality.
                 * @returns {function()} Returns a deregistration function for this listener.
                 */
          $watch: function(Z, q, ut, pt) {
            var xt = k(Z), Mt = _(q) ? q : J;
            if (xt.$$watchDelegate)
              return xt.$$watchDelegate(this, Mt, ut, xt, Z);
            var kt = this, Gt = kt.$$watchers, Vt = {
              fn: Mt,
              last: Ot,
              get: xt,
              exp: pt || Z,
              eq: !!ut
            };
            return y = null, Gt || (Gt = kt.$$watchers = [], Gt.$$digestWatchIndex = -1), Gt.unshift(Vt), Gt.$$digestWatchIndex++, Dt(this, 1), function() {
              var Bt = _e(Gt, Vt);
              Bt >= 0 && (Dt(kt, -1), Bt < Gt.$$digestWatchIndex && Gt.$$digestWatchIndex--), y = null;
            };
          },
          /**
           * @ngdoc method
           * @name $rootScope.Scope#$watchGroup
           * @kind function
           *
           * @description
           * A variant of {@link ng.$rootScope.Scope#$watch $watch()} where it watches an array of `watchExpressions`.
           * If any one expression in the collection changes the `listener` is executed.
           *
           * - The items in the `watchExpressions` array are observed via the standard `$watch` operation. Their return
           *   values are examined for changes on every call to `$digest`.
           * - The `listener` is called whenever any expression in the `watchExpressions` array changes.
           *
           * @param {Array.<string|Function(scope)>} watchExpressions Array of expressions that will be individually
           * watched using {@link ng.$rootScope.Scope#$watch $watch()}
           *
           * @param {function(newValues, oldValues, scope)} listener Callback called whenever the return value of any
           *    expression in `watchExpressions` changes
           *    The `newValues` array contains the current values of the `watchExpressions`, with the indexes matching
           *    those of `watchExpression`
           *    and the `oldValues` array contains the previous values of the `watchExpressions`, with the indexes matching
           *    those of `watchExpression`
           *    The `scope` refers to the current scope.
           * @returns {function()} Returns a de-registration function for all listeners.
           */
          $watchGroup: function(Z, q) {
            var ut = new Array(Z.length), pt = new Array(Z.length), xt = [], Mt = this, kt = !1, Gt = !0;
            if (!Z.length) {
              var Vt = !0;
              return Mt.$evalAsync(function() {
                Vt && q(pt, pt, Mt);
              }), function() {
                Vt = !1;
              };
            }
            if (Z.length === 1)
              return this.$watch(Z[0], function(re, Le, $e) {
                pt[0] = re, ut[0] = Le, q(pt, re === Le ? pt : ut, $e);
              });
            N(Z, function(Bt, re) {
              var Le = Mt.$watch(Bt, function(Xe) {
                pt[re] = Xe, kt || (kt = !0, Mt.$evalAsync(ee));
              });
              xt.push(Le);
            });
            function ee() {
              kt = !1;
              try {
                Gt ? (Gt = !1, q(pt, pt, Mt)) : q(pt, ut, Mt);
              } finally {
                for (var Bt = 0; Bt < Z.length; Bt++)
                  ut[Bt] = pt[Bt];
              }
            }
            return function() {
              for (; xt.length; )
                xt.shift()();
            };
          },
          /**
                 * @ngdoc method
                 * @name $rootScope.Scope#$watchCollection
                 * @kind function
                 *
                 * @description
                 * Shallow watches the properties of an object and fires whenever any of the properties change
                 * (for arrays, this implies watching the array items; for object maps, this implies watching
                 * the properties). If a change is detected, the `listener` callback is fired.
                 *
                 * - The `obj` collection is observed via standard $watch operation and is examined on every
                 *   call to $digest() to see if any items have been added, removed, or moved.
                 * - The `listener` is called whenever anything within the `obj` has changed. Examples include
                 *   adding, removing, and moving items belonging to an object or array.
                 *
                 *
                 * @example
                 * ```js
                    $scope.names = ['igor', 'matias', 'misko', 'james'];
                    $scope.dataCount = 4;
          
                    $scope.$watchCollection('names', function(newNames, oldNames) {
                      $scope.dataCount = newNames.length;
                    });
          
                    expect($scope.dataCount).toEqual(4);
                    $scope.$digest();
          
                    //still at 4 ... no changes
                    expect($scope.dataCount).toEqual(4);
          
                    $scope.names.pop();
                    $scope.$digest();
          
                    //now there's been a change
                    expect($scope.dataCount).toEqual(3);
                 * ```
                 *
                 *
                 * @param {string|function(scope)} obj Evaluated as {@link guide/expression expression}. The
                 *    expression value should evaluate to an object or an array which is observed on each
                 *    {@link ng.$rootScope.Scope#$digest $digest} cycle. Any shallow change within the
                 *    collection will trigger a call to the `listener`.
                 *
                 * @param {function(newCollection, oldCollection, scope)} listener a callback function called
                 *    when a change is detected.
                 *    - The `newCollection` object is the newly modified data obtained from the `obj` expression
                 *    - The `oldCollection` object is a copy of the former collection data.
                 *      Due to performance considerations, the`oldCollection` value is computed only if the
                 *      `listener` function declares two or more arguments.
                 *    - The `scope` argument refers to the current scope.
                 *
                 * @returns {function()} Returns a de-registration function for this listener. When the
                 *    de-registration function is executed, the internal watch operation is terminated.
                 */
          $watchCollection: function(Z, q) {
            $e.$$pure = k(Z).literal, $e.$stateful = !$e.$$pure;
            var ut = this, pt, xt, Mt, kt = q.length > 1, Gt = 0, Vt = k(Z, $e), ee = [], Bt = {}, re = !0, Le = 0;
            function $e(ta) {
              pt = ta;
              var sa, ba, Qa, Ya, Dn;
              if (!j(pt)) {
                if (!lt(pt))
                  xt !== pt && (xt = pt, Gt++);
                else if (O(pt)) {
                  xt !== ee && (xt = ee, Le = xt.length = 0, Gt++), sa = pt.length, Le !== sa && (Gt++, xt.length = Le = sa);
                  for (var mn = 0; mn < sa; mn++)
                    Dn = xt[mn], Ya = pt[mn], Qa = Dn !== Dn && Ya !== Ya, !Qa && Dn !== Ya && (Gt++, xt[mn] = Ya);
                } else {
                  xt !== Bt && (xt = Bt = {}, Le = 0, Gt++), sa = 0;
                  for (ba in pt)
                    l.call(pt, ba) && (sa++, Ya = pt[ba], Dn = xt[ba], ba in xt ? (Qa = Dn !== Dn && Ya !== Ya, !Qa && Dn !== Ya && (Gt++, xt[ba] = Ya)) : (Le++, xt[ba] = Ya, Gt++));
                  if (Le > sa) {
                    Gt++;
                    for (ba in xt)
                      l.call(pt, ba) || (Le--, delete xt[ba]);
                  }
                }
                return Gt;
              }
            }
            function Xe() {
              if (re ? (re = !1, q(pt, pt, ut)) : q(pt, Mt, ut), kt)
                if (!lt(pt))
                  Mt = pt;
                else if (O(pt)) {
                  Mt = new Array(pt.length);
                  for (var ta = 0; ta < pt.length; ta++)
                    Mt[ta] = pt[ta];
                } else {
                  Mt = {};
                  for (var sa in pt)
                    l.call(pt, sa) && (Mt[sa] = pt[sa]);
                }
            }
            return this.$watch(Vt, Xe);
          },
          /**
                 * @ngdoc method
                 * @name $rootScope.Scope#$digest
                 * @kind function
                 *
                 * @description
                 * Processes all of the {@link ng.$rootScope.Scope#$watch watchers} of the current scope and
                 * its children. Because a {@link ng.$rootScope.Scope#$watch watcher}'s listener can change
                 * the model, the `$digest()` keeps calling the {@link ng.$rootScope.Scope#$watch watchers}
                 * until no more listeners are firing. This means that it is possible to get into an infinite
                 * loop. This function will throw `'Maximum iteration limit exceeded.'` if the number of
                 * iterations exceeds 10.
                 *
                 * Usually, you don't call `$digest()` directly in
                 * {@link ng.directive:ngController controllers} or in
                 * {@link ng.$compileProvider#directive directives}.
                 * Instead, you should call {@link ng.$rootScope.Scope#$apply $apply()} (typically from within
                 * a {@link ng.$compileProvider#directive directive}), which will force a `$digest()`.
                 *
                 * If you want to be notified whenever `$digest()` is called,
                 * you can register a `watchExpression` function with
                 * {@link ng.$rootScope.Scope#$watch $watch()} with no `listener`.
                 *
                 * In unit tests, you may need to call `$digest()` to simulate the scope life cycle.
                 *
                 * @example
                 * ```js
                     var scope = ...;
                     scope.name = 'misko';
                     scope.counter = 0;
          
                     expect(scope.counter).toEqual(0);
                     scope.$watch('name', function(newValue, oldValue) {
                       scope.counter = scope.counter + 1;
                     });
                     expect(scope.counter).toEqual(0);
          
                     scope.$digest();
                     // the listener is always called during the first $digest loop after it was registered
                     expect(scope.counter).toEqual(1);
          
                     scope.$digest();
                     // but now it will not be called unless the value changes
                     expect(scope.counter).toEqual(1);
          
                     scope.name = 'adam';
                     scope.$digest();
                     expect(scope.counter).toEqual(2);
                 * ```
                 *
                 */
          $digest: function() {
            var Z, q, ut, pt, xt, Mt, kt, Gt = u, Vt, ee, Bt = z.length ? X : this, re = [], Le, $e;
            Ut("$digest"), S.$$checkUrlChange(), this === X && f !== null && (S.defer.cancel(f), mt()), y = null;
            do {
              kt = !1, ee = Bt;
              for (var Xe = 0; Xe < z.length; Xe++) {
                try {
                  $e = z[Xe], pt = $e.fn, pt($e.scope, $e.locals);
                } catch (ta) {
                  D(ta);
                }
                y = null;
              }
              z.length = 0;
              t:
                do {
                  if (Mt = !ee.$$suspended && ee.$$watchers)
                    for (Mt.$$digestWatchIndex = Mt.length; Mt.$$digestWatchIndex--; )
                      try {
                        if (Z = Mt[Mt.$$digestWatchIndex], Z) {
                          if (xt = Z.get, (q = xt(ee)) !== (ut = Z.last) && !(Z.eq ? je(q, ut) : M(q) && M(ut)))
                            kt = !0, y = Z, Z.last = Z.eq ? la(q, null) : q, pt = Z.fn, pt(q, ut === Ot ? q : ut, ee), Gt < 5 && (Le = 4 - Gt, re[Le] || (re[Le] = []), re[Le].push({
                              msg: _(Z.exp) ? "fn: " + (Z.exp.name || Z.exp.toString()) : Z.exp,
                              newVal: q,
                              oldVal: ut
                            }));
                          else if (Z === y) {
                            kt = !1;
                            break t;
                          }
                        }
                      } catch (ta) {
                        D(ta);
                      }
                  if (!(Vt = !ee.$$suspended && ee.$$watchersCount && ee.$$childHead || ee !== Bt && ee.$$nextSibling))
                    for (; ee !== Bt && !(Vt = ee.$$nextSibling); )
                      ee = ee.$parent;
                } while (ee = Vt);
              if ((kt || z.length) && !Gt--)
                throw Et(), m(
                  "infdig",
                  `{0} $digest() iterations reached. Aborting!
Watchers fired in the last 5 iterations: {1}`,
                  u,
                  re
                );
            } while (kt || z.length);
            for (Et(); It < st.length; )
              try {
                st[It++]();
              } catch (ta) {
                D(ta);
              }
            st.length = It = 0, S.$$checkUrlChange();
          },
          /**
           * @ngdoc method
           * @name $rootScope.Scope#$suspend
           * @kind function
           *
           * @description
           * Suspend watchers of this scope subtree so that they will not be invoked during digest.
           *
           * This can be used to optimize your application when you know that running those watchers
           * is redundant.
           *
           * **Warning**
           *
           * Suspending scopes from the digest cycle can have unwanted and difficult to debug results.
           * Only use this approach if you are confident that you know what you are doing and have
           * ample tests to ensure that bindings get updated as you expect.
           *
           * Some of the things to consider are:
           *
           * * Any external event on a directive/component will not trigger a digest while the hosting
           *   scope is suspended - even if the event handler calls `$apply()` or `$rootScope.$digest()`.
           * * Transcluded content exists on a scope that inherits from outside a directive but exists
           *   as a child of the directive's containing scope. If the containing scope is suspended the
           *   transcluded scope will also be suspended, even if the scope from which the transcluded
           *   scope inherits is not suspended.
           * * Multiple directives trying to manage the suspended status of a scope can confuse each other:
           *    * A call to `$suspend()` on an already suspended scope is a no-op.
           *    * A call to `$resume()` on a non-suspended scope is a no-op.
           *    * If two directives suspend a scope, then one of them resumes the scope, the scope will no
           *      longer be suspended. This could result in the other directive believing a scope to be
           *      suspended when it is not.
           * * If a parent scope is suspended then all its descendants will be also excluded from future
           *   digests whether or not they have been suspended themselves. Note that this also applies to
           *   isolate child scopes.
           * * Calling `$digest()` directly on a descendant of a suspended scope will still run the watchers
           *   for that scope and its descendants. When digesting we only check whether the current scope is
           *   locally suspended, rather than checking whether it has a suspended ancestor.
           * * Calling `$resume()` on a scope that has a suspended ancestor will not cause the scope to be
           *   included in future digests until all its ancestors have been resumed.
           * * Resolved promises, e.g. from explicit `$q` deferreds and `$http` calls, trigger `$apply()`
           *   against the `$rootScope` and so will still trigger a global digest even if the promise was
           *   initiated by a component that lives on a suspended scope.
           */
          $suspend: function() {
            this.$$suspended = !0;
          },
          /**
           * @ngdoc method
           * @name $rootScope.Scope#$isSuspended
           * @kind function
           *
           * @description
           * Call this method to determine if this scope has been explicitly suspended. It will not
           * tell you whether an ancestor has been suspended.
           * To determine if this scope will be excluded from a digest triggered at the $rootScope,
           * for example, you must check all its ancestors:
           *
           * ```
           * function isExcludedFromDigest(scope) {
           *   while(scope) {
           *     if (scope.$isSuspended()) return true;
           *     scope = scope.$parent;
           *   }
           *   return false;
           * ```
           *
           * Be aware that a scope may not be included in digests if it has a suspended ancestor,
           * even if `$isSuspended()` returns false.
           *
           * @returns true if the current scope has been suspended.
           */
          $isSuspended: function() {
            return this.$$suspended;
          },
          /**
           * @ngdoc method
           * @name $rootScope.Scope#$resume
           * @kind function
           *
           * @description
           * Resume watchers of this scope subtree in case it was suspended.
           *
           * See {@link $rootScope.Scope#$suspend} for information about the dangers of using this approach.
           */
          $resume: function() {
            this.$$suspended = !1;
          },
          /**
           * @ngdoc event
           * @name $rootScope.Scope#$destroy
           * @eventType broadcast on scope being destroyed
           *
           * @description
           * Broadcasted when a scope and its children are being destroyed.
           *
           * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
           * clean up DOM bindings before an element is removed from the DOM.
           */
          /**
           * @ngdoc method
           * @name $rootScope.Scope#$destroy
           * @kind function
           *
           * @description
           * Removes the current scope (and all of its children) from the parent scope. Removal implies
           * that calls to {@link ng.$rootScope.Scope#$digest $digest()} will no longer
           * propagate to the current scope and its children. Removal also implies that the current
           * scope is eligible for garbage collection.
           *
           * The `$destroy()` is usually used by directives such as
           * {@link ng.directive:ngRepeat ngRepeat} for managing the
           * unrolling of the loop.
           *
           * Just before a scope is destroyed, a `$destroy` event is broadcasted on this scope.
           * Application code can register a `$destroy` event handler that will give it a chance to
           * perform any necessary cleanup.
           *
           * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
           * clean up DOM bindings before an element is removed from the DOM.
           */
          $destroy: function() {
            if (!this.$$destroyed) {
              var Z = this.$parent;
              this.$broadcast("$destroy"), this.$$destroyed = !0, this === X && S.$$applicationDestroyed(), Dt(this, -this.$$watchersCount);
              for (var q in this.$$listenerCount)
                Tt(this, this.$$listenerCount[q], q);
              Z && Z.$$childHead === this && (Z.$$childHead = this.$$nextSibling), Z && Z.$$childTail === this && (Z.$$childTail = this.$$prevSibling), this.$$prevSibling && (this.$$prevSibling.$$nextSibling = this.$$nextSibling), this.$$nextSibling && (this.$$nextSibling.$$prevSibling = this.$$prevSibling), this.$destroy = this.$digest = this.$apply = this.$evalAsync = this.$applyAsync = J, this.$on = this.$watch = this.$watchGroup = function() {
                return J;
              }, this.$$listeners = {}, this.$$nextSibling = null, E(this);
            }
          },
          /**
                 * @ngdoc method
                 * @name $rootScope.Scope#$eval
                 * @kind function
                 *
                 * @description
                 * Executes the `expression` on the current scope and returns the result. Any exceptions in
                 * the expression are propagated (uncaught). This is useful when evaluating AngularJS
                 * expressions.
                 *
                 * @example
                 * ```js
                     var scope = ng.$rootScope.Scope();
                     scope.a = 1;
                     scope.b = 2;
          
                     expect(scope.$eval('a+b')).toEqual(3);
                     expect(scope.$eval(function(scope){ return scope.a + scope.b; })).toEqual(3);
                 * ```
                 *
                 * @param {(string|function())=} expression An AngularJS expression to be executed.
                 *
                 *    - `string`: execute using the rules as defined in  {@link guide/expression expression}.
                 *    - `function(scope)`: execute the function with the current `scope` parameter.
                 *
                 * @param {(object)=} locals Local variables object, useful for overriding values in scope.
                 * @returns {*} The result of evaluating the expression.
                 */
          $eval: function(Z, q) {
            return k(Z)(this, q);
          },
          /**
           * @ngdoc method
           * @name $rootScope.Scope#$evalAsync
           * @kind function
           *
           * @description
           * Executes the expression on the current scope at a later point in time.
           *
           * The `$evalAsync` makes no guarantees as to when the `expression` will be executed, only
           * that:
           *
           *   - it will execute after the function that scheduled the evaluation (preferably before DOM
           *     rendering).
           *   - at least one {@link ng.$rootScope.Scope#$digest $digest cycle} will be performed after
           *     `expression` execution.
           *
           * Any exceptions from the execution of the expression are forwarded to the
           * {@link ng.$exceptionHandler $exceptionHandler} service.
           *
           * __Note:__ if this function is called outside of a `$digest` cycle, a new `$digest` cycle
           * will be scheduled. However, it is encouraged to always call code that changes the model
           * from within an `$apply` call. That includes code evaluated via `$evalAsync`.
           *
           * @param {(string|function())=} expression An AngularJS expression to be executed.
           *
           *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
           *    - `function(scope)`: execute the function with the current `scope` parameter.
           *
           * @param {(object)=} locals Local variables object, useful for overriding values in scope.
           */
          $evalAsync: function(Z, q) {
            !X.$$phase && !z.length && S.defer(function() {
              z.length && X.$digest();
            }, null, "$evalAsync"), z.push({ scope: this, fn: k(Z), locals: q });
          },
          $$postDigest: function(Z) {
            st.push(Z);
          },
          /**
           * @ngdoc method
           * @name $rootScope.Scope#$apply
           * @kind function
           *
           * @description
           * `$apply()` is used to execute an expression in AngularJS from outside of the AngularJS
           * framework. (For example from browser DOM events, setTimeout, XHR or third party libraries).
           * Because we are calling into the AngularJS framework we need to perform proper scope life
           * cycle of {@link ng.$exceptionHandler exception handling},
           * {@link ng.$rootScope.Scope#$digest executing watches}.
           *
           * **Life cycle: Pseudo-Code of `$apply()`**
           *
           * ```js
               function $apply(expr) {
                 try {
                   return $eval(expr);
                 } catch (e) {
                   $exceptionHandler(e);
                 } finally {
                   $root.$digest();
                 }
               }
           * ```
           *
           *
           * Scope's `$apply()` method transitions through the following stages:
           *
           * 1. The {@link guide/expression expression} is executed using the
           *    {@link ng.$rootScope.Scope#$eval $eval()} method.
           * 2. Any exceptions from the execution of the expression are forwarded to the
           *    {@link ng.$exceptionHandler $exceptionHandler} service.
           * 3. The {@link ng.$rootScope.Scope#$watch watch} listeners are fired immediately after the
           *    expression was executed using the {@link ng.$rootScope.Scope#$digest $digest()} method.
           *
           *
           * @param {(string|function())=} exp An AngularJS expression to be executed.
           *
           *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
           *    - `function(scope)`: execute the function with current `scope` parameter.
           *
           * @returns {*} The result of evaluating the expression.
           */
          $apply: function(Z) {
            try {
              Ut("$apply");
              try {
                return this.$eval(Z);
              } finally {
                Et();
              }
            } catch (q) {
              D(q);
            } finally {
              try {
                X.$digest();
              } catch (q) {
                throw D(q), q;
              }
            }
          },
          /**
           * @ngdoc method
           * @name $rootScope.Scope#$applyAsync
           * @kind function
           *
           * @description
           * Schedule the invocation of $apply to occur at a later time. The actual time difference
           * varies across browsers, but is typically around ~10 milliseconds.
           *
           * This can be used to queue up multiple expressions which need to be evaluated in the same
           * digest.
           *
           * @param {(string|function())=} exp An AngularJS expression to be executed.
           *
           *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
           *    - `function(scope)`: execute the function with current `scope` parameter.
           */
          $applyAsync: function(Z) {
            var q = this;
            Z && ct.push(ut), Z = k(Z), ft();
            function ut() {
              q.$eval(Z);
            }
          },
          /**
           * @ngdoc method
           * @name $rootScope.Scope#$on
           * @kind function
           *
           * @description
           * Listens on events of a given type. See {@link ng.$rootScope.Scope#$emit $emit} for
           * discussion of event life cycle.
           *
           * The event listener function format is: `function(event, args...)`. The `event` object
           * passed into the listener has the following attributes:
           *
           *   - `targetScope` - `{Scope}`: the scope on which the event was `$emit`-ed or
           *     `$broadcast`-ed.
           *   - `currentScope` - `{Scope}`: the scope that is currently handling the event. Once the
           *     event propagates through the scope hierarchy, this property is set to null.
           *   - `name` - `{string}`: name of the event.
           *   - `stopPropagation` - `{function=}`: calling `stopPropagation` function will cancel
           *     further event propagation (available only for events that were `$emit`-ed).
           *   - `preventDefault` - `{function}`: calling `preventDefault` sets `defaultPrevented` flag
           *     to true.
           *   - `defaultPrevented` - `{boolean}`: true if `preventDefault` was called.
           *
           * @param {string} name Event name to listen on.
           * @param {function(event, ...args)} listener Function to call when the event is emitted.
           * @returns {function()} Returns a deregistration function for this listener.
           */
          $on: function(Z, q) {
            var ut = this.$$listeners[Z];
            ut || (this.$$listeners[Z] = ut = []), ut.push(q);
            var pt = this;
            do
              pt.$$listenerCount[Z] || (pt.$$listenerCount[Z] = 0), pt.$$listenerCount[Z]++;
            while (pt = pt.$parent);
            var xt = this;
            return function() {
              var Mt = ut.indexOf(q);
              Mt !== -1 && (delete ut[Mt], Tt(xt, 1, Z));
            };
          },
          /**
           * @ngdoc method
           * @name $rootScope.Scope#$emit
           * @kind function
           *
           * @description
           * Dispatches an event `name` upwards through the scope hierarchy notifying the
           * registered {@link ng.$rootScope.Scope#$on} listeners.
           *
           * The event life cycle starts at the scope on which `$emit` was called. All
           * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
           * notified. Afterwards, the event traverses upwards toward the root scope and calls all
           * registered listeners along the way. The event will stop propagating if one of the listeners
           * cancels it.
           *
           * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
           * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
           *
           * @param {string} name Event name to emit.
           * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
           * @return {Object} Event object (see {@link ng.$rootScope.Scope#$on}).
           */
          $emit: function(Z, q) {
            var ut = [], pt, xt = this, Mt = !1, kt = {
              name: Z,
              targetScope: xt,
              stopPropagation: function() {
                Mt = !0;
              },
              preventDefault: function() {
                kt.defaultPrevented = !0;
              },
              defaultPrevented: !1
            }, Gt = Ka([kt], arguments, 1), Vt, ee;
            do {
              for (pt = xt.$$listeners[Z] || ut, kt.currentScope = xt, Vt = 0, ee = pt.length; Vt < ee; Vt++) {
                if (!pt[Vt]) {
                  pt.splice(Vt, 1), Vt--, ee--;
                  continue;
                }
                try {
                  pt[Vt].apply(null, Gt);
                } catch (Bt) {
                  D(Bt);
                }
              }
              if (Mt)
                break;
              xt = xt.$parent;
            } while (xt);
            return kt.currentScope = null, kt;
          },
          /**
           * @ngdoc method
           * @name $rootScope.Scope#$broadcast
           * @kind function
           *
           * @description
           * Dispatches an event `name` downwards to all child scopes (and their children) notifying the
           * registered {@link ng.$rootScope.Scope#$on} listeners.
           *
           * The event life cycle starts at the scope on which `$broadcast` was called. All
           * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
           * notified. Afterwards, the event propagates to all direct and indirect scopes of the current
           * scope and calls all registered listeners along the way. The event cannot be canceled.
           *
           * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
           * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
           *
           * @param {string} name Event name to broadcast.
           * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
           * @return {Object} Event object, see {@link ng.$rootScope.Scope#$on}
           */
          $broadcast: function(Z, q) {
            var ut = this, pt = ut, xt = ut, Mt = {
              name: Z,
              targetScope: ut,
              preventDefault: function() {
                Mt.defaultPrevented = !0;
              },
              defaultPrevented: !1
            };
            if (!ut.$$listenerCount[Z])
              return Mt;
            for (var kt = Ka([Mt], arguments, 1), Gt, Vt, ee; pt = xt; ) {
              for (Mt.currentScope = pt, Gt = pt.$$listeners[Z] || [], Vt = 0, ee = Gt.length; Vt < ee; Vt++) {
                if (!Gt[Vt]) {
                  Gt.splice(Vt, 1), Vt--, ee--;
                  continue;
                }
                try {
                  Gt[Vt].apply(null, kt);
                } catch (Bt) {
                  D(Bt);
                }
              }
              if (!(xt = pt.$$listenerCount[Z] && pt.$$childHead || pt !== ut && pt.$$nextSibling))
                for (; pt !== ut && !(xt = pt.$$nextSibling); )
                  pt = pt.$parent;
            }
            return Mt.currentScope = null, Mt;
          }
        };
        var X = new Y(), z = X.$$asyncQueue = [], st = X.$$postDigestQueue = [], ct = X.$$applyAsyncQueue = [], It = 0;
        return X;
        function Ut(Z) {
          if (X.$$phase)
            throw m("inprog", "{0} already in progress", X.$$phase);
          X.$$phase = Z;
        }
        function Et() {
          X.$$phase = null;
        }
        function Dt(Z, q) {
          do
            Z.$$watchersCount += q;
          while (Z = Z.$parent);
        }
        function Tt(Z, q, ut) {
          do
            Z.$$listenerCount[ut] -= q, Z.$$listenerCount[ut] === 0 && delete Z.$$listenerCount[ut];
          while (Z = Z.$parent);
        }
        function Ot() {
        }
        function mt() {
          for (; ct.length; )
            try {
              ct.shift()();
            } catch (Z) {
              D(Z);
            }
          f = null;
        }
        function ft() {
          f === null && (f = S.defer(function() {
            X.$apply(mt);
          }, null, "$applyAsync"));
        }
      }
    ];
  }
  function __() {
    var u = /^\s*(https?|s?ftp|mailto|tel|file):/, m = /^\s*((https?|ftp|file|blob):|data:image\/)/;
    this.aHrefSanitizationTrustedUrlList = function(y) {
      return tt(y) ? (u = y, this) : u;
    }, this.imgSrcSanitizationTrustedUrlList = function(y) {
      return tt(y) ? (m = y, this) : m;
    }, this.$get = function() {
      return function(f, w) {
        var D = w ? m : u, k = us(f && f.trim()).href;
        return k !== "" && !k.match(D) ? "unsafe:" + k : f;
      };
    };
  }
  var Lr = n("$sce"), hn = {
    // HTML is used when there's HTML rendered (e.g. ng-bind-html, iframe srcdoc binding).
    HTML: "html",
    // Style statements or stylesheets. Currently unused in AngularJS.
    CSS: "css",
    // An URL used in a context where it refers to the source of media, which are not expected to be run
    // as scripts, such as an image, audio, video, etc.
    MEDIA_URL: "mediaUrl",
    // An URL used in a context where it does not refer to a resource that loads code.
    // A value that can be trusted as a URL can also trusted as a MEDIA_URL.
    URL: "url",
    // RESOURCE_URL is a subtype of URL used where the referred-to resource could be interpreted as
    // code. (e.g. ng-include, script src binding, templateUrl)
    // A value that can be trusted as a RESOURCE_URL, can also trusted as a URL and a MEDIA_URL.
    RESOURCE_URL: "resourceUrl",
    // Script. Currently unused in AngularJS.
    JS: "js"
  }, O_ = /_([a-z])/g;
  function Vf(u) {
    return u.replace(O_, Ik);
  }
  function M_(u) {
    if (u === "self")
      return u;
    if (nt(u)) {
      if (u.indexOf("***") > -1)
        throw Lr(
          "iwcard",
          "Illegal sequence *** in string matcher.  String: {0}",
          u
        );
      return u = Ye(u).replace(/\\\*\\\*/g, ".*").replace(/\\\*/g, "[^:/.?&;]*"), new RegExp("^" + u + "$");
    } else {
      if (V(u))
        return new RegExp("^" + u.source + "$");
      throw Lr(
        "imatcher",
        'Matchers may only be "self", string patterns or RegExp objects'
      );
    }
  }
  function wT(u) {
    var m = [];
    return tt(u) && N(u, function(y) {
      m.push(M_(y));
    }), m;
  }
  function X_() {
    this.SCE_CONTEXTS = hn;
    var u = ["self"], m = [];
    this.trustedResourceUrlList = function(y) {
      return arguments.length && (u = wT(y)), u;
    }, Object.defineProperty(this, "resourceUrlWhitelist", {
      get: function() {
        return this.trustedResourceUrlList;
      },
      set: function(y) {
        this.trustedResourceUrlList = y;
      }
    }), this.bannedResourceUrlList = function(y) {
      return arguments.length && (m = wT(y)), m;
    }, Object.defineProperty(this, "resourceUrlBlacklist", {
      get: function() {
        return this.bannedResourceUrlList;
      },
      set: function(y) {
        this.bannedResourceUrlList = y;
      }
    }), this.$get = ["$injector", "$$sanitizeUri", function(y, f) {
      var w = function(ct) {
        throw Lr("unsafe", "Attempting to use an unsafe value in a safe context.");
      };
      y.has("$sanitize") && (w = y.get("$sanitize"));
      function D(st, ct) {
        return st === "self" ? K_(ct) || J_(ct) : !!st.exec(ct.href);
      }
      function k(st) {
        var ct = us(st.toString()), It, Ut, Et = !1;
        for (It = 0, Ut = u.length; It < Ut; It++)
          if (D(u[It], ct)) {
            Et = !0;
            break;
          }
        if (Et) {
          for (It = 0, Ut = m.length; It < Ut; It++)
            if (D(m[It], ct)) {
              Et = !1;
              break;
            }
        }
        return Et;
      }
      function S(st) {
        var ct = function(Ut) {
          this.$$unwrapTrustedValue = function() {
            return Ut;
          };
        };
        return st && (ct.prototype = new st()), ct.prototype.valueOf = function() {
          return this.$$unwrapTrustedValue();
        }, ct.prototype.toString = function() {
          return this.$$unwrapTrustedValue().toString();
        }, ct;
      }
      var $ = S(), E = {};
      E[hn.HTML] = S($), E[hn.CSS] = S($), E[hn.MEDIA_URL] = S($), E[hn.URL] = S(E[hn.MEDIA_URL]), E[hn.JS] = S($), E[hn.RESOURCE_URL] = S(E[hn.URL]);
      function Y(st, ct) {
        var It = E.hasOwnProperty(st) ? E[st] : null;
        if (!It)
          throw Lr(
            "icontext",
            "Attempted to trust a value in invalid context. Context: {0}; Value: {1}",
            st,
            ct
          );
        if (ct === null || j(ct) || ct === "")
          return ct;
        if (typeof ct != "string")
          throw Lr(
            "itype",
            "Attempted to trust a non-string value in a content requiring a string: Context: {0}",
            st
          );
        return new It(ct);
      }
      function X(st) {
        return st instanceof $ ? st.$$unwrapTrustedValue() : st;
      }
      function z(st, ct) {
        if (ct === null || j(ct) || ct === "")
          return ct;
        var It = E.hasOwnProperty(st) ? E[st] : null;
        if (It && ct instanceof It)
          return ct.$$unwrapTrustedValue();
        if (_(ct.$$unwrapTrustedValue) && (ct = ct.$$unwrapTrustedValue()), st === hn.MEDIA_URL || st === hn.URL)
          return f(ct.toString(), st === hn.MEDIA_URL);
        if (st === hn.RESOURCE_URL) {
          if (k(ct))
            return ct;
          throw Lr(
            "insecurl",
            "Blocked loading resource from url not allowed by $sceDelegate policy.  URL: {0}",
            ct.toString()
          );
        } else if (st === hn.HTML)
          return w(ct);
        throw Lr("unsafe", "Attempting to use an unsafe value in a safe context.");
      }
      return {
        trustAs: Y,
        getTrusted: z,
        valueOf: X
      };
    }];
  }
  function G_() {
    var u = !0;
    this.enabled = function(m) {
      return arguments.length && (u = !!m), u;
    }, this.$get = ["$parse", "$sceDelegate", function(m, y) {
      if (u && d < 8)
        throw Lr(
          "iequirks",
          "Strict Contextual Escaping does not support Internet Explorer version < 11 in quirks mode.  You can fix this by adding the text <!doctype html> to the top of your HTML document.  See http://docs.angularjs.org/api/ng.$sce for more information."
        );
      var f = Ts(hn);
      f.isEnabled = function() {
        return u;
      }, f.trustAs = y.trustAs, f.getTrusted = y.getTrusted, f.valueOf = y.valueOf, u || (f.trustAs = f.getTrusted = function(S, $) {
        return $;
      }, f.valueOf = vt), f.parseAs = function($, E) {
        var Y = m(E);
        return Y.literal && Y.constant ? Y : m(E, function(X) {
          return f.getTrusted($, X);
        });
      };
      var w = f.parseAs, D = f.getTrusted, k = f.trustAs;
      return N(hn, function(S, $) {
        var E = o($);
        f[Vf("parse_as_" + E)] = function(Y) {
          return w(S, Y);
        }, f[Vf("get_trusted_" + E)] = function(Y) {
          return D(S, Y);
        }, f[Vf("trust_as_" + E)] = function(Y) {
          return k(S, Y);
        };
      }), f;
    }];
  }
  function H_() {
    this.$get = ["$window", "$document", function(u, m) {
      var y = {}, f = u.nw && u.nw.process, w = !f && u.chrome && (u.chrome.app && u.chrome.app.runtime || !u.chrome.app && u.chrome.runtime && u.chrome.runtime.id), D = !w && u.history && u.history.pushState, k = U((/android (\d+)/.exec(o((u.navigator || {}).userAgent)) || [])[1]), S = /Boxee/i.test((u.navigator || {}).userAgent), $ = m[0] || {}, E = $.body && $.body.style, Y = !1, X = !1;
      return E && (Y = "transition" in E || "webkitTransition" in E, X = "animation" in E || "webkitAnimation" in E), {
        // Android has history.pushState, but it does not update location correctly
        // so let's not use the history API at all.
        // http://code.google.com/p/android/issues/detail?id=17471
        // https://github.com/angular/angular.js/issues/904
        // older webkit browser (533.9) on Boxee box has exactly the same problem as Android has
        // so let's not use the history API also
        // We are purposefully using `!(android < 4)` to cover the case when `android` is undefined
        history: !!(D && !(k < 4) && !S),
        hasEvent: function(z) {
          if (z === "input" && d)
            return !1;
          if (j(y[z])) {
            var st = $.createElement("div");
            y[z] = "on" + z in st;
          }
          return y[z];
        },
        csp: Aa(),
        transitions: Y,
        animations: X,
        android: k
      };
    }];
  }
  function U_() {
    this.$get = St(function(u) {
      return new F_(u);
    });
  }
  function F_(u) {
    var m = this, y = {}, f = [], w = m.ALL_TASKS_TYPE = "$$all$$", D = m.DEFAULT_TASK_TYPE = "$$default$$";
    m.completeTask = k, m.incTaskCount = Y, m.notifyWhenNoPendingTasks = X;
    function k(z, st) {
      st = st || D;
      try {
        z();
      } finally {
        S(st);
        var ct = y[st], It = y[w];
        if (!It || !ct)
          for (var Ut = It ? E : $, Et; Et = Ut(st); )
            try {
              Et();
            } catch (Dt) {
              u.error(Dt);
            }
      }
    }
    function S(z) {
      z = z || D, y[z] && (y[z]--, y[w]--);
    }
    function $() {
      var z = f.pop();
      return z && z.cb;
    }
    function E(z) {
      for (var st = f.length - 1; st >= 0; --st) {
        var ct = f[st];
        if (ct.type === z)
          return f.splice(st, 1), ct.cb;
      }
    }
    function Y(z) {
      z = z || D, y[z] = (y[z] || 0) + 1, y[w] = (y[w] || 0) + 1;
    }
    function X(z, st) {
      st = st || w, y[st] ? f.push({ type: st, cb: z }) : z();
    }
  }
  var z_ = n("$templateRequest");
  function B_() {
    var u;
    this.httpOptions = function(m) {
      return m ? (u = m, this) : u;
    }, this.$get = [
      "$exceptionHandler",
      "$templateCache",
      "$http",
      "$q",
      "$sce",
      function(m, y, f, w, D) {
        function k(S, $) {
          k.totalPendingRequests++, (!nt(S) || j(y.get(S))) && (S = D.getTrustedResourceUrl(S));
          var E = f.defaults && f.defaults.transformResponse;
          return Yt(E) ? E = E.filter(function(X) {
            return X !== Hf;
          }) : E === Hf && (E = null), f.get(S, et({
            cache: y,
            transformResponse: E
          }, u)).finally(function() {
            k.totalPendingRequests--;
          }).then(function(X) {
            return y.put(S, X.data);
          }, Y);
          function Y(X) {
            return $ || (X = z_(
              "tpload",
              "Failed to load template: {0} (HTTP status: {1} {2})",
              S,
              X.status,
              X.statusText
            ), m(X)), w.reject(X);
          }
        }
        return k.totalPendingRequests = 0, k;
      }
    ];
  }
  function W_() {
    this.$get = [
      "$rootScope",
      "$browser",
      "$location",
      function(u, m, y) {
        var f = {};
        return f.findBindings = function(w, D, k) {
          var S = w.getElementsByClassName("ng-binding"), $ = [];
          return N(S, function(E) {
            var Y = C.element(E).data("$binding");
            Y && N(Y, function(X) {
              if (k) {
                var z = new RegExp("(^|\\s)" + Ye(D) + "(\\s|\\||$)");
                z.test(X) && $.push(E);
              } else
                X.indexOf(D) !== -1 && $.push(E);
            });
          }), $;
        }, f.findModels = function(w, D, k) {
          for (var S = ["ng-", "data-ng-", "ng\\:"], $ = 0; $ < S.length; ++$) {
            var E = k ? "=" : "*=", Y = "[" + S[$] + "model" + E + '"' + D + '"]', X = w.querySelectorAll(Y);
            if (X.length)
              return X;
          }
        }, f.getLocation = function() {
          return y.url();
        }, f.setLocation = function(w) {
          w !== y.url() && (y.url(w), u.$digest());
        }, f.whenStable = function(w) {
          m.notifyWhenNoOutstandingRequests(w);
        }, f;
      }
    ];
  }
  var j_ = n("$timeout");
  function V_() {
    this.$get = [
      "$rootScope",
      "$browser",
      "$q",
      "$$q",
      "$exceptionHandler",
      function(u, m, y, f, w) {
        var D = {};
        function k(S, $, E) {
          _(S) || (E = $, $ = S, S = J);
          var Y = sn(arguments, 3), X = tt(E) && !E, z = (X ? f : y).defer(), st = z.promise, ct;
          return ct = m.defer(function() {
            try {
              z.resolve(S.apply(null, Y));
            } catch (It) {
              z.reject(It), w(It);
            } finally {
              delete D[st.$$timeoutId];
            }
            X || u.$apply();
          }, $, "$timeout"), st.$$timeoutId = ct, D[ct] = z, st;
        }
        return k.cancel = function(S) {
          if (!S)
            return !1;
          if (!S.hasOwnProperty("$$timeoutId"))
            throw j_(
              "badprom",
              "`$timeout.cancel()` called with a promise that was not generated by `$timeout()`."
            );
          if (!D.hasOwnProperty(S.$$timeoutId))
            return !1;
          var $ = S.$$timeoutId, E = D[$];
          return xT(E.promise), E.reject("canceled"), delete D[$], m.defer.cancel($);
        }, k;
      }
    ];
  }
  var Ln = s.document.createElement("a"), AT = us(s.location.href), Ao;
  Ln.href = "http://[::1]";
  var q_ = Ln.hostname === "[::1]";
  function us(u) {
    if (!nt(u))
      return u;
    var m = u;
    d && (Ln.setAttribute("href", m), m = Ln.href), Ln.setAttribute("href", m);
    var y = Ln.hostname;
    return !q_ && y.indexOf(":") > -1 && (y = "[" + y + "]"), {
      href: Ln.href,
      protocol: Ln.protocol ? Ln.protocol.replace(/:$/, "") : "",
      host: Ln.host,
      search: Ln.search ? Ln.search.replace(/^\?/, "") : "",
      hash: Ln.hash ? Ln.hash.replace(/^#/, "") : "",
      hostname: y,
      port: Ln.port,
      pathname: Ln.pathname.charAt(0) === "/" ? Ln.pathname : "/" + Ln.pathname
    };
  }
  function K_(u) {
    return qf(u, AT);
  }
  function J_(u) {
    return qf(u, Z_());
  }
  function Q_(u) {
    var m = [AT].concat(u.map(us));
    return function(f) {
      var w = us(f);
      return m.some(qf.bind(null, w));
    };
  }
  function qf(u, m) {
    return u = us(u), m = us(m), u.protocol === m.protocol && u.host === m.host;
  }
  function Z_() {
    return s.document.baseURI ? s.document.baseURI : (Ao || (Ao = s.document.createElement("a"), Ao.href = ".", Ao = Ao.cloneNode(!1)), Ao.href);
  }
  function tO() {
    this.$get = St(s);
  }
  function CT(u) {
    var m = u[0] || {}, y = {}, f = "";
    function w(k) {
      try {
        return k.cookie || "";
      } catch {
        return "";
      }
    }
    function D(k) {
      try {
        return decodeURIComponent(k);
      } catch {
        return k;
      }
    }
    return function() {
      var k, S, $, E, Y, X = w(m);
      if (X !== f)
        for (f = X, k = f.split("; "), y = {}, $ = 0; $ < k.length; $++)
          S = k[$], E = S.indexOf("="), E > 0 && (Y = D(S.substring(0, E)), j(y[Y]) && (y[Y] = D(S.substring(E + 1))));
      return y;
    };
  }
  CT.$inject = ["$document"];
  function eO() {
    this.$get = CT;
  }
  $T.$inject = ["$provide"];
  function $T(u) {
    var m = "Filter";
    function y(f, w) {
      if (lt(f)) {
        var D = {};
        return N(f, function(k, S) {
          D[S] = y(S, k);
        }), D;
      } else
        return u.factory(f + m, w);
    }
    this.register = y, this.$get = ["$injector", function(f) {
      return function(w) {
        return f.get(w + m);
      };
    }], y("currency", TT), y("date", ET), y("filter", aO), y("json", hO), y("limitTo", yO), y("lowercase", mO), y("number", LT), y("orderBy", NT), y("uppercase", gO);
  }
  function aO() {
    return function(u, m, y, f) {
      if (!O(u)) {
        if (u == null)
          return u;
        throw n("filter")("notarray", "Expected array but received: {0}", u);
      }
      f = f || "$";
      var w = Kf(m), D, k;
      switch (w) {
        case "function":
          D = m;
          break;
        case "boolean":
        case "null":
        case "number":
        case "string":
          k = !0;
        case "object":
          D = nO(m, y, f, k);
          break;
        default:
          return u;
      }
      return Array.prototype.filter.call(u, D);
    };
  }
  function nO(u, m, y, f) {
    var w = lt(u) && y in u, D;
    return m === !0 ? m = je : _(m) || (m = function(k, S) {
      return j(k) ? !1 : k === null || S === null ? k === S : lt(S) || lt(k) && !zt(k) ? !1 : (k = o("" + k), S = o("" + S), k.indexOf(S) !== -1);
    }), D = function(k) {
      return w && !lt(k) ? bl(k, u[y], m, y, !1) : bl(k, u, m, y, f);
    }, D;
  }
  function bl(u, m, y, f, w, D) {
    var k = Kf(u), S = Kf(m);
    if (S === "string" && m.charAt(0) === "!")
      return !bl(u, m.substring(1), y, f, w);
    if (Yt(u))
      return u.some(function(z) {
        return bl(z, m, y, f, w);
      });
    switch (k) {
      case "object":
        var $;
        if (w) {
          for ($ in u)
            if ($.charAt && $.charAt(0) !== "$" && bl(u[$], m, y, f, !0))
              return !0;
          return D ? !1 : bl(u, m, y, f, !1);
        } else if (S === "object") {
          for ($ in m) {
            var E = m[$];
            if (!(_(E) || j(E))) {
              var Y = $ === f, X = Y ? u : u[$];
              if (!bl(X, E, y, f, Y, Y))
                return !1;
            }
          }
          return !0;
        } else
          return y(u, m);
      case "function":
        return !1;
      default:
        return y(u, m);
    }
  }
  function Kf(u) {
    return u === null ? "null" : typeof u;
  }
  var ST = 22, kT = ".", Jf = "0";
  TT.$inject = ["$locale"];
  function TT(u) {
    var m = u.NUMBER_FORMATS;
    return function(y, f, w) {
      j(f) && (f = m.CURRENCY_SYM), j(w) && (w = m.PATTERNS[1].maxFrac);
      var D = f ? /\u00A4/g : /\s*\u00A4\s*/g;
      return y == null ? y : DT(y, m.PATTERNS[1], m.GROUP_SEP, m.DECIMAL_SEP, w).replace(D, f);
    };
  }
  LT.$inject = ["$locale"];
  function LT(u) {
    var m = u.NUMBER_FORMATS;
    return function(y, f) {
      return y == null ? y : DT(
        y,
        m.PATTERNS[0],
        m.GROUP_SEP,
        m.DECIMAL_SEP,
        f
      );
    };
  }
  function sO(u) {
    var m = 0, y, f, w, D, k;
    for ((f = u.indexOf(kT)) > -1 && (u = u.replace(kT, "")), (w = u.search(/e/i)) > 0 ? (f < 0 && (f = w), f += +u.slice(w + 1), u = u.substring(0, w)) : f < 0 && (f = u.length), w = 0; u.charAt(w) === Jf; w++)
      ;
    if (w === (k = u.length))
      y = [0], f = 1;
    else {
      for (k--; u.charAt(k) === Jf; )
        k--;
      for (f -= w, y = [], D = 0; w <= k; w++, D++)
        y[D] = +u.charAt(w);
    }
    return f > ST && (y = y.splice(0, ST - 1), m = f - 1, f = 1), { d: y, e: m, i: f };
  }
  function iO(u, m, y, f) {
    var w = u.d, D = w.length - u.i;
    m = j(m) ? Math.min(Math.max(y, D), f) : +m;
    var k = m + u.i, S = w[k];
    if (k > 0) {
      w.splice(Math.max(u.i, k));
      for (var $ = k; $ < w.length; $++)
        w[$] = 0;
    } else {
      D = Math.max(0, D), u.i = 1, w.length = Math.max(1, k = m + 1), w[0] = 0;
      for (var E = 1; E < k; E++)
        w[E] = 0;
    }
    if (S >= 5)
      if (k - 1 < 0) {
        for (var Y = 0; Y > k; Y--)
          w.unshift(0), u.i++;
        w.unshift(1), u.i++;
      } else
        w[k - 1]++;
    for (; D < Math.max(0, m); D++)
      w.push(0);
    var X = w.reduceRight(function(z, st, ct, It) {
      return st = st + z, It[ct] = st % 10, Math.floor(st / 10);
    }, 0);
    X && (w.unshift(X), u.i++);
  }
  function DT(u, m, y, f, w) {
    if (!(nt(u) || yt(u)) || isNaN(u))
      return "";
    var D = !isFinite(u), k = !1, S = Math.abs(u) + "", $ = "", E;
    if (D)
      $ = "∞";
    else {
      E = sO(S), iO(E, w, m.minFrac, m.maxFrac);
      var Y = E.d, X = E.i, z = E.e, st = [];
      for (k = Y.reduce(function(It, Ut) {
        return It && !Ut;
      }, !0); X < 0; )
        Y.unshift(0), X++;
      X > 0 ? st = Y.splice(X, Y.length) : (st = Y, Y = [0]);
      var ct = [];
      for (Y.length >= m.lgSize && ct.unshift(Y.splice(-m.lgSize, Y.length).join("")); Y.length > m.gSize; )
        ct.unshift(Y.splice(-m.gSize, Y.length).join(""));
      Y.length && ct.unshift(Y.join("")), $ = ct.join(y), st.length && ($ += f + st.join("")), z && ($ += "e+" + z);
    }
    return u < 0 && !k ? m.negPre + $ + m.negSuf : m.posPre + $ + m.posSuf;
  }
  function Yp(u, m, y, f) {
    var w = "";
    for ((u < 0 || f && u <= 0) && (f ? u = -u + 1 : (u = -u, w = "-")), u = "" + u; u.length < m; )
      u = Jf + u;
    return y && (u = u.substr(u.length - m)), w + u;
  }
  function Fn(u, m, y, f, w) {
    return y = y || 0, function(D) {
      var k = D["get" + u]();
      return (y > 0 || k > -y) && (k += y), k === 0 && y === -12 && (k = 12), Yp(k, m, f, w);
    };
  }
  function rd(u, m, y) {
    return function(f, w) {
      var D = f["get" + u](), k = (y ? "STANDALONE" : "") + (m ? "SHORT" : ""), S = c(k + u);
      return w[S][D];
    };
  }
  function rO(u, m, y) {
    var f = -1 * y, w = f >= 0 ? "+" : "";
    return w += Yp(Math[f > 0 ? "floor" : "ceil"](f / 60), 2) + Yp(Math.abs(f % 60), 2), w;
  }
  function IT(u) {
    var m = new Date(u, 0, 1).getDay();
    return new Date(u, 0, (m <= 4 ? 5 : 12) - m);
  }
  function lO(u) {
    return new Date(
      u.getFullYear(),
      u.getMonth(),
      // 4 = index of Thursday
      u.getDate() + (4 - u.getDay())
    );
  }
  function PT(u) {
    return function(m) {
      var y = IT(m.getFullYear()), f = lO(m), w = +f - +y, D = 1 + Math.round(w / 6048e5);
      return Yp(D, u);
    };
  }
  function oO(u, m) {
    return u.getHours() < 12 ? m.AMPMS[0] : m.AMPMS[1];
  }
  function Qf(u, m) {
    return u.getFullYear() <= 0 ? m.ERAS[0] : m.ERAS[1];
  }
  function cO(u, m) {
    return u.getFullYear() <= 0 ? m.ERANAMES[0] : m.ERANAMES[1];
  }
  var dO = {
    yyyy: Fn("FullYear", 4, 0, !1, !0),
    yy: Fn("FullYear", 2, 0, !0, !0),
    y: Fn("FullYear", 1, 0, !1, !0),
    MMMM: rd("Month"),
    MMM: rd("Month", !0),
    MM: Fn("Month", 2, 1),
    M: Fn("Month", 1, 1),
    LLLL: rd("Month", !1, !0),
    dd: Fn("Date", 2),
    d: Fn("Date", 1),
    HH: Fn("Hours", 2),
    H: Fn("Hours", 1),
    hh: Fn("Hours", 2, -12),
    h: Fn("Hours", 1, -12),
    mm: Fn("Minutes", 2),
    m: Fn("Minutes", 1),
    ss: Fn("Seconds", 2),
    s: Fn("Seconds", 1),
    // while ISO 8601 requires fractions to be prefixed with `.` or `,`
    // we can be just safely rely on using `sss` since we currently don't support single or two digit fractions
    sss: Fn("Milliseconds", 3),
    EEEE: rd("Day"),
    EEE: rd("Day", !0),
    a: oO,
    Z: rO,
    ww: PT(2),
    w: PT(1),
    G: Qf,
    GG: Qf,
    GGG: Qf,
    GGGG: cO
  }, uO = /((?:[^yMLdHhmsaZEwG']+)|(?:'(?:[^']|'')*')|(?:E+|y+|M+|L+|d+|H+|h+|m+|s+|a|Z|G+|w+))([\s\S]*)/, pO = /^-?\d+$/;
  ET.$inject = ["$locale"];
  function ET(u) {
    var m = /^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;
    function y(f) {
      var w;
      if (w = f.match(m)) {
        var D = /* @__PURE__ */ new Date(0), k = 0, S = 0, $ = w[8] ? D.setUTCFullYear : D.setFullYear, E = w[8] ? D.setUTCHours : D.setHours;
        w[9] && (k = U(w[9] + w[10]), S = U(w[9] + w[11])), $.call(D, U(w[1]), U(w[2]) - 1, U(w[3]));
        var Y = U(w[4] || 0) - k, X = U(w[5] || 0) - S, z = U(w[6] || 0), st = Math.round(parseFloat("0." + (w[7] || 0)) * 1e3);
        return E.call(D, Y, X, z, st), D;
      }
      return f;
    }
    return function(f, w, D) {
      var k = "", S = [], $, E;
      if (w = w || "mediumDate", w = u.DATETIME_FORMATS[w] || w, nt(f) && (f = pO.test(f) ? U(f) : y(f)), yt(f) && (f = new Date(f)), !Rt(f) || !isFinite(f.getTime()))
        return f;
      for (; w; )
        E = uO.exec(w), E ? (S = Ka(S, E, 1), w = S.pop()) : (S.push(w), w = null);
      var Y = f.getTimezoneOffset();
      return D && (Y = jc(D, Y), f = hl(f, D, !0)), N(S, function(X) {
        $ = dO[X], k += $ ? $(f, u.DATETIME_FORMATS, Y) : X === "''" ? "'" : X.replace(/(^'|'$)/g, "").replace(/''/g, "'");
      }), k;
    };
  }
  function hO() {
    return function(u, m) {
      return j(m) && (m = 2), ks(u, m);
    };
  }
  var mO = St(o), gO = St(c);
  function yO() {
    return function(u, m, y) {
      return Math.abs(Number(m)) === 1 / 0 ? m = Number(m) : m = U(m), M(m) || (yt(u) && (u = u.toString()), !O(u)) ? u : (y = !y || isNaN(y) ? 0 : U(y), y = y < 0 ? Math.max(0, u.length + y) : y, m >= 0 ? Zf(u, y, y + m) : y === 0 ? Zf(u, m, u.length) : Zf(u, Math.max(0, y + m), y));
    };
  }
  function Zf(u, m, y) {
    return nt(u) ? u.slice(m, y) : g.call(u, m, y);
  }
  NT.$inject = ["$parse"];
  function NT(u) {
    return function(k, S, $, E) {
      if (k == null)
        return k;
      if (!O(k))
        throw n("orderBy")("notarray", "Expected array but received: {0}", k);
      Yt(S) || (S = [S]), S.length === 0 && (S = ["+"]);
      var Y = m(S), X = $ ? -1 : 1, z = _(E) ? E : D, st = Array.prototype.map.call(k, ct);
      return st.sort(It), k = st.map(function(Ut) {
        return Ut.value;
      }), k;
      function ct(Ut, Et) {
        return {
          value: Ut,
          tieBreaker: { value: Et, type: "number", index: Et },
          predicateValues: Y.map(function(Dt) {
            return w(Dt.get(Ut), Et);
          })
        };
      }
      function It(Ut, Et) {
        for (var Dt = 0, Tt = Y.length; Dt < Tt; Dt++) {
          var Ot = z(Ut.predicateValues[Dt], Et.predicateValues[Dt]);
          if (Ot)
            return Ot * Y[Dt].descending * X;
        }
        return (z(Ut.tieBreaker, Et.tieBreaker) || D(Ut.tieBreaker, Et.tieBreaker)) * X;
      }
    };
    function m(k) {
      return k.map(function(S) {
        var $ = 1, E = vt;
        if (_(S))
          E = S;
        else if (nt(S) && ((S.charAt(0) === "+" || S.charAt(0) === "-") && ($ = S.charAt(0) === "-" ? -1 : 1, S = S.substring(1)), S !== "" && (E = u(S), E.constant))) {
          var Y = E();
          E = function(X) {
            return X[Y];
          };
        }
        return { get: E, descending: $ };
      });
    }
    function y(k) {
      switch (typeof k) {
        case "number":
        case "boolean":
        case "string":
          return !0;
        default:
          return !1;
      }
    }
    function f(k) {
      return _(k.valueOf) && (k = k.valueOf(), y(k)) || zt(k) && (k = k.toString(), y(k)), k;
    }
    function w(k, S) {
      var $ = typeof k;
      return k === null ? $ = "null" : $ === "object" && (k = f(k)), { value: k, type: $, index: S };
    }
    function D(k, S) {
      var $ = 0, E = k.type, Y = S.type;
      if (E === Y) {
        var X = k.value, z = S.value;
        E === "string" ? (X = X.toLowerCase(), z = z.toLowerCase()) : E === "object" && (lt(X) && (X = k.index), lt(z) && (z = S.index)), X !== z && ($ = X < z ? -1 : 1);
      } else
        $ = E === "undefined" ? 1 : Y === "undefined" ? -1 : E === "null" ? 1 : Y === "null" || E < Y ? -1 : 1;
      return $;
    }
  }
  function Co(u) {
    return _(u) && (u = {
      link: u
    }), u.restrict = u.restrict || "AC", St(u);
  }
  var fO = St({
    restrict: "E",
    compile: function(u, m) {
      if (!m.href && !m.xlinkHref)
        return function(y, f) {
          if (f[0].nodeName.toLowerCase() === "a") {
            var w = A.call(f.prop("href")) === "[object SVGAnimatedString]" ? "xlink:href" : "href";
            f.on("click", function(D) {
              f.attr(w) || D.preventDefault();
            });
          }
        };
    }
  }), _p = {};
  N(Tp, function(u, m) {
    if (u === "multiple")
      return;
    function y(D, k, S) {
      D.$watch(S[f], function(E) {
        S.$set(m, !!E);
      });
    }
    var f = di("ng-" + m), w = y;
    u === "checked" && (w = function(D, k, S) {
      S.ngModel !== S[f] && y(D, k, S);
    }), _p[f] = function() {
      return {
        restrict: "A",
        priority: 100,
        link: w
      };
    };
  }), N(Uk, function(u, m) {
    _p[m] = function() {
      return {
        priority: 100,
        link: function(y, f, w) {
          if (m === "ngPattern" && w.ngPattern.charAt(0) === "/") {
            var D = w.ngPattern.match(i);
            if (D) {
              w.$set("ngPattern", new RegExp(D[1], D[2]));
              return;
            }
          }
          y.$watch(w[m], function(S) {
            w.$set(m, S);
          });
        }
      };
    };
  }), N(["src", "srcset", "href"], function(u) {
    var m = di("ng-" + u);
    _p[m] = ["$sce", function(y) {
      return {
        priority: 99,
        // it needs to run after the attributes are interpolated
        link: function(f, w, D) {
          var k = u, S = u;
          u === "href" && A.call(w.prop("href")) === "[object SVGAnimatedString]" && (S = "xlinkHref", D.$attr[S] = "xlink:href", k = null), D.$set(m, y.getTrustedMediaUrl(D[m])), D.$observe(m, function($) {
            if (!$) {
              u === "href" && D.$set(S, null);
              return;
            }
            D.$set(S, $), d && k && w.prop(k, D[S]);
          });
        }
      };
    }];
  });
  var ld = {
    $addControl: J,
    $getControls: St([]),
    $$renameControl: bO,
    $removeControl: J,
    $setValidity: J,
    $setDirty: J,
    $setPristine: J,
    $setSubmitted: J,
    $$setSubmitted: J
  }, RT = "ng-pending", YT = "ng-submitted";
  function bO(u, m) {
    u.$name = m;
  }
  Op.$inject = ["$element", "$attrs", "$scope", "$animate", "$interpolate"];
  function Op(u, m, y, f, w) {
    this.$$controls = [], this.$error = {}, this.$$success = {}, this.$pending = void 0, this.$name = w(m.name || m.ngForm || "")(y), this.$dirty = !1, this.$pristine = !0, this.$valid = !0, this.$invalid = !1, this.$submitted = !1, this.$$parentForm = ld, this.$$element = u, this.$$animate = f, OT(this);
  }
  Op.prototype = {
    /**
     * @ngdoc method
     * @name form.FormController#$rollbackViewValue
     *
     * @description
     * Rollback all form controls pending updates to the `$modelValue`.
     *
     * Updates may be pending by a debounced event or because the input is waiting for a some future
     * event defined in `ng-model-options`. This method is typically needed by the reset button of
     * a form that uses `ng-model-options` to pend updates.
     */
    $rollbackViewValue: function() {
      N(this.$$controls, function(u) {
        u.$rollbackViewValue();
      });
    },
    /**
     * @ngdoc method
     * @name form.FormController#$commitViewValue
     *
     * @description
     * Commit all form controls pending updates to the `$modelValue`.
     *
     * Updates may be pending by a debounced event or because the input is waiting for a some future
     * event defined in `ng-model-options`. This method is rarely needed as `NgModelController`
     * usually handles calling this in response to input events.
     */
    $commitViewValue: function() {
      N(this.$$controls, function(u) {
        u.$commitViewValue();
      });
    },
    /**
     * @ngdoc method
     * @name form.FormController#$addControl
     * @param {object} control control object, either a {@link form.FormController} or an
     * {@link ngModel.NgModelController}
     *
     * @description
     * Register a control with the form. Input elements using ngModelController do this automatically
     * when they are linked.
     *
     * Note that the current state of the control will not be reflected on the new parent form. This
     * is not an issue with normal use, as freshly compiled and linked controls are in a `$pristine`
     * state.
     *
     * However, if the method is used programmatically, for example by adding dynamically created controls,
     * or controls that have been previously removed without destroying their corresponding DOM element,
     * it's the developers responsibility to make sure the current state propagates to the parent form.
     *
     * For example, if an input control is added that is already `$dirty` and has `$error` properties,
     * calling `$setDirty()` and `$validate()` afterwards will propagate the state to the parent form.
     */
    $addControl: function(u) {
      Pe(u.$name, "input"), this.$$controls.push(u), u.$name && (this[u.$name] = u), u.$$parentForm = this;
    },
    /**
     * @ngdoc method
     * @name form.FormController#$getControls
     * @returns {Array} the controls that are currently part of this form
     *
     * @description
     * This method returns a **shallow copy** of the controls that are currently part of this form.
     * The controls can be instances of {@link form.FormController `FormController`}
     * ({@link ngForm "child-forms"}) and of {@link ngModel.NgModelController `NgModelController`}.
     * If you need access to the controls of child-forms, you have to call `$getControls()`
     * recursively on them.
     * This can be used for example to iterate over all controls to validate them.
     *
     * The controls can be accessed normally, but adding to, or removing controls from the array has
     * no effect on the form. Instead, use {@link form.FormController#$addControl `$addControl()`} and
     * {@link form.FormController#$removeControl `$removeControl()`} for this use-case.
     * Likewise, adding a control to, or removing a control from the form is not reflected
     * in the shallow copy. That means you should get a fresh copy from `$getControls()` every time
     * you need access to the controls.
     */
    $getControls: function() {
      return Ts(this.$$controls);
    },
    // Private API: rename a form control
    $$renameControl: function(u, m) {
      var y = u.$name;
      this[y] === u && delete this[y], this[m] = u, u.$name = m;
    },
    /**
     * @ngdoc method
     * @name form.FormController#$removeControl
     * @param {object} control control object, either a {@link form.FormController} or an
     * {@link ngModel.NgModelController}
     *
     * @description
     * Deregister a control from the form.
     *
     * Input elements using ngModelController do this automatically when they are destroyed.
     *
     * Note that only the removed control's validation state (`$errors`etc.) will be removed from the
     * form. `$dirty`, `$submitted` states will not be changed, because the expected behavior can be
     * different from case to case. For example, removing the only `$dirty` control from a form may or
     * may not mean that the form is still `$dirty`.
     */
    $removeControl: function(u) {
      u.$name && this[u.$name] === u && delete this[u.$name], N(this.$pending, function(m, y) {
        this.$setValidity(y, null, u);
      }, this), N(this.$error, function(m, y) {
        this.$setValidity(y, null, u);
      }, this), N(this.$$success, function(m, y) {
        this.$setValidity(y, null, u);
      }, this), _e(this.$$controls, u), u.$$parentForm = ld;
    },
    /**
     * @ngdoc method
     * @name form.FormController#$setDirty
     *
     * @description
     * Sets the form to a dirty state.
     *
     * This method can be called to add the 'ng-dirty' class and set the form to a dirty
     * state (ng-dirty class). This method will also propagate to parent forms.
     */
    $setDirty: function() {
      this.$$animate.removeClass(this.$$element, So), this.$$animate.addClass(this.$$element, Xp), this.$dirty = !0, this.$pristine = !1, this.$$parentForm.$setDirty();
    },
    /**
     * @ngdoc method
     * @name form.FormController#$setPristine
     *
     * @description
     * Sets the form to its pristine state.
     *
     * This method sets the form's `$pristine` state to true, the `$dirty` state to false, removes
     * the `ng-dirty` class and adds the `ng-pristine` class. Additionally, it sets the `$submitted`
     * state to false.
     *
     * This method will also propagate to all the controls contained in this form.
     *
     * Setting a form back to a pristine state is often useful when we want to 'reuse' a form after
     * saving or resetting it.
     */
    $setPristine: function() {
      this.$$animate.setClass(this.$$element, So, Xp + " " + YT), this.$dirty = !1, this.$pristine = !0, this.$submitted = !1, N(this.$$controls, function(u) {
        u.$setPristine();
      });
    },
    /**
     * @ngdoc method
     * @name form.FormController#$setUntouched
     *
     * @description
     * Sets the form to its untouched state.
     *
     * This method can be called to remove the 'ng-touched' class and set the form controls to their
     * untouched state (ng-untouched class).
     *
     * Setting a form controls back to their untouched state is often useful when setting the form
     * back to its pristine state.
     */
    $setUntouched: function() {
      N(this.$$controls, function(u) {
        u.$setUntouched();
      });
    },
    /**
     * @ngdoc method
     * @name form.FormController#$setSubmitted
     *
     * @description
     * Sets the form to its `$submitted` state. This will also set `$submitted` on all child and
     * parent forms of the form.
     */
    $setSubmitted: function() {
      for (var u = this; u.$$parentForm && u.$$parentForm !== ld; )
        u = u.$$parentForm;
      u.$$setSubmitted();
    },
    $$setSubmitted: function() {
      this.$$animate.addClass(this.$$element, YT), this.$submitted = !0, N(this.$$controls, function(u) {
        u.$$setSubmitted && u.$$setSubmitted();
      });
    }
  }, MT({
    clazz: Op,
    set: function(u, m, y) {
      var f = u[m];
      if (!f)
        u[m] = [y];
      else {
        var w = f.indexOf(y);
        w === -1 && f.push(y);
      }
    },
    unset: function(u, m, y) {
      var f = u[m];
      f && (_e(f, y), f.length === 0 && delete u[m]);
    }
  });
  var _T = function(u) {
    return ["$timeout", "$parse", function(m, y) {
      var f = {
        name: "form",
        restrict: u ? "EAC" : "E",
        require: ["form", "^^?form"],
        //first is the form's own ctrl, second is an optional parent form
        controller: Op,
        compile: function(k, S) {
          k.addClass(So).addClass(cd);
          var $ = S.name ? "name" : u && S.ngForm ? "ngForm" : !1;
          return {
            pre: function(Y, X, z, st) {
              var ct = st[0];
              if (!("action" in z)) {
                var It = function(Dt) {
                  Y.$apply(function() {
                    ct.$commitViewValue(), ct.$setSubmitted();
                  }), Dt.preventDefault();
                };
                X[0].addEventListener("submit", It), X.on("$destroy", function() {
                  m(function() {
                    X[0].removeEventListener("submit", It);
                  }, 0, !1);
                });
              }
              var Ut = st[1] || ct.$$parentForm;
              Ut.$addControl(ct);
              var Et = $ ? w(ct.$name) : J;
              $ && (Et(Y, ct), z.$observe($, function(Dt) {
                ct.$name !== Dt && (Et(Y, void 0), ct.$$parentForm.$$renameControl(ct, Dt), Et = w(ct.$name), Et(Y, ct));
              })), X.on("$destroy", function() {
                ct.$$parentForm.$removeControl(ct), Et(Y, void 0), et(ct, ld);
              });
            }
          };
        }
      };
      return f;
      function w(D) {
        return D === "" ? y('this[""]').assign : y(D).assign || J;
      }
    }];
  }, vO = _T(), xO = _T(!0);
  function OT(u) {
    u.$$classCache = {}, u.$$classCache[QT] = !(u.$$classCache[cd] = u.$$element.hasClass(cd));
  }
  function MT(u) {
    var m = u.clazz, y = u.set, f = u.unset;
    m.prototype.$setValidity = function($, E, Y) {
      j(E) ? w(this, "$pending", $, Y) : D(this, "$pending", $, Y), _t(E) ? E ? (f(this.$error, $, Y), y(this.$$success, $, Y)) : (y(this.$error, $, Y), f(this.$$success, $, Y)) : (f(this.$error, $, Y), f(this.$$success, $, Y)), this.$pending ? (k(this, RT, !0), this.$valid = this.$invalid = void 0, S(this, "", null)) : (k(this, RT, !1), this.$valid = XT(this.$error), this.$invalid = !this.$valid, S(this, "", this.$valid));
      var X;
      this.$pending && this.$pending[$] ? X = void 0 : this.$error[$] ? X = !1 : this.$$success[$] ? X = !0 : X = null, S(this, $, X), this.$$parentForm.$setValidity($, X, this);
    };
    function w($, E, Y, X) {
      $[E] || ($[E] = {}), y($[E], Y, X);
    }
    function D($, E, Y, X) {
      $[E] && f($[E], Y, X), XT($[E]) && ($[E] = void 0);
    }
    function k($, E, Y) {
      Y && !$.$$classCache[E] ? ($.$$animate.addClass($.$$element, E), $.$$classCache[E] = !0) : !Y && $.$$classCache[E] && ($.$$animate.removeClass($.$$element, E), $.$$classCache[E] = !1);
    }
    function S($, E, Y) {
      E = E ? "-" + gp(E, "-") : "", k($, cd + E, Y === !0), k($, QT + E, Y === !1);
    }
  }
  function XT(u) {
    if (u) {
      for (var m in u)
        if (u.hasOwnProperty(m))
          return !1;
    }
    return !0;
  }
  var wO = /^\d{4,}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+(?:[+-][0-2]\d:[0-5]\d|Z)$/, AO = /^[a-z][a-z\d.+-]*:\/*(?:[^:@]+(?::[^@]+)?@)?(?:[^\s:/?#]+|\[[a-f\d:]+])(?::\d+)?(?:\/[^?#]*)?(?:\?[^#]*)?(?:#.*)?$/i, CO = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/, $O = /^\s*(-|\+)?(\d+|(\d*(\.\d*)))([eE][+-]?\d+)?\s*$/, GT = /^(\d{4,})-(\d{2})-(\d{2})$/, HT = /^(\d{4,})-(\d\d)-(\d\d)T(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/, tb = /^(\d{4,})-W(\d\d)$/, UT = /^(\d{4,})-(\d\d)$/, FT = /^(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/, SO = "keydown wheel mousedown", zT = Ee();
  N("date,datetime-local,month,time,week".split(","), function(u) {
    zT[u] = !0;
  });
  var BT = {
    /**
       * @ngdoc input
       * @name input[text]
       *
       * @description
       * Standard HTML text input with AngularJS data binding, inherited by most of the `input` elements.
       *
       *
       * @param {string} ngModel Assignable AngularJS expression to data-bind to.
       * @param {string=} name Property name of the form under which the control is published.
       * @param {string=} required Adds `required` validation error key if the value is not entered.
       * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
       *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
       *    `required` when you want to data-bind to the `required` attribute.
       * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
       *    minlength.
       * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
       *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
       *    any length.
       * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
       *    that contains the regular expression body that will be converted to a regular expression
       *    as in the ngPattern directive.
       * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
       *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
       *    If the expression evaluates to a RegExp object, then this is used directly.
       *    If the expression evaluates to a string, then it will be converted to a RegExp
       *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
       *    `new RegExp('^abc$')`.<br />
       *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
       *    start at the index of the last search's match, thus not taking the whole input value into
       *    account.
       * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
       *    interaction with the input element.
       * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
       *    This parameter is ignored for input[type=password] controls, which will never trim the
       *    input.
       *
       * @example
          <example name="text-input-directive" module="textInputExample">
            <file name="index.html">
             <script>
               angular.module('textInputExample', [])
                 .controller('ExampleController', ['$scope', function($scope) {
                   $scope.example = {
                     text: 'guest',
                     word: /^\s*\w*\s*$/
                   };
                 }]);
             <\/script>
             <form name="myForm" ng-controller="ExampleController">
               <label>Single word:
                 <input type="text" name="input" ng-model="example.text"
                        ng-pattern="example.word" required ng-trim="false">
               </label>
               <div role="alert">
                 <span class="error" ng-show="myForm.input.$error.required">
                   Required!</span>
                 <span class="error" ng-show="myForm.input.$error.pattern">
                   Single word only!</span>
               </div>
               <code>text = {{example.text}}</code><br/>
               <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br/>
               <code>myForm.input.$error = {{myForm.input.$error}}</code><br/>
               <code>myForm.$valid = {{myForm.$valid}}</code><br/>
               <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br/>
              </form>
            </file>
            <file name="protractor.js" type="protractor">
              var text = element(by.binding('example.text'));
              var valid = element(by.binding('myForm.input.$valid'));
              var input = element(by.model('example.text'));
    
              it('should initialize to model', function() {
                expect(text.getText()).toContain('guest');
                expect(valid.getText()).toContain('true');
              });
    
              it('should be invalid if empty', function() {
                input.clear();
                input.sendKeys('');
    
                expect(text.getText()).toEqual('text =');
                expect(valid.getText()).toContain('false');
              });
    
              it('should be invalid if multi word', function() {
                input.clear();
                input.sendKeys('hello world');
    
                expect(valid.getText()).toContain('false');
              });
            </file>
          </example>
       */
    text: kO,
    /**
         * @ngdoc input
         * @name input[date]
         *
         * @description
         * Input with date validation and transformation. In browsers that do not yet support
         * the HTML5 date input, a text element will be used. In that case, text must be entered in a valid ISO-8601
         * date format (yyyy-MM-dd), for example: `2009-01-06`. Since many
         * modern browsers do not yet support this input type, it is important to provide cues to users on the
         * expected input format via a placeholder or label.
         *
         * The model must always be a Date object, otherwise AngularJS will throw an error.
         * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
         *
         * The timezone to be used to read/write the `Date` instance in the model can be defined using
         * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
         *
         * @param {string} ngModel Assignable AngularJS expression to data-bind to.
         * @param {string=} name Property name of the form under which the control is published.
         * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be a
         *   valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
         *   (e.g. `min="{{minDate | date:'yyyy-MM-dd'}}"`). Note that `min` will also add native HTML5
         *   constraint validation.
         * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must be
         *   a valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
         *   (e.g. `max="{{maxDate | date:'yyyy-MM-dd'}}"`). Note that `max` will also add native HTML5
         *   constraint validation.
         * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO date string
         *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
         * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO date string
         *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
         * @param {string=} required Sets `required` validation error key if the value is not entered.
         * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
         *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
         *    `required` when you want to data-bind to the `required` attribute.
         * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
         *    interaction with the input element.
         *
         * @example
         <example name="date-input-directive" module="dateInputExample">
         <file name="index.html">
           <script>
              angular.module('dateInputExample', [])
                .controller('DateController', ['$scope', function($scope) {
                  $scope.example = {
                    value: new Date(2013, 9, 22)
                  };
                }]);
           <\/script>
           <form name="myForm" ng-controller="DateController as dateCtrl">
              <label for="exampleInput">Pick a date in 2013:</label>
              <input type="date" id="exampleInput" name="input" ng-model="example.value"
                  placeholder="yyyy-MM-dd" min="2013-01-01" max="2013-12-31" required />
              <div role="alert">
                <span class="error" ng-show="myForm.input.$error.required">
                    Required!</span>
                <span class="error" ng-show="myForm.input.$error.date">
                    Not a valid date!</span>
               </div>
               <tt>value = {{example.value | date: "yyyy-MM-dd"}}</tt><br/>
               <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
               <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
               <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
               <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
           </form>
         </file>
         <file name="protractor.js" type="protractor">
            var value = element(by.binding('example.value | date: "yyyy-MM-dd"'));
            var valid = element(by.binding('myForm.input.$valid'));
    
            // currently protractor/webdriver does not support
            // sending keys to all known HTML5 input controls
            // for various browsers (see https://github.com/angular/protractor/issues/562).
            function setInput(val) {
              // set the value of the element and force validation.
              var scr = "var ipt = document.getElementById('exampleInput'); " +
              "ipt.value = '" + val + "';" +
              "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
              browser.executeScript(scr);
            }
    
            it('should initialize to model', function() {
              expect(value.getText()).toContain('2013-10-22');
              expect(valid.getText()).toContain('myForm.input.$valid = true');
            });
    
            it('should be invalid if empty', function() {
              setInput('');
              expect(value.getText()).toEqual('value =');
              expect(valid.getText()).toContain('myForm.input.$valid = false');
            });
    
            it('should be invalid if over max', function() {
              setInput('2015-01-01');
              expect(value.getText()).toContain('');
              expect(valid.getText()).toContain('myForm.input.$valid = false');
            });
         </file>
         </example>
         */
    date: od(
      "date",
      GT,
      Mp(GT, ["yyyy", "MM", "dd"]),
      "yyyy-MM-dd"
    ),
    /**
        * @ngdoc input
        * @name input[datetime-local]
        *
        * @description
        * Input with datetime validation and transformation. In browsers that do not yet support
        * the HTML5 date input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
        * local datetime format (yyyy-MM-ddTHH:mm:ss), for example: `2010-12-28T14:57:00`.
        *
        * The model must always be a Date object, otherwise AngularJS will throw an error.
        * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
        *
        * The timezone to be used to read/write the `Date` instance in the model can be defined using
        * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
        *
        * The format of the displayed time can be adjusted with the
        * {@link ng.directive:ngModelOptions#ngModelOptions-arguments ngModelOptions} `timeSecondsFormat`
        * and `timeStripZeroSeconds`.
        *
        * @param {string} ngModel Assignable AngularJS expression to data-bind to.
        * @param {string=} name Property name of the form under which the control is published.
        * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
        *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
        *   inside this attribute (e.g. `min="{{minDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
        *   Note that `min` will also add native HTML5 constraint validation.
        * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
        *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
        *   inside this attribute (e.g. `max="{{maxDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
        *   Note that `max` will also add native HTML5 constraint validation.
        * @param {(date|string)=} ngMin Sets the `min` validation error key to the Date / ISO datetime string
        *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
        * @param {(date|string)=} ngMax Sets the `max` validation error key to the Date / ISO datetime string
        *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
        * @param {string=} required Sets `required` validation error key if the value is not entered.
        * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
        *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
        *    `required` when you want to data-bind to the `required` attribute.
        * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
        *    interaction with the input element.
        *
        * @example
        <example name="datetimelocal-input-directive" module="dateExample">
        <file name="index.html">
          <script>
            angular.module('dateExample', [])
              .controller('DateController', ['$scope', function($scope) {
                $scope.example = {
                  value: new Date(2010, 11, 28, 14, 57)
                };
              }]);
          <\/script>
          <form name="myForm" ng-controller="DateController as dateCtrl">
            <label for="exampleInput">Pick a date between in 2013:</label>
            <input type="datetime-local" id="exampleInput" name="input" ng-model="example.value"
                placeholder="yyyy-MM-ddTHH:mm:ss" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" required />
            <div role="alert">
              <span class="error" ng-show="myForm.input.$error.required">
                  Required!</span>
              <span class="error" ng-show="myForm.input.$error.datetimelocal">
                  Not a valid date!</span>
            </div>
            <tt>value = {{example.value | date: "yyyy-MM-ddTHH:mm:ss"}}</tt><br/>
            <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
            <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
            <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
            <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
          </form>
        </file>
        <file name="protractor.js" type="protractor">
          var value = element(by.binding('example.value | date: "yyyy-MM-ddTHH:mm:ss"'));
          var valid = element(by.binding('myForm.input.$valid'));
    
          // currently protractor/webdriver does not support
          // sending keys to all known HTML5 input controls
          // for various browsers (https://github.com/angular/protractor/issues/562).
          function setInput(val) {
            // set the value of the element and force validation.
            var scr = "var ipt = document.getElementById('exampleInput'); " +
            "ipt.value = '" + val + "';" +
            "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
            browser.executeScript(scr);
          }
    
          it('should initialize to model', function() {
            expect(value.getText()).toContain('2010-12-28T14:57:00');
            expect(valid.getText()).toContain('myForm.input.$valid = true');
          });
    
          it('should be invalid if empty', function() {
            setInput('');
            expect(value.getText()).toEqual('value =');
            expect(valid.getText()).toContain('myForm.input.$valid = false');
          });
    
          it('should be invalid if over max', function() {
            setInput('2015-01-01T23:59:00');
            expect(value.getText()).toContain('');
            expect(valid.getText()).toContain('myForm.input.$valid = false');
          });
        </file>
        </example>
        */
    "datetime-local": od(
      "datetimelocal",
      HT,
      Mp(HT, ["yyyy", "MM", "dd", "HH", "mm", "ss", "sss"]),
      "yyyy-MM-ddTHH:mm:ss.sss"
    ),
    /**
       * @ngdoc input
       * @name input[time]
       *
       * @description
       * Input with time validation and transformation. In browsers that do not yet support
       * the HTML5 time input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
       * local time format (HH:mm:ss), for example: `14:57:00`. Model must be a Date object. This binding will always output a
       * Date object to the model of January 1, 1970, or local date `new Date(1970, 0, 1, HH, mm, ss)`.
       *
       * The model must always be a Date object, otherwise AngularJS will throw an error.
       * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
       *
       * The timezone to be used to read/write the `Date` instance in the model can be defined using
       * {@link ng.directive:ngModelOptions#ngModelOptions-arguments ngModelOptions}. By default,
       * this is the timezone of the browser.
       *
       * The format of the displayed time can be adjusted with the
       * {@link ng.directive:ngModelOptions#ngModelOptions-arguments ngModelOptions} `timeSecondsFormat`
       * and `timeStripZeroSeconds`.
       *
       * @param {string} ngModel Assignable AngularJS expression to data-bind to.
       * @param {string=} name Property name of the form under which the control is published.
       * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
       *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
       *   attribute (e.g. `min="{{minTime | date:'HH:mm:ss'}}"`). Note that `min` will also add
       *   native HTML5 constraint validation.
       * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
       *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
       *   attribute (e.g. `max="{{maxTime | date:'HH:mm:ss'}}"`). Note that `max` will also add
       *   native HTML5 constraint validation.
       * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO time string the
       *   `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
       * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO time string the
       *   `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
       * @param {string=} required Sets `required` validation error key if the value is not entered.
       * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
       *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
       *    `required` when you want to data-bind to the `required` attribute.
       * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
       *    interaction with the input element.
       *
       * @example
       <example name="time-input-directive" module="timeExample">
       <file name="index.html">
         <script>
          angular.module('timeExample', [])
            .controller('DateController', ['$scope', function($scope) {
              $scope.example = {
                value: new Date(1970, 0, 1, 14, 57, 0)
              };
            }]);
         <\/script>
         <form name="myForm" ng-controller="DateController as dateCtrl">
            <label for="exampleInput">Pick a time between 8am and 5pm:</label>
            <input type="time" id="exampleInput" name="input" ng-model="example.value"
                placeholder="HH:mm:ss" min="08:00:00" max="17:00:00" required />
            <div role="alert">
              <span class="error" ng-show="myForm.input.$error.required">
                  Required!</span>
              <span class="error" ng-show="myForm.input.$error.time">
                  Not a valid date!</span>
            </div>
            <tt>value = {{example.value | date: "HH:mm:ss"}}</tt><br/>
            <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
            <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
            <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
            <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
         </form>
       </file>
       <file name="protractor.js" type="protractor">
          var value = element(by.binding('example.value | date: "HH:mm:ss"'));
          var valid = element(by.binding('myForm.input.$valid'));
    
          // currently protractor/webdriver does not support
          // sending keys to all known HTML5 input controls
          // for various browsers (https://github.com/angular/protractor/issues/562).
          function setInput(val) {
            // set the value of the element and force validation.
            var scr = "var ipt = document.getElementById('exampleInput'); " +
            "ipt.value = '" + val + "';" +
            "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
            browser.executeScript(scr);
          }
    
          it('should initialize to model', function() {
            expect(value.getText()).toContain('14:57:00');
            expect(valid.getText()).toContain('myForm.input.$valid = true');
          });
    
          it('should be invalid if empty', function() {
            setInput('');
            expect(value.getText()).toEqual('value =');
            expect(valid.getText()).toContain('myForm.input.$valid = false');
          });
    
          it('should be invalid if over max', function() {
            setInput('23:59:00');
            expect(value.getText()).toContain('');
            expect(valid.getText()).toContain('myForm.input.$valid = false');
          });
       </file>
       </example>
       */
    time: od(
      "time",
      FT,
      Mp(FT, ["HH", "mm", "ss", "sss"]),
      "HH:mm:ss.sss"
    ),
    /**
        * @ngdoc input
        * @name input[week]
        *
        * @description
        * Input with week-of-the-year validation and transformation to Date. In browsers that do not yet support
        * the HTML5 week input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
        * week format (yyyy-W##), for example: `2013-W02`.
        *
        * The model must always be a Date object, otherwise AngularJS will throw an error.
        * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
        *
        * The value of the resulting Date object will be set to Thursday at 00:00:00 of the requested week,
        * due to ISO-8601 week numbering standards. Information on ISO's system for numbering the weeks of the
        * year can be found at: https://en.wikipedia.org/wiki/ISO_8601#Week_dates
        *
        * The timezone to be used to read/write the `Date` instance in the model can be defined using
        * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
        *
        * @param {string} ngModel Assignable AngularJS expression to data-bind to.
        * @param {string=} name Property name of the form under which the control is published.
        * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
        *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
        *   attribute (e.g. `min="{{minWeek | date:'yyyy-Www'}}"`). Note that `min` will also add
        *   native HTML5 constraint validation.
        * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
        *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
        *   attribute (e.g. `max="{{maxWeek | date:'yyyy-Www'}}"`). Note that `max` will also add
        *   native HTML5 constraint validation.
        * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
        *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
        * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
        *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
        * @param {string=} required Sets `required` validation error key if the value is not entered.
        * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
        *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
        *    `required` when you want to data-bind to the `required` attribute.
        * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
        *    interaction with the input element.
        *
        * @example
        <example name="week-input-directive" module="weekExample">
        <file name="index.html">
          <script>
          angular.module('weekExample', [])
            .controller('DateController', ['$scope', function($scope) {
              $scope.example = {
                value: new Date(2013, 0, 3)
              };
            }]);
          <\/script>
          <form name="myForm" ng-controller="DateController as dateCtrl">
            <label>Pick a date between in 2013:
              <input id="exampleInput" type="week" name="input" ng-model="example.value"
                     placeholder="YYYY-W##" min="2012-W32"
                     max="2013-W52" required />
            </label>
            <div role="alert">
              <span class="error" ng-show="myForm.input.$error.required">
                  Required!</span>
              <span class="error" ng-show="myForm.input.$error.week">
                  Not a valid date!</span>
            </div>
            <tt>value = {{example.value | date: "yyyy-Www"}}</tt><br/>
            <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
            <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
            <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
            <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
          </form>
        </file>
        <file name="protractor.js" type="protractor">
          var value = element(by.binding('example.value | date: "yyyy-Www"'));
          var valid = element(by.binding('myForm.input.$valid'));
    
          // currently protractor/webdriver does not support
          // sending keys to all known HTML5 input controls
          // for various browsers (https://github.com/angular/protractor/issues/562).
          function setInput(val) {
            // set the value of the element and force validation.
            var scr = "var ipt = document.getElementById('exampleInput'); " +
            "ipt.value = '" + val + "';" +
            "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
            browser.executeScript(scr);
          }
    
          it('should initialize to model', function() {
            expect(value.getText()).toContain('2013-W01');
            expect(valid.getText()).toContain('myForm.input.$valid = true');
          });
    
          it('should be invalid if empty', function() {
            setInput('');
            expect(value.getText()).toEqual('value =');
            expect(valid.getText()).toContain('myForm.input.$valid = false');
          });
    
          it('should be invalid if over max', function() {
            setInput('2015-W01');
            expect(value.getText()).toContain('');
            expect(valid.getText()).toContain('myForm.input.$valid = false');
          });
        </file>
        </example>
        */
    week: od("week", tb, TO, "yyyy-Www"),
    /**
       * @ngdoc input
       * @name input[month]
       *
       * @description
       * Input with month validation and transformation. In browsers that do not yet support
       * the HTML5 month input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
       * month format (yyyy-MM), for example: `2009-01`.
       *
       * The model must always be a Date object, otherwise AngularJS will throw an error.
       * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
       * If the model is not set to the first of the month, the next view to model update will set it
       * to the first of the month.
       *
       * The timezone to be used to read/write the `Date` instance in the model can be defined using
       * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
       *
       * @param {string} ngModel Assignable AngularJS expression to data-bind to.
       * @param {string=} name Property name of the form under which the control is published.
       * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
       *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
       *   attribute (e.g. `min="{{minMonth | date:'yyyy-MM'}}"`). Note that `min` will also add
       *   native HTML5 constraint validation.
       * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
       *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
       *   attribute (e.g. `max="{{maxMonth | date:'yyyy-MM'}}"`). Note that `max` will also add
       *   native HTML5 constraint validation.
       * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
       *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
       * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
       *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
    
       * @param {string=} required Sets `required` validation error key if the value is not entered.
       * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
       *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
       *    `required` when you want to data-bind to the `required` attribute.
       * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
       *    interaction with the input element.
       *
       * @example
       <example name="month-input-directive" module="monthExample">
       <file name="index.html">
         <script>
          angular.module('monthExample', [])
            .controller('DateController', ['$scope', function($scope) {
              $scope.example = {
                value: new Date(2013, 9, 1)
              };
            }]);
         <\/script>
         <form name="myForm" ng-controller="DateController as dateCtrl">
           <label for="exampleInput">Pick a month in 2013:</label>
           <input id="exampleInput" type="month" name="input" ng-model="example.value"
              placeholder="yyyy-MM" min="2013-01" max="2013-12" required />
           <div role="alert">
             <span class="error" ng-show="myForm.input.$error.required">
                Required!</span>
             <span class="error" ng-show="myForm.input.$error.month">
                Not a valid month!</span>
           </div>
           <tt>value = {{example.value | date: "yyyy-MM"}}</tt><br/>
           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
         </form>
       </file>
       <file name="protractor.js" type="protractor">
          var value = element(by.binding('example.value | date: "yyyy-MM"'));
          var valid = element(by.binding('myForm.input.$valid'));
    
          // currently protractor/webdriver does not support
          // sending keys to all known HTML5 input controls
          // for various browsers (https://github.com/angular/protractor/issues/562).
          function setInput(val) {
            // set the value of the element and force validation.
            var scr = "var ipt = document.getElementById('exampleInput'); " +
            "ipt.value = '" + val + "';" +
            "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
            browser.executeScript(scr);
          }
    
          it('should initialize to model', function() {
            expect(value.getText()).toContain('2013-10');
            expect(valid.getText()).toContain('myForm.input.$valid = true');
          });
    
          it('should be invalid if empty', function() {
            setInput('');
            expect(value.getText()).toEqual('value =');
            expect(valid.getText()).toContain('myForm.input.$valid = false');
          });
    
          it('should be invalid if over max', function() {
            setInput('2015-01');
            expect(value.getText()).toContain('');
            expect(valid.getText()).toContain('myForm.input.$valid = false');
          });
       </file>
       </example>
       */
    month: od(
      "month",
      UT,
      Mp(UT, ["yyyy", "MM"]),
      "yyyy-MM"
    ),
    /**
       * @ngdoc input
       * @name input[number]
       *
       * @description
       * Text input with number validation and transformation. Sets the `number` validation
       * error if not a valid number.
       *
       * <div class="alert alert-warning">
       * The model must always be of type `number` otherwise AngularJS will throw an error.
       * Be aware that a string containing a number is not enough. See the {@link ngModel:numfmt}
       * error docs for more information and an example of how to convert your model if necessary.
       * </div>
       *
       *
       *
       * @knownIssue
       *
       * ### HTML5 constraint validation and `allowInvalid`
       *
       * In browsers that follow the
       * [HTML5 specification](https://html.spec.whatwg.org/multipage/forms.html#number-state-%28type=number%29),
       * `input[number]` does not work as expected with {@link ngModelOptions `ngModelOptions.allowInvalid`}.
       * If a non-number is entered in the input, the browser will report the value as an empty string,
       * which means the view / model values in `ngModel` and subsequently the scope value
       * will also be an empty string.
       *
       * @knownIssue
       *
       * ### Large numbers and `step` validation
       *
       * The `step` validation will not work correctly for very large numbers (e.g. 9999999999) due to
       * Javascript's arithmetic limitations. If you need to handle large numbers, purpose-built
       * libraries (e.g. https://github.com/MikeMcl/big.js/), can be included into AngularJS by
       * {@link guide/forms#modifying-built-in-validators overwriting the validators}
       * for `number` and / or `step`, or by {@link guide/forms#custom-validation applying custom validators}
       * to an `input[text]` element. The source for `input[number]` type can be used as a starting
       * point for both implementations.
       *
       * @param {string} ngModel Assignable AngularJS expression to data-bind to.
       * @param {string=} name Property name of the form under which the control is published.
       * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
       *    Can be interpolated.
       * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
       *    Can be interpolated.
       * @param {string=} ngMin Like `min`, sets the `min` validation error key if the value entered is less than `ngMin`,
       *    but does not trigger HTML5 native validation. Takes an expression.
       * @param {string=} ngMax Like `max`, sets the `max` validation error key if the value entered is greater than `ngMax`,
       *    but does not trigger HTML5 native validation. Takes an expression.
       * @param {string=} step Sets the `step` validation error key if the value entered does not fit the `step` constraint.
       *    Can be interpolated.
       * @param {string=} ngStep Like `step`, sets the `step` validation error key if the value entered does not fit the `ngStep` constraint,
       *    but does not trigger HTML5 native validation. Takes an expression.
       * @param {string=} required Sets `required` validation error key if the value is not entered.
       * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
       *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
       *    `required` when you want to data-bind to the `required` attribute.
       * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
       *    minlength.
       * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
       *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
       *    any length.
       * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
       *    that contains the regular expression body that will be converted to a regular expression
       *    as in the ngPattern directive.
       * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
       *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
       *    If the expression evaluates to a RegExp object, then this is used directly.
       *    If the expression evaluates to a string, then it will be converted to a RegExp
       *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
       *    `new RegExp('^abc$')`.<br />
       *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
       *    start at the index of the last search's match, thus not taking the whole input value into
       *    account.
       * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
       *    interaction with the input element.
       *
       * @example
          <example name="number-input-directive" module="numberExample">
            <file name="index.html">
             <script>
               angular.module('numberExample', [])
                 .controller('ExampleController', ['$scope', function($scope) {
                   $scope.example = {
                     value: 12
                   };
                 }]);
             <\/script>
             <form name="myForm" ng-controller="ExampleController">
               <label>Number:
                 <input type="number" name="input" ng-model="example.value"
                        min="0" max="99" required>
              </label>
               <div role="alert">
                 <span class="error" ng-show="myForm.input.$error.required">
                   Required!</span>
                 <span class="error" ng-show="myForm.input.$error.number">
                   Not valid number!</span>
               </div>
               <tt>value = {{example.value}}</tt><br/>
               <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
               <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
               <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
               <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
              </form>
            </file>
            <file name="protractor.js" type="protractor">
              var value = element(by.binding('example.value'));
              var valid = element(by.binding('myForm.input.$valid'));
              var input = element(by.model('example.value'));
    
              it('should initialize to model', function() {
                expect(value.getText()).toContain('12');
                expect(valid.getText()).toContain('true');
              });
    
              it('should be invalid if empty', function() {
                input.clear();
                input.sendKeys('');
                expect(value.getText()).toEqual('value =');
                expect(valid.getText()).toContain('false');
              });
    
              it('should be invalid if over max', function() {
                input.clear();
                input.sendKeys('123');
                expect(value.getText()).toEqual('value =');
                expect(valid.getText()).toContain('false');
              });
            </file>
          </example>
       */
    number: LO,
    /**
       * @ngdoc input
       * @name input[url]
       *
       * @description
       * Text input with URL validation. Sets the `url` validation error key if the content is not a
       * valid URL.
       *
       * <div class="alert alert-warning">
       * **Note:** `input[url]` uses a regex to validate urls that is derived from the regex
       * used in Chromium. If you need stricter validation, you can use `ng-pattern` or modify
       * the built-in validators (see the {@link guide/forms Forms guide})
       * </div>
       *
       * @param {string} ngModel Assignable AngularJS expression to data-bind to.
       * @param {string=} name Property name of the form under which the control is published.
       * @param {string=} required Sets `required` validation error key if the value is not entered.
       * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
       *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
       *    `required` when you want to data-bind to the `required` attribute.
       * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
       *    minlength.
       * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
       *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
       *    any length.
       * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
       *    that contains the regular expression body that will be converted to a regular expression
       *    as in the ngPattern directive.
       * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
       *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
       *    If the expression evaluates to a RegExp object, then this is used directly.
       *    If the expression evaluates to a string, then it will be converted to a RegExp
       *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
       *    `new RegExp('^abc$')`.<br />
       *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
       *    start at the index of the last search's match, thus not taking the whole input value into
       *    account.
       * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
       *    interaction with the input element.
       *
       * @example
          <example name="url-input-directive" module="urlExample">
            <file name="index.html">
             <script>
               angular.module('urlExample', [])
                 .controller('ExampleController', ['$scope', function($scope) {
                   $scope.url = {
                     text: 'http://google.com'
                   };
                 }]);
             <\/script>
             <form name="myForm" ng-controller="ExampleController">
               <label>URL:
                 <input type="url" name="input" ng-model="url.text" required>
               <label>
               <div role="alert">
                 <span class="error" ng-show="myForm.input.$error.required">
                   Required!</span>
                 <span class="error" ng-show="myForm.input.$error.url">
                   Not valid url!</span>
               </div>
               <tt>text = {{url.text}}</tt><br/>
               <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
               <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
               <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
               <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
               <tt>myForm.$error.url = {{!!myForm.$error.url}}</tt><br/>
              </form>
            </file>
            <file name="protractor.js" type="protractor">
              var text = element(by.binding('url.text'));
              var valid = element(by.binding('myForm.input.$valid'));
              var input = element(by.model('url.text'));
    
              it('should initialize to model', function() {
                expect(text.getText()).toContain('http://google.com');
                expect(valid.getText()).toContain('true');
              });
    
              it('should be invalid if empty', function() {
                input.clear();
                input.sendKeys('');
    
                expect(text.getText()).toEqual('text =');
                expect(valid.getText()).toContain('false');
              });
    
              it('should be invalid if not url', function() {
                input.clear();
                input.sendKeys('box');
    
                expect(valid.getText()).toContain('false');
              });
            </file>
          </example>
       */
    url: IO,
    /**
       * @ngdoc input
       * @name input[email]
       *
       * @description
       * Text input with email validation. Sets the `email` validation error key if not a valid email
       * address.
       *
       * <div class="alert alert-warning">
       * **Note:** `input[email]` uses a regex to validate email addresses that is derived from the regex
       * used in Chromium, which may not fulfill your app's requirements.
       * If you need stricter (e.g. requiring a top-level domain), or more relaxed validation
       * (e.g. allowing IPv6 address literals) you can use `ng-pattern` or
       * modify the built-in validators (see the {@link guide/forms Forms guide}).
       * </div>
       *
       * @param {string} ngModel Assignable AngularJS expression to data-bind to.
       * @param {string=} name Property name of the form under which the control is published.
       * @param {string=} required Sets `required` validation error key if the value is not entered.
       * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
       *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
       *    `required` when you want to data-bind to the `required` attribute.
       * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
       *    minlength.
       * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
       *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
       *    any length.
       * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
       *    that contains the regular expression body that will be converted to a regular expression
       *    as in the ngPattern directive.
       * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
       *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
       *    If the expression evaluates to a RegExp object, then this is used directly.
       *    If the expression evaluates to a string, then it will be converted to a RegExp
       *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
       *    `new RegExp('^abc$')`.<br />
       *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
       *    start at the index of the last search's match, thus not taking the whole input value into
       *    account.
       * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
       *    interaction with the input element.
       *
       * @example
          <example name="email-input-directive" module="emailExample">
            <file name="index.html">
             <script>
               angular.module('emailExample', [])
                 .controller('ExampleController', ['$scope', function($scope) {
                   $scope.email = {
                     text: 'me@example.com'
                   };
                 }]);
             <\/script>
               <form name="myForm" ng-controller="ExampleController">
                 <label>Email:
                   <input type="email" name="input" ng-model="email.text" required>
                 </label>
                 <div role="alert">
                   <span class="error" ng-show="myForm.input.$error.required">
                     Required!</span>
                   <span class="error" ng-show="myForm.input.$error.email">
                     Not valid email!</span>
                 </div>
                 <tt>text = {{email.text}}</tt><br/>
                 <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
                 <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
                 <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
                 <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
                 <tt>myForm.$error.email = {{!!myForm.$error.email}}</tt><br/>
               </form>
             </file>
            <file name="protractor.js" type="protractor">
              var text = element(by.binding('email.text'));
              var valid = element(by.binding('myForm.input.$valid'));
              var input = element(by.model('email.text'));
    
              it('should initialize to model', function() {
                expect(text.getText()).toContain('me@example.com');
                expect(valid.getText()).toContain('true');
              });
    
              it('should be invalid if empty', function() {
                input.clear();
                input.sendKeys('');
                expect(text.getText()).toEqual('text =');
                expect(valid.getText()).toContain('false');
              });
    
              it('should be invalid if not email', function() {
                input.clear();
                input.sendKeys('xxx');
    
                expect(valid.getText()).toContain('false');
              });
            </file>
          </example>
       */
    email: PO,
    /**
       * @ngdoc input
       * @name input[radio]
       *
       * @description
       * HTML radio button.
       *
       * **Note:**<br>
       * All inputs controlled by {@link ngModel ngModel} (including those of type `radio`) will use the
       * value of their `name` attribute to determine the property under which their
       * {@link ngModel.NgModelController NgModelController} will be published on the parent
       * {@link form.FormController FormController}. Thus, if you use the same `name` for multiple
       * inputs of a form (e.g. a group of radio inputs), only _one_ `NgModelController` will be
       * published on the parent `FormController` under that name. The rest of the controllers will
       * continue to work as expected, but you won't be able to access them as properties on the parent
       * `FormController`.
       *
       * <div class="alert alert-info">
       *   <p>
       *     In plain HTML forms, the `name` attribute is used to identify groups of radio inputs, so
       *     that the browser can manage their state (checked/unchecked) based on the state of other
       *     inputs in the same group.
       *   </p>
       *   <p>
       *     In AngularJS forms, this is not necessary. The input's state will be updated based on the
       *     value of the underlying model data.
       *   </p>
       * </div>
       *
       * <div class="alert alert-success">
       *   If you omit the `name` attribute on a radio input, `ngModel` will automatically assign it a
       *   unique name.
       * </div>
       *
       * @param {string} ngModel Assignable AngularJS expression to data-bind to.
       * @param {string} value The value to which the `ngModel` expression should be set when selected.
       *    Note that `value` only supports `string` values, i.e. the scope model needs to be a string,
       *    too. Use `ngValue` if you need complex models (`number`, `object`, ...).
       * @param {string=} name Property name of the form under which the control is published.
       * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
       *    interaction with the input element.
       * @param {string} ngValue AngularJS expression to which `ngModel` will be be set when the radio
       *    is selected. Should be used instead of the `value` attribute if you need
       *    a non-string `ngModel` (`boolean`, `array`, ...).
       *
       * @example
          <example name="radio-input-directive" module="radioExample">
            <file name="index.html">
             <script>
               angular.module('radioExample', [])
                 .controller('ExampleController', ['$scope', function($scope) {
                   $scope.color = {
                     name: 'blue'
                   };
                   $scope.specialValue = {
                     "id": "12345",
                     "value": "green"
                   };
                 }]);
             <\/script>
             <form name="myForm" ng-controller="ExampleController">
               <label>
                 <input type="radio" ng-model="color.name" value="red">
                 Red
               </label><br/>
               <label>
                 <input type="radio" ng-model="color.name" ng-value="specialValue">
                 Green
               </label><br/>
               <label>
                 <input type="radio" ng-model="color.name" value="blue">
                 Blue
               </label><br/>
               <tt>color = {{color.name | json}}</tt><br/>
              </form>
              Note that `ng-value="specialValue"` sets radio item's value to be the value of `$scope.specialValue`.
            </file>
            <file name="protractor.js" type="protractor">
              it('should change state', function() {
                var inputs = element.all(by.model('color.name'));
                var color = element(by.binding('color.name'));
    
                expect(color.getText()).toContain('blue');
    
                inputs.get(0).click();
                expect(color.getText()).toContain('red');
    
                inputs.get(1).click();
                expect(color.getText()).toContain('green');
              });
            </file>
          </example>
       */
    radio: EO,
    /**
       * @ngdoc input
       * @name input[range]
       *
       * @description
       * Native range input with validation and transformation.
       *
       * The model for the range input must always be a `Number`.
       *
       * IE9 and other browsers that do not support the `range` type fall back
       * to a text input without any default values for `min`, `max` and `step`. Model binding,
       * validation and number parsing are nevertheless supported.
       *
       * Browsers that support range (latest Chrome, Safari, Firefox, Edge) treat `input[range]`
       * in a way that never allows the input to hold an invalid value. That means:
       * - any non-numerical value is set to `(max + min) / 2`.
       * - any numerical value that is less than the current min val, or greater than the current max val
       * is set to the min / max val respectively.
       * - additionally, the current `step` is respected, so the nearest value that satisfies a step
       * is used.
       *
       * See the [HTML Spec on input[type=range]](https://www.w3.org/TR/html5/forms.html#range-state-(type=range))
       * for more info.
       *
       * This has the following consequences for AngularJS:
       *
       * Since the element value should always reflect the current model value, a range input
       * will set the bound ngModel expression to the value that the browser has set for the
       * input element. For example, in the following input `<input type="range" ng-model="model.value">`,
       * if the application sets `model.value = null`, the browser will set the input to `'50'`.
       * AngularJS will then set the model to `50`, to prevent input and model value being out of sync.
       *
       * That means the model for range will immediately be set to `50` after `ngModel` has been
       * initialized. It also means a range input can never have the required error.
       *
       * This does not only affect changes to the model value, but also to the values of the `min`,
       * `max`, and `step` attributes. When these change in a way that will cause the browser to modify
       * the input value, AngularJS will also update the model value.
       *
       * Automatic value adjustment also means that a range input element can never have the `required`,
       * `min`, or `max` errors.
       *
       * However, `step` is currently only fully implemented by Firefox. Other browsers have problems
       * when the step value changes dynamically - they do not adjust the element value correctly, but
       * instead may set the `stepMismatch` error. If that's the case, the AngularJS will set the `step`
       * error on the input, and set the model to `undefined`.
       *
       * Note that `input[range]` is not compatible with`ngMax`, `ngMin`, and `ngStep`, because they do
       * not set the `min` and `max` attributes, which means that the browser won't automatically adjust
       * the input value based on their values, and will always assume min = 0, max = 100, and step = 1.
       *
       * @param {string}  ngModel Assignable AngularJS expression to data-bind to.
       * @param {string=} name Property name of the form under which the control is published.
       * @param {string=} min Sets the `min` validation to ensure that the value entered is greater
       *                  than `min`. Can be interpolated.
       * @param {string=} max Sets the `max` validation to ensure that the value entered is less than `max`.
       *                  Can be interpolated.
       * @param {string=} step Sets the `step` validation to ensure that the value entered matches the `step`
       *                  Can be interpolated.
       * @param {expression=} ngChange AngularJS expression to be executed when the ngModel value changes due
       *                      to user interaction with the input element.
       * @param {expression=} ngChecked If the expression is truthy, then the `checked` attribute will be set on the
       *                      element. **Note** : `ngChecked` should not be used alongside `ngModel`.
       *                      Checkout {@link ng.directive:ngChecked ngChecked} for usage.
       *
       * @example
          <example name="range-input-directive" module="rangeExample">
            <file name="index.html">
              <script>
                angular.module('rangeExample', [])
                  .controller('ExampleController', ['$scope', function($scope) {
                    $scope.value = 75;
                    $scope.min = 10;
                    $scope.max = 90;
                  }]);
              <\/script>
              <form name="myForm" ng-controller="ExampleController">
    
                Model as range: <input type="range" name="range" ng-model="value" min="{{min}}"  max="{{max}}">
                <hr>
                Model as number: <input type="number" ng-model="value"><br>
                Min: <input type="number" ng-model="min"><br>
                Max: <input type="number" ng-model="max"><br>
                value = <code>{{value}}</code><br/>
                myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
                myForm.range.$error = <code>{{myForm.range.$error}}</code>
              </form>
            </file>
          </example>
    
       * ## Range Input with ngMin & ngMax attributes
    
       * @example
          <example name="range-input-directive-ng" module="rangeExample">
            <file name="index.html">
              <script>
                angular.module('rangeExample', [])
                  .controller('ExampleController', ['$scope', function($scope) {
                    $scope.value = 75;
                    $scope.min = 10;
                    $scope.max = 90;
                  }]);
              <\/script>
              <form name="myForm" ng-controller="ExampleController">
                Model as range: <input type="range" name="range" ng-model="value" ng-min="min" ng-max="max">
                <hr>
                Model as number: <input type="number" ng-model="value"><br>
                Min: <input type="number" ng-model="min"><br>
                Max: <input type="number" ng-model="max"><br>
                value = <code>{{value}}</code><br/>
                myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
                myForm.range.$error = <code>{{myForm.range.$error}}</code>
              </form>
            </file>
          </example>
    
       */
    range: DO,
    /**
       * @ngdoc input
       * @name input[checkbox]
       *
       * @description
       * HTML checkbox.
       *
       * @param {string} ngModel Assignable AngularJS expression to data-bind to.
       * @param {string=} name Property name of the form under which the control is published.
       * @param {expression=} ngTrueValue The value to which the expression should be set when selected.
       * @param {expression=} ngFalseValue The value to which the expression should be set when not selected.
       * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
       *    interaction with the input element.
       *
       * @example
          <example name="checkbox-input-directive" module="checkboxExample">
            <file name="index.html">
             <script>
               angular.module('checkboxExample', [])
                 .controller('ExampleController', ['$scope', function($scope) {
                   $scope.checkboxModel = {
                    value1 : true,
                    value2 : 'YES'
                  };
                 }]);
             <\/script>
             <form name="myForm" ng-controller="ExampleController">
               <label>Value1:
                 <input type="checkbox" ng-model="checkboxModel.value1">
               </label><br/>
               <label>Value2:
                 <input type="checkbox" ng-model="checkboxModel.value2"
                        ng-true-value="'YES'" ng-false-value="'NO'">
                </label><br/>
               <tt>value1 = {{checkboxModel.value1}}</tt><br/>
               <tt>value2 = {{checkboxModel.value2}}</tt><br/>
              </form>
            </file>
            <file name="protractor.js" type="protractor">
              it('should change state', function() {
                var value1 = element(by.binding('checkboxModel.value1'));
                var value2 = element(by.binding('checkboxModel.value2'));
    
                expect(value1.getText()).toContain('true');
                expect(value2.getText()).toContain('YES');
    
                element(by.model('checkboxModel.value1')).click();
                element(by.model('checkboxModel.value2')).click();
    
                expect(value1.getText()).toContain('false');
                expect(value2.getText()).toContain('NO');
              });
            </file>
          </example>
       */
    checkbox: NO,
    hidden: J,
    button: J,
    submit: J,
    reset: J,
    file: J
  };
  function eb(u) {
    u.$formatters.push(function(m) {
      return u.$isEmpty(m) ? m : m.toString();
    });
  }
  function kO(u, m, y, f, w, D) {
    $o(u, m, y, f, w, D), eb(f);
  }
  function $o(u, m, y, f, w, D) {
    var k = o(m[0].type);
    if (!w.android) {
      var S = !1;
      m.on("compositionstart", function() {
        S = !0;
      }), m.on("compositionupdate", function(X) {
        (j(X.data) || X.data === "") && (S = !1);
      }), m.on("compositionend", function() {
        S = !1, E();
      });
    }
    var $, E = function(X) {
      if ($ && (D.defer.cancel($), $ = null), !S) {
        var z = m.val(), st = X && X.type;
        k !== "password" && (!y.ngTrim || y.ngTrim !== "false") && (z = oe(z)), (f.$viewValue !== z || z === "" && f.$$hasNativeValidators) && f.$setViewValue(z, st);
      }
    };
    if (w.hasEvent("input"))
      m.on("input", E);
    else {
      var Y = function(X, z, st) {
        $ || ($ = D.defer(function() {
          $ = null, (!z || z.value !== st) && E(X);
        }));
      };
      m.on(
        "keydown",
        /** @this */
        function(X) {
          var z = X.keyCode;
          z === 91 || 15 < z && z < 19 || 37 <= z && z <= 40 || Y(X, this, this.value);
        }
      ), w.hasEvent("paste") && m.on("paste cut drop", Y);
    }
    m.on("change", E), zT[k] && f.$$hasNativeValidators && k === y.type && m.on(
      SO,
      /** @this */
      function(X) {
        if (!$) {
          var z = this[r], st = z.badInput, ct = z.typeMismatch;
          $ = D.defer(function() {
            $ = null, (z.badInput !== st || z.typeMismatch !== ct) && E(X);
          });
        }
      }
    ), f.$render = function() {
      var X = f.$isEmpty(f.$viewValue) ? "" : f.$viewValue;
      m.val() !== X && m.val(X);
    };
  }
  function TO(u, m) {
    if (Rt(u))
      return u;
    if (nt(u)) {
      tb.lastIndex = 0;
      var y = tb.exec(u);
      if (y) {
        var f = +y[1], w = +y[2], D = 0, k = 0, S = 0, $ = 0, E = IT(f), Y = (w - 1) * 7;
        return m && (D = m.getHours(), k = m.getMinutes(), S = m.getSeconds(), $ = m.getMilliseconds()), new Date(f, 0, E.getDate() + Y, D, k, S, $);
      }
    }
    return NaN;
  }
  function Mp(u, m) {
    return function(y, f) {
      var w, D;
      if (Rt(y))
        return y;
      if (nt(y)) {
        if (y.charAt(0) === '"' && y.charAt(y.length - 1) === '"' && (y = y.substring(1, y.length - 1)), wO.test(y))
          return new Date(y);
        if (u.lastIndex = 0, w = u.exec(y), w) {
          w.shift(), f ? D = {
            yyyy: f.getFullYear(),
            MM: f.getMonth() + 1,
            dd: f.getDate(),
            HH: f.getHours(),
            mm: f.getMinutes(),
            ss: f.getSeconds(),
            sss: f.getMilliseconds() / 1e3
          } : D = { yyyy: 1970, MM: 1, dd: 1, HH: 0, mm: 0, ss: 0, sss: 0 }, N(w, function(S, $) {
            $ < m.length && (D[m[$]] = +S);
          });
          var k = new Date(D.yyyy, D.MM - 1, D.dd, D.HH, D.mm, D.ss || 0, D.sss * 1e3 || 0);
          return D.yyyy < 100 && k.setFullYear(D.yyyy), k;
        }
      }
      return NaN;
    };
  }
  function od(u, m, y, f) {
    return function(D, k, S, $, E, Y, X, z) {
      ab(D, k, S, $, u), $o(D, k, S, $, E, Y);
      var st = u === "time" || u === "datetimelocal", ct, It;
      if ($.$parsers.push(function(q) {
        if ($.$isEmpty(q))
          return null;
        if (m.test(q))
          return ft(q, ct);
        $.$$parserName = u;
      }), $.$formatters.push(function(q) {
        if (q && !Rt(q))
          throw dd("datefmt", "Expected `{0}` to be a date", q);
        if (Ot(q)) {
          ct = q;
          var ut = $.$options.getOption("timezone");
          return ut && (It = ut, ct = hl(ct, ut, !0)), Z(q, ut);
        } else
          return ct = null, It = null, "";
      }), tt(S.min) || S.ngMin) {
        var Ut = S.min || z(S.ngMin)(D), Et = mt(Ut);
        $.$validators.min = function(q) {
          return !Ot(q) || j(Et) || y(q) >= Et;
        }, S.$observe("min", function(q) {
          q !== Ut && (Et = mt(q), Ut = q, $.$validate());
        });
      }
      if (tt(S.max) || S.ngMax) {
        var Dt = S.max || z(S.ngMax)(D), Tt = mt(Dt);
        $.$validators.max = function(q) {
          return !Ot(q) || j(Tt) || y(q) <= Tt;
        }, S.$observe("max", function(q) {
          q !== Dt && (Tt = mt(q), Dt = q, $.$validate());
        });
      }
      function Ot(q) {
        return q && !(q.getTime && q.getTime() !== q.getTime());
      }
      function mt(q) {
        return tt(q) && !Rt(q) ? ft(q) || void 0 : q;
      }
      function ft(q, ut) {
        var pt = $.$options.getOption("timezone");
        It && It !== pt && (ut = Vc(ut, jc(It)));
        var xt = y(q, ut);
        return !isNaN(xt) && pt && (xt = hl(xt, pt)), xt;
      }
      function Z(q, ut) {
        var pt = f;
        st && nt($.$options.getOption("timeSecondsFormat")) && (pt = f.replace("ss.sss", $.$options.getOption("timeSecondsFormat")).replace(/:$/, ""));
        var xt = X("date")(q, pt, ut);
        return st && $.$options.getOption("timeStripZeroSeconds") && (xt = xt.replace(/(?::00)?(?:\.000)?$/, "")), xt;
      }
    };
  }
  function ab(u, m, y, f, w) {
    var D = m[0], k = f.$$hasNativeValidators = lt(D.validity);
    k && f.$parsers.push(function(S) {
      var $ = m.prop(r) || {};
      if ($.badInput || $.typeMismatch) {
        f.$$parserName = w;
        return;
      }
      return S;
    });
  }
  function WT(u) {
    u.$parsers.push(function(m) {
      if (u.$isEmpty(m))
        return null;
      if ($O.test(m))
        return parseFloat(m);
      u.$$parserName = "number";
    }), u.$formatters.push(function(m) {
      if (!u.$isEmpty(m)) {
        if (!yt(m))
          throw dd("numfmt", "Expected `{0}` to be a number", m);
        m = m.toString();
      }
      return m;
    });
  }
  function Fs(u) {
    return tt(u) && !yt(u) && (u = parseFloat(u)), M(u) ? void 0 : u;
  }
  function nb(u) {
    return (u | 0) === u;
  }
  function sb(u) {
    var m = u.toString(), y = m.indexOf(".");
    if (y === -1) {
      if (-1 < u && u < 1) {
        var f = /e-(\d+)$/.exec(m);
        if (f)
          return Number(f[1]);
      }
      return 0;
    }
    return m.length - y - 1;
  }
  function jT(u, m, y) {
    var f = Number(u), w = !nb(f), D = !nb(m), k = !nb(y);
    if (w || D || k) {
      var S = w ? sb(f) : 0, $ = D ? sb(m) : 0, E = k ? sb(y) : 0, Y = Math.max(S, $, E), X = Math.pow(10, Y);
      f = f * X, m = m * X, y = y * X, w && (f = Math.round(f)), D && (m = Math.round(m)), k && (y = Math.round(y));
    }
    return (f - m) % y === 0;
  }
  function LO(u, m, y, f, w, D, k, S) {
    ab(u, m, y, f, "number"), WT(f), $o(u, m, y, f, w, D);
    var $;
    if (tt(y.min) || y.ngMin) {
      var E = y.min || S(y.ngMin)(u);
      $ = Fs(E), f.$validators.min = function(ct, It) {
        return f.$isEmpty(It) || j($) || It >= $;
      }, y.$observe("min", function(ct) {
        ct !== E && ($ = Fs(ct), E = ct, f.$validate());
      });
    }
    if (tt(y.max) || y.ngMax) {
      var Y = y.max || S(y.ngMax)(u), X = Fs(Y);
      f.$validators.max = function(ct, It) {
        return f.$isEmpty(It) || j(X) || It <= X;
      }, y.$observe("max", function(ct) {
        ct !== Y && (X = Fs(ct), Y = ct, f.$validate());
      });
    }
    if (tt(y.step) || y.ngStep) {
      var z = y.step || S(y.ngStep)(u), st = Fs(z);
      f.$validators.step = function(ct, It) {
        return f.$isEmpty(It) || j(st) || jT(It, $ || 0, st);
      }, y.$observe("step", function(ct) {
        ct !== z && (st = Fs(ct), z = ct, f.$validate());
      });
    }
  }
  function DO(u, m, y, f, w, D) {
    ab(u, m, y, f, "range"), WT(f), $o(u, m, y, f, w, D);
    var k = f.$$hasNativeValidators && m[0].type === "range", S = k ? 0 : void 0, $ = k ? 100 : void 0, E = k ? 1 : void 0, Y = m[0].validity, X = tt(y.min), z = tt(y.max), st = tt(y.step), ct = f.$render;
    f.$render = k && tt(Y.rangeUnderflow) && tt(Y.rangeOverflow) ? (
      //Browsers that implement range will set these values automatically, but reading the adjusted values after
      //$render would cause the min / max validators to be applied with the wrong value
      function() {
        ct(), f.$setViewValue(m.val());
      }
    ) : ct, X && (S = Fs(y.min), f.$validators.min = k ? (
      // Since all browsers set the input to a valid value, we don't need to check validity
      function() {
        return !0;
      }
    ) : (
      // non-support browsers validate the min val
      function(Ot, mt) {
        return f.$isEmpty(mt) || j(S) || mt >= S;
      }
    ), It("min", Ut)), z && ($ = Fs(y.max), f.$validators.max = k ? (
      // Since all browsers set the input to a valid value, we don't need to check validity
      function() {
        return !0;
      }
    ) : (
      // non-support browsers validate the max val
      function(Ot, mt) {
        return f.$isEmpty(mt) || j($) || mt <= $;
      }
    ), It("max", Et)), st && (E = Fs(y.step), f.$validators.step = k ? function() {
      return !Y.stepMismatch;
    } : (
      // ngStep doesn't set the setp attr, so the browser doesn't adjust the input value as setting step would
      function(Ot, mt) {
        return f.$isEmpty(mt) || j(E) || jT(mt, S || 0, E);
      }
    ), It("step", Dt));
    function It(Tt, Ot) {
      m.attr(Tt, y[Tt]);
      var mt = y[Tt];
      y.$observe(Tt, function(Z) {
        Z !== mt && (mt = Z, Ot(Z));
      });
    }
    function Ut(Tt) {
      if (S = Fs(Tt), !M(f.$modelValue))
        if (k) {
          var Ot = m.val();
          S > Ot && (Ot = S, m.val(Ot)), f.$setViewValue(Ot);
        } else
          f.$validate();
    }
    function Et(Tt) {
      if ($ = Fs(Tt), !M(f.$modelValue))
        if (k) {
          var Ot = m.val();
          $ < Ot && (m.val($), Ot = $ < S ? S : $), f.$setViewValue(Ot);
        } else
          f.$validate();
    }
    function Dt(Tt) {
      E = Fs(Tt), !M(f.$modelValue) && (k ? f.$viewValue !== m.val() && f.$setViewValue(m.val()) : f.$validate());
    }
  }
  function IO(u, m, y, f, w, D) {
    $o(u, m, y, f, w, D), eb(f), f.$validators.url = function(k, S) {
      var $ = k || S;
      return f.$isEmpty($) || AO.test($);
    };
  }
  function PO(u, m, y, f, w, D) {
    $o(u, m, y, f, w, D), eb(f), f.$validators.email = function(k, S) {
      var $ = k || S;
      return f.$isEmpty($) || CO.test($);
    };
  }
  function EO(u, m, y, f) {
    var w = !y.ngTrim || oe(y.ngTrim) !== "false";
    j(y.name) && m.attr("name", B());
    var D = function(k) {
      var S;
      m[0].checked && (S = y.value, w && (S = oe(S)), f.$setViewValue(S, k && k.type));
    };
    m.on("change", D), f.$render = function() {
      var k = y.value;
      w && (k = oe(k)), m[0].checked = k === f.$viewValue;
    }, y.$observe("value", f.$render);
  }
  function VT(u, m, y, f, w) {
    var D;
    if (tt(f)) {
      if (D = u(f), !D.constant)
        throw dd("constexpr", "Expected constant expression for `{0}`, but saw `{1}`.", y, f);
      return D(m);
    }
    return w;
  }
  function NO(u, m, y, f, w, D, k, S) {
    var $ = VT(S, u, "ngTrueValue", y.ngTrueValue, !0), E = VT(S, u, "ngFalseValue", y.ngFalseValue, !1), Y = function(X) {
      f.$setViewValue(m[0].checked, X && X.type);
    };
    m.on("change", Y), f.$render = function() {
      m[0].checked = f.$viewValue;
    }, f.$isEmpty = function(X) {
      return X === !1;
    }, f.$formatters.push(function(X) {
      return je(X, $);
    }), f.$parsers.push(function(X) {
      return X ? $ : E;
    });
  }
  var qT = [
    "$browser",
    "$sniffer",
    "$filter",
    "$parse",
    function(u, m, y, f) {
      return {
        restrict: "E",
        require: ["?ngModel"],
        link: {
          pre: function(w, D, k, S) {
            S[0] && (BT[o(k.type)] || BT.text)(
              w,
              D,
              k,
              S[0],
              m,
              u,
              y,
              f
            );
          }
        }
      };
    }
  ], RO = function() {
    var u = {
      configurable: !0,
      enumerable: !1,
      get: function() {
        return this.getAttribute("value") || "";
      },
      set: function(m) {
        this.setAttribute("value", m);
      }
    };
    return {
      restrict: "E",
      priority: 200,
      compile: function(m, y) {
        if (o(y.type) === "hidden")
          return {
            pre: function(f, w, D, k) {
              var S = w[0];
              S.parentNode && S.parentNode.insertBefore(S, S.nextSibling), Object.defineProperty && Object.defineProperty(S, "value", u);
            }
          };
      }
    };
  }, YO = /^(true|false|\d+)$/, _O = function() {
    function u(m, y, f) {
      var w = tt(f) ? f : d === 9 ? "" : null;
      m.prop("value", w), y.$set("value", f);
    }
    return {
      restrict: "A",
      priority: 100,
      compile: function(m, y) {
        return YO.test(y.ngValue) ? function(w, D, k) {
          var S = w.$eval(k.ngValue);
          u(D, k, S);
        } : function(w, D, k) {
          w.$watch(k.ngValue, function($) {
            u(D, k, $);
          });
        };
      }
    };
  }, OO = ["$compile", function(u) {
    return {
      restrict: "AC",
      compile: function(y) {
        return u.$$addBindingClass(y), function(w, D, k) {
          u.$$addBindingInfo(D, k.ngBind), D = D[0], w.$watch(k.ngBind, function($) {
            D.textContent = Ea($);
          });
        };
      }
    };
  }], MO = ["$interpolate", "$compile", function(u, m) {
    return {
      compile: function(f) {
        return m.$$addBindingClass(f), function(D, k, S) {
          var $ = u(k.attr(S.$attr.ngBindTemplate));
          m.$$addBindingInfo(k, $.expressions), k = k[0], S.$observe("ngBindTemplate", function(E) {
            k.textContent = j(E) ? "" : E;
          });
        };
      }
    };
  }], XO = ["$sce", "$parse", "$compile", function(u, m, y) {
    return {
      restrict: "A",
      compile: function(w, D) {
        var k = m(D.ngBindHtml), S = m(D.ngBindHtml, function(E) {
          return u.valueOf(E);
        });
        return y.$$addBindingClass(w), function(E, Y, X) {
          y.$$addBindingInfo(Y, X.ngBindHtml), E.$watch(S, function() {
            var st = k(E);
            Y.html(u.getTrustedHtml(st) || "");
          });
        };
      }
    };
  }], GO = St({
    restrict: "A",
    require: "ngModel",
    link: function(u, m, y, f) {
      f.$viewChangeListeners.push(function() {
        u.$eval(y.ngChange);
      });
    }
  });
  function ib(u, m) {
    u = "ngClass" + u;
    var y;
    return ["$parse", function(k) {
      return {
        restrict: "AC",
        link: function(S, $, E) {
          var Y = $.data("$classCounts"), X = !0, z;
          Y || (Y = Ee(), $.data("$classCounts", Y)), u !== "ngClass" && (y || (y = k("$index", function(Ot) {
            return Ot & 1;
          })), S.$watch(y, Et)), S.$watch(k(E[u], D), Dt);
          function st(Tt) {
            Tt = Ut(w(Tt), 1), E.$addClass(Tt);
          }
          function ct(Tt) {
            Tt = Ut(w(Tt), -1), E.$removeClass(Tt);
          }
          function It(Tt, Ot) {
            var mt = w(Tt), ft = w(Ot), Z = f(mt, ft), q = f(ft, mt), ut = Ut(Z, -1), pt = Ut(q, 1);
            E.$addClass(pt), E.$removeClass(ut);
          }
          function Ut(Tt, Ot) {
            var mt = [];
            return N(Tt, function(ft) {
              (Ot > 0 || Y[ft]) && (Y[ft] = (Y[ft] || 0) + Ot, Y[ft] === +(Ot > 0) && mt.push(ft));
            }), mt.join(" ");
          }
          function Et(Tt) {
            Tt === m ? st(z) : ct(z), X = Tt;
          }
          function Dt(Tt) {
            X === m && It(z, Tt), z = Tt;
          }
        }
      };
    }];
    function f(k, S) {
      if (!k || !k.length)
        return [];
      if (!S || !S.length)
        return k;
      var $ = [];
      t:
        for (var E = 0; E < k.length; E++) {
          for (var Y = k[E], X = 0; X < S.length; X++)
            if (Y === S[X])
              continue t;
          $.push(Y);
        }
      return $;
    }
    function w(k) {
      return k && k.split(" ");
    }
    function D(k) {
      if (!k)
        return k;
      var S = k;
      return Yt(k) ? S = k.map(D).join(" ") : lt(k) ? S = Object.keys(k).filter(function($) {
        return k[$];
      }).join(" ") : nt(k) || (S = k + ""), S;
    }
  }
  var HO = ib("", !0), UO = ib("Odd", 0), FO = ib("Even", 1), zO = Co({
    compile: function(u, m) {
      m.$set("ngCloak", void 0), u.removeClass("ng-cloak");
    }
  }), BO = [function() {
    return {
      restrict: "A",
      scope: !0,
      controller: "@",
      priority: 500
    };
  }], KT = {}, WO = {
    blur: !0,
    focus: !0
  };
  N(
    "click dblclick mousedown mouseup mouseover mouseout mousemove mouseenter mouseleave keydown keyup keypress submit focus blur copy cut paste".split(" "),
    function(u) {
      var m = di("ng-" + u);
      KT[m] = ["$parse", "$rootScope", "$exceptionHandler", function(y, f, w) {
        return JT(y, f, w, m, u, WO[u]);
      }];
    }
  );
  function JT(u, m, y, f, w, D) {
    return {
      restrict: "A",
      compile: function(k, S) {
        var $ = u(S[f]);
        return function(Y, X) {
          X.on(w, function(z) {
            var st = function() {
              $(Y, { $event: z });
            };
            if (!m.$$phase)
              Y.$apply(st);
            else if (D)
              Y.$evalAsync(st);
            else
              try {
                st();
              } catch (ct) {
                y(ct);
              }
          });
        };
      }
    };
  }
  var jO = ["$animate", "$compile", function(u, m) {
    return {
      multiElement: !0,
      transclude: "element",
      priority: 600,
      terminal: !0,
      restrict: "A",
      $$tlb: !0,
      link: function(y, f, w, D, k) {
        var S, $, E;
        y.$watch(w.ngIf, function(X) {
          X ? $ || k(function(z, st) {
            $ = st, z[z.length++] = m.$$createComment("end ngIf", w.ngIf), S = {
              clone: z
            }, u.enter(z, f.parent(), f);
          }) : (E && (E.remove(), E = null), $ && ($.$destroy(), $ = null), S && (E = Ce(S.clone), u.leave(E).done(function(z) {
            z !== !1 && (E = null);
          }), S = null));
        });
      }
    };
  }], VO = [
    "$templateRequest",
    "$anchorScroll",
    "$animate",
    function(u, m, y) {
      return {
        restrict: "ECA",
        priority: 400,
        terminal: !0,
        transclude: "element",
        controller: C.noop,
        compile: function(f, w) {
          var D = w.ngInclude || w.src, k = w.onload || "", S = w.autoscroll;
          return function($, E, Y, X, z) {
            var st = 0, ct, It, Ut, Et = function() {
              It && (It.remove(), It = null), ct && (ct.$destroy(), ct = null), Ut && (y.leave(Ut).done(function(Dt) {
                Dt !== !1 && (It = null);
              }), It = Ut, Ut = null);
            };
            $.$watch(D, function(Tt) {
              var Ot = function(ft) {
                ft !== !1 && tt(S) && (!S || $.$eval(S)) && m();
              }, mt = ++st;
              Tt ? (u(Tt, !0).then(function(ft) {
                if (!$.$$destroyed && mt === st) {
                  var Z = $.$new();
                  X.template = ft;
                  var q = z(Z, function(ut) {
                    Et(), y.enter(ut, null, E).done(Ot);
                  });
                  ct = Z, Ut = q, ct.$emit("$includeContentLoaded", Tt), $.$eval(k);
                }
              }, function() {
                $.$$destroyed || mt === st && (Et(), $.$emit("$includeContentError", Tt));
              }), $.$emit("$includeContentRequested", Tt)) : (Et(), X.template = null);
            });
          };
        }
      };
    }
  ], qO = [
    "$compile",
    function(u) {
      return {
        restrict: "ECA",
        priority: -400,
        require: "ngInclude",
        link: function(m, y, f, w) {
          if (A.call(y[0]).match(/SVG/)) {
            y.empty(), u(Rk(w.template, s.document).childNodes)(
              m,
              function(k) {
                y.append(k);
              },
              { futureParentElement: y }
            );
            return;
          }
          y.html(w.template), u(y.contents())(m);
        }
      };
    }
  ], KO = Co({
    priority: 450,
    compile: function() {
      return {
        pre: function(u, m, y) {
          u.$eval(y.ngInit);
        }
      };
    }
  }), JO = function() {
    return {
      restrict: "A",
      priority: 100,
      require: "ngModel",
      link: function(u, m, y, f) {
        var w = y.ngList || ", ", D = y.ngTrim !== "false", k = D ? oe(w) : w, S = function($) {
          if (!j($)) {
            var E = [];
            return $ && N($.split(k), function(Y) {
              Y && E.push(D ? oe(Y) : Y);
            }), E;
          }
        };
        f.$parsers.push(S), f.$formatters.push(function($) {
          if (Yt($))
            return $.join(w);
        }), f.$isEmpty = function($) {
          return !$ || !$.length;
        };
      }
    };
  }, cd = "ng-valid", QT = "ng-invalid", So = "ng-pristine", Xp = "ng-dirty", rb = "ng-untouched", ZT = "ng-touched", tL = "ng-empty", eL = "ng-not-empty", dd = n("ngModel");
  Gp.$inject = ["$scope", "$exceptionHandler", "$attrs", "$element", "$parse", "$animate", "$timeout", "$q", "$interpolate"];
  function Gp(u, m, y, f, w, D, k, S, $) {
    this.$viewValue = Number.NaN, this.$modelValue = Number.NaN, this.$$rawModelValue = void 0, this.$validators = {}, this.$asyncValidators = {}, this.$parsers = [], this.$formatters = [], this.$viewChangeListeners = [], this.$untouched = !0, this.$touched = !1, this.$pristine = !0, this.$dirty = !1, this.$valid = !0, this.$invalid = !1, this.$error = {}, this.$$success = {}, this.$pending = void 0, this.$name = $(y.name || "", !1)(u), this.$$parentForm = ld, this.$options = Hp, this.$$updateEvents = "", this.$$updateEventHandler = this.$$updateEventHandler.bind(this), this.$$parsedNgModel = w(y.ngModel), this.$$parsedNgModelAssign = this.$$parsedNgModel.assign, this.$$ngModelGet = this.$$parsedNgModel, this.$$ngModelSet = this.$$parsedNgModelAssign, this.$$pendingDebounce = null, this.$$parserValid = void 0, this.$$parserName = "parse", this.$$currentValidationRunId = 0, this.$$scope = u, this.$$rootScope = u.$root, this.$$attr = y, this.$$element = f, this.$$animate = D, this.$$timeout = k, this.$$parse = w, this.$$q = S, this.$$exceptionHandler = m, OT(this), QO(this);
  }
  Gp.prototype = {
    $$initGetterSetters: function() {
      if (this.$options.getOption("getterSetter")) {
        var u = this.$$parse(this.$$attr.ngModel + "()"), m = this.$$parse(this.$$attr.ngModel + "($$$p)");
        this.$$ngModelGet = function(y) {
          var f = this.$$parsedNgModel(y);
          return _(f) && (f = u(y)), f;
        }, this.$$ngModelSet = function(y, f) {
          _(this.$$parsedNgModel(y)) ? m(y, { $$$p: f }) : this.$$parsedNgModelAssign(y, f);
        };
      } else if (!this.$$parsedNgModel.assign)
        throw dd(
          "nonassign",
          "Expression '{0}' is non-assignable. Element: {1}",
          this.$$attr.ngModel,
          Kn(this.$$element)
        );
    },
    /**
     * @ngdoc method
     * @name ngModel.NgModelController#$render
     *
     * @description
     * Called when the view needs to be updated. It is expected that the user of the ng-model
     * directive will implement this method.
     *
     * The `$render()` method is invoked in the following situations:
     *
     * * `$rollbackViewValue()` is called.  If we are rolling back the view value to the last
     *   committed value then `$render()` is called to update the input control.
     * * The value referenced by `ng-model` is changed programmatically and both the `$modelValue` and
     *   the `$viewValue` are different from last time.
     *
     * Since `ng-model` does not do a deep watch, `$render()` is only invoked if the values of
     * `$modelValue` and `$viewValue` are actually different from their previous values. If `$modelValue`
     * or `$viewValue` are objects (rather than a string or number) then `$render()` will not be
     * invoked if you only change a property on the objects.
     */
    $render: J,
    /**
     * @ngdoc method
     * @name ngModel.NgModelController#$isEmpty
     *
     * @description
     * This is called when we need to determine if the value of an input is empty.
     *
     * For instance, the required directive does this to work out if the input has data or not.
     *
     * The default `$isEmpty` function checks whether the value is `undefined`, `''`, `null` or `NaN`.
     *
     * You can override this for input directives whose concept of being empty is different from the
     * default. The `checkboxInputType` directive does this because in its case a value of `false`
     * implies empty.
     *
     * @param {*} value The value of the input to check for emptiness.
     * @returns {boolean} True if `value` is "empty".
     */
    $isEmpty: function(u) {
      return j(u) || u === "" || u === null || u !== u;
    },
    $$updateEmptyClasses: function(u) {
      this.$isEmpty(u) ? (this.$$animate.removeClass(this.$$element, eL), this.$$animate.addClass(this.$$element, tL)) : (this.$$animate.removeClass(this.$$element, tL), this.$$animate.addClass(this.$$element, eL));
    },
    /**
     * @ngdoc method
     * @name ngModel.NgModelController#$setPristine
     *
     * @description
     * Sets the control to its pristine state.
     *
     * This method can be called to remove the `ng-dirty` class and set the control to its pristine
     * state (`ng-pristine` class). A model is considered to be pristine when the control
     * has not been changed from when first compiled.
     */
    $setPristine: function() {
      this.$dirty = !1, this.$pristine = !0, this.$$animate.removeClass(this.$$element, Xp), this.$$animate.addClass(this.$$element, So);
    },
    /**
     * @ngdoc method
     * @name ngModel.NgModelController#$setDirty
     *
     * @description
     * Sets the control to its dirty state.
     *
     * This method can be called to remove the `ng-pristine` class and set the control to its dirty
     * state (`ng-dirty` class). A model is considered to be dirty when the control has been changed
     * from when first compiled.
     */
    $setDirty: function() {
      this.$dirty = !0, this.$pristine = !1, this.$$animate.removeClass(this.$$element, So), this.$$animate.addClass(this.$$element, Xp), this.$$parentForm.$setDirty();
    },
    /**
     * @ngdoc method
     * @name ngModel.NgModelController#$setUntouched
     *
     * @description
     * Sets the control to its untouched state.
     *
     * This method can be called to remove the `ng-touched` class and set the control to its
     * untouched state (`ng-untouched` class). Upon compilation, a model is set as untouched
     * by default, however this function can be used to restore that state if the model has
     * already been touched by the user.
     */
    $setUntouched: function() {
      this.$touched = !1, this.$untouched = !0, this.$$animate.setClass(this.$$element, rb, ZT);
    },
    /**
     * @ngdoc method
     * @name ngModel.NgModelController#$setTouched
     *
     * @description
     * Sets the control to its touched state.
     *
     * This method can be called to remove the `ng-untouched` class and set the control to its
     * touched state (`ng-touched` class). A model is considered to be touched when the user has
     * first focused the control element and then shifted focus away from the control (blur event).
     */
    $setTouched: function() {
      this.$touched = !0, this.$untouched = !1, this.$$animate.setClass(this.$$element, ZT, rb);
    },
    /**
       * @ngdoc method
       * @name ngModel.NgModelController#$rollbackViewValue
       *
       * @description
       * Cancel an update and reset the input element's value to prevent an update to the `$modelValue`,
       * which may be caused by a pending debounced event or because the input is waiting for some
       * future event.
       *
       * If you have an input that uses `ng-model-options` to set up debounced updates or updates that
       * depend on special events such as `blur`, there can be a period when the `$viewValue` is out of
       * sync with the ngModel's `$modelValue`.
       *
       * In this case, you can use `$rollbackViewValue()` to manually cancel the debounced / future update
       * and reset the input to the last committed view value.
       *
       * It is also possible that you run into difficulties if you try to update the ngModel's `$modelValue`
       * programmatically before these debounced/future events have resolved/occurred, because AngularJS's
       * dirty checking mechanism is not able to tell whether the model has actually changed or not.
       *
       * The `$rollbackViewValue()` method should be called before programmatically changing the model of an
       * input which may have such events pending. This is important in order to make sure that the
       * input field will be updated with the new model value and any pending operations are cancelled.
       *
       * @example
       * <example name="ng-model-cancel-update" module="cancel-update-example">
       *   <file name="app.js">
       *     angular.module('cancel-update-example', [])
       *
       *     .controller('CancelUpdateController', ['$scope', function($scope) {
       *       $scope.model = {value1: '', value2: ''};
       *
       *       $scope.setEmpty = function(e, value, rollback) {
       *         if (e.keyCode === 27) {
       *           e.preventDefault();
       *           if (rollback) {
       *             $scope.myForm[value].$rollbackViewValue();
       *           }
       *           $scope.model[value] = '';
       *         }
       *       };
       *     }]);
       *   </file>
       *   <file name="index.html">
       *     <div ng-controller="CancelUpdateController">
       *       <p>Both of these inputs are only updated if they are blurred. Hitting escape should
       *       empty them. Follow these steps and observe the difference:</p>
       *       <ol>
       *         <li>Type something in the input. You will see that the model is not yet updated</li>
       *         <li>Press the Escape key.
       *           <ol>
       *             <li> In the first example, nothing happens, because the model is already '', and no
       *             update is detected. If you blur the input, the model will be set to the current view.
       *             </li>
       *             <li> In the second example, the pending update is cancelled, and the input is set back
       *             to the last committed view value (''). Blurring the input does nothing.
       *             </li>
       *           </ol>
       *         </li>
       *       </ol>
       *
       *       <form name="myForm" ng-model-options="{ updateOn: 'blur' }">
       *         <div>
       *           <p id="inputDescription1">Without $rollbackViewValue():</p>
       *           <input name="value1" aria-describedby="inputDescription1" ng-model="model.value1"
       *                  ng-keydown="setEmpty($event, 'value1')">
       *           value1: "{{ model.value1 }}"
       *         </div>
       *
       *         <div>
       *           <p id="inputDescription2">With $rollbackViewValue():</p>
       *           <input name="value2" aria-describedby="inputDescription2" ng-model="model.value2"
       *                  ng-keydown="setEmpty($event, 'value2', true)">
       *           value2: "{{ model.value2 }}"
       *         </div>
       *       </form>
       *     </div>
       *   </file>
           <file name="style.css">
              div {
                display: table-cell;
              }
              div:nth-child(1) {
                padding-right: 30px;
              }
    
            </file>
       * </example>
       */
    $rollbackViewValue: function() {
      this.$$timeout.cancel(this.$$pendingDebounce), this.$viewValue = this.$$lastCommittedViewValue, this.$render();
    },
    /**
     * @ngdoc method
     * @name ngModel.NgModelController#$validate
     *
     * @description
     * Runs each of the registered validators (first synchronous validators and then
     * asynchronous validators).
     * If the validity changes to invalid, the model will be set to `undefined`,
     * unless {@link ngModelOptions `ngModelOptions.allowInvalid`} is `true`.
     * If the validity changes to valid, it will set the model to the last available valid
     * `$modelValue`, i.e. either the last parsed value or the last value set from the scope.
     */
    $validate: function() {
      if (!M(this.$modelValue)) {
        var u = this.$$lastCommittedViewValue, m = this.$$rawModelValue, y = this.$valid, f = this.$modelValue, w = this.$options.getOption("allowInvalid"), D = this;
        this.$$runValidators(m, u, function(k) {
          !w && y !== k && (D.$modelValue = k ? m : void 0, D.$modelValue !== f && D.$$writeModelToScope());
        });
      }
    },
    $$runValidators: function(u, m, y) {
      this.$$currentValidationRunId++;
      var f = this.$$currentValidationRunId, w = this;
      if (!D()) {
        E(!1);
        return;
      }
      if (!k()) {
        E(!1);
        return;
      }
      S();
      function D() {
        var Y = w.$$parserName;
        if (j(w.$$parserValid))
          $(Y, null);
        else
          return w.$$parserValid || (N(w.$validators, function(X, z) {
            $(z, null);
          }), N(w.$asyncValidators, function(X, z) {
            $(z, null);
          })), $(Y, w.$$parserValid), w.$$parserValid;
        return !0;
      }
      function k() {
        var Y = !0;
        return N(w.$validators, function(X, z) {
          var st = !!X(u, m);
          Y = Y && st, $(z, st);
        }), Y ? !0 : (N(w.$asyncValidators, function(X, z) {
          $(z, null);
        }), !1);
      }
      function S() {
        var Y = [], X = !0;
        N(w.$asyncValidators, function(z, st) {
          var ct = z(u, m);
          if (!qt(ct))
            throw dd(
              "nopromise",
              "Expected asynchronous validator to return a promise but got '{0}' instead.",
              ct
            );
          $(st, void 0), Y.push(ct.then(function() {
            $(st, !0);
          }, function() {
            X = !1, $(st, !1);
          }));
        }), Y.length ? w.$$q.all(Y).then(function() {
          E(X);
        }, J) : E(!0);
      }
      function $(Y, X) {
        f === w.$$currentValidationRunId && w.$setValidity(Y, X);
      }
      function E(Y) {
        f === w.$$currentValidationRunId && y(Y);
      }
    },
    /**
     * @ngdoc method
     * @name ngModel.NgModelController#$commitViewValue
     *
     * @description
     * Commit a pending update to the `$modelValue`.
     *
     * Updates may be pending by a debounced event or because the input is waiting for a some future
     * event defined in `ng-model-options`. this method is rarely needed as `NgModelController`
     * usually handles calling this in response to input events.
     */
    $commitViewValue: function() {
      var u = this.$viewValue;
      this.$$timeout.cancel(this.$$pendingDebounce), !(this.$$lastCommittedViewValue === u && (u !== "" || !this.$$hasNativeValidators)) && (this.$$updateEmptyClasses(u), this.$$lastCommittedViewValue = u, this.$pristine && this.$setDirty(), this.$$parseAndValidate());
    },
    $$parseAndValidate: function() {
      var u = this.$$lastCommittedViewValue, m = u, y = this;
      if (this.$$parserValid = j(m) ? void 0 : !0, this.$setValidity(this.$$parserName, null), this.$$parserName = "parse", this.$$parserValid) {
        for (var f = 0; f < this.$parsers.length; f++)
          if (m = this.$parsers[f](m), j(m)) {
            this.$$parserValid = !1;
            break;
          }
      }
      M(this.$modelValue) && (this.$modelValue = this.$$ngModelGet(this.$$scope));
      var w = this.$modelValue, D = this.$options.getOption("allowInvalid");
      this.$$rawModelValue = m, D && (this.$modelValue = m, k()), this.$$runValidators(m, this.$$lastCommittedViewValue, function(S) {
        D || (y.$modelValue = S ? m : void 0, k());
      });
      function k() {
        y.$modelValue !== w && y.$$writeModelToScope();
      }
    },
    $$writeModelToScope: function() {
      this.$$ngModelSet(this.$$scope, this.$modelValue), N(this.$viewChangeListeners, function(u) {
        try {
          u();
        } catch (m) {
          this.$$exceptionHandler(m);
        }
      }, this);
    },
    /**
     * @ngdoc method
     * @name ngModel.NgModelController#$setViewValue
     *
     * @description
     * Update the view value.
     *
     * This method should be called when a control wants to change the view value; typically,
     * this is done from within a DOM event handler. For example, the {@link ng.directive:input input}
     * directive calls it when the value of the input changes and {@link ng.directive:select select}
     * calls it when an option is selected.
     *
     * When `$setViewValue` is called, the new `value` will be staged for committing through the `$parsers`
     * and `$validators` pipelines. If there are no special {@link ngModelOptions} specified then the staged
     * value is sent directly for processing through the `$parsers` pipeline. After this, the `$validators` and
     * `$asyncValidators` are called and the value is applied to `$modelValue`.
     * Finally, the value is set to the **expression** specified in the `ng-model` attribute and
     * all the registered change listeners, in the `$viewChangeListeners` list are called.
     *
     * In case the {@link ng.directive:ngModelOptions ngModelOptions} directive is used with `updateOn`
     * and the `default` trigger is not listed, all those actions will remain pending until one of the
     * `updateOn` events is triggered on the DOM element.
     * All these actions will be debounced if the {@link ng.directive:ngModelOptions ngModelOptions}
     * directive is used with a custom debounce for this particular event.
     * Note that a `$digest` is only triggered once the `updateOn` events are fired, or if `debounce`
     * is specified, once the timer runs out.
     *
     * When used with standard inputs, the view value will always be a string (which is in some cases
     * parsed into another type, such as a `Date` object for `input[date]`.)
     * However, custom controls might also pass objects to this method. In this case, we should make
     * a copy of the object before passing it to `$setViewValue`. This is because `ngModel` does not
     * perform a deep watch of objects, it only looks for a change of identity. If you only change
     * the property of the object then ngModel will not realize that the object has changed and
     * will not invoke the `$parsers` and `$validators` pipelines. For this reason, you should
     * not change properties of the copy once it has been passed to `$setViewValue`.
     * Otherwise you may cause the model value on the scope to change incorrectly.
     *
     * <div class="alert alert-info">
     * In any case, the value passed to the method should always reflect the current value
     * of the control. For example, if you are calling `$setViewValue` for an input element,
     * you should pass the input DOM value. Otherwise, the control and the scope model become
     * out of sync. It's also important to note that `$setViewValue` does not call `$render` or change
     * the control's DOM value in any way. If we want to change the control's DOM value
     * programmatically, we should update the `ngModel` scope expression. Its new value will be
     * picked up by the model controller, which will run it through the `$formatters`, `$render` it
     * to update the DOM, and finally call `$validate` on it.
     * </div>
     *
     * @param {*} value value from the view.
     * @param {string} trigger Event that triggered the update.
     */
    $setViewValue: function(u, m) {
      this.$viewValue = u, this.$options.getOption("updateOnDefault") && this.$$debounceViewValueCommit(m);
    },
    $$debounceViewValueCommit: function(u) {
      var m = this.$options.getOption("debounce");
      yt(m[u]) ? m = m[u] : yt(m.default) && this.$options.getOption("updateOn").indexOf(u) === -1 ? m = m.default : yt(m["*"]) && (m = m["*"]), this.$$timeout.cancel(this.$$pendingDebounce);
      var y = this;
      m > 0 ? this.$$pendingDebounce = this.$$timeout(function() {
        y.$commitViewValue();
      }, m) : this.$$rootScope.$$phase ? this.$commitViewValue() : this.$$scope.$apply(function() {
        y.$commitViewValue();
      });
    },
    /**
     * @ngdoc method
     *
     * @name ngModel.NgModelController#$overrideModelOptions
     *
     * @description
     *
     * Override the current model options settings programmatically.
     *
     * The previous `ModelOptions` value will not be modified. Instead, a
     * new `ModelOptions` object will inherit from the previous one overriding
     * or inheriting settings that are defined in the given parameter.
     *
     * See {@link ngModelOptions} for information about what options can be specified
     * and how model option inheritance works.
     *
     * <div class="alert alert-warning">
     * **Note:** this function only affects the options set on the `ngModelController`,
     * and not the options on the {@link ngModelOptions} directive from which they might have been
     * obtained initially.
     * </div>
     *
     * <div class="alert alert-danger">
     * **Note:** it is not possible to override the `getterSetter` option.
     * </div>
     *
     * @param {Object} options a hash of settings to override the previous options
     *
     */
    $overrideModelOptions: function(u) {
      this.$options = this.$options.createChild(u), this.$$setUpdateOnEvents();
    },
    /**
       * @ngdoc method
       *
       * @name  ngModel.NgModelController#$processModelValue
    
       * @description
       *
       * Runs the model -> view pipeline on the current
       * {@link ngModel.NgModelController#$modelValue $modelValue}.
       *
       * The following actions are performed by this method:
       *
       * - the `$modelValue` is run through the {@link ngModel.NgModelController#$formatters $formatters}
       * and the result is set to the {@link ngModel.NgModelController#$viewValue $viewValue}
       * - the `ng-empty` or `ng-not-empty` class is set on the element
       * - if the `$viewValue` has changed:
       *   - {@link ngModel.NgModelController#$render $render} is called on the control
       *   - the {@link ngModel.NgModelController#$validators $validators} are run and
       *   the validation status is set.
       *
       * This method is called by ngModel internally when the bound scope value changes.
       * Application developers usually do not have to call this function themselves.
       *
       * This function can be used when the `$viewValue` or the rendered DOM value are not correctly
       * formatted and the `$modelValue` must be run through the `$formatters` again.
       *
       * @example
       * Consider a text input with an autocomplete list (for fruit), where the items are
       * objects with a name and an id.
       * A user enters `ap` and then selects `Apricot` from the list.
       * Based on this, the autocomplete widget will call `$setViewValue({name: 'Apricot', id: 443})`,
       * but the rendered value will still be `ap`.
       * The widget can then call `ctrl.$processModelValue()` to run the model -> view
       * pipeline again, which formats the object to the string `Apricot`,
       * then updates the `$viewValue`, and finally renders it in the DOM.
       *
       * <example module="inputExample" name="ng-model-process">
         <file name="index.html">
          <div ng-controller="inputController" style="display: flex;">
            <div style="margin-right: 30px;">
              Search Fruit:
              <basic-autocomplete items="items" on-select="selectedFruit = item"></basic-autocomplete>
            </div>
            <div>
              Model:<br>
              <pre>{{selectedFruit | json}}</pre>
            </div>
          </div>
         </file>
         <file name="app.js">
          angular.module('inputExample', [])
            .controller('inputController', function($scope) {
              $scope.items = [
                {name: 'Apricot', id: 443},
                {name: 'Clementine', id: 972},
                {name: 'Durian', id: 169},
                {name: 'Jackfruit', id: 982},
                {name: 'Strawberry', id: 863}
              ];
            })
            .component('basicAutocomplete', {
              bindings: {
                items: '<',
                onSelect: '&'
              },
              templateUrl: 'autocomplete.html',
              controller: function($element, $scope) {
                var that = this;
                var ngModel;
    
                that.$postLink = function() {
                  ngModel = $element.find('input').controller('ngModel');
    
                  ngModel.$formatters.push(function(value) {
                    return (value && value.name) || value;
                  });
    
                  ngModel.$parsers.push(function(value) {
                    var match = value;
                    for (var i = 0; i < that.items.length; i++) {
                      if (that.items[i].name === value) {
                        match = that.items[i];
                        break;
                      }
                    }
    
                    return match;
                  });
                };
    
                that.selectItem = function(item) {
                  ngModel.$setViewValue(item);
                  ngModel.$processModelValue();
                  that.onSelect({item: item});
                };
              }
            });
         </file>
         <file name="autocomplete.html">
           <div>
             <input type="search" ng-model="$ctrl.searchTerm" />
             <ul>
               <li ng-repeat="item in $ctrl.items | filter:$ctrl.searchTerm">
                 <button ng-click="$ctrl.selectItem(item)">{{ item.name }}</button>
               </li>
             </ul>
           </div>
         </file>
       * </example>
       *
       */
    $processModelValue: function() {
      var u = this.$$format();
      this.$viewValue !== u && (this.$$updateEmptyClasses(u), this.$viewValue = this.$$lastCommittedViewValue = u, this.$render(), this.$$runValidators(this.$modelValue, this.$viewValue, J));
    },
    /**
     * This method is called internally to run the $formatters on the $modelValue
     */
    $$format: function() {
      for (var u = this.$formatters, m = u.length, y = this.$modelValue; m--; )
        y = u[m](y);
      return y;
    },
    /**
     * This method is called internally when the bound scope value changes.
     */
    $$setModelValue: function(u) {
      this.$modelValue = this.$$rawModelValue = u, this.$$parserValid = void 0, this.$processModelValue();
    },
    $$setUpdateOnEvents: function() {
      this.$$updateEvents && this.$$element.off(this.$$updateEvents, this.$$updateEventHandler), this.$$updateEvents = this.$options.getOption("updateOn"), this.$$updateEvents && this.$$element.on(this.$$updateEvents, this.$$updateEventHandler);
    },
    $$updateEventHandler: function(u) {
      this.$$debounceViewValueCommit(u && u.type);
    }
  };
  function QO(u) {
    u.$$scope.$watch(function(y) {
      var f = u.$$ngModelGet(y);
      return f !== u.$modelValue && // checks for NaN is needed to allow setting the model to NaN when there's an asyncValidator
      // eslint-disable-next-line no-self-compare
      (u.$modelValue === u.$modelValue || f === f) && u.$$setModelValue(f), f;
    });
  }
  MT({
    clazz: Gp,
    set: function(u, m) {
      u[m] = !0;
    },
    unset: function(u, m) {
      delete u[m];
    }
  });
  var ZO = ["$rootScope", function(u) {
    return {
      restrict: "A",
      require: ["ngModel", "^?form", "^?ngModelOptions"],
      controller: Gp,
      // Prelink needs to run before any input directive
      // so that we can set the NgModelOptions in NgModelController
      // before anyone else uses it.
      priority: 1,
      compile: function(y) {
        return y.addClass(So).addClass(rb).addClass(cd), {
          pre: function(w, D, k, S) {
            var $ = S[0], E = S[1] || $.$$parentForm, Y = S[2];
            Y && ($.$options = Y.$options), $.$$initGetterSetters(), E.$addControl($), k.$observe("name", function(X) {
              $.$name !== X && $.$$parentForm.$$renameControl($, X);
            }), w.$on("$destroy", function() {
              $.$$parentForm.$removeControl($);
            });
          },
          post: function(w, D, k, S) {
            var $ = S[0];
            $.$$setUpdateOnEvents();
            function E() {
              $.$setTouched();
            }
            D.on("blur", function() {
              $.$touched || (u.$$phase ? w.$evalAsync(E) : w.$apply(E));
            });
          }
        };
      }
    };
  }], Hp, tM = /(\s+|^)default(\s+|$)/;
  function lb(u) {
    this.$$options = u;
  }
  lb.prototype = {
    /**
     * @ngdoc method
     * @name ModelOptions#getOption
     * @param {string} name the name of the option to retrieve
     * @returns {*} the value of the option
     * @description
     * Returns the value of the given option
     */
    getOption: function(u) {
      return this.$$options[u];
    },
    /**
     * @ngdoc method
     * @name ModelOptions#createChild
     * @param {Object} options a hash of options for the new child that will override the parent's options
     * @return {ModelOptions} a new `ModelOptions` object initialized with the given options.
     */
    createChild: function(u) {
      var m = !1;
      return u = et({}, u), N(
        u,
        /** @this */
        function(y, f) {
          y === "$inherit" ? f === "*" ? m = !0 : (u[f] = this.$$options[f], f === "updateOn" && (u.updateOnDefault = this.$$options.updateOnDefault)) : f === "updateOn" && (u.updateOnDefault = !1, u[f] = oe(y.replace(tM, function() {
            return u.updateOnDefault = !0, " ";
          })));
        },
        this
      ), m && (delete u["*"], aL(u, this.$$options)), aL(u, Hp.$$options), new lb(u);
    }
  }, Hp = new lb({
    updateOn: "",
    updateOnDefault: !0,
    debounce: 0,
    getterSetter: !1,
    allowInvalid: !1,
    timezone: null
  });
  var eM = function() {
    u.$inject = ["$attrs", "$scope"];
    function u(m, y) {
      this.$$attrs = m, this.$$scope = y;
    }
    return u.prototype = {
      $onInit: function() {
        var m = this.parentCtrl ? this.parentCtrl.$options : Hp, y = this.$$scope.$eval(this.$$attrs.ngModelOptions);
        this.$options = m.createChild(y);
      }
    }, {
      restrict: "A",
      // ngModelOptions needs to run before ngModel and input directives
      priority: 10,
      require: { parentCtrl: "?^^ngModelOptions" },
      bindToController: !0,
      controller: u
    };
  };
  function aL(u, m) {
    N(m, function(y, f) {
      tt(u[f]) || (u[f] = y);
    });
  }
  var aM = Co({ terminal: !0, priority: 1e3 }), nM = n("ngOptions"), sM = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+group\s+by\s+([\s\S]+?))?(?:\s+disable\s+when\s+([\s\S]+?))?\s+for\s+(?:([$\w][$\w]*)|(?:\(\s*([$\w][$\w]*)\s*,\s*([$\w][$\w]*)\s*\)))\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?$/, iM = ["$compile", "$document", "$parse", function(u, m, y) {
    function f(S, $, E) {
      var Y = S.match(sM);
      if (!Y)
        throw nM(
          "iexp",
          "Expected expression in form of '_select_ (as _label_)? for (_key_,)?_value_ in _collection_' but got '{0}'. Element: {1}",
          S,
          Kn($)
        );
      var X = Y[5] || Y[7], z = Y[6], st = / as /.test(Y[0]) && Y[1], ct = Y[9], It = y(Y[2] ? Y[1] : X), Ut = st && y(st), Et = Ut || It, Dt = ct && y(ct), Tt = ct ? function(kt, Gt) {
        return Dt(E, Gt);
      } : function(Gt) {
        return xo(Gt);
      }, Ot = function(kt, Gt) {
        return Tt(kt, pt(kt, Gt));
      }, mt = y(Y[2] || Y[1]), ft = y(Y[3] || ""), Z = y(Y[4] || ""), q = y(Y[8]), ut = {}, pt = z ? function(kt, Gt) {
        return ut[z] = Gt, ut[X] = kt, ut;
      } : function(kt) {
        return ut[X] = kt, ut;
      };
      function xt(kt, Gt, Vt, ee, Bt) {
        this.selectValue = kt, this.viewValue = Gt, this.label = Vt, this.group = ee, this.disabled = Bt;
      }
      function Mt(kt) {
        var Gt;
        if (!z && O(kt))
          Gt = kt;
        else {
          Gt = [];
          for (var Vt in kt)
            kt.hasOwnProperty(Vt) && Vt.charAt(0) !== "$" && Gt.push(Vt);
        }
        return Gt;
      }
      return {
        trackBy: ct,
        getTrackByValue: Ot,
        getWatchables: y(q, function(kt) {
          var Gt = [];
          kt = kt || [];
          for (var Vt = Mt(kt), ee = Vt.length, Bt = 0; Bt < ee; Bt++) {
            var re = kt === Vt ? Bt : Vt[Bt], Le = kt[re], $e = pt(Le, re), Xe = Tt(Le, $e);
            if (Gt.push(Xe), Y[2] || Y[1]) {
              var ta = mt(E, $e);
              Gt.push(ta);
            }
            if (Y[4]) {
              var sa = Z(E, $e);
              Gt.push(sa);
            }
          }
          return Gt;
        }),
        getOptions: function() {
          for (var kt = [], Gt = {}, Vt = q(E) || [], ee = Mt(Vt), Bt = ee.length, re = 0; re < Bt; re++) {
            var Le = Vt === ee ? re : ee[re], $e = Vt[Le], Xe = pt($e, Le), ta = Et(E, Xe), sa = Tt(ta, Xe), ba = mt(E, Xe), Qa = ft(E, Xe), Ya = Z(E, Xe), Dn = new xt(sa, ta, ba, Qa, Ya);
            kt.push(Dn), Gt[sa] = Dn;
          }
          return {
            items: kt,
            selectValueMap: Gt,
            getOptionFromViewValue: function(mn) {
              return Gt[Ot(mn)];
            },
            getViewValueFromOption: function(mn) {
              return ct ? la(mn.viewValue) : mn.viewValue;
            }
          };
        }
      };
    }
    var w = s.document.createElement("option"), D = s.document.createElement("optgroup");
    function k(S, $, E, Y) {
      for (var X = Y[0], z = Y[1], st = E.multiple, ct = 0, It = $.children(), Ut = It.length; ct < Ut; ct++)
        if (It[ct].value === "") {
          X.hasEmptyOption = !0, X.emptyOption = It.eq(ct);
          break;
        }
      $.empty();
      var Et = !!X.emptyOption, Dt = p(w.cloneNode(!1));
      Dt.val("?");
      var Tt, Ot = f(E.ngOptions, $, S), mt = m[0].createDocumentFragment();
      X.generateUnknownOptionValue = function(pt) {
        return "?";
      }, st ? (X.writeValue = function(xt) {
        if (Tt) {
          var Mt = xt && xt.map(Z) || [];
          Tt.items.forEach(function(kt) {
            kt.element.selected && !ue(Mt, kt) && (kt.element.selected = !1);
          });
        }
      }, X.readValue = function() {
        var xt = $.val() || [], Mt = [];
        return N(xt, function(kt) {
          var Gt = Tt.selectValueMap[kt];
          Gt && !Gt.disabled && Mt.push(Tt.getViewValueFromOption(Gt));
        }), Mt;
      }, Ot.trackBy && S.$watchCollection(function() {
        if (Yt(z.$viewValue))
          return z.$viewValue.map(function(pt) {
            return Ot.getTrackByValue(pt);
          });
      }, function() {
        z.$render();
      })) : (X.writeValue = function(xt) {
        if (Tt) {
          var Mt = $[0].options[$[0].selectedIndex], kt = Tt.getOptionFromViewValue(xt);
          Mt && Mt.removeAttribute("selected"), kt ? ($[0].value !== kt.selectValue && (X.removeUnknownOption(), $[0].value = kt.selectValue, kt.element.selected = !0), kt.element.setAttribute("selected", "selected")) : X.selectUnknownOrEmptyOption(xt);
        }
      }, X.readValue = function() {
        var xt = Tt.selectValueMap[$.val()];
        return xt && !xt.disabled ? (X.unselectEmptyOption(), X.removeUnknownOption(), Tt.getViewValueFromOption(xt)) : null;
      }, Ot.trackBy && S.$watch(
        function() {
          return Ot.getTrackByValue(z.$viewValue);
        },
        function() {
          z.$render();
        }
      )), Et && (u(X.emptyOption)(S), $.prepend(X.emptyOption), X.emptyOption[0].nodeType === _n ? (X.hasEmptyOption = !1, X.registerOption = function(pt, xt) {
        xt.val() === "" && (X.hasEmptyOption = !0, X.emptyOption = xt, X.emptyOption.removeClass("ng-scope"), z.$render(), xt.on("$destroy", function() {
          var Mt = X.$isEmptyOptionSelected();
          X.hasEmptyOption = !1, X.emptyOption = void 0, Mt && z.$render();
        }));
      }) : X.emptyOption.removeClass("ng-scope")), S.$watchCollection(Ot.getWatchables, ut);
      function ft(pt, xt) {
        var Mt = w.cloneNode(!1);
        xt.appendChild(Mt), q(pt, Mt);
      }
      function Z(pt) {
        var xt = Tt.getOptionFromViewValue(pt), Mt = xt && xt.element;
        return Mt && !Mt.selected && (Mt.selected = !0), xt;
      }
      function q(pt, xt) {
        pt.element = xt, xt.disabled = pt.disabled, pt.label !== xt.label && (xt.label = pt.label, xt.textContent = pt.label), xt.value = pt.selectValue;
      }
      function ut() {
        var pt = Tt && X.readValue();
        if (Tt)
          for (var xt = Tt.items.length - 1; xt >= 0; xt--) {
            var Mt = Tt.items[xt];
            tt(Mt.group) ? kp(Mt.element.parentNode) : kp(Mt.element);
          }
        Tt = Ot.getOptions();
        var kt = {};
        if (Tt.items.forEach(function(Bt) {
          var re;
          tt(Bt.group) ? (re = kt[Bt.group], re || (re = D.cloneNode(!1), mt.appendChild(re), re.label = Bt.group === null ? "null" : Bt.group, kt[Bt.group] = re), ft(Bt, re)) : ft(Bt, mt);
        }), $[0].appendChild(mt), z.$render(), !z.$isEmpty(pt)) {
          var Gt = X.readValue(), Vt = Ot.trackBy || st;
          (Vt ? !je(pt, Gt) : pt !== Gt) && (z.$setViewValue(Gt), z.$render());
        }
      }
    }
    return {
      restrict: "A",
      terminal: !0,
      require: ["select", "ngModel"],
      link: {
        pre: function($, E, Y, X) {
          X[0].registerOption = J;
        },
        post: k
      }
    };
  }], rM = ["$locale", "$interpolate", "$log", function(u, m, y) {
    var f = /{}/g, w = /^when(Minus)?(.+)$/;
    return {
      link: function(D, k, S) {
        var $ = S.count, E = S.$attr.when && k.attr(S.$attr.when), Y = S.offset || 0, X = D.$eval(E) || {}, z = {}, st = m.startSymbol(), ct = m.endSymbol(), It = st + $ + "-" + Y + ct, Ut = C.noop, Et;
        N(S, function(Tt, Ot) {
          var mt = w.exec(Ot);
          if (mt) {
            var ft = (mt[1] ? "-" : "") + o(mt[2]);
            X[ft] = k.attr(S.$attr[Ot]);
          }
        }), N(X, function(Tt, Ot) {
          z[Ot] = m(Tt.replace(f, It));
        }), D.$watch($, function(Ot) {
          var mt = parseFloat(Ot), ft = M(mt);
          if (!ft && !(mt in X) && (mt = u.pluralCat(mt - Y)), mt !== Et && !(ft && M(Et))) {
            Ut();
            var Z = z[mt];
            j(Z) ? (Ot != null && y.debug("ngPluralize: no rule defined for '" + mt + "' in " + E), Ut = J, Dt()) : Ut = D.$watch(Z, Dt), Et = mt;
          }
        });
        function Dt(Tt) {
          k.text(Tt || "");
        }
      }
    };
  }], nL = n("ngRef"), lM = ["$parse", function(u) {
    return {
      priority: -1,
      // Needed for compatibility with element transclusion on the same element
      restrict: "A",
      compile: function(m, y) {
        var f = di(ye(m)), w = u(y.ngRef), D = w.assign || function() {
          throw nL("nonassign", 'Expression in ngRef="{0}" is non-assignable!', y.ngRef);
        };
        return function(k, S, $) {
          var E;
          if ($.hasOwnProperty("ngRefRead")) {
            if ($.ngRefRead === "$element")
              E = S;
            else if (E = S.data("$" + $.ngRefRead + "Controller"), !E)
              throw nL(
                "noctrl",
                'The controller for ngRefRead="{0}" could not be found on ngRef="{1}"',
                $.ngRefRead,
                y.ngRef
              );
          } else
            E = S.data("$" + f + "Controller");
          E = E || S, D(k, E), S.on("$destroy", function() {
            w(k) === E && D(k, null);
          });
        };
      }
    };
  }], oM = ["$parse", "$animate", "$compile", function(u, m, y) {
    var f = "$$NG_REMOVED", w = n("ngRepeat"), D = function(Y, X, z, st, ct, It, Ut) {
      Y[z] = st, ct && (Y[ct] = It), Y.$index = X, Y.$first = X === 0, Y.$last = X === Ut - 1, Y.$middle = !(Y.$first || Y.$last), Y.$odd = !(Y.$even = (X & 1) === 0);
    }, k = function(Y) {
      return Y.clone[0];
    }, S = function(Y) {
      return Y.clone[Y.clone.length - 1];
    }, $ = function(Y, X, z) {
      return xo(z);
    }, E = function(Y, X) {
      return X;
    };
    return {
      restrict: "A",
      multiElement: !0,
      transclude: "element",
      priority: 1e3,
      terminal: !0,
      $$tlb: !0,
      compile: function(X, z) {
        var st = z.ngRepeat, ct = y.$$createComment("end ngRepeat", st), It = st.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);
        if (!It)
          throw w(
            "iexp",
            "Expected expression in form of '_item_ in _collection_[ track by _id_]' but got '{0}'.",
            st
          );
        var Ut = It[1], Et = It[2], Dt = It[3], Tt = It[4];
        if (It = Ut.match(/^(?:(\s*[$\w]+)|\(\s*([$\w]+)\s*,\s*([$\w]+)\s*\))$/), !It)
          throw w(
            "iidexp",
            "'_item_' in '_item_ in _collection_' should be an identifier or '(_key_, _value_)' expression, but got '{0}'.",
            Ut
          );
        var Ot = It[3] || It[1], mt = It[2];
        if (Dt && (!/^[$a-zA-Z_][$a-zA-Z0-9_]*$/.test(Dt) || /^(null|undefined|this|\$index|\$first|\$middle|\$last|\$even|\$odd|\$parent|\$root|\$id)$/.test(Dt)))
          throw w(
            "badident",
            "alias '{0}' is invalid --- must be a valid JS identifier which is not a reserved name.",
            Dt
          );
        var ft;
        if (Tt) {
          var Z = { $id: xo }, q = u(Tt);
          ft = function(ut, pt, xt, Mt) {
            return mt && (Z[mt] = pt), Z[Ot] = xt, Z.$index = Mt, q(ut, Z);
          };
        }
        return function(pt, xt, Mt, kt, Gt) {
          var Vt = Ee();
          pt.$watchCollection(Et, function(Bt) {
            var re, Le, $e = xt[0], Xe, ta = Ee(), sa, ba, Qa, Ya, Dn, mn, wn, Ba, xl;
            if (Dt && (pt[Dt] = Bt), O(Bt))
              mn = Bt, Dn = ft || $;
            else {
              Dn = ft || E, mn = [];
              for (var wl in Bt)
                l.call(Bt, wl) && wl.charAt(0) !== "$" && mn.push(wl);
            }
            for (sa = mn.length, Ba = new Array(sa), re = 0; re < sa; re++)
              if (ba = Bt === mn ? re : mn[re], Qa = Bt[ba], Ya = Dn(pt, ba, Qa, re), Vt[Ya])
                wn = Vt[Ya], delete Vt[Ya], ta[Ya] = wn, Ba[re] = wn;
              else {
                if (ta[Ya])
                  throw N(Ba, function(ui) {
                    ui && ui.scope && (Vt[ui.id] = ui);
                  }), w(
                    "dupes",
                    "Duplicates in a repeater are not allowed. Use 'track by' expression to specify unique keys. Repeater: {0}, Duplicate key: {1}, Duplicate value: {2}",
                    st,
                    Ya,
                    Qa
                  );
                Ba[re] = { id: Ya, scope: void 0, clone: void 0 }, ta[Ya] = !0;
              }
            Z && (Z[Ot] = void 0);
            for (var ob in Vt) {
              if (wn = Vt[ob], xl = Ce(wn.clone), m.leave(xl), xl[0].parentNode)
                for (re = 0, Le = xl.length; re < Le; re++)
                  xl[re][f] = !0;
              wn.scope.$destroy();
            }
            for (re = 0; re < sa; re++)
              if (ba = Bt === mn ? re : mn[re], Qa = Bt[ba], wn = Ba[re], wn.scope) {
                Xe = $e;
                do
                  Xe = Xe.nextSibling;
                while (Xe && Xe[f]);
                k(wn) !== Xe && m.move(Ce(wn.clone), null, $e), $e = S(wn), D(wn.scope, re, Ot, Qa, mt, ba, sa);
              } else
                Gt(function(Dr, cb) {
                  wn.scope = cb;
                  var ud = ct.cloneNode(!1);
                  Dr[Dr.length++] = ud, m.enter(Dr, null, $e), $e = ud, wn.clone = Dr, ta[wn.id] = wn, D(wn.scope, re, Ot, Qa, mt, ba, sa);
                });
            Vt = ta;
          });
        };
      }
    };
  }], sL = "ng-hide", iL = "ng-hide-animate", cM = ["$animate", function(u) {
    return {
      restrict: "A",
      multiElement: !0,
      link: function(m, y, f) {
        m.$watch(f.ngShow, function(D) {
          u[D ? "removeClass" : "addClass"](y, sL, {
            tempClasses: iL
          });
        });
      }
    };
  }], dM = ["$animate", function(u) {
    return {
      restrict: "A",
      multiElement: !0,
      link: function(m, y, f) {
        m.$watch(f.ngHide, function(D) {
          u[D ? "addClass" : "removeClass"](y, sL, {
            tempClasses: iL
          });
        });
      }
    };
  }], uM = Co(function(u, m, y) {
    u.$watchCollection(y.ngStyle, function(w, D) {
      D && w !== D && N(D, function(k, S) {
        m.css(S, "");
      }), w && m.css(w);
    });
  }), pM = ["$animate", "$compile", function(u, m) {
    return {
      require: "ngSwitch",
      // asks for $scope to fool the BC controller module
      controller: ["$scope", function() {
        this.cases = {};
      }],
      link: function(y, f, w, D) {
        var k = w.ngSwitch || w.on, S = [], $ = [], E = [], Y = [], X = function(z, st) {
          return function(ct) {
            ct !== !1 && z.splice(st, 1);
          };
        };
        y.$watch(k, function(st) {
          for (var ct, It; E.length; )
            u.cancel(E.pop());
          for (ct = 0, It = Y.length; ct < It; ++ct) {
            var Ut = Ce($[ct].clone);
            Y[ct].$destroy();
            var Et = E[ct] = u.leave(Ut);
            Et.done(X(E, ct));
          }
          $.length = 0, Y.length = 0, (S = D.cases["!" + st] || D.cases["?"]) && N(S, function(Dt) {
            Dt.transclude(function(Tt, Ot) {
              Y.push(Ot);
              var mt = Dt.element;
              Tt[Tt.length++] = m.$$createComment("end ngSwitchWhen");
              var ft = { clone: Tt };
              $.push(ft), u.enter(Tt, mt.parent(), mt);
            });
          });
        });
      }
    };
  }], hM = Co({
    transclude: "element",
    priority: 1200,
    require: "^ngSwitch",
    multiElement: !0,
    link: function(u, m, y, f, w) {
      var D = y.ngSwitchWhen.split(y.ngSwitchWhenSeparator).sort().filter(
        // Filter duplicate cases
        function(k, S, $) {
          return $[S - 1] !== k;
        }
      );
      N(D, function(k) {
        f.cases["!" + k] = f.cases["!" + k] || [], f.cases["!" + k].push({ transclude: w, element: m });
      });
    }
  }), mM = Co({
    transclude: "element",
    priority: 1200,
    require: "^ngSwitch",
    multiElement: !0,
    link: function(u, m, y, f, w) {
      f.cases["?"] = f.cases["?"] || [], f.cases["?"].push({ transclude: w, element: m });
    }
  }), gM = n("ngTransclude"), yM = ["$compile", function(u) {
    return {
      restrict: "EAC",
      compile: function(y) {
        var f = u(y.contents());
        return y.empty(), function(D, k, S, $, E) {
          if (!E)
            throw gM(
              "orphan",
              "Illegal use of ngTransclude directive in the template! No parent directive that requires a transclusion found. Element: {0}",
              Kn(k)
            );
          S.ngTransclude === S.$attr.ngTransclude && (S.ngTransclude = "");
          var Y = S.ngTransclude || S.ngTranscludeSlot;
          E(X, null, Y), Y && !E.isSlotFilled(Y) && z();
          function X(ct, It) {
            ct.length && st(ct) ? k.append(ct) : (z(), It.$destroy());
          }
          function z() {
            f(D, function(ct) {
              k.append(ct);
            });
          }
          function st(ct) {
            for (var It = 0, Ut = ct.length; It < Ut; It++) {
              var Et = ct[It];
              if (Et.nodeType !== Ja || Et.nodeValue.trim())
                return !0;
            }
          }
        };
      }
    };
  }], fM = ["$templateCache", function(u) {
    return {
      restrict: "E",
      terminal: !0,
      compile: function(m, y) {
        if (y.type === "text/ng-template") {
          var f = y.id, w = m[0].text;
          u.put(f, w);
        }
      }
    };
  }], bM = { $setViewValue: J, $render: J };
  function vl(u, m) {
    u.prop("selected", m), u.attr("selected", m);
  }
  var vM = [
    "$element",
    "$scope",
    /** @this */
    function(u, m) {
      var y = this, f = new Lp();
      y.selectValueMap = {}, y.ngModelCtrl = bM, y.multiple = !1, y.unknownOption = p(s.document.createElement("option")), y.hasEmptyOption = !1, y.emptyOption = void 0, y.renderUnknownOption = function($) {
        var E = y.generateUnknownOptionValue($);
        y.unknownOption.val(E), u.prepend(y.unknownOption), vl(y.unknownOption, !0), u.val(E);
      }, y.updateUnknownOption = function($) {
        var E = y.generateUnknownOptionValue($);
        y.unknownOption.val(E), vl(y.unknownOption, !0), u.val(E);
      }, y.generateUnknownOptionValue = function($) {
        return "? " + xo($) + " ?";
      }, y.removeUnknownOption = function() {
        y.unknownOption.parent() && y.unknownOption.remove();
      }, y.selectEmptyOption = function() {
        y.emptyOption && (u.val(""), vl(y.emptyOption, !0));
      }, y.unselectEmptyOption = function() {
        y.hasEmptyOption && vl(y.emptyOption, !1);
      }, m.$on("$destroy", function() {
        y.renderUnknownOption = J;
      }), y.readValue = function() {
        var E = u.val(), Y = E in y.selectValueMap ? y.selectValueMap[E] : E;
        return y.hasOption(Y) ? Y : null;
      }, y.writeValue = function(E) {
        var Y = u[0].options[u[0].selectedIndex];
        if (Y && vl(p(Y), !1), y.hasOption(E)) {
          y.removeUnknownOption();
          var X = xo(E);
          u.val(X in y.selectValueMap ? X : E);
          var z = u[0].options[u[0].selectedIndex];
          vl(p(z), !0);
        } else
          y.selectUnknownOrEmptyOption(E);
      }, y.addOption = function($, E) {
        if (E[0].nodeType !== _n) {
          Pe($, '"option value"'), $ === "" && (y.hasEmptyOption = !0, y.emptyOption = E);
          var Y = f.get($) || 0;
          f.set($, Y + 1), D();
        }
      }, y.removeOption = function($) {
        var E = f.get($);
        E && (E === 1 ? (f.delete($), $ === "" && (y.hasEmptyOption = !1, y.emptyOption = void 0)) : f.set($, E - 1));
      }, y.hasOption = function($) {
        return !!f.get($);
      }, y.$hasEmptyOption = function() {
        return y.hasEmptyOption;
      }, y.$isUnknownOptionSelected = function() {
        return u[0].options[0] === y.unknownOption[0];
      }, y.$isEmptyOptionSelected = function() {
        return y.hasEmptyOption && u[0].options[u[0].selectedIndex] === y.emptyOption[0];
      }, y.selectUnknownOrEmptyOption = function($) {
        $ == null && y.emptyOption ? (y.removeUnknownOption(), y.selectEmptyOption()) : y.unknownOption.parent().length ? y.updateUnknownOption($) : y.renderUnknownOption($);
      };
      var w = !1;
      function D() {
        w || (w = !0, m.$$postDigest(function() {
          w = !1, y.ngModelCtrl.$render();
        }));
      }
      var k = !1;
      function S($) {
        k || (k = !0, m.$$postDigest(function() {
          m.$$destroyed || (k = !1, y.ngModelCtrl.$setViewValue(y.readValue()), $ && y.ngModelCtrl.$render());
        }));
      }
      y.registerOption = function($, E, Y, X, z) {
        if (Y.$attr.ngValue) {
          var st, ct;
          Y.$observe("value", function(Ut) {
            var Et, Dt = E.prop("selected");
            tt(ct) && (y.removeOption(st), delete y.selectValueMap[ct], Et = !0), ct = xo(Ut), st = Ut, y.selectValueMap[ct] = Ut, y.addOption(Ut, E), E.attr("value", ct), Et && Dt && S();
          });
        } else
          X ? Y.$observe("value", function(Ut) {
            y.readValue();
            var Et, Dt = E.prop("selected");
            tt(st) && (y.removeOption(st), Et = !0), st = Ut, y.addOption(Ut, E), Et && Dt && S();
          }) : z ? $.$watch(z, function(Ut, Et) {
            Y.$set("value", Ut);
            var Dt = E.prop("selected");
            Et !== Ut && y.removeOption(Et), y.addOption(Ut, E), Et && Dt && S();
          }) : y.addOption(Y.value, E);
        Y.$observe("disabled", function(It) {
          (It === "true" || It && E.prop("selected")) && (y.multiple ? S(!0) : (y.ngModelCtrl.$setViewValue(null), y.ngModelCtrl.$render()));
        }), E.on("$destroy", function() {
          var It = y.readValue(), Ut = Y.value;
          y.removeOption(Ut), D(), (y.multiple && It && It.indexOf(Ut) !== -1 || It === Ut) && S(!0);
        });
      };
    }
  ], xM = function() {
    return {
      restrict: "E",
      require: ["select", "?ngModel"],
      controller: vM,
      priority: 1,
      link: {
        pre: u,
        post: m
      }
    };
    function u(y, f, w, D) {
      var k = D[0], S = D[1];
      if (!S) {
        k.registerOption = J;
        return;
      }
      if (k.ngModelCtrl = S, f.on("change", function() {
        k.removeUnknownOption(), y.$apply(function() {
          S.$setViewValue(k.readValue());
        });
      }), w.multiple) {
        k.multiple = !0, k.readValue = function() {
          var X = [];
          return N(f.find("option"), function(z) {
            if (z.selected && !z.disabled) {
              var st = z.value;
              X.push(st in k.selectValueMap ? k.selectValueMap[st] : st);
            }
          }), X;
        }, k.writeValue = function(X) {
          N(f.find("option"), function(z) {
            var st = !!X && (ue(X, z.value) || ue(X, k.selectValueMap[z.value])), ct = z.selected;
            st !== ct && vl(p(z), st);
          });
        };
        var $, E = NaN;
        y.$watch(function() {
          E === S.$viewValue && !je($, S.$viewValue) && ($ = Ts(S.$viewValue), S.$render()), E = S.$viewValue;
        }), S.$isEmpty = function(Y) {
          return !Y || Y.length === 0;
        };
      }
    }
    function m(y, f, w, D) {
      var k = D[1];
      if (k) {
        var S = D[0];
        k.$render = function() {
          S.writeValue(k.$viewValue);
        };
      }
    }
  }, wM = ["$interpolate", function(u) {
    return {
      restrict: "E",
      priority: 100,
      compile: function(m, y) {
        var f, w;
        return tt(y.ngValue) || (tt(y.value) ? f = u(y.value, !0) : (w = u(m.text(), !0), w || y.$set("value", m.text()))), function(D, k, S) {
          var $ = "$selectController", E = k.parent(), Y = E.data($) || E.parent().data($);
          Y && Y.registerOption(D, k, S, f, w);
        };
      }
    };
  }], rL = ["$parse", function(u) {
    return {
      restrict: "A",
      require: "?ngModel",
      link: function(m, y, f, w) {
        if (w) {
          var D = f.hasOwnProperty("required") || u(f.ngRequired)(m);
          f.ngRequired || (f.required = !0), w.$validators.required = function(k, S) {
            return !D || !w.$isEmpty(S);
          }, f.$observe("required", function(k) {
            D !== k && (D = k, w.$validate());
          });
        }
      }
    };
  }], lL = ["$parse", function(u) {
    return {
      restrict: "A",
      require: "?ngModel",
      compile: function(m, y) {
        var f, w;
        return y.ngPattern && (f = y.ngPattern, y.ngPattern.charAt(0) === "/" && i.test(y.ngPattern) ? w = function() {
          return y.ngPattern;
        } : w = u(y.ngPattern)), function(D, k, S, $) {
          if ($) {
            var E = S.pattern;
            S.ngPattern ? E = w(D) : f = S.pattern;
            var Y = dL(E, f, k);
            S.$observe("pattern", function(X) {
              var z = Y;
              Y = dL(X, f, k), (z && z.toString()) !== (Y && Y.toString()) && $.$validate();
            }), $.$validators.pattern = function(X, z) {
              return $.$isEmpty(z) || j(Y) || Y.test(z);
            };
          }
        };
      }
    };
  }], oL = ["$parse", function(u) {
    return {
      restrict: "A",
      require: "?ngModel",
      link: function(m, y, f, w) {
        if (w) {
          var D = f.maxlength || u(f.ngMaxlength)(m), k = Up(D);
          f.$observe("maxlength", function(S) {
            D !== S && (k = Up(S), D = S, w.$validate());
          }), w.$validators.maxlength = function(S, $) {
            return k < 0 || w.$isEmpty($) || $.length <= k;
          };
        }
      }
    };
  }], cL = ["$parse", function(u) {
    return {
      restrict: "A",
      require: "?ngModel",
      link: function(m, y, f, w) {
        if (w) {
          var D = f.minlength || u(f.ngMinlength)(m), k = Up(D) || -1;
          f.$observe("minlength", function(S) {
            D !== S && (k = Up(S) || -1, D = S, w.$validate());
          }), w.$validators.minlength = function(S, $) {
            return w.$isEmpty($) || $.length >= k;
          };
        }
      }
    };
  }];
  function dL(u, m, y) {
    if (u) {
      if (nt(u) && (u = new RegExp("^" + u + "$")), !u.test)
        throw n("ngPattern")(
          "noregexp",
          "Expected {0} to be a RegExp but was {1}. Element: {2}",
          m,
          u,
          Kn(y)
        );
      return u;
    }
  }
  function Up(u) {
    var m = U(u);
    return M(m) ? -1 : m;
  }
  if (s.angular.bootstrap) {
    s.console && console.log("WARNING: Tried to load AngularJS more than once.");
    return;
  }
  Pt(), fp(C), C.module("ngLocale", [], ["$provide", function(u) {
    var m = { ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other" };
    function y(w) {
      w = w + "";
      var D = w.indexOf(".");
      return D == -1 ? 0 : w.length - D - 1;
    }
    function f(w, D) {
      var k = D;
      k === void 0 && (k = Math.min(y(w), 3));
      var S = Math.pow(10, k), $ = (w * S | 0) % S;
      return { v: k, f: $ };
    }
    u.value("$locale", {
      DATETIME_FORMATS: {
        AMPMS: [
          "AM",
          "PM"
        ],
        DAY: [
          "Sunday",
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday"
        ],
        ERANAMES: [
          "Before Christ",
          "Anno Domini"
        ],
        ERAS: [
          "BC",
          "AD"
        ],
        FIRSTDAYOFWEEK: 6,
        MONTH: [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December"
        ],
        SHORTDAY: [
          "Sun",
          "Mon",
          "Tue",
          "Wed",
          "Thu",
          "Fri",
          "Sat"
        ],
        SHORTMONTH: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec"
        ],
        STANDALONEMONTH: [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December"
        ],
        WEEKENDRANGE: [
          5,
          6
        ],
        fullDate: "EEEE, MMMM d, y",
        longDate: "MMMM d, y",
        medium: "MMM d, y h:mm:ss a",
        mediumDate: "MMM d, y",
        mediumTime: "h:mm:ss a",
        short: "M/d/yy h:mm a",
        shortDate: "M/d/yy",
        shortTime: "h:mm a"
      },
      NUMBER_FORMATS: {
        CURRENCY_SYM: "$",
        DECIMAL_SEP: ".",
        GROUP_SEP: ",",
        PATTERNS: [
          {
            gSize: 3,
            lgSize: 3,
            maxFrac: 3,
            minFrac: 0,
            minInt: 1,
            negPre: "-",
            negSuf: "",
            posPre: "",
            posSuf: ""
          },
          {
            gSize: 3,
            lgSize: 3,
            maxFrac: 2,
            minFrac: 2,
            minInt: 1,
            negPre: "-¤",
            negSuf: "",
            posPre: "¤",
            posSuf: ""
          }
        ]
      },
      id: "en-us",
      localeID: "en_US",
      pluralCat: function(w, D) {
        var k = w | 0, S = f(w, D);
        return k == 1 && S.v == 0 ? m.ONE : m.OTHER;
      }
    });
  }]), p(function() {
    yo(s.document, Jc);
  });
})(window);
!window.angular.$$csp().noInlineStyle && window.angular.element(document.head).prepend(window.angular.element("<style>").text('@charset "UTF-8";[ng\\:cloak],[ng-cloak],[data-ng-cloak],[x-ng-cloak],.ng-cloak,.x-ng-cloak,.ng-hide:not(.ng-hide-animate){display:none !important;}ng\\:form{display:block;}.ng-animate-shim{visibility:hidden;}.ng-anchor{position:absolute;}'));
var GX = angular;
const wt = /* @__PURE__ */ Hs(GX);
class nn {
  /**
   * Creates a new CrudControllerBase.
   * @param api Api module typically defined in @salaxy/core used for communicating to server.
   * @param uiHelpers - Salaxy ui helpers service.
   * @param $location Angular.js Location service that is used for navigation. Especially the list views.
   * @param $routeParams - Angular.js routing component
   */
  constructor(t, e, a, n) {
    if (this.api = t, this.uiHelpers = e, this.$location = a, this.$routeParams = n, this._status = "noInit", this.initStatus = {
      isInitDone: !1,
      isReloadRequested: !1
    }, this.delete = (i, r) => this.parentController ? this.parentController.delete(i, r) : (i = i || this.current, this.uiHelpers.showConfirm(r || "SALAXY.NG1.ApiCrudObjectComponent.deleteDialog").then((l) => l ? this.deleteNoConfirm(i).then(() => (this.current === i && (this._currentId = null, this._current = null, this._original = null, this._status = "noInit"), this.uiHelpers.wait().then(() => (this.odataController ? this.odataController.reload() : this.$location.url(this.getDefaults().listUrl), !0)))) : Promise.resolve(!1))), !t)
      throw new Error("api is undefined in ApiCrudObjectController");
    if (!e)
      throw new Error("uiHelpers is undefined in ApiCrudObjectController");
    if (!a)
      throw new Error("$location is undefined in ApiCrudObjectController");
    if (!n)
      throw new Error("$routeParams is undefined in ApiCrudObjectController");
  }
  /**
   * Implement IController by providing onInit method.
   * We currently do nothing here, but if you override this function,
   * you should call this method in base class for future compatibility.
   */
  $onInit() {
    this.bindingMode = this.bindingMode || "null", this.initStatus.isReloadRequested && (this.initStatus.isReloadRequested = !1, this.reload()), this.initStatus.isInitDone = !0;
  }
  /** URL for the OData list service */
  get odataServiceUrl() {
    return this.parentController ? this.parentController.odataServiceUrl : this.api.getODataUrl();
  }
  /**
   * Set the Current selected item (the model).
   * The model may be:
   *
   * - TItem: A bound item (default), which can also be null.
   * - ApiCrudObjectController<TItem>: Parent controller of the same type. Model is fetched from its current and all methods are delegated.
   * - "new": A new item is created.
   * - "url": Fetches the item from the server using the id query string (crudItemId in routeParams).
   * - string: Any other string is interpreted as id which is used to fetch the item from the server.
   */
  set model(t) {
    if (this._model = t, !t)
      this._currentId = null, this.bindingMode = "null", this.parentController = null;
    else if (t === "new")
      this._currentId = null, this.bindingMode = "new", this.parentController = null;
    else if (t === "url")
      this._currentId = this.getRouteData().id, this.bindingMode = this.currentId ? "url" : "null", this.parentController = null, this.action = this.action || this.getRouteData().action;
    else if (wt.isString(t))
      this._currentId = t, this.bindingMode = this.currentId ? "id" : "null", this.parentController = null;
    else if (t && t.$onInit) {
      this.bindingMode = "parentCtrl", this.parentController = t, this.action = this.parentController.action;
      return;
    } else
      this._currentId = null, this.bindingMode = "model", this.parentController = null;
    this.action = this.action || "default", this.initStatus.isInitDone ? this.reload() : this.initStatus.isReloadRequested = !0;
  }
  /** Gets the Current selected item (the model).  */
  get model() {
    return this._model;
  }
  /** Gets the Current selected item. */
  get current() {
    return this.parentController ? this.parentController.current : this._current;
  }
  /** The current Id for the controller. */
  get currentId() {
    return this.parentController ? this.parentController.currentId : this._currentId || (this.current ? this.current.id : null);
  }
  /** Gets the Original item before changes. */
  get original() {
    return this.parentController ? this.parentController.original : this._original;
  }
  /** Gets the isReadOnlyForced status. */
  get isReadOnlyForced() {
    return this.parentController ? this.parentController.isReadOnlyForced : this._isReadOnlyForced;
  }
  /** Sets the isReadOnlyForced status. */
  set isReadOnlyForced(t) {
    t !== void 0 && (this.parentController ? this.parentController.isReadOnlyForced = t : this._isReadOnlyForced = t);
  }
  /** If true, this is a new unsaved object */
  isNew() {
    return this.parentController ? this.parentController.isNew() : !this.currentId || this.currentId === "new" || this.action === "copy-as-new";
  }
  /** If true, the component is in the middle of loading data. */
  get isLoading() {
    switch (this.status) {
      case "initialLoading":
      case "reloading":
        return !0;
      case "loaded":
      case "loadError":
      case "noInit":
      default:
        return !1;
    }
  }
  /**
   * If true, the form controls should be disabled.
   */
  get isDisabled() {
    switch (this.status) {
      case "initialLoading":
      case "reloading":
      case "loadError":
      case "noInit":
        return !0;
      case "loaded":
      default:
        return !1;
    }
  }
  /**
   * If true, the form controls should be read-only (no input control at all).
   */
  get isReadOnly() {
    return this.status === "noInit" || this.status === "initialLoading" || !this.current || this.current.isReadOnly || this.isReadOnlyForced || !1;
  }
  /** Returns true, if the current object has changes. */
  get hasChanges() {
    return this.parentController ? this.parentController.hasChanges : !wt.equals(this._original, this._current);
  }
  /**
   * Gets the status of the data if it is being loaded from a remote server.
   */
  get status() {
    return this.parentController ? this.parentController.status : this._status;
  }
  /** Makes an OData query  */
  getOData(t, e = null) {
    return this.api.getOData(t).then((a) => (e && Object.assign(e, a), e ?? a));
  }
  /** Returns base url of the underlying api. */
  getBaseUrl() {
    return this.api.getBaseUrl();
  }
  /** Gets the data transmitted in the route / url */
  getRouteData() {
    const t = {
      id: null,
      action: null
    };
    if (this.$routeParams && this.$routeParams.crudItemId) {
      let e = this.$routeParams.crudItemId.split("/");
      e = e.map((a) => a && a.replace(/[?&#](.*)/g, "")), t.id = e[0] || null, e[1] && (t.action = e[1]);
    }
    return t;
  }
  /** Save changes to the current item */
  save(t = void 0) {
    if (this.parentController)
      return this.parentController.save(t);
    const e = this.isNew(), a = this.uiHelpers.showLoading("SALAXY.UI_Terms.isSaving");
    return this._status = "reloading", this.api.save(this.current, t).then((n) => (a.dismiss(), this._current = n, this._original = wt.copy(n), this._status = "loaded", this.bindingMode === "url" && e && (this.$location.url(this.getDefaults().detailsUrl + n.id), this.action = "default"), n)).catch((n) => (a.dismiss(), this._status = "loadError", null));
  }
  /** Reset the changes in the current element */
  reset() {
    return this.parentController ? this.parentController.reset() : wt.copy(this._original, this._current);
  }
  /**
   * Shows the detail view for the item.
   * Typically, this takes the user to a new page with the ID.
   * @param item Item may be either Container or list item.
   */
  showDetails(t) {
    return this.parentController ? this.parentController.showDetails(t) : this.$location.url(this.getDefaults().detailsUrl + this.getId(t));
  }
  /**
   * Shows the detail view with a new item that is a copy of the given item.
   * Typically, this takes the user to a new page with the ID with action "copy-as-new".
   * @param item Item may be either Container or list item.
   */
  showCopyAsNew(t) {
    return this.parentController ? this.parentController.showCopyAsNew(t) : this.$location.url(this.getDefaults().detailsUrl + this.getId(t) + "/copy-as-new");
  }
  /**
   * Gets the id for the object regardless of whther the object is Container or list item.
   * Error is thrown if the item does not exist.
   * The method is an extension point for future item types that may have other ID's in the future.
   * @param item The item for which to fetch the ID.
   */
  getId(t) {
    if (!t)
      throw new Error("getId called for null item.");
    return t.containerGuid ? t.containerGuid : t.id;
  }
  /**
   * Deletes an item without showing the confirm dialog.
   * The method shows the "Please wait..." loader, but does not refresh the
   * list or move the browser to listUrl. The caller should take care
   * of the UX actions after delete if necessary.
   * @param item Item to be deleted.
   * @returns Promise that resolves to true (never false). Fails if the deletion fails.
   */
  deleteNoConfirm(t) {
    if (this.parentController)
      return this.parentController.deleteNoConfirm(t);
    if (!t)
      throw new Error("item not specified in deleteNoConfirm.");
    const e = this.uiHelpers.showLoading("SALAXY.UI_Terms.wait");
    return this.api.delete(this.getId(t)).then(() => this.uiHelpers.wait(1e3).then(() => (e.dismiss(), !0)));
  }
  /**
   * Creates a copy of a given item.
   * This is a synchronous method that should basically convert a saved item to a new item.
   * @param copySource Item (container item) to copy as new.
   */
  copyItem(t) {
    const e = JSON.parse(JSON.stringify(t));
    return e.id = null, e.owner = null, e.isReadOnly = !1, e;
  }
  /**
   * Starts the reload process depending on the bindingMode:
   */
  reload() {
    if (this.parentController)
      return this._currentId = this.parentController.currentId, this.parentController.reload().then((t) => (this._currentId = this.parentController.currentId, t));
    switch (this.bindingMode) {
      case "id":
      case "url":
        return this.bindingMode === "url" && (this._currentId = this.getRouteData().id, !this.currentId) ? (this.setCurrentRef(null), this._status = "loaded", Promise.resolve(this.current)) : this.currentId === "new" ? (this.setCurrentRef(this.api.getBlank()), this._currentId = null, this._status = "loaded", Promise.resolve(this.current)) : this.setStatus(this.api.getSingle(this.currentId)).then((t) => {
          if (!t)
            throw this._status = "loadError", new Error(`Item ${this.currentId} not found.`);
          return this.action === "copy-as-new" && (t = this.copyItem(t)), this.setCurrentRef(t), t;
        });
      case "model":
        return this.setCurrentRef(this._model), this._currentId = this.current ? this.current.id : null, this._status = this.current ? "loaded" : "noInit", Promise.resolve(this.current);
      case "parentCtrl":
        throw new Error("Binding mode parentCtrl without parentController.");
      case "new":
        return this.setCurrentRef(this.api.getBlank()), this._currentId = null, this._status = "loaded", Promise.resolve(this.current);
      case "null":
      default:
        return this.setCurrentRef(null), this._currentId = null, this._status = "loaded", Promise.resolve(this.current);
    }
  }
  /**
   * Sets the current item as the given object (reference to a new object).
   * This also resets the original item. This method is typically used when the object is first loaded,
   * when object that is being edited is changed or when object is reloaded from server after saving.
   * @param item The new current item.
   */
  setCurrentRef(t) {
    if (this.parentController)
      return this.parentController.setCurrentRef(t);
    this._current = t, this._original = wt.copy(t);
  }
  /**
   * Sets the current item value:
   * The object reference remains the same, but all its properties are copied using angular.copy().
   * Original object remains as-is by default. This method is typically used at the end of modifyinjg user interfaces.
   * @param item The new current item.
   * @param resetOriginal If true, also resets the orginal value.
   */
  setCurrentValue(t, e = !1) {
    if (this.parentController)
      return this.parentController.setCurrentValue(t, e);
    this._current ? wt.copy(t, this._current) : this._current = t, e && (this._original = wt.copy(t));
  }
  /**
   * Sets the current item. This also resets the original item.
   * @param item The new current item.
   * @param keepOriginalAsIs If true, will not update the original.
   */
  setCurrent(t, e = !1) {
    if (this.parentController)
      return this.parentController.setCurrent(t, e);
    this._current ? wt.copy(t, this._current) : this._current = t, e || (this._original = wt.copy(t));
  }
  /**
   * Calls a promise updating the status on the controller.
   * @param loadAction The promise that executes the loading from server.
   * If action is null, the status is directly set as "loaded".
   */
  setStatus(t) {
    if (this.parentController)
      return this.parentController.setStatus(t);
    if (!t)
      return this._status = "loaded", null;
    switch (this._status) {
      case "noInit":
        this._status = "initialLoading";
        break;
      case "initialLoading":
        this._status = "initialLoading";
        break;
      case "loadError":
        this._status = this.current ? "reloading" : "initialLoading";
        break;
      case "loaded":
        this._status = "reloading";
        break;
      case "reloading":
        this._status = "reloading";
        break;
      default:
        throw Error("Unexpected status: " + this._status);
    }
    return t.then((e) => (this._status = "loaded", e)).catch((e) => (this._status = "loadError", null));
  }
  /**
   * Adds/updates the workflow event for the current using API.
   * @param wfEvent - Workflow event to add/update.
   * @returns - Reloaded item.
   */
  saveWorkflowEvent(t) {
    return this.api.saveWorkflowEvent(this.current, t).then(() => this.reload());
  }
  /**
   * Deletes the given event or all events with given type using API.
   * @param wfIdOrType Id or type of the workflow event.
   * @returns - Reloaded item.
   */
  deleteWorkflowEvent(t) {
    return this.api.deleteWorkflowEvent(this.current, t).then(() => this.reload());
  }
  /**
   * Gets a single workflow event for the item.
   * @param wfId Id of the workflow event.
   * @returns - Single workflow event
   */
  getWorkflowEvent(t) {
    return this.api.getWorkflowEvent(this.current, t);
  }
  /** Returns the current api */
  getApi() {
    return this.api;
  }
  /**
   * Returns the versions for the current item.
   */
  get versions() {
    return (!this._versions || this._versionsId !== this.currentId) && (this._versions = this._versions ?? [], this._versions.splice(0, this._versions.length), this._versionsId = this.currentId, this.currentId && this.api.getVersions(this.currentId).then((t) => {
      this._versions.push(...t);
    })), this._versions;
  }
  /**
   * Gets a version of the current item.
   * @param version VersionInfo of the item.
   */
  getVersion(t) {
    return (!this._version || this._versionId !== `${this.currentId}-${t?.versionId}`) && (this._version = this._version ?? { version: {}, item: null }, wt.copy(t, this._version.version), this._version.item = null, this._versionId = `${this.currentId}-${t?.versionId}`, this.currentId && this.api.getVersion(this.currentId, t?.versionId).then((e) => {
      this._version.item = e;
    })), this._version;
  }
}
class fa {
  constructor() {
    this.detailsUrl = "@", this.listUrl = "@", this.model = "<", this.isReadOnlyForced = "<";
  }
}
class Ki {
  /**
   * Creates a new ListControllerBase.
   * @param uiHelpers - Salaxy ui helpers service for dialogs etc.
   */
  constructor(t) {
    if (this.uiHelpers = t, !t)
      throw new Error("uiHelpers is undefined in ListControllerBase");
  }
  /**
   * Implement IController by providing onInit method.
   * We currently do nothing here, but if you override this function,
   * you should call this method in base class for future compatibility.
   */
  $onInit() {
  }
  /**
   * Gets or sets the parent object that contains the list that is being edited.
   * Typically this parent object is an ApiCrudObject.
   */
  get parent() {
    return this._parent;
  }
  set parent(t) {
    this.original = wt.copy(this.parent), this._parent = t;
  }
  /**
   * Possiblity to define additional logic that is passed to the edit dialog as $ctrl.logic.
   * This may contain additional metadata as well as functions.
   */
  getEditDialogLogic() {
    return {};
  }
  /** View should call this method if there is a UI component that fires commit (typically save) to the parent. */
  commit() {
    this.isInEdit = !1, this.onCommit && this.onCommit({
      parent: this.parent,
      list: this.list
    });
  }
  /** View should call this method if there is a UI component that fires reset / cancel to the parent. */
  reset() {
    this.isInEdit = !1, this.onReset && this.onReset({
      parent: this.parent
      // TODO: Add possibility to signal that reset has been done (from parent back to child).
    }), this.original && wt.copy(this.original, this.parent);
  }
  /**
   * Returns true if the parent can be edited by this component.
   * Takes into account parent being null, isReadOnly and the "read-only" mode of the component.
   */
  get isEditable() {
    return !(!this.parent || this.parent.isReadOnly || this.mode === "read-only");
  }
  /**
   * Gets or sets the flag telling whether the component is in edit or read-only mode.
   * This is restricted by the mode and isReadOnly of the parent calculation.
   */
  get isInEdit() {
    return this.isEditable ? this.mode === "edit" ? !0 : !!this._isInEdit : !1;
  }
  set isInEdit(t) {
    this._isInEdit = t;
  }
  /**
   * View should call this method if the component is changed from read-only mode to edit mode.
   * Not all components support read-only vs. edit modes.
   */
  startEdit() {
    this.isEditable && (this.isInEdit = !0, this.onStartEdit({
      parent: this.parent
    }));
  }
  /**
   * Deletes an item from list (no confirm etc.)
   * The method shows the "Please wait..." loader, but does not call onDelete
   * or move the browser to listUrl. The caller should take care
   * of the UX actions after delete if necessary.
   * @param item Item to delete.
   * @returns Promise that resolves to true (never false). Fails if the deletion fails.
   */
  delete(t) {
    return this.list.splice(this.list.indexOf(t), 1);
  }
  /**
   * Shows the edit dialog.
   * @param item Item to edit or string "new" for creating a new one.
   * @param isNew Optional way of specifying that the item is a new item (with default values, not yet added to the list).
   * If item is string "new", this parameter will have no effect (will always be true).
   */
  showEditDialog(t, e = !1) {
    if (!t)
      throw new Error("showEditDialog called without a parameter.");
    t === "new" && (e = !0, t = this.getBlank()), this.uiHelpers.openEditDialog(this.getEditDialogTemplateUrl(), t, this.getEditDialogLogic()).then((a) => {
      a.action === "ok" || a.action === "ok-no-save" ? (e && this.list.push(a.item), (e || a.hasChanges) && a.action !== "ok-no-save" && this.commit()) : (a.action === "delete" || a.action === "delete-no-save") && (e || (this.delete(t), a.action !== "delete-no-save" && this.commit()));
    });
  }
}
class $r {
  constructor() {
    this.parent = "<", this.onCommit = "&", this.onReset = "&", this.onStartEdit = "&", this.isInEdit = "<", this.mode = "@";
  }
}
const yC = class yC {
  constructor(t) {
    this.ajax = t, this.$onInit = () => {
    };
  }
  /**
   * Gets the "No items" message if there is no items to show.
   * Null, if there are rows to show.
   * The message changesdepending on the situation: No items, Not initiated, Authentication required.
   */
  getNoItemsMessage() {
    return this.$odata.items && this.$odata.items.length > 0 ? null : !this.$odata.options.anon && this.ajax.getTokenStatus() !== "ok" ? "SALAXY.NG1.ODataFooterComponent.getNoItemsMessage.anon" : this.$odata.status === "noInit" ? "OData Service not initialized: Set url property or call setUrl()." : this.$odata.status === "loadError" ? "SALAXY.NG1.ODataFooterComponent.getNoItemsMessage.loadError" : this.$odata.status === "reloading" ? null : this.$odata.status === "initialLoading" ? "SALAXY.UI_Terms.loading" : (this.$odata.status === "loaded", "SALAXY.NG1.ODataFooterComponent.getNoItemsMessage.noItems");
  }
  /** Gets the CSS classes for No items message  */
  getNoItemsCssClass() {
    return this.$odata.items && this.$odata.items.length > 0 ? "" : this.$odata.status === "noInit" || this.$odata.status === "loadError" ? "alert alert-danger" : "alert alert-default";
  }
  /** Gets the paging view to show */
  getPagingView() {
    if (this.$odata.nextPageLink)
      return this.nextPageUrl ? "url" : "nextPageLink";
    if (this.$odata.options.$top)
      return this.$odata.count ? this.$odata.count > this.$odata.items.length ? this.nextPageUrl ? "url" : "clientLimit" : "allVisible" : !this.$odata.items || this.$odata.items.length < (this.$odata.options.$skip || 0) + this.$odata.options.$top ? "allVisible" : this.nextPageUrl ? "url" : "clientLimit";
  }
};
yC.$inject = ["AjaxNg1"];
let rm = yC;
const fC = class fC {
  /**
   * Creates a new controller instance
   * @ignore
   */
  constructor(t, e, a, n, i, r) {
    this.cacheService = t, this.ajax = e, this.$timeout = a, this.$scope = n, this.$controller = i, this.uiHelpers = r, this._status = "noInit", this.count = null, this.nextPageLink = null, this.reader = null, this.$onInit = () => {
      this.reader || (this.reader = this.ajax), this.options || (this.options = {
        $count: !1
      }), this.crudController && (this.$crudController = this.$controller(this.crudController, { $scope: this.$scope }), this.$crudController.odataController = this, this.crudBindings && Object.keys(this.crudBindings).forEach((l) => {
        this.$crudController[l] = this.crudBindings[l];
      }), this.$crudController.$onInit()), this.selectedItems = this.selectedItems || [], this.items = this.items || [], this.reload();
    }, this.$onDestroy = () => {
      wt.isDefined(this.filterTimeout) && this.$timeout.cancel(this.filterTimeout);
    };
  }
  /**
   * Gets the status of the data if it is being loaded from a remote server.
   */
  get status() {
    return this._status;
  }
  /**
   * Set the URL and start reload.
   * @param url OData enndpoint
   * @param queryOptions Optional initial query options.
   */
  setUrl(t, e) {
    this.url = t, this.options = e || this.options, this.reload();
  }
  /**
   * Sets query options. Does not trigger reload.
   * @param queryOptions Query options.
   */
  setQueryOptions(t) {
    this.options = t || this.options;
  }
  /**
   * Method to set the sort by for a column
   * @param column Column to sort by
   * @param direction Optional direction is either "asc" for ascending or "desc" for descending.
   * If direction is not set, will reverse the sort order or ascending being the default.
   */
  orderBy(t, e) {
    e || (e = this.getColumnOrder(t) === "asc" ? "desc" : "asc"), this.options.$orderby = t + " " + e, this.options.$skip = 0, this.reload();
  }
  /**
   * Sets a column filter and reloads the data set.
   * @param column Name of the column.
   * Set the column name as null, if you want to clear all filters.
   * @param value Value of the filter. Null clears the filter (not filter-by-null).
   * TODO: This could potententially be a comma separated value if requirement comes up.
   * @param operation Possibility to negate the equality.
   * @param andFilters If set, adds these additional filters (with and) to the new primary filter.
   * @param valueType Type for the value. Default is string, other option is date
   */
  setFilter(t, e, a = "eq", n, i = "string") {
    t && e ? (this.options.$filter = `${t} ${a || "eq"} ` + (i == "date" ? `${e}` : `'${e}'`), n && (this.options.$filter += " and (" + n + ")")) : this.options.$filter = n || null, this.options.$skip = 0, this.reload();
  }
  /**
   * Gets the text indicating the time that has passed since the data was loaded.
   */
  getLoadedTime(t = "min") {
    if (!this.loadedAt)
      return null;
    const e = (/* @__PURE__ */ new Date()).getTime() - this.loadedAt;
    switch (t) {
      case "min": {
        const a = Math.floor(e / 6e4);
        return a < 1 ? null : a;
      }
      case "10sec":
        return Math.floor(e / 1e4) * 10;
      case "sec":
        return Math.floor(e / 1e3);
    }
  }
  /** Clears the cache and reloads from the server. */
  refresh() {
    this.cacheService.clear(this.cacheKey), this.reload();
  }
  /** Clears the entire cache - all keys and reloads. */
  refreshClearAll() {
    this.cacheService.clearAllKeys(), this.reload();
  }
  /**
   * Sets an item as selected.
   * @param item Item to set as selected
   * @param value Selected true / false or "toggle" to toggle to other value.
   */
  setSelected(t, e = !0) {
    const a = this.selectedItems.findIndex((i) => i.id === t.id), n = a >= 0;
    switch (n && this.selectedItems.splice(a, 1), e) {
      case !0:
        this.selectedItems.push(t);
        break;
      case !1:
        break;
      case "toggle":
        n || this.selectedItems.push(t);
        break;
    }
    this.onListSelect({
      value: e === "toggle" ? !n : e,
      item: t,
      allItems: this.selectedItems
    });
  }
  /**
   * Returns true if the item is selected.
   * @param item Item to check for selected value.
   */
  isSelected(t) {
    return this.selectedItems.findIndex((e) => e.id === t.id) >= 0;
  }
  /** Unselect all */
  unselectAll() {
    this.selectedItems && this.selectedItems.splice(0, this.selectedItems.length);
  }
  /** Select all */
  selectAll() {
    this.selectedItems && this.items && (this.selectedItems.splice(0, this.selectedItems.length), this.selectedItems.push(...this.items));
  }
  /**
   * Gets a column ordering for the specified column.
   * @param columnName Name of the column
   * @returns Column order "asc" or "desc" if column is being sorted. Otherwise null.
   */
  getColumnOrder(t) {
    if (!t || !(this.options.$orderby || "").trim())
      return null;
    const e = this.options.$orderby.split(",");
    for (const a of e) {
      const n = a.trim().split(/\s+/);
      if (n[0].trim().toLowerCase() === t.trim().toLowerCase())
        return n.length > 1 && n[1].trim().toLowerCase() === "desc" ? "desc" : "asc";
    }
  }
  /**
   * Loads items on next page
   * @param append If true, appends the data of the next page link to the current set of items
   */
  loadNextPage(t) {
    if (this.nextPageLink) {
      const e = this.nextPageLink.indexOf("?");
      if (e >= 0) {
        const a = new URLSearchParams(this.nextPageLink.substr(e));
        a.get("$skip") && (this.options.$skip = Number(a.get("$skip")));
      }
      this.loadData(this.options, t);
    }
  }
  /**
   * Called by the view when the search text changes
   * @param searchType If "owner" or "other", the search is performed as owner:search or other:search and the search string is taken from rawSearchString.
   * By default, the search string should be bound to options.$search or options.fullSearch.
   */
  searchChanged(t = "default") {
    t == "other" && (this.options.fullSearch = `${t}:${this.rawSearchStringOther || ""}`), t == "owner" && (this.options.fullSearch = `${t}:${this.rawSearchStringOwner || ""}`), t == "both" && (this.options.fullSearch = `owner:${this.rawSearchStringOwner || ""} AND other:${this.rawSearchStringOther || ""}`), this.options.$skip = 0, this.reloadWithDelay(500);
  }
  /**
   * Starts the reload process.
   * @param delay Loading occurs asyncronously after the specified delay
   */
  reloadWithDelay(t) {
    this.getUrl() && (wt.isDefined(this.filterTimeout) && this.$timeout.cancel(this.filterTimeout), this.filterTimeout = this.$timeout(() => {
      this.loadData(this.options, !1);
    }, t));
  }
  /**
   * Starts the reload process.
   * @returns A promise of OData result as returned by setValues() method.
   */
  reload() {
    if (this.getUrl())
      return wt.isDefined(this.filterTimeout) && this.$timeout.cancel(this.filterTimeout), this.loadData(this.options, !1);
  }
  /** Gets the URL for the server request using the current url and queryOptions */
  getUrl() {
    const t = this.url || (this.$crudController ? this.$crudController.odataServiceUrl : null);
    return t ? qo.getUrl(t, this.options) : null;
  }
  /** If true, the component is in the middle of loading data. */
  get isLoading() {
    switch (this.status) {
      case "initialLoading":
      case "reloading":
        return !0;
      case "loaded":
      case "loadError":
      case "noInit":
      default:
        return !1;
    }
  }
  /**
   * Gets the CSS classes for OData table container.
   * Main function is to get the `salaxy-loading class`.
   * Also renders `salaxy-component salaxy-odata-table` for convenience
   */
  getCssClass() {
    return "salaxy-component salaxy-odata-table salaxy-odata-table-status-" + this.status + (this.isLoading ? " salaxy-odata-table-loading" : "");
  }
  /**
   * Sets the values to items from an OData result.
   * @param data Data as returned from the Ajax component. This is expected being either ODataResult or array of items.
   * @param append If true, appends the result to existing values. Used particularly with nextPageLink if this is used fo "Load more", not "Next page".
   * @returns The data harmonized as OData result.
   */
  setValues(t, e = !1) {
    const a = qo.getODataResult(t);
    return this.items = this.items || [], !e && this.items.length > 0 && this.items.splice(0, this.items.length), this.items.push(...a.items), this.count = a.count, this.nextPageLink = a.nextPageLink, this.hasData = !0, this.loadedAt = t.$loaded || (/* @__PURE__ */ new Date()).getTime(), this.onDataLoaded && this.onDataLoaded({ append: e, result: a }), a;
  }
  /**
   * Calls a promise updating the status on the controller.
   * @param loadAction The promise that executes the loading from server.
   */
  setStatus(t) {
    switch (this._status) {
      case "noInit":
        this._status = "initialLoading";
        break;
      case "initialLoading":
        this._status = "initialLoading";
        break;
      case "loadError":
        this._status = this.items ? "reloading" : "initialLoading";
        break;
      case "loaded":
        this._status = "reloading";
        break;
      case "reloading":
        this._status = "reloading";
        break;
      default:
        throw Error("Unexpected status: " + this._status);
    }
    return t.then((e) => (this._status = "loaded", e)).catch((e) => (this._status = "loadError", null));
  }
  /**
   * Returns the current crud api.
   */
  getApi() {
    return this.$crudController ? this.$crudController.getApi() : null;
  }
  /**
   * Export items. Does not update cache or current items.
   * @param maxCount - maximum number of items to return.
   * maxCount can have the following values:
   * - ```0``` Return all items from the data source.
   * - ```-1``` Return only the currently listed items using the current $filter and $search.
   * - ```n``` Where n is any positive number, returns the given number of items. Should be more than 50 (default page size).
   * @param notify -  function for notifying progress.
   */
  exportItems(t, e = null) {
    return t == -1 ? Promise.resolve(this.items || []) : this.url ? qo.exportItems(this.url, {}, this.reader, e) : this.$crudController ? qo.exportItems(this.$crudController.getApi().getODataUrl(), {}, this.reader, e) : Promise.resolve([]);
  }
  /**
   * Makes a http call to server using the curre
   * @param options - Options based on which the OData query is created.
   * @param append - If true, appends the result to the data.
   * @returns A promise of OData result as returned by setValues() method.
   */
  loadData(t, e = !1) {
    const a = this.getUrl();
    if (!e && this.cacheService.hasData(this.cacheKey, a))
      return this.setStatus(Promise.resolve(this.setValues(this.cacheService.getData(this.cacheKey, a), e)));
    if (this.url)
      return this.setStatus(this.reader.getJSON(a).then((n) => (this.cacheService.setData(this.cacheKey, a, n, 5 * 60), this.setValues(n, e))));
    if (this.$crudController)
      return this.setStatus(this.$crudController.getOData(t).then((n) => (this.cacheService.setData(this.cacheKey, a, n, 5 * 60), this.setValues(n, e))));
    throw Error("No url given for OData queries");
  }
};
fC.$inject = ["CacheService", "AjaxNg1", "$timeout", "$scope", "$controller", "UiHelpers"];
let ni = fC;
const bC = class bC extends nn {
  constructor(t, e, a, n) {
    super(t, e, a, n), this.fullApi = t;
  }
  /**
   * Implement IController
   */
  $onInit() {
    super.$onInit();
  }
  /** Implements the getDefaults of ApiCrudObjectController */
  getDefaults() {
    return {
      listUrl: this.listUrl || "/certificates",
      detailsUrl: this.detailsUrl || "/certificates/details/",
      oDataTemplateUrl: "salaxy-components/odata/lists/Certificates.html",
      oDataOptions: {}
    };
  }
};
bC.$inject = [
  "Certificates",
  "UiHelpers",
  "$location",
  "$routeParams"
];
let OL = bC;
var We = /* @__PURE__ */ ((s) => (s.Ok = "ok", s.OkNoCommit = "ok-no-save", s.Cancel = "cancel", s.Delete = "delete", s.DeleteNoCommit = "delete-no-save", s))(We || {});
class SZ {
}
class kZ {
}
const vC = class vC {
  /** Dependency injection etc. */
  constructor(t, e, a) {
    this.$rootScope = t, this.$timeout = e, this.$sce = a, this.duration = 10, this.alertCounter = 0, this.alerts = [], this.eventPrefix = "alert", this.init();
  }
  /**
   * Adds an error message
   * @param message Message to add
   */
  addError(t) {
    this.addAlert(t, "danger");
  }
  /**
   * Adds a warning message
   * @param message Message to add
   */
  addWarning(t) {
    this.addAlert(t, "warning");
  }
  /**
   * Adds a success message
   * @param message Message to add
   */
  addSuccess(t) {
    this.addAlert(t, "success");
  }
  /**
   * Adds an info message
   * @param message Message to add
   */
  addInfo(t) {
    this.addAlert(t, "info");
  }
  /**
   * Last message - consider this a temporary implementation of the custom alert handling
   * @returns Last message
   */
  getLastMessage() {
    return this.alerts[this.alerts.length - 1].message || null;
  }
  /**
   * Last alertType is bootstrap type: info (default), success, warning or danger.
   * Consider this a temporary implementation of the custom alert handling
   * @returns Last alert type
   */
  getLastAlertType() {
    return this.alerts[this.alerts.length - 1].alertType || null;
  }
  /**
   * INTERNAL ONLY: This functionality is under consideration.
   * We may not support it in the future and we may remove it without it being a breaking change.
   *
   * Controllers can subscribe to changes in service data using this method.
   * Read more about the pattern in: http://www.codelord.net/2015/05/04/angularjs-notifying-about-changes-from-services-to-controllers/
   * @ignore
   * @param scope - Controller scope for the subscribing controller (or directive etc.)
   * @param callback - The event listener function. See $on documentation for details
   */
  onChange(t, e) {
    const a = this.$rootScope.$on(this.eventPrefix + "-service-event", e);
    t.$on("$destroy", a);
  }
  /**
   * Attaches the alert service to AjaxNg1.
   * The init is currently called automatically in constructor, but here you can make an explicit call.
   */
  init() {
    sm.alertService = this;
  }
  /**
   * Adds an alert message
   * @param message - A message text for the Alert. Preferably a short text so that it fits to the pull-righ box.
   * @param alertType - Bootstrap color code for the alert info (default), success, warning or danger
   */
  addAlert(t, e) {
    const a = {
      message: t,
      alertType: e || "info",
      id: this.alertCounter++
    };
    this.alerts.push(a), this.notify(), this.renderAlerts(), this.$timeout(() => {
      this.alerts.splice(0, 1), this.notify(), this.renderAlerts();
    }, 1e3 * this.duration);
  }
  renderAlerts() {
    const t = document.getElementById("salaxy-alert-container");
    if (!t)
      return;
    const e = [], a = t.children;
    for (let r = 0; r < a.length; r++)
      a[r].classList.contains("hide") && e.push(a[r].id);
    let n = "";
    const i = this.alerts.length;
    for (let r = i; r-- !== 0; ) {
      const l = this.alerts[r], o = "salaxy-alert-id-" + l.id;
      e.find((c) => c === o) || (n += `<div id="${o}" class="alert alert-${l.alertType} alert-dismissible" role="alert">
            ${this.$sce.getTrustedHtml(l.message)}
            <button type="button" class="btn-close" data-dismiss="alert" aria-label="Close" onclick="document.getElementById('${o}').classList.toggle('hide');"></button>
          </div>`);
    }
    t.innerHTML = n;
  }
  notify() {
    this.$rootScope.$emit(this.eventPrefix + "-service-event");
  }
};
vC.$inject = ["$rootScope", "$timeout", "$sce"];
let Lv = vC;
var ji = 0, HX = 1, lm = 2, UX = 3, rs = 4, ML = 5, tn = 0, Or = 1, FX = 2, ei = -2, zX = -3, _h = -5, R0 = -1, BX = 1, ah = 2, WX = 3, Y0 = 4, jX = 0, XL = 0, GL = 1, _0 = 2, Qy = 8;
function VX(s, t) {
  return Object.prototype.hasOwnProperty.call(s, t);
}
function O0(s) {
  for (var t = Array.prototype.slice.call(arguments, 1); t.length; ) {
    var e = t.shift();
    if (e) {
      if (typeof e != "object")
        throw new TypeError(e + "must be non-object");
      for (var a in e)
        VX(e, a) && (s[a] = e[a]);
    }
  }
  return s;
}
function om(s, t) {
  return s.length === t ? s : s.subarray ? s.subarray(0, t) : (s.length = t, s);
}
var Ou = {
  arraySet: function(s, t, e, a, n) {
    if (t.subarray && s.subarray) {
      s.set(t.subarray(e, e + a), n);
      return;
    }
    for (var i = 0; i < a; i++)
      s[n + i] = t[e + i];
  },
  // Join array of chunks to single array.
  flattenChunks: function(s) {
    var t, e, a, n, i, r;
    for (a = 0, t = 0, e = s.length; t < e; t++)
      a += s[t].length;
    for (r = new Uint8Array(a), n = 0, t = 0, e = s.length; t < e; t++)
      i = s[t], r.set(i, n), n += i.length;
    return r;
  },
  Buf8: function(s) {
    return new Uint8Array(s);
  },
  Buf16: function(s) {
    return new Uint16Array(s);
  },
  Buf32: function(s) {
    return new Int32Array(s);
  }
}, Mu = {
  arraySet: function(s, t, e, a, n) {
    for (var i = 0; i < a; i++)
      s[n + i] = t[e + i];
  },
  // Join array of chunks to single array.
  flattenChunks: function(s) {
    return [].concat.apply([], s);
  },
  Buf8: function(s) {
    return new Array(s);
  },
  Buf16: function(s) {
    return new Array(s);
  },
  Buf32: function(s) {
    return new Array(s);
  }
}, Oc = function() {
  var s = typeof Uint8Array < "u" && typeof Uint16Array < "u" && typeof Int32Array < "u";
  return Oc = function() {
    return s;
  }, s;
}, _s = function(s, t, e, a, n) {
  return _s = Oc() ? Ou.arraySet : Mu.arraySet, _s(s, t, e, a, n);
}, cm = function(s) {
  return cm = Oc() ? Ou.flattenChunks : Mu.flattenChunks, cm(s);
}, Vi = function(s) {
  return Vi = Oc() ? Ou.Buf8 : Mu.Buf8, Vi(s);
}, fs = function(s) {
  return fs = Oc() ? Ou.Buf16 : Mu.Buf16, fs(s);
}, bc = function(s) {
  return bc = Oc() ? Ou.Buf32 : Mu.Buf32, bc(s);
}, M0 = function() {
  var s = !0;
  try {
    String.fromCharCode.apply(null, [0]);
  } catch {
    s = !1;
  }
  return M0 = function() {
    return s;
  }, s;
}, X0 = function() {
  var s = !0;
  try {
    String.fromCharCode.apply(null, new Uint8Array(1));
  } catch {
    s = !1;
  }
  return X0 = function() {
    return s;
  }, s;
}, kw = function(s) {
  for (var t = Vi(256), e = 0; e < 256; e++)
    t[e] = e >= 252 ? 6 : e >= 248 ? 5 : e >= 240 ? 4 : e >= 224 ? 3 : e >= 192 ? 2 : 1;
  return t[254] = t[254] = 1, kw = function(a) {
    return t[a];
  }, t[s];
};
function Zy(s) {
  var t, e, a, n, i, r = s.length, l = 0;
  for (n = 0; n < r; n++)
    e = s.charCodeAt(n), (e & 64512) === 55296 && n + 1 < r && (a = s.charCodeAt(n + 1), (a & 64512) === 56320 && (e = 65536 + (e - 55296 << 10) + (a - 56320), n++)), l += e < 128 ? 1 : e < 2048 ? 2 : e < 65536 ? 3 : 4;
  for (t = new Uint8Array(l), i = 0, n = 0; i < l; n++)
    e = s.charCodeAt(n), (e & 64512) === 55296 && n + 1 < r && (a = s.charCodeAt(n + 1), (a & 64512) === 56320 && (e = 65536 + (e - 55296 << 10) + (a - 56320), n++)), e < 128 ? t[i++] = e : e < 2048 ? (t[i++] = 192 | e >>> 6, t[i++] = 128 | e & 63) : e < 65536 ? (t[i++] = 224 | e >>> 12, t[i++] = 128 | e >>> 6 & 63, t[i++] = 128 | e & 63) : (t[i++] = 240 | e >>> 18, t[i++] = 128 | e >>> 12 & 63, t[i++] = 128 | e >>> 6 & 63, t[i++] = 128 | e & 63);
  return t;
}
function G0(s, t) {
  if (t < 65534 && (s.subarray && X0() || !s.subarray && M0()))
    return String.fromCharCode.apply(null, om(s, t));
  for (var e = "", a = 0; a < t; a++)
    e += String.fromCharCode(s[a]);
  return e;
}
function qX(s) {
  return G0(s, s.length);
}
function KX(s) {
  for (var t = new Uint8Array(s.length), e = 0, a = t.length; e < a; e++)
    t[e] = s.charCodeAt(e);
  return t;
}
function JX(s, t) {
  var e, a, n, i, r = t || s.length, l = new Array(r * 2);
  for (a = 0, e = 0; e < r; ) {
    if (n = s[e++], n < 128) {
      l[a++] = n;
      continue;
    }
    if (i = kw(n), i > 4) {
      l[a++] = 65533, e += i - 1;
      continue;
    }
    for (n &= i === 2 ? 31 : i === 3 ? 15 : 7; i > 1 && e < r; )
      n = n << 6 | s[e++] & 63, i--;
    if (i > 1) {
      l[a++] = 65533;
      continue;
    }
    n < 65536 ? l[a++] = n : (n -= 65536, l[a++] = 55296 | n >> 10 & 1023, l[a++] = 56320 | n & 1023);
  }
  return G0(l, a);
}
function QX(s, t) {
  var e;
  for (t = t || s.length, t > s.length && (t = s.length), e = t - 1; e >= 0 && (s[e] & 192) === 128; )
    e--;
  return e < 0 || e === 0 ? t : e + kw(s[e]) > t ? e : t;
}
function nu(s, t, e, a) {
  for (var n = s & 65535 | 0, i = s >>> 16 & 65535 | 0, r = 0; e !== 0; ) {
    r = e > 2e3 ? 2e3 : e, e -= r;
    do
      n = n + t[a++] | 0, i = i + n | 0;
    while (--r);
    n %= 65521, i %= 65521;
  }
  return n | i << 16 | 0;
}
function ZX() {
  for (var s, t = [], e = 0; e < 256; e++) {
    s = e;
    for (var a = 0; a < 8; a++)
      s = s & 1 ? 3988292384 ^ s >>> 1 : s >>> 1;
    t[e] = s;
  }
  return t;
}
var H0 = function() {
  var s = ZX();
  return H0 = function() {
    return s;
  }, s;
};
function En(s, t, e, a) {
  var n = H0(), i = a + e;
  s ^= -1;
  for (var r = a; r < i; r++)
    s = s >>> 8 ^ n[(s ^ t[r]) & 255];
  return s ^ -1;
}
var nh = 30, tG = 12;
function eG(s, t) {
  var e, a, n, i, r, l, o, c, d, p, h, g, x, b, A, T, R, C, v, P, O, N, H, F, B;
  e = s.state, a = s.next_in, F = s.input, n = a + (s.avail_in - 5), i = s.next_out, B = s.output, r = i - (t - s.avail_out), l = i + (s.avail_out - 257), o = e.dmax, c = e.wsize, d = e.whave, p = e.wnext, h = e.window, g = e.hold, x = e.bits, b = e.lencode, A = e.distcode, T = (1 << e.lenbits) - 1, R = (1 << e.distbits) - 1;
  t:
    do {
      x < 15 && (g += F[a++] << x, x += 8, g += F[a++] << x, x += 8), C = b[g & T];
      e:
        for (; ; ) {
          if (v = C >>> 24, g >>>= v, x -= v, v = C >>> 16 & 255, v === 0)
            B[i++] = C & 65535;
          else if (v & 16) {
            P = C & 65535, v &= 15, v && (x < v && (g += F[a++] << x, x += 8), P += g & (1 << v) - 1, g >>>= v, x -= v), x < 15 && (g += F[a++] << x, x += 8, g += F[a++] << x, x += 8), C = A[g & R];
            a:
              for (; ; ) {
                if (v = C >>> 24, g >>>= v, x -= v, v = C >>> 16 & 255, v & 16) {
                  if (O = C & 65535, v &= 15, x < v && (g += F[a++] << x, x += 8, x < v && (g += F[a++] << x, x += 8)), O += g & (1 << v) - 1, O > o) {
                    s.msg = "invalid distance too far back", e.mode = nh;
                    break t;
                  }
                  if (g >>>= v, x -= v, v = i - r, O > v) {
                    if (v = O - v, v > d && e.sane) {
                      s.msg = "invalid distance too far back", e.mode = nh;
                      break t;
                    }
                    if (N = 0, H = h, p === 0) {
                      if (N += c - v, v < P) {
                        P -= v;
                        do
                          B[i++] = h[N++];
                        while (--v);
                        N = i - O, H = B;
                      }
                    } else if (p < v) {
                      if (N += c + p - v, v -= p, v < P) {
                        P -= v;
                        do
                          B[i++] = h[N++];
                        while (--v);
                        if (N = 0, p < P) {
                          v = p, P -= v;
                          do
                            B[i++] = h[N++];
                          while (--v);
                          N = i - O, H = B;
                        }
                      }
                    } else if (N += p - v, v < P) {
                      P -= v;
                      do
                        B[i++] = h[N++];
                      while (--v);
                      N = i - O, H = B;
                    }
                    for (; P > 2; )
                      B[i++] = H[N++], B[i++] = H[N++], B[i++] = H[N++], P -= 3;
                    P && (B[i++] = H[N++], P > 1 && (B[i++] = H[N++]));
                  } else {
                    N = i - O;
                    do
                      B[i++] = B[N++], B[i++] = B[N++], B[i++] = B[N++], P -= 3;
                    while (P > 2);
                    P && (B[i++] = B[N++], P > 1 && (B[i++] = B[N++]));
                  }
                } else if (v & 64) {
                  s.msg = "invalid distance code", e.mode = nh;
                  break t;
                } else {
                  C = A[(C & 65535) + (g & (1 << v) - 1)];
                  continue a;
                }
                break;
              }
          } else if (v & 64)
            if (v & 32) {
              e.mode = tG;
              break t;
            } else {
              s.msg = "invalid literal/length code", e.mode = nh;
              break t;
            }
          else {
            C = b[(C & 65535) + (g & (1 << v) - 1)];
            continue e;
          }
          break;
        }
    } while (a < n && i < l);
  P = x >> 3, a -= P, x -= P << 3, g &= (1 << x) - 1, s.next_in = a, s.next_out = i, s.avail_in = a < n ? 5 + (n - a) : 5 - (a - n), s.avail_out = i < l ? 257 + (l - i) : 257 - (i - l), e.hold = g, e.bits = x;
}
var Ro = 15, HL = 852, UL = 592, FL = 0, Lb = 1, zL = 2, aG = [
  /* Length codes 257..285 base */
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  13,
  15,
  17,
  19,
  23,
  27,
  31,
  35,
  43,
  51,
  59,
  67,
  83,
  99,
  115,
  131,
  163,
  195,
  227,
  258,
  0,
  0
], nG = [
  /* Length codes 257..285 extra */
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  17,
  17,
  17,
  17,
  18,
  18,
  18,
  18,
  19,
  19,
  19,
  19,
  20,
  20,
  20,
  20,
  21,
  21,
  21,
  21,
  16,
  72,
  78
], sG = [
  /* Distance codes 0..29 base */
  1,
  2,
  3,
  4,
  5,
  7,
  9,
  13,
  17,
  25,
  33,
  49,
  65,
  97,
  129,
  193,
  257,
  385,
  513,
  769,
  1025,
  1537,
  2049,
  3073,
  4097,
  6145,
  8193,
  12289,
  16385,
  24577,
  0,
  0
], iG = [
  /* Distance codes 0..29 extra */
  16,
  16,
  16,
  16,
  17,
  17,
  18,
  18,
  19,
  19,
  20,
  20,
  21,
  21,
  22,
  22,
  23,
  23,
  24,
  24,
  25,
  25,
  26,
  26,
  27,
  27,
  28,
  28,
  29,
  29,
  64,
  64
];
function Hd(s, t, e, a, n, i, r, l) {
  var o = l.bits, c = 0, d = 0, p = 0, h = 0, g = 0, x = 0, b = 0, A = 0, T = 0, R = 0, C, v, P, O, N, H = null, F = 0, B, Q = fs(Ro + 1), it = fs(Ro + 1), et = null, rt = 0, U, M, W;
  for (c = 0; c <= Ro; c++)
    Q[c] = 0;
  for (d = 0; d < a; d++)
    Q[t[e + d]]++;
  for (g = o, h = Ro; h >= 1 && Q[h] === 0; h--)
    ;
  if (g > h && (g = h), h === 0)
    return n[i++] = 1 << 24 | 64 << 16 | 0, n[i++] = 1 << 24 | 64 << 16 | 0, l.bits = 1, 0;
  for (p = 1; p < h && Q[p] === 0; p++)
    ;
  for (g < p && (g = p), A = 1, c = 1; c <= Ro; c++)
    if (A <<= 1, A -= Q[c], A < 0)
      return -1;
  if (A > 0 && (s === FL || h !== 1))
    return -1;
  for (it[1] = 0, c = 1; c < Ro; c++)
    it[c + 1] = it[c] + Q[c];
  for (d = 0; d < a; d++)
    t[e + d] !== 0 && (r[it[t[e + d]]++] = d);
  if (s === FL ? (H = et = r, B = 19) : s === Lb ? (H = aG, F -= 257, et = nG, rt -= 257, B = 256) : (H = sG, et = iG, B = -1), R = 0, d = 0, c = p, N = i, x = g, b = 0, P = -1, T = 1 << g, O = T - 1, s === Lb && T > HL || s === zL && T > UL)
    return 1;
  for (; ; ) {
    U = c - b, r[d] < B ? (M = 0, W = r[d]) : r[d] > B ? (M = et[rt + r[d]], W = H[F + r[d]]) : (M = 96, W = 0), C = 1 << c - b, v = 1 << x, p = v;
    do
      v -= C, n[N + (R >> b) + v] = U << 24 | M << 16 | W | 0;
    while (v !== 0);
    for (C = 1 << c - 1; R & C; )
      C >>= 1;
    if (C !== 0 ? (R &= C - 1, R += C) : R = 0, d++, --Q[c] === 0) {
      if (c === h)
        break;
      c = t[e + r[d]];
    }
    if (c > g && (R & O) !== P) {
      for (b === 0 && (b = g), N += p, x = c - b, A = 1 << x; x + b < h && (A -= Q[x + b], !(A <= 0)); )
        x++, A <<= 1;
      if (T += 1 << x, s === Lb && T > HL || s === zL && T > UL)
        return 1;
      P = R & O, n[P] = g << 24 | x << 16 | N - i | 0;
    }
  }
  return R !== 0 && (n[N + R] = c - b << 24 | 64 << 16 | 0), l.bits = g, 0;
}
var rG = 0, U0 = 1, F0 = 2, BL = 4, lG = 5, sh = 6, Ul = 0, oG = 1, cG = 2, si = -2, z0 = -3, B0 = -4, dG = -5, WL = 8, W0 = 1, jL = 2, VL = 3, qL = 4, KL = 5, JL = 6, QL = 7, ZL = 8, t1 = 9, e1 = 10, dm = 11, ar = 12, Db = 13, a1 = 14, Ib = 15, n1 = 16, s1 = 17, i1 = 18, r1 = 19, ih = 20, rh = 21, l1 = 22, o1 = 23, c1 = 24, d1 = 25, u1 = 26, Pb = 27, p1 = 28, h1 = 29, Wa = 30, j0 = 31, uG = 32, pG = 852, hG = 592;
function m1(s) {
  return (s >>> 24 & 255) + (s >>> 8 & 65280) + ((s & 65280) << 8) + ((s & 255) << 24);
}
function mG() {
  this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = fs(320), this.work = fs(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
}
function gG(s) {
  var t;
  return !s || !s.state ? si : (t = s.state, s.total_in = s.total_out = t.total = 0, s.msg = "", t.wrap && (s.adler = t.wrap & 1), t.mode = W0, t.last = 0, t.havedict = 0, t.dmax = 32768, t.head = null, t.hold = 0, t.bits = 0, t.lencode = t.lendyn = bc(pG), t.distcode = t.distdyn = bc(hG), t.sane = 1, t.back = -1, Ul);
}
function yG(s) {
  var t;
  return !s || !s.state ? si : (t = s.state, t.wsize = 0, t.whave = 0, t.wnext = 0, gG(s));
}
function fG(s, t) {
  var e, a;
  return !s || !s.state || (a = s.state, t < 0 ? (e = 0, t = -t) : (e = (t >> 4) + 1, t < 48 && (t &= 15)), t && (t < 8 || t > 15)) ? si : (a.window !== null && a.wbits !== t && (a.window = null), a.wrap = e, a.wbits = t, yG(s));
}
function bG(s, t) {
  var e, a;
  return s ? (a = new mG(), s.state = a, a.window = null, e = fG(s, t), e !== Ul && (s.state = null), e) : si;
}
var g1 = !0, Eb, Nb;
function vG(s) {
  if (g1) {
    var t;
    for (Eb = bc(512), Nb = bc(32), t = 0; t < 144; )
      s.lens[t++] = 8;
    for (; t < 256; )
      s.lens[t++] = 9;
    for (; t < 280; )
      s.lens[t++] = 7;
    for (; t < 288; )
      s.lens[t++] = 8;
    for (Hd(U0, s.lens, 0, 288, Eb, 0, s.work, { bits: 9 }), t = 0; t < 32; )
      s.lens[t++] = 5;
    Hd(F0, s.lens, 0, 32, Nb, 0, s.work, { bits: 5 }), g1 = !1;
  }
  s.lencode = Eb, s.lenbits = 9, s.distcode = Nb, s.distbits = 5;
}
function V0(s, t, e, a) {
  var n, i = s.state;
  return i.window === null && (i.wsize = 1 << i.wbits, i.wnext = 0, i.whave = 0, i.window = Vi(i.wsize)), a >= i.wsize ? (_s(i.window, t, e - i.wsize, i.wsize, 0), i.wnext = 0, i.whave = i.wsize) : (n = i.wsize - i.wnext, n > a && (n = a), _s(i.window, t, e - a, n, i.wnext), a -= n, a ? (_s(i.window, t, e - a, a, 0), i.wnext = a, i.whave = i.wsize) : (i.wnext += n, i.wnext === i.wsize && (i.wnext = 0), i.whave < i.wsize && (i.whave += n))), 0;
}
function xG(s, t) {
  var e, a, n, i, r, l, o, c, d, p, h, g, x, b, A = 0, T, R, C, v, P, O, N, H, F = Vi(4), B, Q, it = (
    /* permutation of code lengths */
    [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]
  );
  if (!s || !s.state || !s.output || !s.input && s.avail_in !== 0)
    return si;
  e = s.state, e.mode === ar && (e.mode = Db), r = s.next_out, n = s.output, o = s.avail_out, i = s.next_in, a = s.input, l = s.avail_in, c = e.hold, d = e.bits, p = l, h = o, H = Ul;
  t:
    for (; ; )
      switch (e.mode) {
        case W0:
          if (e.wrap === 0) {
            e.mode = Db;
            break;
          }
          for (; d < 16; ) {
            if (l === 0)
              break t;
            l--, c += a[i++] << d, d += 8;
          }
          if (e.wrap & 2 && c === 35615) {
            e.check = 0, F[0] = c & 255, F[1] = c >>> 8 & 255, e.check = En(e.check, F, 2, 0), c = 0, d = 0, e.mode = jL;
            break;
          }
          if (e.flags = 0, e.head && (e.head.done = !1), !(e.wrap & 1) || /* check if zlib header allowed */
          (((c & 255) << 8) + (c >> 8)) % 31) {
            s.msg = "incorrect header check", e.mode = Wa;
            break;
          }
          if ((c & 15) !== WL) {
            s.msg = "unknown compression method", e.mode = Wa;
            break;
          }
          if (c >>>= 4, d -= 4, N = (c & 15) + 8, e.wbits === 0)
            e.wbits = N;
          else if (N > e.wbits) {
            s.msg = "invalid window size", e.mode = Wa;
            break;
          }
          e.dmax = 1 << N, s.adler = e.check = 1, e.mode = c & 512 ? e1 : ar, c = 0, d = 0;
          break;
        case jL:
          for (; d < 16; ) {
            if (l === 0)
              break t;
            l--, c += a[i++] << d, d += 8;
          }
          if (e.flags = c, (e.flags & 255) !== WL) {
            s.msg = "unknown compression method", e.mode = Wa;
            break;
          }
          if (e.flags & 57344) {
            s.msg = "unknown header flags set", e.mode = Wa;
            break;
          }
          e.head && (e.head.text = c >> 8 & 1), e.flags & 512 && (F[0] = c & 255, F[1] = c >>> 8 & 255, e.check = En(e.check, F, 2, 0)), c = 0, d = 0, e.mode = VL;
        case VL:
          for (; d < 32; ) {
            if (l === 0)
              break t;
            l--, c += a[i++] << d, d += 8;
          }
          e.head && (e.head.time = c), e.flags & 512 && (F[0] = c & 255, F[1] = c >>> 8 & 255, F[2] = c >>> 16 & 255, F[3] = c >>> 24 & 255, e.check = En(e.check, F, 4, 0)), c = 0, d = 0, e.mode = qL;
        case qL:
          for (; d < 16; ) {
            if (l === 0)
              break t;
            l--, c += a[i++] << d, d += 8;
          }
          e.head && (e.head.xflags = c & 255, e.head.os = c >> 8), e.flags & 512 && (F[0] = c & 255, F[1] = c >>> 8 & 255, e.check = En(e.check, F, 2, 0)), c = 0, d = 0, e.mode = KL;
        case KL:
          if (e.flags & 1024) {
            for (; d < 16; ) {
              if (l === 0)
                break t;
              l--, c += a[i++] << d, d += 8;
            }
            e.length = c, e.head && (e.head.extra_len = c), e.flags & 512 && (F[0] = c & 255, F[1] = c >>> 8 & 255, e.check = En(e.check, F, 2, 0)), c = 0, d = 0;
          } else
            e.head && (e.head.extra = null);
          e.mode = JL;
        case JL:
          if (e.flags & 1024 && (g = e.length, g > l && (g = l), g && (e.head && (N = e.head.extra_len - e.length, e.head.extra || (e.head.extra = new Array(e.head.extra_len)), _s(
            e.head.extra,
            a,
            i,
            // extra field is limited to 65536 bytes
            // - no need for additional size check
            g,
            /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
            N
          )), e.flags & 512 && (e.check = En(e.check, a, g, i)), l -= g, i += g, e.length -= g), e.length))
            break t;
          e.length = 0, e.mode = QL;
        case QL:
          if (e.flags & 2048) {
            if (l === 0)
              break t;
            g = 0;
            do
              N = a[i + g++], e.head && N && e.length < 65536 && (e.head.name += String.fromCharCode(N));
            while (N && g < l);
            if (e.flags & 512 && (e.check = En(e.check, a, g, i)), l -= g, i += g, N)
              break t;
          } else
            e.head && (e.head.name = null);
          e.length = 0, e.mode = ZL;
        case ZL:
          if (e.flags & 4096) {
            if (l === 0)
              break t;
            g = 0;
            do
              N = a[i + g++], e.head && N && e.length < 65536 && (e.head.comment += String.fromCharCode(N));
            while (N && g < l);
            if (e.flags & 512 && (e.check = En(e.check, a, g, i)), l -= g, i += g, N)
              break t;
          } else
            e.head && (e.head.comment = null);
          e.mode = t1;
        case t1:
          if (e.flags & 512) {
            for (; d < 16; ) {
              if (l === 0)
                break t;
              l--, c += a[i++] << d, d += 8;
            }
            if (c !== (e.check & 65535)) {
              s.msg = "header crc mismatch", e.mode = Wa;
              break;
            }
            c = 0, d = 0;
          }
          e.head && (e.head.hcrc = e.flags >> 9 & 1, e.head.done = !0), s.adler = e.check = 0, e.mode = ar;
          break;
        case e1:
          for (; d < 32; ) {
            if (l === 0)
              break t;
            l--, c += a[i++] << d, d += 8;
          }
          s.adler = e.check = m1(c), c = 0, d = 0, e.mode = dm;
        case dm:
          if (e.havedict === 0)
            return s.next_out = r, s.avail_out = o, s.next_in = i, s.avail_in = l, e.hold = c, e.bits = d, cG;
          s.adler = e.check = 1, e.mode = ar;
        case ar:
          if (t === lG || t === sh)
            break t;
        case Db:
          if (e.last) {
            c >>>= d & 7, d -= d & 7, e.mode = Pb;
            break;
          }
          for (; d < 3; ) {
            if (l === 0)
              break t;
            l--, c += a[i++] << d, d += 8;
          }
          switch (e.last = c & 1, c >>>= 1, d -= 1, c & 3) {
            case 0:
              e.mode = a1;
              break;
            case 1:
              if (vG(e), e.mode = ih, t === sh) {
                c >>>= 2, d -= 2;
                break t;
              }
              break;
            case 2:
              e.mode = s1;
              break;
            case 3:
              s.msg = "invalid block type", e.mode = Wa;
          }
          c >>>= 2, d -= 2;
          break;
        case a1:
          for (c >>>= d & 7, d -= d & 7; d < 32; ) {
            if (l === 0)
              break t;
            l--, c += a[i++] << d, d += 8;
          }
          if ((c & 65535) !== (c >>> 16 ^ 65535)) {
            s.msg = "invalid stored block lengths", e.mode = Wa;
            break;
          }
          if (e.length = c & 65535, c = 0, d = 0, e.mode = Ib, t === sh)
            break t;
        case Ib:
          e.mode = n1;
        case n1:
          if (g = e.length, g) {
            if (g > l && (g = l), g > o && (g = o), g === 0)
              break t;
            _s(n, a, i, g, r), l -= g, i += g, o -= g, r += g, e.length -= g;
            break;
          }
          e.mode = ar;
          break;
        case s1:
          for (; d < 14; ) {
            if (l === 0)
              break t;
            l--, c += a[i++] << d, d += 8;
          }
          if (e.nlen = (c & 31) + 257, c >>>= 5, d -= 5, e.ndist = (c & 31) + 1, c >>>= 5, d -= 5, e.ncode = (c & 15) + 4, c >>>= 4, d -= 4, e.nlen > 286 || e.ndist > 30) {
            s.msg = "too many length or distance symbols", e.mode = Wa;
            break;
          }
          e.have = 0, e.mode = i1;
        case i1:
          for (; e.have < e.ncode; ) {
            for (; d < 3; ) {
              if (l === 0)
                break t;
              l--, c += a[i++] << d, d += 8;
            }
            e.lens[it[e.have++]] = c & 7, c >>>= 3, d -= 3;
          }
          for (; e.have < 19; )
            e.lens[it[e.have++]] = 0;
          if (e.lencode = e.lendyn, e.lenbits = 7, B = { bits: e.lenbits }, H = Hd(rG, e.lens, 0, 19, e.lencode, 0, e.work, B), e.lenbits = B.bits, H) {
            s.msg = "invalid code lengths set", e.mode = Wa;
            break;
          }
          e.have = 0, e.mode = r1;
        case r1:
          for (; e.have < e.nlen + e.ndist; ) {
            for (; A = e.lencode[c & (1 << e.lenbits) - 1], T = A >>> 24, R = A >>> 16 & 255, C = A & 65535, !(T <= d); ) {
              if (l === 0)
                break t;
              l--, c += a[i++] << d, d += 8;
            }
            if (C < 16)
              c >>>= T, d -= T, e.lens[e.have++] = C;
            else {
              if (C === 16) {
                for (Q = T + 2; d < Q; ) {
                  if (l === 0)
                    break t;
                  l--, c += a[i++] << d, d += 8;
                }
                if (c >>>= T, d -= T, e.have === 0) {
                  s.msg = "invalid bit length repeat", e.mode = Wa;
                  break;
                }
                N = e.lens[e.have - 1], g = 3 + (c & 3), c >>>= 2, d -= 2;
              } else if (C === 17) {
                for (Q = T + 3; d < Q; ) {
                  if (l === 0)
                    break t;
                  l--, c += a[i++] << d, d += 8;
                }
                c >>>= T, d -= T, N = 0, g = 3 + (c & 7), c >>>= 3, d -= 3;
              } else {
                for (Q = T + 7; d < Q; ) {
                  if (l === 0)
                    break t;
                  l--, c += a[i++] << d, d += 8;
                }
                c >>>= T, d -= T, N = 0, g = 11 + (c & 127), c >>>= 7, d -= 7;
              }
              if (e.have + g > e.nlen + e.ndist) {
                s.msg = "invalid bit length repeat", e.mode = Wa;
                break;
              }
              for (; g--; )
                e.lens[e.have++] = N;
            }
          }
          if (e.mode === Wa)
            break;
          if (e.lens[256] === 0) {
            s.msg = "invalid code -- missing end-of-block", e.mode = Wa;
            break;
          }
          if (e.lenbits = 9, B = { bits: e.lenbits }, H = Hd(U0, e.lens, 0, e.nlen, e.lencode, 0, e.work, B), e.lenbits = B.bits, H) {
            s.msg = "invalid literal/lengths set", e.mode = Wa;
            break;
          }
          if (e.distbits = 6, e.distcode = e.distdyn, B = { bits: e.distbits }, H = Hd(F0, e.lens, e.nlen, e.ndist, e.distcode, 0, e.work, B), e.distbits = B.bits, H) {
            s.msg = "invalid distances set", e.mode = Wa;
            break;
          }
          if (e.mode = ih, t === sh)
            break t;
        case ih:
          e.mode = rh;
        case rh:
          if (l >= 6 && o >= 258) {
            s.next_out = r, s.avail_out = o, s.next_in = i, s.avail_in = l, e.hold = c, e.bits = d, eG(s, h), r = s.next_out, n = s.output, o = s.avail_out, i = s.next_in, a = s.input, l = s.avail_in, c = e.hold, d = e.bits, e.mode === ar && (e.back = -1);
            break;
          }
          for (e.back = 0; A = e.lencode[c & (1 << e.lenbits) - 1], T = A >>> 24, R = A >>> 16 & 255, C = A & 65535, !(T <= d); ) {
            if (l === 0)
              break t;
            l--, c += a[i++] << d, d += 8;
          }
          if (R && !(R & 240)) {
            for (v = T, P = R, O = C; A = e.lencode[O + ((c & (1 << v + P) - 1) >> v)], T = A >>> 24, R = A >>> 16 & 255, C = A & 65535, !(v + T <= d); ) {
              if (l === 0)
                break t;
              l--, c += a[i++] << d, d += 8;
            }
            c >>>= v, d -= v, e.back += v;
          }
          if (c >>>= T, d -= T, e.back += T, e.length = C, R === 0) {
            e.mode = u1;
            break;
          }
          if (R & 32) {
            e.back = -1, e.mode = ar;
            break;
          }
          if (R & 64) {
            s.msg = "invalid literal/length code", e.mode = Wa;
            break;
          }
          e.extra = R & 15, e.mode = l1;
        case l1:
          if (e.extra) {
            for (Q = e.extra; d < Q; ) {
              if (l === 0)
                break t;
              l--, c += a[i++] << d, d += 8;
            }
            e.length += c & (1 << e.extra) - 1, c >>>= e.extra, d -= e.extra, e.back += e.extra;
          }
          e.was = e.length, e.mode = o1;
        case o1:
          for (; A = e.distcode[c & (1 << e.distbits) - 1], T = A >>> 24, R = A >>> 16 & 255, C = A & 65535, !(T <= d); ) {
            if (l === 0)
              break t;
            l--, c += a[i++] << d, d += 8;
          }
          if (!(R & 240)) {
            for (v = T, P = R, O = C; A = e.distcode[O + ((c & (1 << v + P) - 1) >> v)], T = A >>> 24, R = A >>> 16 & 255, C = A & 65535, !(v + T <= d); ) {
              if (l === 0)
                break t;
              l--, c += a[i++] << d, d += 8;
            }
            c >>>= v, d -= v, e.back += v;
          }
          if (c >>>= T, d -= T, e.back += T, R & 64) {
            s.msg = "invalid distance code", e.mode = Wa;
            break;
          }
          e.offset = C, e.extra = R & 15, e.mode = c1;
        case c1:
          if (e.extra) {
            for (Q = e.extra; d < Q; ) {
              if (l === 0)
                break t;
              l--, c += a[i++] << d, d += 8;
            }
            e.offset += c & (1 << e.extra) - 1, c >>>= e.extra, d -= e.extra, e.back += e.extra;
          }
          if (e.offset > e.dmax) {
            s.msg = "invalid distance too far back", e.mode = Wa;
            break;
          }
          e.mode = d1;
        case d1:
          if (o === 0)
            break t;
          if (g = h - o, e.offset > g) {
            if (g = e.offset - g, g > e.whave && e.sane) {
              s.msg = "invalid distance too far back", e.mode = Wa;
              break;
            }
            g > e.wnext ? (g -= e.wnext, x = e.wsize - g) : x = e.wnext - g, g > e.length && (g = e.length), b = e.window;
          } else
            b = n, x = r - e.offset, g = e.length;
          g > o && (g = o), o -= g, e.length -= g;
          do
            n[r++] = b[x++];
          while (--g);
          e.length === 0 && (e.mode = rh);
          break;
        case u1:
          if (o === 0)
            break t;
          n[r++] = e.length, o--, e.mode = rh;
          break;
        case Pb:
          if (e.wrap) {
            for (; d < 32; ) {
              if (l === 0)
                break t;
              l--, c |= a[i++] << d, d += 8;
            }
            if (h -= o, s.total_out += h, e.total += h, h && (s.adler = e.check = /*UPDATE(state.check, put - _out, _out);*/
            e.flags ? En(e.check, n, h, r - h) : nu(e.check, n, h, r - h)), h = o, (e.flags ? c : m1(c)) !== e.check) {
              s.msg = "incorrect data check", e.mode = Wa;
              break;
            }
            c = 0, d = 0;
          }
          e.mode = p1;
        case p1:
          if (e.wrap && e.flags) {
            for (; d < 32; ) {
              if (l === 0)
                break t;
              l--, c += a[i++] << d, d += 8;
            }
            if (c !== (e.total & 4294967295)) {
              s.msg = "incorrect length check", e.mode = Wa;
              break;
            }
            c = 0, d = 0;
          }
          e.mode = h1;
        case h1:
          H = oG;
          break t;
        case Wa:
          H = z0;
          break t;
        case j0:
          return B0;
        case uG:
        default:
          return si;
      }
  return s.next_out = r, s.avail_out = o, s.next_in = i, s.avail_in = l, e.hold = c, e.bits = d, (e.wsize || h !== s.avail_out && e.mode < Wa && (e.mode < Pb || t !== BL)) && V0(s, s.output, s.next_out, h - s.avail_out), p -= s.avail_in, h -= s.avail_out, s.total_in += p, s.total_out += h, e.total += h, e.wrap && h && (s.adler = e.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
  e.flags ? En(e.check, n, h, s.next_out - h) : nu(e.check, n, h, s.next_out - h)), s.data_type = e.bits + (e.last ? 64 : 0) + (e.mode === ar ? 128 : 0) + (e.mode === ih || e.mode === Ib ? 256 : 0), (p === 0 && h === 0 || t === BL) && H === Ul && (H = dG), H;
}
function wG(s) {
  if (!s || !s.state)
    return si;
  var t = s.state;
  return t.window && (t.window = null), s.state = null, Ul;
}
function AG(s, t) {
  var e;
  return !s || !s.state || (e = s.state, !(e.wrap & 2)) ? si : (e.head = t, t.done = !1, Ul);
}
function q0(s, t) {
  var e = t.length, a, n, i;
  return !s || !s.state || (a = s.state, a.wrap !== 0 && a.mode !== dm) ? si : a.mode === dm && (n = 1, n = nu(n, t, e, 0), n !== a.check) ? z0 : (i = V0(s, t, e, e), i ? (a.mode = j0, B0) : (a.havedict = 1, Ul));
}
var su = {
  2: "need dictionary",
  /* Z_NEED_DICT       2  */
  1: "stream end",
  /* Z_STREAM_END      1  */
  0: "",
  /* Z_OK              0  */
  "-1": "file error",
  /* Z_ERRNO         (-1) */
  "-2": "stream error",
  /* Z_STREAM_ERROR  (-2) */
  "-3": "data error",
  /* Z_DATA_ERROR    (-3) */
  "-4": "insufficient memory",
  /* Z_MEM_ERROR     (-4) */
  "-5": "buffer error",
  /* Z_BUF_ERROR     (-5) */
  "-6": "incompatible version"
  /* Z_VERSION_ERROR (-6) */
};
function K0() {
  this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
}
function CG() {
  this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
}
var Dv = Object.prototype.toString, tf = function s(t) {
  if (!(this instanceof s))
    return new s(t);
  this.options = O0({
    chunkSize: 16384,
    windowBits: 0,
    to: ""
  }, t || {});
  var e = this.options;
  e.raw && e.windowBits >= 0 && e.windowBits < 16 && (e.windowBits = -e.windowBits, e.windowBits === 0 && (e.windowBits = -15)), e.windowBits >= 0 && e.windowBits < 16 && !(t && t.windowBits) && (e.windowBits += 32), e.windowBits > 15 && e.windowBits < 48 && (e.windowBits & 15 || (e.windowBits |= 15)), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new K0(), this.strm.avail_out = 0;
  var a = bG(
    this.strm,
    e.windowBits
  );
  if (a !== tn)
    throw new Error(su[a]);
  if (this.header = new CG(), AG(this.strm, this.header), e.dictionary && (typeof e.dictionary == "string" ? e.dictionary = Zy(e.dictionary) : Dv.call(e.dictionary) === "[object ArrayBuffer]" && (e.dictionary = new Uint8Array(e.dictionary)), e.raw && (a = q0(this.strm, e.dictionary), a !== tn)))
    throw new Error(su[a]);
};
tf.prototype.push = function(t, e) {
  var a = this.strm, n = this.options.chunkSize, i = this.options.dictionary, r, l, o, c, d, p, h = !1;
  if (this.ended)
    return !1;
  l = e === ~~e ? e : e === !0 ? rs : ji, typeof t == "string" ? a.input = KX(t) : Dv.call(t) === "[object ArrayBuffer]" ? a.input = new Uint8Array(t) : a.input = t, a.next_in = 0, a.avail_in = a.input.length;
  do {
    if (a.avail_out === 0 && (a.output = Vi(n), a.next_out = 0, a.avail_out = n), r = xG(a, ji), r === FX && i && (typeof i == "string" ? p = Zy(i) : Dv.call(i) === "[object ArrayBuffer]" ? p = new Uint8Array(i) : p = i, r = q0(this.strm, p)), r === _h && h === !0 && (r = tn, h = !1), r !== Or && r !== tn)
      return this.onEnd(r), this.ended = !0, !1;
    a.next_out && (a.avail_out === 0 || r === Or || a.avail_in === 0 && (l === rs || l === lm)) && (this.options.to === "string" ? (o = QX(a.output, a.next_out), c = a.next_out - o, d = JX(a.output, o), a.next_out = c, a.avail_out = n - c, c && _s(a.output, a.output, o, c, 0), this.onData(d)) : this.onData(om(a.output, a.next_out))), a.avail_in === 0 && a.avail_out === 0 && (h = !0);
  } while ((a.avail_in > 0 || a.avail_out === 0) && r !== Or);
  return r === Or && (l = rs), l === rs ? (r = wG(this.strm), this.onEnd(r), this.ended = !0, r === tn) : (l === lm && (this.onEnd(tn), a.avail_out = 0), !0);
};
tf.prototype.onData = function(t) {
  this.chunks.push(t);
};
tf.prototype.onEnd = function(t) {
  t === tn && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = cm(this.chunks)), this.chunks = [], this.err = t, this.msg = this.strm.msg;
};
function Yo(s) {
  for (var t = s.length; --t >= 0; )
    s[t] = 0;
}
var $G = 0, J0 = 1, SG = 2, kG = 3, TG = 258, Iv = 29, Xu = 256, Ud = Xu + 1 + Iv, Fo = 30, Tw = 19, Q0 = 2 * Ud + 1, El = 15, Rb = 16, LG = 7, Lw = 256, Z0 = 16, tP = 17, eP = 18, Pv = (
  /* extra bits for each length code */
  [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0]
), Oh = (
  /* extra bits for each distance code */
  [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13]
), DG = (
  /* extra bits for each bit length code */
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7]
), aP = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], IG = 512, Ii, zo, Qo, Zo, Mh, Td;
function Yb(s, t, e, a, n) {
  this.static_tree = s, this.extra_bits = t, this.extra_base = e, this.elems = a, this.max_length = n, this.has_stree = s && s.length;
}
var nP, sP, iP;
function _b(s, t) {
  this.dyn_tree = s, this.max_code = 0, this.stat_desc = t;
}
function rP(s) {
  return s < 256 ? Qo[s] : Qo[256 + (s >>> 7)];
}
function iu(s, t) {
  s.pending_buf[s.pending++] = t & 255, s.pending_buf[s.pending++] = t >>> 8 & 255;
}
function xs(s, t, e) {
  s.bi_valid > Rb - e ? (s.bi_buf |= t << s.bi_valid & 65535, iu(s, s.bi_buf), s.bi_buf = t >> Rb - s.bi_valid, s.bi_valid += e - Rb) : (s.bi_buf |= t << s.bi_valid & 65535, s.bi_valid += e);
}
function _i(s, t, e) {
  xs(
    s,
    e[t * 2],
    e[t * 2 + 1]
    /*.Len*/
  );
}
function lP(s, t) {
  var e = 0;
  do
    e |= s & 1, s >>>= 1, e <<= 1;
  while (--t > 0);
  return e >>> 1;
}
function PG(s) {
  s.bi_valid === 16 ? (iu(s, s.bi_buf), s.bi_buf = 0, s.bi_valid = 0) : s.bi_valid >= 8 && (s.pending_buf[s.pending++] = s.bi_buf & 255, s.bi_buf >>= 8, s.bi_valid -= 8);
}
function EG(s, t) {
  var e = t.dyn_tree, a = t.max_code, n = t.stat_desc.static_tree, i = t.stat_desc.has_stree, r = t.stat_desc.extra_bits, l = t.stat_desc.extra_base, o = t.stat_desc.max_length, c, d, p, h, g, x, b = 0;
  for (h = 0; h <= El; h++)
    s.bl_count[h] = 0;
  for (e[s.heap[s.heap_max] * 2 + 1] = 0, c = s.heap_max + 1; c < Q0; c++)
    d = s.heap[c], h = e[e[d * 2 + 1] * 2 + 1] + 1, h > o && (h = o, b++), e[d * 2 + 1] = h, !(d > a) && (s.bl_count[h]++, g = 0, d >= l && (g = r[d - l]), x = e[d * 2], s.opt_len += x * (h + g), i && (s.static_len += x * (n[d * 2 + 1] + g)));
  if (b !== 0) {
    do {
      for (h = o - 1; s.bl_count[h] === 0; )
        h--;
      s.bl_count[h]--, s.bl_count[h + 1] += 2, s.bl_count[o]--, b -= 2;
    } while (b > 0);
    for (h = o; h !== 0; h--)
      for (d = s.bl_count[h]; d !== 0; )
        p = s.heap[--c], !(p > a) && (e[p * 2 + 1] !== h && (s.opt_len += (h - e[p * 2 + 1]) * e[p * 2], e[p * 2 + 1] = h), d--);
  }
}
function oP(s, t, e) {
  var a = new Array(El + 1), n = 0, i, r;
  for (i = 1; i <= El; i++)
    a[i] = n = n + e[i - 1] << 1;
  for (r = 0; r <= t; r++) {
    var l = s[r * 2 + 1];
    l !== 0 && (s[r * 2] = lP(a[l]++, l));
  }
}
function NG() {
  var s, t, e, a, n, i = new Array(El + 1);
  for (Ii = new Array((Ud + 2) * 2), Yo(Ii), zo = new Array(Fo * 2), Yo(zo), Qo = new Array(IG), Yo(Qo), Zo = new Array(TG - kG + 1), Yo(Zo), Mh = new Array(Iv), Yo(Mh), Td = new Array(Fo), Yo(Td), e = 0, a = 0; a < Iv - 1; a++)
    for (Mh[a] = e, s = 0; s < 1 << Pv[a]; s++)
      Zo[e++] = a;
  for (Zo[e - 1] = a, n = 0, a = 0; a < 16; a++)
    for (Td[a] = n, s = 0; s < 1 << Oh[a]; s++)
      Qo[n++] = a;
  for (n >>= 7; a < Fo; a++)
    for (Td[a] = n << 7, s = 0; s < 1 << Oh[a] - 7; s++)
      Qo[256 + n++] = a;
  for (t = 0; t <= El; t++)
    i[t] = 0;
  for (s = 0; s <= 143; )
    Ii[s * 2 + 1] = 8, s++, i[8]++;
  for (; s <= 255; )
    Ii[s * 2 + 1] = 9, s++, i[9]++;
  for (; s <= 279; )
    Ii[s * 2 + 1] = 7, s++, i[7]++;
  for (; s <= 287; )
    Ii[s * 2 + 1] = 8, s++, i[8]++;
  for (oP(Ii, Ud + 1, i), s = 0; s < Fo; s++)
    zo[s * 2 + 1] = 5, zo[s * 2] = lP(s, 5);
  nP = new Yb(Ii, Pv, Xu + 1, Ud, El), sP = new Yb(zo, Oh, 0, Fo, El), iP = new Yb(new Array(0), DG, 0, Tw, LG);
}
function cP(s) {
  var t;
  for (t = 0; t < Ud; t++)
    s.dyn_ltree[t * 2] = 0;
  for (t = 0; t < Fo; t++)
    s.dyn_dtree[t * 2] = 0;
  for (t = 0; t < Tw; t++)
    s.bl_tree[t * 2] = 0;
  s.dyn_ltree[Lw * 2] = 1, s.opt_len = s.static_len = 0, s.last_lit = s.matches = 0;
}
function dP(s) {
  s.bi_valid > 8 ? iu(s, s.bi_buf) : s.bi_valid > 0 && (s.pending_buf[s.pending++] = s.bi_buf), s.bi_buf = 0, s.bi_valid = 0;
}
function RG(s, t, e, a) {
  dP(s), a && (iu(s, e), iu(s, ~e)), _s(s.pending_buf, s.window, t, e, s.pending), s.pending += e;
}
function y1(s, t, e, a) {
  var n = t * 2, i = e * 2;
  return s[n] < s[i] || s[n] === s[i] && a[t] <= a[e];
}
function Ob(s, t, e) {
  for (var a = s.heap[e], n = e << 1; n <= s.heap_len && (n < s.heap_len && y1(t, s.heap[n + 1], s.heap[n], s.depth) && n++, !y1(t, a, s.heap[n], s.depth)); )
    s.heap[e] = s.heap[n], e = n, n <<= 1;
  s.heap[e] = a;
}
function f1(s, t, e) {
  var a, n, i = 0, r, l;
  if (s.last_lit !== 0)
    do
      a = s.pending_buf[s.d_buf + i * 2] << 8 | s.pending_buf[s.d_buf + i * 2 + 1], n = s.pending_buf[s.l_buf + i], i++, a === 0 ? _i(s, n, t) : (r = Zo[n], _i(s, r + Xu + 1, t), l = Pv[r], l !== 0 && (n -= Mh[r], xs(s, n, l)), a--, r = rP(a), _i(s, r, e), l = Oh[r], l !== 0 && (a -= Td[r], xs(s, a, l)));
    while (i < s.last_lit);
  _i(s, Lw, t);
}
function Ev(s, t) {
  var e = t.dyn_tree, a = t.stat_desc.static_tree, n = t.stat_desc.has_stree, i = t.stat_desc.elems, r, l, o = -1, c;
  for (s.heap_len = 0, s.heap_max = Q0, r = 0; r < i; r++)
    e[r * 2] !== 0 ? (s.heap[++s.heap_len] = o = r, s.depth[r] = 0) : e[r * 2 + 1] = 0;
  for (; s.heap_len < 2; )
    c = s.heap[++s.heap_len] = o < 2 ? ++o : 0, e[c * 2] = 1, s.depth[c] = 0, s.opt_len--, n && (s.static_len -= a[c * 2 + 1]);
  for (t.max_code = o, r = s.heap_len >> 1; r >= 1; r--)
    Ob(s, e, r);
  c = i;
  do
    r = s.heap[
      1
      /*SMALLEST*/
    ], s.heap[
      1
      /*SMALLEST*/
    ] = s.heap[s.heap_len--], Ob(
      s,
      e,
      1
      /*SMALLEST*/
    ), l = s.heap[
      1
      /*SMALLEST*/
    ], s.heap[--s.heap_max] = r, s.heap[--s.heap_max] = l, e[c * 2] = e[r * 2] + e[l * 2], s.depth[c] = (s.depth[r] >= s.depth[l] ? s.depth[r] : s.depth[l]) + 1, e[r * 2 + 1] = e[l * 2 + 1] = c, s.heap[
      1
      /*SMALLEST*/
    ] = c++, Ob(
      s,
      e,
      1
      /*SMALLEST*/
    );
  while (s.heap_len >= 2);
  s.heap[--s.heap_max] = s.heap[
    1
    /*SMALLEST*/
  ], EG(s, t), oP(e, o, s.bl_count);
}
function b1(s, t, e) {
  var a, n = -1, i, r = t[0 * 2 + 1], l = 0, o = 7, c = 4;
  for (r === 0 && (o = 138, c = 3), t[(e + 1) * 2 + 1] = 65535, a = 0; a <= e; a++)
    i = r, r = t[(a + 1) * 2 + 1], !(++l < o && i === r) && (l < c ? s.bl_tree[i * 2] += l : i !== 0 ? (i !== n && s.bl_tree[i * 2]++, s.bl_tree[Z0 * 2]++) : l <= 10 ? s.bl_tree[tP * 2]++ : s.bl_tree[eP * 2]++, l = 0, n = i, r === 0 ? (o = 138, c = 3) : i === r ? (o = 6, c = 3) : (o = 7, c = 4));
}
function v1(s, t, e) {
  var a, n = -1, i, r = t[0 * 2 + 1], l = 0, o = 7, c = 4;
  for (r === 0 && (o = 138, c = 3), a = 0; a <= e; a++)
    if (i = r, r = t[(a + 1) * 2 + 1], !(++l < o && i === r)) {
      if (l < c)
        do
          _i(s, i, s.bl_tree);
        while (--l !== 0);
      else
        i !== 0 ? (i !== n && (_i(s, i, s.bl_tree), l--), _i(s, Z0, s.bl_tree), xs(s, l - 3, 2)) : l <= 10 ? (_i(s, tP, s.bl_tree), xs(s, l - 3, 3)) : (_i(s, eP, s.bl_tree), xs(s, l - 11, 7));
      l = 0, n = i, r === 0 ? (o = 138, c = 3) : i === r ? (o = 6, c = 3) : (o = 7, c = 4);
    }
}
function YG(s) {
  var t;
  for (b1(s, s.dyn_ltree, s.l_desc.max_code), b1(s, s.dyn_dtree, s.d_desc.max_code), Ev(s, s.bl_desc), t = Tw - 1; t >= 3 && s.bl_tree[aP[t] * 2 + 1] === 0; t--)
    ;
  return s.opt_len += 3 * (t + 1) + 5 + 5 + 4, t;
}
function _G(s, t, e, a) {
  var n;
  for (xs(s, t - 257, 5), xs(s, e - 1, 5), xs(s, a - 4, 4), n = 0; n < a; n++)
    xs(s, s.bl_tree[aP[n] * 2 + 1], 3);
  v1(s, s.dyn_ltree, t - 1), v1(s, s.dyn_dtree, e - 1);
}
function OG(s) {
  var t = 4093624447, e;
  for (e = 0; e <= 31; e++, t >>>= 1)
    if (t & 1 && s.dyn_ltree[e * 2] !== 0)
      return XL;
  if (s.dyn_ltree[9 * 2] !== 0 || s.dyn_ltree[10 * 2] !== 0 || s.dyn_ltree[13 * 2] !== 0)
    return GL;
  for (e = 32; e < Xu; e++)
    if (s.dyn_ltree[e * 2] !== 0)
      return GL;
  return XL;
}
var x1 = !1;
function MG(s) {
  x1 || (NG(), x1 = !0), s.l_desc = new _b(s.dyn_ltree, nP), s.d_desc = new _b(s.dyn_dtree, sP), s.bl_desc = new _b(s.bl_tree, iP), s.bi_buf = 0, s.bi_valid = 0, cP(s);
}
function uP(s, t, e, a) {
  xs(s, ($G << 1) + (a ? 1 : 0), 3), RG(s, t, e, !0);
}
function XG(s) {
  xs(s, J0 << 1, 3), _i(s, Lw, Ii), PG(s);
}
function GG(s, t, e, a) {
  var n, i, r = 0;
  s.level > 0 ? (s.strm.data_type === _0 && (s.strm.data_type = OG(s)), Ev(s, s.l_desc), Ev(s, s.d_desc), r = YG(s), n = s.opt_len + 3 + 7 >>> 3, i = s.static_len + 3 + 7 >>> 3, i <= n && (n = i)) : n = i = e + 5, e + 4 <= n && t !== -1 ? uP(s, t, e, a) : s.strategy === Y0 || i === n ? (xs(s, (J0 << 1) + (a ? 1 : 0), 3), f1(s, Ii, zo)) : (xs(s, (SG << 1) + (a ? 1 : 0), 3), _G(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, r + 1), f1(s, s.dyn_ltree, s.dyn_dtree)), cP(s), a && dP(s);
}
function Vr(s, t, e) {
  return s.pending_buf[s.d_buf + s.last_lit * 2] = t >>> 8 & 255, s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = t & 255, s.pending_buf[s.l_buf + s.last_lit] = e & 255, s.last_lit++, t === 0 ? s.dyn_ltree[e * 2]++ : (s.matches++, t--, s.dyn_ltree[(Zo[e] + Xu + 1) * 2]++, s.dyn_dtree[rP(t) * 2]++), s.last_lit === s.lit_bufsize - 1;
}
var HG = 9, UG = 29, FG = 256, Nv = FG + 1 + UG, zG = 30, BG = 19, WG = 2 * Nv + 1, jG = 15, oa = 3, Mr = 258, yi = Mr + oa + 1, VG = 32, ef = 42, Rv = 69, Xh = 73, Gh = 91, Hh = 103, Nl = 113, Ld = 666, Sn = 1, Gu = 2, Fl = 3, Mc = 4, qG = 3;
function Xr(s, t) {
  return s.msg = su[t], t;
}
function w1(s) {
  return (s << 1) - (s > 4 ? 9 : 0);
}
function _r(s) {
  for (var t = s.length; --t >= 0; )
    s[t] = 0;
}
function Nr(s) {
  var t = s.state, e = t.pending;
  e > s.avail_out && (e = s.avail_out), e !== 0 && (_s(s.output, t.pending_buf, t.pending_out, e, s.next_out), s.next_out += e, t.pending_out += e, s.total_out += e, s.avail_out -= e, t.pending -= e, t.pending === 0 && (t.pending_out = 0));
}
function Hn(s, t) {
  GG(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, t), s.block_start = s.strstart, Nr(s.strm);
}
function pa(s, t) {
  s.pending_buf[s.pending++] = t;
}
function fd(s, t) {
  s.pending_buf[s.pending++] = t >>> 8 & 255, s.pending_buf[s.pending++] = t & 255;
}
function KG(s, t, e, a) {
  var n = s.avail_in;
  return n > a && (n = a), n === 0 ? 0 : (s.avail_in -= n, _s(t, s.input, s.next_in, n, e), s.state.wrap === 1 ? s.adler = nu(s.adler, t, n, e) : s.state.wrap === 2 && (s.adler = En(s.adler, t, n, e)), s.next_in += n, s.total_in += n, n);
}
function pP(s, t) {
  var e = s.max_chain_length, a = s.strstart, n, i, r = s.prev_length, l = s.nice_match, o = s.strstart > s.w_size - yi ? s.strstart - (s.w_size - yi) : 0, c = s.window, d = s.w_mask, p = s.prev, h = s.strstart + Mr, g = c[a + r - 1], x = c[a + r];
  s.prev_length >= s.good_match && (e >>= 2), l > s.lookahead && (l = s.lookahead);
  do
    if (n = t, !(c[n + r] !== x || c[n + r - 1] !== g || c[n] !== c[a] || c[++n] !== c[a + 1])) {
      a += 2, n++;
      do
        ;
      while (c[++a] === c[++n] && c[++a] === c[++n] && c[++a] === c[++n] && c[++a] === c[++n] && c[++a] === c[++n] && c[++a] === c[++n] && c[++a] === c[++n] && c[++a] === c[++n] && a < h);
      if (i = Mr - (h - a), a = h - Mr, i > r) {
        if (s.match_start = t, r = i, i >= l)
          break;
        g = c[a + r - 1], x = c[a + r];
      }
    }
  while ((t = p[t & d]) > o && --e !== 0);
  return r <= s.lookahead ? r : s.lookahead;
}
function zl(s) {
  var t = s.w_size, e, a, n, i, r;
  do {
    if (i = s.window_size - s.lookahead - s.strstart, s.strstart >= t + (t - yi)) {
      _s(s.window, s.window, t, t, 0), s.match_start -= t, s.strstart -= t, s.block_start -= t, a = s.hash_size, e = a;
      do
        n = s.head[--e], s.head[e] = n >= t ? n - t : 0;
      while (--a);
      a = t, e = a;
      do
        n = s.prev[--e], s.prev[e] = n >= t ? n - t : 0;
      while (--a);
      i += t;
    }
    if (s.strm.avail_in === 0)
      break;
    if (a = KG(s.strm, s.window, s.strstart + s.lookahead, i), s.lookahead += a, s.lookahead + s.insert >= oa)
      for (r = s.strstart - s.insert, s.ins_h = s.window[r], s.ins_h = (s.ins_h << s.hash_shift ^ s.window[r + 1]) & s.hash_mask; s.insert && (s.ins_h = (s.ins_h << s.hash_shift ^ s.window[r + oa - 1]) & s.hash_mask, s.prev[r & s.w_mask] = s.head[s.ins_h], s.head[s.ins_h] = r, r++, s.insert--, !(s.lookahead + s.insert < oa)); )
        ;
  } while (s.lookahead < yi && s.strm.avail_in !== 0);
}
function JG(s, t) {
  var e = 65535;
  for (e > s.pending_buf_size - 5 && (e = s.pending_buf_size - 5); ; ) {
    if (s.lookahead <= 1) {
      if (zl(s), s.lookahead === 0 && t === ji)
        return Sn;
      if (s.lookahead === 0)
        break;
    }
    s.strstart += s.lookahead, s.lookahead = 0;
    var a = s.block_start + e;
    if ((s.strstart === 0 || s.strstart >= a) && (s.lookahead = s.strstart - a, s.strstart = a, Hn(s, !1), s.strm.avail_out === 0) || s.strstart - s.block_start >= s.w_size - yi && (Hn(s, !1), s.strm.avail_out === 0))
      return Sn;
  }
  return s.insert = 0, t === rs ? (Hn(s, !0), s.strm.avail_out === 0 ? Fl : Mc) : (s.strstart > s.block_start && (Hn(s, !1), s.strm.avail_out === 0), Sn);
}
function Mb(s, t) {
  for (var e, a; ; ) {
    if (s.lookahead < yi) {
      if (zl(s), s.lookahead < yi && t === ji)
        return Sn;
      if (s.lookahead === 0)
        break;
    }
    if (e = 0, s.lookahead >= oa && (s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + oa - 1]) & s.hash_mask, e = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h], s.head[s.ins_h] = s.strstart), e !== 0 && s.strstart - e <= s.w_size - yi && (s.match_length = pP(s, e)), s.match_length >= oa)
      if (a = Vr(s, s.strstart - s.match_start, s.match_length - oa), s.lookahead -= s.match_length, s.match_length <= s.max_lazy_match && s.lookahead >= oa) {
        s.match_length--;
        do
          s.strstart++, s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + oa - 1]) & s.hash_mask, e = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h], s.head[s.ins_h] = s.strstart;
        while (--s.match_length !== 0);
        s.strstart++;
      } else
        s.strstart += s.match_length, s.match_length = 0, s.ins_h = s.window[s.strstart], s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + 1]) & s.hash_mask;
    else
      a = Vr(s, 0, s.window[s.strstart]), s.lookahead--, s.strstart++;
    if (a && (Hn(s, !1), s.strm.avail_out === 0))
      return Sn;
  }
  return s.insert = s.strstart < oa - 1 ? s.strstart : oa - 1, t === rs ? (Hn(s, !0), s.strm.avail_out === 0 ? Fl : Mc) : s.last_lit && (Hn(s, !1), s.strm.avail_out === 0) ? Sn : Gu;
}
function _o(s, t) {
  for (var e, a, n; ; ) {
    if (s.lookahead < yi) {
      if (zl(s), s.lookahead < yi && t === ji)
        return Sn;
      if (s.lookahead === 0)
        break;
    }
    if (e = 0, s.lookahead >= oa && (s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + oa - 1]) & s.hash_mask, e = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h], s.head[s.ins_h] = s.strstart), s.prev_length = s.match_length, s.prev_match = s.match_start, s.match_length = oa - 1, e !== 0 && s.prev_length < s.max_lazy_match && s.strstart - e <= s.w_size - yi && (s.match_length = pP(s, e), s.match_length <= 5 && (s.strategy === BX || s.match_length === oa && s.strstart - s.match_start > 4096) && (s.match_length = oa - 1)), s.prev_length >= oa && s.match_length <= s.prev_length) {
      n = s.strstart + s.lookahead - oa, a = Vr(s, s.strstart - 1 - s.prev_match, s.prev_length - oa), s.lookahead -= s.prev_length - 1, s.prev_length -= 2;
      do
        ++s.strstart <= n && (s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + oa - 1]) & s.hash_mask, e = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h], s.head[s.ins_h] = s.strstart);
      while (--s.prev_length !== 0);
      if (s.match_available = 0, s.match_length = oa - 1, s.strstart++, a && (Hn(s, !1), s.strm.avail_out === 0))
        return Sn;
    } else if (s.match_available) {
      if (a = Vr(s, 0, s.window[s.strstart - 1]), a && Hn(s, !1), s.strstart++, s.lookahead--, s.strm.avail_out === 0)
        return Sn;
    } else
      s.match_available = 1, s.strstart++, s.lookahead--;
  }
  return s.match_available && (a = Vr(s, 0, s.window[s.strstart - 1]), s.match_available = 0), s.insert = s.strstart < oa - 1 ? s.strstart : oa - 1, t === rs ? (Hn(s, !0), s.strm.avail_out === 0 ? Fl : Mc) : s.last_lit && (Hn(s, !1), s.strm.avail_out === 0) ? Sn : Gu;
}
function QG(s, t) {
  for (var e, a, n, i, r = s.window; ; ) {
    if (s.lookahead <= Mr) {
      if (zl(s), s.lookahead <= Mr && t === ji)
        return Sn;
      if (s.lookahead === 0)
        break;
    }
    if (s.match_length = 0, s.lookahead >= oa && s.strstart > 0 && (n = s.strstart - 1, a = r[n], a === r[++n] && a === r[++n] && a === r[++n])) {
      i = s.strstart + Mr;
      do
        ;
      while (a === r[++n] && a === r[++n] && a === r[++n] && a === r[++n] && a === r[++n] && a === r[++n] && a === r[++n] && a === r[++n] && n < i);
      s.match_length = Mr - (i - n), s.match_length > s.lookahead && (s.match_length = s.lookahead);
    }
    if (s.match_length >= oa ? (e = Vr(s, 1, s.match_length - oa), s.lookahead -= s.match_length, s.strstart += s.match_length, s.match_length = 0) : (e = Vr(s, 0, s.window[s.strstart]), s.lookahead--, s.strstart++), e && (Hn(s, !1), s.strm.avail_out === 0))
      return Sn;
  }
  return s.insert = 0, t === rs ? (Hn(s, !0), s.strm.avail_out === 0 ? Fl : Mc) : s.last_lit && (Hn(s, !1), s.strm.avail_out === 0) ? Sn : Gu;
}
function ZG(s, t) {
  for (var e; ; ) {
    if (s.lookahead === 0 && (zl(s), s.lookahead === 0)) {
      if (t === ji)
        return Sn;
      break;
    }
    if (s.match_length = 0, e = Vr(s, 0, s.window[s.strstart]), s.lookahead--, s.strstart++, e && (Hn(s, !1), s.strm.avail_out === 0))
      return Sn;
  }
  return s.insert = 0, t === rs ? (Hn(s, !0), s.strm.avail_out === 0 ? Fl : Mc) : s.last_lit && (Hn(s, !1), s.strm.avail_out === 0) ? Sn : Gu;
}
function Li(s, t, e, a, n) {
  this.good_length = s, this.max_lazy = t, this.nice_length = e, this.max_chain = a, this.func = n;
}
var Dw = function() {
  var s = [
    /*      good lazy nice chain */
    new Li(0, 0, 0, 0, JG),
    /* 0 store only */
    new Li(4, 4, 8, 4, Mb),
    /* 1 max speed, no lazy matches */
    new Li(4, 5, 16, 8, Mb),
    /* 2 */
    new Li(4, 6, 32, 32, Mb),
    /* 3 */
    new Li(4, 4, 16, 16, _o),
    /* 4 lazy matches */
    new Li(8, 16, 32, 32, _o),
    /* 5 */
    new Li(8, 16, 128, 128, _o),
    /* 6 */
    new Li(8, 32, 128, 256, _o),
    /* 7 */
    new Li(32, 128, 258, 1024, _o),
    /* 8 */
    new Li(32, 258, 258, 4096, _o)
    /* 9 max compression */
  ];
  return Dw = function() {
    return s;
  }, s;
};
function tH(s) {
  s.window_size = 2 * s.w_size, _r(s.head);
  var t = Dw();
  s.max_lazy_match = t[s.level].max_lazy, s.good_match = t[s.level].good_length, s.nice_match = t[s.level].nice_length, s.max_chain_length = t[s.level].max_chain, s.strstart = 0, s.block_start = 0, s.lookahead = 0, s.insert = 0, s.match_length = s.prev_length = oa - 1, s.match_available = 0, s.ins_h = 0;
}
function eH() {
  this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = Qy, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = fs(WG * 2), this.dyn_dtree = fs((2 * zG + 1) * 2), this.bl_tree = fs((2 * BG + 1) * 2), _r(this.dyn_ltree), _r(this.dyn_dtree), _r(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = fs(jG + 1), this.heap = fs(2 * Nv + 1), _r(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = fs(2 * Nv + 1), _r(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
}
function aH(s) {
  var t;
  return !s || !s.state ? Xr(s, ei) : (s.total_in = s.total_out = 0, s.data_type = _0, t = s.state, t.pending = 0, t.pending_out = 0, t.wrap < 0 && (t.wrap = -t.wrap), t.status = t.wrap ? ef : Nl, s.adler = t.wrap === 2 ? 0 : 1, t.last_flush = ji, MG(t), tn);
}
function nH(s) {
  var t = aH(s);
  return t === tn && tH(s.state), t;
}
function sH(s, t) {
  return !s || !s.state || s.state.wrap !== 2 ? ei : (s.state.gzhead = t, tn);
}
function iH(s, t, e, a, n, i) {
  if (!s)
    return ei;
  var r = 1;
  if (t === R0 && (t = 6), a < 0 ? (r = 0, a = -a) : a > 15 && (r = 2, a -= 16), n < 1 || n > HG || e !== Qy || a < 8 || a > 15 || t < 0 || t > 9 || i < 0 || i > Y0)
    return Xr(s, ei);
  a === 8 && (a = 9);
  var l = new eH();
  return s.state = l, l.strm = s, l.wrap = r, l.gzhead = null, l.w_bits = a, l.w_size = 1 << l.w_bits, l.w_mask = l.w_size - 1, l.hash_bits = n + 7, l.hash_size = 1 << l.hash_bits, l.hash_mask = l.hash_size - 1, l.hash_shift = ~~((l.hash_bits + oa - 1) / oa), l.window = Vi(l.w_size * 2), l.head = fs(l.hash_size), l.prev = fs(l.w_size), l.lit_bufsize = 1 << n + 6, l.pending_buf_size = l.lit_bufsize * 4, l.pending_buf = Vi(l.pending_buf_size), l.d_buf = 1 * l.lit_bufsize, l.l_buf = 3 * l.lit_bufsize, l.level = t, l.strategy = i, l.method = e, nH(s);
}
function rH(s, t) {
  var e, a, n, i;
  if (!s || !s.state || t > ML || t < 0)
    return s ? Xr(s, ei) : ei;
  if (a = s.state, !s.output || !s.input && s.avail_in !== 0 || a.status === Ld && t !== rs)
    return Xr(s, s.avail_out === 0 ? _h : ei);
  if (a.strm = s, e = a.last_flush, a.last_flush = t, a.status === ef)
    if (a.wrap === 2)
      s.adler = 0, pa(a, 31), pa(a, 139), pa(a, 8), a.gzhead ? (pa(
        a,
        (a.gzhead.text ? 1 : 0) + (a.gzhead.hcrc ? 2 : 0) + (a.gzhead.extra ? 4 : 0) + (a.gzhead.name ? 8 : 0) + (a.gzhead.comment ? 16 : 0)
      ), pa(a, a.gzhead.time & 255), pa(a, a.gzhead.time >> 8 & 255), pa(a, a.gzhead.time >> 16 & 255), pa(a, a.gzhead.time >> 24 & 255), pa(a, a.level === 9 ? 2 : a.strategy >= ah || a.level < 2 ? 4 : 0), pa(a, a.gzhead.os & 255), a.gzhead.extra && a.gzhead.extra.length && (pa(a, a.gzhead.extra.length & 255), pa(a, a.gzhead.extra.length >> 8 & 255)), a.gzhead.hcrc && (s.adler = En(s.adler, a.pending_buf, a.pending, 0)), a.gzindex = 0, a.status = Rv) : (pa(a, 0), pa(a, 0), pa(a, 0), pa(a, 0), pa(a, 0), pa(a, a.level === 9 ? 2 : a.strategy >= ah || a.level < 2 ? 4 : 0), pa(a, qG), a.status = Nl);
    else {
      var r = Qy + (a.w_bits - 8 << 4) << 8, l = -1;
      a.strategy >= ah || a.level < 2 ? l = 0 : a.level < 6 ? l = 1 : a.level === 6 ? l = 2 : l = 3, r |= l << 6, a.strstart !== 0 && (r |= VG), r += 31 - r % 31, a.status = Nl, fd(a, r), a.strstart !== 0 && (fd(a, s.adler >>> 16), fd(a, s.adler & 65535)), s.adler = 1;
    }
  if (a.status === Rv)
    if (a.gzhead.extra) {
      for (n = a.pending; a.gzindex < (a.gzhead.extra.length & 65535) && !(a.pending === a.pending_buf_size && (a.gzhead.hcrc && a.pending > n && (s.adler = En(s.adler, a.pending_buf, a.pending - n, n)), Nr(s), n = a.pending, a.pending === a.pending_buf_size)); )
        pa(a, a.gzhead.extra[a.gzindex] & 255), a.gzindex++;
      a.gzhead.hcrc && a.pending > n && (s.adler = En(s.adler, a.pending_buf, a.pending - n, n)), a.gzindex === a.gzhead.extra.length && (a.gzindex = 0, a.status = Xh);
    } else
      a.status = Xh;
  if (a.status === Xh)
    if (a.gzhead.name) {
      n = a.pending;
      do {
        if (a.pending === a.pending_buf_size && (a.gzhead.hcrc && a.pending > n && (s.adler = En(s.adler, a.pending_buf, a.pending - n, n)), Nr(s), n = a.pending, a.pending === a.pending_buf_size)) {
          i = 1;
          break;
        }
        a.gzindex < a.gzhead.name.length ? i = a.gzhead.name.charCodeAt(a.gzindex++) & 255 : i = 0, pa(a, i);
      } while (i !== 0);
      a.gzhead.hcrc && a.pending > n && (s.adler = En(s.adler, a.pending_buf, a.pending - n, n)), i === 0 && (a.gzindex = 0, a.status = Gh);
    } else
      a.status = Gh;
  if (a.status === Gh)
    if (a.gzhead.comment) {
      n = a.pending;
      do {
        if (a.pending === a.pending_buf_size && (a.gzhead.hcrc && a.pending > n && (s.adler = En(s.adler, a.pending_buf, a.pending - n, n)), Nr(s), n = a.pending, a.pending === a.pending_buf_size)) {
          i = 1;
          break;
        }
        a.gzindex < a.gzhead.comment.length ? i = a.gzhead.comment.charCodeAt(a.gzindex++) & 255 : i = 0, pa(a, i);
      } while (i !== 0);
      a.gzhead.hcrc && a.pending > n && (s.adler = En(s.adler, a.pending_buf, a.pending - n, n)), i === 0 && (a.status = Hh);
    } else
      a.status = Hh;
  if (a.status === Hh && (a.gzhead.hcrc ? (a.pending + 2 > a.pending_buf_size && Nr(s), a.pending + 2 <= a.pending_buf_size && (pa(a, s.adler & 255), pa(a, s.adler >> 8 & 255), s.adler = 0, a.status = Nl)) : a.status = Nl), a.pending !== 0) {
    if (Nr(s), s.avail_out === 0)
      return a.last_flush = -1, tn;
  } else if (s.avail_in === 0 && w1(t) <= w1(e) && t !== rs)
    return Xr(s, _h);
  if (a.status === Ld && s.avail_in !== 0)
    return Xr(s, _h);
  if (s.avail_in !== 0 || a.lookahead !== 0 || t !== ji && a.status !== Ld) {
    var o = a.strategy === ah ? ZG(a, t) : a.strategy === WX ? QG(a, t) : Dw()[a.level].func(a, t);
    if ((o === Fl || o === Mc) && (a.status = Ld), o === Sn || o === Fl)
      return s.avail_out === 0 && (a.last_flush = -1), tn;
    if (o === Gu && (t === HX ? XG(a) : t !== ML && (uP(a, 0, 0, !1), t === UX && (_r(a.head), a.lookahead === 0 && (a.strstart = 0, a.block_start = 0, a.insert = 0))), Nr(s), s.avail_out === 0))
      return a.last_flush = -1, tn;
  }
  return t !== rs ? tn : a.wrap <= 0 ? Or : (a.wrap === 2 ? (pa(a, s.adler & 255), pa(a, s.adler >> 8 & 255), pa(a, s.adler >> 16 & 255), pa(a, s.adler >> 24 & 255), pa(a, s.total_in & 255), pa(a, s.total_in >> 8 & 255), pa(a, s.total_in >> 16 & 255), pa(a, s.total_in >> 24 & 255)) : (fd(a, s.adler >>> 16), fd(a, s.adler & 65535)), Nr(s), a.wrap > 0 && (a.wrap = -a.wrap), a.pending !== 0 ? tn : Or);
}
function lH(s) {
  var t;
  return !s || !s.state ? ei : (t = s.state.status, t !== ef && t !== Rv && t !== Xh && t !== Gh && t !== Hh && t !== Nl && t !== Ld ? Xr(s, ei) : (s.state = null, t === Nl ? Xr(s, zX) : tn));
}
function oH(s, t) {
  var e = t.length, a, n, i, r, l, o, c, d;
  if (!s || !s.state || (a = s.state, r = a.wrap, r === 2 || r === 1 && a.status !== ef || a.lookahead))
    return ei;
  for (r === 1 && (s.adler = nu(s.adler, t, e, 0)), a.wrap = 0, e >= a.w_size && (r === 0 && (_r(a.head), a.strstart = 0, a.block_start = 0, a.insert = 0), d = Vi(a.w_size), _s(d, t, e - a.w_size, a.w_size, 0), t = d, e = a.w_size), l = s.avail_in, o = s.next_in, c = s.input, s.avail_in = e, s.next_in = 0, s.input = t, zl(a); a.lookahead >= oa; ) {
    n = a.strstart, i = a.lookahead - (oa - 1);
    do
      a.ins_h = (a.ins_h << a.hash_shift ^ a.window[n + oa - 1]) & a.hash_mask, a.prev[n & a.w_mask] = a.head[a.ins_h], a.head[a.ins_h] = n, n++;
    while (--i);
    a.strstart = n, a.lookahead = oa - 1, zl(a);
  }
  return a.strstart += a.lookahead, a.block_start = a.strstart, a.insert = a.lookahead, a.lookahead = 0, a.match_length = a.prev_length = oa - 1, a.match_available = 0, s.next_in = o, s.input = c, s.avail_in = l, a.wrap = r, tn;
}
var hP = Object.prototype.toString, af = function(t) {
  this.options = O0({
    level: R0,
    method: Qy,
    chunkSize: 16384,
    windowBits: 15,
    memLevel: 8,
    strategy: jX,
    to: ""
  }, t || {});
  var e = this.options;
  e.raw && e.windowBits > 0 ? e.windowBits = -e.windowBits : e.gzip && e.windowBits > 0 && e.windowBits < 16 && (e.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new K0(), this.strm.avail_out = 0;
  var a = iH(
    this.strm,
    e.level,
    e.method,
    e.windowBits,
    e.memLevel,
    e.strategy
  );
  if (a !== tn)
    throw new Error(su[a]);
  if (e.header && sH(this.strm, e.header), e.dictionary) {
    var n;
    if (typeof e.dictionary == "string" ? n = Zy(e.dictionary) : hP.call(e.dictionary) === "[object ArrayBuffer]" ? n = new Uint8Array(e.dictionary) : n = e.dictionary, a = oH(this.strm, n), a !== tn)
      throw new Error(su[a]);
    this._dict_set = !0;
  }
};
af.prototype.push = function(t, e) {
  var a = this.strm, n = this.options.chunkSize, i, r;
  if (this.ended)
    return !1;
  r = e === ~~e ? e : e === !0 ? rs : ji, typeof t == "string" ? a.input = Zy(t) : hP.call(t) === "[object ArrayBuffer]" ? a.input = new Uint8Array(t) : a.input = t, a.next_in = 0, a.avail_in = a.input.length;
  do {
    if (a.avail_out === 0 && (a.output = Vi(n), a.next_out = 0, a.avail_out = n), i = rH(a, r), i !== Or && i !== tn)
      return this.onEnd(i), this.ended = !0, !1;
    (a.avail_out === 0 || a.avail_in === 0 && (r === rs || r === lm)) && (this.options.to === "string" ? this.onData(qX(om(a.output, a.next_out))) : this.onData(om(a.output, a.next_out)));
  } while ((a.avail_in > 0 || a.avail_out === 0) && i !== Or);
  return r === rs ? (i = lH(this.strm), this.onEnd(i), this.ended = !0, i === tn) : (r === lm && (this.onEnd(tn), a.avail_out = 0), !0);
};
af.prototype.onData = function(t) {
  this.chunks.push(t);
};
af.prototype.onEnd = function(t) {
  t === tn && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = cm(this.chunks)), this.chunks = [], this.err = t, this.msg = this.strm.msg;
};
var Hi = {
  Promise
}, Un = {
  base64: !0,
  array: !0,
  string: !0,
  nodebuffer: !1,
  nodestream: !1,
  get arraybuffer() {
    return typeof ArrayBuffer < "u" && typeof Uint8Array < "u";
  },
  // Returns true if JSZip can read/generate Uint8Array, false otherwise.
  get uint8array() {
    return typeof Uint8Array < "u";
  },
  get blob() {
    return mP();
  }
}, mP = function() {
  var s;
  if (typeof ArrayBuffer > "u")
    s = !1;
  else {
    var t = new ArrayBuffer(0);
    try {
      s = new Blob([t], {
        type: "application/zip"
      }).size === 0;
    } catch {
      s = !1;
    }
  }
  return mP = function() {
    return s;
  }, s;
}, Ri = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", cH = function(s) {
  for (var t = [], e, a, n, i, r, l, o, c = 0, d = s.length, p = d, h = typeof s != "string"; c < s.length; )
    p = d - c, h ? (e = s[c++], a = c < d ? s[c++] : 0, n = c < d ? s[c++] : 0) : (e = s.charCodeAt(c++), a = c < d ? s.charCodeAt(c++) : 0, n = c < d ? s.charCodeAt(c++) : 0), i = e >> 2, r = (e & 3) << 4 | a >> 4, l = p > 1 ? (a & 15) << 2 | n >> 6 : 64, o = p > 2 ? n & 63 : 64, t.push(Ri.charAt(i) + Ri.charAt(r) + Ri.charAt(l) + Ri.charAt(o));
  return t.join("");
}, dH = function(s) {
  var t, e, a, n, i, r, l, o = 0, c = 0, d = "data:";
  if (s.substr(0, d.length) === d)
    throw new Error("Invalid base64 input, it looks like a data url.");
  s = s.replace(/[^A-Za-z0-9\+\/\=]/g, "");
  var p = s.length * 3 / 4;
  if (s.charAt(s.length - 1) === Ri.charAt(64) && p--, s.charAt(s.length - 2) === Ri.charAt(64) && p--, p % 1 !== 0)
    throw new Error("Invalid base64 input, bad content length.");
  var h;
  for (Un.uint8array ? h = new Uint8Array(p | 0) : h = new Array(p | 0); o < s.length; )
    n = Ri.indexOf(s.charAt(o++)), i = Ri.indexOf(s.charAt(o++)), r = Ri.indexOf(s.charAt(o++)), l = Ri.indexOf(s.charAt(o++)), t = n << 2 | i >> 4, e = (i & 15) << 4 | r >> 2, a = (r & 3) << 6 | l, h[c++] = t, r !== 64 && (h[c++] = e), l !== 64 && (h[c++] = a);
  return h;
};
function uH(s) {
  var t = null;
  return Un.uint8array ? t = new Uint8Array(s.length) : t = new Array(s.length), Yv(s, t);
}
var pH = function(s, t) {
  return Hu("blob"), new Blob([s], {
    type: t
  });
};
function lh(s) {
  return s;
}
function Yv(s, t) {
  for (var e = 0; e < s.length; ++e)
    t[e] = s.charCodeAt(e) & 255;
  return t;
}
function hH(s, t, e) {
  var a = [], n = 0, i = s.length;
  if (i <= e)
    return String.fromCharCode.apply(null, s);
  for (; n < i; )
    t === "array" ? a.push(String.fromCharCode.apply(null, s.slice(n, Math.min(n + e, i)))) : a.push(String.fromCharCode.apply(null, s.subarray(n, Math.min(n + e, i)))), n += e;
  return a.join("");
}
function mH(s) {
  for (var t = "", e = 0; e < s.length; e++)
    t += String.fromCharCode(s[e]);
  return t;
}
var gP = function() {
  var s;
  try {
    s = Un.uint8array && String.fromCharCode.apply(null, new Uint8Array(1)).length === 1;
  } catch {
    s = !1;
  }
  return gP = function() {
    return s;
  }, s;
};
function Uh(s) {
  var t = 65536, e = ro(s), a = !0;
  if (e === "uint8array" && (a = gP()), a)
    for (; t > 1; )
      try {
        return hH(s, e, t);
      } catch {
        t = Math.floor(t / 2);
      }
  return mH(s);
}
var gH = Uh;
function A1(s, t) {
  for (var e = 0; e < s.length; e++)
    t[e] = s[e];
  return t;
}
var yP = {
  // string to ?
  string: {
    string: lh,
    array: function(s) {
      return Yv(s, new Array(s.length));
    },
    arraybuffer: function(s) {
      return yP.string.uint8array(s).buffer;
    },
    uint8array: function(s) {
      return Yv(s, new Uint8Array(s.length));
    }
  },
  // array to ?
  array: {
    string: Uh,
    array: lh,
    arraybuffer: function(s) {
      return new Uint8Array(s).buffer;
    },
    uint8array: function(s) {
      return new Uint8Array(s);
    }
  },
  // arraybuffer to ?
  arraybuffer: {
    string: function(s) {
      return Uh(new Uint8Array(s));
    },
    array: function(s) {
      return A1(new Uint8Array(s), new Array(s.byteLength));
    },
    arraybuffer: lh,
    uint8array: function(s) {
      return new Uint8Array(s);
    }
  },
  // uint8array to ?
  uint8array: {
    string: Uh,
    array: function(s) {
      return A1(s, new Array(s.length));
    },
    arraybuffer: function(s) {
      return s.buffer;
    },
    uint8array: lh
  }
}, kn = function(s, t) {
  if (t || (t = ""), !s)
    return t;
  Hu(s);
  var e = ro(t), a = yP[e][s](t);
  return a;
}, ro = function(s) {
  if (typeof s == "string")
    return "string";
  if (Object.prototype.toString.call(s) === "[object Array]")
    return "array";
  if (Un.uint8array && s instanceof Uint8Array)
    return "uint8array";
  if (Un.arraybuffer && s instanceof ArrayBuffer)
    return "arraybuffer";
}, Hu = function(s) {
  var t = Un[s.toLowerCase()];
  if (!t)
    throw new Error(s + " is not supported by this platform");
}, oh = 65535, tc = -1, _v = function(s) {
  var t = "", e, a;
  for (a = 0; a < (s || "").length; a++)
    e = s.charCodeAt(a), t += "\\x" + (e < 16 ? "0" : "") + e.toString(16).toUpperCase();
  return t;
}, um = function(s, t, e) {
  setTimeout(function() {
    s.apply(e || null, t || []);
  }, 0);
}, Iw = function() {
  var s = arguments, t = {}, e, a;
  for (e = 0; e < arguments.length; e++)
    for (a in arguments[e])
      Object.hasOwnProperty.call(s[e], a) && typeof t[a] > "u" && (t[a] = s[e][a]);
  return t;
}, fP = function(s, t, e, a, n) {
  var i = Hi.Promise.resolve(t).then(function(r) {
    var l = Un.blob && (r instanceof Blob || ["[object File]", "[object Blob]"].indexOf(Object.prototype.toString.call(r)) !== -1);
    return l && typeof FileReader < "u" ? new Hi.Promise(function(o, c) {
      var d = new FileReader();
      d.onload = function(p) {
        o(p.target.result);
      }, d.onerror = function(p) {
        c(p.target.error);
      }, d.readAsArrayBuffer(r);
    }) : r;
  });
  return i.then(function(r) {
    var l = ro(r);
    return l ? (l === "arraybuffer" ? r = kn("uint8array", r) : l === "string" && (n ? r = dH(r) : e && a !== !0 && (r = uH(r))), r) : Hi.Promise.reject(
      new Error("Can't read the data of '" + s + "'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?")
    );
  });
}, wa = function(t) {
  this.name = t || "default", this.streamInfo = {}, this.generatedError = null, this.extraStreamInfo = {}, this.isPaused = !0, this.isFinished = !1, this.isLocked = !1, this._listeners = {
    data: [],
    end: [],
    error: []
  }, this.previous = null;
};
wa.prototype.push = function(t) {
  this.emit("data", t);
};
wa.prototype.end = function() {
  if (this.isFinished)
    return !1;
  this.flush();
  try {
    this.emit("end"), this.cleanUp(), this.isFinished = !0;
  } catch (t) {
    this.emit("error", t);
  }
  return !0;
};
wa.prototype.error = function(t) {
  return this.isFinished ? !1 : (this.isPaused ? this.generatedError = t : (this.isFinished = !0, this.emit("error", t), this.previous && this.previous.error(t), this.cleanUp()), !0);
};
wa.prototype.on = function(t, e) {
  return this._listeners[t].push(e), this;
};
wa.prototype.cleanUp = function() {
  this.streamInfo = this.generatedError = this.extraStreamInfo = null, this._listeners = [];
};
wa.prototype.emit = function(t, e) {
  if (this._listeners[t])
    for (var a = 0; a < this._listeners[t].length; a++)
      this._listeners[t][a].call(this, e);
};
wa.prototype.pipe = function(t) {
  return t.registerPrevious(this);
};
wa.prototype.registerPrevious = function(t) {
  if (this.isLocked)
    throw new Error("The stream '" + this + "' has already been used.");
  this.streamInfo = t.streamInfo, this.mergeStreamInfo(), this.previous = t;
  var e = this;
  return t.on("data", function(a) {
    e.processChunk(a);
  }), t.on("end", function() {
    e.end();
  }), t.on("error", function(a) {
    e.error(a);
  }), this;
};
wa.prototype.pause = function() {
  return this.isPaused || this.isFinished ? !1 : (this.isPaused = !0, this.previous && this.previous.pause(), !0);
};
wa.prototype.resume = function() {
  if (!this.isPaused || this.isFinished)
    return !1;
  this.isPaused = !1;
  var t = !1;
  return this.generatedError && (this.error(this.generatedError), t = !0), this.previous && this.previous.resume(), !t;
};
wa.prototype.flush = function() {
};
wa.prototype.processChunk = function(t) {
  this.push(t);
};
wa.prototype.withStreamInfo = function(t, e) {
  return this.extraStreamInfo[t] = e, this.mergeStreamInfo(), this;
};
wa.prototype.mergeStreamInfo = function() {
  for (var t in this.extraStreamInfo)
    this.extraStreamInfo.hasOwnProperty(t) && (this.streamInfo[t] = this.extraStreamInfo[t]);
};
wa.prototype.lock = function() {
  if (this.isLocked)
    throw new Error("The stream '" + this + "' has already been used.");
  this.isLocked = !0, this.previous && this.previous.lock();
};
wa.prototype.toString = function() {
  var t = "Worker " + this.name;
  return this.previous ? this.previous + " -> " + t : t;
};
var Pw = function(s) {
  for (var t = new Array(256), e = 0; e < 256; e++)
    t[e] = e >= 252 ? 6 : e >= 248 ? 5 : e >= 240 ? 4 : e >= 224 ? 3 : e >= 192 ? 2 : 1;
  return t[254] = t[254] = 1, Pw = function(a) {
    return t[a];
  }, t[s];
}, yH = function(s) {
  var t, e, a, n, i, r = s.length, l = 0;
  for (n = 0; n < r; n++)
    e = s.charCodeAt(n), (e & 64512) === 55296 && n + 1 < r && (a = s.charCodeAt(n + 1), (a & 64512) === 56320 && (e = 65536 + (e - 55296 << 10) + (a - 56320), n++)), l += e < 128 ? 1 : e < 2048 ? 2 : e < 65536 ? 3 : 4;
  for (Un.uint8array ? t = new Uint8Array(l) : t = new Array(l), i = 0, n = 0; i < l; n++)
    e = s.charCodeAt(n), (e & 64512) === 55296 && n + 1 < r && (a = s.charCodeAt(n + 1), (a & 64512) === 56320 && (e = 65536 + (e - 55296 << 10) + (a - 56320), n++)), e < 128 ? t[i++] = e : e < 2048 ? (t[i++] = 192 | e >>> 6, t[i++] = 128 | e & 63) : e < 65536 ? (t[i++] = 224 | e >>> 12, t[i++] = 128 | e >>> 6 & 63, t[i++] = 128 | e & 63) : (t[i++] = 240 | e >>> 18, t[i++] = 128 | e >>> 12 & 63, t[i++] = 128 | e >>> 6 & 63, t[i++] = 128 | e & 63);
  return t;
}, fH = function(s, t) {
  var e;
  for (t = t || s.length, t > s.length && (t = s.length), e = t - 1; e >= 0 && (s[e] & 192) === 128; )
    e--;
  return e < 0 || e === 0 ? t : e + Pw(s[e]) > t ? e : t;
}, bH = function(s) {
  var t, e, a, n, i = s.length, r = new Array(i * 2);
  for (e = 0, t = 0; t < i; ) {
    if (a = s[t++], a < 128) {
      r[e++] = a;
      continue;
    }
    if (n = Pw(a), n > 4) {
      r[e++] = 65533, t += n - 1;
      continue;
    }
    for (a &= n === 2 ? 31 : n === 3 ? 15 : 7; n > 1 && t < i; )
      a = a << 6 | s[t++] & 63, n--;
    if (n > 1) {
      r[e++] = 65533;
      continue;
    }
    a < 65536 ? r[e++] = a : (a -= 65536, r[e++] = 55296 | a >> 10 & 1023, r[e++] = 56320 | a & 1023);
  }
  return r.length !== e && (r.subarray ? r = r.subarray(0, e) : r.length = e), gH(r);
}, Fd = function(t) {
  return yH(t);
}, Bl = function(t) {
  return t = kn(Un.uint8array ? "uint8array" : "array", t), bH(t);
}, vH = /* @__PURE__ */ function(s) {
  function t() {
    s.call(this, "utf-8 decode"), this.leftOver = null;
  }
  return s && (t.__proto__ = s), t.prototype = Object.create(s && s.prototype), t.prototype.constructor = t, t.prototype.processChunk = function(a) {
    var n = kn(Un.uint8array ? "uint8array" : "array", a.data);
    if (this.leftOver && this.leftOver.length) {
      if (Un.uint8array) {
        var i = n;
        n = new Uint8Array(i.length + this.leftOver.length), n.set(this.leftOver, 0), n.set(i, this.leftOver.length);
      } else
        n = this.leftOver.concat(n);
      this.leftOver = null;
    }
    var r = fH(n), l = n;
    r !== n.length && (Un.uint8array ? (l = n.subarray(0, r), this.leftOver = n.subarray(r, n.length)) : (l = n.slice(0, r), this.leftOver = n.slice(r, n.length))), this.push({
      data: Bl(l),
      meta: a.meta
    });
  }, t.prototype.flush = function() {
    this.leftOver && this.leftOver.length && (this.push({
      data: Bl(this.leftOver),
      meta: {}
    }), this.leftOver = null);
  }, t;
}(wa), bP = /* @__PURE__ */ function(s) {
  function t() {
    s.call(this, "utf-8 encode");
  }
  return s && (t.__proto__ = s), t.prototype = Object.create(s && s.prototype), t.prototype.constructor = t, t.prototype.processChunk = function(a) {
    this.push({
      data: Fd(a.data),
      meta: a.meta
    });
  }, t;
}(wa), xH = /* @__PURE__ */ function(s) {
  function t(e) {
    s.call(this, "ConvertWorker to " + e), this.destType = e;
  }
  return s && (t.__proto__ = s), t.prototype = Object.create(s && s.prototype), t.prototype.constructor = t, t.prototype.processChunk = function(a) {
    this.push({
      data: kn(this.destType, a.data),
      meta: a.meta
    });
  }, t;
}(wa);
function wH(s, t, e) {
  switch (s) {
    case "blob":
      return pH(kn("arraybuffer", t), e);
    case "base64":
      return cH(t);
    default:
      return kn(s, t);
  }
}
function AH(s, t) {
  var e, a = 0, n = null, i = 0;
  for (e = 0; e < t.length; e++)
    i += t[e].length;
  switch (s) {
    case "string":
      return t.join("");
    case "array":
      return Array.prototype.concat.apply([], t);
    case "uint8array":
      for (n = new Uint8Array(i), e = 0; e < t.length; e++)
        n.set(t[e], a), a += t[e].length;
      return n;
    default:
      throw new Error("concat : unsupported type '" + s + "'");
  }
}
function CH(s, t) {
  return new Hi.Promise(function(e, a) {
    var n = [], i = s._internalType, r = s._outputType, l = s._mimeType;
    s.on("data", function(o, c) {
      n.push(o), t && t(c);
    }).on("error", function(o) {
      n = [], a(o);
    }).on("end", function() {
      try {
        var o = wH(r, AH(i, n), l);
        e(o);
      } catch (c) {
        a(c);
      }
      n = [];
    }).resume();
  });
}
var Xc = function(t, e, a) {
  var n = e;
  switch (e) {
    case "blob":
    case "arraybuffer":
      n = "uint8array";
      break;
    case "base64":
      n = "string";
      break;
  }
  try {
    this._internalType = n, this._outputType = e, this._mimeType = a, Hu(n), this._worker = t.pipe(new xH(n)), t.lock();
  } catch (i) {
    this._worker = new wa("error"), this._worker.error(i);
  }
};
Xc.prototype.accumulate = function(t) {
  return CH(this, t);
};
Xc.prototype.on = function(t, e) {
  var a = this;
  return t === "data" ? this._worker.on(t, function(n) {
    e.call(a, n.data, n.meta);
  }) : this._worker.on(t, function() {
    um(e, arguments, a);
  }), this;
};
Xc.prototype.resume = function() {
  return um(this._worker.resume, [], this._worker), this;
};
Xc.prototype.pause = function() {
  return this._worker.pause(), this;
};
var $H = !1, SH = !1, kH = !1, vP = !0, TH = null, LH = null, DH = null, IH = null, PH = null, EH = null, xP = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  base64: $H,
  binary: SH,
  dir: kH,
  createFolders: vP,
  date: TH,
  compression: LH,
  compressionOptions: DH,
  comment: IH,
  unixPermissions: PH,
  dosPermissions: EH
}), NH = 16 * 1024, Ew = /* @__PURE__ */ function(s) {
  function t(e) {
    s.call(this, "DataWorker");
    var a = this;
    this.dataIsReady = !1, this.index = 0, this.max = 0, this.data = null, this.type = "", this._tickScheduled = !1, e.then(function(n) {
      a.dataIsReady = !0, a.data = n, a.max = n && n.length || 0, a.type = ro(n), a.isPaused || a._tickAndRepeat();
    }, function(n) {
      a.error(n);
    });
  }
  return s && (t.__proto__ = s), t.prototype = Object.create(s && s.prototype), t.prototype.constructor = t, t.prototype.cleanUp = function() {
    s.prototype.cleanUp.call(this), this.data = null;
  }, t.prototype.resume = function() {
    return s.prototype.resume.call(this) ? (!this._tickScheduled && this.dataIsReady && (this._tickScheduled = !0, um(this._tickAndRepeat, [], this)), !0) : !1;
  }, t.prototype._tickAndRepeat = function() {
    this._tickScheduled = !1, !(this.isPaused || this.isFinished) && (this._tick(), this.isFinished || (um(this._tickAndRepeat, [], this), this._tickScheduled = !0));
  }, t.prototype._tick = function() {
    if (this.isPaused || this.isFinished)
      return !1;
    var a = NH, n = null, i = Math.min(this.max, this.index + a);
    if (this.index >= this.max)
      return this.end();
    switch (this.type) {
      case "string":
        n = this.data.substring(this.index, i);
        break;
      case "uint8array":
        n = this.data.subarray(this.index, i);
        break;
      case "array":
        n = this.data.slice(this.index, i);
        break;
    }
    return this.index = i, this.push({
      data: n,
      meta: {
        percent: this.max ? this.index / this.max * 100 : 0
      }
    });
  }, t;
}(wa), Ov = /* @__PURE__ */ function(s) {
  function t(e) {
    s.call(this, "DataLengthProbe for " + e), this.propName = e, this.withStreamInfo(e, 0);
  }
  return s && (t.__proto__ = s), t.prototype = Object.create(s && s.prototype), t.prototype.constructor = t, t.prototype.processChunk = function(a) {
    if (a) {
      var n = this.streamInfo[this.propName] || 0;
      this.streamInfo[this.propName] = n + a.data.length;
    }
    s.prototype.processChunk.call(this, a);
  }, t;
}(wa), Nw = function() {
  for (var s = [], t = 0; t < 256; t++) {
    for (var e = t, a = 0; a < 8; a++)
      e = e & 1 ? 3988292384 ^ e >>> 1 : e >>> 1;
    s[t] = e;
  }
  return Nw = function() {
    return s;
  }, s;
};
function RH(s, t, e, a) {
  var n = Nw(), i = a + e;
  s = s ^ -1;
  for (var r = a; r < i; r++)
    s = s >>> 8 ^ n[(s ^ t[r]) & 255];
  return s ^ -1;
}
function YH(s, t, e, a) {
  var n = Nw(), i = a + e;
  s = s ^ -1;
  for (var r = a; r < i; r++)
    s = s >>> 8 ^ n[(s ^ t.charCodeAt(r)) & 255];
  return s ^ -1;
}
function ru(s, t) {
  if (typeof s > "u" || !s.length)
    return 0;
  var e = ro(s) !== "string";
  return e ? RH(t | 0, s, s.length, 0) : YH(t | 0, s, s.length, 0);
}
var wP = /* @__PURE__ */ function(s) {
  function t() {
    s.call(this, "Crc32Probe"), this.withStreamInfo("crc32", 0);
  }
  return s && (t.__proto__ = s), t.prototype = Object.create(s && s.prototype), t.prototype.constructor = t, t.prototype.processChunk = function(a) {
    this.streamInfo.crc32 = ru(a.data, this.streamInfo.crc32 || 0), this.push(a);
  }, t;
}(wa), vr = function(t, e, a, n, i) {
  this.compressedSize = t, this.uncompressedSize = e, this.crc32 = a, this.compression = n, this.compressedContent = i;
};
vr.prototype.getContentWorker = function() {
  var t = new Ew(Hi.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new Ov("data_length")), e = this;
  return t.on("end", function() {
    if (this.streamInfo.data_length !== e.uncompressedSize)
      throw new Error("Bug : uncompressed data size mismatch");
  }), t;
};
vr.prototype.getCompressedWorker = function() {
  return new Ew(Hi.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize", this.compressedSize).withStreamInfo("uncompressedSize", this.uncompressedSize).withStreamInfo("crc32", this.crc32).withStreamInfo("compression", this.compression);
};
vr.createWorkerFrom = function(t, e, a) {
  return t.pipe(new wP()).pipe(new Ov("uncompressedSize")).pipe(e.compressWorker(a)).pipe(new Ov("compressedSize")).withStreamInfo("compression", e);
};
var Uu = function(t, e, a) {
  this.name = t, this.dir = a.dir, this.date = a.date, this.comment = a.comment, this.unixPermissions = a.unixPermissions, this.dosPermissions = a.dosPermissions, this._data = e, this._dataBinary = a.binary, this.options = {
    compression: a.compression,
    compressionOptions: a.compressionOptions
  };
};
Uu.prototype.internalStream = function(t) {
  var e = null, a = "string";
  try {
    if (!t)
      throw new Error("No output type specified.");
    a = t.toLowerCase();
    var n = a === "string" || a === "text";
    (a === "binarystring" || a === "text") && (a = "string"), e = this._decompressWorker();
    var i = !this._dataBinary;
    i && !n && (e = e.pipe(new bP())), !i && n && (e = e.pipe(new vH()));
  } catch (r) {
    e = new wa("error"), e.error(r);
  }
  return new Xc(e, a, "");
};
Uu.prototype.async = function(t, e) {
  return this.internalStream(t).accumulate(e);
};
Uu.prototype._compressWorker = function(t, e) {
  if (this._data instanceof vr && this._data.compression.magic === t.magic)
    return this._data.getCompressedWorker();
  var a = this._decompressWorker();
  return this._dataBinary || (a = a.pipe(new bP())), vr.createWorkerFrom(a, t, e);
};
Uu.prototype._decompressWorker = function() {
  return this._data instanceof vr ? this._data.getContentWorker() : this._data instanceof wa ? this._data : new Ew(this._data);
};
var AP = function() {
  var s = typeof Uint8Array < "u" && typeof Uint16Array < "u" && typeof Uint32Array < "u", t = s ? "uint8array" : "array";
  AP = function() {
    return t;
  };
}, C1 = /* @__PURE__ */ function(s) {
  function t(e, a) {
    s.call(this, "FlateWorker/" + e), this._pako = null, this._pakoAction = e, this._pakoOptions = a, this.meta = {};
  }
  return s && (t.__proto__ = s), t.prototype = Object.create(s && s.prototype), t.prototype.constructor = t, t.prototype.processChunk = function(a) {
    this.meta = a.meta, this._pako === null && this._createPako(), this._pako.push(kn(AP(), a.data), !1);
  }, t.prototype.flush = function() {
    s.prototype.flush.call(this), this._pako === null && this._createPako(), this._pako.push([], !0);
  }, t.prototype.cleanUp = function() {
    s.prototype.cleanUp.call(this), this._pako = null;
  }, t.prototype._createPako = function() {
    var a = this, n = {
      raw: !0,
      level: this._pakoOptions.level || -1
      // default compression
    };
    this._pako = this._pakoAction === "Deflate" ? new af(n) : new tf(n), this._pako.onData = function(i) {
      a.push({
        data: i,
        meta: a.meta
      });
    };
  }, t;
}(wa), _H = {
  magic: "\b\0",
  compressWorker: function(s) {
    return new C1("Deflate", s);
  },
  uncompressWorker: function() {
    return new C1("Inflate", {});
  }
}, OH = {
  magic: "\0\0",
  compressWorker: function() {
    return new wa("STORE compression");
  },
  uncompressWorker: function() {
    return new wa("STORE decompression");
  }
}, Dd = {
  STORE: OH,
  DEFLATE: _H
}, Rw = "PK", Yw = "PK", Mv = "PK", $1 = "PK\x07", Xb = "PK", MH = "PK\x07\b", Oa = function(s, t) {
  var e = "", a;
  for (a = 0; a < t; a++)
    e += String.fromCharCode(s & 255), s = s >>> 8;
  return e;
}, XH = function(s, t) {
  var e = s;
  return s || (e = t ? 16893 : 33204), (e & 65535) << 16;
}, GH = function(s, t) {
  return (s || 0) & 63;
}, S1 = function(s, t, e, a, n, i) {
  var r = s.file, l = s.compression, o = i !== Fd, c = kn("string", i(r.name)), d = kn("string", Fd(r.name)), p = r.comment, h = kn("string", i(p)), g = kn("string", Fd(p)), x = d.length !== r.name.length, b = g.length !== p.length, A, T, R = "", C = "", v = "", P = r.dir, O = r.date, N = {
    crc32: 0,
    compressedSize: 0,
    uncompressedSize: 0
  };
  (!t || e) && (N.crc32 = s.crc32, N.compressedSize = s.compressedSize, N.uncompressedSize = s.uncompressedSize);
  var H = 0;
  t && (H |= 8), !o && (x || b) && (H |= 2048);
  var F = 0, B = 0;
  P && (F |= 16), n === "UNIX" ? (B = 798, F |= XH(r.unixPermissions, P)) : (B = 20, F |= GH(r.dosPermissions)), A = O.getUTCHours(), A = A << 6, A = A | O.getUTCMinutes(), A = A << 5, A = A | O.getUTCSeconds() / 2, T = O.getUTCFullYear() - 1980, T = T << 4, T = T | O.getUTCMonth() + 1, T = T << 5, T = T | O.getUTCDate(), x && (C = // Version
  Oa(1, 1) + // NameCRC32
  Oa(ru(c), 4) + // UnicodeName
  d, R += // Info-ZIP Unicode Path Extra Field
  "up" + // size
  Oa(C.length, 2) + // content
  C), b && (v = // Version
  Oa(1, 1) + // CommentCRC32
  Oa(ru(h), 4) + // UnicodeName
  g, R += // Info-ZIP Unicode Path Extra Field
  "uc" + // size
  Oa(v.length, 2) + // content
  v);
  var Q = "";
  Q += `
\0`, Q += Oa(H, 2), Q += l.magic, Q += Oa(A, 2), Q += Oa(T, 2), Q += Oa(N.crc32, 4), Q += Oa(N.compressedSize, 4), Q += Oa(N.uncompressedSize, 4), Q += Oa(c.length, 2), Q += Oa(R.length, 2);
  var it = Rw + Q + c + R, et = Yw + // version made by (00: DOS)
  Oa(B, 2) + // file header (common to file and central directory)
  Q + // file comment length
  Oa(h.length, 2) + // disk number start
  "\0\0\0\0" + // external file attributes
  Oa(F, 4) + // relative offset of local header
  Oa(a, 4) + // file name
  c + // extra field
  R + // file comment
  h;
  return {
    fileRecord: it,
    dirRecord: et
  };
}, HH = function(s, t, e, a, n) {
  var i = "", r = kn("string", n(a));
  return i = Mv + // number of this disk
  "\0\0\0\0" + // total number of entries in the central directory on this disk
  Oa(s, 2) + // total number of entries in the central directory
  Oa(s, 2) + // size of the central directory   4 bytes
  Oa(t, 4) + // offset of start of central directory with respect to the starting disk number
  Oa(e, 4) + // .ZIP file comment length
  Oa(r.length, 2) + // .ZIP file comment
  r, i;
}, UH = function(s) {
  var t = "";
  return t = MH + // crc-32                          4 bytes
  Oa(s.crc32, 4) + // compressed size                 4 bytes
  Oa(s.compressedSize, 4) + // uncompressed size               4 bytes
  Oa(s.uncompressedSize, 4), t;
}, FH = /* @__PURE__ */ function(s) {
  function t(e, a, n, i) {
    s.call(this, "ZipFileWorker"), this.bytesWritten = 0, this.zipComment = a, this.zipPlatform = n, this.encodeFileName = i, this.streamFiles = e, this.accumulate = !1, this.contentBuffer = [], this.dirRecords = [], this.currentSourceOffset = 0, this.entriesCount = 0, this.currentFile = null, this._sources = [];
  }
  return s && (t.__proto__ = s), t.prototype = Object.create(s && s.prototype), t.prototype.constructor = t, t.prototype.push = function(a) {
    var n = a.meta.percent || 0, i = this.entriesCount, r = this._sources.length;
    this.accumulate ? this.contentBuffer.push(a) : (this.bytesWritten += a.data.length, s.prototype.push.call(this, {
      data: a.data,
      meta: {
        currentFile: this.currentFile,
        percent: i ? (n + 100 * (i - r - 1)) / i : 100
      }
    }));
  }, t.prototype.openedSource = function(a) {
    this.currentSourceOffset = this.bytesWritten, this.currentFile = a.file.name;
    var n = this.streamFiles && !a.file.dir;
    if (n) {
      var i = S1(a, n, !1, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
      this.push({
        data: i.fileRecord,
        meta: { percent: 0 }
      });
    } else
      this.accumulate = !0;
  }, t.prototype.closedSource = function(a) {
    this.accumulate = !1;
    var n = this.streamFiles && !a.file.dir, i = S1(a, n, !0, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
    if (this.dirRecords.push(i.dirRecord), n)
      this.push({
        data: UH(a),
        meta: { percent: 100 }
      });
    else
      for (this.push({
        data: i.fileRecord,
        meta: { percent: 0 }
      }); this.contentBuffer.length; )
        this.push(this.contentBuffer.shift());
    this.currentFile = null;
  }, t.prototype.flush = function() {
    for (var a = this.bytesWritten, n = 0; n < this.dirRecords.length; n++)
      this.push({
        data: this.dirRecords[n],
        meta: { percent: 100 }
      });
    var i = this.bytesWritten - a, r = HH(this.dirRecords.length, i, a, this.zipComment, this.encodeFileName);
    this.push({
      data: r,
      meta: { percent: 100 }
    });
  }, t.prototype.prepareNextSource = function() {
    this.previous = this._sources.shift(), this.openedSource(this.previous.streamInfo), this.isPaused ? this.previous.pause() : this.previous.resume();
  }, t.prototype.registerPrevious = function(a) {
    this._sources.push(a);
    var n = this;
    return a.on("data", function(i) {
      n.processChunk(i);
    }), a.on("end", function() {
      n.closedSource(n.previous.streamInfo), n._sources.length ? n.prepareNextSource() : n.end();
    }), a.on("error", function(i) {
      n.error(i);
    }), this;
  }, t.prototype.resume = function() {
    if (!s.prototype.resume.call(this))
      return !1;
    if (!this.previous && this._sources.length)
      return this.prepareNextSource(), !0;
    if (!this.previous && !this._sources.length && !this.generatedError)
      return this.end(), !0;
  }, t.prototype.error = function(a) {
    var n = this._sources;
    if (!s.prototype.error.call(this, a))
      return !1;
    for (var i = 0; i < n.length; i++)
      try {
        n[i].error(a);
      } catch {
      }
    return !0;
  }, t.prototype.lock = function() {
    s.prototype.lock.call(this);
    for (var a = this._sources, n = 0; n < a.length; n++)
      a[n].lock();
  }, t;
}(wa), zH = function(s, t) {
  var e = s || t, a = Dd[e];
  if (!a)
    throw new Error(e + " is not a valid compression method !");
  return a;
}, BH = function(s, t, e) {
  var a = new FH(t.streamFiles, e, t.platform, t.encodeFileName), n = 0;
  try {
    s.forEach(function(i, r) {
      n++;
      var l = zH(r.options.compression, t.compression), o = r.options.compressionOptions || t.compressionOptions || {}, c = r.dir, d = r.date;
      r._compressWorker(l, o).withStreamInfo("file", {
        name: i,
        dir: c,
        date: d,
        comment: r.comment || "",
        unixPermissions: r.unixPermissions,
        dosPermissions: r.dosPermissions
      }).pipe(a);
    }), a.entriesCount = n;
  } catch (i) {
    a.error(i);
  }
  return a;
}, Us = function(t) {
  this.data = t, this.length = t.length, this.index = 0, this.zero = 0;
};
Us.prototype.checkOffset = function(t) {
  this.checkIndex(this.index + t);
};
Us.prototype.checkIndex = function(t) {
  if (this.length < this.zero + t || t < 0)
    throw new Error("End of data reached (data length = " + this.length + ", asked index = " + t + "). Corrupted zip ?");
};
Us.prototype.setIndex = function(t) {
  this.checkIndex(t), this.index = t;
};
Us.prototype.skip = function(t) {
  this.setIndex(this.index + t);
};
Us.prototype.byteAt = function(t) {
};
Us.prototype.readInt = function(t) {
  var e = 0, a;
  for (this.checkOffset(t), a = this.index + t - 1; a >= this.index; a--)
    e = (e << 8) + this.byteAt(a);
  return this.index += t, e;
};
Us.prototype.readString = function(t) {
  return kn("string", this.readData(t));
};
Us.prototype.readData = function(t) {
};
Us.prototype.lastIndexOfSignature = function(t) {
};
Us.prototype.readAndCheckSignature = function(t) {
};
Us.prototype.readDate = function() {
  var t = this.readInt(4);
  return new Date(Date.UTC(
    (t >> 25 & 127) + 1980,
    // year
    (t >> 21 & 15) - 1,
    // month
    t >> 16 & 31,
    // day
    t >> 11 & 31,
    // hour
    t >> 5 & 63,
    // minute
    (t & 31) << 1
  ));
};
var CP = /* @__PURE__ */ function(s) {
  function t(e) {
    s.call(this, e);
    for (var a = 0; a < this.data.length; a++)
      e[a] = e[a] & 255;
  }
  return s && (t.__proto__ = s), t.prototype = Object.create(s && s.prototype), t.prototype.constructor = t, t.prototype.byteAt = function(a) {
    return this.data[this.zero + a];
  }, t.prototype.lastIndexOfSignature = function(a) {
    for (var n = a.charCodeAt(0), i = a.charCodeAt(1), r = a.charCodeAt(2), l = a.charCodeAt(3), o = this.length - 4; o >= 0; --o)
      if (this.data[o] === n && this.data[o + 1] === i && this.data[o + 2] === r && this.data[o + 3] === l)
        return o - this.zero;
    return -1;
  }, t.prototype.readAndCheckSignature = function(a) {
    var n = a.charCodeAt(0), i = a.charCodeAt(1), r = a.charCodeAt(2), l = a.charCodeAt(3), o = this.readData(4);
    return n === o[0] && i === o[1] && r === o[2] && l === o[3];
  }, t.prototype.readData = function(a) {
    if (this.checkOffset(a), a === 0)
      return [];
    var n = this.data.slice(this.zero + this.index, this.zero + this.index + a);
    return this.index += a, n;
  }, t;
}(Us), WH = /* @__PURE__ */ function(s) {
  function t(e) {
    s.call(this, e);
  }
  return s && (t.__proto__ = s), t.prototype = Object.create(s && s.prototype), t.prototype.constructor = t, t.prototype.byteAt = function(a) {
    return this.data.charCodeAt(this.zero + a);
  }, t.prototype.lastIndexOfSignature = function(a) {
    return this.data.lastIndexOf(a) - this.zero;
  }, t.prototype.readAndCheckSignature = function(a) {
    var n = this.readData(4);
    return a === n;
  }, t.prototype.readData = function(a) {
    this.checkOffset(a);
    var n = this.data.slice(this.zero + this.index, this.zero + this.index + a);
    return this.index += a, n;
  }, t;
}(Us), jH = /* @__PURE__ */ function(s) {
  function t(e) {
    s.call(this, e);
  }
  return s && (t.__proto__ = s), t.prototype = Object.create(s && s.prototype), t.prototype.constructor = t, t.prototype.readData = function(a) {
    if (this.checkOffset(a), a === 0)
      return new Uint8Array(0);
    var n = this.data.subarray(this.zero + this.index, this.zero + this.index + a);
    return this.index += a, n;
  }, t;
}(CP);
function nf(s) {
  var t = ro(s);
  return Hu(t), t === "string" && !Un.uint8array ? new WH(s) : Un.uint8array ? new jH(kn("uint8array", s)) : new CP(kn("array", s));
}
var VH = 0, qH = 3, KH = function(s) {
  for (var t in Dd)
    if (Dd.hasOwnProperty(t) && Dd[t].magic === s)
      return Dd[t];
  return null;
}, wi = function(t, e) {
  this.options = t, this.loadOptions = e;
};
wi.prototype.isEncrypted = function() {
  return (this.bitFlag & 1) === 1;
};
wi.prototype.useUTF8 = function() {
  return (this.bitFlag & 2048) === 2048;
};
wi.prototype.readLocalPart = function(t) {
  var e, a;
  if (t.skip(22), this.fileNameLength = t.readInt(2), a = t.readInt(2), this.fileName = t.readData(this.fileNameLength), t.skip(a), this.compressedSize === -1 || this.uncompressedSize === -1)
    throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");
  if (e = KH(this.compressionMethod), e === null)
    throw new Error("Corrupted zip : compression " + _v(this.compressionMethod) + " unknown (inner file : " + kn("string", this.fileName) + ")");
  this.decompressed = new vr(this.compressedSize, this.uncompressedSize, this.crc32, e, t.readData(this.compressedSize));
};
wi.prototype.readCentralPart = function(t) {
  this.versionMadeBy = t.readInt(2), t.skip(2), this.bitFlag = t.readInt(2), this.compressionMethod = t.readString(2), this.date = t.readDate(), this.crc32 = t.readInt(4), this.compressedSize = t.readInt(4), this.uncompressedSize = t.readInt(4);
  var e = t.readInt(2);
  if (this.extraFieldsLength = t.readInt(2), this.fileCommentLength = t.readInt(2), this.diskNumberStart = t.readInt(2), this.internalFileAttributes = t.readInt(2), this.externalFileAttributes = t.readInt(4), this.localHeaderOffset = t.readInt(4), this.isEncrypted())
    throw new Error("Encrypted zip are not supported");
  t.skip(e), this.readExtraFields(t), this.parseZIP64ExtraField(t), this.fileComment = t.readData(this.fileCommentLength);
};
wi.prototype.processAttributes = function() {
  this.unixPermissions = null, this.dosPermissions = null;
  var t = this.versionMadeBy >> 8;
  this.dir = !!(this.externalFileAttributes & 16), t === VH && (this.dosPermissions = this.externalFileAttributes & 63), t === qH && (this.unixPermissions = this.externalFileAttributes >> 16 & 65535), !this.dir && this.fileNameStr.slice(-1) === "/" && (this.dir = !0);
};
wi.prototype.parseZIP64ExtraField = function(t) {
  if (this.extraFields[1]) {
    var e = nf(this.extraFields[1].value);
    this.uncompressedSize === tc && (this.uncompressedSize = e.readInt(8)), this.compressedSize === tc && (this.compressedSize = e.readInt(8)), this.localHeaderOffset === tc && (this.localHeaderOffset = e.readInt(8)), this.diskNumberStart === tc && (this.diskNumberStart = e.readInt(4));
  }
};
wi.prototype.readExtraFields = function(t) {
  var e = t.index + this.extraFieldsLength, a, n, i;
  for (this.extraFields || (this.extraFields = {}); t.index < e; )
    a = t.readInt(2), n = t.readInt(2), i = t.readData(n), this.extraFields[a] = {
      id: a,
      length: n,
      value: i
    };
};
wi.prototype.handleUTF8 = function() {
  var t = Un.uint8array ? "uint8array" : "array";
  if (this.useUTF8())
    this.fileNameStr = Bl(this.fileName), this.fileCommentStr = Bl(this.fileComment);
  else {
    var e = this.findExtraFieldUnicodePath();
    if (e !== null)
      this.fileNameStr = e;
    else {
      var a = kn(t, this.fileName);
      this.fileNameStr = this.loadOptions.decodeFileName(a);
    }
    var n = this.findExtraFieldUnicodeComment();
    if (n !== null)
      this.fileCommentStr = n;
    else {
      var i = kn(t, this.fileComment);
      this.fileCommentStr = this.loadOptions.decodeFileName(i);
    }
  }
};
wi.prototype.findExtraFieldUnicodePath = function() {
  var t = this.extraFields[28789];
  if (t) {
    var e = nf(t.value);
    return e.readInt(1) !== 1 || ru(this.fileName) !== e.readInt(4) ? null : Bl(e.readData(t.length - 5));
  }
  return null;
};
wi.prototype.findExtraFieldUnicodeComment = function() {
  var t = this.extraFields[25461];
  if (t) {
    var e = nf(t.value);
    return e.readInt(1) !== 1 || ru(this.fileComment) !== e.readInt(4) ? null : Bl(e.readData(t.length - 5));
  }
  return null;
};
var Ai = function(t) {
  this.files = [], this.loadOptions = t;
};
Ai.prototype.checkSignature = function(t) {
  if (!this.reader.readAndCheckSignature(t)) {
    this.reader.index -= 4;
    var e = this.reader.readString(4);
    throw new Error("Corrupted zip or bug: unexpected signature (" + _v(e) + ", expected " + _v(t) + ")");
  }
};
Ai.prototype.isSignature = function(t, e) {
  var a = this.reader.index;
  this.reader.setIndex(t);
  var n = this.reader.readString(4), i = n === e;
  return this.reader.setIndex(a), i;
};
Ai.prototype.readBlockEndOfCentral = function() {
  this.diskNumber = this.reader.readInt(2), this.diskWithCentralDirStart = this.reader.readInt(2), this.centralDirRecordsOnThisDisk = this.reader.readInt(2), this.centralDirRecords = this.reader.readInt(2), this.centralDirSize = this.reader.readInt(4), this.centralDirOffset = this.reader.readInt(4), this.zipCommentLength = this.reader.readInt(2);
  var t = this.reader.readData(this.zipCommentLength), e = Un.uint8array ? "uint8array" : "array", a = kn(e, t);
  this.zipComment = this.loadOptions.decodeFileName(a);
};
Ai.prototype.readBlockZip64EndOfCentral = function() {
  this.zip64EndOfCentralSize = this.reader.readInt(8), this.reader.skip(4), this.diskNumber = this.reader.readInt(4), this.diskWithCentralDirStart = this.reader.readInt(4), this.centralDirRecordsOnThisDisk = this.reader.readInt(8), this.centralDirRecords = this.reader.readInt(8), this.centralDirSize = this.reader.readInt(8), this.centralDirOffset = this.reader.readInt(8), this.zip64ExtensibleData = {};
  for (var t = this.zip64EndOfCentralSize - 44, e = 0, a, n, i; e < t; )
    a = this.reader.readInt(2), n = this.reader.readInt(4), i = this.reader.readData(n), this.zip64ExtensibleData[a] = {
      id: a,
      length: n,
      value: i
    };
};
Ai.prototype.readBlockZip64EndOfCentralLocator = function() {
  if (this.diskWithZip64CentralDirStart = this.reader.readInt(4), this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8), this.disksCount = this.reader.readInt(4), this.disksCount > 1)
    throw new Error("Multi-volumes zip are not supported");
};
Ai.prototype.readLocalFiles = function() {
  var t, e;
  for (t = 0; t < this.files.length; t++)
    e = this.files[t], this.reader.setIndex(e.localHeaderOffset), this.checkSignature(Rw), e.readLocalPart(this.reader), e.handleUTF8(), e.processAttributes();
};
Ai.prototype.readCentralDir = function() {
  var t;
  for (this.reader.setIndex(this.centralDirOffset); this.reader.readAndCheckSignature(Yw); )
    t = new wi({
      zip64: this.zip64
    }, this.loadOptions), t.readCentralPart(this.reader), this.files.push(t);
  if (this.centralDirRecords !== this.files.length && this.centralDirRecords !== 0 && this.files.length === 0)
    throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
};
Ai.prototype.readEndOfCentral = function() {
  var t = this.reader.lastIndexOfSignature(Mv);
  if (t < 0) {
    var e = !this.isSignature(0, Rw);
    throw e ? new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html") : new Error("Corrupted zip: can't find end of central directory");
  }
  this.reader.setIndex(t);
  var a = t;
  if (this.checkSignature(Mv), this.readBlockEndOfCentral(), this.diskNumber === oh || this.diskWithCentralDirStart === oh || this.centralDirRecordsOnThisDisk === oh || this.centralDirRecords === oh || this.centralDirSize === tc || this.centralDirOffset === tc) {
    if (this.zip64 = !0, t = this.reader.lastIndexOfSignature($1), t < 0)
      throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
    if (this.reader.setIndex(t), this.checkSignature($1), this.readBlockZip64EndOfCentralLocator(), !this.isSignature(this.relativeOffsetEndOfZip64CentralDir, Xb) && (this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(Xb), this.relativeOffsetEndOfZip64CentralDir < 0))
      throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
    this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir), this.checkSignature(Xb), this.readBlockZip64EndOfCentral();
  }
  var n = this.centralDirOffset + this.centralDirSize;
  this.zip64 && (n += 20, n += 12 + this.zip64EndOfCentralSize);
  var i = a - n;
  if (i > 0)
    this.isSignature(a, Yw) || (this.reader.zero = i);
  else if (i < 0)
    throw new Error("Corrupted zip: missing " + Math.abs(i) + " bytes.");
};
Ai.prototype.prepareReader = function(t) {
  this.reader = nf(t);
};
Ai.prototype.load = function(t) {
  this.prepareReader(t), this.readEndOfCentral(), this.readCentralDir(), this.readLocalFiles();
};
function JH(s) {
  return new Hi.Promise(function(t, e) {
    var a = s.decompressed.getContentWorker().pipe(new wP());
    a.on("error", function(n) {
      e(n);
    }).on("end", function() {
      a.streamInfo.crc32 !== s.decompressed.crc32 ? e(new Error("Corrupted zip : CRC32 mismatch")) : t();
    }).resume();
  });
}
function QH(s, t) {
  var e = this;
  return t = Iw(t || {}, {
    base64: !1,
    checkCRC32: !1,
    optimizedBinaryString: !1,
    createFolders: !1,
    decodeFileName: Bl
  }), fP("the loaded zip file", s, !0, t.optimizedBinaryString, t.base64).then(function(a) {
    var n = new Ai(t);
    return n.load(a), n;
  }).then(function(n) {
    var i = [Hi.Promise.resolve(n)], r = n.files;
    if (t.checkCRC32)
      for (var l = 0; l < r.length; l++)
        i.push(JH(r[l]));
    return Hi.Promise.all(i);
  }).then(function(n) {
    for (var i = n.shift(), r = i.files, l = 0; l < r.length; l++) {
      var o = r[l];
      e.file(o.fileNameStr, o.decompressed, {
        binary: !0,
        optimizedBinaryString: !0,
        date: o.date,
        dir: o.dir,
        comment: o.fileCommentStr.length ? o.fileCommentStr : null,
        unixPermissions: o.unixPermissions,
        dosPermissions: o.dosPermissions,
        createFolders: t.createFolders
      });
    }
    return i.zipComment.length && (e.comment = i.zipComment), e;
  });
}
var $P = function(s, t, e) {
  var a = ro(t), n, i = Iw(e || {}, xP);
  i.date = i.date || /* @__PURE__ */ new Date(), i.compression !== null && (i.compression = i.compression.toUpperCase()), typeof i.unixPermissions == "string" && (i.unixPermissions = parseInt(i.unixPermissions, 8)), i.unixPermissions && i.unixPermissions & 16384 && (i.dir = !0), i.dosPermissions && i.dosPermissions & 16 && (i.dir = !0), i.dir && (s = SP(s)), i.createFolders && (n = ZH(s)) && kP.call(this, n, !0);
  var r = a === "string" && i.binary === !1 && i.base64 === !1;
  (!e || typeof e.binary > "u") && (i.binary = !r);
  var l = t instanceof vr && t.uncompressedSize === 0;
  (l || i.dir || !t || t.length === 0) && (i.base64 = !1, i.binary = !0, t = "", i.compression = "STORE", a = "string");
  var o = null;
  t instanceof vr || t instanceof wa ? o = t : o = fP(s, t, i.binary, i.optimizedBinaryString, i.base64);
  var c = new Uu(s, o, i);
  this.files[s] = c;
}, ZH = function(s) {
  s.slice(-1) === "/" && (s = s.substring(0, s.length - 1));
  var t = s.lastIndexOf("/");
  return t > 0 ? s.substring(0, t) : "";
}, SP = function(s) {
  return s.slice(-1) !== "/" && (s += "/"), s;
}, kP = function(s, t) {
  return t = typeof t < "u" ? t : vP, s = SP(s), this.files[s] || $P.call(this, s, null, {
    dir: !0,
    createFolders: t
  }), this.files[s];
};
function TP(s) {
  return Object.prototype.toString.call(s) === "[object RegExp]";
}
var un = function s() {
  if (arguments.length)
    throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
  this.files = /* @__PURE__ */ Object.create(null), this.comment = null, this.root = "", this.clone = function() {
    var t = new s();
    for (var e in this)
      typeof this[e] != "function" && (t[e] = this[e]);
    return t;
  };
}, Fu = { support: { configurable: !0 }, defaults: { configurable: !0 }, version: { configurable: !0 }, external: { configurable: !0 } };
un.prototype.load = function() {
  throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
};
un.prototype.forEach = function(t) {
  var e, a, n;
  for (e in this.files)
    n = this.files[e], a = e.slice(this.root.length, e.length), a && e.slice(0, this.root.length) === this.root && t(a, n);
};
un.prototype.filter = function(t) {
  var e = [];
  return this.forEach(function(a, n) {
    t(a, n) && e.push(n);
  }), e;
};
un.prototype.file = function(t, e, a) {
  if (arguments.length === 1)
    if (TP(t)) {
      var n = t;
      return this.filter(function(r, l) {
        return !l.dir && n.test(r);
      });
    } else {
      var i = this.files[this.root + t];
      return i && !i.dir ? i : null;
    }
  else
    t = this.root + t, $P.call(this, t, e, a);
  return this;
};
un.prototype.folder = function(t) {
  if (!t)
    return this;
  if (TP(t))
    return this.filter(function(i, r) {
      return r.dir && t.test(i);
    });
  var e = this.root + t, a = kP.call(this, e), n = this.clone();
  return n.root = a.name, n;
};
un.prototype.remove = function(t) {
  t = this.root + t;
  var e = this.files[t];
  if (e || (t.slice(-1) !== "/" && (t += "/"), e = this.files[t]), e && !e.dir)
    delete this.files[t];
  else
    for (var a = this.filter(function(i, r) {
      return r.name.slice(0, t.length) === t;
    }), n = 0; n < a.length; n++)
      delete this.files[a[n].name];
  return this;
};
un.prototype.generate = function(t) {
  throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
};
un.prototype.generateInternalStream = function(t) {
  var e, a = {};
  try {
    if (a = Iw(t || {}, {
      streamFiles: !1,
      compression: "STORE",
      compressionOptions: null,
      type: "",
      platform: "DOS",
      comment: null,
      mimeType: "application/zip",
      encodeFileName: Fd
    }), a.type = a.type.toLowerCase(), a.compression = a.compression.toUpperCase(), a.type === "binarystring" && (a.type = "string"), !a.type)
      throw new Error("No output type specified.");
    Hu(a.type), (a.platform === "darwin" || a.platform === "freebsd" || a.platform === "linux" || a.platform === "sunos") && (a.platform = "UNIX"), a.platform === "win32" && (a.platform = "DOS");
    var n = a.comment || this.comment || "";
    e = BH(this, a, n);
  } catch (i) {
    e = new wa("error"), e.error(i);
  }
  return new Xc(e, a.type || "string", a.mimeType);
};
un.prototype.generateAsync = function(t, e) {
  return this.generateInternalStream(t).accumulate(e);
};
un.prototype.loadAsync = function(t, e) {
  return QH.apply(this, [t, e]);
};
un.loadAsync = function(t, e) {
  return new un().loadAsync(t, e);
};
Fu.support.get = function() {
  return Un;
};
Fu.defaults.get = function() {
  return xP;
};
Fu.version.get = function() {
  return "3.2.2-esm";
};
Fu.external.get = function() {
  return Hi;
};
Object.defineProperties(un, Fu);
var LP = { exports: {} };
(function(s, t) {
  (function(e, a) {
    a();
  })(Rs, function() {
    function e(c, d) {
      return typeof d > "u" ? d = { autoBom: !1 } : typeof d != "object" && (console.warn("Deprecated: Expected third argument to be a object"), d = { autoBom: !d }), d.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(c.type) ? new Blob(["\uFEFF", c], { type: c.type }) : c;
    }
    function a(c, d, p) {
      var h = new XMLHttpRequest();
      h.open("GET", c), h.responseType = "blob", h.onload = function() {
        o(h.response, d, p);
      }, h.onerror = function() {
        console.error("could not download file");
      }, h.send();
    }
    function n(c) {
      var d = new XMLHttpRequest();
      d.open("HEAD", c, !1);
      try {
        d.send();
      } catch {
      }
      return 200 <= d.status && 299 >= d.status;
    }
    function i(c) {
      try {
        c.dispatchEvent(new MouseEvent("click"));
      } catch {
        var d = document.createEvent("MouseEvents");
        d.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), c.dispatchEvent(d);
      }
    }
    var r = typeof window == "object" && window.window === window ? window : typeof self == "object" && self.self === self ? self : typeof Rs == "object" && Rs.global === Rs ? Rs : void 0, l = r.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent), o = r.saveAs || (typeof window != "object" || window !== r ? function() {
    } : "download" in HTMLAnchorElement.prototype && !l ? function(c, d, p) {
      var h = r.URL || r.webkitURL, g = document.createElement("a");
      d = d || c.name || "download", g.download = d, g.rel = "noopener", typeof c == "string" ? (g.href = c, g.origin === location.origin ? i(g) : n(g.href) ? a(c, d, p) : i(g, g.target = "_blank")) : (g.href = h.createObjectURL(c), setTimeout(function() {
        h.revokeObjectURL(g.href);
      }, 4e4), setTimeout(function() {
        i(g);
      }, 0));
    } : "msSaveOrOpenBlob" in navigator ? function(c, d, p) {
      if (d = d || c.name || "download", typeof c != "string")
        navigator.msSaveOrOpenBlob(e(c, p), d);
      else if (n(c))
        a(c, d, p);
      else {
        var h = document.createElement("a");
        h.href = c, h.target = "_blank", setTimeout(function() {
          i(h);
        });
      }
    } : function(c, d, p, h) {
      if (h = h || open("", "_blank"), h && (h.document.title = h.document.body.innerText = "downloading..."), typeof c == "string")
        return a(c, d, p);
      var g = c.type === "application/octet-stream", x = /constructor/i.test(r.HTMLElement) || r.safari, b = /CriOS\/[\d]+/.test(navigator.userAgent);
      if ((b || g && x || l) && typeof FileReader < "u") {
        var A = new FileReader();
        A.onloadend = function() {
          var C = A.result;
          C = b ? C : C.replace(/^data:[^;]*;/, "data:attachment/file;"), h ? h.location.href = C : location = C, h = null;
        }, A.readAsDataURL(c);
      } else {
        var T = r.URL || r.webkitURL, R = T.createObjectURL(c);
        h ? h.location = R : location.href = R, h = null, setTimeout(function() {
          T.revokeObjectURL(R);
        }, 4e4);
      }
    });
    r.saveAs = o.saveAs = o, s.exports = o;
  });
})(LP);
var Vn = LP.exports;
class t2 {
  constructor() {
    this.CELL_TYPE_STRING = "string", this.CELL_TYPE_NUMBER = "number", this.CELL_TYPE_DATE = "date", this.CELL_TYPE_BOOLEAN = "boolean", this.MISSING_KEY_FILENAME = "Zipclex config missing property filename", this.INVALID_TYPE_FILENAME = "Zipclex filename can only be of type string", this.INVALID_TYPE_SHEET = "Zipcelx sheet data is not of type array", this.INVALID_TYPE_SHEET_DATA = "Zipclex sheet data childs is not of type array", this.stylesXML = `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
  <styleSheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" >
    <fonts count="1">
      <font>
        <sz val="11" />
        <color theme="1" />
        <name val="Calibri" />
        <family val="2" />
        <scheme val="minor" />
      </font>
    </fonts>
    <fills count="2">
      <fill>
        <patternFill patternType="none" />
      </fill>
      <fill>
        <patternFill patternType="gray125" />
      </fill>
    </fills>
    <borders count="1">
      <border>
        <left />
        <right />
        <top />
        <bottom />
        <diagonal />
      </border>
    </borders>
    <cellStyleXfs count="1">
      <xf numFmtId="0" fontId="0" fillId="0" borderId="0" />
    </cellStyleXfs>
    <cellXfs count="2">
      <xf numFmtId="0" fontId="0" fillId="0" borderId="0" xfId="0" />
      <xf numFmtId="14" fontId="0" fillId="0" borderId="0" xfId="0" applyNumberFormat="1" />
    </cellXfs>
    <cellStyles count="1">
      <cellStyle name="Normal" xfId="0" builtinId="0" />
    </cellStyles>
  </styleSheet>
  `, this.workbookXML = `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
  <workbook xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main"
           xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships">
    <sheets>
      <sheet name="Sheet1" sheetId="1" r:id="rId1" />
    </sheets>
  </workbook>`, this.workbookXMLRels = `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
  <Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">
    <Relationship Id="rId3" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles" Target="styles.xml" />
    <Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet" Target="worksheets/sheet1.xml" />
  </Relationships>`, this.rels = `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
  <Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">
    <Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument" Target="xl/workbook.xml" />
  </Relationships>`, this.contentTypes = `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
  <Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types">
    <Default Extension="rels" ContentType="application/vnd.openxmlformats-package.relationships+xml" />
    <Default Extension="xml" ContentType="application/xml" />
    <Override PartName="/xl/workbook.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml" />
    <Override PartName="/xl/worksheets/sheet1.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml" />
    <Override PartName="/xl/styles.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml" />
  </Types>`, this.templateSheet = `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
  <worksheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main"
             xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships">
    <cols>{cols}</cols>
    <sheetData>{rows}</sheetData>
  </worksheet>`, this.generateExcel = (t) => {
      if (!this.validator(t))
        throw new Error("Validation failed.");
      const e = new un(), a = e.folder("xl");
      a.file("workbook.xml", this.workbookXML), a.file("styles.xml", this.stylesXML), a.file("_rels/workbook.xml.rels", this.workbookXMLRels), e.file("_rels/.rels", this.rels), e.file("[Content_Types].xml", this.contentTypes);
      const n = this.generateXMLWorksheet(t.sheet.data);
      return a.file("worksheets/sheet1.xml", n), e.generateAsync({
        type: "blob",
        mimeType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });
    }, this.childValidator = (t) => t.every((e) => Array.isArray(e)), this.validator = (t) => t.filename ? typeof t.filename != "string" ? (console.error(this.INVALID_TYPE_FILENAME), !1) : Array.isArray(t.sheet.data) ? this.childValidator(t.sheet.data) ? !0 : (console.error(this.INVALID_TYPE_SHEET_DATA), !1) : (console.error(this.INVALID_TYPE_SHEET), !1) : (console.error(this.MISSING_KEY_FILENAME), !1), this.generateColumnLetter = (t) => {
      if (typeof t != "number")
        return "";
      const e = Math.floor(t / 26), a = String.fromCharCode(97 + t % 26).toUpperCase();
      return e === 0 ? a : this.generateColumnLetter(e - 1) + a;
    }, this.generatorCellNumber = (t, e) => `${this.generateColumnLetter(t)}${e}`, this.generatorStringCell = (t, e, a) => `<c r="${this.generatorCellNumber(t, a)}" t="inlineStr"><is><t>${ti.escapeHtml(e)}</t></is></c>`, this.generatorNumberCell = (t, e, a) => `<c r="${this.generatorCellNumber(t, a)}" t="n"><v>${e}</v></c>`, this.generatorDateCell = (t, e, a) => `<c r="${this.generatorCellNumber(t, a)}" t="d" s="1"><v>${e}</v></c>`, this.generatorBooleanCell = (t, e, a) => `<c r="${this.generatorCellNumber(t, a)}" t="b"><v>${e}</v></c>`, this.generatorEmptyCell = (t, e, a) => `<c r="${this.generatorCellNumber(t, a)}"><v></v></c>`, this.formatCell = (t, e, a) => t.type === this.CELL_TYPE_STRING ? this.generatorStringCell(e, t.value, a) : t.type === this.CELL_TYPE_NUMBER ? this.generatorNumberCell(e, t.value, a) : t.type === this.CELL_TYPE_DATE ? this.generatorDateCell(e, t.value, a) : t.type === this.CELL_TYPE_BOOLEAN ? this.generatorBooleanCell(e, t.value, a) : this.generatorEmptyCell(e, t.value, a), this.formatRow = (t, e) => {
      const a = e + 1, n = t.map((i, r) => this.formatCell(i, r, a)).join("");
      return `<row r="${a}">${n}</row>`;
    }, this.generatorRows = (t) => t.map((e, a) => this.formatRow(e, a)).join(""), this.formatCol = (t, e) => {
      const a = e + 1;
      return `<col min="${a}" max="${a}" width="30" customWidth="1"/>`;
    }, this.generatorCols = (t) => t.map((e, a) => this.formatCol(e, a)).join(""), this.generateXMLWorksheet = (t) => {
      const e = this.generatorCols(t.length > 0 ? t[0] : []), a = this.generatorRows(t);
      return this.templateSheet.replace("{rows}", a).replace("{cols}", e);
    };
  }
}
const xC = class xC {
  /**
   * Converts a data table to an excel file.
   * @param tableData Array of rows to convert to an excel file. Each row consists of an array of cell values.
   * @param fileName Name for the excel file without the file extension.
   */
  static export(t, e) {
    const a = this.getRowMapper(), n = {
      filename: e,
      sheet: {
        data: t.map(a)
      }
    };
    return this.zipcelx.generateExcel(n).then((i) => {
      Vn.saveAs(i, `${n.filename}.xlsx`);
    });
  }
  /**
   * Converts multiple data tables to a zip file containing excel files.
   * @param tablesData Multiple data tables. Each table contains an array of rows to convert to a excel file. Each row consists of an array of cell values.
   * @param zipName Name for the zip file without the file extension.
   */
  static exportMany(t, e) {
    const a = this.getRowMapper();
    let n = 0;
    const i = new un(), r = () => {
      if (n === t.length)
        return Promise.resolve();
      const l = t[n++], o = {
        filename: l.fileName,
        sheet: {
          data: l.tableData.map(a)
        }
      };
      return this.zipcelx.generateExcel(o).then((c) => (i.file(`${o.filename}.xlsx`, c), r()));
    };
    return r().then(() => i.generateAsync({
      type: "blob",
      mimeType: "application/zip"
    }).then((l) => {
      Vn.saveAs(l, `${e}.zip`);
    }));
  }
  static getRowMapper() {
    const t = this.getFieldMapper();
    return (e) => e.map(t);
  }
  static getFieldMapper() {
    return (t) => t == null ? { value: t, type: null } : typeof t == "number" ? { value: t, type: "number" } : typeof t == "boolean" ? { value: t ? "true" : "false", type: "boolean" } : typeof t == "string" ? { value: t.replace(/"/g, '""'), type: "string" } : typeof t == "object" && t instanceof Date ? { value: I.format(t, "YYYY-MM-DD"), type: "date" } : { value: JSON.stringify(t), type: "string" };
  }
};
xC.zipcelx = new t2();
let xr = xC;
const wC = class wC {
  constructor(t, e) {
    this.alertService = t, this.$timeout = e;
  }
  /** Copies given data to the clipboard. */
  copyToClipboard(t) {
    return navigator.clipboard.writeText(t).then(() => this.$timeout(() => {
    }));
  }
  /** Gets the default exporters available in the current environment / account  */
  getDefaultExporters() {
    return [
      {
        id: Ta.CopyExcel,
        label: L.get("SALAXY.NG1.ODataActionsComponent.getDefaults.copyExcel"),
        hasLocales: !0,
        export: (t, e) => {
          const a = Ko.export(t, Ab.Txt, e);
          this.copyToClipboard(a), this.alertService.addSuccess(`${t.length} ${L.get("SALAXY.NG1.ExportComponent.export.rowsCopiedOnClipboard")}`);
        }
      },
      {
        id: Ta.FileExcel,
        label: L.get("SALAXY.NG1.ODataActionsComponent.getDefaults.fileExcel"),
        hasLocales: !1,
        export: (t) => xr.export(Ko.exportAsArrays(t), this.getFileName())
      },
      {
        id: Ta.CopyCsv,
        label: L.get("SALAXY.NG1.ODataActionsComponent.getDefaults.copyCsv"),
        hasLocales: !0,
        export: (t, e) => {
          const a = Ko.export(t, Ab.Csv, e);
          this.copyToClipboard(a), this.alertService.addSuccess(`${t.length} ${L.get("SALAXY.NG1.ExportComponent.export.rowsCopiedOnClipboard")}`);
        }
      },
      {
        id: Ta.FileCsv,
        label: L.get("SALAXY.NG1.ODataActionsComponent.getDefaults.fileCsv"),
        hasLocales: !0,
        export: (t, e) => {
          const a = Ko.export(t, Ab.Csv, e);
          Vn.saveAs(new Blob([a], { type: "application/octet-stream;charset=utf-8" }), `${this.getFileName()}.csv`);
        }
      }
    ];
  }
  /** Gets a filename as ¨export_[YYYYMMDD]¨. */
  getFileName() {
    return `export_${I.format("today", "YYYYMMDD")}`;
  }
};
wC.$inject = ["AlertService", "$timeout"];
let Xv = wC;
class Zs {
  /** Create gravatar url from the given email. */
  static getGravatarUrl(t) {
    return `https://www.gravatar.com/avatar/${this.md5((t + "").trim().toLowerCase())}?d=identicon`;
  }
  /** Returns true if the url is gravatar url. */
  static isGravatarUrl(t) {
    return (t + "").trim().toLowerCase().startsWith("https://www.gravatar.com/avatar/");
  }
  /**
   * Calculates md5.
   */
  static md5(t) {
    const e = (at, nt) => at << nt | at >>> 32 - nt, a = (at, nt) => {
      const yt = at & 2147483648, Rt = nt & 2147483648, Yt = at & 1073741824, K = nt & 1073741824, _ = (at & 1073741823) + (nt & 1073741823);
      return Yt & K ? _ ^ 2147483648 ^ yt ^ Rt : Yt | K ? _ & 1073741824 ? _ ^ 3221225472 ^ yt ^ Rt : _ ^ 1073741824 ^ yt ^ Rt : _ ^ yt ^ Rt;
    }, n = (at, nt, yt) => at & nt | ~at & yt, i = (at, nt, yt) => at & yt | nt & ~yt, r = (at, nt, yt) => at ^ nt ^ yt, l = (at, nt, yt) => nt ^ (at | ~yt), o = (at, nt, yt, Rt, Yt, K, _) => (at = a(at, a(a(n(nt, yt, Rt), Yt), _)), a(e(at, K), nt)), c = (at, nt, yt, Rt, Yt, K, _) => (at = a(at, a(a(i(nt, yt, Rt), Yt), _)), a(e(at, K), nt)), d = (at, nt, yt, Rt, Yt, K, _) => (at = a(at, a(a(r(nt, yt, Rt), Yt), _)), a(e(at, K), nt)), p = (at, nt, yt, Rt, Yt, K, _) => (at = a(at, a(a(l(nt, yt, Rt), Yt), _)), a(e(at, K), nt)), h = (at) => {
      let nt;
      const yt = at.length, Rt = yt + 8, K = ((Rt - Rt % 64) / 64 + 1) * 16, _ = Array(K - 1);
      let V = 0, G = 0;
      for (; G < yt; )
        nt = (G - G % 4) / 4, V = G % 4 * 8, _[nt] = _[nt] | at.charCodeAt(G) << V, G++;
      return nt = (G - G % 4) / 4, V = G % 4 * 8, _[nt] = _[nt] | 128 << V, _[K - 2] = yt << 3, _[K - 1] = yt >>> 29, _;
    }, g = (at) => {
      let nt = "", yt = "", Rt, Yt;
      for (Yt = 0; Yt <= 3; Yt++)
        Rt = at >>> Yt * 8 & 255, yt = "0" + Rt.toString(16), nt = nt + yt.substr(yt.length - 2, 2);
      return nt;
    }, x = (at) => {
      at = at.replace(/\r\n/g, `
`);
      let nt = "";
      for (let yt = 0; yt < at.length; yt++) {
        const Rt = at.charCodeAt(yt);
        Rt < 128 ? nt += String.fromCharCode(Rt) : Rt > 127 && Rt < 2048 ? (nt += String.fromCharCode(Rt >> 6 | 192), nt += String.fromCharCode(Rt & 63 | 128)) : (nt += String.fromCharCode(Rt >> 12 | 224), nt += String.fromCharCode(Rt >> 6 & 63 | 128), nt += String.fromCharCode(Rt & 63 | 128));
      }
      return nt;
    };
    let b, A, T, R, C, v, P, O;
    t = x(t);
    const tt = h(t);
    C = 1732584193, v = 4023233417, P = 2562383102, O = 271733878;
    for (let at = 0; at < tt.length; at += 16)
      b = C, A = v, T = P, R = O, C = o(C, v, P, O, tt[at + 0], 7, 3614090360), O = o(O, C, v, P, tt[at + 1], 12, 3905402710), P = o(P, O, C, v, tt[at + 2], 17, 606105819), v = o(v, P, O, C, tt[at + 3], 22, 3250441966), C = o(C, v, P, O, tt[at + 4], 7, 4118548399), O = o(O, C, v, P, tt[at + 5], 12, 1200080426), P = o(P, O, C, v, tt[at + 6], 17, 2821735955), v = o(v, P, O, C, tt[at + 7], 22, 4249261313), C = o(C, v, P, O, tt[at + 8], 7, 1770035416), O = o(O, C, v, P, tt[at + 9], 12, 2336552879), P = o(P, O, C, v, tt[at + 10], 17, 4294925233), v = o(v, P, O, C, tt[at + 11], 22, 2304563134), C = o(C, v, P, O, tt[at + 12], 7, 1804603682), O = o(O, C, v, P, tt[at + 13], 12, 4254626195), P = o(P, O, C, v, tt[at + 14], 17, 2792965006), v = o(v, P, O, C, tt[at + 15], 22, 1236535329), C = c(C, v, P, O, tt[at + 1], 5, 4129170786), O = c(O, C, v, P, tt[at + 6], 9, 3225465664), P = c(P, O, C, v, tt[at + 11], 14, 643717713), v = c(v, P, O, C, tt[at + 0], 20, 3921069994), C = c(C, v, P, O, tt[at + 5], 5, 3593408605), O = c(O, C, v, P, tt[at + 10], 9, 38016083), P = c(P, O, C, v, tt[at + 15], 14, 3634488961), v = c(v, P, O, C, tt[at + 4], 20, 3889429448), C = c(C, v, P, O, tt[at + 9], 5, 568446438), O = c(O, C, v, P, tt[at + 14], 9, 3275163606), P = c(P, O, C, v, tt[at + 3], 14, 4107603335), v = c(v, P, O, C, tt[at + 8], 20, 1163531501), C = c(C, v, P, O, tt[at + 13], 5, 2850285829), O = c(O, C, v, P, tt[at + 2], 9, 4243563512), P = c(P, O, C, v, tt[at + 7], 14, 1735328473), v = c(v, P, O, C, tt[at + 12], 20, 2368359562), C = d(C, v, P, O, tt[at + 5], 4, 4294588738), O = d(O, C, v, P, tt[at + 8], 11, 2272392833), P = d(P, O, C, v, tt[at + 11], 16, 1839030562), v = d(v, P, O, C, tt[at + 14], 23, 4259657740), C = d(C, v, P, O, tt[at + 1], 4, 2763975236), O = d(O, C, v, P, tt[at + 4], 11, 1272893353), P = d(P, O, C, v, tt[at + 7], 16, 4139469664), v = d(v, P, O, C, tt[at + 10], 23, 3200236656), C = d(C, v, P, O, tt[at + 13], 4, 681279174), O = d(O, C, v, P, tt[at + 0], 11, 3936430074), P = d(P, O, C, v, tt[at + 3], 16, 3572445317), v = d(v, P, O, C, tt[at + 6], 23, 76029189), C = d(C, v, P, O, tt[at + 9], 4, 3654602809), O = d(O, C, v, P, tt[at + 12], 11, 3873151461), P = d(P, O, C, v, tt[at + 15], 16, 530742520), v = d(v, P, O, C, tt[at + 2], 23, 3299628645), C = p(C, v, P, O, tt[at + 0], 6, 4096336452), O = p(O, C, v, P, tt[at + 7], 10, 1126891415), P = p(P, O, C, v, tt[at + 14], 15, 2878612391), v = p(v, P, O, C, tt[at + 5], 21, 4237533241), C = p(C, v, P, O, tt[at + 12], 6, 1700485571), O = p(O, C, v, P, tt[at + 3], 10, 2399980690), P = p(P, O, C, v, tt[at + 10], 15, 4293915773), v = p(v, P, O, C, tt[at + 1], 21, 2240044497), C = p(C, v, P, O, tt[at + 8], 6, 1873313359), O = p(O, C, v, P, tt[at + 15], 10, 4264355552), P = p(P, O, C, v, tt[at + 6], 15, 2734768916), v = p(v, P, O, C, tt[at + 13], 21, 1309151649), C = p(C, v, P, O, tt[at + 4], 6, 4149444226), O = p(O, C, v, P, tt[at + 11], 10, 3174756917), P = p(P, O, C, v, tt[at + 2], 15, 718787259), v = p(v, P, O, C, tt[at + 9], 21, 3951481745), C = a(C, b), v = a(v, A), P = a(P, T), O = a(O, R);
    return (g(C) + g(v) + g(P) + g(O)).toLowerCase();
  }
}
const AC = class AC {
  constructor(t) {
    this.ajax = t, this._registeredInputs = {
      array: {
        default: {
          template: "sxy"
        },
        PercentDimension: {
          template: "sxy"
        }
      },
      boolean: {
        default: {
          template: "sxy"
        },
        select: {
          template: "salaxy-components/sxy-form/boolean/default.html"
        },
        radio: {
          template: "sxy"
        },
        checkbox: {
          template: "sxy"
        },
        switch: {
          template: "sxy"
        }
      },
      integer: {
        default: {
          template: "sxy"
        }
      },
      number: {
        default: {
          template: "sxy"
        },
        count: {
          template: "salaxy-components/sxy-form/number/default.html"
        },
        percent: {
          template: "salaxy-components/sxy-form/number/default.html"
        },
        days: {
          template: "salaxy-components/sxy-form/number/default.html"
        },
        kilometers: {
          template: "salaxy-components/sxy-form/number/default.html"
        },
        hours: {
          template: "salaxy-components/sxy-form/number/default.html"
        },
        undefined: {
          template: "salaxy-components/sxy-form/number/default.html"
        }
      },
      object: {
        default: {
          template: "sxy"
        },
        Avatar: {
          template: "sxy"
        },
        DateRange: {
          template: "sxy"
        }
      },
      string: {
        default: {
          template: "sxy"
        },
        multiline: {
          template: "sxy"
        },
        email: {
          template: "sxy"
        },
        password: {
          template: "sxy"
        },
        telephone: {
          template: "sxy"
        },
        date: {
          template: "sxy"
        },
        "date-time": {
          template: "sxy"
        },
        enum: {
          template: "sxy"
        },
        radio: {
          template: "salaxy-components/sxy-form/string/enum.html"
        },
        typeahead: {
          template: "salaxy-components/sxy-form/string/enum.html"
        },
        list: {
          template: "salaxy-components/sxy-form/string/enum.html"
        },
        "pension-contract-number": {
          template: "salaxy-components/sxy-form/string/pension-contract-number.html"
        }
      }
    }, this.cache = new UM(t);
  }
  /** Gets the currently loaded schema documents. */
  getSchemas() {
    return this.cache.schemaCache.filter((t) => !!t.doc);
  }
  /** Gets the raw schema cache, mainly for injecting to other classes that may need it. */
  getCache() {
    return this.cache;
  }
  /**
   * Assures that a schema document identified by URL is loaded from server to the cache
   * Currently, supports only OpenApi 3, but we may later support OpenApi 2 and/or plain JSON schema.
   * @param openApiUrl URL to the open API document.
   * @returns A promise that resolves when the document has been loaded and you can call other methods on it.
   */
  assureSchemaDocument(t) {
    return this.cache.assureSchemaDocument(t);
  }
  /**
   * Adds a schema document to cache
   * TODO: Reconsider the signature.
   */
  addSchemaDocument(t, e) {
    return this.cache.addSchemaDocument(t, e);
  }
  /**
   * Finds a schema document from the cache.
   * This method is syncronous base method for other schema operations
   * Make sure that the schme document has been loaded before calling as this will not load the document,
   * but will fail instead if the schema document is not there.
   * @param openApiUrl URL to the open API document.
   * @param throwIfNotFound If true, will throw an error if the document is not found in the cache.
   */
  findSchemaDoc(t, e) {
    return this.cache.findSchemaDoc(t, e);
  }
  /**
   * Finds a single schema (Data model) within a schema document
   * Make sure that the schme document has been loaded before calling as this will not load the document,
   * but will fail instead if the schema document is not there.
   * @param openApiUrl URL to the open API document.
   * @param name Name of the schema (data model)
   */
  findSchema(t, e) {
    return this.cache.findSchema(t, e);
  }
  /**
   * Gets a property from a schema document. Supports single property names or longer property paths.
   * @param openApiUrl URL to the open API document.
   * @param schemaName The root type from which the property is found.
   * @param path Property path starting with the root schema.
   */
  getProperty(t, e, a) {
    const n = this.findSchema(t, e);
    return ol.getProperty(n, a);
  }
  /**
   * Registers a new custom input for type/format combination
   * @param type JSON type
   * @param format Format in the JSON schema
   * @param template Template for the type/foramt combination.
   * Special key "sxy" can be used to set default templates based on type/format,
   * e.g. ("boolean", "default", "sxy") => "salaxy-components/sxy-form/boolean/default.html".
   */
  registerInput(t, e, a) {
    this._registeredInputs[t][e] = a === "sxy" ? `salaxy-components/sxy-form/${t}/${e}.html` : a;
  }
  /** Gets the AngularJS tempalte for the input. */
  getTemplate(t) {
    const e = this._registeredInputs[t.type];
    return e ? e[t.format] ? e[t.format].template === "sxy" ? `salaxy-components/sxy-form/${t.type}/${t.format}.html` : e[t.format].template : `salaxy-components/sxy-form/${t.type}/${t.isEnum ? "enum" : "default"}.html` : (t.content = `Unregistered type: ${t.type}`, "salaxy-components/sxy-form/error/default.html");
  }
  /** Gets the registered inputs */
  getRegisteredInputs() {
    return this._registeredInputs;
  }
};
AC.$inject = ["AjaxNg1"];
let Gv = AC;
const CC = class CC {
  constructor(t) {
    t.decorator("$exceptionHandler", ["$delegate", (e) => (a, n) => {
      e(a, n);
      const i = Ne.global.appInsights, r = Ne.current;
      if (i && r && r.instrumentationKey)
        try {
          i.trackException({ exception: a }), i.flush();
        } catch (l) {
          console.debug("Application insight", l);
        }
    }]);
  }
};
CC.$inject = ["$provide"];
let Hv = CC;
class TZ {
  constructor(t) {
    this.$sce = t;
  }
  /**
   * Gets a HTML formatted version of the description.
   * @param description Description text to format
   */
  formatDescription(t) {
    if (!t)
      return null;
    const e = t.replace(/<(http[^>]*)>/g, (a, n) => n.endsWith(".jpg") || n.endsWith(".jpeg") || n.endsWith(".png") || n.endsWith(".gif") ? `<a href="${n}" title="${n}" target="_blank"><img src="${n}" alt="External image" style="max-width: 400px"></a>` : `<a href="${n}" title="${n}" target="_blank">LINK</a>`);
    return this.$sce.getTrustedHtml(e);
  }
}
const e2 = [
  {
    title: "Laskelmat (henkilö)",
    url: "#/person-calc",
    id: "personCalc",
    roles: "person",
    children: [
      {
        title: "Viimeisimmät",
        url: "#/calc",
        id: "index"
      },
      {
        title: "Luonnokset",
        url: "#/calc/draft",
        id: "draft"
      },
      {
        title: "Lähetetyt",
        url: "#/calc/shared",
        id: "shared"
      },
      {
        title: "Palkkalaskelma",
        url: "#/calc/details/*",
        visibility: "hidden",
        id: "details"
      },
      {
        title: "Uusi laskelma",
        url: "#/calc/details/*/new-for-worker",
        visibility: "hidden",
        id: "newForWorker"
      },
      {
        title: "Laskelman kopio",
        url: "#/calc/details/*/copy-as-new",
        visibility: "hidden",
        id: "copyAsNew"
      },
      {
        title: "Työntekijälle maksetut",
        url: "#/person-calc/paid-worker",
        id: "paidWorker",
        roles: "person"
      },
      {
        title: "Kotitalouden maksamat",
        url: "#/person-calc/paid-household",
        id: "paidHousehold",
        roles: "person"
      },
      {
        title: "Työntekijän lähetetyt",
        url: "#/person-calc/sent",
        roles: "person",
        id: "sent"
      },
      {
        title: "Perutut ja virheet",
        url: "#/calc/error",
        roles: "person",
        id: "error"
      }
    ]
  },
  {
    title: "Raportit (henkilö)",
    url: "#/person-archive/employer-report",
    id: "reports",
    roles: "person",
    children: [
      {
        title: "Työnantajan maksamat palkat",
        url: "#/person-archive/employer-report",
        id: "personEmployerReport"
      },
      {
        title: "Kotitalousvähennys",
        url: "#/household-years/active",
        id: "householdYears",
        roles: "householdService",
        children: [
          {
            title: "Kotitalousvähennyksen tiedot",
            url: "#/household-years/details/*",
            visibility: "hidden",
            roles: "householdService",
            id: "details"
          }
        ]
      },
      {
        title: "Työntekijälle maksetut palkat",
        url: "#/person-archive/worker-report",
        id: "personWorkerReport"
      },
      {
        url: "#/reports/yearly-summary",
        id: "yearlySummary"
      },
      {
        url: "#/reports/pay-certificate",
        roles: "test",
        id: "payCertificate"
      },
      {
        title: "Laskut",
        url: "#/invoices",
        id: "invoices",
        children: [
          {
            title: "Laskun tiedot",
            url: "#/invoices/details/*",
            visibility: "hidden",
            id: "details"
          }
        ]
      },
      {
        title: "Palkkatietoilmoitukset",
        url: "#/irepr",
        children: [{
          title: "Palkkatietoilmoitus",
          url: "#/irepr/details/*"
        }]
      },
      {
        title: "Erillisilmoitukset",
        url: "#/irpsr",
        id: "irpsr",
        children: [{
          title: "Erillisilmoitus",
          url: "#/irpsr/details/*",
          id: "details"
        }]
      }
    ]
  },
  {
    title: "Asetukset (henkilö)",
    url: "#/person-account",
    id: "settings",
    roles: "person",
    children: [
      {
        title: "Omat tiedot",
        url: "#/person-account",
        id: "personAccount"
      },
      {
        url: "#/settings",
        id: "index"
      },
      {
        title: "Oma verokortti (työntekijä)",
        url: "#/person-taxcards/worker",
        id: "workerTaxcard"
      },
      {
        title: "Työntekijöiden verokortit",
        url: "#/person-taxcards/household",
        id: "householdTaxcards"
      },
      {
        url: "#/settings/pro-settings",
        roles: "test",
        id: "proSettings"
      },
      {
        url: "#/settings/service-settings",
        id: "serviceSettings"
      },
      {
        url: "#/settings/authorizations",
        id: "authorizations"
      },
      {
        title: "Asiakaspalvelu",
        id: "accountants",
        url: "#/settings/accountants"
      },
      {
        id: "accountReset",
        url: "#/settings/account-reset",
        roles: "test"
      }
    ]
  }
], Gb = [
  {
    url: "#/",
    id: "home",
    roles: "company",
    i18n: ["SALAXY.NG1_Pages.Home", "SALAXY.NG1.WorkerListComponent", "SALAXY.NG1.WelcomeComponent", "SALAXY.NG1.SigningComponent", "SALAXY.NG1.ContactInfoComponent"],
    params: {
      features: {
        title: "Features",
        type: "array",
        default: ["welcome", "workerList", "contact"],
        items: {
          type: "string",
          enum: ["welcome", "workerList", "messages", "contact"]
        }
      },
      newCalcDisabled: {
        title: "Palkanmaksu estetty",
        type: "boolean"
      },
      newMessageThreadDisabled: {
        title: "Uuden viestiketjun luonti estetty",
        type: "boolean"
      }
    }
  },
  {
    url: "#/calc",
    id: "calculations",
    i18n: ["SALAXY.NG1.CalcListComponent.panel"],
    roles: "company",
    children: [
      {
        url: "#/calc",
        id: "index"
      },
      {
        url: "#/payroll",
        id: "payroll",
        isFullWidth: !0,
        children: [
          {
            url: "#/payroll/details/*",
            visibility: "hidden",
            id: "details",
            params: {
              actions: {
                title: "Readonly actions",
                type: "array",
                default: [],
                items: {
                  type: "string",
                  enum: ["none", "copy", "pay", "cancel"]
                }
              }
            }
          },
          {
            url: "#/payroll/import/*",
            visibility: "hidden",
            id: "import",
            isFullWidth: !0
          }
        ]
      },
      {
        url: "#/calc/details/*/new-for-worker",
        visibility: "hidden",
        id: "newForWorker"
      },
      {
        url: "#/calc/details/*/copy-as-new",
        visibility: "hidden",
        id: "copyAsNew"
      },
      {
        url: "#/calc/details/*",
        visibility: "hidden",
        id: "details",
        i18n: ["SALAXY.NG1.CalcComponent", "SALAXY.NG1.CalcNewIntroComponent", "SALAXY.NG1.CalcDetailsDialogComponent", "SALAXY.NG1.CalcDetailsWorkerComponent", "SALAXY.NG1.CalcWorktimeComponent", "SALAXY.NG1.CalcDetailsWorktimeProComponent", "SALAXY.NG1.CalcDetailsSalaryComponent", "SALAXY.NG1.CalcDetailsExpensesComponent", "SALAXY.NG1.CalcRowsComponent", "SALAXY.NG1.CalcResultsComponent", "SALAXY.NG1.CalcChartComponent", "SALAXY.NG1.CalcReportsComponent"]
      },
      {
        url: "#/calc/repair/*",
        visibility: "hidden",
        isFullWidth: !0,
        id: "details",
        i18n: ["SALAXY.NG1.CalcComponent", "SALAXY.NG1.CalcNewIntroComponent", "SALAXY.NG1.CalcDetailsDialogComponent", "SALAXY.NG1.CalcDetailsWorkerComponent", "SALAXY.NG1.CalcWorktimeComponent", "SALAXY.NG1.CalcDetailsWorktimeProComponent", "SALAXY.NG1.CalcDetailsSalaryComponent", "SALAXY.NG1.CalcDetailsExpensesComponent", "SALAXY.NG1.CalcRowsComponent", "SALAXY.NG1.CalcResultsComponent", "SALAXY.NG1.CalcChartComponent", "SALAXY.NG1.CalcReportsComponent"]
      },
      {
        url: "#/calc/paid",
        id: "paid",
        roles: "company&&!repairs",
        i18n: ["SALAXY.NG1.CalcListComponent"]
      },
      {
        url: "#/calc/paid-ir",
        id: "paid-ir",
        roles: "company&&repairs",
        i18n: ["SALAXY.NG1.CalcListComponent"]
      },
      {
        url: "#/calc/draft",
        id: "draft",
        i18n: ["SALAXY.NG1.CalcListComponent"]
      },
      {
        url: "#/calc/shared",
        id: "shared",
        i18n: ["SALAXY.NG1.CalcListComponent"]
      },
      {
        url: "#/calc/repairs",
        id: "repairs",
        roles: "company&&repairs",
        i18n: ["SALAXY.NG1.CalcListComponent"]
      },
      {
        url: "#/invoices/sepa",
        isFullWidth: !0,
        id: "sepaInvoices",
        roles: "sepaPartner"
      },
      {
        url: "#/invoices/company",
        id: "companyInvoices",
        roles: "test"
      },
      {
        title: "Maksetun laskelman muokkaus",
        url: "#/calc/editor/*",
        visibility: "hidden",
        isFullWidth: !0,
        id: "editor"
      },
      {
        url: "#/calc/import-calcs",
        id: "importCalcs",
        isFullWidth: !0,
        roles: "test"
      },
      {
        url: "#/invoices/payment-list",
        title: "Maksulista",
        isFullWidth: !0,
        id: "paymentList",
        roles: "test||invoicePaymentList"
      }
    ]
  },
  {
    url: "#/payroll",
    id: "payroll",
    roles: "company",
    visibility: "hidden",
    i18n: ["SALAXY.NG1.PayrollComponent.payrollList"],
    children: [
      {
        url: "#/payroll/details/*",
        visibility: "hidden",
        id: "payrollDetails",
        i18n: ["SALAXY.NG1.PayrollComponent.payrollEdit", "SALAXY.NG1.PayrollComponent.payrollCalcs"]
      },
      {
        url: "#/payroll/import/*",
        visibility: "hidden",
        id: "import",
        isFullWidth: !0
      }
    ]
  },
  {
    id: "messages",
    url: "#/messages",
    roles: "partnerMessaging",
    children: [
      {
        url: "#/messages",
        id: "index",
        i18n: ["SALAXY.NG1.ActionButtonComponent.startNewMessage", "SALAXY.NG1_Pages.Messages.newMessage.title", "SALAXY.NG1_Pages.Messages.newMessage.description.html"]
      },
      {
        id: "omapalkka",
        url: "#/messages/omapalkka",
        title: "Omapalkka",
        roles: "test",
        isFullWidth: !0
      },
      {
        title: "Hyväksyntä",
        url: "#/messages/approval-list",
        id: "approval",
        visibility: "hidden",
        children: [{
          title: "Hyväksy / hylkää",
          url: "#/messages/approval/*",
          visibility: "hidden",
          isFullWidth: !0,
          id: "details"
        }]
      },
      {
        url: "#/messages/details/new",
        id: "new",
        i18n: ["SALAXY.NG1_Pages.Messages.newMessageDetails.title", "SALAXY.NG1_Pages.Messages.newMessageDetails.description.html"]
      },
      {
        url: "#/messages/details/*",
        visibility: "hidden",
        id: "details"
      }
    ]
  },
  {
    url: "#/workers",
    id: "workers",
    roles: "company",
    children: [
      {
        url: "#/workers",
        id: "index",
        params: {
          hidden: {
            title: "Parts to hide from page",
            type: "array",
            default: [],
            items: {
              type: "string",
              enum: ["workers.employments.records.badge", "workers.employments.taxCard", "workers.employments.buttons.newCalc", "workers.employments.employmentId"]
            }
          }
        }
      },
      {
        url: "#/employments",
        visibility: "hidden",
        id: "employments",
        children: [
          {
            url: "#/employments/index",
            id: "index",
            visibility: "hidden"
          }
        ]
      },
      {
        url: "#/employments/details/*",
        visibility: "hidden",
        id: "details",
        i18n: ["SALAXY.NG1.WorkerDetailsComponent", "SALAXY.NG1.WorkerHolidaysComponent", "SALAXY.NG1.WorkerAbsencesComponent"],
        params: {
          features: {
            title: "Features",
            type: "array",
            default: ["detailsEdit", "employment", "calcRows", "calculations", "taxcards", "holidays", "absences"],
            items: {
              type: "string",
              enum: ["detailsEdit", "employment", "calcRows", "calculations", "taxcards", "holidays", "absences"]
            }
          },
          hidden: {
            title: "Parts to hide from page",
            type: "array",
            default: [],
            items: {
              type: "string",
              enum: ["detailsEdit", "employment", "calcRows", "calculations", "taxcards", "holidays", "absences", "employments.defaultCalcRows.features", "employments.calcs.copyAsNew"]
            }
          }
        }
      },
      {
        url: "#/workers/details/*",
        visibility: "hidden",
        id: "workerDetails",
        i18n: ["SALAXY.NG1.WorkerDetailsComponent", "SALAXY.NG1.WorkerHolidaysComponent", "SALAXY.NG1.WorkerAbsencesComponent"],
        params: {
          features: {
            title: "Features",
            type: "array",
            default: ["detailsEdit", "employment", "calcRows", "calculations", "taxcards", "holidays", "absences"],
            items: {
              type: "string",
              enum: ["detailsEdit", "employment", "calcRows", "calculations", "taxcards", "holidays", "absences"]
            }
          }
        }
      },
      {
        url: "#/workers/taxcards",
        id: "taxcards",
        i18n: ["SALAXY.NG1_Pages.Workers.Taxcards.lead"]
      },
      {
        title: "Lisää työntekijätili",
        url: "#/partners/assure-worker-account",
        id: "assureWorkerAccount",
        isFullWidth: !0,
        roles: "assureWorkerAccount"
      },
      {
        url: "#/workers/import-workers",
        id: "importWorkers",
        isFullWidth: !0,
        roles: "test"
      }
    ]
  },
  {
    url: "#/reports/holidays",
    id: "worktime",
    isFullWidth: !0,
    roles: "company&&!disableHolidays",
    children: [
      {
        id: "holidays",
        url: "#/reports/holidays",
        isFullWidth: !0
      },
      {
        id: "absences",
        url: "#/reports/absences",
        isFullWidth: !0
      }
    ]
  },
  {
    url: "#/reports",
    id: "reports",
    roles: "company",
    children: [
      {
        url: "#/reports",
        id: "index",
        i18n: ["SALAXY.NG1_Pages.Reports.latestReports", "SALAXY.NG1.SalaryReportsComponent.calculations", "SALAXY.NG1.SalaryReportsComponent.noCalculations", "SALAXY.NG1.AccountingReportsComponent.accountingReports", "SALAXY.NG1.AccountingReportsComponent.noAccountingReports", "SALAXY.NG1.InvoicesComponent.invoices", "SALAXY.NG1.InvoicesComponent.noInvoices"],
        params: {
          features: {
            title: "Features",
            type: "array",
            default: ["salaryReportList", "accountingReportList"],
            items: {
              type: "string",
              enum: ["salaryReportList", "accountingReportList", "invoiceList"]
            }
          }
        }
      },
      {
        url: "#/accounting",
        id: "accounting",
        isFullWidth: !0,
        children: [{
          url: "#/accounting/details/*",
          isFullWidth: !0,
          id: "details",
          hidden: !0
        }]
      },
      {
        url: "#/accounting/query",
        isFullWidth: !0,
        id: "accountingQuery",
        visibility: "hidden"
      },
      {
        url: "#/accounting/holiday-pay-debt-query",
        isFullWidth: !0,
        id: "accountingHolidayPayDebtQuery",
        visibility: "hidden"
      },
      {
        url: "#/reports/salary-reports",
        id: "salaryReports"
      },
      {
        url: "#/reports/summary-report-query",
        isFullWidth: !0,
        id: "summaryReportQuery"
      },
      {
        url: "#/reports/yearly-summary",
        id: "yearlySummary",
        i18n: ["SALAXY.NG1_Pages.Reports.yearlySummary", "SALAXY.NG1_Pages.Reports.yearlyTitle"]
      },
      {
        url: "#/reports/pay-certificate",
        roles: "pro",
        id: "payCertificate"
      },
      {
        url: "#/reports/accounting-legacy",
        // id: "accountingLegacy",
        i18n: ["SALAXY.NG1_Pages.Reports.accountingIntro", "SALAXY.NG1_Pages.Reports.accountingMonthly", "SALAXY.NG1_Pages.Reports.accountingYearly", "SALAXY.NG1_Sitemap.reports.archive"],
        title: "SALAXY.NG1_Sitemap.personalWeb.archive.main"
        // TODO: fix the id and translation
      },
      {
        url: "#/reports/archive-2018",
        id: "archive",
        visibility: "hidden"
      },
      {
        url: "#/reports/ad-hoc-list",
        id: "ad-hoc",
        roles: "pro,test",
        children: [
          {
            url: "#/reports/ad-hoc/*",
            isFullWidth: !0,
            visibility: "hidden",
            id: "details"
          }
        ]
      },
      {
        url: "#/invoices",
        title: "Maksut",
        id: "invoices",
        visibility: "hidden",
        children: [
          {
            url: "#/invoices/details/*",
            visibility: "hidden",
            id: "details",
            title: "Maksun tiedot",
            i18n: ["SALAXY.NG1_Pages.Invoices"],
            params: {
              features: {
                title: "Tabs",
                type: "array",
                default: ["preview", "calc"],
                items: {
                  type: "string",
                  enum: ["preview", "calc", "printAndBarCode", "actions"]
                }
              }
            }
          }
        ]
      },
      {
        url: "#/reports/holiday-report",
        id: "holidayReport",
        visibility: "visible",
        isFullWidth: !0
      },
      {
        url: "#/reports/holiday-pay-report-query/*",
        isFullWidth: !0,
        id: "holidayPayReportQuery",
        visibility: "hidden"
      },
      {
        url: "#/irepr",
        id: "irepr",
        roles: "test",
        children: [{
          url: "#/irepr/details/*",
          id: "details"
        }]
      },
      {
        url: "#/irpsr",
        id: "irpsr",
        roles: "test",
        children: [{
          url: "#/irpsr/details/*",
          id: "details"
        }]
      }
    ]
  },
  {
    url: "#/settings",
    id: "settings",
    roles: "company",
    children: [
      {
        url: "#/settings",
        id: "index",
        params: {
          features: {
            title: "Features",
            type: "array",
            default: ["account", "insurances", "accountant", "paymentChannels"],
            items: {
              type: "string",
              enum: ["account", "insurances", "accountant", "paymentChannels"]
            }
          }
        }
      },
      {
        url: "#/settings/payment-settings",
        id: "paymentSettings",
        i18n: ["SALAXY.NG1.PaymentSettingsComponent"]
      },
      {
        url: "#/settings/insurances",
        id: "insurances",
        i18n: ["SALAXY.NG1.InsuranceSettingsComponent"]
      },
      {
        url: "#/settings/row-types-settings",
        roles: "test",
        id: "rowTypesSettings"
      },
      {
        url: "#/settings/payment-channel-settings",
        id: "paymentChannelSettings"
      },
      {
        url: "#/settings/accounting-target-settings",
        id: "accountingTargetSettings"
      },
      {
        url: "#/settings/owner-settings",
        id: "ownerSettings"
      },
      {
        url: "#/settings/service-settings",
        id: "serviceSettings"
      },
      {
        url: "#/settings/authorizations",
        id: "authorizations"
      },
      {
        id: "accountants",
        url: "#/settings/accountants",
        roles: "company",
        i18n: ["SALAXY.NG1.AccountantComponent", "SALAXY.NG1.AccountantSelectionComponent"],
        params: {
          accountantRemovalDisabled: {
            title: "Tilitoimiston poistaminen estetty",
            type: "boolean"
          }
        }
      },
      {
        id: "integrations",
        url: "#/settings/integrations"
      },
      {
        id: "accountReset",
        url: "#/settings/account-reset",
        roles: "test"
      },
      {
        id: "paymentChannel",
        url: "#/payment-channel",
        visibility: "hidden"
      }
    ]
  },
  {
    url: "#/service-models/index",
    id: "pro-service",
    roles: "test&&company",
    children: [
      {
        url: "#/service-models/details/*",
        id: "details",
        visibility: "hidden",
        isFullWidth: !0
      },
      {
        url: "#/settings/pro-settings",
        id: "proSettings"
      },
      {
        id: "usecases",
        url: "#/usecases",
        children: [
          {
            id: "details",
            url: "#/usecases/details/*",
            isFullWidth: !0
          }
        ]
      },
      {
        id: "worktime-imports",
        url: "#/worktime-imports",
        isFullWidth: !0,
        children: []
      },
      {
        id: "datasets",
        title: "Datasets",
        url: "#/datasets",
        children: [
          {
            id: "details",
            title: "Dataset",
            url: "#/datasets/details/*",
            isFullWidth: !0
          }
        ]
      },
      {
        id: "calendar-occurences",
        url: "#/calendar/occurences",
        children: []
      },
      {
        id: "calendar",
        url: "#/calendar",
        children: [
          {
            id: "details",
            url: "#/calendar/details/*"
          },
          {
            id: "upload",
            url: "#/calendar/upload/*"
          }
        ]
      },
      {
        url: "#/accounting-targets",
        id: "accountingTargets",
        children: [{
          url: "#/accounting-targets/details/*",
          isFullWidth: !0,
          id: "details"
        }]
      },
      {
        url: "#/customer-invoices",
        id: "customerInvoices",
        children: [{
          url: "#/customer-invoices/details/*",
          isFullWidth: !1,
          id: "details"
        }]
      }
    ]
  },
  {
    url: "#/info",
    // info
    id: "info",
    children: [
      {
        url: "#/info",
        id: "index",
        hidden: !0,
        i18n: ["SALAXY.NG1_Pages.Info", "SALAXY.NG1.ContactInfoComponent"],
        params: {
          hideButtons: {
            title: "Piilota palkkaus.fi-napit",
            type: "boolean"
          },
          hideContactInfo: {
            title: "Piilota Aspan yhteystiedot",
            type: "boolean"
          }
        }
      },
      {
        url: "#/info/abc",
        // temporary fallback
        id: "abc",
        visibility: "hidden"
      }
    ]
  }
];
class ws {
  constructor() {
    console.debug("snowpackHack constructor");
  }
  /**
   * Gets logical visibility, as used in the views an UI logic, i.e.:
   *
   * - hidden: Node is null or visibility is Hidden, HiddenReadOnly or Disabled.
   * - readOnly: Node is null or visibility is ReadOnly, HiddenReadOnly.
   * - disabled: Visibility is Disabled.
   * - Visible: Visibility is Visible or null, node is not null.
   * - isFullWidth: The node has an isFullWidth boolean flag set to true.
   * Supports exclamation mark (!) in the beginning to denote negation (true <=> false).
   * @param node Node to evaluate
   * @param evaluateFor The visibility value to evaluate for.
   */
  static getVisibility(t, e) {
    if (e?.[0] == "!")
      return !this.getVisibility(t, e.substring(1));
    switch (e) {
      case _a.Disabled:
        return t?.visibility == _a.Disabled;
      case _a.Hidden:
        return t == null || t.visibility == _a.Disabled || t.visibility == _a.Hidden || t.visibility == _a.HiddenReadOnly;
      case _a.HiddenReadOnly:
        return this.getVisibility(t, _a.Hidden) || this.getVisibility(t, _a.ReadOnly);
      case _a.ReadOnly:
        return t == null || t.visibility == _a.ReadOnly || t.visibility == _a.HiddenReadOnly;
      case _a.Visible:
        return t != null && (!t.visibility || t.visibility == _a.Visible);
      case "isFullWidth":
        return !!t?.isFullWidth;
      default:
        throw new Error("Unknown visibility value to evaluate:" + e);
    }
  }
  /**
   * Gets the standard company sitemap for Company web sites.
   */
  static getCompanySiteMap() {
    return this.setSitemapTitles(Gb);
  }
  /**
   * Gets the editable version of the sitemap: Full ID's etc.
   * @param site The Site as customized in the Service model.
   * @param nodes Root nodes to start from. If null, a copy of the baseTree is used.
   * @param parentId Identifier of the parent. Used in recursive calls to add fully qualified ID's to all nodes.
   * @returns An editable sitemap.
   */
  static getEditableSitemap(t, e = null, a = null) {
    const n = "SALAXY.NG1_Sitemap";
    return e = e || wt.copy(Gb), (e || []).forEach((i) => {
      let r = !1;
      const l = a ? `${a}.${i.id || "undefined"}` : i.id;
      i.children && (r = !!this.getEditableSitemap(t, i.children, l).find((d) => d.$edit.$hasChanges || d.$edit.$hasTextChanges || d.$edit.$hasChildrenChanges));
      const o = !!i.$edit?.$isOpen;
      i.$edit = t.sitemap?.[l] ? wt.copy(t.sitemap?.[l]) : {}, Object.keys(i.$edit).length && (i.$edit.$hasChanges = !0), i.$edit.$hasChildrenChanges = r, i.$edit.$isOpen = o, i.$edit.$id = l;
      const c = i.children ? ".main" : "";
      switch (i.$edit.$i18nKey = `${n}.${l}${c}`, Object.keys(t.texts ?? {}).find((d) => d.endsWith(i.$edit.$i18nKey)) && (i.$edit.$hasTextChanges = !0), i.$edit.visibility || i.visibility) {
        case _a.Disabled:
          i.$edit.$faIcons = ["fa-ban"];
          break;
        case _a.Hidden:
          i.$edit.$faIcons = ["fa-eye-slash"];
          break;
        case _a.HiddenReadOnly:
          i.$edit.$faIcons = ["fa-eye-slash", "fa-lock"];
          break;
        case _a.ReadOnly:
          i.$edit.$faIcons = ["fa-lock"];
          break;
        case _a.Visible:
        default:
          i.$edit.$faIcons = [];
          break;
      }
      (i.isFullWidth || i.$edit.isFullWidth) && i.$edit.$faIcons.push("fa-arrows-h"), i.$edit.visibility = i.$edit.visibility || "default", i.$edit.roles = ie.assureArray(i.$edit.roles).join(","), i.title = i.title ? i.title : i.$edit.$i18nKey;
    }), e;
  }
  /**
   * Applies custom properties from service model to set of sitemap nodes.
   * Also does backward compatibility from old SalaxySitemapNode format to current SitemapNode.
   * @param session User session that potentially contains the service model.
   * If null or no partner.serviceModel.sitemap, the method does nothing.
   * @param nodes Nodes that are being updated.
   * @param parentId Identifier of the parent. Used in recursive calls to add fully qualified ID's to all nodes.
   */
  static setCustomProperties(t, e, a = null) {
    if (!e?.length)
      return;
    const n = t?.settings?.partner?.serviceModel?.site?.sitemap;
    e.forEach((i) => {
      const r = a && a != "company-site" ? `${a}.${i.id || "undefined"}` : i.id;
      i.hidden && !i.visibility && (i.visibility = _a.Hidden), n && n[r] && Object.keys(n[r]).forEach((l) => {
        const o = n[r][l];
        o && (i[l] = o);
      }), this.setCustomProperties(t, i.children, r);
    });
  }
  /** This just to get snowpack working. */
  snowpackHack() {
    return "snowpackHack";
  }
  /**
   * Gets the combined sitemap that contains the structure for both company
   * and personal (Worker, Household). this is used mainly in development and PRO service:
   * typically, company and personal sites are separate and this tree is not used.
   */
  static getAllRolesSiteMap() {
    const t = wt.copy(Gb);
    return t.splice(t.length - 1, 0, ...e2), this.setSitemapTitles(t);
  }
  /**
   * Sets the titles for each node in given sitemap based on node id from the given tranlsation.
   * @param sitemap Selected sitemap to add titles to
   * @param currentPath Current node in sitemap object
   * @param i18Prefix Translation key prefix (defaults to SALAXY.NG1_Sitemap)
   */
  static setSitemapTitles(t, e = "", a = "SALAXY.NG1_Sitemap") {
    for (const n of t) {
      const i = e ? `${e}.${n.id}` : n.id, r = n.children ? ".main" : "";
      n.title = n.title ? n.title : `${a}.${i}${r}`, n.children && this.setSitemapTitles(n.children, i, a);
    }
    return t;
  }
  /**
   * Removes a section based on id.
   * @param sitemap Sitemap from which the section is removed.
   * @param sectionId Identifier for finding the section to remove.
   */
  static removeSection(t, e) {
    const a = t.findIndex((n) => n.id === e);
    a >= 0 && t.splice(a, 1);
  }
  /**
   * Gets a section based on id.
   * @param sitemap Sitemap from which the section is fetched.
   * @param sectionId Identifier for finding the section to remove.
   */
  static getSection(t, e) {
    return t.find((a) => a.id === e);
  }
  /**
   * Gets a node (subpage) based on id.
   * @param sitemap Sitemap from which the section is fetched.
   * @param sectionId Identifier for finding the section.
   * @param nodeId Identifier for finding the node (subpage to modify or hide).
   */
  static getNode(t, e, a) {
    const n = this.getSection(t, e);
    return !n || !n.children ? null : n.children.find((i) => i.id === a);
  }
  /**
   * Gets a JSON schema of a sitemap node using the params property.
   * NOTE: Advanced properties (i18n, children and params) are not included in this schema. Add if needed.
   */
  static getSchema(t) {
    const e = {
      title: "Current sitemap node",
      type: "object",
      properties: {
        id: {
          title: "Identifier for the node: Should be unique within one set of children.",
          type: "string"
        },
        title: {
          title: "Hard-coded single-language title. This should be used in dev/testing only",
          type: "string"
        },
        url: {
          title: "Navigation URL for the node.",
          type: "string"
        },
        roles: {
          title: "Roles for limiting the visibility of the node.",
          anyOf: [
            {
              type: "string"
            },
            {
              type: "array",
              items: { type: "string" }
            }
          ]
        },
        visibility: {
          title: "Specifies how the node is shown in the navi / UI. Default / null is 'visible'.",
          type: "string"
        },
        isFullWidth: {
          title: "If true, sets container class to container-fluid",
          type: "string"
        }
        /*
        i18n: {
          title: "",
          type: "array",
          items: {
            type: "string",
          }
        },
        children: {
          title: "Array of child nodes.",
          type: "object",
        },
        params: {
          title: "Defines the json schema for parameters that may be defined for a single node/page.",
          type: "object",
        }
        */
      }
    };
    return t.params && (e.properties = { ...e.properties, ...t.params }), e;
  }
}
class Uv {
  constructor(t) {
    t?.length ? (this.isResolved = !0, this.path = t, this.node = t[t.length - 1], this.section = t[0]) : (this.isResolved = !1, this.node = null, this.path = [], this.section = null);
  }
  /**
   * Gets logical visibility, as used in the views an UI logic, i.e.:
   *
   * - hidden: Node is null or visibility is Hidden, HiddenReadOnly or Disabled.
   * - readOnly: Node is null or visibility is ReadOnly, HiddenReadOnly.
   * - disabled: Visibility is Disabled.
   * - Visible: Visibility is Visible or null, node is not null.
   * - isFullWidth: The node has an isFullWidth boolean flag set to true.
   *
   * Supports exclamation mark (!) in the beginning to denote negation (true <=> false).
   * @param visibility The visibility value to evaluate for.
   */
  getVisibility(t) {
    return ws.getVisibility(this.node, t);
  }
  /** Returns true if the page should be displayed read-only */
  get readOnly() {
    return ws.getVisibility(this.node, _a.ReadOnly);
  }
  /**
   * Gets a parameter checking the default value from the schema.
   * The method fails if the parameter is not defined in the schema.
   * @param path Path to the sitemap value / schema definition.
   */
  getParam(t) {
    if (!this.node?.params)
      throw new Error(`The current node ${this.node?.url} does not have parameters defined (path: '${t}').`);
    const e = ol.getProperty(ws.getSchema(this.node), t);
    if (!e)
      throw new Error(`The current node ${this.node.url} does not have property ${t} defined in the schema.`);
    const a = Qe.getProperty(this.node, t);
    return a ?? (e.schema.default !== void 0 ? e.schema.default : null);
  }
  /**
   * Checks if the value contain the given flag value.
   * Typically the value is an array of enum strings and this method checks if it contains an item,
   * but the method also checks for a direct match (without being an array).
   * @param path Path to the sitemap value / schema definition.
   * @param flagValue Text value (typically a string enum) that should be present in the array.
   */
  getFlag(t, e) {
    const a = this.getParam(t);
    return Array.isArray(a) ? !!a.find((n) => n == e) : a == e;
  }
}
const $C = class $C {
  constructor(t, e) {
    e.Promise = function(a) {
      return t(a);
    }, e.Promise.all = t.all.bind(t), e.Promise.reject = t.reject.bind(t), e.Promise.resolve = t.resolve.bind(t), e.Promise.race = t.race.bind(t), e.Promise.allSettled = (a) => e.Promise.all(a.map(
      (n) => n.then((i) => ({
        status: "fulfilled",
        value: i
      })).catch((i) => ({
        status: "rejected",
        reason: i
      }))
    ));
  }
};
$C.$inject = ["$q", "$window"];
let Fv = $C;
const SC = class SC {
  constructor(t) {
    this.$routeProvider = t, this.customSectionRoot = "./views", this.$get = ["$rootScope", (e) => "todo"], this.routeModel = {
      when: []
    };
  }
  /**
   * Adds a routing section where views are coming by default from custom folder.
   * @param section Navigation section in routing.
   * Also used as default for views folder.
   * @param defaultViews Exceptions to the rule: Individual views / pages that should be mapped
   * to default views stored in ng1 library under "salaxy-components/pages/".
   * @param defaultViewsFolder The name of the default views folder if not the same as section.
   * If not specified, the folder is "salaxy-components/pages/[section]".
   * If the paths starts with "salaxy-components", "/" or ".", the path is assumed being a full path.
   * Otherwise the "salaxy-components/pages/" is added before defaultViewsFolder. So typically this can be just a folder / section name (e.g. "calc").
   * @param customViewsFolder If specified, this is the path to the custom folder where the views are.
   * If NOT specified, "[customSectionRoot]/[section]" is used.
   * If the paths starts with "/" or ".", the path is assumed being a full path.
   * Otherwise the customSectionRoot (default "./views/") is added before customViewsFolder. So typically this can be just a folder / section name (e.g. "calc").
   * @example
   * RouteHelperProvider.customSection("calc", ["details"]).
   * // Adds a route as "/calc/:viewName?/:crudItemId*?" where all views are located in "./views/calc/[:viewName].html",
   * // except "/calc/details/:crudItemId*?", which is mapped to "salaxy-components/pages/calc/details.html"
   */
  customSection(t, e, a, n) {
    return a = a || t, !a.startsWith(".") && !a.startsWith("/") && !a.startsWith("salaxy-components/") && (a = "salaxy-components/pages/" + a), n = n || t, !n.startsWith(".") && !n.startsWith("/") && !n.startsWith("salaxy-components/") && (n = this.customSectionRoot + "/" + n), e && Array.isArray(e) && e.forEach((i) => {
      this.when(`/${t}/${i}/:crudItemId*?`, { templateUrl: `${a}/${i}.html` }, t);
    }), this.when(`/${t}/:viewName?/:crudItemId*?`, {
      templateUrl: (i) => `${n}/${i.viewName || "index"}.html`
    }, t), this;
  }
  /**
   * Adds a routing section where views are coming by default from the product ng1 library compiled to "salaxy-components/pages/".
   * @param section Section for the views, e.g. "calc" for "salaxy-components/pages/calc"
   * @param customViews Exceptions to the rule:
   * Individual views that should be mapped to custom folder under customSectionRoot.
   * @param customViewsFolder The name of the custom views folder if not the same as section.
   * If the paths starts with "/" or ".", the path is assumed being a full path.
   * Otherwise the customSectionRoot (default "./views/") is added before customViewsFolder. So typically this can be just a folder / section name (e.g. "calc").
   * @param defaultViewsFolder The name of the default views folder if not the same as section.
   * If not specified, the folder is "salaxy-components/pages/[section]".
   * If the paths starts with "salaxy-components", "/" or ".", the path is assumed being a full path.
   * Otherwise the "salaxy-components/pages/" is added before defaultViewsFolder. So typically this can be just a folder / section name (e.g. "calc").
   * @example
   * RouteHelperProvider.defaultSection("calc", ["details"], "ng1/calc").
   * // Adds a route as "/calc/:viewName?/:crudItemId*?" where all views are located in "salaxy-components/pages/calc/" folder
   * // except "/calc/details/:crudItemId*?", which is mapped to "./views/ng1/calc/details.html".
   */
  defaultSection(t, e, a, n) {
    return a = a || t, !a.startsWith(".") && !a.startsWith("/") && !a.startsWith("salaxy-components/") && (a = this.customSectionRoot + "/" + a), n = n || t, !n.startsWith(".") && !n.startsWith("/") && !n.startsWith("salaxy-components/") && (n = "salaxy-components/pages/" + n), e && Array.isArray(e) && e.forEach((i) => {
      i === "index" ? (this.when(`/${t}/index/:crudItemId*?`, { templateUrl: `${a || t}/index.html` }, t), this.when(`/${t}`, { templateUrl: `${a || t}/index.html` }, t)) : this.when(`/${t}/${i}/:crudItemId*?`, { templateUrl: `${a || t}/${i}.html` }, t);
    }), this.when(`/${t}/:viewName?/:crudItemId*?`, {
      templateUrl: (i) => `${n}/${i.viewName || "index"}.html`
    }, t), this;
  }
  /**
   * Fluid syntax for setting customSectionRoot.
   * @param customSectionRoot Root folder for the custom views.
   * You can use null to set the customSection to default "./views", empty string to none.
   * No trailing dashes i.e. "./views", not "./views/".
   */
  setCustomSectionRoot(t) {
    return t == null && (t = "./views"), this.customSectionRoot = t, this;
  }
  /**
   * Adds the standard index/home pages: "/", "/index" and "/welcome".
   * May later contain special pages like standard error etc.
   * NOTE: If any of the sections already exists, will not add them.
   * @param customViewsFolder if set, uses the given custom folder. Otherwise, sets the paths from library.
   */
  homeDefault(t) {
    const e = t ? `${this.customSectionRoot}/${t}/index.html` : "salaxy-components/pages/home/index.html";
    return this.sectionExists("") || this.when("/", { templateUrl: e }, ""), this.sectionExists("index") || this.when("/index", { templateUrl: e }, "index"), this.sectionExists("welcome") || this.when("/welcome", { templateUrl: e }, "welcome"), this;
  }
  /**
   * For backward compatibility only: Use commit() instead.
   * @deprecated For backward compatibility only: Use commit() instead.
   */
  otherwiseDefault() {
    this.commit();
  }
  /**
   * Equivalent for calling $routeProvider.when(): Adds a new route definition to the $route service.
   * Call commit() method for these configurations to have an effect.
   * @param path Route path (matched against $location.path). If $location.path contains redundant trailing slash or is missing one, the route will still match and the $location.path will be updated to add or drop the trailing slash to exactly match the route definition.
   *
   * - path can contain named groups starting with a colon: e.g. :name. All characters up to the next slash are matched and stored in $routeParams under the given name when the route matches.
   * - path can contain named groups starting with a colon and ending with a star: e.g.:name*. All characters are eagerly stored in $routeParams under the given name when the route matches.
   * - path can contain optional named groups with a question mark: e.g.:name?.
   *
   * For example, routes like /color/:color/largecode/:largecode*\/edit will match /color/brown/largecode/code/with/slashes/edit and extract: color: brown and largecode: code/with/slashes.
   * @param route Mapping information to be assigned to $route.current on route match.
   * @param section identifies the section for later evaluating whether a certain section has been defined or not:
   * This is used in adding the deafults at the commit(): If section is found, it is not filled with defaults
   * E.g. for path "/calc/details" this would be "calc" and "/", it would be "".
   * Please note that in the "calc" case you would need to make sure all the other "calc section" routes are handled,
   * typically by calling defaultSection("calc") or customSection("calc") within the router config.
   */
  when(t, e, a) {
    return this.routeModel.when.push({ section: a, path: t, route: e }), this;
  }
  /**
   * Equivalent for calling $routeProvider.otherwise():
   * Sets route definition that will be used on route change when no other route definition is matched.
   * Call commit() method for these configurations to have an effect.
   * @param params information to be assigned to $route.current.
   */
  otherwise(t) {
    return this.routeModel.otherwise = t, this;
  }
  /**
   * Used in Development and PRO sites to add the Person (Worker/Household) related routes.
   * Typically, sites that target Person accounts are specialized and will not use this method.
   */
  addPersonRoutes() {
    return this.customSection("person-archive", [], "salaxy-components/pages-personal/archive", "salaxy-components/pages-personal/archive"), this.customSection("person-account", [], "salaxy-components/pages-personal/account", "salaxy-components/pages-personal/account"), this.customSection("person-calc", [], "salaxy-components/pages-personal/calc", "salaxy-components/pages-personal/calc"), this.customSection("person-taxcards", [], "salaxy-components/pages-personal/taxcards", "salaxy-components/pages-personal/taxcards"), this;
  }
  /**
   * Commits the intermediary routeModel to the AngularJS $routeProvider.
   * If skipDefault is not set to true, will set the defaults by calling
   * homeDefault(), defaultSection for each product section and otherwiseDefault
   * if the corresponding sections have not already been defined.
   * @param skipDefaults By default, the method first adds all the product-defined
   * default routes to the routeModel. If true, will not add the default routes.
   */
  commit(t = !1) {
    if (this.routeModel.isCommitted)
      throw new Error("RouteHelperProvider.commit() called more than once. This is not supported. Are you calling both otherwiseDefault() and commit()? The first is obsolete since the introduction of commit().");
    t || (this.homeDefault(), this.addIfNotExists("home"), this.addIfNotExists("accounting"), this.addIfNotExists("calc"), this.addIfNotExists("customer-invoices"), this.addIfNotExists("datasets"), this.addIfNotExists("messages"), this.addIfNotExists("service"), this.addIfNotExists("payroll"), this.addIfNotExists("reports"), this.addIfNotExists("irepr"), this.addIfNotExists("irpsr"), this.addIfNotExists("settings"), this.addIfNotExists("accounting-targets"), this.addIfNotExists("info"), this.addIfNotExists("welcome"), this.addIfNotExists("employments"), this.addIfNotExists("workers"), this.addIfNotExists("partners"), this.addIfNotExists("invoices"), this.addIfNotExists("payment-channel"), this.addIfNotExists("earnings-payments"), this.addIfNotExists("salary-reports"), this.addIfNotExists("test"), this.addIfNotExists("calendar"), this.addIfNotExists("usecases"), this.addIfNotExists("worktime-imports"), this.addIfNotExists("service-models"), this.addIfNotExists("household-years"), this.addIfNotExists("worktime-imports"), Ne.current?.isTestData && this.addIfNotExists("reference-objects"), this.routeModel.otherwise || (this.routeModel.otherwise = { templateUrl: "salaxy-components/pages/home/error404.html" }));
    for (const e of this.routeModel.when)
      this.$routeProvider.when(e.path, e.route);
    this.routeModel.otherwise && this.$routeProvider.otherwise(this.routeModel.otherwise), this.routeModel.isCommitted = !0;
  }
  /**
   * Returns true if the sction is already defined in the route model.
   * @param section Section for the views, e.g. "calc" for "salaxy-components/pages/calc"
   */
  sectionExists(t) {
    return !!this.routeModel.when.find((e) => e.section === t);
  }
  /**
   * Calls the defaultSection(section), but only if the sectrion has not been defined with custom values.
   */
  addIfNotExists(t) {
    return this.sectionExists(t) ? !1 : (this.defaultSection(t), !0);
  }
};
SC.$inject = ["$routeProvider"];
let zv = SC;
const k1 = {
  dayNames: [
    "Sunnuntai",
    "Maanantai",
    "Tiisatai",
    "Keskiviikko",
    "Torstai",
    "Perjantai",
    "Lauantai"
  ],
  monthNames: [
    "Tammikuu",
    "Helmikuu",
    "Maaliskuu",
    "Huhtikuu",
    "Toukokuu",
    "Kesäkuu",
    "Heinäkuu",
    "Elokuu",
    "Syyskuu",
    "Lokakuu",
    "Marraskuu",
    "Joulukuu"
  ],
  tokens: {},
  texts: {
    "(~ approximate)": "(~ noin)",
    and: "ja",
    at: "klo",
    day: "päivä",
    days: "päivä",
    every: "joka",
    for: ",",
    hour: "tunti",
    hours: "tunti",
    in: ", vain kuukausina:",
    // TODO: Is this used in other cases
    last: "viimeisenä päivänä",
    minutes: "min",
    month: "kuukausi",
    months: "kuukausi",
    nd: ".",
    "on the": "aina",
    on: "on",
    // TODO
    or: "tai",
    rd: ".",
    st: ".",
    th: ".",
    the: "",
    time: "kerta",
    times: "kertaa",
    until: "päättyen",
    week: "viikko",
    weekday: "viikonpäivä",
    weekdays: "viikonpäivä",
    weeks: "viikko",
    year: "vuosi",
    years: "vuosi",
    "RRule error: Unable to fully convert this rrule to text": "Virhe: En ymmärrä tekstiä"
  }
}, kC = class kC {
  constructor(t, e, a, n) {
    this.$location = e, this.sessionService = a, this.current = new Uv(null), this.isNaviOpen = !1, this.isSidebarOpen = !1, n.has("SITEMAP") ? this.setSitemap(n.get("SITEMAP")) : this.setSitemap([]), t.$on("$routeChangeSuccess", (i, r, l) => {
      this.resolveAndSetCurrentNode();
    }), a.subscribe(t, () => {
      this.updateSitemapInRole();
    });
  }
  /**
   * Gets the current sitemap.
   * @returns Sitemap filtered for the roles of the current user.
   */
  getSitemap() {
    return this.sitemapInRole;
  }
  /**
   * Sets the sitemap any time during the application lifecycle.
   * Alternative way is to set angular constant "SITEMAP", but that must be done before config.
   * @param newSitemap New sitemap to use.
   */
  setSitemap(t) {
    this.sitemapForAllRoles = ws.setSitemapTitles(t), this.updateSitemapInRole();
  }
  /**
   * Gets the current section: The first level node in the sitemap
   * @returns Section filtered by the roles.
   */
  getCurrentSection() {
    return this.currentSection;
  }
  /** Determines if a given node is the current node */
  isCurrent(t) {
    return !t || !this.currentPath ? !1 : !!this.currentPath.find((e) => e === t);
  }
  /** Determines if a given section is the current section */
  isCurrentSection(t) {
    return this.currentSection && t && this.currentSection.url === t.url;
  }
  /**
   * Get sitemap node using path.
   * @param path - Page URL path for the node.
   * @returns - Node if exists, otherwise null.
   */
  getNodeByPath(t) {
    const e = this.sitemapInRole;
    for (const a of e) {
      const n = this.findNode(a, t);
      if (n)
        return n;
    }
    return null;
  }
  /**
   * Get sitemap nodes using path.
   * @param path - Page URL path for the node.
   * @returns - Nodes path if exists, otherwise null.
   */
  getNodesByPath(t) {
    const e = this.getNodeByPath(t);
    if (!e)
      return null;
    const a = this.sitemapInRole, n = [e];
    t:
      for (; ; ) {
        const i = n[0];
        for (const r of a) {
          const l = this.findParentNode(r, i);
          if (l) {
            n.unshift(l);
            continue t;
          }
        }
        break;
      }
    return n;
  }
  /**
   * Filters the sitemap using the role-restrictions in the sitemap
   * @param session - Optional explicitely given session for filtering the sitemap.
   * @param appStatus - Optional explicitely given appStatus for filtering the sitemap. This must be given with explicitely given session.
   */
  updateSitemapInRole(t = null, e = null) {
    const a = wt.copy(this.sitemapForAllRoles);
    this.isTest = t ? Md.isInRole(t, e, "test") : this.sessionService.isInRole("test"), this.sessionService.isInSomeRole("pro,admin") || ws.setCustomProperties(t || this.sessionService.session, a), this.sitemapInRole = this.filterSitemapSectionsByRole(a, t, e), this.resolveAndSetCurrentNode();
  }
  /**
   * Resolve current node from location path
   */
  resolveAndSetCurrentNode() {
    const t = "#" + this.$location.path().toLowerCase(), e = this.resolveCurrent(t, this.sitemapInRole);
    this.current = new Uv(e), this.currentPath = e || [this.sitemapInRole[0]], this.currentSection = this.currentPath[0], this.currentNode = this.currentPath[this.currentPath.length - 1], this.sectionTitle = this.currentSection?.title, this.title = this.currentNode?.title;
  }
  /**
   * Navigate to given path
   * @param path - Path to navigate.
   * @param checkSession - If true, triggers session refresh
   */
  navigateTo(t, e = !1) {
    (e ? this.sessionService.checkSession().then(() => {
    }) : Promise.resolve()).then(() => {
      this.$location.path(t);
    });
  }
  /**
   * Evaluates wildcard string.
   * @param nodeUrl - URL in the sitemap file (e.g. "filename.html#/this/is/nodeUrl"). From this, we take only the hash part ("#/this/is/nodeUrl").
   * @param pathUrl - URL to evaluate - this is the hash path (e.g. "#/this/is/pathUrl")
   * @returns Boolean whether the path url resides within the given node url.
   */
  checkUrl(t, e) {
    t.indexOf("#") !== -1 && (t = t.substr(t.indexOf("#")));
    const a = t.split("/");
    for (const i in a)
      a[i].indexOf(":") === 0 && (a[i] = "*");
    const n = a.join("/");
    return this.wildCardMatch(n, e);
  }
  /**
   * Evaluates wildcard string
   * @param rule - Wildcard rule
   * @param str - String to evaluate
   * @returns Boolean whether the string matches the given wildcard rule.
   */
  wildCardMatch(t, e) {
    return t = t.split("*").join(".*"), t = "^" + t + "$", new RegExp(t, "i").test(e);
  }
  /**
   * Recursive resolver for any depth of sitemap nodes.
   * @param url Url to check for.
   * Note that in AngularJS paths, this should be the NG path starting with "#".
   * @param nodes Nodes to check (typically the whole sitemap).
   * @returns The path to current node or null if the current node cannot be resolved.
   */
  resolveCurrent(t, e) {
    if (!e || e.length === 0)
      return null;
    for (const a of e) {
      const n = this.resolveCurrent(t, a.children);
      if (n)
        return [a, ...n];
      if (this.checkUrl(a.url, t))
        return [a];
    }
    return null;
  }
  /**
   * Filters a node tree bases on user roles.
   * @param nodes - Array of nodes to filter
   * @param session - Optional explicitely given session for filtering the sitemap.
   * @param appStatus - Optional explicitely given appStatus for filtering the sitemap. This must be given with explicitely given session.
   * @returns Filtered list of nodes.
   */
  filterSitemapSectionsByRole(t, e = null, a = null) {
    if (!t)
      return [];
    const n = (r) => e ? Md.isInSomeRole(e, a, ie.assureArray(r)) : this.sessionService.isInSomeRole(r), i = t.filter((r) => {
      const l = ie.assureArray(r.roles);
      if (n(l)) {
        if (this.isTest && l.length) {
          const o = l.filter((c) => c.trim().toLowerCase() !== "test");
          (o.length == 0 || o.length !== l.length && !n(o)) && (r.visibleTestOnly = !0);
        }
        return !0;
      } else
        return !1;
    });
    return i.forEach((r) => {
      r.children = this.filterSitemapSectionsByRole(r.children, e, a);
    }), i;
  }
  findNode(t, e) {
    if (t && e) {
      if (this.checkUrl(t.url, e))
        return t;
      if (t.children)
        for (const a of t.children) {
          const n = this.findNode(a, e);
          if (n)
            return n;
        }
    }
    return null;
  }
  findParentNode(t, e) {
    if (t.children)
      for (const a of t.children) {
        if (a == e)
          return t;
        const n = this.findParentNode(a, e);
        if (n)
          return n;
      }
    return null;
  }
};
kC.$inject = ["$rootScope", "$location", "SessionService", "$injector"];
let Bv = kC;
const TC = class TC {
  /**
   * Creates a new UiCrudHelpers with dependency injection.
   */
  constructor(t, e, a) {
    this.uiHelpers = t, this.taxcards = e, this.employments = a;
  }
  /**
   * Shows a dialog for editing an existing employment.
   * If user clicks OK, the changes are saved.
   * @param employmentId - Identifier of the Workers employment.
   * @param buttonTypes "default" shows standard save button,
   * "updateCalc" shows two buttons "ok" for full calc update and "ok-no-rows" update without touching default rows.
   * @param initialTab - Tab to open.
   * @returns Dialog result. Note that OK result may be either "ok" or "ok-no-rows".
   * The latter means that for calculation only worker info should be updated, not the default rows.
   */
  openEditEmploymentDialog(t, e, a = null) {
    const n = this.uiHelpers.showLoading("Ladataan työntekijän tietoja...");
    return this.employments.getSingle(t).then((i) => (n.dismiss(), this.uiHelpers.openEditEmploymentDialog(i, a, e).then((r) => {
      if (r.action === "ok" || r.action === "ok-no-rows") {
        const l = this.uiHelpers.showLoading("SALAXY.UI_Terms.isSaving");
        return this.employments.save(r.item).then((o) => (l.dismiss(), r.item = o, r));
      } else
        return r;
    })));
  }
  /**
   * Opens a wizard dialog for creating a new Employment relation and potentially a manual Taxcard.
   * If user commits at the end, the changes are saved to both items.
   * @returns Result only has the Employment item (not taxcard - add if necessary).
   */
  async createNewEmployment() {
    const t = await this.uiHelpers.openNewEmploymentWizard(), e = {
      action: t.action,
      hasChanges: t.hasChanges,
      item: void 0,
      logic: t.logic,
      result: t.result
    };
    if (t.action === "ok") {
      const a = this.uiHelpers.showLoading("SALAXY.UI_Terms.isSaving");
      e.item = await this.employments.save(t.item.employment);
      const n = e.item.identity.personalId;
      switch (e.item.info.taxcard) {
        case Xa.NoTaxCard:
          await this.taxcards.save(La.getBlank(n, ma.NoTaxCard));
          break;
        case Xa.Manual: {
          const i = t.item.taxcard.card.kind;
          (i == ma.DefaultYearly || i == ma.NoWithholdingHousehold || i == ma.Replacement || i == ma.NoTaxCard) && await this.taxcards.save(t.item.taxcard);
          break;
        }
        case Xa.Auto:
          await this.taxcards.setAuto(n);
          break;
        case Xa.TaxAtSource:
        case Xa.Undefined:
      }
      a.dismiss();
    }
    return e;
  }
  /**
   * Shows the add new taxcard dialog.
   * If user commits at the end, the changes are saved and the ite is the stored taxcard from server.
   * @param personalId Worker personal id is required.
   */
  createNewTaxcard(t) {
    return this.uiHelpers.openNewTaxcardDialog(t).then((e) => {
      if (e.action === "ok") {
        const a = this.uiHelpers.showLoading("SALAXY.UI_Terms.isSaving");
        return this.taxcards.save(e.item).then((n) => (e.item = n, a.dismiss(), n || this.uiHelpers.showAlert(
          L.get("SALAXY.NG1_Services.UiCrudHelpers.taxcards.noTaxcardTitle"),
          L.get("SALAXY.NG1_Services.UiCrudHelpers.taxcards.noTaxcardText")
        ), n?.incomeLog.find((i) => i.diff && i.diff !== "default") ? this.uiHelpers.openEditDialog("salaxy-components/modals/worker/taxcard-income-log.html", n, {}, "lg").then((i) => {
          if (i.action === "ok") {
            const r = this.uiHelpers.showLoading("Tallennetaan laskelmia...");
            return this.taxcards.commitDiff(n).then((l) => (r.dismiss(), e.item = l, e));
          } else
            return e;
        }) : e));
      } else
        return e;
    });
  }
  /**
   * Refreshes the automatic taxcard.
   * @param taxcardId Automatic taxcard id to refresh.
   * @param salaryDate Salary date for the taxcard.
   */
  refreshAutoTaxcard(t, e) {
    const a = this.uiHelpers.showLoading("SALAXY.UI_Terms.wait", "Verokorttia tarkistetaan.");
    return this.taxcards.refreshAuto(t, e, !0).then((n) => (a.dismiss(), n));
  }
};
TC.$inject = ["UiHelpers", "Taxcards", "Employments"];
let Wv = TC;
const LC = class LC {
  /**
   * Creates a new UiHelpers with dependency injection.
   */
  constructor(t, e, a, n, i, r, l) {
    this.$uibModal = t, this.$location = e, this.$rootScope = a, this.$window = n, this.$timeout = i, this.sessionService = r, this.$uibModalStack = l, this.externalWindows = {}, this.init();
  }
  /**
   * Shows an edit dialog - typically for a list item, but potentially for some other editable item.
   * Alternatively, you may use showDialog() if you wish to specify your own controller (with more logic)
   * @param templateUrl - Template url.
   * @param item - The item that is being edited. The logic will support change tracking and reset on this item.
   * @param logic - Additional logic: Helper functions, metadata etc. that view can use to contruct the UI.
   * @param size - Optional size parameter: sm, lg, xl or ''. Default is empty string (normal size).
   * @param controller Optional controller for the modal instance.
   * The item and logic are passed to controller with dependency injection name "EditDialogParameters".
   * @param options Rarely used dialog options.
   * @param options.template If set, ignores the templateUrl and uses this inline HTML template instead.
   * @returns A promise that resolves to the result from the dialog.
   * @example
   * this.uiHelpers.showDialog("salaxy-components/modals/account/AuthorizedAccountAdd.html", "AccountAuthorizationController")
   */
  openEditDialog(t, e, a, n = "", i = "EditDialogController", r = {}) {
    const l = wt.copy(e), o = {
      backdrop: "static",
      ariaLabelledBy: "modal-title",
      ariaDescribedBy: "modal-body",
      template: r.template,
      templateUrl: r.template ? null : t,
      windowTemplateUrl: "salaxy-components/modals/ui/DialogWindow.html",
      controller: i,
      controllerAs: "$ctrl",
      size: n,
      resolve: {
        EditDialogParameters: () => ({
          current: l,
          logic: a
        }),
        $element: null,
        $attrs: null
      }
    }, c = this.$uibModal.open(o);
    return Promise.resolve(c.result.then((d) => {
      const p = (wt.isString(d) ? d : (d || {}).action) || We.Cancel, h = !wt.equals(l, e);
      return p !== We.Cancel && h && wt.copy(l, e), {
        action: p,
        result: d,
        item: e,
        logic: a,
        hasChanges: h
      };
    }).catch(() => ({
      action: We.Cancel,
      result: null,
      item: e,
      logic: a,
      hasChanges: !1
    })));
  }
  /**
   * Shows an external dialog that may be in an untrusted domain.
   * Enables cross-site communication using postMessage events.
   * @param name Name of the unique window
   * @param url Url to show in the Window
   * @param item The item that is being edited. The logic will support change tracking and reset on this item.
   * @param config Configuration of the opened window.
   * @param resolver Optional function for checking if the promise is resolved.
   */
  showExternalDialog(t, e, a, n, i, r) {
    const l = window;
    n = n || {}, this.externalWindows[t]?.listener && (this.externalWindows[t].listener.call(l, {
      data: {
        action: "cancel"
      },
      origin: null,
      source: null
    }), l.removeEventListener("message", this.externalWindows[t].listener));
    const o = n.width || 600, c = n.height || 700, d = l.outerHeight / 2 + l.screenY - c / 2, p = l.outerWidth / 2 + l.screenX - o / 2, h = `toolbar=no, menubar=no, width=${o}, height=${c}, top=${d}, left=${p}`, g = new URL(e), x = `${g.protocol}//${g.host}`;
    e += (e.indexOf("?") > 0 ? "&" : "?") + "data=" + encodeURIComponent(btoa(JSON.stringify(a))), e.indexOf("http") !== 0 && (e += "&access_token=" + this.sessionService.getCurrentToken()), (!this.externalWindows[t]?.win || this.externalWindows[t].win.closed || this.externalWindows[t].url !== e) && (this.externalWindows[t] = {
      url: e,
      win: window.open(e, t, h),
      listener: null
    });
    try {
      this.externalWindows[t].win.focus();
    } catch {
      return r?.(), this.showAlert("Ponnahdusikkuna estetty selaimen asetuksissa", "Toiminto edellyttää, että sallit ponnahdusikkunan avattavan osoitteeseen " + x + ".", "Sulje").then(() => Promise.resolve({
        action: "cancel",
        hasChanges: !1,
        item: a
      }));
    }
    return r?.(), new Promise((b) => {
      this.externalWindows[t].listener = (A) => {
        if (console.debug("Message received", A), !i || i(A)) {
          const T = A.data.action || "cancel", R = !wt.equals(A.data.item, a);
          T !== We.Cancel && R && wt.copy(A.data.item, a), l.removeEventListener("message", this.externalWindows[t].listener), b({
            action: T,
            hasChanges: R,
            item: a
          });
        }
      }, l.addEventListener("message", this.externalWindows[t].listener, { once: !i });
    });
  }
  /**
   * Shows a custom dialog using the given controller and templateUrl.
   * Optionally injects the given data into the controller as 'data'.
   * NOTE: There is an alternative - more simple - modal dialog pattern openEditDialog() if you do not need a custom controller or windowTemplateUrl.
   * @param templateUrl - Template url.
   * @param controller  - Controller for the dialog.
   * @param data - Optional data to inject into the controller.
   * @param windowTemplateUrl - Optional template url for the window. Defaults to 'salaxy-components/modals/ui/DialogWindow.html'. If "none", no window is used.
   * @param size - Optional size parameter: sm, lg or ''.
   * @param backdrop - Optional. Controls the presence of a backdrop. Allowed value true, false (no backdrop) 'static' (default) backdrop is present but modal window is not closed when clicking outside of the modal window.
   * @returns A promise that resolves to the result from the dialog.
   * @example
   * this.uiHelpers.showDialog("salaxy-components/modals/account/AuthorizedAccountAdd.html", "AccountAuthorizationController")
   */
  showDialog(t, e, a, n, i, r = "static") {
    const l = {};
    e instanceof fc && (l.onCreateNew = e.onCreateNew, l.onListSelect = e.onListSelect, l.onDelete = e.onDelete);
    const o = {
      backdrop: r,
      ariaLabelledBy: "modal-title",
      ariaDescribedBy: "modal-body",
      templateUrl: t,
      windowTemplateUrl: n || "salaxy-components/modals/ui/DialogWindow.html",
      controller: e || "ModalGenericDialogController",
      controllerAs: "$ctrl",
      size: i,
      resolve: {
        data: () => a,
        $attrs: l
      }
    };
    o.windowTemplateUrl === "none" && delete o.windowTemplateUrl;
    const c = this.$uibModal.open(o);
    return Promise.resolve(c.result).then((d) => d).catch((d) => {
      if (d === "backdrop click" || d === "dismissAll")
        return null;
      throw new Error("" + d);
    });
  }
  /**
   * Close all existing modals from modal stack
   */
  dismissAllModals() {
    this.$uibModalStack && this.$uibModalStack.dismissAll("dismissAll");
  }
  /**
   * Shows a customized loading component (spinner) with an optional message.
   * Returns an object with a dismiss function to call for closing the dialog.
   * Note that there is a separate generic directive 'salaxy-loader' for indicating
   * http-traffic.
   * @param heading Translation key for heading text for the loader.
   * Default text is "SALAXY.UI_Terms.loading", but you may set this to null for just the spinner.
   * @param text Optional translation key for additional text paragraph describing what is happening.
   * @returns An object with dismiss function to close the dialog.
   * @example
   * ```ts
   * const loader = this.uiHelper.showLoading("SALAXY.UI_Terms.isSaving", "SALAXY.UI_Terms.pleaseWait");
   * setTimeout(() => {
   *   loader.dismiss();
   * }, 2000);
   * ```
   */
  showLoading(t = "SALAXY.UI_Terms.loading", e, a = !1) {
    const n = {
      heading: t,
      text: e
    }, i = {
      ariaLabelledBy: "modal-title",
      ariaDescribedBy: "modal-body",
      templateUrl: "salaxy-components/modals/ui/Loading.html",
      controller: "ModalGenericDialogController",
      controllerAs: "$ctrl",
      windowClass: "salaxy-component",
      size: "sm",
      resolve: { data: n },
      backdrop: a ? "static" : !0
    }, r = this.$uibModal.open(i);
    return r.result.then(() => {
    }).catch(() => {
    }), {
      dismiss: () => {
        this.$timeout(() => r.dismiss());
      },
      setHeading: (l) => {
        this.$timeout(() => {
          n.heading = l;
        });
      },
      setText: (l) => {
        this.$timeout(() => {
          n.text = l;
        });
      }
    };
  }
  /**
   * Shows a confirm dialog. Like window.confirm() in JavaScript.
   * Returns true if a user clicks OK -button. Otherwise (cancel or close) returns false.
   * @param heading Heading text of the confirm question as translation key.
   * @param text Optional additional text paragraph describing what is happening.
   * @param okText Possibility to override the OK button text. The given text is run through translation.
   * @param cancelText Possibility to override the Cancel button text. The given text is run through translation.
   * @param html Optional HTML content to show in the dialog. If provided, text parameter is ignored.
   * @returns A promise that resolves to true if user clicks OK, otherwise false.
   * @example
   * ```ts
   * this.uiHelpers
   *     .showConfirm("SALAXY.UI_Terms.areYouSure", "SALAXY.UI_Terms.sureToDeleteRecord")
   *     .then((result) => { this.uiHelpers.showAlert("result", result); })
   * ```
   */
  showConfirm(t, e, a = "SALAXY.UI_Terms.ok", n = "SALAXY.UI_Terms.cancel", i = null) {
    const r = {
      ariaLabelledBy: "modal-title",
      ariaDescribedBy: "modal-body",
      templateUrl: "salaxy-components/modals/ui/Confirm.html",
      windowTemplateUrl: "salaxy-components/modals/ui/DialogWindow.html",
      controller: "ModalGenericDialogController",
      controllerAs: "$ctrl",
      resolve: {
        data: {
          heading: t,
          text: e,
          okText: a,
          cancelText: n,
          html: i
        }
      }
    }, l = this.$uibModal.open(r);
    return Promise.resolve(l.result).then((o) => o).catch(() => !1);
  }
  /**
   * Shows a date range dialog that modifies the date range of the given object.
   * @param target Target object, currently both DateRange and Calculation are supported.
   * Please note that the resulting EditDialogResult is always a DateRange though.
   * @param title Title text for the dialog
   * @param okText Possibility to override the button text. The given text is run through translation.
   * @param cancelText Possibility to override the button text. The given text is run through translation.
   * @returns EditDialogResult with the edited DateRange. Note that this is DateRange even if the object to edit is Calculation.
   */
  showDateRange(t, e, a = "SALAXY.UI_Terms.save", n = "SALAXY.UI_Terms.cancel") {
    let i;
    const r = t.info ? t : null;
    return r ? i = {
      start: r.info.workStartDate,
      end: r.info.workEndDate,
      daysCount: r.framework.numberOfDays
    } : i = t, this.openEditDialog("salaxy-components/modals/date-range/DateRange.html", i, {
      title: e,
      okText: a,
      cancelText: n
    }, "sm").then((l) => (l.action === "ok" && r && (r.info.workStartDate = l.item.start, r.info.workEndDate = l.item.end, r.framework.numberOfDays = l.item.daysCount), l));
  }
  /**
   * Shows an alert dialog. Like window.alert() in JavaScript.
   * @param heading Heading text as translation key
   * @param text Optional additional text paragraph describing what is happening.
   * @param okText Possibility to override the button text. The given text is run through translation.
   * @returns A promise with boolean: True if OK button was clicked, false if the dialog is closed / dismissed in another way.
   * @example this.uiHelpers.showAlert("Please note", "There is this thing that we want to tell you.");
   */
  showAlert(t, e, a = "SALAXY.UI_Terms.ok") {
    const n = {
      ariaLabelledBy: "modal-title",
      ariaDescribedBy: "modal-body",
      templateUrl: "salaxy-components/modals/ui/Alert.html",
      controller: "ModalGenericDialogController",
      controllerAs: "$ctrl",
      windowTemplateUrl: "salaxy-components/modals/ui/DialogWindow.html",
      resolve: {
        data: {
          heading: t,
          text: e,
          okText: a
        }
      }
    }, i = this.$uibModal.open(n);
    return Promise.resolve(i.result).then((r) => r).catch(() => !1);
  }
  /**
   * Shows a dialog for editing an existing employment.
   * NOTE: This method does not Save the Worker: The caller must do it separately.
   * @param employment - Worker Employment edited in dialog.
   * @param initialTab - Tab to open.
   * @param buttonTypes "default" shows standard save button,
   * "updateCalc" shows two buttons "ok" for full calc update and "ok-no-rows" update without touching default rows.
   * @returns Dialog result. Note that OK result may be either "ok" or "ok-no-rows".
   * The latter means that for calculation only worker info should be updated, not the default rows.
   */
  openEditEmploymentDialog(t, e = null, a = "default") {
    return this.openEditDialog(
      "salaxy-components/worker/EmploymentEditModal.html",
      t,
      {
        initialTab: e,
        buttonTypes: a,
        title: L.get("SALAXY.NG1.WorkerDetailsComponent.workerEdit.title")
      },
      "lg"
    );
  }
  /**
   * Opens wizard for creating a new employment relation in a modal dialog.
   * NOTE: This method does not Save the Employment relation: The caller must do it separately.
   * @returns Dialog result with the new employment relation data and potential Taxcard (if manual) that should be created.
   * Only create if action is "ok".
   */
  openNewEmploymentWizard() {
    const t = Ma.getBlank();
    return this.openEditDialog("salaxy-components/worker/EmploymentWizard/index.html", t, null, "lg", "EmploymentWizardController").then((e) => {
      const a = e.result.employment;
      let n;
      return e.action == We.Ok && a.info.taxcard == Xa.Manual && (n = e.result.taxcard), {
        action: e.action,
        item: { employment: a, taxcard: n },
        hasChanges: !0,
        logic: e.logic,
        result: e.action = We.Ok ? We.Ok : We.Cancel
      };
    });
  }
  /**
   * Opens a new dialog for adding a new taxcard.
   * @param personalId Worker personal id is required.
   */
  openNewTaxcardDialog(t) {
    if (!t)
      throw new Error("Personal ID is required.");
    const e = La.getBlank(t);
    return this.openEditDialog("salaxy-components/modals/worker/taxcard-new.html", e, {});
  }
  /**
   * Opens a dialog for editing a calendar event.
   * @param calEvent The calendar event that should be created / edited.
   * @param title Title for the dialog.
   * @param template Template to use in create / editing.
   * Simplified is designed for adding scheduling to Calculation / Payroll.
   * @returns Standard dialog result for calendar event.
   */
  openEditCalendarEvent(t, e, a = "default") {
    const n = "SALAXY.UI_Terms.save", i = "SALAXY.UI_Terms.cancel", r = a === "simplified";
    return this.openEditDialog("salaxy-components/modals/workflow/CalendarEventEdit.html", t, { title: e, okText: n, cancelText: i, isSimplified: r }, "lg");
  }
  /**
   * Opens the list of calculations into a dialog window for selecting a set of them.
   * NOTE: If necessary, add functionality to select only one.
   * @param category Either "paid": Read-only or "draft": Editable or "shared": Shared for approval.
   * @param title Title for the dialog.
   */
  openSelectCalcs(t = "draft", e = null) {
    const a = [];
    return e = e || (t === "paid" ? "Valitse maksetut palkat" : t == "shared" ? "Valitse lähetetyt" : "Valitse luonnokset"), this.openEditDialog("salaxy-components/modals/calc/CalcList.html", a, { title: e, category: t });
  }
  /**
   * Opens the list of employment relations into a dialog window for selecting a set of them.
   * @param title Title for the dialog
   * @returns A set of selected item in dialog result.
   */
  openSelectEmployments(t = null) {
    const e = [];
    return t = t || "Valitse työntekijät", this.openEditDialog("salaxy-components/modals/calc/WorkerList.html", e, { title: t });
  }
  /**
   * Opens a search list of specified payload and returns one item.
   * @param title Title for the dialog
   * @returns Selected item or null if none was selected
   */
  openSelect(t = null) {
    const e = [];
    return t = t || "Valitse datasetti", this.openEditDialog("salaxy-components/modals/ui/SelectListItem.html", e, { title: t }).then((a) => a.action === We.Ok && a.item.length ? a.item[0] : null);
  }
  /**
   * Caches data to controller: This is needed to avoid $digest loops in AngularJS controllers.
   * NOTE: Default data diff method uses angular.equals(), so it will not recognize difference in properties starting with "$" - most notably OData options.
   * @param controller Controller that is used for caching. A property $salaxyCache is added for caching if not there already.
   * @param cacheKey Name for the object that is being cached. Must be unique within the controller scope.
   * @param dataMethod Method that gets the data that is being cached.
   * @param dataDiffMethod Optional method that is used for determining whether the data has changed.
   * If not specified, the dataMethod is used for diff. Should be used if dataMethod returns a lot of data or if it is resource intensive.
   */
  cache(t, e, a, n) {
    t.$salaxyCache || (t.$salaxyCache = {});
    const i = t.$salaxyCache;
    if (n) {
      const r = n();
      return (!i[e] || !wt.equals(i[e].key, r)) && (i[e] = {
        key: r,
        data: a()
      }), i[e].data;
    } else {
      const r = a();
      return wt.equals(i[e], r) || (i[e] = r), i[e];
    }
  }
  /**
   * Download provide file
   * @param file File blob
   * @param fileName downloaded file name
   */
  downloadFile(t, e) {
    Vn.saveAs(t, e);
  }
  /**
   * Opens browser internally generated Blob url
   * @param file File blob
   */
  openFile(t) {
    this.$window.open(URL.createObjectURL(t), "_blank", "fullscreen=yes");
  }
  /**
   * Shows a dialog for running a batch process.
   * @param header Header text for the dialog
   * @param list List of items for the batch process: The method is run to each of these items.
   * @param method Method that is run for each of the items.
   * @param batchParamsTemplateUrl Template for user input of data about the action: The parameters for the batch process.
   * @param data Usecase specific data that is bound in the controller and can be used in the template and method.
   * @param columns Columns shown from the list may be specified here. Leave null for default columns.
   * @param chunkSize Optional chunk size for the batch process. This is used if the method supports arrays.
   * @param autoStart Optional. If true, the batch process starts immediately after the dialog is opened.
   * @param autoClose Optional. If true, the batch process dialog closes automatically after the process is done.
   * @param silent Optional. If autoStart and autoClose are true, the dialog is not shown if the list size is smaller than the chunk size.
   * This Tabulator configuration.
   */
  showBatchProcessDialog(t, e, a, n = "salaxy-components/modals/batch/default.html", i, r, l, o, c, d) {
    if (i = i || {}, i.dialogHeader = t, i.dialogList = e, i.gridColumns = r, i.batchMethod = a, i.chunkSize = l, i.batchTemplateUrl = n, i.autoStart = o ?? !1, i.autoClose = c ?? !1, i.silent = d ?? !1, i.done = !1, i.autoStart && i.autoClose && i.silent && i.chunkSize && i.dialogList.length <= i.chunkSize) {
      const p = this.showLoading(t ?? "SALAXY.UI_Terms.wait");
      return i.dialogList.forEach((h) => {
        h.processed = "Processing...";
      }), a(i.dialogList, i).then((h) => {
        let g = 0;
        for (const x of i.dialogList)
          x.processed = "OK " + h[g].message, x.processedResult = { message: h[g].message, result: h[g].result }, g++;
        return p.dismiss(), { done: !0, results: i.dialogList.map((x) => x.processedResult) };
      });
    } else
      return this.showDialog("salaxy-components/modals/batch/dialog.html", "BatchProcessController", i, null, "xl").then(() => i.done ? { done: !0, results: i.dialogList.map((p) => p.processedResult) } : { done: !1, results: [] });
  }
  /**
   * Converts bytes to blob.
   * @param bytes Bytes encoded in base64.
   * @param mimeType Mime type for the blob.
   */
  bytes2Blob(t, e) {
    const a = Uint8Array.from(
      atob(t).split("").map((n) => n.charCodeAt(0))
    );
    return new Blob([a], { type: e });
  }
  /**
   * Waits for a specified delay before resolving the promise.
   * Can be used with index related issues.
   */
  wait(t = 3e3) {
    return new Promise((e) => this.$timeout(() => e(), t));
  }
  /**
   * Shows a dialog based on returnUrl parameter from the current url.
   */
  showReturnUrlDialog() {
    const t = this.getReturnUrlParameters();
    t && (t.returnUrl && (t.returnUrl.toLowerCase().startsWith("http:") || t.returnUrl.toLowerCase().startsWith("https:")) ? (this.showDialog(
      "salaxy-components/modals/" + t.componentTemplate + ".html",
      null
    ).then(() => {
      this.$window.location.assign(t.returnUrl);
    }), this.$rootScope.$evalAsync(() => {
      this.$location.url("/");
    })) : (this.showDialog(
      "salaxy-components/modals/" + t.componentTemplate + ".html",
      null
    ), this.$rootScope.$evalAsync(() => {
      this.$location.url(t.returnUrl);
    })));
  }
  getReturnUrlParameters() {
    const t = this.$location.url();
    if (t.indexOf("/dialog/") !== 0)
      return null;
    const e = t.substring(8, t.indexOf("?")), a = this.$location.search().returnUrl;
    return {
      componentTemplate: e,
      returnUrl: a
    };
  }
  init() {
    this.$rootScope.$on("$locationChangeStart", () => {
      this.showReturnUrlDialog();
    });
  }
};
LC.$inject = ["$uibModal", "$location", "$rootScope", "$window", "$timeout", "SessionService", "$uibModalStack"];
let jv = LC;
const DC = class DC {
  /**
   * Creates a new instance of WizardService
   * @param $rootScope - Angular root scope. Used for event routing
   */
  constructor(t, e) {
    this.$rootScope = t, this.steps = [], this.activeStep = null, this.setSteps(e, !0);
  }
  /** Gets the Wizard steps as collection */
  getSteps() {
    return this.steps;
  }
  /**
   * Sets the Wizard steps
   * @param newSteps - the new collection of steps for the wizard.
   * @param skipNotify - If true will not send the the Notify event to Subscribed controllers.
   */
  setSteps(t = [], e = !1) {
    if (!wt.equals(t, this.steps)) {
      for (let a = 0; a < t.length; a++)
        se.isNumber(t[a].number) || (t[a].number = a + 1);
      this.steps = t, this.activeStep = t.length > 0 ? 1 : 0, e || this.notify();
    }
  }
  /** Gets the number of the currently active step */
  get activeStepNumber() {
    return this.activeStep;
  }
  /** Sets the number of the currently active step */
  set activeStepNumber(t) {
    for (const e of this.steps)
      e.active = !1;
    this.steps[t - 1].active = !0, this.activeStep = t, this.notify();
  }
  /**
   * Gets the current step object
   */
  getCurrentStepObject() {
    return this.activeStep ? this.steps[this.activeStep - 1] : null;
  }
  /**
   * Controllers can subscribe to changes in service data using this method.
   * Read more about the pattern in: http://www.codelord.net/2015/05/04/angularjs-notifying-about-changes-from-services-to-controllers/
   * @param scope - Controller scope for the subscribing controller (or directive etc.)
   * @param callback - The event listener function. See $on documentation for details
   */
  subscribe(t, e) {
    const a = this.$rootScope.$on("wizard-service-event", e);
    t.$on("$destroy", a);
  }
  notify() {
    this.$rootScope.$emit("wizard-service-event");
  }
};
DC.$inject = ["$rootScope"];
let Vv = DC;
class _w {
  constructor(t, e, a) {
    this.$rootScope = t, this.sessionService = e, this.api = a, this.list = [], this.current = null, this.init(), e.subscribe(t, () => {
      this.init();
    });
  }
  /**
   * Gets all items from the service's base URL endpoint.
   * Makes a GET request to the API base URL using the configured Ajax instance.
   * @returns A Promise that resolves to an array of items of type T.
   */
  getAll() {
    const t = this.api.getBaseUrl();
    return this.api.getAjax().getJSON(t);
  }
  /**
   * Reloads the list from the server - called in init and e.g. after Delete and Add new
   * @returns A Promise with result data
   */
  reloadList() {
    return this.getAll().then((t) => (this.list = t, this.isInitialDataLoaded = !0, this.notify(), this.list));
  }
  /**
   * Client-side (synchronous) method for getting a new blank item as bases for UI binding.
   * @returns A Blank item with default values.
   */
  getBlank() {
    return this.api.getBlank();
  }
  /**
   * Get the identifier of the current item, null if none is selected.
   * @returns The identifier of current item, or null if not set
   */
  getCurrentId() {
    return this.current ? this.current.id : null;
  }
  /**
   * Set the current item by id.
   * If id parameter is "new", the item is set to a new blank item.
   * If id paramter is null, the current item is set to null.
   * @param id - The Identifier for the item to set as current
   */
  setCurrentId(t) {
    if (!t) {
      this.setCurrent(null);
      return;
    }
    if (t === "new") {
      this.newCurrent();
      return;
    }
    if (t != null && this.list.length > 0) {
      const e = this.list.filter((a) => a.id === t);
      if (e.length > 0)
        this.setCurrent(e[0]);
      else
        throw Error(`Item ${t} could not be set as current.`);
    }
  }
  /**
   * Set the current item to given item
   * @param item - The item to set as current
   */
  setCurrent(t) {
    this.current = t, this.notify();
  }
  /**
   * Sets the current item to a new blank item.
   */
  newCurrent() {
    this.setCurrent(this.getBlank());
  }
  /**
   * Saves the current item to database.
   * @returns A Promise with result data: The current object after round-trip to server.
   */
  saveCurrent() {
    if (this.current)
      return this.save(this.current);
    throw new Error("SaveCurrent called when current is not set.");
  }
  /**
   * Saves the given item to database.
   * @param item - Item to be saved
   * @returns A Promise with the item after the round-trip to server.
   */
  save(t) {
    return this.api.save(t).then((e) => (this.setCurrent(e), this.reloadList().then(() => e)));
  }
  /**
   * Deletes the specified item.
   * @param id - The identifier for the item to be deleted
   * @returns A Promise with result data ("Object deleted")
   */
  delete(t) {
    return this.api.delete(t).then((e) => this.reloadList().then(() => e));
  }
  /**
   * Creates a copy of a given item.
   * This method does not yet set the item as current.
   * @param copySource Item to copy as new.
   */
  copyAsNew(t) {
    const e = JSON.parse(JSON.stringify(t));
    return e.id = null, e;
  }
  /**
   * INTERNAL ONLY: This functionality is under consideration.
   * We may not support it in the future and we may remove it without it being a breaking change.
   *
   * Controllers can subscribe to changes in service data using this method.
   * Read more about the pattern in: http://www.codelord.net/2015/05/04/angularjs-notifying-about-changes-from-services-to-controllers/
   * @param scope - Controller scope for the subscribing controller (or directive etc.)
   * @param callback - The event listener function. See $on documentation for details
   * @ignore
   */
  onChange(t, e) {
    const a = this.$rootScope.$on(this.eventPrefix + "-service-event", e);
    t.$on("$destroy", a);
  }
  /** INTERNAL ONLY: Emits the service event (typically list reload). This functionality may be dropped in future versions without warning. */
  notify() {
    this.$rootScope.$emit(this.eventPrefix + "-service-event");
  }
  init() {
    if (this.sessionService.isSessionChecked && this.sessionService.isAuthenticated) {
      const t = this.sessionService.session.currentAccount.owner;
      this.initialOwner != t && (this.list = [], this.isInitialDataLoaded = !1, this.initialOwner = t, this.reloadList());
    } else
      this.current = null, this.list = [], this.isInitialDataLoaded = !1, this.initialOwner = null;
  }
}
const IC = class IC extends _w {
  constructor(t, e, a) {
    super(t, e, a), this.authorizedAccountsApi = a, this.eventPrefix = "authorizedAccount", this.authorizingAccounts = [], this.partnerIntegrationSiteList = [
      {
        id: "askelma",
        accountId: "FI14POYA0028382282",
        img: "https://cdn.salaxy.com/img/salaxy/customer/askelma/logo.png"
      },
      {
        id: "easoft",
        accountId: "FI11POY10030958375",
        img: "https://cdn.salaxy.com/img/salaxy/customer/easoft/logo.png"
      },
      {
        id: "domus",
        accountId: "FI23POY10006460809",
        img: "https://cdn.salaxy.com/img/salaxy/customer/domus/logo.png"
      },
      {
        id: "holvi",
        accountId: "FI24POYH0021937564",
        img: "https://cdn.salaxy.com/img/salaxy/customer/holvi/logo.png"
      },
      {
        id: "isolta",
        accountId: "FI24POYI0018540478",
        img: "https://cdn.salaxy.com/img/salaxy/customer/isolta/logo.svg"
      },
      {
        id: "finago",
        accountId: "FI15POYA0008369224",
        img: "https://cdn.salaxy.com/img/salaxy/customer/finago-solo/logo.png"
      },
      {
        id: "accountor",
        accountId: "FI03POYA0003689675",
        img: "https://cdn.salaxy.com/img/salaxy/customer/accountor-go/logo.png"
      },
      {
        id: "briox",
        accountId: "FI33POYB0024403824",
        img: "https://cdn.salaxy.com/img/salaxy/customer/briox/logo.png"
      },
      {
        id: "nocfo",
        accountId: "FI45POYN0031497697",
        img: "https://cdn.salaxy.com/img/salaxy/customer/nocfo/logo.png"
      },
      {
        id: "passeliMerit",
        accountId: "FI43POY10010435606",
        img: "https://cdn.salaxy.com/img/salaxy/customer/passelimerit/logo.png"
      },
      {
        id: "ecom",
        accountId: "FI11POYE0009680831",
        img: "https://cdn.salaxy.com/img/salaxy/customer/ecom/logo.png"
      }
    ], this.refreshAuthorizingAccounts(), e.subscribe(t, () => {
      this.refreshAuthorizingAccounts();
    }), this.partnerIntegrationSiteList.forEach((n) => {
      n.title = L.get(`SALAXY.NG1_Services.AuthorizedAccountService.partnerIntegrationSiteList.${n.id}.title`), n.status = L.get(`SALAXY.NG1_Services.AuthorizedAccountService.partnerIntegrationSiteList.${n.id}.description`);
    });
  }
  /**
   * Refreshes existing authorizing accounts.
   * @returns A Promise with result data (PersonAccount|CompanyAccount)[]
   */
  reloadAuthorizingAccounts() {
    return this.authorizedAccountsApi.getAuthorizingAccounts().then((t) => this.authorizingAccounts = t);
  }
  /**
   * Lists all accounts on behalf of which this account has been authorized to act.
   * @returns A Promise with result data (PersonAccount|CompanyAccount)[]
   */
  getAuthorizingAccounts() {
    return this.authorizingAccounts;
  }
  /**
   * Sets the current partner site
   * @param partnerSite A partner site to be set as current
   */
  setCurrentPartnerSite(t) {
    this.currentPartnerSite = t;
  }
  /**
   * Returns the current partner site
   */
  getCurrentPartnerSite() {
    return this.currentPartnerSite;
  }
  /**
   * Return a list of all possible Integration partner sites
   *
   * Partner sites are services that have Salaxy or Palkkaus functionality in them. Others are services that have a different sign-in method,
   * and these services need an authorization to access user's Salaxy/Palkkaus account. Others use the Salaxy/Palkkaus sign-in method, so they don't
   * need separate authorization. Due to some services needing an authorization and others not needing it, all partner services need to be stored in a
   * separate property, simply listing authorizations does not suffice.
   *
   * Partner services that need an authorization have a property accountId, that is the IBAN for their Salaxy acccount
   * @returns List of partner site objects.
   */
  getPartnerIntegrationSiteList() {
    return this.partnerIntegrationSiteList.forEach((t) => t.enabled = !!this.list.find((e) => e.id === t.accountId)), this.partnerIntegrationSiteList;
  }
  /**
   * Returns the partner site with given id
   * @param id The name of the partner site
   * @returns Partner site object with the given id, or undefined.
   */
  getPartnerSite(t) {
    const e = this.getPartnerIntegrationSiteList().filter((a) => a.id === t);
    return e.length > 0 ? e[0] : null;
  }
  refreshAuthorizingAccounts() {
    if (this.sessionService.isSessionChecked && this.sessionService.isAuthenticated) {
      const t = this.sessionService.session.currentAccount.owner;
      this.initialAuthorizingAccountsOwner != t && (this.authorizingAccounts = [], this.initialAuthorizingAccountsOwner = t, this.reloadAuthorizingAccounts());
    } else
      this.authorizingAccounts = [], this.initialAuthorizingAccountsOwner = null;
  }
};
IC.$inject = ["$rootScope", "SessionService", "AuthorizedAccounts"];
let qv = IC;
class a2 {
  constructor() {
    this.rawCache = {};
  }
  /** Return true if the given item is in the cache. */
  hasData(t, e) {
    if (!t)
      return !1;
    const a = this.rawCache[t];
    return a ? a.validMs < +(/* @__PURE__ */ new Date()).getTime() ? (this.clear(t), !1) : a.url === e : !1;
  }
  /** Returns the data if exists / is valid. */
  getData(t, e) {
    if (!t)
      return null;
    if (this.hasData(t, e))
      return this.rawCache[t].data;
  }
  /** Returns the full cache data based on key without any validation. */
  getFullCache(t) {
    return t ? this.rawCache[t] || {
      data: null,
      key: t,
      url: null,
      validMs: null
    } : null;
  }
  /**
   * Sets the new data to the cache.
   * @param key The cache key. Defining the instance where the cache is being used.
   * If null, does nothing.
   * @param url URL that was called to fetch the cache.
   * Technically, this can be any string that just determines whether the URL / query has changed.
   * @param data Data that is cached
   * @param expiresSeconds Time to live for the data in seconds starting from the current time.
   */
  setData(t, e, a, n) {
    if (!t)
      return null;
    a.$loaded = (/* @__PURE__ */ new Date()).getTime(), this.rawCache[t] = {
      data: a,
      url: e,
      validMs: (/* @__PURE__ */ new Date()).getTime() + n * 1e3
    };
  }
  /** Clears the entire cache - all keys. */
  clearAllKeys() {
    this.rawCache = {};
  }
  /** Clears a given cache key */
  clear(t) {
    t && (this.rawCache[t] = null);
  }
}
const PC = class PC extends _w {
  constructor(t, e, a) {
    super(t, e, a), this.certificateApi = a, this.eventPrefix = "certificate";
  }
};
PC.$inject = ["$rootScope", "SessionService", "Certificates"];
let Kv = PC;
const EC = class EC extends _w {
  constructor(t, e, a) {
    super(t, e, a), this.credentialsApi = a, this.eventPrefix = "certificate";
  }
  /**
   * Returns the url for uploading the avatar image file to the database
   * @returns Id of the credential
   */
  getAvatarUploadUrl(t) {
    return this.credentialsApi.getAvatarUploadUrl(t);
  }
};
EC.$inject = ["$rootScope", "SessionService", "Credentials"];
let Jv = EC;
class Fh {
  /**
   * Gets the Payroll03Info object based on current data (without going to server).
   * @param payroll Payroll object, where info may be outdated.
   * @param calcs Calculations that may be loaded from the server.
   */
  static getInfo(t, e) {
    return t ? !e || e.length === 0 ? t.info : {
      calcCount: e.length,
      // Should this be input.calcs.length? Probably does not really matter.
      fees: ie.sum(e, (a) => a.result.employerCalc.palkkaus),
      totalGrossSalary: ie.sum(e, (a) => se.round(a.result.totals.totalGrossSalary)),
      totalPayment: ie.sum(e, (a) => se.round(a.result.employerCalc.totalPayment)),
      // We could potentially do some client-side validation here, but it may not make sense: Real validation is on the server.
      isReadyForPayment: t.info.isReadyForPayment,
      // Not updated by this logic:
      date: t.info.date,
      salaryDate: t.info.salaryDate,
      paymentDate: t.info.paymentDate,
      paymentId: t.info.paymentId,
      status: t.info.status
    } : new Cw(null).getBlank().info;
  }
  /**
   * Returns true if there is no net salary payment to worker at all.
   * @param calcs - Calculation objects
   */
  static isZeroPayment(t) {
    return !t || !t.length ? !1 : t.every((e) => Da.isZeroPayment(e));
  }
}
const NC = class NC {
  constructor(t, e, a, n, i, r, l, o, c) {
    this.invoicesApi = t, this.sessionService = e, this.uiHelpers = a, this.settingsService = n, this.ajax = i, this.$location = r, this.$timeout = l, this.calculations = o, this.onboardingService = c, this._defaultSepaChannel = At.PalkkausManual, this._defaultPaymentListChannel = At.PalkkausWS;
  }
  /** Gets the default SEPA payment channel. */
  get defaultSepaChannel() {
    return this._defaultSepaChannel;
  }
  set defaultSepaChannel(t) {
    this._defaultSepaChannel = t;
  }
  /** Gets the default payment channel. */
  get defaultPaymentListChannel() {
    return this._defaultPaymentListChannel;
  }
  set defaultPaymentListChannel(t) {
    this._defaultPaymentListChannel = t;
  }
  /**
   * Application level setting of the default payment channel.
   */
  get defaultChannel() {
    if (this.channels) {
      const t = this.sessionService.getSession().settings.defaultPaymentChannel;
      return this.channels.filter((a) => a.id === t).concat(this.channels).find(() => !0)?.id;
    }
    return null;
  }
  /**
   * Gets the enabled payment channels as avatars for the current session.
   */
  get channels() {
    const t = () => this.sessionService.getSession().settings?.paymentChannels.filter(
      (e) => e !== At.PalkkausManual || e === At.PalkkausManual && this.sessionService.isInSomeRole("pro,sepaPartner")
    );
    return this.uiHelpers.cache(
      this,
      "channels",
      () => t()?.map((e) => ne.getChannelAvatar(e))?.filter((e) => !!e),
      () => t()
    );
  }
  /**
   * Gets the enabled payment channels as input enum options for the current session.
   */
  get channelEnumOptions() {
    return this.uiHelpers.cache(
      this,
      "channelEnumOptions",
      () => this.channels?.map((t) => ({ text: t.displayName, value: t.id, title: t.description })),
      () => this.sessionService.getSession()?.settings.paymentChannels
    );
  }
  /**
   * Shows the paymment page as dialog.
   * @param paymentObject - The object to pay: Either Calculation or Payroll
   */
  showPaymentDialog(t) {
    if (!this.checkAccountVerificationForPayment()) {
      this.showMissingSignatureAlert();
      return;
    }
    if (!this.checkChangedSalaryDate(t)) {
      this.showChangedSalaryDateAlert();
      return;
    }
    let e = null;
    if (ne.isPayroll(t) ? e = t.input.paymentChannel : ne.isCalculation(t) && (this.sessionService.isInRole("person") && (t.info.paymentChannel = At.PalkkausPersonal), e = t.info.paymentChannel), ne.isEcfa(e) && !this.checkKycForPayment()) {
      this.showMissingKycAlert();
      return;
    }
    const a = {
      title: e === At.HolviCfa ? L.get("SALAXY.NG1.InvoicesService.logic.title.holviCfa") : e === At.TalenomCfa ? L.get("SALAXY.NG1.InvoicesService.logic.title.talenomCfa") : ne.isPalkkausInvoicesLike(e) ? L.get("SALAXY.NG1.InvoicesService.logic.title.palkkausInvoices") : L.get("SALAXY.NG1.InvoicesService.logic.title.default"),
      type: ne.isPayroll(t) ? "payroll" : "calc",
      okButtonText: e === At.HolviCfa ? L.get("SALAXY.NG1.InvoicesService.logic.okButtonText.holviCfa") : e === At.TalenomCfa ? L.get("SALAXY.NG1.InvoicesService.logic.okButtonText.talenomCfa") : ne.isPalkkausInvoicesLike(e) ? L.get("SALAXY.NG1.InvoicesService.logic.okButtonText.palkkausInvoices") : ne.isCfa(e) ? L.get("SALAXY.NG1.InvoicesService.logic.okButtonText.isCfaChannel") : L.get("SALAXY.NG1.InvoicesService.logic.okButtonText.default"),
      channel: e,
      paymentFunc: null,
      isNullPayment: () => ne.isCalculation(t) && se.round(t.result.employerCalc.totalPayment) == 0 || ne.isPayroll(t) && se.round(t.info.totalPayment) == 0,
      isReadyForPayment: () => ne.isPayroll(t) ? t.info && t.info.isReadyForPayment : ne.isCalculation(t) ? t.worker && t.worker.tax.isValid && !t.result.validation.errors.find((r) => r.type !== "warning") : !1,
      instructions: e === At.HolviCfa ? L.get("SALAXY.NG1.InvoicesService.logic.instructions.holviCfa") : e === At.TalenomCfa ? L.get("SALAXY.NG1.InvoicesService.logic.instructions.talenomCfa") : null
    }, n = () => {
      if (ne.isCalculation(t) && (e == At.PalkkausPersonal || e == At.PalkkausCfaPaytrail || e == At.PalkkausEcfaPaytrail || e == At.PalkkausPSD))
        if (!t.workflow?.status || t.workflow.status === le.Draft) {
          const r = this.uiHelpers.showLoading(L.get("SALAXY.NG1.InvoicesService.saving") + "...");
          return this.calculations.save(t).then((l) => (r.dismiss(), wt.copy(l, t), this.$location.path("/calc/details/" + t.id + "&refresh=" + (/* @__PURE__ */ new Date()).getTime()), t));
        } else
          return Promise.resolve(t);
      else
        return Promise.resolve(t);
    }, i = () => ne.isPayroll(t) ? t.calcs.length > 0 ? Promise.resolve(t) : new Pl(this.ajax).getCalcsOData(t.id, null).then((l) => {
      const o = l.items, c = {};
      c.listItemType = "CalculationListItem";
      const d = void 0, p = void 0, h = (g) => {
        const x = g.map((b) => b.id);
        return this.calculations.getMulti(x).then((b) => {
          const A = g.map(() => ({ message: "", result: [] }));
          return A[0].result = b, A;
        });
      };
      return this.uiHelpers.showBatchProcessDialog(L.get("SALAXY.UI_Terms.wait"), o, h, p, c, d, 20, !0, !0, !0).then((g) => {
        const x = [];
        g.done && g.results.forEach((A) => {
          x.push(...A.result);
        });
        const b = wt.copy(t);
        return b.calcs = x, b.V4 = !0, b;
      });
    }) : Promise.resolve(t);
    if (ne.isCfa(e) && e !== At.PalkkausCfaPaytrail && e !== At.PalkkausEcfaPaytrail)
      i().then((r) => {
        t = r, this.uiHelpers.openEditDialog("salaxy-components/modals/calc/CfaPaymentOverview.html", t, a, "lg").then((l) => {
          l.action === We.Ok && this.createCfaInvoice(e, t);
        });
      });
    else
      switch (e) {
        case At.PalkkausCfaPaytrail:
        case At.PalkkausEcfaPaytrail:
          i().then((r) => {
            t = r, a.paymentFunc = (l) => this.createPalkkausCfaPaytrailInvoice(l), n().then(() => this.uiHelpers.openEditDialog("salaxy-components/modals/calc/CfaPaymentOverview.html", t, a, "lg"));
          });
          break;
        case At.PalkkausPSD: {
          i().then((r) => {
            const l = {
              title: "TODO: Add title",
              isReadyForPayment: () => ne.isPayroll(t) ? t.info && t.info.isReadyForPayment : ne.isCalculation(t) ? t.worker && t.worker.tax.isValid && !t.result.validation.errors.find((o) => o.type !== "warning") : !1,
              instructions: "TODO: Add instructions",
              type: ne.isPayroll(t) ? "payroll" : "calc"
            };
            t = r, n().then(() => this.uiHelpers.openEditDialog("salaxy-components/modals/calc/PSDPaymentOverview.html", t, l, "lg")).then((o) => {
              const c = () => ne.isPayroll(t) ? t.V4 ? new Pl(this.ajax).createInvoices(t.id, [], !1) : this.invoicesApi.createInvoicesForPayroll(e, t.id) : this.invoicesApi.createInvoices(t, e);
              o.action == "create-invoices-pay-later" ? c().then(() => {
                this.uiHelpers.showAlert("Maksut ovat luotu", "Maksut ovat luotu ja ne ovat nyt valmiina maksuun. Tässä näkymässä näet kaikki maksut, joita voit siirtää ryhmittäin maksuun."), this.$location.path("/invoices/payment-list");
              }) : o.action == "create-invoices-pay-now" && c().then((d) => {
                const p = d.filter((b) => b.header.type === ce.Net || b.header.type === ce.Foreclosure || b.header.type === ce.Union || b.header.type === ce.Payroll || b.header.type === ce.Tax).map((b) => b.id), h = {
                  banks: [
                    {
                      id: "OSUUSPANKKI_MOCK",
                      name: "Osuuspankki Mock (hyväksyy maksut automaattisesti)",
                      logo: "https://cdn.salaxy.com/img/salaxy/sign/op.png"
                    },
                    {
                      id: "OSUUSPANKKI_TEST",
                      name: "Osuuspankki Test (tunnistautuminen)",
                      logo: "https://cdn.salaxy.com/img/salaxy/sign/op.png"
                    },
                    {
                      id: "NORDEA_MOCK",
                      name: "Nordea Test Mock (hyväksyy maksut automaattisesti)",
                      logo: "https://cdn.salaxy.com/img/salaxy/sign/nordea.png"
                    },
                    {
                      id: "NORDEA_TEST",
                      name: "Nordea Test (tunnistautuminen ei toimi, jää kesken)",
                      logo: "https://cdn.salaxy.com/img/salaxy/sign/nordea.png"
                    },
                    {
                      id: "NORDEA_PERSONAL_TEST",
                      name: "Nordea Personal Test (Hylkää maksut pankin puolelta)",
                      logo: "https://cdn.salaxy.com/img/salaxy/sign/nordea.png"
                    },
                    {
                      id: "INVALID_BANK_TEST",
                      name: "Invalid Bank (Tekninen virhe tapahtuu ja ruudulle tulee virhe)",
                      logo: "https://cdn.salaxy.com/img/salaxy/sign/invalid.png"
                    }
                  ],
                  selectedBank: null,
                  forceAccountAuthorization: !1,
                  selectBank: (b) => {
                    h.selectedBank = b;
                  }
                }, g = (b) => {
                  ne.isPayroll(t) ? this.$location.path("/payroll/details/" + b + "&refresh=" + (/* @__PURE__ */ new Date()).getTime()) : this.$location.path("/calc/details/" + b + "&refresh=" + (/* @__PURE__ */ new Date()).getTime());
                }, x = (b) => b?.data.action == "refresh" ? (this.$timeout(() => {
                  g(t.id);
                }), !1) : !0;
                this.uiHelpers.openEditDialog("salaxy-components/modals/payment/psd/BankSelection.html", null, h).then((b) => {
                  const A = b.logic.selectedBank, T = b.logic.forceAccountAuthorization, R = `${this.ajax.getServerAddress()}/psdPayment/payInvoices?forceAccountAuthorization=${T}&ids=${p}&bank=${A}&successurl=&access_token=${this.ajax.getCurrentToken()}`;
                  if (b.action === "ok") {
                    const C = this.uiHelpers.showLoading("Avataan pankkimaksua..."), v = () => {
                      C.dismiss();
                    };
                    return this.uiHelpers.showExternalDialog("psdDialog", R, null, null, x, v).then((P) => {
                      P.action == "user-cancel" ? this.uiHelpers.showDialog("salaxy-components/modals/payment/PaymentCancel.html").then(() => {
                        g(t.id);
                      }) : P.action == "invoice-paid" ? this.uiHelpers.showAlert(L.get("SALAXY.NG1.InvoicesService.paytrail.invoicePaid.heading"), L.get("SALAXY.NG1.InvoicesService.paytrail.invoicePaid.text") + ".").then(() => {
                        g(t.id);
                      }) : P.action == "invoice-missing" ? this.uiHelpers.showAlert(L.get("SALAXY.NG1.InvoicesService.paytrail.invoiceMissing.heading"), L.get("SALAXY.NG1.InvoicesService.paytrail.invoiceMissing.text") + ".").then(() => {
                        g(t.id);
                      }) : P.action == We.Ok && this.uiHelpers.showDialog("salaxy-components/modals/payment/PaymentConfirm.html").then(() => {
                        g(t.id);
                      });
                    });
                  }
                });
              });
            });
          });
          break;
        }
        case At.PalkkausWS: {
          this.uiHelpers.openEditDialog("salaxy-components/modals/calc/WSPaymentOverview.html", t, a, "lg");
          break;
        }
        case At.PalkkausPersonal:
          n().then(() => {
            this.uiHelpers.openEditDialog("salaxy-components/modals/calc/PalkkausPersonalPaymentOverview.html", t, a, "lg", "PalkkausPersonalPaymentOverviewController").then((r) => {
              r.action && (r.action == Ft.Canceled ? (this.createPalkkausPersonalInvoice(e, t, Ft.Canceled), this.uiHelpers.showAlert(
                L.get("SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.alerts.headingCancelled"),
                `${L.get("SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.alerts.cancel.infotext1")}.\r
${L.get("SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.alerts.cancel.infotext2")}.`,
                L.get("SALAXY.UI_Terms.ok")
              )) : r.action === Ft.Paid && (this.createPalkkausPersonalInvoice(e, t, Ft.Paid), this.uiHelpers.showAlert(
                L.get("SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.alerts.headingPaid"),
                `${L.get("SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.alerts.paid.text")}\r
${L.get("SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.alerts.paid.infoText1")}\r
${L.get("SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.alerts.paid.infoText2")}\r
${L.get("SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.alerts.paid.infoText3")}`,
                L.get("SALAXY.UI_Terms.ok")
              )));
            });
          });
          break;
        default:
          this.uiHelpers.openEditDialog("salaxy-components/modals/calc/PaymentOverview.html", t, a, "lg");
          break;
      }
  }
  /**
   * Shows the payment invoice inspection page as dialog.
   * @param paymentObject - Paid calculation
   */
  showPalkkausPersonalInvoicesDialog(t) {
    const e = { isInspectingPaidInvoices: !0 };
    this.uiHelpers.openEditDialog("salaxy-components/modals/calc/PalkkausPersonalPaymentOverview.html", t, e, "lg", "PalkkausPersonalPaymentOverviewController");
  }
  /**
   * Querys item and opens paymentdialog
   * @param item InvoiceListItem used to query calculation
   */
  showPaymentDialogForCalculation(t) {
    this.calculations.getSingle(t.businessObjects[0]).then((e) => {
      this.showPaymentDialog(e);
    });
  }
  /**
   * Shows an alert if the signature is missing.
   */
  showMissingSignatureAlert() {
    this.uiHelpers.showConfirm(
      L.get("SALAXY.NG1.InvoicesService.missingSignatureAlert.signatureMissing"),
      L.get("SALAXY.NG1.InvoicesService.missingSignatureAlert.creationCompleteBeforePay") + `
` + L.get("SALAXY.NG1.InvoicesService.missingSignatureAlert.signSignature") + `

` + L.get("SALAXY.NG1.InvoicesService.missingSignatureAlert.continueToSignature"),
      L.get("SALAXY.NG1.InvoicesService.missingSignatureAlert.continue"),
      L.get("SALAXY.NG1.InvoicesService.missingSignatureAlert.close")
    ).then((t) => {
      t && (this.sessionService.getCurrentAccount().entityType === Xi.Person ? this.onboardingService.launchHouseholdOnboarding() : this.onboardingService.launchCompanyOnboarding());
    });
  }
  /**
   * Checks if the company's KYC (Know Your Customer) is completed for payment.
   * @returns {boolean} Returns true if the KYC is completed, otherwise false.
   */
  checkKycForPayment() {
    return !!this.sessionService?.companyAccount?.identity?.kycUpdatedAt;
  }
  /**
   * Shows an alert if the kyc is missing.
   */
  showMissingKycAlert() {
    this.uiHelpers.showConfirm(
      "Asiakkaan tuntemistiedot puuttuvat",
      null,
      "Päivitä asiakkaan tuntemistiedot nyt",
      L.get("SALAXY.NG1.InvoicesService.missingSignatureAlert.close"),
      'Asiakasvaratilin kautta maksaminen edellyttää asiakkaan tuntemistietojen päivittämistä. Päivitä KYC-tiedot oheisesta linkistä tai lue ohjeet, kuinka voit välittää päivityslinkin yhtiön nimenkirjoitusoikeudelliselle henkilölle täältä: <a href="https://help.palkkaus.fi/hc/fi/articles/19590957330589-Asiakkaan-tuntemistietojen-päivitys-KYC" target="_blank">Asiakkaan tuntemistietojen päivittäminen</a>'
    ).then((t) => {
      t && window.open(Ne.current.isTestData ? "https://rc-iam.palkkaus.fi/wizard/index.html" : "https://iam.palkkaus.fi/wizard/index.html", "_blank");
    });
  }
  /**
   * Returns true if the current authenticated user has
   * required verification for the payment.
   */
  checkAccountVerificationForPayment() {
    return this.sessionService.checkAccountVerification();
  }
  /** Returns warning message text for the invoice if reported late.*/
  getEprWarningForPayment(t) {
    return this.isDelayed(t) ? L.get("SALAXY.NG1.InvoicesService.eprWarningForPayment.isDelayed") : "";
  }
  /** Returns warning message text for the invoice if reported late.*/
  getEprWarningForCancellation(t, e) {
    return e ? this.isDelayed(t) ? L.get("SALAXY.NG1.InvoicesService.eprWarningForCancellation.isDelayed") + `

` + L.get("SALAXY.NG1.InvoicesService.eprWarningForCancellation.infoText") : "" : null;
  }
  /**
   * Checks the salary date validity before payment.
   * @param paymentObject - The object to pay: Either Calculation or Payroll
   */
  checkChangedSalaryDate(t) {
    const e = this.sessionService.isInRole("pro") ? "pro" : this.sessionService.isInRole("admin") ? "admin" : null;
    return ne.isPayroll(t) ? t.info.status != Ua.Draft && t.info.status != Ua.WaitingApproval || !t.input.salaryDate ? !0 : t.input.salaryDate != t.info.salaryDate ? !1 : t.input.salaryDateKind == $n.InPast ? !0 : gc.isValidSalaryDate(t.info.salaryDate, null, null, !!t.input.salaryDate, t.input.paymentChannel, Fh.isZeroPayment(t.calcs), e) : ne.isCalculation(t) ? (this.sessionService.isInRole("person") && (t.info.paymentChannel = At.PalkkausPersonal), t.workflow.status != le.Draft && t.workflow.status != le.WaitingApproval && t.workflow.status != le.ProDraft || !t.workflow.requestedSalaryDate ? !0 : t.workflow.requestedSalaryDate != t.workflow.salaryDate ? !1 : t.workflow.salaryDateKind == $n.InPast ? !0 : gc.isValidSalaryDate(t.workflow.salaryDate, t.worker?.paymentData?.ibanNumber, null, !!t.workflow.requestedSalaryDate, t.info.paymentChannel, Da.isZeroPayment(t), e)) : !0;
  }
  /**
   * Shows an alert for invalid salary date.
   */
  showChangedSalaryDateAlert() {
    this.uiHelpers.showAlert(L.get("SALAXY.VALIDATION.Calc.SalaryDateChanged.label"), L.get("SALAXY.VALIDATION.Calc.SalaryDateChanged.description"));
  }
  /** Checks if the Epr report is delayed. */
  isDelayed(t) {
    const e = I.add(t ?? "today", 5, "day"), a = I.addWorkdays(e, 0);
    return I.asDate("today") > a;
  }
  createCfaInvoice(t, e) {
    const a = () => {
      const c = {};
      return ne.isPayroll(e) ? e.V4 ? new Pl(this.ajax).previewInvoices(e.id, [], !1) : (c.payrollIds = [e.id], this.invoicesApi.previewInvoices(t, c)) : (c.calcs = [e], this.invoicesApi.previewInvoices(t, c));
    }, n = () => ne.isPayroll(e) ? e.V4 ? new Pl(this.ajax).createInvoices(e.id, [], !1) : this.invoicesApi.createInvoicesForPayroll(t, e.id) : this.invoicesApi.createInvoices(e, t), i = () => a().then((c) => {
      const d = c.find((p) => p.invoice.entityType == ce.Gross);
      return d ? d.exists ? this.invoicesApi.getSingle(d.invoice.id) : n().then((p) => p.find((h) => h.header.type == ce.Gross)) : null;
    }), r = (c) => {
      ne.isPayroll(e) ? this.$location.path("/payroll/details/" + c + "&refresh=" + (/* @__PURE__ */ new Date()).getTime()) : this.$location.path("/calc/details/" + c + "&refresh=" + (/* @__PURE__ */ new Date()).getTime());
    }, l = (c) => c.header.status === Ft.Paid ? (this.uiHelpers.showAlert(L.get("SALAXY.NG1.InvoicesService.isPaid.payment"), L.get("SALAXY.NG1.InvoicesService.isPaid.paid")), !0) : c.header.status !== Ft.PaymentStarted && c.header.status !== Ft.Unread ? (this.uiHelpers.showAlert(L.get("SALAXY.NG1.InvoicesService.isPaid.cantCreatePayment"), L.get("SALAXY.NG1.InvoicesService.isPaid.cantCreatePaymentAlreadyPaid")), !0) : !1, o = this.uiHelpers.showLoading(L.get("SALAXY.NG1.InvoicesService.creatingPayment") + "...");
    i().then((c) => {
      if (!c) {
        o.dismiss(), this.uiHelpers.showAlert(L.get("SALAXY.NG1.InvoicesService.createInvoice.cantCreateInvoice"), L.get("SALAXY.NG1.InvoicesService.createInvoice.cantCreateInvoiceCheck"));
        return;
      }
      switch (t) {
        case At.PalkkausCfaFinvoice:
        case At.PalkkausEcfaFinvoice:
          if (l(c))
            o.dismiss(), r(c.header.businessObjects[0]);
          else {
            o.dismiss();
            const d = this.settingsService.current.payments.invoice.eInvoiceReceiver, p = this.settingsService.current.payments.invoice.eInvoiceIntermediator, h = {
              eInvoiceReceiver: d,
              eInvoiceIntermediator: p
            }, g = !d || !p, x = (b) => {
              const A = this.uiHelpers.showLoading(L.get("SALAXY.NG1.InvoicesService.sending") + "...");
              if (b.eInvoiceReceiver !== d || b.eInvoiceIntermediator !== p) {
                const T = this.settingsService.current;
                T.payments.invoice.eInvoiceReceiver = b.eInvoiceReceiver, T.payments.invoice.eInvoiceIntermediator = b.eInvoiceIntermediator, this.settingsService.save();
              }
              return this.invoicesApi.sendEInvoice(c.id, b.eInvoiceReceiver, b.eInvoiceIntermediator).then((T) => {
                A.dismiss();
                let R = L.get("SALAXY.NG1.InvoicesService.sendEInvoice.ajax.title"), C = `${L.get("SALAXY.NG1.InvoicesService.sendEInvoice.ajax.msg")} ${b.eInvoiceIntermediator}/${b.eInvoiceReceiver}.`, v = "";
                if (T.Response.Status !== "OK" && (R = L.get("SALAXY.NG1.InvoicesService.sendEInvoice.ajax.error.title"), C = L.get("SALAXY.NG1.InvoicesService.sendEInvoice.ajax.error.msg"), T.Response.FreeText))
                  for (const P of T.Response.FreeText)
                    v += P["#text"] + `
`;
                return v = this.textToRows(v, 80, `
`), this.uiHelpers.showAlert(R, C + `
` + L.get("SALAXY.NG1.InvoicesService.sendEInvoice.ajax.operatorStatus") + `:
` + T.Response.Status + " " + T.Response.StatusCode + `
` + v), T;
              });
            };
            if (g) {
              const b = {
                selectEInvoiceAddress: (A) => {
                  this.settingsService.selectEInvoiceAddress(A);
                }
              };
              this.uiHelpers.openEditDialog("salaxy-components/modals/payment/cfa/EInvoice.html", h, b, null).then((A) => {
                A.action !== We.Ok ? r(c.header.businessObjects[0]) : x(A.item).then(() => {
                  r(c.header.businessObjects[0]);
                });
              });
            } else
              x(h).then(() => {
                r(c.header.businessObjects[0]);
              });
          }
          break;
        case At.PalkkausCfaReference:
        case At.PalkkausEcfaReference:
          {
            o.dismiss();
            const d = [];
            ne.isPayroll(e) ? d.push(...e.calcs) : ne.isCalculation(e) && d.push(e);
            const p = Da.getBlank();
            p.worker.tax = p.worker.tax || {}, p.result = Vy.add(d.map((g) => g.result));
            const h = {
              printClass: "sxyFullPrint",
              print: (g) => {
                h.printClass = g, setTimeout(() => {
                  window.print();
                }, 0);
              },
              calculations: d,
              totalResultCalculation: p
            };
            this.uiHelpers.openEditDialog("salaxy-components/modals/payment/cfa/Transfer.html", c, h, "xl").then(() => {
              r(c.header.businessObjects[0]);
            });
          }
          break;
        case At.PalkkausCfaTest:
          l(c) ? (o.dismiss(), r(c.header.businessObjects[0])) : (o.setHeading(L.get("SALAXY.NG1.InvoicesService.sendEInvoice.paymentChannel.palkkausCfaTest.paying") + "..."), this.invoicesApi.requestStatusUpdate(c.id, Ft.Paid).then(() => {
            o.dismiss(), r(c.header.businessObjects[0]);
          }));
          break;
        case At.HolviCfa:
          l(c) ? (o.dismiss(), r(c.header.businessObjects[0])) : (o.setHeading(L.get("SALAXY.NG1.InvoicesService.sendEInvoice.paymentChannel.holviCfa.paying") + "..."), this.ajax.postJSON(this.ajax.getServerAddress() + "/partner/holvi/invoice/" + c.id, null).then((d) => {
            o.dismiss(), d && this.uiHelpers.showAlert(L.get("SALAXY.NG1.InvoicesService.sendEInvoice.paymentChannel.holviCfa.salariesMovedToPay"), L.get("SALAXY.NG1.InvoicesService.sendEInvoice.paymentChannel.holviCfa.holviConfirm") + `.
` + L.get("SALAXY.NG1.InvoicesService.sendEInvoice.paymentChannel.holviCfa.afterConfirmation") + `
` + L.get("SALAXY.NG1.InvoicesService.sendEInvoice.paymentChannel.holviCfa.accountsToWorker") + `.
` + L.get("SALAXY.NG1.InvoicesService.sendEInvoice.paymentChannel.holviCfa.palkkausIr") + "."), r(c.header.businessObjects[0]);
          }));
          break;
        case At.TalenomCfa:
          l(c) ? (o.dismiss(), r(c.header.businessObjects[0])) : (o.setHeading(L.get("SALAXY.NG1.InvoicesService.sendEInvoice.paymentChannel.talenomCfa.paying") + "..."), this.ajax.postJSON(this.ajax.getServerAddress() + "/partner/talenom/invoice/" + c.id, null).then((d) => {
            o.dismiss(), d && this.uiHelpers.showAlert(L.get("SALAXY.NG1.InvoicesService.sendEInvoice.paymentChannel.talenomCfa.salariesMovedToPay"), L.get("SALAXY.NG1.InvoicesService.sendEInvoice.paymentChannel.talenomCfa.talenomConfirm") + `.
` + L.get("SALAXY.NG1.InvoicesService.sendEInvoice.paymentChannel.talenomCfa.afterConfirmation") + `.
` + L.get("SALAXY.NG1.InvoicesService.sendEInvoice.paymentChannel.talenomCfa.confirm") + "!"), r(c.header.businessObjects[0]);
          }));
          break;
      }
    });
  }
  createPalkkausCfaPaytrailInvoice(t) {
    const e = (r) => {
      ne.isPayroll(t) ? this.$location.path("/payroll/details/" + r + "&refresh=" + (/* @__PURE__ */ new Date()).getTime()) : this.$location.path("/calc/details/" + r + "&refresh=" + (/* @__PURE__ */ new Date()).getTime());
    }, n = ((r) => ne.isPayroll(t) ? this.ajax.getServerAddress() + `/SalaryPayment/PayInvoiceForPayroll/${r}?access_token=${this.ajax.getCurrentToken()}` : this.ajax.getServerAddress() + `/SalaryPayment/PayInvoiceForCalculation/${r}?access_token=${this.ajax.getCurrentToken()}`)(t.id), i = (r) => r?.data.action == "refresh" ? (this.$timeout(() => {
      e(t.id);
    }), !1) : !0;
    this.uiHelpers.showExternalDialog("PaytrailPayment", n, {}, null, i).then((r) => {
      r.action == "user-cancel" ? this.uiHelpers.showDialog("salaxy-components/modals/payment/PaymentCancel.html").then(() => {
        e(t.id);
      }) : r.action == "invoice-paid" ? this.uiHelpers.showAlert(L.get("SALAXY.NG1.InvoicesService.paytrail.invoicePaid.heading"), L.get("SALAXY.NG1.InvoicesService.paytrail.invoicePaid.text") + ".").then(() => {
        e(t.id);
      }) : r.action == "invoice-missing" ? this.uiHelpers.showAlert(L.get("SALAXY.NG1.InvoicesService.paytrail.invoiceMissing.heading"), L.get("SALAXY.NG1.InvoicesService.paytrail.invoiceMissing.text") + ".").then(() => {
        e(t.id);
      }) : r.action == We.Ok && this.uiHelpers.showDialog("salaxy-components/modals/payment/PaymentConfirm.html").then(() => {
        e(t.id);
      });
    });
  }
  createPalkkausPersonalInvoice(t, e, a) {
    if (ne.isPayroll(e)) {
      this.uiHelpers.showAlert(L.get("SALAXY.NG1.InvoicesService.palkkausPersonalInvoice.isPayroll.heading"), L.get("SALAXY.NG1.InvoicesService.palkkausPersonalInvoice.isPayroll.text") + ".");
      return;
    }
    const n = (d, p) => d.header.status === p ? Promise.resolve(d) : this.invoicesApi.requestStatusUpdate(d.id, p), i = () => this.invoicesApi.previewInvoices(t, {
      calcs: [e]
    }), r = () => this.invoicesApi.createInvoices(e, t), l = () => {
      const d = { netInvoice: null, taxInvoice: null };
      return i().then((p) => {
        const h = p.find((A) => A.invoice.entityType == ce.Net && A.invoice.status !== Ft.Canceled && A.invoice.status !== Ft.Error);
        if (!h)
          return Promise.resolve(d);
        const g = p.find((A) => A.invoice.entityType == ce.Tax && A.invoice.status !== Ft.Canceled && A.invoice.status !== Ft.Error), x = () => this.invoicesApi.getSingle(h.invoice.id).then((A) => {
          d.netInvoice = A;
        }), b = () => !g || !g.exists ? Promise.resolve(null) : this.invoicesApi.getSingle(g.invoice.id).then((A) => {
          d.taxInvoice = A;
        });
        return h.exists ? Promise.all([x(), b()]).then(() => d) : r().then((A) => (d.netInvoice = A.find((T) => T.header.type == ce.Net), d.taxInvoice = A.find((T) => T.header.type == ce.Tax), d));
      });
    }, o = (d) => {
      this.$location.path("/calc/details/" + d + "&refresh=" + (/* @__PURE__ */ new Date()).getTime());
    }, c = this.uiHelpers.showLoading(L.get("SALAXY.NG1.InvoicesService.palkkausPersonalInvoice.updatingPaymentStatus") + "...");
    l().then((d) => {
      if (!d.netInvoice) {
        c.dismiss(), this.uiHelpers.showAlert(L.get("SALAXY.NG1.InvoicesService.palkkausPersonalInvoice.createInvoice.heading"), L.get("SALAXY.NG1.InvoicesService.palkkausPersonalInvoice.createInvoice.text") + "...");
        return;
      }
      if (a === Ft.Canceled && n(d.netInvoice, a).then(() => {
        c.dismiss(), o(d.netInvoice.header.businessObjects[0]);
      }), a !== Ft.Canceled) {
        const p = [
          n(d.netInvoice, a)
        ];
        d.taxInvoice && p.push(n(d.taxInvoice, a)), Promise.all(p).then(() => {
          c.dismiss(), o(d.netInvoice.header.businessObjects[0]);
        });
      }
    });
  }
  textToRows(t, e, a) {
    if (!t)
      return t;
    const n = [], i = t.split(a);
    for (const r of i) {
      let l = r;
      for (; l.length > e; )
        n.push(l.substr(0, e)), l = l.slice(e);
      l.length > 0 && n.push(l);
    }
    return n.join(a);
  }
};
NC.$inject = ["Invoices", "SessionService", "UiHelpers", "SettingsService", "AjaxNg1", "$location", "$timeout", "Calculations", "OnboardingService"];
let Qv = NC;
const RC = class RC {
  constructor(t, e, a, n, i, r, l) {
    this.$rootScope = t, this.$sce = e, this.onboardingsApi = a, this.sessionService = n, this.uiHelpers = i, this.ajax = r, this.$location = l, this.init();
  }
  /** Gets / refreshes the onboarding data from the server  */
  getOnboardingData(t = null) {
    return this.onboardingsApi.getOnboarding(t || "latest").then((e) => (this.model = e, this.id = e.id, this.notify(), this.model));
  }
  /**
   * Get the onboarding object for given account.
   * @param accountId - Account id for existing account.
   */
  getOnboardingDataForAccount(t) {
    return this.onboardingsApi.getOnboardingForAccount(t).then((e) => (e ? this.id = e.id : this.id = null, this.model = e, this.model));
  }
  /**
   * Saves the current onboarding to database.
   * @returns A Promise with result data (Onboarding)
   */
  save() {
    const t = this.model.signature.method;
    return this.onboardingsApi.saveOnboarding(this.model).then((e) => (this.id !== e.id && (this.id = e.id), this.model = e, this.model.signature.method = t, this.model));
  }
  /**
   * Commits current onboarding  and creates/changes the account.
   * @returns A Promise with result data (Onboarding)
   */
  commit() {
    return this.onboardingsApi.commitOnboarding(this.model).then((t) => (this.model = t, this.model));
  }
  /**
   * Return the new URL for digital signature: Telia and Singicat
   * @param authService Select the signature service (bank / mobile auth).
   * This is only supported for Telia / Persons (not companies Signicat)
   * @param signerPersonalId Possibility to override the signer personal Id.
   * @param testSignerPersonalId Signer personal id for test.
   * @param successUrl Optional success url for the signature.
   * Leaving this empty will return the brower to the current page (path, not query params / hash)
   * @param cancelUrl Optional cancel / error url for the signature. Default is successUrl.
   */
  getDigitalSignUrl(t = null, e = null, a = null, n = null, i = null) {
    const r = n || (parent !== window ? document.referrer : null);
    return this.getServerAddress() + "/onboarding/DigitalSignatureBegin?id=" + this.model.owner + "|" + this.id + "&signerPersonalId=" + (e || this.model.signature.personalId || "") + "&testSignerPersonalId=" + (a || "") + "&authService=" + (t || "") + "&timestamp=" + Date.now() + (r ? "&successUrl=" + encodeURIComponent(r) : "") + (i ? "&cancelUrl=" + encodeURIComponent(i) : "");
  }
  /**
   * Gets the PDF preview address taking into account potential changes in the model.
   * @param asUntrusted - Boolean indicating if the return url should be returned as untrusted (not wrapped).
   * By default, the url is returned as trusted url.
   * @returns Url address
   */
  getPdfPreviewAddress(t = !1) {
    let e = "";
    this.model?.owner && this.id && (e = this.model.owner + "|" + this.id);
    const a = `${this.getServerAddress()}/onboarding/GetAuthorizationPdfPreview?id=${e}&signer.personalId=${this.model.signature.personalId || ""}`;
    return (!this.lastPdfPreviewUrl || this.lastPdfPreviewUrl.url !== a) && (this.lastPdfPreviewUrl = {
      url: a,
      sce: this.$sce.trustAsResourceUrl(a)
    }), t ? this.lastPdfPreviewUrl.url : this.lastPdfPreviewUrl.sce;
  }
  /**
   * Controllers can subscribe to changes in service data using this method.
   * Read more about the pattern in: http://www.codelord.net/2015/05/04/angularjs-notifying-about-changes-from-services-to-controllers/
   * @param scope Controller scope for the subscribing controller (or directive etc.)
   * @param callback The event listener function. See $on documentation for details
   */
  subscribe(t, e) {
    const a = this.$rootScope.$on("onboarding-service-event", e);
    t.$on("$destroy", a);
  }
  /**
   * Opens customer wizard as modal dialog.
   * @param accountId - Optional accountId for existing company.
   */
  launchCustomerOnboarding(t) {
    return this.getOnboardingDataForAccount(t).then(() => this.model ? this.model : (this.model = {
      accountType: Ws.Company,
      signature: {}
    }, this.id = null, this.save())).then(() => (this.model.accountType = Ws.Company, this.uiHelpers.showDialog(
      "salaxy-components/modals/onboarding/customer/index.html",
      "CustomerOnboardingController",
      null,
      null,
      "lg"
    )));
  }
  /**
   * Shows the current customer invitation as modal dialog.
   * @param accountId - AccountId for existing company.
   */
  showCustomerInvitation(t) {
    return this.getOnboardingDataForAccount(t).then(() => this.model.id ? this.model : this.save()).then(() => this.uiHelpers.showDialog(
      "salaxy-components/modals/onboarding/customer/invitation.html",
      "CustomerOnboardingController",
      null,
      null,
      "lg"
    ));
  }
  /**
   * Opens a generic wizard as modal dialog.
   * If account type is known, opens the the wizard for that type.
   * @param id - Optional onboarding id for existing onboarding.
   * @param isModelLoaded  - If true, the method does not load the model from backend any more.
   */
  launchGenericOnboarding(t = null, e = !1) {
    (e ? Promise.resolve(this.model) : this.getOnboardingData(t)).then(() => {
      this.launchOnboardingOfType(this.model.accountType, t, !0) || this.uiHelpers.showDialog(
        "salaxy-components/modals/onboarding/generic/index.html",
        null,
        {
          launch: (n) => {
            this.launchOnboardingOfType(this.model.accountType, t, !0) && n();
          },
          model: this.model
        },
        null
      );
    });
  }
  /**
   * Launches an onboarding of a type if type is specific.
   * @param role Role that is evaluated: Launched if it matches one of the specific roles.
   * Does not start onboarding if role is None / null etc.
   * @param id Identifier of onboarding object.
   * @param isModelLoaded If true, the model is already loaded.
   * @returns True if the dialog is launched.
   */
  launchOnboardingOfType(t, e = null, a = !1) {
    switch (this.model.accountType) {
      case Ws.Company:
        return this.launchCompanyOnboarding(e, a), !0;
      case Ws.Household:
        return this.launchHouseholdOnboarding(e, a), !0;
      case Ws.Worker:
        return this.launchWorkerOnboarding(e, a), !0;
      default:
        return !1;
    }
  }
  /**
   * Opens worker wizard as modal dialog.
   * @param id - Optional onboarding id for existing worker.
   * @param isModelLoaded  - If true, the method does not load the model from backend any more.
   */
  launchWorkerOnboarding(t = null, e = !1) {
    return this.launchOnboarding(Ws.Worker, "salaxy-components/modals/onboarding/worker/index.html", "WorkerOnboardingController", t, e);
  }
  /**
   * Opens company wizard as modal dialog.
   * @param id - Optioanl onboarding id for existing company.
   * @param isModelLoaded  - If true, the method does not load the model from backend any more.
   */
  launchCompanyOnboarding(t = null, e = !1) {
    return this.launchOnboarding(Ws.Company, "salaxy-components/modals/onboarding/company/index.html", "CompanyOnboardingController", t, e);
  }
  /**
   * Opens household wizard as modal dialog.
   * @param id - Optioanl onboarding id for existing company.
   * @param isModelLoaded  - If true, the method does not load the model from backend any more.
   */
  launchHouseholdOnboarding(t = null, e = !1) {
    return this.launchOnboarding(Ws.Household, "salaxy-components/modals/onboarding/household/index.html", "HouseholdOnboardingController", t, e);
  }
  /**
   * Opens a simple signature page for federation (currently for Raksa / Palkkamylly only)
   * @param id - Optioanl onboarding id for existing person.
   * @param isModelLoaded  - If true, the method does not load the model from backend any more.
   */
  launchFederateSign(t = null, e = !1) {
    return this.launchOnboarding(Ws.Worker, "salaxy-components/modals/onboarding/palkkamylly/federate-sign.html", "WorkerOnboardingController", t, e);
  }
  launchOnboarding(t, e, a, n = null, i = !1, r = null) {
    return (i ? Promise.resolve(this.model) : this.getOnboardingData(n)).then(() => (this.model.accountType = t, this.uiHelpers.showDialog(
      e,
      a,
      r,
      null,
      "lg"
    )));
  }
  notify() {
    this.$rootScope.$emit("onboarding-service-event");
  }
  getServerAddress() {
    return this.serverAddress ? this.serverAddress.replace(/\/+$/, "") : this.sessionService.getServerAddress();
  }
  /**
   * Continues based on returnUrl parameter from the current url.
   */
  launchReturnUrlOnboarding() {
    const t = this.getReturnUrlOnboardingParameters();
    t && (() => {
      const a = this.readTokenFromUrl("ob_token=");
      return a ? (this.ajax.setCurrentToken(a), this.sessionService.checkSession()) : Promise.resolve();
    })().then(() => {
      switch (t.onboardingType) {
        case "company":
          this.launchCompanyOnboarding(t.id);
          break;
        case "household":
          this.launchHouseholdOnboarding(t.id);
          break;
        case "worker":
          this.launchWorkerOnboarding(t.id);
          break;
        case "customer":
          this.launchOnboarding(Ws.Company, "salaxy-components/modals/onboarding/customer/index.html", "CustomerOnboardingController", t.id);
          break;
      }
      this.$rootScope.$evalAsync(() => {
        this.$location.path("/");
      });
    });
  }
  getReturnUrlOnboardingParameters() {
    let t = this.$location.url();
    if (t.indexOf("/onboarding/") !== 0 && (t = this.readTokenFromUrl("url="), !t || t.indexOf("/onboarding/") !== 0))
      return null;
    const e = t.substr(12).split("/");
    if (e.length < 2)
      return;
    const a = e[0], n = e[1].split("&")[0];
    return {
      onboardingType: a,
      id: n
    };
  }
  readTokenFromUrl(t) {
    const e = this.$location.url(), a = e.toLowerCase().indexOf(t);
    if (a >= 0) {
      const n = e.indexOf("&", a);
      return n >= 0 ? e.substring(a + t.length, n) : e.substring(a + t.length);
    }
    return null;
  }
  init() {
    this.$rootScope.$on("$locationChangeStart", () => {
      this.launchReturnUrlOnboarding();
    });
  }
};
RC.$inject = ["$rootScope", "$sce", "Onboardings", "SessionService", "UiHelpers", "AjaxNg1", "$location"];
let Zv = RC;
const YC = class YC {
  /**
   * Creates a new instance of the PartnerService with dependency injection.
   */
  constructor(t, e) {
    this.sessionService = t, this.uiHelpers = e;
  }
  /**
   * Shows a dialog for brand selection.
   * The result may be "ok" for selected brand or "set-default" for reset to original brand.
   */
  showBrandSelection() {
    const t = {
      brand: null
    };
    return this.uiHelpers.openEditDialog("salaxy-components/modals/settings/BrandSelection.html", t, null).then((e) => ({
      action: e.action,
      hasChanges: e.hasChanges,
      logic: e.logic,
      result: e.result,
      item: e.result == We.Ok ? e.item.brand : null
    }));
  }
  /**
   * Shows a dialog for switching the CSS.
   */
  showSwitchCss() {
    this.showBrandSelection().then((t) => {
      t.result == We.Ok ? (this.overrideSkin = t.item.data.skin, this.overridePartnerId = t.item.id, this.sessionService.switchCss(t.item.data.skin)) : t.result == "set-default" && (this.overrideSkin = null, this.overridePartnerId = null, this.sessionService.switchCss(null));
    });
  }
  /**
   * Temporary method only used in development
   * Shows a dialog for switching the CSS.
   */
  showSwitchCssDev() {
    this.showBrandSelection().then((t) => {
      t.result == We.Ok ? (this.overrideSkin = t.item.data.skin, this.overridePartnerId = t.item.id, this.sessionService.switchCss(t.item.data.skin, !0)) : t.result == "set-default" && (this.overrideSkin = null, this.overridePartnerId = null, this.sessionService.switchCss(null, !0));
    });
  }
};
YC.$inject = ["SessionService", "UiHelpers"];
let tx = YC;
const _C = class _C {
  /**
   * Creates a new instance of ReportsService
   * @param $rootScope - Angular rootscope.
   * @param sessionService - Session service notifies when the user is known to be authenticated.
   * @param uiHelpers - Salaxy ui helpers service.
   * @param reportsApi - The Reports API that is used to communicating with the server.
   * @param $sce - $sce is a service that provides Strict Contextual Escaping services to AngularJS
   */
  constructor(t, e, a, n, i) {
    this.sessionService = e, this.uiHelpers = a, this.reportsApi = n, this.$sce = i, this.currentReportType = null, this.reportMetadataCache = {}, this.refresh(), e.subscribe(t, () => {
      this.refresh();
    });
  }
  /**
   * Clear metadata cache.
   */
  refresh() {
    if (this.sessionService.isSessionChecked && this.sessionService.isAuthenticated) {
      const t = this.sessionService.session.currentAccount.owner;
      this.reportMetadataCache.owner != t && (this.reportMetadataCache = { owner: t });
    } else
      this.reportMetadataCache = {};
  }
  /**
   * Gets a list of reports (metadata only) filtered by a report type.
   * @param type - Type of report. See type (string enumeration) for possible values.
   * Also supports value "current" for showing reports defined by currentReportType.
   * @returns A Promise with result data (<Report[]) if dataset not fetched, else the fetched dataset
   */
  getReports(t) {
    if ((!t || t === "current") && (t = this.currentReportType), !t || t === "undefined")
      return [];
    let e = this.reportMetadataCache[t];
    return e || (e = [], this.reportMetadataCache[t] = [], this.reportsApi.getReportsByType(t).then((a) => (this.reportMetadataCache[t] = a, a)));
  }
  /**
   * Gets a link URL for a yearly report. This is a full link with token and absolute URL.
   * @param type - Type of the report must be one of the yearly reports
   * @param year - Year for the report
   * @param id - Worker ID for those reports that are specific to one Worker.
   * @param id2 - Second Worker ID for those reports that have two Workers in one report
   * @returns Yearly report URL string
   */
  getYearlyReportUrl(t, e, a, n) {
    return this.sessionService.getServerAddress() + vv.getYearlyReportUrl(t, e, this.sessionService.getCurrentToken(), a, n);
  }
  /**
   * Gets a. URL for a calculation pdf.
   * If report has not been saved (ID is null), returns null.
   * @param reportType - Type of report
   * @param calcId - Identifier of the calculation. This method requires that the calculation has been saved.
   * @param inline - If true, the Content-Disposition header is returned with inline parameter.
   * @returns Url for specified report
   */
  getPdfUrlForCalc(t, e, a = !1) {
    return e ? this.sessionService.getServerAddress() + vv.getCalcPdfUrl(t, e, a, this.sessionService.getCurrentToken()) : null;
  }
  /**
   * Gets an URL for pdf report for one or more calculations.
   * @param type - Type of report
   * @param ids - Identifiers of the calculations. This method requires that the calculations have been saved.
   * @param inline - If true, the Content-Disposition header is returned with inline parameter.
   * @returns Url for specified report
   */
  getPdfUrlForCalcs(t, e, a = !1) {
    return !e || e.length === 0 ? null : this.sessionService.getServerAddress() + `/v03/api/reports/assure-pdf/${t}?ids=${e.join("&ids=")}&disposition=${a ? "inline" : "attachment"}&access_token=${encodeURIComponent(this.sessionService.getCurrentToken())}`;
  }
  /**
   * Show a report modal (a preview modal dialog) for a given calculation.
   * The calculation may not be stored to backend. I.e. this reporting method is available also to
   * non-authenticated users unlike the more resource intensive methods that generate PDF-files and require CRUD rights.
   * @param reportType - Type of the report to show.
   * @param calculation - Calculation to show in the report.
   * @param view - The default view shown in the UI: "page1" (default), "partial" or "full".
   * @param preview - If true, adds the preview watermark to the report.
   */
  showReportModalForCalc(t, e, a = "page1", n = !1) {
    const r = {
      reportType: t,
      calcs: [e],
      view: a,
      preview: n
    };
    this.uiHelpers.showDialog(
      "salaxy-components/modals/calc/CalcReports.html",
      null,
      r,
      null,
      "xl",
      !0
    );
  }
  /**
   * Gets the monthly / quarterly/ yearly accounting data for the current account.
   * @param refDate - Reference date for the period. Please note that even if the date is not the first day of the given period, the entire period is returned.
   * @param tableType  - Accounting table type.
   * @param periodType - Month, quarter, year or a custom period. The custom period requires endDate. Default value is the month.
   * @param endDate - End date for the period. Required only for the custom period.
   * @returns A Promise with result data (Raw data for accounting purposes).
   */
  getAccountingReportTableForPeriod(t, e = Cb.Classic, a = Wi.Month, n = null) {
    return this.reportsApi.getAccountingReportTableForPeriod(t, e, a, n);
  }
  /**
   * Experimental: Gets the accounting report based on given set of calculations.
   * @param calculationIds - Calculations that are the bases for the report.
   * @param tableType  - Accounting table type.
   * @returns Account report based on the calculations.
   * @ignore
   */
  getAccountingReportTableForCalculationIds(t, e = Cb.Classic) {
    return this.reportsApi.getAccountingReportTableForCalculationIds(t, e);
  }
  /**
   * Experimental: Gets the accounting report based on given set of calculations.
   * @param calculations - Calculations that are the bases for the report.
   * @param tableType  - Accounting table type.
   * @returns Account report based on the calculations.
   * @ignore
   */
  getAccountingReportTableForCalculations(t, e = Cb.Classic) {
    return this.reportsApi.getAccountingReportTableForCalculations(t, e);
  }
  /**
   * Gets an HTML report based on Calculation ID and runs it through $sce.
   * @param reportType - Type of the report to fetch. See the HtmlReportType enumeration for possible values.
   * @param calculationId - GUID for the calculation
   * @returns A Promise with result HTML - already run through $sce.
   */
  getReportHtmlById(t, e) {
    return this.reportsApi.getReportHtmlById(t, e).then((a) => this.$sce.getTrustedHtml(a));
  }
};
_C.$inject = ["$rootScope", "SessionService", "UiHelpers", "Reports", "$sce"];
let ex = _C;
const OC = class OC {
  /**
   * Creates a new instance of RowTypeService
   */
  constructor(t, e) {
    this.settingsService = t, this.session = e, this.listCache = null;
  }
  /**
   * Gets a cached version of CalcRowsLogic with current settings (if available).
   */
  get logic() {
    return this.session.isInRole("household") ? (this._logic || (this.refresh(), this._logic = new Gi("household")), this._logic) : this.isReady ? (this._logic || (this.refresh(), this._logic = new Gi(this.settingsService.current)), this._logic) : new Gi("company");
  }
  /** Clears the cache and reloads the row types (from settings service singleton, not all the way from the server). */
  refresh() {
    this._logic = null, this.timestamp = (/* @__PURE__ */ new Date()).toLocaleTimeString();
  }
  /**
   * If true, the custom row types (currently in settings) have been loaded from the server.
   */
  get isReady() {
    return !!this.settingsService.current;
  }
  /**
   * Gets a filtered list of row types configs
   * @param group If specified, filters the configs by group (builtIn, custom).
   */
  getConfigs(t, e) {
    let a = this.configs;
    t && (a = a.filter((i) => i.group === t)), e && e.length > 0 && (a = a.filter((i) => e.indexOf(i.category) >= 0));
    const n = [
      Wt.PaidSickLeaveSalary,
      Wt.PaidSickLeaveHourlySalary,
      Wt.PaidSickLeaveMonthlySalary,
      Wt.TrainingSalary,
      Wt.TrainingHourlySalary,
      Wt.TrainingMonthlySalary,
      Wt.ServiceCharge
    ];
    return a = a.filter((i) => !(n.indexOf(i.name) >= 0)), this.session.isInSomeRole("pro,admin") || (a = a.filter((i) => i.name != Wt.Service)), a;
  }
  /** Gets a cached list of all configs (even the ones that should typically be hidden from the list by role or because they are obsolete). */
  get configs() {
    if (!this.listCache || this.listCache.key !== this.timestamp) {
      const t = this.logic.getRowConfigs();
      this.listCache = { key: this.timestamp, value: t };
    }
    return this.listCache.value;
  }
  /** Gets the editble rows collection. */
  get allCustomRows() {
    return this.settingsService.current?.calc.salaryDefaults ?? [];
  }
  /**
   * Gets the configuration for a row: May be built-in or custom row type..
   * @param row Row for which to get the configuration.
   * @returns A configuration if found, otherwise undefined.
   */
  getConfig(t) {
    if (!t)
      return;
    if (t.source == On.CustomRowtype)
      return t.config;
    let e;
    if (t.type?.startsWith("/")) {
      if (e = this.logic.getRowConfigs().find((a) => a.type == t.type), e)
        return e;
      console.warn(`Unable to find the row based on the new type '${t.type}' => Fall back to rowType based resolve.`);
    }
    return e = this.logic.getRowConfig(t.rowType), e || console.error(`Row type '${t.rowType}' not found in the row type definitions.`), e;
  }
  /**
   * Deletes an item in the allCustomRows collection.
   * This does not yet save the changes or even refresh the cache.
   */
  deleteRow(t) {
    const e = this.allCustomRows.indexOf(t);
    e >= 0 && this.allCustomRows.splice(e, 1);
  }
  /** Saves the current, potentitally modified set of custom rows. */
  async save() {
    this.settingsService.saveWithoutSessionCheck(), this.refresh();
  }
  /**
   * Call this method when a new row is created to apply the default values.
   */
  applyDefaultsToNewRow(t, e) {
    if (!t || !t.rowType)
      return;
    const a = this.getConfig(t);
    a.amount.default && (t.count = a.amount.default), a.price.default && (t.price = a.price.default);
    const n = this.specialKnownRowTypesAtSalaryDate(e);
    if (n[a.name] && (t.price = n[a.name]), a.group == "custom") {
      const i = this.allCustomRows.find((r) => r.source == On.CustomRowtype && r.type == a.type);
      i && (a.label && (t.message = a.label), i.message && (t.message = i.message), i.count && (t.count = i.count), i.price && (t.price = i.price), i.unit && (t.unit = i.unit), i.accounting && (t.accounting = i.accounting), i.data && (t.data = i.data));
    }
  }
  specialKnownRowTypesAtSalaryDate(t) {
    const e = gr.getYearlyChangingNumbers(t ?? "today");
    return {
      dailyAllowance: e.sideCosts.taxFreeDailyAllowance,
      dailyAllowanceHalf: e.sideCosts.taxFreeDailyHalfAllowance,
      mealCompensation: e.sideCosts.taxFreeMealAllowance
    };
  }
};
OC.$inject = ["SettingsService", "SessionService"];
let ax = OC;
const rc = class rc {
  constructor(t, e, a, n, i, r, l, o, c, d) {
    this.$rootScope = t, this.sessionApi = e, this.accountApi = a, this.$window = n, this.$location = i, this.ajax = r, this.$timeout = l, this.alertService = o, this.workers = c, this.$locale = d, this.personAccount = null, this.companyAccount = null, this.clientRoles = [], this.workerLangs = {}, this.subscribeToLocationChange();
  }
  /**
   * Initializes the session service.
   * Note that the session loading will currently begin already in constructor.
   */
  init() {
    this.alertService.init();
  }
  /**
   * Controllers can subscribe to changes in service data using this method.
   * Read more about the pattern in: http://www.codelord.net/2015/05/04/angularjs-notifying-about-changes-from-services-to-controllers/
   * @param scope - Controller scope for the subscribing controller (or directive etc.)
   * @param callback - The event listener function. See $on documentation for details
   */
  subscribe(t, e) {
    const a = this.$rootScope.$on("session-service-event", e);
    t.$on("$destroy", a);
  }
  /**
   * Services can subscribe to this event to be notified when it is known that there is an authenticated session
   * (as opposed to anonymous session). Uses the same pattern as subscribe.
   * @param scope - Controller scope for the subscribing controller (or directive etc.)
   * @param callback - The event listener function. See $on documentation for details
   */
  onAuthenticatedSession(t, e) {
    const a = this.$rootScope.$on("session-auth-session-event", e);
    t.$on("$destroy", a);
  }
  /**
   * If true, the session is loading: Session, i18n files, service model or something else
   * that may break the entire user interface is (re)loading: User interface should show a loader.
   * Note that isSessionChecking overrides the set value in getter.
   */
  get isLoading() {
    return this._isLoading || this.isSessionChecking;
  }
  set isLoading(t) {
    this._isLoading = t;
  }
  /** If true, the user is authenticated */
  getIsAuthenticated() {
    return this.isAuthenticated;
  }
  /** If true, the session has been checked from the server */
  getIsSessionChecked() {
    return this.isSessionChecked;
  }
  /** If true, the session call is progressing */
  getIsSessionChecking() {
    return this.isSessionChecking;
  }
  /** Avatar to show in the login screen */
  getAvatar() {
    return this.avatar;
  }
  /** The full session objcet */
  getSession() {
    return this.session;
  }
  /** Gets either the Company account or PErson account depending of the type of the current account. */
  getCurrentAccount() {
    return this.getCompanyAccount() || this.getPersonAccount();
  }
  /** Get the person account object if the currently selected account is a person */
  getPersonAccount() {
    return this.personAccount;
  }
  /** The company account object if the currently selected account is a company */
  getCompanyAccount() {
    return this.companyAccount;
  }
  /** Gets the address for the API server where the session is connected */
  getServerAddress() {
    return this.sessionApi.getServerAddress();
  }
  /**
   * Returns current access token
   */
  getCurrentToken() {
    return this.ajax.getCurrentToken();
  }
  /**
   * Checks whether the user is in a given role
   * @param role - One of the known roles or role from server.
   * You can also use exclamation mark for negative (e.g. "!test")
   * @returns True if user is in the given role,
   * or if given roles is null/empty.
   */
  isInRole(t) {
    return Md.isInRole(this.getSession(), this.getAppStatus(), t);
  }
  /**
   * Checks if the user is in ANY of the roles.
   * @param commaSeparatedRolesList - Array of roles or comma separated string containing role names.
   * @returns True if user is in one of the given roles,
   * or if given roles is null or an empty array.
   */
  isInSomeRole(t) {
    return Md.isInSomeRole(this.session, this.getAppStatus(), ie.assureArray(t));
  }
  /**
   * Tests if the current account has ALL the given roles.
   * @param accountRoles - Array of roles.
   * @returns Returns true if the account has all the given roles,
   * or if given roles is null or an empty array.
   */
  isInAllRoles(t) {
    return Md.isInAllRoles(this.session, this.getAppStatus(), t);
  }
  /** Posts a message to the parent window. The message is sent as salaxySessionEvent  */
  postMessageToParent(t) {
    window.parent !== window && window.parent.postMessage && window.parent.postMessage({ salaxySessionEvent: t }, "*");
  }
  /**
   * Checks the current session from the server if user has token (either in-memory or in cookie)
   * @returns A Promise with result data (UserSession)
   */
  checkSession() {
    this.isSessionChecking = !0;
    let t = this.ajax.getCurrentToken();
    if (Vo.validate(t) !== "ok" && (t = null, this.ajax.setCurrentToken(t)), !t)
      return this.isSessionChecked = !0, this.isAuthenticated = !1, this.avatar = null, this.session = null, this.setLanguageForSession(), this.companyAccount = null, this.notify(), this.isSessionChecking = !1, new Promise((n) => {
        this.$timeout(() => {
          n(null);
        });
      });
    const e = this.resolveCss(), a = e?.startsWith("/dev-skins");
    return this.switchCss(e, a), this.sessionApi.getSession().then((n) => this.setSession(n));
  }
  /**
   * Sets the session to a session object that has already been fetched from the server.
   * Note that the caller should also set the token to Ajax.
   * @param session - Session object to set as current session.
   */
  setSession(t) {
    if (this.isSessionChecking = !1, this.isSessionChecked = !0, t)
      if (this.isAuthenticated = t.isAuthorized, this.avatar = t.avatar, this.session = t, this.setLanguageForSession(), this.session.isAuthorized) {
        const e = t.currentAccount.entityType;
        return e === "company" ? this.companyAccount = this.session.currentAccount : e === "person" && (this.personAccount = this.session.currentAccount), this.notify(), this.notifyAuthenticatedSession(), this.postMessageToParent("success"), this.session;
      } else
        return this.notify(), this.postMessageToParent("failure"), this.session;
    else
      return this.isAuthenticated = !1, this.avatar = null, this.session = null, this.companyAccount = null, this.notify(), this.postMessageToParent("failure"), t;
  }
  /**
   * Switches the current web site usage role and refreshes the session.
   * @param role - household or worker.
   * @returns A Promise with result data (new role as string)
   */
  switchRole(t) {
    return this.accountApi.switchRole(t).then((e) => this.checkSession().then(() => e));
  }
  /**
   * Sends the browser to standard Sign-in page on Salaxy API server.
   * @param redirectUrl - The URL where the user is taken after a successfull login
   * @param role - Optional role (household, worker or company) for the situations where it is known - mainly for new users
   * @param partnerSite Identifier of the partner or service model from which the login UI is fetched.
   * @param urlPostfix Additional string that is added to the OAuth2 URL.
   * Used in adding other parameters to the URL, e.g. "&salaxy_language=en"
   */
  signIn(t = null, e = null, a = null, n = null) {
    this.authorize(t, e, a, kL.Sign_in, n);
  }
  /**
   * Sends the browser to standard signUp / register page on Salaxy API server.
   * @param redirectUrl - The URL where the user is taken after a successfull login
   * @param role - Optional role (household, worker or company) for the situations where it is known - mainly for new users
   * @param partnerSite Identifier of the certified partner which should be granted access rights in account creation.
   * Also sets SignIn dialog and onboarding wizard UI skin.
   * @param urlPostfix Additional string that is added to the OAuth2 URL.
   * Used in adding other parameters to the URL, e.g. "&salaxy_language=en"
   */
  register(t = null, e = null, a = null, n = null) {
    this.authorize(t, e, a, kL.Sign_up, n);
  }
  /**
   * Sends the user to the Sign-out page
   * @param redirectUrl - URL where user is redirected after log out.
   * Must be absolute URL. Default is the root of the current server.
   */
  signOut(t) {
    this.ajax.setCurrentToken(null);
    const e = () => window.location.protocol + "//" + window.location.hostname + (window.location.port ? ":" + window.location.port : ""), a = new RegExp(/www2\./, "ig");
    t = (t || e()).replace(a, "www."), this.checkSession().then(() => {
      this.$window.location.href = t;
    });
  }
  /**
   * Returns true if the current authenticated user has signed the contract.
   */
  isSigningOk() {
    return !!(this.session && this.session.currentAccount && this.session.currentAccount.identity.contract && this.session.currentAccount.identity.contract.isSigned);
  }
  /**
   * Returns true if the current authenticated user has signed the contract
   * OR if the user does not have session OR if user is anonymous.
   */
  checkAccountVerification() {
    return !!(!this.session || !this.session.currentAccount || this.session.currentAccount.identity.contract && this.session.currentAccount.identity.contract.isSigned);
  }
  /**
   * Gets the application status that supports the UserSession object by providing additional
   * information about the status of fetching the session, data, expiration etc.
   */
  getAppStatus() {
    let t = null;
    const e = Ne.current;
    e && e.isTestData != null && (t = e.isTestData);
    const a = wt.copy(this.clientRoles ?? []);
    return {
      sessionCheckInProgress: this.getIsSessionChecking() || !this.getIsSessionChecked(),
      clientRoles: a,
      isTestData: t
    };
  }
  /**
   * TODO: Encapsulate this functionality to Ui-customization service. MJ
   *
   * Switches the CSS link to partner-specific CSS.
   * @param cssUrl URL for the CSS file. Typically, "css/skins/${skin}.css"
   * @param useDevelopmentFolder If true, uses the local css file (development environment only).
   * By default, uses the CDN.
   */
  switchCss(t, e = !1) {
    const n = document.getElementById("salaxyMainCss");
    n && (t = t || "css/skins/palkkaus.css", e ? t = t.replace("css/skins", "/dev-skins") : t = this.convertSkinPath(t || "css/skins/palkkaus.css"), n.href !== t && (this.isInRole("test") && !this.isInRole("pro") && window.sessionStorage.setItem(rc.SKIN_SESSION_STORAGE, t), n.href = t));
  }
  /**
   * Resolves current css cdn url with following priority:
   * 1. Url (https://test-yritys.palkkaus.fi/embedded.html?skin=emu#/)
   * 2. Token (Token.parsePayload(token))
   * @returns cdn url to css
   */
  resolveCss() {
    if (this.isInRole("test")) {
      const e = new URLSearchParams(window.location.search);
      if (e.has("skin"))
        return `https://cdn.salaxy.com/skins/bs5/${e.get("skin")}.css`;
      if (e.has("skin-dev"))
        return `/dev-skins/${e.get("skin-dev")}.css`;
    }
    const t = this.ajax.getCurrentToken();
    return this.isInRole("test") && !this.isInRole("pro") ? window.sessionStorage.getItem(rc.SKIN_SESSION_STORAGE) || Vo.parsePayload(t).account_partner_css : Vo.parsePayload(t).account_partner_css;
  }
  /**
   * Parses name of current skin from cdn url
   * @returns name of current skin
   */
  getCurrentCss() {
    const t = document.getElementById("salaxyMainCss")?.href || document.getElementById("salaxyForcedCss")?.href;
    return t?.substring(t?.lastIndexOf("/") + 1)?.replace(/\.[^/.]+$/, "");
  }
  /**
   * Get report lang
   * @param workerId optional workerId to get worker
   * @returns report lang
   */
  getReportLang(t = null) {
    let e = this.session?.currentAccount?.language ?? Me.Fi;
    return e = e === Me.Default ? Me.Fi : e, t ? this.workerLangs[t] ? Promise.resolve(this.workerLangs[t]) : this.workers.getSingle(t).then((a) => {
      const n = a?.language ?? e;
      return this.workerLangs[t] = n === Me.Default ? e : n, this.workerLangs[t];
    }) : Promise.resolve(e);
  }
  // TODO: This method should return an array of channels
  /** Returns the owned payment channel for the current account. */
  getOwnedPaymentChannel() {
    const t = {
      FI03POYA0003689675: At.AccountorGo,
      // Accountor
      FI15POYA0008369224: At.FinagoSolo,
      // FinagoSolo
      FI06POYT0009439335: At.Kevytyrittaja,
      // Kevytyrittaja
      FI14POYA0028382282: At.Askelma,
      // Askelma
      FI33POYB0024403824: At.Briox,
      // Briox
      FI42POYT0025991058: At.Lemonaid,
      // LemonTree
      FI71POYL0029361387: At.Laskupiste,
      // Laskupiste
      FI43POY10010435606: At.PasseliMerit,
      // PasseliMerit
      FI79POYA0034612101: At.Odoo,
      // Odoo
      FI86POYF0022398945: At.Hausvise,
      // Festum
      FI11POYE0009680831: At.Ecom,
      // Ecom
      ...Ne.current?.isTestData === !0 ? { FI88POYP0010378082: At.Kompassi } : { FI15POYY0010378082: At.Kompassi },
      // Kompassi
      FI23POY10006460809: At.Domus,
      // Tietoaika
      FI24POYH0021937564: At.Holvi,
      // Holvi
      FI88POYT0025514542: At.TalenomOnline,
      // Talenom
      FI53POYS0025543933: At.PalkkausWS,
      // SPL
      FI51POYT0031925356: At.TalenomManual
      // TalenomManual
    };
    return this.session && this.session.currentAccount && t[this.session.currentAccount.id] || null;
  }
  /**
   * Does a "soft refresh" of the AngularJS user interface by setting isLoading flag to
   * true and then false after digest loop has run. Layouts should implement this in a way
   * that all views are destroyed and then recreated.
   */
  refreshUi() {
    this.isLoading = !0, this.$timeout(() => {
      this.isLoading = !1;
    });
  }
  /**
   * Sets the language of the session for the given language.
   * Also loads the dictionary for the language if not already loaded.
   * @param lang Language to set.
   */
  setLanguage(t) {
    (!t || t === Me.Default) && (t = Me.Fi), this.isLoading = !0, L.loadLanguage(t).then(() => {
      L.setLanguage(t), L.instance.setTerms(this.session?.settings?.partner?.serviceModel?.site?.texts), this.$locale.DATETIME_FORMATS.MONTH = ie.getRange(1, 12).map((e) => L.get(`SALAXY.ENUM.CalendarMonth.month${e}.label`)), this.$locale.DATETIME_FORMATS.SHORTDAY = [L.get("SALAXY.ENUM.Weekday.day7.short"), ...ie.getRange(1, 6).map((e) => L.get(`SALAXY.ENUM.Weekday.day${e}.short`))], this.refreshUi();
    });
  }
  /** Parses origin url from $location*/
  getOrigin() {
    let t = this.$location.absUrl();
    this.$location.path() != "/" && (t = t.replace(this.$location.path(), "")), t.charAt(t.length - 1) == "/" && (t = t.slice(0, -1)), t.charAt(t.length - 1) == "#" && (t = t.slice(0, -1));
    const e = t.split("/");
    return (e[e.length - 1].toLowerCase().includes(".html") || e[e.length - 1].toLowerCase().includes(".aspx")) && (t = t.replace(e[e.length - 1], "")), t.charAt(t.length - 1) != "/" && (t = t + "/"), t;
  }
  /**
   * Determines whether the customer is a cfa customer.
   * @returns A boolean value indicating whether the customer is a cfa customer.
   */
  get isCfaCustomer() {
    return !!this.session?.settings?.paymentChannels?.some((t) => ne.isCfa(t));
  }
  /** get kyc state */
  get kycState() {
    return this.isCfaCustomer ? this.session?.currentAccount?.identity?.kycUpdatedAt ? I.isBefore(this.session.currentAccount.identity.kycUpdatedAt, I.add(I.getToday(), -10, "month")) ? "expired" : "valid" : "missing" : "ignored";
  }
  /** returns last updated at for kyc. */
  get kycUpdatedAt() {
    return this.session?.currentAccount?.identity?.kycUpdatedAt;
  }
  /** returns expiration date for kyc. */
  get kycExpiresAt() {
    const t = this.session?.currentAccount?.identity?.kycUpdatedAt;
    return t ? I.add(I.asDate(t), 12, "month") : "";
  }
  /**
   * Parsers given roles from the access token.
   * Returns the first found role from the list in order.
   * @param roles Comma separated list of roles or array of roles.
   */
  parseRoleFromAccessToken(t) {
    if (!t)
      return null;
    const e = ie.assureArray(t);
    if (!t.length)
      return null;
    const a = this.ajax.getCurrentToken();
    if (!a)
      return null;
    const i = (Vo.parsePayload(a).scope ?? "").split(" ");
    for (const r of e)
      switch (r) {
        case "pro":
          if (i.indexOf("pro:on_behalf_of") > -1)
            return r;
          break;
        case "admin":
          if (i.indexOf("admin:on_behalf_of") > -1)
            return r;
          break;
      }
    return null;
  }
  notify() {
    this.$rootScope.$emit("session-service-event");
  }
  notifyAuthenticatedSession() {
    this.$rootScope.$emit("session-auth-session-event");
  }
  /**
   * Sends the browser to standard Sign-in page on Salaxy API server.
   * @param redirectUrl The URL where the user is taken after a successfull login.
   * @param role Optional role (household, worker or company) for the situations where it is known - mainly for new users.
   * @param partnerSite The partner site is passed as client_id to the sign-in process.
   * @param mode Salaxy login mode: "sign_in" or "sign_up".
   * @param urlPostfix Additional string that is added to tha URL.
   * Used in adding other parameters to the URL, e.g. "&salaxy_language=en"
   */
  authorize(t = null, e = null, a = null, n = null, i = null) {
    const r = Ne.current, l = a || this.partnerSite || r?.partnerSite || "unknown";
    if ((i || "").indexOf("salaxy_skin") === -1) {
      const c = this.getCurrentCss();
      c && (i = `${i || ""}&salaxy_skin=${c}`);
    }
    const o = this.sessionApi.getSignInAddress(t, e, l, n, i);
    this.$window.location.href = o;
  }
  readTokenFromUrl(t, e) {
    const a = e.toLowerCase().indexOf(t);
    if (a >= 0) {
      const n = e.indexOf("&", a);
      return n >= 0 ? e.substring(a + t.length, n) : e.substring(a + t.length);
    }
    return null;
  }
  checkSessionFromUrl() {
    const t = this.$location.url(), e = this.readTokenFromUrl("access_token=", t);
    if (e) {
      this.ajax.setCurrentToken(e);
      const a = (i, r) => {
        for (const l of i) {
          const o = new RegExp(`\\b${l}\\=[^&]+&?`);
          r = r.replace(o, "");
        }
        return r;
      }, n = (i) => (i = i.replace(/[?&]$/, "").trim(), i.endsWith("/") && !i.endsWith("#/") && (i = i.replace(/\/$/, "").trim()), i);
      return this.$rootScope.$evalAsync(() => {
        this.$location.path(n(a(["access_token", "token_type", "state", "expires_in", "scope"], this.$location.path()))).search("access_token", null).search("token_type", null).search("state", null).search("expires_in", null).search("scope", null);
      }), this.checkSession();
    } else {
      const a = this.readTokenFromUrl("error=", t);
      if (a) {
        const n = this.readTokenFromUrl("error_description=", t) || "", i = this.readTokenFromUrl("error_uri=", t) || "", r = this.readTokenFromUrl("state=", t) || "";
        return this.signInError = decodeURIComponent(a), this.signInErrorDescription = decodeURIComponent(n.replace(/\+/g, "%20")), this.$rootScope.$evalAsync(() => {
          this.$location.path(this.signInErrorUrl || "/").search("error", decodeURIComponent(a.replace(/\+/g, "%20"))).search("error_description", decodeURIComponent(n.replace(/\+/g, "%20"))).search("error_uri", decodeURIComponent(i.replace(/\+/g, "%20"))).search("state", decodeURIComponent(r.replace(/\+/g, "%20")));
        }), this.checkSession();
      }
    }
    return Promise.resolve(null);
  }
  subscribeToLocationChange() {
    this.$rootScope.$on("$locationChangeStart", () => {
      this.checkSessionFromUrl().then(() => {
        !this.isSessionChecked && !this.isSessionChecking && this.checkSession();
      });
    });
  }
  /**
   * Temporary fix to replace old skin paths "ng1/css/something.css" with the new monorepo
   * style "/skins/css/something.css" until the skin paths are fixed at the source.
   */
  convertSkinPath(t) {
    return !t || t.indexOf("skins/css/") >= 0 ? t : t && "https://cdn.salaxy.com/skins/bs5/" + t.substr(t.lastIndexOf("/") + 1);
  }
  setLanguageForSession() {
    const t = new URLSearchParams(window.location.search);
    if (t.has("lang")) {
      const e = t.get("lang")?.toLowerCase();
      if (e) {
        this.setLanguage(e);
        return;
      }
    }
    this.session?.currentAccount && this.session.currentAccount.language && this.setLanguage(this.session.currentAccount.language);
  }
};
rc.$inject = [
  "$rootScope",
  "Session",
  "Accounts",
  "$window",
  "$location",
  "AjaxNg1",
  "$timeout",
  "AlertService",
  "Workers",
  "$locale"
], rc.SKIN_SESSION_STORAGE = "salaxy.skin";
let nx = rc;
const MC = class MC {
  constructor(t, e, a, n, i, r) {
    this.sessionService = e, this.accountSettings = a, this.uiHelpers = n, this.ajax = i, this.$timeout = r, this._reportOptionsLoading = !1, this.refresh(), e.subscribe(t, () => {
      this.refresh();
    });
  }
  /** Saves the session and does the refresh, but not a complete sessionService.checkSession() as in default save().  */
  saveWithoutSessionCheck() {
    return this.accountSettings.save(this.current).then((t) => (this.current = t, t));
  }
  /** Refreshes the current settings from the server. */
  refresh() {
    if (this.sessionService.isSessionChecked && this.sessionService.isAuthenticated) {
      const t = this.sessionService.session.currentAccount.owner;
      return this.current?.owner != t && (this.reportOptions = null, this.current = null, this._reportOptionsLoading = !1), this.accountSettings.get().then((e) => (this.current = e, this.current));
    } else
      this.reportOptions = null, this.current = null, this._reportOptionsLoading = !1;
  }
  /** Saves the current settings back to storage. */
  save() {
    return this.accountSettings.save(this.current).then((t) => (this.current = t, this.sessionService.checkSession().then(() => t)));
  }
  /**
   * Creates a new IR certificate.
   * @param transferId Transfer ID for the IR certificate.
   * @param transferPassword One time transfer password for the IR certificate.
   * @returns Information about the created IR certificate.
   */
  createIrCertificate(t, e) {
    return this.accountSettings.createIrCertificate(t, e);
  }
  /**
   * Renews an existing IR certificate.
   * @returns Information about the created IR certificate.
   */
  renewIrCertificate() {
    return this.accountSettings.renewIrCertificate();
  }
  /**
   * Gets the detials of the existing IR certificate or null if no certificate exists.
   * @returns Information about the current IR certificate.
   */
  getIrCertificate() {
    return this.accountSettings.getIrCertificate();
  }
  /** Sets the eInvoice address using a dialog */
  selectEInvoiceAddress(t) {
    const e = {
      receiver: t.eInvoiceReceiver,
      intermediator: t.eInvoiceIntermediator
    }, a = {
      title: "Hae osoite Y-tunnuksella",
      officialId: this.sessionService.session.currentAccount.identity.officialId,
      isLoading: !1,
      addresses: [],
      isSelected: (n, i) => n.receiver === i.receiver,
      isAnySelected: (n) => a.addresses.some((i) => a.isSelected(n, i)),
      setCurrent: (n, i) => {
        n.receiver = i.receiver, n.intermediator = i.intermediator;
      },
      search: () => {
        a.isLoading = !0;
        const n = `/payments/einvoice/receiver?officialId=${encodeURIComponent(a.officialId)}`;
        this.ajax.getJSON(n).then((i) => {
          a.addresses = i, a.isLoading = !1;
        });
      }
    };
    return a.search(), this.uiHelpers.openEditDialog("salaxy-components/modals/account/EInvoiceAddressList.html", e, a).then((n) => (n.action === "ok" ? (t.eInvoiceReceiver = n.item.receiver, t.eInvoiceIntermediator = n.item.intermediator) : n.action === "reset" && (t.eInvoiceReceiver = null, t.eInvoiceIntermediator = null), n));
  }
  /**
   * Gets ReportOptions
   * @returns returns tempalte ReportOptions
   */
  getReportOptions() {
    if (this.reportOptions)
      return Promise.resolve(this.reportOptions);
    if (!this.sessionService?.session?.currentAccount || this.sessionService.session.currentAccount.avatar.entityType !== Xi.Company)
      return Promise.resolve({});
    if (!this._reportOptionsLoading) {
      this._reportOptionsLoading = !0;
      let e = {};
      const n = this.current?.reporting;
      n?.layoutTemplateId ? this.ajax.getJSON(`${this.ajax.serverAddress}/v03/api/settings/layout/${n.layoutTemplateId}`).then((i) => {
        i ? (e = i, n.logo && n.layoutTemplateId.toLowerCase() === "logo-report-options@FI53POYS0025543933".toLowerCase() ? n.logo.trim().startsWith("<") ? (e.logo = n.logo, this.reportOptions = e) : this.ajax.getJSON(`${this.ajax.serverAddress}/v03/api/settings/logo/${n.logo}`).then((r) => {
          r != null ? e.logo = r : e.logo = n.logo, this.reportOptions = e;
        }) : this.reportOptions = e) : this.reportOptions = e;
      }) : this.reportOptions = e;
    }
    return new Promise((e) => {
      const a = () => {
        if (this.reportOptions)
          return e(this.reportOptions);
        this.$timeout(() => a(), 50);
      };
      a();
    });
  }
};
MC.$inject = ["$rootScope", "SessionService", "AccountSettings", "UiHelpers", "AjaxNg1", "$timeout"];
let sx = MC;
class LZ {
}
const XC = class XC {
  /**
   * Creates a new instance of SignatureService
   * @param $rootScope - Angular root scope. Used for event routing
   */
  constructor(t) {
    this.$rootScope = t, this.tupasMethods = null, this.teliaMethods = null;
  }
  /**
   * Gets a list of available signature methods. Use img-property to show.
   * @param methodGroup - Method group "telia" for Telia Tunnistus and "tupas" for Visma Sign. Default is "tupas".
   */
  getMethods(t = "tupas") {
    switch (t ?? (t = "tupas"), t) {
      case "tupas":
        return this.tupasMethods ?? (this.tupasMethods = TL.getTupasMethods().map((e) => ({
          id: e.id,
          title: e.title,
          name: e.id.substr(6),
          // for backward compatibility
          value: e.id,
          img: e.img,
          isPopular: e.isPopular
        }))), this.tupasMethods;
      case "telia":
        return this.teliaMethods ?? (this.teliaMethods = TL.getTeliaMethods().map((e) => ({
          id: e.id,
          title: e.title,
          name: e.title,
          value: e.id,
          img: e.img,
          isPopular: e.isPopular
        }))), this.teliaMethods;
      default:
        return [];
    }
  }
};
XC.$inject = ["$rootScope"];
let ix = XC;
class n2 {
  constructor() {
    this.dictionary = [];
  }
  /**
   * Get dictionary
   * @returns UiTranslatorDictionaryItem array
   */
  getDictionary() {
    return this.dictionary;
  }
  /**
   * Adds item to dictionary
   * @param item item to be added to dictionary
   */
  addToDictionary(t) {
    this.dictionary.push(t);
  }
}
const GC = class GC {
  constructor(t, e, a, n) {
    this.angularUpload = t, this.ajax = e, this.$q = a, this.files = n;
  }
  /**
   * Standard upload method that uploads data as form POST (multipart/form-data)
   * @param url Service URL that receives the upload.
   * @param data The form data (including the files) that is sent to the server.
   * @param notify Optional function that is called for upload notifications: Progress and error.
   * @returns Message from server as defined by IReturnType.
   */
  upload(t, e, a) {
    return this.$q((n, i) => {
      this.angularUpload.upload({
        method: "POST",
        url: t,
        data: e,
        headers: { Authorization: "Bearer " + this.ajax.getCurrentToken() }
      }).then((r) => {
        n(r.data);
      }, (r) => {
        r = r || {};
        const l = (r.status || "ERROR") + ": " + (r.data || "No data");
        a && a(null, l), i(l);
      }, (r) => {
        const l = Math.min(100, se.round(100 * r.loaded / r.total, 0));
        a && a(l);
      });
    });
  }
  /**
   * Gets a the URL (with token) for a stream of given uploaded file.
   * @param fileId Identifier of the file.
   */
  getFileUrl(t) {
    return `${this.files.getContentUrl(t)}?access_token=${this.ajax.getCurrentToken()}`;
  }
  /**
   * Gets a preview URL (with token) for a given uploaded file.
   * @param fileId Identifier of the file.
   */
  getPreviewUrl(t) {
    return `${this.files.getPreviewUrl(t)}?access_token=${this.ajax.getCurrentToken()}`;
  }
  /**
   * Gets a language versined error description ng-file-upload invalidFile errors (client-side before actual upload).
   * @param invalidFile Invalid file of ng-file-upload component.
   * @param invalidFile.$error Error key, e.g. 'pattern', minSize' or  'maxSize'
   * @param invalidFile.$errorParam Additional error param, e.g. '50KB' or '10MB' for file sizes.
   */
  getInvalidFileDescription(t) {
    if (!t || !t.$error)
      return null;
    switch (t.$error) {
      case "pattern":
        return L.get("SALAXY.NG1.CurrentTaxCardComponent.uploadErrorFormat");
      case "minSize":
        return L.get("SALAXY.NG1.CurrentTaxCardComponent.uploadErrorSmall");
      case "maxSize":
        return L.get("SALAXY.NG1.CurrentTaxCardComponent.uploadErrorLarge");
      default:
        return L.get("SALAXY.NG1.CurrentTaxCardComponent.uploadError");
    }
  }
  /**
   * Gets a font-awesome icon for supported file types.
   * @param fileName The extension of the file name is used for determining the icon.
   */
  getFileIcon(t) {
    if (!t || t.indexOf(".") < 0)
      return "fa-exclamation-triangle";
    switch (t.substring(t.lastIndexOf(".") + 1)) {
      case "txt":
      case "text":
      case "csv":
      case "cs":
      case "css":
      case "htm":
      case "html":
      case "js":
      case "json":
      case "xml":
        return "bi-file-earmark-text";
      case "bmp":
      case "gif":
      case "jpg":
      case "jpeg":
      case "png":
      case "svg":
      case "tif":
      case "tiff":
        return "bi-image";
      case "pdf":
        return "bi-file-earmark-pdf";
      case "xls":
      case "xlsx":
        return "bi-file-earmark-excel";
      case "doc":
      case "docx":
        return "bi-file-earmark-word";
      case "zip":
        return "bi-file-earmark-zip";
      case "ppt":
      case "pptx":
        return "bi-filetype-ppt";
      default:
        return "bi-file-earmark";
    }
  }
};
GC.$inject = ["Upload", "AjaxNg1", "$q", "Files"];
let rx = GC;
const HC = class HC {
  constructor(t, e, a) {
    this.usecases = t, this.sessionService = e, this.$sce = a, this.cachedUsecases = {};
  }
  /**
   * Gets active usecases that are shown in listings (selection of usecase)
   * including type-specific default usecases (applied if no other usecase is defined).
   */
  getActiveUsecases(t = null, e = !1) {
    let n = (this.sessionService.session?.settings?.usecases || []).filter((i) => !t || t == i.itemType);
    return e && (n = n.filter((i) => i.status === Ni.Default)), n;
  }
  /**
   * Gets the active items as list items. The list of all usecases is cached.
   * @param type Type of items to fetch.
   * TODO: The method currently supports max 50 active usecases (of all types).
   */
  getActiveUsecaseListItems(t = null) {
    const e = (a) => (!t || t == a.entityType) && (a.status == Ni.Active || a.status == Ni.Default);
    return this.cachedActiveListItems ? Promise.resolve(this.cachedActiveListItems.filter(e)) : this.usecases.getOData({ $filter: "status eq 'active' or status eq 'default'" }).then((a) => (this.cachedActiveListItems = a.items, this.cachedActiveListItems.filter(e)));
  }
  /**
   * Gets the activity type of usecase from the settings.
   * @param uri Usecase URI
   * @returns Information on whether the usecase is active or not - or default usecase (also active).
   */
  getActive(t) {
    if (!t)
      return Ni.Inactive;
    t.startsWith("http") && (t = new URL(t).pathname);
    const e = this.sessionService.session?.settings?.usecases?.find((a) => a.uri == t);
    return !e || e.status === Ni.Undefined ? Ni.Inactive : e.status;
  }
  /**
   * Gets the order  of usecase from the settings.
   * @param uri Usecase URI
   * @returns Order number for the usecase, 0 if not set.
   */
  getOrder(t) {
    return t ? (t.startsWith("http") && (t = new URL(t).pathname), this.sessionService.session?.settings?.usecases?.find((a) => a.uri == t)?.order ?? 0) : 0;
  }
  /**
   * Assures that the usecase model is fetched and data model is initialized according to usecase.
   * @param type Type of business object
   * @param item Business object to initialize.
   * @param defaultUri Usecase uri if passed by the calling component (e.g. in URL or component attribute).
   * @returns The usecase with session / role related data or null if none is set.
   */
  assureUsecase(t, e, a) {
    return e ? this.getUsecaseForObject(t, e, a).then((n) => (e.usecase = e.usecase || {}, e.usecase.data = e.usecase.data || {}, n ? (n && (e.usecase.uri = n.uri, e.usecase.label = n.label, e.usecase.description = n.description), n) : null)) : Promise.resolve(null);
  }
  /**
   * Gets a usecase definition based on business object (that has usecase data item).
   * @param type Business object type
   * @param item The business objec to evaluate.
   * @param defaultUri Usecase uri if passed by the calling component (e.g. in URL or component attribute).
   * @returns The usecase with session / role related data or null if none is set.
   */
  getUsecaseForObject(t, e, a) {
    if (!e)
      return Promise.resolve(null);
    if (t == Rn.Calculation) {
      const n = [
        "palkkaus.fi/usecases/payroll-service/pro-calc",
        "palkkaus.fi/usecases/payroll-service/calc"
      ];
      if (e?.usecase?.uri && !n.find((i) => e.usecase.uri == i))
        return this.getUsecase(e.usecase.uri);
    } else if (e?.usecase?.uri)
      return this.getUsecase(e.usecase.uri);
    return a = a || this.getActiveUsecases(t, !0)[0]?.uri, a ? this.getUsecase(a) : Promise.resolve(null);
  }
  /** Clears the usecase cache: Will be fetched from the server in next getUsecase(). */
  clearCache() {
    this.cachedUsecases = {};
  }
  /**
   * Adds abilitity to set the contents of a usecase in cache.
   * This is used in dynamic preview in edit usecase scenarios.
   * @param newVersion A version of the usecase that is set into usecases cache.
   */
  setToCache(t) {
    const e = t;
    e.isLoaded = !0, e.exists = !0, e.views?.length && t.uri && (e.defaultView = this.$sce.trustAsResourceUrl(this.usecases.getResourceUrl(t.uri, "html"))), this.cachedUsecases[t.uri] = t;
  }
  /**
   * Gets a usecase based on URI using the session cache.
   * @param uri Uri of the usecase
   * @returns The usecase, typically cached in session.
   */
  getUsecase(t) {
    if (t = LL.getLocalUri(t), ["/UsecaseDefinition/FI53POYS0025543933/costcenter-percentages"].indexOf(t) >= 0)
      return Promise.resolve({
        isLoaded: !0,
        exists: !0,
        uri: t
      });
    const a = this.cachedUsecases[t];
    return a ? a.exists ? Promise.resolve(a) : Promise.resolve(null) : this.usecases.getSingle(LL.getIdAtOwner(t)).then((n) => n ? (this.setToCache(n), n) : (this.cachedUsecases[t] = {
      isLoaded: !0,
      exists: !1,
      uri: t
    }, null));
  }
};
HC.$inject = ["Usecases", "SessionService", "$sce"];
let lx = HC;
class s2 {
  /**
   * Returns an object with one property "val" that is bound to the given key.
   * Used for easier data binding in AngularJS models.
   * @param key Key for the property.
   * @returns An object with one property "val" that is bound to the given key (getter and setter).
   * @example
   * <salaxy-input-boolean name="myInput" ng-model="$ctrl.userSettings.ng1Binder('payroll.newVersion').val" label="Uusi versio"></salaxy-input>
   */
  ng1Binder(t) {
    const e = this;
    return {
      /** Property the is bound to the given key. */
      get val() {
        return e.get(t);
      },
      set val(a) {
        e.set(t, a);
      }
    };
  }
  /**
   * Gets a setting value from local storage
   * @param key String key for the value
   * @returns The value
   */
  get(t) {
    return t = t.toLowerCase().trim(), this.getAll()[t];
  }
  /**
   * Sets a setting value to local sotrage
   * @param key String key for the value
   * @param value The value.
   */
  set(t, e) {
    if (t = t.toLowerCase().trim(), !t)
      throw new Error("Key cannot be empty");
    const a = this.getAll();
    a[t] = e, this.setAll(a);
  }
  getAll() {
    return this.settings || (localStorage["salaxy-user-settings"] || (localStorage["salaxy-user-settings"] = JSON.stringify({})), this.settings = JSON.parse(localStorage["salaxy-user-settings"])), this.settings;
  }
  setAll(t) {
    localStorage["salaxy-user-settings"] = JSON.stringify(t), this.settings = t;
  }
}
const UC = class UC {
  constructor(t, e) {
    this.sessionService = t, this.partnerServicesApi = e;
  }
  /** Lazy loading of current pension order template */
  getCurrent() {
    const t = () => ({
      owner: null,
      orderer: {
        contact: {}
      },
      tyel: {},
      yel: {},
      validation: {}
    });
    if (this.sessionService.isSessionChecked && this.sessionService.isAuthenticated) {
      const e = this.sessionService.session.currentAccount.owner;
      this.current?.owner != e && (this.current = t(), this.current.owner = e, this.partnerServicesApi.getNewVarmaPensionOrder().then((a) => {
        this.current = { ...a, owner: e };
      }));
    } else
      this.current = null;
    return this.current ?? (this.current = t());
  }
  /**
   * Sends order for processing.
   */
  send() {
    const t = this.sessionService.session.currentAccount.owner;
    return this.partnerServicesApi.sendVarmaPensionOrder(this.current).then((e) => (this.current = e, this.current.owner = t, this.sessionService.checkSession().then(() => this.current)));
  }
  /**
   * Validates the order.
   */
  validate() {
    const t = this.sessionService.session.currentAccount.owner;
    return this.partnerServicesApi.validateVarmaPensionOrder(this.current).then((e) => (this.current = e, this.current.owner = t, this.current));
  }
  /**
   * Resets the current order.
   */
  reset() {
    this.current = null;
  }
};
UC.$inject = ["SessionService", "PartnerServices"];
let ox = UC;
const FC = class FC {
  /**
   * Creates a new instance of WorkflowService.
   */
  constructor(t, e) {
    this.sessionService = t, this.credentialService = e;
  }
  /**
   * Returns credentials for the current account.
   * Override this in the pro environment.
   */
  get credentials() {
    return this.credentialService.list;
  }
  /**
   * Returns the credential for current session.
   * Override this in the pro environment.
   */
  get self() {
    return this.sessionService.session.currentCredential;
  }
  /**
   * Adds/updates the workflow event for the current item.
   * @param apiCtrl API CRUD object controller for the item.
   * @param wfEvent Workflow event to add/update.
   * @returns Reloaded item.
   */
  saveWorkflowEvent(t, e) {
    return t.saveWorkflowEvent(e);
  }
  /**
   * Deletes the given event or all events with given type.
   * @param apiCtrl API CRUD object controller for the item.
   * @param wfIdOrType Id or type of the workflow event.
   * @returns - Reloaded item.
   */
  deleteWorkflowEvent(t, e) {
    return t.deleteWorkflowEvent(e);
  }
};
FC.$inject = ["SessionService", "CredentialService"];
let cx = FC;
const zC = class zC extends fc {
  /** Constructor for dependency injection */
  constructor(t, e, a, n, i, r) {
    super(e, n, i, r), this.uploadService = t, this.credentialService = e, this.sessionService = a, this.colorOptions = {
      "#7F2C2A": L.get("SALAXY.NG1.CredentialsComponent.color.brown"),
      "#91D214": L.get("SALAXY.NG1.CredentialsComponent.color.lime"),
      "#61703B": L.get("SALAXY.NG1.CredentialsComponent.color.darkGreen"),
      "#D10074": L.get("SALAXY.NG1.CredentialsComponent.color.pink")
    }, this.originalAvatar = null;
  }
  /**
   * Uploads avatar image file to the server.
   * @param file - selected file
   */
  uploadAvatarImage(t) {
    t && this.uploadService.upload(this.credentialService.getAvatarUploadUrl(this.current.id), { file: t }).then((e) => {
      this.current.avatar.url = e.avatar.url, this.current.avatar.pictureType = e.avatar.pictureType;
    });
  }
  /** Called when avatar changes */
  emailForAvatarChanged() {
    !this.current || !this.current.avatar || this.current.avatar.pictureType === is.Gravatar && (this.current.avatar.url = Zs.getGravatarUrl(this.current.email));
  }
  /** Called when avatar changes */
  typeForAvatarChanged() {
    !this.current || !this.current.avatar || (this.current.avatar.pictureType === is.Gravatar ? this.current.avatar.url = Zs.getGravatarUrl(this.current.email) : (Zs.isGravatarUrl(this.current.avatar.url) && (this.current.avatar.url = null), this.current.avatar.pictureType === is.Uploaded && !this.current.avatar.url && this.originalAvatar && this.originalAvatar.url && this.originalAvatar.pictureType === is.Uploaded && !Zs.isGravatarUrl(this.originalAvatar.url) && (this.current.avatar.url = this.originalAvatar.url)));
  }
  /** Set current credential for edit. */
  setCurrent(t) {
    t && (this.originalAvatar = wt.copy(t.avatar)), super.setCurrent(t);
  }
  /** Saves a new credential */
  saveCurrent() {
    const t = this.uiHelpers.showLoading("SALAXY.UI_Terms.wait");
    return super.saveCurrent().then((e) => (this.originalAvatar = wt.copy(e.avatar), this.sessionService.checkSession().then(() => (t.dismiss(), e))));
  }
};
zC.$inject = ["UploadService", "CredentialService", "SessionService", "$location", "$attrs", "UiHelpers"];
let pm = zC;
const BC = class BC {
  /**
   * Creates a new EmbeddedUiController
   * @ignore
   */
  constructor(t, e, a, n, i) {
    this.sessionService = t, this.$timeout = e, this.ajax = a, this.$location = n, this.userSettingsService = i, this._isLoading = !0, this.$onInit = () => {
      this.startListening();
    }, this.onMessageReceived = (r) => {
      if (r.data.action === "sxy-iframe-change-session") {
        if (this.firstMessageTimeout && (clearTimeout(this.firstMessageTimeout), this.firstMessageTimeout = void 0), r.origin !== this.parentOrigin && this.parentOrigin !== "*") {
          console.error(`Invalid origin ${r.origin} vs ${this.parentOrigin}.`);
          return;
        }
        const l = r.data;
        if (!l.session || !l.token)
          throw new Error("Session or token not defined in sxy-session-response event.");
        (this.sessionService.session?.currentAccount?.id !== l.session.currentAccount.id || this.sessionService.getCurrentToken() !== l.token) && (this.ajax.useCookie = !1, this.ajax.setCurrentToken(l.token), this.sessionService.isLoading = !0, this.sessionService.setSession(l.session)), l.route && this.$location.url(l.route), this._isLoading = !1, this.$timeout();
      }
    };
  }
  /**
   * If true, the layout should show a full-page loader instead of normal pages.
   * Controllers in normal pages should be destoyed (e.g. using ng-if) so that this can also
   * be used in reloading the AngularJS user interface without full Browser reload.
   */
  get showFullPageLoader() {
    return this._isLoading || this.sessionService.isLoading;
  }
  /**
   * Gets the user-specific setting (service), stored in the local storage.
   */
  get userSettings() {
    return this.userSettingsService;
  }
  /**
   * Starts listening for the session change events from the parent frame.
   */
  startListening() {
    if (window.parent === window)
      throw new Error("This is the parent window.");
    window.addEventListener("message", this.onMessageReceived), this.firstMessageTimeout = window.setTimeout(() => {
      throw new Error("Timeout while waiting for session.");
    }, 4e3), this.parentOrigin = "*", window.parent.postMessage({ action: "sxy-iframe-ready" }, this.parentOrigin);
  }
};
BC.$inject = ["SessionService", "$timeout", "AjaxNg1", "$location", "UserSettingsService"];
let dx = BC;
const WC = class WC {
  /**
   * Creates a new PartnerController using dependency injection.
   * @ignore
   */
  constructor(t, e) {
    this.partnerService = t, this.sessionService = e, this.showAll = !1, this.$onInit = () => {
    };
  }
  /** Shows the skin that is currently in use: "default" for the real skin or overriden preview skin for preview purposes. */
  get skin() {
    return this.partnerService.overrideSkin || "default";
  }
  /**
   * Shows the Brand ID that should be used for preview purposes: Either real service model or temporary override ID.
   * Note that the service model may also be null, if there is no partner
   */
  get brandId() {
    return this.partnerService.overridePartnerId || this.sessionService.getSession()?.settings.partner?.serviceModelId;
  }
  /**
   * Shows a dialog for brand selection.
   */
  showSwitchCss() {
    this.partnerService.showSwitchCss();
  }
  /**
   * Temporary method only used in development
   * Shows a dialog for brand selection.
   */
  showSwitchCssDev() {
    this.partnerService.showSwitchCssDev();
  }
  /**
   * Gets the URL for the login screen. Mainly for testing / preview purposes.
   */
  getLoginUrl() {
    return (Ne.current.wwwServer || "https://test-www.palkkaus.fi") + "/Security/Authorize?client_id=" + (this.brandId || "");
  }
  /**
   * Gets the URL for the onboarding screen. Mainly for testing / preview purposes.
   */
  getOnboardingUrl() {
    let e = `${Ne.current.apiServer || "https://test-secure.palkkaus.fi"}/Onboarding/Wizard?id=test&role=company`;
    return this.brandId && (e = e + "&partner=" + this.brandId), e;
  }
};
WC.$inject = ["PartnerService", "SessionService"];
let hm = WC;
const jC = class jC {
  constructor(t, e, a, n) {
    this.sessionService = t, this.$location = e, this.ajax = a, this.uiHelpers = n, this.$onInit = () => {
    };
  }
  /** If true, the session has been checked from theserver - i.e. isAuthenticated = false means that the user really cannot be authenticated. */
  get isSessionChecked() {
    return this.sessionService.getIsSessionChecked();
  }
  /** If true, the session check call is progressing. */
  get isSessionChecking() {
    return this.sessionService.getIsSessionChecking();
  }
  /** If true, the user is authenticated */
  get isAuthenticated() {
    return this.sessionService.getIsAuthenticated();
  }
  /** Avatar to show in the login screen */
  get avatar() {
    return this.sessionService.getAvatar();
  }
  /** The full session objcet */
  get session() {
    return this.sessionService.getSession();
  }
  /** The company account if the current account is company - and if the full account info is fetched */
  get company() {
    return this.sessionService.getCompanyAccount();
  }
  /** The person account if the current account is person - and if the full account info is fetched */
  get person() {
    return this.sessionService.getPersonAccount();
  }
  /**
   * Opens the login form for the current user
   * @param redirectUrl - The URL where the user is taken after a successfull login.
   * @param role - Optional role (household, worker or company) for the situations where it is known - mainly for new users
   * @param partnerSite Identifier of the partner or service model from which the login UI is fetched.
   * @param urlPostfix Additional string that is added to the OAuth2 URL.
   * Used in adding other parameters to the URL, e.g. "&salaxy_language=en"
   */
  signIn(t = null, e = null, a = null, n = null) {
    this.sessionService.signIn(t || this.redirectUrl, e, a, n);
  }
  /**
   * Opens the login dialog with signUp / register functionality
   * @param  redirectUrl - The URL where the user is taken after a successfull login
   * @param  role - Optional role (household, worker or company) for the situations where it is known - mainly for new users
   * @param partnerSite Identifier of the certified partner which should be granted access rights in account creation.
   * Also sets register dialog and onboarding wizard UI skin.
   * @param urlPostfix Additional string that is added to the OAuth2 URL.
   * Used in adding other parameters to the URL, e.g. "&salaxy_language=en"
   */
  register(t = null, e = null, a = null, n = null) {
    this.sessionService.register(t || this.redirectUrl, e, a, n);
  }
  /** If false, the current authenticated user has not signed the contract. */
  get isAccountVerified() {
    return this.sessionService.checkAccountVerification();
  }
  /**
   * Sends the user to the Sign-out page
   * @param redirectUrl - URL where user is redirected after log out.
   * Must be absolute URL. Default is the root of the current server.
   */
  signOut(t) {
    this.sessionService.signOut(t);
  }
  /**
   * Switches the current web site usage role between household and worker.
   * @param role - household or worker.
   * @returns A Promise with result data (new role as string)
   */
  switchRole(t) {
    return this.sessionService.switchRole(t).then((e) => (t === "worker" ? window.location.href = "/Worker#/" : window.location.href = "/Household#/", e));
  }
  /**
   * When called, will show the login screen if the user is not logged in
   */
  checkAuthenticated() {
    this.isSessionChecked && !this.isAuthenticated && this.signIn(window.location.href);
  }
  /**
   * Checks whether the user is in a given role
   * @param  role - One of the known roles
   */
  isInRole(t) {
    return this.sessionService.isInRole(t);
  }
  /**
   * Set the language for UI in the current session.
   * @param lang - Language to select: fi, en, sv.
   */
  setLanguage(t) {
    this.sessionService.setLanguage(t);
  }
  /**
   * Get the current language for UI in the current session.
   */
  getLanguage() {
    return L.getLanguage();
  }
  /**
   * Switches the CSS link to partner-specific CSS.
   * @param cssUrl URL for the CSS file.
   */
  switchCss(t) {
    this.sessionService.switchCss(t);
  }
  /** Sign in error */
  get signInError() {
    return this.sessionService.signInError;
  }
  /** Sign in error description */
  get signInErrorDescription() {
    return this.sessionService.signInErrorDescription;
  }
  /** Sign in error page url */
  get signInErrorPageUrl() {
    return this.sessionService.signInErrorUrl;
  }
  /** Returns current token if exists. */
  get currentToken() {
    return this.ajax.getCurrentToken();
  }
  /** Returns the url to the authorization pdf. */
  get authorizationPdfUrl() {
    return `${Ne.current.apiServer}/Onboarding/GetAuthorizationPdf?access_token=${encodeURIComponent(this.ajax.getCurrentToken())}`;
  }
  /** Returns owned payment channel for current account */
  get ownedPaymentChannel() {
    return this.sessionService.getOwnedPaymentChannel();
  }
  /** get kyc state */
  get kycState() {
    return this.sessionService.kycState;
  }
  /** returns latest update date for kyc. */
  get kycUpdatedAt() {
    return this.sessionService.kycUpdatedAt;
  }
  /** returns expiration date for kyc. */
  get kycExpiresAt() {
    return this.sessionService.kycExpiresAt;
  }
};
jC.$inject = [
  "SessionService",
  "$location",
  "AjaxNg1",
  "UiHelpers"
];
let vi = jC;
const VC = class VC {
  /** Constructor for dependency injection */
  constructor(t, e, a, n, i) {
    this.accounts = t, this.sessionService = e, this.ajax = a, this.uiHelpers = n, this.uploadService = i, this.current = null;
  }
  /**
   * Implement IController
   */
  $onInit() {
    this.current || this.accounts.getCompany().then((t) => {
      this.current = t;
    });
  }
  /** Gets the language of the current company */
  getAccountLanguage() {
    return this.current?.language;
  }
  /** Updates the company */
  saveCurrent() {
    const t = this.uiHelpers.showLoading("SALAXY.UI_Terms.wait");
    return this.ajax.postJSON("/accounts/company", this.current).then((e) => (this.current = e, this.sessionService.checkSession().then(() => (t.dismiss(), e))));
  }
  /**
   * Uploads avatar image file to the server.
   * @param avatar - selected file
   */
  uploadAvatarImage(t, e = null) {
    t && (e = e ?? this.current, this.uploadService.upload(this.accounts.getAvatarUploadUrl(), { avatar: t }).then((a) => {
      e.avatar.url = a.url, e.avatar.pictureType = a.pictureType;
    }));
  }
  /** Called when avatar changes */
  emailForAvatarChanged(t = null) {
    t = t ?? this.current, !(!t || !t.avatar) && t.avatar.pictureType === is.Gravatar && (t.avatar.url = Zs.getGravatarUrl(t.contact.email));
  }
  /** Called when avatar changes */
  typeForAvatarChanged(t = null) {
    if (t = t ?? this.current, !(!t || !t.avatar)) {
      if (t.avatar.pictureType === is.Gravatar)
        t.avatar.url = Zs.getGravatarUrl(t.contact.email);
      else if (Zs.isGravatarUrl(t.avatar.url) && (t.avatar.url = null), t.avatar.pictureType === is.Uploaded) {
        const e = (this.sessionService.getPersonAccount() || {}).avatar;
        !t.avatar.url && e && e.url && e.pictureType === is.Uploaded && !Zs.isGravatarUrl(e.url) && (t.avatar.url = e.url);
      }
    }
  }
  /**
   * Adds/updates the workflow event for the current using API.
   * @param wfEvent - Workflow event to add/update.
   * @returns - Reloaded item.
   */
  saveWorkflowEvent(t) {
    return this.accounts.saveWorkflowEvent(this.current, t).then(() => this.accounts.getCompany().then((e) => {
      this.current = e;
    }));
  }
  /**
   * Deletes the given event or all events with given type using API.
   * @param wfIdOrType Id or type of the workflow event.
   * @returns - Reloaded item.
   */
  deleteWorkflowEvent(t) {
    return this.accounts.deleteWorkflowEvent(this.current, t).then(() => this.accounts.getCompany().then((e) => {
      this.current = e;
    }));
  }
  /**
   * Gets a single workflow event for the item.
   * @param wfId Id the workflow event.
   * @returns - Workflow event.
   */
  getWorkflowEvent(t) {
    return this.accounts.getWorkflowEvent(this.current, t);
  }
  /**
   * Opens modal for avatar edit
   */
  openEditDialog(t) {
    const e = {
      typeForAvatarChanged: (a) => this.typeForAvatarChanged(a),
      uploadAvatarImage: (a, n) => this.uploadAvatarImage(a, n),
      emailForAvatarChanged: (a) => this.emailForAvatarChanged(a)
    };
    this.uiHelpers.openEditDialog(
      t === "avatar" ? "salaxy-components/modals/account/AccountAvatarEdit.html" : "salaxy-components/modals/account/AccountContactEdit.html",
      this.current,
      e
    ).then((a) => {
      a.action === "ok" && (this.current = a.item, this.saveCurrent());
    });
  }
};
VC.$inject = ["Accounts", "SessionService", "AjaxNg1", "UiHelpers", "UploadService"];
let ux = VC;
const qC = class qC {
  constructor(t, e) {
    this.uiHelpers = t, this.uiCrudHelpers = e;
  }
  /** Gets the current calculation. By convention, set in model. */
  get current() {
    return this.model.current;
  }
  /**
   * Opens a dialog that shows the wizard to create a new Employment relation.
   */
  launchEmploymentWizard() {
    this.uiCrudHelpers.createNewEmployment().then((t) => {
      if (t.action === "ok") {
        const e = this.uiHelpers.showLoading("SALAXY.UI_Terms.isSaving");
        this.model.updateFromEmployment(t.item.id, this.updateRows || !1).then(() => {
          e.dismiss();
        });
      }
    });
  }
};
qC.$inject = ["UiHelpers", "UiCrudHelpers"];
let mm = qC;
const KC = class KC extends nn {
  constructor(t, e, a, n, i, r, l) {
    super(t, a, n, i), this.calculationsApi = t, this.reportsService = e, this.sessionService = r, this.invoicesService = l;
  }
  /**
   * Initialization code.
   */
  $onInit() {
    super.$onInit(), this.updateRows == null && (this.updateRows = !0);
  }
  /** Implements the getDefaults of ApiCrudObjectController */
  getDefaults() {
    return {
      listUrl: this.listUrl || "/calc",
      detailsUrl: this.detailsUrl || "/calc/details/",
      oDataTemplateUrl: "salaxy-components/odata/lists/CalculationsAll.html",
      oDataOptions: {}
    };
  }
  /** Recalculates the current calculation */
  recalculate() {
    this.setStatus(this.calculationsApi.recalculate(this.current)).then((t) => {
      this.setCurrentValue(t);
    });
  }
  /**
   * Gets the URL for a calculation pdf.
   * If report has not been saved (ID is null), returns null.s
   * @param calc - Calculation. This method requires that the calculation has been saved.
   * @returns Url for specified report
   */
  getPdfUrl(t) {
    return t ? this.reportsService.getPdfUrlForCalc("salarySlip", t.id, !0) : null;
  }
  /**
   * If true, this is a new unsaved object.
   * Adds "new-for-employment" actions as new item.
   */
  isNew() {
    return this.parentController ? this.parentController.isNew() : this.action === "new-for-worker" || this.action === "new-for-employment" || super.isNew();
  }
  /**
   * Starts the reload process depending on the bindingMode:
   * Overrides a different load process for "new-for-employment".
   */
  reload() {
    if (this.action === "new-for-worker" || this.action === "new-for-employment") {
      if (this.parentController)
        return this.parentController.reload().then((t) => (this._currentId = null, t));
      {
        const t = this.api.getBlank();
        return this.currentId === "new" && (this._currentId = null), this.action === "new-for-worker" ? t.worker.accountId = this.currentId : t.worker.employmentId = this.currentId, this._currentId = null, this.setDefaultPaymentChannel(t), this.setStatus(this.calculationsApi.updateFromEmployment(t, !1, this.updateRows)).then((e) => (this.setCurrentRef(e), e));
      }
    } else
      return this.isNew() && this.sessionService.isInRole("worker") ? this.parentController ? this.parentController.reload().then((t) => (this._currentId = null, t)) : (this.action === "copy-as-new" ? this.setStatus(this.api.getSingle(this.currentId)).then((e) => this.copyItem(e || this.api.getBlank())) : Promise.resolve(this.api.getBlank())).then((e) => (e.worker.isSelf = !0, e.employer.isSelf = !1, this._currentId = null, this.setDefaultPaymentChannel(e), this.setStatus(this.calculationsApi.recalculate(e)).then((a) => (this.setCurrentRef(a), a)))) : super.reload().then((t) => (super.isNew() && this.setDefaultPaymentChannel(t), t));
  }
  /**
   * Creates a copy of a given item.
   * This is a synchronous method that should basically convert a saved item to a new item.
   * @param copySource Item (container item) to copy as new.
   */
  copyItem(t) {
    const e = super.copyItem(t);
    return e.id = null, e.info.workStartDate = null, e.info.workEndDate = null, e.info.workerMessage = null, e.info.paymentId = null, e.info.payrollId = null, e.info.backofficeNotes = null, e.info.pensionPaymentDate = null, e.info.pensionPaymentRef = null, e.info.pensionPaymentSpecifier = null, e.info.paymentChannel = At.Undefined, e.info.messageThreadId = null, e.worktime = {}, e.workflow.status = le.Draft, e.workflow.paidAt = null, e.workflow.salaryDate = null, e.workflow.requestedSalaryDate = null, e.workflow.salaryPaidAt = null, e.createdAt = null, e.updatedAt = null, e.framework && (e.framework.numberOfDays = 0), e.usecase && (e.usecase.uri === "palkkaus.fi/usecases/payroll-service/pro-calc" || e.usecase.uri === "palkkaus.fi/usecases/payroll-service/calc") && (e.usecase = {}), e.isReadOnly = !1, this.setDefaultPaymentChannel(e), e;
  }
  /** Shows the paymentd dialog / the invoices UI. */
  showPaymentDialog() {
    this.invoicesService.showPaymentDialog(this.current);
  }
  /** Shows inspection dialog for invoices of paid calculation*/
  showInvoicesDialog() {
    this.invoicesService.showPalkkausPersonalInvoicesDialog(this.current);
  }
  /**
   * Updates the calculation from Employment ID by deleting all the rows and re-setting the employment.
   * @param employmentId Employement Id to set.
   * If null, the employment Id already in calculation is used:
   * This method cannot be used to remove the Worker (extend if necessary).
   * @param updateRows If true, updates also the calc rows from the default rows in
   * employment relation. If false, the rows are kept as is.
   * @returns The Calculation after recalc (no saving).
   */
  updateFromEmployment(t = null, e) {
    return t && (this.current.worker.employmentId = t), this.calculationsApi.updateFromEmployment(this.current, !1, e).then((a) => (super.setCurrentValue(a), a));
  }
  /**
   * Cancels the payment or invoice processing for the current calculation.
   */
  cancel() {
    const t = this.invoicesService.getEprWarningForCancellation(this.current.workflow?.salaryDate, this.current.workflow?.status == le.PaymentSucceeded), e = t ? `
` + t : "";
    return this.uiHelpers.showConfirm(L.get("SALAXY.NG1.CalcResultsComponent.cancelDialogTitle") + "?", L.get("SALAXY.NG1.CalcResultsComponent.cancelDialogDescr") + `${e}`, "SALAXY.NG1.CalcResultsComponent.cancelDialogYes", "SALAXY.NG1.CalcResultsComponent.cancelDialogNo").then((a) => {
      if (a) {
        const n = this.uiHelpers.showLoading("SALAXY.UI_Terms.wait");
        return this.calculationsApi.cancel(this.currentId).then((i) => (this.setCurrentValue(i), n.dismiss(), this.current));
      } else
        return this.current;
    });
  }
  /**
   * Opens the list for selecting a new paid calculation for repair.
   * @param onAfterAction Function to call after the action.
   */
  launchCreateRepair(t) {
    return this.uiHelpers.openEditDialog(
      "salaxy-components/modals/calc/CalcList.html",
      [],
      {
        title: "SALAXY.UI_Terms.select",
        category: "paid",
        options: { $filter: "status eq 'paymentSucceeded'" },
        okButtonText: "SALAXY.UI_Terms.ok",
        cancelButtonText: "SALAXY.UI_Terms.cancel"
      }
    ).then((e) => {
      if (e.action === "ok" && e.item.length > 0) {
        const a = this.uiHelpers.showLoading("SALAXY.UI_Terms.wait");
        return Promise.all(e.item.map((n) => this.calculationsApi.startRepair(n.id))).then(() => this.uiHelpers.wait(1e3).then(() => {
          if (a.dismiss(), t)
            return t();
        }));
      } else
        return;
    });
  }
  /**
   * If true, the form controls should be read-only (no control at all).
   */
  get isReadOnly() {
    return super.isReadOnly || this.current.workflow?.status === le.PaymentStarted;
  }
  /**
   * Returns true if there is no net salary payment to worker at all.
   */
  get isCurrentZeroPayment() {
    return Da.isZeroPayment(this.current);
  }
  setDefaultPaymentChannel(t) {
    t && t.info && this.sessionService.getSession() && (!t.info.paymentChannel || t.info.paymentChannel === At.Undefined) && (t.info.paymentChannel = this.invoicesService.defaultChannel);
  }
  /**
   * HACK: This will be removed after moved to useCase based calculators.
   * Temporary redirecting to correct details view.
   * TODO: Should be replaced with full usecase logic based implementation.
   */
  showDetails(t) {
    return this.sessionService.isInRole(qy.Test) || (t?.workflow?.status == le.History && (this.detailsUrl = "/calc/history/"), t?.status == le.History && (this.detailsUrl = "/calc/history/")), t?.status == le.Repair && (this.detailsUrl = "/calc/repair/"), super.showDetails(t);
  }
  /** Shows the earnings payment report for the epr. */
  showEpr(t) {
    return this.calculationsApi.getEpr(t.id).then((e) => e ? this.$location.path("/irepr/details/" + e.id) : (this.uiHelpers.showAlert("Palkkatietoilmoitusta ei ole", "Palkkatietoilmoitusta ei ole vielä luotu tälle laskelmalle."), null));
  }
};
KC.$inject = ["Calculations", "ReportsService", "UiHelpers", "$location", "$routeParams", "SessionService", "InvoicesService"];
let wr = KC;
const Ny = class Ny extends wr {
  constructor(t, e, a, n, i, r, l, o, c) {
    super(t, e, a, n, i, r, l), this.invoicesService = l, this.uiCrudHelpers = o, this.usecasesService = c, this.usecase = null, this.historyUsecase = {
      save: () => {
        this.detailsUrl = "/calc/history/", this.current.workflow.status = le.History, this.current.workflow.salaryDateKind = $n.InPast, this.save();
      },
      recalculate: () => {
        this.current.workflow.status = le.History, this.current.workflow.salaryDateKind = $n.InPast, this.recalculate();
      }
    };
  }
  /**
   * Initialization code.
   */
  $onInit() {
    this.isWorkerInfoOpen = !1, super.$onInit();
  }
  /** Overrides the reload to assure that usecase is also loaded. */
  reload() {
    return super.reload().then((t) => {
      const e = this.$location?.search().usecase;
      return !e && this.isNew() ? this.showUsecasesSelection() : this.usecasesService.assureUsecase(Rn.Calculation, t, e).then((a) => (this.usecase = a, t));
    });
  }
  /**
   * If true, the given action (button) is displayed.
   * @param action One of the action values.
   * For now, validation and role based action logic is in UI.
   * Todo: some edge cases, i.e. isForcePayAllAllowed (for pay-button) are still in UI.
   */
  showAction(t) {
    if (!this.current || this.isReadOnlyForced && t != "showPaymentDialog")
      return !1;
    if (this.isReadOnlyForced && t == "showPaymentDialog")
      return !0;
    if (this.current.workflow.status == le.PayrollDraft)
      return !1;
    if (this.current.isReadOnly)
      switch (t) {
        case "cancel":
          return this.current.workflow.status == le.PaymentStarted && ([
            At.PalkkausManual,
            At.TalenomManual,
            At.PalkkausPersonal,
            At.PalkkausInvoices
          ].indexOf(this.current.info.paymentChannel) > -1 || ne.isCfa(this.current.info.paymentChannel) && !this.current.info.payrollId);
        case "copyAsNew":
          return !this.isReadOnlyForced;
        case "showPaymentDialog":
          return !0;
        case "allowForcePay":
        case "pay":
        case "recalculate":
        default:
          return !1;
      }
    else
      switch (t) {
        case "allowForcePay":
          return this.isForcePayAllAllowed && this.current.workflow.status != le.WaitingApproval && this.current.workflow.status != le.SharedRejected && this.current.workflow.status != le.SharedWaiting && this.current.workflow.status != le.Repair;
        case "pay":
          return this.current.workflow.status == le.Draft || this.current.workflow.status == le.ProDraft || this.current.workflow.status == le.SharedApproved;
        case "save":
          return this.current.workflow.status == le.Draft || this.current.workflow.status == le.ProDraft || this.current.workflow.status == le.SharedApproved || this.current.workflow.status == le.History || this.current.workflow.status == le.Repair;
        case "delete":
          return this.current.workflow.status == le.Draft || this.current.workflow.status == le.ProDraft || this.current.workflow.status == le.SharedRejected || this.current.workflow.status == le.History || this.current.workflow.status == le.Repair;
        case "sendToPro":
          return this.current.workflow.status == le.WaitingApproval;
        case "recalculate":
          return !0;
        case "reject":
          return this.current.workflow.status == le.SharedApproved || this.current.workflow.status == le.SharedWaiting;
        case "approve":
          return this.current.workflow.status == le.SharedRejected || this.current.workflow.status == le.SharedWaiting;
        case "setSalaryDateKind":
          return (this.current.workflow.status == le.Draft || this.current.workflow.status == le.ProDraft || this.current.workflow.status == le.SharedApproved) && (ne.isPalkkausManualLike(this.current.info.paymentChannel) || ne.isPalkkausInvoicesLike(this.current.info.paymentChannel) || this.current.info.paymentChannel == At.PalkkausCfaTest || this.current.info.paymentChannel == At.Briox || this.current.info.paymentChannel == At.Askelma || this.current.info.paymentChannel == At.PasseliMerit || this.current.info.paymentChannel == At.Ecom || this.current.info.paymentChannel == At.Hausvise);
        default:
          return !1;
      }
  }
  /**
   * Returns true, if action (button) is disabled
   * TODO: Add rules based on roles and validation? Pay button logic is in UI.
   */
  isActionDisabled(t) {
    if (!this.current || this.isReadOnlyForced)
      return !0;
    if (this.current.isReadOnly)
      switch (t) {
        case "delete":
          return this.current.workflow.status == le.PaymentStarted;
        case "save":
          return this.current.workflow.status == le.PaymentStarted;
        default:
          return !0;
      }
  }
  /** Loads the available usecases => The UI shows them as selection. */
  showUsecasesSelection() {
    return this.usecases = [], this.setStatus(this.usecasesService.getActiveUsecaseListItems(Rn.Calculation).then((t) => (t.length ? this.usecases = t.sort((e, a) => (e.data.order || 100) - (a.data.order || 100)) : this.usecases = null, this.current)));
  }
  /**
   * Sets the given usecase to the current calculation.
   * @param uri Uri for the new usecase.
   */
  setUsecase(t) {
    this.setStatus(this.usecasesService.assureUsecase(Rn.Calculation, this.current, t).then((e) => (this.usecase = e, this.usecases = null, this.current)));
  }
  /**
   * Gets a total of row type(s)
   * @param types A single row type or array of types to filter for calculation.
   */
  getRowTotal(t) {
    return t ? (Array.isArray(t) || (t = [t]), ie.sum(this.current?.result?.rows || [], (e) => t.indexOf(e.rowType) >= 0 ? e.total : 0)) : 0;
  }
  /**
   * Shows a report for the current calculation using a modal dialog.
   * @param reportType - Type of report to show
   */
  showReportDialog(t) {
    this.reportsService.showReportModalForCalc(t, this.current);
  }
  /**
   * Shows a dialog for modifying an existing Worker:
   * Saves changes and updates the calculation.
   */
  showWorkerEditDialog() {
    this.uiCrudHelpers.openEditEmploymentDialog(this.current.worker.employmentId, "updateCalc").then((t) => {
      if (t.action === "ok" || t.action === "ok-no-rows") {
        const e = this.uiHelpers.showLoading("SALAXY.NG1.CalcComponent.dialog.showWorkerEditDialogLoading");
        this.updateFromEmployment(t.item.id, t.action === "ok").then(() => {
          e.dismiss();
        });
      }
    });
  }
  /** Shows infor dialog about the current usecase in the calculation. */
  showUsecaseInfo() {
    this.uiHelpers.openEditDialog("salaxy-components/modals/workflow/UsecaseInfo.html", this.usecase, {
      objUsecase: this.current.usecase,
      canDelete: this.isNew()
    }, "lg").then((t) => {
      if (t.action == We.Delete && this.isNew())
        return this.usecase = null, this.current.usecase = {}, this.showUsecasesSelection();
    });
  }
  /**
   * Shows a dialog during the check of auto taxcard.
   */
  showRefreshAutoTaxcardDialog() {
    const t = this.uiHelpers.showLoading();
    this.uiCrudHelpers.refreshAutoTaxcard(this.current.worker.tax?.taxcardId, this.current.workflow?.salaryDate).then(() => {
      t.dismiss(), this.recalculate();
    });
  }
  /**
   * Shows a dialog for adding a new Employment relation.
   * If user goes through the wizard the employment relation is saved and set to the calculation.
   */
  showNewWorkerDialog() {
    this.uiCrudHelpers.createNewEmployment().then((t) => {
      t.action === "ok" && this.updateFromEmployment(t.item.id, !0);
    });
  }
  /**
   * Returns validation for current calculation or empty validation object if the calculation has not been recalculated (validated).
   */
  get validation() {
    return this.current?.result?.validation || { errors: [], hasAllRequiredFields: !0, isValid: !0 };
  }
  /** Returns true if the payment is possible when the employer pays all.  */
  get isForcePayAllAllowed() {
    return !this.validation.errors.find((e) => e.type !== "warning");
  }
};
Ny.$inject = ["Calculations", "ReportsService", "UiHelpers", "$location", "$routeParams", "SessionService", "InvoicesService", "UiCrudHelpers", "UsecasesService"], Ny.crudBindings = new class extends fa {
}();
let lu = Ny;
const JC = class JC {
  /**
   * Creates a new SalaryBasesController
   * @ignore
   */
  constructor(t, e, a, n, i, r) {
    this.employmentsApi = t, this.uiCrudHelpers = e, this.uiHelpers = a, this.ajax = n, this.jsonSchemaService = i, this.datasetsApi = r, this.matchTypes = {
      row: "Oletusrivi",
      hourlyRow: "Tuntipalkkaan perustuva rivi",
      monthlySalary: "Kuukausipalkka",
      ignore: "Ohitetaan",
      warning: "Varoitus",
      error: "Virhe"
    };
  }
  /** Initializes the controller. */
  $onInit() {
    this.current = {}, this.datasetsApi.getOData({
      // TODO: Perhaps add `status eq "draft/instance/template"`
      $filter: "entityType eq 'import'"
    }).then((t) => {
      this.datasets = t.items;
    });
  }
  /**
   * Loads the given dataset.
   * @param datasetToLoad List item for which the whole dataset should be loaded.
   */
  loadDataset(t) {
    const e = this.uiHelpers.showLoading();
    this.datasetsApi.getSingle(t.id).then((a) => {
      this.dataset = a, e.dismiss();
    });
  }
  /** The row types mapper from the dataset */
  getRowTypeMapper() {
    return this.dataset.data[0]?.content?.length || (this.dataset.data[0].content = qp.getRowTypeMapperEditable()), this.dataset.data[0].content;
  }
  /** Fetches the employment relations for operations on this UI. */
  getEmployments() {
    const t = this.uiHelpers.showLoading("Ladataan työsuhteita...");
    this.employmentsApi.getActiveFullObject(null).then((e) => {
      if (this.payrollController?.current) {
        const a = this.payrollController.current.calcs.map((n) => n.worker.employmentId);
        e.forEach((n) => {
          a.find((i) => n.id == i) && (n.usecase.data = n.usecase.data || {}, n.usecase.data.isPayroll = !0);
        });
      }
      this.employments = e, this.currentTab = "employments", t.dismiss();
    });
  }
  /** Gets the importable interface for importing the SalaryBasesRows */
  getImportable() {
    return {
      getImportMappers() {
        return [{
          value: "NG1/SalaryBasesController/HRSuunti",
          text: "HR Suunti / Tikon tuonti"
        }];
      },
      getImportMapper: async () => {
        const e = new br("NG1/SalaryBasesController/HRSuunti", "HR Suunti / Tikon tuonti"), a = {
          PVM: "date",
          TYNRO: "srcEmploymentId",
          PLNRO: "srcRowTypeId",
          TVR: null,
          "KPL/MISTÄ": "count",
          "AIKA/MIHIN": null,
          "MK/EUR": null,
          OSASTO: "costCenter"
        };
        return await e.setSchemaFromCache(this.jsonSchemaService.getCache(), "salaxy-secure/schemas/v02.json", "SalaryBasesRow", "target"), e.setPaths(a), e.generateSchema("HRSuuntiTikon", "source"), e;
      },
      parsers: $w.getDefaultParsers(),
      finalize: (e) => (this.current.rows = e, this.currentTab = "rows", Promise.resolve()),
      validate: (e, a) => {
        const n = {}, i = new FM(n);
        return this.employments?.length ? (qp.resolveEmployment(e, this.employments), i.checkNotEmpty(e, "employmentId", `Työntekijää ei löydy: ${e.srcEmploymentId}.`)) : a == 0 && i.error("Ei työsuhteita - tietoja ei voi tuoda! Hae ensin työsuhteet ja tuo rivit vasta sen jälkeen.", "Ei työsuhteita"), i.checkNotEmpty(e, "srcRowTypeId", "TYNRO (srcRowTypeId) puuttuu"), i.checkNotEmpty(e, "date", "PVM (date) puuttuu"), i.checkNotEmpty(e, "srcRowTypeId", "PLNRO (srcRowTypeId) puuttuu"), i.checkNotEmpty(e, "count", "KPL/MISTÄ (count) puuttuu"), i.checkNotEmpty(e, "costCenter", "OSASTO (costCenter) puuttuu"), i.recalc(), Promise.resolve({ item: e, validation: n });
      }
    };
  }
  /** Saves the dataset. */
  save() {
    const t = this.uiHelpers.showLoading("Tallennetaan");
    this.dataset.data[0].content.forEach((e) => {
      Object.keys(e).filter((a) => a[0] == "$").forEach((a) => {
        delete e[a];
      });
    }), this.datasetsApi.save(this.dataset).then((e) => {
      this.dataset = e, t.dismiss();
    });
  }
  /** Processes the import  */
  processImport() {
    if (!this.current.rows?.length) {
      alert("Hae ensin työsuhteet (1.) ja lataa data (2.)!");
      return;
    }
    const t = wt.copy(this.getRowTypeMapper());
    qp.resolveTypesAndPrices(this.current.rows, t), this.currentTab = "rows";
  }
  /** Saves the rows to the given payroll */
  saveToPayroll() {
    if ((this.payrollController?.currentId || "new") == "new") {
      alert("Palkkalista ei ole vielä ladattu! Ei voi tallentaa!");
      return;
    }
    if (!this.current?.rows?.length) {
      alert("Ei rivejä!");
      return;
    }
    const t = this.current.rows.filter((a) => a.rowType && a.rowType != Wt.Unknown), e = this.uiHelpers.showLoading("Tallennetaan palkkalistaa");
    qp.addToPayroll(this.payrollController.currentId, t, this.employments, this.ajax).then((a) => {
      e.dismiss(), alert("Rivit on tallennettu palkkalistaan: " + a.id), this.currentTab = "payroll", this.payrollController.reload();
    });
  }
  /** Shows a dialog box for editing the employment. */
  editEmployment(t) {
    this.uiCrudHelpers.openEditEmploymentDialog(t.id, "updateCalc").then((e) => {
      e.action == We.Ok && wt.merge(t, e.item);
    });
  }
};
JC.$inject = ["Employments", "UiCrudHelpers", "UiHelpers", "AjaxNg1", "JsonSchemaService", "Datasets"];
let px = JC;
/*!
 * @kurkle/color v0.3.2
 * https://github.com/kurkle/color#readme
 * (c) 2023 Jukka Kurkela
 * Released under the MIT License
 */
function zu(s) {
  return s + 0.5 | 0;
}
const Gr = (s, t, e) => Math.max(Math.min(s, e), t);
function Id(s) {
  return Gr(zu(s * 2.55), 0, 255);
}
function qr(s) {
  return Gr(zu(s * 255), 0, 255);
}
function dr(s) {
  return Gr(zu(s / 2.55) / 100, 0, 1);
}
function T1(s) {
  return Gr(zu(s * 100), 0, 100);
}
const Bs = { 0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, A: 10, B: 11, C: 12, D: 13, E: 14, F: 15, a: 10, b: 11, c: 12, d: 13, e: 14, f: 15 }, hx = [..."0123456789ABCDEF"], i2 = (s) => hx[s & 15], r2 = (s) => hx[(s & 240) >> 4] + hx[s & 15], ch = (s) => (s & 240) >> 4 === (s & 15), l2 = (s) => ch(s.r) && ch(s.g) && ch(s.b) && ch(s.a);
function o2(s) {
  var t = s.length, e;
  return s[0] === "#" && (t === 4 || t === 5 ? e = {
    r: 255 & Bs[s[1]] * 17,
    g: 255 & Bs[s[2]] * 17,
    b: 255 & Bs[s[3]] * 17,
    a: t === 5 ? Bs[s[4]] * 17 : 255
  } : (t === 7 || t === 9) && (e = {
    r: Bs[s[1]] << 4 | Bs[s[2]],
    g: Bs[s[3]] << 4 | Bs[s[4]],
    b: Bs[s[5]] << 4 | Bs[s[6]],
    a: t === 9 ? Bs[s[7]] << 4 | Bs[s[8]] : 255
  })), e;
}
const c2 = (s, t) => s < 255 ? t(s) : "";
function d2(s) {
  var t = l2(s) ? i2 : r2;
  return s ? "#" + t(s.r) + t(s.g) + t(s.b) + c2(s.a, t) : void 0;
}
const u2 = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function DP(s, t, e) {
  const a = t * Math.min(e, 1 - e), n = (i, r = (i + s / 30) % 12) => e - a * Math.max(Math.min(r - 3, 9 - r, 1), -1);
  return [n(0), n(8), n(4)];
}
function p2(s, t, e) {
  const a = (n, i = (n + s / 60) % 6) => e - e * t * Math.max(Math.min(i, 4 - i, 1), 0);
  return [a(5), a(3), a(1)];
}
function h2(s, t, e) {
  const a = DP(s, 1, 0.5);
  let n;
  for (t + e > 1 && (n = 1 / (t + e), t *= n, e *= n), n = 0; n < 3; n++)
    a[n] *= 1 - t - e, a[n] += t;
  return a;
}
function m2(s, t, e, a, n) {
  return s === n ? (t - e) / a + (t < e ? 6 : 0) : t === n ? (e - s) / a + 2 : (s - t) / a + 4;
}
function Ow(s) {
  const e = s.r / 255, a = s.g / 255, n = s.b / 255, i = Math.max(e, a, n), r = Math.min(e, a, n), l = (i + r) / 2;
  let o, c, d;
  return i !== r && (d = i - r, c = l > 0.5 ? d / (2 - i - r) : d / (i + r), o = m2(e, a, n, d, i), o = o * 60 + 0.5), [o | 0, c || 0, l];
}
function Mw(s, t, e, a) {
  return (Array.isArray(t) ? s(t[0], t[1], t[2]) : s(t, e, a)).map(qr);
}
function Xw(s, t, e) {
  return Mw(DP, s, t, e);
}
function g2(s, t, e) {
  return Mw(h2, s, t, e);
}
function y2(s, t, e) {
  return Mw(p2, s, t, e);
}
function IP(s) {
  return (s % 360 + 360) % 360;
}
function f2(s) {
  const t = u2.exec(s);
  let e = 255, a;
  if (!t)
    return;
  t[5] !== a && (e = t[6] ? Id(+t[5]) : qr(+t[5]));
  const n = IP(+t[2]), i = +t[3] / 100, r = +t[4] / 100;
  return t[1] === "hwb" ? a = g2(n, i, r) : t[1] === "hsv" ? a = y2(n, i, r) : a = Xw(n, i, r), {
    r: a[0],
    g: a[1],
    b: a[2],
    a: e
  };
}
function b2(s, t) {
  var e = Ow(s);
  e[0] = IP(e[0] + t), e = Xw(e), s.r = e[0], s.g = e[1], s.b = e[2];
}
function v2(s) {
  if (!s)
    return;
  const t = Ow(s), e = t[0], a = T1(t[1]), n = T1(t[2]);
  return s.a < 255 ? `hsla(${e}, ${a}%, ${n}%, ${dr(s.a)})` : `hsl(${e}, ${a}%, ${n}%)`;
}
const L1 = {
  x: "dark",
  Z: "light",
  Y: "re",
  X: "blu",
  W: "gr",
  V: "medium",
  U: "slate",
  A: "ee",
  T: "ol",
  S: "or",
  B: "ra",
  C: "lateg",
  D: "ights",
  R: "in",
  Q: "turquois",
  E: "hi",
  P: "ro",
  O: "al",
  N: "le",
  M: "de",
  L: "yello",
  F: "en",
  K: "ch",
  G: "arks",
  H: "ea",
  I: "ightg",
  J: "wh"
}, D1 = {
  OiceXe: "f0f8ff",
  antiquewEte: "faebd7",
  aqua: "ffff",
  aquamarRe: "7fffd4",
  azuY: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "0",
  blanKedOmond: "ffebcd",
  Xe: "ff",
  XeviTet: "8a2be2",
  bPwn: "a52a2a",
  burlywood: "deb887",
  caMtXe: "5f9ea0",
  KartYuse: "7fff00",
  KocTate: "d2691e",
  cSO: "ff7f50",
  cSnflowerXe: "6495ed",
  cSnsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "ffff",
  xXe: "8b",
  xcyan: "8b8b",
  xgTMnPd: "b8860b",
  xWay: "a9a9a9",
  xgYF: "6400",
  xgYy: "a9a9a9",
  xkhaki: "bdb76b",
  xmagFta: "8b008b",
  xTivegYF: "556b2f",
  xSange: "ff8c00",
  xScEd: "9932cc",
  xYd: "8b0000",
  xsOmon: "e9967a",
  xsHgYF: "8fbc8f",
  xUXe: "483d8b",
  xUWay: "2f4f4f",
  xUgYy: "2f4f4f",
  xQe: "ced1",
  xviTet: "9400d3",
  dAppRk: "ff1493",
  dApskyXe: "bfff",
  dimWay: "696969",
  dimgYy: "696969",
  dodgerXe: "1e90ff",
  fiYbrick: "b22222",
  flSOwEte: "fffaf0",
  foYstWAn: "228b22",
  fuKsia: "ff00ff",
  gaRsbSo: "dcdcdc",
  ghostwEte: "f8f8ff",
  gTd: "ffd700",
  gTMnPd: "daa520",
  Way: "808080",
  gYF: "8000",
  gYFLw: "adff2f",
  gYy: "808080",
  honeyMw: "f0fff0",
  hotpRk: "ff69b4",
  RdianYd: "cd5c5c",
  Rdigo: "4b0082",
  ivSy: "fffff0",
  khaki: "f0e68c",
  lavFMr: "e6e6fa",
  lavFMrXsh: "fff0f5",
  lawngYF: "7cfc00",
  NmoncEffon: "fffacd",
  ZXe: "add8e6",
  ZcSO: "f08080",
  Zcyan: "e0ffff",
  ZgTMnPdLw: "fafad2",
  ZWay: "d3d3d3",
  ZgYF: "90ee90",
  ZgYy: "d3d3d3",
  ZpRk: "ffb6c1",
  ZsOmon: "ffa07a",
  ZsHgYF: "20b2aa",
  ZskyXe: "87cefa",
  ZUWay: "778899",
  ZUgYy: "778899",
  ZstAlXe: "b0c4de",
  ZLw: "ffffe0",
  lime: "ff00",
  limegYF: "32cd32",
  lRF: "faf0e6",
  magFta: "ff00ff",
  maPon: "800000",
  VaquamarRe: "66cdaa",
  VXe: "cd",
  VScEd: "ba55d3",
  VpurpN: "9370db",
  VsHgYF: "3cb371",
  VUXe: "7b68ee",
  VsprRggYF: "fa9a",
  VQe: "48d1cc",
  VviTetYd: "c71585",
  midnightXe: "191970",
  mRtcYam: "f5fffa",
  mistyPse: "ffe4e1",
  moccasR: "ffe4b5",
  navajowEte: "ffdead",
  navy: "80",
  Tdlace: "fdf5e6",
  Tive: "808000",
  TivedBb: "6b8e23",
  Sange: "ffa500",
  SangeYd: "ff4500",
  ScEd: "da70d6",
  pOegTMnPd: "eee8aa",
  pOegYF: "98fb98",
  pOeQe: "afeeee",
  pOeviTetYd: "db7093",
  papayawEp: "ffefd5",
  pHKpuff: "ffdab9",
  peru: "cd853f",
  pRk: "ffc0cb",
  plum: "dda0dd",
  powMrXe: "b0e0e6",
  purpN: "800080",
  YbeccapurpN: "663399",
  Yd: "ff0000",
  Psybrown: "bc8f8f",
  PyOXe: "4169e1",
  saddNbPwn: "8b4513",
  sOmon: "fa8072",
  sandybPwn: "f4a460",
  sHgYF: "2e8b57",
  sHshell: "fff5ee",
  siFna: "a0522d",
  silver: "c0c0c0",
  skyXe: "87ceeb",
  UXe: "6a5acd",
  UWay: "708090",
  UgYy: "708090",
  snow: "fffafa",
  sprRggYF: "ff7f",
  stAlXe: "4682b4",
  tan: "d2b48c",
  teO: "8080",
  tEstN: "d8bfd8",
  tomato: "ff6347",
  Qe: "40e0d0",
  viTet: "ee82ee",
  JHt: "f5deb3",
  wEte: "ffffff",
  wEtesmoke: "f5f5f5",
  Lw: "ffff00",
  LwgYF: "9acd32"
};
function x2() {
  const s = {}, t = Object.keys(D1), e = Object.keys(L1);
  let a, n, i, r, l;
  for (a = 0; a < t.length; a++) {
    for (r = l = t[a], n = 0; n < e.length; n++)
      i = e[n], l = l.replace(i, L1[i]);
    i = parseInt(D1[r], 16), s[l] = [i >> 16 & 255, i >> 8 & 255, i & 255];
  }
  return s;
}
let dh;
function w2(s) {
  dh || (dh = x2(), dh.transparent = [0, 0, 0, 0]);
  const t = dh[s.toLowerCase()];
  return t && {
    r: t[0],
    g: t[1],
    b: t[2],
    a: t.length === 4 ? t[3] : 255
  };
}
const A2 = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function C2(s) {
  const t = A2.exec(s);
  let e = 255, a, n, i;
  if (t) {
    if (t[7] !== a) {
      const r = +t[7];
      e = t[8] ? Id(r) : Gr(r * 255, 0, 255);
    }
    return a = +t[1], n = +t[3], i = +t[5], a = 255 & (t[2] ? Id(a) : Gr(a, 0, 255)), n = 255 & (t[4] ? Id(n) : Gr(n, 0, 255)), i = 255 & (t[6] ? Id(i) : Gr(i, 0, 255)), {
      r: a,
      g: n,
      b: i,
      a: e
    };
  }
}
function $2(s) {
  return s && (s.a < 255 ? `rgba(${s.r}, ${s.g}, ${s.b}, ${dr(s.a)})` : `rgb(${s.r}, ${s.g}, ${s.b})`);
}
const Hb = (s) => s <= 31308e-7 ? s * 12.92 : Math.pow(s, 1 / 2.4) * 1.055 - 0.055, Oo = (s) => s <= 0.04045 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4);
function S2(s, t, e) {
  const a = Oo(dr(s.r)), n = Oo(dr(s.g)), i = Oo(dr(s.b));
  return {
    r: qr(Hb(a + e * (Oo(dr(t.r)) - a))),
    g: qr(Hb(n + e * (Oo(dr(t.g)) - n))),
    b: qr(Hb(i + e * (Oo(dr(t.b)) - i))),
    a: s.a + e * (t.a - s.a)
  };
}
function uh(s, t, e) {
  if (s) {
    let a = Ow(s);
    a[t] = Math.max(0, Math.min(a[t] + a[t] * e, t === 0 ? 360 : 1)), a = Xw(a), s.r = a[0], s.g = a[1], s.b = a[2];
  }
}
function PP(s, t) {
  return s && Object.assign(t || {}, s);
}
function I1(s) {
  var t = { r: 0, g: 0, b: 0, a: 255 };
  return Array.isArray(s) ? s.length >= 3 && (t = { r: s[0], g: s[1], b: s[2], a: 255 }, s.length > 3 && (t.a = qr(s[3]))) : (t = PP(s, { r: 0, g: 0, b: 0, a: 1 }), t.a = qr(t.a)), t;
}
function k2(s) {
  return s.charAt(0) === "r" ? C2(s) : f2(s);
}
class ou {
  constructor(t) {
    if (t instanceof ou)
      return t;
    const e = typeof t;
    let a;
    e === "object" ? a = I1(t) : e === "string" && (a = o2(t) || w2(t) || k2(t)), this._rgb = a, this._valid = !!a;
  }
  get valid() {
    return this._valid;
  }
  get rgb() {
    var t = PP(this._rgb);
    return t && (t.a = dr(t.a)), t;
  }
  set rgb(t) {
    this._rgb = I1(t);
  }
  rgbString() {
    return this._valid ? $2(this._rgb) : void 0;
  }
  hexString() {
    return this._valid ? d2(this._rgb) : void 0;
  }
  hslString() {
    return this._valid ? v2(this._rgb) : void 0;
  }
  mix(t, e) {
    if (t) {
      const a = this.rgb, n = t.rgb;
      let i;
      const r = e === i ? 0.5 : e, l = 2 * r - 1, o = a.a - n.a, c = ((l * o === -1 ? l : (l + o) / (1 + l * o)) + 1) / 2;
      i = 1 - c, a.r = 255 & c * a.r + i * n.r + 0.5, a.g = 255 & c * a.g + i * n.g + 0.5, a.b = 255 & c * a.b + i * n.b + 0.5, a.a = r * a.a + (1 - r) * n.a, this.rgb = a;
    }
    return this;
  }
  interpolate(t, e) {
    return t && (this._rgb = S2(this._rgb, t._rgb, e)), this;
  }
  clone() {
    return new ou(this.rgb);
  }
  alpha(t) {
    return this._rgb.a = qr(t), this;
  }
  clearer(t) {
    const e = this._rgb;
    return e.a *= 1 - t, this;
  }
  greyscale() {
    const t = this._rgb, e = zu(t.r * 0.3 + t.g * 0.59 + t.b * 0.11);
    return t.r = t.g = t.b = e, this;
  }
  opaquer(t) {
    const e = this._rgb;
    return e.a *= 1 + t, this;
  }
  negate() {
    const t = this._rgb;
    return t.r = 255 - t.r, t.g = 255 - t.g, t.b = 255 - t.b, this;
  }
  lighten(t) {
    return uh(this._rgb, 2, t), this;
  }
  darken(t) {
    return uh(this._rgb, 2, -t), this;
  }
  saturate(t) {
    return uh(this._rgb, 1, t), this;
  }
  desaturate(t) {
    return uh(this._rgb, 1, -t), this;
  }
  rotate(t) {
    return b2(this._rgb, t), this;
  }
}
/*!
 * Chart.js v4.4.2
 * https://www.chartjs.org
 * (c) 2024 Chart.js Contributors
 * Released under the MIT License
 */
function nr() {
}
const T2 = /* @__PURE__ */ (() => {
  let s = 0;
  return () => s++;
})();
function ua(s) {
  return s === null || typeof s > "u";
}
function ya(s) {
  if (Array.isArray && Array.isArray(s))
    return !0;
  const t = Object.prototype.toString.call(s);
  return t.slice(0, 7) === "[object" && t.slice(-6) === "Array]";
}
function Ve(s) {
  return s !== null && Object.prototype.toString.call(s) === "[object Object]";
}
function Va(s) {
  return (typeof s == "number" || s instanceof Number) && isFinite(+s);
}
function Ds(s, t) {
  return Va(s) ? s : t;
}
function Fe(s, t) {
  return typeof s > "u" ? t : s;
}
const L2 = (s, t) => typeof s == "string" && s.endsWith("%") ? parseFloat(s) / 100 : +s / t, EP = (s, t) => typeof s == "string" && s.endsWith("%") ? parseFloat(s) / 100 * t : +s;
function Sa(s, t, e) {
  if (s && typeof s.call == "function")
    return s.apply(e, t);
}
function ka(s, t, e, a) {
  let n, i, r;
  if (ya(s))
    if (i = s.length, a)
      for (n = i - 1; n >= 0; n--)
        t.call(e, s[n], n);
    else
      for (n = 0; n < i; n++)
        t.call(e, s[n], n);
  else if (Ve(s))
    for (r = Object.keys(s), i = r.length, n = 0; n < i; n++)
      t.call(e, s[r[n]], r[n]);
}
function gm(s, t) {
  let e, a, n, i;
  if (!s || !t || s.length !== t.length)
    return !1;
  for (e = 0, a = s.length; e < a; ++e)
    if (n = s[e], i = t[e], n.datasetIndex !== i.datasetIndex || n.index !== i.index)
      return !1;
  return !0;
}
function ym(s) {
  if (ya(s))
    return s.map(ym);
  if (Ve(s)) {
    const t = /* @__PURE__ */ Object.create(null), e = Object.keys(s), a = e.length;
    let n = 0;
    for (; n < a; ++n)
      t[e[n]] = ym(s[e[n]]);
    return t;
  }
  return s;
}
function NP(s) {
  return [
    "__proto__",
    "prototype",
    "constructor"
  ].indexOf(s) === -1;
}
function D2(s, t, e, a) {
  if (!NP(s))
    return;
  const n = t[s], i = e[s];
  Ve(n) && Ve(i) ? cu(n, i, a) : t[s] = ym(i);
}
function cu(s, t, e) {
  const a = ya(t) ? t : [
    t
  ], n = a.length;
  if (!Ve(s))
    return s;
  e = e || {};
  const i = e.merger || D2;
  let r;
  for (let l = 0; l < n; ++l) {
    if (r = a[l], !Ve(r))
      continue;
    const o = Object.keys(r);
    for (let c = 0, d = o.length; c < d; ++c)
      i(o[c], s, r, e);
  }
  return s;
}
function zd(s, t) {
  return cu(s, t, {
    merger: I2
  });
}
function I2(s, t, e) {
  if (!NP(s))
    return;
  const a = t[s], n = e[s];
  Ve(a) && Ve(n) ? zd(a, n) : Object.prototype.hasOwnProperty.call(t, s) || (t[s] = ym(n));
}
const P1 = {
  // Chart.helpers.core resolveObjectKey should resolve empty key to root object
  "": (s) => s,
  // default resolvers
  x: (s) => s.x,
  y: (s) => s.y
};
function P2(s) {
  const t = s.split("."), e = [];
  let a = "";
  for (const n of t)
    a += n, a.endsWith("\\") ? a = a.slice(0, -1) + "." : (e.push(a), a = "");
  return e;
}
function E2(s) {
  const t = P2(s);
  return (e) => {
    for (const a of t) {
      if (a === "")
        break;
      e = e && e[a];
    }
    return e;
  };
}
function el(s, t) {
  return (P1[t] || (P1[t] = E2(t)))(s);
}
function Gw(s) {
  return s.charAt(0).toUpperCase() + s.slice(1);
}
const Cs = (s) => typeof s < "u", As = (s) => typeof s == "function", E1 = (s, t) => {
  if (s.size !== t.size)
    return !1;
  for (const e of s)
    if (!t.has(e))
      return !1;
  return !0;
};
function N2(s) {
  return s.type === "mouseup" || s.type === "click" || s.type === "contextmenu";
}
const ra = Math.PI, Ga = 2 * ra, R2 = Ga + ra, fm = Number.POSITIVE_INFINITY, Hw = ra / 180, Fa = ra / 2, Js = ra / 4, bm = ra * 2 / 3, Hr = Math.log10, Ui = Math.sign;
function Bd(s, t, e) {
  return Math.abs(s - t) < e;
}
function N1(s) {
  const t = Math.round(s);
  s = Bd(s, t, s / 1e3) ? t : s;
  const e = Math.pow(10, Math.floor(Hr(s))), a = s / e;
  return (a <= 1 ? 1 : a <= 2 ? 2 : a <= 5 ? 5 : 10) * e;
}
function Y2(s) {
  const t = [], e = Math.sqrt(s);
  let a;
  for (a = 1; a < e; a++)
    s % a === 0 && (t.push(a), t.push(s / a));
  return e === (e | 0) && t.push(e), t.sort((n, i) => n - i).pop(), t;
}
function al(s) {
  return !isNaN(parseFloat(s)) && isFinite(s);
}
function _2(s, t) {
  const e = Math.round(s);
  return e - t <= s && e + t >= s;
}
function RP(s, t, e) {
  let a, n, i;
  for (a = 0, n = s.length; a < n; a++)
    i = s[a][e], isNaN(i) || (t.min = Math.min(t.min, i), t.max = Math.max(t.max, i));
}
function bn(s) {
  return s * (ra / 180);
}
function sf(s) {
  return s * (180 / ra);
}
function R1(s) {
  if (!Va(s))
    return;
  let t = 1, e = 0;
  for (; Math.round(s * t) / t !== s; )
    t *= 10, e++;
  return e;
}
function YP(s, t) {
  const e = t.x - s.x, a = t.y - s.y, n = Math.sqrt(e * e + a * a);
  let i = Math.atan2(a, e);
  return i < -0.5 * ra && (i += Ga), {
    angle: i,
    distance: n
  };
}
function vc(s, t) {
  return Math.sqrt(Math.pow(t.x - s.x, 2) + Math.pow(t.y - s.y, 2));
}
function O2(s, t) {
  return (s - t + R2) % Ga - ra;
}
function Ps(s) {
  return (s % Ga + Ga) % Ga;
}
function du(s, t, e, a) {
  const n = Ps(s), i = Ps(t), r = Ps(e), l = Ps(i - n), o = Ps(r - n), c = Ps(n - i), d = Ps(n - r);
  return n === i || n === r || a && i === r || l > o && c < d;
}
function Yn(s, t, e) {
  return Math.max(t, Math.min(e, s));
}
function M2(s) {
  return Yn(s, -32768, 32767);
}
function pr(s, t, e, a = 1e-6) {
  return s >= Math.min(t, e) - a && s <= Math.max(t, e) + a;
}
function Uw(s, t, e) {
  e = e || ((r) => s[r] < t);
  let a = s.length - 1, n = 0, i;
  for (; a - n > 1; )
    i = n + a >> 1, e(i) ? n = i : a = i;
  return {
    lo: n,
    hi: a
  };
}
const hr = (s, t, e, a) => Uw(s, e, a ? (n) => {
  const i = s[n][t];
  return i < e || i === e && s[n + 1][t] === e;
} : (n) => s[n][t] < e), X2 = (s, t, e) => Uw(s, e, (a) => s[a][t] >= e);
function G2(s, t, e) {
  let a = 0, n = s.length;
  for (; a < n && s[a] < t; )
    a++;
  for (; n > a && s[n - 1] > e; )
    n--;
  return a > 0 || n < s.length ? s.slice(a, n) : s;
}
const _P = [
  "push",
  "pop",
  "shift",
  "splice",
  "unshift"
];
function H2(s, t) {
  if (s._chartjs) {
    s._chartjs.listeners.push(t);
    return;
  }
  Object.defineProperty(s, "_chartjs", {
    configurable: !0,
    enumerable: !1,
    value: {
      listeners: [
        t
      ]
    }
  }), _P.forEach((e) => {
    const a = "_onData" + Gw(e), n = s[e];
    Object.defineProperty(s, e, {
      configurable: !0,
      enumerable: !1,
      value(...i) {
        const r = n.apply(this, i);
        return s._chartjs.listeners.forEach((l) => {
          typeof l[a] == "function" && l[a](...i);
        }), r;
      }
    });
  });
}
function Y1(s, t) {
  const e = s._chartjs;
  if (!e)
    return;
  const a = e.listeners, n = a.indexOf(t);
  n !== -1 && a.splice(n, 1), !(a.length > 0) && (_P.forEach((i) => {
    delete s[i];
  }), delete s._chartjs);
}
function OP(s) {
  const t = new Set(s);
  return t.size === s.length ? s : Array.from(t);
}
const MP = function() {
  return typeof window > "u" ? function(s) {
    return s();
  } : window.requestAnimationFrame;
}();
function XP(s, t) {
  let e = [], a = !1;
  return function(...n) {
    e = n, a || (a = !0, MP.call(window, () => {
      a = !1, s.apply(t, e);
    }));
  };
}
function U2(s, t) {
  let e;
  return function(...a) {
    return t ? (clearTimeout(e), e = setTimeout(s, t, a)) : s.apply(this, a), t;
  };
}
const Fw = (s) => s === "start" ? "left" : s === "end" ? "right" : "center", Bn = (s, t, e) => s === "start" ? t : s === "end" ? e : (t + e) / 2, F2 = (s, t, e, a) => s === (a ? "left" : "right") ? e : s === "center" ? (t + e) / 2 : t;
function GP(s, t, e) {
  const a = t.length;
  let n = 0, i = a;
  if (s._sorted) {
    const { iScale: r, _parsed: l } = s, o = r.axis, { min: c, max: d, minDefined: p, maxDefined: h } = r.getUserBounds();
    p && (n = Yn(Math.min(
      // @ts-expect-error Need to type _parsed
      hr(l, o, c).lo,
      // @ts-expect-error Need to fix types on _lookupByKey
      e ? a : hr(t, o, r.getPixelForValue(c)).lo
    ), 0, a - 1)), h ? i = Yn(Math.max(
      // @ts-expect-error Need to type _parsed
      hr(l, r.axis, d, !0).hi + 1,
      // @ts-expect-error Need to fix types on _lookupByKey
      e ? 0 : hr(t, o, r.getPixelForValue(d), !0).hi + 1
    ), n, a) - n : i = a - n;
  }
  return {
    start: n,
    count: i
  };
}
function HP(s) {
  const { xScale: t, yScale: e, _scaleRanges: a } = s, n = {
    xmin: t.min,
    xmax: t.max,
    ymin: e.min,
    ymax: e.max
  };
  if (!a)
    return s._scaleRanges = n, !0;
  const i = a.xmin !== t.min || a.xmax !== t.max || a.ymin !== e.min || a.ymax !== e.max;
  return Object.assign(a, n), i;
}
const ph = (s) => s === 0 || s === 1, _1 = (s, t, e) => -(Math.pow(2, 10 * (s -= 1)) * Math.sin((s - t) * Ga / e)), O1 = (s, t, e) => Math.pow(2, -10 * s) * Math.sin((s - t) * Ga / e) + 1, Wd = {
  linear: (s) => s,
  easeInQuad: (s) => s * s,
  easeOutQuad: (s) => -s * (s - 2),
  easeInOutQuad: (s) => (s /= 0.5) < 1 ? 0.5 * s * s : -0.5 * (--s * (s - 2) - 1),
  easeInCubic: (s) => s * s * s,
  easeOutCubic: (s) => (s -= 1) * s * s + 1,
  easeInOutCubic: (s) => (s /= 0.5) < 1 ? 0.5 * s * s * s : 0.5 * ((s -= 2) * s * s + 2),
  easeInQuart: (s) => s * s * s * s,
  easeOutQuart: (s) => -((s -= 1) * s * s * s - 1),
  easeInOutQuart: (s) => (s /= 0.5) < 1 ? 0.5 * s * s * s * s : -0.5 * ((s -= 2) * s * s * s - 2),
  easeInQuint: (s) => s * s * s * s * s,
  easeOutQuint: (s) => (s -= 1) * s * s * s * s + 1,
  easeInOutQuint: (s) => (s /= 0.5) < 1 ? 0.5 * s * s * s * s * s : 0.5 * ((s -= 2) * s * s * s * s + 2),
  easeInSine: (s) => -Math.cos(s * Fa) + 1,
  easeOutSine: (s) => Math.sin(s * Fa),
  easeInOutSine: (s) => -0.5 * (Math.cos(ra * s) - 1),
  easeInExpo: (s) => s === 0 ? 0 : Math.pow(2, 10 * (s - 1)),
  easeOutExpo: (s) => s === 1 ? 1 : -Math.pow(2, -10 * s) + 1,
  easeInOutExpo: (s) => ph(s) ? s : s < 0.5 ? 0.5 * Math.pow(2, 10 * (s * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (s * 2 - 1)) + 2),
  easeInCirc: (s) => s >= 1 ? s : -(Math.sqrt(1 - s * s) - 1),
  easeOutCirc: (s) => Math.sqrt(1 - (s -= 1) * s),
  easeInOutCirc: (s) => (s /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - s * s) - 1) : 0.5 * (Math.sqrt(1 - (s -= 2) * s) + 1),
  easeInElastic: (s) => ph(s) ? s : _1(s, 0.075, 0.3),
  easeOutElastic: (s) => ph(s) ? s : O1(s, 0.075, 0.3),
  easeInOutElastic(s) {
    return ph(s) ? s : s < 0.5 ? 0.5 * _1(s * 2, 0.1125, 0.45) : 0.5 + 0.5 * O1(s * 2 - 1, 0.1125, 0.45);
  },
  easeInBack(s) {
    return s * s * ((1.70158 + 1) * s - 1.70158);
  },
  easeOutBack(s) {
    return (s -= 1) * s * ((1.70158 + 1) * s + 1.70158) + 1;
  },
  easeInOutBack(s) {
    let t = 1.70158;
    return (s /= 0.5) < 1 ? 0.5 * (s * s * (((t *= 1.525) + 1) * s - t)) : 0.5 * ((s -= 2) * s * (((t *= 1.525) + 1) * s + t) + 2);
  },
  easeInBounce: (s) => 1 - Wd.easeOutBounce(1 - s),
  easeOutBounce(s) {
    return s < 1 / 2.75 ? 7.5625 * s * s : s < 2 / 2.75 ? 7.5625 * (s -= 1.5 / 2.75) * s + 0.75 : s < 2.5 / 2.75 ? 7.5625 * (s -= 2.25 / 2.75) * s + 0.9375 : 7.5625 * (s -= 2.625 / 2.75) * s + 0.984375;
  },
  easeInOutBounce: (s) => s < 0.5 ? Wd.easeInBounce(s * 2) * 0.5 : Wd.easeOutBounce(s * 2 - 1) * 0.5 + 0.5
};
function zw(s) {
  if (s && typeof s == "object") {
    const t = s.toString();
    return t === "[object CanvasPattern]" || t === "[object CanvasGradient]";
  }
  return !1;
}
function M1(s) {
  return zw(s) ? s : new ou(s);
}
function Ub(s) {
  return zw(s) ? s : new ou(s).saturate(0.5).darken(0.1).hexString();
}
const z2 = [
  "x",
  "y",
  "borderWidth",
  "radius",
  "tension"
], B2 = [
  "color",
  "borderColor",
  "backgroundColor"
];
function W2(s) {
  s.set("animation", {
    delay: void 0,
    duration: 1e3,
    easing: "easeOutQuart",
    fn: void 0,
    from: void 0,
    loop: void 0,
    to: void 0,
    type: void 0
  }), s.describe("animation", {
    _fallback: !1,
    _indexable: !1,
    _scriptable: (t) => t !== "onProgress" && t !== "onComplete" && t !== "fn"
  }), s.set("animations", {
    colors: {
      type: "color",
      properties: B2
    },
    numbers: {
      type: "number",
      properties: z2
    }
  }), s.describe("animations", {
    _fallback: "animation"
  }), s.set("transitions", {
    active: {
      animation: {
        duration: 400
      }
    },
    resize: {
      animation: {
        duration: 0
      }
    },
    show: {
      animations: {
        colors: {
          from: "transparent"
        },
        visible: {
          type: "boolean",
          duration: 0
        }
      }
    },
    hide: {
      animations: {
        colors: {
          to: "transparent"
        },
        visible: {
          type: "boolean",
          easing: "linear",
          fn: (t) => t | 0
        }
      }
    }
  });
}
function j2(s) {
  s.set("layout", {
    autoPadding: !0,
    padding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }
  });
}
const X1 = /* @__PURE__ */ new Map();
function V2(s, t) {
  t = t || {};
  const e = s + JSON.stringify(t);
  let a = X1.get(e);
  return a || (a = new Intl.NumberFormat(s, t), X1.set(e, a)), a;
}
function Bu(s, t, e) {
  return V2(t, e).format(s);
}
const UP = {
  values(s) {
    return ya(s) ? s : "" + s;
  },
  numeric(s, t, e) {
    if (s === 0)
      return "0";
    const a = this.chart.options.locale;
    let n, i = s;
    if (e.length > 1) {
      const c = Math.max(Math.abs(e[0].value), Math.abs(e[e.length - 1].value));
      (c < 1e-4 || c > 1e15) && (n = "scientific"), i = q2(s, e);
    }
    const r = Hr(Math.abs(i)), l = isNaN(r) ? 1 : Math.max(Math.min(-1 * Math.floor(r), 20), 0), o = {
      notation: n,
      minimumFractionDigits: l,
      maximumFractionDigits: l
    };
    return Object.assign(o, this.options.ticks.format), Bu(s, a, o);
  },
  logarithmic(s, t, e) {
    if (s === 0)
      return "0";
    const a = e[t].significand || s / Math.pow(10, Math.floor(Hr(s)));
    return [
      1,
      2,
      3,
      5,
      10,
      15
    ].includes(a) || t > 0.8 * e.length ? UP.numeric.call(this, s, t, e) : "";
  }
};
function q2(s, t) {
  let e = t.length > 3 ? t[2].value - t[1].value : t[1].value - t[0].value;
  return Math.abs(e) >= 1 && s !== Math.floor(s) && (e = s - Math.floor(s)), e;
}
var rf = {
  formatters: UP
};
function K2(s) {
  s.set("scale", {
    display: !0,
    offset: !1,
    reverse: !1,
    beginAtZero: !1,
    bounds: "ticks",
    clip: !0,
    grace: 0,
    grid: {
      display: !0,
      lineWidth: 1,
      drawOnChartArea: !0,
      drawTicks: !0,
      tickLength: 8,
      tickWidth: (t, e) => e.lineWidth,
      tickColor: (t, e) => e.color,
      offset: !1
    },
    border: {
      display: !0,
      dash: [],
      dashOffset: 0,
      width: 1
    },
    title: {
      display: !1,
      text: "",
      padding: {
        top: 4,
        bottom: 4
      }
    },
    ticks: {
      minRotation: 0,
      maxRotation: 50,
      mirror: !1,
      textStrokeWidth: 0,
      textStrokeColor: "",
      padding: 3,
      display: !0,
      autoSkip: !0,
      autoSkipPadding: 3,
      labelOffset: 0,
      callback: rf.formatters.values,
      minor: {},
      major: {},
      align: "center",
      crossAlign: "near",
      showLabelBackdrop: !1,
      backdropColor: "rgba(255, 255, 255, 0.75)",
      backdropPadding: 2
    }
  }), s.route("scale.ticks", "color", "", "color"), s.route("scale.grid", "color", "", "borderColor"), s.route("scale.border", "color", "", "borderColor"), s.route("scale.title", "color", "", "color"), s.describe("scale", {
    _fallback: !1,
    _scriptable: (t) => !t.startsWith("before") && !t.startsWith("after") && t !== "callback" && t !== "parser",
    _indexable: (t) => t !== "borderDash" && t !== "tickBorderDash" && t !== "dash"
  }), s.describe("scales", {
    _fallback: "scale"
  }), s.describe("scale.ticks", {
    _scriptable: (t) => t !== "backdropPadding" && t !== "callback",
    _indexable: (t) => t !== "backdropPadding"
  });
}
const Wl = /* @__PURE__ */ Object.create(null), mx = /* @__PURE__ */ Object.create(null);
function jd(s, t) {
  if (!t)
    return s;
  const e = t.split(".");
  for (let a = 0, n = e.length; a < n; ++a) {
    const i = e[a];
    s = s[i] || (s[i] = /* @__PURE__ */ Object.create(null));
  }
  return s;
}
function Fb(s, t, e) {
  return typeof t == "string" ? cu(jd(s, t), e) : cu(jd(s, ""), t);
}
class J2 {
  constructor(t, e) {
    this.animation = void 0, this.backgroundColor = "rgba(0,0,0,0.1)", this.borderColor = "rgba(0,0,0,0.1)", this.color = "#666", this.datasets = {}, this.devicePixelRatio = (a) => a.chart.platform.getDevicePixelRatio(), this.elements = {}, this.events = [
      "mousemove",
      "mouseout",
      "click",
      "touchstart",
      "touchmove"
    ], this.font = {
      family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
      size: 12,
      style: "normal",
      lineHeight: 1.2,
      weight: null
    }, this.hover = {}, this.hoverBackgroundColor = (a, n) => Ub(n.backgroundColor), this.hoverBorderColor = (a, n) => Ub(n.borderColor), this.hoverColor = (a, n) => Ub(n.color), this.indexAxis = "x", this.interaction = {
      mode: "nearest",
      intersect: !0,
      includeInvisible: !1
    }, this.maintainAspectRatio = !0, this.onHover = null, this.onClick = null, this.parsing = !0, this.plugins = {}, this.responsive = !0, this.scale = void 0, this.scales = {}, this.showLine = !0, this.drawActiveElementsOnTop = !0, this.describe(t), this.apply(e);
  }
  set(t, e) {
    return Fb(this, t, e);
  }
  get(t) {
    return jd(this, t);
  }
  describe(t, e) {
    return Fb(mx, t, e);
  }
  override(t, e) {
    return Fb(Wl, t, e);
  }
  route(t, e, a, n) {
    const i = jd(this, t), r = jd(this, a), l = "_" + e;
    Object.defineProperties(i, {
      [l]: {
        value: i[e],
        writable: !0
      },
      [e]: {
        enumerable: !0,
        get() {
          const o = this[l], c = r[n];
          return Ve(o) ? Object.assign({}, c, o) : Fe(o, c);
        },
        set(o) {
          this[l] = o;
        }
      }
    });
  }
  apply(t) {
    t.forEach((e) => e(this));
  }
}
var en = /* @__PURE__ */ new J2({
  _scriptable: (s) => !s.startsWith("on"),
  _indexable: (s) => s !== "events",
  hover: {
    _fallback: "interaction"
  },
  interaction: {
    _scriptable: !1,
    _indexable: !1
  }
}, [
  W2,
  j2,
  K2
]);
function Q2(s) {
  return !s || ua(s.size) || ua(s.family) ? null : (s.style ? s.style + " " : "") + (s.weight ? s.weight + " " : "") + s.size + "px " + s.family;
}
function vm(s, t, e, a, n) {
  let i = t[n];
  return i || (i = t[n] = s.measureText(n).width, e.push(n)), i > a && (a = i), a;
}
function Z2(s, t, e, a) {
  a = a || {};
  let n = a.data = a.data || {}, i = a.garbageCollect = a.garbageCollect || [];
  a.font !== t && (n = a.data = {}, i = a.garbageCollect = [], a.font = t), s.save(), s.font = t;
  let r = 0;
  const l = e.length;
  let o, c, d, p, h;
  for (o = 0; o < l; o++)
    if (p = e[o], p != null && !ya(p))
      r = vm(s, n, i, r, p);
    else if (ya(p))
      for (c = 0, d = p.length; c < d; c++)
        h = p[c], h != null && !ya(h) && (r = vm(s, n, i, r, h));
  s.restore();
  const g = i.length / 2;
  if (g > e.length) {
    for (o = 0; o < g; o++)
      delete n[i[o]];
    i.splice(0, g);
  }
  return r;
}
function Sl(s, t, e) {
  const a = s.currentDevicePixelRatio, n = e !== 0 ? Math.max(e / 2, 0.5) : 0;
  return Math.round((t - n) * a) / a + n;
}
function G1(s, t) {
  t = t || s.getContext("2d"), t.save(), t.resetTransform(), t.clearRect(0, 0, s.width, s.height), t.restore();
}
function gx(s, t, e, a) {
  FP(s, t, e, a, null);
}
function FP(s, t, e, a, n) {
  let i, r, l, o, c, d, p, h;
  const g = t.pointStyle, x = t.rotation, b = t.radius;
  let A = (x || 0) * Hw;
  if (g && typeof g == "object" && (i = g.toString(), i === "[object HTMLImageElement]" || i === "[object HTMLCanvasElement]")) {
    s.save(), s.translate(e, a), s.rotate(A), s.drawImage(g, -g.width / 2, -g.height / 2, g.width, g.height), s.restore();
    return;
  }
  if (!(isNaN(b) || b <= 0)) {
    switch (s.beginPath(), g) {
      default:
        n ? s.ellipse(e, a, n / 2, b, 0, 0, Ga) : s.arc(e, a, b, 0, Ga), s.closePath();
        break;
      case "triangle":
        d = n ? n / 2 : b, s.moveTo(e + Math.sin(A) * d, a - Math.cos(A) * b), A += bm, s.lineTo(e + Math.sin(A) * d, a - Math.cos(A) * b), A += bm, s.lineTo(e + Math.sin(A) * d, a - Math.cos(A) * b), s.closePath();
        break;
      case "rectRounded":
        c = b * 0.516, o = b - c, r = Math.cos(A + Js) * o, p = Math.cos(A + Js) * (n ? n / 2 - c : o), l = Math.sin(A + Js) * o, h = Math.sin(A + Js) * (n ? n / 2 - c : o), s.arc(e - p, a - l, c, A - ra, A - Fa), s.arc(e + h, a - r, c, A - Fa, A), s.arc(e + p, a + l, c, A, A + Fa), s.arc(e - h, a + r, c, A + Fa, A + ra), s.closePath();
        break;
      case "rect":
        if (!x) {
          o = Math.SQRT1_2 * b, d = n ? n / 2 : o, s.rect(e - d, a - o, 2 * d, 2 * o);
          break;
        }
        A += Js;
      case "rectRot":
        p = Math.cos(A) * (n ? n / 2 : b), r = Math.cos(A) * b, l = Math.sin(A) * b, h = Math.sin(A) * (n ? n / 2 : b), s.moveTo(e - p, a - l), s.lineTo(e + h, a - r), s.lineTo(e + p, a + l), s.lineTo(e - h, a + r), s.closePath();
        break;
      case "crossRot":
        A += Js;
      case "cross":
        p = Math.cos(A) * (n ? n / 2 : b), r = Math.cos(A) * b, l = Math.sin(A) * b, h = Math.sin(A) * (n ? n / 2 : b), s.moveTo(e - p, a - l), s.lineTo(e + p, a + l), s.moveTo(e + h, a - r), s.lineTo(e - h, a + r);
        break;
      case "star":
        p = Math.cos(A) * (n ? n / 2 : b), r = Math.cos(A) * b, l = Math.sin(A) * b, h = Math.sin(A) * (n ? n / 2 : b), s.moveTo(e - p, a - l), s.lineTo(e + p, a + l), s.moveTo(e + h, a - r), s.lineTo(e - h, a + r), A += Js, p = Math.cos(A) * (n ? n / 2 : b), r = Math.cos(A) * b, l = Math.sin(A) * b, h = Math.sin(A) * (n ? n / 2 : b), s.moveTo(e - p, a - l), s.lineTo(e + p, a + l), s.moveTo(e + h, a - r), s.lineTo(e - h, a + r);
        break;
      case "line":
        r = n ? n / 2 : Math.cos(A) * b, l = Math.sin(A) * b, s.moveTo(e - r, a - l), s.lineTo(e + r, a + l);
        break;
      case "dash":
        s.moveTo(e, a), s.lineTo(e + Math.cos(A) * (n ? n / 2 : b), a + Math.sin(A) * b);
        break;
      case !1:
        s.closePath();
        break;
    }
    s.fill(), t.borderWidth > 0 && s.stroke();
  }
}
function mr(s, t, e) {
  return e = e || 0.5, !t || s && s.x > t.left - e && s.x < t.right + e && s.y > t.top - e && s.y < t.bottom + e;
}
function Wu(s, t) {
  s.save(), s.beginPath(), s.rect(t.left, t.top, t.right - t.left, t.bottom - t.top), s.clip();
}
function ju(s) {
  s.restore();
}
function tU(s, t, e, a, n) {
  if (!t)
    return s.lineTo(e.x, e.y);
  if (n === "middle") {
    const i = (t.x + e.x) / 2;
    s.lineTo(i, t.y), s.lineTo(i, e.y);
  } else
    n === "after" != !!a ? s.lineTo(t.x, e.y) : s.lineTo(e.x, t.y);
  s.lineTo(e.x, e.y);
}
function eU(s, t, e, a) {
  if (!t)
    return s.lineTo(e.x, e.y);
  s.bezierCurveTo(a ? t.cp1x : t.cp2x, a ? t.cp1y : t.cp2y, a ? e.cp2x : e.cp1x, a ? e.cp2y : e.cp1y, e.x, e.y);
}
function aU(s, t) {
  t.translation && s.translate(t.translation[0], t.translation[1]), ua(t.rotation) || s.rotate(t.rotation), t.color && (s.fillStyle = t.color), t.textAlign && (s.textAlign = t.textAlign), t.textBaseline && (s.textBaseline = t.textBaseline);
}
function nU(s, t, e, a, n) {
  if (n.strikethrough || n.underline) {
    const i = s.measureText(a), r = t - i.actualBoundingBoxLeft, l = t + i.actualBoundingBoxRight, o = e - i.actualBoundingBoxAscent, c = e + i.actualBoundingBoxDescent, d = n.strikethrough ? (o + c) / 2 : c;
    s.strokeStyle = s.fillStyle, s.beginPath(), s.lineWidth = n.decorationWidth || 2, s.moveTo(r, d), s.lineTo(l, d), s.stroke();
  }
}
function sU(s, t) {
  const e = s.fillStyle;
  s.fillStyle = t.color, s.fillRect(t.left, t.top, t.width, t.height), s.fillStyle = e;
}
function jl(s, t, e, a, n, i = {}) {
  const r = ya(t) ? t : [
    t
  ], l = i.strokeWidth > 0 && i.strokeColor !== "";
  let o, c;
  for (s.save(), s.font = n.string, aU(s, i), o = 0; o < r.length; ++o)
    c = r[o], i.backdrop && sU(s, i.backdrop), l && (i.strokeColor && (s.strokeStyle = i.strokeColor), ua(i.strokeWidth) || (s.lineWidth = i.strokeWidth), s.strokeText(c, e, a, i.maxWidth)), s.fillText(c, e, a, i.maxWidth), nU(s, e, a, c, i), a += Number(n.lineHeight);
  s.restore();
}
function xc(s, t) {
  const { x: e, y: a, w: n, h: i, radius: r } = t;
  s.arc(e + r.topLeft, a + r.topLeft, r.topLeft, 1.5 * ra, ra, !0), s.lineTo(e, a + i - r.bottomLeft), s.arc(e + r.bottomLeft, a + i - r.bottomLeft, r.bottomLeft, ra, Fa, !0), s.lineTo(e + n - r.bottomRight, a + i), s.arc(e + n - r.bottomRight, a + i - r.bottomRight, r.bottomRight, Fa, 0, !0), s.lineTo(e + n, a + r.topRight), s.arc(e + n - r.topRight, a + r.topRight, r.topRight, 0, -Fa, !0), s.lineTo(e + r.topLeft, a);
}
const iU = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/, rU = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
function lU(s, t) {
  const e = ("" + s).match(iU);
  if (!e || e[1] === "normal")
    return t * 1.2;
  switch (s = +e[2], e[3]) {
    case "px":
      return s;
    case "%":
      s /= 100;
      break;
  }
  return t * s;
}
const oU = (s) => +s || 0;
function Bw(s, t) {
  const e = {}, a = Ve(t), n = a ? Object.keys(t) : t, i = Ve(s) ? a ? (r) => Fe(s[r], s[t[r]]) : (r) => s[r] : () => s;
  for (const r of n)
    e[r] = oU(i(r));
  return e;
}
function zP(s) {
  return Bw(s, {
    top: "y",
    right: "x",
    bottom: "y",
    left: "x"
  });
}
function Kr(s) {
  return Bw(s, [
    "topLeft",
    "topRight",
    "bottomLeft",
    "bottomRight"
  ]);
}
function vn(s) {
  const t = zP(s);
  return t.width = t.left + t.right, t.height = t.top + t.bottom, t;
}
function an(s, t) {
  s = s || {}, t = t || en.font;
  let e = Fe(s.size, t.size);
  typeof e == "string" && (e = parseInt(e, 10));
  let a = Fe(s.style, t.style);
  a && !("" + a).match(rU) && (console.warn('Invalid font style specified: "' + a + '"'), a = void 0);
  const n = {
    family: Fe(s.family, t.family),
    lineHeight: lU(Fe(s.lineHeight, t.lineHeight), e),
    size: e,
    style: a,
    weight: Fe(s.weight, t.weight),
    string: ""
  };
  return n.string = Q2(n), n;
}
function Pd(s, t, e, a) {
  let n = !0, i, r, l;
  for (i = 0, r = s.length; i < r; ++i)
    if (l = s[i], l !== void 0 && (t !== void 0 && typeof l == "function" && (l = l(t), n = !1), e !== void 0 && ya(l) && (l = l[e % l.length], n = !1), l !== void 0))
      return a && !n && (a.cacheable = !1), l;
}
function cU(s, t, e) {
  const { min: a, max: n } = s, i = EP(t, (n - a) / 2), r = (l, o) => e && l === 0 ? 0 : l + o;
  return {
    min: r(a, -Math.abs(i)),
    max: r(n, i)
  };
}
function cl(s, t) {
  return Object.assign(Object.create(s), t);
}
function Ww(s, t = [
  ""
], e, a, n = () => s[0]) {
  const i = e || s;
  typeof a > "u" && (a = VP("_fallback", s));
  const r = {
    [Symbol.toStringTag]: "Object",
    _cacheable: !0,
    _scopes: s,
    _rootScopes: i,
    _fallback: a,
    _getTarget: n,
    override: (l) => Ww([
      l,
      ...s
    ], t, i, a)
  };
  return new Proxy(r, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(l, o) {
      return delete l[o], delete l._keys, delete s[0][o], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(l, o) {
      return WP(l, o, () => fU(o, t, s, l));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(l, o) {
      return Reflect.getOwnPropertyDescriptor(l._scopes[0], o);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(s[0]);
    },
    /**
    * A trap for the in operator.
    */
    has(l, o) {
      return U1(l).includes(o);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys(l) {
      return U1(l);
    },
    /**
    * A trap for setting property values.
    */
    set(l, o, c) {
      const d = l._storage || (l._storage = n());
      return l[o] = d[o] = c, delete l._keys, !0;
    }
  });
}
function wc(s, t, e, a) {
  const n = {
    _cacheable: !1,
    _proxy: s,
    _context: t,
    _subProxy: e,
    _stack: /* @__PURE__ */ new Set(),
    _descriptors: BP(s, a),
    setContext: (i) => wc(s, i, e, a),
    override: (i) => wc(s.override(i), t, e, a)
  };
  return new Proxy(n, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(i, r) {
      return delete i[r], delete s[r], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(i, r, l) {
      return WP(i, r, () => uU(i, r, l));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(i, r) {
      return i._descriptors.allKeys ? Reflect.has(s, r) ? {
        enumerable: !0,
        configurable: !0
      } : void 0 : Reflect.getOwnPropertyDescriptor(s, r);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(s);
    },
    /**
    * A trap for the in operator.
    */
    has(i, r) {
      return Reflect.has(s, r);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys() {
      return Reflect.ownKeys(s);
    },
    /**
    * A trap for setting property values.
    */
    set(i, r, l) {
      return s[r] = l, delete i[r], !0;
    }
  });
}
function BP(s, t = {
  scriptable: !0,
  indexable: !0
}) {
  const { _scriptable: e = t.scriptable, _indexable: a = t.indexable, _allKeys: n = t.allKeys } = s;
  return {
    allKeys: n,
    scriptable: e,
    indexable: a,
    isScriptable: As(e) ? e : () => e,
    isIndexable: As(a) ? a : () => a
  };
}
const dU = (s, t) => s ? s + Gw(t) : t, jw = (s, t) => Ve(t) && s !== "adapters" && (Object.getPrototypeOf(t) === null || t.constructor === Object);
function WP(s, t, e) {
  if (Object.prototype.hasOwnProperty.call(s, t))
    return s[t];
  const a = e();
  return s[t] = a, a;
}
function uU(s, t, e) {
  const { _proxy: a, _context: n, _subProxy: i, _descriptors: r } = s;
  let l = a[t];
  return As(l) && r.isScriptable(t) && (l = pU(t, l, s, e)), ya(l) && l.length && (l = hU(t, l, s, r.isIndexable)), jw(t, l) && (l = wc(l, n, i && i[t], r)), l;
}
function pU(s, t, e, a) {
  const { _proxy: n, _context: i, _subProxy: r, _stack: l } = e;
  if (l.has(s))
    throw new Error("Recursion detected: " + Array.from(l).join("->") + "->" + s);
  l.add(s);
  let o = t(i, r || a);
  return l.delete(s), jw(s, o) && (o = Vw(n._scopes, n, s, o)), o;
}
function hU(s, t, e, a) {
  const { _proxy: n, _context: i, _subProxy: r, _descriptors: l } = e;
  if (typeof i.index < "u" && a(s))
    return t[i.index % t.length];
  if (Ve(t[0])) {
    const o = t, c = n._scopes.filter((d) => d !== o);
    t = [];
    for (const d of o) {
      const p = Vw(c, n, s, d);
      t.push(wc(p, i, r && r[s], l));
    }
  }
  return t;
}
function jP(s, t, e) {
  return As(s) ? s(t, e) : s;
}
const mU = (s, t) => s === !0 ? t : typeof s == "string" ? el(t, s) : void 0;
function gU(s, t, e, a, n) {
  for (const i of t) {
    const r = mU(e, i);
    if (r) {
      s.add(r);
      const l = jP(r._fallback, e, n);
      if (typeof l < "u" && l !== e && l !== a)
        return l;
    } else if (r === !1 && typeof a < "u" && e !== a)
      return null;
  }
  return !1;
}
function Vw(s, t, e, a) {
  const n = t._rootScopes, i = jP(t._fallback, e, a), r = [
    ...s,
    ...n
  ], l = /* @__PURE__ */ new Set();
  l.add(a);
  let o = H1(l, r, e, i || e, a);
  return o === null || typeof i < "u" && i !== e && (o = H1(l, r, i, o, a), o === null) ? !1 : Ww(Array.from(l), [
    ""
  ], n, i, () => yU(t, e, a));
}
function H1(s, t, e, a, n) {
  for (; e; )
    e = gU(s, t, e, a, n);
  return e;
}
function yU(s, t, e) {
  const a = s._getTarget();
  t in a || (a[t] = {});
  const n = a[t];
  return ya(n) && Ve(e) ? e : n || {};
}
function fU(s, t, e, a) {
  let n;
  for (const i of t)
    if (n = VP(dU(i, s), e), typeof n < "u")
      return jw(s, n) ? Vw(e, a, s, n) : n;
}
function VP(s, t) {
  for (const e of t) {
    if (!e)
      continue;
    const a = e[s];
    if (typeof a < "u")
      return a;
  }
}
function U1(s) {
  let t = s._keys;
  return t || (t = s._keys = bU(s._scopes)), t;
}
function bU(s) {
  const t = /* @__PURE__ */ new Set();
  for (const e of s)
    for (const a of Object.keys(e).filter((n) => !n.startsWith("_")))
      t.add(a);
  return Array.from(t);
}
function qP(s, t, e, a) {
  const { iScale: n } = s, { key: i = "r" } = this._parsing, r = new Array(a);
  let l, o, c, d;
  for (l = 0, o = a; l < o; ++l)
    c = l + e, d = t[c], r[l] = {
      r: n.parse(el(d, i), c)
    };
  return r;
}
const vU = Number.EPSILON || 1e-14, Ac = (s, t) => t < s.length && !s[t].skip && s[t], KP = (s) => s === "x" ? "y" : "x";
function xU(s, t, e, a) {
  const n = s.skip ? t : s, i = t, r = e.skip ? t : e, l = vc(i, n), o = vc(r, i);
  let c = l / (l + o), d = o / (l + o);
  c = isNaN(c) ? 0 : c, d = isNaN(d) ? 0 : d;
  const p = a * c, h = a * d;
  return {
    previous: {
      x: i.x - p * (r.x - n.x),
      y: i.y - p * (r.y - n.y)
    },
    next: {
      x: i.x + h * (r.x - n.x),
      y: i.y + h * (r.y - n.y)
    }
  };
}
function wU(s, t, e) {
  const a = s.length;
  let n, i, r, l, o, c = Ac(s, 0);
  for (let d = 0; d < a - 1; ++d)
    if (o = c, c = Ac(s, d + 1), !(!o || !c)) {
      if (Bd(t[d], 0, vU)) {
        e[d] = e[d + 1] = 0;
        continue;
      }
      n = e[d] / t[d], i = e[d + 1] / t[d], l = Math.pow(n, 2) + Math.pow(i, 2), !(l <= 9) && (r = 3 / Math.sqrt(l), e[d] = n * r * t[d], e[d + 1] = i * r * t[d]);
    }
}
function AU(s, t, e = "x") {
  const a = KP(e), n = s.length;
  let i, r, l, o = Ac(s, 0);
  for (let c = 0; c < n; ++c) {
    if (r = l, l = o, o = Ac(s, c + 1), !l)
      continue;
    const d = l[e], p = l[a];
    r && (i = (d - r[e]) / 3, l[`cp1${e}`] = d - i, l[`cp1${a}`] = p - i * t[c]), o && (i = (o[e] - d) / 3, l[`cp2${e}`] = d + i, l[`cp2${a}`] = p + i * t[c]);
  }
}
function CU(s, t = "x") {
  const e = KP(t), a = s.length, n = Array(a).fill(0), i = Array(a);
  let r, l, o, c = Ac(s, 0);
  for (r = 0; r < a; ++r)
    if (l = o, o = c, c = Ac(s, r + 1), !!o) {
      if (c) {
        const d = c[t] - o[t];
        n[r] = d !== 0 ? (c[e] - o[e]) / d : 0;
      }
      i[r] = l ? c ? Ui(n[r - 1]) !== Ui(n[r]) ? 0 : (n[r - 1] + n[r]) / 2 : n[r - 1] : n[r];
    }
  wU(s, n, i), AU(s, i, t);
}
function hh(s, t, e) {
  return Math.max(Math.min(s, e), t);
}
function $U(s, t) {
  let e, a, n, i, r, l = mr(s[0], t);
  for (e = 0, a = s.length; e < a; ++e)
    r = i, i = l, l = e < a - 1 && mr(s[e + 1], t), i && (n = s[e], r && (n.cp1x = hh(n.cp1x, t.left, t.right), n.cp1y = hh(n.cp1y, t.top, t.bottom)), l && (n.cp2x = hh(n.cp2x, t.left, t.right), n.cp2y = hh(n.cp2y, t.top, t.bottom)));
}
function SU(s, t, e, a, n) {
  let i, r, l, o;
  if (t.spanGaps && (s = s.filter((c) => !c.skip)), t.cubicInterpolationMode === "monotone")
    CU(s, n);
  else {
    let c = a ? s[s.length - 1] : s[0];
    for (i = 0, r = s.length; i < r; ++i)
      l = s[i], o = xU(c, l, s[Math.min(i + 1, r - (a ? 0 : 1)) % r], t.tension), l.cp1x = o.previous.x, l.cp1y = o.previous.y, l.cp2x = o.next.x, l.cp2y = o.next.y, c = l;
  }
  t.capBezierPoints && $U(s, e);
}
function qw() {
  return typeof window < "u" && typeof document < "u";
}
function Kw(s) {
  let t = s.parentNode;
  return t && t.toString() === "[object ShadowRoot]" && (t = t.host), t;
}
function xm(s, t, e) {
  let a;
  return typeof s == "string" ? (a = parseInt(s, 10), s.indexOf("%") !== -1 && (a = a / 100 * t.parentNode[e])) : a = s, a;
}
const lf = (s) => s.ownerDocument.defaultView.getComputedStyle(s, null);
function kU(s, t) {
  return lf(s).getPropertyValue(t);
}
const TU = [
  "top",
  "right",
  "bottom",
  "left"
];
function Ml(s, t, e) {
  const a = {};
  e = e ? "-" + e : "";
  for (let n = 0; n < 4; n++) {
    const i = TU[n];
    a[i] = parseFloat(s[t + "-" + i + e]) || 0;
  }
  return a.width = a.left + a.right, a.height = a.top + a.bottom, a;
}
const LU = (s, t, e) => (s > 0 || t > 0) && (!e || !e.shadowRoot);
function DU(s, t) {
  const e = s.touches, a = e && e.length ? e[0] : s, { offsetX: n, offsetY: i } = a;
  let r = !1, l, o;
  if (LU(n, i, s.target))
    l = n, o = i;
  else {
    const c = t.getBoundingClientRect();
    l = a.clientX - c.left, o = a.clientY - c.top, r = !0;
  }
  return {
    x: l,
    y: o,
    box: r
  };
}
function Ll(s, t) {
  if ("native" in s)
    return s;
  const { canvas: e, currentDevicePixelRatio: a } = t, n = lf(e), i = n.boxSizing === "border-box", r = Ml(n, "padding"), l = Ml(n, "border", "width"), { x: o, y: c, box: d } = DU(s, e), p = r.left + (d && l.left), h = r.top + (d && l.top);
  let { width: g, height: x } = t;
  return i && (g -= r.width + l.width, x -= r.height + l.height), {
    x: Math.round((o - p) / g * e.width / a),
    y: Math.round((c - h) / x * e.height / a)
  };
}
function IU(s, t, e) {
  let a, n;
  if (t === void 0 || e === void 0) {
    const i = Kw(s);
    if (!i)
      t = s.clientWidth, e = s.clientHeight;
    else {
      const r = i.getBoundingClientRect(), l = lf(i), o = Ml(l, "border", "width"), c = Ml(l, "padding");
      t = r.width - c.width - o.width, e = r.height - c.height - o.height, a = xm(l.maxWidth, i, "clientWidth"), n = xm(l.maxHeight, i, "clientHeight");
    }
  }
  return {
    width: t,
    height: e,
    maxWidth: a || fm,
    maxHeight: n || fm
  };
}
const mh = (s) => Math.round(s * 10) / 10;
function PU(s, t, e, a) {
  const n = lf(s), i = Ml(n, "margin"), r = xm(n.maxWidth, s, "clientWidth") || fm, l = xm(n.maxHeight, s, "clientHeight") || fm, o = IU(s, t, e);
  let { width: c, height: d } = o;
  if (n.boxSizing === "content-box") {
    const h = Ml(n, "border", "width"), g = Ml(n, "padding");
    c -= g.width + h.width, d -= g.height + h.height;
  }
  return c = Math.max(0, c - i.width), d = Math.max(0, a ? c / a : d - i.height), c = mh(Math.min(c, r, o.maxWidth)), d = mh(Math.min(d, l, o.maxHeight)), c && !d && (d = mh(c / 2)), (t !== void 0 || e !== void 0) && a && o.height && d > o.height && (d = o.height, c = mh(Math.floor(d * a))), {
    width: c,
    height: d
  };
}
function F1(s, t, e) {
  const a = t || 1, n = Math.floor(s.height * a), i = Math.floor(s.width * a);
  s.height = Math.floor(s.height), s.width = Math.floor(s.width);
  const r = s.canvas;
  return r.style && (e || !r.style.height && !r.style.width) && (r.style.height = `${s.height}px`, r.style.width = `${s.width}px`), s.currentDevicePixelRatio !== a || r.height !== n || r.width !== i ? (s.currentDevicePixelRatio = a, r.height = n, r.width = i, s.ctx.setTransform(a, 0, 0, a, 0, 0), !0) : !1;
}
const EU = function() {
  let s = !1;
  try {
    const t = {
      get passive() {
        return s = !0, !1;
      }
    };
    qw() && (window.addEventListener("test", null, t), window.removeEventListener("test", null, t));
  } catch {
  }
  return s;
}();
function z1(s, t) {
  const e = kU(s, t), a = e && e.match(/^(\d+)(\.\d+)?px$/);
  return a ? +a[1] : void 0;
}
function Dl(s, t, e, a) {
  return {
    x: s.x + e * (t.x - s.x),
    y: s.y + e * (t.y - s.y)
  };
}
function NU(s, t, e, a) {
  return {
    x: s.x + e * (t.x - s.x),
    y: a === "middle" ? e < 0.5 ? s.y : t.y : a === "after" ? e < 1 ? s.y : t.y : e > 0 ? t.y : s.y
  };
}
function RU(s, t, e, a) {
  const n = {
    x: s.cp2x,
    y: s.cp2y
  }, i = {
    x: t.cp1x,
    y: t.cp1y
  }, r = Dl(s, n, e), l = Dl(n, i, e), o = Dl(i, t, e), c = Dl(r, l, e), d = Dl(l, o, e);
  return Dl(c, d, e);
}
const YU = function(s, t) {
  return {
    x(e) {
      return s + s + t - e;
    },
    setWidth(e) {
      t = e;
    },
    textAlign(e) {
      return e === "center" ? e : e === "right" ? "left" : "right";
    },
    xPlus(e, a) {
      return e - a;
    },
    leftForLtr(e, a) {
      return e - a;
    }
  };
}, _U = function() {
  return {
    x(s) {
      return s;
    },
    setWidth(s) {
    },
    textAlign(s) {
      return s;
    },
    xPlus(s, t) {
      return s + t;
    },
    leftForLtr(s, t) {
      return s;
    }
  };
};
function mc(s, t, e) {
  return s ? YU(t, e) : _U();
}
function JP(s, t) {
  let e, a;
  (t === "ltr" || t === "rtl") && (e = s.canvas.style, a = [
    e.getPropertyValue("direction"),
    e.getPropertyPriority("direction")
  ], e.setProperty("direction", t, "important"), s.prevTextDirection = a);
}
function QP(s, t) {
  t !== void 0 && (delete s.prevTextDirection, s.canvas.style.setProperty("direction", t[0], t[1]));
}
function ZP(s) {
  return s === "angle" ? {
    between: du,
    compare: O2,
    normalize: Ps
  } : {
    between: pr,
    compare: (t, e) => t - e,
    normalize: (t) => t
  };
}
function B1({ start: s, end: t, count: e, loop: a, style: n }) {
  return {
    start: s % e,
    end: t % e,
    loop: a && (t - s + 1) % e === 0,
    style: n
  };
}
function OU(s, t, e) {
  const { property: a, start: n, end: i } = e, { between: r, normalize: l } = ZP(a), o = t.length;
  let { start: c, end: d, loop: p } = s, h, g;
  if (p) {
    for (c += o, d += o, h = 0, g = o; h < g && r(l(t[c % o][a]), n, i); ++h)
      c--, d--;
    c %= o, d %= o;
  }
  return d < c && (d += o), {
    start: c,
    end: d,
    loop: p,
    style: s.style
  };
}
function tE(s, t, e) {
  if (!e)
    return [
      s
    ];
  const { property: a, start: n, end: i } = e, r = t.length, { compare: l, between: o, normalize: c } = ZP(a), { start: d, end: p, loop: h, style: g } = OU(s, t, e), x = [];
  let b = !1, A = null, T, R, C;
  const v = () => o(n, C, T) && l(n, C) !== 0, P = () => l(i, T) === 0 || o(i, C, T), O = () => b || v(), N = () => !b || P();
  for (let H = d, F = d; H <= p; ++H)
    R = t[H % r], !R.skip && (T = c(R[a]), T !== C && (b = o(T, n, i), A === null && O() && (A = l(T, n) === 0 ? H : F), A !== null && N() && (x.push(B1({
      start: A,
      end: H,
      loop: h,
      count: r,
      style: g
    })), A = null), F = H, C = T));
  return A !== null && x.push(B1({
    start: A,
    end: p,
    loop: h,
    count: r,
    style: g
  })), x;
}
function eE(s, t) {
  const e = [], a = s.segments;
  for (let n = 0; n < a.length; n++) {
    const i = tE(a[n], s.points, t);
    i.length && e.push(...i);
  }
  return e;
}
function MU(s, t, e, a) {
  let n = 0, i = t - 1;
  if (e && !a)
    for (; n < t && !s[n].skip; )
      n++;
  for (; n < t && s[n].skip; )
    n++;
  for (n %= t, e && (i += n); i > n && s[i % t].skip; )
    i--;
  return i %= t, {
    start: n,
    end: i
  };
}
function XU(s, t, e, a) {
  const n = s.length, i = [];
  let r = t, l = s[t], o;
  for (o = t + 1; o <= e; ++o) {
    const c = s[o % n];
    c.skip || c.stop ? l.skip || (a = !1, i.push({
      start: t % n,
      end: (o - 1) % n,
      loop: a
    }), t = r = c.stop ? o : null) : (r = o, l.skip && (t = o)), l = c;
  }
  return r !== null && i.push({
    start: t % n,
    end: r % n,
    loop: a
  }), i;
}
function GU(s, t) {
  const e = s.points, a = s.options.spanGaps, n = e.length;
  if (!n)
    return [];
  const i = !!s._loop, { start: r, end: l } = MU(e, n, i, a);
  if (a === !0)
    return W1(s, [
      {
        start: r,
        end: l,
        loop: i
      }
    ], e, t);
  const o = l < r ? l + n : l, c = !!s._fullLoop && r === 0 && l === n - 1;
  return W1(s, XU(e, r, o, c), e, t);
}
function W1(s, t, e, a) {
  return !a || !a.setContext || !e ? t : HU(s, t, e, a);
}
function HU(s, t, e, a) {
  const n = s._chart.getContext(), i = j1(s.options), { _datasetIndex: r, options: { spanGaps: l } } = s, o = e.length, c = [];
  let d = i, p = t[0].start, h = p;
  function g(x, b, A, T) {
    const R = l ? -1 : 1;
    if (x !== b) {
      for (x += o; e[x % o].skip; )
        x -= R;
      for (; e[b % o].skip; )
        b += R;
      x % o !== b % o && (c.push({
        start: x % o,
        end: b % o,
        loop: A,
        style: T
      }), d = T, p = b % o);
    }
  }
  for (const x of t) {
    p = l ? p : x.start;
    let b = e[p % o], A;
    for (h = p + 1; h <= x.end; h++) {
      const T = e[h % o];
      A = j1(a.setContext(cl(n, {
        type: "segment",
        p0: b,
        p1: T,
        p0DataIndex: (h - 1) % o,
        p1DataIndex: h % o,
        datasetIndex: r
      }))), UU(A, d) && g(p, h - 1, x.loop, d), b = T, d = A;
    }
    p < h - 1 && g(p, h - 1, x.loop, d);
  }
  return c;
}
function j1(s) {
  return {
    backgroundColor: s.backgroundColor,
    borderCapStyle: s.borderCapStyle,
    borderDash: s.borderDash,
    borderDashOffset: s.borderDashOffset,
    borderJoinStyle: s.borderJoinStyle,
    borderWidth: s.borderWidth,
    borderColor: s.borderColor
  };
}
function UU(s, t) {
  if (!t)
    return !1;
  const e = [], a = function(n, i) {
    return zw(i) ? (e.includes(i) || e.push(i), e.indexOf(i)) : i;
  };
  return JSON.stringify(s, a) !== JSON.stringify(t, a);
}
/*!
 * Chart.js v4.4.2
 * https://www.chartjs.org
 * (c) 2024 Chart.js Contributors
 * Released under the MIT License
 */
class FU {
  constructor() {
    this._request = null, this._charts = /* @__PURE__ */ new Map(), this._running = !1, this._lastDate = void 0;
  }
  _notify(t, e, a, n) {
    const i = e.listeners[n], r = e.duration;
    i.forEach((l) => l({
      chart: t,
      initial: e.initial,
      numSteps: r,
      currentStep: Math.min(a - e.start, r)
    }));
  }
  _refresh() {
    this._request || (this._running = !0, this._request = MP.call(window, () => {
      this._update(), this._request = null, this._running && this._refresh();
    }));
  }
  _update(t = Date.now()) {
    let e = 0;
    this._charts.forEach((a, n) => {
      if (!a.running || !a.items.length)
        return;
      const i = a.items;
      let r = i.length - 1, l = !1, o;
      for (; r >= 0; --r)
        o = i[r], o._active ? (o._total > a.duration && (a.duration = o._total), o.tick(t), l = !0) : (i[r] = i[i.length - 1], i.pop());
      l && (n.draw(), this._notify(n, a, t, "progress")), i.length || (a.running = !1, this._notify(n, a, t, "complete"), a.initial = !1), e += i.length;
    }), this._lastDate = t, e === 0 && (this._running = !1);
  }
  _getAnims(t) {
    const e = this._charts;
    let a = e.get(t);
    return a || (a = {
      running: !1,
      initial: !0,
      items: [],
      listeners: {
        complete: [],
        progress: []
      }
    }, e.set(t, a)), a;
  }
  listen(t, e, a) {
    this._getAnims(t).listeners[e].push(a);
  }
  add(t, e) {
    !e || !e.length || this._getAnims(t).items.push(...e);
  }
  has(t) {
    return this._getAnims(t).items.length > 0;
  }
  start(t) {
    const e = this._charts.get(t);
    e && (e.running = !0, e.start = Date.now(), e.duration = e.items.reduce((a, n) => Math.max(a, n._duration), 0), this._refresh());
  }
  running(t) {
    if (!this._running)
      return !1;
    const e = this._charts.get(t);
    return !(!e || !e.running || !e.items.length);
  }
  stop(t) {
    const e = this._charts.get(t);
    if (!e || !e.items.length)
      return;
    const a = e.items;
    let n = a.length - 1;
    for (; n >= 0; --n)
      a[n].cancel();
    e.items = [], this._notify(t, e, Date.now(), "complete");
  }
  remove(t) {
    return this._charts.delete(t);
  }
}
var rr = /* @__PURE__ */ new FU();
const V1 = "transparent", zU = {
  boolean(s, t, e) {
    return e > 0.5 ? t : s;
  },
  color(s, t, e) {
    const a = M1(s || V1), n = a.valid && M1(t || V1);
    return n && n.valid ? n.mix(a, e).hexString() : t;
  },
  number(s, t, e) {
    return s + (t - s) * e;
  }
};
class BU {
  constructor(t, e, a, n) {
    const i = e[a];
    n = Pd([
      t.to,
      n,
      i,
      t.from
    ]);
    const r = Pd([
      t.from,
      i,
      n
    ]);
    this._active = !0, this._fn = t.fn || zU[t.type || typeof r], this._easing = Wd[t.easing] || Wd.linear, this._start = Math.floor(Date.now() + (t.delay || 0)), this._duration = this._total = Math.floor(t.duration), this._loop = !!t.loop, this._target = e, this._prop = a, this._from = r, this._to = n, this._promises = void 0;
  }
  active() {
    return this._active;
  }
  update(t, e, a) {
    if (this._active) {
      this._notify(!1);
      const n = this._target[this._prop], i = a - this._start, r = this._duration - i;
      this._start = a, this._duration = Math.floor(Math.max(r, t.duration)), this._total += i, this._loop = !!t.loop, this._to = Pd([
        t.to,
        e,
        n,
        t.from
      ]), this._from = Pd([
        t.from,
        n,
        e
      ]);
    }
  }
  cancel() {
    this._active && (this.tick(Date.now()), this._active = !1, this._notify(!1));
  }
  tick(t) {
    const e = t - this._start, a = this._duration, n = this._prop, i = this._from, r = this._loop, l = this._to;
    let o;
    if (this._active = i !== l && (r || e < a), !this._active) {
      this._target[n] = l, this._notify(!0);
      return;
    }
    if (e < 0) {
      this._target[n] = i;
      return;
    }
    o = e / a % 2, o = r && o > 1 ? 2 - o : o, o = this._easing(Math.min(1, Math.max(0, o))), this._target[n] = this._fn(i, l, o);
  }
  wait() {
    const t = this._promises || (this._promises = []);
    return new Promise((e, a) => {
      t.push({
        res: e,
        rej: a
      });
    });
  }
  _notify(t) {
    const e = t ? "res" : "rej", a = this._promises || [];
    for (let n = 0; n < a.length; n++)
      a[n][e]();
  }
}
class Jw {
  constructor(t, e) {
    this._chart = t, this._properties = /* @__PURE__ */ new Map(), this.configure(e);
  }
  configure(t) {
    if (!Ve(t))
      return;
    const e = Object.keys(en.animation), a = this._properties;
    Object.getOwnPropertyNames(t).forEach((n) => {
      const i = t[n];
      if (!Ve(i))
        return;
      const r = {};
      for (const l of e)
        r[l] = i[l];
      (ya(i.properties) && i.properties || [
        n
      ]).forEach((l) => {
        (l === n || !a.has(l)) && a.set(l, r);
      });
    });
  }
  _animateOptions(t, e) {
    const a = e.options, n = jU(t, a);
    if (!n)
      return [];
    const i = this._createAnimations(n, a);
    return a.$shared && WU(t.options.$animations, a).then(() => {
      t.options = a;
    }, () => {
    }), i;
  }
  _createAnimations(t, e) {
    const a = this._properties, n = [], i = t.$animations || (t.$animations = {}), r = Object.keys(e), l = Date.now();
    let o;
    for (o = r.length - 1; o >= 0; --o) {
      const c = r[o];
      if (c.charAt(0) === "$")
        continue;
      if (c === "options") {
        n.push(...this._animateOptions(t, e));
        continue;
      }
      const d = e[c];
      let p = i[c];
      const h = a.get(c);
      if (p)
        if (h && p.active()) {
          p.update(h, d, l);
          continue;
        } else
          p.cancel();
      if (!h || !h.duration) {
        t[c] = d;
        continue;
      }
      i[c] = p = new BU(h, t, c, d), n.push(p);
    }
    return n;
  }
  update(t, e) {
    if (this._properties.size === 0) {
      Object.assign(t, e);
      return;
    }
    const a = this._createAnimations(t, e);
    if (a.length)
      return rr.add(this._chart, a), !0;
  }
}
function WU(s, t) {
  const e = [], a = Object.keys(t);
  for (let n = 0; n < a.length; n++) {
    const i = s[a[n]];
    i && i.active() && e.push(i.wait());
  }
  return Promise.all(e);
}
function jU(s, t) {
  if (!t)
    return;
  let e = s.options;
  if (!e) {
    s.options = t;
    return;
  }
  return e.$shared && (s.options = e = Object.assign({}, e, {
    $shared: !1,
    $animations: {}
  })), e;
}
function q1(s, t) {
  const e = s && s.options || {}, a = e.reverse, n = e.min === void 0 ? t : 0, i = e.max === void 0 ? t : 0;
  return {
    start: a ? i : n,
    end: a ? n : i
  };
}
function VU(s, t, e) {
  if (e === !1)
    return !1;
  const a = q1(s, e), n = q1(t, e);
  return {
    top: n.end,
    right: a.end,
    bottom: n.start,
    left: a.start
  };
}
function qU(s) {
  let t, e, a, n;
  return Ve(s) ? (t = s.top, e = s.right, a = s.bottom, n = s.left) : t = e = a = n = s, {
    top: t,
    right: e,
    bottom: a,
    left: n,
    disabled: s === !1
  };
}
function aE(s, t) {
  const e = [], a = s._getSortedDatasetMetas(t);
  let n, i;
  for (n = 0, i = a.length; n < i; ++n)
    e.push(a[n].index);
  return e;
}
function K1(s, t, e, a = {}) {
  const n = s.keys, i = a.mode === "single";
  let r, l, o, c;
  if (t !== null) {
    for (r = 0, l = n.length; r < l; ++r) {
      if (o = +n[r], o === e) {
        if (a.all)
          continue;
        break;
      }
      c = s.values[o], Va(c) && (i || t === 0 || Ui(t) === Ui(c)) && (t += c);
    }
    return t;
  }
}
function KU(s) {
  const t = Object.keys(s), e = new Array(t.length);
  let a, n, i;
  for (a = 0, n = t.length; a < n; ++a)
    i = t[a], e[a] = {
      x: i,
      y: s[i]
    };
  return e;
}
function J1(s, t) {
  const e = s && s.options.stacked;
  return e || e === void 0 && t.stack !== void 0;
}
function JU(s, t, e) {
  return `${s.id}.${t.id}.${e.stack || e.type}`;
}
function QU(s) {
  const { min: t, max: e, minDefined: a, maxDefined: n } = s.getUserBounds();
  return {
    min: a ? t : Number.NEGATIVE_INFINITY,
    max: n ? e : Number.POSITIVE_INFINITY
  };
}
function ZU(s, t, e) {
  const a = s[t] || (s[t] = {});
  return a[e] || (a[e] = {});
}
function Q1(s, t, e, a) {
  for (const n of t.getMatchingVisibleMetas(a).reverse()) {
    const i = s[n.index];
    if (e && i > 0 || !e && i < 0)
      return n.index;
  }
  return null;
}
function Z1(s, t) {
  const { chart: e, _cachedMeta: a } = s, n = e._stacks || (e._stacks = {}), { iScale: i, vScale: r, index: l } = a, o = i.axis, c = r.axis, d = JU(i, r, a), p = t.length;
  let h;
  for (let g = 0; g < p; ++g) {
    const x = t[g], { [o]: b, [c]: A } = x, T = x._stacks || (x._stacks = {});
    h = T[c] = ZU(n, d, b), h[l] = A, h._top = Q1(h, r, !0, a.type), h._bottom = Q1(h, r, !1, a.type);
    const R = h._visualValues || (h._visualValues = {});
    R[l] = A;
  }
}
function zb(s, t) {
  const e = s.scales;
  return Object.keys(e).filter((a) => e[a].axis === t).shift();
}
function tF(s, t) {
  return cl(s, {
    active: !1,
    dataset: void 0,
    datasetIndex: t,
    index: t,
    mode: "default",
    type: "dataset"
  });
}
function eF(s, t, e) {
  return cl(s, {
    active: !1,
    dataIndex: t,
    parsed: void 0,
    raw: void 0,
    element: e,
    index: t,
    mode: "default",
    type: "data"
  });
}
function bd(s, t) {
  const e = s.controller.index, a = s.vScale && s.vScale.axis;
  if (a) {
    t = t || s._parsed;
    for (const n of t) {
      const i = n._stacks;
      if (!i || i[a] === void 0 || i[a][e] === void 0)
        return;
      delete i[a][e], i[a]._visualValues !== void 0 && i[a]._visualValues[e] !== void 0 && delete i[a]._visualValues[e];
    }
  }
}
const Bb = (s) => s === "reset" || s === "none", tD = (s, t) => t ? s : Object.assign({}, s), aF = (s, t, e) => s && !t.hidden && t._stacked && {
  keys: aE(e, !0),
  values: null
};
class fi {
  constructor(t, e) {
    this.chart = t, this._ctx = t.ctx, this.index = e, this._cachedDataOpts = {}, this._cachedMeta = this.getMeta(), this._type = this._cachedMeta.type, this.options = void 0, this._parsing = !1, this._data = void 0, this._objectData = void 0, this._sharedOptions = void 0, this._drawStart = void 0, this._drawCount = void 0, this.enableOptionSharing = !1, this.supportsDecimation = !1, this.$context = void 0, this._syncList = [], this.datasetElementType = new.target.datasetElementType, this.dataElementType = new.target.dataElementType, this.initialize();
  }
  initialize() {
    const t = this._cachedMeta;
    this.configure(), this.linkScales(), t._stacked = J1(t.vScale, t), this.addElements(), this.options.fill && !this.chart.isPluginEnabled("filler") && console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
  }
  updateIndex(t) {
    this.index !== t && bd(this._cachedMeta), this.index = t;
  }
  linkScales() {
    const t = this.chart, e = this._cachedMeta, a = this.getDataset(), n = (p, h, g, x) => p === "x" ? h : p === "r" ? x : g, i = e.xAxisID = Fe(a.xAxisID, zb(t, "x")), r = e.yAxisID = Fe(a.yAxisID, zb(t, "y")), l = e.rAxisID = Fe(a.rAxisID, zb(t, "r")), o = e.indexAxis, c = e.iAxisID = n(o, i, r, l), d = e.vAxisID = n(o, r, i, l);
    e.xScale = this.getScaleForId(i), e.yScale = this.getScaleForId(r), e.rScale = this.getScaleForId(l), e.iScale = this.getScaleForId(c), e.vScale = this.getScaleForId(d);
  }
  getDataset() {
    return this.chart.data.datasets[this.index];
  }
  getMeta() {
    return this.chart.getDatasetMeta(this.index);
  }
  getScaleForId(t) {
    return this.chart.scales[t];
  }
  _getOtherScale(t) {
    const e = this._cachedMeta;
    return t === e.iScale ? e.vScale : e.iScale;
  }
  reset() {
    this._update("reset");
  }
  _destroy() {
    const t = this._cachedMeta;
    this._data && Y1(this._data, this), t._stacked && bd(t);
  }
  _dataCheck() {
    const t = this.getDataset(), e = t.data || (t.data = []), a = this._data;
    if (Ve(e))
      this._data = KU(e);
    else if (a !== e) {
      if (a) {
        Y1(a, this);
        const n = this._cachedMeta;
        bd(n), n._parsed = [];
      }
      e && Object.isExtensible(e) && H2(e, this), this._syncList = [], this._data = e;
    }
  }
  addElements() {
    const t = this._cachedMeta;
    this._dataCheck(), this.datasetElementType && (t.dataset = new this.datasetElementType());
  }
  buildOrUpdateElements(t) {
    const e = this._cachedMeta, a = this.getDataset();
    let n = !1;
    this._dataCheck();
    const i = e._stacked;
    e._stacked = J1(e.vScale, e), e.stack !== a.stack && (n = !0, bd(e), e.stack = a.stack), this._resyncElements(t), (n || i !== e._stacked) && Z1(this, e._parsed);
  }
  configure() {
    const t = this.chart.config, e = t.datasetScopeKeys(this._type), a = t.getOptionScopes(this.getDataset(), e, !0);
    this.options = t.createResolver(a, this.getContext()), this._parsing = this.options.parsing, this._cachedDataOpts = {};
  }
  parse(t, e) {
    const { _cachedMeta: a, _data: n } = this, { iScale: i, _stacked: r } = a, l = i.axis;
    let o = t === 0 && e === n.length ? !0 : a._sorted, c = t > 0 && a._parsed[t - 1], d, p, h;
    if (this._parsing === !1)
      a._parsed = n, a._sorted = !0, h = n;
    else {
      ya(n[t]) ? h = this.parseArrayData(a, n, t, e) : Ve(n[t]) ? h = this.parseObjectData(a, n, t, e) : h = this.parsePrimitiveData(a, n, t, e);
      const g = () => p[l] === null || c && p[l] < c[l];
      for (d = 0; d < e; ++d)
        a._parsed[d + t] = p = h[d], o && (g() && (o = !1), c = p);
      a._sorted = o;
    }
    r && Z1(this, h);
  }
  parsePrimitiveData(t, e, a, n) {
    const { iScale: i, vScale: r } = t, l = i.axis, o = r.axis, c = i.getLabels(), d = i === r, p = new Array(n);
    let h, g, x;
    for (h = 0, g = n; h < g; ++h)
      x = h + a, p[h] = {
        [l]: d || i.parse(c[x], x),
        [o]: r.parse(e[x], x)
      };
    return p;
  }
  parseArrayData(t, e, a, n) {
    const { xScale: i, yScale: r } = t, l = new Array(n);
    let o, c, d, p;
    for (o = 0, c = n; o < c; ++o)
      d = o + a, p = e[d], l[o] = {
        x: i.parse(p[0], d),
        y: r.parse(p[1], d)
      };
    return l;
  }
  parseObjectData(t, e, a, n) {
    const { xScale: i, yScale: r } = t, { xAxisKey: l = "x", yAxisKey: o = "y" } = this._parsing, c = new Array(n);
    let d, p, h, g;
    for (d = 0, p = n; d < p; ++d)
      h = d + a, g = e[h], c[d] = {
        x: i.parse(el(g, l), h),
        y: r.parse(el(g, o), h)
      };
    return c;
  }
  getParsed(t) {
    return this._cachedMeta._parsed[t];
  }
  getDataElement(t) {
    return this._cachedMeta.data[t];
  }
  applyStack(t, e, a) {
    const n = this.chart, i = this._cachedMeta, r = e[t.axis], l = {
      keys: aE(n, !0),
      values: e._stacks[t.axis]._visualValues
    };
    return K1(l, r, i.index, {
      mode: a
    });
  }
  updateRangeFromParsed(t, e, a, n) {
    const i = a[e.axis];
    let r = i === null ? NaN : i;
    const l = n && a._stacks[e.axis];
    n && l && (n.values = l, r = K1(n, i, this._cachedMeta.index)), t.min = Math.min(t.min, r), t.max = Math.max(t.max, r);
  }
  getMinMax(t, e) {
    const a = this._cachedMeta, n = a._parsed, i = a._sorted && t === a.iScale, r = n.length, l = this._getOtherScale(t), o = aF(e, a, this.chart), c = {
      min: Number.POSITIVE_INFINITY,
      max: Number.NEGATIVE_INFINITY
    }, { min: d, max: p } = QU(l);
    let h, g;
    function x() {
      g = n[h];
      const b = g[l.axis];
      return !Va(g[t.axis]) || d > b || p < b;
    }
    for (h = 0; h < r && !(!x() && (this.updateRangeFromParsed(c, t, g, o), i)); ++h)
      ;
    if (i) {
      for (h = r - 1; h >= 0; --h)
        if (!x()) {
          this.updateRangeFromParsed(c, t, g, o);
          break;
        }
    }
    return c;
  }
  getAllParsedValues(t) {
    const e = this._cachedMeta._parsed, a = [];
    let n, i, r;
    for (n = 0, i = e.length; n < i; ++n)
      r = e[n][t.axis], Va(r) && a.push(r);
    return a;
  }
  getMaxOverflow() {
    return !1;
  }
  getLabelAndValue(t) {
    const e = this._cachedMeta, a = e.iScale, n = e.vScale, i = this.getParsed(t);
    return {
      label: a ? "" + a.getLabelForValue(i[a.axis]) : "",
      value: n ? "" + n.getLabelForValue(i[n.axis]) : ""
    };
  }
  _update(t) {
    const e = this._cachedMeta;
    this.update(t || "default"), e._clip = qU(Fe(this.options.clip, VU(e.xScale, e.yScale, this.getMaxOverflow())));
  }
  update(t) {
  }
  draw() {
    const t = this._ctx, e = this.chart, a = this._cachedMeta, n = a.data || [], i = e.chartArea, r = [], l = this._drawStart || 0, o = this._drawCount || n.length - l, c = this.options.drawActiveElementsOnTop;
    let d;
    for (a.dataset && a.dataset.draw(t, i, l, o), d = l; d < l + o; ++d) {
      const p = n[d];
      p.hidden || (p.active && c ? r.push(p) : p.draw(t, i));
    }
    for (d = 0; d < r.length; ++d)
      r[d].draw(t, i);
  }
  getStyle(t, e) {
    const a = e ? "active" : "default";
    return t === void 0 && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(a) : this.resolveDataElementOptions(t || 0, a);
  }
  getContext(t, e, a) {
    const n = this.getDataset();
    let i;
    if (t >= 0 && t < this._cachedMeta.data.length) {
      const r = this._cachedMeta.data[t];
      i = r.$context || (r.$context = eF(this.getContext(), t, r)), i.parsed = this.getParsed(t), i.raw = n.data[t], i.index = i.dataIndex = t;
    } else
      i = this.$context || (this.$context = tF(this.chart.getContext(), this.index)), i.dataset = n, i.index = i.datasetIndex = this.index;
    return i.active = !!e, i.mode = a, i;
  }
  resolveDatasetElementOptions(t) {
    return this._resolveElementOptions(this.datasetElementType.id, t);
  }
  resolveDataElementOptions(t, e) {
    return this._resolveElementOptions(this.dataElementType.id, e, t);
  }
  _resolveElementOptions(t, e = "default", a) {
    const n = e === "active", i = this._cachedDataOpts, r = t + "-" + e, l = i[r], o = this.enableOptionSharing && Cs(a);
    if (l)
      return tD(l, o);
    const c = this.chart.config, d = c.datasetElementScopeKeys(this._type, t), p = n ? [
      `${t}Hover`,
      "hover",
      t,
      ""
    ] : [
      t,
      ""
    ], h = c.getOptionScopes(this.getDataset(), d), g = Object.keys(en.elements[t]), x = () => this.getContext(a, n, e), b = c.resolveNamedOptions(h, g, x, p);
    return b.$shared && (b.$shared = o, i[r] = Object.freeze(tD(b, o))), b;
  }
  _resolveAnimations(t, e, a) {
    const n = this.chart, i = this._cachedDataOpts, r = `animation-${e}`, l = i[r];
    if (l)
      return l;
    let o;
    if (n.options.animation !== !1) {
      const d = this.chart.config, p = d.datasetAnimationScopeKeys(this._type, e), h = d.getOptionScopes(this.getDataset(), p);
      o = d.createResolver(h, this.getContext(t, a, e));
    }
    const c = new Jw(n, o && o.animations);
    return o && o._cacheable && (i[r] = Object.freeze(c)), c;
  }
  getSharedOptions(t) {
    if (t.$shared)
      return this._sharedOptions || (this._sharedOptions = Object.assign({}, t));
  }
  includeOptions(t, e) {
    return !e || Bb(t) || this.chart._animationsDisabled;
  }
  _getSharedOptions(t, e) {
    const a = this.resolveDataElementOptions(t, e), n = this._sharedOptions, i = this.getSharedOptions(a), r = this.includeOptions(e, i) || i !== n;
    return this.updateSharedOptions(i, e, a), {
      sharedOptions: i,
      includeOptions: r
    };
  }
  updateElement(t, e, a, n) {
    Bb(n) ? Object.assign(t, a) : this._resolveAnimations(e, n).update(t, a);
  }
  updateSharedOptions(t, e, a) {
    t && !Bb(e) && this._resolveAnimations(void 0, e).update(t, a);
  }
  _setStyle(t, e, a, n) {
    t.active = n;
    const i = this.getStyle(e, n);
    this._resolveAnimations(e, a, n).update(t, {
      options: !n && this.getSharedOptions(i) || i
    });
  }
  removeHoverStyle(t, e, a) {
    this._setStyle(t, a, "active", !1);
  }
  setHoverStyle(t, e, a) {
    this._setStyle(t, a, "active", !0);
  }
  _removeDatasetHoverStyle() {
    const t = this._cachedMeta.dataset;
    t && this._setStyle(t, void 0, "active", !1);
  }
  _setDatasetHoverStyle() {
    const t = this._cachedMeta.dataset;
    t && this._setStyle(t, void 0, "active", !0);
  }
  _resyncElements(t) {
    const e = this._data, a = this._cachedMeta.data;
    for (const [l, o, c] of this._syncList)
      this[l](o, c);
    this._syncList = [];
    const n = a.length, i = e.length, r = Math.min(i, n);
    r && this.parse(0, r), i > n ? this._insertElements(n, i - n, t) : i < n && this._removeElements(i, n - i);
  }
  _insertElements(t, e, a = !0) {
    const n = this._cachedMeta, i = n.data, r = t + e;
    let l;
    const o = (c) => {
      for (c.length += e, l = c.length - 1; l >= r; l--)
        c[l] = c[l - e];
    };
    for (o(i), l = t; l < r; ++l)
      i[l] = new this.dataElementType();
    this._parsing && o(n._parsed), this.parse(t, e), a && this.updateElements(i, t, e, "reset");
  }
  updateElements(t, e, a, n) {
  }
  _removeElements(t, e) {
    const a = this._cachedMeta;
    if (this._parsing) {
      const n = a._parsed.splice(t, e);
      a._stacked && bd(a, n);
    }
    a.data.splice(t, e);
  }
  _sync(t) {
    if (this._parsing)
      this._syncList.push(t);
    else {
      const [e, a, n] = t;
      this[e](a, n);
    }
    this.chart._dataChanges.push([
      this.index,
      ...t
    ]);
  }
  _onDataPush() {
    const t = arguments.length;
    this._sync([
      "_insertElements",
      this.getDataset().data.length - t,
      t
    ]);
  }
  _onDataPop() {
    this._sync([
      "_removeElements",
      this._cachedMeta.data.length - 1,
      1
    ]);
  }
  _onDataShift() {
    this._sync([
      "_removeElements",
      0,
      1
    ]);
  }
  _onDataSplice(t, e) {
    e && this._sync([
      "_removeElements",
      t,
      e
    ]);
    const a = arguments.length - 2;
    a && this._sync([
      "_insertElements",
      t,
      a
    ]);
  }
  _onDataUnshift() {
    this._sync([
      "_insertElements",
      0,
      arguments.length
    ]);
  }
}
Jt(fi, "defaults", {}), Jt(fi, "datasetElementType", null), Jt(fi, "dataElementType", null);
function nF(s, t) {
  if (!s._cache.$bar) {
    const e = s.getMatchingVisibleMetas(t);
    let a = [];
    for (let n = 0, i = e.length; n < i; n++)
      a = a.concat(e[n].controller.getAllParsedValues(s));
    s._cache.$bar = OP(a.sort((n, i) => n - i));
  }
  return s._cache.$bar;
}
function sF(s) {
  const t = s.iScale, e = nF(t, s.type);
  let a = t._length, n, i, r, l;
  const o = () => {
    r === 32767 || r === -32768 || (Cs(l) && (a = Math.min(a, Math.abs(r - l) || a)), l = r);
  };
  for (n = 0, i = e.length; n < i; ++n)
    r = t.getPixelForValue(e[n]), o();
  for (l = void 0, n = 0, i = t.ticks.length; n < i; ++n)
    r = t.getPixelForTick(n), o();
  return a;
}
function iF(s, t, e, a) {
  const n = e.barThickness;
  let i, r;
  return ua(n) ? (i = t.min * e.categoryPercentage, r = e.barPercentage) : (i = n * a, r = 1), {
    chunk: i / a,
    ratio: r,
    start: t.pixels[s] - i / 2
  };
}
function rF(s, t, e, a) {
  const n = t.pixels, i = n[s];
  let r = s > 0 ? n[s - 1] : null, l = s < n.length - 1 ? n[s + 1] : null;
  const o = e.categoryPercentage;
  r === null && (r = i - (l === null ? t.end - t.start : l - i)), l === null && (l = i + i - r);
  const c = i - (i - Math.min(r, l)) / 2 * o;
  return {
    chunk: Math.abs(l - r) / 2 * o / a,
    ratio: e.barPercentage,
    start: c
  };
}
function lF(s, t, e, a) {
  const n = e.parse(s[0], a), i = e.parse(s[1], a), r = Math.min(n, i), l = Math.max(n, i);
  let o = r, c = l;
  Math.abs(r) > Math.abs(l) && (o = l, c = r), t[e.axis] = c, t._custom = {
    barStart: o,
    barEnd: c,
    start: n,
    end: i,
    min: r,
    max: l
  };
}
function nE(s, t, e, a) {
  return ya(s) ? lF(s, t, e, a) : t[e.axis] = e.parse(s, a), t;
}
function eD(s, t, e, a) {
  const n = s.iScale, i = s.vScale, r = n.getLabels(), l = n === i, o = [];
  let c, d, p, h;
  for (c = e, d = e + a; c < d; ++c)
    h = t[c], p = {}, p[n.axis] = l || n.parse(r[c], c), o.push(nE(h, p, i, c));
  return o;
}
function Wb(s) {
  return s && s.barStart !== void 0 && s.barEnd !== void 0;
}
function oF(s, t, e) {
  return s !== 0 ? Ui(s) : (t.isHorizontal() ? 1 : -1) * (t.min >= e ? 1 : -1);
}
function cF(s) {
  let t, e, a, n, i;
  return s.horizontal ? (t = s.base > s.x, e = "left", a = "right") : (t = s.base < s.y, e = "bottom", a = "top"), t ? (n = "end", i = "start") : (n = "start", i = "end"), {
    start: e,
    end: a,
    reverse: t,
    top: n,
    bottom: i
  };
}
function dF(s, t, e, a) {
  let n = t.borderSkipped;
  const i = {};
  if (!n) {
    s.borderSkipped = i;
    return;
  }
  if (n === !0) {
    s.borderSkipped = {
      top: !0,
      right: !0,
      bottom: !0,
      left: !0
    };
    return;
  }
  const { start: r, end: l, reverse: o, top: c, bottom: d } = cF(s);
  n === "middle" && e && (s.enableBorderRadius = !0, (e._top || 0) === a ? n = c : (e._bottom || 0) === a ? n = d : (i[aD(d, r, l, o)] = !0, n = c)), i[aD(n, r, l, o)] = !0, s.borderSkipped = i;
}
function aD(s, t, e, a) {
  return a ? (s = uF(s, t, e), s = nD(s, e, t)) : s = nD(s, t, e), s;
}
function uF(s, t, e) {
  return s === t ? e : s === e ? t : s;
}
function nD(s, t, e) {
  return s === "start" ? t : s === "end" ? e : s;
}
function pF(s, { inflateAmount: t }, e) {
  s.inflateAmount = t === "auto" ? e === 1 ? 0.33 : 0 : t;
}
class zh extends fi {
  parsePrimitiveData(t, e, a, n) {
    return eD(t, e, a, n);
  }
  parseArrayData(t, e, a, n) {
    return eD(t, e, a, n);
  }
  parseObjectData(t, e, a, n) {
    const { iScale: i, vScale: r } = t, { xAxisKey: l = "x", yAxisKey: o = "y" } = this._parsing, c = i.axis === "x" ? l : o, d = r.axis === "x" ? l : o, p = [];
    let h, g, x, b;
    for (h = a, g = a + n; h < g; ++h)
      b = e[h], x = {}, x[i.axis] = i.parse(el(b, c), h), p.push(nE(el(b, d), x, r, h));
    return p;
  }
  updateRangeFromParsed(t, e, a, n) {
    super.updateRangeFromParsed(t, e, a, n);
    const i = a._custom;
    i && e === this._cachedMeta.vScale && (t.min = Math.min(t.min, i.min), t.max = Math.max(t.max, i.max));
  }
  getMaxOverflow() {
    return 0;
  }
  getLabelAndValue(t) {
    const e = this._cachedMeta, { iScale: a, vScale: n } = e, i = this.getParsed(t), r = i._custom, l = Wb(r) ? "[" + r.start + ", " + r.end + "]" : "" + n.getLabelForValue(i[n.axis]);
    return {
      label: "" + a.getLabelForValue(i[a.axis]),
      value: l
    };
  }
  initialize() {
    this.enableOptionSharing = !0, super.initialize();
    const t = this._cachedMeta;
    t.stack = this.getDataset().stack;
  }
  update(t) {
    const e = this._cachedMeta;
    this.updateElements(e.data, 0, e.data.length, t);
  }
  updateElements(t, e, a, n) {
    const i = n === "reset", { index: r, _cachedMeta: { vScale: l } } = this, o = l.getBasePixel(), c = l.isHorizontal(), d = this._getRuler(), { sharedOptions: p, includeOptions: h } = this._getSharedOptions(e, n);
    for (let g = e; g < e + a; g++) {
      const x = this.getParsed(g), b = i || ua(x[l.axis]) ? {
        base: o,
        head: o
      } : this._calculateBarValuePixels(g), A = this._calculateBarIndexPixels(g, d), T = (x._stacks || {})[l.axis], R = {
        horizontal: c,
        base: b.base,
        enableBorderRadius: !T || Wb(x._custom) || r === T._top || r === T._bottom,
        x: c ? b.head : A.center,
        y: c ? A.center : b.head,
        height: c ? A.size : Math.abs(b.size),
        width: c ? Math.abs(b.size) : A.size
      };
      h && (R.options = p || this.resolveDataElementOptions(g, t[g].active ? "active" : n));
      const C = R.options || t[g].options;
      dF(R, C, T, r), pF(R, C, d.ratio), this.updateElement(t[g], g, R, n);
    }
  }
  _getStacks(t, e) {
    const { iScale: a } = this._cachedMeta, n = a.getMatchingVisibleMetas(this._type).filter((o) => o.controller.options.grouped), i = a.options.stacked, r = [], l = (o) => {
      const c = o.controller.getParsed(e), d = c && c[o.vScale.axis];
      if (ua(d) || isNaN(d))
        return !0;
    };
    for (const o of n)
      if (!(e !== void 0 && l(o)) && ((i === !1 || r.indexOf(o.stack) === -1 || i === void 0 && o.stack === void 0) && r.push(o.stack), o.index === t))
        break;
    return r.length || r.push(void 0), r;
  }
  _getStackCount(t) {
    return this._getStacks(void 0, t).length;
  }
  _getStackIndex(t, e, a) {
    const n = this._getStacks(t, a), i = e !== void 0 ? n.indexOf(e) : -1;
    return i === -1 ? n.length - 1 : i;
  }
  _getRuler() {
    const t = this.options, e = this._cachedMeta, a = e.iScale, n = [];
    let i, r;
    for (i = 0, r = e.data.length; i < r; ++i)
      n.push(a.getPixelForValue(this.getParsed(i)[a.axis], i));
    const l = t.barThickness;
    return {
      min: l || sF(e),
      pixels: n,
      start: a._startPixel,
      end: a._endPixel,
      stackCount: this._getStackCount(),
      scale: a,
      grouped: t.grouped,
      ratio: l ? 1 : t.categoryPercentage * t.barPercentage
    };
  }
  _calculateBarValuePixels(t) {
    const { _cachedMeta: { vScale: e, _stacked: a, index: n }, options: { base: i, minBarLength: r } } = this, l = i || 0, o = this.getParsed(t), c = o._custom, d = Wb(c);
    let p = o[e.axis], h = 0, g = a ? this.applyStack(e, o, a) : p, x, b;
    g !== p && (h = g - p, g = p), d && (p = c.barStart, g = c.barEnd - c.barStart, p !== 0 && Ui(p) !== Ui(c.barEnd) && (h = 0), h += p);
    const A = !ua(i) && !d ? i : h;
    let T = e.getPixelForValue(A);
    if (this.chart.getDataVisibility(t) ? x = e.getPixelForValue(h + g) : x = T, b = x - T, Math.abs(b) < r) {
      b = oF(b, e, l) * r, p === l && (T -= b / 2);
      const R = e.getPixelForDecimal(0), C = e.getPixelForDecimal(1), v = Math.min(R, C), P = Math.max(R, C);
      T = Math.max(Math.min(T, P), v), x = T + b, a && !d && (o._stacks[e.axis]._visualValues[n] = e.getValueForPixel(x) - e.getValueForPixel(T));
    }
    if (T === e.getPixelForValue(l)) {
      const R = Ui(b) * e.getLineWidthForValue(l) / 2;
      T += R, b -= R;
    }
    return {
      size: b,
      base: T,
      head: x,
      center: x + b / 2
    };
  }
  _calculateBarIndexPixels(t, e) {
    const a = e.scale, n = this.options, i = n.skipNull, r = Fe(n.maxBarThickness, 1 / 0);
    let l, o;
    if (e.grouped) {
      const c = i ? this._getStackCount(t) : e.stackCount, d = n.barThickness === "flex" ? rF(t, e, n, c) : iF(t, e, n, c), p = this._getStackIndex(this.index, this._cachedMeta.stack, i ? t : void 0);
      l = d.start + d.chunk * p + d.chunk / 2, o = Math.min(r, d.chunk * d.ratio);
    } else
      l = a.getPixelForValue(this.getParsed(t)[a.axis], t), o = Math.min(r, e.min * e.ratio);
    return {
      base: l - o / 2,
      head: l + o / 2,
      center: l,
      size: o
    };
  }
  draw() {
    const t = this._cachedMeta, e = t.vScale, a = t.data, n = a.length;
    let i = 0;
    for (; i < n; ++i)
      this.getParsed(i)[e.axis] !== null && a[i].draw(this._ctx);
  }
}
Jt(zh, "id", "bar"), Jt(zh, "defaults", {
  datasetElementType: !1,
  dataElementType: "bar",
  categoryPercentage: 0.8,
  barPercentage: 0.9,
  grouped: !0,
  animations: {
    numbers: {
      type: "number",
      properties: [
        "x",
        "y",
        "base",
        "width",
        "height"
      ]
    }
  }
}), Jt(zh, "overrides", {
  scales: {
    _index_: {
      type: "category",
      offset: !0,
      grid: {
        offset: !0
      }
    },
    _value_: {
      type: "linear",
      beginAtZero: !0
    }
  }
});
class Bh extends fi {
  initialize() {
    this.enableOptionSharing = !0, super.initialize();
  }
  parsePrimitiveData(t, e, a, n) {
    const i = super.parsePrimitiveData(t, e, a, n);
    for (let r = 0; r < i.length; r++)
      i[r]._custom = this.resolveDataElementOptions(r + a).radius;
    return i;
  }
  parseArrayData(t, e, a, n) {
    const i = super.parseArrayData(t, e, a, n);
    for (let r = 0; r < i.length; r++) {
      const l = e[a + r];
      i[r]._custom = Fe(l[2], this.resolveDataElementOptions(r + a).radius);
    }
    return i;
  }
  parseObjectData(t, e, a, n) {
    const i = super.parseObjectData(t, e, a, n);
    for (let r = 0; r < i.length; r++) {
      const l = e[a + r];
      i[r]._custom = Fe(l && l.r && +l.r, this.resolveDataElementOptions(r + a).radius);
    }
    return i;
  }
  getMaxOverflow() {
    const t = this._cachedMeta.data;
    let e = 0;
    for (let a = t.length - 1; a >= 0; --a)
      e = Math.max(e, t[a].size(this.resolveDataElementOptions(a)) / 2);
    return e > 0 && e;
  }
  getLabelAndValue(t) {
    const e = this._cachedMeta, a = this.chart.data.labels || [], { xScale: n, yScale: i } = e, r = this.getParsed(t), l = n.getLabelForValue(r.x), o = i.getLabelForValue(r.y), c = r._custom;
    return {
      label: a[t] || "",
      value: "(" + l + ", " + o + (c ? ", " + c : "") + ")"
    };
  }
  update(t) {
    const e = this._cachedMeta.data;
    this.updateElements(e, 0, e.length, t);
  }
  updateElements(t, e, a, n) {
    const i = n === "reset", { iScale: r, vScale: l } = this._cachedMeta, { sharedOptions: o, includeOptions: c } = this._getSharedOptions(e, n), d = r.axis, p = l.axis;
    for (let h = e; h < e + a; h++) {
      const g = t[h], x = !i && this.getParsed(h), b = {}, A = b[d] = i ? r.getPixelForDecimal(0.5) : r.getPixelForValue(x[d]), T = b[p] = i ? l.getBasePixel() : l.getPixelForValue(x[p]);
      b.skip = isNaN(A) || isNaN(T), c && (b.options = o || this.resolveDataElementOptions(h, g.active ? "active" : n), i && (b.options.radius = 0)), this.updateElement(g, h, b, n);
    }
  }
  resolveDataElementOptions(t, e) {
    const a = this.getParsed(t);
    let n = super.resolveDataElementOptions(t, e);
    n.$shared && (n = Object.assign({}, n, {
      $shared: !1
    }));
    const i = n.radius;
    return e !== "active" && (n.radius = 0), n.radius += Fe(a && a._custom, i), n;
  }
}
Jt(Bh, "id", "bubble"), Jt(Bh, "defaults", {
  datasetElementType: !1,
  dataElementType: "point",
  animations: {
    numbers: {
      type: "number",
      properties: [
        "x",
        "y",
        "borderWidth",
        "radius"
      ]
    }
  }
}), Jt(Bh, "overrides", {
  scales: {
    x: {
      type: "linear"
    },
    y: {
      type: "linear"
    }
  }
});
function hF(s, t, e) {
  let a = 1, n = 1, i = 0, r = 0;
  if (t < Ga) {
    const l = s, o = l + t, c = Math.cos(l), d = Math.sin(l), p = Math.cos(o), h = Math.sin(o), g = (C, v, P) => du(C, l, o, !0) ? 1 : Math.max(v, v * e, P, P * e), x = (C, v, P) => du(C, l, o, !0) ? -1 : Math.min(v, v * e, P, P * e), b = g(0, c, p), A = g(Fa, d, h), T = x(ra, c, p), R = x(ra + Fa, d, h);
    a = (b - T) / 2, n = (A - R) / 2, i = -(b + T) / 2, r = -(A + R) / 2;
  }
  return {
    ratioX: a,
    ratioY: n,
    offsetX: i,
    offsetY: r
  };
}
class Rl extends fi {
  constructor(t, e) {
    super(t, e), this.enableOptionSharing = !0, this.innerRadius = void 0, this.outerRadius = void 0, this.offsetX = void 0, this.offsetY = void 0;
  }
  linkScales() {
  }
  parse(t, e) {
    const a = this.getDataset().data, n = this._cachedMeta;
    if (this._parsing === !1)
      n._parsed = a;
    else {
      let i = (o) => +a[o];
      if (Ve(a[t])) {
        const { key: o = "value" } = this._parsing;
        i = (c) => +el(a[c], o);
      }
      let r, l;
      for (r = t, l = t + e; r < l; ++r)
        n._parsed[r] = i(r);
    }
  }
  _getRotation() {
    return bn(this.options.rotation - 90);
  }
  _getCircumference() {
    return bn(this.options.circumference);
  }
  _getRotationExtents() {
    let t = Ga, e = -Ga;
    for (let a = 0; a < this.chart.data.datasets.length; ++a)
      if (this.chart.isDatasetVisible(a) && this.chart.getDatasetMeta(a).type === this._type) {
        const n = this.chart.getDatasetMeta(a).controller, i = n._getRotation(), r = n._getCircumference();
        t = Math.min(t, i), e = Math.max(e, i + r);
      }
    return {
      rotation: t,
      circumference: e - t
    };
  }
  update(t) {
    const e = this.chart, { chartArea: a } = e, n = this._cachedMeta, i = n.data, r = this.getMaxBorderWidth() + this.getMaxOffset(i) + this.options.spacing, l = Math.max((Math.min(a.width, a.height) - r) / 2, 0), o = Math.min(L2(this.options.cutout, l), 1), c = this._getRingWeight(this.index), { circumference: d, rotation: p } = this._getRotationExtents(), { ratioX: h, ratioY: g, offsetX: x, offsetY: b } = hF(p, d, o), A = (a.width - r) / h, T = (a.height - r) / g, R = Math.max(Math.min(A, T) / 2, 0), C = EP(this.options.radius, R), v = Math.max(C * o, 0), P = (C - v) / this._getVisibleDatasetWeightTotal();
    this.offsetX = x * C, this.offsetY = b * C, n.total = this.calculateTotal(), this.outerRadius = C - P * this._getRingWeightOffset(this.index), this.innerRadius = Math.max(this.outerRadius - P * c, 0), this.updateElements(i, 0, i.length, t);
  }
  _circumference(t, e) {
    const a = this.options, n = this._cachedMeta, i = this._getCircumference();
    return e && a.animation.animateRotate || !this.chart.getDataVisibility(t) || n._parsed[t] === null || n.data[t].hidden ? 0 : this.calculateCircumference(n._parsed[t] * i / Ga);
  }
  updateElements(t, e, a, n) {
    const i = n === "reset", r = this.chart, l = r.chartArea, c = r.options.animation, d = (l.left + l.right) / 2, p = (l.top + l.bottom) / 2, h = i && c.animateScale, g = h ? 0 : this.innerRadius, x = h ? 0 : this.outerRadius, { sharedOptions: b, includeOptions: A } = this._getSharedOptions(e, n);
    let T = this._getRotation(), R;
    for (R = 0; R < e; ++R)
      T += this._circumference(R, i);
    for (R = e; R < e + a; ++R) {
      const C = this._circumference(R, i), v = t[R], P = {
        x: d + this.offsetX,
        y: p + this.offsetY,
        startAngle: T,
        endAngle: T + C,
        circumference: C,
        outerRadius: x,
        innerRadius: g
      };
      A && (P.options = b || this.resolveDataElementOptions(R, v.active ? "active" : n)), T += C, this.updateElement(v, R, P, n);
    }
  }
  calculateTotal() {
    const t = this._cachedMeta, e = t.data;
    let a = 0, n;
    for (n = 0; n < e.length; n++) {
      const i = t._parsed[n];
      i !== null && !isNaN(i) && this.chart.getDataVisibility(n) && !e[n].hidden && (a += Math.abs(i));
    }
    return a;
  }
  calculateCircumference(t) {
    const e = this._cachedMeta.total;
    return e > 0 && !isNaN(t) ? Ga * (Math.abs(t) / e) : 0;
  }
  getLabelAndValue(t) {
    const e = this._cachedMeta, a = this.chart, n = a.data.labels || [], i = Bu(e._parsed[t], a.options.locale);
    return {
      label: n[t] || "",
      value: i
    };
  }
  getMaxBorderWidth(t) {
    let e = 0;
    const a = this.chart;
    let n, i, r, l, o;
    if (!t) {
      for (n = 0, i = a.data.datasets.length; n < i; ++n)
        if (a.isDatasetVisible(n)) {
          r = a.getDatasetMeta(n), t = r.data, l = r.controller;
          break;
        }
    }
    if (!t)
      return 0;
    for (n = 0, i = t.length; n < i; ++n)
      o = l.resolveDataElementOptions(n), o.borderAlign !== "inner" && (e = Math.max(e, o.borderWidth || 0, o.hoverBorderWidth || 0));
    return e;
  }
  getMaxOffset(t) {
    let e = 0;
    for (let a = 0, n = t.length; a < n; ++a) {
      const i = this.resolveDataElementOptions(a);
      e = Math.max(e, i.offset || 0, i.hoverOffset || 0);
    }
    return e;
  }
  _getRingWeightOffset(t) {
    let e = 0;
    for (let a = 0; a < t; ++a)
      this.chart.isDatasetVisible(a) && (e += this._getRingWeight(a));
    return e;
  }
  _getRingWeight(t) {
    return Math.max(Fe(this.chart.data.datasets[t].weight, 1), 0);
  }
  _getVisibleDatasetWeightTotal() {
    return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
  }
}
Jt(Rl, "id", "doughnut"), Jt(Rl, "defaults", {
  datasetElementType: !1,
  dataElementType: "arc",
  animation: {
    animateRotate: !0,
    animateScale: !1
  },
  animations: {
    numbers: {
      type: "number",
      properties: [
        "circumference",
        "endAngle",
        "innerRadius",
        "outerRadius",
        "startAngle",
        "x",
        "y",
        "offset",
        "borderWidth",
        "spacing"
      ]
    }
  },
  cutout: "50%",
  rotation: 0,
  circumference: 360,
  radius: "100%",
  spacing: 0,
  indexAxis: "r"
}), Jt(Rl, "descriptors", {
  _scriptable: (t) => t !== "spacing",
  _indexable: (t) => t !== "spacing" && !t.startsWith("borderDash") && !t.startsWith("hoverBorderDash")
}), Jt(Rl, "overrides", {
  aspectRatio: 1,
  plugins: {
    legend: {
      labels: {
        generateLabels(t) {
          const e = t.data;
          if (e.labels.length && e.datasets.length) {
            const { labels: { pointStyle: a, color: n } } = t.legend.options;
            return e.labels.map((i, r) => {
              const o = t.getDatasetMeta(0).controller.getStyle(r);
              return {
                text: i,
                fillStyle: o.backgroundColor,
                strokeStyle: o.borderColor,
                fontColor: n,
                lineWidth: o.borderWidth,
                pointStyle: a,
                hidden: !t.getDataVisibility(r),
                index: r
              };
            });
          }
          return [];
        }
      },
      onClick(t, e, a) {
        a.chart.toggleDataVisibility(e.index), a.chart.update();
      }
    }
  }
});
class Wh extends fi {
  initialize() {
    this.enableOptionSharing = !0, this.supportsDecimation = !0, super.initialize();
  }
  update(t) {
    const e = this._cachedMeta, { dataset: a, data: n = [], _dataset: i } = e, r = this.chart._animationsDisabled;
    let { start: l, count: o } = GP(e, n, r);
    this._drawStart = l, this._drawCount = o, HP(e) && (l = 0, o = n.length), a._chart = this.chart, a._datasetIndex = this.index, a._decimated = !!i._decimated, a.points = n;
    const c = this.resolveDatasetElementOptions(t);
    this.options.showLine || (c.borderWidth = 0), c.segment = this.options.segment, this.updateElement(a, void 0, {
      animated: !r,
      options: c
    }, t), this.updateElements(n, l, o, t);
  }
  updateElements(t, e, a, n) {
    const i = n === "reset", { iScale: r, vScale: l, _stacked: o, _dataset: c } = this._cachedMeta, { sharedOptions: d, includeOptions: p } = this._getSharedOptions(e, n), h = r.axis, g = l.axis, { spanGaps: x, segment: b } = this.options, A = al(x) ? x : Number.POSITIVE_INFINITY, T = this.chart._animationsDisabled || i || n === "none", R = e + a, C = t.length;
    let v = e > 0 && this.getParsed(e - 1);
    for (let P = 0; P < C; ++P) {
      const O = t[P], N = T ? O : {};
      if (P < e || P >= R) {
        N.skip = !0;
        continue;
      }
      const H = this.getParsed(P), F = ua(H[g]), B = N[h] = r.getPixelForValue(H[h], P), Q = N[g] = i || F ? l.getBasePixel() : l.getPixelForValue(o ? this.applyStack(l, H, o) : H[g], P);
      N.skip = isNaN(B) || isNaN(Q) || F, N.stop = P > 0 && Math.abs(H[h] - v[h]) > A, b && (N.parsed = H, N.raw = c.data[P]), p && (N.options = d || this.resolveDataElementOptions(P, O.active ? "active" : n)), T || this.updateElement(O, P, N, n), v = H;
    }
  }
  getMaxOverflow() {
    const t = this._cachedMeta, e = t.dataset, a = e.options && e.options.borderWidth || 0, n = t.data || [];
    if (!n.length)
      return a;
    const i = n[0].size(this.resolveDataElementOptions(0)), r = n[n.length - 1].size(this.resolveDataElementOptions(n.length - 1));
    return Math.max(a, i, r) / 2;
  }
  draw() {
    const t = this._cachedMeta;
    t.dataset.updateControlPoints(this.chart.chartArea, t.iScale.axis), super.draw();
  }
}
Jt(Wh, "id", "line"), Jt(Wh, "defaults", {
  datasetElementType: "line",
  dataElementType: "point",
  showLine: !0,
  spanGaps: !1
}), Jt(Wh, "overrides", {
  scales: {
    _index_: {
      type: "category"
    },
    _value_: {
      type: "linear"
    }
  }
});
class Vd extends fi {
  constructor(t, e) {
    super(t, e), this.innerRadius = void 0, this.outerRadius = void 0;
  }
  getLabelAndValue(t) {
    const e = this._cachedMeta, a = this.chart, n = a.data.labels || [], i = Bu(e._parsed[t].r, a.options.locale);
    return {
      label: n[t] || "",
      value: i
    };
  }
  parseObjectData(t, e, a, n) {
    return qP.bind(this)(t, e, a, n);
  }
  update(t) {
    const e = this._cachedMeta.data;
    this._updateRadius(), this.updateElements(e, 0, e.length, t);
  }
  getMinMax() {
    const t = this._cachedMeta, e = {
      min: Number.POSITIVE_INFINITY,
      max: Number.NEGATIVE_INFINITY
    };
    return t.data.forEach((a, n) => {
      const i = this.getParsed(n).r;
      !isNaN(i) && this.chart.getDataVisibility(n) && (i < e.min && (e.min = i), i > e.max && (e.max = i));
    }), e;
  }
  _updateRadius() {
    const t = this.chart, e = t.chartArea, a = t.options, n = Math.min(e.right - e.left, e.bottom - e.top), i = Math.max(n / 2, 0), r = Math.max(a.cutoutPercentage ? i / 100 * a.cutoutPercentage : 1, 0), l = (i - r) / t.getVisibleDatasetCount();
    this.outerRadius = i - l * this.index, this.innerRadius = this.outerRadius - l;
  }
  updateElements(t, e, a, n) {
    const i = n === "reset", r = this.chart, o = r.options.animation, c = this._cachedMeta.rScale, d = c.xCenter, p = c.yCenter, h = c.getIndexAngle(0) - 0.5 * ra;
    let g = h, x;
    const b = 360 / this.countVisibleElements();
    for (x = 0; x < e; ++x)
      g += this._computeAngle(x, n, b);
    for (x = e; x < e + a; x++) {
      const A = t[x];
      let T = g, R = g + this._computeAngle(x, n, b), C = r.getDataVisibility(x) ? c.getDistanceFromCenterForValue(this.getParsed(x).r) : 0;
      g = R, i && (o.animateScale && (C = 0), o.animateRotate && (T = R = h));
      const v = {
        x: d,
        y: p,
        innerRadius: 0,
        outerRadius: C,
        startAngle: T,
        endAngle: R,
        options: this.resolveDataElementOptions(x, A.active ? "active" : n)
      };
      this.updateElement(A, x, v, n);
    }
  }
  countVisibleElements() {
    const t = this._cachedMeta;
    let e = 0;
    return t.data.forEach((a, n) => {
      !isNaN(this.getParsed(n).r) && this.chart.getDataVisibility(n) && e++;
    }), e;
  }
  _computeAngle(t, e, a) {
    return this.chart.getDataVisibility(t) ? bn(this.resolveDataElementOptions(t, e).angle || a) : 0;
  }
}
Jt(Vd, "id", "polarArea"), Jt(Vd, "defaults", {
  dataElementType: "arc",
  animation: {
    animateRotate: !0,
    animateScale: !0
  },
  animations: {
    numbers: {
      type: "number",
      properties: [
        "x",
        "y",
        "startAngle",
        "endAngle",
        "innerRadius",
        "outerRadius"
      ]
    }
  },
  indexAxis: "r",
  startAngle: 0
}), Jt(Vd, "overrides", {
  aspectRatio: 1,
  plugins: {
    legend: {
      labels: {
        generateLabels(t) {
          const e = t.data;
          if (e.labels.length && e.datasets.length) {
            const { labels: { pointStyle: a, color: n } } = t.legend.options;
            return e.labels.map((i, r) => {
              const o = t.getDatasetMeta(0).controller.getStyle(r);
              return {
                text: i,
                fillStyle: o.backgroundColor,
                strokeStyle: o.borderColor,
                fontColor: n,
                lineWidth: o.borderWidth,
                pointStyle: a,
                hidden: !t.getDataVisibility(r),
                index: r
              };
            });
          }
          return [];
        }
      },
      onClick(t, e, a) {
        a.chart.toggleDataVisibility(e.index), a.chart.update();
      }
    }
  },
  scales: {
    r: {
      type: "radialLinear",
      angleLines: {
        display: !1
      },
      beginAtZero: !0,
      grid: {
        circular: !0
      },
      pointLabels: {
        display: !1
      },
      startAngle: 0
    }
  }
});
class yx extends Rl {
}
Jt(yx, "id", "pie"), Jt(yx, "defaults", {
  cutout: 0,
  rotation: 0,
  circumference: 360,
  radius: "100%"
});
class jh extends fi {
  getLabelAndValue(t) {
    const e = this._cachedMeta.vScale, a = this.getParsed(t);
    return {
      label: e.getLabels()[t],
      value: "" + e.getLabelForValue(a[e.axis])
    };
  }
  parseObjectData(t, e, a, n) {
    return qP.bind(this)(t, e, a, n);
  }
  update(t) {
    const e = this._cachedMeta, a = e.dataset, n = e.data || [], i = e.iScale.getLabels();
    if (a.points = n, t !== "resize") {
      const r = this.resolveDatasetElementOptions(t);
      this.options.showLine || (r.borderWidth = 0);
      const l = {
        _loop: !0,
        _fullLoop: i.length === n.length,
        options: r
      };
      this.updateElement(a, void 0, l, t);
    }
    this.updateElements(n, 0, n.length, t);
  }
  updateElements(t, e, a, n) {
    const i = this._cachedMeta.rScale, r = n === "reset";
    for (let l = e; l < e + a; l++) {
      const o = t[l], c = this.resolveDataElementOptions(l, o.active ? "active" : n), d = i.getPointPositionForValue(l, this.getParsed(l).r), p = r ? i.xCenter : d.x, h = r ? i.yCenter : d.y, g = {
        x: p,
        y: h,
        angle: d.angle,
        skip: isNaN(p) || isNaN(h),
        options: c
      };
      this.updateElement(o, l, g, n);
    }
  }
}
Jt(jh, "id", "radar"), Jt(jh, "defaults", {
  datasetElementType: "line",
  dataElementType: "point",
  indexAxis: "r",
  showLine: !0,
  elements: {
    line: {
      fill: "start"
    }
  }
}), Jt(jh, "overrides", {
  aspectRatio: 1,
  scales: {
    r: {
      type: "radialLinear"
    }
  }
});
class Vh extends fi {
  getLabelAndValue(t) {
    const e = this._cachedMeta, a = this.chart.data.labels || [], { xScale: n, yScale: i } = e, r = this.getParsed(t), l = n.getLabelForValue(r.x), o = i.getLabelForValue(r.y);
    return {
      label: a[t] || "",
      value: "(" + l + ", " + o + ")"
    };
  }
  update(t) {
    const e = this._cachedMeta, { data: a = [] } = e, n = this.chart._animationsDisabled;
    let { start: i, count: r } = GP(e, a, n);
    if (this._drawStart = i, this._drawCount = r, HP(e) && (i = 0, r = a.length), this.options.showLine) {
      this.datasetElementType || this.addElements();
      const { dataset: l, _dataset: o } = e;
      l._chart = this.chart, l._datasetIndex = this.index, l._decimated = !!o._decimated, l.points = a;
      const c = this.resolveDatasetElementOptions(t);
      c.segment = this.options.segment, this.updateElement(l, void 0, {
        animated: !n,
        options: c
      }, t);
    } else
      this.datasetElementType && (delete e.dataset, this.datasetElementType = !1);
    this.updateElements(a, i, r, t);
  }
  addElements() {
    const { showLine: t } = this.options;
    !this.datasetElementType && t && (this.datasetElementType = this.chart.registry.getElement("line")), super.addElements();
  }
  updateElements(t, e, a, n) {
    const i = n === "reset", { iScale: r, vScale: l, _stacked: o, _dataset: c } = this._cachedMeta, d = this.resolveDataElementOptions(e, n), p = this.getSharedOptions(d), h = this.includeOptions(n, p), g = r.axis, x = l.axis, { spanGaps: b, segment: A } = this.options, T = al(b) ? b : Number.POSITIVE_INFINITY, R = this.chart._animationsDisabled || i || n === "none";
    let C = e > 0 && this.getParsed(e - 1);
    for (let v = e; v < e + a; ++v) {
      const P = t[v], O = this.getParsed(v), N = R ? P : {}, H = ua(O[x]), F = N[g] = r.getPixelForValue(O[g], v), B = N[x] = i || H ? l.getBasePixel() : l.getPixelForValue(o ? this.applyStack(l, O, o) : O[x], v);
      N.skip = isNaN(F) || isNaN(B) || H, N.stop = v > 0 && Math.abs(O[g] - C[g]) > T, A && (N.parsed = O, N.raw = c.data[v]), h && (N.options = p || this.resolveDataElementOptions(v, P.active ? "active" : n)), R || this.updateElement(P, v, N, n), C = O;
    }
    this.updateSharedOptions(p, n, d);
  }
  getMaxOverflow() {
    const t = this._cachedMeta, e = t.data || [];
    if (!this.options.showLine) {
      let l = 0;
      for (let o = e.length - 1; o >= 0; --o)
        l = Math.max(l, e[o].size(this.resolveDataElementOptions(o)) / 2);
      return l > 0 && l;
    }
    const a = t.dataset, n = a.options && a.options.borderWidth || 0;
    if (!e.length)
      return n;
    const i = e[0].size(this.resolveDataElementOptions(0)), r = e[e.length - 1].size(this.resolveDataElementOptions(e.length - 1));
    return Math.max(n, i, r) / 2;
  }
}
Jt(Vh, "id", "scatter"), Jt(Vh, "defaults", {
  datasetElementType: !1,
  dataElementType: "point",
  showLine: !1,
  fill: !1
}), Jt(Vh, "overrides", {
  interaction: {
    mode: "point"
  },
  scales: {
    x: {
      type: "linear"
    },
    y: {
      type: "linear"
    }
  }
});
var mF = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  BarController: zh,
  BubbleController: Bh,
  DoughnutController: Rl,
  LineController: Wh,
  PieController: yx,
  PolarAreaController: Vd,
  RadarController: jh,
  ScatterController: Vh
});
function kl() {
  throw new Error("This method is not implemented: Check that a complete date adapter is provided.");
}
class Qw {
  constructor(t) {
    Jt(this, "options");
    this.options = t || {};
  }
  /**
  * Override default date adapter methods.
  * Accepts type parameter to define options type.
  * @example
  * Chart._adapters._date.override<{myAdapterOption: string}>({
  *   init() {
  *     console.log(this.options.myAdapterOption);
  *   }
  * })
  */
  static override(t) {
    Object.assign(Qw.prototype, t);
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  init() {
  }
  formats() {
    return kl();
  }
  parse() {
    return kl();
  }
  format() {
    return kl();
  }
  add() {
    return kl();
  }
  diff() {
    return kl();
  }
  startOf() {
    return kl();
  }
  endOf() {
    return kl();
  }
}
var sE = {
  _date: Qw
};
function gF(s, t, e, a) {
  const { controller: n, data: i, _sorted: r } = s, l = n._cachedMeta.iScale;
  if (l && t === l.axis && t !== "r" && r && i.length) {
    const o = l._reversePixels ? X2 : hr;
    if (a) {
      if (n._sharedOptions) {
        const c = i[0], d = typeof c.getRange == "function" && c.getRange(t);
        if (d) {
          const p = o(i, t, e - d), h = o(i, t, e + d);
          return {
            lo: p.lo,
            hi: h.hi
          };
        }
      }
    } else
      return o(i, t, e);
  }
  return {
    lo: 0,
    hi: i.length - 1
  };
}
function Vu(s, t, e, a, n) {
  const i = s.getSortedVisibleDatasetMetas(), r = e[t];
  for (let l = 0, o = i.length; l < o; ++l) {
    const { index: c, data: d } = i[l], { lo: p, hi: h } = gF(i[l], t, r, n);
    for (let g = p; g <= h; ++g) {
      const x = d[g];
      x.skip || a(x, c, g);
    }
  }
}
function yF(s) {
  const t = s.indexOf("x") !== -1, e = s.indexOf("y") !== -1;
  return function(a, n) {
    const i = t ? Math.abs(a.x - n.x) : 0, r = e ? Math.abs(a.y - n.y) : 0;
    return Math.sqrt(Math.pow(i, 2) + Math.pow(r, 2));
  };
}
function jb(s, t, e, a, n) {
  const i = [];
  return !n && !s.isPointInArea(t) || Vu(s, e, t, function(l, o, c) {
    !n && !mr(l, s.chartArea, 0) || l.inRange(t.x, t.y, a) && i.push({
      element: l,
      datasetIndex: o,
      index: c
    });
  }, !0), i;
}
function fF(s, t, e, a) {
  let n = [];
  function i(r, l, o) {
    const { startAngle: c, endAngle: d } = r.getProps([
      "startAngle",
      "endAngle"
    ], a), { angle: p } = YP(r, {
      x: t.x,
      y: t.y
    });
    du(p, c, d) && n.push({
      element: r,
      datasetIndex: l,
      index: o
    });
  }
  return Vu(s, e, t, i), n;
}
function bF(s, t, e, a, n, i) {
  let r = [];
  const l = yF(e);
  let o = Number.POSITIVE_INFINITY;
  function c(d, p, h) {
    const g = d.inRange(t.x, t.y, n);
    if (a && !g)
      return;
    const x = d.getCenterPoint(n);
    if (!(!!i || s.isPointInArea(x)) && !g)
      return;
    const A = l(t, x);
    A < o ? (r = [
      {
        element: d,
        datasetIndex: p,
        index: h
      }
    ], o = A) : A === o && r.push({
      element: d,
      datasetIndex: p,
      index: h
    });
  }
  return Vu(s, e, t, c), r;
}
function Vb(s, t, e, a, n, i) {
  return !i && !s.isPointInArea(t) ? [] : e === "r" && !a ? fF(s, t, e, n) : bF(s, t, e, a, n, i);
}
function sD(s, t, e, a, n) {
  const i = [], r = e === "x" ? "inXRange" : "inYRange";
  let l = !1;
  return Vu(s, e, t, (o, c, d) => {
    o[r](t[e], n) && (i.push({
      element: o,
      datasetIndex: c,
      index: d
    }), l = l || o.inRange(t.x, t.y, n));
  }), a && !l ? [] : i;
}
var vF = {
  evaluateInteractionItems: Vu,
  modes: {
    index(s, t, e, a) {
      const n = Ll(t, s), i = e.axis || "x", r = e.includeInvisible || !1, l = e.intersect ? jb(s, n, i, a, r) : Vb(s, n, i, !1, a, r), o = [];
      return l.length ? (s.getSortedVisibleDatasetMetas().forEach((c) => {
        const d = l[0].index, p = c.data[d];
        p && !p.skip && o.push({
          element: p,
          datasetIndex: c.index,
          index: d
        });
      }), o) : [];
    },
    dataset(s, t, e, a) {
      const n = Ll(t, s), i = e.axis || "xy", r = e.includeInvisible || !1;
      let l = e.intersect ? jb(s, n, i, a, r) : Vb(s, n, i, !1, a, r);
      if (l.length > 0) {
        const o = l[0].datasetIndex, c = s.getDatasetMeta(o).data;
        l = [];
        for (let d = 0; d < c.length; ++d)
          l.push({
            element: c[d],
            datasetIndex: o,
            index: d
          });
      }
      return l;
    },
    point(s, t, e, a) {
      const n = Ll(t, s), i = e.axis || "xy", r = e.includeInvisible || !1;
      return jb(s, n, i, a, r);
    },
    nearest(s, t, e, a) {
      const n = Ll(t, s), i = e.axis || "xy", r = e.includeInvisible || !1;
      return Vb(s, n, i, e.intersect, a, r);
    },
    x(s, t, e, a) {
      const n = Ll(t, s);
      return sD(s, n, "x", e.intersect, a);
    },
    y(s, t, e, a) {
      const n = Ll(t, s);
      return sD(s, n, "y", e.intersect, a);
    }
  }
};
const iE = [
  "left",
  "top",
  "right",
  "bottom"
];
function vd(s, t) {
  return s.filter((e) => e.pos === t);
}
function iD(s, t) {
  return s.filter((e) => iE.indexOf(e.pos) === -1 && e.box.axis === t);
}
function xd(s, t) {
  return s.sort((e, a) => {
    const n = t ? a : e, i = t ? e : a;
    return n.weight === i.weight ? n.index - i.index : n.weight - i.weight;
  });
}
function xF(s) {
  const t = [];
  let e, a, n, i, r, l;
  for (e = 0, a = (s || []).length; e < a; ++e)
    n = s[e], { position: i, options: { stack: r, stackWeight: l = 1 } } = n, t.push({
      index: e,
      box: n,
      pos: i,
      horizontal: n.isHorizontal(),
      weight: n.weight,
      stack: r && i + r,
      stackWeight: l
    });
  return t;
}
function wF(s) {
  const t = {};
  for (const e of s) {
    const { stack: a, pos: n, stackWeight: i } = e;
    if (!a || !iE.includes(n))
      continue;
    const r = t[a] || (t[a] = {
      count: 0,
      placed: 0,
      weight: 0,
      size: 0
    });
    r.count++, r.weight += i;
  }
  return t;
}
function AF(s, t) {
  const e = wF(s), { vBoxMaxWidth: a, hBoxMaxHeight: n } = t;
  let i, r, l;
  for (i = 0, r = s.length; i < r; ++i) {
    l = s[i];
    const { fullSize: o } = l.box, c = e[l.stack], d = c && l.stackWeight / c.weight;
    l.horizontal ? (l.width = d ? d * a : o && t.availableWidth, l.height = n) : (l.width = a, l.height = d ? d * n : o && t.availableHeight);
  }
  return e;
}
function CF(s) {
  const t = xF(s), e = xd(t.filter((c) => c.box.fullSize), !0), a = xd(vd(t, "left"), !0), n = xd(vd(t, "right")), i = xd(vd(t, "top"), !0), r = xd(vd(t, "bottom")), l = iD(t, "x"), o = iD(t, "y");
  return {
    fullSize: e,
    leftAndTop: a.concat(i),
    rightAndBottom: n.concat(o).concat(r).concat(l),
    chartArea: vd(t, "chartArea"),
    vertical: a.concat(n).concat(o),
    horizontal: i.concat(r).concat(l)
  };
}
function rD(s, t, e, a) {
  return Math.max(s[e], t[e]) + Math.max(s[a], t[a]);
}
function rE(s, t) {
  s.top = Math.max(s.top, t.top), s.left = Math.max(s.left, t.left), s.bottom = Math.max(s.bottom, t.bottom), s.right = Math.max(s.right, t.right);
}
function $F(s, t, e, a) {
  const { pos: n, box: i } = e, r = s.maxPadding;
  if (!Ve(n)) {
    e.size && (s[n] -= e.size);
    const p = a[e.stack] || {
      size: 0,
      count: 1
    };
    p.size = Math.max(p.size, e.horizontal ? i.height : i.width), e.size = p.size / p.count, s[n] += e.size;
  }
  i.getPadding && rE(r, i.getPadding());
  const l = Math.max(0, t.outerWidth - rD(r, s, "left", "right")), o = Math.max(0, t.outerHeight - rD(r, s, "top", "bottom")), c = l !== s.w, d = o !== s.h;
  return s.w = l, s.h = o, e.horizontal ? {
    same: c,
    other: d
  } : {
    same: d,
    other: c
  };
}
function SF(s) {
  const t = s.maxPadding;
  function e(a) {
    const n = Math.max(t[a] - s[a], 0);
    return s[a] += n, n;
  }
  s.y += e("top"), s.x += e("left"), e("right"), e("bottom");
}
function kF(s, t) {
  const e = t.maxPadding;
  function a(n) {
    const i = {
      left: 0,
      top: 0,
      right: 0,
      bottom: 0
    };
    return n.forEach((r) => {
      i[r] = Math.max(t[r], e[r]);
    }), i;
  }
  return a(s ? [
    "left",
    "right"
  ] : [
    "top",
    "bottom"
  ]);
}
function Ed(s, t, e, a) {
  const n = [];
  let i, r, l, o, c, d;
  for (i = 0, r = s.length, c = 0; i < r; ++i) {
    l = s[i], o = l.box, o.update(l.width || t.w, l.height || t.h, kF(l.horizontal, t));
    const { same: p, other: h } = $F(t, e, l, a);
    c |= p && n.length, d = d || h, o.fullSize || n.push(l);
  }
  return c && Ed(n, t, e, a) || d;
}
function gh(s, t, e, a, n) {
  s.top = e, s.left = t, s.right = t + a, s.bottom = e + n, s.width = a, s.height = n;
}
function lD(s, t, e, a) {
  const n = e.padding;
  let { x: i, y: r } = t;
  for (const l of s) {
    const o = l.box, c = a[l.stack] || {
      count: 1,
      placed: 0,
      weight: 1
    }, d = l.stackWeight / c.weight || 1;
    if (l.horizontal) {
      const p = t.w * d, h = c.size || o.height;
      Cs(c.start) && (r = c.start), o.fullSize ? gh(o, n.left, r, e.outerWidth - n.right - n.left, h) : gh(o, t.left + c.placed, r, p, h), c.start = r, c.placed += p, r = o.bottom;
    } else {
      const p = t.h * d, h = c.size || o.width;
      Cs(c.start) && (i = c.start), o.fullSize ? gh(o, i, n.top, h, e.outerHeight - n.bottom - n.top) : gh(o, i, t.top + c.placed, h, p), c.start = i, c.placed += p, i = o.right;
    }
  }
  t.x = i, t.y = r;
}
var qn = {
  addBox(s, t) {
    s.boxes || (s.boxes = []), t.fullSize = t.fullSize || !1, t.position = t.position || "top", t.weight = t.weight || 0, t._layers = t._layers || function() {
      return [
        {
          z: 0,
          draw(e) {
            t.draw(e);
          }
        }
      ];
    }, s.boxes.push(t);
  },
  removeBox(s, t) {
    const e = s.boxes ? s.boxes.indexOf(t) : -1;
    e !== -1 && s.boxes.splice(e, 1);
  },
  configure(s, t, e) {
    t.fullSize = e.fullSize, t.position = e.position, t.weight = e.weight;
  },
  update(s, t, e, a) {
    if (!s)
      return;
    const n = vn(s.options.layout.padding), i = Math.max(t - n.width, 0), r = Math.max(e - n.height, 0), l = CF(s.boxes), o = l.vertical, c = l.horizontal;
    ka(s.boxes, (b) => {
      typeof b.beforeLayout == "function" && b.beforeLayout();
    });
    const d = o.reduce((b, A) => A.box.options && A.box.options.display === !1 ? b : b + 1, 0) || 1, p = Object.freeze({
      outerWidth: t,
      outerHeight: e,
      padding: n,
      availableWidth: i,
      availableHeight: r,
      vBoxMaxWidth: i / 2 / d,
      hBoxMaxHeight: r / 2
    }), h = Object.assign({}, n);
    rE(h, vn(a));
    const g = Object.assign({
      maxPadding: h,
      w: i,
      h: r,
      x: n.left,
      y: n.top
    }, n), x = AF(o.concat(c), p);
    Ed(l.fullSize, g, p, x), Ed(o, g, p, x), Ed(c, g, p, x) && Ed(o, g, p, x), SF(g), lD(l.leftAndTop, g, p, x), g.x += g.w, g.y += g.h, lD(l.rightAndBottom, g, p, x), s.chartArea = {
      left: g.left,
      top: g.top,
      right: g.left + g.w,
      bottom: g.top + g.h,
      height: g.h,
      width: g.w
    }, ka(l.chartArea, (b) => {
      const A = b.box;
      Object.assign(A, s.chartArea), A.update(g.w, g.h, {
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
      });
    });
  }
};
class lE {
  acquireContext(t, e) {
  }
  releaseContext(t) {
    return !1;
  }
  addEventListener(t, e, a) {
  }
  removeEventListener(t, e, a) {
  }
  getDevicePixelRatio() {
    return 1;
  }
  getMaximumSize(t, e, a, n) {
    return e = Math.max(0, e || t.width), a = a || t.height, {
      width: e,
      height: Math.max(0, n ? Math.floor(e / n) : a)
    };
  }
  isAttached(t) {
    return !0;
  }
  updateConfig(t) {
  }
}
class TF extends lE {
  acquireContext(t) {
    return t && t.getContext && t.getContext("2d") || null;
  }
  updateConfig(t) {
    t.options.animation = !1;
  }
}
const qh = "$chartjs", LF = {
  touchstart: "mousedown",
  touchmove: "mousemove",
  touchend: "mouseup",
  pointerenter: "mouseenter",
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointerleave: "mouseout",
  pointerout: "mouseout"
}, oD = (s) => s === null || s === "";
function DF(s, t) {
  const e = s.style, a = s.getAttribute("height"), n = s.getAttribute("width");
  if (s[qh] = {
    initial: {
      height: a,
      width: n,
      style: {
        display: e.display,
        height: e.height,
        width: e.width
      }
    }
  }, e.display = e.display || "block", e.boxSizing = e.boxSizing || "border-box", oD(n)) {
    const i = z1(s, "width");
    i !== void 0 && (s.width = i);
  }
  if (oD(a))
    if (s.style.height === "")
      s.height = s.width / (t || 2);
    else {
      const i = z1(s, "height");
      i !== void 0 && (s.height = i);
    }
  return s;
}
const oE = EU ? {
  passive: !0
} : !1;
function IF(s, t, e) {
  s && s.addEventListener(t, e, oE);
}
function PF(s, t, e) {
  s && s.canvas && s.canvas.removeEventListener(t, e, oE);
}
function EF(s, t) {
  const e = LF[s.type] || s.type, { x: a, y: n } = Ll(s, t);
  return {
    type: e,
    chart: t,
    native: s,
    x: a !== void 0 ? a : null,
    y: n !== void 0 ? n : null
  };
}
function wm(s, t) {
  for (const e of s)
    if (e === t || e.contains(t))
      return !0;
}
function NF(s, t, e) {
  const a = s.canvas, n = new MutationObserver((i) => {
    let r = !1;
    for (const l of i)
      r = r || wm(l.addedNodes, a), r = r && !wm(l.removedNodes, a);
    r && e();
  });
  return n.observe(document, {
    childList: !0,
    subtree: !0
  }), n;
}
function RF(s, t, e) {
  const a = s.canvas, n = new MutationObserver((i) => {
    let r = !1;
    for (const l of i)
      r = r || wm(l.removedNodes, a), r = r && !wm(l.addedNodes, a);
    r && e();
  });
  return n.observe(document, {
    childList: !0,
    subtree: !0
  }), n;
}
const uu = /* @__PURE__ */ new Map();
let cD = 0;
function cE() {
  const s = window.devicePixelRatio;
  s !== cD && (cD = s, uu.forEach((t, e) => {
    e.currentDevicePixelRatio !== s && t();
  }));
}
function YF(s, t) {
  uu.size || window.addEventListener("resize", cE), uu.set(s, t);
}
function _F(s) {
  uu.delete(s), uu.size || window.removeEventListener("resize", cE);
}
function OF(s, t, e) {
  const a = s.canvas, n = a && Kw(a);
  if (!n)
    return;
  const i = XP((l, o) => {
    const c = n.clientWidth;
    e(l, o), c < n.clientWidth && e();
  }, window), r = new ResizeObserver((l) => {
    const o = l[0], c = o.contentRect.width, d = o.contentRect.height;
    c === 0 && d === 0 || i(c, d);
  });
  return r.observe(n), YF(s, i), r;
}
function qb(s, t, e) {
  e && e.disconnect(), t === "resize" && _F(s);
}
function MF(s, t, e) {
  const a = s.canvas, n = XP((i) => {
    s.ctx !== null && e(EF(i, s));
  }, s);
  return IF(a, t, n), n;
}
class XF extends lE {
  acquireContext(t, e) {
    const a = t && t.getContext && t.getContext("2d");
    return a && a.canvas === t ? (DF(t, e), a) : null;
  }
  releaseContext(t) {
    const e = t.canvas;
    if (!e[qh])
      return !1;
    const a = e[qh].initial;
    [
      "height",
      "width"
    ].forEach((i) => {
      const r = a[i];
      ua(r) ? e.removeAttribute(i) : e.setAttribute(i, r);
    });
    const n = a.style || {};
    return Object.keys(n).forEach((i) => {
      e.style[i] = n[i];
    }), e.width = e.width, delete e[qh], !0;
  }
  addEventListener(t, e, a) {
    this.removeEventListener(t, e);
    const n = t.$proxies || (t.$proxies = {}), r = {
      attach: NF,
      detach: RF,
      resize: OF
    }[e] || MF;
    n[e] = r(t, e, a);
  }
  removeEventListener(t, e) {
    const a = t.$proxies || (t.$proxies = {}), n = a[e];
    if (!n)
      return;
    ({
      attach: qb,
      detach: qb,
      resize: qb
    }[e] || PF)(t, e, n), a[e] = void 0;
  }
  getDevicePixelRatio() {
    return window.devicePixelRatio;
  }
  getMaximumSize(t, e, a, n) {
    return PU(t, e, a, n);
  }
  isAttached(t) {
    const e = Kw(t);
    return !!(e && e.isConnected);
  }
}
function GF(s) {
  return !qw() || typeof OffscreenCanvas < "u" && s instanceof OffscreenCanvas ? TF : XF;
}
var Rh;
let cs = (Rh = class {
  constructor() {
    Jt(this, "x");
    Jt(this, "y");
    Jt(this, "active", !1);
    Jt(this, "options");
    Jt(this, "$animations");
  }
  tooltipPosition(t) {
    const { x: e, y: a } = this.getProps([
      "x",
      "y"
    ], t);
    return {
      x: e,
      y: a
    };
  }
  hasValue() {
    return al(this.x) && al(this.y);
  }
  getProps(t, e) {
    const a = this.$animations;
    if (!e || !a)
      return this;
    const n = {};
    return t.forEach((i) => {
      n[i] = a[i] && a[i].active() ? a[i]._to : this[i];
    }), n;
  }
}, Jt(Rh, "defaults", {}), Jt(Rh, "defaultRoutes"), Rh);
function HF(s, t) {
  const e = s.options.ticks, a = UF(s), n = Math.min(e.maxTicksLimit || a, a), i = e.major.enabled ? zF(t) : [], r = i.length, l = i[0], o = i[r - 1], c = [];
  if (r > n)
    return BF(t, c, i, r / n), c;
  const d = FF(i, t, n);
  if (r > 0) {
    let p, h;
    const g = r > 1 ? Math.round((o - l) / (r - 1)) : null;
    for (yh(t, c, d, ua(g) ? 0 : l - g, l), p = 0, h = r - 1; p < h; p++)
      yh(t, c, d, i[p], i[p + 1]);
    return yh(t, c, d, o, ua(g) ? t.length : o + g), c;
  }
  return yh(t, c, d), c;
}
function UF(s) {
  const t = s.options.offset, e = s._tickSize(), a = s._length / e + (t ? 0 : 1), n = s._maxLength / e;
  return Math.floor(Math.min(a, n));
}
function FF(s, t, e) {
  const a = WF(s), n = t.length / e;
  if (!a)
    return Math.max(n, 1);
  const i = Y2(a);
  for (let r = 0, l = i.length - 1; r < l; r++) {
    const o = i[r];
    if (o > n)
      return o;
  }
  return Math.max(n, 1);
}
function zF(s) {
  const t = [];
  let e, a;
  for (e = 0, a = s.length; e < a; e++)
    s[e].major && t.push(e);
  return t;
}
function BF(s, t, e, a) {
  let n = 0, i = e[0], r;
  for (a = Math.ceil(a), r = 0; r < s.length; r++)
    r === i && (t.push(s[r]), n++, i = e[n * a]);
}
function yh(s, t, e, a, n) {
  const i = Fe(a, 0), r = Math.min(Fe(n, s.length), s.length);
  let l = 0, o, c, d;
  for (e = Math.ceil(e), n && (o = n - a, e = o / Math.floor(o / e)), d = i; d < 0; )
    l++, d = Math.round(i + l * e);
  for (c = Math.max(i, 0); c < r; c++)
    c === d && (t.push(s[c]), l++, d = Math.round(i + l * e));
}
function WF(s) {
  const t = s.length;
  let e, a;
  if (t < 2)
    return !1;
  for (a = s[0], e = 1; e < t; ++e)
    if (s[e] - s[e - 1] !== a)
      return !1;
  return a;
}
const jF = (s) => s === "left" ? "right" : s === "right" ? "left" : s, dD = (s, t, e) => t === "top" || t === "left" ? s[t] + e : s[t] - e, uD = (s, t) => Math.min(t || s, s);
function pD(s, t) {
  const e = [], a = s.length / t, n = s.length;
  let i = 0;
  for (; i < n; i += a)
    e.push(s[Math.floor(i)]);
  return e;
}
function VF(s, t, e) {
  const a = s.ticks.length, n = Math.min(t, a - 1), i = s._startPixel, r = s._endPixel, l = 1e-6;
  let o = s.getPixelForTick(n), c;
  if (!(e && (a === 1 ? c = Math.max(o - i, r - o) : t === 0 ? c = (s.getPixelForTick(1) - o) / 2 : c = (o - s.getPixelForTick(n - 1)) / 2, o += n < t ? c : -c, o < i - l || o > r + l)))
    return o;
}
function qF(s, t) {
  ka(s, (e) => {
    const a = e.gc, n = a.length / 2;
    let i;
    if (n > t) {
      for (i = 0; i < n; ++i)
        delete e.data[a[i]];
      a.splice(0, n);
    }
  });
}
function wd(s) {
  return s.drawTicks ? s.tickLength : 0;
}
function hD(s, t) {
  if (!s.display)
    return 0;
  const e = an(s.font, t), a = vn(s.padding);
  return (ya(s.text) ? s.text.length : 1) * e.lineHeight + a.height;
}
function KF(s, t) {
  return cl(s, {
    scale: t,
    type: "scale"
  });
}
function JF(s, t, e) {
  return cl(s, {
    tick: e,
    index: t,
    type: "tick"
  });
}
function QF(s, t, e) {
  let a = Fw(s);
  return (e && t !== "right" || !e && t === "right") && (a = jF(a)), a;
}
function ZF(s, t, e, a) {
  const { top: n, left: i, bottom: r, right: l, chart: o } = s, { chartArea: c, scales: d } = o;
  let p = 0, h, g, x;
  const b = r - n, A = l - i;
  if (s.isHorizontal()) {
    if (g = Bn(a, i, l), Ve(e)) {
      const T = Object.keys(e)[0], R = e[T];
      x = d[T].getPixelForValue(R) + b - t;
    } else
      e === "center" ? x = (c.bottom + c.top) / 2 + b - t : x = dD(s, e, t);
    h = l - i;
  } else {
    if (Ve(e)) {
      const T = Object.keys(e)[0], R = e[T];
      g = d[T].getPixelForValue(R) - A + t;
    } else
      e === "center" ? g = (c.left + c.right) / 2 - A + t : g = dD(s, e, t);
    x = Bn(a, r, n), p = e === "left" ? -Fa : Fa;
  }
  return {
    titleX: g,
    titleY: x,
    maxWidth: h,
    rotation: p
  };
}
class lo extends cs {
  constructor(t) {
    super(), this.id = t.id, this.type = t.type, this.options = void 0, this.ctx = t.ctx, this.chart = t.chart, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this._margins = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, this.maxWidth = void 0, this.maxHeight = void 0, this.paddingTop = void 0, this.paddingBottom = void 0, this.paddingLeft = void 0, this.paddingRight = void 0, this.axis = void 0, this.labelRotation = void 0, this.min = void 0, this.max = void 0, this._range = void 0, this.ticks = [], this._gridLineItems = null, this._labelItems = null, this._labelSizes = null, this._length = 0, this._maxLength = 0, this._longestTextCache = {}, this._startPixel = void 0, this._endPixel = void 0, this._reversePixels = !1, this._userMax = void 0, this._userMin = void 0, this._suggestedMax = void 0, this._suggestedMin = void 0, this._ticksLength = 0, this._borderValue = 0, this._cache = {}, this._dataLimitsCached = !1, this.$context = void 0;
  }
  init(t) {
    this.options = t.setContext(this.getContext()), this.axis = t.axis, this._userMin = this.parse(t.min), this._userMax = this.parse(t.max), this._suggestedMin = this.parse(t.suggestedMin), this._suggestedMax = this.parse(t.suggestedMax);
  }
  parse(t, e) {
    return t;
  }
  getUserBounds() {
    let { _userMin: t, _userMax: e, _suggestedMin: a, _suggestedMax: n } = this;
    return t = Ds(t, Number.POSITIVE_INFINITY), e = Ds(e, Number.NEGATIVE_INFINITY), a = Ds(a, Number.POSITIVE_INFINITY), n = Ds(n, Number.NEGATIVE_INFINITY), {
      min: Ds(t, a),
      max: Ds(e, n),
      minDefined: Va(t),
      maxDefined: Va(e)
    };
  }
  getMinMax(t) {
    let { min: e, max: a, minDefined: n, maxDefined: i } = this.getUserBounds(), r;
    if (n && i)
      return {
        min: e,
        max: a
      };
    const l = this.getMatchingVisibleMetas();
    for (let o = 0, c = l.length; o < c; ++o)
      r = l[o].controller.getMinMax(this, t), n || (e = Math.min(e, r.min)), i || (a = Math.max(a, r.max));
    return e = i && e > a ? a : e, a = n && e > a ? e : a, {
      min: Ds(e, Ds(a, e)),
      max: Ds(a, Ds(e, a))
    };
  }
  getPadding() {
    return {
      left: this.paddingLeft || 0,
      top: this.paddingTop || 0,
      right: this.paddingRight || 0,
      bottom: this.paddingBottom || 0
    };
  }
  getTicks() {
    return this.ticks;
  }
  getLabels() {
    const t = this.chart.data;
    return this.options.labels || (this.isHorizontal() ? t.xLabels : t.yLabels) || t.labels || [];
  }
  getLabelItems(t = this.chart.chartArea) {
    return this._labelItems || (this._labelItems = this._computeLabelItems(t));
  }
  beforeLayout() {
    this._cache = {}, this._dataLimitsCached = !1;
  }
  beforeUpdate() {
    Sa(this.options.beforeUpdate, [
      this
    ]);
  }
  update(t, e, a) {
    const { beginAtZero: n, grace: i, ticks: r } = this.options, l = r.sampleSize;
    this.beforeUpdate(), this.maxWidth = t, this.maxHeight = e, this._margins = a = Object.assign({
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, a), this.ticks = null, this._labelSizes = null, this._gridLineItems = null, this._labelItems = null, this.beforeSetDimensions(), this.setDimensions(), this.afterSetDimensions(), this._maxLength = this.isHorizontal() ? this.width + a.left + a.right : this.height + a.top + a.bottom, this._dataLimitsCached || (this.beforeDataLimits(), this.determineDataLimits(), this.afterDataLimits(), this._range = cU(this, i, n), this._dataLimitsCached = !0), this.beforeBuildTicks(), this.ticks = this.buildTicks() || [], this.afterBuildTicks();
    const o = l < this.ticks.length;
    this._convertTicksToLabels(o ? pD(this.ticks, l) : this.ticks), this.configure(), this.beforeCalculateLabelRotation(), this.calculateLabelRotation(), this.afterCalculateLabelRotation(), r.display && (r.autoSkip || r.source === "auto") && (this.ticks = HF(this, this.ticks), this._labelSizes = null, this.afterAutoSkip()), o && this._convertTicksToLabels(this.ticks), this.beforeFit(), this.fit(), this.afterFit(), this.afterUpdate();
  }
  configure() {
    let t = this.options.reverse, e, a;
    this.isHorizontal() ? (e = this.left, a = this.right) : (e = this.top, a = this.bottom, t = !t), this._startPixel = e, this._endPixel = a, this._reversePixels = t, this._length = a - e, this._alignToPixels = this.options.alignToPixels;
  }
  afterUpdate() {
    Sa(this.options.afterUpdate, [
      this
    ]);
  }
  beforeSetDimensions() {
    Sa(this.options.beforeSetDimensions, [
      this
    ]);
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = 0, this.right = this.width) : (this.height = this.maxHeight, this.top = 0, this.bottom = this.height), this.paddingLeft = 0, this.paddingTop = 0, this.paddingRight = 0, this.paddingBottom = 0;
  }
  afterSetDimensions() {
    Sa(this.options.afterSetDimensions, [
      this
    ]);
  }
  _callHooks(t) {
    this.chart.notifyPlugins(t, this.getContext()), Sa(this.options[t], [
      this
    ]);
  }
  beforeDataLimits() {
    this._callHooks("beforeDataLimits");
  }
  determineDataLimits() {
  }
  afterDataLimits() {
    this._callHooks("afterDataLimits");
  }
  beforeBuildTicks() {
    this._callHooks("beforeBuildTicks");
  }
  buildTicks() {
    return [];
  }
  afterBuildTicks() {
    this._callHooks("afterBuildTicks");
  }
  beforeTickToLabelConversion() {
    Sa(this.options.beforeTickToLabelConversion, [
      this
    ]);
  }
  generateTickLabels(t) {
    const e = this.options.ticks;
    let a, n, i;
    for (a = 0, n = t.length; a < n; a++)
      i = t[a], i.label = Sa(e.callback, [
        i.value,
        a,
        t
      ], this);
  }
  afterTickToLabelConversion() {
    Sa(this.options.afterTickToLabelConversion, [
      this
    ]);
  }
  beforeCalculateLabelRotation() {
    Sa(this.options.beforeCalculateLabelRotation, [
      this
    ]);
  }
  calculateLabelRotation() {
    const t = this.options, e = t.ticks, a = uD(this.ticks.length, t.ticks.maxTicksLimit), n = e.minRotation || 0, i = e.maxRotation;
    let r = n, l, o, c;
    if (!this._isVisible() || !e.display || n >= i || a <= 1 || !this.isHorizontal()) {
      this.labelRotation = n;
      return;
    }
    const d = this._getLabelSizes(), p = d.widest.width, h = d.highest.height, g = Yn(this.chart.width - p, 0, this.maxWidth);
    l = t.offset ? this.maxWidth / a : g / (a - 1), p + 6 > l && (l = g / (a - (t.offset ? 0.5 : 1)), o = this.maxHeight - wd(t.grid) - e.padding - hD(t.title, this.chart.options.font), c = Math.sqrt(p * p + h * h), r = sf(Math.min(Math.asin(Yn((d.highest.height + 6) / l, -1, 1)), Math.asin(Yn(o / c, -1, 1)) - Math.asin(Yn(h / c, -1, 1)))), r = Math.max(n, Math.min(i, r))), this.labelRotation = r;
  }
  afterCalculateLabelRotation() {
    Sa(this.options.afterCalculateLabelRotation, [
      this
    ]);
  }
  afterAutoSkip() {
  }
  beforeFit() {
    Sa(this.options.beforeFit, [
      this
    ]);
  }
  fit() {
    const t = {
      width: 0,
      height: 0
    }, { chart: e, options: { ticks: a, title: n, grid: i } } = this, r = this._isVisible(), l = this.isHorizontal();
    if (r) {
      const o = hD(n, e.options.font);
      if (l ? (t.width = this.maxWidth, t.height = wd(i) + o) : (t.height = this.maxHeight, t.width = wd(i) + o), a.display && this.ticks.length) {
        const { first: c, last: d, widest: p, highest: h } = this._getLabelSizes(), g = a.padding * 2, x = bn(this.labelRotation), b = Math.cos(x), A = Math.sin(x);
        if (l) {
          const T = a.mirror ? 0 : A * p.width + b * h.height;
          t.height = Math.min(this.maxHeight, t.height + T + g);
        } else {
          const T = a.mirror ? 0 : b * p.width + A * h.height;
          t.width = Math.min(this.maxWidth, t.width + T + g);
        }
        this._calculatePadding(c, d, A, b);
      }
    }
    this._handleMargins(), l ? (this.width = this._length = e.width - this._margins.left - this._margins.right, this.height = t.height) : (this.width = t.width, this.height = this._length = e.height - this._margins.top - this._margins.bottom);
  }
  _calculatePadding(t, e, a, n) {
    const { ticks: { align: i, padding: r }, position: l } = this.options, o = this.labelRotation !== 0, c = l !== "top" && this.axis === "x";
    if (this.isHorizontal()) {
      const d = this.getPixelForTick(0) - this.left, p = this.right - this.getPixelForTick(this.ticks.length - 1);
      let h = 0, g = 0;
      o ? c ? (h = n * t.width, g = a * e.height) : (h = a * t.height, g = n * e.width) : i === "start" ? g = e.width : i === "end" ? h = t.width : i !== "inner" && (h = t.width / 2, g = e.width / 2), this.paddingLeft = Math.max((h - d + r) * this.width / (this.width - d), 0), this.paddingRight = Math.max((g - p + r) * this.width / (this.width - p), 0);
    } else {
      let d = e.height / 2, p = t.height / 2;
      i === "start" ? (d = 0, p = t.height) : i === "end" && (d = e.height, p = 0), this.paddingTop = d + r, this.paddingBottom = p + r;
    }
  }
  _handleMargins() {
    this._margins && (this._margins.left = Math.max(this.paddingLeft, this._margins.left), this._margins.top = Math.max(this.paddingTop, this._margins.top), this._margins.right = Math.max(this.paddingRight, this._margins.right), this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom));
  }
  afterFit() {
    Sa(this.options.afterFit, [
      this
    ]);
  }
  isHorizontal() {
    const { axis: t, position: e } = this.options;
    return e === "top" || e === "bottom" || t === "x";
  }
  isFullSize() {
    return this.options.fullSize;
  }
  _convertTicksToLabels(t) {
    this.beforeTickToLabelConversion(), this.generateTickLabels(t);
    let e, a;
    for (e = 0, a = t.length; e < a; e++)
      ua(t[e].label) && (t.splice(e, 1), a--, e--);
    this.afterTickToLabelConversion();
  }
  _getLabelSizes() {
    let t = this._labelSizes;
    if (!t) {
      const e = this.options.ticks.sampleSize;
      let a = this.ticks;
      e < a.length && (a = pD(a, e)), this._labelSizes = t = this._computeLabelSizes(a, a.length, this.options.ticks.maxTicksLimit);
    }
    return t;
  }
  _computeLabelSizes(t, e, a) {
    const { ctx: n, _longestTextCache: i } = this, r = [], l = [], o = Math.floor(e / uD(e, a));
    let c = 0, d = 0, p, h, g, x, b, A, T, R, C, v, P;
    for (p = 0; p < e; p += o) {
      if (x = t[p].label, b = this._resolveTickFontOptions(p), n.font = A = b.string, T = i[A] = i[A] || {
        data: {},
        gc: []
      }, R = b.lineHeight, C = v = 0, !ua(x) && !ya(x))
        C = vm(n, T.data, T.gc, C, x), v = R;
      else if (ya(x))
        for (h = 0, g = x.length; h < g; ++h)
          P = x[h], !ua(P) && !ya(P) && (C = vm(n, T.data, T.gc, C, P), v += R);
      r.push(C), l.push(v), c = Math.max(C, c), d = Math.max(v, d);
    }
    qF(i, e);
    const O = r.indexOf(c), N = l.indexOf(d), H = (F) => ({
      width: r[F] || 0,
      height: l[F] || 0
    });
    return {
      first: H(0),
      last: H(e - 1),
      widest: H(O),
      highest: H(N),
      widths: r,
      heights: l
    };
  }
  getLabelForValue(t) {
    return t;
  }
  getPixelForValue(t, e) {
    return NaN;
  }
  getValueForPixel(t) {
  }
  getPixelForTick(t) {
    const e = this.ticks;
    return t < 0 || t > e.length - 1 ? null : this.getPixelForValue(e[t].value);
  }
  getPixelForDecimal(t) {
    this._reversePixels && (t = 1 - t);
    const e = this._startPixel + t * this._length;
    return M2(this._alignToPixels ? Sl(this.chart, e, 0) : e);
  }
  getDecimalForPixel(t) {
    const e = (t - this._startPixel) / this._length;
    return this._reversePixels ? 1 - e : e;
  }
  getBasePixel() {
    return this.getPixelForValue(this.getBaseValue());
  }
  getBaseValue() {
    const { min: t, max: e } = this;
    return t < 0 && e < 0 ? e : t > 0 && e > 0 ? t : 0;
  }
  getContext(t) {
    const e = this.ticks || [];
    if (t >= 0 && t < e.length) {
      const a = e[t];
      return a.$context || (a.$context = JF(this.getContext(), t, a));
    }
    return this.$context || (this.$context = KF(this.chart.getContext(), this));
  }
  _tickSize() {
    const t = this.options.ticks, e = bn(this.labelRotation), a = Math.abs(Math.cos(e)), n = Math.abs(Math.sin(e)), i = this._getLabelSizes(), r = t.autoSkipPadding || 0, l = i ? i.widest.width + r : 0, o = i ? i.highest.height + r : 0;
    return this.isHorizontal() ? o * a > l * n ? l / a : o / n : o * n < l * a ? o / a : l / n;
  }
  _isVisible() {
    const t = this.options.display;
    return t !== "auto" ? !!t : this.getMatchingVisibleMetas().length > 0;
  }
  _computeGridLineItems(t) {
    const e = this.axis, a = this.chart, n = this.options, { grid: i, position: r, border: l } = n, o = i.offset, c = this.isHorizontal(), p = this.ticks.length + (o ? 1 : 0), h = wd(i), g = [], x = l.setContext(this.getContext()), b = x.display ? x.width : 0, A = b / 2, T = function(M) {
      return Sl(a, M, b);
    };
    let R, C, v, P, O, N, H, F, B, Q, it, et;
    if (r === "top")
      R = T(this.bottom), N = this.bottom - h, F = R - A, Q = T(t.top) + A, et = t.bottom;
    else if (r === "bottom")
      R = T(this.top), Q = t.top, et = T(t.bottom) - A, N = R + A, F = this.top + h;
    else if (r === "left")
      R = T(this.right), O = this.right - h, H = R - A, B = T(t.left) + A, it = t.right;
    else if (r === "right")
      R = T(this.left), B = t.left, it = T(t.right) - A, O = R + A, H = this.left + h;
    else if (e === "x") {
      if (r === "center")
        R = T((t.top + t.bottom) / 2 + 0.5);
      else if (Ve(r)) {
        const M = Object.keys(r)[0], W = r[M];
        R = T(this.chart.scales[M].getPixelForValue(W));
      }
      Q = t.top, et = t.bottom, N = R + A, F = N + h;
    } else if (e === "y") {
      if (r === "center")
        R = T((t.left + t.right) / 2);
      else if (Ve(r)) {
        const M = Object.keys(r)[0], W = r[M];
        R = T(this.chart.scales[M].getPixelForValue(W));
      }
      O = R - A, H = O - h, B = t.left, it = t.right;
    }
    const rt = Fe(n.ticks.maxTicksLimit, p), U = Math.max(1, Math.ceil(p / rt));
    for (C = 0; C < p; C += U) {
      const M = this.getContext(C), W = i.setContext(M), J = l.setContext(M), vt = W.lineWidth, St = W.color, zt = J.dash || [], j = J.dashOffset, tt = W.tickWidth, lt = W.tickColor, at = W.tickBorderDash || [], nt = W.tickBorderDashOffset;
      v = VF(this, C, o), v !== void 0 && (P = Sl(a, v, vt), c ? O = H = B = it = P : N = F = Q = et = P, g.push({
        tx1: O,
        ty1: N,
        tx2: H,
        ty2: F,
        x1: B,
        y1: Q,
        x2: it,
        y2: et,
        width: vt,
        color: St,
        borderDash: zt,
        borderDashOffset: j,
        tickWidth: tt,
        tickColor: lt,
        tickBorderDash: at,
        tickBorderDashOffset: nt
      }));
    }
    return this._ticksLength = p, this._borderValue = R, g;
  }
  _computeLabelItems(t) {
    const e = this.axis, a = this.options, { position: n, ticks: i } = a, r = this.isHorizontal(), l = this.ticks, { align: o, crossAlign: c, padding: d, mirror: p } = i, h = wd(a.grid), g = h + d, x = p ? -d : g, b = -bn(this.labelRotation), A = [];
    let T, R, C, v, P, O, N, H, F, B, Q, it, et = "middle";
    if (n === "top")
      O = this.bottom - x, N = this._getXAxisLabelAlignment();
    else if (n === "bottom")
      O = this.top + x, N = this._getXAxisLabelAlignment();
    else if (n === "left") {
      const U = this._getYAxisLabelAlignment(h);
      N = U.textAlign, P = U.x;
    } else if (n === "right") {
      const U = this._getYAxisLabelAlignment(h);
      N = U.textAlign, P = U.x;
    } else if (e === "x") {
      if (n === "center")
        O = (t.top + t.bottom) / 2 + g;
      else if (Ve(n)) {
        const U = Object.keys(n)[0], M = n[U];
        O = this.chart.scales[U].getPixelForValue(M) + g;
      }
      N = this._getXAxisLabelAlignment();
    } else if (e === "y") {
      if (n === "center")
        P = (t.left + t.right) / 2 - g;
      else if (Ve(n)) {
        const U = Object.keys(n)[0], M = n[U];
        P = this.chart.scales[U].getPixelForValue(M);
      }
      N = this._getYAxisLabelAlignment(h).textAlign;
    }
    e === "y" && (o === "start" ? et = "top" : o === "end" && (et = "bottom"));
    const rt = this._getLabelSizes();
    for (T = 0, R = l.length; T < R; ++T) {
      C = l[T], v = C.label;
      const U = i.setContext(this.getContext(T));
      H = this.getPixelForTick(T) + i.labelOffset, F = this._resolveTickFontOptions(T), B = F.lineHeight, Q = ya(v) ? v.length : 1;
      const M = Q / 2, W = U.color, J = U.textStrokeColor, vt = U.textStrokeWidth;
      let St = N;
      r ? (P = H, N === "inner" && (T === R - 1 ? St = this.options.reverse ? "left" : "right" : T === 0 ? St = this.options.reverse ? "right" : "left" : St = "center"), n === "top" ? c === "near" || b !== 0 ? it = -Q * B + B / 2 : c === "center" ? it = -rt.highest.height / 2 - M * B + B : it = -rt.highest.height + B / 2 : c === "near" || b !== 0 ? it = B / 2 : c === "center" ? it = rt.highest.height / 2 - M * B : it = rt.highest.height - Q * B, p && (it *= -1), b !== 0 && !U.showLabelBackdrop && (P += B / 2 * Math.sin(b))) : (O = H, it = (1 - Q) * B / 2);
      let zt;
      if (U.showLabelBackdrop) {
        const j = vn(U.backdropPadding), tt = rt.heights[T], lt = rt.widths[T];
        let at = it - j.top, nt = 0 - j.left;
        switch (et) {
          case "middle":
            at -= tt / 2;
            break;
          case "bottom":
            at -= tt;
            break;
        }
        switch (N) {
          case "center":
            nt -= lt / 2;
            break;
          case "right":
            nt -= lt;
            break;
          case "inner":
            T === R - 1 ? nt -= lt : T > 0 && (nt -= lt / 2);
            break;
        }
        zt = {
          left: nt,
          top: at,
          width: lt + j.width,
          height: tt + j.height,
          color: U.backdropColor
        };
      }
      A.push({
        label: v,
        font: F,
        textOffset: it,
        options: {
          rotation: b,
          color: W,
          strokeColor: J,
          strokeWidth: vt,
          textAlign: St,
          textBaseline: et,
          translation: [
            P,
            O
          ],
          backdrop: zt
        }
      });
    }
    return A;
  }
  _getXAxisLabelAlignment() {
    const { position: t, ticks: e } = this.options;
    if (-bn(this.labelRotation))
      return t === "top" ? "left" : "right";
    let n = "center";
    return e.align === "start" ? n = "left" : e.align === "end" ? n = "right" : e.align === "inner" && (n = "inner"), n;
  }
  _getYAxisLabelAlignment(t) {
    const { position: e, ticks: { crossAlign: a, mirror: n, padding: i } } = this.options, r = this._getLabelSizes(), l = t + i, o = r.widest.width;
    let c, d;
    return e === "left" ? n ? (d = this.right + i, a === "near" ? c = "left" : a === "center" ? (c = "center", d += o / 2) : (c = "right", d += o)) : (d = this.right - l, a === "near" ? c = "right" : a === "center" ? (c = "center", d -= o / 2) : (c = "left", d = this.left)) : e === "right" ? n ? (d = this.left + i, a === "near" ? c = "right" : a === "center" ? (c = "center", d -= o / 2) : (c = "left", d -= o)) : (d = this.left + l, a === "near" ? c = "left" : a === "center" ? (c = "center", d += o / 2) : (c = "right", d = this.right)) : c = "right", {
      textAlign: c,
      x: d
    };
  }
  _computeLabelArea() {
    if (this.options.ticks.mirror)
      return;
    const t = this.chart, e = this.options.position;
    if (e === "left" || e === "right")
      return {
        top: 0,
        left: this.left,
        bottom: t.height,
        right: this.right
      };
    if (e === "top" || e === "bottom")
      return {
        top: this.top,
        left: 0,
        bottom: this.bottom,
        right: t.width
      };
  }
  drawBackground() {
    const { ctx: t, options: { backgroundColor: e }, left: a, top: n, width: i, height: r } = this;
    e && (t.save(), t.fillStyle = e, t.fillRect(a, n, i, r), t.restore());
  }
  getLineWidthForValue(t) {
    const e = this.options.grid;
    if (!this._isVisible() || !e.display)
      return 0;
    const n = this.ticks.findIndex((i) => i.value === t);
    return n >= 0 ? e.setContext(this.getContext(n)).lineWidth : 0;
  }
  drawGrid(t) {
    const e = this.options.grid, a = this.ctx, n = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(t));
    let i, r;
    const l = (o, c, d) => {
      !d.width || !d.color || (a.save(), a.lineWidth = d.width, a.strokeStyle = d.color, a.setLineDash(d.borderDash || []), a.lineDashOffset = d.borderDashOffset, a.beginPath(), a.moveTo(o.x, o.y), a.lineTo(c.x, c.y), a.stroke(), a.restore());
    };
    if (e.display)
      for (i = 0, r = n.length; i < r; ++i) {
        const o = n[i];
        e.drawOnChartArea && l({
          x: o.x1,
          y: o.y1
        }, {
          x: o.x2,
          y: o.y2
        }, o), e.drawTicks && l({
          x: o.tx1,
          y: o.ty1
        }, {
          x: o.tx2,
          y: o.ty2
        }, {
          color: o.tickColor,
          width: o.tickWidth,
          borderDash: o.tickBorderDash,
          borderDashOffset: o.tickBorderDashOffset
        });
      }
  }
  drawBorder() {
    const { chart: t, ctx: e, options: { border: a, grid: n } } = this, i = a.setContext(this.getContext()), r = a.display ? i.width : 0;
    if (!r)
      return;
    const l = n.setContext(this.getContext(0)).lineWidth, o = this._borderValue;
    let c, d, p, h;
    this.isHorizontal() ? (c = Sl(t, this.left, r) - r / 2, d = Sl(t, this.right, l) + l / 2, p = h = o) : (p = Sl(t, this.top, r) - r / 2, h = Sl(t, this.bottom, l) + l / 2, c = d = o), e.save(), e.lineWidth = i.width, e.strokeStyle = i.color, e.beginPath(), e.moveTo(c, p), e.lineTo(d, h), e.stroke(), e.restore();
  }
  drawLabels(t) {
    if (!this.options.ticks.display)
      return;
    const a = this.ctx, n = this._computeLabelArea();
    n && Wu(a, n);
    const i = this.getLabelItems(t);
    for (const r of i) {
      const l = r.options, o = r.font, c = r.label, d = r.textOffset;
      jl(a, c, 0, d, o, l);
    }
    n && ju(a);
  }
  drawTitle() {
    const { ctx: t, options: { position: e, title: a, reverse: n } } = this;
    if (!a.display)
      return;
    const i = an(a.font), r = vn(a.padding), l = a.align;
    let o = i.lineHeight / 2;
    e === "bottom" || e === "center" || Ve(e) ? (o += r.bottom, ya(a.text) && (o += i.lineHeight * (a.text.length - 1))) : o += r.top;
    const { titleX: c, titleY: d, maxWidth: p, rotation: h } = ZF(this, o, e, l);
    jl(t, a.text, 0, 0, i, {
      color: a.color,
      maxWidth: p,
      rotation: h,
      textAlign: QF(l, e, n),
      textBaseline: "middle",
      translation: [
        c,
        d
      ]
    });
  }
  draw(t) {
    this._isVisible() && (this.drawBackground(), this.drawGrid(t), this.drawBorder(), this.drawTitle(), this.drawLabels(t));
  }
  _layers() {
    const t = this.options, e = t.ticks && t.ticks.z || 0, a = Fe(t.grid && t.grid.z, -1), n = Fe(t.border && t.border.z, 0);
    return !this._isVisible() || this.draw !== lo.prototype.draw ? [
      {
        z: e,
        draw: (i) => {
          this.draw(i);
        }
      }
    ] : [
      {
        z: a,
        draw: (i) => {
          this.drawBackground(), this.drawGrid(i), this.drawTitle();
        }
      },
      {
        z: n,
        draw: () => {
          this.drawBorder();
        }
      },
      {
        z: e,
        draw: (i) => {
          this.drawLabels(i);
        }
      }
    ];
  }
  getMatchingVisibleMetas(t) {
    const e = this.chart.getSortedVisibleDatasetMetas(), a = this.axis + "AxisID", n = [];
    let i, r;
    for (i = 0, r = e.length; i < r; ++i) {
      const l = e[i];
      l[a] === this.id && (!t || l.type === t) && n.push(l);
    }
    return n;
  }
  _resolveTickFontOptions(t) {
    const e = this.options.ticks.setContext(this.getContext(t));
    return an(e.font);
  }
  _maxDigits() {
    const t = this._resolveTickFontOptions(0).lineHeight;
    return (this.isHorizontal() ? this.width : this.height) / t;
  }
}
class fh {
  constructor(t, e, a) {
    this.type = t, this.scope = e, this.override = a, this.items = /* @__PURE__ */ Object.create(null);
  }
  isForType(t) {
    return Object.prototype.isPrototypeOf.call(this.type.prototype, t.prototype);
  }
  register(t) {
    const e = Object.getPrototypeOf(t);
    let a;
    az(e) && (a = this.register(e));
    const n = this.items, i = t.id, r = this.scope + "." + i;
    if (!i)
      throw new Error("class does not have id: " + t);
    return i in n || (n[i] = t, tz(t, r, a), this.override && en.override(t.id, t.overrides)), r;
  }
  get(t) {
    return this.items[t];
  }
  unregister(t) {
    const e = this.items, a = t.id, n = this.scope;
    a in e && delete e[a], n && a in en[n] && (delete en[n][a], this.override && delete Wl[a]);
  }
}
function tz(s, t, e) {
  const a = cu(/* @__PURE__ */ Object.create(null), [
    e ? en.get(e) : {},
    en.get(t),
    s.defaults
  ]);
  en.set(t, a), s.defaultRoutes && ez(t, s.defaultRoutes), s.descriptors && en.describe(t, s.descriptors);
}
function ez(s, t) {
  Object.keys(t).forEach((e) => {
    const a = e.split("."), n = a.pop(), i = [
      s
    ].concat(a).join("."), r = t[e].split("."), l = r.pop(), o = r.join(".");
    en.route(i, n, o, l);
  });
}
function az(s) {
  return "id" in s && "defaults" in s;
}
class nz {
  constructor() {
    this.controllers = new fh(fi, "datasets", !0), this.elements = new fh(cs, "elements"), this.plugins = new fh(Object, "plugins"), this.scales = new fh(lo, "scales"), this._typedRegistries = [
      this.controllers,
      this.scales,
      this.elements
    ];
  }
  add(...t) {
    this._each("register", t);
  }
  remove(...t) {
    this._each("unregister", t);
  }
  addControllers(...t) {
    this._each("register", t, this.controllers);
  }
  addElements(...t) {
    this._each("register", t, this.elements);
  }
  addPlugins(...t) {
    this._each("register", t, this.plugins);
  }
  addScales(...t) {
    this._each("register", t, this.scales);
  }
  getController(t) {
    return this._get(t, this.controllers, "controller");
  }
  getElement(t) {
    return this._get(t, this.elements, "element");
  }
  getPlugin(t) {
    return this._get(t, this.plugins, "plugin");
  }
  getScale(t) {
    return this._get(t, this.scales, "scale");
  }
  removeControllers(...t) {
    this._each("unregister", t, this.controllers);
  }
  removeElements(...t) {
    this._each("unregister", t, this.elements);
  }
  removePlugins(...t) {
    this._each("unregister", t, this.plugins);
  }
  removeScales(...t) {
    this._each("unregister", t, this.scales);
  }
  _each(t, e, a) {
    [
      ...e
    ].forEach((n) => {
      const i = a || this._getRegistryForType(n);
      a || i.isForType(n) || i === this.plugins && n.id ? this._exec(t, i, n) : ka(n, (r) => {
        const l = a || this._getRegistryForType(r);
        this._exec(t, l, r);
      });
    });
  }
  _exec(t, e, a) {
    const n = Gw(t);
    Sa(a["before" + n], [], a), e[t](a), Sa(a["after" + n], [], a);
  }
  _getRegistryForType(t) {
    for (let e = 0; e < this._typedRegistries.length; e++) {
      const a = this._typedRegistries[e];
      if (a.isForType(t))
        return a;
    }
    return this.plugins;
  }
  _get(t, e, a) {
    const n = e.get(t);
    if (n === void 0)
      throw new Error('"' + t + '" is not a registered ' + a + ".");
    return n;
  }
}
var Pi = /* @__PURE__ */ new nz();
class sz {
  constructor() {
    this._init = [];
  }
  notify(t, e, a, n) {
    e === "beforeInit" && (this._init = this._createDescriptors(t, !0), this._notify(this._init, t, "install"));
    const i = n ? this._descriptors(t).filter(n) : this._descriptors(t), r = this._notify(i, t, e, a);
    return e === "afterDestroy" && (this._notify(i, t, "stop"), this._notify(this._init, t, "uninstall")), r;
  }
  _notify(t, e, a, n) {
    n = n || {};
    for (const i of t) {
      const r = i.plugin, l = r[a], o = [
        e,
        n,
        i.options
      ];
      if (Sa(l, o, r) === !1 && n.cancelable)
        return !1;
    }
    return !0;
  }
  invalidate() {
    ua(this._cache) || (this._oldCache = this._cache, this._cache = void 0);
  }
  _descriptors(t) {
    if (this._cache)
      return this._cache;
    const e = this._cache = this._createDescriptors(t);
    return this._notifyStateChanges(t), e;
  }
  _createDescriptors(t, e) {
    const a = t && t.config, n = Fe(a.options && a.options.plugins, {}), i = iz(a);
    return n === !1 && !e ? [] : lz(t, i, n, e);
  }
  _notifyStateChanges(t) {
    const e = this._oldCache || [], a = this._cache, n = (i, r) => i.filter((l) => !r.some((o) => l.plugin.id === o.plugin.id));
    this._notify(n(e, a), t, "stop"), this._notify(n(a, e), t, "start");
  }
}
function iz(s) {
  const t = {}, e = [], a = Object.keys(Pi.plugins.items);
  for (let i = 0; i < a.length; i++)
    e.push(Pi.getPlugin(a[i]));
  const n = s.plugins || [];
  for (let i = 0; i < n.length; i++) {
    const r = n[i];
    e.indexOf(r) === -1 && (e.push(r), t[r.id] = !0);
  }
  return {
    plugins: e,
    localIds: t
  };
}
function rz(s, t) {
  return !t && s === !1 ? null : s === !0 ? {} : s;
}
function lz(s, { plugins: t, localIds: e }, a, n) {
  const i = [], r = s.getContext();
  for (const l of t) {
    const o = l.id, c = rz(a[o], n);
    c !== null && i.push({
      plugin: l,
      options: oz(s.config, {
        plugin: l,
        local: e[o]
      }, c, r)
    });
  }
  return i;
}
function oz(s, { plugin: t, local: e }, a, n) {
  const i = s.pluginScopeKeys(t), r = s.getOptionScopes(a, i);
  return e && t.defaults && r.push(t.defaults), s.createResolver(r, n, [
    ""
  ], {
    scriptable: !1,
    indexable: !1,
    allKeys: !0
  });
}
function fx(s, t) {
  const e = en.datasets[s] || {};
  return ((t.datasets || {})[s] || {}).indexAxis || t.indexAxis || e.indexAxis || "x";
}
function cz(s, t) {
  let e = s;
  return s === "_index_" ? e = t : s === "_value_" && (e = t === "x" ? "y" : "x"), e;
}
function dz(s, t) {
  return s === t ? "_index_" : "_value_";
}
function mD(s) {
  if (s === "x" || s === "y" || s === "r")
    return s;
}
function uz(s) {
  if (s === "top" || s === "bottom")
    return "x";
  if (s === "left" || s === "right")
    return "y";
}
function bx(s, ...t) {
  if (mD(s))
    return s;
  for (const e of t) {
    const a = e.axis || uz(e.position) || s.length > 1 && mD(s[0].toLowerCase());
    if (a)
      return a;
  }
  throw new Error(`Cannot determine type of '${s}' axis. Please provide 'axis' or 'position' option.`);
}
function gD(s, t, e) {
  if (e[t + "AxisID"] === s)
    return {
      axis: t
    };
}
function pz(s, t) {
  if (t.data && t.data.datasets) {
    const e = t.data.datasets.filter((a) => a.xAxisID === s || a.yAxisID === s);
    if (e.length)
      return gD(s, "x", e[0]) || gD(s, "y", e[0]);
  }
  return {};
}
function hz(s, t) {
  const e = Wl[s.type] || {
    scales: {}
  }, a = t.scales || {}, n = fx(s.type, t), i = /* @__PURE__ */ Object.create(null);
  return Object.keys(a).forEach((r) => {
    const l = a[r];
    if (!Ve(l))
      return console.error(`Invalid scale configuration for scale: ${r}`);
    if (l._proxy)
      return console.warn(`Ignoring resolver passed as options for scale: ${r}`);
    const o = bx(r, l, pz(r, s), en.scales[l.type]), c = dz(o, n), d = e.scales || {};
    i[r] = zd(/* @__PURE__ */ Object.create(null), [
      {
        axis: o
      },
      l,
      d[o],
      d[c]
    ]);
  }), s.data.datasets.forEach((r) => {
    const l = r.type || s.type, o = r.indexAxis || fx(l, t), d = (Wl[l] || {}).scales || {};
    Object.keys(d).forEach((p) => {
      const h = cz(p, o), g = r[h + "AxisID"] || h;
      i[g] = i[g] || /* @__PURE__ */ Object.create(null), zd(i[g], [
        {
          axis: h
        },
        a[g],
        d[p]
      ]);
    });
  }), Object.keys(i).forEach((r) => {
    const l = i[r];
    zd(l, [
      en.scales[l.type],
      en.scale
    ]);
  }), i;
}
function dE(s) {
  const t = s.options || (s.options = {});
  t.plugins = Fe(t.plugins, {}), t.scales = hz(s, t);
}
function uE(s) {
  return s = s || {}, s.datasets = s.datasets || [], s.labels = s.labels || [], s;
}
function mz(s) {
  return s = s || {}, s.data = uE(s.data), dE(s), s;
}
const yD = /* @__PURE__ */ new Map(), pE = /* @__PURE__ */ new Set();
function bh(s, t) {
  let e = yD.get(s);
  return e || (e = t(), yD.set(s, e), pE.add(e)), e;
}
const Ad = (s, t, e) => {
  const a = el(t, e);
  a !== void 0 && s.add(a);
};
let gz = class {
  constructor(t) {
    this._config = mz(t), this._scopeCache = /* @__PURE__ */ new Map(), this._resolverCache = /* @__PURE__ */ new Map();
  }
  get platform() {
    return this._config.platform;
  }
  get type() {
    return this._config.type;
  }
  set type(t) {
    this._config.type = t;
  }
  get data() {
    return this._config.data;
  }
  set data(t) {
    this._config.data = uE(t);
  }
  get options() {
    return this._config.options;
  }
  set options(t) {
    this._config.options = t;
  }
  get plugins() {
    return this._config.plugins;
  }
  update() {
    const t = this._config;
    this.clearCache(), dE(t);
  }
  clearCache() {
    this._scopeCache.clear(), this._resolverCache.clear();
  }
  datasetScopeKeys(t) {
    return bh(t, () => [
      [
        `datasets.${t}`,
        ""
      ]
    ]);
  }
  datasetAnimationScopeKeys(t, e) {
    return bh(`${t}.transition.${e}`, () => [
      [
        `datasets.${t}.transitions.${e}`,
        `transitions.${e}`
      ],
      [
        `datasets.${t}`,
        ""
      ]
    ]);
  }
  datasetElementScopeKeys(t, e) {
    return bh(`${t}-${e}`, () => [
      [
        `datasets.${t}.elements.${e}`,
        `datasets.${t}`,
        `elements.${e}`,
        ""
      ]
    ]);
  }
  pluginScopeKeys(t) {
    const e = t.id, a = this.type;
    return bh(`${a}-plugin-${e}`, () => [
      [
        `plugins.${e}`,
        ...t.additionalOptionScopes || []
      ]
    ]);
  }
  _cachedScopes(t, e) {
    const a = this._scopeCache;
    let n = a.get(t);
    return (!n || e) && (n = /* @__PURE__ */ new Map(), a.set(t, n)), n;
  }
  getOptionScopes(t, e, a) {
    const { options: n, type: i } = this, r = this._cachedScopes(t, a), l = r.get(e);
    if (l)
      return l;
    const o = /* @__PURE__ */ new Set();
    e.forEach((d) => {
      t && (o.add(t), d.forEach((p) => Ad(o, t, p))), d.forEach((p) => Ad(o, n, p)), d.forEach((p) => Ad(o, Wl[i] || {}, p)), d.forEach((p) => Ad(o, en, p)), d.forEach((p) => Ad(o, mx, p));
    });
    const c = Array.from(o);
    return c.length === 0 && c.push(/* @__PURE__ */ Object.create(null)), pE.has(e) && r.set(e, c), c;
  }
  chartOptionScopes() {
    const { options: t, type: e } = this;
    return [
      t,
      Wl[e] || {},
      en.datasets[e] || {},
      {
        type: e
      },
      en,
      mx
    ];
  }
  resolveNamedOptions(t, e, a, n = [
    ""
  ]) {
    const i = {
      $shared: !0
    }, { resolver: r, subPrefixes: l } = fD(this._resolverCache, t, n);
    let o = r;
    if (fz(r, e)) {
      i.$shared = !1, a = As(a) ? a() : a;
      const c = this.createResolver(t, a, l);
      o = wc(r, a, c);
    }
    for (const c of e)
      i[c] = o[c];
    return i;
  }
  createResolver(t, e, a = [
    ""
  ], n) {
    const { resolver: i } = fD(this._resolverCache, t, a);
    return Ve(e) ? wc(i, e, void 0, n) : i;
  }
};
function fD(s, t, e) {
  let a = s.get(t);
  a || (a = /* @__PURE__ */ new Map(), s.set(t, a));
  const n = e.join();
  let i = a.get(n);
  return i || (i = {
    resolver: Ww(t, e),
    subPrefixes: e.filter((l) => !l.toLowerCase().includes("hover"))
  }, a.set(n, i)), i;
}
const yz = (s) => Ve(s) && Object.getOwnPropertyNames(s).some((t) => As(s[t]));
function fz(s, t) {
  const { isScriptable: e, isIndexable: a } = BP(s);
  for (const n of t) {
    const i = e(n), r = a(n), l = (r || i) && s[n];
    if (i && (As(l) || yz(l)) || r && ya(l))
      return !0;
  }
  return !1;
}
var bz = "4.4.2";
const vz = [
  "top",
  "bottom",
  "left",
  "right",
  "chartArea"
];
function bD(s, t) {
  return s === "top" || s === "bottom" || vz.indexOf(s) === -1 && t === "x";
}
function vD(s, t) {
  return function(e, a) {
    return e[s] === a[s] ? e[t] - a[t] : e[s] - a[s];
  };
}
function xD(s) {
  const t = s.chart, e = t.options.animation;
  t.notifyPlugins("afterRender"), Sa(e && e.onComplete, [
    s
  ], t);
}
function xz(s) {
  const t = s.chart, e = t.options.animation;
  Sa(e && e.onProgress, [
    s
  ], t);
}
function hE(s) {
  return qw() && typeof s == "string" ? s = document.getElementById(s) : s && s.length && (s = s[0]), s && s.canvas && (s = s.canvas), s;
}
const Kh = {}, wD = (s) => {
  const t = hE(s);
  return Object.values(Kh).filter((e) => e.canvas === t).pop();
};
function wz(s, t, e) {
  const a = Object.keys(s);
  for (const n of a) {
    const i = +n;
    if (i >= t) {
      const r = s[n];
      delete s[n], (e > 0 || i > t) && (s[i + e] = r);
    }
  }
}
function Az(s, t, e, a) {
  return !e || s.type === "mouseout" ? null : a ? t : s;
}
function vh(s, t, e) {
  return s.options.clip ? s[e] : t[e];
}
function Cz(s, t) {
  const { xScale: e, yScale: a } = s;
  return e && a ? {
    left: vh(e, t, "left"),
    right: vh(e, t, "right"),
    top: vh(a, t, "top"),
    bottom: vh(a, t, "bottom")
  } : t;
}
var Er;
let Jr = (Er = class {
  static register(...t) {
    Pi.add(...t), AD();
  }
  static unregister(...t) {
    Pi.remove(...t), AD();
  }
  constructor(t, e) {
    const a = this.config = new gz(e), n = hE(t), i = wD(n);
    if (i)
      throw new Error("Canvas is already in use. Chart with ID '" + i.id + "' must be destroyed before the canvas with ID '" + i.canvas.id + "' can be reused.");
    const r = a.createResolver(a.chartOptionScopes(), this.getContext());
    this.platform = new (a.platform || GF(n))(), this.platform.updateConfig(a);
    const l = this.platform.acquireContext(n, r.aspectRatio), o = l && l.canvas, c = o && o.height, d = o && o.width;
    if (this.id = T2(), this.ctx = l, this.canvas = o, this.width = d, this.height = c, this._options = r, this._aspectRatio = this.aspectRatio, this._layers = [], this._metasets = [], this._stacks = void 0, this.boxes = [], this.currentDevicePixelRatio = void 0, this.chartArea = void 0, this._active = [], this._lastEvent = void 0, this._listeners = {}, this._responsiveListeners = void 0, this._sortedMetasets = [], this.scales = {}, this._plugins = new sz(), this.$proxies = {}, this._hiddenIndices = {}, this.attached = !1, this._animationsDisabled = void 0, this.$context = void 0, this._doResize = U2((p) => this.update(p), r.resizeDelay || 0), this._dataChanges = [], Kh[this.id] = this, !l || !o) {
      console.error("Failed to create chart: can't acquire context from the given item");
      return;
    }
    rr.listen(this, "complete", xD), rr.listen(this, "progress", xz), this._initialize(), this.attached && this.update();
  }
  get aspectRatio() {
    const { options: { aspectRatio: t, maintainAspectRatio: e }, width: a, height: n, _aspectRatio: i } = this;
    return ua(t) ? e && i ? i : n ? a / n : null : t;
  }
  get data() {
    return this.config.data;
  }
  set data(t) {
    this.config.data = t;
  }
  get options() {
    return this._options;
  }
  set options(t) {
    this.config.options = t;
  }
  get registry() {
    return Pi;
  }
  _initialize() {
    return this.notifyPlugins("beforeInit"), this.options.responsive ? this.resize() : F1(this, this.options.devicePixelRatio), this.bindEvents(), this.notifyPlugins("afterInit"), this;
  }
  clear() {
    return G1(this.canvas, this.ctx), this;
  }
  stop() {
    return rr.stop(this), this;
  }
  resize(t, e) {
    rr.running(this) ? this._resizeBeforeDraw = {
      width: t,
      height: e
    } : this._resize(t, e);
  }
  _resize(t, e) {
    const a = this.options, n = this.canvas, i = a.maintainAspectRatio && this.aspectRatio, r = this.platform.getMaximumSize(n, t, e, i), l = a.devicePixelRatio || this.platform.getDevicePixelRatio(), o = this.width ? "resize" : "attach";
    this.width = r.width, this.height = r.height, this._aspectRatio = this.aspectRatio, F1(this, l, !0) && (this.notifyPlugins("resize", {
      size: r
    }), Sa(a.onResize, [
      this,
      r
    ], this), this.attached && this._doResize(o) && this.render());
  }
  ensureScalesHaveIDs() {
    const e = this.options.scales || {};
    ka(e, (a, n) => {
      a.id = n;
    });
  }
  buildOrUpdateScales() {
    const t = this.options, e = t.scales, a = this.scales, n = Object.keys(a).reduce((r, l) => (r[l] = !1, r), {});
    let i = [];
    e && (i = i.concat(Object.keys(e).map((r) => {
      const l = e[r], o = bx(r, l), c = o === "r", d = o === "x";
      return {
        options: l,
        dposition: c ? "chartArea" : d ? "bottom" : "left",
        dtype: c ? "radialLinear" : d ? "category" : "linear"
      };
    }))), ka(i, (r) => {
      const l = r.options, o = l.id, c = bx(o, l), d = Fe(l.type, r.dtype);
      (l.position === void 0 || bD(l.position, c) !== bD(r.dposition)) && (l.position = r.dposition), n[o] = !0;
      let p = null;
      if (o in a && a[o].type === d)
        p = a[o];
      else {
        const h = Pi.getScale(d);
        p = new h({
          id: o,
          type: d,
          ctx: this.ctx,
          chart: this
        }), a[p.id] = p;
      }
      p.init(l, t);
    }), ka(n, (r, l) => {
      r || delete a[l];
    }), ka(a, (r) => {
      qn.configure(this, r, r.options), qn.addBox(this, r);
    });
  }
  _updateMetasets() {
    const t = this._metasets, e = this.data.datasets.length, a = t.length;
    if (t.sort((n, i) => n.index - i.index), a > e) {
      for (let n = e; n < a; ++n)
        this._destroyDatasetMeta(n);
      t.splice(e, a - e);
    }
    this._sortedMetasets = t.slice(0).sort(vD("order", "index"));
  }
  _removeUnreferencedMetasets() {
    const { _metasets: t, data: { datasets: e } } = this;
    t.length > e.length && delete this._stacks, t.forEach((a, n) => {
      e.filter((i) => i === a._dataset).length === 0 && this._destroyDatasetMeta(n);
    });
  }
  buildOrUpdateControllers() {
    const t = [], e = this.data.datasets;
    let a, n;
    for (this._removeUnreferencedMetasets(), a = 0, n = e.length; a < n; a++) {
      const i = e[a];
      let r = this.getDatasetMeta(a);
      const l = i.type || this.config.type;
      if (r.type && r.type !== l && (this._destroyDatasetMeta(a), r = this.getDatasetMeta(a)), r.type = l, r.indexAxis = i.indexAxis || fx(l, this.options), r.order = i.order || 0, r.index = a, r.label = "" + i.label, r.visible = this.isDatasetVisible(a), r.controller)
        r.controller.updateIndex(a), r.controller.linkScales();
      else {
        const o = Pi.getController(l), { datasetElementType: c, dataElementType: d } = en.datasets[l];
        Object.assign(o, {
          dataElementType: Pi.getElement(d),
          datasetElementType: c && Pi.getElement(c)
        }), r.controller = new o(this, a), t.push(r.controller);
      }
    }
    return this._updateMetasets(), t;
  }
  _resetElements() {
    ka(this.data.datasets, (t, e) => {
      this.getDatasetMeta(e).controller.reset();
    }, this);
  }
  reset() {
    this._resetElements(), this.notifyPlugins("reset");
  }
  update(t) {
    const e = this.config;
    e.update();
    const a = this._options = e.createResolver(e.chartOptionScopes(), this.getContext()), n = this._animationsDisabled = !a.animation;
    if (this._updateScales(), this._checkEventBindings(), this._updateHiddenIndices(), this._plugins.invalidate(), this.notifyPlugins("beforeUpdate", {
      mode: t,
      cancelable: !0
    }) === !1)
      return;
    const i = this.buildOrUpdateControllers();
    this.notifyPlugins("beforeElementsUpdate");
    let r = 0;
    for (let c = 0, d = this.data.datasets.length; c < d; c++) {
      const { controller: p } = this.getDatasetMeta(c), h = !n && i.indexOf(p) === -1;
      p.buildOrUpdateElements(h), r = Math.max(+p.getMaxOverflow(), r);
    }
    r = this._minPadding = a.layout.autoPadding ? r : 0, this._updateLayout(r), n || ka(i, (c) => {
      c.reset();
    }), this._updateDatasets(t), this.notifyPlugins("afterUpdate", {
      mode: t
    }), this._layers.sort(vD("z", "_idx"));
    const { _active: l, _lastEvent: o } = this;
    o ? this._eventHandler(o, !0) : l.length && this._updateHoverStyles(l, l, !0), this.render();
  }
  _updateScales() {
    ka(this.scales, (t) => {
      qn.removeBox(this, t);
    }), this.ensureScalesHaveIDs(), this.buildOrUpdateScales();
  }
  _checkEventBindings() {
    const t = this.options, e = new Set(Object.keys(this._listeners)), a = new Set(t.events);
    (!E1(e, a) || !!this._responsiveListeners !== t.responsive) && (this.unbindEvents(), this.bindEvents());
  }
  _updateHiddenIndices() {
    const { _hiddenIndices: t } = this, e = this._getUniformDataChanges() || [];
    for (const { method: a, start: n, count: i } of e) {
      const r = a === "_removeElements" ? -i : i;
      wz(t, n, r);
    }
  }
  _getUniformDataChanges() {
    const t = this._dataChanges;
    if (!t || !t.length)
      return;
    this._dataChanges = [];
    const e = this.data.datasets.length, a = (i) => new Set(t.filter((r) => r[0] === i).map((r, l) => l + "," + r.splice(1).join(","))), n = a(0);
    for (let i = 1; i < e; i++)
      if (!E1(n, a(i)))
        return;
    return Array.from(n).map((i) => i.split(",")).map((i) => ({
      method: i[1],
      start: +i[2],
      count: +i[3]
    }));
  }
  _updateLayout(t) {
    if (this.notifyPlugins("beforeLayout", {
      cancelable: !0
    }) === !1)
      return;
    qn.update(this, this.width, this.height, t);
    const e = this.chartArea, a = e.width <= 0 || e.height <= 0;
    this._layers = [], ka(this.boxes, (n) => {
      a && n.position === "chartArea" || (n.configure && n.configure(), this._layers.push(...n._layers()));
    }, this), this._layers.forEach((n, i) => {
      n._idx = i;
    }), this.notifyPlugins("afterLayout");
  }
  _updateDatasets(t) {
    if (this.notifyPlugins("beforeDatasetsUpdate", {
      mode: t,
      cancelable: !0
    }) !== !1) {
      for (let e = 0, a = this.data.datasets.length; e < a; ++e)
        this.getDatasetMeta(e).controller.configure();
      for (let e = 0, a = this.data.datasets.length; e < a; ++e)
        this._updateDataset(e, As(t) ? t({
          datasetIndex: e
        }) : t);
      this.notifyPlugins("afterDatasetsUpdate", {
        mode: t
      });
    }
  }
  _updateDataset(t, e) {
    const a = this.getDatasetMeta(t), n = {
      meta: a,
      index: t,
      mode: e,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetUpdate", n) !== !1 && (a.controller._update(e), n.cancelable = !1, this.notifyPlugins("afterDatasetUpdate", n));
  }
  render() {
    this.notifyPlugins("beforeRender", {
      cancelable: !0
    }) !== !1 && (rr.has(this) ? this.attached && !rr.running(this) && rr.start(this) : (this.draw(), xD({
      chart: this
    })));
  }
  draw() {
    let t;
    if (this._resizeBeforeDraw) {
      const { width: a, height: n } = this._resizeBeforeDraw;
      this._resize(a, n), this._resizeBeforeDraw = null;
    }
    if (this.clear(), this.width <= 0 || this.height <= 0 || this.notifyPlugins("beforeDraw", {
      cancelable: !0
    }) === !1)
      return;
    const e = this._layers;
    for (t = 0; t < e.length && e[t].z <= 0; ++t)
      e[t].draw(this.chartArea);
    for (this._drawDatasets(); t < e.length; ++t)
      e[t].draw(this.chartArea);
    this.notifyPlugins("afterDraw");
  }
  _getSortedDatasetMetas(t) {
    const e = this._sortedMetasets, a = [];
    let n, i;
    for (n = 0, i = e.length; n < i; ++n) {
      const r = e[n];
      (!t || r.visible) && a.push(r);
    }
    return a;
  }
  getSortedVisibleDatasetMetas() {
    return this._getSortedDatasetMetas(!0);
  }
  _drawDatasets() {
    if (this.notifyPlugins("beforeDatasetsDraw", {
      cancelable: !0
    }) === !1)
      return;
    const t = this.getSortedVisibleDatasetMetas();
    for (let e = t.length - 1; e >= 0; --e)
      this._drawDataset(t[e]);
    this.notifyPlugins("afterDatasetsDraw");
  }
  _drawDataset(t) {
    const e = this.ctx, a = t._clip, n = !a.disabled, i = Cz(t, this.chartArea), r = {
      meta: t,
      index: t.index,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetDraw", r) !== !1 && (n && Wu(e, {
      left: a.left === !1 ? 0 : i.left - a.left,
      right: a.right === !1 ? this.width : i.right + a.right,
      top: a.top === !1 ? 0 : i.top - a.top,
      bottom: a.bottom === !1 ? this.height : i.bottom + a.bottom
    }), t.controller.draw(), n && ju(e), r.cancelable = !1, this.notifyPlugins("afterDatasetDraw", r));
  }
  isPointInArea(t) {
    return mr(t, this.chartArea, this._minPadding);
  }
  getElementsAtEventForMode(t, e, a, n) {
    const i = vF.modes[e];
    return typeof i == "function" ? i(this, t, a, n) : [];
  }
  getDatasetMeta(t) {
    const e = this.data.datasets[t], a = this._metasets;
    let n = a.filter((i) => i && i._dataset === e).pop();
    return n || (n = {
      type: null,
      data: [],
      dataset: null,
      controller: null,
      hidden: null,
      xAxisID: null,
      yAxisID: null,
      order: e && e.order || 0,
      index: t,
      _dataset: e,
      _parsed: [],
      _sorted: !1
    }, a.push(n)), n;
  }
  getContext() {
    return this.$context || (this.$context = cl(null, {
      chart: this,
      type: "chart"
    }));
  }
  getVisibleDatasetCount() {
    return this.getSortedVisibleDatasetMetas().length;
  }
  isDatasetVisible(t) {
    const e = this.data.datasets[t];
    if (!e)
      return !1;
    const a = this.getDatasetMeta(t);
    return typeof a.hidden == "boolean" ? !a.hidden : !e.hidden;
  }
  setDatasetVisibility(t, e) {
    const a = this.getDatasetMeta(t);
    a.hidden = !e;
  }
  toggleDataVisibility(t) {
    this._hiddenIndices[t] = !this._hiddenIndices[t];
  }
  getDataVisibility(t) {
    return !this._hiddenIndices[t];
  }
  _updateVisibility(t, e, a) {
    const n = a ? "show" : "hide", i = this.getDatasetMeta(t), r = i.controller._resolveAnimations(void 0, n);
    Cs(e) ? (i.data[e].hidden = !a, this.update()) : (this.setDatasetVisibility(t, a), r.update(i, {
      visible: a
    }), this.update((l) => l.datasetIndex === t ? n : void 0));
  }
  hide(t, e) {
    this._updateVisibility(t, e, !1);
  }
  show(t, e) {
    this._updateVisibility(t, e, !0);
  }
  _destroyDatasetMeta(t) {
    const e = this._metasets[t];
    e && e.controller && e.controller._destroy(), delete this._metasets[t];
  }
  _stop() {
    let t, e;
    for (this.stop(), rr.remove(this), t = 0, e = this.data.datasets.length; t < e; ++t)
      this._destroyDatasetMeta(t);
  }
  destroy() {
    this.notifyPlugins("beforeDestroy");
    const { canvas: t, ctx: e } = this;
    this._stop(), this.config.clearCache(), t && (this.unbindEvents(), G1(t, e), this.platform.releaseContext(e), this.canvas = null, this.ctx = null), delete Kh[this.id], this.notifyPlugins("afterDestroy");
  }
  toBase64Image(...t) {
    return this.canvas.toDataURL(...t);
  }
  bindEvents() {
    this.bindUserEvents(), this.options.responsive ? this.bindResponsiveEvents() : this.attached = !0;
  }
  bindUserEvents() {
    const t = this._listeners, e = this.platform, a = (i, r) => {
      e.addEventListener(this, i, r), t[i] = r;
    }, n = (i, r, l) => {
      i.offsetX = r, i.offsetY = l, this._eventHandler(i);
    };
    ka(this.options.events, (i) => a(i, n));
  }
  bindResponsiveEvents() {
    this._responsiveListeners || (this._responsiveListeners = {});
    const t = this._responsiveListeners, e = this.platform, a = (o, c) => {
      e.addEventListener(this, o, c), t[o] = c;
    }, n = (o, c) => {
      t[o] && (e.removeEventListener(this, o, c), delete t[o]);
    }, i = (o, c) => {
      this.canvas && this.resize(o, c);
    };
    let r;
    const l = () => {
      n("attach", l), this.attached = !0, this.resize(), a("resize", i), a("detach", r);
    };
    r = () => {
      this.attached = !1, n("resize", i), this._stop(), this._resize(0, 0), a("attach", l);
    }, e.isAttached(this.canvas) ? l() : r();
  }
  unbindEvents() {
    ka(this._listeners, (t, e) => {
      this.platform.removeEventListener(this, e, t);
    }), this._listeners = {}, ka(this._responsiveListeners, (t, e) => {
      this.platform.removeEventListener(this, e, t);
    }), this._responsiveListeners = void 0;
  }
  updateHoverStyle(t, e, a) {
    const n = a ? "set" : "remove";
    let i, r, l, o;
    for (e === "dataset" && (i = this.getDatasetMeta(t[0].datasetIndex), i.controller["_" + n + "DatasetHoverStyle"]()), l = 0, o = t.length; l < o; ++l) {
      r = t[l];
      const c = r && this.getDatasetMeta(r.datasetIndex).controller;
      c && c[n + "HoverStyle"](r.element, r.datasetIndex, r.index);
    }
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(t) {
    const e = this._active || [], a = t.map(({ datasetIndex: i, index: r }) => {
      const l = this.getDatasetMeta(i);
      if (!l)
        throw new Error("No dataset found at index " + i);
      return {
        datasetIndex: i,
        element: l.data[r],
        index: r
      };
    });
    !gm(a, e) && (this._active = a, this._lastEvent = null, this._updateHoverStyles(a, e));
  }
  notifyPlugins(t, e, a) {
    return this._plugins.notify(this, t, e, a);
  }
  isPluginEnabled(t) {
    return this._plugins._cache.filter((e) => e.plugin.id === t).length === 1;
  }
  _updateHoverStyles(t, e, a) {
    const n = this.options.hover, i = (o, c) => o.filter((d) => !c.some((p) => d.datasetIndex === p.datasetIndex && d.index === p.index)), r = i(e, t), l = a ? t : i(t, e);
    r.length && this.updateHoverStyle(r, n.mode, !1), l.length && n.mode && this.updateHoverStyle(l, n.mode, !0);
  }
  _eventHandler(t, e) {
    const a = {
      event: t,
      replay: e,
      cancelable: !0,
      inChartArea: this.isPointInArea(t)
    }, n = (r) => (r.options.events || this.options.events).includes(t.native.type);
    if (this.notifyPlugins("beforeEvent", a, n) === !1)
      return;
    const i = this._handleEvent(t, e, a.inChartArea);
    return a.cancelable = !1, this.notifyPlugins("afterEvent", a, n), (i || a.changed) && this.render(), this;
  }
  _handleEvent(t, e, a) {
    const { _active: n = [], options: i } = this, r = e, l = this._getActiveElements(t, n, a, r), o = N2(t), c = Az(t, this._lastEvent, a, o);
    a && (this._lastEvent = null, Sa(i.onHover, [
      t,
      l,
      this
    ], this), o && Sa(i.onClick, [
      t,
      l,
      this
    ], this));
    const d = !gm(l, n);
    return (d || e) && (this._active = l, this._updateHoverStyles(l, n, e)), this._lastEvent = c, d;
  }
  _getActiveElements(t, e, a, n) {
    if (t.type === "mouseout")
      return [];
    if (!a)
      return e;
    const i = this.options.hover;
    return this.getElementsAtEventForMode(t, i.mode, i, n);
  }
}, Jt(Er, "defaults", en), Jt(Er, "instances", Kh), Jt(Er, "overrides", Wl), Jt(Er, "registry", Pi), Jt(Er, "version", bz), Jt(Er, "getChart", wD), Er);
function AD() {
  return ka(Jr.instances, (s) => s._plugins.invalidate());
}
function $z(s, t, e) {
  const { startAngle: a, pixelMargin: n, x: i, y: r, outerRadius: l, innerRadius: o } = t;
  let c = n / l;
  s.beginPath(), s.arc(i, r, l, a - c, e + c), o > n ? (c = n / o, s.arc(i, r, o, e + c, a - c, !0)) : s.arc(i, r, n, e + Fa, a - Fa), s.closePath(), s.clip();
}
function Sz(s) {
  return Bw(s, [
    "outerStart",
    "outerEnd",
    "innerStart",
    "innerEnd"
  ]);
}
function kz(s, t, e, a) {
  const n = Sz(s.options.borderRadius), i = (e - t) / 2, r = Math.min(i, a * t / 2), l = (o) => {
    const c = (e - Math.min(i, o)) * a / 2;
    return Yn(o, 0, Math.min(i, c));
  };
  return {
    outerStart: l(n.outerStart),
    outerEnd: l(n.outerEnd),
    innerStart: Yn(n.innerStart, 0, r),
    innerEnd: Yn(n.innerEnd, 0, r)
  };
}
function Mo(s, t, e, a) {
  return {
    x: e + s * Math.cos(t),
    y: a + s * Math.sin(t)
  };
}
function Am(s, t, e, a, n, i) {
  const { x: r, y: l, startAngle: o, pixelMargin: c, innerRadius: d } = t, p = Math.max(t.outerRadius + a + e - c, 0), h = d > 0 ? d + a + e + c : 0;
  let g = 0;
  const x = n - o;
  if (a) {
    const U = d > 0 ? d - a : 0, M = p > 0 ? p - a : 0, W = (U + M) / 2, J = W !== 0 ? x * W / (W + a) : x;
    g = (x - J) / 2;
  }
  const b = Math.max(1e-3, x * p - e / ra) / p, A = (x - b) / 2, T = o + A + g, R = n - A - g, { outerStart: C, outerEnd: v, innerStart: P, innerEnd: O } = kz(t, h, p, R - T), N = p - C, H = p - v, F = T + C / N, B = R - v / H, Q = h + P, it = h + O, et = T + P / Q, rt = R - O / it;
  if (s.beginPath(), i) {
    const U = (F + B) / 2;
    if (s.arc(r, l, p, F, U), s.arc(r, l, p, U, B), v > 0) {
      const vt = Mo(H, B, r, l);
      s.arc(vt.x, vt.y, v, B, R + Fa);
    }
    const M = Mo(it, R, r, l);
    if (s.lineTo(M.x, M.y), O > 0) {
      const vt = Mo(it, rt, r, l);
      s.arc(vt.x, vt.y, O, R + Fa, rt + Math.PI);
    }
    const W = (R - O / h + (T + P / h)) / 2;
    if (s.arc(r, l, h, R - O / h, W, !0), s.arc(r, l, h, W, T + P / h, !0), P > 0) {
      const vt = Mo(Q, et, r, l);
      s.arc(vt.x, vt.y, P, et + Math.PI, T - Fa);
    }
    const J = Mo(N, T, r, l);
    if (s.lineTo(J.x, J.y), C > 0) {
      const vt = Mo(N, F, r, l);
      s.arc(vt.x, vt.y, C, T - Fa, F);
    }
  } else {
    s.moveTo(r, l);
    const U = Math.cos(F) * p + r, M = Math.sin(F) * p + l;
    s.lineTo(U, M);
    const W = Math.cos(B) * p + r, J = Math.sin(B) * p + l;
    s.lineTo(W, J);
  }
  s.closePath();
}
function Tz(s, t, e, a, n) {
  const { fullCircles: i, startAngle: r, circumference: l } = t;
  let o = t.endAngle;
  if (i) {
    Am(s, t, e, a, o, n);
    for (let c = 0; c < i; ++c)
      s.fill();
    isNaN(l) || (o = r + (l % Ga || Ga));
  }
  return Am(s, t, e, a, o, n), s.fill(), o;
}
function Lz(s, t, e, a, n) {
  const { fullCircles: i, startAngle: r, circumference: l, options: o } = t, { borderWidth: c, borderJoinStyle: d, borderDash: p, borderDashOffset: h } = o, g = o.borderAlign === "inner";
  if (!c)
    return;
  s.setLineDash(p || []), s.lineDashOffset = h, g ? (s.lineWidth = c * 2, s.lineJoin = d || "round") : (s.lineWidth = c, s.lineJoin = d || "bevel");
  let x = t.endAngle;
  if (i) {
    Am(s, t, e, a, x, n);
    for (let b = 0; b < i; ++b)
      s.stroke();
    isNaN(l) || (x = r + (l % Ga || Ga));
  }
  g && $z(s, t, x), i || (Am(s, t, e, a, x, n), s.stroke());
}
class Nd extends cs {
  constructor(e) {
    super();
    Jt(this, "circumference");
    Jt(this, "endAngle");
    Jt(this, "fullCircles");
    Jt(this, "innerRadius");
    Jt(this, "outerRadius");
    Jt(this, "pixelMargin");
    Jt(this, "startAngle");
    this.options = void 0, this.circumference = void 0, this.startAngle = void 0, this.endAngle = void 0, this.innerRadius = void 0, this.outerRadius = void 0, this.pixelMargin = 0, this.fullCircles = 0, e && Object.assign(this, e);
  }
  inRange(e, a, n) {
    const i = this.getProps([
      "x",
      "y"
    ], n), { angle: r, distance: l } = YP(i, {
      x: e,
      y: a
    }), { startAngle: o, endAngle: c, innerRadius: d, outerRadius: p, circumference: h } = this.getProps([
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius",
      "circumference"
    ], n), g = (this.options.spacing + this.options.borderWidth) / 2, b = Fe(h, c - o) >= Ga || du(r, o, c), A = pr(l, d + g, p + g);
    return b && A;
  }
  getCenterPoint(e) {
    const { x: a, y: n, startAngle: i, endAngle: r, innerRadius: l, outerRadius: o } = this.getProps([
      "x",
      "y",
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius"
    ], e), { offset: c, spacing: d } = this.options, p = (i + r) / 2, h = (l + o + d + c) / 2;
    return {
      x: a + Math.cos(p) * h,
      y: n + Math.sin(p) * h
    };
  }
  tooltipPosition(e) {
    return this.getCenterPoint(e);
  }
  draw(e) {
    const { options: a, circumference: n } = this, i = (a.offset || 0) / 4, r = (a.spacing || 0) / 2, l = a.circular;
    if (this.pixelMargin = a.borderAlign === "inner" ? 0.33 : 0, this.fullCircles = n > Ga ? Math.floor(n / Ga) : 0, n === 0 || this.innerRadius < 0 || this.outerRadius < 0)
      return;
    e.save();
    const o = (this.startAngle + this.endAngle) / 2;
    e.translate(Math.cos(o) * i, Math.sin(o) * i);
    const c = 1 - Math.sin(Math.min(ra, n || 0)), d = i * c;
    e.fillStyle = a.backgroundColor, e.strokeStyle = a.borderColor, Tz(e, this, d, r, l), Lz(e, this, d, r, l), e.restore();
  }
}
Jt(Nd, "id", "arc"), Jt(Nd, "defaults", {
  borderAlign: "center",
  borderColor: "#fff",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: void 0,
  borderRadius: 0,
  borderWidth: 2,
  offset: 0,
  spacing: 0,
  angle: void 0,
  circular: !0
}), Jt(Nd, "defaultRoutes", {
  backgroundColor: "backgroundColor"
}), Jt(Nd, "descriptors", {
  _scriptable: !0,
  _indexable: (e) => e !== "borderDash"
});
function mE(s, t, e = t) {
  s.lineCap = Fe(e.borderCapStyle, t.borderCapStyle), s.setLineDash(Fe(e.borderDash, t.borderDash)), s.lineDashOffset = Fe(e.borderDashOffset, t.borderDashOffset), s.lineJoin = Fe(e.borderJoinStyle, t.borderJoinStyle), s.lineWidth = Fe(e.borderWidth, t.borderWidth), s.strokeStyle = Fe(e.borderColor, t.borderColor);
}
function Dz(s, t, e) {
  s.lineTo(e.x, e.y);
}
function Iz(s) {
  return s.stepped ? tU : s.tension || s.cubicInterpolationMode === "monotone" ? eU : Dz;
}
function gE(s, t, e = {}) {
  const a = s.length, { start: n = 0, end: i = a - 1 } = e, { start: r, end: l } = t, o = Math.max(n, r), c = Math.min(i, l), d = n < r && i < r || n > l && i > l;
  return {
    count: a,
    start: o,
    loop: t.loop,
    ilen: c < o && !d ? a + c - o : c - o
  };
}
function Pz(s, t, e, a) {
  const { points: n, options: i } = t, { count: r, start: l, loop: o, ilen: c } = gE(n, e, a), d = Iz(i);
  let { move: p = !0, reverse: h } = a || {}, g, x, b;
  for (g = 0; g <= c; ++g)
    x = n[(l + (h ? c - g : g)) % r], !x.skip && (p ? (s.moveTo(x.x, x.y), p = !1) : d(s, b, x, h, i.stepped), b = x);
  return o && (x = n[(l + (h ? c : 0)) % r], d(s, b, x, h, i.stepped)), !!o;
}
function Ez(s, t, e, a) {
  const n = t.points, { count: i, start: r, ilen: l } = gE(n, e, a), { move: o = !0, reverse: c } = a || {};
  let d = 0, p = 0, h, g, x, b, A, T;
  const R = (v) => (r + (c ? l - v : v)) % i, C = () => {
    b !== A && (s.lineTo(d, A), s.lineTo(d, b), s.lineTo(d, T));
  };
  for (o && (g = n[R(0)], s.moveTo(g.x, g.y)), h = 0; h <= l; ++h) {
    if (g = n[R(h)], g.skip)
      continue;
    const v = g.x, P = g.y, O = v | 0;
    O === x ? (P < b ? b = P : P > A && (A = P), d = (p * d + v) / ++p) : (C(), s.lineTo(v, P), x = O, p = 0, b = A = P), T = P;
  }
  C();
}
function vx(s) {
  const t = s.options, e = t.borderDash && t.borderDash.length;
  return !s._decimated && !s._loop && !t.tension && t.cubicInterpolationMode !== "monotone" && !t.stepped && !e ? Ez : Pz;
}
function Nz(s) {
  return s.stepped ? NU : s.tension || s.cubicInterpolationMode === "monotone" ? RU : Dl;
}
function Rz(s, t, e, a) {
  let n = t._path;
  n || (n = t._path = new Path2D(), t.path(n, e, a) && n.closePath()), mE(s, t.options), s.stroke(n);
}
function Yz(s, t, e, a) {
  const { segments: n, options: i } = t, r = vx(t);
  for (const l of n)
    mE(s, i, l.style), s.beginPath(), r(s, t, l, {
      start: e,
      end: e + a - 1
    }) && s.closePath(), s.stroke();
}
const _z = typeof Path2D == "function";
function Oz(s, t, e, a) {
  _z && !t.options.segment ? Rz(s, t, e, a) : Yz(s, t, e, a);
}
class Ur extends cs {
  constructor(t) {
    super(), this.animated = !0, this.options = void 0, this._chart = void 0, this._loop = void 0, this._fullLoop = void 0, this._path = void 0, this._points = void 0, this._segments = void 0, this._decimated = !1, this._pointsUpdated = !1, this._datasetIndex = void 0, t && Object.assign(this, t);
  }
  updateControlPoints(t, e) {
    const a = this.options;
    if ((a.tension || a.cubicInterpolationMode === "monotone") && !a.stepped && !this._pointsUpdated) {
      const n = a.spanGaps ? this._loop : this._fullLoop;
      SU(this._points, a, t, n, e), this._pointsUpdated = !0;
    }
  }
  set points(t) {
    this._points = t, delete this._segments, delete this._path, this._pointsUpdated = !1;
  }
  get points() {
    return this._points;
  }
  get segments() {
    return this._segments || (this._segments = GU(this, this.options.segment));
  }
  first() {
    const t = this.segments, e = this.points;
    return t.length && e[t[0].start];
  }
  last() {
    const t = this.segments, e = this.points, a = t.length;
    return a && e[t[a - 1].end];
  }
  interpolate(t, e) {
    const a = this.options, n = t[e], i = this.points, r = eE(this, {
      property: e,
      start: n,
      end: n
    });
    if (!r.length)
      return;
    const l = [], o = Nz(a);
    let c, d;
    for (c = 0, d = r.length; c < d; ++c) {
      const { start: p, end: h } = r[c], g = i[p], x = i[h];
      if (g === x) {
        l.push(g);
        continue;
      }
      const b = Math.abs((n - g[e]) / (x[e] - g[e])), A = o(g, x, b, a.stepped);
      A[e] = t[e], l.push(A);
    }
    return l.length === 1 ? l[0] : l;
  }
  pathSegment(t, e, a) {
    return vx(this)(t, this, e, a);
  }
  path(t, e, a) {
    const n = this.segments, i = vx(this);
    let r = this._loop;
    e = e || 0, a = a || this.points.length - e;
    for (const l of n)
      r &= i(t, this, l, {
        start: e,
        end: e + a - 1
      });
    return !!r;
  }
  draw(t, e, a, n) {
    const i = this.options || {};
    (this.points || []).length && i.borderWidth && (t.save(), Oz(t, this, a, n), t.restore()), this.animated && (this._pointsUpdated = !1, this._path = void 0);
  }
}
Jt(Ur, "id", "line"), Jt(Ur, "defaults", {
  borderCapStyle: "butt",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: "miter",
  borderWidth: 3,
  capBezierPoints: !0,
  cubicInterpolationMode: "default",
  fill: !1,
  spanGaps: !1,
  stepped: !1,
  tension: 0
}), Jt(Ur, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
}), Jt(Ur, "descriptors", {
  _scriptable: !0,
  _indexable: (t) => t !== "borderDash" && t !== "fill"
});
function CD(s, t, e, a) {
  const n = s.options, { [e]: i } = s.getProps([
    e
  ], a);
  return Math.abs(t - i) < n.radius + n.hitRadius;
}
class Jh extends cs {
  constructor(e) {
    super();
    Jt(this, "parsed");
    Jt(this, "skip");
    Jt(this, "stop");
    this.options = void 0, this.parsed = void 0, this.skip = void 0, this.stop = void 0, e && Object.assign(this, e);
  }
  inRange(e, a, n) {
    const i = this.options, { x: r, y: l } = this.getProps([
      "x",
      "y"
    ], n);
    return Math.pow(e - r, 2) + Math.pow(a - l, 2) < Math.pow(i.hitRadius + i.radius, 2);
  }
  inXRange(e, a) {
    return CD(this, e, "x", a);
  }
  inYRange(e, a) {
    return CD(this, e, "y", a);
  }
  getCenterPoint(e) {
    const { x: a, y: n } = this.getProps([
      "x",
      "y"
    ], e);
    return {
      x: a,
      y: n
    };
  }
  size(e) {
    e = e || this.options || {};
    let a = e.radius || 0;
    a = Math.max(a, a && e.hoverRadius || 0);
    const n = a && e.borderWidth || 0;
    return (a + n) * 2;
  }
  draw(e, a) {
    const n = this.options;
    this.skip || n.radius < 0.1 || !mr(this, a, this.size(n) / 2) || (e.strokeStyle = n.borderColor, e.lineWidth = n.borderWidth, e.fillStyle = n.backgroundColor, gx(e, n, this.x, this.y));
  }
  getRange() {
    const e = this.options || {};
    return e.radius + e.hitRadius;
  }
}
Jt(Jh, "id", "point"), /**
* @type {any}
*/
Jt(Jh, "defaults", {
  borderWidth: 1,
  hitRadius: 1,
  hoverBorderWidth: 1,
  hoverRadius: 4,
  pointStyle: "circle",
  radius: 3,
  rotation: 0
}), /**
* @type {any}
*/
Jt(Jh, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
});
function yE(s, t) {
  const { x: e, y: a, base: n, width: i, height: r } = s.getProps([
    "x",
    "y",
    "base",
    "width",
    "height"
  ], t);
  let l, o, c, d, p;
  return s.horizontal ? (p = r / 2, l = Math.min(e, n), o = Math.max(e, n), c = a - p, d = a + p) : (p = i / 2, l = e - p, o = e + p, c = Math.min(a, n), d = Math.max(a, n)), {
    left: l,
    top: c,
    right: o,
    bottom: d
  };
}
function Fr(s, t, e, a) {
  return s ? 0 : Yn(t, e, a);
}
function Mz(s, t, e) {
  const a = s.options.borderWidth, n = s.borderSkipped, i = zP(a);
  return {
    t: Fr(n.top, i.top, 0, e),
    r: Fr(n.right, i.right, 0, t),
    b: Fr(n.bottom, i.bottom, 0, e),
    l: Fr(n.left, i.left, 0, t)
  };
}
function Xz(s, t, e) {
  const { enableBorderRadius: a } = s.getProps([
    "enableBorderRadius"
  ]), n = s.options.borderRadius, i = Kr(n), r = Math.min(t, e), l = s.borderSkipped, o = a || Ve(n);
  return {
    topLeft: Fr(!o || l.top || l.left, i.topLeft, 0, r),
    topRight: Fr(!o || l.top || l.right, i.topRight, 0, r),
    bottomLeft: Fr(!o || l.bottom || l.left, i.bottomLeft, 0, r),
    bottomRight: Fr(!o || l.bottom || l.right, i.bottomRight, 0, r)
  };
}
function Gz(s) {
  const t = yE(s), e = t.right - t.left, a = t.bottom - t.top, n = Mz(s, e / 2, a / 2), i = Xz(s, e / 2, a / 2);
  return {
    outer: {
      x: t.left,
      y: t.top,
      w: e,
      h: a,
      radius: i
    },
    inner: {
      x: t.left + n.l,
      y: t.top + n.t,
      w: e - n.l - n.r,
      h: a - n.t - n.b,
      radius: {
        topLeft: Math.max(0, i.topLeft - Math.max(n.t, n.l)),
        topRight: Math.max(0, i.topRight - Math.max(n.t, n.r)),
        bottomLeft: Math.max(0, i.bottomLeft - Math.max(n.b, n.l)),
        bottomRight: Math.max(0, i.bottomRight - Math.max(n.b, n.r))
      }
    }
  };
}
function Kb(s, t, e, a) {
  const n = t === null, i = e === null, l = s && !(n && i) && yE(s, a);
  return l && (n || pr(t, l.left, l.right)) && (i || pr(e, l.top, l.bottom));
}
function Hz(s) {
  return s.topLeft || s.topRight || s.bottomLeft || s.bottomRight;
}
function Uz(s, t) {
  s.rect(t.x, t.y, t.w, t.h);
}
function Jb(s, t, e = {}) {
  const a = s.x !== e.x ? -t : 0, n = s.y !== e.y ? -t : 0, i = (s.x + s.w !== e.x + e.w ? t : 0) - a, r = (s.y + s.h !== e.y + e.h ? t : 0) - n;
  return {
    x: s.x + a,
    y: s.y + n,
    w: s.w + i,
    h: s.h + r,
    radius: s.radius
  };
}
class Qh extends cs {
  constructor(t) {
    super(), this.options = void 0, this.horizontal = void 0, this.base = void 0, this.width = void 0, this.height = void 0, this.inflateAmount = void 0, t && Object.assign(this, t);
  }
  draw(t) {
    const { inflateAmount: e, options: { borderColor: a, backgroundColor: n } } = this, { inner: i, outer: r } = Gz(this), l = Hz(r.radius) ? xc : Uz;
    t.save(), (r.w !== i.w || r.h !== i.h) && (t.beginPath(), l(t, Jb(r, e, i)), t.clip(), l(t, Jb(i, -e, r)), t.fillStyle = a, t.fill("evenodd")), t.beginPath(), l(t, Jb(i, e)), t.fillStyle = n, t.fill(), t.restore();
  }
  inRange(t, e, a) {
    return Kb(this, t, e, a);
  }
  inXRange(t, e) {
    return Kb(this, t, null, e);
  }
  inYRange(t, e) {
    return Kb(this, null, t, e);
  }
  getCenterPoint(t) {
    const { x: e, y: a, base: n, horizontal: i } = this.getProps([
      "x",
      "y",
      "base",
      "horizontal"
    ], t);
    return {
      x: i ? (e + n) / 2 : e,
      y: i ? a : (a + n) / 2
    };
  }
  getRange(t) {
    return t === "x" ? this.width / 2 : this.height / 2;
  }
}
Jt(Qh, "id", "bar"), Jt(Qh, "defaults", {
  borderSkipped: "start",
  borderWidth: 0,
  borderRadius: 0,
  inflateAmount: "auto",
  pointStyle: void 0
}), Jt(Qh, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
});
var Fz = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ArcElement: Nd,
  BarElement: Qh,
  LineElement: Ur,
  PointElement: Jh
});
const xx = [
  "rgb(54, 162, 235)",
  "rgb(255, 99, 132)",
  "rgb(255, 159, 64)",
  "rgb(255, 205, 86)",
  "rgb(75, 192, 192)",
  "rgb(153, 102, 255)",
  "rgb(201, 203, 207)"
  // grey
], $D = /* @__PURE__ */ xx.map((s) => s.replace("rgb(", "rgba(").replace(")", ", 0.5)"));
function fE(s) {
  return xx[s % xx.length];
}
function bE(s) {
  return $D[s % $D.length];
}
function zz(s, t) {
  return s.borderColor = fE(t), s.backgroundColor = bE(t), ++t;
}
function Bz(s, t) {
  return s.backgroundColor = s.data.map(() => fE(t++)), t;
}
function Wz(s, t) {
  return s.backgroundColor = s.data.map(() => bE(t++)), t;
}
function jz(s) {
  let t = 0;
  return (e, a) => {
    const n = s.getDatasetMeta(a).controller;
    n instanceof Rl ? t = Bz(e, t) : n instanceof Vd ? t = Wz(e, t) : n && (t = zz(e, t));
  };
}
function SD(s) {
  let t;
  for (t in s)
    if (s[t].borderColor || s[t].backgroundColor)
      return !0;
  return !1;
}
function Vz(s) {
  return s && (s.borderColor || s.backgroundColor);
}
var qz = {
  id: "colors",
  defaults: {
    enabled: !0,
    forceOverride: !1
  },
  beforeLayout(s, t, e) {
    if (!e.enabled)
      return;
    const { data: { datasets: a }, options: n } = s.config, { elements: i } = n;
    if (!e.forceOverride && (SD(a) || Vz(n) || i && SD(i)))
      return;
    const r = jz(s);
    a.forEach(r);
  }
};
function Kz(s, t, e, a, n) {
  const i = n.samples || a;
  if (i >= e)
    return s.slice(t, t + e);
  const r = [], l = (e - 2) / (i - 2);
  let o = 0;
  const c = t + e - 1;
  let d = t, p, h, g, x, b;
  for (r[o++] = s[d], p = 0; p < i - 2; p++) {
    let A = 0, T = 0, R;
    const C = Math.floor((p + 1) * l) + 1 + t, v = Math.min(Math.floor((p + 2) * l) + 1, e) + t, P = v - C;
    for (R = C; R < v; R++)
      A += s[R].x, T += s[R].y;
    A /= P, T /= P;
    const O = Math.floor(p * l) + 1 + t, N = Math.min(Math.floor((p + 1) * l) + 1, e) + t, { x: H, y: F } = s[d];
    for (g = x = -1, R = O; R < N; R++)
      x = 0.5 * Math.abs((H - A) * (s[R].y - F) - (H - s[R].x) * (T - F)), x > g && (g = x, h = s[R], b = R);
    r[o++] = h, d = b;
  }
  return r[o++] = s[c], r;
}
function Jz(s, t, e, a) {
  let n = 0, i = 0, r, l, o, c, d, p, h, g, x, b;
  const A = [], T = t + e - 1, R = s[t].x, v = s[T].x - R;
  for (r = t; r < t + e; ++r) {
    l = s[r], o = (l.x - R) / v * a, c = l.y;
    const P = o | 0;
    if (P === d)
      c < x ? (x = c, p = r) : c > b && (b = c, h = r), n = (i * n + l.x) / ++i;
    else {
      const O = r - 1;
      if (!ua(p) && !ua(h)) {
        const N = Math.min(p, h), H = Math.max(p, h);
        N !== g && N !== O && A.push({
          ...s[N],
          x: n
        }), H !== g && H !== O && A.push({
          ...s[H],
          x: n
        });
      }
      r > 0 && O !== g && A.push(s[O]), A.push(l), d = P, i = 0, x = b = c, p = h = g = r;
    }
  }
  return A;
}
function vE(s) {
  if (s._decimated) {
    const t = s._data;
    delete s._decimated, delete s._data, Object.defineProperty(s, "data", {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      value: t
    });
  }
}
function kD(s) {
  s.data.datasets.forEach((t) => {
    vE(t);
  });
}
function Qz(s, t) {
  const e = t.length;
  let a = 0, n;
  const { iScale: i } = s, { min: r, max: l, minDefined: o, maxDefined: c } = i.getUserBounds();
  return o && (a = Yn(hr(t, i.axis, r).lo, 0, e - 1)), c ? n = Yn(hr(t, i.axis, l).hi + 1, a, e) - a : n = e - a, {
    start: a,
    count: n
  };
}
var Zz = {
  id: "decimation",
  defaults: {
    algorithm: "min-max",
    enabled: !1
  },
  beforeElementsUpdate: (s, t, e) => {
    if (!e.enabled) {
      kD(s);
      return;
    }
    const a = s.width;
    s.data.datasets.forEach((n, i) => {
      const { _data: r, indexAxis: l } = n, o = s.getDatasetMeta(i), c = r || n.data;
      if (Pd([
        l,
        s.options.indexAxis
      ]) === "y" || !o.controller.supportsDecimation)
        return;
      const d = s.scales[o.xAxisID];
      if (d.type !== "linear" && d.type !== "time" || s.options.parsing)
        return;
      let { start: p, count: h } = Qz(o, c);
      const g = e.threshold || 4 * a;
      if (h <= g) {
        vE(n);
        return;
      }
      ua(r) && (n._data = c, delete n.data, Object.defineProperty(n, "data", {
        configurable: !0,
        enumerable: !0,
        get: function() {
          return this._decimated;
        },
        set: function(b) {
          this._data = b;
        }
      }));
      let x;
      switch (e.algorithm) {
        case "lttb":
          x = Kz(c, p, h, a, e);
          break;
        case "min-max":
          x = Jz(c, p, h, a);
          break;
        default:
          throw new Error(`Unsupported decimation algorithm '${e.algorithm}'`);
      }
      n._decimated = x;
    });
  },
  destroy(s) {
    kD(s);
  }
};
function tB(s, t, e) {
  const a = s.segments, n = s.points, i = t.points, r = [];
  for (const l of a) {
    let { start: o, end: c } = l;
    c = Zw(o, c, n);
    const d = wx(e, n[o], n[c], l.loop);
    if (!t.segments) {
      r.push({
        source: l,
        target: d,
        start: n[o],
        end: n[c]
      });
      continue;
    }
    const p = eE(t, d);
    for (const h of p) {
      const g = wx(e, i[h.start], i[h.end], h.loop), x = tE(l, n, g);
      for (const b of x)
        r.push({
          source: b,
          target: h,
          start: {
            [e]: TD(d, g, "start", Math.max)
          },
          end: {
            [e]: TD(d, g, "end", Math.min)
          }
        });
    }
  }
  return r;
}
function wx(s, t, e, a) {
  if (a)
    return;
  let n = t[s], i = e[s];
  return s === "angle" && (n = Ps(n), i = Ps(i)), {
    property: s,
    start: n,
    end: i
  };
}
function eB(s, t) {
  const { x: e = null, y: a = null } = s || {}, n = t.points, i = [];
  return t.segments.forEach(({ start: r, end: l }) => {
    l = Zw(r, l, n);
    const o = n[r], c = n[l];
    a !== null ? (i.push({
      x: o.x,
      y: a
    }), i.push({
      x: c.x,
      y: a
    })) : e !== null && (i.push({
      x: e,
      y: o.y
    }), i.push({
      x: e,
      y: c.y
    }));
  }), i;
}
function Zw(s, t, e) {
  for (; t > s; t--) {
    const a = e[t];
    if (!isNaN(a.x) && !isNaN(a.y))
      break;
  }
  return t;
}
function TD(s, t, e, a) {
  return s && t ? a(s[e], t[e]) : s ? s[e] : t ? t[e] : 0;
}
function xE(s, t) {
  let e = [], a = !1;
  return ya(s) ? (a = !0, e = s) : e = eB(s, t), e.length ? new Ur({
    points: e,
    options: {
      tension: 0
    },
    _loop: a,
    _fullLoop: a
  }) : null;
}
function LD(s) {
  return s && s.fill !== !1;
}
function aB(s, t, e) {
  let n = s[t].fill;
  const i = [
    t
  ];
  let r;
  if (!e)
    return n;
  for (; n !== !1 && i.indexOf(n) === -1; ) {
    if (!Va(n))
      return n;
    if (r = s[n], !r)
      return !1;
    if (r.visible)
      return n;
    i.push(n), n = r.fill;
  }
  return !1;
}
function nB(s, t, e) {
  const a = lB(s);
  if (Ve(a))
    return isNaN(a.value) ? !1 : a;
  let n = parseFloat(a);
  return Va(n) && Math.floor(n) === n ? sB(a[0], t, n, e) : [
    "origin",
    "start",
    "end",
    "stack",
    "shape"
  ].indexOf(a) >= 0 && a;
}
function sB(s, t, e, a) {
  return (s === "-" || s === "+") && (e = t + e), e === t || e < 0 || e >= a ? !1 : e;
}
function iB(s, t) {
  let e = null;
  return s === "start" ? e = t.bottom : s === "end" ? e = t.top : Ve(s) ? e = t.getPixelForValue(s.value) : t.getBasePixel && (e = t.getBasePixel()), e;
}
function rB(s, t, e) {
  let a;
  return s === "start" ? a = e : s === "end" ? a = t.options.reverse ? t.min : t.max : Ve(s) ? a = s.value : a = t.getBaseValue(), a;
}
function lB(s) {
  const t = s.options, e = t.fill;
  let a = Fe(e && e.target, e);
  return a === void 0 && (a = !!t.backgroundColor), a === !1 || a === null ? !1 : a === !0 ? "origin" : a;
}
function oB(s) {
  const { scale: t, index: e, line: a } = s, n = [], i = a.segments, r = a.points, l = cB(t, e);
  l.push(xE({
    x: null,
    y: t.bottom
  }, a));
  for (let o = 0; o < i.length; o++) {
    const c = i[o];
    for (let d = c.start; d <= c.end; d++)
      dB(n, r[d], l);
  }
  return new Ur({
    points: n,
    options: {}
  });
}
function cB(s, t) {
  const e = [], a = s.getMatchingVisibleMetas("line");
  for (let n = 0; n < a.length; n++) {
    const i = a[n];
    if (i.index === t)
      break;
    i.hidden || e.unshift(i.dataset);
  }
  return e;
}
function dB(s, t, e) {
  const a = [];
  for (let n = 0; n < e.length; n++) {
    const i = e[n], { first: r, last: l, point: o } = uB(i, t, "x");
    if (!(!o || r && l)) {
      if (r)
        a.unshift(o);
      else if (s.push(o), !l)
        break;
    }
  }
  s.push(...a);
}
function uB(s, t, e) {
  const a = s.interpolate(t, e);
  if (!a)
    return {};
  const n = a[e], i = s.segments, r = s.points;
  let l = !1, o = !1;
  for (let c = 0; c < i.length; c++) {
    const d = i[c], p = r[d.start][e], h = r[d.end][e];
    if (pr(n, p, h)) {
      l = n === p, o = n === h;
      break;
    }
  }
  return {
    first: l,
    last: o,
    point: a
  };
}
class wE {
  constructor(t) {
    this.x = t.x, this.y = t.y, this.radius = t.radius;
  }
  pathSegment(t, e, a) {
    const { x: n, y: i, radius: r } = this;
    return e = e || {
      start: 0,
      end: Ga
    }, t.arc(n, i, r, e.end, e.start, !0), !a.bounds;
  }
  interpolate(t) {
    const { x: e, y: a, radius: n } = this, i = t.angle;
    return {
      x: e + Math.cos(i) * n,
      y: a + Math.sin(i) * n,
      angle: i
    };
  }
}
function pB(s) {
  const { chart: t, fill: e, line: a } = s;
  if (Va(e))
    return hB(t, e);
  if (e === "stack")
    return oB(s);
  if (e === "shape")
    return !0;
  const n = mB(s);
  return n instanceof wE ? n : xE(n, a);
}
function hB(s, t) {
  const e = s.getDatasetMeta(t);
  return e && s.isDatasetVisible(t) ? e.dataset : null;
}
function mB(s) {
  return (s.scale || {}).getPointPositionForValue ? yB(s) : gB(s);
}
function gB(s) {
  const { scale: t = {}, fill: e } = s, a = iB(e, t);
  if (Va(a)) {
    const n = t.isHorizontal();
    return {
      x: n ? a : null,
      y: n ? null : a
    };
  }
  return null;
}
function yB(s) {
  const { scale: t, fill: e } = s, a = t.options, n = t.getLabels().length, i = a.reverse ? t.max : t.min, r = rB(e, t, i), l = [];
  if (a.grid.circular) {
    const o = t.getPointPositionForValue(0, i);
    return new wE({
      x: o.x,
      y: o.y,
      radius: t.getDistanceFromCenterForValue(r)
    });
  }
  for (let o = 0; o < n; ++o)
    l.push(t.getPointPositionForValue(o, r));
  return l;
}
function Qb(s, t, e) {
  const a = pB(t), { line: n, scale: i, axis: r } = t, l = n.options, o = l.fill, c = l.backgroundColor, { above: d = c, below: p = c } = o || {};
  a && n.points.length && (Wu(s, e), fB(s, {
    line: n,
    target: a,
    above: d,
    below: p,
    area: e,
    scale: i,
    axis: r
  }), ju(s));
}
function fB(s, t) {
  const { line: e, target: a, above: n, below: i, area: r, scale: l } = t, o = e._loop ? "angle" : t.axis;
  s.save(), o === "x" && i !== n && (DD(s, a, r.top), ID(s, {
    line: e,
    target: a,
    color: n,
    scale: l,
    property: o
  }), s.restore(), s.save(), DD(s, a, r.bottom)), ID(s, {
    line: e,
    target: a,
    color: i,
    scale: l,
    property: o
  }), s.restore();
}
function DD(s, t, e) {
  const { segments: a, points: n } = t;
  let i = !0, r = !1;
  s.beginPath();
  for (const l of a) {
    const { start: o, end: c } = l, d = n[o], p = n[Zw(o, c, n)];
    i ? (s.moveTo(d.x, d.y), i = !1) : (s.lineTo(d.x, e), s.lineTo(d.x, d.y)), r = !!t.pathSegment(s, l, {
      move: r
    }), r ? s.closePath() : s.lineTo(p.x, e);
  }
  s.lineTo(t.first().x, e), s.closePath(), s.clip();
}
function ID(s, t) {
  const { line: e, target: a, property: n, color: i, scale: r } = t, l = tB(e, a, n);
  for (const { source: o, target: c, start: d, end: p } of l) {
    const { style: { backgroundColor: h = i } = {} } = o, g = a !== !0;
    s.save(), s.fillStyle = h, bB(s, r, g && wx(n, d, p)), s.beginPath();
    const x = !!e.pathSegment(s, o);
    let b;
    if (g) {
      x ? s.closePath() : PD(s, a, p, n);
      const A = !!a.pathSegment(s, c, {
        move: x,
        reverse: !0
      });
      b = x && A, b || PD(s, a, d, n);
    }
    s.closePath(), s.fill(b ? "evenodd" : "nonzero"), s.restore();
  }
}
function bB(s, t, e) {
  const { top: a, bottom: n } = t.chart.chartArea, { property: i, start: r, end: l } = e || {};
  i === "x" && (s.beginPath(), s.rect(r, a, l - r, n - a), s.clip());
}
function PD(s, t, e, a) {
  const n = t.interpolate(e, a);
  n && s.lineTo(n.x, n.y);
}
var vB = {
  id: "filler",
  afterDatasetsUpdate(s, t, e) {
    const a = (s.data.datasets || []).length, n = [];
    let i, r, l, o;
    for (r = 0; r < a; ++r)
      i = s.getDatasetMeta(r), l = i.dataset, o = null, l && l.options && l instanceof Ur && (o = {
        visible: s.isDatasetVisible(r),
        index: r,
        fill: nB(l, r, a),
        chart: s,
        axis: i.controller.options.indexAxis,
        scale: i.vScale,
        line: l
      }), i.$filler = o, n.push(o);
    for (r = 0; r < a; ++r)
      o = n[r], !(!o || o.fill === !1) && (o.fill = aB(n, r, e.propagate));
  },
  beforeDraw(s, t, e) {
    const a = e.drawTime === "beforeDraw", n = s.getSortedVisibleDatasetMetas(), i = s.chartArea;
    for (let r = n.length - 1; r >= 0; --r) {
      const l = n[r].$filler;
      l && (l.line.updateControlPoints(i, l.axis), a && l.fill && Qb(s.ctx, l, i));
    }
  },
  beforeDatasetsDraw(s, t, e) {
    if (e.drawTime !== "beforeDatasetsDraw")
      return;
    const a = s.getSortedVisibleDatasetMetas();
    for (let n = a.length - 1; n >= 0; --n) {
      const i = a[n].$filler;
      LD(i) && Qb(s.ctx, i, s.chartArea);
    }
  },
  beforeDatasetDraw(s, t, e) {
    const a = t.meta.$filler;
    !LD(a) || e.drawTime !== "beforeDatasetDraw" || Qb(s.ctx, a, s.chartArea);
  },
  defaults: {
    propagate: !0,
    drawTime: "beforeDatasetDraw"
  }
};
const ED = (s, t) => {
  let { boxHeight: e = t, boxWidth: a = t } = s;
  return s.usePointStyle && (e = Math.min(e, t), a = s.pointStyleWidth || Math.min(a, t)), {
    boxWidth: a,
    boxHeight: e,
    itemHeight: Math.max(t, e)
  };
}, xB = (s, t) => s !== null && t !== null && s.datasetIndex === t.datasetIndex && s.index === t.index;
class ND extends cs {
  constructor(t) {
    super(), this._added = !1, this.legendHitBoxes = [], this._hoveredItem = null, this.doughnutMode = !1, this.chart = t.chart, this.options = t.options, this.ctx = t.ctx, this.legendItems = void 0, this.columnSizes = void 0, this.lineWidths = void 0, this.maxHeight = void 0, this.maxWidth = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.height = void 0, this.width = void 0, this._margins = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0;
  }
  update(t, e, a) {
    this.maxWidth = t, this.maxHeight = e, this._margins = a, this.setDimensions(), this.buildLabels(), this.fit();
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = this._margins.left, this.right = this.width) : (this.height = this.maxHeight, this.top = this._margins.top, this.bottom = this.height);
  }
  buildLabels() {
    const t = this.options.labels || {};
    let e = Sa(t.generateLabels, [
      this.chart
    ], this) || [];
    t.filter && (e = e.filter((a) => t.filter(a, this.chart.data))), t.sort && (e = e.sort((a, n) => t.sort(a, n, this.chart.data))), this.options.reverse && e.reverse(), this.legendItems = e;
  }
  fit() {
    const { options: t, ctx: e } = this;
    if (!t.display) {
      this.width = this.height = 0;
      return;
    }
    const a = t.labels, n = an(a.font), i = n.size, r = this._computeTitleHeight(), { boxWidth: l, itemHeight: o } = ED(a, i);
    let c, d;
    e.font = n.string, this.isHorizontal() ? (c = this.maxWidth, d = this._fitRows(r, i, l, o) + 10) : (d = this.maxHeight, c = this._fitCols(r, n, l, o) + 10), this.width = Math.min(c, t.maxWidth || this.maxWidth), this.height = Math.min(d, t.maxHeight || this.maxHeight);
  }
  _fitRows(t, e, a, n) {
    const { ctx: i, maxWidth: r, options: { labels: { padding: l } } } = this, o = this.legendHitBoxes = [], c = this.lineWidths = [
      0
    ], d = n + l;
    let p = t;
    i.textAlign = "left", i.textBaseline = "middle";
    let h = -1, g = -d;
    return this.legendItems.forEach((x, b) => {
      const A = a + e / 2 + i.measureText(x.text).width;
      (b === 0 || c[c.length - 1] + A + 2 * l > r) && (p += d, c[c.length - (b > 0 ? 0 : 1)] = 0, g += d, h++), o[b] = {
        left: 0,
        top: g,
        row: h,
        width: A,
        height: n
      }, c[c.length - 1] += A + l;
    }), p;
  }
  _fitCols(t, e, a, n) {
    const { ctx: i, maxHeight: r, options: { labels: { padding: l } } } = this, o = this.legendHitBoxes = [], c = this.columnSizes = [], d = r - t;
    let p = l, h = 0, g = 0, x = 0, b = 0;
    return this.legendItems.forEach((A, T) => {
      const { itemWidth: R, itemHeight: C } = wB(a, e, i, A, n);
      T > 0 && g + C + 2 * l > d && (p += h + l, c.push({
        width: h,
        height: g
      }), x += h + l, b++, h = g = 0), o[T] = {
        left: x,
        top: g,
        col: b,
        width: R,
        height: C
      }, h = Math.max(h, R), g += C + l;
    }), p += h, c.push({
      width: h,
      height: g
    }), p;
  }
  adjustHitBoxes() {
    if (!this.options.display)
      return;
    const t = this._computeTitleHeight(), { legendHitBoxes: e, options: { align: a, labels: { padding: n }, rtl: i } } = this, r = mc(i, this.left, this.width);
    if (this.isHorizontal()) {
      let l = 0, o = Bn(a, this.left + n, this.right - this.lineWidths[l]);
      for (const c of e)
        l !== c.row && (l = c.row, o = Bn(a, this.left + n, this.right - this.lineWidths[l])), c.top += this.top + t + n, c.left = r.leftForLtr(r.x(o), c.width), o += c.width + n;
    } else {
      let l = 0, o = Bn(a, this.top + t + n, this.bottom - this.columnSizes[l].height);
      for (const c of e)
        c.col !== l && (l = c.col, o = Bn(a, this.top + t + n, this.bottom - this.columnSizes[l].height)), c.top = o, c.left += this.left + n, c.left = r.leftForLtr(r.x(c.left), c.width), o += c.height + n;
    }
  }
  isHorizontal() {
    return this.options.position === "top" || this.options.position === "bottom";
  }
  draw() {
    if (this.options.display) {
      const t = this.ctx;
      Wu(t, this), this._draw(), ju(t);
    }
  }
  _draw() {
    const { options: t, columnSizes: e, lineWidths: a, ctx: n } = this, { align: i, labels: r } = t, l = en.color, o = mc(t.rtl, this.left, this.width), c = an(r.font), { padding: d } = r, p = c.size, h = p / 2;
    let g;
    this.drawTitle(), n.textAlign = o.textAlign("left"), n.textBaseline = "middle", n.lineWidth = 0.5, n.font = c.string;
    const { boxWidth: x, boxHeight: b, itemHeight: A } = ED(r, p), T = function(O, N, H) {
      if (isNaN(x) || x <= 0 || isNaN(b) || b < 0)
        return;
      n.save();
      const F = Fe(H.lineWidth, 1);
      if (n.fillStyle = Fe(H.fillStyle, l), n.lineCap = Fe(H.lineCap, "butt"), n.lineDashOffset = Fe(H.lineDashOffset, 0), n.lineJoin = Fe(H.lineJoin, "miter"), n.lineWidth = F, n.strokeStyle = Fe(H.strokeStyle, l), n.setLineDash(Fe(H.lineDash, [])), r.usePointStyle) {
        const B = {
          radius: b * Math.SQRT2 / 2,
          pointStyle: H.pointStyle,
          rotation: H.rotation,
          borderWidth: F
        }, Q = o.xPlus(O, x / 2), it = N + h;
        FP(n, B, Q, it, r.pointStyleWidth && x);
      } else {
        const B = N + Math.max((p - b) / 2, 0), Q = o.leftForLtr(O, x), it = Kr(H.borderRadius);
        n.beginPath(), Object.values(it).some((et) => et !== 0) ? xc(n, {
          x: Q,
          y: B,
          w: x,
          h: b,
          radius: it
        }) : n.rect(Q, B, x, b), n.fill(), F !== 0 && n.stroke();
      }
      n.restore();
    }, R = function(O, N, H) {
      jl(n, H.text, O, N + A / 2, c, {
        strikethrough: H.hidden,
        textAlign: o.textAlign(H.textAlign)
      });
    }, C = this.isHorizontal(), v = this._computeTitleHeight();
    C ? g = {
      x: Bn(i, this.left + d, this.right - a[0]),
      y: this.top + d + v,
      line: 0
    } : g = {
      x: this.left + d,
      y: Bn(i, this.top + v + d, this.bottom - e[0].height),
      line: 0
    }, JP(this.ctx, t.textDirection);
    const P = A + d;
    this.legendItems.forEach((O, N) => {
      n.strokeStyle = O.fontColor, n.fillStyle = O.fontColor;
      const H = n.measureText(O.text).width, F = o.textAlign(O.textAlign || (O.textAlign = r.textAlign)), B = x + h + H;
      let Q = g.x, it = g.y;
      o.setWidth(this.width), C ? N > 0 && Q + B + d > this.right && (it = g.y += P, g.line++, Q = g.x = Bn(i, this.left + d, this.right - a[g.line])) : N > 0 && it + P > this.bottom && (Q = g.x = Q + e[g.line].width + d, g.line++, it = g.y = Bn(i, this.top + v + d, this.bottom - e[g.line].height));
      const et = o.x(Q);
      if (T(et, it, O), Q = F2(F, Q + x + h, C ? Q + B : this.right, t.rtl), R(o.x(Q), it, O), C)
        g.x += B + d;
      else if (typeof O.text != "string") {
        const rt = c.lineHeight;
        g.y += AE(O, rt) + d;
      } else
        g.y += P;
    }), QP(this.ctx, t.textDirection);
  }
  drawTitle() {
    const t = this.options, e = t.title, a = an(e.font), n = vn(e.padding);
    if (!e.display)
      return;
    const i = mc(t.rtl, this.left, this.width), r = this.ctx, l = e.position, o = a.size / 2, c = n.top + o;
    let d, p = this.left, h = this.width;
    if (this.isHorizontal())
      h = Math.max(...this.lineWidths), d = this.top + c, p = Bn(t.align, p, this.right - h);
    else {
      const x = this.columnSizes.reduce((b, A) => Math.max(b, A.height), 0);
      d = c + Bn(t.align, this.top, this.bottom - x - t.labels.padding - this._computeTitleHeight());
    }
    const g = Bn(l, p, p + h);
    r.textAlign = i.textAlign(Fw(l)), r.textBaseline = "middle", r.strokeStyle = e.color, r.fillStyle = e.color, r.font = a.string, jl(r, e.text, g, d, a);
  }
  _computeTitleHeight() {
    const t = this.options.title, e = an(t.font), a = vn(t.padding);
    return t.display ? e.lineHeight + a.height : 0;
  }
  _getLegendItemAt(t, e) {
    let a, n, i;
    if (pr(t, this.left, this.right) && pr(e, this.top, this.bottom)) {
      for (i = this.legendHitBoxes, a = 0; a < i.length; ++a)
        if (n = i[a], pr(t, n.left, n.left + n.width) && pr(e, n.top, n.top + n.height))
          return this.legendItems[a];
    }
    return null;
  }
  handleEvent(t) {
    const e = this.options;
    if (!$B(t.type, e))
      return;
    const a = this._getLegendItemAt(t.x, t.y);
    if (t.type === "mousemove" || t.type === "mouseout") {
      const n = this._hoveredItem, i = xB(n, a);
      n && !i && Sa(e.onLeave, [
        t,
        n,
        this
      ], this), this._hoveredItem = a, a && !i && Sa(e.onHover, [
        t,
        a,
        this
      ], this);
    } else
      a && Sa(e.onClick, [
        t,
        a,
        this
      ], this);
  }
}
function wB(s, t, e, a, n) {
  const i = AB(a, s, t, e), r = CB(n, a, t.lineHeight);
  return {
    itemWidth: i,
    itemHeight: r
  };
}
function AB(s, t, e, a) {
  let n = s.text;
  return n && typeof n != "string" && (n = n.reduce((i, r) => i.length > r.length ? i : r)), t + e.size / 2 + a.measureText(n).width;
}
function CB(s, t, e) {
  let a = s;
  return typeof t.text != "string" && (a = AE(t, e)), a;
}
function AE(s, t) {
  const e = s.text ? s.text.length : 0;
  return t * e;
}
function $B(s, t) {
  return !!((s === "mousemove" || s === "mouseout") && (t.onHover || t.onLeave) || t.onClick && (s === "click" || s === "mouseup"));
}
var SB = {
  id: "legend",
  _element: ND,
  start(s, t, e) {
    const a = s.legend = new ND({
      ctx: s.ctx,
      options: e,
      chart: s
    });
    qn.configure(s, a, e), qn.addBox(s, a);
  },
  stop(s) {
    qn.removeBox(s, s.legend), delete s.legend;
  },
  beforeUpdate(s, t, e) {
    const a = s.legend;
    qn.configure(s, a, e), a.options = e;
  },
  afterUpdate(s) {
    const t = s.legend;
    t.buildLabels(), t.adjustHitBoxes();
  },
  afterEvent(s, t) {
    t.replay || s.legend.handleEvent(t.event);
  },
  defaults: {
    display: !0,
    position: "top",
    align: "center",
    fullSize: !0,
    reverse: !1,
    weight: 1e3,
    onClick(s, t, e) {
      const a = t.datasetIndex, n = e.chart;
      n.isDatasetVisible(a) ? (n.hide(a), t.hidden = !0) : (n.show(a), t.hidden = !1);
    },
    onHover: null,
    onLeave: null,
    labels: {
      color: (s) => s.chart.options.color,
      boxWidth: 40,
      padding: 10,
      generateLabels(s) {
        const t = s.data.datasets, { labels: { usePointStyle: e, pointStyle: a, textAlign: n, color: i, useBorderRadius: r, borderRadius: l } } = s.legend.options;
        return s._getSortedDatasetMetas().map((o) => {
          const c = o.controller.getStyle(e ? 0 : void 0), d = vn(c.borderWidth);
          return {
            text: t[o.index].label,
            fillStyle: c.backgroundColor,
            fontColor: i,
            hidden: !o.visible,
            lineCap: c.borderCapStyle,
            lineDash: c.borderDash,
            lineDashOffset: c.borderDashOffset,
            lineJoin: c.borderJoinStyle,
            lineWidth: (d.width + d.height) / 4,
            strokeStyle: c.borderColor,
            pointStyle: a || c.pointStyle,
            rotation: c.rotation,
            textAlign: n || c.textAlign,
            borderRadius: r && (l || c.borderRadius),
            datasetIndex: o.index
          };
        }, this);
      }
    },
    title: {
      color: (s) => s.chart.options.color,
      display: !1,
      position: "center",
      text: ""
    }
  },
  descriptors: {
    _scriptable: (s) => !s.startsWith("on"),
    labels: {
      _scriptable: (s) => ![
        "generateLabels",
        "filter",
        "sort"
      ].includes(s)
    }
  }
};
class tA extends cs {
  constructor(t) {
    super(), this.chart = t.chart, this.options = t.options, this.ctx = t.ctx, this._padding = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0;
  }
  update(t, e) {
    const a = this.options;
    if (this.left = 0, this.top = 0, !a.display) {
      this.width = this.height = this.right = this.bottom = 0;
      return;
    }
    this.width = this.right = t, this.height = this.bottom = e;
    const n = ya(a.text) ? a.text.length : 1;
    this._padding = vn(a.padding);
    const i = n * an(a.font).lineHeight + this._padding.height;
    this.isHorizontal() ? this.height = i : this.width = i;
  }
  isHorizontal() {
    const t = this.options.position;
    return t === "top" || t === "bottom";
  }
  _drawArgs(t) {
    const { top: e, left: a, bottom: n, right: i, options: r } = this, l = r.align;
    let o = 0, c, d, p;
    return this.isHorizontal() ? (d = Bn(l, a, i), p = e + t, c = i - a) : (r.position === "left" ? (d = a + t, p = Bn(l, n, e), o = ra * -0.5) : (d = i - t, p = Bn(l, e, n), o = ra * 0.5), c = n - e), {
      titleX: d,
      titleY: p,
      maxWidth: c,
      rotation: o
    };
  }
  draw() {
    const t = this.ctx, e = this.options;
    if (!e.display)
      return;
    const a = an(e.font), i = a.lineHeight / 2 + this._padding.top, { titleX: r, titleY: l, maxWidth: o, rotation: c } = this._drawArgs(i);
    jl(t, e.text, 0, 0, a, {
      color: e.color,
      maxWidth: o,
      rotation: c,
      textAlign: Fw(e.align),
      textBaseline: "middle",
      translation: [
        r,
        l
      ]
    });
  }
}
function kB(s, t) {
  const e = new tA({
    ctx: s.ctx,
    options: t,
    chart: s
  });
  qn.configure(s, e, t), qn.addBox(s, e), s.titleBlock = e;
}
var TB = {
  id: "title",
  _element: tA,
  start(s, t, e) {
    kB(s, e);
  },
  stop(s) {
    const t = s.titleBlock;
    qn.removeBox(s, t), delete s.titleBlock;
  },
  beforeUpdate(s, t, e) {
    const a = s.titleBlock;
    qn.configure(s, a, e), a.options = e;
  },
  defaults: {
    align: "center",
    display: !1,
    font: {
      weight: "bold"
    },
    fullSize: !0,
    padding: 10,
    position: "top",
    text: "",
    weight: 2e3
  },
  defaultRoutes: {
    color: "color"
  },
  descriptors: {
    _scriptable: !0,
    _indexable: !1
  }
};
const xh = /* @__PURE__ */ new WeakMap();
var LB = {
  id: "subtitle",
  start(s, t, e) {
    const a = new tA({
      ctx: s.ctx,
      options: e,
      chart: s
    });
    qn.configure(s, a, e), qn.addBox(s, a), xh.set(s, a);
  },
  stop(s) {
    qn.removeBox(s, xh.get(s)), xh.delete(s);
  },
  beforeUpdate(s, t, e) {
    const a = xh.get(s);
    qn.configure(s, a, e), a.options = e;
  },
  defaults: {
    align: "center",
    display: !1,
    font: {
      weight: "normal"
    },
    fullSize: !0,
    padding: 0,
    position: "top",
    text: "",
    weight: 1500
  },
  defaultRoutes: {
    color: "color"
  },
  descriptors: {
    _scriptable: !0,
    _indexable: !1
  }
};
const Rd = {
  average(s) {
    if (!s.length)
      return !1;
    let t, e, a = /* @__PURE__ */ new Set(), n = 0, i = 0;
    for (t = 0, e = s.length; t < e; ++t) {
      const l = s[t].element;
      if (l && l.hasValue()) {
        const o = l.tooltipPosition();
        a.add(o.x), n += o.y, ++i;
      }
    }
    return {
      x: [
        ...a
      ].reduce((l, o) => l + o) / a.size,
      y: n / i
    };
  },
  nearest(s, t) {
    if (!s.length)
      return !1;
    let e = t.x, a = t.y, n = Number.POSITIVE_INFINITY, i, r, l;
    for (i = 0, r = s.length; i < r; ++i) {
      const o = s[i].element;
      if (o && o.hasValue()) {
        const c = o.getCenterPoint(), d = vc(t, c);
        d < n && (n = d, l = o);
      }
    }
    if (l) {
      const o = l.tooltipPosition();
      e = o.x, a = o.y;
    }
    return {
      x: e,
      y: a
    };
  }
};
function Di(s, t) {
  return t && (ya(t) ? Array.prototype.push.apply(s, t) : s.push(t)), s;
}
function lr(s) {
  return (typeof s == "string" || s instanceof String) && s.indexOf(`
`) > -1 ? s.split(`
`) : s;
}
function DB(s, t) {
  const { element: e, datasetIndex: a, index: n } = t, i = s.getDatasetMeta(a).controller, { label: r, value: l } = i.getLabelAndValue(n);
  return {
    chart: s,
    label: r,
    parsed: i.getParsed(n),
    raw: s.data.datasets[a].data[n],
    formattedValue: l,
    dataset: i.getDataset(),
    dataIndex: n,
    datasetIndex: a,
    element: e
  };
}
function RD(s, t) {
  const e = s.chart.ctx, { body: a, footer: n, title: i } = s, { boxWidth: r, boxHeight: l } = t, o = an(t.bodyFont), c = an(t.titleFont), d = an(t.footerFont), p = i.length, h = n.length, g = a.length, x = vn(t.padding);
  let b = x.height, A = 0, T = a.reduce((v, P) => v + P.before.length + P.lines.length + P.after.length, 0);
  if (T += s.beforeBody.length + s.afterBody.length, p && (b += p * c.lineHeight + (p - 1) * t.titleSpacing + t.titleMarginBottom), T) {
    const v = t.displayColors ? Math.max(l, o.lineHeight) : o.lineHeight;
    b += g * v + (T - g) * o.lineHeight + (T - 1) * t.bodySpacing;
  }
  h && (b += t.footerMarginTop + h * d.lineHeight + (h - 1) * t.footerSpacing);
  let R = 0;
  const C = function(v) {
    A = Math.max(A, e.measureText(v).width + R);
  };
  return e.save(), e.font = c.string, ka(s.title, C), e.font = o.string, ka(s.beforeBody.concat(s.afterBody), C), R = t.displayColors ? r + 2 + t.boxPadding : 0, ka(a, (v) => {
    ka(v.before, C), ka(v.lines, C), ka(v.after, C);
  }), R = 0, e.font = d.string, ka(s.footer, C), e.restore(), A += x.width, {
    width: A,
    height: b
  };
}
function IB(s, t) {
  const { y: e, height: a } = t;
  return e < a / 2 ? "top" : e > s.height - a / 2 ? "bottom" : "center";
}
function PB(s, t, e, a) {
  const { x: n, width: i } = a, r = e.caretSize + e.caretPadding;
  if (s === "left" && n + i + r > t.width || s === "right" && n - i - r < 0)
    return !0;
}
function EB(s, t, e, a) {
  const { x: n, width: i } = e, { width: r, chartArea: { left: l, right: o } } = s;
  let c = "center";
  return a === "center" ? c = n <= (l + o) / 2 ? "left" : "right" : n <= i / 2 ? c = "left" : n >= r - i / 2 && (c = "right"), PB(c, s, t, e) && (c = "center"), c;
}
function YD(s, t, e) {
  const a = e.yAlign || t.yAlign || IB(s, e);
  return {
    xAlign: e.xAlign || t.xAlign || EB(s, t, e, a),
    yAlign: a
  };
}
function NB(s, t) {
  let { x: e, width: a } = s;
  return t === "right" ? e -= a : t === "center" && (e -= a / 2), e;
}
function RB(s, t, e) {
  let { y: a, height: n } = s;
  return t === "top" ? a += e : t === "bottom" ? a -= n + e : a -= n / 2, a;
}
function _D(s, t, e, a) {
  const { caretSize: n, caretPadding: i, cornerRadius: r } = s, { xAlign: l, yAlign: o } = e, c = n + i, { topLeft: d, topRight: p, bottomLeft: h, bottomRight: g } = Kr(r);
  let x = NB(t, l);
  const b = RB(t, o, c);
  return o === "center" ? l === "left" ? x += c : l === "right" && (x -= c) : l === "left" ? x -= Math.max(d, h) + n : l === "right" && (x += Math.max(p, g) + n), {
    x: Yn(x, 0, a.width - t.width),
    y: Yn(b, 0, a.height - t.height)
  };
}
function wh(s, t, e) {
  const a = vn(e.padding);
  return t === "center" ? s.x + s.width / 2 : t === "right" ? s.x + s.width - a.right : s.x + a.left;
}
function OD(s) {
  return Di([], lr(s));
}
function YB(s, t, e) {
  return cl(s, {
    tooltip: t,
    tooltipItems: e,
    type: "tooltip"
  });
}
function MD(s, t) {
  const e = t && t.dataset && t.dataset.tooltip && t.dataset.tooltip.callbacks;
  return e ? s.override(e) : s;
}
const CE = {
  beforeTitle: nr,
  title(s) {
    if (s.length > 0) {
      const t = s[0], e = t.chart.data.labels, a = e ? e.length : 0;
      if (this && this.options && this.options.mode === "dataset")
        return t.dataset.label || "";
      if (t.label)
        return t.label;
      if (a > 0 && t.dataIndex < a)
        return e[t.dataIndex];
    }
    return "";
  },
  afterTitle: nr,
  beforeBody: nr,
  beforeLabel: nr,
  label(s) {
    if (this && this.options && this.options.mode === "dataset")
      return s.label + ": " + s.formattedValue || s.formattedValue;
    let t = s.dataset.label || "";
    t && (t += ": ");
    const e = s.formattedValue;
    return ua(e) || (t += e), t;
  },
  labelColor(s) {
    const e = s.chart.getDatasetMeta(s.datasetIndex).controller.getStyle(s.dataIndex);
    return {
      borderColor: e.borderColor,
      backgroundColor: e.backgroundColor,
      borderWidth: e.borderWidth,
      borderDash: e.borderDash,
      borderDashOffset: e.borderDashOffset,
      borderRadius: 0
    };
  },
  labelTextColor() {
    return this.options.bodyColor;
  },
  labelPointStyle(s) {
    const e = s.chart.getDatasetMeta(s.datasetIndex).controller.getStyle(s.dataIndex);
    return {
      pointStyle: e.pointStyle,
      rotation: e.rotation
    };
  },
  afterLabel: nr,
  afterBody: nr,
  beforeFooter: nr,
  footer: nr,
  afterFooter: nr
};
function hs(s, t, e, a) {
  const n = s[t].call(e, a);
  return typeof n > "u" ? CE[t].call(e, a) : n;
}
var bv;
let XD = (bv = class extends cs {
  constructor(t) {
    super(), this.opacity = 0, this._active = [], this._eventPosition = void 0, this._size = void 0, this._cachedAnimations = void 0, this._tooltipItems = [], this.$animations = void 0, this.$context = void 0, this.chart = t.chart, this.options = t.options, this.dataPoints = void 0, this.title = void 0, this.beforeBody = void 0, this.body = void 0, this.afterBody = void 0, this.footer = void 0, this.xAlign = void 0, this.yAlign = void 0, this.x = void 0, this.y = void 0, this.height = void 0, this.width = void 0, this.caretX = void 0, this.caretY = void 0, this.labelColors = void 0, this.labelPointStyles = void 0, this.labelTextColors = void 0;
  }
  initialize(t) {
    this.options = t, this._cachedAnimations = void 0, this.$context = void 0;
  }
  _resolveAnimations() {
    const t = this._cachedAnimations;
    if (t)
      return t;
    const e = this.chart, a = this.options.setContext(this.getContext()), n = a.enabled && e.options.animation && a.animations, i = new Jw(this.chart, n);
    return n._cacheable && (this._cachedAnimations = Object.freeze(i)), i;
  }
  getContext() {
    return this.$context || (this.$context = YB(this.chart.getContext(), this, this._tooltipItems));
  }
  getTitle(t, e) {
    const { callbacks: a } = e, n = hs(a, "beforeTitle", this, t), i = hs(a, "title", this, t), r = hs(a, "afterTitle", this, t);
    let l = [];
    return l = Di(l, lr(n)), l = Di(l, lr(i)), l = Di(l, lr(r)), l;
  }
  getBeforeBody(t, e) {
    return OD(hs(e.callbacks, "beforeBody", this, t));
  }
  getBody(t, e) {
    const { callbacks: a } = e, n = [];
    return ka(t, (i) => {
      const r = {
        before: [],
        lines: [],
        after: []
      }, l = MD(a, i);
      Di(r.before, lr(hs(l, "beforeLabel", this, i))), Di(r.lines, hs(l, "label", this, i)), Di(r.after, lr(hs(l, "afterLabel", this, i))), n.push(r);
    }), n;
  }
  getAfterBody(t, e) {
    return OD(hs(e.callbacks, "afterBody", this, t));
  }
  getFooter(t, e) {
    const { callbacks: a } = e, n = hs(a, "beforeFooter", this, t), i = hs(a, "footer", this, t), r = hs(a, "afterFooter", this, t);
    let l = [];
    return l = Di(l, lr(n)), l = Di(l, lr(i)), l = Di(l, lr(r)), l;
  }
  _createItems(t) {
    const e = this._active, a = this.chart.data, n = [], i = [], r = [];
    let l = [], o, c;
    for (o = 0, c = e.length; o < c; ++o)
      l.push(DB(this.chart, e[o]));
    return t.filter && (l = l.filter((d, p, h) => t.filter(d, p, h, a))), t.itemSort && (l = l.sort((d, p) => t.itemSort(d, p, a))), ka(l, (d) => {
      const p = MD(t.callbacks, d);
      n.push(hs(p, "labelColor", this, d)), i.push(hs(p, "labelPointStyle", this, d)), r.push(hs(p, "labelTextColor", this, d));
    }), this.labelColors = n, this.labelPointStyles = i, this.labelTextColors = r, this.dataPoints = l, l;
  }
  update(t, e) {
    const a = this.options.setContext(this.getContext()), n = this._active;
    let i, r = [];
    if (!n.length)
      this.opacity !== 0 && (i = {
        opacity: 0
      });
    else {
      const l = Rd[a.position].call(this, n, this._eventPosition);
      r = this._createItems(a), this.title = this.getTitle(r, a), this.beforeBody = this.getBeforeBody(r, a), this.body = this.getBody(r, a), this.afterBody = this.getAfterBody(r, a), this.footer = this.getFooter(r, a);
      const o = this._size = RD(this, a), c = Object.assign({}, l, o), d = YD(this.chart, a, c), p = _D(a, c, d, this.chart);
      this.xAlign = d.xAlign, this.yAlign = d.yAlign, i = {
        opacity: 1,
        x: p.x,
        y: p.y,
        width: o.width,
        height: o.height,
        caretX: l.x,
        caretY: l.y
      };
    }
    this._tooltipItems = r, this.$context = void 0, i && this._resolveAnimations().update(this, i), t && a.external && a.external.call(this, {
      chart: this.chart,
      tooltip: this,
      replay: e
    });
  }
  drawCaret(t, e, a, n) {
    const i = this.getCaretPosition(t, a, n);
    e.lineTo(i.x1, i.y1), e.lineTo(i.x2, i.y2), e.lineTo(i.x3, i.y3);
  }
  getCaretPosition(t, e, a) {
    const { xAlign: n, yAlign: i } = this, { caretSize: r, cornerRadius: l } = a, { topLeft: o, topRight: c, bottomLeft: d, bottomRight: p } = Kr(l), { x: h, y: g } = t, { width: x, height: b } = e;
    let A, T, R, C, v, P;
    return i === "center" ? (v = g + b / 2, n === "left" ? (A = h, T = A - r, C = v + r, P = v - r) : (A = h + x, T = A + r, C = v - r, P = v + r), R = A) : (n === "left" ? T = h + Math.max(o, d) + r : n === "right" ? T = h + x - Math.max(c, p) - r : T = this.caretX, i === "top" ? (C = g, v = C - r, A = T - r, R = T + r) : (C = g + b, v = C + r, A = T + r, R = T - r), P = C), {
      x1: A,
      x2: T,
      x3: R,
      y1: C,
      y2: v,
      y3: P
    };
  }
  drawTitle(t, e, a) {
    const n = this.title, i = n.length;
    let r, l, o;
    if (i) {
      const c = mc(a.rtl, this.x, this.width);
      for (t.x = wh(this, a.titleAlign, a), e.textAlign = c.textAlign(a.titleAlign), e.textBaseline = "middle", r = an(a.titleFont), l = a.titleSpacing, e.fillStyle = a.titleColor, e.font = r.string, o = 0; o < i; ++o)
        e.fillText(n[o], c.x(t.x), t.y + r.lineHeight / 2), t.y += r.lineHeight + l, o + 1 === i && (t.y += a.titleMarginBottom - l);
    }
  }
  _drawColorBox(t, e, a, n, i) {
    const r = this.labelColors[a], l = this.labelPointStyles[a], { boxHeight: o, boxWidth: c } = i, d = an(i.bodyFont), p = wh(this, "left", i), h = n.x(p), g = o < d.lineHeight ? (d.lineHeight - o) / 2 : 0, x = e.y + g;
    if (i.usePointStyle) {
      const b = {
        radius: Math.min(c, o) / 2,
        pointStyle: l.pointStyle,
        rotation: l.rotation,
        borderWidth: 1
      }, A = n.leftForLtr(h, c) + c / 2, T = x + o / 2;
      t.strokeStyle = i.multiKeyBackground, t.fillStyle = i.multiKeyBackground, gx(t, b, A, T), t.strokeStyle = r.borderColor, t.fillStyle = r.backgroundColor, gx(t, b, A, T);
    } else {
      t.lineWidth = Ve(r.borderWidth) ? Math.max(...Object.values(r.borderWidth)) : r.borderWidth || 1, t.strokeStyle = r.borderColor, t.setLineDash(r.borderDash || []), t.lineDashOffset = r.borderDashOffset || 0;
      const b = n.leftForLtr(h, c), A = n.leftForLtr(n.xPlus(h, 1), c - 2), T = Kr(r.borderRadius);
      Object.values(T).some((R) => R !== 0) ? (t.beginPath(), t.fillStyle = i.multiKeyBackground, xc(t, {
        x: b,
        y: x,
        w: c,
        h: o,
        radius: T
      }), t.fill(), t.stroke(), t.fillStyle = r.backgroundColor, t.beginPath(), xc(t, {
        x: A,
        y: x + 1,
        w: c - 2,
        h: o - 2,
        radius: T
      }), t.fill()) : (t.fillStyle = i.multiKeyBackground, t.fillRect(b, x, c, o), t.strokeRect(b, x, c, o), t.fillStyle = r.backgroundColor, t.fillRect(A, x + 1, c - 2, o - 2));
    }
    t.fillStyle = this.labelTextColors[a];
  }
  drawBody(t, e, a) {
    const { body: n } = this, { bodySpacing: i, bodyAlign: r, displayColors: l, boxHeight: o, boxWidth: c, boxPadding: d } = a, p = an(a.bodyFont);
    let h = p.lineHeight, g = 0;
    const x = mc(a.rtl, this.x, this.width), b = function(H) {
      e.fillText(H, x.x(t.x + g), t.y + h / 2), t.y += h + i;
    }, A = x.textAlign(r);
    let T, R, C, v, P, O, N;
    for (e.textAlign = r, e.textBaseline = "middle", e.font = p.string, t.x = wh(this, A, a), e.fillStyle = a.bodyColor, ka(this.beforeBody, b), g = l && A !== "right" ? r === "center" ? c / 2 + d : c + 2 + d : 0, v = 0, O = n.length; v < O; ++v) {
      for (T = n[v], R = this.labelTextColors[v], e.fillStyle = R, ka(T.before, b), C = T.lines, l && C.length && (this._drawColorBox(e, t, v, x, a), h = Math.max(p.lineHeight, o)), P = 0, N = C.length; P < N; ++P)
        b(C[P]), h = p.lineHeight;
      ka(T.after, b);
    }
    g = 0, h = p.lineHeight, ka(this.afterBody, b), t.y -= i;
  }
  drawFooter(t, e, a) {
    const n = this.footer, i = n.length;
    let r, l;
    if (i) {
      const o = mc(a.rtl, this.x, this.width);
      for (t.x = wh(this, a.footerAlign, a), t.y += a.footerMarginTop, e.textAlign = o.textAlign(a.footerAlign), e.textBaseline = "middle", r = an(a.footerFont), e.fillStyle = a.footerColor, e.font = r.string, l = 0; l < i; ++l)
        e.fillText(n[l], o.x(t.x), t.y + r.lineHeight / 2), t.y += r.lineHeight + a.footerSpacing;
    }
  }
  drawBackground(t, e, a, n) {
    const { xAlign: i, yAlign: r } = this, { x: l, y: o } = t, { width: c, height: d } = a, { topLeft: p, topRight: h, bottomLeft: g, bottomRight: x } = Kr(n.cornerRadius);
    e.fillStyle = n.backgroundColor, e.strokeStyle = n.borderColor, e.lineWidth = n.borderWidth, e.beginPath(), e.moveTo(l + p, o), r === "top" && this.drawCaret(t, e, a, n), e.lineTo(l + c - h, o), e.quadraticCurveTo(l + c, o, l + c, o + h), r === "center" && i === "right" && this.drawCaret(t, e, a, n), e.lineTo(l + c, o + d - x), e.quadraticCurveTo(l + c, o + d, l + c - x, o + d), r === "bottom" && this.drawCaret(t, e, a, n), e.lineTo(l + g, o + d), e.quadraticCurveTo(l, o + d, l, o + d - g), r === "center" && i === "left" && this.drawCaret(t, e, a, n), e.lineTo(l, o + p), e.quadraticCurveTo(l, o, l + p, o), e.closePath(), e.fill(), n.borderWidth > 0 && e.stroke();
  }
  _updateAnimationTarget(t) {
    const e = this.chart, a = this.$animations, n = a && a.x, i = a && a.y;
    if (n || i) {
      const r = Rd[t.position].call(this, this._active, this._eventPosition);
      if (!r)
        return;
      const l = this._size = RD(this, t), o = Object.assign({}, r, this._size), c = YD(e, t, o), d = _D(t, o, c, e);
      (n._to !== d.x || i._to !== d.y) && (this.xAlign = c.xAlign, this.yAlign = c.yAlign, this.width = l.width, this.height = l.height, this.caretX = r.x, this.caretY = r.y, this._resolveAnimations().update(this, d));
    }
  }
  _willRender() {
    return !!this.opacity;
  }
  draw(t) {
    const e = this.options.setContext(this.getContext());
    let a = this.opacity;
    if (!a)
      return;
    this._updateAnimationTarget(e);
    const n = {
      width: this.width,
      height: this.height
    }, i = {
      x: this.x,
      y: this.y
    };
    a = Math.abs(a) < 1e-3 ? 0 : a;
    const r = vn(e.padding), l = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
    e.enabled && l && (t.save(), t.globalAlpha = a, this.drawBackground(i, t, n, e), JP(t, e.textDirection), i.y += r.top, this.drawTitle(i, t, e), this.drawBody(i, t, e), this.drawFooter(i, t, e), QP(t, e.textDirection), t.restore());
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(t, e) {
    const a = this._active, n = t.map(({ datasetIndex: l, index: o }) => {
      const c = this.chart.getDatasetMeta(l);
      if (!c)
        throw new Error("Cannot find a dataset at index " + l);
      return {
        datasetIndex: l,
        element: c.data[o],
        index: o
      };
    }), i = !gm(a, n), r = this._positionChanged(n, e);
    (i || r) && (this._active = n, this._eventPosition = e, this._ignoreReplayEvents = !0, this.update(!0));
  }
  handleEvent(t, e, a = !0) {
    if (e && this._ignoreReplayEvents)
      return !1;
    this._ignoreReplayEvents = !1;
    const n = this.options, i = this._active || [], r = this._getActiveElements(t, i, e, a), l = this._positionChanged(r, t), o = e || !gm(r, i) || l;
    return o && (this._active = r, (n.enabled || n.external) && (this._eventPosition = {
      x: t.x,
      y: t.y
    }, this.update(!0, e))), o;
  }
  _getActiveElements(t, e, a, n) {
    const i = this.options;
    if (t.type === "mouseout")
      return [];
    if (!n)
      return e.filter((l) => this.chart.data.datasets[l.datasetIndex] && this.chart.getDatasetMeta(l.datasetIndex).controller.getParsed(l.index) !== void 0);
    const r = this.chart.getElementsAtEventForMode(t, i.mode, i, a);
    return i.reverse && r.reverse(), r;
  }
  _positionChanged(t, e) {
    const { caretX: a, caretY: n, options: i } = this, r = Rd[i.position].call(this, t, e);
    return r !== !1 && (a !== r.x || n !== r.y);
  }
}, Jt(bv, "positioners", Rd), bv);
var _B = {
  id: "tooltip",
  _element: XD,
  positioners: Rd,
  afterInit(s, t, e) {
    e && (s.tooltip = new XD({
      chart: s,
      options: e
    }));
  },
  beforeUpdate(s, t, e) {
    s.tooltip && s.tooltip.initialize(e);
  },
  reset(s, t, e) {
    s.tooltip && s.tooltip.initialize(e);
  },
  afterDraw(s) {
    const t = s.tooltip;
    if (t && t._willRender()) {
      const e = {
        tooltip: t
      };
      if (s.notifyPlugins("beforeTooltipDraw", {
        ...e,
        cancelable: !0
      }) === !1)
        return;
      t.draw(s.ctx), s.notifyPlugins("afterTooltipDraw", e);
    }
  },
  afterEvent(s, t) {
    if (s.tooltip) {
      const e = t.replay;
      s.tooltip.handleEvent(t.event, e, t.inChartArea) && (t.changed = !0);
    }
  },
  defaults: {
    enabled: !0,
    external: null,
    position: "average",
    backgroundColor: "rgba(0,0,0,0.8)",
    titleColor: "#fff",
    titleFont: {
      weight: "bold"
    },
    titleSpacing: 2,
    titleMarginBottom: 6,
    titleAlign: "left",
    bodyColor: "#fff",
    bodySpacing: 2,
    bodyFont: {},
    bodyAlign: "left",
    footerColor: "#fff",
    footerSpacing: 2,
    footerMarginTop: 6,
    footerFont: {
      weight: "bold"
    },
    footerAlign: "left",
    padding: 6,
    caretPadding: 2,
    caretSize: 5,
    cornerRadius: 6,
    boxHeight: (s, t) => t.bodyFont.size,
    boxWidth: (s, t) => t.bodyFont.size,
    multiKeyBackground: "#fff",
    displayColors: !0,
    boxPadding: 0,
    borderColor: "rgba(0,0,0,0)",
    borderWidth: 0,
    animation: {
      duration: 400,
      easing: "easeOutQuart"
    },
    animations: {
      numbers: {
        type: "number",
        properties: [
          "x",
          "y",
          "width",
          "height",
          "caretX",
          "caretY"
        ]
      },
      opacity: {
        easing: "linear",
        duration: 200
      }
    },
    callbacks: CE
  },
  defaultRoutes: {
    bodyFont: "font",
    footerFont: "font",
    titleFont: "font"
  },
  descriptors: {
    _scriptable: (s) => s !== "filter" && s !== "itemSort" && s !== "external",
    _indexable: !1,
    callbacks: {
      _scriptable: !1,
      _indexable: !1
    },
    animation: {
      _fallback: !1
    },
    animations: {
      _fallback: "animation"
    }
  },
  additionalOptionScopes: [
    "interaction"
  ]
}, OB = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  Colors: qz,
  Decimation: Zz,
  Filler: vB,
  Legend: SB,
  SubTitle: LB,
  Title: TB,
  Tooltip: _B
});
const MB = (s, t, e, a) => (typeof t == "string" ? (e = s.push(t) - 1, a.unshift({
  index: e,
  label: t
})) : isNaN(t) && (e = null), e);
function XB(s, t, e, a) {
  const n = s.indexOf(t);
  if (n === -1)
    return MB(s, t, e, a);
  const i = s.lastIndexOf(t);
  return n !== i ? e : n;
}
const GB = (s, t) => s === null ? null : Yn(Math.round(s), 0, t);
function GD(s) {
  const t = this.getLabels();
  return s >= 0 && s < t.length ? t[s] : s;
}
class Ax extends lo {
  constructor(t) {
    super(t), this._startValue = void 0, this._valueRange = 0, this._addedLabels = [];
  }
  init(t) {
    const e = this._addedLabels;
    if (e.length) {
      const a = this.getLabels();
      for (const { index: n, label: i } of e)
        a[n] === i && a.splice(n, 1);
      this._addedLabels = [];
    }
    super.init(t);
  }
  parse(t, e) {
    if (ua(t))
      return null;
    const a = this.getLabels();
    return e = isFinite(e) && a[e] === t ? e : XB(a, t, Fe(e, t), this._addedLabels), GB(e, a.length - 1);
  }
  determineDataLimits() {
    const { minDefined: t, maxDefined: e } = this.getUserBounds();
    let { min: a, max: n } = this.getMinMax(!0);
    this.options.bounds === "ticks" && (t || (a = 0), e || (n = this.getLabels().length - 1)), this.min = a, this.max = n;
  }
  buildTicks() {
    const t = this.min, e = this.max, a = this.options.offset, n = [];
    let i = this.getLabels();
    i = t === 0 && e === i.length - 1 ? i : i.slice(t, e + 1), this._valueRange = Math.max(i.length - (a ? 0 : 1), 1), this._startValue = this.min - (a ? 0.5 : 0);
    for (let r = t; r <= e; r++)
      n.push({
        value: r
      });
    return n;
  }
  getLabelForValue(t) {
    return GD.call(this, t);
  }
  configure() {
    super.configure(), this.isHorizontal() || (this._reversePixels = !this._reversePixels);
  }
  getPixelForValue(t) {
    return typeof t != "number" && (t = this.parse(t)), t === null ? NaN : this.getPixelForDecimal((t - this._startValue) / this._valueRange);
  }
  getPixelForTick(t) {
    const e = this.ticks;
    return t < 0 || t > e.length - 1 ? null : this.getPixelForValue(e[t].value);
  }
  getValueForPixel(t) {
    return Math.round(this._startValue + this.getDecimalForPixel(t) * this._valueRange);
  }
  getBasePixel() {
    return this.bottom;
  }
}
Jt(Ax, "id", "category"), Jt(Ax, "defaults", {
  ticks: {
    callback: GD
  }
});
function HB(s, t) {
  const e = [], { bounds: n, step: i, min: r, max: l, precision: o, count: c, maxTicks: d, maxDigits: p, includeBounds: h } = s, g = i || 1, x = d - 1, { min: b, max: A } = t, T = !ua(r), R = !ua(l), C = !ua(c), v = (A - b) / (p + 1);
  let P = N1((A - b) / x / g) * g, O, N, H, F;
  if (P < 1e-14 && !T && !R)
    return [
      {
        value: b
      },
      {
        value: A
      }
    ];
  F = Math.ceil(A / P) - Math.floor(b / P), F > x && (P = N1(F * P / x / g) * g), ua(o) || (O = Math.pow(10, o), P = Math.ceil(P * O) / O), n === "ticks" ? (N = Math.floor(b / P) * P, H = Math.ceil(A / P) * P) : (N = b, H = A), T && R && i && _2((l - r) / i, P / 1e3) ? (F = Math.round(Math.min((l - r) / P, d)), P = (l - r) / F, N = r, H = l) : C ? (N = T ? r : N, H = R ? l : H, F = c - 1, P = (H - N) / F) : (F = (H - N) / P, Bd(F, Math.round(F), P / 1e3) ? F = Math.round(F) : F = Math.ceil(F));
  const B = Math.max(R1(P), R1(N));
  O = Math.pow(10, ua(o) ? B : o), N = Math.round(N * O) / O, H = Math.round(H * O) / O;
  let Q = 0;
  for (T && (h && N !== r ? (e.push({
    value: r
  }), N < r && Q++, Bd(Math.round((N + Q * P) * O) / O, r, HD(r, v, s)) && Q++) : N < r && Q++); Q < F; ++Q) {
    const it = Math.round((N + Q * P) * O) / O;
    if (R && it > l)
      break;
    e.push({
      value: it
    });
  }
  return R && h && H !== l ? e.length && Bd(e[e.length - 1].value, l, HD(l, v, s)) ? e[e.length - 1].value = l : e.push({
    value: l
  }) : (!R || H === l) && e.push({
    value: H
  }), e;
}
function HD(s, t, { horizontal: e, minRotation: a }) {
  const n = bn(a), i = (e ? Math.sin(n) : Math.cos(n)) || 1e-3, r = 0.75 * t * ("" + s).length;
  return Math.min(t / i, r);
}
class Cm extends lo {
  constructor(t) {
    super(t), this.start = void 0, this.end = void 0, this._startValue = void 0, this._endValue = void 0, this._valueRange = 0;
  }
  parse(t, e) {
    return ua(t) || (typeof t == "number" || t instanceof Number) && !isFinite(+t) ? null : +t;
  }
  handleTickRangeOptions() {
    const { beginAtZero: t } = this.options, { minDefined: e, maxDefined: a } = this.getUserBounds();
    let { min: n, max: i } = this;
    const r = (o) => n = e ? n : o, l = (o) => i = a ? i : o;
    if (t) {
      const o = Ui(n), c = Ui(i);
      o < 0 && c < 0 ? l(0) : o > 0 && c > 0 && r(0);
    }
    if (n === i) {
      let o = i === 0 ? 1 : Math.abs(i * 0.05);
      l(i + o), t || r(n - o);
    }
    this.min = n, this.max = i;
  }
  getTickLimit() {
    const t = this.options.ticks;
    let { maxTicksLimit: e, stepSize: a } = t, n;
    return a ? (n = Math.ceil(this.max / a) - Math.floor(this.min / a) + 1, n > 1e3 && (console.warn(`scales.${this.id}.ticks.stepSize: ${a} would result generating up to ${n} ticks. Limiting to 1000.`), n = 1e3)) : (n = this.computeTickLimit(), e = e || 11), e && (n = Math.min(e, n)), n;
  }
  computeTickLimit() {
    return Number.POSITIVE_INFINITY;
  }
  buildTicks() {
    const t = this.options, e = t.ticks;
    let a = this.getTickLimit();
    a = Math.max(2, a);
    const n = {
      maxTicks: a,
      bounds: t.bounds,
      min: t.min,
      max: t.max,
      precision: e.precision,
      step: e.stepSize,
      count: e.count,
      maxDigits: this._maxDigits(),
      horizontal: this.isHorizontal(),
      minRotation: e.minRotation || 0,
      includeBounds: e.includeBounds !== !1
    }, i = this._range || this, r = HB(n, i);
    return t.bounds === "ticks" && RP(r, this, "value"), t.reverse ? (r.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), r;
  }
  configure() {
    const t = this.ticks;
    let e = this.min, a = this.max;
    if (super.configure(), this.options.offset && t.length) {
      const n = (a - e) / Math.max(t.length - 1, 1) / 2;
      e -= n, a += n;
    }
    this._startValue = e, this._endValue = a, this._valueRange = a - e;
  }
  getLabelForValue(t) {
    return Bu(t, this.chart.options.locale, this.options.ticks.format);
  }
}
class Cx extends Cm {
  determineDataLimits() {
    const { min: t, max: e } = this.getMinMax(!0);
    this.min = Va(t) ? t : 0, this.max = Va(e) ? e : 1, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    const t = this.isHorizontal(), e = t ? this.width : this.height, a = bn(this.options.ticks.minRotation), n = (t ? Math.sin(a) : Math.cos(a)) || 1e-3, i = this._resolveTickFontOptions(0);
    return Math.ceil(e / Math.min(40, i.lineHeight / n));
  }
  getPixelForValue(t) {
    return t === null ? NaN : this.getPixelForDecimal((t - this._startValue) / this._valueRange);
  }
  getValueForPixel(t) {
    return this._startValue + this.getDecimalForPixel(t) * this._valueRange;
  }
}
Jt(Cx, "id", "linear"), Jt(Cx, "defaults", {
  ticks: {
    callback: rf.formatters.numeric
  }
});
const pu = (s) => Math.floor(Hr(s)), Tl = (s, t) => Math.pow(10, pu(s) + t);
function UD(s) {
  return s / Math.pow(10, pu(s)) === 1;
}
function FD(s, t, e) {
  const a = Math.pow(10, e), n = Math.floor(s / a);
  return Math.ceil(t / a) - n;
}
function UB(s, t) {
  const e = t - s;
  let a = pu(e);
  for (; FD(s, t, a) > 10; )
    a++;
  for (; FD(s, t, a) < 10; )
    a--;
  return Math.min(a, pu(s));
}
function FB(s, { min: t, max: e }) {
  t = Ds(s.min, t);
  const a = [], n = pu(t);
  let i = UB(t, e), r = i < 0 ? Math.pow(10, Math.abs(i)) : 1;
  const l = Math.pow(10, i), o = n > i ? Math.pow(10, n) : 0, c = Math.round((t - o) * r) / r, d = Math.floor((t - o) / l / 10) * l * 10;
  let p = Math.floor((c - d) / Math.pow(10, i)), h = Ds(s.min, Math.round((o + d + p * Math.pow(10, i)) * r) / r);
  for (; h < e; )
    a.push({
      value: h,
      major: UD(h),
      significand: p
    }), p >= 10 ? p = p < 15 ? 15 : 20 : p++, p >= 20 && (i++, p = 2, r = i >= 0 ? 1 : r), h = Math.round((o + d + p * Math.pow(10, i)) * r) / r;
  const g = Ds(s.max, h);
  return a.push({
    value: g,
    major: UD(g),
    significand: p
  }), a;
}
class $x extends lo {
  constructor(t) {
    super(t), this.start = void 0, this.end = void 0, this._startValue = void 0, this._valueRange = 0;
  }
  parse(t, e) {
    const a = Cm.prototype.parse.apply(this, [
      t,
      e
    ]);
    if (a === 0) {
      this._zero = !0;
      return;
    }
    return Va(a) && a > 0 ? a : null;
  }
  determineDataLimits() {
    const { min: t, max: e } = this.getMinMax(!0);
    this.min = Va(t) ? Math.max(0, t) : null, this.max = Va(e) ? Math.max(0, e) : null, this.options.beginAtZero && (this._zero = !0), this._zero && this.min !== this._suggestedMin && !Va(this._userMin) && (this.min = t === Tl(this.min, 0) ? Tl(this.min, -1) : Tl(this.min, 0)), this.handleTickRangeOptions();
  }
  handleTickRangeOptions() {
    const { minDefined: t, maxDefined: e } = this.getUserBounds();
    let a = this.min, n = this.max;
    const i = (l) => a = t ? a : l, r = (l) => n = e ? n : l;
    a === n && (a <= 0 ? (i(1), r(10)) : (i(Tl(a, -1)), r(Tl(n, 1)))), a <= 0 && i(Tl(n, -1)), n <= 0 && r(Tl(a, 1)), this.min = a, this.max = n;
  }
  buildTicks() {
    const t = this.options, e = {
      min: this._userMin,
      max: this._userMax
    }, a = FB(e, this);
    return t.bounds === "ticks" && RP(a, this, "value"), t.reverse ? (a.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), a;
  }
  getLabelForValue(t) {
    return t === void 0 ? "0" : Bu(t, this.chart.options.locale, this.options.ticks.format);
  }
  configure() {
    const t = this.min;
    super.configure(), this._startValue = Hr(t), this._valueRange = Hr(this.max) - Hr(t);
  }
  getPixelForValue(t) {
    return (t === void 0 || t === 0) && (t = this.min), t === null || isNaN(t) ? NaN : this.getPixelForDecimal(t === this.min ? 0 : (Hr(t) - this._startValue) / this._valueRange);
  }
  getValueForPixel(t) {
    const e = this.getDecimalForPixel(t);
    return Math.pow(10, this._startValue + e * this._valueRange);
  }
}
Jt($x, "id", "logarithmic"), Jt($x, "defaults", {
  ticks: {
    callback: rf.formatters.logarithmic,
    major: {
      enabled: !0
    }
  }
});
function Sx(s) {
  const t = s.ticks;
  if (t.display && s.display) {
    const e = vn(t.backdropPadding);
    return Fe(t.font && t.font.size, en.font.size) + e.height;
  }
  return 0;
}
function zB(s, t, e) {
  return e = ya(e) ? e : [
    e
  ], {
    w: Z2(s, t.string, e),
    h: e.length * t.lineHeight
  };
}
function zD(s, t, e, a, n) {
  return s === a || s === n ? {
    start: t - e / 2,
    end: t + e / 2
  } : s < a || s > n ? {
    start: t - e,
    end: t
  } : {
    start: t,
    end: t + e
  };
}
function BB(s) {
  const t = {
    l: s.left + s._padding.left,
    r: s.right - s._padding.right,
    t: s.top + s._padding.top,
    b: s.bottom - s._padding.bottom
  }, e = Object.assign({}, t), a = [], n = [], i = s._pointLabels.length, r = s.options.pointLabels, l = r.centerPointLabels ? ra / i : 0;
  for (let o = 0; o < i; o++) {
    const c = r.setContext(s.getPointLabelContext(o));
    n[o] = c.padding;
    const d = s.getPointPosition(o, s.drawingArea + n[o], l), p = an(c.font), h = zB(s.ctx, p, s._pointLabels[o]);
    a[o] = h;
    const g = Ps(s.getIndexAngle(o) + l), x = Math.round(sf(g)), b = zD(x, d.x, h.w, 0, 180), A = zD(x, d.y, h.h, 90, 270);
    WB(e, t, g, b, A);
  }
  s.setCenterPoint(t.l - e.l, e.r - t.r, t.t - e.t, e.b - t.b), s._pointLabelItems = qB(s, a, n);
}
function WB(s, t, e, a, n) {
  const i = Math.abs(Math.sin(e)), r = Math.abs(Math.cos(e));
  let l = 0, o = 0;
  a.start < t.l ? (l = (t.l - a.start) / i, s.l = Math.min(s.l, t.l - l)) : a.end > t.r && (l = (a.end - t.r) / i, s.r = Math.max(s.r, t.r + l)), n.start < t.t ? (o = (t.t - n.start) / r, s.t = Math.min(s.t, t.t - o)) : n.end > t.b && (o = (n.end - t.b) / r, s.b = Math.max(s.b, t.b + o));
}
function jB(s, t, e) {
  const a = s.drawingArea, { extra: n, additionalAngle: i, padding: r, size: l } = e, o = s.getPointPosition(t, a + n + r, i), c = Math.round(sf(Ps(o.angle + Fa))), d = QB(o.y, l.h, c), p = KB(c), h = JB(o.x, l.w, p);
  return {
    visible: !0,
    x: o.x,
    y: d,
    textAlign: p,
    left: h,
    top: d,
    right: h + l.w,
    bottom: d + l.h
  };
}
function VB(s, t) {
  if (!t)
    return !0;
  const { left: e, top: a, right: n, bottom: i } = s;
  return !(mr({
    x: e,
    y: a
  }, t) || mr({
    x: e,
    y: i
  }, t) || mr({
    x: n,
    y: a
  }, t) || mr({
    x: n,
    y: i
  }, t));
}
function qB(s, t, e) {
  const a = [], n = s._pointLabels.length, i = s.options, { centerPointLabels: r, display: l } = i.pointLabels, o = {
    extra: Sx(i) / 2,
    additionalAngle: r ? ra / n : 0
  };
  let c;
  for (let d = 0; d < n; d++) {
    o.padding = e[d], o.size = t[d];
    const p = jB(s, d, o);
    a.push(p), l === "auto" && (p.visible = VB(p, c), p.visible && (c = p));
  }
  return a;
}
function KB(s) {
  return s === 0 || s === 180 ? "center" : s < 180 ? "left" : "right";
}
function JB(s, t, e) {
  return e === "right" ? s -= t : e === "center" && (s -= t / 2), s;
}
function QB(s, t, e) {
  return e === 90 || e === 270 ? s -= t / 2 : (e > 270 || e < 90) && (s -= t), s;
}
function ZB(s, t, e) {
  const { left: a, top: n, right: i, bottom: r } = e, { backdropColor: l } = t;
  if (!ua(l)) {
    const o = Kr(t.borderRadius), c = vn(t.backdropPadding);
    s.fillStyle = l;
    const d = a - c.left, p = n - c.top, h = i - a + c.width, g = r - n + c.height;
    Object.values(o).some((x) => x !== 0) ? (s.beginPath(), xc(s, {
      x: d,
      y: p,
      w: h,
      h: g,
      radius: o
    }), s.fill()) : s.fillRect(d, p, h, g);
  }
}
function tW(s, t) {
  const { ctx: e, options: { pointLabels: a } } = s;
  for (let n = t - 1; n >= 0; n--) {
    const i = s._pointLabelItems[n];
    if (!i.visible)
      continue;
    const r = a.setContext(s.getPointLabelContext(n));
    ZB(e, r, i);
    const l = an(r.font), { x: o, y: c, textAlign: d } = i;
    jl(e, s._pointLabels[n], o, c + l.lineHeight / 2, l, {
      color: r.color,
      textAlign: d,
      textBaseline: "middle"
    });
  }
}
function $E(s, t, e, a) {
  const { ctx: n } = s;
  if (e)
    n.arc(s.xCenter, s.yCenter, t, 0, Ga);
  else {
    let i = s.getPointPosition(0, t);
    n.moveTo(i.x, i.y);
    for (let r = 1; r < a; r++)
      i = s.getPointPosition(r, t), n.lineTo(i.x, i.y);
  }
}
function eW(s, t, e, a, n) {
  const i = s.ctx, r = t.circular, { color: l, lineWidth: o } = t;
  !r && !a || !l || !o || e < 0 || (i.save(), i.strokeStyle = l, i.lineWidth = o, i.setLineDash(n.dash), i.lineDashOffset = n.dashOffset, i.beginPath(), $E(s, e, r, a), i.closePath(), i.stroke(), i.restore());
}
function aW(s, t, e) {
  return cl(s, {
    label: e,
    index: t,
    type: "pointLabel"
  });
}
class Yd extends Cm {
  constructor(t) {
    super(t), this.xCenter = void 0, this.yCenter = void 0, this.drawingArea = void 0, this._pointLabels = [], this._pointLabelItems = [];
  }
  setDimensions() {
    const t = this._padding = vn(Sx(this.options) / 2), e = this.width = this.maxWidth - t.width, a = this.height = this.maxHeight - t.height;
    this.xCenter = Math.floor(this.left + e / 2 + t.left), this.yCenter = Math.floor(this.top + a / 2 + t.top), this.drawingArea = Math.floor(Math.min(e, a) / 2);
  }
  determineDataLimits() {
    const { min: t, max: e } = this.getMinMax(!1);
    this.min = Va(t) && !isNaN(t) ? t : 0, this.max = Va(e) && !isNaN(e) ? e : 0, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    return Math.ceil(this.drawingArea / Sx(this.options));
  }
  generateTickLabels(t) {
    Cm.prototype.generateTickLabels.call(this, t), this._pointLabels = this.getLabels().map((e, a) => {
      const n = Sa(this.options.pointLabels.callback, [
        e,
        a
      ], this);
      return n || n === 0 ? n : "";
    }).filter((e, a) => this.chart.getDataVisibility(a));
  }
  fit() {
    const t = this.options;
    t.display && t.pointLabels.display ? BB(this) : this.setCenterPoint(0, 0, 0, 0);
  }
  setCenterPoint(t, e, a, n) {
    this.xCenter += Math.floor((t - e) / 2), this.yCenter += Math.floor((a - n) / 2), this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(t, e, a, n));
  }
  getIndexAngle(t) {
    const e = Ga / (this._pointLabels.length || 1), a = this.options.startAngle || 0;
    return Ps(t * e + bn(a));
  }
  getDistanceFromCenterForValue(t) {
    if (ua(t))
      return NaN;
    const e = this.drawingArea / (this.max - this.min);
    return this.options.reverse ? (this.max - t) * e : (t - this.min) * e;
  }
  getValueForDistanceFromCenter(t) {
    if (ua(t))
      return NaN;
    const e = t / (this.drawingArea / (this.max - this.min));
    return this.options.reverse ? this.max - e : this.min + e;
  }
  getPointLabelContext(t) {
    const e = this._pointLabels || [];
    if (t >= 0 && t < e.length) {
      const a = e[t];
      return aW(this.getContext(), t, a);
    }
  }
  getPointPosition(t, e, a = 0) {
    const n = this.getIndexAngle(t) - Fa + a;
    return {
      x: Math.cos(n) * e + this.xCenter,
      y: Math.sin(n) * e + this.yCenter,
      angle: n
    };
  }
  getPointPositionForValue(t, e) {
    return this.getPointPosition(t, this.getDistanceFromCenterForValue(e));
  }
  getBasePosition(t) {
    return this.getPointPositionForValue(t || 0, this.getBaseValue());
  }
  getPointLabelPosition(t) {
    const { left: e, top: a, right: n, bottom: i } = this._pointLabelItems[t];
    return {
      left: e,
      top: a,
      right: n,
      bottom: i
    };
  }
  drawBackground() {
    const { backgroundColor: t, grid: { circular: e } } = this.options;
    if (t) {
      const a = this.ctx;
      a.save(), a.beginPath(), $E(this, this.getDistanceFromCenterForValue(this._endValue), e, this._pointLabels.length), a.closePath(), a.fillStyle = t, a.fill(), a.restore();
    }
  }
  drawGrid() {
    const t = this.ctx, e = this.options, { angleLines: a, grid: n, border: i } = e, r = this._pointLabels.length;
    let l, o, c;
    if (e.pointLabels.display && tW(this, r), n.display && this.ticks.forEach((d, p) => {
      if (p !== 0 || p === 0 && this.min < 0) {
        o = this.getDistanceFromCenterForValue(d.value);
        const h = this.getContext(p), g = n.setContext(h), x = i.setContext(h);
        eW(this, g, o, r, x);
      }
    }), a.display) {
      for (t.save(), l = r - 1; l >= 0; l--) {
        const d = a.setContext(this.getPointLabelContext(l)), { color: p, lineWidth: h } = d;
        !h || !p || (t.lineWidth = h, t.strokeStyle = p, t.setLineDash(d.borderDash), t.lineDashOffset = d.borderDashOffset, o = this.getDistanceFromCenterForValue(e.ticks.reverse ? this.min : this.max), c = this.getPointPosition(l, o), t.beginPath(), t.moveTo(this.xCenter, this.yCenter), t.lineTo(c.x, c.y), t.stroke());
      }
      t.restore();
    }
  }
  drawBorder() {
  }
  drawLabels() {
    const t = this.ctx, e = this.options, a = e.ticks;
    if (!a.display)
      return;
    const n = this.getIndexAngle(0);
    let i, r;
    t.save(), t.translate(this.xCenter, this.yCenter), t.rotate(n), t.textAlign = "center", t.textBaseline = "middle", this.ticks.forEach((l, o) => {
      if (o === 0 && this.min >= 0 && !e.reverse)
        return;
      const c = a.setContext(this.getContext(o)), d = an(c.font);
      if (i = this.getDistanceFromCenterForValue(this.ticks[o].value), c.showLabelBackdrop) {
        t.font = d.string, r = t.measureText(l.label).width, t.fillStyle = c.backdropColor;
        const p = vn(c.backdropPadding);
        t.fillRect(-r / 2 - p.left, -i - d.size / 2 - p.top, r + p.width, d.size + p.height);
      }
      jl(t, l.label, 0, -i, d, {
        color: c.color,
        strokeColor: c.textStrokeColor,
        strokeWidth: c.textStrokeWidth
      });
    }), t.restore();
  }
  drawTitle() {
  }
}
Jt(Yd, "id", "radialLinear"), Jt(Yd, "defaults", {
  display: !0,
  animate: !0,
  position: "chartArea",
  angleLines: {
    display: !0,
    lineWidth: 1,
    borderDash: [],
    borderDashOffset: 0
  },
  grid: {
    circular: !1
  },
  startAngle: 0,
  ticks: {
    showLabelBackdrop: !0,
    callback: rf.formatters.numeric
  },
  pointLabels: {
    backdropColor: void 0,
    backdropPadding: 2,
    display: !0,
    font: {
      size: 10
    },
    callback(t) {
      return t;
    },
    padding: 5,
    centerPointLabels: !1
  }
}), Jt(Yd, "defaultRoutes", {
  "angleLines.color": "borderColor",
  "pointLabels.color": "color",
  "ticks.color": "color"
}), Jt(Yd, "descriptors", {
  angleLines: {
    _fallback: "grid"
  }
});
const of = {
  millisecond: {
    common: !0,
    size: 1,
    steps: 1e3
  },
  second: {
    common: !0,
    size: 1e3,
    steps: 60
  },
  minute: {
    common: !0,
    size: 6e4,
    steps: 60
  },
  hour: {
    common: !0,
    size: 36e5,
    steps: 24
  },
  day: {
    common: !0,
    size: 864e5,
    steps: 30
  },
  week: {
    common: !1,
    size: 6048e5,
    steps: 4
  },
  month: {
    common: !0,
    size: 2628e6,
    steps: 12
  },
  quarter: {
    common: !1,
    size: 7884e6,
    steps: 4
  },
  year: {
    common: !0,
    size: 3154e7
  }
}, bs = /* @__PURE__ */ Object.keys(of);
function BD(s, t) {
  return s - t;
}
function WD(s, t) {
  if (ua(t))
    return null;
  const e = s._adapter, { parser: a, round: n, isoWeekday: i } = s._parseOpts;
  let r = t;
  return typeof a == "function" && (r = a(r)), Va(r) || (r = typeof a == "string" ? e.parse(r, a) : e.parse(r)), r === null ? null : (n && (r = n === "week" && (al(i) || i === !0) ? e.startOf(r, "isoWeek", i) : e.startOf(r, n)), +r);
}
function jD(s, t, e, a) {
  const n = bs.length;
  for (let i = bs.indexOf(s); i < n - 1; ++i) {
    const r = of[bs[i]], l = r.steps ? r.steps : Number.MAX_SAFE_INTEGER;
    if (r.common && Math.ceil((e - t) / (l * r.size)) <= a)
      return bs[i];
  }
  return bs[n - 1];
}
function nW(s, t, e, a, n) {
  for (let i = bs.length - 1; i >= bs.indexOf(e); i--) {
    const r = bs[i];
    if (of[r].common && s._adapter.diff(n, a, r) >= t - 1)
      return r;
  }
  return bs[e ? bs.indexOf(e) : 0];
}
function sW(s) {
  for (let t = bs.indexOf(s) + 1, e = bs.length; t < e; ++t)
    if (of[bs[t]].common)
      return bs[t];
}
function VD(s, t, e) {
  if (!e)
    s[t] = !0;
  else if (e.length) {
    const { lo: a, hi: n } = Uw(e, t), i = e[a] >= t ? e[a] : e[n];
    s[i] = !0;
  }
}
function iW(s, t, e, a) {
  const n = s._adapter, i = +n.startOf(t[0].value, a), r = t[t.length - 1].value;
  let l, o;
  for (l = i; l <= r; l = +n.add(l, 1, a))
    o = e[l], o >= 0 && (t[o].major = !0);
  return t;
}
function qD(s, t, e) {
  const a = [], n = {}, i = t.length;
  let r, l;
  for (r = 0; r < i; ++r)
    l = t[r], n[l] = r, a.push({
      value: l,
      major: !1
    });
  return i === 0 || !e ? a : iW(s, a, n, e);
}
class hu extends lo {
  constructor(t) {
    super(t), this._cache = {
      data: [],
      labels: [],
      all: []
    }, this._unit = "day", this._majorUnit = void 0, this._offsets = {}, this._normalized = !1, this._parseOpts = void 0;
  }
  init(t, e = {}) {
    const a = t.time || (t.time = {}), n = this._adapter = new sE._date(t.adapters.date);
    n.init(e), zd(a.displayFormats, n.formats()), this._parseOpts = {
      parser: a.parser,
      round: a.round,
      isoWeekday: a.isoWeekday
    }, super.init(t), this._normalized = e.normalized;
  }
  parse(t, e) {
    return t === void 0 ? null : WD(this, t);
  }
  beforeLayout() {
    super.beforeLayout(), this._cache = {
      data: [],
      labels: [],
      all: []
    };
  }
  determineDataLimits() {
    const t = this.options, e = this._adapter, a = t.time.unit || "day";
    let { min: n, max: i, minDefined: r, maxDefined: l } = this.getUserBounds();
    function o(c) {
      !r && !isNaN(c.min) && (n = Math.min(n, c.min)), !l && !isNaN(c.max) && (i = Math.max(i, c.max));
    }
    (!r || !l) && (o(this._getLabelBounds()), (t.bounds !== "ticks" || t.ticks.source !== "labels") && o(this.getMinMax(!1))), n = Va(n) && !isNaN(n) ? n : +e.startOf(Date.now(), a), i = Va(i) && !isNaN(i) ? i : +e.endOf(Date.now(), a) + 1, this.min = Math.min(n, i - 1), this.max = Math.max(n + 1, i);
  }
  _getLabelBounds() {
    const t = this.getLabelTimestamps();
    let e = Number.POSITIVE_INFINITY, a = Number.NEGATIVE_INFINITY;
    return t.length && (e = t[0], a = t[t.length - 1]), {
      min: e,
      max: a
    };
  }
  buildTicks() {
    const t = this.options, e = t.time, a = t.ticks, n = a.source === "labels" ? this.getLabelTimestamps() : this._generate();
    t.bounds === "ticks" && n.length && (this.min = this._userMin || n[0], this.max = this._userMax || n[n.length - 1]);
    const i = this.min, r = this.max, l = G2(n, i, r);
    return this._unit = e.unit || (a.autoSkip ? jD(e.minUnit, this.min, this.max, this._getLabelCapacity(i)) : nW(this, l.length, e.minUnit, this.min, this.max)), this._majorUnit = !a.major.enabled || this._unit === "year" ? void 0 : sW(this._unit), this.initOffsets(n), t.reverse && l.reverse(), qD(this, l, this._majorUnit);
  }
  afterAutoSkip() {
    this.options.offsetAfterAutoskip && this.initOffsets(this.ticks.map((t) => +t.value));
  }
  initOffsets(t = []) {
    let e = 0, a = 0, n, i;
    this.options.offset && t.length && (n = this.getDecimalForValue(t[0]), t.length === 1 ? e = 1 - n : e = (this.getDecimalForValue(t[1]) - n) / 2, i = this.getDecimalForValue(t[t.length - 1]), t.length === 1 ? a = i : a = (i - this.getDecimalForValue(t[t.length - 2])) / 2);
    const r = t.length < 3 ? 0.5 : 0.25;
    e = Yn(e, 0, r), a = Yn(a, 0, r), this._offsets = {
      start: e,
      end: a,
      factor: 1 / (e + 1 + a)
    };
  }
  _generate() {
    const t = this._adapter, e = this.min, a = this.max, n = this.options, i = n.time, r = i.unit || jD(i.minUnit, e, a, this._getLabelCapacity(e)), l = Fe(n.ticks.stepSize, 1), o = r === "week" ? i.isoWeekday : !1, c = al(o) || o === !0, d = {};
    let p = e, h, g;
    if (c && (p = +t.startOf(p, "isoWeek", o)), p = +t.startOf(p, c ? "day" : r), t.diff(a, e, r) > 1e5 * l)
      throw new Error(e + " and " + a + " are too far apart with stepSize of " + l + " " + r);
    const x = n.ticks.source === "data" && this.getDataTimestamps();
    for (h = p, g = 0; h < a; h = +t.add(h, l, r), g++)
      VD(d, h, x);
    return (h === a || n.bounds === "ticks" || g === 1) && VD(d, h, x), Object.keys(d).sort(BD).map((b) => +b);
  }
  getLabelForValue(t) {
    const e = this._adapter, a = this.options.time;
    return a.tooltipFormat ? e.format(t, a.tooltipFormat) : e.format(t, a.displayFormats.datetime);
  }
  format(t, e) {
    const n = this.options.time.displayFormats, i = this._unit, r = e || n[i];
    return this._adapter.format(t, r);
  }
  _tickFormatFunction(t, e, a, n) {
    const i = this.options, r = i.ticks.callback;
    if (r)
      return Sa(r, [
        t,
        e,
        a
      ], this);
    const l = i.time.displayFormats, o = this._unit, c = this._majorUnit, d = o && l[o], p = c && l[c], h = a[e], g = c && p && h && h.major;
    return this._adapter.format(t, n || (g ? p : d));
  }
  generateTickLabels(t) {
    let e, a, n;
    for (e = 0, a = t.length; e < a; ++e)
      n = t[e], n.label = this._tickFormatFunction(n.value, e, t);
  }
  getDecimalForValue(t) {
    return t === null ? NaN : (t - this.min) / (this.max - this.min);
  }
  getPixelForValue(t) {
    const e = this._offsets, a = this.getDecimalForValue(t);
    return this.getPixelForDecimal((e.start + a) * e.factor);
  }
  getValueForPixel(t) {
    const e = this._offsets, a = this.getDecimalForPixel(t) / e.factor - e.end;
    return this.min + a * (this.max - this.min);
  }
  _getLabelSize(t) {
    const e = this.options.ticks, a = this.ctx.measureText(t).width, n = bn(this.isHorizontal() ? e.maxRotation : e.minRotation), i = Math.cos(n), r = Math.sin(n), l = this._resolveTickFontOptions(0).size;
    return {
      w: a * i + l * r,
      h: a * r + l * i
    };
  }
  _getLabelCapacity(t) {
    const e = this.options.time, a = e.displayFormats, n = a[e.unit] || a.millisecond, i = this._tickFormatFunction(t, 0, qD(this, [
      t
    ], this._majorUnit), n), r = this._getLabelSize(i), l = Math.floor(this.isHorizontal() ? this.width / r.w : this.height / r.h) - 1;
    return l > 0 ? l : 1;
  }
  getDataTimestamps() {
    let t = this._cache.data || [], e, a;
    if (t.length)
      return t;
    const n = this.getMatchingVisibleMetas();
    if (this._normalized && n.length)
      return this._cache.data = n[0].controller.getAllParsedValues(this);
    for (e = 0, a = n.length; e < a; ++e)
      t = t.concat(n[e].controller.getAllParsedValues(this));
    return this._cache.data = this.normalize(t);
  }
  getLabelTimestamps() {
    const t = this._cache.labels || [];
    let e, a;
    if (t.length)
      return t;
    const n = this.getLabels();
    for (e = 0, a = n.length; e < a; ++e)
      t.push(WD(this, n[e]));
    return this._cache.labels = this._normalized ? t : this.normalize(t);
  }
  normalize(t) {
    return OP(t.sort(BD));
  }
}
Jt(hu, "id", "time"), Jt(hu, "defaults", {
  bounds: "data",
  adapters: {},
  time: {
    parser: !1,
    unit: !1,
    round: !1,
    isoWeekday: !1,
    minUnit: "millisecond",
    displayFormats: {}
  },
  ticks: {
    source: "auto",
    callback: !1,
    major: {
      enabled: !1
    }
  }
});
function Ah(s, t, e) {
  let a = 0, n = s.length - 1, i, r, l, o;
  e ? (t >= s[a].pos && t <= s[n].pos && ({ lo: a, hi: n } = hr(s, "pos", t)), { pos: i, time: l } = s[a], { pos: r, time: o } = s[n]) : (t >= s[a].time && t <= s[n].time && ({ lo: a, hi: n } = hr(s, "time", t)), { time: i, pos: l } = s[a], { time: r, pos: o } = s[n]);
  const c = r - i;
  return c ? l + (o - l) * (t - i) / c : l;
}
class kx extends hu {
  constructor(t) {
    super(t), this._table = [], this._minPos = void 0, this._tableRange = void 0;
  }
  initOffsets() {
    const t = this._getTimestampsForTable(), e = this._table = this.buildLookupTable(t);
    this._minPos = Ah(e, this.min), this._tableRange = Ah(e, this.max) - this._minPos, super.initOffsets(t);
  }
  buildLookupTable(t) {
    const { min: e, max: a } = this, n = [], i = [];
    let r, l, o, c, d;
    for (r = 0, l = t.length; r < l; ++r)
      c = t[r], c >= e && c <= a && n.push(c);
    if (n.length < 2)
      return [
        {
          time: e,
          pos: 0
        },
        {
          time: a,
          pos: 1
        }
      ];
    for (r = 0, l = n.length; r < l; ++r)
      d = n[r + 1], o = n[r - 1], c = n[r], Math.round((d + o) / 2) !== c && i.push({
        time: c,
        pos: r / (l - 1)
      });
    return i;
  }
  _generate() {
    const t = this.min, e = this.max;
    let a = super.getDataTimestamps();
    return (!a.includes(t) || !a.length) && a.splice(0, 0, t), (!a.includes(e) || a.length === 1) && a.push(e), a.sort((n, i) => n - i);
  }
  _getTimestampsForTable() {
    let t = this._cache.all || [];
    if (t.length)
      return t;
    const e = this.getDataTimestamps(), a = this.getLabelTimestamps();
    return e.length && a.length ? t = this.normalize(e.concat(a)) : t = e.length ? e : a, t = this._cache.all = t, t;
  }
  getDecimalForValue(t) {
    return (Ah(this._table, t) - this._minPos) / this._tableRange;
  }
  getValueForPixel(t) {
    const e = this._offsets, a = this.getDecimalForPixel(t) / e.factor - e.end;
    return Ah(this._table, a * this._tableRange + this._minPos, !0);
  }
}
Jt(kx, "id", "timeseries"), Jt(kx, "defaults", hu.defaults);
var rW = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  CategoryScale: Ax,
  LinearScale: Cx,
  LogarithmicScale: $x,
  RadialLinearScale: Yd,
  TimeScale: hu,
  TimeSeriesScale: kx
});
const SE = [
  mF,
  Fz,
  OB,
  rW
];
Jr.register(...SE);
const QC = class QC {
  constructor(t, e, a) {
    this.$element = t, this.$timeout = e, this.$scope = a, this.datasetData = {}, this.barChartOptions = {}, this.pieChartOptions = {}, this.chartColors = {};
  }
  /** Initializes the controller. */
  init() {
    this.role = this.role || "employer", this.chartType = this.chartType || "bar", this.setChartOptions(), this.setChartColors(), this.$timeout(() => {
      this.createChart();
    }), this.$scope.$watch(() => ({ chartType: this.chartType, result: this.calc?.result }), (t) => {
      t && (this.chart && (this.chart.destroy(), this.chart = null), this.createChart());
    }, !0);
  }
  /** Creates chart based on data and options to canvas or updates chart if it already exists */
  createChart() {
    this.datasetData = this.getDatasetData, this.scaleYAxis ? this.datasetData.workerChartScale > this.datasetData.employerChartScale ? this.setChartYAxisLimit(this.datasetData.workerChartScale) : this.setChartYAxisLimit(this.datasetData.employerChartScale) : this.role === "worker" ? this.setChartYAxisLimit(this.datasetData.workerChartScale) : this.setChartYAxisLimit(this.datasetData.employerChartScale);
    const t = this.getChartData(), e = this.chartType === "bar" ? this.barChartOptions : this.pieChartOptions;
    if (!this.chart) {
      const a = this.$element.find("canvas")[0]?.getContext("2d");
      a && (this.chart = new Jr(a, {
        type: this.chartType,
        data: t,
        options: e
      }));
    }
  }
  /**
   * Updates provided current chart
   * "none" parameters means no animation for update
   */
  updateChart() {
    if (this.chart) {
      this.datasetData = this.getDatasetData, this.scaleYAxis ? this.datasetData.workerChartScale > this.datasetData.employerChartScale ? this.setChartYAxisLimit(this.datasetData.workerChartScale) : this.setChartYAxisLimit(this.datasetData.employerChartScale) : this.role === "worker" ? this.setChartYAxisLimit(this.datasetData.workerChartScale) : this.setChartYAxisLimit(this.datasetData.employerChartScale);
      const t = this.getChartData(), e = this.chartType === "bar" ? this.barChartOptions : this.pieChartOptions;
      this.chart.data = t, this.chart.options = e, this.chart.update("none");
    }
  }
  /**
   * Calculates and sets a proper Y axis max value for a given value
   * @param value The number of the highest bar in chart
   */
  setChartYAxisLimit(t) {
    const e = Math.round(Math.log10(t)), a = Math.ceil(t / Math.pow(10, e - 1)), n = Math.pow(10, e - 1) * a;
    this.barChartOptions.scales.y = {
      stacked: !0,
      min: 0,
      max: n,
      ticks: {
        callback: function(i) {
          return Number.isInteger(i) ? i : null;
        }
      }
    };
  }
  getChartData() {
    switch (this.role) {
      case "worker":
        return {
          labels: [
            `${L.get(
              "SALAXY.NG1.CalcChartComponent.createChartWorker.seriesLabel.salaryPayment"
            )} ${this.formatCurrency(this.datasetData.salaryPayment)}`,
            `${L.get(
              "SALAXY.NG1.CalcChartComponent.createChartWorker.seriesLabel.tax"
            )} ${this.formatCurrency(this.datasetData.tax)}`,
            `${L.get(
              "SALAXY.NG1.CalcChartComponent.createChartWorker.seriesLabel.workerSideCosts"
            )} ${this.formatCurrency(this.datasetData.workerSideCosts)}`,
            `${L.get(
              "SALAXY.NG1.CalcChartComponent.createChartWorker.seriesLabel.totalExpenses"
            )} ${this.formatCurrency(
              this.datasetData.benefits + this.datasetData.totalExpenses
            )}`
          ],
          datasets: this.getDatasets()
        };
      case "employer":
        return {
          labels: [
            `${L.get(
              "SALAXY.NG1.CalcChartComponent.createChartEmployer.seriesLabel.totalGrossSalary"
            )} ${this.formatCurrency(this.datasetData.totalGrossSalary)}`,
            `${L.get(
              "SALAXY.NG1.CalcChartComponent.createChartEmployer.seriesLabel.salaryAdditions"
            )} ${this.formatCurrency(this.datasetData.salaryAdditions)}`,
            `${L.get(
              "SALAXY.NG1.CalcChartComponent.createChartEmployer.seriesLabel.allSideCosts"
            )} ${this.formatCurrency(this.datasetData.allSideCosts)}`,
            `${L.get(
              "SALAXY.NG1.CalcChartComponent.createChartEmployer.seriesLabel.totalExpenses"
            )} ${this.formatCurrency(this.datasetData.totalExpenses)}`
          ],
          datasets: this.getDatasets()
        };
      default:
        return {
          labels: [],
          datasets: []
        };
    }
  }
  formatCurrency(t) {
    return new Intl.NumberFormat("fi-FI", {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 2
    }).format(t);
  }
  setChartOptions() {
    this.barChartOptions = {
      label: "",
      responsive: !0,
      maintainAspectRatio: !1,
      scales: {
        x: {
          stacked: !0,
          min: 0,
          max: 0,
          display: !1
        },
        y: {
          stacked: !0,
          min: 0,
          max: 5e3,
          ticks: {
            callback: function(t) {
              return Number.isInteger(t) ? t : null;
            }
          }
        }
      },
      plugins: {
        datalabels: {
          display: !1
        },
        legend: {
          display: !1
        },
        tooltip: {
          mode: "index",
          callbacks: {
            title() {
              return "";
            },
            label(t) {
              return t.dataset.label ?? "";
            }
          },
          itemSort(t, e) {
            return e.datasetIndex - t.datasetIndex;
          }
        }
      },
      events: ["mousemove", "click"]
    }, this.pieChartOptions = {
      plugins: {
        legend: {
          display: !1
        },
        tooltip: {
          mode: "dataset",
          callbacks: {
            title() {
              return "";
            },
            label(t) {
              return t.label ?? "";
            }
          },
          itemSort(t, e) {
            return e.datasetIndex - t.datasetIndex;
          }
        }
      },
      events: ["mousemove", "click"]
    };
  }
  getDatasets() {
    if (this.chartType === "pie")
      switch (this.role) {
        case "worker":
          return [
            {
              label: "",
              data: [
                this.datasetData.salaryPayment,
                this.datasetData.tax,
                this.datasetData.workerSideCosts,
                this.datasetData.benefits + this.datasetData.totalExpenses
              ],
              backgroundColor: [
                this.chartColors.info,
                this.chartColors.success,
                this.chartColors.warning,
                this.chartColors.danger
              ]
            }
          ];
        case "employer":
          return [
            {
              label: "",
              data: [
                this.datasetData.totalGrossSalary,
                this.datasetData.salaryAdditions,
                this.datasetData.allSideCosts,
                this.datasetData.totalExpenses
              ],
              backgroundColor: [
                this.chartColors.info,
                this.chartColors.success,
                this.chartColors.warning,
                this.chartColors.danger
              ]
            }
          ];
        default:
          return [];
      }
    else
      switch (this.role) {
        case "worker":
          return [
            {
              label: L.get(
                "SALAXY.NG1.CalcChartComponent.createChartWorker.seriesLabel.salaryPayment"
              ) + this.formatCurrency(this.datasetData.salaryPayment),
              data: [this.datasetData.salaryPayment],
              backgroundColor: this.chartColors.info
            },
            {
              label: L.get(
                "SALAXY.NG1.CalcChartComponent.createChartWorker.seriesLabel.tax"
              ) + this.formatCurrency(this.datasetData.tax),
              data: [this.datasetData.tax],
              backgroundColor: this.chartColors.success
            },
            {
              label: L.get(
                "SALAXY.NG1.CalcChartComponent.createChartWorker.seriesLabel.workerSideCosts"
              ) + this.formatCurrency(this.datasetData.workerSideCosts),
              data: [this.datasetData.workerSideCosts],
              backgroundColor: this.chartColors.warning
            },
            {
              label: L.get(
                "SALAXY.NG1.CalcChartComponent.createChartWorker.seriesLabel.totalExpenses"
              ) + this.formatCurrency(
                this.datasetData.benefits + this.datasetData.totalExpenses
              ),
              data: [
                this.datasetData.benefits + this.datasetData.totalExpenses
              ],
              backgroundColor: this.chartColors.danger
            }
          ];
        case "employer":
          return [
            {
              label: L.get(
                "SALAXY.NG1.CalcChartComponent.createChartEmployer.seriesLabel.totalGrossSalary"
              ) + this.formatCurrency(this.datasetData.totalGrossSalary),
              data: [this.datasetData.totalGrossSalary],
              backgroundColor: this.chartColors.info
            },
            {
              label: L.get(
                "SALAXY.NG1.CalcChartComponent.createChartEmployer.seriesLabel.salaryAdditions"
              ) + this.formatCurrency(this.datasetData.salaryAdditions),
              data: [this.datasetData.salaryAdditions],
              backgroundColor: this.chartColors.success
            },
            {
              label: L.get(
                "SALAXY.NG1.CalcChartComponent.createChartEmployer.seriesLabel.allSideCosts"
              ) + this.formatCurrency(this.datasetData.allSideCosts),
              data: [this.datasetData.allSideCosts],
              backgroundColor: this.chartColors.warning
            },
            {
              label: L.get(
                "SALAXY.NG1.CalcChartComponent.createChartEmployer.seriesLabel.totalExpenses"
              ) + this.formatCurrency(this.datasetData.totalExpenses),
              data: [this.datasetData.totalExpenses],
              backgroundColor: this.chartColors.danger
            }
          ];
        default:
          return [];
      }
  }
  setChartColors() {
    const t = (e) => oc.getBrandColor(e, "rgba");
    this.chartColors = {
      info: t("info"),
      success: t("success"),
      warning: t("warning"),
      danger: t("danger")
    };
  }
  get getDatasetData() {
    const t = this.calc;
    if (!t || !t.result)
      return {};
    const { result: e } = t, a = {
      // Employer numbers
      totalGrossSalary: e.totals.totalBaseSalary,
      salaryAdditions: e.totals.totalGrossSalary - e.totals?.totalBaseSalary,
      allSideCosts: e.employerCalc.allSideCosts,
      finalCost: e.employerCalc.finalCost,
      // Worker numbers
      salaryPayment: e.workerCalc.salaryPayment,
      tax: e.workerCalc.tax,
      workerSideCosts: e.workerCalc.workerSideCosts,
      benefits: e.workerCalc.benefits,
      totalExpenses: e.totals.totalExpenses,
      totalWorkerPayment: e.workerCalc.totalWorkerPayment,
      // Chart scales
      employerChartScale: 0,
      workerChartScale: 0
    };
    return a.employerChartScale = a.totalGrossSalary + a.salaryAdditions + a.allSideCosts + a.totalExpenses, a.workerChartScale = a.salaryPayment + a.tax + a.workerSideCosts + a.benefits + a.totalExpenses, a;
  }
};
QC.$inject = ["$element", "$timeout", "$scope"];
let $m = QC;
const ZC = class ZC {
  /**
   * Creates a new CalcHouseholdUsecaseController
   * @ignore
   */
  constructor(t, e, a) {
    this.uiHelpers = t, this.calcApi = e, this.workersApi = a, this.periodStartDateError = null, this.tree = hi.getUsecaseTree();
  }
  /**
   * Implement IController
   */
  $onInit() {
    !this.calc && this.worker && this.resetEmployment(), this.initDateRanges();
  }
  /**
   * The use case that we are editing
   */
  get usecaseData() {
    return this.calc.usecase.data;
  }
  /** Gets the view template that is used for showing the usecase details part. */
  getTemplate() {
    let t = "other";
    switch (this.usecaseData.uri) {
      case hi.knownUseCases.childCare:
      case hi.knownUseCases.mll:
        t = "childCare";
        break;
      case hi.knownUseCases.cleaning:
        t = "cleaning";
        break;
      case hi.knownUseCases.construction:
        t = "construction";
        break;
      case hi.knownUseCases.santaClaus:
      case hi.knownUseCases.other:
      default:
        t = "other";
        break;
    }
    return `salaxy-components/calc/usecases/household-${t}.html`;
  }
  /**
   * Gets or sets the isHouseholdDeductible within the usecase.
   * Currently, this is part of the usecase specification and will be set to Salary (household properties in V03) from there.
   */
  get isHouseholdDeductible() {
    return this.usecaseData.isHouseholdDeductible;
  }
  set isHouseholdDeductible(t) {
    this.usecaseData.isHouseholdDeductible = t;
  }
  /** Gets the current calculation object */
  get currentCalc() {
    return this.calc;
  }
  /**
   * Returns true if there is no net salary payment to worker at all.
   */
  get isCurrentZeroPayment() {
    return Da.isZeroPayment(this.calc);
  }
  /**
   * Submit the usecase data and recalculate
   */
  submitHouseholdUsecase() {
    const t = this.uiHelpers.showLoading("SALAXY.UI_Terms.isCalculating");
    hi.applyUseCase(this.calc), this.calcApi.recalculate(this.calc).then((e) => {
      wt.copy(e, this.calc), t.dismiss();
    });
  }
  /** Saves the usecase to employment */
  saveEmployment() {
    const t = this.uiHelpers.showLoading("SALAXY.UI_Terms.isSaving");
    this.isReadOnly = !0, this.updateWorkerAccount().then(() => {
      this.workersApi.save(this.worker).then(() => {
        t.dismiss();
      });
    });
  }
  /**
   * Does recalculation on the usecase and and applies it to worker account.
   * @returns The updated worker account. The changes are also applied to the worker property.
   */
  updateWorkerAccount() {
    return hi.applyUseCase(this.calc), this.calcApi.recalculate(this.calc).then((t) => (this.worker.employment.usecase = t.usecase, this.worker.employment.usecase.data.copyToCalc = !0, this.worker.employment.work.salaryDefaults = t.rows, this.worker.employment.work.occupationCode = t.info.occupationCode, this.worker));
  }
  /** Resets the usecase from employment */
  resetEmployment() {
    this.isEmployment = !0, this.calc = Da.getBlank(), this.calc.usecase = {}, wt.copy(this.worker.employment.work.salaryDefaults, this.calc.rows), wt.copy(this.worker.employment.usecase, this.calc.usecase), this.calc.usecase?.uri ? (this.isReadOnly = !0, hi.applyUseCase(this.calc)) : this.isReadOnly = !1;
  }
  /** Starts the edit mode if the component is in read-only mode.  */
  startEdit() {
    this.isReadOnly = !1;
  }
  /**
   * The salary row is the first row is the first row in the rows list
   */
  get salaryRow() {
    return Da.getSalaryRow(this.calc);
  }
  /** Returns true if the usecase has been selected. */
  get isUsecaseSelected() {
    return !!this.calc?.usecase?.uri;
  }
  /** Gets the label for price input */
  get priceLabel() {
    switch (this.salaryRow.rowType) {
      case Wt.Compensation:
        return "Työkorvaus";
      case Wt.Salary:
        return "Kertakorvaus";
      case Wt.HourlySalary:
        return "Tuntipalkka";
      case Wt.MonthlySalary:
        return "Kuukausipalkka";
      case Wt.TotalEmployerPayment:
        return "Kokonaiskustannus";
      case Wt.TotalWorkerPayment:
        return "Nettopalkka";
      default:
        return "Hinta";
    }
  }
  /**
   * Select and set usecase in UI
   */
  selectUsecase(t) {
    this.calc.rows = [], hi.setUsecase(this.calc, t);
  }
  /** Resets the price and amount when row type is changed. */
  changeRowType() {
    this.salaryRow.price = null, this.salaryRow.rowType === Wt.HourlySalary ? (this.salaryRow.count = null, this.salaryRow.unit = xv.Hours) : this.salaryRow.count = 1;
  }
  /**
   * Resets the usecase to empty: Shows the usecase selection again.
   */
  resetUsecase() {
    this.calc.usecase = {};
  }
  /** Getter and setter for Calculation daterange in compatible format for new DateRange component. */
  get dateRange() {
    const t = (this.calc || {}).info, e = (this.calc || {}).framework;
    return this._dateRange || (this._dateRange = {
      start: t.workStartDate,
      end: t.workEndDate,
      daysCount: e.numberOfDays
    }), this._dateRange;
  }
  set dateRange(t) {
    this._dateRange = t;
  }
  /**
   * Called when the date range changes.
   * @param noPeriodStartDateUpdate If true, the _periodStartDate is not updated.
   * Should be true if the change is triggered by that input to avoid UI flickering.
   */
  dateRangeChange(t = !1) {
    const e = (this.currentCalc || {}).info, a = (this.currentCalc || {}).framework;
    e.workStartDate = this.dateRange.start, t || (this._periodStartDate = I.format(this.dateRange.start, "D.M.", null)), e.workEndDate = this.dateRange.end, a.numberOfDays = this.dateRange.daysCount;
  }
  /**
   * Gets or sets the period start date, which is bound to editable input in case the period type
   * is not "other" (date the range / calendar component)
   */
  get periodStartDate() {
    return this._periodStartDate;
  }
  set periodStartDate(t) {
    this._periodStartDate = t;
    const e = (t || "").split(".");
    if (e.length < 2 || e.length > 3) {
      this.periodStartDateError = "Syötä muodossa 'pv.kk.'";
      return;
    }
    let a = e.length === 3 ? Number((e[2] || "").trim()) : null;
    (!a || a < 2019 || a > 2100) && (a = Number(this.dateRange.start.substr(0, 4)));
    const n = I.getDate(a, Number(e[1]), Number(e[0]));
    if (n) {
      switch (this.periodStartDateError = null, this.periodShortcut) {
        case "monthCurrent":
        case "monthLast":
        case "monthOther":
          this.dateRange = I.getDateRange(n, I.add(I.add(n, 1, "month"), -1, "day"));
          break;
        case "weeks2":
          this.dateRange = I.getDateRange(n, I.add(I.add(n, 2, "week"), -1, "day"));
          break;
        case "monthHalf":
          I.getDay(n) === 15 || I.getDay(n) === 16 ? this.dateRange = I.getDateRange(n, I.startEnd(n, "end-month")) : this.dateRange = I.getDateRange(n, I.add(n, 14, "day"));
          break;
        case "other":
          this.dateRange = I.getDateRange(n, n);
          break;
      }
      this.dateRangeChange(!0);
    } else
      this.periodStartDateError = `${t} ei ole päivämäärä.`;
  }
  /**
   * Gets the user interface shortcut for the period type:
   * Different user interfaces are shown depending on the period shortcut.
   */
  get periodShortcut() {
    return !this.dateRange.start || !this.dateRange.end ? null : this.dateRange.start === I.getDate("today", "today", 1) && this.dateRange.end === I.startEnd("today", "end-month") ? "monthCurrent" : this.dateRange.start === I.add(I.startEnd("today", "start-month"), -1, "month") && this.dateRange.end === I.startEnd(I.add(I.startEnd("today", "start-month"), -1, "month"), "end-month") ? "monthLast" : this.dateRange.end === I.add(I.add(this.dateRange.start, 1, "month"), -1, "day") ? "monthOther" : this.dateRange.end === I.add(I.add(this.dateRange.start, 2, "week"), -1, "day") ? "weeks2" : I.getDuration(this.dateRange.start, this.dateRange.end).days() === 14 || I.getDay(this.dateRange.start) === 15 && this.dateRange.end === I.startEnd(this.dateRange.start, "end-month") || I.getDay(this.dateRange.start) === 16 && this.dateRange.end === I.startEnd(this.dateRange.start, "end-month") ? "monthHalf" : "other";
  }
  set periodShortcut(t) {
    switch (this.periodStartDateError = null, t) {
      case "monthCurrent":
        this.dateRange.start = I.getDate("today", "today", 1), this.dateRange.end = I.startEnd("today", "end-month");
        break;
      case "monthOther":
        I.getDay("today") === 1 ? this.dateRange.start = I.add("today", 1, "day") : this.dateRange.start = I.asDate("today"), this.dateRange.end = I.add(I.add(this.dateRange.start, 1, "month"), -1, "day");
        break;
      case "monthLast":
        this.dateRange.start = I.add(I.startEnd("today", "start-month"), -1, "month"), this.dateRange.end = I.startEnd(this.dateRange.start, "end-month");
        break;
      case "weeks2":
        this.dateRange.start = I.add(I.startEnd("today", "start-week"), -2, "week"), this.dateRange.end = I.add(I.startEnd("today", "start-week"), -1, "day");
        break;
      case "monthHalf":
        I.getDay("today") < 16 ? (this.dateRange.start = I.add(I.add(I.startEnd("today", "start-month"), -1, "month"), 15, "day"), this.dateRange.end = I.startEnd(this.dateRange.start, "end-month")) : (this.dateRange.start = I.startEnd("today", "start-month"), this.dateRange.end = I.add(this.dateRange.start, 14, "day"));
        break;
      case "other":
        this.dateRange.start = I.add("today", -1, "day"), this.dateRange.end = I.asDate("today");
        break;
    }
    this.dateRange = I.getDateRange(this.dateRange.start, this.dateRange.end), this.dateRangeChange();
  }
  initDateRanges() {
    const t = I.getMonth(I.getToday());
    this.periodShortcuts = {
      monthCurrent: L.get(`SALAXY.ENUM.CalendarMonth.month${t}.label`),
      monthLast: L.get(`SALAXY.ENUM.CalendarMonth.month${t === 1 ? 12 : t - 1}.label`),
      monthOther: "Muu kuukausi",
      // monthMulti: "Monta kuukautta",
      weeks2: L.get("SALAXY.UI_Terms.week2"),
      monthHalf: L.get("SALAXY.UI_Terms.monthHalf"),
      other: L.get("SALAXY.UI_Terms.otherPeriod")
    }, this._periodStartDate = I.format(this.dateRange.start, "D.M.", null);
  }
};
ZC.$inject = [
  "UiHelpers",
  "Calculations",
  "Workers"
];
let Sm = ZC;
class Xo {
  /**
   * Creates a new CalculatorSection
   * @param isActive - If true, the section is currently active / selected in te user interface.
   * @param isSelectionDone - If true, user has selected some values for the section
   * @param title - Short text title for the section
   */
  constructor(t, e, a) {
    this.isActive = t, this.isSelectionDone = e, this.title = a;
  }
  /**
   * Shortcut for isSelectionDone or isActive.
   * This is when the overview window should be shown colored
   */
  get isOverviewActive() {
    return this.isSelectionDone || this.isActive;
  }
}
class kE {
  /**
   * Creates a new CalculatorSections helper for a calculation
   * @param calc The Calculation object for which the helper operates
   */
  constructor(t) {
    this.calc = t, (!t || Object.keys(t).length === 0) && (this.calc = Da.getBlank());
  }
  /** Stores the UI properties to the calculation until a roundtrip to server. Then the property is set to null */
  get ui() {
    return Da.getUiCache(this.calc);
  }
  /**
   * Activates a section in the calculator (opens the detail view).
   * @param section - Name of the section
   */
  setActive(t) {
    this.ui.activeSection = t;
  }
  /**
   * Toggles the section
   */
  toggleActive(t) {
    this.ui.activeSection = this.ui.activeSection === t ? null : t;
  }
  /**
   * Toggles the section active / non-active.
   */
  toggle(t) {
    this.ui.activeSection === t ? this.ui.activeSection = null : this.ui.activeSection = t;
  }
  /** Gets a section */
  get(t) {
    const e = this.ui.activeSection === t;
    switch (t) {
      case "worker":
        return new Xo(
          e,
          this.calc.worker && this.calc.worker.avatar.id != null,
          this.calc.worker && this.calc.worker.avatar.displayName ? this.calc.worker.avatar.displayName : L.get("SALAXY.NG1.CalcComponent.workerSectionDefaultInfo")
        );
      case "household-usecase":
        return new Xo(
          e,
          this.calc.usecase == null || this.calc.usecase.label != null,
          null
          // No longer in use
        );
      case "worktime":
        return new Xo(
          e,
          !!(this.calc.info.workStartDate && this.calc.info.workEndDate),
          null
          // No longer in use in Calculator2018
        );
      case "expenses": {
        const a = Da.getTotalForCategory(this.calc, "expenses"), n = Da.getTotalForCategory(this.calc, "benefits"), i = Da.getTotalForCategory(this.calc, "deductions"), r = this.calc.salary.isHouseholdDeductible, l = this.calc.framework.unionPayment;
        return new Xo(
          e,
          a + n > 0 || i > 0 || r || l && l !== zM.NotSelected,
          se.toFixed(a + n, 2) + " € - " + se.toFixed(i, 2) + " €"
        );
      }
      case "salary": {
        const a = Da.getTotalForCategory(this.calc, "salary"), n = Da.getTotalForCategory(this.calc, "salaryAdditions");
        return new Xo(
          e,
          a > 0,
          a === 0 ? "0 €" : n > 0 ? se.toFixed(this.calc.result.totals.totalBaseSalary, 2) + " + " + se.toFixed(n, 2) + " €" : se.toFixed(this.calc.result.totals.totalBaseSalary, 2) + " €"
        );
      }
      case "result": {
        const a = this.calc.result && this.calc.result.totals && (this.calc.rows.length > 0 || this.calc.result.totals.total !== 0 || this.calc.workflow.status !== le.Draft) || !1;
        return new Xo(
          a,
          a,
          L.get("SALAXY.NG1.CalcComponent.resultSectionCalculation")
        );
      }
    }
  }
}
class lW extends fa {
  constructor() {
    super(...arguments), this.anonOptions = "<";
  }
}
const Ry = class Ry extends wr {
  constructor(t, e, a, n, i, r, l, o, c) {
    super(t, l, e, n, i, r, o), this.calcApi = t, this.uiCrudHelpers = a, this.invoicesService = o, this.ajax = c, this.chartType = "bar", this.anonOptions = {
      role: "company"
    }, this.loaders = {};
  }
  /**
   * Initialization code.
   */
  $onInit() {
    super.$onInit();
  }
  /** Returns the current. Called currentCalc for backward compatibility with the old views. */
  get currentCalc() {
    return this.current;
  }
  /**
   * Gets the Sections object for the current calculation.
   * It keeps track of which section is currently shown and what text etc. is shown in that section.
   */
  get calcSections() {
    return new kE(this.current);
  }
  /**
   * Gets or sets the isHouseholdDeductible.
   * This will be moved to a different location in V03, hence the abstraction.
   */
  get isHouseholdDeductible() {
    return this.current ? this.current.salary.isHouseholdDeductible : !1;
  }
  set isHouseholdDeductible(t) {
    this.current.salary.isHouseholdDeductible = t;
  }
  /**
   * Gets or sets the taxDeductionCategory (used to be salary.taxDeductionCategories).
   * This will be moved to a different location in V03, hence the abstraction.
   */
  get taxDeductionCategory() {
    return this.current.salary.taxDeductionCategories;
  }
  set taxDeductionCategory(t) {
    this.current.salary.taxDeductionCategories = t;
  }
  /**
   * Returns true if the calculator is in "household" mode (as opposed to default "company" mode).
   */
  get isHousehold() {
    return this.sessionService.isInRole("pro") && this.sessionService.isInRole("person") ? !0 : this.sessionService.isInRole("worker") ? !1 : this.sessionService.isInRole("anon") ? !!(this.anonOptions && this.anonOptions.role === "household") : this.sessionService.isInRole("household");
  }
  /**
   * If true, the given action (button) is displayed.
   * @param action One of the action values.
   * For now, validation and role based action logic is in UI.
   * Todo: some edge cases, i.e. isForcePayAllAllowed (for pay-button) are still in UI.
   */
  showAction(t) {
    if (!this.current || this.isReadOnlyForced && t != "showPaymentDialog")
      return !1;
    if (this.isReadOnlyForced && t == "showPaymentDialog")
      return !0;
    if (this.current.workflow.status == le.PayrollDraft)
      return !1;
    if (this.current.isReadOnly)
      switch (t) {
        case "cancel":
          return this.current.workflow.status == le.PaymentStarted && ([
            At.PalkkausManual,
            At.TalenomManual,
            At.PalkkausPersonal,
            At.PalkkausInvoices
          ].indexOf(this.current.info.paymentChannel) > -1 || ne.isCfa(this.current.info.paymentChannel) && !this.current.info.payrollId);
        case "copyAsNew":
          return !this.isReadOnlyForced;
        case "showPaymentDialog":
          return !0;
        case "allowForcePay":
        case "pay":
        case "recalculate":
        default:
          return !1;
      }
    else
      switch (t) {
        case "allowForcePay":
          return this.isForcePayAllAllowed && this.current.workflow.status != le.WaitingApproval && this.current.workflow.status != le.SharedRejected && this.current.workflow.status != le.SharedWaiting && this.current.workflow.status != le.Repair;
        case "pay":
          return this.current.workflow.status == le.Draft || this.current.workflow.status == le.ProDraft || this.current.workflow.status == le.SharedApproved;
        case "save":
          return this.current.workflow.status == le.Draft || this.current.workflow.status == le.ProDraft || this.current.workflow.status == le.SharedApproved || this.current.workflow.status == le.History || this.current.workflow.status == le.Repair;
        case "delete":
          return this.current.workflow.status == le.Draft || this.current.workflow.status == le.ProDraft || this.current.workflow.status == le.SharedRejected || this.current.workflow.status == le.History || this.current.workflow.status == le.Repair;
        case "sendToPro":
          return this.current.workflow.status == le.WaitingApproval;
        case "recalculate":
          return !0;
        case "reject":
          return this.current.workflow.status == le.SharedApproved || this.current.workflow.status == le.SharedWaiting;
        case "approve":
          return this.current.workflow.status == le.SharedRejected || this.current.workflow.status == le.SharedWaiting;
        case "setSalaryDateKind":
          return (this.current.workflow.status == le.Draft || this.current.workflow.status == le.ProDraft || this.current.workflow.status == le.SharedApproved) && (ne.isPalkkausManualLike(this.current.info.paymentChannel) || ne.isPalkkausInvoicesLike(this.current.info.paymentChannel) || this.current.info.paymentChannel == At.PalkkausCfaTest || this.current.info.paymentChannel == At.Briox || this.current.info.paymentChannel == At.Askelma || this.current.info.paymentChannel == At.PasseliMerit || this.current.info.paymentChannel == At.Ecom || this.current.info.paymentChannel == At.Hausvise);
        default:
          return !1;
      }
  }
  /**
   * Returns true, if action (button) is disabled
   * TODO: Add rules based on roles and validation? Pay button logic is in UI.
   */
  isActionDisabled(t) {
    if (!this.current || this.isReadOnlyForced)
      return !0;
    if (this.current.isReadOnly)
      switch (t) {
        case "delete":
          return this.current.workflow.status == le.PaymentStarted;
        case "save":
          return this.current.workflow.status == le.PaymentStarted;
        default:
          return !0;
      }
  }
  /**
   * Gets the first row of the calculation assuring that it exists
   * If there is no current calculation, the calculation is not added.
   */
  getFirstRow() {
    return Da.getFirstRow(this.current);
  }
  /**
   * Takes the current calculation, creates a copy of it in draft state
   * and sets that calculation as current.
   * This is done typically, when a calculation was in Paid state.
   */
  copyAsNew() {
    const t = this.copyItem(this.current);
    this.calcApi.recalculate(t).then((e) => {
      this.setCurrentRef(e), this?.worktimeCtrl ? this.worktimeCtrl.reset() : this.parentController?.worktimeCtrl && this.parentController.worktimeCtrl.reset(), this.calcSections.setActive("worktime");
    });
  }
  /**
   * Reset worker in the calculations.
   */
  resetWorker() {
    this.currentCalc.worker = Da.getBlank().worker;
  }
  /**
   * Gets misc. logic calculations and operations (client side, based on rows etc.)
   * that affect how the user interface is rendered.
   */
  get calcLogic() {
    if (!this.current)
      return {};
    const t = (this.current.result || {}).workerCalc || {};
    return {
      /** If true, calcualtion contains compensation. This is useful for customizing texts and other UI elements */
      hasCompensation: !!this.current.rows.find((e) => e.rowType === Wt.Compensation),
      /** Expenses box total. TODO: We should see can we move this to result / server side! */
      expensesTotal: t.prepaidExpenses + t.deductions - t.unemploymentInsurance - t.pension - t.tax,
      /** Sum for child care subsidy. This is shown separately in the UI. */
      childCareSubsidy: this.current.result && this.current.result.rows ? ie.sum(this.current.result.rows.filter((e) => e.rowType === Wt.ChildCareSubsidy), (e) => e.total) : null
    };
  }
  /**
   * Opens the login form for the current user
   * @param redirectUrl - The URL where the user is taken after a successfull login.
   * @param role - Optional role (household, worker or company) for the situations where it is known - mainly for new users
   */
  signIn(t = null, e = null) {
    this.sessionService.signIn(t, e);
  }
  /**
   * Opens the login dialog with signUp / register functionality
   * @param redirectUrl - The URL where the user is taken after a successfull login
   * @param role - Optional role (household, worker or company) for the situations where it is known - mainly for new users
   */
  register(t = null, e = null) {
    this.sessionService.register(t, e);
  }
  /**
   * Shows a report for the current calculation using a modal dialog.
   * @param reportType - Type of report to show
   */
  showReportDialog(t) {
    this.reportsService.showReportModalForCalc(t, this.current);
  }
  /**
   * Deletes the currently selected calculation
   */
  deleteCalc(t) {
    this.uiHelpers.showConfirm("SALAXY.NG1.CalcComponent.dialog.deleteCalc").then((e) => {
      if (e)
        if (this.isNew())
          this.$location.path(t || "/");
        else {
          const a = this.uiHelpers.showLoading("SALAXY.UI_Terms.wait");
          this.deleteNoConfirm(this.current).then(() => {
            this.setCurrentRef(this.api.getBlank()), a.dismiss(), this.$location.path(t || "/");
          });
        }
    });
  }
  /**
   * Recalculates the current calculation using the API.
   * @returns A Promise with result data (Calculation)
   */
  recalculate() {
    return this.sessionService.isInRole("worker") ? this.current.worker.isSelf = !0 : this.current.employer.isSelf = !0, this.calcApi.recalculate(this.current).then((t) => (super.setCurrentValue(t), t));
  }
  /**
   * Sets the current item as the given object (reference to a new object).
   * This also resets the original item and sets the state as loaded.
   * Override also sets either employer or worker based on the current role.
   * @param item The new current item.
   */
  setCurrentRef(t) {
    t && (this.sessionService.isInRole("worker") ? t.worker.isSelf = !0 : t.employer.isSelf = !0), super.setCurrentRef(t);
  }
  /** Overrides the save method to allow anonymous saving to local storage */
  save() {
    return this.sessionService.isAuthenticated ? (this.current.worker.accountId === "anon" && (this.current.worker.accountId = null), this.current.worker.accountId || this.deleteFromLocalStorage(), this.current.id === "anon" && (this.current.id = null), super.save()) : (this.current.id = "anon", this.recalculate().then(() => (this.current.worker.accountId = "anon", this.current.worker.avatar.id = this.current.worker.accountId, this.current.worker.avatar.color = "lime", this.current.worker.avatar.displayName = "SALAXY.NG1.CalcComponent.saveNotAuthenticatedDisplayName", this.current.worker.avatar.entityType = Xi.Person, this.current.worker.avatar.pictureType = is.Icon, this.setToLocalStorage(this.current), this.current)));
  }
  /**
   * Returns validation for current calculation or empty validation object if the calculation has not been recalculated (validated).
   */
  get validation() {
    return this.currentCalc?.result?.validation || { errors: [], hasAllRequiredFields: !0, isValid: !0 };
  }
  /** Returns date range text. */
  getDatesRangeText() {
    return !this.currentCalc.info.workStartDate || !this.currentCalc.info.workEndDate ? "SALAXY.NG1.CalcComponent.getDatesRangeText" : I.getFormattedRange(this.currentCalc.info.workStartDate, this.currentCalc.info.workEndDate) + ` (${this.currentCalc.framework.numberOfDays} ${L.get("SALAXY.NG1.CalcComponent.getUsecaseTextNumberOfDays")})`;
  }
  /** Returns household usecase text */
  getUsecaseText() {
    return !this.currentCalc.usecase && !this.currentCalc.framework.numberOfDays ? "SALAXY.NG1.CalcComponent.getUsecaseText" : this.currentCalc.usecase && !this.currentCalc.framework.numberOfDays ? ` ${this.currentCalc.usecase.label}.` + L.get("SALAXY.NG1.CalcComponent.getUsecaseText2") : I.getFormattedRange(this.currentCalc.info.workStartDate, this.currentCalc.info.workEndDate) + ` (${this.currentCalc.framework.numberOfDays} ${L.get("SALAXY.NG1.CalcComponent.getUsecaseTextNumberOfDays")}, ${this.currentCalc.usecase.label})`;
  }
  /** Returns true if the payment is possible when the employer pays all.  */
  get isForcePayAllAllowed() {
    return !this.validation.errors.find((e) => e.type !== "warning");
  }
  /**
   * Shows a dialog for adding a new Employment relation.
   * If user goes through the wizard the employment relation is saved and set to the calculation.
   */
  showNewWorkerDialog() {
    this.uiCrudHelpers.createNewEmployment().then((t) => {
      t.action === "ok" && this.updateFromEmployment(t.item.id, !0);
    });
  }
  /**
   * Shows a dialog during the check of auto taxcard.
   */
  showRefreshAutoTaxcardDialog() {
    this.loaders.showRefreshAutoTaxcardDialog = !0, this.uiCrudHelpers.refreshAutoTaxcard(this.current.worker.tax?.taxcardId, this.current.workflow?.salaryDate).then(() => {
      this.recalculate(), this.loaders.showRefreshAutoTaxcardDialog = !1;
    });
  }
  /**
   * Shows a dialog for modifying an existing Worker:
   * Saves changes and updates the calculation.
   */
  showWorkerEditDialog() {
    this.uiCrudHelpers.openEditEmploymentDialog(this.current.worker.employmentId, "updateCalc").then((t) => {
      if (t.action === "ok" || t.action === "ok-no-rows") {
        const e = this.uiHelpers.showLoading("SALAXY.NG1.CalcComponent.dialog.showWorkerEditDialogLoading");
        this.updateFromEmployment(t.item.id, t.action === "ok").then(() => {
          e.dismiss();
        });
      }
    });
  }
  /** UI related data and texts about the taxcard. */
  get taxUi() {
    return La.getCalcTaxcardInfo(this.current);
  }
  /**
   * Gets the text for pension.
   * @param isOverview If true, returns the shorter text for overview.
   */
  getPensionText(t = !1) {
    if (this.current?.result?.responsibilities?.pensionCalculation)
      return L.get(`SALAXY.ENUM.PensionCalculation.${this.current.result.responsibilities.pensionCalculation}.${t ? "labelForIncome" : "labelWithEnumLabel"}`);
  }
  /**
   * Sends the payroll from company to PRO.
   * @param message Message to the accountant
   */
  sendToPro(t) {
    const e = this.uiHelpers.showLoading("SALAXY.NG1.CalcComponent.dialog.sendToProSending", "SALAXY.NG1.CalcComponent.dialog.sendToProSendingDescr");
    this.current.workflow.status = le.ProDraft, this.save().then(() => {
      this.api.saveWorkflowEvent(this.current, {
        type: "PartnerMessageClosed",
        ui: cc.Success,
        message: t ? L.get("SALAXY.NG1.CalcComponent.dialog.sendToProMessage") + t : "SALAXY.NG1.CalcComponent.dialog.sendToProMessageChecked"
      }).then(() => {
        e.dismiss(), this.$location.path("/service");
      });
    });
  }
  /**
   * Calculates the total amount of days for the given period type.
   * @param periodType Period type to calculate days for.
   * @returns Sum of days for the given period type.
   */
  calculatePeriodDays(t) {
    switch (t) {
      case "leavesDays":
        return ie.sum(this.currentCalc.worktime?.absencesPeriods?.filter((e) => e.causeCode == Ge.AnnualLeave) ?? [], (e) => e.period.daysCount);
      case "absencesDays":
        return ie.sum(this.currentCalc.worktime?.absencesPeriods?.filter((e) => e.causeCode != Ge.AnnualLeave && !e.isPaid) ?? [], (e) => e.period.daysCount);
      case "paidAbsencesDays":
        return ie.sum(this.currentCalc.worktime?.absencesPeriods?.filter((e) => e.causeCode != Ge.AnnualLeave && e.isPaid) ?? [], (e) => e.period.daysCount);
    }
  }
  /**
   * Saves a calculation to local storage
   * @param calc - Calculation to store
   */
  setToLocalStorage(t) {
    window.localStorage && window.localStorage.setItem("salaxy-calculation", JSON.stringify(t));
  }
  /**
   * Deletes a calculation in local storage
   */
  deleteFromLocalStorage() {
    window.localStorage && window.localStorage.removeItem("salaxy-calculation");
  }
};
Ry.crudBindings = new lW(), Ry.$inject = ["Calculations", "UiHelpers", "UiCrudHelpers", "$location", "$routeParams", "SessionService", "ReportsService", "InvoicesService", "AjaxNg1"];
let $s = Ry;
const t$ = class t$ extends $s {
  /**
   * Creates a new instance of the controller with dependency injection.
   * @ignore
   */
  constructor(t, e, a, n, i, r, l, o, c) {
    super(t, e, a, n, i, r, l, o, c), this.invoicesService = o, this.groupingOptions = {
      baseSalary: L.get("SALAXY.NG1.CalcRowsComponent.irRows.baseSalary"),
      benefits: L.get("SALAXY.NG1.CalcRowsComponent.irRows.benefits"),
      deductions: L.get("SALAXY.NG1.CalcRowsComponent.irRows.deductions"),
      disabled: L.get("SALAXY.NG1.CalcRowsComponent.irRows.disabled"),
      expenses: L.get("SALAXY.NG1.CalcRowsComponent.irRows.expenses"),
      otherNoPayment: L.get("SALAXY.NG1.CalcRowsComponent.irRows.otherNoPayment"),
      salaryAdditions: L.get("SALAXY.NG1.CalcRowsComponent.irRows.salaryAdditions"),
      totals: L.get("SALAXY.NG1.CalcRowsComponent.irRows.totals")
    }, this.activeTab = 1;
  }
  /**
   * Implement IController
   */
  $onInit() {
    super.$onInit();
  }
  /** The current row that is being viewed / edited. */
  get currentRow() {
    return !this._currentRow || !this.currentCalc.result || !this.currentCalc.result.irRows ? null : (this.currentCalc.result.irRows.find((t) => t === this._currentRow) || (this._currentRow = null), this._currentRow);
  }
  /** The metadata that describes currentRow */
  get currentRowType() {
    return this.getIncomeType(this.currentRow);
  }
  /** IR-rows that are viewed / edited by the controller */
  get irRows() {
    return !this.currentCalc || !this.currentCalc.result ? [] : this.currentCalc.result.irRows;
  }
  /** Sets the current edited / viewd row */
  setCurrentIrRow(t) {
    this._currentRow = t;
  }
  /** Deletes a row */
  deleteIrRow(t) {
    this.irRows.splice(this.irRows.indexOf(t), 1);
  }
  /** Returns true if the row is read-only: Cannot be directly edited. */
  get isIrRowReadOnly() {
    return this.currentRow == null || this.currentRow.type !== "manual";
  }
  /** Updates the current row type. */
  updateCurrentRowType() {
    this.currentRowType && (!this.currentRow.message || Tn.getAll().find((t) => t.label === this.currentRow.message)) && (this.currentRow.message = this.currentRowType.label);
  }
  /** Gets the income type (the metadata) object for the currently selected row. */
  getIncomeType(t) {
    return Tn.getAll().find((e) => e.code === t.irData.code);
  }
  /** Adds a new IR row to the collection. */
  addIrRow() {
    const t = {
      type: BM.Manual,
      irData: {
        code: null
      },
      count: 1,
      unit: as.Undefined,
      price: 0
    };
    this.irRows.push(t), this.setCurrentIrRow(t);
  }
};
t$.$inject = ["Calculations", "UiHelpers", "UiCrudHelpers", "$location", "$routeParams", "SessionService", "ReportsService", "InvoicesService", "AjaxNg1"];
let km = t$;
const e$ = class e$ {
  /**
   * Creates a new CalcReportController
   * @ignore
   */
  constructor(t, e, a, n, i, r, l, o) {
    this.templates = t, this.ajax = e, this.$sce = a, this.settingsService = n, this.$timeout = i, this.sessionService = r, this.reportsApi = l, this.uiHelpers = o, this.reportData = {
      headerFooter: {},
      layout: {},
      report: {}
    }, this.sxyTableConfig = {
      currentCalc: null,
      reportLang: Me.Default,
      config: null
    };
  }
  /**
   * Implement IController
   */
  $onInit() {
  }
  /** The type for the calculation report. */
  get reportType() {
    return this._reportType;
  }
  /** The type for the calculation report. */
  set reportType(t) {
    t != this._reportType && (this._reportType = t, this.onReportTypeChange && this.onReportTypeChange({ reportType: t }));
  }
  /** Bindable and trusted html. */
  get html() {
    if (!this.calc)
      this.renderedCalc = null, this.renderedOptions = null, this.renderedLang = null;
    else {
      const t = wt.copy(this.calc);
      (!this.renderedCalc || !wt.equals(t, this.renderedCalc) || this.renderedOptions !== this.reportType + ";" + this.templateName || this.renderedLang !== this.lang) && (this.renderedCalc = wt.copy(t), this.renderedOptions = this.reportType + ";" + this.templateName, this.renderedLang = this.lang, this.getDefaultLanguage(this.lang).then((e) => {
        this.lang = e, this.renderedLang = this.lang, this.reportType !== Xd.ESalarySpecification && this.refresh(), this.reportType === Xd.ESalarySpecification && !this.isXslLoading && (this.isXslLoading = !0, this.xslText ? this.refreshESalaryXml() : fetch("https://cdn.salaxy.com/reports/PayslipCommon20.xsl").then((a) => a.text()).then((a) => {
          this.xslText = a, this.refreshESalaryXml();
        }));
      }));
    }
    return this.htmlData;
  }
  /**
   * Config for SxyTable
   */
  get tableConfig() {
    if (!this.calc)
      this.sxyTableConfig = {
        currentCalc: null,
        reportLang: null,
        config: null
      };
    else {
      const t = wt.copy(this.calc);
      (!Qe.equal(this.sxyTableConfig.currentCalc, t) || this.lang !== this.sxyTableConfig.reportLang) && (this.sxyTableConfig.currentCalc = t, this.sxyTableConfig.reportLang = this.lang, this.getDefaultLanguage(this.lang).then((e) => {
        this.lang = e, this.renderedLang = this.lang, this.refreshTableConfig();
      }));
    }
    return this.sxyTableConfig.config;
  }
  /**
   * Method used to refresh table config
   */
  async refreshTableConfig() {
    const t = this.lang ?? Me.Fi;
    await L.loadLanguage(t), this.sxyTableConfig.config = E0.getConfig(this.calc, t), await this.$timeout(), this.$sxyTable.refresh();
  }
  async refreshESalaryXml() {
    const t = await this.resolveCumulativeCalculation(Array.isArray(this.calc) ? this.calc[0] : this.calc), e = this.templates.getHtml("eSalary", XX.getESalary(t), this.lang ?? Me.Fi), a = new XSLTProcessor(), n = new window.DOMParser().parseFromString(this.xslText, "text/xml"), i = new window.DOMParser().parseFromString(e, "text/xml");
    a.importStylesheet(n);
    const r = a.transformToDocument(i);
    this.htmlData = this.$sce.trustAsHtml(r.documentElement.innerHTML), this.isXslLoading = !1, this.$timeout();
  }
  async resolveCumulativeCalculation(t) {
    if (t.id) {
      t = wt.copy(t);
      const e = await this.reportsApi.getCumulativeCalculation(t.id);
      return t.cumulative = e.cumulative, Promise.resolve(t);
    }
    return Promise.resolve(t);
  }
  /**
   * Refresh calculation report data.
   */
  async refresh() {
    this.refreshInprogress || (this.refreshInprogress = !0, this.settingsService.getReportOptions().then(async (t) => {
      this.reportOptions = t;
      const e = this.lang ?? Me.Fi;
      await L.loadLanguage(e), Array.isArray(this.calc) ? (this.reportData.report = or.getCalculationSummaryReport(this.calc, e), this.reportData.headerFooter = or.getCalculationSummaryReportHeaderFooter(this.calc, this.reportOptions, e)) : (this.reportData.report = or.getCalculationReport(this.calc, this.reportType, e), this.reportData.headerFooter = or.getHeaderFooter(this.reportType, this.calc, this.reportOptions, e));
      const a = this.getDefaultReportOptions(wt.copy(this.reportOptions));
      this.reportData.layout = or.getReportLayout(!1, !1, this.preview ? "default" : void 0), this.reportType === Xd.TotalsReport && (this.reportData.report = Array.isArray(this.calc) ? this.calc : [this.calc], this.reportData.headerFooter = or.getTotalReportHeaderFooter(Array.isArray(this.calc) ? this.calc[0] : this.calc, this.reportOptions, e), this.reportData.layout = or.getReportLayout(!0, !1, this.preview ? "default" : void 0)), this.reportData.layout.hasCustomCss = !1, this.reportData.layout.customCss = "", this.preview && (this.reportData.layout.isPreview = !0), this.reportData.layout.margin = {
        top: a.margin.top,
        right: a.margin.right,
        bottom: a.margin.bottom,
        left: a.margin.left
      };
      const n = new io();
      this.reportData.headerHtml = this.reportOptions?.headerTemplate ? n.getHtmlDynamic(this.reportOptions.headerTemplate, this.reportData.headerFooter, e) : "", this.reportData.footerHtml = this.reportOptions?.headerTemplate ? n.getHtmlDynamic(this.reportOptions.footerTemplate, this.reportData.headerFooter, e) : "", this.htmlData = this.$sce.trustAsHtml(this.templates.getHtml(this.templateName, this.reportData, e)), this.refreshInprogress = !1, this.$timeout();
    }));
  }
  getDefaultReportOptions(t) {
    return t = t || {}, t.margin = t.margin || {}, t.margin.top = se.parseNumber(t.margin.top) || 30, t.margin.right = se.parseNumber(t.margin.right) || 10, t.margin.bottom = se.parseNumber(t.margin.bottom) || 40, t.margin.left = se.parseNumber(t.margin.left) || 10, t;
  }
  async getDefaultLanguage(t) {
    return t ? Promise.resolve(t) : this.sessionService.getReportLang();
  }
};
e$.$inject = [
  "Templates",
  "AjaxNg1",
  "$sce",
  "SettingsService",
  "$timeout",
  "SessionService",
  "Reports",
  "UiHelpers"
];
let Tm = e$;
const a$ = class a$ {
  /**
   * Creates a new CalcReportsController
   * @ignore
   */
  constructor(t, e, a, n, i, r, l) {
    this.ajax = t, this.uiHelpers = e, this.sessionService = a, this.$timeout = n, this.$http = i, this.reportsApi = r, this.calculationsApi = l, this.calcs = [], this.reportLang = Me.Default, this.workerLangs = {}, this.reports = {
      salarySlip: {
        full: "salarySlipV2",
        page1: "salarySlipV2Page1",
        partial: "workerCalculationTablesV2"
      },
      employerReport: {
        full: "employerReportV2",
        page1: "employerReportV2Page1",
        partial: "employerCalculationTablesV2"
      },
      paymentReport: {
        full: "paymentReportV2",
        page1: "paymentReportV2",
        partial: "paymentTablesV2"
      },
      paymentSummaryReport: {
        full: "paymentSummaryReportV2",
        page1: "paymentSummaryReportV2",
        partial: "paymentTablesV2"
      },
      totalsReport: {
        full: "totalsReport",
        page1: "totalsReport",
        partial: "totalsTables"
      }
    }, this.sxyTableConfig = {
      currentCalc: null,
      reportLang: Me.Default,
      config: null
    }, this._epr = {
      loading: {},
      pending: {},
      latestCalc: {},
      current: {}
    };
  }
  /**
   * Implement IController
   */
  $onInit() {
    this.view = this.view || "partial", this.sessionService.getReportLang().then((t) => {
      this.reportLang = t;
    });
  }
  /** Sets reportLang and refreshes table if $sxyTable exists */
  async setReportLang(t) {
    switch (this.reportLang = t, this.reportType) {
      case Xd.TotalsReport:
        this.$calcReports && await this.$calcReports.refreshTableConfig();
        break;
      case "rowsReport":
        this.$sxyTable && await this.refreshTableConfig();
        break;
      case "irRows":
        this.$calcsIrRows && await this.$calcsIrRows.refreshTableConfig();
    }
  }
  /**
   * Get lang for employer reports
   * @returns language for calculation
   */
  getEmployerLang() {
    return this.reportLang !== Me.Default ? this.reportLang : (this.employerLang || (this.employerLang = Me.Default, this.sessionService.getReportLang().then((t) => {
      this.employerLang = t, this.$timeout();
    })), this.employerLang);
  }
  /**
   * Get lang for worker reports
   * @param calc selected calculation
   * @returns language for calculation
   */
  getWorkerLang(t) {
    return this.reportLang !== Me.Default ? this.reportLang : (this.workerLangs[t.worker.accountId] || (this.workerLangs[t.worker.accountId] = Me.Default, this.sessionService.getReportLang(t.worker.accountId).then((e) => {
      this.workerLangs[t.worker.accountId] = e, this.$timeout();
    })), this.workerLangs[t.worker.accountId]);
  }
  /** The type for the calculation report. */
  get reportType() {
    return this._reportType;
  }
  /** The type for the calculation report. */
  set reportType(t) {
    t != this._reportType && (this._reportType = t, this.onReportTypeChange && this.onReportTypeChange({ reportType: t }));
  }
  /**
   * Return languge text to ui
   */
  get languageText() {
    switch (this.reportLang) {
      case Me.Fi:
        return "SALAXY.ENUM.Language.fi.label";
      case Me.En:
        return "SALAXY.ENUM.Language.en.label";
      case Me.Sv:
        return "SALAXY.ENUM.Language.sv.label";
      case Me.Default:
        return this.reportType === "salarySlip" || this.reportType === "employerReport" || this.reportType === "paymentReport" ? "SALAXY.NG1.CalcReportsComponent.reportLanguageWorker" : "SALAXY.NG1.CalcReportsComponent.reportLanguageCompany";
    }
  }
  /**
   * Exports tabulator based reports data as excel file
   */
  async downloadExcel() {
    const t = this.uiHelpers.showLoading("SALAXY.UI_Terms.wait"), e = async (i) => {
      const r = this.getEmployerLang() ?? Me.Fi;
      switch (await L.loadLanguage(r), this.reportType) {
        case "totalsReport":
          return E0.getTableData(i, r);
        case "rowsReport":
          return _L.getTableData(i, r);
        case "irRows":
          return N0.getTableData(i, r);
      }
    }, a = {
      totalsReport: "SALAXY.ENUM.ReportType.totalsReport.label",
      rowsReport: "SALAXY.NG1.CalcReportsComponent.rowsReport",
      irRows: "SALAXY.NG1.CalcReportsComponent.irRows"
    }, n = () => ti.escapeFileName(`${L.get(a[this.reportType])}_${I.format("today", "YYYY_MM")}`);
    xr.export(await e(this.calcs), n()), t.dismiss();
  }
  /**
   * Shows a download dialog for the given calculations.
   * @param inline - If true, the download link opens the pdf into a new web page.
   */
  showDownloadDialog(t = !1) {
    const e = this.uiHelpers.showLoading("SALAXY.UI_Terms.loading");
    this.reportsApi.getCalculationReport(this.calcs, this.reportType, this.getEmployerLang(), this.reportLang).then((a) => {
      t ? this.uiHelpers.openFile(a.data) : this.uiHelpers.downloadFile(a.data, decodeURIComponent(a.headers["content-disposition"]).match(/filename\s*=\s*"?(?<file>.*?)(?:\s*;|"|\s*$)/)?.groups?.file), e.dismiss();
    });
  }
  /** Reloads the current report */
  reload() {
    const t = this.reportType;
    this.reportType = null, this.$timeout(0).then(() => {
      this.reportType = t;
    });
  }
  /** Loads epr for the calculation */
  loadEpr(t) {
    if (this.checkForEprChange(t), this._epr.pending[t.id] && !this._epr.loading[t.id]) {
      this._epr.loading[t.id] = !0;
      const e = () => (this._epr.pending[t.id] = !1, this.calculationsApi.convertToEpr(t).then((a) => (this._epr.current[t.id] = this._epr.current[t.id] ?? {}, wt.copy(a, this._epr.current[t.id]), this._epr.current[t.id])));
      e().then(() => {
        this._epr.pending[t.id] ? e() : this._epr.loading[t.id] = !1;
      });
    }
    return this._epr.current[t.id];
  }
  /**
   * Config for SxyTable
   */
  get rowsReportTableConfig() {
    if (!this.calcs)
      this.sxyTableConfig = {
        currentCalc: null,
        reportLang: null,
        config: null
      };
    else {
      const t = wt.copy(this.calcs);
      (!Qe.equal(this.sxyTableConfig.currentCalc, t) || this.reportLang !== this.sxyTableConfig.reportLang) && (this.sxyTableConfig.currentCalc = t, this.sxyTableConfig.reportLang = this.reportLang, this.getDefaultLanguage(this.reportLang).then((e) => {
        this.reportLang = e, this.refreshTableConfig();
      }));
    }
    return this.sxyTableConfig.config;
  }
  async refreshTableConfig() {
    const t = this.reportLang ?? Me.Fi;
    await L.loadLanguage(t), this.sxyTableConfig.config = _L.getConfig(this.calcs, t), await this.$timeout(), this.$sxyTable.refresh();
  }
  async getDefaultLanguage(t) {
    return t ? Promise.resolve(t) : this.sessionService.getReportLang();
  }
  checkForEprChange(t) {
    if (!t?.id)
      return !1;
    wt.equals(t, this._epr.latestCalc[t.id]) || (this._epr.latestCalc[t.id] = wt.copy(t), this._epr.pending[t.id] = !0);
  }
};
a$.$inject = [
  "AjaxNg1",
  "UiHelpers",
  "SessionService",
  "$timeout",
  "$http",
  "Reports",
  "Calculations"
];
let Lm = a$;
const n$ = class n$ {
  /**
   * Creates a new instance of CalcReportsDisplayController
   * @param uiHelpers - Salaxy ui helpers service.
   */
  constructor(t, e) {
    this.uiHelpers = t, this.calculations = e;
  }
  /**
   * Display CalcReports
   * @param reportType Report type
   * @param calculation BusinessObject
   */
  display(t, e) {
    const n = {
      reportType: t,
      calcs: [e]
    };
    this.uiHelpers.showDialog(
      "salaxy-components/modals/calc/CalcReports.html",
      null,
      n,
      null,
      "lg",
      !0
    );
  }
  /**
   * Display CalcReports
   * @param reportType Report type
   * @param calculationId BusinessObject id
   */
  async displayForId(t, e) {
    const n = [await this.calculations.getSingle(e)], i = {
      reportType: t,
      calcs: n
    };
    this.uiHelpers.showDialog(
      "salaxy-components/modals/calc/CalcReports.html",
      null,
      i,
      null,
      "lg",
      !0
    );
  }
};
n$.$inject = [
  "UiHelpers",
  "Calculations"
];
let Tx = n$;
const s$ = class s$ {
  constructor(t, e, a) {
    this.session = t, this.uiHelpers = e, this.rowTypeService = a, this.listCache = null, this.search = (n, i = !1, r = null) => {
      r == null && (r = this.showChildren);
      const l = (c) => ({
        text: c.label,
        value: c.name,
        title: c.descr,
        ui: {
          color: c.color,
          iconText: c.iconText,
          addedByChild: null,
          initials: c.iconText,
          entityType: "company",
          // TODO: Requires refactoring
          group: c.group,
          type: c.type,
          rowType: c.rowType,
          isChild: !1
        }
      }), o = [];
      return n = (n || "").trim().toLowerCase(), this.getRowTypes().forEach((c) => {
        let d = !1, p = !1;
        if (!n || (c.label + c.descr + c.name).toLowerCase().indexOf(n) >= 0) {
          if (o.push(l(c)), !i && o.length >= this.top)
            return o;
          d = !0, p = !0;
        }
        c.kind?.values && c.kind.values.forEach((h) => {
          if (!(h.name == "undefined" || h.name == "unknown") && (p && r || n && (h.label + h.descr + h.name).toLowerCase().indexOf(n) >= 0)) {
            if (!d) {
              const g = l(c);
              g.ui.addedByChild = !0, o.push(g), d = !0;
            }
            if (o.push({
              text: h.label,
              value: c.name + "." + h.name,
              title: h.descr,
              // TODO: Requires refactoring
              ui: {
                group: c.group,
                type: c.type,
                rowType: c.rowType,
                isChild: !0
              }
            }), !i && o.length >= this.top)
              return o;
          }
        });
      }), o.length === 2 && o[0].ui.addedByChild ? [{
        text: o[0].text + ": " + o[1].text,
        value: o[1].value,
        title: o[1].title,
        ui: o[0].ui
      }] : o;
    };
  }
  /** Sets the default values in init. */
  $onInit() {
    this.top = this.top || 50, this.type || (this.type = "typehead");
  }
  /**
   * Detects the changes in the model properties "rowType" and "data.kind"
   * and reflects them to internalValue.
   */
  $doCheck() {
    let t = !1;
    if (this.model?.rowType !== this.modelRowType && (this.modelRowType = this.model?.rowType, t = !0), this.model?.data?.kind !== this.modelDataKind && (this.modelDataKind = this.model?.data?.kind, t = !0), this.model?.type !== this.modelType && (this.modelType = this.model?.type, t = !0), t) {
      const e = this.modelType ? this.modelType.split("/")[2] : this.modelRowType;
      this.modelDataKind ? this._internalValue = this.getList().find((a) => a.value === `${e}.${this.modelDataKind}`) : this._internalValue = this.getList().find((a) => a.value === e);
    }
  }
  /**
   * Internal value from view to the controller. This is one of the numerations returned by getList()
   * if model has been set and it matches to oneof those values.
   */
  get internalValue() {
    return this._internalValue;
  }
  set internalValue(t) {
    if (this._internalValue = t, !!this.model) {
      if (this.model.data = this.model.data || {}, !t)
        this.model.rowType = null, this.model.data.kind = null, this.model.type = null;
      else if (t.value.indexOf(".")) {
        const e = t.value.split(".");
        this.model.rowType = e[0], this.model.data.kind = e[1] || void 0, t.ui && (this.model.type = t.ui.type, this.model.rowType = t.ui.rowType, this.model.config = {
          group: t.ui.group
        });
      } else
        this.model.rowType = t.value, this.model.data.kind = void 0, t.ui && (this.model.type = t.ui.type, this.model.rowType = t.ui.rowType, this.model.config = {
          group: t.ui.group
        });
      this.onRowChanged({ row: this.model });
    }
  }
  /**
   * Gets the list of row types according to options:
   * This list changes and is cached based on role (household/company), language,
   * rowTypes and categories. Currently the same as search(null), but cached.
   */
  getList() {
    return this.uiHelpers.cache(
      this,
      "list",
      () => this.search(null, !0, !0),
      () => L.getLanguage() + this.rowTypes?.join("") + this.categories?.join("")
    );
  }
  /**
   * Gets the search as cached item: Can be bound to ng-repeat.
   * @param searchText The search text. If null or empty, returns the full list.
   */
  getCachedSearch(t) {
    return this.uiHelpers.cache(
      this,
      "search",
      () => this.search(t, !0, null),
      () => t + this.categories?.toString()
    );
  }
  /** Gets a label for the given internal value. */
  getRowLabel(t) {
    if (!t)
      return null;
    let e = null, a = null;
    if (t.indexOf(".")) {
      const r = t.split(".");
      e = r[0], a = r[1], a === "undefined" && (a = null);
    } else
      e = t;
    const n = this.getRowTypes().find((r) => r.name === e);
    if (!n)
      return null;
    const i = n.kind?.values?.find((r) => r.name === a);
    return i ? i.label : n.label;
  }
  /**
   * Shows a dilaog that contains information about the row type.
   * @param rowType The row type to show information about.
   */
  showInfoScreen(t) {
    this.model = this.model || {
      rowIndex: 0,
      data: {
        dimensions: {},
        accounting: {}
      }
    }, this.internalValue = t, this.uiHelpers.openEditDialog("salaxy-components/calc/rows/RowTypeEditDialog.html", this.model, {
      calc: Da.getBlank()
    }, "lg", "CalcRows2019Controller").then((e) => {
    });
  }
  /**
   * Gets the list of row types. Method filters based on rowTypes and categories,
   * the texts are language versioned and there is a role filter for "household"/"company".
   */
  getRowTypes() {
    const t = "" + this.categories + this.rowTypes + this.rowTypeService.isReady;
    if (!this.listCache || this.listCache.key !== t) {
      const e = this.rowTypeService.logic;
      let a;
      if ((this.categories || []).length + (this.rowTypes || []).length > 0) {
        const i = Qe.copy(e.getRowConfigsByCategory(this.categories)), r = i.find((l) => l.name === Wt.IrIncomeType);
        r != null && (r.kind = null), a = e.getRowConfigsByType(this.rowTypes).concat(i);
      } else
        a = e.getRowConfigs();
      const n = [
        Wt.PaidSickLeaveSalary,
        Wt.PaidSickLeaveHourlySalary,
        Wt.PaidSickLeaveMonthlySalary
      ];
      a = a.filter((i) => !(n.indexOf(i.name) >= 0)), this.session.isInSomeRole("pro,admin") || (a = a.filter((i) => i.name != Wt.Service)), this.listCache = { key: t, value: a };
    }
    return this.listCache.value;
  }
};
s$.$inject = ["SessionService", "UiHelpers", "RowTypeService"];
let Dm = s$;
class TE {
  constructor() {
    this.scriptNames = [
      {
        value: "price",
        text: "Hinta"
      },
      {
        value: "count",
        text: "Määrä"
      },
      {
        value: "message",
        text: "Rivin teksti"
      },
      {
        value: "calculation",
        text: "Koko laskelman muokkaus"
      },
      {
        value: "unit",
        text: "Yksikkö"
      },
      {
        value: "sourceId",
        text: "ID lähdejärjestelmässä"
      },
      {
        value: "accounting.dimensions",
        text: "Kustannuspaikat"
      },
      {
        value: "accounting.vatPercent",
        text: "ALV %"
      },
      {
        value: "accounting.vatEntries",
        text: "ALV rivit"
      },
      {
        value: "period",
        text: "Palkkakausi"
      },
      {
        value: "period.start",
        text: "Palkkaukauden alku"
      },
      {
        value: "period.end",
        text: "Palkkaukauden loppu"
      },
      {
        value: "period.daysCount",
        text: "Palkkaukauden työpäivien määrä"
      },
      {
        value: "period.days",
        text: "Palkkaukauden työpäivät"
      }
    ];
  }
  /** Gets the description for a script name */
  getDescription(t) {
    return this.scriptNames.find((e) => e.value === t)?.text;
  }
  /** Returns true if the selected script name has already been added. */
  get selectedScriptAdded() {
    return !!this.row.data.scripting?.[this.selectedScriptName];
  }
  /**
   * Adds a new script expression to the row.
   * @param {string} scriptName - The name of the script to add. selectedScriptName is used if not provided.
   */
  addScript(t) {
    t = t || this.selectedScriptName, this.row.data.scripting = this.row.data.scripting || {}, !this.row.data.scripting[t] && (this.row.data.scripting[t] = "");
  }
  /**
   * Selects a script for editing in full-dialog editor.
   * @param {string} scriptName - The name of the script to edit.
   * Undefined for closing the editor.
   */
  editScript(t) {
    this.editingScriptName = t;
  }
  /**
   * Removes a script from the row.
   * @param {string} scriptName - The name of the script to remove.
   */
  removeScript(t) {
    delete this.row.data.scripting[t];
  }
  /** Gets the scripting property names from the row data */
  get scriptingProperties() {
    return Object.keys(this.row.data?.scripting || {});
  }
}
const i$ = class i$ {
  /**
   * Creates a new CalcWorktimeController
   * @ignore
   */
  constructor(t, e, a, n, i, r) {
    this.uiHelpers = t, this.calcApi = e, this.anonCalcApi = a, this.sessionService = n, this.employmentsApi = i, this.$timeout = r, this.periodStartDateError = null, this.demoData = { startDate: null, endDate: null }, this.isDisabledSalaryDate = (l) => {
      const o = this.sessionService.isInRole("pro") ? "pro" : this.sessionService.isInRole("admin") ? "admin" : null;
      switch (this.calc.workflow.salaryDateKind) {
        case $n.InPast:
          return !1;
        case $n.Default:
        default:
          return !gc.isValidSalaryDate(l, null, null, !0, this.calc.info.paymentChannel, Da.isZeroPayment(this.calc), o);
      }
    };
  }
  /**
   * Implement IController
   */
  $onInit() {
    this.initDateRanges(), this.currentCalc && this.currentCalc.info.workStartDate && this.currentCalc.info.workEndDate && this.reloadHolidays();
  }
  /**
   * Reset the controller to initial state.
   */
  reset() {
    this._dateRange = {}, this._periodStartDate = null, this.worktime ?? (this.worktime = {}), wt.copy(this.calc?.worktime ?? {}, this.worktime);
  }
  /**
   * Loads the employment data for the current worker.
   */
  async loadEmployment() {
    if (this.currentCalc.worker.employmentId) {
      const t = await this.employmentsApi.getSingle(this.currentCalc.worker.employmentId);
      this.workerEmployment = t, this.$timeout();
    } else
      this.workerEmployment = null;
  }
  /**
   * Getter for checking if WorkerHolidays is active.
   */
  get isWorkerHolidaysActive() {
    return this.workerEmployment && this.workerEmployment.holidays ? dn.isWorkerHolidaysActive(this.workerEmployment.holidays) : !1;
  }
  /** Gets the requested salary date */
  get requestedSalaryDate() {
    return this.calc.workflow.requestedSalaryDate;
  }
  set requestedSalaryDate(t) {
    this.calc.workflow.requestedSalaryDate = t, this.calc.workflow.salaryDate = t;
  }
  /**
   * Reloads the holidays from server.
   */
  reloadHolidays() {
    if (this.worktime ?? (this.worktime = {}), !this.sessionService.isInRole("disableHolidays"))
      if (wt.copy(this.calc.worktime ?? {}, this.worktime), this.sessionService.isAuthenticated) {
        if (this.calc?.isReadOnly || this.calc?.workflow?.status === le.PaymentStarted)
          return;
        this.calcApi.getWorktimeData(this.calc).then((t) => wt.copy(t, this.worktime));
      } else
        this.checkDemoData(), this.anonCalcApi.getWorktimeData(this.calc, this.demoData.holidays, this.demoData.absences).then((t) => wt.copy(t, this.worktime));
  }
  /** Holiday year has been changed and must be saved and reloaded. */
  holidaysChanged(t) {
    t.save().then(() => {
      this.reloadHolidays();
    });
  }
  /** Absences has been changed and must be saved and reloaded. */
  absencesChanged(t) {
    t.save().then(() => {
      this.reloadHolidays();
    });
  }
  /** Gets the current calculation object */
  get currentCalc() {
    return this.calc;
  }
  /**
   * Returns true if there is no net salary payment to worker at all.
   */
  get isCurrentZeroPayment() {
    return Da.isZeroPayment(this.calc);
  }
  /** Getter and setter for Calculation daterange in compatible format for new DateRange component. */
  get dateRange() {
    const t = (this.currentCalc || {}).info, e = (this.currentCalc || {}).framework;
    return this._dateRange || (this._dateRange = {
      start: t.workStartDate,
      end: t.workEndDate,
      daysCount: e.numberOfDays
    }), this._dateRange;
  }
  set dateRange(t) {
    this._dateRange = t;
  }
  /** Returns true if the holidays uses accrual. */
  get isHolidayAccrual() {
    return this.worktime?.holidaySpec ? this.worktime.holidaySpec.code == Se.Permanent14Days || this.worktime.holidaySpec.code == Se.Permanent35Hours || this.worktime.holidaySpec.code == Se.TemporaryTimeOff || this.worktime.holidaySpec.code == Se.Other : !1;
  }
  /** Returns true if holidays are accrued for this calc. */
  get accruesHolidays() {
    return this.worktime?.accrualSpec ? this.worktime.accrualSpec.code == Se.Permanent14Days || this.worktime.accrualSpec.code == Se.Permanent35Hours || this.worktime.accrualSpec.code == Se.TemporaryTimeOff || this.worktime.accrualSpec.code == Se.Other : !1;
  }
  /**
   * Called when the date range changes.
   * @param noPeriodStartDateUpdate If true, the _periodStartDate is not updated.
   * Should be true if the change is triggered by that input to avoid UI flickering.
   */
  dateRangeChange(t = !1) {
    const e = (this.currentCalc || {}).info, a = (this.currentCalc || {}).framework;
    e.workStartDate = this.dateRange.start, t || (this._periodStartDate = I.format(this.dateRange.start, "D.M.", null)), e.workEndDate = this.dateRange.end, a.numberOfDays = this.dateRange.daysCount, this.reloadHolidays();
  }
  /**
   * Gets or sets the period start date, which is bound to editable input in case the period type
   * is not "other" (date the range / calendar component)
   */
  get periodStartDate() {
    return this._periodStartDate;
  }
  set periodStartDate(t) {
    this._periodStartDate = t;
    const e = (t || "").split(".");
    if (e.length < 2 || e.length > 3) {
      this.periodStartDateError = "SALAXY.NG1.CalcWorktimeComponent.periodStartDateErrorFormat";
      return;
    }
    let a = e.length === 3 ? Number((e[2] || "").trim()) : null;
    (!a || a < 2019 || a > 2100) && (a = Number(this.dateRange.start.substr(0, 4)));
    const n = I.getDate(a, Number(e[1]), Number(e[0]));
    if (n) {
      switch (this.periodStartDateError = null, this.periodShortcut) {
        case "monthCurrent":
        case "monthLast":
        case "monthOther":
          this.dateRange = I.getDateRange(n, I.add(I.add(n, 1, "month"), -1, "day"));
          break;
        case "weeks2":
          this.dateRange = I.getDateRange(n, I.add(I.add(n, 2, "week"), -1, "day"));
          break;
        case "monthHalf":
          I.getDay(n) === 15 || I.getDay(n) === 16 ? this.dateRange = I.getDateRange(n, I.startEnd(n, "end-month")) : this.dateRange = I.getDateRange(n, I.add(n, 14, "day"));
          break;
        case "other":
          this.dateRange = I.getDateRange(n, n);
          break;
      }
      this.dateRangeChange(!0);
    } else
      this.periodStartDateError = t + " " + L.get("SALAXY.NG1.CalcWorktimeComponent.periodStartDateErrorNotDate");
  }
  /**
   * Gets the user interface shortcut for the period type:
   * Different user interfaces are shown depending on the period shortcut.
   */
  get periodShortcut() {
    return !this.dateRange.start || !this.dateRange.end ? null : this.dateRange.start === I.getDate("today", "today", 1) && this.dateRange.end === I.startEnd("today", "end-month") ? "monthCurrent" : this.dateRange.start === I.add(I.startEnd("today", "start-month"), -1, "month") && this.dateRange.end === I.startEnd(I.add(I.startEnd("today", "start-month"), -1, "month"), "end-month") ? "monthLast" : this.dateRange.end === I.add(I.add(this.dateRange.start, 1, "month"), -1, "day") ? "monthOther" : this.dateRange.end === I.add(I.add(this.dateRange.start, 2, "week"), -1, "day") ? "weeks2" : I.getDuration(this.dateRange.start, this.dateRange.end).days() === 14 || I.getDay(this.dateRange.start) === 15 && this.dateRange.end === I.startEnd(this.dateRange.start, "end-month") || I.getDay(this.dateRange.start) === 16 && this.dateRange.end === I.startEnd(this.dateRange.start, "end-month") ? "monthHalf" : "other";
  }
  set periodShortcut(t) {
    switch (this.periodStartDateError = null, t) {
      case "monthCurrent":
        this.dateRange.start = I.startEnd("today", "start-month"), this.dateRange.end = I.startEnd("today", "end-month");
        break;
      case "monthOther":
        I.getDay("today") === 1 ? this.dateRange.start = I.add("today", 1, "day") : this.dateRange.start = I.asDate("today"), this.dateRange.end = I.add(I.add(this.dateRange.start, 1, "month"), -1, "day");
        break;
      case "monthLast":
        this.dateRange.start = I.add(I.startEnd("today", "start-month"), -1, "month"), this.dateRange.end = I.startEnd(this.dateRange.start, "end-month");
        break;
      case "weeks2":
        this.dateRange.start = I.add(I.startEnd("today", "start-week"), -2, "week"), this.dateRange.end = I.add(I.startEnd("today", "start-week"), -1, "day");
        break;
      case "monthHalf":
        I.getDay("today") < 16 ? (this.dateRange.start = I.add(I.add(I.startEnd("today", "start-month"), -1, "month"), 15, "day"), this.dateRange.end = I.startEnd(this.dateRange.start, "end-month")) : (this.dateRange.start = I.startEnd("today", "start-month"), this.dateRange.end = I.add(this.dateRange.start, 14, "day"));
        break;
      case "other":
        this.dateRange.start = I.add("today", -1, "day"), this.dateRange.end = I.asDate("today");
        break;
    }
    this.dateRange = I.getDateRange(this.dateRange.start, this.dateRange.end), this.dateRangeChange();
  }
  /**
   * Submit the data in the Worktime (period) dialog.
   */
  submitWorktime() {
    const t = this.uiHelpers.showLoading("SALAXY.NG1.CalcWorktimeComponent.submitWorktimeTitle");
    wt.copy(this.worktime, this.calc.worktime), this.calcApi.recalculateWorktime(this.calc).then((e) => {
      wt.copy(e, this.calc), wt.copy(this.calc.worktime, this.worktime), t.dismiss(), new kE(this.currentCalc).setActive("salary");
    });
  }
  /** Returns true if the current worktime data seems to have holidays or absences to add as rows in the salary calculation.  */
  hasHolidaysOrAbsences() {
    return this.worktime?.holidaySpec?.code === Se.HolidayCompensation || this.worktime?.holidaySpec?.code === Se.HolidayCompensationIncluded || (this.worktime?.absencesPeriods ?? []).length > 0;
  }
  /**
   * Returns the logic for the worktime data related lists
   * @returns Logic object for the lists.
   */
  getLogicForLists() {
    const t = {
      getAbcencesForPeriod: () => this.worktime.absencesPeriods.filter((e) => e.causeCode != Ge.AnnualLeave),
      getAbcensePeriodsTotalDays: (e = "all") => {
        const a = t.getAbcencesForPeriod();
        switch (e) {
          case "all":
            return ie.sum(a, (n) => n.period.daysCount);
          case "absencesPaid":
            return ie.sum(a.filter((n) => n.isPaid), (n) => n.period.daysCount);
          case "absencesUnpaid":
            return ie.sum(a.filter((n) => !n.isPaid), (n) => n.period.daysCount);
          case "absencesHolidayAccrual":
            return ie.sum(a.filter((n) => n.isHolidayAccrual), (n) => n.period.daysCount);
          case "absencesNoHolidayAccrual":
            return ie.sum(a.filter((n) => !n.isHolidayAccrual), (n) => n.period.daysCount);
        }
      },
      getAnnualLeavesForPeriod: () => this.worktime.absencesPeriods.filter((e) => e.causeCode == Ge.AnnualLeave),
      getAnnualLeaveDescription: (e) => e.notes ? e.notes : e.period.start < `${I.getYear(this.worktime.workDays.start)}-10-1` ? L.get("SALAXY.NG1.CalcWorktimeComponent.lists.annualLeaves.summerHoliday") : L.get("SALAXY.NG1.CalcWorktimeComponent.lists.annualLeaves.winterHoliday"),
      getAnnualLeavesTotalDays: () => {
        const e = t.getAnnualLeavesForPeriod();
        return ie.sum(e, (a) => a.period.daysCount);
      },
      getAnnualLeavesBonusDays: () => {
        const e = t.getAnnualLeavesForPeriod();
        return ie.sum(e, (a) => a.bonusDaysCount ?? 0);
      },
      getholidayPayCalculationOptions: () => this.uiHelpers.cache(this, "holidayPayCalculationOptions", () => {
        switch (this.worktime.holidaySpec?.code) {
          case Se.Permanent14Days:
            return this.worktime.holidaySpec?.wageBasis === qs.Monthly ? [
              { text: L.get("SALAXY.ENUM.HolidayPayCalculation.normalMonthlyPay.label"), value: Be.NormalMonthlyPay },
              { text: L.get("SALAXY.ENUM.HolidayPayCalculation.otherPay.label"), value: Be.OtherPay }
            ] : [
              { text: L.get("SALAXY.ENUM.HolidayPayCalculation.averageDailyPay.label"), value: Be.AverageDailyPay },
              { text: L.get("SALAXY.ENUM.HolidayPayCalculation.averageHourlyPay.label"), value: Be.AverageHourlyPay },
              { text: L.get("SALAXY.ENUM.HolidayPayCalculation.otherPay.label"), value: Be.OtherPay }
            ];
          case Se.Permanent35Hours:
            return this.worktime.holidaySpec?.wageBasis === qs.Monthly ? [
              { text: L.get("SALAXY.ENUM.HolidayPayCalculation.normalMonthlyPay.label"), value: Be.NormalMonthlyPay },
              { text: L.get("SALAXY.ENUM.HolidayPayCalculation.percentageBasedPay.label"), value: Be.PercentageBasedPay },
              { text: L.get("SALAXY.ENUM.HolidayPayCalculation.otherPay.label"), value: Be.OtherPay }
            ] : [
              { text: L.get("SALAXY.ENUM.HolidayPayCalculation.percentageBasedPay.label"), value: Be.PercentageBasedPay },
              { text: L.get("SALAXY.ENUM.HolidayPayCalculation.otherPay.label"), value: Be.OtherPay }
            ];
          case Se.TemporaryTimeOff:
            if (this.worktime.holidaySpec?.wageBasis === qs.Monthly || this.worktime.holidaySpec?.wageBasis === qs.PerformanceBased || this.worktime.holidaySpec?.wageBasis === qs.Hourly)
              return [
                { text: L.get("SALAXY.ENUM.HolidayPayCalculation.holidayCompensation.label"), value: Be.HolidayCompensation },
                { text: L.get("SALAXY.ENUM.HolidayPayCalculation.otherPay.label"), value: Be.OtherPay }
              ];
            break;
          case Se.Other:
            return this.worktime.holidaySpec?.wageBasis === qs.Monthly ? [
              { text: L.get("SALAXY.ENUM.HolidayPayCalculation.normalMonthlyPay.label"), value: Be.NormalMonthlyPay },
              { text: L.get("SALAXY.ENUM.HolidayPayCalculation.percentageBasedPay.label"), value: Be.PercentageBasedPay },
              { text: L.get("SALAXY.ENUM.HolidayPayCalculation.holidayCompensation.label"), value: Be.HolidayCompensation },
              { text: L.get("SALAXY.ENUM.HolidayPayCalculation.otherPay.label"), value: Be.OtherPay }
            ] : [
              { text: L.get("SALAXY.ENUM.HolidayPayCalculation.averageDailyPay.label"), value: Be.AverageDailyPay },
              { text: L.get("SALAXY.ENUM.HolidayPayCalculation.averageHourlyPay.label"), value: Be.AverageHourlyPay },
              { text: L.get("SALAXY.ENUM.HolidayPayCalculation.percentageBasedPay.label"), value: Be.PercentageBasedPay },
              { text: L.get("SALAXY.ENUM.HolidayPayCalculation.holidayCompensation.label"), value: Be.HolidayCompensation },
              { text: L.get("SALAXY.ENUM.HolidayPayCalculation.otherPay.label"), value: Be.OtherPay }
            ];
          default:
            return [];
        }
      })
    };
    return t;
  }
  /** Shows the pro-dialog */
  showPeriodDetails() {
    const t = {
      worktime: this.worktime,
      logic: this.getLogicForLists()
    };
    this.uiHelpers.showDialog("salaxy-components/calc/details/worktime-pro.html", null, t, null, "lg");
  }
  /**
   * Gets the status for the current holidays and absences fetching.
   * These are fetched from the server when the period and / or worker changes.
   */
  getHolidaysStatus() {
    return !this.currentCalc.worker?.employmentId && this.sessionService.isAuthenticated ? "noWorker" : !this.currentCalc.info.workStartDate || !(this.currentCalc.framework.numberOfDays > 0) ? "noPeriod" : this.worktime?.holidaySpec == null ? "loading" : "ok";
  }
  /**
   * Gets the monthly text for calendar month for accruals.
   * @param type Type of the text is either header or description.
   */
  getAccrualMonthText(t, e) {
    switch (t === "header" && (e = I.getMonth(e.month)), t) {
      case "header":
        return e ? L.get(`SALAXY.ENUM.CalendarMonth.month${e}.label`) : "#err month";
      case "description":
        switch (this.worktime.accrualSpec.code) {
          case Se.Permanent14Days:
            return "SALAXY.NG1.CalcWorktimeComponent.getAccrualMonthText.permanent14Days";
          case Se.Permanent35Hours:
            return "SALAXY.NG1.CalcWorktimeComponent.getAccrualMonthText.permanent35Hours";
          case Se.TemporaryTimeOff:
            return "SALAXY.NG1.CalcWorktimeComponent.getAccrualMonthText.temporaryTimeOff";
          case Se.Other:
            return "SALAXY.NG1.CalcWorktimeComponent.getAccrualMonthText.other";
          default:
            return "SALAXY.NG1.CalcWorktimeComponent.getAccrualMonthText.default";
        }
    }
    return "#err " + t;
  }
  /**
   * Gets the accrual explanation text. This is currently not in use.
   * TODO: translate
   */
  getAccrualText(t) {
    return this.worktime.accrualSpec.code === Se.Permanent14Days ? t.workDays < 14 ? `${t.workDays} pv < 14 pv => Ei lomakertymää.` : `${t.workDays} pv > 14 pv => Lomakertymä ${t.daysAccrued} pv.` : this.worktime.accrualSpec.code === Se.Permanent35Hours ? t.workHours == null ? `Ei tietoa tunneista, oletus yli 35h => Lomakertymä ${t.daysAccrued} pv.` : t.workHours < 35 ? `${t.workHours} h < 35 h => Ei lomakertymää.` : `${t.workHours} h > 35 h => Lomakertymä ${t.daysAccrued} pv.` : this.worktime.accrualSpec.code === Se.TemporaryTimeOff ? `Vapaan ansaintasäännössä lomapäivien kertymä on aina ${t.daysAccrued} pv / kalenterikuukausi.` : this.worktime.accrualSpec.code === Se.Other ? L.get("SALAXY.ENUM.HolidayCode.other.description") : "Ei lomapäivien kertymää.";
  }
  /**
   * Opens the dialog for editing calculation payments
   */
  openCalcLeavesDialog() {
    const t = { calc: this.currentCalc, worktime: this.worktime };
    this.uiHelpers.openEditDialog("salaxy-components/modals/calc/CalcLeaves.html", t, null, "lg").then((e) => {
      e.result && (this.worktime.absencesPeriods = e.result.absencesPeriods);
    });
  }
  /** Checks if the period has changed and if so resets the demo data. */
  checkDemoData() {
    if (this.currentCalc.info.workStartDate == this.demoData.startDate && this.currentCalc.info.workEndDate == this.demoData.endDate)
      return;
    let t = null, e = null;
    if (this.currentCalc.info.workStartDate && this.currentCalc.info.workEndDate) {
      const a = I.getWorkdays(this.currentCalc.info.workStartDate, this.currentCalc.info.workEndDate);
      a.length > 5 && (t = a[Math.round(a.length / 2)], e = a[Math.round(a.length / 2) + 1]);
    }
    if (this.demoData = this.demoData || {}, this.demoData.startDate = this.currentCalc.info.workStartDate, this.demoData.endDate = this.currentCalc.info.workEndDate, !t) {
      this.demoData.holidays = null, this.demoData.absences = null;
      return;
    }
    this.demoData.holidays = {
      year: I.getYear(t),
      employmentId: null,
      spec: {
        wageBasis: qs.Monthly
      }
    }, this.demoData.absences = {
      employmentId: null,
      periods: [
        {
          causeCode: Ge.Illness,
          notes: "Poissaolo demodatassa",
          period: {
            start: e,
            end: e,
            daysCount: 1,
            days: e
          }
        }
      ]
    };
  }
  initDateRanges() {
    const t = I.getMonth(I.getToday());
    this.periodShortcuts = {
      monthCurrent: L.get(`SALAXY.ENUM.CalendarMonth.month${t}.label`),
      monthLast: L.get(`SALAXY.ENUM.CalendarMonth.month${t === 1 ? 12 : t - 1}.label`),
      monthOther: L.get("SALAXY.NG1.DateRange.otherMonth"),
      // monthMulti: "Monta kuukautta",
      weeks2: L.get("SALAXY.UI_Terms.week2"),
      monthHalf: L.get("SALAXY.UI_Terms.monthHalf"),
      other: L.get("SALAXY.UI_Terms.otherPeriod")
    }, this._periodStartDate = I.format(this.dateRange.start, "D.M.", null);
  }
  /** Programmatic tab change via a UI link text. */
  changeTab(t) {
    const e = document.querySelector(`#tabs-buttons-calcWorktime #${t}-tab-button`);
    e && e.click();
  }
};
i$.$inject = [
  "UiHelpers",
  "Calculations",
  "Calculator",
  "SessionService",
  "Employments",
  "$timeout"
];
let Im = i$;
const r$ = class r$ {
  constructor(t) {
    this.uiHelpers = t, this._options = [], this._newDimensions = [];
  }
  /** Copy of inherited dimensions */
  get inherited() {
    return this._inherited;
  }
  /** Copy of inherited dimensions */
  set inherited(t) {
    this._inherited = wt.copy(t);
  }
  /**
   * Returns true if the dimension values are inherited.
   */
  isInherited() {
    return this.row.accounting.dimensions.some((t) => t.id === this.definition.id && !!t.value) ? !1 : !!this.cleanDimensions(this.inherited)?.some((t) => t.id === this.definition.id);
  }
  /**
   * Determines if cost sharing is enabled based on the current definition.
   * @returns {boolean} True if cost sharing is allowed, otherwise false.
   */
  isCostSharingEnabled() {
    const t = this.row.accounting.dimensions.map((e) => e.id);
    return t.length !== new Set(t).size ? !0 : this.definition.allowCostSharing;
  }
  /**
   * Retrieves the cost sharing values for the current row dimension.
   * This method uses a caching mechanism to store the computed values for performance optimization. It truncates the text values to a maximum of 10 characters, appending "..." if the text exceeds this length
   * If the dimension is inherited, it filters and maps the inherited dimensions to the required format. Otherwise, it uses the current row's accounting dimensions.
   */
  getCostSharingValues() {
    return this.uiHelpers.cache(this, "costSharingValues", () => {
      const t = (e) => e.length <= 10 ? e : e.substring(0, 10) + "...";
      return this.isInherited() ? this.cleanDimensions(this.inherited).filter((e) => e.id === this.definition.id).map((e) => ({ text: t(this.definition.options.find((a) => a.value === e.value).text), value: e.percent })) : this.row.accounting.dimensions.filter((e) => e.id === this.definition.id).map((e) => ({ text: t(this.definition.options.find((a) => a.value === e.value).text), value: e.percent }));
    });
  }
  /**
   * Returns inherited single value.
   */
  getInheritedSingleValue() {
    return (this.cleanDimensions(this.inherited) ?? []).find((t) => t.id === this.definition.id);
  }
  /**
   * Sets single value.
   */
  setSingleValue(t) {
    const e = this.row.accounting.dimensions?.find((a) => a.id === this.definition.id);
    e ? e.value = t : this.row.accounting.dimensions.push({ id: this.definition.id, value: t });
  }
  /**
   * Returns single value.
   */
  getSingleValue() {
    let t = this.row.accounting.dimensions?.find((e) => e.id === this.definition.id) ?? this._newDimensions.find((e) => e.id === this.definition.id);
    return !t && !this.readOnly && (t = { id: this.definition.id }, this._newDimensions.push(t)), t;
  }
  /**
   * Returns true if options exists for the dimension.
   * @returns True, if an option exists for the value.
   */
  hasOptions() {
    return this.getOptions().filter((e) => e.value).length > 0;
  }
  /**
   * Returns available options for dimension.
   */
  getOptions() {
    this._options || (this._options = []);
    let t = [];
    return this.definition && (t = this.definition.options.filter(
      (e) => e.scope !== gs.Hidden && // show if scope definition for dimension not given
      (!e.scope || e.scope === gs.None || // or this scope
      gs.Row === e.scope)
    ).map((e) => ({ value: e.value, text: e.text })), t.unshift({ value: "", text: L.get("SALAXY.UI_Terms.notChosen") })), this.modifyOptions(t, this._options), this._options;
  }
  cleanDimensions(t) {
    return t && t.filter((a) => a?.value && a?.id);
  }
  modifyOptions(t, e) {
    wt.equals(t, e) || (e.splice(0, e.length), e.push(...t));
  }
};
r$.$inject = ["UiHelpers"];
let Pm = r$;
const l$ = class l$ {
  /**
   * Constructor to initialize the controller with dependencies.
   * @param uiHelpers - Helper utilities for UI operations.
   * @param $timeout - Angular's timeout service.
   */
  constructor(t, e) {
    this.uiHelpers = t, this.$timeout = e, this.allExamples = [], this.tabOptions = [];
  }
  /**
   * Lifecycle hook that is called after the controller's data-bound properties have been initialized.
   * Fetches example data from the CDN and updates the loading state.
   */
  $onInit() {
    this._isLoading = !0, this.fetchExamplesFromCdn().then((t) => {
      this.allExamples = t, this.generateExampleLocally(), this._isLoading = !1, this.$timeout();
    });
  }
  /**
   * Determines if the loader should be displayed.
   * @returns {boolean} True if the loader should be shown, false otherwise.
   */
  showLoader() {
    return this._isLoading;
  }
  /**
   * Fetches a file from the CDN.
   */
  async fetchExamplesFromCdn() {
    const t = Ne.current.isTestData ? "https://cdn.salaxy.com/docs/row-types/samples/test/examples.json" : "https://cdn.salaxy.com/docs/row-types/samples/prod/examples.json";
    try {
      const e = await fetch(t);
      return e.ok || console.error(`HTTP error! status: ${e.status}`), (await e.json()).examples;
    } catch (e) {
      return console.error("Error fetching file from CDN:", e), [];
    }
  }
  /**
   * Gets the description text for the current example type.
   */
  get example() {
    return this.allExamples?.find((t) => t.type === this.row?.config.type);
  }
  /**
   * Generates a local example for the current row type and selected kind.
   * This method:
   * 1. Checks if there is a valid row to generate an example for
   * 2. Determines if the row has a kind configuration
   * 3. If conditions are met:
   * - Finds or creates an example for the current row type
   * - Removes any existing generated examples
   * - Creates a new sample with generated code
   * - Adds the sample to the examples collection
   * 4. Triggers Angular digest cycle via $timeout
   */
  generateExampleLocally() {
    if (!this.row)
      return;
    const t = this.row.config, e = t.type, a = t?.kind?.name;
    if (!a && !this.selectedKind || a && this.selectedKind) {
      const n = this.allExamples.find((r) => r.type === e);
      n && (n.samples = n.samples.filter((r) => r.description !== "Generated example"));
      const i = {
        code: this.generateCodeExample(),
        description: "Generated example",
        kind: a ? this.selectedKind : null
      };
      if (n)
        n.samples.push(i);
      else {
        const r = `Examples for ${this.row.rowType}`;
        this.allExamples.push({
          type: e,
          description: r,
          samples: [i]
        });
      }
    }
    this.$timeout();
  }
  /**
   * Gets the code samples for the current row type and kind.
   * Results are cached based on the type and kind combination.
   */
  get exampleSamples() {
    return this.uiHelpers.cache(this, "exampleSamples", () => {
      this.tabOptions = [];
      const t = this.allExamples.find((n) => n.type === this.row?.config.type), e = this.row.config?.kind?.name;
      if (e && !this.selectedKind)
        return [];
      const a = t?.samples?.filter((n) => !e || n.kind === this.selectedKind) ?? [];
      for (let n = 1; n < a.length + 1; n++)
        this.tabOptions.push({ value: "tab" + n, text: n });
      return a;
    }, () => `${this.row?.config.type}-${this.selectedKind}`);
  }
  generateCodeExample() {
    const t = this.row.config;
    if (t?.kind?.name) {
      const a = Jo.getUsecaseExampleData(this.row.rowType, this.selectedKind), n = Object.assign({}, a);
      delete n.kind;
      const i = JSON.stringify(n, null, 2).replace(/^{/, `{
  "kind": ` + t.kind.name + "." + this.selectedKind.substr(0, 1).toUpperCase() + this.selectedKind.substr(1) + ",");
      return `import {CalculatorLogic, CalculationRowType, RowsUsecaseLogic, ${t.kind.name}} from "@salaxy/core"; 
//Make an entry for row
const row = RowsUsecaseLogic.getBlankUsecaseRow(CalculationRowType.${this.row.rowType.substr(0, 1).toUpperCase() + this.row.rowType.substr(1)});
row.data = ${i} 
// Add created row to new calculation
const calculation = CalculatorLogic.getBlank();
calculation.rows.push(row);`;
    } else
      return `import {CalculatorLogic, CalculationRowType, RowsUsecaseLogic} from "@salaxy/core"; 
//Make an entry for row
const row = RowsUsecaseLogic.getBlankUsecaseRow(CalculationRowType.${this.row.rowType.substr(0, 1).toUpperCase() + this.row.rowType.substr(1)});
// Add created row to new calculation
const calculation = CalculatorLogic.getBlank();
calculation.rows.push(row);`;
  }
};
l$.$inject = [
  "UiHelpers",
  "$timeout"
];
let Em = l$;
class oW extends $r {
  constructor() {
    super(...arguments), this.title = "@", this.showEditButtons = "<", this.showGrossTotals = "<", this.rows = "<", this.categories = "<", this.statuses = "<", this.rowTypeSelectHelp = "@", this.rowTypes = "<", this.rowSources = "@", this.dimensions = "<", this.type = "@", this.hideFinalCostRow = "<", this.definitionEditor = "<", this.defaultDimension = "@", this.dimensionCount = "<", this.showRowSelection = "<";
  }
}
const Yy = class Yy extends Ki {
  /**
   * Creates a new CalcRows2019Controller
   * @param uiHelpers - Salaxy UI helpers service.
   * @ignore
   */
  constructor(t, e, a, n, i, r) {
    super(t), this.$timeout = e, this.session = a, this.$element = i, this.rowTypeService = r, this.usecase = {}, this.hideFinalCostRow = !1, this.dimensionCount = 0, this._dimensions = void 0, n.logic?.calc && (this.parent = n.logic.calc, n.logic.definitionEditor ? (this.definitionEditor = n.logic.definitionEditor, this.isDialog = !1) : this.isDialog = !0, this.current = n.current);
  }
  /** Sets the default values in init. */
  $onInit() {
    this.newRow = this.getBlank();
  }
  /** Yearlysidecosts for translations, used in template */
  get yearlySideCosts() {
    const t = I.getToday(), e = I.add(t, -1, "year");
    return {
      current: this.formatYearlyNumbers(
        gr.getYearlyChangingNumbers(t)
      ),
      previous: this.formatYearlyNumbers(
        gr.getYearlyChangingNumbers(e)
      )
    };
  }
  /**
   * Marks that the editor is stand-alone, meaning that it does not edit a calculation,
   * but it just edits a set of rows, typically in employment or settings.
   * In this case the editor has creaed a fake calculation (because calculation is currently required for the row editor to work).
   * TODO: Consider separating Calculation rows editor from stand-alone row editor.
   */
  get isStandAlone() {
    return !!this.parent?.usecase?.data?.standAloneRows;
  }
  /** Copies the given text to clipboard. */
  copyToClipboard(t) {
    navigator.clipboard.writeText(t);
  }
  /** List of rows  */
  get list() {
    if (!this.parent)
      if (this.rows)
        this.parent = Da.getBlank(), this.parent.usecase.data.standAloneRows = !0, this.parent.isReadOnly = this.mode == "read-only";
      else
        return null;
    return Da.moveSalaryToRows(this.parent), this.rows && this.parent.rows !== this.rows && (this.parent.rows = this.rows), this.parent.rows;
  }
  /** List filtered by categories and rowTypes. */
  get filteredList() {
    const t = this.rowTypesToShow.map((n) => n), e = ie.assureArray(this.statuses), a = ie.assureArray(this.rowSources);
    return t.length === 0 && e.length === 0 && a.length === 0 ? this.list : this.list.filter(
      (n) => (!t.length || t.indexOf(n.rowType) >= 0) && (!e.length || e.indexOf(n.status) >= 0) && // HACK: rowSources property should be completely removed when moving default row display to RowTypeSettings editor
      (!a.length || n.source != On.PriceEmployment)
    );
  }
  /** Combines together categories and rowTypes properties as one list of row types. */
  get rowTypesToShow() {
    const t = new Gi(
      this.session.isInRole("household") ? "household" : "company"
    ), e = [...this.rowTypes || []];
    if (this.categories)
      for (const a of this.categories)
        e.push(...t.getRowTypesByCategory(a));
    return e;
  }
  /** Creating of a new item. */
  getBlank() {
    return $0.getBlank(this.list?.filter((e) => e.rowIndex >= 0).length || 0);
  }
  /**
   * Returns a validation message for a row or null if none is required.
   * @param row The row that is validated.
   */
  getValidation(t) {
    return Jo.getValidation(t);
  }
  /** Template for edit UI that is shown in a modal dialog. */
  getEditDialogTemplateUrl() {
    return "salaxy-components/calc/rows/CalcRows2019EditDialog.html";
  }
  /** checks if the image fileUrl given in the cost line is not a blob (omapalkka image upload adds blob) */
  showImagePreview() {
    return this.current?.data?.fileUrl && !this.current?.data?.fileUrl.startsWith("blob:");
  }
  /**
   * Gets the UX configuration for a row.
   * @param row Row for which the config is fetched.
   * If not set, gets the config for current.
   */
  getConfig(t = null) {
    return this.rowTypeService.getConfig(t || this.current);
  }
  /**
   * Gets the placeholder text for an input.
   */
  getPlaceholderText(t, e) {
    if (!t.rowType)
      return "";
    const a = this.getConfig(t);
    return e === "amount" ? a.amount.label : a.price.label;
  }
  /**
   * Return the total for the row
   */
  getRowTotal(t) {
    return t == null ? null : t.count == null ? t.price : t.count * t.price;
  }
  /**
   * Returns true, if the row is disabled. The row is interpreted as disabled if it has no rowType
   * or it has been set as hidden in the configuration.
   * @param row Row to check
   * @param field Type of the input / field.
   */
  isDisabled(t, e) {
    if (!t?.rowType)
      return !0;
    const a = this.getConfig(t);
    if (!a?.amount || !a?.price)
      return console.debug("Row config not found for row", t), !1;
    switch (e) {
      case "amount":
        return a.amount.input === "hidden";
      case "price":
        return a.price.input === "hidden";
      default:
        return !1;
    }
  }
  /**
   * Updates the compensation row with the calculated price based on the unit type.
   * @param row - The row containing both the main row price and compensation row data.
   */
  updateCompensationRow(t) {
    const e = t.data.compensationRows[0];
    let a = 0;
    switch (e.unit) {
      case "percent":
        a = t.price * e.count;
        break;
      case "hours":
        a = e.price;
        break;
    }
    e.price = a;
  }
  /** Row type changes on a row */
  rowTypeChanged(t) {
    this.rowTypeService.applyDefaultsToNewRow(t, this.parent?.workflow?.salaryDate ?? "today");
  }
  /**
   * Commits the new row in newRow property and adds it to the rows list.
   * Updates usecase and sets the newRow as new blank row.
   */
  commitNewRow(t = !1) {
    if (!this.newRow?.rowType)
      return console.error("No row type set for the new row."), null;
    const e = this.newRow;
    return this.updateUsecase(e), this.list.push(e), this.rowTypeChanged(e), this.$timeout(() => {
      this.newRow = this.getBlank();
    }, 300), t ? this.showEdit(e, "auto") : this.$timeout(() => {
      let a = null;
      this.isDisabled(e, "amount") ? a = this.$element[0].querySelector(
        "#iptPrice" + e.rowIndex
      ) : a = this.$element[0].querySelector(
        "#iptCount" + e.rowIndex
      ), a && a.focus();
    }, 500), e;
  }
  /** Shows the selection dialog for the row type. */
  showRowTypeSelectionDialog() {
    this.uiHelpers.openEditDialog(
      "salaxy-components/modals/calc/row-type-select.html",
      this.newRow,
      {
        categories: this.categories,
        rowTypes: this.rowTypes,
        rowTypeSelectHelp: this.rowTypeSelectHelp
      }
    ).then((t) => {
      t.action === "ok" && t.hasChanges && this.showEdit(this.commitNewRow(), "auto");
    });
  }
  /** Updates the usecase property values without going to server. */
  updateUsecase(t) {
    this.getUsecaseLogic(t);
  }
  /**
   * Returns the usecase logic instance for current row, also running the first update cycle on the row.
   */
  getUsecaseLogic(t) {
    return Jo.getUsecaseLogicForCalc(t, this.parent, !0);
  }
  /**
   * Gets vehicle type selections from usecase
   * @returns InputEnumOption[] of vehicle selections
   */
  getVehicleTypeSelection() {
    if (!this._vehicleTypeSelection) {
      this._vehicleTypeSelection = [];
      const t = Jo.getUsecaseLogicForCalc(
        this.current,
        this.parent,
        !0
      ).getVehicleTypeSelection();
      this._vehicleTypeSelection.push(...t);
    }
    return this._vehicleTypeSelection;
  }
  /**
   * Gets vehicle additions from usecase
   * @returns InputEnumOption[] of vehicle additions
   */
  getVehicleAdditions() {
    if (!this._vehicleAdditions) {
      this._vehicleAdditions = [];
      const t = Jo.getUsecaseLogicForCalc(
        this.current,
        this.parent,
        !0
      ).getAdditionsSelection();
      this._vehicleAdditions.push(...t);
    }
    return this._vehicleAdditions;
  }
  /**
   * Gets the regions for InternationalDailyAllowance as of today
   */
  get dailyAllowanceRegions() {
    if (!this._dailyAllowanceRegions) {
      this._dailyAllowanceRegions = [];
      const t = [];
      Object.entries(gr.getYearlyTaxFreeNumbers("today").countries).forEach(
        (e) => {
          t.push({
            text: `${L.get(
              `SALAXY.CORE.yearlyTaxfreeYears.countries.${e[0]}`
            )} (${e[1]}€)`,
            value: e[0] ?? ""
          });
        }
      ), this._dailyAllowanceRegions.push(...t);
    }
    return this._dailyAllowanceRegions = this._dailyAllowanceRegions.sort(
      (t, e) => t.text.localeCompare(e.text)
    ), this._dailyAllowanceRegions;
  }
  /**
   * Gets the Incomes Register metadata for a calculation row.
   * @param row Row to check, null for current row.
   * @returns The income type metadata. Empty object for empty row or empty irData.
   */
  getIrCodeData(t = null) {
    return t = t || this.current, t?.data?.irData ? Tn.getAll().find(
      (e) => e.code === t.data.irData.code
    ) : {};
  }
  /** Return the metadata based on irCode */
  getIrCodeDataWithCode(t) {
    return Tn.getAll().find((e) => e.code === t);
  }
  /** Returns true if the filtered list has any rows. */
  get hasRows() {
    return (this.filteredList || []).length > 0;
  }
  /** Gets the total for the current rows. */
  getTotal() {
    return (this.filteredList || []).reduce(
      (t, e) => t + e.count * e.price,
      0
    );
  }
  /**
   * Gets the gross total for the calculation.
   * Current implementation does not support filtering.
   */
  getGrossTotal() {
    return !this.parent || !this.parent.result || !this.parent.result.totals ? null : this.parent.result.totals.totalGrossSalary;
  }
  /**
   * Gets the total payment for the calculation.
   * Current implementation does not support filtering.
   */
  getFinalCost() {
    return !this.parent || !this.parent.result || !this.parent.result.employerCalc ? null : this.parent.result.employerCalc.finalCost;
  }
  /**
   * Gets the net salary for the calculation.
   * Current implementation does not support filtering.
   */
  getNetSalary() {
    return this.parent.result.workerCalc.salaryPayment;
  }
  /**
   * Gets the total payment that is paid to palkkaus.fi.
   * Current implementation does not support filtering.
   */
  getTotalPayment() {
    return this.parent.result.employerCalc.totalPayment;
  }
  /**
   * Closes the edit dialog (either modal dialog or inline).
   * @param method The closing method.
   * @param $close In the case of modal dialog, this is the modal dialog close method.
   */
  closeEditDialog(t, e = null) {
    if (e) {
      e(t);
      return;
    }
    switch (t) {
      case "delete-no-save":
        this.delete(this.current), this.current = null;
        return;
      case "ok-no-save":
      case "cancel":
      default:
        this.current = null;
        return;
    }
  }
  /**
   * Shows the editor UI that may either be a dialog or an inline edit UI.
   * @param item Item to edit. If rowIndex is null/undefined, the item is considered a new row and the properties
   * extend new item (fetched from getBlank()).
   * @param type Type of the edit UI.
   */
  showEdit(t, e = "auto") {
    if (!t)
      throw new Error("showEditDialog called without a parameter.");
    const a = this.isInEdit && t.rowIndex == null;
    if (a ? (t = wt.merge({}, this.getBlank(), t), this.rowTypeChanged(t), this.updateUsecase(t)) : (t.data = t.data ?? {}, t.accounting = t.accounting ?? {}), e != "dialog" && e != "inline") {
      const n = this.$element[0]?.querySelector(
        ".salaxy-calc-rows-editor-details-container"
      );
      n && (n.offsetWidth || n.offsetHeight || n.getClientRects().length) ? e = "inline" : e = "dialog";
    }
    if (e == "dialog") {
      this.showEditDialog(t, a);
      return;
    }
    this.current == t ? this.current = null : (a && this.list.push(t), this.current = t, this.$timeout(() => {
      const n = this.$element[0].querySelector(".salaxy-calc-details-dialog .form-control");
      n && n.focus();
    }, 300));
  }
  /**
   * Shows the edit dialog: Extends the base functionality with custom controller (non-supported results removed).
   * @param item Item to edit or string "new" for creating a new one.
   * @param isNew Optional way of specifying that the item is a new item (with default values, not yet added to the list).
   * If item is string "new", this parameter will have no effect (will always be true).
   */
  showEditDialog(t, e = !1) {
    if (!t)
      throw new Error("showEditDialog called without a parameter.");
    t === "new" && (e = !0, t = this.getBlank()), t.data = t.data ?? {}, t.accounting = t.accounting ?? {}, this.uiHelpers.openEditDialog(
      this.getEditDialogTemplateUrl(),
      t,
      {
        calc: this.parent,
        readOnly: !this.isInEdit
      },
      "",
      "CalcRows2019Controller"
    ).then((a) => {
      a.action === "ok-no-save" ? e && this.list.push(a.item) : a.action === "delete-no-save" && (e || this.delete(t));
    });
  }
  /**
   * Gets or sets the flag telling whether the component is in edit or read-only mode.
   */
  get isInEdit() {
    return this.isEditable ? super.isInEdit : !!this._isInEdit;
  }
  set isInEdit(t) {
    super.isInEdit = t;
  }
  /**
   * Changes the view from read-only mode to edit mode.
   */
  startEdit() {
    this.isEditable ? super.startEdit() : (this.isInEdit = !0, this.onStartEdit({
      parent: this.parent
    }));
  }
  /**
   * Returns placeholder text for row
   * @param row used row
   * @returns row message as string
   */
  getMessagePlaceholderText(t) {
    if (t.message)
      return t.message;
    let e = "";
    return t.rowType === Wt.IrIncomeType ? e = Tn.getAll().find(
      (a) => t.data?.kind && a.transactionCode === t.data.kind || t.data?.irData?.code > 0 && a.code === t.data.irData.code
    )?.label : t.rowType == Wt.AbsencePeriod ? e = He.getEnumLabel(
      "AbsenceCauseCode",
      t.data?.kind
    ) : [
      Wt.DailyAllowance,
      Wt.EmploymentTermination,
      Wt.WorkingTimeCompensation,
      Wt.Remuneration,
      Wt.OtherCompensation,
      Wt.NonProfitOrg,
      Wt.MealBenefit,
      Wt.Training,
      Wt.PaidSickLeave,
      Wt.TotalWorkerPayment
    ].includes(t.rowType) && t.data?.kind && (e = He.getEnumLabel(
      `${t.rowType}Kind`,
      t.data.kind
    )), e || He.getEnumLabel("CalculationRowType", t.rowType);
  }
  /** Initializes and returns the unit for the row. */
  ensureUnit(t) {
    if (!t.unit) {
      const e = this.getConfig(t);
      t.unit = e.amount.unit;
    }
    return t.unit;
  }
  /**
   * Select a row in the list or unselect if already selected.
   * @param row Row to select or "all" to select all currently vivisble rows.
   * @param value Optional value to force selection true or false regardless of the current state.
   */
  toggleSelectedRow(t, e) {
    if (t == "all") {
      this.filteredList.forEach((a) => {
        this.toggleSelectedRow(a, e);
      });
      return;
    }
    t.data.isSelected && !e ? t.data.isSelected = !1 : e !== !1 && (t.data.isSelected = !0);
  }
  /**
   * Gets the selected rows in the list (only the filtered / visible rows).
   * @returns The selected rows.
   */
  getSelectedRows() {
    return this.filteredList.filter((t) => t.data.isSelected);
  }
  /**
   * Determines the visibility of dimensions based on certain conditions.
   * @returns {boolean} - Returns `true` if dimensions should be visible, otherwise `false`.
   */
  showDimension() {
    return this.dimensionsCountToShow() > 0;
  }
  /**
   * Returns the number of dimensions to show.
   * @returns {number} The number of dimensions to show. If `dimensionCount` is not defined, returns 0.
   */
  dimensionsCountToShow() {
    return this.getDimensionsToShow().length;
  }
  /**
   * Retrieves the dimensions to show based on the session settings and predefined rules.
   * This method filters the available dimensions to exclude hidden ones and includes
   * those that match specific scope criteria. It prioritizes adding the default dimension
   * and cost center first, followed by the remaining dimensions until the limit defined
   * by `dimensionsCountToShow` is reached.
   * @returns {CostAccountingDimensionDefinition[]} An array of dimensions to be displayed.
   */
  getDimensionsToShow() {
    if (!this._dimensions) {
      const t = (this.session.session?.settings?.costAccounting?.dimensions ?? []).filter(
        (n) => (
          // no hidden scope
          n.scope !== gs.Hidden && // show if scope definition for dimension not given
          (!n.scope || n.scope === gs.None || // or this scope
          gs.Row === n.scope)
        )
      ), e = this.defaultDimension || "costCenter", a = t.slice(0);
      return a.sort((n, i) => n.id == e || n.id == "costCenter" && i.id != e ? -1 : 0), a.length = a.length > (this.dimensionCount ?? 0) ? this.dimensionCount ?? 0 : a.length, this._dimensions = a;
    }
    return this._dimensions;
  }
  formatYearlyNumbers(t) {
    const e = Object.keys(t.sideCosts);
    for (const a of e)
      t.sideCosts[a] >= 1 && (t.sideCosts[a + "Formatted"] = se.formatPrice(
        t.sideCosts[a]
      ));
    return t;
  }
};
Yy.bindings = new oW(), Yy.$inject = [
  "UiHelpers",
  "$timeout",
  "SessionService",
  "EditDialogParameters",
  "$element",
  "RowTypeService"
];
let Vl = Yy;
const o$ = class o$ extends wr {
  /**
   * Creates a new CalcSharingController
   * @ignore
   */
  constructor(t, e, a, n, i, r, l) {
    super(t, e, a, n, i, r, l), this.invoicesService = l;
  }
  /**
   * Implement IController
   */
  $onInit() {
    super.$onInit();
  }
  /** Approve the the calculation requested by the worker. */
  approve() {
    switch (this.current.workflow.status) {
      case le.SharedWaiting:
      case le.SharedRejected:
        return this.current.workflow.status = le.SharedApproved, this.save();
      case le.SharedApproved:
      default:
        return Promise.resolve(this.current);
    }
  }
  /** Reject the the calculation requested by the worker. */
  reject() {
    switch (this.current.workflow.status) {
      case le.SharedWaiting:
      case le.SharedApproved:
        return this.current.workflow.status = le.SharedRejected, this.save();
      case le.SharedRejected:
      default:
        return Promise.resolve(this.current);
    }
  }
};
o$.$inject = ["Calculations", "ReportsService", "UiHelpers", "$location", "$routeParams", "SessionService", "InvoicesService"];
let Nm = o$;
const c$ = class c$ {
  /**
   * Creates a new CalcReportController
   * @ignore
   */
  constructor(t, e) {
    this.$timeout = t, this.sessionService = e, this.sxyTableConfig = {
      currentCalc: null,
      reportLang: Me.Default,
      config: null
    };
  }
  /**
   * Config for SxyTable
   */
  get tableConfig() {
    if (!this.calcs)
      this.sxyTableConfig = {
        currentCalc: null,
        reportLang: null,
        config: null
      };
    else {
      const t = wt.copy(this.calcs);
      (!Qe.equal(this.sxyTableConfig.currentCalc, t) || this.lang !== this.sxyTableConfig.reportLang) && (this.sxyTableConfig.currentCalc = t, this.sxyTableConfig.reportLang = this.lang, this.getDefaultLanguage(this.lang).then((e) => {
        this.lang = e, this.renderedLang = this.lang, this.refreshTableConfig();
      }));
    }
    return this.sxyTableConfig.config;
  }
  /** Refreshes table config */
  async refreshTableConfig() {
    const t = this.lang ?? Me.Fi;
    await L.loadLanguage(t), this.sxyTableConfig.config = N0.getConfig(this.calcs, t), await this.$timeout(), this.$sxyTable.refresh();
  }
  async getDefaultLanguage(t) {
    return t ? Promise.resolve(t) : this.sessionService.getReportLang();
  }
};
c$.$inject = [
  "$timeout",
  "SessionService"
];
let Rm = c$;
class NZ {
  /**
   * Creates a new CalculatorPanels helper for a calculation
   * @param calc - The Calculation object for which the helper operates
   */
  constructor(t) {
    this.calc = t, (!t || Object.keys(t).length === 0) && (t = Da.getBlank());
  }
  /** Stores the UI properties to the calculation until a roundtrip to server. Then the property is set to null */
  get ui() {
    if (!this.calc)
      return null;
    const t = this.calc;
    return t.$ui = t.$ui || {}, t.$ui.activePanels = t.$ui.activePanels || [], t.$ui;
  }
  /**
   * Toggles the user interface panels active (open/close) in a hierarchical way.
   * The functionality mimics a hierarchical panel/menu structure in HTML / components that are not hierarchical.
   * See the example to better understand the logic.
   * Hierarchy logic is supported to 2 levels only - it is not tested on deeper hierarchy though it may function.
   * @param panels - Identifiers of panel or two panels (panel and its child) that should be toggled.
   * @example
   * Assume we have these two panels open: "panel1", "panel2"
   *
   * - togglePanel("panel1", "panel2") => ["panel1"]      // Normal 2nd level toggle opens and closes the last level.
   * - togglePanel("panel2") => ["panel1"]                // Alternative explicit last level close
   * - togglePanel("panel1") => []                        // Normal 1st level toggle opens and closes the first level
   * - togglePanel("panel3") => ["panel3"]                // Opening another "path" of the hierarchy
   * - togglePanel("panel3", "panel4") => ["panel3", "panel4"]
   * - togglePanel("panel1", "panel4") => ["panel1", "panel4"]    // Being a separate "path" is determined by last element only
   * - togglePanel("last") => ["panel1"]                  // Special keyword for closing the last panel
   * - togglePanel() => []                                // Closes all panels
   */
  toggleActivePanel(...t) {
    if (t.length === 0 || !t[0]) {
      this.ui.activePanels = [];
      return;
    }
    if (t[0] === "last") {
      this.ui.activePanels.length > 0 && this.ui.activePanels.splice(this.ui.activePanels.length - 1);
      return;
    }
    const e = this.ui.activePanels.indexOf(t[t.length - 1]);
    e === -1 ? this.ui.activePanels = t : this.ui.activePanels.splice(e, this.ui.activePanels.length);
  }
  /**
   * Returns true if the panel is active (open).
   * @param panel - identifier of the panel.
   */
  isPanelActive(t) {
    return this.ui.activePanels.indexOf(t) >= 0;
  }
}
const d$ = class d$ {
  /**
   * Creates a new CreditTransferController.
   * @ignore
   */
  constructor(t, e, a) {
    this.$scope = t, this.$sce = e, this.$timeout = a, this.invoiceQrCode = "";
  }
  /** Copies the barcode from input to clipboard. */
  copyBarcode() {
    const t = "barcode" + this.getId();
    document.getElementById(t).select(), document.execCommand("copy");
  }
  /** Gets a unique id for the barcode input (from which the copying to clipboard is done). */
  getId() {
    return this.$scope.$id;
  }
  /**
   * Retrieves the QR code for the specified invoice item.
   * If the QR code is not already cached, it generates the QR code and caches it for future use.
   * @returns The QR code string.
   */
  getQrCode() {
    return this.invoiceQrCode || (this.invoiceQrCode = "loading", this.generateQrCodeSvgForInvoice().then((t) => t ? (this.invoiceQrCode = t, this.$timeout(), this.$sce.trustAsHtml(this.invoiceQrCode)) : (this.invoiceQrCode = "error", this.$timeout(), this.invoiceQrCode))), this.invoiceQrCode === "error" ? this.invoiceQrCode : this.$sce.trustAsHtml(this.invoiceQrCode);
  }
  /**
   * Sets the Invoice based on an invoice preview (list item based preview) if the invoice is not empty.
   * I.e. if you wish to set to null, you need to set the invoice null separately.
   * Gets the original preview object if set.
   */
  get invoicePreview() {
    return this._invoicePreview;
  }
  set invoicePreview(t) {
    this._invoicePreview = t, t?.invoice && (this.invoice = this.getInvoice(t));
  }
  /**
   * Retrieves the barcode for the invoice recipient's IBAN.
   * If the IBAN does not start with "fi" or is not provided, an empty string is returned.
   * The barcode is generated using the Barcodes.createBarcode function.
   * @returns The barcode as a string, wrapped in an HTML trust object.
   */
  getBarcode() {
    if (!this.invoice?.recipient.iban || !this.invoice?.recipient.iban.toLowerCase().trim().startsWith("fi"))
      return "";
    const t = () => ({ document, svgNode: document.createElementNS("http://www.w3.org/2000/svg", "svg") }), e = tl.createBarcode(
      t,
      this.invoice.recipient.iban || "",
      this.invoice.header.referenceNumber || "",
      I.asDate(this.invoice.header.dueDate),
      se.round(this.invoice.header.total * 100, 0),
      {
        width: 1.42,
        height: 35,
        displayValue: !0,
        fontSize: 15
      }
    );
    return e ? this.$sce.trustAsHtml(new XMLSerializer().serializeToString(e)) : "";
  }
  /** Barcode value */
  get bcValue() {
    return this.invoice?.recipient.iban ? tl.getValue(
      this.invoice.recipient.iban || "",
      this.invoice.header.referenceNumber || "",
      I.asDate(this.invoice.header.dueDate),
      se.round(this.invoice.header.total * 100, 0)
    ) : "";
  }
  /**
   * Generates the QR code for the invoice.
   */
  async generateQrCodeSvgForInvoice() {
    return this.invoice ? await Jy.getValue(
      this.getBicForIban(this.invoice?.recipient?.iban),
      this.invoice.recipient.fullName,
      this.invoice.recipient.iban,
      this.invoice.header.referenceNumber,
      null,
      this.invoice.header.total,
      this.invoice.header.dueDate
    ) : void 0;
  }
  /**
   * Returns bic for iban
   * @param iban Iban to get bic for
   */
  getBicForIban(t) {
    return Ky.getBicForIban(t);
  }
  /**
   * Determines whether to show the QR code for the invoice.
   * @returns A boolean indicating whether to show the QR code.
   */
  showQrCode() {
    return ne.isEcfa(this.invoice.header.channel);
  }
  /**
   * Checks if the IBAN of the recipient is an international IBAN.
   * @returns {boolean} True if the IBAN is international, false otherwise.
   */
  isInternationalIban() {
    return Sw.isInternationalIban(this.invoice.recipient.iban ?? "");
  }
  /** Maps an invoice preview object to invoice. */
  getInvoice(t) {
    return t?.invoice ? {
      header: {
        dueDate: t.invoice.data.dueDate,
        total: t.invoice.payment,
        referenceNumber: t.invoice.reference
      },
      rows: [],
      payer: {
        avatar: t.invoice.ownerInfo.avatar,
        officialId: t.invoice.ownerInfo.officialId,
        contact: {
          email: t.invoice.ownerInfo.email,
          telephone: t.invoice.ownerInfo.telephone
        }
      },
      recipient: {
        fullName: t.invoice.otherPartyInfo.avatar.displayName,
        iban: t.invoice.otherPartyInfo.ibanNumber,
        officialId: t.invoice.otherPartyInfo.officialId,
        contact: {
          email: t.invoice.otherPartyInfo.email,
          telephone: t.invoice.otherPartyInfo.telephone
        }
      }
    } : null;
  }
};
d$.$inject = ["$scope", "$sce", "$timeout"];
let Ym = d$;
const u$ = class u$ extends nn {
  constructor(t, e, a, n, i, r, l, o, c, d, p, h, g) {
    super(t, e, n, i), this.payrollsApi = t, this.uiCrudHelpers = a, this.calcsApi = r, this.reportsService = l, this.sessionService = o, this.invoicesService = c, this.calendarEvents = d, this.employmentsApi = p, this.$timeout = h, this.taxcardsApi = g, this.activeTab = "properties", this.loaders = {}, this._employments = {}, this.calcUiProperties = [], this.emptyCalcList = [], this._availableChannels = [], this.isDisabledSalaryDate = (x) => {
      const b = this.sessionService.isInRole("pro") ? "pro" : this.sessionService.isInRole("admin") ? "admin" : null;
      switch (this.current.input.salaryDateKind) {
        case $n.InPast:
          return !1;
        case $n.Default:
        default:
          return !gc.isValidSalaryDate(x, null, null, !0, this.current.input.paymentChannel, Fh.isZeroPayment(this.calcs ?? []), b);
      }
    }, this.setCalc = (x) => {
      const b = this.current.calcs.find((T) => T.id === x.id), A = this.original.calcs.find((T) => T.id === x.id);
      return wt.copy(x, b), wt.copy(x, A), { calc: x, isSaved: !0 };
    }, this.messageActions = [
      {
        text: "Maksa",
        value: "pay",
        title: "Maksa palkkalista"
      },
      /* {
        text: "Tarkista (hyväksy/hylkää)",
        value: "approve",
        title: "Tarkista palkkalista",
      },*/
      {
        text: "Tiedoksi",
        value: "info",
        title: "Tiedoksi palkkalista"
      },
      {
        text: "Vastaa kysymykseen",
        value: "question",
        title: "Kysymyksiä palkkalistasta"
      }
    ];
  }
  /**
   * Initialization code.
   */
  $onInit() {
    super.$onInit(), this.isReadOnlyForced && (this.activeTab = "reports");
  }
  /** Catched the return of reload to update values. */
  reload() {
    return super.reload().then((t) => (super.isNew() && this.setPaymentChannel(t), t));
  }
  /** Implements the getDefaults of ApiCrudObjectController */
  getDefaults() {
    return {
      listUrl: this.listUrl || "/payroll",
      detailsUrl: this.detailsUrl || "/payroll/details/",
      oDataTemplateUrl: "salaxy-components/odata/lists/Payrolls.html",
      oDataOptions: {}
    };
  }
  /**
   * Returns true, if the given action button should be shown
   * @param action One of the action values: See actions field type for supported values.
   */
  showAction(t) {
    const e = this.actions?.length ? this.actions : this.isReadOnlyForced ? [] : ["copy", "cancel"];
    return t === "pay" ? !!e.find((a) => a == t) && !!this.current && (this.current.info.status === Ua.Draft || this.current.info.status === Ua.WaitingApproval) : !!e.find((a) => a == t);
  }
  /** Returns true if any calculations have been added to the Payroll */
  get hasCalculations() {
    return this.current && this.current.calcs.length > 0;
  }
  /** Save changes to the payroll as well as to changed calculations */
  save() {
    return this.changedCalcCount > 0 ? this.commitAllCalcs().then(() => super.save()) : super.save();
  }
  /** Recalculate and save worktimes of all calculations. */
  recalculateWorktimes() {
    const t = this.uiHelpers.showLoading("SALAXY.UI_Terms.wait"), e = this.calcs.map((a) => this.calcsApi.getWorktimeData(a).then((n) => (a.worktime = n, this.calcsApi.recalculateWorktime(a).then((i) => wt.copy(i, a)))));
    return Promise.all(e).then((a) => (t.dismiss(), a));
  }
  /**
   * Calculates the total amount of days for the given period type.
   * @param calc Calculation to calculate days for.
   * @param periodType Period type to calculate days for.
   * @returns Sum of days for the given period type.
   */
  calculatePeriodDays(t, e) {
    switch (e) {
      case "leavesDays":
        return ie.sum(t.worktime?.absencesPeriods?.filter((a) => a.causeCode == Ge.AnnualLeave) ?? [], (a) => a.period.daysCount);
      case "absencesDays":
        return ie.sum(t.worktime?.absencesPeriods?.filter((a) => a.causeCode != Ge.AnnualLeave && !a.isPaid) ?? [], (a) => a.period.daysCount);
      case "paidAbsencesDays":
        return ie.sum(t.worktime?.absencesPeriods?.filter((a) => a.causeCode != Ge.AnnualLeave && a.isPaid) ?? [], (a) => a.period.daysCount);
      case "accruedDays":
        return this.showAccruals(t) ? ie.sum(t.worktime?.accruals, (a) => a.daysAccrued) : 0;
    }
  }
  /**
   * Returns true if the accruals are accumulated.
   * @param calc Calculation.
   * @returns Returns true if the accruals are accumulated.
   */
  showAccruals(t) {
    return t.worktime?.accrualSpec?.code == Se.Permanent14Days || t.worktime?.accrualSpec?.code == Se.Permanent35Hours || t.worktime?.accrualSpec?.code == Se.TemporaryTimeOff || t.worktime?.accrualSpec?.code == Se.Other;
  }
  /**
   * Creates a copy of a payroll
   * This is a synchronous method that should basically convert a saved item to a new item.
   * @param copySource Item (container item) to copy as new.
   */
  copyItem(t) {
    const e = t.id, a = super.copyItem(t);
    return a.info.messageThreadId = null, a.info.status === Ua.Template && (a.input.template = e, a.info.status = Ua.Draft), a.usecase && (a.usecase.uri === "palkkaus.fi/usecases/payroll-service/pro-calc" || a.usecase.uri === "palkkaus.fi/usecases/payroll-service/calc") && (a.usecase = {}), a;
  }
  /**
   * Reloads the validations and info for the current item.
   * These are constructed based on calculations data and if changed, will update the Payroll in storage.
   */
  reloadValidation() {
    this.currentId && this.api.getSingle(this.currentId).then((t) => {
      this.current.validations = t.validations, this.current.info = t.info, this.original.validations = t.validations, this.original.info = t.info;
    });
  }
  /** Gets a validation object for a calculation */
  getValidation(t) {
    return this.current.validations.find((e) => e.id === t.id) || {
      id: t.id,
      // Paid Payrolls will not have validations.
      isValid: !0
    };
  }
  /** UI related data and texts about the taxcard. */
  getTaxUi(t) {
    return La.getCalcTaxcardInfo(t);
  }
  /** Show add new taxcard dialog */
  async showAddNewTaxcard(t) {
    const e = await this.employmentsApi.getSingle(t.worker.employmentId);
    if (!e)
      return;
    const a = this.uiHelpers.showLoading("SALAXY.UI_Terms.wait");
    if ((e.info.taxcard == Xa.Undefined || e.info.taxcard == Xa.Auto) && await this.taxcardsApi.setAuto(t.worker.paymentData.socialSecurityNumberValid)) {
      await this.commitCalc(t, !1, !0), a.dismiss();
      return;
    }
    if ((await this.uiCrudHelpers.createNewTaxcard(t.worker.paymentData.socialSecurityNumberValid)).action === "ok") {
      await this.commitCalc(t, !1, !0), a.dismiss();
      return;
    }
    a.dismiss();
  }
  /**
   * Returns true if the date is overdue (smaller than today).
   * @param date Date to compare to today.
   */
  isOverdue(t) {
    return t = I.asDate(t), t < I.getToday();
  }
  /** Gets the list of calculations in this payroll object */
  get calcs() {
    return this.current ? this.current.calcs : this.emptyCalcList;
  }
  /** Returns the constantly updating info component from the open calculations (without round-trip to server) */
  get info() {
    return Fh.getInfo(this.current, this.calcs);
  }
  /** Summarized CalculationResult for all calculations in the payroll. */
  get calcsResult() {
    const t = Vy.add(this.calcs.map((e) => e.result));
    return wt.equals(t, this._calcsResult) || (this._calcsResult = t), this._calcsResult;
  }
  /** Returns true if there is no net salary payment to worker at all. */
  get isCurrentZeroPayment() {
    return Fh.isZeroPayment(this.calcs ?? []);
  }
  /**
   * Checks if user is in one of the given roles.
   * @param roles A comma separated list of roles, potentially with exlamation mark
   */
  isInSomeRole(t) {
    return this.sessionService.isInSomeRole(t);
  }
  /** Gets the UI properties for a calculation */
  getUi(t) {
    if (!t || !t.id)
      return {};
    let e = this.calcUiProperties.find((a) => a.id === t.id);
    return e == null && (e = {
      id: t.id,
      isCollapsed: !0,
      isInEdit: !1
    }, this.calcUiProperties.push(e)), e;
  }
  /**
   * Set calculation rows editable
   */
  setRowsEditable(t) {
    t === "all" ? (this.setUiForAll("isInEdit", !0), this.setUiForAll("isCollapsed", !1)) : (this.getUi(t).isCollapsed = !1, this.getUi(t).isInEdit = !1, this.getUi(t).isInEdit = !0);
  }
  /**
   * Sets a UI property for all calculations.
   * @param prop Name of the property to set.
   * @param value New value for the property.
   */
  setUiForAll(t, e) {
    this.calcs.forEach((a) => {
      this.getUi(a)[t] = e;
    });
  }
  /**
   * Recalculates and saves calculation to the server.
   * @param calc Calculation to save.
   * @param noReloadValidation If true, the parent should call reloadValidation().
   * @param forceSave If true, changes are saved even when there are no changes.
   */
  commitCalc(t, e = !1, a = !1) {
    return this.getUi(t).isInEdit = !1, a || this.hasCalcChanges(t) ? this.payrollsApi.calculationSave(t, this.current.id).then((n) => (e || this.reloadValidation(), this.setCalc(n))) : Promise.resolve({ calc: t, isSaved: !1 });
  }
  /**
   * Reset any modifications to a calculation.
   * @param calc Calculation that was edited.
   */
  resetCalc(t) {
    if (this.getUi(t).isInEdit = !1, this.hasCalcChanges(t)) {
      const e = this.original.calcs.find((a) => a.id === t.id);
      wt.copy(e, t);
    }
  }
  /** Gets the count of changed calculations. */
  get changedCalcCount() {
    return this.changedCalcCountCache = this.calcs.filter((t) => this.hasCalcChanges(t)).length, this.changedCalcCountCache;
  }
  /** Returns true if a calculation has changes to its original. */
  hasCalcChanges(t) {
    const e = this.original.calcs.find((a) => a.id === t.id);
    if (!e)
      throw new Error("Unexpected: No original calc in hasCalcChanges.");
    return !wt.equals(e, t);
  }
  /**
   * Commits changes to all calculations that are in edit mode.
   * @returns A promise with the number of saved (changed) calculations.
   */
  commitAllCalcs() {
    const t = this.uiHelpers.showLoading("SALAXY.NG1.PayrollComponent.commitAllCalcs.heading");
    this.setUiForAll("isCollapsed", !0), this.setUiForAll("isInEdit", !1);
    const e = this.calcs.map((a) => this.commitCalc(a, !0));
    return Promise.all(e).then((a) => (t.dismiss(), this.reloadValidation(), a.filter((n) => n.isSaved).length));
  }
  /** Resets all calculations to their unsaved state. */
  resetAllCalcs() {
    this.calcs.forEach((t) => this.resetCalc(t));
  }
  /**
   * Opens DateRange component in modal dialog.
   * If daterange is changed asks whether all calculations should be changed to a new period.
   * Saves changes to server.
   */
  showDateRange() {
    this.uiHelpers.showDateRange(this.current.input.period, "SALAXY.NG1.PayrollComponent.showDateRangeTitle", "SALAXY.UI_Terms.save").then((t) => {
      t.result === "ok" && t.hasChanges && this.calcs.length > 0 && this.uiHelpers.showConfirm(
        "SALAXY.NG1.PayrollComponent.showDateRangeDialogTitle",
        "SALAXY.NG1.PayrollComponent.showDateRangeDialogDescr",
        "SALAXY.UI_Terms.yes",
        "SALAXY.UI_Terms.no"
      ).then((e) => {
        e ? (this.calcs.forEach((a) => {
          a.info.workStartDate = this.current.input.period.start, a.info.workEndDate = this.current.input.period.end, a.framework.numberOfDays = this.current.input.period.daysCount;
        }), this.save()) : super.save();
      });
    });
  }
  /**
   * Shows a DateRange edit component for a single calculation.
   * @param calc Calculation to modify.
   */
  showDateRangeForCalculation(t) {
    this.uiHelpers.showDateRange(t, "SALAXY.NG1.PayrollComponent.showDateRangeTitle", "SALAXY.UI_Terms.ok");
  }
  /**
   * Shows the calculation in a new dialog.
   * @param calc Calculation to modify / view in dialog.
   */
  showEditCalcDialog(t, e = "default") {
    const a = e === "ir" ? "salaxy-components/modals/calc/CalcIr.html" : "salaxy-components/modals/calc/Calc.html";
    return this.uiHelpers.openEditDialog(
      a,
      t,
      {
        title: L.get("SALAXY.NG1.PayrollComponent.showEditCalcDialog")
      },
      "lg"
    ).then((n) => n.action === "ok" ? n.hasChanges ? this.commitCalc(n.item).then((i) => i.calc) : t : n.action === "delete" ? (this.deleteCalc(t), null) : (this.resetCalc(t), t));
  }
  /**
   * Shows a dialog for editing an existing worker.
   * @param calc - Calculation that should be edited
   */
  showEditWorkerDialog(t) {
    t.worker?.accountId ? this.uiCrudHelpers.openEditEmploymentDialog(t.worker.employmentId, "updateCalc").then((e) => {
      if (e.action === "ok" || e.action === "ok-no-rows") {
        const a = this.uiHelpers.showLoading("SALAXY.NG1.PayrollComponent.showEditWorkerDialogUpdating");
        this.calcsApi.updateFromEmployment(t, !0, e.action === "ok").then((n) => {
          this.reloadValidation(), this.setCalc(n), a.dismiss();
        });
      }
    }) : this.showAddWorkerDialog(t);
  }
  /**
   * Opens a list of workers in to a dialog window.
   * Edits the  calculation for the selected worker and current payroll.
   */
  showAddWorkerDialog(t) {
    const e = [];
    this.uiHelpers.openEditDialog(
      "salaxy-components/modals/calc/WorkerSelect.html",
      e,
      {
        title: "SALAXY.NG1.PayrollComponent.validate.addWorker"
      }
    ).then((a) => {
      if (a.action === "ok" && a.item.length == 1) {
        const n = this.uiHelpers.showLoading("SALAXY.NG1.PayrollComponent.showEditWorkerDialogUpdating");
        t.worker.employmentId = a.item[0].id, this.calcsApi.updateFromEmployment(t, !0, !1).then((i) => {
          this.reloadValidation(), this.setCalc(i), n.dismiss();
        });
      }
    });
  }
  /**
   * Shows a dialog during the check of auto taxcard.
   */
  showRefreshAutoTaxcardDialog(t) {
    this.loaders.showRefreshAutoTaxcardDialog = !0, this.uiCrudHelpers.refreshAutoTaxcard(t.worker.tax?.taxcardId, t.workflow?.salaryDate).then(() => {
      this.commitCalc(t, !1, !0), this.loaders.showRefreshAutoTaxcardDialog = !1;
    });
  }
  /**
   * Shows a confirm dialog if payroll has any calculations.
   * Returns true if a user clicks OK -button. Otherwise (cancel or close) returns false.
   * @returns True if the user confirmed the operation.
   */
  importEmploymentDataAll() {
    const t = this.current;
    return !t.info.calcCount || t.info.calcCount === 0 ? this.uiHelpers.showAlert("SALAXY.NG1.PayrollComponent.importEmploymentDataAllAlertTitle", "SALAXY.NG1.PayrollComponent.importEmploymentDataAllAlertDescr").then(() => !1) : this.uiHelpers.showConfirm(
      "SALAXY.NG1.PayrollComponent.importEmploymentDataAllConfirmTitle",
      "SALAXY.NG1.PayrollComponent.importEmploymentDataAllConfirmDescr",
      "SALAXY.UI_Terms.continue",
      "SALAXY.UI_Terms.cancel"
    ).then((e) => {
      if (e) {
        const a = this.uiHelpers.showLoading("SALAXY.NG1.PayrollComponent.importEmploymentDataAllLoading"), n = this.calcs.map((i) => this.calcsApi.updateFromEmployment(i, !0, !0).then((r) => this.setCalc(r)));
        return Promise.all(n).then(() => (a.dismiss(), this.reloadValidation(), !0));
      } else
        return !1;
    });
  }
  /**
   * Adds default rows (SalaryDefault) from employment information to calculation.
   * Also saves the calculation
   * @param calc The calculation to update.
   */
  importEmploymentData(t) {
    return this.uiHelpers.showConfirm(
      "SALAXY.NG1.PayrollComponent.importEmploymentDataTitle",
      "SALAXY.NG1.PayrollComponent.importEmploymentDataDescr",
      "SALAXY.UI_Terms.continue",
      "SALAXY.UI_Terms.cancel"
    ).then((e) => {
      if (e) {
        const a = this.uiHelpers.showLoading("SALAXY.NG1.PayrollComponent.importEmploymentDataLoading");
        return this.calcsApi.updateFromEmployment(t, !0, !0).then((n) => (a.dismiss(), this.reloadValidation(), this.setCalc(n)));
      } else
        return Promise.resolve({ calc: t, isSaved: !1 });
    });
  }
  /**
   * Show confirm dialog and export employment data from calculation to Employment relation.
   * If the calculation has unmodified changes, the calculation is saved.
   * @param calc Calculation that should be exported to Employment.
   * @returns True if the user confirmed the operation.
   */
  exportEmploymentData(t) {
    return this.uiHelpers.showConfirm(
      "SALAXY.NG1.PayrollComponent.exportEmploymentDataTitle",
      "SALAXY.NG1.PayrollComponent.exportEmploymentDataDescr",
      "SALAXY.UI_Terms.continue",
      "SALAXY.UI_Terms.cancel"
    ).then((e) => {
      if (e) {
        const a = this.uiHelpers.showLoading("SALAXY.NG1.PayrollComponent.exportEmploymentDataLoading");
        this.exportEmploymentDataNoConfirm(t).then((n) => (n.isSaved && this.reloadValidation(), a.dismiss(), !0));
      } else
        return !1;
    });
  }
  /**
   * Deletes the calculation
   * @param calc Calculation to delete
   * @param unlink If true, will not delete the actual calculation, but instead unlinks it as a separate calculation outside this payroll.
   */
  deleteCalc(t, e = !1) {
    e ? this.uiHelpers.showConfirm(
      "SALAXY.NG1.PayrollComponent.payrollCalcs.unlinkCalcDialog.heading",
      "SALAXY.NG1.PayrollComponent.payrollCalcs.unlinkCalcDialog.intro",
      "SALAXY.NG1.PayrollComponent.payrollCalcs.unlinkCalcDialog.confirmButton",
      "SALAXY.NG1.PayrollComponent.payrollCalcs.unlinkCalcDialog.cancelButton"
    ).then((a) => {
      if (a) {
        const n = this.uiHelpers.showLoading("SALAXY.NG1.PayrollComponent.payrollCalcs.unlinkCalcDialog.loading");
        this.payrollsApi.unlinkCalculations(this.current, [t.id]).then((i) => {
          this.setCurrentValue(i, !0), n.dismiss();
        });
      }
    }) : this.uiHelpers.showConfirm(
      "SALAXY.NG1.PayrollComponent.payrollCalcs.deleteCalcDialog.heading",
      this.changedCalcCount > 0 ? "SALAXY.NG1.PayrollComponent.payrollCalcs.deleteCalcDialog.introChanges" : "SALAXY.NG1.PayrollComponent.payrollCalcs.deleteCalcDialog.introNoChanges",
      "SALAXY.NG1.PayrollComponent.payrollCalcs.deleteCalcDialog.confirmButton",
      "SALAXY.NG1.PayrollComponent.payrollCalcs.deleteCalcDialog.cancelButton"
    ).then((a) => {
      if (a) {
        const n = this.uiHelpers.showLoading("SALAXY.NG1.PayrollComponent.payrollCalcs.deleteCalcDialog.loading");
        this.payrollsApi.deleteCalculations(this.current, [t.id]).then((i) => {
          this.setCurrentValue(i, !0), n.dismiss();
        });
      }
    });
  }
  /**
   * Gets the URL for a payroll pdf.
   * If report has not been saved (ID is null), returns null.
   * @returns Url for specified report
   */
  getPdfUrl() {
    return this.current ? this.reportsService.getPdfUrlForCalcs("salarySlip", this.current.calcs.filter((t) => t.id).map((t) => t.id), !0) : null;
  }
  /**
   * Shows a report for the payroll calculation using a modal dialog.
   * @param reportType - Type of report to show
   * @param calculation - Calculation for the report
   */
  showReport(t, e) {
    this.reportsService.showReportModalForCalc(t, e);
  }
  /**
   * Opens a list of workers in to a dialog window.
   * Creates a new calculation for the selected worker and current payroll.
   */
  createNewCalc() {
    const t = [];
    this.uiHelpers.openEditDialog(
      "salaxy-components/modals/calc/WorkerList.html",
      t,
      {
        title: "SALAXY.NG1.PayrollComponent.createNewCalcDialog"
      }
    ).then((e) => {
      if (e.action === "ok" && t.length > 0) {
        const a = this.uiHelpers.showLoading("SALAXY.NG1.PayrollComponent.createNewCalcLoading");
        this.payrollsApi.addEmployments(this.current, t.map((n) => n.id)).then((n) => {
          this.setCurrentValue(n, !0), a.dismiss();
        });
      }
    });
  }
  /**
   * Opens the list of calculations into a dialog window for selection and then adds them to payroll
   * @param category Either "paid": Read-only, a copy is added ... or "draft": Editable, moved with status changed.
   */
  addExistingCalc(t = "draft") {
    const e = t === "paid" ? "SALAXY.NG1.PayrollComponent.addExistingCalcCopy" : "SALAXY.NG1.PayrollComponent.addExistingCalcMove";
    this.uiHelpers.openSelectCalcs(t, e).then((a) => {
      if (a.action === "ok" && a.item.length > 0) {
        const n = this.uiHelpers.showLoading("SALAXY.NG1.PayrollComponent.addExistingCalcLoading");
        this.payrollsApi.addCalculations(this.current, a.item.map((i) => i.id)).then((i) => {
          this.setCurrentValue(i, !0), n.dismiss();
        });
      }
    });
  }
  /**
   * Opens a list of payrolls for merging the payroll calculations to the current payroll.
   * @param removeImportedRows If true, the operation removes all the imported rows,
   * meaning all the rows in the target Payroll calcs that have a sourceId.
   */
  async mergePayroll(t = !1) {
    const e = [];
    if ((await this.uiHelpers.openEditDialog("salaxy-components/modals/payroll/PayrollList.html", e, {
      title: "Valitse tuotava palkkalista",
      category: "draft"
    }, "lg")).action != "ok" || e.length < 1)
      return;
    const n = this.uiHelpers.showLoading("Yhdistetään palkkalistoja"), i = await this.payrollsApi.getSingle(e[0].id);
    let r = this.current;
    const l = r.calcs.map((h) => h.worker.employmentId), o = new Set(i.calcs.map((h) => h.worker.employmentId).filter((h) => l.indexOf(h) < 0));
    o.size && (n.setText(`Lisätään ${o.size} työntekijää.`), r = await this.payrollsApi.addEmployments(r, [...o]), this.setCurrentValue(r, !0));
    const c = [];
    t && r.calcs.forEach((h) => {
      h.rows.find((g) => !!g.sourceId) && (h.rows = h.rows.filter((g) => !g.sourceId), c.push(h));
    }), i.calcs.forEach((h) => {
      const g = r.calcs.find((b) => b.worker.employmentId == h.worker.employmentId);
      if (!g)
        throw new Error("No calculation: This is unexpected.");
      g.rows = g.rows.filter((b) => b.sourceId != h.id);
      const x = Qe.copy(h.rows);
      x.forEach((b) => {
        b.sourceId = h.id;
      }), g.rows.push(...x), c.indexOf(g) < 0 && c.push(g);
    });
    const d = c.map((h) => this.payrollsApi.calculationSave(h, r.id));
    n.setText(`Tallennetaan ${d.length} muokattua laskelmaa.`), (await Promise.all(d)).forEach((h) => {
      this.setCalc(h);
    }), this.reloadValidation(), n.dismiss();
  }
  /** Returns true if the period of a calculation is different than the period of the Payroll. */
  isDateDifferent(t) {
    return t.info.workStartDate !== this.current.input.period.start || t.info.workEndDate !== this.current.input.period.end || t.framework.numberOfDays !== this.current.input.period.daysCount;
  }
  /**
   * If true, the form controls should be read-only (no control at all).
   */
  get isReadOnly() {
    return super.isReadOnly || this.current.info.status === Ua.PaymentStarted && this.current.input.paymentChannel !== At.Undefined || !this.sessionService.isInRole("pro") && this.current.info.status === Ua.PaymentStarted;
  }
  /**
   * Exports employment data from calculation to Employment relation.
   * If the calculation has unmodified changes, the calculation is saved.
   * @param calc Calculation that should be exported to Employment.
   */
  exportEmploymentDataNoConfirm(t) {
    return this.hasCalcChanges(t) ? this.calcsApi.updateToEmployment(t).then(() => this.commitCalc(t, !0)) : this.calcsApi.updateToEmployment(t).then(() => Promise.resolve({ calc: t, isSaved: !1 }));
  }
  /**
   * Sends a payroll with messaging system and sets
   * @param $msg The MessageThreadCrudController that is used for creating the message thread.
   */
  sendPayroll(t) {
    t.current || (t.model = "new");
    const e = t.current;
    return e.otherParty = this.sessionService.session.settings.partner.accountId, e.status = eu.Active, e.title = e.title || "Palkkalista " + this.current.input.title, e.ownerWorkflow = {
      salaryDate: this.current.info.salaryDate
    }, e.messages.push({
      contentId: this.currentId,
      fromParty: this.sessionService.isInRole("pro") ? Xn.OtherParty : Xn.Owner,
      type: ja.Payroll
    }), t.save().then((a) => {
      if (this.current.info.status != Ua.WaitingApproval)
        return this.current.info.messageThreadId = a.id, this.current.info.status = Ua.WaitingApproval, this.save().then(() => {
        });
      this.current.info.messageThreadId = a.id;
    });
  }
  /**
   * Gets the message title for the action.
   * TODO: This could be replaced by enums.
   */
  getTitle(t) {
    return this.messageActions.find((e) => e.value == t).title + ": " + this.current.input.title;
  }
  /**
   * Deletes a linked message: Both the message thread and msg id in this payroll.
   * @param $msg The MessageThreadCrudController that contains the current message.
   */
  deleteMessage(t) {
    this.uiHelpers.showConfirm("Haluatko poistaa viestiketjun?", "Haluatko varmasti poistaa viestiketjun?").then((e) => {
      e && (t.current ? t.deleteNoConfirm(t.current).then(() => {
        this.current.info.messageThreadId = null, this.save();
      }) : (this.current.info.messageThreadId = null, this.save()));
    });
  }
  /** Shows the paymentd dialog / the invoices UI. */
  showPaymentDialog() {
    this.invoicesService.showPaymentDialog(this.current);
  }
  setPaymentChannel(t) {
    t && t.input && (t.input.paymentChannel = this.invoicesService.defaultChannel);
  }
  /**
   * Sends the payroll from company to PRO.
   * @param message Message to the accountant
   */
  sendToPro(t) {
    const e = this.uiHelpers.showLoading("SALAXY.NG1.PayrollComponent.sendToProSending", "SALAXY.NG1.PayrollComponent.sendToProSendingDescr");
    this.current.info.status = Ua.Draft, this.save().then(() => {
      this.api.saveWorkflowEvent(this.current, {
        type: "PartnerMessageClosed",
        ui: cc.Success,
        message: t ? L.get("SALAXY.NG1.PayrollComponent.sendToProMessage") + t : L.get("SALAXY.NG1.PayrollComponent.sendToProMessageChecked")
      }).then(() => {
        e.dismiss(), this.$location.path("/");
      });
    });
  }
  /**
   * Cancels the payment or invoice processing for the current payroll.
   */
  cancel() {
    const t = this.invoicesService.getEprWarningForCancellation(this.current.info.salaryDate, this.current.info.status == Ua.PaymentSucceeded), e = t ? `
` + t : "";
    return this.uiHelpers.showConfirm(L.get("SALAXY.NG1.CalcResultsComponent.cancelDialogTitle") + "?", L.get("SALAXY.NG1.CalcResultsComponent.cancelDialogDescr") + `${e}`, "SALAXY.NG1.CalcResultsComponent.cancelDialogYes", "SALAXY.NG1.CalcResultsComponent.cancelDialogNo").then((a) => {
      if (a) {
        const n = this.uiHelpers.showLoading("SALAXY.UI_Terms.wait");
        return this.payrollsApi.cancel(this.currentId).then((i) => (this.setCurrentValue(i), n.dismiss(), this.current));
      } else
        return this.current;
    });
  }
  /** Fetches and returns all employment list items related to all calcs in payroll. */
  get employments() {
    if (this.calcs) {
      const t = this.calcs.map((e) => e.worker.employmentId).filter((e) => !!e);
      if (t.length > 0) {
        const e = Object.keys(this._employments), a = t.filter((n) => e.indexOf(n) < 0);
        if (a.length > 0) {
          Object.assign(this._employments, Object.fromEntries(a.map((r) => [r, void 0])));
          const n = 15, i = [];
          for (let r = 0; r < a.length; r += n) {
            const l = a.slice(r, r + n);
            i.push(this.employmentsApi.getOData({ $filter: l.map((o) => `id eq '${o}'`).join(" or ") }));
          }
          Promise.all(i).then((r) => {
            r.forEach((l) => {
              l.items.forEach((o) => {
                this._employments[o.id] = o;
              });
            }), this.$timeout();
          });
        }
      }
    }
    return this._employments;
  }
};
u$.$inject = ["Payrolls", "UiHelpers", "UiCrudHelpers", "$location", "$routeParams", "Calculations", "ReportsService", "SessionService", "InvoicesService", "CalendarEvents", "Employments", "$timeout", "Taxcards"];
let mu = u$;
const p$ = class p$ extends nn {
  constructor(t, e, a, n, i, r, l, o, c, d, p, h, g, x) {
    super(t, e, a, n), this.payrollsApi = t, this.calcsApi = i, this.employmentsApi = r, this.invoicesService = l, this.$timeout = o, this.userSettingsService = c, this.sessionService = d, this.taxcardsApi = p, this.uiCrudHelpers = h, this.$rootScope = g, this.$scope = x, this.calcTab = "rows", this.loaders = {}, this.showHeader = !1, this.reportCalcs = [], this.orderField = void 0, this.orderReverse = !1, this.pageSize = 20, this.pageSizeOptions = { 10: "10", 20: "20", 30: "30", 40: "40", 50: "50" }, this.hasAssistant = !1, this._openAiKey = null, this.columnFilters = {
      PartnerMessageClosed: "",
      PartnerMessageIssue: ""
    }, this._canvasInfo = {
      calc: !1,
      header: !1
    }, this.isDisabledSalaryDate = (A) => {
      switch (this.current.input.salaryDateKind) {
        case $n.InPast:
          return !1;
        case $n.Default:
        default:
          return !gc.isValidSalaryDate(A, null, null, !0, this.current.input.paymentChannel);
      }
    }, this._info = {
      calcCount: {
        actual: 0,
        original: 0,
        exception: !1
      },
      totalGrossSalary: {
        actual: 0,
        original: 0,
        exception: !1
      },
      totalPayment: {
        actual: 0,
        original: 0,
        exception: !1
      }
    }, this.messageActions = [
      {
        text: "Maksa",
        value: "pay",
        title: "Maksa palkkalista"
      },
      /* {
        text: "Tarkista (hyväksy/hylkää)",
        value: "approve",
        title: "Tarkista palkkalista",
      },*/
      {
        text: "Tiedoksi",
        value: "info",
        title: "Tiedoksi palkkalista"
      },
      {
        text: "Vastaa kysymykseen",
        value: "question",
        title: "Kysymyksiä palkkalistasta"
      }
    ], this.rowsImportParams = {
      title: "",
      personalId: "",
      employmentType: "",
      payrollId: "",
      period: {
        start: "",
        end: "",
        daysCount: 0
      }
    };
    const b = this.$rootScope.$on("payroll-tab-event", (A, T) => {
      this.selectTab(T);
    });
    this.$scope.$on("$destroy", b);
  }
  /**
   * Initialization code.
   */
  $onInit() {
    super.$onInit(), this.$scope.$on("tabButtonsControllerReady", (t, e) => {
      e.tabsId === "payrollDetails" && (this.tabButtonsCtrl = e.ctrl, this.isReadOnlyForced && this.selectTab("reports"));
    });
  }
  /** Catched the return of reload to update values. */
  reload() {
    return super.reload().then((t) => (super.isNew() && t?.input && (t.input.paymentChannel = this.invoicesService.defaultChannel), t));
  }
  /** Implements the getDefaults of ApiCrudObjectController */
  getDefaults() {
    return {
      listUrl: this.listUrl || "/payroll",
      detailsUrl: this.detailsUrl || "/payroll/details/",
      oDataTemplateUrl: "salaxy-components/odata/lists/Payrolls.html",
      oDataOptions: {}
    };
  }
  /** Page size */
  get pageSizeOption() {
    return `${this.pageSize}`;
  }
  /** Page size */
  set pageSizeOption(t) {
    this.pageSize = Number.parseInt(t);
  }
  /** Check assistant key */
  get hasAssistantKey() {
    return !1;
  }
  /**
   * Selects and shows a tab in the payroll details view
   */
  selectTab(t) {
    this.tabButtonsCtrl.showTab(t);
  }
  /**
   * Returns true, if the given action button should be shown
   * @param action One of the action values: See actions field type for supported values.
   */
  showAction(t) {
    const e = this.actions?.length ? this.actions : this.isReadOnlyForced ? [] : ["copy", "cancel"];
    return t === "pay" ? !!e.find((a) => a == t) && !!this.current && (this.current.info.status === Ua.Draft || this.current.info.status === Ua.WaitingApproval) : !!e.find((a) => a == t);
  }
  /**
   * If true, the form controls should be read-only (no control at all).
   */
  get isReadOnly() {
    return super.isReadOnly || this.current?.info?.status === Ua.PaymentStarted;
  }
  /** Returns true if the period of a calculation is different than the period of the Payroll. */
  isDateDifferent(t) {
    return t?.data ? I.asDate(t.data.workStartDate) !== I.asDate(this.current.input.period.start) || I.asDate(t.data.workEndDate) !== I.asDate(this.current.input.period.end) : !1;
  }
  /** Save changes to the payroll as well as to changed calculations */
  save(t = null) {
    if (this.loaders[this.current?.id || "new"] = !0, this.isNew() && this.current?.input?.calculations?.length > 0) {
      const e = this.current.input.calculations.slice();
      return this.current.input.calculations = [], this.calcsApi.getSingle(e[0]).then((a) => this.payrollsApi.getCalcsOData(a.info.payrollId, null).then((n) => super.save(t).then(() => {
        const i = this.orderCalcs(e, n.items), r = {};
        r.listItemType = "CalculationListItem";
        const l = void 0, o = void 0, c = (d) => {
          const p = d.map((h) => h.id);
          return this.payrollsApi.addCalculations(this.current.id, p).then((h) => {
            const g = d.map(() => ({ message: "", result: [] }));
            return g.length > 0 && (g[0].result = h), g;
          });
        };
        return this.uiHelpers.showBatchProcessDialog(L.get("SALAXY.UI_Terms.wait"), i, c, o, r, l, 20, !0, !0, !0).then(() => this.$timeout(() => this.reload().then(() => (this.$location.path("/payroll/details/" + this.current.id + "&refresh=" + (/* @__PURE__ */ new Date()).getTime()), this.current)), 5e3));
      })));
    } else {
      const e = this.isNew(), a = this.getHeaderChangeInfo();
      return super.save(t).then((n) => e ? (delete this.loaders.new, delete this.loaders[this.current.id], n) : a.isPaymentChannelChanged || a.isSalaryDateChanged || a.isPeriodChanged ? (a.isPeriodChanged ? this.uiHelpers.showConfirm(
        "SALAXY.NG1.PayrollComponent.showDateRangeDialogTitle",
        "SALAXY.NG1.PayrollComponent.showDateRangeDialogDescr",
        "SALAXY.UI_Terms.yes",
        "SALAXY.UI_Terms.no"
      ) : Promise.resolve(!1)).then((r) => {
        if (!r && !a.isPaymentChannelChanged && !a.isSalaryDateChanged)
          return delete this.loaders.new, delete this.loaders[this.current.id], n;
        {
          const l = this.calcs.slice(0), o = {};
          o.listItemType = "CalculationListItem";
          const c = void 0, d = void 0, p = (h) => {
            const g = h.map((x) => x.id);
            return this.calcsApi.getMulti(g).then((x) => {
              for (const b of x)
                r && (b.info.workStartDate = this.current.input.period.start, b.info.workEndDate = this.current.input.period.end, b.framework.numberOfDays = this.current.input.period.daysCount);
              return this.payrollsApi.saveCalculations(this.current.id, x).then((b) => {
                const A = h.map(() => ({ message: "", result: [] }));
                return A.length > 0 && (A[0].result = b), A;
              });
            });
          };
          return this.uiHelpers.showBatchProcessDialog(L.get("SALAXY.NG1.PayrollComponent.commitAllCalcs.heading"), l, p, d, o, c, 20, !0, !0, !0).then((h) => (h.done && (h.results.forEach((g) => {
            for (const x of g.result) {
              const b = this.calcs.find((A) => A.id === x.id);
              b ? wt.copy(x, b) : this.calcs.push(x);
            }
          }), this.setPageItems()), delete this.loaders.new, delete this.loaders[this.current.id], this.reload()));
        }
      }) : (delete this.loaders.new, delete this.loaders[this.current.id], n));
    }
  }
  /** Recalculate and save worktimes of all calculations. */
  saveWorktimes() {
    this.loaders["worktime" + this.current?.id] = !0;
    const t = this.calcs.slice(0), e = {};
    e.listItemType = "CalculationListItem";
    const a = void 0, n = void 0, i = (r) => {
      const l = r.map((o) => o.id);
      return this.payrollsApi.saveCalculations(this.current.id, l, !0).then((o) => {
        const c = r.map(() => ({ message: "", result: [] }));
        return c.length > 0 && (c[0].result = o), c;
      });
    };
    return this.uiHelpers.showBatchProcessDialog(L.get("SALAXY.NG1.PayrollComponent.commitAllCalcs.heading"), t, i, n, e, a, 20, !0, !0, !0).then((r) => {
      if (r.done) {
        r.results.forEach((o) => {
          for (const c of o.result) {
            const d = this.calcs.find((p) => p.id === c.id);
            d && wt.copy(c, d);
          }
        });
        const l = this.page;
        return l.calcs = [], l.originalCalcs = [], this.reload();
      }
    }).then(() => {
      delete this.loaders["worktime" + this.current?.id];
    });
  }
  /**
   * Calculates the total amount of days for the given period type.
   * @param calc Calculation to calculate days for.
   * @param periodType Period type to calculate days for.
   * @returns Sum of days for the given period type.
   */
  calculatePeriodDays(t, e) {
    switch (e) {
      case "leavesDays":
        return ie.sum(t.worktime?.absencesPeriods?.filter((a) => a.causeCode == Ge.AnnualLeave) ?? [], (a) => a.period.daysCount);
      case "absencesDays":
        return ie.sum(t.worktime?.absencesPeriods?.filter((a) => a.causeCode != Ge.AnnualLeave && !a.isPaid) ?? [], (a) => a.period.daysCount);
      case "paidAbsencesDays":
        return ie.sum(t.worktime?.absencesPeriods?.filter((a) => a.causeCode != Ge.AnnualLeave && a.isPaid) ?? [], (a) => a.period.daysCount);
      case "accruedDays":
        return this.showAccruals(t) ? ie.sum(t.worktime?.accruals, (a) => a.daysAccrued) : 0;
    }
  }
  /**
   * Returns true if the accruals are accumulated.
   * @param calc Calculation.
   * @returns Returns true if the accruals are accumulated.
   */
  showAccruals(t) {
    return t.worktime?.accrualSpec?.code == Se.Permanent14Days || t.worktime?.accrualSpec?.code == Se.Permanent35Hours || t.worktime?.accrualSpec?.code == Se.TemporaryTimeOff || t.worktime?.accrualSpec?.code == Se.Other;
  }
  /**
   * Creates a copy of a payroll
   * This is a synchronous method that should basically convert a saved item to a new item.
   * @param copySource Item (container item) to copy as new.
   */
  copyItem(t) {
    const e = t.id, a = super.copyItem(t);
    return a.input.salaryDate = null, a.info.salaryDate = null, a.info.messageThreadId = null, a.info.originalPaymentId = void 0, a.info.paymentId = void 0, a.info.status === Ua.Template && (a.input.template = e), a.info.status = Ua.Draft, a.usecase && (a.usecase.uri === "palkkaus.fi/usecases/payroll-service/pro-calc" || a.usecase.uri === "palkkaus.fi/usecases/payroll-service/calc") && (a.usecase = {}), a;
  }
  /** Close the header dialog */
  closeHeader() {
    delete this.showHeader, this.isNew() && this.$location.path(this.getDefaults().listUrl);
  }
  /**
   * Sets the current calculation ID
   * @param calcId The ID of the calculation to set.
   * Set as undefined to hide the current calculation.
   */
  setCalc(t) {
    if (this.calcId = t, this.calcListItem = this.calcs.find((e) => e.id === t), this.calc = void 0, this.originalCalc = void 0, t) {
      const e = this.page.calcs.find((a) => a.id === t);
      e && e.rows ? this.uiHelpers.wait(0).then(() => {
        this.calc = e, this.originalCalc = this.page.originalCalcs.find((a) => a.id === t);
      }) : this.calcsApi.getSingle(t).then((a) => {
        const n = this.page.calcs.find((i) => i.id === t);
        if (n) {
          const i = a;
          wt.copy(i, n);
          const r = this.page.originalCalcs.find((l) => l.id === t);
          wt.copy(i, r), this.calc = n, this.originalCalc = r;
        } else {
          const i = this._pages.pages.find((r) => r.items.find((l) => l.id === t));
          if (i) {
            const r = a;
            i.calcs.push(r);
            const l = wt.copy(r);
            i.originalCalcs.push(l), this.calc = r, this.originalCalc = l, this._pages.currentIdx = i.current - 1;
          }
        }
      });
    }
  }
  /**
   * Returns true if the canvas should be shown.
   */
  shouldShowCanvas(t, e) {
    const a = !!e, n = document.querySelector("iframe#launcher");
    return n && (this._canvasInfo[t] = a, this._canvasInfo.calc || this._canvasInfo.header ? n.style.display = "none" : n.style.display = ""), a;
  }
  /**
   * Advances to next calc.
   */
  goToCalc(t = !1) {
    let e = this.calcs.indexOf(this.calcListItem);
    return e == -1 ? void 0 : (this.hasEmploymentChange ? this.saveEmployment(this.$employment.current, !1) : this.hasCalcChange ? this.saveCalc(this.calc) : Promise.resolve(this.current)).then(() => t ? (e -= 1, e > -1 ? this.setCalc(this.calcs[e].id) : this.setCalc(this.calcs[this.calcs.length - 1].id)) : (e += 1, e < this.calcs.length ? this.setCalc(this.calcs[e].id) : this.setCalc(this.calcs[0].id)));
  }
  /**
   * Checks if the current calcs has changes.
   */
  get hasCalcChange() {
    return this.calc?.isReadOnly ? !1 : !wt.equals(this.calc, this.originalCalc);
  }
  /**
   * Checks if the current employment has changes.
   */
  get hasEmploymentChange() {
    if (this.calc?.isReadOnly)
      return !1;
    const t = this.$employment;
    if (t?.current && t?.original) {
      const e = wt.fromJson(wt.toJson(t.current)), a = wt.copy(t.original);
      return Ma.getContact(a, js.EmployerOverride), !wt.equals(e, a);
    }
    return !1;
  }
  /**
   * Toggles the current calculation ID
   * @param calcId The ID of the calculation to set.
   */
  toggleCalc(t) {
    this.calcId === t ? this.setCalc(void 0) : this.setCalc(t);
  }
  /**
   * Saves the calculation and reloads the payroll.
   */
  saveCalc(t, e = !1, a = !1) {
    const n = t.id;
    return this.loaders[n] = !0, this.payrollsApi.saveCalculations(this.current.id, [t], e, a).then((i) => {
      for (const r of i) {
        const l = this.calcs.find((o) => o.id === r.id);
        l && wt.copy(r, l);
      }
      return delete this.loaders[n], this.calcsApi.getSingle(n).then((r) => {
        if (this.calcId == n)
          this.calc ? (wt.copy(r, this.calc), wt.copy(r, this.originalCalc)) : (this.calc = r, this.originalCalc = wt.copy(r));
        else {
          const l = this.page;
          l.calcs = l.calcs.filter((o) => o.id != n), l.originalCalcs = l.originalCalcs.filter((o) => o.id != n);
        }
        return this.reload();
      });
    });
  }
  /**
   * Refreshes the calculation by removing the specified calculation from the current page's
   * calculations and original calculations, then reloads the data.
   */
  refreshCalc(t) {
    const e = this.page;
    return e.calcs = e.calcs.filter((a) => a.id != t.id), e.originalCalcs = e.originalCalcs.filter((a) => a.id != t.id), this.$timeout(() => this.calcsApi.getOData({ $filter: `id eq '${t.id}'` }).then((a) => {
      const n = a.items[0], i = this.calcs.find((r) => r.id === n.id);
      return i && wt.copy(n, i), this.current;
    }), 5e3);
  }
  /**
   * Refreshes the calculation after a workflow event by:
   * 1. Fetching the latest version of the calculation from the API
   * 2. Updating the local calc and originalCalc copies
   * 3. Triggering a refresh of the calculation in the list
   * @returns Promise that resolves with the updated PayrollDetails
   */
  refreshAfterWorkflow() {
    return this.calcsApi.getSingle(this.calc.id).then((t) => (this.calc ? (wt.copy(t, this.calc), wt.copy(t, this.originalCalc)) : (this.calc = t, this.originalCalc = wt.copy(t)), this.refreshCalc(this.calc)));
  }
  /**
   * Adds salary defaults to the current calculation by saving it with the addSalaryDefaults flag.
   * @returns Promise that resolves with the updated PayrollDetails after saving
   */
  async addSalaryDefaultsToCalc() {
    return this.loaders[this.calc.id + "-add-salary-defaults"] = !0, this.saveCalc(this.calc, !1, !0).then(() => (delete this.loaders[this.calc.id + "-add-salary-defaults"], this.current));
  }
  /** Saves the employment and updates the calcs rows optionally */
  saveEmployment(t, e = !1) {
    return this.loaders[this.calc.id + "-employment-" + e] = !0, this.employmentsApi.save(t).then(() => this.calcsApi.updateFromEmployment(this.calc, !1, e).then((a) => (this.calc ? (wt.copy(a, this.calc), wt.copy(a, this.originalCalc)) : (this.calc = a, this.originalCalc = wt.copy(a)), this.saveCalc(this.calc).then(() => (delete this.loaders[this.calc.id + "-employment-" + e], this.current)))));
  }
  /**
   * Gets the list items of the calculations of the current payroll.
   * HACK: This is temporary dev version => Need to consider different apprroaches for the final version.
   */
  get calcs() {
    if (this.current?.id)
      return this._calcs || (this._calcs = [], this._pages = { currentIdx: 0, pages: [] }, this.payrollsApi.getCalcsOData(this.current.id, {}).then((t) => {
        this._calcs = this.orderCalcs(this.current.input.calculations, t.items), this.setPageItems(), this.getEmployments();
      })), this._calcs;
  }
  /**
   * Filters the rows based on column header selection.
   * @param column The name of the column in question.
   * @param value Filtering value string.
   */
  setColumnFilter(t, e) {
    let a = "";
    if (t == "PartnerMessageClosed" || t == "PartnerMessageIssue") {
      const n = [];
      this.columnFilters[t] = e;
      for (const [i, r] of Object.entries(this.columnFilters))
        r == "true" ? n.push(`flags/any(f: f eq '${i}')`) : r == "false" && n.push(`not flags/any(f: f eq '${i}')`);
      a = n.join(" and ");
    }
    this.payrollsApi.getCalcsOData(this.current.id, {
      $filter: a
    }).then((n) => {
      this._calcs = this.orderCalcs(this.current.input.calculations, n.items), this.setPageItems(), this.getEmployments();
    });
  }
  /** Fetches and returns all employment list items related to all calcs in payroll. */
  getEmployments() {
    if (this.calcs) {
      const t = this.calcs.map((e) => e.data.employmentId).filter((e) => !!e);
      if (t.length > 0) {
        this.employments = Object.fromEntries(t.map((n) => [n, void 0]));
        const e = 15, a = [];
        for (let n = 0; n < t.length; n += e) {
          const i = t.slice(n, n + e);
          a.push(this.employmentsApi.getOData({ $filter: i.map((r) => `id eq '${r}'`).join(" or ") }));
        }
        Promise.all(a).then((n) => {
          n.forEach((i) => {
            i.items.forEach((r) => {
              this.employments[r.id] = r;
            });
          }), this.$timeout();
        });
      }
    }
  }
  /** Returns current calc page. */
  get page() {
    if (this._pages)
      for (let t = 0; t < this._pages.pages.length; t++)
        t !== this._pages.currentIdx && this._pages.pages[t].calcs.length > 0 && (this._pages.pages[t].calcs = [], this._pages.pages[t].originalCalcs = []);
    return this._pages?.pages[this._pages.currentIdx];
  }
  /** Set page items. */
  setPageItems() {
    if (this._pages) {
      this._pages.currentIdx = 0, this._pages.pages.splice(0, this._pages.pages.length);
      const t = this._calcs.length, e = Math.ceil(this._calcs.length / this.pageSize);
      for (let a = 0; a < this._calcs.length; a += this.pageSize) {
        const n = this._calcs.slice(a, a + this.pageSize), i = a + 1 + " - " + (a + n.length);
        this._pages.pages.push({ current: Math.ceil((a + 1) / this.pageSize), total: e, items: n, calcs: [], originalCalcs: [], calcRange: i, totalCalcCount: t });
      }
    }
  }
  /** Returns current calc page. */
  getPageCalc(t) {
    if (this._pages) {
      const e = this.page;
      e.calcs ?? (e.calcs = []), e.originalCalcs ?? (e.originalCalcs = []);
      const a = e.calcs.find((n) => n.id == t.id);
      if (a)
        return a.rows ? a : void 0;
      {
        const n = { id: t.id }, i = wt.copy(n);
        e.calcs.push(n), e.originalCalcs.push(i), this.calcsApi.getSingle(t.id).then((r) => {
          wt.copy(r, n), wt.copy(r, i);
        });
      }
    } else
      return;
  }
  /**
   * Saves the calculation and reloads the payroll.
   */
  savePageCalcs() {
    const t = this.page;
    this.loaders["pageCalcs" + t.current] = !0;
    const a = this.page.calcs.filter((n) => !!n.rows && n.isReadOnly !== !0).filter((n) => !wt.equals(n, t.originalCalcs.find((i) => i.id === n.id)));
    return this.payrollsApi.saveCalculations(this.current.id, a).then((n) => {
      for (const i of n) {
        const r = this.calcs.find((l) => l.id === i.id);
        r && wt.copy(i, r);
      }
      return delete this.loaders["pageCalcs" + t.current], t.calcs = t.calcs.filter((i) => !a.find((r) => r.id === i.id)), t.originalCalcs = t.originalCalcs.filter((i) => !a.find((r) => r.id === i.id)), this.reload();
    });
  }
  /**
   * Checks if the current page calcs have changes.
   * Returns the number of changed calcs.
   */
  get numOfChangedPageCalcs() {
    const t = this.page;
    return t ? this.page.calcs.filter((a) => !!a.rows && a.isReadOnly !== !0).filter((a) => !wt.equals(a, t.originalCalcs.find((n) => n.id === a.id))).length : 0;
  }
  /** Gets calculation validity from the calc table entry */
  getCalcValidity(t) {
    return this.current?.validations?.find((e) => e.id === t.id);
  }
  /**
   * Advances to next page.
   */
  goToPage(t = !1) {
    return this._pages ? (this.numOfChangedPageCalcs > 0 ? this.savePageCalcs() : Promise.resolve(this.current)).then(() => {
      let a = this._pages.currentIdx;
      t ? (a -= 1, this._pages.currentIdx = a > -1 ? a : this._pages.pages.length - 1) : (a += 1, this._pages.currentIdx = a < this._pages.pages.length ? a : 0);
    }) : void 0;
  }
  /**
   * Opens a list of workers in to a dialog window.
   * Creates a new calculation for the selected worker and current payroll.
   */
  addEmployments() {
    const t = [];
    this.uiHelpers.openEditDialog(
      "salaxy-components/modals/calc/WorkerList.html",
      t,
      {
        title: "SALAXY.NG1.PayrollComponent.createNewCalcDialog"
      }
    ).then((e) => {
      if (e.action === "ok" && t.length > 0) {
        const a = {};
        a.listItemType = "EmploymentListItem";
        const n = void 0, i = void 0, r = (l) => {
          const o = l.map((c) => c.id);
          return this.payrollsApi.addEmployments(this.current.id, o).then((c) => {
            const d = l.map(() => ({ message: "", result: [] }));
            return d.length > 0 && (d[0].result = c), d;
          });
        };
        return this.uiHelpers.showBatchProcessDialog(L.get("SALAXY.NG1.PayrollComponent.createNewCalcLoading"), t, r, i, a, n, 20, !0, !0, !0).then((l) => (l.done && (l.results.forEach((o) => {
          for (const c of o.result) {
            const d = this.calcs.find((p) => p.id === c.id);
            d ? wt.copy(c, d) : this.calcs.push(c);
          }
        }), this.setPageItems()), this.reload()));
      }
    });
  }
  /**
   * Opens the list of calculations into a dialog window for selection and then adds them to payroll
   * @param category Either "paid": Read-only, a copy is added ... or "draft": Editable, moved with status changed.
   * @param isMerge If true, the operation merges the calculations to the current payroll.
   * @param removeAllRows If true, the merge operation removes all the rows from the calculation.
   * @param applyEmploymentDefaultRows If true, the merge operation adds the employment default rows to the calculations.
   */
  addCalcs(t = "draft", e = !1, a = !1, n = !1) {
    const i = t === "paid" ? "SALAXY.NG1.PayrollComponent.addExistingCalcCopy" : t == "shared" ? "SALAXY.NG1.PayrollComponent.addExistingCalcMoveShared" : "SALAXY.NG1.PayrollComponent.addExistingCalcMove";
    this.uiHelpers.openSelectCalcs(t, i).then((r) => {
      if (r.action === "ok" && r.item.length > 0) {
        const l = r.item, o = {};
        o.listItemType = "CalculationListItem";
        const c = void 0, d = void 0, p = (h) => {
          const g = h.map((x) => x.id);
          return (e ? this.payrollsApi.mergeCalculations(this.current.id, g, a, n) : this.payrollsApi.addCalculations(this.current.id, g)).then((x) => {
            const b = h.map(() => ({ message: "", result: [] }));
            return b.length > 0 && (b[0].result = x), b;
          });
        };
        return this.uiHelpers.showBatchProcessDialog(L.get("SALAXY.NG1.PayrollComponent.addExistingCalcLoading"), l, p, d, o, c, 20, !0, !0, !0).then((h) => (h.done && (h.results.forEach((g) => {
          for (const x of g.result) {
            const b = this.calcs.find((A) => A.id === x.id);
            b ? wt.copy(x, b) : this.calcs.push(x);
          }
        }), this.setPageItems()), this.reload()));
      }
    });
  }
  /**
   * Deletes the calculation
   * @param unlink If true, will not delete the actual calculation, but instead unlinks it as a separate calculation outside this payroll.
   */
  deleteCalc(t = !1) {
    const e = this.calcId;
    t ? this.uiHelpers.showConfirm(
      "SALAXY.NG1.PayrollComponent.payrollCalcs.unlinkCalcDialog.heading",
      "SALAXY.NG1.PayrollComponent.payrollCalcs.unlinkCalcDialog.intro",
      "SALAXY.NG1.PayrollComponent.payrollCalcs.unlinkCalcDialog.confirmButton",
      "SALAXY.NG1.PayrollComponent.payrollCalcs.unlinkCalcDialog.cancelButton"
    ).then((a) => {
      if (a) {
        const n = this.uiHelpers.showLoading("SALAXY.NG1.PayrollComponent.payrollCalcs.unlinkCalcDialog.loading");
        this.payrollsApi.unlinkCalculation(this.current.id, e).then((i) => {
          if (this.setCurrentValue(i, !0), this.current.input.calculations.indexOf(e) == -1) {
            const r = this.calcs.find((l) => l.id === e);
            r && (this.calcs.splice(this.calcs.indexOf(r), 1), this.setPageItems()), this.setCalc(void 0);
          }
          n.dismiss();
        });
      } else
        return;
    }) : this.uiHelpers.showConfirm(
      "SALAXY.NG1.PayrollComponent.payrollCalcs.deleteCalcDialog.heading",
      "SALAXY.NG1.PayrollComponent.payrollCalcs.deleteCalcDialog.introNoChanges",
      "SALAXY.NG1.PayrollComponent.payrollCalcs.deleteCalcDialog.confirmButton",
      "SALAXY.NG1.PayrollComponent.payrollCalcs.deleteCalcDialog.cancelButton"
    ).then((a) => {
      if (a) {
        const n = this.uiHelpers.showLoading("SALAXY.NG1.PayrollComponent.payrollCalcs.deleteCalcDialog.loading");
        this.payrollsApi.deleteCalculation(this.current.id, e).then((i) => {
          if (this.setCurrentValue(i, !0), this.current.input.calculations.indexOf(e) == -1) {
            const r = this.calcs.find((l) => l.id === e);
            r && (this.calcs.splice(this.calcs.indexOf(r), 1), this.setPageItems()), this.setCalc(void 0);
          }
          n.dismiss();
        });
      } else
        return;
    });
  }
  /**
   * Opens a list of payrolls for merging the payroll calculations to the current payroll.
   * @param removeAllRows If true, the operation removes all the rows from the calculation.
   * @param applyEmploymentDefaultRows If true, the operation applies the employment default rows to the new calculations.
   */
  mergePayroll(t = !1, e = !1) {
    const a = [];
    return this.uiHelpers.openEditDialog("salaxy-components/modals/payroll/PayrollDetailsList.html", a, {
      title: L.get("SALAXY.NG1.PayrollComponent.mergePayroll.title"),
      category: "draft"
    }, "lg").then((n) => {
      if (n.action != "ok" || a.length < 1)
        return this.current;
      const i = [];
      let r;
      for (const l of a) {
        if (l.id == this.current.id)
          continue;
        const o = this.payrollsApi.getSingle(l.id).then((c) => this.payrollsApi.getCalcsOData(l.id, null).then((d) => i.push(...this.orderCalcs(c.input.calculations, d.items))));
        r = r ? r.then(o) : o;
      }
      return r.then(() => {
        const l = {};
        l.listItemType = "CalculationListItem";
        const o = void 0, c = void 0, d = (p) => {
          const h = p.map((g) => g.id);
          return this.payrollsApi.mergeCalculations(this.current.id, h, t, e).then((g) => {
            const x = p.map(() => ({ message: "", result: [] }));
            return x.length > 0 && (x[0].result = g), x;
          });
        };
        return this.uiHelpers.showBatchProcessDialog(L.get("SALAXY.NG1.PayrollComponent.mergePayroll.batchProcessTitle"), i, d, c, l, o, 20, !0, !0, !0).then((p) => (p.done && (p.results.forEach((h) => {
          for (const g of h.result) {
            const x = this.calcs.find((b) => b.id === g.id);
            x ? wt.copy(g, x) : this.calcs.push(g);
          }
        }), this.setPageItems()), this.reload()));
      });
    });
  }
  /**
   * Shows a confirm dialog if payroll has any calculations.
   * Returns true if a user clicks OK -button. Otherwise (cancel or close) returns false.
   * @returns True if the user confirmed the operation.
   */
  importEmploymentDataAll() {
    const t = this.current;
    return !t.info.calcCount || t.info.calcCount === 0 ? this.uiHelpers.showAlert("SALAXY.NG1.PayrollComponent.importEmploymentDataAllAlertTitle", "SALAXY.NG1.PayrollComponent.importEmploymentDataAllAlertDescr").then(() => !1) : this.uiHelpers.showConfirm(
      "SALAXY.NG1.PayrollComponent.importEmploymentDataAllConfirmTitle",
      "SALAXY.NG1.PayrollComponent.importEmploymentDataAllConfirmDescr",
      "SALAXY.UI_Terms.continue",
      "SALAXY.UI_Terms.cancel"
    ).then((e) => {
      if (e) {
        const a = this.calcs.slice(0), n = {};
        n.listItemType = "CalculationListItem";
        const i = void 0, r = void 0, l = (o) => this.calcsApi.getSingle(o.id).then((c) => this.calcsApi.updateFromEmployment(c, !0, !0).then(() => [{ message: "", result: [] }]));
        return this.uiHelpers.showBatchProcessDialog(L.get("SALAXY.NG1.PayrollComponent.importEmploymentDataAllLoading"), a, l, r, n, i, null, !0, !0).then(() => this.reload().then(() => (this._calcs = null, !0)));
      } else
        return !1;
    });
  }
  /**
   * Adds salary defaults to all calculations in the current payroll.
   * Shows a confirmation dialog before proceeding.
   * If there are no calculations in the payroll, shows an alert and returns false.
   * Otherwise shows a confirmation dialog:
   * If user confirms, processes all calculations in batches of 20:
   * 1. Saves the calculations with salary defaults via payrollsApi
   * 2. Updates the local calcs list with the returned results
   * 3. Reloads the payroll data
   * 4. Returns true on success
   * If user cancels, returns false
   * @returns Promise<boolean> - True if salary defaults were successfully added, false if cancelled or no calculations
   */
  async addSalaryDefaultsToAllCalcs() {
    const t = this.current;
    return !t.info.calcCount || t.info.calcCount === 0 ? this.uiHelpers.showAlert("SALAXY.NG1.PayrollComponent.importEmploymentDataAllAlertTitle", "SALAXY.NG1.PayrollComponent.addSalaryDefaultsToAllCalcsAlertTitle").then(() => !1) : this.uiHelpers.showConfirm(
      "SALAXY.NG1.PayrollComponent.addSalaryDefaultsToAllCalcsTitle",
      "SALAXY.NG1.PayrollComponent.addSalaryDefaultsToAllCalcsDescr",
      "SALAXY.UI_Terms.continue",
      "SALAXY.UI_Terms.cancel"
    ).then((e) => {
      if (e) {
        const a = this.calcs.slice(0), n = {};
        n.listItemType = "CalculationListItem";
        const i = void 0, r = void 0, l = (o) => {
          const c = o.map((d) => d.id);
          return this.payrollsApi.saveCalculations(this.current.id, c, !1, !0).then((d) => {
            const p = o.map(() => ({ message: "", result: [] }));
            return p.length > 0 && (p[0].result = d), p;
          });
        };
        return this.uiHelpers.showBatchProcessDialog(L.get("SALAXY.NG1.PayrollComponent.importEmploymentDataAllLoading"), a, l, r, n, i, 20, !0, !0, !0).then((o) => (o.done && (o.results.forEach((c) => {
          for (const d of c.result) {
            const p = this.calcs.find((h) => h.id === d.id);
            p ? wt.copy(d, p) : this.calcs.push(d);
          }
        }), this.setPageItems()), this.reload().then(() => (this._calcs = null, !0))));
      } else
        return !1;
    });
  }
  /**
   * Show confirm dialog and export employment data from calculation to Employment relation.
   * If the calculation has unmodified changes, the calculation is saved.
   * @returns True if the user confirmed the operation.
   */
  exportEmploymentData() {
    return this.uiHelpers.showConfirm(
      "SALAXY.NG1.PayrollComponent.exportEmploymentDataTitle",
      "SALAXY.NG1.PayrollComponent.exportEmploymentDataDescr",
      "SALAXY.UI_Terms.continue",
      "SALAXY.UI_Terms.cancel"
    ).then((t) => {
      if (t) {
        const e = this.uiHelpers.showLoading("SALAXY.NG1.PayrollComponent.exportEmploymentDataLoading");
        return this.saveCalc(this.calc).then(() => this.calcsApi.updateToEmployment(this.calc).then(() => (e.dismiss(), !0)));
      } else
        return !1;
    });
  }
  /** Free reports */
  clearReports() {
    this.reportCalcs = null, this.reportCalcs = [];
  }
  /** Refreshses the reports for the payroll. */
  refreshReports() {
    const t = this.current;
    if (t.info.calcCount && t.info.calcCount > 0) {
      const e = this.calcs.slice(0), a = {};
      a.listItemType = "CalculationListItem";
      const n = void 0, i = void 0, r = (l) => {
        const o = l.map((c) => c.id);
        return this.calcsApi.getMulti(o).then((c) => {
          const d = l.map(() => ({ message: "", result: [] }));
          return d.length > 0 && (d[0].result = c), d;
        });
      };
      return this.uiHelpers.showBatchProcessDialog(L.get("SALAXY.UI_Terms.wait"), e, r, i, a, n, 20, !0, !0, !0).then((l) => (l.done && (this.reportCalcs.splice(0, this.reportCalcs.length), l.results.forEach((o) => {
        this.reportCalcs.push(...o.result);
      })), this.reportCalcs));
    } else
      return this.reportCalcs.splice(0, this.reportCalcs.length), Promise.resolve(this.reportCalcs);
  }
  /** Shows the paymentd dialog / the invoices UI. */
  showPaymentDialog() {
    this.invoicesService.showPaymentDialog(this.current);
  }
  /**
   * Cancels the payment or invoice processing for the current payroll.
   */
  cancelInvoices() {
    const t = this.invoicesService.getEprWarningForCancellation(this.current.info.salaryDate, this.current.info.status == Ua.PaymentSucceeded), e = t ? `
` + t : "";
    return this.uiHelpers.showConfirm(L.get("SALAXY.NG1.CalcResultsComponent.cancelDialogTitle") + "?", L.get("SALAXY.NG1.CalcResultsComponent.cancelDialogDescr") + `${e}`, "SALAXY.NG1.CalcResultsComponent.cancelDialogYes", "SALAXY.NG1.CalcResultsComponent.cancelDialogNo").then((a) => {
      if (a)
        if (ne.isCfa(this.current.input.paymentChannel)) {
          const n = this.uiHelpers.showLoading("SALAXY.UI_Terms.wait");
          return this.payrollsApi.cancelInvoices(this.current.id, [], !1).then(() => this.reload().then(() => (n.dismiss(), this._calcs = null, this.current)));
        } else {
          const n = wt.copy(this.calcs), i = {};
          i.listItemType = "CalculationListItem";
          const r = void 0, l = void 0, o = (c, d) => {
            const p = c.map((x) => x.id), g = d.dialogList.filter((x) => !x.processed).length != 0;
            return this.payrollsApi.cancelInvoices(this.current.id, p, g).then(() => c.map(() => ({ message: "", result: [] })));
          };
          return this.uiHelpers.showBatchProcessDialog(L.get("SALAXY.UI_Terms.wait"), n, o, l, i, r, 20, !0, !0, !0).then(() => this.reload().then(() => (this._calcs = null, this.current)));
        }
      else
        return this.current;
    });
  }
  /**
   * Gets the user-specific setting (service), stored in the local storage.
   */
  get userSettings() {
    return this.userSettingsService;
  }
  /** Get calculated header info. */
  get info() {
    const e = (this.calcs ?? []).filter((a) => {
      switch (this.current?.info.status) {
        case Ua.PaymentSucceeded:
          return a.status === le.PaymentSucceeded;
        case Ua.PaymentStarted:
          return a.status === le.PaymentStarted || a.status === le.PaymentSucceeded;
        default:
          return !0;
      }
    });
    return this._info.calcCount.original = this.current?.info.calcCount ?? 0, this._info.calcCount.actual = e.length, this._info.calcCount.exception = this._info.calcCount.actual !== this._info.calcCount.original, this._info.totalGrossSalary.original = se.round(this.current?.info.totalGrossSalary ?? 0), this._info.totalGrossSalary.actual = se.round(ie.sum(e, (a) => a.grossSalary ?? 0)), this._info.totalGrossSalary.exception = this._info.totalGrossSalary.actual !== this._info.totalGrossSalary.original, this._info.totalPayment.original = se.round(this.current?.info.totalPayment ?? 0), this._info.totalPayment.actual = se.round(ie.sum(e, (a) => a.payment ?? 0)), this._info.totalPayment.exception = this._info.totalPayment.actual !== this._info.totalPayment.original, this._info;
  }
  /** Returns exception style. */
  getExceptionStyle(t) {
    return t ? { "text-decoration": "line-through" } : {};
  }
  /** Returns true, if a warning should be indicated in a row. */
  rowStatusWarning(t) {
    switch (this.current?.info.status) {
      case Ua.PaymentSucceeded:
        return t.status !== le.PaymentSucceeded;
      case Ua.PaymentStarted:
        return !(t.status === le.PaymentStarted || t.status === le.PaymentSucceeded);
      default:
        return !1;
    }
  }
  /** Copy current calc */
  copyCalc() {
    const t = wt.copy(this.calc);
    t.id = null, t.info.payrollId = null, t.workflow.status = le.Draft;
    const e = this.uiHelpers.showLoading("SALAXY.UI_Terms.wait");
    return this.calcsApi.save(t).then(() => {
      e.dismiss();
    });
  }
  /** Returns true if the curren payroll has cfa payment channel. */
  get isCfa() {
    return ne.isCfa(this.current?.input?.paymentChannel);
  }
  /** Pay current calc */
  payCalc() {
    this.isCfa || this.invoicesService.showPaymentDialog(this.calc);
  }
  /**
   * Sends a payroll with messaging system and sets
   * @param $msg The MessageThreadCrudController that is used for creating the message thread.
   */
  sendPayrollMessage(t) {
    t.current || (t.model = "new");
    const e = t.current;
    return e.otherParty = this.sessionService.session.settings.partner.accountId, e.status = eu.Active, e.title = e.title || "Palkkalista " + this.current.input.title, e.ownerWorkflow = {
      salaryDate: this.current.info.salaryDate
    }, e.messages.push({
      contentId: this.currentId,
      fromParty: this.sessionService.isInRole("pro") ? Xn.OtherParty : Xn.Owner,
      type: ja.Payroll
    }), t.save().then((a) => {
      if (this.current.info.status != Ua.WaitingApproval)
        return this.current.info.messageThreadId = a.id, this.current.info.status = Ua.WaitingApproval, this.save().then(() => {
        });
      this.current.info.messageThreadId = a.id;
    });
  }
  /**
   * Opens the workflow for the payroll.
   * @param $msg The MessageThreadCrudController that is used for creating the message thread.
   */
  openWorkflowForpayroll(t) {
    t.current || (t.model = "new");
    const e = t.current;
    return e.otherParty = this.sessionService.session.settings.partner.accountId, e.status = eu.Active, e.title = e.title || "Palkkalista " + this.current.input.title, e.ownerWorkflow = {
      salaryDate: this.current.info.salaryDate
    }, e.messages.push({
      contentId: this.currentId,
      fromParty: this.sessionService.isInRole("pro") ? Xn.OtherParty : Xn.Owner,
      type: ja.Payroll
    }), t.save().then((a) => (this.current.info.messageThreadId = a.id, this.save().then(() => {
    })));
  }
  /**
   * Gets the message title for the action.
   */
  getMessageTitle(t) {
    return this.messageActions.find((e) => e.value == t).title + ": " + this.current.input.title;
  }
  /**
   * Deletes a linked message: Both the message thread and msg id in this payroll.
   * @param $msg The MessageThreadCrudController that contains the current message.
   */
  deleteMessage(t) {
    this.uiHelpers.showConfirm("Haluatko poistaa viestiketjun?", "Haluatko varmasti poistaa viestiketjun?").then((e) => {
      e && (t.current ? t.deleteNoConfirm(t.current).then(() => {
        this.current.info.messageThreadId = null, this.save();
      }) : (this.current.info.messageThreadId = null, this.save()));
    });
  }
  /** Show add new taxcard dialog */
  async showAddNewTaxcard(t, e) {
    t.stopPropagation();
    const a = this.uiHelpers.showLoading("SALAXY.UI_Terms.wait"), n = this.getPageCalc(e) ?? await this.calcsApi.getSingle(e.id);
    if (!n || n.isReadOnly) {
      a.dismiss();
      return;
    }
    const i = await this.employmentsApi.getSingle(n.worker.employmentId);
    if (!i) {
      a.dismiss();
      return;
    }
    if ((i.info.taxcard == Xa.Undefined || i.info.taxcard == Xa.Auto) && await this.taxcardsApi.setAuto(n.worker.paymentData.socialSecurityNumberValid)) {
      await this.saveCalc(n), a.dismiss();
      return;
    }
    if ((await this.uiCrudHelpers.createNewTaxcard(n.worker.paymentData.socialSecurityNumberValid)).action === "ok") {
      await this.saveCalc(n), a.dismiss();
      return;
    }
    a.dismiss();
  }
  /** Assist */
  assist() {
    this.hasAssistant = !this.hasAssistant, this.hasAssistant && this.tabButtonsCtrl.showTab("rows");
  }
  /** Sets the ordering for the rows. */
  orderBy(t) {
    this.orderField == t ? this.orderReverse ? (this.orderField = null, this.orderReverse = !1) : this.orderReverse = !0 : (this.orderField = t, this.orderReverse = !1), this.orderField ? this.calcs.sort(this.getOrderBy()) : this.orderCalcs(this.current.input.calculations, this.calcs), this.setPageItems();
  }
  /** Initializes the UI parameters for the rows import data. */
  initRowsImportParams() {
    this.rowsImportParams.title = `Demo data from calculation ${this.calc.worker.avatar.sortableName} ${this.calc.workflow.salaryDate || "No date"}`, this.rowsImportParams.personalId = this.calc.worker.paymentData.socialSecurityNumberValid, this.rowsImportParams.employmentType = this.calc.result.responsibilities.employmentType, this.rowsImportParams.payrollId = this.current.id, this.rowsImportParams.period.start = this.calc.info.workStartDate, this.rowsImportParams.period.end = this.calc.info.workEndDate, this.rowsImportParams.period.daysCount = this.calc.framework.numberOfDays;
  }
  /** Copies the rows import data to the clipboard. */
  copyRowsImportData() {
    if (!this.calc?.rows?.length) {
      alert("Ei rivejä valitussa laskelmassa.");
      return;
    }
    const t = {
      start: this.rowsImportParams.period.start,
      end: this.rowsImportParams.period.end
    };
    let e = 0;
    const a = {
      header: {
        title: this.rowsImportParams.title,
        period: t
      },
      rows: this.calc.rows.map((i) => {
        const r = {
          employmentType: this.rowsImportParams.employmentType,
          personalId: this.rowsImportParams.personalId,
          rowType: i.rowType,
          type: i.type,
          count: i.count,
          message: i.message,
          period: i.period || {},
          accounting: i.accounting,
          sourceId: "DemoImport" + e++,
          // Not typically used in import data.
          // price: x.price,
          // unit: x.unit,
          data: {}
        };
        r.period.start = r.period?.start || t.start, r.period.end = r.period?.end || t.end;
        const l = structuredClone(i.data);
        return delete l.payrollPeriodId, delete l.importExplicitPrice, delete l.committedAt, delete l.status, l.isApproved = !0, l.payrollId = this.rowsImportParams.payrollId, r.data = l, r;
      })
    }, n = JSON.stringify(a, null, 2);
    window.navigator.clipboard.writeText(n), alert("Rivit on kopioitu leikepöydälle");
  }
  /** Ordering filter */
  getOrderBy() {
    switch (this.orderField) {
      case "status":
        return (t, e) => {
          const a = `${L.get("SALAXY.ENUM.CalculationStatus." + (Qe.getProperty(t, this.orderField) ?? "") + ".label")}`, n = `${L.get("SALAXY.ENUM.CalculationStatus." + (Qe.getProperty(e, this.orderField) ?? "") + ".label")}`;
          return (this.orderReverse ? -1 : 1) * a.localeCompare(n, "fi");
        };
      case "grossSalary":
      case "data.workerPayment":
        return (t, e) => (this.orderReverse ? -1 : 1) * ((Qe.getProperty(t, this.orderField) ?? 0) - (Qe.getProperty(e, this.orderField) ?? 0));
      default:
        return (t, e) => (this.orderReverse ? -1 : 1) * (Qe.getProperty(t, this.orderField) ?? "").localeCompare(Qe.getProperty(e, this.orderField) ?? "", "fi");
    }
  }
  getHeaderChangeInfo() {
    return {
      isPaymentChannelChanged: this.current.input.paymentChannel !== this.original.input.paymentChannel,
      isPeriodChanged: this.current.input.period.daysCount !== this.original.input.period.daysCount || this.current.input.period.start !== this.original.input.period.start || this.current.input.period.end !== this.original.input.period.end,
      isSalaryDateChanged: this.current.input.salaryDate !== this.original.input.salaryDate || this.current.input.salaryDateKind !== this.original.input.salaryDateKind
    };
  }
  orderCalcs(t, e) {
    return e && (e.sort((a, n) => t.indexOf(a.id) - t.indexOf(n.id)), e);
  }
};
p$.$inject = ["Payrolls4", "UiHelpers", "$location", "$routeParams", "Calculations", "Employments", "InvoicesService", "$timeout", "UserSettingsService", "SessionService", "Taxcards", "UiCrudHelpers", "$rootScope", "$scope"];
let gu = p$;
const h$ = class h$ {
  constructor(t) {
    this.invoicesService = t;
  }
  /**
   * Initializes the controller
   */
  $onInit() {
  }
  /**
   * Text for the payment button
   * This is typically customized in custom payment scenarios.
   */
  getPaymentButtonText() {
    return this.label ? L.get(this.label) : L.get("SALAXY.UI_Terms.pay");
  }
  /**
   * Shows the payment process first page in a dialog (the invoice create process).
   */
  goToInvoices() {
    this.invoicesService.showPaymentDialog(this.businessObject);
  }
  /** Returns current business object */
  get businessObject() {
    return this.model;
  }
  /**
   * Returns true if there is a selected channel for the business object.
   */
  get isChannelDefined() {
    return this.getCurrentChannel() != At.Undefined;
  }
  /** Gets the current channel avatar. */
  get currentChannel() {
    return ne.getChannelAvatar(this.getCurrentChannel());
  }
  /** Sets the payment channel and starts recalculation. */
  setPaymentChannel(t) {
    if (ne.isCalculation(this.businessObject))
      this.businessObject.info.paymentChannel = t;
    else if (ne.isPayroll(this.businessObject))
      this.businessObject.input.paymentChannel = t;
    else
      throw new Error("Unknwon business object type.");
    this.onPaymentChannelChange({ paymentChannel: t, businessObject: this.businessObject });
  }
  /** Gets the enabled channels. */
  get allChannels() {
    return this.invoicesService.channels;
  }
  getCurrentChannel() {
    let t = null;
    return ne.isCalculation(this.businessObject) ? t = this.businessObject.info.paymentChannel : ne.isPayroll(this.businessObject) && (t = this.businessObject.input.paymentChannel), t ?? At.Undefined;
  }
};
h$.$inject = ["InvoicesService"];
let Lx = h$;
const _y = class _y extends wr {
  constructor(t, e, a, n, i, r, l, o, c, d) {
    super(t, l, e, n, i, r, o), this.uiCrudHelpers = a, this.invoicesService = o, this.reportsApi = c, this.ajax = d, this.loaders = {}, this.accountingDiffDataReader = {
      /** Function to read data into given array */
      read: (p, h, g) => (this.accountingDiffData && g.push(this.accountingDiffData), Promise.resolve()),
      /** Optional label for data export */
      exportLabel: null,
      /** Indicates if the export is not possible */
      disabled: () => !this.accountingDiffData,
      /* Indicates if row is expandable */
      showExpand: !0,
      /* Indicates if rows exists*/
      hasRows: () => !this.accountingDiffData?.ledgerAccounts
    }, this.accountingDiffDataStatus = "initial", this._diffCalc = {}, this.pendingAccountingDiffData = !1, t.getSingle = (p) => this.ajax.getJSON(`/v03-rc/api/calculations/correction/${p}`).then((h) => h.calculation);
  }
  /**
   * Initializes the controller
   */
  $onInit() {
    super.$onInit();
  }
  /** Calculation total result diff between original and current calculation. */
  get diffCalc() {
    return this.onCalculationChange(), this._diffCalc;
  }
  /** Accounting data diff between original and current calculation. */
  get accountingDiffData() {
    return this.onCalculationChange(), this._accountingDiffData;
  }
  /** Document flow for the current calculation */
  get documentFlow() {
    return !this._documentFlow && this.current?.id && (this._documentFlow = { item: null, children: null }, this.ajax.getJSON(`/v03-rc/api/calculations/correction/${this.current.id}/document-flow`).then((t) => {
      wt.copy(t, this._documentFlow);
    })), this._documentFlow;
  }
  /**
   * Returns validation for calculation
   */
  get validation() {
    return this.current ? (this.current.result.validation.isValid || (this.current.result.validation.isValid = this.current.result.validation.errors.every((t) => t.type === Ra.Warning)), this.current.result.validation) : null;
  }
  /**
   * Starts the reload process depending on the bindingMode:
   */
  reload() {
    return super.reload().then((t) => (t.isReadOnly = !1, t));
  }
  /** Load accounting data and calculate diff. */
  loadAccountingDiffData(t = null) {
    if (t == null)
      if (this.accountingDiffDataStatus === "initial")
        t = "default";
      else {
        if (this.accountingDiffDataStatus === "loading")
          return;
        t = this.accountingDiffDataStatus;
      }
    if (this.accountingDiffDataStatus !== "loading") {
      this.pendingAccountingDiffData = !1, this.accountingDiffDataStatus = "loading";
      const e = [this.base, this.current].map((a) => this.reportsApi.getAccountingDataForCalculations([a], t, null));
      Promise.all(e).then((a) => {
        a && a.length == 2 && (this._accountingDiffData = this.diffAccountingData(a[0], a[1])), this.accountingDiffDataStatus = t, this.pendingAccountingDiffData && this.loadAccountingDiffData();
      });
    }
  }
  /**
   * Change base calculations
   */
  changeBase() {
    this.uiHelpers.showDialog(
      "salaxy-components/modals/calc/SelectVersion.html",
      null,
      {
        versions: this.versions,
        versionId: this.versionId
      }
    ).then((t) => {
      if (t && t != "cancel") {
        const e = t;
        this.api.getVersion(this.currentId, e?.versionId).then((a) => {
          a.isReadOnly = !1, this.baseCalc = a, this.versionId = e?.versionId, this.onCalculationChange();
        });
      }
    });
  }
  // TODO: refresh -method should be called after every field update in the ui. Including rows.
  /**
   * Refreshes the calculation using the server side logic.
   * @param refresh Option for refresh.
   */
  refresh(t = "default") {
    let e = "";
    if (t == "default") {
      this.loaders[t] = !0;
      const a = {
        id: this.current.id,
        calculation: this.current,
        state: this._state
      };
      this.ajax.postJSON(`/v03-rc/api/calculations/correction/refresh/${t}`, a).then((n) => {
        this._state = n.state, n.calculation.isReadOnly = !1, wt.copy(n.calculation, this.current), this.loaders[t] = !1;
      });
    } else {
      switch (t) {
        case "worker":
          e = "Haluatko päivittää työntekijän tiedot laskelmalle?";
          break;
        case "employer":
          e = "Haluatko päivittää työnantajan tiedot laskelmalle?";
          break;
        case "employment":
          e = "Haluatko päivittää työsuhteen tiedot laskelmalle?";
          break;
        case "taxcard":
          e = "Haluatko päivittää verokortin tiedot laskelmalle?";
          break;
        case "insurances":
          e = "Haluatko päivittää vero-, eläke- ja vakuutustiedot laskelmalle?";
          break;
        case "cfa":
          e = "Haluatko päivittää asiakasvaraerät laskelmalle?";
          break;
        default:
          e = "";
      }
      this.uiHelpers.showConfirm("Haluatko jatkaa?", e, "Päivitä", "Peruuta").then((a) => {
        if (a) {
          this.loaders[t] = !0;
          const n = {
            id: this.current.id,
            calculation: this.current,
            state: this._state
          };
          this.ajax.postJSON(`/v03-rc/api/calculations/correction/refresh/${t}`, n).then((i) => {
            this._state = i.state, i.calculation.isReadOnly = !1, wt.copy(i.calculation, this.current), this.loaders[t] = !1;
          });
        } else
          return;
      });
    }
  }
  /**
   * Saves the edited readonly calculation.
   */
  saveEdited() {
    const t = {
      id: this.current.id,
      calculation: this.current,
      state: this._state,
      snapshot: {
        categories: []
      }
    };
    this.ajax.getJSON("/v03-rc/api/calculations/correction/snapshot/categories").then((e) => {
      this.uiHelpers.openEditDialog("salaxy-components/modals/calc/EditorConfirm.html", { categories: [""] }, { categories: e }).then((a) => {
        if (a.action == We.Ok) {
          const n = this.uiHelpers.showLoading("SALAXY.UI_Terms.isSaving");
          t.snapshot = a.item, this.ajax.postJSON("/v03-rc/api/calculations/correction", t).then((i) => {
            n.dismiss(), this._state = i.state, i.calculation.isReadOnly = !1, wt.copy(i.calculation, this.current);
          });
        } else
          return;
      });
    });
  }
  /** Getter and setter for Calculation daterange in compatible format for new DateRange component. */
  get dateRange() {
    return this.current ? (this._dateRange || (this._dateRange = {
      start: this.current.info.workStartDate,
      end: this.current.info.workEndDate,
      daysCount: this.current.framework.numberOfDays
    }), this._dateRange) : null;
  }
  set dateRange(t) {
    this._dateRange = t;
  }
  /**
   * Called when the date range changes.
   */
  dateRangeChange() {
    !this.dateRange || !this.current || (this.current.info.workStartDate = this.dateRange.start, this.current.info.workEndDate = this.dateRange.end, this.current.framework.numberOfDays = this.dateRange.daysCount);
  }
  get base() {
    return !this.baseCalc && this.versions.length > 0 && (this.versionId = this.versions[this.versions.length - 1].versionId, this.baseCalc = wt.copy(this.original)), this.baseCalc ?? this.original;
  }
  /**
   * Returns valid employment reg codes for the selected pensions company.
   * @returns Options for the employment reg codes.
   */
  getEmploymentRegCodeOptions() {
    return this.uiHelpers.cache(
      this,
      "employmentRegCodes",
      () => S0.filter((t) => t.pensionCompany === this.current.result.responsibilities.pensionCompany).map((t) => ({ value: t.code, text: L.getLanguage() === Me.Sv ? t.labelSv : t.labelFi })),
      () => this.current.result.responsibilities.pensionCompany
    );
  }
  diffAccountingData(t, e) {
    t.ledgerAccounts.forEach((n) => n.entries = []), t.summary = {}, e.ledgerAccounts.forEach((n) => n.entries = []), e.summary = {};
    const a = e;
    return t.ledgerAccounts.forEach((n) => {
      const i = a.ledgerAccounts.find((r) => r.accountNumber === n.accountNumber && r.accountGrouping == n.accountGrouping);
      if (i)
        i.saldo = i.saldo - n.saldo;
      else {
        const r = wt.copy(n);
        r.saldo = 0 - n.saldo, a.ledgerAccounts.push(r);
      }
    }), a.ledgerAccounts.forEach((n) => n.entries = [
      {
        id: null,
        entryDate: null,
        description: "Ero",
        isDebit: n.saldo >= 0,
        amount: n.saldo >= 0 ? n.saldo : -1 * n.saldo,
        vatPercent: null,
        accountNumber: n.accountNumber,
        accountName: n.accountName,
        accountGrouping: n.accountGrouping,
        dimension: {}
      }
    ]), a;
  }
  onCalculationChange() {
    if (this.base && this.current && (!wt.equals(this.current, this.latestCurrent) || !wt.equals(this.base, this.latestBase))) {
      this.latestCurrent = wt.copy(this.current), this.latestBase = wt.copy(this.base);
      const t = wt.copy(this.base);
      t.result = Vy.diff(this.base.result, this.current.result), wt.copy(t, this._diffCalc), this.pendingAccountingDiffData = !0, this.loadAccountingDiffData();
    }
  }
};
_y.bindings = {}, _y.$inject = ["Calculations", "UiHelpers", "UiCrudHelpers", "$location", "$routeParams", "SessionService", "ReportsService", "InvoicesService", "Reports", "AjaxNg1"];
let _m = _y;
const m$ = class m$ {
  /**
   * Creates a new CalcCostAccountingController
   * @ignore
   */
  constructor(t) {
    this.sessionService = t, this._definitions = [], this._options = {}, this._values = {}, this._inheritedValues = {}, this._obsoleteValues = [], this._newDimensions = [];
  }
  /**
   * Implement IController
   */
  $onInit() {
  }
  /** Copy of inherited dimensions */
  get inherited() {
    return this._inherited;
  }
  /** Copy of inherited dimensions */
  set inherited(t) {
    this._inherited = wt.copy(t);
  }
  /** Returns applicable dimensions*/
  get definitions() {
    const t = (this.dimensions ?? this.sessionService.session?.settings?.costAccounting?.dimensions ?? []).filter(
      (e) => (
        // no hidden scope
        e.scope !== gs.Hidden && // show if scope definition for dimension not given
        (!e.scope || e.scope === gs.None || // or if scope definition for use given
        !this.scope || this.scope === gs.None || // or this scope
        this.scope === e.scope)
      )
    );
    return this.modifyOptions(t, this._definitions), this._definitions;
  }
  /**
   * Returns true, if the dimension exists.
   * @param id Id of the dimension.
   * @returns True, if the dimension with given id exists.
   */
  getDefinition(t) {
    return this.definitions.find((e) => e.id == t);
  }
  /**
   * Returns total percentage for the dimension
   * @param id Name of the dimension.
   */
  getSum(t) {
    return ie.sum((this.current ?? []).filter((e) => e.id == t), (e) => e.percent ?? 0);
  }
  /**
   * Returns available options.
   * @param id Id of the dimension.
   */
  getOptions(t) {
    this._options[t] || (this._options[t] = []);
    let e = [];
    const a = this.definitions.find((n) => n.id === t);
    return a && (e = a.options.filter(
      (n) => n.scope !== gs.Hidden && // show if scope definition for dimension not given
      (!n.scope || n.scope === gs.None || // or if scope definition for use given
      !this.scope || this.scope === gs.None || // or this scope
      this.scope === n.scope)
    ).map((n) => ({ value: n.value, text: n.text })), e.unshift({ value: "", text: L.get("SALAXY.UI_Terms.notChosen") })), this.modifyOptions(e, this._options[t]), this._options[t];
  }
  /**
   * Returns true if options exists for the dimension.
   * @param id Id of the dimension.
   * @param value Value of the dimension.
   * @returns True, if an option exists for the value.
   */
  hasOptions(t, e) {
    const a = this.getOptions(t);
    return e ? !!a.find((n) => n.value == e) : a.filter((n) => n.value).length > 0;
  }
  /**
   * Returns single value.
   * @param id Id of the dimension.
   */
  getSingleValue(t) {
    let e = this.current?.find((a) => a.id === t) ?? this._newDimensions.find((a) => a.id === t);
    return !e && !this.readOnly && (e = { id: t }, this._newDimensions.push(e)), e;
  }
  /**
   * Sets single value.
   * @param id Id of the dimension.
   * @param value Value of the dimension.
   */
  setSingleValue(t, e) {
    const a = this.current?.find((n) => n.id === t);
    a ? a.value = e : this.current.push({ id: t, value: e });
  }
  /**
   * Returns current values.
   * @param id Id of the dimension.
   */
  getValues(t) {
    this._values[t] || (this._values[t] = []);
    const e = (this.current ?? []).filter((a) => a.id === t);
    return this.modifyOptions(e, this._values[t]), this._values[t];
  }
  /**
   * Sets values.
   * @param values Values of the dimension.
   */
  setValues(t) {
    this.current.push(...wt.copy(t));
  }
  /**
   * Deletes value from the dimensions
   * @param value Value to delete
   */
  deleteValue(t) {
    const e = this.current.indexOf(t);
    e >= 0 && this.current.splice(e, 1);
  }
  /**
   * Returns true if the dimension values are inherited.
   * @param id Id of the dimension.
   */
  isInherited(t) {
    return this.current?.some((e) => e.id === t && !!e.value) ? !1 : !!this.cleanDimensions(this.inherited)?.some((e) => e.id === t);
  }
  /**
   * Returns inherited single value.
   * @param id Id of the dimension.
   */
  getInheritedSingleValue(t) {
    return (this.cleanDimensions(this.inherited) ?? []).find((a) => a.id === t);
  }
  /**
   * Returns inherited values.
   * @param id Id of the dimension.
   */
  getInheritedValues(t) {
    this._inheritedValues[t] || (this._inheritedValues[t] = []);
    const e = (this.cleanDimensions(this.inherited) ?? []).filter((a) => a.id === t);
    return this.modifyOptions(e, this._inheritedValues[t]), this._inheritedValues[t];
  }
  /**
   * Returns total percentage for the dimension for inherited values
   * @param id Name of the dimension.
   */
  getInheritedSum(t) {
    return ie.sum((this.cleanDimensions(this.inherited) ?? []).filter((e) => e.id == t), (e) => e.percent ?? 0);
  }
  /**
   * Returns current obsolete values.
   */
  get obsoleteValues() {
    if (this.current) {
      const t = this.current.filter((e) => !this._definitions.find((a) => a.id === e.id)).sort((e, a) => (e.id ?? "").localeCompare(a.id ?? ""));
      this.modifyOptions(t, this._obsoleteValues);
    }
    return this._obsoleteValues;
  }
  /**
   * Returns true if the values contains obsolete dimensions.
   * @returns True if the values contains obsolete dimensions.
   */
  get hasObsoleteValues() {
    return this.obsoleteValues.length > 0;
  }
  modifyOptions(t, e) {
    wt.equals(t, e) || (e.splice(0, e.length), e.push(...t));
  }
  cleanDimensions(t) {
    return t && t.filter((a) => a.value && a.id);
  }
};
m$.$inject = ["SessionService"];
let Cc = m$;
const g$ = class g$ extends Cc {
  /**
   * Creates a new CalcCostAccountingController
   * @ignore
   */
  constructor(t) {
    super(t);
  }
  /**
   * Implement IController
   */
  $onInit() {
    this.scope = gs.Calculation, super.$onInit();
  }
  /**
   * Returns true if the current calculation is read only.
   */
  get isReadOnly() {
    return this.readOnly === !0 || this.readOnly === !1 ? this.readOnly : this.calc.isReadOnly;
  }
  // TO BE REMOVED
  /** Returns the cost accounting model type */
  get isLegacy() {
    return this.calc.usecase?.uri === "/UsecaseDefinition/FI53POYS0025543933/costcenter-percentages";
  }
  /** Returns total cost center percentage */
  getLegacySum() {
    return this.isLegacy ? ie.sum(this.calc.usecase?.data?.dimensions?.costCenter ?? [], (t) => t.percent ?? 0) : 0;
  }
  /** Returns current costCenter. */
  get costCenter() {
    return this.isLegacy && (this.calc.usecase || (this.calc.usecase = {}), this.calc.usecase.data || (this.calc.usecase.data = {}), this.calc.usecase.data.dimensions || (this.calc.usecase.data.dimensions = {}), this.calc.usecase.data.dimensions.costCenter || (this.calc.usecase.data.dimensions.costCenter = [])), this.calc.usecase?.data?.dimensions?.costCenter;
  }
};
g$.$inject = ["SessionService"];
let Om = g$;
const y$ = class y$ extends Cc {
  /**
   * Creates a new CalcCostAccountingController
   * @ignore
   */
  constructor(t) {
    super(t);
  }
  /**
   * Implement IController
   */
  $onInit() {
    this.scope = gs.Row, super.$onInit();
  }
  /**
   * Returns true if the current calculation is read only.
   */
  get isReadOnly() {
    return this.readOnly === !0 || this.readOnly === !1 ? this.readOnly : this.calc.isReadOnly;
  }
  /** Returns the cost accounting model type */
  get isLegacy() {
    return this.calc.usecase?.uri === "/UsecaseDefinition/FI53POYS0025543933/costcenter-percentages";
  }
  /** Returns total cost center percentage */
  getLegacySum() {
    return this.isLegacy ? ie.sum(this.row?.data?.dimensions?.costCenter ?? [], (t) => t.percent ?? 0) : 0;
  }
  /** Returns current costCenter. */
  get costCenter() {
    return this.isLegacy && (this.row.data || (this.row.data = {}), this.row.data.dimensions || (this.row.data.dimensions = {}), this.row.data.dimensions.costCenter || (this.row.data.dimensions.costCenter = [])), this.row.data?.dimensions?.costCenter;
  }
};
y$.$inject = ["SessionService"];
let Mm = y$;
const f$ = class f$ extends bi {
  /**
   * Creates a new WizardController with dependency injection.
   * @ignore
   */
  constructor(t, e, a, n) {
    super(t, n), this.invoices = e, this.editDialogParameters = a;
  }
  /**
   * Initialization of the controller
   */
  $onInit() {
    if (super.$onInit(), this.wizardService.setSteps(this.getWizardSteps()), !this.editDialogParameters)
      throw new Error("No editDialogParameters coming in.");
    this.model = this.editDialogParameters.current, this.model?.workflow?.status === le.PaymentSucceeded && !this.editDialogParameters?.logic?.isInspectingPaidInvoices && (this.step = 4);
  }
  /** Worker wizard configuration */
  getWizardSteps() {
    return this.editDialogParameters?.logic?.isInspectingPaidInvoices ? [
      {
        title: "SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.steps.step1.heading",
        view: "salaxy-components/modals/calc/personal-payment/TotalWorkerPayment.html"
      },
      {
        title: "SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.steps.step2.heading",
        view: "salaxy-components/modals/calc/personal-payment/Tax.html"
      },
      {
        title: "SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.steps.step3.heading",
        view: "salaxy-components/modals/calc/personal-payment/SideCosts.html"
      }
    ] : [
      {
        title: "SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.steps.step1.heading",
        view: "salaxy-components/modals/calc/personal-payment/TotalWorkerPayment.html"
      },
      {
        title: "SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.steps.step2.heading",
        view: "salaxy-components/modals/calc/personal-payment/Tax.html"
      },
      {
        title: "SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.steps.step3.heading",
        view: "salaxy-components/modals/calc/personal-payment/SideCosts.html"
      },
      {
        title: "SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.steps.step4.heading",
        view: "salaxy-components/modals/calc/personal-payment/Approval.html"
      }
    ];
  }
  /** Returns true if user can go forward in  the wizard  */
  get canGoNext() {
    return !!(this.steps.length > this.step && this.steps[this.step] && !this.steps[this.step].disabled);
  }
  /**
   * Navigates to the next step if possible.
   * Override adds the taxcard if personalId is there and resets it if personalId has changed.
   */
  goNext() {
    super.goNext();
  }
  /**
   * Checks if user can navigate to previuous step
   */
  get canGoPrevious() {
    return this.model?.workflow?.status === le.PaymentSucceeded && !this.editDialogParameters?.logic?.isInspectingPaidInvoices ? !1 : this.step > 1 && !this.steps[this.step - 2].disabled;
  }
  /**
   * Return EPR payment warning to template
   */
  get eprPaymentWarning() {
    return this.invoices.getEprWarningForPayment(this.model?.workflow?.salaryDate);
  }
  /**
   * Return EPR cancel warning to template
   */
  get eprCancelWarning() {
    return this.invoices.getEprWarningForCancellation(this.model?.workflow?.salaryDate, this.model?.workflow?.status === le.PaymentSucceeded);
  }
};
f$.$inject = ["$scope", "InvoicesService", "EditDialogParameters", "WizardService"];
let Dx = f$;
const Oy = class Oy {
  constructor(t) {
    this.uiHelpers = t, this.salaryDateKinds = Oy.getSalaryDateKinds();
  }
  /**
   * Initializes the controller
   */
  $onInit() {
  }
  /** Gets the current salary date kind object. */
  get currentSalaryDateKind() {
    let t;
    return ne.isCalculation(this.model) ? t = this.model.workflow.salaryDateKind : ne.isPayroll(this.model) && (t = this.model.input.salaryDateKind), this.salaryDateKinds.find((e) => e.value == t) ?? this.salaryDateKinds[0];
  }
  /** Sets the salary date kind and starts recalculation. */
  setSalaryDateKind(t) {
    if (ne.isCalculation(this.model))
      this.showCalculationSalaryDateKindSelection(t, this.model);
    else if (ne.isPayroll(this.model))
      this.showPayrollSalaryDateKindSelection(t, this.model);
    else
      throw new Error("Unknwon business object type.");
  }
  /** Shows the salary date kind dialog */
  showCalculationSalaryDateKindSelection(t, e) {
    const a = e.workflow.salaryDateKind, n = ne.isCfa(e.info.paymentChannel), i = {
      value: t,
      text: `SALAXY.ENUM.SalaryDateKind.${t}.label`,
      title: `SALAXY.ENUM.SalaryDateKind.${t}.description${n ? "Cfa" : "NonCfa"}`
    };
    this.uiHelpers.openEditDialog("salaxy-components/modals/calc/SalaryDateKind.html", e.workflow.salaryDateKind, i).then((r) => {
      r.action == We.Ok && a != t && (e.workflow.salaryDateKind = t, this.onSalaryDateKindChange({ salaryDateKind: t, businessObject: e }));
    });
  }
  /** Shows the salary date kind dialog */
  showPayrollSalaryDateKindSelection(t, e) {
    const a = e.input.salaryDateKind, n = ne.isCfa(e.input.paymentChannel), i = {
      value: t,
      text: `SALAXY.ENUM.SalaryDateKind.${t}.label`,
      title: `SALAXY.ENUM.SalaryDateKind.${t}.description${n ? "Cfa" : "NonCfa"}`
    };
    this.uiHelpers.openEditDialog("salaxy-components/modals/calc/SalaryDateKind.html", e.input.salaryDateKind, i).then((r) => {
      r.action == We.Ok && a != t && (e.input.salaryDateKind = t, this.onSalaryDateKindChange({ salaryDateKind: t, businessObject: e }));
    });
  }
  static getSalaryDateKinds() {
    return [
      {
        value: $n.Default,
        text: "SALAXY.ENUM.SalaryDateKind.default.label",
        avatar: {
          color: oc.getBrandColor("primary", "rgba"),
          icon: "bi-clock"
        }
      },
      {
        value: $n.InPast,
        text: "SALAXY.ENUM.SalaryDateKind.inPast.label",
        avatar: {
          color: oc.getBrandColor("danger", "rgba"),
          icon: "bi-clock-history"
        }
      }
    ];
  }
};
Oy.$inject = ["UiHelpers"];
let Xm = Oy;
const b$ = class b$ {
  /**
   * Creates a new CalcReportsController
   * @ignore
   */
  constructor(t, e) {
    this.fullApi = t, this.uiHelpers = e, this.annualLeavestoBePaid = [], this.annualLeavesWaitingForPayment = [], this.absencesToUse = [], this.absencesToReject = [], this.employmentHolidayYears = [];
  }
  /**
   * Implement IController
   */
  $onInit() {
    this.absencesToUse.push(...this.worktime.absencesPeriods?.filter((t) => t.causeCode !== Ge.AnnualLeave) || []), this.absencesToUse.forEach((t) => t.id = t.id || "$" + this.newGuid()), this.absencesToReject.push(...wt.copy(this.absencesToUse)), this.getHolidayYearsForEmployment(this.calc.worker.employmentId).then(() => {
      this.annualLeavestoBePaid = this.worktime.absencesPeriods?.filter((t) => t.causeCode == Ge.AnnualLeave) || [], this.annualLeavesWaitingForPayment = this.currentEmploymentHolidayYear.leaves.planned.map((t) => ({
        causeCode: Ge.AnnualLeave,
        id: t.id,
        period: wt.copy(t.period),
        notes: t.notes
      }));
    });
  }
  /** Returns final absences periods */
  getAbsencesPeriods() {
    const t = wt.copy([].concat(...this.annualLeavestoBePaid).concat(...this.absencesToUse));
    return t.forEach((e) => {
      e.id?.startsWith("$") && delete e.id;
    }), t;
  }
  /** Loads holiday years for employment and sets current holiday year */
  getHolidayYearsForEmployment(t) {
    return this.fullApi.getForEmployment(t).then((e) => {
      this.employmentHolidayYears = e;
      const a = I.asDate(this.calc.info.workStartDate || I.getToday()), n = a > I.getDate(I.getYear(a), 3, 31) ? I.getYear(a) : I.getYear(a) - 1;
      return this.currentEmploymentHolidayYear = this.employmentHolidayYears.find((i) => i.year === n), e;
    });
  }
  /**
   * Moves an item between different payment lists.
   * @param item - The item to be moved.
   * @param target - The target payment list.
   */
  moveItem(t, e) {
    if (e === "annualLeavesWaitingForPayment") {
      const a = this.annualLeavestoBePaid.indexOf(t);
      a > -1 && this.annualLeavestoBePaid.splice(a, 1);
    }
    e === "annualLeavestoBePaid" && this.annualLeavestoBePaid.push(t);
  }
  /**
   * Moves an item between different payment lists.
   * @param item - The item to be moved.
   * @param target - The target payment list.
   */
  moveAbsenceItem(t, e) {
    if (e === "absencesToReject") {
      const a = this.absencesToUse.indexOf(t);
      a > -1 && this.absencesToUse.splice(a, 1);
    }
    e === "absencesToUse" && this.absencesToUse.push(t);
  }
  /**
   * Determines if a given leave should be disabled based on its type and whether it's in the list of leaves to be paid.
   * @param {AnnualLeave} leave - The leave object to check.
   */
  isSelectedToBePaid(t) {
    return this.annualLeavestoBePaid?.some((e) => e.id === t.id);
  }
  /**
   * Determines if a given absence should be disabled based on it's in the list of absences to use.
   * @param {AbsencePeriod} absence - The leave object to check.
   */
  isAbsenceSelectedToUse(t) {
    return this.absencesToUse?.some((e) => e.id === t.id);
  }
  /**
   * Determines the style for a given leave based on whether it should be disabled or not.
   * @param {AnnualLeave} leave - The leave object to check.
   */
  getDisabledStyle(t) {
    if (this.isSelectedToBePaid(t))
      return {
        "background-color": "lightgrey",
        opacity: "0.5"
      };
  }
  /**
   * Determines the style for a given absence based on whether it should be disabled or not.
   * @param {AnnualLeave} absence - The absences object to check.
   */
  getAbsenceDisabledStyle(t) {
    if (this.isAbsenceSelectedToUse(t))
      return {
        "background-color": "lightgrey",
        opacity: "0.5"
      };
  }
  /** Returns daysCount sum of annualLeavestoBePaid/bonusPeriodstoBePaid depending on type parameter*/
  getAccrualRemaningsToBePaid(t) {
    return t === "holidayPay" ? ie.sum(this.annualLeavestoBePaid, (e) => e.period.daysCount) || 0 : ie.sum(this.annualLeavestoBePaid, (e) => e.bonusDaysCount) || 0;
  }
  /**
   * Shows the edit dialog.
   * @param item AnnualLeave to edit.
   */
  showEditDialog(t) {
    if (!t)
      throw new Error("showEditDialog called without a parameter.");
    const e = {
      /** Updates the workdays count */
      updatePeriodDays: (a) => {
        a.period.start > a.period.end && (a.period.end = a.period.start), a.period.start && a.period.end && (a.period.days ? (a.period.days = I.getVacationDays(a.period.start, a.period.end), a.period.daysCount = a.period.days.length, this.worktime.holidaySpec.bonusMethod !== Yh.None && (a.bonusDaysCount = a.period.days.length)) : (a.period.daysCount = I.getVacationDays(a.period.start, a.period.end).length, this.worktime.holidaySpec.bonusMethod !== Yh.None && (a.bonusDaysCount = a.period.daysCount)));
      },
      /** Sets the days array in period to enable days selection UI. */
      setDaysSelection: (a) => {
        a.period.days = I.getVacationDays(a.period.start, a.period.end), a.period.daysCount = a.period.days.length, this.worktime.holidaySpec.bonusMethod !== Yh.None && (a.bonusDaysCount = a.period.days.length);
      }
    };
    this.uiHelpers.openEditDialog("salaxy-components/worker/holidays/HolidayYearHolidaysEditDialog.html", t, e).then((a) => {
      (a.action === "delete" || a.action === "delete-no-save") && this.annualLeavestoBePaid.splice(this.annualLeavestoBePaid.indexOf(t), 1);
    });
  }
  newGuid() {
    let t = (/* @__PURE__ */ new Date()).getTime();
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (a) => {
      const n = (t + Math.random() * 16) % 16 | 0;
      return t = Math.floor(t / 16), (a === "x" ? n : n & 3 | 8).toString(16);
    });
  }
};
b$.$inject = ["HolidayYears", "UiHelpers"];
let Gm = b$;
const v$ = class v$ extends $s {
  /**
   * Creates a new CalculationsProController
   */
  constructor(t, e, a, n, i, r, l, o, c, d) {
    super(t, e, a, n, i, r, l, o, c), this.repairApi = t, this.uiHelpersApi = e, this.reportsApi = d, this.accountingDiffDataReader = {
      /** Function to read data into given array */
      read: (p, h, g) => (this.accountingDiffData && g.push(this.accountingDiffData), Promise.resolve()),
      /** Optional label for data export */
      exportLabel: null,
      /** Indicates if the export is not possible */
      disabled: () => !this.accountingDiffData,
      /* Indicates if row is expandable */
      showExpand: !0,
      /* Indicates if rows exists*/
      hasRows: () => !this.accountingDiffData?.ledgerAccounts
    }, this.shared = {
      reportType: "salarySlip"
    }, this._loading = {
      accountingDiffData: !1
    }, this._pendingChanges = {
      accountingDiffData: !1,
      accountingDiffTargetId: "default"
    }, this._diffCalc = {};
  }
  /** Initialize */
  $onInit() {
    super.$onInit();
  }
  /**
   * Finalize the repair and replace the original version with the new one.
   */
  commitRepair() {
    return this.uiHelpers.showConfirm(
      "Korvaa alkuperäinen laskelma?",
      "Tämä korjattu versio laskelmasta korvaa alkuperäisen laskelman. Samalla päivitetään tiedot tulorekisteri-ilmoituksiin ja laskuihin. Korjausta ei voi perua, mutta voit aina korjata viimeisimmän version laskelmasta.",
      "Korvaa alkuperäinen",
      "Peruuta"
    ).then((t) => {
      if (t) {
        const e = this.uiHelpersApi.showLoading("SALAXY.UI_Terms.wait");
        return this.repairApi.commitRepair(this.current).then(() => {
          e.dismiss(), this.uiHelpers.showAlert("Laskelma korvattu onnistuneesti."), this.$location.path("/calc/repairs");
        });
      }
    });
  }
  /**
   * Update repair
   */
  saveRepair() {
    return this.repairApi.saveRepair(this.current).then((t) => (this.setCurrent(t), this.current));
  }
  /**
   * Recalculate repair
   */
  recalculateRepair() {
    return this.repairApi.recalculateRepair(this.current).then((t) => (this.setCurrent(t), this.current));
  }
  /**
   * Select taxcard for the repaired calc.
   */
  selectTaxcard() {
    return this.uiHelpers.openEditDialog(
      "salaxy-components/modals/calc/TaxcardSelect.html",
      [],
      {
        title: "SALAXY.UI_Terms.select",
        options: { $filter: "data/employmentId eq '" + this.current.worker.employmentId + "'" },
        okButtonText: "SALAXY.UI_Terms.ok",
        cancelButtonText: "SALAXY.UI_Terms.cancel"
      }
    ).then((t) => {
      if (t.action === "ok" && t.item.length > 0) {
        const e = this.uiHelpers.showLoading("SALAXY.UI_Terms.wait");
        return this.current.worker.tax.taxcardId = t.item[0].id, this.recalculate().then(() => {
          e.dismiss();
        });
      } else
        return;
    });
  }
  /** Original calculation */
  get base() {
    return this._base || this.current?.info?.originalId && (this._base = {}, this.repairApi.getSingle(this.current?.info?.originalId).then((t) => {
      wt.copy(t, this._base);
    })), this._base?.info ? this._base : null;
  }
  /** Document flow for the current calculation */
  get documentFlow() {
    return this._documentFlow || this.base?.id && (this._documentFlow = { item: null, children: null }, this.repairApi.getDocumentFlow(this.base.id).then((t) => {
      wt.copy(t, this._documentFlow);
    })), this._documentFlow;
  }
  /** Calculation total result diff between original and current calculation. */
  get diffCalc() {
    return this.checkCalculationChange(), this._diffCalc;
  }
  /** Accounting data diff between original and current calculation. */
  get accountingDiffData() {
    return this.checkCalculationChange(), this.loadAccountingDiffData(), this._accountingDiffData;
  }
  /** Change accounting data target */
  onTargetChange(t = "default") {
    this._pendingChanges.accountingDiffData = !0, this._pendingChanges.accountingDiffTargetId = t, this.loadAccountingDiffData();
  }
  /** Getter and setter for Calculation daterange in compatible format for new DateRange component. */
  get dateRange() {
    return this.current ? (this._dateRange || (this._dateRange = {
      start: this.current.info.workStartDate,
      end: this.current.info.workEndDate,
      daysCount: this.current.framework.numberOfDays
    }), this._dateRange) : null;
  }
  set dateRange(t) {
    this._dateRange = t;
  }
  /**
   * Called when the date range changes.
   */
  dateRangeChange() {
    !this.dateRange || !this.current || (this.current.info.workStartDate = this.dateRange.start, this.current.info.workEndDate = this.dateRange.end, this.current.framework.numberOfDays = this.dateRange.daysCount);
  }
  /**
   * Returns valid employment reg codes for the selected pensions company.
   * @returns Options for the employment reg codes.
   */
  getEmploymentRegCodeOptions() {
    return this.uiHelpers.cache(
      this,
      "employmentRegCodes",
      () => S0.filter((t) => t.pensionCompany === this.current.result.responsibilities.pensionCompany).map((t) => ({ value: t.code, text: L.getLanguage() === Me.Sv ? t.labelSv : t.labelFi })),
      () => this.current.result.responsibilities.pensionCompany
    );
  }
  /** Load accounting data and calculate diff. */
  loadAccountingDiffData() {
    if (this._pendingChanges.accountingDiffData && !this._loading.accountingDiffData) {
      this._loading.accountingDiffData = !0;
      const t = () => {
        this._pendingChanges.accountingDiffData = !1;
        const e = [this.base, this.current].map((a) => this.reportsApi.getAccountingDataForCalculations([a], this._pendingChanges.accountingDiffTargetId, null));
        return Promise.all(e).then((a) => (a && a.length == 2 && (this._accountingDiffData = this._accountingDiffData ?? {}, wt.copy(this.diffAccountingData(a[0], a[1]), this._accountingDiffData)), this._accountingDiffData));
      };
      t().then(() => {
        this._pendingChanges.accountingDiffData ? t() : this._loading.accountingDiffData = !1;
      });
    }
  }
  diffAccountingData(t, e) {
    t.ledgerAccounts.forEach((n) => n.entries = []), t.summary = {}, e.ledgerAccounts.forEach((n) => n.entries = []), e.summary = {};
    const a = e;
    return t.ledgerAccounts.forEach((n) => {
      const i = a.ledgerAccounts.find((r) => r.accountNumber === n.accountNumber && r.accountGrouping == n.accountGrouping);
      if (i)
        i.saldo = i.saldo - n.saldo;
      else {
        const r = wt.copy(n);
        r.saldo = 0 - n.saldo, a.ledgerAccounts.push(r);
      }
    }), a.ledgerAccounts.forEach((n) => n.entries = [
      {
        id: null,
        entryDate: null,
        description: "Ero",
        isDebit: n.saldo >= 0,
        amount: n.saldo >= 0 ? n.saldo : -1 * n.saldo,
        vatPercent: null,
        accountNumber: n.accountNumber,
        accountName: n.accountName,
        accountGrouping: n.accountGrouping,
        dimension: {}
      }
    ]), a;
  }
  checkCalculationChange() {
    if (this.base && this.current && (!wt.equals(this.current, this._latestCurrent) || !wt.equals(this.base, this._latestBase))) {
      this._latestCurrent = wt.copy(this.current), this._latestBase = wt.copy(this.base);
      const t = wt.copy(this.base);
      t.result = Vy.diff(this.base.result, this.current.result), wt.copy(t, this._diffCalc), this._pendingChanges.accountingDiffData = !0;
    }
  }
};
v$.$inject = [
  "Calculations",
  "UiHelpers",
  "UiCrudHelpers",
  "$location",
  "$routeParams",
  "SessionService",
  "ReportsService",
  "InvoicesService",
  "AjaxNg1",
  "Reports"
];
let Hm = v$;
const x$ = class x$ {
  constructor(t, e, a, n) {
    this.$timeout = t, this.employments = e, this.uiHelpers = a, this.sessionService = n, this.messages = [], this.loading = !1, this._openAiAvatar = {
      entityType: "company",
      firstName: "OpenAI",
      lastName: null,
      displayName: "OpenAI",
      sortableName: "OpenAI",
      pictureType: "uploaded",
      url: "https://cdn.salaxy.com/img/thumbnail/openai-3.png",
      id: "OpenAI"
    }, this.key = "";
  }
  /**
   * Initializes the controller
   */
  async $onInit() {
  }
  /** Company avatar */
  get myAvatar() {
    return this.sessionService.avatar;
  }
  /** Open AI avatar */
  get openAiAvatar() {
    return this._openAiAvatar;
  }
  /** Chat */
  async chatForPayroll() {
    this.messages.push({ role: "user", content: this.content ?? "", hidden: !1 }), this.content = "";
    const t = document.getElementById("openairesponse");
    t.scrollTop = t.scrollHeight, this.$timeout(() => {
    });
    try {
      this.loading = !0;
      const e = this.openai.beta.chat.completions.stream({
        model: "gpt-4o-mini",
        messages: this.messages,
        temperature: 0,
        response_format: {
          type: "json_schema",
          json_schema: {
            name: "Rows",
            strict: !1,
            schema: {
              type: "object",
              properties: {
                rows: {
                  description: `Set of rows that make up the salary calculation:\r
Expenses, Benefits, deductions etc. Note that side costs are not rows.`,
                  type: "array",
                  items: {
                    $ref: "#/definitions/UserDefinedRowExt"
                  }
                },
                definitions: {
                  UserDefinedRowExt: {
                    description: "This is a user defined calculation row ",
                    type: "object",
                    properties: {
                      employmentId: {
                        description: "ID of the employment relation of the worker.",
                        type: "string"
                      },
                      rowType: {
                        $ref: "#/definitions/CalculationRowType",
                        description: "Logical type of the row"
                      },
                      message: {
                        description: "Description text of the row that is shown in reports. If null, will be set according to type.",
                        type: "string"
                      },
                      count: {
                        format: "double",
                        description: "Count for the row - default is one",
                        type: "number"
                      },
                      price: {
                        format: "double",
                        description: "Price for the row",
                        type: "number"
                      },
                      accounting: {
                        $ref: "#/definitions/RowAccounting",
                        description: "Accounting related data for the row."
                      },
                      data: {
                        description: "Usecase specific data",
                        type: "object",
                        additionalProperties: {
                          type: "object"
                        }
                      }
                    }
                  },
                  CalculationRowType: {
                    description: "CalculationRowType enumeration",
                    enum: [
                      "unknown",
                      "salary",
                      "hourlySalary",
                      "monthlySalary",
                      "totalWorkerPayment",
                      "totalEmployerPayment",
                      "compensation",
                      "overtime",
                      "tesWorktimeShortening",
                      "eveningAddition",
                      "nightimeAddition",
                      "saturdayAddition",
                      "sundayWork",
                      "otherAdditions",
                      "paidSickLeaveSalary",
                      "paidSickLeaveHourlySalary",
                      "paidSickLeaveMonthlySalary",
                      "trainingSalary",
                      "trainingHourlySalary",
                      "trainingMonthlySalary",
                      "accomodationBenefit",
                      "mealBenefit",
                      "phoneBenefit",
                      "carBenefit",
                      "bicycleBenefit",
                      "otherBenefit",
                      "holidayCompensation",
                      "holidayBonus",
                      "holidaySalary",
                      "dailyAllowance",
                      "dailyAllowanceHalf",
                      "mealCompensation",
                      "milageOwnCar",
                      "toolCompensation",
                      "expenses",
                      "milageDaily",
                      "milageOther",
                      "unionPayment",
                      "foreclosure",
                      "advance",
                      "foreclosureByPalkkaus",
                      "prepaidExpenses",
                      "otherDeductions",
                      "deductibleOfExerciseAndCultureBenefit",
                      "childCareSubsidy",
                      "chainsawReduction",
                      "nonProfitOrg",
                      "subsidisedCommute",
                      "irIncomeType",
                      "board",
                      "remuneration",
                      "otherCompensation",
                      "workingTimeCompensation",
                      "employmentTermination",
                      "hourlySalaryWithWorkingTimeCompensation",
                      "paidSickLeave",
                      "training",
                      "taxAtSource",
                      "taxWithholding",
                      "absencePeriod",
                      "serviceCharge",
                      "service",
                      "totals"
                    ],
                    type: "string"
                  },
                  RowAccounting: {
                    description: "Provides row specific data for accounting (both cost and financial accounting).",
                    type: "object",
                    properties: {
                      vatPercent: {
                        format: "double",
                        description: "Percent for VAT calculation expressed as decimal: 24% is 0.24.",
                        type: "number"
                      },
                      vatEntries: {
                        description: `Total VAT amount splitted by VAT rates.\r
Please note, that if both {Palkkaus.Model.Calc.RowAccounting.VatPercent} and the {Palkkaus.Model.Calc.RowAccounting.VatEntries} with some entries given,\r
the {Palkkaus.Model.Calc.RowAccounting.VatEntries} are applied.\r
Please note that this is null by default.`,
                        type: "array",
                        items: {
                          $ref: "#/definitions/VatEntry"
                        }
                      },
                      dimensions: {
                        description: "Values for cost accounting dimensions",
                        type: "array",
                        items: {
                          $ref: "#/definitions/CostAccountingDimension"
                        }
                      }
                    }
                  },
                  VatEntry: {
                    description: "For VAT breakdown of a receipt (ALV-erittely) represents a single VAT rate and the revenue and tax with that rate.",
                    type: "object",
                    properties: {
                      tax: {
                        format: "double",
                        description: `Tax amount of specific VAT rate in euro.\r
This value is mandatory, if the collection of VatEntries contains more than one item.`,
                        type: "number"
                      },
                      vatRate: {
                        $ref: "#/definitions/VatRate",
                        description: "Applied VAT rate. This is always mandatory."
                      },
                      taxPercent: {
                        format: "double",
                        description: "Tax as percent of Net sales (0-1). Currently just informative, but may later be used for Custom non-standard VAT rates.",
                        type: "number"
                      },
                      gross: {
                        format: "double",
                        description: `Gross sales for specific VAT rate including the tax (VAT).\r
This value is mandatory, if the collection of VatEntries contains more than one item.`,
                        type: "number"
                      },
                      net: {
                        format: "double",
                        description: `Net sales for specific VAT rate excluding the tax (VAT).\r
This value is mandatory, if the collection of VatEntries contains more than one item.`,
                        type: "number"
                      }
                    }
                  },
                  VatRate: {
                    description: "VatRate enumeration",
                    enum: [
                      "undefined",
                      "none",
                      "vat0000",
                      "vat1000",
                      "vat1400",
                      "vat2400",
                      "vat2550",
                      "other"
                    ],
                    type: "string"
                  },
                  CostAccountingDimension: {
                    description: "Id of the cost accounting dimension with optional percentage for shared costs.",
                    type: "object",
                    properties: {
                      id: {
                        description: "Dimension Id.",
                        type: "string"
                      },
                      value: {
                        description: "Cost accounting dimension value id.",
                        type: "string"
                      },
                      percent: {
                        format: "percent",
                        description: "Sharing percent for the dimension.",
                        type: "number"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }), a = {
        role: "assistant",
        hidden: !0,
        content: ""
      };
      for await (const n of e) {
        const i = n.choices[0].delta, r = n.choices[0].finish_reason;
        this.messages.indexOf(a) === -1 && (this.messages.push(a), console.log("responseMessage", a)), i.content && (a.content += i.content, t.scrollTop = t.scrollHeight, this.$timeout(() => {
        }));
      }
      this.loading = !1, await this.modifyPayroll(a.content);
    } catch (e) {
      this.loading = !1, console.error("Error in stream start:", e);
    }
    t.scrollTop = t.scrollHeight, this.$timeout(() => {
    });
  }
  /** Chat */
  async chatForAdvise() {
    this.messages.push({ role: "user", content: this.content ?? "", hidden: !1 }), this.content = "";
    const t = document.getElementById("openairesponse");
    t.scrollTop = t.scrollHeight, this.$timeout(() => {
    });
    try {
      const e = await this.openai.chat.completions.create({
        model: "gpt-4o-mini",
        messages: this.messages,
        temperature: 0,
        stream: !0
      }), a = {
        role: "assistant",
        hidden: !1,
        content: ""
      };
      for await (const n of e) {
        const i = n.choices[0].delta, r = n.choices[0].finish_reason;
        this.messages.indexOf(a) === -1 && this.messages.push(a), i.content && (a.content += i.content, t.scrollTop = t.scrollHeight, this.$timeout(() => {
        }));
      }
    } catch (e) {
      console.error("Error in stream start:", e);
    }
    t.scrollTop = t.scrollHeight, this.$timeout(() => {
    });
  }
  /** Chat */
  async chatForReport() {
    this.messages.push({ role: "user", content: this.content, hidden: !1 });
    const t = `Tässä palkkalistan kaikki laskelmat listana (JSON-formaatti). Rivit ovat rakenteessa: rows.\r
` + JSON.stringify(this.page.calcs);
    this.messages.push({ role: "user", content: t + `\r
` + "Muodosta vain HTML:ää oleva vastaus. HTML:n pitäisi sisältää vain perus-tagejä. Ei tyylejä.", hidden: !0 }), this.content = "";
    const a = document.getElementById("openairesponse");
    a.scrollTop = a.scrollHeight, this.$timeout(() => {
    });
    try {
      this.loading = !0;
      const n = await this.openai.chat.completions.create({
        model: "gpt-4o-mini",
        messages: this.messages,
        temperature: 0,
        stream: !0
      }), i = {
        role: "assistant",
        hidden: !0,
        content: "",
        type: "html",
        file: "report.html"
      };
      for await (const l of n) {
        const o = l.choices[0].delta, c = l.choices[0].finish_reason;
        this.messages.indexOf(i) === -1 && this.messages.push(i), o.content && (i.content += o.content, a.scrollTop = a.scrollHeight, this.$timeout(() => {
        }));
      }
      console.log("html for report", i.content);
      const r = i.content.match(/```html([\s\S]*?)```/);
      r && r[1] && (i.content = r[1].trim()), i.hidden = !1, this.loading = !1;
    } catch (n) {
      this.loading = !1, console.error("Error in stream start:", n);
    }
    a.scrollTop = a.scrollHeight, this.$timeout(() => {
    });
  }
  /** Shows the selected report */
  showReport(t) {
    this.uiHelpers.showDialog("salaxy-components/modals/ui/Html.html", null, { html: t.content, title: "Raportti" }, null, "lg");
  }
  /**
   * Reads the xls file
   * @param file Selected file
   */
  async readFile(t) {
    if (!t)
      return Promise.resolve(null);
    this.$timeout(() => {
    });
  }
  /** Modify payroll rows */
  async modifyPayroll(t) {
    var a, n;
    const e = JSON.parse(t).rows;
    if (console.log(e), this.page)
      for (const i of this.page.calcs)
        i.rows.splice(0, i.rows.length);
    for (const i of e)
      if (this.page) {
        const r = this.page.calcs.find((l) => l.worker.employmentId === i.employmentId);
        if (r) {
          const l = i;
          l.accounting ?? (l.accounting = { dimensions: [], vatEntries: [] }), (a = l.accounting).dimensions ?? (a.dimensions = []), (n = l.accounting).vatEntries ?? (n.vatEntries = []), l.data ?? (l.data = {}), r.rows.push(i);
        }
      }
  }
  async generateInitialMessages() {
    const t = (await qo.getAllPages((i) => this.employments.getODataActive("all", i), {})).items, e = `Tässä ovat kaikki työntekijät listattuna (JSON):\r
` + JSON.stringify(t.map((i) => ({ employmentId: i.id, displayName: i.otherPartyInfo?.avatar?.displayName })));
    this.messages.push({ role: "system", hidden: !0, content: e });
    const a = `Tässä ovat kaikki rivityypit (CalculationRowType) listattuna (JSON):\r
` + JSON.stringify(He.getEnumMetadata("CalculationRowType", Me.Fi).values.map((i) => ({ rowType: i.name, label: i.label, description: i.descr })));
    this.messages.push({ role: "system", hidden: !0, content: a });
    const n = `Tässä ovat kaikki vuosittain muuttuvat numerot listattuna vuodelle 2025 (JSON):\r
` + JSON.stringify(gr.getYearlyChangingNumbers(/* @__PURE__ */ new Date()).sideCosts);
    this.messages.push({ role: "system", hidden: !0, content: n });
  }
};
x$.$inject = ["$timeout", "Employments", "UiHelpers", "SessionService"];
let Um = x$;
class LE {
  /**
   * Creates a new ContactInfoController
   * @ignore
   */
  constructor() {
    this.$onInit = () => {
    };
  }
}
const w$ = class w$ extends nn {
  constructor(t, e, a, n, i, r, l, o, c, d) {
    super(t, e, n, i), this.messageApi = t, this.uploadService = a, this.$anchorScroll = r, this.$timeout = l, this.sessionService = o, this.calculations = c, this.payrolls = d, this.newMessage = {
      type: ja.Text
    }, this.$onDestroy = () => {
      wt.isDefined(this.markAsReadTimeout) && this.$timeout.cancel(this.markAsReadTimeout);
    }, this.uploadProgress = 0;
  }
  /**
   * Initialization code.
   */
  $onInit() {
    this.role = this.role || Xn.Owner, super.$onInit();
  }
  /** Implements the getDefaults of ApiCrudObjectController */
  getDefaults() {
    return {
      listUrl: this.listUrl || "/messages",
      detailsUrl: this.detailsUrl || "/messages/details/",
      approvalUrl: this.approvalUrl || "/messages/approval/",
      oDataTemplateUrl: "salaxy-components/odata/lists/MessageThreads.html",
      oDataOptions: {}
    };
  }
  /**
   * If true, this is a new unsaved object.
   * Adds "new-for-calc" and "new-for-payroll" actions as new item.
   */
  isNew() {
    return this.parentController ? this.parentController.isNew() : this.action === "new-for-calc" || this.action === "new-for-payroll" || super.isNew();
  }
  /**
   * Overrides the isReadOnly with workflow cases
   */
  get isReadOnly() {
    return super.isReadOnly || this.role === "owner" && this.current?.workflowData?.events.some((t) => t.type === "PartnerMessageClosed");
  }
  /**
   * If set, the controller will mark a message thread as open once it has been loaded.
   * If the value is true, the message is marked as read immediately.
   * If the value is number, the controller waits the given amount of seconds before marking the item as read.
   */
  get markAsRead() {
    return this.parentController ? this.parentController.markAsRead : this._markAsRead;
  }
  set markAsRead(t) {
    this.parentController && (this.parentController.markAsRead = t), this._markAsRead = t;
  }
  /**
   * Salaxy ID (IBAN format) for the other party (besides the message thread owner).
   * Supports special values: "partner" for payment partner.
   */
  get otherParty() {
    return this._otherParty;
  }
  set otherParty(t) {
    t === "partner" ? this._otherParty = this.sessionService.session.settings.partner.accountId : this._otherParty = t;
  }
  /**
   * If set, shows a drop-down for these options using the enum component.
   * Keys may have special values: "partner": payment partner.
   */
  get otherPartyOptions() {
    return this._otherPartyOptions;
  }
  set otherPartyOptions(t) {
    if (!t || Object.keys(t).length === 0) {
      this._otherPartyOptions = null;
      return;
    }
    this._otherPartyOptions = Object.assign({}, ...Object.keys(t).map((e) => {
      if (e === "partner") {
        const a = this.sessionService.session.settings.partner;
        return { [a.accountId]: t[e] || a.serviceModel.site.webAppName || a.info.avatar.displayName };
      }
      return { [e]: t[e] };
    }));
  }
  /**
   * Returns true if the other-party is 'partner' or partner's ID.
   */
  get isOtherPartyPartner() {
    return this.otherParty === "partner" || this.otherParty === this.sessionService.session?.settings?.partner?.accountId;
  }
  /**
   * Adds a text message (from the textarea / this.newMessage) to the current thread.
   */
  sendMessage() {
    switch (this.newMessage.content = (this.newMessage.content || "").trim(), this.newMessage.fromParty = this.role, this.newMessage.type) {
      case ja.Text:
        if (!this.newMessage.content)
          return;
        break;
    }
    return this.setStatus(this.messageApi.addMessage(this.currentId, this.newMessage)).then((t) => (this.newMessage = {
      type: ja.Text
    }, this.setCurrent(t), t));
  }
  /** Sets the type of the message to be added / edited */
  setType(t) {
    switch (t = t || ja.Text, this.newMessage = {
      type: t
    }, t) {
      case "absence":
        this.newMessage.contentData = {
          periods: []
        }, this.newMessage.content = "Absence content";
        break;
      case "annualLeave":
        this.newMessage.contentData = {
          leaves: []
        }, this.newMessage.content = "Annual leave content";
        break;
    }
  }
  /**
   * Sends an email notification to the thread owner.
   */
  sendNotification() {
    const t = this.sessionService.session.settings.partner.serviceModel.site.webAppName || this.sessionService.session.settings.partner.info.avatar.displayName, e = `${L.get("SALAXY.NG1.MessageThreadComponent.sendNotificationSubject")} ${t}`, a = `${L.get("SALAXY.NG1.MessageThreadComponent.sendNotificationBody")}`;
    return this.setStatus(this.messageApi.sendNotification(this.currentId, e, a)).then((n) => (this.setCurrent(n), n));
  }
  /** Overrides the save to assure that the other party is defined (can be set in component properties).  */
  save() {
    if (!this.current.otherParty) {
      if (!this.otherParty) {
        this.uiHelpers.showAlert("SALAXY.NG1.MessageThreadComponent.saveNoToField");
        return;
      }
      this.current.otherParty = this.otherParty;
    }
    return super.save();
  }
  /** Selects a calculation as current calculation. */
  selectCalc() {
    this.uiHelpers.openSelectCalcs("draft", "Valitse palkkalaskelma").then((t) => {
      t.action == We.Ok && t.item.length > 0 && this.calculations.getSingle(t.item[0].id).then((e) => {
        this.calc = e, this.updateCalc();
      });
    });
  }
  /** Updates the calculation based on rows in the message. */
  updateCalc() {
    this.calc = this.calc || Da.getBlank();
    const t = ie.sum(this.current.messages, (a) => a.contentData?.totalTime || 0);
    this.calc.employer.isSelf = !0, this.calc.worker.accountId = this.calc.worker.accountId || this.current.otherParty, this.calc.rows = this.calc.rows.filter((a) => a.sourceId != this.current.id), this.calc.rows.splice(0, 0, {
      rowType: Wt.HourlySalary,
      count: se.round(t / 60),
      price: 10,
      sourceId: this.current.id
    }), this.recalculate();
  }
  /** Recalculates the calculation based on the rows in the message. */
  recalculate() {
    return this.calculations.recalculate(this.calc).then((t) => (this.calc = t, this.calc));
  }
  /** Saves the current calculation. */
  saveCalc() {
    return this.calculations.save(this.calc).then((t) => (this.calc = t, this.calc));
  }
  /**
   * Starts the reload process depending on the bindingMode.
   * Overrides a different load process for "new-for-calc" and "new-for-payroll".
   * Overrides the reload to send the browser to the bottom
   */
  reload() {
    return this.action === "new-for-calc" || this.action === "new-for-payroll" ? this.parentController ? this.parentController.reload().then((t) => (this._currentId = null, t)) : (() => {
      const e = this.api.getBlank();
      return e.status = eu.Active, this.currentId === "new" && (this._currentId = null), this.action === "new-for-calc" && this.currentId && this.currentId != "new" ? this.getCalculationListItem(this.currentId).then((a) => (e.title = "Palkka " + a?.otherPartyInfo?.avatar?.displayName, e.ownerWorkflow = {
        salaryDate: a?.salaryDate
      }, e.messages.push(
        {
          contentId: this.currentId,
          fromParty: this.role || Xn.Owner,
          type: ja.Calculation
        }
      ), e)) : this.action === "new-for-payroll" && this.currentId && this.currentId != "new" ? this.getPayrollListItem(this.currentId).then((a) => (e.status = eu.Active, e.title = "Palkkalista " + a?.shortText, e.ownerWorkflow = {
        salaryDate: a?.salaryDate
      }, e.messages.push(
        {
          contentId: this.currentId,
          fromParty: this.role || Xn.Owner,
          type: ja.Payroll
        }
      ), e)) : Promise.resolve(e);
    })().then((e) => (this._currentId = null, this.setStatus(Promise.resolve(e)).then((a) => (this.setCurrentRef(a), a)))) : super.reload().then((t) => (this.createCalc && this.updateCalc(), this.isNew() || (this.$timeout(() => {
      this.$anchorScroll("messageContainerBottom");
    }), this.status === "loaded" && this.markAsRead && !this.getReadTime() && this.current.messages.filter((a) => a.fromParty === (this.role === "otherParty" ? "owner" : "otherParty")).length > 0 && (this.markAsRead === !0 ? this.markAllAsRead() : this.markAsReadTimeout = this.$timeout(() => {
      this.isInEdit || this.markAllAsRead();
    }, this.markAsRead * 1e3))), t));
  }
  /**
   * Marks all messages as read by a given party.
   * The command is immediately sent to the server and the current message is updated incrementally (just the read/unread info).
   * @param readBy The party for which the messages are marked as read.
   * If not specified, uses the current role or the controller.
   * @returns The entire thread with the messages marked as read.
   */
  markAllAsRead(t) {
    return t = t || this.role || Xn.Owner, this.messageApi.markAsRead(this.currentId, t).then((e) => (this.current.messages.forEach((a) => {
      t === "otherParty" ? a.readByOtherParty = a.readByOtherParty || (/* @__PURE__ */ new Date()).toISOString() : a.readByOwner = a.readByOwner || (/* @__PURE__ */ new Date()).toISOString();
    }), e));
  }
  /**
   * Marks a message / attachment as read/unread also changing all messages before that message.
   * The role of the read/unread is determined by the message: It is the opposite of fromParty (owner (default)/otherParty).
   * The changes are made only to the current message, not Saved to the server.
   * @param message The message that is marked as read/unread (with the messages before that).
   * @param readByValue Possibility to force whether the flag is set to read or unread.
   * If null, the flag is set to the opposite of the current.
   */
  markItemAsRead(t, e = null) {
    const a = t.fromParty === "otherParty" ? "owner" : "otherParty";
    if (e == null && (e = a === "owner" ? !t.readByOwner : !t.readByOtherParty), e) {
      for (const n of this.current.messages)
        if (a === "owner" ? n.readByOwner = n.readByOwner || (/* @__PURE__ */ new Date()).toISOString() : n.readByOtherParty = n.readByOtherParty || (/* @__PURE__ */ new Date()).toISOString(), n === t)
          return;
    } else {
      const n = this.current.messages.indexOf(t);
      for (let i = n; i < this.current.messages.length; i++)
        a === "owner" ? this.current.messages[i].readByOwner = null : this.current.messages[i].readByOtherParty = null;
    }
  }
  /**
   * Gets the time when a message was read.
   * The time is dependent of the fromParty of the message: There are separate times for owner and other party.
   * If time is null, the message has not been read.
   * @param message Message for which the readTime is fetched.
   * If not set, uses the last message for the current party.
   * @returns If fromParty is "otherParty", then readByOwner is returned, otherwise readByOtherParty is returned.
   * The value should be ISO date (string) or null if the item has not been read yet.
   */
  getReadTime(t = null) {
    if (!t) {
      const e = this.current.messages.filter((a) => a.fromParty === (this.role === "otherParty" ? "owner" : "otherParty"));
      if (e.length === 0)
        return null;
      t = e[e.length - 1];
    }
    return t.fromParty === "otherParty" ? t.readByOwner || null : t.readByOtherParty || null;
  }
  /**
   * Uploads the files to the server
   * @param files The files collection from the upload component
   * @example
   * <button ngf-select="$ctrl.uploadFiles($files)" multiple accept="image/*">Select Files</button>
   */
  uploadFiles(t) {
    if (t && t.length) {
      const e = this.uiHelpers.showLoading("SALAXY.NG1.MessageThreadComponent.uploadFilesSaving");
      this.uploadService.upload(
        this.messageApi.getUploadUrl(this.currentId),
        {
          files: t,
          from: this.role || "owner"
        },
        (a, n) => {
          this.uploadProgress = a;
        }
      ).then((a) => (this.newMessage.content = "", this.setCurrent(a), e.dismiss(), a)).catch((a) => {
        throw e.dismiss(), this.uiHelpers.showAlert("SALAXY.UI_Terms.error", "SALAXY.NG1.MessageThreadComponent.uploadFilesError"), new Error(a);
      });
    }
  }
  /**
   * Gets the file display related information.
   * @param message Message that contains the file.
   */
  getFileInfo(t) {
    const e = {
      isImage: !1,
      previewUrl: null,
      downloadUrl: null,
      icon: null
    };
    return t.type !== "blobFile" || (e.isImage = !0, e.icon = this.uploadService.getFileIcon(t.content), t.contentId && (t.preview === t.contentId && (e.previewUrl = this.uploadService.getPreviewUrl(t.preview)), e.downloadUrl = this.uploadService.getFileUrl(t.contentId))), e;
  }
  /**
   * Opens the list of calculations into a dialog window for selection and then adds them to payroll
   * @param category Either "paid": Read-only, a copy is added ... or "draft": Editable, moved with status changed.
   */
  addExistingCalc(t = "draft") {
    const e = [];
    this.uiHelpers.openEditDialog(
      "salaxy-components/modals/calc/CalcList.html",
      e,
      {
        title: t === "paid" ? "SALAXY.NG1.MessageThreadComponent.addExistingCalcCopy" : "SALAXY.NG1.MessageThreadComponent.addExistingCalcMove",
        category: t
      }
    ).then((a) => {
      if (a.action === "ok" && e.length > 0) {
        const n = this.uiHelpers.showLoading("SALAXY.NG1.MessageThreadComponent.addExistingCalcLoading"), i = e.map((r) => ({
          contentId: r.id,
          fromParty: this.role || Xn.Owner,
          type: ja.Calculation
        }));
        this.current.messages.push(...i), this.save().then(() => {
          n.dismiss();
        });
      }
    });
  }
  /**
   * Opens the list of payrolls into a dialog window for selection and then adds them to payroll
   * @param category Either "paid": Read-only, a copy is added ... or "draft": Editable, moved with status changed.
   */
  addExistingPayroll(t = "draft") {
    const e = [];
    this.uiHelpers.openEditDialog(
      "salaxy-components/modals/payroll/PayrollList.html",
      e,
      {
        title: t === "paid" ? "Maksetut" : "Luonnokset",
        category: t
      }
    ).then((a) => {
      if (a.action === "ok" && e.length > 0) {
        const n = this.uiHelpers.showLoading("Lisätään palkkalistoja"), i = e.map((r) => ({
          contentId: r.id,
          fromParty: this.role || Xn.Owner,
          type: ja.Payroll
        }));
        this.current.messages.push(...i), this.save().then(() => {
          n.dismiss();
        });
      }
    });
  }
  /** Deletes a message from the message list (must be saved still) */
  deleteMessage(t) {
    this.current.messages.splice(this.current.messages.findIndex((e) => e === t), 1);
  }
  getCalculationListItem(t) {
    return this.calculations.getOData({ $filter: `id eq '${t}'` }).then((e) => e.items.length == 1 ? e.items[0] : null);
  }
  getPayrollListItem(t) {
    return this.payrolls.getOData({ $filter: `id eq '${t}'` }).then((e) => e.items.length == 1 ? e.items[0] : null);
  }
};
w$.$inject = ["MessageThreads", "UiHelpers", "UploadService", "$location", "$routeParams", "$anchorScroll", "$timeout", "SessionService", "Calculations", "Payrolls"];
let yu = w$;
const A$ = class A$ {
  /**
   * Creates a new ContactInfoController
   * @ignore
   */
  constructor(t, e, a) {
    this.ajax = t, this.sessionService = e, this.$sce = a, this._url = null, this._urlInProgress = !1, this.$onInit = () => {
    };
  }
  /** Gets the URL to the Omapalkka server with Google Firebase token. */
  get url() {
    return this.sessionService.isAuthenticated && (this._url || this._urlInProgress || (this._urlInProgress = !0, this.ajax.getJSON(`${Ne.current.getOmapalkkaApiServer()}/api/security/token`).then((t) => {
      const e = `${Ne.current.getOmapalkkaServer()}/embedded.html#fb-token=${t?.access_token}`;
      this._url = this.$sce.trustAsResourceUrl(e);
    }))), this._url;
  }
};
A$.$inject = ["AjaxNg1", "SessionService", "$sce"];
let Ix = A$;
const C$ = class C$ {
  /**
   * Creates a new VarmaBannerController
   * @ignore
   */
  constructor(t, e, a, n) {
    this.sessionService = t, this.settingsService = e, this.uiHelpers = a, this.$sce = n, this._varmaPensionBanners = {
      isReady: !1,
      showGetTyel: !1,
      showMoveTyel: !1,
      showGetYel: !1
    }, this._dismissed = {
      showGetTyel: !1,
      showMoveTyel: !1,
      showGetYel: [],
      inStorage: !1
    };
  }
  /**
   * Implement IController
   */
  $onInit() {
  }
  /**
   * Show the popup
   */
  showVarmaPopup() {
    let t = {};
    this.varmaPensionBanners.showGetTyel ? t = {
      dismiss: () => this.dismiss("tyel"),
      varmaShopLink: this.getVarmaShopLink(),
      title: L.get("SALAXY.NG1.VarmaBannerComponent.pensionPopup.tyel.title"),
      message: this.$sce.trustAsHtml(L.get("SALAXY.NG1.VarmaBannerComponent.pensionPopup.tyel.html")),
      btnText: L.get("SALAXY.NG1.VarmaBannerComponent.pensionPopup.tyel.btnText")
    } : this.varmaPensionBanners.showMoveTyel ? t = {
      dismiss: () => this.dismiss("moveTyel"),
      varmaShopLink: this.getVarmaShopLink(),
      title: L.get("SALAXY.NG1.VarmaBannerComponent.pensionPopup.moveTyel.title"),
      message: this.$sce.trustAsHtml(L.get("SALAXY.NG1.VarmaBannerComponent.pensionPopup.moveTyel.html", { pensionCompany: L.get("SALAXY.ENUM.PensionCompany." + this.settingsService.current?.calc.pensionContracts[0].company + ".label") })),
      btnText: L.get("SALAXY.NG1.VarmaBannerComponent.pensionPopup.moveTyel.btnText")
    } : this.varmaPensionBanners.showGetYel && (t = {
      dismiss: () => this.dismiss("yel"),
      varmaShopLink: this.getVarmaShopLink(),
      title: L.get("SALAXY.NG1.VarmaBannerComponent.pensionPopup.yel.title"),
      message: this.$sce.trustAsHtml(L.get("SALAXY.NG1.VarmaBannerComponent.pensionPopup.yel.html")),
      btnText: L.get("SALAXY.NG1.VarmaBannerComponent.pensionPopup.yel.btnText")
    }), t.dismiss && this.uiHelpers.openEditDialog(
      "salaxy-components/modals/communications/VarmaPopup.html",
      t,
      null,
      "lg"
    ).then((e) => {
      e.action == We.Cancel && t.dismiss();
    });
  }
  /** Gets the flags that indicate which popup to show. */
  get varmaPensionBanners() {
    return this._varmaPensionBanners.isReady = !!this.calc && !!this.settingsService.current, this._varmaPensionBanners.showGetTyel = this._varmaPensionBanners.isReady && this.isTyelCalculation && !this.dismissed.showGetTyel && (this.settingsService.current?.calc.pensionContracts.length == 0 || this.settingsService.current?.calc.pensionContracts.every((t) => !t.company)), this._varmaPensionBanners.showMoveTyel = this._varmaPensionBanners.isReady && this.isTyelCalculation && !this.dismissed.showMoveTyel && !this._varmaPensionBanners.showGetTyel && this.settingsService.current?.calc.pensionContracts.every((t) => t.company != Is.Varma) && this.settingsService.current?.calc.pensionContracts.every((t) => t.company != Is.None), this._varmaPensionBanners.showGetYel = this._varmaPensionBanners.isReady && this.isYelCalculation && this.calc.worker?.employmentId && this.dismissed.showGetYel.indexOf(this.calc.worker?.employmentId) < 0, this._varmaPensionBanners;
  }
  /** Get link to Varma pension contract shop with language parameter */
  getVarmaShopLink() {
    if (!this.settingsService.current)
      return "https://vaha.asiointi.varma.fi/vakuutushakemus/?PartnerID=Palkkaus&utm_source=partner&utm_medium=palkkaus";
    switch (this.sessionService.session.currentAccount?.language ?? Me.Fi) {
      case Me.Default:
      case Me.Fi:
        return "https://vaha.asiointi.varma.fi/vakuutushakemus/?PartnerID=Palkkaus&utm_source=partner&utm_medium=palkkaus";
      case Me.Sv:
        return "https://vaha.asiointi.varma.fi/vakuutushakemus/?PartnerID=Palkkaus&langcode=sv&utm_source=partner&utm_medium=palkkaus";
      case Me.En:
        return "https://vaha.asiointi.varma.fi/vakuutushakemus/?PartnerID=Palkkaus&langcode=en&utm_source=partner&utm_medium=palkkaus";
    }
  }
  /** Adds dismissed to local storage to prevent the display of the popups again */
  dismiss(t) {
    switch (t) {
      case "yel":
        this._dismissed.showGetYel.indexOf(this.calc.worker.employmentId) < 0 && this._dismissed.showGetYel.push(this.calc.worker.employmentId);
        break;
      case "tyel":
        this._dismissed.showGetTyel = !0;
        break;
      case "moveTyel":
        this._dismissed.showMoveTyel = !0;
        break;
    }
    this._dismissed.inStorage = !0, window.localStorage && window.localStorage.setItem("salaxy-varma-banner-dismissed", JSON.stringify(this._dismissed));
  }
  /** Checks if the banner as been dismissed earlier */
  get dismissed() {
    if (!this._dismissed.inStorage && window.localStorage) {
      const t = window.localStorage.getItem("salaxy-varma-banner-dismissed");
      t && (this._dismissed = JSON.parse(t), this._dismissed.inStorage = !0);
    }
    return this._dismissed;
  }
  /** Logic for determing the pension is for employee */
  get isTyelCalculation() {
    return this.calc ? this.calc.result?.responsibilities?.pensionCalculation == DL.Employee : !1;
  }
  /** Logic for determing the pension is for entrepreneur */
  get isYelCalculation() {
    return this.calc ? this.calc.result?.responsibilities?.pensionCalculation == DL.Entrepreneur : !1;
  }
};
C$.$inject = [
  "SessionService",
  "SettingsService",
  "UiHelpers",
  "$sce"
];
let Fm = C$;
const $$ = class $$ {
  /**
   * Creates a new WelcomeController
   * @ignore
   */
  constructor(t, e, a, n, i, r, l, o, c, d) {
    this.session = t, this.workers = e, this.settingsService = a, this.$location = n, this.uiCrudHelpers = i, this.$rootScope = r, this.taxcards = l, this.overview = o, this.uiHelpers = c, this.reportsService = d, this.workerUI = {}, this.workerList = [], this.paymentStartedWarningStartDate = I.getToday(), this.paymentStartedWarningEndDate = I.add(this.paymentStartedWarningStartDate, -6, "month"), this.workerListStatus = "initial", this.$onInit = () => {
      this.loadWelcomeData(), this.session.subscribe(this.$rootScope, () => {
        this.loadWelcomeData();
      });
    }, this.createNewCalculationFor = (p) => {
      this.$location.path("/calc/details/" + p + "/new-for-employment");
    }, this.filterWorkers = (p) => {
      let h = [];
      return p ? (p = (p || "").trim().toLowerCase(), h = this.workerList.filter((g) => (g.otherPartyInfo.avatar.displayName || "").toLowerCase().indexOf(p) >= 0 || (g.otherPartyInfo.avatar.sortableName || "").toLowerCase().indexOf(p) >= 0 || (g.otherPartyInfo.telephone || "").toLowerCase().indexOf(p) >= 0 || (g.otherPartyInfo.email || "").toLowerCase().indexOf(p) >= 0 || (g.id || "").toLowerCase().indexOf(p) === 0 || (g.otherPartyInfo.officialId || "").toLowerCase().indexOf(p) === 0).map(this.getAvatar)) : h = this.workerList.slice(0, 30).map(this.getAvatar), h.map((g) => ({
        value: g.id,
        title: g.description,
        text: g.displayName + " (" + g.displayId + ")",
        ui: g
      }));
    }, this.getWorkerName = (p) => {
      for (const h of this.workerList)
        if (p === h.otherId)
          return ti.escapeHtml(this.getAvatar(h).displayName);
      return p;
    }, this.getAvatar = (p) => {
      const h = Object.assign({}, p.otherPartyInfo.avatar);
      return h.displayId = ((p.id || "").startsWith("FI") ? Sw.formatIban(p.id) + " / " : "") + (p.otherPartyInfo.officialId ? p.otherPartyInfo.officialId : "-"), h.displayName = ti.escapeHtml(h.displayName), h.description = ti.escapeHtml(Ma.getDescription(p.otherPartyInfo, p?.data.type, p?.data.pensionCalculation)), h.id = p.id, h;
    };
  }
  /**
   * Gets a preview URL for the image.
   * Currently only for a taxcard, but may later support other items.
   */
  // eslint-disable-next-line
  getPreviewUrl(t) {
    return null;
  }
  /**
   * Returns the url where to download the tax card
   * @param taxCard Taxcard or if null, the current is used.
   */
  getTaxcardDownloadUrl(t) {
    return this.taxcards.getDownloadUrl(t);
  }
  /** Gets the current pension product or empty object */
  getPension() {
    return this.settingsService.current?.calc.pensionContracts.find((t) => I.isSameOrAfter("today", t.startDate ?? "1900-01-01") && I.isBefore("today", I.add(t.endDate ?? "2100-01-01", 1, "day"))) || {};
  }
  /** Gets the current insurance product or empty object */
  getInsurance() {
    return this.settingsService.current?.calc.insuranceContracts.find((t) => I.isSameOrAfter("today", t.startDate ?? "1900-01-01") && I.isBefore("today", I.add(t.endDate ?? "2100-01-01", 1, "day"))) || {};
  }
  /**
   * Loads the welcome data from the server.
   */
  loadWelcomeData() {
    if (this.session.isSessionChecked && this.session.isAuthenticated) {
      const t = this.session.session.currentAccount.owner;
      this.initialOwner != t && (this.initialOwner = t, this.workerDataNew = void 0, this.workerUI = {}, this.settingsByProxy = !1, this.workerList = [], this.workerListStatus = "initial", this.session.isInRole("person") ? this.loadWorkerData() : this.session.isInRole("company") && this.loadCompanyData());
    } else
      this.initialOwner = null, this.workerDataNew = void 0, this.workerUI = {}, this.settingsByProxy = !1, this.workerList = [], this.workerListStatus = "initial";
  }
  /** Loads the Worker role data and UI. */
  loadWorkerData() {
    this.overview.getWelcomeDataWorker().then((t) => {
      this.workerDataNew = t, this.workerUI = {
        isReady: !0,
        taxCardAdded: !!t.activeTaxcard
      };
    });
  }
  /** Loads worker list initially */
  loadWorkers() {
    return this.workerListStatus === "loaded" ? Promise.resolve(this.workerList) : (this.workerListStatus = "loading", this.workers.getOData({}).then((t) => (this.workerList = t.items, this.workerListStatus = "loaded", this.workerList)));
  }
  /** Loads the welcome data from the server for Company role */
  loadCompanyData() {
  }
  /**
   * Gets the URL for a calculation pdf.
   * If report has not been saved (ID is null), returns null.
   * @param calc - Calculation. This method requires that the calculation has been saved.
   * @param inline - if false, downloads the pdf file
   * @returns Url for specified report
   */
  getPdfUrl(t, e = !1) {
    return t ? this.reportsService.getPdfUrlForCalc("salarySlip", t.id, e) : null;
  }
  /**
   * Gets the chart data for taxcard, labels, colors and other settings.
   * Uses chartCache to avoid $digest loop.
   */
  get taxcardChartData() {
    return !this.workerDataNew || !this.workerDataNew.activeTaxcard ? null : this.workerDataNew.activeTaxcard.card.incomeLimit ? { config: this.uiHelpers.cache(
      this,
      "lineChartV2",
      () => La.getMainChartV2(this.workerDataNew.activeTaxcard),
      () => La.getIncomeLimitInfo(this.workerDataNew.activeTaxcard)
    ), limits: La.getIncomeLimitInfo(this.workerDataNew.activeTaxcard) } : { config: this.uiHelpers.cache(
      this,
      "pieChartV2",
      () => La.getPieChartDataV2(this.workerDataNew.activeTaxcard),
      () => La.getIncomeLimitInfo(this.workerDataNew.activeTaxcard)
    ), limits: La.getIncomeLimitInfo(this.workerDataNew.activeTaxcard) };
  }
  /**
   * Gets the chart data for taxcard, labels, colors and other settings.
   * Uses chartCache to avoid $digest loop.
   */
  get taxcardMobileChartData() {
    return !this.workerDataNew || !this.workerDataNew.activeTaxcard ? null : this.uiHelpers.cache(
      this,
      "lineChartMobileV2",
      () => {
        const t = La.getMainChartV2(this.workerDataNew.activeTaxcard);
        return t.options.plugins.legend.display = !1, t;
      },
      () => La.getIncomeLimitInfo(this.workerDataNew.activeTaxcard)
    );
  }
  /** Calls the Worker wizard and if a Worker is added, starts a calculation for that worker. */
  launchEmploymentWizard() {
    this.uiCrudHelpers.createNewEmployment().then((t) => {
      t.action === "ok" && this.createNewCalculationFor(t.item.id);
    });
  }
  /** Gets the flags that indicate which tutorials to show. */
  get tutorials() {
    const t = {
      showAnon: !1,
      showAddWorker: !1,
      showAddCalculation: !0,
      showSign: !1,
      showPension: !1,
      showInsurance: !1,
      showTryPayroll: !1,
      showNewFeatures: !1
    };
    if (!this.session.isSessionChecked)
      return t;
    if (!this.session.isAuthenticated)
      return t.showAnon = !0, t;
    switch (this.settingsByProxy || (this.session.checkAccountVerification() || (t.showSign = !0), t.showPension = this.settingsService.current?.calc.pensionContracts.length == 0 || this.settingsService.current?.calc.pensionContracts.every((e) => !e.company), t.showInsurance = this.settingsService.current?.calc.pensionContracts.length == 0 || this.settingsService.current?.calc.insuranceContracts.every((e) => !e.company)), this.workerListStatus) {
      case "loaded":
        if (this.workerList.length === 0)
          return t.showAddWorker = !0, t;
        if (this.workerList.length > 45)
          return t.showAddCalculation = !1, t;
        break;
      case "loading":
        return t;
      case "initial":
        return this.loadWorkers(), t;
    }
    return t.showAddCalculation = !0, t;
  }
  /**
   * Returns system alert html.
   */
  get systemAlertHtml() {
    if (!this.session)
      return null;
    const t = this.session.getSession();
    if (!t)
      return null;
    const e = t.systemAlertHtml;
    return e || null;
  }
  /**
   * Returns true if system alert exists.
   */
  get hasSystemAlert() {
    return !!this.systemAlertHtml;
  }
  /**
   * Searches all workers and checks if manual/auto taxcard is enabled
   */
  showAutoTaxcardInfobox() {
    if (this.workerList.length)
      return !this.workerList.some((t) => t.data.taxcard === Xa.Auto || t.data.taxcard === Xa.Manual);
  }
};
$$.$inject = [
  "SessionService",
  "Workers",
  "SettingsService",
  "$location",
  "UiCrudHelpers",
  "$rootScope",
  "Taxcards",
  "Overview",
  "UiHelpers",
  "ReportsService"
];
let zm = $$;
const My = class My {
  /**
   * Creates a new InputController
   * @ignore
   */
  constructor() {
    this.validationErrors = [], this._onInitValue = this.onInitValue;
  }
  /**
   * Set the values and defaults on init.
   * When overridding at derived classes, do your own stuff first and then call this method
   * because this method calls validate() at the end.
   */
  $onInit() {
    if (this.tooltipHtml && !this.tooltipPlacement && (this.tooltipPlacement = "top"), !this.name)
      throw new Error(`Property 'name' is required for Salaxy form controls (label: ${this.label}).`);
    this.name && this.label == null && (this.label = this.name), this.requirePendingUpdate && (this.require = !0, this.requirePendingUpdate = void 0), this.model.$render = () => {
      this.value = this.model.$viewValue, this._onInitValue && (this._onInitValue(), this._onInitValue = null);
    }, this.validate();
  }
  /** Gets or sets the presence of the required validator in the underlying model. */
  get require() {
    return !!this.model?.$validators.required;
  }
  set require(t) {
    if (!this.model) {
      this.requirePendingUpdate = t;
      return;
    }
    const e = !!this.model.$validators.required;
    t && !e ? this.model.$validators.required = (a, n) => !this.model.$isEmpty(n) : !t && e && delete this.model.$validators.required;
  }
  /** Gets the readonly value either from the controller or from the form */
  getReadOnly() {
    const t = (this.readOnly + "").trim().toLowerCase();
    return t === "true" || t === "1" ? !0 : t === "false" || t === "0" ? !1 : !!this?.form?.$$element[0]?.attributes?.readonly;
  }
  /** Gets the disabled value either from the controller or from the form */
  getDisabled() {
    return this.disabled ? !0 : this.form && this.form.$$element && this.form.$$element[0] ? !!this.form.$$element[0].attributes.disabled : !1;
  }
  /** Returns the placeholder text: We will probably add stuff about validation here if not explicitly set. */
  getPlaceholder() {
    return this.placeholder;
  }
  /** Gets the tooltip HTML with necessary escape. */
  getToolTipHtml() {
    return this.tooltipHtml;
  }
  /** On change of the value, do preventive operations and set value to model. */
  onChange() {
    this.model.$setViewValue(this.value), this.validate();
  }
  /** Do validations. Automatically called on onInit() and onChange() */
  validate() {
    const t = [];
    for (const e in this.model.$error)
      Qe.has(this.model.$error, e) && e !== "parse" && t.push("SALAXY.VALIDATION.ValidationErrors." + e);
    return this.modifyValidationErrors(t, this.validationErrors), !(this.validationErrors.length > 0);
  }
  /** Called after initial value assignment. Called only once.  */
  onInitValue() {
  }
  modifyValidationErrors(t, e) {
    wt.equals(t, e) || (e.splice(0, e.length), e.push(...t));
  }
};
My.crudBindings = {
  /** Name of the input - also used as id. */
  name: "@",
  /** Label for the control */
  label: "@",
  /**
   * @deprecated Use "require" instead:
   * This attribute overlaps with required/ng-required directive, which produces unexpected results.
   */
  required: "@",
  /** If true the field is required (form validation) */
  require: "<",
  /**
   * Expression for read-only display of the input control
   * This is visualized in a different way than readonly: The input is not shown and display is more compact.
   */
  readOnly: "<",
  /** Expression for ng-readonly of the input */
  readonly: "<",
  /** Expression for ng-disabled of the input */
  disabled: "<",
  /**
   * Positioning of the label of form-control.
   * Supported values are "horizontal" (default), "no-label", "plain" and "basic".
   * See FormGourpLabelType for details.
   */
  labelType: "@",
  /**
   * Label columns expressed as Bootstrap grid columns. Supports multiple classes (e.g. "col-xs-4 col-sm-2").
   * Default is 'col-sm-4' for label-type: 'horizontal' and 'col-sm-12' for label-type: 'no-label'.
   * Other label-types do not have column classes at the moment.
   */
  labelCols: "@",
  /** Placeholder text */
  placeholder: "@",
  /**
   * TooltipHtml adds an info button after the input which opens a uib-popover-html.
   */
  tooltipHtml: "@",
  /** Options for ui.bootstrap.popover */
  tooltipPlacement: "@",
  /**
   * Disables the default validation error message.
   * Use this if you want to create custom error messages in the UI.
   */
  disableValidationErrors: "<",
  /**
   * Style of the input.
   * Supports empty or 'openClose'
   */
  inputMode: "@",
  // TODO: tsekkaa nämä ja kommentoi
  onSelectFunction: "<",
  inputFormatter: "<",
  getOptions: "<"
}, My.$inject = [];
let Ia = My;
var DE = { exports: {} };
(function(s, t) {
  (function(e, a) {
    s.exports = a();
  })(Rs, function() {
    return function() {
      var e = { d: function(K, _) {
        for (var V in _)
          e.o(_, V) && !e.o(K, V) && Object.defineProperty(K, V, { enumerable: !0, get: _[V] });
      }, o: function(K, _) {
        return Object.prototype.hasOwnProperty.call(K, _);
      } }, a = {};
      e.d(a, { default: function() {
        return Rt;
      } });
      var n = { days: "days", months: "months", years: "years", day: "day", month: "month", year: "year", eventChangeViewDate: "changeViewDate", eventChangeCurrentView: "changeCurrentView", eventChangeFocusDate: "changeFocusDate", eventChangeSelectedDate: "changeSelectedDate", eventChangeTime: "changeTime", eventChangeLastSelectedDate: "changeLastSelectedDate", actionSelectDate: "selectDate", actionUnselectDate: "unselectDate", cssClassWeekend: "-weekend-" }, i = { classes: "", inline: !1, locale: { days: ["Воскресенье", "Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота"], daysShort: ["Вос", "Пон", "Вто", "Сре", "Чет", "Пят", "Суб"], daysMin: ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"], months: ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"], monthsShort: ["Янв", "Фев", "Мар", "Апр", "Май", "Июн", "Июл", "Авг", "Сен", "Окт", "Ноя", "Дек"], today: "Сегодня", clear: "Очистить", dateFormat: "dd.MM.yyyy", timeFormat: "HH:mm", firstDay: 1 }, startDate: /* @__PURE__ */ new Date(), firstDay: "", weekends: [6, 0], dateFormat: "", altField: "", altFieldDateFormat: "T", toggleSelected: !0, keyboardNav: !0, selectedDates: !1, container: "", isMobile: !1, visible: !1, position: "bottom left", offset: 12, view: n.days, minView: n.days, showOtherMonths: !0, selectOtherMonths: !0, moveToOtherMonthsOnSelect: !0, showOtherYears: !0, selectOtherYears: !0, moveToOtherYearsOnSelect: !0, minDate: "", maxDate: "", disableNavWhenOutOfRange: !0, multipleDates: !1, multipleDatesSeparator: ", ", range: !1, dynamicRange: !0, buttons: !1, monthsField: "monthsShort", showEvent: "focus", autoClose: !1, fixedHeight: !1, prevHtml: '<svg><path d="M 17,12 l -5,5 l 5,5"></path></svg>', nextHtml: '<svg><path d="M 14,12 l 5,5 l -5,5"></path></svg>', navTitles: { days: "MMMM, <i>yyyy</i>", months: "yyyy", years: "yyyy1 - yyyy2" }, timepicker: !1, onlyTimepicker: !1, dateTimeSeparator: " ", timeFormat: "", minHours: 0, maxHours: 24, minMinutes: 0, maxMinutes: 59, hoursStep: 1, minutesStep: 1, onSelect: !1, onChangeViewDate: !1, onChangeView: !1, onRenderCell: !1, onShow: !1, onHide: !1, onClickDayName: !1 };
      function r(K) {
        let _ = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : document;
        return typeof K == "string" ? _.querySelector(K) : K;
      }
      function l() {
        let { tagName: K = "div", className: _ = "", innerHtml: V = "", id: G = "", attrs: dt = {} } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, ht = document.createElement(K);
        return _ && ht.classList.add(..._.split(" ")), G && (ht.id = G), V && (ht.innerHTML = V), dt && o(ht, dt), ht;
      }
      function o(K, _) {
        for (let [V, G] of Object.entries(_))
          G !== void 0 && K.setAttribute(V, G);
        return K;
      }
      function c(K) {
        return new Date(K.getFullYear(), K.getMonth() + 1, 0).getDate();
      }
      function d(K) {
        let _ = K.getHours(), { hours: V, dayPeriod: G } = p(_);
        return { year: K.getFullYear(), month: K.getMonth(), fullMonth: K.getMonth() + 1 < 10 ? "0" + (K.getMonth() + 1) : K.getMonth() + 1, date: K.getDate(), fullDate: K.getDate() < 10 ? "0" + K.getDate() : K.getDate(), day: K.getDay(), hours: _, fullHours: h(_), hours12: V, dayPeriod: G, fullHours12: h(V), minutes: K.getMinutes(), fullMinutes: K.getMinutes() < 10 ? "0" + K.getMinutes() : K.getMinutes() };
      }
      function p(K) {
        return { dayPeriod: K > 11 ? "pm" : "am", hours: K % 12 == 0 ? 12 : K % 12 };
      }
      function h(K) {
        return K < 10 ? "0" + K : K;
      }
      function g(K) {
        let _ = 10 * Math.floor(K.getFullYear() / 10);
        return [_, _ + 9];
      }
      function x() {
        let K = [];
        for (var _ = arguments.length, V = new Array(_), G = 0; G < _; G++)
          V[G] = arguments[G];
        return V.forEach((dt) => {
          if (typeof dt == "object")
            for (let ht in dt)
              dt[ht] && K.push(ht);
          else
            dt && K.push(dt);
        }), K.join(" ");
      }
      function b(K, _) {
        let V = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : n.days;
        if (!K || !_)
          return !1;
        let G = d(K), dt = d(_);
        return { [n.days]: G.date === dt.date && G.month === dt.month && G.year === dt.year, [n.months]: G.month === dt.month && G.year === dt.year, [n.years]: G.year === dt.year }[V];
      }
      function A(K, _, V) {
        let G = R(K, !1).getTime(), dt = R(_, !1).getTime();
        return V ? G >= dt : G > dt;
      }
      function T(K, _) {
        return !A(K, _, !0);
      }
      function R(K) {
        let _ = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1], V = new Date(K.getTime());
        return typeof _ != "boolean" || _ || function(G) {
          G.setHours(0, 0, 0, 0);
        }(V), V;
      }
      function C(K, _, V) {
        K.length ? K.forEach((G) => {
          G.addEventListener(_, V);
        }) : K.addEventListener(_, V);
      }
      function v(K, _) {
        return !(!K || K === document || K instanceof DocumentFragment) && (K.matches(_) ? K : v(K.parentNode, _));
      }
      function P(K, _, V) {
        return K > V ? V : K < _ ? _ : K;
      }
      function O(K) {
        for (var _ = arguments.length, V = new Array(_ > 1 ? _ - 1 : 0), G = 1; G < _; G++)
          V[G - 1] = arguments[G];
        return V.filter((dt) => dt).forEach((dt) => {
          for (let [ht, ot] of Object.entries(dt))
            if (ot !== void 0 && ot.toString() === "[object Object]") {
              let $t = K[ht] !== void 0 ? K[ht].toString() : void 0, _t = ot.toString(), qt = Array.isArray(ot) ? [] : {};
              K[ht] = K[ht] ? $t !== _t ? qt : K[ht] : qt, O(K[ht], ot);
            } else
              K[ht] = ot;
        }), K;
      }
      function N(K) {
        let _ = K;
        return K instanceof Date || (typeof K == "string" && /^\d{4}-\d{2}-\d{2}$/.test(K) && (K += "T00:00:00"), _ = new Date(K)), isNaN(_.getTime()) && (console.log(`Unable to convert value "${K}" to Date object`), _ = !1), _;
      }
      function H(K) {
        let _ = "\\s|\\.|-|/|\\\\|,|\\$|\\!|\\?|:|;";
        return new RegExp("(^|>|" + _ + ")(" + K + ")($|<|" + _ + ")", "g");
      }
      function F(K, _, V) {
        return (_ = function(G) {
          var dt = function(ht, ot) {
            if (typeof ht != "object" || ht === null)
              return ht;
            var $t = ht[Symbol.toPrimitive];
            if ($t !== void 0) {
              var _t = $t.call(ht, "string");
              if (typeof _t != "object")
                return _t;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return String(ht);
          }(G);
          return typeof dt == "symbol" ? dt : String(dt);
        }(_)) in K ? Object.defineProperty(K, _, { value: V, enumerable: !0, configurable: !0, writable: !0 }) : K[_] = V, K;
      }
      class B {
        constructor() {
          let { type: _, date: V, dp: G, opts: dt, body: ht } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
          F(this, "focus", () => {
            this.$cell.classList.add("-focus-"), this.focused = !0;
          }), F(this, "removeFocus", () => {
            this.$cell.classList.remove("-focus-"), this.focused = !1;
          }), F(this, "select", () => {
            this.$cell.classList.add("-selected-"), this.selected = !0;
          }), F(this, "removeSelect", () => {
            this.$cell.classList.remove("-selected-", "-range-from-", "-range-to-"), this.selected = !1;
          }), F(this, "onChangeSelectedDate", () => {
            this.isDisabled || (this._handleSelectedStatus(), this.opts.range && this._handleRangeStatus());
          }), F(this, "onChangeFocusDate", (ot) => {
            if (!ot)
              return void (this.focused && this.removeFocus());
            let $t = b(ot, this.date, this.type);
            $t ? this.focus() : !$t && this.focused && this.removeFocus(), this.opts.range && this._handleRangeStatus();
          }), F(this, "render", () => (this.$cell.innerHTML = this._getHtml(), this._handleClasses(), this.$cell)), this.type = _, this.singleType = this.type.slice(0, -1), this.date = V, this.dp = G, this.opts = dt, this.body = ht, this.customData = !1, this.init();
        }
        init() {
          var _;
          let { onRenderCell: V } = this.opts;
          V && (this.customData = V({ date: this.date, cellType: this.singleType, datepicker: this.dp })), this._createElement(), this._bindDatepickerEvents(), (_ = this.customData) !== null && _ !== void 0 && _.disabled && this.dp.disableDate(this.date);
        }
        _bindDatepickerEvents() {
          this.dp.on(n.eventChangeSelectedDate, this.onChangeSelectedDate), this.dp.on(n.eventChangeFocusDate, this.onChangeFocusDate);
        }
        unbindDatepickerEvents() {
          this.dp.off(n.eventChangeSelectedDate, this.onChangeSelectedDate), this.dp.off(n.eventChangeFocusDate, this.onChangeFocusDate);
        }
        _createElement() {
          var _;
          let { year: V, month: G, date: dt } = d(this.date), ht = ((_ = this.customData) === null || _ === void 0 ? void 0 : _.attrs) || {};
          this.$cell = l({ attrs: { "data-year": V, "data-month": G, "data-date": dt, ...ht } }), this.$cell.adpCell = this;
        }
        _getClassName() {
          var _;
          let V = /* @__PURE__ */ new Date(), { selectOtherMonths: G, selectOtherYears: dt } = this.opts, { minDate: ht, maxDate: ot, isDateDisabled: $t } = this.dp, { day: _t } = d(this.date), qt = this._isOutOfMinMaxRange(), de = $t(this.date), me = x("air-datepicker-cell", `-${this.singleType}-`, { "-current-": b(V, this.date, this.type), "-min-date-": ht && b(ht, this.date, this.type), "-max-date-": ot && b(ot, this.date, this.type) }), Ht = "";
          switch (this.type) {
            case n.days:
              Ht = x({ "-weekend-": this.dp.isWeekend(_t), "-other-month-": this.isOtherMonth, "-disabled-": this.isOtherMonth && !G || qt || de });
              break;
            case n.months:
              Ht = x({ "-disabled-": qt });
              break;
            case n.years:
              Ht = x({ "-other-decade-": this.isOtherDecade, "-disabled-": qt || this.isOtherDecade && !dt });
          }
          return x(me, Ht, (_ = this.customData) === null || _ === void 0 ? void 0 : _.classes).split(" ");
        }
        _getHtml() {
          var _;
          let { year: V, month: G, date: dt } = d(this.date), { showOtherMonths: ht, showOtherYears: ot } = this.opts;
          if ((_ = this.customData) !== null && _ !== void 0 && _.html)
            return this.customData.html;
          switch (this.type) {
            case n.days:
              return !ht && this.isOtherMonth ? "" : dt;
            case n.months:
              return this.dp.locale[this.opts.monthsField][G];
            case n.years:
              return !ot && this.isOtherDecade ? "" : V;
          }
        }
        _isOutOfMinMaxRange() {
          let { minDate: _, maxDate: V } = this.dp, { type: G, date: dt } = this, { month: ht, year: ot, date: $t } = d(dt), _t = G === n.days, qt = G === n.years, de = !!_ && new Date(ot, qt ? _.getMonth() : ht, _t ? $t : _.getDate()), me = !!V && new Date(ot, qt ? V.getMonth() : ht, _t ? $t : V.getDate());
          return _ && V ? T(de, _) || A(me, V) : _ ? T(de, _) : V ? A(me, V) : void 0;
        }
        destroy() {
          this.unbindDatepickerEvents();
        }
        _handleRangeStatus() {
          const { selectedDates: _, focusDate: V, rangeDateTo: G, rangeDateFrom: dt } = this.dp, ht = _.length;
          if (!ht)
            return;
          let ot = dt, $t = G;
          if (ht === 1 && V) {
            const Ht = A(V, _[0]);
            ot = Ht ? _[0] : V, $t = Ht ? V : _[0];
          }
          let _t = x({ "-in-range-": ot && $t && (qt = this.date, de = ot, me = $t, A(qt, de) && T(qt, me)), "-range-from-": ot && b(this.date, ot, this.type), "-range-to-": $t && b(this.date, $t, this.type) });
          var qt, de, me;
          this.$cell.classList.remove("-range-from-", "-range-to-", "-in-range-"), _t && this.$cell.classList.add(..._t.split(" "));
        }
        _handleSelectedStatus() {
          let _ = this.dp._checkIfDateIsSelected(this.date, this.type);
          _ ? this.select() : !_ && this.selected && this.removeSelect();
        }
        _handleInitialFocusStatus() {
          b(this.dp.focusDate, this.date, this.type) && this.focus();
        }
        _handleClasses() {
          this.$cell.setAttribute("class", ""), this._handleInitialFocusStatus(), this.dp.hasSelectedDates && (this._handleSelectedStatus(), this.dp.opts.range && this._handleRangeStatus()), this.$cell.classList.add(...this._getClassName());
        }
        get isDisabled() {
          return this.$cell.matches(".-disabled-");
        }
        get isOtherMonth() {
          return this.dp.isOtherMonth(this.date);
        }
        get isOtherDecade() {
          return this.dp.isOtherDecade(this.date);
        }
      }
      function Q(K, _, V) {
        return (_ = function(G) {
          var dt = function(ht, ot) {
            if (typeof ht != "object" || ht === null)
              return ht;
            var $t = ht[Symbol.toPrimitive];
            if ($t !== void 0) {
              var _t = $t.call(ht, "string");
              if (typeof _t != "object")
                return _t;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return String(ht);
          }(G);
          return typeof dt == "symbol" ? dt : String(dt);
        }(_)) in K ? Object.defineProperty(K, _, { value: V, enumerable: !0, configurable: !0, writable: !0 }) : K[_] = V, K;
      }
      let it = { [n.days]: `<div class="air-datepicker-body--day-names"></div><div class="air-datepicker-body--cells -${n.days}-"></div>`, [n.months]: `<div class="air-datepicker-body--cells -${n.months}-"></div>`, [n.years]: `<div class="air-datepicker-body--cells -${n.years}-"></div>` };
      const et = ".air-datepicker-cell";
      class rt {
        constructor(_) {
          let { dp: V, type: G, opts: dt } = _;
          Q(this, "handleClick", (ht) => {
            let ot = ht.target.closest(et).adpCell;
            if (ot.isDisabled)
              return;
            if (!this.dp.isMinViewReached)
              return void this.dp.down();
            let $t = this.dp._checkIfDateIsSelected(ot.date, ot.type);
            $t ? this.dp._handleAlreadySelectedDates($t, ot.date) : this.dp.selectDate(ot.date);
          }), Q(this, "handleDayNameClick", (ht) => {
            let ot = ht.target.getAttribute("data-day-index");
            this.opts.onClickDayName({ dayIndex: Number(ot), datepicker: this.dp });
          }), Q(this, "onChangeCurrentView", (ht) => {
            ht !== this.type ? this.hide() : (this.show(), this.render());
          }), Q(this, "onMouseOverCell", (ht) => {
            let ot = v(ht.target, et);
            this.dp.setFocusDate(!!ot && ot.adpCell.date);
          }), Q(this, "onMouseOutCell", () => {
            this.dp.setFocusDate(!1);
          }), Q(this, "onClickBody", (ht) => {
            let { onClickDayName: ot } = this.opts, $t = ht.target;
            $t.closest(et) && this.handleClick(ht), ot && $t.closest(".air-datepicker-body--day-name") && this.handleDayNameClick(ht);
          }), Q(this, "onMouseDown", (ht) => {
            this.pressed = !0;
            let ot = v(ht.target, et), $t = ot && ot.adpCell;
            b($t.date, this.dp.rangeDateFrom) && (this.rangeFromFocused = !0), b($t.date, this.dp.rangeDateTo) && (this.rangeToFocused = !0);
          }), Q(this, "onMouseMove", (ht) => {
            if (!this.pressed || !this.dp.isMinViewReached)
              return;
            ht.preventDefault();
            let ot = v(ht.target, et), $t = ot && ot.adpCell, { selectedDates: _t, rangeDateTo: qt, rangeDateFrom: de } = this.dp;
            if (!$t || $t.isDisabled)
              return;
            let { date: me } = $t;
            if (_t.length === 2) {
              if (this.rangeFromFocused && !A(me, qt)) {
                let { hours: Ht, minutes: oe } = d(de);
                me.setHours(Ht), me.setMinutes(oe), this.dp.rangeDateFrom = me, this.dp.replaceDate(de, me);
              }
              if (this.rangeToFocused && !T(me, de)) {
                let { hours: Ht, minutes: oe } = d(qt);
                me.setHours(Ht), me.setMinutes(oe), this.dp.rangeDateTo = me, this.dp.replaceDate(qt, me);
              }
            }
          }), Q(this, "onMouseUp", () => {
            this.pressed = !1, this.rangeFromFocused = !1, this.rangeToFocused = !1;
          }), Q(this, "onChangeViewDate", (ht, ot) => {
            if (!this.isVisible)
              return;
            let $t = g(ht), _t = g(ot);
            switch (this.dp.currentView) {
              case n.days:
                if (b(ht, ot, n.months))
                  return;
                break;
              case n.months:
                if (b(ht, ot, n.years))
                  return;
                break;
              case n.years:
                if ($t[0] === _t[0] && $t[1] === _t[1])
                  return;
            }
            this.render();
          }), Q(this, "render", () => {
            this.destroyCells(), this._generateCells(), this.cells.forEach((ht) => {
              this.$cells.appendChild(ht.render());
            });
          }), this.dp = V, this.type = G, this.opts = dt, this.cells = [], this.$el = "", this.pressed = !1, this.isVisible = !0, this.init();
        }
        init() {
          this._buildBaseHtml(), this.type === n.days && this.renderDayNames(), this.render(), this._bindEvents(), this._bindDatepickerEvents();
        }
        _bindEvents() {
          let { range: _, dynamicRange: V } = this.opts;
          C(this.$el, "mouseover", this.onMouseOverCell), C(this.$el, "mouseout", this.onMouseOutCell), C(this.$el, "click", this.onClickBody), _ && V && (C(this.$el, "mousedown", this.onMouseDown), C(this.$el, "mousemove", this.onMouseMove), C(window.document, "mouseup", this.onMouseUp));
        }
        _bindDatepickerEvents() {
          this.dp.on(n.eventChangeViewDate, this.onChangeViewDate), this.dp.on(n.eventChangeCurrentView, this.onChangeCurrentView);
        }
        _buildBaseHtml() {
          this.$el = l({ className: `air-datepicker-body -${this.type}-`, innerHtml: it[this.type] }), this.$names = r(".air-datepicker-body--day-names", this.$el), this.$cells = r(".air-datepicker-body--cells", this.$el);
        }
        _getDayNamesHtml() {
          let _ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.dp.locale.firstDay, V = "", G = this.dp.isWeekend, { onClickDayName: dt } = this.opts, ht = _, ot = 0;
          for (; ot < 7; ) {
            let $t = ht % 7;
            V += `<div class="${x("air-datepicker-body--day-name", { [n.cssClassWeekend]: G($t), "-clickable-": !!dt })}" data-day-index='${$t}'>${this.dp.locale.daysMin[$t]}</div>`, ot++, ht++;
          }
          return V;
        }
        renderDayNames() {
          this.$names.innerHTML = this._getDayNamesHtml();
        }
        _generateCell(_) {
          let { type: V, dp: G, opts: dt } = this;
          return new B({ type: V, dp: G, opts: dt, date: _, body: this });
        }
        _generateCells() {
          rt.getDatesFunction(this.type)(this.dp, (_) => {
            this.cells.push(this._generateCell(_));
          });
        }
        show() {
          this.isVisible = !0, this.$el.classList.remove("-hidden-");
        }
        hide() {
          this.isVisible = !1, this.$el.classList.add("-hidden-");
        }
        destroyCells() {
          this.cells.forEach((_) => _.destroy()), this.cells = [], this.$cells.innerHTML = "";
        }
        destroy() {
          this.destroyCells(), this.dp.off(n.eventChangeViewDate, this.onChangeViewDate), this.dp.off(n.eventChangeCurrentView, this.onChangeCurrentView);
        }
        static getDaysDates(_, V) {
          let { viewDate: G, opts: { fixedHeight: dt }, locale: { firstDay: ht } } = _, ot = c(G), { year: $t, month: _t } = d(G), qt = new Date($t, _t, 1), de = new Date($t, _t, ot), me = qt.getDay() - ht, Ht = 6 - de.getDay() + ht;
          me = me < 0 ? me + 7 : me, Ht = Ht > 6 ? Ht - 7 : Ht;
          let oe = function(la, qa) {
            let { year: je, month: Aa, date: ge } = d(la);
            return new Date(je, Aa, ge - qa);
          }(qt, me), Ye = ot + me + Ht, ze = oe.getDate(), { year: Lt, month: ye } = d(oe), ue = 0;
          dt && (Ye = 42);
          const _e = [];
          for (; ue < Ye; ) {
            let la = new Date(Lt, ye, ze + ue);
            V && V(la), _e.push(la), ue++;
          }
          return _e;
        }
        static getMonthsDates(_, V) {
          let { year: G } = _.parsedViewDate, dt = 0, ht = [];
          for (; dt < 12; ) {
            const ot = new Date(G, dt);
            ht.push(ot), V && V(ot), dt++;
          }
          return ht;
        }
        static getYearsDates(_, V) {
          let G = g(_.viewDate), dt = G[0] - 1, ht = G[1] + 1, ot = dt, $t = [];
          for (; ot <= ht; ) {
            const _t = new Date(ot, 0);
            $t.push(_t), V && V(_t), ot++;
          }
          return $t;
        }
        static getDatesFunction() {
          let _ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : n.days;
          return { [n.days]: rt.getDaysDates, [n.months]: rt.getMonthsDates, [n.years]: rt.getYearsDates }[_];
        }
      }
      function U(K, _, V) {
        return (_ = function(G) {
          var dt = function(ht, ot) {
            if (typeof ht != "object" || ht === null)
              return ht;
            var $t = ht[Symbol.toPrimitive];
            if ($t !== void 0) {
              var _t = $t.call(ht, "string");
              if (typeof _t != "object")
                return _t;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return String(ht);
          }(G);
          return typeof dt == "symbol" ? dt : String(dt);
        }(_)) in K ? Object.defineProperty(K, _, { value: V, enumerable: !0, configurable: !0, writable: !0 }) : K[_] = V, K;
      }
      class M {
        constructor(_) {
          let { dp: V, opts: G } = _;
          U(this, "onClickNav", (dt) => {
            let ht = v(dt.target, ".air-datepicker-nav--action");
            if (!ht)
              return;
            let ot = ht.dataset.action;
            this.dp[ot]();
          }), U(this, "onChangeViewDate", () => {
            this.render(), this._resetNavStatus(), this.handleNavStatus();
          }), U(this, "onChangeCurrentView", () => {
            this.render(), this._resetNavStatus(), this.handleNavStatus();
          }), U(this, "onClickNavTitle", () => {
            this.dp.isFinalView || this.dp.up();
          }), U(this, "update", () => {
            let { prevHtml: dt, nextHtml: ht } = this.opts;
            this.$prev.innerHTML = dt, this.$next.innerHTML = ht, this._resetNavStatus(), this.render(), this.handleNavStatus();
          }), U(this, "renderDelay", () => {
            setTimeout(this.render);
          }), U(this, "render", () => {
            this.$title.innerHTML = this._getTitle(), function(dt, ht) {
              for (let ot in ht)
                ht[ot] ? dt.classList.add(ot) : dt.classList.remove(ot);
            }(this.$title, { "-disabled-": this.dp.isFinalView });
          }), this.dp = V, this.opts = G, this.init();
        }
        init() {
          this._createElement(), this._buildBaseHtml(), this._defineDOM(), this.render(), this.handleNavStatus(), this._bindEvents(), this._bindDatepickerEvents();
        }
        _defineDOM() {
          this.$title = r(".air-datepicker-nav--title", this.$el), this.$prev = r('[data-action="prev"]', this.$el), this.$next = r('[data-action="next"]', this.$el);
        }
        _bindEvents() {
          this.$el.addEventListener("click", this.onClickNav), this.$title.addEventListener("click", this.onClickNavTitle);
        }
        _bindDatepickerEvents() {
          this.dp.on(n.eventChangeViewDate, this.onChangeViewDate), this.dp.on(n.eventChangeCurrentView, this.onChangeCurrentView), this.isNavIsFunction && (this.dp.on(n.eventChangeSelectedDate, this.renderDelay), this.dp.opts.timepicker && this.dp.on(n.eventChangeTime, this.render));
        }
        destroy() {
          this.dp.off(n.eventChangeViewDate, this.onChangeViewDate), this.dp.off(n.eventChangeCurrentView, this.onChangeCurrentView), this.isNavIsFunction && (this.dp.off(n.eventChangeSelectedDate, this.renderDelay), this.dp.opts.timepicker && this.dp.off(n.eventChangeTime, this.render));
        }
        _createElement() {
          this.$el = l({ tagName: "nav", className: "air-datepicker-nav" });
        }
        _getTitle() {
          let { dp: _, opts: V } = this, G = V.navTitles[_.currentView];
          return typeof G == "function" ? G(_) : _.formatDate(_.viewDate, G);
        }
        handleNavStatus() {
          let { disableNavWhenOutOfRange: _ } = this.opts, { minDate: V, maxDate: G } = this.dp;
          if (!V && !G || !_)
            return;
          let { year: dt, month: ht } = this.dp.parsedViewDate, ot = !!V && d(V), $t = !!G && d(G);
          switch (this.dp.currentView) {
            case n.days:
              V && ot.month >= ht && ot.year >= dt && this._disableNav("prev"), G && $t.month <= ht && $t.year <= dt && this._disableNav("next");
              break;
            case n.months:
              V && ot.year >= dt && this._disableNav("prev"), G && $t.year <= dt && this._disableNav("next");
              break;
            case n.years: {
              let _t = g(this.dp.viewDate);
              V && ot.year >= _t[0] && this._disableNav("prev"), G && $t.year <= _t[1] && this._disableNav("next");
              break;
            }
          }
        }
        _disableNav(_) {
          r('[data-action="' + _ + '"]', this.$el).classList.add("-disabled-");
        }
        _resetNavStatus() {
          (function(_) {
            for (var V = arguments.length, G = new Array(V > 1 ? V - 1 : 0), dt = 1; dt < V; dt++)
              G[dt - 1] = arguments[dt];
            _.length ? _.forEach((ht) => {
              ht.classList.remove(...G);
            }) : _.classList.remove(...G);
          })(this.$el.querySelectorAll(".air-datepicker-nav--action"), "-disabled-");
        }
        _buildBaseHtml() {
          let { prevHtml: _, nextHtml: V } = this.opts;
          this.$el.innerHTML = `<div class="air-datepicker-nav--action" data-action="prev">${_}</div><div class="air-datepicker-nav--title"></div><div class="air-datepicker-nav--action" data-action="next">${V}</div>`;
        }
        get isNavIsFunction() {
          let { navTitles: _ } = this.opts;
          return Object.keys(_).find((V) => typeof _[V] == "function");
        }
      }
      var W = { today: { content: (K) => K.locale.today, onClick: (K) => K.setViewDate(/* @__PURE__ */ new Date()) }, clear: { content: (K) => K.locale.clear, onClick: (K) => K.clear() } };
      class J {
        constructor(_) {
          let { dp: V, opts: G } = _;
          this.dp = V, this.opts = G, this.init();
        }
        init() {
          this.createElement(), this.render();
        }
        createElement() {
          this.$el = l({ className: "air-datepicker-buttons" });
        }
        destroy() {
          this.$el.parentNode.removeChild(this.$el);
        }
        clearHtml() {
          return this.$el.innerHTML = "", this;
        }
        generateButtons() {
          let { buttons: _ } = this.opts;
          Array.isArray(_) || (_ = [_]), _.forEach((V) => {
            let G = V;
            typeof V == "string" && W[V] && (G = W[V]);
            let dt = this.createButton(G);
            G.onClick && this.attachEventToButton(dt, G.onClick), this.$el.appendChild(dt);
          });
        }
        attachEventToButton(_, V) {
          _.addEventListener("click", () => {
            V(this.dp);
          });
        }
        createButton(_) {
          let { content: V, className: G, tagName: dt = "button", attrs: ht = {} } = _;
          return l({ tagName: dt, innerHtml: `<span tabindex='-1'>${typeof V == "function" ? V(this.dp) : V}</span>`, className: x("air-datepicker-button", G), attrs: ht });
        }
        render() {
          this.generateButtons();
        }
      }
      function vt(K, _, V) {
        return (_ = function(G) {
          var dt = function(ht, ot) {
            if (typeof ht != "object" || ht === null)
              return ht;
            var $t = ht[Symbol.toPrimitive];
            if ($t !== void 0) {
              var _t = $t.call(ht, "string");
              if (typeof _t != "object")
                return _t;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return String(ht);
          }(G);
          return typeof dt == "symbol" ? dt : String(dt);
        }(_)) in K ? Object.defineProperty(K, _, { value: V, enumerable: !0, configurable: !0, writable: !0 }) : K[_] = V, K;
      }
      class St {
        constructor() {
          let { opts: _, dp: V } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
          vt(this, "toggleTimepickerIsActive", (dt) => {
            this.dp.timepickerIsActive = dt;
          }), vt(this, "onChangeSelectedDate", (dt) => {
            let { date: ht, updateTime: ot = !1 } = dt;
            ht && (this.setMinMaxTime(ht), this.setCurrentTime(!!ot && ht), this.addTimeToDate(ht));
          }), vt(this, "onChangeLastSelectedDate", (dt) => {
            dt && (this.setTime(dt), this.render());
          }), vt(this, "onChangeInputRange", (dt) => {
            let ht = dt.target;
            this[ht.getAttribute("name")] = ht.value, this.updateText(), this.dp.trigger(n.eventChangeTime, { hours: this.hours, minutes: this.minutes });
          }), vt(this, "onMouseEnterLeave", (dt) => {
            let ht = dt.target.getAttribute("name"), ot = this.$minutesText;
            ht === "hours" && (ot = this.$hoursText), ot.classList.toggle("-focus-");
          }), vt(this, "onFocus", () => {
            this.toggleTimepickerIsActive(!0);
          }), vt(this, "onBlur", () => {
            this.toggleTimepickerIsActive(!1);
          }), this.opts = _, this.dp = V;
          let { timeFormat: G } = this.dp.locale;
          G && (G.match(H("h")) || G.match(H("hh"))) && (this.ampm = !0), this.init();
        }
        init() {
          this.setTime(this.dp.lastSelectedDate || this.dp.viewDate), this.createElement(), this.buildHtml(), this.defineDOM(), this.render(), this.bindDatepickerEvents(), this.bindDOMEvents();
        }
        bindDatepickerEvents() {
          this.dp.on(n.eventChangeSelectedDate, this.onChangeSelectedDate), this.dp.on(n.eventChangeLastSelectedDate, this.onChangeLastSelectedDate);
        }
        bindDOMEvents() {
          let _ = "input";
          navigator.userAgent.match(/trident/gi) && (_ = "change"), C(this.$ranges, _, this.onChangeInputRange), C(this.$ranges, "mouseenter", this.onMouseEnterLeave), C(this.$ranges, "mouseleave", this.onMouseEnterLeave), C(this.$ranges, "focus", this.onFocus), C(this.$ranges, "mousedown", this.onFocus), C(this.$ranges, "blur", this.onBlur);
        }
        createElement() {
          this.$el = l({ className: x("air-datepicker-time", { "-am-pm-": this.dp.ampm }) });
        }
        destroy() {
          this.dp.off(n.eventChangeSelectedDate, this.onChangeSelectedDate), this.dp.off(n.eventChangeLastSelectedDate, this.onChangeLastSelectedDate), this.$el.parentNode.removeChild(this.$el);
        }
        buildHtml() {
          let { ampm: _, hours: V, displayHours: G, minutes: dt, minHours: ht, minMinutes: ot, maxHours: $t, maxMinutes: _t, dayPeriod: qt, opts: { hoursStep: de, minutesStep: me } } = this;
          this.$el.innerHTML = `<div class="air-datepicker-time--current">   <span class="air-datepicker-time--current-hours">${h(G)}</span>   <span class="air-datepicker-time--current-colon">:</span>   <span class="air-datepicker-time--current-minutes">${h(dt)}</span>   ` + (_ ? `<span class='air-datepicker-time--current-ampm'>${qt}</span>` : "") + `</div><div class="air-datepicker-time--sliders">   <div class="air-datepicker-time--row">      <input type="range" name="hours" value="${V}" min="${ht}" max="${$t}" step="${de}"/>   </div>   <div class="air-datepicker-time--row">      <input type="range" name="minutes" value="${dt}" min="${ot}" max="${_t}" step="${me}"/>   </div></div>`;
        }
        defineDOM() {
          let _ = (V) => r(V, this.$el);
          this.$ranges = this.$el.querySelectorAll('[type="range"]'), this.$hours = _('[name="hours"]'), this.$minutes = _('[name="minutes"]'), this.$hoursText = _(".air-datepicker-time--current-hours"), this.$minutesText = _(".air-datepicker-time--current-minutes"), this.$ampm = _(".air-datepicker-time--current-ampm");
        }
        setTime(_) {
          this.setMinMaxTime(_), this.setCurrentTime(_);
        }
        addTimeToDate(_) {
          _ && (_.setHours(this.hours), _.setMinutes(this.minutes));
        }
        setMinMaxTime(_) {
          if (this.setMinMaxTimeFromOptions(), _) {
            let { minDate: V, maxDate: G } = this.dp;
            V && b(_, V) && this.setMinTimeFromMinDate(V), G && b(_, G) && this.setMaxTimeFromMaxDate(G);
          }
        }
        setCurrentTime(_) {
          let { hours: V, minutes: G } = _ ? d(_) : this;
          this.hours = P(V, this.minHours, this.maxHours), this.minutes = P(G, this.minMinutes, this.maxMinutes);
        }
        setMinMaxTimeFromOptions() {
          let { minHours: _, minMinutes: V, maxHours: G, maxMinutes: dt } = this.opts;
          this.minHours = P(_, 0, 23), this.minMinutes = P(V, 0, 59), this.maxHours = P(G, 0, 23), this.maxMinutes = P(dt, 0, 59);
        }
        setMinTimeFromMinDate(_) {
          let { lastSelectedDate: V } = this.dp;
          this.minHours = _.getHours(), V && V.getHours() > _.getHours() ? this.minMinutes = this.opts.minMinutes : this.minMinutes = _.getMinutes();
        }
        setMaxTimeFromMaxDate(_) {
          let { lastSelectedDate: V } = this.dp;
          this.maxHours = _.getHours(), V && V.getHours() < _.getHours() ? this.maxMinutes = this.opts.maxMinutes : this.maxMinutes = _.getMinutes();
        }
        updateSliders() {
          o(this.$hours, { min: this.minHours, max: this.maxHours }).value = this.hours, o(this.$minutes, { min: this.minMinutes, max: this.maxMinutes }).value = this.minutes;
        }
        updateText() {
          this.$hoursText.innerHTML = h(this.displayHours), this.$minutesText.innerHTML = h(this.minutes), this.ampm && (this.$ampm.innerHTML = this.dayPeriod);
        }
        set hours(_) {
          this._hours = _;
          let { hours: V, dayPeriod: G } = p(_);
          this.displayHours = this.ampm ? V : _, this.dayPeriod = G;
        }
        get hours() {
          return this._hours;
        }
        render() {
          this.updateSliders(), this.updateText();
        }
      }
      function zt(K, _, V) {
        return (_ = function(G) {
          var dt = function(ht, ot) {
            if (typeof ht != "object" || ht === null)
              return ht;
            var $t = ht[Symbol.toPrimitive];
            if ($t !== void 0) {
              var _t = $t.call(ht, "string");
              if (typeof _t != "object")
                return _t;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return String(ht);
          }(G);
          return typeof dt == "symbol" ? dt : String(dt);
        }(_)) in K ? Object.defineProperty(K, _, { value: V, enumerable: !0, configurable: !0, writable: !0 }) : K[_] = V, K;
      }
      class j {
        constructor(_) {
          let { dp: V, opts: G } = _;
          zt(this, "pressedKeys", /* @__PURE__ */ new Set()), zt(this, "hotKeys", /* @__PURE__ */ new Map([[[["Control", "ArrowRight"], ["Control", "ArrowUp"]], (dt) => dt.month++], [[["Control", "ArrowLeft"], ["Control", "ArrowDown"]], (dt) => dt.month--], [[["Shift", "ArrowRight"], ["Shift", "ArrowUp"]], (dt) => dt.year++], [[["Shift", "ArrowLeft"], ["Shift", "ArrowDown"]], (dt) => dt.year--], [[["Alt", "ArrowRight"], ["Alt", "ArrowUp"]], (dt) => dt.year += 10], [[["Alt", "ArrowLeft"], ["Alt", "ArrowDown"]], (dt) => dt.year -= 10], [["Control", "Shift", "ArrowUp"], (dt, ht) => ht.up()]])), zt(this, "handleHotKey", (dt) => {
            let ht = this.hotKeys.get(dt), ot = d(this.getInitialFocusDate());
            ht(ot, this.dp);
            let { year: $t, month: _t, date: qt } = ot, de = c(new Date($t, _t));
            de < qt && (qt = de);
            let me = this.dp.getClampedDate(new Date($t, _t, qt));
            this.dp.setFocusDate(me, { viewDateTransition: !0 });
          }), zt(this, "isHotKeyPressed", () => {
            let dt = !1, ht = this.pressedKeys.size, ot = ($t) => this.pressedKeys.has($t);
            for (let [$t] of this.hotKeys) {
              if (dt)
                break;
              if (Array.isArray($t[0]))
                $t.forEach((_t) => {
                  dt || ht !== _t.length || (dt = _t.every(ot) && $t);
                });
              else {
                if (ht !== $t.length)
                  continue;
                dt = $t.every(ot) && $t;
              }
            }
            return dt;
          }), zt(this, "isArrow", (dt) => dt >= 37 && dt <= 40), zt(this, "onKeyDown", (dt) => {
            let { key: ht, which: ot } = dt, { dp: $t, dp: { focusDate: _t }, opts: qt } = this;
            this.registerKey(ht);
            let de = this.isHotKeyPressed();
            if (de)
              return dt.preventDefault(), void this.handleHotKey(de);
            if (this.isArrow(ot))
              return dt.preventDefault(), void this.focusNextCell(ht);
            if (ht === "Enter") {
              if ($t.currentView !== qt.minView)
                return void $t.down();
              if (_t) {
                let me = $t._checkIfDateIsSelected(_t);
                return void (me ? $t._handleAlreadySelectedDates(me, _t) : $t.selectDate(_t));
              }
            }
            ht === "Escape" && this.dp.hide();
          }), zt(this, "onKeyUp", (dt) => {
            this.removeKey(dt.key);
          }), this.dp = V, this.opts = G, this.init();
        }
        init() {
          this.bindKeyboardEvents();
        }
        bindKeyboardEvents() {
          let { $el: _ } = this.dp;
          _.addEventListener("keydown", this.onKeyDown), _.addEventListener("keyup", this.onKeyUp);
        }
        destroy() {
          let { $el: _ } = this.dp;
          _.removeEventListener("keydown", this.onKeyDown), _.removeEventListener("keyup", this.onKeyUp), this.hotKeys = null, this.pressedKeys = null;
        }
        getInitialFocusDate() {
          let { focusDate: _, currentView: V, selectedDates: G, parsedViewDate: { year: dt, month: ht } } = this.dp, ot = _ || G[G.length - 1];
          if (!ot)
            switch (V) {
              case n.days:
                ot = new Date(dt, ht, (/* @__PURE__ */ new Date()).getDate());
                break;
              case n.months:
                ot = new Date(dt, ht, 1);
                break;
              case n.years:
                ot = new Date(dt, 0, 1);
            }
          return ot;
        }
        focusNextCell(_) {
          let V = this.getInitialFocusDate(), { currentView: G } = this.dp, { days: dt, months: ht, years: ot } = n, $t = d(V), _t = $t.year, qt = $t.month, de = $t.date;
          switch (_) {
            case "ArrowLeft":
              G === dt && (de -= 1), G === ht && (qt -= 1), G === ot && (_t -= 1);
              break;
            case "ArrowUp":
              G === dt && (de -= 7), G === ht && (qt -= 3), G === ot && (_t -= 4);
              break;
            case "ArrowRight":
              G === dt && (de += 1), G === ht && (qt += 1), G === ot && (_t += 1);
              break;
            case "ArrowDown":
              G === dt && (de += 7), G === ht && (qt += 3), G === ot && (_t += 4);
          }
          let me = this.dp.getClampedDate(new Date(_t, qt, de));
          this.dp.setFocusDate(me, { viewDateTransition: !0 });
        }
        registerKey(_) {
          this.pressedKeys.add(_);
        }
        removeKey(_) {
          this.pressedKeys.delete(_);
        }
      }
      let tt = { on(K, _) {
        this.__events || (this.__events = {}), this.__events[K] ? this.__events[K].push(_) : this.__events[K] = [_];
      }, off(K, _) {
        this.__events && this.__events[K] && (this.__events[K] = this.__events[K].filter((V) => V !== _));
      }, removeAllEvents() {
        this.__events = {};
      }, trigger(K) {
        for (var _ = arguments.length, V = new Array(_ > 1 ? _ - 1 : 0), G = 1; G < _; G++)
          V[G - 1] = arguments[G];
        this.__events && this.__events[K] && this.__events[K].forEach((dt) => {
          dt(...V);
        });
      } };
      function lt(K, _, V) {
        return (_ = function(G) {
          var dt = function(ht, ot) {
            if (typeof ht != "object" || ht === null)
              return ht;
            var $t = ht[Symbol.toPrimitive];
            if ($t !== void 0) {
              var _t = $t.call(ht, "string");
              if (typeof _t != "object")
                return _t;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return String(ht);
          }(G);
          return typeof dt == "symbol" ? dt : String(dt);
        }(_)) in K ? Object.defineProperty(K, _, { value: V, enumerable: !0, configurable: !0, writable: !0 }) : K[_] = V, K;
      }
      let at = "", nt = "", yt = !1;
      class Rt {
        static buildGlobalContainer(_) {
          yt = !0, at = l({ className: _, id: _ }), r("body").appendChild(at);
        }
        constructor(_, V) {
          var G = this;
          if (lt(this, "viewIndexes", [n.days, n.months, n.years]), lt(this, "next", () => {
            let { year: ot, month: $t } = this.parsedViewDate;
            switch (this.currentView) {
              case n.days:
                this.setViewDate(new Date(ot, $t + 1, 1));
                break;
              case n.months:
                this.setViewDate(new Date(ot + 1, $t, 1));
                break;
              case n.years:
                this.setViewDate(new Date(ot + 10, 0, 1));
            }
          }), lt(this, "prev", () => {
            let { year: ot, month: $t } = this.parsedViewDate;
            switch (this.currentView) {
              case n.days:
                this.setViewDate(new Date(ot, $t - 1, 1));
                break;
              case n.months:
                this.setViewDate(new Date(ot - 1, $t, 1));
                break;
              case n.years:
                this.setViewDate(new Date(ot - 10, 0, 1));
            }
          }), lt(this, "_finishHide", () => {
            this.hideAnimation = !1, this._destroyComponents(), this.$container.removeChild(this.$datepicker);
          }), lt(this, "setPosition", function(ot) {
            let $t = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
            if (typeof (ot = ot || G.opts.position) == "function")
              return void (G.customHide = ot({ $datepicker: G.$datepicker, $target: G.$el, $pointer: G.$pointer, isViewChange: $t, done: G._finishHide }));
            let _t, qt, { isMobile: de } = G.opts, me = G.$el.getBoundingClientRect(), Ht = G.$el.getBoundingClientRect(), oe = G.$datepicker.offsetParent, Ye = G.$el.offsetParent, ze = G.$datepicker.getBoundingClientRect(), Lt = ot.split(" "), ye = window.scrollY, ue = window.scrollX, _e = G.opts.offset, la = Lt[0], qa = Lt[1];
            if (de)
              G.$datepicker.style.cssText = "left: 50%; top: 50%";
            else {
              if (oe === Ye && oe !== document.body && (Ht = { top: G.$el.offsetTop, left: G.$el.offsetLeft, width: me.width, height: G.$el.offsetHeight }, ye = 0, ue = 0), oe !== Ye && oe !== document.body) {
                let je = oe.getBoundingClientRect();
                Ht = { top: me.top - je.top, left: me.left - je.left, width: me.width, height: me.height }, ye = 0, ue = 0;
              }
              switch (la) {
                case "top":
                  _t = Ht.top - ze.height - _e;
                  break;
                case "right":
                  qt = Ht.left + Ht.width + _e;
                  break;
                case "bottom":
                  _t = Ht.top + Ht.height + _e;
                  break;
                case "left":
                  qt = Ht.left - ze.width - _e;
              }
              switch (qa) {
                case "top":
                  _t = Ht.top;
                  break;
                case "right":
                  qt = Ht.left + Ht.width - ze.width;
                  break;
                case "bottom":
                  _t = Ht.top + Ht.height - ze.height;
                  break;
                case "left":
                  qt = Ht.left;
                  break;
                case "center":
                  /left|right/.test(la) ? _t = Ht.top + Ht.height / 2 - ze.height / 2 : qt = Ht.left + Ht.width / 2 - ze.width / 2;
              }
              G.$datepicker.style.cssText = `left: ${qt + ue}px; top: ${_t + ye}px`;
            }
          }), lt(this, "_setInputValue", () => {
            let { opts: ot, $altField: $t, locale: { dateFormat: _t } } = this, { altFieldDateFormat: qt, altField: de } = ot;
            de && $t && ($t.value = this._getInputValue(qt)), this.$el.value = this._getInputValue(_t);
          }), lt(this, "_getInputValue", (ot) => {
            let { selectedDates: $t, opts: _t } = this, { multipleDates: qt, multipleDatesSeparator: de } = _t;
            if (!$t.length)
              return "";
            let me = typeof ot == "function", Ht = me ? ot(qt ? $t : $t[0]) : $t.map((oe) => this.formatDate(oe, ot));
            return Ht = me ? Ht : Ht.join(de), Ht;
          }), lt(this, "_checkIfDateIsSelected", function(ot) {
            let $t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : n.days, _t = !1;
            return G.selectedDates.some((qt) => {
              let de = b(ot, qt, $t);
              return _t = de && qt, de;
            }), _t;
          }), lt(this, "_scheduleCallAfterTransition", (ot) => {
            this._cancelScheduledCall(), ot && ot(!1), this._onTransitionEnd = () => {
              ot && ot(!0);
            }, this.$datepicker.addEventListener("transitionend", this._onTransitionEnd, { once: !0 });
          }), lt(this, "_cancelScheduledCall", () => {
            this.$datepicker.removeEventListener("transitionend", this._onTransitionEnd);
          }), lt(this, "setViewDate", (ot) => {
            if (!((ot = N(ot)) instanceof Date) || b(ot, this.viewDate))
              return;
            let $t = this.viewDate;
            this.viewDate = ot;
            let { onChangeViewDate: _t } = this.opts;
            if (_t) {
              let { month: qt, year: de } = this.parsedViewDate;
              _t({ month: qt, year: de, decade: this.curDecade });
            }
            this.trigger(n.eventChangeViewDate, ot, $t);
          }), lt(this, "setFocusDate", function(ot) {
            let $t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            (!ot || (ot = N(ot)) instanceof Date) && (G.focusDate = ot, G.trigger(n.eventChangeFocusDate, ot, $t));
          }), lt(this, "setCurrentView", function(ot) {
            let $t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            if (G.viewIndexes.includes(ot)) {
              if (G.currentView = ot, G.elIsInput && G.visible && G.setPosition(void 0, !0), G.trigger(n.eventChangeCurrentView, ot), !G.views[ot]) {
                let _t = G.views[ot] = new rt({ dp: G, opts: G.opts, type: ot });
                G.shouldUpdateDOM && G.$content.appendChild(_t.$el);
              }
              G.opts.onChangeView && !$t.silent && G.opts.onChangeView(ot);
            }
          }), lt(this, "_updateLastSelectedDate", (ot) => {
            this.lastSelectedDate = ot, this.trigger(n.eventChangeLastSelectedDate, ot);
          }), lt(this, "destroy", () => {
            if (this.isDestroyed)
              return;
            let { showEvent: ot, isMobile: $t } = this.opts, _t = this.$datepicker.parentNode;
            _t && _t.removeChild(this.$datepicker), this.$el.removeEventListener(ot, this._onFocus), this.$el.removeEventListener("blur", this._onBlur), window.removeEventListener("resize", this._onResize), $t && this._removeMobileAttributes(), this.keyboardNav && this.keyboardNav.destroy(), this.views = null, this.nav = null, this.$datepicker = null, this.opts = {}, this.$customContainer = null, this.viewDate = null, this.focusDate = null, this.selectedDates = [], this.rangeDateFrom = null, this.rangeDateTo = null, this.isDestroyed = !0;
          }), lt(this, "update", function() {
            let ot = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, $t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _t = O({}, G.opts), { silent: qt } = $t;
            O(G.opts, ot);
            let { timepicker: de, buttons: me, range: Ht, selectedDates: oe, isMobile: Ye } = G.opts, ze = G.visible || G.treatAsInline;
            G._createMinMaxDates(), G._limitViewDateByMaxMinDates(), G._handleLocale(), oe && (G.selectedDates = [], G.selectDate(oe, { silent: qt })), ot.view && G.setCurrentView(ot.view, { silent: qt }), G._setInputValue(), _t.range && !Ht ? (G.rangeDateTo = !1, G.rangeDateFrom = !1) : !_t.range && Ht && G.selectedDates.length && (G.rangeDateFrom = G.selectedDates[0], G.rangeDateTo = G.selectedDates[1]), _t.timepicker && !de ? (ze && G.timepicker.destroy(), G.timepicker = !1, G.$timepicker.parentNode.removeChild(G.$timepicker)) : !_t.timepicker && de && G._addTimepicker(), !_t.buttons && me ? G._addButtons() : _t.buttons && !me ? (G.buttons.destroy(), G.$buttons.parentNode.removeChild(G.$buttons)) : ze && _t.buttons && me && G.buttons.clearHtml().render(), !_t.isMobile && Ye ? (G.treatAsInline || nt || G._createMobileOverlay(), G._addMobileAttributes(), G.visible && G._showMobileOverlay()) : _t.isMobile && !Ye && (G._removeMobileAttributes(), G.visible && (nt.classList.remove("-active-"), typeof G.opts.position != "function" && G.setPosition())), ze && (G.nav.update(), G.views[G.currentView].render(), G.currentView === n.days && G.views[G.currentView].renderDayNames());
          }), lt(this, "disableDate", (ot, $t) => {
            (Array.isArray(ot) ? ot : [ot]).forEach((_t) => {
              let qt = N(_t);
              if (!qt)
                return;
              let de = $t ? "delete" : "add";
              this.disabledDates[de](this.formatDate(qt, "yyyy-MM-dd"));
              let me = this.getCell(qt, this.currentViewSingular);
              me && me.adpCell.render();
            }, []);
          }), lt(this, "enableDate", (ot) => {
            this.disableDate(ot, !0);
          }), lt(this, "isDateDisabled", (ot) => {
            let $t = N(ot);
            return this.disabledDates.has(this.formatDate($t, "yyyy-MM-dd"));
          }), lt(this, "isOtherMonth", (ot) => {
            let { month: $t } = d(ot);
            return $t !== this.parsedViewDate.month;
          }), lt(this, "isOtherYear", (ot) => {
            let { year: $t } = d(ot);
            return $t !== this.parsedViewDate.year;
          }), lt(this, "isOtherDecade", (ot) => {
            let { year: $t } = d(ot), [_t, qt] = g(this.viewDate);
            return $t < _t || $t > qt;
          }), lt(this, "_onChangeSelectedDate", (ot) => {
            let { silent: $t } = ot;
            setTimeout(() => {
              this._setInputValue(), this.opts.onSelect && !$t && this._triggerOnSelect();
            });
          }), lt(this, "_onChangeFocusedDate", function(ot) {
            let { viewDateTransition: $t } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            if (!ot)
              return;
            let _t = !1;
            $t && (_t = G.isOtherMonth(ot) || G.isOtherYear(ot) || G.isOtherDecade(ot)), _t && G.setViewDate(ot), G.opts.onFocus && G.opts.onFocus({ datepicker: G, date: ot });
          }), lt(this, "_onChangeTime", (ot) => {
            let { hours: $t, minutes: _t } = ot, qt = /* @__PURE__ */ new Date(), { lastSelectedDate: de, opts: { onSelect: me } } = this, Ht = de;
            de || (Ht = qt);
            let oe = this.getCell(Ht, this.currentViewSingular), Ye = oe && oe.adpCell;
            Ye && Ye.isDisabled || (Ht.setHours($t), Ht.setMinutes(_t), de ? (this._setInputValue(), me && this._triggerOnSelect()) : this.selectDate(Ht));
          }), lt(this, "_onFocus", (ot) => {
            this.visible || this.show();
          }), lt(this, "_onBlur", (ot) => {
            this.inFocus || !this.visible || this.opts.isMobile || this.hide();
          }), lt(this, "_onMouseDown", (ot) => {
            this.inFocus = !0;
          }), lt(this, "_onMouseUp", (ot) => {
            this.inFocus = !1, this.$el.focus();
          }), lt(this, "_onResize", () => {
            this.visible && typeof this.opts.position != "function" && this.setPosition();
          }), lt(this, "_onClickOverlay", () => {
            this.visible && this.hide();
          }), lt(this, "getViewDates", function() {
            let ot = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : n.days;
            return rt.getDatesFunction(ot)(G);
          }), lt(this, "isWeekend", (ot) => this.opts.weekends.includes(ot)), lt(this, "getClampedDate", (ot) => {
            let { minDate: $t, maxDate: _t } = this, qt = ot;
            return _t && A(ot, _t) ? qt = _t : $t && T(ot, $t) && (qt = $t), qt;
          }), this.$el = r(_), !this.$el)
            return;
          this.$datepicker = l({ className: "air-datepicker" }), this.opts = O({}, i, V), this.$customContainer = !!this.opts.container && r(this.opts.container), this.$altField = r(this.opts.altField || !1);
          let { view: dt, startDate: ht } = this.opts;
          ht || (this.opts.startDate = /* @__PURE__ */ new Date()), this.$el.nodeName === "INPUT" && (this.elIsInput = !0), this.inited = !1, this.visible = !1, this.viewDate = N(this.opts.startDate), this.focusDate = !1, this.initialReadonly = this.$el.getAttribute("readonly"), this.customHide = !1, this.currentView = dt, this.selectedDates = [], this.disabledDates = /* @__PURE__ */ new Set(), this.isDestroyed = !1, this.views = {}, this.keys = [], this.rangeDateFrom = "", this.rangeDateTo = "", this.timepickerIsActive = !1, this.treatAsInline = this.opts.inline || !this.elIsInput, this.init();
        }
        init() {
          let { opts: _, treatAsInline: V, opts: { inline: G, isMobile: dt, selectedDates: ht, keyboardNav: ot, onlyTimepicker: $t } } = this, _t = r("body");
          (!yt || yt && at && !_t.contains(at)) && !G && this.elIsInput && !this.$customContainer && Rt.buildGlobalContainer(Rt.defaultGlobalContainerId), !dt || nt || V || this._createMobileOverlay(), this._handleLocale(), this._bindSubEvents(), this._createMinMaxDates(), this._limitViewDateByMaxMinDates(), this.elIsInput && (G || this._bindEvents(), ot && !$t && (this.keyboardNav = new j({ dp: this, opts: _ }))), ht && this.selectDate(ht, { silent: !0 }), this.opts.visible && !V && this.show(), dt && !V && this.$el.setAttribute("readonly", !0), V && this._createComponents();
        }
        _createMobileOverlay() {
          nt = l({ className: "air-datepicker-overlay" }), at.appendChild(nt);
        }
        _createComponents() {
          let { opts: _, treatAsInline: V, opts: { inline: G, buttons: dt, timepicker: ht, position: ot, classes: $t, onlyTimepicker: _t, isMobile: qt } } = this;
          this._buildBaseHtml(), this.elIsInput && (G || this._setPositionClasses(ot)), !G && this.elIsInput || this.$datepicker.classList.add("-inline-"), $t && this.$datepicker.classList.add(...$t.split(" ")), _t && this.$datepicker.classList.add("-only-timepicker-"), qt && !V && this._addMobileAttributes(), this.views[this.currentView] = new rt({ dp: this, type: this.currentView, opts: _ }), this.nav = new M({ dp: this, opts: _ }), ht && this._addTimepicker(), dt && this._addButtons(), this.$content.appendChild(this.views[this.currentView].$el), this.$nav.appendChild(this.nav.$el);
        }
        _destroyComponents() {
          for (let _ in this.views)
            this.views[_].destroy();
          this.views = {}, this.nav.destroy(), this.timepicker && this.timepicker.destroy();
        }
        _addMobileAttributes() {
          nt.addEventListener("click", this._onClickOverlay), this.$datepicker.classList.add("-is-mobile-"), this.$el.setAttribute("readonly", !0);
        }
        _removeMobileAttributes() {
          nt.removeEventListener("click", this._onClickOverlay), this.$datepicker.classList.remove("-is-mobile-"), this.initialReadonly || this.initialReadonly === "" || this.$el.removeAttribute("readonly");
        }
        _createMinMaxDates() {
          let { minDate: _, maxDate: V } = this.opts;
          this.minDate = !!_ && N(_), this.maxDate = !!V && N(V);
        }
        _addTimepicker() {
          this.$timepicker = l({ className: "air-datepicker--time" }), this.$datepicker.appendChild(this.$timepicker), this.timepicker = new St({ dp: this, opts: this.opts }), this.$timepicker.appendChild(this.timepicker.$el);
        }
        _addButtons() {
          this.$buttons = l({ className: "air-datepicker--buttons" }), this.$datepicker.appendChild(this.$buttons), this.buttons = new J({ dp: this, opts: this.opts }), this.$buttons.appendChild(this.buttons.$el);
        }
        _bindSubEvents() {
          this.on(n.eventChangeSelectedDate, this._onChangeSelectedDate), this.on(n.eventChangeFocusDate, this._onChangeFocusedDate), this.on(n.eventChangeTime, this._onChangeTime);
        }
        _buildBaseHtml() {
          let { inline: _ } = this.opts;
          var V, G;
          this.elIsInput ? _ ? (V = this.$datepicker, (G = this.$el).parentNode.insertBefore(V, G.nextSibling)) : this.$container.appendChild(this.$datepicker) : this.$el.appendChild(this.$datepicker), this.$datepicker.innerHTML = '<i class="air-datepicker--pointer"></i><div class="air-datepicker--navigation"></div><div class="air-datepicker--content"></div>', this.$content = r(".air-datepicker--content", this.$datepicker), this.$pointer = r(".air-datepicker--pointer", this.$datepicker), this.$nav = r(".air-datepicker--navigation", this.$datepicker);
        }
        _handleLocale() {
          let { locale: _, dateFormat: V, firstDay: G, timepicker: dt, onlyTimepicker: ht, timeFormat: ot, dateTimeSeparator: $t } = this.opts;
          var _t;
          this.locale = (_t = _, JSON.parse(JSON.stringify(_t))), V && (this.locale.dateFormat = V), ot !== void 0 && ot !== "" && (this.locale.timeFormat = ot);
          let { timeFormat: qt } = this.locale;
          if (G !== "" && (this.locale.firstDay = G), dt && typeof V != "function") {
            let de = qt ? $t : "";
            this.locale.dateFormat = [this.locale.dateFormat, qt || ""].join(de);
          }
          ht && typeof V != "function" && (this.locale.dateFormat = this.locale.timeFormat);
        }
        _setPositionClasses(_) {
          if (typeof _ == "function")
            return void this.$datepicker.classList.add("-custom-position-");
          let V = (_ = _.split(" "))[0], G = `air-datepicker -${V}-${_[1]}- -from-${V}-`;
          this.$datepicker.classList.add(...G.split(" "));
        }
        _bindEvents() {
          this.$el.addEventListener(this.opts.showEvent, this._onFocus), this.$el.addEventListener("blur", this._onBlur), this.$datepicker.addEventListener("mousedown", this._onMouseDown), this.$datepicker.addEventListener("mouseup", this._onMouseUp), window.addEventListener("resize", this._onResize);
        }
        _limitViewDateByMaxMinDates() {
          let { viewDate: _, minDate: V, maxDate: G } = this;
          G && A(_, G) && this.setViewDate(G), V && T(_, V) && this.setViewDate(V);
        }
        formatDate() {
          let _ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.viewDate, V = arguments.length > 1 ? arguments[1] : void 0;
          if (_ = N(_), !(_ instanceof Date))
            return;
          let G = V, dt = this.locale, ht = d(_), ot = ht.dayPeriod, $t = g(_), _t = Rt.replacer, qt = { T: _.getTime(), m: ht.minutes, mm: ht.fullMinutes, h: ht.hours12, hh: ht.fullHours12, H: ht.hours, HH: ht.fullHours, aa: ot, AA: ot.toUpperCase(), E: dt.daysShort[ht.day], EEEE: dt.days[ht.day], d: ht.date, dd: ht.fullDate, M: ht.month + 1, MM: ht.fullMonth, MMM: dt.monthsShort[ht.month], MMMM: dt.months[ht.month], yy: ht.year.toString().slice(-2), yyyy: ht.year, yyyy1: $t[0], yyyy2: $t[1] };
          for (let [de, me] of Object.entries(qt))
            G = _t(G, H(de), me);
          return G;
        }
        down(_) {
          this._handleUpDownActions(_, "down");
        }
        up(_) {
          this._handleUpDownActions(_, "up");
        }
        selectDate(_) {
          let V, G = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, { currentView: dt, parsedViewDate: ht, selectedDates: ot } = this, { updateTime: $t } = G, { moveToOtherMonthsOnSelect: _t, moveToOtherYearsOnSelect: qt, multipleDates: de, range: me, autoClose: Ht, onBeforeSelect: oe } = this.opts, Ye = ot.length;
          if (Array.isArray(_))
            return _.forEach((ze) => {
              this.selectDate(ze, G);
            }), new Promise((ze) => {
              setTimeout(ze);
            });
          if ((_ = N(_)) instanceof Date) {
            if (oe && !oe({ date: _, datepicker: this }))
              return Promise.resolve();
            if (dt === n.days && _.getMonth() !== ht.month && _t && (V = new Date(_.getFullYear(), _.getMonth(), 1)), dt === n.years && _.getFullYear() !== ht.year && qt && (V = new Date(_.getFullYear(), 0, 1)), V && this.setViewDate(V), de && !me) {
              if (Ye === de)
                return;
              this._checkIfDateIsSelected(_) || ot.push(_);
            } else if (me)
              switch (Ye) {
                case 1:
                  ot.push(_), this.rangeDateTo || (this.rangeDateTo = _), A(this.rangeDateFrom, this.rangeDateTo) && (this.rangeDateTo = this.rangeDateFrom, this.rangeDateFrom = _), this.selectedDates = [this.rangeDateFrom, this.rangeDateTo];
                  break;
                case 2:
                  this.selectedDates = [_], this.rangeDateFrom = _, this.rangeDateTo = "";
                  break;
                default:
                  this.selectedDates = [_], this.rangeDateFrom = _;
              }
            else
              this.selectedDates = [_];
            return this.trigger(n.eventChangeSelectedDate, { action: n.actionSelectDate, silent: G?.silent, date: _, updateTime: $t }), this._updateLastSelectedDate(_), Ht && !this.timepickerIsActive && this.visible && (de || me ? me && Ye === 1 && this.hide() : this.hide()), new Promise((ze) => {
              setTimeout(ze);
            });
          }
        }
        unselectDate(_) {
          let V = this.selectedDates, G = this;
          if ((_ = N(_)) instanceof Date)
            return V.some((dt, ht) => {
              if (b(dt, _))
                return V.splice(ht, 1), G.selectedDates.length ? (G.rangeDateTo = "", G.rangeDateFrom = V[0], G._updateLastSelectedDate(G.selectedDates[G.selectedDates.length - 1])) : (G.rangeDateFrom = "", G.rangeDateTo = "", G._updateLastSelectedDate(!1)), this.trigger(n.eventChangeSelectedDate, { action: n.actionUnselectDate, date: _ }), !0;
            });
        }
        replaceDate(_, V) {
          let G = this.selectedDates.find((ht) => b(ht, _, this.currentView)), dt = this.selectedDates.indexOf(G);
          dt < 0 || b(this.selectedDates[dt], V, this.currentView) || (this.selectedDates[dt] = V, this.trigger(n.eventChangeSelectedDate, { action: n.actionSelectDate, date: V, updateTime: !0 }), this._updateLastSelectedDate(V));
        }
        clear() {
          let _ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
          return this.selectedDates = [], this.rangeDateFrom = !1, this.rangeDateTo = !1, this.lastSelectedDate = !1, this.trigger(n.eventChangeSelectedDate, { action: n.actionUnselectDate, silent: _.silent }), new Promise((V) => {
            setTimeout(V);
          });
        }
        show() {
          let { onShow: _, isMobile: V } = this.opts;
          this._cancelScheduledCall(), this.visible || this.hideAnimation || this._createComponents(), this.setPosition(this.opts.position), this.$datepicker.classList.add("-active-"), this.visible = !0, _ && this._scheduleCallAfterTransition(_), V && this._showMobileOverlay();
        }
        hide() {
          let { onHide: _, isMobile: V } = this.opts, G = this._hasTransition();
          this.visible = !1, this.hideAnimation = !0, this.$datepicker.classList.remove("-active-"), this.customHide && this.customHide(), this.elIsInput && this.$el.blur(), this._scheduleCallAfterTransition((dt) => {
            !this.customHide && (dt && G || !dt && !G) && this._finishHide(), _ && _(dt);
          }), V && nt.classList.remove("-active-");
        }
        _triggerOnSelect() {
          let _ = [], V = [], { selectedDates: G, locale: dt, opts: { onSelect: ht, multipleDates: ot, range: $t } } = this, _t = ot || $t, qt = typeof dt.dateFormat == "function";
          G.length && (_ = G.map(R), V = qt ? ot ? dt.dateFormat(_) : _.map((de) => dt.dateFormat(de)) : _.map((de) => this.formatDate(de, dt.dateFormat))), ht({ date: _t ? _ : _[0], formattedDate: _t ? V : V[0], datepicker: this });
        }
        _handleAlreadySelectedDates(_, V) {
          let { selectedDates: G, rangeDateFrom: dt, rangeDateTo: ht } = this, { range: ot, toggleSelected: $t } = this.opts, _t = G.length, qt = typeof $t == "function" ? $t({ datepicker: this, date: V }) : $t, de = !!(ot && _t === 1 && _), me = de ? R(V) : V;
          ot && !qt && (_t !== 2 && this.selectDate(me), _t === 2 && b(dt, ht)) || (qt ? this.unselectDate(me) : this._updateLastSelectedDate(de ? me : _));
        }
        _handleUpDownActions(_, V) {
          if (!((_ = N(_ || this.focusDate || this.viewDate)) instanceof Date))
            return;
          let G = V === "up" ? this.viewIndex + 1 : this.viewIndex - 1;
          G > 2 && (G = 2), G < 0 && (G = 0), this.setViewDate(new Date(_.getFullYear(), _.getMonth(), 1)), this.setCurrentView(this.viewIndexes[G]);
        }
        getCell(_) {
          let V = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : n.day;
          if (!((_ = N(_)) instanceof Date))
            return;
          let { year: G, month: dt, date: ht } = d(_), ot = `[data-year="${G}"]`, $t = `[data-month="${dt}"]`, _t = { [n.day]: `${ot}${$t}[data-date="${ht}"]`, [n.month]: `${ot}${$t}`, [n.year]: `${ot}` };
          return this.views[this.currentView] ? this.views[this.currentView].$el.querySelector(_t[V]) : void 0;
        }
        _showMobileOverlay() {
          nt.classList.add("-active-");
        }
        _hasTransition() {
          return window.getComputedStyle(this.$datepicker).getPropertyValue("transition-duration").split(", ").reduce((_, V) => parseFloat(V) + _, 0) > 0;
        }
        get shouldUpdateDOM() {
          return this.visible || this.treatAsInline;
        }
        get parsedViewDate() {
          return d(this.viewDate);
        }
        get currentViewSingular() {
          return this.currentView.slice(0, -1);
        }
        get curDecade() {
          return g(this.viewDate);
        }
        get viewIndex() {
          return this.viewIndexes.indexOf(this.currentView);
        }
        get isFinalView() {
          return this.currentView === n.years;
        }
        get hasSelectedDates() {
          return this.selectedDates.length > 0;
        }
        get isMinViewReached() {
          return this.currentView === this.opts.minView || this.currentView === n.days;
        }
        get $container() {
          return this.$customContainer || at;
        }
        static replacer(_, V, G) {
          return _.replace(V, function(dt, ht, ot, $t) {
            return ht + G + $t;
          });
        }
      }
      var Yt;
      return lt(Rt, "defaults", i), lt(Rt, "version", "3.5.3"), lt(Rt, "defaultGlobalContainerId", "air-datepicker-global-container"), Yt = Rt.prototype, Object.assign(Yt, tt), a.default;
    }();
  });
})(DE);
var cW = DE.exports;
const IE = /* @__PURE__ */ Hs(cW);
var eA = {};
Object.defineProperty(eA, "__esModule", {
  value: !0
});
var aA = eA.default = void 0, dW = {
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  daysMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  monthsShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  today: "Today",
  clear: "Clear",
  dateFormat: "MM/dd/yyyy",
  timeFormat: "hh:mm aa",
  firstDay: 0
};
aA = eA.default = dW;
var nA = {};
Object.defineProperty(nA, "__esModule", {
  value: !0
});
var fu = nA.default = void 0, uW = {
  days: ["Sunnuntai", "Maanantai", "Tiistai", "Keskiviikko", "Torstai", "Perjantai", "Lauantai"],
  daysShort: ["Su", "Ma", "Ti", "Ke", "To", "Pe", "La"],
  daysMin: ["Su", "Ma", "Ti", "Ke", "To", "Pe", "La"],
  months: ["Tammikuu", "Helmikuu", "Maaliskuu", "Huhtikuu", "Toukokuu", "Kesäkuu", "Heinäkuu", "Elokuu", "Syyskuu", "Lokakuu", "Marraskuu", "Joulukuu"],
  monthsShort: ["Tammi", "Helmi", "Maalis", "Huhti", "Touko", "Kesä", "Heinä", "Elo", "Syys", "Loka", "Marras", "Joulu"],
  today: "Tänään",
  clear: "Tyhjennä",
  dateFormat: "dd.MM.yyyy",
  timeFormat: "HH:mm",
  firstDay: 1
};
fu = nA.default = uW;
var sA = {};
Object.defineProperty(sA, "__esModule", {
  value: !0
});
var iA = sA.default = void 0, pW = {
  days: ["Söndag", "Måndag", "Tisdag", "Onsdag", "Torsdag", "Fredag", "Lördag"],
  daysShort: ["Sön", "Mån", "Tis", "Ons", "Tor", "Fre", "Lör"],
  daysMin: ["Sö", "Må", "Ti", "On", "To", "Fr", "Lö"],
  months: ["Januari", "Februari", "Mars", "April", "Maj", "Juni", "Juli", "Augusti", "September", "Oktober", "November", "December"],
  monthsShort: ["Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"],
  today: "I dag",
  clear: "Nollställ",
  dateFormat: "yyyy-MM-dd",
  timeFormat: "HH:mm",
  firstDay: 1
};
iA = sA.default = pW;
const S$ = class S$ {
  constructor(t, e, a, n) {
    this.sessionService = t, this.$element = e, this.$timeout = a, this.$scope = n, this.timepicker = !1, this.showButtons = !0;
  }
  /** Getter and setter for the formatted value. */
  get datepickerValue() {
    return this.isMultiple ? this.model?.$viewValue : this.model?.$viewValue ? I.getFormattedDate(I.asJSDate(this.model.$viewValue)) : "";
  }
  set datepickerValue(t) {
    this.model && (this.model.$viewValue = t);
  }
  /** Set the values and defaults on init */
  $onInit() {
    this.name && !this.label && (this.label = this.name), this.initDatepicker(), this.watchChanges && this.$scope.$watch(() => this.model.$viewValue, (t, e) => {
      t !== e && (this.datepicker.clear({ silent: !0 }), this.setDatepickerComponentValue(t), (this.minDate || this.maxDate) && this.updateDatepickerMinMaxRange(), this.isMultiple && (this.daysCount = t.days ? t.days.length : t.daysCount));
    }, !0);
  }
  /**
   * Initialize the datepicker element.
   */
  initDatepicker() {
    this.$timeout(() => {
      const t = this.$element[0].querySelector(".datepicker-input");
      if (!t)
        return;
      let e = "days", a = "days", n = !1, i = !1, r = "dd.MM.yyyy", l, o;
      const c = {
        content: L.get("SALAXY.UI_Terms.today"),
        className: "today-button btn btn-info me-1",
        onClick: (x) => {
          const b = /* @__PURE__ */ new Date();
          x.selectDate(b), x.setViewDate(b);
        }
      }, d = {
        content: L.get("SALAXY.UI_Terms.clear"),
        className: "clear-button btn btn-danger",
        onClick: (x) => {
          x.clear();
        }
      };
      let p = this.showButtons ? [c, d] : [];
      if (this.isMultiple && (n = 365, p = []), this.format)
        switch (this.format) {
          case "month":
            r = "MMMM, yyyy", e = "months", a = "months";
            break;
          case "year":
            r = "yyyy", e = "years", a = "years";
            break;
        }
      if (this.$element[0].tagName.toLowerCase() == "salaxy-datepicker" && (i = !0), this.dateDisabled)
        switch (this.dateDisabled) {
          case "next-weekday":
            l = I.asJSDate(I.asDate("today"));
            break;
          case "salary":
            l = I.asJSDate(I.add(I.asDate("today"), -1, "year"));
        }
      else
        this.minDate && (l = this.minDate), this.maxDate && (o = this.maxDate);
      const h = {
        fi: fu,
        en: aA,
        sv: iA
      }, g = L.getLanguage();
      this.datepicker = new IE(t, {
        locale: h?.[g] || fu,
        view: e,
        multipleDates: n,
        autoClose: !0,
        buttons: p,
        inline: i,
        minView: a,
        dateFormat: r,
        minDate: l,
        maxDate: o,
        timepicker: this.timepicker,
        position: "bottom right",
        onSelect: (x) => {
          this.changeDateEvent(x.date);
        },
        onRenderCell: (x) => this.dateDisabled && this.disableFunction ? this.isDateDisabled(this.disableFunction(x.date)) : this.isDateDisabled(this.checkDateDisabled(x.date))
      }), this.model.$viewValue && this.setDatepickerComponentValue(this.model.$viewValue);
    }, 100);
  }
  /** Updates the datepicker min-max range limit options. */
  updateDatepickerMinMaxRange() {
    this.datepicker.update({ minDate: this.minDate, maxDate: this.maxDate }, { silent: !0 });
  }
  /** Wrapper for updating component value. Note: update is always made "silent", so that the onSelect event won't get fired. */
  setDatepickerComponentValue(t) {
    let e;
    this.isMultiple ? (e = t.days ? t.days : [], this.daysCount = this.model.$viewValue.days ? this.model.$viewValue.days.length : this.model.$viewValue.daysCount) : e = t, this.datepicker.selectDate(e, { silent: !0 }), this.validate(), this.$scope.$evalAsync();
  }
  /**
   * Change event method.
   * @param date Date value that's picked in the datepicker.
   */
  changeDateEvent(t) {
    let e;
    Array.isArray(t) ? e = t.map((n) => I.asDate(n)) : t === void 0 ? e = "" : this.timepicker ? e = t.toISOString() : e = I.asDate(t);
    const a = this.isMultiple ? {
      ...this.model.$viewValue,
      days: e,
      daysCount: e.length
    } : e;
    this.model.$setViewValue(a), this.validate(), this.$scope.$evalAsync();
  }
  /**
   * Checks if given date is disabled with one of two methods: "next-weekday" and "salary".
   * @param date The date to evaluate.
   * @returns boolean Either true = date is disabled, false = not disabled.
   */
  checkDateDisabled(t) {
    const e = this.sessionService.isInRole("pro") ? "pro" : this.sessionService.isInRole("admin") ? "admin" : null;
    switch (this.dateDisabled) {
      case "next-weekday":
        return I.asDate(t) < I.addWorkdays("today", 1) || !I.isWorkday(t);
      case "salary":
        return !gc.isValidSalaryDate(t, null, null, !0, this.paymentChannel, this.zeroPayment, e);
    }
  }
  /** Returns object for disabled dates to show in the datepicker UI. */
  isDateDisabled(t) {
    if (t)
      return {
        disabled: !0,
        classes: "disabled-class"
      };
  }
  /** Gets the readonly value either from the controller or from the form */
  getReadOnly() {
    const t = (this.readOnly + "").trim().toLowerCase();
    return t === "true" || t === "1" ? !0 : t === "false" || t === "0" ? !1 : !!this?.form?.$$element[0]?.attributes?.readonly;
  }
  /** Gets or sets the presence of the required validator in the underlying model. */
  get require() {
    return !!this.model?.$validators.required;
  }
  set require(t) {
    const e = () => {
      if (!this.model) {
        setTimeout(e);
        return;
      }
      const a = !!this.model.$validators.required;
      t && !a ? this.model.$validators.required = (n, i) => !this.model.$isEmpty(i) : !t && a && delete this.model.$validators.required;
    };
    e();
  }
  /** Do validations. */
  validate() {
    return this.require && !this.model.$viewValue ? !1 : this.model.$viewValue ? I.isValidDateTime(this.model.$viewValue) ? (this.validationError = "", this.require && this.model.$setValidity("required", !0), !0) : (this.validationError = "SALAXY.NG1.DatepickerComponent.validationErrorDefault", !1) : !0;
  }
};
S$.$inject = ["SessionService", "$element", "$timeout", "$scope"];
let bu = S$;
const k$ = class k$ extends bu {
  constructor(t, e, a, n) {
    super(t, e, a, n);
  }
  /** Gets the tooltip HTML with necessary escape. */
  getToolTipHtml() {
    return this.tooltipHtml;
  }
};
k$.$inject = ["SessionService", "$element", "$timeout", "$scope"];
let Bm = k$;
const T$ = class T$ {
  constructor(t, e) {
    this.$element = t, this.$timeout = e, this.periodStartDateError = null;
  }
  /** Set the values and defaults on init */
  $onInit() {
    this.dateRangeValues = {
      start: null,
      end: null,
      days: [],
      daysCount: null
    };
    const t = I.getMonth(I.getToday());
    this.periodShortcuts = {
      monthCurrent: L.get(`SALAXY.ENUM.CalendarMonth.month${t}.label`),
      monthLast: L.get(`SALAXY.ENUM.CalendarMonth.month${t === 1 ? 12 : t - 1}.label`),
      monthOther: L.get("SALAXY.NG1.DateRange.otherMonth"),
      // monthMulti: "Monta kuukautta",
      weeks2: L.get("SALAXY.UI_Terms.week2"),
      monthHalf: L.get("SALAXY.UI_Terms.monthHalf"),
      other: L.get("SALAXY.UI_Terms.otherPeriod")
    }, this.initDatepicker();
  }
  /** HACK: Temporary shortcut period setting. Needs go-through / refactoring. */
  get dateRange() {
    return this.value === void 0 && (this.value = {
      start: void 0,
      end: void 0,
      daysCount: void 0
    }), this.value;
  }
  set dateRange(t) {
    this.value = t;
  }
  /** Gets or sets the period start date */
  get periodStartDate() {
    return this._periodStartDate;
  }
  set periodStartDate(t) {
    this._periodStartDate = t;
    const e = (t || "").split(".");
    if (e.length < 2 || e.length > 3) {
      this.periodStartDateError = L.get("SALAXY.NG1.DateRange.periodStartDateError");
      return;
    }
    let a = e.length === 3 ? Number((e[2] || "").trim()) : null;
    (!a || a < 2019 || a > 2100) && (a = Number(this.dateRangeValues.start.substr(0, 4)));
    const n = I.getDate(a, Number(e[1]), Number(e[0]));
    if (n) {
      switch (this.periodStartDateError = null, this.periodShortcut) {
        case "monthCurrent":
        case "monthLast":
        case "monthOther":
          this.dateRangeValues = I.getDateRange(n, I.add(I.add(n, 1, "month"), -1, "day"));
          break;
        case "weeks2":
          this.dateRangeValues = I.getDateRange(n, I.add(I.add(n, 2, "week"), -1, "day"));
          break;
        case "monthHalf":
          I.getDay(n) === 15 || I.getDay(n) === 16 ? this.dateRangeValues = I.getDateRange(n, I.startEnd(n, "end-month")) : this.dateRangeValues = I.getDateRange(n, I.add(n, 14, "day"));
          break;
        case "other":
          this.dateRangeValues = I.getDateRange(n, n);
          break;
      }
      this.datepicker.clear({ silent: !0 }), this.setValues(this.dateRangeValues, !1);
    } else
      this.periodStartDateError = `${t}` + L.get("SALAXY.NG1.DateRange.periodStartDateError2");
  }
  /** Gets the user interface shortcut for the period. */
  get periodShortcut() {
    return !this.dateRangeValues || !this.dateRangeValues.start || !this.dateRangeValues.end ? null : this.dateRangeValues.start === I.getDate("today", "today", 1) && this.dateRangeValues.end === I.startEnd("today", "end-month") ? "monthCurrent" : this.dateRangeValues.start === I.add(I.startEnd("today", "start-month"), -1, "month") && this.dateRangeValues.end === I.startEnd(I.add(I.startEnd("today", "start-month"), -1, "month"), "end-month") ? "monthLast" : this.dateRangeValues.end === I.add(I.add(this.dateRangeValues.start, 1, "month"), -1, "day") ? "monthOther" : this.dateRangeValues.end === I.add(I.add(this.dateRangeValues.start, 2, "week"), -1, "day") ? "weeks2" : I.getDuration(this.dateRangeValues.start, this.dateRangeValues.end).days() === 14 || I.getDay(this.dateRangeValues.start) === 15 && this.dateRangeValues.end === I.startEnd(this.dateRangeValues.start, "end-month") || I.getDay(this.dateRangeValues.start) === 16 && this.dateRangeValues.end === I.startEnd(this.dateRangeValues.start, "end-month") ? "monthHalf" : "other";
  }
  set periodShortcut(t) {
    switch (this.periodStartDateError = null, t) {
      case "monthCurrent":
        this.dateRangeValues.start = I.startEnd("today", "start-month"), this.dateRangeValues.end = I.startEnd("today", "end-month");
        break;
      case "monthOther":
        I.getDay("today") === 1 ? this.dateRangeValues.start = I.add("today", 1, "day") : this.dateRangeValues.start = I.asDate("today"), this.dateRangeValues.end = I.add(I.add(this.dateRangeValues.start, 1, "month"), -1, "day");
        break;
      case "monthLast":
        this.dateRangeValues.start = I.add(I.startEnd("today", "start-month"), -1, "month"), this.dateRangeValues.end = I.startEnd(this.dateRangeValues.start, "end-month");
        break;
      case "weeks2":
        this.dateRangeValues.start = I.add(I.startEnd("today", "start-week"), -2, "week"), this.dateRangeValues.end = I.add(I.startEnd("today", "start-week"), -1, "day");
        break;
      case "monthHalf":
        I.getDay("today") < 16 ? (this.dateRangeValues.start = I.add(I.add(I.startEnd("today", "start-month"), -1, "month"), 15, "day"), this.dateRangeValues.end = I.startEnd(this.dateRangeValues.start, "end-month")) : (this.dateRangeValues.start = I.startEnd("today", "start-month"), this.dateRangeValues.end = I.add(this.dateRangeValues.start, 14, "day"));
        break;
      case "other":
        this.dateRangeValues.start = I.add("today", -1, "day"), this.dateRangeValues.end = I.asDate("today");
        break;
    }
    this.dateRangeValues = I.getDateRange(this.dateRangeValues.start, this.dateRangeValues.end), this._periodStartDate = I.format(this.dateRangeValues.start, "D.M.", null), this.setValues(this.dateRangeValues, !0);
  }
  /**
   * Initialize the datepicker element.
   */
  initDatepicker() {
    this.$timeout(() => {
      const t = this.$element[0].querySelector(".input-daterange");
      if (!t) {
        this.setValues(this.model.$viewValue, !1);
        return;
      }
      const e = {
        fi: fu,
        en: aA,
        sv: iA
      }, a = L.getLanguage();
      this.datepicker = new IE(t, {
        locale: e?.[a] || fu,
        autoClose: !0,
        range: !0,
        toggleSelected: !1,
        onSelect: (n) => {
          this.changeDateEvent(n);
        }
      }), this.setValues(this.model.$viewValue, !0);
    }, 100);
  }
  /**
   * Method makes sure all the required values are set:
   * - datepicker component's selected range
   * - the whole date range object, containing the formatted date
   * - period start date for manual typing
   */
  setValues(t, e) {
    t.start && (e && this.datepicker.selectDate([t.start, t.end], { silent: !0 }), this.dateRangeValues = {
      ...t,
      formattedRange: I.getFormattedRange(t.start, t.end)
    }, this.model.$setViewValue(this.dateRangeValues), this._periodStartDate = I.format(this.dateRangeValues.start, "D.M.", null));
  }
  /**
   * Datepicker element change event method.
   * @param event Date values that are picked in the datepicker.
   */
  changeDateEvent(t) {
    const e = I.asDate(t.date[0]);
    let a = e;
    t.date[1] && (a = I.asDate(t.date[1]));
    const n = {
      start: e,
      end: a,
      daysCount: I.getWorkdays(e, a).length
    };
    this.setValues(n, !1), this.onChange();
  }
  /** Gets the readonly value either from the controller or from the form */
  getReadOnly() {
    const t = (this.readOnly + "").trim().toLowerCase();
    return t === "true" || t === "1" ? !0 : t === "false" || t === "0" ? !1 : !!this?.form?.$$element[0]?.attributes?.readonly;
  }
};
T$.$inject = ["$element", "$timeout"];
let Wm = T$;
const L$ = class L$ {
  constructor() {
  }
  /**
   * Checks the existence of name property.
   */
  $onInit() {
    if (!this.name)
      throw new Error(`Property 'name' is required for Salaxy form controls (label: ${this.label}).`);
    if (this.name && this.label == null && (this.label = this.name), this.required) {
      const t = this.required?.toLowerCase().trim();
      this.require = t === "true" || t === "1";
    }
  }
  /**
   * Gets the class (or classes space separated) for label or value element.
   */
  getLabelCols(t) {
    switch (t) {
      case "label":
        return this.labelCols || "col-sm-4";
      case "value": {
        let e = "";
        if (this.labelCols && this.labelCols.length >= 8) {
          const a = /col-(xs|sm|md|lg)-([1-9][1-2]?)/gm;
          let n = a.exec(this.labelCols);
          for (; n !== null; ) {
            n.index === a.lastIndex && a.lastIndex++;
            const i = parseInt(n[2], 10);
            i > 0 && i < 13 && (e += `col-${n[1]}-${12 - i} `), n = a.exec(this.labelCols);
          }
        }
        return e.trim() || "col-sm-8";
      }
      case "no-label":
        return this.labelCols || "col-sm-12";
    }
  }
  /** Gets the label type with "horizontal" as default / unknown value. */
  getLabelType() {
    switch (this.labelType) {
      case "no-label":
      case "plain":
      case "basic":
      case "empty-label":
      case "inline":
        return this.labelType;
      default:
        return "horizontal";
    }
  }
};
L$.$inject = [];
let Px = L$;
const D$ = class D$ extends Ia {
  /**
   * Creates a new InputController
   * @ignore
   */
  constructor() {
    super();
  }
  /** Set the values and defaults on init */
  $onInit() {
    this.maxlength || (this.maxlength = 1e5), this.minlength && (this.require = !0), this.required && (this.require = !0), super.$onInit();
  }
  /** On change of the value, do preventive operations and set value to model. */
  onChange() {
    this.value && this.maxlength && this.value.length > this.maxlength && (this.value = this.value.substring(0, this.maxlength)), super.onChange();
  }
};
D$.$inject = [];
let xi = D$;
const I$ = class I$ extends xi {
  /**
   * Creates a new InputAccountingTargetController
   * @ignore
   */
  constructor(t) {
    super(), this.accountingTargets = t;
  }
  /**
   * Query all available accountingTargets from index
   */
  queryAccountingTargets(t) {
    t = t ?? "";
    const e = {
      $search: t,
      $top: 50
    };
    return this.accountingTargets.getOData(e).then((a) => a.items);
  }
  /**
   * Get selected accounting target displayName
   * @param accountingTargetId selected accounting target id
   * @param refresher helper for refreshing view after
   * @returns accountingTargetDisplayName from otherPartyInfo.avatar.displayName
   */
  queryAccountingTargetDisplayName(t, e) {
    if (!t)
      return "";
    if (this._accountingTargetDisplayItem && this._accountingTargetDisplayItem.id === t)
      return this._accountingTargetDisplayItem.otherPartyInfo.avatar.displayName;
    this._accountingTargetDisplayItem = {
      id: t,
      otherPartyInfo: {
        avatar: {
          displayName: t
        }
      }
    };
    const a = {
      $filter: `id eq '${t}_AccountingTargetDto'`,
      $top: 50
    };
    return this.accountingTargets.getOData(a).then((n) => {
      this._accountingTargetDisplayItem = n.items.find((i) => i.id === t) ?? this._accountingTargetDisplayItem, e[0] = (/* @__PURE__ */ new Date()).getTime();
    }), this._accountingTargetDisplayItem.otherPartyInfo.avatar.displayName;
  }
};
I$.$inject = ["AccountingTargets"];
let Ex = I$;
const P$ = class P$ extends Ia {
  /**
   * Creates a new InputController
   * @ignore
   */
  constructor() {
    super();
  }
  /** Toggles boolean value. */
  toggle() {
    this.value = !this.value, this.onChange();
  }
};
P$.$inject = [];
let jm = P$;
const E$ = class E$ extends xi {
  /**
   * Creates a new InputCollectiveBargainAgreementController
   * @ignore
   */
  constructor() {
    super(), this.cbaCodes = [], this.getCbaCodes = (t) => {
      if (!t || t.length < 2)
        return this.cbaCodes.filter((a) => !this.hiddenCodes?.find((n) => n.toString() === a.value.toString()));
      let e = this.cbaCodes.filter((a) => a.text.toLowerCase().indexOf(t.toLowerCase()) >= 0);
      return this.hiddenCodes && (e = e.filter((a) => !this.hiddenCodes.find((n) => n.toString() === a.value.toString()))), e;
    }, this.getCbaLabel = (t) => this.cbaCodes.find((e) => e.value === t)?.text;
  }
  /** Sets the default values in init. */
  $onInit() {
    super.$onInit();
    const t = L.getLanguage();
    this.cbaCodes = WM.map((e) => {
      const a = t === "fi" ? e.labelFi : t === "en" ? e.labelEn : e.labelSv;
      return { value: e.code, text: a };
    });
  }
  /** Returns the placeholder text - this control has a default text. */
  getPlaceholder() {
    return super.getPlaceholder() || L.get("SALAXY.NG1.InputCollectiveBargainAgreement.getPlaceholder");
  }
  /**
   * Returns the HTML for the tooltip.
   * @returns HTML for the tooltip
   */
  getToolTipHtml() {
    return `<span>${L.get("SALAXY.NG1.WorkerWizardComponent.employment.info.cbaCodeInfo")}</span>`;
  }
};
E$.$inject = [];
let Vm = E$;
class rA extends xi {
  // TODO: tarpeeton?
  constructor() {
    super(), this.enumCache = [];
  }
  /** Sets the default values in init. */
  $onInit() {
    super.$onInit(), this.type || (this.type = "select"), this.hiddenOptions || (this.hiddenOptions = ["undefined"]), this.invalidEnums || (this.invalidEnums = ["unknown"]), this.remember && window.localStorage.getItem(this.remember + "." + this.name) && (this.value = this.getStoredValue(), super.onChange());
  }
  /** Options list */
  get options() {
    return this._options;
  }
  set options(t) {
    this._options = t;
  }
  /**
   * Gets the label for an enumeration.
   * @param value Type of the enum.
   */
  getEnumerationLabel(t) {
    const e = this.getEnumerations().find((a) => a.value === t);
    return e ? this.formatLabel(e) : null;
  }
  /** Returns true if the placeholder should be added to the options. */
  get showPlaceholder() {
    return (!this.value || this.value === "undefined" || this.value === "unknown") && !this.getEnumerations().find((t) => t.value === this.value);
  }
  /** Formats the label for display and typeahed searches. */
  formatLabel(t) {
    switch (this.labelFormat) {
      case "value":
        return t.value;
      case "text-value": {
        let e = t.text ? L.get(t.text) : t.text;
        return e = e || t.value, `${e}${t.value ? " (" + t.value + ")" : ""}`;
      }
      case "title":
        return L.get(t.title) ?? L.get(t.text);
      case "text":
      default:
        return L.get(t.text);
    }
  }
  /**
   * Returns items for current enumeration.
   */
  getEnumerations() {
    if (this.enumCache.length > 0 && !this.disableCache)
      return this.enumCache;
    let t = [];
    const e = this.value;
    if (this.options)
      Array.isArray(this.options) ? t = this.options.map((n) => n == null ? { value: null, text: "[null]" } : Qe.has(n, "value") || Qe.has(n, "text") ? {
        value: n.value,
        text: n.text,
        title: n.title && n.title !== n.value ? n.title : null,
        ui: n.ui ? n.ui : null
      } : { value: n, text: n }) : t = Object.keys(this.options).map((n) => ({ value: n, text: this.options[n], title: null }));
    else if (this.enum) {
      const n = He.getEnumMetadata(this.enum);
      n ? t = n.values.map((i) => ({ value: i.name, text: i.label, title: i.descr && i.descr !== i.name ? i.descr : null })) : t = [{
        value: "",
        text: `ERROR: ${this.enum} not found.`,
        title: null
      }];
    }
    this.hiddenOptions && (t = t.filter((n) => {
      const i = ie.assureArray(this.hiddenOptions).find((r) => r === n.value);
      return i == null || i === e;
    }));
    const a = ie.assureArray(this.filter);
    return a.length > 0 && (t = a.map((n) => t.find((i) => i.value === n)).filter((n) => n != null)), this.modifyOptions(t, this.enumCache), this.enumCache;
  }
  modifyOptions(t, e) {
    wt.equals(t, e) || (e.splice(0, e.length), e.push(...t));
  }
  /** Store selection to LocalStorage */
  setStoredValue(t, e) {
    if (this.remember && window.localStorage) {
      const a = this.remember + "." + t;
      window.localStorage.setItem(a, e);
    }
  }
  /** Get stored value from LocalStorage*/
  getStoredValue() {
    if (this.remember && window.localStorage) {
      const t = this.remember + "." + this.name;
      return window.localStorage.getItem(t);
    }
    return null;
  }
}
const N$ = class N$ extends rA {
  /**
   * Creates a new InputOccupationTypeController
   * @ignore
   */
  constructor(t, e) {
    super(), this.$scope = t, this.workflowService = e, this.credentials = [];
  }
  /** Options list */
  get options() {
    const t = this.workflowService.credentials || [];
    return wt.equals(this.credentials, t) || (this._options = t.map((e) => ({
      value: e.id,
      text: e.avatar.displayName
    }))), this._options;
  }
  set options(t) {
  }
};
N$.$inject = ["$scope", "WorkflowService"];
let qm = N$;
const R$ = class R$ extends Ia {
  /**
   * Creates a new InputController
   * @ignore
   */
  constructor() {
    super();
  }
  /** Set the values and defaults on init */
  $onInit() {
    this.name && !this.label && (this.label = this.name), this.model.$render = () => {
      this.value = this.model.$viewValue, this.setInnerValue(this.model.$viewValue);
    }, this.validate();
  }
  /** Called when the view changes the model. */
  onChange() {
    this.value = this.getInnerValue(), super.onChange();
  }
  /** Gets the inner value as string */
  getInnerValue() {
    if (!this.innerValue)
      return null;
    let t = "";
    return this.innerValue.days != null && !isNaN(this.innerValue.days) && (t += this.innerValue.days), this.innerValue.rest && (t != "" && (t += "."), t += this.innerValue.rest), t == "" ? null : (this.innerValue.isNegative && (t = "-" + t), t);
  }
  /** Parses an input string and sets the inner value based on it. */
  setInnerValue(t) {
    if (t = t?.trim(), !t) {
      this.innerValue = null;
      return;
    }
    this.innerValue = this.innerValue || {}, t[0] == "-" ? (this.innerValue.isNegative = !0, t = t.substring(1)) : this.innerValue.isNegative = !1;
    const e = t.indexOf(".");
    e >= 0 ? (this.innerValue.days = parseInt(t.substr(0, e)) || 0, this.innerValue.rest = t.substr(e + 1).trim()) : t.indexOf(":") >= 0 ? (this.innerValue.days = parseInt(t) || 0, this.innerValue.rest = null) : (this.innerValue.days = null, this.innerValue.rest = t.trim());
  }
};
R$.$inject = [];
let Km = R$;
const Y$ = class Y$ extends xi {
  /**
   * Creates a new InputIncomeTypeController
   * @ignore
   */
  constructor() {
    super(), this.getIncomeTypes = (t) => {
      Tn.getAll();
      let e = Tn.search(t);
      return this.hiddenCodes && (e = e.filter((a) => !this.hiddenCodes.includes(a.code))), e.map((a) => ({
        value: a.code,
        text: a.label,
        title: a.description,
        ui: {
          initials: a.code,
          color: "#2b507c",
          entityType: "company"
        }
      }));
    };
  }
  /** Sets the default values in init. */
  $onInit() {
    super.$onInit(), this.type || (this.type = "typehead");
  }
  /**
   * Returns the label for given income type.
   * @param code - Income type code.
   */
  getRowLabel(t) {
    if (!t)
      return null;
    const e = Tn.getAll().find((a) => a.code === Number(t));
    return e ? e.code + " - " + e.label : "SALAXY.NG1.InputIncomeType.getRowLabelNotFound" + t;
  }
  /** Returns the placeholder text - this control has a default text. */
  getPlaceholder() {
    return super.getPlaceholder() || L.get("SALAXY.NG1.InputIncomeType.getPlaceholder");
  }
};
Y$.$inject = ["SessionService", "UiHelpers"];
let Jm = Y$;
class PE extends Ia {
  /** Sets the default values in init. */
  $onInit() {
    super.$onInit();
  }
  /**
   * Gets or sets the string value that is used in the view.
   * For percent, this is multiplied by 100.
   */
  get viewValue() {
    let t = se.parseNumber(this.value);
    return t != null && this.unit === xv.Percent && (t = t * 100), this.negative && t && (t = t * -1), t == null ? null : se.toString(t).replace(".", ",");
  }
  set viewValue(t) {
    let e = se.parseNumber(t);
    e != null && this.unit === xv.Percent && (e = e / 100), this.negative && e && (e = e * -1), this.value = e, this.onChange();
  }
  /**
   * Gets an indicator string (1-2 characters) for the unit.
   */
  getUnitIndicator(t) {
    return Gi.getUnitIndicator(t ?? this.unit);
  }
  /**
   * Changes the unit and calls the onUnitChange function.
   * @param unit New unit.
   */
  changeUnit(t) {
    this.unit = t, this.onUnitChange && this.onUnitChange({ unit: t });
  }
}
const _$ = class _$ extends xi {
  /**
   * Creates a new InputOccupationTypeController
   * @ignore
   */
  constructor(t) {
    super(), this.sessionService = t, this.getOccupations = (e) => {
      let a;
      if (!e || e.length < 2) {
        const n = this.defaultList || (this.sessionService.isInSomeRole("household,worker") ? "household" : "company");
        a = dc.getByIds(n);
      } else
        a = dc.search(e);
      return a.map((n) => ({
        value: n.id,
        text: n.label,
        object: n
      }));
    };
  }
  /** Sets the default values in init. */
  $onInit() {
    super.$onInit();
  }
  /**
   * Returns the label for given occupation id.
   * @param occupationId - Id of the occupation.
   */
  getOccupationLabel(t) {
    for (const e of dc.getAll(null))
      if (t === e.id)
        return e.label;
    return t;
  }
  /** Returns the placeholder text - this control has a default text. */
  getPlaceholder() {
    return super.getPlaceholder() || L.get("SALAXY.NG1.InputOccupationType.getPlaceholder");
  }
};
_$.$inject = ["SessionService"];
let Nx = _$;
var Rx = [
  "MO",
  "TU",
  "WE",
  "TH",
  "FR",
  "SA",
  "SU"
], ns = (
  /** @class */
  function() {
    function s(t, e) {
      if (e === 0)
        throw new Error("Can't create weekday with n == 0");
      this.weekday = t, this.n = e;
    }
    return s.fromStr = function(t) {
      return new s(Rx.indexOf(t));
    }, s.prototype.nth = function(t) {
      return this.n === t ? this : new s(this.weekday, t);
    }, s.prototype.equals = function(t) {
      return this.weekday === t.weekday && this.n === t.n;
    }, s.prototype.toString = function() {
      var t = Rx[this.weekday];
      return this.n && (t = (this.n > 0 ? "+" : "") + String(this.n) + t), t;
    }, s.prototype.getJsWeekday = function() {
      return this.weekday === 6 ? 0 : this.weekday + 1;
    }, s;
  }()
), fn = function(s) {
  return s != null;
}, Ei = function(s) {
  return typeof s == "number";
}, KD = function(s) {
  return typeof s == "string" && Rx.includes(s);
}, Ys = Array.isArray, Ji = function(s, t) {
  t === void 0 && (t = s), arguments.length === 1 && (t = s, s = 0);
  for (var e = [], a = s; a < t; a++)
    e.push(a);
  return e;
}, ha = function(s, t) {
  var e = 0, a = [];
  if (Ys(s))
    for (; e < t; e++)
      a[e] = [].concat(s);
  else
    for (; e < t; e++)
      a[e] = s;
  return a;
}, hW = function(s) {
  return Ys(s) ? s : [s];
};
function Go(s, t, e) {
  e === void 0 && (e = " ");
  var a = String(s);
  return t = t >> 0, a.length > t ? String(a) : (t = t - a.length, t > e.length && (e += ha(e, t / e.length)), e.slice(0, t) + String(a));
}
var mW = function(s, t, e) {
  var a = s.split(t);
  return e ? a.slice(0, e).concat([a.slice(e).join(t)]) : a;
}, Qs = function(s, t) {
  var e = s % t;
  return e * t < 0 ? e + t : e;
}, Zb = function(s, t) {
  return { div: Math.floor(s / t), mod: Qs(s, t) };
}, Yi = function(s) {
  return !fn(s) || s.length === 0;
}, Nn = function(s) {
  return !Yi(s);
}, Na = function(s, t) {
  return Nn(s) && s.indexOf(t) !== -1;
}, ql = function(s, t, e, a, n, i) {
  return a === void 0 && (a = 0), n === void 0 && (n = 0), i === void 0 && (i = 0), new Date(Date.UTC(s, t - 1, e, a, n, i));
}, gW = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], EE = 1e3 * 60 * 60 * 24, NE = 9999, RE = ql(1970, 1, 1), yW = [6, 0, 1, 2, 3, 4, 5], qd = function(s) {
  return s % 4 === 0 && s % 100 !== 0 || s % 400 === 0;
}, YE = function(s) {
  return s instanceof Date;
}, _d = function(s) {
  return YE(s) && !isNaN(s.getTime());
}, fW = function(s, t) {
  var e = s.getTime(), a = t.getTime(), n = e - a;
  return Math.round(n / EE);
}, Yx = function(s) {
  return fW(s, RE);
}, _E = function(s) {
  return new Date(RE.getTime() + s * EE);
}, bW = function(s) {
  var t = s.getUTCMonth();
  return t === 1 && qd(s.getUTCFullYear()) ? 29 : gW[t];
}, $c = function(s) {
  return yW[s.getUTCDay()];
}, JD = function(s, t) {
  var e = ql(s, t + 1, 1);
  return [$c(e), bW(e)];
}, OE = function(s, t) {
  return t = t || s, new Date(Date.UTC(s.getUTCFullYear(), s.getUTCMonth(), s.getUTCDate(), t.getHours(), t.getMinutes(), t.getSeconds(), t.getMilliseconds()));
}, _x = function(s) {
  var t = new Date(s.getTime());
  return t;
}, QD = function(s) {
  for (var t = [], e = 0; e < s.length; e++)
    t.push(_x(s[e]));
  return t;
}, vu = function(s) {
  s.sort(function(t, e) {
    return t.getTime() - e.getTime();
  });
}, lA = function(s, t) {
  t === void 0 && (t = !0);
  var e = new Date(s);
  return [
    Go(e.getUTCFullYear().toString(), 4, "0"),
    Go(e.getUTCMonth() + 1, 2, "0"),
    Go(e.getUTCDate(), 2, "0"),
    "T",
    Go(e.getUTCHours(), 2, "0"),
    Go(e.getUTCMinutes(), 2, "0"),
    Go(e.getUTCSeconds(), 2, "0"),
    t ? "Z" : ""
  ].join("");
}, oA = function(s) {
  var t = /^(\d{4})(\d{2})(\d{2})(T(\d{2})(\d{2})(\d{2})Z?)?$/, e = t.exec(s);
  if (!e)
    throw new Error("Invalid UNTIL value: ".concat(s));
  return new Date(Date.UTC(parseInt(e[1], 10), parseInt(e[2], 10) - 1, parseInt(e[3], 10), parseInt(e[5], 10) || 0, parseInt(e[6], 10) || 0, parseInt(e[7], 10) || 0));
}, ZD = function(s, t) {
  var e = s.toLocaleString("sv-SE", { timeZone: t });
  return e.replace(" ", "T") + "Z";
}, vW = function(s, t) {
  var e = Intl.DateTimeFormat().resolvedOptions().timeZone, a = new Date(ZD(s, e)), n = new Date(ZD(s, t ?? "UTC")), i = n.getTime() - a.getTime();
  return new Date(s.getTime() - i);
}, ec = (
  /** @class */
  function() {
    function s(t, e) {
      this.minDate = null, this.maxDate = null, this._result = [], this.total = 0, this.method = t, this.args = e, t === "between" ? (this.maxDate = e.inc ? e.before : new Date(e.before.getTime() - 1), this.minDate = e.inc ? e.after : new Date(e.after.getTime() + 1)) : t === "before" ? this.maxDate = e.inc ? e.dt : new Date(e.dt.getTime() - 1) : t === "after" && (this.minDate = e.inc ? e.dt : new Date(e.dt.getTime() + 1));
    }
    return s.prototype.accept = function(t) {
      ++this.total;
      var e = this.minDate && t < this.minDate, a = this.maxDate && t > this.maxDate;
      if (this.method === "between") {
        if (e)
          return !0;
        if (a)
          return !1;
      } else if (this.method === "before") {
        if (a)
          return !1;
      } else if (this.method === "after")
        return e ? !0 : (this.add(t), !1);
      return this.add(t);
    }, s.prototype.add = function(t) {
      return this._result.push(t), !0;
    }, s.prototype.getValue = function() {
      var t = this._result;
      switch (this.method) {
        case "all":
        case "between":
          return t;
        case "before":
        case "after":
        default:
          return t.length ? t[t.length - 1] : null;
      }
    }, s.prototype.clone = function() {
      return new s(this.method, this.args);
    }, s;
  }()
), Ox = function(s, t) {
  return Ox = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, a) {
    e.__proto__ = a;
  } || function(e, a) {
    for (var n in a)
      Object.prototype.hasOwnProperty.call(a, n) && (e[n] = a[n]);
  }, Ox(s, t);
};
function cA(s, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  Ox(s, t);
  function e() {
    this.constructor = s;
  }
  s.prototype = t === null ? Object.create(t) : (e.prototype = t.prototype, new e());
}
var Os = function() {
  return Os = Object.assign || function(t) {
    for (var e, a = 1, n = arguments.length; a < n; a++) {
      e = arguments[a];
      for (var i in e)
        Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }
    return t;
  }, Os.apply(this, arguments);
};
function be(s, t, e) {
  if (e || arguments.length === 2)
    for (var a = 0, n = t.length, i; a < n; a++)
      (i || !(a in t)) && (i || (i = Array.prototype.slice.call(t, 0, a)), i[a] = t[a]);
  return s.concat(i || Array.prototype.slice.call(t));
}
var tI = (
  /** @class */
  function(s) {
    cA(t, s);
    function t(e, a, n) {
      var i = s.call(this, e, a) || this;
      return i.iterator = n, i;
    }
    return t.prototype.add = function(e) {
      return this.iterator(e, this._result.length) ? (this._result.push(e), !0) : !1;
    }, t;
  }(ec)
), Qm = {
  dayNames: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ],
  monthNames: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ],
  tokens: {
    SKIP: /^[ \r\n\t]+|^\.$/,
    number: /^[1-9][0-9]*/,
    numberAsText: /^(one|two|three)/i,
    every: /^every/i,
    "day(s)": /^days?/i,
    "weekday(s)": /^weekdays?/i,
    "week(s)": /^weeks?/i,
    "hour(s)": /^hours?/i,
    "minute(s)": /^minutes?/i,
    "month(s)": /^months?/i,
    "year(s)": /^years?/i,
    on: /^(on|in)/i,
    at: /^(at)/i,
    the: /^the/i,
    first: /^first/i,
    second: /^second/i,
    third: /^third/i,
    nth: /^([1-9][0-9]*)(\.|th|nd|rd|st)/i,
    last: /^last/i,
    for: /^for/i,
    "time(s)": /^times?/i,
    until: /^(un)?til/i,
    monday: /^mo(n(day)?)?/i,
    tuesday: /^tu(e(s(day)?)?)?/i,
    wednesday: /^we(d(n(esday)?)?)?/i,
    thursday: /^th(u(r(sday)?)?)?/i,
    friday: /^fr(i(day)?)?/i,
    saturday: /^sa(t(urday)?)?/i,
    sunday: /^su(n(day)?)?/i,
    january: /^jan(uary)?/i,
    february: /^feb(ruary)?/i,
    march: /^mar(ch)?/i,
    april: /^apr(il)?/i,
    may: /^may/i,
    june: /^june?/i,
    july: /^july?/i,
    august: /^aug(ust)?/i,
    september: /^sep(t(ember)?)?/i,
    october: /^oct(ober)?/i,
    november: /^nov(ember)?/i,
    december: /^dec(ember)?/i,
    comma: /^(,\s*|(and|or)\s*)+/i
  }
}, eI = function(s, t) {
  return s.indexOf(t) !== -1;
}, xW = function(s) {
  return s.toString();
}, wW = function(s, t, e) {
  return "".concat(t, " ").concat(e, ", ").concat(s);
}, Sr = (
  /** @class */
  function() {
    function s(t, e, a, n) {
      if (e === void 0 && (e = xW), a === void 0 && (a = Qm), n === void 0 && (n = wW), this.text = [], this.language = a || Qm, this.gettext = e, this.dateFormatter = n, this.rrule = t, this.options = t.options, this.origOptions = t.origOptions, this.origOptions.bymonthday) {
        var i = [].concat(this.options.bymonthday), r = [].concat(this.options.bynmonthday);
        i.sort(function(d, p) {
          return d - p;
        }), r.sort(function(d, p) {
          return p - d;
        }), this.bymonthday = i.concat(r), this.bymonthday.length || (this.bymonthday = null);
      }
      if (fn(this.origOptions.byweekday)) {
        var l = Ys(this.origOptions.byweekday) ? this.origOptions.byweekday : [this.origOptions.byweekday], o = String(l);
        this.byweekday = {
          allWeeks: l.filter(function(d) {
            return !d.n;
          }),
          someWeeks: l.filter(function(d) {
            return !!d.n;
          }),
          isWeekdays: o.indexOf("MO") !== -1 && o.indexOf("TU") !== -1 && o.indexOf("WE") !== -1 && o.indexOf("TH") !== -1 && o.indexOf("FR") !== -1 && o.indexOf("SA") === -1 && o.indexOf("SU") === -1,
          isEveryDay: o.indexOf("MO") !== -1 && o.indexOf("TU") !== -1 && o.indexOf("WE") !== -1 && o.indexOf("TH") !== -1 && o.indexOf("FR") !== -1 && o.indexOf("SA") !== -1 && o.indexOf("SU") !== -1
        };
        var c = function(d, p) {
          return d.weekday - p.weekday;
        };
        this.byweekday.allWeeks.sort(c), this.byweekday.someWeeks.sort(c), this.byweekday.allWeeks.length || (this.byweekday.allWeeks = null), this.byweekday.someWeeks.length || (this.byweekday.someWeeks = null);
      } else
        this.byweekday = null;
    }
    return s.isFullyConvertible = function(t) {
      var e = !0;
      if (!(t.options.freq in s.IMPLEMENTED) || t.origOptions.until && t.origOptions.count)
        return !1;
      for (var a in t.origOptions) {
        if (eI(["dtstart", "tzid", "wkst", "freq"], a))
          return !0;
        if (!eI(s.IMPLEMENTED[t.options.freq], a))
          return !1;
      }
      return e;
    }, s.prototype.isFullyConvertible = function() {
      return s.isFullyConvertible(this.rrule);
    }, s.prototype.toString = function() {
      var t = this.gettext;
      if (!(this.options.freq in s.IMPLEMENTED))
        return t("RRule error: Unable to fully convert this rrule to text");
      if (this.text = [t("every")], this[Ue.FREQUENCIES[this.options.freq]](), this.options.until) {
        this.add(t("until"));
        var e = this.options.until;
        this.add(this.dateFormatter(e.getUTCFullYear(), this.language.monthNames[e.getUTCMonth()], e.getUTCDate()));
      } else
        this.options.count && this.add(t("for")).add(this.options.count.toString()).add(this.plural(this.options.count) ? t("times") : t("time"));
      return this.isFullyConvertible() || this.add(t("(~ approximate)")), this.text.join("");
    }, s.prototype.HOURLY = function() {
      var t = this.gettext;
      this.options.interval !== 1 && this.add(this.options.interval.toString()), this.add(this.plural(this.options.interval) ? t("hours") : t("hour"));
    }, s.prototype.MINUTELY = function() {
      var t = this.gettext;
      this.options.interval !== 1 && this.add(this.options.interval.toString()), this.add(this.plural(this.options.interval) ? t("minutes") : t("minute"));
    }, s.prototype.DAILY = function() {
      var t = this.gettext;
      this.options.interval !== 1 && this.add(this.options.interval.toString()), this.byweekday && this.byweekday.isWeekdays ? this.add(this.plural(this.options.interval) ? t("weekdays") : t("weekday")) : this.add(this.plural(this.options.interval) ? t("days") : t("day")), this.origOptions.bymonth && (this.add(t("in")), this._bymonth()), this.bymonthday ? this._bymonthday() : this.byweekday ? this._byweekday() : this.origOptions.byhour && this._byhour();
    }, s.prototype.WEEKLY = function() {
      var t = this.gettext;
      this.options.interval !== 1 && this.add(this.options.interval.toString()).add(this.plural(this.options.interval) ? t("weeks") : t("week")), this.byweekday && this.byweekday.isWeekdays ? this.options.interval === 1 ? this.add(this.plural(this.options.interval) ? t("weekdays") : t("weekday")) : this.add(t("on")).add(t("weekdays")) : this.byweekday && this.byweekday.isEveryDay ? this.add(this.plural(this.options.interval) ? t("days") : t("day")) : (this.options.interval === 1 && this.add(t("week")), this.origOptions.bymonth && (this.add(t("in")), this._bymonth()), this.bymonthday ? this._bymonthday() : this.byweekday && this._byweekday(), this.origOptions.byhour && this._byhour());
    }, s.prototype.MONTHLY = function() {
      var t = this.gettext;
      this.origOptions.bymonth ? (this.options.interval !== 1 && (this.add(this.options.interval.toString()).add(t("months")), this.plural(this.options.interval) && this.add(t("in"))), this._bymonth()) : (this.options.interval !== 1 && this.add(this.options.interval.toString()), this.add(this.plural(this.options.interval) ? t("months") : t("month"))), this.bymonthday ? this._bymonthday() : this.byweekday && this.byweekday.isWeekdays ? this.add(t("on")).add(t("weekdays")) : this.byweekday && this._byweekday();
    }, s.prototype.YEARLY = function() {
      var t = this.gettext;
      this.origOptions.bymonth ? (this.options.interval !== 1 && (this.add(this.options.interval.toString()), this.add(t("years"))), this._bymonth()) : (this.options.interval !== 1 && this.add(this.options.interval.toString()), this.add(this.plural(this.options.interval) ? t("years") : t("year"))), this.bymonthday ? this._bymonthday() : this.byweekday && this._byweekday(), this.options.byyearday && this.add(t("on the")).add(this.list(this.options.byyearday, this.nth, t("and"))).add(t("day")), this.options.byweekno && this.add(t("in")).add(this.plural(this.options.byweekno.length) ? t("weeks") : t("week")).add(this.list(this.options.byweekno, void 0, t("and")));
    }, s.prototype._bymonthday = function() {
      var t = this.gettext;
      this.byweekday && this.byweekday.allWeeks ? this.add(t("on")).add(this.list(this.byweekday.allWeeks, this.weekdaytext, t("or"))).add(t("the")).add(this.list(this.bymonthday, this.nth, t("or"))) : this.add(t("on the")).add(this.list(this.bymonthday, this.nth, t("and")));
    }, s.prototype._byweekday = function() {
      var t = this.gettext;
      this.byweekday.allWeeks && !this.byweekday.isWeekdays && this.add(t("on")).add(this.list(this.byweekday.allWeeks, this.weekdaytext)), this.byweekday.someWeeks && (this.byweekday.allWeeks && this.add(t("and")), this.add(t("on the")).add(this.list(this.byweekday.someWeeks, this.weekdaytext, t("and"))));
    }, s.prototype._byhour = function() {
      var t = this.gettext;
      this.add(t("at")).add(this.list(this.origOptions.byhour, void 0, t("and")));
    }, s.prototype._bymonth = function() {
      this.add(this.list(this.options.bymonth, this.monthtext, this.gettext("and")));
    }, s.prototype.nth = function(t) {
      t = parseInt(t.toString(), 10);
      var e, a = this.gettext;
      if (t === -1)
        return a("last");
      var n = Math.abs(t);
      switch (n) {
        case 1:
        case 21:
        case 31:
          e = n + a("st");
          break;
        case 2:
        case 22:
          e = n + a("nd");
          break;
        case 3:
        case 23:
          e = n + a("rd");
          break;
        default:
          e = n + a("th");
      }
      return t < 0 ? e + " " + a("last") : e;
    }, s.prototype.monthtext = function(t) {
      return this.language.monthNames[t - 1];
    }, s.prototype.weekdaytext = function(t) {
      var e = Ei(t) ? (t + 1) % 7 : t.getJsWeekday();
      return (t.n ? this.nth(t.n) + " " : "") + this.language.dayNames[e];
    }, s.prototype.plural = function(t) {
      return t % 100 !== 1;
    }, s.prototype.add = function(t) {
      return this.text.push(" "), this.text.push(t), this;
    }, s.prototype.list = function(t, e, a, n) {
      var i = this;
      n === void 0 && (n = ","), Ys(t) || (t = [t]);
      var r = function(o, c, d) {
        for (var p = "", h = 0; h < o.length; h++)
          h !== 0 && (h === o.length - 1 ? p += " " + d + " " : p += c + " "), p += o[h];
        return p;
      };
      e = e || function(o) {
        return o.toString();
      };
      var l = function(o) {
        return e && e.call(i, o);
      };
      return a ? r(t.map(l), n, a) : t.map(l).join(n + " ");
    }, s;
  }()
), AW = (
  /** @class */
  function() {
    function s(t) {
      this.done = !0, this.rules = t;
    }
    return s.prototype.start = function(t) {
      return this.text = t, this.done = !1, this.nextSymbol();
    }, s.prototype.isDone = function() {
      return this.done && this.symbol === null;
    }, s.prototype.nextSymbol = function() {
      var t, e;
      this.symbol = null, this.value = null;
      do {
        if (this.done)
          return !1;
        var a = void 0;
        t = null;
        for (var n in this.rules) {
          a = this.rules[n];
          var i = a.exec(this.text);
          i && (t === null || i[0].length > t[0].length) && (t = i, e = n);
        }
        if (t != null && (this.text = this.text.substr(t[0].length), this.text === "" && (this.done = !0)), t == null) {
          this.done = !0, this.symbol = null, this.value = null;
          return;
        }
      } while (e === "SKIP");
      return this.symbol = e, this.value = t, !0;
    }, s.prototype.accept = function(t) {
      if (this.symbol === t) {
        if (this.value) {
          var e = this.value;
          return this.nextSymbol(), e;
        }
        return this.nextSymbol(), !0;
      }
      return !1;
    }, s.prototype.acceptNumber = function() {
      return this.accept("number");
    }, s.prototype.expect = function(t) {
      if (this.accept(t))
        return !0;
      throw new Error("expected " + t + " but found " + this.symbol);
    }, s;
  }()
);
function ME(s, t) {
  t === void 0 && (t = Qm);
  var e = {}, a = new AW(t.tokens);
  if (!a.start(s))
    return null;
  return n(), e;
  function n() {
    a.expect("every");
    var h = a.acceptNumber();
    if (h && (e.interval = parseInt(h[0], 10)), a.isDone())
      throw new Error("Unexpected end");
    switch (a.symbol) {
      case "day(s)":
        e.freq = Ue.DAILY, a.nextSymbol() && (r(), p());
        break;
      case "weekday(s)":
        e.freq = Ue.WEEKLY, e.byweekday = [Ue.MO, Ue.TU, Ue.WE, Ue.TH, Ue.FR], a.nextSymbol(), r(), p();
        break;
      case "week(s)":
        e.freq = Ue.WEEKLY, a.nextSymbol() && (i(), r(), p());
        break;
      case "hour(s)":
        e.freq = Ue.HOURLY, a.nextSymbol() && (i(), p());
        break;
      case "minute(s)":
        e.freq = Ue.MINUTELY, a.nextSymbol() && (i(), p());
        break;
      case "month(s)":
        e.freq = Ue.MONTHLY, a.nextSymbol() && (i(), p());
        break;
      case "year(s)":
        e.freq = Ue.YEARLY, a.nextSymbol() && (i(), p());
        break;
      case "monday":
      case "tuesday":
      case "wednesday":
      case "thursday":
      case "friday":
      case "saturday":
      case "sunday":
        e.freq = Ue.WEEKLY;
        var g = a.symbol.substr(0, 2).toUpperCase();
        if (e.byweekday = [Ue[g]], !a.nextSymbol())
          return;
        for (; a.accept("comma"); ) {
          if (a.isDone())
            throw new Error("Unexpected end");
          var x = o();
          if (!x)
            throw new Error("Unexpected symbol " + a.symbol + ", expected weekday");
          e.byweekday.push(Ue[x]), a.nextSymbol();
        }
        r(), d(), p();
        break;
      case "january":
      case "february":
      case "march":
      case "april":
      case "may":
      case "june":
      case "july":
      case "august":
      case "september":
      case "october":
      case "november":
      case "december":
        if (e.freq = Ue.YEARLY, e.bymonth = [l()], !a.nextSymbol())
          return;
        for (; a.accept("comma"); ) {
          if (a.isDone())
            throw new Error("Unexpected end");
          var b = l();
          if (!b)
            throw new Error("Unexpected symbol " + a.symbol + ", expected month");
          e.bymonth.push(b), a.nextSymbol();
        }
        i(), p();
        break;
      default:
        throw new Error("Unknown symbol");
    }
  }
  function i() {
    var h = a.accept("on"), g = a.accept("the");
    if (h || g)
      do {
        var x = c(), b = o(), A = l();
        if (x)
          b ? (a.nextSymbol(), e.byweekday || (e.byweekday = []), e.byweekday.push(Ue[b].nth(x))) : (e.bymonthday || (e.bymonthday = []), e.bymonthday.push(x), a.accept("day(s)"));
        else if (b)
          a.nextSymbol(), e.byweekday || (e.byweekday = []), e.byweekday.push(Ue[b]);
        else if (a.symbol === "weekday(s)")
          a.nextSymbol(), e.byweekday || (e.byweekday = [Ue.MO, Ue.TU, Ue.WE, Ue.TH, Ue.FR]);
        else if (a.symbol === "week(s)") {
          a.nextSymbol();
          var T = a.acceptNumber();
          if (!T)
            throw new Error("Unexpected symbol " + a.symbol + ", expected week number");
          for (e.byweekno = [parseInt(T[0], 10)]; a.accept("comma"); ) {
            if (T = a.acceptNumber(), !T)
              throw new Error("Unexpected symbol " + a.symbol + "; expected monthday");
            e.byweekno.push(parseInt(T[0], 10));
          }
        } else if (A)
          a.nextSymbol(), e.bymonth || (e.bymonth = []), e.bymonth.push(A);
        else
          return;
      } while (a.accept("comma") || a.accept("the") || a.accept("on"));
  }
  function r() {
    var h = a.accept("at");
    if (h)
      do {
        var g = a.acceptNumber();
        if (!g)
          throw new Error("Unexpected symbol " + a.symbol + ", expected hour");
        for (e.byhour = [parseInt(g[0], 10)]; a.accept("comma"); ) {
          if (g = a.acceptNumber(), !g)
            throw new Error("Unexpected symbol " + a.symbol + "; expected hour");
          e.byhour.push(parseInt(g[0], 10));
        }
      } while (a.accept("comma") || a.accept("at"));
  }
  function l() {
    switch (a.symbol) {
      case "january":
        return 1;
      case "february":
        return 2;
      case "march":
        return 3;
      case "april":
        return 4;
      case "may":
        return 5;
      case "june":
        return 6;
      case "july":
        return 7;
      case "august":
        return 8;
      case "september":
        return 9;
      case "october":
        return 10;
      case "november":
        return 11;
      case "december":
        return 12;
      default:
        return !1;
    }
  }
  function o() {
    switch (a.symbol) {
      case "monday":
      case "tuesday":
      case "wednesday":
      case "thursday":
      case "friday":
      case "saturday":
      case "sunday":
        return a.symbol.substr(0, 2).toUpperCase();
      default:
        return !1;
    }
  }
  function c() {
    switch (a.symbol) {
      case "last":
        return a.nextSymbol(), -1;
      case "first":
        return a.nextSymbol(), 1;
      case "second":
        return a.nextSymbol(), a.accept("last") ? -2 : 2;
      case "third":
        return a.nextSymbol(), a.accept("last") ? -3 : 3;
      case "nth":
        var h = parseInt(a.value[1], 10);
        if (h < -366 || h > 366)
          throw new Error("Nth out of range: " + h);
        return a.nextSymbol(), a.accept("last") ? -h : h;
      default:
        return !1;
    }
  }
  function d() {
    a.accept("on"), a.accept("the");
    var h = c();
    if (h)
      for (e.bymonthday = [h], a.nextSymbol(); a.accept("comma"); ) {
        if (h = c(), !h)
          throw new Error("Unexpected symbol " + a.symbol + "; expected monthday");
        e.bymonthday.push(h), a.nextSymbol();
      }
  }
  function p() {
    if (a.symbol === "until") {
      var h = Date.parse(a.text);
      if (!h)
        throw new Error("Cannot parse until date:" + a.text);
      e.until = new Date(h);
    } else
      a.accept("for") && (e.count = parseInt(a.value[0], 10), a.expect("number"));
  }
}
var ga;
(function(s) {
  s[s.YEARLY = 0] = "YEARLY", s[s.MONTHLY = 1] = "MONTHLY", s[s.WEEKLY = 2] = "WEEKLY", s[s.DAILY = 3] = "DAILY", s[s.HOURLY = 4] = "HOURLY", s[s.MINUTELY = 5] = "MINUTELY", s[s.SECONDLY = 6] = "SECONDLY";
})(ga || (ga = {}));
function dA(s) {
  return s < ga.HOURLY;
}
var CW = function(s, t) {
  return t === void 0 && (t = Qm), new Ue(ME(s, t) || void 0);
}, Gc = [
  "count",
  "until",
  "interval",
  "byweekday",
  "bymonthday",
  "bymonth"
];
Sr.IMPLEMENTED = [];
Sr.IMPLEMENTED[ga.HOURLY] = Gc;
Sr.IMPLEMENTED[ga.MINUTELY] = Gc;
Sr.IMPLEMENTED[ga.DAILY] = ["byhour"].concat(Gc);
Sr.IMPLEMENTED[ga.WEEKLY] = Gc;
Sr.IMPLEMENTED[ga.MONTHLY] = Gc;
Sr.IMPLEMENTED[ga.YEARLY] = ["byweekno", "byyearday"].concat(Gc);
var $W = function(s, t, e, a) {
  return new Sr(s, t, e, a).toString();
}, SW = Sr.isFullyConvertible, Zm = (
  /** @class */
  function() {
    function s(t, e, a, n) {
      this.hour = t, this.minute = e, this.second = a, this.millisecond = n || 0;
    }
    return s.prototype.getHours = function() {
      return this.hour;
    }, s.prototype.getMinutes = function() {
      return this.minute;
    }, s.prototype.getSeconds = function() {
      return this.second;
    }, s.prototype.getMilliseconds = function() {
      return this.millisecond;
    }, s.prototype.getTime = function() {
      return (this.hour * 60 * 60 + this.minute * 60 + this.second) * 1e3 + this.millisecond;
    }, s;
  }()
), kW = (
  /** @class */
  function(s) {
    cA(t, s);
    function t(e, a, n, i, r, l, o) {
      var c = s.call(this, i, r, l, o) || this;
      return c.year = e, c.month = a, c.day = n, c;
    }
    return t.fromDate = function(e) {
      return new this(e.getUTCFullYear(), e.getUTCMonth() + 1, e.getUTCDate(), e.getUTCHours(), e.getUTCMinutes(), e.getUTCSeconds(), e.valueOf() % 1e3);
    }, t.prototype.getWeekday = function() {
      return $c(new Date(this.getTime()));
    }, t.prototype.getTime = function() {
      return new Date(Date.UTC(this.year, this.month - 1, this.day, this.hour, this.minute, this.second, this.millisecond)).getTime();
    }, t.prototype.getDay = function() {
      return this.day;
    }, t.prototype.getMonth = function() {
      return this.month;
    }, t.prototype.getYear = function() {
      return this.year;
    }, t.prototype.addYears = function(e) {
      this.year += e;
    }, t.prototype.addMonths = function(e) {
      if (this.month += e, this.month > 12) {
        var a = Math.floor(this.month / 12), n = Qs(this.month, 12);
        this.month = n, this.year += a, this.month === 0 && (this.month = 12, --this.year);
      }
    }, t.prototype.addWeekly = function(e, a) {
      a > this.getWeekday() ? this.day += -(this.getWeekday() + 1 + (6 - a)) + e * 7 : this.day += -(this.getWeekday() - a) + e * 7, this.fixDay();
    }, t.prototype.addDaily = function(e) {
      this.day += e, this.fixDay();
    }, t.prototype.addHours = function(e, a, n) {
      for (a && (this.hour += Math.floor((23 - this.hour) / e) * e); ; ) {
        this.hour += e;
        var i = Zb(this.hour, 24), r = i.div, l = i.mod;
        if (r && (this.hour = l, this.addDaily(r)), Yi(n) || Na(n, this.hour))
          break;
      }
    }, t.prototype.addMinutes = function(e, a, n, i) {
      for (a && (this.minute += Math.floor((1439 - (this.hour * 60 + this.minute)) / e) * e); ; ) {
        this.minute += e;
        var r = Zb(this.minute, 60), l = r.div, o = r.mod;
        if (l && (this.minute = o, this.addHours(l, !1, n)), (Yi(n) || Na(n, this.hour)) && (Yi(i) || Na(i, this.minute)))
          break;
      }
    }, t.prototype.addSeconds = function(e, a, n, i, r) {
      for (a && (this.second += Math.floor((86399 - (this.hour * 3600 + this.minute * 60 + this.second)) / e) * e); ; ) {
        this.second += e;
        var l = Zb(this.second, 60), o = l.div, c = l.mod;
        if (o && (this.second = c, this.addMinutes(o, !1, n, i)), (Yi(n) || Na(n, this.hour)) && (Yi(i) || Na(i, this.minute)) && (Yi(r) || Na(r, this.second)))
          break;
      }
    }, t.prototype.fixDay = function() {
      if (!(this.day <= 28)) {
        var e = JD(this.year, this.month - 1)[1];
        if (!(this.day <= e))
          for (; this.day > e; ) {
            if (this.day -= e, ++this.month, this.month === 13 && (this.month = 1, ++this.year, this.year > NE))
              return;
            e = JD(this.year, this.month - 1)[1];
          }
      }
    }, t.prototype.add = function(e, a) {
      var n = e.freq, i = e.interval, r = e.wkst, l = e.byhour, o = e.byminute, c = e.bysecond;
      switch (n) {
        case ga.YEARLY:
          return this.addYears(i);
        case ga.MONTHLY:
          return this.addMonths(i);
        case ga.WEEKLY:
          return this.addWeekly(i, r);
        case ga.DAILY:
          return this.addDaily(i);
        case ga.HOURLY:
          return this.addHours(i, a, l);
        case ga.MINUTELY:
          return this.addMinutes(i, a, l, o);
        case ga.SECONDLY:
          return this.addSeconds(i, a, l, o, c);
      }
    }, t;
  }(Zm)
);
function XE(s) {
  for (var t = [], e = Object.keys(s), a = 0, n = e; a < n.length; a++) {
    var i = n[a];
    Na(aj, i) || t.push(i), YE(s[i]) && !_d(s[i]) && t.push(i);
  }
  if (t.length)
    throw new Error("Invalid options: " + t.join(", "));
  return Os({}, s);
}
function TW(s) {
  var t = Os(Os({}, uA), XE(s));
  if (fn(t.byeaster) && (t.freq = Ue.YEARLY), !(fn(t.freq) && Ue.FREQUENCIES[t.freq]))
    throw new Error("Invalid frequency: ".concat(t.freq, " ").concat(s.freq));
  if (t.dtstart || (t.dtstart = new Date((/* @__PURE__ */ new Date()).setMilliseconds(0))), fn(t.wkst) ? Ei(t.wkst) || (t.wkst = t.wkst.weekday) : t.wkst = Ue.MO.weekday, fn(t.bysetpos)) {
    Ei(t.bysetpos) && (t.bysetpos = [t.bysetpos]);
    for (var e = 0; e < t.bysetpos.length; e++) {
      var a = t.bysetpos[e];
      if (a === 0 || !(a >= -366 && a <= 366))
        throw new Error("bysetpos must be between 1 and 366, or between -366 and -1");
    }
  }
  if (!(t.byweekno || Nn(t.byweekno) || Nn(t.byyearday) || t.bymonthday || Nn(t.bymonthday) || fn(t.byweekday) || fn(t.byeaster)))
    switch (t.freq) {
      case Ue.YEARLY:
        t.bymonth || (t.bymonth = t.dtstart.getUTCMonth() + 1), t.bymonthday = t.dtstart.getUTCDate();
        break;
      case Ue.MONTHLY:
        t.bymonthday = t.dtstart.getUTCDate();
        break;
      case Ue.WEEKLY:
        t.byweekday = [$c(t.dtstart)];
        break;
    }
  if (fn(t.bymonth) && !Ys(t.bymonth) && (t.bymonth = [t.bymonth]), fn(t.byyearday) && !Ys(t.byyearday) && Ei(t.byyearday) && (t.byyearday = [t.byyearday]), !fn(t.bymonthday))
    t.bymonthday = [], t.bynmonthday = [];
  else if (Ys(t.bymonthday)) {
    for (var n = [], i = [], e = 0; e < t.bymonthday.length; e++) {
      var a = t.bymonthday[e];
      a > 0 ? n.push(a) : a < 0 && i.push(a);
    }
    t.bymonthday = n, t.bynmonthday = i;
  } else
    t.bymonthday < 0 ? (t.bynmonthday = [t.bymonthday], t.bymonthday = []) : (t.bynmonthday = [], t.bymonthday = [t.bymonthday]);
  if (fn(t.byweekno) && !Ys(t.byweekno) && (t.byweekno = [t.byweekno]), !fn(t.byweekday))
    t.bynweekday = null;
  else if (Ei(t.byweekday))
    t.byweekday = [t.byweekday], t.bynweekday = null;
  else if (KD(t.byweekday))
    t.byweekday = [ns.fromStr(t.byweekday).weekday], t.bynweekday = null;
  else if (t.byweekday instanceof ns)
    !t.byweekday.n || t.freq > Ue.MONTHLY ? (t.byweekday = [t.byweekday.weekday], t.bynweekday = null) : (t.bynweekday = [[t.byweekday.weekday, t.byweekday.n]], t.byweekday = null);
  else {
    for (var r = [], l = [], e = 0; e < t.byweekday.length; e++) {
      var o = t.byweekday[e];
      if (Ei(o)) {
        r.push(o);
        continue;
      } else if (KD(o)) {
        r.push(ns.fromStr(o).weekday);
        continue;
      }
      !o.n || t.freq > Ue.MONTHLY ? r.push(o.weekday) : l.push([o.weekday, o.n]);
    }
    t.byweekday = Nn(r) ? r : null, t.bynweekday = Nn(l) ? l : null;
  }
  return fn(t.byhour) ? Ei(t.byhour) && (t.byhour = [t.byhour]) : t.byhour = t.freq < Ue.HOURLY ? [t.dtstart.getUTCHours()] : null, fn(t.byminute) ? Ei(t.byminute) && (t.byminute = [t.byminute]) : t.byminute = t.freq < Ue.MINUTELY ? [t.dtstart.getUTCMinutes()] : null, fn(t.bysecond) ? Ei(t.bysecond) && (t.bysecond = [t.bysecond]) : t.bysecond = t.freq < Ue.SECONDLY ? [t.dtstart.getUTCSeconds()] : null, { parsedOptions: t };
}
function LW(s) {
  var t = s.dtstart.getTime() % 1e3;
  if (!dA(s.freq))
    return [];
  var e = [];
  return s.byhour.forEach(function(a) {
    s.byminute.forEach(function(n) {
      s.bysecond.forEach(function(i) {
        e.push(new Zm(a, n, i, t));
      });
    });
  }), e;
}
function Mx(s) {
  var t = s.split(`
`).map(DW).filter(function(e) {
    return e !== null;
  });
  return Os(Os({}, t[0]), t[1]);
}
function tg(s) {
  var t = {}, e = /DTSTART(?:;TZID=([^:=]+?))?(?::|=)([^;\s]+)/i.exec(s);
  if (!e)
    return t;
  var a = e[1], n = e[2];
  return a && (t.tzid = a), t.dtstart = oA(n), t;
}
function DW(s) {
  if (s = s.replace(/^\s+|\s+$/, ""), !s.length)
    return null;
  var t = /^([A-Z]+?)[:;]/.exec(s.toUpperCase());
  if (!t)
    return aI(s);
  var e = t[1];
  switch (e.toUpperCase()) {
    case "RRULE":
    case "EXRULE":
      return aI(s);
    case "DTSTART":
      return tg(s);
    default:
      throw new Error("Unsupported RFC prop ".concat(e, " in ").concat(s));
  }
}
function aI(s) {
  var t = s.replace(/^RRULE:/i, ""), e = tg(t), a = s.replace(/^(?:RRULE|EXRULE):/i, "").split(";");
  return a.forEach(function(n) {
    var i = n.split("="), r = i[0], l = i[1];
    switch (r.toUpperCase()) {
      case "FREQ":
        e.freq = ga[l.toUpperCase()];
        break;
      case "WKST":
        e.wkst = mi[l.toUpperCase()];
        break;
      case "COUNT":
      case "INTERVAL":
      case "BYSETPOS":
      case "BYMONTH":
      case "BYMONTHDAY":
      case "BYYEARDAY":
      case "BYWEEKNO":
      case "BYHOUR":
      case "BYMINUTE":
      case "BYSECOND":
        var o = IW(l), c = r.toLowerCase();
        e[c] = o;
        break;
      case "BYWEEKDAY":
      case "BYDAY":
        e.byweekday = PW(l);
        break;
      case "DTSTART":
      case "TZID":
        var d = tg(s);
        e.tzid = d.tzid, e.dtstart = d.dtstart;
        break;
      case "UNTIL":
        e.until = oA(l);
        break;
      case "BYEASTER":
        e.byeaster = Number(l);
        break;
      default:
        throw new Error("Unknown RRULE property '" + r + "'");
    }
  }), e;
}
function IW(s) {
  if (s.indexOf(",") !== -1) {
    var t = s.split(",");
    return t.map(nI);
  }
  return nI(s);
}
function nI(s) {
  return /^[+-]?\d+$/.test(s) ? Number(s) : s;
}
function PW(s) {
  var t = s.split(",");
  return t.map(function(e) {
    if (e.length === 2)
      return mi[e];
    var a = e.match(/^([+-]?\d{1,2})([A-Z]{2})$/);
    if (!a || a.length < 3)
      throw new SyntaxError("Invalid weekday string: ".concat(e));
    var n = Number(a[1]), i = a[2], r = mi[i].weekday;
    return new ns(r, n);
  });
}
var eg = (
  /** @class */
  function() {
    function s(t, e) {
      if (isNaN(t.getTime()))
        throw new RangeError("Invalid date passed to DateWithZone");
      this.date = t, this.tzid = e;
    }
    return Object.defineProperty(s.prototype, "isUTC", {
      get: function() {
        return !this.tzid || this.tzid.toUpperCase() === "UTC";
      },
      enumerable: !1,
      configurable: !0
    }), s.prototype.toString = function() {
      var t = lA(this.date.getTime(), this.isUTC);
      return this.isUTC ? ":".concat(t) : ";TZID=".concat(this.tzid, ":").concat(t);
    }, s.prototype.getTime = function() {
      return this.date.getTime();
    }, s.prototype.rezonedDate = function() {
      return this.isUTC ? this.date : vW(this.date, this.tzid);
    }, s;
  }()
);
function Xx(s) {
  for (var t = [], e = "", a = Object.keys(s), n = Object.keys(uA), i = 0; i < a.length; i++)
    if (a[i] !== "tzid" && Na(n, a[i])) {
      var r = a[i].toUpperCase(), l = s[a[i]], o = "";
      if (!(!fn(l) || Ys(l) && !l.length)) {
        switch (r) {
          case "FREQ":
            o = Ue.FREQUENCIES[s.freq];
            break;
          case "WKST":
            Ei(l) ? o = new ns(l).toString() : o = l.toString();
            break;
          case "BYWEEKDAY":
            r = "BYDAY", o = hW(l).map(function(g) {
              return g instanceof ns ? g : Ys(g) ? new ns(g[0], g[1]) : new ns(g);
            }).toString();
            break;
          case "DTSTART":
            e = EW(l, s.tzid);
            break;
          case "UNTIL":
            o = lA(l, !s.tzid);
            break;
          default:
            if (Ys(l)) {
              for (var c = [], d = 0; d < l.length; d++)
                c[d] = String(l[d]);
              o = c.toString();
            } else
              o = String(l);
        }
        o && t.push([r, o]);
      }
    }
  var p = t.map(function(g) {
    var x = g[0], b = g[1];
    return "".concat(x, "=").concat(b.toString());
  }).join(";"), h = "";
  return p !== "" && (h = "RRULE:".concat(p)), [e, h].filter(function(g) {
    return !!g;
  }).join(`
`);
}
function EW(s, t) {
  return s ? "DTSTART" + new eg(new Date(s), t).toString() : "";
}
function NW(s, t) {
  return Array.isArray(s) ? !Array.isArray(t) || s.length !== t.length ? !1 : s.every(function(e, a) {
    return e.getTime() === t[a].getTime();
  }) : s instanceof Date ? t instanceof Date && s.getTime() === t.getTime() : s === t;
}
var RW = (
  /** @class */
  function() {
    function s() {
      this.all = !1, this.before = [], this.after = [], this.between = [];
    }
    return s.prototype._cacheAdd = function(t, e, a) {
      e && (e = e instanceof Date ? _x(e) : QD(e)), t === "all" ? this.all = e : (a._value = e, this[t].push(a));
    }, s.prototype._cacheGet = function(t, e) {
      var a = !1, n = e ? Object.keys(e) : [], i = function(d) {
        for (var p = 0; p < n.length; p++) {
          var h = n[p];
          if (!NW(e[h], d[h]))
            return !0;
        }
        return !1;
      }, r = this[t];
      if (t === "all")
        a = this.all;
      else if (Ys(r))
        for (var l = 0; l < r.length; l++) {
          var o = r[l];
          if (!(n.length && i(o))) {
            a = o._value;
            break;
          }
        }
      if (!a && this.all) {
        for (var c = new ec(t, e), l = 0; l < this.all.length && c.accept(this.all[l]); l++)
          ;
        a = c.getValue(), this._cacheAdd(t, a, e);
      }
      return Ys(a) ? QD(a) : a instanceof Date ? _x(a) : a;
    }, s;
  }()
), YW = be(be(be(be(be(be(be(be(be(be(be(be(be([], ha(1, 31), !0), ha(2, 28), !0), ha(3, 31), !0), ha(4, 30), !0), ha(5, 31), !0), ha(6, 30), !0), ha(7, 31), !0), ha(8, 31), !0), ha(9, 30), !0), ha(10, 31), !0), ha(11, 30), !0), ha(12, 31), !0), ha(1, 7), !0), _W = be(be(be(be(be(be(be(be(be(be(be(be(be([], ha(1, 31), !0), ha(2, 29), !0), ha(3, 31), !0), ha(4, 30), !0), ha(5, 31), !0), ha(6, 30), !0), ha(7, 31), !0), ha(8, 31), !0), ha(9, 30), !0), ha(10, 31), !0), ha(11, 30), !0), ha(12, 31), !0), ha(1, 7), !0), OW = Ji(1, 29), MW = Ji(1, 30), zr = Ji(1, 31), Wn = Ji(1, 32), XW = be(be(be(be(be(be(be(be(be(be(be(be(be([], Wn, !0), MW, !0), Wn, !0), zr, !0), Wn, !0), zr, !0), Wn, !0), Wn, !0), zr, !0), Wn, !0), zr, !0), Wn, !0), Wn.slice(0, 7), !0), GW = be(be(be(be(be(be(be(be(be(be(be(be(be([], Wn, !0), OW, !0), Wn, !0), zr, !0), Wn, !0), zr, !0), Wn, !0), Wn, !0), zr, !0), Wn, !0), zr, !0), Wn, !0), Wn.slice(0, 7), !0), HW = Ji(-28, 0), UW = Ji(-29, 0), Br = Ji(-30, 0), jn = Ji(-31, 0), FW = be(be(be(be(be(be(be(be(be(be(be(be(be([], jn, !0), UW, !0), jn, !0), Br, !0), jn, !0), Br, !0), jn, !0), jn, !0), Br, !0), jn, !0), Br, !0), jn, !0), jn.slice(0, 7), !0), zW = be(be(be(be(be(be(be(be(be(be(be(be(be([], jn, !0), HW, !0), jn, !0), Br, !0), jn, !0), Br, !0), jn, !0), jn, !0), Br, !0), jn, !0), Br, !0), jn, !0), jn.slice(0, 7), !0), BW = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335, 366], WW = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334, 365], sI = function() {
  for (var s = [], t = 0; t < 55; t++)
    s = s.concat(Ji(7));
  return s;
}();
function jW(s, t) {
  var e = ql(s, 1, 1), a = qd(s) ? 366 : 365, n = qd(s + 1) ? 366 : 365, i = Yx(e), r = $c(e), l = Os(Os({ yearlen: a, nextyearlen: n, yearordinal: i, yearweekday: r }, VW(s)), { wnomask: null });
  if (Yi(t.byweekno))
    return l;
  l.wnomask = ha(0, a + 7);
  var o, c, d = o = Qs(7 - r + t.wkst, 7);
  d >= 4 ? (d = 0, c = l.yearlen + Qs(r - t.wkst, 7)) : c = a - d;
  for (var p = Math.floor(c / 7), h = Qs(c, 7), g = Math.floor(p + h / 4), x = 0; x < t.byweekno.length; x++) {
    var b = t.byweekno[x];
    if (b < 0 && (b += g + 1), b > 0 && b <= g) {
      var A = void 0;
      b > 1 ? (A = d + (b - 1) * 7, d !== o && (A -= 7 - o)) : A = d;
      for (var T = 0; T < 7 && (l.wnomask[A] = 1, A++, l.wdaymask[A] !== t.wkst); T++)
        ;
    }
  }
  if (Na(t.byweekno, 1)) {
    var A = d + g * 7;
    if (d !== o && (A -= 7 - o), A < a)
      for (var x = 0; x < 7 && (l.wnomask[A] = 1, A += 1, l.wdaymask[A] !== t.wkst); x++)
        ;
  }
  if (d) {
    var R = void 0;
    if (Na(t.byweekno, -1))
      R = -1;
    else {
      var C = $c(ql(s - 1, 1, 1)), v = Qs(7 - C.valueOf() + t.wkst, 7), P = qd(s - 1) ? 366 : 365, O = void 0;
      v >= 4 ? (v = 0, O = P + Qs(C - t.wkst, 7)) : O = a - d, R = Math.floor(52 + Qs(O, 7) / 4);
    }
    if (Na(t.byweekno, R))
      for (var A = 0; A < d; A++)
        l.wnomask[A] = 1;
  }
  return l;
}
function VW(s) {
  var t = qd(s) ? 366 : 365, e = ql(s, 1, 1), a = $c(e);
  return t === 365 ? {
    mmask: YW,
    mdaymask: GW,
    nmdaymask: zW,
    wdaymask: sI.slice(a),
    mrange: WW
  } : {
    mmask: _W,
    mdaymask: XW,
    nmdaymask: FW,
    wdaymask: sI.slice(a),
    mrange: BW
  };
}
function qW(s, t, e, a, n, i) {
  var r = {
    lastyear: s,
    lastmonth: t,
    nwdaymask: []
  }, l = [];
  if (i.freq === Ue.YEARLY)
    if (Yi(i.bymonth))
      l = [[0, e]];
    else
      for (var o = 0; o < i.bymonth.length; o++)
        t = i.bymonth[o], l.push(a.slice(t - 1, t + 1));
  else
    i.freq === Ue.MONTHLY && (l = [a.slice(t - 1, t + 1)]);
  if (Yi(l))
    return r;
  r.nwdaymask = ha(0, e);
  for (var o = 0; o < l.length; o++)
    for (var c = l[o], d = c[0], p = c[1] - 1, h = 0; h < i.bynweekday.length; h++) {
      var g = void 0, x = i.bynweekday[h], b = x[0], A = x[1];
      A < 0 ? (g = p + (A + 1) * 7, g -= Qs(n[g] - b, 7)) : (g = d + (A - 1) * 7, g += Qs(7 - n[g] + b, 7)), d <= g && g <= p && (r.nwdaymask[g] = 1);
    }
  return r;
}
function KW(s, t) {
  t === void 0 && (t = 0);
  var e = s % 19, a = Math.floor(s / 100), n = s % 100, i = Math.floor(a / 4), r = a % 4, l = Math.floor((a + 8) / 25), o = Math.floor((a - l + 1) / 3), c = Math.floor(19 * e + a - i - o + 15) % 30, d = Math.floor(n / 4), p = n % 4, h = Math.floor(32 + 2 * r + 2 * d - c - p) % 7, g = Math.floor((e + 11 * c + 22 * h) / 451), x = Math.floor((c + h - 7 * g + 114) / 31), b = (c + h - 7 * g + 114) % 31 + 1, A = Date.UTC(s, x - 1, b + t), T = Date.UTC(s, 0, 1);
  return [Math.ceil((A - T) / (1e3 * 60 * 60 * 24))];
}
var JW = (
  /** @class */
  function() {
    function s(t) {
      this.options = t;
    }
    return s.prototype.rebuild = function(t, e) {
      var a = this.options;
      if (t !== this.lastyear && (this.yearinfo = jW(t, a)), Nn(a.bynweekday) && (e !== this.lastmonth || t !== this.lastyear)) {
        var n = this.yearinfo, i = n.yearlen, r = n.mrange, l = n.wdaymask;
        this.monthinfo = qW(t, e, i, r, l, a);
      }
      fn(a.byeaster) && (this.eastermask = KW(t, a.byeaster));
    }, Object.defineProperty(s.prototype, "lastyear", {
      get: function() {
        return this.monthinfo ? this.monthinfo.lastyear : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(s.prototype, "lastmonth", {
      get: function() {
        return this.monthinfo ? this.monthinfo.lastmonth : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(s.prototype, "yearlen", {
      get: function() {
        return this.yearinfo.yearlen;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(s.prototype, "yearordinal", {
      get: function() {
        return this.yearinfo.yearordinal;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(s.prototype, "mrange", {
      get: function() {
        return this.yearinfo.mrange;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(s.prototype, "wdaymask", {
      get: function() {
        return this.yearinfo.wdaymask;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(s.prototype, "mmask", {
      get: function() {
        return this.yearinfo.mmask;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(s.prototype, "wnomask", {
      get: function() {
        return this.yearinfo.wnomask;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(s.prototype, "nwdaymask", {
      get: function() {
        return this.monthinfo ? this.monthinfo.nwdaymask : [];
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(s.prototype, "nextyearlen", {
      get: function() {
        return this.yearinfo.nextyearlen;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(s.prototype, "mdaymask", {
      get: function() {
        return this.yearinfo.mdaymask;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(s.prototype, "nmdaymask", {
      get: function() {
        return this.yearinfo.nmdaymask;
      },
      enumerable: !1,
      configurable: !0
    }), s.prototype.ydayset = function() {
      return [Ji(this.yearlen), 0, this.yearlen];
    }, s.prototype.mdayset = function(t, e) {
      for (var a = this.mrange[e - 1], n = this.mrange[e], i = ha(null, this.yearlen), r = a; r < n; r++)
        i[r] = r;
      return [i, a, n];
    }, s.prototype.wdayset = function(t, e, a) {
      for (var n = ha(null, this.yearlen + 7), i = Yx(ql(t, e, a)) - this.yearordinal, r = i, l = 0; l < 7 && (n[i] = i, ++i, this.wdaymask[i] !== this.options.wkst); l++)
        ;
      return [n, r, i];
    }, s.prototype.ddayset = function(t, e, a) {
      var n = ha(null, this.yearlen), i = Yx(ql(t, e, a)) - this.yearordinal;
      return n[i] = i, [n, i, i + 1];
    }, s.prototype.htimeset = function(t, e, a, n) {
      var i = this, r = [];
      return this.options.byminute.forEach(function(l) {
        r = r.concat(i.mtimeset(t, l, a, n));
      }), vu(r), r;
    }, s.prototype.mtimeset = function(t, e, a, n) {
      var i = this.options.bysecond.map(function(r) {
        return new Zm(t, e, r, n);
      });
      return vu(i), i;
    }, s.prototype.stimeset = function(t, e, a, n) {
      return [new Zm(t, e, a, n)];
    }, s.prototype.getdayset = function(t) {
      switch (t) {
        case ga.YEARLY:
          return this.ydayset.bind(this);
        case ga.MONTHLY:
          return this.mdayset.bind(this);
        case ga.WEEKLY:
          return this.wdayset.bind(this);
        case ga.DAILY:
          return this.ddayset.bind(this);
        default:
          return this.ddayset.bind(this);
      }
    }, s.prototype.gettimeset = function(t) {
      switch (t) {
        case ga.HOURLY:
          return this.htimeset.bind(this);
        case ga.MINUTELY:
          return this.mtimeset.bind(this);
        case ga.SECONDLY:
          return this.stimeset.bind(this);
      }
    }, s;
  }()
);
function QW(s, t, e, a, n, i) {
  for (var r = [], l = 0; l < s.length; l++) {
    var o = void 0, c = void 0, d = s[l];
    d < 0 ? (o = Math.floor(d / t.length), c = Qs(d, t.length)) : (o = Math.floor((d - 1) / t.length), c = Qs(d - 1, t.length));
    for (var p = [], h = e; h < a; h++) {
      var g = i[h];
      fn(g) && p.push(g);
    }
    var x = void 0;
    o < 0 ? x = p.slice(o)[0] : x = p[o];
    var b = t[c], A = _E(n.yearordinal + x), T = OE(A, b);
    Na(r, T) || r.push(T);
  }
  return vu(r), r;
}
function GE(s, t) {
  var e = t.dtstart, a = t.freq, n = t.interval, i = t.until, r = t.bysetpos, l = t.count;
  if (l === 0 || n === 0)
    return sr(s);
  var o = kW.fromDate(e), c = new JW(t);
  c.rebuild(o.year, o.month);
  for (var d = ej(c, o, t); ; ) {
    var p = c.getdayset(a)(o.year, o.month, o.day), h = p[0], g = p[1], x = p[2], b = tj(h, g, x, c, t);
    if (Nn(r))
      for (var A = QW(r, d, g, x, c, h), T = 0; T < A.length; T++) {
        var R = A[T];
        if (i && R > i)
          return sr(s);
        if (R >= e) {
          var C = iI(R, t);
          if (!s.accept(C) || l && (--l, !l))
            return sr(s);
        }
      }
    else
      for (var T = g; T < x; T++) {
        var v = h[T];
        if (fn(v))
          for (var P = _E(c.yearordinal + v), O = 0; O < d.length; O++) {
            var N = d[O], R = OE(P, N);
            if (i && R > i)
              return sr(s);
            if (R >= e) {
              var C = iI(R, t);
              if (!s.accept(C) || l && (--l, !l))
                return sr(s);
            }
          }
      }
    if (t.interval === 0 || (o.add(t, b), o.year > NE))
      return sr(s);
    dA(a) || (d = c.gettimeset(a)(o.hour, o.minute, o.second, 0)), c.rebuild(o.year, o.month);
  }
}
function ZW(s, t, e) {
  var a = e.bymonth, n = e.byweekno, i = e.byweekday, r = e.byeaster, l = e.bymonthday, o = e.bynmonthday, c = e.byyearday;
  return Nn(a) && !Na(a, s.mmask[t]) || Nn(n) && !s.wnomask[t] || Nn(i) && !Na(i, s.wdaymask[t]) || Nn(s.nwdaymask) && !s.nwdaymask[t] || r !== null && !Na(s.eastermask, t) || (Nn(l) || Nn(o)) && !Na(l, s.mdaymask[t]) && !Na(o, s.nmdaymask[t]) || Nn(c) && (t < s.yearlen && !Na(c, t + 1) && !Na(c, -s.yearlen + t) || t >= s.yearlen && !Na(c, t + 1 - s.yearlen) && !Na(c, -s.nextyearlen + t - s.yearlen));
}
function iI(s, t) {
  return new eg(s, t.tzid).rezonedDate();
}
function sr(s) {
  return s.getValue();
}
function tj(s, t, e, a, n) {
  for (var i = !1, r = t; r < e; r++) {
    var l = s[r];
    i = ZW(a, l, n), i && (s[l] = null);
  }
  return i;
}
function ej(s, t, e) {
  var a = e.freq, n = e.byhour, i = e.byminute, r = e.bysecond;
  return dA(a) ? LW(e) : a >= Ue.HOURLY && Nn(n) && !Na(n, t.hour) || a >= Ue.MINUTELY && Nn(i) && !Na(i, t.minute) || a >= Ue.SECONDLY && Nn(r) && !Na(r, t.second) ? [] : s.gettimeset(a)(t.hour, t.minute, t.second, t.millisecond);
}
var mi = {
  MO: new ns(0),
  TU: new ns(1),
  WE: new ns(2),
  TH: new ns(3),
  FR: new ns(4),
  SA: new ns(5),
  SU: new ns(6)
}, uA = {
  freq: ga.YEARLY,
  dtstart: null,
  interval: 1,
  wkst: mi.MO,
  count: null,
  until: null,
  tzid: null,
  bysetpos: null,
  bymonth: null,
  bymonthday: null,
  bynmonthday: null,
  byyearday: null,
  byweekno: null,
  byweekday: null,
  bynweekday: null,
  byhour: null,
  byminute: null,
  bysecond: null,
  byeaster: null
}, aj = Object.keys(uA), Ue = (
  /** @class */
  function() {
    function s(t, e) {
      t === void 0 && (t = {}), e === void 0 && (e = !1), this._cache = e ? null : new RW(), this.origOptions = XE(t);
      var a = TW(t).parsedOptions;
      this.options = a;
    }
    return s.parseText = function(t, e) {
      return ME(t, e);
    }, s.fromText = function(t, e) {
      return CW(t, e);
    }, s.fromString = function(t) {
      return new s(s.parseString(t) || void 0);
    }, s.prototype._iter = function(t) {
      return GE(t, this.options);
    }, s.prototype._cacheGet = function(t, e) {
      return this._cache ? this._cache._cacheGet(t, e) : !1;
    }, s.prototype._cacheAdd = function(t, e, a) {
      if (this._cache)
        return this._cache._cacheAdd(t, e, a);
    }, s.prototype.all = function(t) {
      if (t)
        return this._iter(new tI("all", {}, t));
      var e = this._cacheGet("all");
      return e === !1 && (e = this._iter(new ec("all", {})), this._cacheAdd("all", e)), e;
    }, s.prototype.between = function(t, e, a, n) {
      if (a === void 0 && (a = !1), !_d(t) || !_d(e))
        throw new Error("Invalid date passed in to RRule.between");
      var i = {
        before: e,
        after: t,
        inc: a
      };
      if (n)
        return this._iter(new tI("between", i, n));
      var r = this._cacheGet("between", i);
      return r === !1 && (r = this._iter(new ec("between", i)), this._cacheAdd("between", r, i)), r;
    }, s.prototype.before = function(t, e) {
      if (e === void 0 && (e = !1), !_d(t))
        throw new Error("Invalid date passed in to RRule.before");
      var a = { dt: t, inc: e }, n = this._cacheGet("before", a);
      return n === !1 && (n = this._iter(new ec("before", a)), this._cacheAdd("before", n, a)), n;
    }, s.prototype.after = function(t, e) {
      if (e === void 0 && (e = !1), !_d(t))
        throw new Error("Invalid date passed in to RRule.after");
      var a = { dt: t, inc: e }, n = this._cacheGet("after", a);
      return n === !1 && (n = this._iter(new ec("after", a)), this._cacheAdd("after", n, a)), n;
    }, s.prototype.count = function() {
      return this.all().length;
    }, s.prototype.toString = function() {
      return Xx(this.origOptions);
    }, s.prototype.toText = function(t, e, a) {
      return $W(this, t, e, a);
    }, s.prototype.isFullyConvertibleToText = function() {
      return SW(this);
    }, s.prototype.clone = function() {
      return new s(this.origOptions);
    }, s.FREQUENCIES = [
      "YEARLY",
      "MONTHLY",
      "WEEKLY",
      "DAILY",
      "HOURLY",
      "MINUTELY",
      "SECONDLY"
    ], s.YEARLY = ga.YEARLY, s.MONTHLY = ga.MONTHLY, s.WEEKLY = ga.WEEKLY, s.DAILY = ga.DAILY, s.HOURLY = ga.HOURLY, s.MINUTELY = ga.MINUTELY, s.SECONDLY = ga.SECONDLY, s.MO = mi.MO, s.TU = mi.TU, s.WE = mi.WE, s.TH = mi.TH, s.FR = mi.FR, s.SA = mi.SA, s.SU = mi.SU, s.parseString = Mx, s.optionsToString = Xx, s;
  }()
);
function nj(s, t, e, a, n, i) {
  var r = {}, l = s.accept;
  function o(h, g) {
    e.forEach(function(x) {
      x.between(h, g, !0).forEach(function(b) {
        r[Number(b)] = !0;
      });
    });
  }
  n.forEach(function(h) {
    var g = new eg(h, i).rezonedDate();
    r[Number(g)] = !0;
  }), s.accept = function(h) {
    var g = Number(h);
    return isNaN(g) ? l.call(this, h) : !r[g] && (o(new Date(g - 1), new Date(g + 1)), !r[g]) ? (r[g] = !0, l.call(this, h)) : !0;
  }, s.method === "between" && (o(s.args.after, s.args.before), s.accept = function(h) {
    var g = Number(h);
    return r[g] ? !0 : (r[g] = !0, l.call(this, h));
  });
  for (var c = 0; c < a.length; c++) {
    var d = new eg(a[c], i).rezonedDate();
    if (!s.accept(new Date(d.getTime())))
      break;
  }
  t.forEach(function(h) {
    GE(s, h.options);
  });
  var p = s._result;
  switch (vu(p), s.method) {
    case "all":
    case "between":
      return p;
    case "before":
      return p.length && p[p.length - 1] || null;
    case "after":
    default:
      return p.length && p[0] || null;
  }
}
var rI = {
  dtstart: null,
  cache: !1,
  unfold: !1,
  forceset: !1,
  compatible: !1,
  tzid: null
};
function sj(s, t) {
  var e = [], a = [], n = [], i = [], r = tg(s), l = r.dtstart, o = r.tzid, c = cj(s, t.unfold);
  return c.forEach(function(d) {
    var p;
    if (d) {
      var h = oj(d), g = h.name, x = h.parms, b = h.value;
      switch (g.toUpperCase()) {
        case "RRULE":
          if (x.length)
            throw new Error("unsupported RRULE parm: ".concat(x.join(",")));
          e.push(Mx(d));
          break;
        case "RDATE":
          var A = (p = /RDATE(?:;TZID=([^:=]+))?/i.exec(d)) !== null && p !== void 0 ? p : [], T = A[1];
          T && !o && (o = T), a = a.concat(lI(b, x));
          break;
        case "EXRULE":
          if (x.length)
            throw new Error("unsupported EXRULE parm: ".concat(x.join(",")));
          n.push(Mx(b));
          break;
        case "EXDATE":
          i = i.concat(lI(b, x));
          break;
        case "DTSTART":
          break;
        default:
          throw new Error("unsupported property: " + g);
      }
    }
  }), {
    dtstart: l,
    tzid: o,
    rrulevals: e,
    rdatevals: a,
    exrulevals: n,
    exdatevals: i
  };
}
function ij(s, t) {
  var e = sj(s, t), a = e.rrulevals, n = e.rdatevals, i = e.exrulevals, r = e.exdatevals, l = e.dtstart, o = e.tzid, c = t.cache === !1;
  if (t.compatible && (t.forceset = !0, t.unfold = !0), t.forceset || a.length > 1 || n.length || i.length || r.length) {
    var d = new uj(c);
    return d.dtstart(l), d.tzid(o || void 0), a.forEach(function(h) {
      d.rrule(new Ue(tv(h, l, o), c));
    }), n.forEach(function(h) {
      d.rdate(h);
    }), i.forEach(function(h) {
      d.exrule(new Ue(tv(h, l, o), c));
    }), r.forEach(function(h) {
      d.exdate(h);
    }), t.compatible && t.dtstart && d.rdate(l), d;
  }
  var p = a[0] || {};
  return new Ue(tv(p, p.dtstart || t.dtstart || l, p.tzid || t.tzid || o), c);
}
function Gx(s, t) {
  return t === void 0 && (t = {}), ij(s, rj(t));
}
function tv(s, t, e) {
  return Os(Os({}, s), { dtstart: t, tzid: e });
}
function rj(s) {
  var t = [], e = Object.keys(s), a = Object.keys(rI);
  if (e.forEach(function(n) {
    Na(a, n) || t.push(n);
  }), t.length)
    throw new Error("Invalid options: " + t.join(", "));
  return Os(Os({}, rI), s);
}
function lj(s) {
  if (s.indexOf(":") === -1)
    return {
      name: "RRULE",
      value: s
    };
  var t = mW(s, ":", 1), e = t[0], a = t[1];
  return {
    name: e,
    value: a
  };
}
function oj(s) {
  var t = lj(s), e = t.name, a = t.value, n = e.split(";");
  if (!n)
    throw new Error("empty property name");
  return {
    name: n[0].toUpperCase(),
    parms: n.slice(1),
    value: a
  };
}
function cj(s, t) {
  if (t === void 0 && (t = !1), s = s && s.trim(), !s)
    throw new Error("Invalid empty string");
  if (!t)
    return s.split(/\s/);
  for (var e = s.split(`
`), a = 0; a < e.length; ) {
    var n = e[a] = e[a].replace(/\s+$/g, "");
    n ? a > 0 && n[0] === " " ? (e[a - 1] += n.slice(1), e.splice(a, 1)) : a += 1 : e.splice(a, 1);
  }
  return e;
}
function dj(s) {
  s.forEach(function(t) {
    if (!/(VALUE=DATE(-TIME)?)|(TZID=)/.test(t))
      throw new Error("unsupported RDATE/EXDATE parm: " + t);
  });
}
function lI(s, t) {
  return dj(t), s.split(",").map(function(e) {
    return oA(e);
  });
}
function oI(s) {
  var t = this;
  return function(e) {
    if (e !== void 0 && (t["_".concat(s)] = e), t["_".concat(s)] !== void 0)
      return t["_".concat(s)];
    for (var a = 0; a < t._rrule.length; a++) {
      var n = t._rrule[a].origOptions[s];
      if (n)
        return n;
    }
  };
}
var uj = (
  /** @class */
  function(s) {
    cA(t, s);
    function t(e) {
      e === void 0 && (e = !1);
      var a = s.call(this, {}, e) || this;
      return a.dtstart = oI.apply(a, ["dtstart"]), a.tzid = oI.apply(a, ["tzid"]), a._rrule = [], a._rdate = [], a._exrule = [], a._exdate = [], a;
    }
    return t.prototype._iter = function(e) {
      return nj(e, this._rrule, this._exrule, this._rdate, this._exdate, this.tzid());
    }, t.prototype.rrule = function(e) {
      cI(e, this._rrule);
    }, t.prototype.exrule = function(e) {
      cI(e, this._exrule);
    }, t.prototype.rdate = function(e) {
      dI(e, this._rdate);
    }, t.prototype.exdate = function(e) {
      dI(e, this._exdate);
    }, t.prototype.rrules = function() {
      return this._rrule.map(function(e) {
        return Gx(e.toString());
      });
    }, t.prototype.exrules = function() {
      return this._exrule.map(function(e) {
        return Gx(e.toString());
      });
    }, t.prototype.rdates = function() {
      return this._rdate.map(function(e) {
        return new Date(e.getTime());
      });
    }, t.prototype.exdates = function() {
      return this._exdate.map(function(e) {
        return new Date(e.getTime());
      });
    }, t.prototype.valueOf = function() {
      var e = [];
      return !this._rrule.length && this._dtstart && (e = e.concat(Xx({ dtstart: this._dtstart }))), this._rrule.forEach(function(a) {
        e = e.concat(a.toString().split(`
`));
      }), this._exrule.forEach(function(a) {
        e = e.concat(a.toString().split(`
`).map(function(n) {
          return n.replace(/^RRULE:/, "EXRULE:");
        }).filter(function(n) {
          return !/^DTSTART/.test(n);
        }));
      }), this._rdate.length && e.push(uI("RDATE", this._rdate, this.tzid())), this._exdate.length && e.push(uI("EXDATE", this._exdate, this.tzid())), e;
    }, t.prototype.toString = function() {
      return this.valueOf().join(`
`);
    }, t.prototype.clone = function() {
      var e = new t(!!this._cache);
      return this._rrule.forEach(function(a) {
        return e.rrule(a.clone());
      }), this._exrule.forEach(function(a) {
        return e.exrule(a.clone());
      }), this._rdate.forEach(function(a) {
        return e.rdate(new Date(a.getTime()));
      }), this._exdate.forEach(function(a) {
        return e.exdate(new Date(a.getTime()));
      }), e;
    }, t;
  }(Ue)
);
function cI(s, t) {
  if (!(s instanceof Ue))
    throw new TypeError(String(s) + " is not RRule instance");
  Na(t.map(String), String(s)) || t.push(s);
}
function dI(s, t) {
  if (!(s instanceof Date))
    throw new TypeError(String(s) + " is not Date instance");
  Na(t.map(Number), Number(s)) || (t.push(s), vu(t));
}
function uI(s, t, e) {
  var a = !e || e.toUpperCase() === "UTC", n = a ? "".concat(s, ":") : "".concat(s, ";TZID=").concat(e, ":"), i = t.map(function(r) {
    return lA(r.valueOf(), a);
  }).join(",");
  return "".concat(n).concat(i);
}
const O$ = class O$ extends Ia {
  /**
   * Creates a new InputController
   * @ignore
   */
  constructor() {
    super();
  }
  /**
   * Gets the recurrence rule as human readable text.
   * @param rrule The iCalendar Recurrence rule that should be interpreted.
   */
  getRRuleText(t) {
    return Gx(t, {
      // dtstart: Dates.asDate,
    }).toText((a) => k1.texts[a.toString()] || a.toString(), k1, (a, n, i) => `${i}. ${n}ta ${a}`);
  }
};
O$.$inject = [];
let ag = O$;
class HE extends Ia {
  constructor() {
    super(...arguments), this.type = "time";
  }
  /** Sets the default values in init. */
  $onInit() {
    super.$onInit();
  }
  /**
   * Gets or sets the string value that is used in the view.
   */
  get viewValue() {
    return this.value ? (this.type === "time" ? this._viewValue?.getTime() !== ys.fromTime(this.value).getTime() && (this._viewValue = ys.fromTime(this.value)) : this.type === "minutes" && this._viewValue?.getTime() !== ys.fromMinutes(this.value).getTime() && (this._viewValue = ys.fromMinutes(this.value)), this._viewValue) : null;
  }
  set viewValue(t) {
    this.type === "time" ? this.value = ys.asTime(t) : this.type === "minutes" && (this.value = ys.asMinutes(t)), this.onChange();
  }
}
var ls = "top", Ms = "bottom", Xs = "right", os = "left", cf = "auto", Hc = [ls, Ms, Xs, os], Kl = "start", Sc = "end", UE = "clippingParents", pA = "viewport", Bo = "popper", FE = "reference", Hx = /* @__PURE__ */ Hc.reduce(function(s, t) {
  return s.concat([t + "-" + Kl, t + "-" + Sc]);
}, []), hA = /* @__PURE__ */ [].concat(Hc, [cf]).reduce(function(s, t) {
  return s.concat([t, t + "-" + Kl, t + "-" + Sc]);
}, []), zE = "beforeRead", BE = "read", WE = "afterRead", jE = "beforeMain", VE = "main", qE = "afterMain", KE = "beforeWrite", JE = "write", QE = "afterWrite", ZE = [zE, BE, WE, jE, VE, qE, KE, JE, QE];
function qi(s) {
  return s ? (s.nodeName || "").toLowerCase() : null;
}
function Gs(s) {
  if (s == null)
    return window;
  if (s.toString() !== "[object Window]") {
    var t = s.ownerDocument;
    return t && t.defaultView || window;
  }
  return s;
}
function Jl(s) {
  var t = Gs(s).Element;
  return s instanceof t || s instanceof Element;
}
function ai(s) {
  var t = Gs(s).HTMLElement;
  return s instanceof t || s instanceof HTMLElement;
}
function mA(s) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = Gs(s).ShadowRoot;
  return s instanceof t || s instanceof ShadowRoot;
}
function pj(s) {
  var t = s.state;
  Object.keys(t.elements).forEach(function(e) {
    var a = t.styles[e] || {}, n = t.attributes[e] || {}, i = t.elements[e];
    !ai(i) || !qi(i) || (Object.assign(i.style, a), Object.keys(n).forEach(function(r) {
      var l = n[r];
      l === !1 ? i.removeAttribute(r) : i.setAttribute(r, l === !0 ? "" : l);
    }));
  });
}
function hj(s) {
  var t = s.state, e = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, e.popper), t.styles = e, t.elements.arrow && Object.assign(t.elements.arrow.style, e.arrow), function() {
    Object.keys(t.elements).forEach(function(a) {
      var n = t.elements[a], i = t.attributes[a] || {}, r = Object.keys(t.styles.hasOwnProperty(a) ? t.styles[a] : e[a]), l = r.reduce(function(o, c) {
        return o[c] = "", o;
      }, {});
      !ai(n) || !qi(n) || (Object.assign(n.style, l), Object.keys(i).forEach(function(o) {
        n.removeAttribute(o);
      }));
    });
  };
}
const gA = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: pj,
  effect: hj,
  requires: ["computeStyles"]
};
function Fi(s) {
  return s.split("-")[0];
}
var Xl = Math.max, ng = Math.min, kc = Math.round;
function Ux() {
  var s = navigator.userAgentData;
  return s != null && s.brands && Array.isArray(s.brands) ? s.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function tN() {
  return !/^((?!chrome|android).)*safari/i.test(Ux());
}
function Tc(s, t, e) {
  t === void 0 && (t = !1), e === void 0 && (e = !1);
  var a = s.getBoundingClientRect(), n = 1, i = 1;
  t && ai(s) && (n = s.offsetWidth > 0 && kc(a.width) / s.offsetWidth || 1, i = s.offsetHeight > 0 && kc(a.height) / s.offsetHeight || 1);
  var r = Jl(s) ? Gs(s) : window, l = r.visualViewport, o = !tN() && e, c = (a.left + (o && l ? l.offsetLeft : 0)) / n, d = (a.top + (o && l ? l.offsetTop : 0)) / i, p = a.width / n, h = a.height / i;
  return {
    width: p,
    height: h,
    top: d,
    right: c + p,
    bottom: d + h,
    left: c,
    x: c,
    y: d
  };
}
function yA(s) {
  var t = Tc(s), e = s.offsetWidth, a = s.offsetHeight;
  return Math.abs(t.width - e) <= 1 && (e = t.width), Math.abs(t.height - a) <= 1 && (a = t.height), {
    x: s.offsetLeft,
    y: s.offsetTop,
    width: e,
    height: a
  };
}
function eN(s, t) {
  var e = t.getRootNode && t.getRootNode();
  if (s.contains(t))
    return !0;
  if (e && mA(e)) {
    var a = t;
    do {
      if (a && s.isSameNode(a))
        return !0;
      a = a.parentNode || a.host;
    } while (a);
  }
  return !1;
}
function Ar(s) {
  return Gs(s).getComputedStyle(s);
}
function mj(s) {
  return ["table", "td", "th"].indexOf(qi(s)) >= 0;
}
function dl(s) {
  return ((Jl(s) ? s.ownerDocument : (
    // $FlowFixMe[prop-missing]
    s.document
  )) || window.document).documentElement;
}
function df(s) {
  return qi(s) === "html" ? s : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    s.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    s.parentNode || // DOM Element detected
    (mA(s) ? s.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    dl(s)
  );
}
function pI(s) {
  return !ai(s) || // https://github.com/popperjs/popper-core/issues/837
  Ar(s).position === "fixed" ? null : s.offsetParent;
}
function gj(s) {
  var t = /firefox/i.test(Ux()), e = /Trident/i.test(Ux());
  if (e && ai(s)) {
    var a = Ar(s);
    if (a.position === "fixed")
      return null;
  }
  var n = df(s);
  for (mA(n) && (n = n.host); ai(n) && ["html", "body"].indexOf(qi(n)) < 0; ) {
    var i = Ar(n);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || t && i.willChange === "filter" || t && i.filter && i.filter !== "none")
      return n;
    n = n.parentNode;
  }
  return null;
}
function qu(s) {
  for (var t = Gs(s), e = pI(s); e && mj(e) && Ar(e).position === "static"; )
    e = pI(e);
  return e && (qi(e) === "html" || qi(e) === "body" && Ar(e).position === "static") ? t : e || gj(s) || t;
}
function fA(s) {
  return ["top", "bottom"].indexOf(s) >= 0 ? "x" : "y";
}
function Kd(s, t, e) {
  return Xl(s, ng(t, e));
}
function yj(s, t, e) {
  var a = Kd(s, t, e);
  return a > e ? e : a;
}
function aN() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function nN(s) {
  return Object.assign({}, aN(), s);
}
function sN(s, t) {
  return t.reduce(function(e, a) {
    return e[a] = s, e;
  }, {});
}
var fj = function(t, e) {
  return t = typeof t == "function" ? t(Object.assign({}, e.rects, {
    placement: e.placement
  })) : t, nN(typeof t != "number" ? t : sN(t, Hc));
};
function bj(s) {
  var t, e = s.state, a = s.name, n = s.options, i = e.elements.arrow, r = e.modifiersData.popperOffsets, l = Fi(e.placement), o = fA(l), c = [os, Xs].indexOf(l) >= 0, d = c ? "height" : "width";
  if (!(!i || !r)) {
    var p = fj(n.padding, e), h = yA(i), g = o === "y" ? ls : os, x = o === "y" ? Ms : Xs, b = e.rects.reference[d] + e.rects.reference[o] - r[o] - e.rects.popper[d], A = r[o] - e.rects.reference[o], T = qu(i), R = T ? o === "y" ? T.clientHeight || 0 : T.clientWidth || 0 : 0, C = b / 2 - A / 2, v = p[g], P = R - h[d] - p[x], O = R / 2 - h[d] / 2 + C, N = Kd(v, O, P), H = o;
    e.modifiersData[a] = (t = {}, t[H] = N, t.centerOffset = N - O, t);
  }
}
function vj(s) {
  var t = s.state, e = s.options, a = e.element, n = a === void 0 ? "[data-popper-arrow]" : a;
  n != null && (typeof n == "string" && (n = t.elements.popper.querySelector(n), !n) || eN(t.elements.popper, n) && (t.elements.arrow = n));
}
const iN = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: bj,
  effect: vj,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Lc(s) {
  return s.split("-")[1];
}
var xj = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function wj(s, t) {
  var e = s.x, a = s.y, n = t.devicePixelRatio || 1;
  return {
    x: kc(e * n) / n || 0,
    y: kc(a * n) / n || 0
  };
}
function hI(s) {
  var t, e = s.popper, a = s.popperRect, n = s.placement, i = s.variation, r = s.offsets, l = s.position, o = s.gpuAcceleration, c = s.adaptive, d = s.roundOffsets, p = s.isFixed, h = r.x, g = h === void 0 ? 0 : h, x = r.y, b = x === void 0 ? 0 : x, A = typeof d == "function" ? d({
    x: g,
    y: b
  }) : {
    x: g,
    y: b
  };
  g = A.x, b = A.y;
  var T = r.hasOwnProperty("x"), R = r.hasOwnProperty("y"), C = os, v = ls, P = window;
  if (c) {
    var O = qu(e), N = "clientHeight", H = "clientWidth";
    if (O === Gs(e) && (O = dl(e), Ar(O).position !== "static" && l === "absolute" && (N = "scrollHeight", H = "scrollWidth")), O = O, n === ls || (n === os || n === Xs) && i === Sc) {
      v = Ms;
      var F = p && O === P && P.visualViewport ? P.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        O[N]
      );
      b -= F - a.height, b *= o ? 1 : -1;
    }
    if (n === os || (n === ls || n === Ms) && i === Sc) {
      C = Xs;
      var B = p && O === P && P.visualViewport ? P.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        O[H]
      );
      g -= B - a.width, g *= o ? 1 : -1;
    }
  }
  var Q = Object.assign({
    position: l
  }, c && xj), it = d === !0 ? wj({
    x: g,
    y: b
  }, Gs(e)) : {
    x: g,
    y: b
  };
  if (g = it.x, b = it.y, o) {
    var et;
    return Object.assign({}, Q, (et = {}, et[v] = R ? "0" : "", et[C] = T ? "0" : "", et.transform = (P.devicePixelRatio || 1) <= 1 ? "translate(" + g + "px, " + b + "px)" : "translate3d(" + g + "px, " + b + "px, 0)", et));
  }
  return Object.assign({}, Q, (t = {}, t[v] = R ? b + "px" : "", t[C] = T ? g + "px" : "", t.transform = "", t));
}
function Aj(s) {
  var t = s.state, e = s.options, a = e.gpuAcceleration, n = a === void 0 ? !0 : a, i = e.adaptive, r = i === void 0 ? !0 : i, l = e.roundOffsets, o = l === void 0 ? !0 : l, c = {
    placement: Fi(t.placement),
    variation: Lc(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: n,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, hI(Object.assign({}, c, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: r,
    roundOffsets: o
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, hI(Object.assign({}, c, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: o
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const bA = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: Aj,
  data: {}
};
var Ch = {
  passive: !0
};
function Cj(s) {
  var t = s.state, e = s.instance, a = s.options, n = a.scroll, i = n === void 0 ? !0 : n, r = a.resize, l = r === void 0 ? !0 : r, o = Gs(t.elements.popper), c = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return i && c.forEach(function(d) {
    d.addEventListener("scroll", e.update, Ch);
  }), l && o.addEventListener("resize", e.update, Ch), function() {
    i && c.forEach(function(d) {
      d.removeEventListener("scroll", e.update, Ch);
    }), l && o.removeEventListener("resize", e.update, Ch);
  };
}
const vA = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: Cj,
  data: {}
};
var $j = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Zh(s) {
  return s.replace(/left|right|bottom|top/g, function(t) {
    return $j[t];
  });
}
var Sj = {
  start: "end",
  end: "start"
};
function mI(s) {
  return s.replace(/start|end/g, function(t) {
    return Sj[t];
  });
}
function xA(s) {
  var t = Gs(s), e = t.pageXOffset, a = t.pageYOffset;
  return {
    scrollLeft: e,
    scrollTop: a
  };
}
function wA(s) {
  return Tc(dl(s)).left + xA(s).scrollLeft;
}
function kj(s, t) {
  var e = Gs(s), a = dl(s), n = e.visualViewport, i = a.clientWidth, r = a.clientHeight, l = 0, o = 0;
  if (n) {
    i = n.width, r = n.height;
    var c = tN();
    (c || !c && t === "fixed") && (l = n.offsetLeft, o = n.offsetTop);
  }
  return {
    width: i,
    height: r,
    x: l + wA(s),
    y: o
  };
}
function Tj(s) {
  var t, e = dl(s), a = xA(s), n = (t = s.ownerDocument) == null ? void 0 : t.body, i = Xl(e.scrollWidth, e.clientWidth, n ? n.scrollWidth : 0, n ? n.clientWidth : 0), r = Xl(e.scrollHeight, e.clientHeight, n ? n.scrollHeight : 0, n ? n.clientHeight : 0), l = -a.scrollLeft + wA(s), o = -a.scrollTop;
  return Ar(n || e).direction === "rtl" && (l += Xl(e.clientWidth, n ? n.clientWidth : 0) - i), {
    width: i,
    height: r,
    x: l,
    y: o
  };
}
function AA(s) {
  var t = Ar(s), e = t.overflow, a = t.overflowX, n = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(e + n + a);
}
function rN(s) {
  return ["html", "body", "#document"].indexOf(qi(s)) >= 0 ? s.ownerDocument.body : ai(s) && AA(s) ? s : rN(df(s));
}
function Jd(s, t) {
  var e;
  t === void 0 && (t = []);
  var a = rN(s), n = a === ((e = s.ownerDocument) == null ? void 0 : e.body), i = Gs(a), r = n ? [i].concat(i.visualViewport || [], AA(a) ? a : []) : a, l = t.concat(r);
  return n ? l : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    l.concat(Jd(df(r)))
  );
}
function Fx(s) {
  return Object.assign({}, s, {
    left: s.x,
    top: s.y,
    right: s.x + s.width,
    bottom: s.y + s.height
  });
}
function Lj(s, t) {
  var e = Tc(s, !1, t === "fixed");
  return e.top = e.top + s.clientTop, e.left = e.left + s.clientLeft, e.bottom = e.top + s.clientHeight, e.right = e.left + s.clientWidth, e.width = s.clientWidth, e.height = s.clientHeight, e.x = e.left, e.y = e.top, e;
}
function gI(s, t, e) {
  return t === pA ? Fx(kj(s, e)) : Jl(t) ? Lj(t, e) : Fx(Tj(dl(s)));
}
function Dj(s) {
  var t = Jd(df(s)), e = ["absolute", "fixed"].indexOf(Ar(s).position) >= 0, a = e && ai(s) ? qu(s) : s;
  return Jl(a) ? t.filter(function(n) {
    return Jl(n) && eN(n, a) && qi(n) !== "body";
  }) : [];
}
function Ij(s, t, e, a) {
  var n = t === "clippingParents" ? Dj(s) : [].concat(t), i = [].concat(n, [e]), r = i[0], l = i.reduce(function(o, c) {
    var d = gI(s, c, a);
    return o.top = Xl(d.top, o.top), o.right = ng(d.right, o.right), o.bottom = ng(d.bottom, o.bottom), o.left = Xl(d.left, o.left), o;
  }, gI(s, r, a));
  return l.width = l.right - l.left, l.height = l.bottom - l.top, l.x = l.left, l.y = l.top, l;
}
function lN(s) {
  var t = s.reference, e = s.element, a = s.placement, n = a ? Fi(a) : null, i = a ? Lc(a) : null, r = t.x + t.width / 2 - e.width / 2, l = t.y + t.height / 2 - e.height / 2, o;
  switch (n) {
    case ls:
      o = {
        x: r,
        y: t.y - e.height
      };
      break;
    case Ms:
      o = {
        x: r,
        y: t.y + t.height
      };
      break;
    case Xs:
      o = {
        x: t.x + t.width,
        y: l
      };
      break;
    case os:
      o = {
        x: t.x - e.width,
        y: l
      };
      break;
    default:
      o = {
        x: t.x,
        y: t.y
      };
  }
  var c = n ? fA(n) : null;
  if (c != null) {
    var d = c === "y" ? "height" : "width";
    switch (i) {
      case Kl:
        o[c] = o[c] - (t[d] / 2 - e[d] / 2);
        break;
      case Sc:
        o[c] = o[c] + (t[d] / 2 - e[d] / 2);
        break;
    }
  }
  return o;
}
function Dc(s, t) {
  t === void 0 && (t = {});
  var e = t, a = e.placement, n = a === void 0 ? s.placement : a, i = e.strategy, r = i === void 0 ? s.strategy : i, l = e.boundary, o = l === void 0 ? UE : l, c = e.rootBoundary, d = c === void 0 ? pA : c, p = e.elementContext, h = p === void 0 ? Bo : p, g = e.altBoundary, x = g === void 0 ? !1 : g, b = e.padding, A = b === void 0 ? 0 : b, T = nN(typeof A != "number" ? A : sN(A, Hc)), R = h === Bo ? FE : Bo, C = s.rects.popper, v = s.elements[x ? R : h], P = Ij(Jl(v) ? v : v.contextElement || dl(s.elements.popper), o, d, r), O = Tc(s.elements.reference), N = lN({
    reference: O,
    element: C,
    strategy: "absolute",
    placement: n
  }), H = Fx(Object.assign({}, C, N)), F = h === Bo ? H : O, B = {
    top: P.top - F.top + T.top,
    bottom: F.bottom - P.bottom + T.bottom,
    left: P.left - F.left + T.left,
    right: F.right - P.right + T.right
  }, Q = s.modifiersData.offset;
  if (h === Bo && Q) {
    var it = Q[n];
    Object.keys(B).forEach(function(et) {
      var rt = [Xs, Ms].indexOf(et) >= 0 ? 1 : -1, U = [ls, Ms].indexOf(et) >= 0 ? "y" : "x";
      B[et] += it[U] * rt;
    });
  }
  return B;
}
function Pj(s, t) {
  t === void 0 && (t = {});
  var e = t, a = e.placement, n = e.boundary, i = e.rootBoundary, r = e.padding, l = e.flipVariations, o = e.allowedAutoPlacements, c = o === void 0 ? hA : o, d = Lc(a), p = d ? l ? Hx : Hx.filter(function(x) {
    return Lc(x) === d;
  }) : Hc, h = p.filter(function(x) {
    return c.indexOf(x) >= 0;
  });
  h.length === 0 && (h = p);
  var g = h.reduce(function(x, b) {
    return x[b] = Dc(s, {
      placement: b,
      boundary: n,
      rootBoundary: i,
      padding: r
    })[Fi(b)], x;
  }, {});
  return Object.keys(g).sort(function(x, b) {
    return g[x] - g[b];
  });
}
function Ej(s) {
  if (Fi(s) === cf)
    return [];
  var t = Zh(s);
  return [mI(s), t, mI(t)];
}
function Nj(s) {
  var t = s.state, e = s.options, a = s.name;
  if (!t.modifiersData[a]._skip) {
    for (var n = e.mainAxis, i = n === void 0 ? !0 : n, r = e.altAxis, l = r === void 0 ? !0 : r, o = e.fallbackPlacements, c = e.padding, d = e.boundary, p = e.rootBoundary, h = e.altBoundary, g = e.flipVariations, x = g === void 0 ? !0 : g, b = e.allowedAutoPlacements, A = t.options.placement, T = Fi(A), R = T === A, C = o || (R || !x ? [Zh(A)] : Ej(A)), v = [A].concat(C).reduce(function(lt, at) {
      return lt.concat(Fi(at) === cf ? Pj(t, {
        placement: at,
        boundary: d,
        rootBoundary: p,
        padding: c,
        flipVariations: x,
        allowedAutoPlacements: b
      }) : at);
    }, []), P = t.rects.reference, O = t.rects.popper, N = /* @__PURE__ */ new Map(), H = !0, F = v[0], B = 0; B < v.length; B++) {
      var Q = v[B], it = Fi(Q), et = Lc(Q) === Kl, rt = [ls, Ms].indexOf(it) >= 0, U = rt ? "width" : "height", M = Dc(t, {
        placement: Q,
        boundary: d,
        rootBoundary: p,
        altBoundary: h,
        padding: c
      }), W = rt ? et ? Xs : os : et ? Ms : ls;
      P[U] > O[U] && (W = Zh(W));
      var J = Zh(W), vt = [];
      if (i && vt.push(M[it] <= 0), l && vt.push(M[W] <= 0, M[J] <= 0), vt.every(function(lt) {
        return lt;
      })) {
        F = Q, H = !1;
        break;
      }
      N.set(Q, vt);
    }
    if (H)
      for (var St = x ? 3 : 1, zt = function(at) {
        var nt = v.find(function(yt) {
          var Rt = N.get(yt);
          if (Rt)
            return Rt.slice(0, at).every(function(Yt) {
              return Yt;
            });
        });
        if (nt)
          return F = nt, "break";
      }, j = St; j > 0; j--) {
        var tt = zt(j);
        if (tt === "break")
          break;
      }
    t.placement !== F && (t.modifiersData[a]._skip = !0, t.placement = F, t.reset = !0);
  }
}
const oN = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: Nj,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function yI(s, t, e) {
  return e === void 0 && (e = {
    x: 0,
    y: 0
  }), {
    top: s.top - t.height - e.y,
    right: s.right - t.width + e.x,
    bottom: s.bottom - t.height + e.y,
    left: s.left - t.width - e.x
  };
}
function fI(s) {
  return [ls, Xs, Ms, os].some(function(t) {
    return s[t] >= 0;
  });
}
function Rj(s) {
  var t = s.state, e = s.name, a = t.rects.reference, n = t.rects.popper, i = t.modifiersData.preventOverflow, r = Dc(t, {
    elementContext: "reference"
  }), l = Dc(t, {
    altBoundary: !0
  }), o = yI(r, a), c = yI(l, n, i), d = fI(o), p = fI(c);
  t.modifiersData[e] = {
    referenceClippingOffsets: o,
    popperEscapeOffsets: c,
    isReferenceHidden: d,
    hasPopperEscaped: p
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": d,
    "data-popper-escaped": p
  });
}
const cN = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: Rj
};
function Yj(s, t, e) {
  var a = Fi(s), n = [os, ls].indexOf(a) >= 0 ? -1 : 1, i = typeof e == "function" ? e(Object.assign({}, t, {
    placement: s
  })) : e, r = i[0], l = i[1];
  return r = r || 0, l = (l || 0) * n, [os, Xs].indexOf(a) >= 0 ? {
    x: l,
    y: r
  } : {
    x: r,
    y: l
  };
}
function _j(s) {
  var t = s.state, e = s.options, a = s.name, n = e.offset, i = n === void 0 ? [0, 0] : n, r = hA.reduce(function(d, p) {
    return d[p] = Yj(p, t.rects, i), d;
  }, {}), l = r[t.placement], o = l.x, c = l.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += o, t.modifiersData.popperOffsets.y += c), t.modifiersData[a] = r;
}
const dN = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: _j
};
function Oj(s) {
  var t = s.state, e = s.name;
  t.modifiersData[e] = lN({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const CA = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: Oj,
  data: {}
};
function Mj(s) {
  return s === "x" ? "y" : "x";
}
function Xj(s) {
  var t = s.state, e = s.options, a = s.name, n = e.mainAxis, i = n === void 0 ? !0 : n, r = e.altAxis, l = r === void 0 ? !1 : r, o = e.boundary, c = e.rootBoundary, d = e.altBoundary, p = e.padding, h = e.tether, g = h === void 0 ? !0 : h, x = e.tetherOffset, b = x === void 0 ? 0 : x, A = Dc(t, {
    boundary: o,
    rootBoundary: c,
    padding: p,
    altBoundary: d
  }), T = Fi(t.placement), R = Lc(t.placement), C = !R, v = fA(T), P = Mj(v), O = t.modifiersData.popperOffsets, N = t.rects.reference, H = t.rects.popper, F = typeof b == "function" ? b(Object.assign({}, t.rects, {
    placement: t.placement
  })) : b, B = typeof F == "number" ? {
    mainAxis: F,
    altAxis: F
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, F), Q = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, it = {
    x: 0,
    y: 0
  };
  if (O) {
    if (i) {
      var et, rt = v === "y" ? ls : os, U = v === "y" ? Ms : Xs, M = v === "y" ? "height" : "width", W = O[v], J = W + A[rt], vt = W - A[U], St = g ? -H[M] / 2 : 0, zt = R === Kl ? N[M] : H[M], j = R === Kl ? -H[M] : -N[M], tt = t.elements.arrow, lt = g && tt ? yA(tt) : {
        width: 0,
        height: 0
      }, at = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : aN(), nt = at[rt], yt = at[U], Rt = Kd(0, N[M], lt[M]), Yt = C ? N[M] / 2 - St - Rt - nt - B.mainAxis : zt - Rt - nt - B.mainAxis, K = C ? -N[M] / 2 + St + Rt + yt + B.mainAxis : j + Rt + yt + B.mainAxis, _ = t.elements.arrow && qu(t.elements.arrow), V = _ ? v === "y" ? _.clientTop || 0 : _.clientLeft || 0 : 0, G = (et = Q?.[v]) != null ? et : 0, dt = W + Yt - G - V, ht = W + K - G, ot = Kd(g ? ng(J, dt) : J, W, g ? Xl(vt, ht) : vt);
      O[v] = ot, it[v] = ot - W;
    }
    if (l) {
      var $t, _t = v === "x" ? ls : os, qt = v === "x" ? Ms : Xs, de = O[P], me = P === "y" ? "height" : "width", Ht = de + A[_t], oe = de - A[qt], Ye = [ls, os].indexOf(T) !== -1, ze = ($t = Q?.[P]) != null ? $t : 0, Lt = Ye ? Ht : de - N[me] - H[me] - ze + B.altAxis, ye = Ye ? de + N[me] + H[me] - ze - B.altAxis : oe, ue = g && Ye ? yj(Lt, de, ye) : Kd(g ? Lt : Ht, de, g ? ye : oe);
      O[P] = ue, it[P] = ue - de;
    }
    t.modifiersData[a] = it;
  }
}
const uN = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: Xj,
  requiresIfExists: ["offset"]
};
function Gj(s) {
  return {
    scrollLeft: s.scrollLeft,
    scrollTop: s.scrollTop
  };
}
function Hj(s) {
  return s === Gs(s) || !ai(s) ? xA(s) : Gj(s);
}
function Uj(s) {
  var t = s.getBoundingClientRect(), e = kc(t.width) / s.offsetWidth || 1, a = kc(t.height) / s.offsetHeight || 1;
  return e !== 1 || a !== 1;
}
function Fj(s, t, e) {
  e === void 0 && (e = !1);
  var a = ai(t), n = ai(t) && Uj(t), i = dl(t), r = Tc(s, n, e), l = {
    scrollLeft: 0,
    scrollTop: 0
  }, o = {
    x: 0,
    y: 0
  };
  return (a || !a && !e) && ((qi(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  AA(i)) && (l = Hj(t)), ai(t) ? (o = Tc(t, !0), o.x += t.clientLeft, o.y += t.clientTop) : i && (o.x = wA(i))), {
    x: r.left + l.scrollLeft - o.x,
    y: r.top + l.scrollTop - o.y,
    width: r.width,
    height: r.height
  };
}
function zj(s) {
  var t = /* @__PURE__ */ new Map(), e = /* @__PURE__ */ new Set(), a = [];
  s.forEach(function(i) {
    t.set(i.name, i);
  });
  function n(i) {
    e.add(i.name);
    var r = [].concat(i.requires || [], i.requiresIfExists || []);
    r.forEach(function(l) {
      if (!e.has(l)) {
        var o = t.get(l);
        o && n(o);
      }
    }), a.push(i);
  }
  return s.forEach(function(i) {
    e.has(i.name) || n(i);
  }), a;
}
function Bj(s) {
  var t = zj(s);
  return ZE.reduce(function(e, a) {
    return e.concat(t.filter(function(n) {
      return n.phase === a;
    }));
  }, []);
}
function Wj(s) {
  var t;
  return function() {
    return t || (t = new Promise(function(e) {
      Promise.resolve().then(function() {
        t = void 0, e(s());
      });
    })), t;
  };
}
function jj(s) {
  var t = s.reduce(function(e, a) {
    var n = e[a.name];
    return e[a.name] = n ? Object.assign({}, n, a, {
      options: Object.assign({}, n.options, a.options),
      data: Object.assign({}, n.data, a.data)
    }) : a, e;
  }, {});
  return Object.keys(t).map(function(e) {
    return t[e];
  });
}
var bI = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function vI() {
  for (var s = arguments.length, t = new Array(s), e = 0; e < s; e++)
    t[e] = arguments[e];
  return !t.some(function(a) {
    return !(a && typeof a.getBoundingClientRect == "function");
  });
}
function uf(s) {
  s === void 0 && (s = {});
  var t = s, e = t.defaultModifiers, a = e === void 0 ? [] : e, n = t.defaultOptions, i = n === void 0 ? bI : n;
  return function(l, o, c) {
    c === void 0 && (c = i);
    var d = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, bI, i),
      modifiersData: {},
      elements: {
        reference: l,
        popper: o
      },
      attributes: {},
      styles: {}
    }, p = [], h = !1, g = {
      state: d,
      setOptions: function(T) {
        var R = typeof T == "function" ? T(d.options) : T;
        b(), d.options = Object.assign({}, i, d.options, R), d.scrollParents = {
          reference: Jl(l) ? Jd(l) : l.contextElement ? Jd(l.contextElement) : [],
          popper: Jd(o)
        };
        var C = Bj(jj([].concat(a, d.options.modifiers)));
        return d.orderedModifiers = C.filter(function(v) {
          return v.enabled;
        }), x(), g.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!h) {
          var T = d.elements, R = T.reference, C = T.popper;
          if (vI(R, C)) {
            d.rects = {
              reference: Fj(R, qu(C), d.options.strategy === "fixed"),
              popper: yA(C)
            }, d.reset = !1, d.placement = d.options.placement, d.orderedModifiers.forEach(function(B) {
              return d.modifiersData[B.name] = Object.assign({}, B.data);
            });
            for (var v = 0; v < d.orderedModifiers.length; v++) {
              if (d.reset === !0) {
                d.reset = !1, v = -1;
                continue;
              }
              var P = d.orderedModifiers[v], O = P.fn, N = P.options, H = N === void 0 ? {} : N, F = P.name;
              typeof O == "function" && (d = O({
                state: d,
                options: H,
                name: F,
                instance: g
              }) || d);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: Wj(function() {
        return new Promise(function(A) {
          g.forceUpdate(), A(d);
        });
      }),
      destroy: function() {
        b(), h = !0;
      }
    };
    if (!vI(l, o))
      return g;
    g.setOptions(c).then(function(A) {
      !h && c.onFirstUpdate && c.onFirstUpdate(A);
    });
    function x() {
      d.orderedModifiers.forEach(function(A) {
        var T = A.name, R = A.options, C = R === void 0 ? {} : R, v = A.effect;
        if (typeof v == "function") {
          var P = v({
            state: d,
            name: T,
            instance: g,
            options: C
          }), O = function() {
          };
          p.push(P || O);
        }
      });
    }
    function b() {
      p.forEach(function(A) {
        return A();
      }), p = [];
    }
    return g;
  };
}
var Vj = /* @__PURE__ */ uf(), qj = [vA, CA, bA, gA], Kj = /* @__PURE__ */ uf({
  defaultModifiers: qj
}), Jj = [vA, CA, bA, gA, dN, oN, uN, iN, cN], pf = /* @__PURE__ */ uf({
  defaultModifiers: Jj
});
const pN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  afterMain: qE,
  afterRead: WE,
  afterWrite: QE,
  applyStyles: gA,
  arrow: iN,
  auto: cf,
  basePlacements: Hc,
  beforeMain: jE,
  beforeRead: zE,
  beforeWrite: KE,
  bottom: Ms,
  clippingParents: UE,
  computeStyles: bA,
  createPopper: pf,
  createPopperBase: Vj,
  createPopperLite: Kj,
  detectOverflow: Dc,
  end: Sc,
  eventListeners: vA,
  flip: oN,
  hide: cN,
  left: os,
  main: VE,
  modifierPhases: ZE,
  offset: dN,
  placements: hA,
  popper: Bo,
  popperGenerator: uf,
  popperOffsets: CA,
  preventOverflow: uN,
  read: BE,
  reference: FE,
  right: Xs,
  start: Kl,
  top: ls,
  variationPlacements: Hx,
  viewport: pA,
  write: JE
}, Symbol.toStringTag, { value: "Module" })), M$ = class M$ extends xi {
  constructor(t, e, a) {
    super(), this.$timeout = t, this.$element = e, this.$scope = a, this.enumCache = [], this.filteredItems = [], this.displayText = "", this.clearOnSelect = !1, this.allowCustomValues = !1, this.returnObject = !1, this.valueAsObject = !1;
  }
  /** Sets the default values in init. */
  $onInit() {
    this.enum && (this.filteredItems = this.getEnumerations()), super.$onInit(), this.$timeout(() => {
      this.value != null && (typeof this.value == "object" ? this.displayText = this.value.text : this.displayText = this.getEnumerationLabel(this.value)), this.createResultListElem();
    });
  }
  /** Delete dom stuff - click event, result list and popper instance - upon destroying of the component (for example changing the tab). */
  $onDestroy() {
    this.resultListElem?.remove && this.resultListElem.remove(), this.popperInstance?.destroy(), wt.element(document.body).off("click");
  }
  /** Creates the result list popper element. */
  createResultListElem() {
    this.resultListElem = this.$element[0].querySelector(".typeahead-result-list");
    const t = wt.element(document.body);
    this.popperInstance = pf(
      this.$element[0].querySelector(".typeahead-wrapper"),
      this.resultListElem,
      {
        placement: "bottom-start",
        modifiers: [
          {
            name: "flip",
            enabled: !1
          }
        ]
      }
    ), t.append(this.resultListElem);
    const e = (a) => {
      const n = a.target;
      !this.$element[0].contains(n) && this.resultListElem && !this.resultListElem.contains(n) && this.hideResultsList();
    };
    document.addEventListener("click", e), this.$scope.$on("$destroy", () => {
      this.popperInstance.destroy(), document.removeEventListener("click", e);
    });
  }
  /** Show results list. */
  showResultsList() {
    this.resultListElem.classList.remove("d-none"), this.resultListElem.classList.remove("ng-hide"), this.popperInstance.update();
  }
  /** Hide results list. */
  hideResultsList() {
    this.resultListElem.classList.add("d-none");
  }
  /** Options list */
  get options() {
    return this._options;
  }
  set options(t) {
    Array.isArray(t) && t.length && typeof t[0] != "object" && (t = t.map((e) => ({ value: e, text: e }))), this._options = t;
  }
  /** Select an item from the typeahead list. */
  selectItem(t) {
    this.onSelectFunction && this.onSelectFunction(t.value), this.value = this.valueAsObject ? t : t.value, this.displayText = t.text ? t.text : t.value, this.returnObject && this.$timeout(() => {
      this.objectData = t.object;
    }), this.filteredItems = [], this.hideResultsList(), super.onChange(), this.clearOnSelect && this.$timeout(() => {
      this.displayText = "", this.value = "";
    });
  }
  /**
   * Gets the label for an enumeration.
   * @param value Type of the enum.
   */
  getEnumerationLabel(t) {
    if (this.inputFormatter)
      return this.inputFormatter(t);
    const e = this.getEnumerations().find((a) => a.value === t);
    return e ? this.formatLabel(e) : t;
  }
  /** Formats the label for display and typeahed searches. */
  formatLabel(t) {
    switch (this.labelFormat) {
      case "value":
        return t.value;
      case "text-value": {
        let e = t.text ? L.get(t.text) : t.text;
        return e = e || t.value, `${e}${t.value ? " (" + t.value + ")" : ""}`;
      }
      case "title":
        return L.get(t.title) ?? L.get(t.text);
      case "text":
      default:
        return L.get(t.text);
    }
  }
  /**
   * Returns items for current enumeration.
   */
  getEnumerations() {
    if (this.enumCache.length > 0 && !this.disableCache)
      return this.enumCache;
    let t = [];
    if (this.options)
      Array.isArray(this.options) ? t = this.options.map((a) => a == null ? { value: null, text: "[null]" } : Qe.has(a, "value") || Qe.has(a, "text") ? {
        value: a.value,
        text: a.text,
        title: a.title && a.title !== a.value ? a.title : null,
        ui: a.ui ? a.ui : null
      } : { value: a, text: a }) : t = Object.keys(this.options).map((a) => ({ value: a, text: this.options[a], title: null }));
    else if (this.enum) {
      const a = He.getEnumMetadata(this.enum);
      a ? t = a.values.map((n) => ({
        value: n.name,
        text: n.label,
        title: n.descr && n.descr !== n.name ? n.descr : null
      })) : t = [{
        value: "",
        text: `ERROR: ${this.enum} not found.`,
        title: null
      }];
    }
    const e = ie.assureArray(this.filter);
    return e.length > 0 && (t = e.map((a) => t.find((n) => n.value === a)).filter((a) => a != null)), this.modifyOptions(t, this.enumCache), this.enumCache;
  }
  modifyOptions(t, e) {
    wt.equals(t, e) || (e.splice(0, e.length), e.push(...t));
  }
  /** Filter items based on the input query */
  filterEnumItems(t) {
    if (t)
      this.filteredItems = this.getEnumerations();
    else if (!this.value)
      this.filteredItems = this.getEnumerations();
    else {
      const e = this.getEnumerations();
      this.filteredItems = e.filter((a) => L.get(a.text).toLowerCase().includes(this.value.toLowerCase()) || L.get(a.title).toLowerCase().includes(this.value.toLowerCase()));
    }
  }
  /** Reacts to the changing input value. */
  async onInputChange() {
    this.getOptions ? this.filteredItems = await Promise.resolve(this.getOptions(this.displayText)) : this.options ? this.filteredItems = this.options.filter((t) => t.text?.toLowerCase().includes(this.displayText.toLowerCase()) || t.title?.toLowerCase().includes(this.displayText.toLowerCase()) || t.value?.toLowerCase().includes(this.displayText.toLowerCase())) : this.filterEnumItems(!1), this.filteredItems.length > 0 ? this.showResultsList() : this.hideResultsList(), this.allowCustomValues && (this.value = this.displayText, super.onChange());
  }
  /**
   * Clears the selected value in the input field.
   */
  clearValue() {
    this.$timeout(() => {
      this.value = "", this.displayText = "", super.onChange(), this.showAllItems(), this.$element[0].querySelector("input.typeahead-input").focus(), this.returnObject && (this.objectData = {});
    });
  }
  /** Show all typeahead results (that are currently at hand). Triggered via ng-click. */
  async showAllItems() {
    this.options ? this.filteredItems = this.options : this.getOptions ? this.filteredItems = await Promise.resolve(this.getOptions()) : this.enum && (this.filteredItems = this.getEnumerations()), this.filteredItems?.length > 0 && this.showResultsList();
  }
};
M$.$inject = ["$timeout", "$element", "$scope"];
let sg = M$;
class hN {
  constructor() {
  }
  /**
   * Handles the click event for the toggle button.
   * @param {string} value - The value to set for the ngModel.
   */
  onClick(t) {
    this.model.$setViewValue(t);
  }
}
const X$ = class X$ {
  constructor(t) {
    this.uiHelpers = t, this.layout = "default", this.$onInit = () => {
      this.layout != "minimal" && (this.layout = "default");
    };
  }
  /** If false, there is no validation object bound to the component. */
  get hasValidation() {
    return !!this.apiValidation;
  }
  /** If true, the validation has no errors. */
  get isValid() {
    return this.getValidation().isValid;
  }
  /** If false, has empty required fields. These are shown separately from other errors. */
  get hasAllRequiredFields() {
    return this.apiValidation?.hasAllRequiredFields ?? !1;
  }
  /** If true, there is no errors, but there are some warnings.  */
  get hasWarningsOnly() {
    return this.apiValidation?.isValid && !!this.apiValidation?.errors?.find((t) => t.type == Ra.Warning);
  }
  /** If true, has other errors than missing required fiels. */
  get hasValidationOrGeneralErrors() {
    return this.getErrors("!required").length > 0;
  }
  /**
   * Gets the errors, optionally filtered by a type.
   * @param type Type of the error: "general", "required", "invalid" or null.
   * If null, all errors are returned.
   * Also supports negation: "!general", "!required" or "!invalid".
   */
  getErrors(t) {
    const e = this.getValidation().errors || [];
    return t ? t.toString().startsWith("!") ? (t = t.substr(1), e.filter((a) => a.type !== t) || []) : e.filter((a) => a.type === t) || [] : e || [];
  }
  /**
   * Returns the label for the validation result.
   * The label is translated using the key: `SALAXY.VALIDATION.[error.code].label`
   * If the translation does not exist the `error.msg` is returned.
   * @param error - Error in validation.
   */
  getLabel(t) {
    const e = "SALAXY.VALIDATION." + t.code + ".label";
    return L.getWithDefault(e) || t.msg || "❗ERROR";
  }
  /**
   * Returns the description for the validation result.
   * The label is translated using the key: `SALAXY.VALIDATION.[error.code].description`
   * If the translation does not exist the `null` is returned.
   * @param error - Error in validation.
   */
  getDescription(t) {
    const e = "SALAXY.VALIDATION." + t.code + ".description";
    return L.getWithDefault(e) || t.description;
  }
  /**
   * Returns true if the translation for the key `SALAXY.VALIDATION.[error.code].description` exists.
   * @param error - Error in validation.
   */
  hasDescription(t) {
    return !!this.getDescription(t);
  }
  /** Shows details of the errors. */
  showDetails() {
    this.uiHelpers.showDialog(
      "salaxy-components/form-controls/ValidationSummaryDetails.html",
      null,
      // controller
      {
        controller: () => this
      },
      null
      // window template URL
    );
  }
  getValidation() {
    return this.apiValidation || {
      errors: [],
      hasAllRequiredFields: !0,
      isValid: !1
    };
  }
};
X$.$inject = ["UiHelpers"];
let ig = X$;
class mN extends Ia {
  /** Set the values and defaults on init */
  $onInit() {
    super.$onInit();
  }
  /** Delete one multiplier */
  delete(t) {
    delete this.value[t], this.onChange();
  }
  /** Add one multiplier */
  createNew() {
    let t = 1;
    this.value || (this.value = {});
    for (const e in this.value) {
      const a = Number.parseInt(e);
      a >= t && (t = a + 1);
    }
    this.value[t] = 0, this.onChange();
  }
  /** On key changed event. */
  onKeyChanged(t, e) {
    if (t !== e) {
      const a = this.value[t];
      delete this.value[t], this.value[e] = a;
    }
    this.onChange();
  }
}
const G$ = class G$ extends xi {
  constructor(t, e) {
    super(), this.uiHelpers = t, this.rowTypeService = e;
  }
  /** Set the values and defaults on init */
  $onInit() {
    super.$onInit();
  }
  /** Returns true if this is an exclusive row type.  */
  get isExclusive() {
    return (this.value ?? "").startsWith("!");
  }
  /** Returns text for the row type */
  get text() {
    if (!this.value)
      return "";
    const t = this.parseRowType(this.value);
    switch (t.baseType) {
      case "rowType":
        return L.get("SALAXY.NG1.WorkerHolidaysComponent.UI.inputs.rowType") + ": " + this.getCalculationRowTypeLabel(t.type, t.kind) + (t.unit ? ` (${He.getEnumLabel("CalculationRowUnit", t.unit, null, null)})` : "");
      case "incomeType": {
        const e = Tn.getAll(null).find((a) => a.code + "" == t.type);
        return `Tulolaji: ${e?.code} - ` + e?.label + (t.unit ? ` (${He.getEnumLabel("CalculationRowUnit", t.unit, null, null)})` : "");
      }
      case "type":
        return L.get("SALAXY.NG1.WorkerHolidaysComponent.UI.inputs.wageType") + ": " + t.type + (t.kind ? `/${t.kind}` : "") + (t.unit ? ` (${He.getEnumLabel("CalculationRowUnit", t.unit, null, null)})` : "");
    }
  }
  /** Edit entry. */
  edit() {
    const t = this.rowTypeService, e = {
      readOnly: this.getReadOnly(),
      _userDefinedRow: {
        item: null,
        row: {
          data: {
            get kind() {
              return e._userDefinedRow.item.kind;
            },
            set kind(a) {
              e._userDefinedRow.item.kind = a;
            }
          },
          get rowType() {
            return e._userDefinedRow.item.baseType == "type" ? (!e._userDefinedRow.item._type && e._userDefinedRow.item.type && (e._userDefinedRow.item._type = t.getConfigs().find((a) => a.type == e._userDefinedRow.item.type)?.rowType), e._userDefinedRow.item._type) : e._userDefinedRow.item.type;
          },
          set rowType(a) {
            e._userDefinedRow.item.baseType == "type" ? e._userDefinedRow.item._type = a : e._userDefinedRow.item.type = a;
          },
          get type() {
            return e._userDefinedRow.item.baseType == "type" ? e._userDefinedRow.item.type : e._userDefinedRow.item._type;
          },
          set type(a) {
            e._userDefinedRow.item.baseType == "type" ? e._userDefinedRow.item.type = a : e._userDefinedRow.item._type = a;
          }
        }
      },
      asUserDefinedRow: (a) => (e._userDefinedRow.item = a, e._userDefinedRow.row)
    };
    this.uiHelpers.openEditDialog(
      "salaxy-components/modals/form-controls/HolidayRowTypeEdit.html",
      this.parseRowType(this.value),
      e
    ).then((a) => {
      a.action === We.Ok && (this.value = a.item.baseType == "type" ? this.composeType(a.item) : this.composeRowType(a.item), this.onChange());
    });
  }
  getCalculationRowTypeLabel(t, e) {
    let a = "";
    if (t === Wt.IrIncomeType)
      a = Tn.getAll(null).find((n) => e && n.transactionCode === e)?.label;
    else if (e) {
      const n = Gi.getRowConfig(t);
      a = He.getEnumLabel(n.kind.name, e, null, null);
    }
    return a || He.getEnumLabel("CalculationRowType", t, null, null);
  }
  parseRowType(t) {
    if (!t)
      return { isExclusive: !1 };
    let e = !1, a = "", n = "", i = "";
    t.startsWith("!") && (e = !0, t = t.substring(1));
    const r = t.split(".")[0];
    switch (t.lastIndexOf("-") > 0 && (a = t.substring(t.lastIndexOf("-") + 1), t = t.substring(0, t.lastIndexOf("-"))), r) {
      case "incomeType":
        i = t.split(".")[1];
        break;
      case "rowType":
        {
          const l = t.split(".");
          i = l[1], l.length == 3 && (n = l[2]);
        }
        break;
      case "type":
        {
          const o = t.substring(t.indexOf(".") + 1).split("/");
          o.length >= 3 && (i = "/" + o[1] + "/" + o[2]), o.length == 4 && (n = o[3]);
        }
        break;
    }
    return { baseType: r, type: i, kind: n, unit: a, isExclusive: e };
  }
  composeRowType(t) {
    if (!t?.baseType || !t?.type)
      return "";
    let e = `${t.baseType}.${t.type}`;
    return t.kind && (e += `.${t.kind}`), t.unit && t.unit !== "undefined" && (e += `-${t.unit}`), t.isExclusive && (e = "!" + e), e;
  }
  composeType(t) {
    if (!t?.baseType || !t?.type)
      return "";
    let e = `${t.baseType}.${t.type}`;
    return t.kind && (e += `/${t.kind}`), t.unit && t.unit !== "undefined" && (e += `-${t.unit}`), t.isExclusive && (e = "!" + e), e;
  }
};
G$.$inject = ["UiHelpers", "RowTypeService"];
let rg = G$;
const H$ = class H$ {
  /**
   * Creates a new InputController
   * @ignore
   */
  constructor() {
    this.$onInit = () => {
      this.buttonClass = this.buttonClass || "btn-primary";
    };
  }
  /**
   * Returns environment based on config.
   * TODO: Replace this with ConfigsLogic
   */
  getEnv() {
    const t = Ne.current;
    return t.isTestData ? t.apiServer?.indexOf("localhost") > -1 ? "local" : t.integrationsServer?.indexOf("test") > -1 ? "test" : t.apiServer?.indexOf("rc") > -1 ? "rc" : "demo" : "prod";
  }
};
H$.$inject = [];
let lg = H$;
const U$ = class U$ {
  /**
   * Creates a new AlertController
   * @ignore
   */
  constructor(t) {
    this.$transclude = t, this.forceMoreInfo = !1, this.$onInit = () => {
    };
  }
  /** Returns true if details part (aside element) is filled / "More info" button should be shown. */
  get hasMoreInfo() {
    return this.$transclude.isSlotFilled("aside");
  }
  /** Returns the icon based on the type. */
  getIcon() {
    if (!this.icon)
      switch (this.type) {
        case "danger":
          return "bi-exclamation-lg";
        case "success":
          return "bi-check-lg";
        case "warning":
          return "bi-exclamation-triangle-fill";
        default:
          return "bi-info";
      }
    return this.icon === "none" ? null : this.icon;
  }
};
U$.$inject = ["$transclude"];
let og = U$;
const F$ = class F$ {
  /**
   * Creates a new AvatarController
   * @ignore
   */
  constructor() {
    this.$onInit = () => {
    };
  }
  /** Returns true if the avatar is an image url (as opposed to icon rendering) */
  get isImage() {
    return this.avatar != null && (this.avatar.pictureType === is.Uploaded || this.avatar.pictureType === is.Gravatar) && this.avatar.url != null && this.avatar.url.substr(0, 4).toLowerCase() === "http";
  }
  /** Returns true if the avatar should be rendered as a person icon */
  get isPersonIcon() {
    return this.avatar != null && !this.isImage && this.avatar.entityType !== "company";
  }
  /** Returns true if the avatar should be rendered as a company icon */
  get isCompanyIcon() {
    return this.avatar == null || !this.isImage && this.avatar.entityType === "company";
  }
  /** Returns the avatar color or 'gray' if nothing is defined. */
  get color() {
    return this.avatar ? this.getColor(this.avatar.color) : "gray";
  }
  /** Returns the initials for rendering the avatar */
  get initials() {
    return this.avatar ? this.avatar.initials || "-" : "?";
  }
  /**
   * Return the color for the avatar icon and line strokes.
   * If some colors require adjustments due to accessibility reasons, they can be implemented here.
   */
  getColor(t) {
    switch (t) {
      case "yellow":
        return "#ebc000";
      case "lime":
        return "limegreen";
      case "pink":
        return "#ff8fa2";
      default:
        return t;
    }
  }
};
F$.$inject = [];
let cg = F$;
const z$ = class z$ {
  /**
   * Constructor for dependency instance.
   * @param $uibModalInstance Modal instance supports functions such as close(result), dismiss(reason) and promises result, opened, closed and rendered.
   * @param data Rest of the data injected from the caller.
   */
  constructor(t, e, a, n, i) {
    this.$uibModalInstance = t, this.$timeout = n, this.jsonSchemaService = i, this.isProcessStarted = !1, this.openApi = "salaxy-secure/schemas/v02.json", this.$onInit = () => {
      this.resetProcessed(), this.autoStart === !0 && this.startProcess(), this.data.listItemType ? this.openApiDoc ? (this.jsonSchemaService.addSchemaDocument(this.openApi, this.openApiDoc), this.schemaModel = this.jsonSchemaService.findSchema(this.openApi, this.data.listItemType), this.isReady = !0) : this.jsonSchemaService.assureSchemaDocument(this.openApi).then((r) => {
        this.openApiDoc = r, this.schemaModel = this.jsonSchemaService.findSchema(this.openApi, this.data.listItemType), this.isReady = !0;
      }) : this.isReady = !0;
    }, this.data = e, this.dialogHeader = this.data.dialogHeader || L.get("SALAXY.NG1.BatchProcessComponent.title"), this.list = this.data.dialogList || [], this.columns = this.getColumns(this.data.gridColumns), this.method = this.data.batchMethod, this.chunkSize = this.data.chunkSize ?? 0, this.autoStart = this.data.autoStart ?? !1, this.autoClose = this.data.autoClose ?? !1, this.tableOptions = this.getGridOptions(), this.batchTemplateUrl = a.trustAsResourceUrl(e.batchTemplateUrl);
  }
  /** Starts the processing */
  startProcess() {
    this.isProcessStarted || (this.isProcessStarted = !0, this.resetProcessed(), this.processNextItems());
  }
  /** Processes next items in the queue */
  processNextItems() {
    this.$timeout(() => {
      this.processNextItemsInternal();
      try {
        this.$table.tabulator.replaceData(this.list);
      } catch {
      }
    });
  }
  processNextItemsInternal() {
    const t = this.processCounter;
    if (t.isProcessing = !0, t.canceling) {
      t.isProcessing = !1, t.isDone = !0;
      return;
    }
    const e = this.list.filter((a) => !a.processed);
    if (e.length === 0)
      t.isProcessing = !1, t.isDone = !0, this.data.done = !0, this.autoClose && this.close();
    else {
      const a = e.slice(0, this.chunkSize > 0 ? this.chunkSize : 1);
      for (const n of a)
        n.processed = L.get("SALAXY.NG1.BatchProcessComponent.processing");
      this.method(this.chunkSize > 0 ? a : a[0], this.data).then((n) => {
        let i = 0;
        for (const r of a)
          r.processed = "OK " + n[i].message, r.processedResult = { message: n[i].message, result: n[i].result }, i++;
        t.processedCount += a.length, this.processNextItems();
      }).catch((n) => {
        let i = "Server error", r = "Unknown error";
        n && (r = n.statusText || r, n.data && (i = n.data.error || i, r = n.data.messageHtml || r));
        for (const l of a)
          l.processed = "ERR " + i + ". " + r, l.processedResult = null;
        console.error(i, n), t.processedCount += a.length, t.errorsCount += a.length, this.processNextItems();
      });
    }
  }
  /** Closes the dialog. */
  close() {
    this.resetProcessed(), this.$uibModalInstance.close();
  }
  /** Resets the processed status column(s) */
  resetProcessed() {
    for (const t of this.list)
      t.processed && (t.processed = null);
    this.processCounter = {
      isProcessing: !1,
      isDone: !1,
      totalCount: this.list.length,
      processedCount: 0,
      errorsCount: 0,
      canceling: !1
    };
  }
  /** Cancels the process: Waits for the next response, but does not start a new one. */
  cancelProcess() {
    this.processCounter.canceling = !0;
  }
  getColumns(t) {
    const e = [
      ...this.getAvatarCols("owner", L.get("SALAXY.NG1.BatchProcessComponent.employer"), { width: 300 }),
      ...this.getAvatarCols("other", L.get("SALAXY.NG1.BatchProcessComponent.worker"), { width: 400 }),
      {
        field: "status",
        title: L.get("SALAXY.NG1.BatchProcessComponent.status"),
        formatter: (a) => {
          const n = a.getData().status, i = ol.getProperty(this.schemaModel, "status")?.schema?.format;
          return n ? i ? L.get(`SALAXY.ENUM.${i}.${n}.label`) : `<div>${n}</div>` : "<div>-</div>";
        }
      }
    ];
    return typeof t == "string" && (t = ie.assureArray(t)), t?.length || (t = e), t.find((a) => a == "processed" || a.field === "processed") || t.splice(0, 0, {
      width: 400,
      field: "processed",
      title: L.get("SALAXY.NG1.BatchProcessComponent.processed")
      // TODO: cellTemplate: "salaxy-aspa-components/grid-col/processed.html",
      // eslint-disable-next-line
      // cellTooltip: (row, col) => row.entity.processed,
    }), t;
  }
  /**
   * Gets a column definition for avatar column: Renders an avatar with sortable name and second info line.
   * @param party The party to render: either "owner" (ownerInfo) or "other" (otherPartyInfo).
   * @param title The title of the column.
   * @param props Other properties that should be set on the column.
   */
  getAvatarCols(t, e, a) {
    const n = t === "other" ? "otherPartyInfo" : "ownerInfo";
    return [
      {
        field: `${n}.avatar.sortableName`,
        title: e,
        headerFilter: !0,
        formatter: (r) => {
          const l = r.getData()[n];
          return `
              <div class="tabulator-avatar">${k0.getAvatar(l?.avatar)}${l?.avatar?.sortableName || "-"}</div>
          `;
        },
        ...a
      }
    ];
  }
  /**
   * Gets a column definition for enumerations column
   * @param field The field name / path in the data model.
   * @param title The title of the column.
   * @param enumType The type name of the enumeration.
   * @param props Other properties that should be set on the column.
   */
  getEnumColumn(t, e, a, n) {
    return {
      field: t,
      title: e,
      formatter: (i) => He.getEnumLabel(a, i.getValue()),
      headerFilter: "list",
      headerFilterFunc: "=",
      headerFilterParams: {
        values: He.getEnumMetadata(a)?.values.map((i) => ({ label: i.label, value: i.name }))
      },
      ...n
    };
  }
  /** Gets the options for the UI grid */
  getGridOptions() {
    return {
      height: "50vh",
      layout: "fitColumns"
    };
  }
};
z$.$inject = ["$uibModalInstance", "data", "$sce", "$timeout", "JsonSchemaService"];
let zx = z$;
const B$ = class B$ {
  constructor(t, e) {
    this.uiHelpers = t, this.$http = e, this.weekdaysForMonth = [], this.showExport = !1, this.HOLIDAY_COLOR = "#BBB", this.WEEKEND_COLOR = "#DDD", this.EVENT_COLOR = "#009fd8", this.$onInit = () => {
      this.start = I.asDate(this.start) || I.getDate("today", 1, 1), this.end = I.asDate(this.end) || I.getDate("today", 12, 31), this.today = I.asDate(this.today) || I.getToday(), this.weekdays = Array.from("1234567").map((a) => L.getWithDefault(`SALAXY.ENUM.Weekday.day${a}.short`, "d" + a)), this.initHeader();
    }, this.getCacheKey = () => wt.copy({
      data: this.data,
      start: "" + this.start,
      end: "" + this.end,
      mode: this.mode || "",
      today: this._today
    }), this.cacheCounter = 0;
  }
  /** Initialize the header (days) */
  initHeader() {
    switch (this.mode) {
      case "align-left":
        this.weekdaysForMonth = [...Array(31)].map((t, e) => ({ ix: e, text: (e + 1).toString() }));
        break;
      case "horizontal":
        break;
      default:
        for (let t = 0; t < 5; t++)
          this.weekdaysForMonth.push(...this.weekdays.map((e, a) => ({ ix: t * 7 + a, weekday: a + 1, text: e })));
        this.weekdaysForMonth.push({ ix: 5 * 7 + 0, weekday: 1, text: this.weekdays[0] }, { ix: 5 * 7 + 1, weekday: 2, text: this.weekdays[1] });
        break;
    }
  }
  /**
   * Specifies how the weekdays are aligned from one month to another.
   * "horizontal" shows all months side-by-side horizontally, so there is no alignment.
   */
  get mode() {
    switch (this._mode) {
      case "align-left":
      case "horizontal":
      case "list":
        return this._mode;
      default:
        return "align-weekdays";
    }
  }
  set mode(t) {
    this._mode = t;
  }
  /** Gets the Today date for the calendar as ISO date yyyy-MM-dd. */
  get today() {
    return this._today || (this._today = I.getToday()), this._today;
  }
  /** Sets the Today date as dately object (e.g. ISO string, JS Date or key string "today") */
  set today(t) {
    this._today = I.asDate(t);
  }
  /** Gets all days of all months */
  get allDays() {
    return this.uiHelpers.cache(this, "allDays", () => this.months.reduce((t, e) => t.concat(e.days), []), () => this.cacheCounter);
  }
  /**
   * Gets the data harmonized as an array of Calendar Series
   */
  get series() {
    return this._series;
  }
  /**
   * Gets the monthly list: Only the dates that have events on them.
   * Only the start of event is considered except for the first month where all intercepting properties are.
   */
  get monthlyList() {
    return this.uiHelpers.cache(this, "monthList", () => this.months.map((e) => ({
      daysInMonth: e.daysInMonth,
      firstDayDayOfWeek: e.firstDayDayOfWeek,
      month: e.month,
      title: e.title,
      year: e.year,
      days: e.days.map((n) => {
        let i = 0;
        return Object.keys(n.events).reduce((r, l) => (r[l] = n.events[l], i += r[l].length, r), {}), i ? {
          day: n.day,
          date: n.date,
          weekday: n.weekday,
          weekdayText: n.weekdayText,
          dayType: n.dayType,
          events: n.events.map((r) => r.filter((l) => n.date === l.start)),
          periods: null,
          // Add support if needed
          singleDays: null
        } : null;
      }).filter((n) => !!n)
    })), () => this.cacheCounter);
  }
  /** The collection of months that the calendar renders. */
  get months() {
    return this.uiHelpers.cache(this, "months", () => {
      const t = [], e = I.startEnd(this.start || "today", "start-month"), a = I.startEnd(this.end || "today", "start-month");
      this.assureNormalizedCopy();
      const n = this.series || [];
      if (!I.isValidDateTime(e) || !I.isValidDateTime(a) || e > a)
        return console.error("Invalid date range in CalendarController."), [];
      let i = e;
      for (; i <= a; ) {
        const r = I.getDaysInMonth(i), l = I.getWeekday(i), o = {
          month: I.getMonth(i),
          year: I.getYear(i),
          title: L.get(`SALAXY.ENUM.CalendarMonth.month${I.getMonth(i)}.label`),
          firstDayDayOfWeek: l,
          daysInMonth: r,
          days: []
        };
        for (let c = 1; c <= r; c++) {
          const d = I.setDay(i, c), p = I.getWeekday(d), h = n.map((b) => b.events.filter((A) => A.end && !A.icon && A.start <= d && A.end >= d)), g = n.map((b) => b.events.filter((A) => (!A.end || A.icon) && d === A.start)), x = n.map((b) => b.events.filter((A) => d === A.start || A.end && !A.icon && A.start < d && A.end >= d));
          o.days.push({
            day: c,
            date: d,
            weekday: p,
            weekdayText: this.weekdays[p - 1],
            dayType: d === this.today ? "today" : I.isHoliday(d) ? "holiday" : "normal",
            events: x,
            periods: h,
            singleDays: g
          });
        }
        t.push(o), i = I.add(i, 1, "month");
      }
      return t;
    }, this.getCacheKey);
  }
  /**
   * Gets the short text "ma", "ti", "ke", "to", "pe", "la", "su".
   * @param date Date as ISO string or date
   */
  getShortWeekdayText(t) {
    return this.weekdays[I.getWeekday(t) - 1];
  }
  /** Gets the CSS class(es) for a calendar event. */
  getCssClass(t) {
    return t ? t.icon ? `fa ${t.icon} event-single-day ${t.cssClass || "text-info"} clickable` : `event-period ${t.cssClass || "salaxy-cal-event-primary"} clickable` : null;
  }
  /**
   * Get the event CSS style for a single day. Main thing is to set the disposition and smaller size if the day has overlapping items.
   * @param event Event for which to calculate the styles.
   * @param allEvents All events in the given series/type: Either period or singleDay.
   */
  getEventStyle(t, e) {
    if (t.icon) {
      const a = e.indexOf(t);
      switch (e.length) {
        case 1:
          return null;
        case 2:
          return {
            "font-size": "12px",
            bottom: (a === 1 ? 0 : 8) + "px",
            left: (a === 1 ? 2 : -4) + "px"
          };
        case 3:
          return {
            "font-size": "10px",
            bottom: (a > 1 ? 0 : 8) + "px",
            left: (a === 0 ? -4 : a === 2 ? 0 : 4) + "px"
          };
        default:
          return {
            "font-size": "10px",
            bottom: (a > 1 ? 0 : 8) + "px",
            left: (a === 0 || a === 2 ? -4 : 4) + "px"
          };
      }
    } else if (e.length > 1) {
      const a = (this.mode === "horizontal" ? 30 : 16) / e.length, n = e.indexOf(t);
      return {
        height: a + "px",
        bottom: a * (e.length - 1 - n) + "px"
      };
    }
    return null;
  }
  /**
   * A date in the calendar was clicked.
   * @param day Day that was clicked.
   * @param series The series that contains the event.
   * If null, the click is in header etc. where series is not available.
   * @param $event The AngularJS event used to stop propagation.
   */
  dateClicked(t, e, a) {
    if (a.stopPropagation(), e = e || this.series[0], this.listController && e) {
      this.listController.parent = e.data;
      const n = this.listController.getBlank();
      n.period && (n.period.start = t.date, n.period.end = t.date), this.listController.showEditDialog(n, !0);
      return;
    }
    this.onListSelect({
      type: "day",
      date: t.date,
      day: t,
      series: e
    });
  }
  /**
   * Called by view when an event is clicked.
   * @param ev Event that is being clicked
   * @param day Day on which the event occurs
   * @param series The series that contains the event. If null, the first series is taken.
   * @param $event AngularJS event: Used for stopping propagation.
   */
  eventClicked(t, e, a, n) {
    if (n.stopPropagation(), a = a || this.series[0], this.listController && a) {
      this.listController.parent = a.data, this.listController.showEditDialog(t.data);
      return;
    }
    this.onListSelect({
      type: "event",
      date: e.date,
      day: e,
      calEvent: t,
      series: a
    });
  }
  /**
   * A series title in the calendar was clicked.
   * @param series The series.
   * @param $event The AngularJS event used to stop propagation.
   */
  seriesClicked(t, e) {
    e.stopPropagation(), this.onListSelect({
      type: "series",
      date: void 0,
      day: void 0,
      series: t
    });
  }
  /**
   * Exports the calendar as a PDF.
   * This method shows a loading indicator, constructs a URL for the PDF request,
   * and handles the PDF request.
   */
  exportCalendarPdf() {
    const t = this.uiHelpers.showLoading("SALAXY.UI_Terms.loading"), e = `${Ne.current.reportServer}/pdf?reportType=calendar&language=${encodeURIComponent(L.getLanguage())}&disposition=inline`;
    this.handlePdfRequest(e, !1, { object: { months: this.months, series: this.series } }, t);
  }
  async handlePdfRequest(t, e, a, n) {
    try {
      await this.fetchPdf(t, a, e);
    } catch (i) {
      if (t.includes(Ne.current.reportServer) && Ne.current.getEnv() === "prod") {
        t = t.replace(
          Ne.current.reportServer,
          "https://failover-reports.salaxy.com"
        );
        try {
          await this.fetchPdf(t, a, e);
        } catch (r) {
          console.error(r);
        }
      } else
        console.error(i);
    }
    n && n.dismiss();
  }
  async fetchPdf(t, e, a) {
    let n;
    e ? n = await this.$http.post(t, e, { responseType: "blob" }) : n = await this.$http.get(t, { responseType: "blob" }), n.data && (a ? this.uiHelpers.openFile(n.data) : this.uiHelpers.downloadFile(
      n.data,
      decodeURIComponent(n.headers("content-disposition")).match(
        /filename\s*=\s*"?(?<file>.*?)(?:\s*;|"|\s*$)/
      )?.groups?.file
    ));
  }
  /**
   * Export the calendar as Excel.
   */
  exportCalendarExcel() {
    const t = this.generateExcelHeaders(), e = this.generateExcelDataRows(), a = [t, ...e];
    xr.export(a, "lomakalenteri");
  }
  generateExcelHeaders() {
    const t = ["Työntekijä"];
    return this.allDays.forEach((e) => {
      t.push(I.getFormattedDate(e.date));
    }), t;
  }
  generateExcelDataRows() {
    return this.series.map((t) => this.generateExcelDataRow(t));
  }
  generateExcelDataRow(t) {
    const e = [];
    return e.push(`${t.title} ${dn.getPlannedLeavesCount(t.data, "all")}/${t.data.accrual.endSaldo} pv`), this.allDays.forEach((a) => {
      const n = t.events.some((i) => a.date >= i.start && a.date <= i.end);
      e.push(n ? 1 : " ");
    }), e;
  }
  /**
   * Copies the data as normalized data set so that we can harmonize the dates and potentially make other changes in the future.
   * Copy is shallow copy of CalendarUiEvent.
   */
  assureNormalizedCopy() {
    const t = [];
    if (!this.data)
      return t;
    if (this.mapper)
      this.mapper(this.data).forEach((a, n) => {
        t.push({
          key: a.key || "Series" + n,
          title: a.title,
          description: a.description,
          avatar: a.avatar,
          events: a.events.map((i) => Object.assign({}, i)),
          data: a.data
        });
      });
    else {
      const e = {
        key: "default",
        avatar: null,
        title: null,
        events: [],
        data: null
      };
      this.data.forEach((a, n) => {
        typeof a == "string" ? e.events.push({ start: a }) : a?.start ? e.events.push(Object.assign({}, a)) : a?.key === "default" ? (e.events.push(...a.events.map((i) => Object.assign({}, i))), e.avatar = a.avatar || e.avatar, e.title = a.title || e.title, e.description = a.description || e.description) : Array.isArray(a?.events) && t.push({
          key: a.key || "Series" + n,
          title: a.title,
          description: a.description,
          avatar: a.avatar,
          events: a.events.map((i) => Object.assign({}, i)),
          data: a.data
        });
      }), e.events.length && t.splice(0, 0, e);
    }
    t.forEach((e) => {
      e.events.forEach((a) => {
        a.start = I.asDate(a.start), a.end = I.asDate(a.end), a.end || (a.icon = a.icon || "bi-circle-fill");
      });
    }), this.cacheCounter++, this._series = t;
  }
};
B$.$inject = ["UiHelpers", "$http"];
let dg = B$;
/*!
* chartjs-plugin-annotation v3.0.1
* https://www.chartjs.org/chartjs-plugin-annotation/index
 * (c) 2023 chartjs-plugin-annotation Contributors
 * Released under the MIT License
 */
const xI = {
  modes: {
    /**
     * Point mode returns all elements that hit test based on the event position
     * @param {Object} state - the state of the plugin
     * @param {ChartEvent} event - the event we are find things at
     * @return {AnnotationElement[]} - elements that are found
     */
    point(s, t) {
      return tm(s, t, { intersect: !0 });
    },
    /**
     * Nearest mode returns the element closest to the event position
     * @param {Object} state - the state of the plugin
     * @param {ChartEvent} event - the event we are find things at
     * @param {Object} options - interaction options to use
     * @return {AnnotationElement[]} - elements that are found (only 1 element)
     */
    nearest(s, t, e) {
      return tV(s, t, e);
    },
    /**
     * x mode returns the elements that hit-test at the current x coordinate
     * @param {Object} state - the state of the plugin
     * @param {ChartEvent} event - the event we are find things at
     * @param {Object} options - interaction options to use
     * @return {AnnotationElement[]} - elements that are found
     */
    x(s, t, e) {
      return tm(s, t, { intersect: e.intersect, axis: "x" });
    },
    /**
     * y mode returns the elements that hit-test at the current y coordinate
     * @param {Object} state - the state of the plugin
     * @param {ChartEvent} event - the event we are find things at
     * @param {Object} options - interaction options to use
     * @return {AnnotationElement[]} - elements that are found
     */
    y(s, t, e) {
      return tm(s, t, { intersect: e.intersect, axis: "y" });
    }
  }
};
function $A(s, t, e) {
  return (xI.modes[e.mode] || xI.modes.nearest)(s, t, e);
}
function Qj(s, t, e) {
  return e !== "x" && e !== "y" ? s.inRange(t.x, t.y, "x", !0) || s.inRange(t.x, t.y, "y", !0) : s.inRange(t.x, t.y, e, !0);
}
function Zj(s, t, e) {
  return e === "x" ? { x: s.x, y: t.y } : e === "y" ? { x: t.x, y: s.y } : t;
}
function tm(s, t, e) {
  return s.visibleElements.filter((a) => e.intersect ? a.inRange(t.x, t.y) : Qj(a, t, e.axis));
}
function tV(s, t, e) {
  let a = Number.POSITIVE_INFINITY;
  return tm(s, t, e).reduce((n, i) => {
    const r = i.getCenterPoint(), l = Zj(t, r, e.axis), o = vc(t, l);
    return o < a ? (n = [i], a = o) : o === a && n.push(i), n;
  }, []).sort((n, i) => n._index - i._index).slice(0, 1);
}
const eV = (s, t) => t > s || s.length > t.length && s.slice(0, t.length) === t, Yl = 1e-3, hf = (s, t, e) => Math.min(e, Math.max(t, s));
function aV(s, t, e) {
  for (const a of Object.keys(s))
    s[a] = hf(s[a], t, e);
  return s;
}
function nV(s, t, e, a) {
  if (!s || !t || e <= 0)
    return !1;
  const n = a / 2;
  return Math.pow(s.x - t.x, 2) + Math.pow(s.y - t.y, 2) <= Math.pow(e + n, 2);
}
function gN(s, { x: t, y: e, x2: a, y2: n }, i, r) {
  const l = r / 2, o = s.x >= t - l - Yl && s.x <= a + l + Yl, c = s.y >= e - l - Yl && s.y <= n + l + Yl;
  return i === "x" ? o : (i === "y" || o) && c;
}
function Uc(s, t) {
  const { centerX: e, centerY: a } = s.getProps(["centerX", "centerY"], t);
  return { x: e, y: a };
}
function sV(s, t, e, a = !0) {
  const n = e.split(".");
  let i = 0;
  for (const r of t.split(".")) {
    const l = n[i++];
    if (parseInt(r, 10) < parseInt(l, 10))
      break;
    if (eV(l, r)) {
      if (a)
        throw new Error(`${s} v${e} is not supported. v${t} or newer is required.`);
      return !1;
    }
  }
  return !0;
}
const yN = (s) => typeof s == "string" && s.endsWith("%"), fN = (s) => parseFloat(s) / 100, bN = (s) => hf(fN(s), 0, 1), $h = (s, t) => ({ x: s, y: t, x2: s, y2: t, width: 0, height: 0 }), iV = {
  box: (s) => $h(s.centerX, s.centerY),
  ellipse: (s) => ({ centerX: s.centerX, centerY: s.centerX, radius: 0, width: 0, height: 0 }),
  label: (s) => $h(s.centerX, s.centerY),
  line: (s) => $h(s.x, s.y),
  point: (s) => ({ centerX: s.centerX, centerY: s.centerY, radius: 0, width: 0, height: 0 }),
  polygon: (s) => $h(s.centerX, s.centerY)
};
function SA(s, t) {
  return t === "start" ? 0 : t === "end" ? s : yN(t) ? bN(t) * s : s / 2;
}
function nl(s, t, e = !0) {
  return typeof t == "number" ? t : yN(t) ? (e ? bN(t) : fN(t)) * s : s;
}
function rV(s, t) {
  const { x: e, width: a } = s, n = t.textAlign;
  return n === "center" ? e + a / 2 : n === "end" || n === "right" ? e + a : e;
}
function kA(s, t = "center") {
  return Ve(s) ? {
    x: Fe(s.x, t),
    y: Fe(s.y, t)
  } : (s = Fe(s, t), {
    x: s,
    y: s
  });
}
function vN(s) {
  return s && (Cs(s.xValue) || Cs(s.yValue));
}
function Ku(s, t, e) {
  const a = e.init;
  if (a) {
    if (a === !0)
      return wN(t, e);
  } else
    return;
  return lV(s, t, e);
}
function xN(s, t, e) {
  let a = !1;
  return t.forEach((n) => {
    As(s[n]) ? (a = !0, e[n] = s[n]) : Cs(e[n]) && delete e[n];
  }), a;
}
function wN(s, t) {
  const e = t.type || "line";
  return iV[e](s);
}
function lV(s, t, e) {
  const a = Sa(e.init, [{ chart: s, properties: t, options: e }]);
  if (a === !0)
    return wN(t, e);
  if (Ve(a))
    return a;
}
const ev = /* @__PURE__ */ new Map(), oV = (s) => isNaN(s) || s <= 0, cV = (s) => s.reduce(function(t, e) {
  return t += e.string, t;
}, "");
function mf(s) {
  if (s && typeof s == "object") {
    const t = s.toString();
    return t === "[object HTMLImageElement]" || t === "[object HTMLCanvasElement]";
  }
}
function TA(s, { x: t, y: e }, a) {
  a && (s.translate(t, e), s.rotate(bn(a)), s.translate(-t, -e));
}
function sl(s, t) {
  if (t && t.borderWidth)
    return s.lineCap = t.borderCapStyle, s.setLineDash(t.borderDash), s.lineDashOffset = t.borderDashOffset, s.lineJoin = t.borderJoinStyle, s.lineWidth = t.borderWidth, s.strokeStyle = t.borderColor, !0;
}
function Fc(s, t) {
  s.shadowColor = t.backgroundShadowColor, s.shadowBlur = t.shadowBlur, s.shadowOffsetX = t.shadowOffsetX, s.shadowOffsetY = t.shadowOffsetY;
}
function LA(s, t) {
  const e = t.content;
  if (mf(e))
    return {
      width: nl(e.width, t.width),
      height: nl(e.height, t.height)
    };
  const a = t.font, n = ya(a) ? a.map((o) => an(o)) : [an(a)], i = t.textStrokeWidth, r = ya(e) ? e : [e], l = r.join() + cV(n) + i + (s._measureText ? "-spriting" : "");
  return ev.has(l) || ev.set(l, mV(s, r, n, i)), ev.get(l);
}
function AN(s, t, e) {
  const { x: a, y: n, width: i, height: r } = t;
  s.save(), Fc(s, e);
  const l = sl(s, e);
  s.fillStyle = e.backgroundColor, s.beginPath(), xc(s, {
    x: a,
    y: n,
    w: i,
    h: r,
    radius: aV(Kr(e.borderRadius), 0, Math.min(i, r) / 2)
  }), s.closePath(), s.fill(), l && (s.shadowColor = e.borderShadowColor, s.stroke()), s.restore();
}
function dV(s, t, e) {
  const a = e.content;
  if (mf(a)) {
    s.save(), s.globalAlpha = fV(e.opacity, a.style.opacity), s.drawImage(a, t.x, t.y, t.width, t.height), s.restore();
    return;
  }
  const n = ya(a) ? a : [a], i = e.font, r = ya(i) ? i.map((p) => an(p)) : [an(i)], l = e.color, o = ya(l) ? l : [l], c = rV(t, e), d = t.y + e.textStrokeWidth / 2;
  s.save(), s.textBaseline = "middle", s.textAlign = e.textAlign, uV(s, e) && gV(s, { x: c, y: d }, n, r), yV(s, { x: c, y: d }, n, { fonts: r, colors: o }), s.restore();
}
function uV(s, t) {
  if (t.textStrokeWidth > 0)
    return s.lineJoin = "round", s.miterLimit = 2, s.lineWidth = t.textStrokeWidth, s.strokeStyle = t.textStrokeColor, !0;
}
function pV(s, t, e, a) {
  const { radius: n, options: i } = t, r = i.pointStyle, l = i.rotation;
  let o = (l || 0) * Hw;
  if (mf(r)) {
    s.save(), s.translate(e, a), s.rotate(o), s.drawImage(r, -r.width / 2, -r.height / 2, r.width, r.height), s.restore();
    return;
  }
  oV(n) || hV(s, { x: e, y: a, radius: n, rotation: l, style: r, rad: o });
}
function hV(s, { x: t, y: e, radius: a, rotation: n, style: i, rad: r }) {
  let l, o, c, d;
  switch (s.beginPath(), i) {
    default:
      s.arc(t, e, a, 0, Ga), s.closePath();
      break;
    case "triangle":
      s.moveTo(t + Math.sin(r) * a, e - Math.cos(r) * a), r += bm, s.lineTo(t + Math.sin(r) * a, e - Math.cos(r) * a), r += bm, s.lineTo(t + Math.sin(r) * a, e - Math.cos(r) * a), s.closePath();
      break;
    case "rectRounded":
      d = a * 0.516, c = a - d, l = Math.cos(r + Js) * c, o = Math.sin(r + Js) * c, s.arc(t - l, e - o, d, r - ra, r - Fa), s.arc(t + o, e - l, d, r - Fa, r), s.arc(t + l, e + o, d, r, r + Fa), s.arc(t - o, e + l, d, r + Fa, r + ra), s.closePath();
      break;
    case "rect":
      if (!n) {
        c = Math.SQRT1_2 * a, s.rect(t - c, e - c, 2 * c, 2 * c);
        break;
      }
      r += Js;
    case "rectRot":
      l = Math.cos(r) * a, o = Math.sin(r) * a, s.moveTo(t - l, e - o), s.lineTo(t + o, e - l), s.lineTo(t + l, e + o), s.lineTo(t - o, e + l), s.closePath();
      break;
    case "crossRot":
      r += Js;
    case "cross":
      l = Math.cos(r) * a, o = Math.sin(r) * a, s.moveTo(t - l, e - o), s.lineTo(t + l, e + o), s.moveTo(t + o, e - l), s.lineTo(t - o, e + l);
      break;
    case "star":
      l = Math.cos(r) * a, o = Math.sin(r) * a, s.moveTo(t - l, e - o), s.lineTo(t + l, e + o), s.moveTo(t + o, e - l), s.lineTo(t - o, e + l), r += Js, l = Math.cos(r) * a, o = Math.sin(r) * a, s.moveTo(t - l, e - o), s.lineTo(t + l, e + o), s.moveTo(t + o, e - l), s.lineTo(t - o, e + l);
      break;
    case "line":
      l = Math.cos(r) * a, o = Math.sin(r) * a, s.moveTo(t - l, e - o), s.lineTo(t + l, e + o);
      break;
    case "dash":
      s.moveTo(t, e), s.lineTo(t + Math.cos(r) * a, e + Math.sin(r) * a);
      break;
  }
  s.fill();
}
function mV(s, t, e, a) {
  s.save();
  const n = t.length;
  let i = 0, r = a;
  for (let l = 0; l < n; l++) {
    const o = e[Math.min(l, e.length - 1)];
    s.font = o.string;
    const c = t[l];
    i = Math.max(i, s.measureText(c).width + a), r += o.lineHeight;
  }
  return s.restore(), { width: i, height: r };
}
function gV(s, { x: t, y: e }, a, n) {
  s.beginPath();
  let i = 0;
  a.forEach(function(r, l) {
    const o = n[Math.min(l, n.length - 1)], c = o.lineHeight;
    s.font = o.string, s.strokeText(r, t, e + c / 2 + i), i += c;
  }), s.stroke();
}
function yV(s, { x: t, y: e }, a, { fonts: n, colors: i }) {
  let r = 0;
  a.forEach(function(l, o) {
    const c = i[Math.min(o, i.length - 1)], d = n[Math.min(o, n.length - 1)], p = d.lineHeight;
    s.beginPath(), s.font = d.string, s.fillStyle = c, s.fillText(l, t, e + p / 2 + r), r += p, s.fill();
  });
}
function fV(s, t) {
  const e = al(s) ? s : t;
  return al(e) ? hf(e, 0, 1) : 1;
}
const wI = {
  xScaleID: { min: "xMin", max: "xMax", start: "left", end: "right", startProp: "x", endProp: "x2" },
  yScaleID: { min: "yMin", max: "yMax", start: "bottom", end: "top", startProp: "y", endProp: "y2" }
};
function Ic(s, t, e) {
  return t = typeof t == "number" ? t : s.parse(t), Va(t) ? s.getPixelForValue(t) : e;
}
function Ql(s, t, e) {
  const a = t[e];
  if (a || e === "scaleID")
    return a;
  const n = e.charAt(0), i = Object.values(s).filter((r) => r.axis && r.axis === n);
  return i.length ? i[0].id : n;
}
function CN(s, t) {
  if (s) {
    const e = s.options.reverse, a = Ic(s, t.min, e ? t.end : t.start), n = Ic(s, t.max, e ? t.start : t.end);
    return {
      start: a,
      end: n
    };
  }
}
function $N(s, t) {
  const { chartArea: e, scales: a } = s, n = a[Ql(a, t, "xScaleID")], i = a[Ql(a, t, "yScaleID")];
  let r = e.width / 2, l = e.height / 2;
  return n && (r = Ic(n, t.xValue, n.left + n.width / 2)), i && (l = Ic(i, t.yValue, i.top + i.height / 2)), { x: r, y: l };
}
function DA(s, t) {
  const e = s.scales, a = e[Ql(e, t, "xScaleID")], n = e[Ql(e, t, "yScaleID")];
  if (!a && !n)
    return {};
  let { left: i, right: r } = a || s.chartArea, { top: l, bottom: o } = n || s.chartArea;
  const c = AI(a, { min: t.xMin, max: t.xMax, start: i, end: r });
  i = c.start, r = c.end;
  const d = AI(n, { min: t.yMin, max: t.yMax, start: o, end: l });
  return l = d.start, o = d.end, {
    x: i,
    y: l,
    x2: r,
    y2: o,
    width: r - i,
    height: o - l,
    centerX: i + (r - i) / 2,
    centerY: l + (o - l) / 2
  };
}
function SN(s, t) {
  if (!vN(t)) {
    const e = DA(s, t);
    let a = t.radius;
    (!a || isNaN(a)) && (a = Math.min(e.width, e.height) / 2, t.radius = a);
    const n = a * 2, i = e.centerX + t.xAdjust, r = e.centerY + t.yAdjust;
    return {
      x: i - a,
      y: r - a,
      x2: i + a,
      y2: r + a,
      centerX: i,
      centerY: r,
      width: n,
      height: n,
      radius: a
    };
  }
  return vV(s, t);
}
function bV(s, t) {
  const { scales: e, chartArea: a } = s, n = e[t.scaleID], i = { x: a.left, y: a.top, x2: a.right, y2: a.bottom };
  return n ? xV(n, i, t) : wV(e, i, t), i;
}
function kN(s, t) {
  const e = DA(s, t);
  return e.initProperties = Ku(s, e, t), e.elements = [{
    type: "label",
    optionScope: "label",
    properties: $V(s, e, t),
    initProperties: e.initProperties
  }], e;
}
function vV(s, t) {
  const e = $N(s, t), a = t.radius * 2;
  return {
    x: e.x - t.radius + t.xAdjust,
    y: e.y - t.radius + t.yAdjust,
    x2: e.x + t.radius + t.xAdjust,
    y2: e.y + t.radius + t.yAdjust,
    centerX: e.x + t.xAdjust,
    centerY: e.y + t.yAdjust,
    radius: t.radius,
    width: a,
    height: a
  };
}
function AI(s, t) {
  const e = CN(s, t) || t;
  return {
    start: Math.min(e.start, e.end),
    end: Math.max(e.start, e.end)
  };
}
function xV(s, t, e) {
  const a = Ic(s, e.value, NaN), n = Ic(s, e.endValue, a);
  s.isHorizontal() ? (t.x = a, t.x2 = n) : (t.y = a, t.y2 = n);
}
function wV(s, t, e) {
  for (const a of Object.keys(wI)) {
    const n = s[Ql(s, e, a)];
    if (n) {
      const { min: i, max: r, start: l, end: o, startProp: c, endProp: d } = wI[a], p = CN(n, { min: e[i], max: e[r], start: n[l], end: n[o] });
      t[c] = p.start, t[d] = p.end;
    }
  }
}
function AV({ properties: s, options: t }, e, a, n) {
  const { x: i, x2: r, width: l } = s;
  return TN({ start: i, end: r, size: l, borderWidth: t.borderWidth }, {
    position: a.x,
    padding: { start: n.left, end: n.right },
    adjust: t.label.xAdjust,
    size: e.width
  });
}
function CV({ properties: s, options: t }, e, a, n) {
  const { y: i, y2: r, height: l } = s;
  return TN({ start: i, end: r, size: l, borderWidth: t.borderWidth }, {
    position: a.y,
    padding: { start: n.top, end: n.bottom },
    adjust: t.label.yAdjust,
    size: e.height
  });
}
function TN(s, t) {
  const { start: e, end: a, borderWidth: n } = s, { position: i, padding: { start: r, end: l }, adjust: o } = t, c = a - n - e - r - l - t.size;
  return e + n / 2 + o + SA(c, i);
}
function $V(s, t, e) {
  const a = e.label;
  a.backgroundColor = "transparent", a.callout.display = !1;
  const n = kA(a.position), i = vn(a.padding), r = LA(s.ctx, a), l = AV({ properties: t, options: e }, r, n, i), o = CV({ properties: t, options: e }, r, n, i), c = r.width + i.width, d = r.height + i.height;
  return {
    x: l,
    y: o,
    x2: l + c,
    y2: o + d,
    width: c,
    height: d,
    centerX: l + c / 2,
    centerY: o + d / 2,
    rotation: a.rotation
  };
}
function oo(s, t, e) {
  const a = Math.cos(e), n = Math.sin(e), i = t.x, r = t.y;
  return {
    x: i + a * (s.x - i) - n * (s.y - r),
    y: r + n * (s.x - i) + a * (s.y - r)
  };
}
const Bx = ["enter", "leave"], IA = Bx.concat("click");
function SV(s, t, e) {
  t.listened = xN(e, IA, t.listeners), t.moveListened = !1, t._getElements = $A, Bx.forEach((a) => {
    As(e[a]) && (t.moveListened = !0);
  }), (!t.listened || !t.moveListened) && t.annotations.forEach((a) => {
    !t.listened && As(a.click) && (t.listened = !0), t.moveListened || Bx.forEach((n) => {
      As(a[n]) && (t.listened = !0, t.moveListened = !0);
    });
  });
}
function kV(s, t, e) {
  if (s.listened)
    switch (t.type) {
      case "mousemove":
      case "mouseout":
        return TV(s, t, e);
      case "click":
        return LV(s, t, e);
    }
}
function TV(s, t, e) {
  if (!s.moveListened)
    return;
  let a;
  t.type === "mousemove" ? a = $A(s, t, e.interaction) : a = [];
  const n = s.hovered;
  s.hovered = a;
  const i = { state: s, event: t };
  let r = CI(i, "leave", n, a);
  return CI(i, "enter", a, n) || r;
}
function CI({ state: s, event: t }, e, a, n) {
  let i;
  for (const r of a)
    n.indexOf(r) < 0 && (i = LN(r.options[e] || s.listeners[e], r, t) || i);
  return i;
}
function LV(s, t, e) {
  const a = s.listeners, n = $A(s, t, e.interaction);
  let i;
  for (const r of n)
    i = LN(r.options.click || a.click, r, t) || i;
  return i;
}
function LN(s, t, e) {
  return Sa(s, [t.$context, e]) === !0;
}
const ug = ["afterDraw", "beforeDraw"];
function DV(s, t, e) {
  const a = t.visibleElements;
  t.hooked = xN(e, ug, t.hooks), t.hooked || a.forEach((n) => {
    t.hooked || ug.forEach((i) => {
      As(n.options[i]) && (t.hooked = !0);
    });
  });
}
function $I(s, t, e) {
  if (s.hooked) {
    const a = t.options[e] || s.hooks[e];
    return Sa(a, [t.$context]);
  }
}
function IV(s, t, e) {
  const a = YV(s.scales, t, e);
  let n = SI(t, a, "min", "suggestedMin");
  n = SI(t, a, "max", "suggestedMax") || n, n && As(t.handleTickRangeOptions) && t.handleTickRangeOptions();
}
function PV(s, t) {
  for (const e of s)
    NV(e, t);
}
function SI(s, t, e, a) {
  if (Va(t[e]) && !EV(s.options, e, a)) {
    const n = s[e] !== t[e];
    return s[e] = t[e], n;
  }
}
function EV(s, t, e) {
  return Cs(s[t]) || Cs(s[e]);
}
function NV(s, t) {
  for (const e of ["scaleID", "xScaleID", "yScaleID"]) {
    const a = Ql(t, s, e);
    a && !t[a] && RV(s, e) && console.warn(`No scale found with id '${a}' for annotation '${s.id}'`);
  }
}
function RV(s, t) {
  if (t === "scaleID")
    return !0;
  const e = t.charAt(0);
  for (const a of ["Min", "Max", "Value"])
    if (Cs(s[e + a]))
      return !0;
  return !1;
}
function YV(s, t, e) {
  const a = t.axis, n = t.id, i = a + "ScaleID", r = {
    min: Fe(t.min, Number.NEGATIVE_INFINITY),
    max: Fe(t.max, Number.POSITIVE_INFINITY)
  };
  for (const l of e)
    l.scaleID === n ? kI(l, t, ["value", "endValue"], r) : Ql(s, l, i) === n && kI(l, t, [a + "Min", a + "Max", a + "Value"], r);
  return r;
}
function kI(s, t, e, a) {
  for (const n of e) {
    const i = s[n];
    if (Cs(i)) {
      const r = t.parse(i);
      a.min = Math.min(a.min, r), a.max = Math.max(a.max, r);
    }
  }
}
class zc extends cs {
  inRange(t, e, a, n) {
    const { x: i, y: r } = oo({ x: t, y: e }, this.getCenterPoint(n), bn(-this.options.rotation));
    return gN({ x: i, y: r }, this.getProps(["x", "y", "x2", "y2"], n), a, this.options.borderWidth);
  }
  getCenterPoint(t) {
    return Uc(this, t);
  }
  draw(t) {
    t.save(), TA(t, this.getCenterPoint(), this.options.rotation), AN(t, this, this.options), t.restore();
  }
  get label() {
    return this.elements && this.elements[0];
  }
  resolveElementProperties(t, e) {
    return kN(t, e);
  }
}
zc.id = "boxAnnotation";
zc.defaults = {
  adjustScaleRange: !0,
  backgroundShadowColor: "transparent",
  borderCapStyle: "butt",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: "miter",
  borderRadius: 0,
  borderShadowColor: "transparent",
  borderWidth: 1,
  display: !0,
  init: void 0,
  label: {
    backgroundColor: "transparent",
    borderWidth: 0,
    callout: {
      display: !1
    },
    color: "black",
    content: null,
    display: !1,
    drawTime: void 0,
    font: {
      family: void 0,
      lineHeight: void 0,
      size: void 0,
      style: void 0,
      weight: "bold"
    },
    height: void 0,
    opacity: void 0,
    padding: 6,
    position: "center",
    rotation: void 0,
    textAlign: "start",
    textStrokeColor: void 0,
    textStrokeWidth: 0,
    width: void 0,
    xAdjust: 0,
    yAdjust: 0,
    z: void 0
  },
  rotation: 0,
  shadowBlur: 0,
  shadowOffsetX: 0,
  shadowOffsetY: 0,
  xMax: void 0,
  xMin: void 0,
  xScaleID: void 0,
  yMax: void 0,
  yMin: void 0,
  yScaleID: void 0,
  z: 0
};
zc.defaultRoutes = {
  borderColor: "color",
  backgroundColor: "color"
};
zc.descriptors = {
  label: {
    _fallback: !0
  }
};
const DN = ["left", "bottom", "top", "right"];
class Ju extends cs {
  inRange(t, e, a, n) {
    const { x: i, y: r } = oo({ x: t, y: e }, this.getCenterPoint(n), bn(-this.rotation));
    return gN({ x: i, y: r }, this.getProps(["x", "y", "x2", "y2"], n), a, this.options.borderWidth);
  }
  getCenterPoint(t) {
    return Uc(this, t);
  }
  draw(t) {
    const e = this.options, a = !Cs(this._visible) || this._visible;
    !e.display || !e.content || !a || (t.save(), TA(t, this.getCenterPoint(), this.rotation), OV(t, this), AN(t, this, e), dV(t, zV(this), e), t.restore());
  }
  resolveElementProperties(t, e) {
    let a;
    if (vN(e))
      a = $N(t, e);
    else {
      const { centerX: l, centerY: o } = DA(t, e);
      a = { x: l, y: o };
    }
    const n = vn(e.padding), i = LA(t.ctx, e), r = _V(a, i, e, n);
    return {
      initProperties: Ku(t, r, e),
      pointX: a.x,
      pointY: a.y,
      ...r,
      rotation: e.rotation
    };
  }
}
Ju.id = "labelAnnotation";
Ju.defaults = {
  adjustScaleRange: !0,
  backgroundColor: "transparent",
  backgroundShadowColor: "transparent",
  borderCapStyle: "butt",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: "miter",
  borderRadius: 0,
  borderShadowColor: "transparent",
  borderWidth: 0,
  callout: {
    borderCapStyle: "butt",
    borderColor: void 0,
    borderDash: [],
    borderDashOffset: 0,
    borderJoinStyle: "miter",
    borderWidth: 1,
    display: !1,
    margin: 5,
    position: "auto",
    side: 5,
    start: "50%"
  },
  color: "black",
  content: null,
  display: !0,
  font: {
    family: void 0,
    lineHeight: void 0,
    size: void 0,
    style: void 0,
    weight: void 0
  },
  height: void 0,
  init: void 0,
  opacity: void 0,
  padding: 6,
  position: "center",
  rotation: 0,
  shadowBlur: 0,
  shadowOffsetX: 0,
  shadowOffsetY: 0,
  textAlign: "center",
  textStrokeColor: void 0,
  textStrokeWidth: 0,
  width: void 0,
  xAdjust: 0,
  xMax: void 0,
  xMin: void 0,
  xScaleID: void 0,
  xValue: void 0,
  yAdjust: 0,
  yMax: void 0,
  yMin: void 0,
  yScaleID: void 0,
  yValue: void 0,
  z: 0
};
Ju.defaultRoutes = {
  borderColor: "color"
};
function _V(s, t, e, a) {
  const n = t.width + a.width + e.borderWidth, i = t.height + a.height + e.borderWidth, r = kA(e.position, "center"), l = TI(s.x, n, e.xAdjust, r.x), o = TI(s.y, i, e.yAdjust, r.y);
  return {
    x: l,
    y: o,
    x2: l + n,
    y2: o + i,
    width: n,
    height: i,
    centerX: l + n / 2,
    centerY: o + i / 2
  };
}
function TI(s, t, e = 0, a) {
  return s - SA(t, a) + e;
}
function OV(s, t) {
  const { pointX: e, pointY: a, options: n } = t, i = n.callout, r = i && i.display && UV(t, i);
  if (!r || BV(t, i, r))
    return;
  if (s.save(), s.beginPath(), !sl(s, i))
    return s.restore();
  const { separatorStart: o, separatorEnd: c } = MV(t, r), { sideStart: d, sideEnd: p } = GV(t, r, o);
  (i.margin > 0 || n.borderWidth === 0) && (s.moveTo(o.x, o.y), s.lineTo(c.x, c.y)), s.moveTo(d.x, d.y), s.lineTo(p.x, p.y);
  const h = oo({ x: e, y: a }, t.getCenterPoint(), bn(-t.rotation));
  s.lineTo(h.x, h.y), s.stroke(), s.restore();
}
function MV(s, t) {
  const { x: e, y: a, x2: n, y2: i } = s, r = XV(s, t);
  let l, o;
  return t === "left" || t === "right" ? (l = { x: e + r, y: a }, o = { x: l.x, y: i }) : (l = { x: e, y: a + r }, o = { x: n, y: l.y }), { separatorStart: l, separatorEnd: o };
}
function XV(s, t) {
  const { width: e, height: a, options: n } = s, i = n.callout.margin + n.borderWidth / 2;
  return t === "right" ? e + i : t === "bottom" ? a + i : -i;
}
function GV(s, t, e) {
  const { y: a, width: n, height: i, options: r } = s, l = r.callout.start, o = HV(t, r.callout);
  let c, d;
  return t === "left" || t === "right" ? (c = { x: e.x, y: a + nl(i, l) }, d = { x: c.x + o, y: c.y }) : (c = { x: e.x + nl(n, l), y: e.y }, d = { x: c.x, y: c.y + o }), { sideStart: c, sideEnd: d };
}
function HV(s, t) {
  const e = t.side;
  return s === "left" || s === "top" ? -e : e;
}
function UV(s, t) {
  const e = t.position;
  return DN.includes(e) ? e : FV(s, t);
}
function FV(s, t) {
  const { x: e, y: a, x2: n, y2: i, width: r, height: l, pointX: o, pointY: c, centerX: d, centerY: p, rotation: h } = s, g = { x: d, y: p }, x = t.start, b = nl(r, x), A = nl(l, x), T = [e, e + b, e + b, n], R = [a + A, i, a, i], C = [];
  for (let v = 0; v < 4; v++) {
    const P = oo({ x: T[v], y: R[v] }, g, bn(h));
    C.push({
      position: DN[v],
      distance: vc(P, { x: o, y: c })
    });
  }
  return C.sort((v, P) => v.distance - P.distance)[0].position;
}
function zV({ x: s, y: t, width: e, height: a, options: n }) {
  const i = n.borderWidth / 2, r = vn(n.padding);
  return {
    x: s + r.left + i,
    y: t + r.top + i,
    width: e - r.left - r.right - n.borderWidth,
    height: a - r.top - r.bottom - n.borderWidth
  };
}
function BV(s, t, e) {
  const { pointX: a, pointY: n } = s, i = t.margin;
  let r = a, l = n;
  return e === "left" ? r += i : e === "right" ? r -= i : e === "top" ? l += i : e === "bottom" && (l -= i), s.inRange(r, l);
}
const PA = (s, t, e) => ({ x: s.x + e * (t.x - s.x), y: s.y + e * (t.y - s.y) }), Wx = (s, t, e) => PA(t, e, Math.abs((s - t.y) / (e.y - t.y))).x, LI = (s, t, e) => PA(t, e, Math.abs((s - t.x) / (e.x - t.x))).y, Od = (s) => s * s, WV = (s, t, { x: e, y: a, x2: n, y2: i }, r) => r === "y" ? { start: Math.min(a, i), end: Math.max(a, i), value: t } : { start: Math.min(e, n), end: Math.max(e, n), value: s }, DI = (s, t, e, a) => (1 - a) * (1 - a) * s + 2 * (1 - a) * a * t + a * a * e, jx = (s, t, e, a) => ({ x: DI(s.x, t.x, e.x, a), y: DI(s.y, t.y, e.y, a) }), II = (s, t, e, a) => 2 * (1 - a) * (t - s) + 2 * a * (e - t), PI = (s, t, e, a) => -Math.atan2(II(s.x, t.x, e.x, a), II(s.y, t.y, e.y, a)) + 0.5 * ra;
class Qu extends cs {
  inRange(t, e, a, n) {
    const i = this.options.borderWidth / 2;
    if (a !== "x" && a !== "y") {
      const r = { mouseX: t, mouseY: e }, { path: l, ctx: o } = this;
      if (l) {
        sl(o, this.options);
        const { chart: d } = this.$context, p = t * d.currentDevicePixelRatio, h = e * d.currentDevicePixelRatio, g = o.isPointInStroke(l, p, h) || Vx(this, r, n);
        return o.restore(), g;
      }
      const c = Od(i);
      return KV(this, r, c, n) || Vx(this, r, n);
    }
    return jV(this, { mouseX: t, mouseY: e }, a, { hBorderWidth: i, useFinalPosition: n });
  }
  getCenterPoint(t) {
    return Uc(this, t);
  }
  draw(t) {
    const { x: e, y: a, x2: n, y2: i, cp: r, options: l } = this;
    if (t.save(), !sl(t, l))
      return t.restore();
    Fc(t, l);
    const o = Math.sqrt(Math.pow(n - e, 2) + Math.pow(i - a, 2));
    if (l.curve && r)
      return s3(t, this, r, o), t.restore();
    const { startOpts: c, endOpts: d, startAdjust: p, endAdjust: h } = IN(this), g = Math.atan2(i - a, n - e);
    t.translate(e, a), t.rotate(g), t.beginPath(), t.moveTo(0 + p, 0), t.lineTo(o - h, 0), t.shadowColor = l.borderShadowColor, t.stroke(), qx(t, 0, p, c), qx(t, o, -h, d), t.restore();
  }
  get label() {
    return this.elements && this.elements[0];
  }
  resolveElementProperties(t, e) {
    const a = bV(t, e), { x: n, y: i, x2: r, y2: l } = a, o = VV(a, t.chartArea), c = o ? qV({ x: n, y: i }, { x: r, y: l }, t.chartArea) : { x: n, y: i, x2: r, y2: l, width: Math.abs(r - n), height: Math.abs(l - i) };
    if (c.centerX = (r + n) / 2, c.centerY = (l + i) / 2, c.initProperties = Ku(t, c, e), e.curve) {
      const p = { x: c.x, y: c.y }, h = { x: c.x2, y: c.y2 };
      c.cp = n3(c, e, vc(p, h));
    }
    const d = JV(t, c, e.label);
    return d._visible = o, c.elements = [{
      type: "label",
      optionScope: "label",
      properties: d,
      initProperties: c.initProperties
    }], c;
  }
}
Qu.id = "lineAnnotation";
const EI = {
  backgroundColor: void 0,
  backgroundShadowColor: void 0,
  borderColor: void 0,
  borderDash: void 0,
  borderDashOffset: void 0,
  borderShadowColor: void 0,
  borderWidth: void 0,
  display: void 0,
  fill: void 0,
  length: void 0,
  shadowBlur: void 0,
  shadowOffsetX: void 0,
  shadowOffsetY: void 0,
  width: void 0
};
Qu.defaults = {
  adjustScaleRange: !0,
  arrowHeads: {
    display: !1,
    end: Object.assign({}, EI),
    fill: !1,
    length: 12,
    start: Object.assign({}, EI),
    width: 6
  },
  borderDash: [],
  borderDashOffset: 0,
  borderShadowColor: "transparent",
  borderWidth: 2,
  curve: !1,
  controlPoint: {
    y: "-50%"
  },
  display: !0,
  endValue: void 0,
  init: void 0,
  label: {
    backgroundColor: "rgba(0,0,0,0.8)",
    backgroundShadowColor: "transparent",
    borderCapStyle: "butt",
    borderColor: "black",
    borderDash: [],
    borderDashOffset: 0,
    borderJoinStyle: "miter",
    borderRadius: 6,
    borderShadowColor: "transparent",
    borderWidth: 0,
    callout: Object.assign({}, Ju.defaults.callout),
    color: "#fff",
    content: null,
    display: !1,
    drawTime: void 0,
    font: {
      family: void 0,
      lineHeight: void 0,
      size: void 0,
      style: void 0,
      weight: "bold"
    },
    height: void 0,
    opacity: void 0,
    padding: 6,
    position: "center",
    rotation: 0,
    shadowBlur: 0,
    shadowOffsetX: 0,
    shadowOffsetY: 0,
    textAlign: "center",
    textStrokeColor: void 0,
    textStrokeWidth: 0,
    width: void 0,
    xAdjust: 0,
    yAdjust: 0,
    z: void 0
  },
  scaleID: void 0,
  shadowBlur: 0,
  shadowOffsetX: 0,
  shadowOffsetY: 0,
  value: void 0,
  xMax: void 0,
  xMin: void 0,
  xScaleID: void 0,
  yMax: void 0,
  yMin: void 0,
  yScaleID: void 0,
  z: 0
};
Qu.descriptors = {
  arrowHeads: {
    start: {
      _fallback: !0
    },
    end: {
      _fallback: !0
    },
    _fallback: !0
  }
};
Qu.defaultRoutes = {
  borderColor: "color"
};
function jV(s, { mouseX: t, mouseY: e }, a, { hBorderWidth: n, useFinalPosition: i }) {
  const r = WV(t, e, s.getProps(["x", "y", "x2", "y2"], i), a);
  return r.value >= r.start - n && r.value <= r.end + n || Vx(s, { mouseX: t, mouseY: e }, i, a);
}
function VV({ x: s, y: t, x2: e, y2: a }, { top: n, right: i, bottom: r, left: l }) {
  return !(s < l && e < l || s > i && e > i || t < n && a < n || t > r && a > r);
}
function NI({ x: s, y: t }, e, { top: a, right: n, bottom: i, left: r }) {
  return s < r && (t = LI(r, { x: s, y: t }, e), s = r), s > n && (t = LI(n, { x: s, y: t }, e), s = n), t < a && (s = Wx(a, { x: s, y: t }, e), t = a), t > i && (s = Wx(i, { x: s, y: t }, e), t = i), { x: s, y: t };
}
function qV(s, t, e) {
  const { x: a, y: n } = NI(s, t, e), { x: i, y: r } = NI(t, s, e);
  return { x: a, y: n, x2: i, y2: r, width: Math.abs(i - a), height: Math.abs(r - n) };
}
function KV(s, { mouseX: t, mouseY: e }, a = Yl, n) {
  const { x: i, y: r, x2: l, y2: o } = s.getProps(["x", "y", "x2", "y2"], n), c = l - i, d = o - r, p = Od(c) + Od(d), h = p === 0 ? -1 : ((t - i) * c + (e - r) * d) / p;
  let g, x;
  return h < 0 ? (g = i, x = r) : h > 1 ? (g = l, x = o) : (g = i + h * c, x = r + h * d), Od(t - g) + Od(e - x) <= a;
}
function Vx(s, { mouseX: t, mouseY: e }, a, n) {
  const i = s.label;
  return i.options.display && i.inRange(t, e, n, a);
}
function JV(s, t, e) {
  const a = e.borderWidth, n = vn(e.padding), i = LA(s.ctx, e), r = i.width + n.width + a, l = i.height + n.height + a;
  return ZV(t, e, { width: r, height: l, padding: n }, s.chartArea);
}
function QV(s) {
  const { x: t, y: e, x2: a, y2: n } = s, i = Math.atan2(n - e, a - t);
  return i > ra / 2 ? i - ra : i < ra / -2 ? i + ra : i;
}
function ZV(s, t, e, a) {
  const { width: n, height: i, padding: r } = e, { xAdjust: l, yAdjust: o } = t, c = { x: s.x, y: s.y }, d = { x: s.x2, y: s.y2 }, p = t.rotation === "auto" ? QV(s) : bn(t.rotation), h = t3(n, i, p), g = e3(s, t, { labelSize: h, padding: r }, a), x = s.cp ? jx(c, s.cp, d, g) : PA(c, d, g), b = { size: h.w, min: a.left, max: a.right, padding: r.left }, A = { size: h.h, min: a.top, max: a.bottom, padding: r.top }, T = YI(x.x, b) + l, R = YI(x.y, A) + o;
  return {
    x: T - n / 2,
    y: R - i / 2,
    x2: T + n / 2,
    y2: R + i / 2,
    centerX: T,
    centerY: R,
    pointX: x.x,
    pointY: x.y,
    width: n,
    height: i,
    rotation: sf(p)
  };
}
function t3(s, t, e) {
  const a = Math.cos(e), n = Math.sin(e);
  return {
    w: Math.abs(s * a) + Math.abs(t * n),
    h: Math.abs(s * n) + Math.abs(t * a)
  };
}
function e3(s, t, e, a) {
  let n;
  const i = a3(s, a);
  return t.position === "start" ? n = RI({ w: s.x2 - s.x, h: s.y2 - s.y }, e, t, i) : t.position === "end" ? n = 1 - RI({ w: s.x - s.x2, h: s.y - s.y2 }, e, t, i) : n = SA(1, t.position), n;
}
function RI(s, t, e, a) {
  const { labelSize: n, padding: i } = t, r = s.w * a.dx, l = s.h * a.dy, o = r > 0 && (n.w / 2 + i.left - a.x) / r, c = l > 0 && (n.h / 2 + i.top - a.y) / l;
  return hf(Math.max(o, c), 0, 0.25);
}
function a3(s, t) {
  const { x: e, x2: a, y: n, y2: i } = s, r = Math.min(n, i) - t.top, l = Math.min(e, a) - t.left, o = t.bottom - Math.max(n, i), c = t.right - Math.max(e, a);
  return {
    x: Math.min(l, c),
    y: Math.min(r, o),
    dx: l <= c ? 1 : -1,
    dy: r <= o ? 1 : -1
  };
}
function YI(s, t) {
  const { size: e, min: a, max: n, padding: i } = t, r = e / 2;
  return e > n - a ? (n + a) / 2 : (a >= s - i - r && (s = a + i + r), n <= s + i + r && (s = n - i - r), s);
}
function IN(s) {
  const t = s.options, e = t.arrowHeads && t.arrowHeads.start, a = t.arrowHeads && t.arrowHeads.end;
  return {
    startOpts: e,
    endOpts: a,
    startAdjust: _I(s, e),
    endAdjust: _I(s, a)
  };
}
function _I(s, t) {
  if (!t || !t.display)
    return 0;
  const { length: e, width: a } = t, n = s.options.borderWidth / 2, i = { x: e, y: a + n };
  return Math.abs(Wx(0, i, { x: 0, y: n }));
}
function qx(s, t, e, a) {
  if (!a || !a.display)
    return;
  const { length: n, width: i, fill: r, backgroundColor: l, borderColor: o } = a, c = Math.abs(t - n) + e;
  s.beginPath(), Fc(s, a), sl(s, a), s.moveTo(c, -i), s.lineTo(t + e, 0), s.lineTo(c, i), r === !0 ? (s.fillStyle = l || o, s.closePath(), s.fill(), s.shadowColor = "transparent") : s.shadowColor = a.borderShadowColor, s.stroke();
}
function n3(s, t, e) {
  const { x: a, y: n, x2: i, y2: r, centerX: l, centerY: o } = s, c = Math.atan2(r - n, i - a), d = kA(t.controlPoint, 0), p = {
    x: l + nl(e, d.x, !1),
    y: o + nl(e, d.y, !1)
  };
  return oo(p, { x: l, y: o }, c);
}
function OI(s, { x: t, y: e }, { angle: a, adjust: n }, i) {
  !i || !i.display || (s.save(), s.translate(t, e), s.rotate(a), qx(s, 0, -n, i), s.restore());
}
function s3(s, t, e, a) {
  const { x: n, y: i, x2: r, y2: l, options: o } = t, { startOpts: c, endOpts: d, startAdjust: p, endAdjust: h } = IN(t), g = { x: n, y: i }, x = { x: r, y: l }, b = PI(g, e, x, 0), A = PI(g, e, x, 1) - ra, T = jx(g, e, x, p / a), R = jx(g, e, x, 1 - h / a), C = new Path2D();
  s.beginPath(), C.moveTo(T.x, T.y), C.quadraticCurveTo(e.x, e.y, R.x, R.y), s.shadowColor = o.borderShadowColor, s.stroke(C), t.path = C, t.ctx = s, OI(s, T, { angle: b, adjust: p }, c), OI(s, R, { angle: A, adjust: h }, d);
}
class Zu extends cs {
  inRange(t, e, a, n) {
    const i = this.options.rotation, r = this.options.borderWidth;
    if (a !== "x" && a !== "y")
      return i3({ x: t, y: e }, this.getProps(["width", "height", "centerX", "centerY"], n), i, r);
    const { x: l, y: o, x2: c, y2: d } = this.getProps(["x", "y", "x2", "y2"], n), p = r / 2, h = a === "y" ? { start: o, end: d } : { start: l, end: c }, g = oo({ x: t, y: e }, this.getCenterPoint(n), bn(-i));
    return g[a] >= h.start - p - Yl && g[a] <= h.end + p + Yl;
  }
  getCenterPoint(t) {
    return Uc(this, t);
  }
  draw(t) {
    const { width: e, height: a, centerX: n, centerY: i, options: r } = this;
    t.save(), TA(t, this.getCenterPoint(), r.rotation), Fc(t, this.options), t.beginPath(), t.fillStyle = r.backgroundColor;
    const l = sl(t, r);
    t.ellipse(n, i, a / 2, e / 2, ra / 2, 0, 2 * ra), t.fill(), l && (t.shadowColor = r.borderShadowColor, t.stroke()), t.restore();
  }
  get label() {
    return this.elements && this.elements[0];
  }
  resolveElementProperties(t, e) {
    return kN(t, e);
  }
}
Zu.id = "ellipseAnnotation";
Zu.defaults = {
  adjustScaleRange: !0,
  backgroundShadowColor: "transparent",
  borderDash: [],
  borderDashOffset: 0,
  borderShadowColor: "transparent",
  borderWidth: 1,
  display: !0,
  init: void 0,
  label: Object.assign({}, zc.defaults.label),
  rotation: 0,
  shadowBlur: 0,
  shadowOffsetX: 0,
  shadowOffsetY: 0,
  xMax: void 0,
  xMin: void 0,
  xScaleID: void 0,
  yMax: void 0,
  yMin: void 0,
  yScaleID: void 0,
  z: 0
};
Zu.defaultRoutes = {
  borderColor: "color",
  backgroundColor: "color"
};
Zu.descriptors = {
  label: {
    _fallback: !0
  }
};
function i3(s, t, e, a) {
  const { width: n, height: i, centerX: r, centerY: l } = t, o = n / 2, c = i / 2;
  if (o <= 0 || c <= 0)
    return !1;
  const d = bn(e || 0), p = a / 2 || 0, h = Math.cos(d), g = Math.sin(d), x = Math.pow(h * (s.x - r) + g * (s.y - l), 2), b = Math.pow(g * (s.x - r) - h * (s.y - l), 2);
  return x / Math.pow(o + p, 2) + b / Math.pow(c + p, 2) <= 1.0001;
}
class gf extends cs {
  inRange(t, e, a, n) {
    const { x: i, y: r, x2: l, y2: o, width: c } = this.getProps(["x", "y", "x2", "y2", "width"], n), d = this.options.borderWidth;
    if (a !== "x" && a !== "y")
      return nV({ x: t, y: e }, this.getCenterPoint(n), c / 2, d);
    const p = d / 2, h = a === "y" ? { start: r, end: o, value: e } : { start: i, end: l, value: t };
    return h.value >= h.start - p && h.value <= h.end + p;
  }
  getCenterPoint(t) {
    return Uc(this, t);
  }
  draw(t) {
    const e = this.options, a = e.borderWidth;
    if (e.radius < 0.1)
      return;
    t.save(), t.fillStyle = e.backgroundColor, Fc(t, e);
    const n = sl(t, e);
    pV(t, this, this.centerX, this.centerY), n && !mf(e.pointStyle) && (t.shadowColor = e.borderShadowColor, t.stroke()), t.restore(), e.borderWidth = a;
  }
  resolveElementProperties(t, e) {
    const a = SN(t, e);
    return a.initProperties = Ku(t, a, e), a;
  }
}
gf.id = "pointAnnotation";
gf.defaults = {
  adjustScaleRange: !0,
  backgroundShadowColor: "transparent",
  borderDash: [],
  borderDashOffset: 0,
  borderShadowColor: "transparent",
  borderWidth: 1,
  display: !0,
  init: void 0,
  pointStyle: "circle",
  radius: 10,
  rotation: 0,
  shadowBlur: 0,
  shadowOffsetX: 0,
  shadowOffsetY: 0,
  xAdjust: 0,
  xMax: void 0,
  xMin: void 0,
  xScaleID: void 0,
  xValue: void 0,
  yAdjust: 0,
  yMax: void 0,
  yMin: void 0,
  yScaleID: void 0,
  yValue: void 0,
  z: 0
};
gf.defaultRoutes = {
  borderColor: "color",
  backgroundColor: "color"
};
class yf extends cs {
  inRange(t, e, a, n) {
    if (a !== "x" && a !== "y")
      return this.options.radius >= 0.1 && this.elements.length > 1 && l3(this.elements, t, e, n);
    const i = oo({ x: t, y: e }, this.getCenterPoint(n), bn(-this.options.rotation)), r = this.elements.map((c) => a === "y" ? c.bY : c.bX), l = Math.min(...r), o = Math.max(...r);
    return i[a] >= l && i[a] <= o;
  }
  getCenterPoint(t) {
    return Uc(this, t);
  }
  draw(t) {
    const { elements: e, options: a } = this;
    t.save(), t.beginPath(), t.fillStyle = a.backgroundColor, Fc(t, a);
    const n = sl(t, a);
    let i = !0;
    for (const r of e)
      i ? (t.moveTo(r.x, r.y), i = !1) : t.lineTo(r.x, r.y);
    t.closePath(), t.fill(), n && (t.shadowColor = a.borderShadowColor, t.stroke()), t.restore();
  }
  resolveElementProperties(t, e) {
    const a = SN(t, e), { sides: n, rotation: i } = e, r = [], l = 2 * ra / n;
    let o = i * Hw;
    for (let c = 0; c < n; c++, o += l) {
      const d = r3(a, e, o);
      d.initProperties = Ku(t, a, e), r.push(d);
    }
    return a.elements = r, a;
  }
}
yf.id = "polygonAnnotation";
yf.defaults = {
  adjustScaleRange: !0,
  backgroundShadowColor: "transparent",
  borderCapStyle: "butt",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: "miter",
  borderShadowColor: "transparent",
  borderWidth: 1,
  display: !0,
  init: void 0,
  point: {
    radius: 0
  },
  radius: 10,
  rotation: 0,
  shadowBlur: 0,
  shadowOffsetX: 0,
  shadowOffsetY: 0,
  sides: 3,
  xAdjust: 0,
  xMax: void 0,
  xMin: void 0,
  xScaleID: void 0,
  xValue: void 0,
  yAdjust: 0,
  yMax: void 0,
  yMin: void 0,
  yScaleID: void 0,
  yValue: void 0,
  z: 0
};
yf.defaultRoutes = {
  borderColor: "color",
  backgroundColor: "color"
};
function r3({ centerX: s, centerY: t }, { radius: e, borderWidth: a }, n) {
  const i = a / 2, r = Math.sin(n), l = Math.cos(n), o = { x: s + r * e, y: t - l * e };
  return {
    type: "point",
    optionScope: "point",
    properties: {
      x: o.x,
      y: o.y,
      centerX: o.x,
      centerY: o.y,
      bX: s + r * (e + i),
      bY: t - l * (e + i)
    }
  };
}
function l3(s, t, e, a) {
  let n = !1, i = s[s.length - 1].getProps(["bX", "bY"], a);
  for (const r of s) {
    const l = r.getProps(["bX", "bY"], a);
    l.bY > e != i.bY > e && t < (i.bX - l.bX) * (e - l.bY) / (i.bY - l.bY) + l.bX && (n = !n), i = l;
  }
  return n;
}
const Qr = {
  box: zc,
  ellipse: Zu,
  label: Ju,
  line: Qu,
  point: gf,
  polygon: yf
};
Object.keys(Qr).forEach((s) => {
  en.describe(`elements.${Qr[s].id}`, {
    _fallback: "plugins.annotation.common"
  });
});
const o3 = {
  update: Object.assign
}, c3 = IA.concat(ug), MI = (s, t) => Ve(t) ? Jx(s, t) : s, Kx = (s) => s === "color" || s === "font";
function EA(s = "line") {
  return Qr[s] ? s : (console.warn(`Unknown annotation type: '${s}', defaulting to 'line'`), "line");
}
function d3(s, t, e, a) {
  const n = p3(s, e.animations, a), i = t.annotations, r = g3(t.elements, i);
  for (let l = 0; l < i.length; l++) {
    const o = i[l], c = PN(r, l, o.type), d = o.setContext(m3(s, c, o)), p = c.resolveElementProperties(s, d);
    p.skip = u3(p), "elements" in p && (h3(c, p.elements, d, n), delete p.elements), Cs(c.x) || Object.assign(c, p), Object.assign(c, p.initProperties), p.options = EN(d), n.update(c, p);
  }
}
function u3(s) {
  return isNaN(s.x) || isNaN(s.y);
}
function p3(s, t, e) {
  return e === "reset" || e === "none" || e === "resize" ? o3 : new Jw(s, t);
}
function h3(s, t, e, a) {
  const n = s.elements || (s.elements = []);
  n.length = t.length;
  for (let i = 0; i < t.length; i++) {
    const r = t[i], l = r.properties, o = PN(n, i, r.type, r.initProperties), c = e[r.optionScope].override(r);
    l.options = EN(c), a.update(o, l);
  }
}
function PN(s, t, e, a) {
  const n = Qr[EA(e)];
  let i = s[t];
  return (!i || !(i instanceof n)) && (i = s[t] = new n(), Object.assign(i, a)), i;
}
function EN(s) {
  const t = Qr[EA(s.type)], e = {};
  e.id = s.id, e.type = s.type, e.drawTime = s.drawTime, Object.assign(
    e,
    Jx(s, t.defaults),
    Jx(s, t.defaultRoutes)
  );
  for (const a of c3)
    e[a] = s[a];
  return e;
}
function Jx(s, t) {
  const e = {};
  for (const a of Object.keys(t)) {
    const n = t[a], i = s[a];
    Kx(a) && ya(i) ? e[a] = i.map((r) => MI(r, n)) : e[a] = MI(i, n);
  }
  return e;
}
function m3(s, t, e) {
  return t.$context || (t.$context = Object.assign(Object.create(s.getContext()), {
    element: t,
    id: e.id,
    type: "annotation"
  }));
}
function g3(s, t) {
  const e = t.length, a = s.length;
  if (a < e) {
    const n = e - a;
    s.splice(a, 0, ...new Array(n));
  } else
    a > e && s.splice(e, a - e);
  return s;
}
var y3 = "3.0.1";
const Rr = /* @__PURE__ */ new Map(), f3 = IA.concat(ug);
var b3 = {
  id: "annotation",
  version: y3,
  beforeRegister() {
    sV("chart.js", "4.0", Jr.version);
  },
  afterRegister() {
    Jr.register(Qr);
  },
  afterUnregister() {
    Jr.unregister(Qr);
  },
  beforeInit(s) {
    Rr.set(s, {
      annotations: [],
      elements: [],
      visibleElements: [],
      listeners: {},
      listened: !1,
      moveListened: !1,
      hooks: {},
      hooked: !1,
      hovered: []
    });
  },
  beforeUpdate(s, t, e) {
    const a = Rr.get(s), n = a.annotations = [];
    let i = e.annotations;
    Ve(i) ? Object.keys(i).forEach((r) => {
      const l = i[r];
      Ve(l) && (l.id = r, n.push(l));
    }) : ya(i) && n.push(...i), PV(n, s.scales);
  },
  afterDataLimits(s, t) {
    const e = Rr.get(s);
    IV(s, t.scale, e.annotations.filter((a) => a.display && a.adjustScaleRange));
  },
  afterUpdate(s, t, e) {
    const a = Rr.get(s);
    SV(s, a, e), d3(s, a, e, t.mode), a.visibleElements = a.elements.filter((n) => !n.skip && n.options.display), DV(s, a, e);
  },
  beforeDatasetsDraw(s, t, e) {
    Sh(s, "beforeDatasetsDraw", e.clip);
  },
  afterDatasetsDraw(s, t, e) {
    Sh(s, "afterDatasetsDraw", e.clip);
  },
  beforeDraw(s, t, e) {
    Sh(s, "beforeDraw", e.clip);
  },
  afterDraw(s, t, e) {
    Sh(s, "afterDraw", e.clip);
  },
  beforeEvent(s, t, e) {
    const a = Rr.get(s);
    kV(a, t.event, e) && (t.changed = !0);
  },
  afterDestroy(s) {
    Rr.delete(s);
  },
  _getState(s) {
    return Rr.get(s);
  },
  defaults: {
    animations: {
      numbers: {
        properties: ["x", "y", "x2", "y2", "width", "height", "centerX", "centerY", "pointX", "pointY", "radius"],
        type: "number"
      }
    },
    clip: !0,
    interaction: {
      mode: void 0,
      axis: void 0,
      intersect: void 0
    },
    common: {
      drawTime: "afterDatasetsDraw",
      init: !1,
      label: {}
    }
  },
  descriptors: {
    _indexable: !1,
    _scriptable: (s) => !f3.includes(s) && s !== "init",
    annotations: {
      _allKeys: !1,
      _fallback: (s, t) => `elements.${Qr[EA(t.type)].id}`
    },
    interaction: {
      _fallback: !0
    },
    common: {
      label: {
        _indexable: Kx,
        _fallback: !0
      },
      _indexable: Kx
    }
  },
  additionalOptionScopes: [""]
};
function Sh(s, t, e) {
  const { ctx: a, chartArea: n } = s, i = Rr.get(s);
  e && Wu(a, n);
  const r = v3(i.visibleElements, t).sort((l, o) => l.element.options.z - o.element.options.z);
  for (const l of r)
    x3(a, n, i, l);
  e && ju(a);
}
function v3(s, t) {
  const e = [];
  for (const a of s)
    if (a.options.drawTime === t && e.push({ element: a, main: !0 }), a.elements && a.elements.length)
      for (const n of a.elements)
        n.options.display && n.options.drawTime === t && e.push({ element: n });
  return e;
}
function x3(s, t, e, a) {
  const n = a.element;
  a.main ? ($I(e, n, "beforeDraw"), n.draw(s, t), $I(e, n, "afterDraw")) : n.draw(s, t);
}
var NN = { exports: {} };
(function(s, t) {
  (function(e, a) {
    s.exports = a();
  })(Rs, function() {
    var e = 1e3, a = 6e4, n = 36e5, i = "millisecond", r = "second", l = "minute", o = "hour", c = "day", d = "week", p = "month", h = "quarter", g = "year", x = "date", b = "Invalid Date", A = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, T = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, R = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(rt) {
      var U = ["th", "st", "nd", "rd"], M = rt % 100;
      return "[" + rt + (U[(M - 20) % 10] || U[M] || U[0]) + "]";
    } }, C = function(rt, U, M) {
      var W = String(rt);
      return !W || W.length >= U ? rt : "" + Array(U + 1 - W.length).join(M) + rt;
    }, v = { s: C, z: function(rt) {
      var U = -rt.utcOffset(), M = Math.abs(U), W = Math.floor(M / 60), J = M % 60;
      return (U <= 0 ? "+" : "-") + C(W, 2, "0") + ":" + C(J, 2, "0");
    }, m: function rt(U, M) {
      if (U.date() < M.date())
        return -rt(M, U);
      var W = 12 * (M.year() - U.year()) + (M.month() - U.month()), J = U.clone().add(W, p), vt = M - J < 0, St = U.clone().add(W + (vt ? -1 : 1), p);
      return +(-(W + (M - J) / (vt ? J - St : St - J)) || 0);
    }, a: function(rt) {
      return rt < 0 ? Math.ceil(rt) || 0 : Math.floor(rt);
    }, p: function(rt) {
      return { M: p, y: g, w: d, d: c, D: x, h: o, m: l, s: r, ms: i, Q: h }[rt] || String(rt || "").toLowerCase().replace(/s$/, "");
    }, u: function(rt) {
      return rt === void 0;
    } }, P = "en", O = {};
    O[P] = R;
    var N = "$isDayjsObject", H = function(rt) {
      return rt instanceof it || !(!rt || !rt[N]);
    }, F = function rt(U, M, W) {
      var J;
      if (!U)
        return P;
      if (typeof U == "string") {
        var vt = U.toLowerCase();
        O[vt] && (J = vt), M && (O[vt] = M, J = vt);
        var St = U.split("-");
        if (!J && St.length > 1)
          return rt(St[0]);
      } else {
        var zt = U.name;
        O[zt] = U, J = zt;
      }
      return !W && J && (P = J), J || !W && P;
    }, B = function(rt, U) {
      if (H(rt))
        return rt.clone();
      var M = typeof U == "object" ? U : {};
      return M.date = rt, M.args = arguments, new it(M);
    }, Q = v;
    Q.l = F, Q.i = H, Q.w = function(rt, U) {
      return B(rt, { locale: U.$L, utc: U.$u, x: U.$x, $offset: U.$offset });
    };
    var it = function() {
      function rt(M) {
        this.$L = F(M.locale, null, !0), this.parse(M), this.$x = this.$x || M.x || {}, this[N] = !0;
      }
      var U = rt.prototype;
      return U.parse = function(M) {
        this.$d = function(W) {
          var J = W.date, vt = W.utc;
          if (J === null)
            return /* @__PURE__ */ new Date(NaN);
          if (Q.u(J))
            return /* @__PURE__ */ new Date();
          if (J instanceof Date)
            return new Date(J);
          if (typeof J == "string" && !/Z$/i.test(J)) {
            var St = J.match(A);
            if (St) {
              var zt = St[2] - 1 || 0, j = (St[7] || "0").substring(0, 3);
              return vt ? new Date(Date.UTC(St[1], zt, St[3] || 1, St[4] || 0, St[5] || 0, St[6] || 0, j)) : new Date(St[1], zt, St[3] || 1, St[4] || 0, St[5] || 0, St[6] || 0, j);
            }
          }
          return new Date(J);
        }(M), this.init();
      }, U.init = function() {
        var M = this.$d;
        this.$y = M.getFullYear(), this.$M = M.getMonth(), this.$D = M.getDate(), this.$W = M.getDay(), this.$H = M.getHours(), this.$m = M.getMinutes(), this.$s = M.getSeconds(), this.$ms = M.getMilliseconds();
      }, U.$utils = function() {
        return Q;
      }, U.isValid = function() {
        return this.$d.toString() !== b;
      }, U.isSame = function(M, W) {
        var J = B(M);
        return this.startOf(W) <= J && J <= this.endOf(W);
      }, U.isAfter = function(M, W) {
        return B(M) < this.startOf(W);
      }, U.isBefore = function(M, W) {
        return this.endOf(W) < B(M);
      }, U.$g = function(M, W, J) {
        return Q.u(M) ? this[W] : this.set(J, M);
      }, U.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, U.valueOf = function() {
        return this.$d.getTime();
      }, U.startOf = function(M, W) {
        var J = this, vt = !!Q.u(W) || W, St = Q.p(M), zt = function(Yt, K) {
          var _ = Q.w(J.$u ? Date.UTC(J.$y, K, Yt) : new Date(J.$y, K, Yt), J);
          return vt ? _ : _.endOf(c);
        }, j = function(Yt, K) {
          return Q.w(J.toDate()[Yt].apply(J.toDate("s"), (vt ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(K)), J);
        }, tt = this.$W, lt = this.$M, at = this.$D, nt = "set" + (this.$u ? "UTC" : "");
        switch (St) {
          case g:
            return vt ? zt(1, 0) : zt(31, 11);
          case p:
            return vt ? zt(1, lt) : zt(0, lt + 1);
          case d:
            var yt = this.$locale().weekStart || 0, Rt = (tt < yt ? tt + 7 : tt) - yt;
            return zt(vt ? at - Rt : at + (6 - Rt), lt);
          case c:
          case x:
            return j(nt + "Hours", 0);
          case o:
            return j(nt + "Minutes", 1);
          case l:
            return j(nt + "Seconds", 2);
          case r:
            return j(nt + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, U.endOf = function(M) {
        return this.startOf(M, !1);
      }, U.$set = function(M, W) {
        var J, vt = Q.p(M), St = "set" + (this.$u ? "UTC" : ""), zt = (J = {}, J[c] = St + "Date", J[x] = St + "Date", J[p] = St + "Month", J[g] = St + "FullYear", J[o] = St + "Hours", J[l] = St + "Minutes", J[r] = St + "Seconds", J[i] = St + "Milliseconds", J)[vt], j = vt === c ? this.$D + (W - this.$W) : W;
        if (vt === p || vt === g) {
          var tt = this.clone().set(x, 1);
          tt.$d[zt](j), tt.init(), this.$d = tt.set(x, Math.min(this.$D, tt.daysInMonth())).$d;
        } else
          zt && this.$d[zt](j);
        return this.init(), this;
      }, U.set = function(M, W) {
        return this.clone().$set(M, W);
      }, U.get = function(M) {
        return this[Q.p(M)]();
      }, U.add = function(M, W) {
        var J, vt = this;
        M = Number(M);
        var St = Q.p(W), zt = function(lt) {
          var at = B(vt);
          return Q.w(at.date(at.date() + Math.round(lt * M)), vt);
        };
        if (St === p)
          return this.set(p, this.$M + M);
        if (St === g)
          return this.set(g, this.$y + M);
        if (St === c)
          return zt(1);
        if (St === d)
          return zt(7);
        var j = (J = {}, J[l] = a, J[o] = n, J[r] = e, J)[St] || 1, tt = this.$d.getTime() + M * j;
        return Q.w(tt, this);
      }, U.subtract = function(M, W) {
        return this.add(-1 * M, W);
      }, U.format = function(M) {
        var W = this, J = this.$locale();
        if (!this.isValid())
          return J.invalidDate || b;
        var vt = M || "YYYY-MM-DDTHH:mm:ssZ", St = Q.z(this), zt = this.$H, j = this.$m, tt = this.$M, lt = J.weekdays, at = J.months, nt = J.meridiem, yt = function(K, _, V, G) {
          return K && (K[_] || K(W, vt)) || V[_].slice(0, G);
        }, Rt = function(K) {
          return Q.s(zt % 12 || 12, K, "0");
        }, Yt = nt || function(K, _, V) {
          var G = K < 12 ? "AM" : "PM";
          return V ? G.toLowerCase() : G;
        };
        return vt.replace(T, function(K, _) {
          return _ || function(V) {
            switch (V) {
              case "YY":
                return String(W.$y).slice(-2);
              case "YYYY":
                return Q.s(W.$y, 4, "0");
              case "M":
                return tt + 1;
              case "MM":
                return Q.s(tt + 1, 2, "0");
              case "MMM":
                return yt(J.monthsShort, tt, at, 3);
              case "MMMM":
                return yt(at, tt);
              case "D":
                return W.$D;
              case "DD":
                return Q.s(W.$D, 2, "0");
              case "d":
                return String(W.$W);
              case "dd":
                return yt(J.weekdaysMin, W.$W, lt, 2);
              case "ddd":
                return yt(J.weekdaysShort, W.$W, lt, 3);
              case "dddd":
                return lt[W.$W];
              case "H":
                return String(zt);
              case "HH":
                return Q.s(zt, 2, "0");
              case "h":
                return Rt(1);
              case "hh":
                return Rt(2);
              case "a":
                return Yt(zt, j, !0);
              case "A":
                return Yt(zt, j, !1);
              case "m":
                return String(j);
              case "mm":
                return Q.s(j, 2, "0");
              case "s":
                return String(W.$s);
              case "ss":
                return Q.s(W.$s, 2, "0");
              case "SSS":
                return Q.s(W.$ms, 3, "0");
              case "Z":
                return St;
            }
            return null;
          }(K) || St.replace(":", "");
        });
      }, U.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, U.diff = function(M, W, J) {
        var vt, St = this, zt = Q.p(W), j = B(M), tt = (j.utcOffset() - this.utcOffset()) * a, lt = this - j, at = function() {
          return Q.m(St, j);
        };
        switch (zt) {
          case g:
            vt = at() / 12;
            break;
          case p:
            vt = at();
            break;
          case h:
            vt = at() / 3;
            break;
          case d:
            vt = (lt - tt) / 6048e5;
            break;
          case c:
            vt = (lt - tt) / 864e5;
            break;
          case o:
            vt = lt / n;
            break;
          case l:
            vt = lt / a;
            break;
          case r:
            vt = lt / e;
            break;
          default:
            vt = lt;
        }
        return J ? vt : Q.a(vt);
      }, U.daysInMonth = function() {
        return this.endOf(p).$D;
      }, U.$locale = function() {
        return O[this.$L];
      }, U.locale = function(M, W) {
        if (!M)
          return this.$L;
        var J = this.clone(), vt = F(M, W, !0);
        return vt && (J.$L = vt), J;
      }, U.clone = function() {
        return Q.w(this.$d, this);
      }, U.toDate = function() {
        return new Date(this.valueOf());
      }, U.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, U.toISOString = function() {
        return this.$d.toISOString();
      }, U.toString = function() {
        return this.$d.toUTCString();
      }, rt;
    }(), et = it.prototype;
    return B.prototype = et, [["$ms", i], ["$s", r], ["$m", l], ["$H", o], ["$W", c], ["$M", p], ["$y", g], ["$D", x]].forEach(function(rt) {
      et[rt[1]] = function(U) {
        return this.$g(U, rt[0], rt[1]);
      };
    }), B.extend = function(rt, U) {
      return rt.$i || (rt(U, it, B), rt.$i = !0), B;
    }, B.locale = F, B.isDayjs = H, B.unix = function(rt) {
      return B(1e3 * rt);
    }, B.en = O[P], B.Ls = O, B.p = {}, B;
  });
})(NN);
var w3 = NN.exports;
const Mn = /* @__PURE__ */ Hs(w3);
var RN = { exports: {} };
(function(s, t) {
  (function(e, a) {
    s.exports = a();
  })(Rs, function() {
    var e = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, a = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d\d/, i = /\d\d?/, r = /\d*[^-_:/,()\s\d]+/, l = {}, o = function(b) {
      return (b = +b) + (b > 68 ? 1900 : 2e3);
    }, c = function(b) {
      return function(A) {
        this[b] = +A;
      };
    }, d = [/[+-]\d\d:?(\d\d)?|Z/, function(b) {
      (this.zone || (this.zone = {})).offset = function(A) {
        if (!A || A === "Z")
          return 0;
        var T = A.match(/([+-]|\d\d)/g), R = 60 * T[1] + (+T[2] || 0);
        return R === 0 ? 0 : T[0] === "+" ? -R : R;
      }(b);
    }], p = function(b) {
      var A = l[b];
      return A && (A.indexOf ? A : A.s.concat(A.f));
    }, h = function(b, A) {
      var T, R = l.meridiem;
      if (R) {
        for (var C = 1; C <= 24; C += 1)
          if (b.indexOf(R(C, 0, A)) > -1) {
            T = C > 12;
            break;
          }
      } else
        T = b === (A ? "pm" : "PM");
      return T;
    }, g = { A: [r, function(b) {
      this.afternoon = h(b, !1);
    }], a: [r, function(b) {
      this.afternoon = h(b, !0);
    }], S: [/\d/, function(b) {
      this.milliseconds = 100 * +b;
    }], SS: [n, function(b) {
      this.milliseconds = 10 * +b;
    }], SSS: [/\d{3}/, function(b) {
      this.milliseconds = +b;
    }], s: [i, c("seconds")], ss: [i, c("seconds")], m: [i, c("minutes")], mm: [i, c("minutes")], H: [i, c("hours")], h: [i, c("hours")], HH: [i, c("hours")], hh: [i, c("hours")], D: [i, c("day")], DD: [n, c("day")], Do: [r, function(b) {
      var A = l.ordinal, T = b.match(/\d+/);
      if (this.day = T[0], A)
        for (var R = 1; R <= 31; R += 1)
          A(R).replace(/\[|\]/g, "") === b && (this.day = R);
    }], M: [i, c("month")], MM: [n, c("month")], MMM: [r, function(b) {
      var A = p("months"), T = (p("monthsShort") || A.map(function(R) {
        return R.slice(0, 3);
      })).indexOf(b) + 1;
      if (T < 1)
        throw new Error();
      this.month = T % 12 || T;
    }], MMMM: [r, function(b) {
      var A = p("months").indexOf(b) + 1;
      if (A < 1)
        throw new Error();
      this.month = A % 12 || A;
    }], Y: [/[+-]?\d+/, c("year")], YY: [n, function(b) {
      this.year = o(b);
    }], YYYY: [/\d{4}/, c("year")], Z: d, ZZ: d };
    function x(b) {
      var A, T;
      A = b, T = l && l.formats;
      for (var R = (b = A.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(F, B, Q) {
        var it = Q && Q.toUpperCase();
        return B || T[Q] || e[Q] || T[it].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(et, rt, U) {
          return rt || U.slice(1);
        });
      })).match(a), C = R.length, v = 0; v < C; v += 1) {
        var P = R[v], O = g[P], N = O && O[0], H = O && O[1];
        R[v] = H ? { regex: N, parser: H } : P.replace(/^\[|\]$/g, "");
      }
      return function(F) {
        for (var B = {}, Q = 0, it = 0; Q < C; Q += 1) {
          var et = R[Q];
          if (typeof et == "string")
            it += et.length;
          else {
            var rt = et.regex, U = et.parser, M = F.slice(it), W = rt.exec(M)[0];
            U.call(B, W), F = F.replace(W, "");
          }
        }
        return function(J) {
          var vt = J.afternoon;
          if (vt !== void 0) {
            var St = J.hours;
            vt ? St < 12 && (J.hours += 12) : St === 12 && (J.hours = 0), delete J.afternoon;
          }
        }(B), B;
      };
    }
    return function(b, A, T) {
      T.p.customParseFormat = !0, b && b.parseTwoDigitYear && (o = b.parseTwoDigitYear);
      var R = A.prototype, C = R.parse;
      R.parse = function(v) {
        var P = v.date, O = v.utc, N = v.args;
        this.$u = O;
        var H = N[1];
        if (typeof H == "string") {
          var F = N[2] === !0, B = N[3] === !0, Q = F || B, it = N[2];
          B && (it = N[2]), l = this.$locale(), !F && it && (l = T.Ls[it]), this.$d = function(M, W, J) {
            try {
              if (["x", "X"].indexOf(W) > -1)
                return new Date((W === "X" ? 1e3 : 1) * M);
              var vt = x(W)(M), St = vt.year, zt = vt.month, j = vt.day, tt = vt.hours, lt = vt.minutes, at = vt.seconds, nt = vt.milliseconds, yt = vt.zone, Rt = /* @__PURE__ */ new Date(), Yt = j || (St || zt ? 1 : Rt.getDate()), K = St || Rt.getFullYear(), _ = 0;
              St && !zt || (_ = zt > 0 ? zt - 1 : Rt.getMonth());
              var V = tt || 0, G = lt || 0, dt = at || 0, ht = nt || 0;
              return yt ? new Date(Date.UTC(K, _, Yt, V, G, dt, ht + 60 * yt.offset * 1e3)) : J ? new Date(Date.UTC(K, _, Yt, V, G, dt, ht)) : new Date(K, _, Yt, V, G, dt, ht);
            } catch {
              return /* @__PURE__ */ new Date("");
            }
          }(P, H, O), this.init(), it && it !== !0 && (this.$L = this.locale(it).$L), Q && P != this.format(H) && (this.$d = /* @__PURE__ */ new Date("")), l = {};
        } else if (H instanceof Array)
          for (var et = H.length, rt = 1; rt <= et; rt += 1) {
            N[1] = H[rt - 1];
            var U = T.apply(this, N);
            if (U.isValid()) {
              this.$d = U.$d, this.$L = U.$L, this.init();
              break;
            }
            rt === et && (this.$d = /* @__PURE__ */ new Date(""));
          }
        else
          C.call(this, v);
      };
    };
  });
})(RN);
var A3 = RN.exports;
const C3 = /* @__PURE__ */ Hs(A3);
var YN = { exports: {} };
(function(s, t) {
  (function(e, a) {
    s.exports = a();
  })(Rs, function() {
    return function(e, a) {
      var n = a.prototype, i = n.format;
      n.format = function(r) {
        var l = this, o = this.$locale();
        if (!this.isValid())
          return i.bind(this)(r);
        var c = this.$utils(), d = (r || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, function(p) {
          switch (p) {
            case "Q":
              return Math.ceil((l.$M + 1) / 3);
            case "Do":
              return o.ordinal(l.$D);
            case "gggg":
              return l.weekYear();
            case "GGGG":
              return l.isoWeekYear();
            case "wo":
              return o.ordinal(l.week(), "W");
            case "w":
            case "ww":
              return c.s(l.week(), p === "w" ? 1 : 2, "0");
            case "W":
            case "WW":
              return c.s(l.isoWeek(), p === "W" ? 1 : 2, "0");
            case "k":
            case "kk":
              return c.s(String(l.$H === 0 ? 24 : l.$H), p === "k" ? 1 : 2, "0");
            case "X":
              return Math.floor(l.$d.getTime() / 1e3);
            case "x":
              return l.$d.getTime();
            case "z":
              return "[" + l.offsetName() + "]";
            case "zzz":
              return "[" + l.offsetName("long") + "]";
            default:
              return p;
          }
        });
        return i.bind(this)(d);
      };
    };
  });
})(YN);
var $3 = YN.exports;
const S3 = /* @__PURE__ */ Hs($3);
var _N = { exports: {} };
(function(s, t) {
  (function(e, a) {
    s.exports = a();
  })(Rs, function() {
    var e = "month", a = "quarter";
    return function(n, i) {
      var r = i.prototype;
      r.quarter = function(c) {
        return this.$utils().u(c) ? Math.ceil((this.month() + 1) / 3) : this.month(this.month() % 3 + 3 * (c - 1));
      };
      var l = r.add;
      r.add = function(c, d) {
        return c = Number(c), this.$utils().p(d) === a ? this.add(3 * c, e) : l.bind(this)(c, d);
      };
      var o = r.startOf;
      r.startOf = function(c, d) {
        var p = this.$utils(), h = !!p.u(d) || d;
        if (p.p(c) === a) {
          var g = this.quarter() - 1;
          return h ? this.month(3 * g).startOf(e).startOf("day") : this.month(3 * g + 2).endOf(e).endOf("day");
        }
        return o.bind(this)(c, d);
      };
    };
  });
})(_N);
var k3 = _N.exports;
const T3 = /* @__PURE__ */ Hs(k3);
var ON = { exports: {} };
(function(s, t) {
  (function(e, a) {
    s.exports = a();
  })(Rs, function() {
    var e = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" };
    return function(a, n, i) {
      var r = n.prototype, l = r.format;
      i.en.formats = e, r.format = function(o) {
        o === void 0 && (o = "YYYY-MM-DDTHH:mm:ssZ");
        var c = this.$locale().formats, d = function(p, h) {
          return p.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(g, x, b) {
            var A = b && b.toUpperCase();
            return x || h[b] || e[b] || h[A].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(T, R, C) {
              return R || C.slice(1);
            });
          });
        }(o, c === void 0 ? {} : c);
        return l.call(this, d);
      };
    };
  });
})(ON);
var L3 = ON.exports;
const D3 = /* @__PURE__ */ Hs(L3);
var MN = { exports: {} };
(function(s, t) {
  (function(e, a) {
    s.exports = a();
  })(Rs, function() {
    var e = "day";
    return function(a, n, i) {
      var r = function(c) {
        return c.add(4 - c.isoWeekday(), e);
      }, l = n.prototype;
      l.isoWeekYear = function() {
        return r(this).year();
      }, l.isoWeek = function(c) {
        if (!this.$utils().u(c))
          return this.add(7 * (c - this.isoWeek()), e);
        var d, p, h, g, x = r(this), b = (d = this.isoWeekYear(), p = this.$u, h = (p ? i.utc : i)().year(d).startOf("year"), g = 4 - h.isoWeekday(), h.isoWeekday() > 4 && (g += 7), h.add(g, e));
        return x.diff(b, "week") + 1;
      }, l.isoWeekday = function(c) {
        return this.$utils().u(c) ? this.day() || 7 : this.day(this.day() % 7 ? c : c - 7);
      };
      var o = l.startOf;
      l.startOf = function(c, d) {
        var p = this.$utils(), h = !!p.u(d) || d;
        return p.p(c) === "isoweek" ? h ? this.date(this.date() - (this.isoWeekday() - 1)).startOf("day") : this.date(this.date() - 1 - (this.isoWeekday() - 1) + 7).endOf("day") : o.bind(this)(c, d);
      };
    };
  });
})(MN);
var I3 = MN.exports;
const P3 = /* @__PURE__ */ Hs(I3);
Mn.extend(S3);
Mn.extend(T3);
Mn.extend(D3);
Mn.extend(C3);
Mn.extend(P3);
var E3 = {
  datetime: "MMM D, YYYY, h:mm:ss a",
  millisecond: "h:mm:ss.SSS a",
  second: "h:mm:ss a",
  minute: "h:mm a",
  hour: "hA",
  day: "MMM D",
  week: "ll",
  month: "MMM YYYY",
  quarter: "[Q]Q - YYYY",
  year: "YYYY"
};
sE._date.override({
  //_id: 'dayjs', //DEBUG,
  formats: function() {
    return E3;
  },
  parse: function(t, e) {
    var a = typeof t;
    return t === null || a === "undefined" ? null : a === "string" && typeof e == "string" ? Mn(t, e).isValid() ? Mn(t, e).valueOf() : null : t instanceof Mn ? null : Mn(t).isValid() ? Mn(t).valueOf() : null;
  },
  format: function(t, e) {
    return Mn(t).format(e);
  },
  add: function(t, e, a) {
    return Mn(t).add(e, a).valueOf();
  },
  diff: function(t, e, a) {
    return Mn(t).diff(Mn(e), a);
  },
  startOf: function(t, e, a) {
    if (e === "isoWeek") {
      var n = typeof a == "number" && a > 0 && a < 7 ? a : 1;
      return Mn(t).isoWeekday(n).startOf("day").valueOf();
    }
    return Mn(t).startOf(e).valueOf();
  },
  endOf: function(t, e) {
    return Mn(t).endOf(e).valueOf();
  }
});
Jr.register(...SE, b3);
const W$ = class W$ {
  constructor(t, e, a) {
    this.$element = t, this.$timeout = e, this.$scope = a, this.chart = void 0;
  }
  /**
   * Implement IController
   */
  init() {
    this.customHeight = this.customHeight ?? "", this.customWidth = this.customWidth ?? "", this.customClass = this.customClass ?? "", this.$timeout(() => {
      this.createChart();
    }), this.$scope.$watch(() => this.config?.data, (t) => {
      t && this.updateChart();
    }, !0);
  }
  /** Creates chart based on data and options to canvas or updates chart if it already exists */
  createChart() {
    if (!this.chart) {
      const t = this.$element.find("canvas")[0]?.getContext("2d");
      t && this.config && (this.chart = new Jr(t, this.config));
    }
  }
  /**
   * Updates provided current chart
   * "none" parameters means no animation for update
   */
  updateChart() {
    this.chart && (this.chart.data = this.config?.data, this.chart.update("none"));
  }
};
W$.$inject = ["$element", "$timeout", "$scope"];
let pg = W$;
const j$ = class j$ {
  /**
   * Creates a new instance of the directive.
   */
  constructor(t) {
    this.uiHelpers = t, this.config = {
      hoverPreviewEnabled: !1,
      hoverPreviewArrayCount: 100,
      hoverPreviewFieldCount: 5
    };
  }
  /**
   * Initialize default values.
   */
  $onInit() {
    this.open == null && (this.open = 1), this.isOpen = !!this.open, this.jsonType = this.getType(this.json), this.changes = this.getChanges(), this.deletedKeys = this.getDeletedKeys();
  }
  /** Escapes quotation marks in text */
  escapeString(t) {
    return t.replace(/"/g, '\\"');
  }
  /** From http://stackoverflow.com/a/332429 */
  getObjectName(t) {
    if (t === void 0)
      return "";
    if (t === null || typeof t == "object" && !t.constructor)
      return "Object";
    if (t.__proto__ !== void 0 && t.__proto__.constructor !== void 0 && t.__proto__.constructor.name !== void 0)
      return t.__proto__.constructor.name;
    const a = /function (.{1,})\(/.exec(t.constructor.toString());
    return a && a.length > 1 ? a[1] : "";
  }
  /** Gets the object type as string */
  getType(t) {
    if (t === null)
      return "null";
    const e = typeof t;
    return e === "string" && (new Date(t).toString() !== "Invalid Date" && (this.isDate = !0), t.indexOf("http") === 0 && (this.isUrl = !0)), e;
  }
  /** Gets the value preview text. */
  getValuePreview(t) {
    const e = this.getType(t);
    return e === "null" || e === "undefined" ? e : (e === "string" && (t = '"' + this.escapeString(t) + '"'), e === "function" ? t.toString().replace(/[\r\n]/g, "").replace(/\{.*\}/, "") + "{…}" : t);
  }
  /** Gets a preview of the object. */
  getPreview(t) {
    let e = "";
    return wt.isObject(t) ? (e = this.getObjectName(t), wt.isArray(t) && (e += "[" + t.length + "]")) : e = this.getValuePreview(t), e;
  }
  /** Returns true, if json is an array */
  isArray() {
    return wt.isArray(this.json);
  }
  /** Returns true, if json is an object (including an array). */
  isObject() {
    return wt.isObject(this.json);
  }
  /** Gets the keys for the object. Only returns keys whgere showKey is true. */
  getKeys() {
    if (this.isObject())
      return Object.keys(this.json).filter((t) => this.showKey(t)).map((t) => t === "" ? '""' : t);
  }
  /** Hides keys like $$hashKey */
  showKey(t) {
    return !t || t === "$ref" ? !0 : !t.startsWith("$");
  }
  /** If true, the current JSON has a key */
  get hasKey() {
    return typeof this.key < "u";
  }
  /** Gets the constructor name */
  getConstructorName() {
    return this.getObjectName(this.json);
  }
  /** Returns true if the the object is an empty object. */
  isEmptyObject() {
    return this.getKeys() && !this.getKeys().length && this.isOpen && !this.isArray();
  }
  /** Opens / closes the node */
  toggleOpen() {
    this.isOpen = !this.isOpen;
  }
  /** Returns the number of open levels for immediate children (this open - 1, but not less than 0). */
  childrenOpen() {
    return this.open > 1 ? this.open - 1 : 0;
  }
  /** Opens the link in a new window. */
  openLink(t) {
    t && (window.location.href = this.json);
  }
  /** Parses value (gets a preview) */
  parseValue(t) {
    return this.getValuePreview(t);
  }
  /** Shows the current JSON as dialog. */
  showDialog() {
    this.uiHelpers.openEditDialog("salaxy-components/helpers/JsonFormatterDialog.html", this.json, {
      compare: this.compare,
      compareTo: this.compareTo,
      key: this.key,
      open: this.open,
      type: "default",
      title: this.key ? "JSON Preview " + this.key : "JSON Preview"
    });
  }
  /** Returns true if the thumbnail should be shown */
  showThumbnail() {
    return !!this.config.hoverPreviewEnabled && this.isObject() && !this.isOpen;
  }
  /** Gets the thumbnail value. */
  getThumbnail() {
    if (this.isArray())
      return this.json.length > this.config.hoverPreviewArrayCount ? "Array[" + this.json.length + "]" : "[" + this.json.map(this.getPreview).join(", ") + "]";
    {
      const t = this.getKeys(), a = t.slice(0, this.config.hoverPreviewFieldCount).map((i) => i + ":" + this.getPreview(this.json[i])), n = t.length >= 5 ? "…" : "";
      return "{" + a.join(", ") + n + "}";
    }
  }
  /** Gets the keys that are not in the current, but are in the original. */
  getDeletedKeys() {
    if (!this.compare || !wt.isObject(this.compareTo))
      return [];
    const t = this.getKeys();
    return Object.keys(this.compareTo).map((e) => e === "" ? '""' : t.find((a) => a === e) ? null : e).filter((e) => e != null);
  }
  /** Gets the changes compared to the original element */
  getChanges() {
    if (!this.compare || wt.equals(this.json, this.compareTo))
      return null;
    let t = "changed", e = "*";
    const a = this.getValuePreview(this.compareTo);
    return a === "undefined" || a === "null" ? (t = "new", e = "+") : (this.jsonType === "null" || this.jsonType === "undefined") && (t = "deleted", e = "-"), {
      type: t,
      oldValue: a,
      icon: e
    };
  }
};
j$.$inject = ["UiHelpers"];
let hg = j$;
const V$ = class V$ {
  /**
   * Creates a new NaviController
   * @param naviService - Service that stores the navigation state.
   * @ignore
   */
  constructor(t, e, a) {
    this.naviService = t, this.sessionService = e, this.userSettingsService = a, this.mode = "default", this.$onInit = () => {
      this.mode !== "accordion" && this.mode !== "3-levels" && this.mode !== "horizontal" && (this.mode = "default");
    };
  }
  /**
   * Contains information about the current sitemap node (if resoved) and other data related to route.
   * This property takes into account that the current node may not be found,
   * i.e. current.node may be null, current.path may be [].
   * However, the "route" as an object should never be null.
   * All the other properties in this controller use first node as default for historical reasons.
   */
  get route() {
    return this.naviService.current;
  }
  /**
   * Returns the main sitemap object that is used in rendering the navigation.
   * Set the sitemap by setting the angular constant or object "SITEMAP"
   */
  get sitemap() {
    return this.naviService.getSitemap();
  }
  /**
   * If true, the layout should show a full-page loader instead of normal pages.
   * Controllers in normal pages should be destoyed (e.g. using ng-if) so that this can also
   * be used in reloading the AngularJS user interface without full Browser reload.
   */
  get showFullPageLoader() {
    return this.sessionService.isLoading;
  }
  /**
   * Gets the user-specific setting (service), stored in the local storage.
   */
  get userSettings() {
    return this.userSettingsService;
  }
  /**
   * Temporary visibility helper for the new Payroll 4 version.
   */
  get newPayrollVersion() {
    const e = {
      /** If true, the switch for selecting version 4 is shown to the user. */
      show: !0,
      /** If true the new version is in use. */
      use: this.userSettings.ng1Binder("payroll.newVersion").val ?? !0
    };
    return this.sessionService.session.settings.integration?.serverUrl && (e.show = !1, e.use = !0), e;
  }
  /** New payroll version use */
  get newPayrollVersionUse() {
    return this.newPayrollVersion.use;
  }
  /**
   * New payroll version use
   */
  set newPayrollVersionUse(t) {
    this.userSettings.ng1Binder("payroll.newVersion").val = t ?? !0;
  }
  /**
   * Returns route for the given path
   * @param path Page URL path for the node.
   * @returns Route for the path.
   */
  getRoute(t = null) {
    return t ? new Uv(this.naviService.getNodesByPath(t)) : this.route;
  }
  /**
   * Retuns the identifier of the currently selected section.
   * If nothing else is selected, it will return the first section, by convention called 'home'.
   */
  getSectionId() {
    return this.naviService.currentSection ? this.naviService.currentSection.id : "home";
  }
  /**
   * Gets the navi URL from a sitemap node.
   * Currently, removes "*" at the end if url ends with "/*", but may be used for additional logic in the future.
   */
  getUrl(t) {
    return !t || !t.url ? null : t.url.endsWith("/*") ? t.url.substr(0, t.url.length - 1) : t.url;
  }
  /** Toggles the isNaviOpen property */
  toggleNavi() {
    this.naviService.isNaviOpen = !this.naviService.isNaviOpen;
  }
  /**
   * True if the navigation (e.g. left sidebar) is open.
   * Typically, this property is used only in narrow (mobile) view, otherwise the sidebar is always shown.
   */
  get isNaviOpen() {
    return this.naviService.isNaviOpen;
  }
  set isNaviOpen(t) {
    this.naviService.isNaviOpen = t;
  }
  /** Toggles the isSidebarOpen property */
  toggleSidebar() {
    this.naviService.isSidebarOpen = !this.naviService.isSidebarOpen;
  }
  /**
   * True if the secondary sidebar (e.g. right sidebar) is open.
   */
  get isSidebarOpen() {
    return this.naviService.isSidebarOpen;
  }
  set isSidebarOpen(t) {
    this.naviService.isSidebarOpen = t;
  }
  /**
   * Gets the current section: The first level node in the sitemap
   * @returns Section filtered by the roles.
   */
  getSection() {
    return this.naviService.getCurrentSection();
  }
  /**
   * Returns true if the node should be hidden in the navi.
   * @param node Node to check. If null, the current node is checked (not defaulted to first node).
   */
  getHidden(t = null) {
    return ws.getVisibility(t || this.route.node, _a.Hidden);
  }
  /**
   * Gets the visibility:disabled flag for the current node OR any node in the path
   */
  getDisabled() {
    return this.route.node?.visibility == _a.Disabled || !!this.route.path.find((t) => t.visibility == _a.Disabled);
  }
  /**
   * Returns true if the node has non-hidden children.
   * @param node Node to check
   */
  hasChildren(t) {
    return !!t?.children.find((e) => !ws.getVisibility(e, _a.Hidden));
  }
  /**
   * Filters away the hidden nodes from node array.
   * @param nodes Node array.
   */
  filterHidden(t) {
    return t ? t.filter((e) => !ws.getVisibility(e, _a.Hidden)) : [];
  }
  /**
   * Returns true if the given node is the currently selected node.
   */
  isCurrent(t) {
    return this.naviService.isCurrent(t);
  }
  /**
   * Returns true if the given node is the currently selected node.
   */
  isCurrentSection(t) {
    return this.naviService.isCurrentSection(t);
  }
  /**
   * In test environment, returns true if the sitemap node has role "test" and it is visible only because of that role.
   * @param siteMapNode Node in the sitemap.
   */
  isTest(t) {
    return t.visibleTestOnly >= 0;
  }
  /**
   * Navigate to given path
   * @param path - Path to navigate.
   * @param checkSession - If true, triggers session refresh
   */
  navigateTo(t, e = !1) {
    this.naviService.navigateTo(t, e);
  }
  /** Returns the page / node title */
  get title() {
    return this.naviService.title || this.naviService.sectionTitle || " ";
  }
  /** Gets the currently selected node. */
  get current() {
    return this.naviService.currentNode;
  }
  /** Current path from root to the current node. */
  get currentPath() {
    return this.naviService.currentPath;
  }
  /** Returns true if the current window is in an IFrame */
  get isInIframe() {
    try {
      return window.self !== window.top;
    } catch {
      return !0;
    }
  }
  /** Returns current year. Used for example in copyright texts in footers */
  getCurrentYear() {
    return (/* @__PURE__ */ new Date()).getFullYear();
  }
  /**
   * Determines whether to show the KYC (Know Your Customer) information.
   * @returns A boolean value indicating whether to show the KYC information.
   */
  get showKyc() {
    return this.sessionService.kycState == "missing" || this.sessionService.kycState == "expired";
  }
  /** Returns current application */
  get applicationId() {
    return Ne.current.applicationId;
  }
};
V$.$inject = ["NaviService", "SessionService", "UserSettingsService"];
let xu = V$;
const q$ = class q$ {
  /**
   * Creates a new SpinnerController
   * @ignore
   */
  constructor() {
    this.$onInit = () => {
    };
  }
  /**
   * Gets the header with default Finnish texts for "SALAXY.UI_Terms.loading" and "SALAXY.UI_Terms.loginInProgress".
   * Other untranslated language terms (starting with "SALAXY.") return an empty text. Other texts are printed as is.
   */
  getHeading() {
    if (!this.heading)
      return null;
    const t = {
      "SALAXY.UI_Terms.loading": "Ladataan...",
      "SALAXY.UI_Terms.loginInProgress": "Kirjaudutaan..."
    };
    let e = this.heading;
    return e.startsWith("SALAXY.") && (e = t[this.heading]), L.getWithDefault(this.heading, e);
  }
};
q$.$inject = [];
let mg = q$;
const K$ = class K$ {
  /**
   * Creates a new TabController.
   * @ignore
   */
  constructor(t) {
    this.$element = t, this.selected = !1, this.disable = !1, this.index = null, this.heading = null, this.headingElement = null, this.contentElement = null, this.sort = 0;
  }
  /**
   * Change event handler. Re-sets the one-way bound fields.
   * This is needed, because the parent scope cannot detect the changes without the re-set.
   */
  $onChanges(t) {
    t.disable && (this.disable = t.disable.currentValue), t.index && (this.index = t.index.currentValue);
  }
  /**
   * Registers this tab to the tabs controller.
   * Passes the heading DOM element to be displayed in the header.
   */
  $onInit() {
    this.sort = this.getPosition(this.$element), this.headingElement = this.findTranscludeElement(this.$element, "heading"), this.contentElement = this.findTranscludeElement(this.$element, "content"), this.index = this.tabsCtrl.register(this);
  }
  /**
   * De-registers this tab from the tabs controller.
   */
  $onDestroy() {
    this.tabsCtrl.deregister(this);
  }
  /**
   * Tries to find the element with ng-transclude='heading' attribute.
   * @param el - Element to check.
   */
  findTranscludeElement(t, e) {
    if (t.attr("ng-transclude") === e)
      return t[0];
    const a = t.children();
    for (let n = 0; n < a.length; n++) {
      const i = this.findTranscludeElement(a.eq(n), e);
      if (i)
        return i;
    }
    return null;
  }
  getPosition(t) {
    const e = this.findParentTag(t, "salaxy-tab");
    if (!e)
      return 0;
    const a = this.findParentTag(e, "salaxy-tabs");
    if (!a)
      return 0;
    const n = [];
    this.findChildren(a, n, "salaxy-tab");
    for (let i = 0; i < n.length; i++)
      if (e[0] === n[i][0])
        return i;
    return 0;
  }
  findParentTag(t, e) {
    if (t[0].tagName.toLowerCase() === e)
      return t;
    const a = t.parent();
    return a.length === 1 ? this.findParentTag(a, e) : null;
  }
  findChildren(t, e, a) {
    if (t[0].tagName.toLowerCase() === a) {
      e.push(t);
      return;
    }
    const n = t.children();
    for (let i = 0; i < n.length; i++)
      this.findChildren(n.eq(i), e, a);
  }
};
K$.$inject = ["$element"];
let gg = K$;
const J$ = class J$ {
  /**
   * Creates a new TabsController.
   * @ignore
   */
  constructor() {
    this.tabs = [], this.active = "";
  }
  /** Set the values and defaults on init */
  $onInit() {
  }
  /**
   * Registers a single tab to this controller.
   * @param tab - Tab to register.
   */
  register(t) {
    this.tabs.push(t), this.setSortOrder(t), this.tabs.sort((a, n) => a.sort > n.sort ? 1 : a.sort < n.sort ? -1 : 0);
    const e = this.findIndex(t);
    return t.index == this.active && (t.selected = !0), t.index || e;
  }
  /**
   * De-registers a single tab from this controller.
   * @param tab - Tab to de-register.
   */
  deregister(t) {
    const e = this.findIndex(t);
    if (this.tabs[e].index === this.active) {
      const a = e === this.tabs.length - 1 ? e - 1 : (e + 1) % this.tabs.length;
      this.select(this.tabs[a]);
    }
    this.tabs.splice(e, 1);
  }
  /**
   * Sets the selected tab as selected.
   * @param selectedTab - Selected tab.
   */
  select(t, e) {
    if (!(t && t.disable === !0)) {
      for (const a of this.tabs)
        a.selected && a !== t && (a.selected = !1);
      t && (t.selected = !0, t.onSelect({
        $event: e
      }));
    }
  }
  findIndex(t) {
    for (let e = 0; e < this.tabs.length; e++)
      if (this.tabs[e] === t)
        return e;
    return 0;
  }
  setSortOrder(t) {
    let e = !1;
    for (const a of this.tabs)
      a !== t && a.sort === t.sort && (e = !0);
    if (e)
      for (const a of this.tabs)
        a !== t && a.sort >= t.sort && a.sort++;
  }
};
J$.$inject = [];
let yg = J$;
const Q$ = class Q$ {
  /**
   * Creates a new TabButtonsController.
   * @ignore
   */
  constructor(t, e, a) {
    this.$location = t, this.$timeout = e, this.$scope = a;
  }
  /** Sets default tab value on component initialization. If default tab is not manually set, defaults to the first tab in the options list. */
  $onInit() {
    let e = this.options.find((i) => i.isDefault)?.value || this.options[0].value;
    const a = this.$location.search().tab, n = this.options.map((i) => i.value);
    a && n.includes(a) && (e = a), this.currentTab = e, this.showTab(this.currentTab), this.$timeout(() => {
      this.$scope.$emit("tabButtonsControllerReady", { ctrl: this, tabsId: this.tabsId });
    }, 0);
  }
  /**
   * Shows a tab programmatically.
   * @param tabValue Tab's id text value.
   */
  showTab(t) {
    this.clearSelection(), this.currentTab = t;
    const e = document.getElementById(`tab-content-${this.tabsId}`);
    if (e) {
      const a = e.querySelector(`#${t}-tab`);
      a && (a.classList.add("active"), a.classList.add("show"));
    }
  }
  /**
   * Clears previously selected tabs (removes classes).
   */
  clearSelection() {
    document.querySelectorAll(`#tab-content-${this.tabsId} > .tab-pane`).forEach((e) => {
      e.classList.remove("active"), e.classList.remove("show");
    });
  }
  /**
   * Return the text value for tab button, either a translation or numerical value.
   * @param tabText Tab text value to be returned.
   * @returns Tab button text.
   */
  getTabText(t) {
    return typeof t == "number" ? t : L.get(t);
  }
};
Q$.$inject = ["$location", "$timeout", "$scope"];
let fg = Q$;
const Z$ = class Z$ {
  /**
   * Creates a new UiTranslatorController
   * @ignore
   */
  constructor(t, e, a) {
    this.uiHelpers = t, this.$timeout = e, this.uiTranslatorService = a, this.allKeyValues = [], this.serviceModelTexts = [], this.showCols = {
      fullKey: "true",
      fi: "true",
      en: "true",
      sv: "true"
    }, this.listFilter = {}, this.isLoading = !1, this.$onInit = () => {
      this.initTranslationTable(), this.initTexts();
    };
  }
  /**
   * Beginning of the full key that is used to filtering the dictionary items (allKeyValues filter).
   * The value may be a string, array or comma separated string of values.
   */
  get filter() {
    return this._filter;
  }
  set filter(t) {
    this._filter = t, this.updateAllKeyValues();
  }
  /** Updates this.text and keeps reference to parent */
  updateTexts() {
    wt.copy(this.toTexts(), this.texts);
  }
  /**
   * Check if key exists in serviceModelTexts for specified language.
   * @param fullkey Dictionary key
   * @param lang Language that is checked.
   * @returns True if the provided key exists
   */
  checkIfExistsInTexts(t, e) {
    return !!this.serviceModelTexts.find((a) => a.fullKey === t && e in a);
  }
  /**
   * Check if item can be deleted from serviceModelTexts
   * @param fullKey dictionary key
   * @returns True if the item can be deleted.
   */
  canDeleteFromText(t) {
    return !!this.serviceModelTexts.find((e) => e.fullKey === t);
  }
  /**
   * Finds and return item from serviceModelTexts
   * @param fullkey search value
   * @returns serviceModelTexts item
   */
  getEditableText(t) {
    return this.serviceModelTexts.find(({ fullKey: e }) => e === t);
  }
  /**
   * Adds item to serviceModelTexts
   * @param fullKey fullKey to be added
   */
  addToTexts(t, e) {
    const a = this.serviceModelTexts.findIndex((n) => n.fullKey === t);
    if (a > -1)
      this.serviceModelTexts[a][e] = "";
    else {
      const n = { fullKey: t };
      n[e] = "", this.serviceModelTexts.push(n);
    }
    this.updateTexts();
  }
  /**
   * Remove item from serviceModelTexts
   * @param fullKey fullKey search value
   */
  removeFromTexts(t) {
    const e = this.serviceModelTexts.findIndex((a) => a.fullKey === t);
    this.serviceModelTexts.splice(e, 1), this.updateTexts();
  }
  /**
   * Save current diff to JSON file
   */
  downloadTexts() {
    const t = this.getDiffDictionary(), e = JSON.stringify(t), a = new TextEncoder().encode(e), n = new Blob([a], {
      type: "application/json;charset=utf-8"
    });
    this.uiHelpers.downloadFile(n, "diff");
  }
  initTranslationTable() {
    this.isLoading = !0, this.$timeout().then(() => {
      this.uiTranslatorService.getDictionary().length < 1 ? L.instance.getBaseDictionary().then((t) => {
        this.createKeyValues(t, ""), this.updateAllKeyValues(), this.$timeout(), this.isLoading = !1;
      }) : (this.updateAllKeyValues(), this.isLoading = !1);
    });
  }
  initTexts() {
    this.serviceModelTexts = this.fromTexts(this.texts);
  }
  fromTexts(t) {
    t = t || {};
    const e = [];
    return Object.keys(t).forEach((a) => {
      const n = a.substr(0, 2), i = a.substring(3);
      if (e.length) {
        const r = e.findIndex((l) => l.fullKey === i);
        if (r > -1)
          e[r][n] = t[a];
        else {
          const l = { fullKey: i };
          l[n] = t[a], e.push(l);
        }
      } else {
        const r = { fullKey: i };
        r[n] = t[a], e.push(r);
      }
    }), e;
  }
  toTexts() {
    const t = {};
    return this.serviceModelTexts.forEach((e) => {
      Object.keys(e).forEach((a) => {
        if (a !== "fullKey") {
          const n = `${a}.${e.fullKey}`;
          t[n] = e[a];
        }
      });
    }), t;
  }
  updateAllKeyValues() {
    this.allKeyValues = this.uiTranslatorService.getDictionary();
    const t = ie.assureArray(this.filter);
    t.length && (this.allKeyValues = this.allKeyValues.filter((e) => t.find((a) => e.fullKey.startsWith(a))));
  }
  createKeyValues(t, e) {
    Object.keys(t).forEach((a) => {
      if (typeof t[a] == "object")
        this.createKeyValues(t[a], `${e}.${a}`);
      else {
        const n = `${e}.${a}`, i = n.substring(4), r = n.slice(1, 3), l = this.uiTranslatorService.getDictionary(), o = l.findIndex((c) => c.fullKey === i);
        if (o > -1)
          l[o][r] = t[a];
        else {
          const c = i.split("."), d = {
            fullKey: i,
            shortKey: c[c.length - 1],
            fileName: c[1],
            keyComponent: c[2],
            keyValue: c[3]
          };
          d[r] = t[a], this.uiTranslatorService.addToDictionary(d);
        }
      }
    });
  }
  getDiffDictionary() {
    const t = {
      fi: {},
      en: {},
      sv: {}
    };
    return this.serviceModelTexts.forEach((e) => {
      const a = e.fullKey.split(".");
      Object.keys(t).forEach((n) => {
        let i = t[n];
        for (let r = 0; r < a.length; r++)
          r === a.length - 1 ? i = i[a[r]] = e[n] : a[r] in i ? i = i[a[r]] : i = i[a[r]] = {};
      });
    }), t;
  }
};
Z$.$inject = ["UiHelpers", "$timeout", "UiTranslatorService"];
let bg = Z$;
const tS = class tS {
  /**
   * Constructor for Dependency Injection.
   */
  constructor(t, e) {
    this.fileService = t, this.jsonSchemaService = e, this.calculationsUrl = new nm(null).getBaseUrl();
  }
  /**
   * Returns Exportable api for the used crud.
   * @returns Exportable api.
   */
  getExportable() {
    switch (this.$crud.getApi().getBaseUrl()) {
      case this.calculationsUrl:
        return {
          getExportMappers: () => yc.getMappers(["Calculation", "CalculationListItem"]),
          getExportMapper: (e) => yc.getBuiltInMapper(e, this.jsonSchemaService.getCache()),
          exporters: this.fileService.getDefaultExporters(),
          getSingle: (e) => this.$crud.getApi().getSingle(e.id),
          list: (e, a) => this.$odata.exportItems(e ?? 0, a)
        };
      default:
        return null;
    }
  }
};
tS.$inject = ["FileService", "JsonSchemaService"];
let vg = tS;
const eS = class eS {
  /**
   * Constructor for Dependency Injection.
   * @param uiHelpers Salaxy ui helpers.
   * @param wizardService Wizard service.
   */
  constructor(t, e, a) {
    this.uiHelpers = t, this.wizardService = e, this.$timeout = a, this.localeId = T0.Fi, this.mapper = null, this.importSteps = [
      {
        title: "Liitä / lataa taulukko",
        view: "salaxy-components/modals/import/ImportStep1.html"
      },
      {
        title: "Asetukset",
        view: "salaxy-components/modals/import/ImportStep2.html"
      },
      {
        title: "Validointi",
        view: "salaxy-components/modals/import/ImportStep3.html"
      },
      {
        title: "Tallennus",
        view: "salaxy-components/modals/import/ImportStep4.html"
      }
    ], this.batch = null, this.progress = 0, this.progressMessage = null, this.lastResult = null, this._objectMappers = null;
  }
  /** Gets or sets the Importable api that defines how the data is imported. */
  get api() {
    return this._api;
  }
  set api(t) {
    this._api = t, this.createBatch();
  }
  /** Available object mappers for export */
  get objectMappers() {
    return this._objectMappers || (this._objectMappers = this.api.getImportMappers(), this._objectMappers?.length == 1 && this.setMapper(this._objectMappers[0].value)), this._objectMappers;
  }
  /** Clears the last validation result. */
  clearLastResult() {
    this.batch && this.batch.clearValidation(), this.lastResult = null;
  }
  /**
   * Shows import dialog.
   * @param api Optional API implementing Importable that is set to the controller.
   * The API must be set to the controller as property or in this parameter or showImport() will fail
   */
  showImport(t = null) {
    if (t && (this.api = t), !this.api)
      throw new Error("Importable API not specified in showImport()");
    this.wizardService.setSteps(this.importSteps), this.wizardService.activeStepNumber = 1;
    const e = {
      $parent: this
    };
    this.uiHelpers.showDialog(
      "salaxy-components/modals/import/Import.html",
      "WizardController",
      e,
      null,
      "lg"
    ).then(() => {
    });
  }
  /** Paste data from clipboard. */
  pasteFromClipboard() {
    return this.createBatch(), navigator.clipboard.readText().then((t) => (this.batch.rawData = t, this.$timeout(() => t)));
  }
  /**
   * Reads the file
   * @param file Selected file
   */
  readFile(t) {
    if (!t)
      return Promise.resolve(null);
    if (t.name && t.name.toLowerCase().match(/\.xl(s|sx)$/g))
      return this.uiHelpers.showAlert("Tiedoston muotoa ei tueta", "Excel-tiedostot eivät ole vielä tuettuja. Käytä csv tai tab -muotoa."), Promise.resolve(null);
    const e = new Promise((a, n) => {
      const i = new FileReader();
      i.onloadend = () => {
        a(i.result);
      }, i.onerror = () => n, i.readAsText(t);
    });
    return this.createBatch(), e.then((a) => (this.batch.rawData = a, this.$timeout(() => a)));
  }
  /**
   * Creates / resets the import batch as new using the current api
   * (should be selected before) and mapper (may be null / not yet selected).
   */
  createBatch() {
    this.batch = new jM(this.mapper, this.api), this.fileParsers = this.api.parsers ?? [], this.currentFileParser = null;
  }
  /**
   * Read batch raw data.
   * @returns The status of the read as API validation object (also saved to lastResult).
   */
  readBatch() {
    if (!this.currentFileParser) {
      const t = $w.guessParser(this.fileParsers, this.batch.rawData);
      if (t)
        this.currentFileParser = t.parser, this.localeId = t.locale;
      else
        return;
    }
    return this.lastResult = this.batch.read(null, this.currentFileParser, this.localeId), this.lastResult;
  }
  /**
   * Sets the import mapper by ID.
   * @param id Identifier of the new object mapper.
   * @returns The mapper once it has been loaded / resolved.
   */
  setMapper(t) {
    return this.api.getImportMapper(t).then((e) => (this.mapper = e, this.batch.setMapper(e), this.readBatch(), this.$timeout(), e));
  }
  /** Read batch data */
  mapBatch() {
    this.batch.map();
  }
  /** Validate batch data */
  validateBatch() {
    this.setProgress(1, "Tarkistetaan...");
    const t = (e, a, n, i) => {
      this.setProgress(a + 1, "Tarkistetaan...", n);
    };
    this.batch.validate(t).then(() => {
      this.setProgress(0);
    });
  }
  /**
   * Imports the batch data.
   * @param $close Close function of the UI Bootstrap dialog.
   */
  importBatch(t) {
    this.setProgress(1, "Tallennetaan... ");
    const e = (a, n, i, r) => {
      this.setProgress(n + 1, "Tallennetaan...", i);
    };
    this.lastResult = null, this.batch.import(e).then((a) => {
      this.setProgress(0), this.lastResult = a, a.errors?.length || t(We.Ok);
    });
  }
  /**
   * Sets the progress indicator
   * @param value Value of the progress 0-100. If the process is just starting, use 1.
   * If not in progress, use 0. If the count is null, you may also use absolute value (index+1) here:
   * The system will convert it to 1-100 first assuming there is 10 items, then that there is 100 items.
   * @param message Progress message
   * @param count Total count of items if known.
   */
  setProgress(t, e = null, a = null) {
    if (!t) {
      this.progress = 0, this.progressMessage = null;
      return;
    }
    a ? this.progress = t / a * 100 : t < 10 ? this.progress = t * 10 : t < 100 ? this.progress = t : t < 1e3 ? this.progress = t / 10 : this.progress = 90, this.progress > 100 && (this.progress = 100), this.progress < 1 && (this.progress = 1), this.progressMessage = e ? e + " " : "", t != 1 && t != 100 && (this.progressMessage += `(${t}${a ? "/" + a : ""})`);
  }
  /** Toggles the debug view on/off. */
  toggleDebug() {
    const t = !this.isDebug;
    this.isDebug = t;
    const e = document.getElementById("salaxyDialog");
    e && (t ? e.style.width = "98vw" : e.style.width = null);
  }
};
eS.$inject = ["UiHelpers", "WizardService", "$timeout"];
let Qx = eS;
const aS = class aS {
  constructor(t, e) {
    this.alertService = t, this.uiHelpers = e, this.maxCount = "0", this.maxCountOptions = [
      {
        value: "0",
        text: L.get("SALAXY.NG1.ExportComponent.exportLengths.all")
      },
      {
        value: "-1",
        text: L.get("SALAXY.NG1.ExportComponent.exportLengths.current")
      },
      {
        value: "1000",
        text: L.get("SALAXY.NG1.ExportComponent.exportLengths.short")
      },
      {
        value: "10000",
        text: L.get("SALAXY.NG1.ExportComponent.exportLengths.long")
      }
    ], this.localeId = T0.Fi, this.mapper = null, this.isExporting = !1, this.exportMessage = null, this.allMappers = null, this.listItemMappers = null, this.objectMappers = null;
  }
  /** Gets or sets the API that implements the Exportable interface. */
  get api() {
    return this._api;
  }
  set api(t) {
    this._api = t, this.exporters = this.api.exporters ?? [], this.currentExporter = this.exporters[0], this.allMappers = this.api.getExportMappers(), this.listItemMappers = this.api.getExportMappers().filter((e) => (e.sourceSchema || "").indexOf("ListItem") > 0), this.objectMappers = this.api.getExportMappers().filter((e) => (e.sourceSchema || "").indexOf("ListItem") < 0);
  }
  /**
   * Shows an export dialog for full export.
   * @param api Optional API implementing Exportable that is set to the controller.
   * The API must be set to the controller as property or in this parameter or showExport() will fail
   */
  showExport(t) {
    if (this.api = t || this.api, !this.api)
      throw new Error("Exportable API not specified in showExport()");
    this.currentExporter = this.exporters[0];
    const e = this.uiHelpers.showLoading();
    this.api.getExportMapper((this.listItemMappers[0] || this.allMappers[0]).uri).then((a) => {
      this.mapper = a;
      const n = {
        $parent: this
      };
      e.dismiss(), this.uiHelpers.showDialog("salaxy-components/modals/export/Export.html", null, n, null, "lg");
    });
  }
  /**
   * Executes an immediate quick export - typically directly from a view.
   * Shows the Loader while data is being loaded for the export.
   * @param exporterId Exporter ID. If null, the first exporter in API is used.
   * @param api Optional API implementing Exportable that is set to the controller.
   * The API must be set to the controller as property or in this parameter or quickExport() will fail
   * @param mapper Optional mapper to use in the export. This may be the full DataMapperInfo object or just its uri.
   * If null and mapper has already been set, keeps the current mapper,
   * If null and current mapper is null, sets the first available list mapper, then any mapper. No mappers fails.
   */
  quickExport(t, e, a = null) {
    if (this.api = e || this.api, !this.api)
      throw new Error("Exportable API not specified in quickExport()");
    const n = this.uiHelpers.showLoading();
    return this.export(a, t).then(() => {
      n.dismiss();
    });
  }
  /**
   * Exports data to desired format.
   * @param mapper The mapper to use in the export. This may be the full DataMapperInfo object or just its uri.
   * If null and mapper has already been set, keeps the current mapper,
   * If null and current mapper is null, sets the first available list mapper, then any mapper. No mappers fails.
   * @param exporterId Identifies the exporter defining the file type and how the result is presented (copy-paste, download, send to external...).
   * If no exporter is selected for the controller, the first exporter in API is used.
   */
  export(t = null, e = null) {
    return e && (this.currentExporter = this.exporters.find((a) => a.id == e)), this.currentExporter = this.currentExporter || this.api.exporters[0], this.setExportMapper(t).then(() => {
      this.isExporting = !0, this.exportMessage = L.get("SALAXY.NG1.ExportComponent.export.creating");
      const a = (n, i, r) => {
        this.exportMessage = `${n} (${i + 1}${r ? "/" + r : ""})`;
      };
      return VM.getExportData(this.api, this.mapper, Number(this.maxCount), a).then((n) => {
        if (this.isExporting = !1, this.exportMessage = null, !n || !n.length) {
          this.alertService.addError(L.get("SALAXY.NG1.ExportComponent.export.noRows"));
          return;
        }
        this.currentExporter.export(n, this.localeId);
      });
    });
  }
  /**
   * Loads the mapper definition and sets the current mapper to it.
   * @param newMapper New mapper to load and set as current: DataMapperInfo or its uri.
   * If null and mapper has already been set, keeps the current mapper,
   * If null and current mapper is null, sets the first available list mapper, then any mapper. No mappers fails.
   */
  setExportMapper(t) {
    let e = t?.uri || t;
    if (!e) {
      if (this.mapper)
        return Promise.resolve(this.mapper);
      e = (this.listItemMappers[0] || this.allMappers[0]).uri;
    }
    return this.mapper?.uri == e ? Promise.resolve(this.mapper) : (this.mapper = null, this.api.getExportMapper(e).then((a) => (this.mapper = a, a)));
  }
  /** Toggles the debug view on/off. */
  toggleDebug() {
    const t = !this.isDebug;
    this.isDebug = t;
    const e = document.getElementById("salaxyDialog");
    e && (t ? e.style.width = "98vw" : e.style.width = null);
  }
};
aS.$inject = ["AlertService", "UiHelpers"];
let Zx = aS;
class ds {
  constructor(t) {
    this.table = t;
  }
  //////////////////////////////////////////
  /////////////// DataLoad /////////////////
  //////////////////////////////////////////
  reloadData(t, e, a) {
    return this.table.dataLoader.load(t, void 0, void 0, void 0, e, a);
  }
  //////////////////////////////////////////
  ///////////// Localization ///////////////
  //////////////////////////////////////////
  langText() {
    return this.table.modules.localize.getText(...arguments);
  }
  langBind() {
    return this.table.modules.localize.bind(...arguments);
  }
  langLocale() {
    return this.table.modules.localize.getLocale(...arguments);
  }
  //////////////////////////////////////////
  ////////// Inter Table Comms /////////////
  //////////////////////////////////////////
  commsConnections() {
    return this.table.modules.comms.getConnections(...arguments);
  }
  commsSend() {
    return this.table.modules.comms.send(...arguments);
  }
  //////////////////////////////////////////
  //////////////// Layout  /////////////////
  //////////////////////////////////////////
  layoutMode() {
    return this.table.modules.layout.getMode();
  }
  layoutRefresh(t) {
    return this.table.modules.layout.layout(t);
  }
  //////////////////////////////////////////
  /////////////// Event Bus ////////////////
  //////////////////////////////////////////
  subscribe() {
    return this.table.eventBus.subscribe(...arguments);
  }
  unsubscribe() {
    return this.table.eventBus.unsubscribe(...arguments);
  }
  subscribed(t) {
    return this.table.eventBus.subscribed(t);
  }
  subscriptionChange() {
    return this.table.eventBus.subscriptionChange(...arguments);
  }
  dispatch() {
    return this.table.eventBus.dispatch(...arguments);
  }
  chain() {
    return this.table.eventBus.chain(...arguments);
  }
  confirm() {
    return this.table.eventBus.confirm(...arguments);
  }
  dispatchExternal() {
    return this.table.externalEvents.dispatch(...arguments);
  }
  subscribedExternal(t) {
    return this.table.externalEvents.subscribed(t);
  }
  subscriptionChangeExternal() {
    return this.table.externalEvents.subscriptionChange(...arguments);
  }
  //////////////////////////////////////////
  //////////////// Options /////////////////
  //////////////////////////////////////////
  options(t) {
    return this.table.options[t];
  }
  setOption(t, e) {
    return typeof e < "u" && (this.table.options[t] = e), this.table.options[t];
  }
  //////////////////////////////////////////
  /////////// Deprecation Checks ///////////
  //////////////////////////////////////////
  deprecationCheck(t, e, a) {
    return this.table.deprecationAdvisor.check(t, e, a);
  }
  deprecationCheckMsg(t, e) {
    return this.table.deprecationAdvisor.checkMsg(t, e);
  }
  deprecationMsg(t) {
    return this.table.deprecationAdvisor.msg(t);
  }
  //////////////////////////////////////////
  //////////////// Modules /////////////////
  //////////////////////////////////////////
  module(t) {
    return this.table.module(t);
  }
}
class za {
  static elVisible(t) {
    return !(t.offsetWidth <= 0 && t.offsetHeight <= 0);
  }
  static elOffset(t) {
    var e = t.getBoundingClientRect();
    return {
      top: e.top + window.pageYOffset - document.documentElement.clientTop,
      left: e.left + window.pageXOffset - document.documentElement.clientLeft
    };
  }
  static retrieveNestedData(t, e, a) {
    var n = t ? e.split(t) : [e], i = n.length, r;
    for (let l = 0; l < i && (a = a[n[l]], r = a, !!a); l++)
      ;
    return r;
  }
  static deepClone(t, e, a = []) {
    var n = {}.__proto__, i = [].__proto__;
    e || (e = Object.assign(Array.isArray(t) ? [] : {}, t));
    for (var r in t) {
      let l = t[r], o, c;
      l != null && typeof l == "object" && (l.__proto__ === n || l.__proto__ === i) && (o = a.findIndex((d) => d.subject === l), o > -1 ? e[r] = a[o].copy : (c = Object.assign(Array.isArray(l) ? [] : {}, l), a.unshift({ subject: l, copy: c }), e[r] = this.deepClone(l, c, a)));
    }
    return e;
  }
}
class NA extends ds {
  constructor(t, e, a) {
    super(t), this.element = e, this.container = this._lookupContainer(), this.parent = a, this.reversedX = !1, this.childPopup = null, this.blurable = !1, this.blurCallback = null, this.blurEventsBound = !1, this.renderedCallback = null, this.visible = !1, this.hideable = !0, this.element.classList.add("tabulator-popup-container"), this.blurEvent = this.hide.bind(this, !1), this.escEvent = this._escapeCheck.bind(this), this.destroyBinding = this.tableDestroyed.bind(this), this.destroyed = !1;
  }
  tableDestroyed() {
    this.destroyed = !0, this.hide(!0);
  }
  _lookupContainer() {
    var t = this.table.options.popupContainer;
    return typeof t == "string" ? (t = document.querySelector(t), t || console.warn("Menu Error - no container element found matching selector:", this.table.options.popupContainer, "(defaulting to document body)")) : t === !0 && (t = this.table.element), t && !this._checkContainerIsParent(t) && (t = !1, console.warn("Menu Error - container element does not contain this table:", this.table.options.popupContainer, "(defaulting to document body)")), t || (t = document.body), t;
  }
  _checkContainerIsParent(t, e = this.table.element) {
    return t === e ? !0 : e.parentNode ? this._checkContainerIsParent(t, e.parentNode) : !1;
  }
  renderCallback(t) {
    this.renderedCallback = t;
  }
  containerEventCoords(t) {
    var e = !(t instanceof MouseEvent), a = e ? t.touches[0].pageX : t.pageX, n = e ? t.touches[0].pageY : t.pageY;
    if (this.container !== document.body) {
      let i = za.elOffset(this.container);
      a -= i.left, n -= i.top;
    }
    return { x: a, y: n };
  }
  elementPositionCoords(t, e = "right") {
    var a = za.elOffset(t), n, i, r;
    switch (this.container !== document.body && (n = za.elOffset(this.container), a.left -= n.left, a.top -= n.top), e) {
      case "right":
        i = a.left + t.offsetWidth, r = a.top - 1;
        break;
      case "bottom":
        i = a.left, r = a.top + t.offsetHeight;
        break;
      case "left":
        i = a.left, r = a.top - 1;
        break;
      case "top":
        i = a.left, r = a.top;
        break;
      case "center":
        i = a.left + t.offsetWidth / 2, r = a.top + t.offsetHeight / 2;
        break;
    }
    return { x: i, y: r, offset: a };
  }
  show(t, e) {
    var a, n, i, r, l;
    return this.destroyed || this.table.destroyed ? this : (t instanceof HTMLElement ? (i = t, l = this.elementPositionCoords(t, e), r = l.offset, a = l.x, n = l.y) : typeof t == "number" ? (r = { top: 0, left: 0 }, a = t, n = e) : (l = this.containerEventCoords(t), a = l.x, n = l.y, this.reversedX = !1), this.element.style.top = n + "px", this.element.style.left = a + "px", this.container.appendChild(this.element), typeof this.renderedCallback == "function" && this.renderedCallback(), this._fitToScreen(a, n, i, r, e), this.visible = !0, this.subscribe("table-destroy", this.destroyBinding), this.element.addEventListener("mousedown", (o) => {
      o.stopPropagation();
    }), this);
  }
  _fitToScreen(t, e, a, n, i) {
    var r = this.container === document.body ? document.documentElement.scrollTop : this.container.scrollTop;
    if ((t + this.element.offsetWidth >= this.container.offsetWidth || this.reversedX) && (this.element.style.left = "", a ? this.element.style.right = this.container.offsetWidth - n.left + "px" : this.element.style.right = this.container.offsetWidth - t + "px", this.reversedX = !0), e + this.element.offsetHeight > Math.max(this.container.offsetHeight, r ? this.container.scrollHeight : 0))
      if (a)
        switch (i) {
          case "bottom":
            this.element.style.top = parseInt(this.element.style.top) - this.element.offsetHeight - a.offsetHeight - 1 + "px";
            break;
          default:
            this.element.style.top = parseInt(this.element.style.top) - this.element.offsetHeight + a.offsetHeight + 1 + "px";
        }
      else
        this.element.style.top = parseInt(this.element.style.top) - this.element.offsetHeight + "px";
  }
  isVisible() {
    return this.visible;
  }
  hideOnBlur(t) {
    return this.blurable = !0, this.visible && (setTimeout(() => {
      this.visible && (this.table.rowManager.element.addEventListener("scroll", this.blurEvent), this.subscribe("cell-editing", this.blurEvent), document.body.addEventListener("click", this.blurEvent), document.body.addEventListener("contextmenu", this.blurEvent), document.body.addEventListener("mousedown", this.blurEvent), window.addEventListener("resize", this.blurEvent), document.body.addEventListener("keydown", this.escEvent), this.blurEventsBound = !0);
    }, 100), this.blurCallback = t), this;
  }
  _escapeCheck(t) {
    t.keyCode == 27 && this.hide();
  }
  blockHide() {
    this.hideable = !1;
  }
  restoreHide() {
    this.hideable = !0;
  }
  hide(t = !1) {
    return this.visible && this.hideable && (this.blurable && this.blurEventsBound && (document.body.removeEventListener("keydown", this.escEvent), document.body.removeEventListener("click", this.blurEvent), document.body.removeEventListener("contextmenu", this.blurEvent), document.body.removeEventListener("mousedown", this.blurEvent), window.removeEventListener("resize", this.blurEvent), this.table.rowManager.element.removeEventListener("scroll", this.blurEvent), this.unsubscribe("cell-editing", this.blurEvent), this.blurEventsBound = !1), this.childPopup && this.childPopup.hide(), this.parent && (this.parent.childPopup = null), this.element.parentNode && this.element.parentNode.removeChild(this.element), this.visible = !1, this.blurCallback && !t && this.blurCallback(), this.unsubscribe("table-destroy", this.destroyBinding)), this;
  }
  child(t) {
    return this.childPopup && this.childPopup.hide(), this.childPopup = new NA(this.table, t, this), this.childPopup;
  }
}
class Ze extends ds {
  constructor(t, e) {
    super(t), this._handler = null;
  }
  initialize() {
  }
  ///////////////////////////////////
  ////// Options Registration ///////
  ///////////////////////////////////
  registerTableOption(t, e) {
    this.table.optionsList.register(t, e);
  }
  registerColumnOption(t, e) {
    this.table.columnManager.optionsList.register(t, e);
  }
  ///////////////////////////////////
  /// Public Function Registration ///
  ///////////////////////////////////
  registerTableFunction(t, e) {
    typeof this.table[t] > "u" ? this.table[t] = (...a) => (this.table.initGuard(t), e(...a)) : console.warn("Unable to bind table function, name already in use", t);
  }
  registerComponentFunction(t, e, a) {
    return this.table.componentFunctionBinder.bind(t, e, a);
  }
  ///////////////////////////////////
  ////////// Data Pipeline //////////
  ///////////////////////////////////
  registerDataHandler(t, e) {
    this.table.rowManager.registerDataPipelineHandler(t, e), this._handler = t;
  }
  registerDisplayHandler(t, e) {
    this.table.rowManager.registerDisplayPipelineHandler(t, e), this._handler = t;
  }
  displayRows(t) {
    var e = this.table.rowManager.displayRows.length - 1, a;
    if (this._handler && (a = this.table.rowManager.displayPipeline.findIndex((n) => n.handler === this._handler), a > -1 && (e = a)), t && (e = e + t), this._handler)
      return e > -1 ? this.table.rowManager.getDisplayRows(e) : this.activeRows();
  }
  activeRows() {
    return this.table.rowManager.activeRows;
  }
  refreshData(t, e) {
    e || (e = this._handler), e && this.table.rowManager.refreshActiveData(e, !1, t);
  }
  ///////////////////////////////////
  //////// Footer Management ////////
  ///////////////////////////////////
  footerAppend(t) {
    return this.table.footerManager.append(t);
  }
  footerPrepend(t) {
    return this.table.footerManager.prepend(t);
  }
  footerRemove(t) {
    return this.table.footerManager.remove(t);
  }
  ///////////////////////////////////
  //////// Popups Management ////////
  ///////////////////////////////////
  popup(t, e) {
    return new NA(this.table, t, e);
  }
  ///////////////////////////////////
  //////// Alert Management ////////
  ///////////////////////////////////
  alert(t, e) {
    return this.table.alertManager.alert(t, e);
  }
  clearAlert() {
    return this.table.alertManager.clear();
  }
}
var N3 = {};
class Pc extends Ze {
  constructor(t) {
    super(t), this.allowedTypes = ["", "data", "download", "clipboard", "print", "htmlOutput"], this.registerColumnOption("accessor"), this.registerColumnOption("accessorParams"), this.registerColumnOption("accessorData"), this.registerColumnOption("accessorDataParams"), this.registerColumnOption("accessorDownload"), this.registerColumnOption("accessorDownloadParams"), this.registerColumnOption("accessorClipboard"), this.registerColumnOption("accessorClipboardParams"), this.registerColumnOption("accessorPrint"), this.registerColumnOption("accessorPrintParams"), this.registerColumnOption("accessorHtmlOutput"), this.registerColumnOption("accessorHtmlOutputParams");
  }
  initialize() {
    this.subscribe("column-layout", this.initializeColumn.bind(this)), this.subscribe("row-data-retrieve", this.transformRow.bind(this));
  }
  //initialize column accessor
  initializeColumn(t) {
    var e = !1, a = {};
    this.allowedTypes.forEach((n) => {
      var i = "accessor" + (n.charAt(0).toUpperCase() + n.slice(1)), r;
      t.definition[i] && (r = this.lookupAccessor(t.definition[i]), r && (e = !0, a[i] = {
        accessor: r,
        params: t.definition[i + "Params"] || {}
      }));
    }), e && (t.modules.accessor = a);
  }
  lookupAccessor(t) {
    var e = !1;
    switch (typeof t) {
      case "string":
        Pc.accessors[t] ? e = Pc.accessors[t] : console.warn("Accessor Error - No such accessor found, ignoring: ", t);
        break;
      case "function":
        e = t;
        break;
    }
    return e;
  }
  //apply accessor to row
  transformRow(t, e) {
    var a = "accessor" + (e.charAt(0).toUpperCase() + e.slice(1)), n = t.getComponent(), i = za.deepClone(t.data || {});
    return this.table.columnManager.traverse(function(r) {
      var l, o, c, d;
      r.modules.accessor && (o = r.modules.accessor[a] || r.modules.accessor.accessor || !1, o && (l = r.getFieldValue(i), l != "undefined" && (d = r.getComponent(), c = typeof o.params == "function" ? o.params(l, i, e, d, n) : o.params, r.setFieldValue(i, o.accessor(l, i, e, c, d, n)))));
    }), i;
  }
}
Pc.moduleName = "accessor";
Pc.accessors = N3;
var R3 = {
  method: "GET"
};
function tw(s, t) {
  var e = [];
  if (t = t || "", Array.isArray(s))
    s.forEach((n, i) => {
      e = e.concat(tw(n, t ? t + "[" + i + "]" : i));
    });
  else if (typeof s == "object")
    for (var a in s)
      e = e.concat(tw(s[a], t ? t + "[" + a + "]" : a));
  else
    e.push({ key: t, value: s });
  return e;
}
function Y3(s) {
  var t = tw(s), e = [];
  return t.forEach(function(a) {
    e.push(encodeURIComponent(a.key) + "=" + encodeURIComponent(a.value));
  }), e.join("&");
}
function XN(s, t, e) {
  return s && e && Object.keys(e).length && (!t.method || t.method.toLowerCase() == "get") && (t.method = "get", s += (s.includes("?") ? "&" : "?") + Y3(e)), s;
}
function _3(s, t, e) {
  var a;
  return new Promise((n, i) => {
    if (s = this.urlGenerator.call(this.table, s, t, e), t.method.toUpperCase() != "GET")
      if (a = typeof this.table.options.ajaxContentType == "object" ? this.table.options.ajaxContentType : this.contentTypeFormatters[this.table.options.ajaxContentType], a) {
        for (var r in a.headers)
          t.headers || (t.headers = {}), typeof t.headers[r] > "u" && (t.headers[r] = a.headers[r]);
        t.body = a.body.call(this, s, t, e);
      } else
        console.warn("Ajax Error - Invalid ajaxContentType value:", this.table.options.ajaxContentType);
    s ? (typeof t.headers > "u" && (t.headers = {}), typeof t.headers.Accept > "u" && (t.headers.Accept = "application/json"), typeof t.headers["X-Requested-With"] > "u" && (t.headers["X-Requested-With"] = "XMLHttpRequest"), typeof t.mode > "u" && (t.mode = "cors"), t.mode == "cors" ? (typeof t.headers.Origin > "u" && (t.headers.Origin = window.location.origin), typeof t.credentials > "u" && (t.credentials = "same-origin")) : typeof t.credentials > "u" && (t.credentials = "include"), fetch(s, t).then((l) => {
      l.ok ? l.json().then((o) => {
        n(o);
      }).catch((o) => {
        i(o), console.warn("Ajax Load Error - Invalid JSON returned", o);
      }) : (console.error("Ajax Load Error - Connection Error: " + l.status, l.statusText), i(l));
    }).catch((l) => {
      console.error("Ajax Load Error - Connection Error: ", l), i(l);
    })) : (console.warn("Ajax Load Error - No URL Set"), n([]));
  });
}
function ew(s, t) {
  var e = [];
  if (t = t || "", Array.isArray(s))
    s.forEach((n, i) => {
      e = e.concat(ew(n, t ? t + "[" + i + "]" : i));
    });
  else if (typeof s == "object")
    for (var a in s)
      e = e.concat(ew(s[a], t ? t + "[" + a + "]" : a));
  else
    e.push({ key: t, value: s });
  return e;
}
var O3 = {
  json: {
    headers: {
      "Content-Type": "application/json"
    },
    body: function(s, t, e) {
      return JSON.stringify(e);
    }
  },
  form: {
    headers: {},
    body: function(s, t, e) {
      var a = ew(e), n = new FormData();
      return a.forEach(function(i) {
        n.append(i.key, i.value);
      }), n;
    }
  }
};
class gi extends Ze {
  constructor(t) {
    super(t), this.config = {}, this.url = "", this.urlGenerator = !1, this.params = !1, this.loaderPromise = !1, this.registerTableOption("ajaxURL", !1), this.registerTableOption("ajaxURLGenerator", !1), this.registerTableOption("ajaxParams", {}), this.registerTableOption("ajaxConfig", "get"), this.registerTableOption("ajaxContentType", "form"), this.registerTableOption("ajaxRequestFunc", !1), this.registerTableOption("ajaxRequesting", function() {
    }), this.registerTableOption("ajaxResponse", !1), this.contentTypeFormatters = gi.contentTypeFormatters;
  }
  //initialize setup options
  initialize() {
    this.loaderPromise = this.table.options.ajaxRequestFunc || gi.defaultLoaderPromise, this.urlGenerator = this.table.options.ajaxURLGenerator || gi.defaultURLGenerator, this.table.options.ajaxURL && this.setUrl(this.table.options.ajaxURL), this.setDefaultConfig(this.table.options.ajaxConfig), this.registerTableFunction("getAjaxUrl", this.getUrl.bind(this)), this.subscribe("data-loading", this.requestDataCheck.bind(this)), this.subscribe("data-params", this.requestParams.bind(this)), this.subscribe("data-load", this.requestData.bind(this));
  }
  requestParams(t, e, a, n) {
    var i = this.table.options.ajaxParams;
    return i && (typeof i == "function" && (i = i.call(this.table)), n = Object.assign(Object.assign({}, i), n)), n;
  }
  requestDataCheck(t, e, a, n) {
    return !!(!t && this.url || typeof t == "string");
  }
  requestData(t, e, a, n, i) {
    var r;
    return !i && this.requestDataCheck(t) ? (t && this.setUrl(t), r = this.generateConfig(a), this.sendRequest(this.url, e, r)) : i;
  }
  setDefaultConfig(t = {}) {
    this.config = Object.assign({}, gi.defaultConfig), typeof t == "string" ? this.config.method = t : Object.assign(this.config, t);
  }
  //load config object
  generateConfig(t = {}) {
    var e = Object.assign({}, this.config);
    return typeof t == "string" ? e.method = t : Object.assign(e, t), e;
  }
  //set request url
  setUrl(t) {
    this.url = t;
  }
  //get request url
  getUrl() {
    return this.url;
  }
  //send ajax request
  sendRequest(t, e, a) {
    return this.table.options.ajaxRequesting.call(this.table, t, e) !== !1 ? this.loaderPromise(t, a, e).then((n) => (this.table.options.ajaxResponse && (n = this.table.options.ajaxResponse.call(this.table, t, e, n)), n)) : Promise.reject();
  }
}
gi.moduleName = "ajax";
gi.defaultConfig = R3;
gi.defaultURLGenerator = XN;
gi.defaultLoaderPromise = _3;
gi.contentTypeFormatters = O3;
var M3 = {
  replace: function(s) {
    return this.table.setData(s);
  },
  update: function(s) {
    return this.table.updateOrAddData(s);
  },
  insert: function(s) {
    return this.table.addData(s);
  },
  range: function(s) {
    var t = [], e = this.table.modules.selectRange.activeRange, a = !1, n, i, r, l, o;
    return o = s.length, e && (n = e.getBounds(), i = n.start, n.start === n.end && (a = !0), i && (t = this.table.rowManager.activeRows.slice(), r = t.indexOf(i.row), a ? l = s.length : l = t.indexOf(n.end.row) - r + 1, r > -1 && (this.table.blockRedraw(), t = t.slice(r, r + l), t.forEach((c, d) => {
      c.updateData(s[d % o]);
    }), this.table.restoreRedraw()))), t;
  }
}, X3 = {
  table: function(s) {
    var t = [], e = !0, a = this.table.columnManager.columns, n = [], i = [];
    return s = s.split(`
`), s.forEach(function(r) {
      t.push(r.split("	"));
    }), t.length && !(t.length === 1 && t[0].length < 2) ? (t[0].forEach(function(r) {
      var l = a.find(function(o) {
        return r && o.definition.title && r.trim() && o.definition.title.trim() === r.trim();
      });
      l ? n.push(l) : e = !1;
    }), e || (e = !0, n = [], t[0].forEach(function(r) {
      var l = a.find(function(o) {
        return r && o.field && r.trim() && o.field.trim() === r.trim();
      });
      l ? n.push(l) : e = !1;
    }), e || (n = this.table.columnManager.columnsByIndex)), e && t.shift(), t.forEach(function(r) {
      var l = {};
      r.forEach(function(o, c) {
        n[c] && (l[n[c].field] = o);
      }), i.push(l);
    }), i) : !1;
  },
  range: function(s) {
    var t = [], e = [], a = this.table.modules.selectRange.activeRange, n = !1, i, r, l, o, c;
    return a && (i = a.getBounds(), r = i.start, i.start === i.end && (n = !0), r && (s = s.split(`
`), s.forEach(function(d) {
      t.push(d.split("	"));
    }), t.length && (o = this.table.columnManager.getVisibleColumnsByIndex(), c = o.indexOf(r.column), c > -1))) ? (n ? l = t[0].length : l = o.indexOf(i.end.column) - c + 1, o = o.slice(c, c + l), t.forEach((d) => {
      var p = {}, h = d.length;
      o.forEach(function(g, x) {
        p[g.field] = d[x % h];
      }), e.push(p);
    }), e) : !1;
  }
};
class Zl extends Ze {
  constructor(t) {
    super(t), this.mode = !0, this.pasteParser = function() {
    }, this.pasteAction = function() {
    }, this.customSelection = !1, this.rowRange = !1, this.blocked = !0, this.registerTableOption("clipboard", !1), this.registerTableOption("clipboardCopyStyled", !0), this.registerTableOption("clipboardCopyConfig", !1), this.registerTableOption("clipboardCopyFormatter", !1), this.registerTableOption("clipboardCopyRowRange", "active"), this.registerTableOption("clipboardPasteParser", "table"), this.registerTableOption("clipboardPasteAction", "insert"), this.registerColumnOption("clipboard"), this.registerColumnOption("titleClipboard");
  }
  initialize() {
    this.mode = this.table.options.clipboard, this.rowRange = this.table.options.clipboardCopyRowRange, (this.mode === !0 || this.mode === "copy") && this.table.element.addEventListener("copy", (t) => {
      var e, a, n;
      this.blocked || (t.preventDefault(), this.customSelection ? (e = this.customSelection, this.table.options.clipboardCopyFormatter && (e = this.table.options.clipboardCopyFormatter("plain", e))) : (n = this.table.modules.export.generateExportList(this.table.options.clipboardCopyConfig, this.table.options.clipboardCopyStyled, this.rowRange, "clipboard"), a = this.table.modules.export.generateHTMLTable(n), e = a ? this.generatePlainContent(n) : "", this.table.options.clipboardCopyFormatter && (e = this.table.options.clipboardCopyFormatter("plain", e), a = this.table.options.clipboardCopyFormatter("html", a))), window.clipboardData && window.clipboardData.setData ? window.clipboardData.setData("Text", e) : t.clipboardData && t.clipboardData.setData ? (t.clipboardData.setData("text/plain", e), a && t.clipboardData.setData("text/html", a)) : t.originalEvent && t.originalEvent.clipboardData.setData && (t.originalEvent.clipboardData.setData("text/plain", e), a && t.originalEvent.clipboardData.setData("text/html", a)), this.dispatchExternal("clipboardCopied", e, a), this.reset());
    }), (this.mode === !0 || this.mode === "paste") && this.table.element.addEventListener("paste", (t) => {
      this.paste(t);
    }), this.setPasteParser(this.table.options.clipboardPasteParser), this.setPasteAction(this.table.options.clipboardPasteAction), this.registerTableFunction("copyToClipboard", this.copy.bind(this));
  }
  reset() {
    this.blocked = !0, this.customSelection = !1;
  }
  generatePlainContent(t) {
    var e = [];
    return t.forEach((a) => {
      var n = [];
      a.columns.forEach((i) => {
        var r = "";
        if (i)
          if (a.type === "group" && (i.value = i.component.getKey()), i.value === null)
            r = "";
          else
            switch (typeof i.value) {
              case "object":
                r = JSON.stringify(i.value);
                break;
              case "undefined":
                r = "";
                break;
              default:
                r = i.value;
            }
        n.push(r);
      }), e.push(n.join("	"));
    }), e.join(`
`);
  }
  copy(t, e) {
    var a, n;
    this.blocked = !1, this.customSelection = !1, (this.mode === !0 || this.mode === "copy") && (this.rowRange = t || this.table.options.clipboardCopyRowRange, typeof window.getSelection < "u" && typeof document.createRange < "u" ? (t = document.createRange(), t.selectNodeContents(this.table.element), a = window.getSelection(), a.toString() && e && (this.customSelection = a.toString()), a.removeAllRanges(), a.addRange(t)) : typeof document.selection < "u" && typeof document.body.createTextRange < "u" && (n = document.body.createTextRange(), n.moveToElementText(this.table.element), n.select()), document.execCommand("copy"), a && a.removeAllRanges());
  }
  //PASTE EVENT HANDLING
  setPasteAction(t) {
    switch (typeof t) {
      case "string":
        this.pasteAction = Zl.pasteActions[t], this.pasteAction || console.warn("Clipboard Error - No such paste action found:", t);
        break;
      case "function":
        this.pasteAction = t;
        break;
    }
  }
  setPasteParser(t) {
    switch (typeof t) {
      case "string":
        this.pasteParser = Zl.pasteParsers[t], this.pasteParser || console.warn("Clipboard Error - No such paste parser found:", t);
        break;
      case "function":
        this.pasteParser = t;
        break;
    }
  }
  paste(t) {
    var e, a, n;
    this.checkPasteOrigin(t) && (e = this.getPasteData(t), a = this.pasteParser.call(this, e), a ? (t.preventDefault(), this.table.modExists("mutator") && (a = this.mutateData(a)), n = this.pasteAction.call(this, a), this.dispatchExternal("clipboardPasted", e, a, n)) : this.dispatchExternal("clipboardPasteError", e));
  }
  mutateData(t) {
    var e = [];
    return Array.isArray(t) ? t.forEach((a) => {
      e.push(this.table.modules.mutator.transformRow(a, "clipboard"));
    }) : e = t, e;
  }
  checkPasteOrigin(t) {
    var e = !0, a = this.confirm("clipboard-paste", [t]);
    return (a || !["DIV", "SPAN"].includes(t.target.tagName)) && (e = !1), e;
  }
  getPasteData(t) {
    var e;
    return window.clipboardData && window.clipboardData.getData ? e = window.clipboardData.getData("Text") : t.clipboardData && t.clipboardData.getData ? e = t.clipboardData.getData("text/plain") : t.originalEvent && t.originalEvent.clipboardData.getData && (e = t.originalEvent.clipboardData.getData("text/plain")), e;
  }
}
Zl.moduleName = "clipboard";
Zl.pasteActions = M3;
Zl.pasteParsers = X3;
class G3 {
  constructor(t) {
    return this._row = t, new Proxy(this, {
      get: function(e, a, n) {
        return typeof e[a] < "u" ? e[a] : e._row.table.componentFunctionBinder.handle("row", e._row, a);
      }
    });
  }
  getData(t) {
    return this._row.getData(t);
  }
  getElement() {
    return this._row.getElement();
  }
  getTable() {
    return this._row.table;
  }
  getCells() {
    var t = [];
    return this._row.getCells().forEach(function(e) {
      t.push(e.getComponent());
    }), t;
  }
  getCell(t) {
    var e = this._row.getCell(t);
    return e ? e.getComponent() : !1;
  }
  _getSelf() {
    return this._row;
  }
}
class GN {
  constructor(t) {
    return this._cell = t, new Proxy(this, {
      get: function(e, a, n) {
        return typeof e[a] < "u" ? e[a] : e._cell.table.componentFunctionBinder.handle("cell", e._cell, a);
      }
    });
  }
  getValue() {
    return this._cell.getValue();
  }
  getOldValue() {
    return this._cell.getOldValue();
  }
  getInitialValue() {
    return this._cell.initialValue;
  }
  getElement() {
    return this._cell.getElement();
  }
  getRow() {
    return this._cell.row.getComponent();
  }
  getData(t) {
    return this._cell.row.getData(t);
  }
  getType() {
    return "cell";
  }
  getField() {
    return this._cell.column.getField();
  }
  getColumn() {
    return this._cell.column.getComponent();
  }
  setValue(t, e) {
    typeof e > "u" && (e = !0), this._cell.setValue(t, e);
  }
  restoreOldValue() {
    this._cell.setValueActual(this._cell.getOldValue());
  }
  restoreInitialValue() {
    this._cell.setValueActual(this._cell.initialValue);
  }
  checkHeight() {
    this._cell.checkHeight();
  }
  getTable() {
    return this._cell.table;
  }
  _getSelf() {
    return this._cell;
  }
}
class tp extends ds {
  constructor(t, e) {
    super(t.table), this.table = t.table, this.column = t, this.row = e, this.element = null, this.value = null, this.initialValue, this.oldValue = null, this.modules = {}, this.height = null, this.width = null, this.minWidth = null, this.component = null, this.loaded = !1, this.build();
  }
  //////////////// Setup Functions /////////////////
  //generate element
  build() {
    this.generateElement(), this.setWidth(), this._configureCell(), this.setValueActual(this.column.getFieldValue(this.row.data)), this.initialValue = this.value;
  }
  generateElement() {
    this.element = document.createElement("div"), this.element.className = "tabulator-cell", this.element.setAttribute("role", "gridcell");
  }
  _configureCell() {
    var t = this.element, e = this.column.getField(), a = {
      top: "flex-start",
      bottom: "flex-end",
      middle: "center"
    }, n = {
      left: "flex-start",
      right: "flex-end",
      center: "center"
    };
    if (t.style.textAlign = this.column.hozAlign, this.column.vertAlign && (t.style.display = "inline-flex", t.style.alignItems = a[this.column.vertAlign] || "", this.column.hozAlign && (t.style.justifyContent = n[this.column.hozAlign] || "")), e && t.setAttribute("tabulator-field", e), this.column.definition.cssClass) {
      var i = this.column.definition.cssClass.split(" ");
      i.forEach((r) => {
        t.classList.add(r);
      });
    }
    this.dispatch("cell-init", this), this.column.visible || this.hide();
  }
  //generate cell contents
  _generateContents() {
    var t;
    switch (t = this.chain("cell-format", this, null, () => this.element.innerHTML = this.value), typeof t) {
      case "object":
        if (t instanceof Node) {
          for (; this.element.firstChild; )
            this.element.removeChild(this.element.firstChild);
          this.element.appendChild(t);
        } else
          this.element.innerHTML = "", t != null && console.warn("Format Error - Formatter has returned a type of object, the only valid formatter object return is an instance of Node, the formatter returned:", t);
        break;
      case "undefined":
        this.element.innerHTML = "";
        break;
      default:
        this.element.innerHTML = t;
    }
  }
  cellRendered() {
    this.dispatch("cell-rendered", this);
  }
  //////////////////// Getters ////////////////////
  getElement(t) {
    return this.loaded || (this.loaded = !0, t || this.layoutElement()), this.element;
  }
  getValue() {
    return this.value;
  }
  getOldValue() {
    return this.oldValue;
  }
  //////////////////// Actions ////////////////////
  setValue(t, e, a) {
    var n = this.setValueProcessData(t, e, a);
    n && (this.dispatch("cell-value-updated", this), this.cellRendered(), this.column.definition.cellEdited && this.column.definition.cellEdited.call(this.table, this.getComponent()), this.dispatchExternal("cellEdited", this.getComponent()), this.subscribedExternal("dataChanged") && this.dispatchExternal("dataChanged", this.table.rowManager.getData()));
  }
  setValueProcessData(t, e, a) {
    var n = !1;
    return (this.value !== t || a) && (n = !0, e && (t = this.chain("cell-value-changing", [this, t], null, t))), this.setValueActual(t), n && this.dispatch("cell-value-changed", this), n;
  }
  setValueActual(t) {
    this.oldValue = this.value, this.value = t, this.dispatch("cell-value-save-before", this), this.column.setFieldValue(this.row.data, t), this.dispatch("cell-value-save-after", this), this.loaded && this.layoutElement();
  }
  layoutElement() {
    this._generateContents(), this.dispatch("cell-layout", this);
  }
  setWidth() {
    this.width = this.column.width, this.element.style.width = this.column.widthStyled;
  }
  clearWidth() {
    this.width = "", this.element.style.width = "";
  }
  getWidth() {
    return this.width || this.element.offsetWidth;
  }
  setMinWidth() {
    this.minWidth = this.column.minWidth, this.element.style.minWidth = this.column.minWidthStyled;
  }
  setMaxWidth() {
    this.maxWidth = this.column.maxWidth, this.element.style.maxWidth = this.column.maxWidthStyled;
  }
  checkHeight() {
    this.row.reinitializeHeight();
  }
  clearHeight() {
    this.element.style.height = "", this.height = null, this.dispatch("cell-height", this, "");
  }
  setHeight() {
    this.height = this.row.height, this.element.style.height = this.row.heightStyled, this.dispatch("cell-height", this, this.row.heightStyled);
  }
  getHeight() {
    return this.height || this.element.offsetHeight;
  }
  show() {
    this.element.style.display = this.column.vertAlign ? "inline-flex" : "";
  }
  hide() {
    this.element.style.display = "none";
  }
  delete() {
    this.dispatch("cell-delete", this), !this.table.rowManager.redrawBlock && this.element.parentNode && this.element.parentNode.removeChild(this.element), this.element = !1, this.column.deleteCell(this), this.row.deleteCell(this), this.calcs = {};
  }
  getIndex() {
    return this.row.getCellIndex(this);
  }
  //////////////// Object Generation /////////////////
  getComponent() {
    return this.component || (this.component = new GN(this)), this.component;
  }
}
class HN {
  constructor(t) {
    return this._column = t, this.type = "ColumnComponent", new Proxy(this, {
      get: function(e, a, n) {
        return typeof e[a] < "u" ? e[a] : e._column.table.componentFunctionBinder.handle("column", e._column, a);
      }
    });
  }
  getElement() {
    return this._column.getElement();
  }
  getDefinition() {
    return this._column.getDefinition();
  }
  getField() {
    return this._column.getField();
  }
  getTitleDownload() {
    return this._column.getTitleDownload();
  }
  getCells() {
    var t = [];
    return this._column.cells.forEach(function(e) {
      t.push(e.getComponent());
    }), t;
  }
  isVisible() {
    return this._column.visible;
  }
  show() {
    this._column.isGroup ? this._column.columns.forEach(function(t) {
      t.show();
    }) : this._column.show();
  }
  hide() {
    this._column.isGroup ? this._column.columns.forEach(function(t) {
      t.hide();
    }) : this._column.hide();
  }
  toggle() {
    this._column.visible ? this.hide() : this.show();
  }
  delete() {
    return this._column.delete();
  }
  getSubColumns() {
    var t = [];
    return this._column.columns.length && this._column.columns.forEach(function(e) {
      t.push(e.getComponent());
    }), t;
  }
  getParentColumn() {
    return this._column.parent instanceof zi ? this._column.parent.getComponent() : !1;
  }
  _getSelf() {
    return this._column;
  }
  scrollTo(t, e) {
    return this._column.table.columnManager.scrollToColumn(this._column, t, e);
  }
  getTable() {
    return this._column.table;
  }
  move(t, e) {
    var a = this._column.table.columnManager.findColumn(t);
    a ? this._column.table.columnManager.moveColumn(this._column, a, e) : console.warn("Move Error - No matching column found:", a);
  }
  getNextColumn() {
    var t = this._column.nextColumn();
    return t ? t.getComponent() : !1;
  }
  getPrevColumn() {
    var t = this._column.prevColumn();
    return t ? t.getComponent() : !1;
  }
  updateDefinition(t) {
    return this._column.updateDefinition(t);
  }
  getWidth() {
    return this._column.getWidth();
  }
  setWidth(t) {
    var e;
    return t === !0 ? e = this._column.reinitializeWidth(!0) : e = this._column.setWidth(t), this._column.table.columnManager.rerenderColumns(!0), e;
  }
}
var UN = {
  title: void 0,
  field: void 0,
  columns: void 0,
  visible: void 0,
  hozAlign: void 0,
  vertAlign: void 0,
  width: void 0,
  minWidth: 40,
  maxWidth: void 0,
  maxInitialWidth: void 0,
  cssClass: void 0,
  variableHeight: void 0,
  headerVertical: void 0,
  headerHozAlign: void 0,
  headerWordWrap: !1,
  editableTitle: void 0
};
class zi extends ds {
  constructor(t, e) {
    super(e.table), this.definition = t, this.parent = e, this.type = "column", this.columns = [], this.cells = [], this.element = this.createElement(), this.contentElement = !1, this.titleHolderElement = !1, this.titleElement = !1, this.groupElement = this.createGroupElement(), this.isGroup = !1, this.hozAlign = "", this.vertAlign = "", this.field = "", this.fieldStructure = "", this.getFieldValue = "", this.setFieldValue = "", this.titleDownload = null, this.titleFormatterRendered = !1, this.mapDefinitions(), this.setField(this.definition.field), this.modules = {}, this.width = null, this.widthStyled = "", this.maxWidth = null, this.maxWidthStyled = "", this.maxInitialWidth = null, this.minWidth = null, this.minWidthStyled = "", this.widthFixed = !1, this.visible = !0, this.component = null, this.definition.columns ? (this.isGroup = !0, this.definition.columns.forEach((a, n) => {
      var i = new zi(a, this);
      this.attachColumn(i);
    }), this.checkColumnVisibility()) : e.registerColumnField(this), this._initialize();
  }
  createElement() {
    var t = document.createElement("div");
    switch (t.classList.add("tabulator-col"), t.setAttribute("role", "columnheader"), t.setAttribute("aria-sort", "none"), this.table.options.columnHeaderVertAlign) {
      case "middle":
        t.style.justifyContent = "center";
        break;
      case "bottom":
        t.style.justifyContent = "flex-end";
        break;
    }
    return t;
  }
  createGroupElement() {
    var t = document.createElement("div");
    return t.classList.add("tabulator-col-group-cols"), t;
  }
  mapDefinitions() {
    var t = this.table.options.columnDefaults;
    if (t)
      for (let e in t)
        typeof this.definition[e] > "u" && (this.definition[e] = t[e]);
    this.definition = this.table.columnManager.optionsList.generate(zi.defaultOptionList, this.definition);
  }
  checkDefinition() {
    Object.keys(this.definition).forEach((t) => {
      zi.defaultOptionList.indexOf(t) === -1 && console.warn("Invalid column definition option in '" + (this.field || this.definition.title) + "' column:", t);
    });
  }
  setField(t) {
    this.field = t, this.fieldStructure = t ? this.table.options.nestedFieldSeparator ? t.split(this.table.options.nestedFieldSeparator) : [t] : [], this.getFieldValue = this.fieldStructure.length > 1 ? this._getNestedData : this._getFlatData, this.setFieldValue = this.fieldStructure.length > 1 ? this._setNestedData : this._setFlatData;
  }
  //register column position with column manager
  registerColumnPosition(t) {
    this.parent.registerColumnPosition(t);
  }
  //register column position with column manager
  registerColumnField(t) {
    this.parent.registerColumnField(t);
  }
  //trigger position registration
  reRegisterPosition() {
    this.isGroup ? this.columns.forEach(function(t) {
      t.reRegisterPosition();
    }) : this.registerColumnPosition(this);
  }
  //build header element
  _initialize() {
    for (var t = this.definition; this.element.firstChild; )
      this.element.removeChild(this.element.firstChild);
    t.headerVertical && (this.element.classList.add("tabulator-col-vertical"), t.headerVertical === "flip" && this.element.classList.add("tabulator-col-vertical-flip")), this.contentElement = this._buildColumnHeaderContent(), this.element.appendChild(this.contentElement), this.isGroup ? this._buildGroupHeader() : this._buildColumnHeader(), this.dispatch("column-init", this);
  }
  //build header element for header
  _buildColumnHeader() {
    var t = this.definition;
    if (this.dispatch("column-layout", this), typeof t.visible < "u" && (t.visible ? this.show(!0) : this.hide(!0)), t.cssClass) {
      var e = t.cssClass.split(" ");
      e.forEach((a) => {
        this.element.classList.add(a);
      });
    }
    t.field && this.element.setAttribute("tabulator-field", t.field), this.setMinWidth(parseInt(t.minWidth)), t.maxInitialWidth && (this.maxInitialWidth = parseInt(t.maxInitialWidth)), t.maxWidth && this.setMaxWidth(parseInt(t.maxWidth)), this.reinitializeWidth(), this.hozAlign = this.definition.hozAlign, this.vertAlign = this.definition.vertAlign, this.titleElement.style.textAlign = this.definition.headerHozAlign;
  }
  _buildColumnHeaderContent() {
    var t = document.createElement("div");
    return t.classList.add("tabulator-col-content"), this.titleHolderElement = document.createElement("div"), this.titleHolderElement.classList.add("tabulator-col-title-holder"), t.appendChild(this.titleHolderElement), this.titleElement = this._buildColumnHeaderTitle(), this.titleHolderElement.appendChild(this.titleElement), t;
  }
  //build title element of column
  _buildColumnHeaderTitle() {
    var t = this.definition, e = document.createElement("div");
    if (e.classList.add("tabulator-col-title"), t.headerWordWrap && e.classList.add("tabulator-col-title-wrap"), t.editableTitle) {
      var a = document.createElement("input");
      a.classList.add("tabulator-title-editor"), a.addEventListener("click", (n) => {
        n.stopPropagation(), a.focus();
      }), a.addEventListener("mousedown", (n) => {
        n.stopPropagation();
      }), a.addEventListener("change", () => {
        t.title = a.value, this.dispatchExternal("columnTitleChanged", this.getComponent());
      }), e.appendChild(a), t.field ? this.langBind("columns|" + t.field, (n) => {
        a.value = n || t.title || "&nbsp;";
      }) : a.value = t.title || "&nbsp;";
    } else
      t.field ? this.langBind("columns|" + t.field, (n) => {
        this._formatColumnHeaderTitle(e, n || t.title || "&nbsp;");
      }) : this._formatColumnHeaderTitle(e, t.title || "&nbsp;");
    return e;
  }
  _formatColumnHeaderTitle(t, e) {
    var a = this.chain("column-format", [this, e, t], null, () => e);
    switch (typeof a) {
      case "object":
        a instanceof Node ? t.appendChild(a) : (t.innerHTML = "", console.warn("Format Error - Title formatter has returned a type of object, the only valid formatter object return is an instance of Node, the formatter returned:", a));
        break;
      case "undefined":
        t.innerHTML = "";
        break;
      default:
        t.innerHTML = a;
    }
  }
  //build header element for column group
  _buildGroupHeader() {
    if (this.element.classList.add("tabulator-col-group"), this.element.setAttribute("role", "columngroup"), this.element.setAttribute("aria-title", this.definition.title), this.definition.cssClass) {
      var t = this.definition.cssClass.split(" ");
      t.forEach((e) => {
        this.element.classList.add(e);
      });
    }
    this.titleElement.style.textAlign = this.definition.headerHozAlign, this.element.appendChild(this.groupElement);
  }
  //flat field lookup
  _getFlatData(t) {
    return t[this.field];
  }
  //nested field lookup
  _getNestedData(t) {
    var e = t, a = this.fieldStructure, n = a.length, i;
    for (let r = 0; r < n && (e = e[a[r]], i = e, !!e); r++)
      ;
    return i;
  }
  //flat field set
  _setFlatData(t, e) {
    this.field && (t[this.field] = e);
  }
  //nested field set
  _setNestedData(t, e) {
    var a = t, n = this.fieldStructure, i = n.length;
    for (let r = 0; r < i; r++)
      if (r == i - 1)
        a[n[r]] = e;
      else {
        if (!a[n[r]])
          if (typeof e < "u")
            a[n[r]] = {};
          else
            break;
        a = a[n[r]];
      }
  }
  //attach column to this group
  attachColumn(t) {
    this.groupElement ? (this.columns.push(t), this.groupElement.appendChild(t.getElement()), t.columnRendered()) : console.warn("Column Warning - Column being attached to another column instead of column group");
  }
  //vertically align header in column
  verticalAlign(t, e) {
    var a = this.parent.isGroup ? this.parent.getGroupElement().clientHeight : e || this.parent.getHeadersElement().clientHeight;
    this.element.style.height = a + "px", this.dispatch("column-height", this, this.element.style.height), this.isGroup && (this.groupElement.style.minHeight = a - this.contentElement.offsetHeight + "px"), this.columns.forEach(function(n) {
      n.verticalAlign(t);
    });
  }
  //clear vertical alignment
  clearVerticalAlign() {
    this.element.style.paddingTop = "", this.element.style.height = "", this.element.style.minHeight = "", this.groupElement.style.minHeight = "", this.columns.forEach(function(t) {
      t.clearVerticalAlign();
    }), this.dispatch("column-height", this, "");
  }
  //// Retrieve Column Information ////
  //return column header element
  getElement() {
    return this.element;
  }
  //return column group element
  getGroupElement() {
    return this.groupElement;
  }
  //return field name
  getField() {
    return this.field;
  }
  getTitleDownload() {
    return this.titleDownload;
  }
  //return the first column in a group
  getFirstColumn() {
    return this.isGroup ? this.columns.length ? this.columns[0].getFirstColumn() : !1 : this;
  }
  //return the last column in a group
  getLastColumn() {
    return this.isGroup ? this.columns.length ? this.columns[this.columns.length - 1].getLastColumn() : !1 : this;
  }
  //return all columns in a group
  getColumns(t) {
    var e = [];
    return t ? this.columns.forEach((a) => {
      e.push(a), e = e.concat(a.getColumns(!0));
    }) : e = this.columns, e;
  }
  //return all columns in a group
  getCells() {
    return this.cells;
  }
  //retrieve the top column in a group of columns
  getTopColumn() {
    return this.parent.isGroup ? this.parent.getTopColumn() : this;
  }
  //return column definition object
  getDefinition(t) {
    var e = [];
    return this.isGroup && t && (this.columns.forEach(function(a) {
      e.push(a.getDefinition(!0));
    }), this.definition.columns = e), this.definition;
  }
  //////////////////// Actions ////////////////////
  checkColumnVisibility() {
    var t = !1;
    this.columns.forEach(function(e) {
      e.visible && (t = !0);
    }), t ? (this.show(), this.dispatchExternal("columnVisibilityChanged", this.getComponent(), !1)) : this.hide();
  }
  //show column
  show(t, e) {
    this.visible || (this.visible = !0, this.element.style.display = "", this.parent.isGroup && this.parent.checkColumnVisibility(), this.cells.forEach(function(a) {
      a.show();
    }), !this.isGroup && this.width === null && this.reinitializeWidth(), this.table.columnManager.verticalAlignHeaders(), this.dispatch("column-show", this, e), t || this.dispatchExternal("columnVisibilityChanged", this.getComponent(), !0), this.parent.isGroup && this.parent.matchChildWidths(), this.silent || this.table.columnManager.rerenderColumns());
  }
  //hide column
  hide(t, e) {
    this.visible && (this.visible = !1, this.element.style.display = "none", this.table.columnManager.verticalAlignHeaders(), this.parent.isGroup && this.parent.checkColumnVisibility(), this.cells.forEach(function(a) {
      a.hide();
    }), this.dispatch("column-hide", this, e), t || this.dispatchExternal("columnVisibilityChanged", this.getComponent(), !1), this.parent.isGroup && this.parent.matchChildWidths(), this.silent || this.table.columnManager.rerenderColumns());
  }
  matchChildWidths() {
    var t = 0;
    this.contentElement && this.columns.length && (this.columns.forEach(function(e) {
      e.visible && (t += e.getWidth());
    }), this.contentElement.style.maxWidth = t - 1 + "px", this.parent.isGroup && this.parent.matchChildWidths());
  }
  removeChild(t) {
    var e = this.columns.indexOf(t);
    e > -1 && this.columns.splice(e, 1), this.columns.length || this.delete();
  }
  setWidth(t) {
    this.widthFixed = !0, this.setWidthActual(t);
  }
  setWidthActual(t) {
    isNaN(t) && (t = Math.floor(this.table.element.clientWidth / 100 * parseInt(t))), t = Math.max(this.minWidth, t), this.maxWidth && (t = Math.min(this.maxWidth, t)), this.width = t, this.widthStyled = t ? t + "px" : "", this.element.style.width = this.widthStyled, this.isGroup || this.cells.forEach(function(e) {
      e.setWidth();
    }), this.parent.isGroup && this.parent.matchChildWidths(), this.dispatch("column-width", this);
  }
  checkCellHeights() {
    var t = [];
    this.cells.forEach(function(e) {
      e.row.heightInitialized && (e.row.getElement().offsetParent !== null ? (t.push(e.row), e.row.clearCellHeight()) : e.row.heightInitialized = !1);
    }), t.forEach(function(e) {
      e.calcHeight();
    }), t.forEach(function(e) {
      e.setCellHeight();
    });
  }
  getWidth() {
    var t = 0;
    return this.isGroup ? this.columns.forEach(function(e) {
      e.visible && (t += e.getWidth());
    }) : t = this.width, t;
  }
  getLeftOffset() {
    var t = this.element.offsetLeft;
    return this.parent.isGroup && (t += this.parent.getLeftOffset()), t;
  }
  getHeight() {
    return Math.ceil(this.element.getBoundingClientRect().height);
  }
  setMinWidth(t) {
    this.maxWidth && t > this.maxWidth && (t = this.maxWidth, console.warn("the minWidth (" + t + "px) for column '" + this.field + "' cannot be bigger that its maxWidth (" + this.maxWidthStyled + ")")), this.minWidth = t, this.minWidthStyled = t ? t + "px" : "", this.element.style.minWidth = this.minWidthStyled, this.cells.forEach(function(e) {
      e.setMinWidth();
    });
  }
  setMaxWidth(t) {
    this.minWidth && t < this.minWidth && (t = this.minWidth, console.warn("the maxWidth (" + t + "px) for column '" + this.field + "' cannot be smaller that its minWidth (" + this.minWidthStyled + ")")), this.maxWidth = t, this.maxWidthStyled = t ? t + "px" : "", this.element.style.maxWidth = this.maxWidthStyled, this.cells.forEach(function(e) {
      e.setMaxWidth();
    });
  }
  delete() {
    return new Promise((t, e) => {
      this.isGroup && this.columns.forEach(function(n) {
        n.delete();
      }), this.dispatch("column-delete", this);
      var a = this.cells.length;
      for (let n = 0; n < a; n++)
        this.cells[0].delete();
      this.element.parentNode && this.element.parentNode.removeChild(this.element), this.element = !1, this.contentElement = !1, this.titleElement = !1, this.groupElement = !1, this.parent.isGroup && this.parent.removeChild(this), this.table.columnManager.deregisterColumn(this), this.table.columnManager.rerenderColumns(!0), this.dispatch("column-deleted", this), t();
    });
  }
  columnRendered() {
    this.titleFormatterRendered && this.titleFormatterRendered(), this.dispatch("column-rendered", this);
  }
  //////////////// Cell Management /////////////////
  //generate cell for this column
  generateCell(t) {
    var e = new tp(this, t);
    return this.cells.push(e), e;
  }
  nextColumn() {
    var t = this.table.columnManager.findColumnIndex(this);
    return t > -1 ? this._nextVisibleColumn(t + 1) : !1;
  }
  _nextVisibleColumn(t) {
    var e = this.table.columnManager.getColumnByIndex(t);
    return !e || e.visible ? e : this._nextVisibleColumn(t + 1);
  }
  prevColumn() {
    var t = this.table.columnManager.findColumnIndex(this);
    return t > -1 ? this._prevVisibleColumn(t - 1) : !1;
  }
  _prevVisibleColumn(t) {
    var e = this.table.columnManager.getColumnByIndex(t);
    return !e || e.visible ? e : this._prevVisibleColumn(t - 1);
  }
  reinitializeWidth(t) {
    this.widthFixed = !1, typeof this.definition.width < "u" && !t && this.setWidth(this.definition.width), this.dispatch("column-width-fit-before", this), this.fitToData(t), this.dispatch("column-width-fit-after", this);
  }
  //set column width to maximum cell width for non group columns
  fitToData(t) {
    if (!this.isGroup) {
      this.widthFixed || (this.element.style.width = "", this.cells.forEach((n) => {
        n.clearWidth();
      }));
      var e = this.element.offsetWidth;
      if ((!this.width || !this.widthFixed) && (this.cells.forEach((n) => {
        var i = n.getWidth();
        i > e && (e = i);
      }), e)) {
        var a = e + 1;
        this.maxInitialWidth && !t && (a = Math.min(a, this.maxInitialWidth)), this.setWidthActual(a);
      }
    }
  }
  updateDefinition(t) {
    var e;
    return this.isGroup || this.parent.isGroup ? (console.error("Column Update Error - The updateDefinition function is only available on ungrouped columns"), Promise.reject("Column Update Error - The updateDefinition function is only available on columns, not column groups")) : (e = Object.assign({}, this.getDefinition()), e = Object.assign(e, t), this.table.columnManager.addColumn(e, !1, this).then((a) => (e.field == this.field && (this.field = !1), this.delete().then(() => a.getComponent()))));
  }
  deleteCell(t) {
    var e = this.cells.indexOf(t);
    e > -1 && this.cells.splice(e, 1);
  }
  //////////////// Object Generation /////////////////
  getComponent() {
    return this.component || (this.component = new HN(this)), this.component;
  }
  getPosition() {
    return this.table.columnManager.getVisibleColumnsByIndex().indexOf(this) + 1;
  }
}
zi.defaultOptionList = UN;
class ff {
  constructor(t) {
    return this._row = t, new Proxy(this, {
      get: function(e, a, n) {
        return typeof e[a] < "u" ? e[a] : e._row.table.componentFunctionBinder.handle("row", e._row, a);
      }
    });
  }
  getData(t) {
    return this._row.getData(t);
  }
  getElement() {
    return this._row.getElement();
  }
  getCells() {
    var t = [];
    return this._row.getCells().forEach(function(e) {
      t.push(e.getComponent());
    }), t;
  }
  getCell(t) {
    var e = this._row.getCell(t);
    return e ? e.getComponent() : !1;
  }
  getIndex() {
    return this._row.getData("data")[this._row.table.options.index];
  }
  getPosition() {
    return this._row.getPosition();
  }
  watchPosition(t) {
    return this._row.watchPosition(t);
  }
  delete() {
    return this._row.delete();
  }
  scrollTo(t, e) {
    return this._row.table.rowManager.scrollToRow(this._row, t, e);
  }
  move(t, e) {
    this._row.moveToRow(t, e);
  }
  update(t) {
    return this._row.updateData(t);
  }
  normalizeHeight() {
    this._row.normalizeHeight(!0);
  }
  _getSelf() {
    return this._row;
  }
  reformat() {
    return this._row.reinitialize();
  }
  getTable() {
    return this._row.table;
  }
  getNextRow() {
    var t = this._row.nextRow();
    return t && t.getComponent();
  }
  getPrevRow() {
    var t = this._row.prevRow();
    return t && t.getComponent();
  }
}
class ss extends ds {
  constructor(t, e, a = "row") {
    super(e.table), this.parent = e, this.data = {}, this.type = a, this.element = !1, this.modules = {}, this.cells = [], this.height = 0, this.heightStyled = "", this.manualHeight = !1, this.outerHeight = 0, this.initialized = !1, this.heightInitialized = !1, this.position = 0, this.positionWatchers = [], this.component = null, this.created = !1, this.setData(t);
  }
  create() {
    this.created || (this.created = !0, this.generateElement());
  }
  createElement() {
    var t = document.createElement("div");
    t.classList.add("tabulator-row"), t.setAttribute("role", "row"), this.element = t;
  }
  getElement() {
    return this.create(), this.element;
  }
  detachElement() {
    this.element && this.element.parentNode && this.element.parentNode.removeChild(this.element);
  }
  generateElement() {
    this.createElement(), this.dispatch("row-init", this);
  }
  generateCells() {
    this.cells = this.table.columnManager.generateCells(this);
  }
  //functions to setup on first render
  initialize(t, e) {
    if (this.create(), !this.initialized || t) {
      for (this.deleteCells(); this.element.firstChild; )
        this.element.removeChild(this.element.firstChild);
      this.dispatch("row-layout-before", this), this.generateCells(), this.initialized = !0, this.table.columnManager.renderer.renderRowCells(this, e), t && this.normalizeHeight(), this.dispatch("row-layout", this), this.table.options.rowFormatter && this.table.options.rowFormatter(this.getComponent()), this.dispatch("row-layout-after", this);
    } else
      this.table.columnManager.renderer.rerenderRowCells(this, e);
  }
  rendered() {
    this.cells.forEach((t) => {
      t.cellRendered();
    });
  }
  reinitializeHeight() {
    this.heightInitialized = !1, this.element && this.element.offsetParent !== null && this.normalizeHeight(!0);
  }
  deinitialize() {
    this.initialized = !1;
  }
  deinitializeHeight() {
    this.heightInitialized = !1;
  }
  reinitialize(t) {
    this.initialized = !1, this.heightInitialized = !1, this.manualHeight || (this.height = 0, this.heightStyled = ""), this.element && this.element.offsetParent !== null && this.initialize(!0), this.dispatch("row-relayout", this);
  }
  //get heights when doing bulk row style calcs in virtual DOM
  calcHeight(t) {
    var e = 0, a;
    this.table.options.rowHeight ? this.height = this.table.options.rowHeight : (a = this.table.options.resizableRows ? this.element.clientHeight : 0, this.cells.forEach(function(n) {
      var i = n.getHeight();
      i > e && (e = i);
    }), t ? this.height = Math.max(e, a) : this.height = this.manualHeight ? this.height : Math.max(e, a)), this.heightStyled = this.height ? this.height + "px" : "", this.outerHeight = this.element.offsetHeight;
  }
  //set of cells
  setCellHeight() {
    this.cells.forEach(function(t) {
      t.setHeight();
    }), this.heightInitialized = !0;
  }
  clearCellHeight() {
    this.cells.forEach(function(t) {
      t.clearHeight();
    });
  }
  //normalize the height of elements in the row
  normalizeHeight(t) {
    t && !this.table.options.rowHeight && this.clearCellHeight(), this.calcHeight(t), this.setCellHeight();
  }
  //set height of rows
  setHeight(t, e) {
    (this.height != t || e) && (this.manualHeight = !0, this.height = t, this.heightStyled = t ? t + "px" : "", this.setCellHeight(), this.outerHeight = this.element.offsetHeight);
  }
  //return rows outer height
  getHeight() {
    return this.outerHeight;
  }
  //return rows outer Width
  getWidth() {
    return this.element.offsetWidth;
  }
  //////////////// Cell Management /////////////////
  deleteCell(t) {
    var e = this.cells.indexOf(t);
    e > -1 && this.cells.splice(e, 1);
  }
  //////////////// Data Management /////////////////
  setData(t) {
    this.data = this.chain("row-data-init-before", [this, t], void 0, t), this.dispatch("row-data-init-after", this);
  }
  //update the rows data
  updateData(t) {
    var e = this.element && za.elVisible(this.element), a = {}, n;
    return new Promise((i, r) => {
      typeof t == "string" && (t = JSON.parse(t)), this.dispatch("row-data-save-before", this), this.subscribed("row-data-changing") && (a = Object.assign(a, this.data), a = Object.assign(a, t)), n = this.chain("row-data-changing", [this, a, t], null, t);
      for (let l in n)
        this.data[l] = n[l];
      this.dispatch("row-data-save-after", this);
      for (let l in t)
        this.table.columnManager.getColumnsByFieldRoot(l).forEach((c) => {
          let d = this.getCell(c.getField());
          if (d) {
            let p = c.getFieldValue(n);
            d.getValue() !== p && (d.setValueProcessData(p), e && d.cellRendered());
          }
        });
      e ? (this.normalizeHeight(!0), this.table.options.rowFormatter && this.table.options.rowFormatter(this.getComponent())) : (this.initialized = !1, this.height = 0, this.heightStyled = ""), this.dispatch("row-data-changed", this, e, t), this.dispatchExternal("rowUpdated", this.getComponent()), this.subscribedExternal("dataChanged") && this.dispatchExternal("dataChanged", this.table.rowManager.getData()), i();
    });
  }
  getData(t) {
    return t ? this.chain("row-data-retrieve", [this, t], null, this.data) : this.data;
  }
  getCell(t) {
    var e = !1;
    return t = this.table.columnManager.findColumn(t), !this.initialized && this.cells.length === 0 && this.generateCells(), e = this.cells.find(function(a) {
      return a.column === t;
    }), e;
  }
  getCellIndex(t) {
    return this.cells.findIndex(function(e) {
      return e === t;
    });
  }
  findCell(t) {
    return this.cells.find((e) => e.element === t);
  }
  getCells() {
    return !this.initialized && this.cells.length === 0 && this.generateCells(), this.cells;
  }
  nextRow() {
    var t = this.table.rowManager.nextDisplayRow(this, !0);
    return t || !1;
  }
  prevRow() {
    var t = this.table.rowManager.prevDisplayRow(this, !0);
    return t || !1;
  }
  moveToRow(t, e) {
    var a = this.table.rowManager.findRow(t);
    a ? (this.table.rowManager.moveRowActual(this, a, !e), this.table.rowManager.refreshActiveData("display", !1, !0)) : console.warn("Move Error - No matching row found:", t);
  }
  ///////////////////// Actions  /////////////////////
  delete() {
    return this.dispatch("row-delete", this), this.deleteActual(), Promise.resolve();
  }
  deleteActual(t) {
    this.detachModules(), this.table.rowManager.deleteRow(this, t), this.deleteCells(), this.initialized = !1, this.heightInitialized = !1, this.element = !1, this.dispatch("row-deleted", this);
  }
  detachModules() {
    this.dispatch("row-deleting", this);
  }
  deleteCells() {
    var t = this.cells.length;
    for (let e = 0; e < t; e++)
      this.cells[0].delete();
  }
  wipe() {
    if (this.detachModules(), this.deleteCells(), this.element) {
      for (; this.element.firstChild; )
        this.element.removeChild(this.element.firstChild);
      this.element.parentNode && this.element.parentNode.removeChild(this.element);
    }
    this.element = !1, this.modules = {};
  }
  isDisplayed() {
    return this.table.rowManager.getDisplayRows().includes(this);
  }
  getPosition() {
    return this.isDisplayed() ? this.position : !1;
  }
  setPosition(t) {
    t != this.position && (this.position = t, this.positionWatchers.forEach((e) => {
      e(this.position);
    }));
  }
  watchPosition(t) {
    this.positionWatchers.push(t), t(this.position);
  }
  getGroup() {
    return this.modules.group || !1;
  }
  //////////////// Object Generation /////////////////
  getComponent() {
    return this.component || (this.component = new ff(this)), this.component;
  }
}
var H3 = {
  avg: function(s, t, e) {
    var a = 0, n = typeof e.precision < "u" ? e.precision : 2;
    return s.length && (a = s.reduce(function(i, r) {
      return Number(i) + Number(r);
    }), a = a / s.length, a = n !== !1 ? a.toFixed(n) : a), parseFloat(a).toString();
  },
  max: function(s, t, e) {
    var a = null, n = typeof e.precision < "u" ? e.precision : !1;
    return s.forEach(function(i) {
      i = Number(i), (i > a || a === null) && (a = i);
    }), a !== null ? n !== !1 ? a.toFixed(n) : a : "";
  },
  min: function(s, t, e) {
    var a = null, n = typeof e.precision < "u" ? e.precision : !1;
    return s.forEach(function(i) {
      i = Number(i), (i < a || a === null) && (a = i);
    }), a !== null ? n !== !1 ? a.toFixed(n) : a : "";
  },
  sum: function(s, t, e) {
    var a = 0, n = typeof e.precision < "u" ? e.precision : !1;
    return s.length && s.forEach(function(i) {
      i = Number(i), a += isNaN(i) ? 0 : Number(i);
    }), n !== !1 ? a.toFixed(n) : a;
  },
  concat: function(s, t, e) {
    var a = 0;
    return s.length && (a = s.reduce(function(n, i) {
      return String(n) + String(i);
    })), a;
  },
  count: function(s, t, e) {
    var a = 0;
    return s.length && s.forEach(function(n) {
      n && a++;
    }), a;
  },
  unique: function(s, t, e) {
    var a = s.filter((n, i) => (s || n === 0) && s.indexOf(n) === i);
    return a.length;
  }
};
class Wr extends Ze {
  constructor(t) {
    super(t), this.topCalcs = [], this.botCalcs = [], this.genColumn = !1, this.topElement = this.createElement(), this.botElement = this.createElement(), this.topRow = !1, this.botRow = !1, this.topInitialized = !1, this.botInitialized = !1, this.blocked = !1, this.recalcAfterBlock = !1, this.registerTableOption("columnCalcs", !0), this.registerColumnOption("topCalc"), this.registerColumnOption("topCalcParams"), this.registerColumnOption("topCalcFormatter"), this.registerColumnOption("topCalcFormatterParams"), this.registerColumnOption("bottomCalc"), this.registerColumnOption("bottomCalcParams"), this.registerColumnOption("bottomCalcFormatter"), this.registerColumnOption("bottomCalcFormatterParams");
  }
  createElement() {
    var t = document.createElement("div");
    return t.classList.add("tabulator-calcs-holder"), t;
  }
  initialize() {
    this.genColumn = new zi({ field: "value" }, this), this.subscribe("cell-value-changed", this.cellValueChanged.bind(this)), this.subscribe("column-init", this.initializeColumnCheck.bind(this)), this.subscribe("row-deleted", this.rowsUpdated.bind(this)), this.subscribe("scroll-horizontal", this.scrollHorizontal.bind(this)), this.subscribe("row-added", this.rowsUpdated.bind(this)), this.subscribe("column-moved", this.recalcActiveRows.bind(this)), this.subscribe("column-add", this.recalcActiveRows.bind(this)), this.subscribe("data-refreshed", this.recalcActiveRowsRefresh.bind(this)), this.subscribe("table-redraw", this.tableRedraw.bind(this)), this.subscribe("rows-visible", this.visibleRows.bind(this)), this.subscribe("scrollbar-vertical", this.adjustForScrollbar.bind(this)), this.subscribe("redraw-blocked", this.blockRedraw.bind(this)), this.subscribe("redraw-restored", this.restoreRedraw.bind(this)), this.subscribe("table-redrawing", this.resizeHolderWidth.bind(this)), this.subscribe("column-resized", this.resizeHolderWidth.bind(this)), this.subscribe("column-show", this.resizeHolderWidth.bind(this)), this.subscribe("column-hide", this.resizeHolderWidth.bind(this)), this.registerTableFunction("getCalcResults", this.getResults.bind(this)), this.registerTableFunction("recalc", this.userRecalc.bind(this)), this.resizeHolderWidth();
  }
  resizeHolderWidth() {
    this.topElement.style.minWidth = this.table.columnManager.headersElement.offsetWidth + "px";
  }
  tableRedraw(t) {
    this.recalc(this.table.rowManager.activeRows), t && this.redraw();
  }
  blockRedraw() {
    this.blocked = !0, this.recalcAfterBlock = !1;
  }
  restoreRedraw() {
    this.blocked = !1, this.recalcAfterBlock && (this.recalcAfterBlock = !1, this.recalcActiveRowsRefresh());
  }
  ///////////////////////////////////
  ///////// Table Functions /////////
  ///////////////////////////////////
  userRecalc() {
    this.recalc(this.table.rowManager.activeRows);
  }
  ///////////////////////////////////
  ///////// Internal Logic //////////
  ///////////////////////////////////
  blockCheck() {
    return this.blocked && (this.recalcAfterBlock = !0), this.blocked;
  }
  visibleRows(t, e) {
    return this.topRow && e.unshift(this.topRow), this.botRow && e.push(this.botRow), e;
  }
  rowsUpdated(t) {
    this.table.options.groupBy ? this.recalcRowGroup(t) : this.recalcActiveRows();
  }
  recalcActiveRowsRefresh() {
    this.table.options.groupBy && this.table.options.dataTreeStartExpanded && this.table.options.dataTree ? this.recalcAll() : this.recalcActiveRows();
  }
  recalcActiveRows() {
    this.recalc(this.table.rowManager.activeRows);
  }
  cellValueChanged(t) {
    (t.column.definition.topCalc || t.column.definition.bottomCalc) && (this.table.options.groupBy ? ((this.table.options.columnCalcs == "table" || this.table.options.columnCalcs == "both") && this.recalcActiveRows(), this.table.options.columnCalcs != "table" && this.recalcRowGroup(t.row)) : this.recalcActiveRows());
  }
  initializeColumnCheck(t) {
    (t.definition.topCalc || t.definition.bottomCalc) && this.initializeColumn(t);
  }
  //initialize column calcs
  initializeColumn(t) {
    var e = t.definition, a = {
      topCalcParams: e.topCalcParams || {},
      botCalcParams: e.bottomCalcParams || {}
    };
    if (e.topCalc) {
      switch (typeof e.topCalc) {
        case "string":
          Wr.calculations[e.topCalc] ? a.topCalc = Wr.calculations[e.topCalc] : console.warn("Column Calc Error - No such calculation found, ignoring: ", e.topCalc);
          break;
        case "function":
          a.topCalc = e.topCalc;
          break;
      }
      a.topCalc && (t.modules.columnCalcs = a, this.topCalcs.push(t), this.table.options.columnCalcs != "group" && this.initializeTopRow());
    }
    if (e.bottomCalc) {
      switch (typeof e.bottomCalc) {
        case "string":
          Wr.calculations[e.bottomCalc] ? a.botCalc = Wr.calculations[e.bottomCalc] : console.warn("Column Calc Error - No such calculation found, ignoring: ", e.bottomCalc);
          break;
        case "function":
          a.botCalc = e.bottomCalc;
          break;
      }
      a.botCalc && (t.modules.columnCalcs = a, this.botCalcs.push(t), this.table.options.columnCalcs != "group" && this.initializeBottomRow());
    }
  }
  //dummy functions to handle being mock column manager
  registerColumnField() {
  }
  removeCalcs() {
    var t = !1;
    this.topInitialized && (this.topInitialized = !1, this.topElement.parentNode.removeChild(this.topElement), t = !0), this.botInitialized && (this.botInitialized = !1, this.footerRemove(this.botElement), t = !0), t && this.table.rowManager.adjustTableSize();
  }
  reinitializeCalcs() {
    this.topCalcs.length && this.initializeTopRow(), this.botCalcs.length && this.initializeBottomRow();
  }
  initializeTopRow() {
    var t = document.createDocumentFragment();
    this.topInitialized || (t.appendChild(document.createElement("br")), t.appendChild(this.topElement), this.table.columnManager.getContentsElement().insertBefore(t, this.table.columnManager.headersElement.nextSibling), this.topInitialized = !0);
  }
  initializeBottomRow() {
    this.botInitialized || (this.footerPrepend(this.botElement), this.botInitialized = !0);
  }
  scrollHorizontal(t) {
    this.botInitialized && this.botRow && (this.botElement.scrollLeft = t);
  }
  recalc(t) {
    var e, a;
    if (!this.blockCheck() && (this.topInitialized || this.botInitialized)) {
      if (e = this.rowsToData(t), this.topInitialized) {
        for (this.topRow && this.topRow.deleteCells(), a = this.generateRow("top", e), this.topRow = a; this.topElement.firstChild; )
          this.topElement.removeChild(this.topElement.firstChild);
        this.topElement.appendChild(a.getElement()), a.initialize(!0);
      }
      if (this.botInitialized) {
        for (this.botRow && this.botRow.deleteCells(), a = this.generateRow("bottom", e), this.botRow = a; this.botElement.firstChild; )
          this.botElement.removeChild(this.botElement.firstChild);
        this.botElement.appendChild(a.getElement()), a.initialize(!0);
      }
      this.table.rowManager.adjustTableSize(), this.table.modExists("frozenColumns") && this.table.modules.frozenColumns.layout();
    }
  }
  recalcRowGroup(t) {
    this.recalcGroup(this.table.modules.groupRows.getRowGroup(t));
  }
  recalcAll() {
    if ((this.topCalcs.length || this.botCalcs.length) && (this.table.options.columnCalcs !== "group" && this.recalcActiveRows(), this.table.options.groupBy && this.table.options.columnCalcs !== "table")) {
      var t = this.table.modules.groupRows.getChildGroups();
      t.forEach((e) => {
        this.recalcGroup(e);
      });
    }
  }
  recalcGroup(t) {
    var e, a;
    this.blockCheck() || t && t.calcs && (t.calcs.bottom && (e = this.rowsToData(t.rows), a = this.generateRowData("bottom", e), t.calcs.bottom.updateData(a), t.calcs.bottom.reinitialize()), t.calcs.top && (e = this.rowsToData(t.rows), a = this.generateRowData("top", e), t.calcs.top.updateData(a), t.calcs.top.reinitialize()));
  }
  //generate top stats row
  generateTopRow(t) {
    return this.generateRow("top", this.rowsToData(t));
  }
  //generate bottom stats row
  generateBottomRow(t) {
    return this.generateRow("bottom", this.rowsToData(t));
  }
  rowsToData(t) {
    var e = [];
    return t.forEach((a) => {
      if (e.push(a.getData()), this.table.options.dataTree && this.table.options.dataTreeChildColumnCalcs && a.modules.dataTree && a.modules.dataTree.open) {
        var n = this.rowsToData(this.table.modules.dataTree.getFilteredTreeChildren(a));
        e = e.concat(n);
      }
    }), e;
  }
  //generate stats row
  generateRow(t, e) {
    var a = this.generateRowData(t, e), n;
    return this.table.modExists("mutator") && this.table.modules.mutator.disable(), n = new ss(a, this, "calc"), this.table.modExists("mutator") && this.table.modules.mutator.enable(), n.getElement().classList.add("tabulator-calcs", "tabulator-calcs-" + t), n.component = !1, n.getComponent = () => (n.component || (n.component = new G3(n)), n.component), n.generateCells = () => {
      var i = [];
      this.table.columnManager.columnsByIndex.forEach((r) => {
        this.genColumn.setField(r.getField()), this.genColumn.hozAlign = r.hozAlign, r.definition[t + "CalcFormatter"] && this.table.modExists("format") ? this.genColumn.modules.format = {
          formatter: this.table.modules.format.getFormatter(r.definition[t + "CalcFormatter"]),
          params: r.definition[t + "CalcFormatterParams"] || {}
        } : this.genColumn.modules.format = {
          formatter: this.table.modules.format.getFormatter("plaintext"),
          params: {}
        }, this.genColumn.definition.cssClass = r.definition.cssClass;
        var l = new tp(this.genColumn, n);
        l.getElement(), l.column = r, l.setWidth(), r.cells.push(l), i.push(l), r.visible || l.hide();
      }), n.cells = i;
    }, n;
  }
  //generate stats row
  generateRowData(t, e) {
    var a = {}, n = t == "top" ? this.topCalcs : this.botCalcs, i = t == "top" ? "topCalc" : "botCalc", r, l;
    return n.forEach(function(o) {
      var c = [];
      o.modules.columnCalcs && o.modules.columnCalcs[i] && (e.forEach(function(d) {
        c.push(o.getFieldValue(d));
      }), l = i + "Params", r = typeof o.modules.columnCalcs[l] == "function" ? o.modules.columnCalcs[l](c, e) : o.modules.columnCalcs[l], o.setFieldValue(a, o.modules.columnCalcs[i](c, e, r)));
    }), a;
  }
  hasTopCalcs() {
    return !!this.topCalcs.length;
  }
  hasBottomCalcs() {
    return !!this.botCalcs.length;
  }
  //handle table redraw
  redraw() {
    this.topRow && this.topRow.normalizeHeight(!0), this.botRow && this.botRow.normalizeHeight(!0);
  }
  //return the calculated
  getResults() {
    var t = {}, e;
    return this.table.options.groupBy && this.table.modExists("groupRows") ? (e = this.table.modules.groupRows.getGroups(!0), e.forEach((a) => {
      t[a.getKey()] = this.getGroupResults(a);
    })) : t = {
      top: this.topRow ? this.topRow.getData() : {},
      bottom: this.botRow ? this.botRow.getData() : {}
    }, t;
  }
  //get results from a group
  getGroupResults(t) {
    var e = t._getSelf(), a = t.getSubGroups(), n = {}, i = {};
    return a.forEach((r) => {
      n[r.getKey()] = this.getGroupResults(r);
    }), i = {
      top: e.calcs.top ? e.calcs.top.getData() : {},
      bottom: e.calcs.bottom ? e.calcs.bottom.getData() : {},
      groups: n
    }, i;
  }
  adjustForScrollbar(t) {
    this.botRow && (this.table.rtl ? this.botElement.style.paddingLeft = t + "px" : this.botElement.style.paddingRight = t + "px");
  }
}
Wr.moduleName = "columnCalcs";
Wr.calculations = H3;
class FN extends Ze {
  constructor(t) {
    super(t), this.indent = 10, this.field = "", this.collapseEl = null, this.expandEl = null, this.branchEl = null, this.elementField = !1, this.startOpen = function() {
    }, this.registerTableOption("dataTree", !1), this.registerTableOption("dataTreeFilter", !0), this.registerTableOption("dataTreeSort", !0), this.registerTableOption("dataTreeElementColumn", !1), this.registerTableOption("dataTreeBranchElement", !0), this.registerTableOption("dataTreeChildIndent", 9), this.registerTableOption("dataTreeChildField", "_children"), this.registerTableOption("dataTreeCollapseElement", !1), this.registerTableOption("dataTreeExpandElement", !1), this.registerTableOption("dataTreeStartExpanded", !1), this.registerTableOption("dataTreeChildColumnCalcs", !1), this.registerTableOption("dataTreeSelectPropagate", !1), this.registerComponentFunction("row", "treeCollapse", this.collapseRow.bind(this)), this.registerComponentFunction("row", "treeExpand", this.expandRow.bind(this)), this.registerComponentFunction("row", "treeToggle", this.toggleRow.bind(this)), this.registerComponentFunction("row", "getTreeParent", this.getTreeParent.bind(this)), this.registerComponentFunction("row", "getTreeChildren", this.getRowChildren.bind(this)), this.registerComponentFunction("row", "addTreeChild", this.addTreeChildRow.bind(this)), this.registerComponentFunction("row", "isTreeExpanded", this.isRowExpanded.bind(this));
  }
  initialize() {
    if (this.table.options.dataTree) {
      var t = null, e = this.table.options;
      switch (this.field = e.dataTreeChildField, this.indent = e.dataTreeChildIndent, this.options("movableRows") && console.warn("The movableRows option is not available with dataTree enabled, moving of child rows could result in unpredictable behavior"), e.dataTreeBranchElement ? e.dataTreeBranchElement === !0 ? (this.branchEl = document.createElement("div"), this.branchEl.classList.add("tabulator-data-tree-branch")) : typeof e.dataTreeBranchElement == "string" ? (t = document.createElement("div"), t.innerHTML = e.dataTreeBranchElement, this.branchEl = t.firstChild) : this.branchEl = e.dataTreeBranchElement : (this.branchEl = document.createElement("div"), this.branchEl.classList.add("tabulator-data-tree-branch-empty")), e.dataTreeCollapseElement ? typeof e.dataTreeCollapseElement == "string" ? (t = document.createElement("div"), t.innerHTML = e.dataTreeCollapseElement, this.collapseEl = t.firstChild) : this.collapseEl = e.dataTreeCollapseElement : (this.collapseEl = document.createElement("div"), this.collapseEl.classList.add("tabulator-data-tree-control"), this.collapseEl.tabIndex = 0, this.collapseEl.innerHTML = "<div class='tabulator-data-tree-control-collapse'></div>"), e.dataTreeExpandElement ? typeof e.dataTreeExpandElement == "string" ? (t = document.createElement("div"), t.innerHTML = e.dataTreeExpandElement, this.expandEl = t.firstChild) : this.expandEl = e.dataTreeExpandElement : (this.expandEl = document.createElement("div"), this.expandEl.classList.add("tabulator-data-tree-control"), this.expandEl.tabIndex = 0, this.expandEl.innerHTML = "<div class='tabulator-data-tree-control-expand'></div>"), typeof e.dataTreeStartExpanded) {
        case "boolean":
          this.startOpen = function(a, n) {
            return e.dataTreeStartExpanded;
          };
          break;
        case "function":
          this.startOpen = e.dataTreeStartExpanded;
          break;
        default:
          this.startOpen = function(a, n) {
            return e.dataTreeStartExpanded[n];
          };
          break;
      }
      this.subscribe("row-init", this.initializeRow.bind(this)), this.subscribe("row-layout-after", this.layoutRow.bind(this)), this.subscribe("row-deleted", this.rowDelete.bind(this), 0), this.subscribe("row-data-changed", this.rowDataChanged.bind(this), 10), this.subscribe("cell-value-updated", this.cellValueChanged.bind(this)), this.subscribe("edit-cancelled", this.cellValueChanged.bind(this)), this.subscribe("column-moving-rows", this.columnMoving.bind(this)), this.subscribe("table-built", this.initializeElementField.bind(this)), this.subscribe("table-redrawing", this.tableRedrawing.bind(this)), this.registerDisplayHandler(this.getRows.bind(this), 30);
    }
  }
  tableRedrawing(t) {
    var e;
    t && (e = this.table.rowManager.getRows(), e.forEach((a) => {
      this.reinitializeRowChildren(a);
    }));
  }
  initializeElementField() {
    var t = this.table.columnManager.getFirstVisibleColumn();
    this.elementField = this.table.options.dataTreeElementColumn || (t ? t.field : !1);
  }
  getRowChildren(t) {
    return this.getTreeChildren(t, !0);
  }
  columnMoving() {
    var t = [];
    return this.table.rowManager.rows.forEach((e) => {
      t = t.concat(this.getTreeChildren(e, !1, !0));
    }), t;
  }
  rowDataChanged(t, e, a) {
    this.redrawNeeded(a) && (this.initializeRow(t), e && (this.layoutRow(t), this.refreshData(!0)));
  }
  cellValueChanged(t) {
    var e = t.column.getField();
    e === this.elementField && this.layoutRow(t.row);
  }
  initializeRow(t) {
    var e = t.getData()[this.field], a = Array.isArray(e), n = a || !a && typeof e == "object" && e !== null;
    !n && t.modules.dataTree && t.modules.dataTree.branchEl && t.modules.dataTree.branchEl.parentNode.removeChild(t.modules.dataTree.branchEl), !n && t.modules.dataTree && t.modules.dataTree.controlEl && t.modules.dataTree.controlEl.parentNode.removeChild(t.modules.dataTree.controlEl), t.modules.dataTree = {
      index: t.modules.dataTree ? t.modules.dataTree.index : 0,
      open: n ? t.modules.dataTree ? t.modules.dataTree.open : this.startOpen(t.getComponent(), 0) : !1,
      controlEl: t.modules.dataTree && n ? t.modules.dataTree.controlEl : !1,
      branchEl: t.modules.dataTree && n ? t.modules.dataTree.branchEl : !1,
      parent: t.modules.dataTree ? t.modules.dataTree.parent : !1,
      children: n
    };
  }
  reinitializeRowChildren(t) {
    var e = this.getTreeChildren(t, !1, !0);
    e.forEach(function(a) {
      a.reinitialize(!0);
    });
  }
  layoutRow(t) {
    var e = this.elementField ? t.getCell(this.elementField) : t.getCells()[0], a = e.getElement(), n = t.modules.dataTree;
    n.branchEl && (n.branchEl.parentNode && n.branchEl.parentNode.removeChild(n.branchEl), n.branchEl = !1), n.controlEl && (n.controlEl.parentNode && n.controlEl.parentNode.removeChild(n.controlEl), n.controlEl = !1), this.generateControlElement(t, a), t.getElement().classList.add("tabulator-tree-level-" + n.index), n.index && (this.branchEl ? (n.branchEl = this.branchEl.cloneNode(!0), a.insertBefore(n.branchEl, a.firstChild), this.table.rtl ? n.branchEl.style.marginRight = (n.branchEl.offsetWidth + n.branchEl.style.marginLeft) * (n.index - 1) + n.index * this.indent + "px" : n.branchEl.style.marginLeft = (n.branchEl.offsetWidth + n.branchEl.style.marginRight) * (n.index - 1) + n.index * this.indent + "px") : this.table.rtl ? a.style.paddingRight = parseInt(window.getComputedStyle(a, null).getPropertyValue("padding-right")) + n.index * this.indent + "px" : a.style.paddingLeft = parseInt(window.getComputedStyle(a, null).getPropertyValue("padding-left")) + n.index * this.indent + "px");
  }
  generateControlElement(t, e) {
    var a = t.modules.dataTree, n = a.controlEl;
    e = e || t.getCells()[0].getElement(), a.children !== !1 && (a.open ? (a.controlEl = this.collapseEl.cloneNode(!0), a.controlEl.addEventListener("click", (i) => {
      i.stopPropagation(), this.collapseRow(t);
    })) : (a.controlEl = this.expandEl.cloneNode(!0), a.controlEl.addEventListener("click", (i) => {
      i.stopPropagation(), this.expandRow(t);
    })), a.controlEl.addEventListener("mousedown", (i) => {
      i.stopPropagation();
    }), n && n.parentNode === e ? n.parentNode.replaceChild(a.controlEl, n) : e.insertBefore(a.controlEl, e.firstChild));
  }
  getRows(t) {
    var e = [];
    return t.forEach((a, n) => {
      var i, r;
      e.push(a), a instanceof ss && (a.create(), i = a.modules.dataTree, !i.index && i.children !== !1 && (r = this.getChildren(a), r.forEach((l) => {
        l.create(), e.push(l);
      })));
    }), e;
  }
  getChildren(t, e) {
    var a = t.modules.dataTree, n = [], i = [];
    return a.children !== !1 && (a.open || e) && (Array.isArray(a.children) || (a.children = this.generateChildren(t)), this.table.modExists("filter") && this.table.options.dataTreeFilter ? n = this.table.modules.filter.filter(a.children) : n = a.children, this.table.modExists("sort") && this.table.options.dataTreeSort && this.table.modules.sort.sort(n), n.forEach((r) => {
      i.push(r);
      var l = this.getChildren(r);
      l.forEach((o) => {
        i.push(o);
      });
    })), i;
  }
  generateChildren(t) {
    var e = [], a = t.getData()[this.field];
    return Array.isArray(a) || (a = [a]), a.forEach((n) => {
      var i = new ss(n || {}, this.table.rowManager);
      i.create(), i.modules.dataTree.index = t.modules.dataTree.index + 1, i.modules.dataTree.parent = t, i.modules.dataTree.children && (i.modules.dataTree.open = this.startOpen(i.getComponent(), i.modules.dataTree.index)), e.push(i);
    }), e;
  }
  expandRow(t, e) {
    var a = t.modules.dataTree;
    a.children !== !1 && (a.open = !0, t.reinitialize(), this.refreshData(!0), this.dispatchExternal("dataTreeRowExpanded", t.getComponent(), t.modules.dataTree.index));
  }
  collapseRow(t) {
    var e = t.modules.dataTree;
    e.children !== !1 && (e.open = !1, t.reinitialize(), this.refreshData(!0), this.dispatchExternal("dataTreeRowCollapsed", t.getComponent(), t.modules.dataTree.index));
  }
  toggleRow(t) {
    var e = t.modules.dataTree;
    e.children !== !1 && (e.open ? this.collapseRow(t) : this.expandRow(t));
  }
  isRowExpanded(t) {
    return t.modules.dataTree.open;
  }
  getTreeParent(t) {
    return t.modules.dataTree.parent ? t.modules.dataTree.parent.getComponent() : !1;
  }
  getTreeParentRoot(t) {
    return t.modules.dataTree && t.modules.dataTree.parent ? this.getTreeParentRoot(t.modules.dataTree.parent) : t;
  }
  getFilteredTreeChildren(t) {
    var e = t.modules.dataTree, a = [], n;
    return e.children && (Array.isArray(e.children) || (e.children = this.generateChildren(t)), this.table.modExists("filter") && this.table.options.dataTreeFilter ? n = this.table.modules.filter.filter(e.children) : n = e.children, n.forEach((i) => {
      i instanceof ss && a.push(i);
    })), a;
  }
  rowDelete(t) {
    var e = t.modules.dataTree.parent, a;
    e && (a = this.findChildIndex(t, e), a !== !1 && e.data[this.field].splice(a, 1), e.data[this.field].length || delete e.data[this.field], this.initializeRow(e), this.layoutRow(e)), this.refreshData(!0);
  }
  addTreeChildRow(t, e, a, n) {
    var i = !1;
    typeof e == "string" && (e = JSON.parse(e)), Array.isArray(t.data[this.field]) || (t.data[this.field] = [], t.modules.dataTree.open = this.startOpen(t.getComponent(), t.modules.dataTree.index)), typeof n < "u" && (i = this.findChildIndex(n, t), i !== !1 && t.data[this.field].splice(a ? i : i + 1, 0, e)), i === !1 && (a ? t.data[this.field].unshift(e) : t.data[this.field].push(e)), this.initializeRow(t), this.layoutRow(t), this.refreshData(!0);
  }
  findChildIndex(t, e) {
    var a = !1;
    return typeof t == "object" ? t instanceof ss ? a = t.data : t instanceof ff ? a = t._getSelf().data : typeof HTMLElement < "u" && t instanceof HTMLElement ? e.modules.dataTree && (a = e.modules.dataTree.children.find((n) => n instanceof ss ? n.element === t : !1), a && (a = a.data)) : t === null && (a = !1) : typeof t > "u" ? a = !1 : a = e.data[this.field].find((n) => n.data[this.table.options.index] == t), a && (Array.isArray(e.data[this.field]) && (a = e.data[this.field].indexOf(a)), a == -1 && (a = !1)), a;
  }
  getTreeChildren(t, e, a) {
    var n = t.modules.dataTree, i = [];
    return n && n.children && (Array.isArray(n.children) || (n.children = this.generateChildren(t)), n.children.forEach((r) => {
      r instanceof ss && (i.push(e ? r.getComponent() : r), a && (i = i.concat(this.getTreeChildren(r, e, a))));
    })), i;
  }
  getChildField() {
    return this.field;
  }
  redrawNeeded(t) {
    return (this.field ? typeof t[this.field] < "u" : !1) || (this.elementField ? typeof t[this.elementField] < "u" : !1);
  }
}
FN.moduleName = "dataTree";
function U3(s, t = {}, e) {
  var a = t.delimiter ? t.delimiter : ",", n = [], i = [];
  s.forEach((r) => {
    var l = [];
    switch (r.type) {
      case "group":
        console.warn("Download Warning - CSV downloader cannot process row groups");
        break;
      case "calc":
        console.warn("Download Warning - CSV downloader cannot process column calculations");
        break;
      case "header":
        r.columns.forEach((o, c) => {
          o && o.depth === 1 && (i[c] = typeof o.value > "u" || o.value === null ? "" : '"' + String(o.value).split('"').join('""') + '"');
        });
        break;
      case "row":
        r.columns.forEach((o) => {
          if (o) {
            switch (typeof o.value) {
              case "object":
                o.value = o.value !== null ? JSON.stringify(o.value) : "";
                break;
              case "undefined":
                o.value = "";
                break;
            }
            l.push('"' + String(o.value).split('"').join('""') + '"');
          }
        }), n.push(l.join(a));
        break;
    }
  }), i.length && n.unshift(i.join(a)), n = n.join(`
`), t.bom && (n = "\uFEFF" + n), e(n, "text/csv");
}
function F3(s, t, e) {
  var a = [];
  s.forEach((n) => {
    var i = {};
    switch (n.type) {
      case "header":
        break;
      case "group":
        console.warn("Download Warning - JSON downloader cannot process row groups");
        break;
      case "calc":
        console.warn("Download Warning - JSON downloader cannot process column calculations");
        break;
      case "row":
        n.columns.forEach((r) => {
          r && (i[r.component.getTitleDownload() || r.component.getField()] = r.value);
        }), a.push(i);
        break;
    }
  }), a = JSON.stringify(a, null, "	"), e(a, "application/json");
}
function z3(s, t = {}, e) {
  var a = [], n = [], i = {}, r = t.rowGroupStyles || {
    fontStyle: "bold",
    fontSize: 12,
    cellPadding: 6,
    fillColor: 220
  }, l = t.rowCalcStyles || {
    fontStyle: "bold",
    fontSize: 10,
    cellPadding: 4,
    fillColor: 232
  }, o = t.jsPDF || {}, c = t.title ? t.title : "";
  o.orientation || (o.orientation = t.orientation || "landscape"), o.unit || (o.unit = "pt"), s.forEach((h) => {
    switch (h.type) {
      case "header":
        a.push(d(h));
        break;
      case "group":
        n.push(d(h, r));
        break;
      case "calc":
        n.push(d(h, l));
        break;
      case "row":
        n.push(d(h));
        break;
    }
  });
  function d(h, g) {
    var x = [];
    return h.columns.forEach((b) => {
      var A;
      if (b) {
        switch (typeof b.value) {
          case "object":
            b.value = b.value !== null ? JSON.stringify(b.value) : "";
            break;
          case "undefined":
            b.value = "";
            break;
        }
        A = {
          content: b.value,
          colSpan: b.width,
          rowSpan: b.height
        }, g && (A.styles = g), x.push(A);
      }
    }), x;
  }
  var p = new jspdf.jsPDF(o);
  t.autoTable && (typeof t.autoTable == "function" ? i = t.autoTable(p) || {} : i = t.autoTable), c && (i.didDrawPage = function(h) {
    p.text(c, 40, 30);
  }), i.head = a, i.body = n, p.autoTable(i), t.documentProcessing && t.documentProcessing(p), e(p.output("arraybuffer"), "application/pdf");
}
function B3(s, t, e) {
  var a = this, n = t.sheetName || "Sheet1", i = XLSX.utils.book_new(), r = new ds(this), l = "compress" in t ? t.compress : !0, o = t.writeOptions || { bookType: "xlsx", bookSST: !0, compression: l }, c;
  o.type = "binary", i.SheetNames = [], i.Sheets = {};
  function d() {
    var g = [], x = [], b = {}, A = { s: { c: 0, r: 0 }, e: { c: s[0] ? s[0].columns.reduce((T, R) => T + (R && R.width ? R.width : 1), 0) : 0, r: s.length } };
    return s.forEach((T, R) => {
      var C = [];
      T.columns.forEach(function(v, P) {
        v ? (C.push(!(v.value instanceof Date) && typeof v.value == "object" ? JSON.stringify(v.value) : v.value), (v.width > 1 || v.height > -1) && (v.height > 1 || v.width > 1) && x.push({ s: { r: R, c: P }, e: { r: R + v.height - 1, c: P + v.width - 1 } })) : C.push("");
      }), g.push(C);
    }), XLSX.utils.sheet_add_aoa(b, g), b["!ref"] = XLSX.utils.encode_range(A), x.length && (b["!merges"] = x), b;
  }
  if (t.sheetOnly) {
    e(d());
    return;
  }
  if (t.sheets)
    for (var p in t.sheets)
      t.sheets[p] === !0 ? (i.SheetNames.push(p), i.Sheets[p] = d()) : (i.SheetNames.push(p), r.commsSend(t.sheets[p], "download", "intercept", {
        type: "xlsx",
        options: { sheetOnly: !0 },
        active: a.active,
        intercept: function(g) {
          i.Sheets[p] = g;
        }
      }));
  else
    i.SheetNames.push(n), i.Sheets[n] = d();
  t.documentProcessing && (i = t.documentProcessing(i));
  function h(g) {
    for (var x = new ArrayBuffer(g.length), b = new Uint8Array(x), A = 0; A != g.length; ++A)
      b[A] = g.charCodeAt(A) & 255;
    return x;
  }
  c = XLSX.write(i, o), e(h(c), "application/octet-stream");
}
function W3(s, t, e) {
  this.modExists("export", !0) && e(this.modules.export.generateHTMLTable(s), "text/html");
}
function j3(s, t, e) {
  const a = [];
  s.forEach((n) => {
    const i = {};
    switch (n.type) {
      case "header":
        break;
      case "group":
        console.warn("Download Warning - JSON downloader cannot process row groups");
        break;
      case "calc":
        console.warn("Download Warning - JSON downloader cannot process column calculations");
        break;
      case "row":
        n.columns.forEach((r) => {
          r && (i[r.component.getTitleDownload() || r.component.getField()] = r.value);
        }), a.push(JSON.stringify(i));
        break;
    }
  }), e(a.join(`
`), "application/x-ndjson");
}
var V3 = {
  csv: U3,
  json: F3,
  jsonLines: j3,
  pdf: z3,
  xlsx: B3,
  html: W3
};
class Ec extends Ze {
  constructor(t) {
    super(t), this.registerTableOption("downloadEncoder", function(e, a) {
      return new Blob([e], { type: a });
    }), this.registerTableOption("downloadReady", void 0), this.registerTableOption("downloadConfig", {}), this.registerTableOption("downloadRowRange", "active"), this.registerColumnOption("download"), this.registerColumnOption("titleDownload");
  }
  initialize() {
    this.deprecatedOptionsCheck(), this.registerTableFunction("download", this.download.bind(this)), this.registerTableFunction("downloadToTab", this.downloadToTab.bind(this));
  }
  deprecatedOptionsCheck() {
    this.deprecationCheck("downloadReady", "downloadEncoder");
  }
  ///////////////////////////////////
  ///////// Table Functions /////////
  ///////////////////////////////////
  downloadToTab(t, e, a, n) {
    this.download(t, e, a, n, !0);
  }
  ///////////////////////////////////
  ///////// Internal Logic //////////
  ///////////////////////////////////
  //trigger file download
  download(t, e, a, n, i) {
    var r = !1;
    function l(c, d) {
      i ? i === !0 ? this.triggerDownload(c, d, t, e, !0) : i(c) : this.triggerDownload(c, d, t, e);
    }
    if (typeof t == "function" ? r = t : Ec.downloaders[t] ? r = Ec.downloaders[t] : console.warn("Download Error - No such download type found: ", t), r) {
      var o = this.generateExportList(n);
      r.call(this.table, o, a || {}, l.bind(this));
    }
  }
  generateExportList(t) {
    var e = this.table.modules.export.generateExportList(this.table.options.downloadConfig, !1, t || this.table.options.downloadRowRange, "download"), a = this.table.options.groupHeaderDownload;
    return a && !Array.isArray(a) && (a = [a]), e.forEach((n) => {
      var i;
      n.type === "group" && (i = n.columns[0], a && a[n.indent] && (i.value = a[n.indent](i.value, n.component._group.getRowCount(), n.component._group.getData(), n.component)));
    }), e;
  }
  triggerDownload(t, e, a, n, i) {
    var r = document.createElement("a"), l = this.table.options.downloadEncoder(t, e);
    l && (i ? window.open(window.URL.createObjectURL(l)) : (n = n || "Tabulator." + (typeof a == "function" ? "txt" : a), navigator.msSaveOrOpenBlob ? navigator.msSaveOrOpenBlob(l, n) : (r.setAttribute("href", window.URL.createObjectURL(l)), r.setAttribute("download", n), r.style.display = "none", document.body.appendChild(r), r.click(), document.body.removeChild(r))), this.dispatchExternal("downloadComplete"));
  }
  commsReceived(t, e, a) {
    switch (e) {
      case "intercept":
        this.download(a.type, "", a.options, a.active, a.intercept);
        break;
    }
  }
}
Ec.moduleName = "download";
Ec.downloaders = V3;
function bf(s, t) {
  var e = t.mask, a = typeof t.maskLetterChar < "u" ? t.maskLetterChar : "A", n = typeof t.maskNumberChar < "u" ? t.maskNumberChar : "9", i = typeof t.maskWildcardChar < "u" ? t.maskWildcardChar : "*";
  function r(l) {
    var o = e[l];
    typeof o < "u" && o !== i && o !== a && o !== n && (s.value = s.value + "" + o, r(l + 1));
  }
  s.addEventListener("keydown", (l) => {
    var o = s.value.length, c = l.key;
    if (l.keyCode > 46 && !l.ctrlKey && !l.metaKey) {
      if (o >= e.length)
        return l.preventDefault(), l.stopPropagation(), !1;
      switch (e[o]) {
        case a:
          if (c.toUpperCase() == c.toLowerCase())
            return l.preventDefault(), l.stopPropagation(), !1;
          break;
        case n:
          if (isNaN(c))
            return l.preventDefault(), l.stopPropagation(), !1;
          break;
        case i:
          break;
        default:
          if (c !== e[o])
            return l.preventDefault(), l.stopPropagation(), !1;
      }
    }
  }), s.addEventListener("keyup", (l) => {
    l.keyCode > 46 && t.maskAutoFill && r(s.value.length);
  }), s.placeholder || (s.placeholder = e), t.maskAutoFill && r(s.value.length);
}
function q3(s, t, e, a, n) {
  var i = s.getValue(), r = document.createElement("input");
  if (r.setAttribute("type", n.search ? "search" : "text"), r.style.padding = "4px", r.style.width = "100%", r.style.boxSizing = "border-box", n.elementAttributes && typeof n.elementAttributes == "object")
    for (let o in n.elementAttributes)
      o.charAt(0) == "+" ? (o = o.slice(1), r.setAttribute(o, r.getAttribute(o) + n.elementAttributes["+" + o])) : r.setAttribute(o, n.elementAttributes[o]);
  r.value = typeof i < "u" ? i : "", t(function() {
    s.getType() === "cell" && (r.focus({ preventScroll: !0 }), r.style.height = "100%", n.selectContents && r.select());
  });
  function l(o) {
    (i === null || typeof i > "u") && r.value !== "" || r.value !== i ? e(r.value) && (i = r.value) : a();
  }
  return r.addEventListener("change", l), r.addEventListener("blur", l), r.addEventListener("keydown", function(o) {
    switch (o.keyCode) {
      case 13:
        l();
        break;
      case 27:
        a();
        break;
      case 35:
      case 36:
        o.stopPropagation();
        break;
    }
  }), n.mask && bf(r, n), r;
}
function K3(s, t, e, a, n) {
  var i = s.getValue(), r = n.verticalNavigation || "hybrid", l = String(i !== null && typeof i < "u" ? i : ""), o = document.createElement("textarea"), c = 0;
  if (o.style.display = "block", o.style.padding = "2px", o.style.height = "100%", o.style.width = "100%", o.style.boxSizing = "border-box", o.style.whiteSpace = "pre-wrap", o.style.resize = "none", n.elementAttributes && typeof n.elementAttributes == "object")
    for (let p in n.elementAttributes)
      p.charAt(0) == "+" ? (p = p.slice(1), o.setAttribute(p, o.getAttribute(p) + n.elementAttributes["+" + p])) : o.setAttribute(p, n.elementAttributes[p]);
  o.value = l, t(function() {
    s.getType() === "cell" && (o.focus({ preventScroll: !0 }), o.style.height = "100%", o.scrollHeight, o.style.height = o.scrollHeight + "px", s.getRow().normalizeHeight(), n.selectContents && o.select());
  });
  function d(p) {
    (i === null || typeof i > "u") && o.value !== "" || o.value !== i ? (e(o.value) && (i = o.value), setTimeout(function() {
      s.getRow().normalizeHeight();
    }, 300)) : a();
  }
  return o.addEventListener("change", d), o.addEventListener("blur", d), o.addEventListener("keyup", function() {
    o.style.height = "";
    var p = o.scrollHeight;
    o.style.height = p + "px", p != c && (c = p, s.getRow().normalizeHeight());
  }), o.addEventListener("keydown", function(p) {
    switch (p.keyCode) {
      case 13:
        p.shiftKey && n.shiftEnterSubmit && d();
        break;
      case 27:
        a();
        break;
      case 38:
        (r == "editor" || r == "hybrid" && o.selectionStart) && (p.stopImmediatePropagation(), p.stopPropagation());
        break;
      case 40:
        (r == "editor" || r == "hybrid" && o.selectionStart !== o.value.length) && (p.stopImmediatePropagation(), p.stopPropagation());
        break;
      case 35:
      case 36:
        p.stopPropagation();
        break;
    }
  }), n.mask && bf(o, n), o;
}
function J3(s, t, e, a, n) {
  var i = s.getValue(), r = n.verticalNavigation || "editor", l = document.createElement("input");
  if (l.setAttribute("type", "number"), typeof n.max < "u" && l.setAttribute("max", n.max), typeof n.min < "u" && l.setAttribute("min", n.min), typeof n.step < "u" && l.setAttribute("step", n.step), l.style.padding = "4px", l.style.width = "100%", l.style.boxSizing = "border-box", n.elementAttributes && typeof n.elementAttributes == "object")
    for (let d in n.elementAttributes)
      d.charAt(0) == "+" ? (d = d.slice(1), l.setAttribute(d, l.getAttribute(d) + n.elementAttributes["+" + d])) : l.setAttribute(d, n.elementAttributes[d]);
  l.value = i;
  var o = function(d) {
    c();
  };
  t(function() {
    s.getType() === "cell" && (l.removeEventListener("blur", o), l.focus({ preventScroll: !0 }), l.style.height = "100%", l.addEventListener("blur", o), n.selectContents && l.select());
  });
  function c() {
    var d = l.value;
    !isNaN(d) && d !== "" && (d = Number(d)), d !== i ? e(d) && (i = d) : a();
  }
  return l.addEventListener("keydown", function(d) {
    switch (d.keyCode) {
      case 13:
        c();
        break;
      case 27:
        a();
        break;
      case 38:
      case 40:
        r == "editor" && (d.stopImmediatePropagation(), d.stopPropagation());
        break;
      case 35:
      case 36:
        d.stopPropagation();
        break;
    }
  }), n.mask && bf(l, n), l;
}
function Q3(s, t, e, a, n) {
  var i = s.getValue(), r = document.createElement("input");
  if (r.setAttribute("type", "range"), typeof n.max < "u" && r.setAttribute("max", n.max), typeof n.min < "u" && r.setAttribute("min", n.min), typeof n.step < "u" && r.setAttribute("step", n.step), r.style.padding = "4px", r.style.width = "100%", r.style.boxSizing = "border-box", n.elementAttributes && typeof n.elementAttributes == "object")
    for (let o in n.elementAttributes)
      o.charAt(0) == "+" ? (o = o.slice(1), r.setAttribute(o, r.getAttribute(o) + n.elementAttributes["+" + o])) : r.setAttribute(o, n.elementAttributes[o]);
  r.value = i, t(function() {
    s.getType() === "cell" && (r.focus({ preventScroll: !0 }), r.style.height = "100%");
  });
  function l() {
    var o = r.value;
    !isNaN(o) && o !== "" && (o = Number(o)), o != i ? e(o) && (i = o) : a();
  }
  return r.addEventListener("blur", function(o) {
    l();
  }), r.addEventListener("keydown", function(o) {
    switch (o.keyCode) {
      case 13:
        l();
        break;
      case 27:
        a();
        break;
    }
  }), r;
}
function Z3(s, t, e, a, n) {
  var i = n.format, r = n.verticalNavigation || "editor", l = i ? window.DateTime || luxon.DateTime : null, o = s.getValue(), c = document.createElement("input");
  function d(h) {
    var g;
    return l.isDateTime(h) ? g = h : i === "iso" ? g = l.fromISO(String(h)) : g = l.fromFormat(String(h), i), g.toFormat("yyyy-MM-dd");
  }
  if (c.type = "date", c.style.padding = "4px", c.style.width = "100%", c.style.boxSizing = "border-box", n.max && c.setAttribute("max", i ? d(n.max) : n.max), n.min && c.setAttribute("min", i ? d(n.min) : n.min), n.elementAttributes && typeof n.elementAttributes == "object")
    for (let h in n.elementAttributes)
      h.charAt(0) == "+" ? (h = h.slice(1), c.setAttribute(h, c.getAttribute(h) + n.elementAttributes["+" + h])) : c.setAttribute(h, n.elementAttributes[h]);
  o = typeof o < "u" ? o : "", i && (l ? o = d(o) : console.error("Editor Error - 'date' editor 'format' param is dependant on luxon.js")), c.value = o, t(function() {
    s.getType() === "cell" && (c.focus({ preventScroll: !0 }), c.style.height = "100%", n.selectContents && c.select());
  });
  function p() {
    var h = c.value, g;
    if ((o === null || typeof o > "u") && h !== "" || h !== o) {
      if (h && i)
        switch (g = l.fromFormat(String(h), "yyyy-MM-dd"), i) {
          case !0:
            h = g;
            break;
          case "iso":
            h = g.toISO();
            break;
          default:
            h = g.toFormat(i);
        }
      e(h) && (o = c.value);
    } else
      a();
  }
  return c.addEventListener("blur", function(h) {
    (h.relatedTarget || h.rangeParent || h.explicitOriginalTarget !== c) && p();
  }), c.addEventListener("keydown", function(h) {
    switch (h.keyCode) {
      case 13:
        p();
        break;
      case 27:
        a();
        break;
      case 35:
      case 36:
        h.stopPropagation();
        break;
      case 38:
      case 40:
        r == "editor" && (h.stopImmediatePropagation(), h.stopPropagation());
        break;
    }
  }), c;
}
function t4(s, t, e, a, n) {
  var i = n.format, r = n.verticalNavigation || "editor", l = i ? window.DateTime || luxon.DateTime : null, o, c = s.getValue(), d = document.createElement("input");
  if (d.type = "time", d.style.padding = "4px", d.style.width = "100%", d.style.boxSizing = "border-box", n.elementAttributes && typeof n.elementAttributes == "object")
    for (let h in n.elementAttributes)
      h.charAt(0) == "+" ? (h = h.slice(1), d.setAttribute(h, d.getAttribute(h) + n.elementAttributes["+" + h])) : d.setAttribute(h, n.elementAttributes[h]);
  c = typeof c < "u" ? c : "", i && (l ? (l.isDateTime(c) ? o = c : i === "iso" ? o = l.fromISO(String(c)) : o = l.fromFormat(String(c), i), c = o.toFormat("HH:mm")) : console.error("Editor Error - 'date' editor 'format' param is dependant on luxon.js")), console.log("val", c), d.value = c, t(function() {
    s.getType() == "cell" && (d.focus({ preventScroll: !0 }), d.style.height = "100%", n.selectContents && d.select());
  });
  function p() {
    var h = d.value, g;
    if ((c === null || typeof c > "u") && h !== "" || h !== c) {
      if (h && i)
        switch (g = l.fromFormat(String(h), "hh:mm"), i) {
          case !0:
            h = g;
            break;
          case "iso":
            h = g.toISO();
            break;
          default:
            h = g.toFormat(i);
        }
      e(h) && (c = d.value);
    } else
      a();
  }
  return d.addEventListener("blur", function(h) {
    (h.relatedTarget || h.rangeParent || h.explicitOriginalTarget !== d) && p();
  }), d.addEventListener("keydown", function(h) {
    switch (h.keyCode) {
      case 13:
        p();
        break;
      case 27:
        a();
        break;
      case 35:
      case 36:
        h.stopPropagation();
        break;
      case 38:
      case 40:
        r == "editor" && (h.stopImmediatePropagation(), h.stopPropagation());
        break;
    }
  }), d;
}
function e4(s, t, e, a, n) {
  var i = n.format, r = n.verticalNavigation || "editor", l = i ? window.DateTime || luxon.DateTime : null, o, c = s.getValue(), d = document.createElement("input");
  if (d.type = "datetime-local", d.style.padding = "4px", d.style.width = "100%", d.style.boxSizing = "border-box", n.elementAttributes && typeof n.elementAttributes == "object")
    for (let h in n.elementAttributes)
      h.charAt(0) == "+" ? (h = h.slice(1), d.setAttribute(h, d.getAttribute(h) + n.elementAttributes["+" + h])) : d.setAttribute(h, n.elementAttributes[h]);
  c = typeof c < "u" ? c : "", i && (l ? (l.isDateTime(c) ? o = c : i === "iso" ? o = l.fromISO(String(c)) : o = l.fromFormat(String(c), i), c = o.toFormat("yyyy-MM-dd") + "T" + o.toFormat("HH:mm")) : console.error("Editor Error - 'date' editor 'format' param is dependant on luxon.js")), d.value = c, t(function() {
    s.getType() === "cell" && (d.focus({ preventScroll: !0 }), d.style.height = "100%", n.selectContents && d.select());
  });
  function p() {
    var h = d.value, g;
    if ((c === null || typeof c > "u") && h !== "" || h !== c) {
      if (h && i)
        switch (g = l.fromISO(String(h)), i) {
          case !0:
            h = g;
            break;
          case "iso":
            h = g.toISO();
            break;
          default:
            h = g.toFormat(i);
        }
      e(h) && (c = d.value);
    } else
      a();
  }
  return d.addEventListener("blur", function(h) {
    (h.relatedTarget || h.rangeParent || h.explicitOriginalTarget !== d) && p();
  }), d.addEventListener("keydown", function(h) {
    switch (h.keyCode) {
      case 13:
        p();
        break;
      case 27:
        a();
        break;
      case 35:
      case 36:
        h.stopPropagation();
        break;
      case 38:
      case 40:
        r == "editor" && (h.stopImmediatePropagation(), h.stopPropagation());
        break;
    }
  }), d;
}
class RA {
  constructor(t, e, a, n, i, r) {
    this.edit = t, this.table = t.table, this.cell = e, this.params = this._initializeParams(r), this.data = [], this.displayItems = [], this.currentItems = [], this.focusedItem = null, this.input = this._createInputElement(), this.listEl = this._createListElement(), this.initialValues = null, this.isFilter = e.getType() === "header", this.filterTimeout = null, this.filtered = !1, this.typing = !1, this.values = [], this.popup = null, this.listIteration = 0, this.lastAction = "", this.filterTerm = "", this.blurable = !0, this.actions = {
      success: n,
      cancel: i
    }, this._deprecatedOptionsCheck(), this._initializeValue(), a(this._onRendered.bind(this));
  }
  _deprecatedOptionsCheck() {
    this.params.listItemFormatter && this.cell.getTable().deprecationAdvisor.msg("The listItemFormatter editor param has been deprecated, please see the latest editor documentation for updated options"), this.params.sortValuesList && this.cell.getTable().deprecationAdvisor.msg("The sortValuesList editor param has been deprecated, please see the latest editor documentation for updated options"), this.params.searchFunc && this.cell.getTable().deprecationAdvisor.msg("The searchFunc editor param has been deprecated, please see the latest editor documentation for updated options"), this.params.searchingPlaceholder && this.cell.getTable().deprecationAdvisor.msg("The searchingPlaceholder editor param has been deprecated, please see the latest editor documentation for updated options");
  }
  _initializeValue() {
    var t = this.cell.getValue();
    typeof t > "u" && typeof this.params.defaultValue < "u" && (t = this.params.defaultValue), this.initialValues = this.params.multiselect ? t : [t], this.isFilter && (this.input.value = this.initialValues ? this.initialValues.join(",") : "", this.headerFilterInitialListGen());
  }
  _onRendered() {
    var t = this.cell.getElement();
    function e(a) {
      a.stopPropagation();
    }
    this.isFilter || (this.input.style.height = "100%", this.input.focus({ preventScroll: !0 })), t.addEventListener("click", e), setTimeout(() => {
      t.removeEventListener("click", e);
    }, 1e3), this.input.addEventListener("mousedown", this._preventPopupBlur.bind(this));
  }
  _createListElement() {
    var t = document.createElement("div");
    return t.classList.add("tabulator-edit-list"), t.addEventListener("mousedown", this._preventBlur.bind(this)), t.addEventListener("keydown", this._inputKeyDown.bind(this)), t;
  }
  _setListWidth() {
    var t = this.isFilter ? this.input : this.cell.getElement();
    this.listEl.style.minWidth = t.offsetWidth + "px", this.params.maxWidth && (this.params.maxWidth === !0 ? this.listEl.style.maxWidth = t.offsetWidth + "px" : typeof this.params.maxWidth == "number" ? this.listEl.style.maxWidth = this.params.maxWidth + "px" : this.listEl.style.maxWidth = this.params.maxWidth);
  }
  _createInputElement() {
    var t = this.params.elementAttributes, e = document.createElement("input");
    if (e.setAttribute("type", this.params.clearable ? "search" : "text"), e.style.padding = "4px", e.style.width = "100%", e.style.boxSizing = "border-box", this.params.autocomplete || (e.style.cursor = "default", e.style.caretColor = "transparent"), t && typeof t == "object")
      for (let a in t)
        a.charAt(0) == "+" ? (a = a.slice(1), e.setAttribute(a, e.getAttribute(a) + t["+" + a])) : e.setAttribute(a, t[a]);
    return this.params.mask && bf(e, this.params), this._bindInputEvents(e), e;
  }
  _initializeParams(t) {
    var e = ["values", "valuesURL", "valuesLookup"], a;
    return t = Object.assign({}, t), t.verticalNavigation = t.verticalNavigation || "editor", t.placeholderLoading = typeof t.placeholderLoading > "u" ? "Searching ..." : t.placeholderLoading, t.placeholderEmpty = typeof t.placeholderEmpty > "u" ? "No Results Found" : t.placeholderEmpty, t.filterDelay = typeof t.filterDelay > "u" ? 300 : t.filterDelay, t.emptyValue = Object.keys(t).includes("emptyValue") ? t.emptyValue : "", a = Object.keys(t).filter((n) => e.includes(n)).length, a ? a > 1 && console.warn("list editor config error - only one of the values, valuesURL, or valuesLookup options can be set on the same editor") : console.warn("list editor config error - either the values, valuesURL, or valuesLookup option must be set"), t.autocomplete ? t.multiselect && (t.multiselect = !1, console.warn("list editor config error - multiselect option is not available when autocomplete is enabled")) : (t.freetext && (t.freetext = !1, console.warn("list editor config error - freetext option is only available when autocomplete is enabled")), t.filterFunc && (t.filterFunc = !1, console.warn("list editor config error - filterFunc option is only available when autocomplete is enabled")), t.filterRemote && (t.filterRemote = !1, console.warn("list editor config error - filterRemote option is only available when autocomplete is enabled")), t.mask && (t.mask = !1, console.warn("list editor config error - mask option is only available when autocomplete is enabled")), t.allowEmpty && (t.allowEmpty = !1, console.warn("list editor config error - allowEmpty option is only available when autocomplete is enabled")), t.listOnEmpty && (t.listOnEmpty = !1, console.warn("list editor config error - listOnEmpty option is only available when autocomplete is enabled"))), t.filterRemote && !(typeof t.valuesLookup == "function" || t.valuesURL) && (t.filterRemote = !1, console.warn("list editor config error - filterRemote option should only be used when values list is populated from a remote source")), t;
  }
  //////////////////////////////////////
  ////////// Event Handling ////////////
  //////////////////////////////////////
  _bindInputEvents(t) {
    t.addEventListener("focus", this._inputFocus.bind(this)), t.addEventListener("click", this._inputClick.bind(this)), t.addEventListener("blur", this._inputBlur.bind(this)), t.addEventListener("keydown", this._inputKeyDown.bind(this)), t.addEventListener("search", this._inputSearch.bind(this)), this.params.autocomplete && t.addEventListener("keyup", this._inputKeyUp.bind(this));
  }
  _inputFocus(t) {
    this.rebuildOptionsList();
  }
  _filter() {
    this.params.filterRemote ? (clearTimeout(this.filterTimeout), this.filterTimeout = setTimeout(() => {
      this.rebuildOptionsList();
    }, this.params.filterDelay)) : this._filterList();
  }
  _inputClick(t) {
    t.stopPropagation();
  }
  _inputBlur(t) {
    this.blurable && (this.popup ? this.popup.hide() : this._resolveValue(!0));
  }
  _inputSearch() {
    this._clearChoices();
  }
  _inputKeyDown(t) {
    switch (t.keyCode) {
      case 38:
        this._keyUp(t);
        break;
      case 40:
        this._keyDown(t);
        break;
      case 37:
      case 39:
        this._keySide(t);
        break;
      case 13:
        this._keyEnter();
        break;
      case 27:
        this._keyEsc();
        break;
      case 36:
      case 35:
        this._keyHomeEnd(t);
        break;
      case 9:
        this._keyTab(t);
        break;
      default:
        this._keySelectLetter(t);
    }
  }
  _inputKeyUp(t) {
    switch (t.keyCode) {
      case 38:
      case 37:
      case 39:
      case 40:
      case 13:
      case 27:
        break;
      default:
        this._keyAutoCompLetter(t);
    }
  }
  _preventPopupBlur() {
    this.popup && this.popup.blockHide(), setTimeout(() => {
      this.popup && this.popup.restoreHide();
    }, 10);
  }
  _preventBlur() {
    this.blurable = !1, setTimeout(() => {
      this.blurable = !0;
    }, 10);
  }
  //////////////////////////////////////
  //////// Keyboard Navigation /////////
  //////////////////////////////////////
  _keyTab(t) {
    this.params.autocomplete && this.lastAction === "typing" ? this._resolveValue(!0) : this.focusedItem && this._chooseItem(this.focusedItem, !0);
  }
  _keyUp(t) {
    var e = this.displayItems.indexOf(this.focusedItem);
    (this.params.verticalNavigation == "editor" || this.params.verticalNavigation == "hybrid" && e) && (t.stopImmediatePropagation(), t.stopPropagation(), t.preventDefault(), e > 0 && this._focusItem(this.displayItems[e - 1]));
  }
  _keyDown(t) {
    var e = this.displayItems.indexOf(this.focusedItem);
    (this.params.verticalNavigation == "editor" || this.params.verticalNavigation == "hybrid" && e < this.displayItems.length - 1) && (t.stopImmediatePropagation(), t.stopPropagation(), t.preventDefault(), e < this.displayItems.length - 1 && (e == -1 ? this._focusItem(this.displayItems[0]) : this._focusItem(this.displayItems[e + 1])));
  }
  _keySide(t) {
    this.params.autocomplete || (t.stopImmediatePropagation(), t.stopPropagation(), t.preventDefault());
  }
  _keyEnter(t) {
    this.params.autocomplete && this.lastAction === "typing" ? this._resolveValue(!0) : this.focusedItem && this._chooseItem(this.focusedItem);
  }
  _keyEsc(t) {
    this._cancel();
  }
  _keyHomeEnd(t) {
    this.params.autocomplete && t.stopImmediatePropagation();
  }
  _keySelectLetter(t) {
    this.params.autocomplete || (t.preventDefault(), t.keyCode >= 38 && t.keyCode <= 90 && this._scrollToValue(t.keyCode));
  }
  _keyAutoCompLetter(t) {
    this._filter(), this.lastAction = "typing", this.typing = !0;
  }
  _scrollToValue(t) {
    clearTimeout(this.filterTimeout);
    var e = String.fromCharCode(t).toLowerCase();
    this.filterTerm += e.toLowerCase();
    var a = this.displayItems.find((n) => typeof n.label < "u" && n.label.toLowerCase().startsWith(this.filterTerm));
    a && this._focusItem(a), this.filterTimeout = setTimeout(() => {
      this.filterTerm = "";
    }, 800);
  }
  _focusItem(t) {
    this.lastAction = "focus", this.focusedItem && this.focusedItem.element && this.focusedItem.element.classList.remove("focused"), this.focusedItem = t, t && t.element && (t.element.classList.add("focused"), t.element.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "start" }));
  }
  //////////////////////////////////////
  /////// Data List Generation /////////
  //////////////////////////////////////
  headerFilterInitialListGen() {
    this._generateOptions(!0);
  }
  rebuildOptionsList() {
    this._generateOptions().then(this._sortOptions.bind(this)).then(this._buildList.bind(this)).then(this._showList.bind(this)).catch((t) => {
      Number.isInteger(t) || console.error("List generation error", t);
    });
  }
  _filterList() {
    this._buildList(this._filterOptions()), this._showList();
  }
  _generateOptions(t) {
    var e = [], a = ++this.listIteration;
    return this.filtered = !1, this.params.values ? e = this.params.values : this.params.valuesURL ? e = this._ajaxRequest(this.params.valuesURL, this.input.value) : typeof this.params.valuesLookup == "function" ? e = this.params.valuesLookup(this.cell, this.input.value) : this.params.valuesLookup && (e = this._uniqueColumnValues(this.params.valuesLookupField)), e instanceof Promise ? (t || this._addPlaceholder(this.params.placeholderLoading), e.then().then((n) => this.listIteration === a ? this._parseList(n) : Promise.reject(a))) : Promise.resolve(this._parseList(e));
  }
  _addPlaceholder(t) {
    var e = document.createElement("div");
    typeof t == "function" && (t = t(this.cell.getComponent(), this.listEl)), t && (this._clearList(), t instanceof HTMLElement ? e = t : (e.classList.add("tabulator-edit-list-placeholder"), e.innerHTML = t), this.listEl.appendChild(e), this._showList());
  }
  _ajaxRequest(t, e) {
    var a = this.params.filterRemote ? { term: e } : {};
    return t = XN(t, {}, a), fetch(t).then((n) => n.ok ? n.json().catch((i) => (console.warn("List Ajax Load Error - Invalid JSON returned", i), Promise.reject(i))) : (console.error("List Ajax Load Error - Connection Error: " + n.status, n.statusText), Promise.reject(n))).catch((n) => (console.error("List Ajax Load Error - Connection Error: ", n), Promise.reject(n)));
  }
  _uniqueColumnValues(t) {
    var e = {}, a = this.table.getData(this.params.valuesLookup), n;
    return t ? n = this.table.columnManager.getColumnByField(t) : n = this.cell.getColumn()._getSelf(), n ? a.forEach((i) => {
      var r = n.getFieldValue(i);
      r !== null && typeof r < "u" && r !== "" && (e[r] = !0);
    }) : (console.warn("unable to find matching column to create select lookup list:", t), e = []), Object.keys(e);
  }
  _parseList(t) {
    var e = [];
    return Array.isArray(t) || (t = Object.entries(t).map(([a, n]) => ({
      label: n,
      value: a
    }))), t.forEach((a) => {
      typeof a != "object" && (a = {
        label: a,
        value: a
      }), this._parseListItem(a, e, 0);
    }), !this.currentItems.length && this.params.freetext && (this.input.value = this.initialValues, this.typing = !0, this.lastAction = "typing"), this.data = e, e;
  }
  _parseListItem(t, e, a) {
    var n = {};
    t.options ? n = this._parseListGroup(t, a + 1) : (n = {
      label: t.label,
      value: t.value,
      itemParams: t.itemParams,
      elementAttributes: t.elementAttributes,
      element: !1,
      selected: !1,
      visible: !0,
      level: a,
      original: t
    }, this.initialValues && this.initialValues.indexOf(t.value) > -1 && this._chooseItem(n, !0)), e.push(n);
  }
  _parseListGroup(t, e) {
    var a = {
      label: t.label,
      group: !0,
      itemParams: t.itemParams,
      elementAttributes: t.elementAttributes,
      element: !1,
      visible: !0,
      level: e,
      options: [],
      original: t
    };
    return t.options.forEach((n) => {
      this._parseListItem(n, a.options, e);
    }), a;
  }
  _sortOptions(t) {
    var e;
    return this.params.sort && (e = typeof this.params.sort == "function" ? this.params.sort : this._defaultSortFunction.bind(this), this._sortGroup(e, t)), t;
  }
  _sortGroup(t, e) {
    e.sort((a, n) => t(a.label, n.label, a.value, n.value, a.original, n.original)), e.forEach((a) => {
      a.group && this._sortGroup(t, a.options);
    });
  }
  _defaultSortFunction(t, e) {
    var a, n, i, r, l = 0, o, c = /(\d+)|(\D+)/g, d = /\d/, p = 0;
    if (this.params.sort === "desc" && ([t, e] = [e, t]), !t && t !== 0)
      p = !e && e !== 0 ? 0 : -1;
    else if (!e && e !== 0)
      p = 1;
    else {
      if (isFinite(t) && isFinite(e))
        return t - e;
      if (a = String(t).toLowerCase(), n = String(e).toLowerCase(), a === n)
        return 0;
      if (!(d.test(a) && d.test(n)))
        return a > n ? 1 : -1;
      for (a = a.match(c), n = n.match(c), o = a.length > n.length ? n.length : a.length; l < o; )
        if (i = a[l], r = n[l++], i !== r)
          return isFinite(i) && isFinite(r) ? (i.charAt(0) === "0" && (i = "." + i), r.charAt(0) === "0" && (r = "." + r), i - r) : i > r ? 1 : -1;
      return a.length > n.length;
    }
    return p;
  }
  _filterOptions() {
    var t = this.params.filterFunc || this._defaultFilterFunc, e = this.input.value;
    return e ? (this.filtered = !0, this.data.forEach((a) => {
      this._filterItem(t, e, a);
    })) : this.filtered = !1, this.data;
  }
  _filterItem(t, e, a) {
    var n = !1;
    return a.group ? (a.options.forEach((i) => {
      this._filterItem(t, e, i) && (n = !0);
    }), a.visible = n) : a.visible = t(e, a.label, a.value, a.original), a.visible;
  }
  _defaultFilterFunc(t, e, a, n) {
    return t = String(t).toLowerCase(), e !== null && typeof e < "u" && (String(e).toLowerCase().indexOf(t) > -1 || String(a).toLowerCase().indexOf(t) > -1);
  }
  //////////////////////////////////////
  /////////// Display List /////////////
  //////////////////////////////////////
  _clearList() {
    for (; this.listEl.firstChild; )
      this.listEl.removeChild(this.listEl.firstChild);
    this.displayItems = [];
  }
  _buildList(t) {
    this._clearList(), t.forEach((e) => {
      this._buildItem(e);
    }), this.displayItems.length || this._addPlaceholder(this.params.placeholderEmpty);
  }
  _buildItem(t) {
    var e = t.element, a;
    if (!this.filtered || t.visible) {
      if (!e) {
        if (e = document.createElement("div"), e.tabIndex = 0, a = this.params.itemFormatter ? this.params.itemFormatter(t.label, t.value, t.original, e) : t.label, a instanceof HTMLElement ? e.appendChild(a) : e.innerHTML = a, t.group ? e.classList.add("tabulator-edit-list-group") : e.classList.add("tabulator-edit-list-item"), e.classList.add("tabulator-edit-list-group-level-" + t.level), t.elementAttributes && typeof t.elementAttributes == "object")
          for (let n in t.elementAttributes)
            n.charAt(0) == "+" ? (n = n.slice(1), e.setAttribute(n, this.input.getAttribute(n) + t.elementAttributes["+" + n])) : e.setAttribute(n, t.elementAttributes[n]);
        t.group ? e.addEventListener("click", this._groupClick.bind(this, t)) : e.addEventListener("click", this._itemClick.bind(this, t)), e.addEventListener("mousedown", this._preventBlur.bind(this)), t.element = e;
      }
      this._styleItem(t), this.listEl.appendChild(e), t.group ? t.options.forEach((n) => {
        this._buildItem(n);
      }) : this.displayItems.push(t);
    }
  }
  _showList() {
    var t = this.popup && this.popup.isVisible();
    if (this.input.parentNode) {
      if (this.params.autocomplete && this.input.value === "" && !this.params.listOnEmpty) {
        this.popup && this.popup.hide(!0);
        return;
      }
      this._setListWidth(), this.popup || (this.popup = this.edit.popup(this.listEl)), this.popup.show(this.cell.getElement(), "bottom"), t || setTimeout(() => {
        this.popup.hideOnBlur(this._resolveValue.bind(this, !0));
      }, 10);
    }
  }
  _styleItem(t) {
    t && t.element && (t.selected ? t.element.classList.add("active") : t.element.classList.remove("active"));
  }
  //////////////////////////////////////
  ///////// User Interaction ///////////
  //////////////////////////////////////
  _itemClick(t, e) {
    e.stopPropagation(), this._chooseItem(t);
  }
  _groupClick(t, e) {
    e.stopPropagation();
  }
  //////////////////////////////////////
  ////// Current Item Management ///////
  //////////////////////////////////////
  _cancel() {
    this.popup.hide(!0), this.actions.cancel();
  }
  _clearChoices() {
    this.typing = !0, this.currentItems.forEach((t) => {
      t.selected = !1, this._styleItem(t);
    }), this.currentItems = [], this.focusedItem = null;
  }
  _chooseItem(t, e) {
    var a;
    this.typing = !1, this.params.multiselect ? (a = this.currentItems.indexOf(t), a > -1 ? (this.currentItems.splice(a, 1), t.selected = !1) : (this.currentItems.push(t), t.selected = !0), this.input.value = this.currentItems.map((n) => n.label).join(","), this._styleItem(t)) : (this.currentItems = [t], t.selected = !0, this.input.value = t.label, this._styleItem(t), e || this._resolveValue()), this._focusItem(t);
  }
  _resolveValue(t) {
    var e, a;
    if (this.popup && this.popup.hide(!0), this.params.multiselect)
      e = this.currentItems.map((n) => n.value);
    else if (t && this.params.autocomplete && this.typing)
      if (this.params.freetext || this.params.allowEmpty && this.input.value === "")
        e = this.input.value;
      else {
        this.actions.cancel();
        return;
      }
    else
      this.currentItems[0] ? e = this.currentItems[0].value : (a = Array.isArray(this.initialValues) ? this.initialValues[0] : this.initialValues, a === null || typeof a > "u" || a === "" ? e = a : e = this.params.emptyValue);
    e === "" && (e = this.params.emptyValue), this.actions.success(e), this.isFilter && (this.initialValues = e && !Array.isArray(e) ? [e] : e, this.currentItems = []);
  }
}
function a4(s, t, e, a, n) {
  this.deprecationMsg("The select editor has been deprecated, please use the new list editor");
  var i = new RA(this, s, t, e, a, n);
  return i.input;
}
function n4(s, t, e, a, n) {
  var i = new RA(this, s, t, e, a, n);
  return i.input;
}
function s4(s, t, e, a, n) {
  this.deprecationMsg("The autocomplete editor has been deprecated, please use the new list editor with the 'autocomplete' editorParam"), n.autocomplete = !0;
  var i = new RA(this, s, t, e, a, n);
  return i.input;
}
function i4(s, t, e, a, n) {
  var i = this, r = s.getElement(), l = s.getValue(), o = r.getElementsByTagName("svg").length || 5, c = r.getElementsByTagName("svg")[0] ? r.getElementsByTagName("svg")[0].getAttribute("width") : 14, d = [], p = document.createElement("div"), h = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  function g(T) {
    d.forEach(function(R, C) {
      C < T ? (i.table.browser == "ie" ? R.setAttribute("class", "tabulator-star-active") : R.classList.replace("tabulator-star-inactive", "tabulator-star-active"), R.innerHTML = '<polygon fill="#488CE9" stroke="#014AAE" stroke-width="37.6152" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="259.216,29.942 330.27,173.919 489.16,197.007 374.185,309.08 401.33,467.31 259.216,392.612 117.104,467.31 144.25,309.08 29.274,197.007 188.165,173.919 "/>') : (i.table.browser == "ie" ? R.setAttribute("class", "tabulator-star-inactive") : R.classList.replace("tabulator-star-active", "tabulator-star-inactive"), R.innerHTML = '<polygon fill="#010155" stroke="#686868" stroke-width="37.6152" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="259.216,29.942 330.27,173.919 489.16,197.007 374.185,309.08 401.33,467.31 259.216,392.612 117.104,467.31 144.25,309.08 29.274,197.007 188.165,173.919 "/>');
    });
  }
  function x(T) {
    var R = document.createElement("span"), C = h.cloneNode(!0);
    d.push(C), R.addEventListener("mouseenter", function(v) {
      v.stopPropagation(), v.stopImmediatePropagation(), g(T);
    }), R.addEventListener("mousemove", function(v) {
      v.stopPropagation(), v.stopImmediatePropagation();
    }), R.addEventListener("click", function(v) {
      v.stopPropagation(), v.stopImmediatePropagation(), e(T), r.blur();
    }), R.appendChild(C), p.appendChild(R);
  }
  function b(T) {
    l = T, g(T);
  }
  if (r.style.whiteSpace = "nowrap", r.style.overflow = "hidden", r.style.textOverflow = "ellipsis", p.style.verticalAlign = "middle", p.style.display = "inline-block", p.style.padding = "4px", h.setAttribute("width", c), h.setAttribute("height", c), h.setAttribute("viewBox", "0 0 512 512"), h.setAttribute("xml:space", "preserve"), h.style.padding = "0 1px", n.elementAttributes && typeof n.elementAttributes == "object")
    for (let T in n.elementAttributes)
      T.charAt(0) == "+" ? (T = T.slice(1), p.setAttribute(T, p.getAttribute(T) + n.elementAttributes["+" + T])) : p.setAttribute(T, n.elementAttributes[T]);
  for (var A = 1; A <= o; A++)
    x(A);
  return l = Math.min(parseInt(l), o), g(l), p.addEventListener("mousemove", function(T) {
    g(0);
  }), p.addEventListener("click", function(T) {
    e(0);
  }), r.addEventListener("blur", function(T) {
    a();
  }), r.addEventListener("keydown", function(T) {
    switch (T.keyCode) {
      case 39:
        b(l + 1);
        break;
      case 37:
        b(l - 1);
        break;
      case 13:
        e(l);
        break;
      case 27:
        a();
        break;
    }
  }), p;
}
function r4(s, t, e, a, n) {
  var i = s.getElement(), r = typeof n.max > "u" ? i.getElementsByTagName("div")[0] && i.getElementsByTagName("div")[0].getAttribute("max") || 100 : n.max, l = typeof n.min > "u" ? i.getElementsByTagName("div")[0] && i.getElementsByTagName("div")[0].getAttribute("min") || 0 : n.min, o = (r - l) / 100, c = s.getValue() || 0, d = document.createElement("div"), p = document.createElement("div"), h, g;
  function x() {
    var b = window.getComputedStyle(i, null), A = o * Math.round(p.offsetWidth / ((i.clientWidth - parseInt(b.getPropertyValue("padding-left")) - parseInt(b.getPropertyValue("padding-right"))) / 100)) + l;
    e(A), i.setAttribute("aria-valuenow", A), i.setAttribute("aria-label", c);
  }
  if (d.style.position = "absolute", d.style.right = "0", d.style.top = "0", d.style.bottom = "0", d.style.width = "5px", d.classList.add("tabulator-progress-handle"), p.style.display = "inline-block", p.style.position = "relative", p.style.height = "100%", p.style.backgroundColor = "#488CE9", p.style.maxWidth = "100%", p.style.minWidth = "0%", n.elementAttributes && typeof n.elementAttributes == "object")
    for (let b in n.elementAttributes)
      b.charAt(0) == "+" ? (b = b.slice(1), p.setAttribute(b, p.getAttribute(b) + n.elementAttributes["+" + b])) : p.setAttribute(b, n.elementAttributes[b]);
  return i.style.padding = "4px 4px", c = Math.min(parseFloat(c), r), c = Math.max(parseFloat(c), l), c = Math.round((c - l) / o), p.style.width = c + "%", i.setAttribute("aria-valuemin", l), i.setAttribute("aria-valuemax", r), p.appendChild(d), d.addEventListener("mousedown", function(b) {
    h = b.screenX, g = p.offsetWidth;
  }), d.addEventListener("mouseover", function() {
    d.style.cursor = "ew-resize";
  }), i.addEventListener("mousemove", function(b) {
    h && (p.style.width = g + b.screenX - h + "px");
  }), i.addEventListener("mouseup", function(b) {
    h && (b.stopPropagation(), b.stopImmediatePropagation(), h = !1, g = !1, x());
  }), i.addEventListener("keydown", function(b) {
    switch (b.keyCode) {
      case 39:
        b.preventDefault(), p.style.width = p.clientWidth + i.clientWidth / 100 + "px";
        break;
      case 37:
        b.preventDefault(), p.style.width = p.clientWidth - i.clientWidth / 100 + "px";
        break;
      case 9:
      case 13:
        x();
        break;
      case 27:
        a();
        break;
    }
  }), i.addEventListener("blur", function() {
    a();
  }), p;
}
function l4(s, t, e, a, n) {
  var i = s.getValue(), r = document.createElement("input"), l = n.tristate, o = typeof n.indeterminateValue > "u" ? null : n.indeterminateValue, c = !1, d = Object.keys(n).includes("trueValue"), p = Object.keys(n).includes("falseValue");
  if (r.setAttribute("type", "checkbox"), r.style.marginTop = "5px", r.style.boxSizing = "border-box", n.elementAttributes && typeof n.elementAttributes == "object")
    for (let g in n.elementAttributes)
      g.charAt(0) == "+" ? (g = g.slice(1), r.setAttribute(g, r.getAttribute(g) + n.elementAttributes["+" + g])) : r.setAttribute(g, n.elementAttributes[g]);
  r.value = i, l && (typeof i > "u" || i === o || i === "") && (c = !0, r.indeterminate = !0), this.table.browser != "firefox" && this.table.browser != "safari" && t(function() {
    s.getType() === "cell" && r.focus({ preventScroll: !0 });
  }), r.checked = d ? i === n.trueValue : i === !0 || i === "true" || i === "True" || i === 1;
  function h(g) {
    var x = r.checked;
    return d && x ? x = n.trueValue : p && !x && (x = n.falseValue), l ? g ? c ? o : x : r.checked && !c ? (r.checked = !1, r.indeterminate = !0, c = !0, o) : (c = !1, x) : x;
  }
  return r.addEventListener("change", function(g) {
    e(h());
  }), r.addEventListener("blur", function(g) {
    e(h(!0));
  }), r.addEventListener("keydown", function(g) {
    g.keyCode == 13 && e(h()), g.keyCode == 27 && a();
  }), r;
}
var o4 = {
  input: q3,
  textarea: K3,
  number: J3,
  range: Q3,
  date: Z3,
  time: t4,
  datetime: e4,
  select: a4,
  list: n4,
  autocomplete: s4,
  star: i4,
  progress: r4,
  tickCross: l4
};
class ep extends Ze {
  constructor(t) {
    super(t), this.currentCell = !1, this.mouseClick = !1, this.recursionBlock = !1, this.invalidEdit = !1, this.editedCells = [], this.editors = ep.editors, this.registerColumnOption("editable"), this.registerColumnOption("editor"), this.registerColumnOption("editorParams"), this.registerColumnOption("cellEditing"), this.registerColumnOption("cellEdited"), this.registerColumnOption("cellEditCancelled"), this.registerTableOption("editTriggerEvent", "focus"), this.registerTableFunction("getEditedCells", this.getEditedCells.bind(this)), this.registerTableFunction("clearCellEdited", this.clearCellEdited.bind(this)), this.registerTableFunction("navigatePrev", this.navigatePrev.bind(this)), this.registerTableFunction("navigateNext", this.navigateNext.bind(this)), this.registerTableFunction("navigateLeft", this.navigateLeft.bind(this)), this.registerTableFunction("navigateRight", this.navigateRight.bind(this)), this.registerTableFunction("navigateUp", this.navigateUp.bind(this)), this.registerTableFunction("navigateDown", this.navigateDown.bind(this)), this.registerComponentFunction("cell", "isEdited", this.cellIsEdited.bind(this)), this.registerComponentFunction("cell", "clearEdited", this.clearEdited.bind(this)), this.registerComponentFunction("cell", "edit", this.editCell.bind(this)), this.registerComponentFunction("cell", "cancelEdit", this.cellCancelEdit.bind(this)), this.registerComponentFunction("cell", "navigatePrev", this.navigatePrev.bind(this)), this.registerComponentFunction("cell", "navigateNext", this.navigateNext.bind(this)), this.registerComponentFunction("cell", "navigateLeft", this.navigateLeft.bind(this)), this.registerComponentFunction("cell", "navigateRight", this.navigateRight.bind(this)), this.registerComponentFunction("cell", "navigateUp", this.navigateUp.bind(this)), this.registerComponentFunction("cell", "navigateDown", this.navigateDown.bind(this));
  }
  initialize() {
    this.subscribe("cell-init", this.bindEditor.bind(this)), this.subscribe("cell-delete", this.clearEdited.bind(this)), this.subscribe("cell-value-changed", this.updateCellClass.bind(this)), this.subscribe("column-layout", this.initializeColumnCheck.bind(this)), this.subscribe("column-delete", this.columnDeleteCheck.bind(this)), this.subscribe("row-deleting", this.rowDeleteCheck.bind(this)), this.subscribe("row-layout", this.rowEditableCheck.bind(this)), this.subscribe("data-refreshing", this.cancelEdit.bind(this)), this.subscribe("clipboard-paste", this.pasteBlocker.bind(this)), this.subscribe("keybinding-nav-prev", this.navigatePrev.bind(this, void 0)), this.subscribe("keybinding-nav-next", this.keybindingNavigateNext.bind(this)), this.subscribe("keybinding-nav-up", this.navigateUp.bind(this, void 0)), this.subscribe("keybinding-nav-down", this.navigateDown.bind(this, void 0));
  }
  ///////////////////////////////////
  ///////// Paste Negation //////////
  ///////////////////////////////////
  pasteBlocker(t) {
    if (this.currentCell)
      return !0;
  }
  ///////////////////////////////////
  ////// Keybinding Functions ///////
  ///////////////////////////////////
  keybindingNavigateNext(t) {
    var e = this.currentCell, a = this.options("tabEndNewRow");
    e && (this.navigateNext(e, t) || a && (e.getElement().firstChild.blur(), this.invalidEdit || (a === !0 ? a = this.table.addRow({}) : typeof a == "function" ? a = this.table.addRow(a(e.row.getComponent())) : a = this.table.addRow(Object.assign({}, a)), a.then(() => {
      setTimeout(() => {
        e.getComponent().navigateNext();
      });
    }))));
  }
  ///////////////////////////////////
  ///////// Cell Functions //////////
  ///////////////////////////////////
  cellIsEdited(t) {
    return !!t.modules.edit && t.modules.edit.edited;
  }
  cellCancelEdit(t) {
    t === this.currentCell ? this.table.modules.edit.cancelEdit() : console.warn("Cancel Editor Error - This cell is not currently being edited ");
  }
  ///////////////////////////////////
  ///////// Table Functions /////////
  ///////////////////////////////////
  updateCellClass(t) {
    this.allowEdit(t) ? t.getElement().classList.add("tabulator-editable") : t.getElement().classList.remove("tabulator-editable");
  }
  clearCellEdited(t) {
    t || (t = this.table.modules.edit.getEditedCells()), Array.isArray(t) || (t = [t]), t.forEach((e) => {
      this.table.modules.edit.clearEdited(e._getSelf());
    });
  }
  navigatePrev(t = this.currentCell, e) {
    var a, n;
    if (t) {
      if (e && e.preventDefault(), a = this.navigateLeft(), a)
        return !0;
      if (n = this.table.rowManager.prevDisplayRow(t.row, !0), n && (a = this.findPrevEditableCell(n, n.cells.length), a))
        return a.getComponent().edit(), !0;
    }
    return !1;
  }
  navigateNext(t = this.currentCell, e) {
    var a, n;
    if (t) {
      if (e && e.preventDefault(), a = this.navigateRight(), a)
        return !0;
      if (n = this.table.rowManager.nextDisplayRow(t.row, !0), n && (a = this.findNextEditableCell(n, -1), a))
        return a.getComponent().edit(), !0;
    }
    return !1;
  }
  navigateLeft(t = this.currentCell, e) {
    var a, n;
    return t && (e && e.preventDefault(), a = t.getIndex(), n = this.findPrevEditableCell(t.row, a), n) ? (n.getComponent().edit(), !0) : !1;
  }
  navigateRight(t = this.currentCell, e) {
    var a, n;
    return t && (e && e.preventDefault(), a = t.getIndex(), n = this.findNextEditableCell(t.row, a), n) ? (n.getComponent().edit(), !0) : !1;
  }
  navigateUp(t = this.currentCell, e) {
    var a, n;
    return t && (e && e.preventDefault(), a = t.getIndex(), n = this.table.rowManager.prevDisplayRow(t.row, !0), n) ? (n.cells[a].getComponent().edit(), !0) : !1;
  }
  navigateDown(t = this.currentCell, e) {
    var a, n;
    return t && (e && e.preventDefault(), a = t.getIndex(), n = this.table.rowManager.nextDisplayRow(t.row, !0), n) ? (n.cells[a].getComponent().edit(), !0) : !1;
  }
  findNextEditableCell(t, e) {
    var a = !1;
    if (e < t.cells.length - 1)
      for (var n = e + 1; n < t.cells.length; n++) {
        let i = t.cells[n];
        if (i.column.modules.edit && za.elVisible(i.getElement()) && this.allowEdit(i)) {
          a = i;
          break;
        }
      }
    return a;
  }
  findPrevEditableCell(t, e) {
    var a = !1;
    if (e > 0)
      for (var n = e - 1; n >= 0; n--) {
        let i = t.cells[n];
        if (i.column.modules.edit && za.elVisible(i.getElement()) && this.allowEdit(i)) {
          a = i;
          break;
        }
      }
    return a;
  }
  ///////////////////////////////////
  ///////// Internal Logic //////////
  ///////////////////////////////////
  initializeColumnCheck(t) {
    typeof t.definition.editor < "u" && this.initializeColumn(t);
  }
  columnDeleteCheck(t) {
    this.currentCell && this.currentCell.column === t && this.cancelEdit();
  }
  rowDeleteCheck(t) {
    this.currentCell && this.currentCell.row === t && this.cancelEdit();
  }
  rowEditableCheck(t) {
    t.getCells().forEach((e) => {
      e.column.modules.edit && typeof e.column.modules.edit.check == "function" && this.updateCellClass(e);
    });
  }
  //initialize column editor
  initializeColumn(t) {
    var e = {
      editor: !1,
      blocked: !1,
      check: t.definition.editable,
      params: t.definition.editorParams || {}
    };
    switch (typeof t.definition.editor) {
      case "string":
        this.editors[t.definition.editor] ? e.editor = this.editors[t.definition.editor] : console.warn("Editor Error - No such editor found: ", t.definition.editor);
        break;
      case "function":
        e.editor = t.definition.editor;
        break;
      case "boolean":
        t.definition.editor === !0 && (typeof t.definition.formatter != "function" ? this.editors[t.definition.formatter] ? e.editor = this.editors[t.definition.formatter] : e.editor = this.editors.input : console.warn("Editor Error - Cannot auto lookup editor for a custom formatter: ", t.definition.formatter));
        break;
    }
    e.editor && (t.modules.edit = e);
  }
  getCurrentCell() {
    return this.currentCell ? this.currentCell.getComponent() : !1;
  }
  clearEditor(t) {
    var e = this.currentCell, a;
    if (this.invalidEdit = !1, e) {
      for (this.currentCell = !1, a = e.getElement(), this.dispatch("edit-editor-clear", e, t), a.classList.remove("tabulator-editing"); a.firstChild; )
        a.removeChild(a.firstChild);
      e.row.getElement().classList.remove("tabulator-editing"), e.table.element.classList.remove("tabulator-editing");
    }
  }
  cancelEdit() {
    if (this.currentCell) {
      var t = this.currentCell, e = this.currentCell.getComponent();
      this.clearEditor(!0), t.setValueActual(t.getValue()), t.cellRendered(), (t.column.definition.editor == "textarea" || t.column.definition.variableHeight) && t.row.normalizeHeight(!0), t.column.definition.cellEditCancelled && t.column.definition.cellEditCancelled.call(this.table, e), this.dispatch("edit-cancelled", t), this.dispatchExternal("cellEditCancelled", e);
    }
  }
  //return a formatted value for a cell
  bindEditor(t) {
    if (t.column.modules.edit) {
      var e = this, a = t.getElement(!0);
      this.updateCellClass(t), a.setAttribute("tabindex", 0), a.addEventListener("mousedown", function(n) {
        n.button === 2 ? n.preventDefault() : e.mouseClick = !0;
      }), this.options("editTriggerEvent") === "dblclick" && a.addEventListener("dblclick", function(n) {
        a.classList.contains("tabulator-editing") || (a.focus({ preventScroll: !0 }), e.edit(t, n, !1));
      }), (this.options("editTriggerEvent") === "focus" || this.options("editTriggerEvent") === "click") && a.addEventListener("click", function(n) {
        a.classList.contains("tabulator-editing") || (a.focus({ preventScroll: !0 }), e.edit(t, n, !1));
      }), this.options("editTriggerEvent") === "focus" && a.addEventListener("focus", function(n) {
        e.recursionBlock || e.edit(t, n, !1);
      });
    }
  }
  focusCellNoEvent(t, e) {
    this.recursionBlock = !0, e && this.table.browser === "ie" || t.getElement().focus({ preventScroll: !0 }), this.recursionBlock = !1;
  }
  editCell(t, e) {
    this.focusCellNoEvent(t), this.edit(t, !1, e);
  }
  focusScrollAdjust(t) {
    if (this.table.rowManager.getRenderMode() == "virtual") {
      var e = this.table.rowManager.element.scrollTop, a = this.table.rowManager.element.clientHeight + this.table.rowManager.element.scrollTop, n = t.row.getElement();
      n.offsetTop < e ? this.table.rowManager.element.scrollTop -= e - n.offsetTop : n.offsetTop + n.offsetHeight > a && (this.table.rowManager.element.scrollTop += n.offsetTop + n.offsetHeight - a);
      var i = this.table.rowManager.element.scrollLeft, r = this.table.rowManager.element.clientWidth + this.table.rowManager.element.scrollLeft, l = t.getElement();
      this.table.modExists("frozenColumns") && (i += parseInt(this.table.modules.frozenColumns.leftMargin || 0), r -= parseInt(this.table.modules.frozenColumns.rightMargin || 0)), this.table.options.renderHorizontal === "virtual" && (i -= parseInt(this.table.columnManager.renderer.vDomPadLeft), r -= parseInt(this.table.columnManager.renderer.vDomPadLeft)), l.offsetLeft < i ? this.table.rowManager.element.scrollLeft -= i - l.offsetLeft : l.offsetLeft + l.offsetWidth > r && (this.table.rowManager.element.scrollLeft += l.offsetLeft + l.offsetWidth - r);
    }
  }
  allowEdit(t) {
    var e = !!t.column.modules.edit;
    if (t.column.modules.edit)
      switch (typeof t.column.modules.edit.check) {
        case "function":
          t.row.initialized && (e = t.column.modules.edit.check(t.getComponent()));
          break;
        case "string":
          e = !!t.row.data[t.column.modules.edit.check];
          break;
        case "boolean":
          e = t.column.modules.edit.check;
          break;
      }
    return e;
  }
  edit(t, e, a) {
    var n = this, i = !0, r = function() {
    }, l = t.getElement(), o = !1, c, d, p;
    if (this.currentCell) {
      !this.invalidEdit && this.currentCell !== t && this.cancelEdit();
      return;
    }
    function h(T) {
      if (n.currentCell === t && !o) {
        var R = n.chain("edit-success", [t, T], !0, !0);
        return R === !0 || n.table.options.validationMode === "highlight" ? (o = !0, n.clearEditor(), t.modules.edit || (t.modules.edit = {}), t.modules.edit.edited = !0, n.editedCells.indexOf(t) == -1 && n.editedCells.push(t), t.setValue(T, !0), R === !0) : (o = !0, n.invalidEdit = !0, n.focusCellNoEvent(t, !0), r(), setTimeout(() => {
          o = !1;
        }, 10), !1);
      }
    }
    function g() {
      n.currentCell === t && !o && n.cancelEdit();
    }
    function x(T) {
      r = T;
    }
    if (t.column.modules.edit.blocked)
      return this.mouseClick = !1, this.blur(l), !1;
    if (e && e.stopPropagation(), i = this.allowEdit(t), i || a) {
      if (n.cancelEdit(), n.currentCell = t, this.focusScrollAdjust(t), d = t.getComponent(), this.mouseClick && (this.mouseClick = !1, t.column.definition.cellClick && t.column.definition.cellClick.call(this.table, e, d)), t.column.definition.cellEditing && t.column.definition.cellEditing.call(this.table, d), this.dispatch("cell-editing", t), this.dispatchExternal("cellEditing", d), p = typeof t.column.modules.edit.params == "function" ? t.column.modules.edit.params(d) : t.column.modules.edit.params, c = t.column.modules.edit.editor.call(n, d, x, h, g, p), this.currentCell && c !== !1)
        if (c instanceof Node) {
          for (l.classList.add("tabulator-editing"), t.row.getElement().classList.add("tabulator-editing"), t.table.element.classList.add("tabulator-editing"); l.firstChild; )
            l.removeChild(l.firstChild);
          l.appendChild(c), r();
          for (var b = l.children, A = 0; A < b.length; A++)
            b[A].addEventListener("click", function(T) {
              T.stopPropagation();
            });
        } else
          return console.warn("Edit Error - Editor should return an instance of Node, the editor returned:", c), this.blur(l), !1;
      else
        return this.blur(l), !1;
      return !0;
    } else
      return this.mouseClick = !1, this.blur(l), !1;
  }
  blur(t) {
    this.confirm("edit-blur", [t]) || t.blur();
  }
  getEditedCells() {
    var t = [];
    return this.editedCells.forEach((e) => {
      t.push(e.getComponent());
    }), t;
  }
  clearEdited(t) {
    var e;
    t.modules.edit && t.modules.edit.edited && (t.modules.edit.edited = !1, this.dispatch("edit-edited-clear", t)), e = this.editedCells.indexOf(t), e > -1 && this.editedCells.splice(e, 1);
  }
}
ep.moduleName = "edit";
ep.editors = o4;
class XI {
  constructor(t, e, a, n) {
    this.type = t, this.columns = e, this.component = a || !1, this.indent = n || 0;
  }
}
class av {
  constructor(t, e, a, n, i) {
    this.value = t, this.component = e || !1, this.width = a, this.height = n, this.depth = i;
  }
}
class zN extends Ze {
  constructor(t) {
    super(t), this.config = {}, this.cloneTableStyle = !0, this.colVisProp = "", this.registerTableOption("htmlOutputConfig", !1), this.registerColumnOption("htmlOutput"), this.registerColumnOption("titleHtmlOutput");
  }
  initialize() {
    this.registerTableFunction("getHtml", this.getHtml.bind(this));
  }
  ///////////////////////////////////
  ///////// Table Functions /////////
  ///////////////////////////////////
  ///////////////////////////////////
  ///////// Internal Logic //////////
  ///////////////////////////////////
  generateExportList(t, e, a, n) {
    this.cloneTableStyle = e, this.config = t || {}, this.colVisProp = n;
    var i, r;
    if (a === "range") {
      var l = this.table.modules.selectRange.selectedColumns();
      i = this.config.columnHeaders !== !1 ? this.headersToExportRows(this.generateColumnGroupHeaders(l)) : [], r = this.bodyToExportRows(this.rowLookup(a), this.table.modules.selectRange.selectedColumns(!0));
    } else
      i = this.config.columnHeaders !== !1 ? this.headersToExportRows(this.generateColumnGroupHeaders()) : [], r = this.bodyToExportRows(this.rowLookup(a));
    return i.concat(r);
  }
  generateTable(t, e, a, n) {
    var i = this.generateExportList(t, e, a, n);
    return this.generateTableElement(i);
  }
  rowLookup(t) {
    var e = [];
    if (typeof t == "function")
      t.call(this.table).forEach((a) => {
        a = this.table.rowManager.findRow(a), a && e.push(a);
      });
    else
      switch (t) {
        case !0:
        case "visible":
          e = this.table.rowManager.getVisibleRows(!1, !0);
          break;
        case "all":
          e = this.table.rowManager.rows;
          break;
        case "selected":
          e = this.table.modules.selectRow.selectedRows;
          break;
        case "range":
          e = this.table.modules.selectRange.selectedRows();
          break;
        case "active":
        default:
          this.table.options.pagination ? e = this.table.rowManager.getDisplayRows(this.table.rowManager.displayRows.length - 2) : e = this.table.rowManager.getDisplayRows();
      }
    return Object.assign([], e);
  }
  generateColumnGroupHeaders(t) {
    var e = [];
    return t || (t = this.config.columnGroups !== !1 ? this.table.columnManager.columns : this.table.columnManager.columnsByIndex), t.forEach((a) => {
      var n = this.processColumnGroup(a);
      n && e.push(n);
    }), e;
  }
  processColumnGroup(t) {
    var e = t.columns, a = 0, n = t.definition["title" + (this.colVisProp.charAt(0).toUpperCase() + this.colVisProp.slice(1))] || t.definition.title, i = {
      title: n,
      column: t,
      depth: 1
    };
    if (e.length) {
      if (i.subGroups = [], i.width = 0, e.forEach((r) => {
        var l = this.processColumnGroup(r);
        l && (i.width += l.width, i.subGroups.push(l), l.depth > a && (a = l.depth));
      }), i.depth += a, !i.width)
        return !1;
    } else if (this.columnVisCheck(t))
      i.width = 1;
    else
      return !1;
    return i;
  }
  columnVisCheck(t) {
    var e = t.definition[this.colVisProp];
    return typeof e == "function" && (e = e.call(this.table, t.getComponent())), e !== !1 && (t.visible || !t.visible && e);
  }
  headersToExportRows(t) {
    var e = [], a = 0, n = [];
    function i(r, l) {
      var o = a - l;
      if (typeof e[l] > "u" && (e[l] = []), r.height = r.subGroups ? 1 : o - r.depth + 1, e[l].push(r), r.height > 1)
        for (let c = 1; c < r.height; c++)
          typeof e[l + c] > "u" && (e[l + c] = []), e[l + c].push(!1);
      if (r.width > 1)
        for (let c = 1; c < r.width; c++)
          e[l].push(!1);
      r.subGroups && r.subGroups.forEach(function(c) {
        i(c, l + 1);
      });
    }
    return t.forEach(function(r) {
      r.depth > a && (a = r.depth);
    }), t.forEach(function(r) {
      i(r, 0);
    }), e.forEach((r) => {
      var l = [];
      r.forEach((o) => {
        if (o) {
          let c = typeof o.title > "u" ? "" : o.title;
          l.push(new av(c, o.column.getComponent(), o.width, o.height, o.depth));
        } else
          l.push(null);
      }), n.push(new XI("header", l));
    }), n;
  }
  bodyToExportRows(t, e = []) {
    var a = [];
    return e.length === 0 && this.table.columnManager.columnsByIndex.forEach((n) => {
      this.columnVisCheck(n) && e.push(n.getComponent());
    }), this.config.columnCalcs !== !1 && this.table.modExists("columnCalcs") && (this.table.modules.columnCalcs.topInitialized && t.unshift(this.table.modules.columnCalcs.topRow), this.table.modules.columnCalcs.botInitialized && t.push(this.table.modules.columnCalcs.botRow)), t = t.filter((n) => {
      switch (n.type) {
        case "group":
          return this.config.rowGroups !== !1;
        case "calc":
          return this.config.columnCalcs !== !1;
        case "row":
          return !(this.table.options.dataTree && this.config.dataTree === !1 && n.modules.dataTree.parent);
      }
      return !0;
    }), t.forEach((n, i) => {
      var r = n.getData(this.colVisProp), l = [], o = 0;
      switch (n.type) {
        case "group":
          o = n.level, l.push(new av(n.key, n.getComponent(), e.length, 1));
          break;
        case "calc":
        case "row":
          e.forEach((c) => {
            l.push(new av(c._column.getFieldValue(r), c, 1, 1));
          }), this.table.options.dataTree && this.config.dataTree !== !1 && (o = n.modules.dataTree.index);
          break;
      }
      a.push(new XI(n.type, l, n.getComponent(), o));
    }), a;
  }
  generateTableElement(t) {
    var e = document.createElement("table"), a = document.createElement("thead"), n = document.createElement("tbody"), i = this.lookupTableStyles(), r = this.table.options["rowFormatter" + (this.colVisProp.charAt(0).toUpperCase() + this.colVisProp.slice(1))], l = {};
    return l.rowFormatter = r !== null ? r : this.table.options.rowFormatter, this.table.options.dataTree && this.config.dataTree !== !1 && this.table.modExists("columnCalcs") && (l.treeElementField = this.table.modules.dataTree.elementField), l.groupHeader = this.table.options["groupHeader" + (this.colVisProp.charAt(0).toUpperCase() + this.colVisProp.slice(1))], l.groupHeader && !Array.isArray(l.groupHeader) && (l.groupHeader = [l.groupHeader]), e.classList.add("tabulator-print-table"), this.mapElementStyles(this.table.columnManager.getHeadersElement(), a, ["border-top", "border-left", "border-right", "border-bottom", "background-color", "color", "font-weight", "font-family", "font-size"]), t.length > 1e3 && console.warn("It may take a long time to render an HTML table with more than 1000 rows"), t.forEach((o, c) => {
      let d;
      switch (o.type) {
        case "header":
          a.appendChild(this.generateHeaderElement(o, l, i));
          break;
        case "group":
          n.appendChild(this.generateGroupElement(o, l, i));
          break;
        case "calc":
          n.appendChild(this.generateCalcElement(o, l, i));
          break;
        case "row":
          d = this.generateRowElement(o, l, i), this.mapElementStyles(c % 2 && i.evenRow ? i.evenRow : i.oddRow, d, ["border-top", "border-left", "border-right", "border-bottom", "color", "font-weight", "font-family", "font-size", "background-color"]), n.appendChild(d);
          break;
      }
    }), a.innerHTML && e.appendChild(a), e.appendChild(n), this.mapElementStyles(this.table.element, e, ["border-top", "border-left", "border-right", "border-bottom"]), e;
  }
  lookupTableStyles() {
    var t = {};
    return this.cloneTableStyle && window.getComputedStyle && (t.oddRow = this.table.element.querySelector(".tabulator-row-odd:not(.tabulator-group):not(.tabulator-calcs)"), t.evenRow = this.table.element.querySelector(".tabulator-row-even:not(.tabulator-group):not(.tabulator-calcs)"), t.calcRow = this.table.element.querySelector(".tabulator-row.tabulator-calcs"), t.firstRow = this.table.element.querySelector(".tabulator-row:not(.tabulator-group):not(.tabulator-calcs)"), t.firstGroup = this.table.element.getElementsByClassName("tabulator-group")[0], t.firstRow && (t.styleCells = t.firstRow.getElementsByClassName("tabulator-cell"), t.firstCell = t.styleCells[0], t.lastCell = t.styleCells[t.styleCells.length - 1])), t;
  }
  generateHeaderElement(t, e, a) {
    var n = document.createElement("tr");
    return t.columns.forEach((i) => {
      if (i) {
        var r = document.createElement("th"), l = i.component._column.definition.cssClass ? i.component._column.definition.cssClass.split(" ") : [];
        r.colSpan = i.width, r.rowSpan = i.height, r.innerHTML = i.value, this.cloneTableStyle && (r.style.boxSizing = "border-box"), l.forEach(function(o) {
          r.classList.add(o);
        }), this.mapElementStyles(i.component.getElement(), r, ["text-align", "border-top", "border-left", "border-right", "border-bottom", "background-color", "color", "font-weight", "font-family", "font-size"]), this.mapElementStyles(i.component._column.contentElement, r, ["padding-top", "padding-left", "padding-right", "padding-bottom"]), i.component._column.visible ? this.mapElementStyles(i.component.getElement(), r, ["width"]) : i.component._column.definition.width && (r.style.width = i.component._column.definition.width + "px"), i.component._column.parent && this.mapElementStyles(i.component._column.parent.groupElement, r, ["border-top"]), n.appendChild(r);
      }
    }), n;
  }
  generateGroupElement(t, e, a) {
    var n = document.createElement("tr"), i = document.createElement("td"), r = t.columns[0];
    return n.classList.add("tabulator-print-table-row"), e.groupHeader && e.groupHeader[t.indent] ? r.value = e.groupHeader[t.indent](r.value, t.component._group.getRowCount(), t.component._group.getData(), t.component) : e.groupHeader !== !1 && (r.value = t.component._group.generator(r.value, t.component._group.getRowCount(), t.component._group.getData(), t.component)), i.colSpan = r.width, i.innerHTML = r.value, n.classList.add("tabulator-print-table-group"), n.classList.add("tabulator-group-level-" + t.indent), r.component.isVisible() && n.classList.add("tabulator-group-visible"), this.mapElementStyles(a.firstGroup, n, ["border-top", "border-left", "border-right", "border-bottom", "color", "font-weight", "font-family", "font-size", "background-color"]), this.mapElementStyles(a.firstGroup, i, ["padding-top", "padding-left", "padding-right", "padding-bottom"]), n.appendChild(i), n;
  }
  generateCalcElement(t, e, a) {
    var n = this.generateRowElement(t, e, a);
    return n.classList.add("tabulator-print-table-calcs"), this.mapElementStyles(a.calcRow, n, ["border-top", "border-left", "border-right", "border-bottom", "color", "font-weight", "font-family", "font-size", "background-color"]), n;
  }
  generateRowElement(t, e, a) {
    var n = document.createElement("tr");
    if (n.classList.add("tabulator-print-table-row"), t.columns.forEach((i, r) => {
      if (i) {
        var l = document.createElement("td"), o = i.component._column, c = this.table, d = c.columnManager.findColumnIndex(o), p = i.value, h, g = {
          modules: {},
          getValue: function() {
            return p;
          },
          getField: function() {
            return o.definition.field;
          },
          getElement: function() {
            return l;
          },
          getType: function() {
            return "cell";
          },
          getColumn: function() {
            return o.getComponent();
          },
          getData: function() {
            return t.component.getData();
          },
          getRow: function() {
            return t.component;
          },
          getTable: function() {
            return c;
          },
          getComponent: function() {
            return g;
          },
          column: o
        }, x = o.definition.cssClass ? o.definition.cssClass.split(" ") : [];
        if (x.forEach(function(b) {
          l.classList.add(b);
        }), this.table.modExists("format") && this.config.formatCells !== !1)
          p = this.table.modules.format.formatExportValue(g, this.colVisProp);
        else
          switch (typeof p) {
            case "object":
              p = p !== null ? JSON.stringify(p) : "";
              break;
            case "undefined":
              p = "";
              break;
          }
        p instanceof Node ? l.appendChild(p) : l.innerHTML = p, h = a.styleCells && a.styleCells[d] ? a.styleCells[d] : a.firstCell, h && (this.mapElementStyles(h, l, ["padding-top", "padding-left", "padding-right", "padding-bottom", "border-top", "border-left", "border-right", "border-bottom", "color", "font-weight", "font-family", "font-size", "text-align"]), o.definition.align && (l.style.textAlign = o.definition.align)), this.table.options.dataTree && this.config.dataTree !== !1 && (e.treeElementField && e.treeElementField == o.field || !e.treeElementField && r == 0) && (t.component._row.modules.dataTree.controlEl && l.insertBefore(t.component._row.modules.dataTree.controlEl.cloneNode(!0), l.firstChild), t.component._row.modules.dataTree.branchEl && l.insertBefore(t.component._row.modules.dataTree.branchEl.cloneNode(!0), l.firstChild)), n.appendChild(l), g.modules.format && g.modules.format.renderedCallback && g.modules.format.renderedCallback();
      }
    }), e.rowFormatter && t.type === "row" && this.config.formatCells !== !1) {
      let i = Object.assign(t.component);
      i.getElement = function() {
        return n;
      }, e.rowFormatter(t.component);
    }
    return n;
  }
  generateHTMLTable(t) {
    var e = document.createElement("div");
    return e.appendChild(this.generateTableElement(t)), e.innerHTML;
  }
  getHtml(t, e, a, n) {
    var i = this.generateExportList(a || this.table.options.htmlOutputConfig, e, t, n || "htmlOutput");
    return this.generateHTMLTable(i);
  }
  mapElementStyles(t, e, a) {
    if (this.cloneTableStyle && t && e) {
      var n = {
        "background-color": "backgroundColor",
        color: "fontColor",
        width: "width",
        "font-weight": "fontWeight",
        "font-family": "fontFamily",
        "font-size": "fontSize",
        "text-align": "textAlign",
        "border-top": "borderTop",
        "border-left": "borderLeft",
        "border-right": "borderRight",
        "border-bottom": "borderBottom",
        "padding-top": "paddingTop",
        "padding-left": "paddingLeft",
        "padding-right": "paddingRight",
        "padding-bottom": "paddingBottom"
      };
      if (window.getComputedStyle) {
        var i = window.getComputedStyle(t);
        a.forEach(function(r) {
          e.style[n[r]] || (e.style[n[r]] = i.getPropertyValue(r));
        });
      }
    }
  }
}
zN.moduleName = "export";
var c4 = {
  //equal to
  "=": function(s, t, e, a) {
    return t == s;
  },
  //less than
  "<": function(s, t, e, a) {
    return t < s;
  },
  //less than or equal to
  "<=": function(s, t, e, a) {
    return t <= s;
  },
  //greater than
  ">": function(s, t, e, a) {
    return t > s;
  },
  //greater than or equal to
  ">=": function(s, t, e, a) {
    return t >= s;
  },
  //not equal to
  "!=": function(s, t, e, a) {
    return t != s;
  },
  regex: function(s, t, e, a) {
    return typeof s == "string" && (s = new RegExp(s)), s.test(t);
  },
  //contains the string
  like: function(s, t, e, a) {
    return s === null || typeof s > "u" ? t === s : typeof t < "u" && t !== null ? String(t).toLowerCase().indexOf(s.toLowerCase()) > -1 : !1;
  },
  //contains the keywords
  keywords: function(s, t, e, a) {
    var n = s.toLowerCase().split(typeof a.separator > "u" ? " " : a.separator), i = String(t === null || typeof t > "u" ? "" : t).toLowerCase(), r = [];
    return n.forEach((l) => {
      i.includes(l) && r.push(!0);
    }), a.matchAll ? r.length === n.length : !!r.length;
  },
  //starts with the string
  starts: function(s, t, e, a) {
    return s === null || typeof s > "u" ? t === s : typeof t < "u" && t !== null ? String(t).toLowerCase().startsWith(s.toLowerCase()) : !1;
  },
  //ends with the string
  ends: function(s, t, e, a) {
    return s === null || typeof s > "u" ? t === s : typeof t < "u" && t !== null ? String(t).toLowerCase().endsWith(s.toLowerCase()) : !1;
  },
  //in array
  in: function(s, t, e, a) {
    return Array.isArray(s) ? s.length ? s.indexOf(t) > -1 : !0 : (console.warn("Filter Error - filter value is not an array:", s), !1);
  }
};
class ur extends Ze {
  constructor(t) {
    super(t), this.filterList = [], this.headerFilters = {}, this.headerFilterColumns = [], this.prevHeaderFilterChangeCheck = "", this.prevHeaderFilterChangeCheck = "{}", this.changed = !1, this.tableInitialized = !1, this.registerTableOption("filterMode", "local"), this.registerTableOption("initialFilter", !1), this.registerTableOption("initialHeaderFilter", !1), this.registerTableOption("headerFilterLiveFilterDelay", 300), this.registerTableOption("placeholderHeaderFilter", !1), this.registerColumnOption("headerFilter"), this.registerColumnOption("headerFilterPlaceholder"), this.registerColumnOption("headerFilterParams"), this.registerColumnOption("headerFilterEmptyCheck"), this.registerColumnOption("headerFilterFunc"), this.registerColumnOption("headerFilterFuncParams"), this.registerColumnOption("headerFilterLiveFilter"), this.registerTableFunction("searchRows", this.searchRows.bind(this)), this.registerTableFunction("searchData", this.searchData.bind(this)), this.registerTableFunction("setFilter", this.userSetFilter.bind(this)), this.registerTableFunction("refreshFilter", this.userRefreshFilter.bind(this)), this.registerTableFunction("addFilter", this.userAddFilter.bind(this)), this.registerTableFunction("getFilters", this.getFilters.bind(this)), this.registerTableFunction("setHeaderFilterFocus", this.userSetHeaderFilterFocus.bind(this)), this.registerTableFunction("getHeaderFilterValue", this.userGetHeaderFilterValue.bind(this)), this.registerTableFunction("setHeaderFilterValue", this.userSetHeaderFilterValue.bind(this)), this.registerTableFunction("getHeaderFilters", this.getHeaderFilters.bind(this)), this.registerTableFunction("removeFilter", this.userRemoveFilter.bind(this)), this.registerTableFunction("clearFilter", this.userClearFilter.bind(this)), this.registerTableFunction("clearHeaderFilter", this.userClearHeaderFilter.bind(this)), this.registerComponentFunction("column", "headerFilterFocus", this.setHeaderFilterFocus.bind(this)), this.registerComponentFunction("column", "reloadHeaderFilter", this.reloadHeaderFilter.bind(this)), this.registerComponentFunction("column", "getHeaderFilterValue", this.getHeaderFilterValue.bind(this)), this.registerComponentFunction("column", "setHeaderFilterValue", this.setHeaderFilterValue.bind(this));
  }
  initialize() {
    this.subscribe("column-init", this.initializeColumnHeaderFilter.bind(this)), this.subscribe("column-width-fit-before", this.hideHeaderFilterElements.bind(this)), this.subscribe("column-width-fit-after", this.showHeaderFilterElements.bind(this)), this.subscribe("table-built", this.tableBuilt.bind(this)), this.subscribe("placeholder", this.generatePlaceholder.bind(this)), this.table.options.filterMode === "remote" && this.subscribe("data-params", this.remoteFilterParams.bind(this)), this.registerDataHandler(this.filter.bind(this), 10);
  }
  tableBuilt() {
    this.table.options.initialFilter && this.setFilter(this.table.options.initialFilter), this.table.options.initialHeaderFilter && this.table.options.initialHeaderFilter.forEach((t) => {
      var e = this.table.columnManager.findColumn(t.field);
      if (e)
        this.setHeaderFilterValue(e, t.value);
      else
        return console.warn("Column Filter Error - No matching column found:", t.field), !1;
    }), this.tableInitialized = !0;
  }
  remoteFilterParams(t, e, a, n) {
    return n.filter = this.getFilters(!0, !0), n;
  }
  generatePlaceholder(t) {
    if (this.table.options.placeholderHeaderFilter && Object.keys(this.headerFilters).length)
      return this.table.options.placeholderHeaderFilter;
  }
  ///////////////////////////////////
  ///////// Table Functions /////////
  ///////////////////////////////////
  //set standard filters
  userSetFilter(t, e, a, n) {
    this.setFilter(t, e, a, n), this.refreshFilter();
  }
  //set standard filters
  userRefreshFilter() {
    this.refreshFilter();
  }
  //add filter to array
  userAddFilter(t, e, a, n) {
    this.addFilter(t, e, a, n), this.refreshFilter();
  }
  userSetHeaderFilterFocus(t) {
    var e = this.table.columnManager.findColumn(t);
    if (e)
      this.setHeaderFilterFocus(e);
    else
      return console.warn("Column Filter Focus Error - No matching column found:", t), !1;
  }
  userGetHeaderFilterValue(t) {
    var e = this.table.columnManager.findColumn(t);
    if (e)
      return this.getHeaderFilterValue(e);
    console.warn("Column Filter Error - No matching column found:", t);
  }
  userSetHeaderFilterValue(t, e) {
    var a = this.table.columnManager.findColumn(t);
    if (a)
      this.setHeaderFilterValue(a, e);
    else
      return console.warn("Column Filter Error - No matching column found:", t), !1;
  }
  //remove filter from array
  userRemoveFilter(t, e, a) {
    this.removeFilter(t, e, a), this.refreshFilter();
  }
  //clear filters
  userClearFilter(t) {
    this.clearFilter(t), this.refreshFilter();
  }
  //clear header filters
  userClearHeaderFilter() {
    this.clearHeaderFilter(), this.refreshFilter();
  }
  //search for specific row components
  searchRows(t, e, a) {
    return this.search("rows", t, e, a);
  }
  //search for specific data
  searchData(t, e, a) {
    return this.search("data", t, e, a);
  }
  ///////////////////////////////////
  ///////// Internal Logic //////////
  ///////////////////////////////////
  initializeColumnHeaderFilter(t) {
    var e = t.definition;
    e.headerFilter && this.initializeColumn(t);
  }
  //initialize column header filter
  initializeColumn(t, e) {
    var a = this, n = t.getField();
    function i(r) {
      var l = t.modules.filter.tagType == "input" && t.modules.filter.attrType == "text" || t.modules.filter.tagType == "textarea" ? "partial" : "match", o = "", c = "", d;
      if (typeof t.modules.filter.prevSuccess > "u" || t.modules.filter.prevSuccess !== r) {
        if (t.modules.filter.prevSuccess = r, t.modules.filter.emptyFunc(r))
          delete a.headerFilters[n];
        else {
          switch (t.modules.filter.value = r, typeof t.definition.headerFilterFunc) {
            case "string":
              ur.filters[t.definition.headerFilterFunc] ? (o = t.definition.headerFilterFunc, d = function(p) {
                var h = t.definition.headerFilterFuncParams || {}, g = t.getFieldValue(p);
                return h = typeof h == "function" ? h(r, g, p) : h, ur.filters[t.definition.headerFilterFunc](r, g, p, h);
              }) : console.warn("Header Filter Error - Matching filter function not found: ", t.definition.headerFilterFunc);
              break;
            case "function":
              d = function(p) {
                var h = t.definition.headerFilterFuncParams || {}, g = t.getFieldValue(p);
                return h = typeof h == "function" ? h(r, g, p) : h, t.definition.headerFilterFunc(r, g, p, h);
              }, o = d;
              break;
          }
          if (!d)
            switch (l) {
              case "partial":
                d = function(p) {
                  var h = t.getFieldValue(p);
                  return typeof h < "u" && h !== null ? String(h).toLowerCase().indexOf(String(r).toLowerCase()) > -1 : !1;
                }, o = "like";
                break;
              default:
                d = function(p) {
                  return t.getFieldValue(p) == r;
                }, o = "=";
            }
          a.headerFilters[n] = { value: r, func: d, type: o };
        }
        t.modules.filter.value = r, c = JSON.stringify(a.headerFilters), a.prevHeaderFilterChangeCheck !== c && (a.prevHeaderFilterChangeCheck = c, a.trackChanges(), a.refreshFilter());
      }
      return !0;
    }
    t.modules.filter = {
      success: i,
      attrType: !1,
      tagType: !1,
      emptyFunc: !1
    }, this.generateHeaderFilterElement(t);
  }
  generateHeaderFilterElement(t, e, a) {
    var n = this, i = t.modules.filter.success, r = t.getField(), l, o, c, d, p, h, g, x;
    t.modules.filter.value = e;
    function b() {
    }
    function A(T) {
      x = T;
    }
    if (t.modules.filter.headerElement && t.modules.filter.headerElement.parentNode && t.contentElement.removeChild(t.modules.filter.headerElement.parentNode), r) {
      switch (t.modules.filter.emptyFunc = t.definition.headerFilterEmptyCheck || function(T) {
        return !T && T !== 0;
      }, l = document.createElement("div"), l.classList.add("tabulator-header-filter"), typeof t.definition.headerFilter) {
        case "string":
          n.table.modules.edit.editors[t.definition.headerFilter] ? (o = n.table.modules.edit.editors[t.definition.headerFilter], (t.definition.headerFilter === "tick" || t.definition.headerFilter === "tickCross") && !t.definition.headerFilterEmptyCheck && (t.modules.filter.emptyFunc = function(T) {
            return T !== !0 && T !== !1;
          })) : console.warn("Filter Error - Cannot build header filter, No such editor found: ", t.definition.editor);
          break;
        case "function":
          o = t.definition.headerFilter;
          break;
        case "boolean":
          t.modules.edit && t.modules.edit.editor ? o = t.modules.edit.editor : t.definition.formatter && n.table.modules.edit.editors[t.definition.formatter] ? (o = n.table.modules.edit.editors[t.definition.formatter], (t.definition.formatter === "tick" || t.definition.formatter === "tickCross") && !t.definition.headerFilterEmptyCheck && (t.modules.filter.emptyFunc = function(T) {
            return T !== !0 && T !== !1;
          })) : o = n.table.modules.edit.editors.input;
          break;
      }
      if (o) {
        if (d = {
          getValue: function() {
            return typeof e < "u" ? e : "";
          },
          getField: function() {
            return t.definition.field;
          },
          getElement: function() {
            return l;
          },
          getColumn: function() {
            return t.getComponent();
          },
          getTable: () => this.table,
          getType: () => "header",
          getRow: function() {
            return {
              normalizeHeight: function() {
              }
            };
          }
        }, g = t.definition.headerFilterParams || {}, g = typeof g == "function" ? g.call(n.table, d) : g, c = o.call(this.table.modules.edit, d, A, i, b, g), !c) {
          console.warn("Filter Error - Cannot add filter to " + r + " column, editor returned a value of false");
          return;
        }
        if (!(c instanceof Node)) {
          console.warn("Filter Error - Cannot add filter to " + r + " column, editor should return an instance of Node, the editor returned:", c);
          return;
        }
        n.langBind("headerFilters|columns|" + t.definition.field, function(T) {
          c.setAttribute("placeholder", typeof T < "u" && T ? T : t.definition.headerFilterPlaceholder || n.langText("headerFilters|default"));
        }), c.addEventListener("click", function(T) {
          T.stopPropagation(), c.focus();
        }), c.addEventListener("focus", (T) => {
          var R = this.table.columnManager.contentsElement.scrollLeft, C = this.table.rowManager.element.scrollLeft;
          R !== C && (this.table.rowManager.scrollHorizontal(R), this.table.columnManager.scrollHorizontal(R));
        }), p = !1, h = function(T) {
          p && clearTimeout(p), p = setTimeout(function() {
            i(c.value);
          }, n.table.options.headerFilterLiveFilterDelay);
        }, t.modules.filter.headerElement = c, t.modules.filter.attrType = c.hasAttribute("type") ? c.getAttribute("type").toLowerCase() : "", t.modules.filter.tagType = c.tagName.toLowerCase(), t.definition.headerFilterLiveFilter !== !1 && (t.definition.headerFilter === "autocomplete" || t.definition.headerFilter === "tickCross" || (t.definition.editor === "autocomplete" || t.definition.editor === "tickCross") && t.definition.headerFilter === !0 || (c.addEventListener("keyup", h), c.addEventListener("search", h), t.modules.filter.attrType == "number" && c.addEventListener("change", function(T) {
          i(c.value);
        }), t.modules.filter.attrType == "text" && this.table.browser !== "ie" && c.setAttribute("type", "search")), (t.modules.filter.tagType == "input" || t.modules.filter.tagType == "select" || t.modules.filter.tagType == "textarea") && c.addEventListener("mousedown", function(T) {
          T.stopPropagation();
        })), l.appendChild(c), t.contentElement.appendChild(l), a || n.headerFilterColumns.push(t), x && x();
      }
    } else
      console.warn("Filter Error - Cannot add header filter, column has no field set:", t.definition.title);
  }
  //hide all header filter elements (used to ensure correct column widths in "fitData" layout mode)
  hideHeaderFilterElements() {
    this.headerFilterColumns.forEach(function(t) {
      t.modules.filter && t.modules.filter.headerElement && (t.modules.filter.headerElement.style.display = "none");
    });
  }
  //show all header filter elements (used to ensure correct column widths in "fitData" layout mode)
  showHeaderFilterElements() {
    this.headerFilterColumns.forEach(function(t) {
      t.modules.filter && t.modules.filter.headerElement && (t.modules.filter.headerElement.style.display = "");
    });
  }
  //programmatically set focus of header filter
  setHeaderFilterFocus(t) {
    t.modules.filter && t.modules.filter.headerElement ? t.modules.filter.headerElement.focus() : console.warn("Column Filter Focus Error - No header filter set on column:", t.getField());
  }
  //programmatically get value of header filter
  getHeaderFilterValue(t) {
    if (t.modules.filter && t.modules.filter.headerElement)
      return t.modules.filter.value;
    console.warn("Column Filter Error - No header filter set on column:", t.getField());
  }
  //programmatically set value of header filter
  setHeaderFilterValue(t, e) {
    t && (t.modules.filter && t.modules.filter.headerElement ? (this.generateHeaderFilterElement(t, e, !0), t.modules.filter.success(e)) : console.warn("Column Filter Error - No header filter set on column:", t.getField()));
  }
  reloadHeaderFilter(t) {
    t && (t.modules.filter && t.modules.filter.headerElement ? this.generateHeaderFilterElement(t, t.modules.filter.value, !0) : console.warn("Column Filter Error - No header filter set on column:", t.getField()));
  }
  refreshFilter() {
    this.tableInitialized && (this.table.options.filterMode === "remote" ? this.reloadData(null, !1, !1) : this.refreshData(!0));
  }
  //check if the filters has changed since last use
  trackChanges() {
    this.changed = !0, this.dispatch("filter-changed");
  }
  //check if the filters has changed since last use
  hasChanged() {
    var t = this.changed;
    return this.changed = !1, t;
  }
  //set standard filters
  setFilter(t, e, a, n) {
    this.filterList = [], Array.isArray(t) || (t = [{ field: t, type: e, value: a, params: n }]), this.addFilter(t);
  }
  //add filter to array
  addFilter(t, e, a, n) {
    var i = !1;
    Array.isArray(t) || (t = [{ field: t, type: e, value: a, params: n }]), t.forEach((r) => {
      r = this.findFilter(r), r && (this.filterList.push(r), i = !0);
    }), i && this.trackChanges();
  }
  findFilter(t) {
    var e;
    if (Array.isArray(t))
      return this.findSubFilters(t);
    var a = !1;
    return typeof t.field == "function" ? a = function(n) {
      return t.field(n, t.type || {});
    } : ur.filters[t.type] ? (e = this.table.columnManager.getColumnByField(t.field), e ? a = function(n) {
      return ur.filters[t.type](t.value, e.getFieldValue(n), n, t.params || {});
    } : a = function(n) {
      return ur.filters[t.type](t.value, n[t.field], n, t.params || {});
    }) : console.warn("Filter Error - No such filter type found, ignoring: ", t.type), t.func = a, t.func ? t : !1;
  }
  findSubFilters(t) {
    var e = [];
    return t.forEach((a) => {
      a = this.findFilter(a), a && e.push(a);
    }), e.length ? e : !1;
  }
  //get all filters
  getFilters(t, e) {
    var a = [];
    return t && (a = this.getHeaderFilters()), e && a.forEach(function(n) {
      typeof n.type == "function" && (n.type = "function");
    }), a = a.concat(this.filtersToArray(this.filterList, e)), a;
  }
  //filter to Object
  filtersToArray(t, e) {
    var a = [];
    return t.forEach((n) => {
      var i;
      Array.isArray(n) ? a.push(this.filtersToArray(n, e)) : (i = { field: n.field, type: n.type, value: n.value }, e && typeof i.type == "function" && (i.type = "function"), a.push(i));
    }), a;
  }
  //get all filters
  getHeaderFilters() {
    var t = [];
    for (var e in this.headerFilters)
      t.push({ field: e, type: this.headerFilters[e].type, value: this.headerFilters[e].value });
    return t;
  }
  //remove filter from array
  removeFilter(t, e, a) {
    Array.isArray(t) || (t = [{ field: t, type: e, value: a }]), t.forEach((n) => {
      var i = -1;
      typeof n.field == "object" ? i = this.filterList.findIndex((r) => n === r) : i = this.filterList.findIndex((r) => n.field === r.field && n.type === r.type && n.value === r.value), i > -1 ? this.filterList.splice(i, 1) : console.warn("Filter Error - No matching filter type found, ignoring: ", n.type);
    }), this.trackChanges();
  }
  //clear filters
  clearFilter(t) {
    this.filterList = [], t && this.clearHeaderFilter(), this.trackChanges();
  }
  //clear header filters
  clearHeaderFilter() {
    this.headerFilters = {}, this.prevHeaderFilterChangeCheck = "{}", this.headerFilterColumns.forEach((t) => {
      typeof t.modules.filter.value < "u" && delete t.modules.filter.value, t.modules.filter.prevSuccess = void 0, this.reloadHeaderFilter(t);
    }), this.trackChanges();
  }
  //search data and return matching rows
  search(t, e, a, n) {
    var i = [], r = [];
    return Array.isArray(e) || (e = [{ field: e, type: a, value: n }]), e.forEach((l) => {
      l = this.findFilter(l), l && r.push(l);
    }), this.table.rowManager.rows.forEach((l) => {
      var o = !0;
      r.forEach((c) => {
        this.filterRecurse(c, l.getData()) || (o = !1);
      }), o && i.push(t === "data" ? l.getData("data") : l.getComponent());
    }), i;
  }
  //filter row array
  filter(t, e) {
    var a = [], n = [];
    return this.subscribedExternal("dataFiltering") && this.dispatchExternal("dataFiltering", this.getFilters(!0)), this.table.options.filterMode !== "remote" && (this.filterList.length || Object.keys(this.headerFilters).length) ? t.forEach((i) => {
      this.filterRow(i) && a.push(i);
    }) : a = t.slice(0), this.subscribedExternal("dataFiltered") && (a.forEach((i) => {
      n.push(i.getComponent());
    }), this.dispatchExternal("dataFiltered", this.getFilters(!0), n)), a;
  }
  //filter individual row
  filterRow(t, e) {
    var a = !0, n = t.getData();
    this.filterList.forEach((r) => {
      this.filterRecurse(r, n) || (a = !1);
    });
    for (var i in this.headerFilters)
      this.headerFilters[i].func(n) || (a = !1);
    return a;
  }
  filterRecurse(t, e) {
    var a = !1;
    return Array.isArray(t) ? t.forEach((n) => {
      this.filterRecurse(n, e) && (a = !0);
    }) : a = t.func(e), a;
  }
}
ur.moduleName = "filter";
ur.filters = c4;
function d4(s, t, e) {
  return this.emptyToSpace(this.sanitizeHTML(s.getValue()));
}
function u4(s, t, e) {
  return s.getValue();
}
function p4(s, t, e) {
  return s.getElement().style.whiteSpace = "pre-wrap", this.emptyToSpace(this.sanitizeHTML(s.getValue()));
}
function h4(s, t, e) {
  var a = parseFloat(s.getValue()), n = "", i, r, l, o, c, d = t.decimal || ".", p = t.thousand || ",", h = t.negativeSign || "-", g = t.symbol || "", x = !!t.symbolAfter, b = typeof t.precision < "u" ? t.precision : 2;
  if (isNaN(a))
    return this.emptyToSpace(this.sanitizeHTML(s.getValue()));
  if (a < 0 && (a = Math.abs(a), n = h), i = b !== !1 ? a.toFixed(b) : a, i = String(i).split("."), r = i[0], l = i.length > 1 ? d + i[1] : "", t.thousand !== !1)
    for (o = /(\d+)(\d{3})/; o.test(r); )
      r = r.replace(o, "$1" + p + "$2");
  return c = r + l, n === !0 ? (c = "(" + c + ")", x ? c + g : g + c) : x ? n + c + g : n + g + c;
}
function m4(s, t, e) {
  var a = s.getValue(), n = t.urlPrefix || "", i = t.download, r = a, l = document.createElement("a"), o;
  function c(d, p) {
    var h = d.shift(), g = p[h];
    return d.length && typeof g == "object" ? c(d, g) : g;
  }
  if (t.labelField && (o = s.getData(), r = c(t.labelField.split(this.table.options.nestedFieldSeparator), o)), t.label)
    switch (typeof t.label) {
      case "string":
        r = t.label;
        break;
      case "function":
        r = t.label(s);
        break;
    }
  if (r) {
    if (t.urlField && (o = s.getData(), a = za.retrieveNestedData(this.table.options.nestedFieldSeparator, t.urlField, o)), t.url)
      switch (typeof t.url) {
        case "string":
          a = t.url;
          break;
        case "function":
          a = t.url(s);
          break;
      }
    return l.setAttribute("href", n + a), t.target && l.setAttribute("target", t.target), t.download && (typeof i == "function" ? i = i(s) : i = i === !0 ? "" : i, l.setAttribute("download", i)), l.innerHTML = this.emptyToSpace(this.sanitizeHTML(r)), l;
  } else
    return "&nbsp;";
}
function g4(s, t, e) {
  var a = document.createElement("img"), n = s.getValue();
  switch (t.urlPrefix && (n = t.urlPrefix + s.getValue()), t.urlSuffix && (n = n + t.urlSuffix), a.setAttribute("src", n), typeof t.height) {
    case "number":
      a.style.height = t.height + "px";
      break;
    case "string":
      a.style.height = t.height;
      break;
  }
  switch (typeof t.width) {
    case "number":
      a.style.width = t.width + "px";
      break;
    case "string":
      a.style.width = t.width;
      break;
  }
  return a.addEventListener("load", function() {
    s.getRow().normalizeHeight();
  }), a;
}
function y4(s, t, e) {
  var a = s.getValue(), n = s.getElement(), i = t.allowEmpty, r = t.allowTruthy, l = Object.keys(t).includes("trueValue"), o = typeof t.tickElement < "u" ? t.tickElement : '<svg enable-background="new 0 0 24 24" height="14" width="14" viewBox="0 0 24 24" xml:space="preserve" ><path fill="#2DC214" clip-rule="evenodd" d="M21.652,3.211c-0.293-0.295-0.77-0.295-1.061,0L9.41,14.34  c-0.293,0.297-0.771,0.297-1.062,0L3.449,9.351C3.304,9.203,3.114,9.13,2.923,9.129C2.73,9.128,2.534,9.201,2.387,9.351  l-2.165,1.946C0.078,11.445,0,11.63,0,11.823c0,0.194,0.078,0.397,0.223,0.544l4.94,5.184c0.292,0.296,0.771,0.776,1.062,1.07  l2.124,2.141c0.292,0.293,0.769,0.293,1.062,0l14.366-14.34c0.293-0.294,0.293-0.777,0-1.071L21.652,3.211z" fill-rule="evenodd"/></svg>', c = typeof t.crossElement < "u" ? t.crossElement : '<svg enable-background="new 0 0 24 24" height="14" width="14"  viewBox="0 0 24 24" xml:space="preserve" ><path fill="#CE1515" d="M22.245,4.015c0.313,0.313,0.313,0.826,0,1.139l-6.276,6.27c-0.313,0.312-0.313,0.826,0,1.14l6.273,6.272  c0.313,0.313,0.313,0.826,0,1.14l-2.285,2.277c-0.314,0.312-0.828,0.312-1.142,0l-6.271-6.271c-0.313-0.313-0.828-0.313-1.141,0  l-6.276,6.267c-0.313,0.313-0.828,0.313-1.141,0l-2.282-2.28c-0.313-0.313-0.313-0.826,0-1.14l6.278-6.269  c0.313-0.312,0.313-0.826,0-1.14L1.709,5.147c-0.314-0.313-0.314-0.827,0-1.14l2.284-2.278C4.308,1.417,4.821,1.417,5.135,1.73  L11.405,8c0.314,0.314,0.828,0.314,1.141,0.001l6.276-6.267c0.312-0.312,0.826-0.312,1.141,0L22.245,4.015z"/></svg>';
  return l && a === t.trueValue || !l && (r && a || a === !0 || a === "true" || a === "True" || a === 1 || a === "1") ? (n.setAttribute("aria-checked", !0), o || "") : i && (a === "null" || a === "" || a === null || typeof a > "u") ? (n.setAttribute("aria-checked", "mixed"), "") : (n.setAttribute("aria-checked", !1), c || "");
}
function f4(s, t, e) {
  var a = window.DateTime || luxon.DateTime, n = t.inputFormat || "yyyy-MM-dd HH:mm:ss", i = t.outputFormat || "dd/MM/yyyy HH:mm:ss", r = typeof t.invalidPlaceholder < "u" ? t.invalidPlaceholder : "", l = s.getValue();
  if (typeof a < "u") {
    var o;
    return a.isDateTime(l) ? o = l : n === "iso" ? o = a.fromISO(String(l)) : o = a.fromFormat(String(l), n), o.isValid ? (t.timezone && (o = o.setZone(t.timezone)), o.toFormat(i)) : r === !0 || !l ? l : typeof r == "function" ? r(l) : r;
  } else
    console.error("Format Error - 'datetime' formatter is dependant on luxon.js");
}
function b4(s, t, e) {
  var a = window.DateTime || luxon.DateTime, n = t.inputFormat || "yyyy-MM-dd HH:mm:ss", i = typeof t.invalidPlaceholder < "u" ? t.invalidPlaceholder : "", r = typeof t.suffix < "u" ? t.suffix : !1, l = typeof t.unit < "u" ? t.unit : "days", o = typeof t.humanize < "u" ? t.humanize : !1, c = typeof t.date < "u" ? t.date : a.now(), d = s.getValue();
  if (typeof a < "u") {
    var p;
    return a.isDateTime(d) ? p = d : n === "iso" ? p = a.fromISO(String(d)) : p = a.fromFormat(String(d), n), p.isValid ? o ? p.diff(c, l).toHuman() + (r ? " " + r : "") : parseInt(p.diff(c, l)[l]) + (r ? " " + r : "") : i === !0 ? d : typeof i == "function" ? i(d) : i;
  } else
    console.error("Format Error - 'datetimediff' formatter is dependant on luxon.js");
}
function v4(s, t, e) {
  var a = s.getValue();
  return typeof t[a] > "u" ? (console.warn("Missing display value for " + a), a) : t[a];
}
function x4(s, t, e) {
  var a = s.getValue(), n = s.getElement(), i = t && t.stars ? t.stars : 5, r = document.createElement("span"), l = document.createElementNS("http://www.w3.org/2000/svg", "svg"), o = '<polygon fill="#FFEA00" stroke="#C1AB60" stroke-width="37.6152" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="259.216,29.942 330.27,173.919 489.16,197.007 374.185,309.08 401.33,467.31 259.216,392.612 117.104,467.31 144.25,309.08 29.274,197.007 188.165,173.919 "/>', c = '<polygon fill="#D2D2D2" stroke="#686868" stroke-width="37.6152" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="259.216,29.942 330.27,173.919 489.16,197.007 374.185,309.08 401.33,467.31 259.216,392.612 117.104,467.31 144.25,309.08 29.274,197.007 188.165,173.919 "/>';
  r.style.verticalAlign = "middle", l.setAttribute("width", "14"), l.setAttribute("height", "14"), l.setAttribute("viewBox", "0 0 512 512"), l.setAttribute("xml:space", "preserve"), l.style.padding = "0 1px", a = a && !isNaN(a) ? parseInt(a) : 0, a = Math.max(0, Math.min(a, i));
  for (var d = 1; d <= i; d++) {
    var p = l.cloneNode(!0);
    p.innerHTML = d <= a ? o : c, r.appendChild(p);
  }
  return n.style.whiteSpace = "nowrap", n.style.overflow = "hidden", n.style.textOverflow = "ellipsis", n.setAttribute("aria-label", a), r;
}
function w4(s, t, e) {
  var a = this.sanitizeHTML(s.getValue()) || 0, n = document.createElement("span"), i = t && t.max ? t.max : 100, r = t && t.min ? t.min : 0, l = t && typeof t.color < "u" ? t.color : ["red", "orange", "green"], o = "#666666", c, d;
  if (!(isNaN(a) || typeof s.getValue() > "u")) {
    switch (n.classList.add("tabulator-traffic-light"), d = parseFloat(a) <= i ? parseFloat(a) : i, d = parseFloat(d) >= r ? parseFloat(d) : r, c = (i - r) / 100, d = Math.round((d - r) / c), typeof l) {
      case "string":
        o = l;
        break;
      case "function":
        o = l(a);
        break;
      case "object":
        if (Array.isArray(l)) {
          var p = 100 / l.length, h = Math.floor(d / p);
          h = Math.min(h, l.length - 1), h = Math.max(h, 0), o = l[h];
          break;
        }
    }
    return n.style.backgroundColor = o, n;
  }
}
function A4(s, t = {}, e) {
  var a = this.sanitizeHTML(s.getValue()) || 0, n = s.getElement(), i = t.max ? t.max : 100, r = t.min ? t.min : 0, l = t.legendAlign ? t.legendAlign : "center", o, c, d, p, h;
  switch (c = parseFloat(a) <= i ? parseFloat(a) : i, c = parseFloat(c) >= r ? parseFloat(c) : r, o = (i - r) / 100, c = Math.round((c - r) / o), typeof t.color) {
    case "string":
      d = t.color;
      break;
    case "function":
      d = t.color(a);
      break;
    case "object":
      if (Array.isArray(t.color)) {
        let A = 100 / t.color.length, T = Math.floor(c / A);
        T = Math.min(T, t.color.length - 1), T = Math.max(T, 0), d = t.color[T];
        break;
      }
    default:
      d = "#2DC214";
  }
  switch (typeof t.legend) {
    case "string":
      p = t.legend;
      break;
    case "function":
      p = t.legend(a);
      break;
    case "boolean":
      p = a;
      break;
    default:
      p = !1;
  }
  switch (typeof t.legendColor) {
    case "string":
      h = t.legendColor;
      break;
    case "function":
      h = t.legendColor(a);
      break;
    case "object":
      if (Array.isArray(t.legendColor)) {
        let A = 100 / t.legendColor.length, T = Math.floor(c / A);
        T = Math.min(T, t.legendColor.length - 1), T = Math.max(T, 0), h = t.legendColor[T];
      }
      break;
    default:
      h = "#000";
  }
  n.style.minWidth = "30px", n.style.position = "relative", n.setAttribute("aria-label", c);
  var g = document.createElement("div");
  g.style.display = "inline-block", g.style.width = c + "%", g.style.backgroundColor = d, g.style.height = "100%", g.setAttribute("data-max", i), g.setAttribute("data-min", r);
  var x = document.createElement("div");
  if (x.style.position = "relative", x.style.width = "100%", x.style.height = "100%", p) {
    var b = document.createElement("div");
    b.style.position = "absolute", b.style.top = 0, b.style.left = 0, b.style.textAlign = l, b.style.width = "100%", b.style.color = h, b.innerHTML = p;
  }
  return e(function() {
    if (!(s instanceof GN)) {
      var A = document.createElement("div");
      A.style.position = "absolute", A.style.top = "4px", A.style.bottom = "4px", A.style.left = "4px", A.style.right = "4px", n.appendChild(A), n = A;
    }
    n.appendChild(x), x.appendChild(g), p && x.appendChild(b);
  }), "";
}
function C4(s, t, e) {
  return s.getElement().style.backgroundColor = this.sanitizeHTML(s.getValue()), "";
}
function $4(s, t, e) {
  return '<svg enable-background="new 0 0 24 24" height="14" width="14" viewBox="0 0 24 24" xml:space="preserve" ><path fill="#2DC214" clip-rule="evenodd" d="M21.652,3.211c-0.293-0.295-0.77-0.295-1.061,0L9.41,14.34  c-0.293,0.297-0.771,0.297-1.062,0L3.449,9.351C3.304,9.203,3.114,9.13,2.923,9.129C2.73,9.128,2.534,9.201,2.387,9.351  l-2.165,1.946C0.078,11.445,0,11.63,0,11.823c0,0.194,0.078,0.397,0.223,0.544l4.94,5.184c0.292,0.296,0.771,0.776,1.062,1.07  l2.124,2.141c0.292,0.293,0.769,0.293,1.062,0l14.366-14.34c0.293-0.294,0.293-0.777,0-1.071L21.652,3.211z" fill-rule="evenodd"/></svg>';
}
function S4(s, t, e) {
  return '<svg enable-background="new 0 0 24 24" height="14" width="14" viewBox="0 0 24 24" xml:space="preserve" ><path fill="#CE1515" d="M22.245,4.015c0.313,0.313,0.313,0.826,0,1.139l-6.276,6.27c-0.313,0.312-0.313,0.826,0,1.14l6.273,6.272  c0.313,0.313,0.313,0.826,0,1.14l-2.285,2.277c-0.314,0.312-0.828,0.312-1.142,0l-6.271-6.271c-0.313-0.313-0.828-0.313-1.141,0  l-6.276,6.267c-0.313,0.313-0.828,0.313-1.141,0l-2.282-2.28c-0.313-0.313-0.313-0.826,0-1.14l6.278-6.269  c0.313-0.312,0.313-0.826,0-1.14L1.709,5.147c-0.314-0.313-0.314-0.827,0-1.14l2.284-2.278C4.308,1.417,4.821,1.417,5.135,1.73  L11.405,8c0.314,0.314,0.828,0.314,1.141,0.001l6.276-6.267c0.312-0.312,0.826-0.312,1.141,0L22.245,4.015z"/></svg>';
}
function k4(s, t, e) {
  var a = document.createElement("span"), n = s.getRow(), i = s.getTable();
  return n.watchPosition((r) => {
    t.relativeToPage && (r += i.modules.page.getPageSize() * (i.modules.page.getPage() - 1)), a.innerText = r;
  }), a;
}
function T4(s, t, e) {
  return s.getElement().classList.add("tabulator-row-handle"), "<div class='tabulator-row-handle-box'><div class='tabulator-row-handle-bar'></div><div class='tabulator-row-handle-bar'></div><div class='tabulator-row-handle-bar'></div></div>";
}
function L4(s, t, e) {
  var a = document.createElement("div"), n = s.getRow()._row.modules.responsiveLayout;
  a.classList.add("tabulator-responsive-collapse-toggle"), a.innerHTML = `<svg class='tabulator-responsive-collapse-toggle-open' viewbox="0 0 24 24">
  <line x1="7" y1="12" x2="17" y2="12" fill="none" stroke-width="3" stroke-linecap="round" />
  <line y1="7" x1="12" y2="17" x2="12" fill="none" stroke-width="3" stroke-linecap="round" />
</svg>

<svg class='tabulator-responsive-collapse-toggle-close' viewbox="0 0 24 24">
  <line x1="7" y1="12" x2="17" y2="12"  fill="none" stroke-width="3" stroke-linecap="round" />
</svg>`, s.getElement().classList.add("tabulator-row-handle");
  function i(r) {
    var l = n.element;
    n.open = r, l && (n.open ? (a.classList.add("open"), l.style.display = "") : (a.classList.remove("open"), l.style.display = "none"));
  }
  return a.addEventListener("click", function(r) {
    r.stopImmediatePropagation(), i(!n.open), s.getTable().rowManager.adjustTableSize();
  }), i(n.open), a;
}
function D4(s, t, e) {
  var a = document.createElement("input"), n = !1;
  if (a.type = "checkbox", a.setAttribute("aria-label", "Select Row"), this.table.modExists("selectRow", !0))
    if (a.addEventListener("click", (r) => {
      r.stopPropagation();
    }), typeof s.getRow == "function") {
      var i = s.getRow();
      i instanceof ff ? (a.addEventListener("change", (r) => {
        this.table.options.selectableRowsRangeMode === "click" && n ? n = !1 : i.toggleSelect();
      }), this.table.options.selectableRowsRangeMode === "click" && a.addEventListener("click", (r) => {
        n = !0, this.table.modules.selectRow.handleComplexRowClick(i._row, r);
      }), a.checked = i.isSelected && i.isSelected(), this.table.modules.selectRow.registerRowSelectCheckbox(i, a)) : a = "";
    } else
      a.addEventListener("change", (r) => {
        this.table.modules.selectRow.selectedRows.length ? this.table.deselectRow() : this.table.selectRow(t.rowRange);
      }), this.table.modules.selectRow.registerHeaderSelectCheckbox(a);
  return a;
}
var I4 = {
  plaintext: d4,
  html: u4,
  textarea: p4,
  money: h4,
  link: m4,
  image: g4,
  tickCross: y4,
  datetime: f4,
  datetimediff: b4,
  lookup: v4,
  star: x4,
  traffic: w4,
  progress: A4,
  color: C4,
  buttonTick: $4,
  buttonCross: S4,
  rownum: k4,
  handle: T4,
  responsiveCollapse: L4,
  rowSelection: D4
};
class Vs extends Ze {
  constructor(t) {
    super(t), this.registerColumnOption("formatter"), this.registerColumnOption("formatterParams"), this.registerColumnOption("formatterPrint"), this.registerColumnOption("formatterPrintParams"), this.registerColumnOption("formatterClipboard"), this.registerColumnOption("formatterClipboardParams"), this.registerColumnOption("formatterHtmlOutput"), this.registerColumnOption("formatterHtmlOutputParams"), this.registerColumnOption("titleFormatter"), this.registerColumnOption("titleFormatterParams");
  }
  initialize() {
    this.subscribe("cell-format", this.formatValue.bind(this)), this.subscribe("cell-rendered", this.cellRendered.bind(this)), this.subscribe("column-layout", this.initializeColumn.bind(this)), this.subscribe("column-format", this.formatHeader.bind(this));
  }
  //initialize column formatter
  initializeColumn(t) {
    t.modules.format = this.lookupFormatter(t, ""), typeof t.definition.formatterPrint < "u" && (t.modules.format.print = this.lookupFormatter(t, "Print")), typeof t.definition.formatterClipboard < "u" && (t.modules.format.clipboard = this.lookupFormatter(t, "Clipboard")), typeof t.definition.formatterHtmlOutput < "u" && (t.modules.format.htmlOutput = this.lookupFormatter(t, "HtmlOutput"));
  }
  lookupFormatter(t, e) {
    var a = { params: t.definition["formatter" + e + "Params"] || {} }, n = t.definition["formatter" + e];
    switch (typeof n) {
      case "string":
        Vs.formatters[n] ? a.formatter = Vs.formatters[n] : (console.warn("Formatter Error - No such formatter found: ", n), a.formatter = Vs.formatters.plaintext);
        break;
      case "function":
        a.formatter = n;
        break;
      default:
        a.formatter = Vs.formatters.plaintext;
        break;
    }
    return a;
  }
  cellRendered(t) {
    t.modules.format && t.modules.format.renderedCallback && !t.modules.format.rendered && (t.modules.format.renderedCallback(), t.modules.format.rendered = !0);
  }
  //return a formatted value for a column header
  formatHeader(t, e, a) {
    var n, i, r, l;
    return t.definition.titleFormatter ? (n = this.getFormatter(t.definition.titleFormatter), r = (o) => {
      t.titleFormatterRendered = o;
    }, l = {
      getValue: function() {
        return e;
      },
      getElement: function() {
        return a;
      },
      getType: function() {
        return "header";
      },
      getColumn: function() {
        return t.getComponent();
      },
      getTable: () => this.table
    }, i = t.definition.titleFormatterParams || {}, i = typeof i == "function" ? i() : i, n.call(this, l, i, r)) : e;
  }
  //return a formatted value for a cell
  formatValue(t) {
    var e = t.getComponent(), a = typeof t.column.modules.format.params == "function" ? t.column.modules.format.params(e) : t.column.modules.format.params;
    function n(i) {
      t.modules.format || (t.modules.format = {}), t.modules.format.renderedCallback = i, t.modules.format.rendered = !1;
    }
    return t.column.modules.format.formatter.call(this, e, a, n);
  }
  formatExportValue(t, e) {
    var a = t.column.modules.format[e], n;
    if (a) {
      let i = function(r) {
        t.modules.format || (t.modules.format = {}), t.modules.format.renderedCallback = r, t.modules.format.rendered = !1;
      };
      return n = typeof a.params == "function" ? a.params(t.getComponent()) : a.params, a.formatter.call(this, t.getComponent(), n, i);
    } else
      return this.formatValue(t);
  }
  sanitizeHTML(t) {
    if (t) {
      var e = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
        "/": "&#x2F;",
        "`": "&#x60;",
        "=": "&#x3D;"
      };
      return String(t).replace(/[&<>"'`=/]/g, function(a) {
        return e[a];
      });
    } else
      return t;
  }
  emptyToSpace(t) {
    return t === null || typeof t > "u" || t === "" ? "&nbsp;" : t;
  }
  //get formatter for cell
  getFormatter(t) {
    switch (typeof t) {
      case "string":
        Vs.formatters[t] ? t = Vs.formatters[t] : (console.warn("Formatter Error - No such formatter found: ", t), t = Vs.formatters.plaintext);
        break;
      case "function":
        break;
      default:
        t = Vs.formatters.plaintext;
        break;
    }
    return t;
  }
}
Vs.moduleName = "format";
Vs.formatters = I4;
class BN extends Ze {
  constructor(t) {
    super(t), this.leftColumns = [], this.rightColumns = [], this.initializationMode = "left", this.active = !1, this.blocked = !0, this.registerColumnOption("frozen");
  }
  //reset initial state
  reset() {
    this.initializationMode = "left", this.leftColumns = [], this.rightColumns = [], this.active = !1;
  }
  initialize() {
    this.subscribe("cell-layout", this.layoutCell.bind(this)), this.subscribe("column-init", this.initializeColumn.bind(this)), this.subscribe("column-width", this.layout.bind(this)), this.subscribe("row-layout-after", this.layoutRow.bind(this)), this.subscribe("table-layout", this.layout.bind(this)), this.subscribe("columns-loading", this.reset.bind(this)), this.subscribe("column-add", this.reinitializeColumns.bind(this)), this.subscribe("column-deleted", this.reinitializeColumns.bind(this)), this.subscribe("column-hide", this.reinitializeColumns.bind(this)), this.subscribe("column-show", this.reinitializeColumns.bind(this)), this.subscribe("columns-loaded", this.reinitializeColumns.bind(this)), this.subscribe("table-redraw", this.layout.bind(this)), this.subscribe("layout-refreshing", this.blockLayout.bind(this)), this.subscribe("layout-refreshed", this.unblockLayout.bind(this)), this.subscribe("scrollbar-vertical", this.adjustForScrollbar.bind(this));
  }
  blockLayout() {
    this.blocked = !0;
  }
  unblockLayout() {
    this.blocked = !1;
  }
  layoutCell(t) {
    this.layoutElement(t.element, t.column);
  }
  reinitializeColumns() {
    this.reset(), this.table.columnManager.columnsByIndex.forEach((t) => {
      this.initializeColumn(t);
    }), this.layout();
  }
  //initialize specific column
  initializeColumn(t) {
    var e = { margin: 0, edge: !1 };
    t.isGroup || (this.frozenCheck(t) ? (e.position = this.initializationMode, this.initializationMode == "left" ? this.leftColumns.push(t) : this.rightColumns.unshift(t), this.active = !0, t.modules.frozen = e) : this.initializationMode = "right");
  }
  frozenCheck(t) {
    return t.parent.isGroup && t.definition.frozen && console.warn("Frozen Column Error - Parent column group must be frozen, not individual columns or sub column groups"), t.parent.isGroup ? this.frozenCheck(t.parent) : t.definition.frozen;
  }
  //layout calculation rows
  layoutCalcRows() {
    this.table.modExists("columnCalcs") && (this.table.modules.columnCalcs.topInitialized && this.table.modules.columnCalcs.topRow && this.layoutRow(this.table.modules.columnCalcs.topRow), this.table.modules.columnCalcs.botInitialized && this.table.modules.columnCalcs.botRow && this.layoutRow(this.table.modules.columnCalcs.botRow), this.table.modExists("groupRows") && this.layoutGroupCalcs(this.table.modules.groupRows.getGroups()));
  }
  layoutGroupCalcs(t) {
    t.forEach((e) => {
      e.calcs.top && this.layoutRow(e.calcs.top), e.calcs.bottom && this.layoutRow(e.calcs.bottom), e.groupList && e.groupList.length && this.layoutGroupCalcs(e.groupList);
    });
  }
  //calculate column positions and layout headers
  layoutColumnPosition(t) {
    var e = [], a = 0, n = 0;
    this.leftColumns.forEach((i, r) => {
      if (i.modules.frozen.marginValue = a, i.modules.frozen.margin = i.modules.frozen.marginValue + "px", i.visible && (a += i.getWidth()), r == this.leftColumns.length - 1 ? i.modules.frozen.edge = !0 : i.modules.frozen.edge = !1, i.parent.isGroup) {
        var l = this.getColGroupParentElement(i);
        e.includes(l) || (this.layoutElement(l, i), e.push(l)), l.classList.toggle("tabulator-frozen-left", i.modules.frozen.edge && i.modules.frozen.position === "left"), l.classList.toggle("tabulator-frozen-right", i.modules.frozen.edge && i.modules.frozen.position === "right");
      } else
        this.layoutElement(i.getElement(), i);
      t && i.cells.forEach((o) => {
        this.layoutElement(o.getElement(!0), i);
      });
    }), this.rightColumns.forEach((i, r) => {
      i.modules.frozen.marginValue = n, i.modules.frozen.margin = i.modules.frozen.marginValue + "px", i.visible && (n += i.getWidth()), r == this.rightColumns.length - 1 ? i.modules.frozen.edge = !0 : i.modules.frozen.edge = !1, i.parent.isGroup ? this.layoutElement(this.getColGroupParentElement(i), i) : this.layoutElement(i.getElement(), i), t && i.cells.forEach((l) => {
        this.layoutElement(l.getElement(!0), i);
      });
    });
  }
  getColGroupParentElement(t) {
    return t.parent.isGroup ? this.getColGroupParentElement(t.parent) : t.getElement();
  }
  //layout columns appropriately
  layout() {
    this.active && !this.blocked && (this.layoutColumnPosition(), this.reinitializeRows(), this.layoutCalcRows());
  }
  reinitializeRows() {
    var t = this.table.rowManager.getVisibleRows(!0), e = this.table.rowManager.getRows().filter((a) => !t.includes(a));
    e.forEach((a) => {
      a.deinitialize();
    }), t.forEach((a) => {
      a.type === "row" && this.layoutRow(a);
    });
  }
  layoutRow(t) {
    this.table.options.layout === "fitDataFill" && this.rightColumns.length && (this.table.rowManager.getTableElement().style.minWidth = "calc(100% - " + this.rightMargin + ")"), this.leftColumns.forEach((e) => {
      var a = t.getCell(e);
      a && this.layoutElement(a.getElement(!0), e);
    }), this.rightColumns.forEach((e) => {
      var a = t.getCell(e);
      a && this.layoutElement(a.getElement(!0), e);
    });
  }
  layoutElement(t, e) {
    var a;
    e.modules.frozen && t && (t.style.position = "sticky", this.table.rtl ? a = e.modules.frozen.position === "left" ? "right" : "left" : a = e.modules.frozen.position, t.style[a] = e.modules.frozen.margin, t.classList.add("tabulator-frozen"), t.classList.toggle("tabulator-frozen-left", e.modules.frozen.edge && e.modules.frozen.position === "left"), t.classList.toggle("tabulator-frozen-right", e.modules.frozen.edge && e.modules.frozen.position === "right"));
  }
  adjustForScrollbar(t) {
    this.rightColumns.length && (this.table.columnManager.getContentsElement().style.width = "calc(100% - " + t + "px)");
  }
  _calcSpace(t, e) {
    var a = 0;
    for (let n = 0; n < e; n++)
      t[n].visible && (a += t[n].getWidth());
    return a;
  }
}
BN.moduleName = "frozenColumns";
class WN extends Ze {
  constructor(t) {
    super(t), this.topElement = document.createElement("div"), this.rows = [], this.registerComponentFunction("row", "freeze", this.freezeRow.bind(this)), this.registerComponentFunction("row", "unfreeze", this.unfreezeRow.bind(this)), this.registerComponentFunction("row", "isFrozen", this.isRowFrozen.bind(this)), this.registerTableOption("frozenRowsField", "id"), this.registerTableOption("frozenRows", !1);
  }
  initialize() {
    var t = document.createDocumentFragment();
    this.rows = [], this.topElement.classList.add("tabulator-frozen-rows-holder"), t.appendChild(document.createElement("br")), t.appendChild(this.topElement), this.table.columnManager.getContentsElement().insertBefore(t, this.table.columnManager.headersElement.nextSibling), this.subscribe("row-deleting", this.detachRow.bind(this)), this.subscribe("rows-visible", this.visibleRows.bind(this)), this.registerDisplayHandler(this.getRows.bind(this), 10), this.table.options.frozenRows && (this.subscribe("data-processed", this.initializeRows.bind(this)), this.subscribe("row-added", this.initializeRow.bind(this)), this.subscribe("table-redrawing", this.resizeHolderWidth.bind(this)), this.subscribe("column-resized", this.resizeHolderWidth.bind(this)), this.subscribe("column-show", this.resizeHolderWidth.bind(this)), this.subscribe("column-hide", this.resizeHolderWidth.bind(this))), this.resizeHolderWidth();
  }
  resizeHolderWidth() {
    this.topElement.style.minWidth = this.table.columnManager.headersElement.offsetWidth + "px";
  }
  initializeRows() {
    this.table.rowManager.getRows().forEach((t) => {
      this.initializeRow(t);
    });
  }
  initializeRow(t) {
    var e = this.table.options.frozenRows, a = typeof e;
    a === "number" ? t.getPosition() && t.getPosition() + this.rows.length <= e && this.freezeRow(t) : a === "function" ? e.call(this.table, t.getComponent()) && this.freezeRow(t) : Array.isArray(e) && e.includes(t.data[this.options("frozenRowsField")]) && this.freezeRow(t);
  }
  isRowFrozen(t) {
    var e = this.rows.indexOf(t);
    return e > -1;
  }
  isFrozen() {
    return !!this.rows.length;
  }
  visibleRows(t, e) {
    return this.rows.forEach((a) => {
      e.push(a);
    }), e;
  }
  //filter frozen rows out of display data
  getRows(t) {
    var e = t.slice(0);
    return this.rows.forEach(function(a) {
      var n = e.indexOf(a);
      n > -1 && e.splice(n, 1);
    }), e;
  }
  freezeRow(t) {
    t.modules.frozen ? console.warn("Freeze Error - Row is already frozen") : (t.modules.frozen = !0, this.topElement.appendChild(t.getElement()), t.initialize(), t.normalizeHeight(), this.rows.push(t), this.refreshData(!1, "display"), this.table.rowManager.adjustTableSize(), this.styleRows());
  }
  unfreezeRow(t) {
    t.modules.frozen ? (t.modules.frozen = !1, this.detachRow(t), this.table.rowManager.adjustTableSize(), this.refreshData(!1, "display"), this.rows.length && this.styleRows()) : console.warn("Freeze Error - Row is already unfrozen");
  }
  detachRow(t) {
    var e = this.rows.indexOf(t);
    if (e > -1) {
      var a = t.getElement();
      a.parentNode && a.parentNode.removeChild(a), this.rows.splice(e, 1);
    }
  }
  styleRows(t) {
    this.rows.forEach((e, a) => {
      this.table.rowManager.styleRow(e, a);
    });
  }
}
WN.moduleName = "frozenRows";
class P4 {
  constructor(t) {
    return this._group = t, this.type = "GroupComponent", new Proxy(this, {
      get: function(e, a, n) {
        return typeof e[a] < "u" ? e[a] : e._group.groupManager.table.componentFunctionBinder.handle("group", e._group, a);
      }
    });
  }
  getKey() {
    return this._group.key;
  }
  getField() {
    return this._group.field;
  }
  getElement() {
    return this._group.element;
  }
  getRows() {
    return this._group.getRows(!0);
  }
  getSubGroups() {
    return this._group.getSubGroups(!0);
  }
  getParentGroup() {
    return this._group.parent ? this._group.parent.getComponent() : !1;
  }
  isVisible() {
    return this._group.visible;
  }
  show() {
    this._group.show();
  }
  hide() {
    this._group.hide();
  }
  toggle() {
    this._group.toggleVisibility();
  }
  scrollTo(t, e) {
    return this._group.groupManager.table.rowManager.scrollToRow(this._group, t, e);
  }
  _getSelf() {
    return this._group;
  }
  getTable() {
    return this._group.groupManager.table;
  }
}
class ac {
  constructor(t, e, a, n, i, r, l) {
    this.groupManager = t, this.parent = e, this.key = n, this.level = a, this.field = i, this.hasSubGroups = a < t.groupIDLookups.length - 1, this.addRow = this.hasSubGroups ? this._addRowToGroup : this._addRow, this.type = "group", this.old = l, this.rows = [], this.groups = [], this.groupList = [], this.generator = r, this.element = !1, this.elementContents = !1, this.height = 0, this.outerHeight = 0, this.initialized = !1, this.calcs = {}, this.initialized = !1, this.modules = {}, this.arrowElement = !1, this.visible = l ? l.visible : typeof t.startOpen[a] < "u" ? t.startOpen[a] : t.startOpen[0], this.component = null, this.createElements(), this.addBindings(), this.createValueGroups();
  }
  wipe(t) {
    t || (this.groupList.length ? this.groupList.forEach(function(e) {
      e.wipe();
    }) : this.rows.forEach((e) => {
      e.modules && delete e.modules.group;
    })), this.element = !1, this.arrowElement = !1, this.elementContents = !1;
  }
  createElements() {
    var t = document.createElement("div");
    t.classList.add("tabulator-arrow"), this.element = document.createElement("div"), this.element.classList.add("tabulator-row"), this.element.classList.add("tabulator-group"), this.element.classList.add("tabulator-group-level-" + this.level), this.element.setAttribute("role", "rowgroup"), this.arrowElement = document.createElement("div"), this.arrowElement.classList.add("tabulator-group-toggle"), this.arrowElement.appendChild(t), this.groupManager.table.options.movableRows !== !1 && this.groupManager.table.modExists("moveRow") && this.groupManager.table.modules.moveRow.initializeGroupHeader(this);
  }
  createValueGroups() {
    var t = this.level + 1;
    this.groupManager.allowedValues && this.groupManager.allowedValues[t] && this.groupManager.allowedValues[t].forEach((e) => {
      this._createGroup(e, t);
    });
  }
  addBindings() {
    var t;
    this.groupManager.table.options.groupToggleElement && (t = this.groupManager.table.options.groupToggleElement == "arrow" ? this.arrowElement : this.element, t.addEventListener("click", (e) => {
      this.groupManager.table.options.groupToggleElement === "arrow" && (e.stopPropagation(), e.stopImmediatePropagation()), setTimeout(() => {
        this.toggleVisibility();
      });
    }));
  }
  _createGroup(t, e) {
    var a = e + "_" + t, n = new ac(this.groupManager, this, e, t, this.groupManager.groupIDLookups[e].field, this.groupManager.headerGenerator[e] || this.groupManager.headerGenerator[0], this.old ? this.old.groups[a] : !1);
    this.groups[a] = n, this.groupList.push(n);
  }
  _addRowToGroup(t) {
    var e = this.level + 1;
    if (this.hasSubGroups) {
      var a = this.groupManager.groupIDLookups[e].func(t.getData()), n = e + "_" + a;
      this.groupManager.allowedValues && this.groupManager.allowedValues[e] ? this.groups[n] && this.groups[n].addRow(t) : (this.groups[n] || this._createGroup(a, e), this.groups[n].addRow(t));
    }
  }
  _addRow(t) {
    this.rows.push(t), t.modules.group = this;
  }
  insertRow(t, e, a) {
    var n = this.conformRowData({});
    t.updateData(n);
    var i = this.rows.indexOf(e);
    i > -1 ? a ? this.rows.splice(i + 1, 0, t) : this.rows.splice(i, 0, t) : a ? this.rows.push(t) : this.rows.unshift(t), t.modules.group = this, this.groupManager.table.modExists("columnCalcs") && this.groupManager.table.options.columnCalcs != "table" && this.groupManager.table.modules.columnCalcs.recalcGroup(this), this.groupManager.updateGroupRows(!0);
  }
  scrollHeader(t) {
    this.arrowElement && (this.arrowElement.style.marginLeft = t, this.groupList.forEach(function(e) {
      e.scrollHeader(t);
    }));
  }
  getRowIndex(t) {
  }
  //update row data to match grouping constraints
  conformRowData(t) {
    return this.field ? t[this.field] = this.key : console.warn("Data Conforming Error - Cannot conform row data to match new group as groupBy is a function"), this.parent && (t = this.parent.conformRowData(t)), t;
  }
  removeRow(t) {
    var e = this.rows.indexOf(t), a = t.getElement();
    e > -1 && this.rows.splice(e, 1), !this.groupManager.table.options.groupValues && !this.rows.length ? (this.parent ? this.parent.removeGroup(this) : this.groupManager.removeGroup(this), this.groupManager.updateGroupRows(!0)) : (a.parentNode && a.parentNode.removeChild(a), this.groupManager.blockRedraw || (this.generateGroupHeaderContents(), this.groupManager.table.modExists("columnCalcs") && this.groupManager.table.options.columnCalcs != "table" && this.groupManager.table.modules.columnCalcs.recalcGroup(this)));
  }
  removeGroup(t) {
    var e = t.level + "_" + t.key, a;
    this.groups[e] && (delete this.groups[e], a = this.groupList.indexOf(t), a > -1 && this.groupList.splice(a, 1), this.groupList.length || (this.parent ? this.parent.removeGroup(this) : this.groupManager.removeGroup(this)));
  }
  getHeadersAndRows() {
    var t = [];
    return t.push(this), this._visSet(), this.calcs.top && (this.calcs.top.detachElement(), this.calcs.top.deleteCells()), this.calcs.bottom && (this.calcs.bottom.detachElement(), this.calcs.bottom.deleteCells()), this.visible ? this.groupList.length ? this.groupList.forEach(function(e) {
      t = t.concat(e.getHeadersAndRows());
    }) : (this.groupManager.table.options.columnCalcs != "table" && this.groupManager.table.modExists("columnCalcs") && this.groupManager.table.modules.columnCalcs.hasTopCalcs() && (this.calcs.top = this.groupManager.table.modules.columnCalcs.generateTopRow(this.rows), t.push(this.calcs.top)), t = t.concat(this.rows), this.groupManager.table.options.columnCalcs != "table" && this.groupManager.table.modExists("columnCalcs") && this.groupManager.table.modules.columnCalcs.hasBottomCalcs() && (this.calcs.bottom = this.groupManager.table.modules.columnCalcs.generateBottomRow(this.rows), t.push(this.calcs.bottom))) : !this.groupList.length && this.groupManager.table.options.columnCalcs != "table" && this.groupManager.table.modExists("columnCalcs") && (this.groupManager.table.modules.columnCalcs.hasTopCalcs() && this.groupManager.table.options.groupClosedShowCalcs && (this.calcs.top = this.groupManager.table.modules.columnCalcs.generateTopRow(this.rows), t.push(this.calcs.top)), this.groupManager.table.modules.columnCalcs.hasBottomCalcs() && this.groupManager.table.options.groupClosedShowCalcs && (this.calcs.bottom = this.groupManager.table.modules.columnCalcs.generateBottomRow(this.rows), t.push(this.calcs.bottom))), t;
  }
  getData(t, e) {
    var a = [];
    return this._visSet(), (!t || t && this.visible) && this.rows.forEach((n) => {
      a.push(n.getData(e || "data"));
    }), a;
  }
  getRowCount() {
    var t = 0;
    return this.groupList.length ? this.groupList.forEach((e) => {
      t += e.getRowCount();
    }) : t = this.rows.length, t;
  }
  toggleVisibility() {
    this.visible ? this.hide() : this.show();
  }
  hide() {
    this.visible = !1, this.groupManager.table.rowManager.getRenderMode() == "basic" && !this.groupManager.table.options.pagination ? (this.element.classList.remove("tabulator-group-visible"), this.groupList.length ? this.groupList.forEach((t) => {
      var e = t.getHeadersAndRows();
      e.forEach((a) => {
        a.detachElement();
      });
    }) : this.rows.forEach((t) => {
      var e = t.getElement();
      e.parentNode.removeChild(e);
    }), this.groupManager.updateGroupRows(!0)) : this.groupManager.updateGroupRows(!0), this.groupManager.table.externalEvents.dispatch("groupVisibilityChanged", this.getComponent(), !1);
  }
  show() {
    if (this.visible = !0, this.groupManager.table.rowManager.getRenderMode() == "basic" && !this.groupManager.table.options.pagination) {
      this.element.classList.add("tabulator-group-visible");
      var t = this.generateElement();
      this.groupList.length ? this.groupList.forEach((e) => {
        var a = e.getHeadersAndRows();
        a.forEach((n) => {
          var i = n.getElement();
          t.parentNode.insertBefore(i, t.nextSibling), n.initialize(), t = i;
        });
      }) : this.rows.forEach((e) => {
        var a = e.getElement();
        t.parentNode.insertBefore(a, t.nextSibling), e.initialize(), t = a;
      }), this.groupManager.updateGroupRows(!0);
    } else
      this.groupManager.updateGroupRows(!0);
    this.groupManager.table.externalEvents.dispatch("groupVisibilityChanged", this.getComponent(), !0);
  }
  _visSet() {
    var t = [];
    typeof this.visible == "function" && (this.rows.forEach(function(e) {
      t.push(e.getData());
    }), this.visible = this.visible(this.key, this.getRowCount(), t, this.getComponent()));
  }
  getRowGroup(t) {
    var e = !1;
    return this.groupList.length ? this.groupList.forEach(function(a) {
      var n = a.getRowGroup(t);
      n && (e = n);
    }) : this.rows.find(function(a) {
      return a === t;
    }) && (e = this), e;
  }
  getSubGroups(t) {
    var e = [];
    return this.groupList.forEach(function(a) {
      e.push(t ? a.getComponent() : a);
    }), e;
  }
  getRows(t, e) {
    var a = [];
    return e && this.groupList.length ? this.groupList.forEach((n) => {
      a = a.concat(n.getRows(t, e));
    }) : this.rows.forEach(function(n) {
      a.push(t ? n.getComponent() : n);
    }), a;
  }
  generateGroupHeaderContents() {
    var t = [], e = this.getRows(!1, !0);
    for (e.forEach(function(a) {
      t.push(a.getData());
    }), this.elementContents = this.generator(this.key, this.getRowCount(), t, this.getComponent()); this.element.firstChild; )
      this.element.removeChild(this.element.firstChild);
    typeof this.elementContents == "string" ? this.element.innerHTML = this.elementContents : this.element.appendChild(this.elementContents), this.element.insertBefore(this.arrowElement, this.element.firstChild);
  }
  getPath(t = []) {
    return t.unshift(this.key), this.parent && this.parent.getPath(t), t;
  }
  ////////////// Standard Row Functions //////////////
  getElement() {
    return this.elementContents ? this.element : this.generateElement();
  }
  generateElement() {
    this.addBindings = !1, this._visSet(), this.visible ? this.element.classList.add("tabulator-group-visible") : this.element.classList.remove("tabulator-group-visible");
    for (var t = 0; t < this.element.childNodes.length; ++t)
      this.element.childNodes[t].parentNode.removeChild(this.element.childNodes[t]);
    return this.generateGroupHeaderContents(), this.element;
  }
  detachElement() {
    this.element && this.element.parentNode && this.element.parentNode.removeChild(this.element);
  }
  //normalize the height of elements in the row
  normalizeHeight() {
    this.setHeight(this.element.clientHeight);
  }
  initialize(t) {
    (!this.initialized || t) && (this.normalizeHeight(), this.initialized = !0);
  }
  reinitialize() {
    this.initialized = !1, this.height = 0, za.elVisible(this.element) && this.initialize(!0);
  }
  setHeight(t) {
    this.height != t && (this.height = t, this.outerHeight = this.element.offsetHeight);
  }
  //return rows outer height
  getHeight() {
    return this.outerHeight;
  }
  getGroup() {
    return this;
  }
  reinitializeHeight() {
  }
  calcHeight() {
  }
  setCellHeight() {
  }
  clearCellHeight() {
  }
  deinitializeHeight() {
  }
  rendered() {
  }
  //////////////// Object Generation /////////////////
  getComponent() {
    return this.component || (this.component = new P4(this)), this.component;
  }
}
class jN extends Ze {
  constructor(t) {
    super(t), this.groupIDLookups = !1, this.startOpen = [function() {
      return !1;
    }], this.headerGenerator = [function() {
      return "";
    }], this.groupList = [], this.allowedValues = !1, this.groups = {}, this.displayHandler = this.getRows.bind(this), this.blockRedraw = !1, this.registerTableOption("groupBy", !1), this.registerTableOption("groupStartOpen", !0), this.registerTableOption("groupValues", !1), this.registerTableOption("groupUpdateOnCellEdit", !1), this.registerTableOption("groupHeader", !1), this.registerTableOption("groupHeaderPrint", null), this.registerTableOption("groupHeaderClipboard", null), this.registerTableOption("groupHeaderHtmlOutput", null), this.registerTableOption("groupHeaderDownload", null), this.registerTableOption("groupToggleElement", "arrow"), this.registerTableOption("groupClosedShowCalcs", !1), this.registerTableFunction("setGroupBy", this.setGroupBy.bind(this)), this.registerTableFunction("setGroupValues", this.setGroupValues.bind(this)), this.registerTableFunction("setGroupStartOpen", this.setGroupStartOpen.bind(this)), this.registerTableFunction("setGroupHeader", this.setGroupHeader.bind(this)), this.registerTableFunction("getGroups", this.userGetGroups.bind(this)), this.registerTableFunction("getGroupedData", this.userGetGroupedData.bind(this)), this.registerComponentFunction("row", "getGroup", this.rowGetGroup.bind(this));
  }
  //initialize group configuration
  initialize() {
    this.subscribe("table-destroy", this._blockRedrawing.bind(this)), this.subscribe("rows-wipe", this._blockRedrawing.bind(this)), this.subscribe("rows-wiped", this._restore_redrawing.bind(this)), this.table.options.groupBy && (this.table.options.groupUpdateOnCellEdit && (this.subscribe("cell-value-updated", this.cellUpdated.bind(this)), this.subscribe("row-data-changed", this.reassignRowToGroup.bind(this), 0)), this.subscribe("table-built", this.configureGroupSetup.bind(this)), this.subscribe("row-deleting", this.rowDeleting.bind(this)), this.subscribe("row-deleted", this.rowsUpdated.bind(this)), this.subscribe("scroll-horizontal", this.scrollHeaders.bind(this)), this.subscribe("rows-wipe", this.wipe.bind(this)), this.subscribe("rows-added", this.rowsUpdated.bind(this)), this.subscribe("row-moving", this.rowMoving.bind(this)), this.subscribe("row-adding-index", this.rowAddingIndex.bind(this)), this.subscribe("rows-sample", this.rowSample.bind(this)), this.subscribe("render-virtual-fill", this.virtualRenderFill.bind(this)), this.registerDisplayHandler(this.displayHandler, 20), this.initialized = !0);
  }
  _blockRedrawing() {
    this.blockRedraw = !0;
  }
  _restore_redrawing() {
    this.blockRedraw = !1;
  }
  configureGroupSetup() {
    if (this.table.options.groupBy) {
      var t = this.table.options.groupBy, e = this.table.options.groupStartOpen, a = this.table.options.groupHeader;
      if (this.allowedValues = this.table.options.groupValues, Array.isArray(t) && Array.isArray(a) && t.length > a.length && console.warn("Error creating group headers, groupHeader array is shorter than groupBy array"), this.headerGenerator = [function() {
        return "";
      }], this.startOpen = [function() {
        return !1;
      }], this.langBind("groups|item", (i, r) => {
        this.headerGenerator[0] = (l, o, c) => (typeof l > "u" ? "" : l) + "<span>(" + o + " " + (o === 1 ? i : r.groups.items) + ")</span>";
      }), this.groupIDLookups = [], t)
        this.table.modExists("columnCalcs") && this.table.options.columnCalcs != "table" && this.table.options.columnCalcs != "both" && this.table.modules.columnCalcs.removeCalcs();
      else if (this.table.modExists("columnCalcs") && this.table.options.columnCalcs != "group") {
        var n = this.table.columnManager.getRealColumns();
        n.forEach((i) => {
          i.definition.topCalc && this.table.modules.columnCalcs.initializeTopRow(), i.definition.bottomCalc && this.table.modules.columnCalcs.initializeBottomRow();
        });
      }
      Array.isArray(t) || (t = [t]), t.forEach((i, r) => {
        var l, o;
        typeof i == "function" ? l = i : (o = this.table.columnManager.getColumnByField(i), o ? l = function(c) {
          return o.getFieldValue(c);
        } : l = function(c) {
          return c[i];
        }), this.groupIDLookups.push({
          field: typeof i == "function" ? !1 : i,
          func: l,
          values: this.allowedValues ? this.allowedValues[r] : !1
        });
      }), e && (Array.isArray(e) || (e = [e]), e.forEach((i) => {
      }), this.startOpen = e), a && (this.headerGenerator = Array.isArray(a) ? a : [a]);
    } else
      this.groupList = [], this.groups = {};
  }
  rowSample(t, e) {
    if (this.table.options.groupBy) {
      var a = this.getGroups(!1)[0];
      e.push(a.getRows(!1)[0]);
    }
    return e;
  }
  virtualRenderFill() {
    var t = this.table.rowManager.tableElement, e = this.table.rowManager.getVisibleRows();
    if (this.table.options.groupBy)
      e = e.filter((a) => a.type !== "group"), t.style.minWidth = e.length ? "" : this.table.columnManager.getWidth() + "px";
    else
      return e;
  }
  rowAddingIndex(t, e, a) {
    if (this.table.options.groupBy) {
      this.assignRowToGroup(t);
      var n = t.modules.group.rows;
      return n.length > 1 && (!e || e && n.indexOf(e) == -1 ? a ? n[0] !== t && (e = n[0], this.table.rowManager.moveRowInArray(t.modules.group.rows, t, e, !a)) : n[n.length - 1] !== t && (e = n[n.length - 1], this.table.rowManager.moveRowInArray(t.modules.group.rows, t, e, !a)) : this.table.rowManager.moveRowInArray(t.modules.group.rows, t, e, !a)), e;
    }
  }
  trackChanges() {
    this.dispatch("group-changed");
  }
  ///////////////////////////////////
  ///////// Table Functions /////////
  ///////////////////////////////////
  setGroupBy(t) {
    this.table.options.groupBy = t, this.initialized || this.initialize(), this.configureGroupSetup(), !t && this.table.modExists("columnCalcs") && this.table.options.columnCalcs === !0 && this.table.modules.columnCalcs.reinitializeCalcs(), this.refreshData(), this.trackChanges();
  }
  setGroupValues(t) {
    this.table.options.groupValues = t, this.configureGroupSetup(), this.refreshData(), this.trackChanges();
  }
  setGroupStartOpen(t) {
    this.table.options.groupStartOpen = t, this.configureGroupSetup(), this.table.options.groupBy ? (this.refreshData(), this.trackChanges()) : console.warn("Grouping Update - cant refresh view, no groups have been set");
  }
  setGroupHeader(t) {
    this.table.options.groupHeader = t, this.configureGroupSetup(), this.table.options.groupBy ? (this.refreshData(), this.trackChanges()) : console.warn("Grouping Update - cant refresh view, no groups have been set");
  }
  userGetGroups(t) {
    return this.getGroups(!0);
  }
  // get grouped table data in the same format as getData()
  userGetGroupedData() {
    return this.table.options.groupBy ? this.getGroupedData() : this.getData();
  }
  ///////////////////////////////////////
  ///////// Component Functions /////////
  ///////////////////////////////////////
  rowGetGroup(t) {
    return t.modules.group ? t.modules.group.getComponent() : !1;
  }
  ///////////////////////////////////
  ///////// Internal Logic //////////
  ///////////////////////////////////
  rowMoving(t, e, a) {
    if (this.table.options.groupBy) {
      !a && e instanceof ac && (e = this.table.rowManager.prevDisplayRow(t) || e);
      var n = e instanceof ac ? e : e.modules.group, i = t instanceof ac ? t : t.modules.group;
      n === i ? this.table.rowManager.moveRowInArray(n.rows, t, e, a) : (i && i.removeRow(t), n.insertRow(t, e, a));
    }
  }
  rowDeleting(t) {
    this.table.options.groupBy && t.modules.group && t.modules.group.removeRow(t);
  }
  rowsUpdated(t) {
    this.table.options.groupBy && this.updateGroupRows(!0);
  }
  cellUpdated(t) {
    this.table.options.groupBy && this.reassignRowToGroup(t.row);
  }
  //return appropriate rows with group headers
  getRows(t) {
    return this.table.options.groupBy && this.groupIDLookups.length ? (this.dispatchExternal("dataGrouping"), this.generateGroups(t), this.subscribedExternal("dataGrouped") && this.dispatchExternal("dataGrouped", this.getGroups(!0)), this.updateGroupRows()) : t.slice(0);
  }
  getGroups(t) {
    var e = [];
    return this.groupList.forEach(function(a) {
      e.push(t ? a.getComponent() : a);
    }), e;
  }
  getChildGroups(t) {
    var e = [];
    return t || (t = this), t.groupList.forEach((a) => {
      a.groupList.length ? e = e.concat(this.getChildGroups(a)) : e.push(a);
    }), e;
  }
  wipe() {
    this.table.options.groupBy && (this.groupList.forEach(function(t) {
      t.wipe();
    }), this.groupList = [], this.groups = {});
  }
  pullGroupListData(t) {
    var e = [];
    return t.forEach((a) => {
      var n = {};
      n.level = 0, n.rowCount = 0, n.headerContent = "";
      var i = [];
      a.hasSubGroups ? (i = this.pullGroupListData(a.groupList), n.level = a.level, n.rowCount = i.length - a.groupList.length, n.headerContent = a.generator(a.key, n.rowCount, a.rows, a), e.push(n), e = e.concat(i)) : (n.level = a.level, n.headerContent = a.generator(a.key, a.rows.length, a.rows, a), n.rowCount = a.getRows().length, e.push(n), a.getRows().forEach((r) => {
        e.push(r.getData("data"));
      }));
    }), e;
  }
  getGroupedData() {
    return this.pullGroupListData(this.groupList);
  }
  getRowGroup(t) {
    var e = !1;
    return this.options("dataTree") && (t = this.table.modules.dataTree.getTreeParentRoot(t)), this.groupList.forEach((a) => {
      var n = a.getRowGroup(t);
      n && (e = n);
    }), e;
  }
  countGroups() {
    return this.groupList.length;
  }
  generateGroups(t) {
    var e = this.groups;
    this.groups = {}, this.groupList = [], this.allowedValues && this.allowedValues[0] ? (this.allowedValues[0].forEach((a) => {
      this.createGroup(a, 0, e);
    }), t.forEach((a) => {
      this.assignRowToExistingGroup(a, e);
    })) : t.forEach((a) => {
      this.assignRowToGroup(a, e);
    }), Object.values(e).forEach((a) => {
      a.wipe(!0);
    });
  }
  createGroup(t, e, a) {
    var n = e + "_" + t, i;
    a = a || [], i = new ac(this, !1, e, t, this.groupIDLookups[0].field, this.headerGenerator[0], a[n]), this.groups[n] = i, this.groupList.push(i);
  }
  assignRowToExistingGroup(t, e) {
    var a = this.groupIDLookups[0].func(t.getData()), n = "0_" + a;
    this.groups[n] && this.groups[n].addRow(t);
  }
  assignRowToGroup(t, e) {
    var a = this.groupIDLookups[0].func(t.getData()), n = !this.groups["0_" + a];
    return n && this.createGroup(a, 0, e), this.groups["0_" + a].addRow(t), !n;
  }
  reassignRowToGroup(t) {
    if (t.type === "row") {
      var e = t.modules.group, a = e.getPath(), n = this.getExpectedPath(t), i;
      i = a.length == n.length && a.every((r, l) => r === n[l]), i || (e.removeRow(t), this.assignRowToGroup(t, this.groups), this.refreshData(!0));
    }
  }
  getExpectedPath(t) {
    var e = [], a = t.getData();
    return this.groupIDLookups.forEach((n) => {
      e.push(n.func(a));
    }), e;
  }
  updateGroupRows(t) {
    var e = [];
    return this.blockRedraw || (this.groupList.forEach((a) => {
      e = e.concat(a.getHeadersAndRows());
    }), t && this.refreshData(!0)), e;
  }
  scrollHeaders(t) {
    this.table.options.groupBy && (this.table.options.renderHorizontal === "virtual" && (t -= this.table.columnManager.renderer.vDomPadLeft), t = t + "px", this.groupList.forEach((e) => {
      e.scrollHeader(t);
    }));
  }
  removeGroup(t) {
    var e = t.level + "_" + t.key, a;
    this.groups[e] && (delete this.groups[e], a = this.groupList.indexOf(t), a > -1 && this.groupList.splice(a, 1));
  }
  checkBasicModeGroupHeaderWidth() {
    var t = this.table.rowManager.tableElement, e = !0;
    this.table.rowManager.getDisplayRows().forEach((a, n) => {
      this.table.rowManager.styleRow(a, n), t.appendChild(a.getElement()), a.initialize(!0), a.type !== "group" && (e = !1);
    }), e ? t.style.minWidth = this.table.columnManager.getWidth() + "px" : t.style.minWidth = "";
  }
}
jN.moduleName = "groupRows";
var E4 = {
  cellEdit: function(s) {
    s.component.setValueProcessData(s.data.oldValue), s.component.cellRendered();
  },
  rowAdd: function(s) {
    s.component.deleteActual(), this.table.rowManager.checkPlaceholder();
  },
  rowDelete: function(s) {
    var t = this.table.rowManager.addRowActual(s.data.data, s.data.pos, s.data.index);
    this.table.options.groupBy && this.table.modExists("groupRows") && this.table.modules.groupRows.updateGroupRows(!0), this._rebindRow(s.component, t), this.table.rowManager.checkPlaceholder();
  },
  rowMove: function(s) {
    var t = s.data.posFrom - s.data.posTo > 0;
    this.table.rowManager.moveRowActual(s.component, this.table.rowManager.getRowFromPosition(s.data.posFrom), t), this.table.rowManager.regenerateRowPositions(), this.table.rowManager.reRenderInPosition();
  }
}, N4 = {
  cellEdit: function(s) {
    s.component.setValueProcessData(s.data.newValue), s.component.cellRendered();
  },
  rowAdd: function(s) {
    var t = this.table.rowManager.addRowActual(s.data.data, s.data.pos, s.data.index);
    this.table.options.groupBy && this.table.modExists("groupRows") && this.table.modules.groupRows.updateGroupRows(!0), this._rebindRow(s.component, t), this.table.rowManager.checkPlaceholder();
  },
  rowDelete: function(s) {
    s.component.deleteActual(), this.table.rowManager.checkPlaceholder();
  },
  rowMove: function(s) {
    this.table.rowManager.moveRowActual(s.component, this.table.rowManager.getRowFromPosition(s.data.posTo), s.data.after), this.table.rowManager.regenerateRowPositions(), this.table.rowManager.reRenderInPosition();
  }
};
class to extends Ze {
  constructor(t) {
    super(t), this.history = [], this.index = -1, this.registerTableOption("history", !1);
  }
  initialize() {
    this.table.options.history && (this.subscribe("cell-value-updated", this.cellUpdated.bind(this)), this.subscribe("cell-delete", this.clearComponentHistory.bind(this)), this.subscribe("row-delete", this.rowDeleted.bind(this)), this.subscribe("rows-wipe", this.clear.bind(this)), this.subscribe("row-added", this.rowAdded.bind(this)), this.subscribe("row-move", this.rowMoved.bind(this))), this.registerTableFunction("undo", this.undo.bind(this)), this.registerTableFunction("redo", this.redo.bind(this)), this.registerTableFunction("getHistoryUndoSize", this.getHistoryUndoSize.bind(this)), this.registerTableFunction("getHistoryRedoSize", this.getHistoryRedoSize.bind(this)), this.registerTableFunction("clearHistory", this.clear.bind(this));
  }
  rowMoved(t, e, a) {
    this.action("rowMove", t, { posFrom: t.getPosition(), posTo: e.getPosition(), to: e, after: a });
  }
  rowAdded(t, e, a, n) {
    this.action("rowAdd", t, { data: e, pos: a, index: n });
  }
  rowDeleted(t) {
    var e, a;
    this.table.options.groupBy ? (a = t.getComponent().getGroup()._getSelf().rows, e = a.indexOf(t), e && (e = a[e - 1])) : (e = t.table.rowManager.getRowIndex(t), e && (e = t.table.rowManager.rows[e - 1])), this.action("rowDelete", t, { data: t.getData(), pos: !e, index: e });
  }
  cellUpdated(t) {
    this.action("cellEdit", t, { oldValue: t.oldValue, newValue: t.value });
  }
  clear() {
    this.history = [], this.index = -1;
  }
  action(t, e, a) {
    this.history = this.history.slice(0, this.index + 1), this.history.push({
      type: t,
      component: e,
      data: a
    }), this.index++;
  }
  getHistoryUndoSize() {
    return this.index + 1;
  }
  getHistoryRedoSize() {
    return this.history.length - (this.index + 1);
  }
  clearComponentHistory(t) {
    var e = this.history.findIndex(function(a) {
      return a.component === t;
    });
    e > -1 && (this.history.splice(e, 1), e <= this.index && this.index--, this.clearComponentHistory(t));
  }
  undo() {
    if (this.index > -1) {
      let t = this.history[this.index];
      return to.undoers[t.type].call(this, t), this.index--, this.dispatchExternal("historyUndo", t.type, t.component.getComponent(), t.data), !0;
    } else
      return console.warn(this.options("history") ? "History Undo Error - No more history to undo" : "History module not enabled"), !1;
  }
  redo() {
    if (this.history.length - 1 > this.index) {
      this.index++;
      let t = this.history[this.index];
      return to.redoers[t.type].call(this, t), this.dispatchExternal("historyRedo", t.type, t.component.getComponent(), t.data), !0;
    } else
      return console.warn(this.options("history") ? "History Redo Error - No more history to redo" : "History module not enabled"), !1;
  }
  //rebind rows to new element after deletion
  _rebindRow(t, e) {
    this.history.forEach(function(a) {
      if (a.component instanceof ss)
        a.component === t && (a.component = e);
      else if (a.component instanceof tp && a.component.row === t) {
        var n = a.component.column.getField();
        n && (a.component = e.getCell(n));
      }
    });
  }
}
to.moduleName = "history";
to.undoers = E4;
to.redoers = N4;
class VN extends Ze {
  constructor(t) {
    super(t), this.fieldIndex = [], this.hasIndex = !1;
  }
  initialize() {
    this.tableElementCheck();
  }
  tableElementCheck() {
    this.table.originalElement && this.table.originalElement.tagName === "TABLE" && (this.table.originalElement.childNodes.length ? this.parseTable() : console.warn("Unable to parse data from empty table tag, Tabulator should be initialized on a div tag unless importing data from a table element."));
  }
  parseTable() {
    var t = this.table.originalElement, e = this.table.options, a = t.getElementsByTagName("th"), n = t.getElementsByTagName("tbody")[0], i = [];
    this.hasIndex = !1, this.dispatchExternal("htmlImporting"), n = n ? n.getElementsByTagName("tr") : [], this._extractOptions(t, e), a.length ? this._extractHeaders(a, n) : this._generateBlankHeaders(a, n);
    for (var r = 0; r < n.length; r++) {
      var l = n[r], o = l.getElementsByTagName("td"), c = {};
      this.hasIndex || (c[e.index] = r);
      for (var d = 0; d < o.length; d++) {
        var p = o[d];
        typeof this.fieldIndex[d] < "u" && (c[this.fieldIndex[d]] = p.innerHTML);
      }
      i.push(c);
    }
    e.data = i, this.dispatchExternal("htmlImported");
  }
  //extract tabulator attribute options
  _extractOptions(t, e, a) {
    var n = t.attributes, i = Object.keys(a || e), r = {};
    i.forEach((d) => {
      r[d.toLowerCase()] = d;
    });
    for (var l in n) {
      var o = n[l], c;
      o && typeof o == "object" && o.name && o.name.indexOf("tabulator-") === 0 && (c = o.name.replace("tabulator-", ""), typeof r[c] < "u" && (e[r[c]] = this._attribValue(o.value)));
    }
  }
  //get value of attribute
  _attribValue(t) {
    return t === "true" ? !0 : t === "false" ? !1 : t;
  }
  //find column if it has already been defined
  _findCol(t) {
    var e = this.table.options.columns.find((a) => a.title === t);
    return e || !1;
  }
  //extract column from headers
  _extractHeaders(t, e) {
    for (var a = 0; a < t.length; a++) {
      var n = t[a], i = !1, r = this._findCol(n.textContent), l;
      r ? i = !0 : r = { title: n.textContent.trim() }, r.field || (r.field = n.textContent.trim().toLowerCase().replaceAll(" ", "_")), l = n.getAttribute("width"), l && !r.width && (r.width = l), this._extractOptions(n, r, this.table.columnManager.optionsList.registeredDefaults), this.fieldIndex[a] = r.field, r.field == this.table.options.index && (this.hasIndex = !0), i || this.table.options.columns.push(r);
    }
  }
  //generate blank headers
  _generateBlankHeaders(t, e) {
    for (var a = 0; a < t.length; a++) {
      var n = t[a], i = { title: "", field: "col" + a };
      this.fieldIndex[a] = i.field;
      var r = n.getAttribute("width");
      r && (i.width = r), this.table.options.columns.push(i);
    }
  }
}
VN.moduleName = "htmlTableImport";
function R4(s) {
  var t = [], e = 0, a = 0, n = !1;
  for (let i = 0; i < s.length; i++) {
    let r = s[i], l = s[i + 1];
    if (t[e] || (t[e] = []), t[e][a] || (t[e][a] = ""), r == '"' && n && l == '"') {
      t[e][a] += r, i++;
      continue;
    }
    if (r == '"') {
      n = !n;
      continue;
    }
    if (r == "," && !n) {
      a++;
      continue;
    }
    if (r == "\r" && l == `
` && !n) {
      a = 0, e++, i++;
      continue;
    }
    if ((r == "\r" || r == `
`) && !n) {
      a = 0, e++;
      continue;
    }
    t[e][a] += r;
  }
  return t;
}
function Y4(s) {
  try {
    return JSON.parse(s);
  } catch (t) {
    return console.warn("JSON Import Error - File contents is invalid JSON", t), Promise.reject();
  }
}
function _4(s) {
  return s;
}
var O4 = {
  csv: R4,
  json: Y4,
  array: _4
};
class ap extends Ze {
  constructor(t) {
    super(t), this.registerTableOption("importFormat"), this.registerTableOption("importReader", "text");
  }
  initialize() {
    this.registerTableFunction("import", this.importFromFile.bind(this)), this.table.options.importFormat && (this.subscribe("data-loading", this.loadDataCheck.bind(this), 10), this.subscribe("data-load", this.loadData.bind(this), 10));
  }
  loadDataCheck(t) {
    return this.table.options.importFormat && (typeof t == "string" || Array.isArray(t) && t.length && Array.isArray(t));
  }
  loadData(t, e, a, n, i) {
    return this.importData(this.lookupImporter(), t).then(this.structureData.bind(this)).catch((r) => (console.error("Import Error:", r || "Unable to import data"), Promise.reject(r)));
  }
  lookupImporter(t) {
    var e;
    return t || (t = this.table.options.importFormat), typeof t == "string" ? e = ap.importers[t] : e = t, e || console.error("Import Error - Importer not found:", t), e;
  }
  importFromFile(t, e) {
    var a = this.lookupImporter(t);
    if (a)
      return this.pickFile(e).then(this.importData.bind(this, a)).then(this.structureData.bind(this)).then(this.setData.bind(this)).catch((n) => (console.error("Import Error:", n || "Unable to import file"), Promise.reject(n)));
  }
  pickFile(t) {
    return new Promise((e, a) => {
      var n = document.createElement("input");
      n.type = "file", n.accept = t, n.addEventListener("change", (i) => {
        var r = n.files[0], l = new FileReader();
        switch (this.table.options.importReader) {
          case "buffer":
            l.readAsArrayBuffer(r);
            break;
          case "binary":
            l.readAsBinaryString(r);
            break;
          case "url":
            l.readAsDataURL(r);
            break;
          case "text":
          default:
            l.readAsText(r);
        }
        l.onload = (o) => {
          e(l.result);
        }, l.onerror = (o) => {
          console.warn("File Load Error - Unable to read file"), a();
        };
      }), n.click();
    });
  }
  importData(t, e) {
    var a = t.call(this.table, e);
    return a instanceof Promise ? a : a ? Promise.resolve(a) : Promise.reject();
  }
  structureData(t) {
    var e = [];
    return Array.isArray(t) && t.length && Array.isArray(t[0]) ? (this.table.options.autoColumns ? e = this.structureArrayToObject(t) : e = this.structureArrayToColumns(t), e) : t;
  }
  structureArrayToObject(t) {
    var e = t.shift(), a = t.map((n) => {
      var i = {};
      return e.forEach((r, l) => {
        i[r] = n[l];
      }), i;
    });
    return a;
  }
  structureArrayToColumns(t) {
    var e = [], a = this.table.getColumns();
    return a[0] && t[0][0] && a[0].getDefinition().title === t[0][0] && t.shift(), t.forEach((n) => {
      var i = {};
      n.forEach((r, l) => {
        var o = a[l];
        o && (i[o.getField()] = r);
      }), e.push(i);
    }), e;
  }
  setData(t) {
    return this.table.setData(t);
  }
}
ap.moduleName = "import";
ap.importers = O4;
class qN extends Ze {
  constructor(t) {
    super(t), this.eventMap = {
      //row events
      rowClick: "row-click",
      rowDblClick: "row-dblclick",
      rowContext: "row-contextmenu",
      rowMouseEnter: "row-mouseenter",
      rowMouseLeave: "row-mouseleave",
      rowMouseOver: "row-mouseover",
      rowMouseOut: "row-mouseout",
      rowMouseMove: "row-mousemove",
      rowMouseDown: "row-mousedown",
      rowMouseUp: "row-mouseup",
      rowTap: "row",
      rowDblTap: "row",
      rowTapHold: "row",
      //cell events
      cellClick: "cell-click",
      cellDblClick: "cell-dblclick",
      cellContext: "cell-contextmenu",
      cellMouseEnter: "cell-mouseenter",
      cellMouseLeave: "cell-mouseleave",
      cellMouseOver: "cell-mouseover",
      cellMouseOut: "cell-mouseout",
      cellMouseMove: "cell-mousemove",
      cellMouseDown: "cell-mousedown",
      cellMouseUp: "cell-mouseup",
      cellTap: "cell",
      cellDblTap: "cell",
      cellTapHold: "cell",
      //column header events
      headerClick: "column-click",
      headerDblClick: "column-dblclick",
      headerContext: "column-contextmenu",
      headerMouseEnter: "column-mouseenter",
      headerMouseLeave: "column-mouseleave",
      headerMouseOver: "column-mouseover",
      headerMouseOut: "column-mouseout",
      headerMouseMove: "column-mousemove",
      headerMouseDown: "column-mousedown",
      headerMouseUp: "column-mouseup",
      headerTap: "column",
      headerDblTap: "column",
      headerTapHold: "column",
      //group header
      groupClick: "group-click",
      groupDblClick: "group-dblclick",
      groupContext: "group-contextmenu",
      groupMouseEnter: "group-mouseenter",
      groupMouseLeave: "group-mouseleave",
      groupMouseOver: "group-mouseover",
      groupMouseOut: "group-mouseout",
      groupMouseMove: "group-mousemove",
      groupMouseDown: "group-mousedown",
      groupMouseUp: "group-mouseup",
      groupTap: "group",
      groupDblTap: "group",
      groupTapHold: "group"
    }, this.subscribers = {}, this.touchSubscribers = {}, this.columnSubscribers = {}, this.touchWatchers = {
      row: {
        tap: null,
        tapDbl: null,
        tapHold: null
      },
      cell: {
        tap: null,
        tapDbl: null,
        tapHold: null
      },
      column: {
        tap: null,
        tapDbl: null,
        tapHold: null
      },
      group: {
        tap: null,
        tapDbl: null,
        tapHold: null
      }
    }, this.registerColumnOption("headerClick"), this.registerColumnOption("headerDblClick"), this.registerColumnOption("headerContext"), this.registerColumnOption("headerMouseEnter"), this.registerColumnOption("headerMouseLeave"), this.registerColumnOption("headerMouseOver"), this.registerColumnOption("headerMouseOut"), this.registerColumnOption("headerMouseMove"), this.registerColumnOption("headerMouseDown"), this.registerColumnOption("headerMouseUp"), this.registerColumnOption("headerTap"), this.registerColumnOption("headerDblTap"), this.registerColumnOption("headerTapHold"), this.registerColumnOption("cellClick"), this.registerColumnOption("cellDblClick"), this.registerColumnOption("cellContext"), this.registerColumnOption("cellMouseEnter"), this.registerColumnOption("cellMouseLeave"), this.registerColumnOption("cellMouseOver"), this.registerColumnOption("cellMouseOut"), this.registerColumnOption("cellMouseMove"), this.registerColumnOption("cellMouseDown"), this.registerColumnOption("cellMouseUp"), this.registerColumnOption("cellTap"), this.registerColumnOption("cellDblTap"), this.registerColumnOption("cellTapHold");
  }
  initialize() {
    this.initializeExternalEvents(), this.subscribe("column-init", this.initializeColumn.bind(this)), this.subscribe("cell-dblclick", this.cellContentsSelectionFixer.bind(this)), this.subscribe("scroll-horizontal", this.clearTouchWatchers.bind(this)), this.subscribe("scroll-vertical", this.clearTouchWatchers.bind(this));
  }
  clearTouchWatchers() {
    var t = Object.values(this.touchWatchers);
    t.forEach((e) => {
      for (let a in e)
        e[a] = null;
    });
  }
  cellContentsSelectionFixer(t, e) {
    var a;
    if (!(this.table.modExists("edit") && this.table.modules.edit.currentCell === e)) {
      t.preventDefault();
      try {
        document.selection ? (a = document.body.createTextRange(), a.moveToElementText(e.getElement()), a.select()) : window.getSelection && (a = document.createRange(), a.selectNode(e.getElement()), window.getSelection().removeAllRanges(), window.getSelection().addRange(a));
      } catch {
      }
    }
  }
  initializeExternalEvents() {
    for (let t in this.eventMap)
      this.subscriptionChangeExternal(t, this.subscriptionChanged.bind(this, t));
  }
  subscriptionChanged(t, e) {
    e ? this.subscribers[t] || (this.eventMap[t].includes("-") ? (this.subscribers[t] = this.handle.bind(this, t), this.subscribe(this.eventMap[t], this.subscribers[t])) : this.subscribeTouchEvents(t)) : this.eventMap[t].includes("-") ? this.subscribers[t] && !this.columnSubscribers[t] && !this.subscribedExternal(t) && (this.unsubscribe(this.eventMap[t], this.subscribers[t]), delete this.subscribers[t]) : this.unsubscribeTouchEvents(t);
  }
  subscribeTouchEvents(t) {
    var e = this.eventMap[t];
    this.touchSubscribers[e + "-touchstart"] || (this.touchSubscribers[e + "-touchstart"] = this.handleTouch.bind(this, e, "start"), this.touchSubscribers[e + "-touchend"] = this.handleTouch.bind(this, e, "end"), this.subscribe(e + "-touchstart", this.touchSubscribers[e + "-touchstart"]), this.subscribe(e + "-touchend", this.touchSubscribers[e + "-touchend"])), this.subscribers[t] = !0;
  }
  unsubscribeTouchEvents(t) {
    var e = !0, a = this.eventMap[t];
    if (this.subscribers[t] && !this.subscribedExternal(t)) {
      delete this.subscribers[t];
      for (let n in this.eventMap)
        this.eventMap[n] === a && this.subscribers[n] && (e = !1);
      e && (this.unsubscribe(a + "-touchstart", this.touchSubscribers[a + "-touchstart"]), this.unsubscribe(a + "-touchend", this.touchSubscribers[a + "-touchend"]), delete this.touchSubscribers[a + "-touchstart"], delete this.touchSubscribers[a + "-touchend"]);
    }
  }
  initializeColumn(t) {
    var e = t.definition;
    for (let a in this.eventMap)
      e[a] && (this.subscriptionChanged(a, !0), this.columnSubscribers[a] || (this.columnSubscribers[a] = []), this.columnSubscribers[a].push(t));
  }
  handle(t, e, a) {
    this.dispatchEvent(t, e, a);
  }
  handleTouch(t, e, a, n) {
    var i = this.touchWatchers[t];
    switch (t === "column" && (t = "header"), e) {
      case "start":
        i.tap = !0, clearTimeout(i.tapHold), i.tapHold = setTimeout(() => {
          clearTimeout(i.tapHold), i.tapHold = null, i.tap = null, clearTimeout(i.tapDbl), i.tapDbl = null, this.dispatchEvent(t + "TapHold", a, n);
        }, 1e3);
        break;
      case "end":
        i.tap && (i.tap = null, this.dispatchEvent(t + "Tap", a, n)), i.tapDbl ? (clearTimeout(i.tapDbl), i.tapDbl = null, this.dispatchEvent(t + "DblTap", a, n)) : i.tapDbl = setTimeout(() => {
          clearTimeout(i.tapDbl), i.tapDbl = null;
        }, 300), clearTimeout(i.tapHold), i.tapHold = null;
        break;
    }
  }
  dispatchEvent(t, e, a) {
    var n = a.getComponent(), i;
    this.columnSubscribers[t] && (a instanceof tp ? i = a.column.definition[t] : a instanceof zi && (i = a.definition[t]), i && i(e, n)), this.dispatchExternal(t, e, n);
  }
}
qN.moduleName = "interaction";
var M4 = {
  navPrev: "shift + 9",
  navNext: 9,
  navUp: 38,
  navDown: 40,
  navLeft: 37,
  navRight: 39,
  scrollPageUp: 33,
  scrollPageDown: 34,
  scrollToStart: 36,
  scrollToEnd: 35,
  undo: ["ctrl + 90", "meta + 90"],
  redo: ["ctrl + 89", "meta + 89"],
  copyToClipboard: ["ctrl + 67", "meta + 67"],
  rangeJumpUp: ["ctrl + 38", "meta + 38"],
  rangeJumpDown: ["ctrl + 40", "meta + 40"],
  rangeJumpLeft: ["ctrl + 37", "meta + 37"],
  rangeJumpRight: ["ctrl + 39", "meta + 39"],
  rangeExpandUp: "shift + 38",
  rangeExpandDown: "shift + 40",
  rangeExpandLeft: "shift + 37",
  rangeExpandRight: "shift + 39",
  rangeExpandJumpUp: ["ctrl + shift + 38", "meta + shift + 38"],
  rangeExpandJumpDown: ["ctrl + shift + 40", "meta + shift + 40"],
  rangeExpandJumpLeft: ["ctrl + shift + 37", "meta + shift + 37"],
  rangeExpandJumpRight: ["ctrl + shift + 39", "meta + shift + 39"]
}, X4 = {
  keyBlock: function(s) {
    s.stopPropagation(), s.preventDefault();
  },
  scrollPageUp: function(s) {
    var t = this.table.rowManager, e = t.scrollTop - t.element.clientHeight;
    s.preventDefault(), t.displayRowsCount && (e >= 0 ? t.element.scrollTop = e : t.scrollToRow(t.getDisplayRows()[0])), this.table.element.focus();
  },
  scrollPageDown: function(s) {
    var t = this.table.rowManager, e = t.scrollTop + t.element.clientHeight, a = t.element.scrollHeight;
    s.preventDefault(), t.displayRowsCount && (e <= a ? t.element.scrollTop = e : t.scrollToRow(t.getDisplayRows()[t.displayRowsCount - 1])), this.table.element.focus();
  },
  scrollToStart: function(s) {
    var t = this.table.rowManager;
    s.preventDefault(), t.displayRowsCount && t.scrollToRow(t.getDisplayRows()[0]), this.table.element.focus();
  },
  scrollToEnd: function(s) {
    var t = this.table.rowManager;
    s.preventDefault(), t.displayRowsCount && t.scrollToRow(t.getDisplayRows()[t.displayRowsCount - 1]), this.table.element.focus();
  },
  navPrev: function(s) {
    this.dispatch("keybinding-nav-prev", s);
  },
  navNext: function(s) {
    this.dispatch("keybinding-nav-next", s);
  },
  navLeft: function(s) {
    this.dispatch("keybinding-nav-left", s);
  },
  navRight: function(s) {
    this.dispatch("keybinding-nav-right", s);
  },
  navUp: function(s) {
    this.dispatch("keybinding-nav-up", s);
  },
  navDown: function(s) {
    this.dispatch("keybinding-nav-down", s);
  },
  rangeJumpLeft: function(s) {
    this.dispatch("keybinding-nav-range", s, "left", !0, !1);
  },
  rangeJumpRight: function(s) {
    this.dispatch("keybinding-nav-range", s, "right", !0, !1);
  },
  rangeJumpUp: function(s) {
    this.dispatch("keybinding-nav-range", s, "up", !0, !1);
  },
  rangeJumpDown: function(s) {
    this.dispatch("keybinding-nav-range", s, "down", !0, !1);
  },
  rangeExpandLeft: function(s) {
    this.dispatch("keybinding-nav-range", s, "left", !1, !0);
  },
  rangeExpandRight: function(s) {
    this.dispatch("keybinding-nav-range", s, "right", !1, !0);
  },
  rangeExpandUp: function(s) {
    this.dispatch("keybinding-nav-range", s, "up", !1, !0);
  },
  rangeExpandDown: function(s) {
    this.dispatch("keybinding-nav-range", s, "down", !1, !0);
  },
  rangeExpandJumpLeft: function(s) {
    this.dispatch("keybinding-nav-range", s, "left", !0, !0);
  },
  rangeExpandJumpRight: function(s) {
    this.dispatch("keybinding-nav-range", s, "right", !0, !0);
  },
  rangeExpandJumpUp: function(s) {
    this.dispatch("keybinding-nav-range", s, "up", !0, !0);
  },
  rangeExpandJumpDown: function(s) {
    this.dispatch("keybinding-nav-range", s, "down", !0, !0);
  },
  undo: function(s) {
    var t = !1;
    this.table.options.history && this.table.modExists("history") && this.table.modExists("edit") && (t = this.table.modules.edit.currentCell, t || (s.preventDefault(), this.table.modules.history.undo()));
  },
  redo: function(s) {
    var t = !1;
    this.table.options.history && this.table.modExists("history") && this.table.modExists("edit") && (t = this.table.modules.edit.currentCell, t || (s.preventDefault(), this.table.modules.history.redo()));
  },
  copyToClipboard: function(s) {
    this.table.modules.edit.currentCell || this.table.modExists("clipboard", !0) && this.table.modules.clipboard.copy(!1, !0);
  }
};
class Zr extends Ze {
  constructor(t) {
    super(t), this.watchKeys = null, this.pressedKeys = null, this.keyupBinding = !1, this.keydownBinding = !1, this.registerTableOption("keybindings", {}), this.registerTableOption("tabEndNewRow", !1);
  }
  initialize() {
    var t = this.table.options.keybindings, e = {};
    this.watchKeys = {}, this.pressedKeys = [], t !== !1 && (Object.assign(e, Zr.bindings), Object.assign(e, t), this.mapBindings(e), this.bindEvents()), this.subscribe("table-destroy", this.clearBindings.bind(this));
  }
  mapBindings(t) {
    for (let e in t)
      Zr.actions[e] ? t[e] && (typeof t[e] != "object" && (t[e] = [t[e]]), t[e].forEach((a) => {
        var n = Array.isArray(a) ? a : [a];
        n.forEach((i) => {
          this.mapBinding(e, i);
        });
      })) : console.warn("Key Binding Error - no such action:", e);
  }
  mapBinding(t, e) {
    var a = {
      action: Zr.actions[t],
      keys: [],
      ctrl: !1,
      shift: !1,
      meta: !1
    }, n = e.toString().toLowerCase().split(" ").join("").split("+");
    n.forEach((i) => {
      switch (i) {
        case "ctrl":
          a.ctrl = !0;
          break;
        case "shift":
          a.shift = !0;
          break;
        case "meta":
          a.meta = !0;
          break;
        default:
          i = isNaN(i) ? i.toUpperCase().charCodeAt(0) : parseInt(i), a.keys.push(i), this.watchKeys[i] || (this.watchKeys[i] = []), this.watchKeys[i].push(a);
      }
    });
  }
  bindEvents() {
    var t = this;
    this.keyupBinding = function(e) {
      var a = e.keyCode, n = t.watchKeys[a];
      n && (t.pressedKeys.push(a), n.forEach(function(i) {
        t.checkBinding(e, i);
      }));
    }, this.keydownBinding = function(e) {
      var a = e.keyCode, n = t.watchKeys[a];
      if (n) {
        var i = t.pressedKeys.indexOf(a);
        i > -1 && t.pressedKeys.splice(i, 1);
      }
    }, this.table.element.addEventListener("keydown", this.keyupBinding), this.table.element.addEventListener("keyup", this.keydownBinding);
  }
  clearBindings() {
    this.keyupBinding && this.table.element.removeEventListener("keydown", this.keyupBinding), this.keydownBinding && this.table.element.removeEventListener("keyup", this.keydownBinding);
  }
  checkBinding(t, e) {
    var a = !0;
    return t.ctrlKey == e.ctrl && t.shiftKey == e.shift && t.metaKey == e.meta ? (e.keys.forEach((n) => {
      var i = this.pressedKeys.indexOf(n);
      i == -1 && (a = !1);
    }), a && e.action.call(this, t), !0) : !1;
  }
}
Zr.moduleName = "keybindings";
Zr.bindings = M4;
Zr.actions = X4;
class KN extends Ze {
  constructor(t) {
    super(t), this.menuContainer = null, this.nestedMenuBlock = !1, this.currentComponent = null, this.rootPopup = null, this.columnSubscribers = {}, this.registerTableOption("menuContainer", void 0), this.registerTableOption("rowContextMenu", !1), this.registerTableOption("rowClickMenu", !1), this.registerTableOption("rowDblClickMenu", !1), this.registerTableOption("groupContextMenu", !1), this.registerTableOption("groupClickMenu", !1), this.registerTableOption("groupDblClickMenu", !1), this.registerColumnOption("headerContextMenu"), this.registerColumnOption("headerClickMenu"), this.registerColumnOption("headerDblClickMenu"), this.registerColumnOption("headerMenu"), this.registerColumnOption("headerMenuIcon"), this.registerColumnOption("contextMenu"), this.registerColumnOption("clickMenu"), this.registerColumnOption("dblClickMenu");
  }
  initialize() {
    this.deprecatedOptionsCheck(), this.initializeRowWatchers(), this.initializeGroupWatchers(), this.subscribe("column-init", this.initializeColumn.bind(this));
  }
  deprecatedOptionsCheck() {
    this.deprecationCheck("menuContainer", "popupContainer") || (this.table.options.popupContainer = this.table.options.menuContainer);
  }
  initializeRowWatchers() {
    this.table.options.rowContextMenu && (this.subscribe("row-contextmenu", this.loadMenuEvent.bind(this, this.table.options.rowContextMenu)), this.table.on("rowTapHold", this.loadMenuEvent.bind(this, this.table.options.rowContextMenu))), this.table.options.rowClickMenu && this.subscribe("row-click", this.loadMenuEvent.bind(this, this.table.options.rowClickMenu)), this.table.options.rowDblClickMenu && this.subscribe("row-dblclick", this.loadMenuEvent.bind(this, this.table.options.rowDblClickMenu));
  }
  initializeGroupWatchers() {
    this.table.options.groupContextMenu && (this.subscribe("group-contextmenu", this.loadMenuEvent.bind(this, this.table.options.groupContextMenu)), this.table.on("groupTapHold", this.loadMenuEvent.bind(this, this.table.options.groupContextMenu))), this.table.options.groupClickMenu && this.subscribe("group-click", this.loadMenuEvent.bind(this, this.table.options.groupClickMenu)), this.table.options.groupDblClickMenu && this.subscribe("group-dblclick", this.loadMenuEvent.bind(this, this.table.options.groupDblClickMenu));
  }
  initializeColumn(t) {
    var e = t.definition;
    e.headerContextMenu && !this.columnSubscribers.headerContextMenu && (this.columnSubscribers.headerContextMenu = this.loadMenuTableColumnEvent.bind(this, "headerContextMenu"), this.subscribe("column-contextmenu", this.columnSubscribers.headerContextMenu), this.table.on("headerTapHold", this.loadMenuTableColumnEvent.bind(this, "headerContextMenu"))), e.headerClickMenu && !this.columnSubscribers.headerClickMenu && (this.columnSubscribers.headerClickMenu = this.loadMenuTableColumnEvent.bind(this, "headerClickMenu"), this.subscribe("column-click", this.columnSubscribers.headerClickMenu)), e.headerDblClickMenu && !this.columnSubscribers.headerDblClickMenu && (this.columnSubscribers.headerDblClickMenu = this.loadMenuTableColumnEvent.bind(this, "headerDblClickMenu"), this.subscribe("column-dblclick", this.columnSubscribers.headerDblClickMenu)), e.headerMenu && this.initializeColumnHeaderMenu(t), e.contextMenu && !this.columnSubscribers.contextMenu && (this.columnSubscribers.contextMenu = this.loadMenuTableCellEvent.bind(this, "contextMenu"), this.subscribe("cell-contextmenu", this.columnSubscribers.contextMenu), this.table.on("cellTapHold", this.loadMenuTableCellEvent.bind(this, "contextMenu"))), e.clickMenu && !this.columnSubscribers.clickMenu && (this.columnSubscribers.clickMenu = this.loadMenuTableCellEvent.bind(this, "clickMenu"), this.subscribe("cell-click", this.columnSubscribers.clickMenu)), e.dblClickMenu && !this.columnSubscribers.dblClickMenu && (this.columnSubscribers.dblClickMenu = this.loadMenuTableCellEvent.bind(this, "dblClickMenu"), this.subscribe("cell-dblclick", this.columnSubscribers.dblClickMenu));
  }
  initializeColumnHeaderMenu(t) {
    var e = t.definition.headerMenuIcon, a;
    a = document.createElement("span"), a.classList.add("tabulator-header-popup-button"), e ? (typeof e == "function" && (e = e(t.getComponent())), e instanceof HTMLElement ? a.appendChild(e) : a.innerHTML = e) : a.innerHTML = "&vellip;", a.addEventListener("click", (n) => {
      n.stopPropagation(), n.preventDefault(), this.loadMenuEvent(t.definition.headerMenu, n, t);
    }), t.titleElement.insertBefore(a, t.titleElement.firstChild);
  }
  loadMenuTableCellEvent(t, e, a) {
    a._cell && (a = a._cell), a.column.definition[t] && this.loadMenuEvent(a.column.definition[t], e, a);
  }
  loadMenuTableColumnEvent(t, e, a) {
    a._column && (a = a._column), a.definition[t] && this.loadMenuEvent(a.definition[t], e, a);
  }
  loadMenuEvent(t, e, a) {
    a._group ? a = a._group : a._row && (a = a._row), t = typeof t == "function" ? t.call(this.table, e, a.getComponent()) : t, this.loadMenu(e, a, t);
  }
  loadMenu(t, e, a, n, i) {
    var r = !(t instanceof MouseEvent), l = document.createElement("div"), o;
    if (l.classList.add("tabulator-menu"), r || t.preventDefault(), !(!a || !a.length)) {
      if (n)
        o = i.child(l);
      else {
        if (this.nestedMenuBlock) {
          if (this.rootPopup)
            return;
        } else
          this.nestedMenuBlock = setTimeout(() => {
            this.nestedMenuBlock = !1;
          }, 100);
        this.rootPopup && this.rootPopup.hide(), this.rootPopup = o = this.popup(l);
      }
      a.forEach((c) => {
        var d = document.createElement("div"), p = c.label, h = c.disabled;
        c.separator ? d.classList.add("tabulator-menu-separator") : (d.classList.add("tabulator-menu-item"), typeof p == "function" && (p = p.call(this.table, e.getComponent())), p instanceof Node ? d.appendChild(p) : d.innerHTML = p, typeof h == "function" && (h = h.call(this.table, e.getComponent())), h ? (d.classList.add("tabulator-menu-item-disabled"), d.addEventListener("click", (g) => {
          g.stopPropagation();
        })) : c.menu && c.menu.length ? d.addEventListener("click", (g) => {
          g.stopPropagation(), this.loadMenu(g, e, c.menu, d, o);
        }) : c.action && d.addEventListener("click", (g) => {
          c.action(g, e.getComponent());
        }), c.menu && c.menu.length && d.classList.add("tabulator-menu-item-submenu")), l.appendChild(d);
      }), l.addEventListener("click", (c) => {
        this.rootPopup && this.rootPopup.hide();
      }), o.show(n || t), o === this.rootPopup && (this.rootPopup.hideOnBlur(() => {
        this.rootPopup = null, this.currentComponent && (this.dispatch("menu-closed", a, o), this.dispatchExternal("menuClosed", this.currentComponent.getComponent()), this.currentComponent = null);
      }), this.currentComponent = e, this.dispatch("menu-opened", a, o), this.dispatchExternal("menuOpened", e.getComponent()));
    }
  }
}
KN.moduleName = "menu";
class JN extends Ze {
  constructor(t) {
    super(t), this.placeholderElement = this.createPlaceholderElement(), this.hoverElement = !1, this.checkTimeout = !1, this.checkPeriod = 250, this.moving = !1, this.toCol = !1, this.toColAfter = !1, this.startX = 0, this.autoScrollMargin = 40, this.autoScrollStep = 5, this.autoScrollTimeout = !1, this.touchMove = !1, this.moveHover = this.moveHover.bind(this), this.endMove = this.endMove.bind(this), this.registerTableOption("movableColumns", !1);
  }
  createPlaceholderElement() {
    var t = document.createElement("div");
    return t.classList.add("tabulator-col"), t.classList.add("tabulator-col-placeholder"), t;
  }
  initialize() {
    this.table.options.movableColumns && (this.subscribe("column-init", this.initializeColumn.bind(this)), this.subscribe("alert-show", this.abortMove.bind(this)));
  }
  abortMove() {
    clearTimeout(this.checkTimeout);
  }
  initializeColumn(t) {
    var e = this, a = {}, n;
    !t.modules.frozen && !t.isGroup && (n = t.getElement(), a.mousemove = function(i) {
      t.parent === e.moving.parent && ((e.touchMove ? i.touches[0].pageX : i.pageX) - za.elOffset(n).left + e.table.columnManager.contentsElement.scrollLeft > t.getWidth() / 2 ? (e.toCol !== t || !e.toColAfter) && (n.parentNode.insertBefore(e.placeholderElement, n.nextSibling), e.moveColumn(t, !0)) : (e.toCol !== t || e.toColAfter) && (n.parentNode.insertBefore(e.placeholderElement, n), e.moveColumn(t, !1)));
    }.bind(e), n.addEventListener("mousedown", function(i) {
      e.touchMove = !1, i.which === 1 && (e.checkTimeout = setTimeout(function() {
        e.startMove(i, t);
      }, e.checkPeriod));
    }), n.addEventListener("mouseup", function(i) {
      i.which === 1 && e.checkTimeout && clearTimeout(e.checkTimeout);
    }), e.bindTouchEvents(t)), t.modules.moveColumn = a;
  }
  bindTouchEvents(t) {
    var e = t.getElement(), a = !1, n, i, r, l, o, c;
    e.addEventListener("touchstart", (d) => {
      this.checkTimeout = setTimeout(() => {
        this.touchMove = !0, n = t.nextColumn(), r = n ? n.getWidth() / 2 : 0, i = t.prevColumn(), l = i ? i.getWidth() / 2 : 0, o = 0, c = 0, a = !1, this.startMove(d, t);
      }, this.checkPeriod);
    }, { passive: !0 }), e.addEventListener("touchmove", (d) => {
      var p, h;
      this.moving && (this.moveHover(d), a || (a = d.touches[0].pageX), p = d.touches[0].pageX - a, p > 0 ? n && p - o > r && (h = n, h !== t && (a = d.touches[0].pageX, h.getElement().parentNode.insertBefore(this.placeholderElement, h.getElement().nextSibling), this.moveColumn(h, !0))) : i && -p - c > l && (h = i, h !== t && (a = d.touches[0].pageX, h.getElement().parentNode.insertBefore(this.placeholderElement, h.getElement()), this.moveColumn(h, !1))), h && (n = h.nextColumn(), o = r, r = n ? n.getWidth() / 2 : 0, i = h.prevColumn(), c = l, l = i ? i.getWidth() / 2 : 0));
    }, { passive: !0 }), e.addEventListener("touchend", (d) => {
      this.checkTimeout && clearTimeout(this.checkTimeout), this.moving && this.endMove(d);
    });
  }
  startMove(t, e) {
    var a = e.getElement(), n = this.table.columnManager.getContentsElement(), i = this.table.columnManager.getHeadersElement();
    this.moving = e, this.startX = (this.touchMove ? t.touches[0].pageX : t.pageX) - za.elOffset(a).left, this.table.element.classList.add("tabulator-block-select"), this.placeholderElement.style.width = e.getWidth() + "px", this.placeholderElement.style.height = e.getHeight() + "px", a.parentNode.insertBefore(this.placeholderElement, a), a.parentNode.removeChild(a), this.hoverElement = a.cloneNode(!0), this.hoverElement.classList.add("tabulator-moving"), n.appendChild(this.hoverElement), this.hoverElement.style.left = "0", this.hoverElement.style.bottom = n.clientHeight - i.offsetHeight + "px", this.touchMove || (this._bindMouseMove(), document.body.addEventListener("mousemove", this.moveHover), document.body.addEventListener("mouseup", this.endMove)), this.moveHover(t);
  }
  _bindMouseMove() {
    this.table.columnManager.columnsByIndex.forEach(function(t) {
      t.modules.moveColumn.mousemove && t.getElement().addEventListener("mousemove", t.modules.moveColumn.mousemove);
    });
  }
  _unbindMouseMove() {
    this.table.columnManager.columnsByIndex.forEach(function(t) {
      t.modules.moveColumn.mousemove && t.getElement().removeEventListener("mousemove", t.modules.moveColumn.mousemove);
    });
  }
  moveColumn(t, e) {
    var a = this.moving.getCells();
    this.toCol = t, this.toColAfter = e, e ? t.getCells().forEach(function(n, i) {
      var r = n.getElement(!0);
      r.parentNode && a[i] && r.parentNode.insertBefore(a[i].getElement(), r.nextSibling);
    }) : t.getCells().forEach(function(n, i) {
      var r = n.getElement(!0);
      r.parentNode && a[i] && r.parentNode.insertBefore(a[i].getElement(), r);
    });
  }
  endMove(t) {
    (t.which === 1 || this.touchMove) && (this._unbindMouseMove(), this.placeholderElement.parentNode.insertBefore(this.moving.getElement(), this.placeholderElement.nextSibling), this.placeholderElement.parentNode.removeChild(this.placeholderElement), this.hoverElement.parentNode.removeChild(this.hoverElement), this.table.element.classList.remove("tabulator-block-select"), this.toCol && this.table.columnManager.moveColumnActual(this.moving, this.toCol, this.toColAfter), this.moving = !1, this.toCol = !1, this.toColAfter = !1, this.touchMove || (document.body.removeEventListener("mousemove", this.moveHover), document.body.removeEventListener("mouseup", this.endMove)));
  }
  moveHover(t) {
    var e = this.table.columnManager.getContentsElement(), a = e.scrollLeft, n = (this.touchMove ? t.touches[0].pageX : t.pageX) - za.elOffset(e).left + a, i;
    this.hoverElement.style.left = n - this.startX + "px", n - a < this.autoScrollMargin && (this.autoScrollTimeout || (this.autoScrollTimeout = setTimeout(() => {
      i = Math.max(0, a - 5), this.table.rowManager.getElement().scrollLeft = i, this.autoScrollTimeout = !1;
    }, 1))), a + e.clientWidth - n < this.autoScrollMargin && (this.autoScrollTimeout || (this.autoScrollTimeout = setTimeout(() => {
      i = Math.min(e.clientWidth, a + 5), this.table.rowManager.getElement().scrollLeft = i, this.autoScrollTimeout = !1;
    }, 1)));
  }
}
JN.moduleName = "moveColumn";
class vf extends Ze {
  constructor(t) {
    super(t), this.placeholderElement = this.createPlaceholderElement(), this.hoverElement = !1, this.checkTimeout = !1, this.checkPeriod = 150, this.moving = !1, this.toRow = !1, this.toRowAfter = !1, this.hasHandle = !1, this.startY = 0, this.startX = 0, this.moveHover = this.moveHover.bind(this), this.endMove = this.endMove.bind(this), this.tableRowDropEvent = !1, this.touchMove = !1, this.connection = !1, this.connectionSelectorsTables = !1, this.connectionSelectorsElements = !1, this.connectionElements = [], this.connections = [], this.connectedTable = !1, this.connectedRow = !1, this.registerTableOption("movableRows", !1), this.registerTableOption("movableRowsConnectedTables", !1), this.registerTableOption("movableRowsConnectedElements", !1), this.registerTableOption("movableRowsSender", !1), this.registerTableOption("movableRowsReceiver", "insert"), this.registerColumnOption("rowHandle");
  }
  createPlaceholderElement() {
    var t = document.createElement("div");
    return t.classList.add("tabulator-row"), t.classList.add("tabulator-row-placeholder"), t;
  }
  initialize() {
    this.table.options.movableRows && (this.connectionSelectorsTables = this.table.options.movableRowsConnectedTables, this.connectionSelectorsElements = this.table.options.movableRowsConnectedElements, this.connection = this.connectionSelectorsTables || this.connectionSelectorsElements, this.subscribe("cell-init", this.initializeCell.bind(this)), this.subscribe("column-init", this.initializeColumn.bind(this)), this.subscribe("row-init", this.initializeRow.bind(this)));
  }
  initializeGroupHeader(t) {
    var e = this, a = {};
    a.mouseup = function(n) {
      e.tableRowDrop(n, t);
    }.bind(e), a.mousemove = function(n) {
      var i;
      n.pageY - za.elOffset(t.element).top + e.table.rowManager.element.scrollTop > t.getHeight() / 2 ? (e.toRow !== t || !e.toRowAfter) && (i = t.getElement(), i.parentNode.insertBefore(e.placeholderElement, i.nextSibling), e.moveRow(t, !0)) : (e.toRow !== t || e.toRowAfter) && (i = t.getElement(), i.previousSibling && (i.parentNode.insertBefore(e.placeholderElement, i), e.moveRow(t, !1)));
    }.bind(e), t.modules.moveRow = a;
  }
  initializeRow(t) {
    var e = this, a = {}, n;
    a.mouseup = function(i) {
      e.tableRowDrop(i, t);
    }.bind(e), a.mousemove = function(i) {
      var r = t.getElement();
      i.pageY - za.elOffset(r).top + e.table.rowManager.element.scrollTop > t.getHeight() / 2 ? (e.toRow !== t || !e.toRowAfter) && (r.parentNode.insertBefore(e.placeholderElement, r.nextSibling), e.moveRow(t, !0)) : (e.toRow !== t || e.toRowAfter) && (r.parentNode.insertBefore(e.placeholderElement, r), e.moveRow(t, !1));
    }.bind(e), this.hasHandle || (n = t.getElement(), n.addEventListener("mousedown", function(i) {
      i.which === 1 && (e.checkTimeout = setTimeout(function() {
        e.startMove(i, t);
      }, e.checkPeriod));
    }), n.addEventListener("mouseup", function(i) {
      i.which === 1 && e.checkTimeout && clearTimeout(e.checkTimeout);
    }), this.bindTouchEvents(t, t.getElement())), t.modules.moveRow = a;
  }
  initializeColumn(t) {
    t.definition.rowHandle && this.table.options.movableRows !== !1 && (this.hasHandle = !0);
  }
  initializeCell(t) {
    if (t.column.definition.rowHandle && this.table.options.movableRows !== !1) {
      var e = this, a = t.getElement(!0);
      a.addEventListener("mousedown", function(n) {
        n.which === 1 && (e.checkTimeout = setTimeout(function() {
          e.startMove(n, t.row);
        }, e.checkPeriod));
      }), a.addEventListener("mouseup", function(n) {
        n.which === 1 && e.checkTimeout && clearTimeout(e.checkTimeout);
      }), this.bindTouchEvents(t.row, a);
    }
  }
  bindTouchEvents(t, e) {
    var a = !1, n, i, r, l, o, c;
    e.addEventListener("touchstart", (d) => {
      this.checkTimeout = setTimeout(() => {
        this.touchMove = !0, n = t.nextRow(), r = n ? n.getHeight() / 2 : 0, i = t.prevRow(), l = i ? i.getHeight() / 2 : 0, o = 0, c = 0, a = !1, this.startMove(d, t);
      }, this.checkPeriod);
    }, { passive: !0 }), this.moving, this.toRow, this.toRowAfter, e.addEventListener("touchmove", (d) => {
      var p, h;
      this.moving && (d.preventDefault(), this.moveHover(d), a || (a = d.touches[0].pageY), p = d.touches[0].pageY - a, p > 0 ? n && p - o > r && (h = n, h !== t && (a = d.touches[0].pageY, h.getElement().parentNode.insertBefore(this.placeholderElement, h.getElement().nextSibling), this.moveRow(h, !0))) : i && -p - c > l && (h = i, h !== t && (a = d.touches[0].pageY, h.getElement().parentNode.insertBefore(this.placeholderElement, h.getElement()), this.moveRow(h, !1))), h && (n = h.nextRow(), o = r, r = n ? n.getHeight() / 2 : 0, i = h.prevRow(), c = l, l = i ? i.getHeight() / 2 : 0));
    }), e.addEventListener("touchend", (d) => {
      this.checkTimeout && clearTimeout(this.checkTimeout), this.moving && (this.endMove(d), this.touchMove = !1);
    });
  }
  _bindMouseMove() {
    this.table.rowManager.getDisplayRows().forEach((t) => {
      (t.type === "row" || t.type === "group") && t.modules.moveRow && t.modules.moveRow.mousemove && t.getElement().addEventListener("mousemove", t.modules.moveRow.mousemove);
    });
  }
  _unbindMouseMove() {
    this.table.rowManager.getDisplayRows().forEach((t) => {
      (t.type === "row" || t.type === "group") && t.modules.moveRow && t.modules.moveRow.mousemove && t.getElement().removeEventListener("mousemove", t.modules.moveRow.mousemove);
    });
  }
  startMove(t, e) {
    var a = e.getElement();
    this.setStartPosition(t, e), this.moving = e, this.table.element.classList.add("tabulator-block-select"), this.placeholderElement.style.width = e.getWidth() + "px", this.placeholderElement.style.height = e.getHeight() + "px", this.connection ? (this.table.element.classList.add("tabulator-movingrow-sending"), this.connectToTables(e)) : (a.parentNode.insertBefore(this.placeholderElement, a), a.parentNode.removeChild(a)), this.hoverElement = a.cloneNode(!0), this.hoverElement.classList.add("tabulator-moving"), this.connection ? (document.body.appendChild(this.hoverElement), this.hoverElement.style.left = "0", this.hoverElement.style.top = "0", this.hoverElement.style.width = this.table.element.clientWidth + "px", this.hoverElement.style.whiteSpace = "nowrap", this.hoverElement.style.overflow = "hidden", this.hoverElement.style.pointerEvents = "none") : (this.table.rowManager.getTableElement().appendChild(this.hoverElement), this.hoverElement.style.left = "0", this.hoverElement.style.top = "0", this._bindMouseMove()), document.body.addEventListener("mousemove", this.moveHover), document.body.addEventListener("mouseup", this.endMove), this.dispatchExternal("rowMoving", e.getComponent()), this.moveHover(t);
  }
  setStartPosition(t, e) {
    var a = this.touchMove ? t.touches[0].pageX : t.pageX, n = this.touchMove ? t.touches[0].pageY : t.pageY, i, r;
    i = e.getElement(), this.connection ? (r = i.getBoundingClientRect(), this.startX = r.left - a + window.pageXOffset, this.startY = r.top - n + window.pageYOffset) : this.startY = n - i.getBoundingClientRect().top;
  }
  endMove(t) {
    (!t || t.which === 1 || this.touchMove) && (this._unbindMouseMove(), this.connection || (this.placeholderElement.parentNode.insertBefore(this.moving.getElement(), this.placeholderElement.nextSibling), this.placeholderElement.parentNode.removeChild(this.placeholderElement)), this.hoverElement.parentNode.removeChild(this.hoverElement), this.table.element.classList.remove("tabulator-block-select"), this.toRow ? this.table.rowManager.moveRow(this.moving, this.toRow, this.toRowAfter) : this.dispatchExternal("rowMoveCancelled", this.moving.getComponent()), this.moving = !1, this.toRow = !1, this.toRowAfter = !1, document.body.removeEventListener("mousemove", this.moveHover), document.body.removeEventListener("mouseup", this.endMove), this.connection && (this.table.element.classList.remove("tabulator-movingrow-sending"), this.disconnectFromTables()));
  }
  moveRow(t, e) {
    this.toRow = t, this.toRowAfter = e;
  }
  moveHover(t) {
    this.connection ? this.moveHoverConnections.call(this, t) : this.moveHoverTable.call(this, t);
  }
  moveHoverTable(t) {
    var e = this.table.rowManager.getElement(), a = e.scrollTop, n = (this.touchMove ? t.touches[0].pageY : t.pageY) - e.getBoundingClientRect().top + a;
    this.hoverElement.style.top = Math.min(n - this.startY, this.table.rowManager.element.scrollHeight - this.hoverElement.offsetHeight) + "px";
  }
  moveHoverConnections(t) {
    this.hoverElement.style.left = this.startX + (this.touchMove ? t.touches[0].pageX : t.pageX) + "px", this.hoverElement.style.top = this.startY + (this.touchMove ? t.touches[0].pageY : t.pageY) + "px";
  }
  elementRowDrop(t, e, a) {
    this.dispatchExternal("movableRowsElementDrop", t, e, a ? a.getComponent() : !1);
  }
  //establish connection with other tables
  connectToTables(t) {
    var e;
    this.connectionSelectorsTables && (e = this.commsConnections(this.connectionSelectorsTables), this.dispatchExternal("movableRowsSendingStart", e), this.commsSend(this.connectionSelectorsTables, "moveRow", "connect", {
      row: t
    })), this.connectionSelectorsElements && (this.connectionElements = [], Array.isArray(this.connectionSelectorsElements) || (this.connectionSelectorsElements = [this.connectionSelectorsElements]), this.connectionSelectorsElements.forEach((a) => {
      typeof a == "string" ? this.connectionElements = this.connectionElements.concat(Array.prototype.slice.call(document.querySelectorAll(a))) : this.connectionElements.push(a);
    }), this.connectionElements.forEach((a) => {
      var n = (i) => {
        this.elementRowDrop(i, a, this.moving);
      };
      a.addEventListener("mouseup", n), a.tabulatorElementDropEvent = n, a.classList.add("tabulator-movingrow-receiving");
    }));
  }
  //disconnect from other tables
  disconnectFromTables() {
    var t;
    this.connectionSelectorsTables && (t = this.commsConnections(this.connectionSelectorsTables), this.dispatchExternal("movableRowsSendingStop", t), this.commsSend(this.connectionSelectorsTables, "moveRow", "disconnect")), this.connectionElements.forEach((e) => {
      e.classList.remove("tabulator-movingrow-receiving"), e.removeEventListener("mouseup", e.tabulatorElementDropEvent), delete e.tabulatorElementDropEvent;
    });
  }
  //accept incomming connection
  connect(t, e) {
    return this.connectedTable ? (console.warn("Move Row Error - Table cannot accept connection, already connected to table:", this.connectedTable), !1) : (this.connectedTable = t, this.connectedRow = e, this.table.element.classList.add("tabulator-movingrow-receiving"), this.table.rowManager.getDisplayRows().forEach((a) => {
      a.type === "row" && a.modules.moveRow && a.modules.moveRow.mouseup && a.getElement().addEventListener("mouseup", a.modules.moveRow.mouseup);
    }), this.tableRowDropEvent = this.tableRowDrop.bind(this), this.table.element.addEventListener("mouseup", this.tableRowDropEvent), this.dispatchExternal("movableRowsReceivingStart", e, t), !0);
  }
  //close incoming connection
  disconnect(t) {
    t === this.connectedTable ? (this.connectedTable = !1, this.connectedRow = !1, this.table.element.classList.remove("tabulator-movingrow-receiving"), this.table.rowManager.getDisplayRows().forEach((e) => {
      e.type === "row" && e.modules.moveRow && e.modules.moveRow.mouseup && e.getElement().removeEventListener("mouseup", e.modules.moveRow.mouseup);
    }), this.table.element.removeEventListener("mouseup", this.tableRowDropEvent), this.dispatchExternal("movableRowsReceivingStop", t)) : console.warn("Move Row Error - trying to disconnect from non connected table");
  }
  dropComplete(t, e, a) {
    var n = !1;
    if (a) {
      switch (typeof this.table.options.movableRowsSender) {
        case "string":
          n = this.senders[this.table.options.movableRowsSender];
          break;
        case "function":
          n = this.table.options.movableRowsSender;
          break;
      }
      n ? n.call(this, this.moving ? this.moving.getComponent() : void 0, e ? e.getComponent() : void 0, t) : this.table.options.movableRowsSender && console.warn("Mover Row Error - no matching sender found:", this.table.options.movableRowsSender), this.dispatchExternal("movableRowsSent", this.moving.getComponent(), e ? e.getComponent() : void 0, t);
    } else
      this.dispatchExternal("movableRowsSentFailed", this.moving.getComponent(), e ? e.getComponent() : void 0, t);
    this.endMove();
  }
  tableRowDrop(t, e) {
    var a = !1, n = !1;
    switch (t.stopImmediatePropagation(), typeof this.table.options.movableRowsReceiver) {
      case "string":
        a = this.receivers[this.table.options.movableRowsReceiver];
        break;
      case "function":
        a = this.table.options.movableRowsReceiver;
        break;
    }
    a ? n = a.call(this, this.connectedRow.getComponent(), e ? e.getComponent() : void 0, this.connectedTable) : console.warn("Mover Row Error - no matching receiver found:", this.table.options.movableRowsReceiver), n ? this.dispatchExternal("movableRowsReceived", this.connectedRow.getComponent(), e ? e.getComponent() : void 0, this.connectedTable) : this.dispatchExternal("movableRowsReceivedFailed", this.connectedRow.getComponent(), e ? e.getComponent() : void 0, this.connectedTable), this.commsSend(this.connectedTable, "moveRow", "dropcomplete", {
      row: e,
      success: n
    });
  }
  commsReceived(t, e, a) {
    switch (e) {
      case "connect":
        return this.connect(t, a.row);
      case "disconnect":
        return this.disconnect(t);
      case "dropcomplete":
        return this.dropComplete(t, a.row, a.success);
    }
  }
}
vf.prototype.receivers = {
  insert: function(s, t, e) {
    return this.table.addRow(s.getData(), void 0, t), !0;
  },
  add: function(s, t, e) {
    return this.table.addRow(s.getData()), !0;
  },
  update: function(s, t, e) {
    return t ? (t.update(s.getData()), !0) : !1;
  },
  replace: function(s, t, e) {
    return t ? (this.table.addRow(s.getData(), void 0, t), t.delete(), !0) : !1;
  }
};
vf.prototype.senders = {
  delete: function(s, t, e) {
    s.delete();
  }
};
vf.moduleName = "moveRow";
var G4 = {};
class Nc extends Ze {
  constructor(t) {
    super(t), this.allowedTypes = ["", "data", "edit", "clipboard"], this.enabled = !0, this.registerColumnOption("mutator"), this.registerColumnOption("mutatorParams"), this.registerColumnOption("mutatorData"), this.registerColumnOption("mutatorDataParams"), this.registerColumnOption("mutatorEdit"), this.registerColumnOption("mutatorEditParams"), this.registerColumnOption("mutatorClipboard"), this.registerColumnOption("mutatorClipboardParams"), this.registerColumnOption("mutateLink");
  }
  initialize() {
    this.subscribe("cell-value-changing", this.transformCell.bind(this)), this.subscribe("cell-value-changed", this.mutateLink.bind(this)), this.subscribe("column-layout", this.initializeColumn.bind(this)), this.subscribe("row-data-init-before", this.rowDataChanged.bind(this)), this.subscribe("row-data-changing", this.rowDataChanged.bind(this));
  }
  rowDataChanged(t, e, a) {
    return this.transformRow(e, "data", a);
  }
  //initialize column mutator
  initializeColumn(t) {
    var e = !1, a = {};
    this.allowedTypes.forEach((n) => {
      var i = "mutator" + (n.charAt(0).toUpperCase() + n.slice(1)), r;
      t.definition[i] && (r = this.lookupMutator(t.definition[i]), r && (e = !0, a[i] = {
        mutator: r,
        params: t.definition[i + "Params"] || {}
      }));
    }), e && (t.modules.mutate = a);
  }
  lookupMutator(t) {
    var e = !1;
    switch (typeof t) {
      case "string":
        Nc.mutators[t] ? e = Nc.mutators[t] : console.warn("Mutator Error - No such mutator found, ignoring: ", t);
        break;
      case "function":
        e = t;
        break;
    }
    return e;
  }
  //apply mutator to row
  transformRow(t, e, a) {
    var n = "mutator" + (e.charAt(0).toUpperCase() + e.slice(1)), i;
    return this.enabled && this.table.columnManager.traverse((r) => {
      var l, o, c;
      r.modules.mutate && (l = r.modules.mutate[n] || r.modules.mutate.mutator || !1, l && (i = r.getFieldValue(typeof a < "u" ? a : t), (e == "data" && !a || typeof i < "u") && (c = r.getComponent(), o = typeof l.params == "function" ? l.params(i, t, e, c) : l.params, r.setFieldValue(t, l.mutator(i, t, e, o, c)))));
    }), t;
  }
  //apply mutator to new cell value
  transformCell(t, e) {
    if (t.column.modules.mutate) {
      var a = t.column.modules.mutate.mutatorEdit || t.column.modules.mutate.mutator || !1, n = {};
      if (a)
        return n = Object.assign(n, t.row.getData()), t.column.setFieldValue(n, e), a.mutator(e, n, "edit", a.params, t.getComponent());
    }
    return e;
  }
  mutateLink(t) {
    var e = t.column.definition.mutateLink;
    e && (Array.isArray(e) || (e = [e]), e.forEach((a) => {
      var n = t.row.getCell(a);
      n && n.setValue(n.getValue(), !0, !0);
    }));
  }
  enable() {
    this.enabled = !0;
  }
  disable() {
    this.enabled = !1;
  }
}
Nc.moduleName = "mutator";
Nc.mutators = G4;
function H4(s, t, e, a, n) {
  var i = document.createElement("span"), r = document.createElement("span"), l = document.createElement("span"), o = document.createElement("span"), c = document.createElement("span"), d = document.createElement("span");
  return this.table.modules.localize.langBind("pagination|counter|showing", (p) => {
    r.innerHTML = p;
  }), this.table.modules.localize.langBind("pagination|counter|of", (p) => {
    o.innerHTML = p;
  }), this.table.modules.localize.langBind("pagination|counter|rows", (p) => {
    d.innerHTML = p;
  }), a ? (l.innerHTML = " " + t + "-" + Math.min(t + s - 1, a) + " ", c.innerHTML = " " + a + " ", i.appendChild(r), i.appendChild(l), i.appendChild(o), i.appendChild(c), i.appendChild(d)) : (l.innerHTML = " 0 ", i.appendChild(r), i.appendChild(l), i.appendChild(d)), i;
}
function U4(s, t, e, a, n) {
  var i = document.createElement("span"), r = document.createElement("span"), l = document.createElement("span"), o = document.createElement("span"), c = document.createElement("span"), d = document.createElement("span");
  return this.table.modules.localize.langBind("pagination|counter|showing", (p) => {
    r.innerHTML = p;
  }), l.innerHTML = " " + e + " ", this.table.modules.localize.langBind("pagination|counter|of", (p) => {
    o.innerHTML = p;
  }), c.innerHTML = " " + n + " ", this.table.modules.localize.langBind("pagination|counter|pages", (p) => {
    d.innerHTML = p;
  }), i.appendChild(r), i.appendChild(l), i.appendChild(o), i.appendChild(c), i.appendChild(d), i;
}
var F4 = {
  rows: H4,
  pages: U4
};
class np extends Ze {
  constructor(t) {
    super(t), this.mode = "local", this.progressiveLoad = !1, this.element = null, this.pageCounterElement = null, this.pageCounter = null, this.size = 0, this.page = 1, this.count = 5, this.max = 1, this.remoteRowCountEstimate = null, this.initialLoad = !0, this.dataChanging = !1, this.pageSizes = [], this.registerTableOption("pagination", !1), this.registerTableOption("paginationMode", "local"), this.registerTableOption("paginationSize", !1), this.registerTableOption("paginationInitialPage", 1), this.registerTableOption("paginationCounter", !1), this.registerTableOption("paginationCounterElement", !1), this.registerTableOption("paginationButtonCount", 5), this.registerTableOption("paginationSizeSelector", !1), this.registerTableOption("paginationElement", !1), this.registerTableOption("paginationAddRow", "page"), this.registerTableOption("progressiveLoad", !1), this.registerTableOption("progressiveLoadDelay", 0), this.registerTableOption("progressiveLoadScrollMargin", 0), this.registerTableFunction("setMaxPage", this.setMaxPage.bind(this)), this.registerTableFunction("setPage", this.setPage.bind(this)), this.registerTableFunction("setPageToRow", this.userSetPageToRow.bind(this)), this.registerTableFunction("setPageSize", this.userSetPageSize.bind(this)), this.registerTableFunction("getPageSize", this.getPageSize.bind(this)), this.registerTableFunction("previousPage", this.previousPage.bind(this)), this.registerTableFunction("nextPage", this.nextPage.bind(this)), this.registerTableFunction("getPage", this.getPage.bind(this)), this.registerTableFunction("getPageMax", this.getPageMax.bind(this)), this.registerComponentFunction("row", "pageTo", this.setPageToRow.bind(this));
  }
  initialize() {
    this.table.options.pagination ? (this.subscribe("row-deleted", this.rowsUpdated.bind(this)), this.subscribe("row-added", this.rowsUpdated.bind(this)), this.subscribe("data-processed", this.initialLoadComplete.bind(this)), this.subscribe("table-built", this.calculatePageSizes.bind(this)), this.subscribe("footer-redraw", this.footerRedraw.bind(this)), this.table.options.paginationAddRow == "page" && this.subscribe("row-adding-position", this.rowAddingPosition.bind(this)), this.table.options.paginationMode === "remote" && (this.subscribe("data-params", this.remotePageParams.bind(this)), this.subscribe("data-loaded", this._parseRemoteData.bind(this))), this.table.options.progressiveLoad && console.error("Progressive Load Error - Pagination and progressive load cannot be used at the same time"), this.registerDisplayHandler(this.restOnRenderBefore.bind(this), 40), this.registerDisplayHandler(this.getRows.bind(this), 50), this.createElements(), this.initializePageCounter(), this.initializePaginator()) : this.table.options.progressiveLoad && (this.subscribe("data-params", this.remotePageParams.bind(this)), this.subscribe("data-loaded", this._parseRemoteData.bind(this)), this.subscribe("table-built", this.calculatePageSizes.bind(this)), this.subscribe("data-processed", this.initialLoadComplete.bind(this)), this.initializeProgressive(this.table.options.progressiveLoad), this.table.options.progressiveLoad === "scroll" && this.subscribe("scroll-vertical", this.scrollVertical.bind(this)));
  }
  rowAddingPosition(t, e) {
    var a = this.table.rowManager, n = a.getDisplayRows(), i;
    return e ? n.length ? i = n[0] : a.activeRows.length && (i = a.activeRows[a.activeRows.length - 1], e = !1) : n.length && (i = n[n.length - 1], e = !(n.length < this.size)), { index: i, top: e };
  }
  calculatePageSizes() {
    var t, e;
    this.table.options.paginationSize ? this.size = this.table.options.paginationSize : (t = document.createElement("div"), t.classList.add("tabulator-row"), t.style.visibility = "hidden", e = document.createElement("div"), e.classList.add("tabulator-cell"), e.innerHTML = "Page Row Test", t.appendChild(e), this.table.rowManager.getTableElement().appendChild(t), this.size = Math.floor(this.table.rowManager.getElement().clientHeight / t.offsetHeight), this.table.rowManager.getTableElement().removeChild(t)), this.dispatchExternal("pageSizeChanged", this.size), this.generatePageSizeSelectList();
  }
  initialLoadComplete() {
    this.initialLoad = !1;
  }
  remotePageParams(t, e, a, n) {
    return this.initialLoad || (this.progressiveLoad && !a || !this.progressiveLoad && !this.dataChanging) && this.reset(!0), n.page = this.page, this.size && (n.size = this.size), n;
  }
  ///////////////////////////////////
  ///////// Table Functions /////////
  ///////////////////////////////////
  userSetPageToRow(t) {
    return this.table.options.pagination && (t = this.table.rowManager.findRow(t), t) ? this.setPageToRow(t) : Promise.reject();
  }
  userSetPageSize(t) {
    return this.table.options.pagination ? (this.setPageSize(t), this.setPage(1)) : !1;
  }
  ///////////////////////////////////
  ///////// Internal Logic //////////
  ///////////////////////////////////
  scrollVertical(t, e) {
    var a, n, i;
    !e && !this.table.dataLoader.loading && (a = this.table.rowManager.getElement(), n = a.scrollHeight - a.clientHeight - t, i = this.table.options.progressiveLoadScrollMargin || a.clientHeight * 2, n < i && this.nextPage().catch(() => {
    }));
  }
  restOnRenderBefore(t, e) {
    return e || this.mode === "local" && this.reset(), t;
  }
  rowsUpdated() {
    this.refreshData(!0, "all");
  }
  createElements() {
    var t;
    this.element = document.createElement("span"), this.element.classList.add("tabulator-paginator"), this.pagesElement = document.createElement("span"), this.pagesElement.classList.add("tabulator-pages"), t = document.createElement("button"), t.classList.add("tabulator-page"), t.setAttribute("type", "button"), t.setAttribute("role", "button"), t.setAttribute("aria-label", ""), t.setAttribute("title", ""), this.firstBut = t.cloneNode(!0), this.firstBut.setAttribute("data-page", "first"), this.prevBut = t.cloneNode(!0), this.prevBut.setAttribute("data-page", "prev"), this.nextBut = t.cloneNode(!0), this.nextBut.setAttribute("data-page", "next"), this.lastBut = t.cloneNode(!0), this.lastBut.setAttribute("data-page", "last"), this.table.options.paginationSizeSelector && (this.pageSizeSelect = document.createElement("select"), this.pageSizeSelect.classList.add("tabulator-page-size"));
  }
  generatePageSizeSelectList() {
    var t = [];
    if (this.pageSizeSelect) {
      if (Array.isArray(this.table.options.paginationSizeSelector))
        t = this.table.options.paginationSizeSelector, this.pageSizes = t, this.pageSizes.indexOf(this.size) == -1 && t.unshift(this.size);
      else if (this.pageSizes.indexOf(this.size) == -1) {
        t = [];
        for (let e = 1; e < 5; e++)
          t.push(this.size * e);
        this.pageSizes = t;
      } else
        t = this.pageSizes;
      for (; this.pageSizeSelect.firstChild; )
        this.pageSizeSelect.removeChild(this.pageSizeSelect.firstChild);
      t.forEach((e) => {
        var a = document.createElement("option");
        a.value = e, e === !0 ? this.langBind("pagination|all", function(n) {
          a.innerHTML = n;
        }) : a.innerHTML = e, this.pageSizeSelect.appendChild(a);
      }), this.pageSizeSelect.value = this.size;
    }
  }
  initializePageCounter() {
    var t = this.table.options.paginationCounter, e = null;
    t && (typeof t == "function" ? e = t : e = np.pageCounters[t], e ? (this.pageCounter = e, this.pageCounterElement = document.createElement("span"), this.pageCounterElement.classList.add("tabulator-page-counter")) : console.warn("Pagination Error - No such page counter found: ", t));
  }
  //setup pagination
  initializePaginator(t) {
    var e, a;
    t || (this.langBind("pagination|first", (n) => {
      this.firstBut.innerHTML = n;
    }), this.langBind("pagination|first_title", (n) => {
      this.firstBut.setAttribute("aria-label", n), this.firstBut.setAttribute("title", n);
    }), this.langBind("pagination|prev", (n) => {
      this.prevBut.innerHTML = n;
    }), this.langBind("pagination|prev_title", (n) => {
      this.prevBut.setAttribute("aria-label", n), this.prevBut.setAttribute("title", n);
    }), this.langBind("pagination|next", (n) => {
      this.nextBut.innerHTML = n;
    }), this.langBind("pagination|next_title", (n) => {
      this.nextBut.setAttribute("aria-label", n), this.nextBut.setAttribute("title", n);
    }), this.langBind("pagination|last", (n) => {
      this.lastBut.innerHTML = n;
    }), this.langBind("pagination|last_title", (n) => {
      this.lastBut.setAttribute("aria-label", n), this.lastBut.setAttribute("title", n);
    }), this.firstBut.addEventListener("click", () => {
      this.setPage(1);
    }), this.prevBut.addEventListener("click", () => {
      this.previousPage();
    }), this.nextBut.addEventListener("click", () => {
      this.nextPage();
    }), this.lastBut.addEventListener("click", () => {
      this.setPage(this.max);
    }), this.table.options.paginationElement && (this.element = this.table.options.paginationElement), this.pageSizeSelect && (e = document.createElement("label"), this.langBind("pagination|page_size", (n) => {
      this.pageSizeSelect.setAttribute("aria-label", n), this.pageSizeSelect.setAttribute("title", n), e.innerHTML = n;
    }), this.element.appendChild(e), this.element.appendChild(this.pageSizeSelect), this.pageSizeSelect.addEventListener("change", (n) => {
      this.setPageSize(this.pageSizeSelect.value == "true" ? !0 : this.pageSizeSelect.value), this.setPage(1);
    })), this.element.appendChild(this.firstBut), this.element.appendChild(this.prevBut), this.element.appendChild(this.pagesElement), this.element.appendChild(this.nextBut), this.element.appendChild(this.lastBut), this.table.options.paginationElement || (this.table.options.paginationCounter && (this.table.options.paginationCounterElement ? this.table.options.paginationCounterElement instanceof HTMLElement ? this.table.options.paginationCounterElement.appendChild(this.pageCounterElement) : typeof this.table.options.paginationCounterElement == "string" && (a = document.querySelector(this.table.options.paginationCounterElement), a ? a.appendChild(this.pageCounterElement) : console.warn("Pagination Error - Unable to find element matching paginationCounterElement selector:", this.table.options.paginationCounterElement)) : this.footerAppend(this.pageCounterElement)), this.footerAppend(this.element)), this.page = this.table.options.paginationInitialPage, this.count = this.table.options.paginationButtonCount), this.mode = this.table.options.paginationMode;
  }
  initializeProgressive(t) {
    this.initializePaginator(!0), this.mode = "progressive_" + t, this.progressiveLoad = !0;
  }
  trackChanges() {
    this.dispatch("page-changed");
  }
  //calculate maximum page from number of rows
  setMaxRows(t) {
    t ? this.max = this.size === !0 ? 1 : Math.ceil(t / this.size) : this.max = 1, this.page > this.max && (this.page = this.max);
  }
  //reset to first page without triggering action
  reset(t) {
    this.initialLoad || (this.mode == "local" || t) && (this.page = 1, this.trackChanges());
  }
  //set the maximum page
  setMaxPage(t) {
    t = parseInt(t), this.max = t || 1, this.page > this.max && (this.page = this.max, this.trigger());
  }
  //set current page number
  setPage(t) {
    switch (t) {
      case "first":
        return this.setPage(1);
      case "prev":
        return this.previousPage();
      case "next":
        return this.nextPage();
      case "last":
        return this.setPage(this.max);
    }
    return t = parseInt(t), t > 0 && t <= this.max || this.mode !== "local" ? (this.page = t, this.trackChanges(), this.trigger()) : (console.warn("Pagination Error - Requested page is out of range of 1 - " + this.max + ":", t), Promise.reject());
  }
  setPageToRow(t) {
    var e = this.displayRows(-1), a = e.indexOf(t);
    if (a > -1) {
      var n = this.size === !0 ? 1 : Math.ceil((a + 1) / this.size);
      return this.setPage(n);
    } else
      return console.warn("Pagination Error - Requested row is not visible"), Promise.reject();
  }
  setPageSize(t) {
    t !== !0 && (t = parseInt(t)), t > 0 && (this.size = t, this.dispatchExternal("pageSizeChanged", t)), this.pageSizeSelect && this.generatePageSizeSelectList(), this.trackChanges();
  }
  _setPageCounter(t, e, a) {
    var n;
    if (this.pageCounter)
      switch (this.mode === "remote" && (e = this.size, a = (this.page - 1) * this.size + 1, t = this.remoteRowCountEstimate), n = this.pageCounter.call(this, e, a, this.page, t, this.max), typeof n) {
        case "object":
          if (n instanceof Node) {
            for (; this.pageCounterElement.firstChild; )
              this.pageCounterElement.removeChild(this.pageCounterElement.firstChild);
            this.pageCounterElement.appendChild(n);
          } else
            this.pageCounterElement.innerHTML = "", n != null && console.warn("Page Counter Error - Page Counter has returned a type of object, the only valid page counter object return is an instance of Node, the page counter returned:", n);
          break;
        case "undefined":
          this.pageCounterElement.innerHTML = "";
          break;
        default:
          this.pageCounterElement.innerHTML = n;
      }
  }
  //setup the pagination buttons
  _setPageButtons() {
    let t = Math.floor((this.count - 1) / 2), e = Math.ceil((this.count - 1) / 2), a = this.max - this.page + t + 1 < this.count ? this.max - this.count + 1 : Math.max(this.page - t, 1), n = this.page <= e ? Math.min(this.count, this.max) : Math.min(this.page + e, this.max);
    for (; this.pagesElement.firstChild; )
      this.pagesElement.removeChild(this.pagesElement.firstChild);
    this.page == 1 ? (this.firstBut.disabled = !0, this.prevBut.disabled = !0) : (this.firstBut.disabled = !1, this.prevBut.disabled = !1), this.page == this.max ? (this.lastBut.disabled = !0, this.nextBut.disabled = !0) : (this.lastBut.disabled = !1, this.nextBut.disabled = !1);
    for (let i = a; i <= n; i++)
      i > 0 && i <= this.max && this.pagesElement.appendChild(this._generatePageButton(i));
    this.footerRedraw();
  }
  _generatePageButton(t) {
    var e = document.createElement("button");
    return e.classList.add("tabulator-page"), t == this.page && e.classList.add("active"), e.setAttribute("type", "button"), e.setAttribute("role", "button"), this.langBind("pagination|page_title", (a) => {
      e.setAttribute("aria-label", a + " " + t), e.setAttribute("title", a + " " + t);
    }), e.setAttribute("data-page", t), e.textContent = t, e.addEventListener("click", (a) => {
      this.setPage(t);
    }), e;
  }
  //previous page
  previousPage() {
    return this.page > 1 ? (this.page--, this.trackChanges(), this.trigger()) : (console.warn("Pagination Error - Previous page would be less than page 1:", 0), Promise.reject());
  }
  //next page
  nextPage() {
    return this.page < this.max ? (this.page++, this.trackChanges(), this.trigger()) : (this.progressiveLoad || console.warn("Pagination Error - Next page would be greater than maximum page of " + this.max + ":", this.max + 1), Promise.reject());
  }
  //return current page number
  getPage() {
    return this.page;
  }
  //return max page number
  getPageMax() {
    return this.max;
  }
  getPageSize(t) {
    return this.size;
  }
  getMode() {
    return this.mode;
  }
  //return appropriate rows for current page
  getRows(t) {
    var e = 0, a, n, i, r, l = t.filter((o) => o.type === "row");
    if (this.mode == "local") {
      a = [], this.setMaxRows(t.length), this.size === !0 ? (n = 0, i = t.length) : (n = this.size * (this.page - 1), i = n + parseInt(this.size)), this._setPageButtons();
      for (let o = n; o < i; o++) {
        let c = t[o];
        c && (a.push(c), c.type === "row" && (r || (r = c), e++));
      }
      return this._setPageCounter(l.length, e, r ? l.indexOf(r) + 1 : 0), a;
    } else
      return this._setPageButtons(), this._setPageCounter(l.length), t.slice(0);
  }
  trigger() {
    var t;
    switch (this.mode) {
      case "local":
        return t = this.table.rowManager.scrollLeft, this.refreshData(), this.table.rowManager.scrollHorizontal(t), this.dispatchExternal("pageLoaded", this.getPage()), Promise.resolve();
      case "remote":
        return this.dataChanging = !0, this.reloadData(null).finally(() => {
          this.dataChanging = !1;
        });
      case "progressive_load":
      case "progressive_scroll":
        return this.reloadData(null, !0);
      default:
        return console.warn("Pagination Error - no such pagination mode:", this.mode), Promise.reject();
    }
  }
  _parseRemoteData(t) {
    var e;
    if (typeof t.last_page > "u" && console.warn("Remote Pagination Error - Server response missing '" + (this.options("dataReceiveParams").last_page || "last_page") + "' property"), t.data)
      if (this.max = parseInt(t.last_page) || 1, this.remoteRowCountEstimate = typeof t.last_row < "u" ? t.last_row : t.last_page * this.size - (this.page == t.last_page ? this.size - t.data.length : 0), this.progressiveLoad) {
        switch (this.mode) {
          case "progressive_load":
            this.page == 1 ? this.table.rowManager.setData(t.data, !1, this.page == 1) : this.table.rowManager.addRows(t.data), this.page < this.max && setTimeout(() => {
              this.nextPage();
            }, this.table.options.progressiveLoadDelay);
            break;
          case "progressive_scroll":
            t = this.page === 1 ? t.data : this.table.rowManager.getData().concat(t.data), this.table.rowManager.setData(t, this.page !== 1, this.page == 1), e = this.table.options.progressiveLoadScrollMargin || this.table.rowManager.element.clientHeight * 2, this.table.rowManager.element.scrollHeight <= this.table.rowManager.element.clientHeight + e && this.page < this.max && setTimeout(() => {
              this.nextPage();
            });
            break;
        }
        return !1;
      } else
        this.dispatchExternal("pageLoaded", this.getPage());
    else
      console.warn("Remote Pagination Error - Server response missing '" + (this.options("dataReceiveParams").data || "data") + "' property");
    return t.data;
  }
  //handle the footer element being redrawn
  footerRedraw() {
    var t = this.table.footerManager.containerElement;
    Math.ceil(t.clientWidth) - t.scrollWidth < 0 ? this.pagesElement.style.display = "none" : (this.pagesElement.style.display = "", Math.ceil(t.clientWidth) - t.scrollWidth < 0 && (this.pagesElement.style.display = "none"));
  }
}
np.moduleName = "page";
np.pageCounters = F4;
var z4 = {
  local: function(s, t) {
    var e = localStorage.getItem(s + "-" + t);
    return e ? JSON.parse(e) : !1;
  },
  cookie: function(s, t) {
    var e = document.cookie, a = s + "-" + t, n = e.indexOf(a + "="), i, r;
    return n > -1 && (e = e.slice(n), i = e.indexOf(";"), i > -1 && (e = e.slice(0, i)), r = e.replace(a + "=", "")), r ? JSON.parse(r) : !1;
  }
}, B4 = {
  local: function(s, t, e) {
    localStorage.setItem(s + "-" + t, JSON.stringify(e));
  },
  cookie: function(s, t, e) {
    var a = /* @__PURE__ */ new Date();
    a.setDate(a.getDate() + 1e4), document.cookie = s + "-" + t + "=" + JSON.stringify(e) + "; expires=" + a.toUTCString();
  }
};
class ms extends Ze {
  constructor(t) {
    super(t), this.mode = "", this.id = "", this.defWatcherBlock = !1, this.config = {}, this.readFunc = !1, this.writeFunc = !1, this.registerTableOption("persistence", !1), this.registerTableOption("persistenceID", ""), this.registerTableOption("persistenceMode", !0), this.registerTableOption("persistenceReaderFunc", !1), this.registerTableOption("persistenceWriterFunc", !1);
  }
  // Test for whether localStorage is available for use.
  localStorageTest() {
    var t = "_tabulator_test";
    try {
      return window.localStorage.setItem(t, t), window.localStorage.removeItem(t), !0;
    } catch {
      return !1;
    }
  }
  //setup parameters
  initialize() {
    if (this.table.options.persistence) {
      var t = this.table.options.persistenceMode, e = this.table.options.persistenceID, a;
      this.mode = t !== !0 ? t : this.localStorageTest() ? "local" : "cookie", this.table.options.persistenceReaderFunc ? typeof this.table.options.persistenceReaderFunc == "function" ? this.readFunc = this.table.options.persistenceReaderFunc : ms.readers[this.table.options.persistenceReaderFunc] ? this.readFunc = ms.readers[this.table.options.persistenceReaderFunc] : console.warn("Persistence Read Error - invalid reader set", this.table.options.persistenceReaderFunc) : ms.readers[this.mode] ? this.readFunc = ms.readers[this.mode] : console.warn("Persistence Read Error - invalid reader set", this.mode), this.table.options.persistenceWriterFunc ? typeof this.table.options.persistenceWriterFunc == "function" ? this.writeFunc = this.table.options.persistenceWriterFunc : ms.writers[this.table.options.persistenceWriterFunc] ? this.writeFunc = ms.writers[this.table.options.persistenceWriterFunc] : console.warn("Persistence Write Error - invalid reader set", this.table.options.persistenceWriterFunc) : ms.writers[this.mode] ? this.writeFunc = ms.writers[this.mode] : console.warn("Persistence Write Error - invalid writer set", this.mode), this.id = "tabulator-" + (e || this.table.element.getAttribute("id") || ""), this.config = {
        sort: this.table.options.persistence === !0 || this.table.options.persistence.sort,
        filter: this.table.options.persistence === !0 || this.table.options.persistence.filter,
        headerFilter: this.table.options.persistence === !0 || this.table.options.persistence.headerFilter,
        group: this.table.options.persistence === !0 || this.table.options.persistence.group,
        page: this.table.options.persistence === !0 || this.table.options.persistence.page,
        columns: this.table.options.persistence === !0 ? ["title", "width", "visible"] : this.table.options.persistence.columns
      }, this.config.page && (a = this.retrieveData("page"), a && (typeof a.paginationSize < "u" && (this.config.page === !0 || this.config.page.size) && (this.table.options.paginationSize = a.paginationSize), typeof a.paginationInitialPage < "u" && (this.config.page === !0 || this.config.page.page) && (this.table.options.paginationInitialPage = a.paginationInitialPage))), this.config.group && (a = this.retrieveData("group"), a && (typeof a.groupBy < "u" && (this.config.group === !0 || this.config.group.groupBy) && (this.table.options.groupBy = a.groupBy), typeof a.groupStartOpen < "u" && (this.config.group === !0 || this.config.group.groupStartOpen) && (this.table.options.groupStartOpen = a.groupStartOpen), typeof a.groupHeader < "u" && (this.config.group === !0 || this.config.group.groupHeader) && (this.table.options.groupHeader = a.groupHeader))), this.config.columns && (this.table.options.columns = this.load("columns", this.table.options.columns), this.subscribe("column-init", this.initializeColumn.bind(this)), this.subscribe("column-show", this.save.bind(this, "columns")), this.subscribe("column-hide", this.save.bind(this, "columns")), this.subscribe("column-moved", this.save.bind(this, "columns"))), this.subscribe("table-built", this.tableBuilt.bind(this), 0), this.subscribe("table-redraw", this.tableRedraw.bind(this)), this.subscribe("filter-changed", this.eventSave.bind(this, "filter")), this.subscribe("filter-changed", this.eventSave.bind(this, "headerFilter")), this.subscribe("sort-changed", this.eventSave.bind(this, "sort")), this.subscribe("group-changed", this.eventSave.bind(this, "group")), this.subscribe("page-changed", this.eventSave.bind(this, "page")), this.subscribe("column-resized", this.eventSave.bind(this, "columns")), this.subscribe("column-width", this.eventSave.bind(this, "columns")), this.subscribe("layout-refreshed", this.eventSave.bind(this, "columns"));
    }
    this.registerTableFunction("getColumnLayout", this.getColumnLayout.bind(this)), this.registerTableFunction("setColumnLayout", this.setColumnLayout.bind(this));
  }
  eventSave(t) {
    this.config[t] && this.save(t);
  }
  tableBuilt() {
    var t, e, a;
    this.config.sort && (t = this.load("sort"), t && (this.table.options.initialSort = t)), this.config.filter && (e = this.load("filter"), e && (this.table.options.initialFilter = e)), this.config.headerFilter && (a = this.load("headerFilter"), a && (this.table.options.initialHeaderFilter = a));
  }
  tableRedraw(t) {
    t && this.config.columns && this.save("columns");
  }
  ///////////////////////////////////
  ///////// Table Functions /////////
  ///////////////////////////////////
  getColumnLayout() {
    return this.parseColumns(this.table.columnManager.getColumns());
  }
  setColumnLayout(t) {
    return this.table.columnManager.setColumns(this.mergeDefinition(this.table.options.columns, t, !0)), !0;
  }
  ///////////////////////////////////
  ///////// Internal Logic //////////
  ///////////////////////////////////
  initializeColumn(t) {
    var e, a;
    this.config.columns && (this.defWatcherBlock = !0, e = t.getDefinition(), a = this.config.columns === !0 ? Object.keys(e) : this.config.columns, a.forEach((n) => {
      var i = Object.getOwnPropertyDescriptor(e, n), r = e[n];
      i && Object.defineProperty(e, n, {
        set: (l) => {
          r = l, this.defWatcherBlock || this.save("columns"), i.set && i.set(l);
        },
        get: () => (i.get && i.get(), r)
      });
    }), this.defWatcherBlock = !1);
  }
  //load saved definitions
  load(t, e) {
    var a = this.retrieveData(t);
    return e && (a = a ? this.mergeDefinition(e, a) : e), a;
  }
  //retrieve data from memory
  retrieveData(t) {
    return this.readFunc ? this.readFunc(this.id, t) : !1;
  }
  //merge old and new column definitions
  mergeDefinition(t, e, a) {
    var n = [];
    return e = e || [], e.forEach((i, r) => {
      var l = this._findColumn(t, i), o;
      l && (a ? o = Object.keys(i) : this.config.columns === !0 || this.config.columns == null ? (o = Object.keys(l), o.push("width")) : o = this.config.columns, o.forEach((c) => {
        c !== "columns" && typeof i[c] < "u" && (l[c] = i[c]);
      }), l.columns && (l.columns = this.mergeDefinition(l.columns, i.columns)), n.push(l));
    }), t.forEach((i, r) => {
      var l = this._findColumn(e, i);
      l || (n.length > r ? n.splice(r, 0, i) : n.push(i));
    }), n;
  }
  //find matching columns
  _findColumn(t, e) {
    var a = e.columns ? "group" : e.field ? "field" : "object";
    return t.find(function(n) {
      switch (a) {
        case "group":
          return n.title === e.title && n.columns.length === e.columns.length;
        case "field":
          return n.field === e.field;
        case "object":
          return n === e;
      }
    });
  }
  //save data
  save(t) {
    var e = {};
    switch (t) {
      case "columns":
        e = this.parseColumns(this.table.columnManager.getColumns());
        break;
      case "filter":
        e = this.table.modules.filter.getFilters();
        break;
      case "headerFilter":
        e = this.table.modules.filter.getHeaderFilters();
        break;
      case "sort":
        e = this.validateSorters(this.table.modules.sort.getSort());
        break;
      case "group":
        e = this.getGroupConfig();
        break;
      case "page":
        e = this.getPageConfig();
        break;
    }
    this.writeFunc && this.writeFunc(this.id, t, e);
  }
  //ensure sorters contain no function data
  validateSorters(t) {
    return t.forEach(function(e) {
      e.column = e.field, delete e.field;
    }), t;
  }
  getGroupConfig() {
    var t = {};
    return this.config.group && ((this.config.group === !0 || this.config.group.groupBy) && (t.groupBy = this.table.options.groupBy), (this.config.group === !0 || this.config.group.groupStartOpen) && (t.groupStartOpen = this.table.options.groupStartOpen), (this.config.group === !0 || this.config.group.groupHeader) && (t.groupHeader = this.table.options.groupHeader)), t;
  }
  getPageConfig() {
    var t = {};
    return this.config.page && ((this.config.page === !0 || this.config.page.size) && (t.paginationSize = this.table.modules.page.getPageSize()), (this.config.page === !0 || this.config.page.page) && (t.paginationInitialPage = this.table.modules.page.getPage())), t;
  }
  //parse columns for data to store
  parseColumns(t) {
    var e = [], a = ["headerContextMenu", "headerMenu", "contextMenu", "clickMenu"];
    return t.forEach((n) => {
      var i = {}, r = n.getDefinition(), l;
      n.isGroup ? (i.title = r.title, i.columns = this.parseColumns(n.getColumns())) : (i.field = n.getField(), this.config.columns === !0 || this.config.columns == null ? (l = Object.keys(r), l.push("width"), l.push("visible")) : l = this.config.columns, l.forEach((o) => {
        switch (o) {
          case "width":
            i.width = n.getWidth();
            break;
          case "visible":
            i.visible = n.visible;
            break;
          default:
            typeof r[o] != "function" && a.indexOf(o) === -1 && (i[o] = r[o]);
        }
      })), e.push(i);
    }), e;
  }
}
ms.moduleName = "persistence";
ms.moduleInitOrder = -10;
ms.readers = z4;
ms.writers = B4;
class QN extends Ze {
  constructor(t) {
    super(t), this.columnSubscribers = {}, this.registerTableOption("rowContextPopup", !1), this.registerTableOption("rowClickPopup", !1), this.registerTableOption("rowDblClickPopup", !1), this.registerTableOption("groupContextPopup", !1), this.registerTableOption("groupClickPopup", !1), this.registerTableOption("groupDblClickPopup", !1), this.registerColumnOption("headerContextPopup"), this.registerColumnOption("headerClickPopup"), this.registerColumnOption("headerDblClickPopup"), this.registerColumnOption("headerPopup"), this.registerColumnOption("headerPopupIcon"), this.registerColumnOption("contextPopup"), this.registerColumnOption("clickPopup"), this.registerColumnOption("dblClickPopup"), this.registerComponentFunction("cell", "popup", this._componentPopupCall.bind(this)), this.registerComponentFunction("column", "popup", this._componentPopupCall.bind(this)), this.registerComponentFunction("row", "popup", this._componentPopupCall.bind(this)), this.registerComponentFunction("group", "popup", this._componentPopupCall.bind(this));
  }
  initialize() {
    this.initializeRowWatchers(), this.initializeGroupWatchers(), this.subscribe("column-init", this.initializeColumn.bind(this));
  }
  _componentPopupCall(t, e, a) {
    this.loadPopupEvent(e, null, t, a);
  }
  initializeRowWatchers() {
    this.table.options.rowContextPopup && (this.subscribe("row-contextmenu", this.loadPopupEvent.bind(this, this.table.options.rowContextPopup)), this.table.on("rowTapHold", this.loadPopupEvent.bind(this, this.table.options.rowContextPopup))), this.table.options.rowClickPopup && this.subscribe("row-click", this.loadPopupEvent.bind(this, this.table.options.rowClickPopup)), this.table.options.rowDblClickPopup && this.subscribe("row-dblclick", this.loadPopupEvent.bind(this, this.table.options.rowDblClickPopup));
  }
  initializeGroupWatchers() {
    this.table.options.groupContextPopup && (this.subscribe("group-contextmenu", this.loadPopupEvent.bind(this, this.table.options.groupContextPopup)), this.table.on("groupTapHold", this.loadPopupEvent.bind(this, this.table.options.groupContextPopup))), this.table.options.groupClickPopup && this.subscribe("group-click", this.loadPopupEvent.bind(this, this.table.options.groupClickPopup)), this.table.options.groupDblClickPopup && this.subscribe("group-dblclick", this.loadPopupEvent.bind(this, this.table.options.groupDblClickPopup));
  }
  initializeColumn(t) {
    var e = t.definition;
    e.headerContextPopup && !this.columnSubscribers.headerContextPopup && (this.columnSubscribers.headerContextPopup = this.loadPopupTableColumnEvent.bind(this, "headerContextPopup"), this.subscribe("column-contextmenu", this.columnSubscribers.headerContextPopup), this.table.on("headerTapHold", this.loadPopupTableColumnEvent.bind(this, "headerContextPopup"))), e.headerClickPopup && !this.columnSubscribers.headerClickPopup && (this.columnSubscribers.headerClickPopup = this.loadPopupTableColumnEvent.bind(this, "headerClickPopup"), this.subscribe("column-click", this.columnSubscribers.headerClickPopup)), e.headerDblClickPopup && !this.columnSubscribers.headerDblClickPopup && (this.columnSubscribers.headerDblClickPopup = this.loadPopupTableColumnEvent.bind(this, "headerDblClickPopup"), this.subscribe("column-dblclick", this.columnSubscribers.headerDblClickPopup)), e.headerPopup && this.initializeColumnHeaderPopup(t), e.contextPopup && !this.columnSubscribers.contextPopup && (this.columnSubscribers.contextPopup = this.loadPopupTableCellEvent.bind(this, "contextPopup"), this.subscribe("cell-contextmenu", this.columnSubscribers.contextPopup), this.table.on("cellTapHold", this.loadPopupTableCellEvent.bind(this, "contextPopup"))), e.clickPopup && !this.columnSubscribers.clickPopup && (this.columnSubscribers.clickPopup = this.loadPopupTableCellEvent.bind(this, "clickPopup"), this.subscribe("cell-click", this.columnSubscribers.clickPopup)), e.dblClickPopup && !this.columnSubscribers.dblClickPopup && (this.columnSubscribers.dblClickPopup = this.loadPopupTableCellEvent.bind(this, "dblClickPopup"), this.subscribe("cell-click", this.columnSubscribers.dblClickPopup));
  }
  initializeColumnHeaderPopup(t) {
    var e = t.definition.headerPopupIcon, a;
    a = document.createElement("span"), a.classList.add("tabulator-header-popup-button"), e ? (typeof e == "function" && (e = e(t.getComponent())), e instanceof HTMLElement ? a.appendChild(e) : a.innerHTML = e) : a.innerHTML = "&vellip;", a.addEventListener("click", (n) => {
      n.stopPropagation(), n.preventDefault(), this.loadPopupEvent(t.definition.headerPopup, n, t);
    }), t.titleElement.insertBefore(a, t.titleElement.firstChild);
  }
  loadPopupTableCellEvent(t, e, a) {
    a._cell && (a = a._cell), a.column.definition[t] && this.loadPopupEvent(a.column.definition[t], e, a);
  }
  loadPopupTableColumnEvent(t, e, a) {
    a._column && (a = a._column), a.definition[t] && this.loadPopupEvent(a.definition[t], e, a);
  }
  loadPopupEvent(t, e, a, n) {
    var i;
    function r(l) {
      i = l;
    }
    a._group ? a = a._group : a._row && (a = a._row), t = typeof t == "function" ? t.call(this.table, e, a.getComponent(), r) : t, this.loadPopup(e, a, t, i, n);
  }
  loadPopup(t, e, a, n, i) {
    var r = !(t instanceof MouseEvent), l, o;
    a instanceof HTMLElement ? l = a : (l = document.createElement("div"), l.innerHTML = a), l.classList.add("tabulator-popup"), l.addEventListener("click", (c) => {
      c.stopPropagation();
    }), r || t.preventDefault(), o = this.popup(l), typeof n == "function" && o.renderCallback(n), t ? o.show(t) : o.show(e.getElement(), i || "center"), o.hideOnBlur(() => {
      this.dispatchExternal("popupClosed", e.getComponent());
    }), this.dispatchExternal("popupOpened", e.getComponent());
  }
}
QN.moduleName = "popup";
class ZN extends Ze {
  constructor(t) {
    super(t), this.element = !1, this.manualBlock = !1, this.beforeprintEventHandler = null, this.afterprintEventHandler = null, this.registerTableOption("printAsHtml", !1), this.registerTableOption("printFormatter", !1), this.registerTableOption("printHeader", !1), this.registerTableOption("printFooter", !1), this.registerTableOption("printStyled", !0), this.registerTableOption("printRowRange", "visible"), this.registerTableOption("printConfig", {}), this.registerColumnOption("print"), this.registerColumnOption("titlePrint");
  }
  initialize() {
    this.table.options.printAsHtml && (this.beforeprintEventHandler = this.replaceTable.bind(this), this.afterprintEventHandler = this.cleanup.bind(this), window.addEventListener("beforeprint", this.beforeprintEventHandler), window.addEventListener("afterprint", this.afterprintEventHandler), this.subscribe("table-destroy", this.destroy.bind(this))), this.registerTableFunction("print", this.printFullscreen.bind(this));
  }
  destroy() {
    this.table.options.printAsHtml && (window.removeEventListener("beforeprint", this.beforeprintEventHandler), window.removeEventListener("afterprint", this.afterprintEventHandler));
  }
  ///////////////////////////////////
  ///////// Table Functions /////////
  ///////////////////////////////////
  ///////////////////////////////////
  ///////// Internal Logic //////////
  ///////////////////////////////////
  replaceTable() {
    this.manualBlock || (this.element = document.createElement("div"), this.element.classList.add("tabulator-print-table"), this.element.appendChild(this.table.modules.export.generateTable(this.table.options.printConfig, this.table.options.printStyled, this.table.options.printRowRange, "print")), this.table.element.style.display = "none", this.table.element.parentNode.insertBefore(this.element, this.table.element));
  }
  cleanup() {
    document.body.classList.remove("tabulator-print-fullscreen-hide"), this.element && this.element.parentNode && (this.element.parentNode.removeChild(this.element), this.table.element.style.display = "");
  }
  printFullscreen(t, e, a) {
    var n = window.scrollX, i = window.scrollY, r = document.createElement("div"), l = document.createElement("div"), o = this.table.modules.export.generateTable(typeof a < "u" ? a : this.table.options.printConfig, typeof e < "u" ? e : this.table.options.printStyled, t || this.table.options.printRowRange, "print"), c, d;
    this.manualBlock = !0, this.element = document.createElement("div"), this.element.classList.add("tabulator-print-fullscreen"), this.table.options.printHeader && (r.classList.add("tabulator-print-header"), c = typeof this.table.options.printHeader == "function" ? this.table.options.printHeader.call(this.table) : this.table.options.printHeader, typeof c == "string" ? r.innerHTML = c : r.appendChild(c), this.element.appendChild(r)), this.element.appendChild(o), this.table.options.printFooter && (l.classList.add("tabulator-print-footer"), d = typeof this.table.options.printFooter == "function" ? this.table.options.printFooter.call(this.table) : this.table.options.printFooter, typeof d == "string" ? l.innerHTML = d : l.appendChild(d), this.element.appendChild(l)), document.body.classList.add("tabulator-print-fullscreen-hide"), document.body.appendChild(this.element), this.table.options.printFormatter && this.table.options.printFormatter(this.element, o), window.print(), this.cleanup(), window.scrollTo(n, i), this.manualBlock = !1;
  }
}
ZN.moduleName = "print";
class tR extends Ze {
  constructor(t) {
    super(t), this.data = !1, this.blocked = !1, this.origFuncs = {}, this.currentVersion = 0, this.registerTableOption("reactiveData", !1);
  }
  initialize() {
    this.table.options.reactiveData && (this.subscribe("cell-value-save-before", this.block.bind(this, "cellsave")), this.subscribe("cell-value-save-after", this.unblock.bind(this, "cellsave")), this.subscribe("row-data-save-before", this.block.bind(this, "rowsave")), this.subscribe("row-data-save-after", this.unblock.bind(this, "rowsave")), this.subscribe("row-data-init-after", this.watchRow.bind(this)), this.subscribe("data-processing", this.watchData.bind(this)), this.subscribe("table-destroy", this.unwatchData.bind(this)));
  }
  watchData(t) {
    var e = this, a;
    this.currentVersion++, a = this.currentVersion, this.unwatchData(), this.data = t, this.origFuncs.push = t.push, Object.defineProperty(this.data, "push", {
      enumerable: !1,
      configurable: !0,
      value: function() {
        var n = Array.from(arguments), i;
        return !e.blocked && a === e.currentVersion && (e.block("data-push"), n.forEach((r) => {
          e.table.rowManager.addRowActual(r, !1);
        }), i = e.origFuncs.push.apply(t, arguments), e.unblock("data-push")), i;
      }
    }), this.origFuncs.unshift = t.unshift, Object.defineProperty(this.data, "unshift", {
      enumerable: !1,
      configurable: !0,
      value: function() {
        var n = Array.from(arguments), i;
        return !e.blocked && a === e.currentVersion && (e.block("data-unshift"), n.forEach((r) => {
          e.table.rowManager.addRowActual(r, !0);
        }), i = e.origFuncs.unshift.apply(t, arguments), e.unblock("data-unshift")), i;
      }
    }), this.origFuncs.shift = t.shift, Object.defineProperty(this.data, "shift", {
      enumerable: !1,
      configurable: !0,
      value: function() {
        var n, i;
        return !e.blocked && a === e.currentVersion && (e.block("data-shift"), e.data.length && (n = e.table.rowManager.getRowFromDataObject(e.data[0]), n && n.deleteActual()), i = e.origFuncs.shift.call(t), e.unblock("data-shift")), i;
      }
    }), this.origFuncs.pop = t.pop, Object.defineProperty(this.data, "pop", {
      enumerable: !1,
      configurable: !0,
      value: function() {
        var n, i;
        return !e.blocked && a === e.currentVersion && (e.block("data-pop"), e.data.length && (n = e.table.rowManager.getRowFromDataObject(e.data[e.data.length - 1]), n && n.deleteActual()), i = e.origFuncs.pop.call(t), e.unblock("data-pop")), i;
      }
    }), this.origFuncs.splice = t.splice, Object.defineProperty(this.data, "splice", {
      enumerable: !1,
      configurable: !0,
      value: function() {
        var n = Array.from(arguments), i = n[0] < 0 ? t.length + n[0] : n[0], r = n[1], l = n[2] ? n.slice(2) : !1, o, c;
        if (!e.blocked && a === e.currentVersion) {
          if (e.block("data-splice"), l && (o = t[i] ? e.table.rowManager.getRowFromDataObject(t[i]) : !1, o ? l.forEach((p) => {
            e.table.rowManager.addRowActual(p, !0, o, !0);
          }) : (l = l.slice().reverse(), l.forEach((p) => {
            e.table.rowManager.addRowActual(p, !0, !1, !0);
          }))), r !== 0) {
            var d = t.slice(i, typeof n[1] > "u" ? n[1] : i + r);
            d.forEach((p, h) => {
              var g = e.table.rowManager.getRowFromDataObject(p);
              g && g.deleteActual(h !== d.length - 1);
            });
          }
          (l || r !== 0) && e.table.rowManager.reRenderInPosition(), c = e.origFuncs.splice.apply(t, arguments), e.unblock("data-splice");
        }
        return c;
      }
    });
  }
  unwatchData() {
    if (this.data !== !1)
      for (var t in this.origFuncs)
        Object.defineProperty(this.data, t, {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: this.origFuncs.key
        });
  }
  watchRow(t) {
    var e = t.getData();
    for (var a in e)
      this.watchKey(t, e, a);
    this.table.options.dataTree && this.watchTreeChildren(t);
  }
  watchTreeChildren(t) {
    var e = this, a = t.getData()[this.table.options.dataTreeChildField], n = {};
    a && (n.push = a.push, Object.defineProperty(a, "push", {
      enumerable: !1,
      configurable: !0,
      value: () => {
        if (!e.blocked) {
          e.block("tree-push");
          var i = n.push.apply(a, arguments);
          this.rebuildTree(t), e.unblock("tree-push");
        }
        return i;
      }
    }), n.unshift = a.unshift, Object.defineProperty(a, "unshift", {
      enumerable: !1,
      configurable: !0,
      value: () => {
        if (!e.blocked) {
          e.block("tree-unshift");
          var i = n.unshift.apply(a, arguments);
          this.rebuildTree(t), e.unblock("tree-unshift");
        }
        return i;
      }
    }), n.shift = a.shift, Object.defineProperty(a, "shift", {
      enumerable: !1,
      configurable: !0,
      value: () => {
        if (!e.blocked) {
          e.block("tree-shift");
          var i = n.shift.call(a);
          this.rebuildTree(t), e.unblock("tree-shift");
        }
        return i;
      }
    }), n.pop = a.pop, Object.defineProperty(a, "pop", {
      enumerable: !1,
      configurable: !0,
      value: () => {
        if (!e.blocked) {
          e.block("tree-pop");
          var i = n.pop.call(a);
          this.rebuildTree(t), e.unblock("tree-pop");
        }
        return i;
      }
    }), n.splice = a.splice, Object.defineProperty(a, "splice", {
      enumerable: !1,
      configurable: !0,
      value: () => {
        if (!e.blocked) {
          e.block("tree-splice");
          var i = n.splice.apply(a, arguments);
          this.rebuildTree(t), e.unblock("tree-splice");
        }
        return i;
      }
    }));
  }
  rebuildTree(t) {
    this.table.modules.dataTree.initializeRow(t), this.table.modules.dataTree.layoutRow(t), this.table.rowManager.refreshActiveData("tree", !1, !0);
  }
  watchKey(t, e, a) {
    var n = this, i = Object.getOwnPropertyDescriptor(e, a), r = e[a], l = this.currentVersion;
    Object.defineProperty(e, a, {
      set: (o) => {
        if (r = o, !n.blocked && l === n.currentVersion) {
          n.block("key");
          var c = {};
          c[a] = o, t.updateData(c), n.unblock("key");
        }
        i.set && i.set(o);
      },
      get: () => (i.get && i.get(), r)
    });
  }
  unwatchRow(t) {
    var e = t.getData();
    for (var a in e)
      Object.defineProperty(e, a, {
        value: e[a]
      });
  }
  block(t) {
    this.blocked || (this.blocked = t);
  }
  unblock(t) {
    this.blocked === t && (this.blocked = !1);
  }
}
tR.moduleName = "reactiveData";
class eR extends Ze {
  constructor(t) {
    super(t), this.startColumn = !1, this.startX = !1, this.startWidth = !1, this.latestX = !1, this.handle = null, this.initialNextColumn = null, this.nextColumn = null, this.initialized = !1, this.registerColumnOption("resizable", !0), this.registerTableOption("resizableColumnFit", !1);
  }
  initialize() {
    this.subscribe("column-rendered", this.layoutColumnHeader.bind(this));
  }
  initializeEventWatchers() {
    this.initialized || (this.subscribe("cell-rendered", this.layoutCellHandles.bind(this)), this.subscribe("cell-delete", this.deInitializeComponent.bind(this)), this.subscribe("cell-height", this.resizeHandle.bind(this)), this.subscribe("column-moved", this.columnLayoutUpdated.bind(this)), this.subscribe("column-hide", this.deInitializeColumn.bind(this)), this.subscribe("column-show", this.columnLayoutUpdated.bind(this)), this.subscribe("column-width", this.columnWidthUpdated.bind(this)), this.subscribe("column-delete", this.deInitializeComponent.bind(this)), this.subscribe("column-height", this.resizeHandle.bind(this)), this.initialized = !0);
  }
  layoutCellHandles(t) {
    t.row.type === "row" && (this.deInitializeComponent(t), this.initializeColumn("cell", t, t.column, t.element));
  }
  layoutColumnHeader(t) {
    t.definition.resizable && (this.initializeEventWatchers(), this.deInitializeComponent(t), this.initializeColumn("header", t, t, t.element));
  }
  columnLayoutUpdated(t) {
    var e = t.prevColumn();
    this.reinitializeColumn(t), e && this.reinitializeColumn(e);
  }
  columnWidthUpdated(t) {
    t.modules.frozen && (this.table.modules.frozenColumns.leftColumns.includes(t) ? this.table.modules.frozenColumns.leftColumns.forEach((e) => {
      this.reinitializeColumn(e);
    }) : this.table.modules.frozenColumns.rightColumns.includes(t) && this.table.modules.frozenColumns.rightColumns.forEach((e) => {
      this.reinitializeColumn(e);
    }));
  }
  frozenColumnOffset(t) {
    var e = !1;
    return t.modules.frozen && (e = t.modules.frozen.marginValue, t.modules.frozen.position === "left" ? e += t.getWidth() - 3 : e && (e -= 3)), e !== !1 ? e + "px" : !1;
  }
  reinitializeColumn(t) {
    var e = this.frozenColumnOffset(t);
    t.cells.forEach((a) => {
      a.modules.resize && a.modules.resize.handleEl && (e && (a.modules.resize.handleEl.style[t.modules.frozen.position] = e, a.modules.resize.handleEl.style["z-index"] = 11), a.element.after(a.modules.resize.handleEl));
    }), t.modules.resize && t.modules.resize.handleEl && (e && (t.modules.resize.handleEl.style[t.modules.frozen.position] = e), t.element.after(t.modules.resize.handleEl));
  }
  initializeColumn(t, e, a, n) {
    var i = this, r = !1, l = a.definition.resizable, o = {}, c = a.getLastColumn();
    if (t === "header" && (r = a.definition.formatter == "textarea" || a.definition.variableHeight, o = { variableHeight: r }), (l === !0 || l == t) && this._checkResizability(c)) {
      var d = document.createElement("span");
      d.className = "tabulator-col-resize-handle", d.addEventListener("click", function(h) {
        h.stopPropagation();
      });
      var p = function(h) {
        i.startColumn = a, i.initialNextColumn = i.nextColumn = c.nextColumn(), i._mouseDown(h, c, d);
      };
      d.addEventListener("mousedown", p), d.addEventListener("touchstart", p, { passive: !0 }), d.addEventListener("dblclick", (h) => {
        var g = c.getWidth();
        h.stopPropagation(), c.reinitializeWidth(!0), g !== c.getWidth() && (i.dispatch("column-resized", c), i.table.externalEvents.dispatch("columnResized", c.getComponent()));
      }), a.modules.frozen && (d.style.position = "sticky", d.style[a.modules.frozen.position] = this.frozenColumnOffset(a)), o.handleEl = d, n.parentNode && a.visible && n.after(d);
    }
    e.modules.resize = o;
  }
  deInitializeColumn(t) {
    this.deInitializeComponent(t), t.cells.forEach((e) => {
      this.deInitializeComponent(e);
    });
  }
  deInitializeComponent(t) {
    var e;
    t.modules.resize && (e = t.modules.resize.handleEl, e && e.parentElement && e.parentElement.removeChild(e));
  }
  resizeHandle(t, e) {
    t.modules.resize && t.modules.resize.handleEl && (t.modules.resize.handleEl.style.height = e);
  }
  _checkResizability(t) {
    return t.definition.resizable;
  }
  _mouseDown(t, e, a) {
    var n = this;
    n.table.element.classList.add("tabulator-block-select");
    function i(l) {
      var o = typeof l.screenX > "u" ? l.touches[0].screenX : l.screenX, c = o - n.startX, d = o - n.latestX, p, h;
      if (n.latestX = o, n.table.rtl && (c = -c, d = -d), p = e.width == e.minWidth || e.width == e.maxWidth, e.setWidth(n.startWidth + c), h = e.width == e.minWidth || e.width == e.maxWidth, d < 0 && (n.nextColumn = n.initialNextColumn), n.table.options.resizableColumnFit && n.nextColumn && !(p && h)) {
        let g = n.nextColumn.getWidth();
        d > 0 && g <= n.nextColumn.minWidth && (n.nextColumn = n.nextColumn.nextColumn()), n.nextColumn && n.nextColumn.setWidth(n.nextColumn.getWidth() - d);
      }
      n.table.columnManager.rerenderColumns(!0), !n.table.browserSlow && e.modules.resize && e.modules.resize.variableHeight && e.checkCellHeights();
    }
    function r(l) {
      n.startColumn.modules.edit && (n.startColumn.modules.edit.blocked = !1), n.table.browserSlow && e.modules.resize && e.modules.resize.variableHeight && e.checkCellHeights(), document.body.removeEventListener("mouseup", r), document.body.removeEventListener("mousemove", i), a.removeEventListener("touchmove", i), a.removeEventListener("touchend", r), n.table.element.classList.remove("tabulator-block-select"), n.startWidth !== e.getWidth() && (n.table.columnManager.verticalAlignHeaders(), n.dispatch("column-resized", e), n.table.externalEvents.dispatch("columnResized", e.getComponent()));
    }
    t.stopPropagation(), n.startColumn.modules.edit && (n.startColumn.modules.edit.blocked = !0), n.startX = typeof t.screenX > "u" ? t.touches[0].screenX : t.screenX, n.latestX = n.startX, n.startWidth = e.getWidth(), document.body.addEventListener("mousemove", i), document.body.addEventListener("mouseup", r), a.addEventListener("touchmove", i, { passive: !0 }), a.addEventListener("touchend", r);
  }
}
eR.moduleName = "resizeColumns";
class aR extends Ze {
  constructor(t) {
    super(t), this.startColumn = !1, this.startY = !1, this.startHeight = !1, this.handle = null, this.prevHandle = null, this.registerTableOption("resizableRows", !1);
  }
  initialize() {
    this.table.options.resizableRows && this.subscribe("row-layout-after", this.initializeRow.bind(this));
  }
  initializeRow(t) {
    var e = this, a = t.getElement(), n = document.createElement("div");
    n.className = "tabulator-row-resize-handle";
    var i = document.createElement("div");
    i.className = "tabulator-row-resize-handle prev", n.addEventListener("click", function(o) {
      o.stopPropagation();
    });
    var r = function(o) {
      e.startRow = t, e._mouseDown(o, t, n);
    };
    n.addEventListener("mousedown", r), n.addEventListener("touchstart", r, { passive: !0 }), i.addEventListener("click", function(o) {
      o.stopPropagation();
    });
    var l = function(o) {
      var c = e.table.rowManager.prevDisplayRow(t);
      c && (e.startRow = c, e._mouseDown(o, c, i));
    };
    i.addEventListener("mousedown", l), i.addEventListener("touchstart", l, { passive: !0 }), a.appendChild(n), a.appendChild(i);
  }
  _mouseDown(t, e, a) {
    var n = this;
    n.table.element.classList.add("tabulator-block-select");
    function i(l) {
      e.setHeight(n.startHeight + ((typeof l.screenY > "u" ? l.touches[0].screenY : l.screenY) - n.startY));
    }
    function r(l) {
      document.body.removeEventListener("mouseup", i), document.body.removeEventListener("mousemove", i), a.removeEventListener("touchmove", i), a.removeEventListener("touchend", r), n.table.element.classList.remove("tabulator-block-select"), n.dispatchExternal("rowResized", e.getComponent());
    }
    t.stopPropagation(), n.startY = typeof t.screenY > "u" ? t.touches[0].screenY : t.screenY, n.startHeight = e.getHeight(), document.body.addEventListener("mousemove", i), document.body.addEventListener("mouseup", r), a.addEventListener("touchmove", i, { passive: !0 }), a.addEventListener("touchend", r);
  }
}
aR.moduleName = "resizeRows";
class nR extends Ze {
  constructor(t) {
    super(t), this.binding = !1, this.visibilityObserver = !1, this.resizeObserver = !1, this.containerObserver = !1, this.tableHeight = 0, this.tableWidth = 0, this.containerHeight = 0, this.containerWidth = 0, this.autoResize = !1, this.visible = !1, this.initialized = !1, this.initialRedraw = !1, this.registerTableOption("autoResize", !0);
  }
  initialize() {
    if (this.table.options.autoResize) {
      var t = this.table, e;
      this.tableHeight = t.element.clientHeight, this.tableWidth = t.element.clientWidth, t.element.parentNode && (this.containerHeight = t.element.parentNode.clientHeight, this.containerWidth = t.element.parentNode.clientWidth), typeof IntersectionObserver < "u" && typeof ResizeObserver < "u" && t.rowManager.getRenderMode() === "virtual" ? (this.initializeVisibilityObserver(), this.autoResize = !0, this.resizeObserver = new ResizeObserver((a) => {
        if (!t.browserMobile || t.browserMobile && (!t.modules.edit || t.modules.edit && !t.modules.edit.currentCell)) {
          var n = Math.floor(a[0].contentRect.height), i = Math.floor(a[0].contentRect.width);
          (this.tableHeight != n || this.tableWidth != i) && (this.tableHeight = n, this.tableWidth = i, t.element.parentNode && (this.containerHeight = t.element.parentNode.clientHeight, this.containerWidth = t.element.parentNode.clientWidth), this.redrawTable());
        }
      }), this.resizeObserver.observe(t.element), e = window.getComputedStyle(t.element), this.table.element.parentNode && !this.table.rowManager.fixedHeight && (e.getPropertyValue("max-height") || e.getPropertyValue("min-height")) && (this.containerObserver = new ResizeObserver((a) => {
        if (!t.browserMobile || t.browserMobile && (!t.modules.edit || t.modules.edit && !t.modules.edit.currentCell)) {
          var n = Math.floor(a[0].contentRect.height), i = Math.floor(a[0].contentRect.width);
          (this.containerHeight != n || this.containerWidth != i) && (this.containerHeight = n, this.containerWidth = i, this.tableHeight = t.element.clientHeight, this.tableWidth = t.element.clientWidth), this.redrawTable();
        }
      }), this.containerObserver.observe(this.table.element.parentNode)), this.subscribe("table-resize", this.tableResized.bind(this))) : (this.binding = function() {
        (!t.browserMobile || t.browserMobile && (!t.modules.edit || t.modules.edit && !t.modules.edit.currentCell)) && (t.columnManager.rerenderColumns(!0), t.redraw());
      }, window.addEventListener("resize", this.binding)), this.subscribe("table-destroy", this.clearBindings.bind(this));
    }
  }
  initializeVisibilityObserver() {
    this.visibilityObserver = new IntersectionObserver((t) => {
      this.visible = t[0].isIntersecting, this.initialized ? this.visible && (this.redrawTable(this.initialRedraw), this.initialRedraw = !1) : (this.initialized = !0, this.initialRedraw = !this.visible);
    }), this.visibilityObserver.observe(this.table.element);
  }
  redrawTable(t) {
    this.initialized && this.visible && (this.table.columnManager.rerenderColumns(!0), this.table.redraw(t));
  }
  tableResized() {
    this.table.rowManager.redraw();
  }
  clearBindings() {
    this.binding && window.removeEventListener("resize", this.binding), this.resizeObserver && this.resizeObserver.unobserve(this.table.element), this.visibilityObserver && this.visibilityObserver.unobserve(this.table.element), this.containerObserver && this.containerObserver.unobserve(this.table.element.parentNode);
  }
}
nR.moduleName = "resizeTable";
class sR extends Ze {
  constructor(t) {
    super(t), this.columns = [], this.hiddenColumns = [], this.mode = "", this.index = 0, this.collapseFormatter = [], this.collapseStartOpen = !0, this.collapseHandleColumn = !1, this.registerTableOption("responsiveLayout", !1), this.registerTableOption("responsiveLayoutCollapseStartOpen", !0), this.registerTableOption("responsiveLayoutCollapseUseFormatters", !0), this.registerTableOption("responsiveLayoutCollapseFormatter", !1), this.registerColumnOption("responsive");
  }
  //generate responsive columns list
  initialize() {
    this.table.options.responsiveLayout && (this.subscribe("column-layout", this.initializeColumn.bind(this)), this.subscribe("column-show", this.updateColumnVisibility.bind(this)), this.subscribe("column-hide", this.updateColumnVisibility.bind(this)), this.subscribe("columns-loaded", this.initializeResponsivity.bind(this)), this.subscribe("column-moved", this.initializeResponsivity.bind(this)), this.subscribe("column-add", this.initializeResponsivity.bind(this)), this.subscribe("column-delete", this.initializeResponsivity.bind(this)), this.subscribe("table-redrawing", this.tableRedraw.bind(this)), this.table.options.responsiveLayout === "collapse" && (this.subscribe("row-data-changed", this.generateCollapsedRowContent.bind(this)), this.subscribe("row-init", this.initializeRow.bind(this)), this.subscribe("row-layout", this.layoutRow.bind(this))));
  }
  tableRedraw(t) {
    ["fitColumns", "fitDataStretch"].indexOf(this.layoutMode()) === -1 && (t || this.update());
  }
  initializeResponsivity() {
    var t = [];
    this.mode = this.table.options.responsiveLayout, this.collapseFormatter = this.table.options.responsiveLayoutCollapseFormatter || this.formatCollapsedData, this.collapseStartOpen = this.table.options.responsiveLayoutCollapseStartOpen, this.hiddenColumns = [], this.table.columnManager.columnsByIndex.forEach((e, a) => {
      e.modules.responsive && e.modules.responsive.order && e.modules.responsive.visible && (e.modules.responsive.index = a, t.push(e), !e.visible && this.mode === "collapse" && this.hiddenColumns.push(e));
    }), t = t.reverse(), t = t.sort((e, a) => {
      var n = a.modules.responsive.order - e.modules.responsive.order;
      return n || a.modules.responsive.index - e.modules.responsive.index;
    }), this.columns = t, this.mode === "collapse" && this.generateCollapsedContent();
    for (let e of this.table.columnManager.columnsByIndex)
      if (e.definition.formatter == "responsiveCollapse") {
        this.collapseHandleColumn = e;
        break;
      }
    this.collapseHandleColumn && (this.hiddenColumns.length ? this.collapseHandleColumn.show() : this.collapseHandleColumn.hide());
  }
  //define layout information
  initializeColumn(t) {
    var e = t.getDefinition();
    t.modules.responsive = { order: typeof e.responsive > "u" ? 1 : e.responsive, visible: e.visible !== !1 };
  }
  initializeRow(t) {
    var e;
    t.type !== "calc" && (e = document.createElement("div"), e.classList.add("tabulator-responsive-collapse"), t.modules.responsiveLayout = {
      element: e,
      open: this.collapseStartOpen
    }, this.collapseStartOpen || (e.style.display = "none"));
  }
  layoutRow(t) {
    var e = t.getElement();
    t.modules.responsiveLayout && (e.appendChild(t.modules.responsiveLayout.element), this.generateCollapsedRowContent(t));
  }
  //update column visibility
  updateColumnVisibility(t, e) {
    !e && t.modules.responsive && (t.modules.responsive.visible = t.visible, this.initializeResponsivity());
  }
  hideColumn(t) {
    var e = this.hiddenColumns.length;
    t.hide(!1, !0), this.mode === "collapse" && (this.hiddenColumns.unshift(t), this.generateCollapsedContent(), this.collapseHandleColumn && !e && this.collapseHandleColumn.show());
  }
  showColumn(t) {
    var e;
    t.show(!1, !0), t.setWidth(t.getWidth()), this.mode === "collapse" && (e = this.hiddenColumns.indexOf(t), e > -1 && this.hiddenColumns.splice(e, 1), this.generateCollapsedContent(), this.collapseHandleColumn && !this.hiddenColumns.length && this.collapseHandleColumn.hide());
  }
  //redraw columns to fit space
  update() {
    for (var t = !0; t; ) {
      let e = this.table.modules.layout.getMode() == "fitColumns" ? this.table.columnManager.getFlexBaseWidth() : this.table.columnManager.getWidth(), a = (this.table.options.headerVisible ? this.table.columnManager.element.clientWidth : this.table.element.clientWidth) - e;
      if (a < 0) {
        let n = this.columns[this.index];
        n ? (this.hideColumn(n), this.index++) : t = !1;
      } else {
        let n = this.columns[this.index - 1];
        n && a > 0 && a >= n.getWidth() ? (this.showColumn(n), this.index--) : t = !1;
      }
      this.table.rowManager.activeRowsCount || this.table.rowManager.renderEmptyScroll();
    }
  }
  generateCollapsedContent() {
    var t = this.table.rowManager.getDisplayRows();
    t.forEach((e) => {
      this.generateCollapsedRowContent(e);
    });
  }
  generateCollapsedRowContent(t) {
    var e, a;
    if (t.modules.responsiveLayout) {
      for (e = t.modules.responsiveLayout.element; e.firstChild; )
        e.removeChild(e.firstChild);
      a = this.collapseFormatter(this.generateCollapsedRowData(t)), a && e.appendChild(a);
    }
  }
  generateCollapsedRowData(t) {
    var e = t.getData(), a = [], n;
    return this.hiddenColumns.forEach((i) => {
      var r = i.getFieldValue(e);
      if (i.definition.title && i.field)
        if (i.modules.format && this.table.options.responsiveLayoutCollapseUseFormatters) {
          let l = function(o) {
            o();
          };
          n = {
            value: !1,
            data: {},
            getValue: function() {
              return r;
            },
            getData: function() {
              return e;
            },
            getType: function() {
              return "cell";
            },
            getElement: function() {
              return document.createElement("div");
            },
            getRow: function() {
              return t.getComponent();
            },
            getColumn: function() {
              return i.getComponent();
            },
            getTable: () => this.table
          }, a.push({
            field: i.field,
            title: i.definition.title,
            value: i.modules.format.formatter.call(this.table.modules.format, n, i.modules.format.params, l)
          });
        } else
          a.push({
            field: i.field,
            title: i.definition.title,
            value: r
          });
    }), a;
  }
  formatCollapsedData(t) {
    var e = document.createElement("table");
    return t.forEach(function(a) {
      var n = document.createElement("tr"), i = document.createElement("td"), r = document.createElement("td"), l, o = document.createElement("strong");
      i.appendChild(o), this.langBind("columns|" + a.field, function(c) {
        o.innerHTML = c || a.title;
      }), a.value instanceof Node ? (l = document.createElement("div"), l.appendChild(a.value), r.appendChild(l)) : r.innerHTML = a.value, n.appendChild(i), n.appendChild(r), e.appendChild(n);
    }, this), Object.keys(t).length ? e : "";
  }
}
sR.moduleName = "responsiveLayout";
class iR extends Ze {
  constructor(t) {
    super(t), this.selecting = !1, this.lastClickedRow = !1, this.selectPrev = [], this.selectedRows = [], this.headerCheckboxElement = null, this.registerTableOption("selectableRows", "highlight"), this.registerTableOption("selectableRowsRangeMode", "drag"), this.registerTableOption("selectableRowsRollingSelection", !0), this.registerTableOption("selectableRowsPersistence", !0), this.registerTableOption("selectableRowsCheck", function(e, a) {
      return !0;
    }), this.registerTableFunction("selectRow", this.selectRows.bind(this)), this.registerTableFunction("deselectRow", this.deselectRows.bind(this)), this.registerTableFunction("toggleSelectRow", this.toggleRow.bind(this)), this.registerTableFunction("getSelectedRows", this.getSelectedRows.bind(this)), this.registerTableFunction("getSelectedData", this.getSelectedData.bind(this)), this.registerComponentFunction("row", "select", this.selectRows.bind(this)), this.registerComponentFunction("row", "deselect", this.deselectRows.bind(this)), this.registerComponentFunction("row", "toggleSelect", this.toggleRow.bind(this)), this.registerComponentFunction("row", "isSelected", this.isRowSelected.bind(this));
  }
  initialize() {
    this.deprecatedOptionsCheck(), this.table.options.selectableRows === "highlight" && this.table.options.selectableRange && (this.table.options.selectableRows = !1), this.table.options.selectableRows !== !1 && (this.subscribe("row-init", this.initializeRow.bind(this)), this.subscribe("row-deleting", this.rowDeleted.bind(this)), this.subscribe("rows-wipe", this.clearSelectionData.bind(this)), this.subscribe("rows-retrieve", this.rowRetrieve.bind(this)), this.table.options.selectableRows && !this.table.options.selectableRowsPersistence && this.subscribe("data-refreshing", this.deselectRows.bind(this)));
  }
  deprecatedOptionsCheck() {
    this.deprecationCheck("selectable", "selectableRows", !0), this.deprecationCheck("selectableRollingSelection", "selectableRowsRollingSelection", !0), this.deprecationCheck("selectableRangeMode", "selectableRowsRangeMode", !0), this.deprecationCheck("selectablePersistence", "selectableRowsPersistence", !0), this.deprecationCheck("selectableCheck", "selectableRowsCheck", !0);
  }
  rowRetrieve(t, e) {
    return t === "selected" ? this.selectedRows : e;
  }
  rowDeleted(t) {
    this._deselectRow(t, !0);
  }
  clearSelectionData(t) {
    var e = this.selectedRows.length;
    this.selecting = !1, this.lastClickedRow = !1, this.selectPrev = [], this.selectedRows = [], e && t !== !0 && this._rowSelectionChanged();
  }
  initializeRow(t) {
    var e = this, a = e.checkRowSelectability(t), n = t.getElement(), i = function() {
      setTimeout(function() {
        e.selecting = !1;
      }, 50), document.body.removeEventListener("mouseup", i);
    };
    t.modules.select = { selected: !1 }, n.classList.toggle("tabulator-selectable", a), n.classList.toggle("tabulator-unselectable", !a), e.checkRowSelectability(t) && e.table.options.selectableRows && e.table.options.selectableRows != "highlight" && (e.table.options.selectableRowsRangeMode === "click" ? n.addEventListener("click", this.handleComplexRowClick.bind(this, t)) : (n.addEventListener("click", function(r) {
      (!e.table.modExists("edit") || !e.table.modules.edit.getCurrentCell()) && e.table._clearSelection(), e.selecting || e.toggleRow(t);
    }), n.addEventListener("mousedown", function(r) {
      if (r.shiftKey)
        return e.table._clearSelection(), e.selecting = !0, e.selectPrev = [], document.body.addEventListener("mouseup", i), document.body.addEventListener("keyup", i), e.toggleRow(t), !1;
    }), n.addEventListener("mouseenter", function(r) {
      e.selecting && (e.table._clearSelection(), e.toggleRow(t), e.selectPrev[1] == t && e.toggleRow(e.selectPrev[0]));
    }), n.addEventListener("mouseout", function(r) {
      e.selecting && (e.table._clearSelection(), e.selectPrev.unshift(t));
    })));
  }
  handleComplexRowClick(t, e) {
    if (e.shiftKey) {
      this.table._clearSelection(), this.lastClickedRow = this.lastClickedRow || t;
      var a = this.table.rowManager.getDisplayRowIndex(this.lastClickedRow), n = this.table.rowManager.getDisplayRowIndex(t), i = a <= n ? a : n, r = a >= n ? a : n, l = this.table.rowManager.getDisplayRows().slice(0), o = l.splice(i, r - i + 1);
      e.ctrlKey || e.metaKey ? (o.forEach((c) => {
        c !== this.lastClickedRow && (this.table.options.selectableRows !== !0 && !this.isRowSelected(t) ? this.selectedRows.length < this.table.options.selectableRows && this.toggleRow(c) : this.toggleRow(c));
      }), this.lastClickedRow = t) : (this.deselectRows(void 0, !0), this.table.options.selectableRows !== !0 && o.length > this.table.options.selectableRows && (o = o.slice(0, this.table.options.selectableRows)), this.selectRows(o)), this.table._clearSelection();
    } else
      e.ctrlKey || e.metaKey ? (this.toggleRow(t), this.lastClickedRow = t) : (this.deselectRows(void 0, !0), this.selectRows(t), this.lastClickedRow = t);
  }
  checkRowSelectability(t) {
    return t && t.type === "row" ? this.table.options.selectableRowsCheck.call(this.table, t.getComponent()) : !1;
  }
  //toggle row selection
  toggleRow(t) {
    this.checkRowSelectability(t) && (t.modules.select && t.modules.select.selected ? this._deselectRow(t) : this._selectRow(t));
  }
  //select a number of rows
  selectRows(t) {
    var e = [], a, n;
    switch (typeof t) {
      case "undefined":
        a = this.table.rowManager.rows;
        break;
      case "number":
        a = this.table.rowManager.findRow(t);
        break;
      case "string":
        a = this.table.rowManager.findRow(t), a || (a = this.table.rowManager.getRows(t));
        break;
      default:
        a = t;
        break;
    }
    Array.isArray(a) ? a.length && (a.forEach((i) => {
      n = this._selectRow(i, !0, !0), n && e.push(n);
    }), this._rowSelectionChanged(!1, e)) : a && this._selectRow(a, !1, !0);
  }
  //select an individual row
  _selectRow(t, e, a) {
    if (!isNaN(this.table.options.selectableRows) && this.table.options.selectableRows !== !0 && !a && this.selectedRows.length >= this.table.options.selectableRows)
      if (this.table.options.selectableRowsRollingSelection)
        this._deselectRow(this.selectedRows[0]);
      else
        return !1;
    var n = this.table.rowManager.findRow(t);
    if (n) {
      if (this.selectedRows.indexOf(n) == -1)
        return n.getElement().classList.add("tabulator-selected"), n.modules.select || (n.modules.select = {}), n.modules.select.selected = !0, n.modules.select.checkboxEl && (n.modules.select.checkboxEl.checked = !0), this.selectedRows.push(n), this.table.options.dataTreeSelectPropagate && this.childRowSelection(n, !0), this.dispatchExternal("rowSelected", n.getComponent()), this._rowSelectionChanged(e, n), n;
    } else
      e || console.warn("Selection Error - No such row found, ignoring selection:" + t);
  }
  isRowSelected(t) {
    return this.selectedRows.indexOf(t) !== -1;
  }
  //deselect a number of rows
  deselectRows(t, e) {
    var a = [], n, i;
    switch (typeof t) {
      case "undefined":
        n = Object.assign([], this.selectedRows);
        break;
      case "number":
        n = this.table.rowManager.findRow(t);
        break;
      case "string":
        n = this.table.rowManager.findRow(t), n || (n = this.table.rowManager.getRows(t));
        break;
      default:
        n = t;
        break;
    }
    Array.isArray(n) ? n.length && (n.forEach((r) => {
      i = this._deselectRow(r, !0, !0), i && a.push(i);
    }), this._rowSelectionChanged(e, [], a)) : n && this._deselectRow(n, e, !0);
  }
  //deselect an individual row
  _deselectRow(t, e) {
    var a = this, n = a.table.rowManager.findRow(t), i, r;
    if (n) {
      if (i = a.selectedRows.findIndex(function(l) {
        return l == n;
      }), i > -1)
        return r = n.getElement(), r && r.classList.remove("tabulator-selected"), n.modules.select || (n.modules.select = {}), n.modules.select.selected = !1, n.modules.select.checkboxEl && (n.modules.select.checkboxEl.checked = !1), a.selectedRows.splice(i, 1), this.table.options.dataTreeSelectPropagate && this.childRowSelection(n, !1), this.dispatchExternal("rowDeselected", n.getComponent()), a._rowSelectionChanged(e, void 0, n), n;
    } else
      e || console.warn("Deselection Error - No such row found, ignoring selection:" + t);
  }
  getSelectedData() {
    var t = [];
    return this.selectedRows.forEach(function(e) {
      t.push(e.getData());
    }), t;
  }
  getSelectedRows() {
    var t = [];
    return this.selectedRows.forEach(function(e) {
      t.push(e.getComponent());
    }), t;
  }
  _rowSelectionChanged(t, e = [], a = []) {
    this.headerCheckboxElement && (this.selectedRows.length === 0 ? (this.headerCheckboxElement.checked = !1, this.headerCheckboxElement.indeterminate = !1) : this.table.rowManager.rows.length === this.selectedRows.length ? (this.headerCheckboxElement.checked = !0, this.headerCheckboxElement.indeterminate = !1) : (this.headerCheckboxElement.indeterminate = !0, this.headerCheckboxElement.checked = !1)), t || (Array.isArray(e) || (e = [e]), e = e.map((n) => n.getComponent()), Array.isArray(a) || (a = [a]), a = a.map((n) => n.getComponent()), this.dispatchExternal("rowSelectionChanged", this.getSelectedData(), this.getSelectedRows(), e, a));
  }
  registerRowSelectCheckbox(t, e) {
    t._row.modules.select || (t._row.modules.select = {}), t._row.modules.select.checkboxEl = e;
  }
  registerHeaderSelectCheckbox(t) {
    this.headerCheckboxElement = t;
  }
  childRowSelection(t, e) {
    var a = this.table.modules.dataTree.getChildren(t, !0);
    if (e)
      for (let n of a)
        this._selectRow(n, !0);
    else
      for (let n of a)
        this._deselectRow(n, !0);
  }
}
iR.moduleName = "selectRow";
function W4(s, t, e, a, n, i, r) {
  var l = r.alignEmptyValues, o = r.decimalSeparator, c = r.thousandSeparator, d = 0;
  if (s = String(s), t = String(t), c && (s = s.split(c).join(""), t = t.split(c).join("")), o && (s = s.split(o).join("."), t = t.split(o).join(".")), s = parseFloat(s), t = parseFloat(t), isNaN(s))
    d = isNaN(t) ? 0 : -1;
  else if (isNaN(t))
    d = 1;
  else
    return s - t;
  return (l === "top" && i === "desc" || l === "bottom" && i === "asc") && (d *= -1), d;
}
function j4(s, t, e, a, n, i, r) {
  var l = r.alignEmptyValues, o = 0, c;
  if (!s)
    o = t ? -1 : 0;
  else if (!t)
    o = 1;
  else {
    switch (typeof r.locale) {
      case "boolean":
        r.locale && (c = this.langLocale());
        break;
      case "string":
        c = r.locale;
        break;
    }
    return String(s).toLowerCase().localeCompare(String(t).toLowerCase(), c);
  }
  return (l === "top" && i === "desc" || l === "bottom" && i === "asc") && (o *= -1), o;
}
function YA(s, t, e, a, n, i, r) {
  var l = window.DateTime || luxon.DateTime, o = r.format || "dd/MM/yyyy HH:mm:ss", c = r.alignEmptyValues, d = 0;
  if (typeof l < "u") {
    if (l.isDateTime(s) || (o === "iso" ? s = l.fromISO(String(s)) : s = l.fromFormat(String(s), o)), l.isDateTime(t) || (o === "iso" ? t = l.fromISO(String(t)) : t = l.fromFormat(String(t), o)), !s.isValid)
      d = t.isValid ? -1 : 0;
    else if (!t.isValid)
      d = 1;
    else
      return s - t;
    return (c === "top" && i === "desc" || c === "bottom" && i === "asc") && (d *= -1), d;
  } else
    console.error("Sort Error - 'datetime' sorter is dependant on luxon.js");
}
function V4(s, t, e, a, n, i, r) {
  return r.format || (r.format = "dd/MM/yyyy"), YA.call(this, s, t, e, a, n, i, r);
}
function q4(s, t, e, a, n, i, r) {
  return r.format || (r.format = "HH:mm"), YA.call(this, s, t, e, a, n, i, r);
}
function K4(s, t, e, a, n, i, r) {
  var l = s === !0 || s === "true" || s === "True" || s === 1 ? 1 : 0, o = t === !0 || t === "true" || t === "True" || t === 1 ? 1 : 0;
  return l - o;
}
function J4(s, t, e, a, n, i, r) {
  var l = r.type || "length", o = r.alignEmptyValues, c = 0;
  function d(p) {
    var h;
    switch (l) {
      case "length":
        h = p.length;
        break;
      case "sum":
        h = p.reduce(function(g, x) {
          return g + x;
        });
        break;
      case "max":
        h = Math.max.apply(null, p);
        break;
      case "min":
        h = Math.min.apply(null, p);
        break;
      case "avg":
        h = p.reduce(function(g, x) {
          return g + x;
        }) / p.length;
        break;
    }
    return h;
  }
  if (!Array.isArray(s))
    c = Array.isArray(t) ? -1 : 0;
  else if (!Array.isArray(t))
    c = 1;
  else
    return d(t) - d(s);
  return (o === "top" && i === "desc" || o === "bottom" && i === "asc") && (c *= -1), c;
}
function Q4(s, t, e, a, n, i, r) {
  var l = typeof s > "u" ? 0 : 1, o = typeof t > "u" ? 0 : 1;
  return l - o;
}
function Z4(s, t, e, a, n, i, r) {
  var l, o, c, d, p = 0, h, g = /(\d+)|(\D+)/g, x = /\d/, b = r.alignEmptyValues, A = 0;
  if (!s && s !== 0)
    A = !t && t !== 0 ? 0 : -1;
  else if (!t && t !== 0)
    A = 1;
  else {
    if (isFinite(s) && isFinite(t))
      return s - t;
    if (l = String(s).toLowerCase(), o = String(t).toLowerCase(), l === o)
      return 0;
    if (!(x.test(l) && x.test(o)))
      return l > o ? 1 : -1;
    for (l = l.match(g), o = o.match(g), h = l.length > o.length ? o.length : l.length; p < h; )
      if (c = l[p], d = o[p++], c !== d)
        return isFinite(c) && isFinite(d) ? (c.charAt(0) === "0" && (c = "." + c), d.charAt(0) === "0" && (d = "." + d), c - d) : c > d ? 1 : -1;
    return l.length > o.length;
  }
  return (b === "top" && i === "desc" || b === "bottom" && i === "asc") && (A *= -1), A;
}
var t6 = {
  number: W4,
  string: j4,
  date: V4,
  time: q4,
  datetime: YA,
  boolean: K4,
  array: J4,
  exists: Q4,
  alphanum: Z4
};
class Gl extends Ze {
  constructor(t) {
    super(t), this.sortList = [], this.changed = !1, this.registerTableOption("sortMode", "local"), this.registerTableOption("initialSort", !1), this.registerTableOption("columnHeaderSortMulti", !0), this.registerTableOption("sortOrderReverse", !1), this.registerTableOption("headerSortElement", "<div class='tabulator-arrow'></div>"), this.registerTableOption("headerSortClickElement", "header"), this.registerColumnOption("sorter"), this.registerColumnOption("sorterParams"), this.registerColumnOption("headerSort", !0), this.registerColumnOption("headerSortStartingDir"), this.registerColumnOption("headerSortTristate");
  }
  initialize() {
    this.subscribe("column-layout", this.initializeColumn.bind(this)), this.subscribe("table-built", this.tableBuilt.bind(this)), this.registerDataHandler(this.sort.bind(this), 20), this.registerTableFunction("setSort", this.userSetSort.bind(this)), this.registerTableFunction("getSorters", this.getSort.bind(this)), this.registerTableFunction("clearSort", this.clearSort.bind(this)), this.table.options.sortMode === "remote" && this.subscribe("data-params", this.remoteSortParams.bind(this));
  }
  tableBuilt() {
    this.table.options.initialSort && this.setSort(this.table.options.initialSort);
  }
  remoteSortParams(t, e, a, n) {
    var i = this.getSort();
    return i.forEach((r) => {
      delete r.column;
    }), n.sort = i, n;
  }
  ///////////////////////////////////
  ///////// Table Functions /////////
  ///////////////////////////////////
  userSetSort(t, e) {
    this.setSort(t, e), this.refreshSort();
  }
  clearSort() {
    this.clear(), this.refreshSort();
  }
  ///////////////////////////////////
  ///////// Internal Logic //////////
  ///////////////////////////////////
  //initialize column header for sorting
  initializeColumn(t) {
    var e = !1, a, n;
    switch (typeof t.definition.sorter) {
      case "string":
        Gl.sorters[t.definition.sorter] ? e = Gl.sorters[t.definition.sorter] : console.warn("Sort Error - No such sorter found: ", t.definition.sorter);
        break;
      case "function":
        e = t.definition.sorter;
        break;
    }
    if (t.modules.sort = {
      sorter: e,
      dir: "none",
      params: t.definition.sorterParams || {},
      startingDir: t.definition.headerSortStartingDir || "asc",
      tristate: t.definition.headerSortTristate
    }, t.definition.headerSort !== !1) {
      switch (a = t.getElement(), a.classList.add("tabulator-sortable"), n = document.createElement("div"), n.classList.add("tabulator-col-sorter"), this.table.options.headerSortClickElement) {
        case "icon":
          n.classList.add("tabulator-col-sorter-element");
          break;
        case "header":
          a.classList.add("tabulator-col-sorter-element");
          break;
        default:
          a.classList.add("tabulator-col-sorter-element");
          break;
      }
      switch (this.table.options.headerSortElement) {
        case "function":
          break;
        case "object":
          n.appendChild(this.table.options.headerSortElement);
          break;
        default:
          n.innerHTML = this.table.options.headerSortElement;
      }
      t.titleHolderElement.appendChild(n), t.modules.sort.element = n, this.setColumnHeaderSortIcon(t, "none"), this.table.options.headerSortClickElement === "icon" && n.addEventListener("mousedown", (i) => {
        i.stopPropagation();
      }), (this.table.options.headerSortClickElement === "icon" ? n : a).addEventListener("click", (i) => {
        var r = "", l = [], o = !1;
        if (t.modules.sort) {
          if (t.modules.sort.tristate)
            t.modules.sort.dir == "none" ? r = t.modules.sort.startingDir : t.modules.sort.dir == t.modules.sort.startingDir ? r = t.modules.sort.dir == "asc" ? "desc" : "asc" : r = "none";
          else
            switch (t.modules.sort.dir) {
              case "asc":
                r = "desc";
                break;
              case "desc":
                r = "asc";
                break;
              default:
                r = t.modules.sort.startingDir;
            }
          this.table.options.columnHeaderSortMulti && (i.shiftKey || i.ctrlKey) ? (l = this.getSort(), o = l.findIndex((c) => c.field === t.getField()), o > -1 ? (l[o].dir = r, o = l.splice(o, 1)[0], r != "none" && l.push(o)) : r != "none" && l.push({ column: t, dir: r }), this.setSort(l)) : r == "none" ? this.clear() : this.setSort(t, r), this.refreshSort();
        }
      });
    }
  }
  refreshSort() {
    this.table.options.sortMode === "remote" ? this.reloadData(null, !1, !1) : this.refreshData(!0);
  }
  //check if the sorters have changed since last use
  hasChanged() {
    var t = this.changed;
    return this.changed = !1, t;
  }
  //return current sorters
  getSort() {
    var t = this, e = [];
    return t.sortList.forEach(function(a) {
      a.column && e.push({ column: a.column.getComponent(), field: a.column.getField(), dir: a.dir });
    }), e;
  }
  //change sort list and trigger sort
  setSort(t, e) {
    var a = this, n = [];
    Array.isArray(t) || (t = [{ column: t, dir: e }]), t.forEach(function(i) {
      var r;
      r = a.table.columnManager.findColumn(i.column), r ? (i.column = r, n.push(i), a.changed = !0) : console.warn("Sort Warning - Sort field does not exist and is being ignored: ", i.column);
    }), a.sortList = n, this.dispatch("sort-changed");
  }
  //clear sorters
  clear() {
    this.setSort([]);
  }
  //find appropriate sorter for column
  findSorter(t) {
    var e = this.table.rowManager.activeRows[0], a = "string", n, i;
    if (e && (e = e.getData(), n = t.getField(), n))
      switch (i = t.getFieldValue(e), typeof i) {
        case "undefined":
          a = "string";
          break;
        case "boolean":
          a = "boolean";
          break;
        default:
          !isNaN(i) && i !== "" ? a = "number" : i.match(/((^[0-9]+[a-z]+)|(^[a-z]+[0-9]+))+$/i) && (a = "alphanum");
          break;
      }
    return Gl.sorters[a];
  }
  //work through sort list sorting data
  sort(t) {
    var e = this, a = this.table.options.sortOrderReverse ? e.sortList.slice().reverse() : e.sortList, n = [], i = [];
    return this.subscribedExternal("dataSorting") && this.dispatchExternal("dataSorting", e.getSort()), e.clearColumnHeaders(), this.table.options.sortMode !== "remote" ? (a.forEach(function(r, l) {
      var o;
      r.column && (o = r.column.modules.sort, o && (o.sorter || (o.sorter = e.findSorter(r.column)), r.params = typeof o.params == "function" ? o.params(r.column.getComponent(), r.dir) : o.params, n.push(r)), e.setColumnHeader(r.column, r.dir));
    }), n.length && e._sortItems(t, n)) : a.forEach(function(r, l) {
      e.setColumnHeader(r.column, r.dir);
    }), this.subscribedExternal("dataSorted") && (t.forEach((r) => {
      i.push(r.getComponent());
    }), this.dispatchExternal("dataSorted", e.getSort(), i)), t;
  }
  //clear sort arrows on columns
  clearColumnHeaders() {
    this.table.columnManager.getRealColumns().forEach((t) => {
      t.modules.sort && (t.modules.sort.dir = "none", t.getElement().setAttribute("aria-sort", "none"), this.setColumnHeaderSortIcon(t, "none"));
    });
  }
  //set the column header sort direction
  setColumnHeader(t, e) {
    t.modules.sort.dir = e, t.getElement().setAttribute("aria-sort", e === "asc" ? "ascending" : "descending"), this.setColumnHeaderSortIcon(t, e);
  }
  setColumnHeaderSortIcon(t, e) {
    var a = t.modules.sort.element, n;
    if (t.definition.headerSort && typeof this.table.options.headerSortElement == "function") {
      for (; a.firstChild; )
        a.removeChild(a.firstChild);
      n = this.table.options.headerSortElement.call(this.table, t.getComponent(), e), typeof n == "object" ? a.appendChild(n) : a.innerHTML = n;
    }
  }
  //sort each item in sort list
  _sortItems(t, e) {
    var a = e.length - 1;
    t.sort((n, i) => {
      for (var r, l = a; l >= 0; l--) {
        let o = e[l];
        if (r = this._sortRow(n, i, o.column, o.dir, o.params), r !== 0)
          break;
      }
      return r;
    });
  }
  //process individual rows for a sort function on active data
  _sortRow(t, e, a, n, i) {
    var r, l, o = n == "asc" ? t : e, c = n == "asc" ? e : t;
    return t = a.getFieldValue(o.getData()), e = a.getFieldValue(c.getData()), t = typeof t < "u" ? t : "", e = typeof e < "u" ? e : "", r = o.getComponent(), l = c.getComponent(), a.modules.sort.sorter.call(this, t, e, r, l, a.getComponent(), n, i);
  }
}
Gl.moduleName = "sort";
Gl.sorters = t6;
class e6 {
  constructor(t) {
    return this._range = t, new Proxy(this, {
      get: function(e, a, n) {
        return typeof e[a] < "u" ? e[a] : e._range.table.componentFunctionBinder.handle("range", e._range, a);
      }
    });
  }
  getElement() {
    return this._range.element;
  }
  getData() {
    return this._range.getData();
  }
  getCells() {
    return this._range.getCells(!0);
  }
  getStructuredCells() {
    return this._range.getStructuredCells();
  }
  getRows() {
    return this._range.getRows().map((t) => t.getComponent());
  }
  getColumns() {
    return this._range.getColumns().map((t) => t.getComponent());
  }
  getBounds() {
    return this._range.getBounds();
  }
  getTopEdge() {
    return this._range.top;
  }
  getBottomEdge() {
    return this._range.bottom;
  }
  getLeftEdge() {
    return this._range.left;
  }
  getRightEdge() {
    return this._range.right;
  }
  setBounds(t, e) {
    this._range.destroyedGuard("setBounds") && this._range.setBounds(t && t._cell, e && e._cell);
  }
  setStartBound(t) {
    this._range.destroyedGuard("setStartBound") && (this._range.setEndBound(t && t._cell), this._range.rangeManager.layoutElement());
  }
  setEndBound(t) {
    this._range.destroyedGuard("setEndBound") && (this._range.setEndBound(t && t._cell), this._range.rangeManager.layoutElement());
  }
  clearValues() {
    this._range.destroyedGuard("clearValues") && this._range.clearValues();
  }
  remove() {
    this._range.destroyedGuard("remove") && this._range.destroy(!0);
  }
}
class a6 extends ds {
  constructor(t, e, a, n) {
    super(t), this.rangeManager = e, this.element = null, this.initialized = !1, this.initializing = {
      start: !1,
      end: !1
    }, this.destroyed = !1, this.top = 0, this.bottom = 0, this.left = 0, this.right = 0, this.table = t, this.start = { row: 0, col: 0 }, this.end = { row: 0, col: 0 }, this.rangeManager.rowHeader && (this.left = 1, this.right = 1, this.start.col = 1, this.end.col = 1), this.initElement(), setTimeout(() => {
      this.initBounds(a, n);
    });
  }
  initElement() {
    this.element = document.createElement("div"), this.element.classList.add("tabulator-range");
  }
  initBounds(t, e) {
    this._updateMinMax(), t && this.setBounds(t, e || t);
  }
  ///////////////////////////////////
  ///////   Boundary Setup    ///////
  ///////////////////////////////////
  setStart(t, e) {
    (this.start.row !== t || this.start.col !== e) && (this.start.row = t, this.start.col = e, this.initializing.start = !0, this._updateMinMax());
  }
  setEnd(t, e) {
    (this.end.row !== t || this.end.col !== e) && (this.end.row = t, this.end.col = e, this.initializing.end = !0, this._updateMinMax());
  }
  setBounds(t, e, a) {
    t && this.setStartBound(t), this.setEndBound(e || t), this.rangeManager.layoutElement(a);
  }
  setStartBound(t) {
    var e, a;
    t.type === "column" ? this.rangeManager.columnSelection && this.setStart(0, t.getPosition() - 1) : (e = t.row.position - 1, a = t.column.getPosition() - 1, t.column === this.rangeManager.rowHeader ? this.setStart(e, 1) : this.setStart(e, a));
  }
  setEndBound(t) {
    var e = this._getTableRows().length, a, n, i;
    t.type === "column" ? this.rangeManager.columnSelection && (this.rangeManager.selecting === "column" ? this.setEnd(e - 1, t.getPosition() - 1) : this.rangeManager.selecting === "cell" && this.setEnd(0, t.getPosition() - 1)) : (a = t.row.position - 1, n = t.column.getPosition() - 1, i = t.column === this.rangeManager.rowHeader, this.rangeManager.selecting === "row" ? this.setEnd(a, this._getTableColumns().length - 1) : this.rangeManager.selecting !== "row" && i ? this.setEnd(a, 0) : this.rangeManager.selecting === "column" ? this.setEnd(e - 1, n) : this.setEnd(a, n));
  }
  _updateMinMax() {
    this.top = Math.min(this.start.row, this.end.row), this.bottom = Math.max(this.start.row, this.end.row), this.left = Math.min(this.start.col, this.end.col), this.right = Math.max(this.start.col, this.end.col), this.initialized ? this.dispatchExternal("rangeChanged", this.getComponent()) : this.initializing.start && this.initializing.end && (this.initialized = !0, this.dispatchExternal("rangeAdded", this.getComponent()));
  }
  _getTableColumns() {
    return this.table.columnManager.getVisibleColumnsByIndex();
  }
  _getTableRows() {
    return this.table.rowManager.getDisplayRows();
  }
  ///////////////////////////////////
  ///////      Rendering      ///////
  ///////////////////////////////////
  layout() {
    var t = this.table.rowManager.renderer.vDomTop, e = this.table.rowManager.renderer.vDomBottom, a = this.table.columnManager.renderer.leftCol, n = this.table.columnManager.renderer.rightCol, i, r, l, o, c, d;
    t == null && (t = 0), e == null && (e = 1 / 0), a == null && (a = 0), n == null && (n = 1 / 0), this.overlaps(a, t, n, e) && (i = Math.max(this.top, t), r = Math.min(this.bottom, e), l = Math.max(this.left, a), o = Math.min(this.right, n), c = this.rangeManager.getCell(i, l), d = this.rangeManager.getCell(r, o), this.element.classList.add("tabulator-range-active"), this.element.style.left = c.row.getElement().offsetLeft + c.getElement().offsetLeft + "px", this.element.style.top = c.row.getElement().offsetTop + "px", this.element.style.width = d.getElement().offsetLeft + d.getElement().offsetWidth - c.getElement().offsetLeft + "px", this.element.style.height = d.row.getElement().offsetTop + d.row.getElement().offsetHeight - c.row.getElement().offsetTop + "px");
  }
  atTopLeft(t) {
    return t.row.position - 1 === this.top && t.column.getPosition() - 1 === this.left;
  }
  atBottomRight(t) {
    return t.row.position - 1 === this.bottom && t.column.getPosition() - 1 === this.right;
  }
  occupies(t) {
    return this.occupiesRow(t.row) && this.occupiesColumn(t.column);
  }
  occupiesRow(t) {
    return this.top <= t.position - 1 && t.position - 1 <= this.bottom;
  }
  occupiesColumn(t) {
    return this.left <= t.getPosition() - 1 && t.getPosition() - 1 <= this.right;
  }
  overlaps(t, e, a, n) {
    return !(this.left > a || t > this.right || this.top > n || e > this.bottom);
  }
  getData() {
    var t = [], e = this.getRows(), a = this.getColumns();
    return e.forEach((n) => {
      var i = n.getData(), r = {};
      a.forEach((l) => {
        r[l.field] = i[l.field];
      }), t.push(r);
    }), t;
  }
  getCells(t, e) {
    var a = [], n = this.getRows(), i = this.getColumns();
    return t ? a = n.map((r) => {
      var l = [];
      return r.getCells().forEach((o) => {
        i.includes(o.column) && l.push(e ? o.getComponent() : o);
      }), l;
    }) : n.forEach((r) => {
      r.getCells().forEach((l) => {
        i.includes(l.column) && a.push(e ? l.getComponent() : l);
      });
    }), a;
  }
  getStructuredCells() {
    return this.getCells(!0, !0);
  }
  getRows() {
    return this._getTableRows().slice(this.top, this.bottom + 1);
  }
  getColumns() {
    return this._getTableColumns().slice(this.left, this.right + 1);
  }
  clearValues() {
    var t = this.getCells(), e = this.table.options.selectableRangeClearCellsValue;
    this.table.blockRedraw(), t.forEach((a) => {
      a.setValue(e);
    }), this.table.restoreRedraw();
  }
  getBounds(t) {
    var e = this.getCells(!1, t), a = {
      start: null,
      end: null
    };
    return e.length ? (a.start = e[0], a.end = e[e.length - 1]) : console.warn("No bounds defined on range"), a;
  }
  getComponent() {
    return this.component || (this.component = new e6(this)), this.component;
  }
  destroy(t) {
    this.destroyed = !0, this.element.remove(), t && this.rangeManager.rangeRemoved(this), this.initialized && this.dispatchExternal("rangeRemoved", this.getComponent());
  }
  destroyedGuard(t) {
    return this.destroyed && console.warn("You cannot call the " + t + " function on a destroyed range"), !this.destroyed;
  }
}
class rR extends Ze {
  constructor(t) {
    super(t), this.selecting = "cell", this.mousedown = !1, this.ranges = [], this.overlay = null, this.rowHeader = null, this.layoutChangeTimeout = null, this.columnSelection = !1, this.rowSelection = !1, this.maxRanges = 0, this.activeRange = !1, this.blockKeydown = !1, this.keyDownEvent = this._handleKeyDown.bind(this), this.mouseUpEvent = this._handleMouseUp.bind(this), this.registerTableOption("selectableRange", !1), this.registerTableOption("selectableRangeColumns", !1), this.registerTableOption("selectableRangeRows", !1), this.registerTableOption("selectableRangeClearCells", !1), this.registerTableOption("selectableRangeClearCellsValue", void 0), this.registerTableFunction("getRangesData", this.getRangesData.bind(this)), this.registerTableFunction("getRanges", this.getRanges.bind(this)), this.registerTableFunction("addRange", this.addRangeFromComponent.bind(this)), this.registerComponentFunction("cell", "getRanges", this.cellGetRanges.bind(this)), this.registerComponentFunction("row", "getRanges", this.rowGetRanges.bind(this)), this.registerComponentFunction("column", "getRanges", this.colGetRanges.bind(this));
  }
  ///////////////////////////////////
  ///////    Initialization   ///////
  ///////////////////////////////////
  initialize() {
    this.options("selectableRange") && (this.options("selectableRows") ? console.warn("SelectRange functionality cannot be used in conjunction with row selection") : (this.maxRanges = this.options("selectableRange"), this.initializeTable(), this.initializeWatchers()));
  }
  initializeTable() {
    this.overlay = document.createElement("div"), this.overlay.classList.add("tabulator-range-overlay"), this.rangeContainer = document.createElement("div"), this.rangeContainer.classList.add("tabulator-range-container"), this.activeRangeCellElement = document.createElement("div"), this.activeRangeCellElement.classList.add("tabulator-range-cell-active"), this.overlay.appendChild(this.rangeContainer), this.overlay.appendChild(this.activeRangeCellElement), this.table.rowManager.element.addEventListener("keydown", this.keyDownEvent), this.resetRanges(), this.table.rowManager.element.appendChild(this.overlay), this.table.columnManager.element.setAttribute("tabindex", 0), this.table.element.classList.add("tabulator-ranges");
  }
  initializeWatchers() {
    this.columnSelection = this.options("selectableRangeColumns"), this.rowSelection = this.options("selectableRangeRows"), this.subscribe("column-init", this.initializeColumn.bind(this)), this.subscribe("column-mousedown", this.handleColumnMouseDown.bind(this)), this.subscribe("column-mousemove", this.handleColumnMouseMove.bind(this)), this.subscribe("column-resized", this.handleColumnResized.bind(this)), this.subscribe("column-width", this.layoutChange.bind(this)), this.subscribe("column-height", this.layoutChange.bind(this)), this.subscribe("column-resized", this.layoutChange.bind(this)), this.subscribe("columns-loaded", this.updateHeaderColumn.bind(this)), this.subscribe("cell-height", this.layoutChange.bind(this)), this.subscribe("cell-rendered", this.renderCell.bind(this)), this.subscribe("cell-mousedown", this.handleCellMouseDown.bind(this)), this.subscribe("cell-mousemove", this.handleCellMouseMove.bind(this)), this.subscribe("cell-click", this.handleCellClick.bind(this)), this.subscribe("cell-editing", this.handleEditingCell.bind(this)), this.subscribe("page-changed", this.redraw.bind(this)), this.subscribe("scroll-vertical", this.layoutChange.bind(this)), this.subscribe("scroll-horizontal", this.layoutChange.bind(this)), this.subscribe("data-destroy", this.tableDestroyed.bind(this)), this.subscribe("data-processed", this.resetRanges.bind(this)), this.subscribe("table-layout", this.layoutElement.bind(this)), this.subscribe("table-redraw", this.redraw.bind(this)), this.subscribe("table-destroy", this.tableDestroyed.bind(this)), this.subscribe("edit-editor-clear", this.finishEditingCell.bind(this)), this.subscribe("edit-blur", this.restoreFocus.bind(this)), this.subscribe("keybinding-nav-prev", this.keyNavigate.bind(this, "left")), this.subscribe("keybinding-nav-next", this.keyNavigate.bind(this, "right")), this.subscribe("keybinding-nav-left", this.keyNavigate.bind(this, "left")), this.subscribe("keybinding-nav-right", this.keyNavigate.bind(this, "right")), this.subscribe("keybinding-nav-up", this.keyNavigate.bind(this, "up")), this.subscribe("keybinding-nav-down", this.keyNavigate.bind(this, "down")), this.subscribe("keybinding-nav-range", this.keyNavigateRange.bind(this));
  }
  initializeColumn(t) {
    this.columnSelection && t.definition.headerSort && this.options("headerSortClickElement") !== "icon" && console.warn("Using column headerSort with selectableRangeColumns option may result in unpredictable behavior. Consider using headerSortClickElement: 'icon'."), t.modules.edit;
  }
  updateHeaderColumn() {
    this.rowSelection && (this.rowHeader = this.table.columnManager.getVisibleColumnsByIndex()[0], this.rowHeader && (this.rowHeader.definition.cssClass = this.rowHeader.definition.cssClass + " tabulator-range-row-header", this.rowHeader.definition.headerSort && console.warn("Using column headerSort with selectableRangeRows option may result in unpredictable behavior"), this.rowHeader.definition.editor && console.warn("Using column editor with selectableRangeRows option may result in unpredictable behavior")));
  }
  ///////////////////////////////////
  ///////   Table Functions   ///////
  ///////////////////////////////////
  getRanges() {
    return this.ranges.map((t) => t.getComponent());
  }
  getRangesData() {
    return this.ranges.map((t) => t.getData());
  }
  addRangeFromComponent(t, e) {
    return t = t ? t._cell : null, e = e ? e._cell : null, this.addRange(t, e);
  }
  ///////////////////////////////////
  /////// Component Functions ///////
  ///////////////////////////////////
  cellGetRanges(t) {
    var e = [];
    return t.column === this.rowHeader ? e = this.ranges.filter((a) => a.occupiesRow(t.row)) : e = this.ranges.filter((a) => a.occupies(t)), e.map((a) => a.getComponent());
  }
  rowGetRanges(t) {
    var e = this.ranges.filter((a) => a.occupiesRow(t));
    return e.map((a) => a.getComponent());
  }
  colGetRanges(t) {
    var e = this.ranges.filter((a) => a.occupiesColumn(t));
    return e.map((a) => a.getComponent());
  }
  ///////////////////////////////////
  ////////// Event Handlers /////////
  ///////////////////////////////////
  _handleMouseUp(t) {
    this.mousedown = !1, document.removeEventListener("mouseup", this.mouseUpEvent);
  }
  _handleKeyDown(t) {
    if (!this.blockKeydown && (!this.table.modules.edit || this.table.modules.edit && !this.table.modules.edit.currentCell)) {
      if (t.key === "Enter") {
        if (this.table.modules.edit && this.table.modules.edit.currentCell)
          return;
        this.table.modules.edit.editCell(this.getActiveCell()), t.preventDefault();
      }
      (t.key === "Backspace" || t.key === "Delete") && this.options("selectableRangeClearCells") && this.activeRange && this.activeRange.clearValues();
    }
  }
  initializeFocus(t) {
    var e;
    try {
      document.selection ? (e = document.body.createTextRange(), e.moveToElementText(t.getElement()), e.select()) : window.getSelection && (e = document.createRange(), e.selectNode(t.getElement()), window.getSelection().removeAllRanges(), window.getSelection().addRange(e));
    } catch {
    }
  }
  restoreFocus(t) {
    return this.table.rowManager.element.focus(), !0;
  }
  ///////////////////////////////////
  ////// Column Functionality ///////
  ///////////////////////////////////
  handleColumnResized(t) {
    var e;
    this.selecting !== "column" && this.selecting !== "all" || (e = this.ranges.some((a) => a.occupiesColumn(t)), e && this.ranges.forEach((a) => {
      var n = a.getColumns(!0);
      n.forEach((i) => {
        i !== t && i.setWidth(t.width);
      });
    }));
  }
  handleColumnMouseDown(t, e) {
    t.button === 2 && (this.selecting === "column" || this.selecting === "all") && this.activeRange.occupiesColumn(e) || (this.mousedown = !0, document.addEventListener("mouseup", this.mouseUpEvent), this.newSelection(t, e));
  }
  handleColumnMouseMove(t, e) {
    e === this.rowHeader || !this.mousedown || this.selecting === "all" || this.activeRange.setBounds(!1, e, !0);
  }
  ///////////////////////////////////
  //////// Cell Functionality ///////
  ///////////////////////////////////
  renderCell(t) {
    var e = t.getElement(), a = this.ranges.findIndex((n) => n.occupies(t));
    e.classList.toggle("tabulator-range-selected", a !== -1), e.classList.toggle("tabulator-range-only-cell-selected", this.ranges.length === 1 && this.ranges[0].atTopLeft(t) && this.ranges[0].atBottomRight(t)), e.dataset.range = a;
  }
  handleCellMouseDown(t, e) {
    t.button === 2 && (this.activeRange.occupies(e) || (this.selecting === "row" || this.selecting === "all") && this.activeRange.occupiesRow(e.row)) || (this.mousedown = !0, document.addEventListener("mouseup", this.mouseUpEvent), this.newSelection(t, e));
  }
  handleCellMouseMove(t, e) {
    !this.mousedown || this.selecting === "all" || this.activeRange.setBounds(!1, e, !0);
  }
  handleCellClick(t, e) {
    this.initializeFocus(e);
  }
  handleEditingCell(t) {
    this.activeRange && this.activeRange.setBounds(t);
  }
  finishEditingCell() {
    this.blockKeydown = !0, this.table.rowManager.element.focus(), setTimeout(() => {
      this.blockKeydown = !1;
    }, 10);
  }
  ///////////////////////////////////
  ///////     Navigation      ///////
  ///////////////////////////////////
  keyNavigate(t, e) {
    this.navigate(!1, !1, t) && e.preventDefault();
  }
  keyNavigateRange(t, e, a, n) {
    this.navigate(a, n, e) && t.preventDefault();
  }
  navigate(t, e, a) {
    var n = !1, i, r, l, o, c, d;
    if (this.table.modules.edit && this.table.modules.edit.currentCell)
      return !1;
    if (this.ranges.length > 1 && (this.ranges = this.ranges.filter((p) => p === this.activeRange ? (p.setEnd(p.start.row, p.start.col), !0) : (p.destroy(), !1))), i = this.activeRange, r = e ? i.end : i.start, l = r.row, o = r.col, t)
      switch (a) {
        case "left":
          o = this.findJumpCellLeft(i.start.row, r.col);
          break;
        case "right":
          o = this.findJumpCellRight(i.start.row, r.col);
          break;
        case "up":
          l = this.findJumpCellUp(r.row, i.start.col);
          break;
        case "down":
          l = this.findJumpCellDown(r.row, i.start.col);
          break;
      }
    else {
      if (e && (this.selecting === "row" && (a === "left" || a === "right") || this.selecting === "column" && (a === "up" || a === "down")))
        return;
      switch (a) {
        case "left":
          o = Math.max(o - 1, 0);
          break;
        case "right":
          o = Math.min(o + 1, this.getTableColumns().length - 1);
          break;
        case "up":
          l = Math.max(l - 1, 0);
          break;
        case "down":
          l = Math.min(l + 1, this.getTableRows().length - 1);
          break;
      }
    }
    if (n = o !== r.col || l !== r.row, e || i.setStart(l, o), i.setEnd(l, o), e || (this.selecting = "cell"), n)
      return c = this.getRowByRangePos(i.end.row), d = this.getColumnByRangePos(i.end.col), (a === "left" || a === "right") && d.getElement().parentNode === null ? d.getComponent().scrollTo(void 0, !1) : (a === "up" || a === "down") && c.getElement().parentNode === null ? c.getComponent().scrollTo(void 0, !1) : this.autoScroll(i, c.getElement(), d.getElement()), this.layoutElement(), !0;
  }
  rangeRemoved(t) {
    this.ranges = this.ranges.filter((e) => e !== t), this.activeRange === t && (this.ranges.length ? this.activeRange = this.ranges[this.ranges.length - 1] : this.addRange()), this.layoutElement();
  }
  findJumpCell(t, e, a, n) {
    var i;
    e && (t = t.reverse());
    for (let r of t) {
      let l = r.getValue();
      if (a) {
        if (i = r, l)
          break;
      } else if (n) {
        if (i = r, l)
          break;
      } else if (l)
        i = r;
      else
        break;
    }
    return i;
  }
  findJumpCellLeft(t, e) {
    var a = this.getRowByRangePos(t), n = a.cells.filter((d) => d.column.visible), i = !n[e].getValue(), r = n[e] ? !n[e].getValue() : !1, l = e, o = this.rowHeader ? n.slice(1, e) : n.slice(0, e), c = this.findJumpCell(o, !0, i, r);
    return c && (l = c.column.getPosition() - 1), l;
  }
  findJumpCellRight(t, e) {
    var a = this.getRowByRangePos(t), n = a.cells.filter((c) => c.column.visible), i = !n[e].getValue(), r = n[e + 1] ? !n[e + 1].getValue() : !1, l = e, o = this.findJumpCell(n.slice(e + 1, n.length), !1, i, r);
    return o && (l = o.column.getPosition() - 1), l;
  }
  findJumpCellUp(t, e) {
    var a = this.getColumnByRangePos(e), n = a.cells.filter((c) => this.table.rowManager.activeRows.includes(c.row)), i = !n[t].getValue(), r = n[t - 1] ? !n[t - 1].getValue() : !1, l = t, o = this.findJumpCell(n.slice(0, l), !0, i, r);
    return o && (l = o.row.position - 1), l;
  }
  findJumpCellDown(t, e) {
    var a = this.getColumnByRangePos(e), n = a.cells.filter((c) => this.table.rowManager.activeRows.includes(c.row)), i = !n[t].getValue(), r = n[t + 1] ? !n[t + 1].getValue() : !1, l = t, o = this.findJumpCell(n.slice(l + 1, n.length), !1, i, r);
    return o && (l = o.row.position - 1), l;
  }
  ///////////////////////////////////
  ///////      Selection      ///////
  ///////////////////////////////////
  newSelection(t, e) {
    var a;
    if (e.type === "column") {
      if (!this.columnSelection)
        return;
      if (e === this.rowHeader) {
        a = this.resetRanges(), this.selecting = "all";
        var n, i = this.getCell(-1, -1);
        this.rowHeader ? n = this.getCell(0, 1) : n = this.getCell(0, 0), a.setBounds(n, i);
        return;
      } else
        this.selecting = "column";
    } else
      e.column === this.rowHeader ? this.selecting = "row" : this.selecting = "cell";
    t.shiftKey ? this.activeRange.setBounds(!1, e) : t.ctrlKey ? this.addRange().setBounds(e) : this.resetRanges().setBounds(e);
  }
  autoScroll(t, e, a) {
    var n = this.table.rowManager.element, i, r, l, o, c;
    typeof e > "u" && (e = this.getRowByRangePos(t.end.row).getElement()), typeof a > "u" && (a = this.getColumnByRangePos(t.end.col).getElement()), this.rowHeader && (i = this.rowHeader.getElement()), r = {
      left: a.offsetLeft,
      right: a.offsetLeft + a.offsetWidth,
      top: e.offsetTop,
      bottom: e.offsetTop + e.offsetHeight
    }, l = {
      left: n.scrollLeft,
      right: Math.ceil(n.scrollLeft + n.clientWidth),
      top: n.scrollTop,
      bottom: n.scrollTop + n.offsetHeight - this.table.rowManager.scrollbarWidth
    }, i && (l.left += i.offsetWidth), o = l.left < r.left && r.left < l.right && l.left < r.right && r.right < l.right, c = l.top < r.top && r.top < l.bottom && l.top < r.bottom && r.bottom < l.bottom, o || (r.left < l.left ? (n.scrollLeft = r.left, i && (n.scrollLeft -= i.offsetWidth)) : r.right > l.right && (n.scrollLeft = r.right - n.clientWidth)), c || (r.top < l.top ? n.scrollTop = r.top : r.bottom > l.bottom && (n.scrollTop = r.bottom - n.clientHeight));
  }
  ///////////////////////////////////
  ///////       Layout        ///////
  ///////////////////////////////////
  layoutChange() {
    this.overlay.style.visibility = "hidden", clearTimeout(this.layoutChangeTimeout), this.layoutChangeTimeout = setTimeout(this.layoutRanges.bind(this), 200);
  }
  redraw(t) {
    t && (this.selecting = "cell", this.resetRanges(), this.layoutElement());
  }
  layoutElement(t) {
    var e;
    t ? e = this.table.rowManager.getVisibleRows(!0) : e = this.table.rowManager.getRows(), e.forEach((a) => {
      a.type === "row" && (this.layoutRow(a), a.cells.forEach((n) => this.renderCell(n)));
    }), this.getTableColumns().forEach((a) => {
      this.layoutColumn(a);
    }), this.layoutRanges();
  }
  layoutRow(t) {
    var e = t.getElement(), a = !1, n = this.ranges.some((i) => i.occupiesRow(t));
    this.selecting === "row" ? a = n : this.selecting === "all" && (a = !0), e.classList.toggle("tabulator-range-selected", a), e.classList.toggle("tabulator-range-highlight", n);
  }
  layoutColumn(t) {
    var e = t.getElement(), a = !1, n = this.ranges.some((i) => i.occupiesColumn(t));
    this.selecting === "column" ? a = n : this.selecting === "all" && (a = !0), e.classList.toggle("tabulator-range-selected", a), e.classList.toggle("tabulator-range-highlight", n);
  }
  layoutRanges() {
    var t;
    this.table.initialized && (t = this.getActiveCell(), t && (this.activeRangeCellElement.style.left = t.row.getElement().offsetLeft + t.getElement().offsetLeft + "px", this.activeRangeCellElement.style.top = t.row.getElement().offsetTop + "px", this.activeRangeCellElement.style.width = t.getElement().offsetLeft + t.getElement().offsetWidth - t.getElement().offsetLeft + "px", this.activeRangeCellElement.style.height = t.row.getElement().offsetTop + t.row.getElement().offsetHeight - t.row.getElement().offsetTop + "px", this.ranges.forEach((e) => e.layout()), this.overlay.style.visibility = "visible"));
  }
  ///////////////////////////////////
  ///////  Helper Functions   ///////
  ///////////////////////////////////	
  getCell(t, e) {
    var a;
    return e < 0 && (e = this.getTableColumns().length + e, e < 0) ? null : (t < 0 && (t = this.getTableRows().length + t), a = this.table.rowManager.getRowFromPosition(t + 1), a ? a.getCells(!1, !0).filter((n) => n.column.visible)[e] : null);
  }
  getActiveCell() {
    return this.getCell(this.activeRange.start.row, this.activeRange.start.col);
  }
  getRowByRangePos(t) {
    return this.getTableRows()[t];
  }
  getColumnByRangePos(t) {
    return this.getTableColumns()[t];
  }
  getTableRows() {
    return this.table.rowManager.getDisplayRows();
  }
  getTableColumns() {
    return this.table.columnManager.getVisibleColumnsByIndex();
  }
  addRange(t, e) {
    var a;
    return this.maxRanges !== !0 && this.ranges.length >= this.maxRanges && this.ranges.shift().destroy(), a = new a6(this.table, this, t, e), this.activeRange = a, this.ranges.push(a), this.rangeContainer.appendChild(a.element), a;
  }
  resetRanges() {
    var t, e;
    return this.ranges.forEach((a) => a.destroy()), this.ranges = [], t = this.addRange(), this.table.rowManager.activeRows.length && (e = this.table.rowManager.activeRows[0].cells[this.rowHeader ? 1 : 0], e && (t.setBounds(e), this.initializeFocus(e))), t;
  }
  tableDestroyed() {
    document.removeEventListener("mouseup", this.mouseUpEvent), this.table.rowManager.element.removeEventListener("keydown", this.keyDownEvent);
  }
  selectedRows(t) {
    return t ? this.activeRange.getRows().map((e) => e.getComponent()) : this.activeRange.getRows();
  }
  selectedColumns(t) {
    return t ? this.activeRange.getColumns().map((e) => e.getComponent()) : this.activeRange.getColumns();
  }
}
rR.moduleName = "selectRange";
let lR = class extends Ze {
  constructor(t) {
    super(t), this.tooltipSubscriber = null, this.headerSubscriber = null, this.timeout = null, this.popupInstance = null, this.registerTableOption("tooltipGenerationMode", void 0), this.registerTableOption("tooltipDelay", 300), this.registerColumnOption("tooltip"), this.registerColumnOption("headerTooltip");
  }
  initialize() {
    this.deprecatedOptionsCheck(), this.subscribe("column-init", this.initializeColumn.bind(this));
  }
  deprecatedOptionsCheck() {
    this.deprecationCheckMsg("tooltipGenerationMode", "This option is no longer needed as tooltips are always generated on hover now");
  }
  initializeColumn(t) {
    t.definition.headerTooltip && !this.headerSubscriber && (this.headerSubscriber = !0, this.subscribe("column-mousemove", this.mousemoveCheck.bind(this, "headerTooltip")), this.subscribe("column-mouseout", this.mouseoutCheck.bind(this, "headerTooltip"))), t.definition.tooltip && !this.tooltipSubscriber && (this.tooltipSubscriber = !0, this.subscribe("cell-mousemove", this.mousemoveCheck.bind(this, "tooltip")), this.subscribe("cell-mouseout", this.mouseoutCheck.bind(this, "tooltip")));
  }
  mousemoveCheck(t, e, a) {
    var n = t === "tooltip" ? a.column.definition.tooltip : a.definition.headerTooltip;
    n && (this.clearPopup(), this.timeout = setTimeout(this.loadTooltip.bind(this, e, a, n), this.table.options.tooltipDelay));
  }
  mouseoutCheck(t, e, a) {
    this.popupInstance || this.clearPopup();
  }
  clearPopup(t, e, a) {
    clearTimeout(this.timeout), this.timeout = null, this.popupInstance && this.popupInstance.hide();
  }
  loadTooltip(t, e, a) {
    var n, i, r;
    function l(o) {
      i = o;
    }
    typeof a == "function" && (a = a(t, e.getComponent(), l)), a instanceof HTMLElement ? n = a : (n = document.createElement("div"), a === !0 && (e instanceof tp ? a = e.value : e.definition.field ? this.langBind("columns|" + e.definition.field, (o) => {
      n.innerHTML = a = o || e.definition.title;
    }) : a = e.definition.title), n.innerHTML = a), (a || a === 0 || a === !1) && (n.classList.add("tabulator-tooltip"), n.addEventListener("mousemove", (o) => o.preventDefault()), this.popupInstance = this.popup(n), typeof i == "function" && this.popupInstance.renderCallback(i), r = this.popupInstance.containerEventCoords(t), this.popupInstance.show(r.x + 15, r.y + 15).hideOnBlur(() => {
      this.dispatchExternal("TooltipClosed", e.getComponent()), this.popupInstance = null;
    }), this.dispatchExternal("TooltipOpened", e.getComponent()));
  }
};
lR.moduleName = "tooltip";
var n6 = {
  //is integer
  integer: function(s, t, e) {
    return t === "" || t === null || typeof t > "u" ? !0 : (t = Number(t), !isNaN(t) && isFinite(t) && Math.floor(t) === t);
  },
  //is float
  float: function(s, t, e) {
    return t === "" || t === null || typeof t > "u" ? !0 : (t = Number(t), !isNaN(t) && isFinite(t) && t % 1 !== 0);
  },
  //must be a number
  numeric: function(s, t, e) {
    return t === "" || t === null || typeof t > "u" ? !0 : !isNaN(t);
  },
  //must be a string
  string: function(s, t, e) {
    return t === "" || t === null || typeof t > "u" ? !0 : isNaN(t);
  },
  //must be alphanumeric
  alphanumeric: function(s, t, e) {
    if (t === "" || t === null || typeof t > "u")
      return !0;
    var a = new RegExp(/^[a-z0-9]+$/i);
    return a.test(t);
  },
  //maximum value
  max: function(s, t, e) {
    return t === "" || t === null || typeof t > "u" ? !0 : parseFloat(t) <= e;
  },
  //minimum value
  min: function(s, t, e) {
    return t === "" || t === null || typeof t > "u" ? !0 : parseFloat(t) >= e;
  },
  //starts with  value
  starts: function(s, t, e) {
    return t === "" || t === null || typeof t > "u" ? !0 : String(t).toLowerCase().startsWith(String(e).toLowerCase());
  },
  //ends with  value
  ends: function(s, t, e) {
    return t === "" || t === null || typeof t > "u" ? !0 : String(t).toLowerCase().endsWith(String(e).toLowerCase());
  },
  //minimum string length
  minLength: function(s, t, e) {
    return t === "" || t === null || typeof t > "u" ? !0 : String(t).length >= e;
  },
  //maximum string length
  maxLength: function(s, t, e) {
    return t === "" || t === null || typeof t > "u" ? !0 : String(t).length <= e;
  },
  //in provided value list
  in: function(s, t, e) {
    return t === "" || t === null || typeof t > "u" ? !0 : (typeof e == "string" && (e = e.split("|")), e.indexOf(t) > -1);
  },
  //must match provided regex
  regex: function(s, t, e) {
    if (t === "" || t === null || typeof t > "u")
      return !0;
    var a = new RegExp(e);
    return a.test(t);
  },
  //value must be unique in this column
  unique: function(s, t, e) {
    if (t === "" || t === null || typeof t > "u")
      return !0;
    var a = !0, n = s.getData(), i = s.getColumn()._getSelf();
    return this.table.rowManager.rows.forEach(function(r) {
      var l = r.getData();
      l !== n && t == i.getFieldValue(l) && (a = !1);
    }), a;
  },
  //must have a value
  required: function(s, t, e) {
    return t !== "" && t !== null && typeof t < "u";
  }
};
class sp extends Ze {
  constructor(t) {
    super(t), this.invalidCells = [], this.registerTableOption("validationMode", "blocking"), this.registerColumnOption("validator"), this.registerTableFunction("getInvalidCells", this.getInvalidCells.bind(this)), this.registerTableFunction("clearCellValidation", this.userClearCellValidation.bind(this)), this.registerTableFunction("validate", this.userValidate.bind(this)), this.registerComponentFunction("cell", "isValid", this.cellIsValid.bind(this)), this.registerComponentFunction("cell", "clearValidation", this.clearValidation.bind(this)), this.registerComponentFunction("cell", "validate", this.cellValidate.bind(this)), this.registerComponentFunction("column", "validate", this.columnValidate.bind(this)), this.registerComponentFunction("row", "validate", this.rowValidate.bind(this));
  }
  initialize() {
    this.subscribe("cell-delete", this.clearValidation.bind(this)), this.subscribe("column-layout", this.initializeColumnCheck.bind(this)), this.subscribe("edit-success", this.editValidate.bind(this)), this.subscribe("edit-editor-clear", this.editorClear.bind(this)), this.subscribe("edit-edited-clear", this.editedClear.bind(this));
  }
  ///////////////////////////////////
  ///////// Event Handling //////////
  ///////////////////////////////////
  editValidate(t, e, a) {
    var n = this.table.options.validationMode !== "manual" ? this.validate(t.column.modules.validate, t, e) : !0;
    return n !== !0 && setTimeout(() => {
      t.getElement().classList.add("tabulator-validation-fail"), this.dispatchExternal("validationFailed", t.getComponent(), e, n);
    }), n;
  }
  editorClear(t, e) {
    e && t.column.modules.validate && this.cellValidate(t), t.getElement().classList.remove("tabulator-validation-fail");
  }
  editedClear(t) {
    t.modules.validate && (t.modules.validate.invalid = !1);
  }
  ///////////////////////////////////
  ////////// Cell Functions /////////
  ///////////////////////////////////
  cellIsValid(t) {
    return t.modules.validate && t.modules.validate.invalid || !0;
  }
  cellValidate(t) {
    return this.validate(t.column.modules.validate, t, t.getValue());
  }
  ///////////////////////////////////
  ///////// Column Functions ////////
  ///////////////////////////////////
  columnValidate(t) {
    var e = [];
    return t.cells.forEach((a) => {
      this.cellValidate(a) !== !0 && e.push(a.getComponent());
    }), e.length ? e : !0;
  }
  ///////////////////////////////////
  ////////// Row Functions //////////
  ///////////////////////////////////
  rowValidate(t) {
    var e = [];
    return t.cells.forEach((a) => {
      this.cellValidate(a) !== !0 && e.push(a.getComponent());
    }), e.length ? e : !0;
  }
  ///////////////////////////////////
  ///////// Table Functions /////////
  ///////////////////////////////////
  userClearCellValidation(t) {
    t || (t = this.getInvalidCells()), Array.isArray(t) || (t = [t]), t.forEach((e) => {
      this.clearValidation(e._getSelf());
    });
  }
  userValidate(t) {
    var e = [];
    return this.table.rowManager.rows.forEach((a) => {
      a = a.getComponent();
      var n = a.validate();
      n !== !0 && (e = e.concat(n));
    }), e.length ? e : !0;
  }
  ///////////////////////////////////
  ///////// Internal Logic //////////
  ///////////////////////////////////
  initializeColumnCheck(t) {
    typeof t.definition.validator < "u" && this.initializeColumn(t);
  }
  //validate
  initializeColumn(t) {
    var e = this, a = [], n;
    t.definition.validator && (Array.isArray(t.definition.validator) ? t.definition.validator.forEach((i) => {
      n = e._extractValidator(i), n && a.push(n);
    }) : (n = this._extractValidator(t.definition.validator), n && a.push(n)), t.modules.validate = a.length ? a : !1);
  }
  _extractValidator(t) {
    var e, a, n;
    switch (typeof t) {
      case "string":
        return n = t.indexOf(":"), n > -1 ? (e = t.substring(0, n), a = t.substring(n + 1)) : e = t, this._buildValidator(e, a);
      case "function":
        return this._buildValidator(t);
      case "object":
        return this._buildValidator(t.type, t.parameters);
    }
  }
  _buildValidator(t, e) {
    var a = typeof t == "function" ? t : sp.validators[t];
    return a ? {
      type: typeof t == "function" ? "function" : t,
      func: a,
      params: e
    } : (console.warn("Validator Setup Error - No matching validator found:", t), !1);
  }
  validate(t, e, a) {
    var n = this, i = [], r = this.invalidCells.indexOf(e);
    return t && t.forEach((l) => {
      l.func.call(n, e.getComponent(), a, l.params) || i.push({
        type: l.type,
        parameters: l.params
      });
    }), e.modules.validate || (e.modules.validate = {}), i.length ? (e.modules.validate.invalid = i, this.table.options.validationMode !== "manual" && e.getElement().classList.add("tabulator-validation-fail"), r == -1 && this.invalidCells.push(e)) : (e.modules.validate.invalid = !1, e.getElement().classList.remove("tabulator-validation-fail"), r > -1 && this.invalidCells.splice(r, 1)), i.length ? i : !0;
  }
  getInvalidCells() {
    var t = [];
    return this.invalidCells.forEach((e) => {
      t.push(e.getComponent());
    }), t;
  }
  clearValidation(t) {
    var e;
    t.modules.validate && t.modules.validate.invalid && (t.getElement().classList.remove("tabulator-validation-fail"), t.modules.validate.invalid = !1, e = this.invalidCells.indexOf(t), e > -1 && this.invalidCells.splice(e, 1));
  }
}
sp.moduleName = "validate";
sp.validators = n6;
var s6 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  AccessorModule: Pc,
  AjaxModule: gi,
  ClipboardModule: Zl,
  ColumnCalcsModule: Wr,
  DataTreeModule: FN,
  DownloadModule: Ec,
  EditModule: ep,
  ExportModule: zN,
  FilterModule: ur,
  FormatModule: Vs,
  FrozenColumnsModule: BN,
  FrozenRowsModule: WN,
  GroupRowsModule: jN,
  HistoryModule: to,
  HtmlTableImportModule: VN,
  ImportModule: ap,
  InteractionModule: qN,
  KeybindingsModule: Zr,
  MenuModule: KN,
  MoveColumnsModule: JN,
  MoveRowsModule: vf,
  MutatorModule: Nc,
  PageModule: np,
  PersistenceModule: ms,
  PopupModule: QN,
  PrintModule: ZN,
  ReactiveDataModule: tR,
  ResizeColumnsModule: eR,
  ResizeRowsModule: aR,
  ResizeTableModule: nR,
  ResponsiveLayoutModule: sR,
  SelectRowModule: iR,
  SortModule: Gl,
  SelectRangeModule: rR,
  TooltipModule: lR,
  ValidateModule: sp
}), i6 = {
  debugEventsExternal: !1,
  //flag to console log events
  debugEventsInternal: !1,
  //flag to console log events
  debugInvalidOptions: !0,
  //allow toggling of invalid option warnings
  debugInvalidComponentFuncs: !0,
  //allow toggling of invalid component warnings
  debugInitialization: !0,
  //allow toggling of pre initialization function call warnings
  debugDeprecation: !0,
  //allow toggling of deprecation warnings
  height: !1,
  //height of tabulator
  minHeight: !1,
  //minimum height of tabulator
  maxHeight: !1,
  //maximum height of tabulator
  columnHeaderVertAlign: "top",
  //vertical alignment of column headers
  popupContainer: !1,
  columns: [],
  //store for colum header info
  columnDefaults: {},
  //store column default props
  data: !1,
  //default starting data
  autoColumns: !1,
  //build columns from data row structure
  autoColumnsDefinitions: !1,
  nestedFieldSeparator: ".",
  //separator for nested data
  footerElement: !1,
  //hold footer element
  index: "id",
  //filed for row index
  textDirection: "auto",
  addRowPos: "bottom",
  //position to insert blank rows, top|bottom
  headerVisible: !0,
  //hide header
  renderVertical: "virtual",
  renderHorizontal: "basic",
  renderVerticalBuffer: 0,
  // set virtual DOM buffer size
  scrollToRowPosition: "top",
  scrollToRowIfVisible: !0,
  scrollToColumnPosition: "left",
  scrollToColumnIfVisible: !0,
  rowFormatter: !1,
  rowFormatterPrint: null,
  rowFormatterClipboard: null,
  rowFormatterHtmlOutput: null,
  rowHeight: null,
  placeholder: !1,
  dataLoader: !0,
  dataLoaderLoading: !1,
  dataLoaderError: !1,
  dataLoaderErrorTimeout: 3e3,
  dataSendParams: {},
  dataReceiveParams: {}
};
class oR {
  constructor(t, e, a = {}) {
    this.table = t, this.msgType = e, this.registeredDefaults = Object.assign({}, a);
  }
  register(t, e) {
    this.registeredDefaults[t] = e;
  }
  generate(t, e = {}) {
    var a = Object.assign({}, this.registeredDefaults), n = this.table.options.debugInvalidOptions || e.debugInvalidOptions === !0;
    Object.assign(a, t);
    for (let i in e)
      a.hasOwnProperty(i) || (n && console.warn("Invalid " + this.msgType + " option:", i), a[i] = e.key);
    for (let i in a)
      i in e ? a[i] = e[i] : Array.isArray(a[i]) ? a[i] = Object.assign([], a[i]) : typeof a[i] == "object" && a[i] !== null ? a[i] = Object.assign({}, a[i]) : typeof a[i] > "u" && delete a[i];
    return a;
  }
}
class xf extends ds {
  constructor(t) {
    super(t), this.elementVertical = t.rowManager.element, this.elementHorizontal = t.columnManager.element, this.tableElement = t.rowManager.tableElement, this.verticalFillMode = "fit";
  }
  ///////////////////////////////////
  /////// Internal Bindings /////////
  ///////////////////////////////////
  initialize() {
  }
  clearRows() {
  }
  clearColumns() {
  }
  reinitializeColumnWidths(t) {
  }
  renderRows() {
  }
  renderColumns() {
  }
  rerenderRows(t) {
    t && t();
  }
  rerenderColumns(t, e) {
  }
  renderRowCells(t) {
  }
  rerenderRowCells(t, e) {
  }
  scrollColumns(t, e) {
  }
  scrollRows(t, e) {
  }
  resize() {
  }
  scrollToRow(t) {
  }
  scrollToRowNearestTop(t) {
  }
  visibleRows(t) {
    return [];
  }
  ///////////////////////////////////
  //////// Helper Functions /////////
  ///////////////////////////////////
  rows() {
    return this.table.rowManager.getDisplayRows();
  }
  styleRow(t, e) {
    var a = t.getElement();
    e % 2 ? (a.classList.add("tabulator-row-even"), a.classList.remove("tabulator-row-odd")) : (a.classList.add("tabulator-row-odd"), a.classList.remove("tabulator-row-even"));
  }
  ///////////////////////////////////
  /////// External Triggers /////////
  /////// (DO NOT OVERRIDE) /////////
  ///////////////////////////////////
  clear() {
    this.clearRows(), this.clearColumns();
  }
  render() {
    this.renderRows(), this.renderColumns();
  }
  rerender(t) {
    this.rerenderRows(), this.rerenderColumns();
  }
  scrollToRowPosition(t, e, a) {
    var n = this.rows().indexOf(t), i = t.getElement(), r = 0;
    return new Promise((l, o) => {
      if (n > -1) {
        if (typeof a > "u" && (a = this.table.options.scrollToRowIfVisible), !a && za.elVisible(i) && (r = za.elOffset(i).top - za.elOffset(this.elementVertical).top, r > 0 && r < this.elementVertical.clientHeight - i.offsetHeight))
          return l(), !1;
        switch (typeof e > "u" && (e = this.table.options.scrollToRowPosition), e === "nearest" && (e = this.scrollToRowNearestTop(t) ? "top" : "bottom"), this.scrollToRow(t), e) {
          case "middle":
          case "center":
            this.elementVertical.scrollHeight - this.elementVertical.scrollTop == this.elementVertical.clientHeight ? this.elementVertical.scrollTop = this.elementVertical.scrollTop + (i.offsetTop - this.elementVertical.scrollTop) - (this.elementVertical.scrollHeight - i.offsetTop) / 2 : this.elementVertical.scrollTop = this.elementVertical.scrollTop - this.elementVertical.clientHeight / 2;
            break;
          case "bottom":
            this.elementVertical.scrollHeight - this.elementVertical.scrollTop == this.elementVertical.clientHeight ? this.elementVertical.scrollTop = this.elementVertical.scrollTop - (this.elementVertical.scrollHeight - i.offsetTop) + i.offsetHeight : this.elementVertical.scrollTop = this.elementVertical.scrollTop - this.elementVertical.clientHeight + i.offsetHeight;
            break;
          case "top":
            this.elementVertical.scrollTop = i.offsetTop;
            break;
        }
        l();
      } else
        console.warn("Scroll Error - Row not visible"), o("Scroll Error - Row not visible");
    });
  }
}
class r6 extends xf {
  constructor(t) {
    super(t);
  }
  renderRowCells(t, e) {
    const a = document.createDocumentFragment();
    t.cells.forEach((n) => {
      a.appendChild(n.getElement());
    }), t.element.appendChild(a), e || t.cells.forEach((n) => {
      n.cellRendered();
    });
  }
  reinitializeColumnWidths(t) {
    t.forEach(function(e) {
      e.reinitializeWidth();
    });
  }
}
class l6 extends xf {
  constructor(t) {
    super(t), this.leftCol = 0, this.rightCol = 0, this.scrollLeft = 0, this.vDomScrollPosLeft = 0, this.vDomScrollPosRight = 0, this.vDomPadLeft = 0, this.vDomPadRight = 0, this.fitDataColAvg = 0, this.windowBuffer = 200, this.visibleRows = null, this.initialized = !1, this.isFitData = !1, this.columns = [];
  }
  initialize() {
    this.compatibilityCheck(), this.layoutCheck(), this.vertScrollListen();
  }
  compatibilityCheck() {
    this.options("layout") == "fitDataTable" && console.warn("Horizontal Virtual DOM is not compatible with fitDataTable layout mode"), this.options("responsiveLayout") && console.warn("Horizontal Virtual DOM is not compatible with responsive columns"), this.options("rtl") && console.warn("Horizontal Virtual DOM is not currently compatible with RTL text direction");
  }
  layoutCheck() {
    this.isFitData = this.options("layout").startsWith("fitData");
  }
  vertScrollListen() {
    this.subscribe("scroll-vertical", this.clearVisRowCache.bind(this)), this.subscribe("data-refreshed", this.clearVisRowCache.bind(this));
  }
  clearVisRowCache() {
    this.visibleRows = null;
  }
  //////////////////////////////////////
  ///////// Public Functions ///////////
  //////////////////////////////////////
  renderColumns(t, e) {
    this.dataChange();
  }
  scrollColumns(t, e) {
    this.scrollLeft != t && (this.scrollLeft = t, this.scroll(t - (this.vDomScrollPosLeft + this.windowBuffer)));
  }
  calcWindowBuffer() {
    var t = this.elementVertical.clientWidth;
    this.table.columnManager.columnsByIndex.forEach((e) => {
      if (e.visible) {
        var a = e.getWidth();
        a > t && (t = a);
      }
    }), this.windowBuffer = t * 2;
  }
  rerenderColumns(t, e) {
    var a = {
      cols: this.columns,
      leftCol: this.leftCol,
      rightCol: this.rightCol
    }, n = 0;
    t && !this.initialized || (this.clear(), this.calcWindowBuffer(), this.scrollLeft = this.elementVertical.scrollLeft, this.vDomScrollPosLeft = this.scrollLeft - this.windowBuffer, this.vDomScrollPosRight = this.scrollLeft + this.elementVertical.clientWidth + this.windowBuffer, this.table.columnManager.columnsByIndex.forEach((i) => {
      var r = {}, l;
      i.visible && (i.modules.frozen || (l = i.getWidth(), r.leftPos = n, r.rightPos = n + l, r.width = l, this.isFitData && (r.fitDataCheck = i.modules.vdomHoz ? i.modules.vdomHoz.fitDataCheck : !0), n + l > this.vDomScrollPosLeft && n < this.vDomScrollPosRight ? (this.leftCol == -1 && (this.leftCol = this.columns.length, this.vDomPadLeft = n), this.rightCol = this.columns.length) : this.leftCol !== -1 && (this.vDomPadRight += l), this.columns.push(i), i.modules.vdomHoz = r, n += l));
    }), this.tableElement.style.paddingLeft = this.vDomPadLeft + "px", this.tableElement.style.paddingRight = this.vDomPadRight + "px", this.initialized = !0, e || (!t || this.reinitChanged(a)) && this.reinitializeRows(), this.elementVertical.scrollLeft = this.scrollLeft);
  }
  renderRowCells(t) {
    if (this.initialized)
      this.initializeRow(t);
    else {
      const e = document.createDocumentFragment();
      t.cells.forEach((a) => {
        e.appendChild(a.getElement());
      }), t.element.appendChild(e), t.cells.forEach((a) => {
        a.cellRendered();
      });
    }
  }
  rerenderRowCells(t, e) {
    this.reinitializeRow(t, e);
  }
  reinitializeColumnWidths(t) {
    for (let e = this.leftCol; e <= this.rightCol; e++)
      this.columns[e].reinitializeWidth();
  }
  //////////////////////////////////////
  //////// Internal Rendering //////////
  //////////////////////////////////////
  deinitialize() {
    this.initialized = !1;
  }
  clear() {
    this.columns = [], this.leftCol = -1, this.rightCol = 0, this.vDomScrollPosLeft = 0, this.vDomScrollPosRight = 0, this.vDomPadLeft = 0, this.vDomPadRight = 0;
  }
  dataChange() {
    var t = !1, e, a;
    if (this.isFitData) {
      if (this.table.columnManager.columnsByIndex.forEach((n) => {
        !n.definition.width && n.visible && (t = !0);
      }), t && this.table.rowManager.getDisplayRows().length && (this.vDomScrollPosRight = this.scrollLeft + this.elementVertical.clientWidth + this.windowBuffer, e = this.chain("rows-sample", [1], [], () => this.table.rowManager.getDisplayRows())[0], e)) {
        a = e.getElement(), e.generateCells(), this.tableElement.appendChild(a);
        for (let n = 0; n < e.cells.length; n++) {
          let i = e.cells[n];
          a.appendChild(i.getElement()), i.column.reinitializeWidth();
        }
        a.parentNode.removeChild(a), this.rerenderColumns(!1, !0);
      }
    } else
      this.options("layout") === "fitColumns" && (this.layoutRefresh(), this.rerenderColumns(!1, !0));
  }
  reinitChanged(t) {
    var e = !0;
    return t.cols.length !== this.columns.length || t.leftCol !== this.leftCol || t.rightCol !== this.rightCol ? !0 : (t.cols.forEach((a, n) => {
      a !== this.columns[n] && (e = !1);
    }), !e);
  }
  reinitializeRows() {
    var t = this.getVisibleRows(), e = this.table.rowManager.getRows().filter((a) => !t.includes(a));
    t.forEach((a) => {
      this.reinitializeRow(a, !0);
    }), e.forEach((a) => {
      a.deinitialize();
    });
  }
  getVisibleRows() {
    return this.visibleRows || (this.visibleRows = this.table.rowManager.getVisibleRows()), this.visibleRows;
  }
  scroll(t) {
    this.vDomScrollPosLeft += t, this.vDomScrollPosRight += t, Math.abs(t) > this.windowBuffer / 2 ? this.rerenderColumns() : t > 0 ? (this.addColRight(), this.removeColLeft()) : (this.addColLeft(), this.removeColRight());
  }
  colPositionAdjust(t, e, a) {
    for (let n = t; n < e; n++) {
      let i = this.columns[n];
      i.modules.vdomHoz.leftPos += a, i.modules.vdomHoz.rightPos += a;
    }
  }
  addColRight() {
    for (var t = !1, e = !0; e; ) {
      let a = this.columns[this.rightCol + 1];
      a && a.modules.vdomHoz.leftPos <= this.vDomScrollPosRight ? (t = !0, this.getVisibleRows().forEach((n) => {
        if (n.type !== "group") {
          var i = n.getCell(a);
          n.getElement().insertBefore(i.getElement(), n.getCell(this.columns[this.rightCol]).getElement().nextSibling), i.cellRendered();
        }
      }), this.fitDataColActualWidthCheck(a), this.rightCol++, this.getVisibleRows().forEach((n) => {
        n.type !== "group" && (n.modules.vdomHoz.rightCol = this.rightCol);
      }), this.rightCol >= this.columns.length - 1 ? this.vDomPadRight = 0 : this.vDomPadRight -= a.getWidth()) : e = !1;
    }
    t && (this.tableElement.style.paddingRight = this.vDomPadRight + "px");
  }
  addColLeft() {
    for (var t = !1, e = !0; e; ) {
      let a = this.columns[this.leftCol - 1];
      if (a)
        if (a.modules.vdomHoz.rightPos >= this.vDomScrollPosLeft) {
          t = !0, this.getVisibleRows().forEach((i) => {
            if (i.type !== "group") {
              var r = i.getCell(a);
              i.getElement().insertBefore(r.getElement(), i.getCell(this.columns[this.leftCol]).getElement()), r.cellRendered();
            }
          }), this.leftCol--, this.getVisibleRows().forEach((i) => {
            i.type !== "group" && (i.modules.vdomHoz.leftCol = this.leftCol);
          }), this.leftCol <= 0 ? this.vDomPadLeft = 0 : this.vDomPadLeft -= a.getWidth();
          let n = this.fitDataColActualWidthCheck(a);
          n && (this.scrollLeft = this.elementVertical.scrollLeft = this.elementVertical.scrollLeft + n, this.vDomPadRight -= n);
        } else
          e = !1;
      else
        e = !1;
    }
    t && (this.tableElement.style.paddingLeft = this.vDomPadLeft + "px");
  }
  removeColRight() {
    for (var t = !1, e = !0; e; ) {
      let a = this.columns[this.rightCol];
      a && a.modules.vdomHoz.leftPos > this.vDomScrollPosRight ? (t = !0, this.getVisibleRows().forEach((n) => {
        if (n.type !== "group") {
          var i = n.getCell(a);
          try {
            n.getElement().removeChild(i.getElement());
          } catch (r) {
            console.warn("Could not removeColRight", r.message);
          }
        }
      }), this.vDomPadRight += a.getWidth(), this.rightCol--, this.getVisibleRows().forEach((n) => {
        n.type !== "group" && (n.modules.vdomHoz.rightCol = this.rightCol);
      })) : e = !1;
    }
    t && (this.tableElement.style.paddingRight = this.vDomPadRight + "px");
  }
  removeColLeft() {
    for (var t = !1, e = !0; e; ) {
      let a = this.columns[this.leftCol];
      a && a.modules.vdomHoz.rightPos < this.vDomScrollPosLeft ? (t = !0, this.getVisibleRows().forEach((n) => {
        if (n.type !== "group") {
          var i = n.getCell(a);
          try {
            n.getElement().removeChild(i.getElement());
          } catch (r) {
            console.warn("Could not removeColLeft", r.message);
          }
        }
      }), this.vDomPadLeft += a.getWidth(), this.leftCol++, this.getVisibleRows().forEach((n) => {
        n.type !== "group" && (n.modules.vdomHoz.leftCol = this.leftCol);
      })) : e = !1;
    }
    t && (this.tableElement.style.paddingLeft = this.vDomPadLeft + "px");
  }
  fitDataColActualWidthCheck(t) {
    var e, a;
    return t.modules.vdomHoz.fitDataCheck && (t.reinitializeWidth(), e = t.getWidth(), a = e - t.modules.vdomHoz.width, a && (t.modules.vdomHoz.rightPos += a, t.modules.vdomHoz.width = e, this.colPositionAdjust(this.columns.indexOf(t) + 1, this.columns.length, a)), t.modules.vdomHoz.fitDataCheck = !1), a;
  }
  initializeRow(t) {
    if (t.type !== "group") {
      t.modules.vdomHoz = {
        leftCol: this.leftCol,
        rightCol: this.rightCol
      }, this.table.modules.frozenColumns && this.table.modules.frozenColumns.leftColumns.forEach((e) => {
        this.appendCell(t, e);
      });
      for (let e = this.leftCol; e <= this.rightCol; e++)
        this.appendCell(t, this.columns[e]);
      this.table.modules.frozenColumns && this.table.modules.frozenColumns.rightColumns.forEach((e) => {
        this.appendCell(t, e);
      });
    }
  }
  appendCell(t, e) {
    if (e && e.visible) {
      let a = t.getCell(e);
      t.getElement().appendChild(a.getElement()), a.cellRendered();
    }
  }
  reinitializeRow(t, e) {
    if (t.type !== "group" && (e || !t.modules.vdomHoz || t.modules.vdomHoz.leftCol !== this.leftCol || t.modules.vdomHoz.rightCol !== this.rightCol)) {
      for (var a = t.getElement(); a.firstChild; )
        a.removeChild(a.firstChild);
      this.initializeRow(t);
    }
  }
}
class o6 extends ds {
  constructor(t) {
    super(t), this.blockHozScrollEvent = !1, this.headersElement = null, this.contentsElement = null, this.element = null, this.columns = [], this.columnsByIndex = [], this.columnsByField = {}, this.scrollLeft = 0, this.optionsList = new oR(this.table, "column definition", UN), this.redrawBlock = !1, this.redrawBlockUpdate = null, this.renderer = null;
  }
  ////////////// Setup Functions /////////////////
  initialize() {
    this.initializeRenderer(), this.headersElement = this.createHeadersElement(), this.contentsElement = this.createHeaderContentsElement(), this.element = this.createHeaderElement(), this.contentsElement.insertBefore(this.headersElement, this.contentsElement.firstChild), this.element.insertBefore(this.contentsElement, this.element.firstChild), this.initializeScrollWheelWatcher(), this.subscribe("scroll-horizontal", this.scrollHorizontal.bind(this)), this.subscribe("scrollbar-vertical", this.padVerticalScrollbar.bind(this));
  }
  padVerticalScrollbar(t) {
    this.table.rtl ? this.headersElement.style.marginLeft = t + "px" : this.headersElement.style.marginRight = t + "px";
  }
  initializeRenderer() {
    var t, e = {
      virtual: l6,
      basic: r6
    };
    typeof this.table.options.renderHorizontal == "string" ? t = e[this.table.options.renderHorizontal] : t = this.table.options.renderHorizontal, t ? (this.renderer = new t(this.table, this.element, this.tableElement), this.renderer.initialize()) : console.error("Unable to find matching renderer:", this.table.options.renderHorizontal);
  }
  createHeadersElement() {
    var t = document.createElement("div");
    return t.classList.add("tabulator-headers"), t.setAttribute("role", "row"), t;
  }
  createHeaderContentsElement() {
    var t = document.createElement("div");
    return t.classList.add("tabulator-header-contents"), t.setAttribute("role", "rowgroup"), t;
  }
  createHeaderElement() {
    var t = document.createElement("div");
    return t.classList.add("tabulator-header"), t.setAttribute("role", "rowgroup"), this.table.options.headerVisible || t.classList.add("tabulator-header-hidden"), t;
  }
  //return containing element
  getElement() {
    return this.element;
  }
  //return containing contents element
  getContentsElement() {
    return this.contentsElement;
  }
  //return header containing element
  getHeadersElement() {
    return this.headersElement;
  }
  //scroll horizontally to match table body
  scrollHorizontal(t) {
    this.contentsElement.scrollLeft = t, this.scrollLeft = t, this.renderer.scrollColumns(t);
  }
  initializeScrollWheelWatcher() {
    this.contentsElement.addEventListener("wheel", (t) => {
      var e;
      t.deltaX && (e = this.contentsElement.scrollLeft + t.deltaX, this.table.rowManager.scrollHorizontal(e), this.table.columnManager.scrollHorizontal(e));
    });
  }
  ///////////// Column Setup Functions /////////////
  generateColumnsFromRowData(t) {
    var e = [], a = this.table.options.autoColumnsDefinitions, n, i;
    if (t && t.length) {
      n = t[0];
      for (var r in n) {
        let l = {
          field: r,
          title: r
        }, o = n[r];
        switch (typeof o) {
          case "undefined":
            i = "string";
            break;
          case "boolean":
            i = "boolean";
            break;
          case "object":
            Array.isArray(o) ? i = "array" : i = "string";
            break;
          default:
            !isNaN(o) && o !== "" ? i = "number" : o.match(/((^[0-9]+[a-z]+)|(^[a-z]+[0-9]+))+$/i) ? i = "alphanum" : i = "string";
            break;
        }
        l.sorter = i, e.push(l);
      }
      if (a)
        switch (typeof a) {
          case "function":
            this.table.options.columns = a.call(this.table, e);
            break;
          case "object":
            Array.isArray(a) ? e.forEach((l) => {
              var o = a.find((c) => c.field === l.field);
              o && Object.assign(l, o);
            }) : e.forEach((l) => {
              a[l.field] && Object.assign(l, a[l.field]);
            }), this.table.options.columns = e;
            break;
        }
      else
        this.table.options.columns = e;
      this.setColumns(this.table.options.columns);
    }
  }
  setColumns(t, e) {
    for (; this.headersElement.firstChild; )
      this.headersElement.removeChild(this.headersElement.firstChild);
    this.columns = [], this.columnsByIndex = [], this.columnsByField = {}, this.dispatch("columns-loading"), t.forEach((a, n) => {
      this._addColumn(a);
    }), this._reIndexColumns(), this.dispatch("columns-loaded"), this.rerenderColumns(!1, !0), this.redraw(!0);
  }
  _addColumn(t, e, a) {
    var n = new zi(t, this), i = n.getElement(), r = a && this.findColumnIndex(a);
    if (a && r > -1) {
      var l = a.getTopColumn(), o = this.columns.indexOf(l), c = l.getElement();
      e ? (this.columns.splice(o, 0, n), c.parentNode.insertBefore(i, c)) : (this.columns.splice(o + 1, 0, n), c.parentNode.insertBefore(i, c.nextSibling));
    } else
      e ? (this.columns.unshift(n), this.headersElement.insertBefore(n.getElement(), this.headersElement.firstChild)) : (this.columns.push(n), this.headersElement.appendChild(n.getElement()));
    return n.columnRendered(), n;
  }
  registerColumnField(t) {
    t.definition.field && (this.columnsByField[t.definition.field] = t);
  }
  registerColumnPosition(t) {
    this.columnsByIndex.push(t);
  }
  _reIndexColumns() {
    this.columnsByIndex = [], this.columns.forEach(function(t) {
      t.reRegisterPosition();
    });
  }
  //ensure column headers take up the correct amount of space in column groups
  verticalAlignHeaders() {
    var t = 0;
    this.redrawBlock || (this.headersElement.style.height = "", this.columns.forEach((e) => {
      e.clearVerticalAlign();
    }), this.columns.forEach((e) => {
      var a = e.getHeight();
      a > t && (t = a);
    }), this.headersElement.style.height = t + "px", this.columns.forEach((e) => {
      e.verticalAlign(this.table.options.columnHeaderVertAlign, t);
    }), this.table.rowManager.adjustTableSize());
  }
  //////////////// Column Details /////////////////
  findColumn(t) {
    var e;
    if (typeof t == "object") {
      if (t instanceof zi)
        return t;
      if (t instanceof HN)
        return t._getSelf() || !1;
      if (typeof HTMLElement < "u" && t instanceof HTMLElement)
        return e = [], this.columns.forEach((n) => {
          e.push(n), e = e.concat(n.getColumns(!0));
        }), e.find((n) => n.element === t) || !1;
    } else
      return this.columnsByField[t] || !1;
    return !1;
  }
  getColumnByField(t) {
    return this.columnsByField[t];
  }
  getColumnsByFieldRoot(t) {
    var e = [];
    return Object.keys(this.columnsByField).forEach((a) => {
      var n = this.table.options.nestedFieldSeparator ? a.split(this.table.options.nestedFieldSeparator)[0] : a;
      n === t && e.push(this.columnsByField[a]);
    }), e;
  }
  getColumnByIndex(t) {
    return this.columnsByIndex[t];
  }
  getFirstVisibleColumn() {
    var t = this.columnsByIndex.findIndex((e) => e.visible);
    return t > -1 ? this.columnsByIndex[t] : !1;
  }
  getVisibleColumnsByIndex() {
    return this.columnsByIndex.filter((t) => t.visible);
  }
  getColumns() {
    return this.columns;
  }
  findColumnIndex(t) {
    return this.columnsByIndex.findIndex((e) => t === e);
  }
  //return all columns that are not groups
  getRealColumns() {
    return this.columnsByIndex;
  }
  //traverse across columns and call action
  traverse(t) {
    this.columnsByIndex.forEach((e, a) => {
      t(e, a);
    });
  }
  //get definitions of actual columns
  getDefinitions(t) {
    var e = [];
    return this.columnsByIndex.forEach((a) => {
      (!t || t && a.visible) && e.push(a.getDefinition());
    }), e;
  }
  //get full nested definition tree
  getDefinitionTree() {
    var t = [];
    return this.columns.forEach((e) => {
      t.push(e.getDefinition(!0));
    }), t;
  }
  getComponents(t) {
    var e = [], a = t ? this.columns : this.columnsByIndex;
    return a.forEach((n) => {
      e.push(n.getComponent());
    }), e;
  }
  getWidth() {
    var t = 0;
    return this.columnsByIndex.forEach((e) => {
      e.visible && (t += e.getWidth());
    }), t;
  }
  moveColumn(t, e, a) {
    e.element.parentNode.insertBefore(t.element, e.element), a && e.element.parentNode.insertBefore(e.element, t.element), this.moveColumnActual(t, e, a), this.verticalAlignHeaders(), this.table.rowManager.reinitialize();
  }
  moveColumnActual(t, e, a) {
    t.parent.isGroup ? this._moveColumnInArray(t.parent.columns, t, e, a) : this._moveColumnInArray(this.columns, t, e, a), this._moveColumnInArray(this.columnsByIndex, t, e, a, !0), this.rerenderColumns(!0), this.dispatch("column-moved", t, e, a), this.subscribedExternal("columnMoved") && this.dispatchExternal("columnMoved", t.getComponent(), this.table.columnManager.getComponents());
  }
  _moveColumnInArray(t, e, a, n, i) {
    var r = t.indexOf(e), l, o = [];
    r > -1 && (t.splice(r, 1), l = t.indexOf(a), l > -1 ? n && (l = l + 1) : l = r, t.splice(l, 0, e), i && (o = this.chain("column-moving-rows", [e, a, n], null, []) || [], o = o.concat(this.table.rowManager.rows), o.forEach(function(c) {
      if (c.cells.length) {
        var d = c.cells.splice(r, 1)[0];
        c.cells.splice(l, 0, d);
      }
    })));
  }
  scrollToColumn(t, e, a) {
    var n = 0, i = t.getLeftOffset(), r = 0, l = t.getElement();
    return new Promise((o, c) => {
      if (typeof e > "u" && (e = this.table.options.scrollToColumnPosition), typeof a > "u" && (a = this.table.options.scrollToColumnIfVisible), t.visible) {
        switch (e) {
          case "middle":
          case "center":
            r = -this.element.clientWidth / 2;
            break;
          case "right":
            r = l.clientWidth - this.headersElement.clientWidth;
            break;
        }
        if (!a && i > 0 && i + l.offsetWidth < this.element.clientWidth)
          return !1;
        n = i + r, n = Math.max(Math.min(n, this.table.rowManager.element.scrollWidth - this.table.rowManager.element.clientWidth), 0), this.table.rowManager.scrollHorizontal(n), this.scrollHorizontal(n), o();
      } else
        console.warn("Scroll Error - Column not visible"), c("Scroll Error - Column not visible");
    });
  }
  //////////////// Cell Management /////////////////
  generateCells(t) {
    var e = [];
    return this.columnsByIndex.forEach((a) => {
      e.push(a.generateCell(t));
    }), e;
  }
  //////////////// Column Management /////////////////
  getFlexBaseWidth() {
    var t = this.table.element.clientWidth, e = 0;
    return this.table.rowManager.element.scrollHeight > this.table.rowManager.element.clientHeight && (t -= this.table.rowManager.element.offsetWidth - this.table.rowManager.element.clientWidth), this.columnsByIndex.forEach(function(a) {
      var n, i, r;
      a.visible && (n = a.definition.width || 0, i = parseInt(a.minWidth), typeof n == "string" ? n.indexOf("%") > -1 ? r = t / 100 * parseInt(n) : r = parseInt(n) : r = n, e += r > i ? r : i);
    }), e;
  }
  addColumn(t, e, a) {
    return new Promise((n, i) => {
      var r = this._addColumn(t, e, a);
      this._reIndexColumns(), this.dispatch("column-add", t, e, a), this.layoutMode() != "fitColumns" && r.reinitializeWidth(), this.redraw(!0), this.table.rowManager.reinitialize(), this.rerenderColumns(), n(r);
    });
  }
  //remove column from system
  deregisterColumn(t) {
    var e = t.getField(), a;
    e && delete this.columnsByField[e], a = this.columnsByIndex.indexOf(t), a > -1 && this.columnsByIndex.splice(a, 1), a = this.columns.indexOf(t), a > -1 && this.columns.splice(a, 1), this.verticalAlignHeaders(), this.redraw();
  }
  rerenderColumns(t, e) {
    this.redrawBlock ? (t === !1 || t === !0 && this.redrawBlockUpdate === null) && (this.redrawBlockUpdate = t) : this.renderer.rerenderColumns(t, e);
  }
  blockRedraw() {
    this.redrawBlock = !0, this.redrawBlockUpdate = null;
  }
  restoreRedraw() {
    this.redrawBlock = !1, this.verticalAlignHeaders(), this.renderer.rerenderColumns(this.redrawBlockUpdate);
  }
  //redraw columns
  redraw(t) {
    za.elVisible(this.element) && this.verticalAlignHeaders(), t && (this.table.rowManager.resetScroll(), this.table.rowManager.reinitialize()), this.confirm("table-redrawing", t) || this.layoutRefresh(t), this.dispatch("table-redraw", t), this.table.footerManager.redraw();
  }
}
class c6 extends xf {
  constructor(t) {
    super(t), this.verticalFillMode = "fill", this.scrollTop = 0, this.scrollLeft = 0, this.scrollTop = 0, this.scrollLeft = 0;
  }
  clearRows() {
    for (var t = this.tableElement; t.firstChild; )
      t.removeChild(t.firstChild);
    t.scrollTop = 0, t.scrollLeft = 0, t.style.minWidth = "", t.style.minHeight = "", t.style.display = "", t.style.visibility = "";
  }
  renderRows() {
    var t = this.tableElement, e = !0, a = document.createDocumentFragment(), n = this.rows();
    n.forEach((i, r) => {
      this.styleRow(i, r), i.initialize(!1, !0), i.type !== "group" && (e = !1), a.appendChild(i.getElement());
    }), t.appendChild(a), n.forEach((i) => {
      i.rendered(), i.heightInitialized || i.calcHeight(!0);
    }), n.forEach((i) => {
      i.heightInitialized || i.setCellHeight();
    }), e ? t.style.minWidth = this.table.columnManager.getWidth() + "px" : t.style.minWidth = "";
  }
  rerenderRows(t) {
    this.clearRows(), t && t(), this.renderRows(), this.rows().length || this.table.rowManager.tableEmpty();
  }
  scrollToRowNearestTop(t) {
    var e = za.elOffset(t.getElement()).top;
    return !(Math.abs(this.elementVertical.scrollTop - e) > Math.abs(this.elementVertical.scrollTop + this.elementVertical.clientHeight - e));
  }
  scrollToRow(t) {
    var e = t.getElement();
    this.elementVertical.scrollTop = za.elOffset(e).top - za.elOffset(this.elementVertical).top + this.elementVertical.scrollTop;
  }
  visibleRows(t) {
    return this.rows();
  }
}
class d6 extends xf {
  constructor(t) {
    super(t), this.verticalFillMode = "fill", this.scrollTop = 0, this.scrollLeft = 0, this.vDomRowHeight = 20, this.vDomTop = 0, this.vDomBottom = 0, this.vDomScrollPosTop = 0, this.vDomScrollPosBottom = 0, this.vDomTopPad = 0, this.vDomBottomPad = 0, this.vDomMaxRenderChain = 90, this.vDomWindowBuffer = 0, this.vDomWindowMinTotalRows = 20, this.vDomWindowMinMarginRows = 5, this.vDomTopNewRows = [], this.vDomBottomNewRows = [];
  }
  //////////////////////////////////////
  ///////// Public Functions ///////////
  //////////////////////////////////////
  clearRows() {
    for (var t = this.tableElement; t.firstChild; )
      t.removeChild(t.firstChild);
    t.style.paddingTop = "", t.style.paddingBottom = "", t.style.minHeight = "", t.style.display = "", t.style.visibility = "", this.elementVertical.scrollTop = 0, this.elementVertical.scrollLeft = 0, this.scrollTop = 0, this.scrollLeft = 0, this.vDomTop = 0, this.vDomBottom = 0, this.vDomTopPad = 0, this.vDomBottomPad = 0, this.vDomScrollPosTop = 0, this.vDomScrollPosBottom = 0;
  }
  renderRows() {
    this._virtualRenderFill();
  }
  rerenderRows(t) {
    for (var e = this.elementVertical.scrollTop, a = !1, n = !1, i = this.table.rowManager.scrollLeft, r = this.rows(), l = this.vDomTop; l <= this.vDomBottom; l++)
      if (r[l]) {
        var o = e - r[l].getElement().offsetTop;
        if (n === !1 || Math.abs(o) < n)
          n = o, a = l;
        else
          break;
      }
    r.forEach((c) => {
      c.deinitializeHeight();
    }), t && t(), this.rows().length ? this._virtualRenderFill(a === !1 ? this.rows.length - 1 : a, !0, n || 0) : (this.clear(), this.table.rowManager.tableEmpty()), this.scrollColumns(i);
  }
  scrollColumns(t) {
    this.table.rowManager.scrollHorizontal(t);
  }
  scrollRows(t, e) {
    var a = t - this.vDomScrollPosTop, n = t - this.vDomScrollPosBottom, i = this.vDomWindowBuffer * 2, r = this.rows();
    if (this.scrollTop = t, -a > i || n > i) {
      var l = this.table.rowManager.scrollLeft;
      this._virtualRenderFill(Math.floor(this.elementVertical.scrollTop / this.elementVertical.scrollHeight * r.length)), this.scrollColumns(l);
    } else
      e ? (a < 0 && this._addTopRow(r, -a), n < 0 && (this.vDomScrollHeight - this.scrollTop > this.vDomWindowBuffer ? this._removeBottomRow(r, -n) : this.vDomScrollPosBottom = this.scrollTop)) : (n >= 0 && this._addBottomRow(r, n), a >= 0 && (this.scrollTop > this.vDomWindowBuffer ? this._removeTopRow(r, a) : this.vDomScrollPosTop = this.scrollTop));
  }
  resize() {
    this.vDomWindowBuffer = this.table.options.renderVerticalBuffer || this.elementVertical.clientHeight;
  }
  scrollToRowNearestTop(t) {
    var e = this.rows().indexOf(t);
    return !(Math.abs(this.vDomTop - e) > Math.abs(this.vDomBottom - e));
  }
  scrollToRow(t) {
    var e = this.rows().indexOf(t);
    e > -1 && this._virtualRenderFill(e, !0);
  }
  visibleRows(t) {
    var e = this.elementVertical.scrollTop, a = this.elementVertical.clientHeight + e, n = !1, i = 0, r = 0, l = this.rows();
    if (t)
      i = this.vDomTop, r = this.vDomBottom;
    else
      for (var o = this.vDomTop; o <= this.vDomBottom; o++)
        if (l[o])
          if (n)
            if (a - l[o].getElement().offsetTop >= 0)
              r = o;
            else
              break;
          else if (e - l[o].getElement().offsetTop >= 0)
            i = o;
          else if (n = !0, a - l[o].getElement().offsetTop >= 0)
            r = o;
          else
            break;
    return l.slice(i, r + 1);
  }
  //////////////////////////////////////
  //////// Internal Rendering //////////
  //////////////////////////////////////
  //full virtual render
  _virtualRenderFill(t, e, a) {
    var n = this.tableElement, i = this.elementVertical, r = 0, l = 0, o = 0, c = 0, d = 0, p = 0, h = this.rows(), g = h.length, x = 0, b, A, T = [], R = 0, C = 0, v = this.table.rowManager.fixedHeight, P = this.elementVertical.clientHeight, O = this.table.options.rowHeight, N = !0;
    if (t = t || 0, a = a || 0, !t)
      this.clear();
    else {
      for (; n.firstChild; )
        n.removeChild(n.firstChild);
      c = (g - t + 1) * this.vDomRowHeight, c < P && (t -= Math.ceil((P - c) / this.vDomRowHeight), t < 0 && (t = 0)), r = Math.min(Math.max(Math.floor(this.vDomWindowBuffer / this.vDomRowHeight), this.vDomWindowMinMarginRows), t), t -= r;
    }
    if (g && za.elVisible(this.elementVertical)) {
      for (this.vDomTop = t, this.vDomBottom = t - 1, v || this.table.options.maxHeight ? (O && (C = P / O + this.vDomWindowBuffer / O), C = Math.max(this.vDomWindowMinTotalRows, Math.ceil(C))) : C = g; (C == g || l <= P + this.vDomWindowBuffer || R < this.vDomWindowMinTotalRows) && this.vDomBottom < g - 1; ) {
        for (T = [], A = document.createDocumentFragment(), p = 0; p < C && this.vDomBottom < g - 1; )
          x = this.vDomBottom + 1, b = h[x], this.styleRow(b, x), b.initialize(!1, !0), !b.heightInitialized && !this.table.options.rowHeight && b.clearCellHeight(), A.appendChild(b.getElement()), T.push(b), this.vDomBottom++, p++;
        if (!T.length)
          break;
        n.appendChild(A), T.forEach((H) => {
          H.rendered(), H.heightInitialized || H.calcHeight(!0);
        }), T.forEach((H) => {
          H.heightInitialized || H.setCellHeight();
        }), T.forEach((H) => {
          o = H.getHeight(), R < r ? d += o : l += o, o > this.vDomWindowBuffer && (this.vDomWindowBuffer = o * 2), R++;
        }), N = this.table.rowManager.adjustTableSize(), P = this.elementVertical.clientHeight, N && (v || this.table.options.maxHeight) && (O = l / R, C = Math.max(this.vDomWindowMinTotalRows, Math.ceil(P / O + this.vDomWindowBuffer / O)));
      }
      t ? (this.vDomTopPad = e ? this.vDomRowHeight * this.vDomTop + a : this.scrollTop - d, this.vDomBottomPad = this.vDomBottom == g - 1 ? 0 : Math.max(this.vDomScrollHeight - this.vDomTopPad - l - d, 0)) : (this.vDomTopPad = 0, this.vDomRowHeight = Math.floor((l + d) / R), this.vDomBottomPad = this.vDomRowHeight * (g - this.vDomBottom - 1), this.vDomScrollHeight = d + l + this.vDomBottomPad - P), n.style.paddingTop = this.vDomTopPad + "px", n.style.paddingBottom = this.vDomBottomPad + "px", e && (this.scrollTop = this.vDomTopPad + d + a - (this.elementVertical.scrollWidth > this.elementVertical.clientWidth ? this.elementVertical.offsetHeight - P : 0)), this.scrollTop = Math.min(this.scrollTop, this.elementVertical.scrollHeight - P), this.elementVertical.scrollWidth > this.elementVertical.clientWidth && e && (this.scrollTop += this.elementVertical.offsetHeight - P), this.vDomScrollPosTop = this.scrollTop, this.vDomScrollPosBottom = this.scrollTop, i.scrollTop = this.scrollTop, this.dispatch("render-virtual-fill");
    }
  }
  _addTopRow(t, e) {
    for (var a = this.tableElement, n = [], i = 0, r = this.vDomTop - 1, l = 0, o = !0; o; )
      if (this.vDomTop) {
        let c = t[r], d, p;
        c && l < this.vDomMaxRenderChain ? (d = c.getHeight() || this.vDomRowHeight, p = c.initialized, e >= d ? (this.styleRow(c, r), a.insertBefore(c.getElement(), a.firstChild), (!c.initialized || !c.heightInitialized) && n.push(c), c.initialize(), p || (d = c.getElement().offsetHeight, d > this.vDomWindowBuffer && (this.vDomWindowBuffer = d * 2)), e -= d, i += d, this.vDomTop--, r--, l++) : o = !1) : o = !1;
      } else
        o = !1;
    for (let c of n)
      c.clearCellHeight();
    this._quickNormalizeRowHeight(n), i && (this.vDomTopPad -= i, this.vDomTopPad < 0 && (this.vDomTopPad = r * this.vDomRowHeight), r < 1 && (this.vDomTopPad = 0), a.style.paddingTop = this.vDomTopPad + "px", this.vDomScrollPosTop -= i);
  }
  _removeTopRow(t, e) {
    for (var a = [], n = 0, i = 0, r = !0; r; ) {
      let l = t[this.vDomTop], o;
      l && i < this.vDomMaxRenderChain ? (o = l.getHeight() || this.vDomRowHeight, e >= o ? (this.vDomTop++, e -= o, n += o, a.push(l), i++) : r = !1) : r = !1;
    }
    for (let l of a) {
      let o = l.getElement();
      o.parentNode && o.parentNode.removeChild(o);
    }
    n && (this.vDomTopPad += n, this.tableElement.style.paddingTop = this.vDomTopPad + "px", this.vDomScrollPosTop += this.vDomTop ? n : n + this.vDomWindowBuffer);
  }
  _addBottomRow(t, e) {
    for (var a = this.tableElement, n = [], i = 0, r = this.vDomBottom + 1, l = 0, o = !0; o; ) {
      let c = t[r], d, p;
      c && l < this.vDomMaxRenderChain ? (d = c.getHeight() || this.vDomRowHeight, p = c.initialized, e >= d ? (this.styleRow(c, r), a.appendChild(c.getElement()), (!c.initialized || !c.heightInitialized) && n.push(c), c.initialize(), p || (d = c.getElement().offsetHeight, d > this.vDomWindowBuffer && (this.vDomWindowBuffer = d * 2)), e -= d, i += d, this.vDomBottom++, r++, l++) : o = !1) : o = !1;
    }
    for (let c of n)
      c.clearCellHeight();
    this._quickNormalizeRowHeight(n), i && (this.vDomBottomPad -= i, (this.vDomBottomPad < 0 || r == t.length - 1) && (this.vDomBottomPad = 0), a.style.paddingBottom = this.vDomBottomPad + "px", this.vDomScrollPosBottom += i);
  }
  _removeBottomRow(t, e) {
    for (var a = [], n = 0, i = 0, r = !0; r; ) {
      let l = t[this.vDomBottom], o;
      l && i < this.vDomMaxRenderChain ? (o = l.getHeight() || this.vDomRowHeight, e >= o ? (this.vDomBottom--, e -= o, n += o, a.push(l), i++) : r = !1) : r = !1;
    }
    for (let l of a) {
      let o = l.getElement();
      o.parentNode && o.parentNode.removeChild(o);
    }
    n && (this.vDomBottomPad += n, this.vDomBottomPad < 0 && (this.vDomBottomPad = 0), this.tableElement.style.paddingBottom = this.vDomBottomPad + "px", this.vDomScrollPosBottom -= n);
  }
  _quickNormalizeRowHeight(t) {
    for (let e of t)
      e.calcHeight();
    for (let e of t)
      e.setCellHeight();
  }
}
class u6 extends ds {
  constructor(t) {
    super(t), this.element = this.createHolderElement(), this.tableElement = this.createTableElement(), this.heightFixer = this.createTableElement(), this.placeholder = null, this.placeholderContents = null, this.firstRender = !1, this.renderMode = "virtual", this.fixedHeight = !1, this.rows = [], this.activeRowsPipeline = [], this.activeRows = [], this.activeRowsCount = 0, this.displayRows = [], this.displayRowsCount = 0, this.scrollTop = 0, this.scrollLeft = 0, this.redrawBlock = !1, this.redrawBlockRestoreConfig = !1, this.redrawBlockRenderInPosition = !1, this.dataPipeline = [], this.displayPipeline = [], this.scrollbarWidth = 0, this.renderer = null;
  }
  //////////////// Setup Functions /////////////////
  createHolderElement() {
    var t = document.createElement("div");
    return t.classList.add("tabulator-tableholder"), t.setAttribute("tabindex", 0), t;
  }
  createTableElement() {
    var t = document.createElement("div");
    return t.classList.add("tabulator-table"), t.setAttribute("role", "rowgroup"), t;
  }
  initializePlaceholder() {
    var t = this.table.options.placeholder;
    if (typeof t == "function" && (t = t.call(this.table)), t = this.chain("placeholder", [t], t, t) || t, t) {
      let e = document.createElement("div");
      if (e.classList.add("tabulator-placeholder"), typeof t == "string") {
        let a = document.createElement("div");
        a.classList.add("tabulator-placeholder-contents"), a.innerHTML = t, e.appendChild(a), this.placeholderContents = a;
      } else
        typeof HTMLElement < "u" && t instanceof HTMLElement ? (e.appendChild(t), this.placeholderContents = t) : (console.warn("Invalid placeholder provided, must be string or HTML Element", t), this.el = null);
      this.placeholder = e;
    }
  }
  //return containing element
  getElement() {
    return this.element;
  }
  //return table element
  getTableElement() {
    return this.tableElement;
  }
  initialize() {
    this.initializePlaceholder(), this.initializeRenderer(), this.element.appendChild(this.tableElement), this.firstRender = !0, this.element.addEventListener("scroll", () => {
      var t = this.element.scrollLeft, e = this.scrollLeft > t, a = this.element.scrollTop, n = this.scrollTop > a;
      this.scrollLeft != t && (this.scrollLeft = t, this.dispatch("scroll-horizontal", t, e), this.dispatchExternal("scrollHorizontal", t, e), this._positionPlaceholder()), this.scrollTop != a && (this.scrollTop = a, this.renderer.scrollRows(a, n), this.dispatch("scroll-vertical", a, n), this.dispatchExternal("scrollVertical", a, n));
    });
  }
  ////////////////// Row Manipulation //////////////////
  findRow(t) {
    if (typeof t == "object") {
      if (t instanceof ss)
        return t;
      if (t instanceof ff)
        return t._getSelf() || !1;
      if (typeof HTMLElement < "u" && t instanceof HTMLElement)
        return this.rows.find((a) => a.getElement() === t) || !1;
      if (t === null)
        return !1;
    } else
      return typeof t > "u" ? !1 : this.rows.find((a) => a.data[this.table.options.index] == t) || !1;
    return !1;
  }
  getRowFromDataObject(t) {
    var e = this.rows.find((a) => a.data === t);
    return e || !1;
  }
  getRowFromPosition(t) {
    return this.getDisplayRows().find((e) => e.getPosition() === t && e.isDisplayed());
  }
  scrollToRow(t, e, a) {
    return this.renderer.scrollToRowPosition(t, e, a);
  }
  ////////////////// Data Handling //////////////////
  setData(t, e, a) {
    return new Promise((n, i) => {
      e && this.getDisplayRows().length ? this.table.options.pagination ? this._setDataActual(t, !0) : this.reRenderInPosition(() => {
        this._setDataActual(t);
      }) : (this.table.options.autoColumns && a && this.table.initialized && this.table.columnManager.generateColumnsFromRowData(t), this.resetScroll(), this._setDataActual(t)), n();
    });
  }
  _setDataActual(t, e) {
    this.dispatchExternal("dataProcessing", t), this._wipeElements(), Array.isArray(t) ? (this.dispatch("data-processing", t), t.forEach((a, n) => {
      if (a && typeof a == "object") {
        var i = new ss(a, this);
        this.rows.push(i);
      } else
        console.warn("Data Loading Warning - Invalid row data detected and ignored, expecting object but received:", a);
    }), this.refreshActiveData(!1, !1, e), this.dispatch("data-processed", t), this.dispatchExternal("dataProcessed", t)) : console.error(`Data Loading Error - Unable to process data due to invalid data type 
Expecting: array 
Received: `, typeof t, `
Data:     `, t);
  }
  _wipeElements() {
    this.dispatch("rows-wipe"), this.destroy(), this.adjustTableSize(), this.dispatch("rows-wiped");
  }
  destroy() {
    this.rows.forEach((t) => {
      t.wipe();
    }), this.rows = [], this.activeRows = [], this.activeRowsPipeline = [], this.activeRowsCount = 0, this.displayRows = [], this.displayRowsCount = 0;
  }
  deleteRow(t, e) {
    var a = this.rows.indexOf(t), n = this.activeRows.indexOf(t);
    n > -1 && this.activeRows.splice(n, 1), a > -1 && this.rows.splice(a, 1), this.setActiveRows(this.activeRows), this.displayRowIterator((i) => {
      var r = i.indexOf(t);
      r > -1 && i.splice(r, 1);
    }), e || this.reRenderInPosition(), this.regenerateRowPositions(), this.dispatchExternal("rowDeleted", t.getComponent()), this.displayRowsCount || this.tableEmpty(), this.subscribedExternal("dataChanged") && this.dispatchExternal("dataChanged", this.getData());
  }
  addRow(t, e, a, n) {
    var i = this.addRowActual(t, e, a, n);
    return i;
  }
  //add multiple rows
  addRows(t, e, a, n) {
    var i = [];
    return new Promise((r, l) => {
      e = this.findAddRowPos(e), Array.isArray(t) || (t = [t]), (typeof a > "u" && e || typeof a < "u" && !e) && t.reverse(), t.forEach((o, c) => {
        var d = this.addRow(o, e, a, !0);
        i.push(d), this.dispatch("row-added", d, o, e, a);
      }), this.refreshActiveData(n ? "displayPipeline" : !1, !1, !0), this.regenerateRowPositions(), this.displayRowsCount && this._clearPlaceholder(), r(i);
    });
  }
  findAddRowPos(t) {
    return typeof t > "u" && (t = this.table.options.addRowPos), t === "pos" && (t = !0), t === "bottom" && (t = !1), t;
  }
  addRowActual(t, e, a, n) {
    var i = t instanceof ss ? t : new ss(t || {}, this), r = this.findAddRowPos(e), l = -1, o, c;
    return a || (c = this.chain("row-adding-position", [i, r], null, { index: a, top: r }), a = c.index, r = c.top), typeof a < "u" && (a = this.findRow(a)), a = this.chain("row-adding-index", [i, a, r], null, a), a && (l = this.rows.indexOf(a)), a && l > -1 ? (o = this.activeRows.indexOf(a), this.displayRowIterator(function(d) {
      var p = d.indexOf(a);
      p > -1 && d.splice(r ? p : p + 1, 0, i);
    }), o > -1 && this.activeRows.splice(r ? o : o + 1, 0, i), this.rows.splice(r ? l : l + 1, 0, i)) : r ? (this.displayRowIterator(function(d) {
      d.unshift(i);
    }), this.activeRows.unshift(i), this.rows.unshift(i)) : (this.displayRowIterator(function(d) {
      d.push(i);
    }), this.activeRows.push(i), this.rows.push(i)), this.setActiveRows(this.activeRows), this.dispatchExternal("rowAdded", i.getComponent()), this.subscribedExternal("dataChanged") && this.dispatchExternal("dataChanged", this.table.rowManager.getData()), n || this.reRenderInPosition(), i;
  }
  moveRow(t, e, a) {
    this.dispatch("row-move", t, e, a), this.moveRowActual(t, e, a), this.regenerateRowPositions(), this.dispatch("row-moved", t, e, a), this.dispatchExternal("rowMoved", t.getComponent());
  }
  moveRowActual(t, e, a) {
    this.moveRowInArray(this.rows, t, e, a), this.moveRowInArray(this.activeRows, t, e, a), this.displayRowIterator((n) => {
      this.moveRowInArray(n, t, e, a);
    }), this.dispatch("row-moving", t, e, a);
  }
  moveRowInArray(t, e, a, n) {
    var i, r, l, o;
    if (e !== a && (i = t.indexOf(e), i > -1 && (t.splice(i, 1), r = t.indexOf(a), r > -1 ? n ? t.splice(r + 1, 0, e) : t.splice(r, 0, e) : t.splice(i, 0, e)), t === this.getDisplayRows())) {
      l = i < r ? i : r, o = r > i ? r : i + 1;
      for (let c = l; c <= o; c++)
        t[c] && this.styleRow(t[c], c);
    }
  }
  clearData() {
    this.setData([]);
  }
  getRowIndex(t) {
    return this.findRowIndex(t, this.rows);
  }
  getDisplayRowIndex(t) {
    var e = this.getDisplayRows().indexOf(t);
    return e > -1 ? e : !1;
  }
  nextDisplayRow(t, e) {
    var a = this.getDisplayRowIndex(t), n = !1;
    return a !== !1 && a < this.displayRowsCount - 1 && (n = this.getDisplayRows()[a + 1]), n && (!(n instanceof ss) || n.type != "row") ? this.nextDisplayRow(n, e) : n;
  }
  prevDisplayRow(t, e) {
    var a = this.getDisplayRowIndex(t), n = !1;
    return a && (n = this.getDisplayRows()[a - 1]), e && n && (!(n instanceof ss) || n.type != "row") ? this.prevDisplayRow(n, e) : n;
  }
  findRowIndex(t, e) {
    var a;
    return t = this.findRow(t), t && (a = e.indexOf(t), a > -1) ? a : !1;
  }
  getData(t, e) {
    var a = [], n = this.getRows(t);
    return n.forEach(function(i) {
      i.type == "row" && a.push(i.getData(e || "data"));
    }), a;
  }
  getComponents(t) {
    var e = [], a = this.getRows(t);
    return a.forEach(function(n) {
      e.push(n.getComponent());
    }), e;
  }
  getDataCount(t) {
    var e = this.getRows(t);
    return e.length;
  }
  scrollHorizontal(t) {
    this.scrollLeft = t, this.element.scrollLeft = t, this.dispatch("scroll-horizontal", t);
  }
  registerDataPipelineHandler(t, e) {
    typeof e < "u" ? (this.dataPipeline.push({ handler: t, priority: e }), this.dataPipeline.sort((a, n) => a.priority - n.priority)) : console.error("Data pipeline handlers must have a priority in order to be registered");
  }
  registerDisplayPipelineHandler(t, e) {
    typeof e < "u" ? (this.displayPipeline.push({ handler: t, priority: e }), this.displayPipeline.sort((a, n) => a.priority - n.priority)) : console.error("Display pipeline handlers must have a priority in order to be registered");
  }
  //set active data set
  refreshActiveData(t, e, a) {
    var n = this.table, i = "", r = 0, l = ["all", "dataPipeline", "display", "displayPipeline", "end"];
    if (!this.table.destroyed) {
      if (typeof t == "function")
        if (r = this.dataPipeline.findIndex((o) => o.handler === t), r > -1)
          i = "dataPipeline", e && (r == this.dataPipeline.length - 1 ? i = "display" : r++);
        else if (r = this.displayPipeline.findIndex((o) => o.handler === t), r > -1)
          i = "displayPipeline", e && (r == this.displayPipeline.length - 1 ? i = "end" : r++);
        else {
          console.error("Unable to refresh data, invalid handler provided", t);
          return;
        }
      else
        i = t || "all", r = 0;
      if (this.redrawBlock) {
        (!this.redrawBlockRestoreConfig || this.redrawBlockRestoreConfig && (this.redrawBlockRestoreConfig.stage === i && r < this.redrawBlockRestoreConfig.index || l.indexOf(i) < l.indexOf(this.redrawBlockRestoreConfig.stage))) && (this.redrawBlockRestoreConfig = {
          handler: t,
          skipStage: e,
          renderInPosition: a,
          stage: i,
          index: r
        });
        return;
      } else
        za.elVisible(this.element) ? a ? this.reRenderInPosition(this.refreshPipelines.bind(this, t, i, r, a)) : (this.refreshPipelines(t, i, r, a), t || this.table.columnManager.renderer.renderColumns(), this.renderTable(), n.options.layoutColumnsOnNewData && this.table.columnManager.redraw(!0)) : this.refreshPipelines(t, i, r, a), this.dispatch("data-refreshed");
    }
  }
  refreshPipelines(t, e, a, n) {
    switch (this.dispatch("data-refreshing"), (!t || !this.activeRowsPipeline[0]) && (this.activeRowsPipeline[0] = this.rows.slice(0)), e) {
      case "all":
      case "dataPipeline":
        for (let i = a; i < this.dataPipeline.length; i++) {
          let r = this.dataPipeline[i].handler(this.activeRowsPipeline[i].slice(0));
          this.activeRowsPipeline[i + 1] = r || this.activeRowsPipeline[i].slice(0);
        }
        this.setActiveRows(this.activeRowsPipeline[this.dataPipeline.length]);
      case "display":
        a = 0, this.resetDisplayRows();
      case "displayPipeline":
        for (let i = a; i < this.displayPipeline.length; i++) {
          let r = this.displayPipeline[i].handler((i ? this.getDisplayRows(i - 1) : this.activeRows).slice(0), n);
          this.setDisplayRows(r || this.getDisplayRows(i - 1).slice(0), i);
        }
      case "end":
        this.regenerateRowPositions();
    }
    this.getDisplayRows().length && this._clearPlaceholder();
  }
  //regenerate row positions
  regenerateRowPositions() {
    var t = this.getDisplayRows(), e = 1;
    t.forEach((a) => {
      a.type === "row" && (a.setPosition(e), e++);
    });
  }
  setActiveRows(t) {
    this.activeRows = this.activeRows = Object.assign([], t), this.activeRowsCount = this.activeRows.length;
  }
  //reset display rows array
  resetDisplayRows() {
    this.displayRows = [], this.displayRows.push(this.activeRows.slice(0)), this.displayRowsCount = this.displayRows[0].length;
  }
  //set display row pipeline data
  setDisplayRows(t, e) {
    this.displayRows[e] = t, e == this.displayRows.length - 1 && (this.displayRowsCount = this.displayRows[this.displayRows.length - 1].length);
  }
  getDisplayRows(t) {
    return typeof t > "u" ? this.displayRows.length ? this.displayRows[this.displayRows.length - 1] : [] : this.displayRows[t] || [];
  }
  getVisibleRows(t, e) {
    var a = Object.assign([], this.renderer.visibleRows(!e));
    return t && (a = this.chain("rows-visible", [e], a, a)), a;
  }
  //repeat action across display rows
  displayRowIterator(t) {
    this.activeRowsPipeline.forEach(t), this.displayRows.forEach(t), this.displayRowsCount = this.displayRows[this.displayRows.length - 1].length;
  }
  //return only actual rows (not group headers etc)
  getRows(t) {
    var e = [];
    switch (t) {
      case "active":
        e = this.activeRows;
        break;
      case "display":
        e = this.table.rowManager.getDisplayRows();
        break;
      case "visible":
        e = this.getVisibleRows(!1, !0);
        break;
      default:
        e = this.chain("rows-retrieve", t, null, this.rows) || this.rows;
    }
    return e;
  }
  ///////////////// Table Rendering /////////////////
  //trigger rerender of table in current position
  reRenderInPosition(t) {
    this.redrawBlock ? t ? t() : this.redrawBlockRenderInPosition = !0 : (this.dispatchExternal("renderStarted"), this.renderer.rerenderRows(t), this.fixedHeight || this.adjustTableSize(), this.scrollBarCheck(), this.dispatchExternal("renderComplete"));
  }
  scrollBarCheck() {
    var t = 0;
    this.element.scrollHeight > this.element.clientHeight && (t = this.element.offsetWidth - this.element.clientWidth), t !== this.scrollbarWidth && (this.scrollbarWidth = t, this.dispatch("scrollbar-vertical", t));
  }
  initializeRenderer() {
    var t, e = {
      virtual: d6,
      basic: c6
    };
    typeof this.table.options.renderVertical == "string" ? t = e[this.table.options.renderVertical] : t = this.table.options.renderVertical, t ? (this.renderMode = this.table.options.renderVertical, this.renderer = new t(this.table, this.element, this.tableElement), this.renderer.initialize(), (this.table.element.clientHeight || this.table.options.height) && !(this.table.options.minHeight && this.table.options.maxHeight) ? this.fixedHeight = !0 : this.fixedHeight = !1) : console.error("Unable to find matching renderer:", this.table.options.renderVertical);
  }
  getRenderMode() {
    return this.renderMode;
  }
  renderTable() {
    this.dispatchExternal("renderStarted"), this.element.scrollTop = 0, this._clearTable(), this.displayRowsCount ? (this.renderer.renderRows(), this.firstRender && (this.firstRender = !1, this.fixedHeight || this.adjustTableSize(), this.layoutRefresh(!0))) : this.renderEmptyScroll(), this.fixedHeight || this.adjustTableSize(), this.dispatch("table-layout"), this.displayRowsCount || this._showPlaceholder(), this.scrollBarCheck(), this.dispatchExternal("renderComplete");
  }
  //show scrollbars on empty table div
  renderEmptyScroll() {
    this.placeholder ? this.tableElement.style.display = "none" : this.tableElement.style.minWidth = this.table.columnManager.getWidth() + "px";
  }
  _clearTable() {
    this._clearPlaceholder(), this.scrollTop = 0, this.scrollLeft = 0, this.renderer.clearRows();
  }
  tableEmpty() {
    this.renderEmptyScroll(), this._showPlaceholder();
  }
  checkPlaceholder() {
    this.displayRowsCount ? this._clearPlaceholder() : this.tableEmpty();
  }
  _showPlaceholder() {
    this.placeholder && (this.placeholder && this.placeholder.parentNode && this.placeholder.parentNode.removeChild(this.placeholder), this.initializePlaceholder(), this.placeholder.setAttribute("tabulator-render-mode", this.renderMode), this.getElement().appendChild(this.placeholder), this._positionPlaceholder(), this.adjustTableSize());
  }
  _clearPlaceholder() {
    this.placeholder && this.placeholder.parentNode && this.placeholder.parentNode.removeChild(this.placeholder), this.tableElement.style.minWidth = "", this.tableElement.style.display = "";
  }
  _positionPlaceholder() {
    this.placeholder && this.placeholder.parentNode && (this.placeholder.style.width = this.table.columnManager.getWidth() + "px", this.placeholderContents.style.width = this.table.rowManager.element.clientWidth + "px", this.placeholderContents.style.marginLeft = this.scrollLeft + "px");
  }
  styleRow(t, e) {
    var a = t.getElement();
    e % 2 ? (a.classList.add("tabulator-row-even"), a.classList.remove("tabulator-row-odd")) : (a.classList.add("tabulator-row-odd"), a.classList.remove("tabulator-row-even"));
  }
  //normalize height of active rows
  normalizeHeight() {
    this.activeRows.forEach(function(t) {
      t.normalizeHeight();
    });
  }
  //adjust the height of the table holder to fit in the Tabulator element
  adjustTableSize() {
    let t = this.element.clientHeight, e, a = !1;
    if (this.renderer.verticalFillMode === "fill") {
      let n = Math.floor(this.table.columnManager.getElement().getBoundingClientRect().height + (this.table.footerManager && this.table.footerManager.active && !this.table.footerManager.external ? this.table.footerManager.getElement().getBoundingClientRect().height : 0));
      if (this.fixedHeight) {
        e = isNaN(this.table.options.minHeight) ? this.table.options.minHeight : this.table.options.minHeight + "px";
        const i = "calc(100% - " + n + "px)";
        this.element.style.minHeight = e || "calc(100% - " + n + "px)", this.element.style.height = i, this.element.style.maxHeight = i;
      } else
        this.element.style.height = "", this.element.style.height = this.table.element.clientHeight - n + "px", this.element.scrollTop = this.scrollTop;
      this.renderer.resize(), !this.fixedHeight && t != this.element.clientHeight && (a = !0, this.subscribed("table-resize") ? this.dispatch("table-resize") : this.redraw()), this.scrollBarCheck();
    }
    return this._positionPlaceholder(), a;
  }
  //reinitialize all rows
  reinitialize() {
    this.rows.forEach(function(t) {
      t.reinitialize(!0);
    });
  }
  //prevent table from being redrawn
  blockRedraw() {
    this.redrawBlock = !0, this.redrawBlockRestoreConfig = !1;
  }
  //restore table redrawing
  restoreRedraw() {
    this.redrawBlock = !1, this.redrawBlockRestoreConfig ? (this.refreshActiveData(this.redrawBlockRestoreConfig.handler, this.redrawBlockRestoreConfig.skipStage, this.redrawBlockRestoreConfig.renderInPosition), this.redrawBlockRestoreConfig = !1) : this.redrawBlockRenderInPosition && this.reRenderInPosition(), this.redrawBlockRenderInPosition = !1;
  }
  //redraw table
  redraw(t) {
    this.adjustTableSize(), this.table.tableWidth = this.table.element.clientWidth, t ? this.renderTable() : (this.reRenderInPosition(), this.scrollHorizontal(this.scrollLeft));
  }
  resetScroll() {
    if (this.element.scrollLeft = 0, this.element.scrollTop = 0, this.table.browser === "ie") {
      var t = document.createEvent("Event");
      t.initEvent("scroll", !1, !0), this.element.dispatchEvent(t);
    } else
      this.element.dispatchEvent(new Event("scroll"));
  }
}
class p6 extends ds {
  constructor(t) {
    super(t), this.active = !1, this.element = this.createElement(), this.containerElement = this.createContainerElement(), this.external = !1;
  }
  initialize() {
    this.initializeElement();
  }
  createElement() {
    var t = document.createElement("div");
    return t.classList.add("tabulator-footer"), t;
  }
  createContainerElement() {
    var t = document.createElement("div");
    return t.classList.add("tabulator-footer-contents"), this.element.appendChild(t), t;
  }
  initializeElement() {
    if (this.table.options.footerElement)
      switch (typeof this.table.options.footerElement) {
        case "string":
          this.table.options.footerElement[0] === "<" ? this.containerElement.innerHTML = this.table.options.footerElement : (this.external = !0, this.containerElement = document.querySelector(this.table.options.footerElement));
          break;
        default:
          this.element = this.table.options.footerElement;
          break;
      }
  }
  getElement() {
    return this.element;
  }
  append(t) {
    this.activate(), this.containerElement.appendChild(t), this.table.rowManager.adjustTableSize();
  }
  prepend(t) {
    this.activate(), this.element.insertBefore(t, this.element.firstChild), this.table.rowManager.adjustTableSize();
  }
  remove(t) {
    t.parentNode.removeChild(t), this.deactivate();
  }
  deactivate(t) {
    (!this.element.firstChild || t) && (this.external || this.element.parentNode.removeChild(this.element), this.active = !1);
  }
  activate() {
    this.active || (this.active = !0, this.external || (this.table.element.appendChild(this.getElement()), this.table.element.style.display = ""));
  }
  redraw() {
    this.dispatch("footer-redraw");
  }
}
class h6 extends ds {
  constructor(t) {
    super(t), this.el = null, this.abortClasses = ["tabulator-headers", "tabulator-table"], this.previousTargets = {}, this.listeners = [
      "click",
      "dblclick",
      "contextmenu",
      "mouseenter",
      "mouseleave",
      "mouseover",
      "mouseout",
      "mousemove",
      "mouseup",
      "mousedown",
      "touchstart",
      "touchend"
    ], this.componentMap = {
      "tabulator-cell": "cell",
      "tabulator-row": "row",
      "tabulator-group": "group",
      "tabulator-col": "column"
    }, this.pseudoTrackers = {
      row: {
        subscriber: null,
        target: null
      },
      cell: {
        subscriber: null,
        target: null
      },
      group: {
        subscriber: null,
        target: null
      },
      column: {
        subscriber: null,
        target: null
      }
    }, this.pseudoTracking = !1;
  }
  initialize() {
    this.el = this.table.element, this.buildListenerMap(), this.bindSubscriptionWatchers();
  }
  buildListenerMap() {
    var t = {};
    this.listeners.forEach((e) => {
      t[e] = {
        handler: null,
        components: []
      };
    }), this.listeners = t;
  }
  bindPseudoEvents() {
    Object.keys(this.pseudoTrackers).forEach((t) => {
      this.pseudoTrackers[t].subscriber = this.pseudoMouseEnter.bind(this, t), this.subscribe(t + "-mouseover", this.pseudoTrackers[t].subscriber);
    }), this.pseudoTracking = !0;
  }
  pseudoMouseEnter(t, e, a) {
    this.pseudoTrackers[t].target !== a && (this.pseudoTrackers[t].target && this.dispatch(t + "-mouseleave", e, this.pseudoTrackers[t].target), this.pseudoMouseLeave(t, e), this.pseudoTrackers[t].target = a, this.dispatch(t + "-mouseenter", e, a));
  }
  pseudoMouseLeave(t, e) {
    var a = Object.keys(this.pseudoTrackers), n = {
      row: ["cell"],
      cell: ["row"]
    };
    a = a.filter((i) => {
      var r = n[t];
      return i !== t && (!r || r && !r.includes(i));
    }), a.forEach((i) => {
      var r = this.pseudoTrackers[i].target;
      this.pseudoTrackers[i].target && (this.dispatch(i + "-mouseleave", e, r), this.pseudoTrackers[i].target = null);
    });
  }
  bindSubscriptionWatchers() {
    var t = Object.keys(this.listeners), e = Object.values(this.componentMap);
    for (let a of e)
      for (let n of t) {
        let i = a + "-" + n;
        this.subscriptionChange(i, this.subscriptionChanged.bind(this, a, n));
      }
    this.subscribe("table-destroy", this.clearWatchers.bind(this));
  }
  subscriptionChanged(t, e, a) {
    var n = this.listeners[e].components, i = n.indexOf(t), r = !1;
    a ? i === -1 && (n.push(t), r = !0) : this.subscribed(t + "-" + e) || i > -1 && (n.splice(i, 1), r = !0), (e === "mouseenter" || e === "mouseleave") && !this.pseudoTracking && this.bindPseudoEvents(), r && this.updateEventListeners();
  }
  updateEventListeners() {
    for (let t in this.listeners) {
      let e = this.listeners[t];
      e.components.length ? e.handler || (e.handler = this.track.bind(this, t), this.el.addEventListener(t, e.handler)) : e.handler && (this.el.removeEventListener(t, e.handler), e.handler = null);
    }
  }
  track(t, e) {
    var a = e.composedPath && e.composedPath() || e.path, n = this.findTargets(a);
    n = this.bindComponents(t, n), this.triggerEvents(t, e, n), this.pseudoTracking && (t == "mouseover" || t == "mouseleave") && !Object.keys(n).length && this.pseudoMouseLeave("none", e);
  }
  findTargets(t) {
    var e = {};
    let a = Object.keys(this.componentMap);
    for (let n of t) {
      let i = n.classList ? [...n.classList] : [];
      if (i.filter((o) => this.abortClasses.includes(o)).length)
        break;
      let l = i.filter((o) => a.includes(o));
      for (let o of l)
        e[this.componentMap[o]] || (e[this.componentMap[o]] = n);
    }
    return e.group && e.group === e.row && delete e.row, e;
  }
  bindComponents(t, e) {
    var a = Object.keys(e).reverse(), n = this.listeners[t], i = {}, r = {};
    for (let l of a) {
      let o, c = e[l], d = this.previousTargets[l];
      if (d && d.target === c)
        o = d.component;
      else
        switch (l) {
          case "row":
          case "group":
            (n.components.includes("row") || n.components.includes("cell") || n.components.includes("group")) && (o = this.table.rowManager.getVisibleRows(!0).find((h) => h.getElement() === c), e.row && e.row.parentNode && e.row.parentNode.closest(".tabulator-row") && (e[l] = !1));
            break;
          case "column":
            n.components.includes("column") && (o = this.table.columnManager.findColumn(c));
            break;
          case "cell":
            n.components.includes("cell") && (i.row instanceof ss ? o = i.row.findCell(c) : e.row && console.warn("Event Target Lookup Error - The row this cell is attached to cannot be found, has the table been reinitialized without being destroyed first?"));
            break;
        }
      o && (i[l] = o, r[l] = {
        target: c,
        component: o
      });
    }
    return this.previousTargets = r, i;
  }
  triggerEvents(t, e, a) {
    var n = this.listeners[t];
    for (let i in a)
      a[i] && n.components.includes(i) && this.dispatch(i + "-" + t, e, a[i]);
  }
  clearWatchers() {
    for (let t in this.listeners) {
      let e = this.listeners[t];
      e.handler && (this.el.removeEventListener(t, e.handler), e.handler = null);
    }
  }
}
class m6 {
  constructor(t) {
    this.table = t, this.bindings = {};
  }
  bind(t, e, a) {
    this.bindings[t] || (this.bindings[t] = {}), this.bindings[t][e] ? console.warn("Unable to bind component handler, a matching function name is already bound", t, e, a) : this.bindings[t][e] = a;
  }
  handle(t, e, a) {
    if (this.bindings[t] && this.bindings[t][a] && typeof this.bindings[t][a].bind == "function")
      return this.bindings[t][a].bind(null, e);
    a !== "then" && typeof a == "string" && !a.startsWith("_") && this.table.options.debugInvalidComponentFuncs && console.error("The " + t + " component does not have a " + a + " function, have you checked that you have the correct Tabulator module installed?");
  }
}
class g6 extends ds {
  constructor(t) {
    super(t), this.requestOrder = 0, this.loading = !1;
  }
  initialize() {
  }
  load(t, e, a, n, i, r) {
    var l = ++this.requestOrder;
    if (this.table.destroyed)
      return Promise.resolve();
    if (this.dispatchExternal("dataLoading", t), t && (t.indexOf("{") == 0 || t.indexOf("[") == 0) && (t = JSON.parse(t)), this.confirm("data-loading", [t, e, a, i])) {
      this.loading = !0, i || this.alertLoader(), e = this.chain("data-params", [t, a, i], e || {}, e || {}), e = this.mapParams(e, this.table.options.dataSendParams);
      var o = this.chain("data-load", [t, e, a, i], !1, Promise.resolve([]));
      return o.then((c) => {
        if (this.table.destroyed)
          console.warn("Data Load Response Blocked - Table has been destroyed");
        else {
          !Array.isArray(c) && typeof c == "object" && (c = this.mapParams(c, this.objectInvert(this.table.options.dataReceiveParams)));
          var d = this.chain("data-loaded", c, null, c);
          l == this.requestOrder ? (this.clearAlert(), d !== !1 && (this.dispatchExternal("dataLoaded", d), this.table.rowManager.setData(d, n, typeof r > "u" ? !n : r))) : console.warn("Data Load Response Blocked - An active data load request was blocked by an attempt to change table data while the request was being made");
        }
      }).catch((c) => {
        console.error("Data Load Error: ", c), this.dispatchExternal("dataLoadError", c), i || this.alertError(), setTimeout(() => {
          this.clearAlert();
        }, this.table.options.dataLoaderErrorTimeout);
      }).finally(() => {
        this.loading = !1;
      });
    } else
      return this.dispatchExternal("dataLoaded", t), t || (t = []), this.table.rowManager.setData(t, n, typeof r > "u" ? !n : r), Promise.resolve();
  }
  mapParams(t, e) {
    var a = {};
    for (let n in t)
      a[e.hasOwnProperty(n) ? e[n] : n] = t[n];
    return a;
  }
  objectInvert(t) {
    var e = {};
    for (let a in t)
      e[t[a]] = a;
    return e;
  }
  blockActiveLoad() {
    this.requestOrder++;
  }
  alertLoader() {
    var t = typeof this.table.options.dataLoader == "function" ? this.table.options.dataLoader() : this.table.options.dataLoader;
    t && this.table.alertManager.alert(this.table.options.dataLoaderLoading || this.langText("data|loading"));
  }
  alertError() {
    this.table.alertManager.alert(this.table.options.dataLoaderError || this.langText("data|error"), "error");
  }
  clearAlert() {
    this.table.alertManager.clear();
  }
}
class y6 {
  constructor(t, e, a) {
    this.table = t, this.events = {}, this.optionsList = e || {}, this.subscriptionNotifiers = {}, this.dispatch = a ? this._debugDispatch.bind(this) : this._dispatch.bind(this), this.debug = a;
  }
  subscriptionChange(t, e) {
    this.subscriptionNotifiers[t] || (this.subscriptionNotifiers[t] = []), this.subscriptionNotifiers[t].push(e), this.subscribed(t) && this._notifySubscriptionChange(t, !0);
  }
  subscribe(t, e) {
    this.events[t] || (this.events[t] = []), this.events[t].push(e), this._notifySubscriptionChange(t, !0);
  }
  unsubscribe(t, e) {
    var a;
    if (this.events[t])
      if (e)
        if (a = this.events[t].findIndex((n) => n === e), a > -1)
          this.events[t].splice(a, 1);
        else {
          console.warn("Cannot remove event, no matching event found:", t, e);
          return;
        }
      else
        delete this.events[t];
    else {
      console.warn("Cannot remove event, no events set on:", t);
      return;
    }
    this._notifySubscriptionChange(t, !1);
  }
  subscribed(t) {
    return this.events[t] && this.events[t].length;
  }
  _notifySubscriptionChange(t, e) {
    var a = this.subscriptionNotifiers[t];
    a && a.forEach((n) => {
      n(e);
    });
  }
  _dispatch() {
    var t = Array.from(arguments), e = t.shift(), a;
    return this.events[e] && this.events[e].forEach((n, i) => {
      let r = n.apply(this.table, t);
      i || (a = r);
    }), a;
  }
  _debugDispatch() {
    var t = Array.from(arguments), e = t[0];
    return t[0] = "ExternalEvent:" + t[0], (this.debug === !0 || this.debug.includes(e)) && console.log(...t), this._dispatch(...arguments);
  }
}
class f6 {
  constructor(t) {
    this.events = {}, this.subscriptionNotifiers = {}, this.dispatch = t ? this._debugDispatch.bind(this) : this._dispatch.bind(this), this.chain = t ? this._debugChain.bind(this) : this._chain.bind(this), this.confirm = t ? this._debugConfirm.bind(this) : this._confirm.bind(this), this.debug = t;
  }
  subscriptionChange(t, e) {
    this.subscriptionNotifiers[t] || (this.subscriptionNotifiers[t] = []), this.subscriptionNotifiers[t].push(e), this.subscribed(t) && this._notifySubscriptionChange(t, !0);
  }
  subscribe(t, e, a = 1e4) {
    this.events[t] || (this.events[t] = []), this.events[t].push({ callback: e, priority: a }), this.events[t].sort((n, i) => n.priority - i.priority), this._notifySubscriptionChange(t, !0);
  }
  unsubscribe(t, e) {
    var a;
    if (this.events[t]) {
      if (e)
        if (a = this.events[t].findIndex((n) => n.callback === e), a > -1)
          this.events[t].splice(a, 1);
        else {
          console.warn("Cannot remove event, no matching event found:", t, e);
          return;
        }
    } else {
      console.warn("Cannot remove event, no events set on:", t);
      return;
    }
    this._notifySubscriptionChange(t, !1);
  }
  subscribed(t) {
    return this.events[t] && this.events[t].length;
  }
  _chain(t, e, a, n) {
    var i = a;
    return Array.isArray(e) || (e = [e]), this.subscribed(t) ? (this.events[t].forEach((r, l) => {
      i = r.callback.apply(this, e.concat([i]));
    }), i) : typeof n == "function" ? n() : n;
  }
  _confirm(t, e) {
    var a = !1;
    return Array.isArray(e) || (e = [e]), this.subscribed(t) && this.events[t].forEach((n, i) => {
      n.callback.apply(this, e) && (a = !0);
    }), a;
  }
  _notifySubscriptionChange(t, e) {
    var a = this.subscriptionNotifiers[t];
    a && a.forEach((n) => {
      n(e);
    });
  }
  _dispatch() {
    var t = Array.from(arguments), e = t.shift();
    this.events[e] && this.events[e].forEach((a) => {
      a.callback.apply(this, t);
    });
  }
  _debugDispatch() {
    var t = Array.from(arguments), e = t[0];
    return t[0] = "InternalEvent:" + e, (this.debug === !0 || this.debug.includes(e)) && console.log(...t), this._dispatch(...arguments);
  }
  _debugChain() {
    var t = Array.from(arguments), e = t[0];
    return t[0] = "InternalEvent:" + e, (this.debug === !0 || this.debug.includes(e)) && console.log(...t), this._chain(...arguments);
  }
  _debugConfirm() {
    var t = Array.from(arguments), e = t[0];
    return t[0] = "InternalEvent:" + e, (this.debug === !0 || this.debug.includes(e)) && console.log(...t), this._confirm(...arguments);
  }
}
class b6 extends ds {
  constructor(t) {
    super(t);
  }
  _warnUser() {
    this.options("debugDeprecation") && console.warn(...arguments);
  }
  check(t, e, a) {
    var n = "";
    return typeof this.options(t) < "u" ? (n = "Deprecated Setup Option - Use of the %c" + t + "%c option is now deprecated", e ? (n = n + ", Please use the %c" + e + "%c option instead", this._warnUser(n, "font-weight: bold;", "font-weight: normal;", "font-weight: bold;", "font-weight: normal;"), a && (this.table.options[e] = this.table.options[t])) : this._warnUser(n, "font-weight: bold;", "font-weight: normal;"), !1) : !0;
  }
  checkMsg(t, e) {
    return typeof this.options(t) < "u" ? (this._warnUser("%cDeprecated Setup Option - Use of the %c" + t + " %c option is now deprecated, " + e, "font-weight: normal;", "font-weight: bold;", "font-weight: normal;"), !1) : !0;
  }
  msg(t) {
    this._warnUser(t);
  }
}
class Es {
  static register(t) {
    Es.tables.push(t);
  }
  static deregister(t) {
    var e = Es.tables.indexOf(t);
    e > -1 && Es.tables.splice(e, 1);
  }
  static lookupTable(t, e) {
    var a = [], n, i;
    if (typeof t == "string") {
      if (n = document.querySelectorAll(t), n.length)
        for (var r = 0; r < n.length; r++)
          i = Es.matchElement(n[r]), i && a.push(i);
    } else
      typeof HTMLElement < "u" && t instanceof HTMLElement || t instanceof eo ? (i = Es.matchElement(t), i && a.push(i)) : Array.isArray(t) ? t.forEach(function(l) {
        a = a.concat(Es.lookupTable(l));
      }) : e || console.warn("Table Connection Error - Invalid Selector", t);
    return a;
  }
  static matchElement(t) {
    return Es.tables.find(function(e) {
      return t instanceof eo ? e === t : e.element === t;
    });
  }
}
Es.tables = [];
function v6(s, t) {
  t && this.table.columnManager.renderer.reinitializeColumnWidths(s), this.table.options.responsiveLayout && this.table.modExists("responsiveLayout", !0) && this.table.modules.responsiveLayout.update();
}
function GI(s, t) {
  s.forEach(function(e) {
    e.reinitializeWidth();
  }), this.table.options.responsiveLayout && this.table.modExists("responsiveLayout", !0) && this.table.modules.responsiveLayout.update();
}
function x6(s, t) {
  var e = 0, a = this.table.rowManager.element.clientWidth, n = 0, i = !1;
  s.forEach((r, l) => {
    r.widthFixed || r.reinitializeWidth(), (this.table.options.responsiveLayout ? r.modules.responsive.visible : r.visible) && (i = r), r.visible && (e += r.getWidth());
  }), i ? (n = a - e + i.getWidth(), this.table.options.responsiveLayout && this.table.modExists("responsiveLayout", !0) && (i.setWidth(0), this.table.modules.responsiveLayout.update()), n > 0 ? i.setWidth(n) : i.reinitializeWidth()) : this.table.options.responsiveLayout && this.table.modExists("responsiveLayout", !0) && this.table.modules.responsiveLayout.update();
}
function w6(s, t) {
  var e = this.table.rowManager.element.getBoundingClientRect().width, a = 0, n = 0, i = 0, r = 0, l = [], o = [], c = 0, d = 0, p = 0;
  function h(x) {
    var b;
    return typeof x == "string" ? x.indexOf("%") > -1 ? b = e / 100 * parseInt(x) : b = parseInt(x) : b = x, b;
  }
  function g(x, b, A, T) {
    var R = [], C = 0, v = 0, P = 0, O = i, N = 0, H = 0, F = [];
    function B(it) {
      return A * (it.column.definition.widthGrow || 1);
    }
    function Q(it) {
      return h(it.width) - A * (it.column.definition.widthShrink || 0);
    }
    return x.forEach(function(it, et) {
      var rt = T ? Q(it) : B(it);
      it.column.minWidth >= rt ? R.push(it) : it.column.maxWidth && it.column.maxWidth < rt ? (it.width = it.column.maxWidth, b -= it.column.maxWidth, O -= T ? it.column.definition.widthShrink || 1 : it.column.definition.widthGrow || 1, O && (A = Math.floor(b / O))) : (F.push(it), H += T ? it.column.definition.widthShrink || 1 : it.column.definition.widthGrow || 1);
    }), R.length ? (R.forEach(function(it) {
      C += T ? it.width - it.column.minWidth : it.column.minWidth, it.width = it.column.minWidth;
    }), v = b - C, P = H ? Math.floor(v / H) : v, N = g(F, v, P, T)) : (N = H ? b - Math.floor(b / H) * H : b, F.forEach(function(it) {
      it.width = T ? Q(it) : B(it);
    })), N;
  }
  this.table.options.responsiveLayout && this.table.modExists("responsiveLayout", !0) && this.table.modules.responsiveLayout.update(), this.table.rowManager.element.scrollHeight > this.table.rowManager.element.clientHeight && (e -= this.table.rowManager.element.offsetWidth - this.table.rowManager.element.clientWidth), s.forEach(function(x) {
    var b, A, T;
    x.visible && (b = x.definition.width, A = parseInt(x.minWidth), b ? (T = h(b), a += T > A ? T : A, x.definition.widthShrink && (o.push({
      column: x,
      width: T > A ? T : A
    }), c += x.definition.widthShrink)) : (l.push({
      column: x,
      width: 0
    }), i += x.definition.widthGrow || 1));
  }), n = e - a, r = Math.floor(n / i), p = g(l, n, r, !1), l.length && p > 0 && (l[l.length - 1].width += p), l.forEach(function(x) {
    n -= x.width;
  }), d = Math.abs(p) + n, d > 0 && c && (p = g(o, d, Math.floor(d / c), !0)), p && o.length && (o[o.length - 1].width -= p), l.forEach(function(x) {
    x.column.setWidth(x.width);
  }), o.forEach(function(x) {
    x.column.setWidth(x.width);
  });
}
var A6 = {
  fitData: v6,
  fitDataFill: GI,
  fitDataTable: GI,
  fitDataStretch: x6,
  fitColumns: w6
};
class Rc extends Ze {
  constructor(t) {
    super(t, "layout"), this.mode = null, this.registerTableOption("layout", "fitData"), this.registerTableOption("layoutColumnsOnNewData", !1), this.registerColumnOption("widthGrow"), this.registerColumnOption("widthShrink");
  }
  //initialize layout system
  initialize() {
    var t = this.table.options.layout;
    Rc.modes[t] ? this.mode = t : (console.warn("Layout Error - invalid mode set, defaulting to 'fitData' : " + t), this.mode = "fitData"), this.table.element.setAttribute("tabulator-layout", this.mode), this.subscribe("column-init", this.initializeColumn.bind(this));
  }
  initializeColumn(t) {
    t.definition.widthGrow && (t.definition.widthGrow = Number(t.definition.widthGrow)), t.definition.widthShrink && (t.definition.widthShrink = Number(t.definition.widthShrink));
  }
  getMode() {
    return this.mode;
  }
  //trigger table layout
  layout(t) {
    this.dispatch("layout-refreshing"), Rc.modes[this.mode].call(this, this.table.columnManager.columnsByIndex, t), this.dispatch("layout-refreshed");
  }
}
Rc.moduleName = "layout";
Rc.modes = A6;
var C6 = {
  default: {
    //hold default locale text
    groups: {
      item: "item",
      items: "items"
    },
    columns: {},
    data: {
      loading: "Loading",
      error: "Error"
    },
    pagination: {
      page_size: "Page Size",
      page_title: "Show Page",
      first: "First",
      first_title: "First Page",
      last: "Last",
      last_title: "Last Page",
      prev: "Prev",
      prev_title: "Prev Page",
      next: "Next",
      next_title: "Next Page",
      all: "All",
      counter: {
        showing: "Showing",
        of: "of",
        rows: "rows",
        pages: "pages"
      }
    },
    headerFilters: {
      default: "filter column...",
      columns: {}
    }
  }
};
class ip extends Ze {
  constructor(t) {
    super(t), this.locale = "default", this.lang = !1, this.bindings = {}, this.langList = {}, this.registerTableOption("locale", !1), this.registerTableOption("langs", {});
  }
  initialize() {
    this.langList = za.deepClone(ip.langs), this.table.options.columnDefaults.headerFilterPlaceholder !== !1 && this.setHeaderFilterPlaceholder(this.table.options.columnDefaults.headerFilterPlaceholder);
    for (let t in this.table.options.langs)
      this.installLang(t, this.table.options.langs[t]);
    this.setLocale(this.table.options.locale), this.registerTableFunction("setLocale", this.setLocale.bind(this)), this.registerTableFunction("getLocale", this.getLocale.bind(this)), this.registerTableFunction("getLang", this.getLang.bind(this));
  }
  //set header placeholder
  setHeaderFilterPlaceholder(t) {
    this.langList.default.headerFilters.default = t;
  }
  //setup a lang description object
  installLang(t, e) {
    this.langList[t] ? this._setLangProp(this.langList[t], e) : this.langList[t] = e;
  }
  _setLangProp(t, e) {
    for (let a in e)
      t[a] && typeof t[a] == "object" ? this._setLangProp(t[a], e[a]) : t[a] = e[a];
  }
  //set current locale
  setLocale(t) {
    t = t || "default";
    function e(a, n) {
      for (var i in a)
        typeof a[i] == "object" ? (n[i] || (n[i] = {}), e(a[i], n[i])) : n[i] = a[i];
    }
    if (t === !0 && navigator.language && (t = navigator.language.toLowerCase()), t && !this.langList[t]) {
      let a = t.split("-")[0];
      this.langList[a] ? (console.warn("Localization Error - Exact matching locale not found, using closest match: ", t, a), t = a) : (console.warn("Localization Error - Matching locale not found, using default: ", t), t = "default");
    }
    this.locale = t, this.lang = za.deepClone(this.langList.default || {}), t != "default" && e(this.langList[t], this.lang), this.dispatchExternal("localized", this.locale, this.lang), this._executeBindings();
  }
  //get current locale
  getLocale(t) {
    return this.locale;
  }
  //get lang object for given local or current if none provided
  getLang(t) {
    return t ? this.langList[t] : this.lang;
  }
  //get text for current locale
  getText(t, e) {
    var a = e ? t + "|" + e : t, n = a.split("|"), i = this._getLangElement(n, this.locale);
    return i || "";
  }
  //traverse langs object and find localized copy
  _getLangElement(t, e) {
    var a = this.lang;
    return t.forEach(function(n) {
      var i;
      a && (i = a[n], typeof i < "u" ? a = i : a = !1);
    }), a;
  }
  //set update binding
  bind(t, e) {
    this.bindings[t] || (this.bindings[t] = []), this.bindings[t].push(e), e(this.getText(t), this.lang);
  }
  //iterate through bindings and trigger updates
  _executeBindings() {
    for (let t in this.bindings)
      this.bindings[t].forEach((e) => {
        e(this.getText(t), this.lang);
      });
  }
}
ip.moduleName = "localize";
ip.langs = C6;
class cR extends Ze {
  constructor(t) {
    super(t);
  }
  initialize() {
    this.registerTableFunction("tableComms", this.receive.bind(this));
  }
  getConnections(t) {
    var e = [], a;
    return a = Es.lookupTable(t), a.forEach((n) => {
      this.table !== n && e.push(n);
    }), e;
  }
  send(t, e, a, n) {
    var i = this.getConnections(t);
    i.forEach((r) => {
      r.tableComms(this.table.element, e, a, n);
    }), !i.length && t && console.warn("Table Connection Error - No tables matching selector found", t);
  }
  receive(t, e, a, n) {
    if (this.table.modExists(e))
      return this.table.modules[e].commsReceived(t, a, n);
    console.warn("Inter-table Comms Error - no such module:", e);
  }
}
cR.moduleName = "comms";
var $6 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  LayoutModule: Rc,
  LocalizeModule: ip,
  CommsModule: cR
});
class dR {
  constructor(t, e) {
    this.bindStaticFunctionality(t), this.bindModules(t, $6, !0), e && this.bindModules(t, e);
  }
  bindStaticFunctionality(t) {
    t.moduleBindings = {}, t.extendModule = function(e, a, n) {
      if (t.moduleBindings[e]) {
        var i = t.moduleBindings[e][a];
        if (i)
          if (typeof n == "object")
            for (let r in n)
              i[r] = n[r];
          else
            console.warn("Module Error - Invalid value type, it must be an object");
        else
          console.warn("Module Error - property does not exist:", a);
      } else
        console.warn("Module Error - module does not exist:", e);
    }, t.registerModule = function(e) {
      Array.isArray(e) || (e = [e]), e.forEach((a) => {
        t.registerModuleBinding(a);
      });
    }, t.registerModuleBinding = function(e) {
      t.moduleBindings[e.moduleName] = e;
    }, t.findTable = function(e) {
      var a = Es.lookupTable(e, !0);
      return Array.isArray(a) && !a.length ? !1 : a;
    }, t.prototype.bindModules = function() {
      var e = [], a = [], n = [];
      this.modules = {};
      for (var i in t.moduleBindings) {
        let r = t.moduleBindings[i], l = new r(this);
        this.modules[i] = l, r.prototype.moduleCore ? this.modulesCore.push(l) : r.moduleInitOrder ? r.moduleInitOrder < 0 ? e.push(l) : a.push(l) : n.push(l);
      }
      e.sort((r, l) => r.moduleInitOrder > l.moduleInitOrder ? 1 : -1), a.sort((r, l) => r.moduleInitOrder > l.moduleInitOrder ? 1 : -1), this.modulesRegular = e.concat(n.concat(a));
    };
  }
  bindModules(t, e, a) {
    var n = Object.values(e);
    a && n.forEach((i) => {
      i.prototype.moduleCore = !0;
    }), t.registerModule(n);
  }
}
let S6 = class extends ds {
  constructor(t) {
    super(t), this.element = this._createAlertElement(), this.msgElement = this._createMsgElement(), this.type = null, this.element.appendChild(this.msgElement);
  }
  _createAlertElement() {
    var t = document.createElement("div");
    return t.classList.add("tabulator-alert"), t;
  }
  _createMsgElement() {
    var t = document.createElement("div");
    return t.classList.add("tabulator-alert-msg"), t.setAttribute("role", "alert"), t;
  }
  _typeClass() {
    return "tabulator-alert-state-" + this.type;
  }
  alert(t, e = "msg") {
    if (t) {
      for (this.clear(), this.dispatch("alert-show", e), this.type = e; this.msgElement.firstChild; )
        this.msgElement.removeChild(this.msgElement.firstChild);
      this.msgElement.classList.add(this._typeClass()), typeof t == "function" && (t = t()), t instanceof HTMLElement ? this.msgElement.appendChild(t) : this.msgElement.innerHTML = t, this.table.element.appendChild(this.element);
    }
  }
  clear() {
    this.dispatch("alert-hide", this.type), this.element.parentNode && this.element.parentNode.removeChild(this.element), this.msgElement.classList.remove(this._typeClass());
  }
};
class eo {
  constructor(t, e) {
    this.options = {}, this.columnManager = null, this.rowManager = null, this.footerManager = null, this.alertManager = null, this.vdomHoz = null, this.externalEvents = null, this.eventBus = null, this.interactionMonitor = !1, this.browser = "", this.browserSlow = !1, this.browserMobile = !1, this.rtl = !1, this.originalElement = null, this.componentFunctionBinder = new m6(this), this.dataLoader = !1, this.modules = {}, this.modulesCore = [], this.modulesRegular = [], this.deprecationAdvisor = new b6(this), this.optionsList = new oR(this, "table constructor"), this.initialized = !1, this.destroyed = !1, this.initializeElement(t) && (this.initializeCoreSystems(e), setTimeout(() => {
      this._create();
    })), Es.register(this);
  }
  initializeElement(t) {
    return typeof HTMLElement < "u" && t instanceof HTMLElement ? (this.element = t, !0) : typeof t == "string" ? (this.element = document.querySelector(t), this.element ? !0 : (console.error("Tabulator Creation Error - no element found matching selector: ", t), !1)) : (console.error("Tabulator Creation Error - Invalid element provided:", t), !1);
  }
  initializeCoreSystems(t) {
    this.columnManager = new o6(this), this.rowManager = new u6(this), this.footerManager = new p6(this), this.dataLoader = new g6(this), this.alertManager = new S6(this), this.bindModules(), this.options = this.optionsList.generate(eo.defaultOptions, t), this._clearObjectPointers(), this._mapDeprecatedFunctionality(), this.externalEvents = new y6(this, this.options, this.options.debugEventsExternal), this.eventBus = new f6(this.options.debugEventsInternal), this.interactionMonitor = new h6(this), this.dataLoader.initialize(), this.footerManager.initialize();
  }
  //convert deprecated functionality to new functions
  _mapDeprecatedFunctionality() {
  }
  _clearSelection() {
    this.element.classList.add("tabulator-block-select"), window.getSelection ? window.getSelection().empty ? window.getSelection().empty() : window.getSelection().removeAllRanges && window.getSelection().removeAllRanges() : document.selection && document.selection.empty(), this.element.classList.remove("tabulator-block-select");
  }
  //create table
  _create() {
    this.externalEvents.dispatch("tableBuilding"), this.eventBus.dispatch("table-building"), this._rtlCheck(), this._buildElement(), this._initializeTable(), this._loadInitialData(), this.initialized = !0, this.externalEvents.dispatch("tableBuilt");
  }
  _rtlCheck() {
    var t = window.getComputedStyle(this.element);
    switch (this.options.textDirection) {
      case "auto":
        if (t.direction !== "rtl")
          break;
      case "rtl":
        this.element.classList.add("tabulator-rtl"), this.rtl = !0;
        break;
      case "ltr":
        this.element.classList.add("tabulator-ltr");
      default:
        this.rtl = !1;
    }
  }
  //clear pointers to objects in default config object
  _clearObjectPointers() {
    this.options.columns = this.options.columns.slice(0), Array.isArray(this.options.data) && !this.options.reactiveData && (this.options.data = this.options.data.slice(0));
  }
  //build tabulator element
  _buildElement() {
    var t = this.element, e = this.options, a;
    if (t.tagName === "TABLE") {
      this.originalElement = this.element, a = document.createElement("div");
      var n = t.attributes;
      for (var i in n)
        typeof n[i] == "object" && a.setAttribute(n[i].name, n[i].value);
      t.parentNode.replaceChild(a, t), this.element = t = a;
    }
    for (t.classList.add("tabulator"), t.setAttribute("role", "grid"); t.firstChild; )
      t.removeChild(t.firstChild);
    e.height && (e.height = isNaN(e.height) ? e.height : e.height + "px", t.style.height = e.height), e.minHeight !== !1 && (e.minHeight = isNaN(e.minHeight) ? e.minHeight : e.minHeight + "px", t.style.minHeight = e.minHeight), e.maxHeight !== !1 && (e.maxHeight = isNaN(e.maxHeight) ? e.maxHeight : e.maxHeight + "px", t.style.maxHeight = e.maxHeight);
  }
  //initialize core systems and modules
  _initializeTable() {
    var t = this.element, e = this.options;
    this.interactionMonitor.initialize(), this.columnManager.initialize(), this.rowManager.initialize(), this._detectBrowser(), this.modulesCore.forEach((a) => {
      a.initialize();
    }), t.appendChild(this.columnManager.getElement()), t.appendChild(this.rowManager.getElement()), e.footerElement && this.footerManager.activate(), e.autoColumns && e.data && this.columnManager.generateColumnsFromRowData(this.options.data), this.modulesRegular.forEach((a) => {
      a.initialize();
    }), this.columnManager.setColumns(e.columns), this.eventBus.dispatch("table-built");
  }
  _loadInitialData() {
    this.dataLoader.load(this.options.data), this.columnManager.verticalAlignHeaders();
  }
  //deconstructor
  destroy() {
    var t = this.element;
    for (this.destroyed = !0, Es.deregister(this), this.eventBus.dispatch("table-destroy"), this.rowManager.destroy(); t.firstChild; )
      t.removeChild(t.firstChild);
    t.classList.remove("tabulator"), this.externalEvents.dispatch("tableDestroyed");
  }
  _detectBrowser() {
    var t = navigator.userAgent || navigator.vendor || window.opera;
    t.indexOf("Trident") > -1 ? (this.browser = "ie", this.browserSlow = !0) : t.indexOf("Edge") > -1 ? (this.browser = "edge", this.browserSlow = !0) : t.indexOf("Firefox") > -1 ? (this.browser = "firefox", this.browserSlow = !1) : t.indexOf("Mac OS") > -1 ? (this.browser = "safari", this.browserSlow = !1) : (this.browser = "other", this.browserSlow = !1), this.browserMobile = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(t) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(t.slice(0, 4));
  }
  initGuard(t, e) {
    var a, n;
    return this.options.debugInitialization && !this.initialized && (t || (a = new Error().stack.split(`
`), n = a[0] == "Error" ? a[2] : a[1], n[0] == " " ? t = n.trim().split(" ")[1].split(".")[1] : t = n.trim().split("@")[0]), console.warn("Table Not Initialized - Calling the " + t + " function before the table is initialized may result in inconsistent behavior, Please wait for the `tableBuilt` event before calling this function." + (e ? " " + e : ""))), this.initialized;
  }
  ////////////////// Data Handling //////////////////
  //block table redrawing
  blockRedraw() {
    this.initGuard(), this.eventBus.dispatch("redraw-blocking"), this.rowManager.blockRedraw(), this.columnManager.blockRedraw(), this.eventBus.dispatch("redraw-blocked");
  }
  //restore table redrawing
  restoreRedraw() {
    this.initGuard(), this.eventBus.dispatch("redraw-restoring"), this.rowManager.restoreRedraw(), this.columnManager.restoreRedraw(), this.eventBus.dispatch("redraw-restored");
  }
  //load data
  setData(t, e, a) {
    return this.initGuard(!1, "To set initial data please use the 'data' property in the table constructor."), this.dataLoader.load(t, e, a, !1);
  }
  //clear data
  clearData() {
    this.initGuard(), this.dataLoader.blockActiveLoad(), this.rowManager.clearData();
  }
  //get table data array
  getData(t) {
    return this.rowManager.getData(t);
  }
  //get table data array count
  getDataCount(t) {
    return this.rowManager.getDataCount(t);
  }
  //replace data, keeping table in position with same sort
  replaceData(t, e, a) {
    return this.initGuard(), this.dataLoader.load(t, e, a, !0, !0);
  }
  //update table data
  updateData(t) {
    var e = 0;
    return this.initGuard(), new Promise((a, n) => {
      this.dataLoader.blockActiveLoad(), typeof t == "string" && (t = JSON.parse(t)), t && t.length > 0 ? t.forEach((i) => {
        var r = this.rowManager.findRow(i[this.options.index]);
        r ? (e++, r.updateData(i).then(() => {
          e--, e || a();
        }).catch((l) => {
          n("Update Error - Unable to update row", i, l);
        })) : n("Update Error - Unable to find row", i);
      }) : (console.warn("Update Error - No data provided"), n("Update Error - No data provided"));
    });
  }
  addData(t, e, a) {
    return this.initGuard(), new Promise((n, i) => {
      this.dataLoader.blockActiveLoad(), typeof t == "string" && (t = JSON.parse(t)), t ? this.rowManager.addRows(t, e, a).then((r) => {
        var l = [];
        r.forEach(function(o) {
          l.push(o.getComponent());
        }), n(l);
      }) : (console.warn("Update Error - No data provided"), i("Update Error - No data provided"));
    });
  }
  //update table data
  updateOrAddData(t) {
    var e = [], a = 0;
    return this.initGuard(), new Promise((n, i) => {
      this.dataLoader.blockActiveLoad(), typeof t == "string" && (t = JSON.parse(t)), t && t.length > 0 ? t.forEach((r) => {
        var l = this.rowManager.findRow(r[this.options.index]);
        a++, l ? l.updateData(r).then(() => {
          a--, e.push(l.getComponent()), a || n(e);
        }) : this.rowManager.addRows(r).then((o) => {
          a--, e.push(o[0].getComponent()), a || n(e);
        });
      }) : (console.warn("Update Error - No data provided"), i("Update Error - No data provided"));
    });
  }
  //get row object
  getRow(t) {
    var e = this.rowManager.findRow(t);
    return e ? e.getComponent() : (console.warn("Find Error - No matching row found:", t), !1);
  }
  //get row object
  getRowFromPosition(t) {
    var e = this.rowManager.getRowFromPosition(t);
    return e ? e.getComponent() : (console.warn("Find Error - No matching row found:", t), !1);
  }
  //delete row from table
  deleteRow(t) {
    var e = [];
    this.initGuard(), Array.isArray(t) || (t = [t]);
    for (let a of t) {
      let n = this.rowManager.findRow(a, !0);
      if (n)
        e.push(n);
      else
        return console.error("Delete Error - No matching row found:", a), Promise.reject("Delete Error - No matching row found");
    }
    return e.sort((a, n) => this.rowManager.rows.indexOf(a) > this.rowManager.rows.indexOf(n) ? 1 : -1), e.forEach((a) => {
      a.delete();
    }), this.rowManager.reRenderInPosition(), Promise.resolve();
  }
  //add row to table
  addRow(t, e, a) {
    return this.initGuard(), typeof t == "string" && (t = JSON.parse(t)), this.rowManager.addRows(t, e, a, !0).then((n) => n[0].getComponent());
  }
  //update a row if it exists otherwise create it
  updateOrAddRow(t, e) {
    var a = this.rowManager.findRow(t);
    return this.initGuard(), typeof e == "string" && (e = JSON.parse(e)), a ? a.updateData(e).then(() => a.getComponent()) : this.rowManager.addRows(e).then((n) => n[0].getComponent());
  }
  //update row data
  updateRow(t, e) {
    var a = this.rowManager.findRow(t);
    return this.initGuard(), typeof e == "string" && (e = JSON.parse(e)), a ? a.updateData(e).then(() => Promise.resolve(a.getComponent())) : (console.warn("Update Error - No matching row found:", t), Promise.reject("Update Error - No matching row found"));
  }
  //scroll to row in DOM
  scrollToRow(t, e, a) {
    var n = this.rowManager.findRow(t);
    return n ? this.rowManager.scrollToRow(n, e, a) : (console.warn("Scroll Error - No matching row found:", t), Promise.reject("Scroll Error - No matching row found"));
  }
  moveRow(t, e, a) {
    var n = this.rowManager.findRow(t);
    this.initGuard(), n ? n.moveToRow(e, a) : console.warn("Move Error - No matching row found:", t);
  }
  getRows(t) {
    return this.rowManager.getComponents(t);
  }
  //get position of row in table
  getRowPosition(t) {
    var e = this.rowManager.findRow(t);
    return e ? e.getPosition() : (console.warn("Position Error - No matching row found:", t), !1);
  }
  /////////////// Column Functions  ///////////////
  setColumns(t) {
    this.initGuard(!1, "To set initial columns please use the 'columns' property in the table constructor"), this.columnManager.setColumns(t);
  }
  getColumns(t) {
    return this.columnManager.getComponents(t);
  }
  getColumn(t) {
    var e = this.columnManager.findColumn(t);
    return e ? e.getComponent() : (console.warn("Find Error - No matching column found:", t), !1);
  }
  getColumnDefinitions() {
    return this.columnManager.getDefinitionTree();
  }
  showColumn(t) {
    var e = this.columnManager.findColumn(t);
    if (this.initGuard(), e)
      e.show();
    else
      return console.warn("Column Show Error - No matching column found:", t), !1;
  }
  hideColumn(t) {
    var e = this.columnManager.findColumn(t);
    if (this.initGuard(), e)
      e.hide();
    else
      return console.warn("Column Hide Error - No matching column found:", t), !1;
  }
  toggleColumn(t) {
    var e = this.columnManager.findColumn(t);
    if (this.initGuard(), e)
      e.visible ? e.hide() : e.show();
    else
      return console.warn("Column Visibility Toggle Error - No matching column found:", t), !1;
  }
  addColumn(t, e, a) {
    var n = this.columnManager.findColumn(a);
    return this.initGuard(), this.columnManager.addColumn(t, e, n).then((i) => i.getComponent());
  }
  deleteColumn(t) {
    var e = this.columnManager.findColumn(t);
    return this.initGuard(), e ? e.delete() : (console.warn("Column Delete Error - No matching column found:", t), Promise.reject());
  }
  updateColumnDefinition(t, e) {
    var a = this.columnManager.findColumn(t);
    return this.initGuard(), a ? a.updateDefinition(e) : (console.warn("Column Update Error - No matching column found:", t), Promise.reject());
  }
  moveColumn(t, e, a) {
    var n = this.columnManager.findColumn(t), i = this.columnManager.findColumn(e);
    this.initGuard(), n ? i ? this.columnManager.moveColumn(n, i, a) : console.warn("Move Error - No matching column found:", i) : console.warn("Move Error - No matching column found:", t);
  }
  //scroll to column in DOM
  scrollToColumn(t, e, a) {
    return new Promise((n, i) => {
      var r = this.columnManager.findColumn(t);
      return r ? this.columnManager.scrollToColumn(r, e, a) : (console.warn("Scroll Error - No matching column found:", t), Promise.reject("Scroll Error - No matching column found"));
    });
  }
  //////////// General Public Functions ////////////
  //redraw list without updating data
  redraw(t) {
    this.initGuard(), this.columnManager.redraw(t), this.rowManager.redraw(t);
  }
  setHeight(t) {
    this.options.height = isNaN(t) ? t : t + "px", this.element.style.height = this.options.height, this.rowManager.initializeRenderer(), this.rowManager.redraw(!0);
  }
  //////////////////// Event Bus ///////////////////
  on(t, e) {
    this.externalEvents.subscribe(t, e);
  }
  off(t, e) {
    this.externalEvents.unsubscribe(t, e);
  }
  dispatchEvent() {
    var t = Array.from(arguments);
    t.shift(), this.externalEvents.dispatch(...arguments);
  }
  //////////////////// Alerts ///////////////////
  alert(t, e) {
    this.initGuard(), this.alertManager.alert(t, e);
  }
  clearAlert() {
    this.initGuard(), this.alertManager.clear();
  }
  ////////////// Extension Management //////////////
  modExists(t, e) {
    return this.modules[t] ? !0 : (e && console.error("Tabulator Module Not Installed: " + t), !1);
  }
  module(t) {
    var e = this.modules[t];
    return e || console.error("Tabulator module not installed: " + t), e;
  }
}
eo.defaultOptions = i6;
new dR(eo);
class _A extends eo {
}
new dR(_A, s6);
let ir = null;
class OA {
  /**
   * Creates a new DataImportController
   * @ignore
   */
  constructor(t, e) {
    this.jsonSchemaService = t, this.$timeout = e, this.action = "upload", this.importCurrent = 0, this.importTotal = 0, this.isImporting = !1, this.isCanceled = !1;
  }
  /**
   * Implement IController
   */
  async $onInit() {
    ir = await Promise.resolve(Ne.global.XLSX), this.init();
  }
  /**
   * Download data or template
   * @param helpData Help data in the form or array of arrays
   */
  async download(t = null) {
    const e = wt.copy(this.sourceData);
    if (e.length < 1) {
      const i = {};
      this.mapper.source.keys.forEach((r) => {
        i[r] = null;
      }), e.push(i);
    }
    for (const i of e)
      delete i.validation;
    const a = ir.utils.json_to_sheet(e), n = ir.utils.book_new();
    if (ir.utils.book_append_sheet(n, a, "data"), t) {
      const i = ir.utils.aoa_to_sheet(t);
      ir.utils.book_append_sheet(n, i, "help");
    }
    ir.writeFile(n, "import.xlsx");
  }
  /** Upload rows to table */
  async upload(t) {
    if (t && t.length) {
      this.reset();
      const a = await t[0].arrayBuffer(), n = ir.read(a);
      if (n?.SheetNames?.length > 0) {
        const i = n.Sheets[n.SheetNames[0]], r = ir.utils.sheet_to_json(i);
        this.sourceData = [], r.forEach((l) => {
          if (this.hasData(l)) {
            const o = { validation: {} };
            this.mapper.source.keys.forEach((c) => {
              this.setFieldValue(o, c, l[c]);
            }), this.sourceData.push(o);
          }
        });
      }
      this.table.setData(this.sourceData), await this.$timeout();
    }
  }
  /** Reset data */
  reset(t = !1) {
    this.importTotal = 0, this.importCurrent = 0, this.isImporting = !1, this.isCanceled = !1, this.sourceData = [], this.targetData = null, this.table && t && (this.table.setData(this.sourceData), this.$timeout());
  }
  /** Paste data */
  async paste() {
    const t = await navigator.clipboard.readText();
    if (t) {
      const e = this.table.modules.clipboard.pasteParser(t);
      e && this.table.modules.clipboard.pasteAction(e), await this.$timeout();
    }
  }
  /** Map and validate data */
  async validate() {
    this.importTotal = 0;
    let t = !0;
    for (const e of this.sourceData) {
      let a = !0;
      e.importStatus = Pn.Ignored, e.validation = null;
      for (const n of this.mapper.source.keys)
        this.validateField(n, e[n]) || a && (a = !1, t = !1, e.validation = {
          isValid: !1,
          errors: [
            {
              type: Ra.General,
              msg: `${L.get("SALAXY.NG1.DataImport.messageInvalid")} ${this.getFieldTitle(n)}`
            }
          ]
        });
      a && (e.validation = {
        isValid: !0,
        errors: []
      });
    }
    t ? this.targetData = this.mapper.doMap(this.sourceData) : this.targetData = null, this.table.setData(this.sourceData), await this.$timeout();
  }
  /** Returns extra validator */
  getExtraValidators() {
    return [];
  }
  /** Enrichs data */
  getDataEnrichers() {
    return [];
  }
  /** Cancel import */
  cancel() {
    this.isCanceled = !0;
  }
  /**
   * Options validation. If required, override this method in the inheritied class.
   */
  hasInvalidOptions() {
    return !1;
  }
  /** Returns number of undefined validation rows */
  get validationUndoneRows() {
    return this.sourceData.filter((t) => !t.validation?.isValid && t.validation?.isValid !== !1).length;
  }
  /** Returns number of success rows */
  get validationSuccessRows() {
    return this.sourceData.filter((t) => t.validation?.isValid === !0).length;
  }
  /** Returns number of error rows */
  get validationErrorRows() {
    return this.sourceData.filter((t) => t.validation?.isValid === !1).length;
  }
  /** Returns number of success rows */
  get importSuccessRows() {
    return this.getImportStatusRows(Pn.Success);
  }
  /** Returns number of error rows */
  get importErrorRows() {
    return this.getImportStatusRows(Pn.Error);
  }
  /** Returns number of warning rows */
  get importWarningRows() {
    return this.getImportStatusRows(Pn.Warning);
  }
  /** Returns number of success rows */
  get importIgnoredRows() {
    return this.getImportStatusRows(Pn.Ignored);
  }
  getFieldTitle(t) {
    return t;
  }
  getEditor(t) {
    const e = this.mapper.source.schema.properties[t];
    switch (e?.type) {
      case "string": {
        switch (e.format) {
          case "date":
            return { editor: "date" };
          case "date-time":
            return { editor: "datetime" };
          case "multiline":
            return { editor: "textarea" };
        }
        if (e.format == "Occupation")
          return {
            editor: "list",
            editorParams: {
              values: dc.getAll().map((n) => ({ value: n.code, label: n.label })),
              autocomplete: !0
            }
          };
        if (e.format && e.enum?.length > 0) {
          const a = He.getEnumMetadata(e.format);
          return {
            editor: "list",
            formatter: function(n) {
              const i = n.getValue();
              return i ? a.values.find((r) => r.name == i)?.label ?? i : null;
            },
            editorParams: {
              values: a.values.map((n) => ({ value: n.name, label: n.label }))
            }
          };
        }
        break;
      }
      case "number":
      case "integer":
        return { editor: "number" };
      case "boolean":
        return { editor: "tickCross" };
    }
    return { editor: "input" };
  }
  validateField(t, e) {
    if (!t)
      return !0;
    const a = this.mapper.source.schema.properties[t];
    switch (a?.type) {
      case "string": {
        if (!e)
          return !0;
        if (typeof e != "string")
          return !1;
        switch (a.format) {
          case "date":
          case "date-time":
            return I.isValidDateTime(e);
        }
        return a.format == "Occupation" ? dc.getAll().some((i) => i.code === e) : a.format && a.enum?.length > 0 ? He.getEnumMetadata(a.format).values.some((i) => i.name === e) : !0;
      }
      case "number":
      case "integer":
        return e == null || e == null ? !0 : typeof e == "number" || typeof e == "bigint";
      case "boolean":
        return e == null || e == null ? !0 : typeof e == "boolean";
      default:
        return e == null || e == null ? !0 : typeof e == "string";
    }
  }
  /** Default help data for columns. */
  getDefaultHelpDataForColumns() {
    return [
      [L.get("SALAXY.NG1.DataImport.help.fields.title")],
      [L.get("SALAXY.NG1.DataImport.help.fields.id"), L.get("SALAXY.NG1.DataImport.help.fields.type"), L.get("SALAXY.NG1.DataImport.help.fields.name"), L.get("SALAXY.NG1.DataImport.help.fields.description")],
      ...this.mapper.source.keys.map((t) => [
        t,
        this.mapper.source.schema.properties[t]?.format || this.mapper.source.schema.properties[t]?.type || "string",
        L.getWithDefault((this.mapper.source.schema.properties[t] ?? {})["x-salaxy-title"], ""),
        L.getWithDefault((this.mapper.source.schema.properties[t] ?? {})["x-salaxy-description"], "")
      ]),
      [""],
      [L.get("SALAXY.NG1.DataImport.help.values.title")],
      [L.get("SALAXY.NG1.DataImport.help.values.type"), L.get("SALAXY.NG1.DataImport.help.values.value"), L.get("SALAXY.NG1.DataImport.help.values.description")],
      ...this.mapper.source.keys.filter((t) => this.getEditor(t)?.editor === "list").flatMap(
        (t) => this.getEditor(t)?.editorParams.values.map((e) => [this.mapper.source.schema.properties[t].format, e.value, e.label])
      )
    ];
  }
  setFieldValue(t, e, a) {
    const n = this.mapper?.source.schema.properties ? this.mapper.source.schema.properties[e] : void 0;
    switch (n?.type) {
      case "string": {
        if (a != null && a != null)
          if (n.format == "date" || n.format == "date-time") {
            if (typeof a == "number") {
              const i = I.getDate(1900, 1, 1);
              a = I.add(i, a - 2, "day");
            }
          } else if (n.format && (n.enum?.length ?? -1) > 0) {
            const i = He.getEnumMetadata(n.format), r = a.toLowerCase(), l = i.values.find((o) => o.name.toLowerCase() === r);
            l && (a = l.name);
          } else
            (typeof a == "number" || typeof a == "bigint" || typeof a == "boolean") && (a = `${a}`);
        break;
      }
      case "number": {
        a != null && a != null && typeof a == "string" && (a = se.parseNumber(a));
        break;
      }
      case "integer": {
        a != null && a != null && typeof a == "string" && (a = se.round(se.parseNumber(a), 0));
        break;
      }
      case "boolean": {
        a != null && a != null && typeof a == "string" && (a = a.toLowerCase() == "TRUE");
        break;
      }
    }
    t[e] = a;
  }
  getImportStatusRows(t) {
    return this.sourceData.filter((e) => e.importStatus == t).length;
  }
  async init() {
    this.mapper = await this.getImportMapper(), this.reset(), this.table = new _A("#import-table", {
      height: "calc(100vh - 500px)",
      // set height of table (in CSS or here), this enables the Virtual DOM and improves render speed dramatically (can be any valid css height value)
      data: this.sourceData,
      //assign data to table
      layout: "fitColumns",
      //fit columns to width of table (optional)
      clipboard: !0,
      clipboardPasteAction: (t) => (this.reset(), t.forEach((e) => {
        if (this.hasData(e)) {
          const a = { validation: {} };
          this.mapper.source.keys.forEach((n) => {
            this.setFieldValue(a, n, e[n]);
          }), this.sourceData.push(a);
        }
      }), this.table.setData(this.sourceData), this.sourceData),
      columns: [
        {
          title: L.get("SALAXY.NG1.DataImport.columnImportStatus"),
          field: "importStatus",
          formatter: function(t) {
            switch (t.getValue() ?? Pn.Ignored) {
              case Pn.Ignored:
                return `<span class="text-default">${L.get("SALAXY.NG1.DataImport.ignoredLabel")}</span>`;
              case Pn.Success:
                return `<span class="text-success" >${L.get("SALAXY.NG1.DataImport.successLabel")}</span>`;
              case Pn.Error:
                return `<span class="text-danger" >${L.get("SALAXY.NG1.DataImport.errorLabel")}</span>`;
              case Pn.Warning:
                return `<span class="text-warning" >${L.get("SALAXY.NG1.DataImport.warningLabel")}</span>`;
            }
            return null;
          },
          headerSort: !1
        },
        {
          title: L.get("SALAXY.NG1.DataImport.columnValidation"),
          field: "validation",
          formatter: function(t) {
            const e = t.getValue();
            return e ? !e.isValid && e.isValid !== !1 ? e.errors?.length > 0 ? `<span class="text-warning">${(e.errors ?? []).map((a) => a.msg).join("<br>")}</span>` : null : e.isValid !== !1 ? e.errors?.length > 0 ? `<span class="text-success">${(e.errors ?? []).map((a) => a.msg).join("<br>")}</span>` : '<span class="text-success">Ok</span>' : `<span class="text-danger" >${(e.errors ?? []).map((a) => a.msg).join("<br>")}</span>` : null;
          },
          headerSort: !1
        },
        ...this.mapper.source.keys.map((t) => ({
          title: this.getFieldTitle(t),
          field: t,
          ...this.getEditor(t),
          headerSort: !1,
          headerVertical: "flip"
        }))
      ]
    }), this.table.on("cellEdited", async () => {
      await this.$timeout();
    }), await this.$timeout();
  }
  hasData(t) {
    if (!t)
      return !1;
    let e = !1;
    for (const a of Object.keys(t))
      if (e = e || t[a] != null && t[a] != null && !(typeof t[a] == "string" && t[a].trim().length == 0), e)
        return e;
    return e;
  }
}
const nS = class nS extends OA {
  /**
   * Creates a new WorkerImportController
   * @ignore
   */
  constructor(t, e, a, n) {
    super(e, a), this.importsApi = t, this.uiHelpers = n, this.dataEnricher = {
      enrich: () => this.enrichEInvoiceAddresses(),
      buttonLabel: L.get("SALAXY.NG1.CompanyImport.enrichEInvoiceAddressesButton")
    };
  }
  /**
   * Implement IController
   */
  async $onInit() {
    super.$onInit();
  }
  /** Enrichs data */
  getDataEnrichers() {
    return [this.dataEnricher];
  }
  /** Import data */
  async import() {
    if (this.isImporting || (await this.validate(), !this.targetData))
      return;
    this.isImporting = !0, this.isCanceled = !1;
    for (const r of this.sourceData)
      r.validation = null, r.importStatus = Pn.Ignored;
    this.table.setData(this.sourceData), await this.$timeout();
    const t = (r) => `${r.item.officialId}`.toLowerCase(), e = (r) => `${r.officialId}`.toLowerCase();
    this.importTotal = this.targetData.length, this.importCurrent = 0;
    const a = 10, n = [];
    for (let r = 0; r < this.targetData.length; r += a)
      n.push(this.targetData.slice(r, r + a));
    let i = 0;
    for (const r of n) {
      try {
        if (this.isCanceled)
          break;
        r.splice(0, r.length, ...await this.importsApi.importCompanies(r));
      } catch (l) {
        for (const o of r)
          o.result = o.result ?? {}, o.result.status = Pn.Error, o.validation = {
            isValid: !1,
            errors: [{
              key: null,
              type: Ra.General,
              code: "Server error",
              msg: l?.data?.messageHtml || JSON.stringify(l?.data, Object.getOwnPropertyNames(l?.data))
            }]
          };
      }
      for (const l of r) {
        const o = this.sourceData.filter((c) => e(c) == t(l));
        for (const c of o)
          c.validation = {
            isValid: l.validation?.isValid,
            errors: l.validation?.errors
          }, c.importStatus = l.result?.status;
        i += o.length, this.importCurrent = i, this.table.setData(this.sourceData), await this.$timeout();
      }
    }
    this.isImporting = !1, await this.$timeout();
  }
  /** Help */
  async help() {
    const t = [
      [L.get("SALAXY.NG1.CompanyImport.help.title")],
      [""],
      [L.get("SALAXY.NG1.CompanyImport.help.overview.title")],
      [L.get("SALAXY.NG1.CompanyImport.help.overview.row1")],
      [L.get("SALAXY.NG1.CompanyImport.help.overview.row2")],
      [""],
      ...this.getDefaultHelpDataForColumns()
    ];
    await this.download(t);
  }
  async getImportMapper() {
    const t = new br("NG1/CompanyImportController", "Asiakkaat"), e = {
      officialId: "item.officialId",
      partnerAccountId: "item.partnerAccountId",
      email: "item.email",
      telephone: "item.telephone",
      contactFirstName: "item.contactFirstName",
      contactLastname: "item.contactLastName",
      proxyPartner: "item.proxyPartner",
      language: "item.language",
      eInvoiceReceiver: "parameters.settings.payments.invoice.eInvoiceReceiver",
      eInvoiceIntermediator: "parameters.settings.payments.invoice.eInvoiceIntermediator"
    };
    return await t.setSchemaFromCache(this.jsonSchemaService.getCache(), "salaxy-secure/schemas/v02.json", "CompanyImport", "target"), t.setPaths(e), t.generateSchema("CompanyImportRow", "source"), t;
  }
  async enrichEInvoiceAddresses() {
    if (!this.sourceData || this.sourceData.length == 0)
      return;
    const t = this.uiHelpers.showLoading("SALAXY.NG1.CompanyImport.enrichEInvoiceAddressesMessage", "");
    for (const e of this.sourceData) {
      if (e.eInvoiceReceiver && e.eInvoiceIntermediator)
        continue;
      t.setText(e.officialId);
      const a = await this.importsApi.queryEInvoiceAddress(e.officialId);
      if (a.length == 0)
        continue;
      if (a.length == 1) {
        e.eInvoiceReceiver = a[0].receiver, e.eInvoiceIntermediator = a[0].intermediator, await this.validate();
        continue;
      }
      const i = await this.uiHelpers.openEditDialog("salaxy-components/helpers/import/EInvoiceAddressSelect.html", { selection: null }, { addresses: a, select: (r, l, o) => {
        r.selection = l, o(We.Ok);
      } });
      if (i.result == We.Ok && i.item.selection?.receiver && i.item.selection?.intermediator) {
        e.eInvoiceReceiver = i.item.selection?.receiver, e.eInvoiceIntermediator = i.item.selection?.intermediator, await this.validate();
        continue;
      }
    }
    t.dismiss();
  }
};
nS.$inject = ["Imports", "JsonSchemaService", "$timeout", "UiHelpers"];
let xg = nS;
const sS = class sS extends OA {
  /**
   * Creates a new WorkerImportController
   * @ignore
   */
  constructor(t, e, a) {
    super(e, a), this.importsApi = t, this.isValidating = !1, this.customOptions = "removeAllRows", this.getTargetKey = (n) => `${n.officialId}_${n.item.worker.paymentData.socialSecurityNumber}_${I.asDate(n.item.workflow.salaryDate)}_${n.parameters.payroll.input.title}`.toLowerCase(), this.getSourceKey = (n) => `${n.companyOfficialId}_${n.personalId}_${I.asDate(n.salaryDate)}_${n.payrollTitle}`.toLowerCase(), this.getCheckTargetKey = (n) => `${n.officialId}_${n.id}`.toLowerCase(), this.getCheckSourceKey = (n) => `${n.companyOfficialId}_${n.employmentId || n.personalId}`.toLowerCase(), this.extraValidator = {
      validate: () => this.validateWorkers(),
      buttonLabel: L.get("SALAXY.NG1.CalcImport.validateWorkersButton")
    };
  }
  /**
   * Implement IController
   */
  async $onInit() {
    super.$onInit(), this.optionsTemplate = "salaxy-components/helpers/import/CalcImportOptions.html", this.options = {
      isMerge: !0,
      rowMergeOption: $b.RemoveAllRows,
      applyEmploymentDefaultRows: !1,
      sourceId: null
    };
  }
  /**
   * Updates options from the ui.
   */
  updateOptions() {
    switch (this.customOptions) {
      case "addRows":
        this.options.rowMergeOption = void 0;
        break;
      case "removeImportedRows":
        this.options.rowMergeOption = $b.RemoveImportedRows;
        break;
      case "removeAllRows":
        this.options.rowMergeOption = $b.RemoveAllRows;
        break;
    }
  }
  /**
   * Options validation. If required, override this method in the inheritied class.
   */
  hasInvalidOptions() {
    return this.optionsForm && this.optionsForm.$invalid;
  }
  /** Import data */
  async import() {
    if (this.isImporting || (await this.validate(), !this.targetData))
      return;
    this.isImporting = !0, this.isCanceled = !1;
    for (const r of this.sourceData)
      r.validation = null, r.importStatus = Pn.Ignored;
    this.table.setData(this.sourceData), await this.$timeout(), this.importTotal = this.targetData.length, this.importCurrent = 0;
    const t = ie.groupBy(this.targetData, this.getTargetKey), e = [];
    for (const r in t) {
      const l = t[r], o = l.splice(0, 1)[0];
      for (const c of l)
        o.item.rows.push(...c.item.rows);
      e.push(o);
    }
    const a = 10, n = [];
    for (let r = 0; r < e.length; r += a)
      n.push(e.slice(r, r + a));
    let i = 0;
    for (const r of n) {
      try {
        if (this.isCanceled)
          break;
        r.splice(0, r.length, ...await this.importsApi.importCalculations(r, this.options));
      } catch (l) {
        for (const o of r)
          o.result = o.result ?? {}, o.result.status = Pn.Error, o.validation = {
            isValid: !1,
            errors: [{
              key: null,
              type: Ra.General,
              code: "Server error",
              msg: l?.data?.messageHtml || JSON.stringify(l?.data, Object.getOwnPropertyNames(l?.data))
            }]
          };
      }
      for (const l of r) {
        const o = this.sourceData.filter((c) => this.getSourceKey(c) == this.getTargetKey(l));
        for (const c of o)
          c.validation = {
            isValid: l.validation?.isValid,
            errors: l.validation?.errors
          }, c.importStatus = l.result?.status;
        i += o.length, this.importCurrent = i, this.table.setData(this.sourceData), await this.$timeout();
      }
    }
    this.isImporting = !1, await this.$timeout();
  }
  /** Help */
  async help() {
    const t = [
      [L.get("SALAXY.NG1.CalcImport.help.title")],
      [""],
      [L.get("SALAXY.NG1.CalcImport.help.overview.title")],
      [L.get("SALAXY.NG1.CalcImport.help.overview.row1")],
      [L.get("SALAXY.NG1.CalcImport.help.overview.row2")],
      [""],
      ...this.getDefaultHelpDataForColumns()
    ];
    await this.download(t);
  }
  /** Returns extra validator */
  getExtraValidators() {
    return [this.extraValidator];
  }
  async getImportMapper() {
    const t = {
      rowType: "rowType",
      message: "message",
      kind: "data.kind",
      count: "count",
      price: "price",
      unit: "unit",
      // rowSourceId: "sourceId",
      vatPercent: "accounting.vatPercent"
    }, e = new br("NG1/CalcImporController", "Palkkalaskelmat");
    await e.setSchemaFromCache(this.jsonSchemaService.getCache(), "salaxy-secure/schemas/v02.json", "UserDefinedRow", "target"), e.setPaths(t), e.generateSchema("CalculationImportRow", "source");
    const a = new L0(
      null,
      "item.rows",
      (r) => r.rowType && r.price > 0 ? e.doMap([r]) : []
    ), n = new br("NG1/CalcImportController", "Palkkalaskelmat"), i = {
      companyOfficialId: "officialId",
      personalId: "item.worker.paymentData.socialSecurityNumber",
      employmentId: "item.worker.employmentId",
      occupationCode: "item.info.occupationCode",
      periodStart: "item.info.workStartDate",
      periodEnd: "item.info.workEndDate",
      workDescription: "item.info.workDescription",
      salarySlipMessage: "item.info.salarySlipMessage",
      salaryDate: "item.workflow.salaryDate",
      paymentChannel: "item.info.paymentChannel",
      payrollTitle: "parameters.payroll.input.title",
      // payrollSourceId: "parameters.payroll.input.sourceId",
      // sourceId: "item.info.sourceId",
      fixedTaxAmount: "item.worker.tax.fixedTaxAmount",
      rowType: a
    };
    await n.setSchemaFromCache(this.jsonSchemaService.getCache(), "salaxy-secure/schemas/v02.json", "CalculationImport", "target"), n.setPaths(i), n.generateSchema("CalculationImportRow", "source"), n.source.schema.properties.occupationCode.format = "Occupation";
    for (const r in e.source.schema.properties)
      n.source.schema.properties[r] = e.source.schema.properties[r];
    return n;
  }
  /** Import data */
  async validateWorkers() {
    if (this.isValidating || (await this.validate(), !this.targetData))
      return;
    this.isValidating = !0;
    for (const i of this.sourceData)
      i.validation = null, i.validation = {
        isValid: null,
        // null on purpose
        errors: [{
          type: Ra.General,
          msg: L.get("SALAXY.UI_Terms.wait")
        }]
      }, i.importStatus = Pn.Ignored;
    this.table.setData(this.sourceData), await this.$timeout();
    const t = ie.groupBy(this.sourceData, this.getCheckSourceKey), e = [];
    for (const i in t)
      e.push({
        officialId: t[i][0].companyOfficialId,
        id: t[i][0].employmentId || t[i][0].personalId
      });
    const a = 10, n = [];
    for (let i = 0; i < e.length; i += a)
      n.push(e.slice(i, i + a));
    for (const i of n) {
      try {
        i.splice(0, i.length, ...await this.importsApi.checkWorkers(i));
      } catch (r) {
        for (const l of i)
          l.result = l.result ?? {}, l.result.status = D0.Error, l.validation = {
            isValid: !1,
            errors: [{
              key: null,
              type: Ra.General,
              code: "Server error",
              msg: r?.data?.messageHtml || JSON.stringify(r?.data, Object.getOwnPropertyNames(r?.data))
            }]
          };
      }
      for (const r of i) {
        const l = this.sourceData.filter((o) => this.getCheckSourceKey(o) == this.getCheckTargetKey(r));
        for (const o of l)
          o.validation = {
            isValid: r.validation.isValid && r.result.item.length == 1,
            errors: r.validation.isValid ? r.result.item == null || r.result.item.length == 0 ? [{ msg: L.get("SALAXY.NG1.CalcImport.messageMissingEmployment"), type: Ra.General }] : r.result.item.length == 1 ? [{ msg: L.get("SALAXY.NG1.CalcImport.messageExistingEmployment"), type: Ra.General }] : r.result.item.length > 1 ? [{ msg: L.get("SALAXY.NG1.CalcImport.messageSeveralEmployments"), type: Ra.General }] : r.validation.errors : r.validation.errors
          };
        this.table.setData(this.sourceData), await this.$timeout();
      }
    }
    this.isValidating = !1, await this.$timeout();
  }
};
sS.$inject = ["Imports", "JsonSchemaService", "$timeout"];
let wg = sS;
const iS = class iS {
  constructor(t, e, a, n, i, r, l) {
    this.ajax = t, this.$timeout = e, this.userSettingsService = a, this.$sce = n, this.sessionService = i, this.uiHelpers = r, this.reportsService = l, this.payrollCalcs = [], this.salarySlipListType = "all", this.payroll = void 0, this.debugJson = "", this._payrollId = void 0, this.salarySlipCache = {
      /** Employment ID for which the data has been fetched. */
      personalId: void 0,
      /** List of calculations for the employment ID */
      calcList: void 0,
      /** Type of the list (filtering of the items on server-side) */
      type: void 0
    }, this.currentEmploymentPdf = void 0, this.uploadResults = void 0, this.statusGroups = [
      {
        key: "todo",
        statuses: ["preview", "new", "error", "deleted", "edited"],
        text: "SALAXY.NG1.ImportStagingComponent.statusGroup.todo",
        count: 0,
        active: !0
      },
      {
        key: "waitingCommit",
        statuses: ["preview", "new", "edited"],
        text: "SALAXY.NG1.ImportStagingComponent.statusGroup.waitingCommit",
        count: 0
      },
      {
        key: "committed",
        statuses: ["committed"],
        text: "SALAXY.NG1.ImportStagingComponent.status.committed",
        count: 0
      },
      {
        key: "all",
        statuses: [],
        text: "SALAXY.NG1.ImportStagingComponent.status.all",
        count: 0
      },
      {
        key: "ignored",
        statuses: ["ignored"],
        text: "SALAXY.NG1.ImportStagingComponent.status.ignored",
        count: 0
      },
      {
        key: "error",
        statuses: ["error"],
        text: "SALAXY.NG1.ImportStagingComponent.status.error",
        count: 0
      },
      {
        key: "preview",
        statuses: ["preview"],
        text: "SALAXY.NG1.ImportStagingComponent.status.preview",
        count: 0
      }
    ];
  }
  $onInit() {
    this.isSupported && (this.worktimeApi = new IL(this.serverUrl + "/api/v01/worktime", this.ajax), this.worktimeApi.reloadList().then(() => {
      this.$timeout();
    }), this.payroll && (this.payrollId = this.payroll.id), this.worktimeApi.fetchAllPayrolls().then(() => {
      this.$timeout();
    }));
  }
  /** Gets or sets the current payroll in the controller and also updates the selected payroll in the WorktimeApiConnector. */
  get payrollId() {
    return this._payrollId;
  }
  set payrollId(t) {
    this._payrollId = t, this.worktimeApi.detailsPayrollId = t;
  }
  /**
   * If supported for the company or partner, this URL is the integration server used in for the imports.
   */
  get serverUrl() {
    return this.sessionService.session.settings.integration.serverUrl || void 0;
  }
  /**
   * Gets the user-specific setting (service), stored in the local storage.
   */
  get userSettings() {
    return this.userSettingsService;
  }
  /** If true, the staginc server is supported for the partner. */
  get isSupported() {
    return !!this.serverUrl;
  }
  /** Gets the calculations / salary slips for the employment. */
  get currentEmploymentCalcs() {
    if (!this.worktimeApi.current?.preview?.employments?.length)
      return [];
    const t = this.worktimeApi.current.preview.employments[0].identity.personalId;
    return (this.salarySlipCache.personalId !== t || this.salarySlipCache.type !== this.salarySlipListType) && (this.salarySlipCache.personalId = t, this.salarySlipCache.calcList = void 0, this.salarySlipCache.type = this.salarySlipListType, this.ajax.getJSON(this.serverUrl + `/api/v01/worktime/employment/${t}/calculations?type=${this.salarySlipListType}`).then((e) => {
      this.salarySlipCache.calcList = e.value;
    })), this.salarySlipCache.calcList;
  }
  /**
   * Commits the current payroll.
   * @param scope - The scope of the commit: Payroll commits the entire payroll in the controller.
   * Employment commits the selected employment only and the Payroll specified in the employment.
   */
  async commitPayroll(t) {
    const e = async (n, i) => {
      await this.ajax.postJSON(this.serverUrl + `/api/v01/worktime/commit-payroll/${n}/${i}`, void 0);
    };
    if (t == "payroll") {
      if (!this.payrollId)
        throw new Error("No payroll selected.");
      const n = this.worktimeApi.getFilteredList(this.payrollId), i = [
        { title: L.get("SALAXY.UI_Terms.name"), field: "sortableName" },
        { title: L.get("SALAXY.UI_Terms.personalId"), field: "personalId" }
      ];
      await this.uiHelpers.showBatchProcessDialog(L.get("SALAXY.NG1.ImportStagingComponent.dialog.commitPayroll"), n, async (r, l) => {
        if (Array.isArray(r))
          throw new Error("Batch processing not supported for payroll commit.");
        return await e(this.payrollId, r.id), [{
          message: "",
          result: void 0
        }];
      }, void 0, {}, i, void 0, !0), this.$timeout(() => {
        this.reloadUi();
      });
      return;
    }
    const a = this.uiHelpers.showLoading(L.get("SALAXY.NG1.ImportStagingComponent.dialog.commitPayroll"));
    await e(this.worktimeApi.detailsPayrollId, this.worktimeApi.current.id), a.dismiss(), this.reloadUi();
  }
  /** Reloads the current user interface: Especially the payroll if we are in the Payroll view. */
  reloadUi() {
    this.sessionService.refreshUi();
  }
  /**
   * Gets the totals for the selected payroll or the entire history if no payroll is selected.
   * @param row - The row for which to get the totals.
   */
  getTotals(t) {
    if (t == "all") {
      let e = [];
      return this.worktimeApi?.list && (e = this.payrollId ? this.worktimeApi.list.map((a) => a.payrolls[this.payrollId]).filter((a) => a) : this.worktimeApi.list.map((a) => a.totals)), this.uiHelpers.cache(
        this,
        "allTotals",
        () => e.reduce((a, n) => ({
          calcs: {
            count: a.calcs.count + n.calcs.count
          },
          period: n.period,
          // Add min/max if necessary
          rows: {
            committed: a.rows.committed + n.rows.committed,
            count: a.rows.count + n.rows.count,
            deleted: a.rows.deleted + n.rows.deleted,
            edited: a.rows.edited + n.rows.edited,
            error: a.rows.error + n.rows.error,
            ignored: a.rows.ignored + n.rows.ignored,
            new: a.rows.new + n.rows.new,
            preview: a.rows.preview + n.rows.preview
          },
          salaryDate: n.salaryDate
          // Add min/max if necessary
        }), {
          calcs: {
            count: 0
          },
          rows: {
            committed: 0,
            count: 0,
            deleted: 0,
            edited: 0,
            error: 0,
            ignored: 0,
            new: 0,
            preview: 0
          }
        })
        /** Add upadated at to WorktimeImportPreviewMetadata for quicker cache  */
      );
    }
    if (this.payrollId) {
      const e = t.payrolls[this.payrollId];
      if (this.payrollCalcs && e && !e.committed) {
        const a = this.payrollCalcs.find((n) => n.data.employmentId == t.id);
        a && (e.committed = {
          gross: a.grossSalary,
          net: a.data.workerPayment
        });
      }
      return e;
    }
    return t.totals;
  }
  /**
   * Recalculates the current worktime (if selected).
   */
  async recalculateWorktime() {
    const t = this.worktimeApi.current?.id;
    this.showDetails(void 0);
    const e = this.uiHelpers.showLoading(L.get("SALAXY.NG1.ImportStagingComponent.dialog.recalculating"));
    await this.worktimeApi.recalculateWorktime(t), this.showDetails(t), e.dismiss();
  }
  /**
   * Saves the manual rows to the server and refreshes the view.
   * @returns The updated worktime import.
   */
  async saveManualRows() {
    await this.worktimeApi.saveManualRows(), await this.recalculateWorktime();
  }
  /** Deletes the current worktime (with are you sure) */
  async deleteWorktime() {
    this.worktimeApi.current && this.uiHelpers.showConfirm("SALAXY.NG1.ApiCrudObjectComponent.deleteDialog").then((t) => {
      if (t) {
        const e = this.worktimeApi.current.id;
        this.showDetails(void 0), this.worktimeApi.delete(e);
      }
    });
  }
  /**
   * Recalculates all the worktimes in the list.
   */
  async recalculateAllWorktimes() {
    const t = this.uiHelpers.showLoading(L.get("SALAXY.NG1.ImportStagingComponent.dialog.recalculating")), e = this.worktimeApi.getFilteredList(this.payrollId);
    for (let a = 0; a < e.length; a++) {
      const n = e[a];
      t.setText(`Recalculating ${n.sortableName} ${a + 1}/${e.length}...`), await this.worktimeApi.recalculateWorktime(n.id);
    }
    t.dismiss();
  }
  /**
   * Shows a report for the current calculation using a modal dialog.
   * @param calculationId - Identifier of the calculation to show.
   * @param reportType - Type of report to show
   */
  showReportDialog(t, e = "salarySlip") {
    if (t.startsWith("preview-")) {
      const i = this.worktimeApi.current.preview.calculations.find((r) => r.id == t);
      if (i) {
        this.reportsService.showReportModalForCalc(e, i, "page1", !0);
        return;
      }
      throw new Error(`Calculation ${t} not found in preview.`);
    }
    const n = `${this.serverUrl}/api/v01/worktime/calculations/${t}`;
    this.ajax.getJSON(n).then((i) => {
      this.reportsService.showReportModalForCalc(e, i, "page1", !1);
    });
  }
  /**
   * Shows the salary slip PDF in the IFrame UI.
   * Sets the currentEmploymentPdf to the PDF of the salary slip (Base64 resource URI).
   * @param calculationId Identifier of the calculation for which the PDF is shown.
   */
  showSalarySlipPdf(t) {
    if (this.currentEmploymentPdf = "loading", !t) {
      this.currentEmploymentPdf = void 0;
      return;
    }
    this.ajax.getHTML(this.serverUrl + `/api/v01/worktime/calculations/${t}/pdf`).then((e) => {
      this.currentEmploymentPdf = this.$sce.trustAsResourceUrl(`data:application/pdf;base64, ${encodeURI(e)}`), this.$timeout();
    });
  }
  /**
   * Shows the salary slip HTML in the IFrame UI.
   * @param calculationId Identifier of the calculation for which the HTML is shown.
   */
  showSalarySlipHtml(t) {
    this.currentEmploymentPdf = this.$sce.trustAsResourceUrl(this.serverUrl + `/api/v01/worktime/calculations/${t}/html?access_token=` + this.ajax.getCurrentToken());
  }
  /**
   * Shows (hides) an item in the details view
   * @param id - The ID of the item to show. If undefined, hides the details view.
   */
  showDetails(t) {
    t ? this.worktimeApi.showDetails(t) : this.worktimeApi.setCurrent(void 0);
  }
  /** Returns true if the offcanvas (dialog) should be shown. */
  get showOffcanvas() {
    return !!this.worktimeApi.current;
  }
  /**
   * Uploads a JSON file for testing purposes.
   * Should be added to a form submit event.
   * @param event - The change event that triggered by the file upload
   * ...or string "clipboard" for clipboard data.
   * @example
   * ```html
   * <form ng-submit="$ctrl.uploadTestFile($event)">
   *   <input type="file" class="form-control" />
   *   <button type="submit" class="btn btn-default">Upload</button>
   * </form>
   * ```
   */
  async uploadTestFile(t) {
    let e;
    if (t == "clipboard") {
      const i = await window.navigator.clipboard.readText();
      e = JSON.parse(i);
    } else {
      const i = t?.target;
      if (!i.tagName || i.tagName.toLowerCase() !== "form")
        throw new Error('Method uploadTestFile should be connected to submit event of a form, e.g. <form ng-submit="$ctrl.uploadTestFile($event)">.');
      const r = i.querySelector("input[type=file]");
      if (!r)
        throw new Error("No file input found in the form.");
      const l = r.files?.[0];
      if (!l)
        return;
      const o = await l.text();
      e = JSON.parse(o);
    }
    if (!e.rows && !e.employments)
      throw new Error("Invalid data: Rows or employments are required.");
    let a;
    try {
      a = await this.worktimeApi.callUpdateWorktime(e);
    } catch (i) {
      throw this.uploadResults = i, this.$timeout(), i;
    }
    const n = (a.rows ?? []).concat(a.employments ?? []).filter((i) => !i.validation.isValid);
    n.length ? (console.error("Validation errors", n), this.uploadResults = n, alert("Validation errors found, see console for details.")) : (console.debug("Result", a), this.uploadResults = a, alert("Updates have been saved and validated.")), this.$timeout();
  }
  /**
   * Uploads a JSON string for testing purposes.
   * @param text - The JSON string to upload
   */
  async uploadTestJson(t) {
    const e = JSON.parse(t);
    let a;
    try {
      a = await this.worktimeApi.callUpdateWorktime(e);
    } catch (i) {
      throw this.uploadResults = i, this.$timeout(), i;
    }
    const n = (a.rows ?? []).concat(a.employments ?? []).filter((i) => !i.validation.isValid);
    n.length ? (console.error("Validation errors", n), this.uploadResults = n, alert("Validation errors found, see console for details.")) : (console.debug("Result", a), this.uploadResults = a, alert("Updates have been saved and validated.")), this.$timeout();
  }
  /**
   * Formats the debug JSON string.
   */
  formatDebugJson() {
    this.debugJson = JSON.stringify(JSON.parse(this.debugJson), null, 2);
  }
  /**
   * Adds a blank WorktimeImport object to the debug JSON editor.
   * Uses WorktimeApiConnector.getBlank() to generate the empty object.
   */
  debugJsonAddBlank() {
    this.debugJson = JSON.stringify(IL.getBlank(), null, 2);
  }
  /**
   * Marks the selected rows with given state.
   * @param rows - The rows to mark.
   * @param status - The status to set.
   * Status "new" is essentially reverting the state from "ignored" => final state may be "preview", "new" or "error" depending on other properties of the row.
   */
  setStatus(t, e) {
    const a = this.uiHelpers.showLoading();
    this.worktimeApi.setStatus(t, e).then((n) => {
      a.dismiss(), this.$timeout();
    });
  }
  /**
   * Deletes the selected rows from the current worktime import and saves the changes .
   * @param rows - The rows to delete.
   */
  async deleteRows(t) {
    if (!await this.uiHelpers.showConfirm("Haluatko varmaan poistaa valitut rivit?", "Rivit poistetaan työajan tuonnista, mutta ne saatetaan tuoda uudelleen myöhemmin, jos lähdejärjestelmän dataa päivitetään."))
      return;
    const a = this.uiHelpers.showLoading();
    this.worktimeApi.current.rows = this.worktimeApi.current.rows.filter((n) => !t.includes(n)), await this.worktimeApi.saveCurrent(), a.dismiss();
  }
  /**
   * Moves the selected rows to the given payroll.
   * @param rows - The rows to move.
   * @param payrollId - The payroll id to move to.
   * @returns The updated worktime import.
   */
  async moveToPayroll(t, e) {
    const a = this.uiHelpers.showLoading();
    this.worktimeApi.moveToPayroll(t, e).then((n) => {
      a.dismiss(), this.$timeout();
    });
  }
  /** The current status group. */
  get statusGroup() {
    return this.statusGroups.find((t) => t.active) || this.statusGroups[0];
  }
  set statusGroup(t) {
    this.statusGroups.forEach((e) => e.active = e.key == t.key);
  }
  updateCounts() {
    this.statusGroups.forEach((t) => t.count = this.worktimeApi.filteredRows.filter((e) => t.statuses.includes(e.status)).length);
  }
};
iS.$inject = ["AjaxNg1", "$timeout", "UserSettingsService", "$sce", "SessionService", "UiHelpers", "ReportsService"];
let Ag = iS;
const rS = class rS extends OA {
  /**
   * Creates a new WorkerImportController
   * @ignore
   */
  constructor(t, e, a) {
    super(e, a), this.importsApi = t, this.isValidating = !1, this.getTargetKey = (n) => `${n.officialId}_${n.item.officialPersonId}`.toLowerCase(), this.getSourceKey = (n) => `${n.companyOfficialId}_${n.personalId}`.toLowerCase(), this.getCheckTargetKey = (n) => `${n.officialId}_${n.id}`.toLowerCase(), this.getCheckSourceKey = (n) => `${n.companyOfficialId}_${n.personalId}`.toLowerCase(), this.extraValidator = {
      validate: () => this.validateWorkers(),
      buttonLabel: L.get("SALAXY.NG1.WorkerImport.validateWorkersButton")
    };
  }
  /**
   * Implement IController
   */
  async $onInit() {
    super.$onInit();
  }
  /** Import data */
  async import() {
    if (this.isImporting || (await this.validate(), !this.targetData))
      return;
    this.isImporting = !0, this.isCanceled = !1;
    for (const n of this.sourceData)
      n.validation = null, n.importStatus = Pn.Ignored;
    this.table.setData(this.sourceData), await this.$timeout(), this.importTotal = this.targetData.length, this.importCurrent = 0;
    const t = 10, e = [];
    for (let n = 0; n < this.targetData.length; n += t)
      e.push(this.targetData.slice(n, n + t));
    let a = 0;
    for (const n of e) {
      try {
        if (this.isCanceled)
          break;
        n.splice(0, n.length, ...await this.importsApi.importWorkers(n));
      } catch (i) {
        for (const r of n)
          r.result = r.result ?? {}, r.result.status = Pn.Error, r.validation = {
            isValid: !1,
            errors: [{
              key: null,
              type: Ra.General,
              code: "Server error",
              msg: i?.data?.messageHtml || JSON.stringify(i?.data, Object.getOwnPropertyNames(i?.data))
            }]
          };
      }
      for (const i of n) {
        const r = this.sourceData.filter((l) => this.getSourceKey(l) == this.getTargetKey(i));
        for (const l of r)
          l.validation = {
            isValid: i.validation?.isValid,
            errors: i.validation?.errors
          }, l.importStatus = i.result?.status;
        a += r.length, this.importCurrent = a, this.table.setData(this.sourceData), await this.$timeout();
      }
    }
    this.isImporting = !1, await this.$timeout();
  }
  /** Help */
  async help() {
    const t = [
      [L.get("SALAXY.NG1.WorkerImport.help.title")],
      [""],
      [L.get("SALAXY.NG1.WorkerImport.help.overview.title")],
      [L.get("SALAXY.NG1.WorkerImport.help.overview.row1")],
      [L.get("SALAXY.NG1.WorkerImport.help.overview.row2")],
      [""],
      ...this.getDefaultHelpDataForColumns()
    ];
    await this.download(t);
  }
  /** Returns extra validator */
  getExtraValidators() {
    return [this.extraValidator];
  }
  async getImportMapper() {
    const t = {
      defaultRowType: "rowType",
      defaultRowKind: "data.kind",
      defaultSalary: "price"
    }, e = new br("NG1/WorkerImporController", "Työntekijät");
    await e.setSchemaFromCache(this.jsonSchemaService.getCache(), "salaxy-secure/schemas/v02.json", "UserDefinedRow", "target"), e.setPaths(t), e.generateSchema("WorkerImportRow", "source");
    const a = new L0(
      null,
      "item.employment.work.salaryDefaults",
      (r) => r.defaultRowType && r.defaultSalary > 0 ? e.doMap([r]) : []
    ), n = new br("NG1/WorkerImportController", "Työntekijät"), i = {
      companyOfficialId: "officialId",
      personalId: "item.officialPersonId",
      sourceId: "item.employment.sourceId",
      firstName: "item.avatar.firstName",
      lastName: "item.avatar.lastName",
      email: "item.contact.email",
      telephone: "item.contact.telephone",
      ibanNumber: "item.ibanNumber",
      street: "item.contact.street",
      postalCode: "item.contact.postalCode",
      city: "item.contact.city",
      countryCode: "item.contact.countryCode",
      startDate: "item.employment.startDate",
      employmentType: "item.employment.type",
      pensionCalculation: "item.employment.pensionCalculation",
      description: "item.employment.work.description",
      occupationCode: "item.employment.work.occupationCode",
      taxcard: "item.employment.taxcard",
      defaultRowType: a
    };
    await n.setSchemaFromCache(this.jsonSchemaService.getCache(), "salaxy-secure/schemas/v02.json", "WorkerImport", "target"), n.setPaths(i), n.generateSchema("WorkerImportRow", "source"), n.source.schema.properties.occupationCode.format = "Occupation";
    for (const r in e.source.schema.properties)
      n.source.schema.properties[r] = e.source.schema.properties[r];
    return n;
  }
  /** Import data */
  async validateWorkers() {
    if (this.isValidating || (await this.validate(), !this.targetData))
      return;
    this.isValidating = !0;
    for (const i of this.sourceData)
      i.validation = null, i.validation = {
        isValid: null,
        // null on purpose
        errors: [{
          type: Ra.General,
          msg: L.get("SALAXY.UI_Terms.wait")
        }]
      }, i.importStatus = Pn.Ignored;
    this.table.setData(this.sourceData), await this.$timeout();
    const t = ie.groupBy(this.sourceData, this.getCheckSourceKey), e = [];
    for (const i in t)
      e.push({
        officialId: t[i][0].companyOfficialId,
        id: t[i][0].personalId
      });
    const a = 10, n = [];
    for (let i = 0; i < e.length; i += a)
      n.push(e.slice(i, i + a));
    for (const i of n) {
      try {
        i.splice(0, i.length, ...await this.importsApi.checkWorkers(i));
      } catch (r) {
        for (const l of i)
          l.result = l.result ?? {}, l.result.status = D0.Error, l.validation = {
            isValid: !1,
            errors: [{
              key: null,
              type: Ra.General,
              code: "Server error",
              msg: r?.data?.messageHtml || JSON.stringify(r?.data, Object.getOwnPropertyNames(r?.data))
            }]
          };
      }
      for (const r of i) {
        const l = this.sourceData.filter((o) => this.getCheckSourceKey(o) == this.getCheckTargetKey(r));
        for (const o of l)
          o.validation = {
            isValid: r.validation.isValid,
            errors: r.validation.isValid ? r.result.item == null || r.result.item.length == 0 ? [{ msg: L.get("SALAXY.NG1.WorkerImport.messageMissingEmployment"), type: Ra.General }] : r.result.item.length == 1 ? [{ msg: L.get("SALAXY.NG1.WorkerImport.messageExistingEmployment"), type: Ra.General }] : r.result.item.length > 1 ? [{ msg: L.get("SALAXY.NG1.WorkerImport.messageSeveralEmployments"), type: Ra.General }] : r.validation.errors : r.validation.errors
          };
        this.table.setData(this.sourceData), await this.$timeout();
      }
    }
    this.isValidating = !1, await this.$timeout();
  }
};
rS.$inject = ["Imports", "JsonSchemaService", "$timeout"];
let Cg = rS;
const lS = class lS extends nn {
  /**
   * Creates a new DatasetsCrudController
   * @ignore
   */
  constructor(t, e, a, n) {
    super(t, e, a, n);
  }
  /**
   * Controller initialization
   */
  $onInit() {
    super.$onInit();
  }
  /** Implements the getDefaults of ApiCrudObjectController */
  getDefaults() {
    return {
      listUrl: this.listUrl || "/customer-invoices/",
      detailsUrl: this.detailsUrl || "/customer-invoices/details/",
      // TODO: Add a custom listing
      oDataTemplateUrl: "salaxy-components/odata/lists/CustomerInvoices.html",
      oDataOptions: {}
    };
  }
};
lS.$inject = [
  "CustomerInvoices",
  "UiHelpers",
  "$location",
  "$routeParams"
];
let aw = lS;
const oS = class oS extends nn {
  constructor(t, e, a, n, i, r) {
    super(t, e, a, n), this.invoicesApi = t, this.invoicesService = i, this.ajax = r, this._reportCalcs = [], this._calcOrPayrollId = [], this.selectionDataReader = {
      /** Function to read data into given array */
      read: (l, o) => {
        const c = this.odataController.selectedItems.map((d) => this.api.getSingle(d.id));
        return Promise.all(c).then((d) => {
          l.push(...d.filter((p) => !!p));
        });
      },
      /** Optional label for data export */
      exportLabel: L.get("SALAXY.NG1.AccountingReportToolsComponent.exportLabel"),
      /** Indicates if the export is not possible */
      disabled: () => !this.odataController.selectedItems || this.odataController.selectedItems.length === 0
    }, this.selectionDataReaderPerson = {
      /** Function to read data into given array */
      read: (l, o) => {
        const c = this.odataController.selectedItems.map((d) => this.api.getSingle(d.id));
        return Promise.all(c).then((d) => {
          d = d.filter((p) => p.header.type === ce.Net || p.header.type === ce.Tax), l.push(...d.filter((p) => !!p));
        });
      },
      /** Optional label for data export */
      exportLabel: L.get("SALAXY.NG1.AccountingReportToolsComponent.exportLabel"),
      /** Indicates if the export is not possible */
      disabled: () => !this.odataController.selectedItems || this.odataController.selectedItems.length === 0
    }, this.statusFilters = [
      {
        value: "all",
        text: L.get("SALAXY.NG1.InvoicesComponent.statusAll"),
        ui: ""
      },
      {
        value: "waitingConfirmation",
        text: L.get("SALAXY.NG1.InvoicesComponent.statusWaitingConfirmation"),
        ui: "status eq 'unread' or status eq 'read' or status eq 'waitingConfirmation'"
      },
      {
        value: "paid",
        text: L.get("SALAXY.NG1.InvoicesComponent.statusPaid"),
        ui: "status eq 'paid' or status eq 'paymentStarted' or status eq 'canceled'"
      },
      {
        value: "forecast",
        text: L.get("SALAXY.NG1.InvoicesComponent.statusForecast"),
        ui: "status eq 'forecast' or status eq 'preview'"
      }
    ], this.getItemDataReader = (l) => ({
      /** Function to read data into given array */
      read: (o, c) => (l.isReading = !0, this.api.getSingle(l.id).then((d) => (d && o.push(d), l.isReading = !1, Promise.resolve()))),
      /** Optional label for data export */
      exportLabel: null,
      /** Indicates if the export is not possible */
      disabled: () => !1
    });
  }
  /**
   * Initializes the controller
   */
  $onInit() {
    super.$onInit();
  }
  /** Gets the default channel for the current account. */
  get defaultChannel() {
    return this.invoicesService.defaultChannel;
  }
  /** Implements the getDefaults of ApiCrudObjectController */
  getDefaults() {
    return {
      listUrl: this.listUrl || "invoices",
      detailsUrl: this.detailsUrl || "/invoices/details/",
      oDataTemplateUrl: "salaxy-components/odata/lists/InvoicesPanel.html",
      oDataOptions: {}
    };
  }
  /** Gets the type of the due date vs. the current date and status for display purposes. */
  getDueDateType(t) {
    if (t.entityType === "unemployment")
      return "estimation";
    switch (t.status) {
      case Ft.Canceled:
        return "canceled";
      case Ft.Forecast:
      case Ft.Preview:
        return t.endAt > I.getToday() ? "future" : "default";
      case Ft.Undefined:
      case Ft.Unread:
        return t.endAt < I.getToday() ? "overdue" : "default";
      case Ft.Read:
      case Ft.WaitingConfirmation:
      case Ft.WaitingPalkkaus:
      case Ft.Paid:
      case Ft.PaymentStarted:
        return "default";
    }
    return "default";
  }
  /** For list components, gets the OData query options. */
  getListOptions() {
    return this.uiHelpers.cache(this, "listOptions", () => this.mode === "panel" ? {
      $filter: "",
      $top: 5,
      $orderby: "endAt desc"
    } : {
      $orderby: "endAt desc"
    });
  }
  /** Returns content url for the invoice. */
  getContentUrl(t, e = !1) {
    return this.invoicesApi.getContentUrl(t, e);
  }
  /**
   * Request the status update for the invoice.
   * @param status Status data. If not set, uses the requestedStatus property of the controller.
   */
  requestStatusUpdate(t = null) {
    if (t = t || this.requestedStatus, t === Ft.Paid && (this.current.header.channel === At.Test || this.current.header.channel === At.Procountor || this.current.header.channel === At.VismaNetvisor)) {
      const e = this.uiHelpers.showLoading("Maksuikkuna avattu...");
      let a = "";
      switch (this.current.header.channel) {
        case At.Test:
          a = Ne.current.isTestData ? "https://test-integrations.salaxy.com/test#/dialogs/invoice" : "https://integrations.salaxy.com/test#/dialogs/invoice";
          break;
        case At.Procountor:
          a = Ne.current.isTestData ? "http://localhost:93/procountor/invoice.html" : "https://integrations.salaxy.com/procountor/invoice.html";
          break;
        case At.VismaNetvisor:
          a = Ne.current.isTestData ? "http://localhost:93/vismanetvisor/invoice.html" : "https://integrations.salaxy.com/vismanetvisor/invoice.html";
          break;
      }
      return a += "?invoiceIds=" + this.currentId + "&token=" + this.ajax.getCurrentToken(), this.uiHelpers.showExternalDialog("invoiceCreation", a, {}).then(() => (e.dismiss(), this.setStatus(this.api.getSingle(this.current.id)).then((n) => (n && this.setCurrent(n), n))));
    } else
      return this.setStatus(this.invoicesApi.requestStatusUpdate(this.currentId, t).then((e) => (e && this.setCurrent(e), e)));
  }
  /** Requested status for binding */
  get requestedStatus() {
    return this.current ? this.current.header.requestedStatus || this.current.header.status : null;
  }
  /** Requested status for binding */
  set requestedStatus(t) {
    this.current.header.requestedStatus = t;
  }
  /**
   * Delete invoice and related business objects (calculations and payrolls)
   * @param item  - Invoice to delete.
   * @param confirmMessage - Optional message for confirm popup
   */
  deleteWithBusinessObjects(t, e) {
    return t = t || this.current, this.uiHelpers.showConfirm(e || "Haluatko varmasti poistaa tämän laskun ja siihen liittyvät laskelmat ja palkkalistat?").then((a) => a ? this.ajax.remove(`/accounts/invoice?ids=${t.id}`).then(() => (this.current === t && this.setCurrent(null), this.odataController ? this.odataController.reload() : this.$location.url(this.getDefaults().listUrl), !0)) : Promise.resolve(!1));
  }
  /** Unselect all */
  unselectAll() {
    this.odataController.selectedItems && this.odataController.selectedItems.splice(0, this.odataController.selectedItems.length);
  }
  /** Select all */
  selectAll() {
    this.odataController.selectedItems && this.odataController.items && (this.odataController.selectedItems.splice(0, this.odataController.selectedItems.length), this.odataController.selectedItems.push(...this.odataController.items));
  }
  /** Open PaymentDialog for selected row */
  showPaymentDialog(t) {
    this.invoicesService.showPaymentDialogForCalculation(t);
  }
  /** Get invoices calculation by id */
  getReportCalcs() {
    const t = this.current.header.businessObjects[0];
    return this._calcOrPayrollId.includes(t) || (this._calcOrPayrollId.push(t), new nm(this.ajax).getSingle(t).then((a) => {
      a ? (this._reportCalcs.splice(0, this._reportCalcs.length), this._reportCalcs.push(a)) : this.current.header.type === ce.Gross && new Cw(this.ajax).getOData({ $filter: `id eq '${this.current.header.businessObjects[0]}'` }).then((i) => {
        i.items[0] && i.items[0].businessObjects.length && new nm(this.ajax).getMulti(i.items[0].businessObjects).then((l) => {
          this._reportCalcs.splice(0, this._reportCalcs.length), this._reportCalcs.push(...l);
        });
      });
    })), this._reportCalcs;
  }
};
oS.$inject = [
  "Invoices",
  "UiHelpers",
  "$location",
  "$routeParams",
  "InvoicesService",
  "AjaxNg1",
  "Calculations",
  "Payrolls"
];
let Cr = oS;
const cS = class cS extends Cr {
  constructor(t, e, a, n, i, r, l, o, c, d, p) {
    super(t, e, a, n, i, r), this.invService = i, this.sepaAjax = r, this.session = l, this.$http = o, this.$timeout = c, this.$sce = d, this.$scope = p, this.groupedItems = [], this.queryYear = I.getToday(), this.selectedInvoices = [], this.invoiceEntityTypes = [
      { label: L.get("SALAXY.NG1.InvoicesComponent.all"), value: "all" },
      { label: L.get("SALAXY.ENUM.InvoiceType.net.label"), value: "net" },
      { label: L.get("SALAXY.ENUM.InvoiceType.pension.label"), value: "pension" },
      { label: L.get("SALAXY.ENUM.InvoiceType.tax.label"), value: "tax" },
      { label: L.get("SALAXY.ENUM.InvoiceType.unemployment.label"), value: "unemployment" },
      { label: L.get("SALAXY.ENUM.InvoiceType.union.label"), value: "union" },
      { label: L.get("SALAXY.ENUM.InvoiceType.payroll.label"), value: "payroll" }
    ], this.invoiceEntityType = this.invoiceEntityTypes.find((h) => h.value === "all"), this.statusFilters = [
      {
        value: "all",
        text: L.get("SALAXY.NG1.InvoicesComponent.statusAll"),
        ui: ""
      },
      {
        value: "read",
        text: "Käsittelyssä olevat",
        ui: "status eq 'read'"
      },
      {
        value: "unread",
        text: "Uudet maksut",
        ui: "status eq 'unread'"
      },
      {
        value: "paid",
        text: "Maksetut",
        ui: "status eq 'paid'"
      },
      {
        value: "canceled",
        text: "Perutut",
        ui: "status eq 'canceled'"
      },
      {
        value: "forecast",
        text: L.get("SALAXY.NG1.InvoicesComponent.statusForecast"),
        ui: "status eq 'forecast' or status eq 'preview'"
      }
    ], this.statusFilter = this.statusFilters.find((h) => h.value === "all"), this.currentTab = "netpaymentsandforeclosure", this.paymentChannelConfig = null, this.sortMode = "desc", this.otherPartyNameFilter = "", this.referenceFilter = "", this.ibanFilter = "", this.qrCodesCache = {}, this.rowActionsCache = {}, this.rowGroupActionsCache = {}, this.filterInvoices = (h) => !(this.invoiceEntityType.value !== "all" && h.entityType !== this.invoiceEntityType.value || this.statusFilter.value !== "all" && h.status !== this.statusFilter.value || this.otherPartyNameFilter && !h.otherPartyInfo?.avatar?.displayName?.toLowerCase().includes(this.otherPartyNameFilter.toLowerCase()) || this.referenceFilter && !h.reference?.toLowerCase().includes(this.referenceFilter.toLowerCase()) || this.ibanFilter && !h.otherPartyInfo?.ibanNumber?.toLowerCase().includes(this.ibanFilter.toLowerCase())), this.getGroupItemDataReader = (h, g, x = null) => ({
      /** Function to read data into given array */
      read: (b, A) => (() => {
        const R = this.getEprWarning([h], g);
        return R ? this.uiHelpers.showConfirm("Huomioi palkkatietoilmoitukset!", R) : Promise.resolve(!0);
      })().then((R) => {
        if (R)
          return h["isReading" + (g || "")] = !0, this.getInvoice(h, A, g).then((C) => {
            C && b.push(C), h["isReading" + (g || "")] = !1;
          });
      }),
      getSepaData: (b) => this.getSepaData(b, null, x),
      getFinvoiceData: (b) => this.getFinvoiceData(b),
      getPdfData: (b) => this.getPdfData(b),
      /** Optional label for data export */
      exportLabel: null,
      /** Indicates if the export is not possible */
      disabled: () => !1
    });
  }
  /** URL for the OData list service, null for preventing automatic initial load */
  get odataServiceUrl() {
    return null;
  }
  /** Intitializes the controller */
  $onInit() {
    this.paymentChannel ?? (this.paymentChannel = this.invService.defaultPaymentListChannel), super.$onInit(), this.$scope.$on("tabButtonsControllerReady", (t, e) => {
      this.tabButtonsCtrl = e.ctrl;
    }), this.companyAccount = this.session.getCompanyAccount(), this.loadData();
  }
  /**
   * Selects and shows a tab in the payroll details view
   */
  selectTab(t) {
    this.tabButtonsCtrl.showTab(t);
  }
  /**
   * Loads the data for the controller.
   */
  loadData(t = !0) {
    let e;
    t && (e = this.uiHelpers.showLoading("SALAXY.UI_Terms.loading")), this.loadAllInvoices().then((a) => {
      console.log(a), this.setPaymentChannelConfig(), this.updategroupedItems(a), t && e.dismiss(), this.$timeout();
    });
  }
  /**
   * Checks if multi-select functionality is supported by the current payment channel configuration
   * @returns True if multi-select is supported, false otherwise
   */
  supportItemMultiSelect() {
    return !!this.paymentChannelConfig?.multiSelectAction;
  }
  /**
   * Checks if the current payment channel configuration supports system messages
   * @returns True if system messages are supported, false otherwise
   */
  hasSystemMessagesEnabled() {
    return !!this.paymentChannelConfig?.hasSystemMessagesEnabled;
  }
  /**
   * Checks if a given invoice item is currently selected
   * @param item The invoice item to check
   * @returns True if the item is in the selectedInvoices array, false otherwise
   */
  isSelected(t) {
    return this.selectedInvoices.findIndex((e) => e.id === t.id) >= 0;
  }
  /**
   * Sets the selected state of an invoice item
   * @param item The invoice item to select/unselect
   * @param value True to select, false to unselect, "toggle" to toggle selection state
   */
  setSelected(t, e = !0) {
    const a = this.selectedInvoices.findIndex((i) => i.id === t.id), n = a >= 0;
    switch (n && this.selectedInvoices.splice(a, 1), e) {
      case !0:
        this.selectedInvoices.push(t);
        break;
      case !1:
        break;
      case "toggle":
        n || this.selectedInvoices.push(t);
        break;
    }
  }
  /**
   * Sets the payment channel configuration based on the current payment channel.
   * This method calls getPaymentChannelConfig() to get the appropriate configuration
   * and assigns it to the paymentChannelConfig property.
   */
  setPaymentChannelConfig() {
    this.paymentChannelConfig = this.getPaymentChannelConfig();
  }
  /**
   * Gets the payment channel configuration based on the current payment channel.
   * @returns A configuration object containing row actions for invoice items.
   * Currently only handles PaymentChannel.PalkkausManual channel.
   * For PalkkausManual channel, returns an object with:
   * - rowActions: Function that returns an array of actions available for an invoice item
   * - For unread/read status: Adds "Merkitse maksetuiksi" (Mark as paid) action
   * - For unread/read/paid status: Adds "Peru lasku" (Cancel invoice) action
   * - Actions are cached by invoice ID and status
   * Each action has:
   * - text: Display text for the action
   * - onClick: Handler function that shows confirmation dialog and updates invoice status
   */
  getPaymentChannelConfig() {
    const t = (e, a) => {
      const n = a === Ft.Canceled ? "Laskut perutaan" : "Laskut siirretään maksuun", i = a === Ft.Canceled ? "Lasku perutaan" : "Siirretään maksuun...";
      return this.uiHelpers.showConfirm("HUOM", n).then((r) => {
        if (r) {
          const l = this.uiHelpers.showLoading(i);
          return Promise.all(e.map((o, c) => (l.setText(`${c}/${e.length}`), this.api.requestStatusUpdate(o, a)))).then(() => this.uiHelpers.wait().then(() => {
            this.loadData(!1), this.setPaymentChannelConfig(), l.dismiss();
          }));
        }
      });
    };
    switch (this.paymentChannel) {
      case At.Hausvise:
        return {
          hasSystemMessagesEnabled: !1,
          rowActions: (e) => {
            const a = `${e.id}-${e.status}`;
            if (this.rowActionsCache[a])
              return this.rowActionsCache[a];
            const n = [], i = [Ft.Unread, Ft.Read], r = [Ft.Unread, Ft.Read, Ft.Paid], l = (d) => d.entityType !== ce.Payroll, o = (d) => d.entityType !== ce.Payroll, c = (d, p, h) => this.uiHelpers.showConfirm("HUOM", h).then((g) => {
              if (g) {
                const x = this.uiHelpers.showLoading("Päivitetään laskun tilaa...");
                return this.api.requestStatusUpdate(d.id, p).then(() => this.uiHelpers.wait().then(() => {
                  this.loadData(!1), x.dismiss();
                }));
              }
            });
            return l(e) && i.includes(e.status) && n.push({
              text: "Merkitse maksetuiksi",
              onClick: (d) => c(d, Ft.Paid, "Merkitse maksetuksi vain, jos olet maksanut laskun muulla tavalla kuin Hausvisessa")
            }), o(e) && r.includes(e.status) && n.push({
              text: "Peru lasku",
              onClick: (d) => c(d, Ft.Canceled, "Peru lasku vain, jos Hausvise ei poikkeuksellisesti pysty käsittelemään laskua")
            }), this.rowActionsCache[a] = n, n;
          },
          groupingFunction: (e) => {
            const a = [];
            return e.forEach((n) => {
              if (n.entityType === ce.Net || n.entityType === ce.Foreclosure || n.entityType === ce.Payroll)
                if (n.data.payrollId) {
                  const i = n.data.payrollId;
                  let r = a.find((l) => l.id === i);
                  r || (r = {
                    id: i,
                    businessObjectId: i,
                    groupType: "payroll",
                    title: n.data.payrollTitle,
                    sortableDate: n.data.dueDate,
                    invoices: []
                  }, a.push(r)), r.invoices.push(n);
                } else {
                  let i = a.find((r) => r.id === n.businessObjects[0]);
                  i || (i = {
                    id: n.businessObjects[0],
                    businessObjectId: n.businessObjects[0],
                    groupType: "calculation",
                    title: "Palkkalaskelma",
                    sortableDate: n.data.dueDate,
                    invoices: []
                  }, a.push(i)), i.invoices.push(n);
                }
              if (n.entityType === ce.Tax || n.entityType === ce.Union || n.entityType === ce.Unemployment || n.entityType === ce.Pension) {
                const i = I.getYear(n.logicalDate) + "-" + I.getMonth(n.logicalDate);
                let r = a.find((l) => l.id === i);
                r || (r = {
                  id: i,
                  groupType: "monthly",
                  title: `${L.get(`SALAXY.ENUM.CalendarMonth.month${I.getMonth(n.logicalDate)}.label`)} ${I.getYear(n.logicalDate)}`,
                  sortableDate: n.data.dueDate,
                  invoices: []
                }, a.push(r)), r.invoices.push(n);
              }
            }), a.filter((n) => n.groupType === "monthly").forEach((n) => {
              n.invoices.sort((i, r) => i.data.dueDate.localeCompare(r.data.dueDate));
            }), a;
          }
        };
      case At.PalkkausPSD: {
        const e = (a) => {
          const n = {
            banks: [
              {
                id: "OSUUSPANKKI_MOCK",
                name: "Osuuspankki Mock (hyväksyy maksut automaattisesti)",
                logo: "https://cdn.salaxy.com/img/salaxy/sign/op.png"
              },
              {
                id: "OSUUSPANKKI_TEST",
                name: "Osuuspankki Test (tunnistautuminen)",
                logo: "https://cdn.salaxy.com/img/salaxy/sign/op.png"
              },
              {
                id: "NORDEA_MOCK",
                name: "Nordea Test Mock (hyväksyy maksut automaattisesti)",
                logo: "https://cdn.salaxy.com/img/salaxy/sign/nordea.png"
              },
              {
                id: "NORDEA_TEST",
                name: "Nordea Test (tunnistautuminen ei toimi, jää kesken)",
                logo: "https://cdn.salaxy.com/img/salaxy/sign/nordea.png"
              },
              {
                id: "NORDEA_PERSONAL_TEST",
                name: "Nordea Personal Test (Hylkää maksut pankin puolelta)",
                logo: "https://cdn.salaxy.com/img/salaxy/sign/nordea.png"
              },
              {
                id: "INVALID_BANK_TEST",
                name: "Invalid Bank (Tekninen virhe tapahtuu ja ruudulle tulee virhe)",
                logo: "https://cdn.salaxy.com/img/salaxy/sign/invalid.png"
              }
            ],
            selectedBank: null,
            forceAccountAuthorization: !1,
            selectBank: (i) => {
              n.selectedBank = i;
            }
          };
          this.uiHelpers.openEditDialog("salaxy-components/modals/payment/psd/BankSelection.html", null, n).then((i) => {
            if (i.action === "ok") {
              const r = i.logic.selectedBank, l = i.logic.forceAccountAuthorization, o = `${this.sepaAjax.getServerAddress()}/psdPayment/payInvoices?forceAccountAuthorization=${l}&ids=${a}&bank=${r}&successurl=&access_token=${this.sepaAjax.getCurrentToken()}`, c = this.uiHelpers.showLoading("Avataan pankkimaksua..."), d = () => {
                c.dismiss();
              };
              this.uiHelpers.showExternalDialog("psdDialog", o, null, null, null, d).then((p) => {
                const h = this.uiHelpers.showLoading();
                p.action == "user-cancel" ? this.uiHelpers.showDialog("salaxy-components/modals/payment/PaymentCancel.html").then(() => {
                  this.uiHelpers.wait().then(() => {
                    this.loadData(!1), h.dismiss();
                  });
                }) : p.action == "invoice-paid" ? this.uiHelpers.showAlert(L.get("Maksu"), L.get("Lasku(t) on jo maksettu.") + ".").then(() => {
                  this.uiHelpers.wait().then(() => {
                    this.loadData(!1), h.dismiss();
                  });
                }) : p.action == "invoice-missing" ? this.uiHelpers.showAlert(L.get("Maksua ei voitu luoda"), L.get("Maksua ei voitu luoda. Tarkista, onko laskelma/palkkalista jo maksettu") + ".").then(() => {
                  this.uiHelpers.wait().then(() => {
                    this.loadData(!1), h.dismiss();
                  });
                }) : p.action == We.Ok && this.uiHelpers.showDialog("salaxy-components/modals/payment/PaymentConfirm.html").then(() => {
                  this.uiHelpers.wait().then(() => {
                    this.loadData(!1), h.dismiss();
                  });
                });
              });
            }
          });
        };
        return {
          hasSystemMessagesEnabled: !0,
          rowGroupActions: (a) => {
            a.invoices.sort((l, o) => (o.payment ?? 0) - (l.payment ?? 0));
            const n = `${a.id}-${a.businessObjectId}-${this.paymentChannel}-${a.invoices.map((l) => l.status).join()}`;
            if (this.rowGroupActionsCache[n])
              return this.rowGroupActionsCache[n];
            const i = [];
            return a.invoices.some((l) => l.status === Ft.Paid || l.status === Ft.Canceled || l.status === Ft.Read) || (i.push({
              text: "Maksa laskuryhmä",
              onClick: (l) => e(l.invoices.map((o) => o.id).join(","))
            }), i.push({
              text: "Peru laskuryhmä",
              onClick: (l) => t(l.invoices.map((o) => o.id), Ft.Canceled)
            })), this.rowGroupActionsCache[n] = i, i;
          },
          groupingFunction: (a) => {
            const n = [];
            return a.forEach((i) => {
              if (i.entityType === ce.Net || i.entityType === ce.Foreclosure || i.entityType === ce.Union || i.entityType === ce.Tax || i.entityType === ce.Payroll)
                if (i.data.payrollId) {
                  const r = i.data.payrollId;
                  let l = n.find((o) => o.id === r);
                  l || (l = {
                    id: r,
                    businessObjectId: r,
                    groupType: "payroll",
                    title: i.data.payrollTitle,
                    sortableDate: i.data.dueDate,
                    invoices: []
                  }, n.push(l)), l.invoices.push(i);
                } else {
                  let r = n.find((l) => l.id === i.businessObjects[0]);
                  r || (r = {
                    id: i.businessObjects[0],
                    businessObjectId: i.businessObjects[0],
                    groupType: "calculation",
                    title: "Palkkalaskelma",
                    sortableDate: i.data.dueDate,
                    invoices: []
                  }, n.push(r)), r.invoices.push(i);
                }
              if (i.entityType === ce.Unemployment || i.entityType === ce.Pension) {
                const r = I.getYear(i.logicalDate) + "-" + I.getMonth(i.logicalDate);
                let l = n.find((o) => o.id === r);
                l || (l = {
                  id: r,
                  groupType: "monthly",
                  title: `${L.get(`SALAXY.ENUM.CalendarMonth.month${I.getMonth(i.logicalDate)}.label`)} ${I.getYear(i.logicalDate)}`,
                  sortableDate: i.data.dueDate,
                  invoices: []
                }, n.push(l)), l.invoices.push(i);
              }
            }), n.filter((i) => i.groupType === "monthly").forEach((i) => {
              i.invoices.sort((r, l) => r.data.dueDate.localeCompare(l.data.dueDate));
            }), n;
          }
        };
      }
      case At.PalkkausWS:
        return {
          hasSystemMessagesEnabled: !0,
          multiSelectAction: () => ({
            text: "Siirrä valitut laskut maksuun",
            onClick: () => t(this.selectedInvoices.map((e) => e.id), Ft.Unread)
          }),
          rowActions: (e) => {
            const a = `${e.id}-${e.status}-${this.paymentChannel}`;
            if (this.rowActionsCache[a])
              return this.rowActionsCache[a];
            const n = [];
            return e.status !== Ft.Paid && e.status !== Ft.Canceled && (n.push({
              text: "Siirrä maksuun",
              onClick: (i) => t([i.id], Ft.Unread)
            }), n.push({
              text: "Peru lasku",
              onClick: (i) => t([i.id], Ft.Canceled)
            })), this.rowActionsCache[a] = n, n;
          },
          groupingFunction: (e) => {
            const a = [];
            return e.forEach((n) => {
              if (n.entityType === ce.Net || n.entityType === ce.Foreclosure)
                if (n.data.payrollId) {
                  const i = n.data.payrollId;
                  let r = a.find((l) => l.id === i);
                  r || (r = {
                    id: i,
                    businessObjectId: i,
                    groupType: "payroll",
                    title: n.data.payrollTitle,
                    sortableDate: n.data.dueDate,
                    invoices: []
                  }, a.push(r)), r.invoices.push(n);
                } else
                  a.push(
                    {
                      id: n.id,
                      businessObjectId: n.businessObjects[0],
                      groupType: "calculation",
                      title: "Palkkalaskelma",
                      sortableDate: n.data.dueDate,
                      invoices: [n]
                    }
                  );
              if (n.entityType === ce.Tax || n.entityType === ce.Union || n.entityType === ce.Unemployment || n.entityType === ce.Pension) {
                const i = I.getYear(n.logicalDate) + "-" + I.getMonth(n.logicalDate);
                let r = a.find((l) => l.id === i);
                r || (r = {
                  id: i,
                  groupType: "monthly",
                  title: `${L.get(`SALAXY.ENUM.CalendarMonth.month${I.getMonth(n.logicalDate)}.label`)} ${I.getYear(n.logicalDate)}`,
                  sortableDate: n.data.dueDate,
                  invoices: []
                }, a.push(r)), r.invoices.push(n);
              }
            }), a.filter((n) => n.groupType === "monthly").forEach((n) => {
              n.invoices.sort((i, r) => i.data.dueDate.localeCompare(r.data.dueDate));
            }), a;
          }
        };
      default:
        return null;
    }
  }
  /**
   * Gets the grouped invoice items filtered and sorted based on the current tab.
   * @returns An array of grouped invoice items, filtered and sorted by date.
   * For the "netpaymentsandforeclosure" tab, returns only net payments and foreclosures.
   * For the "monthlypayments" tab, returns only monthly payments like tax, union etc.
   * Returns empty array if no grouped items exist or for unknown tabs.
   */
  getGroupedItems() {
    if (!this.groupedItems)
      return [];
    const t = (e, a) => (this.sortMode === "asc" ? 1 : -1) * e.sortableDate.localeCompare(a.sortableDate);
    switch (this.currentTab) {
      case "netpaymentsandforeclosure":
        return this.groupedItems.filter((e) => e.groupType === "payroll" || e.groupType === "calculation").sort(t);
      case "monthlypayments":
        return this.groupedItems.filter((e) => e.groupType === "monthly").sort(t);
      default:
        return [];
    }
  }
  /**
   * Toggles the sort mode between ascending and descending.
   * This affects the order of grouped items when displayed.
   */
  changeSortMode() {
    this.sortMode = this.sortMode === "asc" ? "desc" : "asc";
  }
  /**
   * Updates the grouped items based on the provided invoice list items.
   * Groups net payments and foreclosures by payroll or calculation.
   * Groups monthly payments (tax, union, unemployment, pension) by month.
   * @param items List of invoice items to group
   */
  updategroupedItems(t) {
    this.groupedItems = [], this.groupedItems = this.paymentChannelConfig?.groupingFunction(t) ?? [];
  }
  /**
   * Loads all invoices from the server.
   * @returns Promise of all invoices
   */
  async loadAllInvoices() {
    const t = [], e = (a = null) => {
      let n = { $filter: `data/channel eq '${this.paymentChannel}' and endAt ge ${I.getYear(this.queryYear)}-01-01 and endAt le ${I.getYear(this.queryYear)}-12-31`, $orderby: "endAt desc" };
      const i = a?.indexOf("?") ?? -1;
      if (i >= 0) {
        const r = new URLSearchParams(a.substr(i));
        r.get("$skip") && (n = { $skip: Number(r.get("$skip")), $filter: `data/channel eq '${this.paymentChannel}' and endAt ge ${I.getYear(this.queryYear)}-01-01 and endAt le ${I.getYear(this.queryYear)}-12-31`, $orderby: "endAt desc" });
      }
      return this.invoicesApi.getOData(n).then((r) => (t.push(...r.items), r.nextPageLink ? e(r.nextPageLink) : null));
    };
    return e().then(() => t);
  }
  /**
   * Shows a dialog for a single invoice.
   * @param item Invoice item.
   */
  showInvoiceDialog(t) {
    this.uiHelpers.openEditDialog("salaxy-components/modals/invoices/invoice-payment-list-dialog.html", t, { parent: this }, "lg");
  }
  /**
   * Returns PDF url for a single invoice.
   * @param item Invoice list item.
   */
  getPdfUrl(t) {
    return t.pdfUrl || (t.pdfUrl = this.api.getContentUrl(t.id, !1)), t.pdfUrl;
  }
  /**
   * Retrieves the QR code for the specified invoice item.
   * If the QR code is not already cached, it generates the QR code and caches it for future use.
   * @param item - The invoice item for which to retrieve the QR code.
   * @returns The QR code string.
   */
  getQrCode(t) {
    return this.qrCodesCache[t.id] || (this.qrCodesCache[t.id] = "loading", this.generateQrCodeSvgForInvoice(t).then((e) => e ? (this.qrCodesCache[t.id] = e, this.$timeout(), this.$sce.trustAsHtml(this.qrCodesCache[t.id])) : (this.qrCodesCache[t.id] = "error", this.$timeout(), this.qrCodesCache[t.id]))), this.qrCodesCache[t.id] === "error" ? this.qrCodesCache[t.id] : this.$sce.trustAsHtml(this.qrCodesCache[t.id]);
  }
  /**
   * Calculates barcode value for the invoice item.
   * @param item Invoice list item.
   */
  getBarcodeValue(t) {
    return tl.getValue(
      t.otherPartyInfo.ibanNumber || "",
      t.reference || "",
      I.asDate(t.data.dueDate),
      se.round(t.payment * 100, 0)
    );
  }
  /**
   * Retrieves the barcode for the invoice recipient's IBAN.
   * If the IBAN does not start with "fi" or is not provided, an empty string is returned.
   * The barcode is generated using the Barcodes.createBarcode function.
   * @returns The barcode as a string, wrapped in an HTML trust object.
   */
  getBarcode(t) {
    if (!t.otherPartyInfo.ibanNumber || !t.otherPartyInfo.ibanNumber.toLowerCase().trim().startsWith("fi"))
      return "";
    const e = () => ({ document, svgNode: document.createElementNS("http://www.w3.org/2000/svg", "svg") }), a = tl.createBarcode(
      e,
      t.otherPartyInfo.ibanNumber || "",
      t.reference || "",
      I.asDate(t.data.dueDate),
      se.round(t.payment * 100, 0),
      {
        width: 1.8,
        height: 32,
        displayValue: !0,
        fontSize: 15
      }
    );
    return a ? this.$sce.trustAsHtml(new XMLSerializer().serializeToString(a)) : "";
  }
  /** Hides bar code for forecast and preview invoice statuses*/
  hideBarCode(t) {
    return t.status === Ft.Forecast || t.status === Ft.Preview;
  }
  /**
   * Copies the barcode to clipboard.
   * @param item Invoice list item.
   */
  copyBarcode(t) {
    navigator.clipboard.writeText(this.getBarcodeValue(t));
  }
  /** Gets and avatar image for a payment channel */
  getChannelAvatar(t) {
    return ne.getChannelAvatar(t);
  }
  getInvoice(t, e, a = null) {
    const n = (i, r) => i.header.status === r ? Promise.resolve(i) : this.api.requestStatusUpdate(t.id, r);
    return this.api.getSingle(t.id).then((i) => a ? n(i, a).then((r) => (t.status = r.header.status, r)) : i);
  }
  async getPdfData(t) {
    const e = [], a = this.uiHelpers.showLoading("SALAXY.UI_Terms.loading");
    for (const [n, i] of t.entries()) {
      const r = await this.download("/v03/api/invoices/content", i, "blob");
      a.setText(`${n}/${t.length}`), e.push(r);
    }
    return a.dismiss(), e;
  }
  async getFinvoiceData(t) {
    const e = [], a = this.uiHelpers.showLoading("SALAXY.UI_Terms.loading");
    for (const [n, i] of t.entries()) {
      const r = await this.download("/v03/api/invoices/finvoice", i, "blob");
      a.setText(`${n}/${t.length}`), e.push(r);
    }
    return a.dismiss(), e;
  }
  getSepaData(t, e = null, a = null) {
    const i = `/v03/api/invoices/sepa?version=${a === "sepaFileV03" || a === "sepaCopyV03" ? "pain.001.001.03" : "pain.001.001.02"}${e ? "&payerIbanNumber=" + encodeURIComponent(e) : ""}`;
    return this.download(i, t, "text");
  }
  download(t, e, a) {
    const n = {}, i = this.sepaAjax.getCurrentToken();
    return i && (n.headers = { Authorization: "Bearer " + i }), n.url = this.sepaAjax.getServerAddress() + t, n.method = "POST", n.data = e, n.responseType = a, n.withCredentials = i ? !1 : this.sepaAjax.useCredentials, this.$http(n).then(
      (r) => r.data,
      (r) => null
    );
  }
  getEprWarning(t, e) {
    const a = (n) => {
      if (this.session.isInRole(qy.Test)) {
        const i = I.add(n ?? "today", 5, "day"), r = I.addWorkdays(i, 0);
        return I.asDate("today") > r;
      }
      return !1;
    };
    if (e === Ft.Canceled) {
      for (const n of t)
        if (n.status === Ft.Paid && n.entityType == ce.Net && a(n.logicalDate))
          return `Palkanmaksusta tehdyt tulorekisteri-ilmoitukset perutaan automaattisesti.

Jos maksat palkan uudestaan samalle palkkapäivälle, ota huomioon, että uudesta palkkatietoilmoituksesta saattaa seurata myöhästymismaksu. Haluatko varmasti perua maksut?`;
    } else if (e === Ft.Paid) {
      for (const n of t)
        if (n.status !== Ft.Paid && n.entityType == ce.Net && a(n.logicalDate))
          return "Annetulle palkkapäivälle tehtävä palkkatietoilmoitus myöhästyy, koska ilmoitus pitää tehdä 5 päivän kuluessa palkkapäivästä. Ota huomioon, että tästä saattaa seurata myöhästymismaksu. Haluatko varmasti merkitä palkan maksetuiksi?";
    }
    return null;
  }
  async generateQrCodeSvgForInvoice(t) {
    return await Jy.getValue(
      Ky.getBicForIban(t.otherPartyInfo.ibanNumber.replace(/\s+/g, "")),
      t.otherPartyInfo.avatar.displayName,
      t.otherPartyInfo?.ibanNumber,
      t.reference,
      null,
      t.payment,
      t.endAt
    );
  }
};
cS.$inject = [
  "Invoices",
  "UiHelpers",
  "$location",
  "$routeParams",
  "InvoicesService",
  "AjaxNg1",
  "SessionService",
  "$http",
  "$timeout",
  "$sce",
  "$scope"
];
let $g = cS;
const dS = class dS {
  constructor(t, e, a, n, i, r, l) {
    this.invoicesApi = t, this.invoicesService = e, this.calculationsApi = a, this.sessionService = n, this.uiHelpers = i, this.$location = r, this.ajax = l, this.invoices = [], this.userCanceled = !1, this._primaryCalcNetInvoicePreview = null, this._primaryCalcTaxInvoicePreview = null;
  }
  /**
   * Implement IController by providing onInit method.
   * We currently do nothing here, but if you override this function,
   * you should call this method in base class for future compatibility.
   */
  $onInit() {
    this.bindingMode = this.bindingMode || "null";
  }
  /**
   * Set the Current selected item (the model).
   * Currently, only Calculation or PayrollDetails is supported,
   * but we will probably support controller and url in the future.
   */
  set model(t) {
    if (this._model = t, ne.isCalculation(t) || ne.isPayroll(t))
      this._current = t, this.bindingMode = "model";
    else
      throw new Error("Not implemented: Only Calculation or PayrollDetails is currently supported.");
    this.reload();
  }
  /** Gets the Current selected item (the model). */
  get model() {
    return this._model;
  }
  /** Changes the channel */
  set channel(t) {
    ne.isCalculation(this.current) ? this.current.info.paymentChannel = t : this.current.input.paymentChannel = t, this.reload();
  }
  /** The current payment channel for user interface purposes. */
  get channel() {
    return this.current ? (ne.isCalculation(this.current) ? this.current.info.paymentChannel : this.current.input.paymentChannel) || this.invoicesService.defaultChannel : null;
  }
  /** Gets the enabled channels. */
  get allChannels() {
    return this.invoicesService.channelEnumOptions;
  }
  /** Gets the text for the Primary submit button. Null for hiding the button. */
  getOkBtn() {
    if (this.userCanceled || !this.isValid)
      return null;
    switch (this.paymentStatus) {
      case "paid":
      case "exceptions":
      case "canceled":
      case "unknown":
        return null;
      case "preview":
        return ne.isPalkkausManualLike(this.channel) && this.salaryDateKind == $n.InPast ? L.get("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.createAndMarkPaid") : ne.isPalkkausManualLike(this.channel) || this.channel === At.PalkkausWS || this.channel === At.FinagoSolo || this.channel === At.AccountorGo ? this.sessionService.isInRole("accountorService") ? null : L.get("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.createPayments") : ne.isPalkkausInvoicesLike(this.channel) ? L.get("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.createInvoices") : this.channel === At.Hausvise ? L.get("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.createPaymentMaterial") : L.get("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.sendForPayment");
      case "inProgress":
        return this.channel === At.Procountor || this.channel === At.VismaNetvisor || this.channel === At.Test ? L.get("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.checkPayment") : null;
      default:
        return !this.channel || this.channel === At.Undefined ? null : ne.isPalkkausInvoicesLike(this.channel) ? L.get("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.createInvoices") : this.channel === At.Hausvise ? L.get("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.createPaymentMaterial") : L.get("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.sendForPayment");
    }
  }
  /**
   * Intro text for the dialog.
   */
  get intro() {
    return ne.isPalkkausManualLike(this.channel) ? this.salaryDateKind == $n.InPast ? L.get("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.palkkausManualAndFixed.intro") : L.get("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.palkkausManual.intro") : L.get(`SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.${this.channel}.intro`);
  }
  /** Title for the dialog */
  get title() {
    switch (this.channel) {
      case At.PalkkausManual:
      case At.TalenomManual:
        return this.salaryDateKind == $n.InPast ? L.get("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.palkkausManualAndFixed.heading") : L.get("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.palkkausManual.heading");
      case At.PalkkausWS:
        return L.get("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.palkkausWS.heading");
      case At.PalkkausPSD:
        return L.get("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.palkkausPSD.heading");
      case At.PalkkausInvoices:
        return L.get("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.palkkausInvoices.heading");
      case At.Kitsas:
        return L.get("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.kitsas.heading");
      case At.FinagoSolo:
        return L.get("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.finagoSolo.heading");
      case At.AccountorGo:
        return L.get("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.accountorGo.heading");
      case At.Askelma:
        return L.get("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.askelma.heading");
      case At.Briox:
        return L.get("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.briox.heading");
      case At.Lemonaid:
        return L.get("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.lemonaid.heading");
      case At.Laskupiste:
        return L.get("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.laskupiste.heading");
      case At.PasseliMerit:
        return L.get("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.passeliMerit.heading");
      case At.Odoo:
        return L.get("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.odoo.heading");
      case At.Hausvise:
        return L.get("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.hausvise.heading");
      case At.Ecom:
        return L.get("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.ecom.heading");
      case At.Kompassi:
        return L.get("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.kompassi.heading");
      case At.Domus:
        return L.get("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.domus.heading");
      case At.Holvi:
        return L.get("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.holvi.heading");
      case At.TalenomOnline:
        return L.get("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.talenomOnline.heading");
      case At.PalkkausPersonal:
      default:
        return L.get("SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.loadingPayment");
    }
  }
  /** Gets the Current selected item. */
  get current() {
    return this._current;
  }
  /**
   * Returns true if the invoices have been created => the payment process has been started.
   * It may have been completed (paid), canceled or rejected.
   */
  get isStarted() {
    return ne.isPayroll(this.current) && this.current.info.status !== Ua.Draft ? !0 : !!(ne.isCalculation(this.current) && this.current.isReadOnly);
  }
  /**
   * Gets the payment status of the invoices.
   *
   * - unknown: The invoices have not been loaded from the server yet.
   * - preview: The invoices have not yet been created
   * - inProgress: Any of the invoices is in progress (WaitingPalkkaus,Unread, Read, WaitingConfirmation, PaymentStarted)
   * OR some invoices have been paid, some not (default state).
   * - canceled: One of the invoices is canceled.
   * - exceptions: Any of the invoices have exceptions (Undefined, Error)
   * - paid: All the invoices have been paid
   *
   * This is ready only after the invoices have been loaded by Preview (may be already created invoices).
   */
  get paymentStatus() {
    if (!this.invoices || this.invoices.length === 0)
      return "unknown";
    if (this.invoices.every((i) => !i.exists))
      return "preview";
    if (this.invoices.find((i) => i.invoice.status == Ft.Paid && i.invoice.entityType == "net")?.invoice.data.channel == At.PalkkausPersonal)
      return "paid";
    const e = [Ft.WaitingPalkkaus, Ft.Unread, Ft.Read, Ft.WaitingConfirmation, Ft.PaymentStarted];
    if (this.invoices.find((i) => e.indexOf(i.invoice.status) >= 0))
      return "inProgress";
    if (this.invoices.find((i) => i.invoice.status === Ft.Canceled))
      return "canceled";
    const a = [Ft.Undefined, Ft.Error];
    if (this.invoices.find((i) => a.indexOf(i.invoice.status) >= 0))
      return "exceptions";
    const n = [Ft.Paid, Ft.Forecast, Ft.Preview];
    return this.invoices.every((i) => n.indexOf(i.invoice.status) >= 0) ? "paid" : "inProgress";
  }
  /** Gets the type of current. */
  get currentType() {
    return this.current ? ne.isPayroll(this.current) ? "PayrollDetails" : ne.isCalculation(this.current) ? "Calculation" : null : null;
  }
  /** Returns true if the calculations are valid for payment. */
  get isValid() {
    return ne.isPayroll(this.current) ? this.current.info && this.current.info.isReadyForPayment : ne.isCalculation(this.current) ? this.current.result && // this.current.result.validation?.isValid &&
    !(this.current.result.validation?.errors ?? []).find((t) => t.type !== "warning") && this.current.worker && this.current.worker.tax.isValid : !1;
  }
  /** Gets and avatar image for a payment channel */
  getChannelAvatar(t) {
    const e = t.value || At.Undefined;
    return ne.getChannelAvatar(e);
  }
  /** Reloads the preview invoices from the server. */
  reload() {
    if (!(!this.channel || this.channel === At.Undefined || !this.isValid) && this.bindingMode != null) {
      if (this.bindingMode !== "model")
        throw new Error("Not implemented: Only Calculation or PayrollDetails is currently supported.");
      if (this.invoices = null, ne.isPayroll(this.current))
        if (this.current.calcs?.length > 0)
          this.invoicesApi.previewInvoices(this.channel, { payrollIds: [this.current.id] }).then((t) => {
            this.invoices = t;
          });
        else {
          const t = new Pl(this.ajax);
          t.getCalcsOData(this.current.id, null).then((e) => {
            const a = e.items, n = {};
            n.listItemType = "CalculationListItem";
            const i = void 0, r = void 0, l = (o, c) => {
              const d = o.map((g) => g.id), h = c.dialogList.filter((g) => !g.processed).length != 0;
              return t.previewInvoices(this.current.id, d, h).then((g) => {
                const x = o.map(() => ({ message: "", result: [] }));
                return x.length > 0 && (x[0].result = g), x;
              });
            };
            this.uiHelpers.showBatchProcessDialog(L.get("SALAXY.NG1.InvoicesCreateComponent.uiStatusLoading"), a, l, r, n, i, 20, !0, !0, !0).then((o) => {
              o.done ? (this.invoices = [], o.results.forEach((c) => {
                this.invoices.push(...c.result);
              })) : (this.userCanceled = !0, this.invoices = []);
            });
          });
        }
      else
        ne.isCalculation(this.current) && this.invoicesApi.previewInvoices(this.channel, { calcs: [this.current] }).then((t) => {
          this.invoices = t;
        });
    }
  }
  /** Gets the part of the UI that should be visible. */
  get uiStatus() {
    return this.userCanceled ? "userCanceled" : this.isValid ? this.paymentStatus === "unknown" ? "loading" : this.paymentStatus === "exceptions" || this.paymentStatus === "canceled" || this.paymentStatus === "inProgress" || this.paymentStatus === "paid" ? "created" : !this.channel || this.channel === At.Undefined ? "undefined" : [
      At.AccountorGo,
      At.FinagoSolo,
      At.Kevytyrittaja,
      At.Askelma,
      At.Briox,
      At.Lemonaid,
      At.Laskupiste,
      At.PasseliMerit,
      At.Odoo,
      At.Hausvise,
      At.Ecom,
      At.Kompassi,
      At.Domus,
      At.Holvi,
      At.PalkkausManual,
      At.TalenomManual,
      At.PalkkausWS,
      At.PalkkausPSD,
      At.PalkkausPersonal,
      At.PalkkausInvoices,
      At.Kitsas,
      At.Test,
      At.ZeroPayment,
      At.TalenomOnline,
      At.VismaNetvisor,
      At.Procountor
    ].find((e) => e === this.channel) ? "supportedChannel" : "unsupported" : "invalid";
  }
  /** Returns current salary date kind */
  get salaryDateKind() {
    let t;
    return ne.isPayroll(this.current) ? t = this.current.input.salaryDateKind : ne.isCalculation(this.current) && (t = this.current.workflow.salaryDateKind), t ?? $n.Default;
  }
  /**
   * Starts the invoices creation process from the current channel and model.
   * This method is used when controller is used first as previe and then creating invoices.
   */
  createInvoices(t) {
    if (!this.channel || this.channel === At.Undefined || !this.isValid)
      throw new Error("Cannot start invoices creation");
    if (!this.invoicesService.checkAccountVerificationForPayment()) {
      this.invoicesService.showMissingSignatureAlert();
      return;
    }
    if (!this.invoicesService.checkChangedSalaryDate(this.current)) {
      this.invoicesService.showChangedSalaryDateAlert();
      return;
    }
    if (ne.isEcfa(this.channel) && !this.invoicesService.checkKycForPayment()) {
      this.invoicesService.showMissingKycAlert();
      return;
    }
    const e = [Ft.WaitingPalkkaus, Ft.Read, Ft.WaitingConfirmation, Ft.PaymentStarted];
    if (ne.isPayroll(this.current))
      if (this.channel === At.Test || this.channel === At.VismaNetvisor || this.channel === At.Procountor)
        if (this.paymentStatus === "inProgress") {
          const a = this.uiHelpers.showLoading("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.paymentDialogOpened"), n = this.invoices.filter((r) => e.indexOf(r.invoice.status) >= 0).map((r) => r.invoice.id);
          let i = "";
          switch (this.channel) {
            case At.Test:
              i = Ne.current.isTestData ? "https://test-integrations.salaxy.com/test#/dialogs/payment" : "https://integrations.salaxy.com/test#/dialogs/payment";
              break;
            case At.Procountor:
              i = Ne.current.isTestData ? "http://localhost:93/procountor/payment.html" : "https://integrations.salaxy.com/procountor/payment.html";
              break;
            case At.VismaNetvisor:
              i = Ne.current.isTestData ? "http://localhost:93/vismanetvisor/payment.html" : "https://integrations.salaxy.com/vismanetvisor/payment.html";
              break;
          }
          i += "?invoiceIds=" + n + "&token=" + this.ajax.getCurrentToken(), this.uiHelpers.showExternalDialog("payrollPayment", i, {}).then(() => {
            a.dismiss(), this.$location.path("/payroll/details/" + this.current.id + "&refresh=" + (/* @__PURE__ */ new Date()).getTime()), t && t("ok");
          });
        } else {
          const a = this.uiHelpers.showLoading("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.creatingInvoices");
          this.invoicesApi.createInvoicesForPayroll(this.channel, this.current.id).then((n) => {
            a.setHeading("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.paymentDialogOpened");
            const i = n.filter((l) => l.header.status === Ft.Unread).map((l) => l.id);
            let r = "";
            switch (this.channel) {
              case At.Test:
                r = Ne.current.isTestData ? "https://test-integrations.salaxy.com/test#/dialogs/payment" : "https://integrations.salaxy.com/test#/dialogs/payment";
                break;
              case At.Procountor:
                r = Ne.current.isTestData ? "http://localhost:93/procountor/payment.html" : "https://integrations.salaxy.com/procountor/payment.html";
                break;
              case At.VismaNetvisor:
                r = Ne.current.isTestData ? "http://localhost:93/vismanetvisor/payment.html" : "https://integrations.salaxy.com/vismanetvisor/payment.html";
                break;
            }
            r += "?invoiceIds=" + i + "&token=" + this.ajax.getCurrentToken(), this.uiHelpers.showExternalDialog("payrollPayment", r, {}).then(() => {
              a.dismiss(), this.$location.path("/payroll/details/" + this.current.id + "&refresh=" + (/* @__PURE__ */ new Date()).getTime()), t && t("ok");
            });
          });
        }
      else if (this.current.calcs?.length > 0) {
        const a = this.uiHelpers.showLoading("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.creatingInvoices");
        this.invoicesApi.createInvoicesForPayroll(this.channel, this.current.id).then(() => {
          a.dismiss(), this.$location.path("/payroll/details/" + this.current.id + "&refresh=" + (/* @__PURE__ */ new Date()).getTime()), this.showInvoiceSuccessAlert(this.channel), t && t("ok");
        });
      } else {
        const a = new Pl(this.ajax);
        a.getCalcsOData(this.current.id, null).then((n) => {
          const i = n.items, r = {};
          r.listItemType = "CalculationListItem";
          const l = void 0, o = void 0, c = (d, p) => {
            const h = d.map((b) => b.id), x = p.dialogList.filter((b) => !b.processed).length != 0;
            return a.createInvoices(this.current.id, h, x).then((b) => {
              const A = d.map(() => ({ message: "", result: [] }));
              return A.length > 0 && (A[0].result = b), A;
            });
          };
          this.uiHelpers.showBatchProcessDialog(L.get("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.creatingInvoices"), i, c, o, r, l, 20, !0, !0, !0).then((d) => {
            d.done ? (this.$location.path("/payroll/details/" + this.current.id + "&refresh=" + (/* @__PURE__ */ new Date()).getTime()), this.showInvoiceSuccessAlert(this.channel), t && t("ok")) : this.userCanceled = !0;
          });
        });
      }
    else if (ne.isCalculation(this.current)) {
      const a = (n) => {
        if (n) {
          const i = n.find((r) => r.header.type === ce.Net || r.header.type === ce.Gross)?.header.businessObjects[0];
          if (i)
            return this.calculationsApi.getSingle(i).then((r) => (wt.copy(r, this.current), this.current));
        }
        return Promise.resolve(this.current);
      };
      if (this.channel === At.Test || this.channel === At.VismaNetvisor || this.channel === At.Procountor)
        if (this.paymentStatus === "inProgress") {
          const n = this.uiHelpers.showLoading("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.paymentDialogOpened"), i = this.invoices.filter((l) => e.indexOf(l.invoice.status) >= 0).map((l) => l.invoice.id);
          let r = "";
          switch (this.channel) {
            case At.Test:
              r = Ne.current.isTestData ? "https://test-integrations.salaxy.com/test#/dialogs/payment" : "https://integrations.salaxy.com/test#/dialogs/payment";
              break;
            case At.Procountor:
              r = Ne.current.isTestData ? "http://localhost:93/procountor/payment.html" : "https://integrations.salaxy.com/procountor/payment.html";
              break;
            case At.VismaNetvisor:
              r = Ne.current.isTestData ? "http://localhost:93/vismanetvisor/payment.html" : "https://integrations.salaxy.com/vismanetvisor/payment.html";
              break;
          }
          r += "?invoiceIds=" + i + "&token=" + this.ajax.getCurrentToken(), this.uiHelpers.showExternalDialog("calcPayment", r, {}).then(() => {
            a(null).then(() => {
              n.dismiss(), this.$location.path("/calc/details/" + this.current.id + "&refresh=" + (/* @__PURE__ */ new Date()).getTime());
            }), t && t("ok");
          });
        } else {
          const n = this.uiHelpers.showLoading("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.creatingInvoices");
          this.invoicesApi.createInvoices(this.current, this.channel).then((i) => {
            n.setHeading("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.paymentDialogOpened");
            let r = i.filter((o) => o.header.status === Ft.Unread).map((o) => o.id), l = "";
            switch (this.channel) {
              case At.Test:
                l = Ne.current.isTestData ? "https://test-integrations.salaxy.com/test#/dialogs/payment" : "https://integrations.salaxy.com/test#/dialogs/payment";
                break;
              case At.Procountor:
                l = Ne.current.isTestData ? "http://localhost:93/procountor/payment.html" : "https://integrations.salaxy.com/procountor/payment.html";
                break;
              case At.VismaNetvisor:
                r = i.filter((o) => o.header.paymentType === qM.Salary && o.header.status === Ft.Unread).map((o) => o.id), l = Ne.current.isTestData ? "http://localhost:93/vismanetvisor/payment.html" : "https://integrations.salaxy.com/vismanetvisor/payment.html";
                break;
            }
            l += "?invoiceIds=" + r + "&token=" + this.ajax.getCurrentToken(), this.uiHelpers.showExternalDialog("calcPayment", l, {}).then(() => {
              a(i).then(() => {
                n.dismiss(), this.$location.path("/calc/details/" + this.current.id + "&refresh=" + (/* @__PURE__ */ new Date()).getTime());
              }), t && t("ok");
            });
          });
        }
      else {
        const n = this.uiHelpers.showLoading("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.creatingInvoices");
        this.invoicesApi.createInvoices(this.current, this.channel).then((i) => {
          a(i).then(() => {
            n.dismiss(), this.current?.info?.payrollId ? this.$location.path("/payroll/details/" + this.current.info.payrollId + "&refresh=" + (/* @__PURE__ */ new Date()).getTime()) : this.$location.path("/calc/details/" + this.current.id + "&refresh=" + (/* @__PURE__ */ new Date()).getTime()), this.showInvoiceSuccessAlert(this.channel);
          }), t && t("ok");
        });
      }
    }
  }
  /**
   * Create invoices for calculation: Immediate execution without preview. Used in PRO and other advanced UI.
   * Shows a loader dialog, saves changes if necessary, creates invoices and reloads the controller.
   * @param calcController Controller that contains the calculation that should be paid. May have save changes.
   * @param channel Payment channel that is used for payment.
   */
  createInvoicesForCalculation(t, e) {
    if (!this.invoicesService.checkAccountVerificationForPayment()) {
      this.invoicesService.showMissingSignatureAlert();
      return;
    }
    if (!this.invoicesService.checkChangedSalaryDate(t.current)) {
      this.invoicesService.showChangedSalaryDateAlert();
      return;
    }
    if (ne.isEcfa(e) && !this.invoicesService.checkKycForPayment()) {
      this.invoicesService.showMissingKycAlert();
      return;
    }
    const a = this.uiHelpers.showLoading("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.creatingInvoices");
    return this.invoicesApi.createInvoices(t.current, e).then((n) => (t.reload(), a.dismiss(), this.showInvoiceSuccessAlert(e), n));
  }
  /**
   * Create invoices for payroll: Immediate execution without preview. Used in PRO and other advanced UI.
   * Shows a loader dialog, saves changes if necessary, creates invoices and reloads the controller.
   * @param payrollController Controller that contains the calculation that should be paid. May have save changes.
   * @param channel Payment channel that is used for payment.
   */
  createInvoicesForPayroll(t, e) {
    if (!this.invoicesService.checkAccountVerificationForPayment()) {
      this.invoicesService.showMissingSignatureAlert();
      return;
    }
    if (!this.invoicesService.checkChangedSalaryDate(t.current)) {
      this.invoicesService.showChangedSalaryDateAlert();
      return;
    }
    if (ne.isEcfa(e) && !this.invoicesService.checkKycForPayment()) {
      this.invoicesService.showMissingKycAlert();
      return;
    }
    const a = this.uiHelpers.showLoading("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.creatingInvoices"), n = () => this.invoicesApi.createInvoicesForPayroll(e, t.current.id).then((i) => (t.reload(), a.dismiss(), this.showInvoiceSuccessAlert(e), i));
    return t.hasChanges || t.isNew() ? t.save().then(() => n()) : n();
  }
  /** Gets text for preview invoice */
  getPreviewText(t) {
    return (t.invoice.data.channel == At.PalkkausInvoices || t.invoice.data.channel == At.Kitsas) && (t.invoice.entityType == ce.Tax || t.invoice.entityType == ce.Union || t.invoice.entityType == ce.Payroll) ? L.get("SALAXY.NG1.InvoicesCreateTableComponent.PalkkausInvoicesTaxPreviewText") : L.get("SALAXY.NG1.InvoicesCreateTableComponent.dueDateTypePreview");
  }
  /** Gets text for estimation invoice */
  getEstimationText(t) {
    return `${t.invoice.otherPartyInfo.avatar.sortableName} ${L.get("SALAXY.NG1.InvoicesCreateTableComponent.sendsInvoice")}`;
  }
  /** Gets the type of the calculation for display purposes. */
  getDueDateType(t) {
    return t.invoice.entityType === "unemployment" ? "estimation" : t.invoice.status === Ft.Forecast ? "forecast" : t.invoice.status === Ft.Preview ? "preview" : t.invoice.data.channel === At.ZeroPayment || t.invoice.status === Ft.Paid && t.invoice.payment === 0 ? "zero" : !t.invoice.otherId && t.invoice.data.channel === At.VismaNetvisor ? "preview" : t.invoice.status === Ft.Paid || ne.isPalkkausManualLike(t.invoice.data.channel) && (t.invoice.entityType === ce.Net || t.invoice.entityType === ce.Foreclosure) && this.salaryDateKind === $n.InPast || ne.isPalkkausInvoicesLike(t.invoice.data.channel) && (t.invoice.entityType === ce.Net || t.invoice.entityType === ce.Foreclosure) && this.salaryDateKind === $n.InPast ? "paid" : ne.isPalkkausInvoicesLike(t.invoice.data.channel) && (t.invoice.entityType == ce.Tax || t.invoice.entityType == ce.Union || t.invoice.entityType == ce.Payroll) ? "preview" : "default";
  }
  /**
   * Returns the net invoice preview for current calculation.
   */
  get primaryCalcNetInvoicePreview() {
    if (!this._primaryCalcNetInvoicePreview && this.invoices && this.invoices.length > 0) {
      const t = this.invoices.find((e) => e.invoice.entityType === ce.Net && e.invoice.status !== Ft.Canceled && e.invoice.status !== Ft.Error);
      t && (this._primaryCalcNetInvoicePreview = t);
    }
    return this._primaryCalcNetInvoicePreview;
  }
  /**
   * Returns the ysc invoice preview for current calculation.
   */
  get primaryCalcTaxInvoicePreview() {
    if (!this._primaryCalcTaxInvoicePreview && this.invoices && this.invoices.length > 0) {
      const t = this.invoices.find((e) => e.invoice.entityType === ce.Tax && e.invoice.status !== Ft.Canceled && e.invoice.status !== Ft.Error);
      t && (this._primaryCalcTaxInvoicePreview = t);
    }
    return this._primaryCalcTaxInvoicePreview;
  }
  getNetInvoiceId(t) {
    return !t || t.length === 0 ? null : (t.find((e) => e.header.type === ce.Net) || {}).id;
  }
  showInvoiceSuccessAlert(t) {
    t === At.ZeroPayment ? this.uiHelpers.showAlert("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.zeroPayment.successAlertHeading", "SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.zeroPayment.successAlertText") : t === At.AccountorGo ? this.uiHelpers.showAlert("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.accountorGo.successAlertHeading", "SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.accountorGo.successAlertText") : t === At.FinagoSolo ? this.uiHelpers.showAlert("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.finagoSolo.successAlertHeading", "SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.finagoSolo.successAlertText") : t === At.Kevytyrittaja ? this.uiHelpers.showAlert("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.kevytyrittaja.successAlertHeading", "SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.kevytyrittaja.successAlertText") : t === At.Askelma ? this.uiHelpers.showAlert("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.askelma.successAlertHeading", "SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.askelma.successAlertText") : t === At.Briox ? this.uiHelpers.showAlert("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.briox.successAlertHeading", "SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.briox.successAlertText") : t === At.Lemonaid ? this.uiHelpers.showAlert("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.lemonaid.successAlertHeading", "SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.lemonaid.successAlertText") : t === At.Laskupiste ? this.uiHelpers.showAlert("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.laskupiste.successAlertHeading", "SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.laskupiste.successAlertText") : t === At.PasseliMerit ? this.uiHelpers.showAlert("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.passeliMerit.successAlertHeading", "SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.passeliMerit.successAlertText") : t === At.Odoo ? this.uiHelpers.showAlert("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.odoo.successAlertHeading", "SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.odoo.successAlertText") : t === At.Hausvise ? this.uiHelpers.showAlert("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.hausvise.successAlertHeading", "SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.hausvise.successAlertText") : t === At.Ecom ? this.uiHelpers.showAlert("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.ecom.successAlertHeading", "SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.ecom.successAlertText") : t === At.Kompassi ? this.uiHelpers.showAlert("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.kompassi.successAlertHeading", "SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.kompassi.successAlertText") : t === At.Domus ? this.uiHelpers.showAlert("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.domus.successAlertHeading", "SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.domus.successAlertText").then(() => {
      window.parent.postMessage({ salaxyEvent: "InvoiceSuccessAlert" }, "*"), console.debug("Domus", "InvoiceSuccessAlert posted with postMessage");
    }) : t === At.Holvi ? this.uiHelpers.showAlert("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.holvi.successAlertHeading", "SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.holvi.successAlertText") : t === At.TalenomOnline ? this.uiHelpers.showAlert("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.talenomOnline.successAlertHeading", "SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.talenomOnline.successAlertText") : ne.isPalkkausManualLike(t) ? this.salaryDateKind == $n.InPast ? this.uiHelpers.showAlert("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.palkkausManualAndFixed.successAlertHeading", "SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.palkkausManualAndFixed.successAlertText") : this.uiHelpers.showAlert("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.palkkausManual.successAlertHeading", "SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.palkkausManual.successAlertText") : t === At.PalkkausWS ? this.uiHelpers.showConfirm(
      "SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.kitsas.successAlertHeading",
      null,
      "Maksa laskut heti",
      "Syötä lisää palkkoja",
      L.get("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.kitsas.successAlertText")
    ).then((e) => {
      e && this.$location.path("/invoices/payment-list");
    }) : t === At.PalkkausPersonal ? this.uiHelpers.showAlert("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.palkkausPersonal.successAlertHeading", "SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.palkkausPersonal.successAlertText") : t === At.PalkkausInvoices ? this.uiHelpers.showConfirm(
      "SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.palkkausInvoices.successAlertHeading",
      null,
      "SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.palkkausInvoices.successAlertOk",
      "SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.palkkausInvoices.successAlertCancel",
      L.get("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.palkkausInvoices.successAlertText")
    ).then((e) => {
      e && this.$location.path("/invoices/company");
    }) : t === At.Kitsas && this.uiHelpers.showConfirm(
      "SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.kitsas.successAlertHeading",
      null,
      "SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.kitsas.successAlertOk",
      "SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.kitsas.successAlertCancel",
      L.get("SALAXY.NG1.InvoicesCreateComponent.PaymentChannel.kitsas.successAlertText")
    ).then((e) => {
      e && this.$location.path("/invoices/company");
    });
  }
};
dS.$inject = ["Invoices", "InvoicesService", "Calculations", "SessionService", "UiHelpers", "$location", "AjaxNg1"];
let Sg = dS;
const uS = class uS extends nn {
  constructor(t, e, a, n, i, r) {
    super(new wv(null, t), e, a, n), this.ajax = t, this.sessionService = i, this.$scope = r, this.selectionDataReader = {
      /** Function to read data into given array */
      read: (l, o) => {
        const c = this.odataController.selectedItems.map((d) => this.api.getSingle(d.id));
        return Promise.all(c).then((d) => {
          l.push(...d.filter((p) => !!p));
        });
      },
      /** Optional label for data export */
      exportLabel: L.get("SALAXY.NG1.AccountingReportToolsComponent.exportLabel"),
      /** Indicates if the export is not possible */
      disabled: () => !this.odataController.selectedItems || this.odataController.selectedItems.length === 0
    }, this.getItemDataReader = (l) => ({
      /** Function to read data into given array */
      read: (o, c) => (l.isReading = !0, this.api.getSingle(l.id).then((d) => (d && o.push(d), l.isReading = !1, Promise.resolve()))),
      /** Optional label for data export */
      exportLabel: null,
      /** Indicates if the export is not possible */
      disabled: () => !1
    });
  }
  /**
   * Initialization code.
   */
  $onInit() {
    const t = () => {
      if (this.sessionService.isSessionChecked && this.sessionService.isAuthenticated) {
        const e = this.sessionService.session.currentAccount.owner;
        this._initialOwner != e && (this._initialOwner = e, this.channel = this.sessionService.getOwnedPaymentChannel(), this.reload(), this.unread = null, this.odataController && this.odataController.refreshClearAll());
      } else
        this._initialOwner = null, this.channel = null, this.api = null, this.unread = null, this.odataController && this.odataController.refreshClearAll();
    };
    t(), this.sessionService.subscribe(this.$scope, () => {
      t();
    }), super.$onInit();
  }
  /** Name/key of the channel on which the controller operates. */
  get channel() {
    return this._channel;
  }
  set channel(t) {
    this._channel = t, t && (this.api = new wv(t, this.ajax));
  }
  /** Gets the full items for unread objects. */
  get unreadInvoices() {
    return this.unread || (this.unread = [], this.paymentChannelApi.getInvoicesByStatus().then((t) => {
      this.unread = t;
    })), this.unread;
  }
  /** Implements the getDefaults of ApiCrudObjectController */
  getDefaults() {
    return {
      listUrl: this.listUrl || "payment-channel",
      detailsUrl: this.detailsUrl || "/payment-channel/details/",
      oDataTemplateUrl: "salaxy-components/odata/lists/InvoicesPanel.html",
      oDataOptions: {}
    };
  }
  /** Returns content url for the invoice. */
  getContentUrl(t, e = !1) {
    return this.paymentChannelApi.getContentUrl(t, e);
  }
  /**
   * Updates the status of the invoice.
   * @param data Status data. If not set, uses the statusData property of the controller.
   */
  updateStatus(t = null) {
    const e = this.uiHelpers.showLoading();
    return t = t || this.statusData, this.setStatus(this.paymentChannelApi.updateStatus([t]).then((a) => (e.dismiss(), this.setCurrent(a[0]), this.resetStatusData(), a[0])));
  }
  /** Resets the status data according to current Invoice. */
  resetStatusData() {
    if (!this.current) {
      this.statusData = null;
      return;
    }
    this.statusData = {
      id: this.current.id,
      externalId: this.current.header.externalId,
      date: I.getToday(),
      status: this.current.header.status,
      amount: this.current.header.total
    };
  }
  /** Gets and avatar image for a payment channel */
  getChannelAvatar() {
    return ne.getChannelAvatar(this.channel);
  }
  /** Unselect all */
  unselectAll() {
    this.odataController.selectedItems && this.odataController.selectedItems.splice(0, this.odataController.selectedItems.length);
  }
  /** Select all */
  selectAll() {
    this.odataController.selectedItems && this.odataController.items && (this.odataController.selectedItems.splice(0, this.odataController.selectedItems.length), this.odataController.selectedItems.push(...this.odataController.items));
  }
  /**
   * Updates the invoice. Only valid in the test environment.
   */
  save() {
    const t = this.uiHelpers.showLoading();
    return this.ajax.postJSON(`/v03/api/payment-channel/${this.channel}`, this.current).then((e) => (t.dismiss(), this.setCurrent(e), e));
  }
  get paymentChannelApi() {
    return this.api;
  }
};
uS.$inject = [
  "AjaxNg1",
  "UiHelpers",
  "$location",
  "$routeParams",
  "SessionService",
  "$scope"
];
let kg = uS;
const pS = class pS {
  constructor(t, e, a) {
    this.ajax = t, this.$http = e, this.uiHelpers = a, this.fileTypeId = "pdfFile", this.fileTypes = [
      {
        id: "pdfFile",
        label: L.get("SALAXY.ENUM.ExportMethod.filePdf.label"),
        workflowMessage: L.get("SALAXY.ENUM.ExportMethod.filePdf.label"),
        icon: "fa-file-pdf-o"
      },
      {
        id: "sepaFile",
        label: L.get("SALAXY.ENUM.ExportMethod.fileSepa.label"),
        workflowMessage: L.get("SALAXY.ENUM.ExportMethod.fileSepa.workflowMessage"),
        icon: "fa-file-code-o"
      },
      {
        id: "sepaFileV03",
        label: L.get("SALAXY.ENUM.ExportMethod.fileSepaV03.label"),
        workflowMessage: L.get("SALAXY.ENUM.ExportMethod.fileSepaV03.workflowMessage"),
        icon: "fa-file-code-o"
      },
      {
        id: "sepaCopy",
        label: L.get("SALAXY.ENUM.ExportMethod.copySepa.label"),
        workflowMessage: L.get("SALAXY.ENUM.ExportMethod.copySepa.workflowMessage"),
        icon: "fa-clipboard"
      },
      {
        id: "sepaCopyV03",
        label: L.get("SALAXY.ENUM.ExportMethod.copySepaV03.label"),
        workflowMessage: L.get("SALAXY.ENUM.ExportMethod.copySepaV03.workflowMessage"),
        icon: "fa-clipboard"
      },
      {
        id: "finvoiceFile",
        label: L.get("SALAXY.ENUM.ExportMethod.finvoiceFile.label"),
        workflowMessage: L.get("SALAXY.ENUM.ExportMethod.finvoiceFile.workflowMessage"),
        icon: "fa-file-code-o"
      }
    ], this._fileTypeOptions = null;
  }
  /** Filetype Enum Options for filetype select element*/
  get fileTypeOptions() {
    return this._fileTypeOptions || (this._fileTypeOptions = this.fileTypes.map((t) => ({ value: t.id, text: t.label }))), this._fileTypeOptions;
  }
  /**
   * Initialize controller values.
   */
  $onInit() {
  }
  /** Set visible filetypes. Sets the first file type as default. */
  setFileTypes(t) {
    if (t && t.length > 0) {
      const e = [];
      t.forEach((a) => {
        const n = this.fileTypes.find((i) => i.id === a);
        n && e.push(n);
      }), this.fileTypes.splice(0), this.fileTypes.push(...e), this.fileTypeId = t[0];
    }
  }
  /** Exports data in defined format. */
  export(t = null, e = !1, a = !1) {
    if (t || (t = this.reader), !t)
      return console.error("No reader for invoices."), Promise.resolve();
    const n = e ? { dismiss: () => null } : this.uiHelpers.showLoading("SALAXY.UI_Terms.wait"), i = [];
    return t.read(i, this.getWorkflowMessage()).then(() => {
      if (i.length === 0)
        return n.dismiss(), Promise.resolve();
      if (!a)
        switch (this.fileTypeId) {
          case "pdfFile":
            return (t.getPdfData ?? ((r) => this.getPdfData(r)))(i).then((r) => {
              if (r.length === 1) {
                Vn.saveAs(r[0], `${this.getFileName(i[0])}.pdf`), n.dismiss();
                return;
              } else {
                let l = 0;
                const o = new un(), c = () => {
                  l !== r.length && (o.file(`${this.getFileName(i[l])}.pdf`, r[l]), l++, c());
                };
                return c(), o.generateAsync({
                  type: "blob",
                  mimeType: "application/zip"
                }).then((d) => {
                  Vn.saveAs(d, `${this.getZipFileName(i)}.zip`), n.dismiss();
                });
              }
            });
          case "sepaFile":
          case "sepaFileV03":
            return (t.getSepaData ?? ((r) => this.getSepaData(r)))(i).then((r) => {
              Vn.saveAs(new Blob([r], { type: "text/xml;charset=utf-8" }), i.length === 1 ? `${this.getFileName(i[0])}.xml` : `${this.getZipFileName(i)}.xml`), n.dismiss();
            });
          case "sepaCopy":
          case "sepaCopyV03":
            return (t.getSepaData ?? ((r) => this.getSepaData(r)))(i).then((r) => {
              navigator.clipboard.writeText(r), n.dismiss();
            });
          case "finvoiceFile":
            return (t.getFinvoiceData ?? ((r) => this.getFinvoiceData(r)))(i).then((r) => {
              if (r.length === 1) {
                Vn.saveAs(r[0], `${this.getFileName(i[0])}.xml`), n.dismiss();
                return;
              } else {
                let l = 0;
                const o = new un(), c = () => {
                  l !== r.length && (o.file(`${this.getFileName(i[l])}.xml`, r[l]), l++, c());
                };
                return c(), o.generateAsync({
                  type: "blob",
                  mimeType: "application/zip"
                }).then((d) => {
                  Vn.saveAs(d, `${this.getZipFileName(i)}.zip`), n.dismiss();
                });
              }
            });
        }
    });
  }
  /**
   * Create single invoice.
   * @param channel Payment channel.
   * @param invoiceType Invoice type.
   * @returns New/updated invoice.
   */
  createSingleInvoice(t, e) {
    const a = this.uiHelpers.showLoading();
    return this.ajax.postJSON(`/v03/api/invoices/create/${t}/${e}?month=${I.format(/* @__PURE__ */ new Date(), "YYYY-MM-01")}`, null).then((n) => (a.dismiss(), this.uiHelpers.showAlert("Lasku luotu", "Päivitä lista.").then(() => n)));
  }
  /**
   * Returns the file type definition
   * @param fileTypeId File type id.
   */
  getFileType(t) {
    return this.fileTypes.find((e) => e.id === t);
  }
  getFileName(t) {
    return ti.escapeFileName(`${L.get("SALAXY.UI_Terms.downLoadableMaterialTypes.payment")}_${t.payer.avatar.displayName}_${t.id}`);
  }
  getZipFileName(t) {
    return ti.escapeFileName(`${L.get("SALAXY.UI_Terms.downLoadableMaterialTypes.payments")}${t[0].payer.avatar.displayName}_${I.format("today", "YYYYMMDD")}`);
  }
  getWorkflowMessage() {
    const t = this.getFileType(this.fileTypeId);
    return t ? t.workflowMessage : null;
  }
  getPdfData(t) {
    const e = t.map((a) => this.download("/v03/api/invoices/content", a, "blob"));
    return Promise.all(e);
  }
  getFinvoiceData(t) {
    const e = t.map((a) => this.download("/v03/api/invoices/finvoice", a, "blob"));
    return Promise.all(e);
  }
  getSepaData(t, e = null) {
    const n = `/v03/api/invoices/sepa?version=${this.fileTypeId === "sepaFileV03" || this.fileTypeId === "sepaCopyV03" ? "pain.001.001.03" : "pain.001.001.02"}${e ? "&payerIbanNumber=" + encodeURIComponent(e) : ""}`;
    return this.download(n, t, "text");
  }
  download(t, e, a) {
    const n = {}, i = this.ajax.getCurrentToken();
    return i && (n.headers = { Authorization: "Bearer " + i }), n.url = this.ajax.getServerAddress() + t, n.method = "POST", n.data = e, n.responseType = a, n.withCredentials = i ? !1 : this.ajax.useCredentials, this.$http(n).then(
      (r) => r.data,
      (r) => null
    );
  }
};
pS.$inject = [
  "AjaxNg1",
  "$http",
  "UiHelpers"
];
let Tg = pS;
const hS = class hS extends Cr {
  constructor(t, e, a, n, i, r, l, o, c, d) {
    super(t, e, a, n, i, r), this.invService = i, this.sepaAjax = r, this.session = l, this.$http = o, this.$timeout = c, this.$sce = d, this.queryYear = I.getToday(), this.invoiceEntityTypes = [
      { label: L.get("SALAXY.NG1.InvoicesComponent.all"), value: "all" },
      { label: L.get("SALAXY.ENUM.InvoiceType.net.label"), value: "net" },
      { label: L.get("SALAXY.ENUM.InvoiceType.pension.label"), value: "pension" },
      { label: L.get("SALAXY.ENUM.InvoiceType.tax.label"), value: "tax" },
      { label: L.get("SALAXY.ENUM.InvoiceType.unemployment.label"), value: "unemployment" },
      { label: L.get("SALAXY.ENUM.InvoiceType.union.label"), value: "union" },
      { label: L.get("SALAXY.ENUM.InvoiceType.payroll.label"), value: "payroll" }
    ], this.invoiceEntityType = this.invoiceEntityTypes.find((p) => p.value === "all"), this.statusFilter = this.statusFilters.find((p) => p.value === "waitingConfirmation"), this._allChannels = null, this.qrCodesCache = {}, this.invoiceFilter = (p) => this.statusFilter.value === "all" && this.invoiceEntityType.value === "all" ? !0 : !(this.invoiceEntityType.value !== "all" && p.invoiceType !== this.invoiceEntityType.value || {
      waitingConfirmation: [Ft.Unread, Ft.Read, Ft.WaitingConfirmation],
      paid: [Ft.Paid, Ft.PaymentStarted, Ft.Canceled],
      forecast: [Ft.Forecast, Ft.Preview]
    }[this.statusFilter.value]?.indexOf(p.status) === -1), this.getGroupDataReader = (p, h) => ({
      /** Function to read data into given array */
      read: (g, x) => (() => {
        const A = this.getEprWarning(p.invoices, h);
        return A ? this.uiHelpers.showConfirm("Huomioi palkkatietoilmoitukset!", A) : Promise.resolve(!0);
      })().then((A) => {
        if (A) {
          p["isReading" + (h || "")] = !0;
          const T = p.invoices.map((R) => () => this.getInvoice(R, x, h));
          return KM.sequence(T).then((R) => {
            g.push(...R.filter((C) => !!C)), p["isReading" + (h || "")] = !1, h && (p.status = h);
          });
        } else
          return;
      }),
      getSepaData: (g) => this.getSepaData(g),
      getFinvoiceData: (g) => this.getFinvoiceData(g),
      getPdfData: (g) => this.getPdfData(g),
      /** Optional label for data export */
      exportLabel: null,
      /** Indicates if the export is not possible */
      disabled: () => !1
    }), this.getGroupItemDataReader = (p, h) => ({
      /** Function to read data into given array */
      read: (g, x) => (() => {
        const A = this.getEprWarning([p], h);
        return A ? this.uiHelpers.showConfirm("Huomioi palkkatietoilmoitukset!", A) : Promise.resolve(!0);
      })().then((A) => {
        if (A)
          return p["isReading" + (h || "")] = !0, this.getInvoice(p, x, h).then((T) => {
            T && g.push(T), p["isReading" + (h || "")] = !1;
          });
      }),
      getSepaData: (g) => this.getSepaData(g),
      getFinvoiceData: (g) => this.getFinvoiceData(g),
      getPdfData: (g) => this.getPdfData(g),
      /** Optional label for data export */
      exportLabel: null,
      /** Indicates if the export is not possible */
      disabled: () => !1
    });
  }
  /** URL for the OData list service, null for preventing automatic initial load */
  get odataServiceUrl() {
    return null;
  }
  /** Intitializes the controller */
  $onInit() {
    this.sepaChannel ?? (this.sepaChannel = this.invService.defaultSepaChannel), super.$onInit(), this.loadData();
  }
  /**
   * Loads the data for the controller.
   */
  loadData() {
    const t = this.uiHelpers.showLoading("SALAXY.UI_Terms.loading");
    this.loadAllInvoices().then((e) => {
      this.updateGroupedItems(e), t.dismiss(), this.$timeout();
    });
  }
  /**
   * Loads all invoices from the server.
   * @returns Promise of all invoices
   */
  async loadAllInvoices() {
    const t = [], e = (a = null) => {
      let n = { $filter: `data/channel eq '${this.sepaChannel}' and endAt ge ${I.getYear(this.queryYear)}-01-01 and endAt le ${I.getYear(this.queryYear)}-12-31`, $orderby: "endAt desc" };
      const i = a?.indexOf("?") ?? -1;
      if (i >= 0) {
        const r = new URLSearchParams(a.substr(i));
        r.get("$skip") && (n = { $skip: Number(r.get("$skip")), $filter: `data/channel eq '${this.sepaChannel}' and endAt ge ${I.getYear(this.queryYear)}-01-01 and endAt le ${I.getYear(this.queryYear)}-12-31`, $orderby: "endAt desc" });
      }
      return this.invoicesApi.getOData(n).then((r) => (t.push(...r.items), r.nextPageLink ? e(r.nextPageLink) : null));
    };
    return e().then(() => t);
  }
  /**
   * Shows a dialog for a group of invoices.
   * @param group Group of invoices as defined in groupedItems.
   */
  showGroupDialog(t) {
    this.uiHelpers.openEditDialog("salaxy-components/modals/invoices/invoice-group-dialog.html", t, { parent: this }, "xl");
  }
  /**
   * Shows a dialog for a single invoice.
   * @param item Invoice item.
   */
  showInvoiceDialog(t) {
    this.uiHelpers.openEditDialog("salaxy-components/modals/invoices/invoice-dialog.html", t, { parent: this }, "xl");
  }
  /** Gets the grouped items, creating them if necessary. */
  getGroupedItems() {
    return this.groupedItems;
  }
  /** Updates the grouped items based on the ODataQueryController.  */
  updateGroupedItems(t) {
    this.groupedItems = [], t.forEach((e) => {
      const a = e.ownerId + e.entityType + e.status + e.data.dueDate + e.data.channel;
      let n = this.groupedItems.find((i) => i.id === a);
      n || (n = {
        id: a,
        ownerInfo: e.ownerInfo,
        invoiceType: e.entityType,
        status: e.status,
        dueDate: e.data.dueDate,
        payment: 0,
        channel: e.data.channel,
        invoices: []
      }, this.groupedItems.push(n)), n.payment += e.payment, n.invoices.push(e);
    });
  }
  /**
   * Returns PDF url for a single invoice.
   * @param item Invoice list item.
   */
  getPdfUrl(t) {
    return t.pdfUrl || (t.pdfUrl = this.api.getContentUrl(t.id, !1)), t.pdfUrl;
  }
  /**
   * Retrieves the QR code for the specified invoice item.
   * If the QR code is not already cached, it generates the QR code and caches it for future use.
   * @param item - The invoice item for which to retrieve the QR code.
   * @returns The QR code string.
   */
  getQrCode(t) {
    return this.qrCodesCache[t.id] || (this.qrCodesCache[t.id] = "loading", this.generateQrCodeSvgForInvoice(t).then((e) => e ? (this.qrCodesCache[t.id] = e, this.$timeout(), this.$sce.trustAsHtml(this.qrCodesCache[t.id])) : (this.qrCodesCache[t.id] = "error", this.$timeout(), this.qrCodesCache[t.id]))), this.qrCodesCache[t.id] === "error" ? this.qrCodesCache[t.id] : this.$sce.trustAsHtml(this.qrCodesCache[t.id]);
  }
  /**
   * Calculates barcode value for the invoice item.
   * @param item Invoice list item.
   */
  getBarcodeValue(t) {
    return tl.getValue(
      t.otherPartyInfo.ibanNumber || "",
      t.reference || "",
      I.asDate(t.data.dueDate),
      se.round(t.payment * 100, 0)
    );
  }
  /**
   * Retrieves the barcode for the invoice recipient's IBAN.
   * If the IBAN does not start with "fi" or is not provided, an empty string is returned.
   * The barcode is generated using the Barcodes.createBarcode function.
   * @returns The barcode as a string, wrapped in an HTML trust object.
   */
  getBarcode(t) {
    if (!t.otherPartyInfo.ibanNumber || !t.otherPartyInfo.ibanNumber.toLowerCase().trim().startsWith("fi"))
      return "";
    const e = () => ({ document, svgNode: document.createElementNS("http://www.w3.org/2000/svg", "svg") }), a = tl.createBarcode(
      e,
      t.otherPartyInfo.ibanNumber || "",
      t.reference || "",
      I.asDate(t.data.dueDate),
      se.round(t.payment * 100, 0),
      {
        width: 1.8,
        height: 32,
        displayValue: !0,
        fontSize: 15
      }
    );
    return a ? this.$sce.trustAsHtml(new XMLSerializer().serializeToString(a)) : "";
  }
  /** Hides bar code for forecast and preview invoice statuses*/
  hideBarCode(t) {
    return t.status === Ft.Forecast || t.status === Ft.Preview;
  }
  /**
   * Copies the barcode to clipboard.
   * @param item Invoice list item.
   */
  copyBarcode(t) {
    navigator.clipboard.writeText(this.getBarcodeValue(t));
  }
  /** Gets and avatar image for a payment channel */
  getChannelAvatar(t) {
    return ne.getChannelAvatar(t);
  }
  /** Update status of invoices in group using the group data reader. */
  updateInvoiceGroupStatus(t, e) {
    const a = this.uiHelpers.showLoading("Odota...");
    this.getGroupDataReader(t, e).read([], null).then(() => {
      a.dismiss();
    });
  }
  /** Update status of single invoice using the group data reader. */
  updateInvoiceGroupItemStatus(t, e) {
    const a = this.uiHelpers.showLoading("Odota...");
    this.getGroupItemDataReader(t, e).read([], null).then(() => {
      a.dismiss();
    });
  }
  /**
   * Gets all channels as avatars for drop-down.
   */
  getAllChannels() {
    if (this.session.getSession() && this._allChannels === null) {
      const t = this.session.getSession().settings;
      let e = t.paymentChannels || [];
      t.defaultPaymentChannel && (e = e.filter((a) => a !== t.defaultPaymentChannel), e.unshift(t.defaultPaymentChannel)), e.indexOf(At.ZeroPayment) < 0 && e.push(At.ZeroPayment), this._allChannels = e.map((a) => ne.getChannelAvatar(a));
    }
    return this._allChannels;
  }
  /**
   * Summs payment fields of InvoiceListImte array
   * @returns summed values
   */
  sumInvoicePayments(t) {
    let e = 0;
    return t.forEach((a) => {
      e += a.payment;
    }), e;
  }
  getInvoice(t, e, a = null) {
    const n = (i, r) => i.header.status === r ? Promise.resolve(i) : this.api.requestStatusUpdate(t.id, r);
    return this.api.getSingle(t.id).then((i) => a ? n(i, a).then((r) => (t.status = r.header.status, r)) : i);
  }
  async getPdfData(t) {
    const e = [], a = this.uiHelpers.showLoading("SALAXY.UI_Terms.loading");
    for (const [n, i] of t.entries()) {
      const r = await this.download("/v03/api/invoices/content", i, "blob");
      a.setText(`${n}/${t.length}`), e.push(r);
    }
    return a.dismiss(), e;
  }
  async getFinvoiceData(t) {
    const e = [], a = this.uiHelpers.showLoading("SALAXY.UI_Terms.loading");
    for (const [n, i] of t.entries()) {
      const r = await this.download("/v03/api/invoices/finvoice", i, "blob");
      a.setText(`${n}/${t.length}`), e.push(r);
    }
    return a.dismiss(), e;
  }
  getSepaData(t, e = null) {
    const a = `/v03/api/invoices/sepa${e ? "?payerIbanNumber=" + encodeURIComponent(e) : ""}`;
    return this.download(a, t, "text");
  }
  download(t, e, a) {
    const n = {}, i = this.sepaAjax.getCurrentToken();
    return i && (n.headers = { Authorization: "Bearer " + i }), n.url = this.sepaAjax.getServerAddress() + t, n.method = "POST", n.data = e, n.responseType = a, n.withCredentials = i ? !1 : this.sepaAjax.useCredentials, this.$http(n).then(
      (r) => r.data,
      (r) => null
    );
  }
  getEprWarning(t, e) {
    if (e === Ft.Canceled) {
      for (const a of t)
        if (a.status === Ft.Paid && a.entityType == ce.Net && this.isDelayed(a.logicalDate))
          return `Palkanmaksusta tehdyt tulorekisteri-ilmoitukset perutaan automaattisesti.

Jos maksat palkan uudestaan samalle palkkapäivälle, ota huomioon, että uudesta palkkatietoilmoituksesta saattaa seurata myöhästymismaksu. Haluatko varmasti perua maksut?`;
    } else if (e === Ft.Paid) {
      for (const a of t)
        if (a.status !== Ft.Paid && a.entityType == ce.Net && this.isDelayed(a.logicalDate))
          return "Annetulle palkkapäivälle tehtävä palkkatietoilmoitus myöhästyy, koska ilmoitus pitää tehdä 5 päivän kuluessa palkkapäivästä. Ota huomioon, että tästä saattaa seurata myöhästymismaksu. Haluatko varmasti merkitä palkan maksetuiksi?";
    }
    return null;
  }
  /** Checks if the Epr report is delayed. */
  isDelayed(t) {
    if (this.session.isInRole(qy.Test)) {
      const e = I.add(t ?? "today", 5, "day"), a = I.addWorkdays(e, 0);
      return I.asDate("today") > a;
    }
    return !1;
  }
  async generateQrCodeSvgForInvoice(t) {
    return await Jy.getValue(
      Ky.getBicForIban(t.otherPartyInfo.ibanNumber.replace(/\s+/g, "")),
      t.otherPartyInfo.avatar.displayName,
      t.otherPartyInfo?.ibanNumber,
      t.reference,
      null,
      t.payment,
      t.endAt
    );
  }
};
hS.$inject = [
  "Invoices",
  "UiHelpers",
  "$location",
  "$routeParams",
  "InvoicesService",
  "AjaxNg1",
  "SessionService",
  "$http",
  "$timeout",
  "$sce"
];
let nw = hS;
const mS = class mS {
  /**
   * Creates a new InvoiceReportController
   * @ignore
   */
  constructor(t, e, a, n) {
    this.templates = t, this.$sce = e, this.$timeout = a, this.sessionService = n, this.reportData = {
      headerFooter: {},
      layout: {},
      report: {}
    };
  }
  /**
   * Implement IController
   */
  $onInit() {
  }
  /** Bindable and trusted html. */
  get html() {
    if (!this.invoice)
      this.renderedInvoice = null, this.renderedLang = null, this.renderedApplySiteStyles = null;
    else {
      const t = wt.copy(this.invoice);
      (!this.renderedInvoice || !wt.equals(t, this.renderedInvoice) || this.renderedLang !== this.lang || this.applySiteStyles !== this.renderedApplySiteStyles) && (this.renderedApplySiteStyles = this.applySiteStyles, this.renderedInvoice = wt.copy(t), this.renderedLang = this.lang, this.getDefaultLanguage(this.lang).then((e) => {
        this.lang = e, this.renderedLang = this.lang, this.refresh();
      }));
    }
    return this.htmlData;
  }
  /** Checks if invoice is preview */
  isPreviewInvoice() {
    return [ce.Pension, ce.Unemployment].includes(
      this.invoice.header.type
    ) && [Ft.Preview, Ft.Forecast].includes(
      this.invoice.header.status
    );
  }
  /**
   * Refresh invoice report data.
   */
  async refresh() {
    if (this.refreshInprogress)
      return;
    this.refreshInprogress = !0;
    const t = this.lang ?? Me.Fi;
    await L.loadLanguage(t), this.reportData.report = await eh.getInvoice(this.invoice, this.getDocumentAndSvgNode), this.reportData.report.barcode && (this.reportData.report.barcode = new XMLSerializer().serializeToString(this.reportData.report.barcode)), this.reportOptions = eh.loadReportOptions(wt.copy(this.invoice)), this.reportData.headerFooter = eh.getHeaderFooter(this.invoice, this.reportOptions, t), this.reportData.layout = eh.loadReportLayout(!1), this.reportData.layout.hasCustomCss = !1, this.reportData.layout.customCss = "", this.reportData.layout.margin = {
      top: this.reportOptions.margin.top,
      right: this.reportOptions.margin.right,
      bottom: this.reportOptions.margin.bottom,
      left: this.reportOptions.margin.left
    };
    const e = new io();
    this.reportData.headerHtml = this.reportOptions?.headerTemplate ? e.getHtmlDynamic(this.reportOptions.headerTemplate, this.reportData.headerFooter, t) : "", this.reportData.footerHtml = this.reportOptions?.headerTemplate ? e.getHtmlDynamic(this.reportOptions.footerTemplate, this.reportData.headerFooter, t) : "", this.htmlData = this.$sce.trustAsHtml(this.templates.getHtml(this.applySiteStyles ? "invoiceTable" : "invoice", this.reportData, t)), this.refreshInprogress = !1, this.$timeout();
  }
  getDocumentAndSvgNode() {
    return { document, svgNode: document.createElementNS("http://www.w3.org/2000/svg", "svg") };
  }
  async getDefaultLanguage(t) {
    return t ? Promise.resolve(t) : this.sessionService.getReportLang();
  }
};
mS.$inject = [
  "Templates",
  "$sce",
  "$timeout",
  "SessionService"
];
let Lg = mS;
const gS = class gS extends Cr {
  constructor(t, e, a, n, i, r, l, o, c, d) {
    super(
      t,
      e,
      a,
      n,
      i,
      r
    ), this.companyAjax = r, this.session = l, this.$http = o, this.$timeout = c, this.$sce = d, this.queryMonth = I.format(I.getToday(), "YYYY-MM-01"), this.queryOptions = [
      {
        value: "unpaid",
        text: L.get(
          "SALAXY.NG1.InvoicesComponent.statusWaitingConfirmation"
        ),
        ui: () => ({
          $filter: `data/channel eq '${this.channel}' and (entityType eq '${ce.Net}' or entityType eq '${ce.Foreclosure}' or entityType eq '${ce.Tax}' or  entityType eq '${ce.Union}' or  entityType eq '${ce.Payroll}') and ( status eq '${Ft.Preview}' or status eq '${Ft.Unread}' or status eq '${Ft.Read}' or status eq '${Ft.WaitingConfirmation}')`,
          $top: void 0,
          $orderby: "endAt asc"
        })
      },
      {
        value: "paid",
        text: L.get("SALAXY.NG1.InvoicesComponent.statusPaid"),
        ui: () => ({
          $filter: `${this.dateFilterQueryOption.ui().dateFilter}data/channel eq '${this.channel}' and (entityType eq '${ce.Net}' or entityType eq '${ce.Foreclosure}' or entityType eq '${ce.Tax}' or  entityType eq '${ce.Union}' or  entityType eq '${ce.Payroll}') and ( status eq '${Ft.Paid}' or status eq '${Ft.PaymentStarted}' or status eq '${Ft.Canceled}')`,
          $top: void 0,
          $orderby: "endAt asc"
        })
      },
      {
        value: "all",
        text: L.get("SALAXY.NG1.InvoicesComponent.statusAll"),
        ui: () => ({
          $filter: `${this.dateFilterQueryOption.ui().dateFilter}data/channel eq '${this.channel}' and (entityType eq '${ce.Net}' or entityType eq '${ce.Foreclosure}' or entityType eq '${ce.Tax}' or  entityType eq '${ce.Union}' or  entityType eq '${ce.Payroll}') `,
          $top: void 0,
          $orderby: "endAt asc"
        })
      }
    ], this.queryDateFilterOptions = [
      {
        value: "default",
        text: `${I.getMonth(I.add(this.queryMonth, -1, "month"))}-${I.getMonth(I.add(this.queryMonth, 1, "month"))}/${I.getYear(this.queryMonth)}`,
        ui: () => ({
          dateFilter: `endAt ge ${I.add(
            this.queryMonth,
            -1,
            "month"
          )} and endAt le ${I.startEnd(
            I.add(this.queryMonth, 1, "month"),
            "end-month"
          )} and `
        })
      },
      {
        value: "fromStartOfYear",
        text: `${L.get("SALAXY.UI_Terms.year")} ${I.getYear(this.queryMonth)}`,
        ui: () => ({
          dateFilter: `endAt ge ${I.startEnd(
            this.queryMonth,
            "start-year"
          )} and endAt le ${I.startEnd(
            this.queryMonth,
            "end-year"
          )} and `
        })
      },
      {
        value: "all",
        text: L.get("SALAXY.NG1.InvoicesCompany.queryFilterDateAll"),
        ui: () => ({
          dateFilter: ""
        })
      },
      {
        value: "other",
        text: L.get("SALAXY.NG1.InvoicesCompany.queryFilterDateOther"),
        ui: () => ({
          dateFilter: ""
        })
      }
    ], this.queryOption = this.queryOptions[0], this.dateFilterQueryOption = this.queryDateFilterOptions[0], this.qrCodesCache = {}, this.getInvoiceReader = (p, h, g = !0) => ({
      /** Function to read data into given array */
      read: (x, b) => (() => {
        const T = this.getEprWarning([p], h);
        if (T)
          return this.uiHelpers.showConfirm(
            L.get("SALAXY.NG1.InvoicesCompany.invoiceReader.eprWarningHeading"),
            T
          );
        if (h === Ft.Canceled) {
          const R = (C) => C.entityType === "net" && C.status === Ft.Unread ? L.get("SALAXY.NG1.InvoicesCompany.invoiceReader.cancellationTexts.invoiceCancelingNetInvoiceText") : C.entityType === "tax" && C.status !== Ft.Paid ? L.get("SALAXY.NG1.InvoicesCompany.invoiceReader.cancellationTexts.invoiceCancelingTax") : L.get("SALAXY.NG1.InvoicesCompany.invoiceReader.cancellationTexts.invoiceCancelingInvoiceText");
          return this.uiHelpers.showConfirm(
            L.get("SALAXY.NG1.InvoicesCompany.invoiceReader.cancellationTexts.invoiceCancelingHeading"),
            R(p),
            L.get("SALAXY.NG1.InvoicesCompany.companyInvoiceDialog.buttons.save"),
            L.get("SALAXY.NG1.InvoicesCompany.companyInvoiceDialog.buttons.cancel")
          );
        }
        return Promise.resolve(!0);
      })().then((T) => {
        if (T)
          return p["isReading" + (h || "")] = !0, this.getInvoice(p, b, h).then((R) => {
            R && (p.data.statusAt = R.header.statusAt, p.status = R.header.status, g ? this.refreshPeriodicInvoices().then(() => {
              x.push(R);
            }) : x.push(R)), p["isReading" + (h || "")] = !1;
          });
      }),
      getSepaData: (x) => {
      },
      getFinvoiceData: (x) => {
      },
      getPdfData: (x) => {
      },
      /** Optional label for data export */
      exportLabel: null,
      /** Indicates if the export is not possible */
      disabled: () => !1
    });
  }
  /** Intitializes the controller */
  $onInit() {
    this.channel || (this.channel = At.PalkkausInvoices), super.$onInit();
  }
  /** For list components, gets the OData query options. */
  getListOptions() {
    return this.uiHelpers.cache(this, "listOptions", () => this.queryOption.ui());
  }
  /**
   * Sets the date filter query option.
   * @param option - The input enum option.
   */
  setDateFilterQueryOption(t) {
    const e = this.dateFilterQueryOption;
    if (this.dateFilterQueryOption = t, this.dateFilterQueryOption.value !== "other")
      this.doQuery();
    else {
      const a = {
        startDate: I.add(this.queryMonth, -1, "month"),
        endDate: I.add(this.queryMonth, 1, "month")
      };
      this.uiHelpers.openEditDialog(
        "salaxy-components/modals/invoices/company-invoices-date-filter-dialog.html",
        null,
        a
      ).then((n) => {
        n.action === "ok" ? (this.dateFilterQueryOption.ui = () => ({
          dateFilter: `endAt ge ${n.logic.startDate} and endAt le ${n.logic.endDate} and `
        }), this.dateFilterQueryOption.text = `Muu ${n.logic.startDate} - ${n.logic.endDate}`, this.doQuery()) : this.dateFilterQueryOption = e;
      });
    }
  }
  /** Refreshes query */
  doQuery() {
    this.odataController.setQueryOptions(this.queryOption.ui()), this.odataController.refresh();
  }
  /** Dropdown options for marking invoice as paid */
  getMarkAsPaidOptions(t) {
    return this.uiHelpers.cache(
      this,
      "markAsPaidOptions",
      () => {
        const e = [], a = (o) => t.filter(
          (c) => c.entityType === o && c.status !== Ft.Paid && c.status !== Ft.Canceled
        ), n = a(ce.Net), i = a(ce.Tax), r = a(ce.Union), l = a(ce.Foreclosure);
        return e.push({
          value: "all",
          text: L.get("SALAXY.NG1.InvoicesCompany.markAsPaidOptions.all")
        }), n.length > 0 && e.push({
          value: ce.Net,
          text: L.get("SALAXY.NG1.InvoicesCompany.markAsPaidOptions.netInvoices")
        }), i.length > 0 && e.push({
          value: ce.Tax,
          text: L.get("SALAXY.NG1.InvoicesCompany.markAsPaidOptions.taxInvoices")
        }), r.length > 0 && e.push({
          value: ce.Union,
          text: L.get("SALAXY.NG1.InvoicesCompany.markAsPaidOptions.unionInvoices")
        }), l.length > 0 && e.push({
          value: ce.Foreclosure,
          text: L.get("SALAXY.NG1.InvoicesCompany.markAsPaidOptions.foreclosureInvoices")
        }), e.push({
          value: "removeAll",
          text: L.get("SALAXY.NG1.InvoicesCompany.markAsPaidOptions.removeAll")
        }), e;
      },
      () => t.map((e) => e.id)
    );
  }
  /**
   * Selects invoices of a specific type and marks them as selected.
   * @param action - The type of invoices to select.
   */
  selectInvoicesByType(t) {
    if (t === "removeAll") {
      this.odataController.unselectAll();
      return;
    }
    if (t === "all") {
      this.odataController.selectAll();
      return;
    }
    const e = this.odataController.items.filter(
      (a) => a.entityType === t && a.status !== Ft.Paid && a.status !== Ft.Canceled
    );
    for (const a of e)
      this.odataController.setSelected(a, !0);
  }
  /**
   * Determines whether to show the "Mark as Paid" button for a given invoice.
   * @param invoice - The invoice to check.
   * @returns A boolean indicating whether to show the button.
   */
  showMarkAsPaidButton(t) {
    return t.status === Ft.Preview || t.status === Ft.Unread;
  }
  /**
   * Determines whether to show the "Mark as Canceled" button for a given invoice.
   * @param invoice - The invoice to check.
   * @returns A boolean indicating whether to show the button.
   */
  showMarkAsCanceledButton(t) {
    return t.status === Ft.Paid || t.status === Ft.Unread || t.status === Ft.Preview;
  }
  /**
   * Determines whether to show the IR cancel information text for a given invoice.
   * @param invoice - The invoice item to check.
   * @returns `true` if the invoice entity type is `Net` and the status is `Paid`, otherwise `false`.
   */
  showIrCancelInfoText(t) {
    return t.entityType === ce.Net && t.status === Ft.Paid;
  }
  /**
   * Shows a dialog for a single invoice.
   * @param item Invoice item.
   */
  showInvoiceDialog(t) {
    this.uiHelpers.openEditDialog(
      "salaxy-components/modals/invoices/company-invoice-dialog.html",
      t,
      { parent: this },
      "lg"
    ).then((e) => {
      e.action === "ok" && this.getInvoice(t, null, null).then((a) => {
        t.data.statusAt = a.header.statusAt, t.status = a.header.status, this.refreshPeriodicInvoices();
      });
    });
  }
  /**
   * Marks selected invoices as paid.
   * This method filters the selected invoices to exclude those that are already paid or canceled.
   * It then shows a loading indicator and processes each invoice by marking it as paid.
   * After processing all invoices, it refreshes the periodic invoices and dismisses the loading indicator.
   * @returns A promise that resolves when the operation is complete.
   */
  async markInvoicesAsPaid() {
    const t = this.odataController.selectedItems.filter(
      (a) => a.status != Ft.Paid && a.status != Ft.Canceled
    ), e = this.uiHelpers.showLoading(
      "SALAXY.NG1.InvoicesCompany.markingAsPaid"
    );
    for (const [a, n] of t.entries()) {
      const i = this.getInvoiceReader(n, Ft.Paid, !1);
      e.setText(`${a + 1}/${t.length}`), await i.read([], null);
    }
    await this.refreshPeriodicInvoices(), e.dismiss();
  }
  /** Update status of single invoice. */
  updateInvoiceStatus(t, e) {
    const a = this.uiHelpers.showLoading(
      e === Ft.Paid ? "SALAXY.NG1.InvoicesCompany.markingAsPaid" : "SALAXY.NG1.InvoicesCompany.markingAsCanceled"
    );
    this.getInvoiceReader(t, e).read([], null).then(() => {
      a.dismiss();
    });
  }
  /**
   * Returns PDF url for a single invoice.
   * @param item Invoice list item.
   */
  getPdfUrl(t) {
    return t.pdfUrl || (t.pdfUrl = this.getContentUrl(t.id, !1)), t.pdfUrl;
  }
  /**
   * Retrieves the QR code for the specified invoice item.
   * If the QR code is not already cached, it generates the QR code and caches it for future use.
   * @param item - The invoice item for which to retrieve the QR code.
   * @returns The QR code string.
   */
  getQrCode(t) {
    return this.qrCodesCache[t.id] || (this.qrCodesCache[t.id] = "loading", this.generateQrCodeSvgForInvoice(t).then((e) => e ? (this.qrCodesCache[t.id] = e, this.$timeout(), this.$sce.trustAsHtml(this.qrCodesCache[t.id])) : (this.qrCodesCache[t.id] = "error", this.$timeout(), this.qrCodesCache[t.id]))), this.qrCodesCache[t.id] === "error" ? this.qrCodesCache[t.id] : this.$sce.trustAsHtml(this.qrCodesCache[t.id]);
  }
  /**
   * Calculates barcode value for the invoice item.
   * @param item Invoice list item.
   */
  getBarcodeValue(t) {
    return tl.getValue(
      t.otherPartyInfo.ibanNumber || "",
      t.entityType === "net" ? "" : t.reference,
      I.asDate(t.data.dueDate),
      se.round(this.getInvoicePayment(t) * 100, 0)
    );
  }
  /**
   * Calculates the invoice payment amount for a given invoice item.
   * If the invoice item is of type "tax" or "union" and the total paid amount
   * is different from the payment amount, it returns the rounded difference
   * between the payment amount and the total paid amount.
   * Otherwise, it returns the payment amount.
   * @param {InvoiceListItem} item - The invoice item to calculate the payment for.
   * @returns {number} - The calculated payment amount.
   */
  getInvoicePayment(t) {
    return (t.entityType == "tax" || t.entityType == "union") && t.data?.totalPaid && t.data.totalPaid != t.payment ? se.round(t.payment - t.data.totalPaid) : t.payment;
  }
  /**
   * Retrieves the barcode for the invoice recipient's IBAN.
   * If the IBAN does not start with "fi" or is not provided, an empty string is returned.
   * The barcode is generated using the Barcodes.createBarcode function.
   * @returns The barcode as a string, wrapped in an HTML trust object.
   */
  getBarcode(t) {
    if (!t.otherPartyInfo.ibanNumber || !t.otherPartyInfo.ibanNumber.toLowerCase().trim().startsWith("fi"))
      return "";
    const e = () => ({
      document,
      svgNode: document.createElementNS("http://www.w3.org/2000/svg", "svg")
    }), a = tl.createBarcode(
      e,
      t.otherPartyInfo.ibanNumber || "",
      t.entityType === "net" ? "" : t.reference || "",
      I.asDate(t.data.dueDate),
      se.round(this.getInvoicePayment(t) * 100, 0),
      {
        width: 1.8,
        height: 32,
        displayValue: !0,
        fontSize: 15
      }
    );
    return a ? this.$sce.trustAsHtml(
      new XMLSerializer().serializeToString(a)
    ) : "";
  }
  /**
   * Copies the barcode to clipboard.
   * @param item Invoice list item.
   */
  copyBarcode(t) {
    navigator.clipboard.writeText(this.getBarcodeValue(t));
  }
  /**
   * Displays the PDF for the given invoice items.
   * @param items - The list of invoice items.
   */
  showloadPfd(t) {
    const e = this.uiHelpers.showLoading("SALAXY.UI_Terms.loading"), a = `${Ne.current.reportServer}/pdf?id=&reportType=${encodeURIComponent(
      "invoiceList"
    )}&template=${encodeURIComponent(
      "invoiceList"
    )}&language=${encodeURIComponent(
      L.getLanguage()
    )}&disposition=inline&access_token=${this.companyAjax.getCurrentToken()}`;
    this.handlePdfRequest(a, !1, { object: t }, e);
  }
  /**
   * Generates a URL for the calculation details of an invoice item.
   * @param item - The invoice item for which to generate the URL.
   * @returns A string representing the URL for the calculation details.
   */
  calculationHref(t) {
    return t.status == Ft.Canceled && (t.entityType == ce.Net || t.entityType == ce.Foreclosure) && t.businessObjects.length == 1 ? `#/calc/details/${t.businessObjects[0]}` : "";
  }
  getEprWarning(t, e) {
    if (e === Ft.Canceled) {
      for (const a of t)
        if (a.status === Ft.Paid && a.entityType == ce.Net && this.isDelayed(a.logicalDate))
          return L.get("SALAXY.NG1.InvoicesCompany.invoiceReader.eprWarningTextCanceled");
    } else if (e === Ft.Paid) {
      for (const a of t)
        if (a.status !== Ft.Paid && a.entityType == ce.Net && this.isDelayed(a.logicalDate))
          return L.get("SALAXY.NG1.InvoicesCompany.invoiceReader.eprWarningTextPaid");
    }
    return null;
  }
  /** Checks if the Epr report is delayed. */
  isDelayed(t) {
    if (this.session.isInRole(qy.Test)) {
      const e = I.add(t ?? "today", 5, "day"), a = I.addWorkdays(e, 0);
      return I.asDate("today") > a;
    }
    return !1;
  }
  getInvoice(t, e, a = null) {
    const n = (i, r) => i.header.status === r ? Promise.resolve(i) : this.invoicesApi.requestStatusUpdate(t.id, r);
    return this.api.getSingle(t.id).then((i) => a ? n(i, a).then(
      (r) => (t.status = r.header.status, r)
    ) : i);
  }
  async generateQrCodeSvgForInvoice(t) {
    return await Jy.getValue(
      Ky.getBicForIban(
        t.otherPartyInfo.ibanNumber.replace(/\s+/g, "")
      ),
      t.otherPartyInfo.avatar.displayName,
      t.otherPartyInfo?.ibanNumber,
      t.entityType === "net" ? null : t.reference,
      t.entityType === "net" ? `${L.get(
        `SALAXY.ENUM.InvoiceType.${t.entityType}.label`
      )} ${I.getFormattedRange(
        t.data.periodStart,
        t.data.periodEnd
      )}` : null,
      this.getInvoicePayment(t),
      t.endAt
    );
  }
  async handlePdfRequest(t, e, a, n) {
    try {
      await this.fetchPdf(t, a, e);
    } catch (i) {
      if (t.includes(Ne.current.reportServer) && Ne.current.getEnv() === "prod") {
        t = t.replace(
          Ne.current.reportServer,
          "https://failover-reports.salaxy.com"
        );
        try {
          await this.fetchPdf(t, a, e);
        } catch (r) {
          console.error(r);
        }
      } else
        console.error(i);
    }
    n && n.dismiss();
  }
  async fetchPdf(t, e, a) {
    let n;
    e ? n = await this.$http.post(t, e, { responseType: "blob" }) : n = await this.$http.get(t, { responseType: "blob" }), n.data && (a ? this.uiHelpers.openFile(n.data) : this.uiHelpers.downloadFile(
      n.data,
      decodeURIComponent(n.headers("content-disposition")).match(
        /filename\s*=\s*"?(?<file>.*?)(?:\s*;|"|\s*$)/
      )?.groups?.file
    ));
  }
  async refreshPeriodicInvoices() {
    const t = this.odataController.items.filter(
      (i) => i.entityType === ce.Tax || i.entityType === ce.Union || i.entityType === ce.Payroll || i.entityType === ce.Foreclosure
    );
    if (t.length === 0)
      return Promise.resolve([]);
    const e = t.map((i) => `id eq '${i.id}'`).join(" or "), a = this.uiHelpers.showLoading(L.get("SALAXY.NG1.InvoicesCompany.gettingsInvoices"));
    return await ((i) => new Promise((r) => setTimeout(r, i)))(3e3), this.odataController.getApi().getOData({ $filter: e }).then((i) => {
      const r = [];
      for (const l of t) {
        const o = i.items.find((c) => c.id === l.id);
        o ? wt.copy(o, l) : r.push(l);
      }
      return r.forEach((l) => {
        const o = this.odataController.items.indexOf(l);
        o > -1 && this.odataController.items.splice(o, 1);
      }), a.dismiss(), t;
    }).catch((i) => (a.dismiss(), console.error(i), t));
  }
};
gS.$inject = [
  "Invoices",
  "UiHelpers",
  "$location",
  "$routeParams",
  "InvoicesService",
  "AjaxNg1",
  "SessionService",
  "$http",
  "$timeout",
  "$sce"
];
let Dg = gS;
const yS = class yS {
  constructor(t, e) {
    this.calculationsApi = t, this.ajax = e, this.groupedPaymentChannelResult = [], this.paymentStartedWarningStartDate = I.getToday() + "Z", this.paymentStartedWarningEndDate = I.add(I.getToday(), -6, "month") + "Z";
  }
  /**
   * Implement IController
   */
  $onInit() {
    this.getOData().then((t) => {
      this.groupResultsByPaymentChannel(t);
    });
  }
  /**
   * Groups the results by payment channel and stores the unique payment channels.
   */
  groupResultsByPaymentChannel(t) {
    const e = t.reduce((a, n) => (a.includes(n.data.paymentChannel) || a.push(n.data.paymentChannel), a), []);
    this.groupedPaymentChannelResult = e;
  }
  /**
   * Retrieves a list of calculation items based on OData filters
   * This method fetches data from the calculations API or a specific OData endpoint depending on the value of the `isPro` property. It applies filters to retrieve items with a status of 'paymentStarted' and within a specified salary date range.
   */
  async getOData() {
    return this.isPro ? (this.result = await qo.getOData("/v01/api/pro/calculations/readonly", { $filter: `status eq 'paymentStarted' and ${this.getPaymentChannelFilter()} and salaryDate lt ${this.paymentStartedWarningStartDate} and salaryDate gt ${this.paymentStartedWarningEndDate}` }, this.ajax), this.result.items ?? []) : (this.result = await this.calculationsApi.getOData({
      $filter: `status eq 'paymentStarted' and ${this.getPaymentChannelFilter()} and salaryDate lt ${this.paymentStartedWarningStartDate} and salaryDate gt ${this.paymentStartedWarningEndDate}`
    }), this.result.items ?? []);
  }
  /**
   * Generates an HTML string containing payment channel information.
   * The generated HTML includes:
   * - A header with the payment channel label.
   * - A description paragraph.
   * - Instruction text specific to the payment channel.
   * - Links related to the payment channel, including calculation and payroll links if applicable.
   * - A help link to an external article.
   */
  getpaymentChannelInfoHtml(t) {
    const e = this.result.items.filter((i) => i.data.paymentChannel === t), a = () => L.get(`SALAXY.NG1.InvoiceAlertsComponent.${t}.instructionText.html`), n = () => {
      if (ne.isPalkkausManualLike(t)) {
        const i = this.getUrls();
        let r = L.get("SALAXY.NG1.InvoiceAlertsComponent.calculationLink.html", { calculationUrl: i.calculationUrl });
        return e.some((l) => l.data.payrollId) && (r += L.get("SALAXY.NG1.InvoiceAlertsComponent.payrollLink.html", { payrollUrl: i.payrollUrl })), r;
      } else {
        let i = L.get("SALAXY.NG1.InvoiceAlertsComponent.calculationLink.html", { calculationUrl: "#/calc/paid/" });
        return e.some((r) => r.data.payrollId) && (i += L.get("SALAXY.NG1.InvoiceAlertsComponent.payrollLink.html", { calculationUrl: "#/payroll/" })), i;
      }
    };
    return `
      <div class="row">
          <div class="col-12">
            <p class="lead lead-with-text">${L.get("SALAXY.NG1.InvoiceAlertsComponent.header", { channel: L.get(`SALAXY.ENUM.PaymentChannel.${t}.label`) })}</p>
            <p>${L.get("SALAXY.NG1.InvoiceAlertsComponent.description")} ${a()} ${n()}</p>
          </div>
          <div class="col-12">
            <a href="https://help.palkkaus.fi/hc/fi/articles/23187345878557-Sinulla-on-keskeneräisiä-palkkalaskelmia-ilmoitus" target="_blank">${L.get("SALAXY.NG1.InvoiceAlertsComponent.openHelp")}</a>
          </div>
      </div>
    `;
  }
  getUrls() {
    const t = window.location.href;
    return t.includes("localhost") && t.includes("/ng1/") ? { calculationUrl: "#/calc/paid", payrollUrl: "#/payroll" } : t.includes(":9001") ? { calculationUrl: "#/pro/calc-paid", payrollUrl: "#/pro/payroll-paid" } : t.includes("pro.palkkaus.fi") ? { calculationUrl: "#/pro/calc-paid", payrollUrl: "#/pro/payroll-paid" } : t.includes("palkkaus.fi/company") ? { calculationUrl: "#/calc/paid", payrollUrl: "#/payroll" } : t.includes("yritys.palkkaus.fi") ? { calculationUrl: "#/calc/paid", payrollUrl: "#/payroll" } : { calculationUrl: "", payrollUrl: "" };
  }
  getPaymentChannelFilter() {
    return `(${this.paymentChannels.map((t) => `data/paymentChannel eq '${t}'`).join(" or ")})`;
  }
};
yS.$inject = ["Calculations", "AjaxNg1"];
let Ig = yS;
const fS = class fS {
  constructor(t) {
    this.editDialogParams = t, this.$onInit = () => {
      if (!this.editDialogParams)
        throw new Error("No editDialogParams coming in.");
      this.current = this.editDialogParams.current, this.logic = this.editDialogParams.logic;
    };
  }
};
fS.$inject = ["EditDialogParameters"];
let sw = fS;
const bS = class bS {
  constructor(t) {
    this.data = t;
  }
};
bS.$inject = ["data"];
let Pg = bS;
const vS = class vS extends wr {
  /**
   * Creates a new CalcSharingController
   * @ignore
   */
  constructor(t, e, a, n, i, r, l, o, c, d) {
    super(t, e, a, n, i, r, l), this.sharingCalculationsApi = t, this.employmentsApi = o, this.onboardingService = c, this.taxcards = d, this.employingRelations = [], this.uriCopied = !1, this.webSharingTargets = {
      email: {
        title: L.get("SALAXY.NG1.CalcSharingComponent.sharingTargets.email"),
        icon: "fa-envelope-o",
        action: () => this.showEmailSharing()
      },
      whatsApp: {
        title: "WhatsApp",
        icon: "fa-whatsapp",
        getUrl: () => this.getWhatsAppUrl()
      },
      telegram: {
        title: "Telegram",
        icon: "fa-telegram",
        getUrl: () => this.getTelegramUrl()
      }
    }, this.mobileSharingTargets = {
      email: {
        title: L.get("SALAXY.NG1.CalcSharingComponent.sharingTargets.email"),
        icon: "fa-envelope-o",
        action: () => this.showEmailSharing()
      },
      device: {
        title: L.get("SALAXY.NG1.CalcSharingComponent.sharingTargets.device"),
        icon: "fa-share",
        action: () => this.shareInMobile()
      }
    }, this.isSharingType = null;
  }
  /**
   * Implement IController
   */
  $onInit() {
    super.$onInit(), this.loadEmployingRelations();
  }
  /** Show sharing page for the current calculation. */
  showSharing(t = null) {
    return ((!t || t === "default") && !this.current.isReadOnly ? this.save() : Promise.resolve(this.current)).then((a) => this.$location.url(`/calc/sharing/${a.id}${t ? "/" + t : ""}`));
  }
  /**
   * Shares the current calculation.
   * @param type Type of the sharing action or link.
   * @param employer List item for employer to share the calculation with. Mandatory in Direct share.
   * @returns Sharing object of the calculation.
   */
  share(t = Po.Undefined, e = null) {
    if (t !== Po.Undefined && !this.sessionService.checkAccountVerification())
      return this.showMissingSignatureAlert(), Promise.resolve(null);
    const a = () => t !== Po.Employer ? Promise.resolve(null) : this.createSharingMessage(e);
    return this.isSharingType = `${t}${e?.ownerId ? e.ownerId : ""}`, a().then((n) => t === Po.Employer && !n ? (this.isSharingType = null, null) : this.sharingCalculationsApi.share(this.currentId, t, e?.ownerId, n?.to, n?.cc, n?.message).then(() => (t === Po.Employer && this.uiHelpers.showAlert(L.get("SALAXY.NG1.CalcSharingComponent.emailSent") + "."), this.reload().then(() => (this.isSharingType = null, this.showDetails(this.current))))));
  }
  /**
   * Loads employing relations of the existing employers for the current account.
   * @param options OData query options.
   */
  loadEmployingRelations(t = null) {
    return this.employmentsApi.getODataForEmployingRelations(t).then((e) => {
      const a = [];
      return e.items.forEach((n) => {
        a.findIndex((i) => i.ownerId === n.ownerId) === -1 && a.push(n);
      }), this.employingRelations = a, this.employingRelations;
    });
  }
  /**
   * Returns validation for current calculation or empty validation object if the calculation has not been recalculated (validated).
   */
  get validation() {
    return this.current?.result?.validation || { errors: [], hasAllRequiredFields: !0, isValid: !0 };
  }
  /** Returns the employer for the given id using employing employers as a source */
  get employer() {
    return this.current && this.current.sharing.type === Po.Employer && this.employingRelations ? this.employingRelations.find((t) => t.ownerId === this.current.sharing.uri) : null;
  }
  /** Returns email address for current accoount */
  get cc() {
    return this.sessionService.session ? this.sessionService.session.currentAccount.contact.email : null;
  }
  /** Copies link to clipboard */
  copyUri() {
    navigator.clipboard.writeText(this.current.sharing.uri), this.uriCopied = !0;
  }
  /** Returns true if the given typing is just processing sharing */
  isSharing(t) {
    return t === this.isSharingType;
  }
  /** Returns true if the navigator.share -function exists. */
  get isMobileSharingEnabled() {
    return !!navigator.share;
  }
  /** Whatsapp-link */
  getWhatsAppUrl() {
    return this.current ? `https://wa.me/?text=${encodeURIComponent(this.getSharingMessage() + `
` + this.current.sharing.uri)}` : "";
  }
  /** Telegram-link */
  getTelegramUrl() {
    return this.current ? `https://telegram.me/share/url?url=${encodeURIComponent(this.current.sharing.uri)}&text=${encodeURIComponent(this.getSharingMessage())}` : "";
  }
  /** Mobile sharing */
  shareInMobile() {
    const t = {
      url: this.current.sharing.uri,
      title: this.getSharingTitle(),
      text: this.getSharingMessage()
    };
    return navigator.share(t);
  }
  showEmailSharing() {
    this.createSharingMessage().then((t) => {
      t && this.sendSharingEmail(t.to, t.cc, t.message);
    });
  }
  createSharingMessage(t) {
    const e = {
      to: t?.ownerInfo?.email || "",
      cc: this.cc,
      message: ""
    };
    return this.uiHelpers.openEditDialog("salaxy-components/modals/calc/EmailSharing.html", e, null).then((a) => a.result === "ok" ? a.item : null);
  }
  sendSharingEmail(t, e, a) {
    return this.isSharingType = "notification", this.sharingCalculationsApi.notifySharing(this.currentId, t, e, a).then((n) => (this.isSharingType = null, n === !0 ? this.uiHelpers.showAlert(L.get("SALAXY.NG1.CalcSharingComponent.emailSendSuccess") + ".") : this.uiHelpers.showAlert(L.get("SALAXY.NG1.CalcSharingComponent.emailSent") + "."), this.reload().then(() => n)));
  }
  getSharingMessage() {
    return `${L.get("SALAXY.NG1.CalcSharingComponent.sharingMessage.calculationSent")}. 
 ${L.get("SALAXY.NG1.CalcSharingComponent.sharingMessage.login")}!`;
  }
  getSharingTitle() {
    return L.get("SALAXY.NG1.CalcSharingComponent.sharingTitle");
  }
  /**
   * Shows an alert if the signature is missing.
   */
  showMissingSignatureAlert() {
    this.uiHelpers.showConfirm(
      L.get("SALAXY.NG1.CalcSharingComponent.missingSignatureAlert.missingSignature"),
      `${L.get("SALAXY.NG1.CalcSharingComponent.missingSignatureAlert.finishAccountCreation")}
 ${L.get("SALAXY.NG1.CalcSharingComponent.missingSignatureAlert.signAuthorization")} 

 ${L.get("SALAXY.NG1.CalcSharingComponent.missingSignatureAlert.continueToSigning")}`,
      L.get("SALAXY.NG1.CalcSharingComponent.missingSignatureAlert.continue"),
      L.get("SALAXY.NG1.CalcSharingComponent.missingSignatureAlert.close")
    ).then((t) => {
      t && this.onboardingService.launchWorkerOnboarding();
    });
  }
};
vS.$inject = ["Calculations", "ReportsService", "UiHelpers", "$location", "$routeParams", "SessionService", "InvoicesService", "Employments", "OnboardingService", "Taxcards"];
let wu = vS;
const xS = class xS {
  /**
   * Creates a new EmployerSelectController
   * @ignore
   */
  constructor(t, e) {
    this.employmentsApi = t, this.uiHelpers = e, this.employingRelations = [];
  }
  /**
   * Implement IController
   */
  $onInit() {
    this.loadEmployingRelations(), this.selectedItems = this.selectedItems || [], this.items = this.items || [];
  }
  /**
   * Loads employing relations of the existing employers for the current account.
   * @param options OData query options.
   */
  loadEmployingRelations(t = null) {
    return this.employmentsApi.getODataForEmployingRelations(t).then((e) => {
      const a = [];
      return e.items.forEach((n) => {
        a.findIndex((i) => i.ownerId === n.ownerId) === -1 && a.push(n);
      }), this.employingRelations = a, this.employingRelations;
    });
  }
  /**
   * Sets an item as selected.
   * @param item Item to set as selected
   * @param value Selected true / false or "toggle" to toggle to other value.
   */
  setEmployerSelected(t, e = !0) {
    const a = this.selectedItems.findIndex((i) => i.ownerId === t.ownerId), n = a >= 0;
    switch (n && this.selectedItems.splice(a, 1), e) {
      case !0:
        this.selectedItems.push(t);
        break;
      case !1:
        break;
      case "toggle":
        n || this.selectedItems.push(t);
        break;
    }
    this.onEmployerSelect({
      value: e === "toggle" ? !n : e,
      item: t,
      /** All items that are currently selected. */
      allItems: this.selectedItems
    }), this.selectEmployer(t.ownerId);
  }
  /**
   * Returns true if the item is selected.
   * @param item Item to check for selected value.
   */
  isEmployerSelected(t) {
    return this.selectedItems.findIndex((e) => e.ownerId === t.ownerId) >= 0;
  }
  /** Unselect all */
  unselectAll() {
    this.selectedItems && (this.selectedItems.splice(0, this.selectedItems.length), this.showFullEmployerList = !0);
  }
  /** Selects employer */
  selectEmployer(t) {
    this.employerId = t;
  }
};
xS.$inject = ["Employments", "UiHelpers"];
let Eg = xS;
const wS = class wS {
  constructor(t) {
    this.ajax = t, this.yearOptions = [
      { value: "2024", name: "2024" },
      { value: "2023", name: "2023" },
      { value: "2022", name: "2022" },
      { value: "2021", name: "2021" },
      { value: "2020", name: "2020" },
      { value: "2019", name: "2019" },
      { value: "2018", name: "2018" },
      { value: "2017", name: "2017" },
      { value: "2016", name: "2016" },
      { value: "2015", name: "2015" },
      { value: "2014", name: "2014" }
    ], this._currentReport = null, this._selectedYear = null, this._employers14BGroups = null, this.$onInit = () => {
      this.refreshData();
    };
  }
  /**
   * Returns the currently loaded report data.
   */
  get currentReport() {
    return this._currentReport;
  }
  /**
   * Returns the currently selected year.
   */
  get selectedYear() {
    return this._selectedYear || (this._selectedYear = this.yearOptions[0]), this._selectedYear;
  }
  /**
   * Sets the currently selected year and reloads the data.
   */
  set selectedYear(t) {
    this._selectedYear = t, this.refreshData();
  }
  /**
   * Returns employer ids and names in groups of two as in the 14B form (14B Kotitalousvähennys –
   * työntekijälle maksettu palkka (3026))
   */
  get employers14BGroups() {
    return this._employers14BGroups;
  }
  /**
   * Returns the employer id from the current report data if available otherwise undefined.
   */
  get employerId() {
    return this._currentReport?.employerReports?.[0]?.employerId;
  }
  /**
   * Returns the salary amount for TVR (Työttömyysvakuutusrahasto).
   */
  get tvrSalaryAmount() {
    return this._currentReport.employerReports.reduce((t, e) => t + e.totalSocialSecurityBase, 0);
  }
  /**
   * Returns avatar data based on the given url.
   * @param url Avatar url.
   * @returns Avatar data.
   */
  avatarFrom(t) {
    return t.toLowerCase().startsWith("/person/icon/") ? this.avatarDataFromIcon(t) : t.toLowerCase().startsWith("http") ? this.avatarDataFromUrl(t) : {
      color: "pink",
      initials: "#?"
    };
  }
  /**
   * Returns the worker email address from a report object otherwise null or undefined.
   * @param report The report object to search for worker email.
   * @returns Returns the email address or null/undefined.
   */
  workerEmailFrom(t) {
    return t?.worker.contact.email || t?.worker.identity.email;
  }
  /**
   * Checks if the selected reporting year is before incomes registry was established and/or
   * implemented.
   * @returns Returns true if selected year is before and false otherwise.
   */
  get isSelectedYearBeforeIncomesRegistry() {
    return this.selectedYear.value < 2019;
  }
  /**
   * Returns the authorization token for the current user.
   */
  get token() {
    return this.ajax.getCurrentToken();
  }
  /**
   * Returns the api server address.
   */
  get apiServerAddress() {
    return this.ajax.getServerAddress();
  }
  avatarDataFromIcon(t) {
    const e = t.substring(t.lastIndexOf("/") + 1), a = e.substring(0, e.indexOf("?color=")) || "#?", n = e.substring(e.indexOf("?color=") + 7) || "pink";
    return {
      initials: a,
      color: n,
      baseIcon: "fa-user"
    };
  }
  avatarDataFromUrl(t) {
    return {
      url: t.trim().replace("https://az724081.vo.msecnd.net", "https://cdn.salaxy.com")
    };
  }
  refreshData() {
    this.ajax.getJSON(`/v03-rc/api/yearly/employer-report/${this.selectedYear.value}`).then((t) => {
      this._currentReport = t, this._employers14BGroups = this.extractEmployer14BGroups();
    });
  }
  extractEmployer14BGroups() {
    const t = this._currentReport.employerReports.filter((e) => e.isHouseholdDeductionWork);
    return t.reduce((e, a, n) => {
      if (n % 2 === 0) {
        const i = a.worker.identity.socialSecurityNumberValid, r = t?.[n + 1]?.worker.identity.socialSecurityNumberValid || "", l = a.worker.fullName + (t?.[n + 1] ? " ja " + t[n + 1].worker.fullName : "");
        e.push({ id1: i, id2: r, names: l });
      }
      return e;
    }, []);
  }
};
wS.$inject = ["AjaxNg1"];
let Ng = wS;
const AS = class AS {
  /**
   * Creates a new EmployerSelectController
   * @ignore
   */
  constructor(t) {
    this.employmentsApi = t, this.employingRelations = [];
  }
  /**
   * Implement IController
   */
  $onInit() {
    this.loadEmployingRelations(), this.selectedItems = this.selectedItems || [], this.items = this.items || [];
  }
  /**
   * Loads employing relations of the existing employers for the current account.
   * @param options OData query options.
   */
  loadEmployingRelations(t = null) {
    return this.employmentsApi.getODataForEmployingRelations(t).then((e) => {
      const a = [];
      return e.items.forEach((n) => {
        a.findIndex((i) => i.ownerId === n.ownerId) === -1 && a.push(n);
      }), this.employingRelations = a, this.employingRelations.length == 1 && this.setEmployerSelected(this.employingRelations[0], !0), this.employingRelations;
    });
  }
  /**
   * Sets an item as selected.
   * @param item Item to set as selected
   * @param value Selected true / false or "toggle" to toggle to other value.
   */
  setEmployerSelected(t, e = !0) {
    const a = this.selectedItems.findIndex((i) => i.ownerId === t.ownerId), n = a >= 0;
    switch (n && this.selectedItems.splice(a, 1), e) {
      case !0:
        this.selectedItems.push(t);
        break;
      case !1:
        break;
      case "toggle":
        n || this.selectedItems.push(t);
        break;
    }
    this.onEmployerSelect({
      value: e === "toggle" ? !n : e,
      item: t,
      /** All items that are currently selected. */
      allItems: this.selectedItems
    });
  }
  /**
   * Returns true if the item is selected.
   * @param item Item to check for selected value.
   */
  isEmployerSelected(t) {
    return this.selectedItems.findIndex((e) => e.ownerId === t.ownerId) >= 0;
  }
  /** Unselect all */
  unselectAll() {
    this.selectedItems && (this.selectedItems.splice(0, this.selectedItems.length), this.showFullEmployerList = !0);
  }
};
AS.$inject = ["Employments"];
let Rg = AS;
const CS = class CS {
  constructor(t) {
    this.ajax = t, this.yearOptions = [
      { value: "2020", name: "2020" },
      { value: "2019", name: "2019" },
      { value: "2018", name: "2018" },
      { value: "2017", name: "2017" },
      { value: "2016", name: "2016" },
      { value: "2015", name: "2015" }
    ], this._currentReport = null, this._selectedYear = null, this._yearlyDeductionMaxAmounts = {
      2020: 2250,
      2019: 2400,
      2018: 2400,
      2017: 2400,
      2016: 2400,
      2015: 2400
    }, this.$onInit = () => {
      this.refreshData();
    };
  }
  /**
   * Returns the currently loaded report data.
   */
  get currentReport() {
    return this._currentReport;
  }
  /**
   * Returns the currently selected year. Defaults to current year minus one.
   */
  get selectedYear() {
    return this._selectedYear || (this._selectedYear = this.yearOptions[0]), this._selectedYear;
  }
  /**
   * Sets the currently selected year and reloads the data.
   */
  set selectedYear(t) {
    this._selectedYear = t, this.refreshData();
  }
  /**
   * Returns the employer id from the current report data if available otherwise undefined.
   */
  get employerId() {
    return this._currentReport?.employerReports?.[0]?.employerId;
  }
  /**
   * Returns the total deduction amount from a given employer report.
   * @param employerReport The employer report for which the amount is calculated for.
   * @returns The total deduction amount from a given employer report.
   */
  employerDeductionsTotalAmount(t) {
    return this.formatNumber(
      t.totalTaxableDeduction + t.totalMandatorySideCosts + t.deductionInsuranceEtc
    );
  }
  /**
   * Returns the total deduction amount for a 14B form of a given year end report.
   */
  yearlyForm14BTotalAmount(t) {
    return this.formatNumber(
      t.employerReports.reduce((e, a) => e + a.deduction14BFormTotal, 0)
    );
  }
  /**
   * Returns the total house hold deduction amount of a given year end report.
   * @param yearlyReport The year end report for which the amount is calculated for.
   */
  yearlyDeductionsTotalAmount(t) {
    return this.formatNumber(this.calculateYearlyDeductionsTotalAmount(t));
  }
  /**
   * Returns the total deduction amount for a given reports with maximum and deductible amount taken
   * into account.
   * @param yearlyReport The year end report for which the amount is calculated for.
   * @param deductibleAmount The deductible amount (can change in the future?)
   * @returns The total deduction amount with maximum and deductible amount taken into account.
   */
  yearlyDeductionTotal(t, e = 100) {
    return this.formatNumber(
      Math.min(
        Math.max(
          this.calculateYearlyDeductionsTotalAmount(t) - e,
          0
        ),
        this.deductionMaxAmount
      )
    );
  }
  /**
   * Returns...
   */
  get deductionMaxAmount() {
    return this._yearlyDeductionMaxAmounts[this.selectedYear.value];
  }
  /**
   * Return the given amount formatted as a currency string.
   * @param amount The amount to be formatted.
   * @returns The amount formatted as currency.
   */
  formatNumber(t) {
    return new Intl.NumberFormat(
      "fi-FI",
      {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
      }
    ).format(t);
  }
  /**
   * Formats the given start and end datetimes to an optimized datarange string.
   * @param start The start datetime of the date range.
   * @param end The end datetime of the date range.
   * @returns Returns the daterange as an optimized date range string.
   */
  formatDateRange(t, e) {
    return I.getFormattedRange(t, e);
  }
  /**
   * Returns an avatar.
   * @param url Avatart url.
   * @returns Avatar.
   */
  avatarFrom(t) {
    return t.toLowerCase().startsWith("/person/icon/") ? this.avatarDataFromIcon(t) : t.toLowerCase().startsWith("http") ? this.avatarDataFromUrl(t) : {
      color: "pink",
      initials: "#?"
    };
  }
  calculateYearlyDeductionsTotalAmount(t) {
    return t.employerReports.reduce((e, a) => e + a.totalTaxableDeduction + a.totalMandatorySideCosts + a.deductionInsuranceEtc, 0);
  }
  avatarDataFromIcon(t) {
    const e = t.substring(t.lastIndexOf("/") + 1), a = e.substring(0, e.indexOf("?color=")) || "#?", n = e.substring(e.indexOf("?color=") + 7) || "pink";
    return {
      initials: a,
      color: n,
      baseIcon: "fa-user"
    };
  }
  avatarDataFromUrl(t) {
    return {
      url: t.trim().replace("https://az724081.vo.msecnd.net", "https://cdn.salaxy.com")
    };
  }
  /**
   * Returns the worker email address from a report object otherwise null or undefined.
   * @param report The report object to search for worker email.
   * @returns Returns the email address or null/undefined.
   */
  workerEmailFrom(t) {
    return t?.worker.contact.email || t?.worker.identity.email;
  }
  refreshData() {
    this.ajax.getJSON(`/v03/api/yearly/tax-household-deduction-report/${this.selectedYear.value}`).then((t) => {
      this._currentReport = t;
    });
  }
};
CS.$inject = ["AjaxNg1"];
let Yg = CS;
const $S = class $S extends nn {
  constructor(t, e, a, n, i, r) {
    super(t, e, a, n), this.householdYearsApi = t, this.reportsService = i, this.sessionService = r, this._yearlyCalculations = { year: null, calculations: [], modifiedCalculations: [], status: "loaded", workers: [] };
  }
  /**
   * Initializes the controller
   */
  $onInit() {
    super.$onInit();
  }
  /** Implements the getDefaults of ApiCrudObjectController */
  getDefaults() {
    return {
      listUrl: this.listUrl || "/household-years",
      detailsUrl: this.detailsUrl || "/household-years/details/",
      oDataTemplateUrl: "salaxy-components/odata/lists/HouseholdYears.html",
      oDataOptions: {}
    };
  }
  /** Save changes to the current item */
  async save() {
    for (const t of this.yearlyCalculations.modifiedCalculations) {
      const e = await this.householdYearsApi.updateCalculation(t), a = this.yearlyCalculations.calculations.indexOf(t);
      a >= 0 && wt.copy(e, this.yearlyCalculations.calculations[a]);
    }
    return this.yearlyCalculations.modifiedCalculations.splice(0, this.yearlyCalculations.modifiedCalculations.length), super.save();
  }
  /** Returns all paid calculations for the household year */
  get yearlyCalculations() {
    return !this.current || !this.current.year ? (this._yearlyCalculations.year = null, this._yearlyCalculations.status = "loaded", this._yearlyCalculations.calculations.splice(0, this._yearlyCalculations.calculations.length), this._yearlyCalculations.modifiedCalculations.splice(0, this._yearlyCalculations.modifiedCalculations.length), this._yearlyCalculations.workers.splice(0, this._yearlyCalculations.calculations.length)) : this._yearlyCalculations.year !== this.current.year && this._yearlyCalculations.status !== "loading" && (this._yearlyCalculations.year = this.current.year, this._yearlyCalculations.status = "loading", this.householdYearsApi.getCalculationsForYear(this._yearlyCalculations.year).then((t) => {
      this._yearlyCalculations.calculations = [], this._yearlyCalculations.modifiedCalculations = [], this._yearlyCalculations.workers = [], this._yearlyCalculations.calculations.push(...t);
      for (const e of this._yearlyCalculations.calculations) {
        let a = this._yearlyCalculations.workers.find((n) => n.worker.paymentData.socialSecurityNumberValid == e.worker.paymentData.socialSecurityNumberValid);
        a || (a = { worker: e.worker, totalTaxable: 0, mandatorySideCosts: 0, calculations: [] }, this._yearlyCalculations.workers.push(a)), a.calculations.push(e), a.mandatorySideCosts += e.result.employerCalc.mandatorySideCosts, a.totalTaxable += e.result.totals.totalTaxable;
      }
      this._yearlyCalculations.status = "loaded";
    })), this._yearlyCalculations;
  }
  /** Returns true if the feedback is active */
  get isOpen() {
    return this.current ? this.sessionService.isInSomeRole(["pro", "admin"]) || !this.current.processingStatus || this.current.processingStatus === JM.Open : !1;
  }
  /** Calculates the household tax deduction total */
  getTaxDeductionTotal() {
    let t = 0;
    const e = this.yearlyCalculations.calculations;
    for (const a of e)
      a.usecase?.data?.isHouseholdDeductible && !this.isHouseholdDeductionExtended(a) && (t += a.result.employerCalc.mandatorySideCosts, t += a.result.totals.totalTaxable * this.getHouseholdDeduction(a));
    return t;
  }
  /** Calculates the household tax deduction total */
  getTaxDeductionTotalExtended() {
    let t = 0;
    const e = this.yearlyCalculations.calculations;
    for (const a of e)
      a.usecase?.data?.isHouseholdDeductible && this.isHouseholdDeductionExtended(a) && (t += a.result.employerCalc.mandatorySideCosts, t += a.result.totals.totalTaxable * this.getHouseholdDeduction(a));
    return t;
  }
  /** Returns true if the deduction should be split between spouses */
  canSplitWithSpouse() {
    return this.getSplittableMaxAmount() > 0;
  }
  /** Returns current deduction max amount */
  getSplittableMaxAmount() {
    let t = 0;
    return this.getTaxDeductionTotal() + (this.current.insuranceAmount ?? 0) > this.getHouseholdDeductionMaxAmount() + this.getHouseholdDeductionDeductible() && (t = this.getHouseholdDeductionMaxAmount()), Math.min(this.getTaxDeductionTotal(), this.getHouseholdDeductionMaxAmount() + this.getHouseholdDeductionDeductible()) + this.getTaxDeductionTotalExtended() + (this.current.insuranceAmount ?? 0) > this.getHouseholdDeductionMaxAmountExtended() + this.getHouseholdDeductionDeductible() && (t = this.getHouseholdDeductionMaxAmountExtended()), t;
  }
  /** Returns household deduction for calculation */
  getHouseholdDeduction(t) {
    const e = this.getTaxDeductionWorkCategories(t), a = this.getYearlySideCosts();
    return this.getHouseholdDeductionCategoriesExtended().includes(e) ? a.householdDeductionExtended : a.householdDeduction;
  }
  /** Returns deduction deductible */
  getHouseholdDeductionDeductible() {
    return this.getYearlySideCosts().householdDeductionDeductible;
  }
  /**
   * Gets a link URL for a yearly report. This is a full link with token and absolute URL.
   * @param type - Type of the report must be one of the yearly reports
   * @param year - Year for the report
   * @param id - Worker ID for those reports that are specific to one Worker.
   * @param id2 - Second Worker ID for those reports that have two Workers in one report
   */
  getYearlyReport(t, e, a, n) {
    return this.reportsService.getYearlyReportUrl(t, e, a, n);
  }
  /** Set calculation modified */
  calculationUpdated(t) {
    if (!this.yearlyCalculations.modifiedCalculations.find((a) => a.id === t.id)) {
      const a = this.yearlyCalculations.calculations.find((n) => n.id == t.id);
      a && this.yearlyCalculations.modifiedCalculations.push(a);
    }
  }
  /**
   * Sets the active year to the controller.
   */
  setActiveYear() {
    const t = /* @__PURE__ */ new Date(), e = t.getMonth() >= 2 ? t.getFullYear() : t.getFullYear() - 1;
    this.householdYearsApi.getOData(null).then((a) => {
      const n = a, i = `${e}-01-01T00:00:00Z`, r = n.items.find((l) => l.logicalDate == i);
      if (r)
        this.householdYearsApi.getSingle(r.id).then((l) => {
          this.model = l;
        });
      else {
        const l = this.api.getBlank();
        l.year = e, this.model = l;
      }
    });
  }
  /** Export pdf for the given deductions */
  async export() {
    const t = this.uiHelpers.showLoading("SALAXY.UI_Terms.wait", "Ladataan PDF-tiedostoja..."), e = await this.downloadReportsForHousehold();
    if (e.length === 0)
      t.dismiss();
    else if (e.length === 1)
      this.uiHelpers.downloadFile(e[0].blob, e[0].fileName), t.dismiss();
    else {
      t.setText("Muodostetaan pakattu tiedosto");
      const a = new un();
      e.forEach((i) => {
        a.file(`${i.fileName}`, i.blob);
      });
      const n = await a.generateAsync({
        type: "blob",
        mimeType: "application/zip"
      });
      Vn.saveAs(n, `${ti.escapeFileName(`14B_${I.format("today", "YYYYMMDD")}`)}.zip`), t.dismiss();
    }
  }
  async downloadReportsForHousehold() {
    if (!this.current?.id)
      return Promise.resolve([]);
    const t = [], e = await this.householdYearsApi.downloadPdfs(this.current.id);
    for (const a of e)
      t.push({
        fileName: a.fileName,
        blob: this.uiHelpers.bytes2Blob(a.bytes, "application/pdf")
      });
    return t;
  }
  getYearlySideCosts() {
    return !this.current || !this.current.year ? gr.getYearlyChangingNumbers(I.getToday()).sideCosts : gr.getYearlyChangingNumbers(`${this.current.year}-01-01`).sideCosts;
  }
  getHouseholdDeductionMaxAmount() {
    return this.getYearlySideCosts().householdDeductionMaxAmount;
  }
  getHouseholdDeductionMaxAmountExtended() {
    return this.getYearlySideCosts().householdDeductionMaxAmountExtended;
  }
  getTaxDeductionWorkCategories(t) {
    return t.usecase?.data?.taxDeductionCategories ?? QM.None;
  }
  getHouseholdDeductionCategoriesExtended() {
    return this.getYearlySideCosts().householdDeductionCategoriesExtended ?? [];
  }
  isHouseholdDeductionExtended(t) {
    const e = this.getTaxDeductionWorkCategories(t);
    return this.getHouseholdDeductionCategoriesExtended().includes(e);
  }
};
$S.$inject = [
  "HouseholdYears",
  "UiHelpers",
  "$location",
  "$routeParams",
  "ReportsService",
  "SessionService"
];
let Au = $S;
const SS = class SS {
  /** Constructor for dependency injection */
  constructor(t, e, a, n, i) {
    this.accounts = t, this.sessionService = e, this.uploadService = a, this.uiHelpers = n, this.$location = i, this.sideCosts = gr.getYearlyChangingNumbers(/* @__PURE__ */ new Date()).sideCosts, this._currentTab = null, this.saveCurrent = () => {
      const r = this.uiHelpers.showLoading("SALAXY.UI_Terms.wait");
      return this.accounts.savePerson(this.current).then((l) => (this.current = l, this.sessionService.checkSession().then(() => (r.dismiss(), this.current))));
    };
  }
  /**
   * Implement IController
   */
  $onInit() {
    !this.current && this.sessionService.getCurrentToken() && this.accounts.getPerson().then((t) => {
      this.current = t;
    });
  }
  /**
   * Switches the current web site usage role between household and worker.
   * TODO: This functionality will be removed
   * @param role - household or worker.
   * @returns A Promise with result data (new role as string)
   */
  switchRole(t) {
    return this.sessionService.switchRole(t).then((e) => (t === "worker" ? window.location.href = "/Worker#/" : window.location.href = "/Household#/", e));
  }
  /** Gets the language of the user (person) */
  getAccountLanguage() {
    return this.current?.language;
  }
  /**
   * Uploads avatar image file to the server.
   * @param avatar - selected file
   */
  uploadAvatarImage(t) {
    t && this.uploadService.upload(this.accounts.getAvatarUploadUrl(), { avatar: t }).then((e) => {
      this.current.avatar.url = e.url, this.current.avatar.pictureType = e.pictureType;
    });
  }
  /** Called when avatar changes */
  emailForAvatarChanged() {
    !this.current || !this.current.avatar || this.current.avatar.pictureType === is.Gravatar && (this.current.avatar.url = Zs.getGravatarUrl(this.current.contact.email));
  }
  /** Called when avatar changes */
  typeForAvatarChanged() {
    if (!(!this.current || !this.current.avatar)) {
      if (this.current.avatar.pictureType === is.Gravatar)
        this.current.avatar.url = Zs.getGravatarUrl(this.current.contact.email);
      else if (Zs.isGravatarUrl(this.current.avatar.url) && (this.current.avatar.url = null), this.current.avatar.pictureType === is.Uploaded) {
        const t = (this.sessionService.getPersonAccount() || {}).avatar;
        !this.current.avatar.url && t && t.url && t.pictureType === is.Uploaded && !Zs.isGravatarUrl(t.url) && (this.current.avatar.url = t.url);
      }
    }
  }
  /**
   * For the tab UI control, returns the current tab, if defined in the path
   * or set explicitly. Defaults to "default".
   */
  get currentTab() {
    if (this._currentTab)
      return this._currentTab;
    const t = ["default", "contact", "avatar", "insurance", "identity", "taxcard"], e = (this.$location && this.$location.hash() || "").trim().toLowerCase();
    return t.indexOf(e) > -1 ? e : "default";
  }
  set currentTab(t) {
    this._currentTab = t;
  }
  /**
   * Adds/updates the workflow event for the current using API.
   * @param wfEvent - Workflow event to add/update.
   * @returns - Reloaded item.
   */
  saveWorkflowEvent(t) {
    return this.accounts.saveWorkflowEvent(this.current, t).then(() => this.accounts.getPerson().then((e) => {
      this.current = e;
    }));
  }
  /**
   * Deletes the given event or all events with given type using API.
   * @param wfIdOrType Id or type of the workflow event.
   * @returns - Reloaded item.
   */
  deleteWorkflowEvent(t) {
    return this.accounts.deleteWorkflowEvent(this.current, t).then(() => this.accounts.getPerson().then((e) => {
      this.current = e;
    }));
  }
  /**
   * Gets a single workflow event for the item.
   * @param wfId Id the workflow event.
   * @returns - Workflow event.
   */
  getWorkflowEvent(t) {
    return this.accounts.getWorkflowEvent(this.current, t);
  }
};
SS.$inject = ["Accounts", "SessionService", "UploadService", "UiHelpers", "$location"];
let ao = SS;
const kS = class kS {
  constructor(t) {
    this.ajax = t, this._yearOptions = null, this._currentReport = null, this._selectedYear = null, this.$onInit = () => {
      this.refreshData();
    };
  }
  /** Return year options for the year select control. */
  get yearOptions() {
    if (!this._yearOptions) {
      const e = (/* @__PURE__ */ new Date()).getFullYear();
      this._yearOptions = [];
      for (let a = 2014; a <= e; a++)
        this._yearOptions.unshift({ value: "" + a, name: "" + a });
    }
    return this._yearOptions;
  }
  /**
   * Returns the currently loaded report data.
   */
  get currentReport() {
    return this._currentReport;
  }
  /**
   * Returns the currently selected reporting year.
   */
  get selectedYear() {
    return this._selectedYear || (this._selectedYear = this.yearOptions[0]), this._selectedYear;
  }
  /**
   * Sets the currently selected reporting year and reloads the data.
   */
  set selectedYear(t) {
    this._selectedYear = t, this.refreshData();
  }
  /**
   * Returns the worker email address from a report object otherwise null or undefined.
   * @param report The report object to search for worker email.
   * @returns Returns the email address or null/undefined.
   */
  employerEmailFrom(t) {
    return t?.employer.contact.email || t?.employer.identity.email;
  }
  /**
   * Checks if the selected reporting year is before incomes registry was established and/or
   * implemented.
   * @returns Returns true if selected year is before and false otherwise.
   */
  get isSelectedYearBeforeIncomesRegistry() {
    return this.selectedYear.value < 2019;
  }
  /**
   * Returns avatar data based on the given url.
   * @param url Avatar url.
   * @returns Avatar data.
   */
  avatarFrom(t) {
    return t.toLowerCase().startsWith("/person/icon/") ? this.avatarDataFromIcon(t) : t.toLowerCase().startsWith("http") ? this.avatarDataFromUrl(t) : {
      color: "pink",
      initials: "#?"
    };
  }
  /**
   * Returns the authorization token for the current user.
   */
  get token() {
    return this.ajax.getCurrentToken();
  }
  /**
   * Returns the api server address.
   */
  get apiServerAddress() {
    return this.ajax.getServerAddress();
  }
  avatarDataFromIcon(t) {
    const e = t.substring(t.lastIndexOf("/") + 1), a = e.substring(0, e.indexOf("?color=")) || "#?", n = e.substring(e.indexOf("?color=") + 7) || "pink";
    return {
      initials: a,
      color: n,
      baseIcon: "fa-user"
    };
  }
  avatarDataFromUrl(t) {
    return {
      url: t.trim().replace("https://az724081.vo.msecnd.net", "https://cdn.salaxy.com")
    };
  }
  refreshData() {
    this.ajax.getJSON(`/v03-rc/api/yearly/worker-report/${this.selectedYear.value}`).then((t) => {
      this._currentReport = t;
    });
  }
};
kS.$inject = ["AjaxNg1"];
let _g = kS;
const TS = class TS extends yu {
  /** Constructor for dependency injection */
  constructor(t, e, a, n, i, r, l, o, c, d, p) {
    super(t, e, a, n, i, r, l, o, c, d), this.msgApi = t, this.$interval = p, this.entries = [], this.currentEntry = null, this.projects = {
      1234: "Projekti 1",
      2345: "Toinen projekti",
      1345: "Joku muu projekti"
    }, this.$onDestroy = () => {
      this.stopTechnicalTimer();
    }, this.calendarDemoData = [
      {
        day: "ma",
        date: "2.5.",
        hours: "7:30 h"
      },
      {
        day: "ti",
        date: "3.5.",
        hours: "7:30 h"
      },
      {
        day: "ke",
        date: "4.5.",
        hours: null
      },
      {
        day: "to",
        date: "5.5.",
        hours: null
      },
      {
        day: "pe",
        date: "6.5.",
        hours: null
      },
      {
        day: "la",
        date: "7.5.",
        hours: null,
        isHoliday: !0
      },
      {
        day: "su",
        date: "8.5.",
        hours: null,
        isHoliday: !0
      }
    ];
  }
  /**
   * Implement IController
   */
  $onInit() {
    this.resetTimer(), super.$onInit();
  }
  /** Resets the timer to zero value */
  resetTimer() {
    this.stopTechnicalTimer(), this.currentEntry = {
      isStarted: !1,
      start: this.roundDate(),
      total: /* @__PURE__ */ new Date(0)
    };
  }
  /** Starts the timer. */
  startTimer() {
    this.stopTechnicalTimer(), this.currentEntry.start = this.roundDate(), this.currentEntry.isStarted = !0, this.timer = this.$interval(() => {
      this.currentEntry.total = new Date(this.roundDate().getTime() - this.currentEntry.start.getTime());
    }, 1e3);
  }
  /** Starts the timer. */
  stopTimer() {
    this.currentEntry.end = this.roundDate(), this.currentEntry.total = new Date(this.currentEntry.end.getTime() - this.currentEntry.start.getTime()), this.entries.push(this.currentEntry), this.resetTimer();
  }
  /** Gets the project text for a project */
  getProjectText(t) {
    return t ? this.projects[t] || "Ei projektia " + t : "Ei projektia";
  }
  /** Gets the total of the timesheets logged today */
  getTotal() {
    return new Date(ie.sum(this.entries, (t) => t.total.getTime()));
  }
  roundDate(t = null) {
    return t || (t = /* @__PURE__ */ new Date()), t.setMilliseconds(0), t;
  }
  stopTechnicalTimer() {
    this.timer && this.$interval.cancel(this.timer);
  }
  /** Sets the usecase to a new message thread */
  setUsecase(t) {
    this.current.usecase = {
      uri: "palkkaus.fi/testing/messages-proto/" + t.id,
      label: t.title,
      description: t.descr,
      data: {
        protoId: t.id
      }
    };
  }
  /** Gets the usecases available for the current Worker-Employer combination. */
  getUsecases() {
    return this.uiHelpers.cache(this, "usecases", () => [
      {
        id: "default",
        icon: "fa-envelope",
        title: "Viesti",
        descr: "Lähetä viesti turvapostilla."
      },
      {
        id: "timer",
        icon: "fa-clock-o",
        title: "Kellokortti",
        descr: "Leimaa sisään digitaalisella kellokorttisovelluksella."
      },
      {
        id: "timesheet",
        icon: "fa-calendar",
        title: "Kirjaa tunteja",
        descr: "Kirjaa / muokkaa jo tapahtuneita tunteja."
      },
      {
        id: "timesheet",
        icon: "fa-calendar",
        title: "Kirjaa työaikoja",
        descr: "Kirjaa / muokkaa jo tehtyjä työaikoja (myös kellonajat)."
      },
      {
        id: "timesheet",
        icon: "fa-sun-o",
        title: "Lomakalenteri",
        descr: "Lähetä lomapyyntö"
      },
      {
        id: "timesheet",
        icon: "fa-ambulance",
        title: "Poissaolot",
        descr: "Ilmoita poissaolosta"
      },
      {
        id: "travel",
        icon: "fa-suitcase",
        title: "Matkalaskut",
        descr: "Kilometrikorvaukset, päivärahat ja kulukorvaukset matkoista."
      },
      {
        id: "expenses",
        icon: "fa-shopping-cart",
        title: "Kulukorvaukset",
        descr: "Kulukorvaukset kuittien perusteella mukaan lukien kilometrikorvaukset."
      },
      {
        id: "calc",
        pic: "https://salaxypublic.blob.core.windows.net/salaxy-wordpress/2019/03/palkkaennakko_palkkalaskuri_palkkalaskelma.png",
        title: "Palkkalaskuri",
        descr: "Palkkaus.fi perinteinen palkkalaskuri, jolla voit lähettää minkä tahansa palkkapyynnön."
      }
    ]);
  }
};
TS.$inject = ["MessageThreads", "UiHelpers", "UploadService", "$location", "$routeParams", "$anchorScroll", "$timeout", "SessionService", "$interval", "Calculations", "Payrolls"];
let iw = TS;
const LS = class LS extends Ki {
  /** Constructor for dependency injection */
  constructor(t, e, a) {
    super(e), this.$interval = t, this.sessionService = a;
  }
  /**
   * Controller initializations
   */
  $onInit() {
    this.isTimerOn && this.startTechnicalTimer(this.getTimerMessage()), this.validateEntries(), this.onCommit = () => {
      this.validateEntries(), this.isTimerOn && this.startTechnicalTimer(this.getTimerMessage());
    }, super.$onInit();
  }
  /**
   * Stop timer on destroy
   */
  $onDestoy() {
    this.stopTechnicalTimer();
  }
  /**
   * Returns true if the message indicates that the timer should be on.
   */
  get isTimerOn() {
    const t = this.getTimerMessage();
    return t.contentData.startTime && !t.contentData.endTime;
  }
  /**
   * Returns true if the message indicates that the timer should be on.
   */
  get isTimerOnFromDayBefore() {
    const t = this.getTimerMessage();
    return this.isTimerOn && I.isBefore(t.contentData.period.start, I.getToday());
  }
  /**
   * Ensure that atleast one message exists
   */
  getTimerMessage() {
    const t = this.list.findIndex(
      (e) => e.type === ja.Timer && (!e.contentData.startTime && !e.contentData.endTime || e.contentData.startTime && !e.contentData.endTime)
    );
    return t >= 0 ? (this._newTimerMessage = null, this.list[t]) : (this._newTimerMessage || (this._newTimerMessage = this.getBlank()), this._newTimerMessage);
  }
  /**
   * List of items
   */
  get list() {
    return this.parent ? this.parent.messages : null;
  }
  /** Template for edit UI that is shown in a modal dialog. */
  getEditDialogTemplateUrl() {
    return "salaxy-components/worker/TimerEditDialog.html";
  }
  /**
   * Creating of a new item
   */
  getBlank() {
    const t = {
      modification: kd.CREATE,
      period: {
        start: I.getToday()
      }
    };
    return {
      type: ja.Timer,
      content: "Kellokorttikirjaus",
      contentData: t,
      fromParty: Xn.OtherParty
    };
  }
  /** Starts the timer. */
  startTimer() {
    this.stopTechnicalTimer();
    let t = this.getTimerMessage();
    this.list.indexOf(t) < 0 && this.list.push(t);
    const e = /* @__PURE__ */ new Date();
    t.contentData.period.start = I.asDate(e), t.contentData.startTime = ys.asTime(e), t.contentData.totalTime = 0, t.contentData.totalTimeInSeconds = 0, this.crudController.save().then((a) => {
      this.parent = a, t = this.getTimerMessage(), this.startTechnicalTimer(t);
    });
  }
  /** Stops the timer. */
  stopTimer() {
    this.stopTechnicalTimer();
    const t = this.getTimerMessage(), e = /* @__PURE__ */ new Date();
    t.contentData.period.end = I.asDate(e), t.contentData.endTime = ys.asTime(e), this.calculateAndSetTotals(t), this.crudController.save().then((a) => {
      this.parent = a, this.validateEntries();
    });
  }
  /**
   * Formats time as minutes or seconds.
   * TODO: implement this as filter.
   * @param total Total number of minutes or seconds
   * @param unit Unit: seconds or minutes
   * @returns Formatted time
   */
  formatTime(t, e = "minutes") {
    const a = (n) => n.toString().padStart(2, "0");
    switch (t = se.isNumber(t) ? t : 0, e) {
      case "minutes": {
        const n = Math.floor(t / 60), i = t % 60;
        return `${a(n)}:${a(i)}`;
      }
      case "seconds": {
        const n = Math.floor(t / 3600), i = Math.floor(t % 3600 / 60), r = t % 60;
        return `${a(n)}:${a(i)}:${a(r)}`;
      }
    }
  }
  /**
   * Gets the total of the timesheets logged in messageThread.
   */
  getAndFormatTotal() {
    return this.formatTime(ie.sum(this.list, (t) => t.contentData.totalTime));
  }
  /**
   * Override for ListControllerBase showEditDialog
   * @param item Item to edit or string "new" for creating a new one.
   * @param isNew Optional way of specifying that the item is a new item (with default values, not yet added to the list).
   * If item is string "new", this parameter will have no effect (will always be true).
   */
  showEditDialog(t, e = !1) {
    if (!t)
      throw new Error("showEditDialog called without a parameter.");
    t === "new" && (e = !0, t = this.getBlank());
    const a = (this.crudController?.employingRelation?.settings?.costAccounting?.dimensions || this.sessionService.session.settings?.costAccounting?.dimensions || void 0).find((i) => i.name = "lk1"), n = a ? {
      options: a.options,
      label: a.label
    } : null;
    this.uiHelpers.openEditDialog(this.getEditDialogTemplateUrl(), t, { ...this.getEditDialogLogic(), costAccountingSettings: n }).then((i) => {
      i.action === "ok" || i.action === "ok-no-save" ? (this.calculateAndSetTotals(i.item), e && this.list.push(i.item), (e || i.hasChanges) && i.action !== "ok-no-save" && this.commit()) : (i.action === "delete" || i.action === "delete-no-save") && (e || (this.delete(t), i.action !== "delete-no-save" && this.commit()));
    });
  }
  /** Gets the project text for a project */
  getDimensionOptionText(t) {
    if (t) {
      const e = (this.crudController?.employingRelation?.settings?.costAccounting?.dimensions || this.sessionService.session.settings?.costAccounting?.dimensions || void 0).find((a) => a.name = "lk1");
      if (e)
        return e.options.find((a) => a.value === t)?.text ?? "";
    }
    return "";
  }
  startTechnicalTimer(t) {
    this.stopTechnicalTimer(), this.timer = this.$interval((e) => {
      this.calculateAndSetTotals(e, /* @__PURE__ */ new Date());
    }, 1e3, 0, !0, t);
  }
  calculateAndSetTotals(t, e = null) {
    const a = /* @__PURE__ */ new Date(), n = /* @__PURE__ */ new Date(`${t.contentData.period.start ?? I.asDate(a)}T${t.contentData.startTime ?? ys.asTime(a)}:00`);
    e = e ?? /* @__PURE__ */ new Date(`${t.contentData.period.end ?? I.asDate(a)}T${t.contentData.endTime ?? ys.asTime(a)}:00`);
    const i = e.getTime() - n.getTime();
    t.contentData.totalTimeInSeconds = Math.floor(i / 1e3), t.contentData.totalTime = Math.floor(i / 6e4);
  }
  stopTechnicalTimer() {
    this.timer && this.$interval.cancel(this.timer);
  }
  /** Overlapping timer log entries validation */
  validateEntries() {
    for (const t of this.list)
      t.validation = null;
    for (const t of this.list)
      if (t.contentData.period.start && t.contentData.startTime && t.contentData.period.end && t.contentData.endTime) {
        const e = /* @__PURE__ */ new Date(`${t.contentData.period.start}T${t.contentData.startTime}:00`), a = /* @__PURE__ */ new Date(`${t.contentData.period.end}T${t.contentData.endTime}:00`);
        this.list.find((i) => {
          if (i.contentData.period.start && i.contentData.startTime && i.contentData.period.end && i.contentData.endTime) {
            const r = /* @__PURE__ */ new Date(`${i.contentData.period.start}T${i.contentData.startTime}:00`), l = /* @__PURE__ */ new Date(`${i.contentData.period.end}T${i.contentData.endTime}:00`);
            return t != i && // endTime not inside entry's range
            (I.isSameOrAfter(l, e, "minutes") && I.isSameOrBefore(l, a, "minutes") || // startTime not inside entry's range
            I.isSameOrAfter(r, e, "minutes") && I.isBefore(r, a, "minutes") || // another range covers entry's range
            I.isSameOrBefore(r, e, "minutes") && I.isSameOrAfter(l, a, "minutes"));
          } else
            return !1;
        }) && (t.validation = {
          errors: [{
            type: "invalid",
            msg: "Päällekkäisiä kirjauksia",
            code: "TimeSheetInput.isOverlapping"
          }],
          isValid: !1,
          hasAllRequiredFields: !0
        });
      }
  }
};
LS.$inject = ["$interval", "UiHelpers", "SessionService"];
let Og = LS;
class k6 extends $r {
  constructor() {
    super(...arguments), this.reportType = "<", this.crudController = "<";
  }
}
const Xy = class Xy extends Ki {
  /** Constructor for dependency injection */
  constructor(t, e) {
    super(t), this.sessionService = e, this.currentWeek = [];
  }
  /**
   * Implement IController
   */
  $onInit() {
    this.currentDate = I.getToday(), this.setCurrentWeek();
  }
  /**
   * List of items
   */
  get list() {
    return this.parent ? this.parent.messages : null;
  }
  /** Template for edit UI that is shown in a modal dialog. */
  getEditDialogTemplateUrl() {
    if (this.reportType == ja.HourlyReport)
      return "salaxy-components/worker/HourlyReportEditDialog.html";
    if (this.reportType == ja.TimeReport)
      return "salaxy-components/worker/TimeReportEditDialog.html";
  }
  /**
   * Creating of a new item
   */
  getBlank() {
    if (this.reportType === ja.HourlyReport) {
      const t = {
        modification: kd.CREATE,
        project: "",
        projectText: "",
        period: {
          start: this.currentDate
        },
        totalTime: 450
      };
      return {
        type: ja.HourlyReport,
        content: "Tuntikirjaus",
        contentData: t,
        fromParty: Xn.OtherParty
      };
    }
    if (this.reportType === ja.TimeReport) {
      const t = {
        modification: kd.CREATE,
        project: "",
        projectText: "",
        period: {
          start: this.currentDate
        }
      };
      return {
        type: ja.TimeReport,
        content: "Työaikakirjaus",
        contentData: t,
        fromParty: Xn.OtherParty
      };
    }
  }
  /** Logic used in ListControlerBase showEditDialog */
  getEditDialogLogic() {
    return {};
  }
  /** Sums daily total time */
  countDailyHours(t) {
    let e = 0;
    return this.list.filter((n) => I.getFormattedDate(n.contentData.period.start) === I.getFormattedDate(t)).forEach((n) => {
      e = e + n.contentData.totalTime;
    }), e === 0 ? 0 : e;
  }
  /** Sum weekly totalTime */
  get weeklyHours() {
    let t = 0;
    return this.list.filter((a) => I.isSameOrAfter(a.contentData.period.start, this.firstDayOfCurrentWeek) && I.isSameOrBefore(a.contentData.period.start, this.lastDayOfCurrentWeek)).forEach((a) => {
      t = t + a.contentData.totalTime;
    }), t === 0 ? 0 : t;
  }
  /** Sets current week for ui */
  setCurrentWeek() {
    this.firstDayOfCurrentWeekFormatted = I.getFormattedDate(I.startEnd(this.currentDate, "start-week")), this.lastDayOfCurrentWeekFormatted = I.getFormattedDate(I.startEnd(this.currentDate, "end-week")), this.firstDayOfCurrentWeek = I.startEnd(this.currentDate, "start-week"), this.lastDayOfCurrentWeek = I.startEnd(this.currentDate, "end-week"), this.currentWeek = [
      {
        dayName: "Ma",
        date: I.format(this.firstDayOfCurrentWeek, "YYYY-MM-DD"),
        displayDate: I.format(this.firstDayOfCurrentWeek, "DD.MM"),
        isCollapsed: !0
      },
      {
        dayName: "Ti",
        date: I.format(I.add(this.firstDayOfCurrentWeek, 1, "day"), "YYYY-MM-DD"),
        displayDate: I.format(I.add(this.firstDayOfCurrentWeek, 1, "day"), "DD.MM"),
        isCollapsed: !0
      },
      {
        dayName: "Ke",
        date: I.format(I.add(this.firstDayOfCurrentWeek, 2, "day"), "YYYY-MM-DD"),
        displayDate: I.format(I.add(this.firstDayOfCurrentWeek, 2, "day"), "DD.MM"),
        isCollapsed: !0
      },
      {
        dayName: "To",
        date: I.format(I.add(this.firstDayOfCurrentWeek, 3, "day"), "YYYY-MM-DD"),
        displayDate: I.format(I.add(this.firstDayOfCurrentWeek, 3, "day"), "DD.MM"),
        isCollapsed: !0
      },
      {
        dayName: "Pe",
        date: I.format(I.add(this.firstDayOfCurrentWeek, 4, "day"), "YYYY-MM-DD"),
        displayDate: I.format(I.add(this.firstDayOfCurrentWeek, 4, "day"), "DD.MM"),
        isCollapsed: !0
      },
      {
        dayName: "La",
        date: I.format(I.add(this.firstDayOfCurrentWeek, 5, "day"), "YYYY-MM-DD"),
        displayDate: I.format(I.add(this.firstDayOfCurrentWeek, 5, "day"), "DD.MM"),
        isCollapsed: !0
      },
      {
        dayName: "Su",
        date: I.format(I.add(this.firstDayOfCurrentWeek, 6, "day"), "YYYY-MM-DD"),
        displayDate: I.format(I.add(this.firstDayOfCurrentWeek, 6, "day"), "DD.MM"),
        isCollapsed: !0
      }
    ];
  }
  /** Gets the project text for a project */
  getDimensionOptionText(t) {
    if (t) {
      const e = (this.crudController?.employingRelation?.settings?.costAccounting?.dimensions || this.sessionService.session.settings?.costAccounting?.dimensions || void 0).find((a) => a.name = "lk1");
      if (e)
        return e.options.find((a) => a.value === t)?.text ?? "";
    }
    return "";
  }
  /**
   * Controlls visibility of dates messages
   * @param date Used to find correct date from currentWeek
   */
  setHourlyRecordsVisible(t) {
    const e = this.currentWeek.find((a) => a.date === t);
    e.isCollapsed = !e.isCollapsed;
  }
  /** Change current week and reload week data */
  changeWeek(t) {
    t ? this.currentDate = I.add(this.currentDate, 7, "day") : this.currentDate = I.add(this.currentDate, -7, "day"), this.setCurrentWeek();
  }
  /** Get current weeknumber */
  get currentWeekNumber() {
    return I.getWeekNumber(this.currentDate);
  }
  /**
   * Check if provided date is saturday or sunday or not workday
   * @param date Used date to determine if saturday or sunday
   * @returns Boolean if date is saturday or sunday
   */
  isHoliday(t) {
    return !I.isWorkday(t) || I.isHoliday(t);
  }
  /**
   * Checks if expand button should be visible
   * @param date used to search correct objects
   * @returns Boolean that indicates if expand chevron should be visible
   */
  showExpandButton(t) {
    return this.list.filter((a) => I.getFormattedDate(a.contentData.period.start) === I.getFormattedDate(t)).length > 0;
  }
  /**
   * Get blank message object for edit dialog
   * @param date is used to create start date
   * @returns Blank message object
   */
  getEditDialogItem(t) {
    if (this.reportType === ja.HourlyReport)
      return {
        type: this.reportType,
        content: "Tuntikirjaus",
        fromParty: Xn.OtherParty,
        contentData: {
          modification: kd.CREATE,
          project: "",
          projectText: "",
          period: {
            start: t
          },
          totalTime: 450
        }
      };
    if (this.reportType === ja.TimeReport)
      return {
        type: this.reportType,
        content: "Työaikakirjaus",
        fromParty: Xn.OtherParty,
        contentData: {
          modification: kd.CREATE,
          project: "",
          projectText: "",
          period: {
            start: t
          },
          totalTime: 450
        }
      };
  }
  /**
   * Get button style for date. Handles dirrerent styles for workday, today, holiday
   * @param date Day used to figure date
   * @returns button class as string
   */
  getDateStyle(t) {
    return t === I.getToday() ? "bg-info" : !I.isWorkday(t) || I.isHoliday(t) ? "bg-primary" : "btn btn-default";
  }
  /**
   * Override for ListControllerBase showEditDialog
   * @param item Item to edit or string "new" for creating a new one.
   * @param isNew Optional way of specifying that the item is a new item (with default values, not yet added to the list).
   * If item is string "new", this parameter will have no effect (will always be true).
   */
  showEditDialog(t, e = !1) {
    if (!t)
      throw new Error("showEditDialog called without a parameter.");
    t === "new" && (e = !0, t = this.getBlank());
    const a = (this.crudController?.employingRelation?.settings?.costAccounting?.dimensions || this.sessionService.session.settings?.costAccounting?.dimensions || void 0).find((i) => i.name = "lk1"), n = a ? {
      options: a.options,
      label: a.label
    } : null;
    this.uiHelpers.openEditDialog(this.getEditDialogTemplateUrl(), t, { ...this.getEditDialogLogic(), costAccountingSettings: n }).then((i) => {
      if (i.action === "ok" || i.action === "ok-no-save") {
        if (i.item.type === ja.TimeReport) {
          const r = /* @__PURE__ */ new Date(`${I.getToday()}T${i.item.contentData.startTime}:00`), l = /* @__PURE__ */ new Date(`${I.getToday()}T${i.item.contentData.endTime}:00`);
          i.item.contentData.totalTime = Math.floor((l.getTime() - r.getTime()) / 6e4);
        }
        e && this.list.push(i.item), (e || i.hasChanges) && i.action !== "ok-no-save" && this.commit();
      } else
        (i.action === "delete" || i.action === "delete-no-save") && (e || (this.delete(t), i.action !== "delete-no-save" && this.commit()));
    });
  }
};
Xy.bindings = new k6(), Xy.$inject = ["UiHelpers", "SessionService"];
let Cu = Xy;
class T6 extends $r {
  constructor() {
    super(...arguments), this.reportType = "<", this.crudController = "<";
  }
}
const Gy = class Gy extends Ki {
  /** Constructor for dependency injection */
  constructor(t) {
    super(t), this._rowTypes = ["expenses", "milageDaily", "milageOther", "milageOwnCar", "dailyAllowance"];
  }
  /** Template for edit UI that is shown in a modal dialog. */
  getEditDialogTemplateUrl() {
    throw new Error("Method not implemented.");
  }
  /**
   * Creating of a new item
   */
  getBlank() {
    throw new Error("Method not implemented.");
  }
  /**
   * List of items
   */
  get list() {
    return this.parent ? this.parent.messages : null;
  }
  /**
   * Ensure that atleast one message exists
   */
  getCalcRowMessage() {
    const t = this.list.findIndex((e) => e.type === ja.CalcRow);
    return t >= 0 ? this.list[t] : (this.list.unshift({ type: ja.CalcRow, contentData: { rows: [] } }), this.list[0]);
  }
  /**
   * Get rowTypes based on report type
   */
  getRowTypes() {
    if (this.reportType === "expense")
      return this._rowTypes;
    if (this.reportType === "travel")
      return this._rowTypes;
  }
};
Gy.bindings = new T6(), Gy.$inject = ["UiHelpers"];
let $u = Gy;
const DS = class DS {
  constructor(t, e, a, n) {
    this.api = t, this.uiHelpers = e, this.uploadService = a, this.workflowService = n, this._wfType = "EmployerMessageRecord", this._events = [];
  }
  /**
   * Loads the records for the entity.
   */
  $onInit() {
    this.reload();
  }
  /**
   * Reloads data
   */
  reload() {
    this.isLoading = !0, this.api.getForEntity(this.entityType, this.entityId).then((t) => {
      this.records = t, this.isLoading = !1;
    });
  }
  /** Returns events for the record. */
  getEvents(t) {
    return this.events.filter((e) => e.record && e.record === t.id);
  }
  /** Returns single event for the record. */
  getSingleEvent(t) {
    const e = this.getEvents(t);
    return e.length > 0 ? e[0] : {};
  }
  /**
   * Shows the edit dialog.
   * @param item Item to edit or to create.
   * @param index Current index. -1 for new.
   */
  showEditRecord(t, e = -1) {
    const a = {
      title: e < 0 ? L.get("SALAXY.UI_Terms.add") : this.readOnly ? L.get("SALAXY.UI_Terms.show") : L.get("SALAXY.UI_Terms.edit"),
      showDelete: e > -1 && !this.readOnly,
      readOnly: this.readOnly,
      recordTypes: [],
      getAttachmentDownloadUrl: (i) => this.getAttachmentDownloadUrl(i),
      getAttachmentIcon: (i) => this.getAttachmentIcon(i),
      uploadAttachments: (i, r) => this.uploadAttachments(i, r)
    };
    t.entityType = this.entityType, t.entityId = this.entityId;
    const n = { record: t, wfEvent: this.getSingleEvent(t) };
    a.recordTypes.push(...this.records.map((i) => i.recordType).filter((i, r, l) => l.indexOf(i) === r)), a.recordTypes.sort(), this.uiHelpers.openEditDialog("salaxy-components/modals/records/Record.html", n, a).then((i) => {
      i.action === "ok" ? e === -1 ? this.api.save(i.item.record).then((r) => {
        this.records.push(r), this.saveWorkflowEvent(r, i.item.wfEvent);
      }) : this.api.save(i.item.record).then((r) => {
        wt.copy(r, this.records[e]), this.saveWorkflowEvent(this.records[e], i.item.wfEvent);
      }) : i.action === "delete" && (this.deleteRecord(i.item.record, e), this.deleteWorkflowEvent(i.item.wfEvent));
    }), this.api.getRecordTypes().then((i) => {
      a.recordTypes.push(...i ?? []), a.recordTypes.splice(0, a.recordTypes.length, ...a.recordTypes.filter((r, l, o) => o.indexOf(r) === l)), a.recordTypes.sort();
    });
  }
  /**
   * Deletes one record
   * @param item Item to delete.
   * @param index Current index.
   */
  deleteRecord(t, e = -1) {
    if (e > -1) {
      const a = this.getSingleEvent(t);
      return this.api.delete(t.id).then(() => (this.records.splice(e, 1), this.deleteWorkflowEvent(a)));
    }
  }
  /** Returns file icon for the attachment. */
  getAttachmentIcon(t) {
    return this.uploadService.getFileIcon(t?.fileName);
  }
  /** Returns download url for the attachment. */
  getAttachmentDownloadUrl(t) {
    return this.uploadService.getFileUrl(t?.contentId);
  }
  /** Returns the upload url for the attachment */
  getAttachmentUploadUrl() {
    return this.api.getRecordUploadUrl(this.entityType, this.entityId);
  }
  /**
   * Uploads the attachments to the server, and adds them to the attchment collection.
   * @param files The files collection from the upload component
   * @param attachments The attachment collection for the results.
   */
  uploadAttachments(t, e) {
    if (t && t.length) {
      const a = this.getAttachmentUploadUrl(), n = this.uiHelpers.showLoading("SALAXY.NG1.MessageThreadComponent.uploadFilesSaving");
      return this.uploadService.upload(
        a,
        { files: t }
      ).then((i) => (i && e.push(...i), n.dismiss(), i)).catch((i) => {
        throw n.dismiss(), this.uiHelpers.showAlert("SALAXY.UI_Terms.error", "SALAXY.NG1.MessageThreadComponent.uploadFilesError"), new Error(i);
      });
    }
  }
  deleteWorkflowEvent(t) {
    return this.cleanWorkflowEvents().then(() => t.id ? this.workflowService.deleteWorkflowEvent(this.apiCtrl, t.id) : Promise.resolve(this.apiCtrl.current));
  }
  saveWorkflowEvent(t, e) {
    return e.message ? this.cleanWorkflowEvents().then(() => (e.record = t.id, e.type = this._wfType, this.workflowService.saveWorkflowEvent(this.apiCtrl, e))) : this.deleteWorkflowEvent(e);
  }
  async cleanWorkflowEvents() {
    const t = this.events.filter((e) => e.id && (!e.record || e.record && !this.records.some((a) => e.record === a.id)));
    for (const e of t)
      await this.workflowService.deleteWorkflowEvent(this.apiCtrl, e.id);
    return this.apiCtrl.current;
  }
  get entityId() {
    return this.entityType == "employment" ? (
      // Support old worker based cruds (not sure if this hack is needed anymore)
      this.apiCtrl.getApi().getBaseUrl() === "/accounts/workers" ? this.apiCtrl.current.employmentId : this.apiCtrl.current.id
    ) : this.entityType == "account" ? null : this.apiCtrl.current.id;
  }
  get events() {
    const t = (this.apiCtrl.current?.workflowData?.events ?? []).filter((e) => e.type == this._wfType);
    return this.modifyArray(t, this._events), this._events;
  }
  modifyArray(t, e) {
    wt.equals(t, e) || (e.splice(0, e.length), e.push(...t));
  }
};
DS.$inject = [
  "Records",
  "UiHelpers",
  "UploadService",
  "WorkflowService"
];
let Mg = DS;
const IS = class IS extends nn {
  constructor(t, e, a, n, i, r) {
    super(t, a, n, i), this.filesApi = t, this.reportsApi = e, this.$timeout = r, this.panelQueryOptions = {
      $filter: "entityType eq 'MonthlyReport.MonthlyAccounting'",
      $orderby: "logicalDate desc",
      $top: 5
    }, this.selectionDataReader = {
      /** Function to read data into given array */
      read: (l, o, c, d) => {
        const p = this.odataController.selectedItems;
        let h = 0;
        const g = () => {
          if (h === p.length)
            return Promise.resolve();
          const x = p[h++];
          return this.reportsApi.getAccountingData(x.id, l, o).then((b) => {
            if (d) {
              const A = {
                type: "PartnerMessageClosed",
                ui: "success",
                message: d
              };
              return this.filesApi.saveWorkflowEvent(x, A).then(() => (this.setWorkflowEvent(x, A), b && c.push(b), g()));
            } else
              return b && c.push(b), g();
          });
        };
        return g().then(() => Promise.resolve());
      },
      /** Optional label for data export */
      exportLabel: L.get("SALAXY.NG1.AccountingReportToolsComponent.exportLabel"),
      /** Indicates if the export is not possible */
      disabled: () => !this.odataController.selectedItems || this.odataController.selectedItems.length === 0,
      /* Indicates if row is expandable */
      showExpand: !1,
      /* Indicates if rows exists*/
      hasRows: () => !this.odataController.selectedItems || this.odataController.selectedItems.length === 0
    }, this.currentDataReader = {
      /** Function to read data into given array */
      read: (l, o, c, d) => {
        if (this.currentData)
          if (d) {
            const p = {
              type: "PartnerMessageClosed",
              ui: "success",
              message: d
            };
            return this.filesApi.saveWorkflowEvent(this.current, p).then(() => (c.push(this.currentData), this.reload().then(() => Promise.resolve())));
          } else
            return c.push(this.currentData), Promise.resolve();
        else
          return Promise.resolve();
      },
      /** Optional label for data export */
      exportLabel: null,
      /** Indicates if the export is not possible */
      disabled: () => !this.currentData,
      /* Indicates if row is expandable */
      showExpand: !0,
      /* Indicates if rows exists*/
      hasRows: () => !this.currentData?.ledgerAccounts
    }, this.currentDataStatus = "initial", this.getODataFilter = () => {
      const l = I.format(I.add(this.logicalDate, 1, "year"), "YYYY-01-01");
      return `entityType eq 'MonthlyReport.MonthlyAccounting' and logicalDate ge ${this.logicalDate} and logicalDate lt ${l}`;
    }, this.getItemDataReader = (l) => ({
      /** Function to read data into given array */
      read: (o, c, d, p) => (l.isReading = !0, this.reportsApi.getAccountingData(l.id, o, c).then((h) => {
        if (p) {
          const g = {
            type: "PartnerMessageClosed",
            ui: "success",
            message: p
          };
          return this.filesApi.saveWorkflowEvent(l, g).then(() => (this.setWorkflowEvent(l, g), h && d.push(h), l.isReading = !1, Promise.resolve()));
        } else
          return h && d.push(h), l.isReading = !1, Promise.resolve();
      })),
      /** Optional label for data export */
      exportLabel: null,
      /** Indicates if the export is not possible */
      disabled: () => !1,
      /* Indicates if row is expandable */
      showExpand: !0,
      /* Indicates if rows exists*/
      hasRows: !0
    });
  }
  /**
   * Initialization code.
   */
  $onInit() {
    super.$onInit(), I.getMonth("today") === 1 ? this.logicalDate = I.format(I.add("today", -1, "year"), "YYYY-01-01") : this.logicalDate = I.format("today", "YYYY-01-01");
  }
  /** Implements the getDefaults of ApiCrudObjectController */
  getDefaults() {
    return {
      listUrl: this.listUrl || "/accounting",
      detailsUrl: this.detailsUrl || "/accounting/details/",
      oDataTemplateUrl: "salaxy-components/odata/lists/ApiCrudObject.html",
      oDataOptions: {}
    };
  }
  /** Event handler for logical date. */
  logicalDateChanged() {
    this.odataController.selectedItems && this.odataController.selectedItems.splice(0, this.odataController.selectedItems.length), this.odataController.options.$filter = this.getODataFilter(), this.odataController.refresh();
  }
  /** Unselect all */
  unselectAll() {
    this.odataController.selectedItems && this.odataController.selectedItems.splice(0, this.odataController.selectedItems.length);
  }
  /** Select all */
  selectAll() {
    this.odataController.selectedItems && this.odataController.items && (this.odataController.selectedItems.splice(0, this.odataController.selectedItems.length), this.odataController.selectedItems.push(...this.odataController.items));
  }
  /** Accounting data of the current item. */
  get currentData() {
    return this.currentId ? this.loadCurrentData() : (this._currentData = null, this.currentDataStatus = "initial"), this._currentData;
  }
  /** Load current data */
  loadCurrentData(t = null) {
    if (t == null)
      if (this.currentDataStatus === "initial")
        t = "default";
      else {
        if (this.currentDataStatus === "loading")
          return;
        t = this.currentDataStatus.split(".")[1];
      }
    const e = `${this.currentId}.${t}`;
    if (this.currentDataStatus !== e && this.currentDataStatus !== "loading") {
      this.currentDataStatus = "loading";
      const a = this.uiHelpers.showLoading("SALAXY.UI_Terms.wait");
      this.reportsApi.getAccountingData(this.currentId, t, null).then((n) => {
        n && (this._currentData = n), this.currentDataStatus = e, a.dismiss();
      });
    }
  }
  setWorkflowEvent(t, e) {
    t.flags = (t.flags || []).filter((a) => a !== e.type), t.messages = (t.messages || []).filter((a) => !a.startsWith(e.type)), t.flags.push(e.type), t.messages.push(`${e.type} (Ui${e.ui}): ${e.message} ()`);
  }
};
IS.$inject = [
  "Files",
  "Reports",
  "UiHelpers",
  "$location",
  "$routeParams",
  "$timeout"
];
let Su = IS;
const PS = class PS {
  constructor(t, e) {
    this.reportsApi = t, this.uiHelpers = e, this.queryType = "periodQuery", this.periodType = Wi.Month, this.periodDateKind = _u.PaidAtDate, this.calculations = [], this.dataReader = {
      /**
       * Function to read data into given array
       * TODO: Should make interface for this or otherwise go-through.
       */
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      read: (a, n, i, r) => (this.data && i.push(this.data), Promise.resolve()),
      /** Optional label for data export */
      exportLabel: null,
      /** Indicates if the export is not possible */
      disabled: () => !this.data,
      /* Indicates if row is expandable */
      showExpand: !0,
      /* Indicates if rows exists*/
      hasRows: () => !this.data?.ledgerAccounts
    };
  }
  /**
   * Initialize controller values.
   */
  $onInit() {
    this.view = this.view || "partial", this.refDate = I.format(I.add("today", -1, "month"), "YYYY-MM-01"), this.calcs?.length > 0 && (this.queryType = "calcs", this.queryData());
  }
  /**
   * Opens the list of calculations into a dialog window for selection and then adds them to the selected calculations
   * @param category Either "paid" or "draft".
   */
  addCalcs(t = "draft") {
    const e = [];
    this.uiHelpers.openEditDialog(
      "salaxy-components/modals/calc/CalcList.html",
      e,
      {
        title: t === "paid" ? "Valitse maksetut palkat" : "Valitse luonnokset",
        category: t
      }
    ).then((a) => {
      if (a.action === "ok" && a.item.length > 0)
        for (const n of a.item)
          this.calculations.some((i) => i.id === n.id) || this.calculations.push(n);
    });
  }
  /** Removes the selected calculation from the calculations list. */
  removeCalc(t) {
    this.calculations = this.calculations.filter((e) => e.id !== t.id);
  }
  /** Queries the report data. */
  queryData(t = "default") {
    const e = this.uiHelpers.showLoading("SALAXY.UI_Terms.wait");
    switch (this.queryType) {
      case "periodQuery":
        this.reportsApi.getAccountingDataForPeriod(this.refDate, t, this.periodType, this.endDate, this.periodDateKind).then((a) => {
          this.data = a, e.dismiss();
        });
        break;
      case "selectionQuery": {
        const a = this.calculations.map((n) => n.id);
        this.reportsApi.getAccountingDataForCalculationIds(a, t).then((n) => {
          this.data = n, e.dismiss();
        });
        break;
      }
      case "calcs":
        this.reportsApi.getAccountingDataForCalculations(this.calcs, t).then((a) => {
          this.data = a, e.dismiss();
        });
        break;
      default:
        throw e.dismiss(), new Error("Unknown queryType: " + this.queryType);
    }
  }
};
PS.$inject = [
  "Reports",
  "UiHelpers"
];
let Xg = PS;
const ES = class ES {
  constructor(t, e, a) {
    this.templates = t, this.$sce = e, this.settingsService = a, this.reportData = {
      headerFooter: {},
      layout: {},
      report: {}
    };
  }
  /**
   * Initialize controller values.
   */
  $onInit() {
    this.view = this.view || "partial", this.reportData.layout = kb.getReportLayout(!1);
  }
  /** Expand/close all nodes */
  expand(t = !1) {
    if (this.data)
      for (const e of this.data.ledgerAccounts)
        e.rowToggle = !t;
  }
  /** Returns true if at least one account is toggled */
  get anyExpanded() {
    if (this.data) {
      for (const t of this.data.ledgerAccounts)
        if (t.rowToggle)
          return !0;
    }
    return !1;
  }
  /** Bindable and trusted html. */
  get html() {
    if (this.calcLang = this.lang === "default" ? "fi" : this.lang, !this.data)
      this.renderedData = null, this.renderedLang = null;
    else {
      const t = wt.copy(this.data);
      (!this.renderedData || !wt.equals(t, this.renderedData) || this.renderedLang !== this.calcLang) && (this.renderedData = t, this.renderedLang = this.calcLang, this.refresh());
    }
    return this.htmlData;
  }
  /**
   * Refresh calculation report data.
   */
  refresh() {
    this.refreshInprogress || (this.refreshInprogress = !0, this.settingsService.getReportOptions().then((t) => {
      this.reportOptions = t;
      const e = this.getDefaultReportOptions(wt.copy(this.reportOptions));
      this.reportData.headerFooter = kb.getHeaderFooter(this.data, this.reportOptions, this.calcLang), this.reportData.layout.hasCustomCss = !1, this.reportData.layout.customCss = "", this.reportData.layout.margin = {
        top: e.margin.top,
        right: e.margin.right,
        bottom: e.margin.bottom,
        left: e.margin.left
      };
      const a = new io();
      this.reportData.headerHtml = this.reportOptions?.headerTemplate ? a.getHtmlDynamic(this.reportOptions.headerTemplate, this.reportData.headerFooter, this.calcLang) : "", this.reportData.footerHtml = this.reportOptions?.headerTemplate ? a.getHtmlDynamic(this.reportOptions.footerTemplate, this.reportData.headerFooter, this.calcLang) : "", this.reportData.report = kb.getAccountingReport(this.data), this.htmlData = this.$sce.trustAsHtml(this.templates.getHtml("accountingReport", this.reportData, this.calcLang)), this.refreshInprogress = !1;
    }));
  }
  getDefaultReportOptions(t) {
    return t = t || {}, t.margin = t.margin || {}, t.margin.top = se.parseNumber(t.margin.top) || 30, t.margin.right = se.parseNumber(t.margin.right) || 10, t.margin.bottom = se.parseNumber(t.margin.bottom) || 40, t.margin.left = se.parseNumber(t.margin.left) || 10, t;
  }
};
ES.$inject = ["Templates", "$sce", "SettingsService"];
let Gg = ES;
const tu = class tu {
  constructor(t, e, a, n, i, r, l) {
    this.uiHelpers = t, this.$timeout = e, this.settingsService = a, this.sessionService = n, this.$location = i, this.$http = r, this.ajax = l, this.localeId = "fi", this.locales = [
      {
        id: "fi",
        label: L.get("SALAXY.ENUM.Culture.fi.label"),
        description: L.get("SALAXY.ENUM.Culture.fi.description")
      },
      {
        id: "en",
        label: L.get("SALAXY.ENUM.Culture.en.label"),
        description: L.get("SALAXY.ENUM.Culture.en.description")
      }
    ], this.exportMethod = Ta.FileExcel, this._exportMethods = [
      {
        id: Ta.FilePdf,
        label: L.get("SALAXY.ENUM.ExportMethod.filePdf.label"),
        hasLocales: !1,
        workflowMessage: L.get("SALAXY.ENUM.ExportMethod.filePdf.workflowMessage")
      },
      {
        id: Ta.FileExcel,
        label: L.get("SALAXY.ENUM.ExportMethod.fileExcel.label"),
        hasLocales: !1,
        workflowMessage: L.get("SALAXY.ENUM.ExportMethod.fileExcel.workflowMessage")
      },
      {
        id: Ta.CopyExcel,
        label: L.get("SALAXY.ENUM.ExportMethod.copyExcel.label"),
        hasLocales: !0,
        workflowMessage: L.get("SALAXY.ENUM.ExportMethod.copyExcel.workflowMessage")
      },
      {
        id: Ta.FileCsv,
        label: L.get("SALAXY.ENUM.ExportMethod.fileCsv.label"),
        hasLocales: !0,
        workflowMessage: L.get("SALAXY.ENUM.ExportMethod.fileCsv.workflowMessage")
      },
      {
        id: Ta.CopyCsv,
        label: L.get("SALAXY.ENUM.ExportMethod.copyCsv.label"),
        hasLocales: !0,
        workflowMessage: L.get("SALAXY.ENUM.ExportMethod.copyCsv.workflowMessage")
      },
      {
        id: Ta.FileText,
        label: L.get("SALAXY.ENUM.ExportMethod.fileText.label"),
        hasLocales: !0,
        workflowMessage: L.get("SALAXY.ENUM.ExportMethod.fileText.workflowMessage")
      },
      {
        id: Ta.CopyText,
        label: L.get("SALAXY.ENUM.ExportMethod.copyText.label"),
        hasLocales: !0,
        workflowMessage: L.get("SALAXY.ENUM.ExportMethod.copyText.workflowMessage")
      },
      {
        id: Ta.Api,
        label: "API integraatio",
        hasLocales: !1,
        workflowMessage: ""
      }
    ], this.targetId = "default", this.targets = [], this.targetOptions = ZM.getSupportedTargets(), this.defaultOption = {
      // Palkkaus.fi
      getExportData: (o) => this.targetOptions["36dff2e2-e181-4f0d-9004-0e4aa92f5e17"].getExportData(o),
      defaultExportMethod: Ta.FileExcel,
      noCsvBom: !1
    };
  }
  /**
   * Initialize controller values.
   */
  $onInit() {
    new Promise((e) => {
      const a = () => {
        if (this.settingsService.current)
          return e(this.settingsService.current);
        this.$timeout(() => a(), 50);
      };
      a();
    }).then((e) => {
      this.targets = e.accounting.targets;
      for (const a of this.targets) {
        const n = this.targetOptions[a.id] || this.targetOptions[a.format] || this.defaultOption;
        a.getExportData = n.getExportData, a.schemes = n.schemes ?? [], a.defaultExportMethod = n.defaultExportMethod, a.noCsvQuotedStrings = n.noCsvQuotedStrings, a.noCsvBom = n.noCsvBom, a.formatAsText = n.formatAsText;
      }
      e.accounting.defaultTargetId && (this.targetId = e.accounting.defaultTargetId, this.setExportMethod(e.accounting.defaultTargetId));
    }), this.view = this.view || "partial";
  }
  /** Exports data in defined format. */
  export(t = null, e = !1) {
    if (t || (t = this.reader), !t)
      return console.error("No data reader for accounting data."), Promise.resolve();
    const a = e ? { dismiss: () => null } : this.uiHelpers.showLoading("SALAXY.UI_Terms.wait"), n = this.getTarget(this.targetId), i = [];
    return t.read(this.targetId, null, i, this.getWorkflowMessage()).then(() => {
      if (i.length === 0)
        return a.dismiss(), Promise.resolve();
      switch (this.exportMethod) {
        case Ta.Api:
          a.dismiss(), this.sendToApi(n, i);
          return;
        case Ta.FilePdf:
          if (i.length === 1)
            return this.getPdf(i[0]).then((r) => {
              this.uiHelpers.downloadFile(r.blob, r.fileName), a.dismiss();
            });
          {
            const r = new un();
            return ((o) => {
              const c = [];
              for (const d of o)
                c.push(this.getPdf(d));
              return Promise.all(c).then((d) => {
                let p = 0;
                d.forEach((h) => {
                  p++, r.file(`${p}_ ${h.fileName}`, h.blob);
                });
              });
            })(i).then(() => {
              r.generateAsync({
                type: "blob",
                mimeType: "application/zip"
              }).then((o) => {
                Vn.saveAs(o, `${this.getZipName(i)}.zip`), a.dismiss();
              });
            });
          }
        case Ta.FileCsv:
          if (i.length === 1) {
            const r = i[0];
            Vn.saveAs(new Blob([this.getCsv(n.getExportData(r, this.schemeId), this.localeId !== "en", !n.noCsvBom, !n.noCsvQuotedStrings)], { type: "application/octet-stream;charset=utf-8" }), `${this.getFileName(r)}.csv`), a.dismiss();
            return;
          } else {
            let r = 0;
            const l = new un(), o = () => {
              if (r === i.length)
                return;
              const c = i[r++], d = new Blob([this.getCsv(n.getExportData(c, this.schemeId), this.localeId !== "en", !n.noCsvBom, !n.noCsvQuotedStrings)], { type: "application/octet-stream;charset=utf-8" });
              l.file(`${this.getFileName(c)}.csv`, d), o();
            };
            o(), l.generateAsync({
              type: "blob",
              mimeType: "application/zip"
            }).then((c) => {
              Vn.saveAs(c, `${this.getZipName(i)}.zip`), a.dismiss();
            });
          }
          break;
        case Ta.FileExcel:
          if (i.length === 1) {
            const r = i[0];
            xr.export(n.getExportData(r, this.schemeId), this.getFileName(r)).then(() => {
              a.dismiss();
            });
          } else if (i.length > 1) {
            const r = [], l = () => {
              if (r.length === i.length)
                return;
              const o = i[r.length];
              r.push({
                tableData: n.getExportData(o, this.schemeId),
                fileName: this.getFileName(o)
              }), l();
            };
            l(), xr.exportMany(r, this.getZipName(i)).then(() => {
              a.dismiss();
            });
          }
          break;
        case Ta.FileText:
          if (i.length === 1) {
            const r = i[0];
            Vn.saveAs(new Blob([this.getText(n.getExportData(r, this.schemeId), this.localeId !== "en", n.formatAsText)], { type: "application/octet-stream;charset=utf-8" }), `${this.getFileName(r)}.txt`), a.dismiss();
            return;
          } else {
            let r = 0;
            const l = new un(), o = () => {
              if (r === i.length)
                return;
              const c = i[r++], d = new Blob([this.getText(n.getExportData(c, this.schemeId), this.localeId !== "en", n.formatAsText)], { type: "application/octet-stream;charset=utf-8" });
              l.file(`${this.getFileName(c)}.txt`, d), o();
            };
            o(), l.generateAsync({
              type: "blob",
              mimeType: "application/zip"
            }).then((c) => {
              Vn.saveAs(c, `${this.getZipName(i)}.zip`), a.dismiss();
            });
          }
          break;
        case Ta.CopyCsv:
          if (i.length === 1) {
            const r = i[0];
            this.copyToClipboard(this.getCsv(n.getExportData(r, this.schemeId), this.localeId !== "en", !n.noCsvBom, !n.noCsvQuotedStrings)), a.dismiss();
            return;
          } else if (i.length > 1) {
            let r = 0, l = n.noCsvBom ? "" : "\uFEFF";
            const o = () => {
              if (r === i.length)
                return;
              const c = i[r++];
              l += `${this.getFileName(c)}\r
`, l += this.getCsv(n.getExportData(c, this.schemeId), this.localeId !== "en", !1, !n.noCsvQuotedStrings) + (r < i.length ? `\r
` : ""), o();
            };
            o(), this.copyToClipboard(l), a.dismiss();
            return;
          }
          break;
        case Ta.CopyExcel:
          if (i.length === 1) {
            const r = i[0];
            this.copyToClipboard(this.getTabbed(
              n.getExportData(r, this.schemeId),
              this.localeId !== "en"
              /* En */
            )), a.dismiss();
            return;
          } else if (i.length > 1) {
            let r = 0, l = "";
            const o = () => {
              if (r === i.length)
                return;
              const c = i[r++];
              l += `${this.getFileName(c)}\r
`, l += this.getTabbed(
                n.getExportData(c, this.schemeId),
                this.localeId !== "en"
                /* En */
              ) + (r < i.length ? `
` : ""), o();
            };
            o(), this.copyToClipboard(l), a.dismiss();
            return;
          }
          break;
        case Ta.CopyText:
          if (i.length === 1) {
            const r = i[0];
            this.copyToClipboard(this.getText(n.getExportData(r, this.schemeId), this.localeId !== "en", n.formatAsText)), a.dismiss();
            return;
          } else if (i.length > 1) {
            let r = 0, l = "";
            const o = () => {
              if (r === i.length)
                return;
              const c = i[r++];
              l += `${this.getFileName(c)}\r
`, l += this.getText(n.getExportData(c, this.schemeId), this.localeId !== "en", n.formatAsText) + (r < i.length ? `\r
` : ""), o();
            };
            o(), this.copyToClipboard(l), a.dismiss();
            return;
          }
          break;
        default:
          a.dismiss(), this.uiHelpers.showAlert("Ei vielä toteutettu", "Tätä tiedostotyyppiä ei ole toteutettu.");
          return;
      }
      a.dismiss();
    });
  }
  /** Navigates to given path and closes possible open modal dialogs. */
  navigate(t) {
    this.$location.path(t), this.uiHelpers.dismissAllModals();
  }
  /**
   * Change target and call event handler.
   * @param targetId - New target id.
   */
  changeTarget(t) {
    this.setExportMethod(t), this.targetId = t, this.onTargetChange({ targetId: t });
  }
  /**
   * Returns the export methods that are available for the accounting target.
   */
  get exportMethods() {
    const t = this.getTarget(this.targetId), e = [];
    return t?.availableMethods?.length > 0 ? e.push(...t.availableMethods) : e.push(Ta.FilePdf, Ta.FileExcel, Ta.CopyExcel, Ta.FileCsv, Ta.CopyCsv), this._exportMethods.filter((a) => e.indexOf(a.id) > -1);
  }
  /**
   * Returns the export method type definition
   * @param exportMethodId export method id
   */
  getExportMethod(t) {
    return this.exportMethods.find((e) => e.id === t);
  }
  /**
   * Returns the target definition
   * @param targetId Target id.
   */
  getTarget(t) {
    return this.targets.find((e) => e.id === t);
  }
  /**
   * Returns the locale definition
   * @param localeId Locale id.
   */
  getLocale(t) {
    return this.locales.find((e) => e.id === t);
  }
  /**
   * Returns the scheme definition.
   * @param schemeId Scheme id.
   */
  getScheme(t) {
    return this.getTarget(this.targetId)?.schemes.find((e) => e.id === t);
  }
  setExportMethod(t) {
    if (this.targetOptions[t]) {
      this.exportMethod = this.targetOptions[t].defaultExportMethod, this.schemeId = this.targetOptions[t].schemes?.length ? this.targetOptions[t].schemes[0].id : null;
      return;
    }
    const e = this.getTarget(t);
    this.schemeId = e.schemes?.length ? e.schemes[0].id : null, this.exportMethod = e.method && e.method !== "undefined" ? e.method : e.defaultExportMethod;
  }
  /**
   * Method for calling onExpandChange event
   * @param close If true, closes the expanding component.
   */
  expand(t = !1) {
    this.onExpandChange({ close: t });
  }
  getFileName(t) {
    return ti.escapeFileName(`${L.get("SALAXY.UI_Terms.downLoadableMaterialTypes.accounting")}_${t.employer.displayName}_${I.format(t.period.start ?? "today", "YYYY_MM")}`);
  }
  getZipName(t) {
    return ti.escapeFileName(`${L.get("SALAXY.UI_Terms.downLoadableMaterialTypes.accounting")}_${I.format("today", "YYYYMMDD")}`);
  }
  getWorkflowMessage() {
    const t = this.getExportMethod(this.exportMethod);
    return t ? t.workflowMessage : null;
  }
  getCsv(t, e = !0, a, n) {
    const i = e ? ";" : ",", r = this.formatRow(e, i, n), l = t.map(r);
    return (a ? "\uFEFF" : "") + l.join(`\r
`);
  }
  getText(t, e = !0, a) {
    if (a == null) {
      const n = this.formatRow(e, "	", !1);
      return t.map(n).join(`\r
`);
    } else
      return a(t, e);
  }
  getPdf(t) {
    const e = `${Ne.current.reportServer}/pdf?id=&reportType=${encodeURIComponent("accountingReport")}&template=${encodeURIComponent("accountingReport")}&disposition=inline&access_token=${this.ajax.getCurrentToken()}`;
    return this.$http.post(e, { object: t }, { responseType: "blob" }).then((a) => {
      if (a.data)
        return Promise.resolve({ blob: a.data, fileName: a.headers("content-disposition").split(";")[1].split("filename")[1].split("=")[1].trim().replace(/"/g, "") });
    }, (a) => (console.error(a), Promise.reject(a)));
  }
  getTabbed(t, e = !0) {
    const a = this.formatRow(e, "	");
    return t.map(a).join(`
`);
  }
  formatRow(t, e, a = !0) {
    const n = this.formatField(t, a);
    return (i) => i.map(n).join(e);
  }
  formatField(t, e = !0) {
    return (a) => a == null ? "" : typeof a == "number" ? t ? a.toString().replace(".", ",") : a : typeof a == "boolean" ? a ? "TRUE" : "FALSE" : typeof a == "string" ? e ? '"' + a.replace(/"/g, '""') + '"' : a : typeof a == "object" ? a instanceof Date ? t ? I.format(a, "D.M.YYYY") : I.format(a, "YYYY-MM-DD") : e ? '"' + JSON.stringify(a).replace(/"/g, '""') + '"' : JSON.stringify(a) : JSON.stringify(a);
  }
  copyToClipboard(t) {
    navigator.clipboard.writeText(t);
  }
  async sendToApi(t, e) {
    if (!t.channel || t.channel === "undefined")
      return;
    const a = this.uiHelpers.showLoading("SALAXY.UI_Terms.wait"), n = [];
    for (const i of e)
      n.push({
        accountingData: i,
        preview: (await this.$http.post(this.getAccountingDataUrl(t, "accountingPreview"), i, { responseType: "json" }))?.data,
        result: "",
        error: ""
      });
    a.dismiss(), this.uiHelpers.openEditDialog("salaxy-components/report/modals/PostAccountingData.html", n, {
      postData: (i) => {
        i.isPosting = !0, this.$http.post(this.getAccountingDataUrl(t, "accounting"), i.accountingData, { responseType: "json" }).then((r) => {
          i.isPosting = !1, i.error = "", i.result = this.getAccountingDataResult(t, r);
        }).catch((r) => {
          i.isPosting = !1, i.error = this.getAccountingDataError(t, r), i.result = "";
        });
      },
      previewTemplateUrl: this.getAccountingDataPreviewTemplate(t)
    }, "lg");
  }
  getAccountingDataUrl(t, e) {
    const a = this.ajax.getCurrentToken();
    return `${`${Ne.current.integrationsServer}/${tu.channelBasePaths[t.channel]}/${e}`}?accessToken=${a}&accountingTargetId=${t.id}`;
  }
  getAccountingDataError(t, e) {
    return e?.data?.detail ? L.get("SALAXY.UI_Terms.error") + ", " + e.data.detail : e.data ? L.get("SALAXY.UI_Terms.error") + ", " + e.data.status + "-" + e.data.title : L.get("SALAXY.UI_Terms.error");
  }
  getAccountingDataResult(t, e) {
    switch (t.channel) {
      case Ks.VismaFivaldi:
        return L.get("SALAXY.UI_Terms.ok") + ", VismaFivaldi: " + e.data.fivaldiVoucherNumber;
      default:
        return L.get("SALAXY.UI_Terms.ok");
    }
  }
  getAccountingDataPreviewTemplate(t) {
    switch (t.channel) {
      case Ks.VismaFivaldi:
        return "salaxy-components/report/modals/FivaldiPreview.html";
      default:
        return "";
    }
  }
};
tu.$inject = [
  "UiHelpers",
  "$timeout",
  "SettingsService",
  "SessionService",
  "$location",
  "$http",
  "AjaxNg1"
], tu.channelBasePaths = {
  [Ks.Procountor]: "procountor",
  [Ks.VismaNetvisor]: "vismanetvisor",
  [Ks.VismaFivaldi]: "vismafivaldi"
};
let Hg = tu;
const NS = class NS extends nn {
  constructor(t, e, a, n, i, r, l) {
    super(t, e, a, n), this.fullApi = t, this.calcApi = i, this.absencesApi = r, this.session = l;
  }
  /**
   * Initializes the controller
   */
  $onInit() {
    super.$onInit();
  }
  /** Implements the getDefaults of ApiCrudObjectController */
  getDefaults() {
    return {
      listUrl: this.listUrl || "irepr",
      detailsUrl: this.detailsUrl || "/irepr/details/",
      oDataTemplateUrl: "salaxy-components/odata/lists/IrEpr.html",
      oDataOptions: {}
    };
  }
  /** Gets calculation */
  get calculation() {
    return this.current?.info?.calculationId != null && (this.calculationId = this.current.info.calculationId), this._calculation;
  }
  /**
   * Sets calculation and if it is different then starts the loading of the EarningsPayment object to that calculation.
   */
  set calculation(t) {
    if (!this._hasCalculationFor) {
      if (t == null || t.id == null) {
        this._calculation = null, this._calculationId = null;
        return;
      }
      this.calculationId !== t?.id && (this._calculation = t, this._calculationId = t.id, this.current?.info?.calculationId !== t.id && this.setStatus(this.calcApi.getEpr(t.id)).then((e) => {
        this.setCurrent(e);
      }));
    }
  }
  /** Gets calculation */
  get calculationId() {
    return this._calculation?.id ?? this._calculationId;
  }
  /**
   * Sets calculation and if it is different then starts the loading of the EarningsPayment object to that calculation.
   */
  set calculationId(t) {
    if (!this._hasCalculationFor) {
      if (t == null) {
        this._calculation = null, this._calculationId = null;
        return;
      }
      this.calculationId !== t && (this._calculation = null, this._calculationId = t, this.calcApi.getSingle(t).then((e) => {
        this._calculation = e;
      }), this.current?.info?.calculationId !== t && this.setStatus(this.calcApi.getEpr(t)).then((e) => {
        this.setCurrent(e);
      }));
    }
  }
  /** Used for setting the calculation with the model, without epr reload. */
  set calculationFor(t) {
    this._calculation = t, this._calculationId = t?.id, this._hasCalculationFor = !0;
  }
  /** Returns true if the report can be canceled. */
  get isCancellable() {
    return this.current && this.getLatestNonErrorReportLogEntry()?.eventType === ea.ReportLogEventType.Sent;
  }
  /** Returns true if the item is read-only */
  get isReadOnly() {
    return super.isReadOnly || !this.tempShowEditInNonAdminMode && !this.session.isInRole("admin");
  }
  /** Save resource */
  saveChanges() {
    return this._calculation && this.calcController && this.calcController.hasChanges ? this.calcApi.saveIr(this._calculation).then((t) => (this._calculation = t, this.calcApi.convertToEpr(this._calculation).then((e) => (this.current.deliveryData.reports[0].transactions = e.deliveryData.reports[0].transactions, this.save().then(() => (this.calcController.setCurrent(this._calculation), this.current)))))) : this.save().then(() => this.current);
  }
  /** Send to incomes register. */
  sendToIncomesRegister(t) {
    return this.saveChanges().then((e) => {
      if (e.validation.isValid) {
        const a = this.uiHelpers.showLoading("SALAXY.NG1.EarningsPaymentComponent.common.loaderTextSending"), n = {
          id: this.current.id,
          startAt: t ? JSON.stringify(t).replace(/"/g, "") : null,
          action: ea.IrScheduleAction.Send
        };
        return this.fullApi.sendSchedule(n).then(() => this.reloadFromServer().then(() => (a.dismiss(), this.current)));
      } else
        return this.uiHelpers.showAlert("SALAXY.NG1.EarningsPaymentComponent.common.sendFailureTitle", "SALAXY.NG1.EarningsPaymentComponent.common.validationErrorText"), this.current;
    });
  }
  /** Get latest incomes register report log entry */
  getLatestNonErrorReportLogEntry() {
    if (this.current.reportLog != null) {
      const t = this.current.reportLog.filter((e) => e.eventType !== ea.ReportLogEventType.Error);
      if (t.length > 0)
        return t[t.length - 1];
    }
    return null;
  }
  /** Sends cancel request to incomes register */
  cancelToIncomesRegister() {
    const t = this.uiHelpers.showLoading("SALAXY.NG1.EarningsPaymentComponent.common.loaderTextCanceling"), e = {
      id: this.current.id,
      action: ea.IrScheduleAction.Cancel
    };
    return this.fullApi.sendSchedule(e).then(() => this.reloadFromServer().then(() => (t.dismiss(), this.current)));
  }
  /** Opens sheculing dialog and sends scheduling after successful dialog close */
  openSetScheduleDialog() {
    const t = /* @__PURE__ */ new Date();
    return this.uiHelpers.openEditDialog("salaxy-components/report/modals/IrScheduleSendDialog.html", {
      startAtHours: t.getHours(),
      startAtMinutes: t.getMinutes(),
      startAt: t
    }, {}).then((e) => {
      if (e.result === "ok") {
        const a = new Date(e.item.startAt);
        return a.setHours(e.item.startAtHours || 0), a.setMinutes(e.item.startAtMinutes || 0), this.sendToIncomesRegister(a);
      } else
        return this.current;
    });
  }
  /** Remove Incomes register queue item */
  removeIrQueueItem() {
    const t = this.uiHelpers.showLoading("SALAXY.NG1.EarningsPaymentComponent.common.loaderTextRemoving");
    return this.fullApi.removeIrQueueItem(this.current.id).then(() => this.reloadFromServer().then(() => (t.dismiss(), this.current)));
  }
  /** Opens a dialog for importing absences. */
  importAbsences() {
    this.absencesApi.getForEmployment(this.calculation.worker.employmentId).then((t) => {
      this.uiHelpers.openEditDialog("salaxy-components/report/modals/IrImportAbsencesDialog.html", t, {}).then((e) => {
        if (e.result === "ok" && t.periods) {
          const a = t.periods.filter((n) => n.selected);
          if (a.length > 0) {
            const n = this.current.deliveryData.reports[0];
            n.absence = n.absence ?? {};
            let i = null, r = null;
            a.forEach((l) => {
              l.isPaid ? (n.absence.paidAbsence = n.absence.paidAbsence ?? {}, n.absence.paidAbsence.paidAbsencePeriods = n.absence.paidAbsence.paidAbsencePeriods ?? [], n.absence.paidAbsence.paidAbsencePeriods.push({
                startDate: l.period?.start,
                endDate: l.period?.end,
                causeCode: this.getPaidAbsenceCauseCode(l.causeCode),
                absenceDays: l.period?.daysCount,
                amount: l.amount
              })) : (n.absence.unpaidAbsence = n.absence.unpaidAbsence ?? {}, n.absence.unpaidAbsence.unpaidAbsencePeriods = n.absence.unpaidAbsence.unpaidAbsencePeriods ?? [], n.absence.unpaidAbsence.unpaidAbsencePeriods.push({
                startDate: l.period?.start,
                endDate: l.period?.end,
                causeCode: this.getUnpaidAbsenceCauseCode(l.causeCode),
                absenceDays: l.period?.daysCount
              })), (!i || l.period && l.period.start && I.asDate(i) > I.asDate(l.period.start)) && (i = l.period?.start), (!r || l.period && l.period.end && I.asDate(r) < I.asDate(l.period.end)) && (r = l.period?.end);
            }), n.absence.absenceRepStartDate = i, n.absence.absenceRepEndDate = r;
          }
        }
      });
    });
  }
  /** Checks if the IR report is modified. */
  isIrModified(t) {
    return t.flags.some((e) => e === "modified");
  }
  /** Checks if the Epr is delayed. */
  isDelayed(t) {
    if (!t.data.firstDeliveredAt) {
      const e = I.add(t.salaryDate, 5, "day"), a = I.addWorkdays(e, 0);
      return I.asDate("today") > a;
    }
    return !1;
  }
  reloadFromServer() {
    return this.setStatus(this.api.getSingle(this.current.id)).then((t) => (this.setCurrent(t), t));
  }
  getUnpaidAbsenceCauseCode(t) {
    switch (t) {
      case Ge.Illness:
        return ea.UnpaidAbsenceCauseCode.Illness;
      case Ge.PartTimeSickLeave:
        return ea.UnpaidAbsenceCauseCode.PartTimeSickLeave;
      case Ge.ParentalLeave:
        return ea.UnpaidAbsenceCauseCode.ParentalLeave;
      case Ge.SpecialMaternityLeave:
        return ea.UnpaidAbsenceCauseCode.SpecialMaternityLeave;
      case Ge.Rehabilitation:
        return ea.UnpaidAbsenceCauseCode.Rehabilitation;
      case Ge.ChildIllness:
        return ea.UnpaidAbsenceCauseCode.ChildIllness;
      case Ge.PartTimeChildCareLeave:
        return ea.UnpaidAbsenceCauseCode.PartTimeChildCareLeave;
      case Ge.Training:
        return ea.UnpaidAbsenceCauseCode.Training;
      case Ge.JobAlternationLeave:
        return ea.UnpaidAbsenceCauseCode.JobAlternationLeave;
      case Ge.StudyLeave:
        return ea.UnpaidAbsenceCauseCode.StudyLeave;
      case Ge.IndustrialAction:
        return ea.UnpaidAbsenceCauseCode.IndustrialAction;
      case Ge.InterruptionInWorkProvision:
        return ea.UnpaidAbsenceCauseCode.InterruptionInWorkProvision;
      case Ge.LeaveOfAbsence:
        return ea.UnpaidAbsenceCauseCode.LeaveOfAbsence;
      case Ge.MilitaryRefresherTraining:
        return ea.UnpaidAbsenceCauseCode.MilitaryRefresherTraining;
      case Ge.MilitaryService:
        return ea.UnpaidAbsenceCauseCode.MilitaryService;
      case Ge.LayOff:
        return ea.UnpaidAbsenceCauseCode.LayOff;
      case Ge.ChildCareLeave:
        return ea.UnpaidAbsenceCauseCode.ChildCareLeave;
      case Ge.Other:
      default:
        return ea.UnpaidAbsenceCauseCode.Other;
    }
  }
  getPaidAbsenceCauseCode(t) {
    switch (t) {
      case Ge.Illness:
        return ea.PaidAbsenceCauseCode.Illness;
      case Ge.PartTimeSickLeave:
        return ea.PaidAbsenceCauseCode.PartTimeSickLeave;
      case Ge.ParentalLeave:
        return ea.PaidAbsenceCauseCode.ParentalLeave;
      case Ge.SpecialMaternityLeave:
        return ea.PaidAbsenceCauseCode.SpecialMaternityLeave;
      case Ge.Rehabilitation:
        return ea.PaidAbsenceCauseCode.Rehabilitation;
      case Ge.ChildIllness:
        return ea.PaidAbsenceCauseCode.ChildIllness;
      case Ge.PartTimeChildCareLeave:
        return ea.PaidAbsenceCauseCode.PartTimeChildCareLeave;
      case Ge.Training:
        return ea.PaidAbsenceCauseCode.Training;
      case Ge.LeaveOfAbsence:
        return ea.PaidAbsenceCauseCode.LeaveOfAbsence;
      case Ge.MilitaryRefresherTraining:
        return ea.PaidAbsenceCauseCode.MilitaryRefresherTraining;
      case Ge.MidWeekHoliday:
        return ea.PaidAbsenceCauseCode.MidWeekHoliday;
      case Ge.AccruedHoliday:
        return ea.PaidAbsenceCauseCode.AccruedHoliday;
      case Ge.OccupationalAccident:
        return ea.PaidAbsenceCauseCode.OccupationalAccident;
      case Ge.AnnualLeave:
        return ea.PaidAbsenceCauseCode.AnnualLeave;
      case Ge.PartTimeAbsenceDueToRehabilitation:
        return ea.PaidAbsenceCauseCode.PartTimeAbsenceDueToRehabilitation;
      case Ge.Other:
      default:
        return ea.PaidAbsenceCauseCode.Other;
    }
  }
};
NS.$inject = [
  "IrEarningsPayments",
  "UiHelpers",
  "$location",
  "$routeParams",
  "Calculations",
  "Absences",
  "SessionService"
];
let ku = NS;
const RS = class RS extends nn {
  constructor(t, e, a, n, i) {
    super(t, e, a, n), this.fullApi = t, this.session = i;
  }
  /**
   * Initializes the controller
   */
  $onInit() {
    super.$onInit();
  }
  /** Implements the getDefaults of ApiCrudObjectController */
  getDefaults() {
    return {
      listUrl: this.listUrl || "irpsr",
      detailsUrl: this.detailsUrl || "/irpsr/details/",
      oDataTemplateUrl: "salaxy-components/odata/lists/IrPsr.html",
      oDataOptions: {}
    };
  }
  /** Returns true if the report can be canceled. */
  get isCancellable() {
    return this.current && this.getLatestNonErrorReportLogEntry()?.eventType === Kp.ReportLogEventType.Sent;
  }
  /** Returns true if the item is read-only */
  get isReadOnly() {
    return super.isReadOnly || !this.tempShowEditInNonAdminMode && !this.session.isInRole("admin");
  }
  /** Send to incomes register  */
  sendToIncomesRegister(t) {
    return this.save().then((e) => {
      if (e.validation.isValid) {
        const a = this.uiHelpers.showLoading("SALAXY.NG1.PayerSummaryComponent.common.loaderTextSending"), n = {
          id: this.current.id,
          startAt: t ? JSON.stringify(t).replace(/"/g, "") : null,
          action: Kp.IrScheduleAction.Send
        };
        return this.fullApi.sendSchedule(n).then(() => this.reloadFromServer().then(() => (a.dismiss(), this.current)));
      } else
        return this.uiHelpers.showAlert("SALAXY.NG1.PayerSummaryComponent.common.sendFailureTitle", "SALAXY.NG1.PayerSummaryComponent.common.validationErrorText"), this.current;
    });
  }
  /** Get latest incomes register report log entry */
  getLatestNonErrorReportLogEntry() {
    if (this.current.reportLog != null) {
      const t = this.current.reportLog.filter((e) => e.eventType !== Kp.ReportLogEventType.Error);
      if (t.length > 0)
        return t[t.length - 1];
    }
    return null;
  }
  /** Sends cancel request to incomes register */
  cancelToIncomesRegister() {
    const t = this.uiHelpers.showLoading("SALAXY.NG1.PayerSummaryComponent.common.loaderTextCanceling"), e = {
      id: this.current.id,
      action: Kp.IrScheduleAction.Cancel
    };
    return this.fullApi.sendSchedule(e).then(() => this.reloadFromServer().then(() => (t.dismiss(), this.current)));
  }
  /** Opens sheculing dialog and sends scheduling after successful dialog close */
  openSetScheduleDialog() {
    return this.uiHelpers.openEditDialog("salaxy-components/report/modals/IrScheduleSendDialog.html", {
      startAt: /* @__PURE__ */ new Date()
    }, {}).then((t) => t.result === "ok" ? this.sendToIncomesRegister(t.item.startAt) : this.current);
  }
  /** Remove Incomes register queue item */
  removeIrQueueItem() {
    const t = this.uiHelpers.showLoading("SALAXY.NG1.PayerSummaryComponent.common.loaderTextRemoving");
    return this.fullApi.removeIrQueueItem(this.current.id).then(() => this.reloadFromServer().then(() => (t.dismiss(), this.current)));
  }
  /** Checks if the IR report is modified. */
  isIrModified(t) {
    return t.flags.some((e) => e === "modified");
  }
  /** Checks if the Psr is delayed. */
  isDelayed(t) {
    if (!t.data.firstDeliveredAt) {
      const e = I.add(I.add(t.logicalDate, 1, "month"), 4, "day"), a = I.addWorkdays(e, 0);
      return I.asDate("today") > a;
    }
    return !1;
  }
  reloadFromServer() {
    return this.setStatus(this.api.getSingle(this.current.id)).then((t) => (this.setCurrent(t), t));
  }
};
RS.$inject = [
  "IrPayerSummaries",
  "UiHelpers",
  "$location",
  "$routeParams",
  "SessionService"
];
let Tu = RS;
const YS = class YS {
  constructor(t, e) {
    this.reportsService = t, this.sessionService = e, this.types = this.getReportTypes(), this.$onInit = () => {
    };
  }
  /**
   * Gets a list of reports (metadata only) filtered by a report type.
   * @param type - Type of report. See type (string enumeration) for possible values. Default is the property reportType.
   */
  getReports(t = this.reportType) {
    return this.reportsService.getReports(t);
  }
  /**
   * Gets a list of available report types for the current user.
   * TODO: This method is still under construction.
   */
  getReportTypes() {
    return vv.getReportTypes().filter((a) => this.sessionService.isInSomeRole(a.roles));
  }
  /**
   * Gets an HTML report based on Calculation ID, runs it through $sce
   * and sets it as reportHtml.
   * @param reportType - Type of the report to fetch. See the HtmlReportType enumeration for possible values.
   * @param calculationId - GUID for the calculation
   * @returns A Promise with result HTML - already run through $sce.
   */
  getReportHtmlById(t, e) {
    return this.reportHtml = "<salaxy-spinner></salaxy-spinner>", this.reportsService.getReportHtmlById(t, e).then((a) => (this.reportHtml = a, a)).catch((a) => {
      this.reportHtml = `<div class="alert alert-danger"><strong>Error in fetching report</strong><pre>${wt.toJson(a)}</pre></div>`;
    });
  }
};
YS.$inject = [
  "ReportsService",
  "SessionService"
];
let Ug = YS;
const _S = class _S extends wr {
  constructor(t, e, a, n, i, r, l) {
    super(t, e, a, n, i, r, l), this.invoicesService = l, this.panelQueryOptions = {
      $filter: "status eq 'paymentSucceeded'",
      $top: 5,
      $orderby: "salaryDate desc"
    }, this.queryOptions = {
      $filter: "status eq 'paymentSucceeded'",
      $top: 20,
      $orderby: "salaryDate desc"
    };
  }
  /**
   * Initializes the controller
   */
  $onInit() {
    super.$onInit();
  }
  /** Implements the getDefaults of ApiCrudObjectController */
  getDefaults() {
    return {
      listUrl: this.listUrl || "reports/salary-reports",
      detailsUrl: this.detailsUrl || "/calc/details/",
      oDataTemplateUrl: "salaxy-components/odata/lists/SalaryReportsPanel.html",
      oDataOptions: {}
    };
  }
  /** Unselect all */
  unselectAll() {
    this.odataController.selectedItems && this.odataController.selectedItems.splice(0, this.odataController.selectedItems.length);
  }
  /** Select all */
  selectAll() {
    this.odataController.selectedItems && this.odataController.items && (this.odataController.selectedItems.splice(0, this.odataController.selectedItems.length), this.odataController.selectedItems.push(...this.odataController.items));
  }
};
_S.$inject = ["Calculations", "ReportsService", "UiHelpers", "$location", "$routeParams", "SessionService", "InvoicesService"];
let Fg = _S;
const OS = class OS extends bi {
  constructor(t, e, a) {
    super(t, e), this.reports = a, this.worker = null, this.selectedWorkers = [], this.periodCalculations = [], this.validation = null, this.wizardSteps = [
      {
        title: L.get("SALAXY.NG1.PayCertificateComponent.wizard.stepSelectWorkerTitle"),
        view: "salaxy-components/report/PayCertificateStep1.html"
      },
      {
        title: L.get("SALAXY.NG1.PayCertificateComponent.wizard.stepSelectPeriodCalcsTitle"),
        view: "salaxy-components/report/PayCertificateStep2.html"
      },
      {
        title: L.get("SALAXY.NG1.PayCertificateComponent.wizard.stepAdditionalInfoTitle"),
        view: "salaxy-components/report/PayCertificateStep3.html"
      }
    ];
  }
  /**
   * Initialization of the controller
   */
  $onInit() {
    super.$onInit(), this.wizardService.setSteps(this.wizardSteps), this.wizardService.activeStepNumber = 1;
  }
  /** Returns true if goNext is enabled  */
  get canGoNext() {
    return this.steps.length > this.step && this.steps[this.step] && !this.steps[this.step].disabled ? !(this.step === 1 && this.selectedWorkers.length === 0 || this.step === 2 && this.periodCalculations.length === 0) : !1;
  }
  /**
   * Navigates to the next step if possible
   */
  goNext() {
    super.goNext(), this.step === 3 && this.validate();
  }
  /** Selects the worker and advances the workflow */
  selectWorker(t, e) {
    e && (this.worker = t, this.selectedWorkers.splice(0, this.selectedWorkers.length), this.selectedWorkers.push(this.worker), this.periodCalculations = [], this.validation = null, this.goNext());
  }
  /** Selects calculations from the period */
  selectCalculations(t, e) {
    let a = I.add("today", -1 * e, "week");
    a = I.startEnd(a, "start-week"), this.periodCalculations.splice(0, this.periodCalculations.length);
    for (const n of t)
      I.asDate(n.salaryDate) >= a && this.periodCalculations.push(n);
  }
  /** Selects calculations from the period */
  unselectCalculations() {
    this.periodCalculations.splice(0, this.periodCalculations.length);
  }
  /**
   * Returns the url for downloading pdf.
   * @param inline If true will open the pdf. The default is false: download as attachment.
   * @returns URL for downloading the report.
   */
  getDownloadPdfUrl(t = !1) {
    return !this.worker || !this.periodCalculations || this.periodCalculations.length === 0 ? null : this.reports.getPayCertificatePdfUrl(this.worker.otherId, this.periodCalculations.map((e) => e.id), t);
  }
  /**
   * Validates the report server side.
   */
  validate() {
    this.validation = null, !(!this.worker || !this.periodCalculations || this.periodCalculations.length === 0) && this.reports.validatePayCertificate(this.worker.otherId, this.periodCalculations.map((t) => t.id)).then((t) => {
      this.validation = t;
    });
  }
  /**
   * Start new wizard
   */
  startNew() {
    this.step = 1, this.worker = null, this.selectedWorkers.splice(0, this.selectedWorkers.length), this.periodCalculations = [], this.validation = null;
  }
};
OS.$inject = ["$scope", "WizardService", "Reports"];
let zg = OS;
class uR {
  constructor(t, e, a) {
    this.datasets = t, this.uiHelpers = e, this.sessionService = a, this.queryOptions = {
      period: {
        periodType: Wi.Month,
        refDate: I.format(I.add("today", -1, "month"), "YYYY-MM-01"),
        endDate: null,
        periodDateKind: _u.SalaryDate,
        selectedWorkers: []
      },
      calculations: [],
      payrolls: []
    }, this.templates = [];
  }
  /**
   * Initialize controller values.
   */
  $onInit() {
    Promise.resolve(Ne.global.agGrid).then((e) => {
      const a = e;
      a.LicenseManager.setLicenseKey("CompanyName=Suomen Palkanlaskenta Oy,LicensedGroup=Palkkaus.fi,LicenseType=MultipleApplications,LicensedConcurrentDeveloperCount=3,LicensedProductionInstancesCount=1,AssetReference=AG-012462,ExpiryDate=17_December_2021_[v2]_MTYzOTY5OTIwMDAwMA==5d6e41ff68f667b432fc0424ad42ca1d"), a.ModuleRegistry.getRegisteredModules().length || a.ModuleRegistry.registerModules(a.AllModules);
      const i = document.querySelector(this.gridElmentId);
      this.grid = new a.Grid(i, this.gridOptions), this.loadTemplates();
    });
  }
  /**
   * Returns the template definition
   * @param templateId Template id.
   */
  getTemplate(t) {
    return this.templates.find((e) => e.id === t);
  }
  /**
   * Selects the template to show
   * @param templateId The selected template.
   */
  selectTemplate(t) {
    this.templateId = t, this.grid && this.loadTemplateConfig(t).then((e) => {
      this.setTemplateStateToGrid(e);
    });
  }
  /**
   * Save template
   */
  showSaveTemplate() {
    const t = this.getTemplate(this.templateId), e = {
      isNew: t.isReadOnly,
      isEditable: !t.isReadOnly,
      label: t.isReadOnly ? "Uusi raportti (" + (this.templates.filter((n) => !n.isReadOnly).length + 1) + ")" : t.label
    }, a = (n) => this.datasets.save({
      id: n.id,
      info: {
        label: n.label,
        status: PL.Template,
        type: EL.ReportAdHoc
      },
      usecase: {
        uri: this.usecaseUri
      },
      data: [{
        content: [
          n.config
        ]
      }]
    }).then((i) => ({
      id: i.id,
      owner: i.owner,
      label: i.info.label,
      config: i.data[0].content[0],
      isReadOnly: i.isReadOnly,
      avatar: this.sessionService.avatar
    }));
    this.uiHelpers.openEditDialog(
      "salaxy-components/report/modals/CalculationReportSaveTemplate.html",
      e,
      null
    ).then((n) => {
      if (n.action === "ok") {
        const i = n.item;
        if (!i.isNew)
          t.label = i.label, this.setGridStateToTemplate(t), a(t);
        else {
          const r = {
            id: null,
            owner: null,
            label: i.label,
            config: {},
            isReadOnly: !1
          };
          this.setGridStateToTemplate(r), a(r).then((l) => {
            this.templates.push(l), this.selectTemplate(l.id);
          });
        }
      } else
        n.action === "delete" && this.showDeleteTemplate();
    });
  }
  /**
   * Delete template
   */
  showDeleteTemplate() {
    const t = this.getTemplate(this.templateId);
    this.uiHelpers.showConfirm(`Haluatko poistaa tämän raporttipohjan '${t.label}'?`).then((e) => {
      if (e && !t.isReadOnly) {
        const a = this.templates.findIndex((n) => n.id === this.templateId);
        this.templates.splice(a, 1), this.selectTemplate(this.templates[a - 1].id), this.datasets.delete(t.id);
      }
    });
  }
  /**
   * Shows the period selection dialog and makes the search.
   */
  showPeriodSelection() {
    this.uiHelpers.openEditDialog(
      "salaxy-components/report/modals/CalculationReportPeriodSelection.html",
      this.queryOptions.period,
      {
        showWorkerSelection: (t) => {
          this.uiHelpers.openEditDialog(
            "salaxy-components/modals/calc/WorkerList.html",
            [].concat(...t.selectedWorkers),
            {
              title: "Valitse työntekijät"
            }
          ).then((e) => {
            e.action === "ok" && (t.selectedWorkers.splice(0, t.selectedWorkers.length), t.selectedWorkers.push(...e.item));
          });
        }
      }
    ).then((t) => {
      if (t.action === "ok") {
        this.queryOptions.period = t.item, this.gridOptions.api.showLoadingOverlay();
        const e = t.item.selectedWorkers.length > 0 ? t.item.selectedWorkers.map((a) => a.otherPartyInfo.avatar.id) : null;
        this.queryDataForPeriod(t.item.refDate, t.item.periodType, t.item.endDate, t.item.periodDateKind, e).then((a) => {
          this.setData(a);
        });
      }
    });
  }
  /**
   * Shows the calculation selection dialog and makes the search.
   */
  showCalcsSelection() {
    this.uiHelpers.openEditDialog(
      "salaxy-components/modals/calc/CalcList.html",
      this.queryOptions.calculations,
      {
        title: "Valitse maksetut palkat",
        category: "paid"
      }
    ).then((t) => {
      if (t.action === "ok" && t.item.length > 0) {
        this.queryOptions.calculations = t.item;
        const e = t.item.map((a) => a.id);
        this.gridOptions.api.showLoadingOverlay(), this.queryDataForCalculationIds(e).then((a) => {
          this.setData(a);
        });
      }
    });
  }
  /**
   * Shows the calculation selection dialog and makes the search.
   */
  showPayrollSelection() {
    this.uiHelpers.openEditDialog(
      "salaxy-components/modals/payroll/PayrollList.html",
      this.queryOptions.payrolls,
      {
        title: "Valitse palkkalistat",
        category: "paid"
      },
      "lg"
    ).then((t) => {
      if (t.action === "ok" && t.item.length > 0) {
        this.queryOptions.payrolls = t.item;
        const e = t.item.reduce((a, n) => a.concat(n.businessObjects), []);
        this.gridOptions.api.showLoadingOverlay(), this.queryDataForCalculationIds(e).then((a) => {
          this.setData(a);
        });
      }
    });
  }
  loadTemplates() {
    this.templates.splice(0);
    const t = `status eq '${PL.Template}' and entityType eq '${EL.ReportAdHoc}' and data/usecaseUri eq '${this.usecaseUri}'`;
    this.datasets.getOData({ $filter: t }).then((e) => {
      const a = e.items.map((n) => ({
        id: n.id,
        owner: n.owner,
        label: n.shortText,
        config: null,
        isReadOnly: n.isReadOnly,
        avatar: n.ownerInfo.avatar
      }));
      this.templates.push(...this.defaultTemplates.concat(...a));
    });
  }
  loadTemplateConfig(t) {
    const e = this.getTemplate(t);
    return e.config ? Promise.resolve(e) : this.datasets.getSingle(e.id + (e.isReadOnly ? `@${e.owner}` : "")).then((a) => (e.config = a.data.length == 1 && a.data[0].content.length == 1 ? a.data[0].content[0] : {}, e));
  }
  setTemplateStateToGrid(t) {
    this.gridOptions.columnApi.setPivotMode(t.config.isPivotMode ?? !1), t.config.columnState ? this.gridOptions.columnApi.applyColumnState({
      state: t.config.columnState,
      applyOrder: !0
    }) : this.gridOptions.columnApi.resetColumnState(), t.config.columnGroupState ? this.gridOptions.columnApi.setColumnGroupState(t.config.columnGroupState) : this.gridOptions.columnApi.resetColumnGroupState(), this.gridOptions.api.setFilterModel(t.config.filterModel);
  }
  setGridStateToTemplate(t) {
    t.config = t.config ?? {}, t.config.columnState = this.gridOptions.columnApi.getColumnState(), t.config.columnGroupState = this.gridOptions.columnApi.getColumnGroupState(), t.config.filterModel = this.gridOptions.api.getFilterModel(), t.config.isPivotMode = this.gridOptions.columnApi.isPivotMode();
  }
}
const MS = class MS extends uR {
  constructor(t, e, a, n, i) {
    super(t, e, a), this.reports = n, this.$timeout = i, this.usecaseUri = "palkkaus.fi/reports/calculationReport", this.gridOptions = {
      statusBar: {
        statusPanels: [
          { statusPanel: "agTotalAndFilteredRowCountComponent", key: "totalAndFilter", align: "left" },
          { statusPanel: "agSelectedRowCountComponent", align: "left" },
          { statusPanel: "agAggregationComponent", align: "right" }
        ]
      },
      enableMultiRowDragging: !0,
      rowGroupPanelShow: "always",
      pivotPanelShow: "always",
      enableCharts: !0,
      enableRangeSelection: !0,
      defaultExportParams: {
        columnGroups: !0,
        headerRowHeight: 30,
        rowHeight: 22,
        fontSize: 14
      },
      defaultColDef: {
        flex: 1,
        minWidth: 200,
        sortable: !0,
        filter: !0,
        resizable: !0,
        floatingFilter: !0
      },
      sideBar: { toolPanels: ["columns", "filters"] },
      rowData: []
    }, this.gridElmentId = "#dataGrid", this.defaultTemplates = [
      {
        id: "incomeTypes",
        owner: null,
        label: "Tulolajiraportti",
        config: null,
        isReadOnly: !0,
        avatar: {
          initials: "TLR",
          entityType: Xi.Company,
          color: "#009fd8"
        }
      },
      {
        id: "totals",
        owner: null,
        label: "Palkanmaksujen erittely",
        config: null,
        isReadOnly: !0,
        avatar: {
          initials: "PME",
          entityType: Xi.Company,
          color: "#009fd8"
        }
      },
      {
        id: "plain",
        owner: null,
        label: "Kaikki sarakkeet",
        config: {},
        isReadOnly: !0,
        avatar: {
          initials: "Kasa",
          entityType: Xi.Company,
          color: "#009fd8"
        }
      }
    ];
  }
  /**
   * Initialize controller values.
   */
  $onInit() {
    super.$onInit();
  }
  /**
   * Processes and sets the data.
   */
  setData(t) {
    this.data = t;
    const e = (g, x) => {
      if (!g || !x)
        return g === x ? 0 : g ? 1 : -1;
      const b = I.asDate(g), A = I.asDate(x);
      return b === A ? 0 : b > A ? 1 : -1;
    }, a = (g, x) => e(x, g), n = [];
    n.push(
      {
        headerName: "Laskelmat",
        children: [
          {
            headerName: "Työntekijä",
            rowDrag: !0,
            field: "worker",
            enableRowGroup: !0,
            filter: "agMultiColumnFilter"
          },
          {
            headerName: "Laskelma",
            // rowDrag: true,
            field: "calculation",
            // enableRowGroup: true,
            valueGetter: (g) => g.node && g.node.data ? `${g.node.data.worker} ${g.node.data.salaryDate} ${se.formatPrice(g.node.data["totals-totalGrossSalary"])}` : "",
            cellRenderer: (g) => g.node && g.node.data ? `<a href="#/calc/details/${g.node.data.calculationId}" target="_blank" rel="noopener">${ti.escapeHtml(g.node.data.worker)} ${g.node.data.salaryDate} ${se.formatPrice(g.node.data["totals-totalGrossSalary"])}</a>` : ""
          },
          {
            headerName: "Työntekijän syntymäaika",
            field: "workerBirthDate",
            valueFormatter: (g) => I.getFormattedDate(g.value),
            type: ["rightAligned"],
            filter: "agDateColumnFilter",
            comparator: e,
            filterParams: { comparator: a }
          },
          {
            headerName: "Palkkapäivä",
            field: "salaryDate",
            valueFormatter: (g) => I.getFormattedDate(g.value),
            type: ["rightAligned"],
            filter: "agDateColumnFilter",
            comparator: e,
            filterParams: { comparator: a }
          },
          {
            headerName: "Brutto",
            field: "totalGrossSalary",
            valueGetter: (g) => g.node && g.node.data ? g.node.data["totals-totalGrossSalary"] : null,
            type: ["numericColumn"],
            valueFormatter: (g) => se.formatNumber(g.value, 2),
            filter: "agNumberColumnFilter"
          },
          {
            headerName: "Kuvaus",
            field: "workDescription",
            filter: "agMultiColumnFilter"
          },
          {
            headerName: "Aloituspäivä",
            field: "workStartDate",
            valueFormatter: (g) => I.getFormattedDate(g.value),
            type: ["rightAligned"],
            filter: "agDateColumnFilter",
            comparator: e,
            filterParams: { comparator: a }
          },
          {
            headerName: "Lopetuspäivä",
            field: "workEndDate",
            valueFormatter: (g) => I.getFormattedDate(g.value),
            type: ["rightAligned"],
            filter: "agDateColumnFilter",
            comparator: e,
            filterParams: { comparator: a }
          },
          {
            headerName: "Työsuhteen aloituspäivä",
            field: "workerEmploymentStartDate",
            valueFormatter: (g) => I.getFormattedDate(g.value),
            type: ["rightAligned"],
            filter: "agDateColumnFilter",
            comparator: e,
            filterParams: { comparator: a }
          },
          {
            headerName: "Työsuhteen päättymispäivä",
            field: "workerEmploymentEndDate",
            valueFormatter: (g) => I.getFormattedDate(g.value),
            type: ["rightAligned"],
            filter: "agDateColumnFilter",
            comparator: e,
            filterParams: { comparator: a }
          },
          {
            headerName: "Määräaikainen työsuhde",
            field: "workerEmploymentIsFixedTerm",
            filter: "agMultiColumnFilter"
          }
        ]
      },
      {
        headerName: "Ryhmittelyt",
        children: [
          {
            headerName: "Kuukausi",
            field: "salaryMonth",
            enablePivot: !0,
            enableRowGroup: !0,
            type: ["numericColumn"],
            filter: "agMultiColumnFilter"
          },
          {
            headerName: "Vuosi",
            field: "salaryYear",
            enablePivot: !0,
            enableRowGroup: !0,
            type: ["numericColumn"],
            filter: "agMultiColumnFilter"
          },
          {
            headerName: "Ammattiluokka",
            field: "occupationCode",
            enablePivot: !0,
            enableRowGroup: !0,
            filter: "agMultiColumnFilter"
          },
          {
            headerName: "Eläketurva",
            field: "pensionCalculation",
            enablePivot: !0,
            enableRowGroup: !0,
            filter: "agMultiColumnFilter"
          }
        ]
      }
    );
    const i = {
      headerName: "Tulolajit",
      children: []
    };
    n.push(i), Object.keys(this.data.irLabels).forEach((g) => {
      i.children.push({
        field: g,
        headerName: this.data.irLabels[g],
        enableValue: !0,
        type: ["numericColumn"],
        valueFormatter: (x) => se.formatNumber(x.value, 2),
        filter: "agNumberColumnFilter"
      });
    });
    const r = {
      headerName: "Rivityypit",
      children: []
    };
    n.push(r), Object.keys(this.data.typeLabels).forEach((g) => {
      r.children.push({
        field: g,
        headerName: this.data.typeLabels[g],
        enableValue: !0,
        type: ["numericColumn"],
        valueFormatter: (x) => se.formatNumber(x.value, 2),
        filter: "agNumberColumnFilter"
      });
    });
    const l = {
      headerName: "Työnantaja",
      children: []
    }, o = {
      headerName: "Työntekijä",
      children: []
    }, c = {
      headerName: "Yhteensä",
      children: []
    }, d = {
      headerName: "Maksut",
      children: [
        o,
        l,
        c
      ]
    };
    n.push(d), Object.keys(this.data.totalLabels).forEach((g) => {
      (g.indexOf("employerCalc") === 0 ? l : g.indexOf("workerCalc") === 0 ? o : c).children.push({
        field: g,
        headerName: this.data.totalLabels[g],
        enableValue: !0,
        type: ["numericColumn"],
        valueFormatter: (b) => se.formatNumber(b.value, 2),
        filter: "agNumberColumnFilter"
      });
    });
    const p = this.getTemplate("incomeTypes");
    p.config = p.config ?? { columnState: this.createIncomeTypesPreset(n, this.data.rows) };
    const h = this.getTemplate("totals");
    h.config = h.config ?? { columnState: this.createTotalsPreset(n) }, this.$timeout(() => {
      const g = this.gridOptions.api.getFilterModel();
      this.gridOptions.api.setFilterModel(null), this.gridOptions.api.setRowData(this.data.rows), this.gridOptions.api.setColumnDefs(n), this.gridOptions.api.setFilterModel(g), this.selectTemplate(this.templateId ?? "incomeTypes");
    });
  }
  /**
   * Gets the monthly / quarterly / yearly cumulative data for the current account.
   * @param refDate Reference date for the period. Please note that even if the date is not the first day of the given period, the entire period is returned.
   * @param periodType Month, quarter, year or a custom period. The custom period requires endDate. Default value is the month.
   * @param endDate End date for the period. Required only for the custom period.
   * @param periodDateKind Period date type: paid at date, salary date or work date.
   * @param workers List of worker official ids.
   * @returns A Promise with result data.
   */
  queryDataForPeriod(t, e, a, n, i) {
    return e === "all" && (t = "2010-01-01", a = "2100-01-01", e = Wi.Custom), this.reports.getCalculationReportData(t, e, a, n, i);
  }
  /**
   * Gets the cumulative data based on given set of calculations.
   * @param calculationIds - Calculations that are the bases for the report.
   * @returns A Promise with result data.
   */
  queryDataForCalculationIds(t) {
    return this.reports.getCalculationReportDataForCalculationIds(t);
  }
  createIncomeTypesPreset(t, e) {
    const a = [], n = t[0];
    for (const p of n.children)
      switch (p.field) {
        case "worker":
          a.push(this.createPresetCol(p.field, !0, !0));
          break;
        case "calculation":
          a.push(this.createPresetCol(p.field, !1));
          break;
        default:
          a.push(this.createPresetCol(p.field, !0));
      }
    const i = t[1];
    for (const p of i.children)
      a.push(this.createPresetCol(p.field, !0));
    const r = t[2];
    for (const p of r.children) {
      const h = !(e ?? []).find((g) => g[p.field]);
      p.field.endsWith("-price") ? a.push(this.createPresetCol(p.field, h, !1, "avg")) : a.push(this.createPresetCol(p.field, h, !1, "sum"));
    }
    const l = t[3];
    for (const p of l.children)
      a.push(this.createPresetCol(p.field, !0));
    const o = t[4].children[0];
    for (const p of o.children)
      a.push(this.createPresetCol(p.field, !0));
    const c = t[4].children[1];
    for (const p of c.children)
      a.push(this.createPresetCol(p.field, !0));
    const d = t[4].children[2];
    for (const p of d.children)
      a.push(this.createPresetCol(p.field, !0));
    return a;
  }
  createTotalsPreset(t) {
    const e = [], a = t[0];
    for (const p of a.children)
      switch (p.field) {
        case "worker":
          e.push(this.createPresetCol(p.field, !0, !0));
          break;
        case "salaryDate":
        case "workStartDate":
        case "workEndDate":
          e.push(this.createPresetCol(p.field, !1));
          break;
        default:
          e.push(this.createPresetCol(p.field, !0));
          break;
      }
    const n = t[1];
    for (const p of n.children)
      switch (p.field) {
        case "pensionCalculation":
          e.push(this.createPresetCol(p.field, !1));
          break;
        default:
          e.push(this.createPresetCol(p.field, !0));
          break;
      }
    const i = t[2];
    for (const p of i.children)
      e.push(this.createPresetCol(p.field, !0));
    const r = t[3];
    for (const p of r.children)
      e.push(this.createPresetCol(p.field, !0));
    const l = [
      "totals-totalGrossSalary",
      "workerCalc-benefits",
      "totals-annualHolidayCompensation",
      "totals-holidayBonus",
      "totals-holidaySalary",
      // "muut vähennettävät erät ml. luontoiseduista vähennettävät"
      "totals-totalTaxable",
      "workerCalc-tax",
      "workerCalc-pension",
      "workerCalc-unemploymentInsurance",
      "workerCalc-unionPayment",
      "workerCalc-foreclosure",
      "workerCalc-salaryAdvance",
      "workerCalc-otherDeductions",
      "workerCalc-deductions",
      "workerCalc-prepaidExpenses",
      "totals-totalExpenses",
      "workerCalc-totalWorkerPayment",
      "employerCalc-totalPayment",
      "employerCalc-palkkaus",
      "employerCalc-service",
      "employerCalc-socialSecurity",
      "totals-pension",
      "employerCalc-pension",
      "totals-unemployment",
      "employerCalc-unemployment",
      "totals-totalPensionInsuranceBase",
      "totals-totalSocialSecurityBase",
      "totals-totalHealthInsuranceBase",
      "totals-totalUnemploymentInsuranceBase",
      "totals-totalAccidentInsuranceBase",
      "totals-totalAccidentInsurance",
      "totals-totalGroupLifeInsurance"
    ];
    for (const p of l)
      e.push(this.createPresetCol(p, !1, !1, "sum"));
    const o = t[4].children[0];
    for (const p of o.children)
      l.indexOf(p.field) < 0 && e.push(this.createPresetCol(p.field, !0));
    const c = t[4].children[1];
    for (const p of c.children)
      l.indexOf(p.field) < 0 && e.push(this.createPresetCol(p.field, !0));
    const d = t[4].children[2];
    for (const p of d.children)
      l.indexOf(p.field) < 0 && e.push(this.createPresetCol(p.field, !0));
    return e;
  }
  createPresetCol(t, e, a = !1, n = null) {
    return {
      aggFunc: n,
      colId: t,
      flex: 1,
      hide: e,
      pinned: null,
      pivot: !1,
      pivotIndex: null,
      rowGroup: a,
      rowGroupIndex: null,
      sort: null,
      sortIndex: null,
      width: 200
    };
  }
};
MS.$inject = ["Datasets", "UiHelpers", "SessionService", "Reports", "$timeout"];
let Bg = MS;
const XS = class XS extends uR {
  constructor(t, e, a, n, i) {
    super(t, e, a), this.reports = n, this.$timeout = i, this.usecaseUri = "palkkaus.fi/reports/accountingRowReport", this.gridOptions = {
      statusBar: {
        statusPanels: [
          { statusPanel: "agTotalAndFilteredRowCountComponent", key: "totalAndFilter", align: "left" },
          { statusPanel: "agSelectedRowCountComponent", align: "left" },
          { statusPanel: "agAggregationComponent", align: "right" }
        ]
      },
      enableMultiRowDragging: !0,
      rowGroupPanelShow: "always",
      pivotPanelShow: "always",
      enableCharts: !0,
      enableRangeSelection: !0,
      pivotMode: !0,
      suppressExpandablePivotGroups: !0,
      defaultExportParams: {
        columnGroups: !0,
        headerRowHeight: 30,
        rowHeight: 22,
        fontSize: 14
      },
      defaultColDef: {
        flex: 1,
        minWidth: 200,
        sortable: !0,
        filter: !0,
        resizable: !0,
        floatingFilter: !0
      },
      sideBar: { toolPanels: ["columns", "filters"] },
      rowData: []
    }, this.gridElmentId = "#dataGrid", this.defaultTemplates = [
      {
        id: "holidays",
        owner: null,
        label: "Lomapalkkaraportti",
        config: null,
        isReadOnly: !0,
        avatar: {
          initials: "LPR",
          entityType: Xi.Company,
          color: "#009fd8"
        }
      },
      {
        id: "plain",
        owner: null,
        label: "Kaikki sarakkeet",
        config: { isPivotMode: !1 },
        isReadOnly: !0,
        avatar: {
          initials: "Kasa",
          entityType: Xi.Company,
          color: "#009fd8"
        }
      }
    ], this.entryCodeGroups = {
      totalType: "Yhteensä",
      incomeType: "Tulolaji"
    }, this.entryCodes = {
      totalPensionWorker: "Työntekijöiden TyEL-maksut",
      totalPensionEmployer: "Työnantajan TyEL-maksu",
      totalPension: "TyEL-maksut",
      totalUnemploymentWorker: "Työntekijöiden työttömyysvakuutusmaksut",
      totalUnemploymentEmployer: "Työnantajan työttömyysvakuutusmaksu",
      totalUnemployment: "Työttömyysvakuutusmaksut",
      totalSocialSecurityEmployer: "Työnantajan sairausvakuutusmaksu",
      totalSocialSecurityWorker: "Työntekijältä erikseen perittävä sairausvakuutusmaksu",
      totalTax: "Ennakonpidätykset",
      totalPalkkaus: "Palkkaus.fi-palkkio",
      totalWorkerPayment: "Työntekijän nettopalkka ja kulukorvaukset",
      totalPayment: "Maksettu asiakasvaratilille",
      totalAccidentInsurance: "Työtapaturma- ja ammattitautivakuutusmaksut",
      totalGroupLifeInsurance: "Ryhmähenkivakuutusmaksut",
      totalAccruedHolidayPay: "Kertyneet lomapalkat",
      totalAccruedHolidaySocialSecurity: "Kertyneet lomapalkkojen sairausvakuutusmaksut",
      totalAccruedHolidayPension: "Kertyneet lomapalkkojen TyEL-maksut",
      totalAccruedHolidayUnemployment: "Kertyneet lomapalkkojen työttömyysvakuutusmaksut (TVR)",
      totalPaidHolidaySalary: "Maksetut loma-ajan palkat",
      totalPaidHolidayBonus: "Maksetut lomarahat",
      totalPaidHolidayCompensation: "Maksetut lomakorvaukset",
      totalPaidHolidaySocialSecurity: "Maksetut lomapalkkojen sairausvakuutusmaksut",
      totalPaidHolidayPension: "Maksetut lomapalkkojen TyEL-maksut",
      totalPaidHolidayUnemployment: "Maksetut lomapalkkojen työttömyysvakuutusmaksut (TVR)",
      totalGrossSalary: "Bruttopalkka"
    };
  }
  /**
   * Initialize controller values.
   */
  $onInit() {
    super.$onInit();
  }
  /**
   * Processes and sets the data.
   */
  setData(t) {
    this.data = t;
    const e = (r, l) => {
      if (!r || !l)
        return r === l ? 0 : r ? 1 : -1;
      const o = I.asDate(r), c = I.asDate(l);
      return o === c ? 0 : o > c ? 1 : -1;
    }, a = (r, l) => e(l, r), n = [];
    n.push(
      {
        field: "message",
        headerName: "Selite",
        filter: "agMultiColumnFilter",
        enablePivot: !0,
        enableRowGroup: !0
      },
      {
        field: "entryDate",
        headerName: "Päiväys",
        valueFormatter: (r) => I.getFormattedDate(r.value),
        type: ["rightAligned"],
        filter: "agDateColumnFilter",
        comparator: e,
        filterParams: { comparator: a },
        enablePivot: !0,
        enableRowGroup: !0
      },
      {
        field: "amount",
        headerName: "Summa",
        enableValue: !0,
        type: ["numericColumn"],
        valueFormatter: (r) => se.formatNumber(r.value, 2),
        filter: "agNumberColumnFilter"
      },
      {
        field: "dimension.workerName",
        headerName: "Työntekijä",
        filter: "agMultiColumnFilter",
        enablePivot: !0,
        enableRowGroup: !0
      },
      /*
      {
        field: "dimension.dimensions.costCenter",
        headerName: "Kustannuspaikka",
        filter: "agMultiColumnFilter",
        enablePivot: true,
        enableRowGroup: true,
      },
      {
        field: "dimension.rowType",
        headerName: "Laskelmarivin tyyppi",
        filter: "agMultiColumnFilter",
        enablePivot: true,
        enableRowGroup: true,
      },
      */
      {
        field: "entryCodeGroup",
        headerName: "Kirjanpitorivin tyyppi",
        filter: "agMultiColumnFilter",
        enablePivot: !0,
        enableRowGroup: !0,
        valueGetter: (r) => this.getEntryCodeGroupName(r?.data?.entryCodeGroup)
      },
      {
        field: "entryCode",
        headerName: "Kirjanpitorivin tunniste",
        filter: "agMultiColumnFilter",
        enablePivot: !0,
        enableRowGroup: !0,
        valueGetter: (r) => this.getEntryCodeName(r?.data?.entryCode)
      }
    );
    const i = this.getTemplate("holidays");
    i.config = i.config ?? {
      isPivotMode: !0,
      columnState: this.createHolidaysPreset(n),
      filterModel: {
        entryCodeGroup: {
          filterType: "multi",
          filterModels: [
            null,
            {
              values: [
                this.entryCodeGroups.totalType
              ],
              filterType: "set"
            }
          ]
        },
        entryCode: {
          filterType: "multi",
          filterModels: [
            null,
            {
              values: [
                this.entryCodes.totalGrossSalary,
                this.entryCodes.totalAccruedHolidayPay,
                this.entryCodes.totalAccruedHolidaySocialSecurity,
                this.entryCodes.totalAccruedHolidayPension,
                this.entryCodes.totalAccruedHolidayUnemployment,
                this.entryCodes.totalPaidHolidaySalary,
                this.entryCodes.totalPaidHolidayBonus,
                this.entryCodes.totalPaidHolidayCompensation,
                this.entryCodes.totalPaidHolidaySocialSecurity,
                this.entryCodes.totalPaidHolidayPension,
                this.entryCodes.totalPaidHolidayUnemployment
              ],
              filterType: "set"
            }
          ]
        }
      }
    }, this.$timeout(() => {
      const r = this.gridOptions.api.getFilterModel();
      this.gridOptions.api.setFilterModel(null), this.gridOptions.api.setRowData(this.data.rows), this.gridOptions.api.setColumnDefs(n), this.gridOptions.api.setFilterModel(r), this.selectTemplate(this.templateId ?? "holidays");
    });
  }
  getEntryCodeGroupName(t) {
    return this.entryCodeGroups["" + t];
  }
  getEntryCodeName(t) {
    return this.entryCodes["" + t];
  }
  /**
   * Gets the monthly / quarterly / yearly accounitng row data for the current account.
   * @param refDate Reference date for the period. Please note that even if the date is not the first day of the given period, the entire period is returned.
   * @param periodType Month, quarter, year or a custom period. The custom period requires endDate. Default value is the month.
   * @param endDate End date for the period. Required only for the custom period.
   * @param periodDateKind Period date type: paid at date, salary date or work date.
   * @param workers List of worker official ids.
   * @returns A Promise with result data.
   */
  queryDataForPeriod(t, e, a, n, i) {
    return e === "all" && (t = "2010-01-01", a = "2100-01-01", e = Wi.Custom), this.reports.getAccountingRowReportData(t, e, a, n, i);
  }
  /**
   * Gets the accounting row data based on given set of calculations.
   * @param calculationIds - Calculations that are the bases for the report.
   * @returns A Promise with result data.
   */
  queryDataForCalculationIds(t) {
    return this.reports.getAccountingRowReportDataForCalculationIds(t);
  }
  createHolidaysPreset(t) {
    const e = [];
    for (const a of t)
      switch (a.field) {
        case "dimension.workerName":
          e.push(this.createPresetCol(a.field, !1, !0));
          break;
        default:
          e.push(this.createPresetCol(a.field, !0));
          break;
      }
    return e.push(this.createPresetCol("amount", !1, !1, "sum")), e.push(this.createPresetCol("entryCodeGroup", !1, !1, null, !0, 0)), e.push(this.createPresetCol("entryCode", !1, !1, null, !0, 1)), e;
  }
  createPresetCol(t, e, a = !1, n = null, i = !1, r = null) {
    return {
      aggFunc: n,
      colId: t,
      flex: 1,
      hide: e,
      pinned: null,
      pivot: i,
      pivotIndex: r,
      rowGroup: a,
      rowGroupIndex: null,
      sort: null,
      sortIndex: null,
      width: 200
    };
  }
};
XS.$inject = ["Datasets", "UiHelpers", "SessionService", "Reports", "$timeout"];
let Wg = XS;
const GS = class GS {
  /**
   * Creates a new instance of SummaryReportDisplayController
   * @param uiHelpers - Salaxy ui helpers service.
   */
  constructor(t, e) {
    this.uiHelpers = t, this.reports = e;
  }
  /**
   * Display Summary report
   * @param refDate date
   * @param type report type
   */
  display(t, e) {
    const a = {
      summaryReportData: null,
      isLoading: !0
    };
    this.reports.getSummaryReportData(t, this.getPeriodType(e)).then((n) => {
      a.summaryReportData = n, a.isLoading = !1;
    }), this.uiHelpers.showDialog(
      "salaxy-components/modals/report/SummaryReport.html",
      null,
      a,
      null,
      "landscape",
      !0
    );
  }
  getPeriodType(t) {
    switch (t) {
      case "monthlyDetails":
        return Wi.Month;
      case "yearlyDetails":
        return Wi.Year;
    }
  }
};
GS.$inject = [
  "UiHelpers",
  "Reports"
];
let rw = GS;
const HS = class HS {
  /**
   * Creates a new CalcReportController
   * @ignore
   */
  constructor(t, e, a, n, i, r, l, o) {
    this.templates = t, this.$sce = e, this.settingsService = a, this.$timeout = n, this.$http = i, this.uiHelpers = r, this.sessionService = l, this.ajax = o, this.templateName = "summaryReport", this.reportTemplate = "summaryReport", this.reportData = {
      headerFooter: {},
      layout: {},
      report: {}
    }, this._reportLang = Me.Default;
  }
  /**
   * Implement IController
   */
  $onInit() {
    this.sessionService.getReportLang().then((t) => {
      this.reportLang = t;
    });
  }
  /**
   * Get _reportLang
   */
  get reportLang() {
    return this._reportLang;
  }
  /**
   * Set _reportLang & lang
   */
  set reportLang(t) {
    this._reportLang = t, t !== Me.Default ? this.lang = this._reportLang : this.sessionService.getReportLang().then((e) => {
      this.lang = e;
    });
  }
  /**
   * Return languge text to ui
   */
  get languageText() {
    switch (this.reportLang) {
      case Me.Fi:
        return "SALAXY.ENUM.Language.fi.label";
      case Me.En:
        return "SALAXY.ENUM.Language.en.label";
      case Me.Sv:
        return "SALAXY.ENUM.Language.sv.label";
      case Me.Default:
        return "SALAXY.NG1.CalcReportsComponent.reportLanguageCompany";
    }
  }
  /** Bindable and trusted html. */
  get html() {
    if (!this.data)
      this.renderedData = null, this.renderedLang = null;
    else {
      const t = wt.copy(this.data);
      (!this.renderedData || !wt.equals(t, this.renderedData) || this.renderedLang !== this.lang) && (this.lang = this.lang === Me.Default ? Me.Fi : this.lang, this.renderedData = wt.copy(t), this.renderedLang = this.lang, this.refresh());
    }
    return this.htmlData;
  }
  async refresh() {
    this.refreshInprogress || (this.refreshInprogress = !0, this.settingsService.getReportOptions().then(async (t) => {
      this.reportOptions = t;
      const e = this.lang ?? Me.Fi;
      await L.loadLanguage(e);
      const a = this.getDefaultReportOptions(wt.copy(this.reportOptions));
      this.reportData.headerFooter = hc.getSummaryReportHeaderFooter(this.data, a, e), this.reportData.report = hc.getSummaryReport(this.data), this.reportData.layout = hc.getReportLayout(!1, !1), this.reportData.layout.hasCustomCss = !1, this.reportData.layout.customCss = "", this.reportData.layout.margin = {
        top: a.margin.top,
        right: a.margin.right,
        bottom: a.margin.bottom,
        left: a.margin.left
      };
      const n = new io();
      this.reportData.headerHtml = this.reportOptions?.headerTemplate ? n.getHtmlDynamic(this.reportOptions.headerTemplate, this.reportData.headerFooter, e) : "", this.reportData.footerHtml = this.reportOptions?.headerTemplate ? n.getHtmlDynamic(this.reportOptions.footerTemplate, this.reportData.headerFooter, e) : "", this.htmlData = this.$sce.trustAsHtml(this.templates.getHtml(this.templateName, this.reportData, e)), this.refreshInprogress = !1, this.$timeout();
    }));
  }
  /**
   * Shows a download dialog for the given summary report.
   * @param inline - If true, the download link opens the pdf into a new web page.
   */
  showDownloadDialog(t = !1) {
    const e = `${Ne.current.reportServer}/pdf?id=&reportType=${encodeURIComponent("monthlyDetails")}&template=${encodeURIComponent(this.reportTemplate)}&language=${encodeURIComponent(this.lang)}&disposition=inline&access_token=${this.ajax.getCurrentToken()}`;
    this.handlePdfRequest(e, t, this.data);
  }
  getDefaultReportOptions(t) {
    return t = t || {}, t.margin = t.margin || {}, t.margin.top = se.parseNumber(t.margin.top) || 30, t.margin.right = se.parseNumber(t.margin.right) || 10, t.margin.bottom = se.parseNumber(t.margin.bottom) || 40, t.margin.left = se.parseNumber(t.margin.left) || 10, t;
  }
  /**
   * Handles pdf request
   * @param url post url
   * @param inline inline pdf
   * @param data business object
   */
  handlePdfRequest(t, e, a) {
    this.$http.post(t, { object: a }, { responseType: "blob" }).then((n) => {
      n.data && (e ? this.uiHelpers.openFile(n.data) : this.uiHelpers.downloadFile(n.data, n.headers("content-disposition").split(";")[1].split("filename")[1].split("=")[1].trim().replace(/"/g, "")));
    }, (n) => {
      console.error(n);
    });
  }
};
HS.$inject = ["Templates", "$sce", "SettingsService", "$timeout", "$http", "UiHelpers", "SessionService", "AjaxNg1"];
let jg = HS;
const US = class US {
  /**
   * Creates a new instance of AccountingReportDisplayController
   * @param uiHelpers - Salaxy ui helpers service.
   */
  constructor(t, e) {
    this.uiHelpers = t, this.reports = e;
  }
  /**
   * Display accounting report
   * @param refDate date
   */
  display(t) {
    const e = (n) => this.reports.getAccountingDataForPeriod(t, n ?? "default", Wi.Month, null, _u.PaidAtDate), a = {
      accountingData: null,
      isLoading: !0,
      reader: {
        /**
         * Function to read data into given array
         * TODO: Should make interface for this or otherwise go-through.
         */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        read: (n, i, r, l) => (a.accountingData && r.push(a.accountingData), Promise.resolve()),
        /** Optional label for data export */
        exportLabel: null,
        /** Indicates if the export is not possible */
        disabled: () => !a.accountingData,
        /* Indicates if row is expandable */
        showExpand: !0,
        /* Indicates if rows exists*/
        hasRows: () => !a.accountingData?.ledgerAccounts
      },
      loadCurrent: (n) => {
        a.isLoading = !0, e(n).then((i) => {
          a.accountingData = i, a.isLoading = !1;
        });
      }
    };
    a.isLoading = !0, e(null).then((n) => {
      a.accountingData = n, a.isLoading = !1;
    }), this.uiHelpers.showDialog(
      "salaxy-components/modals/report/AccountingReport.html",
      null,
      a,
      null,
      "lg",
      !0
    );
  }
};
US.$inject = [
  "UiHelpers",
  "Reports"
];
let lw = US;
const FS = class FS {
  /**
   * Creates a new CalcReportController
   * @ignore
   */
  constructor(t, e, a, n, i, r, l, o) {
    this.templates = t, this.$sce = e, this.settingsService = a, this.$timeout = n, this.$http = i, this.uiHelpers = r, this.sessionService = l, this.ajax = o, this.templateName = "workerSummaryReport", this.reportTemplate = "workerSummaryReport", this.reportData = {
      headerFooter: {},
      layout: {},
      report: {}
    }, this._reportLang = Me.Default;
  }
  /**
   * Implement IController
   */
  $onInit() {
    this.sessionService.getReportLang().then((t) => {
      this.reportLang = t;
    });
  }
  /**
   * Get _reportLang
   */
  get reportLang() {
    return this._reportLang;
  }
  /**
   * Set _reportLang & lang
   */
  set reportLang(t) {
    this._reportLang = t, t !== Me.Default ? this.lang = this._reportLang : this.sessionService.getReportLang().then((e) => {
      this.lang = e;
    });
  }
  /**
   * Return languge text to ui
   */
  get languageText() {
    switch (this.reportLang) {
      case Me.Fi:
        return "SALAXY.ENUM.Language.fi.label";
      case Me.En:
        return "SALAXY.ENUM.Language.en.label";
      case Me.Sv:
        return "SALAXY.ENUM.Language.sv.label";
      case Me.Default:
        return "SALAXY.NG1.CalcReportsComponent.reportLanguageCompany";
    }
  }
  /** Bindable and trusted html. */
  get html() {
    if (!this.data)
      this.renderedData = null, this.renderedLang = null;
    else {
      const t = wt.copy(this.data);
      (!this.renderedData || !wt.equals(t, this.renderedData) || this.renderedLang !== this.lang) && (this.lang = this.lang === Me.Default ? Me.Fi : this.lang, this.renderedData = wt.copy(t), this.renderedLang = this.lang, this.refresh());
    }
    return this.htmlData;
  }
  async refresh() {
    this.refreshInprogress || (this.refreshInprogress = !0, this.settingsService.getReportOptions().then(async (t) => {
      this.reportOptions = t;
      const e = this.lang ?? Me.Fi;
      await L.loadLanguage(e);
      const a = this.getDefaultReportOptions(wt.copy(this.reportOptions));
      this.reportData.headerFooter = Tb.getWorkerSummaryReportHeaderFooter(this.data, a, e), this.reportData.report = Tb.getWorkerSummaryReport(this.data, e), this.reportData.layout = Tb.getReportLayout(!0, !1), this.reportData.layout.hasCustomCss = !1, this.reportData.layout.customCss = "", this.reportData.layout.margin = {
        top: a.margin.top,
        right: a.margin.right,
        bottom: a.margin.bottom,
        left: a.margin.left
      };
      const n = new io();
      this.reportData.headerHtml = this.reportOptions?.headerTemplate ? n.getHtmlDynamic(this.reportOptions.headerTemplate, this.reportData.headerFooter, e) : "", this.reportData.footerHtml = this.reportOptions?.headerTemplate ? n.getHtmlDynamic(this.reportOptions.footerTemplate, this.reportData.headerFooter, e) : "", this.htmlData = this.$sce.trustAsHtml(this.templates.getHtml(this.templateName, this.reportData, e)), this.refreshInprogress = !1, this.$timeout();
    }));
  }
  /**
   * Shows a download dialog for the given summary report.
   * @param inline - If true, the download link opens the pdf into a new web page.
   */
  showDownloadDialog(t = !1) {
    const e = `${Ne.current.reportServer}/pdf?id=&reportType=${encodeURIComponent("yearlyWorkerSummary")}&template=${encodeURIComponent(this.reportTemplate)}&language=${encodeURIComponent(this.lang)}&disposition=inline&access_token=${this.ajax.getCurrentToken()}`;
    this.handlePdfRequest(e, t, this.data);
  }
  getDefaultReportOptions(t) {
    return t = t || {}, t.margin = t.margin || {}, t.margin.top = se.parseNumber(t.margin.top) || 30, t.margin.right = se.parseNumber(t.margin.right) || 10, t.margin.bottom = se.parseNumber(t.margin.bottom) || 40, t.margin.left = se.parseNumber(t.margin.left) || 10, t;
  }
  /**
   * Handles pdf request
   * @param url post url
   * @param inline inline pdf
   * @param data business object
   */
  handlePdfRequest(t, e, a) {
    this.$http.post(t, { object: a }, { responseType: "blob" }).then((n) => {
      n.data && (e ? this.uiHelpers.openFile(n.data) : this.uiHelpers.downloadFile(n.data, n.headers("content-disposition").split(";")[1].split("filename")[1].split("=")[1].trim().replace(/"/g, "")));
    }, (n) => {
      console.error(n);
    });
  }
};
FS.$inject = ["Templates", "$sce", "SettingsService", "$timeout", "$http", "UiHelpers", "SessionService", "AjaxNg1"];
let Vg = FS;
const zS = class zS {
  /**
   * Creates a new instance of WorkerSummaryReportDisplayController
   * @param uiHelpers - Salaxy ui helpers service.
   */
  constructor(t, e) {
    this.uiHelpers = t, this.reports = e;
  }
  /**
   * Parses workerId from report url
   * @param reportUrl url to be parsed
   * @returns workerId
   */
  parseWorkerID(t) {
    return new RegExp("[?&]id(=([^&#]*)|&|#|$)").exec(t)[2];
  }
  /**
   * Query WorkerSummaryReportData and display it in dialog
   * @param refDate date
   */
  display(t, e, a) {
    const n = {
      workerSummaryReportData: null,
      isLoading: !0
    };
    this.reports.getWorkerSummaryReportData(t, e, a, Wi.Year, null, _u.SalaryDate).then((i) => {
      n.workerSummaryReportData = i, n.isLoading = !1;
    }), this.uiHelpers.showDialog(
      "salaxy-components/modals/report/WorkerSummaryReport.html",
      null,
      n,
      null,
      "landscape",
      !0
    );
  }
};
zS.$inject = [
  "UiHelpers",
  "Reports"
];
let ow = zS;
const BS = class BS {
  constructor(t, e, a, n, i) {
    this.holidayYears = t, this.reports = e, this.uiHelpers = a, this.employments = n, this.uiCrudHelpers = i, this.refDate = I.getToday(), this.years = [], this.resultRows = [], this.hasQueryedDebt = !1, this.employmentListItems = [];
  }
  /** Controller initialization */
  $onInit() {
    const t = this.uiHelpers.showLoading("SALAXY.UI_Terms.wait");
    this.loadEmployments().then((e) => {
      this.employmentListItems = e, this.query(), t.dismiss();
    });
  }
  /**
   * Shows an edit dialog for the employment.
   * @param row Row that contains field employmentId (Identifier for the employment).
   * @param row.employmentId The row must contain the employment identifier.
   */
  showEditEmploymentDialog(t) {
    if (!t.employment?.id) {
      console.error("EmploymentId is missing", t);
      return;
    }
    this.uiCrudHelpers.openEditEmploymentDialog(t.employment?.id, "default", "holidays");
  }
  /** Query Holiday year data. */
  query(t = !1) {
    const e = this.uiHelpers.showLoading("SALAXY.UI_Terms.wait");
    return (t ? this.reports.getAccountingHolidayPayDebtReportData(this.refDate) : this.holidayYears.getForAllYears().then((n) => ({
      holidayCalc: {
        totalAccruedHolidayPay: 0,
        totalAccruedHolidayBonus: 0,
        totalAccruedHolidaySocialSecurity: 0,
        totalAccruedHolidayPension: 0,
        totalAccruedHolidayUnemployment: 0,
        totalAccruedHolidayAccidentInsurance: 0,
        totalAccruedHolidayGroupLifeInsurance: 0
      },
      holidayYears: n.map((i) => ({
        holidayYear: i,
        holidayCalc: {}
      }))
    }))).then((n) => {
      this.data = n, this.holidayCalc = {}, this.holidayCalc.total = n.holidayCalc, this.holidayCalcTotal = {}, this.holidayCalcTotal.total = se.round(
        (n.holidayCalc?.totalAccruedHolidayPay ?? 0) + (n.holidayCalc?.totalAccruedHolidayBonus ?? 0) + (n.holidayCalc?.totalAccruedHolidaySocialSecurity ?? 0) + (n.holidayCalc?.totalAccruedHolidayPension ?? 0) + (n.holidayCalc?.totalAccruedHolidayUnemployment ?? 0) + (n.holidayCalc?.totalAccruedHolidayAccidentInsurance ?? 0) + (n.holidayCalc?.totalAccruedHolidayGroupLifeInsurance ?? 0),
        2
      ), this.resultRows = [], this.years = [], this.year = void 0, this.data.holidayYears.forEach((i) => {
        const r = {
          employment: this.employmentListItems.find((l) => l.id === i.holidayYear?.employmentId),
          data: i,
          holidayYearReportRow: this.getBlankHolidayYearReportRow()
        };
        this.resultRows.push(r), this.years.indexOf("" + i.holidayYear.year) < 0 && this.years.push("" + i.holidayYear.year);
      }), this.years.sort(), this.years.reverse(), this.year = this.years.length > 0 ? this.years[0] : void 0;
      for (const i of this.years) {
        const r = this.data.holidayYears.filter((o) => o.holidayYear.year == Number.parseInt(i)), l = {
          totalAccruedHolidayPay: se.round(ie.sum(r, (o) => o.holidayCalc?.totalAccruedHolidayPay ?? 0), 2),
          totalAccruedHolidayBonus: se.round(ie.sum(r, (o) => o.holidayCalc?.totalAccruedHolidayBonus ?? 0), 2),
          totalAccruedHolidaySocialSecurity: se.round(ie.sum(r, (o) => o.holidayCalc?.totalAccruedHolidaySocialSecurity ?? 0), 2),
          totalAccruedHolidayPension: se.round(ie.sum(r, (o) => o.holidayCalc?.totalAccruedHolidayPension ?? 0), 2),
          totalAccruedHolidayUnemployment: se.round(ie.sum(r, (o) => o.holidayCalc?.totalAccruedHolidayUnemployment ?? 0), 2),
          totalAccruedHolidayAccidentInsurance: se.round(ie.sum(r, (o) => o.holidayCalc?.totalAccruedHolidayAccidentInsurance ?? 0), 2),
          totalAccruedHolidayGroupLifeInsurance: se.round(ie.sum(r, (o) => o.holidayCalc?.totalAccruedHolidayGroupLifeInsurance ?? 0), 2)
        };
        this.holidayCalc[i] = l, this.holidayCalcTotal[i] = se.round(
          (l.totalAccruedHolidayPay ?? 0) + (l.totalAccruedHolidayBonus ?? 0) + (l.totalAccruedHolidayPension ?? 0) + (l.totalAccruedHolidayUnemployment ?? 0) + (l.totalAccruedHolidayAccidentInsurance ?? 0) + (l.totalAccruedHolidayGroupLifeInsurance ?? 0),
          2
        );
      }
      return this.createHolidayYearReportRows(), t && (this.hasQueryedDebt = !0), e.dismiss(), n;
    });
  }
  /**
   * Export totalRows to excel
   */
  exportToExcel() {
    const t = Number.parseInt(this.year ?? "0");
    if (t === 0)
      return;
    const e = this.uiHelpers.showLoading("SALAXY.UI_Terms.wait"), a = [], n = [
      L.get("SALAXY.NG1_Other.Roles.worker"),
      L.get("SALAXY.NG1.HolidayReportComponent.table.startDate"),
      L.get("SALAXY.NG1.HolidayReportComponent.table.endDate"),
      L.get("SALAXY.NG1.HolidayReportComponent.table.employment"),
      L.get("SALAXY.NG1.HolidayReportComponent.table.salary"),
      L.get("SALAXY.NG1.HolidayReportComponent.table.holidayCode"),
      L.get("SALAXY.NG1.HolidayReportComponent.table.periodDefaultAccrual"),
      L.get("SALAXY.NG1.HolidayReportComponent.table.holidayPayCalculation"),
      L.get("SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.startSaldo"),
      L.get("SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.total"),
      L.get("SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.paid"),
      L.get("SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.available"),
      L.get("SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.holidaySalary"),
      L.get("SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.holidayCompensation"),
      L.get("SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.paidBonus"),
      L.get("SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.availableBonus"),
      L.get("SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.holidayBonus"),
      L.get("SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.holidayPayDailySalary"),
      L.get("SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.totalAccruedHolidayPay"),
      L.get("SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.totalAccruedHolidayBonus"),
      L.get("SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.totalAccruedHolidaySocialSecurity"),
      L.get("SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.totalAccruedHolidayPension"),
      L.get("SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.totalAccruedHolidayUnemployment"),
      L.get("SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.totalAccruedHolidayAccidentInsurance"),
      L.get("SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.totalAccruedHolidayGroupLifeInsurance"),
      L.get("SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.totalAccruedHolidayTotal")
    ];
    a.push(n);
    const i = this.resultRows.filter((r) => r.data.holidayYear.year == t).map((r) => {
      const l = r.holidayYearReportRow;
      return [
        l.workerAvatar.displayName,
        l.startDate = I.format(l.startDate),
        l.endDate = I.format(l.endDate),
        l.employmentType,
        l.grossSalary,
        l.holidayCode,
        l.periodDefaultAccrual,
        l.holidayPayCalculation,
        l.startSaldo,
        l.total,
        l.paid,
        l.available,
        l.holidaySalary,
        l.holidayCompensation,
        l.paidBonus,
        l.availableBonus,
        l.holidayBonus,
        l.holidayPayDailySalary,
        l.totalAccruedHolidayPay,
        l.totalAccruedHolidayBonus,
        l.totalAccruedHolidaySocialSecurity,
        l.totalAccruedHolidayPension,
        l.totalAccruedHolidayUnemployment,
        l.totalAccruedHolidayAccidentInsurance,
        l.totalAccruedHolidayGroupLifeInsurance,
        l.totalAccruedHolidayTotal
      ];
    });
    a.push(...i), a.length > 0 ? xr.export(a, `holidayYear-${t}`).then(() => {
      e.dismiss();
    }) : e.dismiss();
  }
  async loadEmployments() {
    const t = [], e = (a = null) => {
      let n = null;
      const i = a?.indexOf("?") ?? -1;
      if (i >= 0) {
        const r = new URLSearchParams(a.substr(i));
        r.get("$skip") && (n = { $skip: Number(r.get("$skip")) });
      }
      return this.employments.getOData(n).then((r) => (t.push(...r.items), r.nextPageLink ? e(r.nextPageLink) : null));
    };
    return e().then(() => t);
  }
  createHolidayYearReportRows() {
    this.resultRows.forEach((t) => {
      t.holidayYearReportRow.workerAvatar = t.employment?.otherPartyInfo?.avatar, t.holidayYearReportRow.workerId = t.employment?.otherPartyInfo?.avatar?.id, t.holidayYearReportRow.employmentId = t.employment?.id, t.holidayYearReportRow.startDate = t.employment?.data?.startDate, t.holidayYearReportRow.endDate = t.employment?.data?.endDate, t.holidayYearReportRow.employmentType = He.getEnumLabel("EmploymentRelationType", t.employment?.data?.type) === "#err EmploymentRelationType.NoEnumValue" ? "-" : He.getEnumLabel("EmploymentRelationType", t.employment?.data?.type), t.holidayYearReportRow.grossSalary = se.round(t.employment?.grossSalary ?? 0, 2), t.holidayYearReportRow.holidayCode = (t.data.holidayYear.spec.code ?? Se.Undefined) == Se.Undefined ? "" : He.getEnumLabel("HolidayCode", t.data.holidayYear.spec.code), t.holidayYearReportRow.periodDefaultAccrual = t.data.holidayYear.spec.code == Se.Permanent14Days || t.data.holidayYear.spec.code == Se.Permanent35Hours || t.data.holidayYear.spec.code == Se.TemporaryTimeOff || t.data.holidayYear.spec.code == Se.Other ? t.data.holidayYear.accrual.defaultAccrual : null, t.holidayYearReportRow.holidayPayCalculation = (t.data.holidayYear.spec.holidayPayCalculation ?? "undefined") == "undefined" ? "" : He.getEnumLabel("HolidayPayCalculation", t.data.holidayYear.spec.holidayPayCalculation), t.holidayYearReportRow.startSaldo = se.round(t.data.holidayYear.accrual.startSaldo ?? 0, 0), t.holidayYearReportRow.total = se.round(t.data.holidayYear.accrual.total ?? 0, 0), t.holidayYearReportRow.paid = se.round(dn.getPaidHolidaysCalculation(t.data.holidayYear, "total").holidayDays ?? 0, 0), t.holidayYearReportRow.available = se.round(dn.getPaidHolidaysCalculation(t.data.holidayYear, "endSaldo").holidayDays ?? 0, 0), t.holidayYearReportRow.holidaySalary = dn.getPaidHolidaysCalculation(t.data.holidayYear, "total").holidaySalary ?? 0, t.holidayYearReportRow.holidayCompensation = dn.getPaidHolidaysCalculation(t.data.holidayYear, "total").holidayCompensation ?? 0, t.holidayYearReportRow.paidBonus = se.round(dn.getPaidBonusCalculation(t.data.holidayYear, "total").holidayDays ?? 0, 0), t.holidayYearReportRow.availableBonus = se.round(dn.getPaidBonusCalculation(t.data.holidayYear, "endSaldo").holidayDays ?? 0, 0), t.holidayYearReportRow.holidayBonus = dn.getPaidBonusCalculation(t.data.holidayYear, "total").holidayBonus ?? 0, t.holidayYearReportRow.holidayPayDailySalary = dn.getHolidayPayDailySalary(t.data.holidayYear) ?? 0, t.holidayYearReportRow.totalAccruedHolidayPay = t.data.holidayCalc?.totalAccruedHolidayPay ?? 0, t.holidayYearReportRow.totalAccruedHolidayBonus = t.data.holidayCalc?.totalAccruedHolidayBonus ?? 0, t.holidayYearReportRow.totalAccruedHolidaySocialSecurity = t.data.holidayCalc?.totalAccruedHolidaySocialSecurity ?? 0, t.holidayYearReportRow.totalAccruedHolidayPension = t.data.holidayCalc?.totalAccruedHolidayPension ?? 0, t.holidayYearReportRow.totalAccruedHolidayUnemployment = t.data.holidayCalc?.totalAccruedHolidayUnemployment ?? 0, t.holidayYearReportRow.totalAccruedHolidayAccidentInsurance = t.data.holidayCalc?.totalAccruedHolidayAccidentInsurance ?? 0, t.holidayYearReportRow.totalAccruedHolidayGroupLifeInsurance = t.data.holidayCalc?.totalAccruedHolidayGroupLifeInsurance ?? 0, t.holidayYearReportRow.totalAccruedHolidayTotal = se.round(
        t.holidayYearReportRow.totalAccruedHolidayPay + t.holidayYearReportRow.totalAccruedHolidayBonus + t.holidayYearReportRow.totalAccruedHolidaySocialSecurity + t.holidayYearReportRow.totalAccruedHolidayPension + t.holidayYearReportRow.totalAccruedHolidayUnemployment + t.holidayYearReportRow.totalAccruedHolidayAccidentInsurance + t.holidayYearReportRow.totalAccruedHolidayGroupLifeInsurance,
        2
      );
    });
  }
  getBlankHolidayYearReportRow() {
    return {
      workerAvatar: null,
      workerId: null,
      employmentId: null,
      startDate: null,
      endDate: null,
      employmentType: null,
      grossSalary: 0,
      holidayCode: null,
      periodDefaultAccrual: null,
      holidayPayCalculation: null,
      startSaldo: 0,
      total: 0,
      paid: 0,
      available: 0,
      holidaySalary: 0,
      holidayCompensation: 0,
      paidBonus: 0,
      availableBonus: 0,
      holidayBonus: 0,
      holidayPayDailySalary: 0,
      totalAccruedHolidayPay: 0,
      totalAccruedHolidayBonus: 0,
      totalAccruedHolidaySocialSecurity: 0,
      totalAccruedHolidayPension: 0,
      totalAccruedHolidayUnemployment: 0,
      totalAccruedHolidayAccidentInsurance: 0,
      totalAccruedHolidayGroupLifeInsurance: 0,
      totalAccruedHolidayTotal: 0
    };
  }
};
BS.$inject = [
  "HolidayYears",
  "Reports",
  "UiHelpers",
  "Employments",
  "UiCrudHelpers"
];
let qg = BS;
const WS = class WS {
  constructor(t, e, a, n) {
    this.$http = t, this.ajax = e, this.uiHelpers = a, this.reportsApi = n;
  }
  /**
   * Export items
   * One item is exported as pdf and multiple items are exported as zip containg pdfs.
   */
  async export(t) {
    const e = this.uiHelpers.showLoading("SALAXY.UI_Terms.loading"), a = t.map((i) => {
      const r = `${Ne.current.apiServer}/v03/api/reports/assure-pdf/salarySlip?language=${encodeURIComponent(L.getLanguage())}&ids=${i.id}&disposition=inline&access_token=${this.ajax.getCurrentToken()}`;
      return this.ajax.getBlob(r);
    }), n = await Promise.all(a);
    if (n.length === 1)
      this.uiHelpers.downloadFile(n[0].data, decodeURIComponent(n[0].headers["content-disposition"]).match(/filename\s*=\s*"?(?<file>.*?)(?:\s*;|"|\s*$)/)?.groups?.file), e.dismiss();
    else {
      const i = new un(), r = {};
      n.forEach((o) => {
        const c = `${decodeURIComponent(o.headers["content-disposition"]).match(/filename\s*=\s*"?(?<file>.*?)(?:\s*;|"|\s*$)/)?.groups?.file}`;
        Object.keys(r).includes(c) ? (++r[c], i.file(`${r[c]}_${c}`, o.data)) : (r[c] = 1, i.file(c, o.data));
      });
      const l = await i.generateAsync({ type: "blob", mimeType: "application/zip" });
      Vn.saveAs(l, ti.escapeFileName(`${L.get("SALAXY.UI_Terms.downLoadableMaterialTypes.calculations")}_${I.format("today", "YYYYMMDD")}`)), e.dismiss();
    }
  }
};
WS.$inject = [
  "$http",
  "AjaxNg1",
  "UiHelpers",
  "Reports"
];
let cw = WS;
const jS = class jS {
  constructor(t, e) {
    this.reportsApi = t, this.uiHelpers = e, this.refDate = I.getToday(), this.dataReader = {
      /**
       * Function to read data into given array
       */
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      read: (a, n, i, r) => (this.data && i.push(this.data), Promise.resolve()),
      /** Optional label for data export */
      exportLabel: null,
      /** Indicates if the export is not possible */
      disabled: () => !this.data,
      /* Indicates if row is expandable */
      showExpand: !0,
      /* Indicates if rows exists*/
      hasRows: () => !this.data?.ledgerAccounts
    };
  }
  /**
   * Initialize controller values.
   */
  $onInit() {
    this.view = this.view || "partial";
  }
  /** Queries the report data. */
  queryData(t = "default") {
    const e = this.uiHelpers.showLoading("SALAXY.UI_Terms.wait");
    this.reportsApi.getAccountingDataForHolidayPayDebt(this.refDate, t).then((a) => {
      this.data = a, e.dismiss();
    });
  }
};
jS.$inject = [
  "Reports",
  "UiHelpers"
];
let Kg = jS;
const VS = class VS {
  constructor(t, e, a) {
    this.holidayYearsApi = t, this.uiHelpers = e, this.$routeParams = a, this.years = [], this.totals = {
      total: 0,
      hours: 0,
      overtimeHours: 0,
      workingDays: 0,
      absenceDays: 0
    };
  }
  /** Controller initialization */
  $onInit() {
    const t = this.uiHelpers.showLoading("SALAXY.UI_Terms.wait"), e = this.$routeParams.crudItemId ?? "";
    this.year = e.split("/")[0], this.employmentId = e.split("/")[1], this.loadYears().then((a) => {
      this.years = a, this.query(), t.dismiss();
    });
  }
  /** Queries the report data. */
  query() {
    const t = this.uiHelpers.showLoading("SALAXY.UI_Terms.wait");
    this.holidayYearsApi.getHolidayPayCalculationReportData(this.year, this.employmentId).then((e) => {
      this.data = e, this.data.holidayYear.accrual.total = se.round(this.data.holidayYear.accrual.total, 0), this.totals.total = se.round(ie.sum(this.data.calculations, (a) => a.total), 2), this.totals.hours = se.round(ie.sum(this.data.calculations, (a) => a.hours), 2), this.totals.overtimeHours = se.round(ie.sum(this.data.calculations, (a) => a.overtimeHours), 2), this.totals.workingDays = se.round(ie.sum(this.data.calculations, (a) => a.workingDays), 2), this.totals.absenceDays = se.round(ie.sum(this.data.calculations, (a) => a.absenceDays), 2), t.dismiss();
    });
  }
  /** Returns label for the ir row. */
  getLabel(t) {
    if (t.message)
      return t.message;
    let e = t.data.calculationRowType || Wt.Unknown;
    e = e.substr(0, 1).toLowerCase() + e.substr(1);
    const a = t.irData?.code, n = t.data.kind;
    let i = "";
    return e === Wt.IrIncomeType ? i = Tn.getAll(null).find((r) => n && r.transactionCode === n || a > 0 && r.code === a)?.label : e === Wt.MealBenefit && a !== 334 ? i = Tn.getAll(null).find((r) => a > 0 && r.code === a)?.label : [
      Wt.Unknown,
      Wt.CarBenefit,
      Wt.BicycleBenefit,
      Wt.SubsidisedCommute,
      Wt.TaxAtSource,
      Wt.HourlySalaryWithWorkingTimeCompensation
    ].includes(e) ? i = Tn.getAll(null).find((r) => a > 0 && r.code === a)?.label : [
      Wt.DailyAllowance,
      Wt.EmploymentTermination,
      Wt.WorkingTimeCompensation,
      Wt.Remuneration,
      Wt.OtherCompensation,
      Wt.NonProfitOrg,
      Wt.MealBenefit,
      // main MealBenefit
      Wt.Training,
      Wt.PaidSickLeave
    ].includes(e) && n && (i = He.getEnumLabel(`${t.data.calculationRowType}Kind`, n, null, null)), i || He.getEnumLabel("CalculationRowType", e, null, null);
  }
  loadYears() {
    return this.holidayYearsApi.getOData({ $filter: `data/employmentId eq '${this.employmentId}'` }).then((t) => {
      const e = t.items.map((a) => "" + a.data.year);
      return e.sort(), e.reverse(), e;
    });
  }
};
VS.$inject = [
  "HolidayYears",
  "UiHelpers",
  "$routeParams"
];
let Jg = VS;
const qS = class qS {
  constructor(t, e, a, n) {
    this.reports = t, this.uiHelpers = e, this.employments = a, this.uiCrudHelpers = n, this.queryOptions = {
      periodType: Wi.Year,
      refDate: I.getDate(I.getYear("today"), 1, 1),
      endDate: I.getDate(I.getYear("today"), 12, 31),
      periodDateKind: _u.SalaryDate
    }, this.resultRows = [], this.currentTab = "incomereport", this.irReportRows = [], this.entrepreneurSummaryReportResults = [], this.workerSummaryReportResults = [], this.totalSummaryReportResults = [];
  }
  /** Controller initialization */
  $onInit() {
    const t = this.uiHelpers.showLoading("SALAXY.UI_Terms.wait");
    this.query().then(() => {
      t.dismiss();
    });
  }
  /** Return query info text */
  getQueryInfoText() {
    return this.summaryReportData?.startDate && this.summaryReportData?.endDate ? `${L.get("SALAXY.NG1.HolidayReportComponent.irIncomeTypeReportInfo")}: ${I.getFormattedDate(this.summaryReportData.startDate)} - ${I.getFormattedDate(this.summaryReportData.endDate)}` : "";
  }
  /**
   * Shows the period selection dialog and makes the search.
   */
  showPeriodSelection() {
    this.uiHelpers.openEditDialog(
      "salaxy-components/report/modals/SummaryReportPeriodSelection.html",
      this.queryOptions,
      null
    ).then((t) => {
      t.action === "ok" && (this.queryOptions = t.item, this.query());
    });
  }
  /**
   * Shows an edit dialog for the employment.
   * @param row Row that contains field employmentId (Identifier for the employment).
   * @param row.employmentId The row must contain the employment identifier.
   */
  showEditEmploymentDialog(t) {
    if (!t.employmentId) {
      console.error("EmploymentId is missing", t);
      return;
    }
    this.uiCrudHelpers.openEditEmploymentDialog(t.employmentId, "default").then((e) => {
      e.action === "ok" && this.query();
    });
  }
  /**
   * Filters zero rows off
   * @returns IrCodeIncomeReportRow[] containing not zero rows
   */
  getIrReportRows() {
    const t = [];
    return this.resultRows.map((a) => a.irCodeIncomeReportRow).forEach((a) => {
      a && t.push(a);
    }), t;
  }
  /**
   * Groups each result rows summary report entrepreneur results
   * @returns array of grouped entrepreneur results
   */
  getEntrepreneurSummaryReportResults() {
    const t = [];
    return this.resultRows.forEach((e) => {
      e?.summaryReportRow?.result?.entrepreneurResult && (e.summaryReportRow.result = e.summaryReportRow.result || {}, e.summaryReportRow.result.entrepreneurResult = e.summaryReportRow.result.entrepreneurResult || this.getBlankSummaryReportRowResult(), e.summaryReportRow.result.entrepreneurResult.avatar = e.avatar, e.summaryReportRow.result.entrepreneurResult.workerId = e.workerId, e.summaryReportRow.result.entrepreneurResult.employmentId = e.employmentId, t.push(e.summaryReportRow.result.entrepreneurResult));
    }), t;
  }
  /**
   * Groups each result rows summary report worker results
   * @returns array of grouped worker results
   */
  getWorkerSummaryReportResults() {
    const t = [];
    return this.resultRows.forEach((e) => {
      e.summaryReportRow.result.workerResult && (e.summaryReportRow.result.workerResult.avatar = e.avatar, e.summaryReportRow.result.workerResult.workerId = e.workerId, e.summaryReportRow.result.workerResult.employmentId = e.employmentId, t.push(e.summaryReportRow.result.workerResult));
    }), t;
  }
  /**
   * Export totalRows to excel
   */
  exportToExcel() {
    const t = this.uiHelpers.showLoading("SALAXY.UI_Terms.wait"), e = [];
    if (this.currentTab === "incomereport") {
      const n = this.irReportRows;
      if (n.length > 0) {
        e.push([L.get("SALAXY.NG1_Other.Roles.worker"), ...n[0].rows.map((r) => r.label)]);
        const i = n.map((r) => [r.workerAvatar.displayName, ...r.rows.map((l) => l.total)]);
        e.push(...i);
      }
    } else if (this.currentTab === "salarypaymentreport") {
      const n = [
        L.get("SALAXY.NG1_Other.Roles.worker"),
        L.get("SALAXY.REPORTS.summary.table.totalGrossSalary"),
        L.get("SALAXY.REPORTS.summary.table.totalRowCategory"),
        L.get("SALAXY.REPORTS.summary.table.benefits"),
        L.get("SALAXY.REPORTS.summary.table.irCode"),
        L.get("SALAXY.REPORTS.summary.table.totalTaxable"),
        L.get("SALAXY.REPORTS.summary.table.tax"),
        L.get("SALAXY.REPORTS.summary.table.pension"),
        L.get("SALAXY.REPORTS.summary.table.unemploymentInsurance"),
        L.get("SALAXY.REPORTS.summary.table.unionPayment"),
        L.get("SALAXY.REPORTS.summary.table.foreclosure"),
        L.get("SALAXY.REPORTS.summary.table.otherDeductions"),
        L.get("SALAXY.REPORTS.summary.table.totalExpenses"),
        L.get("SALAXY.REPORTS.summary.table.totalWorkerPayment"),
        L.get("SALAXY.REPORTS.summary.table.totalPayment"),
        L.get("SALAXY.REPORTS.summary.table.palkkaus"),
        L.get("SALAXY.REPORTS.summary.table.service"),
        L.get("SALAXY.REPORTS.summary.table.socialSecurity"),
        L.get("SALAXY.REPORTS.summary.table.totalPensions"),
        L.get("SALAXY.REPORTS.summary.table.employerPension"),
        L.get("SALAXY.REPORTS.summary.table.unemployment"),
        L.get("SALAXY.REPORTS.summary.table.employerUnemployment")
      ];
      if (e.push(n), this.entrepreneurSummaryReportResults.length > 0) {
        const i = this.entrepreneurSummaryReportResults.map((r) => [
          `${r.avatar.displayName} (YEL)`,
          r.totalGrossSalary,
          r.totalRowCategory,
          r.benefits,
          r.irCode,
          r.totalTaxable,
          r.tax,
          r.pension,
          r.unemploymentInsurance,
          r.unionPayment,
          r.foreclosure,
          r.otherDeductions,
          r.totalExpenses,
          r.totalWorkerPayment,
          r.totalPayment,
          r.palkkaus,
          r.service,
          r.socialSecurity,
          r.totalPensions,
          r.employerPension,
          r.unemployment,
          r.employerUnemployment
        ]);
        e.push(...i);
      }
      if (this.workerSummaryReportResults.length > 0) {
        const i = this.workerSummaryReportResults.map((r) => [
          `${r.avatar.displayName} (TyEL)`,
          r.totalGrossSalary,
          r.totalRowCategory,
          r.benefits,
          r.irCode,
          r.totalTaxable,
          r.tax,
          r.pension,
          r.unemploymentInsurance,
          r.unionPayment,
          r.foreclosure,
          r.otherDeductions,
          r.totalExpenses,
          r.totalWorkerPayment,
          r.totalPayment,
          r.palkkaus,
          r.service,
          r.socialSecurity,
          r.totalPensions,
          r.employerPension,
          r.unemployment,
          r.employerUnemployment
        ]);
        e.push(...i);
      }
      if (this.workerSummaryReportResults.length > 0 || this.entrepreneurSummaryReportResults.length > 0) {
        const i = this.totalSummaryReportResults.map((r) => [
          L.get("SALAXY.REPORTS.summary.table.total"),
          r.totalGrossSalary,
          r.totalRowCategory,
          r.benefits,
          r.irCode,
          r.totalTaxable,
          r.tax,
          r.pension,
          r.unemploymentInsurance,
          r.unionPayment,
          r.foreclosure,
          r.otherDeductions,
          r.totalExpenses,
          r.totalWorkerPayment,
          r.totalPayment,
          r.palkkaus,
          r.service,
          r.socialSecurity,
          r.totalPensions,
          r.employerPension,
          r.unemployment,
          r.employerUnemployment
        ]);
        e.push(...i);
      }
    }
    const a = this.currentTab == "incomereport" ? `incomeReport-${I.getToday()}` : `salaryPaymentReport-${I.getToday()}`;
    e.length > 0 ? xr.export(e, a).then(() => {
      t.dismiss();
    }) : t.dismiss();
  }
  query() {
    const t = this.uiHelpers.showLoading("SALAXY.UI_Terms.wait");
    return this.reports.getSummaryReportData(`${I.asDate(this.queryOptions.refDate)}`, this.queryOptions.periodType, `${I.asDate(this.queryOptions.endDate)}`, this.queryOptions.periodDateKind).then((e) => {
      this.summaryReportData = e, this.resultRows = [];
      const a = (n) => this.summaryReportData.calculations.filter((r) => r.worker.employmentId === n).sort((r, l) => r.updatedAt > l.updatedAt ? -1 : 1)[0]?.worker?.avatar;
      return this.summaryReportData?.calculations?.forEach((n) => {
        let i = this.resultRows.find((r) => r.employmentId === n.worker?.employmentId);
        if (!i) {
          const r = this.getBlankResultRow(), l = a(n.worker.employmentId);
          r.employmentId = n.worker.employmentId, r.avatar = l, r.workerId = l?.id, this.resultRows.push(r), i = r;
        }
        i.calculations.push(n);
      }), this.generateResults(), t.dismiss(), e;
    });
  }
  generateResults() {
    this.createIrReportRows(), this.createSummaryReportRows(), this.irReportRows = this.getIrReportRows(), this.entrepreneurSummaryReportResults = this.getEntrepreneurSummaryReportResults(), this.workerSummaryReportResults = this.getWorkerSummaryReportResults(), this.totalSummaryReportResults = this.resultRows[0]?.summaryReportRow?.result?.totalResult ? [this.resultRows[0].summaryReportRow.result.totalResult] : [];
  }
  createIrReportRows() {
    this.resultRows.forEach((t) => {
      (this.summaryReportData?.calculations?.map((o) => o.result.irRows).flat().filter((o) => o.irData.code !== 1 && o.irData.code !== 0) ?? []).forEach((o) => {
        t.irCodeIncomeReportRow.rows.some((c) => c.key === `${o.data.calculationRowType}-${o.irData.code}`) || t.irCodeIncomeReportRow.rows.push({
          key: `${o.data.calculationRowType}-${o.irData.code}`,
          label: this.getLabel(o),
          code: o.irData.code,
          isCount: !1,
          total: 0
        }), t.irCodeIncomeReportRow.rows.sort((c, d) => c.code > d.code ? 1 : -1);
      });
      const a = t.irCodeIncomeReportRow.rows.findIndex((o) => o.key === "HourlySalary-201");
      a >= 0 && t.irCodeIncomeReportRow.rows.splice(a + 1, 0, {
        key: "salaryPaymentWorkingHours",
        label: L.get("SALAXY.NG1.HolidayReportComponent.salaryPaymentWorkingHours"),
        code: null,
        isCount: !0,
        total: 0
      });
      const n = t.irCodeIncomeReportRow.rows.findIndex((o) => o.key === "MonthlySalary-201");
      n >= 0 && t.irCodeIncomeReportRow.rows.splice(n + 1, 0, {
        key: "salaryPaymentMonths",
        label: L.get("SALAXY.NG1.HolidayReportComponent.salaryPaymentMonths"),
        code: null,
        isCount: !0,
        total: 0
      });
      const i = {
        workerAvatar: t.avatar,
        workerId: t.workerId,
        employmentId: t.employmentId,
        rows: [...structuredClone(t.irCodeIncomeReportRow.rows)]
      };
      t.calculations.map((o) => o.result.irRows).flat().filter((o) => o.irData.code !== 1 && o.irData.code !== 0).forEach((o) => {
        const c = i.rows.find((d) => d.key === `${o.data.calculationRowType}-${o.irData.code}`);
        c.total += o.total;
      });
      const r = i.rows.find((o) => o.key === "salaryPaymentWorkingHours");
      if (r) {
        const o = t.calculations.map((c) => c.result.irRows.filter((d) => d.unit === as.Hours && d.irData.code === 201)).flat();
        r.total = ie.sum(o, (c) => c.count);
      }
      const l = i.rows.find((o) => o.key === "salaryPaymentMonths");
      if (l) {
        const o = t.calculations.filter((c) => c.result.irRows.some((d) => (
          /*x.unit === Unit.Period &&*/
          d.irData.code === 201
        )));
        l.total = [...new Set(o.map((c) => I.getMonth(c.workflow.salaryDate)))].length;
      }
      i.rows.some((o) => o.total > 0) ? t.irCodeIncomeReportRow = i : t.irCodeIncomeReportRow = null;
    });
  }
  createSummaryReportRows() {
    if (!this.summaryReportData || Object.keys(this.summaryReportData).length === 0)
      return;
    const t = Qe.copy(this.summaryReportData);
    this.resultRows.forEach((e) => {
      t.calculations = e.calculations, hc.getSummaryReport(t).result.workerResult.forEach((a) => {
        this.createSummaryReportRowResult(e, a, "workerResult");
      }), hc.getSummaryReport(t).result.entrepreneurResult.forEach((a) => {
        this.createSummaryReportRowResult(e, a, "entrepreneurResult");
      }), hc.getSummaryReport(t).totalResult.forEach((a) => {
        this.createSummaryReportRowResult(e, a, "totalResult");
      });
    });
  }
  createSummaryReportRowResult(t, e, a) {
    t.summaryReportRow.result[a] || (t.summaryReportRow.result[a] = this.getBlankSummaryReportRowResult()), delete e.worker, delete e.workStartDate, delete e.workStartEndDate;
    for (const [n, i] of Object.entries(e))
      t.summaryReportRow.result[a][n] += se.parseNumber(i), se.round(t.summaryReportRow.result[a][n]);
  }
  getLabel(t) {
    let e = t.data.calculationRowType || Wt.Unknown;
    e = e.substr(0, 1).toLowerCase() + e.substr(1);
    const a = t.irData?.code, n = this.getKind(t);
    let i = "";
    return e === Wt.IrIncomeType ? i = Tn.getAll(null).find((r) => n && r.transactionCode === n || a > 0 && r.code === a)?.label + `(${a})` : e === Wt.MealBenefit && a !== 334 ? i = Tn.getAll(null).find((r) => a > 0 && r.code === a)?.label + `(${a})` : [
      Wt.Unknown,
      Wt.CarBenefit,
      Wt.BicycleBenefit,
      Wt.SubsidisedCommute,
      Wt.TaxAtSource,
      Wt.HourlySalaryWithWorkingTimeCompensation
    ].includes(e) ? i = Tn.getAll(null).find((r) => a > 0 && r.code === a)?.label + `(${a})` : [
      Wt.DailyAllowance,
      Wt.EmploymentTermination,
      Wt.WorkingTimeCompensation,
      Wt.Remuneration,
      Wt.OtherCompensation,
      Wt.NonProfitOrg,
      Wt.MealBenefit,
      // main MealBenefit
      Wt.Training,
      Wt.PaidSickLeave
    ].includes(e) && n && (i = He.getEnumLabel(`${t.data.calculationRowType}Kind`, n, null, null) + `(${a})`), i || He.getEnumLabel("CalculationRowType", e, null, null) + `(${a})`;
  }
  getKind(t) {
    if (t.data.kind)
      return t.data.kind;
    switch (t.data.calculationRowType.substr(0, 1).toLowerCase() + t.data.calculationRowType.substr(1)) {
      case Wt.DailyAllowance: {
        const a = t.irData.dailyAllowance[0];
        return {
          [Jp.InternationalDailyAllowance]: yd.InternationalDailyAllowance,
          [Jp.PartialDailyAllowance]: yd.PartialDailyAllowance,
          [Jp.MealAllowance]: yd.MealAllowance,
          [Jp.FullDailyAllowance]: yd.FullDailyAllowance
        }[a] ?? yd.Undefined;
      }
      case Wt.EmploymentTermination: {
        switch (t.irData.code) {
          case 208:
            return gd.NoticePeriodCompensation;
          case 224:
            return gd.MonetaryWorkingTimeBankCompensation;
          case 229:
            return gd.TerminationAndLayOffDamages;
          case 231:
            return gd.VoluntaryTerminationCompensation;
          case 338:
            return gd.PensionPaidByEmployer;
        }
        break;
      }
      case Wt.WorkingTimeCompensation: {
        switch (t.irData.code) {
          case 205:
            return Ls.EmergencyWorkCompensation;
          case 206:
            return Ls.EveningWorkCompensation;
          case 207:
            return Ls.EveningShiftAllowance;
          case 211:
            return Ls.SaturdayPay;
          case 212:
            return Ls.ExtraWorkPremium;
          case 216:
            return Ls.OtherCompensation;
          case 217:
            return Ls.WaitingTimeCompensation;
          case 221:
            return Ls.SundayWorkCompensation;
          case 230:
            return Ls.StandByCompensation;
          case 232:
            return Ls.WeeklyRestCompensation;
          case 235:
            return Ls.OvertimeCompensation;
          case 236:
            return Ls.NightWorkAllowance;
          case 237:
            return Ls.NightShiftCompensation;
        }
        break;
      }
      case Wt.Remuneration: {
        switch (t.irData.code) {
          case 202:
            return Eo.InitiativeFee;
          case 203:
            return Eo.BonusPay;
          case 220:
            return Eo.Commission;
          case 223:
            return Eo.PerformanceBonus;
          case 226:
            return Eo.ShareIssueForEmployees;
          case 233:
            return Eo.ProfitSharingBonus;
        }
        break;
      }
      case Wt.OtherCompensation: {
        switch (t.irData.code) {
          case 210:
            return An.MeetingFee;
          case 214:
            return An.LectureFee;
          case 215:
            return An.PositionOfTrustCompensation;
          case 225:
            return An.AccruedTimeOffCompensation;
          case 308:
            return An.MembershipOfGoverningBodyCompensation;
          case 310:
            return An.MonetaryGiftForEmployees;
          case 313:
            return An.UseCompensationAsEarnedIncome;
          case 314:
            return An.UseCompensationAsCapitalIncome;
          case 316:
            return An.OtherTaxableIncomeAsEarnedIncome;
          case 320:
            return An.StockOptionsAndGrants;
          case 326:
            return An.EmployeeInventionCompensation;
          case 332:
            return An.CapitalIncomePayment;
          case 339:
            return An.WorkEffortBasedDividendsAsWage;
          case 340:
            return An.WorkEffortBasedDividendsAsNonWage;
          case 343:
            return An.EmployeeStockOption;
          case 361:
            return An.EmployeeStockOptionWithLowerPrice;
          case 366:
            return An.CopyrightRoyaltiesEarnedIncome;
          case 367:
            return An.StockGrantPaidInMoney;
          case 368:
            return An.EmployeeStockOptionPaidInMoney;
        }
        break;
      }
      case Wt.NonProfitOrg: {
        switch (t.irData.code) {
          case 358:
          case 1358:
            return NL.DailyAllowance;
          case 357:
            return NL.KilometreAllowance;
        }
        break;
      }
      case Wt.Training: {
        switch (t.irData.code) {
          case 227:
            return pc.TrainingSalary;
          case 201: {
            if (t.unit === as.Hours)
              return pc.TrainingHourlySalary;
            if (t.unit === as.Period)
              return pc.TrainingMonthlySalary;
          }
        }
        break;
      }
      case Wt.PaidSickLeave: {
        switch (t.irData.code) {
          case 227:
            return uc.PaidSickLeaveSalary;
          case 201: {
            if (t.unit === as.Hours)
              return uc.PaidSickLeaveHourlySalary;
            if (t.unit === as.Period)
              return uc.PaidSickLeaveMonthlySalary;
          }
        }
        break;
      }
      default:
        return null;
    }
  }
  getBlankResultRow() {
    return {
      employmentId: null,
      avatar: null,
      workerId: null,
      calculations: [],
      irCodeIncomeReportRow: this.getBlankIrCodeIncomeReportRow(),
      summaryReportRow: this.getBlankSummaryReportRow()
    };
  }
  getBlankIrCodeIncomeReportRow() {
    return {
      workerAvatar: null,
      workerId: null,
      employmentId: null,
      rows: []
    };
  }
  getBlankSummaryReportRow() {
    return {
      result: {
        workerResult: null,
        entrepreneurResult: null,
        totalResult: null
      }
    };
  }
  getBlankSummaryReportRowResult() {
    return {
      avatar: null,
      workerId: null,
      employmentId: null,
      totalGrossSalary: 0,
      totalRowCategory: 0,
      benefits: 0,
      irCode: 0,
      totalTaxable: 0,
      tax: 0,
      pension: 0,
      unemploymentInsurance: 0,
      unionPayment: 0,
      foreclosure: 0,
      otherDeductions: 0,
      totalExpenses: 0,
      totalWorkerPayment: 0,
      totalPayment: 0,
      palkkaus: 0,
      service: 0,
      socialSecurity: 0,
      totalPensions: 0,
      employerPension: 0,
      unemployment: 0,
      employerUnemployment: 0
    };
  }
};
qS.$inject = [
  "Reports",
  "UiHelpers",
  "Employments",
  "UiCrudHelpers"
];
let Qg = qS;
const KS = class KS {
  constructor(t, e, a) {
    this.ajax = t, this.settingsService = e, this.uiHelpers = a;
  }
  /**
   * Returns current accountant.
   */
  get accountant() {
    return this.settingsService.current ? this.settingsService.current.partner : null;
  }
  /** Returns accountant main type */
  get accountantMainType() {
    return this.getAccountantMainType(this.accountant);
  }
  /** Shows the edit dialog */
  showEdit(t = !1) {
    const e = this.accountant || {
      type: $l.None,
      info: {
        avatar: {}
      }
    }, a = {
      type: this.getAccountantMainType(e),
      searchResult: [],
      isLoading: !1,
      removalDisabled: t,
      selected: this.getAccountantMainType(e) == "company" ? e.info : null,
      select: (n, i) => {
        n.info = i, n.type = $l.PendingPrimaryPartner, a.selected = i;
      },
      reset: (n) => {
        a.selected = null, Object.assign(n, e);
      },
      search: (n) => (a.isLoading = !0, this.ajax.getJSON(`/v03/api/settings/partners?search=${encodeURIComponent(n)}`).then((i) => (a.searchResult = i, a.isLoading = !1, a.searchResult)))
    };
    return this.uiHelpers.openEditDialog(
      "salaxy-components/modals/settings/AccountantSelection.html",
      e,
      a,
      "lg"
    ).then((n) => {
      if (n.result === "ok") {
        const i = this.uiHelpers.showLoading("SALAXY.UI_Terms.isSaving");
        return a.type === "none" && (n.item.info.avatar.firstName || n.item.info.avatar.lastName) && (n.item.type = $l.None, n.item.info.avatar.displayName = (n.item.info.avatar.firstName + " " + n.item.info.avatar.lastName).trim(), n.item.info.avatar.color = "gray", n.item.info.avatar.entityType = Xi.Person, n.item.info.avatar.initials = (((n.item.info.avatar.firstName ?? "") + " ")[0].toUpperCase() + ((n.item.info.avatar.lastName ?? "") + " ")[0].toUpperCase()).trim()), this.settingsService.current.partner = n.item, this.settingsService.save().then(() => {
          i.dismiss();
        });
      } else if (n.result === "remove") {
        this.settingsService.current.partner = {
          info: {
            avatar: {}
          },
          type: $l.None
        };
        const i = this.uiHelpers.showLoading("SALAXY.UI_Terms.isSaving");
        return this.settingsService.save().then(() => {
          i.dismiss();
        });
      } else if (n.result === "removePrimaryPartner") {
        this.showConfirmPartnerRemoval();
        return;
      }
    });
  }
  /** Removes pricing partner using confirmation dialog. */
  showConfirmPartnerRemoval() {
    this.uiHelpers.showConfirm("SALAXY.NG1.AccountantComponent.showConfirmPartnerRemovalTitle", "SALAXY.NG1.AccountantComponent.showConfirmPartnerRemovalDesciption").then((t) => {
      if (t) {
        this.settingsService.current.partner = {
          info: {
            avatar: {}
          },
          type: $l.None
        };
        const e = this.uiHelpers.showLoading("SALAXY.UI_Terms.isSaving");
        return this.settingsService.save().then(() => {
          e.dismiss();
        });
      }
    });
  }
  /** Save current accountant. This mainly for email address. */
  save() {
    const t = this.uiHelpers.showLoading("SALAXY.UI_Terms.isSaving");
    return this.settingsService.save().then(() => {
      t.dismiss();
    });
  }
  getAccountantMainType(t) {
    return !t || !t.type || t.type === $l.Unknown || t.type === $l.None ? "none" : "company";
  }
};
KS.$inject = ["AjaxNg1", "SettingsService", "UiHelpers"];
let Zg = KS;
const lc = class lc {
  constructor(t, e, a, n, i) {
    this.settingsService = t, this.uiHelpers = e, this.sessionService = a, this.$http = n, this.ajax = i, this.$onInit = () => {
    };
  }
  /**
   * Returns true if the given accounting target item is an API integration type acccounting
   * target.
   * @param item The accounting target item
   * @returns True or false.
   */
  isApiIntegration(t) {
    return (t?.availableMethods ?? []).indexOf(Ta.Api) > -1 && (t?.channel === Ks.Procountor || t?.channel === Ks.VismaNetvisor || t?.channel === Ks.VismaFivaldi);
  }
  /** Opens the channel setup dialog in a new window. */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  openChannelSetupDialog(t, e) {
    t?.channel && (this.closeFn = e, this.uiHelpers.showExternalDialog(
      t.id,
      this.getAccountingTargetSettingsUrl(t),
      {},
      this.getExternalDialogConfigByTarget(t)
    ).then((a) => {
      console.log("Accounting target settings saved, results = ", a), this.handleExternalDialogReturnData(t, a) && (t.data = { ...t.data, ...a.item.data });
    }));
  }
  /**
   * Loads the chart of accounts from the channel.
   * @param target Accounting target.
   * @param closeFn $close function to call.
   */
  async configureCoa(t, e) {
    this.closeFn = e;
    const a = await this.loadCoaFromChannel(t);
    if (!a)
      return;
    navigator.clipboard.writeText(a), this.closeFn("close");
    const n = (await new I0(this.ajax).getOData(null)).items.find((i) => i.id === t.id)?.owner;
    this.isAdmin() ? window.location.href = `/AccountingTargetDto/Client/${n}/#/accounting-targets/details/${t.id}` : window.location.href = `./#/accounting-targets/details/${t.id}@${n}`;
  }
  async loadCoaFromChannel(t) {
    const e = await this.$http.get(this.getCoaUrl(t), { responseType: "json" });
    return Object.keys(e.data).reduce((a, n) => a + n + ";" + e.data[n] + `
`, "");
  }
  getAccountingTargetSettingsUrl(t) {
    const e = this.sessionService.getCurrentToken();
    return `${Ne.current.integrationsServer + "/" + lc.channelPaths[t.channel].settings}?accessToken=${e}&accountingTargetId=${t.id}`;
  }
  getExternalDialogConfigByTarget(t) {
    switch (t.channel) {
      case Ks.VismaFivaldi:
        return { height: 810 };
      default:
        return {};
    }
  }
  getCoaUrl(t) {
    const e = this.sessionService.getCurrentToken();
    return `${Ne.current.integrationsServer + "/" + lc.channelPaths[t.channel].coa}?accessToken=${e}&accountingTargetId=${t.id}`;
  }
  handleExternalDialogReturnData(t, e) {
    switch (e.action) {
      case "cancel":
        break;
      case "save":
        if (!wt.equals(t.data, e.item.data))
          return this.saveSettings(e.item), !0;
        break;
      default:
        return !1;
    }
  }
  saveSettings(t) {
    const e = this.findAccountingTargetFromCompanySettings(t);
    e.data = { ...e.data, ...t.data }, this.settingsService.save();
  }
  findAccountingTargetFromCompanySettings(t) {
    return this.settingsService.current.accounting?.targets.find((e) => e.id === t.id);
  }
  isAdmin() {
    return !!this.sessionService.clientRoles.find((e) => e === "admin");
  }
};
lc.$inject = ["SettingsService", "UiHelpers", "SessionService", "$http", "AjaxNg1"], lc.channelPaths = {
  [Ks.Procountor]: {},
  // Procountor accounting channel is under construction.
  [Ks.VismaNetvisor]: {
    settings: "vismanetvisor/settings.html",
    coa: "vismanetvisor/coa"
  },
  [Ks.VismaFivaldi]: {
    settings: "vismafivaldi/settings.html",
    coa: "vismafivaldi/coa"
  }
};
let dw = lc;
const JS = class JS extends nn {
  constructor(t, e, a, n, i, r) {
    super(t, a, n, i), this.fullApi = t, this.sessionService = e, this.$timeout = r, this.accountFilter = "all", this.showDistinct = !1, this.entryCodeGroups = {
      incomeType: "Tulolaji",
      totalType: "Laskettu erä"
    }, this.totalTypes = {
      totalPensionWorker: "Työntekijöiden TyEL-maksut",
      totalPensionEmployer: "Työnantajan TyEL-maksu",
      totalPension: "TyEL-maksut",
      totalUnemploymentWorker: "Työntekijöiden työttömyysvakuutusmaksut",
      totalUnemploymentEmployer: "Työnantajan työttömyysvakuutusmaksu",
      totalUnemployment: "Työttömyysvakuutusmaksut",
      totalSocialSecurityEmployer: "Työnantajan sairausvakuutusmaksu",
      totalSocialSecurityWorker: "Työntekijältä erikseen perittävä sairausvakuutusmaksu",
      totalTax: "Ennakonpidätykset",
      totalTaxAtSource: "Lähdeverot",
      totalPalkkaus: "Palkkaus.fi-palkkio",
      totalWorkerPayment: "Työntekijän nettopalkka ja kulukorvaukset",
      totalPayment: "Maksettu asiakasvaratilille",
      totalAccidentInsurance: "Työtapaturma- ja ammattitautivakuutusmaksut",
      totalGroupLifeInsurance: "Ryhmähenkivakuutusmaksut",
      totalAccruedHolidayPay: "Kertyneet lomapalkat",
      totalAccruedHolidayBonus: "Kertyneet lomarahat",
      totalAccruedHolidaySocialSecurity: "Kertyneet lomapalkkojen sairausvakuutusmaksut",
      totalAccruedHolidayPension: "Kertyneet lomapalkkojen TyEL-maksut",
      totalAccruedHolidayUnemployment: "Kertyneet lomapalkkojen työttömyysvakuutusmaksut (TVR)",
      totalAccruedGroupLifeInsurance: "Kertyneet lomapalkkojen ryhmähenkivakuutusmaksut",
      totalAccruedAccidentInsurance: "Kertyneet lomapalkkojen työtapaturma- ja ammattitautivakuutusmaksut",
      totalPaidHolidaySalary: "Maksetut loma-ajan palkat",
      totalPaidHolidayBonus: "Maksetut lomarahat",
      totalPaidHolidayCompensation: "Maksetut lomakorvaukset",
      totalPaidHolidaySocialSecurity: "Maksetut lomapalkkojen sairausvakuutusmaksut",
      totalPaidHolidayPension: "Maksetut lomapalkkojen TyEL-maksut",
      totalPaidHolidayUnemployment: "Maksetut lomapalkkojen työttömyysvakuutusmaksut (TVR)"
    }, this.incomeTypes = Tn.getAll(L.getLanguage() || Me.Fi).map((l) => ({ value: "" + l.code, text: l.code + " - " + l.label, title: l.description })), this.legacyFlags = [
      { value: "customerSelfPayment", text: "Työnantaja hoitaa" },
      { value: "cfDeductionAtSalaxy", text: "Palkkaus pidättää" },
      { value: "incomeEarnerEntrepreneur", text: "Sovellettava eläketurva: yrittäjä" },
      { value: `${Wt.Expenses}`, text: "Palkkalaji: Kulukorvaus" },
      { value: `${Wt.PrepaidExpenses}`, text: "Palkkalaji: Kulukorvausennakko" },
      { value: `${Wt.Foreclosure}`, text: "Palkkalaji: Ulosotto" },
      { value: `${Wt.UnionPayment}`, text: "Palkkalaji: AY-jäsenmaksu" },
      { value: `${Wt.Advance}`, text: "Palkkalaji: Palkkaennakko" },
      { value: `${Wt.Service}`, text: "Palkkalaji: Palvelumaksu" },
      { value: `${Wt.HolidaySalary}`, text: "Palkkalaji: Loma-ajan palkka" },
      { value: `${Wt.PaidSickLeave}.${uc.PaidSickLeaveSalary}`, text: "Palkkalaji: Palkallinen sairauspoissaolo, kertakorvaus" },
      { value: `${Wt.PaidSickLeave}.${uc.PaidSickLeaveHourlySalary}`, text: "Palkkalaji: Palkallinen sairauspoissaolo, tuntipalkka" },
      { value: `${Wt.PaidSickLeave}.${uc.PaidSickLeaveMonthlySalary}`, text: "Palkkalaji: Palkallinen sairauspoissaolo, kuukausipalkka" },
      { value: `${Wt.Training}.${pc.TrainingSalary}`, text: "Palkkalaji: Koulutusaika, kertakorvaus" },
      { value: `${Wt.Training}.${pc.TrainingHourlySalary}`, text: "Palkkalaji: Koulutusaika, tuntipalkka" },
      { value: `${Wt.Training}.${pc.TrainingMonthlySalary}`, text: "Palkkalaji: Koulutusaika, kuukausipalkka" },
      { value: `${Wt.DeductibleOfExerciseAndCultureBenefit}`, text: "Palkkalaji: Liikunta- ja kulttuuri-edun omavastuu" }
    ];
  }
  /**
   * Implement IController
   */
  $onInit() {
    super.$onInit();
  }
  /** Implements the getDefaults of ApiCrudObjectController */
  getDefaults() {
    return {
      listUrl: this.listUrl || "/accounting-targets",
      detailsUrl: this.detailsUrl || "/accounting-targets/details/",
      oDataTemplateUrl: "salaxy-components/odata/lists/AccountingTargets.html",
      oDataOptions: {}
    };
  }
  /**
   * Additional setup after the item has been loaded.
   * @param item Item that has been loaded
   */
  setCurrentRef(t) {
    super.setCurrentRef(t), this.current?.ruleSet?.templateId && this.current.ruleSet.templateId !== this.template?.ruleSet?.templateId && this.fullApi.getSingle(this.current.ruleSet.templateId).then((e) => {
      this.template = e;
    });
  }
  /**
   * Shows the detail view for the item.
   * Supports viewing public items from other users as read-only.
   * @param item Item may be either Container or list item.
   */
  showDetails(t) {
    return this.parentController ? this.parentController.showDetails(t) : this.$location.url(this.getDefaults().detailsUrl + this.getId(t) + "@" + t.owner);
  }
  /** Gets entry description */
  getEntryDescription(t) {
    switch (t.entryCodeGroup) {
      case "incomeType":
        return this.entryCodeGroups[t.entryCodeGroup] + ": " + this.incomeTypes.find((e) => e.value === t.entryCode).text;
      case "totalType":
        return this.entryCodeGroups[t.entryCodeGroup] + ": " + this.totalTypes[t.entryCode];
    }
    return "";
  }
  /** Selects entry */
  selectEntry(t) {
    this.uiHelpers.openEditDialog(
      "salaxy-components/modals/settings/EntryCodes.html",
      t,
      {
        entryCodeGroups: this.entryCodeGroups,
        totalTypes: this.totalTypes,
        incomeTypes: this.incomeTypes
      }
    ).then((e) => {
      e.action == We.Ok && e.item.entryCode && e.item.entryCodeGroup && (t.entryCode = e.item.entryCode, t.entryCodeGroup = e.item.entryCodeGroup);
    });
  }
  /**
   * Shows the detail view with a new item that is a copy of the given item.
   * Please note that this method supports copying public items from other users. Override is required because the default cannoty copy from other users
   * @param item Item may be either Container or list item.
   */
  showCopyAsNew(t) {
    return this.parentController ? this.parentController.showCopyAsNew(t) : this.$location.url(this.getDefaults().detailsUrl + this.getId(t) + "@" + t.owner + "/copy-as-new");
  }
  /**
   * Creates a copy of the current set
   * Changes the settings so that the accounting target becomes a new item
   * @param copySource Item (container item) to copy as new.
   */
  copyItem(t) {
    const e = super.copyItem(t);
    return e.info.target.avatar.id = null, e.info.target.avatar.displayName = "Kopio " + e.info.target.avatar.displayName, e.ruleSet.templateId = t.id + "@" + t.owner, e.isReadOnly = !1, e.ruleSet.targetCoA = wt.copy(e.ruleSet.accounts), e;
  }
  /** Selects the account */
  selectAccount(t, e) {
    const a = wt.copy(this.current.ruleSet.accounts);
    for (const n of a)
      e ? n.isSelected = n.id === t.creditId : n.isSelected = n.id === t.debitId;
    this.uiHelpers.showDialog(
      "salaxy-components/report/modals/AccountNumbers.html",
      null,
      {
        accounts: a
      }
    ).then((n) => {
      n && (e ? t.creditId = n.id : t.debitId = n.id);
    });
  }
  /**
   * Sets selectedAccount
   * @param selectedAccount selectedAccount
   */
  selectTargetAccount(t) {
    const e = wt.copy(this.current.ruleSet.targetCoA);
    for (const a of e)
      a.isSelected = a.account === t.account;
    this.uiHelpers.showDialog(
      "salaxy-components/report/modals/AccountNumbers.html",
      null,
      {
        accounts: e
      }
    ).then((a) => {
      a && (t.account = a.account, t.text = a.text);
    });
  }
  /** Return targetCoA */
  get hasTargetCoA() {
    return !!this.current.ruleSet.targetCoA.length;
  }
  groupBy(t, e, a = !1) {
    let n = t.reduce((i, r) => {
      const l = e(r);
      return i[l] = i[l] || [], i[l].push(r), i;
    }, {});
    return a && (n = Object.keys(n).sort().reduce((i, r) => (i[r] = n[r], i), {})), n;
  }
  /** Gets the ruleset rouws grouped by account and grouping */
  get groupedRows() {
    return this.uiHelpers.cache(this, "groupedRows", () => {
      if (!this.current)
        return null;
      const t = (e) => {
        if (!e.isIncluded)
          return "xxxx";
        const a = (this.getAccount(e.debitId)?.account || "9999") + (e.debitGrouping || "yyyy"), n = (this.getAccount(e.creditId)?.account || "9999") + (e.creditGrouping || "yyyy");
        return a + n || "zzzz";
      };
      return this.groupBy(this.current.ruleSet.rows, t, !0);
    });
  }
  /**
   * Get rows based on current ruleSet, account and isDebet
   * @param account iterated account from current.ruleSet.accounts
   * @param isDebet indicates if debet or credit account
   */
  getRulesetByAccount(t, e) {
    return this.current.ruleSet.rows.filter((a) => e ? a.debitId === t.id : a.creditId === t.id);
  }
  /** Returns account details */
  getAccount(t) {
    return this.current.ruleSet.accounts.find((e) => e.id === t);
  }
  /** Adds new account */
  addAccount(t = !1) {
    const e = t ? this.current.ruleSet.accounts.length : 0, a = t ? this.current.ruleSet.accounts[this.current.ruleSet.accounts.length - 1] : this.current.ruleSet.accounts[0], n = {
      isReadOnly: !1,
      id: this.newGuid(),
      account: a.account,
      text: a.text
    };
    this.current.ruleSet.accounts.splice(e, 0, n);
  }
  /**
   * Add new account to TargetCoA
   * @param addToEnd tells if adds to end of array or not
   */
  addTargetCoaAccount(t = !1) {
    const e = t ? this.current.ruleSet.targetCoA.length : 0, a = t ? this.current.ruleSet.targetCoA[this.current.ruleSet.targetCoA.length - 1] : this.current.ruleSet.targetCoA[0], n = {
      isReadOnly: !1,
      id: this.newGuid(),
      account: a.account,
      text: a.text
    };
    this.current.ruleSet.targetCoA.splice(e, 0, n);
  }
  /** Removes the account */
  removeAccount(t, e = !1) {
    if (!t.isReadOnly)
      if (e) {
        const a = this.current.ruleSet.targetCoA.findIndex((n) => n === t);
        this.current.ruleSet.targetCoA.splice(a, 1);
      } else {
        if (this.current.ruleSet.rows.some((n) => n.creditId === t.id || n.debitId === t.id)) {
          this.uiHelpers.showAlert("Tiliä ei voi poistaa", "Tili on käytössä tiliöintimallissa.");
          return;
        }
        const a = this.current.ruleSet.accounts.findIndex((n) => n.id === t.id);
        this.current.ruleSet.accounts.splice(a, 1);
      }
  }
  /**
   * Validated row input
   * @param row Row to be validated
   */
  isValidAccount(t) {
    return this.current.ruleSet.targetCoA.length ? !!this.current.ruleSet.targetCoA.find((e) => e.account.toString() === t.account.toString()) : !0;
  }
  /** Adds a new row */
  addRow(t, e = !1) {
    const a = t ? this.current.ruleSet.rows.findIndex((r) => r.id === t.id) : this.current.ruleSet.rows.length, n = t || (e ? this.current.ruleSet.rows[0] : this.current.ruleSet.rows[this.current.ruleSet.rows.length - 1]), i = {
      isReadOnly: !1,
      enabled: n.enabled,
      id: this.newGuid(),
      entryCodeGroup: n.entryCodeGroup,
      entryCode: n.entryCode,
      isIncluded: n.isIncluded,
      debitId: n.debitId,
      debitGrouping: n.debitGrouping,
      creditId: n.creditId,
      creditGrouping: n.creditGrouping,
      flags: wt.copy(n.flags)
    };
    this.current.ruleSet.rows.splice(e ? 0 : a, 0, i);
  }
  /** Removes the row */
  removeRow(t) {
    const e = this.current.ruleSet.rows.findIndex((a) => a.id === t.id);
    t.isReadOnly || this.current.ruleSet.rows.splice(e, 1);
  }
  /** Selects flags */
  selectFlags(t) {
    this.uiHelpers.openEditDialog(
      "salaxy-components/modals/settings/Flags.html",
      t,
      {
        getFlagText: (e) => this.getFlagText(e),
        addFlag: (e) => {
          const a = {
            prefix: "",
            value: "",
            kind: "",
            dimensionValue: ""
          }, n = {
            _userDefinedRow: {
              item: null,
              row: {
                data: {
                  get kind() {
                    return n._userDefinedRow.item.kind;
                  },
                  set kind(i) {
                    n._userDefinedRow.item.kind = i;
                  }
                },
                get rowType() {
                  return n._userDefinedRow.item.prefix == "type" ? n._userDefinedRow.item._value : n._userDefinedRow.item.value;
                },
                set rowType(i) {
                  n._userDefinedRow.item.prefix == "type" ? n._userDefinedRow.item._value = i : n._userDefinedRow.item.value = i;
                },
                get type() {
                  return n._userDefinedRow.item.prefix == "type" ? n._userDefinedRow.item.value : n._userDefinedRow.item._value;
                },
                set type(i) {
                  n._userDefinedRow.item.prefix == "type" ? n._userDefinedRow.item.value = i : n._userDefinedRow.item._value = i;
                }
              }
            },
            asUserDefinedRow: (i) => (n._userDefinedRow.item = i, n._userDefinedRow.row),
            pensionCalculation: He.getEnumMetadata("PensionCalculation").values.map((i) => ({ text: i.label, value: i.name })).concat({ value: "entrepreneurLike", text: "Sovellettava eläketurva: yrittäjä" }),
            selfPayment: [
              { text: "SALAXY.ENUM.InvoiceType.net.label", value: "net" },
              { text: "SALAXY.ENUM.InvoiceType.tax.label", value: "tax" },
              { text: "SALAXY.ENUM.InvoiceType.pension.label", value: "pension" },
              { text: "SALAXY.ENUM.InvoiceType.unemployment.label", value: "unemployment" }
            ],
            dimension: (this.sessionService.session?.settings?.costAccounting?.dimensions ?? []).map((i) => ({ text: i.label, value: i.id })),
            prefixOptions: [
              { text: "SALAXY.NG1.EmploymentRelation.employmentRelation", value: "employmentType" },
              { text: "SALAXY.NG1.WorkerWizardComponent.employment.pension.title", value: "pensionCalculation" },
              { text: "SALAXY.NG1.CalcRowTypeComponent.rowType", value: "rowType" },
              { text: "SALAXY.NG1.CalcRowTypeComponent.wageType", value: "type" },
              { text: "SALAXY.MODEL.CostAccountingSettings.title", value: "dimension" },
              { text: "SelfPayment", value: "selfPayment" },
              { text: "Behavior", value: "behavior" },
              { text: "Regex", value: "regex" }
            ]
          };
          this.uiHelpers.openEditDialog(
            "salaxy-components/modals/settings/FlagSelection.html",
            a,
            n
          ).then((i) => {
            i.action == We.Ok && (i.item.prefix == "type" ? i.item.kind ? e.flags.push(i.item.prefix + "." + i.item.value + "/" + i.item.kind) : e.flags.push(i.item.prefix + "." + i.item.value) : i.item.prefix == "rowType" ? i.item.kind ? e.flags.push(i.item.prefix + "." + i.item.value + "." + i.item.kind) : e.flags.push(i.item.prefix + "." + i.item.value) : i.item.prefix == "dimension" ? e.flags.push(i.item.prefix + "." + i.item.value + "." + i.item.dimensionValue) : e.flags.push(i.item.prefix + "." + i.item.value));
          });
        }
      }
    ).then((e) => {
      e.action == We.Ok && (t.flags = e.item.flags.filter((a) => !!a));
    });
  }
  /** Paste data from clipboard. */
  pasteFromClipboard() {
    return this.rawData = null, this.fileExtension = null, navigator.clipboard.readText().then((t) => (this.rawData = t, this.import(), this.$timeout(() => this.rawData)));
  }
  /**
   * Reads the file
   * @param file Selected file
   */
  readFile(t) {
    return this.rawData = null, this.fileExtension = null, t ? (t.name && (this.fileExtension = Qp.getExtensionFromFileName(t.name)), new Promise((a, n) => {
      const i = new FileReader();
      i.onloadend = () => {
        a(i.result);
      }, i.onerror = () => n, i.readAsText(t);
    }).then((a) => (this.rawData = a, this.import(), this.$timeout(() => a)))) : Promise.resolve(null);
  }
  /**
   * Import data
   */
  import() {
    let t = null;
    if (this.fileExtension && this.fileExtension === "xlsx") {
      this.uiHelpers.showAlert("Tiedoston muotoa ei tueta", "Excel-tiedostot eivät ole vielä tuettuja. Tallenna Excel-taulukko csv-muodossa tai kopioi taulukko leikepöydän kautta.");
      return;
    }
    const e = Qp.getFileDelimiter(this.rawData);
    if (e === tX.Unknown) {
      this.uiHelpers.showAlert("Tiedoston muotoa ei tueta", "Virheellinen");
      return;
    }
    const a = Ko.getFirstRow(this.rawData, e);
    if (!a.length) {
      this.uiHelpers.showAlert("Tiedoston rivejä ei voida lukea", "Virheellinen");
      return;
    }
    const n = Object.keys(a), i = !/\d/.test(a[n[0]]) && !/\d/.test(a[n[1]]) ? null : ["aaaa", "bbbb"];
    t = Ko.import(this.rawData, Qp.getTableFormatByDelimeter(e), Qp.getCsvLocale(e), i);
    const r = this.validateTableData(t);
    if (r.validationSuccess) {
      const l = t.data.map((o) => ({ account: o[r.account].toString(), text: o[r.text] }));
      this.current.ruleSet.targetCoA.length ? this.uiHelpers.showConfirm("Tilikartan päivitys", "Haluatko korvata aikaisemman tilikarttasi tuodulla", "Kyllä", "En").then((o) => {
        o && (this.current.ruleSet.targetCoA = l);
      }) : this.current.ruleSet.targetCoA = l;
    } else
      this.uiHelpers.showAlert("Tiedoston muotoa ei tueta", "Virheellinen");
  }
  /**
   * Sort accounts
   */
  sortRulesetAccounts() {
    this.current.ruleSet.accounts.sort((t, e) => t.account > e.account ? 1 : t.account < e.account ? -1 : 0);
  }
  /**
   * Updates ruleSet account with provided targetCoA account
   * @param targetCoaAccount targetCoA account
   */
  updateRuleSetAccount(t) {
    const e = this.current.ruleSet.accounts.find((a) => a.account === t.account);
    e && (e.text = t.text);
  }
  /**
   * Updates provided account text to match targetCoa account
   * @param rulesetAccount ruleSet account
   */
  updateAccountToMatchTargetCoa(t) {
    const e = this.current.ruleSet.targetCoA.find((a) => a.account === t.account);
    e && (t.text = e.text);
  }
  /**
   * Return account text to ui
   */
  get accountFilterText() {
    switch (this.accountFilter) {
      case "all":
        return "SALAXY.NG1.AccountingTargetDetailsComponent.filters.all";
      case "includedAndEnabled":
        return "SALAXY.NG1.AccountingTargetDetailsComponent.filters.includedAndEnabled";
      case "error":
        return "SALAXY.NG1.AccountingTargetDetailsComponent.filters.error";
    }
  }
  /**
   * Filter accounts
   */
  get filteredAccounts() {
    switch (this.accountFilter) {
      case "all":
        return this.current.ruleSet.accounts;
      case "includedAndEnabled":
        return this.current.ruleSet.accounts.filter((t) => this.current.ruleSet.rows.find((e) => e.enabled && e.isIncluded && (e.debitId === t.id || e.creditId === t.id)));
      case "error":
        return this.current.ruleSet.accounts.filter((t) => !this.current.ruleSet.targetCoA.map((e) => e.account).includes(t.account));
    }
  }
  /**
   * Get accounting rules acount for distinct view
   * @param account account id
   * @returns rules count as number
   */
  getRulesCount(t) {
    const e = this.current.ruleSet.accounts.filter((a) => a.account === t).map((a) => a.id);
    switch (this.accountFilter) {
      case "all":
      case "error":
        return this.current.ruleSet.rows.filter((a) => e.indexOf(a.debitId) >= 0 || e.indexOf(a.creditId) >= 0).length;
      case "includedAndEnabled":
        return this.current.ruleSet.rows.filter((a) => a.enabled && a.isIncluded && (e.indexOf(a.debitId) >= 0 || e.indexOf(a.creditId) >= 0)).length;
    }
  }
  /** Returns flag text */
  getFlagText(t) {
    if (!t)
      return { found: !1, text: null };
    const e = this.legacyFlags.find((i) => i.value === t);
    if (e)
      return { found: !0, text: e.text };
    const a = t.split(".");
    let n = "";
    switch (a[0]) {
      case "employmentType":
        n = He.getEnumLabel("EmploymentRelationType", a[1]);
        break;
      case "pensionCalculation":
        a[1] == "entrepereurLike" ? n = "Sovellettava eläketurva: yrittäjä" : n = He.getEnumLabel("PensionCalculation", a[1]);
        break;
      case "rowType":
        a.length > 2 ? n = this.getCalculationRowTypeLabel(a[1], a[2]) : n = this.getCalculationRowTypeLabel(a[1], null);
        break;
      case "type":
        n = t.replace("type.", "");
        break;
      case "dimension":
        n = t.replace("dimension.", "");
        break;
      case "selfPayment":
        n = He.getEnumLabel("InvoiceType", a[1]), n && (n = "Self payment: " + n);
        break;
      case "behavior":
        n = He.getEnumLabel("CalculationFlag", a[1]);
        break;
      case "regex":
        n = t.replace("regex.", "");
        break;
    }
    return n ? { found: !0, text: n } : { found: !1, text: t };
  }
  /**
   * Created distinct object array with account key
   */
  get distinctAccounts() {
    return [...new Map(this.filteredAccounts.map((t) => [t.account, t])).values()];
  }
  /**
   * Acount number of digits in account candidate
   */
  countDigits(t) {
    const e = t.match(/\d+/g);
    return e ? e.join("").length : 0;
  }
  /**
   * Validated generated Tables data
   * @returns is TableData valid
   */
  validateTableData(t) {
    if (!t.data)
      return { validationSuccess: !1, account: null, text: null };
    if (t.errors.length !== 0)
      return { validationSuccess: !1, account: null, text: null };
    if (t.data && t.data.length < 1)
      return { validationSuccess: !1, account: null, text: null };
    for (const [e, a] of Object.entries(t.data[0]))
      if (e.length < 2 || a.length < 2)
        return { validationSuccess: !1, account: null, text: null };
    for (const e of t.data) {
      const a = Object.keys(e), n = this.countDigits(e[a[0]].toString()), i = this.countDigits(e[a[1]].toString());
      return !/\d/.test(e[a[0]]) && !/\d/.test(e[a[1]]) ? { validationSuccess: !1, account: null, text: null } : { validationSuccess: !0, account: n > i ? a[0] : a[1], text: n > i ? a[1] : a[0] };
    }
  }
  newGuid() {
    let t = (/* @__PURE__ */ new Date()).getTime();
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (a) => {
      const n = (t + Math.random() * 16) % 16 | 0;
      return t = Math.floor(t / 16), (a === "x" ? n : n & 3 | 8).toString(16);
    });
  }
  getCalculationRowTypeLabel(t, e) {
    let a = "";
    if (t === Wt.IrIncomeType)
      a = Tn.getAll(null).find((n) => e && n.transactionCode === e)?.label;
    else if (e) {
      const n = Gi.getRowConfig(t);
      a = He.getEnumLabel(n.kind.name, e, null, null);
    }
    return a || He.getEnumLabel("CalculationRowType", t, null, null);
  }
};
JS.$inject = [
  "AccountingTargets",
  "SessionService",
  "UiHelpers",
  "$location",
  "$routeParams",
  "$timeout"
];
let ty = JS;
const Yr = class Yr {
  constructor(t, e, a, n, i) {
    this.sessionService = t, this.settingsService = e, this.uiHelpers = a, this.ajax = n, this.$sce = i, this.sideCosts = gr.getYearlyChangingNumbers(/* @__PURE__ */ new Date()).sideCosts, this._irCertificate = null, this._openAiKey = null, this.saves = {};
  }
  /**
   * Initializes the controller
   */
  $onInit() {
    this.sections = this.sections || ["pensionContracts", "yelPensionContracts", "insuranceContracts", "incomesRegister", "payslip", "omapalkka"], this._openAiKey = window.localStorage.getItem("openAiKey") || "";
  }
  /** Copy current from SettingsService */
  get current() {
    return !this._current && this.settingsService.current && (this._current = wt.copy(this.settingsService.current)), this._current;
  }
  /** Returns current pension contracts once loaded assuring there is at least one active item. */
  get pensionContracts() {
    return this.current ? (Yr.getActive(this.current.calc.pensionContracts) || this.current.calc.pensionContracts.push({}), this.current.calc.pensionContracts) : null;
  }
  /** Returns current insurance contracts once loaded assuring there is at least one active item. */
  get insuranceContracts() {
    return this.current ? (Yr.getActive(this.current.calc.insuranceContracts) || this.current.calc.insuranceContracts.push({}), this.current.calc.insuranceContracts) : null;
  }
  /**
   * Returns current default accounting target.
   */
  get defaultAccountingTarget() {
    return !this.current?.accounting?.targets || !this.current?.accounting?.defaultTargetId ? null : this.current.accounting.targets.find((t) => t.id == this.current?.accounting.defaultTargetId);
  }
  /**
   * Returns true, if the contract should be visible:
   * Companies: All pending contracts and first active contract.
   * Personal: The first active contract, no pending contracts.
   * @param contract Contract to evaluate
   * @param allContracts Collection of contracts that contain the contract to evaluate.
   */
  isVisibleContract(t, e) {
    return t.status === RL.Pending ? !!this.sessionService.isInRole("company") : t === Yr.getActive(e);
  }
  /** Gets the relevant contracts that are shown in personal (household) userinterface. */
  get personal() {
    const t = {
      insurance: null,
      pension: null
    };
    return this.current && (t.insurance = Yr.getActive(this.insuranceContracts), t.pension = Yr.getActive(this.pensionContracts)), t;
  }
  /** Returns OPEN AI Key */
  get openAiKey() {
    return this._openAiKey;
  }
  /** Sets OPEN AI Key */
  set openAiKey(t) {
    this._openAiKey = t;
  }
  /** Saves open AI Key */
  saveOpenAiKey() {
    window.localStorage.setItem("openAiKey", this._openAiKey || "");
  }
  /**
   * Saves changes for settings
   * @param section Section to save: Copies only that section to settingsService.
   * Null saves nothing.
   */
  save(t) {
    switch (t) {
      case "pensionContracts":
        this.settingsService.current.calc.pensionContracts = wt.copy(this.current.calc.pensionContracts), this.settingsService.current.payments.customerFunds.isPensionSelfHandling = this.current.payments.customerFunds.isPensionSelfHandling;
        break;
      case "insuranceContracts":
        this.settingsService.current.calc.insuranceContracts = wt.copy(this.current.calc.insuranceContracts);
        break;
      case "incomesRegister":
        this.settingsService.current.calc.incomesRegister = wt.copy(this.current.calc.incomesRegister);
        break;
      case "eInvoice":
        this.settingsService.current.payments.invoice.eInvoiceReceiver = this.current.payments.invoice.eInvoiceReceiver, this.settingsService.current.payments.invoice.eInvoiceIntermediator = this.current.payments.invoice.eInvoiceIntermediator;
        break;
      case "sepa":
        this.settingsService.current.payments.invoice.sepaBankPartyId = this.current.payments.invoice.sepaBankPartyId, this.settingsService.current.payments.invoice.ibanNumber = this.current.payments.invoice.ibanNumber;
        break;
      case "taxAndSocialSecuritySelfHandling":
        this.settingsService.current.payments.customerFunds.isTaxAndSocialSecuritySelfHandling = this.current.payments.customerFunds.isTaxAndSocialSecuritySelfHandling;
        break;
      case "workerSelfHandling":
        this.settingsService.current.payments.customerFunds.isWorkerSelfHandling = this.current.payments.customerFunds.isWorkerSelfHandling;
        break;
      case "unemploymentSelfHandling":
        return;
      case "payslip": {
        const e = this.settingsService.current.messaging.workerSalarySlipDeliveryMethods.filter((a) => a !== ps.Payslip);
        this.settingsService.current.messaging.workerSalarySlipDeliveryMethods.splice(0, this.settingsService.current.messaging.workerSalarySlipDeliveryMethods.length), this.settingsService.current.messaging.workerSalarySlipDeliveryMethods.push(...e), this.current.messaging.workerSalarySlipDeliveryMethods.indexOf(ps.Payslip) > -1 && this.settingsService.current.messaging.workerSalarySlipDeliveryMethods.push(ps.Payslip);
        break;
      }
      case "omapalkka": {
        const e = this.settingsService.current.messaging.workerSalarySlipDeliveryMethods.filter((a) => a !== ps.Omapalkka);
        this.settingsService.current.messaging.workerSalarySlipDeliveryMethods.splice(0, this.settingsService.current.messaging.workerSalarySlipDeliveryMethods.length), this.settingsService.current.messaging.workerSalarySlipDeliveryMethods.push(...e), this.current.messaging.workerSalarySlipDeliveryMethods.indexOf(ps.Omapalkka) > -1 && this.settingsService.current.messaging.workerSalarySlipDeliveryMethods.push(ps.Omapalkka);
        break;
      }
      case "all":
        this.settingsService.current = wt.copy(this.current);
        break;
    }
    t && (this.saves[t] = !0, this.settingsService.save().then((e) => {
      switch (t) {
        case "pensionContracts":
          this.current.calc.pensionContracts = wt.copy(e.calc.pensionContracts), this.current.payments.customerFunds.isPensionSelfHandling = e.payments.customerFunds.isPensionSelfHandling;
          break;
        case "insuranceContracts":
          this.current.calc.insuranceContracts = wt.copy(e.calc.insuranceContracts);
          break;
        case "incomesRegister":
          this.current.calc.incomesRegister = wt.copy(e.calc.incomesRegister);
          break;
        case "eInvoice":
          this.current.payments.invoice.eInvoiceReceiver = e.payments.invoice.eInvoiceReceiver, this.current.payments.invoice.eInvoiceIntermediator = e.payments.invoice.eInvoiceIntermediator;
          break;
        case "sepa":
          this.current.payments.invoice.sepaBankPartyId = e.payments.invoice.sepaBankPartyId, this.current.payments.invoice.ibanNumber = e.payments.invoice.ibanNumber;
          break;
        case "taxAndSocialSecuritySelfHandling":
          this.current.payments.customerFunds.isTaxAndSocialSecuritySelfHandling = e.payments.customerFunds.isTaxAndSocialSecuritySelfHandling;
          break;
        case "workerSelfHandling":
          this.current.payments.customerFunds.isWorkerSelfHandling = e.payments.customerFunds.isWorkerSelfHandling;
          break;
        case "payslip":
        case "omapalkka":
          this.current.messaging.workerSalarySlipDeliveryMethods = e.messaging.workerSalarySlipDeliveryMethods;
          break;
        case "all":
          this._current = wt.copy(e);
          break;
      }
      this.saves[t] = !1;
    }));
  }
  /**
   * Creates a new IR certificate.
   * @param transferId Transfer ID for the IR certificate.
   * @param transferPassword One time transfer password for the IR certificate.
   * @returns Information about the created IR certificate.
   */
  async createIrCertificate(t, e) {
    this.saves.irCertificate = !0;
    try {
      await this.settingsService.createIrCertificate(t, e);
    } finally {
      this.saves.irCertificate = !1, this._irCertificate = null;
    }
    return Promise.resolve();
  }
  /**
   * Renews an existing IR certificate.
   * @returns Information about the created IR certificate.
   */
  async renewIrCertificate() {
    this.saves.irCertificate = !0;
    try {
      await this.settingsService.renewIrCertificate();
    } finally {
      console.log("renewIrCertificate"), this.saves.irCertificate = !1, this._irCertificate = null;
    }
    return Promise.resolve();
  }
  /** Returns true if the account has chosen to use own certificate */
  hasOwnIrCertificate() {
    return this.settingsService.current?.calc?.incomesRegister?.irDelivery?.senderOfficialId != null && this.settingsService.current?.calc?.incomesRegister?.irDelivery?.senderOfficialId == this.sessionService.session?.currentAccount?.identity?.officialId;
  }
  /** Current IR certificate */
  get irCertificate() {
    return this.hasOwnIrCertificate() && (this._irCertificate || (this._irCertificate = {
      id: null
    }, this.settingsService.getIrCertificate().then((t) => {
      t?.id && wt.copy(t, this._irCertificate);
    }))), this._irCertificate;
  }
  /**
   * Send all workers paid calculations to omapalkka
   */
  sendPaidCalculationsToOmapalkka() {
    const t = this.uiHelpers.showLoading();
    this.ajax.postJSON(`${Ne.current.getOmapalkkaApiServer()}/api/messages/create-for-salary/all`, {}).then(() => {
      t.dismiss();
    }).catch((e) => {
      console.error(e), t.dismiss();
    });
  }
  /** Checks if switch input should be disabled on salarySlipDeliveryMethodsForm*/
  disableSwitchInput() {
    return this.isSaving("omapalkka") || this.isSaving("payslip") || !!this.isReadOnlyForced || !this.current.messaging.denyServiceModel && this.current.partner.serviceModel.features.messaging;
  }
  /**
   * Sets pension number for test account to the given contract
   * @param item Pension contract
   */
  setPensionNumberForTest(t) {
    t.contractNumber = C0.getPensionNumberForTest(t.company);
  }
  /**
   * Shows the eInvoice selection dialog
   */
  selectEInvoiceAddress() {
    this.settingsService.selectEInvoiceAddress(this.current.payments.invoice);
  }
  /**
   * Gets the progress of save operation.
   * @param section Section to check for saving.
   * Note that "all" will check only "all" operations, not underlying sub-sections saving ("any").
   */
  isSaving(t) {
    return !!(this.saves[t] || this.saves.all);
  }
  /**
   * Event handler for accounting target selection.
   * @param current Settings object to edit/create.
   * @param logic Logic object passed to the dialog controller.
   * @param logic.isReadOnly Read-only flag in logic.
   * @param value Boolean indicating if the item is selected or not.
   * @param item  The selected item.
   * @param allItems All selected items.
   */
  onAccountingTargetSelect(t, e, a, n, i) {
    i.splice(0, i.length), e.isReadOnly = !0, a == !0 && (t.id = n.id, t.avatar = n.otherPartyInfo.avatar, t.format = n.data.format, t.channel = n.data.channel, t.method = n.data.method, t.availableMethods = ie.assureArray(n.data.availableMethods), e.isReadOnly = !1, i.push(n));
  }
  /**
   * Event handler for usecase selection.
   * @param current Settings object to edit/create.
   * @param logic Logic object passed to the dialog controller.
   * @param logic.isReadOnly Read-only flag in logic.
   * @param value Boolean indicating if the item is selected or not.
   * @param item  The selected item.
   * @param allItems All selected items.
   */
  onUsecaseSelect(t, e, a, n, i) {
    i.splice(0, i.length), e.isReadOnly = !0, a == !0 && (t.uri = n.reference, t.label = n.shortText, t.itemType = n.entityType, t.status = n.status, t.order = n.data.order, e.isReadOnly = !1, i.push(n));
  }
  /**
   * Return Avatar from current.payment.channels ENUM
   * @returns Avatar
   */
  getPaymentChannelAvatar(t) {
    return ne.getChannelAvatar(t.channel);
  }
  /**
   * Created InputEnumOption [] from current.accounting.targets
   * @returns InputEnumOption [] for template
   */
  getSelectableAccountingTargets() {
    return this.uiHelpers.cache(
      this,
      "selectableAccountingTargets",
      () => this.current.accounting.targets.map((t) => ({
        text: t.avatar.displayName,
        value: t.id,
        ui: t.avatar
      })),
      () => this.current.accounting.targets.map((t) => t.id)
    );
  }
  /**
   * Created InputEnumOption [] from current.payment.channels
   * @returns InputEnumOption [] for template
   */
  getSelectablePaymenMethods() {
    return this.uiHelpers.cache(
      this,
      "selectablePaymentMethods",
      () => this.current.payments.channels.map((t) => {
        const e = ne.getChannelAvatar(t.channel) ?? ne.getChannelAvatar(At.Undefined);
        return {
          text: e.displayName,
          value: e.id,
          ui: e
        };
      }),
      () => this.current.payments.channels.map((t) => ne.getChannelAvatar(t.channel)?.id)
    );
  }
  /**
   * Returns true if the payslip is included in worker's SalarySlipDeliveryMethods.
   */
  get payslip() {
    return this.current?.messaging?.workerSalarySlipDeliveryMethods?.indexOf(ps.Payslip) >= 0 || !1;
  }
  /**
   * Sets/unsets the payslip as one of worker's SalarySlipDeliveryMethods.
   * @param value Boolean value if the payslip should be set.
   */
  set payslip(t) {
    if (this.current) {
      if (t)
        this.current.messaging.workerSalarySlipDeliveryMethods.indexOf(ps.Payslip) < 0 && this.current.messaging.workerSalarySlipDeliveryMethods.push(ps.Payslip);
      else {
        const e = this.current.messaging.workerSalarySlipDeliveryMethods.filter((a) => a !== ps.Payslip);
        this.current.messaging.workerSalarySlipDeliveryMethods.splice(0, this.current.messaging.workerSalarySlipDeliveryMethods.length), this.current.messaging.workerSalarySlipDeliveryMethods.push(...e);
      }
      this.save("payslip");
    }
  }
  /**
   * Returns true if the omapalkka is included in worker's SalarySlipDeliveryMethods.
   */
  get omapalkka() {
    return this.current?.messaging?.workerSalarySlipDeliveryMethods?.indexOf(ps.Omapalkka) >= 0 || !1;
  }
  /**
   * Sets/unsets the omapalkka as one of worker's SalarySlipDeliveryMethods.
   * @param value Boolean value if the payslip should be set.
   */
  set omapalkka(t) {
    if (this.current) {
      if (t)
        this.current.messaging.workerSalarySlipDeliveryMethods.indexOf(ps.Omapalkka) < 0 && this.current.messaging.workerSalarySlipDeliveryMethods.push(ps.Omapalkka);
      else {
        const e = this.current.messaging.workerSalarySlipDeliveryMethods.filter((a) => a !== ps.Omapalkka);
        this.current.messaging.workerSalarySlipDeliveryMethods.splice(0, this.current.messaging.workerSalarySlipDeliveryMethods.length), this.current.messaging.workerSalarySlipDeliveryMethods.push(...e);
      }
      this.save("omapalkka");
    }
  }
  /**
   * Confirm service change
   */
  confirmServiceModelChange() {
    this.uiHelpers.showConfirm("Palvelumallin ohitus", "Olet muuttamassa palvelumallin käyttöä. Paina 'Ok' tallentaaksesi").then((t) => {
      t && this.save("all");
    });
  }
  /**
   * Creates datauri for given image
   * @param logo Logo for dataurl
   */
  createReportLogoDatauri(t) {
    ((a) => new Promise((n, i) => {
      const r = new FileReader();
      r.onload = (l) => {
        n(l.target?.result);
      }, r.onerror = (l) => {
        i(l);
      }, r.readAsDataURL(a);
    }))(t).then((a) => {
      this.current.reporting.logo = `<img src="${a}">`;
    });
  }
  /**
   * Retrieves the report logo.
   * @returns The report logo as a html string.
   */
  getReportLogo() {
    if (!this.current.reporting.logo)
      return "";
    if (this.current.reporting.logo.startsWith("<img src="))
      return this.current.reporting.logo;
    if (this.current.reporting.logo.startsWith("<svg"))
      return this.$sce.trustAsHtml(this.current.reporting.logo);
  }
  static getActive(t) {
    const e = I.getToday();
    return t?.find((a) => a.status !== RL.Pending && I.isSameOrAfter(e, a.startDate ?? "1900-01-01") && I.isBefore(e, I.add(a.endDate ?? "2100-01-01", 1, "day")));
  }
};
Yr.$inject = ["SessionService", "SettingsService", "UiHelpers", "AjaxNg1", "$sce"];
let ii = Yr;
const QS = class QS extends bi {
  /**
   * Creates a new WizardController
   * @param $scope - The Angular scope
   * @param wizardService - Maintains the state of the wizard
   * @param partnerServices - Local Tapiola insurance orders API
   * @param uiHelpers - Salaxy UI helpers
   */
  constructor(t, e, a, n) {
    super(t, e), this.partnerServices = a, this.uiHelpers = n, this.isSent = !1, this.isSending = !1, this.current = null, this.today = I.getToday(), this.countryCodes = [
      { value: "fi", text: "Suomi" },
      { value: "sv", text: "Sverige" },
      { value: "ee", text: "Eesti" }
    ], this.insuranceStartingPointDateOptions = {}, this.wizardSteps = [
      {
        // 0
        title: L.get("SALAXY.NG1.InsuranceComponent.start.wizard.title"),
        heading: L.get("SALAXY.NG1.InsuranceComponent.start.wizard.title"),
        intro: "",
        active: !0,
        view: "salaxy-components/modals/localTapiola/Start.html"
      },
      {
        // 1
        title: L.get("SALAXY.NG1.InsuranceComponent.contactInfo.wizard.title"),
        heading: L.get("SALAXY.NG1.InsuranceComponent.contactInfo.wizard.heading"),
        intro: "",
        view: "salaxy-components/modals/localTapiola/ContactInfo.html",
        buttonsView: "salaxy-components/modals/localTapiola/buttons-default.html"
      },
      {
        // 2
        title: L.get("SALAXY.NG1.InsuranceComponent.ownerInfo.wizard.title"),
        heading: L.get("SALAXY.NG1.InsuranceComponent.ownerInfo.wizard.heading"),
        intro: L.get("SALAXY.NG1.InsuranceComponent.ownerInfo.wizard.intro"),
        view: "salaxy-components/modals/localTapiola/Owner-info.html",
        buttonsView: "salaxy-components/modals/localTapiola/buttons-default.html"
      },
      {
        // 3
        title: L.get("SALAXY.NG1.InsuranceComponent.beneficiaryInfo.wizard.title"),
        heading: L.get("SALAXY.NG1.InsuranceComponent.beneficiaryInfo.wizard.heading"),
        intro: L.get("SALAXY.NG1.InsuranceComponent.beneficiaryInfo.wizard.intro"),
        view: "salaxy-components/modals/localTapiola/Beneficiary-info.html",
        buttonsView: "salaxy-components/modals/localTapiola/buttons-default.html"
      },
      {
        // 4
        title: L.get("SALAXY.NG1.InsuranceComponent.insuranceInfoNew.wizard.title"),
        heading: L.get("SALAXY.NG1.InsuranceComponent.insuranceInfoNew.wizard.heading"),
        intro: "",
        view: "salaxy-components/modals/localTapiola/InsuranceInfo-new.html",
        buttonsView: "salaxy-components/modals/localTapiola/buttons-send.html"
        //buttons send
      },
      {
        // 5
        title: L.get("SALAXY.NG1.InsuranceComponent.entrepreneur.wizard.title"),
        heading: L.get("SALAXY.NG1.InsuranceComponent.entrepreneur.wizard.heading"),
        intro: "",
        view: "salaxy-components/modals/localTapiola/Entrepreneur.html",
        buttonsView: "salaxy-components/modals/localTapiola/buttons-default.html"
      },
      {
        // 6
        title: L.get("SALAXY.NG1.InsuranceComponent.contactInfoEntrepreneur.wizard.title"),
        heading: L.get("SALAXY.NG1.InsuranceComponent.contactInfoEntrepreneur.wizard.heading"),
        intro: "",
        view: "salaxy-components/modals/localTapiola/ContactInfo-entrepreneur.html",
        buttonsView: "salaxy-components/modals/localTapiola/buttons-default.html"
      },
      {
        // 7
        title: L.get("SALAXY.NG1.InsuranceComponent.ownerInfo.wizard.titleAlt"),
        heading: L.get("SALAXY.NG1.InsuranceComponent.ownerInfo.wizard.heading"),
        intro: L.get("SALAXY.NG1.InsuranceComponent.ownerInfo.wizard.intro"),
        view: "salaxy-components/modals/localTapiola/Owner-info.html",
        buttonsView: "salaxy-components/modals/localTapiola/buttons-default.html"
      },
      {
        // 8
        title: L.get("SALAXY.NG1.InsuranceComponent.beneficiaryInfo.wizard.titleAlt"),
        heading: L.get("SALAXY.NG1.InsuranceComponent.beneficiaryInfo.wizard.heading"),
        intro: L.get("SALAXY.NG1.InsuranceComponent.beneficiaryInfo.wizard.intro"),
        view: "salaxy-components/modals/localTapiola/Beneficiary-info.html",
        buttonsView: "salaxy-components/modals/localTapiola/buttons-send.html"
      },
      {
        // 9
        title: L.get("SALAXY.NG1.InsuranceComponent.contactInfo.wizard.titleAlt"),
        heading: "",
        intro: L.get("SALAXY.NG1.InsuranceComponent.contactInfo.wizard.intro"),
        view: "salaxy-components/modals/localTapiola/ContactInfo.html",
        buttonsView: "salaxy-components/modals/localTapiola/buttons-default.html"
      },
      {
        // 10
        title: L.get("SALAXY.NG1.InsuranceComponent.ownerInfo.wizard.titleMoveInsurance"),
        heading: L.get("SALAXY.NG1.InsuranceComponent.ownerInfo.wizard.heading"),
        intro: L.get("SALAXY.NG1.InsuranceComponent.ownerInfo.wizard.intro"),
        view: "salaxy-components/modals/localTapiola/Owner-info.html",
        buttonsView: "salaxy-components/modals/localTapiola/buttons-default.html"
      },
      {
        // 11
        title: L.get("SALAXY.NG1.InsuranceComponent.beneficiaryInfo.wizard.titleMoveInsurance"),
        heading: L.get("SALAXY.NG1.InsuranceComponent.beneficiaryInfo.wizard.heading"),
        intro: L.get("SALAXY.NG1.InsuranceComponent.beneficiaryInfo.wizard.intro"),
        view: "salaxy-components/modals/localTapiola/Beneficiary-info.html",
        buttonsView: "salaxy-components/modals/localTapiola/buttons-default.html"
      },
      {
        // 12
        title: L.get("SALAXY.NG1.InsuranceComponent.insuranceMove.wizard.title"),
        heading: "",
        intro: "",
        view: "salaxy-components/modals/localTapiola/InsuranceInfo-move.html",
        buttonsView: "salaxy-components/modals/localTapiola/buttons-send.html"
      },
      {
        // 13
        title: L.get("SALAXY.NG1.InsuranceComponent.thankYou.wizard.title"),
        heading: "",
        intro: "",
        view: "salaxy-components/modals/localTapiola/ThankYou.html"
      }
    ], this.newSteps = [
      this.wizardSteps[0],
      // start
      this.wizardSteps[1],
      // contact new
      this.wizardSteps[2],
      // owner info
      this.wizardSteps[3],
      // beneficiary info
      this.wizardSteps[4],
      // additional info
      this.wizardSteps[13]
      // thank you
    ], this.newEntrepreneurSteps = [
      this.wizardSteps[0],
      // start
      this.wizardSteps[5],
      // additional info entrepreneur
      this.wizardSteps[6],
      // contact info
      this.wizardSteps[7],
      // owner info
      this.wizardSteps[8],
      // beneficiary info
      this.wizardSteps[13]
      // thank you
    ], this.moveSteps = [
      this.wizardSteps[0],
      // start
      this.wizardSteps[9],
      // contact info (move)
      this.wizardSteps[10],
      // owner info
      this.wizardSteps[11],
      // beneficiary info
      this.wizardSteps[12],
      // additional info (move)
      this.wizardSteps[13]
      // thank you
    ], this.$onInit = () => {
      this.partnerServices.getNewLocalTapiolaInsuranceOrder().then((i) => {
        this.current = i;
      });
    };
  }
  /**
   * Sets the current wizard action and wizard steps
   * @param insuranceAction - Action to performs: order new or move existing insurance.
   */
  setInsuranceAction(t) {
    switch (this.isSending = !1, this.isSent = !1, this.formDataValidity = !0, this.action = t, this.getStartingPointDates(), this.current.id = null, this.current.company.beneficiaries.length === 0 && this.current.company.beneficiaries.push({}), this.current.company.owners.length === 0 && this.current.company.owners.push({}), t) {
      case "newInsurance":
        this.current.items = [
          {
            orderType: Sb.NewWorkerInsurance,
            occupations: [{}]
          }
        ], this.wizardService.setSteps(this.newSteps);
        break;
      case "moveInsurance":
        this.current.items = [
          {
            orderType: Sb.MoveWorkerInsurance,
            occupations: [{}]
          }
        ], this.wizardService.setSteps(this.moveSteps);
        break;
      case "newInsuranceForEntrepreneur":
        this.current.items = [
          {
            orderType: Sb.NewEntrepreneurInsurance,
            occupations: [{}]
          }
        ], this.wizardService.setSteps(this.newEntrepreneurSteps);
        break;
    }
  }
  /** Send the current order. */
  send() {
    if (this.isSending)
      return;
    if (this.isSent) {
      this.goNext();
      return;
    }
    this.isSending = !0;
    const t = this.uiHelpers.showLoading("SALAXY.UI_Terms.wait");
    this.partnerServices.sendLocalTapiolaInsuranceOrder(this.current).then(() => {
      t.dismiss(), this.goNext(), this.isSent = !0, this.isSending = !1;
    });
  }
  /**
   * Get next possible dates for moving existing insurance contract to LocalTapiola
   */
  getStartingPointDates() {
    const t = "Ensimmäinen mahdollinen ajankohta", e = I.add(I.startEnd("today", "start-quarter"), 1, "quarter"), a = I.add(I.startEnd("today", "start-quarter"), 2, "quarter"), n = I.add(I.startEnd("today", "start-quarter"), 3, "quarter"), i = I.add(I.startEnd("today", "start-quarter"), 4, "quarter");
    this.insuranceStartingPointDateOptions = {
      [t]: "Ensimmäinen mahdollinen ajankohta",
      [I.format(e, "YYYY-MM-DD")]: I.format(e, "D.M.YYYY"),
      [I.format(a, "YYYY-MM-DD")]: I.format(a, "D.M.YYYY"),
      [I.format(n, "YYYY-MM-DD")]: I.format(n, "D.M.YYYY"),
      [I.format(i, "YYYY-MM-DD")]: I.format(i, "D.M.YYYY")
    };
  }
  /** Go to the next step */
  goNext() {
    this.step++;
  }
  /**
   * Go to the last step ("thank you" step)
   */
  goToLast() {
    this.step = this.steps.length;
  }
  /**
   * Navigates to the previous step if possible and saves the data.
   */
  goPrevious() {
    super.goPrevious();
  }
  /**
   * Returns true, if the given order type exists in the current order items.
   * @param orderTypes - Order type to check.
   * @returns True, if the order type is found, otherwise default.
   */
  hasOrderType(...t) {
    return (t ?? []).some((e) => !!(this.current.items ?? []).find((a) => a.orderType === e));
  }
  /** Returns true if user can go forward in wizard  */
  get canGoNext() {
    return !!(this.steps.length > this.step && this.steps[this.step] && !this.steps[this.step].disabled && this.formDataValidity);
  }
  /** Opens the insurance dialog. */
  openModal() {
    this.wizardService.setSteps([this.wizardSteps[0]]), this.step = 1, this.uiHelpers.showDialog(
      "salaxy-components/modals/account/Insurance.html",
      "InsuranceWizardController",
      null,
      null,
      "lg"
    );
  }
  /**
   * Validates the order.
   */
  validate() {
    return this.partnerServices.validateLocalTapiolaInsuranceOrder(this.current).then((t) => (this.current = t, this.current));
  }
  /**
   * Resets the current order.
   */
  reset() {
  }
};
QS.$inject = ["$scope", "WizardService", "PartnerServices", "UiHelpers"];
let ey = QS;
const ZS = class ZS {
  constructor(t, e) {
    this.beneficialOwnersApi = t, this.$timoeut = e, this.mode = "byAmount", this.current = null, this.saves = {}, this.$onInit = () => {
      this.beneficialOwnersApi.get().then((a) => {
        this.current = a;
      });
    };
  }
  /**
   * Total amount of user input shares
   */
  getTotalAmount() {
    return !this.mode || !this.current ? 0 : ie.sum(this.current.owners, (t) => t.numberOfShares ?? 0);
  }
  /**
   * Total percentage of user input shares
   */
  getTotalPercent() {
    return !this.mode || !this.current ? 0 : ie.sum(this.current.owners, (t) => t.percentOfShares ?? 0);
  }
  /**
   * Calculates percentage from the given share amount
   */
  getPercentFromAmount(t) {
    return this.mode == "byAmount" && this.current && this.current.ownedCompanyDetails.totalNumberOfShares != null ? t / this.current.ownedCompanyDetails.totalNumberOfShares * 100 : 0;
  }
  /**
   * Calculates share amount from the given share percentage
   */
  getAmountFromPercent(t) {
    return this.mode == "byPercent" && this.current && this.current.ownedCompanyDetails.totalNumberOfShares != null ? this.current.ownedCompanyDetails.totalNumberOfShares * (t / 100) : 0;
  }
  /**
   * update
   */
  recalculateShares() {
    if (!(!this.mode || !this.current)) {
      if (this.mode == "byPercent")
        for (const t of this.current.owners)
          t.numberOfShares = this.current.ownedCompanyDetails.totalNumberOfShares * (t.percentOfShares / 100);
      if (this.mode == "byAmount")
        for (const t of this.current.owners)
          t.percentOfShares = t.numberOfShares / this.current.ownedCompanyDetails.totalNumberOfShares * 100;
    }
  }
  /** Saves the current owners and beneficiaries to backend. */
  save(t) {
    this.saves[t] = !0, this.beneficialOwnersApi.save(this.current).then((e) => {
      this.current = e, this.saves[t] = !1;
    });
  }
  /** Indicates the progress of save operation. */
  isSaving(t) {
    return this.saves[t] || !1;
  }
};
ZS.$inject = ["BeneficialOwnersApi", "$timeout"];
let ay = ZS;
const tk = class tk {
  constructor(t, e, a) {
    this.settingsService = t, this.uiHelpers = e, this.sessionService = a, this._siteChannels = null, this.$onInit = () => {
    };
  }
  /**
   * Gets the current settings object as soon as it is loaded.
   * Note that this is null until the settings have been loaded from server.
   */
  get current() {
    return this.settingsService.current;
  }
  /**
   * If the channels are set site specific (e.g. custom sites), the settings cannot be saved.
   * Site specific changes are done to session, and exposed by InvoicesService
   */
  get isReadOnly() {
    return !!(!this.current || this.current.partner.serviceModel.features.payments && !this.current.payments.denyServiceModel || this.isSiteSpecific);
  }
  /** Returns true, if the settings are site specific. */
  get isSiteSpecific() {
    const t = this.current.payments.channels.filter((a) => a.isAvailable && a.isEnabled);
    return !(t.length === this.sessionService.getSession()?.settings?.paymentChannels?.length && t.length > 0 && this.sessionService.getSession().settings.paymentChannels.every((n) => t.some((i) => i.channel === n)));
  }
  /**
   * Gets the payment channel.
   * @param type Type of the channel to list:
   *
   * - enabled: Enabled channels
   * - available: Available channels that can be enabled (have not yet been enabled).
   * - unavailable: Unavailable channels (cannot be enabled)
   * - all: Really all channels, even the technical ones that cannot be enabled.
   */
  getPaymentChannels(t) {
    if (!this.current)
      return null;
    let e = [];
    switch (this.isSiteSpecific ? (this._siteChannels === null && (this._siteChannels = this.sessionService.getSession().settings.paymentChannels.map((a) => ({ channel: a, isEnabled: !0, isAvailable: !0 }))), e = e.concat(this._siteChannels)) : e = e.concat(this.current.payments.channels), e = e.filter(
      (a) => a.channel !== At.PalkkausManual || a.channel === At.PalkkausManual && this.sessionService.isInSomeRole("pro,sepaPartner")
    ), t) {
      case "all":
        return e;
      case "available":
        return e.filter((a) => a.isAvailable && !a.isEnabled);
      case "unavailable":
        return e.filter((a) => !a.isAvailable);
      case "enabled":
      default:
        return e.filter((a) => a.isAvailable && a.isEnabled);
    }
  }
  /** Gets the visual representation and language versioned UI texts of the payment channel */
  getAvatar(t) {
    return ne.getChannelAvatar(t);
  }
  /** Gets the default channel. */
  get defaultChannel() {
    return this.sessionService.getSession().settings.defaultPaymentChannel;
  }
  /** Opens the channel setup dialog in a new window. */
  openChannelSetupDialog(t) {
    let e = null, a = !1;
    switch (t) {
      case At.Test:
        a = !0, e = Ne.current.isTestData ? "https://test-integrations.salaxy.com/test#/dialogs/settings" : "https://integrations.salaxy.com/test#/dialogs/settings", e += "?token=" + this.sessionService.getCurrentToken();
        break;
      case At.Procountor:
        a = !0, e = Ne.current.isTestData ? "http://localhost:93/procountor/settings.html" : "https://integrations.salaxy.com/procountor/settings.html", e += "?token=" + this.sessionService.getCurrentToken();
        break;
      case At.VismaNetvisor:
        a = !0, e = Ne.current.isTestData ? "http://localhost:93/vismanetvisor/settings.html" : "https://integrations.salaxy.com/vismanetvisor/settings.html", e += "?token=" + this.sessionService.getCurrentToken();
        break;
    }
    const n = this.getPaymentChannels("all").find((d) => d.channel === t);
    if (!n) {
      this.uiHelpers.showAlert("Maksutapaa ei voi muokata", "Palkanlaskentasivuston asetukset estävät maksutavan muokkauksen.");
      return;
    }
    const i = this.current.payments, r = [Is.None, Is.Ilmarinen, Is.Elo, Is.Varma], l = this.current.calc.pensionContracts.every((d) => r.indexOf(d.company) >= 0), o = {
      id: n.channel,
      isDefault: n.channel == this.defaultChannel,
      settings: {
        data: n.data,
        isAvailable: n.isAvailable,
        isEnabled: n.isEnabled
      },
      customerFundsSettings: {
        isPensionIncludedSupported: l,
        isPensionSelfHandling: i.customerFunds.isPensionSelfHandling,
        isTaxAndSocialSecuritySelfHandling: i.customerFunds.isTaxAndSocialSecuritySelfHandling,
        isWorkerSelfHandling: i.customerFunds.isWorkerSelfHandling
      },
      invoiceSettings: {
        eInvoiceIntermediator: i.invoice.eInvoiceIntermediator,
        eInvoiceReceiver: i.invoice.eInvoiceReceiver,
        ibanNumber: i.invoice.ibanNumber,
        sepaBankPartyId: i.invoice.sepaBankPartyId
      },
      isReadOnly: this.isReadOnly
    }, c = (d, p) => {
      if (d === We.Cancel) {
        console.debug("Canceling: Remove this message");
        return;
      }
      if (p.id !== this.lastPaymentChannelWindow)
        throw new Error(`Invalid response from channel ${p.id || "undefined"}, expected ${this.lastPaymentChannelWindow}.`);
      let h = i.channels.find((g) => g.channel === t);
      h || (h = n, i.channels.push(h)), (d === We.Ok || d === "set-default") && (h.data = p.settings.data, h.isEnabled = h.isAvailable && !0, d === "set-default" && (i.defaultChannel = t), i.customerFunds.isPensionSelfHandling = p.customerFundsSettings.isPensionSelfHandling, i.customerFunds.isTaxAndSocialSecuritySelfHandling = p.customerFundsSettings.isTaxAndSocialSecuritySelfHandling, i.customerFunds.isWorkerSelfHandling = p.customerFundsSettings.isWorkerSelfHandling, i.invoice.eInvoiceIntermediator = p.invoiceSettings.eInvoiceIntermediator, i.invoice.eInvoiceReceiver = p.invoiceSettings.eInvoiceReceiver, i.invoice.ibanNumber = p.invoiceSettings.ibanNumber, i.invoice.sepaBankPartyId = p.invoiceSettings.sepaBankPartyId, this.settingsService.save()), d === We.Delete && (n.isEnabled = !1, this.settingsService.save());
    };
    this.lastPaymentChannelWindow = t, a ? this.uiHelpers.showExternalDialog(o.id, e, o).then((d) => {
      c(d.action, d.item);
    }) : this.uiHelpers.openEditDialog(
      "salaxy-components/modals/settings/PaymentChannel.html",
      o,
      {
        channelAvatar: ne.getChannelAvatar(o.id),
        selectEInvoiceAddress: (d) => {
          this.settingsService.selectEInvoiceAddress(d);
        }
      }
    ).then((d) => {
      c(d.action, d.item);
    });
  }
};
tk.$inject = ["SettingsService", "UiHelpers", "SessionService"];
let ny = tk;
const ek = class ek {
  constructor(t, e, a, n) {
    this.rowTypeService = t, this.uiHelpers = e, this.$timeout = a, this.$element = n, this.listCache = null;
  }
  /** Sets the default values in init. */
  $onInit() {
    this.newRow = this.getBlank();
  }
  /** Saves the changes to row types. */
  save() {
    this.rowTypeService.save(), this.listCache = null;
  }
  /**
   * Gets the current object: Either the rows collection from settings as soon as it is loaded or an employment relation.
   */
  get current() {
    return this.model ? this.model : this.rowTypeService.isReady ? this.rowTypeService.allCustomRows : void 0;
  }
  /**
   * List of items to edit: In settings or Employment relation.
   */
  get list() {
    return this.current?.work?.salaryDefaults ? this.current.work.salaryDefaults : this.rowTypeService.allCustomRows;
  }
  /**
   * Gets the price rows in the current modeel.
   */
  get pricesList() {
    return this.list.filter((t) => t.source === On.PriceCompany || t.source == On.PriceEmployment);
  }
  /**
   * Gets the copy rows in the current model.
   */
  get copyRowsList() {
    return this.list.filter((t) => t.source === On.CopyCompany || t.source == On.CopyEmployment);
  }
  /**
   * Gets the default rows from the current model
   */
  get defaultsList() {
    return this.list.filter((t) => !t.source || t.source === On.Undefined || t.source == On.ManualRow);
  }
  /**
   * Gets the list of company specific rows, always in settings even if the bound model is employment.
   */
  get settingsList() {
    if (!this.rowTypeService.isReady) {
      console.error("Settings not yet loaded, handle this edge case.");
      return;
    }
    return this.rowTypeService.allCustomRows;
  }
  /**
   * Gets the configuration object for a row definition.
   * @param row Row for which the configuration is fetched.
   * @returns The configuration for the row.
   */
  getConfig(t) {
    return this.rowTypeService.getConfig(t);
  }
  /** Creating of a new item. */
  getBlank() {
    const t = Math.max(...this.list.map((a) => a.rowIndex), 0) + 1, e = $0.getBlank(t);
    return e.config = {}, e;
  }
  /**
   * Gets the search as cached item: Can be bound to ng-repeat.
   * @param searchText The search text. If null or empty, returns the full list.
   */
  getCachedSearch(t) {
    return this.uiHelpers.cache(
      this,
      "search",
      () => this.search(t, this.mode == "builtIn" || this.mode == "custom" ? this.mode : void 0),
      () => this.listCache?.key + this.rowTypeService.timestamp + t + this.categories?.toString() + this.mode
    );
  }
  /**
   * Searches the row types.
   * @param searchText The search text. If null or empty, returns the full list.
   */
  search(t, e) {
    const a = (i) => ({
      text: i.label,
      value: i.name,
      title: i.descr,
      ui: {
        color: i.color,
        iconText: i.iconText,
        addedByChild: null,
        // TODO: Requires refactoring
        group: i.group,
        type: i.type,
        rowType: i.rowType
      }
    }), n = [];
    return t = (t || "").trim().toLowerCase(), this.getRowTypes(e).forEach((i) => {
      let r = !1;
      (!t || (i.label + i.descr + i.name).toLowerCase().indexOf(t) >= 0) && (n.push(a(i)), r = !0), i.kind?.values && i.kind.values.forEach((l) => {
        if (!(l.name == "undefined" || l.name == "unknown") && t && (l.label + l.descr + l.name).toLowerCase().indexOf(t) >= 0) {
          if (!r) {
            const o = a(i);
            o.ui.addedByChild = !0, n.push(o), r = !0;
          }
          n.push({
            text: l.label,
            value: i.name + "." + l.name,
            title: l.descr,
            // TODO: Requires refactoring
            ui: {
              group: i.group,
              type: i.type,
              rowType: i.rowType
            }
          });
        }
      });
    }), n.length === 2 && n[0].ui.addedByChild ? [{
      text: n[0].text + ": " + n[1].text,
      value: n[1].value,
      title: n[1].title,
      ui: n[0].ui
    }] : n;
  }
  /**
   * Opens an edit dialog for price or default row => Opening just a normal dialog.
   * @param row Row to edit: This should be a price row or default row: Not a custom row.
   */
  showEdit(t) {
    if (!t)
      throw new Error("showEditDialog called without a parameter.");
    const e = Da.getBlank();
    e.usecase.data.standAloneRows = !0, e.isReadOnly = !1, this.uiHelpers.openEditDialog("salaxy-components/calc/rows/CalcRows2019EditDialog.html", t, {
      calc: e
    }, "", "CalcRows2019Controller").then((a) => {
      a.action === "ok-no-save" || a.action === "delete-no-save" && this.delete(t);
    });
  }
  /**
   * Deletes a row. This does not save changes.
   * @param row Row to delete.
   */
  delete(t) {
    this.list.splice(this.list.indexOf(t), 1);
  }
  /** Copies the given text to clipboard. */
  copyToClipboard(t) {
    navigator.clipboard.writeText(t);
  }
  /**
   * Commits the new row in newRow property and adds it to the rows list.
   * Updates usecase and sets the newRow as new blank row.
   */
  commitNewRow(t, e = !1) {
    if (!this.newRow?.type)
      return null;
    const a = this.getBlank();
    if (t == "price" ? a.source = this.model?.work ? On.PriceEmployment : On.PriceCompany : t == "copy" ? a.source = this.model?.work ? On.CopyEmployment : On.CopyCompany : a.source = t, this.newRow.config?.group === "custom") {
      if (a.type = this.newRow.type, a.config = this.getRowTypes(void 0).find((i) => i.type === a.type), !a.config)
        throw new Error("Row type not found in config: " + a.type);
      a.rowType = a.config.rowType;
      const n = this.settingsList.find((i) => i.type === a.type);
      if (!n)
        throw new Error("Row type not found in settings: " + a.type);
      a.data.kind = n.data.kind, a.price = n.price, this.rowTypeService.applyDefaultsToNewRow(a, void 0);
    } else
      a.rowType = this.newRow.rowType, a.data.kind = this.newRow.data.kind, a.type = this.newRow.type, a.config = {
        group: "builtIn"
      };
    return Jo.getUsecaseLogicForCalc(a, Da.getBlank(), !0), this.list.push(a), this.$timeout(() => {
      this.newRow = this.getBlank();
    }, 300), e ? this.showEdit(a) : this.$timeout(() => {
      let n = null;
      n = this.$element[0].querySelector(
        "#iptPrice" + a.rowIndex
      ), n && n.focus();
    }, 500), a;
  }
  /**
   * Shows a dialog for editing the row-type or that shows information about the row-type if read-only.
   * @param rowType The row type to show information about.
   */
  showRowTypeDetails(t) {
    let e = this.settingsList.find((a) => a.source == On.CustomRowtype && a.config.name == t.value);
    if (e || (e = {
      rowIndex: 0,
      rowType: t.value,
      source: On.CustomRowtype,
      data: {
        dimensions: {},
        accounting: {}
      },
      config: structuredClone(Gi.getRowConfig(t.value))
    }, e.config.group = "builtIn"), !e)
      throw new Error("Row type not found: " + t.value);
    this.uiHelpers.openEditDialog("salaxy-components/calc/rows/RowTypeEditDialog.html", e, {
      calc: Da.getBlank(),
      definitionEditor: this.getDialogLogic(e.config.group)
    }, "lg", "CalcRows2019Controller").then((a) => {
      a.action == We.Ok && (this.rowTypeService.save(), this.listCache = null);
    });
  }
  getDialogLogic(t) {
    return {
      // Perhaps this is not really necessary => You could just get it from the config?
      mode: t
    };
  }
  /**
   * Creates a new custom row type.
   * @param rowType Base row type for the custom type.
   */
  async createCustomRowType(t) {
    const e = prompt("Syötä rivityypille ID (a-z, 0-9, _):");
    if (!e)
      return;
    if (e.match(/[^a-zA-Z0-9_]/)) {
      alert("Virheellinen ID");
      return;
    }
    if (this.getRowTypes(void 0).find((r) => r.name === e)) {
      alert(`ID on '${e}' jo käytössä`);
      return;
    }
    const a = structuredClone(Gi.getRowConfig(t.value));
    a.group = "custom", a.name = e, a.type = "/custom/" + e, a.label = e + " (uusi)";
    const n = {
      type: "/custom/" + e,
      rowType: t.value,
      rowIndex: 0,
      // HACK: Custom only if really custom
      source: On.CustomRowtype,
      data: {
        dimensions: {},
        accounting: {},
        scripting: {}
      },
      config: a
    };
    (await this.uiHelpers.openEditDialog("salaxy-components/calc/rows/RowTypeEditDialog.html", n, {
      calc: Da.getBlank(),
      definitionEditor: this.getDialogLogic("custom")
    }, "lg", "CalcRows2019Controller")).action == We.Ok && (this.rowTypeService.allCustomRows.push(n), this.rowTypeService.save().then(() => {
    }), this.listCache = null);
  }
  /**
   * Deletes a custom row type.
   * @param rowType The row type to delete.
   */
  deleteCustomRowType(t) {
    confirm("Haluatko poistaa rivityypin '" + t.text + "'?") && (this.rowTypeService.deleteRow(this.settingsList.find((e) => e.source == On.CustomRowtype && e.config.name == t.value)), this.rowTypeService.save());
  }
  /**
   * Returns placeholder text for row
   * NOTE: Copied from CalcRows2019Controller - This will be refactored into a logic class!
   * @param row used row
   * @returns row message as string
   */
  getMessagePlaceholderText(t) {
    if (t.message)
      return t.message;
    let e = "";
    return t.rowType === Wt.IrIncomeType ? e = Tn.getAll().find(
      (a) => t.data?.kind && a.transactionCode === t.data.kind || t.data?.irData?.code > 0 && a.code === t.data.irData.code
    )?.label : t.rowType == Wt.AbsencePeriod ? e = He.getEnumLabel(
      "AbsenceCauseCode",
      t.data?.kind
    ) : [
      Wt.DailyAllowance,
      Wt.EmploymentTermination,
      Wt.WorkingTimeCompensation,
      Wt.Remuneration,
      Wt.OtherCompensation,
      Wt.NonProfitOrg,
      Wt.MealBenefit,
      Wt.Training,
      Wt.PaidSickLeave,
      Wt.TotalWorkerPayment
    ].includes(t.rowType) && t.data?.kind && (e = He.getEnumLabel(
      `${t.rowType}Kind`,
      t.data.kind
    )), e || He.getEnumLabel("CalculationRowType", t.rowType);
  }
  /**
   * Gets the list of row types. Method filters based on rowTypes and categories,
   * the texts are language versioned.
   */
  getRowTypes(t) {
    return this.rowTypeService.isReady ? this.rowTypeService.getConfigs(t, this.categories) : (console.error("Row types not yet loaded, handle this edge case."), []);
  }
};
ek.$inject = ["RowTypeService", "UiHelpers", "$timeout", "$element"];
let sy = ek;
const ak = class ak extends nn {
  constructor(t, e, a, n) {
    super(t, e, a, n), this.fullApi = t, this.defaultParamsSchema = {
      title: "Current sitemap node",
      type: "object",
      properties: {}
    };
  }
  $onInit() {
    super.$onInit(), this.initLanguage();
  }
  /** Implements the getDefaults of ApiCrudObjectController */
  getDefaults() {
    return {
      listUrl: this.listUrl || "/service-models",
      detailsUrl: this.detailsUrl || "/service-models/details/",
      oDataTemplateUrl: "salaxy-components/odata/lists/ServiceModels.html",
      oDataOptions: {}
    };
  }
  /**
   * Event handler for accounting target selection.
   * @param current Settings object to edit/create.
   * @param logic Logic object passed to the dialog controller.
   * @param logic.isReadOnly Read-only flag in logic.
   * @param value Boolean indicating if the item is selected or not.
   * @param item  The selected item.
   * @param allItems All selected items.
   */
  onAccountingTargetSelect(t, e, a, n, i) {
    i.splice(0, i.length), e.isReadOnly = !0, a == !0 && (t.id = n.id, t.avatar = n.otherPartyInfo.avatar, t.format = n.data.format, t.channel = n.data.channel, t.method = n.data.method, t.availableMethods = ie.assureArray(n.data.availableMethods), e.isReadOnly = !1, i.push(n));
  }
  /**
   * Event handler for usecase selection.
   * @param current Settings object to edit/create.
   * @param logic Logic object passed to the dialog controller.
   * @param logic.isReadOnly Read-only flag in logic.
   * @param value Boolean indicating if the item is selected or not.
   * @param item  The selected item.
   * @param allItems All selected items.
   */
  onUsecaseSelect(t, e, a, n, i) {
    i.splice(0, i.length), e.isReadOnly = !0, a == !0 && (t.uri = n.reference, t.label = n.shortText, t.itemType = n.entityType, t.status = n.status, t.order = n.data.order, e.isReadOnly = !1, i.push(n));
  }
  /**
   * Return Avatar from current.payment.channels ENUM
   * @returns Avatar
   */
  /* public getPaymentChannelAvatar(item) {
    return InvoicesLogic.getChannelAvatar(item.channel);
  } */
  /**
   * Created InputEnumOption [] from current.accounting.targets
   * @returns InputEnumOption [] for template
   */
  getSelectableAccountingTargets() {
    return this.uiHelpers.cache(
      this,
      "selectableAccountingTargets",
      () => this.current.accounting.targets.map((t) => ({
        text: t.avatar.displayName,
        value: t.id,
        ui: { avatar: t.avatar }
      })),
      () => this.current.accounting.targets.map((t) => t.id)
    );
  }
  /**
   * Created InputEnumOption [] from all payment channels
   * @returns InputEnumOption [] for template
   */
  getSelectablePaymentChannels() {
    if (this.current.payments.channels)
      return this.uiHelpers.cache(
        this,
        "selectablePaymentChannels",
        () => this.current.payments.channels.map((t) => {
          const e = ne.getChannelAvatar(t.channel);
          return {
            text: e.displayName,
            value: e.id,
            ui: e
          };
        }),
        () => this.current.payments.channels.map((t) => ne.getChannelAvatar(t.channel).id)
      );
  }
  /** Returns all payment channels. */
  getAllPaymentChannels() {
    return this.uiHelpers.cache(
      this,
      "allSelectablePaymentChannels",
      () => ne.getAllChannels().map((t) => ({
        text: t.displayName,
        value: t.id,
        ui: { avatar: t }
      })),
      () => ne.getAllChannels().map((t) => t.id)
    );
  }
  /**
   * Save service model
   */
  saveServiceModel() {
    this.isSaving = !0, this.commitSitemapNode(), this.save().then(() => {
      this.isSaving = !1;
    });
  }
  /** Gets the editable version of the sitemap */
  get sitemap() {
    return this._sitemap || (this.translations.setTerms(this.current?.site?.texts), this._sitemap = ws.getEditableSitemap(this.current.site), this.currentSitemapNode = this._sitemap[0]), this._sitemap;
  }
  /** Resets all sitemap changes */
  resetSitemapChanges() {
    this._sitemap = null, this.current.site.texts = {}, this.current.site.sitemap = {};
  }
  /**
   * Show / hide all nodes in the sitemap.
   * @param open If true open / show all nodes. Default is close all nodes.
   */
  showHideAll(t) {
    this.sitemap.forEach((e) => {
      e.$edit.$isOpen = t, (e.children || []).forEach((a) => {
        a.$edit.$isOpen = t;
      });
    });
  }
  /** Currently edited sitemap node */
  get currentSitemapNode() {
    return this._currentSitemapNode;
  }
  set currentSitemapNode(t) {
    this.commitSitemapNode(), this._currentSitemapNode = t;
  }
  /** Commits the changes of the current sitemap node to current service model (no save to server.)  */
  commitSitemapNode() {
    const t = this._currentSitemapNode;
    if (t) {
      this.current.site.sitemap = this.current.site.sitemap || {};
      const e = Object.entries(t.$edit).filter(([a, n]) => n != null && n != "" && !(Array.isArray(n) && n.length == 0) && a[0] != "$" && !(a == "visible" || n == "default"));
      if (e.length) {
        const a = Object.fromEntries(e);
        a.roles && (a.roles = ie.assureArray(a.roles).map((n) => n.trim())), this.current.site.sitemap[t.$edit.$id] = a;
      } else
        this.current.site.sitemap[t.$edit.$id] && delete this.current.site.sitemap[t.$edit.$id];
      this.translations = new Zp(wt.copy(this.cleanDictionary)), this.translations.setTerms(this.current?.site?.texts), this._sitemap = ws.getEditableSitemap(this.current.site, this._sitemap);
    }
  }
  /**
   * Resets all changes for the current sitemap node.
   * @param resetCommitted If true, also resets the values that are committed to the
   * original values from in the library
   */
  resetSitemapNode(t) {
    const e = this.currentSitemapNode;
    t && this.current.site.sitemap[e.$edit.$id] && delete this.current.site.sitemap[e.$edit.$id], this.translations = new Zp(wt.copy(this.cleanDictionary)), this.translations.setTerms(this.current?.site?.texts), this._sitemap = ws.getEditableSitemap(this.current.site, this._sitemap);
  }
  /**
   * Returns true, if the node has test role set.
   * @param node Node to evaluate.
   */
  getIsTest(t) {
    const e = t.$edit.roles?.length ? t.$edit.roles : t.roles;
    return e ? ie.assureArray(e).indexOf("test") >= 0 : !1;
  }
  /**
   * Gets all roles except "test" (which is displayed by getIsTest) as comma separated string.
   * @param node Node to evaluate.
   */
  getRoles(t) {
    const e = t.$edit.roles?.length ? t.$edit.roles : t.roles;
    return e ? ie.assureArray(e).filter((a) => a != "test").join(", ") : null;
  }
  /** Gets the params schema from the sitemap (service model). */
  getSitemapParamsSchema() {
    return this.uiHelpers.cache(this, "sitemapNodeParams", () => {
      const t = this.currentSitemapNode, e = {
        openapi: "3.0.1",
        info: {
          title: "SitemapParams_" + t.id,
          version: "1.0",
          description: `Sitemap parameters for node ${t.$edit.$id}`
        },
        paths: {},
        components: {
          schemas: {}
        }
      };
      return this.addNodeParamSchemas(this.sitemap, e.components.schemas), e;
    }, () => this.currentSitemapNode?.$edit.$id);
  }
  /** Exports the current object as json to property this.json. */
  exportJson() {
    this.json = JSON.stringify(this.current, null, 2);
  }
  /** Sets current object from the JSON (this.json shown in code editor). */
  importJson() {
    this._sitemap = null, this._currentSitemapNode = null, this.translations = new Zp(wt.copy(this.cleanDictionary)), this.translations.setTerms(this.current?.site?.texts), this.setCurrentValue(JSON.parse(this.json));
  }
  addNodeParamSchemas(t, e) {
    t?.length && t.forEach((a) => {
      if (Object.keys(a.params || {}).length) {
        const n = wt.copy(this.defaultParamsSchema);
        n.properties = { ...n.properties, ...this.currentSitemapNode.params }, e[a.$edit.$id] = n;
      } else
        e[a.$edit.$id] = this.defaultParamsSchema;
      this.addNodeParamSchemas(a.children, e);
    });
  }
  /**
   * Translates the given key to current language with the translations in the current service model
   * @param key The translation key
   */
  translate(t) {
    return this.translations.get(t);
  }
  /** Initializes the Translations instance (loads the language and sets the current language). */
  initLanguage() {
    const t = L.getLanguage();
    this.translations || (this.translations = new Zp(), this.translations.localesPath = L.instance.localesPath), this.translations.loadLanguage(t).then(() => {
      this.cleanDictionary = wt.copy(this.translations.getCurrentDictionary()), this.translations.setLanguage(t), this.translations.setTerms(this.current?.site?.texts);
    });
  }
};
ak.$inject = [
  "ServiceModels",
  "UiHelpers",
  "$location",
  "$routeParams"
];
let iy = ak;
const nk = class nk {
  constructor(t, e, a) {
    this.$transclude = t, this.$element = e, this.$sce = a, this.onEditorMessage = (n) => {
      if (n.origin === this.targetOrigin) {
        if (this.codeEditorIFrame) {
          if (this.codeEditorIFrame.contentWindow !== n.source)
            return;
          Object.prototype.hasOwnProperty.call(n.data, "code") && (this.code = n.data.code);
        } else if (Object.prototype.hasOwnProperty.call(n.data, "loaded")) {
          const i = this.codeEditorIFrame = this.$element.find("iframe")[0];
          if (i.contentWindow !== n.source)
            return;
          this.codeEditorIFrame = i, i.contentWindow.postMessage({ code: this.code }, this.targetOrigin);
          return;
        }
      }
    };
  }
  /** Initializes the controller */
  $onInit() {
    this.editor || (this.editor = "monaco"), this.registerTransclude(), this.targetOrigin = Ne.current.codeEditor, this.model && (this.model.$render = () => {
      this.value = this.model.$viewValue, this.codeEditorIFrame && this.codeEditorIFrame.contentWindow.postMessage({ code: this.code }, this.codeEditorIFrame.contentWindow.origin);
    }), this.registerCodeEditorWindow();
  }
  /** Clears the window event hooks */
  $onDestroy() {
    window.removeEventListener("message", this.onEditorMessage, !1);
  }
  /** The code that is shown in editor. */
  get code() {
    return this.value;
  }
  set code(t) {
    this.value = t, this.model && this.model.$setViewValue(this.value);
  }
  /** On change of the value, do preventive operations and set value to model. */
  onChange() {
    this.model && this.model.$setViewValue(this.value);
  }
  registerCodeEditorWindow() {
    this.mode != "basic" && this.targetOrigin && (this.codeEditorUrl = this.$sce.trustAsResourceUrl(`${this.targetOrigin}?editor=${this.editor}&readonly=${this.readOnly}&lang=${this.lang || ""}`), this.itemType && (this.codeEditorUrl = this.$sce.trustAsResourceUrl(`${this.codeEditorUrl}&item=${this.itemType}`)), window.addEventListener("message", this.onEditorMessage, !1));
  }
  registerTransclude() {
    this.$transclude((t, e) => {
      let a = "";
      for (let n = 0; n < t.length; n++)
        t[n].nodeType === 3 ? a += t[n].textContent : a += (t[n].outerHTML || "").replace(" ng-scope", "").replace("ng-scope", "").replace(' class=""', "");
      return a = a.trim(), a && (this.value = a), t;
    });
  }
};
nk.$inject = ["$transclude", "$element", "$sce"];
let ry = nk;
const sk = class sk {
  constructor(t, e, a, n) {
    this.jsonSchemaService = t, this.$rootScope = e, this.uiHelpers = a, this.$timeout = n, this.lastUniqueId = 0, this.registeredInputs = {};
  }
  /** Initializes the controller */
  $onInit() {
    this.init();
  }
  /**
   * Type of the model: Bases for the user interface.
   * This may be either a TypeScript typename or OpenApi schema component name.
   */
  get type() {
    return this._type;
  }
  set type(t) {
    this._type = t, this.id && (this.isReady = !1, this.$timeout().then(() => {
      this.init();
    }));
  }
  /** Initializes or re-initializes the data model. */
  init() {
    this.model = this.model || {}, this.id = (this.type || "undefined") + this.$rootScope.$id.toString(), this.openApi && this.type ? this.openApiDoc ? (this.jsonSchemaService.addSchemaDocument(this.openApi, this.openApiDoc), this.schemaModel = this.jsonSchemaService.findSchema(this.openApi, this.type), this.model || (this.model = {}), this._info = this.openApiDoc.info || {
      title: "unknown",
      version: "0"
    }, this.label = this.label || L.getWithDefault(`${this.getModelNamespace()}.${this.type}.title`, this.schemaModel?.title || this.type), this.isReady = !0) : this.jsonSchemaService.assureSchemaDocument(this.openApi).then((t) => {
      this._info = t.info || {
        title: "unknown",
        version: "0"
      }, this.schemaModel = this.jsonSchemaService.findSchema(this.openApi, this.type), this.model || (this.model = {}), this.label = this.label || L.getWithDefault(`${this.getModelNamespace()}.${this.type}.title`, this.schemaModel?.title || this.type), this.isReady = !0;
    }) : (this.schemaModel = null, this.isReady = !0);
  }
  /**
   * Registers an input (control) to a data point in the form.
   * @param path Data path that the input registers to.
   * This should be either "form" to register to the root of the form or
   * more typically "form.prop.perhapsSubProperty" to register to a property.
   */
  registerInput(t, e, a) {
    if (!(t || "").trim())
      throw Error("Path / model is required for each sxy-input element. Use e.g. 'form.temp'.");
    const n = {
      prop: this.getProperty(t),
      id: null,
      isRoot: !1,
      templateUrl: null,
      input: null
    };
    if (n.prop)
      n.id = `${this.id}_${n.prop.propertyName}${this.getUniqueId()}`, n.input = Gd.getInputMetadata(n.prop.schema, n.prop.propertyName, t), n.input.format = a || n.input.format, n.templateUrl = this.jsonSchemaService.getTemplate(n.input);
    else if (n.isRoot = t === "form", n.isRoot)
      n.id = `${this.id}_form${this.getUniqueId()}`, n.input = this.schemaModel ? Gd.getInputForSelf(this.schemaModel, null, t) : null, n.input && (n.input.format = a || n.input.format), n.prop = {
        isRequired: !1,
        parentName: this.type,
        propertyName: null,
        schema: this.schemaModel
      }, n.templateUrl = n.input ? this.jsonSchemaService.getTemplate(n.input) : null;
    else {
      const i = t.substr(t.lastIndexOf(".") + 1);
      n.id = `${this.id}_${i}${this.getUniqueId()}`, e = e || "string", n.input = {
        name: i,
        format: a,
        isEnum: null,
        path: t,
        type: e,
        content: `Property "${t}" does not exist in schema.`
      }, n.prop = {
        isRequired: !1,
        parentName: null,
        propertyName: i,
        schema: null
      }, n.templateUrl = this.jsonSchemaService.getTemplate(n.input);
    }
    return this.registeredInputs[n.id] = n.prop, n;
  }
  /**
   * Gets the model for a property that an invidual input within the form can bind to.
   * @param path Property path, currently always starting with "form.",
   * e.g. "form.id" or "form.employer.accountId"
   */
  getProperty(t) {
    const e = this.getFormPath(t);
    return e ? ol.getProperty(this.schemaModel, e) : null;
  }
  /**
   * Sets a value in the model using property path.
   * @param path Property path, currently always starting with "form.",
   * e.g. "form.id" or "form.owner.id"
   * @param value Value to set to model.
   * @returns True if the property is set. Value is not set if there is no propertyPath/obj or
   * if the value is already set to new value (currently strict equality check "===",
   * but may be changed without it being a breaking change).
   */
  setValue(t, e) {
    const a = this.getFormPath(t);
    if (!a)
      throw new Error("Cannot set the objects own value. setValue only supports setting property values.");
    return Qe.setProperty(this.model, a, e);
  }
  /**
   * Gets a value from the model using property path.
   * @param path Property path, currently always starting with "form.",
   * e.g. "form.id" or "form.owner.id"
   */
  getValue(t) {
    return this.getFormPath(t) ? Qe.getProperty(this.model, this.getFormPath(t)) : this.model;
  }
  /** Gets the validation based on the current form. */
  getValidation() {
    const t = [];
    if (this.ngForm.$invalid)
      for (const e of Object.keys(this.ngForm.$error))
        for (let a = 0; a < this.ngForm.$error[e].length; a++)
          t.push([e, this.ngForm.$error[e][a].$name]);
    return this.uiHelpers.cache(this, "validation", () => {
      const e = t.map((a) => {
        const n = a[0], i = this.registeredInputs[a[1]], r = {
          code: n,
          key: a[1],
          type: a[0] === "required" ? Ra.Required : Ra.Invalid,
          msg: L.getWithDefault(
            "SALAXY.VALIDATION.ValidationErrors." + n,
            L.get("SALAXY.VALIDATION.ValidationErrors.unknown", { error: n })
          )
        };
        return i?.propertyName && (i.parentName ? r.key = i.parentName + "." + i.propertyName : r.key = i.propertyName, r.msg = L.getWithDefault(`${this.getModelNamespace()}.${r.key}.title`, i.propertyName) + ": " + r.msg), r;
      });
      return {
        hasAllRequiredFields: !e.find((a) => a.type === Ra.Required),
        isValid: e.length === 0,
        errors: e
      };
    }, () => t);
  }
  /** Returns the namespace for the current openApi model, the default is SALAXY.MODEL */
  getModelNamespace() {
    return this._info?.["x-salaxy-model-namespace"] || "SALAXY.MODEL";
  }
  /** Returns the namespace for the current openApi enums, the default is SALAXY.ENUM */
  getEnumNamespace() {
    return this._info?.["x-salaxy-enum-namespace"] || "SALAXY.ENUM";
  }
  getFormPath(t) {
    if (t === "form")
      return null;
    if (!t.startsWith("form."))
      throw new Error("Currently, only 'form' and 'form.' supported in property paths.");
    return t.replace("form.", "");
  }
  /** Gets a unique id to form components / inputs. This may later further track the inputs. */
  getUniqueId() {
    return this.lastUniqueId++;
  }
};
sk.$inject = ["JsonSchemaService", "$rootScope", "UiHelpers", "$timeout"];
let ly = sk;
const ik = class ik {
  constructor() {
  }
  /** Initializes the controller */
  $onInit() {
  }
  /** For alert component, gets the classes that format the alert. */
  getAlertClasses() {
    switch (this.type) {
      case "default":
      case "primary":
      case "success":
      case "info":
      case "warning":
      case "danger":
        return `alert alert-${this.type}`;
      case "error":
        return "alert alert-danger";
      default:
        return "alert alert-info";
    }
  }
  /** Returns the icon based on the type. */
  getAlertIcon() {
    if (!this.icon)
      switch (this.type) {
        case "danger":
        case "error":
          return "fa-exclamation";
        case "success":
          return "fa-check";
        case "warning":
          return "fa-exclamation-triangle";
        default:
          return "fa-info";
      }
    return this.icon === "none" ? null : this.icon;
  }
};
ik.$inject = [];
let oy = ik;
const Hy = class Hy {
  constructor(t, e, a, n, i) {
    this.jsonSchemaService = t, this.uiHelpers = e, this.$element = a, this.$timeout = n, this.fileService = i, this.selection = [], this.isInitDone = !1;
  }
  /** Initializes the controller */
  $onInit() {
    this.initModel();
  }
  /**
   * The schema definition that defines the structure of each item in the grid.
   */
  get schemaDef() {
    return this._schemaDef;
  }
  set schemaDef(t) {
    this._schemaDef = t, this.isInitDone && this.renderGrid();
  }
  /**
   * Adds an empty row to the grid.
   * @param rowData Data to add to the grid. Array of of objects.
   * @param index Index position. If null, will add to the end.
   */
  addRow(t = [{}], e = null) {
    this.gridOptions.api.applyTransaction({
      add: t,
      addIndex: e
    }), this.commit();
  }
  /** Delete the selected rows from the grid. */
  deleteSelectedRows() {
    const t = this.gridOptions.api.getSelectedRows();
    this.gridOptions.api.applyTransaction({ remove: t }), this.commit();
  }
  /** Clears all rows in the grid. Sets the data to an empty array. */
  clear() {
    this.gridOptions.api.setRowData([]), this.commit();
  }
  /** Commits the changes in the grid to the source data. */
  commit() {
    this.data.length = 0, this.gridOptions.api.forEachNode((t) => {
      this.data.push(t.data);
    });
  }
  /**
   * Validates a single item based on the schema.
   * @param item Item to validate
   */
  validateItem(t) {
    if (!t)
      return {
        isValid: !1,
        hasAllRequiredFields: !1,
        errors: [{
          msg: "Row is empty / null, this is not allowed: Null rows must be filtered out before adding.",
          type: Ra.General
        }]
      };
    const e = {
      errors: []
    };
    return Object.keys(t).forEach((a) => {
      const n = t[a], i = (this.schemaDef || {}).properties[a];
      if (i) {
        if (n)
          switch (i.type) {
            case "integer":
              Number.isInteger(+n) || e.errors.push({
                msg: `Value '${n}' in ${a} is not an integer.`,
                type: Ra.Invalid,
                key: a
              });
              break;
            case "number":
              isNaN(n) && e.errors.push({
                msg: `Value '${n}' in ${a} is not a number.`,
                type: Ra.Invalid,
                key: a
              });
              break;
            case "boolean":
              ["true", "false"].indexOf((n + "").toLowerCase()) < 0 && e.errors.push({
                msg: `Value '${n}' in ${a} is not a valid boolean (true/false).`,
                type: Ra.Invalid,
                key: a
              });
              break;
            case "array":
              Array.isArray(n) || e.errors.push({
                msg: `Value '${n}' in ${a} is not a valid array.`,
                type: Ra.Invalid,
                key: a
              });
              break;
          }
      } else
        e.errors.push({
          msg: `Property ${a} is not defined in the schema.`,
          type: Ra.Warning
        });
    }), e.hasAllRequiredFields = !e.errors.find((a) => a.type == Ra.Required), e.isValid = !e.errors.find((a) => a.type !== Ra.Warning), e;
  }
  /**
   * Takes an input object with string based data and maps to correct typing or empty objects.
   * E.g. "2" => 2, "True" = true. Original data is not changed and only data in schema is returned.
   * Keep the method in sync with validateItem.
   * @param item Item to convert as typed item.
   * @returns Typed item
   */
  convertTypes(t) {
    if (!t)
      return null;
    const e = {};
    return Object.keys(t).forEach((a) => {
      const n = t[a], i = (this.schemaDef || {}).properties[a];
      if (i && n)
        switch (i.type) {
          case "integer":
            Number.isInteger(+n) && (e[a] = Number(n));
            break;
          case "number":
            isNaN(n) || (e[a] = Number(n));
            break;
          case "boolean":
            ["true", "false"].indexOf((n + "").toLowerCase()) >= 0 && (e[a] = (n + "").toLowerCase() == "true");
            break;
          case "array":
            Array.isArray(n) || (e[a] = n);
            break;
          case "string":
            e[a] = n;
            break;
        }
    }), e;
  }
  /** Gets the exportable for the current data model. */
  getExportable() {
    const t = this.getMapper().reverse(this.schema + "FullExport", `Full object export for ${this.schema}`), e = new br(this.schema + "GridExport", `Table export for ${this.schema}`);
    e.setSchema(this.schemaDef, this.schema, "source"), e.setPathsFromSourceSchema(this.getFields());
    const a = [e, t];
    return {
      exporters: this.fileService.getDefaultExporters(),
      getExportMappers: () => a.map((i) => yc.getInfo(i)),
      getExportMapper: (i) => Promise.resolve(a.find((r) => r.uri == i)),
      list: (i) => {
        const r = i > 0 ? this.data.slice(0, i) : this.data;
        return Promise.resolve(r);
      },
      getSingle: (i) => Promise.resolve(i)
    };
  }
  /** Gets the importable for the current data model. */
  getImportable() {
    const t = this.getMapper();
    return {
      getImportMappers: () => [{
        value: null,
        text: t.title
      }],
      getImportMapper() {
        return Promise.resolve(t);
      },
      finalize: (e) => (this.clear(), this.addRow(e.map((a) => this.convertTypes(a))), this.commit(), Promise.resolve()),
      validate: (e) => Promise.resolve({ item: e, validation: this.validateItem(e) }),
      parsers: $w.getDefaultParsers()
    };
  }
  /** Available object mapper for import based on the current schema. */
  getMapper() {
    const t = new br(this.schema + "Import_sxyGrid", `Table import for ${this.schema}`);
    return t.setStringToSchemaMapping(this.schemaDef, this.schema), t;
  }
  initModel() {
    this.doc = this.doc || "salaxy-secure/schemas/v02.json", !this.schemaDef && this.doc && this.schema ? this.jsonSchemaService.assureSchemaDocument(this.doc).then((t) => {
      this.isInitDone = !0, this.schemaDef = t.components.schemas[this.schema];
    }) : this.schemaDef && this.renderGrid();
  }
  /** Gets the fields based on include OR exclude and schema defs definitions. */
  getFields() {
    let t = ie.assureArray(this.include);
    if (t.length == 0) {
      t = Object.keys(this.schemaDef?.properties || {});
      const e = ie.assureArray(this.exclude);
      e.length > 0 && (t = t.filter((a) => e.indexOf(a) < 0));
    }
    return t;
  }
  renderGrid() {
    this.gridOptions = {
      defaultColDef: {
        editable: !0
      },
      rowSelection: "multiple",
      undoRedoCellEditing: !0,
      undoRedoCellEditingLimit: 20,
      onSelectionChanged: (a) => {
        this.selection = a.api.getSelectedNodes(), this.$timeout(0);
      }
    };
    const t = [];
    this.getFields().forEach((a) => {
      const n = ol.getProperty(this.schemaDef, a)?.schema;
      if (n) {
        let i = n.title;
        i || (i = a.indexOf(".") ? a.substring(a.lastIndexOf(".") + 1) : a);
        const r = {
          field: a,
          headerName: i
        };
        switch (n.type) {
          case "integer":
          case "number":
            r.type = ["numericColumn"];
            break;
          case "object":
            r.cellRenderer = k0.getCellRenderer(n);
            break;
        }
        if (n.description && (r.headerTooltip = n.description), n.enum?.length) {
          const l = He.getEnumMetadata(n.format).values;
          r.cellEditor = "agSelectCellEditor", r.cellEditorParams = {
            values: l.map((o) => o.name)
          }, r.refData = l.reduce((o, c) => ({ ...o, [c.name]: c.label }), {});
        }
        t.push(r);
      } else
        console.error(`Cannot find column ${a}`);
    }), Promise.resolve(Ne.global.salaxy.grid).then((a) => {
      const n = a.GridWrapper, i = n.agGrid;
      i.LicenseManager.setLicenseKey(n.AG_GRID_LICENCE_KEY), i.ModuleRegistry.getRegisteredModules().length || i.ModuleRegistry.registerModules(i.AllModules);
      const r = this.$element[0].querySelector("#dataGrid");
      new i.Grid(r, this.gridOptions);
    }), this.$timeout(() => {
      this.gridOptions.api.setRowData(this.data), this.gridOptions.api.setColumnDefs(t);
    });
  }
};
Hy.$inject = ["JsonSchemaService", "UiHelpers", "$element", "$timeout", "FileService"], Hy.bindings = {
  /**
   * The schema definition that defines the structure of the grid.
   */
  schemaDef: "<",
  /**
   * URL of the schema document that contains the schemaDef.
   * If set with schema in init, loads the document.
   */
  doc: "@",
  /**
   * Key of schemaDef in doc.
   * If set with doc in init, will load the schema document from server and set the schemaDef.
   */
  schema: "@",
  /** Data that is rendered / edited in the grid. */
  data: "<",
  /**
   * List of columns to include in the grid. Raw field names - may be a property tree.
   */
  include: "<",
  /**
   * List of columns to exclude from the grid.
   * This property is currenlty used only if include property is undefined, i.e. in default
   * rendering, which will render the first-level properties. As such, exclude does not really support property paths.
   */
  exclude: "<"
};
let Lu = Hy;
const Uy = class Uy {
  constructor(t, e, a, n) {
    this.uiHelpers = t, this.$transclude = e, this.$element = a, this.fileService = n;
  }
  /** Initializes the controller */
  $onInit() {
    this.initModel();
  }
  /**
   * Gets the formatted value for the input depending on the data type.
   * @param childName For object arrays, gets the value for the specified child input.
   * @param index For object the index of the item in the array.
   * May later support other child scenarios.
   */
  formatValue(t, e = null) {
    if (t && e != null) {
      const a = this.schemaModel?.items;
      if (a) {
        const n = a.properties[t], i = this.value[e][t];
        return i && n.format && n.enum?.length ? He.getEnumLabel(`${this.form.getEnumNamespace()}.${n.format}`, i) : i;
      }
      return `#ERR: formatValue not an array ${t}, ${e}.`;
    }
    return "#ERR: TODO Add other formatters here";
  }
  /**
   * Gets the label for the input.
   * Default is "SALAXY.MODEL.[TypeName].[propName].title" in the dictionary.
   * @param childName For object arrays, gets the label for the specified child input.
   * May later support other child scenarios.
   */
  getLabel(t) {
    if (t) {
      const e = this.schemaModel?.items;
      if (e?.type === "object" && e.format) {
        const a = e.properties?.[t]?.title ?? "#" + t;
        return L.getWithDefault(`${this.form.getModelNamespace()}.${e.format}.${t}.title`, a);
      }
      return this.propertyName ? L.getWithDefault(`${this.form.getModelNamespace()}.${this.parentSchemaName}.${this.propertyName}.${t}.title`, "#" + t) : this.parentSchemaName ? L.getWithDefault(`${this.form.getModelNamespace()}.${this.parentSchemaName}.${t}.title`, "#" + t) : "#ERR: " + t;
    }
    if (this.label)
      return this.label[0] === "." && this.label[1] !== "." && this.propertyName && (this.label = `${this.form.getModelNamespace()}.${this.parentSchemaName}.${this.propertyName}${this.label}`), L.get(this.label);
    if (this.propertyName) {
      const e = this.schemaModel?.title ?? "#" + this.propertyName;
      return L.getWithDefault(`${this.form.getModelNamespace()}.${this.parentSchemaName}.${this.propertyName}.title`, e);
    }
    if (this.parentSchemaName) {
      const e = this.schemaModel?.title ?? "#" + this.parentSchemaName;
      return L.getWithDefault(`${this.form.getModelNamespace()}.${this.parentSchemaName}.title`, e);
    }
    return "#ERR: " + this.model;
  }
  /** Gets the description for the input */
  getDescr() {
    return L.getWithDefault(
      `${this.form.getModelNamespace()}.${this.parentSchemaName}.${this.propertyName}.descr`,
      this.schemaModel?.description
    );
  }
  /** Gets the read-only value based on defaults and explicit values. */
  getReadOnly() {
    const t = (this.readOnly || "").trim().toLowerCase();
    if (t === "true" || t === "1")
      return !0;
    if (t === "false" || t === "0")
      return !1;
    const e = (this.form.readOnly || "").trim().toLowerCase();
    return e === "true" || e === "1" ? !0 : this.schemaModel?.readOnly != null ? this.schemaModel.readOnly : ["id", "createdAt", "updatedAt", "isReadOnly", "owner", "partner"].indexOf(this.propertyName) >= 0;
  }
  /** Gets the minimum value */
  getMinimum() {
    return this.minimum != null ? this.minimum : this.schemaModel?.minimum != null ? this.schemaModel.minimum : null;
  }
  /** Gets the maximum value */
  getMaximum() {
    return this.maximum != null ? this.maximum : this.schemaModel?.maximum != null ? this.schemaModel.maximum : null;
  }
  /** Gets the multipleOf value */
  getMultipleOf() {
    return this.multipleOf != null ? this.multipleOf : this.schemaModel?.multipleOf != null ? this.schemaModel.multipleOf : null;
  }
  /** Gets the minimum length value for string input */
  getMinLength() {
    return this.schemaModel?.minLength != null ? this.schemaModel.minLength : null;
  }
  /** Gets the maximum length value for string input */
  getMaxLength() {
    return this.schemaModel?.maxLength != null ? this.schemaModel.maxLength : null;
  }
  /** Gets the minimum length value for string input */
  getPattern() {
    return this.schemaModel?.pattern != null ? this.schemaModel.pattern : null;
  }
  /** Gets the require value based on defaults and explicit values. */
  getRequire() {
    const t = (this.require || "").trim().toLowerCase();
    return t === "true" || t === "1";
  }
  /** Gets the disable value based on defaults and explicit values. */
  getDisable() {
    const t = (this.disable || "").trim().toLowerCase();
    return t === "true" || t === "1";
  }
  /** Gets or sets the value in the model */
  get value() {
    return this.form?.getValue(this.model);
  }
  set value(t) {
    this.form && this.form.setValue(this.model, t);
  }
  /**
   * For datatype "object", gets the inputs for child properties.
   * For datatype "array", gets the inputs for items.
   * For other types, gets an array with single input for that type
   * (TODO: Does this make sense? It is essentially the same as parent).
   * @param defaultTop Returns top n children.
   * If include is specified (fields are hand-picked), this proeprty is ignored.
   */
  getChildInputs(t) {
    return this.uiHelpers.cache(this, "childInputs", () => {
      if (!this.schemaModel)
        return null;
      let e;
      this.schemaModel.type === "object" ? e = Gd.getInputsForObject(this.schemaModel, this.model) : ol.isArraySchemaObject(this.schemaModel) ? e = Gd.getInputsForArray(this.schemaModel, this.model) : e = [Gd.getInputForSelf(this.schemaModel, null, "form")];
      const a = ie.assureArray(this.include);
      a.length > 0 && (e = a.map((i) => e.find((r) => r.name === i)).filter((i) => !!i), t = a.length);
      const n = ie.assureArray(this.exclude);
      return n.length > 0 && (e = e.filter((i) => n.indexOf(i.name) < 0)), e.slice(0, t);
    });
  }
  /**
   * Shows an edit dialog for item.
   * @param item Item to edit
   * @param index Index of the item in the current model array if available.
   */
  edit(t, e) {
    const a = {
      openApi: this.form.openApi,
      type: this.schemaModel?.items?.format,
      title: e < 0 ? L.get("SALAXY.NG1.SxyInputComponent.addNewRow") : L.get("SALAXY.NG1.SxyInputComponent.editRow"),
      showDelete: e > -1 && !this.getReadOnly(),
      isReadOnly: this.getReadOnly(),
      debugger: this.form.debugger
    };
    if (this.$transclude?.isSlotFilled("form")) {
      let n = "";
      this.$transclude((r, l) => (wt.forEach(r, (o) => {
        o.tagName === "FORM" && (n += o.innerHTML);
      }), n = n.trim(), null), this.$element, "form");
      const i = `<div class="modal-header">
      <h2 class="modal-title">{{ $ctrl.logic.title }}</h2>
      <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
    </div>
    <div class="modal-body">
      <sxy-form open-api="{{ $ctrl.logic.openApi }}" type="{{ $ctrl.logic.type }}" auto-gen="false" debugger="$ctrl.logic.debugger"
        model="$ctrl.current" read-only="{{$ctrl.logic.isReadOnly ? 'true' : ''}}">
        <div>${n || "Form tag contains no data"}</div>
      </sxy-form>
    </div>
    <div class="modal-footer">
      <button type="button" ng-if="$ctrl.logic.showDelete" class="btn btn-danger" ng-click="$close('delete-no-save')" sxy-text="SALAXY.UI_Terms.delete"></button>
      <button type="reset" ng-if="!$ctrl.logic.isReadOnly" class="btn btn-default ms-auto" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
      <button type="button" ng-if="!$ctrl.logic.isReadOnly" class="btn btn-primary" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.ok"></button>
      <button type="button" ng-if="$ctrl.logic.isReadOnly" class="btn btn-primary" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
    </div>`;
      return this.uiHelpers.openEditDialog(null, t, a, "", "EditDialogController", { template: i }).then((r) => (r.action === We.DeleteNoCommit && this.delete(t, e), r));
    }
    return this.uiHelpers.openEditDialog("salaxy-components/sxy-form/SxyInput-dialog-edit.html", t, a).then((n) => (n.action === We.DeleteNoCommit && this.delete(t, e), n));
  }
  /**
   * Deletes an item (currently no "Are you sure?")
   * @param item Item to delete
   * @param index Index of the item in the current model array. This is currently required.
   */
  delete(t, e) {
    this.value.splice(e, 1);
  }
  /**
   * Creates a new item to the current array.
   * @param item Item to add. If not specified (default), shows an edit dialog for creating the item.
   */
  createNew(t = null) {
    if (t) {
      this.value || (this.value = []), this.value.push(t);
      return;
    }
    return this.edit({}, -1).then((e) => (e.action === "ok" && (this.value || (this.value = []), this.value.push(e.item)), e));
  }
  /**
   * Gets an array total for view purposes
   * @param field Name of the field for which the total is calculated
   * @param type Type of calculation. Currently only sum is supported, but others may be added (e.g. "avg").
   */
  getTotal(t, e = "sum") {
    if (this.value)
      switch (e) {
        case "sum":
        default:
          return ie.sum(this.value, (a) => a[t]);
      }
  }
  /**
   * Gets the options for enumerations based on schema.
   * For an array, gets the options for item enumeration.
   */
  getEnumOptions() {
    return this.uiHelpers.cache(this, "getEnumOptions", () => {
      if (!this.schemaModel)
        return [];
      let t = this.schemaModel.enum, e = this.schemaModel.format;
      if (t?.length || (t = this.schemaModel.items?.enum, e = this.schemaModel.items?.format), t?.length > 0)
        return t.map((a) => ({
          title: He.getEnumDescr(`${this.form.getEnumNamespace()}.${e}`, a),
          text: He.getEnumLabel(`${this.form.getEnumNamespace()}.${e}`, a),
          value: a
        }));
    }, () => this.schemaModel.type + this.schemaModel.format + this.schemaModel.enum?.length);
  }
  /**
   * Gets the format assuring that it is of supported type.
   * Currently, there is only special logic for enums.
   */
  getFormat() {
    if (this.input.isEnum) {
      const t = this.format || this.input.format;
      return ["select", "radio", "multi-select", "typeahead", "list"].indexOf(t) >= 0 ? t : "select";
    }
    return this.format;
  }
  /** Gets the exportable for the current data model: For exporting an array. */
  getExportable() {
    if (!this.schemaModel.items)
      return {
        exporters: [],
        getExportMappers: () => [],
        getExportMapper: () => null,
        list: () => Promise.resolve([]),
        getSingle: (n) => Promise.resolve(n)
      };
    const t = new br(this.propertyName + "GridExport", `Table export for ${this.propertyName}`);
    t.setSchema(this.schemaModel.items, this.propertyName, "source"), t.setPathsFromSourceSchema(this.getChildInputs(100).map((n) => n.name));
    const e = [t];
    return {
      exporters: this.fileService.getDefaultExporters(),
      getExportMappers: () => e.map((n) => yc.getInfo(n)),
      getExportMapper: (n) => Promise.resolve(e.find((i) => i.uri == n)),
      list: (n) => {
        const i = n > 0 ? this.value.slice(0, n) : this.value;
        return Promise.resolve(i);
      },
      getSingle: (n) => Promise.resolve(n)
    };
  }
  initModel() {
    if (!this.model)
      throw new Error("Input not bound to model.");
    if (!this.form) {
      this.input = {
        type: "error",
        content: "No sxy-form for input with model " + this.model,
        name: this.model,
        path: this.model,
        isEnum: !1,
        format: null
      }, this.name = this.id = this.input.name, this.templateUrl = "salaxy-components/sxy-form/error/default.html", this.schemaModel = null;
      return;
    }
    const t = this.form.registerInput(this.model, this.type, this.format);
    this.schemaModel = t.prop.schema || null, this.parentSchemaName = t.prop.parentName, this.name = this.id = t.id, this.propertyName = t.prop.propertyName, t.prop.isRequired && !(this.require || "").trim() && (this.require = "true"), this.input = t.input, this.type && this.type !== this.input.type && console.error(`Input type "${this.type}" not supported for property "${this.input.name}", defaulting to "${this.input.type}".`), this.templateUrl = t.templateUrl;
  }
};
Uy.$inject = ["UiHelpers", "$transclude", "$element", "FileService"], Uy.bindings = {
  /**
   * Model in the form. Currently always starts with "form." to bind to main data object of the form.
   * For fieldset, this may also be just "form" to bind to main model in form (not a property).
   */
  model: "@",
  /** Possibility to override the label. */
  label: "@",
  /**
   * Type of the input component as one of JSON schema types:
   * 'boolean', 'object', 'number', 'string', 'integer' or 'array'.
   * Typically, this will be inferred from the model, but you may set it explicitly if the property is not yet in the model.
   */
  type: "@",
  /**
   * Format of the input component as JSON schema format:
   * Examples include "multiline", "date" (string) and "radio", "checkbox" (boolean).
   */
  format: "@",
  /**
   * True or false forces the read-only mode on the input regardless of the default value.
   * This "read-only" attribute behaves differently than the HTML "readonly" attribute:
   * The value is boolean (true/1 or false/0). Non existent attribute or empty/null uses
   * the default value from metadata (API model) or from the form.
   * Also, the input will become fully read-only view without any form control.
   */
  readOnly: "@",
  /**
   * True or false forces the disabled mode on the input.
   * This "disable" attribute behaves differently than the HTML "disabled" attribute:
   * The value is boolean (true/1 or false/0). Non existent attribute or empty/null
   * uses the default value: Currently always false, but may later come from metadata.
   */
  disable: "@",
  /**
   * True or false forces the required mode on the input.
   * This "require" attribute behaves differently than the HTML "required" attribute:
   * The value is boolean (true/1 or false/0). Non existent attribute or empty/null
   * uses the default value from metadata (API model).
   */
  require: "@",
  /**
   * Minimum value of the field
   */
  minimum: "@",
  /**
   * Maximum value of the field
   */
  maximum: "@",
  /**
   * Multiple of (step) of the value
   */
  multipleOf: "@",
  /**
   * For arrays, fieldsets and other components that enumerate children,
   * defines which children are shown (taken to inputs collection).
   * Comma separated list of property names.
   */
  include: "@",
  /**
   * For arrays, fieldsets and other components that enumerate children,
   * defines which children are hidden (excluded from inputs collection).
   * Comma separated list of property names.
   */
  exclude: "@"
};
let no = Uy;
const rk = class rk {
  constructor(t, e) {
    this.jsonSchemaService = t, this.uiHelpers = e;
  }
  /** Initializes the controller */
  $onInit() {
    this.types = [];
    const t = this.jsonSchemaService.getRegisteredInputs(), e = { string: "Teksti", number: "Numero", array: "Lista", boolean: "On/off (boolean)", integer: "Kokonaisluku", object: "Muu..." };
    Object.keys(t).forEach((a) => {
      this.types.push({
        text: e[a],
        value: a,
        formats: Object.keys(t[a]).map((n) => ({
          text: n == "default" ? "Oletus" : n,
          // TODO: Translate
          value: n == "default" ? "" : n
        }))
      });
    });
  }
  /** Adds a new property to the current schema */
  addProperty() {
    const t = window.prompt("Mikä on lisättävän tietueen tekninen nimi (a-z, 0-1, ei välejä eikä erikoismerkkejä)?");
    this.model[t] = {};
  }
  /** Deletes a property from the schema. */
  deleteProperty(t) {
    delete this.model[t];
  }
  /** Gets the formats for given type */
  getFormats(t) {
    return this.types.find((e) => e.value == t).formats;
  }
};
rk.$inject = ["JsonSchemaService", "UiHelpers"];
let cy = rk;
const lk = class lk {
  constructor(t, e, a) {
    this.jsonSchemaService = t, this.$element = e, this.$timeout = a, this.filters = !1, this.filterDefinitions = {}, this.tableConfigCache = {
      data: null,
      include: null,
      exclude: null,
      options: null
    };
  }
  /** Initializes the controller */
  $onInit() {
    this.init();
  }
  /** Intialises settings */
  async init() {
    if (this.doc = this.doc || "salaxy-secure/schemas/v02.json", !this.schemaDef && this.doc && this.schema) {
      const t = await this.jsonSchemaService.assureSchemaDocument(this.doc);
      this.schemaDef = t?.components?.schemas?.[this.schema];
    }
    this.renderTable();
  }
  /**
   * Method used to refresh table if data, include, exclude or options changes
   */
  refresh() {
    this.renderTable();
  }
  async renderTable() {
    const t = [];
    this.getFields().forEach((i) => {
      let r, l;
      if (typeof i == "string" ? (r = i, l = {
        field: r,
        title: "#field"
        // Will be replaced below
      }) : (r = i.field || "", l = i), !r && !l.formatter) {
        console.error("Invalid column definition (no field): ", i);
        return;
      }
      const o = ol.getProperty(this.schemaDef, r)?.schema;
      o && ((l == null || l.title == "#field") && (l.title = o.title || "#field"), this.setDefaultFormatter(o, l), o.description && (l.headerTooltip = o.description), o.enum?.length), (l.title == null || l.title == "#field") && (l.title = r.indexOf(".") ? r.substring(r.lastIndexOf(".") + 1) : r), l.headerFilter && (l.field ? (this.filterDefinitions[l.field] = l.headerFilter, this.filters || (l.headerFilter = void 0)) : console.error("Cannot set filter for column without field: ", l)), t.push(l);
    });
    const e = {};
    this.options && Object.assign(e, this.options), this.data?.getTabulatorConfig ? Object.assign(e, this.data.getTabulatorConfig()) : e.data = this.data || [], t.length ? e.columns = t : e.autoColumns == null && (e.autoColumns = !0);
    const a = this.$element.find("div")[0];
    if (!a)
      throw new Error("Cannot find div element for table.");
    this.tabulator = new _A(a, e);
    const n = e.events ?? {};
    Object.keys(n).forEach((i) => {
      const r = i;
      this.tabulator.on(r, n[r]);
    }), await this.$timeout();
  }
  //TODO: Replaces @salaxy/core assureArray?
  assureArray(t) {
    return t ? Array.isArray(t) ? t : t.split(",") : [];
  }
  getFields() {
    let t = this.assureArray(this.include);
    if (t.length == 0) {
      let e = Object.keys(this.schemaDef?.properties || {});
      const a = this.assureArray(this.exclude);
      a.length > 0 && (e = e.filter((n) => a.indexOf(n) < 0)), t = e;
    }
    return t;
  }
  setDefaultFormatter(t, e) {
    if (!e.formatter)
      switch (t.type) {
        case "integer":
        case "number":
          break;
        case "object":
          break;
        case "string":
          t.format === "date-time" && (e.formatter = (a, n, i) => {
            const r = a.getValue();
            return r ? new Date(r).toLocaleDateString("fi-FI") : "";
          }, e.hozAlign = "right");
      }
  }
};
lk.$inject = ["JsonSchemaService", "$element", "$timeout"];
let dy = lk;
const ok = class ok {
  /**
   * Creates a new AccountResetController.
   * @param testApi - Api methods for resetting account data.
   * @param uiHelpers - Salaxy UI Helpers.
   * @param ajax - Salaxy ajax component.
   */
  constructor(t, e, a, n) {
    this.testApi = t, this.uiHelpers = e, this.ajax = a, this.sessionService = n;
  }
  /**
   * Delete the current account data and credentials (including Auth0 user).
   * Can be called only in a test environment.
   */
  deleteCurrent() {
    this.uiHelpers.showConfirm("Haluatko varmasti poistaa tilin?").then((t) => {
      if (t) {
        const e = this.uiHelpers.showLoading("SALAXY.UI_Terms.wait");
        this.testApi.deleteCurrentAccount().then(() => {
          e.dismiss(), this.logout();
        });
      }
    });
  }
  /**
   * Remove all calculations, workers etc. user objects except products and signature from the account.
   * Can be called only in a test environment.
   */
  deleteData() {
    this.uiHelpers.showConfirm("Haluatko varmasti poistaa tiliin liittyvän datan?").then((t) => {
      if (t) {
        const e = this.uiHelpers.showLoading("SALAXY.UI_Terms.wait");
        this.testApi.deleteCurrentAccountData().then(() => {
          e.dismiss(), this.logout();
        });
      }
    });
  }
  /**
   * Remove all calculations, payrolls and payments from the account.
   * Can be called only in a test environment.
   */
  deleteCalculations() {
    this.uiHelpers.showConfirm("Haluatko varmasti poistaa tilin laskelmat?").then((t) => {
      if (t) {
        const e = this.uiHelpers.showLoading("SALAXY.UI_Terms.wait");
        this.testApi.deleteCurrentAccountCalculations().then(() => {
          e.dismiss(), this.logout();
        });
      }
    });
  }
  /**
   * Remove workers including calculations, employment contracts and tax cards from the account.
   * Can be called only in a test environment.
   */
  deleteWorkers() {
    this.uiHelpers.showConfirm("Haluatko varmasti poistaa tilin työntekijät?").then((t) => {
      if (t) {
        const e = this.uiHelpers.showLoading("SALAXY.UI_Terms.wait");
        this.testApi.deleteCurrentAccountWorkers().then(() => {
          e.dismiss(), this.logout();
        });
      }
    });
  }
  /**
   * Remove all holiday year from all workers. Does not touch the default values of holidays in Worker Employment relation.
   * Can be called only in a test environment.
   */
  deleteHolidays() {
    this.uiHelpers.showConfirm("Haluatko varmasti poistaa loma- ja poissaolotiedot?").then((t) => {
      if (t) {
        const e = this.uiHelpers.showLoading("SALAXY.UI_Terms.wait");
        this.testApi.deleteCurrentAccountHolidays().then(() => {
          e.dismiss(), this.logout();
        });
      }
    });
  }
  /**
   * Delete all empty accounts (company or worker) created by this account.
   * Can be called only in a test environment.
   */
  deleteAuthorizingAccounts() {
    this.uiHelpers.showConfirm("Haluatko varmasti poistaa tilin luomat muut tilit?").then((t) => {
      if (t) {
        const e = this.uiHelpers.showLoading("SALAXY.UI_Terms.wait");
        this.testApi.deleteCurrentAccountAuthorizingAccounts().then(() => {
          e.dismiss(), this.logout();
        });
      }
    });
  }
  /**
   * Remove pension and insurance from the account.
   * Can be called only in a test environment.
   */
  deletePensionAndInsurance() {
    this.uiHelpers.showConfirm("Haluatko varmasti poistaa tiliin liittyvän TyEL:n ja vakuutukset?").then((t) => {
      if (t) {
        const e = this.uiHelpers.showLoading("SALAXY.UI_Terms.wait");
        this.testApi.deleteCurrentAccountPensionAndInsurance().then(() => {
          e.dismiss(), this.logout();
        });
      }
    });
  }
  /**
   * Remove the signature from the account.
   * Can be called only in a test environment.
   */
  deleteSignature() {
    this.uiHelpers.showConfirm("Haluatko varmasti poistaa tilin valtuutuksen (allekirjoitus)?").then((t) => {
      if (t) {
        const e = this.uiHelpers.showLoading("SALAXY.UI_Terms.wait");
        this.testApi.deleteCurrentAccountSignature().then(() => {
          e.dismiss(), this.logout();
        });
      }
    });
  }
  /**
   * Checks if the KYC (Know Your Customer) process is done for the current account.
   * @returns A boolean value indicating whether the KYC process is done.
   */
  isKycMissing() {
    return !this.sessionService.session?.currentAccount?.identity?.kycUpdatedAt;
  }
  /**
   * Handles the KYC (Know Your Customer) process.
   * If KYC is missing, it activates the KYC.
   * Otherwise, it deletes the KYC.
   */
  handleKyc() {
    this.isKycMissing() ? this.activateKyc() : this.deleteKyc();
  }
  /**
   * Deletes the KYC (Know Your Customer) information for the current account.
   * Shows a confirmation dialog before deleting the KYC.
   * If the user confirms, it makes an API call to delete the KYC and logs out the user.
   */
  deleteKyc() {
    this.uiHelpers.showConfirm("Haluatko varmasti poistaa tilin KYCin?").then((t) => {
      if (t) {
        const e = this.uiHelpers.showLoading("SALAXY.UI_Terms.wait");
        this.testApi.deleteCurrentAccountKyc().then(() => {
          e.dismiss(), this.logout();
        });
      }
    });
  }
  /**
   * Activates the KYC for the account.
   * Displays a confirmation dialog and proceeds with the activation if confirmed.
   * Deletes the current account signature and logs out after successful activation.
   */
  activateKyc() {
    this.uiHelpers.showConfirm("Haluatko varmasti aktivoidatilin KYCin?").then((t) => {
      if (t) {
        const e = this.uiHelpers.showLoading("SALAXY.UI_Terms.wait");
        this.testApi.activateCurrentAccountKyc().then(() => {
          e.dismiss(), this.logout();
        });
      }
    });
  }
  logout() {
    this.ajax.setCurrentToken(null), window.location.assign("/");
  }
};
ok.$inject = [
  "Test",
  "UiHelpers",
  "AjaxNg1",
  "SessionService"
];
let uy = ok;
const L6 = "This text is in json", D6 = {
  test: L6
}, ck = class ck {
  constructor(t) {
    this.sessionSrv = t, this.reportsTests = {
      loaded: null,
      mapper: null,
      handlebars: null
    }, this.chartData = La.getMainChart(
      {
        card: {
          incomeLimit: 3e4,
          taxPercent: 10,
          taxPercent2: 30,
          forYear: I.getYear(I.getToday()),
          personalId: "111111-111*",
          validity: {
            start: I.getToday()
          }
        },
        result: {
          totalIncome: 21e3
        },
        incomeLog: []
      }
    );
  }
  /**
   * Controller initialization
   */
  $onInit() {
    try {
      this.runReportTests();
    } catch (t) {
      console.error("Init tests run failed with exception."), console.log(t);
    }
  }
  /** Gets number 1 from @salaxy/core library. */
  getNumber() {
    return se.parseNumber("1") || null;
  }
  /** Gets a date formatted with Dates library: "20.02.2020" */
  getADate() {
    return I.format(I.asDate("2020-02-20"));
  }
  /** Returns true if the code can read the token usin Base64 library. */
  readToken() {
    return Vo.parseHeader("eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJPbmxpbmUgSldUIEJ1aWxkZXIiLCJpYXQiOjE2Mjg2OTE2OTMsImV4cCI6MTY2MDIyNzY5MywiYXVkIjoid3d3LmV4YW1wbGUuY29tIiwic3ViIjoianJvY2tldEBleGFtcGxlLmNvbSIsIkdpdmVuTmFtZSI6IkpvaG5ueSIsIlN1cm5hbWUiOiJSb2NrZXQiLCJFbWFpbCI6Impyb2NrZXRAZXhhbXBsZS5jb20iLCJSb2xlIjpbIk1hbmFnZXIiLCJQcm9qZWN0IEFkbWluaXN0cmF0b3IiXX0.WBuoHS5h8iZi0b5cE25onpvgYFv_X-QXbLdf0KjECEY").alg === "HS256";
  }
  /** Runs smoke tests related to Reports library. */
  runReportTests() {
    this.reportsTests.loaded = !!new or(), this.reportsTests.mapper = this.isCalcMapperWorking(), this.reportsTests.handlebars = this.isHbsTemplatesWorking();
  }
  /** Shows a saveAs dialog for text file ("Hello, world!"). */
  saveAs() {
    const t = new Blob(["Hello, world!"], { type: "text/plain;charset=utf-8" });
    window.saveAs(t, "hello world.txt");
  }
  /** Gets a text from json file. */
  getJson() {
    return D6.test;
  }
  isCalcMapperWorking() {
    const t = Da.getBlank();
    t.worker.avatar.firstName = "James", t.worker.avatar.sortableName = "JamesB", t.worker.tax.snapshot = { forYear: 2021, incomeLimit: 999.5 }, t.result.totals = {}, t.result.workerCalc = {}, t.result.responsibilities = {}, t.result.employerCalc = {};
    const e = or.getCalculationReport(t, Xd.SalarySlip, void 0);
    return e.header.taxcardIncomeLimit === 999.5 && e.header.worker.avatar.firstName === "James" && e.header.worker.avatar.sortableName === "JamesB";
  }
  /**
   * Tests that handlebars templates including nested partials and helpers are working correctly.
   * @returns Returns true if templates are working and otherwise false.
   */
  isHbsTemplatesWorking() {
    const t = new io().getHtml(
      "salarySlipV2",
      {
        report: {
          header: {
            taxcardIncomeLimit: 999.5,
            worker: {
              avatar: {
                firstName: "James",
                sortableName: "JamesB"
              }
            }
          }
        }
      }
    );
    return (
      // Produced by a deeply nested partial (salarySlipV2 -> workerReportHeadV2 ->
      // contractPartiesContactDetailsV2)
      t.indexOf('<div class="uppercase">JamesB</div>') !== -1 && t.indexOf("<span>999,50€</span>") !== -1
    );
  }
};
ck.$inject = ["SessionService"];
let py = ck;
const dk = class dk extends nn {
  constructor(t, e, a, n) {
    super(t, e, a, n);
  }
  /** Implements the getDefaults of ApiCrudObjectController */
  getDefaults() {
    return {
      listUrl: this.listUrl || "/reference-objects",
      detailsUrl: this.detailsUrl || "/reference-objects/details/",
      oDataTemplateUrl: "salaxy-components/odata/lists/ReferenceObjects.html",
      oDataOptions: {}
    };
  }
};
dk.$inject = [
  "ReferenceObjects",
  "UiHelpers",
  "$location",
  "$routeParams"
];
let uw = dk;
class I6 extends $r {
  constructor() {
    super(...arguments), this.condensed = "<", this.filterStart = "<", this.filterEnd = "<";
  }
}
const Fy = class Fy extends Ki {
  constructor(t) {
    super(t), this.mapToCalendar = (e) => [{
      key: e.id,
      title: e.workerSnapshot?.displayName,
      avatar: e.workerSnapshot,
      events: e.periods.map((a) => ({
        start: a.period.start,
        end: a.period.end,
        summary: He.getEnumLabel("AbsenceCauseCode", a.causeCode),
        data: a
      }))
    }], this.filter = (e) => !(this.filterEnd && e.period.start > this.filterEnd || this.filterStart && e.period.end < this.filterStart);
  }
  /** List of items */
  get list() {
    return this.parent ? this.parent.periods : null;
  }
  /** Creating of a new item. */
  getBlank() {
    return {
      period: {
        start: I.getToday(),
        end: I.getToday(),
        daysCount: 1
      }
    };
  }
  /** Template for edit UI that is shown in a modal dialog. */
  getEditDialogTemplateUrl() {
    return "salaxy-components/worker/AbsencePeriodsEditDialog.html";
  }
  /** Calendar is clicked => Show edit dialog accorging to calendar data. */
  calendarClick(t, e, a) {
    switch (t) {
      case "event":
        this.showEditDialog(a.data);
        break;
      case "day": {
        const n = this.getBlank();
        n.period.start = e, n.period.end = e, this.showEditDialog(n, !0);
        break;
      }
      default:
        throw new Error("Not supported: " + t);
    }
  }
  /** Gets the needed logic for Edit dialog */
  getEditDialogLogic() {
    return dn.getAbsencesEditDialogLogic();
  }
  /** Gets a total days calculation for different types. */
  getTotalDays(t = "all") {
    const e = this.list.filter((a) => this.filter(a));
    switch (t) {
      case "all":
        return ie.sum(e, (a) => a.period.daysCount);
      case "absencesPaid":
        return ie.sum(e.filter((a) => a.isPaid), (a) => a.period.daysCount);
      case "absencesUnpaid":
        return ie.sum(e.filter((a) => !a.isPaid), (a) => a.period.daysCount);
      case "absencesHolidayAccrual":
        return ie.sum(e.filter((a) => a.isHolidayAccrual), (a) => a.period.daysCount);
      case "absencesNoHolidayAccrual":
        return ie.sum(e.filter((a) => !a.isHolidayAccrual), (a) => a.period.daysCount);
    }
    return null;
  }
};
Fy.bindings = new I6(), Fy.$inject = ["UiHelpers"];
let Du = Fy;
const uk = class uk extends nn {
  constructor(t, e, a, n, i, r, l, o, c, d, p) {
    super(t, r, l, o), this.fullApi = t, this.sessionService = e, this.fileService = a, this.jsonSchemaService = n, this.uiCrudHelpers = i, this.$timeout = c, this.calculations = d, this.$route = p, this._readOnlyDefaultContact = {}, this.calcListLogic = {
      /**
       * Returns true if the calculation is for another employment relation than the current one.
       * @param calc Calculation to evaluate.
       * @returns True, if the calculation is for another employment relation.
       */
      isNotCurrentEmployment: (h) => h.data.employmentId !== this.currentId
    };
  }
  /**
   * Initialization code.
   */
  $onInit() {
    super.$onInit();
  }
  /** Implements the getDefaults of ApiCrudObjectController */
  getDefaults() {
    return {
      listUrl: this.listUrl || "/workers",
      detailsUrl: this.detailsUrl || "/employments/details/",
      oDataTemplateUrl: "salaxy-components/odata/lists/Employments.html",
      oDataOptions: {}
    };
  }
  /**
   * Gets or sets the taxcard type in employment.
   * In set, shows a confirm dialog before committing the change.
   */
  get taxcardType() {
    return this.current.info.taxcard;
  }
  set taxcardType(t) {
    if (!(!this.current?.info || this.current.info.taxcard == t)) {
      if ((this.current.info?.taxcard || Xa.Undefined) == Xa.Undefined) {
        this.current.info.taxcard = t, this.save();
        return;
      }
      this.uiHelpers.showConfirm("SALAXY.UI_Terms.areYouSure", "SALAXY.NG1.WorkerDetailsComponent.taxCard.typeAreYouSure").then((e) => {
        e && (this.current.info.taxcard = t, this.save());
      });
    }
  }
  /** Returns true if the employer is a household employer (person as opposed to company). */
  get isHousehold() {
    return this.sessionService.isInRole("person");
  }
  /**
   * Gets a description text for an employment relation
   * @param employment The employment relation to describe.
   */
  getEmploymentDescription(t) {
    return Ma.isListItem(t) ? Ma.getDescription(t.otherPartyInfo, t.data.type, t.data.pensionCalculation) : Ma.getDescription(t.personalInfo, t.info?.type, t.info?.pensionCalculation);
  }
  /**
   * Gets a descriptive text on whether the employment is active or not.
   * @param employment Employment relation to get the text for.
   * @returns A text that describes whether the employment is active or not with the dates (start and end).
   */
  getActiveText(t) {
    return Ma.getActiveText(t);
  }
  /**
   * Gets the tax card info text for active taxcard.
   */
  getTaxCardInfo() {
    const t = {
      text: L.get("SALAXY.UI_Terms.loading"),
      isMissing: !1
    };
    if (!this.current)
      return t;
    if (this.current.info.taxcard == Xa.NoTaxCard)
      return t.text = He.getEnumLabel("TaxcardKind", ma.NoTaxCard), t;
    if (this.current.info.taxcard == Xa.TaxAtSource)
      return t.text = He.getEnumLabel("EmploymentRelationTaxcard", Xa.TaxAtSource), t.text = `${t.text} ${se.formatPercent(this.current.international.taxAtSource.percent * 100, null)}`, t;
    if (!this.taxcardsController?.current)
      return t;
    const e = this.taxcardsController.current, a = e.active;
    if (!a && e.employmentTaxcard == Xa.Auto)
      t.text = He.getEnumLabel("TaxcardKind", ma.Auto);
    else {
      const n = a ? a.card.kind : ma.Undefined;
      if (t.isMissing = n == ma.Undefined, n === ma.Undefined || n === ma.NoTaxCard || n === ma.NoWithholdingHousehold)
        t.text = He.getEnumLabel("TaxcardKind", n);
      else {
        const i = a?.card?.taxPercent === 0 ? 0 : a?.card?.taxPercent || 60;
        t.text = He.getEnumLabel("TaxcardKind", n) + ": " + se.formatPercent(i);
      }
    }
    return t;
  }
  /**
   * Gets a contact of specific type.
   * @param type Type of contact to get. Use null to fetch any contact type (creates Default if requested).
   * @param createIfNotExists If true creates the contact of given type if one does not exist.
   * @returns Contact of given type or undefined if one is not found AND createIfNotExists is false.
   */
  getContact(t, e = !0) {
    return Ma.getContact(this.current, t || js.Default, e);
  }
  /**
   * Returns default contact as read only.
   */
  get readOnlyDefaultContact() {
    const t = this.getContact(js.Default) ?? {};
    return Qe.equal(t, this._readOnlyDefaultContact) || (this._readOnlyDefaultContact = { ...t }), this._readOnlyDefaultContact;
  }
  /**
   * Gets the text for a Taxcard type badge (short text in lists).
   * Returns null if the badge should not be shown.
   */
  getTaxcardBadge(t) {
    switch (t) {
      case Xa.Auto:
        return "Auto";
      case Xa.Manual:
        return "Manual";
      case Xa.NoTaxCard:
        return "60%";
      case Xa.TaxAtSource:
      default:
        return He.getEnumLabel("EmploymentRelationTaxcard", t);
    }
  }
  /**
   * Opens the new Employment relation wizard and if a new relation is created, moves the user to the list view.
   */
  launchCreateEmploymentWizard() {
    this.uiCrudHelpers.createNewEmployment().then((t) => {
      if (t.action === "ok") {
        const e = this.uiHelpers.showLoading("SALAXY.UI_Terms.wait");
        return this.uiHelpers.wait(3e3).then(() => {
          e.dismiss(), this.$route.reload();
        });
      }
    });
  }
  /**
   * Shows a dialog for editing an existing employment.
   * If user clicks OK, the changes are saved.
   * @param employmentId - Identifier of the Workers employment.
   * @param buttonTypes "default" shows standard save button,
   * "updateCalc" shows two buttons "ok" for full calc update and "ok-no-rows" update without touching default rows.
   * @param initialTab - Tab to open.
   * @returns Dialog result. Note that OK result may be either "ok" or "ok-no-rows".
   * The latter means that for calculation only worker info should be updated, not the default rows.
   */
  openEditEmploymentDialog(t, e, a = null) {
    return this.uiCrudHelpers.openEditEmploymentDialog(t, e, a);
  }
  /**
   * Returns Exportable api for the used crud.
   * @returns Exportable api.
   */
  getExportable() {
    return {
      getExportMappers: () => yc.getMappers(["Employment", "EmploymentListItem"]),
      getExportMapper: (t) => yc.getBuiltInMapper(t, this.jsonSchemaService.getCache()),
      exporters: this.fileService.getDefaultExporters(),
      getSingle: (t) => this.getApi().getSingle(t.id),
      list: (t, e) => this.odataController.exportItems(t ?? 0, e)
    };
  }
  /**
   * Deletes the current employment if there are no associated calculations.
   * This method checks for any calculations associated with the current employment.
   * If no calculations are found, it proceeds to delete the employment.
   * Otherwise, it shows an alert indicating that the employment cannot be deleted because there are associated calculations that need to be removed first.
   */
  async deleteEmployment() {
    if ((await this.calculations.getOData({ $filter: `data/employmentId eq '${this.current.id}'` })).items.length === 0) {
      await this.delete(this.current, L.get("SALAXY.NG1.WorkerListComponent.employmentDeletion.confirmText"));
      return;
    }
    this.uiHelpers.showAlert(
      L.get("SALAXY.NG1.WorkerListComponent.employmentDeletion.existingtCalculationsHeading"),
      L.get("SALAXY.NG1.WorkerListComponent.employmentDeletion.existingtCalculationsText")
    );
  }
  /**
   * Opens a list of employment relations in to a dialog window.
   * Creates list of selected employments and updates taxcard to auto.
   * @param items Optional array of currently loaded/visible items.
   * The data.taxcard is updated so that the changes are refelected in the list.
   */
  selectAutoTaxcardForEmployments(t) {
    const e = [];
    this.uiHelpers.openEditDialog(
      "salaxy-components/modals/calc/WorkerList.html",
      e,
      {
        title: "SALAXY.NG1.PayrollComponent.createNewCalcDialog",
        okButtonText: "SALAXY.NG1.WorkerListComponent.okButtonText",
        infoHtml: "SALAXY.NG1.WorkerListComponent.infoText.html"
      }
    ).then((a) => {
      if (a.action === "ok" && e.length > 0) {
        const n = this.uiHelpers.showLoading("SALAXY.UI_Terms.isSaving");
        let i = 1;
        e.forEach((r) => {
          n.setText(`${L.get("SALAXY.UI_Terms.isSaving")} ${i}/${e.length}`), this.fullApi.getSingle(r.id).then((l) => {
            l.info.taxcard = Xa.Auto, this.fullApi.save(l).then((o) => {
              if (t) {
                const c = t.find((d) => d.id === o.id);
                c && (c.data.taxcard = o.info.taxcard);
              }
              i++, i - 1 === e.length && n.dismiss();
            });
          });
        });
      }
    });
  }
  /**
   * Called when the type of pension calculation changes
   * => Sets the PartialOwner and NoPensionRequired IncomeEarnerTypes accordingly.
   */
  pensionCalculationChange() {
    Ma.resetModelFromPensionCalculation(this.current);
  }
  /** Gets the session - currently used for company type */
  get session() {
    return this.sessionService.session;
  }
  /** Called when the type of employment changes => Sets the income earner types accordingly. */
  employmentTypeChange() {
    Ma.resetModelFromType(this.current);
  }
  /** Gets the cached version of the social security selection. */
  get socSec() {
    return this.uiHelpers.cache(
      this,
      "socSec",
      () => this.getSocialSecurityModel(
        this.sessionService.session?.settings,
        this.current.info.type,
        this.current.international.socialSecurity,
        this.current.info.pensionCalculation,
        this.current.info.pensionCompany,
        this.current.info.insuranceCompany,
        this.current.international.socialSecurityExceptions
      ),
      () => this.current.info.type + this.current.international.socialSecurity + this.current.info.pensionCalculation + this.current.info.pensionCompany + this.current?.info.insuranceCompany + this.current.international.socialSecurityExceptions
    );
  }
  /** Gets or sets the current country. When setting, the "foreign" address is reset. When getting Finland (fi) is converted to null. */
  get country() {
    return this.current.international.country == P0.Fi ? null : this.current.international.country;
  }
  set country(t) {
    this.current.international.country = t, this.current.contacts = (this.current.contacts || []).filter((a) => a.type != js.Foreign);
    const e = this.getContact(js.Foreign, !0);
    e.country = t;
  }
  /**
   * Gets the social security pensions model (available options) for the current selections.
   * @param settings Account settings in the session
   * @param type Type of employment relation selected
   * @param socialSecurity Whether the person is in Finnish or foregion social security - or mixed
   * @param pensionCalculation Type of Pension calculation: employee/TyEL or others (YEL, farmer etc.)
   * @param pensionCompany Pension company (if several) that is selected.
   * @param insuranceCompany Insurance company (if several) that is selected.
   * @param socSecExceptions The selected social security exceptions (not subject to)
   */
  getSocialSecurityModel(t, e, a, n, i, r, l) {
    return Ma.getSocialSecurityModel(t, e, a, n, i, r, l);
  }
  /** Overrides the Save method so that it realoads the taxcards controller if present. */
  save() {
    return super.save().then((t) => (this.taxcardsController && this.taxcardsController.reload(), t));
  }
  /**
   * Gets a tooltip that shows which fields are editied in the employment relation to be different
   * from the worker account (what the registered Worker has input in their UI).
   * @param inputName Name of the field in Contact or "ibanNumber".
   * @returns Tooltip text if there is a diff and tooltip should be shown.
   */
  getInputTooltip(t) {
    if (t == "ibanNumber")
      return this.current.info.ibanNumber !== this.current.personalInfo.ibanNumber ? `Tilinumeroa on muokattu tähän työsuhteeseen. Rekisteröityneen työntekijän syöttämä arvo on "${this.current.personalInfo.ibanNumber}". Jos haluat käyttää työntekijän syöttämää arvoa, voit kopioida sen ja päivittää tiedon kenttään, tai tyhjentää kentän ja painaa Tallenna.` : void 0;
    if (!Ma.getContact(this.current, js.EmployerOverride))
      return;
    const e = Ma.getContact(this.current, js.EmployerOverride)?.[t], a = Ma.getContact(this.current, js.WorkerAccount)?.[t];
    if (e)
      return `Yhteystietoa on muokattu tähän työsuhteeseen. Rekisteröityneen työntekijän syöttämä arvo on "${a}"`;
  }
  /**
   * Returns the true if the field is required for the more complex UI fields.
   * @param inputName Name of the field in Contact address (currently email and telephone never required) or "ibanNumber".
   * @returns True if required.
   */
  isRequired(t) {
    return t == "ibanNumber" ? this.current.info.salaryPaymentMethod != eX.BankAccount ? !1 : !this.current.isRegistered || !this.current.personalInfo.ibanNumber : this.isOtherIdentifier && (!this.current.isRegistered || !this.getContact(js.WorkerAccount)[t]);
  }
  /**
   * Returns true if the current personal ID is other identifier than Finnish Personal Identification Number (keinohetu).
   */
  get isOtherIdentifier() {
    return Ma.isPersonalIdOther(this.current.identity.personalId);
  }
  /**
   * Gets the list of other employments with this personal ID.
   * First call starts the loading process and returns undefined.
   * Once response is received, the getter returns an array of employments (list items).
   */
  get otherEmployments() {
    if (this.current)
      return this._otherEmployments || (this.current.personalInfo.officialId ? (this._otherEmployments = "loading", this.fullApi.getOData({ $filter: `otherPartyInfo/officialId eq '${this.current.personalInfo.officialId}'` }).then((t) => {
        this._otherEmployments = t.items.filter((e) => e.id != this.current.id);
      })) : this._otherEmployments = []), this._otherEmployments == "loading" ? void 0 : this._otherEmployments;
  }
};
uk.$inject = ["Employments", "SessionService", "FileService", "JsonSchemaService", "UiCrudHelpers", "UiHelpers", "$location", "$routeParams", "$timeout", "Calculations", "$route"];
let hy = uk;
const pk = class pk {
  /** Creates a new EmploymentTaxcardsController */
  constructor(t, e) {
    this.taxcards = t, this.uiHelpers = e, this.today = I.getToday(), this.$onInit = () => {
      this.mode = this.mode || "all";
    };
  }
  /**
   * Defines to which employment relation the functionality is bound to.
   * The setter also starts the loading process.
   */
  get employmentId() {
    return this._employmentId;
  }
  set employmentId(t) {
    this._employmentId = t, this.reload();
  }
  /** List of taxcards after it has been loaded. Null if nothing is loaded yet. */
  get list() {
    return this.current ? this.current.list : null;
  }
  /** Reloads the data from the server. */
  reload() {
    this.current = null, this.employmentId && this.taxcards.getEmploymentTaxcards(this.employmentId, this.today).then((t) => {
      this.current = t;
    });
  }
  /**
   * Removes a taxcard from the list and does a refresh.
   * @param id Taxcard id.
   */
  deleteTaxCard(t) {
    this.taxcards.delete(t).then(() => {
      this.reload();
    });
  }
  /** Edit income log. */
  editIncomeLog() {
    this.uiHelpers.openEditDialog(
      "salaxy-components/modals/worker/taxcard-income-log.html",
      this.current.active,
      { editable: !0 },
      "lg"
    ).then((t) => {
      if (t.action === We.Ok) {
        const e = this.uiHelpers.showLoading("SALAXY.UI_Terms.pleaseWait");
        this.taxcards.save(this.current.active).then((a) => {
          e.dismiss(), this.reload(), this.onSave && this.onSave({ item: a });
        });
      }
    });
  }
};
pk.$inject = ["Taxcards", "UiHelpers"];
let my = pk;
const hk = class hk extends bi {
  /**
   * Creates a new WizardController with dependency injection.
   * @ignore
   */
  constructor(t, e, a, n, i, r) {
    super(t, a), this.editDialogParameters = e, this.sessionService = n, this.uiHelpers = i, this.api = r;
  }
  /**
   * Initialization of the controller
   */
  $onInit() {
    if (super.$onInit(), this.wizardService.setSteps(this.getWizardSteps()), this.wizardService.activeStepNumber = 1, !this.editDialogParameters)
      throw new Error("No editDialogParameters coming in.");
    this.current = this.editDialogParameters.current;
  }
  /** Returns true if user can go forward in the wizard  */
  get canGoNext() {
    return !!(this.steps.length > this.step && this.steps[this.step] && !this.steps[this.step].disabled && (this.formDataValidity === !0 || this.formDataValidity === null));
  }
  /** Gets the session - currently used for company type */
  get session() {
    return this.sessionService.session;
  }
  /** Called when the type of employment changes => Sets the income earner types accordingly. */
  employmentTypeChange() {
    Ma.resetModelFromType(this.current), Ma.setSalaryDefaultRows(this.current.info.type, this.current.work);
  }
  /** Gets the cached version of the social security selection. */
  get socSec() {
    return this.uiHelpers.cache(
      this,
      "socSec",
      () => this.getSocialSecurityModel(
        this.sessionService.session?.settings,
        this.current.info.type,
        this.current.international.socialSecurity,
        this.current.info.pensionCalculation,
        this.current.info.pensionCompany,
        this.current.info.insuranceCompany,
        this.current.international.socialSecurityExceptions
      ),
      () => this.current.info.type + this.current.international.socialSecurity + this.current.info.pensionCalculation + this.current.info.pensionCompany + this.current?.info.insuranceCompany + this.current.international.socialSecurityExceptions
    );
  }
  /** Gets or sets the current country. When setting, the "foreign" address is reset. When getting Finland (fi) is converted to null. */
  get country() {
    return this.current.international.country == P0.Fi ? null : this.current.international.country;
  }
  set country(t) {
    this.current.international.country = t, this.current.contacts = (this.current.contacts || []).filter((a) => a.type != js.Foreign);
    const e = this.getContact(js.Foreign);
    e.country = t;
  }
  /**
   * Gets the social security pensions model (available options) for the current selections.
   * @param settings Account settings in the session
   * @param type Type of employment relation selected
   * @param socialSecurity Whether the person is in Finnish or foregion social security - or mixed
   * @param pensionCalculation Type of Pension calculation: employee/TyEL or others (YEL, farmer etc.)
   * @param pensionCompany Pension company (if several) that is selected.
   * @param insuranceCompany Insurance company (if several) that is selected.
   * @param socSecExceptions The selected social security exceptions (not subject to)
   */
  getSocialSecurityModel(t, e, a, n, i, r, l) {
    return Ma.getSocialSecurityModel(t, e, a, n, i, r, l);
  }
  /**
   * Called when the type of pension calculation changes
   * => Sets the PartialOwner and NoPensionRequired IncomeEarnerTypes accordingly.
   */
  pensionCalculationChange() {
    Ma.resetModelFromPensionCalculation(this.current);
  }
  /**
   * Gets the list of other employments with this personal ID.
   * First call starts the loading process and returns undefined.
   * Once response is received, the getter returns an array of employments (list items).
   * The method also initializes the taxcard (if personal ID is changed and valid).
   */
  get otherEmployments() {
    if (this.current)
      return this.checkPersonalId(), this._otherEmployments == "loading" ? void 0 : this._otherEmployments;
  }
  /**
   * Gets a description text for an employment relation
   * @param employment The employment relation to describe.
   */
  getEmploymentDescription(t) {
    return Ma.isListItem(t) ? Ma.getDescription(t.otherPartyInfo, t.data.type, t.data.pensionCalculation) : Ma.getDescription(t.personalInfo, t.info?.type, t.info?.pensionCalculation);
  }
  /**
   * Gets a descriptive text on whether the employment is active or not.
   * @param employment Employment relation to get the text for.
   * @returns A text that describes whether the employment is active or not with the dates (start and end).
   */
  getActiveText(t) {
    return Ma.getActiveText(t);
  }
  /**
   * Populates worker with test data.
   * @param useRealPersonaIdRange If true, uses the real personal id range instead of artificial ID range ("keinohetu": last 3 numbers start with 9).
   */
  populateWithTestData(t = !1) {
    Ma.populateWithTestData(this.current, t);
  }
  /**
   * Deletes a calculation row.
   * @param rowIndex - Zero based row index of the row that should be deleted.
   */
  deleteSalaryDefaultsRow(t) {
    this.current.work.salaryDefaults.splice(t);
  }
  /** Returns true if the employer is a household employer (person as opposed to company). */
  get isHousehold() {
    return this.sessionService.isInRole("person");
  }
  /** Worker wizard configuration */
  getWizardSteps() {
    const t = [
      {
        title: "SALAXY.NG1.WorkerWizardComponent.step1.title",
        view: "salaxy-components/worker/EmploymentWizard/identity.html"
      },
      {
        title: "SALAXY.NG1.WorkerWizardComponent.step2.title",
        view: "salaxy-components/worker/EmploymentWizard/person.html"
      },
      {
        title: "SALAXY.NG1.WorkerWizardComponent.step3.title",
        view: "salaxy-components/worker/EmploymentWizard/type.html"
      }
    ];
    return this.isHousehold ? t : [
      ...t,
      {
        title: "SALAXY.NG1.WorkerWizardComponent.step4.title",
        view: "salaxy-components/worker/EmploymentWizard/work.html"
      },
      {
        title: "SALAXY.NG1.WorkerWizardComponent.step5.title",
        view: "salaxy-components/worker/EmploymentWizard/tax.html"
      }
    ];
  }
  /** Saves the taxcard and closes the dialog. */
  saveAndClose(t) {
    let e = this.taxcard;
    (this.current.info.taxcard != Xa.Manual || !e.card.kind || e.card.kind === ma.Undefined || e.card.kind === ma.Auto) && (e = null), t({
      action: "ok",
      employment: this.current,
      taxcard: e
    });
  }
  /**
   * Gets the contact information of the worker. Contact of the specific type will be created if one does not exist.
   * @param type Type of contact info.
   * @returns Contact object for data binding.
   */
  getContact(t = js.Default) {
    return Ma.getContact(this.current, t, !0);
  }
  /**
   * Returns true if the current personal ID is other identifier than Finnish Personal Identification Number (keinohetu).
   */
  get isOtherIdentifier() {
    return Ma.isPersonalIdOther(this.current.identity.personalId);
  }
  checkPersonalId() {
    const t = this.current.identity.personalId;
    if (!t || !cn.isPersonalIdFi(t)) {
      (this._otherEmployments || this._otherEmploymentsLastPersonalId) && (this._otherEmploymentsLastPersonalId = void 0, this._otherEmployments = void 0);
      return;
    }
    this.taxcard?.card?.personalId !== t && (this.current.info.taxcard = Xa.Auto, this.taxcard = La.getBlank(t, ma.Auto)), this._otherEmploymentsLastPersonalId != this.current.identity.personalId && (this._otherEmploymentsLastPersonalId = this.current.identity.personalId, this._otherEmployments = "loading", this.api.getOData({ $filter: `otherPartyInfo/officialId eq '${this.current.identity.personalId}'` }).then((e) => {
      this._otherEmployments = e.items.filter((a) => a.id != this.current.id);
    }));
  }
};
hk.$inject = ["$scope", "EditDialogParameters", "WizardService", "SessionService", "UiHelpers", "Employments"];
let pw = hk;
const zy = class zy extends Ki {
  constructor(t, e) {
    super(e), this.holidayYears = t;
  }
  /** List of items */
  get list() {
    return !this.parent || !this.parent.accrual || !this.parent.accrual.months ? [] : this.parent.accrual.months;
  }
  /** Creating of a new item. */
  getBlank() {
    return {};
  }
  /**
   * Saves changes to the parent object using the CRUD API.
   */
  saveParent() {
    const t = this.uiHelpers.showLoading("SALAXY.UI_Terms.isSaving");
    this.holidayYears.save(this.parent).then((e) => {
      this.parent = e, t.dismiss();
    });
  }
  /** Template for edit UI that is shown in a modal dialog. */
  getEditDialogTemplateUrl() {
    return "salaxy-components/worker/holidays/HolidayYearAbsencesEditDialog.html";
  }
  /** Chart config for accrual overview. */
  getChartConfig(t) {
    return this.uiHelpers.cache(this, "accrualChart", () => this.createConfig(t));
  }
  createConfig(t) {
    const e = [[], []], a = [];
    let i = this.parent.accrual.startSaldo;
    for (const r of t) {
      i += r.daysAccrued;
      const l = I.startEnd("today", "start-month");
      e[0].push(r.month <= l ? i : null), e[1].push(r.month >= l ? i : null), a.push(L.get(`SALAXY.ENUM.CalendarMonth.month${I.getMonth(r.month)}.short`));
    }
    return {
      type: "line",
      data: {
        labels: a,
        datasets: [
          {
            label: L.get("SALAXY.NG1.HolidayYearAccrualComponent.accumulated"),
            data: [
              ...e[0]
            ],
            borderColor: "rgb(159,192,209)",
            fill: {
              target: "origin",
              above: "rgb(234,241,245, 0.5)"
            },
            elements: {
              point: {
                backgroundColor: "rgb(234,241,245)"
              }
            }
          },
          {
            label: L.get("SALAXY.NG1.HolidayYearAccrualComponent.futureEstimate"),
            data: [
              ...e[1]
            ],
            fill: {
              target: "origin",
              above: "rgb(248,248,248, 0.5)"
            },
            elements: {
              point: {
                backgroundColor: "rgb(248,248,248)"
              }
            }
          }
        ]
      },
      options: {
        scales: {
          y: {
            ticks: {
              beginAtZero: !0
            }
          }
        },
        plugins: {
          legend: {
            display: !1
          }
        }
      }
    };
  }
  /** Gets the color for the row avatar */
  getRowColor(t) {
    return t === "start" || t === "total" ? oc.getBrandColor("primary") : t.month > this.getThisMonth() ? "#ddd" : t.month === this.getThisMonth() ? oc.getBrandColor("danger") : oc.getBrandColor("primary");
  }
  /** Gets this month: The first date of this month */
  getThisMonth() {
    return I.getToday().substr(0, 8) + "01";
  }
  /**
   * Returns the notes if available or, if not, description text based on the source.
   */
  getAccrualNotes(t) {
    if (t.notes)
      return t.notes;
    switch (t.source) {
      case th.Manual:
        return L.get("SALAXY.NG1.HolidayYearAccrualComponent.holidayAccrualSource.manual");
      case th.CalcDraft:
        return L.get("SALAXY.NG1.HolidayYearAccrualComponent.holidayAccrualSource.calcDraft");
      case th.CalcPaid:
        return L.get("SALAXY.NG1.HolidayYearAccrualComponent.holidayAccrualSource.calcPaid");
      case th.Initial:
      default:
        return t.month === this.getThisMonth() ? L.get("SALAXY.NG1.HolidayYearAccrualComponent.holidayAccrualSource.defaultThisMonth") : t.month > this.getThisMonth() ? L.get("SALAXY.NG1.HolidayYearAccrualComponent.holidayAccrualSource.defaultEstimate") : L.get("SALAXY.NG1.HolidayYearAccrualComponent.holidayAccrualSource.default");
    }
  }
  /** Gets calculations related to holiday accruals */
  getAccrualCalculations() {
    const t = this.parent.accrual.startSaldo, e = {
      accrual: ie.sum(this.list, (a) => a.daysAccrued),
      accrualToday: ie.sum(this.list.filter((a) => a.month < I.getToday()), (a) => a.daysAccrued),
      total: 0,
      totalToday: 0
    };
    return e.total = e.accrual + t, e.totalToday = e.accrualToday + t, e;
  }
};
zy.bindings = new $r(), zy.$inject = [
  "HolidayYears",
  "UiHelpers"
];
let Iu = zy;
const mk = class mk extends nn {
  constructor(t, e, a, n, i) {
    super(t, e, a, n), this.fullApi = t, this.uiCrudHelpers = i, this.viewType = "overview", this.employmentHolidayYears = [], this.isAccrualView = !1, this.mapToCalendar = (r) => r.map((l) => ({
      key: l.id,
      title: l.workerSnapshot.displayName,
      description: `${L.get("SALAXY.NG1.HolidayYearComponent.planned")} ${this.getTotalDays("all", l)}${L.get("SALAXY.NG1.HolidayYearComponent.date")}, ${L.get("SALAXY.NG1.HolidayYearComponent.accumulation")} ${l.accrual.endSaldo}`,
      avatar: l.workerSnapshot,
      data: l,
      events: l.leaves.planned.map((o) => ({
        start: o.period.start,
        end: o.period.end,
        summary: o.notes || `${L.get("SALAXY.NG1.HolidayYearComponent.holiday")} ${o.period.daysCount} ${L.get("SALAXY.NG1.HolidayYearComponent.days")}`,
        data: o
      }))
    }));
  }
  /** Controller initialization */
  $onInit() {
    this.forDate = this.forDate || I.getToday();
    const t = I.getYear(this.forDate);
    this.reportParams = {
      today: this.forDate,
      years: Array.from({ length: 5 }, (e, a) => t + 1 - a)
    }, this.reportView, super.$onInit();
  }
  /** Implements the getDefaults of ApiCrudObjectController */
  getDefaults() {
    return {
      listUrl: this.listUrl || "/workers",
      detailsUrl: this.detailsUrl || "/workers/details/",
      oDataTemplateUrl: "salaxy-components/odata/lists/Holidays.html",
      oDataOptions: {}
    };
  }
  /**
   * Sets the employment ID and if it is different then starts the loading of the Absences object to that employment ID.
   */
  set employmentId(t) {
    if (this._employmentId !== t) {
      if (this.employmentHolidayYears = [], !t) {
        this._employmentId && (this._employmentId = null, this.model = null, this.reload());
        return;
      }
      this._employmentId = t, this.fullApi.getForEmployment(t).then((e) => {
        this.employmentHolidayYears = e, this.setYear();
      });
    }
  }
  /** Gets the employment ID */
  get employmentId() {
    return this._employmentId;
  }
  /** Initializes the holidays for the current Worker */
  initHolidays(t) {
    const e = this.uiHelpers.showLoading(L.get("SALAXY.NG1.HolidayYearComponent.dialog.creatingYearHolidays"));
    this.fullApi.initForEmployment(this.employmentId, t).then((a) => {
      this.employmentHolidayYears = a, this.setYear(), e.dismiss();
    });
  }
  /**
   * Gets the holiday logic for the given specification.
   * @param spec The specification for which the logic is calculated.
   * @returns The logic object that can be used in the UI.
   */
  getHolidayLogic(t) {
    const e = {
      /** If true, has holiday years => A warning for overwrite should be shown. */
      hasData: !!this.current,
      /** True if the accrual is based on law. Ui binds to this. */
      accrualByLaw: !t.accrualFixed,
      /**
       * Sets the accrualFixed value based on accrualByLaw value
       * @param itemData The data that is being edited (current in view)
       */
      accrualByLawChanged: (a) => {
        a.accrualFixed = e.accrualByLaw ? null : a.code === Se.TemporaryTimeOff ? 2 : 2.5;
      },
      /**
       * Sets the accrualByLaw value based on accrualFixed value
       * @param itemData The data that is being edited (current in view)
       */
      accrualFixedChanged: (a) => {
        a.accrualFixed || (a.accrualFixed = null, e.accrualByLaw = !0);
      },
      /**
       * Business logic for field visibility
       * @param itemData The data that is being edited (current in view)
       * @param field Name of the field for which the visibility is calculated.
       */
      getVisibility: (a, n) => {
        switch (n) {
          case "accruesHolidays":
          case "startSaldo":
          case "bonusMethod":
            return a.code === Se.Permanent14Days || a.code === Se.Permanent35Hours || a.code === Se.TemporaryTimeOff || a.code === Se.Other;
          case "accrualFixed":
            return a.code === Se.Permanent14Days || a.code === Se.Permanent35Hours || a.code === Se.TemporaryTimeOff;
          case "compensation":
            return a.code === Se.HolidayCompensation || a.code === Se.HolidayCompensationIncluded;
          case "bonusPercent":
            return a.code === Se.Permanent14Days || a.code === Se.Permanent35Hours || a.code === Se.TemporaryTimeOff || a.code === Se.Other || a.code === Se.HolidayCompensation || a.code === Se.HolidayCompensationIncluded;
          default:
            return !0;
        }
      },
      getholidayPayCalculationOptions: (a) => this.uiHelpers.cache(this, "holidayPayCalculationOptions", () => {
        switch (a?.code) {
          case Se.Permanent14Days:
            return a.wageBasis === qs.Monthly ? [
              { text: L.get("SALAXY.ENUM.HolidayPayCalculation.normalMonthlyPay.label"), value: Be.NormalMonthlyPay },
              { text: L.get("SALAXY.ENUM.HolidayPayCalculation.otherPay.label"), value: Be.OtherPay }
            ] : [
              { text: L.get("SALAXY.ENUM.HolidayPayCalculation.averageHourlyPay.label"), value: Be.AverageHourlyPay },
              { text: L.get("SALAXY.ENUM.HolidayPayCalculation.averageDailyPay.label"), value: Be.AverageDailyPay },
              { text: L.get("SALAXY.ENUM.HolidayPayCalculation.otherPay.label"), value: Be.OtherPay }
            ];
          case Se.Permanent35Hours:
            return a.wageBasis === qs.Monthly ? [
              { text: L.get("SALAXY.ENUM.HolidayPayCalculation.normalMonthlyPay.label"), value: Be.NormalMonthlyPay },
              { text: L.get("SALAXY.ENUM.HolidayPayCalculation.percentageBasedPay.label"), value: Be.PercentageBasedPay },
              { text: L.get("SALAXY.ENUM.HolidayPayCalculation.otherPay.label"), value: Be.OtherPay }
            ] : [
              { text: L.get("SALAXY.ENUM.HolidayPayCalculation.percentageBasedPay.label"), value: Be.PercentageBasedPay },
              { text: L.get("SALAXY.ENUM.HolidayPayCalculation.otherPay.label"), value: Be.OtherPay }
            ];
          case Se.TemporaryTimeOff:
            return [
              { text: L.get("SALAXY.ENUM.HolidayPayCalculation.holidayCompensation.label"), value: Be.HolidayCompensation },
              { text: L.get("SALAXY.ENUM.HolidayPayCalculation.otherPay.label"), value: Be.OtherPay }
            ];
          case Se.Other:
            return a.wageBasis === qs.Monthly ? [
              { text: L.get("SALAXY.ENUM.HolidayPayCalculation.normalMonthlyPay.label"), value: Be.NormalMonthlyPay },
              { text: L.get("SALAXY.ENUM.HolidayPayCalculation.percentageBasedPay.label"), value: Be.PercentageBasedPay },
              { text: L.get("SALAXY.ENUM.HolidayPayCalculation.holidayCompensation.label"), value: Be.HolidayCompensation },
              { text: L.get("SALAXY.ENUM.HolidayPayCalculation.otherPay.label"), value: Be.OtherPay }
            ] : [
              { text: L.get("SALAXY.ENUM.HolidayPayCalculation.averageHourlyPay.label"), value: Be.AverageHourlyPay },
              { text: L.get("SALAXY.ENUM.HolidayPayCalculation.averageDailyPay.label"), value: Be.AverageDailyPay },
              { text: L.get("SALAXY.ENUM.HolidayPayCalculation.percentageBasedPay.label"), value: Be.PercentageBasedPay },
              { text: L.get("SALAXY.ENUM.HolidayPayCalculation.holidayCompensation.label"), value: Be.HolidayCompensation },
              { text: L.get("SALAXY.ENUM.HolidayPayCalculation.otherPay.label"), value: Be.OtherPay }
            ];
          default:
            return [];
        }
      })
    };
    return e;
  }
  /** Shows the Init holidays dialog for initializing the holiday years for the given worker */
  showInitHolidays() {
    if (!this.employmentId)
      throw Error("Employment ID not defined in showInitHolidays().");
    const t = this.uiHelpers.showLoading(L.get("SALAXY.NG1.HolidayYearComponent.dialog.loadingDefaults"));
    this.fullApi.getDefaultSpecForEmployment(this.employmentId).then((e) => {
      t.dismiss();
      const a = this.getHolidayLogic(e);
      this.uiHelpers.openEditDialog("salaxy-components/worker/holidays/WorkerHolidaysInitDialog.html", e, a, "lg").then((n) => {
        n.action === "ok" && this.initHolidays(n.item);
      });
    });
  }
  /** Gets the visualisation data for the selected holiday year. */
  getYearVisualisation() {
    return this.current ? ((!this.visualizationCache || this.visualizationCache.year !== this.current.year || this.visualizationCache.employmentId !== this.current.employmentId) && (this.visualizationCache = dn.getYearVisualisation(this.current)), this.visualizationCache) : null;
  }
  /** Gets a total days calculation for different types. */
  getTotalDays(t = "all", e = null) {
    return e = e || this.current, dn.getPlannedLeavesCount(e, t);
  }
  /**
   * Gets items visibility based on properties of the selected holiday year.
   * @param elements Logical name of group of items in teh view.
   */
  getVisibility(t) {
    const e = this.current.spec.code;
    switch (t) {
      case "accrual":
        return e === Se.Permanent14Days || e === Se.Permanent35Hours || e === Se.TemporaryTimeOff || e === Se.Other;
      case "hourly":
        return this.current.spec.wageBasis === qs.Hourly || this.current.spec.wageBasis === qs.PerformanceBased;
      case "compensation":
        return e === Se.HolidayCompensation || e === Se.HolidayCompensationIncluded;
      default:
        return !0;
    }
  }
  /** For the reporting purposes, gets or sets the holiday year as year number. */
  get reportYear() {
    if (!this.reportParams._year) {
      let t = I.getYear(this.reportParams.today || "today");
      I.getMonth(this.reportParams.today || "today") < 3 && t--, this.reportYear = t;
    }
    return this.reportParams._year;
  }
  set reportYear(t) {
    t = Math.round(Number(t)), !(!t || t < 2018 || t > 2100) && (this.reportParams._year = t, this.reportView !== "otherPeriod" ? (this.reportParams.yearStart = t + "-01-01", this.reportParams.yearEnd = t + 1 + "-04-30") : (this.reportParams.yearStart = t + "-05-01", this.reportParams.yearEnd = t + 1 + "-04-30"));
  }
  /**
   * Gets or sets the report view that is currently shown.
   */
  get reportView() {
    if (!this.reportParams._view) {
      const t = I.getMonth(this.reportParams.today || "today"), e = I.getYear(this.reportParams.today || "today");
      e === this.reportYear ? t < 10 ? this.reportView = "summerPeriod" : this.reportView = "winterPeriod" : e - 1 === this.reportYear ? t < 4 ? this.reportView = "winterPeriod" : this.reportView = "list" : this.reportView = "list";
    }
    return this.reportParams._view;
  }
  set reportView(t) {
    switch (this.reportParams._view = t, t) {
      case "summerPeriod":
        this.reportParams.start = this.reportYear + "-05-01", this.reportParams.end = this.reportYear + "-09-30";
        break;
      case "winterPeriod":
        this.reportParams.start = this.reportYear + "-10-01", this.reportParams.end = this.reportYear + 1 + "-04-30";
        break;
      case "otherPeriod":
        this.reportParams.start = this.reportYear + "-01-01", this.reportParams.end = this.reportYear + 1 + "-04-30";
        break;
      default:
        this.reportParams.start = this.reportParams.yearStart, this.reportParams.end = this.reportParams.yearEnd;
    }
  }
  /**
   * Returns missing holiday year.
   */
  get missingHolidayYear() {
    if (!this.employmentHolidayYears || this.employmentHolidayYears.length == 0)
      return null;
    const t = I.getToday(), e = 1 + (I.getMonth(t) > 3 ? I.getYear(t) : I.getYear(t) - 1);
    return this.employmentHolidayYears.find((a) => a.year == e) ? null : e;
  }
  /**
   * Saves a holiday year based on calendar input and updates the value in allYears property.
   */
  saveYear(t) {
    const e = this.uiHelpers.showLoading(`${L.get("SALAXY.NG1.HolidayYearComponent.dialog.saving")}...`);
    return this.api.save(t).then((a) => {
      wt.copy(a, t), e.dismiss();
    });
  }
  /**
   * Show an edit dialog for the holiday year.
   * @param year The holiday year to update.
   */
  showEditDialog(t) {
    this.uiCrudHelpers.openEditEmploymentDialog(t.employmentId, "default", "holidays").then((e) => {
      e.action === "ok" && this.getHolidayYears(!0);
    });
  }
  /**
   * Shows worker selection dialog and after that opens selected workers employment dialog.
   */
  showAddWorker() {
    const t = [];
    this.uiHelpers.openEditDialog(
      "salaxy-components/modals/calc/WorkerSelect.html",
      t,
      {
        title: "SALAXY.NG1.PayrollComponent.validate.addWorker"
      }
    ).then((e) => {
      e.action === "ok" && e.item.length == 1 && this.uiCrudHelpers.openEditEmploymentDialog(e.item[0].id, "default", "holidays").then((a) => {
        a.action === "ok" && this.getHolidayYears(!0);
      });
    });
  }
  /**
   * Gets the full holiday years for all Workers for reporting purposes
   * @param keepView If true, does not reset the view based on the incoming data.
   * If true, you should make sure the year does not change because then view will be invalid for the year
   * I.e. should be true only for reload scenarios.
   */
  getHolidayYears(t = !1) {
    this.fullApi.getForYear(this.reportYear).then((e) => {
      this.allYears = e, t || (this.reportParams._view = null, this.reportView);
    });
  }
  /**
   * Returns true, if two objects are different.
   * @param obj1 First object to compare
   * @param obj2 Second object to compare
   */
  isChanged(t, e) {
    return !wt.equals(t, e);
  }
  /**
   * Sets the view type for the holiday year.
   * @param isAccrualView  If true, the view is set to this.currentYear +1, otherwise to this.currentYear.
   */
  setAccrualView(t) {
    this.isAccrualView = t;
  }
  /**
   * Sets the correct holiday year for the view based on the current date.
   * This is for planning/consuming holidays.
   */
  setYear() {
    const t = this.forDate, e = t > I.getDate(I.getYear(t), 4, 30) ? I.getYear(t) : I.getYear(t) - 1;
    this.model = this.employmentHolidayYears.find((a) => a.year === e) || this.employmentHolidayYears[0];
  }
};
mk.$inject = [
  "HolidayYears",
  "UiHelpers",
  "$location",
  "$routeParams",
  "UiCrudHelpers"
];
let gy = mk;
class P6 extends $r {
  constructor() {
    super(...arguments), this.condensed = "<", this.filterStart = "<", this.filterEnd = "<";
  }
}
const By = class By extends Ki {
  constructor(t) {
    super(t), this.filter = (e) => !(this.filterEnd && e.period.start > this.filterEnd || this.filterStart && e.period.end < this.filterStart);
  }
  /** List of items */
  get list() {
    return !this.parent || !this.parent.leaves || !this.parent.leaves.planned ? [] : this.parent.leaves.planned;
  }
  /** Creating of a new item. */
  getBlank() {
    return {
      period: {
        start: I.getToday(),
        end: I.getToday(),
        daysCount: 1
      }
    };
  }
  /** Template for edit UI that is shown in a modal dialog. */
  getEditDialogTemplateUrl() {
    return "salaxy-components/worker/holidays/HolidayYearHolidaysEditDialog.html";
  }
  /** Logic for edit dialog. */
  getEditDialogLogic() {
    return {
      /** Updates the workdays count */
      updatePeriodDays: (t) => {
        t.period.start > t.period.end && (t.period.end = t.period.start), t.period.start && t.period.end && (t.period.days ? (t.period.days = I.getVacationDays(t.period.start, t.period.end), t.period.daysCount = t.period.days.length) : t.period.daysCount = I.getVacationDays(t.period.start, t.period.end).length);
      },
      /** Sets the days array in period to enable days selection UI. */
      setDaysSelection: (t) => {
        t.period.days = I.getVacationDays(t.period.start, t.period.end), t.period.daysCount = t.period.days.length;
      },
      /**
       * For example, when parent year is 2024:
       * - minDate is 2024-01-01
       * - maxDate is 2025-04-30
       */
      minDate: I.getDate(this.parent.year, 1, 1),
      maxDate: I.getDate(this.parent.year + 1, 4, 30)
    };
  }
  /**
   * Shows the edit dialog.
   * @param item Annual leave to edit or string "new" for creating a new one.
   * @param isNew Optional way of specifying that the item is a new item (with default values, not yet added to the list).
   * If item is string "new", this parameter will have no effect (will always be true).
   */
  showEditDialog(t, e = !1) {
    if (!t)
      throw new Error("showEditDialog called without a parameter.");
    t === "new" && (e = !0, t = this.getBlank());
    const a = (n) => {
      n.action === "ok" || n.action === "ok-no-save" ? (e && this.list.push(n.item), (e || n.hasChanges) && n.action !== "ok-no-save" && this.commit()) : (n.action === "delete" || n.action === "delete-no-save") && (e || (this.delete(t), n.action !== "delete-no-save" && this.commit()));
    };
    this.uiHelpers.openEditDialog(this.getEditDialogTemplateUrl(), t, this.getEditDialogLogic()).then((n) => {
      (n.action === "ok" || n.action === "ok-no-save") && n.item.period.start >= I.getDate(this.parent.year, 1, 1) && n.item.period.end <= I.getDate(this.parent.year, 4, 30) ? this.uiHelpers.showConfirm("SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidaysEditDialog.dialogHeading", "SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidaysEditDialog.dialogText").then((i) => {
        i && a(n);
      }) : a(n);
    });
  }
  /** Gets the description text for the planned holiday. */
  getDescription(t) {
    return t.notes ? t.notes : t.period.start < `${this.parent.year}-10-1` ? "Kesäloma" : "Talviloma";
  }
  /** Gets a total days calculation for different types. */
  getTotalDays(t = "all") {
    return t === "filtered" ? ie.sum(this.list.filter((e) => this.filter(e)), (e) => e.period.daysCount) : this.parent ? dn.getPlannedLeavesCount(this.parent, t) : null;
  }
};
By.bindings = new P6(), By.$inject = ["UiHelpers"];
let Pu = By;
const Wy = class Wy extends Ki {
  constructor(t, e) {
    super(t), this.reports = e;
  }
  /** Gets the worker ID for the current holiday year. */
  get workerId() {
    return !this.parent || !this.parent.workerSnapshot ? null : this.parent.workerSnapshot.id;
  }
  /** Gets the employment ID for the current holiday year. */
  get employmentId() {
    return !this.parent || !this.parent.workerSnapshot ? null : this.parent.employmentId;
  }
  /**
   * List of items fetched from the holiday year,
   * cached to the controller level, except when workerId changes.
   */
  get list() {
    return !this.parent || !this.parent.leaves || !this.parent.leaves.paid ? [] : this.getLeavesPaid();
  }
  /**
   * Returns true if the bonus should be paid for the employee.
   */
  get shoudPayBonus() {
    return this.parent?.spec ? (this.parent.spec.code === Se.Permanent14Days || this.parent.spec.code === Se.Permanent35Hours || this.parent.spec.code === Se.TemporaryTimeOff || this.parent.spec.code === Se.Other) && this.parent.spec.bonusMethod !== Yh.None : !1;
  }
  /**
   * List of paid holidays.
   */
  getLeavesPaid() {
    for (const t of this.parent.leaves.paid)
      t.avatar ?? (t.avatar = {}), t.holidayBonus > 0 && !(t.holidaySalary > 0 || t.holidayCompensation > 0) ? wt.copy(dn.getPaidBonusAvatar("row", t), t.avatar) : wt.copy(dn.getPaidCalculationAvatar("row", t), t.avatar);
    return this.totals ?? (this.totals = {}), this.totals.startSaldo = this.copyAnnualLeavePayment(dn.getPaidHolidaysCalculation(this.parent, "startSaldo"), this.totals.startSaldo), this.totals.total = this.copyAnnualLeavePayment(dn.getPaidHolidaysCalculation(this.parent, "total"), this.totals.total), this.totals.endSaldo = this.copyAnnualLeavePayment(dn.getPaidHolidaysCalculation(this.parent, "endSaldo"), this.totals.endSaldo), this.bonusTotals ?? (this.bonusTotals = {}), this.bonusTotals.startSaldo = this.copyAnnualLeavePayment(dn.getPaidBonusCalculation(this.parent, "startSaldo"), this.bonusTotals.startSaldo), this.bonusTotals.total = this.copyAnnualLeavePayment(dn.getPaidBonusCalculation(this.parent, "total"), this.bonusTotals.total), this.bonusTotals.endSaldo = this.copyAnnualLeavePayment(dn.getPaidBonusCalculation(this.parent, "endSaldo"), this.bonusTotals.endSaldo), this.parent.leaves.paid;
  }
  copyAnnualLeavePayment(t, e) {
    return e ?? (e = {}), e.avatar ?? (e.avatar = {}), wt.copy(t.avatar, e.avatar), e.holidayBonus = t.holidayBonus, e.holidayCompensation = t.holidayCompensation, e.holidayDays = t.holidayDays, e.holidaySalary = t.holidaySalary, e;
  }
  /** Creating of a new item. */
  getBlank() {
    return {
      kind: aX.Undefined,
      avatar: {
        displayName: "Käsin syötetty korjaus",
        description: null,
        color: "rgb(74, 146, 233)",
        initials: "edit",
        entityType: Xi.Company
      },
      date: I.getToday(),
      period: I.getDateRange(I.getToday(), I.getToday()),
      holidayBonus: null,
      holidayCompensation: null,
      holidayDays: null,
      holidaySalary: null
    };
  }
  /** Gets calculations preview pdf url based on given id */
  getPdfUrl(t) {
    return this.reports.getPdfUrlForCalc("salarySlip", t, !0);
  }
  /** Logic for edit dialog. */
  getEditDialogLogic() {
    return {
      /** Updates the workdays count */
      updatePeriodDays: (t) => {
        t.period.start > t.period.end && (t.period.end = t.period.start), t.period.start && t.period.end && (t.period.days ? (t.period.days = I.getVacationDays(t.period.start, t.period.end), t.period.daysCount = t.period.days.length) : t.period.daysCount = I.getVacationDays(t.period.start, t.period.end).length, t.holidayDays = t.period.daysCount);
      },
      updateDaysCount: (t) => {
        t.period.daysCount = t.holidayDays;
      },
      getPdfUrl: (t) => this.getPdfUrl(t)
    };
  }
  /** Template for edit UI that is shown in a modal dialog. */
  getEditDialogTemplateUrl() {
    return "salaxy-components/worker/holidays/HolidayYearPaidEditDialog.html";
  }
};
Wy.bindings = new $r(), Wy.$inject = [
  "UiHelpers",
  "ReportsService"
];
let Eu = Wy;
const gk = class gk {
  /** Creates a new MyTaxcardsController */
  constructor(t, e, a) {
    this.taxcards = t, this.uiCrudHelpers = e, this.uiHelpers = a, this.$onInit = () => {
      this.reload();
    };
  }
  /** Reloads the data from the server. */
  reload() {
    this.current = null, this.taxcards.getMyTaxcards().then((t) => {
      this.current = t, this.current?.active && (this.currentTab = "calcs");
    });
  }
  /**
   * Removes a taxcard from the list and does a refresh.
   * @param id Taxcard id.
   */
  deleteTaxCard(t) {
    this.taxcards.delete(t).then(() => {
      this.reload();
    });
  }
  /**
   * Sets the users automatic shared taxcard as ON or if already set refreshes the taxcard from tax authorities.
   */
  setSharedAutoForSelf() {
    if (this.current.active?.card.kind === ma.Auto)
      this.uiCrudHelpers.refreshAutoTaxcard(this.current.active.id).then((t) => {
        this.reload();
      });
    else {
      const t = this.uiHelpers.showLoading("SALAXY.NG1.WorkerDetailsComponent.taxCard.setSharedAutoForSelf.loadingTitle", "SALAXY.NG1.WorkerDetailsComponent.taxCard.setSharedAutoForSelf.loadingText");
      this.taxcards.setAuto(this.current.personalId).then((e) => {
        e == null ? (t.dismiss(), this.uiHelpers.showAlert("SALAXY.NG1.WorkerDetailsComponent.taxCard.setSharedAutoForSelf.alertTitle", "SALAXY.NG1.WorkerDetailsComponent.taxCard.setSharedAutoForSelf.alertTextAutoCard")) : (this.reload(), t.dismiss());
      });
    }
  }
  /**
   * Gets the chart type that should be shown.
   */
  get chartType() {
    return this.current ? this.current.active.card.incomeLimit ? "full" : "pie" : "none";
  }
  /**
   * Gets main chart configuration for <salaxy-chart>
   * @param taxcard current taxcard
   */
  getMainChartConfig(t) {
    return this.uiHelpers.cache(
      this,
      "mainChartConfig",
      () => La.getMainChartV2(t),
      () => La.getIncomeLimitInfo(t)
    );
  }
  /**
   * Gets pie chart configuration for <salaxy-chart>
   * @param taxcard current taxcard
   */
  getPieChartConfig(t) {
    return this.uiHelpers.cache(
      this,
      "pieChartConfig",
      () => La.getPieChartDataV2(t),
      () => La.getIncomeLimitInfo(t)
    );
  }
};
gk.$inject = ["Taxcards", "UiCrudHelpers", "UiHelpers"];
let hw = gk;
const yk = class yk {
  constructor(t) {
    this.sessionService = t, this.today = I.getToday(), this.showToday = !1, this.addNewUi = {
      /** If true, shown the 1st tax percent */
      showTaxPercent: !1,
      /** If true, shown the income limit AND 2nd tax pecent. */
      showIncomeLimit: !1,
      /** If true, the require the income limit AND 2nd tax percent (default yearly). */
      requireIncomeLimit: !1,
      /** If true, shows input for previous salaries paid. */
      showPreviousSalariesPaid: !1,
      /** If true, the tax percents etc. cannot be edited (no taxcard household or 60%).*/
      readonly: !1,
      /** Options for the start date: currently min and max dates. */
      startDateOptions: null,
      /**
       * Years that are allowed in the year selection:
       * Current year + next year in December, previous year in January.
       */
      yearsAllowed: null
    }, this.taxcardKindOptions = {
      defaultYearly: "SALAXY.NG1.CurrentTaxCardComponent.taxcardKindOptions.defaultYearly",
      replacement: "SALAXY.NG1.CurrentTaxCardComponent.taxcardKindOptions.replacement",
      noTaxCard: "SALAXY.NG1.CurrentTaxCardComponent.taxcardKindOptions.noTaxCard",
      // This is removed from company role in init (only for household employers).
      noWithholdingHousehold: "SALAXY.NG1.CurrentTaxCardComponent.taxcardKindOptions.noWithholdingHousehold"
    };
  }
  /**
   * Implement IController
   */
  $onInit() {
    this.sessionService.isInRole("company") && delete this.taxcardKindOptions.noWithholdingHousehold;
  }
  /** Returns true if one of the edit forms is shown ad if it is valid. */
  get isFormValid() {
    return this.editForm?.$valid && (this.current?.card?.kind || "undefined") != "undefined";
  }
  /**
   * Gets a row for data binding of external salaries paid outside Salaxy system.
   * Will create the row if it does not exist. The save method will remove any empty rows.
   */
  get previousSalariesRow() {
    return this.current ? (this.current.incomeLog || (this.current.incomeLog = []), this.current.incomeLog.find((t) => t.type === jr.ExternalSalaries) || this.current.incomeLog.push({
      type: jr.ExternalSalaries,
      id: null,
      description: L.get("SALAXY.NG1.CurrentTaxCardComponent.previousSalariesRow"),
      startDate: this.today,
      endDate: this.today,
      income: null,
      tax: null
    }), this.current.incomeLog.find((t) => t.type === jr.ExternalSalaries)) : null;
  }
  /**
   * Resets the current taxcard as new (when the kind changes).
   * @param kind If specified, reset the taxcard to the given type.
   */
  resetAsNew(t) {
    this.setCurrent(La.getBlank(this.current.card.personalId, t, null, this.today)), this.updateUISettings();
  }
  /** Handles change of the year in the years dropdown. */
  yearChanged() {
    this.setCurrent(La.getBlank(this.current.card.personalId, this.current.card.kind, this.current.card.forYear, this.today)), this.updateUISettings();
  }
  /** Sets the current item value keeping the original reference. */
  setCurrent(t) {
    wt.copy(t, this.current), this.updateUISettings();
  }
  /** Defines which fields to show/hide, require etc. in the view */
  updateUISettings() {
    const t = {
      showTaxPercent: !1,
      showIncomeLimit: !1,
      requireIncomeLimit: !1,
      showPreviousSalariesPaid: !1,
      readonly: !1,
      startDateOptions: null,
      yearsAllowed: null
    };
    if (!this.current) {
      this.addNewUi = t;
      return;
    }
    const e = I.getYear(this.today), a = I.getMonth(this.today);
    let n;
    a === 1 ? n = [e, e - 1] : a === 12 ? n = [e, e + 1] : n = [e], n.indexOf(this.current.card.forYear) < 0 && (this.current.id || (this.current.card.forYear = e));
    const i = this.current.card.forYear;
    switch (n = n.length < 2 ? null : n, t.showTaxPercent = !0, this.current.card.kind) {
      case ma.Auto:
        t.showTaxPercent = !1;
        break;
      case ma.NoTaxCard:
      case ma.NoWithholdingHousehold:
        t.readonly = !0;
        break;
      case ma.Undefined:
        t.readonly = !0, t.showTaxPercent = !1;
        break;
      case ma.DefaultYearly:
        t.showIncomeLimit = !0, t.showPreviousSalariesPaid = !0, t.requireIncomeLimit = !0, t.yearsAllowed = n;
        break;
      case ma.Replacement:
        t.showIncomeLimit = !0, t.showPreviousSalariesPaid = !0, t.yearsAllowed = n, t.startDateOptions = {
          minDate: I.asJSDate(i + "-01-01"),
          maxDate: I.asJSDate(i + "-11-31")
        };
        break;
    }
    this.addNewUi = t;
  }
};
yk.$inject = ["SessionService"];
let yy = yk;
const fk = class fk extends nn {
  constructor(t, e, a, n, i, r, l, o) {
    super(t, e, n, i), this.fullApi = t, this.uiCrudHelpers = a, this.uploadService = r, this.sessionService = l, this.$timeout = o, this.uploadProgress = null, this.today = I.getToday(), this.employmentRelationTaxcardType = Xa.Auto, this.loaders = {}, this.currentChartConfig = {}, this.taxcardKindOptions = {
      auto: "SALAXY.NG1.CurrentTaxCardComponent.taxcardKindOptions.auto",
      defaultYearly: "SALAXY.NG1.CurrentTaxCardComponent.taxcardKindOptions.defaultYearly",
      replacement: "SALAXY.NG1.CurrentTaxCardComponent.taxcardKindOptions.replacement",
      noTaxCard: "SALAXY.NG1.CurrentTaxCardComponent.taxcardKindOptions.noTaxCard",
      noWithholdingHousehold: "SALAXY.NG1.CurrentTaxCardComponent.taxcardKindOptions.noWithholdingHousehold"
    }, this.taxcardKindOptionsV2 = {
      defaultYearly: "SALAXY.NG1.CurrentTaxCardComponent.taxcardKindOptions.defaultYearly",
      replacement: "SALAXY.NG1.CurrentTaxCardComponent.taxcardKindOptions.replacement",
      noTaxCard: "SALAXY.NG1.CurrentTaxCardComponent.taxcardKindOptions.noTaxCard",
      noWithholdingHousehold: "SALAXY.NG1.CurrentTaxCardComponent.taxcardKindOptions.noWithholdingHousehold"
    };
  }
  /**
   * Implement IController
   */
  $onInit() {
    this.mode = this.mode || "default", this.sessionService.isInRole("worker") && (this.isSelf = !0), this.sessionService.isInRole("company") && (delete this.taxcardKindOptions.noWithholdingHousehold, delete this.taxcardKindOptionsV2.noWithholdingHousehold), this.sessionService.isInRole("person") ? this.current?.card.kind === ma.Undefined && (this.current.card.kind = ma.Auto) : this.current?.card.kind === ma.Undefined && (this.current.card.kind = ma.Auto), super.$onInit();
  }
  /**
   * Either a valid Finnish Personal ID or "self" for the current Worker account.
   * Required for creating a new taxcard: The personal ID is used for setting the connection to Worker account or self.
   * The personal id is used when binding is null (buttons for create new) or "new" (actual new UI).
   */
  get personalId() {
    return this._personalId;
  }
  set personalId(t) {
    if (!t) {
      this._personalId = null;
      return;
    }
    if (t === "self") {
      if (!this.sessionService.isInRole("worker"))
        throw new Error("Cannot bind taxcard to 'self' for Account that is not a Worker.");
      this._personalId = this.sessionService.getCurrentAccount().identity.officialId, this.isSelf = !0;
    } else
      this._personalId = t, this.sessionService.getCurrentAccount().identity.officialId === t && (this.isSelf = !0);
    t && this.bindingMode === "new" && this.reload();
  }
  /** Returns true if one of the edit forms is shown ad if it is valid. */
  get isFormValid() {
    return this.editForm && this.editForm.$valid;
  }
  /**
   * Gets the chart type that should be shown.
   * Type "preview" means no chart: Only show the preview image of the card.
   */
  get chartType() {
    return this.current ? this.current.card.incomeLimit ? "full" : "pie" : "none";
  }
  /**
   * Gets a row for data binding of external salaries paid outside Salaxy system.
   * Will create the row if it does not exist. The save method will remove any empty rows.
   */
  get previousSalariesRow() {
    return this.current ? (this.current.incomeLog || (this.current.incomeLog = []), this.current.incomeLog.find((t) => t.type === jr.ExternalSalaries) || this.current.incomeLog.push({
      type: jr.ExternalSalaries,
      id: null,
      description: L.get("SALAXY.NG1.CurrentTaxCardComponent.previousSalariesRow"),
      startDate: this.today,
      endDate: this.today,
      income: null,
      tax: null
    }), this.current.incomeLog.find((t) => t.type === jr.ExternalSalaries)) : null;
  }
  /**
   * Starts the reload process depending on the bindingMode:
   */
  reload() {
    return this.bindingMode === "new" ? (this.setCurrentRef(La.getBlank(this.personalId)), this._currentId = null, this.setStatus(null), this.updateUISettings(), Promise.resolve(this.current)) : super.reload().then((t) => (this.$timeout(() => {
      this.updateUISettings();
    }), t));
  }
  /** Gets the user interface mode: The UI view that is shown by the component. */
  getMode() {
    return this.bindingMode === "null" ? this.personalId ? "null" : "no-personal-id" : this.isNew() ? this.personalId ? "new" : "no-personal-id" : this.mode === "pro" ? this.mode : "default";
  }
  /** Implements the getDefaults of ApiCrudObjectController */
  getDefaults() {
    return {
      listUrl: this.listUrl || "/taxcards",
      detailsUrl: this.detailsUrl || null,
      oDataTemplateUrl: "salaxy-components/odata/lists/Taxcards.html",
      oDataOptions: {}
    };
  }
  /**
   * Shows the detail view for the item.
   * Typically, this takes the user to a new page with the ID.
   * @param item Item may be either Container or list item.
   */
  showDetails(t) {
    return this.parentController ? this.parentController.showDetails(t) : this.getDefaults().detailsUrl ? this.$location.url(this.getDefaults().detailsUrl + this.getId(t)) : t.data.employmentId ? this.$location.url("/employments/details/" + t.data.employmentId + "?tab=taxcards") : t.otherId ? this.$location.url("/employment/details/" + t.id + "?tab=taxcards") : t.worker && t.worker.id ? this.$location.url("/employment/details/" + t.employmentId + "?tab=taxcards") : this.$location.url("/taxcards/details/" + t.id);
  }
  /** Save changes to the current item and then calls the on-save event. */
  save() {
    return super.save().then((t) => {
      if (!t)
        throw new Error("Taxcard saving failed (api returns null): this should only occur with automatic taxcards, and only in adding (this controller is not designed for adding a new taxcard).");
      return this.onSave && this.onSave({ item: t }), t;
    });
  }
  /**
   * Saves the taxcard and checks the diff after save:
   * If there are paid calculations that should be added to the taxcards, shows a dialog for that.
   */
  saveCheckDiff() {
    return this.save().then((t) => {
      if (t.incomeLog.find((e) => e.diff && e.diff !== "default"))
        return this.uiHelpers.openEditDialog("salaxy-components/modals/worker/taxcard-income-log.html", t, {}, "lg").then((e) => {
          if (e.action === "ok") {
            const a = this.uiHelpers.showLoading("SALAXY.NG1.CurrentTaxCardComponent.saveCheckDiffSaving");
            this.fullApi.commitDiff(t).then((n) => (a.dismiss(), n));
          } else
            return t;
        });
    });
  }
  /**
   * Starts the "Add new" process for the tax card.
   * By default we do not allow modifying taxcards to the end-user (only allowed for PRO-users).
   * Instead, they will always add a new taxcard.
   * Note: This method breaks the existing model binding of the controller and binds model="'new'".
   */
  showAddNew() {
    if (!this.personalId) {
      if (!this.current.card.personalId)
        throw new Error("No personal ID: Cannot add new card.");
      this.personalId = this.current.card.personalId;
    }
    this.loaders.showAddNew = !0, this.uiCrudHelpers.createNewTaxcard(this.personalId).then((t) => {
      t.action === "ok" && (this.bindingMode === "url" ? this.showDetails(t.item) : (this.reload(), this.onSave && this.onSave({ item: t.item }))), this.loaders.showAddNew = !1;
    });
  }
  /**
   * Sets auto taxcard and saves it
   */
  async setAuto() {
    if (!this.personalId) {
      if (!this.current.card.personalId)
        throw new Error("No personal ID: Cannot add new card.");
      this.personalId = this.current.card.personalId;
    }
    this.loaders.showSetAuto = !0;
    const t = this.uiHelpers.showLoading("SALAXY.NG1.WorkerDetailsComponent.taxCard.setSharedAutoForSelf.loadingTitle", "SALAXY.NG1.WorkerDetailsComponent.taxCard.setSharedAutoForSelf.loadingText"), e = await this.fullApi.setAuto(this.personalId);
    e == null ? this.uiHelpers.showAlert("SALAXY.NG1.WorkerDetailsComponent.taxCard.setSharedAutoForSelf.alertTitle", "SALAXY.NG1.WorkerDetailsComponent.taxCard.setSharedAutoForSelf.alertTextAutoCard") : this.onSave && this.onSave({ item: e }), t.dismiss(), this.loaders.showSetAuto = !1;
  }
  /** Shows the user interface for editing the minimum percent. */
  editTaxPercentMin() {
    this.uiHelpers.openEditDialog("salaxy-components/modals/worker/taxcard-min-percent.html", {
      taxPercentMin: this.current.card.taxPercentMin
    }, {}).then((t) => {
      t.action == We.Ok && (this.current.card.taxPercentMinOwned = t.item.taxPercentMin || null, this.current.card.taxPercentMin = t.item.taxPercentMin || null, this.save());
    });
  }
  /** Edit income log. */
  editIncomeLog() {
    this.uiHelpers.openEditDialog(
      "salaxy-components/modals/worker/taxcard-income-log.html",
      this.current,
      { editable: !0 },
      "lg"
    ).then((t) => {
      t.action === We.Ok && this.save();
    });
  }
  /**
   * Resets the current taxcard as new.
   * @param kind If specified, reset the taxcard to the given type.
   */
  resetAsNew(t) {
    this.setCurrentValue(La.getBlank(this.personalId, t, null, this.today)), this.updateUISettings();
  }
  /** Handles change of the year in the years dropdown. */
  yearChanged() {
    this.setCurrentValue(La.getBlank(this.personalId, this.current.card.kind, this.current.card.forYear, this.today)), this.updateUISettings();
  }
  /**
   * Returns the url where to download the tax card
   * @param taxCard Taxcard or if null, the current is used.
   */
  getTaxcardDownloadUrl(t) {
    return t = t || this.current, this.fullApi.getDownloadUrl(t);
  }
  /**
   * Returns the url where to preview the tax card
   * @param taxCard Taxcard or if null, the current is used.
   */
  getTaxcardPreviewUrl(t) {
    return t = t || this.current, this.fullApi.getPreviewUrl(t);
  }
  /**
   * Returns the url where to preview the tax card in upload scenario.
   * When uploading (adding a new taxcard) the taxcard is not necessarily saved so the preview cannot be fetched based on taxcard id.
   * On the other hand we are always in current user context (current user is the file owner), so we can use previewUri directly
   * @param taxCard Taxcard or if null, the current is used.
   */
  getUploadPreviewUrl(t) {
    return t = t || this.current, !t || !t.card.previewUri ? null : this.uploadService.getPreviewUrl(t.card.previewUri);
  }
  /**
   * Uploads tax card to the server.
   * @param file - selected file
   */
  uploadTaxCard(t) {
    this.uploadProgress = null, t && this.uploadService.upload(this.fullApi.getUploadUrl(), { file: t }, (e, a) => {
      this.uploadProgress = e;
    }).then(
      (e) => {
        this.uploadProgress = null, this.current.card.fileUri = e.card.fileUri, this.current.card.previewUri = e.card.previewUri;
      }
    ).catch((e) => {
      throw this.uiHelpers.showAlert("SALAXY.UI_Terms.error", "SALAXY.NG1.CurrentTaxCardComponent.uploadTaxCardAlertDescr"), new Error(e);
    });
  }
  /**
   * Gets main chart configuration for <salaxy-chart>
   * @param taxcard current taxcard
   */
  getMainChartConfig(t) {
    return this.uiHelpers.cache(
      this,
      "mainChartConfig",
      () => La.getMainChartV2(t),
      () => La.getIncomeLimitInfo(t)
    );
  }
  /**
   * Gets pie chart configuration for <salaxy-chart>
   * @param taxcard current taxcard
   */
  getPieChartConfig(t) {
    return this.uiHelpers.cache(
      this,
      "pieChartConfig",
      () => La.getPieChartDataV2(t),
      () => La.getIncomeLimitInfo(t)
    );
  }
  /**
   * Checks if the tax card is expired
   * A tax card still valid in the next year's January
   */
  isTaxCardExpired(t) {
    return !La.isTaxcardValid(t, this.today);
  }
  /**
   * Gets a language versioned error description ng-file-upload invalidFile errors (client-side before actual upload).
   * @param invalidFile Invalid file of ng-file-upload component.
   */
  getInvalidFileDescription(t) {
    return this.uploadService.getInvalidFileDescription(t);
  }
  /**
   * Adds a new taxcard for list item and after adding updates the current list without going to server.
   * This is needed because refreshing of the list may not provide the correct results as search is asynchronous.
   */
  showTaxCardAddDialogForTaxCardsList(t) {
    this.loaders.showTaxCardAddDialogForTaxCardsList = !0, this.uiCrudHelpers.createNewTaxcard(t.otherPartyInfo.officialId).then((e) => {
      if (e.action === "ok") {
        const a = e.item.card;
        t.data.employmentId = e.item.employmentId, t.data.forYear = a.forYear, t.data.incomeLimit = a.incomeLimit, t.data.kind = a.kind, t.data.taxPercent = a.taxPercent, t.data.taxPercent2 = a.taxPercent2, t.payment = e.item.result.payment, t.data.totalIncome = e.item.result.totalIncome, t.startAt = a.validity.start, t.endAt = a.validity.end;
      }
      this.loaders.showTaxCardAddDialogForTaxCardsList = !1;
    });
  }
  /** Commits the DIFF's to storage: synchs the taxcard to actual paid calculations. */
  commitDiff() {
    this.fullApi.commitDiff(this.current).then((t) => {
      this.setCurrentValue(t, !0);
    });
  }
  /**
   * Shows a dialog during the check of auto taxcard.
   */
  showRefreshAutoTaxcardDialog() {
    this.loaders.showRefreshAutoTaxcardDialog = !0, this.uiCrudHelpers.refreshAutoTaxcard(this.current.id).then((t) => {
      t.length && this.setStatus(this.api.getSingle(t[0].id)).then((e) => {
        this.setCurrent(e);
      }), this.loaders.showRefreshAutoTaxcardDialog = !1;
    });
  }
  /** Defines which fields to show/hide, require etc. in the view */
  updateUISettings() {
    const t = {
      /** If true, shown the 1st tax percent */
      showTaxPercent: !1,
      /** If true, shown the income limit AND 2nd tax pecent. */
      showIncomeLimit: !1,
      /** If true, the require the income limit AND 2nd tax percent. */
      requireIncomeLimit: !1,
      /** If true, shows input for previous salaries paid. */
      showPreviousSalariesPaid: !1,
      /** If true shows the image of an example tax card. */
      showExampleTaxCard: !0,
      /** Upload is either hidden, shown as optional (at the end) or required (in the beginning). */
      upload: "hide",
      /**
       * If true, the tax percents etc. cannot be edited.
       * In this case, also the helper numbers (1.-5.) that show where the number is in the PDF should not be shown.,
       */
      readonly: !1,
      /** Options for the start date: currently min and max dates. */
      startDateOptions: null,
      /**
       * Years that are allowed in the year selection:
       * Current year + next year in December, previous year in January.
       */
      yearsAllowed: null
    };
    if (!this.current) {
      this.addNewUi = t;
      return;
    }
    const e = I.getYear(this.today), a = I.getMonth(this.today);
    let n;
    a === 1 ? n = [e, e - 1] : a === 12 ? n = [e, e + 1] : n = [e], n.indexOf(this.current.card.forYear) < 0 && (this.current.id || (this.current.card.forYear = e));
    const i = this.current.card.forYear;
    switch (n = n.length < 2 ? null : n, t.showTaxPercent = !0, t.showExampleTaxCard = !0, this.current.card.kind) {
      case ma.Auto:
        t.showExampleTaxCard = !1, t.showTaxPercent = !1;
        break;
      case ma.NoTaxCard:
      case ma.NoWithholdingHousehold:
        t.readonly = !0, t.showExampleTaxCard = !1;
        break;
      case ma.Undefined:
        t.readonly = !0, t.showTaxPercent = !1;
        break;
      case ma.DefaultYearly:
        t.showIncomeLimit = !0, t.showPreviousSalariesPaid = !0, t.requireIncomeLimit = !0, t.showExampleTaxCard = !0, t.upload = this.isSelf ? "required" : "show", t.yearsAllowed = n;
        break;
      case ma.Replacement:
        t.showIncomeLimit = !0, t.showPreviousSalariesPaid = !0, t.showExampleTaxCard = !0, t.upload = this.isSelf ? "required" : "show", t.yearsAllowed = n, t.startDateOptions = {
          minDate: I.asJSDate(i + "-01-01"),
          maxDate: I.asJSDate(i + "-11-31")
        };
        break;
    }
    this.addNewUi = t;
  }
};
fk.$inject = [
  "Taxcards",
  "UiHelpers",
  "UiCrudHelpers",
  "$location",
  "$routeParams",
  "UploadService",
  "SessionService",
  "$timeout"
];
let fy = fk;
const bk = class bk extends Ki {
  /**
   * Creates a new TaxcardIncomeLogController.
   */
  constructor(t) {
    super(t), this.uiHelpers = t;
  }
  /** List that is edited */
  get list() {
    return this.parent ? this.parent.incomeLog : null;
  }
  /**
   * Shows the edit dialog.
   * @param item Item to edit or string "new" for creating a new one.
   * @param isNew Optional way of specifying that the item is a new item (with default values, not yet added to the list).
   * If item is string "new", this parameter will have no effect (will always be true).
   */
  showEditDialog(t, e = !1) {
    if (!this.editable || t !== "new" && this.isReadOnly(t))
      return null;
    super.showEditDialog(t, e);
  }
  /** Gets the URL for the log entry edit dialog. */
  getEditDialogTemplateUrl() {
    return "salaxy-components/worker/taxcard/TaxcardIncomeLogEditDialog.html";
  }
  /** Gets a new blank entry with default values. */
  getBlank() {
    return {
      type: jr.ExternalSalaries,
      paidAt: I.getToday()
    };
  }
  /** Returns true, if the calculations paid are different than the calculations in the income log. */
  get hasDiff() {
    return !!(this.list || []).find((t) => t.diff && t.diff !== "default");
  }
  /** Gets a sum from the list */
  getSum(t) {
    return this.list ? ie.sum(this.list, (e) => e[t]) : null;
  }
  /** Returns true if the row is read-only */
  isReadOnly(t) {
    return t.type !== jr.ExternalSalaries;
  }
};
bk.$inject = ["UiHelpers"];
let by = bk;
const vk = class vk extends nn {
  constructor(t, e, a, n, i) {
    super(t, e, a, n), this.fullApi = t, this.uiCrudHelpers = i, this.viewType = "overview", this.mapToCalendar = (r) => r.map((l) => ({
      key: l.id,
      title: l.workerSnapshot.displayName,
      description: `${L.get("SALAXY.NG1.WorkerAbsencesCrudComponent.absencesPaid")} ${this.getPeriodCalculation(l, "absencesPaid")}, ${L.get("SALAXY.NG1.WorkerAbsencesCrudComponent.absencesUnpaid")} ${this.getPeriodCalculation(l, "absencesUnpaid")}`,
      avatar: l.workerSnapshot,
      data: l,
      events: l.periods.filter(this.filter).map((o) => ({
        start: o.period.start,
        end: o.period.end,
        summary: He.getEnumLabel("AbsenceCauseCode", o.causeCode) + ` ${I.getFormattedRange(o.period.start, o.period.end)}, ${o.period.days?.length || o.period.daysCount} ${L.get("SALAXY.NG1.WorkerAbsencesCrudComponent.days")}.`,
        data: o
      }))
    })), this.filter = (r) => !(this.reportParams.end && r.period.start > this.reportParams.end || this.reportParams.start && r.period.end < this.reportParams.start);
  }
  /**
   * Implement IController
   */
  $onInit() {
    this.currentYear = I.getYear("today"), this.years = ie.getRange(2019, this.currentYear), this.reportParams = {
      today: I.getToday()
    }, this.reportView = "thisYear", this.reportView, super.$onInit();
  }
  /** Implements the getDefaults of ApiCrudObjectController */
  getDefaults() {
    return {
      listUrl: this.listUrl || "/workers",
      detailsUrl: this.detailsUrl || "/workers/details/",
      oDataTemplateUrl: "salaxy-components/odata/lists/Absences.html",
      oDataOptions: {}
    };
  }
  /**
   * Sets the employment ID and if it is different then starts the loading of the Absences object to that employment ID.
   */
  set employmentId(t) {
    if (this._employmentId !== t) {
      if (!t) {
        this._employmentId && (this._employmentId = null, this.model = null, this.reload());
        return;
      }
      this.fullApi.getForEmployment(t).then((e) => {
        this.model = e;
      });
    }
  }
  /** Gets the employment ID */
  get employmentId() {
    return this._employmentId;
  }
  /**
   * Gets or sets the report view that is currently shown.
   */
  get reportView() {
    return this.reportParams._view || (this.reportView = "thisMonth"), this.reportParams._view;
  }
  set reportView(t) {
    this.reportParams._view = t;
    const e = I.getYear(this.reportParams.today), a = I.asDate(this.reportParams.today), n = I.startEnd(a, "start-month"), i = I.startEnd(a, "end-month"), r = I.add(I.startEnd(a, "start-month"), -1, "month"), l = I.startEnd(r, "end-month");
    switch (t) {
      case "thisYear":
        this.reportParams.start = e + "-01-01", this.reportParams.end = e + "-12-31";
        break;
      case "lastYear":
        this.reportParams.start = e - 1 + "-01-01", this.reportParams.end = e - 1 + "-12-31";
        break;
      case "thisMonth":
        this.reportParams.start = n, this.reportParams.end = i;
        break;
      case "lastMonth":
        this.reportParams.start = r, this.reportParams.end = l;
        break;
      default:
        this.reportParams.start = this.years[0] + "-01-01", this.reportParams.end = this.years[this.years.length - 1] + "-12-31";
    }
  }
  /**
   * Saves a the Worker absences based on calendar input and updates the value in allAbsences property.
   * @param itemToSave A Worker absences object.
   */
  saveAbsences(t) {
    const e = this.uiHelpers.showLoading(`${L.get("SALAXY.NG1.WorkerAbsencesCrudComponent.saving")}...`);
    return this.api.save(t).then((a) => {
      wt.copy(a, t), e.dismiss();
    });
  }
  /**
   * Show an edit dialog for the absences.
   * @param absences The Worker absences to update.
   */
  showEditDialog(t) {
    this.uiCrudHelpers.openEditEmploymentDialog(t.employmentId, "default", "absences").then((e) => {
      e.action === "ok" && this.getAbsences();
    });
  }
  /**
   * Shows the add worker dialog: A
   */
  showAddWorker() {
    this.uiHelpers.openSelectEmployments().then((t) => {
      t.action === "ok" && t.item.length && t.item.filter((a) => !this.allAbsences.find((n) => n.employmentId === a.id)).forEach((a) => {
        const n = this.api.getBlank();
        n.employmentId = a.id, n.workerSnapshot = a.otherPartyInfo.avatar, this.allAbsences.push(n), this.saveAbsences(n);
      });
    });
  }
  /**
   * Gets the full absence objects for all Workers.
   */
  getAbsences() {
    this.fullApi.getLatest().then((t) => {
      this.allAbsences = t;
    });
  }
  /**
   * Returns true, if two objects are different.
   * @param obj1 First object to compare
   * @param obj2 Second object to compare
   */
  isChanged(t, e) {
    return !wt.equals(t, e);
  }
  /**
   * Gets a calculated value based on filtered absence periods.
   * TODO: Consider moving to core (there is the same code in AbsencePeriodsController)
   * @param absences Worker absences object.
   * @param type Type of calculation
   */
  getPeriodCalculation(t, e = "all") {
    const a = t.periods.filter(this.filter);
    switch (e) {
      case "all":
        return ie.sum(a, (n) => n.period.daysCount);
      case "length":
        return a.length;
      case "firstPeriod":
        return a.length ? a[0].period : null;
      case "lastPeriod":
        return a.length ? a[a.length - 1].period : null;
      case "absencesPaid":
        return ie.sum(a.filter((n) => n.isPaid), (n) => n.period.daysCount);
      case "absencesUnpaid":
        return ie.sum(a.filter((n) => !n.isPaid), (n) => n.period.daysCount);
      case "absencesHolidayAccrual":
        return ie.sum(a.filter((n) => n.isHolidayAccrual), (n) => n.period.daysCount);
      case "absencesNoHolidayAccrual":
        return ie.sum(a.filter((n) => !n.isHolidayAccrual), (n) => n.period.daysCount);
    }
    return null;
  }
};
vk.$inject = [
  "Absences",
  "UiHelpers",
  "$location",
  "$routeParams",
  "UiCrudHelpers"
];
let vy = vk;
const xk = class xk extends nn {
  constructor(t, e, a, n) {
    super(t, e, a, n);
  }
  /**
   * Initialization code.
   */
  $onInit() {
    super.$onInit();
  }
  /** Implements the getDefaults of ApiCrudObjectController */
  getDefaults() {
    return {
      listUrl: this.listUrl || "/workers",
      detailsUrl: this.detailsUrl || "/workers/details/",
      oDataTemplateUrl: "salaxy-components/odata/lists/Employments.html",
      oDataOptions: {}
    };
  }
};
xk.$inject = ["Workers", "UiHelpers", "$location", "$routeParams"];
let xy = xk;
const wk = class wk {
  /**
   * Creates a new WorkerAssureController
   * @param uiHelpers - Salaxy ui helpers service.
   * @param ajax - Salaxy ajax service.
   * @ignore
   */
  constructor(t, e) {
    this.uiHelpers = t, this.ajax = e, this.assureWorkerAccountReq = this.getEmptyAssureWorkerAccountReq();
  }
  /** Controller initialization */
  $onInit() {
  }
  /**
   * Calls the AssureWorkerAccount method in the API with the data defined in assureWorkerAccountReq
   */
  submitAssureWorkerAccount(t, e) {
    const a = this.uiHelpers.showLoading("SALAXY.UI_Terms.wait");
    let n = "/partner/assureworker";
    return n += "?officialId=" + encodeURIComponent(this.assureWorkerAccountReq.officialId), n += "&firstName=" + encodeURIComponent(this.assureWorkerAccountReq.firstName), n += "&lastName=" + encodeURIComponent(this.assureWorkerAccountReq.lastName), n += "&email=" + encodeURIComponent(this.assureWorkerAccountReq.email), n += "&telephone=" + encodeURIComponent(this.assureWorkerAccountReq.telephone), n += "&bankAccountIban=" + encodeURIComponent(this.assureWorkerAccountReq.bankAccountIban), this.assureWorkerAccountReq.startDate && (n += "&startDate=" + encodeURIComponent(this.assureWorkerAccountReq.startDate)), this.assureWorkerAccountReq.endDate && (n += "&endDate=" + encodeURIComponent(this.assureWorkerAccountReq.endDate)), this.ajax.postJSON(n, "").then((i) => (e.items.find((l) => l.otherId === i.id) == null && e.items.unshift({
      createdAt: i.createdAt,
      updatedAt: i.updatedAt,
      otherId: i.id,
      otherPartyInfo: {
        avatar: i.avatar,
        officialId: i.officialPersonId,
        email: i.contact.email,
        telephone: i.contact.telephone,
        ibanNumber: i.ibanNumber
      },
      data: {
        type: i.employment.type,
        pensionCalculation: i.employment.pensionCalculation
      }
    }), t.model = i.employmentId, this.resetAssureWorkerAccount(), a.dismiss(), i));
  }
  /**
   * Resets assure worker account model.
   */
  resetAssureWorkerAccount() {
    this.assureWorkerAccountReq = this.getEmptyAssureWorkerAccountReq();
  }
  /** Gets an empty assureWorkerAccountReq - used for reset. */
  getEmptyAssureWorkerAccountReq() {
    return {
      officialId: null,
      firstName: null,
      lastName: null,
      email: null,
      telephone: null,
      bankAccountIban: null,
      startDate: null,
      endDate: null
    };
  }
};
wk.$inject = ["UiHelpers", "AjaxNg1"];
let wy = wk;
const Ak = class Ak extends nn {
  /**
   * Creates a new WorkflowController
   * @ignore
   */
  constructor(t, e, a, n, i) {
    super(t, e, a, n), this.fullApi = t, this.wizardService = i, this.colWidthClasses = ["col-sm-12", "col-sm-12", "col-sm-6", "col-sm-4", "col-sm-3", "col-sm-fifth", "col-sm-2"], this.tabOptions = [], this.calendarMapper = (r) => {
      const l = {
        key: "default",
        title: "Preview",
        events: []
      }, o = {
        undefined: null,
        display: "fa-bell",
        email: "fa-envelope",
        audio: "fa-volume-off",
        createItem: "fa-star",
        paymentDate: "fa-money",
        script: "fa-cog"
      }, c = ["info", "default", "success", "primary"];
      return this.calendarView = {}, r.occurenceInfo.next.forEach((d, p) => {
        const h = c[p % 4];
        d.start < (this.calendarView.start || "9999-01-01") && (this.calendarView.start = d.start);
        let g = d.end;
        d.duration == "1.00:00:00" ? g = null : d.isAllDay && (g = I.add(g, -1, "day")), l.events.push({
          start: d.start,
          end: g,
          summary: L.get(d.summary) || L.get("SALAXY.NG1.ODataCalendarEventComponent.event"),
          cssClass: `salaxy-cal-event-${h}`
        }), d.actions.forEach((x) => {
          x.start < this.calendarView.start && (this.calendarView.start = x.start), l.events.push({
            start: x.start,
            summary: L.get(x.summary) || L.getWithDefault("SALAXY.ENUM.CalendarActionType." + x.type, x.type),
            icon: o[x.type],
            cssClass: `btn-${h}`
          });
        });
      }), this.calendarView.start = I.startEnd(this.calendarView.start || I.getToday(), "start-month"), this.calendarView.end = I.add(I.add(this.calendarView.start, 3, "month"), -1, "day"), [l];
    };
  }
  /** Gets all the steps in the Wizard */
  get steps() {
    return this.wizardService.getSteps();
  }
  /** Gets the number of the currently active step */
  get step() {
    return this.wizardService.activeStepNumber;
  }
  /** Sets the number of the currently active step */
  set step(t) {
    this.wizardService.activeStepNumber = t;
  }
  /** The currently selected step object */
  get currentStep() {
    return this.wizardService.getCurrentStepObject();
  }
  /** Active styling properties */
  get style() {
    return {
      colWidthClass: this.colWidthClasses[this.steps.length]
    };
  }
  /** Returns true if goNext is enabled  */
  get canGoNext() {
    return !!(this.steps.length > this.step && this.steps[this.step] && !this.steps[this.step].disabled);
  }
  /** Returns true if goNext is enabled  */
  get canGoPrevious() {
    return this.step > 1 && !this.steps[this.step - 2].disabled;
  }
  /**
   * Navigates to the next step if possible
   */
  goNext() {
    this.canGoNext && this.step++;
  }
  /** Navigates to the previous step if possible */
  goPrevious() {
    this.canGoPrevious && this.step--;
  }
  /**
   * Controller initialization
   */
  $onInit() {
    this.wizardService.setSteps([
      {
        title: "SALAXY.NG1.ODataCalendarEventComponent.step1Title",
        active: !0
      },
      {
        title: "SALAXY.NG1.ODataCalendarEventComponent.step2Title"
      },
      {
        title: "SALAXY.NG1.ODataCalendarEventComponent.step3Title"
      }
    ]), super.$onInit(), this.tabOptions = [
      { value: "basic", text: "Perustiedot" },
      { value: "recurrence", text: `Toistuvuus (${this.current?.event?.recurrenceRules?.length || "ei toistu"})` },
      { value: "actions", text: `Tehtävät / ilmoitukset (${this.current?.event.actions?.length || 0})` },
      { value: "preview", text: "Esikatselu" },
      {
        value: "attendees",
        text: `Henkilöt (${this.current?.event.attendees?.length || "-"})`,
        disabled: !this.current?.event.attendees?.length
      },
      {
        value: "attachments",
        text: `Liitteet (${this.current?.event.attachments?.length || "-"})`,
        disabled: !this.current?.event.attachments?.length
      },
      { value: "debug", text: "Debug" }
    ];
  }
  /** Implements the getDefaults of ApiCrudObjectController */
  getDefaults() {
    return {
      listUrl: this.listUrl || "/calendar",
      detailsUrl: this.detailsUrl || "/calendar/details/",
      oDataTemplateUrl: "salaxy-components/odata/lists/calendar/Events.html",
      oDataOptions: {}
    };
  }
  /**
   * Loads a recurring event from the data storage and sets it as current item.
   */
  getRecurringEvent(t, e) {
    return this.setStatus(this.fullApi.getRecurringEvent(e, t, YL.CreateRecurrence)).then((a) => {
      if (!a)
        throw new Error(`Item ${this.currentId} not found.`);
      return this.model = a, a;
    });
  }
  /**
   * GetId is overriden so that the id contains also the payload type besides the id
   * @param item The item for which to fetch the ID.
   */
  getId(t) {
    if (!t)
      throw new Error("getId called for null item.");
    return t.containerGuid ? t.containerGuid + "/" + t.payloadType : t.id + "/" + t.payloadType;
  }
  /** Adds a new recurrence rule to the event */
  addRecurrenceRule() {
    this.current.event.recurrenceRules = this.current.event.recurrenceRules || [], this.current.event.recurrenceRules.push("FREQ=MONTHLY;INTERVAL=1");
  }
  /** Adds a new action to the event */
  addAction() {
    this.current.event.actions = this.current.event.actions || [];
    const t = {
      type: this.current.event.actions.length ? No.Email : No.CreateItem
    };
    this.current.event.actions.push(t);
  }
  /**
   * Deletes an item in the recurrence rules
   * @param index The index number of the item to delete.
   */
  deleteRecurrence(t) {
    this.current.event.recurrenceRules.splice(t, 1);
  }
  /**
   * Deletes an item in the actions
   * @param index The index number of the item to delete.
   */
  deleteAction(t) {
    this.current.event.actions.splice(t, 1);
  }
  /**
   * Saves the calendar item.
   * Override done so that durations (timespans) are converted from number to string.
   */
  save() {
    return this.checkDurations(), super.save();
  }
  /**
   * Shows the detail view for the event in a dialog.
   * @param id Identifier of the calendar event to edit.
   * Use "new" to add a new item.
   */
  showDetailsDialog(t) {
    const e = this.uiHelpers.showLoading("SALAXY.UI_Terms.loading"), a = t === "new" ? "SALAXY.NG1.ODataCalendarEventComponent.showDetailsDialogTitle" : "SALAXY.NG1.ODataCalendarEventComponent.showDetailsDialogTitle2";
    this.fullApi.getSingle(t).then((n) => {
      e.setHeading("Muokkaus auki"), this.uiHelpers.openEditCalendarEvent(n, a).then((i) => {
        i.action === "ok" ? (e.setHeading("SALAXY.UI_Terms.isSaving"), this.fullApi.save(i.item).then(() => {
          e.dismiss(), this.odataController && this.odataController.reload();
        })) : e.dismiss();
      });
    });
  }
  /** Gets the event duration, even if it is null (start and end defined). */
  getEventDuration() {
    if (!this.current)
      return null;
    if (this.current.event.duration)
      return ys.formatDuration(this.current.event.duration);
    let t = this.current.event.end ?? this.current.event.start;
    return t < this.current.event.start ? L.get("SALAXY.NG1.ODataCalendarEventComponent.getEventDurationError") : (this.current.event.isAllDay && (t = I.add(t, 1, "day")), ys.formatRangeToDuration(this.current.event.start, t));
  }
  /** Assures that the durations are strings, not numbers. The UI binding makes them numbers. */
  checkDurations() {
    this.current?.event.duration && (this.current.event.duration = this.current.event.duration.toString()), (this.current?.event.actions || []).forEach((t) => {
      t.triggerDuration && (t.triggerDuration = t.triggerDuration.toString());
    });
  }
  /**
   * Preview calendar is clicked
   * @param type event or empty day
   * @param date Date as string
   * @param calEvent Calendar event that is clicked.
   */
  calendarClick(t, e, a) {
    if (t === "event") {
      let n;
      const i = (this.preview ?? this.current).event.actions.find((r) => a.data?.id && r.id === a.data.id);
      i ? n = `${He.getEnumLabel("CalendarActionType", i.type)}: ${I.getFormattedDate(a.start)}.
${i.summary || "SALAXY.NG1.ODataCalendarEventComponent.calendarClickNoDescription"} (${L.get("SALAXY.NG1.ODataCalendarEventComponent.calendarClickDuration")}: ${i.triggerDuration || i.triggerDateTime})

${i.description || ""}` : n = `${L.get("SALAXY.NG1.ODataCalendarEventComponent.reoccuringEvent")}: ${I.getFormattedDate(a.start)}.`, this.uiHelpers.showAlert(a.summary, n);
    }
  }
  /**
   * Reloads the preview from the server.
   */
  reloadPreview() {
    this.preview = null, this.checkDurations(), this.fullApi.recalculate(this.current).then((t) => {
      this.preview = t;
      const e = this.getPreviewRange(t);
      this.preview.start = e.start, this.preview.end = e.end;
    });
  }
  /** Gets a peview range (currently 4 months) for a calendar event  */
  getPreviewRange(t) {
    const e = I.getToday();
    if (t.occurenceInfo.occurencesEnd < e)
      return {
        start: I.add(I.startEnd(t.occurenceInfo.occurencesEnd, "start-month"), -3, "month"),
        end: I.startEnd(t.occurenceInfo.occurencesEnd, "end-month")
      };
    let a;
    return t.occurenceInfo.occurencesStart > I.add("today", 1, "month") ? a = I.startEnd(t.occurenceInfo.occurencesStart, "start-month") : a = I.startEnd(I.add("today", -1, "month"), "start-month"), {
      start: a,
      end: I.startEnd(I.add(a, 4, "month"), "end-month")
    };
  }
  /**
   * Gets or sets the value of whether the e-mail notification should be sent.
   * Used by simplified view as boolean: Adds or removes a second item to actions array.
   */
  get notificationEnabled() {
    return !!this.current.event.actions.find((t) => t.type == No.Email);
  }
  set notificationEnabled(t) {
    t ? this.current.event.actions.push({
      type: No.Email,
      summary: L.get("SALAXY.NG1.ODataCalendarEventComponent.notificationEnabledSummary"),
      triggerDuration: this.current.event.actions[1]?.triggerDuration ?? "10.00:00",
      description: null,
      attendees: [{ email: null }]
    }) : this.current.event.actions = this.current.event.actions.filter((e) => e.type != No.Email);
  }
  /** Gets the notification if one exists. */
  get notification() {
    return this.current.event.actions.find((t) => t.type == No.Email);
  }
  /** Shows the create/edit dialog for the current event. */
  showEditEvent() {
    this.fullApi.getRecurringEvent(this.currentId, Rn.PayrollDetails, YL.CreateRecurrence).then((t) => {
      this.uiHelpers.openEditCalendarEvent(t, "SALAXY.NG1.ODataCalendarEventComponent.showEditEventTitle", "simplified").then((e) => {
        e.action === "ok" ? (this.setCurrentRef(e.item), this.save()) : e.action === "delete" && (this.setCurrentRef(e.item), this.delete());
      });
    });
  }
  /** End date needs updating, when start date changes.  */
  updateEndDate() {
    this.endMinDate = this.current.event.start || null;
  }
};
Ak.$inject = [
  "CalendarEvents",
  "UiHelpers",
  "$location",
  "$routeParams",
  "WizardService"
];
let Ay = Ak;
const Ck = class Ck extends Ki {
  /**
   * Creates a new WorkflowController
   * @ignore
   */
  constructor(t, e) {
    super(e), this.calendarEvents = t, this.isLoading = !1, this.categorySelections = {
      [Rn.CalendarEvent]: L.get("SALAXY.NG1_Pages.Calendar.categorySelections.calendarEvent"),
      [Rn.Calculation]: L.get("SALAXY.NG1_Pages.Calendar.categorySelections.calculation"),
      [Rn.CalculationPaid]: L.get("SALAXY.NG1_Pages.Calendar.categorySelections.calculationPaid"),
      [Rn.PayrollDetails]: L.get("SALAXY.NG1_Pages.Calendar.categorySelections.payrollDetails"),
      [Rn.MessageThread]: L.get("SALAXY.NG1_Pages.Calendar.categorySelections.messageThread"),
      "calculation,payrollDetails,calculationPaid": L.get("SALAXY.NG1_Pages.Calendar.categorySelections.calculationsAndPayrolls"),
      all: L.get("SALAXY.NG1_Pages.Calendar.categorySelections.all"),
      none: L.get("SALAXY.NG1_Pages.Calendar.categorySelections.none"),
      default: L.get("SALAXY.NG1_Pages.Calendar.categorySelections.default")
      /*
      action: "Automaattiset työnkulut",
      holiday: "Lomat",
      absencePeriod: "Poissaolot",
      */
    }, this.emptyArr = [];
  }
  /**
   * Controller initialization
   */
  $onInit() {
    const t = I.add(I.startEnd("today", "start-month"), -1, "month");
    this.range = this.range || {
      start: t,
      end: I.add(I.add(t, 3, "month"), -1, "day")
    }, this.categories = this.categories || Rn.Calculation, this.reload();
  }
  /** Gets the list of occurences */
  get list() {
    return this.parent?.items || this.emptyArr;
  }
  /** Gets the edit dialog template URL */
  getEditDialogTemplateUrl() {
    return "salaxy-components/workflow/calendar/Occurences-details.html";
  }
  /** Gets a blank event occurence (currently not supported / thows an error) */
  getBlank() {
    throw new Error("You cannot create an event occurence directly: Create and event instead.");
  }
  /** Gets the custom logic for dialog */
  getEditDialogLogic() {
    return {};
  }
  /** Reload the OData query using the range and categories parameters */
  reload() {
    this.isLoading = !0, this.calendarEvents.getOccurences(ie.assureArray(this.categories), this.range.start, this.range.end).then((t) => {
      this.parent = t, this.isLoading = !1;
      const e = {
        key: "periods",
        title: L.get("SALAXY.NG1_Pages.Calendar.calendarSeriesPeriods"),
        events: t.items.map((i) => ({
          summary: i.shortText,
          start: i.startAt,
          end: i.endAt
        }))
      }, a = {
        key: "actions",
        title: L.get("SALAXY.NG1_Pages.Calendar.calendarSeriesActions"),
        events: []
      };
      t.items.forEach((i) => {
        e.events.push(...i.actions);
      }), this.calendarPeriods = [e, a];
      let n = this.currentDay;
      n < this.range.start ? n = this.range.start : n > this.range.end && (n = this.range.end), this.currentDay = n;
    });
  }
  /**
   * Gets or sets the current day for the daily and weekly calendar.
   * Setting to null will set the day as today.
   */
  get currentDay() {
    return this._currentDay || (this._currentDay = I.getToday()), this._currentDay;
  }
  set currentDay(t) {
    t = I.asDate(t), this._currentDay = t || I.getToday();
    const e = I.add(this._currentDay, 1, "day");
    this.todayOccurences = this.list.filter((n) => n.endAt >= this._currentDay && n.startAt < e);
    const a = I.startEnd(this._currentDay, "start-week");
    this.currentWeek = [];
    for (let n = 0; n < 7; n++) {
      const i = a, r = I.add(a, 1, "day");
      this.currentWeek.push({
        date: i,
        occurences: this.list.filter((l) => l.endAt >= i && l.startAt < r)
      });
    }
  }
};
Ck.$inject = [
  "CalendarEvents",
  "UiHelpers"
];
let mw = Ck;
const $k = class $k extends nn {
  /**
   * Creates a new DatasetsCrudController
   * @ignore
   */
  constructor(t, e, a, n, i, r, l, o, c) {
    super(t, e, a, n), this.usecasesService = i, this.jsonSchemaService = r, this.sessionService = l, this.ajax = o, this.$timeout = c, this.usecase = null, this.generateTabOptions = function() {
      return this.uiHelpers.cache(this, "generateTabOptions", () => !this.current || !this.current.data ? [] : this.current.data.map((d, p) => ({
        value: d.name || `tab-${p}`,
        text: d.label || d.name
      })));
    }, this.schemaCache = {
      "": []
    }, this.propertyTreeCache = {
      "": []
    };
  }
  /**
   * Controller initialization
   */
  $onInit() {
    super.$onInit();
  }
  /** Implements the getDefaults of ApiCrudObjectController */
  getDefaults() {
    return {
      listUrl: this.listUrl || "/datasets",
      detailsUrl: this.detailsUrl || "/datasets/details/",
      oDataTemplateUrl: "salaxy-components/odata/lists/Datasets.html",
      oDataOptions: {}
    };
  }
  /** Overrides the reload to assure that usecase is also loaded. */
  reload() {
    return super.reload().then((t) => {
      if (!t)
        return this.usecase = "none", t;
      this.current.data.forEach((a) => {
        (a.schemaDoc || "any") != "any" && a.schemaDoc != "usecase" && this.jsonSchemaService.assureSchemaDocument(a.schemaDoc);
      }), this.generateTabOptions();
      const e = this.$location?.search().usecase || this.defaultUsecase;
      return t.data.forEach((a) => a.content = a.content || []), e || t.usecase?.uri ? this.usecasesService.assureUsecase(Rn.Dataset, t, e).then((a) => (a ? this.usecase = a : (this.usecase = "none", this.assureUsecasesLoaded()), t)) : (this.assureUsecasesLoaded(), this.usecase = "none", t);
    });
  }
  assureUsecasesLoaded() {
    this.usecasesService.getActiveUsecaseListItems(Rn.Dataset).then((t) => {
      this.usecases = t.sort((e, a) => (e.data.order || 100) - (a.data.order || 100)).map((e) => ({ text: e.shortText, value: e.uri }));
    });
  }
  /** Gets the user interface mode */
  getMode() {
    if (this.isLoading || !this.usecase?.isLoaded && this.usecase != "none")
      return "loading";
    switch (this.mode) {
      case "data-edit":
      case "full-edit":
      case "usecase":
        return this.mode;
      default:
        return this.usecase?.defaultView ? "usecase" : "data-edit";
    }
  }
  /** Adds a new "table" to the dataset */
  addDataObject() {
    this.current.data.push({
      label: "Uusi tietue"
    });
  }
  /**
   * Removes a data object from the dataset
   * @param index Index of the object to remove.
   */
  deleteObject(t) {
    this.current.data.splice(t, 1);
  }
  /** Executes the current action with the current item. */
  async executeAction(t) {
    const e = new Av(t);
    return await e.execute(this.current, this.sessionService.session, this.ajax), e.isAsync && this.$timeout(), e;
  }
  /**
   * Adds an item to the default view (first view). Adds the view if it does not already exist.
   * Method may later be extended to support multiple views and/or more elaborate column properties.
   * @param dataObjectIndex Index of the data object to which the view item is added.
   * @param type Add include or exclude rule.
   * @param value Value to add to the array.
   */
  addViewItem(t, e, a = "") {
    const n = this.current.data[t];
    n.views = n.views || [], n.views.length < 1 && n.views.push({});
    const i = n.views[0];
    e == "exclude" ? (i.exclude = i.exclude || [], i.exclude.push(a)) : e == "include" && (i.include = i.include || [], i.include.push(a));
  }
  /**
   * Helper method to move an item in an array up or down.
   * @param arr Array to operate on
   * @param fromIndex Index of the item to move
   * @param step How many items to move and to which direction: -1 is one up, 1 is one down.
   */
  arraymove(t, e, a) {
    const n = t[e];
    t.splice(e, 1);
    let i = e + a;
    i > t.length && (i = t.length), i < 0 && (i = 0), t.splice(i, 0, n);
  }
  /**
   * Gets the available schema documents that can be used for modeling the data objects.
   * @returns Cached collection of available schema documents.
   */
  getSchemaDocs() {
    return this.uiHelpers.cache(this, "schemaList", () => (console.log("Refresh cache."), [
      {
        value: "any",
        text: "Ei määritetty (any)",
        title: "any"
      },
      {
        value: "usecase",
        text: "Räätälöinti",
        title: "usecase"
      },
      ...this.jsonSchemaService.getSchemas().map((t) => ({
        value: t.url,
        text: t.doc.info.title,
        title: t.url
      }))
    ]), () => this.jsonSchemaService.getSchemas().map((t) => t.url));
  }
  /**
   * Gets the schemas defined in the specified schema document
   * @param docUrl The URL (unique key in cache) for the schema document.
   */
  getSchemas(t) {
    if ((!t || t == "any") && (t = ""), !this.schemaCache[t])
      if (t == "usecase")
        if (this.usecase == "none")
          this.schemaCache.usecase = [];
        else {
          const e = this.usecase.schema.components.schemas;
          this.schemaCache[t] = Object.keys(e).map((a) => ({
            value: a,
            text: `${e[a].title} (${a})`,
            title: e[a].description || a
          }));
        }
      else {
        const e = this.jsonSchemaService.findSchemaDoc(t, !0).doc.components.schemas;
        this.schemaCache[t] = Object.keys(e).map((a) => {
          const n = e[a].title ? `${e[a].title} (${a})` : a;
          return {
            value: a,
            text: n,
            title: e[a].description || a
          };
        });
      }
    return this.schemaCache[t];
  }
  /**
   * Gets the full schema definition for the specified table.
   * @param index Index number of the data object in the data collection.
   */
  getSchamaDef(t) {
    const e = this.current.data[t].schemaDoc, a = this.current.data[t].schema;
    if (!e || e == "any")
      return null;
    if (e == "usecase")
      return this.usecase == "none" ? null : this.usecase.schema.components.schemas[a];
    {
      const n = this.jsonSchemaService.findSchemaDoc(e, !1);
      return n ? n.doc.components.schemas[a] : null;
    }
  }
  /**
   * Gets all the properties within a schema for property selection.
   * @param index Index number of the data object in the data collection.
   */
  getAllPropertiesOfSchema(t) {
    const e = this.current.data[t].schemaDoc, a = this.current.data[t].schema;
    if (this.propertyTreeCache[e + a])
      return this.propertyTreeCache[e + a];
    const n = this.getProperties(this.getSchamaDef(t));
    return this.propertyTreeCache[e + a] = n, n;
  }
  getProperties(t, e = "") {
    const a = [];
    return Object.keys(t.properties || {}).forEach((n) => {
      const i = t.properties[n];
      a.push({
        value: e + n,
        text: e + n,
        title: i.title || i.description
      }), i.type == "object" && a.push(...this.getProperties(i, e + n + "."));
    }), a;
  }
};
$k.$inject = [
  "Datasets",
  "UiHelpers",
  "$location",
  "$routeParams",
  "UsecasesService",
  "JsonSchemaService",
  "SessionService",
  "AjaxNg1",
  "$timeout"
];
let Cy = $k;
const Sk = class Sk extends nn {
  /**
   * Creates a new UsecasesCrudController
   * @ignore
   */
  constructor(t, e, a, n, i, r, l, o, c, d, p, h) {
    super(t, e, a, n), this.usecasesService = i, this.sessionService = r, this.ajax = l, this.$timeout = o, this.calculations = c, this.payrolls = d, this.datasets = p, this.$templateCache = h, this._currentSchema = {}, this.getOrder = (g) => this.usecasesService.getOrder(g.uri);
  }
  /**
   * Implement IController
   */
  $onInit() {
    super.$onInit();
  }
  /** Gets the type name of item type, i.e. "Calculation" for "calculation" enumeration. */
  get itemType() {
    return "CalculationListItem[]";
  }
  /**
   * Shows the detail view for the item.
   * Supports viewing public items from other users as read-only.
   * @param item Item may be either Container or list item.
   */
  showDetails(t) {
    return this.parentController ? this.parentController.showDetails(t) : this.$location.url(this.getDefaults().detailsUrl + this.getId(t) + "@" + t.owner);
  }
  /**
   * Gets the activity type of usecase from the settings.
   * @param item List item to check.
   * @returns Information on whether the usecase is active or not - or default usecase (also active).
   */
  getActive(t) {
    return this.usecasesService.getActive(t.uri);
  }
  /**
   * Gets the activity bg-color of usecase from the settings.
   * @param status Status for color.
   * @returns Bg color for the status.
   */
  getStatusBgColor(t) {
    switch (t) {
      case Ni.Inactive:
        return "bg-warning";
      case Ni.Active:
        return "bg-info";
      case Ni.Default:
        return "bg-danger";
      case Ni.Undefined:
      default:
        return "bg-default";
    }
  }
  toLowerCamelCase(t) {
    return t.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (e, a) => a.toUpperCase());
  }
  /**
   * Shows the detail view with a new item that is a copy of the given item.
   * Supports copying public items from other users.
   * @param item Item may be either Container or list item.
   */
  showCopyAsNew(t) {
    return this.parentController ? this.parentController.showCopyAsNew(t) : this.$location.url(this.getDefaults().detailsUrl + this.getId(t) + "@" + t.owner + "/copy-as-new");
  }
  /** The data container in the current business object */
  get usecase() {
    return this.currentItem?.usecase;
  }
  /** The data part of the usecase: Used in data binding. */
  get data() {
    return this.currentItem?.usecase?.data;
  }
  /**
   * Gets a list of usecases for the current account.
   * First get will start the load process and then the list is cached to controller scope.
   */
  get list() {
    return this._list || (this._list = [], this.getOData(null).then((t) => {
      this._list = t.items.sort((e, a) => (e.data.order || 100) - (a.data.order || 100));
    })), this._list;
  }
  /**
   * Checks if the given schema is defined in the current usecase: Exists and has any properties.
   * @param schemaNames One or several names of the schema to check whether they are defined.
   * If any schema is exists and has properties, returns true.
   */
  isDefined(...t) {
    return ol.isDefined(this.current?.schema, ...t);
  }
  /** Returns the whole Open API schema document as editable string. */
  get editableSchema() {
    return JSON.stringify(this.current.schema || "{}", null, "	");
  }
  /** Parses the schema from the given string. */
  set editableSchema(t) {
    this.current.schema = JSON.parse(t);
  }
  /** Sets the current editable schema (one of the schemas within the Open API document). */
  setCurrentSchema(t) {
    this._currentSchema.key = t, this._currentSchema.schema = this.current.schema.components.schemas[t];
  }
  /** Gets the current editable schema (one of the schemas within the Open API document). */
  get currentSchema() {
    return this._currentSchema.schema;
  }
  /** Gets the property name / key of the current editable schema (one of the schemas within the Open API document). */
  get currentSchemaKey() {
    return this._currentSchema.key;
  }
  /** Creates a new current editable schema (one of the schemas within the Open API document). */
  createSchema() {
    const t = window.prompt(L.get("SALAXY.NG1.UsecaseDetailsComponent.createSchemaName"));
    this._currentSchema.key = t, this._currentSchema.schema = {
      type: "object",
      title: `${L.get("SALAXY.NG1.UsecaseDetailsComponent.createSchemaTitle")} (${t})`,
      properties: {}
    }, this.current.schema.components.schemas[t] = this._currentSchema.schema;
  }
  /** Removes an schema from this usecase. */
  deleteSchema(t) {
    delete this.current.schema.components.schemas[t], this.currentSchemaKey == t && (this._currentSchema.key = Object.keys(this.current.schema.components.schemas)[0], this._currentSchema.schema = this._currentSchema.key ? this.current.schema.components.schemas[this._currentSchema.key] : null);
  }
  /** The currently selected editable action (script). */
  get currentAction() {
    return this._currentAction;
  }
  set currentAction(t) {
    this._currentAction = t, this.currentExecutor = new Av(t);
  }
  /**
   * Current editable view.
   */
  get currentView() {
    return this._currentView;
  }
  set currentView(t) {
    const e = "salaxy-dynamic-templates/usecase-custom-view.html";
    this.$templateCache.remove(e), t?.content?.trim() && this.$templateCache.put(e, t.content), this._currentView = t;
  }
  /** Overrides the save for clear cache. */
  save() {
    return this.usecasesService.clearCache(), super.save();
  }
  /** Create a new action / script to this usecase. */
  createAction() {
    this.currentAction = {
      actionType: nX.ClientScript,
      uiColor: cc.Default,
      uiText: L.get("SALAXY.NG1.UsecaseDetailsComponent.createAction"),
      content: "// Add script here."
    }, this.current.actions.push(this.currentAction);
  }
  /** Creates a new view and sets it as current. */
  createView() {
    this.currentView = {
      label: null,
      description: null,
      content: "<p>Create your view here.</p>"
    }, this.current.views.push(this.currentView);
  }
  /** Overrides the default reload for clearing the cache. */
  reload() {
    return super.reload().then((t) => (this.usecasesService.setToCache(t), t));
  }
  /**
   * Refreshes the current usecase to cache: Used in preview.
   */
  refreshCurrentInCache() {
    this.usecasesService.setToCache(this.current);
  }
  /** Removes an action from this usecase. */
  deleteAction(t) {
    t && (this.current.actions.splice(this.current.actions.indexOf(t), 1), this.currentAction == t && (this.currentAction = this.current.actions[0]));
  }
  /**
   * Removes a view from this usecase.
   */
  deleteView(t) {
    t && (this.current.views.splice(this.current.views.indexOf(t), 1), this.currentView == t && (this.currentView = this.current.views[0]));
  }
  /** Executes the current action with the current item. */
  async executeAction(t) {
    const e = t ? new Av(t) : this.currentExecutor;
    return await e.execute(this.currentItem, this.sessionService.session, this.ajax), e.isAsync && this.$timeout(), e;
  }
  /**
   * Opens a dialog for selecting the current item for which to execute a usecase.
   * @param type Type of item to select: Select from dialog, new or null/empty.
   */
  selectItem(t) {
    if (!t) {
      this.currentItem = null;
      return;
    }
    switch (this.current.itemType) {
      case Rn.Calculation:
      case Rn.CalculationPaid:
        if (t == "new")
          this.currentItem = this.calculations.getBlank();
        else {
          const e = this.current.itemType == Rn.CalculationPaid ? "paid" : "draft";
          this.uiHelpers.openSelectCalcs(e, "Select a calculation for demo").then((a) => {
            if (a.action == "ok" && a.item.length > 0) {
              const n = this.uiHelpers.showLoading();
              this.calculations.getSingle(a.item[0].id).then((i) => {
                this.currentItem = i, i.usecase.uri = this.current.uri, n.dismiss();
              });
            }
          });
        }
        return;
      case Rn.PayrollDetails:
        t == "new" ? this.currentItem = this.payrolls.getBlank() : alert("TODO: Payroll selection not yet supported.");
        return;
      case Rn.Dataset:
        t == "new" ? this.currentItem = this.datasets.getBlank() : this.uiHelpers.openSelect("Select a dataset").then((e) => {
          if (e) {
            const a = this.uiHelpers.showLoading();
            this.datasets.getSingle(e.id).then((n) => {
              this.currentItem = n, n.usecase.uri = this.current.uri, a.dismiss();
            });
          }
        });
        return;
      default:
        alert(`Item type ${this.current.itemType} not supported for debug data.`);
        return;
    }
  }
  /** Implements the getDefaults of ApiCrudObjectController */
  getDefaults() {
    return {
      listUrl: this.listUrl || "/usecases",
      detailsUrl: this.detailsUrl || "/usecases/details/",
      oDataTemplateUrl: "salaxy-components/odata/lists/Usecases.html",
      oDataOptions: {}
    };
  }
};
Sk.$inject = [
  "Usecases",
  "UiHelpers",
  "$location",
  "$routeParams",
  "UsecasesService",
  "SessionService",
  "AjaxNg1",
  "$timeout",
  "Calculations",
  "Payrolls",
  "Datasets",
  "$templateCache"
];
let $y = Sk;
const kk = class kk {
  /**
   * Creates a new WorkflowController
   * @ignore
   */
  constructor(t, e, a, n) {
    this.workflowService = t, this.uiHelpers = e, this.sessionService = a, this.credentialService = n, this.isUpdating = !1, this._events = [];
  }
  /**
   * Implement IController
   */
  $onInit() {
    this.showWorkflowAssign = this.showWorkflowAssign !== !1;
  }
  /** Returns the events of given type. */
  get events() {
    const t = (this.apiCtrl.current?.workflowData?.events ?? []).filter((e) => e.type == this.wfType);
    return this.modifyArray(t, this._events), this._events;
  }
  /**
   * Returns the current workflow event of the given type.
   * @param wfType Event type of the workflow event.
   * @returns Returns the current workflow event of the given type.
   */
  getWorkflowEvent(t) {
    return this.getSingleWorkflowEvent(t);
  }
  /**
   * Returns true if the workflow of the current item has an event of the given type.
   * @param wfType Event type of the workflow event.
   * @returns Returns true if the current item contains an event of the given type.
   */
  hasWorkflowEvent(t) {
    return !!this.getWorkflowEvent(t);
  }
  /**
   * Adds/updates the workflow event for the current item.
   * @param wfEvent Workflow event to add/update.
   * @returns Reloaded item.
   */
  saveWorkflowEvent(t) {
    if (!this.isUpdating)
      return this.isUpdating = !0, this.workflowService.saveWorkflowEvent(this.apiCtrl, t).then((e) => (this.isUpdating = !1, this.onChange && this.onChange({ item: e, isDelete: !1 }), e));
  }
  /**
   * Deletes the given event or all events with given type.
   * @param wfIdOrType Id or type of the workflow event.
   * @returns - Reloaded item.
   */
  deleteWorkflowEvent(t) {
    if (!this.isUpdating)
      return this.isUpdating = !0, this.workflowService.deleteWorkflowEvent(this.apiCtrl, t).then((e) => (this.isUpdating = !1, this.onChange && this.onChange({ item: e, isDelete: !0 }), e));
  }
  /**
   * Shows a workflow editor for the given event.
   * Saves the event and reloads the item.
   * @param config Configuration for the worklow editor.
   * @param wfEvent Workflow event for the editor.
   * @returns - Reloaded item.
   */
  showWorkflowEventEditor(t, e) {
    return this.apiCtrl.current ? (t.title = t.title || "SALAXY.NG1.WorkFlowIssueComponent.showWorkflowEventEditorTitle", this.uiHelpers.openEditDialog(
      "salaxy-components/modals/workflow/WorkflowEventEdit.html",
      e,
      {
        ...t,
        readOnly: this.readOnly
      }
    ).then((a) => a.action === "ok" ? this.saveWorkflowEvent(a.item) : Promise.resolve(this.apiCtrl.current))) : Promise.resolve(this.apiCtrl.current);
  }
  /** Returns avatar for the given credential. */
  getCredential(t) {
    return this.credentials.find((e) => e.id === t) || {};
  }
  /** Gets the credetial of the current assigned-to person or undefined if there is no assignment. */
  getAssignedTo() {
    const t = this.getWorkflowEvent("PartnerMessageAssignedTo")?.assignedTo;
    if (t)
      return this.getCredential(t);
  }
  /** Returns credentials for the current account. */
  get credentials() {
    return this.workflowService.credentials;
  }
  /** Returns the credential for current session */
  get self() {
    return this.workflowService.self;
  }
  /**
   * Responds to button click with appropriate UI logic.
   * @param type The button that was clicked.
   * @param credential The credential to assign to. Only for type "assign". Use undefined to remove assignment.
   */
  buttonClick(t, e) {
    switch (t) {
      case "close":
        this.hasWorkflowEvent("PartnerMessageClosed") ? this.uiHelpers.showConfirm("SALAXY.NG1.WorkFlowIssueComponent.deleteConfirmations.close").then((a) => {
          a && this.deleteWorkflowEvent("PartnerMessageClosed");
        }) : this.saveWorkflowEvent({
          type: "PartnerMessageClosed",
          ui: cc.Success,
          message: L.get("SALAXY.UI_Terms.checked")
        });
        return;
      case "issue":
        this.hasWorkflowEvent("PartnerMessageIssue") ? this.uiHelpers.showConfirm("SALAXY.NG1.WorkFlowIssueComponent.deleteConfirmations.issue").then((a) => {
          a && this.deleteWorkflowEvent("PartnerMessageIssue");
        }) : this.showWorkflowEventEditor(
          { title: void 0, showUi: !1 },
          { type: "PartnerMessageIssue", ui: cc.Danger, message: "" }
        );
        return;
      case "assign":
        e ? this.saveWorkflowEvent({
          type: "PartnerMessageAssignedTo",
          ui: cc.Primary,
          message: e.email || e.avatar.displayName,
          assignedTo: e.id
        }) : this.deleteWorkflowEvent("PartnerMessageAssignedTo");
        return;
      default:
        throw new Error("Not implemented: " + t);
    }
  }
  modifyArray(t, e) {
    wt.equals(t, e) || (e.splice(0, e.length), e.push(...t));
  }
  getSingleWorkflowEvent(t) {
    if (!this.apiCtrl.current || !t)
      return null;
    const e = this.apiCtrl.current?.workflowData;
    return !e || !e.events ? null : e.events.find((a) => (a.type || "").toLowerCase() === t.toLowerCase());
  }
};
kk.$inject = [
  "WorkflowService",
  "UiHelpers",
  "SessionService",
  "CredentialService"
];
let Nu = kk;
function E6(s) {
  return s.workflowData !== void 0;
}
function HI(s) {
  return s.messages !== void 0;
}
const Tk = class Tk {
  /**
   * Creates a new WorkflowBadgeController
   * @ignore
   */
  constructor(t, e, a) {
    this.uiHelpers = t, this.records = e, this.uploadService = a, this._events = [];
  }
  /**
   * Implement IController
   */
  $onInit() {
  }
  /** Workflow events for ui. */
  get events() {
    if (E6(this.model)) {
      const t = (this.model.workflowData?.events ?? []).filter((e) => !this.wfTypes || this.wfTypes.length == 0 || this.wfTypes.indexOf(e.type) >= 0);
      this.modifyArray(t, this._events);
    } else if (HI(this.model)) {
      const t = [];
      for (const e of this.model.messages) {
        const a = this.toWorkflowEvent(e);
        (!this.wfTypes || this.wfTypes.length == 0 || this.wfTypes.indexOf(a.type) >= 0) && t.push(a);
      }
      this.modifyArray(t, this._events);
    } else
      this.modifyArray([], this._events);
    return this._events;
  }
  /** Opens a display for workflow event details */
  showEventDetails(t) {
    const e = () => {
      if (HI(this.model)) {
        const n = this.apiCtrl.getApi().getBaseUrl() === "/accounts/workers" ? this.model.otherId : this.model.id;
        return this.apiCtrl.getApi().getSingle(n);
      } else
        return Promise.resolve(this.model);
    };
    (t?.id ? e().then((n) => Promise.resolve(n.workflowData.events.find((i) => i.id == t.id)).then((i) => i ? i.record ? this.records.getSingle(i.record).then((r) => ({ event: i, record: r })) : { event: i, record: null } : { event: t, record: null })) : Promise.resolve({ event: t, record: null })).then((n) => {
      this.uiHelpers.openEditDialog(
        "salaxy-components/modals/workflow/WorkflowBadgeDetails.html",
        n,
        {
          getAttachmentDownloadUrl: (i) => this.getAttachmentDownloadUrl(i),
          getAttachmentIcon: (i) => this.getAttachmentIcon(i)
        }
      );
    });
  }
  /** Returns file icon for the attachment. */
  getAttachmentIcon(t) {
    return this.uploadService.getFileIcon(t?.fileName);
  }
  /** Returns download url for the attachment. */
  getAttachmentDownloadUrl(t) {
    return this.uploadService.getFileUrl(t?.contentId);
  }
  toWorkflowEvent(t) {
    if (!t)
      return {};
    const e = t.indexOf("(Ui"), a = t.indexOf("):", e + 3), n = t.substring(0, e - 1) || "", i = t.substring(e + 3, a).toLowerCase();
    let r = t.substring(a + 3);
    const l = r.lastIndexOf("("), o = r.substring(0, l).trim();
    r = r.substring(l + 1), r = r.substring(0, r.length - 1);
    let c = "";
    const d = r.lastIndexOf(" id ");
    d >= 0 && (c = r.substring(d + 4), r = r.substring(0, d));
    let p = "";
    const h = r.lastIndexOf(" to ");
    h >= 0 && (p = r.substring(h + 4), r = r.substring(0, h));
    let g = "";
    const x = r.lastIndexOf(" at ");
    return x >= 0 && (g = r.substring(x + 4), r = r.substring(0, x), g = g.replace(" ", "T") + "Z"), {
      id: c,
      type: n,
      ui: i,
      user: r,
      assignedTo: p,
      message: o,
      time: g
    };
  }
  modifyArray(t, e) {
    wt.equals(t, e) || (e.splice(0, e.length), e.push(...t));
  }
};
Tk.$inject = [
  "UiHelpers",
  "Records",
  "UploadService"
];
let Sy = Tk;
class Ct {
  constructor() {
    this.templateUrl = ["$element", "$attrs", (t, e) => e.templateUrl ? e.templateUrl : this.defaultTemplate];
  }
}
class N6 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {}, this.controller = vi, this.defaultTemplate = "salaxy-components/account/AccountInfo.html";
  }
}
class R6 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {}, this.transclude = {
      main: "?main",
      header: "?header"
    }, this.controller = hm, this.defaultTemplate = "salaxy-components/account/AssurePartner.html";
  }
}
class Y6 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** Id that specifies what auth card to be shown */
      authId: "<",
      /** If set to true, the switch is not shown on the card. */
      hideSwitch: "@"
    }, this.controller = Hl, this.defaultTemplate = "salaxy-components/account/AuthCard.html";
  }
}
class _6 extends Ct {
  constructor() {
    super(...arguments), this.bindings = Hl.crudBindings, this.transclude = {
      header: "?header"
    }, this.controller = Hl, this.defaultTemplate = "salaxy-components/account/AuthorizedAccounts.html";
  }
}
class O6 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {}, this.transclude = {
      header: "?header"
    }, this.controller = Hl, this.defaultTemplate = "salaxy-components/account/AuthorizingAccounts.html";
  }
}
class M6 extends Ct {
  constructor() {
    super(...arguments), this.bindings = au.crudBindings, this.transclude = {
      header: "?header"
    }, this.controller = au, this.defaultTemplate = "salaxy-components/account/Certificates.html";
  }
}
class X6 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      showEdit: "<"
    }, this.transclude = {
      header: "?header"
    }, this.controller = pm, this.defaultTemplate = "salaxy-components/account/Credentials.html";
  }
}
class G6 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {}, this.controller = vi, this.defaultTemplate = "salaxy-components/account/LanguageSelector.html";
  }
}
class H6 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** URL to which the user should be redirected. When you specify string, use quotes. */
      redirectUrl: "<",
      /** If specified, sets the login text. Default is "SALAXY.UI_Terms.login"  */
      loginText: "@",
      /** If specified, sets the button class. Default is "btn-default". */
      btnClass: "@"
    }, this.controller = vi, this.defaultTemplate = "salaxy-components/account/LoginButton.html";
  }
}
class U6 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** If true, shows the component even if the Signing is already OK. */
      showAlways: "<",
      /** If true, component shows success popup */
      showInPopup: "<"
    }, this.controller = im, this.defaultTemplate = "salaxy-components/account/Signing.html";
  }
}
class F6 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {}, this.controller = vi, this.defaultTemplate = "salaxy-components/account/UserInfo.html";
  }
}
class z6 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {}, this.controller = vi, this.defaultTemplate = "salaxy-components/account/AccountAvatarEdit.html";
  }
}
class B6 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {}, this.controller = vi, this.defaultTemplate = "salaxy-components/account/AccountContactEdit.html";
  }
}
class W6 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** The calculation that is being edited  */
      model: "<",
      /**
       * If true, will also update the calculation rows from employment relation when the employment
       * relation is selected. By default, does not update the rows.
       */
      updateRows: "<"
    }, this.controller = mm, this.defaultTemplate = "salaxy-components/calc/2022/CalcEmployment.html";
  }
}
class j6 extends Ct {
  constructor() {
    super(...arguments), this.bindings = Vl.bindings, this.transclude = {
      footer: "?footer"
    }, this.controller = Vl, this.defaultTemplate = "salaxy-components/calc/2022/CalcRowsEditor.html";
  }
}
class V6 extends Ct {
  constructor() {
    super(...arguments), this.bindings = lu.crudBindings, this.controller = lu, this.defaultTemplate = "salaxy-components/calc/2022/CalcUsecase.html";
  }
}
class q6 extends Ct {
  constructor() {
    super(...arguments), this.bindings = new class extends fa {
      constructor() {
        super(...arguments), this.actions = "<", this.payrollDetailsCurrentTab = "@";
      }
    }(), this.controller = gu, this.defaultTemplate = "salaxy-components/calc/payrollV4/PayrollDetails.html";
  }
}
class K6 extends Ct {
  constructor() {
    super(...arguments), this.bindings = new class extends fa {
      constructor() {
        super(...arguments), this.hideButton = "<", this.mode = "<";
      }
    }(), this.transclude = {
      header: "?header"
    }, this.controller = gu, this.defaultTemplate = "salaxy-components/calc/payrollV4/PayrollDetailsList.html";
  }
}
class J6 extends Ct {
  constructor() {
    super(...arguments), this.bindings = new class extends fa {
      constructor() {
        super(...arguments), this.actions = "<";
      }
    }(), this.controller = mu, this.defaultTemplate = "salaxy-components/calc/payroll/PayrollEdit.html";
  }
}
class Q6 extends Ct {
  constructor() {
    super(...arguments), this.bindings = new class extends fa {
      constructor() {
        super(...arguments), this.hideButton = "<", this.mode = "<";
      }
    }(), this.transclude = {
      header: "?header"
    }, this.controller = mu, this.defaultTemplate = "salaxy-components/calc/payroll/PayrollList.html";
  }
}
class Z6 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** Filters list by given field:value */
      filter: "@",
      /** Max count of calculations to show in the list. */
      limitTo: "<",
      /** Status category for the list. Possible categories: draft, paid. Default is paid */
      category: "@",
      /**
       * List of statuses to include in the list.
       * WARNING: This may be depricated in v03: Use category and/or $filter instead.
       */
      statusList: "<",
      /**
       * Function that is called when user selects an item in the list.
       * Note that the event is called only in the selections (single and multi). Not when there is a link to details view in a link list.
       * Function has the following locals: value: true/false, item: the last selected/unselected item, allItems: Array of all currently selected items.
       * @example <salaxy-employment-list mode="select" on-list-select="$ctrl.updateFromEmployment(item.id)"></salaxy-employment-list>
       */
      onListSelect: "&",
      /** Selected items for the case where the list is used as a select list (as opposed to link list). */
      selectedItems: "<",
      /** Type of the view. Currently supports "default", "panel" and "select" */
      mode: "@",
      /** OData query options */
      options: "<",
      /** URL to the OData service. */
      url: "@",
      /** Data passed from the parent to the component / view */
      data: "<",
      /** If readOnly is true, edit, copy etc. buttons from the new list view are hidden if readOnly property is supported */
      readOnly: "<",
      /**
       * CRUD controller that implements Delete and potentially other methods about the object.
       * If you wish to use this in the view use "as $controllerName" syntax
       * @example
       * <salaxy-odata-table crud-controller="CalculationCrudController as $crud">
       */
      crudController: "@"
    }, this.controller = ni, this.defaultTemplate = "salaxy-components/calc/payroll/PayrollSelectList.html";
  }
}
class tq extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** Filters list by given field:value */
      filter: "@",
      /** Max count of calculations to show in the list. */
      limitTo: "<",
      /** Status category for the list. Possible categories: draft, paid. Default is paid */
      category: "@",
      /**
       * List of statuses to include in the list.
       * WARNING: This may be depricated in v03: Use category and/or $filter instead.
       */
      statusList: "<",
      /**
       * Function that is called when user selects an item in the list.
       * Note that the event is called only in the selections (single and multi). Not when there is a link to details view in a link list.
       * Function has the following locals: value: true/false, item: the last selected/unselected item, allItems: Array of all currently selected items.
       * @example <salaxy-employment-list mode="select" on-list-select="$ctrl.updateFromEmployment(item.id)"></salaxy-employment-list>
       */
      onListSelect: "&",
      /** Selected items for the case where the list is used as a select list (as opposed to link list). */
      selectedItems: "<",
      /** Type of the view. Currently supports "default", "panel" and "select" */
      mode: "@",
      /** OData query options */
      options: "<",
      /** URL to the OData service. */
      url: "@",
      /** Data passed from the parent to the component / view */
      data: "<",
      /** If readOnly is true, edit, copy etc. buttons from the new list view are hidden if readOnly property is supported */
      readOnly: "<",
      /**
       * CRUD controller that implements Delete and potentially other methods about the object.
       * If you wish to use this in the view use "as $controllerName" syntax
       * @example
       * <salaxy-odata-table crud-controller="CalculationCrudController as $crud">
       */
      crudController: "@"
    }, this.controller = ni, this.defaultTemplate = "salaxy-components/calc/payrollV4/PayrollDetailsSelectList.html";
  }
}
class eq extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** Current payroll to assist */
      current: "<",
      /** Current page */
      page: "<"
    }, this.controller = Um, this.defaultTemplate = "salaxy-components/calc/payrollV4/PayrollAssistant.html";
  }
}
class aq extends Ct {
  constructor() {
    super(...arguments), this.bindings = $s.crudBindings, this.controller = km, this.defaultTemplate = "salaxy-components/calc/rows/CalcIrRows.html";
  }
}
class nq extends Ct {
  constructor() {
    super(...arguments), this.bindings = Vl.bindings, this.controller = Vl, this.defaultTemplate = "salaxy-components/calc/rows/CalcRows2019Editor.html";
  }
}
class sq extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** Calculation for the row. */
      calc: "<",
      /** The calculation row. */
      row: "<",
      /** Forced read only state */
      readOnly: "<",
      /**
       * Optional CostAccountingDimensionDefinitions
       * If not set, cost accounting dimensions and their options are read from the settings.
       */
      dimensions: "<"
    }, this.controller = Mm, this.defaultTemplate = "salaxy-components/calc/rows/CalcRowCostAccounting.html";
  }
}
class iq extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** Currently edited row */
      row: "<",
      /** Dimension definition. */
      definition: "<",
      /** Possible inherited dimensions values from upper lever (e.g. calc level to rows) */
      inherited: "<",
      /** Forced read only state */
      readOnly: "<",
      /**
       * Style of the inputs.
       * Supports empty or 'openClose'. Only available when not readOnly
       */
      inputMode: "@"
    }, this.controller = Pm, this.defaultTemplate = "salaxy-components/calc/rows/CalcRowDimensionInput.html";
  }
}
class rq extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** Calculations for report. */
      calcs: "<",
      /** The language of report. */
      lang: "<"
    }, this.controller = Rm, this.defaultTemplate = "salaxy-components/calc/rows/CalcsIrRows.html";
  }
}
class lq extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** The calculation row. */
      row: "<"
    }, this.controller = Em, this.defaultTemplate = "salaxy-components/calc/rows/CalcRowDocumentation.html";
  }
}
class oq extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** The calculation row. */
      row: "<"
    }, this.controller = TE, this.defaultTemplate = "salaxy-components/calc/rows/CalcRowFormula.html";
  }
}
class cq extends Ct {
  constructor() {
    super(...arguments), this.bindings = $s.crudBindings, this.controller = $s, this.defaultTemplate = "salaxy-components/calc/Calc.html";
  }
}
class dq extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** Calculation for which the chart is rendered.  */
      calc: "<",
      /** Role for which the chart is rendered. Currently, 'worker' and 'employer' are supported. Employer is the default. */
      role: "@",
      /** If true, the Y axis of this chart is scaled so that if worker and employer charts are side to side, their Y axis are the same */
      scaleYAxis: "<",
      /** Type of the chart - "pie" and "bar" (default) are currently supported. */
      chartType: "<",
      /** - colors: Custom colors for the chart as a string containing hex values of the colors, separated by comma */
      colors: "@"
    }, this.controller = $m, this.defaultTemplate = "salaxy-components/calc/CalcChart.html";
  }
}
class uq extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /**
       * Option to hide new calc button.
       * Set this true if the site has action buttons configured elsewhere.
       */
      hideButton: "<",
      /** If readOnly is true, edit, copy etc. buttons from the new list view are hidden if readOnly property is supported */
      readOnly: "<"
    }, this.controller = ni, this.defaultTemplate = "salaxy-components/calc/CalcDashboard.html";
  }
}
class pq extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** Filters list by given field:value */
      filter: "@",
      /** Max count of calculations to show in the list. */
      limitTo: "<",
      /** Status category for the list. Possible categories: draft, paid. Default is paid */
      category: "@",
      /**
       * List of statuses to include in the list.
       * WARNING: This may be depricated in v03: Use category and/or $filter instead.
       */
      statusList: "<",
      /**
       * Function that is called when user selects an item in the list.
       * Note that the event is called only in the selections (single and multi). Not when there is a link to details view in a link list.
       * Function has the following locals: value: true/false, item: the last selected/unselected item, allItems: Array of all currently selected items.
       * @example <salaxy-employment-list mode="select" on-list-select="$ctrl.updateFromEmployment(item.id)"></salaxy-employment-list>
       */
      onListSelect: "&",
      /** Selected items for the case where the list is used as a select list (as opposed to link list). */
      selectedItems: "<",
      /** Type of the view. Currently supports "default", "panel" and "select" */
      mode: "@",
      /** OData query options */
      options: "<",
      /** URL to the OData service. */
      url: "@",
      /** Data passed from the parent to the component / view */
      data: "<",
      /** If readOnly is true, edit, copy etc. buttons from the new list view are hidden if readOnly property is supported */
      readOnly: "<",
      /**
       * CRUD controller that implements Delete and potentially other methods about the object.
       * If you wish to use this in the view use "as $controllerName" syntax
       * @example
       * <salaxy-odata-table crud-controller="CalculationCrudController as $crud">
       */
      crudController: "@"
    }, this.controller = ni, this.defaultTemplate = "salaxy-components/calc/CalcList.html";
  }
}
class hq extends Ct {
  constructor() {
    super(...arguments), this.bindings = $s.crudBindings, this.controller = $s, this.defaultTemplate = "salaxy-components/calc/CalcNewIntro.html";
  }
}
class mq extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** The calculation for the report. */
      calc: "<",
      /** Calculation report type (for example: salarySlip, employerReport or paymentReport) */
      reportType: "<",
      /** Template for the report (for example: salarySlipV2, employerReportV2, paymentReportV2 ) */
      templateName: "<",
      /** If true, uses the current style of the site. The default value is false. */
      applySiteStyles: "<",
      /** The language for report*/
      lang: "<",
      /** If true, adds the preview watermark to the report */
      preview: "<",
      /** Called when the report type has been changed. */
      onReportTypeChange: "&"
    }, this.controller = Tm, this.defaultTemplate = "salaxy-components/calc/CalcReport.html";
  }
}
class gq extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** The calculations for the report. */
      calcs: "<",
      /** Current report type. */
      reportType: "<",
      /**
       * The default view shown in the UI: "partial" (default), "page1" or "full".
       * Please note that not all reports support "page1" or "full".
       */
      view: "@",
      /** If true, adds the preview watermark to the report */
      preview: "<",
      /** Called when the report type has been changed. */
      onReportTypeChange: "&"
    }, this.controller = Lm, this.defaultTemplate = "salaxy-components/calc/CalcReports.html";
  }
}
class yq extends Ct {
  constructor() {
    super(...arguments), this.bindings = $s.crudBindings, this.controller = $s, this.defaultTemplate = "salaxy-components/calc/CalcResults.html";
  }
}
class fq extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** Type of the input element. Options are typeahead and list (select, search-list and radio may be supported later). */
      type: "@",
      /** If set, filters the rows based on categories (plus rowTypes if set) */
      categories: "<",
      /** If set, shows only these types (plus categories if set) */
      rowTypes: "<",
      /** Name and identifier of the typeahead input */
      name: "@",
      /**
       * Placeholder text in the typeahead input.
       * Default is 'SALAXY.UI_Terms.select'.
       */
      placeholder: "@",
      /** The calculation row that this component modifies. */
      model: "<",
      /**
       * Function that is called after the row type and potentially kind and message have been changed.
       * @example <salaxy-calc-row-type on-row-changed="$ctrl.commitNewRow()"></salaxy-calc-row-type>
       */
      onRowChanged: "&",
      /** If true, the list will show all the children under each parent that is shown */
      showChildren: "<",
      /** Normally (default true), the selected value is cleared and a row is created/added, but in some cases (false) the value is saved as-is (and not cleared - the typical typeahead element behaviour). */
      clearOnSelect: "<"
    }, this.controller = Dm, this.defaultTemplate = "salaxy-components/calc/CalcRowType.html";
  }
}
class bq extends Ct {
  constructor() {
    super(...arguments), this.bindings = new class extends fa {
      constructor() {
        super(...arguments), this.type = "<", this.disabled = "<", this.buttonClass = "@", this.iconOnly = "<";
      }
    }(), this.controller = Nm, this.defaultTemplate = "salaxy-components/calc/CalcSharingReceiptAction.html";
  }
}
class vq extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** The calculation*/
      calc: "<",
      /** The worktime*/
      worktime: "<"
    }, this.controller = Gm, this.defaultTemplate = "salaxy-components/calc/CalcLeaves.html";
  }
}
class xq extends Ct {
  constructor() {
    super(...arguments), this.bindings = $s.crudBindings, this.controller = $s, this.defaultTemplate = "salaxy-components/calc/CalcWorkerInfo.html";
  }
}
class wq extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** The calculation that the component edits (shows in read-only mode). */
      calc: "<"
    }, this.controller = Im, this.defaultTemplate = "salaxy-components/calc/CalcWorktime.html";
  }
}
class Aq extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /**
       * The current business item that is being paid: Either Calculation or PayrollDetails.
       * Currently only supports direct reference. May later support 'url' etc. like CRUD controllers.
       */
      model: "<",
      /** Expression for ng-disabled of the input. */
      disabled: "<",
      /**
       * Additional class / classes for button. Can also be used to override default btn-primary class styles.
       * (i.e. <salaxy-pay-button button-class="btn-lg uppercase btn-success">)
       */
      buttonClass: "@",
      /**
       * Text for the payment button.
       * This is typically customized in custom payment scenarios.
       */
      label: "@",
      /** Mode is either "pay-button" (default), "channel-select", "button-and-channel" or "button-and-channel-horizontal" */
      mode: "@",
      /** Called when the payment channel has been changed. */
      onPaymentChannelChange: "&"
    }, this.controller = "PaymentController", this.defaultTemplate = "salaxy-components/calc/PayButton.html";
  }
}
class Cq extends Ct {
  constructor() {
    super(...arguments), this.bindings = new class extends fa {
    }(), this.controller = _m, this.defaultTemplate = "salaxy-components/calc/CalcEditor.html";
  }
}
class $q extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** The calculation. */
      calc: "<",
      /** Forced read only state */
      readOnly: "<",
      /**
       * Optional CostAccountingDimensionDefinitions
       * If not set, cost accounting dimensions and their options are read from the settings.
       */
      dimensions: "<",
      /**
       * Style of the inputs.
       * Supports empty or 'openClose'. Only available in not readOnly
       */
      inputMode: "@"
    }, this.controller = Om, this.defaultTemplate = "salaxy-components/calc/CalcCostAccounting.html";
  }
}
class Sq extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** Dimension values for edit. */
      current: "<",
      /** Possible inherited dimensions values from upper lever (e.g. calc level to rows) */
      inherited: "<",
      /** Forced read only state */
      readOnly: "<",
      /**
       * Optional CostAccountingDimensionDefinitions
       * If not set, cost accounting dimensions and their options are read from the settings.
       */
      dimensions: "<",
      /**
       * Scope for the cost accounting: calculation or row.
       */
      scope: "@",
      /**
       * Style of the inputs.
       * Supports empty or 'openClose'. Only available when not readOnly
       */
      inputMode: "@"
    }, this.controller = Cc, this.defaultTemplate = "salaxy-components/calc/CostAccounting.html";
  }
}
class kq extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /**
       * The current object containing salaryDateKind -field: Either Calculation or PayrollDetails.
       */
      model: "<",
      /** Expression for ng-disabled of the input. */
      disabled: "<",
      /**
       * Additional class / classes for button. Can also be used to override default btn-primary class styles.
       * (i.e. <salaxy-pay-button button-class="btn-lg uppercase btn-success">)
       */
      buttonClass: "@",
      /** Called when the salary date kind has been changed. */
      onSalaryDateKindChange: "&"
    }, this.controller = Xm, this.defaultTemplate = "salaxy-components/calc/SalaryDateKindButton.html";
  }
}
class Tq extends Ct {
  constructor() {
    super(...arguments), this.bindings = new class extends fa {
    }(), this.controller = Hm, this.defaultTemplate = "salaxy-components/calc/CalcRepair.html";
  }
}
class Lq extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** If true, short version of the content is shown */
      showShortContent: "=",
      /** If true, contact info is hidden */
      hideContactInfo: "<"
    }, this.controller = LE, this.defaultTemplate = "salaxy-components/communications/ContactInfo.html";
  }
}
class Dq extends Ct {
  constructor() {
    super(...arguments), this.transclude = {
      /** A "header" element can be used to add HTML on top of the message thread (where the header is now). */
      header: "?header",
      /** A "header-new" element overrides the default text for new message thread. */
      headerNew: "?headerNew"
    }, this.bindings = new class extends fa {
      constructor() {
        super(...arguments), this.role = "@", this.otherParty = "<", this.otherPartyOptions = "<", this.markAsRead = "<", this.approvalUrl = "@";
      }
    }(), this.controller = yu, this.defaultTemplate = "salaxy-components/communications/MessageThread.html";
  }
}
class Iq extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** Current calculation */
      calc: "<"
    }, this.controller = Fm, this.defaultTemplate = "salaxy-components/communications/VarmaBanner.html";
  }
}
class Pq extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /**
       * If set to true, the settings are handled by proxy:
       * we do not ask the user to change the settings in
       * the Welcome screen (mainly Pension or Insurance).
       */
      settingsByProxy: "<"
    }, this.controller = zm, this.defaultTemplate = "salaxy-components/communications/Welcome.html";
  }
}
class Eq extends Ct {
  constructor() {
    super(...arguments), this.bindings = Cu.bindings, this.controller = Cu, this.defaultTemplate = "salaxy-components/communications/messages/message-types/HourlyReport.html";
  }
}
class Nq extends $r {
  constructor() {
    super(...arguments), this.timerMode = "@", this.crudController = "<";
  }
}
class Rq extends Ct {
  constructor() {
    super(...arguments), this.bindings = new Nq(), this.controller = Og, this.defaultTemplate = "salaxy-components/communications/messages/message-types/Timer.html";
  }
}
class Yq extends Ct {
  constructor() {
    super(...arguments), this.bindings = $u.bindings, this.controller = $u, this.defaultTemplate = "salaxy-components/communications/messages/message-types/ExpenseReport.html";
  }
}
class _q extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** Max count of threads to show in the list. */
      limitTo: "<",
      /** If readOnly is true, create buttons from the list view are hidden if readOnly property is supported */
      readOnly: "<",
      /**
       * URL for the approval view.
       */
      approvalUrl: "@"
    }, this.controller = ni, this.defaultTemplate = "salaxy-components/communications/MessageThreadList.html";
  }
}
class Oq extends Ct {
  constructor() {
    super(...arguments), this.require = {
      model: "ngModel",
      form: "?^^form"
    }, this.bindings = Qe.extend(Ia.crudBindings, {
      /**
       * Preset algorithms for enabled/disabled dates.
       * Currently, "salary" and "next-weekday" are implemented.
       * If set as "disable-function", you should set the disable-function too.
       */
      dateDisabled: "@",
      /** Disable function for date. If set, date-disabled is ignored. */
      disableFunction: "<",
      /** Payment channel. This affects which dates are disabled in the salary date selection. */
      paymentChannel: "<",
      /** Zero payment (no worker net salary payment). This affects which dates are disabled in the salary date selection. */
      zeroPayment: "<",
      /**
       * Minimum available date.
       * Bindable and ISO string version of the datepicker-options.minDate.
       * Currently not supported together with dateDisabled filters.
       */
      minDate: "<",
      /**
       * Maximum available date.
       * Bindable and ISO string version of the datepicker-options.maxDate.
       * Currently not supported together with dateDisabled filters.
       */
      maxDate: "<",
      /**
       * If true, can pick multiple dates from the selector.
       */
      isMultiple: "<",
      /**
       * If true, datepicker watches for external changes that should be reflected in this picker.
       */
      watchChanges: "<",
      /**
       * Whether to show timepicker alongside the calendar.
       */
      timepicker: "<",
      /**
       * Whether to show Today/Clear buttons below the calendar.
       */
      showButtons: "<"
    }), this.controller = bu, this.defaultTemplate = "salaxy-components/form-controls/Datepicker.html";
  }
}
class Mq extends Ct {
  constructor() {
    super(...arguments), this.require = {
      model: "ngModel",
      form: "?^^form"
    }, this.bindings = Qe.extend(Ia.crudBindings, {
      /** Format for the date, default is d.M.yyyy */
      format: "@",
      /**
       * Preset algorithms for enabled/disabled dates.
       * Currently, only "salary" is supported for salary dates, but more might be added later.
       * If set as "disable-function", you should set the disable-function too.
       */
      dateDisabled: "@",
      /** Disable function for date. If set, date-disabled is ignored. */
      disableFunction: "<",
      /** Payment channel. This affects which dates are disabled in the salary date selection. */
      paymentChannel: "<",
      /** Zero payment (no worker net salary payment). This affects which dates are disabled in the salary date selection. */
      zeroPayment: "<",
      /**
       * Minimum available date.
       * Bindable and ISO string version of the datepicker-options.minDate.
       * Currently not supported together with dateDisabled filters.
       */
      minDate: "<",
      /**
       * Maximum available date.
       * Bindable and ISO string version of the datepicker-options.maxDate.
       * Currently not supported together with dateDisabled filters.
       */
      maxDate: "<",
      onChange: "&"
    }), this.controller = Bm, this.defaultTemplate = "salaxy-components/form-controls/DatepickerPopup.html";
  }
}
class Xq extends Ct {
  constructor() {
    super(...arguments), this.require = {
      model: "ngModel",
      form: "?^^form"
    }, this.bindings = Qe.extend(Ia.crudBindings, {
      /**
       * Label for the scondary input (Default: SALAXY.NG1.DateRange.labelDaysCount).
       * Translation is attempted.
       */
      labelDaysCount: "@",
      /**
       * The selection mode is either:
       *
       * - "range" for (default) calendar control with start and end.
       * - "calc" for period selection that is optimized for salary calculation (months, 2 weeks, 1/2 months etc.)
       */
      mode: "@",
      /**
       * Fires an event when the model is changing: Any of the values specific to the model are changing: start, end or daysCount.
       * This should typically used instead of ng-change because ng-change will only fire if the object reference changes.
       * On-change fires when dates or day count changes and this is typically what you are looking for.
       * @example <salaxy-date-range ng-model="$ctrl.dateRange" on-change="$ctrl.dateRangeChange()"></salaxy-date-range>
       */
      onChange: "&",
      /**
       * The data range values: start, end, daysCount and formattedDate.
       */
      dateRangeValues: "<"
    }), this.controller = Wm, this.defaultTemplate = "salaxy-components/form-controls/DateRange.html";
  }
}
class Gq extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** Name of the input - also used as id. */
      name: "@",
      /** Label for the control */
      label: "@",
      /**
       * @deprecated Use "require" instead:
       * This attribute overlaps with required/ng-required directive, which produces unexpected results.
       */
      required: "@",
      /** If true the field is required (form validation) */
      require: "<",
      /**
       * Positioning of the label of form-control.
       * Supported values are "horizontal" (default), "no-label", "plain", "basic" and "empty-label".
       * See FormGourpLabelType for details.
       */
      labelType: "@",
      /**
       * Label columns expressed as Bootstrap grid columns.
       * Default is 'col-sm-4' for label-type: 'horizontal' and 'col-sm-12' for label-type: 'no-label'.
       * Other label-types do not have column classes at the moment.
       */
      labelCols: "@"
    }, this.transclude = !0, this.controller = Px, this.defaultTemplate = "salaxy-components/form-controls/FormGroup.html";
  }
}
class Hq extends Ct {
  constructor() {
    super(...arguments), this.require = {
      model: "ngModel",
      form: "?^^form"
    }, this.bindings = Qe.extend(Ia.crudBindings, {
      /** Minimum length for the text value, default is 0 (form validation) */
      minlength: "@",
      /** Maximum length for the text value, default is 1024 (form validation) */
      maxlength: "@",
      /** Regular expression pattern for validation (form validation) */
      pattern: "@",
      /** Type for the input. Defaults to text. Supports currently text and password. */
      type: "@"
    }), this.controller = xi, this.defaultTemplate = "salaxy-components/form-controls/Input.html";
  }
}
class Uq extends Ct {
  constructor() {
    super(...arguments), this.require = {
      model: "ngModel",
      form: "?^^form"
    }, this.bindings = Ia.crudBindings, this.controller = Ex, this.defaultTemplate = "salaxy-components/form-controls/InputAccountingTarget.html";
  }
}
class Fq extends Ct {
  constructor() {
    super(...arguments), this.require = {
      model: "ngModel",
      form: "?^^form"
    }, this.bindings = Qe.extend(Ia.crudBindings, {
      /** Type of the input element. Options are checkbox, radio, select and switch */
      type: "@",
      /**
       * Text to show as a label for input with value FALSE
       * Supported by types radio and select
       */
      labelFalse: "@",
      /**
       * Text to show as a label for input with value TRUE
       * Supported by types radio, checkbox and select
       */
      labelTrue: "@",
      /**
       * TODO: Is this needed when there's support for 'empty-label' ?
       * BS class for offsetting the input (no-label)
       */
      offsetCols: "@",
      /** If true, the radio buttons are aligned horizontally side-by-side */
      horizontal: "<"
    }), this.controller = jm, this.defaultTemplate = "salaxy-components/form-controls/InputBoolean.html";
  }
}
class zq extends Ct {
  constructor() {
    super(...arguments), this.require = {
      model: "ngModel",
      form: "?^^form"
    }, this.bindings = Qe.extend(Ia.crudBindings, {
      /** List of collective bargain agreement codes to exclude from the selection list. */
      hiddenCodes: "<"
    }), this.controller = Vm, this.defaultTemplate = "salaxy-components/form-controls/InputCollectiveBargainAgreement.html";
  }
}
class pR extends Ct {
  constructor() {
    super(...arguments), this.require = {
      model: "ngModel",
      form: "?^^form"
    }, this.bindings = Qe.extend(Ia.crudBindings, {
      /**
       * Binds to an enumeration defined by the Salaxy API.
       * Set the name of the enumeration.
       */
      enum: "@",
      /**
       * Options of the select control as a key-value object.
       */
      options: "<",
      /** Type of the input element. Options are select, multi-select, radio and dropdown */
      type: "@",
      /**
       * These values are visible only if they are selected in the data.
       * I.e. after something else is selected, hidden value cannot be selected back.
       * Use for not-selected values ("Please choose...") when you do not want selection reversed
       * or legacy data that is not selectable, but may still exist on the server.
       */
      hiddenOptions: "@",
      /**
       * Array or comma separated string to filter the option values to just the given ones.
       * Also sets the order to this order, so works for ordering a given set of values.
       * Note that hiddenOptions is applied first, so if you want e.g. "undefined" to appear if selected,
       * you may add it here and it behaves as expected (undefined is still hidden if a value is selevted).
       */
      filter: "@",
      /**
       * Comma serapated list of values that should not be considered as valid in the UI.
       * Default is ["unknown"] and is only used when input is "required" and input type is "select".
       * Use in situations where an unknown/other/none value is set in API but should not be available as an option.
       */
      invalidEnums: "@",
      /** If true, the control is not caching values. */
      disableCache: "@",
      /**
       * Label format for the option. The default format is to show only the text of the option.
       * Options are:
       * "text" or empty: only the text of the option is displayed.
       * "text-value": in addition to the text, the value is also displayed in the label.
       * "value": only the value is displayed.
       */
      labelFormat: "@",
      /**
       * If set, last selected option is stored in LocalStorage and set as default/selected value in element. Currently supported only in type 'select' and 'uib-dropbdown'.
       */
      remember: "@"
    }), this.controller = rA, this.defaultTemplate = "salaxy-components/form-controls/InputEnum.html";
  }
}
class Bq extends pR {
  constructor() {
    super(), this.controller = qm;
  }
}
class Wq extends Ct {
  constructor() {
    super(...arguments), this.require = {
      model: "ngModel",
      form: "?^^form"
    }, this.bindings = Qe.extend(Ia.crudBindings, {}), this.controller = Km, this.defaultTemplate = "salaxy-components/form-controls/InputDuration.html";
  }
}
class jq extends Ct {
  constructor() {
    super(...arguments), this.require = {
      model: "ngModel",
      form: "?^^form"
    }, this.bindings = Qe.extend(Ia.crudBindings, {
      /** Type of the input element is either typehead or list. Default is typeahead. */
      type: "@",
      /** List of income type codes to exclude from the selection list. */
      hiddenCodes: "<"
    }), this.controller = Jm, this.defaultTemplate = "salaxy-components/form-controls/InputIncomeType.html";
  }
}
class Vq extends Ct {
  constructor() {
    super(...arguments), this.require = {
      model: "ngModel",
      form: "?^^form"
    }, this.bindings = Qe.extend(Ia.crudBindings, {
      /**
       * Unit for the number.
       * If set, shows a visual clue of the unit.
       * For 'percent' editor value is multiplied by 100.
       */
      unit: "@",
      /**
       * Expression for the allowed Units for the number.
       * If set, shows a selection of control for the unit.
       */
      units: "<",
      /** Minimum number*/
      minimum: "@",
      /** Maximum number*/
      maximum: "@",
      /** Multiple of (step) number*/
      multipleOf: "@",
      /**
       * If true, the input edits negative value: The value is multiplied by -1.
       * E.g. "3" days ago => -3.
       */
      negative: "<",
      /** Type of the input element. Options: default or slider */
      type: "@",
      /** Step for slider */
      sliderStep: "@",
      /**
       * Function that is called when the unit has been changed.
       * Function has the following locals:  unit: the selected unit.
       */
      onUnitChange: "&"
    }), this.controller = PE, this.defaultTemplate = "salaxy-components/form-controls/InputNumber.html";
  }
}
class qq extends Ct {
  constructor() {
    super(...arguments), this.require = {
      model: "ngModel",
      form: "?^^form"
    }, this.bindings = Qe.extend(Ia.crudBindings, {
      /**
       * One or comma-separated list of occupation IDs, or a known keyword to define which occupations are shown
       * Supported keywords: 'household' and 'company'
       * If empty, shows all
       */
      defaultList: "@"
    }), this.controller = Nx, this.defaultTemplate = "salaxy-components/form-controls/InputOccupationType.html";
  }
}
class Kq extends Ct {
  constructor() {
    super(...arguments), this.require = {
      model: "ngModel",
      form: "?^^form"
    }, this.bindings = Qe.extend(Ia.crudBindings, {}), this.controller = ag, this.defaultTemplate = "salaxy-components/form-controls/InputRrule.html";
  }
}
class Jq extends Ct {
  constructor() {
    super(...arguments), this.require = {
      model: "ngModel",
      form: "?^^form"
    }, this.bindings = Qe.extend(Ia.crudBindings, {
      /**
       * Used type in input. Types are minutes and isoTime
       */
      type: "@"
    }), this.controller = HE, this.defaultTemplate = "salaxy-components/form-controls/InputTime.html";
  }
}
class Qq extends Ct {
  constructor() {
    super(...arguments), this.require = {
      model: "ngModel"
    }, this.bindings = Qe.extend(Ia.crudBindings, {
      /** The options to be displayed in the toggle buttons. For each given value, a new button is created. */
      options: "<",
      /** Display type of toggle buttons: "row", "inline" or "block" */
      type: "@",
      /** Type "row" toggle button has an image on top of the the text. */
      imgSrc: "@"
    }), this.controller = hN, this.defaultTemplate = "salaxy-components/form-controls/ToggleButtons.html";
  }
}
class Zq extends Ct {
  constructor() {
    super(...arguments), this.require = {
      model: "ngModel",
      form: "?^^form"
    }, this.bindings = Qe.extend(Ia.crudBindings, {
      /** Minimum length for the text value, default is 0 (form validation) */
      minlength: "@",
      /** Maximum length for the text value, default is 1024 (form validation) */
      maxlength: "@",
      /** Regular expression pattern for validation (form validation) */
      pattern: "@",
      /** The rows property of the textarea. Default is 3. */
      rows: "<"
    }), this.controller = xi, this.defaultTemplate = "salaxy-components/form-controls/Textarea.html";
  }
}
class t5 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** The server-side API-validation object that is displayed by this component. */
      apiValidation: "<",
      /** HTML that should be shown when the bound validation data is null. */
      loadingHtml: "@",
      /** Layout of the validation html. Use "minimal" for easy customizing*/
      layout: "@"
    }, this.transclude = !0, this.controller = ig, this.defaultTemplate = "salaxy-components/form-controls/ValidationSummary.html";
  }
}
class e5 extends Ct {
  constructor() {
    super(...arguments), this.require = {
      model: "ngModel",
      form: "?^^form"
    }, this.bindings = Qe.extend(Ia.crudBindings, {
      /**
       * Binds to an enumeration defined by the Salaxy API.
       * Set the name of the enumeration.
       */
      enum: "@",
      /**
       * Options of the select control as a key-value object.
       */
      options: "<",
      /**
       * Array or comma separated string to filter the option values to just the given ones.
       * Also sets the order to this order, so works for ordering a given set of values.
       * Note that hiddenOptions is applied first, so if you want e.g. "undefined" to appear if selected,
       * you may add it here and it behaves as expected (undefined is still hidden if a value is selevted).
       */
      filter: "@",
      /** If true, the control is not caching values. */
      disableCache: "@",
      /**
       * Label format for the option. The default format is to show only the text of the option.
       * Options are:
       * "text" or empty: only the text of the option is displayed.
       * "text-value": in addition to the text, the value is also displayed in the label.
       * "value": only the value is displayed.
       */
      labelFormat: "@",
      /** If true, upon selection the value is not set for the input field (it is used for other things thought). */
      clearOnSelect: "<",
      /** If true, save new values (ones typed but not found in the select list) to database. Used in ng1-aspa. */
      allowCustomValues: "<",
      /** True = return the typeahead selection object alongside the value. */
      returnObject: "<",
      /** The object data that's to be returned. */
      objectData: "=",
      /** True = The value is saved as a whole object, false = as a primitive (string/number/etc. from the item key "value") */
      valueAsObject: "<"
    }), this.controller = sg, this.defaultTemplate = "salaxy-components/form-controls/InputTypeahead.html";
  }
}
class a5 extends Ct {
  constructor() {
    super(...arguments), this.require = {
      model: "ngModel",
      form: "?^^form"
    }, this.bindings = Ia.crudBindings, this.controller = rg, this.defaultTemplate = "salaxy-components/form-controls/InputHolidayRowType.html";
  }
}
class n5 extends Ct {
  constructor() {
    super(...arguments), this.require = {
      model: "ngModel",
      form: "?^^form"
    }, this.bindings = Ia.crudBindings, this.controller = mN, this.defaultTemplate = "salaxy-components/form-controls/InputHolidayMultipliers.html";
  }
}
class s5 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** Text for the button */
      label: "@",
      /** Additional Bootstrap or custom style classes. Bootstrap I.e. btn-danger, btn-sm, my-btn. Defaults to btn-primary */
      buttonClass: "@",
      /** Disabled but visible */
      disabled: "<",
      /** Options for button. */
      options: "<",
      /**
       * Action to be executed.
       * newCalc: starts a new blank calculation.
       * newCalcForEmployment: starts a new calculation for the given employment id.
       * newPayroll: starts a new blank payroll.
       * newWorker: opens workerWizard for creating a new worker.
       * newMessage: starts a new message thread with partner.
       * payment: Not supported at the moment. opens the payment dialog for the current calculation.
       * newTaxcard: Links to taxcards page. Currently supported only when role is Worker.
       * newRepair: Starts a repair process for a calculation.
       */
      action: "<",
      /**
       * Function that is called after the function. This is typically used for navigation or a list reload.
       */
      onAfterAction: "&"
    }, this.controller = lg, this.defaultTemplate = "salaxy-components/helpers/ActionButton.html";
  }
}
let i5 = class extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /**
       * Possibility to speicfy a font-awesome icon.
       * Setting "none", will show no icon.
       * If not set, it is determined by type.
       */
      icon: "@",
      /** Type of the alert is the Bootstrap style: Note that also "primary" and "default" are supported. */
      type: "@",
      /**
       * Alert main content as simple text.
       * You can alternatively provide html as main element.
       */
      text: "@",
      /** If true, the aside part is shown immidiately. Also hides "read more"- button. */
      forceMoreInfo: "<"
    }, this.transclude = {
      /**
       * The main content of the alert.
       * You can alternatively provide a simple text in "text" property.
       */
      main: "?main",
      /**
       * Optional Details part of the alert.
       * Will automatically show "Read more" button.
       */
      aside: "?aside"
    }, this.controller = og, this.defaultTemplate = "salaxy-components/helpers/Alert.html";
  }
};
class r5 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** The Avatar object that should be rendered */
      avatar: "="
    }, this.controller = cg, this.defaultTemplate = "salaxy-components/helpers/Avatar.html";
  }
}
class l5 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /**
       * Start date for the calendar as ISO date yyyy-MM-dd. Renders from the beginning of this month.
       */
      start: "<",
      /**
       * End date of the calendar as ISO date yyyy-MM-dd. Renders until the end of this month.
       */
      end: "<",
      /**
       * Today date for the calendar as ISO date yyyy-MM-dd.
       * Can be set as dately object (e.g. ISO string, JS Date or key string "today")
       */
      today: "<",
      /** The data that is plotted on the calendar chart. */
      data: "<",
      /** Optional data mapper function that is used in mapping the data to CalendarSeries array. */
      mapper: "<",
      /** TODO: Remove */
      periods: "<",
      /** TODO: Remove */
      days: "<",
      /** Type of chart: "align-weekdays", "align-left" or horizontal. */
      mode: "@",
      /**
       * Function that is called when user selects an item in the calendar.
       * Function can have the following locals: type: "event" | "day", date: string, day: Full calendar day with all the day info,
       * calEvent: The calendar event if type is "event", series: Series that the event belongs to or the series that is clicked (not always available).
       * @example <salaxy-calendar on-list-select="$ctrl.myCustomSelectFunc(type, date, calEvent)"></salaxy-calendar>
       */
      onListSelect: "&",
      /** Possibility of specifying a list controller that can be used for item editing. */
      listController: "<",
      /** If set to true, the export buttons are visible. */
      showExport: "<"
    }, this.controller = dg, this.defaultTemplate = "salaxy-components/helpers/Calendar.html";
  }
}
class o5 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** Config of chart */
      config: "<",
      /** Custom height of chart */
      customHeight: "@",
      /** Custom height of chart */
      customWidth: "@",
      /** Custom height of chart */
      customClass: "@"
    }, this.controller = pg, this.defaultTemplate = "salaxy-components/helpers/Chart.html";
  }
}
class c5 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** The DataMapper that is shown.  */
      model: "<",
      /**
       * Type of the user interface:
       *
       * - "value-map" (default) Shows the source values in the table, target mapping is editable.
       * - "debug" Full data mapper debugger / editor UI.
       * - "source-value" Shows the source values in a table, also the validation column
       * - "target-value" Shows the target values in a table, also the validation column
       */
      type: "@"
    }, this.controller = Pg, this.defaultTemplate = "salaxy-components/helpers/DataMapper.html";
  }
}
class d5 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** The JavaScript object that should be displayed. */
      json: "<",
      /** If true json is compared to compare-to value. */
      compare: "<",
      /** The original JavaScript to which to show DIFF (show changes in data). */
      compareTo: "<",
      /** When displaying children, sets the property / key name for json */
      key: "<",
      /** Number that indicated how many levels JSON should be open */
      open: "<",
      /**
       * Set to "dialog" if you want to show a button that opens the JSON in dialog.
       * Otherwise, an inline tree view is shown.
       */
      type: "@",
      /** Optional button class for the dialog button. Default is "btn btn-default btn-xs" */
      btnClass: "@"
    }, this.controller = hg, this.defaultTemplate = "salaxy-components/helpers/JsonFormatter.html";
  }
}
class u5 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /**
       * - mode: "default", "accordion" or "horizontal"
       * - default: shows full two levels of the tree. Typically used as sitemap in the content area.
       * - accordion: shows first level of the navi tree and second level only if is in the current path.
       * Typically used in left menu navigation.
       * - horizontal: Full navi on top bar. Second tier in dropdowns.
       * - 3-levels: Accordion with 3 levels.
       */
      mode: "@"
    }, this.controller = xu, this.defaultTemplate = "salaxy-components/helpers/NaviSitemap.html";
  }
}
class p5 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /**
       * - mode: "default", "accordion" or "horizontal"
       * - default: shows full two levels of the tree. Typically used as sitemap in the content area.
       * - accordion: shows first level of the navi tree and second level only if is in the current path.
       * - horizontal: Full navi on top bar. Second tier in dropdowns.
       * Typically used in left menu navigation.
       */
      mode: "@",
      /**
       * - layout: "default" or "iframe"
       * - default: Basic layout with full navigation (left sidebar or horizontal).
       * - iframe: Layout without first tier navigation on left sidebar. Second tier navigation items are under dropdown in top bar / header if mode is default. On horizontal mode full navigation is on top bar.
       */
      layout: "@"
    }, this.transclude = {
      /** Header part of the page. Note that mobile header is defined separately. */
      header: "?header",
      /** Main content part of the page */
      main: "?main",
      /** The main navigation: By default: left sidebar. */
      nav: "?nav"
    }, this.controller = xu, this.defaultTemplate = "salaxy-components/helpers/NaviStarterLayout.html";
  }
}
class h5 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** If true, the spinner is shown full screen. */
      fullScreen: "=",
      /**
       * Heading is the larger text under the spinner.
       * The text is translated.
       */
      heading: "@",
      /**
       * Small text - use pre for line breaks.
       * The text is translated.
       */
      text: "@"
    }, this.controller = mg, this.defaultTemplate = "salaxy-components/helpers/Spinner.html";
  }
}
let m5 = class extends Ct {
  constructor() {
    super(...arguments), this.require = {
      tabsCtrl: "^salaxyTabs"
    }, this.bindings = {
      /** Index/name for the tab. */
      index: "<",
      /** Disable tab attribute. */
      disable: "<",
      /** Text heading. */
      heading: "@",
      /** Selection event handler */
      onSelect: "&select"
    }, this.controller = gg, this.defaultTemplate = "salaxy-components/helpers/Tab.html", this.transclude = {
      content: "?salaxyTabContent",
      heading: "?salaxyTabHeading"
    };
  }
};
class g5 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** Expression for active tab in the tabset */
      active: "=?"
    }, this.controller = yg, this.defaultTemplate = "salaxy-components/helpers/Tabs.html", this.transclude = !0;
  }
}
class y5 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      currentTab: "=",
      options: "<",
      tabsId: "@"
    }, this.controller = fg, this.defaultTemplate = "salaxy-components/helpers/TabButtons.html";
  }
}
class f5 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** User interface mode for the component: "table" (default) or "fieldset" */
      mode: "@",
      /**
       * Beginning of the full key that is used to filtering the dictionary items (allKeyValues filter).
       * The value may be a string, array or comma separated string of values.
       */
      filter: "<",
      /** Texts from serviceModel that are being edited */
      texts: "<"
    }, this.controller = bg, this.defaultTemplate = "salaxy-components/helpers/UiTranslator.html";
  }
}
class MA extends Ct {
  constructor() {
    super(...arguments), this.bindings = {}, this.controller = null, this.defaultTemplate = "salaxy-components/helpers/import/DataImport.html";
  }
}
class b5 extends MA {
  constructor() {
    super(...arguments), this.controller = wg;
  }
}
class v5 extends MA {
  constructor() {
    super(...arguments), this.controller = xg;
  }
}
class x5 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** Binds the current payroll (the full object) typically from the Payroll details view. */
      payroll: "<",
      /** If the list off calculations committed into the Payroll typically from the Payroll details view. */
      payrollCalcs: "<"
    }, this.controller = Ag, this.defaultTemplate = "salaxy-components/helpers/import/staging/ImportStaging.html";
  }
}
class w5 extends MA {
  constructor() {
    super(...arguments), this.controller = Cg;
  }
}
class A5 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** Invoice to display in the credit transfer. */
      invoice: "<",
      /** Invoice preview to display in the credit transfer. */
      invoicePreview: "<",
      /**
       * Display mode is either
       *
       * - "official": The official printable credit transfer (Finanssialan keskusliitto)
       * - "barcode-copy": The copy-paste input + button (in a div) for copy pasting the the barcode into a web bank
       * - "default": Both of the above separted by an explaining text.
       */
      mode: "@"
    }, this.transclude = {
      /**
       * HTML to include in the message section
       */
      message: "?message"
    }, this.controller = Ym, this.defaultTemplate = "salaxy-components/invoices/CreditTransfer.html";
  }
}
class C5 extends Ct {
  constructor() {
    super(...arguments), this.bindings = new fa(), this.controller = Cr, this.defaultTemplate = "salaxy-components/invoices/InvoiceEdit.html";
  }
}
class $5 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /**
       * list view 'mode'.
       * If undefined, defaults to full list.
       * Use panel for dashboards etc.
       */
      mode: "@"
    }, this.controller = Cr, this.defaultTemplate = "salaxy-components/invoices/InvoiceList.html";
  }
}
class S5 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {}, this.controller = $g, this.defaultTemplate = "salaxy-components/invoices/InvoicePaymentList.html";
  }
}
class k5 extends Ct {
  constructor() {
    super(...arguments), this.bindings = new fa(), this.controller = Cr, this.defaultTemplate = "salaxy-components/invoices/InvoicePreview.html";
  }
}
class T5 extends Ct {
  constructor() {
    super(...arguments), this.bindings = new fa(), this.controller = Sg, this.defaultTemplate = "salaxy-components/invoices/InvoicesCreate.html";
  }
}
class L5 extends Ct {
  constructor() {
    super(...arguments), this.bindings = new fa(), this.controller = kg, this.defaultTemplate = "salaxy-components/invoices/InvoicePreview.html";
  }
}
class D5 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** Reference to the data reader object. */
      reader: "<"
    }, this.controller = Tg, this.defaultTemplate = "salaxy-components/invoices/InvoiceTools.html";
  }
}
class I5 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** The invoice for the report. */
      invoice: "<",
      /** If true, uses the current style of the site. The default value is false. */
      applySiteStyles: "<",
      /** The language for report*/
      lang: "<"
    }, this.controller = Lg, this.defaultTemplate = "salaxy-components/invoices/InvoiceReport.html";
  }
}
class P5 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /**
       * channel for the invocie processing. Default is PalkkausInvoices.
       */
      channel: "<"
    }, this.controller = Dg, this.defaultTemplate = "salaxy-components/invoices/CompanyInvoices.html";
  }
}
class E5 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** Payment channels for OData query. */
      paymentChannels: "<",
      /** Indicates if used in pro. */
      isPro: "<"
    }, this.controller = Ig, this.defaultTemplate = "salaxy-components/invoices/InvoiceAlerts.html";
  }
}
class N5 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {}, this.controller = wy, this.defaultTemplate = "salaxy-components/worker/WorkerAssure.html";
  }
}
class R5 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** Type of paging */
      paging: "@",
      /**
       * Manually defined URL for the nextPageLink.
       * Browser is directed to this URL instead of loading more data from nextPageLink.
       */
      nextPageUrl: "@"
    }, this.require = {
      $odata: "^^salaxyOdataTable"
    }, this.controller = rm, this.defaultTemplate = "salaxy-components/odata/OdataFooter.html";
  }
}
class Y5 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** OData query options */
      options: "<",
      /** URL to the OData service. */
      url: "@",
      /** Data passed from the parent to the component / view */
      data: "<",
      /** Selected items for the case where the list is used as a select list (as opposed to link list). */
      selectedItems: "<",
      /** Current list of items. */
      items: "<",
      /**
       * Function that is called when user selects an item in the list.
       * Note that the event is called only in the selections (single and multi). Not when there is a link to details view in a link list.
       * Function has the following locals: value: true/false, item: the last selected/unselected item, allItems: Array of all currently selected items.
       * @example <salaxy-employment-list mode="select" on-list-select="$ctrl.updateFromEmployment(item.id)"></salaxy-employment-list>
       */
      onListSelect: "&",
      /** Function that is called when the data has been loaded and set as values of the items. */
      onDataLoaded: "&",
      /**
       * CRUD controller that typically defines the values for url template and
       * @example
       * <salaxy-odata-table crud-controller="PayrollCrudController as $crud">
       */
      crudController: "@",
      /**
       * Optional bindings for the CRUD controller. All properties are set to crudController before calling init.
       * @example
       * <salaxy-odata-table crud-controller="PayrollCrudController as $crud" crud-bindings="{ myProp: 'foobar' }">
       */
      crudBindings: "<",
      /** Defines the cache key. A non-null value also means that the caqche is enabled. */
      cacheKey: "@",
      /** Optional reader component for OData. Uses the given url and reads data from the OData source. */
      reader: "<",
      /** If readOnly is true, edit, copy etc. buttons from the new list view are hidden if readOnly property is supported */
      readOnly: "<",
      /** Logic object for component */
      logic: "<",
      /**Select mode for component */
      selectMode: "<"
    }, this.controller = ni, this.defaultTemplate = "salaxy-components/odata/lists/_default.html";
  }
}
class _5 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** Default locale for data exports/imports. */
      localeId: "<",
      /** Flag indicating if the export options are visible. */
      showExport: "@"
    }, this.require = {
      $odata: "^^salaxyOdataTable"
    }, this.transclude = !0, this.controller = vg, this.defaultTemplate = "salaxy-components/odata/OdataActions.html";
  }
}
class O5 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {}, this.controller = vi, this.defaultTemplate = "salaxy-components/personal/AccountAuthorizationPerson.html";
  }
}
class M5 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** Current person account. Optional */
      current: "<"
    }, this.controller = ao, this.defaultTemplate = "salaxy-components/personal/AccountAvatarEditPerson.html";
  }
}
class X5 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** Current person account. Optional */
      current: "<"
    }, this.controller = ao, this.defaultTemplate = "salaxy-components/personal/AccountContactEditPerson.html";
  }
}
class G5 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** Current tab in initialization. If not set, will be fetched from url hash. */
      currentTab: "@"
    }, this.controller = ao, this.defaultTemplate = "salaxy-components/personal/AccountDetailsPerson.html";
  }
}
class H5 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** Current person account. Optional */
      current: "<"
    }, this.controller = ao, this.defaultTemplate = "salaxy-components/personal/AccountDetailsEditPerson.html";
  }
}
class U5 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {}, this.require = {
      model: "?ngModel"
    }, this.controller = vi, this.defaultTemplate = "salaxy-components/personal/AccountInfoPerson.html";
  }
}
class F5 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {}, this.controller = ii, this.defaultTemplate = "salaxy-components/personal/AccountInsuranceEditPerson.html";
  }
}
class z5 extends Ct {
  constructor() {
    super(...arguments), this.bindings = new class extends fa {
      constructor() {
        super(...arguments), this.selectedItems = "<", this.items = "<", this.onEmployerSelect = "&";
      }
    }(), this.controller = Eg, this.defaultTemplate = "salaxy-components/personal/EmployerList.html";
  }
}
class B5 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {}, this.controller = Ng, this.defaultTemplate = "salaxy-components/personal/EmployerReport.html";
  }
}
class W5 extends Ct {
  constructor() {
    super(...arguments), this.bindings = new class extends fa {
      constructor() {
        super(...arguments), this.selectedItems = "<", this.items = "<", this.onEmployerSelect = "&";
      }
    }(), this.controller = Rg, this.defaultTemplate = "salaxy-components/personal/EmployerSelect.html";
  }
}
class j5 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** The calculation that the component edits */
      calc: "<",
      /** Alternative data binding: creates a calculation based on Worker defaults. */
      worker: "<",
      /**
       * Shows the Save and Reset buttons.
       * Currently, this is only enabled for WorkerAccount data binding, but may later be enabled for calc.
       */
      showSave: "<",
      /** isReadOnly*/
      isReadOnly: "<"
    }, this.controller = Sm, this.defaultTemplate = "salaxy-components/personal/CalcHouseholdUsecase.html";
  }
}
class V5 extends Ct {
  constructor() {
    super(...arguments), this.bindings = new class extends fa {
      constructor() {
        super(...arguments), this.showLinkSharing = "<";
      }
    }(), this.controller = wu, this.defaultTemplate = "salaxy-components/personal/CalcSharing.html";
  }
}
class q5 extends Ct {
  constructor() {
    super(...arguments), this.bindings = new fa(), this.controller = wu, this.defaultTemplate = "salaxy-components/personal/CalcSharingInfo.html";
  }
}
class K5 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {}, this.controller = Yg, this.defaultTemplate = "salaxy-components/personal/HouseholdDeductionReport.html";
  }
}
class J5 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {}, this.controller = _g, this.defaultTemplate = "salaxy-components/personal/WorkerReport.html";
  }
}
class Q5 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {}, this.controller = Au, this.defaultTemplate = "salaxy-components/personal/HouseholdYearList.html";
  }
}
class Z5 extends Ct {
  constructor() {
    super(...arguments), this.bindings = new fa(), this.controller = Au, this.defaultTemplate = "salaxy-components/personal/HouseholdYearDetails.html";
  }
}
class t8 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /**
       * list view 'mode'.
       * If undefined, defaults to full list.
       * Use panel for dashboards etc.
       */
      mode: "@"
    }, this.controller = Su, this.defaultTemplate = "salaxy-components/report/AccountingReportList.html";
  }
}
class e8 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /**
       * Specify the calculations that should be reported.
       * If null, will show a user interface to select calculations or period.
       */
      calcs: "<",
      /**
       * Report view table only (partial) or pdf preview (full)
       * Defaults to 'partial'
       */
      view: "<",
      /** The language for report*/
      lang: "<"
    }, this.controller = Xg, this.defaultTemplate = "salaxy-components/report/AccountingReportQuery.html";
  }
}
class a8 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** Accounting data */
      data: "<",
      /**
       * Report view table only (partial) or pdf preview (full)
       * Defaults to 'partial'
       */
      view: "<",
      /** The language for report*/
      lang: "<"
    }, this.controller = Gg, this.defaultTemplate = "salaxy-components/report/AccountingReportRows.html";
  }
}
class n8 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** Reference to the data reader object. */
      reader: "<",
      /** Called when the target has been changed. */
      onTargetChange: "&",
      /** Called when the expand button state changed */
      onExpandChange: "&",
      /** Binded expand state*/
      anyExpanded: "<",
      /**
       * Report view table only (partial) or pdf preview (full)
       * Defaults to 'partial'
       */
      view: "<"
    }, this.controller = Hg, this.defaultTemplate = "salaxy-components/report/AccountingReportTools.html";
  }
}
class s8 extends Ct {
  constructor() {
    super(...arguments), this.bindings = new fa(), this.controller = Su, this.defaultTemplate = "salaxy-components/report/AccountingReportViewer.html";
  }
}
class i8 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** Template for the report */
      templateId: "<"
    }, this.controller = Bg, this.defaultTemplate = "salaxy-components/report/CalculationReport.html";
  }
}
class r8 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {}, this.controller = qg, this.defaultTemplate = "salaxy-components/report/HolidayReport.html";
  }
}
class l8 extends Ct {
  constructor() {
    super(...arguments), this.bindings = new class extends fa {
      constructor() {
        super(...arguments), this.calculationId = "<", this.calculation = "<", this.calculationFor = "<";
      }
    }(), this.controller = ku, this.defaultTemplate = "salaxy-components/report/IrEarningsPayment.html";
  }
}
class o8 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {}, this.controller = ku, this.defaultTemplate = "salaxy-components/report/IrEarningsPaymentList.html";
  }
}
class c8 extends Ct {
  constructor() {
    super(...arguments), this.bindings = new class extends fa {
    }(), this.controller = Tu, this.defaultTemplate = "salaxy-components/report/IrPayerSummary.html";
  }
}
class d8 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {}, this.controller = Tu, this.defaultTemplate = "salaxy-components/report/IrPayerSummaryList.html";
  }
}
class u8 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {}, this.controller = zg, this.defaultTemplate = "salaxy-components/report/PayCertificate.html";
  }
}
class p8 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /**
       * - report-type: Type of the report (string, see reportType enumeration) that is shown in the list.
       * Also supports value null/"current" for showing reports defined by reportsService.currentReportType.
       */
      reportType: "<",
      /**
       * -title
       * Heading of the list. Supports translation keys.
       * Default is reportType based enumeration translation.
       */
      heading: "@"
    }, this.controller = Ug, this.defaultTemplate = "salaxy-components/report/ReportList.html";
  }
}
class h8 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /**
       * list view 'mode'.
       * If undefined, defaults to full list.
       * Use panel for dashboards etc.
       */
      mode: "@"
    }, this.controller = Fg, this.defaultTemplate = "salaxy-components/report/SalaryReportList.html";
  }
}
class m8 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** Template for the report */
      templateId: "<"
    }, this.controller = Wg, this.defaultTemplate = "salaxy-components/report/AccountingRowReport.html";
  }
}
class g8 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** The data for the report. */
      data: "<"
    }, this.controller = jg, this.defaultTemplate = "salaxy-components/report/SummaryReport.html";
  }
}
class y8 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** The data for the report. */
      data: "<"
    }, this.controller = Vg, this.defaultTemplate = "salaxy-components/report/WorkerSummaryReport.html";
  }
}
class f8 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /**
       * Report view table only (partial) or pdf preview (full)
       * Defaults to 'partial'
       */
      view: "<",
      /** The language for report*/
      lang: "<"
    }, this.controller = Kg, this.defaultTemplate = "salaxy-components/report/AccountingHolidayPayDebtReportQuery.html";
  }
}
class b8 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {}, this.controller = Jg, this.defaultTemplate = "salaxy-components/report/HolidayPayReportQuery.html";
  }
}
class v8 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {}, this.controller = Qg, this.defaultTemplate = "salaxy-components/report/SummaryReportQuery.html";
  }
}
class x8 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** If true, removing accountant is disabled */
      removalDisabled: "<"
    }, this.controller = Zg, this.defaultTemplate = "salaxy-components/settings/Accountant.html";
  }
}
class w8 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {}, this.controller = ii, this.defaultTemplate = "salaxy-components/settings/AccountingSettings.html";
  }
}
class A8 extends Ct {
  constructor() {
    super(...arguments), this.bindings = new fa(), this.controller = ty, this.defaultTemplate = "salaxy-components/settings/AccountingTargetDetails.html";
  }
}
class C8 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** Forced read only state */
      isReadOnlyForced: "<"
    }, this.controller = ii, this.defaultTemplate = "salaxy-components/settings/AccountingTargetSettings.html";
  }
}
class $8 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** Forced read only state */
      isReadOnlyForced: "<"
    }, this.controller = ii, this.defaultTemplate = "salaxy-components/settings/CostAccountingSettings.html";
  }
}
class S8 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {}, this.controller = ii, this.defaultTemplate = "salaxy-components/settings/HolidaySettings.html";
  }
}
class k8 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {}, this.controller = ey, this.controllerAs = "$ctrl", this.defaultTemplate = "salaxy-components/modals/account/Insurance.html";
  }
}
class T8 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /**
       * Array of section ids to show
       * By default: ['pensionContracts','insuranceContracts']
       * All options:
       * 'pensionContracts': Pension related settings
       * 'yelPensionContracts': Pension related settings
       * 'insuranceContracts' : Insureance contract related settings
       */
      sections: "<",
      /** Sets the isReadOnlyForced status. */
      isReadOnlyForced: "<"
    }, this.controller = ii, this.defaultTemplate = "salaxy-components/settings/Insurances.html";
  }
}
class L8 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** Sets the isReadOnlyForced status. */
      isReadOnlyForced: "<"
    }, this.controller = ay, this.defaultTemplate = "salaxy-components/settings/OwnerSettings.html";
  }
}
class D8 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {}, this.controller = ny, this.defaultTemplate = "salaxy-components/settings/PaymentChannelSettings.html";
  }
}
class I8 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /**
       * Array of section ids to show
       * By default: ['pensionContracts','insuranceContracts','incomesRegister']
       * All options:
       * 'pensionContracts': Pension related settings
       * 'insuranceContracts' : Insureance contract related settings
       * 'incomesRegister': Tax reporting related settings
       * 'eInvoice': EInvoice related settings
       * 'sepa' : Sepa payments related settings
       * 'taxAndSocialSecuritySelfHandling': Settings for tax payments
       * 'pensionSelfHandling': Settings for pension payments
       * 'workerSelfHandling': Settings for net salary payments
       * 'unemploymentSelfHandling' Settings for unemployment payments
       */
      sections: "<",
      /** Sets the isReadOnlyForced status. */
      isReadOnlyForced: "<"
    }, this.controller = ii, this.defaultTemplate = "salaxy-components/settings/PaymentSettings.html";
  }
}
class P8 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {}, this.controller = ii, this.defaultTemplate = "salaxy-components/settings/ProSettings.html";
  }
}
class E8 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /**
       * Defines the type of rows editor: "builtIn" for built-in rows,
       * "custom" for custom rows, "prices" company specific default prices per row type.
       */
      mode: "@",
      /**
       * Set this property if you want to explicitly set the model.
       * If undefinded, the component binds to company settings.
       */
      model: "<"
    }, this.controller = sy, this.defaultTemplate = "salaxy-components/settings/RowTypesSettings.html";
  }
}
class N8 extends Ct {
  constructor() {
    super(...arguments), this.bindings = new fa(), this.controller = iy, this.defaultTemplate = "salaxy-components/settings/ServiceModelDetails.html";
  }
}
class R8 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {}, this.controller = ii, this.defaultTemplate = "salaxy-components/settings/IrDeliverySettings.html";
  }
}
class Y8 extends Ct {
  constructor() {
    super(...arguments), this.transclude = !0, this.bindings = {
      /**
       * Possibility to speicfy a font-awesome icon.
       * Setting "none", will show no icon.
       * If not set, it is determined by type.
       */
      icon: "@",
      /** Type of the alert is the Bootstrap style: Note that also "primary" and "default" are supported. */
      type: "@",
      /**
       * Translation key to HTML that should be the main message of the alert.
       * You can alternatively provide html as main element (transclude).
       */
      msg: "@",
      /**
       * Alert main content as simple text.
       * You can alternatively provide html as main element.
       */
      text: "@",
      /**
       * Optional Details part of the alert.
       * Will automatically show "Read more" button.
       */
      aside: "@"
    }, this.controller = oy, this.defaultTemplate = "salaxy-components/sxy-form/SxyAlert.html";
  }
}
class _8 extends Ct {
  constructor() {
    super(...arguments), this.transclude = !0, this.require = {
      model: "?ngModel"
    }, this.bindings = {
      /** Type of user interface to render: "monaco" (default) or "basic" HTML (textarea/pre) */
      mode: "@",
      /** If true, the component is read-only */
      readOnly: "<",
      /**
       * Language of the code, e.g. "javascript" (default), "html", "json" or "css".
       * Currently only affects the Monaco editor.
       */
      lang: "@",
      /**
       * Type of the main object that is called "item" in the code.
       * Type should be one of @salaxy/core types (e.g. "Calculation") or supported
       * native types (currently ["any", "string", "[]"]). Default is any.
       */
      itemType: "<",
      /** The height of the editor as CSS, (e.g. "calc(100vh - 600px)"). Default is "400px" */
      height: "@",
      /**
       * Type of the editor to use: "monaco" (default), "sample" or "formula".
       */
      editor: "@"
    }, this.controller = ry, this.defaultTemplate = "salaxy-components/sxy-form/SxyCodeEditor.html";
  }
}
class O8 extends Ct {
  constructor() {
    super(...arguments), this.require = {
      form: "^^sxyForm"
    }, this.bindings = Qe.extend(no.bindings, {}), this.controller = no, this.defaultTemplate = "salaxy-components/sxy-form/SxyFieldset.html";
  }
}
class M8 extends Ct {
  constructor() {
    super(...arguments), this.transclude = {
      div: "?div"
    }, this.bindings = {
      /** Data object that is being edited by the fieldset. */
      model: "<",
      /** The data type that describes the object and creates the user interface. */
      type: "@",
      /**
       * URL for the Open API document that contains the definition for the type.
       * The url can be an absolute url, relative url or an url with salaxy-secure/ -prefix.
       * The salaxy-secure/ -prefix will be replaced in runtime with the salaxy api server url of the curren environment.
       */
      openApi: "@",
      /** Direct reference to internal document object. */
      openApiDoc: "<",
      /**
       * The translation code for the label/legend/title.
       * Default is "SALAXY.MODEL.[type].title"] or if not available, just the type text.
       */
      label: "@",
      /**
       * If true, the form is auto-generated from the type and inner HTML is ignored.
       * If false (default), the inner HTML is used to show the form.
       */
      autoGen: "<",
      /** If true, shows the form debugger */
      debugger: "<",
      /** Sets the entire form as read-only. Individual field may still be set read-only=false to make it editable. */
      readOnly: "@"
    }, this.controller = ly, this.defaultTemplate = "salaxy-components/sxy-form/SxyForm.html";
  }
}
class X8 extends Ct {
  constructor() {
    super(...arguments), this.require = {
      form: "?^^sxyForm"
    }, this.bindings = Qe.extend(Lu.bindings, {}), this.controller = Lu, this.defaultTemplate = "salaxy-components/sxy-form/SxyGrid.html";
  }
}
class G8 extends Ct {
  constructor() {
    super(...arguments), this.require = {
      form: "?^^sxyForm"
    }, this.bindings = Qe.extend(no.bindings, {}), this.transclude = {
      /** Defines the inner form of Array dialogs and later potentially other dialogs and sub-forms */
      form: "?form"
    }, this.controller = no, this.defaultTemplate = "salaxy-components/sxy-form/SxyInput.html";
  }
}
class H8 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      model: "<"
    }, this.controller = cy, this.defaultTemplate = "salaxy-components/sxy-form/SxySchemaEditor.html";
  }
}
class U8 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** The schema definition that defines the structure of the grid. */
      schemaDef: "<",
      /** URL of the schema document that contains the schemaDef. If set with schema in init, loads the document.*/
      doc: "@",
      /** Key of schemaDef in doc. If set with doc in init, will load the schema document from server and set the schemaDef.*/
      schema: "@",
      /** Data that is rendered / edited in the grid. This is either an array or an object that implements getTabulatorConfig() method for ajax data.*/
      data: "<",
      /**
       * List of columns to include in the grid.
       * This may be an array or comma separated string of field names (or a property tree, e.g. "owner.avatar.displayName").
       * Alternatively, the entries in the array may be be full Tabulator column definitions, where `field` propererty defines the
       * data item and fetches the default properties from the schema.
       */
      include: "<",
      /**
       * List of columns to exclude from the grid.
       * This property is currenlty used only if include property is undefined, i.e. in default
       * rendering, which will render the first-level properties. As such, exclude does not really support property paths.
       */
      exclude: "<",
      /** Additional configuration for the table in init. */
      options: "<",
      /** After init, exposes the Tabulator for calling methods. */
      tabulator: "<",
      /**
       * Gets the state of filters or sets the initial state of filters.
       * By default, the filters are not shown before showFilters() function is called.
       * If the property / attribute is set to true before initial render, the filters are shown.
       * Use showFilters() function to show or hide the filters after initial render.
       */
      filters: "<"
    }, this.controller = dy, this.defaultTemplate = "salaxy-components/sxy-table/SxyTable.html";
  }
}
class F8 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {}, this.controller = uy, this.defaultTemplate = "salaxy-components/test/AccountReset.html";
  }
}
class z8 {
  constructor() {
    this.bindings = {
      /** Defines the view / set of tests: "core" or "ng1" */
      mode: "@"
    }, this.controller = py, this.templateUrl = "salaxy-components/test/SmokeTest.html";
  }
}
class B8 extends Ct {
  constructor() {
    super(...arguments), this.bindings = Iu.bindings, this.controller = Iu, this.defaultTemplate = "salaxy-components/worker/holidays/HolidayYearAccrual.html";
  }
}
class W8 extends Ct {
  constructor() {
    super(...arguments), this.bindings = Pu.bindings, this.controller = Pu, this.defaultTemplate = "salaxy-components/worker/holidays/HolidayYearHolidays.html";
  }
}
class j8 extends Ct {
  constructor() {
    super(...arguments), this.bindings = Eu.bindings, this.controller = Eu, this.defaultTemplate = "salaxy-components/worker/holidays/HolidayYearPaid.html";
  }
}
class V8 extends Ct {
  constructor() {
    super(...arguments), this.bindings = new class extends fa {
      constructor() {
        super(...arguments), this.employmentId = "<", this.forDate = "<";
      }
    }(), this.controller = gy, this.defaultTemplate = "salaxy-components/worker/holidays/WorkerHolidays.html";
  }
}
class q8 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** Employment ID of the Worker whose taxcards are shown in the component. */
      employmentId: "<",
      /**
       * View mode:
       *
       * - "active" only shows the active taxcard.
       * - "list" only shows the history list.
       * - "all" (default) shows both active and history.
       */
      mode: "@",
      /**
       * Event that is called when a taxcard is saved and the parent UI probably needs to be refreshed.
       * @example <salaxy-employment-taxcards employment-id="$ctrl.current.employmentId" on-save="$ctrl.refresh()"></salaxy-employment-taxcards>
       */
      onSave: "&",
      /** If true, does not show the save / current buttons - the parent must show them. */
      hideButtons: "<"
    }, this.controller = my, this.defaultTemplate = "salaxy-components/worker/taxcard/EmploymentTaxcards.html";
  }
}
class K8 extends Ct {
  constructor() {
    super(...arguments), this.bindings = new class extends fa {
      constructor() {
        super(...arguments), this.mode = "@", this.personalId = "<", this.onSave = "&", this.hideButtons = "<", this.employmentRelationTaxcardType = "<";
      }
    }(), this.controller = fy, this.defaultTemplate = "salaxy-components/worker/taxcard/TaxcardDetails.html";
  }
}
class J8 extends $r {
  constructor() {
    super(...arguments), this.editable = "<";
  }
}
class Q8 extends Ct {
  constructor() {
    super(...arguments), this.bindings = new J8(), this.controller = by, this.defaultTemplate = "salaxy-components/worker/taxcard/TaxcardIncomeLog.html";
  }
}
class Z8 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** The taxcard that is being edited */
      current: "<"
    }, this.controller = yy, this.defaultTemplate = "salaxy-components/worker/taxcard/TaxcardManualEdit.html";
  }
}
class t9 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {}, this.controller = ni, this.defaultTemplate = "salaxy-components/worker/taxcard/TaxCardsList.html";
  }
}
class e9 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /**
       * Function that is called when user selects an item in the list.
       * Note that the event is called only in the selections (single and multi).
       * Function has the following locals: value: true/false, item: the last selected/unselected item, allItems: Array of all currently selected items.
       * @example <salaxy-taxcard-list mode="select" options="$ctrl.logic.options" on-list-select="$ctrl.logic.doSomething(item.id)"></salaxy-taxcard-list>
       */
      onListSelect: "&",
      /** Selected items for the case where the list is used as a select list (as opposed to link list). */
      selectedItems: "<",
      /** Type of the view. Currently supports "default", "panel" and "select" */
      mode: "@",
      /** OData query options */
      options: "<"
    }, this.controller = ni, this.defaultTemplate = "salaxy-components/worker/taxcard/TaxcardList.html";
  }
}
class a9 extends Ct {
  constructor() {
    super(...arguments), this.bindings = Du.bindings, this.controller = Du, this.defaultTemplate = "salaxy-components/worker/AbsencePeriods.html";
  }
}
class n9 extends Ct {
  constructor() {
    super(...arguments), this.bindings = new class extends fa {
      constructor() {
        super(...arguments), this.currentTab = "@", this.isModal = "<";
      }
    }(), this.controller = hy, this.defaultTemplate = "salaxy-components/worker/employment/Details.html";
  }
}
class s9 extends Ct {
  constructor() {
    super(...arguments), this.bindings = new class extends fa {
      constructor() {
        super(...arguments), this.employmentId = "<";
      }
    }(), this.controller = vy, this.defaultTemplate = "salaxy-components/worker/WorkerAbsences.html";
  }
}
class i9 extends Ct {
  constructor() {
    super(...arguments), this.bindings = new fa(), this.controller = xy, this.defaultTemplate = "salaxy-components/worker/WorkerDetails.html";
  }
}
class UI extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /**
       * Function that is called when user selects an item in the list.
       * Note that the event is called only in the selections (single and multi). Not when there is a link to details view in a link list.
       * Function has the following locals: value: true/false, item: the last selected/unselected item, allItems: Array of all currently selected items.
       * @example <salaxy-employment-list mode="select" on-list-select="$ctrl.updateFromEmployment(item.id)"></salaxy-employment-list>
       */
      onListSelect: "&",
      /** Selected items for the case where the list is used as a select list (as opposed to link list). */
      selectedItems: "<",
      /** Type of the view. Currently supports "default" and "select" */
      mode: "@",
      /** Max count of workers to show in the list. */
      limitTo: "<",
      /** If readOnly is true, edit, copy etc. buttons from the new list view are hidden if readOnly property is supported */
      readOnly: "<",
      /** boolean indicating if toolbar should be shown*/
      showToolbar: "<"
    }, this.controller = ni, this.defaultTemplate = "salaxy-components/worker/EmploymentList.html";
  }
}
class r9 extends Ct {
  constructor() {
    super(...arguments), this.bindings = new class extends fa {
    }(), this.controller = Ay, this.defaultTemplate = "salaxy-components/workflow/CalendarEventDetails.html";
  }
}
class l9 extends Ct {
  constructor() {
    super(...arguments), this.bindings = new class extends fa {
      constructor() {
        super(...arguments), this.mode = "@", this.defaultUsecase = "@";
      }
    }(), this.controller = Cy, this.defaultTemplate = "salaxy-components/workflow/dataset/DatasetDetails.html";
  }
}
class o9 extends Ct {
  constructor() {
    super(...arguments), this.bindings = new fa(), this.controller = $y, this.defaultTemplate = "salaxy-components/workflow/usecases/UsecaseDetails.html";
  }
}
class c9 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /**
       * Binding to entity type
       */
      entityType: "<",
      /** Expression for the api controller . */
      apiCtrl: "<",
      /** Binding to read only state */
      readOnly: "<"
    }, this.controller = Mg, this.defaultTemplate = "salaxy-components/records/Records.html";
  }
}
class d9 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** Expression for the api controller . */
      apiCtrl: "<",
      /** Optional binding for enabling/disabling the controls */
      disabled: "<",
      /** on-change event */
      onChange: "&",
      /** Option to show/hide workflow assign control. Default is true */
      showWorkflowAssign: "<"
    }, this.controller = Nu, this.defaultTemplate = "salaxy-components/workflow/WorkflowButtons.html";
  }
}
class u9 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** Expression for the api controller . */
      apiCtrl: "<",
      /** Optional binding for enabling/disabling the control */
      disabled: "<",
      /** Called when workflow action has been taken */
      onChange: "&"
    }, this.controller = Nu, this.defaultTemplate = "salaxy-components/workflow/WorkflowReopen.html";
  }
}
class p9 extends Ct {
  constructor() {
    super(...arguments), this.bindings = {
      /** Expression for the api controller . */
      apiCtrl: "<",
      /** Object or list item which contains workflow message data. */
      model: "<",
      /** Comma separated list of types to show the badge for. */
      wfTypes: "<",
      /** Visual mode of the component: horizontal or vertical (default). */
      mode: "@"
    }, this.controller = Sy, this.defaultTemplate = "salaxy-components/workflow/WorkflowBadge.html";
  }
}
class h9 {
  /** Gets the components for Module registration. */
  static getComponents() {
    return {
      // - account
      salaxyAccountInfo: new N6(),
      salaxyAssurePartner: new R6(),
      salaxyAuthCard: new Y6(),
      salaxyAuthorizedAccounts: new _6(),
      salaxyAuthorizingAccounts: new O6(),
      salaxyCertificates: new M6(),
      salaxyCredentials: new X6(),
      salaxyLanguageSelector: new G6(),
      salaxyLoginButton: new H6(),
      salaxySigning: new U6(),
      salaxyUserInfo: new F6(),
      salaxyAccountAvatarEdit: new z6(),
      salaxyAccountContactEdit: new B6(),
      // - personal
      salaxyAccountAuthorizationPerson: new O5(),
      salaxyAccountAvatarEditPerson: new M5(),
      salaxyAccountContactEditPerson: new X5(),
      salaxyAccountDetailsEditPerson: new H5(),
      salaxyAccountDetailsPerson: new G5(),
      salaxyAccountInfoPerson: new U5(),
      salaxyAccountInsuranceEditPerson: new F5(),
      salaxyEmployerList: new z5(),
      salaxyEmployerSelect: new W5(),
      // - calc
      salaxyCalcEmployment: new W6(),
      salaxyCalcHouseholdUsecase: new j5(),
      salaxyCalcIrRows: new aq(),
      salaxyCalcsIrRows: new rq(),
      salaxyCalcList: new pq(),
      salaxyCalcWorktime: new wq(),
      salaxyCalc: new cq(),
      salaxyCalcChart: new dq(),
      salaxyCalcDashboard: new uq(),
      salaxyCalcEditor: new Cq(),
      salaxyCalcNewIntro: new hq(),
      salaxyCalcRepair: new Tq(),
      salaxyCalcReport: new mq(),
      salaxyCalcReports: new gq(),
      salaxyCalcResults: new yq(),
      salaxyCalcRowType: new fq(),
      salaxyCalcRowsEditor: new j6(),
      salaxyCalcRows2019Editor: new nq(),
      salaxyCalcRowFormula: new oq(),
      salaxyCalcUsecase: new V6(),
      salaxyPayrollDetails: new q6(),
      salaxyPayrollDetailsList: new K6(),
      salaxyPayrollDetailsSelectList: new tq(),
      salaxyPayrollEdit: new J6(),
      salaxyPayrollList: new Q6(),
      salaxyPayrollAssistant: new eq(),
      salaxyPayButton: new Aq(),
      salaxySalaryDateKindButton: new kq(),
      salaxyCalcSharing: new V5(),
      salaxyCalcSharingInfo: new q5(),
      salaxyCalcSharingReceiptAction: new bq(),
      salaxyCalcLeaves: new vq(),
      salaxyCalcWorkerInfo: new xq(),
      salaxyPayrollSelectList: new Z6(),
      salaxyCalcCostAccounting: new $q(),
      salaxyCalcRowCostAccounting: new sq(),
      salaxyCalcRowDimensionInput: new iq(),
      salaxyCalcRowDocumentation: new lq(),
      salaxyCostAccounting: new Sq(),
      // - communications
      salaxyContactInfo: new Lq(),
      salaxyHourlyReport: new Eq(),
      salaxyMessageThread: new Dq(),
      salaxyMessageThreadList: new _q(),
      salaxyTimer: new Rq(),
      salaxyVarmaBanner: new Iq(),
      salaxyWelcome: new Pq(),
      salaxyExpenseReport: new Yq(),
      // - sxy-form framework
      sxyAlert: new Y8(),
      sxyCodeEditor: new _8(),
      sxyFieldset: new O8(),
      sxyForm: new M8(),
      sxyGrid: new X8(),
      sxyInput: new G8(),
      sxySchemaEditor: new H8(),
      // - sxy-table framework
      sxyTable: new U8(),
      // - test: Test data and system testing.
      salaxyAccountReset: new F8(),
      salaxySmokeTest: new z8(),
      // - form-controls
      salaxyDatepicker: new Oq(),
      salaxyDatepickerPopup: new Mq(),
      salaxyDateRange: new Xq(),
      salaxyFormGroup: new Gq(),
      salaxyInput: new Hq(),
      salaxyInputAccountingTarget: new Uq(),
      salaxyInputBoolean: new Fq(),
      salaxyInputCollectiveBargainAgreement: new zq(),
      salaxyInputCredential: new Bq(),
      salaxyInputDuration: new Wq(),
      salaxyInputEnum: new pR(),
      salaxyInputIncomeType: new jq(),
      salaxyInputNumber: new Vq(),
      salaxyInputOccupationType: new qq(),
      salaxyInputRrule: new Kq(),
      salaxyInputTime: new Jq(),
      salaxyInputTypeahead: new e5(),
      salaxyToggleButtons: new Qq(),
      salaxyTextarea: new Zq(),
      salaxyValidationSummary: new t5(),
      salaxyInputHolidayMultipliers: new n5(),
      salaxyInputHolidayRowType: new a5(),
      // - helpers
      salaxyActionButton: new s5(),
      salaxyAlert: new i5(),
      salaxyAvatar: new r5(),
      salaxyChart: new o5(),
      salaxyCalendar: new l5(),
      salaxyDataMapper: new c5(),
      salaxyJsonFormatter: new d5(),
      salaxyNaviSitemap: new u5(),
      salaxyNaviStarterLayout: new p5(),
      salaxyOdataActions: new _5(),
      salaxyOdataFooter: new R5(),
      salaxyOdataTable: new Y5(),
      salaxySpinner: new h5(),
      salaxyTabs: new g5(),
      salaxyTab: new m5(),
      salaxyTabButtons: new y5(),
      salaxyUiTranslator: new f5(),
      // - import
      salaxyCalcImport: new b5(),
      salaxyCompanyImport: new v5(),
      salaxyImportStaging: new x5(),
      salaxyWorkerImport: new w5(),
      // - invoices
      salaxyCreditTransfer: new A5(),
      salaxyInvoiceAlerts: new E5(),
      salaxyInvoiceEdit: new C5(),
      salaxyInvoiceList: new $5(),
      salaxyInvoicePreview: new k5(),
      salaxyInvoicesCreate: new T5(),
      salaxyPaymentChannelInvoicePreview: new L5(),
      salaxyInvoiceTools: new D5(),
      salaxyInvoiceReport: new I5(),
      salaxyInvoicePaymentList: new S5(),
      salaxyCompanyInvoices: new P5(),
      // - report
      salaxyHolidayReport: new r8(),
      salaxyHolidayPayReportQuery: new b8(),
      salaxyIrEarningsPayment: new l8(),
      salaxyIrEarningsPaymentList: new o8(),
      salaxyIrPayerSummary: new c8(),
      salaxyIrPayerSummaryList: new d8(),
      salaxyReportList: new p8(),
      salaxySalaryReportList: new h8(),
      salaxyAccountingReportQuery: new e8(),
      salaxyAccountingHolidayPayDebtReportQuery: new f8(),
      salaxyAccountingReportList: new t8(),
      salaxyAccountingReportRows: new a8(),
      salaxyAccountingReportTools: new n8(),
      salaxyAccountingReportViewer: new s8(),
      salaxyPayCertificate: new u8(),
      salaxyCalculationReport: new i8(),
      salaxyAccountingRowReport: new m8(),
      salaxyEmployerReport: new B5(),
      salaxyWorkerReport: new J5(),
      salaxyHouseholdDeductionReport: new K5(),
      salaxyHouseholdYearDetails: new Z5(),
      salaxyHouseholdYearList: new Q5(),
      salaxySummaryReport: new g8(),
      salaxySummaryReportQuery: new v8(),
      salaxyWorkerSummaryReport: new y8(),
      // - worker
      salaxyAbsencePeriods: new a9(),
      salaxyEmploymentDetails: new n9(),
      salaxyEmploymentTaxcards: new q8(),
      salaxyHolidayYearAccrual: new B8(),
      salaxyHolidayYearHolidays: new W8(),
      salaxyHolidayYearPaid: new j8(),
      salaxyTaxcardDetails: new K8(),
      salaxyTaxcardIncomeLog: new Q8(),
      salaxyTaxcardManualEdit: new Z8(),
      salaxyTaxcardList: new e9(),
      salaxyTaxCardsList: new t9(),
      salaxyWorkerAbsences: new s9(),
      salaxyWorkerDetails: new i9(),
      salaxyWorkerHolidays: new V8(),
      salaxyEmploymentList: new UI(),
      salaxyWorkerList: new UI(),
      // For backward compatibility only
      // - obsolete
      salaxyWorkerAssure: new N5(),
      // - workflow
      salaxyCalendarEventDetails: new r9(),
      salaxyDatasetDetails: new l9(),
      salaxyWorkflowButtons: new d9(),
      salaxyWorkflowReopen: new u9(),
      salaxyWorkflowBadge: new p9(),
      // - records
      salaxyRecords: new c9(),
      // - settings
      salaxyAccountant: new x8(),
      salaxyRowTypesSettings: new E8(),
      salaxyAccountingTargetDetails: new A8(),
      salaxyInsurance: new k8(),
      salaxyInsuranceSettings: new T8(),
      salaxyOwnerSettings: new L8(),
      salaxyPaymentChannelSettings: new D8(),
      salaxyPaymentSettings: new I8(),
      salaxyProSettings: new P8(),
      salaxyAccountingTargetSettings: new C8(),
      salaxyServiceModelDetails: new N8(),
      salaxyUsecaseDetails: new o9(),
      salaxyCostAccountingSettings: new $8(),
      salaxyAccountingSettings: new w8(),
      salaxyHolidaySettings: new S8(),
      salaxyIrDeliverySettings: new R8()
    };
  }
}
/**
 * @license AngularJS v1.8.3
 * (c) 2010-2020 Google LLC. http://angularjs.org
 * License: MIT
 */
(function(s, t) {
  function e(A, T) {
    if (n(A)) {
      T = T || [];
      for (var R = 0, C = A.length; R < C; R++)
        T[R] = A[R];
    } else if (i(A)) {
      T = T || {};
      for (var v in A)
        v.charAt(0) === "$" && v.charAt(1) === "$" || (T[v] = A[v]);
    }
    return T || A;
  }
  function a(A, T) {
    var R = [], C = A.replace(/([().])/g, "\\$1").replace(/(\/)?:(\w+)(\*\?|[?*])?/g, function(v, P, O, N) {
      var H = N === "?" || N === "*?", F = N === "*" || N === "*?";
      return R.push({ name: O, optional: H }), P = P || "", (H ? "(?:" + P : P + "(?:") + (F ? "(.+?)" : "([^/]+)") + (H ? "?)?" : ")");
    }).replace(/([/$*])/g, "\\$1");
    return T.ignoreTrailingSlashes && (C = C.replace(/\/+$/, "") + "/*"), {
      keys: R,
      regexp: new RegExp(
        "^" + C + "(?:[?#]|$)",
        T.caseInsensitiveMatch ? "i" : ""
      )
    };
  }
  var n, i, r, l, o = t.module("ngRoute", []).info({ angularVersion: "1.8.3" }).provider("$route", p).run(h), c = t.$$minErr("ngRoute"), d;
  function p() {
    n = t.isArray, i = t.isObject, r = t.isDefined, l = t.noop;
    function A(R, C) {
      return t.extend(Object.create(R), C);
    }
    var T = {};
    this.when = function(R, C) {
      var v = e(C);
      if (t.isUndefined(v.reloadOnUrl) && (v.reloadOnUrl = !0), t.isUndefined(v.reloadOnSearch) && (v.reloadOnSearch = !0), t.isUndefined(v.caseInsensitiveMatch) && (v.caseInsensitiveMatch = this.caseInsensitiveMatch), T[R] = t.extend(
        v,
        { originalPath: R },
        R && a(R, v)
      ), R) {
        var P = R[R.length - 1] === "/" ? R.substr(0, R.length - 1) : R + "/";
        T[P] = t.extend(
          { originalPath: R, redirectTo: R },
          a(P, v)
        );
      }
      return this;
    }, this.caseInsensitiveMatch = !1, this.otherwise = function(R) {
      return typeof R == "string" && (R = { redirectTo: R }), this.when(null, R), this;
    }, d = !0, this.eagerInstantiationEnabled = function(C) {
      return r(C) ? (d = C, this) : d;
    }, this.$get = [
      "$rootScope",
      "$location",
      "$routeParams",
      "$q",
      "$injector",
      "$templateRequest",
      "$sce",
      "$browser",
      function(R, C, v, P, O, N, H, F) {
        var B = !1, Q, it, et = {
          routes: T,
          /**
           * @ngdoc method
           * @name $route#reload
           *
           * @description
           * Causes `$route` service to reload the current route even if
           * {@link ng.$location $location} hasn't changed.
           *
           * As a result of that, {@link ngRoute.directive:ngView ngView}
           * creates new scope and reinstantiates the controller.
           */
          reload: function() {
            B = !0;
            var lt = {
              defaultPrevented: !1,
              preventDefault: function() {
                this.defaultPrevented = !0, B = !1;
              }
            };
            R.$evalAsync(function() {
              U(lt), lt.defaultPrevented || M();
            });
          },
          /**
           * @ngdoc method
           * @name $route#updateParams
           *
           * @description
           * Causes `$route` service to update the current URL, replacing
           * current route parameters with those specified in `newParams`.
           * Provided property names that match the route's path segment
           * definitions will be interpolated into the location's path, while
           * remaining properties will be treated as query params.
           *
           * @param {!Object<string, string>} newParams mapping of URL parameter names to values
           */
          updateParams: function(lt) {
            if (this.current && this.current.$$route)
              lt = t.extend({}, this.current.params, lt), C.path(tt(this.current.$$route.originalPath, lt)), C.search(lt);
            else
              throw c("norout", "Tried updating route with no current route");
          }
        };
        return R.$on("$locationChangeStart", U), R.$on("$locationChangeSuccess", M), et;
        function rt(lt, at) {
          var nt = at.keys, yt = {};
          if (!at.regexp)
            return null;
          var Rt = at.regexp.exec(lt);
          if (!Rt)
            return null;
          for (var Yt = 1, K = Rt.length; Yt < K; ++Yt) {
            var _ = nt[Yt - 1], V = Rt[Yt];
            _ && V && (yt[_.name] = V);
          }
          return yt;
        }
        function U(lt) {
          var at = et.current;
          Q = zt(), it = j(Q, at), !it && (at || Q) && R.$broadcast("$routeChangeStart", Q, at).defaultPrevented && lt && lt.preventDefault();
        }
        function M() {
          var lt = et.current, at = Q;
          if (it)
            lt.params = at.params, t.copy(lt.params, v), R.$broadcast("$routeUpdate", lt);
          else if (at || lt) {
            B = !1, et.current = at;
            var nt = P.resolve(at);
            F.$$incOutstandingRequestCount("$route"), nt.then(W).then(J).then(function(yt) {
              return yt && nt.then(vt).then(function(Rt) {
                at === et.current && (at && (at.locals = Rt, t.copy(at.params, v)), R.$broadcast("$routeChangeSuccess", at, lt));
              });
            }).catch(function(yt) {
              at === et.current && R.$broadcast("$routeChangeError", at, lt, yt);
            }).finally(function() {
              F.$$completeOutstandingRequest(l, "$route");
            });
          }
        }
        function W(lt) {
          var at = {
            route: lt,
            hasRedirection: !1
          };
          if (lt) {
            if (lt.redirectTo)
              if (t.isString(lt.redirectTo))
                at.path = tt(lt.redirectTo, lt.params), at.search = lt.params, at.hasRedirection = !0;
              else {
                var nt = C.path(), yt = C.search(), Rt = lt.redirectTo(lt.pathParams, nt, yt);
                t.isDefined(Rt) && (at.url = Rt, at.hasRedirection = !0);
              }
            else if (lt.resolveRedirectTo)
              return P.resolve(O.invoke(lt.resolveRedirectTo)).then(function(Yt) {
                return t.isDefined(Yt) && (at.url = Yt, at.hasRedirection = !0), at;
              });
          }
          return at;
        }
        function J(lt) {
          var at = !0;
          if (lt.route !== et.current)
            at = !1;
          else if (lt.hasRedirection) {
            var nt = C.url(), yt = lt.url;
            yt ? C.url(yt).replace() : yt = C.path(lt.path).search(lt.search).replace().url(), yt !== nt && (at = !1);
          }
          return at;
        }
        function vt(lt) {
          if (lt) {
            var at = t.extend({}, lt.resolve);
            t.forEach(at, function(yt, Rt) {
              at[Rt] = t.isString(yt) ? O.get(yt) : O.invoke(yt, null, null, Rt);
            });
            var nt = St(lt);
            return t.isDefined(nt) && (at.$template = nt), P.all(at);
          }
        }
        function St(lt) {
          var at, nt;
          return t.isDefined(at = lt.template) ? t.isFunction(at) && (at = at(lt.params)) : t.isDefined(nt = lt.templateUrl) && (t.isFunction(nt) && (nt = nt(lt.params)), t.isDefined(nt) && (lt.loadedTemplateUrl = H.valueOf(nt), at = N(nt))), at;
        }
        function zt() {
          var lt, at;
          return t.forEach(T, function(nt, yt) {
            !at && (lt = rt(C.path(), nt)) && (at = A(nt, {
              params: t.extend({}, C.search(), lt),
              pathParams: lt
            }), at.$$route = nt);
          }), at || T[null] && A(T[null], { params: {}, pathParams: {} });
        }
        function j(lt, at) {
          return !B && lt && at && lt.$$route === at.$$route && (!lt.reloadOnUrl || !lt.reloadOnSearch && t.equals(lt.pathParams, at.pathParams));
        }
        function tt(lt, at) {
          var nt = [];
          return t.forEach((lt || "").split(":"), function(yt, Rt) {
            if (Rt === 0)
              nt.push(yt);
            else {
              var Yt = yt.match(/(\w+)(?:[?*])?(.*)/), K = Yt[1];
              nt.push(at[K]), nt.push(Yt[2] || ""), delete at[K];
            }
          }), nt.join("");
        }
      }
    ];
  }
  h.$inject = ["$injector"];
  function h(A) {
    d && A.get("$route");
  }
  o.provider("$routeParams", g);
  function g() {
    this.$get = function() {
      return {};
    };
  }
  o.directive("ngView", x), o.directive("ngView", b), x.$inject = ["$route", "$anchorScroll", "$animate"];
  function x(A, T, R) {
    return {
      restrict: "ECA",
      terminal: !0,
      priority: 400,
      transclude: "element",
      link: function(C, v, P, O, N) {
        var H, F, B, Q = P.autoscroll, it = P.onload || "";
        C.$on("$routeChangeSuccess", rt), rt();
        function et() {
          B && (R.cancel(B), B = null), H && (H.$destroy(), H = null), F && (B = R.leave(F), B.done(function(U) {
            U !== !1 && (B = null);
          }), F = null);
        }
        function rt() {
          var U = A.current && A.current.locals, M = U && U.$template;
          if (t.isDefined(M)) {
            var W = C.$new(), J = A.current, vt = N(W, function(St) {
              R.enter(St, null, F || v).done(function(j) {
                j !== !1 && t.isDefined(Q) && (!Q || C.$eval(Q)) && T();
              }), et();
            });
            F = vt, H = J.scope = W, H.$emit("$viewContentLoaded"), H.$eval(it);
          } else
            et();
        }
      }
    };
  }
  b.$inject = ["$compile", "$controller", "$route"];
  function b(A, T, R) {
    return {
      restrict: "ECA",
      priority: -400,
      link: function(C, v) {
        var P = R.current, O = P.locals;
        v.html(O.$template);
        var N = A(v.contents());
        if (P.controller) {
          O.$scope = C;
          var H = T(P.controller, O);
          P.controllerAs && (C[P.controllerAs] = H), v.data("$ngControllerController", H), v.children().data("$ngControllerController", H);
        }
        C[P.resolveAs || "$resolve"] = O, N(C);
      }
    };
  }
})(window, window.angular);
var m9 = "ngRoute";
const g9 = /* @__PURE__ */ Hs(m9);
angular.module("ngLocale", [], ["$provide", function(s) {
  var t = { ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other" };
  function e(n) {
    n = n + "";
    var i = n.indexOf(".");
    return i == -1 ? 0 : n.length - i - 1;
  }
  function a(n, i) {
    var r = i;
    r === void 0 && (r = Math.min(e(n), 3));
    var l = Math.pow(10, r), o = (n * l | 0) % l;
    return { v: r, f: o };
  }
  s.value("$locale", {
    DATETIME_FORMATS: {
      AMPMS: [
        "ap.",
        "ip."
      ],
      DAY: [
        "sunnuntaina",
        "maanantaina",
        "tiistaina",
        "keskiviikkona",
        "torstaina",
        "perjantaina",
        "lauantaina"
      ],
      ERANAMES: [
        "ennen Kristuksen syntymää",
        "jälkeen Kristuksen syntymän"
      ],
      ERAS: [
        "eKr.",
        "jKr."
      ],
      FIRSTDAYOFWEEK: 0,
      MONTH: [
        "tammikuuta",
        "helmikuuta",
        "maaliskuuta",
        "huhtikuuta",
        "toukokuuta",
        "kesäkuuta",
        "heinäkuuta",
        "elokuuta",
        "syyskuuta",
        "lokakuuta",
        "marraskuuta",
        "joulukuuta"
      ],
      SHORTDAY: [
        "su",
        "ma",
        "ti",
        "ke",
        "to",
        "pe",
        "la"
      ],
      SHORTMONTH: [
        "tammik.",
        "helmik.",
        "maalisk.",
        "huhtik.",
        "toukok.",
        "kesäk.",
        "heinäk.",
        "elok.",
        "syysk.",
        "lokak.",
        "marrask.",
        "jouluk."
      ],
      STANDALONEMONTH: [
        "tammikuu",
        "helmikuu",
        "maaliskuu",
        "huhtikuu",
        "toukokuu",
        "kesäkuu",
        "heinäkuu",
        "elokuu",
        "syyskuu",
        "lokakuu",
        "marraskuu",
        "joulukuu"
      ],
      WEEKENDRANGE: [
        5,
        6
      ],
      fullDate: "cccc d. MMMM y",
      longDate: "d. MMMM y",
      medium: "d.M.y H.mm.ss",
      mediumDate: "d.M.y",
      mediumTime: "H.mm.ss",
      short: "d.M.y H.mm",
      shortDate: "d.M.y",
      shortTime: "H.mm"
    },
    NUMBER_FORMATS: {
      CURRENCY_SYM: "€",
      DECIMAL_SEP: ",",
      GROUP_SEP: " ",
      PATTERNS: [
        {
          gSize: 3,
          lgSize: 3,
          maxFrac: 3,
          minFrac: 0,
          minInt: 1,
          negPre: "-",
          negSuf: "",
          posPre: "",
          posSuf: ""
        },
        {
          gSize: 3,
          lgSize: 3,
          maxFrac: 2,
          minFrac: 2,
          minInt: 1,
          negPre: "-",
          negSuf: " ¤",
          posPre: "",
          posSuf: " ¤"
        }
      ]
    },
    id: "fi",
    localeID: "fi",
    pluralCat: function(n, i) {
      var r = n | 0, l = a(n, i);
      return r == 1 && l.v == 0 ? t.ONE : t.OTHER;
    }
  });
}]);
angular.module("ui.bootstrap", ["ui.bootstrap.tpls", "ui.bootstrap.collapse", "ui.bootstrap.tabindex", "ui.bootstrap.accordion", "ui.bootstrap.alert", "ui.bootstrap.buttons", "ui.bootstrap.carousel", "ui.bootstrap.dateparser", "ui.bootstrap.isClass", "ui.bootstrap.datepicker", "ui.bootstrap.position", "ui.bootstrap.datepickerPopup", "ui.bootstrap.debounce", "ui.bootstrap.multiMap", "ui.bootstrap.dropdown", "ui.bootstrap.stackedMap", "ui.bootstrap.modal", "ui.bootstrap.paging", "ui.bootstrap.pager", "ui.bootstrap.pagination", "ui.bootstrap.tooltip", "ui.bootstrap.popover", "ui.bootstrap.progressbar", "ui.bootstrap.rating", "ui.bootstrap.tabs", "ui.bootstrap.timepicker", "ui.bootstrap.typeahead"]);
angular.module("ui.bootstrap.tpls", ["uib/template/accordion/accordion-group.html", "uib/template/accordion/accordion.html", "uib/template/alert/alert.html", "uib/template/carousel/carousel.html", "uib/template/carousel/slide.html", "uib/template/datepicker/datepicker.html", "uib/template/datepicker/day.html", "uib/template/datepicker/month.html", "uib/template/datepicker/year.html", "uib/template/datepickerPopup/popup.html", "uib/template/modal/window.html", "uib/template/pager/pager.html", "uib/template/pagination/pagination.html", "uib/template/tooltip/tooltip-html-popup.html", "uib/template/tooltip/tooltip-popup.html", "uib/template/tooltip/tooltip-template-popup.html", "uib/template/popover/popover-html.html", "uib/template/popover/popover-template.html", "uib/template/popover/popover.html", "uib/template/progressbar/bar.html", "uib/template/progressbar/progress.html", "uib/template/progressbar/progressbar.html", "uib/template/rating/rating.html", "uib/template/tabs/tab.html", "uib/template/tabs/tabset.html", "uib/template/timepicker/timepicker.html", "uib/template/typeahead/typeahead-match.html", "uib/template/typeahead/typeahead-popup.html"]);
angular.module("ui.bootstrap.collapse", []).directive("uibCollapse", ["$animate", "$q", "$parse", "$injector", function(s, t, e, a) {
  var n = a.has("$animateCss") ? a.get("$animateCss") : null;
  return {
    link: function(i, r, l) {
      var o = e(l.expanding), c = e(l.expanded), d = e(l.collapsing), p = e(l.collapsed), h = !1, g = {}, x = {};
      b();
      function b() {
        h = "horizontal" in l, h ? (g = {
          width: ""
        }, x = { width: "0" }) : (g = {
          height: ""
        }, x = { height: "0" }), i.$eval(l.uibCollapse) || r.addClass("in").addClass("collapse").attr("aria-expanded", !0).attr("aria-hidden", !1).css(g);
      }
      function A(P) {
        return h ? { width: P.scrollWidth + "px" } : { height: P.scrollHeight + "px" };
      }
      function T() {
        r.hasClass("collapse") && r.hasClass("in") || t.resolve(o(i)).then(function() {
          r.removeClass("collapse").addClass("collapsing").attr("aria-expanded", !0).attr("aria-hidden", !1), n ? n(r, {
            addClass: "in",
            easing: "ease",
            css: {
              overflow: "hidden"
            },
            to: A(r[0])
          }).start().finally(R) : s.addClass(r, "in", {
            css: {
              overflow: "hidden"
            },
            to: A(r[0])
          }).then(R);
        }, angular.noop);
      }
      function R() {
        r.removeClass("collapsing").addClass("collapse").css(g), c(i);
      }
      function C() {
        if (!r.hasClass("collapse") && !r.hasClass("in"))
          return v();
        t.resolve(d(i)).then(function() {
          r.css(A(r[0])).removeClass("collapse").addClass("collapsing").attr("aria-expanded", !1).attr("aria-hidden", !0), n ? n(r, {
            removeClass: "in",
            to: x
          }).start().finally(v) : s.removeClass(r, "in", {
            to: x
          }).then(v);
        }, angular.noop);
      }
      function v() {
        r.css(x), r.removeClass("collapsing").addClass("collapse"), p(i);
      }
      i.$watch(l.uibCollapse, function(P) {
        P ? C() : T();
      });
    }
  };
}]);
angular.module("ui.bootstrap.tabindex", []).directive("uibTabindexToggle", function() {
  return {
    restrict: "A",
    link: function(s, t, e) {
      e.$observe("disabled", function(a) {
        e.$set("tabindex", a ? -1 : null);
      });
    }
  };
});
angular.module("ui.bootstrap.accordion", ["ui.bootstrap.collapse", "ui.bootstrap.tabindex"]).constant("uibAccordionConfig", {
  closeOthers: !0
}).controller("UibAccordionController", ["$scope", "$attrs", "uibAccordionConfig", function(s, t, e) {
  this.groups = [], this.closeOthers = function(a) {
    var n = angular.isDefined(t.closeOthers) ? s.$eval(t.closeOthers) : e.closeOthers;
    n && angular.forEach(this.groups, function(i) {
      i !== a && (i.isOpen = !1);
    });
  }, this.addGroup = function(a) {
    var n = this;
    this.groups.push(a), a.$on("$destroy", function(i) {
      n.removeGroup(a);
    });
  }, this.removeGroup = function(a) {
    var n = this.groups.indexOf(a);
    n !== -1 && this.groups.splice(n, 1);
  };
}]).directive("uibAccordion", function() {
  return {
    controller: "UibAccordionController",
    controllerAs: "accordion",
    transclude: !0,
    templateUrl: function(s, t) {
      return t.templateUrl || "uib/template/accordion/accordion.html";
    }
  };
}).directive("uibAccordionGroup", function() {
  return {
    require: "^uibAccordion",
    // We need this directive to be inside an accordion
    transclude: !0,
    // It transcludes the contents of the directive into the template
    restrict: "A",
    templateUrl: function(s, t) {
      return t.templateUrl || "uib/template/accordion/accordion-group.html";
    },
    scope: {
      heading: "@",
      // Interpolate the heading attribute onto this scope
      panelClass: "@?",
      // Ditto with panelClass
      isOpen: "=?",
      isDisabled: "=?"
    },
    controller: function() {
      this.setHeading = function(s) {
        this.heading = s;
      };
    },
    link: function(s, t, e, a) {
      t.addClass("panel"), a.addGroup(s), s.openClass = e.openClass || "panel-open", s.panelClass = e.panelClass || "panel-default", s.$watch("isOpen", function(i) {
        t.toggleClass(s.openClass, !!i), i && a.closeOthers(s);
      }), s.toggleOpen = function(i) {
        s.isDisabled || (!i || i.which === 32) && (s.isOpen = !s.isOpen);
      };
      var n = "accordiongroup-" + s.$id + "-" + Math.floor(Math.random() * 1e4);
      s.headingId = n + "-tab", s.panelId = n + "-panel";
    }
  };
}).directive("uibAccordionHeading", function() {
  return {
    transclude: !0,
    // Grab the contents to be used as the heading
    template: "",
    // In effect remove this element!
    replace: !0,
    require: "^uibAccordionGroup",
    link: function(s, t, e, a, n) {
      a.setHeading(n(s, angular.noop));
    }
  };
}).directive("uibAccordionTransclude", function() {
  return {
    require: "^uibAccordionGroup",
    link: function(t, e, a, n) {
      t.$watch(function() {
        return n[a.uibAccordionTransclude];
      }, function(i) {
        if (i) {
          var r = angular.element(e[0].querySelector(s()));
          r.html(""), r.append(i);
        }
      });
    }
  };
  function s() {
    return "uib-accordion-header,data-uib-accordion-header,x-uib-accordion-header,uib\\:accordion-header,[uib-accordion-header],[data-uib-accordion-header],[x-uib-accordion-header]";
  }
});
angular.module("ui.bootstrap.alert", []).controller("UibAlertController", ["$scope", "$element", "$attrs", "$interpolate", "$timeout", function(s, t, e, a, n) {
  s.closeable = !!e.close, t.addClass("alert"), e.$set("role", "alert"), s.closeable && t.addClass("alert-dismissible");
  var i = angular.isDefined(e.dismissOnTimeout) ? a(e.dismissOnTimeout)(s.$parent) : null;
  i && n(function() {
    s.close();
  }, parseInt(i, 10));
}]).directive("uibAlert", function() {
  return {
    controller: "UibAlertController",
    controllerAs: "alert",
    restrict: "A",
    templateUrl: function(s, t) {
      return t.templateUrl || "uib/template/alert/alert.html";
    },
    transclude: !0,
    scope: {
      close: "&"
    }
  };
});
angular.module("ui.bootstrap.buttons", []).constant("uibButtonConfig", {
  activeClass: "active",
  toggleEvent: "click"
}).controller("UibButtonsController", ["uibButtonConfig", function(s) {
  this.activeClass = s.activeClass || "active", this.toggleEvent = s.toggleEvent || "click";
}]).directive("uibBtnRadio", ["$parse", function(s) {
  return {
    require: ["uibBtnRadio", "ngModel"],
    controller: "UibButtonsController",
    controllerAs: "buttons",
    link: function(t, e, a, n) {
      var i = n[0], r = n[1], l = s(a.uibUncheckable);
      e.find("input").css({ display: "none" }), r.$render = function() {
        e.toggleClass(i.activeClass, angular.equals(r.$modelValue, t.$eval(a.uibBtnRadio)));
      }, e.on(i.toggleEvent, function() {
        if (!a.disabled) {
          var o = e.hasClass(i.activeClass);
          (!o || angular.isDefined(a.uncheckable)) && t.$apply(function() {
            r.$setViewValue(o ? null : t.$eval(a.uibBtnRadio)), r.$render();
          });
        }
      }), a.uibUncheckable && t.$watch(l, function(o) {
        a.$set("uncheckable", o ? "" : void 0);
      });
    }
  };
}]).directive("uibBtnCheckbox", function() {
  return {
    require: ["uibBtnCheckbox", "ngModel"],
    controller: "UibButtonsController",
    controllerAs: "button",
    link: function(s, t, e, a) {
      var n = a[0], i = a[1];
      t.find("input").css({ display: "none" });
      function r() {
        return o(e.btnCheckboxTrue, !0);
      }
      function l() {
        return o(e.btnCheckboxFalse, !1);
      }
      function o(c, d) {
        return angular.isDefined(c) ? s.$eval(c) : d;
      }
      i.$render = function() {
        t.toggleClass(n.activeClass, angular.equals(i.$modelValue, r()));
      }, t.on(n.toggleEvent, function() {
        e.disabled || s.$apply(function() {
          i.$setViewValue(t.hasClass(n.activeClass) ? l() : r()), i.$render();
        });
      });
    }
  };
});
angular.module("ui.bootstrap.carousel", []).controller("UibCarouselController", ["$scope", "$element", "$interval", "$timeout", "$animate", function(s, t, e, a, n) {
  var i = this, r = i.slides = s.slides = [], l = "uib-slideDirection", o = s.active, c, d, p = !1;
  t.addClass("carousel"), i.addSlide = function(C, v) {
    r.push({
      slide: C,
      element: v
    }), r.sort(function(P, O) {
      return +P.slide.index - +O.slide.index;
    }), (C.index === s.active || r.length === 1 && !angular.isNumber(s.active)) && (s.$currentTransition && (s.$currentTransition = null), o = C.index, s.active = C.index, h(o), i.select(r[x(C)]), r.length === 1 && s.play());
  }, i.getCurrentIndex = function() {
    for (var C = 0; C < r.length; C++)
      if (r[C].slide.index === o)
        return C;
  }, i.next = s.next = function() {
    var C = (i.getCurrentIndex() + 1) % r.length;
    if (C === 0 && s.noWrap()) {
      s.pause();
      return;
    }
    return i.select(r[C], "next");
  }, i.prev = s.prev = function() {
    var C = i.getCurrentIndex() - 1 < 0 ? r.length - 1 : i.getCurrentIndex() - 1;
    if (s.noWrap() && C === r.length - 1) {
      s.pause();
      return;
    }
    return i.select(r[C], "prev");
  }, i.removeSlide = function(C) {
    var v = x(C);
    r.splice(v, 1), r.length > 0 && o === v ? v >= r.length ? (o = r.length - 1, s.active = o, h(o), i.select(r[r.length - 1])) : (o = v, s.active = o, h(o), i.select(r[v])) : o > v && (o--, s.active = o), r.length === 0 && (o = null, s.active = null);
  }, i.select = s.select = function(C, v) {
    var P = x(C.slide);
    v === void 0 && (v = P > i.getCurrentIndex() ? "next" : "prev"), C.slide.index !== o && !s.$currentTransition && g(C.slide, P, v);
  }, s.indexOfSlide = function(C) {
    return +C.slide.index;
  }, s.isActive = function(C) {
    return s.active === C.slide.index;
  }, s.isPrevDisabled = function() {
    return s.active === 0 && s.noWrap();
  }, s.isNextDisabled = function() {
    return s.active === r.length - 1 && s.noWrap();
  }, s.pause = function() {
    s.noPause || (d = !1, b());
  }, s.play = function() {
    d || (d = !0, T());
  }, t.on("mouseenter", s.pause), t.on("mouseleave", s.play), s.$on("$destroy", function() {
    p = !0, b();
  }), s.$watch("noTransition", function(C) {
    n.enabled(t, !C);
  }), s.$watch("interval", T), s.$watchCollection("slides", A), s.$watch("active", function(C) {
    if (angular.isNumber(C) && o !== C) {
      for (var v = 0; v < r.length; v++)
        if (r[v].slide.index === C) {
          C = v;
          break;
        }
      var P = r[C];
      P && (h(C), i.select(r[C]), o = C);
    }
  });
  function h(C) {
    for (var v = 0; v < r.length; v++)
      r[v].slide.active = v === C;
  }
  function g(C, v, P) {
    if (!p) {
      if (angular.extend(C, { direction: P }), angular.extend(r[o].slide || {}, { direction: P }), n.enabled(t) && !s.$currentTransition && r[v].element && i.slides.length > 1) {
        r[v].element.data(l, C.direction);
        var O = i.getCurrentIndex();
        angular.isNumber(O) && r[O].element && r[O].element.data(l, C.direction), s.$currentTransition = !0, n.on("addClass", r[v].element, function(N, H) {
          H === "close" && (s.$currentTransition = null, n.off("addClass", N));
        });
      }
      s.active = C.index, o = C.index, h(v), T();
    }
  }
  function x(C) {
    for (var v = 0; v < r.length; v++)
      if (r[v].slide === C)
        return v;
  }
  function b() {
    c && (e.cancel(c), c = null);
  }
  function A(C) {
    C.length || (s.$currentTransition = null);
  }
  function T() {
    b();
    var C = +s.interval;
    !isNaN(C) && C > 0 && (c = e(R, C));
  }
  function R() {
    var C = +s.interval;
    d && !isNaN(C) && C > 0 && r.length ? s.next() : s.pause();
  }
}]).directive("uibCarousel", function() {
  return {
    transclude: !0,
    controller: "UibCarouselController",
    controllerAs: "carousel",
    restrict: "A",
    templateUrl: function(s, t) {
      return t.templateUrl || "uib/template/carousel/carousel.html";
    },
    scope: {
      active: "=",
      interval: "=",
      noTransition: "=",
      noPause: "=",
      noWrap: "&"
    }
  };
}).directive("uibSlide", ["$animate", function(s) {
  return {
    require: "^uibCarousel",
    restrict: "A",
    transclude: !0,
    templateUrl: function(t, e) {
      return e.templateUrl || "uib/template/carousel/slide.html";
    },
    scope: {
      actual: "=?",
      index: "=?"
    },
    link: function(t, e, a, n) {
      e.addClass("item"), n.addSlide(t, e), t.$on("$destroy", function() {
        n.removeSlide(t);
      }), t.$watch("active", function(i) {
        s[i ? "addClass" : "removeClass"](e, "active");
      });
    }
  };
}]).animation(".item", [
  "$animateCss",
  function(s) {
    var t = "uib-slideDirection";
    function e(a, n, i) {
      a.removeClass(n), i && i();
    }
    return {
      beforeAddClass: function(a, n, i) {
        if (n === "active") {
          var r = a.data(t), l = r === "next" ? "left" : "right", o = e.bind(
            this,
            a,
            l + " " + r,
            i
          );
          return a.addClass(r), s(a, { addClass: l }).start().done(o), function() {
          };
        }
        i();
      },
      beforeRemoveClass: function(a, n, i) {
        if (n === "active") {
          var r = a.data(t), l = r === "next" ? "left" : "right", o = e.bind(this, a, l, i);
          return s(a, { addClass: l }).start().done(o), function() {
          };
        }
        i();
      }
    };
  }
]);
angular.module("ui.bootstrap.dateparser", []).service("uibDateParser", ["$log", "$locale", "dateFilter", "orderByFilter", "filterFilter", function(s, t, e, a, n) {
  var i = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g, r, l;
  this.init = function() {
    r = t.id, this.parsers = {}, this.formatters = {}, l = [
      {
        key: "yyyy",
        regex: "\\d{4}",
        apply: function(v) {
          this.year = +v;
        },
        formatter: function(v) {
          var P = /* @__PURE__ */ new Date();
          return P.setFullYear(Math.abs(v.getFullYear())), e(P, "yyyy");
        }
      },
      {
        key: "yy",
        regex: "\\d{2}",
        apply: function(v) {
          v = +v, this.year = v < 69 ? v + 2e3 : v + 1900;
        },
        formatter: function(v) {
          var P = /* @__PURE__ */ new Date();
          return P.setFullYear(Math.abs(v.getFullYear())), e(P, "yy");
        }
      },
      {
        key: "y",
        regex: "\\d{1,4}",
        apply: function(v) {
          this.year = +v;
        },
        formatter: function(v) {
          var P = /* @__PURE__ */ new Date();
          return P.setFullYear(Math.abs(v.getFullYear())), e(P, "y");
        }
      },
      {
        key: "M!",
        regex: "0?[1-9]|1[0-2]",
        apply: function(v) {
          this.month = v - 1;
        },
        formatter: function(v) {
          var P = v.getMonth();
          return /^[0-9]$/.test(P) ? e(v, "MM") : e(v, "M");
        }
      },
      {
        key: "MMMM",
        regex: t.DATETIME_FORMATS.MONTH.join("|"),
        apply: function(v) {
          this.month = t.DATETIME_FORMATS.MONTH.indexOf(v);
        },
        formatter: function(v) {
          return e(v, "MMMM");
        }
      },
      {
        key: "MMM",
        regex: t.DATETIME_FORMATS.SHORTMONTH.join("|"),
        apply: function(v) {
          this.month = t.DATETIME_FORMATS.SHORTMONTH.indexOf(v);
        },
        formatter: function(v) {
          return e(v, "MMM");
        }
      },
      {
        key: "MM",
        regex: "0[1-9]|1[0-2]",
        apply: function(v) {
          this.month = v - 1;
        },
        formatter: function(v) {
          return e(v, "MM");
        }
      },
      {
        key: "M",
        regex: "[1-9]|1[0-2]",
        apply: function(v) {
          this.month = v - 1;
        },
        formatter: function(v) {
          return e(v, "M");
        }
      },
      {
        key: "d!",
        regex: "[0-2]?[0-9]{1}|3[0-1]{1}",
        apply: function(v) {
          this.date = +v;
        },
        formatter: function(v) {
          var P = v.getDate();
          return /^[1-9]$/.test(P) ? e(v, "dd") : e(v, "d");
        }
      },
      {
        key: "dd",
        regex: "[0-2][0-9]{1}|3[0-1]{1}",
        apply: function(v) {
          this.date = +v;
        },
        formatter: function(v) {
          return e(v, "dd");
        }
      },
      {
        key: "d",
        regex: "[1-2]?[0-9]{1}|3[0-1]{1}",
        apply: function(v) {
          this.date = +v;
        },
        formatter: function(v) {
          return e(v, "d");
        }
      },
      {
        key: "EEEE",
        regex: t.DATETIME_FORMATS.DAY.join("|"),
        formatter: function(v) {
          return e(v, "EEEE");
        }
      },
      {
        key: "EEE",
        regex: t.DATETIME_FORMATS.SHORTDAY.join("|"),
        formatter: function(v) {
          return e(v, "EEE");
        }
      },
      {
        key: "HH",
        regex: "(?:0|1)[0-9]|2[0-3]",
        apply: function(v) {
          this.hours = +v;
        },
        formatter: function(v) {
          return e(v, "HH");
        }
      },
      {
        key: "hh",
        regex: "0[0-9]|1[0-2]",
        apply: function(v) {
          this.hours = +v;
        },
        formatter: function(v) {
          return e(v, "hh");
        }
      },
      {
        key: "H",
        regex: "1?[0-9]|2[0-3]",
        apply: function(v) {
          this.hours = +v;
        },
        formatter: function(v) {
          return e(v, "H");
        }
      },
      {
        key: "h",
        regex: "[0-9]|1[0-2]",
        apply: function(v) {
          this.hours = +v;
        },
        formatter: function(v) {
          return e(v, "h");
        }
      },
      {
        key: "mm",
        regex: "[0-5][0-9]",
        apply: function(v) {
          this.minutes = +v;
        },
        formatter: function(v) {
          return e(v, "mm");
        }
      },
      {
        key: "m",
        regex: "[0-9]|[1-5][0-9]",
        apply: function(v) {
          this.minutes = +v;
        },
        formatter: function(v) {
          return e(v, "m");
        }
      },
      {
        key: "sss",
        regex: "[0-9][0-9][0-9]",
        apply: function(v) {
          this.milliseconds = +v;
        },
        formatter: function(v) {
          return e(v, "sss");
        }
      },
      {
        key: "ss",
        regex: "[0-5][0-9]",
        apply: function(v) {
          this.seconds = +v;
        },
        formatter: function(v) {
          return e(v, "ss");
        }
      },
      {
        key: "s",
        regex: "[0-9]|[1-5][0-9]",
        apply: function(v) {
          this.seconds = +v;
        },
        formatter: function(v) {
          return e(v, "s");
        }
      },
      {
        key: "a",
        regex: t.DATETIME_FORMATS.AMPMS.join("|"),
        apply: function(v) {
          this.hours === 12 && (this.hours = 0), v === "PM" && (this.hours += 12);
        },
        formatter: function(v) {
          return e(v, "a");
        }
      },
      {
        key: "Z",
        regex: "[+-]\\d{4}",
        apply: function(v) {
          var P = v.match(/([+-])(\d{2})(\d{2})/), O = P[1], N = P[2], H = P[3];
          this.hours += x(O + N), this.minutes += x(O + H);
        },
        formatter: function(v) {
          return e(v, "Z");
        }
      },
      {
        key: "ww",
        regex: "[0-4][0-9]|5[0-3]",
        formatter: function(v) {
          return e(v, "ww");
        }
      },
      {
        key: "w",
        regex: "[0-9]|[1-4][0-9]|5[0-3]",
        formatter: function(v) {
          return e(v, "w");
        }
      },
      {
        key: "GGGG",
        regex: t.DATETIME_FORMATS.ERANAMES.join("|").replace(/\s/g, "\\s"),
        formatter: function(v) {
          return e(v, "GGGG");
        }
      },
      {
        key: "GGG",
        regex: t.DATETIME_FORMATS.ERAS.join("|"),
        formatter: function(v) {
          return e(v, "GGG");
        }
      },
      {
        key: "GG",
        regex: t.DATETIME_FORMATS.ERAS.join("|"),
        formatter: function(v) {
          return e(v, "GG");
        }
      },
      {
        key: "G",
        regex: t.DATETIME_FORMATS.ERAS.join("|"),
        formatter: function(v) {
          return e(v, "G");
        }
      }
    ], angular.version.major >= 1 && angular.version.minor > 4 && l.push({
      key: "LLLL",
      regex: t.DATETIME_FORMATS.STANDALONEMONTH.join("|"),
      apply: function(v) {
        this.month = t.DATETIME_FORMATS.STANDALONEMONTH.indexOf(v);
      },
      formatter: function(v) {
        return e(v, "LLLL");
      }
    });
  }, this.init();
  function o(v) {
    return n(l, { key: v }, !0)[0];
  }
  this.getParser = function(v) {
    var P = o(v);
    return P && P.apply || null;
  }, this.overrideParser = function(v, P) {
    var O = o(v);
    O && angular.isFunction(P) && (this.parsers = {}, O.apply = P);
  }.bind(this);
  function c(v) {
    var P = [], O = v.split(""), N = v.indexOf("'");
    if (N > -1) {
      var H = !1;
      v = v.split("");
      for (var F = N; F < v.length; F++)
        H ? (v[F] === "'" && (F + 1 < v.length && v[F + 1] === "'" ? (v[F + 1] = "$", O[F + 1] = "") : (O[F] = "", H = !1)), v[F] = "$") : v[F] === "'" && (v[F] = "$", O[F] = "", H = !0);
      v = v.join("");
    }
    return angular.forEach(l, function(B) {
      var Q = v.indexOf(B.key);
      if (Q > -1) {
        v = v.split(""), O[Q] = "(" + B.regex + ")", v[Q] = "$";
        for (var it = Q + 1, et = Q + B.key.length; it < et; it++)
          O[it] = "", v[it] = "$";
        v = v.join(""), P.push({
          index: Q,
          key: B.key,
          apply: B.apply,
          matcher: B.regex
        });
      }
    }), {
      regex: new RegExp("^" + O.join("") + "$"),
      map: a(P, "index")
    };
  }
  function d(v) {
    for (var P = [], O = 0, N, H; O < v.length; ) {
      if (angular.isNumber(H)) {
        if (v.charAt(O) === "'")
          (O + 1 >= v.length || v.charAt(O + 1) !== "'") && (P.push(p(v, H, O)), H = null);
        else if (O === v.length)
          for (; H < v.length; )
            N = h(v, H), P.push(N), H = N.endIdx;
        O++;
        continue;
      }
      if (v.charAt(O) === "'") {
        H = O, O++;
        continue;
      }
      N = h(v, O), P.push(N.parser), O = N.endIdx;
    }
    return P;
  }
  function p(v, P, O) {
    return function() {
      return v.substr(P + 1, O - P - 1);
    };
  }
  function h(v, P) {
    for (var O = v.substr(P), N = 0; N < l.length; N++)
      if (new RegExp("^" + l[N].key).test(O)) {
        var H = l[N];
        return {
          endIdx: P + H.key.length,
          parser: H.formatter
        };
      }
    return {
      endIdx: P + 1,
      parser: function() {
        return O.charAt(0);
      }
    };
  }
  this.filter = function(v, P) {
    if (!angular.isDate(v) || isNaN(v) || !P)
      return "";
    P = t.DATETIME_FORMATS[P] || P, t.id !== r && this.init(), this.formatters[P] || (this.formatters[P] = d(P));
    var O = this.formatters[P];
    return O.reduce(function(N, H) {
      return N + H(v);
    }, "");
  }, this.parse = function(v, P, O) {
    if (!angular.isString(v) || !P)
      return v;
    P = t.DATETIME_FORMATS[P] || P, P = P.replace(i, "\\$&"), t.id !== r && this.init(), this.parsers[P] || (this.parsers[P] = c(P));
    var N = this.parsers[P], H = N.regex, F = N.map, B = v.match(H), Q = !1;
    if (B && B.length) {
      var it, et;
      angular.isDate(O) && !isNaN(O.getTime()) ? it = {
        year: O.getFullYear(),
        month: O.getMonth(),
        date: O.getDate(),
        hours: O.getHours(),
        minutes: O.getMinutes(),
        seconds: O.getSeconds(),
        milliseconds: O.getMilliseconds()
      } : (O && s.warn("dateparser:", "baseDate is not a valid date"), it = { year: 1900, month: 0, date: 1, hours: 0, minutes: 0, seconds: 0, milliseconds: 0 });
      for (var rt = 1, U = B.length; rt < U; rt++) {
        var M = F[rt - 1];
        M.matcher === "Z" && (Q = !0), M.apply && M.apply.call(it, B[rt]);
      }
      var W = Q ? Date.prototype.setUTCFullYear : Date.prototype.setFullYear, J = Q ? Date.prototype.setUTCHours : Date.prototype.setHours;
      return g(it.year, it.month, it.date) && (angular.isDate(O) && !isNaN(O.getTime()) && !Q ? (et = new Date(O), W.call(et, it.year, it.month, it.date), J.call(
        et,
        it.hours,
        it.minutes,
        it.seconds,
        it.milliseconds
      )) : (et = /* @__PURE__ */ new Date(0), W.call(et, it.year, it.month, it.date), J.call(
        et,
        it.hours || 0,
        it.minutes || 0,
        it.seconds || 0,
        it.milliseconds || 0
      ))), et;
    }
  };
  function g(v, P, O) {
    return O < 1 ? !1 : P === 1 && O > 28 ? O === 29 && (v % 4 === 0 && v % 100 !== 0 || v % 400 === 0) : P === 3 || P === 5 || P === 8 || P === 10 ? O < 31 : !0;
  }
  function x(v) {
    return parseInt(v, 10);
  }
  this.toTimezone = b, this.fromTimezone = A, this.timezoneToOffset = T, this.addDateMinutes = R, this.convertTimezoneToLocal = C;
  function b(v, P) {
    return v && P ? C(v, P) : v;
  }
  function A(v, P) {
    return v && P ? C(v, P, !0) : v;
  }
  function T(v, P) {
    v = v.replace(/:/g, "");
    var O = Date.parse("Jan 01, 1970 00:00:00 " + v) / 6e4;
    return isNaN(O) ? P : O;
  }
  function R(v, P) {
    return v = new Date(v.getTime()), v.setMinutes(v.getMinutes() + P), v;
  }
  function C(v, P, O) {
    O = O ? -1 : 1;
    var N = v.getTimezoneOffset(), H = T(P, N);
    return R(v, O * (H - N));
  }
}]);
angular.module("ui.bootstrap.isClass", []).directive("uibIsClass", [
  "$animate",
  function(s) {
    var t = /^\s*([\s\S]+?)\s+on\s+([\s\S]+?)\s*$/, e = /^\s*([\s\S]+?)\s+for\s+([\s\S]+?)\s*$/;
    return {
      restrict: "A",
      compile: function(a, n) {
        var i = [], r = [], l = {}, o = n.uibIsClass.match(t), c = o[2], d = o[1], p = d.split(",");
        return h;
        function h(b, A, T) {
          i.push(b), r.push({
            scope: b,
            element: A
          }), p.forEach(function(R, C) {
            g(R, b);
          }), b.$on("$destroy", x);
        }
        function g(b, A) {
          var T = b.match(e), R = A.$eval(T[1]), C = T[2], v = l[b];
          if (!v) {
            var P = function(O) {
              var N = null;
              r.some(function(H) {
                var F = H.scope.$eval(c);
                if (F === O)
                  return N = H, !0;
              }), v.lastActivated !== N && (v.lastActivated && s.removeClass(v.lastActivated.element, R), N && s.addClass(N.element, R), v.lastActivated = N);
            };
            l[b] = v = {
              lastActivated: null,
              scope: A,
              watchFn: P,
              compareWithExp: C,
              watcher: A.$watch(C, P)
            };
          }
          v.watchFn(A.$eval(C));
        }
        function x(b) {
          var A = b.targetScope, T = i.indexOf(A);
          if (i.splice(T, 1), r.splice(T, 1), i.length) {
            var R = i[0];
            angular.forEach(l, function(C) {
              C.scope === A && (C.watcher = R.$watch(C.compareWithExp, C.watchFn), C.scope = R);
            });
          } else
            l = {};
        }
      }
    };
  }
]);
angular.module("ui.bootstrap.datepicker", ["ui.bootstrap.dateparser", "ui.bootstrap.isClass"]).value("$datepickerSuppressError", !1).value("$datepickerLiteralWarning", !0).constant("uibDatepickerConfig", {
  datepickerMode: "day",
  formatDay: "dd",
  formatMonth: "MMMM",
  formatYear: "yyyy",
  formatDayHeader: "EEE",
  formatDayTitle: "MMMM yyyy",
  formatMonthTitle: "yyyy",
  maxDate: null,
  maxMode: "year",
  minDate: null,
  minMode: "day",
  monthColumns: 3,
  ngModelOptions: {},
  shortcutPropagation: !1,
  showWeeks: !0,
  yearColumns: 5,
  yearRows: 4
}).controller("UibDatepickerController", [
  "$scope",
  "$element",
  "$attrs",
  "$parse",
  "$interpolate",
  "$locale",
  "$log",
  "dateFilter",
  "uibDatepickerConfig",
  "$datepickerLiteralWarning",
  "$datepickerSuppressError",
  "uibDateParser",
  function(s, t, e, a, n, i, r, l, o, c, d, p) {
    var h = this, g = { $setViewValue: angular.noop }, x = {}, b = [];
    t.addClass("uib-datepicker"), e.$set("role", "application"), s.datepickerOptions || (s.datepickerOptions = {}), this.modes = ["day", "month", "year"], [
      "customClass",
      "dateDisabled",
      "datepickerMode",
      "formatDay",
      "formatDayHeader",
      "formatDayTitle",
      "formatMonth",
      "formatMonthTitle",
      "formatYear",
      "maxDate",
      "maxMode",
      "minDate",
      "minMode",
      "monthColumns",
      "showWeeks",
      "shortcutPropagation",
      "startingDay",
      "yearColumns",
      "yearRows"
    ].forEach(function(C) {
      switch (C) {
        case "customClass":
        case "dateDisabled":
          s[C] = s.datepickerOptions[C] || angular.noop;
          break;
        case "datepickerMode":
          s.datepickerMode = angular.isDefined(s.datepickerOptions.datepickerMode) ? s.datepickerOptions.datepickerMode : o.datepickerMode;
          break;
        case "formatDay":
        case "formatDayHeader":
        case "formatDayTitle":
        case "formatMonth":
        case "formatMonthTitle":
        case "formatYear":
          h[C] = angular.isDefined(s.datepickerOptions[C]) ? n(s.datepickerOptions[C])(s.$parent) : o[C];
          break;
        case "monthColumns":
        case "showWeeks":
        case "shortcutPropagation":
        case "yearColumns":
        case "yearRows":
          h[C] = angular.isDefined(s.datepickerOptions[C]) ? s.datepickerOptions[C] : o[C];
          break;
        case "startingDay":
          angular.isDefined(s.datepickerOptions.startingDay) ? h.startingDay = s.datepickerOptions.startingDay : angular.isNumber(o.startingDay) ? h.startingDay = o.startingDay : h.startingDay = (i.DATETIME_FORMATS.FIRSTDAYOFWEEK + 8) % 7;
          break;
        case "maxDate":
        case "minDate":
          s.$watch("datepickerOptions." + C, function(v) {
            v ? angular.isDate(v) ? h[C] = p.fromTimezone(new Date(v), x.getOption("timezone")) : (c && r.warn("Literal date support has been deprecated, please switch to date object usage"), h[C] = new Date(l(v, "medium"))) : h[C] = o[C] ? p.fromTimezone(new Date(o[C]), x.getOption("timezone")) : null, h.refreshView();
          });
          break;
        case "maxMode":
        case "minMode":
          s.datepickerOptions[C] ? s.$watch(function() {
            return s.datepickerOptions[C];
          }, function(v) {
            h[C] = s[C] = angular.isDefined(v) ? v : s.datepickerOptions[C], (C === "minMode" && h.modes.indexOf(s.datepickerOptions.datepickerMode) < h.modes.indexOf(h[C]) || C === "maxMode" && h.modes.indexOf(s.datepickerOptions.datepickerMode) > h.modes.indexOf(h[C])) && (s.datepickerMode = h[C], s.datepickerOptions.datepickerMode = h[C]);
          }) : h[C] = s[C] = o[C] || null;
          break;
      }
    }), s.uniqueId = "datepicker-" + s.$id + "-" + Math.floor(Math.random() * 1e4), s.disabled = angular.isDefined(e.disabled) || !1, angular.isDefined(e.ngDisabled) && b.push(s.$parent.$watch(e.ngDisabled, function(C) {
      s.disabled = C, h.refreshView();
    })), s.isActive = function(C) {
      return h.compare(C.date, h.activeDate) === 0 ? (s.activeDateId = C.uid, !0) : !1;
    }, this.init = function(C) {
      g = C, x = R(g), s.datepickerOptions.initDate ? (h.activeDate = p.fromTimezone(s.datepickerOptions.initDate, x.getOption("timezone")) || /* @__PURE__ */ new Date(), s.$watch("datepickerOptions.initDate", function(P) {
        P && (g.$isEmpty(g.$modelValue) || g.$invalid) && (h.activeDate = p.fromTimezone(P, x.getOption("timezone")), h.refreshView());
      })) : h.activeDate = /* @__PURE__ */ new Date();
      var v = g.$modelValue ? new Date(g.$modelValue) : /* @__PURE__ */ new Date();
      this.activeDate = isNaN(v) ? p.fromTimezone(/* @__PURE__ */ new Date(), x.getOption("timezone")) : p.fromTimezone(v, x.getOption("timezone")), g.$render = function() {
        h.render();
      };
    }, this.render = function() {
      if (g.$viewValue) {
        var C = new Date(g.$viewValue), v = !isNaN(C);
        v ? this.activeDate = p.fromTimezone(C, x.getOption("timezone")) : d || r.error('Datepicker directive: "ng-model" value must be a Date object');
      }
      this.refreshView();
    }, this.refreshView = function() {
      if (this.element) {
        s.selectedDt = null, this._refreshView(), s.activeDt && (s.activeDateId = s.activeDt.uid);
        var C = g.$viewValue ? new Date(g.$viewValue) : null;
        C = p.fromTimezone(C, x.getOption("timezone")), g.$setValidity("dateDisabled", !C || this.element && !this.isDisabled(C));
      }
    }, this.createDateObject = function(C, v) {
      var P = g.$viewValue ? new Date(g.$viewValue) : null;
      P = p.fromTimezone(P, x.getOption("timezone"));
      var O = /* @__PURE__ */ new Date();
      O = p.fromTimezone(O, x.getOption("timezone"));
      var N = this.compare(C, O), H = {
        date: C,
        label: p.filter(C, v),
        selected: P && this.compare(C, P) === 0,
        disabled: this.isDisabled(C),
        past: N < 0,
        current: N === 0,
        future: N > 0,
        customClass: this.customClass(C) || null
      };
      return P && this.compare(C, P) === 0 && (s.selectedDt = H), h.activeDate && this.compare(H.date, h.activeDate) === 0 && (s.activeDt = H), H;
    }, this.isDisabled = function(C) {
      return s.disabled || this.minDate && this.compare(C, this.minDate) < 0 || this.maxDate && this.compare(C, this.maxDate) > 0 || s.dateDisabled && s.dateDisabled({ date: C, mode: s.datepickerMode });
    }, this.customClass = function(C) {
      return s.customClass({ date: C, mode: s.datepickerMode });
    }, this.split = function(C, v) {
      for (var P = []; C.length > 0; )
        P.push(C.splice(0, v));
      return P;
    }, s.select = function(C) {
      if (s.datepickerMode === h.minMode) {
        var v = g.$viewValue ? p.fromTimezone(new Date(g.$viewValue), x.getOption("timezone")) : new Date(0, 0, 0, 0, 0, 0, 0);
        v.setFullYear(C.getFullYear(), C.getMonth(), C.getDate()), v = p.toTimezone(v, x.getOption("timezone")), g.$setViewValue(v), g.$render();
      } else
        h.activeDate = C, T(h.modes[h.modes.indexOf(s.datepickerMode) - 1]), s.$emit("uib:datepicker.mode");
      s.$broadcast("uib:datepicker.focus");
    }, s.move = function(C) {
      var v = h.activeDate.getFullYear() + C * (h.step.years || 0), P = h.activeDate.getMonth() + C * (h.step.months || 0);
      h.activeDate.setFullYear(v, P, 1), h.refreshView();
    }, s.toggleMode = function(C) {
      C = C || 1, !(s.datepickerMode === h.maxMode && C === 1 || s.datepickerMode === h.minMode && C === -1) && (T(h.modes[h.modes.indexOf(s.datepickerMode) + C]), s.$emit("uib:datepicker.mode"));
    }, s.keys = { 13: "enter", 32: "space", 33: "pageup", 34: "pagedown", 35: "end", 36: "home", 37: "left", 38: "up", 39: "right", 40: "down" };
    var A = function() {
      h.element[0].focus();
    };
    s.$on("uib:datepicker.focus", A), s.keydown = function(C) {
      var v = s.keys[C.which];
      if (!(!v || C.shiftKey || C.altKey || s.disabled))
        if (C.preventDefault(), h.shortcutPropagation || C.stopPropagation(), v === "enter" || v === "space") {
          if (h.isDisabled(h.activeDate))
            return;
          s.select(h.activeDate);
        } else
          C.ctrlKey && (v === "up" || v === "down") ? s.toggleMode(v === "up" ? 1 : -1) : (h.handleKeyDown(v, C), h.refreshView());
    }, t.on("keydown", function(C) {
      s.$apply(function() {
        s.keydown(C);
      });
    }), s.$on("$destroy", function() {
      for (; b.length; )
        b.shift()();
    });
    function T(C) {
      s.datepickerMode = C, s.datepickerOptions.datepickerMode = C;
    }
    function R(C) {
      var v;
      if (angular.version.minor < 6)
        v = C.$options || s.datepickerOptions.ngModelOptions || o.ngModelOptions || {}, v.getOption = function(O) {
          return v[O];
        };
      else {
        var P = C.$options.getOption("timezone") || (s.datepickerOptions.ngModelOptions ? s.datepickerOptions.ngModelOptions.timezone : null) || (o.ngModelOptions ? o.ngModelOptions.timezone : null);
        v = C.$options.createChild(o.ngModelOptions).createChild(s.datepickerOptions.ngModelOptions).createChild(C.$options).createChild({ timezone: P });
      }
      return v;
    }
  }
]).controller("UibDaypickerController", ["$scope", "$element", "dateFilter", function(s, t, e) {
  var a = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  this.step = { months: 1 }, this.element = t;
  function n(r, l) {
    return l === 1 && r % 4 === 0 && (r % 100 !== 0 || r % 400 === 0) ? 29 : a[l];
  }
  this.init = function(r) {
    angular.extend(r, this), s.showWeeks = r.showWeeks, r.refreshView();
  }, this.getDates = function(r, l) {
    for (var o = new Array(l), c = new Date(r), d = 0, p; d < l; )
      p = new Date(c), o[d++] = p, c.setDate(c.getDate() + 1);
    return o;
  }, this._refreshView = function() {
    var r = this.activeDate.getFullYear(), l = this.activeDate.getMonth(), o = new Date(this.activeDate);
    o.setFullYear(r, l, 1);
    var c = this.startingDay - o.getDay(), d = c > 0 ? 7 - c : -c, p = new Date(o);
    d > 0 && p.setDate(-d + 1);
    for (var h = this.getDates(p, 42), g = 0; g < 42; g++)
      h[g] = angular.extend(this.createDateObject(h[g], this.formatDay), {
        secondary: h[g].getMonth() !== l,
        uid: s.uniqueId + "-" + g
      });
    s.labels = new Array(7);
    for (var x = 0; x < 7; x++)
      s.labels[x] = {
        abbr: e(h[x].date, this.formatDayHeader),
        full: e(h[x].date, "EEEE")
      };
    if (s.title = e(this.activeDate, this.formatDayTitle), s.rows = this.split(h, 7), s.showWeeks) {
      s.weekNumbers = [];
      for (var b = (11 - this.startingDay) % 7, A = s.rows.length, T = 0; T < A; T++)
        s.weekNumbers.push(
          i(s.rows[T][b].date)
        );
    }
  }, this.compare = function(r, l) {
    var o = new Date(r.getFullYear(), r.getMonth(), r.getDate()), c = new Date(l.getFullYear(), l.getMonth(), l.getDate());
    return o.setFullYear(r.getFullYear()), c.setFullYear(l.getFullYear()), o - c;
  };
  function i(r) {
    var l = new Date(r);
    l.setDate(l.getDate() + 4 - (l.getDay() || 7));
    var o = l.getTime();
    return l.setMonth(0), l.setDate(1), Math.floor(Math.round((o - l) / 864e5) / 7) + 1;
  }
  this.handleKeyDown = function(r, l) {
    var o = this.activeDate.getDate();
    if (r === "left")
      o = o - 1;
    else if (r === "up")
      o = o - 7;
    else if (r === "right")
      o = o + 1;
    else if (r === "down")
      o = o + 7;
    else if (r === "pageup" || r === "pagedown") {
      var c = this.activeDate.getMonth() + (r === "pageup" ? -1 : 1);
      this.activeDate.setMonth(c, 1), o = Math.min(n(this.activeDate.getFullYear(), this.activeDate.getMonth()), o);
    } else
      r === "home" ? o = 1 : r === "end" && (o = n(this.activeDate.getFullYear(), this.activeDate.getMonth()));
    this.activeDate.setDate(o);
  };
}]).controller("UibMonthpickerController", ["$scope", "$element", "dateFilter", function(s, t, e) {
  this.step = { years: 1 }, this.element = t, this.init = function(a) {
    angular.extend(a, this), a.refreshView();
  }, this._refreshView = function() {
    for (var a = new Array(12), n = this.activeDate.getFullYear(), i, r = 0; r < 12; r++)
      i = new Date(this.activeDate), i.setFullYear(n, r, 1), a[r] = angular.extend(this.createDateObject(i, this.formatMonth), {
        uid: s.uniqueId + "-" + r
      });
    s.title = e(this.activeDate, this.formatMonthTitle), s.rows = this.split(a, this.monthColumns), s.yearHeaderColspan = this.monthColumns > 3 ? this.monthColumns - 2 : 1;
  }, this.compare = function(a, n) {
    var i = new Date(a.getFullYear(), a.getMonth()), r = new Date(n.getFullYear(), n.getMonth());
    return i.setFullYear(a.getFullYear()), r.setFullYear(n.getFullYear()), i - r;
  }, this.handleKeyDown = function(a, n) {
    var i = this.activeDate.getMonth();
    if (a === "left")
      i = i - 1;
    else if (a === "up")
      i = i - this.monthColumns;
    else if (a === "right")
      i = i + 1;
    else if (a === "down")
      i = i + this.monthColumns;
    else if (a === "pageup" || a === "pagedown") {
      var r = this.activeDate.getFullYear() + (a === "pageup" ? -1 : 1);
      this.activeDate.setFullYear(r);
    } else
      a === "home" ? i = 0 : a === "end" && (i = 11);
    this.activeDate.setMonth(i);
  };
}]).controller("UibYearpickerController", ["$scope", "$element", "dateFilter", function(s, t, e) {
  var a, n;
  this.element = t;
  function i(r) {
    return parseInt((r - 1) / n, 10) * n + 1;
  }
  this.yearpickerInit = function() {
    a = this.yearColumns, n = this.yearRows * a, this.step = { years: n };
  }, this._refreshView = function() {
    for (var r = new Array(n), l, o = 0, c = i(this.activeDate.getFullYear()); o < n; o++)
      l = new Date(this.activeDate), l.setFullYear(c + o, 0, 1), r[o] = angular.extend(this.createDateObject(l, this.formatYear), {
        uid: s.uniqueId + "-" + o
      });
    s.title = [r[0].label, r[n - 1].label].join(" - "), s.rows = this.split(r, a), s.columns = a;
  }, this.compare = function(r, l) {
    return r.getFullYear() - l.getFullYear();
  }, this.handleKeyDown = function(r, l) {
    var o = this.activeDate.getFullYear();
    r === "left" ? o = o - 1 : r === "up" ? o = o - a : r === "right" ? o = o + 1 : r === "down" ? o = o + a : r === "pageup" || r === "pagedown" ? o += (r === "pageup" ? -1 : 1) * n : r === "home" ? o = i(this.activeDate.getFullYear()) : r === "end" && (o = i(this.activeDate.getFullYear()) + n - 1), this.activeDate.setFullYear(o);
  };
}]).directive("uibDatepicker", function() {
  return {
    templateUrl: function(s, t) {
      return t.templateUrl || "uib/template/datepicker/datepicker.html";
    },
    scope: {
      datepickerOptions: "=?"
    },
    require: ["uibDatepicker", "^ngModel"],
    restrict: "A",
    controller: "UibDatepickerController",
    controllerAs: "datepicker",
    link: function(s, t, e, a) {
      var n = a[0], i = a[1];
      n.init(i);
    }
  };
}).directive("uibDaypicker", function() {
  return {
    templateUrl: function(s, t) {
      return t.templateUrl || "uib/template/datepicker/day.html";
    },
    require: ["^uibDatepicker", "uibDaypicker"],
    restrict: "A",
    controller: "UibDaypickerController",
    link: function(s, t, e, a) {
      var n = a[0], i = a[1];
      i.init(n);
    }
  };
}).directive("uibMonthpicker", function() {
  return {
    templateUrl: function(s, t) {
      return t.templateUrl || "uib/template/datepicker/month.html";
    },
    require: ["^uibDatepicker", "uibMonthpicker"],
    restrict: "A",
    controller: "UibMonthpickerController",
    link: function(s, t, e, a) {
      var n = a[0], i = a[1];
      i.init(n);
    }
  };
}).directive("uibYearpicker", function() {
  return {
    templateUrl: function(s, t) {
      return t.templateUrl || "uib/template/datepicker/year.html";
    },
    require: ["^uibDatepicker", "uibYearpicker"],
    restrict: "A",
    controller: "UibYearpickerController",
    link: function(s, t, e, a) {
      var n = a[0];
      angular.extend(n, a[1]), n.yearpickerInit(), n.refreshView();
    }
  };
});
angular.module("ui.bootstrap.position", []).factory("$uibPosition", ["$document", "$window", function(s, t) {
  var e, a, n = {
    normal: /(auto|scroll)/,
    hidden: /(auto|scroll|hidden)/
  }, i = {
    auto: /\s?auto?\s?/i,
    primary: /^(top|bottom|left|right)$/,
    secondary: /^(top|bottom|left|right|center)$/,
    vertical: /^(top|bottom)$/
  }, r = /(HTML|BODY)/;
  return {
    /**
     * Provides a raw DOM element from a jQuery/jQLite element.
     *
     * @param {element} elem - The element to convert.
     *
     * @returns {element} A HTML element.
     */
    getRawNode: function(l) {
      return l.nodeName ? l : l[0] || l;
    },
    /**
     * Provides a parsed number for a style property.  Strips
     * units and casts invalid numbers to 0.
     *
     * @param {string} value - The style value to parse.
     *
     * @returns {number} A valid number.
     */
    parseStyle: function(l) {
      return l = parseFloat(l), isFinite(l) ? l : 0;
    },
    /**
     * Provides the closest positioned ancestor.
     *
     * @param {element} element - The element to get the offest parent for.
     *
     * @returns {element} The closest positioned ancestor.
     */
    offsetParent: function(l) {
      l = this.getRawNode(l);
      var o = l.offsetParent || s[0].documentElement;
      function c(d) {
        return (t.getComputedStyle(d).position || "static") === "static";
      }
      for (; o && o !== s[0].documentElement && c(o); )
        o = o.offsetParent;
      return o || s[0].documentElement;
    },
    /**
     * Provides the scrollbar width, concept from TWBS measureScrollbar()
     * function in https://github.com/twbs/bootstrap/blob/master/js/modal.js
     * In IE and Edge, scollbar on body and html element overlay and should
     * return a width of 0.
     *
     * @returns {number} The width of the browser scollbar.
     */
    scrollbarWidth: function(l) {
      if (l) {
        if (angular.isUndefined(a)) {
          var o = s.find("body");
          o.addClass("uib-position-body-scrollbar-measure"), a = t.innerWidth - o[0].clientWidth, a = isFinite(a) ? a : 0, o.removeClass("uib-position-body-scrollbar-measure");
        }
        return a;
      }
      if (angular.isUndefined(e)) {
        var c = angular.element('<div class="uib-position-scrollbar-measure"></div>');
        s.find("body").append(c), e = c[0].offsetWidth - c[0].clientWidth, e = isFinite(e) ? e : 0, c.remove();
      }
      return e;
    },
    /**
     * Provides the padding required on an element to replace the scrollbar.
     *
     * @returns {object} An object with the following properties:
     *   <ul>
     *     <li>**scrollbarWidth**: the width of the scrollbar</li>
     *     <li>**widthOverflow**: whether the the width is overflowing</li>
     *     <li>**right**: the amount of right padding on the element needed to replace the scrollbar</li>
     *     <li>**rightOriginal**: the amount of right padding currently on the element</li>
     *     <li>**heightOverflow**: whether the the height is overflowing</li>
     *     <li>**bottom**: the amount of bottom padding on the element needed to replace the scrollbar</li>
     *     <li>**bottomOriginal**: the amount of bottom padding currently on the element</li>
     *   </ul>
     */
    scrollbarPadding: function(l) {
      l = this.getRawNode(l);
      var o = t.getComputedStyle(l), c = this.parseStyle(o.paddingRight), d = this.parseStyle(o.paddingBottom), p = this.scrollParent(l, !1, !0), h = this.scrollbarWidth(r.test(p.tagName));
      return {
        scrollbarWidth: h,
        widthOverflow: p.scrollWidth > p.clientWidth,
        right: c + h,
        originalRight: c,
        heightOverflow: p.scrollHeight > p.clientHeight,
        bottom: d + h,
        originalBottom: d
      };
    },
    /**
     * Checks to see if the element is scrollable.
     *
     * @param {element} elem - The element to check.
     * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
     *   default is false.
     *
     * @returns {boolean} Whether the element is scrollable.
     */
    isScrollable: function(l, o) {
      l = this.getRawNode(l);
      var c = o ? n.hidden : n.normal, d = t.getComputedStyle(l);
      return c.test(d.overflow + d.overflowY + d.overflowX);
    },
    /**
     * Provides the closest scrollable ancestor.
     * A port of the jQuery UI scrollParent method:
     * https://github.com/jquery/jquery-ui/blob/master/ui/scroll-parent.js
     *
     * @param {element} elem - The element to find the scroll parent of.
     * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
     *   default is false.
     * @param {boolean=} [includeSelf=false] - Should the element being passed be
     * included in the scrollable llokup.
     *
     * @returns {element} A HTML element.
     */
    scrollParent: function(l, o, c) {
      l = this.getRawNode(l);
      var d = o ? n.hidden : n.normal, p = s[0].documentElement, h = t.getComputedStyle(l);
      if (c && d.test(h.overflow + h.overflowY + h.overflowX))
        return l;
      var g = h.position === "absolute", x = l.parentElement || p;
      if (x === p || h.position === "fixed")
        return p;
      for (; x.parentElement && x !== p; ) {
        var b = t.getComputedStyle(x);
        if (g && b.position !== "static" && (g = !1), !g && d.test(b.overflow + b.overflowY + b.overflowX))
          break;
        x = x.parentElement;
      }
      return x;
    },
    /**
     * Provides read-only equivalent of jQuery's position function:
     * http://api.jquery.com/position/ - distance to closest positioned
     * ancestor.  Does not account for margins by default like jQuery position.
     *
     * @param {element} elem - The element to caclulate the position on.
     * @param {boolean=} [includeMargins=false] - Should margins be accounted
     * for, default is false.
     *
     * @returns {object} An object with the following properties:
     *   <ul>
     *     <li>**width**: the width of the element</li>
     *     <li>**height**: the height of the element</li>
     *     <li>**top**: distance to top edge of offset parent</li>
     *     <li>**left**: distance to left edge of offset parent</li>
     *   </ul>
     */
    position: function(l, o) {
      l = this.getRawNode(l);
      var c = this.offset(l);
      if (o) {
        var d = t.getComputedStyle(l);
        c.top -= this.parseStyle(d.marginTop), c.left -= this.parseStyle(d.marginLeft);
      }
      var p = this.offsetParent(l), h = { top: 0, left: 0 };
      return p !== s[0].documentElement && (h = this.offset(p), h.top += p.clientTop - p.scrollTop, h.left += p.clientLeft - p.scrollLeft), {
        width: Math.round(angular.isNumber(c.width) ? c.width : l.offsetWidth),
        height: Math.round(angular.isNumber(c.height) ? c.height : l.offsetHeight),
        top: Math.round(c.top - h.top),
        left: Math.round(c.left - h.left)
      };
    },
    /**
     * Provides read-only equivalent of jQuery's offset function:
     * http://api.jquery.com/offset/ - distance to viewport.  Does
     * not account for borders, margins, or padding on the body
     * element.
     *
     * @param {element} elem - The element to calculate the offset on.
     *
     * @returns {object} An object with the following properties:
     *   <ul>
     *     <li>**width**: the width of the element</li>
     *     <li>**height**: the height of the element</li>
     *     <li>**top**: distance to top edge of viewport</li>
     *     <li>**right**: distance to bottom edge of viewport</li>
     *   </ul>
     */
    offset: function(l) {
      l = this.getRawNode(l);
      var o = l.getBoundingClientRect();
      return {
        width: Math.round(angular.isNumber(o.width) ? o.width : l.offsetWidth),
        height: Math.round(angular.isNumber(o.height) ? o.height : l.offsetHeight),
        top: Math.round(o.top + (t.pageYOffset || s[0].documentElement.scrollTop)),
        left: Math.round(o.left + (t.pageXOffset || s[0].documentElement.scrollLeft))
      };
    },
    /**
     * Provides offset distance to the closest scrollable ancestor
     * or viewport.  Accounts for border and scrollbar width.
     *
     * Right and bottom dimensions represent the distance to the
     * respective edge of the viewport element.  If the element
     * edge extends beyond the viewport, a negative value will be
     * reported.
     *
     * @param {element} elem - The element to get the viewport offset for.
     * @param {boolean=} [useDocument=false] - Should the viewport be the document element instead
     * of the first scrollable element, default is false.
     * @param {boolean=} [includePadding=true] - Should the padding on the offset parent element
     * be accounted for, default is true.
     *
     * @returns {object} An object with the following properties:
     *   <ul>
     *     <li>**top**: distance to the top content edge of viewport element</li>
     *     <li>**bottom**: distance to the bottom content edge of viewport element</li>
     *     <li>**left**: distance to the left content edge of viewport element</li>
     *     <li>**right**: distance to the right content edge of viewport element</li>
     *   </ul>
     */
    viewportOffset: function(l, o, c) {
      l = this.getRawNode(l), c = c !== !1;
      var d = l.getBoundingClientRect(), p = { top: 0, left: 0, bottom: 0, right: 0 }, h = o ? s[0].documentElement : this.scrollParent(l), g = h.getBoundingClientRect();
      if (p.top = g.top + h.clientTop, p.left = g.left + h.clientLeft, h === s[0].documentElement && (p.top += t.pageYOffset, p.left += t.pageXOffset), p.bottom = p.top + h.clientHeight, p.right = p.left + h.clientWidth, c) {
        var x = t.getComputedStyle(h);
        p.top += this.parseStyle(x.paddingTop), p.bottom -= this.parseStyle(x.paddingBottom), p.left += this.parseStyle(x.paddingLeft), p.right -= this.parseStyle(x.paddingRight);
      }
      return {
        top: Math.round(d.top - p.top),
        bottom: Math.round(p.bottom - d.bottom),
        left: Math.round(d.left - p.left),
        right: Math.round(p.right - d.right)
      };
    },
    /**
     * Provides an array of placement values parsed from a placement string.
     * Along with the 'auto' indicator, supported placement strings are:
     *   <ul>
     *     <li>top: element on top, horizontally centered on host element.</li>
     *     <li>top-left: element on top, left edge aligned with host element left edge.</li>
     *     <li>top-right: element on top, lerightft edge aligned with host element right edge.</li>
     *     <li>bottom: element on bottom, horizontally centered on host element.</li>
     *     <li>bottom-left: element on bottom, left edge aligned with host element left edge.</li>
     *     <li>bottom-right: element on bottom, right edge aligned with host element right edge.</li>
     *     <li>left: element on left, vertically centered on host element.</li>
     *     <li>left-top: element on left, top edge aligned with host element top edge.</li>
     *     <li>left-bottom: element on left, bottom edge aligned with host element bottom edge.</li>
     *     <li>right: element on right, vertically centered on host element.</li>
     *     <li>right-top: element on right, top edge aligned with host element top edge.</li>
     *     <li>right-bottom: element on right, bottom edge aligned with host element bottom edge.</li>
     *   </ul>
     * A placement string with an 'auto' indicator is expected to be
     * space separated from the placement, i.e: 'auto bottom-left'  If
     * the primary and secondary placement values do not match 'top,
     * bottom, left, right' then 'top' will be the primary placement and
     * 'center' will be the secondary placement.  If 'auto' is passed, true
     * will be returned as the 3rd value of the array.
     *
     * @param {string} placement - The placement string to parse.
     *
     * @returns {array} An array with the following values
     * <ul>
     *   <li>**[0]**: The primary placement.</li>
     *   <li>**[1]**: The secondary placement.</li>
     *   <li>**[2]**: If auto is passed: true, else undefined.</li>
     * </ul>
     */
    parsePlacement: function(l) {
      var o = i.auto.test(l);
      return o && (l = l.replace(i.auto, "")), l = l.split("-"), l[0] = l[0] || "top", i.primary.test(l[0]) || (l[0] = "top"), l[1] = l[1] || "center", i.secondary.test(l[1]) || (l[1] = "center"), o ? l[2] = !0 : l[2] = !1, l;
    },
    /**
     * Provides coordinates for an element to be positioned relative to
     * another element.  Passing 'auto' as part of the placement parameter
     * will enable smart placement - where the element fits. i.e:
     * 'auto left-top' will check to see if there is enough space to the left
     * of the hostElem to fit the targetElem, if not place right (same for secondary
     * top placement).  Available space is calculated using the viewportOffset
     * function.
     *
     * @param {element} hostElem - The element to position against.
     * @param {element} targetElem - The element to position.
     * @param {string=} [placement=top] - The placement for the targetElem,
     *   default is 'top'. 'center' is assumed as secondary placement for
     *   'top', 'left', 'right', and 'bottom' placements.  Available placements are:
     *   <ul>
     *     <li>top</li>
     *     <li>top-right</li>
     *     <li>top-left</li>
     *     <li>bottom</li>
     *     <li>bottom-left</li>
     *     <li>bottom-right</li>
     *     <li>left</li>
     *     <li>left-top</li>
     *     <li>left-bottom</li>
     *     <li>right</li>
     *     <li>right-top</li>
     *     <li>right-bottom</li>
     *   </ul>
     * @param {boolean=} [appendToBody=false] - Should the top and left values returned
     *   be calculated from the body element, default is false.
     *
     * @returns {object} An object with the following properties:
     *   <ul>
     *     <li>**top**: Value for targetElem top.</li>
     *     <li>**left**: Value for targetElem left.</li>
     *     <li>**placement**: The resolved placement.</li>
     *   </ul>
     */
    positionElements: function(l, o, c, d) {
      l = this.getRawNode(l), o = this.getRawNode(o);
      var p = angular.isDefined(o.offsetWidth) ? o.offsetWidth : o.prop("offsetWidth"), h = angular.isDefined(o.offsetHeight) ? o.offsetHeight : o.prop("offsetHeight");
      c = this.parsePlacement(c);
      var g = d ? this.offset(l) : this.position(l), x = { top: 0, left: 0, placement: "" };
      if (c[2]) {
        var b = this.viewportOffset(l, d), A = t.getComputedStyle(o), T = {
          width: p + Math.round(Math.abs(this.parseStyle(A.marginLeft) + this.parseStyle(A.marginRight))),
          height: h + Math.round(Math.abs(this.parseStyle(A.marginTop) + this.parseStyle(A.marginBottom)))
        };
        if (c[0] = c[0] === "top" && T.height > b.top && T.height <= b.bottom ? "bottom" : c[0] === "bottom" && T.height > b.bottom && T.height <= b.top ? "top" : c[0] === "left" && T.width > b.left && T.width <= b.right ? "right" : c[0] === "right" && T.width > b.right && T.width <= b.left ? "left" : c[0], c[1] = c[1] === "top" && T.height - g.height > b.bottom && T.height - g.height <= b.top ? "bottom" : c[1] === "bottom" && T.height - g.height > b.top && T.height - g.height <= b.bottom ? "top" : c[1] === "left" && T.width - g.width > b.right && T.width - g.width <= b.left ? "right" : c[1] === "right" && T.width - g.width > b.left && T.width - g.width <= b.right ? "left" : c[1], c[1] === "center")
          if (i.vertical.test(c[0])) {
            var R = g.width / 2 - p / 2;
            b.left + R < 0 && T.width - g.width <= b.right ? c[1] = "left" : b.right + R < 0 && T.width - g.width <= b.left && (c[1] = "right");
          } else {
            var C = g.height / 2 - T.height / 2;
            b.top + C < 0 && T.height - g.height <= b.bottom ? c[1] = "top" : b.bottom + C < 0 && T.height - g.height <= b.top && (c[1] = "bottom");
          }
      }
      switch (c[0]) {
        case "top":
          x.top = g.top - h;
          break;
        case "bottom":
          x.top = g.top + g.height;
          break;
        case "left":
          x.left = g.left - p;
          break;
        case "right":
          x.left = g.left + g.width;
          break;
      }
      switch (c[1]) {
        case "top":
          x.top = g.top;
          break;
        case "bottom":
          x.top = g.top + g.height - h;
          break;
        case "left":
          x.left = g.left;
          break;
        case "right":
          x.left = g.left + g.width - p;
          break;
        case "center":
          i.vertical.test(c[0]) ? x.left = g.left + g.width / 2 - p / 2 : x.top = g.top + g.height / 2 - h / 2;
          break;
      }
      return x.top = Math.round(x.top), x.left = Math.round(x.left), x.placement = c[1] === "center" ? c[0] : c[0] + "-" + c[1], x;
    },
    /**
     * Provides a way to adjust the top positioning after first
     * render to correctly align element to top after content
     * rendering causes resized element height
     *
     * @param {array} placementClasses - The array of strings of classes
     * element should have.
     * @param {object} containerPosition - The object with container
     * position information
     * @param {number} initialHeight - The initial height for the elem.
     * @param {number} currentHeight - The current height for the elem.
     */
    adjustTop: function(l, o, c, d) {
      if (l.indexOf("top") !== -1 && c !== d)
        return {
          top: o.top - d + "px"
        };
    },
    /**
     * Provides a way for positioning tooltip & dropdown
     * arrows when using placement options beyond the standard
     * left, right, top, or bottom.
     *
     * @param {element} elem - The tooltip/dropdown element.
     * @param {string} placement - The placement for the elem.
     */
    positionArrow: function(l, o) {
      l = this.getRawNode(l);
      var c = l.querySelector(".tooltip-inner, .popover-inner");
      if (c) {
        var d = angular.element(c).hasClass("tooltip-inner"), p = d ? l.querySelector(".tooltip-arrow") : l.querySelector(".arrow");
        if (p) {
          var h = {
            top: "",
            bottom: "",
            left: "",
            right: ""
          };
          if (o = this.parsePlacement(o), o[1] === "center") {
            angular.element(p).css(h);
            return;
          }
          var g = "border-" + o[0] + "-width", x = t.getComputedStyle(p)[g], b = "border-";
          i.vertical.test(o[0]) ? b += o[0] + "-" + o[1] : b += o[1] + "-" + o[0], b += "-radius";
          var A = t.getComputedStyle(d ? c : l)[b];
          switch (o[0]) {
            case "top":
              h.bottom = d ? "0" : "-" + x;
              break;
            case "bottom":
              h.top = d ? "0" : "-" + x;
              break;
            case "left":
              h.right = d ? "0" : "-" + x;
              break;
            case "right":
              h.left = d ? "0" : "-" + x;
              break;
          }
          h[o[1]] = A, angular.element(p).css(h);
        }
      }
    }
  };
}]);
angular.module("ui.bootstrap.datepickerPopup", ["ui.bootstrap.datepicker", "ui.bootstrap.position"]).value("$datepickerPopupLiteralWarning", !0).constant("uibDatepickerPopupConfig", {
  altInputFormats: [],
  appendToBody: !1,
  clearText: "Clear",
  closeOnDateSelection: !0,
  closeText: "Done",
  currentText: "Today",
  datepickerPopup: "yyyy-MM-dd",
  datepickerPopupTemplateUrl: "uib/template/datepickerPopup/popup.html",
  datepickerTemplateUrl: "uib/template/datepicker/datepicker.html",
  html5Types: {
    date: "yyyy-MM-dd",
    "datetime-local": "yyyy-MM-ddTHH:mm:ss.sss",
    month: "yyyy-MM"
  },
  onOpenFocus: !0,
  showButtonBar: !0,
  placement: "auto bottom-left"
}).controller("UibDatepickerPopupController", [
  "$scope",
  "$element",
  "$attrs",
  "$compile",
  "$log",
  "$parse",
  "$window",
  "$document",
  "$rootScope",
  "$uibPosition",
  "dateFilter",
  "uibDateParser",
  "uibDatepickerPopupConfig",
  "$timeout",
  "uibDatepickerConfig",
  "$datepickerPopupLiteralWarning",
  function(s, t, e, a, n, i, r, l, o, c, d, p, h, g, x, b) {
    var A = !1, T, R, C, v, P, O, N, H, F, B, Q, it, et, rt = [];
    this.init = function(j) {
      if (B = j, Q = zt(B), R = angular.isDefined(e.closeOnDateSelection) ? s.$parent.$eval(e.closeOnDateSelection) : h.closeOnDateSelection, C = angular.isDefined(e.datepickerAppendToBody) ? s.$parent.$eval(e.datepickerAppendToBody) : h.appendToBody, v = angular.isDefined(e.onOpenFocus) ? s.$parent.$eval(e.onOpenFocus) : h.onOpenFocus, P = angular.isDefined(e.datepickerPopupTemplateUrl) ? e.datepickerPopupTemplateUrl : h.datepickerPopupTemplateUrl, O = angular.isDefined(e.datepickerTemplateUrl) ? e.datepickerTemplateUrl : h.datepickerTemplateUrl, et = angular.isDefined(e.altInputFormats) ? s.$parent.$eval(e.altInputFormats) : h.altInputFormats, s.showButtonBar = angular.isDefined(e.showButtonBar) ? s.$parent.$eval(e.showButtonBar) : h.showButtonBar, h.html5Types[e.type] ? (T = h.html5Types[e.type], A = !0) : (T = e.uibDatepickerPopup || h.datepickerPopup, e.$observe("uibDatepickerPopup", function(tt, lt) {
        var at = tt || h.datepickerPopup;
        if (at !== T && (T = at, B.$modelValue = null, !T))
          throw new Error("uibDatepickerPopup must have a date format specified.");
      })), !T)
        throw new Error("uibDatepickerPopup must have a date format specified.");
      if (A && e.uibDatepickerPopup)
        throw new Error("HTML5 date input types do not support custom formats.");
      N = angular.element("<div uib-datepicker-popup-wrap><div uib-datepicker></div></div>"), N.attr({
        "ng-model": "date",
        "ng-change": "dateSelection(date)",
        "template-url": P
      }), H = angular.element(N.children()[0]), H.attr("template-url", O), s.datepickerOptions || (s.datepickerOptions = {}), A && e.type === "month" && (s.datepickerOptions.datepickerMode = "month", s.datepickerOptions.minMode = "month"), H.attr("datepicker-options", "datepickerOptions"), A ? B.$formatters.push(function(tt) {
        return s.date = p.fromTimezone(tt, Q.getOption("timezone")), tt;
      }) : (B.$$parserName = "date", B.$validators.date = W, B.$parsers.unshift(M), B.$formatters.push(function(tt) {
        return B.$isEmpty(tt) ? (s.date = tt, tt) : (angular.isNumber(tt) && (tt = new Date(tt)), s.date = p.fromTimezone(tt, Q.getOption("timezone")), p.filter(s.date, T));
      })), B.$viewChangeListeners.push(function() {
        s.date = U(B.$viewValue);
      }), t.on("keydown", vt), it = a(N)(s), N.remove(), C ? l.find("body").append(it) : t.after(it), s.$on("$destroy", function() {
        for (s.isOpen === !0 && (o.$$phase || s.$apply(function() {
          s.isOpen = !1;
        })), it.remove(), t.off("keydown", vt), l.off("click", J), F && F.off("scroll", St), angular.element(r).off("resize", St); rt.length; )
          rt.shift()();
      });
    }, s.getText = function(j) {
      return s[j + "Text"] || h[j + "Text"];
    }, s.isDisabled = function(j) {
      j === "today" && (j = p.fromTimezone(/* @__PURE__ */ new Date(), Q.getOption("timezone")));
      var tt = {};
      return angular.forEach(["minDate", "maxDate"], function(lt) {
        s.datepickerOptions[lt] ? angular.isDate(s.datepickerOptions[lt]) ? tt[lt] = new Date(s.datepickerOptions[lt]) : (b && n.warn("Literal date support has been deprecated, please switch to date object usage"), tt[lt] = new Date(d(s.datepickerOptions[lt], "medium"))) : tt[lt] = null;
      }), s.datepickerOptions && tt.minDate && s.compare(j, tt.minDate) < 0 || tt.maxDate && s.compare(j, tt.maxDate) > 0;
    }, s.compare = function(j, tt) {
      return new Date(j.getFullYear(), j.getMonth(), j.getDate()) - new Date(tt.getFullYear(), tt.getMonth(), tt.getDate());
    }, s.dateSelection = function(j) {
      s.date = j;
      var tt = s.date ? p.filter(s.date, T) : null;
      t.val(tt), B.$setViewValue(tt), R && (s.isOpen = !1, t[0].focus());
    }, s.keydown = function(j) {
      j.which === 27 && (j.stopPropagation(), s.isOpen = !1, t[0].focus());
    }, s.select = function(j, tt) {
      if (tt.stopPropagation(), j === "today") {
        var lt = /* @__PURE__ */ new Date();
        angular.isDate(s.date) ? (j = new Date(s.date), j.setFullYear(lt.getFullYear(), lt.getMonth(), lt.getDate())) : (j = p.fromTimezone(lt, Q.getOption("timezone")), j.setHours(0, 0, 0, 0));
      }
      s.dateSelection(j);
    }, s.close = function(j) {
      j.stopPropagation(), s.isOpen = !1, t[0].focus();
    }, s.disabled = angular.isDefined(e.disabled) || !1, e.ngDisabled && rt.push(s.$parent.$watch(i(e.ngDisabled), function(j) {
      s.disabled = j;
    })), s.$watch("isOpen", function(j) {
      j ? s.disabled ? s.isOpen = !1 : g(function() {
        St(), v && s.$broadcast("uib:datepicker.focus"), l.on("click", J);
        var tt = e.popupPlacement ? e.popupPlacement : h.placement;
        C || c.parsePlacement(tt)[2] ? (F = F || angular.element(c.scrollParent(t)), F && F.on("scroll", St)) : F = null, angular.element(r).on("resize", St);
      }, 0, !1) : (l.off("click", J), F && F.off("scroll", St), angular.element(r).off("resize", St));
    });
    function U(j) {
      var tt = p.parse(j, T, s.date);
      if (isNaN(tt)) {
        for (var lt = 0; lt < et.length; lt++)
          if (tt = p.parse(j, et[lt], s.date), !isNaN(tt))
            return tt;
      }
      return tt;
    }
    function M(j) {
      if (angular.isNumber(j) && (j = new Date(j)), !j)
        return null;
      if (angular.isDate(j) && !isNaN(j))
        return j;
      if (angular.isString(j)) {
        var tt = U(j);
        if (!isNaN(tt))
          return p.toTimezone(tt, Q.getOption("timezone"));
      }
      return Q.getOption("allowInvalid") ? j : void 0;
    }
    function W(j, tt) {
      var lt = j || tt;
      return !e.ngRequired && !lt || (angular.isNumber(lt) && (lt = new Date(lt)), !lt) || angular.isDate(lt) && !isNaN(lt) ? !0 : angular.isString(lt) ? !isNaN(U(lt)) : !1;
    }
    function J(j) {
      if (!(!s.isOpen && s.disabled)) {
        var tt = it[0], lt = t[0].contains(j.target), at = tt.contains !== void 0 && tt.contains(j.target);
        s.isOpen && !(lt || at) && s.$apply(function() {
          s.isOpen = !1;
        });
      }
    }
    function vt(j) {
      j.which === 27 && s.isOpen ? (j.preventDefault(), j.stopPropagation(), s.$apply(function() {
        s.isOpen = !1;
      }), t[0].focus()) : j.which === 40 && !s.isOpen && (j.preventDefault(), j.stopPropagation(), s.$apply(function() {
        s.isOpen = !0;
      }));
    }
    function St() {
      if (s.isOpen) {
        var j = angular.element(it[0].querySelector(".uib-datepicker-popup")), tt = e.popupPlacement ? e.popupPlacement : h.placement, lt = c.positionElements(t, j, tt, C);
        j.css({ top: lt.top + "px", left: lt.left + "px" }), j.hasClass("uib-position-measure") && j.removeClass("uib-position-measure");
      }
    }
    function zt(j) {
      var tt;
      return angular.version.minor < 6 ? (tt = angular.isObject(j.$options) ? j.$options : {
        timezone: null
      }, tt.getOption = function(lt) {
        return tt[lt];
      }) : tt = j.$options, tt;
    }
    s.$on("uib:datepicker.mode", function() {
      g(St, 0, !1);
    });
  }
]).directive("uibDatepickerPopup", function() {
  return {
    require: ["ngModel", "uibDatepickerPopup"],
    controller: "UibDatepickerPopupController",
    scope: {
      datepickerOptions: "=?",
      isOpen: "=?",
      currentText: "@",
      clearText: "@",
      closeText: "@"
    },
    link: function(s, t, e, a) {
      var n = a[0], i = a[1];
      i.init(n);
    }
  };
}).directive("uibDatepickerPopupWrap", function() {
  return {
    restrict: "A",
    transclude: !0,
    templateUrl: function(s, t) {
      return t.templateUrl || "uib/template/datepickerPopup/popup.html";
    }
  };
});
angular.module("ui.bootstrap.debounce", []).factory("$$debounce", ["$timeout", function(s) {
  return function(t, e) {
    var a;
    return function() {
      var n = this, i = Array.prototype.slice.call(arguments);
      a && s.cancel(a), a = s(function() {
        t.apply(n, i);
      }, e);
    };
  };
}]);
angular.module("ui.bootstrap.multiMap", []).factory("$$multiMap", function() {
  return {
    createNew: function() {
      var s = {};
      return {
        entries: function() {
          return Object.keys(s).map(function(t) {
            return {
              key: t,
              value: s[t]
            };
          });
        },
        get: function(t) {
          return s[t];
        },
        hasKey: function(t) {
          return !!s[t];
        },
        keys: function() {
          return Object.keys(s);
        },
        put: function(t, e) {
          s[t] || (s[t] = []), s[t].push(e);
        },
        remove: function(t, e) {
          var a = s[t];
          if (a) {
            var n = a.indexOf(e);
            n !== -1 && a.splice(n, 1), a.length || delete s[t];
          }
        }
      };
    }
  };
});
angular.module("ui.bootstrap.dropdown", ["ui.bootstrap.multiMap", "ui.bootstrap.position"]).constant("uibDropdownConfig", {
  appendToOpenClass: "uib-dropdown-open",
  openClass: "open"
}).service("uibDropdownService", ["$document", "$rootScope", "$$multiMap", function(s, t, e) {
  var a = null, n = e.createNew();
  this.isOnlyOpen = function(r, l) {
    var o = n.get(l);
    if (o) {
      var c = o.reduce(function(d, p) {
        return p.scope === r ? p : d;
      }, {});
      if (c)
        return o.length === 1;
    }
    return !1;
  }, this.open = function(r, l, o) {
    if (a || s.on("click", i), a && a !== r && (a.isOpen = !1), a = r, !!o) {
      var c = n.get(o);
      if (c) {
        var d = c.map(function(p) {
          return p.scope;
        });
        d.indexOf(r) === -1 && n.put(o, {
          scope: r
        });
      } else
        n.put(o, {
          scope: r
        });
    }
  }, this.close = function(r, l, o) {
    if (a === r && (s.off("click", i), s.off("keydown", this.keybindFilter), a = null), !!o) {
      var c = n.get(o);
      if (c) {
        var d = c.reduce(function(p, h) {
          return h.scope === r ? h : p;
        }, {});
        d && n.remove(o, d);
      }
    }
  };
  var i = function(r) {
    if (!(!a || !a.isOpen) && !(r && a.getAutoClose() === "disabled") && !(r && r.which === 3)) {
      var l = a.getToggleElement();
      if (!(r && l && l[0].contains(r.target))) {
        var o = a.getDropdownElement();
        r && a.getAutoClose() === "outsideClick" && o && o[0].contains(r.target) || (a.focusToggleElement(), a.isOpen = !1, t.$$phase || a.$apply());
      }
    }
  };
  this.keybindFilter = function(r) {
    if (a) {
      var l = a.getDropdownElement(), o = a.getToggleElement(), c = l && l[0].contains(r.target), d = o && o[0].contains(r.target);
      r.which === 27 ? (r.stopPropagation(), a.focusToggleElement(), i()) : a.isKeynavEnabled() && [38, 40].indexOf(r.which) !== -1 && a.isOpen && (c || d) && (r.preventDefault(), r.stopPropagation(), a.focusDropdownEntry(r.which));
    }
  };
}]).controller("UibDropdownController", ["$scope", "$element", "$attrs", "$parse", "uibDropdownConfig", "uibDropdownService", "$animate", "$uibPosition", "$document", "$compile", "$templateRequest", function(s, t, e, a, n, i, r, l, o, c, d) {
  var p = this, h = s.$new(), g, x = n.appendToOpenClass, b = n.openClass, A, T = angular.noop, R = e.onToggle ? a(e.onToggle) : angular.noop, C = !1, v = o.find("body");
  t.addClass("dropdown"), this.init = function() {
    e.isOpen && (A = a(e.isOpen), T = A.assign, s.$watch(A, function(O) {
      h.isOpen = !!O;
    })), C = angular.isDefined(e.keyboardNav);
  }, this.toggle = function(O) {
    return h.isOpen = arguments.length ? !!O : !h.isOpen, angular.isFunction(T) && T(h, h.isOpen), h.isOpen;
  }, this.isOpen = function() {
    return h.isOpen;
  }, h.getToggleElement = function() {
    return p.toggleElement;
  }, h.getAutoClose = function() {
    return e.autoClose || "always";
  }, h.getElement = function() {
    return t;
  }, h.isKeynavEnabled = function() {
    return C;
  }, h.focusDropdownEntry = function(O) {
    var N = p.dropdownMenu ? (
      //If append to body is used.
      angular.element(p.dropdownMenu).find("a")
    ) : t.find("ul").eq(0).find("a");
    switch (O) {
      case 40: {
        angular.isNumber(p.selectedOption) ? p.selectedOption = p.selectedOption === N.length - 1 ? p.selectedOption : p.selectedOption + 1 : p.selectedOption = 0;
        break;
      }
      case 38: {
        angular.isNumber(p.selectedOption) ? p.selectedOption = p.selectedOption === 0 ? 0 : p.selectedOption - 1 : p.selectedOption = N.length - 1;
        break;
      }
    }
    N[p.selectedOption].focus();
  }, h.getDropdownElement = function() {
    return p.dropdownMenu;
  }, h.focusToggleElement = function() {
    p.toggleElement && p.toggleElement[0].focus();
  };
  function P() {
    t.append(p.dropdownMenu);
  }
  h.$watch("isOpen", function(O, N) {
    var H = null, F = !1;
    if (angular.isDefined(e.dropdownAppendTo)) {
      var B = a(e.dropdownAppendTo)(h);
      B && (H = angular.element(B));
    }
    if (angular.isDefined(e.dropdownAppendToBody)) {
      var Q = a(e.dropdownAppendToBody)(h);
      Q !== !1 && (F = !0);
    }
    if (F && !H && (H = v), H && p.dropdownMenu && (O ? (H.append(p.dropdownMenu), t.on("$destroy", P)) : (t.off("$destroy", P), P())), H && p.dropdownMenu) {
      var it = l.positionElements(t, p.dropdownMenu, "bottom-left", !0), et, rt, U, M = 0;
      if (et = {
        top: it.top + "px",
        display: O ? "block" : "none"
      }, rt = p.dropdownMenu.hasClass("dropdown-menu-right"), rt ? (et.left = "auto", U = l.scrollbarPadding(H), U.heightOverflow && U.scrollbarWidth && (M = U.scrollbarWidth), et.right = window.innerWidth - M - (it.left + t.prop("offsetWidth")) + "px") : (et.left = it.left + "px", et.right = "auto"), !F) {
        var W = l.offset(H);
        et.top = it.top - W.top + "px", rt ? et.right = window.innerWidth - (it.left - W.left + t.prop("offsetWidth")) + "px" : et.left = it.left - W.left + "px";
      }
      p.dropdownMenu.css(et);
    }
    var J = H || t, vt = H ? x : b, St = J.hasClass(vt), zt = i.isOnlyOpen(s, H);
    if (St === !O) {
      var j;
      H ? j = zt ? "removeClass" : "addClass" : j = O ? "addClass" : "removeClass", r[j](J, vt).then(function() {
        angular.isDefined(O) && O !== N && R(s, { open: !!O });
      });
    }
    if (O)
      p.dropdownMenuTemplateUrl ? d(p.dropdownMenuTemplateUrl).then(function(lt) {
        g = h.$new(), c(lt.trim())(g, function(at) {
          var nt = at;
          p.dropdownMenu.replaceWith(nt), p.dropdownMenu = nt, o.on("keydown", i.keybindFilter);
        });
      }) : o.on("keydown", i.keybindFilter), h.focusToggleElement(), i.open(h, t, H);
    else {
      if (i.close(h, t, H), p.dropdownMenuTemplateUrl) {
        g && g.$destroy();
        var tt = angular.element('<ul class="dropdown-menu"></ul>');
        p.dropdownMenu.replaceWith(tt), p.dropdownMenu = tt;
      }
      p.selectedOption = null;
    }
    angular.isFunction(T) && T(s, O);
  });
}]).directive("uibDropdown", function() {
  return {
    controller: "UibDropdownController",
    link: function(s, t, e, a) {
      a.init();
    }
  };
}).directive("uibDropdownMenu", function() {
  return {
    restrict: "A",
    require: "?^uibDropdown",
    link: function(s, t, e, a) {
      if (!(!a || angular.isDefined(e.dropdownNested))) {
        t.addClass("dropdown-menu");
        var n = e.templateUrl;
        n && (a.dropdownMenuTemplateUrl = n), a.dropdownMenu || (a.dropdownMenu = t);
      }
    }
  };
}).directive("uibDropdownToggle", function() {
  return {
    require: "?^uibDropdown",
    link: function(s, t, e, a) {
      if (a) {
        t.addClass("dropdown-toggle"), a.toggleElement = t;
        var n = function(i) {
          i.preventDefault(), !t.hasClass("disabled") && !e.disabled && s.$apply(function() {
            a.toggle();
          });
        };
        t.on("click", n), t.attr({ "aria-haspopup": !0, "aria-expanded": !1 }), s.$watch(a.isOpen, function(i) {
          t.attr("aria-expanded", !!i);
        }), s.$on("$destroy", function() {
          t.off("click", n);
        });
      }
    }
  };
});
angular.module("ui.bootstrap.stackedMap", []).factory("$$stackedMap", function() {
  return {
    createNew: function() {
      var s = [];
      return {
        add: function(t, e) {
          s.push({
            key: t,
            value: e
          });
        },
        get: function(t) {
          for (var e = 0; e < s.length; e++)
            if (t === s[e].key)
              return s[e];
        },
        keys: function() {
          for (var t = [], e = 0; e < s.length; e++)
            t.push(s[e].key);
          return t;
        },
        top: function() {
          return s[s.length - 1];
        },
        remove: function(t) {
          for (var e = -1, a = 0; a < s.length; a++)
            if (t === s[a].key) {
              e = a;
              break;
            }
          return s.splice(e, 1)[0];
        },
        removeTop: function() {
          return s.pop();
        },
        length: function() {
          return s.length;
        }
      };
    }
  };
});
angular.module("ui.bootstrap.modal", ["ui.bootstrap.multiMap", "ui.bootstrap.stackedMap", "ui.bootstrap.position"]).provider("$uibResolve", function() {
  var s = this;
  this.resolver = null, this.setResolver = function(t) {
    this.resolver = t;
  }, this.$get = ["$injector", "$q", function(t, e) {
    var a = s.resolver ? t.get(s.resolver) : null;
    return {
      resolve: function(n, i, r, l) {
        if (a)
          return a.resolve(n, i, r, l);
        var o = [];
        return angular.forEach(n, function(c) {
          angular.isFunction(c) || angular.isArray(c) ? o.push(e.resolve(t.invoke(c))) : angular.isString(c) ? o.push(e.resolve(t.get(c))) : o.push(e.resolve(c));
        }), e.all(o).then(function(c) {
          var d = {}, p = 0;
          return angular.forEach(n, function(h, g) {
            d[g] = c[p++];
          }), d;
        });
      }
    };
  }];
}).directive("uibModalBackdrop", [
  "$animate",
  "$injector",
  "$uibModalStack",
  function(s, t, e) {
    return {
      restrict: "A",
      compile: function(n, i) {
        return n.addClass(i.backdropClass), a;
      }
    };
    function a(n, i, r) {
      r.modalInClass && (s.addClass(i, r.modalInClass), n.$on(e.NOW_CLOSING_EVENT, function(l, o) {
        var c = o();
        n.modalOptions.animation ? s.removeClass(i, r.modalInClass).then(c) : c();
      }));
    }
  }
]).directive("uibModalWindow", [
  "$uibModalStack",
  "$q",
  "$animateCss",
  "$document",
  function(s, t, e, a) {
    return {
      scope: {
        index: "@"
      },
      restrict: "A",
      transclude: !0,
      templateUrl: function(n, i) {
        return i.templateUrl || "uib/template/modal/window.html";
      },
      link: function(n, i, r) {
        i.addClass(r.windowTopClass || ""), n.size = r.size, n.close = function(o) {
          var c = s.getTop();
          c && c.value.backdrop && c.value.backdrop !== "static" && o.target === o.currentTarget && (o.preventDefault(), o.stopPropagation(), s.dismiss(c.key, "backdrop click"));
        }, i.on("click", n.close), n.$isRendered = !0;
        var l = t.defer();
        n.$$postDigest(function() {
          l.resolve();
        }), l.promise.then(function() {
          var o = null;
          r.modalInClass && (o = e(i, {
            addClass: r.modalInClass
          }).start(), n.$on(s.NOW_CLOSING_EVENT, function(c, d) {
            var p = d();
            e(i, {
              removeClass: r.modalInClass
            }).start().then(p);
          })), t.when(o).then(function() {
            var c = s.getTop();
            if (c && s.modalRendered(c.key), !(a[0].activeElement && i[0].contains(a[0].activeElement))) {
              var d = i[0].querySelector("[autofocus]");
              d ? d.focus() : i[0].focus();
            }
          });
        });
      }
    };
  }
]).directive("uibModalAnimationClass", function() {
  return {
    compile: function(s, t) {
      t.modalAnimation && s.addClass(t.uibModalAnimationClass);
    }
  };
}).directive("uibModalTransclude", ["$animate", function(s) {
  return {
    link: function(t, e, a, n, i) {
      i(t.$parent, function(r) {
        e.empty(), s.enter(r, e);
      });
    }
  };
}]).factory("$uibModalStack", [
  "$animate",
  "$animateCss",
  "$document",
  "$compile",
  "$rootScope",
  "$q",
  "$$multiMap",
  "$$stackedMap",
  "$uibPosition",
  function(s, t, e, a, n, i, r, l, o) {
    var c = "modal-open", d, p, h = l.createNew(), g = r.createNew(), x = {
      NOW_CLOSING_EVENT: "modal.stack.now-closing"
    }, b = 0, A = null, T = "data-bootstrap-modal-aria-hidden-count", R = "a[href], area[href], input:not([disabled]):not([tabindex='-1']), button:not([disabled]):not([tabindex='-1']),select:not([disabled]):not([tabindex='-1']), textarea:not([disabled]):not([tabindex='-1']), iframe, object, embed, *[tabindex]:not([tabindex='-1']), *[contenteditable=true]", C, v = /[A-Z]/g;
    function P(U) {
      var M = "-";
      return U.replace(v, function(W, J) {
        return (J ? M : "") + W.toLowerCase();
      });
    }
    function O(U) {
      return !!(U.offsetWidth || U.offsetHeight || U.getClientRects().length);
    }
    function N() {
      for (var U = -1, M = h.keys(), W = 0; W < M.length; W++)
        h.get(M[W]).value.backdrop && (U = W);
      return U > -1 && U < b && (U = b), U;
    }
    n.$watch(N, function(U) {
      p && (p.index = U);
    });
    function H(U, M) {
      var W = h.get(U).value, J = W.appendTo;
      h.remove(U), A = h.top(), A && (b = parseInt(A.value.modalDomEl.attr("index"), 10)), Q(W.modalDomEl, W.modalScope, function() {
        var vt = W.openedClass || c;
        g.remove(vt, U);
        var St = g.hasKey(vt);
        J.toggleClass(vt, St), !St && C && C.heightOverflow && C.scrollbarWidth && (C.originalRight ? J.css({ paddingRight: C.originalRight + "px" }) : J.css({ paddingRight: "" }), C = null), F(!0);
      }, W.closedDeferred), B(), M && M.focus ? M.focus() : J.focus && J.focus();
    }
    function F(U) {
      var M;
      h.length() > 0 && (M = h.top().value, M.modalDomEl.toggleClass(M.windowTopClass || "", U));
    }
    function B() {
      d && N() === -1 && (Q(d, p, function() {
      }), d = void 0, p = void 0);
    }
    function Q(U, M, W, J) {
      var vt, St = null, zt = function() {
        return vt || (vt = i.defer(), St = vt.promise), function() {
          vt.resolve();
        };
      };
      return M.$broadcast(x.NOW_CLOSING_EVENT, zt), i.when(St).then(j);
      function j() {
        j.done || (j.done = !0, s.leave(U).then(function() {
          W && W(), U.remove(), J && J.resolve();
        }), M.$destroy());
      }
    }
    e.on("keydown", it), n.$on("$destroy", function() {
      e.off("keydown", it);
    });
    function it(U) {
      if (U.isDefaultPrevented())
        return U;
      var M = h.top();
      if (M)
        switch (U.which) {
          case 27: {
            M.value.keyboard && (U.preventDefault(), n.$apply(function() {
              x.dismiss(M.key, "escape key press");
            }));
            break;
          }
          case 9: {
            var W = x.loadFocusElementList(M), J = !1;
            U.shiftKey ? (x.isFocusInFirstItem(U, W) || x.isModalFocused(U, M)) && (J = x.focusLastFocusableElement(W)) : x.isFocusInLastItem(U, W) && (J = x.focusFirstFocusableElement(W)), J && (U.preventDefault(), U.stopPropagation());
            break;
          }
        }
    }
    x.open = function(U, M) {
      var W = e[0].activeElement, J = M.openedClass || c;
      F(!1), A = h.top(), h.add(U, {
        deferred: M.deferred,
        renderDeferred: M.renderDeferred,
        closedDeferred: M.closedDeferred,
        modalScope: M.scope,
        backdrop: M.backdrop,
        keyboard: M.keyboard,
        openedClass: M.openedClass,
        windowTopClass: M.windowTopClass,
        animation: M.animation,
        appendTo: M.appendTo
      }), g.put(J, U);
      var vt = M.appendTo, St = N();
      St >= 0 && !d && (p = n.$new(!0), p.modalOptions = M, p.index = St, d = angular.element('<div uib-modal-backdrop="modal-backdrop"></div>'), d.attr({
        class: "modal-backdrop",
        "ng-style": "{'z-index': 1040 + (index && 1 || 0) + index*10}",
        "uib-modal-animation-class": "fade",
        "modal-in-class": "in"
      }), M.backdropClass && d.addClass(M.backdropClass), M.animation && d.attr("modal-animation", "true"), a(d)(p), s.enter(d, vt), o.isScrollable(vt) && (C = o.scrollbarPadding(vt), C.heightOverflow && C.scrollbarWidth && vt.css({ paddingRight: C.right + "px" })));
      var zt;
      M.component ? (zt = document.createElement(P(M.component.name)), zt = angular.element(zt), zt.attr({
        resolve: "$resolve",
        "modal-instance": "$uibModalInstance",
        close: "$close($value)",
        dismiss: "$dismiss($value)"
      })) : zt = M.content, b = A ? parseInt(A.value.modalDomEl.attr("index"), 10) + 1 : 0;
      var j = angular.element('<div uib-modal-window="modal-window"></div>');
      j.attr({
        class: "modal",
        "template-url": M.windowTemplateUrl,
        "window-top-class": M.windowTopClass,
        role: "dialog",
        "aria-labelledby": M.ariaLabelledBy,
        "aria-describedby": M.ariaDescribedBy,
        size: M.size,
        index: b,
        animate: "animate",
        "ng-style": "{'z-index': 1050 + $$topModalIndex*10, display: 'block'}",
        tabindex: -1,
        "uib-modal-animation-class": "fade",
        "modal-in-class": "in"
      }).append(zt), M.windowClass && j.addClass(M.windowClass), M.animation && j.attr("modal-animation", "true"), vt.addClass(J), M.scope && (M.scope.$$topModalIndex = b), s.enter(a(j)(M.scope), vt), h.top().value.modalDomEl = j, h.top().value.modalOpener = W, tt(j);
      function tt(lt) {
        if (!lt || lt[0].tagName === "BODY")
          return;
        return at(lt).forEach(function(nt) {
          var yt = nt.getAttribute("aria-hidden") === "true", Rt = parseInt(nt.getAttribute(T), 10);
          Rt || (Rt = yt ? 1 : 0), nt.setAttribute(T, Rt + 1), nt.setAttribute("aria-hidden", "true");
        }), tt(lt.parent());
        function at(nt) {
          var yt = nt.parent() ? nt.parent().children() : [];
          return Array.prototype.filter.call(yt, function(Rt) {
            return Rt !== nt[0];
          });
        }
      }
    };
    function et(U, M, W) {
      return !U.value.modalScope.$broadcast("modal.closing", M, W).defaultPrevented;
    }
    function rt() {
      Array.prototype.forEach.call(
        document.querySelectorAll("[" + T + "]"),
        function(U) {
          var M = parseInt(U.getAttribute(T), 10), W = M - 1;
          U.setAttribute(T, W), W || (U.removeAttribute(T), U.removeAttribute("aria-hidden"));
        }
      );
    }
    return x.close = function(U, M) {
      var W = h.get(U);
      return rt(), W && et(W, M, !0) ? (W.value.modalScope.$$uibDestructionScheduled = !0, W.value.deferred.resolve(M), H(U, W.value.modalOpener), !0) : !W;
    }, x.dismiss = function(U, M) {
      var W = h.get(U);
      return rt(), W && et(W, M, !1) ? (W.value.modalScope.$$uibDestructionScheduled = !0, W.value.deferred.reject(M), H(U, W.value.modalOpener), !0) : !W;
    }, x.dismissAll = function(U) {
      for (var M = this.getTop(); M && this.dismiss(M.key, U); )
        M = this.getTop();
    }, x.getTop = function() {
      return h.top();
    }, x.modalRendered = function(U) {
      var M = h.get(U);
      M && M.value.renderDeferred.resolve();
    }, x.focusFirstFocusableElement = function(U) {
      return U.length > 0 ? (U[0].focus(), !0) : !1;
    }, x.focusLastFocusableElement = function(U) {
      return U.length > 0 ? (U[U.length - 1].focus(), !0) : !1;
    }, x.isModalFocused = function(U, M) {
      if (U && M) {
        var W = M.value.modalDomEl;
        if (W && W.length)
          return (U.target || U.srcElement) === W[0];
      }
      return !1;
    }, x.isFocusInFirstItem = function(U, M) {
      return M.length > 0 ? (U.target || U.srcElement) === M[0] : !1;
    }, x.isFocusInLastItem = function(U, M) {
      return M.length > 0 ? (U.target || U.srcElement) === M[M.length - 1] : !1;
    }, x.loadFocusElementList = function(U) {
      if (U) {
        var M = U.value.modalDomEl;
        if (M && M.length) {
          var W = M[0].querySelectorAll(R);
          return W && Array.prototype.filter.call(W, function(J) {
            return O(J);
          });
        }
      }
    }, x;
  }
]).provider("$uibModal", function() {
  var s = {
    options: {
      animation: !0,
      backdrop: !0,
      //can also be false or 'static'
      keyboard: !0
    },
    $get: [
      "$rootScope",
      "$q",
      "$document",
      "$templateRequest",
      "$controller",
      "$uibResolve",
      "$uibModalStack",
      function(t, e, a, n, i, r, l) {
        var o = {};
        function c(p) {
          return p.template ? e.when(p.template) : n(angular.isFunction(p.templateUrl) ? p.templateUrl() : p.templateUrl);
        }
        var d = null;
        return o.getPromiseChain = function() {
          return d;
        }, o.open = function(p) {
          var h = e.defer(), g = e.defer(), x = e.defer(), b = e.defer(), A = {
            result: h.promise,
            opened: g.promise,
            closed: x.promise,
            rendered: b.promise,
            close: function(v) {
              return l.close(A, v);
            },
            dismiss: function(v) {
              return l.dismiss(A, v);
            }
          };
          if (p = angular.extend({}, s.options, p), p.resolve = p.resolve || {}, p.appendTo = p.appendTo || a.find("body").eq(0), !p.appendTo.length)
            throw new Error("appendTo element not found. Make sure that the element passed is in DOM.");
          if (!p.component && !p.template && !p.templateUrl)
            throw new Error("One of component or template or templateUrl options is required.");
          var T;
          p.component ? T = e.when(r.resolve(p.resolve, {}, null, null)) : T = e.all([c(p), r.resolve(p.resolve, {}, null, null)]);
          function R() {
            return T;
          }
          var C;
          return C = d = e.all([d]).then(R, R).then(function(P) {
            var O = p.scope || t, N = O.$new();
            N.$close = A.close, N.$dismiss = A.dismiss, N.$on("$destroy", function() {
              N.$$uibDestructionScheduled || N.$dismiss("$uibUnscheduledDestruction");
            });
            var H = {
              scope: N,
              deferred: h,
              renderDeferred: b,
              closedDeferred: x,
              animation: p.animation,
              backdrop: p.backdrop,
              keyboard: p.keyboard,
              backdropClass: p.backdropClass,
              windowTopClass: p.windowTopClass,
              windowClass: p.windowClass,
              windowTemplateUrl: p.windowTemplateUrl,
              ariaLabelledBy: p.ariaLabelledBy,
              ariaDescribedBy: p.ariaDescribedBy,
              size: p.size,
              openedClass: p.openedClass,
              appendTo: p.appendTo
            }, F = {}, B, Q, it = {};
            p.component ? (et(F, !1, !0, !1), F.name = p.component, H.component = F) : p.controller && (et(it, !0, !1, !0), Q = i(p.controller, it, !0, p.controllerAs), p.controllerAs && p.bindToController && (B = Q.instance, B.$close = N.$close, B.$dismiss = N.$dismiss, angular.extend(B, {
              $resolve: it.$scope.$resolve
            }, O)), B = Q(), angular.isFunction(B.$onInit) && B.$onInit()), p.component || (H.content = P[0]), l.open(A, H), g.resolve(!0);
            function et(rt, U, M, W) {
              rt.$scope = N, rt.$scope.$resolve = {}, M ? rt.$scope.$uibModalInstance = A : rt.$uibModalInstance = A;
              var J = U ? P[1] : P;
              angular.forEach(J, function(vt, St) {
                W && (rt[St] = vt), rt.$scope.$resolve[St] = vt;
              });
            }
          }, function(P) {
            g.reject(P), h.reject(P);
          }).finally(function() {
            d === C && (d = null);
          }), A;
        }, o;
      }
    ]
  };
  return s;
});
angular.module("ui.bootstrap.paging", []).factory("uibPaging", ["$parse", function(s) {
  return {
    create: function(t, e, a) {
      t.setNumPages = a.numPages ? s(a.numPages).assign : angular.noop, t.ngModelCtrl = { $setViewValue: angular.noop }, t._watchers = [], t.init = function(n, i) {
        t.ngModelCtrl = n, t.config = i, n.$render = function() {
          t.render();
        }, a.itemsPerPage ? t._watchers.push(e.$parent.$watch(a.itemsPerPage, function(r) {
          t.itemsPerPage = parseInt(r, 10), e.totalPages = t.calculateTotalPages(), t.updatePage();
        })) : t.itemsPerPage = i.itemsPerPage, e.$watch("totalItems", function(r, l) {
          (angular.isDefined(r) || r !== l) && (e.totalPages = t.calculateTotalPages(), t.updatePage());
        });
      }, t.calculateTotalPages = function() {
        var n = t.itemsPerPage < 1 ? 1 : Math.ceil(e.totalItems / t.itemsPerPage);
        return Math.max(n || 0, 1);
      }, t.render = function() {
        e.page = parseInt(t.ngModelCtrl.$viewValue, 10) || 1;
      }, e.selectPage = function(n, i) {
        i && i.preventDefault();
        var r = !e.ngDisabled || !i;
        r && e.page !== n && n > 0 && n <= e.totalPages && (i && i.target && i.target.blur(), t.ngModelCtrl.$setViewValue(n), t.ngModelCtrl.$render());
      }, e.getText = function(n) {
        return e[n + "Text"] || t.config[n + "Text"];
      }, e.noPrevious = function() {
        return e.page === 1;
      }, e.noNext = function() {
        return e.page === e.totalPages;
      }, t.updatePage = function() {
        t.setNumPages(e.$parent, e.totalPages), e.page > e.totalPages ? e.selectPage(e.totalPages) : t.ngModelCtrl.$render();
      }, e.$on("$destroy", function() {
        for (; t._watchers.length; )
          t._watchers.shift()();
      });
    }
  };
}]);
angular.module("ui.bootstrap.pager", ["ui.bootstrap.paging", "ui.bootstrap.tabindex"]).controller("UibPagerController", ["$scope", "$attrs", "uibPaging", "uibPagerConfig", function(s, t, e, a) {
  s.align = angular.isDefined(t.align) ? s.$parent.$eval(t.align) : a.align, e.create(this, s, t);
}]).constant("uibPagerConfig", {
  itemsPerPage: 10,
  previousText: "« Previous",
  nextText: "Next »",
  align: !0
}).directive("uibPager", ["uibPagerConfig", function(s) {
  return {
    scope: {
      totalItems: "=",
      previousText: "@",
      nextText: "@",
      ngDisabled: "="
    },
    require: ["uibPager", "?ngModel"],
    restrict: "A",
    controller: "UibPagerController",
    controllerAs: "pager",
    templateUrl: function(t, e) {
      return e.templateUrl || "uib/template/pager/pager.html";
    },
    link: function(t, e, a, n) {
      e.addClass("pager");
      var i = n[0], r = n[1];
      r && i.init(r, s);
    }
  };
}]);
angular.module("ui.bootstrap.pagination", ["ui.bootstrap.paging", "ui.bootstrap.tabindex"]).controller("UibPaginationController", ["$scope", "$attrs", "$parse", "uibPaging", "uibPaginationConfig", function(s, t, e, a, n) {
  var i = this, r = angular.isDefined(t.maxSize) ? s.$parent.$eval(t.maxSize) : n.maxSize, l = angular.isDefined(t.rotate) ? s.$parent.$eval(t.rotate) : n.rotate, o = angular.isDefined(t.forceEllipses) ? s.$parent.$eval(t.forceEllipses) : n.forceEllipses, c = angular.isDefined(t.boundaryLinkNumbers) ? s.$parent.$eval(t.boundaryLinkNumbers) : n.boundaryLinkNumbers, d = angular.isDefined(t.pageLabel) ? function(x) {
    return s.$parent.$eval(t.pageLabel, { $page: x });
  } : angular.identity;
  s.boundaryLinks = angular.isDefined(t.boundaryLinks) ? s.$parent.$eval(t.boundaryLinks) : n.boundaryLinks, s.directionLinks = angular.isDefined(t.directionLinks) ? s.$parent.$eval(t.directionLinks) : n.directionLinks, t.$set("role", "menu"), a.create(this, s, t), t.maxSize && i._watchers.push(s.$parent.$watch(e(t.maxSize), function(x) {
    r = parseInt(x, 10), i.render();
  }));
  function p(x, b, A) {
    return {
      number: x,
      text: b,
      active: A
    };
  }
  function h(x, b) {
    var A = [], T = 1, R = b, C = angular.isDefined(r) && r < b;
    C && (l ? (T = Math.max(x - Math.floor(r / 2), 1), R = T + r - 1, R > b && (R = b, T = R - r + 1)) : (T = (Math.ceil(x / r) - 1) * r + 1, R = Math.min(T + r - 1, b)));
    for (var v = T; v <= R; v++) {
      var P = p(v, d(v), v === x);
      A.push(P);
    }
    if (C && r > 0 && (!l || o || c)) {
      if (T > 1) {
        if (!c || T > 3) {
          var O = p(T - 1, "...", !1);
          A.unshift(O);
        }
        if (c) {
          if (T === 3) {
            var N = p(2, "2", !1);
            A.unshift(N);
          }
          var H = p(1, "1", !1);
          A.unshift(H);
        }
      }
      if (R < b) {
        if (!c || R < b - 2) {
          var F = p(R + 1, "...", !1);
          A.push(F);
        }
        if (c) {
          if (R === b - 2) {
            var B = p(b - 1, b - 1, !1);
            A.push(B);
          }
          var Q = p(b, b, !1);
          A.push(Q);
        }
      }
    }
    return A;
  }
  var g = this.render;
  this.render = function() {
    g(), s.page > 0 && s.page <= s.totalPages && (s.pages = h(s.page, s.totalPages));
  };
}]).constant("uibPaginationConfig", {
  itemsPerPage: 10,
  boundaryLinks: !1,
  boundaryLinkNumbers: !1,
  directionLinks: !0,
  firstText: "First",
  previousText: "Previous",
  nextText: "Next",
  lastText: "Last",
  rotate: !0,
  forceEllipses: !1
}).directive("uibPagination", ["$parse", "uibPaginationConfig", function(s, t) {
  return {
    scope: {
      totalItems: "=",
      firstText: "@",
      previousText: "@",
      nextText: "@",
      lastText: "@",
      ngDisabled: "="
    },
    require: ["uibPagination", "?ngModel"],
    restrict: "A",
    controller: "UibPaginationController",
    controllerAs: "pagination",
    templateUrl: function(e, a) {
      return a.templateUrl || "uib/template/pagination/pagination.html";
    },
    link: function(e, a, n, i) {
      a.addClass("pagination");
      var r = i[0], l = i[1];
      l && r.init(l, t);
    }
  };
}]);
angular.module("ui.bootstrap.tooltip", ["ui.bootstrap.position", "ui.bootstrap.stackedMap"]).provider("$uibTooltip", function() {
  var s = {
    placement: "top",
    placementClassPrefix: "",
    animation: !0,
    popupDelay: 0,
    popupCloseDelay: 0,
    useContentExp: !1
  }, t = {
    mouseenter: "mouseleave",
    click: "click",
    outsideClick: "outsideClick",
    focus: "blur",
    none: ""
  }, e = {};
  this.options = function(n) {
    angular.extend(e, n);
  }, this.setTriggers = function(i) {
    angular.extend(t, i);
  };
  function a(n) {
    var i = /[A-Z]/g, r = "-";
    return n.replace(i, function(l, o) {
      return (o ? r : "") + l.toLowerCase();
    });
  }
  this.$get = ["$window", "$compile", "$timeout", "$document", "$uibPosition", "$interpolate", "$rootScope", "$parse", "$$stackedMap", function(n, i, r, l, o, c, d, p, h) {
    var g = h.createNew();
    l.on("keyup", x), d.$on("$destroy", function() {
      l.off("keyup", x);
    });
    function x(b) {
      if (b.which === 27) {
        var A = g.top();
        A && (A.value.close(), A = null);
      }
    }
    return function(A, T, R, C) {
      C = angular.extend({}, s, e, C);
      function v(F) {
        var B = (F || C.trigger || R).split(" "), Q = B.map(function(it) {
          return t[it] || it;
        });
        return {
          show: B,
          hide: Q
        };
      }
      var P = a(A), O = c.startSymbol(), N = c.endSymbol(), H = "<div " + P + '-popup uib-title="' + O + "title" + N + '" ' + (C.useContentExp ? 'content-exp="contentExp()" ' : 'content="' + O + "content" + N + '" ') + 'origin-scope="origScope" class="uib-position-measure ' + T + '" tooltip-animation-class="fade"uib-tooltip-classes ng-class="{ in: isOpen }" ></div>';
      return {
        compile: function(F, B) {
          var Q = i(H);
          return function(et, rt, U, M) {
            var W, J, vt, St, zt, j, tt, lt = angular.isDefined(C.appendToBody) ? C.appendToBody : !1, at = v(void 0), nt = angular.isDefined(U[T + "Enable"]), yt = et.$new(!0), Rt = !1, Yt = angular.isDefined(U[T + "IsOpen"]) ? p(U[T + "IsOpen"]) : !1, K = C.useContentExp ? p(U[A]) : !1, _ = [], V, G = function() {
              !W || !W.html() || j || (j = r(function() {
                var ge = o.positionElements(rt, W, yt.placement, lt), Ka = angular.isDefined(W.offsetHeight) ? W.offsetHeight : W.prop("offsetHeight"), sn = lt ? o.offset(rt) : o.position(rt);
                W.css({ top: ge.top + "px", left: ge.left + "px" });
                var Ie = ge.placement.split("-");
                W.hasClass(Ie[0]) || (W.removeClass(V.split("-")[0]), W.addClass(Ie[0])), W.hasClass(C.placementClassPrefix + ge.placement) || (W.removeClass(C.placementClassPrefix + V), W.addClass(C.placementClassPrefix + ge.placement)), tt = r(function() {
                  var Ss = angular.isDefined(W.offsetHeight) ? W.offsetHeight : W.prop("offsetHeight"), ks = o.adjustTop(Ie, sn, Ka, Ss);
                  ks && W.css(ks), tt = null;
                }, 0, !1), W.hasClass("uib-position-measure") ? (o.positionArrow(W, ge.placement), W.removeClass("uib-position-measure")) : V !== ge.placement && o.positionArrow(W, ge.placement), V = ge.placement, j = null;
              }, 0, !1));
            };
            yt.origScope = et, yt.isOpen = !1;
            function dt() {
              yt.isOpen ? ot() : ht();
            }
            function ht() {
              nt && !et.$eval(U[T + "Enable"]) || (de(), oe(), yt.popupDelay ? St || (St = r($t, yt.popupDelay, !1)) : $t());
            }
            function ot() {
              _t(), yt.popupCloseDelay ? zt || (zt = r(qt, yt.popupCloseDelay, !1)) : qt();
            }
            function $t() {
              if (_t(), de(), !yt.content)
                return angular.noop;
              me(), yt.$evalAsync(function() {
                yt.isOpen = !0, Ye(!0), G();
              });
            }
            function _t() {
              St && (r.cancel(St), St = null), j && (r.cancel(j), j = null);
            }
            function qt() {
              yt && yt.$evalAsync(function() {
                yt && (yt.isOpen = !1, Ye(!1), yt.animation ? vt || (vt = r(Ht, 150, !1)) : Ht());
              });
            }
            function de() {
              zt && (r.cancel(zt), zt = null), vt && (r.cancel(vt), vt = null);
            }
            function me() {
              W || (J = yt.$new(), W = Q(J, function(ge) {
                lt ? l.find("body").append(ge) : rt.after(ge);
              }), g.add(yt, {
                close: qt
              }), ze());
            }
            function Ht() {
              _t(), de(), Lt(), W && (W.remove(), W = null, tt && r.cancel(tt)), g.remove(yt), J && (J.$destroy(), J = null);
            }
            function oe() {
              yt.title = U[T + "Title"], K ? yt.content = K(et) : yt.content = U[A], yt.popupClass = U[T + "Class"], yt.placement = angular.isDefined(U[T + "Placement"]) ? U[T + "Placement"] : C.placement;
              var ge = o.parsePlacement(yt.placement);
              V = ge[1] ? ge[0] + "-" + ge[1] : ge[0];
              var Ka = parseInt(U[T + "PopupDelay"], 10), sn = parseInt(U[T + "PopupCloseDelay"], 10);
              yt.popupDelay = isNaN(Ka) ? C.popupDelay : Ka, yt.popupCloseDelay = isNaN(sn) ? C.popupCloseDelay : sn;
            }
            function Ye(ge) {
              Yt && angular.isFunction(Yt.assign) && Yt.assign(et, ge);
            }
            yt.contentExp = function() {
              return yt.content;
            }, U.$observe("disabled", function(ge) {
              ge && _t(), ge && yt.isOpen && qt();
            }), Yt && et.$watch(Yt, function(ge) {
              yt && !ge === yt.isOpen && dt();
            });
            function ze() {
              _.length = 0, K ? (_.push(
                et.$watch(K, function(ge) {
                  yt.content = ge, !ge && yt.isOpen && qt();
                })
              ), _.push(
                J.$watch(function() {
                  Rt || (Rt = !0, J.$$postDigest(function() {
                    Rt = !1, yt && yt.isOpen && G();
                  }));
                })
              )) : _.push(
                U.$observe(A, function(ge) {
                  yt.content = ge, !ge && yt.isOpen ? qt() : G();
                })
              ), _.push(
                U.$observe(T + "Title", function(ge) {
                  yt.title = ge, yt.isOpen && G();
                })
              ), _.push(
                U.$observe(T + "Placement", function(ge) {
                  yt.placement = ge || C.placement, yt.isOpen && G();
                })
              );
            }
            function Lt() {
              _.length && (angular.forEach(_, function(ge) {
                ge();
              }), _.length = 0);
            }
            function ye(ge) {
              !yt || !yt.isOpen || !W || !rt[0].contains(ge.target) && !W[0].contains(ge.target) && ot();
            }
            function ue(ge) {
              ge.which === 27 && ot();
            }
            var _e = function() {
              at.show.forEach(function(ge) {
                ge === "outsideClick" ? rt.off("click", dt) : (rt.off(ge, ht), rt.off(ge, dt)), rt.off("keypress", ue);
              }), at.hide.forEach(function(ge) {
                ge === "outsideClick" ? l.off("click", ye) : rt.off(ge, ot);
              });
            };
            function la() {
              var ge = [], Ka = [], sn = et.$eval(U[T + "Trigger"]);
              _e(), angular.isObject(sn) ? (Object.keys(sn).forEach(function(Ie) {
                ge.push(Ie), Ka.push(sn[Ie]);
              }), at = {
                show: ge,
                hide: Ka
              }) : at = v(sn), at.show !== "none" && at.show.forEach(function(Ie, Ss) {
                Ie === "outsideClick" ? (rt.on("click", dt), l.on("click", ye)) : Ie === at.hide[Ss] ? rt.on(Ie, dt) : Ie && (rt.on(Ie, ht), rt.on(at.hide[Ss], ot)), rt.on("keypress", ue);
              });
            }
            la();
            var qa = et.$eval(U[T + "Animation"]);
            yt.animation = angular.isDefined(qa) ? !!qa : C.animation;
            var je, Aa = T + "AppendToBody";
            Aa in U && U[Aa] === void 0 ? je = !0 : je = et.$eval(U[Aa]), lt = angular.isDefined(je) ? je : lt, et.$on("$destroy", function() {
              _e(), Ht(), yt = null;
            });
          };
        }
      };
    };
  }];
}).directive("uibTooltipTemplateTransclude", [
  "$animate",
  "$sce",
  "$compile",
  "$templateRequest",
  function(s, t, e, a) {
    return {
      link: function(n, i, r) {
        var l = n.$eval(r.tooltipTemplateTranscludeScope), o = 0, c, d, p, h = function() {
          d && (d.remove(), d = null), c && (c.$destroy(), c = null), p && (s.leave(p).then(function() {
            d = null;
          }), d = p, p = null);
        };
        n.$watch(t.parseAsResourceUrl(r.uibTooltipTemplateTransclude), function(g) {
          var x = ++o;
          g ? (a(g, !0).then(function(b) {
            if (x === o) {
              var A = l.$new(), T = b, R = e(T)(A, function(C) {
                h(), s.enter(C, i);
              });
              c = A, p = R, c.$emit("$includeContentLoaded", g);
            }
          }, function() {
            x === o && (h(), n.$emit("$includeContentError", g));
          }), n.$emit("$includeContentRequested", g)) : h();
        }), n.$on("$destroy", h);
      }
    };
  }
]).directive("uibTooltipClasses", ["$uibPosition", function(s) {
  return {
    restrict: "A",
    link: function(t, e, a) {
      if (t.placement) {
        var n = s.parsePlacement(t.placement);
        e.addClass(n[0]);
      }
      t.popupClass && e.addClass(t.popupClass), t.animation && e.addClass(a.tooltipAnimationClass);
    }
  };
}]).directive("uibTooltipPopup", function() {
  return {
    restrict: "A",
    scope: { content: "@" },
    templateUrl: "uib/template/tooltip/tooltip-popup.html"
  };
}).directive("uibTooltip", ["$uibTooltip", function(s) {
  return s("uibTooltip", "tooltip", "mouseenter");
}]).directive("uibTooltipTemplatePopup", function() {
  return {
    restrict: "A",
    scope: { contentExp: "&", originScope: "&" },
    templateUrl: "uib/template/tooltip/tooltip-template-popup.html"
  };
}).directive("uibTooltipTemplate", ["$uibTooltip", function(s) {
  return s("uibTooltipTemplate", "tooltip", "mouseenter", {
    useContentExp: !0
  });
}]).directive("uibTooltipHtmlPopup", function() {
  return {
    restrict: "A",
    scope: { contentExp: "&" },
    templateUrl: "uib/template/tooltip/tooltip-html-popup.html"
  };
}).directive("uibTooltipHtml", ["$uibTooltip", function(s) {
  return s("uibTooltipHtml", "tooltip", "mouseenter", {
    useContentExp: !0
  });
}]);
angular.module("ui.bootstrap.popover", ["ui.bootstrap.tooltip"]).directive("uibPopoverTemplatePopup", function() {
  return {
    restrict: "A",
    scope: { uibTitle: "@", contentExp: "&", originScope: "&" },
    templateUrl: "uib/template/popover/popover-template.html"
  };
}).directive("uibPopoverTemplate", ["$uibTooltip", function(s) {
  return s("uibPopoverTemplate", "popover", "click", {
    useContentExp: !0
  });
}]).directive("uibPopoverHtmlPopup", function() {
  return {
    restrict: "A",
    scope: { contentExp: "&", uibTitle: "@" },
    templateUrl: "uib/template/popover/popover-html.html"
  };
}).directive("uibPopoverHtml", ["$uibTooltip", function(s) {
  return s("uibPopoverHtml", "popover", "click", {
    useContentExp: !0
  });
}]).directive("uibPopoverPopup", function() {
  return {
    restrict: "A",
    scope: { uibTitle: "@", content: "@" },
    templateUrl: "uib/template/popover/popover.html"
  };
}).directive("uibPopover", ["$uibTooltip", function(s) {
  return s("uibPopover", "popover", "click");
}]);
angular.module("ui.bootstrap.progressbar", []).constant("uibProgressConfig", {
  animate: !0,
  max: 100
}).controller("UibProgressController", ["$scope", "$attrs", "uibProgressConfig", function(s, t, e) {
  var a = this, n = angular.isDefined(t.animate) ? s.$parent.$eval(t.animate) : e.animate;
  this.bars = [], s.max = i(), this.addBar = function(r, l, o) {
    n || l.css({ transition: "none" }), this.bars.push(r), r.max = i(), r.title = o && angular.isDefined(o.title) ? o.title : "progressbar", r.$watch("value", function(c) {
      r.recalculatePercentage();
    }), r.recalculatePercentage = function() {
      var c = a.bars.reduce(function(d, p) {
        return p.percent = +(100 * p.value / p.max).toFixed(2), d + p.percent;
      }, 0);
      c > 100 && (r.percent -= c - 100);
    }, r.$on("$destroy", function() {
      l = null, a.removeBar(r);
    });
  }, this.removeBar = function(r) {
    this.bars.splice(this.bars.indexOf(r), 1), this.bars.forEach(function(l) {
      l.recalculatePercentage();
    });
  }, s.$watch("maxParam", function(r) {
    a.bars.forEach(function(l) {
      l.max = i(), l.recalculatePercentage();
    });
  });
  function i() {
    return angular.isDefined(s.maxParam) ? s.maxParam : e.max;
  }
}]).directive("uibProgress", function() {
  return {
    replace: !0,
    transclude: !0,
    controller: "UibProgressController",
    require: "uibProgress",
    scope: {
      maxParam: "=?max"
    },
    templateUrl: "uib/template/progressbar/progress.html"
  };
}).directive("uibBar", function() {
  return {
    replace: !0,
    transclude: !0,
    require: "^uibProgress",
    scope: {
      value: "=",
      type: "@"
    },
    templateUrl: "uib/template/progressbar/bar.html",
    link: function(s, t, e, a) {
      a.addBar(s, t, e);
    }
  };
}).directive("uibProgressbar", function() {
  return {
    replace: !0,
    transclude: !0,
    controller: "UibProgressController",
    scope: {
      value: "=",
      maxParam: "=?max",
      type: "@"
    },
    templateUrl: "uib/template/progressbar/progressbar.html",
    link: function(s, t, e, a) {
      a.addBar(s, angular.element(t.children()[0]), { title: e.title });
    }
  };
});
angular.module("ui.bootstrap.rating", []).constant("uibRatingConfig", {
  max: 5,
  stateOn: null,
  stateOff: null,
  enableReset: !0,
  titles: ["one", "two", "three", "four", "five"]
}).controller("UibRatingController", ["$scope", "$attrs", "uibRatingConfig", function(s, t, e) {
  var a = { $setViewValue: angular.noop }, n = this;
  this.init = function(i) {
    a = i, a.$render = this.render, a.$formatters.push(function(o) {
      return angular.isNumber(o) && o << 0 !== o && (o = Math.round(o)), o;
    }), this.stateOn = angular.isDefined(t.stateOn) ? s.$parent.$eval(t.stateOn) : e.stateOn, this.stateOff = angular.isDefined(t.stateOff) ? s.$parent.$eval(t.stateOff) : e.stateOff, this.enableReset = angular.isDefined(t.enableReset) ? s.$parent.$eval(t.enableReset) : e.enableReset;
    var r = angular.isDefined(t.titles) ? s.$parent.$eval(t.titles) : e.titles;
    this.titles = angular.isArray(r) && r.length > 0 ? r : e.titles;
    var l = angular.isDefined(t.ratingStates) ? s.$parent.$eval(t.ratingStates) : new Array(angular.isDefined(t.max) ? s.$parent.$eval(t.max) : e.max);
    s.range = this.buildTemplateObjects(l);
  }, this.buildTemplateObjects = function(i) {
    for (var r = 0, l = i.length; r < l; r++)
      i[r] = angular.extend({ index: r }, { stateOn: this.stateOn, stateOff: this.stateOff, title: this.getTitle(r) }, i[r]);
    return i;
  }, this.getTitle = function(i) {
    return i >= this.titles.length ? i + 1 : this.titles[i];
  }, s.rate = function(i) {
    if (!s.readonly && i >= 0 && i <= s.range.length) {
      var r = n.enableReset && a.$viewValue === i ? 0 : i;
      a.$setViewValue(r), a.$render();
    }
  }, s.enter = function(i) {
    s.readonly || (s.value = i), s.onHover({ value: i });
  }, s.reset = function() {
    s.value = a.$viewValue, s.onLeave();
  }, s.onKeydown = function(i) {
    /(37|38|39|40)/.test(i.which) && (i.preventDefault(), i.stopPropagation(), s.rate(s.value + (i.which === 38 || i.which === 39 ? 1 : -1)));
  }, this.render = function() {
    s.value = a.$viewValue, s.title = n.getTitle(s.value - 1);
  };
}]).directive("uibRating", function() {
  return {
    require: ["uibRating", "ngModel"],
    restrict: "A",
    scope: {
      readonly: "=?readOnly",
      onHover: "&",
      onLeave: "&"
    },
    controller: "UibRatingController",
    templateUrl: "uib/template/rating/rating.html",
    link: function(s, t, e, a) {
      var n = a[0], i = a[1];
      n.init(i);
    }
  };
});
angular.module("ui.bootstrap.tabs", []).controller("UibTabsetController", ["$scope", function(s) {
  var t = this, e;
  t.tabs = [], t.select = function(i, r) {
    if (!a) {
      var l = n(e), o = t.tabs[l];
      if (o) {
        if (o.tab.onDeselect({
          $event: r,
          $selectedIndex: i
        }), r && r.isDefaultPrevented())
          return;
        o.tab.active = !1;
      }
      var c = t.tabs[i];
      c ? (c.tab.onSelect({
        $event: r
      }), c.tab.active = !0, t.active = c.index, e = c.index) : !c && angular.isDefined(e) && (t.active = null, e = null);
    }
  }, t.addTab = function(r) {
    if (t.tabs.push({
      tab: r,
      index: r.index
    }), t.tabs.sort(function(o, c) {
      return o.index > c.index ? 1 : o.index < c.index ? -1 : 0;
    }), r.index === t.active || !angular.isDefined(t.active) && t.tabs.length === 1) {
      var l = n(r.index);
      t.select(l);
    }
  }, t.removeTab = function(r) {
    for (var l, o = 0; o < t.tabs.length; o++)
      if (t.tabs[o].tab === r) {
        l = o;
        break;
      }
    if (t.tabs[l].index === t.active) {
      var c = l === t.tabs.length - 1 ? l - 1 : l + 1 % t.tabs.length;
      t.select(c);
    }
    t.tabs.splice(l, 1);
  }, s.$watch("tabset.active", function(i) {
    angular.isDefined(i) && i !== e && t.select(n(i));
  });
  var a;
  s.$on("$destroy", function() {
    a = !0;
  });
  function n(i) {
    for (var r = 0; r < t.tabs.length; r++)
      if (t.tabs[r].index === i)
        return r;
  }
}]).directive("uibTabset", function() {
  return {
    transclude: !0,
    replace: !0,
    scope: {},
    bindToController: {
      active: "=?",
      type: "@"
    },
    controller: "UibTabsetController",
    controllerAs: "tabset",
    templateUrl: function(s, t) {
      return t.templateUrl || "uib/template/tabs/tabset.html";
    },
    link: function(s, t, e) {
      s.vertical = angular.isDefined(e.vertical) ? s.$parent.$eval(e.vertical) : !1, s.justified = angular.isDefined(e.justified) ? s.$parent.$eval(e.justified) : !1;
    }
  };
}).directive("uibTab", ["$parse", function(s) {
  return {
    require: "^uibTabset",
    replace: !0,
    templateUrl: function(t, e) {
      return e.templateUrl || "uib/template/tabs/tab.html";
    },
    transclude: !0,
    scope: {
      heading: "@",
      index: "=?",
      classes: "@?",
      onSelect: "&select",
      //This callback is called in contentHeadingTransclude
      //once it inserts the tab's content into the dom
      onDeselect: "&deselect"
    },
    controller: function() {
    },
    controllerAs: "tab",
    link: function(t, e, a, n, i) {
      t.disabled = !1, a.disable && t.$parent.$watch(s(a.disable), function(r) {
        t.disabled = !!r;
      }), angular.isUndefined(a.index) && (n.tabs && n.tabs.length ? t.index = Math.max.apply(null, n.tabs.map(function(r) {
        return r.index;
      })) + 1 : t.index = 0), angular.isUndefined(a.classes) && (t.classes = ""), t.select = function(r) {
        if (!t.disabled) {
          for (var l, o = 0; o < n.tabs.length; o++)
            if (n.tabs[o].tab === t) {
              l = o;
              break;
            }
          n.select(l, r);
        }
      }, n.addTab(t), t.$on("$destroy", function() {
        n.removeTab(t);
      }), t.$transcludeFn = i;
    }
  };
}]).directive("uibTabHeadingTransclude", function() {
  return {
    restrict: "A",
    require: "^uibTab",
    link: function(s, t) {
      s.$watch("headingElement", function(a) {
        a && (t.html(""), t.append(a));
      });
    }
  };
}).directive("uibTabContentTransclude", function() {
  return {
    restrict: "A",
    require: "^uibTabset",
    link: function(t, e, a) {
      var n = t.$eval(a.uibTabContentTransclude).tab;
      n.$transcludeFn(n.$parent, function(i) {
        angular.forEach(i, function(r) {
          s(r) ? n.headingElement = r : e.append(r);
        });
      });
    }
  };
  function s(t) {
    return t.tagName && (t.hasAttribute("uib-tab-heading") || t.hasAttribute("data-uib-tab-heading") || t.hasAttribute("x-uib-tab-heading") || t.tagName.toLowerCase() === "uib-tab-heading" || t.tagName.toLowerCase() === "data-uib-tab-heading" || t.tagName.toLowerCase() === "x-uib-tab-heading" || t.tagName.toLowerCase() === "uib:tab-heading");
  }
});
angular.module("ui.bootstrap.timepicker", []).constant("uibTimepickerConfig", {
  hourStep: 1,
  minuteStep: 1,
  secondStep: 1,
  showMeridian: !0,
  showSeconds: !1,
  meridians: null,
  readonlyInput: !1,
  mousewheel: !0,
  arrowkeys: !0,
  showSpinners: !0,
  templateUrl: "uib/template/timepicker/timepicker.html"
}).controller("UibTimepickerController", ["$scope", "$element", "$attrs", "$parse", "$log", "$locale", "uibTimepickerConfig", function(s, t, e, a, n, i, r) {
  var l, o, c, d = /* @__PURE__ */ new Date(), p = [], h = { $setViewValue: angular.noop }, g = angular.isDefined(e.meridians) ? s.$parent.$eval(e.meridians) : r.meridians || i.DATETIME_FORMATS.AMPMS, x = angular.isDefined(e.padHours) ? s.$parent.$eval(e.padHours) : !0;
  s.tabindex = angular.isDefined(e.tabindex) ? e.tabindex : 0, t.removeAttr("tabindex"), this.init = function(M, W) {
    h = M, h.$render = this.render, h.$formatters.unshift(function(tt) {
      return tt ? new Date(tt) : null;
    });
    var J = W.eq(0), vt = W.eq(1), St = W.eq(2);
    l = J.controller("ngModel"), o = vt.controller("ngModel"), c = St.controller("ngModel");
    var zt = angular.isDefined(e.mousewheel) ? s.$parent.$eval(e.mousewheel) : r.mousewheel;
    zt && this.setupMousewheelEvents(J, vt, St);
    var j = angular.isDefined(e.arrowkeys) ? s.$parent.$eval(e.arrowkeys) : r.arrowkeys;
    j && this.setupArrowkeyEvents(J, vt, St), s.readonlyInput = angular.isDefined(e.readonlyInput) ? s.$parent.$eval(e.readonlyInput) : r.readonlyInput, this.setupInputEvents(J, vt, St);
  };
  var b = r.hourStep;
  e.hourStep && p.push(s.$parent.$watch(a(e.hourStep), function(M) {
    b = +M;
  }));
  var A = r.minuteStep;
  e.minuteStep && p.push(s.$parent.$watch(a(e.minuteStep), function(M) {
    A = +M;
  }));
  var T;
  p.push(s.$parent.$watch(a(e.min), function(M) {
    var W = new Date(M);
    T = isNaN(W) ? void 0 : W;
  }));
  var R;
  p.push(s.$parent.$watch(a(e.max), function(M) {
    var W = new Date(M);
    R = isNaN(W) ? void 0 : W;
  }));
  var C = !1;
  e.ngDisabled && p.push(s.$parent.$watch(a(e.ngDisabled), function(M) {
    C = M;
  })), s.noIncrementHours = function() {
    var M = et(d, b * 60);
    return C || M > R || M < d && M < T;
  }, s.noDecrementHours = function() {
    var M = et(d, -b * 60);
    return C || M < T || M > d && M > R;
  }, s.noIncrementMinutes = function() {
    var M = et(d, A);
    return C || M > R || M < d && M < T;
  }, s.noDecrementMinutes = function() {
    var M = et(d, -A);
    return C || M < T || M > d && M > R;
  }, s.noIncrementSeconds = function() {
    var M = rt(d, v);
    return C || M > R || M < d && M < T;
  }, s.noDecrementSeconds = function() {
    var M = rt(d, -v);
    return C || M < T || M > d && M > R;
  }, s.noToggleMeridian = function() {
    return d.getHours() < 12 ? C || et(d, 12 * 60) > R : C || et(d, -12 * 60) < T;
  };
  var v = r.secondStep;
  e.secondStep && p.push(s.$parent.$watch(a(e.secondStep), function(M) {
    v = +M;
  })), s.showSeconds = r.showSeconds, e.showSeconds && p.push(s.$parent.$watch(a(e.showSeconds), function(M) {
    s.showSeconds = !!M;
  })), s.showMeridian = r.showMeridian, e.showMeridian && p.push(s.$parent.$watch(a(e.showMeridian), function(M) {
    if (s.showMeridian = !!M, h.$error.time) {
      var W = P(), J = O();
      angular.isDefined(W) && angular.isDefined(J) && (d.setHours(W), F());
    } else
      Q();
  }));
  function P() {
    var M = +s.hours, W = s.showMeridian ? M > 0 && M < 13 : M >= 0 && M < 24;
    if (!(!W || s.hours === ""))
      return s.showMeridian && (M === 12 && (M = 0), s.meridian === g[1] && (M = M + 12)), M;
  }
  function O() {
    var M = +s.minutes, W = M >= 0 && M < 60;
    if (!(!W || s.minutes === ""))
      return M;
  }
  function N() {
    var M = +s.seconds;
    return M >= 0 && M < 60 ? M : void 0;
  }
  function H(M, W) {
    return M === null ? "" : angular.isDefined(M) && M.toString().length < 2 && !W ? "0" + M : M.toString();
  }
  this.setupMousewheelEvents = function(M, W, J) {
    var vt = function(St) {
      St.originalEvent && (St = St.originalEvent);
      var zt = St.wheelDelta ? St.wheelDelta : -St.deltaY;
      return St.detail || zt > 0;
    };
    M.on("mousewheel wheel", function(St) {
      C || s.$apply(vt(St) ? s.incrementHours() : s.decrementHours()), St.preventDefault();
    }), W.on("mousewheel wheel", function(St) {
      C || s.$apply(vt(St) ? s.incrementMinutes() : s.decrementMinutes()), St.preventDefault();
    }), J.on("mousewheel wheel", function(St) {
      C || s.$apply(vt(St) ? s.incrementSeconds() : s.decrementSeconds()), St.preventDefault();
    });
  }, this.setupArrowkeyEvents = function(M, W, J) {
    M.on("keydown", function(vt) {
      C || (vt.which === 38 ? (vt.preventDefault(), s.incrementHours(), s.$apply()) : vt.which === 40 && (vt.preventDefault(), s.decrementHours(), s.$apply()));
    }), W.on("keydown", function(vt) {
      C || (vt.which === 38 ? (vt.preventDefault(), s.incrementMinutes(), s.$apply()) : vt.which === 40 && (vt.preventDefault(), s.decrementMinutes(), s.$apply()));
    }), J.on("keydown", function(vt) {
      C || (vt.which === 38 ? (vt.preventDefault(), s.incrementSeconds(), s.$apply()) : vt.which === 40 && (vt.preventDefault(), s.decrementSeconds(), s.$apply()));
    });
  }, this.setupInputEvents = function(M, W, J) {
    if (s.readonlyInput) {
      s.updateHours = angular.noop, s.updateMinutes = angular.noop, s.updateSeconds = angular.noop;
      return;
    }
    var vt = function(St, zt, j) {
      h.$setViewValue(null), h.$setValidity("time", !1), angular.isDefined(St) && (s.invalidHours = St, l && l.$setValidity("hours", !1)), angular.isDefined(zt) && (s.invalidMinutes = zt, o && o.$setValidity("minutes", !1)), angular.isDefined(j) && (s.invalidSeconds = j, c && c.$setValidity("seconds", !1));
    };
    s.updateHours = function() {
      var St = P(), zt = O();
      h.$setDirty(), angular.isDefined(St) && angular.isDefined(zt) ? (d.setHours(St), d.setMinutes(zt), d < T || d > R ? vt(!0) : F("h")) : vt(!0);
    }, M.on("blur", function(St) {
      h.$setTouched(), U() ? B() : s.hours === null || s.hours === "" ? vt(!0) : !s.invalidHours && s.hours < 10 && s.$apply(function() {
        s.hours = H(s.hours, !x);
      });
    }), s.updateMinutes = function() {
      var St = O(), zt = P();
      h.$setDirty(), angular.isDefined(St) && angular.isDefined(zt) ? (d.setHours(zt), d.setMinutes(St), d < T || d > R ? vt(void 0, !0) : F("m")) : vt(void 0, !0);
    }, W.on("blur", function(St) {
      h.$setTouched(), U() ? B() : s.minutes === null ? vt(void 0, !0) : !s.invalidMinutes && s.minutes < 10 && s.$apply(function() {
        s.minutes = H(s.minutes);
      });
    }), s.updateSeconds = function() {
      var St = N();
      h.$setDirty(), angular.isDefined(St) ? (d.setSeconds(St), F("s")) : vt(void 0, void 0, !0);
    }, J.on("blur", function(St) {
      U() ? B() : !s.invalidSeconds && s.seconds < 10 && s.$apply(function() {
        s.seconds = H(s.seconds);
      });
    });
  }, this.render = function() {
    var M = h.$viewValue;
    isNaN(M) ? (h.$setValidity("time", !1), n.error('Timepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.')) : (M && (d = M), d < T || d > R ? (h.$setValidity("time", !1), s.invalidHours = !0, s.invalidMinutes = !0) : B(), Q());
  };
  function F(M) {
    B(), h.$setViewValue(new Date(d)), Q(M);
  }
  function B() {
    l && l.$setValidity("hours", !0), o && o.$setValidity("minutes", !0), c && c.$setValidity("seconds", !0), h.$setValidity("time", !0), s.invalidHours = !1, s.invalidMinutes = !1, s.invalidSeconds = !1;
  }
  function Q(M) {
    if (!h.$modelValue)
      s.hours = null, s.minutes = null, s.seconds = null, s.meridian = g[0];
    else {
      var W = d.getHours(), J = d.getMinutes(), vt = d.getSeconds();
      s.showMeridian && (W = W === 0 || W === 12 ? 12 : W % 12), s.hours = M === "h" ? W : H(W, !x), M !== "m" && (s.minutes = H(J)), s.meridian = d.getHours() < 12 ? g[0] : g[1], M !== "s" && (s.seconds = H(vt)), s.meridian = d.getHours() < 12 ? g[0] : g[1];
    }
  }
  function it(M) {
    d = rt(d, M), F();
  }
  function et(M, W) {
    return rt(M, W * 60);
  }
  function rt(M, W) {
    var J = new Date(M.getTime() + W * 1e3), vt = new Date(M);
    return vt.setHours(J.getHours(), J.getMinutes(), J.getSeconds()), vt;
  }
  function U() {
    return (s.hours === null || s.hours === "") && (s.minutes === null || s.minutes === "") && (!s.showSeconds || s.showSeconds && (s.seconds === null || s.seconds === ""));
  }
  s.showSpinners = angular.isDefined(e.showSpinners) ? s.$parent.$eval(e.showSpinners) : r.showSpinners, s.incrementHours = function() {
    s.noIncrementHours() || it(b * 60 * 60);
  }, s.decrementHours = function() {
    s.noDecrementHours() || it(-b * 60 * 60);
  }, s.incrementMinutes = function() {
    s.noIncrementMinutes() || it(A * 60);
  }, s.decrementMinutes = function() {
    s.noDecrementMinutes() || it(-A * 60);
  }, s.incrementSeconds = function() {
    s.noIncrementSeconds() || it(v);
  }, s.decrementSeconds = function() {
    s.noDecrementSeconds() || it(-v);
  }, s.toggleMeridian = function() {
    var M = O(), W = P();
    s.noToggleMeridian() || (angular.isDefined(M) && angular.isDefined(W) ? it(12 * 60 * (d.getHours() < 12 ? 60 : -60)) : s.meridian = s.meridian === g[0] ? g[1] : g[0]);
  }, s.blur = function() {
    h.$setTouched();
  }, s.$on("$destroy", function() {
    for (; p.length; )
      p.shift()();
  });
}]).directive("uibTimepicker", ["uibTimepickerConfig", function(s) {
  return {
    require: ["uibTimepicker", "?^ngModel"],
    restrict: "A",
    controller: "UibTimepickerController",
    controllerAs: "timepicker",
    scope: {},
    templateUrl: function(t, e) {
      return e.templateUrl || s.templateUrl;
    },
    link: function(t, e, a, n) {
      var i = n[0], r = n[1];
      r && i.init(r, e.find("input"));
    }
  };
}]);
angular.module("ui.bootstrap.typeahead", ["ui.bootstrap.debounce", "ui.bootstrap.position"]).factory("uibTypeaheadParser", ["$parse", function(s) {
  var t = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+([\s\S]+?)$/;
  return {
    parse: function(e) {
      var a = e.match(t);
      if (!a)
        throw new Error(
          'Expected typeahead specification in form of "_modelValue_ (as _label_)? for _item_ in _collection_" but got "' + e + '".'
        );
      return {
        itemName: a[3],
        source: s(a[4]),
        viewMapper: s(a[2] || a[1]),
        modelMapper: s(a[1])
      };
    }
  };
}]).controller("UibTypeaheadController", [
  "$scope",
  "$element",
  "$attrs",
  "$compile",
  "$parse",
  "$q",
  "$timeout",
  "$document",
  "$window",
  "$rootScope",
  "$$debounce",
  "$uibPosition",
  "uibTypeaheadParser",
  function(s, t, e, a, n, i, r, l, o, c, d, p, h) {
    var g = [9, 13, 27, 38, 40], x = 200, b, A, T = s.$eval(e.typeaheadMinLength);
    !T && T !== 0 && (T = 1), s.$watch(e.typeaheadMinLength, function(Ht) {
      T = !Ht && Ht !== 0 ? 1 : Ht;
    });
    var R = s.$eval(e.typeaheadWaitMs) || 0, C = s.$eval(e.typeaheadEditable) !== !1;
    s.$watch(e.typeaheadEditable, function(Ht) {
      C = Ht !== !1;
    });
    var v = n(e.typeaheadLoading).assign || angular.noop, P = e.typeaheadShouldSelect ? n(e.typeaheadShouldSelect) : function(Ht, oe) {
      var Ye = oe.$event;
      return Ye.which === 13 || Ye.which === 9;
    }, O = n(e.typeaheadOnSelect), N = angular.isDefined(e.typeaheadSelectOnBlur) ? s.$eval(e.typeaheadSelectOnBlur) : !1, H = n(e.typeaheadNoResults).assign || angular.noop, F = e.typeaheadInputFormatter ? n(e.typeaheadInputFormatter) : void 0, B = e.typeaheadAppendToBody ? s.$eval(e.typeaheadAppendToBody) : !1, Q = e.typeaheadAppendTo ? s.$eval(e.typeaheadAppendTo) : null, it = s.$eval(e.typeaheadFocusFirst) !== !1, et = e.typeaheadSelectOnExact ? s.$eval(e.typeaheadSelectOnExact) : !1, rt = n(e.typeaheadIsOpen).assign || angular.noop, U = s.$eval(e.typeaheadShowHint) || !1, M = n(e.ngModel), W = n(e.ngModel + "($$$p)"), J = function(Ht, oe) {
      return angular.isFunction(M(s)) && A.getOption("getterSetter") ? W(Ht, { $$$p: oe }) : M.assign(Ht, oe);
    }, vt = h.parse(e.uibTypeahead), St, zt, j = s.$new(), tt = s.$on("$destroy", function() {
      j.$destroy();
    });
    j.$on("$destroy", tt);
    var lt = "typeahead-" + j.$id + "-" + Math.floor(Math.random() * 1e4);
    t.attr({
      "aria-autocomplete": "list",
      "aria-expanded": !1,
      "aria-owns": lt
    });
    var at, nt;
    U && (at = angular.element("<div></div>"), at.css("position", "relative"), t.after(at), nt = t.clone(), nt.attr("placeholder", ""), nt.attr("tabindex", "-1"), nt.val(""), nt.css({
      position: "absolute",
      top: "0px",
      left: "0px",
      "border-color": "transparent",
      "box-shadow": "none",
      opacity: 1,
      background: "none 0% 0% / auto repeat scroll padding-box border-box rgb(255, 255, 255)",
      color: "#999"
    }), t.css({
      position: "relative",
      "vertical-align": "top",
      "background-color": "transparent"
    }), nt.attr("id") && nt.removeAttr("id"), at.append(nt), nt.after(t));
    var yt = angular.element("<div uib-typeahead-popup></div>");
    yt.attr({
      id: lt,
      matches: "matches",
      active: "activeIdx",
      select: "select(activeIdx, evt)",
      "move-in-progress": "moveInProgress",
      query: "query",
      position: "position",
      "assign-is-open": "assignIsOpen(isOpen)",
      debounce: "debounceUpdate"
    }), angular.isDefined(e.typeaheadTemplateUrl) && yt.attr("template-url", e.typeaheadTemplateUrl), angular.isDefined(e.typeaheadPopupTemplateUrl) && yt.attr("popup-template-url", e.typeaheadPopupTemplateUrl);
    var Rt = function() {
      U && nt.val("");
    }, Yt = function() {
      j.matches = [], j.activeIdx = -1, t.attr("aria-expanded", !1), Rt();
    }, K = function(Ht) {
      return lt + "-option-" + Ht;
    };
    j.$watch("activeIdx", function(Ht) {
      Ht < 0 ? t.removeAttr("aria-activedescendant") : t.attr("aria-activedescendant", K(Ht));
    });
    var _ = function(Ht, oe) {
      return j.matches.length > oe && Ht ? Ht.toUpperCase() === j.matches[oe].label.toUpperCase() : !1;
    }, V = function(Ht, oe) {
      var Ye = { $viewValue: Ht };
      v(s, !0), H(s, !1), i.when(vt.source(s, Ye)).then(function(ze) {
        var Lt = Ht === b.$viewValue;
        if (Lt && St)
          if (ze && ze.length > 0) {
            j.activeIdx = it ? 0 : -1, H(s, !1), j.matches.length = 0;
            for (var ye = 0; ye < ze.length; ye++)
              Ye[vt.itemName] = ze[ye], j.matches.push({
                id: K(ye),
                label: vt.viewMapper(j, Ye),
                model: ze[ye]
              });
            if (j.query = Ht, ht(), t.attr("aria-expanded", !0), et && j.matches.length === 1 && _(Ht, 0) && (angular.isNumber(j.debounceUpdate) || angular.isObject(j.debounceUpdate) ? d(function() {
              j.select(0, oe);
            }, angular.isNumber(j.debounceUpdate) ? j.debounceUpdate : j.debounceUpdate.default) : j.select(0, oe)), U) {
              var ue = j.matches[0].label;
              angular.isString(Ht) && Ht.length > 0 && ue.slice(0, Ht.length).toUpperCase() === Ht.toUpperCase() ? nt.val(Ht + ue.slice(Ht.length)) : nt.val("");
            }
          } else
            Yt(), H(s, !0);
        Lt && v(s, !1);
      }, function() {
        Yt(), v(s, !1), H(s, !0);
      });
    };
    B && (angular.element(o).on("resize", dt), l.find("body").on("scroll", dt));
    var G = d(function() {
      j.matches.length && ht(), j.moveInProgress = !1;
    }, x);
    j.moveInProgress = !1;
    function dt() {
      j.moveInProgress || (j.moveInProgress = !0, j.$digest()), G();
    }
    function ht() {
      j.position = B ? p.offset(t) : p.position(t), j.position.top += t.prop("offsetHeight");
    }
    j.query = void 0;
    var ot, $t = function(Ht) {
      ot = r(function() {
        V(Ht);
      }, R);
    }, _t = function() {
      ot && r.cancel(ot);
    };
    Yt(), j.assignIsOpen = function(Ht) {
      rt(s, Ht);
    }, j.select = function(Ht, oe) {
      var Ye = {}, ze, Lt;
      zt = !0, Ye[vt.itemName] = Lt = j.matches[Ht].model, ze = vt.modelMapper(s, Ye), J(s, ze), b.$setValidity("editable", !0), b.$setValidity("parse", !0), O(s, {
        $item: Lt,
        $model: ze,
        $label: vt.viewMapper(s, Ye),
        $event: oe
      }), Yt(), j.$eval(e.typeaheadFocusOnSelect) !== !1 && r(function() {
        t[0].focus();
      }, 0, !1);
    }, t.on("keydown", function(Ht) {
      if (!(j.matches.length === 0 || g.indexOf(Ht.which) === -1)) {
        var oe = P(s, { $event: Ht });
        if (j.activeIdx === -1 && oe || Ht.which === 9 && Ht.shiftKey) {
          Yt(), j.$digest();
          return;
        }
        Ht.preventDefault();
        var Ye;
        switch (Ht.which) {
          case 27:
            Ht.stopPropagation(), Yt(), s.$digest();
            break;
          case 38:
            j.activeIdx = (j.activeIdx > 0 ? j.activeIdx : j.matches.length) - 1, j.$digest(), Ye = yt[0].querySelectorAll(".uib-typeahead-match")[j.activeIdx], Ye.parentNode.scrollTop = Ye.offsetTop;
            break;
          case 40:
            j.activeIdx = (j.activeIdx + 1) % j.matches.length, j.$digest(), Ye = yt[0].querySelectorAll(".uib-typeahead-match")[j.activeIdx], Ye.parentNode.scrollTop = Ye.offsetTop;
            break;
          default:
            oe && j.$apply(function() {
              angular.isNumber(j.debounceUpdate) || angular.isObject(j.debounceUpdate) ? d(function() {
                j.select(j.activeIdx, Ht);
              }, angular.isNumber(j.debounceUpdate) ? j.debounceUpdate : j.debounceUpdate.default) : j.select(j.activeIdx, Ht);
            });
        }
      }
    }), t.on("focus", function(Ht) {
      St = !0, T === 0 && !b.$viewValue && r(function() {
        V(b.$viewValue, Ht);
      }, 0);
    }), t.on("blur", function(Ht) {
      N && j.matches.length && j.activeIdx !== -1 && !zt && (zt = !0, j.$apply(function() {
        angular.isObject(j.debounceUpdate) && angular.isNumber(j.debounceUpdate.blur) ? d(function() {
          j.select(j.activeIdx, Ht);
        }, j.debounceUpdate.blur) : j.select(j.activeIdx, Ht);
      })), !C && b.$error.editable && (b.$setViewValue(), j.$apply(function() {
        b.$setValidity("editable", !0), b.$setValidity("parse", !0);
      }), t.val("")), St = !1, zt = !1;
    });
    var qt = function(Ht) {
      t[0] !== Ht.target && Ht.which !== 3 && j.matches.length !== 0 && (Yt(), c.$$phase || s.$digest());
    };
    l.on("click", qt), s.$on("$destroy", function() {
      l.off("click", qt), (B || Q) && de.remove(), B && (angular.element(o).off("resize", dt), l.find("body").off("scroll", dt)), yt.remove(), U && at.remove();
    });
    var de = a(yt)(j);
    B ? l.find("body").append(de) : Q ? angular.element(Q).eq(0).append(de) : t.after(de), this.init = function(Ht) {
      b = Ht, A = me(b), j.debounceUpdate = n(A.getOption("debounce"))(s), b.$parsers.unshift(function(oe) {
        if (St = !0, T === 0 || oe && oe.length >= T ? R > 0 ? (_t(), $t(oe)) : V(oe) : (v(s, !1), _t(), Yt()), C)
          return oe;
        if (!oe)
          return b.$setValidity("editable", !0), null;
        b.$setValidity("editable", !1);
      }), b.$formatters.push(function(oe) {
        var Ye, ze, Lt = {};
        return C || b.$setValidity("editable", !0), F ? (Lt.$model = oe, F(s, Lt)) : (Lt[vt.itemName] = oe, Ye = vt.viewMapper(s, Lt), Lt[vt.itemName] = void 0, ze = vt.viewMapper(s, Lt), Ye !== ze ? Ye : oe);
      });
    };
    function me(Ht) {
      var oe;
      return angular.version.minor < 6 ? (oe = Ht.$options || {}, oe.getOption = function(Ye) {
        return oe[Ye];
      }) : oe = Ht.$options, oe;
    }
  }
]).directive("uibTypeahead", function() {
  return {
    controller: "UibTypeaheadController",
    require: ["ngModel", "uibTypeahead"],
    link: function(s, t, e, a) {
      a[1].init(a[0]);
    }
  };
}).directive("uibTypeaheadPopup", ["$$debounce", function(s) {
  return {
    scope: {
      matches: "=",
      query: "=",
      active: "=",
      position: "&",
      moveInProgress: "=",
      select: "&",
      assignIsOpen: "&",
      debounce: "&"
    },
    replace: !0,
    templateUrl: function(t, e) {
      return e.popupTemplateUrl || "uib/template/typeahead/typeahead-popup.html";
    },
    link: function(t, e, a) {
      t.templateUrl = a.templateUrl, t.isOpen = function() {
        var n = t.matches.length > 0;
        return t.assignIsOpen({ isOpen: n }), n;
      }, t.isActive = function(n) {
        return t.active === n;
      }, t.selectActive = function(n) {
        t.active = n;
      }, t.selectMatch = function(n, i) {
        var r = t.debounce();
        angular.isNumber(r) || angular.isObject(r) ? s(function() {
          t.select({ activeIdx: n, evt: i });
        }, angular.isNumber(r) ? r : r.default) : t.select({ activeIdx: n, evt: i });
      };
    }
  };
}]).directive("uibTypeaheadMatch", ["$templateRequest", "$compile", "$parse", function(s, t, e) {
  return {
    scope: {
      index: "=",
      match: "=",
      query: "="
    },
    link: function(a, n, i) {
      var r = e(i.templateUrl)(a.$parent) || "uib/template/typeahead/typeahead-match.html";
      s(r).then(function(l) {
        var o = angular.element(l.trim());
        n.replaceWith(o), t(o)(a);
      });
    }
  };
}]).filter("uibTypeaheadHighlight", ["$sce", "$injector", "$log", function(s, t, e) {
  var a;
  a = t.has("$sanitize");
  function n(r) {
    return r.replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1");
  }
  function i(r) {
    return /<.*>/g.test(r);
  }
  return function(r, l) {
    return !a && i(r) && e.warn("Unsafe use of typeahead please use ngSanitize"), r = l ? ("" + r).replace(new RegExp(n(l), "gi"), "<strong>$&</strong>") : r, a || (r = s.trustAsHtml(r)), r;
  };
}]);
angular.module("uib/template/accordion/accordion-group.html", []).run(["$templateCache", function(s) {
  s.put(
    "uib/template/accordion/accordion-group.html",
    `<div role="tab" id="{{::headingId}}" aria-selected="{{isOpen}}" class="panel-heading" ng-keypress="toggleOpen($event)">
  <h4 class="panel-title">
    <a role="button" data-toggle="collapse" href aria-expanded="{{isOpen}}" aria-controls="{{::panelId}}" tabindex="0" class="accordion-toggle" ng-click="toggleOpen()" uib-accordion-transclude="heading" ng-disabled="isDisabled" uib-tabindex-toggle><span uib-accordion-header ng-class="{'text-muted': isDisabled}">{{heading}}</span></a>
  </h4>
</div>
<div id="{{::panelId}}" aria-labelledby="{{::headingId}}" aria-hidden="{{!isOpen}}" role="tabpanel" class="panel-collapse collapse" uib-collapse="!isOpen">
  <div class="panel-body" ng-transclude></div>
</div>
`
  );
}]);
angular.module("uib/template/accordion/accordion.html", []).run(["$templateCache", function(s) {
  s.put(
    "uib/template/accordion/accordion.html",
    '<div role="tablist" class="panel-group" ng-transclude></div>'
  );
}]);
angular.module("uib/template/alert/alert.html", []).run(["$templateCache", function(s) {
  s.put(
    "uib/template/alert/alert.html",
    `<button ng-show="closeable" type="button" class="close" ng-click="close({$event: $event})">
  <span aria-hidden="true">&times;</span>
  <span class="sr-only">Close</span>
</button>
<div ng-transclude></div>
`
  );
}]);
angular.module("uib/template/carousel/carousel.html", []).run(["$templateCache", function(s) {
  s.put(
    "uib/template/carousel/carousel.html",
    `<div class="carousel-inner" ng-transclude></div>
<a role="button" href class="left carousel-control" ng-click="prev()" ng-class="{ disabled: isPrevDisabled() }" ng-show="slides.length > 1">
  <span aria-hidden="true" class="glyphicon glyphicon-chevron-left"></span>
  <span class="sr-only">previous</span>
</a>
<a role="button" href class="right carousel-control" ng-click="next()" ng-class="{ disabled: isNextDisabled() }" ng-show="slides.length > 1">
  <span aria-hidden="true" class="glyphicon glyphicon-chevron-right"></span>
  <span class="sr-only">next</span>
</a>
<ol class="carousel-indicators" ng-show="slides.length > 1">
  <li ng-repeat="slide in slides | orderBy:indexOfSlide track by $index" ng-class="{ active: isActive(slide) }" ng-click="select(slide)">
    <span class="sr-only">slide {{ $index + 1 }} of {{ slides.length }}<span ng-if="isActive(slide)">, currently active</span></span>
  </li>
</ol>
`
  );
}]);
angular.module("uib/template/carousel/slide.html", []).run(["$templateCache", function(s) {
  s.put(
    "uib/template/carousel/slide.html",
    `<div class="text-center" ng-transclude></div>
`
  );
}]);
angular.module("uib/template/datepicker/datepicker.html", []).run(["$templateCache", function(s) {
  s.put(
    "uib/template/datepicker/datepicker.html",
    `<div ng-switch="datepickerMode">
  <div uib-daypicker ng-switch-when="day" tabindex="0" class="uib-daypicker"></div>
  <div uib-monthpicker ng-switch-when="month" tabindex="0" class="uib-monthpicker"></div>
  <div uib-yearpicker ng-switch-when="year" tabindex="0" class="uib-yearpicker"></div>
</div>
`
  );
}]);
angular.module("uib/template/datepicker/day.html", []).run(["$templateCache", function(s) {
  s.put(
    "uib/template/datepicker/day.html",
    `<table role="grid" aria-labelledby="{{::uniqueId}}-title" aria-activedescendant="{{activeDateId}}">
  <thead>
    <tr>
      <th><button type="button" class="btn btn-default btn-sm pull-left uib-left" ng-click="move(-1)" tabindex="-1"><i aria-hidden="true" class="glyphicon glyphicon-chevron-left"></i><span class="sr-only">previous</span></button></th>
      <th colspan="{{::5 + showWeeks}}"><button id="{{::uniqueId}}-title" role="heading" aria-live="assertive" aria-atomic="true" type="button" class="btn btn-default btn-sm uib-title" ng-click="toggleMode()" ng-disabled="datepickerMode === maxMode" tabindex="-1"><strong>{{title}}</strong></button></th>
      <th><button type="button" class="btn btn-default btn-sm pull-right uib-right" ng-click="move(1)" tabindex="-1"><i aria-hidden="true" class="glyphicon glyphicon-chevron-right"></i><span class="sr-only">next</span></button></th>
    </tr>
    <tr>
      <th ng-if="showWeeks" class="text-center"></th>
      <th ng-repeat="label in ::labels track by $index" class="text-center"><small aria-label="{{::label.full}}">{{::label.abbr}}</small></th>
    </tr>
  </thead>
  <tbody>
    <tr class="uib-weeks" ng-repeat="row in rows track by $index" role="row">
      <td ng-if="showWeeks" class="text-center h6"><em>{{ weekNumbers[$index] }}</em></td>
      <td ng-repeat="dt in row" class="uib-day text-center" role="gridcell"
        id="{{::dt.uid}}"
        ng-class="::dt.customClass">
        <button type="button" class="btn btn-default btn-sm"
          uib-is-class="
            'btn-info' for selectedDt,
            'active' for activeDt
            on dt"
          ng-click="select(dt.date)"
          ng-disabled="::dt.disabled"
          tabindex="-1"><span ng-class="::{'text-muted': dt.secondary, 'text-info': dt.current}">{{::dt.label}}</span></button>
      </td>
    </tr>
  </tbody>
</table>
`
  );
}]);
angular.module("uib/template/datepicker/month.html", []).run(["$templateCache", function(s) {
  s.put(
    "uib/template/datepicker/month.html",
    `<table role="grid" aria-labelledby="{{::uniqueId}}-title" aria-activedescendant="{{activeDateId}}">
  <thead>
    <tr>
      <th><button type="button" class="btn btn-default btn-sm pull-left uib-left" ng-click="move(-1)" tabindex="-1"><i aria-hidden="true" class="glyphicon glyphicon-chevron-left"></i><span class="sr-only">previous</span></button></th>
      <th colspan="{{::yearHeaderColspan}}"><button id="{{::uniqueId}}-title" role="heading" aria-live="assertive" aria-atomic="true" type="button" class="btn btn-default btn-sm uib-title" ng-click="toggleMode()" ng-disabled="datepickerMode === maxMode" tabindex="-1"><strong>{{title}}</strong></button></th>
      <th><button type="button" class="btn btn-default btn-sm pull-right uib-right" ng-click="move(1)" tabindex="-1"><i aria-hidden="true" class="glyphicon glyphicon-chevron-right"></i><span class="sr-only">next</span></i></button></th>
    </tr>
  </thead>
  <tbody>
    <tr class="uib-months" ng-repeat="row in rows track by $index" role="row">
      <td ng-repeat="dt in row" class="uib-month text-center" role="gridcell"
        id="{{::dt.uid}}"
        ng-class="::dt.customClass">
        <button type="button" class="btn btn-default"
          uib-is-class="
            'btn-info' for selectedDt,
            'active' for activeDt
            on dt"
          ng-click="select(dt.date)"
          ng-disabled="::dt.disabled"
          tabindex="-1"><span ng-class="::{'text-info': dt.current}">{{::dt.label}}</span></button>
      </td>
    </tr>
  </tbody>
</table>
`
  );
}]);
angular.module("uib/template/datepicker/popup.html", []).run(["$templateCache", function(s) {
  s.put(
    "uib/template/datepicker/popup.html",
    `<div>
  <ul class="uib-datepicker-popup dropdown-menu uib-position-measure" dropdown-nested ng-if="isOpen" ng-keydown="keydown($event)" ng-click="$event.stopPropagation()">
    <li ng-transclude></li>
    <li ng-if="showButtonBar" class="uib-button-bar">
      <span class="btn-group pull-left">
        <button type="button" class="btn btn-sm btn-info uib-datepicker-current" ng-click="select('today', $event)" ng-disabled="isDisabled('today')">{{ getText('current') }}</button>
        <button type="button" class="btn btn-sm btn-danger uib-clear" ng-click="select(null, $event)">{{ getText('clear') }}</button>
      </span>
      <button type="button" class="btn btn-sm btn-success pull-right uib-close" ng-click="close($event)">{{ getText('close') }}</button>
    </li>
  </ul>
</div>
`
  );
}]);
angular.module("uib/template/datepicker/year.html", []).run(["$templateCache", function(s) {
  s.put(
    "uib/template/datepicker/year.html",
    `<table role="grid" aria-labelledby="{{::uniqueId}}-title" aria-activedescendant="{{activeDateId}}">
  <thead>
    <tr>
      <th><button type="button" class="btn btn-default btn-sm pull-left uib-left" ng-click="move(-1)" tabindex="-1"><i aria-hidden="true" class="glyphicon glyphicon-chevron-left"></i><span class="sr-only">previous</span></button></th>
      <th colspan="{{::columns - 2}}"><button id="{{::uniqueId}}-title" role="heading" aria-live="assertive" aria-atomic="true" type="button" class="btn btn-default btn-sm uib-title" ng-click="toggleMode()" ng-disabled="datepickerMode === maxMode" tabindex="-1"><strong>{{title}}</strong></button></th>
      <th><button type="button" class="btn btn-default btn-sm pull-right uib-right" ng-click="move(1)" tabindex="-1"><i aria-hidden="true" class="glyphicon glyphicon-chevron-right"></i><span class="sr-only">next</span></button></th>
    </tr>
  </thead>
  <tbody>
    <tr class="uib-years" ng-repeat="row in rows track by $index" role="row">
      <td ng-repeat="dt in row" class="uib-year text-center" role="gridcell"
        id="{{::dt.uid}}"
        ng-class="::dt.customClass">
        <button type="button" class="btn btn-default"
          uib-is-class="
            'btn-info' for selectedDt,
            'active' for activeDt
            on dt"
          ng-click="select(dt.date)"
          ng-disabled="::dt.disabled"
          tabindex="-1"><span ng-class="::{'text-info': dt.current}">{{::dt.label}}</span></button>
      </td>
    </tr>
  </tbody>
</table>
`
  );
}]);
angular.module("uib/template/datepickerPopup/popup.html", []).run(["$templateCache", function(s) {
  s.put(
    "uib/template/datepickerPopup/popup.html",
    `<ul role="presentation" class="uib-datepicker-popup dropdown-menu uib-position-measure" dropdown-nested ng-if="isOpen" ng-keydown="keydown($event)" ng-click="$event.stopPropagation()">
  <li ng-transclude></li>
  <li ng-if="showButtonBar" class="uib-button-bar">
    <span class="btn-group pull-left">
      <button type="button" class="btn btn-sm btn-info uib-datepicker-current" ng-click="select('today', $event)" ng-disabled="isDisabled('today')">{{ getText('current') }}</button>
      <button type="button" class="btn btn-sm btn-danger uib-clear" ng-click="select(null, $event)">{{ getText('clear') }}</button>
    </span>
    <button type="button" class="btn btn-sm btn-success pull-right uib-close" ng-click="close($event)">{{ getText('close') }}</button>
  </li>
</ul>
`
  );
}]);
angular.module("uib/template/modal/backdrop.html", []).run(["$templateCache", function(s) {
  s.put(
    "uib/template/modal/backdrop.html",
    `<div class="modal-backdrop"
     uib-modal-animation-class="fade"
     modal-in-class="in"
     ng-style="{'z-index': 1040 + (index && 1 || 0) + index*10}"
></div>
`
  );
}]);
angular.module("uib/template/modal/window.html", []).run(["$templateCache", function(s) {
  s.put(
    "uib/template/modal/window.html",
    `<div class="modal-dialog {{size ? 'modal-' + size : ''}}"><div class="modal-content" uib-modal-transclude></div></div>
`
  );
}]);
angular.module("uib/template/pager/pager.html", []).run(["$templateCache", function(s) {
  s.put(
    "uib/template/pager/pager.html",
    `<li ng-class="{disabled: noPrevious()||ngDisabled, previous: align}"><a href ng-click="selectPage(page - 1, $event)" ng-disabled="noPrevious()||ngDisabled" uib-tabindex-toggle>{{::getText('previous')}}</a></li>
<li ng-class="{disabled: noNext()||ngDisabled, next: align}"><a href ng-click="selectPage(page + 1, $event)" ng-disabled="noNext()||ngDisabled" uib-tabindex-toggle>{{::getText('next')}}</a></li>
`
  );
}]);
angular.module("uib/template/pagination/pagination.html", []).run(["$templateCache", function(s) {
  s.put(
    "uib/template/pagination/pagination.html",
    `<li role="menuitem" ng-if="::boundaryLinks" ng-class="{disabled: noPrevious()||ngDisabled}" class="pagination-first"><a href ng-click="selectPage(1, $event)" ng-disabled="noPrevious()||ngDisabled" uib-tabindex-toggle>{{::getText('first')}}</a></li>
<li role="menuitem" ng-if="::directionLinks" ng-class="{disabled: noPrevious()||ngDisabled}" class="pagination-prev"><a href ng-click="selectPage(page - 1, $event)" ng-disabled="noPrevious()||ngDisabled" uib-tabindex-toggle>{{::getText('previous')}}</a></li>
<li role="menuitem" ng-repeat="page in pages track by $index" ng-class="{active: page.active,disabled: ngDisabled&&!page.active}" class="pagination-page"><a href ng-click="selectPage(page.number, $event)" ng-disabled="ngDisabled&&!page.active" uib-tabindex-toggle>{{page.text}}</a></li>
<li role="menuitem" ng-if="::directionLinks" ng-class="{disabled: noNext()||ngDisabled}" class="pagination-next"><a href ng-click="selectPage(page + 1, $event)" ng-disabled="noNext()||ngDisabled" uib-tabindex-toggle>{{::getText('next')}}</a></li>
<li role="menuitem" ng-if="::boundaryLinks" ng-class="{disabled: noNext()||ngDisabled}" class="pagination-last"><a href ng-click="selectPage(totalPages, $event)" ng-disabled="noNext()||ngDisabled" uib-tabindex-toggle>{{::getText('last')}}</a></li>
`
  );
}]);
angular.module("uib/template/tooltip/tooltip-html-popup.html", []).run(["$templateCache", function(s) {
  s.put(
    "uib/template/tooltip/tooltip-html-popup.html",
    `<div class="tooltip-arrow"></div>
<div class="tooltip-inner" ng-bind-html="contentExp()"></div>
`
  );
}]);
angular.module("uib/template/tooltip/tooltip-popup.html", []).run(["$templateCache", function(s) {
  s.put(
    "uib/template/tooltip/tooltip-popup.html",
    `<div class="tooltip-arrow"></div>
<div class="tooltip-inner" ng-bind="content"></div>
`
  );
}]);
angular.module("uib/template/tooltip/tooltip-template-popup.html", []).run(["$templateCache", function(s) {
  s.put(
    "uib/template/tooltip/tooltip-template-popup.html",
    `<div class="tooltip-arrow"></div>
<div class="tooltip-inner"
  uib-tooltip-template-transclude="contentExp()"
  tooltip-template-transclude-scope="originScope()"></div>
`
  );
}]);
angular.module("uib/template/popover/popover-html.html", []).run(["$templateCache", function(s) {
  s.put(
    "uib/template/popover/popover-html.html",
    `<div class="arrow"></div>

<div class="popover-inner">
    <h3 class="popover-title" ng-bind="uibTitle" ng-if="uibTitle"></h3>
    <div class="popover-content" ng-bind-html="contentExp()"></div>
</div>
`
  );
}]);
angular.module("uib/template/popover/popover-template.html", []).run(["$templateCache", function(s) {
  s.put(
    "uib/template/popover/popover-template.html",
    `<div class="arrow"></div>

<div class="popover-inner">
    <h3 class="popover-title" ng-bind="uibTitle" ng-if="uibTitle"></h3>
    <div class="popover-content"
      uib-tooltip-template-transclude="contentExp()"
      tooltip-template-transclude-scope="originScope()"></div>
</div>
`
  );
}]);
angular.module("uib/template/popover/popover.html", []).run(["$templateCache", function(s) {
  s.put(
    "uib/template/popover/popover.html",
    `<div class="arrow"></div>

<div class="popover-inner">
    <h3 class="popover-title" ng-bind="uibTitle" ng-if="uibTitle"></h3>
    <div class="popover-content" ng-bind="content"></div>
</div>
`
  );
}]);
angular.module("uib/template/progressbar/bar.html", []).run(["$templateCache", function(s) {
  s.put(
    "uib/template/progressbar/bar.html",
    `<div class="progress-bar" ng-class="type && 'progress-bar-' + type" role="progressbar" aria-valuenow="{{value}}" aria-valuemin="0" aria-valuemax="{{max}}" ng-style="{width: (percent < 100 ? percent : 100) + '%'}" aria-valuetext="{{percent | number:0}}%" aria-labelledby="{{::title}}" ng-transclude></div>
`
  );
}]);
angular.module("uib/template/progressbar/progress.html", []).run(["$templateCache", function(s) {
  s.put(
    "uib/template/progressbar/progress.html",
    '<div class="progress" ng-transclude aria-labelledby="{{::title}}"></div>'
  );
}]);
angular.module("uib/template/progressbar/progressbar.html", []).run(["$templateCache", function(s) {
  s.put(
    "uib/template/progressbar/progressbar.html",
    `<div class="progress">
  <div class="progress-bar" ng-class="type && 'progress-bar-' + type" role="progressbar" aria-valuenow="{{value}}" aria-valuemin="0" aria-valuemax="{{max}}" ng-style="{width: (percent < 100 ? percent : 100) + '%'}" aria-valuetext="{{percent | number:0}}%" aria-labelledby="{{::title}}" ng-transclude></div>
</div>
`
  );
}]);
angular.module("uib/template/rating/rating.html", []).run(["$templateCache", function(s) {
  s.put(
    "uib/template/rating/rating.html",
    `<span ng-mouseleave="reset()" ng-keydown="onKeydown($event)" tabindex="0" role="slider" aria-valuemin="0" aria-valuemax="{{range.length}}" aria-valuenow="{{value}}" aria-valuetext="{{title}}">
    <span ng-repeat-start="r in range track by $index" class="sr-only">({{ $index < value ? '*' : ' ' }})</span>
    <i ng-repeat-end ng-mouseenter="enter($index + 1)" ng-click="rate($index + 1)" class="glyphicon" ng-class="$index < value && (r.stateOn || 'glyphicon-star') || (r.stateOff || 'glyphicon-star-empty')" ng-attr-title="{{r.title}}"></i>
</span>
`
  );
}]);
angular.module("uib/template/tabs/tab.html", []).run(["$templateCache", function(s) {
  s.put(
    "uib/template/tabs/tab.html",
    `<li ng-class="[{active: active, disabled: disabled}, classes]" class="uib-tab nav-item">
  <a href ng-click="select($event)" class="nav-link" uib-tab-heading-transclude>{{heading}}</a>
</li>
`
  );
}]);
angular.module("uib/template/tabs/tabset.html", []).run(["$templateCache", function(s) {
  s.put(
    "uib/template/tabs/tabset.html",
    `<div>
  <ul class="nav nav-{{tabset.type || 'tabs'}}" ng-class="{'nav-stacked': vertical, 'nav-justified': justified}" ng-transclude></ul>
  <div class="tab-content">
    <div class="tab-pane"
         ng-repeat="tab in tabset.tabs"
         ng-class="{active: tabset.active === tab.index}"
         uib-tab-content-transclude="tab">
    </div>
  </div>
</div>
`
  );
}]);
angular.module("uib/template/timepicker/timepicker.html", []).run(["$templateCache", function(s) {
  s.put(
    "uib/template/timepicker/timepicker.html",
    `<table class="uib-timepicker">
  <tbody>
    <tr class="text-center" ng-show="::showSpinners">
      <td class="uib-increment hours"><a ng-click="incrementHours()" ng-class="{disabled: noIncrementHours()}" class="btn btn-link" ng-disabled="noIncrementHours()" tabindex="-1"><span class="glyphicon glyphicon-chevron-up"></span></a></td>
      <td>&nbsp;</td>
      <td class="uib-increment minutes"><a ng-click="incrementMinutes()" ng-class="{disabled: noIncrementMinutes()}" class="btn btn-link" ng-disabled="noIncrementMinutes()" tabindex="-1"><span class="glyphicon glyphicon-chevron-up"></span></a></td>
      <td ng-show="showSeconds">&nbsp;</td>
      <td ng-show="showSeconds" class="uib-increment seconds"><a ng-click="incrementSeconds()" ng-class="{disabled: noIncrementSeconds()}" class="btn btn-link" ng-disabled="noIncrementSeconds()" tabindex="-1"><span class="glyphicon glyphicon-chevron-up"></span></a></td>
      <td ng-show="showMeridian"></td>
    </tr>
    <tr>
      <td class="form-group uib-time hours" ng-class="{'has-error': invalidHours}">
        <input type="text" placeholder="HH" ng-model="hours" ng-change="updateHours()" class="form-control text-center" ng-readonly="::readonlyInput" maxlength="2" tabindex="{{::tabindex}}" ng-disabled="noIncrementHours()" ng-blur="blur()">
      </td>
      <td class="uib-separator">:</td>
      <td class="form-group uib-time minutes" ng-class="{'has-error': invalidMinutes}">
        <input type="text" placeholder="MM" ng-model="minutes" ng-change="updateMinutes()" class="form-control text-center" ng-readonly="::readonlyInput" maxlength="2" tabindex="{{::tabindex}}" ng-disabled="noIncrementMinutes()" ng-blur="blur()">
      </td>
      <td ng-show="showSeconds" class="uib-separator">:</td>
      <td class="form-group uib-time seconds" ng-class="{'has-error': invalidSeconds}" ng-show="showSeconds">
        <input type="text" placeholder="SS" ng-model="seconds" ng-change="updateSeconds()" class="form-control text-center" ng-readonly="readonlyInput" maxlength="2" tabindex="{{::tabindex}}" ng-disabled="noIncrementSeconds()" ng-blur="blur()">
      </td>
      <td ng-show="showMeridian" class="uib-time am-pm"><button type="button" ng-class="{disabled: noToggleMeridian()}" class="btn btn-default text-center" ng-click="toggleMeridian()" ng-disabled="noToggleMeridian()" tabindex="{{::tabindex}}">{{meridian}}</button></td>
    </tr>
    <tr class="text-center" ng-show="::showSpinners">
      <td class="uib-decrement hours"><a ng-click="decrementHours()" ng-class="{disabled: noDecrementHours()}" class="btn btn-link" ng-disabled="noDecrementHours()" tabindex="-1"><span class="glyphicon glyphicon-chevron-down"></span></a></td>
      <td>&nbsp;</td>
      <td class="uib-decrement minutes"><a ng-click="decrementMinutes()" ng-class="{disabled: noDecrementMinutes()}" class="btn btn-link" ng-disabled="noDecrementMinutes()" tabindex="-1"><span class="glyphicon glyphicon-chevron-down"></span></a></td>
      <td ng-show="showSeconds">&nbsp;</td>
      <td ng-show="showSeconds" class="uib-decrement seconds"><a ng-click="decrementSeconds()" ng-class="{disabled: noDecrementSeconds()}" class="btn btn-link" ng-disabled="noDecrementSeconds()" tabindex="-1"><span class="glyphicon glyphicon-chevron-down"></span></a></td>
      <td ng-show="showMeridian"></td>
    </tr>
  </tbody>
</table>
`
  );
}]);
angular.module("uib/template/typeahead/typeahead-match.html", []).run(["$templateCache", function(s) {
  s.put(
    "uib/template/typeahead/typeahead-match.html",
    `<a href
   tabindex="-1"
   ng-bind-html="match.label | uibTypeaheadHighlight:query"
   ng-attr-title="{{match.label}}"></a>
`
  );
}]);
angular.module("uib/template/typeahead/typeahead-popup.html", []).run(["$templateCache", function(s) {
  s.put(
    "uib/template/typeahead/typeahead-popup.html",
    `<ul class="dropdown-menu" ng-show="isOpen() && !moveInProgress" ng-style="{top: position().top+'px', left: position().left+'px'}" role="listbox" aria-hidden="{{!isOpen()}}">
    <li class="uib-typeahead-match" ng-repeat="match in matches track by $index" ng-class="{active: isActive($index) }" ng-mouseenter="selectActive($index)" ng-click="selectMatch($index, $event)" role="option" id="{{::match.id}}">
        <div uib-typeahead-match index="$index" match="match" query="query" template-url="templateUrl"></div>
    </li>
</ul>
`
  );
}]);
angular.module("ui.bootstrap.carousel").run(function() {
  !angular.$$csp().noInlineStyle && !angular.$$uibCarouselCss && angular.element(document).find("head").prepend('<style type="text/css">.ng-animate.item:not(.left):not(.right){-webkit-transition:0s ease-in-out left;transition:0s ease-in-out left}</style>'), angular.$$uibCarouselCss = !0;
});
angular.module("ui.bootstrap.datepicker").run(function() {
  !angular.$$csp().noInlineStyle && !angular.$$uibDatepickerCss && angular.element(document).find("head").prepend('<style type="text/css">.uib-datepicker .uib-title{width:100%;}.uib-day button,.uib-month button,.uib-year button{min-width:100%;}.uib-left,.uib-right{width:100%}</style>'), angular.$$uibDatepickerCss = !0;
});
angular.module("ui.bootstrap.position").run(function() {
  !angular.$$csp().noInlineStyle && !angular.$$uibPositionCss && angular.element(document).find("head").prepend('<style type="text/css">.uib-position-measure{display:block !important;visibility:hidden !important;position:absolute !important;top:-9999px !important;left:-9999px !important;}.uib-position-scrollbar-measure{position:absolute !important;top:-9999px !important;width:50px !important;height:50px !important;overflow:scroll !important;}.uib-position-body-scrollbar-measure{overflow:scroll !important;}</style>'), angular.$$uibPositionCss = !0;
});
angular.module("ui.bootstrap.datepickerPopup").run(function() {
  !angular.$$csp().noInlineStyle && !angular.$$uibDatepickerpopupCss && angular.element(document).find("head").prepend('<style type="text/css">.uib-datepicker-popup.dropdown-menu{display:block;float:none;margin:0;}.uib-button-bar{padding:10px 9px 2px;}</style>'), angular.$$uibDatepickerpopupCss = !0;
});
angular.module("ui.bootstrap.tooltip").run(function() {
  !angular.$$csp().noInlineStyle && !angular.$$uibTooltipCss && angular.element(document).find("head").prepend('<style type="text/css">[uib-tooltip-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-popup].tooltip.right-bottom > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.right-bottom > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.right-bottom > .tooltip-arrow,[uib-popover-popup].popover.top-left > .arrow,[uib-popover-popup].popover.top-right > .arrow,[uib-popover-popup].popover.bottom-left > .arrow,[uib-popover-popup].popover.bottom-right > .arrow,[uib-popover-popup].popover.left-top > .arrow,[uib-popover-popup].popover.left-bottom > .arrow,[uib-popover-popup].popover.right-top > .arrow,[uib-popover-popup].popover.right-bottom > .arrow,[uib-popover-html-popup].popover.top-left > .arrow,[uib-popover-html-popup].popover.top-right > .arrow,[uib-popover-html-popup].popover.bottom-left > .arrow,[uib-popover-html-popup].popover.bottom-right > .arrow,[uib-popover-html-popup].popover.left-top > .arrow,[uib-popover-html-popup].popover.left-bottom > .arrow,[uib-popover-html-popup].popover.right-top > .arrow,[uib-popover-html-popup].popover.right-bottom > .arrow,[uib-popover-template-popup].popover.top-left > .arrow,[uib-popover-template-popup].popover.top-right > .arrow,[uib-popover-template-popup].popover.bottom-left > .arrow,[uib-popover-template-popup].popover.bottom-right > .arrow,[uib-popover-template-popup].popover.left-top > .arrow,[uib-popover-template-popup].popover.left-bottom > .arrow,[uib-popover-template-popup].popover.right-top > .arrow,[uib-popover-template-popup].popover.right-bottom > .arrow{top:auto;bottom:auto;left:auto;right:auto;margin:0;}[uib-popover-popup].popover,[uib-popover-html-popup].popover,[uib-popover-template-popup].popover{display:block !important;}</style>'), angular.$$uibTooltipCss = !0;
});
angular.module("ui.bootstrap.timepicker").run(function() {
  !angular.$$csp().noInlineStyle && !angular.$$uibTimepickerCss && angular.element(document).find("head").prepend('<style type="text/css">.uib-time input{width:50px;}</style>'), angular.$$uibTimepickerCss = !0;
});
angular.module("ui.bootstrap.typeahead").run(function() {
  !angular.$$csp().noInlineStyle && !angular.$$uibTypeaheadCss && angular.element(document).find("head").prepend('<style type="text/css">[uib-typeahead-popup].dropdown-menu{display:block;}</style>'), angular.$$uibTypeaheadCss = !0;
});
var y9 = "ui.bootstrap";
const f9 = /* @__PURE__ */ Hs(y9);
/**
 * @license AngularJS v1.8.3
 * (c) 2010-2020 Google LLC. http://angularjs.org
 * License: MIT
 */
(function(s, t) {
  var e = t.$$minErr("$sanitize"), a, n, i, r, l, o, c, d, p, h;
  function g() {
    var b = !1, A = !1;
    this.$get = ["$$sanitizeUri", function(nt) {
      return b = !0, A && n(Q, F), function(yt) {
        var Rt = [];
        return p(yt, h(Rt, function(Yt, K) {
          return !/^unsafe:/.test(nt(Yt, K));
        })), Rt.join("");
      };
    }], this.enableSvg = function(nt) {
      return l(nt) ? (A = nt, this) : A;
    }, this.addValidElements = function(nt) {
      return b || (r(nt) && (nt = { htmlElements: nt }), J(F, nt.svgElements), J(C, nt.htmlVoidElements), J(Q, nt.htmlVoidElements), J(Q, nt.htmlElements)), this;
    }, this.addValidAttrs = function(nt) {
      return b || n(U, W(nt, !0)), this;
    }, a = t.bind, n = t.extend, i = t.forEach, r = t.isArray, l = t.isDefined, o = t.$$lowercase, c = t.noop, p = St, h = tt, d = s.Node.prototype.contains || /** @this */
    function(nt) {
      return !!(this.compareDocumentPosition(nt) & 16);
    };
    var T = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g, R = /([^#-~ |!])/g, C = M("area,br,col,hr,img,wbr"), v = M("colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr"), P = M("rp,rt"), O = n(
      {},
      P,
      v
    ), N = n({}, v, M("address,article,aside,blockquote,caption,center,del,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5,h6,header,hgroup,hr,ins,map,menu,nav,ol,pre,section,table,ul")), H = n({}, P, M("a,abbr,acronym,b,bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,q,ruby,rp,rt,s,samp,small,span,strike,strong,sub,sup,time,tt,u,var")), F = M("circle,defs,desc,ellipse,font-face,font-face-name,font-face-src,g,glyph,hkern,image,linearGradient,line,marker,metadata,missing-glyph,mpath,path,polygon,polyline,radialGradient,rect,stop,svg,switch,text,title,tspan"), B = M("script,style"), Q = n(
      {},
      C,
      N,
      H,
      O
    ), it = M("background,cite,href,longdesc,src,xlink:href,xml:base"), et = M("abbr,align,alt,axis,bgcolor,border,cellpadding,cellspacing,class,clear,color,cols,colspan,compact,coords,dir,face,headers,height,hreflang,hspace,ismap,lang,language,nohref,nowrap,rel,rev,rows,rowspan,rules,scope,scrolling,shape,size,span,start,summary,tabindex,target,title,type,valign,value,vspace,width"), rt = M("accent-height,accumulate,additive,alphabetic,arabic-form,ascent,baseProfile,bbox,begin,by,calcMode,cap-height,class,color,color-rendering,content,cx,cy,d,dx,dy,descent,display,dur,end,fill,fill-rule,font-family,font-size,font-stretch,font-style,font-variant,font-weight,from,fx,fy,g1,g2,glyph-name,gradientUnits,hanging,height,horiz-adv-x,horiz-origin-x,ideographic,k,keyPoints,keySplines,keyTimes,lang,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mathematical,max,min,offset,opacity,orient,origin,overline-position,overline-thickness,panose-1,path,pathLength,points,preserveAspectRatio,r,refX,refY,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,rotate,rx,ry,slope,stemh,stemv,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,systemLanguage,target,text-anchor,to,transform,type,u1,u2,underline-position,underline-thickness,unicode,unicode-range,units-per-em,values,version,viewBox,visibility,width,widths,x,x-height,x1,x2,xlink:actuate,xlink:arcrole,xlink:role,xlink:show,xlink:title,xlink:type,xml:base,xml:lang,xml:space,xmlns,xmlns:xlink,y,y1,y2,zoomAndPan", !0), U = n(
      {},
      it,
      rt,
      et
    );
    function M(nt, yt) {
      return W(nt.split(","), yt);
    }
    function W(nt, yt) {
      var Rt = {}, Yt;
      for (Yt = 0; Yt < nt.length; Yt++)
        Rt[yt ? o(nt[Yt]) : nt[Yt]] = !0;
      return Rt;
    }
    function J(nt, yt) {
      yt && yt.length && n(nt, W(yt));
    }
    var vt = function(nt, yt) {
      if (K())
        return _;
      if (!yt || !yt.implementation)
        throw e("noinert", "Can't create an inert html document");
      var Rt = yt.implementation.createHTMLDocument("inert"), Yt = (Rt.documentElement || Rt.getDocumentElement()).querySelector("body");
      return V;
      function K() {
        try {
          return !!_("");
        } catch {
          return !1;
        }
      }
      function _(G) {
        G = "<remove></remove>" + G;
        try {
          var dt = new nt.DOMParser().parseFromString(G, "text/html").body;
          return dt.firstChild.remove(), dt;
        } catch {
          return;
        }
      }
      function V(G) {
        return Yt.innerHTML = G, yt.documentMode && lt(Yt), Yt;
      }
    }(s, s.document);
    function St(nt, yt) {
      nt == null ? nt = "" : typeof nt != "string" && (nt = "" + nt);
      var Rt = vt(nt);
      if (!Rt)
        return "";
      var Yt = 5;
      do {
        if (Yt === 0)
          throw e("uinput", "Failed to sanitize html because the input is unstable");
        Yt--, nt = Rt.innerHTML, Rt = vt(nt);
      } while (nt !== Rt.innerHTML);
      for (var K = Rt.firstChild; K; ) {
        switch (K.nodeType) {
          case 1:
            yt.start(K.nodeName.toLowerCase(), zt(K.attributes));
            break;
          case 3:
            yt.chars(K.textContent);
            break;
        }
        var _;
        if (!(_ = K.firstChild) && (K.nodeType === 1 && yt.end(K.nodeName.toLowerCase()), _ = at("nextSibling", K), !_))
          for (; _ == null && (K = at("parentNode", K), K !== Rt); )
            _ = at("nextSibling", K), K.nodeType === 1 && yt.end(K.nodeName.toLowerCase());
        K = _;
      }
      for (; K = Rt.firstChild; )
        Rt.removeChild(K);
    }
    function zt(nt) {
      for (var yt = {}, Rt = 0, Yt = nt.length; Rt < Yt; Rt++) {
        var K = nt[Rt];
        yt[K.name] = K.value;
      }
      return yt;
    }
    function j(nt) {
      return nt.replace(/&/g, "&amp;").replace(T, function(yt) {
        var Rt = yt.charCodeAt(0), Yt = yt.charCodeAt(1);
        return "&#" + ((Rt - 55296) * 1024 + (Yt - 56320) + 65536) + ";";
      }).replace(R, function(yt) {
        return "&#" + yt.charCodeAt(0) + ";";
      }).replace(/</g, "&lt;").replace(/>/g, "&gt;");
    }
    function tt(nt, yt) {
      var Rt = !1, Yt = a(nt, nt.push);
      return {
        start: function(K, _) {
          K = o(K), !Rt && B[K] && (Rt = K), !Rt && Q[K] === !0 && (Yt("<"), Yt(K), i(_, function(V, G) {
            var dt = o(G), ht = K === "img" && dt === "src" || dt === "background";
            U[dt] === !0 && (it[dt] !== !0 || yt(V, ht)) && (Yt(" "), Yt(G), Yt('="'), Yt(j(V)), Yt('"'));
          }), Yt(">"));
        },
        end: function(K) {
          K = o(K), !Rt && Q[K] === !0 && C[K] !== !0 && (Yt("</"), Yt(K), Yt(">")), K == Rt && (Rt = !1);
        },
        chars: function(K) {
          Rt || Yt(j(K));
        }
      };
    }
    function lt(nt) {
      for (; nt; ) {
        if (nt.nodeType === s.Node.ELEMENT_NODE)
          for (var yt = nt.attributes, Rt = 0, Yt = yt.length; Rt < Yt; Rt++) {
            var K = yt[Rt], _ = K.name.toLowerCase();
            (_ === "xmlns:ns1" || _.lastIndexOf("ns1:", 0) === 0) && (nt.removeAttributeNode(K), Rt--, Yt--);
          }
        var V = nt.firstChild;
        V && lt(V), nt = at("nextSibling", nt);
      }
    }
    function at(nt, yt) {
      var Rt = yt[nt];
      if (Rt && d.call(yt, Rt))
        throw e("elclob", "Failed to sanitize html because the element is clobbered: {0}", yt.outerHTML || yt.outerText);
      return Rt;
    }
  }
  function x(b) {
    var A = [], T = h(A, c);
    return T.chars(b), A.join("");
  }
  t.module("ngSanitize", []).provider("$sanitize", g).info({ angularVersion: "1.8.3" }), t.module("ngSanitize").filter("linky", ["$sanitize", function(b) {
    var A = /((s?ftp|https?):\/\/|(www\.)|(mailto:)?[A-Za-z0-9._%+-]+@)\S*[^\s.;,(){}<>"\u201d\u2019]/i, T = /^mailto:/i, R = t.$$minErr("linky"), C = t.isDefined, v = t.isFunction, P = t.isObject, O = t.isString;
    return function(N, H, F) {
      if (N == null || N === "")
        return N;
      if (!O(N))
        throw R("notstring", "Expected string but received: {0}", N);
      for (var B = v(F) ? F : P(F) ? function() {
        return F;
      } : function() {
        return {};
      }, Q, it = N, et = [], rt, U; Q = it.match(A); )
        rt = Q[0], !Q[2] && !Q[4] && (rt = (Q[3] ? "http://" : "mailto:") + rt), U = Q.index, M(it.substr(0, U)), W(rt, Q[0].replace(T, "")), it = it.substring(U + Q[0].length);
      return M(it), b(et.join(""));
      function M(J) {
        J && et.push(x(J));
      }
      function W(J, vt) {
        var St, zt = B(J);
        et.push("<a ");
        for (St in zt)
          et.push(St + '="' + zt[St] + '" ');
        C(H) && !("target" in zt) && et.push(
          'target="',
          H,
          '" '
        ), et.push(
          'href="',
          J.replace(/"/g, "&quot;"),
          '">'
        ), M(vt), et.push("</a>");
      }
    };
  }]);
})(window, window.angular);
var b9 = "ngSanitize";
const v9 = /* @__PURE__ */ Hs(b9);
(function() {
  function s(a, n) {
    window.XMLHttpRequest.prototype[a] = n(window.XMLHttpRequest.prototype[a]);
  }
  function t(a, n, i) {
    try {
      Object.defineProperty(a, n, { get: i });
    } catch {
    }
  }
  if (window.FileAPI || (window.FileAPI = {}), !window.XMLHttpRequest)
    throw "AJAX is not supported. XMLHttpRequest is not defined.";
  if (FileAPI.shouldLoad = !window.FormData || FileAPI.forceLoad, FileAPI.shouldLoad) {
    var e = function(a) {
      if (!a.__listeners) {
        a.upload || (a.upload = {}), a.__listeners = [];
        var n = a.upload.addEventListener;
        a.upload.addEventListener = function(i, r) {
          a.__listeners[i] = r, n && n.apply(this, arguments);
        };
      }
    };
    s("open", function(a) {
      return function(n, i, r) {
        e(this), this.__url = i;
        try {
          a.apply(this, [n, i, r]);
        } catch (l) {
          l.message.indexOf("Access is denied") > -1 && (this.__origError = l, a.apply(this, [n, "_fix_for_ie_crossdomain__", r]));
        }
      };
    }), s("getResponseHeader", function(a) {
      return function(n) {
        return this.__fileApiXHR && this.__fileApiXHR.getResponseHeader ? this.__fileApiXHR.getResponseHeader(n) : a == null ? null : a.apply(this, [n]);
      };
    }), s("getAllResponseHeaders", function(a) {
      return function() {
        return this.__fileApiXHR && this.__fileApiXHR.getAllResponseHeaders ? this.__fileApiXHR.getAllResponseHeaders() : a == null ? null : a.apply(this);
      };
    }), s("abort", function(a) {
      return function() {
        return this.__fileApiXHR && this.__fileApiXHR.abort ? this.__fileApiXHR.abort() : a == null ? null : a.apply(this);
      };
    }), s("setRequestHeader", function(a) {
      return function(n, i) {
        if (n === "__setXHR_") {
          e(this);
          var r = i(this);
          r instanceof Function && r(this);
        } else
          this.__requestHeaders = this.__requestHeaders || {}, this.__requestHeaders[n] = i, a.apply(this, arguments);
      };
    }), s("send", function(a) {
      return function() {
        var n = this;
        if (arguments[0] && arguments[0].__isFileAPIShim) {
          var i = arguments[0], r = {
            url: n.__url,
            jsonp: !1,
            //removes the callback form param
            cache: !0,
            //removes the ?fileapiXXX in the url
            complete: function(c, d) {
              c && angular.isString(c) && c.indexOf("#2174") !== -1 && (c = null), n.__completed = !0, !c && n.__listeners.load && n.__listeners.load({
                type: "load",
                loaded: n.__loaded,
                total: n.__total,
                target: n,
                lengthComputable: !0
              }), !c && n.__listeners.loadend && n.__listeners.loadend({
                type: "loadend",
                loaded: n.__loaded,
                total: n.__total,
                target: n,
                lengthComputable: !0
              }), c === "abort" && n.__listeners.abort && n.__listeners.abort({
                type: "abort",
                loaded: n.__loaded,
                total: n.__total,
                target: n,
                lengthComputable: !0
              }), d.status !== void 0 && t(n, "status", function() {
                return d.status === 0 && c && c !== "abort" ? 500 : d.status;
              }), d.statusText !== void 0 && t(n, "statusText", function() {
                return d.statusText;
              }), t(n, "readyState", function() {
                return 4;
              }), d.response !== void 0 && t(n, "response", function() {
                return d.response;
              });
              var p = d.responseText || (c && d.status === 0 && c !== "abort" ? c : void 0);
              t(n, "responseText", function() {
                return p;
              }), t(n, "response", function() {
                return p;
              }), c && t(n, "err", function() {
                return c;
              }), n.__fileApiXHR = d, n.onreadystatechange && n.onreadystatechange(), n.onload && n.onload();
            },
            progress: function(c) {
              if (c.target = n, n.__listeners.progress && n.__listeners.progress(c), n.__total = c.total, n.__loaded = c.loaded, c.total === c.loaded) {
                var d = this;
                setTimeout(function() {
                  n.__completed || (n.getAllResponseHeaders = function() {
                  }, d.complete(null, { status: 204, statusText: "No Content" }));
                }, FileAPI.noContentTimeout || 1e4);
              }
            },
            headers: n.__requestHeaders
          };
          r.data = {}, r.files = {};
          for (var l = 0; l < i.data.length; l++) {
            var o = i.data[l];
            o.val != null && o.val.name != null && o.val.size != null && o.val.type != null ? r.files[o.key] = o.val : r.data[o.key] = o.val;
          }
          setTimeout(function() {
            if (!FileAPI.hasFlash)
              throw 'Adode Flash Player need to be installed. To check ahead use "FileAPI.hasFlash"';
            n.__fileApiXHR = FileAPI.upload(r);
          }, 1);
        } else {
          if (this.__origError)
            throw this.__origError;
          a.apply(n, arguments);
        }
      };
    }), window.XMLHttpRequest.__isFileAPIShim = !0, window.FormData = FormData = function() {
      return {
        append: function(a, n, i) {
          n.__isFileAPIBlobShim && (n = n.data[0]), this.data.push({
            key: a,
            val: n,
            name: i
          });
        },
        data: [],
        __isFileAPIShim: !0
      };
    }, window.Blob = Blob = function(a) {
      return {
        data: a,
        __isFileAPIBlobShim: !0
      };
    };
  }
})();
(function() {
  function s(d) {
    return d[0].tagName.toLowerCase() === "input" && d.attr("type") && d.attr("type").toLowerCase() === "file";
  }
  function t() {
    try {
      var d = new ActiveXObject("ShockwaveFlash.ShockwaveFlash");
      if (d)
        return !0;
    } catch {
      if (navigator.mimeTypes["application/x-shockwave-flash"] !== void 0)
        return !0;
    }
    return !1;
  }
  function e(d) {
    var p = 0, h = 0;
    if (window.jQuery)
      return jQuery(d).offset();
    if (d.offsetParent)
      do
        p += d.offsetLeft - d.scrollLeft, h += d.offsetTop - d.scrollTop, d = d.offsetParent;
      while (d);
    return {
      left: p,
      top: h
    };
  }
  if (FileAPI.shouldLoad) {
    if (FileAPI.hasFlash = t(), FileAPI.forceLoad && (FileAPI.html5 = !1), !FileAPI.upload) {
      var a, n, i = document.createElement("script"), r = document.getElementsByTagName("script"), l, o, c;
      if (window.FileAPI.jsUrl)
        a = window.FileAPI.jsUrl;
      else if (window.FileAPI.jsPath)
        n = window.FileAPI.jsPath;
      else
        for (l = 0; l < r.length; l++)
          if (c = r[l].src, o = c.search(/\/ng\-file\-upload[\-a-zA-z0-9\.]*\.js/), o > -1) {
            n = c.substring(0, o + 1);
            break;
          }
      FileAPI.staticPath == null && (FileAPI.staticPath = n), i.setAttribute("src", a || n + "FileAPI.min.js"), document.getElementsByTagName("head")[0].appendChild(i);
    }
    FileAPI.ngfFixIE = function(d, p, h) {
      if (!t())
        throw 'Adode Flash Player need to be installed. To check ahead use "FileAPI.hasFlash"';
      var g = function() {
        var b = p.parent();
        d.attr("disabled") ? b && b.removeClass("js-fileapi-wrapper") : (p.attr("__ngf_flash_") || (p.unbind("change"), p.unbind("click"), p.bind("change", function(A) {
          x.apply(this, [A]), h.apply(this, [A]);
        }), p.attr("__ngf_flash_", "true")), b.addClass("js-fileapi-wrapper"), s(d) || (b.css("position", "absolute").css("top", e(d[0]).top + "px").css("left", e(d[0]).left + "px").css("width", d[0].offsetWidth + "px").css("height", d[0].offsetHeight + "px").css("filter", "alpha(opacity=0)").css("display", d.css("display")).css("overflow", "hidden").css("z-index", "900000").css("visibility", "visible"), p.css("width", d[0].offsetWidth + "px").css("height", d[0].offsetHeight + "px").css("position", "absolute").css("top", "0px").css("left", "0px")));
      };
      d.bind("mouseenter", g);
      var x = function(b) {
        for (var A = FileAPI.getFiles(b), T = 0; T < A.length; T++)
          A[T].size === void 0 && (A[T].size = 0), A[T].name === void 0 && (A[T].name = "file"), A[T].type === void 0 && (A[T].type = "undefined");
        b.target || (b.target = {}), b.target.files = A, b.target.files !== A && (b.__files_ = A), (b.__files_ || b.target.files).item = function(R) {
          return (b.__files_ || b.target.files)[R] || null;
        };
      };
    }, FileAPI.disableFileInput = function(d, p) {
      p ? d.removeClass("js-fileapi-wrapper") : d.addClass("js-fileapi-wrapper");
    };
  }
})();
window.FileReader || (window.FileReader = function() {
  var s = this, t = !1;
  this.listeners = {}, this.addEventListener = function(n, i) {
    s.listeners[n] = s.listeners[n] || [], s.listeners[n].push(i);
  }, this.removeEventListener = function(n, i) {
    s.listeners[n] && s.listeners[n].splice(s.listeners[n].indexOf(i), 1);
  }, this.dispatchEvent = function(n) {
    var i = s.listeners[n.type];
    if (i)
      for (var r = 0; r < i.length; r++)
        i[r].call(s, n);
  }, this.onabort = this.onerror = this.onload = this.onloadstart = this.onloadend = this.onprogress = null;
  var e = function(n, i) {
    var r = { type: n, target: s, loaded: i.loaded, total: i.total, error: i.error };
    return i.result != null && (r.target.result = i.result), r;
  }, a = function(n) {
    t || (t = !0, s.onloadstart && s.onloadstart(e("loadstart", n)));
    var i;
    n.type === "load" ? (s.onloadend && s.onloadend(e("loadend", n)), i = e("load", n), s.onload && s.onload(i), s.dispatchEvent(i)) : n.type === "progress" ? (i = e("progress", n), s.onprogress && s.onprogress(i), s.dispatchEvent(i)) : (i = e("error", n), s.onerror && s.onerror(i), s.dispatchEvent(i));
  };
  this.readAsDataURL = function(n) {
    FileAPI.readAsDataURL(n, a);
  }, this.readAsText = function(n) {
    FileAPI.readAsText(n, a);
  };
});
window.XMLHttpRequest && !(window.FileAPI && FileAPI.shouldLoad) && (window.XMLHttpRequest.prototype.setRequestHeader = /* @__PURE__ */ function(s) {
  return function(t, e) {
    if (t === "__setXHR_") {
      var a = e(this);
      a instanceof Function && a(this);
    } else
      s.apply(this, arguments);
  };
}(window.XMLHttpRequest.prototype.setRequestHeader));
var Gn = angular.module("ngFileUpload", []);
Gn.version = "12.2.13";
Gn.service("UploadBase", [
  "$http",
  "$q",
  "$timeout",
  function(s, t, e) {
    var a = this;
    a.promisesCount = 0, this.isResumeSupported = function() {
      return window.Blob && window.Blob.prototype.slice;
    };
    var n = this.isResumeSupported();
    function i(l) {
      l.method = l.method || "POST", l.headers = l.headers || {};
      var o = l._deferred = l._deferred || t.defer(), c = o.promise;
      function d(g) {
        o.notify && o.notify(g), c.progressFunc && e(function() {
          c.progressFunc(g);
        });
      }
      function p(g) {
        return l._start != null && n ? {
          loaded: g.loaded + l._start,
          total: l._file && l._file.size || g.total,
          type: g.type,
          config: l,
          lengthComputable: !0,
          target: g.target
        } : g;
      }
      l.disableProgress || (l.headers.__setXHR_ = function() {
        return function(g) {
          !g || !g.upload || !g.upload.addEventListener || (l.__XHR = g, l.xhrFn && l.xhrFn(g), g.upload.addEventListener("progress", function(x) {
            x.config = l, d(p(x));
          }, !1), g.upload.addEventListener("load", function(x) {
            x.lengthComputable && (x.config = l, d(p(x)));
          }, !1));
        };
      });
      function h() {
        s(l).then(
          function(g) {
            if (n && l._chunkSize && !l._finished && l._file) {
              var x = l._file && l._file.size || 0;
              d(
                {
                  loaded: Math.min(l._end, x),
                  total: x,
                  config: l,
                  type: "progress"
                }
              ), a.upload(l, !0);
            } else
              l._finished && delete l._finished, o.resolve(g);
          },
          function(g) {
            o.reject(g);
          },
          function(g) {
            o.notify(g);
          }
        );
      }
      return n ? l._chunkSize && l._end && !l._finished ? (l._start = l._end, l._end += l._chunkSize, h()) : l.resumeSizeUrl ? s.get(l.resumeSizeUrl).then(function(g) {
        l.resumeSizeResponseReader ? l._start = l.resumeSizeResponseReader(g.data) : l._start = parseInt((g.data.size == null ? g.data : g.data.size).toString()), l._chunkSize && (l._end = l._start + l._chunkSize), h();
      }, function(g) {
        throw g;
      }) : l.resumeSize ? l.resumeSize().then(function(g) {
        l._start = g, l._chunkSize && (l._end = l._start + l._chunkSize), h();
      }, function(g) {
        throw g;
      }) : (l._chunkSize && (l._start = 0, l._end = l._start + l._chunkSize), h()) : h(), c.success = function(g) {
        return c.then(function(x) {
          g(x.data, x.status, x.headers, l);
        }), c;
      }, c.error = function(g) {
        return c.then(null, function(x) {
          g(x.data, x.status, x.headers, l);
        }), c;
      }, c.progress = function(g) {
        return c.progressFunc = g, c.then(null, null, function(x) {
          g(x);
        }), c;
      }, c.abort = c.pause = function() {
        return l.__XHR && e(function() {
          l.__XHR.abort();
        }), c;
      }, c.xhr = function(g) {
        return l.xhrFn = /* @__PURE__ */ function(x) {
          return function() {
            x && x.apply(c, arguments), g.apply(c, arguments);
          };
        }(l.xhrFn), c;
      }, a.promisesCount++, c.finally && c.finally instanceof Function && c.finally(function() {
        a.promisesCount--;
      }), c;
    }
    this.isUploadInProgress = function() {
      return a.promisesCount > 0;
    }, this.rename = function(l, o) {
      return l.ngfName = o, l;
    }, this.jsonBlob = function(l) {
      l != null && !angular.isString(l) && (l = JSON.stringify(l));
      var o = new window.Blob([l], { type: "application/json" });
      return o._ngfBlob = !0, o;
    }, this.json = function(l) {
      return angular.toJson(l);
    };
    function r(l) {
      var o = {};
      for (var c in l)
        l.hasOwnProperty(c) && (o[c] = l[c]);
      return o;
    }
    this.isFile = function(l) {
      return l != null && (l instanceof window.Blob || l.flashId && l.name && l.size);
    }, this.upload = function(l, o) {
      function c(h, g) {
        if (h._ngfBlob)
          return h;
        if (l._file = l._file || h, l._start != null && n) {
          l._end && l._end >= h.size && (l._finished = !0, l._end = h.size);
          var x = h.slice(l._start, l._end || h.size);
          return x.name = h.name, x.ngfName = h.ngfName, l._chunkSize && (g.append("_chunkSize", l._chunkSize), g.append("_currentChunkSize", l._end - l._start), g.append("_chunkNumber", Math.floor(l._start / l._chunkSize)), g.append("_totalSize", l._file.size)), x;
        }
        return h;
      }
      function d(h, g, x) {
        if (g !== void 0)
          if (angular.isDate(g) && (g = g.toISOString()), angular.isString(g))
            h.append(x, g);
          else if (a.isFile(g)) {
            var b = c(g, h), A = x.split(",");
            A[1] && (b.ngfName = A[1].replace(/^\s+|\s+$/g, ""), x = A[0]), l._fileKey = l._fileKey || x, h.append(x, b, b.ngfName || b.name);
          } else if (angular.isObject(g)) {
            if (g.$$ngfCircularDetection)
              throw "ngFileUpload: Circular reference in config.data. Make sure specified data for Upload.upload() has no circular reference: " + x;
            g.$$ngfCircularDetection = !0;
            try {
              for (var T in g)
                if (g.hasOwnProperty(T) && T !== "$$ngfCircularDetection") {
                  var R = l.objectKey == null ? "[i]" : l.objectKey;
                  g.length && parseInt(T) > -1 && (R = l.arrayKey == null ? R : l.arrayKey), d(h, g[T], x + R.replace(/[ik]/g, T));
                }
            } finally {
              delete g.$$ngfCircularDetection;
            }
          } else
            h.append(x, g);
      }
      function p() {
        l._chunkSize = a.translateScalars(l.resumeChunkSize), l._chunkSize = l._chunkSize ? parseInt(l._chunkSize.toString()) : null, l.headers = l.headers || {}, l.headers["Content-Type"] = void 0, l.transformRequest = l.transformRequest ? angular.isArray(l.transformRequest) ? l.transformRequest : [l.transformRequest] : [], l.transformRequest.push(function(h) {
          var g = new window.FormData(), x;
          h = h || l.fields || {}, l.file && (h.file = l.file);
          for (x in h)
            if (h.hasOwnProperty(x)) {
              var b = h[x];
              l.formDataAppender ? l.formDataAppender(g, x, b) : d(g, b, x);
            }
          return g;
        });
      }
      return o || (l = r(l)), l._isDigested || (l._isDigested = !0, p()), i(l);
    }, this.http = function(l) {
      return l = r(l), l.transformRequest = l.transformRequest || function(o) {
        return window.ArrayBuffer && o instanceof window.ArrayBuffer || o instanceof window.Blob ? o : s.defaults.transformRequest[0].apply(this, arguments);
      }, l._chunkSize = a.translateScalars(l.resumeChunkSize), l._chunkSize = l._chunkSize ? parseInt(l._chunkSize.toString()) : null, i(l);
    }, this.translateScalars = function(l) {
      if (angular.isString(l)) {
        if (l.search(/kb/i) === l.length - 2)
          return parseFloat(l.substring(0, l.length - 2) * 1024);
        if (l.search(/mb/i) === l.length - 2)
          return parseFloat(l.substring(0, l.length - 2) * 1048576);
        if (l.search(/gb/i) === l.length - 2)
          return parseFloat(l.substring(0, l.length - 2) * 1073741824);
        if (l.search(/b/i) === l.length - 1)
          return parseFloat(l.substring(0, l.length - 1));
        if (l.search(/s/i) === l.length - 1)
          return parseFloat(l.substring(0, l.length - 1));
        if (l.search(/m/i) === l.length - 1)
          return parseFloat(l.substring(0, l.length - 1) * 60);
        if (l.search(/h/i) === l.length - 1)
          return parseFloat(l.substring(0, l.length - 1) * 3600);
      }
      return l;
    }, this.urlToBlob = function(l) {
      var o = t.defer();
      return s({ url: l, method: "get", responseType: "arraybuffer" }).then(function(c) {
        var d = new Uint8Array(c.data), p = c.headers("content-type") || "image/WebP", h = new window.Blob([d], { type: p }), g = l.match(/.*\/(.+?)(\?.*)?$/);
        g.length > 1 && (h.name = g[1]), o.resolve(h);
      }, function(c) {
        o.reject(c);
      }), o.promise;
    }, this.setDefaults = function(l) {
      this.defaults = l || {};
    }, this.defaults = {}, this.version = Gn.version;
  }
]);
Gn.service("Upload", ["$parse", "$timeout", "$compile", "$q", "UploadExif", function(s, t, e, a, n) {
  var i = n;
  i.getAttrWithDefaults = function(c, d) {
    if (c[d] != null)
      return c[d];
    var p = i.defaults[d];
    return p == null || angular.isString(p) ? p : JSON.stringify(p);
  }, i.attrGetter = function(c, d, p, h) {
    var g = this.getAttrWithDefaults(d, c);
    if (p)
      try {
        return h ? s(g)(p, h) : s(g)(p);
      } catch (x) {
        if (c.search(/min|max|pattern/i))
          return g;
        throw x;
      }
    else
      return g;
  }, i.shouldUpdateOn = function(c, d, p) {
    var h = i.attrGetter("ngfModelOptions", d, p);
    return h && h.updateOn ? h.updateOn.split(" ").indexOf(c) > -1 : !0;
  }, i.emptyPromise = function() {
    var c = a.defer(), d = arguments;
    return t(function() {
      c.resolve.apply(c, d);
    }), c.promise;
  }, i.rejectPromise = function() {
    var c = a.defer(), d = arguments;
    return t(function() {
      c.reject.apply(c, d);
    }), c.promise;
  }, i.happyPromise = function(c, d) {
    var p = a.defer();
    return c.then(function(h) {
      p.resolve(h);
    }, function(h) {
      t(function() {
        throw h;
      }), p.resolve(d);
    }), p.promise;
  };
  function r(c, d, p) {
    var h = [i.emptyPromise()];
    return angular.forEach(c, function(g, x) {
      g.type.indexOf("image/jpeg") === 0 && i.attrGetter("ngfFixOrientation", d, p, { $file: g }) && h.push(i.happyPromise(i.applyExifRotation(g), g).then(function(b) {
        c.splice(x, 1, b);
      }));
    }), a.all(h);
  }
  function l(c, d, p, h) {
    var g = i.attrGetter("ngfResize", d, p);
    if (!g || !i.isResizeSupported() || !c.length)
      return i.emptyPromise();
    if (g instanceof Function) {
      var x = a.defer();
      return g(c).then(function(b) {
        o(b, c, d, p, h).then(function(A) {
          x.resolve(A);
        }, function(A) {
          x.reject(A);
        });
      }, function(b) {
        x.reject(b);
      });
    } else
      return o(g, c, d, p, h);
  }
  function o(c, d, p, h, g) {
    var x = [i.emptyPromise()];
    function b(T, R) {
      if (T.type.indexOf("image") === 0) {
        if (c.pattern && !i.validatePattern(T, c.pattern))
          return;
        c.resizeIf = function(v, P) {
          return i.attrGetter(
            "ngfResizeIf",
            p,
            h,
            { $width: v, $height: P, $file: T }
          );
        };
        var C = i.resize(T, c);
        x.push(C), C.then(function(v) {
          d.splice(R, 1, v);
        }, function(v) {
          T.$error = "resize", (T.$errorMessages = T.$errorMessages || {}).resize = !0, T.$errorParam = (v ? (v.message ? v.message : v) + ": " : "") + (T && T.name), g.$ngfValidations.push({ name: "resize", valid: !1 }), i.applyModelValidation(g, d);
        });
      }
    }
    for (var A = 0; A < d.length; A++)
      b(d[A], A);
    return a.all(x);
  }
  return i.updateModel = function(c, d, p, h, g, x, b) {
    function A(rt, U, M, W, J) {
      d.$$ngfPrevValidFiles = rt, d.$$ngfPrevInvalidFiles = U;
      var vt = rt && rt.length ? rt[0] : null, St = U && U.length ? U[0] : null;
      c && (i.applyModelValidation(c, rt), c.$setViewValue(J ? vt : rt)), h && s(h)(p, {
        $files: rt,
        $file: vt,
        $newFiles: M,
        $duplicateFiles: W,
        $invalidFiles: U,
        $invalidFile: St,
        $event: x
      });
      var zt = i.attrGetter("ngfModelInvalid", d);
      zt && t(function() {
        s(zt).assign(p, J ? St : U);
      }), t(function() {
      });
    }
    var T, R = [], C, v, P = [], O = [];
    function N() {
      function rt(W, J) {
        return W.name === J.name && (W.$ngfOrigSize || W.size) === (J.$ngfOrigSize || J.size) && W.type === J.type;
      }
      function U(W) {
        var J;
        for (J = 0; J < C.length; J++)
          if (rt(W, C[J]))
            return !0;
        for (J = 0; J < v.length; J++)
          if (rt(W, v[J]))
            return !0;
        return !1;
      }
      if (g) {
        T = [], R = [];
        for (var M = 0; M < g.length; M++)
          U(g[M]) ? R.push(g[M]) : T.push(g[M]);
      }
    }
    function H(rt) {
      return angular.isArray(rt) ? rt : [rt];
    }
    function F() {
      function rt() {
        t(function() {
          A(
            B ? C.concat(O) : O,
            B ? v.concat(P) : P,
            g,
            R,
            Q
          );
        }, et && et.debounce ? et.debounce.change || et.debounce : 0);
      }
      var U = it ? T : O;
      l(U, d, p, c).then(function() {
        it ? i.validate(T, B ? C.length : 0, c, d, p).then(function(M) {
          O = M.validsFiles, P = M.invalidsFiles, rt();
        }) : rt();
      }, function() {
        for (var M = 0; M < U.length; M++) {
          var W = U[M];
          if (W.$error === "resize") {
            var J = O.indexOf(W);
            J > -1 && (O.splice(J, 1), P.push(W)), rt();
          }
        }
      });
    }
    C = d.$$ngfPrevValidFiles || [], v = d.$$ngfPrevInvalidFiles || [], c && c.$modelValue && (C = H(c.$modelValue));
    var B = i.attrGetter("ngfKeep", d, p);
    T = (g || []).slice(0), (B === "distinct" || i.attrGetter("ngfKeepDistinct", d, p) === !0) && N();
    var Q = !B && !i.attrGetter("ngfMultiple", d, p) && !i.attrGetter("multiple", d);
    if (!(B && !T.length)) {
      i.attrGetter("ngfBeforeModelChange", d, p, {
        $files: g,
        $file: g && g.length ? g[0] : null,
        $newFiles: T,
        $duplicateFiles: R,
        $event: x
      });
      var it = i.attrGetter("ngfValidateAfterResize", d, p), et = i.attrGetter("ngfModelOptions", d, p);
      i.validate(T, B ? C.length : 0, c, d, p).then(function(rt) {
        b ? A(T, [], g, R, Q) : ((!et || !et.allowInvalid) && !it ? (O = rt.validFiles, P = rt.invalidFiles) : O = T, i.attrGetter("ngfFixOrientation", d, p) && i.isExifSupported() ? r(O, d, p).then(function() {
          F();
        }) : F());
      });
    }
  }, i;
}]);
Gn.directive("ngfSelect", ["$parse", "$timeout", "$compile", "Upload", function(s, t, e, a) {
  var n = [];
  function i(l) {
    var o = l.match(/Android[^\d]*(\d+)\.(\d+)/);
    if (o && o.length > 2) {
      var c = a.defaults.androidFixMinorVersion || 4;
      return parseInt(o[1]) < 4 || parseInt(o[1]) === c && parseInt(o[2]) < c;
    }
    return l.indexOf("Chrome") === -1 && /.*Windows.*Safari.*/.test(l);
  }
  function r(l, o, c, d, p, h, g, x) {
    var b = function(et, rt) {
      return x.attrGetter(et, c, rt);
    };
    function A() {
      return o[0].tagName.toLowerCase() === "input" && c.type && c.type.toLowerCase() === "file";
    }
    function T() {
      return b("ngfChange") || b("ngfSelect");
    }
    function R(et) {
      if (x.shouldUpdateOn("change", c, l)) {
        var rt = et.__files_ || et.target && et.target.files, U = [];
        if (!rt)
          return;
        for (var M = 0; M < rt.length; M++)
          U.push(rt[M]);
        x.updateModel(
          d,
          c,
          l,
          T(),
          U.length ? U : null,
          et
        );
      }
    }
    x.registerModelChangeValidator(d, c, l);
    var C = [];
    b("ngfMultiple") && C.push(l.$watch(b("ngfMultiple"), function() {
      B.attr("multiple", b("ngfMultiple", l));
    })), b("ngfCapture") && C.push(l.$watch(b("ngfCapture"), function() {
      B.attr("capture", b("ngfCapture", l));
    })), b("ngfAccept") && C.push(l.$watch(b("ngfAccept"), function() {
      B.attr("accept", b("ngfAccept", l));
    })), C.push(c.$observe("accept", function() {
      B.attr("accept", b("accept"));
    }));
    function v(et, rt) {
      function U(J) {
        et.attr("id", "ngf-" + J), rt.attr("id", "ngf-label-" + J);
      }
      for (var M = 0; M < o[0].attributes.length; M++) {
        var W = o[0].attributes[M];
        W.name !== "type" && W.name !== "class" && W.name !== "style" && (W.name === "id" ? (U(W.value), C.push(c.$observe("id", U))) : et.attr(W.name, !W.value && (W.name === "required" || W.name === "multiple") ? W.name : W.value));
      }
    }
    function P() {
      if (A())
        return o;
      var et = angular.element('<input type="file">'), rt = angular.element("<label>upload</label>");
      return rt.css("visibility", "hidden").css("position", "absolute").css("overflow", "hidden").css("width", "0px").css("height", "0px").css("border", "none").css("margin", "0px").css("padding", "0px").attr("tabindex", "-1"), v(et, rt), n.push({ el: o, ref: rt }), document.body.appendChild(rt.append(et)[0]), et;
    }
    function O(et) {
      if (o.attr("disabled"))
        return !1;
      if (!b("ngfSelectDisabled", l)) {
        var rt = F(et);
        if (rt != null)
          return rt;
        Q(et);
        try {
          !A() && !document.body.contains(B[0]) && (n.push({ el: o, ref: B.parent() }), document.body.appendChild(B.parent()[0]), B.bind("change", R));
        } catch {
        }
        return i(navigator.userAgent) ? setTimeout(function() {
          B[0].click();
        }, 0) : B[0].click(), !1;
      }
    }
    var N = 0, H = 0;
    function F(et) {
      var rt = et.changedTouches || et.originalEvent && et.originalEvent.changedTouches;
      if (rt) {
        if (et.type === "touchstart")
          return H = rt[0].clientX, N = rt[0].clientY, !0;
        if (et.type === "touchend") {
          var U = rt[0].clientX, M = rt[0].clientY;
          if (Math.abs(U - H) > 20 || Math.abs(M - N) > 20)
            return et.stopPropagation(), et.preventDefault(), !1;
        }
        return !0;
      }
    }
    var B = o;
    function Q(et) {
      x.shouldUpdateOn("click", c, l) && B.val() && (B.val(null), x.updateModel(d, c, l, T(), null, et, !0));
    }
    A() || (B = P()), B.bind("change", R), A() ? o.bind("click", Q) : o.bind("click touchstart touchend", O);
    function it(et) {
      if (B && !B.attr("__ngf_ie10_Fix_")) {
        if (!B[0].parentNode) {
          B = null;
          return;
        }
        et.preventDefault(), et.stopPropagation(), B.unbind("click");
        var rt = B.clone();
        return B.replaceWith(rt), B = rt, B.attr("__ngf_ie10_Fix_", "true"), B.bind("change", R), B.bind("click", it), B[0].click(), !1;
      } else
        B.removeAttr("__ngf_ie10_Fix_");
    }
    navigator.appVersion.indexOf("MSIE 10") !== -1 && B.bind("click", it), d && d.$formatters.push(function(et) {
      return (et == null || et.length === 0) && B.val() && B.val(null), et;
    }), l.$on("$destroy", function() {
      A() || B.parent().remove(), angular.forEach(C, function(et) {
        et();
      });
    }), h(function() {
      for (var et = 0; et < n.length; et++) {
        var rt = n[et];
        document.body.contains(rt.el[0]) || (n.splice(et, 1), rt.ref.remove());
      }
    }), window.FileAPI && window.FileAPI.ngfFixIE && window.FileAPI.ngfFixIE(o, B, R);
  }
  return {
    restrict: "AEC",
    require: "?ngModel",
    link: function(l, o, c, d) {
      r(l, o, c, d, s, t, e, a);
    }
  };
}]);
(function() {
  Gn.service("UploadDataUrl", ["UploadBase", "$timeout", "$q", function(e, a, n) {
    var i = e;
    return i.base64DataUrl = function(r) {
      if (angular.isArray(r)) {
        var l = n.defer(), o = 0;
        return angular.forEach(r, function(c) {
          i.dataUrl(c, !0).finally(function() {
            if (o++, o === r.length) {
              var d = [];
              angular.forEach(r, function(p) {
                d.push(p.$ngfDataUrl);
              }), l.resolve(d, r);
            }
          });
        }), l.promise;
      } else
        return i.dataUrl(r, !0);
    }, i.dataUrl = function(r, l) {
      if (!r)
        return i.emptyPromise(r, r);
      if (l && r.$ngfDataUrl != null || !l && r.$ngfBlobUrl != null)
        return i.emptyPromise(l ? r.$ngfDataUrl : r.$ngfBlobUrl, r);
      var o = l ? r.$$ngfDataUrlPromise : r.$$ngfBlobUrlPromise;
      if (o)
        return o;
      var c = n.defer();
      return a(function() {
        if (window.FileReader && r && (!window.FileAPI || navigator.userAgent.indexOf("MSIE 8") === -1 || r.size < 2e4) && (!window.FileAPI || navigator.userAgent.indexOf("MSIE 9") === -1 || r.size < 4e6)) {
          var d = window.URL || window.webkitURL;
          if (d && d.createObjectURL && !l) {
            var p;
            try {
              p = d.createObjectURL(r);
            } catch {
              a(function() {
                r.$ngfBlobUrl = "", c.reject();
              });
              return;
            }
            a(function() {
              if (r.$ngfBlobUrl = p, p) {
                c.resolve(p, r), i.blobUrls = i.blobUrls || [], i.blobUrlsTotalSize = i.blobUrlsTotalSize || 0, i.blobUrls.push({ url: p, size: r.size }), i.blobUrlsTotalSize += r.size || 0;
                for (var g = i.defaults.blobUrlsMaxMemory || 268435456, x = i.defaults.blobUrlsMaxQueueSize || 200; (i.blobUrlsTotalSize > g || i.blobUrls.length > x) && i.blobUrls.length > 1; ) {
                  var b = i.blobUrls.splice(0, 1)[0];
                  d.revokeObjectURL(b.url), i.blobUrlsTotalSize -= b.size;
                }
              }
            });
          } else {
            var h = new FileReader();
            h.onload = function(g) {
              a(function() {
                r.$ngfDataUrl = g.target.result, c.resolve(g.target.result, r), a(function() {
                  delete r.$ngfDataUrl;
                }, 1e3);
              });
            }, h.onerror = function() {
              a(function() {
                r.$ngfDataUrl = "", c.reject();
              });
            }, h.readAsDataURL(r);
          }
        } else
          a(function() {
            r[l ? "$ngfDataUrl" : "$ngfBlobUrl"] = "", c.reject();
          });
      }), l ? o = r.$$ngfDataUrlPromise = c.promise : o = r.$$ngfBlobUrlPromise = c.promise, o.finally(function() {
        delete r[l ? "$$ngfDataUrlPromise" : "$$ngfBlobUrlPromise"];
      }), o;
    }, i;
  }]);
  function s(e) {
    return e.tagName.toLowerCase() === "img" ? "image" : e.tagName.toLowerCase() === "audio" ? "audio" : e.tagName.toLowerCase() === "video" ? "video" : /./;
  }
  function t(e, a, n, i, r, l, o, c) {
    function d(p) {
      var h = e.attrGetter("ngfNoObjectUrl", r, n);
      e.dataUrl(p, h).finally(function() {
        a(function() {
          var g = (h ? p.$ngfDataUrl : p.$ngfBlobUrl) || p.$ngfDataUrl;
          c ? i.css("background-image", "url('" + (g || "") + "')") : i.attr("src", g), g ? i.removeClass("ng-hide") : i.addClass("ng-hide");
        });
      });
    }
    a(function() {
      var p = n.$watch(r[l], function(h) {
        var g = o;
        if (l === "ngfThumbnail" && (g || (g = {
          width: i[0].naturalWidth || i[0].clientWidth,
          height: i[0].naturalHeight || i[0].clientHeight
        }), g.width === 0 && window.getComputedStyle)) {
          var x = getComputedStyle(i[0]);
          x.width && x.width.indexOf("px") > -1 && x.height && x.height.indexOf("px") > -1 && (g = {
            width: parseInt(x.width.slice(0, -2)),
            height: parseInt(x.height.slice(0, -2))
          });
        }
        if (angular.isString(h))
          return i.removeClass("ng-hide"), c ? i.css("background-image", "url('" + h + "')") : i.attr("src", h);
        h && h.type && h.type.search(s(i[0])) === 0 && (!c || h.type.indexOf("image") === 0) ? g && e.isResizeSupported() ? (g.resizeIf = function(b, A) {
          return e.attrGetter(
            "ngfResizeIf",
            r,
            n,
            { $width: b, $height: A, $file: h }
          );
        }, e.resize(h, g).then(
          function(b) {
            d(b);
          },
          function(b) {
            throw b;
          }
        )) : d(h) : i.addClass("ng-hide");
      });
      n.$on("$destroy", function() {
        p();
      });
    });
  }
  Gn.directive("ngfSrc", ["Upload", "$timeout", function(e, a) {
    return {
      restrict: "AE",
      link: function(n, i, r) {
        t(
          e,
          a,
          n,
          i,
          r,
          "ngfSrc",
          e.attrGetter("ngfResize", r, n),
          !1
        );
      }
    };
  }]), Gn.directive("ngfBackground", ["Upload", "$timeout", function(e, a) {
    return {
      restrict: "AE",
      link: function(n, i, r) {
        t(
          e,
          a,
          n,
          i,
          r,
          "ngfBackground",
          e.attrGetter("ngfResize", r, n),
          !0
        );
      }
    };
  }]), Gn.directive("ngfThumbnail", ["Upload", "$timeout", function(e, a) {
    return {
      restrict: "AE",
      link: function(n, i, r) {
        var l = e.attrGetter("ngfSize", r, n);
        t(
          e,
          a,
          n,
          i,
          r,
          "ngfThumbnail",
          l,
          e.attrGetter("ngfAsBackground", r, n)
        );
      }
    };
  }]), Gn.config(["$compileProvider", function(e) {
    e.imgSrcSanitizationWhitelist && e.imgSrcSanitizationWhitelist(/^\s*(https?|ftp|mailto|tel|webcal|local|file|data|blob):/), e.aHrefSanitizationWhitelist && e.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|tel|webcal|local|file|data|blob):/);
  }]), Gn.filter("ngfDataUrl", ["UploadDataUrl", "$sce", function(e, a) {
    return function(n, i, r) {
      if (angular.isString(n))
        return a.trustAsResourceUrl(n);
      var l = n && ((i ? n.$ngfDataUrl : n.$ngfBlobUrl) || n.$ngfDataUrl);
      return n && !l ? (!n.$ngfDataUrlFilterInProgress && angular.isObject(n) && (n.$ngfDataUrlFilterInProgress = !0, e.dataUrl(n, i)), "") : (n && delete n.$ngfDataUrlFilterInProgress, (n && l ? r ? a.trustAsResourceUrl(l) : l : n) || "");
    };
  }]);
})();
Gn.service("UploadValidate", [
  "UploadDataUrl",
  "$q",
  "$timeout",
  function(s, t, e) {
    var a = s;
    function n(r) {
      var l = "", o = [];
      if (r.length > 2 && r[0] === "/" && r[r.length - 1] === "/")
        l = r.substring(1, r.length - 1);
      else {
        var c = r.split(",");
        if (c.length > 1)
          for (var d = 0; d < c.length; d++) {
            var p = n(c[d]);
            p.regexp ? (l += "(" + p.regexp + ")", d < c.length - 1 && (l += "|")) : o = o.concat(p.excludes);
          }
        else
          r.indexOf("!") === 0 ? o.push("^((?!" + n(r.substring(1)).regexp + ").)*$") : (r.indexOf(".") === 0 && (r = "*" + r), l = "^" + r.replace(new RegExp("[.\\\\+*?\\[\\^\\]$(){}=!<>|:\\-]", "g"), "\\$&") + "$", l = l.replace(/\\\*/g, ".*").replace(/\\\?/g, "."));
      }
      return { regexp: l, excludes: o };
    }
    a.validatePattern = function(r, l) {
      if (!l)
        return !0;
      var o = n(l), c = !0;
      if (o.regexp && o.regexp.length) {
        var d = new RegExp(o.regexp, "i");
        c = r.type != null && d.test(r.type) || r.name != null && d.test(r.name);
      }
      for (var p = o.excludes.length; p--; ) {
        var h = new RegExp(o.excludes[p], "i");
        c = c && (r.type == null || h.test(r.type)) && (r.name == null || h.test(r.name));
      }
      return c;
    }, a.ratioToFloat = function(r) {
      var l = r.toString(), o = l.search(/[x:]/i);
      return o > -1 ? l = parseFloat(l.substring(0, o)) / parseFloat(l.substring(o + 1)) : l = parseFloat(l), l;
    }, a.registerModelChangeValidator = function(r, l, o) {
      r && r.$formatters.push(function(c) {
        if (r.$dirty) {
          var d = c;
          c && !angular.isArray(c) && (d = [c]), a.validate(d, 0, r, l, o).then(function() {
            a.applyModelValidation(r, d);
          });
        }
        return c;
      });
    };
    function i(r, l) {
      l != null && !r.$dirty && (r.$setDirty ? r.$setDirty() : r.$dirty = !0);
    }
    return a.applyModelValidation = function(r, l) {
      i(r, l), angular.forEach(r.$ngfValidations, function(o) {
        r.$setValidity(o.name, o.valid);
      });
    }, a.getValidationAttr = function(r, l, o, c, d) {
      var p = "ngf" + o[0].toUpperCase() + o.substr(1), h = a.attrGetter(p, r, l, { $file: d });
      if (h == null && (h = a.attrGetter("ngfValidate", r, l, { $file: d }), h)) {
        var g = (c || o).split(".");
        h = h[g[0]], g.length > 1 && (h = h && h[g[1]]);
      }
      return h;
    }, a.validate = function(r, l, o, c, d) {
      o = o || {}, o.$ngfValidations = o.$ngfValidations || [], angular.forEach(o.$ngfValidations, function(v) {
        v.valid = !0;
      });
      var p = function(v, P) {
        return a.attrGetter(v, c, d, P);
      }, h = (a.attrGetter("ngfIgnoreInvalid", c, d) || "").split(" "), g = a.attrGetter("ngfRunAllValidations", c, d);
      if (r == null || r.length === 0)
        return a.emptyPromise({ validFiles: r, invalidFiles: [] });
      r = r.length === void 0 ? [r] : r.slice(0);
      var x = [];
      function b(v, P, O) {
        if (r) {
          for (var N = r.length, H = null; N--; ) {
            var F = r[N];
            if (F) {
              var B = a.getValidationAttr(c, d, v, P, F);
              B != null && (O(F, B, N) || (h.indexOf(v) === -1 ? (F.$error = v, (F.$errorMessages = F.$errorMessages || {})[v] = !0, F.$errorParam = B, x.indexOf(F) === -1 && x.push(F), g || r.splice(N, 1), H = !1) : r.splice(N, 1)));
            }
          }
          H !== null && o.$ngfValidations.push({ name: v, valid: H });
        }
      }
      b("pattern", null, a.validatePattern), b("minSize", "size.min", function(v, P) {
        return v.size + 0.1 >= a.translateScalars(P);
      }), b("maxSize", "size.max", function(v, P) {
        return v.size - 0.1 <= a.translateScalars(P);
      });
      var A = 0;
      if (b("maxTotalSize", null, function(v, P) {
        return A += v.size, A > a.translateScalars(P) ? (r.splice(0, r.length), !1) : !0;
      }), b("validateFn", null, function(v, P) {
        return P === !0 || P === null || P === "";
      }), !r.length)
        return a.emptyPromise({ validFiles: [], invalidFiles: x });
      function T(v, P, O, N, H) {
        function F(it, et, rt) {
          function U(M) {
            if (M())
              if (h.indexOf(v) === -1) {
                if (et.$error = v, (et.$errorMessages = et.$errorMessages || {})[v] = !0, et.$errorParam = rt, x.indexOf(et) === -1 && x.push(et), !g) {
                  var W = r.indexOf(et);
                  W > -1 && r.splice(W, 1);
                }
                it.resolve(!1);
              } else {
                var J = r.indexOf(et);
                J > -1 && r.splice(J, 1), it.resolve(!0);
              }
            else
              it.resolve(!0);
          }
          rt != null ? N(et, rt).then(function(M) {
            U(function() {
              return !H(M, rt);
            });
          }, function() {
            U(function() {
              return p("ngfValidateForce", { $file: et });
            });
          }) : it.resolve(!0);
        }
        var B = [a.emptyPromise(!0)];
        r && (r = r.length === void 0 ? [r] : r, angular.forEach(r, function(it) {
          var et = t.defer();
          if (B.push(et.promise), O && (it.type == null || it.type.search(O) !== 0)) {
            et.resolve(!0);
            return;
          }
          v === "dimensions" && a.attrGetter("ngfDimensions", c) != null ? a.imageDimensions(it).then(function(rt) {
            F(
              et,
              it,
              p("ngfDimensions", { $file: it, $width: rt.width, $height: rt.height })
            );
          }, function() {
            et.resolve(!1);
          }) : v === "duration" && a.attrGetter("ngfDuration", c) != null ? a.mediaDuration(it).then(function(rt) {
            F(
              et,
              it,
              p("ngfDuration", { $file: it, $duration: rt })
            );
          }, function() {
            et.resolve(!1);
          }) : F(
            et,
            it,
            a.getValidationAttr(c, d, v, P, it)
          );
        }));
        var Q = t.defer();
        return t.all(B).then(function(it) {
          for (var et = !0, rt = 0; rt < it.length; rt++)
            if (!it[rt]) {
              et = !1;
              break;
            }
          o.$ngfValidations.push({ name: v, valid: et }), Q.resolve(et);
        }), Q.promise;
      }
      var R = t.defer(), C = [];
      return C.push(T(
        "maxHeight",
        "height.max",
        /image/,
        this.imageDimensions,
        function(v, P) {
          return v.height <= P;
        }
      )), C.push(T(
        "minHeight",
        "height.min",
        /image/,
        this.imageDimensions,
        function(v, P) {
          return v.height >= P;
        }
      )), C.push(T(
        "maxWidth",
        "width.max",
        /image/,
        this.imageDimensions,
        function(v, P) {
          return v.width <= P;
        }
      )), C.push(T(
        "minWidth",
        "width.min",
        /image/,
        this.imageDimensions,
        function(v, P) {
          return v.width >= P;
        }
      )), C.push(T(
        "dimensions",
        null,
        /image/,
        function(v, P) {
          return a.emptyPromise(P);
        },
        function(v) {
          return v;
        }
      )), C.push(T(
        "ratio",
        null,
        /image/,
        this.imageDimensions,
        function(v, P) {
          for (var O = P.toString().split(","), N = !1, H = 0; H < O.length; H++)
            Math.abs(v.width / v.height - a.ratioToFloat(O[H])) < 0.01 && (N = !0);
          return N;
        }
      )), C.push(T(
        "maxRatio",
        "ratio.max",
        /image/,
        this.imageDimensions,
        function(v, P) {
          return v.width / v.height - a.ratioToFloat(P) < 1e-4;
        }
      )), C.push(T(
        "minRatio",
        "ratio.min",
        /image/,
        this.imageDimensions,
        function(v, P) {
          return v.width / v.height - a.ratioToFloat(P) > -1e-4;
        }
      )), C.push(T(
        "maxDuration",
        "duration.max",
        /audio|video/,
        this.mediaDuration,
        function(v, P) {
          return v <= a.translateScalars(P);
        }
      )), C.push(T(
        "minDuration",
        "duration.min",
        /audio|video/,
        this.mediaDuration,
        function(v, P) {
          return v >= a.translateScalars(P);
        }
      )), C.push(T(
        "duration",
        null,
        /audio|video/,
        function(v, P) {
          return a.emptyPromise(P);
        },
        function(v) {
          return v;
        }
      )), C.push(T(
        "validateAsyncFn",
        null,
        null,
        function(v, P) {
          return P;
        },
        function(v) {
          return v === !0 || v === null || v === "";
        }
      )), t.all(C).then(function() {
        if (g)
          for (var v = 0; v < r.length; v++) {
            var P = r[v];
            P.$error && r.splice(v--, 1);
          }
        g = !1, b("maxFiles", null, function(O, N, H) {
          return l + H < N;
        }), R.resolve({ validFiles: r, invalidFiles: x });
      }), R.promise;
    }, a.imageDimensions = function(r) {
      if (r.$ngfWidth && r.$ngfHeight) {
        var l = t.defer();
        return e(function() {
          l.resolve({ width: r.$ngfWidth, height: r.$ngfHeight });
        }), l.promise;
      }
      if (r.$ngfDimensionPromise)
        return r.$ngfDimensionPromise;
      var o = t.defer();
      return e(function() {
        if (r.type.indexOf("image") !== 0) {
          o.reject("not image");
          return;
        }
        a.dataUrl(r).then(function(c) {
          var d = angular.element("<img>").attr("src", c).css("visibility", "hidden").css("position", "fixed").css("max-width", "none !important").css("max-height", "none !important");
          function p() {
            var b = d[0].naturalWidth || d[0].clientWidth, A = d[0].naturalHeight || d[0].clientHeight;
            d.remove(), r.$ngfWidth = b, r.$ngfHeight = A, o.resolve({ width: b, height: A });
          }
          function h() {
            d.remove(), o.reject("load error");
          }
          d.on("load", p), d.on("error", h);
          var g = 0;
          function x() {
            e(function() {
              d[0].parentNode && (d[0].clientWidth ? p() : g++ > 10 ? h() : x());
            }, 1e3);
          }
          x(), angular.element(document.getElementsByTagName("body")[0]).append(d);
        }, function() {
          o.reject("load error");
        });
      }), r.$ngfDimensionPromise = o.promise, r.$ngfDimensionPromise.finally(function() {
        delete r.$ngfDimensionPromise;
      }), r.$ngfDimensionPromise;
    }, a.mediaDuration = function(r) {
      if (r.$ngfDuration) {
        var l = t.defer();
        return e(function() {
          l.resolve(r.$ngfDuration);
        }), l.promise;
      }
      if (r.$ngfDurationPromise)
        return r.$ngfDurationPromise;
      var o = t.defer();
      return e(function() {
        if (r.type.indexOf("audio") !== 0 && r.type.indexOf("video") !== 0) {
          o.reject("not media");
          return;
        }
        a.dataUrl(r).then(function(c) {
          var d = angular.element(r.type.indexOf("audio") === 0 ? "<audio>" : "<video>").attr("src", c).css("visibility", "none").css("position", "fixed");
          function p() {
            var x = d[0].duration;
            r.$ngfDuration = x, d.remove(), o.resolve(x);
          }
          function h() {
            d.remove(), o.reject("load error");
          }
          d.on("loadedmetadata", p), d.on("error", h);
          function g() {
            e(function() {
              d[0].parentNode && (d[0].duration ? p() : g());
            }, 1e3);
          }
          g(), angular.element(document.body).append(d);
        }, function() {
          o.reject("load error");
        });
      }), r.$ngfDurationPromise = o.promise, r.$ngfDurationPromise.finally(function() {
        delete r.$ngfDurationPromise;
      }), r.$ngfDurationPromise;
    }, a;
  }
]);
Gn.service("UploadResize", ["UploadValidate", "$q", function(s, t) {
  var e = s, a = function(i, r, l, o, c) {
    var d = c ? Math.max(l / i, o / r) : Math.min(l / i, o / r);
    return {
      width: i * d,
      height: r * d,
      marginX: i * d - l,
      marginY: r * d - o
    };
  }, n = function(i, r, l, o, c, d, p, h) {
    var g = t.defer(), x = document.createElement("canvas"), b = document.createElement("img");
    return b.setAttribute("style", "visibility:hidden;position:fixed;z-index:-100000"), document.body.appendChild(b), b.onload = function() {
      var A = b.width, T = b.height;
      if (b.parentNode.removeChild(b), h != null && h(A, T) === !1) {
        g.reject("resizeIf");
        return;
      }
      try {
        if (d) {
          var R = e.ratioToFloat(d), C = A / T;
          C < R ? (r = A, l = r / R) : (l = T, r = l * R);
        }
        r || (r = A), l || (l = T);
        var v = a(A, T, r, l, p);
        x.width = Math.min(v.width, r), x.height = Math.min(v.height, l);
        var P = x.getContext("2d");
        P.drawImage(
          b,
          Math.min(0, -v.marginX / 2),
          Math.min(0, -v.marginY / 2),
          v.width,
          v.height
        ), g.resolve(x.toDataURL(c || "image/WebP", o || 0.934));
      } catch (O) {
        g.reject(O);
      }
    }, b.onerror = function() {
      b.parentNode.removeChild(b), g.reject();
    }, b.src = i, g.promise;
  };
  return e.dataUrltoBlob = function(i, r, l) {
    for (var o = i.split(","), c = o[0].match(/:(.*?);/)[1], d = atob(o[1]), p = d.length, h = new Uint8Array(p); p--; )
      h[p] = d.charCodeAt(p);
    var g = new window.Blob([h], { type: c });
    return g.name = r, g.$ngfOrigSize = l, g;
  }, e.isResizeSupported = function() {
    var i = document.createElement("canvas");
    return window.atob && i.getContext && i.getContext("2d") && window.Blob;
  }, e.isResizeSupported() && Object.defineProperty(window.Blob.prototype, "name", {
    get: function() {
      return this.$ngfName;
    },
    set: function(i) {
      this.$ngfName = i;
    },
    configurable: !0
  }), e.resize = function(i, r) {
    if (i.type.indexOf("image") !== 0)
      return e.emptyPromise(i);
    var l = t.defer();
    return e.dataUrl(i, !0).then(function(o) {
      n(
        o,
        r.width,
        r.height,
        r.quality,
        r.type || i.type,
        r.ratio,
        r.centerCrop,
        r.resizeIf
      ).then(function(c) {
        if (i.type === "image/jpeg" && r.restoreExif !== !1)
          try {
            c = e.restoreExif(o, c);
          } catch (p) {
            setTimeout(function() {
              throw p;
            }, 1);
          }
        try {
          var d = e.dataUrltoBlob(c, i.name, i.size);
          l.resolve(d);
        } catch (p) {
          l.reject(p);
        }
      }, function(c) {
        c === "resizeIf" && l.resolve(i), l.reject(c);
      });
    }, function(o) {
      l.reject(o);
    }), l.promise;
  }, e;
}]);
(function() {
  Gn.directive("ngfDrop", [
    "$parse",
    "$timeout",
    "$window",
    "Upload",
    "$http",
    "$q",
    function(e, a, n, i, r, l) {
      return {
        restrict: "AEC",
        require: "?ngModel",
        link: function(o, c, d, p) {
          s(o, c, d, p, e, a, n, i, r, l);
        }
      };
    }
  ]), Gn.directive("ngfNoFileDrop", function() {
    return function(e, a) {
      t() && a.css("display", "none");
    };
  }), Gn.directive("ngfDropAvailable", ["$parse", "$timeout", "Upload", function(e, a, n) {
    return function(i, r, l) {
      if (t()) {
        var o = e(n.attrGetter("ngfDropAvailable", l));
        a(function() {
          o(i), o.assign && o.assign(i, !0);
        });
      }
    };
  }]);
  function s(e, a, n, i, r, l, o, c, d, p) {
    var h = t(), g = function(H, F, B) {
      return c.attrGetter(H, n, F, B);
    };
    if (g("dropAvailable") && l(function() {
      e[g("dropAvailable")] ? e[g("dropAvailable")].value = h : e[g("dropAvailable")] = h;
    }), !h) {
      g("ngfHideOnDropNotAvailable", e) === !0 && a.css("display", "none");
      return;
    }
    function x() {
      return a.attr("disabled") || g("ngfDropDisabled", e);
    }
    g("ngfSelect") == null && c.registerModelChangeValidator(i, n, e);
    var b = null, A = r(g("ngfStopPropagation")), T = 1, R;
    a[0].addEventListener("dragover", function(H) {
      if (!(x() || !c.shouldUpdateOn("drop", n, e))) {
        if (H.preventDefault(), A(e) && H.stopPropagation(), navigator.userAgent.indexOf("Chrome") > -1) {
          var F = H.dataTransfer.effectAllowed;
          H.dataTransfer.dropEffect = F === "move" || F === "linkMove" ? "move" : "copy";
        }
        l.cancel(b), R || (R = "C", O(e, n, H, function(B) {
          R = B, a.addClass(R), g("ngfDrag", e, { $isDragging: !0, $class: R, $event: H });
        }));
      }
    }, !1), a[0].addEventListener("dragenter", function(H) {
      x() || !c.shouldUpdateOn("drop", n, e) || (H.preventDefault(), A(e) && H.stopPropagation());
    }, !1), a[0].addEventListener("dragleave", function(H) {
      x() || !c.shouldUpdateOn("drop", n, e) || (H.preventDefault(), A(e) && H.stopPropagation(), b = l(function() {
        R && a.removeClass(R), R = null, g("ngfDrag", e, { $isDragging: !1, $event: H });
      }, T || 100));
    }, !1), a[0].addEventListener("drop", function(H) {
      x() || !c.shouldUpdateOn("drop", n, e) || (H.preventDefault(), A(e) && H.stopPropagation(), R && a.removeClass(R), R = null, C(H.dataTransfer, H, "dropUrl"));
    }, !1), a[0].addEventListener("paste", function(H) {
      navigator.userAgent.toLowerCase().indexOf("firefox") > -1 && g("ngfEnableFirefoxPaste", e) && H.preventDefault(), !(x() || !c.shouldUpdateOn("paste", n, e)) && C(H.clipboardData || H.originalEvent.clipboardData, H, "pasteUrl");
    }, !1), navigator.userAgent.toLowerCase().indexOf("firefox") > -1 && g("ngfEnableFirefoxPaste", e) && (a.attr("contenteditable", !0), a.on("keypress", function(H) {
      !H.metaKey && !H.ctrlKey && H.preventDefault();
    }));
    function C(H, F, B) {
      if (H) {
        var Q;
        try {
          Q = H && H.getData && H.getData("text/html");
        } catch {
        }
        N(
          H.items,
          H.files,
          g("ngfAllowDir", e) !== !1,
          g("multiple") || g("ngfMultiple", e)
        ).then(function(it) {
          it.length ? v(it, F) : P(B, Q).then(function(et) {
            v(et, F);
          });
        });
      }
    }
    function v(H, F) {
      c.updateModel(i, n, e, g("ngfChange") || g("ngfDrop"), H, F);
    }
    function P(H, F) {
      if (!c.shouldUpdateOn(H, n, e) || typeof F != "string")
        return c.rejectPromise([]);
      var B = [];
      F.replace(/<(img src|img [^>]* src) *=\"([^\"]*)\"/gi, function(rt, U, M) {
        B.push(M);
      });
      var Q = [], it = [];
      if (B.length) {
        angular.forEach(B, function(rt) {
          Q.push(c.urlToBlob(rt).then(function(U) {
            it.push(U);
          }));
        });
        var et = p.defer();
        return p.all(Q).then(function() {
          et.resolve(it);
        }, function(rt) {
          et.reject(rt);
        }), et.promise;
      }
      return c.emptyPromise();
    }
    function O(H, F, B, Q) {
      var it = g("ngfDragOverClass", H, { $event: B }), et = "dragover";
      if (angular.isString(it))
        et = it;
      else if (it && (it.delay && (T = it.delay), it.accept || it.reject)) {
        var rt = B.dataTransfer.items;
        if (rt == null || !rt.length)
          et = it.accept;
        else
          for (var U = it.pattern || g("ngfPattern", H, { $event: B }), M = rt.length; M--; )
            if (c.validatePattern(rt[M], U))
              et = it.accept;
            else {
              et = it.reject;
              break;
            }
      }
      Q(et);
    }
    function N(H, F, B, Q) {
      var it = c.getValidationAttr(n, e, "maxFiles");
      it == null && (it = Number.MAX_VALUE);
      var et = c.getValidationAttr(n, e, "maxTotalSize");
      et == null && (et = Number.MAX_VALUE);
      var rt = g("ngfIncludeDir", e), U = [], M = 0;
      function W(at, nt) {
        var yt = p.defer();
        if (at != null)
          if (at.isDirectory) {
            var Rt = [c.emptyPromise()];
            if (rt) {
              var Yt = { type: "directory" };
              Yt.name = Yt.path = (nt || "") + at.name, U.push(Yt);
            }
            var K = at.createReader(), _ = [], V = function() {
              K.readEntries(function(G) {
                try {
                  G.length ? (_ = _.concat(Array.prototype.slice.call(G || [], 0)), V()) : (angular.forEach(_.slice(0), function(dt) {
                    U.length <= it && M <= et && Rt.push(W(dt, (nt || "") + at.name + "/"));
                  }), p.all(Rt).then(function() {
                    yt.resolve();
                  }, function(dt) {
                    yt.reject(dt);
                  }));
                } catch (dt) {
                  yt.reject(dt);
                }
              }, function(G) {
                yt.reject(G);
              });
            };
            V();
          } else
            at.file(function(G) {
              try {
                G.path = (nt || "") + G.name, rt && (G = c.rename(G, G.path)), U.push(G), M += G.size, yt.resolve();
              } catch (dt) {
                yt.reject(dt);
              }
            }, function(G) {
              yt.reject(G);
            });
        return yt.promise;
      }
      var J = [c.emptyPromise()];
      if (H && H.length > 0 && o.location.protocol !== "file:")
        for (var vt = 0; vt < H.length; vt++) {
          if (H[vt].webkitGetAsEntry && H[vt].webkitGetAsEntry() && H[vt].webkitGetAsEntry().isDirectory) {
            var St = H[vt].webkitGetAsEntry();
            if (St.isDirectory && !B)
              continue;
            St != null && J.push(W(St));
          } else {
            var zt = H[vt].getAsFile();
            zt != null && (U.push(zt), M += zt.size);
          }
          if (U.length > it || M > et || !Q && U.length > 0)
            break;
        }
      else if (F != null)
        for (var j = 0; j < F.length; j++) {
          var tt = F.item(j);
          if ((tt.type || tt.size > 0) && (U.push(tt), M += tt.size), U.length > it || M > et || !Q && U.length > 0)
            break;
        }
      var lt = p.defer();
      return p.all(J).then(function() {
        if (!Q && !rt && U.length) {
          for (var at = 0; U[at] && U[at].type === "directory"; )
            at++;
          lt.resolve([U[at]]);
        } else
          lt.resolve(U);
      }, function(at) {
        lt.reject(at);
      }), lt.promise;
    }
  }
  function t() {
    var e = document.createElement("div");
    return "draggable" in e && "ondrop" in e && !/Edge\/12./i.test(navigator.userAgent);
  }
})();
Gn.service("UploadExif", ["UploadResize", "$q", function(s, t) {
  var e = s;
  e.isExifSupported = function() {
    return window.FileReader && new FileReader().readAsArrayBuffer && e.isResizeSupported();
  };
  function a(i, r, l, o) {
    switch (r) {
      case 2:
        return i.transform(-1, 0, 0, 1, l, 0);
      case 3:
        return i.transform(-1, 0, 0, -1, l, o);
      case 4:
        return i.transform(1, 0, 0, -1, 0, o);
      case 5:
        return i.transform(0, 1, 1, 0, 0, 0);
      case 6:
        return i.transform(0, 1, -1, 0, o, 0);
      case 7:
        return i.transform(0, -1, -1, 0, o, l);
      case 8:
        return i.transform(0, -1, 1, 0, 0, l);
    }
  }
  e.readOrientation = function(i) {
    var r = t.defer(), l = new FileReader(), o = i.slice ? i.slice(0, 64 * 1024) : i;
    return l.readAsArrayBuffer(o), l.onerror = function(c) {
      return r.reject(c);
    }, l.onload = function(c) {
      var d = { orientation: 1 }, p = new DataView(this.result);
      if (p.getUint16(0, !1) !== 65496)
        return r.resolve(d);
      for (var h = p.byteLength, g = 2; g < h; ) {
        var x = p.getUint16(g, !1);
        if (g += 2, x === 65505) {
          if (p.getUint32(g += 2, !1) !== 1165519206)
            return r.resolve(d);
          var b = p.getUint16(g += 6, !1) === 18761;
          g += p.getUint32(g + 4, b);
          var A = p.getUint16(g, b);
          g += 2;
          for (var T = 0; T < A; T++)
            if (p.getUint16(g + T * 12, b) === 274) {
              var R = p.getUint16(g + T * 12 + 8, b);
              return R >= 2 && R <= 8 && (p.setUint16(g + T * 12 + 8, 1, b), d.fixedArrayBuffer = c.target.result), d.orientation = R, r.resolve(d);
            }
        } else {
          if ((x & 65280) !== 65280)
            break;
          g += p.getUint16(g, !1);
        }
      }
      return r.resolve(d);
    }, r.promise;
  };
  function n(i) {
    for (var r = "", l = new Uint8Array(i), o = l.byteLength, c = 0; c < o; c++)
      r += String.fromCharCode(l[c]);
    return window.btoa(r);
  }
  return e.applyExifRotation = function(i) {
    if (i.type.indexOf("image/jpeg") !== 0)
      return e.emptyPromise(i);
    var r = t.defer();
    return e.readOrientation(i).then(function(l) {
      if (l.orientation < 2 || l.orientation > 8)
        return r.resolve(i);
      e.dataUrl(i, !0).then(function(o) {
        var c = document.createElement("canvas"), d = document.createElement("img");
        d.onload = function() {
          try {
            c.width = l.orientation > 4 ? d.height : d.width, c.height = l.orientation > 4 ? d.width : d.height;
            var p = c.getContext("2d");
            a(p, l.orientation, d.width, d.height), p.drawImage(d, 0, 0);
            var h = c.toDataURL(i.type || "image/WebP", 0.934);
            h = e.restoreExif(n(l.fixedArrayBuffer), h);
            var g = e.dataUrltoBlob(h, i.name);
            r.resolve(g);
          } catch (x) {
            return r.reject(x);
          }
        }, d.onerror = function() {
          r.reject();
        }, d.src = o;
      }, function(o) {
        r.reject(o);
      });
    }, function(l) {
      r.reject(l);
    }), r.promise;
  }, e.restoreExif = function(i, r) {
    var l = {};
    return l.KEY_STR = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", l.encode64 = function(o) {
      var c = "", d, p, h = "", g, x, b, A = "", T = 0;
      do
        d = o[T++], p = o[T++], h = o[T++], g = d >> 2, x = (d & 3) << 4 | p >> 4, b = (p & 15) << 2 | h >> 6, A = h & 63, isNaN(p) ? b = A = 64 : isNaN(h) && (A = 64), c = c + this.KEY_STR.charAt(g) + this.KEY_STR.charAt(x) + this.KEY_STR.charAt(b) + this.KEY_STR.charAt(A), d = p = h = "", g = x = b = A = "";
      while (T < o.length);
      return c;
    }, l.restore = function(o, c) {
      o.match("data:image/jpeg;base64,") && (o = o.replace("data:image/jpeg;base64,", ""));
      var d = this.decode64(o), p = this.slice2Segments(d), h = this.exifManipulation(c, p);
      return "data:image/jpeg;base64," + this.encode64(h);
    }, l.exifManipulation = function(o, c) {
      var d = this.getExifArray(c), p = this.insertExif(o, d);
      return new Uint8Array(p);
    }, l.getExifArray = function(o) {
      for (var c, d = 0; d < o.length; d++)
        if (c = o[d], c[0] === 255 & c[1] === 225)
          return c;
      return [];
    }, l.insertExif = function(o, c) {
      var d = o.replace("data:image/jpeg;base64,", ""), p = this.decode64(d), h = p.indexOf(255, 3), g = p.slice(0, h), x = p.slice(h), b = g;
      return b = b.concat(c), b = b.concat(x), b;
    }, l.slice2Segments = function(o) {
      for (var c = 0, d = []; !(o[c] === 255 & o[c + 1] === 218); ) {
        if (o[c] === 255 & o[c + 1] === 216)
          c += 2;
        else {
          var p = o[c + 2] * 256 + o[c + 3], h = c + p + 2, g = o.slice(c, h);
          d.push(g), c = h;
        }
        if (c > o.length)
          break;
      }
      return d;
    }, l.decode64 = function(o) {
      var c, d, p = "", h, g, x, b = "", A = 0, T = [], R = /[^A-Za-z0-9\+\/\=]/g;
      R.exec(o) && console.log(`There were invalid base64 characters in the input text.
Valid base64 characters are A-Z, a-z, 0-9, ` + ", " / `,and "="
` + "Expect errors in decoding."), o = o.replace(/[^A-Za-z0-9\+\/\=]/g, "");
      do
        h = this.KEY_STR.indexOf(o.charAt(A++)), g = this.KEY_STR.indexOf(o.charAt(A++)), x = this.KEY_STR.indexOf(o.charAt(A++)), b = this.KEY_STR.indexOf(o.charAt(A++)), c = h << 2 | g >> 4, d = (g & 15) << 4 | x >> 2, p = (x & 3) << 6 | b, T.push(c), x !== 64 && T.push(d), b !== 64 && T.push(p), c = d = p = "", h = g = x = b = "";
      while (A < o.length);
      return T;
    }, l.restore(i, r);
  }, e;
}]);
var x9 = "ngFileUpload";
const w9 = /* @__PURE__ */ Hs(x9);
var hR = { exports: {} };
/*!
 * angular-translate - v2.19.1 - 2024-01-21
 * 
 * Copyright (c) 2024 The angular-translate team, Pascal Precht; Licensed MIT
 */
(function(s) {
  (function(t, e) {
    s.exports ? s.exports = e() : e();
  })(Rs, function() {
    t.$inject = ["$translate"], a.$inject = ["$STORAGE_KEY", "$windowProvider", "$translateSanitizationProvider", "pascalprechtTranslateOverrider"], n.$inject = ["$interpolate", "$translateSanitization"], i.$inject = ["$translate", "$interpolate", "$compile", "$parse", "$rootScope"], l.$inject = ["$translate", "$rootScope"], c.$inject = ["$translate", "$rootScope"], g.$inject = ["$parse", "$translate"], x.$inject = ["$cacheFactory"], angular.module("pascalprecht.translate", ["ng"]).run(t);
    function t(b) {
      var A = b.storageKey(), T = b.storage(), R = function() {
        var C = b.preferredLanguage();
        angular.isString(C) ? b.use(C) : T.put(A, b.use());
      };
      R.displayName = "fallbackFromIncorrectStorageValue", T ? T.get(A) ? b.use(T.get(A)).catch(R) : R() : angular.isString(b.preferredLanguage()) && b.use(b.preferredLanguage());
    }
    t.displayName = "runTranslate", angular.module("pascalprecht.translate").provider("$translateSanitization", e);
    function e() {
      var b, A, T = null, R = !1, C = !1, v;
      v = {
        sanitize: function(F, B) {
          return B === "text" && (F = O(F)), F;
        },
        escape: function(F, B) {
          return B === "text" && (F = P(F)), F;
        },
        sanitizeParameters: function(F, B) {
          return B === "params" && (F = H(F, O)), F;
        },
        escapeParameters: function(F, B) {
          return B === "params" && (F = H(F, P)), F;
        },
        sce: function(F, B, Q) {
          return B === "text" ? F = N(F) : B === "params" && Q !== "filter" && (F = H(F, P)), F;
        },
        sceParameters: function(F, B) {
          return B === "params" && (F = H(F, N)), F;
        }
      }, v.escaped = v.escapeParameters, this.addStrategy = function(F, B) {
        return v[F] = B, this;
      }, this.removeStrategy = function(F) {
        return delete v[F], this;
      }, this.useStrategy = function(F) {
        return R = !0, T = F, this;
      }, this.$get = ["$injector", "$log", function(F, B) {
        var Q = {}, it = function(rt, U, M, W) {
          return angular.forEach(W, function(J) {
            if (angular.isFunction(J))
              rt = J(rt, U, M);
            else if (angular.isFunction(v[J]))
              rt = v[J](rt, U, M);
            else if (angular.isString(v[J])) {
              if (!Q[v[J]])
                try {
                  Q[v[J]] = F.get(v[J]);
                } catch {
                  throw Q[v[J]] = function() {
                  }, new Error("pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: '" + J + "'");
                }
              rt = Q[v[J]](rt, U, M);
            } else
              throw new Error("pascalprecht.translate.$translateSanitization: Unknown sanitization strategy: '" + J + "'");
          }), rt;
        }, et = function() {
          !R && !C && (B.warn("pascalprecht.translate.$translateSanitization: No sanitization strategy has been configured. This can have serious security implications. See http://angular-translate.github.io/docs/#/guide/19_security for details."), C = !0);
        };
        return F.has("$sanitize") && (b = F.get("$sanitize")), F.has("$sce") && (A = F.get("$sce")), {
          /**
           * @ngdoc function
           * @name pascalprecht.translate.$translateSanitization#useStrategy
           * @methodOf pascalprecht.translate.$translateSanitization
           *
           * @description
           * Selects a sanitization strategy. When an array is provided the strategies will be executed in order.
           *
           * @param {string|StrategyFunction|array} strategy The sanitization strategy / strategies which should be used. Either a name of an existing strategy, a custom strategy function, or an array consisting of multiple names and / or custom functions.
           */
          useStrategy: /* @__PURE__ */ function(rt) {
            return function(U) {
              rt.useStrategy(U);
            };
          }(this),
          /**
           * @ngdoc function
           * @name pascalprecht.translate.$translateSanitization#sanitize
           * @methodOf pascalprecht.translate.$translateSanitization
           *
           * @description
           * Sanitizes a value.
           *
           * @param {string|object} value The value which should be sanitized.
           * @param {string} mode The current sanitization mode, either 'params' or 'text'.
           * @param {string|StrategyFunction|array} [strategy] Optional custom strategy which should be used instead of the currently selected strategy.
           * @param {string} [context] The context of this call: filter, service. Default is service
           * @returns {string|object} sanitized value
           */
          sanitize: function(rt, U, M, W) {
            if (T || et(), !M && M !== null && (M = T), !M)
              return rt;
            W || (W = "service");
            var J = angular.isArray(M) ? M : [M];
            return it(rt, U, W, J);
          }
        };
      }];
      var P = function(F) {
        var B = angular.element("<div></div>");
        return B.text(F), B.html();
      }, O = function(F) {
        if (!b)
          throw new Error("pascalprecht.translate.$translateSanitization: Error cannot find $sanitize service. Either include the ngSanitize module (https://docs.angularjs.org/api/ngSanitize) or use a sanitization strategy which does not depend on $sanitize, such as 'escape'.");
        return b(F);
      }, N = function(F) {
        if (!A)
          throw new Error("pascalprecht.translate.$translateSanitization: Error cannot find $sce service.");
        return A.trustAsHtml(F);
      }, H = function(F, B, Q) {
        if (angular.isDate(F))
          return F;
        if (angular.isObject(F)) {
          var it = angular.isArray(F) ? [] : {};
          if (!Q)
            Q = [];
          else if (Q.indexOf(F) > -1)
            throw new Error("pascalprecht.translate.$translateSanitization: Error cannot interpolate parameter due recursive object");
          return Q.push(F), angular.forEach(F, function(et, rt) {
            angular.isFunction(et) || (it[rt] = H(et, B, Q));
          }), Q.splice(-1, 1), it;
        } else
          return angular.isNumber(F) || F === !0 || F === !1 ? F : !angular.isUndefined(F) && F !== null ? B(F) : F;
      };
    }
    angular.module("pascalprecht.translate").constant("pascalprechtTranslateOverrider", {}).provider("$translate", a);
    function a(b, A, T, R) {
      var C = {}, v, P = [], O, N, H, F, B, Q, it = b, et, rt, U, M = [], W, J = "translate-cloak", vt, St, zt, j = !1, tt = !1, lt = !0, at = ".", nt = !1, yt = !1, Rt, Yt = 0, K = !0, _, V = "default", G = {
        default: function(Lt) {
          return (Lt || "").split("-").join("_");
        },
        java: function(Lt) {
          var ye = (Lt || "").split("-").join("_"), ue = ye.split("_");
          return ue.length > 1 ? ue[0].toLowerCase() + "_" + ue[1].toUpperCase() : ye;
        },
        bcp47: function(Lt) {
          var ye = (Lt || "").split("_").join("-"), ue = ye.split("-");
          switch (ue.length) {
            case 1:
              ue[0] = ue[0].toLowerCase();
              break;
            case 2:
              ue[0] = ue[0].toLowerCase(), ue[1].length === 4 ? ue[1] = ue[1].charAt(0).toUpperCase() + ue[1].slice(1).toLowerCase() : ue[1] = ue[1].toUpperCase();
              break;
            case 3:
              ue[0] = ue[0].toLowerCase(), ue[1] = ue[1].charAt(0).toUpperCase() + ue[1].slice(1).toLowerCase(), ue[2] = ue[2].toUpperCase();
              break;
            default:
              return ye;
          }
          return ue.join("-");
        },
        "iso639-1": function(Lt) {
          var ye = (Lt || "").split("_").join("-"), ue = ye.split("-");
          return ue[0].toLowerCase();
        }
      }, dt = "2.19.1", ht = function() {
        if (angular.isFunction(R.getLocale))
          return R.getLocale();
        var Lt = A.$get().navigator, ye = ["language", "browserLanguage", "systemLanguage", "userLanguage"], ue, _e;
        if (angular.isArray(Lt.languages)) {
          for (ue = 0; ue < Lt.languages.length; ue++)
            if (_e = Lt.languages[ue], _e && _e.length)
              return _e;
        }
        for (ue = 0; ue < ye.length; ue++)
          if (_e = Lt[ye[ue]], _e && _e.length)
            return _e;
        return null;
      };
      ht.displayName = "angular-translate/service: getFirstBrowserLanguage";
      var ot = function() {
        var Lt = ht() || "";
        return G[V] && (Lt = G[V](Lt)), Lt;
      };
      ot.displayName = "angular-translate/service: getLocale";
      var $t = function(Lt, ye) {
        for (var ue = 0, _e = Lt.length; ue < _e; ue++)
          if (Lt[ue] === ye)
            return ue;
        return -1;
      }, _t = function() {
        return this.toString().replace(/^\s+|\s+$/g, "");
      }, qt = function(Lt) {
        return angular.isString(Lt) ? Lt.toLowerCase() : Lt;
      }, de = function(Lt) {
        if (Lt) {
          for (var ye = [], ue = qt(Lt), _e = 0, la = P.length; _e < la; _e++)
            ye.push(qt(P[_e]));
          if (_e = $t(ye, ue), _e > -1)
            return P[_e];
          if (O) {
            var qa;
            for (var je in O)
              if (O.hasOwnProperty(je)) {
                var Aa = !1, ge = Object.prototype.hasOwnProperty.call(O, je) && qt(je) === qt(Lt);
                if (je.slice(-1) === "*" && (Aa = qt(je.slice(0, -1)) === qt(Lt.slice(0, je.length - 1))), (ge || Aa) && (qa = O[je], $t(ye, qt(qa)) > -1))
                  return qa;
              }
          }
          var Ka = Lt.split("_");
          if (Ka.length > 1 && $t(ye, qt(Ka[0])) > -1)
            return Ka[0];
        }
      }, me = function(Lt, ye) {
        if (!Lt && !ye)
          return C;
        if (Lt && !ye) {
          if (angular.isString(Lt))
            return C[Lt];
        } else
          angular.isObject(C[Lt]) || (C[Lt] = {}), angular.extend(C[Lt], Ht(ye));
        return this;
      };
      this.translations = me, this.cloakClassName = function(Lt) {
        return Lt ? (J = Lt, this) : J;
      }, this.allowNamespaces = function(Lt) {
        return Lt === void 0 ? lt : (lt = Lt, this);
      }, this.nestedObjectDelimeter = function(Lt) {
        return Lt ? (at = Lt, this) : at;
      };
      var Ht = function(Lt, ye, ue, _e) {
        var la, qa, je, Aa;
        if (ye || (ye = []), ue || (ue = {}), !lt)
          return Lt;
        for (la in Lt)
          Object.prototype.hasOwnProperty.call(Lt, la) && (Aa = Lt[la], angular.isObject(Aa) ? Ht(Aa, ye.concat(la), ue, la) : (qa = ye.length ? "" + ye.join(at) + at + la : la, ye.length && la === _e && (je = "" + ye.join(at), ue[je] = "@:" + qa), ue[qa] = Aa));
        return ue;
      };
      Ht.displayName = "flatObject", this.addInterpolation = function(Lt) {
        return M.push(Lt), this;
      }, this.useMessageFormatInterpolation = function() {
        return this.useInterpolation("$translateMessageFormatInterpolation");
      }, this.useInterpolation = function(Lt) {
        return U = Lt, this;
      }, this.useSanitizeValueStrategy = function(Lt) {
        return T.useStrategy(Lt), this;
      }, this.preferredLanguage = function(Lt) {
        return Lt ? (oe(Lt), this) : v;
      };
      var oe = function(Lt) {
        return Lt && (v = Lt), v;
      };
      this.translationNotFoundIndicator = function(Lt) {
        return this.translationNotFoundIndicatorLeft(Lt), this.translationNotFoundIndicatorRight(Lt), this;
      }, this.translationNotFoundIndicatorLeft = function(Lt) {
        return Lt ? (St = Lt, this) : St;
      }, this.translationNotFoundIndicatorRight = function(Lt) {
        return Lt ? (zt = Lt, this) : zt;
      }, this.fallbackLanguage = function(Lt) {
        return Ye(Lt), this;
      };
      var Ye = function(Lt) {
        return Lt ? (angular.isString(Lt) ? (H = !0, N = [Lt]) : angular.isArray(Lt) && (H = !1, N = Lt), angular.isString(v) && $t(N, v) < 0 && N.push(v), this) : H ? N[0] : N;
      };
      this.use = function(Lt) {
        if (Lt) {
          if (!C[Lt] && !W)
            throw new Error("$translateProvider couldn't find translationTable for langKey: '" + Lt + "'");
          return F = Lt, this;
        }
        return F;
      }, this.resolveClientLocale = function() {
        return ot();
      };
      var ze = function(Lt) {
        return Lt ? (it = Lt, this) : et ? et + it : it;
      };
      this.storageKey = ze, this.useUrlLoader = function(Lt, ye) {
        return this.useLoader("$translateUrlLoader", angular.extend({ url: Lt }, ye));
      }, this.useStaticFilesLoader = function(Lt) {
        return this.useLoader("$translateStaticFilesLoader", Lt);
      }, this.useLoader = function(Lt, ye) {
        return W = Lt, vt = ye || {}, this;
      }, this.useLocalStorage = function() {
        return this.useStorage("$translateLocalStorage");
      }, this.useCookieStorage = function() {
        return this.useStorage("$translateCookieStorage");
      }, this.useStorage = function(Lt) {
        return Q = Lt, this;
      }, this.storagePrefix = function(Lt) {
        return Lt && (et = Lt, this);
      }, this.useMissingTranslationHandlerLog = function() {
        return this.useMissingTranslationHandler("$translateMissingTranslationHandlerLog");
      }, this.useMissingTranslationHandler = function(Lt) {
        return rt = Lt, this;
      }, this.usePostCompiling = function(Lt) {
        return j = !!Lt, this;
      }, this.forceAsyncReload = function(Lt) {
        return tt = !!Lt, this;
      }, this.uniformLanguageTag = function(Lt) {
        return Lt ? angular.isString(Lt) && (Lt = {
          standard: Lt
        }) : Lt = {}, V = Lt.standard, this;
      }, this.determinePreferredLanguage = function(Lt) {
        var ye = Lt && angular.isFunction(Lt) ? Lt() : ot();
        return P.length ? v = de(ye) || ye : v = ye, this;
      }, this.registerAvailableLanguageKeys = function(Lt, ye) {
        return Lt ? (P = Lt, ye && (O = ye), this) : P;
      }, this.useLoaderCache = function(Lt) {
        return Lt === !1 ? Rt = void 0 : Lt === !0 ? Rt = !0 : typeof Lt > "u" ? Rt = "$translationCache" : Lt && (Rt = Lt), this;
      }, this.directivePriority = function(Lt) {
        return Lt === void 0 ? Yt : (Yt = Lt, this);
      }, this.statefulFilter = function(Lt) {
        return Lt === void 0 ? K : (K = Lt, this);
      }, this.postProcess = function(Lt) {
        return Lt ? _ = Lt : _ = void 0, this;
      }, this.keepContent = function(Lt) {
        return yt = !!Lt, this;
      }, this.$get = ["$log", "$injector", "$rootScope", "$q", function(Lt, ye, ue, _e) {
        var la, qa = ye.get(U || "$translateDefaultInterpolation"), je = !1, Aa = {}, ge = {}, Ka, sn, Ie = function(Pt, jt, ke, pe, Pe, Te) {
          !F && v && (F = v);
          var Ce = Pe && Pe !== F ? (
            // we don't want to re-negotiate $uses
            de(Pe) || Pe
          ) : F;
          if (Pe && hp(Pe), angular.isArray(Pt)) {
            var Ee = function(Ja) {
              for (var _n = {}, ci = [], Zi = function(td) {
                var ed = _e.defer(), yp = function(fp) {
                  _n[td] = fp, ed.resolve([td, fp]);
                };
                return Ie(td, jt, ke, pe, Pe, Te).then(yp, yp), ed.promise;
              }, Zc = 0, Ts = Ja.length; Zc < Ts; Zc++)
                ci.push(Zi(Ja[Zc]));
              return _e.all(ci).then(function() {
                return _n;
              });
            };
            return Ee(Pt);
          }
          var Ea = _e.defer();
          if (Pt)
            Pt = _t.apply(Pt);
          else
            throw new TypeError("translationId must be a not empty string");
          var na = function() {
            var Ja = ge[Ce] || ge[v];
            if (Ka = 0, Q && !Ja) {
              var _n = la.get(it);
              if (Ja = ge[_n], N && N.length) {
                var ci = $t(N, _n);
                Ka = ci === 0 ? 1 : 0, $t(N, v) < 0 && N.push(v);
              }
            }
            return Ja;
          }();
          if (!na)
            Jn(Pt, jt, ke, pe, Ce, Te).then(Ea.resolve, Ea.reject);
          else {
            var Qn = function() {
              Pe || (Ce = F), Jn(Pt, jt, ke, pe, Ce, Te).then(Ea.resolve, Ea.reject);
            };
            Qn.displayName = "promiseResolved", na.finally(Qn).catch(angular.noop);
          }
          return Ea.promise;
        }, Ss = function(Pt) {
          return St && (Pt = [St, Pt].join(" ")), zt && (Pt = [Pt, zt].join(" ")), Pt;
        }, ks = function(Pt) {
          F = Pt, Q && la.put(Ie.storageKey(), F), ue.$emit("$translateChangeSuccess", { language: Pt }), qa.setLocale(F);
          var jt = function(ke, pe) {
            Aa[pe].setLocale(F);
          };
          jt.displayName = "eachInterpolatorLocaleSetter", angular.forEach(Aa, jt), ue.$emit("$translateChangeEnd", { language: Pt });
        }, Tr = function(Pt) {
          if (!Pt)
            throw "No language key specified for loading.";
          var jt = _e.defer();
          ue.$emit("$translateLoadingStart", { language: Pt }), je = !0;
          var ke = Rt;
          typeof ke == "string" && (ke = ye.get(ke));
          var pe = angular.extend({}, vt, {
            key: Pt,
            $http: angular.extend({}, {
              cache: ke
            }, vt.$http)
          }), Pe = function(Ce) {
            var Ee = {};
            ue.$emit("$translateLoadingSuccess", { language: Pt }), angular.isArray(Ce) ? angular.forEach(Ce, function(Ea) {
              angular.extend(Ee, Ht(Ea));
            }) : angular.extend(Ee, Ht(Ce)), je = !1, jt.resolve({
              key: Pt,
              table: Ee
            }), ue.$emit("$translateLoadingEnd", { language: Pt });
          };
          Pe.displayName = "onLoaderSuccess";
          var Te = function(Ce) {
            ue.$emit("$translateLoadingError", { language: Ce }), jt.reject(Ce), ue.$emit("$translateLoadingEnd", { language: Ce });
          };
          return Te.displayName = "onLoaderError", ye.get(W)(pe).then(Pe, Te), jt.promise;
        };
        if (Q && (la = ye.get(Q), !la.get || !la.put))
          throw new Error("Couldn't use storage '" + Q + "', missing get() or put() method!");
        if (M.length) {
          var pp = function(Pt) {
            var jt = ye.get(Pt);
            jt.setLocale(v || F), Aa[jt.getInterpolationIdentifier()] = jt;
          };
          pp.displayName = "interpolationFactoryAdder", angular.forEach(M, pp);
        }
        var jc = function(Pt) {
          var jt = _e.defer();
          if (Object.prototype.hasOwnProperty.call(C, Pt))
            jt.resolve(C[Pt]);
          else if (ge[Pt]) {
            var ke = function(pe) {
              me(pe.key, pe.table), jt.resolve(pe.table);
            };
            ke.displayName = "translationTableResolver", ge[Pt].then(ke, jt.reject);
          } else
            jt.reject();
          return jt.promise;
        }, Vc = function(Pt, jt, ke, pe, Pe) {
          var Te = _e.defer(), Ce = function(Ee) {
            if (Object.prototype.hasOwnProperty.call(Ee, jt) && Ee[jt] !== null) {
              pe.setLocale(Pt);
              var Ea = Ee[jt];
              if (Ea.substr(0, 2) === "@:")
                Vc(Pt, Ea.substr(2), ke, pe, Pe).then(Te.resolve, Te.reject);
              else {
                var na = pe.interpolate(Ee[jt], ke, "service", Pe, jt);
                na = go(jt, Ee[jt], na, ke, Pt), Te.resolve(na);
              }
              pe.setLocale(F);
            } else
              Te.reject();
          };
          return Ce.displayName = "fallbackTranslationResolver", jc(Pt).then(Ce, Te.reject), Te.promise;
        }, hl = function(Pt, jt, ke, pe, Pe) {
          var Te, Ce = C[Pt];
          if (Ce && Object.prototype.hasOwnProperty.call(Ce, jt) && Ce[jt] !== null) {
            if (pe.setLocale(Pt), Te = pe.interpolate(Ce[jt], ke, "filter", Pe, jt), Te = go(jt, Ce[jt], Te, ke, Pt, Pe), !angular.isString(Te) && angular.isFunction(Te.$$unwrapTrustedValue)) {
              var Ee = Te.$$unwrapTrustedValue();
              if (Ee.substr(0, 2) === "@:")
                return hl(Pt, Ee.substr(2), ke, pe, Pe);
            } else if (Te.substr(0, 2) === "@:")
              return hl(Pt, Te.substr(2), ke, pe, Pe);
            pe.setLocale(F);
          }
          return Te;
        }, Kn = function(Pt, jt, ke, pe) {
          return rt ? ye.get(rt)(Pt, F, jt, ke, pe) : Pt;
        }, qc = function(Pt, jt, ke, pe, Pe, Te) {
          var Ce = _e.defer();
          if (Pt < N.length) {
            var Ee = N[Pt];
            Vc(Ee, jt, ke, pe, Te).then(
              function(na) {
                Ce.resolve(na);
              },
              function() {
                return qc(Pt + 1, jt, ke, pe, Pe, Te).then(Ce.resolve, Ce.reject);
              }
            );
          } else if (Pe)
            Ce.resolve(Pe);
          else {
            var Ea = Kn(jt, ke, Pe);
            rt && Ea ? Ce.resolve(Ea) : Ce.reject(Ss(jt));
          }
          return Ce.promise;
        }, mo = function(Pt, jt, ke, pe, Pe) {
          var Te;
          if (Pt < N.length) {
            var Ce = N[Pt];
            Te = hl(Ce, jt, ke, pe, Pe), !Te && Te !== "" && (Te = mo(Pt + 1, jt, ke, pe));
          }
          return Te;
        }, Lf = function(Pt, jt, ke, pe, Pe) {
          return qc(sn > 0 ? sn : Ka, Pt, jt, ke, pe, Pe);
        }, Kc = function(Pt, jt, ke, pe) {
          return mo(sn > 0 ? sn : Ka, Pt, jt, ke, pe);
        }, Jn = function(Pt, jt, ke, pe, Pe, Te) {
          var Ce = _e.defer(), Ee = Pe ? C[Pe] : C, Ea = ke ? Aa[ke] : qa;
          if (Ee && Object.prototype.hasOwnProperty.call(Ee, Pt) && Ee[Pt] !== null) {
            var na = Ee[Pt];
            if (na.substr(0, 2) === "@:")
              Ie(na.substr(2), jt, ke, pe, Pe, Te).then(Ce.resolve, Ce.reject);
            else {
              var Qn = Ea.interpolate(na, jt, "service", Te, Pt);
              Qn = go(Pt, na, Qn, jt, Pe), Ce.resolve(Qn);
            }
          } else {
            var Ja;
            rt && !je && (Ja = Kn(Pt, jt, pe)), Pe && N && N.length ? Lf(Pt, jt, Ea, pe, Te).then(function(_n) {
              Ce.resolve(_n);
            }, function(_n) {
              Ce.reject(Ss(_n));
            }) : rt && !je && Ja ? pe ? Ce.resolve(pe) : Ce.resolve(Ja) : pe ? Ce.resolve(pe) : Ce.reject(Ss(Pt));
          }
          return Ce.promise;
        }, Qi = function(Pt, jt, ke, pe, Pe) {
          var Te, Ce = pe ? C[pe] : C, Ee = qa;
          if (Aa && Object.prototype.hasOwnProperty.call(Aa, ke) && (Ee = Aa[ke]), Ce && Object.prototype.hasOwnProperty.call(Ce, Pt) && Ce[Pt] !== null) {
            var Ea = Ce[Pt];
            Ea.substr(0, 2) === "@:" ? Te = Qi(Ea.substr(2), jt, ke, pe, Pe) : (Te = Ee.interpolate(Ea, jt, "filter", Pe, Pt), Te = go(Pt, Ea, Te, jt, pe, Pe));
          } else {
            var na;
            rt && !je && (na = Kn(Pt, jt, Pe)), pe && N && N.length ? (Ka = 0, Te = Kc(Pt, jt, Ee, Pe)) : rt && !je && na ? Te = na : Te = Ss(Pt);
          }
          return Te;
        }, Df = function(Pt) {
          B === Pt && (B = void 0), ge[Pt] = void 0;
        }, go = function(Pt, jt, ke, pe, Pe, Te) {
          var Ce = _;
          return Ce && (typeof Ce == "string" && (Ce = ye.get(Ce)), Ce) ? Ce(Pt, jt, ke, pe, Pe, Te) : ke;
        }, hp = function(Pt) {
          !C[Pt] && W && !ge[Pt] && (ge[Pt] = Tr(Pt).then(function(jt) {
            return me(jt.key, jt.table), jt;
          }));
        };
        Ie.preferredLanguage = function(Pt) {
          return Pt && oe(Pt), v;
        }, Ie.cloakClassName = function() {
          return J;
        }, Ie.allowNamespaces = function() {
          return lt;
        }, Ie.nestedObjectDelimeter = function() {
          return at;
        }, Ie.fallbackLanguage = function(Pt) {
          if (Pt != null) {
            if (Ye(Pt), W && N && N.length)
              for (var jt = 0, ke = N.length; jt < ke; jt++)
                ge[N[jt]] || (ge[N[jt]] = Tr(N[jt]));
            Ie.use(Ie.use());
          }
          return H ? N[0] : N;
        }, Ie.useFallbackLanguage = function(Pt) {
          if (Pt != null)
            if (!Pt)
              sn = 0;
            else {
              var jt = $t(N, Pt);
              jt > -1 && (sn = jt);
            }
        }, Ie.proposedLanguage = function() {
          return B;
        }, Ie.storage = function() {
          return la;
        }, Ie.negotiateLocale = de, Ie.use = function(Pt) {
          if (!Pt)
            return F;
          var jt = _e.defer();
          jt.promise.then(null, angular.noop), ue.$emit("$translateChangeStart", { language: Pt });
          var ke = de(Pt);
          return P.length > 0 && !ke ? _e.reject(Pt) : (ke && (Pt = ke), B = Pt, (tt || !C[Pt]) && W && !ge[Pt] ? (ge[Pt] = Tr(Pt).then(function(pe) {
            return me(pe.key, pe.table), jt.resolve(pe.key), B === Pt && ks(pe.key), pe;
          }, function(pe) {
            return ue.$emit("$translateChangeError", { language: pe }), jt.reject(pe), ue.$emit("$translateChangeEnd", { language: pe }), _e.reject(pe);
          }), ge[Pt].finally(function() {
            Df(Pt);
          }).catch(angular.noop)) : ge[Pt] ? ge[Pt].then(function(pe) {
            return B === pe.key && ks(pe.key), jt.resolve(pe.key), pe;
          }, function(pe) {
            return !F && N && N.length > 0 && N[0] !== pe ? Ie.use(N[0]).then(jt.resolve, jt.reject) : jt.reject(pe);
          }) : (jt.resolve(Pt), ks(Pt)), jt.promise);
        }, Ie.resolveClientLocale = function() {
          return ot();
        }, Ie.storageKey = function() {
          return ze();
        }, Ie.isPostCompilingEnabled = function() {
          return j;
        }, Ie.isForceAsyncReloadEnabled = function() {
          return tt;
        }, Ie.isKeepContent = function() {
          return yt;
        }, Ie.refresh = function(Pt) {
          if (!W)
            throw new Error("Couldn't refresh translation table, no loader registered!");
          ue.$emit("$translateRefreshStart", { language: Pt });
          var jt = _e.defer(), ke = {};
          function pe(Te) {
            var Ce = Tr(Te);
            return ge[Te] = Ce, Ce.then(
              function(Ee) {
                C[Te] = {}, me(Te, Ee.table), ke[Te] = !0;
              },
              //handle rejection to appease the $q validation
              angular.noop
            ), Ce;
          }
          if (jt.promise.then(
            function() {
              for (var Te in C)
                C.hasOwnProperty(Te) && (Te in ke || delete C[Te]);
              F && ks(F);
            },
            //handle rejection to appease the $q validation
            angular.noop
          ).finally(
            function() {
              ue.$emit("$translateRefreshEnd", { language: Pt });
            }
          ), Pt)
            C[Pt] ? pe(Pt).then(jt.resolve, jt.reject) : jt.reject();
          else {
            var Pe = N && N.slice() || [];
            F && Pe.indexOf(F) === -1 && Pe.push(F), _e.all(Pe.map(pe)).then(jt.resolve, jt.reject);
          }
          return jt.promise;
        }, Ie.instant = function(Pt, jt, ke, pe, Pe) {
          var Te = pe && pe !== F ? (
            // we don't want to re-negotiate $uses
            de(pe) || pe
          ) : F;
          if (Pt === null || angular.isUndefined(Pt))
            return Pt;
          if (pe && hp(pe), angular.isArray(Pt)) {
            for (var Ce = {}, Ee = 0, Ea = Pt.length; Ee < Ea; Ee++)
              Ce[Pt[Ee]] = Ie.instant(Pt[Ee], jt, ke, pe, Pe);
            return Ce;
          }
          if (angular.isString(Pt) && Pt.length < 1)
            return Pt;
          Pt && (Pt = _t.apply(Pt));
          var na, Qn = [];
          v && Qn.push(v), Te && Qn.push(Te), N && N.length && (Qn = Qn.concat(N));
          for (var Ja = 0, _n = Qn.length; Ja < _n; Ja++) {
            var ci = Qn[Ja];
            if (C[ci] && typeof C[ci][Pt] < "u" && (na = Qi(Pt, jt, ke, Te, Pe)), typeof na < "u")
              break;
          }
          if (!na && na !== "")
            if (St || zt)
              na = Ss(Pt);
            else {
              na = qa.interpolate(Pt, jt, "filter", Pe);
              var Zi;
              rt && !je && (Zi = Kn(Pt, jt, Pe)), rt && !je && Zi && (na = Zi);
            }
          return na;
        }, Ie.versionInfo = function() {
          return dt;
        }, Ie.loaderCache = function() {
          return Rt;
        }, Ie.directivePriority = function() {
          return Yt;
        }, Ie.statefulFilter = function() {
          return K;
        }, Ie.isReady = function() {
          return nt;
        };
        var yo = _e.defer();
        yo.promise.then(function() {
          nt = !0;
        }), Ie.onReady = function(Pt) {
          var jt = _e.defer();
          return angular.isFunction(Pt) && jt.promise.then(Pt), nt ? jt.resolve() : yo.promise.then(jt.resolve), jt.promise;
        }, Ie.getAvailableLanguageKeys = function() {
          return P.length > 0 ? P : null;
        }, Ie.getTranslationTable = function(Pt) {
          return Pt = Pt || Ie.use(), Pt && C[Pt] ? angular.copy(C[Pt]) : null;
        };
        var Jc = ue.$on("$translateReady", function() {
          yo.resolve(), Jc(), Jc = null;
        }), mp = ue.$on("$translateChangeEnd", function() {
          yo.resolve(), mp(), mp = null;
        });
        if (W) {
          if (angular.equals(C, {}) && Ie.use() && Ie.use(Ie.use()), N && N.length)
            for (var If = function(Pt) {
              return me(Pt.key, Pt.table), ue.$emit("$translateChangeEnd", { language: Pt.key }), Pt;
            }, Qc = 0, gp = N.length; Qc < gp; Qc++) {
              var fo = N[Qc];
              (tt || !C[fo]) && (ge[fo] = Tr(fo).then(If));
            }
        } else
          ue.$emit("$translateReady", { language: Ie.use() });
        return Ie;
      }];
    }
    a.displayName = "displayName", angular.module("pascalprecht.translate").factory("$translateDefaultInterpolation", n);
    function n(b, A) {
      var T = {}, R = "default";
      return T.setLocale = function(C) {
      }, T.getInterpolationIdentifier = function() {
        return R;
      }, T.useSanitizeValueStrategy = function(C) {
        return A.useStrategy(C), this;
      }, T.interpolate = function(C, v, P, O, N) {
        v = v || {}, v = A.sanitize(v, "params", O, P);
        var H;
        return angular.isNumber(C) ? H = "" + C : angular.isString(C) ? (H = b(C)(v), H = A.sanitize(H, "text", O, P)) : H = "", H;
      }, T;
    }
    n.displayName = "$translateDefaultInterpolation", angular.module("pascalprecht.translate").constant("$STORAGE_KEY", "NG_TRANSLATE_LANG_KEY"), angular.module("pascalprecht.translate").directive("translate", i);
    function i(b, A, T, R, C) {
      var v = function() {
        return this.toString().replace(/^\s+|\s+$/g, "");
      }, P = function(O) {
        return angular.isString(O) ? O.toLowerCase() : O;
      };
      return {
        restrict: "AE",
        scope: !0,
        priority: b.directivePriority(),
        compile: function(O, N) {
          var H = N.translateValues ? N.translateValues : void 0, F = N.translateInterpolation ? N.translateInterpolation : void 0, B = N.translateSanitizeStrategy ? N.translateSanitizeStrategy : void 0, Q = O[0].outerHTML.match(/translate-value-+/i), it = "^(.*)(" + A.startSymbol() + ".*" + A.endSymbol() + ")(.*)", et = "^(.*)" + A.startSymbol() + "(.*)" + A.endSymbol() + "(.*)";
          return function(U, M, W) {
            U.interpolateParams = {}, U.preText = "", U.postText = "", U.translateNamespace = r(U);
            var J = {}, vt = function(K, _, V) {
              if (_.translateValues && angular.extend(K, R(_.translateValues)(U.$parent)), Q) {
                for (var G in V)
                  if (Object.prototype.hasOwnProperty.call(_, G) && G.substr(0, 14) === "translateValue" && G !== "translateValues") {
                    var dt = P(G.substr(14, 1)) + G.substr(15);
                    K[dt] = V[G];
                  }
              }
            }, St = function(K) {
              if (angular.isFunction(St._unwatchOld) && (St._unwatchOld(), St._unwatchOld = void 0), angular.equals(K, "") || !angular.isDefined(K)) {
                var _ = v.apply(M.text()).replace(/\n/g, " "), V = _.match(it);
                if (angular.isArray(V)) {
                  U.preText = V[1], U.postText = V[3], J.translate = A(V[2])(U.$parent);
                  var G = _.match(et);
                  angular.isArray(G) && G[2] && G[2].length && (St._unwatchOld = U.$watch(G[2], function(dt) {
                    J.translate = dt, nt();
                  }));
                } else
                  J.translate = _ || void 0;
              } else
                J.translate = K;
              nt();
            }, zt = function(K) {
              W.$observe(K, function(_) {
                J[K] = _, nt();
              });
            };
            vt(U.interpolateParams, W, N);
            var j = !0;
            W.$observe("translate", function(K) {
              typeof K > "u" ? St("") : (K !== "" || !j) && (J.translate = K, nt()), j = !1;
            });
            for (var tt in W)
              W.hasOwnProperty(tt) && tt.substr(0, 13) === "translateAttr" && tt.length > 13 && zt(tt);
            if (W.$observe("translateDefault", function(K) {
              U.defaultText = K, nt();
            }), B && W.$observe("translateSanitizeStrategy", function(K) {
              U.sanitizeStrategy = R(K)(U.$parent), nt();
            }), H && W.$observe("translateValues", function(K) {
              K && U.$parent.$watch(function() {
                angular.extend(U.interpolateParams, R(K)(U.$parent));
              });
            }), Q) {
              var lt = function(K) {
                W.$observe(K, function(_) {
                  var V = P(K.substr(14, 1)) + K.substr(15);
                  U.interpolateParams[V] = _;
                });
              };
              for (var at in W)
                Object.prototype.hasOwnProperty.call(W, at) && at.substr(0, 14) === "translateValue" && at !== "translateValues" && lt(at);
            }
            var nt = function() {
              for (var K in J)
                J.hasOwnProperty(K) && J[K] !== void 0 && yt(K, J[K], U, U.interpolateParams, U.defaultText, U.translateNamespace);
            }, yt = function(K, _, V, G, dt, ht) {
              _ ? (ht && _.charAt(0) === "." && (_ = ht + _), b(_, G, F, dt, V.translateLanguage, V.sanitizeStrategy).then(function(ot) {
                Rt(ot, V, !0, K);
              }, function(ot) {
                Rt(ot, V, !1, K);
              })) : Rt(_, V, !1, K);
            }, Rt = function(K, _, V, G) {
              if (V || typeof _.defaultText < "u" && (K = _.defaultText), G === "translate") {
                (V || !V && !b.isKeepContent() && typeof W.translateKeepContent > "u") && M.empty().append(_.preText + K + _.postText);
                var dt = b.isPostCompilingEnabled(), ht = typeof N.translateCompile < "u", ot = ht && N.translateCompile !== "false";
                (dt && !ht || ot) && T(M.contents())(_);
              } else {
                var $t = W.$attr[G];
                $t.substr(0, 5) === "data-" && ($t = $t.substr(5)), $t = $t.substr(15), M.attr($t, K);
              }
            };
            (H || Q || W.translateDefault) && U.$watch("interpolateParams", nt, !0), U.$on("translateLanguageChanged", nt);
            var Yt = C.$on("$translateChangeSuccess", nt);
            M.text().length ? W.translate ? St(W.translate) : St("") : W.translate && St(W.translate), nt(), U.$on("$destroy", Yt);
          };
        }
      };
    }
    function r(b) {
      if (b.translateNamespace)
        return b.translateNamespace;
      if (b.$parent)
        return r(b.$parent);
    }
    i.displayName = "translateDirective", angular.module("pascalprecht.translate").directive("translateAttr", l);
    function l(b, A) {
      return {
        restrict: "A",
        priority: b.directivePriority(),
        link: function(R, C, v) {
          var P, O, N, H = {}, F = function() {
            angular.forEach(P, function(Q, it) {
              Q && (H[it] = !0, R.translateNamespace && Q.charAt(0) === "." && (Q = R.translateNamespace + Q), b(Q, O, v.translateInterpolation, void 0, R.translateLanguage, N).then(function(et) {
                C.attr(it, et);
              }, function(et) {
                C.attr(it, et);
              }));
            }), angular.forEach(H, function(Q, it) {
              P[it] || (C.removeAttr(it), delete H[it]);
            });
          };
          o(
            R,
            v.translateAttr,
            function(Q) {
              P = Q;
            },
            F
          ), o(
            R,
            v.translateValues,
            function(Q) {
              O = Q;
            },
            F
          ), o(
            R,
            v.translateSanitizeStrategy,
            function(Q) {
              N = Q;
            },
            F
          ), v.translateValues && R.$watch(v.translateValues, F, !0), R.$on("translateLanguageChanged", F);
          var B = A.$on("$translateChangeSuccess", F);
          F(), R.$on("$destroy", B);
        }
      };
    }
    function o(b, A, T, R) {
      A && (A.substr(0, 2) === "::" ? A = A.substr(2) : b.$watch(A, function(C) {
        T(C), R();
      }, !0), T(b.$eval(A)));
    }
    l.displayName = "translateAttrDirective", angular.module("pascalprecht.translate").directive("translateCloak", c);
    function c(b, A) {
      return {
        compile: function(T) {
          var R = function(v) {
            v.addClass(b.cloakClassName());
          }, C = function(v) {
            v.removeClass(b.cloakClassName());
          };
          return R(T), function(P, O, N) {
            var H = C.bind(this, O), F = R.bind(this, O);
            N.translateCloak && N.translateCloak.length ? (N.$observe("translateCloak", function(B) {
              b(B).then(H, F);
            }), A.$on("$translateChangeSuccess", function() {
              b(N.translateCloak).then(H, F);
            })) : b.onReady(H);
          };
        }
      };
    }
    c.displayName = "translateCloakDirective", angular.module("pascalprecht.translate").directive("translateNamespace", d);
    function d() {
      return {
        restrict: "A",
        scope: !0,
        compile: function() {
          return {
            pre: function(b, A, T) {
              b.translateNamespace = p(b), b.translateNamespace && T.translateNamespace.charAt(0) === "." ? b.translateNamespace += T.translateNamespace : b.translateNamespace = T.translateNamespace;
            }
          };
        }
      };
    }
    function p(b) {
      if (b.translateNamespace)
        return b.translateNamespace;
      if (b.$parent)
        return p(b.$parent);
    }
    d.displayName = "translateNamespaceDirective", angular.module("pascalprecht.translate").directive("translateLanguage", h);
    function h() {
      return {
        restrict: "A",
        scope: !0,
        compile: function() {
          return function(A, T, R) {
            R.$observe("translateLanguage", function(C) {
              A.translateLanguage = C;
            }), A.$watch("translateLanguage", function() {
              A.$broadcast("translateLanguageChanged");
            });
          };
        }
      };
    }
    h.displayName = "translateLanguageDirective", angular.module("pascalprecht.translate").filter("translate", g);
    function g(b, A) {
      var T = function(R, C, v, P) {
        if (!angular.isObject(C)) {
          var O = this || {
            __SCOPE_IS_NOT_AVAILABLE: "More info at https://github.com/angular/angular.js/commit/8863b9d04c722b278fa93c5d66ad1e578ad6eb1f"
          };
          C = b(C)(O);
        }
        return A.instant(R, C, v, P);
      };
      return A.statefulFilter() && (T.$stateful = !0), T;
    }
    g.displayName = "translateFilterFactory", angular.module("pascalprecht.translate").factory("$translationCache", x);
    function x(b) {
      return b("translations");
    }
    return x.displayName = "$translationCache", "pascalprecht.translate";
  });
})(hR);
var A9 = hR.exports;
const C9 = /* @__PURE__ */ Hs(A9);
class $9 {
  /** Gets the controllers for Module registration. */
  static getControllers() {
    return {
      AbsencePeriodsController: Du,
      AccountantController: Zg,
      AccountingChannelSettingsController: dw,
      AccountAuthorizationController: Hl,
      AccountingHolidayPayDebtReportQueryController: Kg,
      AccountingReportCrudController: Su,
      AccountingReportDisplayController: lw,
      AccountingReportQueryController: Xg,
      AccountingReportRowsController: Gg,
      AccountingReportToolsController: Hg,
      AccountingRowReportController: Wg,
      AccountingTargetCrudController: ty,
      AccountResetController: uy,
      ActionButtonController: lg,
      AlertController: og,
      AvatarController: cg,
      BatchProcessController: zx,
      CalcChartController: $m,
      CalcCostAccountingController: Om,
      CalcEmploymentController: mm,
      CalcHouseholdUsecaseController: Sm,
      CalcImportController: wg,
      CalcIrRowsController: km,
      CalcsIrRowsController: Rm,
      CalcWorktimeController: Im,
      CalcRepairController: Hm,
      CalcReportController: Tm,
      CalcReportsController: Lm,
      CalcReportsDisplayController: Tx,
      CalcRowCostAccountingController: Mm,
      CalcRowDimensionInputController: Pm,
      CalcRowDocumentationController: Em,
      CalcRowFormulaController: TE,
      CalcRowTypeController: Dm,
      CalcRows2019Controller: Vl,
      CalcSharingController: wu,
      CalcSharingReceiptActionController: Nm,
      CalculationCrudController: wr,
      CalculationEditorController: _m,
      CalculationReportController: Bg,
      Calculator2019Controller: $s,
      Calculator2022Controller: lu,
      CalcLeavesController: Gm,
      CalendarController: dg,
      CalendarEventsCrudController: Ay,
      CalendarOccurencesController: mw,
      CertificateController: au,
      ChartController: pg,
      CompanyAccountController: ux,
      CompanyInvoicesController: Dg,
      CompanyImportController: xg,
      CompanyOnboardingController: kv,
      CompanySettingsController: ii,
      ContactInfoController: LE,
      CostAccountingController: Cc,
      CredentialController: pm,
      CreditTransferController: Ym,
      CustomerInvoiceCrudController: aw,
      CustomerOnboardingController: Cv,
      DatasetsCrudController: Cy,
      DatepickerController: bu,
      DatepickerPopupController: Bm,
      DateRangeController: Wm,
      EditDialogController: sw,
      EmbeddedUiController: dx,
      EmployerListController: Eg,
      EmployerReportController: Ng,
      EmployerSelectController: Rg,
      EmploymentCrudController: hy,
      EmploymentTaxcardsController: my,
      EmploymentWizardController: pw,
      ExportController: Zx,
      HolidayPayReportQueryController: Jg,
      HolidayReportController: qg,
      HolidayYearAccrualController: Iu,
      HolidayYearCrudController: gy,
      HolidayYearHolidaysController: Pu,
      HolidayYearPaidController: Eu,
      HouseholdDeductionReportController: Yg,
      HouseholdOnboardingController: Sv,
      HouseholdYearCrudController: Au,
      ImportController: Qx,
      ImportStagingController: Ag,
      InputBooleanController: jm,
      InputCollectiveBargainAgreementController: Vm,
      InputCredentialController: qm,
      InputDurationController: Km,
      InputEnumController: rA,
      InputHolidayMultipliersController: mN,
      InputHolidayRowTypeController: rg,
      InputIncomeTypeController: Jm,
      InputNumberController: PE,
      InputRruleController: ag,
      InputTimeController: HE,
      InputTypeaheadController: sg,
      InsuranceWizardController: ey,
      InvoiceCrudController: Cr,
      InvoicesCreateController: Sg,
      InvoiceReportController: Lg,
      InvoiceSepaController: nw,
      InvoiceToolsController: Tg,
      InvoiceAlertsController: Ig,
      InvoicePaymentListController: $g,
      IrEarningsPaymentCrudController: ku,
      IrPayerSummaryCrudController: Tu,
      JsonFormatterController: hg,
      MessageThreadCrudController: yu,
      ModalGenericDialogController: Pg,
      MyTaxcardsController: hw,
      NaviController: xu,
      ODataActionsController: vg,
      ODataHelperController: rm,
      ODataQueryController: ni,
      OmapalkkaController: Ix,
      OwnerSettingsController: ay,
      PartnerController: hm,
      PayCertificateController: zg,
      PaymentController: Lx,
      PaymentChannelController: kg,
      PaymentChannelSettingsController: ny,
      PayrollCrudController: mu,
      Payroll4AssistantController: Um,
      Payroll4CrudController: gu,
      PalkkausPersonalPaymentOverviewController: Dx,
      PersonAccountController: ao,
      RecordsController: Mg,
      ReferenceObjectCrudController: uw,
      ReportsController: Ug,
      RowTypesSettingsController: sy,
      SalaryBasesController: px,
      SalaryDateKindController: Xm,
      SalarySlipDownloadController: cw,
      SalaryReportCrudController: Fg,
      SessionController: vi,
      ServiceModelCrudController: iy,
      SignatureController: Tv,
      SigningController: im,
      SmokeTestController: py,
      SpinnerController: mg,
      SummaryReportController: jg,
      SummaryReportDisplayController: rw,
      SummaryReportQueryController: Qg,
      SxyCodeEditorController: ry,
      SxyFormController: ly,
      SxyFormElementController: oy,
      SxyTableController: dy,
      SxyGridController: Lu,
      SxyInputController: no,
      SxySchemaEditorController: cy,
      TabController: gg,
      TabsController: yg,
      TabButtonsController: fg,
      TaxcardManualEditController: yy,
      TaxcardCrudController: fy,
      TaxcardIncomeLogController: by,
      ToggleButtonsController: hN,
      UiTranslatorController: bg,
      UsecasesCrudController: $y,
      VarmaBannerController: Fm,
      WelcomeController: zm,
      WizardController: bi,
      WorkerAbsencesCrudController: vy,
      WorkerAccountCrudController: xy,
      WorkerAssureController: wy,
      WorkerExpenseReportController: $u,
      WorkerHourlyReportController: Cu,
      WorkerImportController: Cg,
      WorkerOnboardingController: $v,
      WorkerReportController: _g,
      WorkerSummaryReportController: Vg,
      WorkerSummaryReportDisplayController: ow,
      WorkerTimerController: Og,
      WorkflowController: Nu,
      WorkflowBadgeController: Sy,
      TimesheetWorkerDemoController: iw,
      ValidationSummaryController: ig
    };
  }
}
class XA {
  /**
   * Creates a new instance of the directive.
   */
  constructor() {
    this.restrict = "A";
  }
  /**
   * Factory for directive registration.
   * @ignore
   */
  static salaxyAppendNode() {
    const t = () => new XA();
    return t.$inject = [], t;
  }
  /**
   * Evaluates the attribute value (DOM node or default string), and appends it to the current element.
   * @ignore
   */
  link(t, e, a) {
    const n = t.$eval(a.salaxyAppendNode);
    e.append(n);
  }
}
/*!
  * Bootstrap v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */
const Pr = /* @__PURE__ */ new Map(), nv = {
  set(s, t, e) {
    Pr.has(s) || Pr.set(s, /* @__PURE__ */ new Map());
    const a = Pr.get(s);
    if (!a.has(t) && a.size !== 0) {
      console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(a.keys())[0]}.`);
      return;
    }
    a.set(t, e);
  },
  get(s, t) {
    return Pr.has(s) && Pr.get(s).get(t) || null;
  },
  remove(s, t) {
    if (!Pr.has(s))
      return;
    const e = Pr.get(s);
    e.delete(t), e.size === 0 && Pr.delete(s);
  }
}, S9 = 1e6, k9 = 1e3, gw = "transitionend", mR = (s) => (s && window.CSS && window.CSS.escape && (s = s.replace(/#([^\s"#']+)/g, (t, e) => `#${CSS.escape(e)}`)), s), T9 = (s) => s == null ? `${s}` : Object.prototype.toString.call(s).match(/\s([a-z]+)/i)[1].toLowerCase(), L9 = (s) => {
  do
    s += Math.floor(Math.random() * S9);
  while (document.getElementById(s));
  return s;
}, D9 = (s) => {
  if (!s)
    return 0;
  let {
    transitionDuration: t,
    transitionDelay: e
  } = window.getComputedStyle(s);
  const a = Number.parseFloat(t), n = Number.parseFloat(e);
  return !a && !n ? 0 : (t = t.split(",")[0], e = e.split(",")[0], (Number.parseFloat(t) + Number.parseFloat(e)) * k9);
}, gR = (s) => {
  s.dispatchEvent(new Event(gw));
}, yr = (s) => !s || typeof s != "object" ? !1 : (typeof s.jquery < "u" && (s = s[0]), typeof s.nodeType < "u"), il = (s) => yr(s) ? s.jquery ? s[0] : s : typeof s == "string" && s.length > 0 ? document.querySelector(mR(s)) : null, Bc = (s) => {
  if (!yr(s) || s.getClientRects().length === 0)
    return !1;
  const t = getComputedStyle(s).getPropertyValue("visibility") === "visible", e = s.closest("details:not([open])");
  if (!e)
    return t;
  if (e !== s) {
    const a = s.closest("summary");
    if (a && a.parentNode !== e || a === null)
      return !1;
  }
  return t;
}, rl = (s) => !s || s.nodeType !== Node.ELEMENT_NODE || s.classList.contains("disabled") ? !0 : typeof s.disabled < "u" ? s.disabled : s.hasAttribute("disabled") && s.getAttribute("disabled") !== "false", yR = (s) => {
  if (!document.documentElement.attachShadow)
    return null;
  if (typeof s.getRootNode == "function") {
    const t = s.getRootNode();
    return t instanceof ShadowRoot ? t : null;
  }
  return s instanceof ShadowRoot ? s : s.parentNode ? yR(s.parentNode) : null;
}, ky = () => {
}, rp = (s) => {
  s.offsetHeight;
}, fR = () => window.jQuery && !document.body.hasAttribute("data-bs-no-jquery") ? window.jQuery : null, sv = [], I9 = (s) => {
  document.readyState === "loading" ? (sv.length || document.addEventListener("DOMContentLoaded", () => {
    for (const t of sv)
      t();
  }), sv.push(s)) : s();
}, ri = () => document.documentElement.dir === "rtl", oi = (s) => {
  I9(() => {
    const t = fR();
    if (t) {
      const e = s.NAME, a = t.fn[e];
      t.fn[e] = s.jQueryInterface, t.fn[e].Constructor = s, t.fn[e].noConflict = () => (t.fn[e] = a, s.jQueryInterface);
    }
  });
}, vs = (s, t = [], e = s) => typeof s == "function" ? s(...t) : e, bR = (s, t, e = !0) => {
  if (!e) {
    vs(s);
    return;
  }
  const n = D9(t) + 5;
  let i = !1;
  const r = ({
    target: l
  }) => {
    l === t && (i = !0, t.removeEventListener(gw, r), vs(s));
  };
  t.addEventListener(gw, r), setTimeout(() => {
    i || gR(t);
  }, n);
}, GA = (s, t, e, a) => {
  const n = s.length;
  let i = s.indexOf(t);
  return i === -1 ? !e && a ? s[n - 1] : s[0] : (i += e ? 1 : -1, a && (i = (i + n) % n), s[Math.max(0, Math.min(i, n - 1))]);
}, P9 = /[^.]*(?=\..*)\.|.*/, E9 = /\..*/, N9 = /::\d+$/, iv = {};
let FI = 1;
const vR = {
  mouseenter: "mouseover",
  mouseleave: "mouseout"
}, R9 = /* @__PURE__ */ new Set(["click", "dblclick", "mouseup", "mousedown", "contextmenu", "mousewheel", "DOMMouseScroll", "mouseover", "mouseout", "mousemove", "selectstart", "selectend", "keydown", "keypress", "keyup", "orientationchange", "touchstart", "touchmove", "touchend", "touchcancel", "pointerdown", "pointermove", "pointerup", "pointerleave", "pointercancel", "gesturestart", "gesturechange", "gestureend", "focus", "blur", "change", "reset", "select", "submit", "focusin", "focusout", "load", "unload", "beforeunload", "resize", "move", "DOMContentLoaded", "readystatechange", "error", "abort", "scroll"]);
function xR(s, t) {
  return t && `${t}::${FI++}` || s.uidEvent || FI++;
}
function wR(s) {
  const t = xR(s);
  return s.uidEvent = t, iv[t] = iv[t] || {}, iv[t];
}
function Y9(s, t) {
  return function e(a) {
    return HA(a, {
      delegateTarget: s
    }), e.oneOff && Zt.off(s, a.type, t), t.apply(s, [a]);
  };
}
function _9(s, t, e) {
  return function a(n) {
    const i = s.querySelectorAll(t);
    for (let {
      target: r
    } = n; r && r !== this; r = r.parentNode)
      for (const l of i)
        if (l === r)
          return HA(n, {
            delegateTarget: r
          }), a.oneOff && Zt.off(s, n.type, t, e), e.apply(r, [n]);
  };
}
function AR(s, t, e = null) {
  return Object.values(s).find((a) => a.callable === t && a.delegationSelector === e);
}
function CR(s, t, e) {
  const a = typeof t == "string", n = a ? e : t || e;
  let i = $R(s);
  return R9.has(i) || (i = s), [a, n, i];
}
function zI(s, t, e, a, n) {
  if (typeof t != "string" || !s)
    return;
  let [i, r, l] = CR(t, e, a);
  t in vR && (r = ((x) => function(b) {
    if (!b.relatedTarget || b.relatedTarget !== b.delegateTarget && !b.delegateTarget.contains(b.relatedTarget))
      return x.call(this, b);
  })(r));
  const o = wR(s), c = o[l] || (o[l] = {}), d = AR(c, r, i ? e : null);
  if (d) {
    d.oneOff = d.oneOff && n;
    return;
  }
  const p = xR(r, t.replace(P9, "")), h = i ? _9(s, e, r) : Y9(s, r);
  h.delegationSelector = i ? e : null, h.callable = r, h.oneOff = n, h.uidEvent = p, c[p] = h, s.addEventListener(l, h, i);
}
function yw(s, t, e, a, n) {
  const i = AR(t[e], a, n);
  i && (s.removeEventListener(e, i, !!n), delete t[e][i.uidEvent]);
}
function O9(s, t, e, a) {
  const n = t[e] || {};
  for (const [i, r] of Object.entries(n))
    i.includes(a) && yw(s, t, e, r.callable, r.delegationSelector);
}
function $R(s) {
  return s = s.replace(E9, ""), vR[s] || s;
}
const Zt = {
  on(s, t, e, a) {
    zI(s, t, e, a, !1);
  },
  one(s, t, e, a) {
    zI(s, t, e, a, !0);
  },
  off(s, t, e, a) {
    if (typeof t != "string" || !s)
      return;
    const [n, i, r] = CR(t, e, a), l = r !== t, o = wR(s), c = o[r] || {}, d = t.startsWith(".");
    if (typeof i < "u") {
      if (!Object.keys(c).length)
        return;
      yw(s, o, r, i, n ? e : null);
      return;
    }
    if (d)
      for (const p of Object.keys(o))
        O9(s, o, p, t.slice(1));
    for (const [p, h] of Object.entries(c)) {
      const g = p.replace(N9, "");
      (!l || t.includes(g)) && yw(s, o, r, h.callable, h.delegationSelector);
    }
  },
  trigger(s, t, e) {
    if (typeof t != "string" || !s)
      return null;
    const a = fR(), n = $R(t), i = t !== n;
    let r = null, l = !0, o = !0, c = !1;
    i && a && (r = a.Event(t, e), a(s).trigger(r), l = !r.isPropagationStopped(), o = !r.isImmediatePropagationStopped(), c = r.isDefaultPrevented());
    const d = HA(new Event(t, {
      bubbles: l,
      cancelable: !0
    }), e);
    return c && d.preventDefault(), o && s.dispatchEvent(d), d.defaultPrevented && r && r.preventDefault(), d;
  }
};
function HA(s, t = {}) {
  for (const [e, a] of Object.entries(t))
    try {
      s[e] = a;
    } catch {
      Object.defineProperty(s, e, {
        configurable: !0,
        get() {
          return a;
        }
      });
    }
  return s;
}
function BI(s) {
  if (s === "true")
    return !0;
  if (s === "false")
    return !1;
  if (s === Number(s).toString())
    return Number(s);
  if (s === "" || s === "null")
    return null;
  if (typeof s != "string")
    return s;
  try {
    return JSON.parse(decodeURIComponent(s));
  } catch {
    return s;
  }
}
function rv(s) {
  return s.replace(/[A-Z]/g, (t) => `-${t.toLowerCase()}`);
}
const fr = {
  setDataAttribute(s, t, e) {
    s.setAttribute(`data-bs-${rv(t)}`, e);
  },
  removeDataAttribute(s, t) {
    s.removeAttribute(`data-bs-${rv(t)}`);
  },
  getDataAttributes(s) {
    if (!s)
      return {};
    const t = {}, e = Object.keys(s.dataset).filter((a) => a.startsWith("bs") && !a.startsWith("bsConfig"));
    for (const a of e) {
      let n = a.replace(/^bs/, "");
      n = n.charAt(0).toLowerCase() + n.slice(1, n.length), t[n] = BI(s.dataset[a]);
    }
    return t;
  },
  getDataAttribute(s, t) {
    return BI(s.getAttribute(`data-bs-${rv(t)}`));
  }
};
class lp {
  // Getters
  static get Default() {
    return {};
  }
  static get DefaultType() {
    return {};
  }
  static get NAME() {
    throw new Error('You have to implement the static method "NAME", for each component!');
  }
  _getConfig(t) {
    return t = this._mergeConfigObj(t), t = this._configAfterMerge(t), this._typeCheckConfig(t), t;
  }
  _configAfterMerge(t) {
    return t;
  }
  _mergeConfigObj(t, e) {
    const a = yr(e) ? fr.getDataAttribute(e, "config") : {};
    return {
      ...this.constructor.Default,
      ...typeof a == "object" ? a : {},
      ...yr(e) ? fr.getDataAttributes(e) : {},
      ...typeof t == "object" ? t : {}
    };
  }
  _typeCheckConfig(t, e = this.constructor.DefaultType) {
    for (const [a, n] of Object.entries(e)) {
      const i = t[a], r = yr(i) ? "element" : T9(i);
      if (!new RegExp(n).test(r))
        throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${a}" provided type "${r}" but expected type "${n}".`);
    }
  }
}
const M9 = "5.3.3";
class Ci extends lp {
  constructor(t, e) {
    super(), t = il(t), t && (this._element = t, this._config = this._getConfig(e), nv.set(this._element, this.constructor.DATA_KEY, this));
  }
  // Public
  dispose() {
    nv.remove(this._element, this.constructor.DATA_KEY), Zt.off(this._element, this.constructor.EVENT_KEY);
    for (const t of Object.getOwnPropertyNames(this))
      this[t] = null;
  }
  _queueCallback(t, e, a = !0) {
    bR(t, e, a);
  }
  _getConfig(t) {
    return t = this._mergeConfigObj(t, this._element), t = this._configAfterMerge(t), this._typeCheckConfig(t), t;
  }
  // Static
  static getInstance(t) {
    return nv.get(il(t), this.DATA_KEY);
  }
  static getOrCreateInstance(t, e = {}) {
    return this.getInstance(t) || new this(t, typeof e == "object" ? e : null);
  }
  static get VERSION() {
    return M9;
  }
  static get DATA_KEY() {
    return `bs.${this.NAME}`;
  }
  static get EVENT_KEY() {
    return `.${this.DATA_KEY}`;
  }
  static eventName(t) {
    return `${t}${this.EVENT_KEY}`;
  }
}
const lv = (s) => {
  let t = s.getAttribute("data-bs-target");
  if (!t || t === "#") {
    let e = s.getAttribute("href");
    if (!e || !e.includes("#") && !e.startsWith("."))
      return null;
    e.includes("#") && !e.startsWith("#") && (e = `#${e.split("#")[1]}`), t = e && e !== "#" ? e.trim() : null;
  }
  return t ? t.split(",").map((e) => mR(e)).join(",") : null;
}, Re = {
  find(s, t = document.documentElement) {
    return [].concat(...Element.prototype.querySelectorAll.call(t, s));
  },
  findOne(s, t = document.documentElement) {
    return Element.prototype.querySelector.call(t, s);
  },
  children(s, t) {
    return [].concat(...s.children).filter((e) => e.matches(t));
  },
  parents(s, t) {
    const e = [];
    let a = s.parentNode.closest(t);
    for (; a; )
      e.push(a), a = a.parentNode.closest(t);
    return e;
  },
  prev(s, t) {
    let e = s.previousElementSibling;
    for (; e; ) {
      if (e.matches(t))
        return [e];
      e = e.previousElementSibling;
    }
    return [];
  },
  // TODO: this is now unused; remove later along with prev()
  next(s, t) {
    let e = s.nextElementSibling;
    for (; e; ) {
      if (e.matches(t))
        return [e];
      e = e.nextElementSibling;
    }
    return [];
  },
  focusableChildren(s) {
    const t = ["a", "button", "input", "textarea", "select", "details", "[tabindex]", '[contenteditable="true"]'].map((e) => `${e}:not([tabindex^="-"])`).join(",");
    return this.find(t, s).filter((e) => !rl(e) && Bc(e));
  },
  getSelectorFromElement(s) {
    const t = lv(s);
    return t && Re.findOne(t) ? t : null;
  },
  getElementFromSelector(s) {
    const t = lv(s);
    return t ? Re.findOne(t) : null;
  },
  getMultipleElementsFromSelector(s) {
    const t = lv(s);
    return t ? Re.find(t) : [];
  }
}, wf = (s, t = "hide") => {
  const e = `click.dismiss${s.EVENT_KEY}`, a = s.NAME;
  Zt.on(document, e, `[data-bs-dismiss="${a}"]`, function(n) {
    if (["A", "AREA"].includes(this.tagName) && n.preventDefault(), rl(this))
      return;
    const i = Re.getElementFromSelector(this) || this.closest(`.${a}`);
    s.getOrCreateInstance(i)[t]();
  });
}, X9 = "alert", G9 = "bs.alert", SR = `.${G9}`, H9 = `close${SR}`, U9 = `closed${SR}`, F9 = "fade", z9 = "show";
class Af extends Ci {
  // Getters
  static get NAME() {
    return X9;
  }
  // Public
  close() {
    if (Zt.trigger(this._element, H9).defaultPrevented)
      return;
    this._element.classList.remove(z9);
    const e = this._element.classList.contains(F9);
    this._queueCallback(() => this._destroyElement(), this._element, e);
  }
  // Private
  _destroyElement() {
    this._element.remove(), Zt.trigger(this._element, U9), this.dispose();
  }
  // Static
  static jQueryInterface(t) {
    return this.each(function() {
      const e = Af.getOrCreateInstance(this);
      if (typeof t == "string") {
        if (e[t] === void 0 || t.startsWith("_") || t === "constructor")
          throw new TypeError(`No method named "${t}"`);
        e[t](this);
      }
    });
  }
}
wf(Af, "close");
oi(Af);
const B9 = "button", W9 = "bs.button", j9 = `.${W9}`, V9 = ".data-api", q9 = "active", WI = '[data-bs-toggle="button"]', K9 = `click${j9}${V9}`;
class Cf extends Ci {
  // Getters
  static get NAME() {
    return B9;
  }
  // Public
  toggle() {
    this._element.setAttribute("aria-pressed", this._element.classList.toggle(q9));
  }
  // Static
  static jQueryInterface(t) {
    return this.each(function() {
      const e = Cf.getOrCreateInstance(this);
      t === "toggle" && e[t]();
    });
  }
}
Zt.on(document, K9, WI, (s) => {
  s.preventDefault();
  const t = s.target.closest(WI);
  Cf.getOrCreateInstance(t).toggle();
});
oi(Cf);
const J9 = "swipe", Wc = ".bs.swipe", Q9 = `touchstart${Wc}`, Z9 = `touchmove${Wc}`, tK = `touchend${Wc}`, eK = `pointerdown${Wc}`, aK = `pointerup${Wc}`, nK = "touch", sK = "pen", iK = "pointer-event", rK = 40, lK = {
  endCallback: null,
  leftCallback: null,
  rightCallback: null
}, oK = {
  endCallback: "(function|null)",
  leftCallback: "(function|null)",
  rightCallback: "(function|null)"
};
class Ty extends lp {
  constructor(t, e) {
    super(), this._element = t, !(!t || !Ty.isSupported()) && (this._config = this._getConfig(e), this._deltaX = 0, this._supportPointerEvents = !!window.PointerEvent, this._initEvents());
  }
  // Getters
  static get Default() {
    return lK;
  }
  static get DefaultType() {
    return oK;
  }
  static get NAME() {
    return J9;
  }
  // Public
  dispose() {
    Zt.off(this._element, Wc);
  }
  // Private
  _start(t) {
    if (!this._supportPointerEvents) {
      this._deltaX = t.touches[0].clientX;
      return;
    }
    this._eventIsPointerPenTouch(t) && (this._deltaX = t.clientX);
  }
  _end(t) {
    this._eventIsPointerPenTouch(t) && (this._deltaX = t.clientX - this._deltaX), this._handleSwipe(), vs(this._config.endCallback);
  }
  _move(t) {
    this._deltaX = t.touches && t.touches.length > 1 ? 0 : t.touches[0].clientX - this._deltaX;
  }
  _handleSwipe() {
    const t = Math.abs(this._deltaX);
    if (t <= rK)
      return;
    const e = t / this._deltaX;
    this._deltaX = 0, e && vs(e > 0 ? this._config.rightCallback : this._config.leftCallback);
  }
  _initEvents() {
    this._supportPointerEvents ? (Zt.on(this._element, eK, (t) => this._start(t)), Zt.on(this._element, aK, (t) => this._end(t)), this._element.classList.add(iK)) : (Zt.on(this._element, Q9, (t) => this._start(t)), Zt.on(this._element, Z9, (t) => this._move(t)), Zt.on(this._element, tK, (t) => this._end(t)));
  }
  _eventIsPointerPenTouch(t) {
    return this._supportPointerEvents && (t.pointerType === sK || t.pointerType === nK);
  }
  // Static
  static isSupported() {
    return "ontouchstart" in document.documentElement || navigator.maxTouchPoints > 0;
  }
}
const cK = "carousel", dK = "bs.carousel", ul = `.${dK}`, kR = ".data-api", uK = "ArrowLeft", pK = "ArrowRight", hK = 500, Cd = "next", Ho = "prev", Wo = "left", em = "right", mK = `slide${ul}`, ov = `slid${ul}`, gK = `keydown${ul}`, yK = `mouseenter${ul}`, fK = `mouseleave${ul}`, bK = `dragstart${ul}`, vK = `load${ul}${kR}`, xK = `click${ul}${kR}`, TR = "carousel", kh = "active", wK = "slide", AK = "carousel-item-end", CK = "carousel-item-start", $K = "carousel-item-next", SK = "carousel-item-prev", LR = ".active", DR = ".carousel-item", kK = LR + DR, TK = ".carousel-item img", LK = ".carousel-indicators", DK = "[data-bs-slide], [data-bs-slide-to]", IK = '[data-bs-ride="carousel"]', PK = {
  [uK]: em,
  [pK]: Wo
}, EK = {
  interval: 5e3,
  keyboard: !0,
  pause: "hover",
  ride: !1,
  touch: !0,
  wrap: !0
}, NK = {
  interval: "(number|boolean)",
  // TODO:v6 remove boolean support
  keyboard: "boolean",
  pause: "(string|boolean)",
  ride: "(boolean|string)",
  touch: "boolean",
  wrap: "boolean"
};
class op extends Ci {
  constructor(t, e) {
    super(t, e), this._interval = null, this._activeElement = null, this._isSliding = !1, this.touchTimeout = null, this._swipeHelper = null, this._indicatorsElement = Re.findOne(LK, this._element), this._addEventListeners(), this._config.ride === TR && this.cycle();
  }
  // Getters
  static get Default() {
    return EK;
  }
  static get DefaultType() {
    return NK;
  }
  static get NAME() {
    return cK;
  }
  // Public
  next() {
    this._slide(Cd);
  }
  nextWhenVisible() {
    !document.hidden && Bc(this._element) && this.next();
  }
  prev() {
    this._slide(Ho);
  }
  pause() {
    this._isSliding && gR(this._element), this._clearInterval();
  }
  cycle() {
    this._clearInterval(), this._updateInterval(), this._interval = setInterval(() => this.nextWhenVisible(), this._config.interval);
  }
  _maybeEnableCycle() {
    if (this._config.ride) {
      if (this._isSliding) {
        Zt.one(this._element, ov, () => this.cycle());
        return;
      }
      this.cycle();
    }
  }
  to(t) {
    const e = this._getItems();
    if (t > e.length - 1 || t < 0)
      return;
    if (this._isSliding) {
      Zt.one(this._element, ov, () => this.to(t));
      return;
    }
    const a = this._getItemIndex(this._getActive());
    if (a === t)
      return;
    const n = t > a ? Cd : Ho;
    this._slide(n, e[t]);
  }
  dispose() {
    this._swipeHelper && this._swipeHelper.dispose(), super.dispose();
  }
  // Private
  _configAfterMerge(t) {
    return t.defaultInterval = t.interval, t;
  }
  _addEventListeners() {
    this._config.keyboard && Zt.on(this._element, gK, (t) => this._keydown(t)), this._config.pause === "hover" && (Zt.on(this._element, yK, () => this.pause()), Zt.on(this._element, fK, () => this._maybeEnableCycle())), this._config.touch && Ty.isSupported() && this._addTouchEventListeners();
  }
  _addTouchEventListeners() {
    for (const a of Re.find(TK, this._element))
      Zt.on(a, bK, (n) => n.preventDefault());
    const e = {
      leftCallback: () => this._slide(this._directionToOrder(Wo)),
      rightCallback: () => this._slide(this._directionToOrder(em)),
      endCallback: () => {
        this._config.pause === "hover" && (this.pause(), this.touchTimeout && clearTimeout(this.touchTimeout), this.touchTimeout = setTimeout(() => this._maybeEnableCycle(), hK + this._config.interval));
      }
    };
    this._swipeHelper = new Ty(this._element, e);
  }
  _keydown(t) {
    if (/input|textarea/i.test(t.target.tagName))
      return;
    const e = PK[t.key];
    e && (t.preventDefault(), this._slide(this._directionToOrder(e)));
  }
  _getItemIndex(t) {
    return this._getItems().indexOf(t);
  }
  _setActiveIndicatorElement(t) {
    if (!this._indicatorsElement)
      return;
    const e = Re.findOne(LR, this._indicatorsElement);
    e.classList.remove(kh), e.removeAttribute("aria-current");
    const a = Re.findOne(`[data-bs-slide-to="${t}"]`, this._indicatorsElement);
    a && (a.classList.add(kh), a.setAttribute("aria-current", "true"));
  }
  _updateInterval() {
    const t = this._activeElement || this._getActive();
    if (!t)
      return;
    const e = Number.parseInt(t.getAttribute("data-bs-interval"), 10);
    this._config.interval = e || this._config.defaultInterval;
  }
  _slide(t, e = null) {
    if (this._isSliding)
      return;
    const a = this._getActive(), n = t === Cd, i = e || GA(this._getItems(), a, n, this._config.wrap);
    if (i === a)
      return;
    const r = this._getItemIndex(i), l = (g) => Zt.trigger(this._element, g, {
      relatedTarget: i,
      direction: this._orderToDirection(t),
      from: this._getItemIndex(a),
      to: r
    });
    if (l(mK).defaultPrevented || !a || !i)
      return;
    const c = !!this._interval;
    this.pause(), this._isSliding = !0, this._setActiveIndicatorElement(r), this._activeElement = i;
    const d = n ? CK : AK, p = n ? $K : SK;
    i.classList.add(p), rp(i), a.classList.add(d), i.classList.add(d);
    const h = () => {
      i.classList.remove(d, p), i.classList.add(kh), a.classList.remove(kh, p, d), this._isSliding = !1, l(ov);
    };
    this._queueCallback(h, a, this._isAnimated()), c && this.cycle();
  }
  _isAnimated() {
    return this._element.classList.contains(wK);
  }
  _getActive() {
    return Re.findOne(kK, this._element);
  }
  _getItems() {
    return Re.find(DR, this._element);
  }
  _clearInterval() {
    this._interval && (clearInterval(this._interval), this._interval = null);
  }
  _directionToOrder(t) {
    return ri() ? t === Wo ? Ho : Cd : t === Wo ? Cd : Ho;
  }
  _orderToDirection(t) {
    return ri() ? t === Ho ? Wo : em : t === Ho ? em : Wo;
  }
  // Static
  static jQueryInterface(t) {
    return this.each(function() {
      const e = op.getOrCreateInstance(this, t);
      if (typeof t == "number") {
        e.to(t);
        return;
      }
      if (typeof t == "string") {
        if (e[t] === void 0 || t.startsWith("_") || t === "constructor")
          throw new TypeError(`No method named "${t}"`);
        e[t]();
      }
    });
  }
}
Zt.on(document, xK, DK, function(s) {
  const t = Re.getElementFromSelector(this);
  if (!t || !t.classList.contains(TR))
    return;
  s.preventDefault();
  const e = op.getOrCreateInstance(t), a = this.getAttribute("data-bs-slide-to");
  if (a) {
    e.to(a), e._maybeEnableCycle();
    return;
  }
  if (fr.getDataAttribute(this, "slide") === "next") {
    e.next(), e._maybeEnableCycle();
    return;
  }
  e.prev(), e._maybeEnableCycle();
});
Zt.on(window, vK, () => {
  const s = Re.find(IK);
  for (const t of s)
    op.getOrCreateInstance(t);
});
oi(op);
const RK = "collapse", YK = "bs.collapse", cp = `.${YK}`, _K = ".data-api", OK = `show${cp}`, MK = `shown${cp}`, XK = `hide${cp}`, GK = `hidden${cp}`, HK = `click${cp}${_K}`, cv = "show", nc = "collapse", Th = "collapsing", UK = "collapsed", FK = `:scope .${nc} .${nc}`, zK = "collapse-horizontal", BK = "width", WK = "height", jK = ".collapse.show, .collapse.collapsing", fw = '[data-bs-toggle="collapse"]', VK = {
  parent: null,
  toggle: !0
}, qK = {
  parent: "(null|element)",
  toggle: "boolean"
};
class Ru extends Ci {
  constructor(t, e) {
    super(t, e), this._isTransitioning = !1, this._triggerArray = [];
    const a = Re.find(fw);
    for (const n of a) {
      const i = Re.getSelectorFromElement(n), r = Re.find(i).filter((l) => l === this._element);
      i !== null && r.length && this._triggerArray.push(n);
    }
    this._initializeChildren(), this._config.parent || this._addAriaAndCollapsedClass(this._triggerArray, this._isShown()), this._config.toggle && this.toggle();
  }
  // Getters
  static get Default() {
    return VK;
  }
  static get DefaultType() {
    return qK;
  }
  static get NAME() {
    return RK;
  }
  // Public
  toggle() {
    this._isShown() ? this.hide() : this.show();
  }
  show() {
    if (this._isTransitioning || this._isShown())
      return;
    let t = [];
    if (this._config.parent && (t = this._getFirstLevelChildren(jK).filter((l) => l !== this._element).map((l) => Ru.getOrCreateInstance(l, {
      toggle: !1
    }))), t.length && t[0]._isTransitioning || Zt.trigger(this._element, OK).defaultPrevented)
      return;
    for (const l of t)
      l.hide();
    const a = this._getDimension();
    this._element.classList.remove(nc), this._element.classList.add(Th), this._element.style[a] = 0, this._addAriaAndCollapsedClass(this._triggerArray, !0), this._isTransitioning = !0;
    const n = () => {
      this._isTransitioning = !1, this._element.classList.remove(Th), this._element.classList.add(nc, cv), this._element.style[a] = "", Zt.trigger(this._element, MK);
    }, r = `scroll${a[0].toUpperCase() + a.slice(1)}`;
    this._queueCallback(n, this._element, !0), this._element.style[a] = `${this._element[r]}px`;
  }
  hide() {
    if (this._isTransitioning || !this._isShown() || Zt.trigger(this._element, XK).defaultPrevented)
      return;
    const e = this._getDimension();
    this._element.style[e] = `${this._element.getBoundingClientRect()[e]}px`, rp(this._element), this._element.classList.add(Th), this._element.classList.remove(nc, cv);
    for (const n of this._triggerArray) {
      const i = Re.getElementFromSelector(n);
      i && !this._isShown(i) && this._addAriaAndCollapsedClass([n], !1);
    }
    this._isTransitioning = !0;
    const a = () => {
      this._isTransitioning = !1, this._element.classList.remove(Th), this._element.classList.add(nc), Zt.trigger(this._element, GK);
    };
    this._element.style[e] = "", this._queueCallback(a, this._element, !0);
  }
  _isShown(t = this._element) {
    return t.classList.contains(cv);
  }
  // Private
  _configAfterMerge(t) {
    return t.toggle = !!t.toggle, t.parent = il(t.parent), t;
  }
  _getDimension() {
    return this._element.classList.contains(zK) ? BK : WK;
  }
  _initializeChildren() {
    if (!this._config.parent)
      return;
    const t = this._getFirstLevelChildren(fw);
    for (const e of t) {
      const a = Re.getElementFromSelector(e);
      a && this._addAriaAndCollapsedClass([e], this._isShown(a));
    }
  }
  _getFirstLevelChildren(t) {
    const e = Re.find(FK, this._config.parent);
    return Re.find(t, this._config.parent).filter((a) => !e.includes(a));
  }
  _addAriaAndCollapsedClass(t, e) {
    if (t.length)
      for (const a of t)
        a.classList.toggle(UK, !e), a.setAttribute("aria-expanded", e);
  }
  // Static
  static jQueryInterface(t) {
    const e = {};
    return typeof t == "string" && /show|hide/.test(t) && (e.toggle = !1), this.each(function() {
      const a = Ru.getOrCreateInstance(this, e);
      if (typeof t == "string") {
        if (typeof a[t] > "u")
          throw new TypeError(`No method named "${t}"`);
        a[t]();
      }
    });
  }
}
Zt.on(document, HK, fw, function(s) {
  (s.target.tagName === "A" || s.delegateTarget && s.delegateTarget.tagName === "A") && s.preventDefault();
  for (const t of Re.getMultipleElementsFromSelector(this))
    Ru.getOrCreateInstance(t, {
      toggle: !1
    }).toggle();
});
oi(Ru);
const jI = "dropdown", KK = "bs.dropdown", co = `.${KK}`, UA = ".data-api", JK = "Escape", VI = "Tab", QK = "ArrowUp", qI = "ArrowDown", ZK = 2, t7 = `hide${co}`, e7 = `hidden${co}`, a7 = `show${co}`, n7 = `shown${co}`, IR = `click${co}${UA}`, PR = `keydown${co}${UA}`, s7 = `keyup${co}${UA}`, jo = "show", i7 = "dropup", r7 = "dropend", l7 = "dropstart", o7 = "dropup-center", c7 = "dropdown-center", _l = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)', d7 = `${_l}.${jo}`, am = ".dropdown-menu", u7 = ".navbar", p7 = ".navbar-nav", h7 = ".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)", m7 = ri() ? "top-end" : "top-start", g7 = ri() ? "top-start" : "top-end", y7 = ri() ? "bottom-end" : "bottom-start", f7 = ri() ? "bottom-start" : "bottom-end", b7 = ri() ? "left-start" : "right-start", v7 = ri() ? "right-start" : "left-start", x7 = "top", w7 = "bottom", A7 = {
  autoClose: !0,
  boundary: "clippingParents",
  display: "dynamic",
  offset: [0, 2],
  popperConfig: null,
  reference: "toggle"
}, C7 = {
  autoClose: "(boolean|string)",
  boundary: "(string|element)",
  display: "string",
  offset: "(array|string|function)",
  popperConfig: "(null|object|function)",
  reference: "(string|element|object)"
};
class Bi extends Ci {
  constructor(t, e) {
    super(t, e), this._popper = null, this._parent = this._element.parentNode, this._menu = Re.next(this._element, am)[0] || Re.prev(this._element, am)[0] || Re.findOne(am, this._parent), this._inNavbar = this._detectNavbar();
  }
  // Getters
  static get Default() {
    return A7;
  }
  static get DefaultType() {
    return C7;
  }
  static get NAME() {
    return jI;
  }
  // Public
  toggle() {
    return this._isShown() ? this.hide() : this.show();
  }
  show() {
    if (rl(this._element) || this._isShown())
      return;
    const t = {
      relatedTarget: this._element
    };
    if (!Zt.trigger(this._element, a7, t).defaultPrevented) {
      if (this._createPopper(), "ontouchstart" in document.documentElement && !this._parent.closest(p7))
        for (const a of [].concat(...document.body.children))
          Zt.on(a, "mouseover", ky);
      this._element.focus(), this._element.setAttribute("aria-expanded", !0), this._menu.classList.add(jo), this._element.classList.add(jo), Zt.trigger(this._element, n7, t);
    }
  }
  hide() {
    if (rl(this._element) || !this._isShown())
      return;
    const t = {
      relatedTarget: this._element
    };
    this._completeHide(t);
  }
  dispose() {
    this._popper && this._popper.destroy(), super.dispose();
  }
  update() {
    this._inNavbar = this._detectNavbar(), this._popper && this._popper.update();
  }
  // Private
  _completeHide(t) {
    if (!Zt.trigger(this._element, t7, t).defaultPrevented) {
      if ("ontouchstart" in document.documentElement)
        for (const a of [].concat(...document.body.children))
          Zt.off(a, "mouseover", ky);
      this._popper && this._popper.destroy(), this._menu.classList.remove(jo), this._element.classList.remove(jo), this._element.setAttribute("aria-expanded", "false"), fr.removeDataAttribute(this._menu, "popper"), Zt.trigger(this._element, e7, t);
    }
  }
  _getConfig(t) {
    if (t = super._getConfig(t), typeof t.reference == "object" && !yr(t.reference) && typeof t.reference.getBoundingClientRect != "function")
      throw new TypeError(`${jI.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
    return t;
  }
  _createPopper() {
    if (typeof pN > "u")
      throw new TypeError("Bootstrap's dropdowns require Popper (https://popper.js.org)");
    let t = this._element;
    this._config.reference === "parent" ? t = this._parent : yr(this._config.reference) ? t = il(this._config.reference) : typeof this._config.reference == "object" && (t = this._config.reference);
    const e = this._getPopperConfig();
    this._popper = pf(t, this._menu, e);
  }
  _isShown() {
    return this._menu.classList.contains(jo);
  }
  _getPlacement() {
    const t = this._parent;
    if (t.classList.contains(r7))
      return b7;
    if (t.classList.contains(l7))
      return v7;
    if (t.classList.contains(o7))
      return x7;
    if (t.classList.contains(c7))
      return w7;
    const e = getComputedStyle(this._menu).getPropertyValue("--bs-position").trim() === "end";
    return t.classList.contains(i7) ? e ? g7 : m7 : e ? f7 : y7;
  }
  _detectNavbar() {
    return this._element.closest(u7) !== null;
  }
  _getOffset() {
    const {
      offset: t
    } = this._config;
    return typeof t == "string" ? t.split(",").map((e) => Number.parseInt(e, 10)) : typeof t == "function" ? (e) => t(e, this._element) : t;
  }
  _getPopperConfig() {
    const t = {
      placement: this._getPlacement(),
      modifiers: [{
        name: "preventOverflow",
        options: {
          boundary: this._config.boundary
        }
      }, {
        name: "offset",
        options: {
          offset: this._getOffset()
        }
      }]
    };
    return (this._inNavbar || this._config.display === "static") && (fr.setDataAttribute(this._menu, "popper", "static"), t.modifiers = [{
      name: "applyStyles",
      enabled: !1
    }]), {
      ...t,
      ...vs(this._config.popperConfig, [t])
    };
  }
  _selectMenuItem({
    key: t,
    target: e
  }) {
    const a = Re.find(h7, this._menu).filter((n) => Bc(n));
    a.length && GA(a, e, t === qI, !a.includes(e)).focus();
  }
  // Static
  static jQueryInterface(t) {
    return this.each(function() {
      const e = Bi.getOrCreateInstance(this, t);
      if (typeof t == "string") {
        if (typeof e[t] > "u")
          throw new TypeError(`No method named "${t}"`);
        e[t]();
      }
    });
  }
  static clearMenus(t) {
    if (t.button === ZK || t.type === "keyup" && t.key !== VI)
      return;
    const e = Re.find(d7);
    for (const a of e) {
      const n = Bi.getInstance(a);
      if (!n || n._config.autoClose === !1)
        continue;
      const i = t.composedPath(), r = i.includes(n._menu);
      if (i.includes(n._element) || n._config.autoClose === "inside" && !r || n._config.autoClose === "outside" && r || n._menu.contains(t.target) && (t.type === "keyup" && t.key === VI || /input|select|option|textarea|form/i.test(t.target.tagName)))
        continue;
      const l = {
        relatedTarget: n._element
      };
      t.type === "click" && (l.clickEvent = t), n._completeHide(l);
    }
  }
  static dataApiKeydownHandler(t) {
    const e = /input|textarea/i.test(t.target.tagName), a = t.key === JK, n = [QK, qI].includes(t.key);
    if (!n && !a || e && !a)
      return;
    t.preventDefault();
    const i = this.matches(_l) ? this : Re.prev(this, _l)[0] || Re.next(this, _l)[0] || Re.findOne(_l, t.delegateTarget.parentNode), r = Bi.getOrCreateInstance(i);
    if (n) {
      t.stopPropagation(), r.show(), r._selectMenuItem(t);
      return;
    }
    r._isShown() && (t.stopPropagation(), r.hide(), i.focus());
  }
}
Zt.on(document, PR, _l, Bi.dataApiKeydownHandler);
Zt.on(document, PR, am, Bi.dataApiKeydownHandler);
Zt.on(document, IR, Bi.clearMenus);
Zt.on(document, s7, Bi.clearMenus);
Zt.on(document, IR, _l, function(s) {
  s.preventDefault(), Bi.getOrCreateInstance(this).toggle();
});
oi(Bi);
const ER = "backdrop", $7 = "fade", KI = "show", JI = `mousedown.bs.${ER}`, S7 = {
  className: "modal-backdrop",
  clickCallback: null,
  isAnimated: !1,
  isVisible: !0,
  // if false, we use the backdrop helper without adding any element to the dom
  rootElement: "body"
  // give the choice to place backdrop under different elements
}, k7 = {
  className: "string",
  clickCallback: "(function|null)",
  isAnimated: "boolean",
  isVisible: "boolean",
  rootElement: "(element|string)"
};
class NR extends lp {
  constructor(t) {
    super(), this._config = this._getConfig(t), this._isAppended = !1, this._element = null;
  }
  // Getters
  static get Default() {
    return S7;
  }
  static get DefaultType() {
    return k7;
  }
  static get NAME() {
    return ER;
  }
  // Public
  show(t) {
    if (!this._config.isVisible) {
      vs(t);
      return;
    }
    this._append();
    const e = this._getElement();
    this._config.isAnimated && rp(e), e.classList.add(KI), this._emulateAnimation(() => {
      vs(t);
    });
  }
  hide(t) {
    if (!this._config.isVisible) {
      vs(t);
      return;
    }
    this._getElement().classList.remove(KI), this._emulateAnimation(() => {
      this.dispose(), vs(t);
    });
  }
  dispose() {
    this._isAppended && (Zt.off(this._element, JI), this._element.remove(), this._isAppended = !1);
  }
  // Private
  _getElement() {
    if (!this._element) {
      const t = document.createElement("div");
      t.className = this._config.className, this._config.isAnimated && t.classList.add($7), this._element = t;
    }
    return this._element;
  }
  _configAfterMerge(t) {
    return t.rootElement = il(t.rootElement), t;
  }
  _append() {
    if (this._isAppended)
      return;
    const t = this._getElement();
    this._config.rootElement.append(t), Zt.on(t, JI, () => {
      vs(this._config.clickCallback);
    }), this._isAppended = !0;
  }
  _emulateAnimation(t) {
    bR(t, this._getElement(), this._config.isAnimated);
  }
}
const T7 = "focustrap", L7 = "bs.focustrap", Ly = `.${L7}`, D7 = `focusin${Ly}`, I7 = `keydown.tab${Ly}`, P7 = "Tab", E7 = "forward", QI = "backward", N7 = {
  autofocus: !0,
  trapElement: null
  // The element to trap focus inside of
}, R7 = {
  autofocus: "boolean",
  trapElement: "element"
};
class RR extends lp {
  constructor(t) {
    super(), this._config = this._getConfig(t), this._isActive = !1, this._lastTabNavDirection = null;
  }
  // Getters
  static get Default() {
    return N7;
  }
  static get DefaultType() {
    return R7;
  }
  static get NAME() {
    return T7;
  }
  // Public
  activate() {
    this._isActive || (this._config.autofocus && this._config.trapElement.focus(), Zt.off(document, Ly), Zt.on(document, D7, (t) => this._handleFocusin(t)), Zt.on(document, I7, (t) => this._handleKeydown(t)), this._isActive = !0);
  }
  deactivate() {
    this._isActive && (this._isActive = !1, Zt.off(document, Ly));
  }
  // Private
  _handleFocusin(t) {
    const {
      trapElement: e
    } = this._config;
    if (t.target === document || t.target === e || e.contains(t.target))
      return;
    const a = Re.focusableChildren(e);
    a.length === 0 ? e.focus() : this._lastTabNavDirection === QI ? a[a.length - 1].focus() : a[0].focus();
  }
  _handleKeydown(t) {
    t.key === P7 && (this._lastTabNavDirection = t.shiftKey ? QI : E7);
  }
}
const ZI = ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top", t0 = ".sticky-top", Lh = "padding-right", e0 = "margin-right";
class bw {
  constructor() {
    this._element = document.body;
  }
  // Public
  getWidth() {
    const t = document.documentElement.clientWidth;
    return Math.abs(window.innerWidth - t);
  }
  hide() {
    const t = this.getWidth();
    this._disableOverFlow(), this._setElementAttributes(this._element, Lh, (e) => e + t), this._setElementAttributes(ZI, Lh, (e) => e + t), this._setElementAttributes(t0, e0, (e) => e - t);
  }
  reset() {
    this._resetElementAttributes(this._element, "overflow"), this._resetElementAttributes(this._element, Lh), this._resetElementAttributes(ZI, Lh), this._resetElementAttributes(t0, e0);
  }
  isOverflowing() {
    return this.getWidth() > 0;
  }
  // Private
  _disableOverFlow() {
    this._saveInitialAttribute(this._element, "overflow"), this._element.style.overflow = "hidden";
  }
  _setElementAttributes(t, e, a) {
    const n = this.getWidth(), i = (r) => {
      if (r !== this._element && window.innerWidth > r.clientWidth + n)
        return;
      this._saveInitialAttribute(r, e);
      const l = window.getComputedStyle(r).getPropertyValue(e);
      r.style.setProperty(e, `${a(Number.parseFloat(l))}px`);
    };
    this._applyManipulationCallback(t, i);
  }
  _saveInitialAttribute(t, e) {
    const a = t.style.getPropertyValue(e);
    a && fr.setDataAttribute(t, e, a);
  }
  _resetElementAttributes(t, e) {
    const a = (n) => {
      const i = fr.getDataAttribute(n, e);
      if (i === null) {
        n.style.removeProperty(e);
        return;
      }
      fr.removeDataAttribute(n, e), n.style.setProperty(e, i);
    };
    this._applyManipulationCallback(t, a);
  }
  _applyManipulationCallback(t, e) {
    if (yr(t)) {
      e(t);
      return;
    }
    for (const a of Re.find(t, this._element))
      e(a);
  }
}
const Y7 = "modal", _7 = "bs.modal", li = `.${_7}`, O7 = ".data-api", M7 = "Escape", X7 = `hide${li}`, G7 = `hidePrevented${li}`, YR = `hidden${li}`, _R = `show${li}`, H7 = `shown${li}`, U7 = `resize${li}`, F7 = `click.dismiss${li}`, z7 = `mousedown.dismiss${li}`, B7 = `keydown.dismiss${li}`, W7 = `click${li}${O7}`, a0 = "modal-open", j7 = "fade", n0 = "show", dv = "modal-static", V7 = ".modal.show", q7 = ".modal-dialog", K7 = ".modal-body", J7 = '[data-bs-toggle="modal"]', Q7 = {
  backdrop: !0,
  focus: !0,
  keyboard: !0
}, Z7 = {
  backdrop: "(boolean|string)",
  focus: "boolean",
  keyboard: "boolean"
};
class Yc extends Ci {
  constructor(t, e) {
    super(t, e), this._dialog = Re.findOne(q7, this._element), this._backdrop = this._initializeBackDrop(), this._focustrap = this._initializeFocusTrap(), this._isShown = !1, this._isTransitioning = !1, this._scrollBar = new bw(), this._addEventListeners();
  }
  // Getters
  static get Default() {
    return Q7;
  }
  static get DefaultType() {
    return Z7;
  }
  static get NAME() {
    return Y7;
  }
  // Public
  toggle(t) {
    return this._isShown ? this.hide() : this.show(t);
  }
  show(t) {
    this._isShown || this._isTransitioning || Zt.trigger(this._element, _R, {
      relatedTarget: t
    }).defaultPrevented || (this._isShown = !0, this._isTransitioning = !0, this._scrollBar.hide(), document.body.classList.add(a0), this._adjustDialog(), this._backdrop.show(() => this._showElement(t)));
  }
  hide() {
    !this._isShown || this._isTransitioning || Zt.trigger(this._element, X7).defaultPrevented || (this._isShown = !1, this._isTransitioning = !0, this._focustrap.deactivate(), this._element.classList.remove(n0), this._queueCallback(() => this._hideModal(), this._element, this._isAnimated()));
  }
  dispose() {
    Zt.off(window, li), Zt.off(this._dialog, li), this._backdrop.dispose(), this._focustrap.deactivate(), super.dispose();
  }
  handleUpdate() {
    this._adjustDialog();
  }
  // Private
  _initializeBackDrop() {
    return new NR({
      isVisible: !!this._config.backdrop,
      // 'static' option will be translated to true, and booleans will keep their value,
      isAnimated: this._isAnimated()
    });
  }
  _initializeFocusTrap() {
    return new RR({
      trapElement: this._element
    });
  }
  _showElement(t) {
    document.body.contains(this._element) || document.body.append(this._element), this._element.style.display = "block", this._element.removeAttribute("aria-hidden"), this._element.setAttribute("aria-modal", !0), this._element.setAttribute("role", "dialog"), this._element.scrollTop = 0;
    const e = Re.findOne(K7, this._dialog);
    e && (e.scrollTop = 0), rp(this._element), this._element.classList.add(n0);
    const a = () => {
      this._config.focus && this._focustrap.activate(), this._isTransitioning = !1, Zt.trigger(this._element, H7, {
        relatedTarget: t
      });
    };
    this._queueCallback(a, this._dialog, this._isAnimated());
  }
  _addEventListeners() {
    Zt.on(this._element, B7, (t) => {
      if (t.key === M7) {
        if (this._config.keyboard) {
          this.hide();
          return;
        }
        this._triggerBackdropTransition();
      }
    }), Zt.on(window, U7, () => {
      this._isShown && !this._isTransitioning && this._adjustDialog();
    }), Zt.on(this._element, z7, (t) => {
      Zt.one(this._element, F7, (e) => {
        if (!(this._element !== t.target || this._element !== e.target)) {
          if (this._config.backdrop === "static") {
            this._triggerBackdropTransition();
            return;
          }
          this._config.backdrop && this.hide();
        }
      });
    });
  }
  _hideModal() {
    this._element.style.display = "none", this._element.setAttribute("aria-hidden", !0), this._element.removeAttribute("aria-modal"), this._element.removeAttribute("role"), this._isTransitioning = !1, this._backdrop.hide(() => {
      document.body.classList.remove(a0), this._resetAdjustments(), this._scrollBar.reset(), Zt.trigger(this._element, YR);
    });
  }
  _isAnimated() {
    return this._element.classList.contains(j7);
  }
  _triggerBackdropTransition() {
    if (Zt.trigger(this._element, G7).defaultPrevented)
      return;
    const e = this._element.scrollHeight > document.documentElement.clientHeight, a = this._element.style.overflowY;
    a === "hidden" || this._element.classList.contains(dv) || (e || (this._element.style.overflowY = "hidden"), this._element.classList.add(dv), this._queueCallback(() => {
      this._element.classList.remove(dv), this._queueCallback(() => {
        this._element.style.overflowY = a;
      }, this._dialog);
    }, this._dialog), this._element.focus());
  }
  /**
   * The following methods are used to handle overflowing modals
   */
  _adjustDialog() {
    const t = this._element.scrollHeight > document.documentElement.clientHeight, e = this._scrollBar.getWidth(), a = e > 0;
    if (a && !t) {
      const n = ri() ? "paddingLeft" : "paddingRight";
      this._element.style[n] = `${e}px`;
    }
    if (!a && t) {
      const n = ri() ? "paddingRight" : "paddingLeft";
      this._element.style[n] = `${e}px`;
    }
  }
  _resetAdjustments() {
    this._element.style.paddingLeft = "", this._element.style.paddingRight = "";
  }
  // Static
  static jQueryInterface(t, e) {
    return this.each(function() {
      const a = Yc.getOrCreateInstance(this, t);
      if (typeof t == "string") {
        if (typeof a[t] > "u")
          throw new TypeError(`No method named "${t}"`);
        a[t](e);
      }
    });
  }
}
Zt.on(document, W7, J7, function(s) {
  const t = Re.getElementFromSelector(this);
  ["A", "AREA"].includes(this.tagName) && s.preventDefault(), Zt.one(t, _R, (n) => {
    n.defaultPrevented || Zt.one(t, YR, () => {
      Bc(this) && this.focus();
    });
  });
  const e = Re.findOne(V7);
  e && Yc.getInstance(e).hide(), Yc.getOrCreateInstance(t).toggle(this);
});
wf(Yc);
oi(Yc);
const tJ = "offcanvas", eJ = "bs.offcanvas", kr = `.${eJ}`, OR = ".data-api", aJ = `load${kr}${OR}`, nJ = "Escape", s0 = "show", i0 = "showing", r0 = "hiding", sJ = "offcanvas-backdrop", MR = ".offcanvas.show", iJ = `show${kr}`, rJ = `shown${kr}`, lJ = `hide${kr}`, l0 = `hidePrevented${kr}`, XR = `hidden${kr}`, oJ = `resize${kr}`, cJ = `click${kr}${OR}`, dJ = `keydown.dismiss${kr}`, uJ = '[data-bs-toggle="offcanvas"]', pJ = {
  backdrop: !0,
  keyboard: !0,
  scroll: !1
}, hJ = {
  backdrop: "(boolean|string)",
  keyboard: "boolean",
  scroll: "boolean"
};
class ll extends Ci {
  constructor(t, e) {
    super(t, e), this._isShown = !1, this._backdrop = this._initializeBackDrop(), this._focustrap = this._initializeFocusTrap(), this._addEventListeners();
  }
  // Getters
  static get Default() {
    return pJ;
  }
  static get DefaultType() {
    return hJ;
  }
  static get NAME() {
    return tJ;
  }
  // Public
  toggle(t) {
    return this._isShown ? this.hide() : this.show(t);
  }
  show(t) {
    if (this._isShown || Zt.trigger(this._element, iJ, {
      relatedTarget: t
    }).defaultPrevented)
      return;
    this._isShown = !0, this._backdrop.show(), this._config.scroll || new bw().hide(), this._element.setAttribute("aria-modal", !0), this._element.setAttribute("role", "dialog"), this._element.classList.add(i0);
    const a = () => {
      (!this._config.scroll || this._config.backdrop) && this._focustrap.activate(), this._element.classList.add(s0), this._element.classList.remove(i0), Zt.trigger(this._element, rJ, {
        relatedTarget: t
      });
    };
    this._queueCallback(a, this._element, !0);
  }
  hide() {
    if (!this._isShown || Zt.trigger(this._element, lJ).defaultPrevented)
      return;
    this._focustrap.deactivate(), this._element.blur(), this._isShown = !1, this._element.classList.add(r0), this._backdrop.hide();
    const e = () => {
      this._element.classList.remove(s0, r0), this._element.removeAttribute("aria-modal"), this._element.removeAttribute("role"), this._config.scroll || new bw().reset(), Zt.trigger(this._element, XR);
    };
    this._queueCallback(e, this._element, !0);
  }
  dispose() {
    this._backdrop.dispose(), this._focustrap.deactivate(), super.dispose();
  }
  // Private
  _initializeBackDrop() {
    const t = () => {
      if (this._config.backdrop === "static") {
        Zt.trigger(this._element, l0);
        return;
      }
      this.hide();
    }, e = !!this._config.backdrop;
    return new NR({
      className: sJ,
      isVisible: e,
      isAnimated: !0,
      rootElement: this._element.parentNode,
      clickCallback: e ? t : null
    });
  }
  _initializeFocusTrap() {
    return new RR({
      trapElement: this._element
    });
  }
  _addEventListeners() {
    Zt.on(this._element, dJ, (t) => {
      if (t.key === nJ) {
        if (this._config.keyboard) {
          this.hide();
          return;
        }
        Zt.trigger(this._element, l0);
      }
    });
  }
  // Static
  static jQueryInterface(t) {
    return this.each(function() {
      const e = ll.getOrCreateInstance(this, t);
      if (typeof t == "string") {
        if (e[t] === void 0 || t.startsWith("_") || t === "constructor")
          throw new TypeError(`No method named "${t}"`);
        e[t](this);
      }
    });
  }
}
Zt.on(document, cJ, uJ, function(s) {
  const t = Re.getElementFromSelector(this);
  if (["A", "AREA"].includes(this.tagName) && s.preventDefault(), rl(this))
    return;
  Zt.one(t, XR, () => {
    Bc(this) && this.focus();
  });
  const e = Re.findOne(MR);
  e && e !== t && ll.getInstance(e).hide(), ll.getOrCreateInstance(t).toggle(this);
});
Zt.on(window, aJ, () => {
  for (const s of Re.find(MR))
    ll.getOrCreateInstance(s).show();
});
Zt.on(window, oJ, () => {
  for (const s of Re.find("[aria-modal][class*=show][class*=offcanvas-]"))
    getComputedStyle(s).position !== "fixed" && ll.getOrCreateInstance(s).hide();
});
wf(ll);
oi(ll);
const mJ = /^aria-[\w-]*$/i, GR = {
  // Global attributes allowed on any supplied element below.
  "*": ["class", "dir", "id", "lang", "role", mJ],
  a: ["target", "href", "title", "rel"],
  area: [],
  b: [],
  br: [],
  col: [],
  code: [],
  dd: [],
  div: [],
  dl: [],
  dt: [],
  em: [],
  hr: [],
  h1: [],
  h2: [],
  h3: [],
  h4: [],
  h5: [],
  h6: [],
  i: [],
  img: ["src", "srcset", "alt", "title", "width", "height"],
  li: [],
  ol: [],
  p: [],
  pre: [],
  s: [],
  small: [],
  span: [],
  sub: [],
  sup: [],
  strong: [],
  u: [],
  ul: []
}, gJ = /* @__PURE__ */ new Set(["background", "cite", "href", "itemtype", "longdesc", "poster", "src", "xlink:href"]), yJ = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i, fJ = (s, t) => {
  const e = s.nodeName.toLowerCase();
  return t.includes(e) ? gJ.has(e) ? !!yJ.test(s.nodeValue) : !0 : t.filter((a) => a instanceof RegExp).some((a) => a.test(e));
};
function bJ(s, t, e) {
  if (!s.length)
    return s;
  if (e && typeof e == "function")
    return e(s);
  const n = new window.DOMParser().parseFromString(s, "text/html"), i = [].concat(...n.body.querySelectorAll("*"));
  for (const r of i) {
    const l = r.nodeName.toLowerCase();
    if (!Object.keys(t).includes(l)) {
      r.remove();
      continue;
    }
    const o = [].concat(...r.attributes), c = [].concat(t["*"] || [], t[l] || []);
    for (const d of o)
      fJ(d, c) || r.removeAttribute(d.nodeName);
  }
  return n.body.innerHTML;
}
const vJ = "TemplateFactory", xJ = {
  allowList: GR,
  content: {},
  // { selector : text ,  selector2 : text2 , }
  extraClass: "",
  html: !1,
  sanitize: !0,
  sanitizeFn: null,
  template: "<div></div>"
}, wJ = {
  allowList: "object",
  content: "object",
  extraClass: "(string|function)",
  html: "boolean",
  sanitize: "boolean",
  sanitizeFn: "(null|function)",
  template: "string"
}, AJ = {
  entry: "(string|element|function|null)",
  selector: "(string|element)"
};
class CJ extends lp {
  constructor(t) {
    super(), this._config = this._getConfig(t);
  }
  // Getters
  static get Default() {
    return xJ;
  }
  static get DefaultType() {
    return wJ;
  }
  static get NAME() {
    return vJ;
  }
  // Public
  getContent() {
    return Object.values(this._config.content).map((t) => this._resolvePossibleFunction(t)).filter(Boolean);
  }
  hasContent() {
    return this.getContent().length > 0;
  }
  changeContent(t) {
    return this._checkContent(t), this._config.content = {
      ...this._config.content,
      ...t
    }, this;
  }
  toHtml() {
    const t = document.createElement("div");
    t.innerHTML = this._maybeSanitize(this._config.template);
    for (const [n, i] of Object.entries(this._config.content))
      this._setContent(t, i, n);
    const e = t.children[0], a = this._resolvePossibleFunction(this._config.extraClass);
    return a && e.classList.add(...a.split(" ")), e;
  }
  // Private
  _typeCheckConfig(t) {
    super._typeCheckConfig(t), this._checkContent(t.content);
  }
  _checkContent(t) {
    for (const [e, a] of Object.entries(t))
      super._typeCheckConfig({
        selector: e,
        entry: a
      }, AJ);
  }
  _setContent(t, e, a) {
    const n = Re.findOne(a, t);
    if (n) {
      if (e = this._resolvePossibleFunction(e), !e) {
        n.remove();
        return;
      }
      if (yr(e)) {
        this._putElementInTemplate(il(e), n);
        return;
      }
      if (this._config.html) {
        n.innerHTML = this._maybeSanitize(e);
        return;
      }
      n.textContent = e;
    }
  }
  _maybeSanitize(t) {
    return this._config.sanitize ? bJ(t, this._config.allowList, this._config.sanitizeFn) : t;
  }
  _resolvePossibleFunction(t) {
    return vs(t, [this]);
  }
  _putElementInTemplate(t, e) {
    if (this._config.html) {
      e.innerHTML = "", e.append(t);
      return;
    }
    e.textContent = t.textContent;
  }
}
const $J = "tooltip", SJ = /* @__PURE__ */ new Set(["sanitize", "allowList", "sanitizeFn"]), uv = "fade", kJ = "modal", Dh = "show", TJ = ".tooltip-inner", o0 = `.${kJ}`, c0 = "hide.bs.modal", $d = "hover", pv = "focus", LJ = "click", DJ = "manual", IJ = "hide", PJ = "hidden", EJ = "show", NJ = "shown", RJ = "inserted", YJ = "click", _J = "focusin", OJ = "focusout", MJ = "mouseenter", XJ = "mouseleave", GJ = {
  AUTO: "auto",
  TOP: "top",
  RIGHT: ri() ? "left" : "right",
  BOTTOM: "bottom",
  LEFT: ri() ? "right" : "left"
}, HJ = {
  allowList: GR,
  animation: !0,
  boundary: "clippingParents",
  container: !1,
  customClass: "",
  delay: 0,
  fallbackPlacements: ["top", "right", "bottom", "left"],
  html: !1,
  offset: [0, 6],
  placement: "top",
  popperConfig: null,
  sanitize: !0,
  sanitizeFn: null,
  selector: !1,
  template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
  title: "",
  trigger: "hover focus"
}, UJ = {
  allowList: "object",
  animation: "boolean",
  boundary: "(string|element)",
  container: "(string|element|boolean)",
  customClass: "(string|function)",
  delay: "(number|object)",
  fallbackPlacements: "array",
  html: "boolean",
  offset: "(array|string|function)",
  placement: "(string|function)",
  popperConfig: "(null|object|function)",
  sanitize: "boolean",
  sanitizeFn: "(null|function)",
  selector: "(string|boolean)",
  template: "string",
  title: "(string|element|function)",
  trigger: "string"
};
class uo extends Ci {
  constructor(t, e) {
    if (typeof pN > "u")
      throw new TypeError("Bootstrap's tooltips require Popper (https://popper.js.org)");
    super(t, e), this._isEnabled = !0, this._timeout = 0, this._isHovered = null, this._activeTrigger = {}, this._popper = null, this._templateFactory = null, this._newContent = null, this.tip = null, this._setListeners(), this._config.selector || this._fixTitle();
  }
  // Getters
  static get Default() {
    return HJ;
  }
  static get DefaultType() {
    return UJ;
  }
  static get NAME() {
    return $J;
  }
  // Public
  enable() {
    this._isEnabled = !0;
  }
  disable() {
    this._isEnabled = !1;
  }
  toggleEnabled() {
    this._isEnabled = !this._isEnabled;
  }
  toggle() {
    if (this._isEnabled) {
      if (this._activeTrigger.click = !this._activeTrigger.click, this._isShown()) {
        this._leave();
        return;
      }
      this._enter();
    }
  }
  dispose() {
    clearTimeout(this._timeout), Zt.off(this._element.closest(o0), c0, this._hideModalHandler), this._element.getAttribute("data-bs-original-title") && this._element.setAttribute("title", this._element.getAttribute("data-bs-original-title")), this._disposePopper(), super.dispose();
  }
  show() {
    if (this._element.style.display === "none")
      throw new Error("Please use show on visible elements");
    if (!(this._isWithContent() && this._isEnabled))
      return;
    const t = Zt.trigger(this._element, this.constructor.eventName(EJ)), a = (yR(this._element) || this._element.ownerDocument.documentElement).contains(this._element);
    if (t.defaultPrevented || !a)
      return;
    this._disposePopper();
    const n = this._getTipElement();
    this._element.setAttribute("aria-describedby", n.getAttribute("id"));
    const {
      container: i
    } = this._config;
    if (this._element.ownerDocument.documentElement.contains(this.tip) || (i.append(n), Zt.trigger(this._element, this.constructor.eventName(RJ))), this._popper = this._createPopper(n), n.classList.add(Dh), "ontouchstart" in document.documentElement)
      for (const l of [].concat(...document.body.children))
        Zt.on(l, "mouseover", ky);
    const r = () => {
      Zt.trigger(this._element, this.constructor.eventName(NJ)), this._isHovered === !1 && this._leave(), this._isHovered = !1;
    };
    this._queueCallback(r, this.tip, this._isAnimated());
  }
  hide() {
    if (!this._isShown() || Zt.trigger(this._element, this.constructor.eventName(IJ)).defaultPrevented)
      return;
    if (this._getTipElement().classList.remove(Dh), "ontouchstart" in document.documentElement)
      for (const n of [].concat(...document.body.children))
        Zt.off(n, "mouseover", ky);
    this._activeTrigger[LJ] = !1, this._activeTrigger[pv] = !1, this._activeTrigger[$d] = !1, this._isHovered = null;
    const a = () => {
      this._isWithActiveTrigger() || (this._isHovered || this._disposePopper(), this._element.removeAttribute("aria-describedby"), Zt.trigger(this._element, this.constructor.eventName(PJ)));
    };
    this._queueCallback(a, this.tip, this._isAnimated());
  }
  update() {
    this._popper && this._popper.update();
  }
  // Protected
  _isWithContent() {
    return !!this._getTitle();
  }
  _getTipElement() {
    return this.tip || (this.tip = this._createTipElement(this._newContent || this._getContentForTemplate())), this.tip;
  }
  _createTipElement(t) {
    const e = this._getTemplateFactory(t).toHtml();
    if (!e)
      return null;
    e.classList.remove(uv, Dh), e.classList.add(`bs-${this.constructor.NAME}-auto`);
    const a = L9(this.constructor.NAME).toString();
    return e.setAttribute("id", a), this._isAnimated() && e.classList.add(uv), e;
  }
  setContent(t) {
    this._newContent = t, this._isShown() && (this._disposePopper(), this.show());
  }
  _getTemplateFactory(t) {
    return this._templateFactory ? this._templateFactory.changeContent(t) : this._templateFactory = new CJ({
      ...this._config,
      // the `content` var has to be after `this._config`
      // to override config.content in case of popover
      content: t,
      extraClass: this._resolvePossibleFunction(this._config.customClass)
    }), this._templateFactory;
  }
  _getContentForTemplate() {
    return {
      [TJ]: this._getTitle()
    };
  }
  _getTitle() {
    return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute("data-bs-original-title");
  }
  // Private
  _initializeOnDelegatedTarget(t) {
    return this.constructor.getOrCreateInstance(t.delegateTarget, this._getDelegateConfig());
  }
  _isAnimated() {
    return this._config.animation || this.tip && this.tip.classList.contains(uv);
  }
  _isShown() {
    return this.tip && this.tip.classList.contains(Dh);
  }
  _createPopper(t) {
    const e = vs(this._config.placement, [this, t, this._element]), a = GJ[e.toUpperCase()];
    return pf(this._element, t, this._getPopperConfig(a));
  }
  _getOffset() {
    const {
      offset: t
    } = this._config;
    return typeof t == "string" ? t.split(",").map((e) => Number.parseInt(e, 10)) : typeof t == "function" ? (e) => t(e, this._element) : t;
  }
  _resolvePossibleFunction(t) {
    return vs(t, [this._element]);
  }
  _getPopperConfig(t) {
    const e = {
      placement: t,
      modifiers: [{
        name: "flip",
        options: {
          fallbackPlacements: this._config.fallbackPlacements
        }
      }, {
        name: "offset",
        options: {
          offset: this._getOffset()
        }
      }, {
        name: "preventOverflow",
        options: {
          boundary: this._config.boundary
        }
      }, {
        name: "arrow",
        options: {
          element: `.${this.constructor.NAME}-arrow`
        }
      }, {
        name: "preSetPlacement",
        enabled: !0,
        phase: "beforeMain",
        fn: (a) => {
          this._getTipElement().setAttribute("data-popper-placement", a.state.placement);
        }
      }]
    };
    return {
      ...e,
      ...vs(this._config.popperConfig, [e])
    };
  }
  _setListeners() {
    const t = this._config.trigger.split(" ");
    for (const e of t)
      if (e === "click")
        Zt.on(this._element, this.constructor.eventName(YJ), this._config.selector, (a) => {
          this._initializeOnDelegatedTarget(a).toggle();
        });
      else if (e !== DJ) {
        const a = e === $d ? this.constructor.eventName(MJ) : this.constructor.eventName(_J), n = e === $d ? this.constructor.eventName(XJ) : this.constructor.eventName(OJ);
        Zt.on(this._element, a, this._config.selector, (i) => {
          const r = this._initializeOnDelegatedTarget(i);
          r._activeTrigger[i.type === "focusin" ? pv : $d] = !0, r._enter();
        }), Zt.on(this._element, n, this._config.selector, (i) => {
          const r = this._initializeOnDelegatedTarget(i);
          r._activeTrigger[i.type === "focusout" ? pv : $d] = r._element.contains(i.relatedTarget), r._leave();
        });
      }
    this._hideModalHandler = () => {
      this._element && this.hide();
    }, Zt.on(this._element.closest(o0), c0, this._hideModalHandler);
  }
  _fixTitle() {
    const t = this._element.getAttribute("title");
    t && (!this._element.getAttribute("aria-label") && !this._element.textContent.trim() && this._element.setAttribute("aria-label", t), this._element.setAttribute("data-bs-original-title", t), this._element.removeAttribute("title"));
  }
  _enter() {
    if (this._isShown() || this._isHovered) {
      this._isHovered = !0;
      return;
    }
    this._isHovered = !0, this._setTimeout(() => {
      this._isHovered && this.show();
    }, this._config.delay.show);
  }
  _leave() {
    this._isWithActiveTrigger() || (this._isHovered = !1, this._setTimeout(() => {
      this._isHovered || this.hide();
    }, this._config.delay.hide));
  }
  _setTimeout(t, e) {
    clearTimeout(this._timeout), this._timeout = setTimeout(t, e);
  }
  _isWithActiveTrigger() {
    return Object.values(this._activeTrigger).includes(!0);
  }
  _getConfig(t) {
    const e = fr.getDataAttributes(this._element);
    for (const a of Object.keys(e))
      SJ.has(a) && delete e[a];
    return t = {
      ...e,
      ...typeof t == "object" && t ? t : {}
    }, t = this._mergeConfigObj(t), t = this._configAfterMerge(t), this._typeCheckConfig(t), t;
  }
  _configAfterMerge(t) {
    return t.container = t.container === !1 ? document.body : il(t.container), typeof t.delay == "number" && (t.delay = {
      show: t.delay,
      hide: t.delay
    }), typeof t.title == "number" && (t.title = t.title.toString()), typeof t.content == "number" && (t.content = t.content.toString()), t;
  }
  _getDelegateConfig() {
    const t = {};
    for (const [e, a] of Object.entries(this._config))
      this.constructor.Default[e] !== a && (t[e] = a);
    return t.selector = !1, t.trigger = "manual", t;
  }
  _disposePopper() {
    this._popper && (this._popper.destroy(), this._popper = null), this.tip && (this.tip.remove(), this.tip = null);
  }
  // Static
  static jQueryInterface(t) {
    return this.each(function() {
      const e = uo.getOrCreateInstance(this, t);
      if (typeof t == "string") {
        if (typeof e[t] > "u")
          throw new TypeError(`No method named "${t}"`);
        e[t]();
      }
    });
  }
}
oi(uo);
const FJ = "popover", zJ = ".popover-header", BJ = ".popover-body", WJ = {
  ...uo.Default,
  content: "",
  offset: [0, 8],
  placement: "right",
  template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
  trigger: "click"
}, jJ = {
  ...uo.DefaultType,
  content: "(null|string|element|function)"
};
class $f extends uo {
  // Getters
  static get Default() {
    return WJ;
  }
  static get DefaultType() {
    return jJ;
  }
  static get NAME() {
    return FJ;
  }
  // Overrides
  _isWithContent() {
    return this._getTitle() || this._getContent();
  }
  // Private
  _getContentForTemplate() {
    return {
      [zJ]: this._getTitle(),
      [BJ]: this._getContent()
    };
  }
  _getContent() {
    return this._resolvePossibleFunction(this._config.content);
  }
  // Static
  static jQueryInterface(t) {
    return this.each(function() {
      const e = $f.getOrCreateInstance(this, t);
      if (typeof t == "string") {
        if (typeof e[t] > "u")
          throw new TypeError(`No method named "${t}"`);
        e[t]();
      }
    });
  }
}
oi($f);
const VJ = "scrollspy", qJ = "bs.scrollspy", FA = `.${qJ}`, KJ = ".data-api", JJ = `activate${FA}`, d0 = `click${FA}`, QJ = `load${FA}${KJ}`, ZJ = "dropdown-item", Uo = "active", tQ = '[data-bs-spy="scroll"]', hv = "[href]", eQ = ".nav, .list-group", u0 = ".nav-link", aQ = ".nav-item", nQ = ".list-group-item", sQ = `${u0}, ${aQ} > ${u0}, ${nQ}`, iQ = ".dropdown", rQ = ".dropdown-toggle", lQ = {
  offset: null,
  // TODO: v6 @deprecated, keep it for backwards compatibility reasons
  rootMargin: "0px 0px -25%",
  smoothScroll: !1,
  target: null,
  threshold: [0.1, 0.5, 1]
}, oQ = {
  offset: "(number|null)",
  // TODO v6 @deprecated, keep it for backwards compatibility reasons
  rootMargin: "string",
  smoothScroll: "boolean",
  target: "element",
  threshold: "array"
};
class Sf extends Ci {
  constructor(t, e) {
    super(t, e), this._targetLinks = /* @__PURE__ */ new Map(), this._observableSections = /* @__PURE__ */ new Map(), this._rootElement = getComputedStyle(this._element).overflowY === "visible" ? null : this._element, this._activeTarget = null, this._observer = null, this._previousScrollData = {
      visibleEntryTop: 0,
      parentScrollTop: 0
    }, this.refresh();
  }
  // Getters
  static get Default() {
    return lQ;
  }
  static get DefaultType() {
    return oQ;
  }
  static get NAME() {
    return VJ;
  }
  // Public
  refresh() {
    this._initializeTargetsAndObservables(), this._maybeEnableSmoothScroll(), this._observer ? this._observer.disconnect() : this._observer = this._getNewObserver();
    for (const t of this._observableSections.values())
      this._observer.observe(t);
  }
  dispose() {
    this._observer.disconnect(), super.dispose();
  }
  // Private
  _configAfterMerge(t) {
    return t.target = il(t.target) || document.body, t.rootMargin = t.offset ? `${t.offset}px 0px -30%` : t.rootMargin, typeof t.threshold == "string" && (t.threshold = t.threshold.split(",").map((e) => Number.parseFloat(e))), t;
  }
  _maybeEnableSmoothScroll() {
    this._config.smoothScroll && (Zt.off(this._config.target, d0), Zt.on(this._config.target, d0, hv, (t) => {
      const e = this._observableSections.get(t.target.hash);
      if (e) {
        t.preventDefault();
        const a = this._rootElement || window, n = e.offsetTop - this._element.offsetTop;
        if (a.scrollTo) {
          a.scrollTo({
            top: n,
            behavior: "smooth"
          });
          return;
        }
        a.scrollTop = n;
      }
    }));
  }
  _getNewObserver() {
    const t = {
      root: this._rootElement,
      threshold: this._config.threshold,
      rootMargin: this._config.rootMargin
    };
    return new IntersectionObserver((e) => this._observerCallback(e), t);
  }
  // The logic of selection
  _observerCallback(t) {
    const e = (r) => this._targetLinks.get(`#${r.target.id}`), a = (r) => {
      this._previousScrollData.visibleEntryTop = r.target.offsetTop, this._process(e(r));
    }, n = (this._rootElement || document.documentElement).scrollTop, i = n >= this._previousScrollData.parentScrollTop;
    this._previousScrollData.parentScrollTop = n;
    for (const r of t) {
      if (!r.isIntersecting) {
        this._activeTarget = null, this._clearActiveClass(e(r));
        continue;
      }
      const l = r.target.offsetTop >= this._previousScrollData.visibleEntryTop;
      if (i && l) {
        if (a(r), !n)
          return;
        continue;
      }
      !i && !l && a(r);
    }
  }
  _initializeTargetsAndObservables() {
    this._targetLinks = /* @__PURE__ */ new Map(), this._observableSections = /* @__PURE__ */ new Map();
    const t = Re.find(hv, this._config.target);
    for (const e of t) {
      if (!e.hash || rl(e))
        continue;
      const a = Re.findOne(decodeURI(e.hash), this._element);
      Bc(a) && (this._targetLinks.set(decodeURI(e.hash), e), this._observableSections.set(e.hash, a));
    }
  }
  _process(t) {
    this._activeTarget !== t && (this._clearActiveClass(this._config.target), this._activeTarget = t, t.classList.add(Uo), this._activateParents(t), Zt.trigger(this._element, JJ, {
      relatedTarget: t
    }));
  }
  _activateParents(t) {
    if (t.classList.contains(ZJ)) {
      Re.findOne(rQ, t.closest(iQ)).classList.add(Uo);
      return;
    }
    for (const e of Re.parents(t, eQ))
      for (const a of Re.prev(e, sQ))
        a.classList.add(Uo);
  }
  _clearActiveClass(t) {
    t.classList.remove(Uo);
    const e = Re.find(`${hv}.${Uo}`, t);
    for (const a of e)
      a.classList.remove(Uo);
  }
  // Static
  static jQueryInterface(t) {
    return this.each(function() {
      const e = Sf.getOrCreateInstance(this, t);
      if (typeof t == "string") {
        if (e[t] === void 0 || t.startsWith("_") || t === "constructor")
          throw new TypeError(`No method named "${t}"`);
        e[t]();
      }
    });
  }
}
Zt.on(window, QJ, () => {
  for (const s of Re.find(tQ))
    Sf.getOrCreateInstance(s);
});
oi(Sf);
const cQ = "tab", dQ = "bs.tab", po = `.${dQ}`, uQ = `hide${po}`, pQ = `hidden${po}`, hQ = `show${po}`, mQ = `shown${po}`, gQ = `click${po}`, yQ = `keydown${po}`, fQ = `load${po}`, bQ = "ArrowLeft", p0 = "ArrowRight", vQ = "ArrowUp", h0 = "ArrowDown", mv = "Home", m0 = "End", Ol = "active", g0 = "fade", gv = "show", xQ = "dropdown", HR = ".dropdown-toggle", wQ = ".dropdown-menu", yv = `:not(${HR})`, AQ = '.list-group, .nav, [role="tablist"]', CQ = ".nav-item, .list-group-item", $Q = `.nav-link${yv}, .list-group-item${yv}, [role="tab"]${yv}`, UR = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]', fv = `${$Q}, ${UR}`, SQ = `.${Ol}[data-bs-toggle="tab"], .${Ol}[data-bs-toggle="pill"], .${Ol}[data-bs-toggle="list"]`;
class _c extends Ci {
  constructor(t) {
    super(t), this._parent = this._element.closest(AQ), this._parent && (this._setInitialAttributes(this._parent, this._getChildren()), Zt.on(this._element, yQ, (e) => this._keydown(e)));
  }
  // Getters
  static get NAME() {
    return cQ;
  }
  // Public
  show() {
    const t = this._element;
    if (this._elemIsActive(t))
      return;
    const e = this._getActiveElem(), a = e ? Zt.trigger(e, uQ, {
      relatedTarget: t
    }) : null;
    Zt.trigger(t, hQ, {
      relatedTarget: e
    }).defaultPrevented || a && a.defaultPrevented || (this._deactivate(e, t), this._activate(t, e));
  }
  // Private
  _activate(t, e) {
    if (!t)
      return;
    t.classList.add(Ol), this._activate(Re.getElementFromSelector(t));
    const a = () => {
      if (t.getAttribute("role") !== "tab") {
        t.classList.add(gv);
        return;
      }
      t.removeAttribute("tabindex"), t.setAttribute("aria-selected", !0), this._toggleDropDown(t, !0), Zt.trigger(t, mQ, {
        relatedTarget: e
      });
    };
    this._queueCallback(a, t, t.classList.contains(g0));
  }
  _deactivate(t, e) {
    if (!t)
      return;
    t.classList.remove(Ol), t.blur(), this._deactivate(Re.getElementFromSelector(t));
    const a = () => {
      if (t.getAttribute("role") !== "tab") {
        t.classList.remove(gv);
        return;
      }
      t.setAttribute("aria-selected", !1), t.setAttribute("tabindex", "-1"), this._toggleDropDown(t, !1), Zt.trigger(t, pQ, {
        relatedTarget: e
      });
    };
    this._queueCallback(a, t, t.classList.contains(g0));
  }
  _keydown(t) {
    if (![bQ, p0, vQ, h0, mv, m0].includes(t.key))
      return;
    t.stopPropagation(), t.preventDefault();
    const e = this._getChildren().filter((n) => !rl(n));
    let a;
    if ([mv, m0].includes(t.key))
      a = e[t.key === mv ? 0 : e.length - 1];
    else {
      const n = [p0, h0].includes(t.key);
      a = GA(e, t.target, n, !0);
    }
    a && (a.focus({
      preventScroll: !0
    }), _c.getOrCreateInstance(a).show());
  }
  _getChildren() {
    return Re.find(fv, this._parent);
  }
  _getActiveElem() {
    return this._getChildren().find((t) => this._elemIsActive(t)) || null;
  }
  _setInitialAttributes(t, e) {
    this._setAttributeIfNotExists(t, "role", "tablist");
    for (const a of e)
      this._setInitialAttributesOnChild(a);
  }
  _setInitialAttributesOnChild(t) {
    t = this._getInnerElement(t);
    const e = this._elemIsActive(t), a = this._getOuterElement(t);
    t.setAttribute("aria-selected", e), a !== t && this._setAttributeIfNotExists(a, "role", "presentation"), e || t.setAttribute("tabindex", "-1"), this._setAttributeIfNotExists(t, "role", "tab"), this._setInitialAttributesOnTargetPanel(t);
  }
  _setInitialAttributesOnTargetPanel(t) {
    const e = Re.getElementFromSelector(t);
    e && (this._setAttributeIfNotExists(e, "role", "tabpanel"), t.id && this._setAttributeIfNotExists(e, "aria-labelledby", `${t.id}`));
  }
  _toggleDropDown(t, e) {
    const a = this._getOuterElement(t);
    if (!a.classList.contains(xQ))
      return;
    const n = (i, r) => {
      const l = Re.findOne(i, a);
      l && l.classList.toggle(r, e);
    };
    n(HR, Ol), n(wQ, gv), a.setAttribute("aria-expanded", e);
  }
  _setAttributeIfNotExists(t, e, a) {
    t.hasAttribute(e) || t.setAttribute(e, a);
  }
  _elemIsActive(t) {
    return t.classList.contains(Ol);
  }
  // Try to get the inner element (usually the .nav-link)
  _getInnerElement(t) {
    return t.matches(fv) ? t : Re.findOne(fv, t);
  }
  // Try to get the outer element (usually the .nav-item)
  _getOuterElement(t) {
    return t.closest(CQ) || t;
  }
  // Static
  static jQueryInterface(t) {
    return this.each(function() {
      const e = _c.getOrCreateInstance(this);
      if (typeof t == "string") {
        if (e[t] === void 0 || t.startsWith("_") || t === "constructor")
          throw new TypeError(`No method named "${t}"`);
        e[t]();
      }
    });
  }
}
Zt.on(document, gQ, UR, function(s) {
  ["A", "AREA"].includes(this.tagName) && s.preventDefault(), !rl(this) && _c.getOrCreateInstance(this).show();
});
Zt.on(window, fQ, () => {
  for (const s of Re.find(SQ))
    _c.getOrCreateInstance(s);
});
oi(_c);
const kQ = "toast", TQ = "bs.toast", pl = `.${TQ}`, LQ = `mouseover${pl}`, DQ = `mouseout${pl}`, IQ = `focusin${pl}`, PQ = `focusout${pl}`, EQ = `hide${pl}`, NQ = `hidden${pl}`, RQ = `show${pl}`, YQ = `shown${pl}`, _Q = "fade", y0 = "hide", Ih = "show", Ph = "showing", OQ = {
  animation: "boolean",
  autohide: "boolean",
  delay: "number"
}, MQ = {
  animation: !0,
  autohide: !0,
  delay: 5e3
};
class kf extends Ci {
  constructor(t, e) {
    super(t, e), this._timeout = null, this._hasMouseInteraction = !1, this._hasKeyboardInteraction = !1, this._setListeners();
  }
  // Getters
  static get Default() {
    return MQ;
  }
  static get DefaultType() {
    return OQ;
  }
  static get NAME() {
    return kQ;
  }
  // Public
  show() {
    if (Zt.trigger(this._element, RQ).defaultPrevented)
      return;
    this._clearTimeout(), this._config.animation && this._element.classList.add(_Q);
    const e = () => {
      this._element.classList.remove(Ph), Zt.trigger(this._element, YQ), this._maybeScheduleHide();
    };
    this._element.classList.remove(y0), rp(this._element), this._element.classList.add(Ih, Ph), this._queueCallback(e, this._element, this._config.animation);
  }
  hide() {
    if (!this.isShown() || Zt.trigger(this._element, EQ).defaultPrevented)
      return;
    const e = () => {
      this._element.classList.add(y0), this._element.classList.remove(Ph, Ih), Zt.trigger(this._element, NQ);
    };
    this._element.classList.add(Ph), this._queueCallback(e, this._element, this._config.animation);
  }
  dispose() {
    this._clearTimeout(), this.isShown() && this._element.classList.remove(Ih), super.dispose();
  }
  isShown() {
    return this._element.classList.contains(Ih);
  }
  // Private
  _maybeScheduleHide() {
    this._config.autohide && (this._hasMouseInteraction || this._hasKeyboardInteraction || (this._timeout = setTimeout(() => {
      this.hide();
    }, this._config.delay)));
  }
  _onInteraction(t, e) {
    switch (t.type) {
      case "mouseover":
      case "mouseout": {
        this._hasMouseInteraction = e;
        break;
      }
      case "focusin":
      case "focusout": {
        this._hasKeyboardInteraction = e;
        break;
      }
    }
    if (e) {
      this._clearTimeout();
      return;
    }
    const a = t.relatedTarget;
    this._element === a || this._element.contains(a) || this._maybeScheduleHide();
  }
  _setListeners() {
    Zt.on(this._element, LQ, (t) => this._onInteraction(t, !0)), Zt.on(this._element, DQ, (t) => this._onInteraction(t, !1)), Zt.on(this._element, IQ, (t) => this._onInteraction(t, !0)), Zt.on(this._element, PQ, (t) => this._onInteraction(t, !1));
  }
  _clearTimeout() {
    clearTimeout(this._timeout), this._timeout = null;
  }
  // Static
  static jQueryInterface(t) {
    return this.each(function() {
      const e = kf.getOrCreateInstance(this, t);
      if (typeof t == "string") {
        if (typeof e[t] > "u")
          throw new TypeError(`No method named "${t}"`);
        e[t](this);
      }
    });
  }
}
wf(kf);
oi(kf);
class zA {
  /**
   * Creates a new instance of the directive.
   */
  constructor() {
    this.restrict = "A";
  }
  /**
   * Factory for directive registration.
   * @ignore
   */
  static salaxyBs5Tooltip() {
    const t = () => new zA();
    return t.$inject = [], t;
  }
  /**
   * Attaches the appropriate Bootstrap scripts to the element.
   * @ignore
   */
  link(t, e, a) {
    new uo(e[0], {
      title: "<div>" + a.title + "</div>",
      html: !0
    });
  }
}
class BA {
  /**
   * Creates a new instance of the directive.
   */
  constructor() {
    this.restrict = "A";
  }
  /**
   * Factory for directive registration.
   * @ignore
   */
  static salaxyBs5Popover() {
    const t = () => new BA();
    return t.$inject = [], t;
  }
  /**
   * Attaches the appropriate Bootstrap scripts to the element.
   * @ignore
   */
  link(t, e, a) {
    const n = t.$eval(a.bsTitle), i = "<div>" + t.$eval(a.bsContent) + "</div>", r = t.$eval(a.bsPlacement) || "right";
    new $f(e[0], {
      title: n,
      content: i,
      placement: r,
      trigger: "focus"
    });
  }
}
class sc {
  /**
   * Boolean conversion.
   * @example
   * ```html
   * <select ng-model="model.value" sxy-enum-as-boolean>
   *  <option value="null">Null</option>
   *  <option value="true">True</option>
   *  <option value="false">False</option>
   * </select>
   * ```
   */
  static sxyEnumAsBoolean() {
    return () => sc.directive("sxyEnumAsBoolean", sc.booleanParser);
  }
  static directive(t, e, a = null) {
    return {
      restrict: "A",
      require: "ngModel",
      link: sc.getLink(t, e, a)
    };
  }
  static getLink(t, e, a) {
    return (n, i, r, l) => {
      l.$parsers.push(e), l.$formatters.push(a || sc.defaultFormatter);
    };
  }
  static booleanParser(t) {
    switch (t) {
      case "null":
        return null;
      case "false":
        return !1;
      case "true":
        return !0;
    }
    return t;
  }
  static defaultFormatter(t) {
    return "" + t;
  }
}
class Dy {
  /**
   * Creates a new instance of the directive.
   */
  constructor(t, e) {
    this.sessionService = t, this.ngIf = e[0], this.restrict = this.ngIf.restrict, this.transclude = this.ngIf.transclude, this.priority = this.ngIf.priority, this.terminal = this.ngIf.terminal;
  }
  /**
   * Factory method for the directive creation.
   * @ignore
   */
  static sxyIfRole() {
    const t = (e, a) => new Dy(e, a);
    return t.$inject = ["SessionService", "ngIfDirective"], t;
  }
  /**
   * Link function for the directive.
   * @ignore
   */
  link(t, e, a) {
    const n = a.sxyIfRole || a.salaxyIfRole;
    a.ngIf = () => this.sessionService.isInSomeRole(n), this.ngIf.link.apply(this.ngIf, arguments);
  }
}
class WA {
  /**
   * Creates a new instance of the directive.
   */
  constructor(t, e) {
    this.naviService = t, this.ngIf = e[0], this.restrict = this.ngIf.restrict, this.transclude = this.ngIf.transclude, this.priority = this.ngIf.priority, this.terminal = this.ngIf.terminal;
  }
  /**
   * Factory method for the directive creation.
   * @ignore
   */
  static sxyIfSitemap() {
    const t = (e, a) => new WA(e, a);
    return t.$inject = ["NaviService", "ngIfDirective"], t;
  }
  /**
   * Link function for the directive.
   * @ignore
   */
  link(t, e, a) {
    const n = a.sxyIfSitemap, i = a.prop;
    a.ngIf = () => {
      if (i && i != "visibility") {
        const r = this.naviService.current.node?.[i]?.toString();
        return r?.trim() && n?.trim() ? r.trim().toLowerCase() == n.trim().toLowerCase() : !1;
      } else
        return this.naviService.current.getVisibility(n);
    }, this.ngIf.link.apply(this.ngIf, arguments);
  }
}
class jA {
  /**
   * Creates a new instance of the directive.
   */
  constructor() {
    this.restrict = "A";
  }
  /**
   * Factory for the directive creation.
   * @ignore
   */
  static salaxyLoader() {
    const t = () => new jA();
    return t.$inject = [], t;
  }
  /**
   * Link function for the directive.
   * @ignore
   */
  link(t, e, a) {
    t.$on("salaxy-loader-show", () => {
      e.hasClass("salaxy-loading") || e.addClass("salaxy-loading");
    }), t.$on("salaxy-loader-hide", () => {
      e.hasClass("salaxy-loading") && e.removeClass("salaxy-loading");
    });
  }
}
class VA {
  /**
   * Creates a new instance of the directive.
   */
  constructor() {
    this.restrict = "A", this.replace = !0, this.transclude = !0, this.scope = !0, this.require = {
      $odata: "^^salaxyOdataTable"
    }, this.link = (t, e, a, n) => {
      t.$odata = n.$odata, t.orderby = a.sxyOrderby;
    };
  }
  /**
   * Factory for directive registration.
   * @ignore
   */
  static sxyOrderby() {
    const t = () => new VA();
    return t.$inject = [], t;
  }
  /**
   * Template is based on the original tag.
   */
  template(t, e) {
    const a = t[0].nodeName;
    return `<${a} ng-click="$odata.orderBy(orderby)" class="clickable">
            <ng-transclude></ng-transclude><i ng-if="$odata.getColumnOrder(orderby)" class="bi salaxy-odata-table-sort bi-sort-{{ $odata.getColumnOrder(orderby) == 'asc' ? 'up' : 'down' }}" aria-hidden="true"></i></${a}>`;
  }
}
class aa {
  /**
   * Tax percent validator.
   * @example
   * ```html
   * <input name="taxPercent" type="text" ng-model="taxPercent" sxy-tax-percent>
   * ```
   */
  static sxyTaxPercent() {
    return () => aa.directive("sxyTaxPercent", cn.isTaxPercent);
  }
  /**
   * Currency value validator.
   * @example
   * ```html
   * <input name="currency" type="text" ng-model="currency" sxy-currency>
   * ```
   */
  static sxyCurrency() {
    return () => aa.directive("sxyCurrency", cn.isCurrency);
  }
  /**
   * Iban validator.
   * @example
   * ```html
   * <input name="iban" type="text" ng-model="iban" sxy-iban>
   * ```
   */
  static sxyIban() {
    return () => aa.directive("sxyIban", cn.isIban);
  }
  /**
   * Email validator.
   * @example
   * ```html
   * <input name="email" type="text" ng-model="email" sxy-email>
   * ```
   */
  static sxyEmail() {
    return () => aa.directive("sxyEmail", cn.isEmail);
  }
  /**
   * Mobile phone validator.
   * @example
   * ```html
   * <input name="mobilePhone" type="text" ng-model="mobilePhone" sxy-mobile-phone>
   * ```
   */
  static sxyMobilePhone() {
    return () => aa.directive("sxyMobilePhone", cn.isMobilePhone);
  }
  /**
   * Finnish personal id validator.
   * @example
   * ```html
   * <input name="personalIdFi" type="text" ng-model="personalIdFi" sxy-personal-id-fi>
   * ```
   */
  static sxyPersonalIdFi() {
    return () => aa.directive("sxyPersonalIdFi", cn.isPersonalIdFi);
  }
  /**
   * Finnish company id validator.
   * @example
   * ```html
   * <input name="companyIdFi" type="text" ng-model="companyIdFi" sxy-company-id-fi>
   * ```
   */
  static sxyCompanyIdFi() {
    return () => aa.directive("sxyCompanyIdFi", cn.formatCompanyIdFi);
  }
  /**
   * Finnish official id validator. Official ID may be either company id orr personal id.
   * @example
   * ```html
   * <input name="officialIdFi" type="text" ng-model="officialIdFi" sxy-official-id-fi>
   * ```
   */
  static sxyOfficialIdFi() {
    return () => aa.directive("sxyOfficialIdFi", (t) => cn.formatCompanyIdFi(t, !0) || cn.isPersonalIdFi(t));
  }
  /**
   * Finnish postal code validator.
   * @example
   * ```html
   * <input name="postalCodeFi" type="text" ng-model="postalCodeFi" sxy-postal-code-fi>
   * ```
   */
  static sxyPostalCodeFi() {
    return () => aa.directive("sxyPostalCodeFi", cn.isPostalCodeFi);
  }
  /**
   * Number validator.
   * @example
   * ```html
   * <input name="number" type="text" ng-model="number" sxy-number>
   * ```
   */
  static sxyNumber() {
    return () => aa.directive("sxyNumber", cn.isNumber);
  }
  /**
   * Pension contract number validator.
   * @example
   * ```html
   * <input name="pensionContractNumber" type="text" ng-model="pensionContractNumber" sxy-pension-contract-number="'varma'">
   * ```
   */
  static sxyPensionContractNumber() {
    return () => aa.directive("sxyPensionContractNumber", (t, e) => {
      let a = !1;
      return e ? a = e == cn.isPensionContractNumber(t) : a = !!cn.isPensionContractNumber(t), setTimeout(() => {
      }), a;
    });
  }
  /**
   * Integer validator.
   * @example
   * ```html
   * <input name="intger" type="text" ng-model="integer" sxy-integer>
   * ```
   */
  static sxyInteger() {
    return () => aa.directive("sxyInteger", cn.isInteger);
  }
  /**
   * Maximum value validator
   * <input name="number" type="text" ng-model="number" sxy-min="$ctrl.maximum">
   */
  static sxyMin() {
    return () => aa.directive("sxyMin", (t, e) => !cn.isNumber(t) || !cn.isNumber(e) ? !0 : se.parseNumber(t) >= se.parseNumber(e));
  }
  /**
   * Maximum value validator
   * <input name="number" type="text" ng-model="number" sxy-max="$ctrl.maximum">
   */
  static sxyMax() {
    return () => aa.directive("sxyMax", (t, e) => !cn.isNumber(t) || !cn.isNumber(e) ? !0 : se.parseNumber(t) <= se.parseNumber(e));
  }
  /**
   * Multiple of value validator
   * <input name="number" type="text" ng-model="number" sxy-multiple-of="$ctrl.multipleOf">
   */
  static sxyMultipleOf() {
    return () => aa.directive("sxyMultipleOf", (t, e) => !cn.isNumber(t) || !cn.isNumber(e) ? !0 : se.parseNumber(e) <= 0 ? !1 : se.parseNumber(t) % se.parseNumber(e) === 0);
  }
  /**
   * Finnish bank reference number validator.
   * @example
   * ```html
   * <input name="bankRefNumber" type="text" ng-model="bankRefNumber" sxy-bank-reference-fi>
   * ```
   */
  static sxyBankReferenceFi() {
    return () => aa.directive("sxyBankReferenceFi", cn.isFinnishBankReferenceNumber);
  }
  /**
   * Validator for values which should not be considered as valid in the UI (i.e. unknown, none)
   */
  static sxyExcludeUnknowns() {
    return () => aa.directive("sxyExcludeUnknowns", (t, e) => !(ie.assureArray(e).indexOf(t) >= 0));
  }
  static directive(t, e) {
    return {
      restrict: "A",
      require: "ngModel",
      link: aa.setValidator(t, e)
    };
  }
  static parserAndFormatterDirective(t, e) {
    return {
      restrict: "A",
      require: "ngModel",
      link: aa.setParserAndFormatter(t, e)
    };
  }
  static setValidator(t, e) {
    return (a, n, i, r) => {
      r.$validators[t] = (l, o) => r.$isEmpty(l) ? !0 : e(o, a.$eval(i[t]));
    };
  }
  static setParserAndFormatter(t, e) {
    return (a, n, i, r) => {
      r.$parsers.unshift((l) => {
        let o = !0;
        for (let c = 0; c < t.length; c++) {
          const d = e[c](l);
          r.$setValidity(t[c], d), d || (o = !1);
        }
        return o ? l : void 0;
      });
    };
  }
}
class qA {
  /**
   * Creates a new instance of the directive.
   */
  constructor() {
    this.restrict = "A", this.require = "ngModel";
  }
  /**
   * Factory for directive registration.
   * @ignore
   */
  static salaxyDatepickerInputValidation() {
    const t = () => new qA();
    return t.$inject = [], t;
  }
  /**
   * Validates the datepicker manual input using the same rules
   * as the actual calendar selection control.
   * @ignore
   */
  link(t, e, a, n) {
    n.$validators.invalidDate = (i, r) => {
      if (!i)
        return !0;
      const l = t.$eval(a.datepickerOptions);
      if (!l)
        return !0;
      if (l.minDate || l.maxDate) {
        const o = I.asDate(i);
        if (l.minDate) {
          const c = I.asDate(l.minDate);
          if (o < c)
            return !1;
        }
        if (l.maxDate) {
          const c = I.asDate(l.maxDate);
          if (o > c)
            return !1;
        }
      }
      return !(l.dateDisabled && l.dateDisabled({ date: I.asJSDate(i) }));
    };
  }
}
function KA() {
  return {
    async: !1,
    breaks: !1,
    extensions: null,
    gfm: !0,
    hooks: null,
    pedantic: !1,
    renderer: null,
    silent: !1,
    tokenizer: null,
    walkTokens: null
  };
}
let ho = KA();
function FR(s) {
  ho = s;
}
const zR = /[&<>"']/, XQ = new RegExp(zR.source, "g"), BR = /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/, GQ = new RegExp(BR.source, "g"), HQ = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;"
}, f0 = (s) => HQ[s];
function Ns(s, t) {
  if (t) {
    if (zR.test(s))
      return s.replace(XQ, f0);
  } else if (BR.test(s))
    return s.replace(GQ, f0);
  return s;
}
const UQ = /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig;
function FQ(s) {
  return s.replace(UQ, (t, e) => (e = e.toLowerCase(), e === "colon" ? ":" : e.charAt(0) === "#" ? e.charAt(1) === "x" ? String.fromCharCode(parseInt(e.substring(2), 16)) : String.fromCharCode(+e.substring(1)) : ""));
}
const zQ = /(^|[^\[])\^/g;
function Pa(s, t) {
  let e = typeof s == "string" ? s : s.source;
  t = t || "";
  const a = {
    replace: (n, i) => {
      let r = typeof i == "string" ? i : i.source;
      return r = r.replace(zQ, "$1"), e = e.replace(n, r), a;
    },
    getRegex: () => new RegExp(e, t)
  };
  return a;
}
function b0(s) {
  try {
    s = encodeURI(s).replace(/%25/g, "%");
  } catch {
    return null;
  }
  return s;
}
const Qd = { exec: () => null };
function v0(s, t) {
  const e = s.replace(/\|/g, (i, r, l) => {
    let o = !1, c = r;
    for (; --c >= 0 && l[c] === "\\"; )
      o = !o;
    return o ? "|" : " |";
  }), a = e.split(/ \|/);
  let n = 0;
  if (a[0].trim() || a.shift(), a.length > 0 && !a[a.length - 1].trim() && a.pop(), t)
    if (a.length > t)
      a.splice(t);
    else
      for (; a.length < t; )
        a.push("");
  for (; n < a.length; n++)
    a[n] = a[n].trim().replace(/\\\|/g, "|");
  return a;
}
function Eh(s, t, e) {
  const a = s.length;
  if (a === 0)
    return "";
  let n = 0;
  for (; n < a; ) {
    const i = s.charAt(a - n - 1);
    if (i === t && !e)
      n++;
    else if (i !== t && e)
      n++;
    else
      break;
  }
  return s.slice(0, a - n);
}
function BQ(s, t) {
  if (s.indexOf(t[1]) === -1)
    return -1;
  let e = 0;
  for (let a = 0; a < s.length; a++)
    if (s[a] === "\\")
      a++;
    else if (s[a] === t[0])
      e++;
    else if (s[a] === t[1] && (e--, e < 0))
      return a;
  return -1;
}
function x0(s, t, e, a) {
  const n = t.href, i = t.title ? Ns(t.title) : null, r = s[1].replace(/\\([\[\]])/g, "$1");
  if (s[0].charAt(0) !== "!") {
    a.state.inLink = !0;
    const l = {
      type: "link",
      raw: e,
      href: n,
      title: i,
      text: r,
      tokens: a.inlineTokens(r)
    };
    return a.state.inLink = !1, l;
  }
  return {
    type: "image",
    raw: e,
    href: n,
    title: i,
    text: Ns(r)
  };
}
function WQ(s, t) {
  const e = s.match(/^(\s+)(?:```)/);
  if (e === null)
    return t;
  const a = e[1];
  return t.split(`
`).map((n) => {
    const i = n.match(/^\s+/);
    if (i === null)
      return n;
    const [r] = i;
    return r.length >= a.length ? n.slice(a.length) : n;
  }).join(`
`);
}
class Iy {
  // set by the lexer
  constructor(t) {
    Jt(this, "options");
    Jt(this, "rules");
    // set by the lexer
    Jt(this, "lexer");
    this.options = t || ho;
  }
  space(t) {
    const e = this.rules.block.newline.exec(t);
    if (e && e[0].length > 0)
      return {
        type: "space",
        raw: e[0]
      };
  }
  code(t) {
    const e = this.rules.block.code.exec(t);
    if (e) {
      const a = e[0].replace(/^ {1,4}/gm, "");
      return {
        type: "code",
        raw: e[0],
        codeBlockStyle: "indented",
        text: this.options.pedantic ? a : Eh(a, `
`)
      };
    }
  }
  fences(t) {
    const e = this.rules.block.fences.exec(t);
    if (e) {
      const a = e[0], n = WQ(a, e[3] || "");
      return {
        type: "code",
        raw: a,
        lang: e[2] ? e[2].trim().replace(this.rules.inline.anyPunctuation, "$1") : e[2],
        text: n
      };
    }
  }
  heading(t) {
    const e = this.rules.block.heading.exec(t);
    if (e) {
      let a = e[2].trim();
      if (/#$/.test(a)) {
        const n = Eh(a, "#");
        (this.options.pedantic || !n || / $/.test(n)) && (a = n.trim());
      }
      return {
        type: "heading",
        raw: e[0],
        depth: e[1].length,
        text: a,
        tokens: this.lexer.inline(a)
      };
    }
  }
  hr(t) {
    const e = this.rules.block.hr.exec(t);
    if (e)
      return {
        type: "hr",
        raw: e[0]
      };
  }
  blockquote(t) {
    const e = this.rules.block.blockquote.exec(t);
    if (e) {
      let a = e[0].replace(/\n {0,3}((?:=+|-+) *)(?=\n|$)/g, `
    $1`);
      a = Eh(a.replace(/^ *>[ \t]?/gm, ""), `
`);
      const n = this.lexer.state.top;
      this.lexer.state.top = !0;
      const i = this.lexer.blockTokens(a);
      return this.lexer.state.top = n, {
        type: "blockquote",
        raw: e[0],
        tokens: i,
        text: a
      };
    }
  }
  list(t) {
    let e = this.rules.block.list.exec(t);
    if (e) {
      let a = e[1].trim();
      const n = a.length > 1, i = {
        type: "list",
        raw: "",
        ordered: n,
        start: n ? +a.slice(0, -1) : "",
        loose: !1,
        items: []
      };
      a = n ? `\\d{1,9}\\${a.slice(-1)}` : `\\${a}`, this.options.pedantic && (a = n ? a : "[*+-]");
      const r = new RegExp(`^( {0,3}${a})((?:[	 ][^\\n]*)?(?:\\n|$))`);
      let l = "", o = "", c = !1;
      for (; t; ) {
        let d = !1;
        if (!(e = r.exec(t)) || this.rules.block.hr.test(t))
          break;
        l = e[0], t = t.substring(l.length);
        let p = e[2].split(`
`, 1)[0].replace(/^\t+/, (T) => " ".repeat(3 * T.length)), h = t.split(`
`, 1)[0], g = 0;
        this.options.pedantic ? (g = 2, o = p.trimStart()) : (g = e[2].search(/[^ ]/), g = g > 4 ? 1 : g, o = p.slice(g), g += e[1].length);
        let x = !1;
        if (!p && /^ *$/.test(h) && (l += h + `
`, t = t.substring(h.length + 1), d = !0), !d) {
          const T = new RegExp(`^ {0,${Math.min(3, g - 1)}}(?:[*+-]|\\d{1,9}[.)])((?:[ 	][^\\n]*)?(?:\\n|$))`), R = new RegExp(`^ {0,${Math.min(3, g - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`), C = new RegExp(`^ {0,${Math.min(3, g - 1)}}(?:\`\`\`|~~~)`), v = new RegExp(`^ {0,${Math.min(3, g - 1)}}#`);
          for (; t; ) {
            const P = t.split(`
`, 1)[0];
            if (h = P, this.options.pedantic && (h = h.replace(/^ {1,4}(?=( {4})*[^ ])/g, "  ")), C.test(h) || v.test(h) || T.test(h) || R.test(t))
              break;
            if (h.search(/[^ ]/) >= g || !h.trim())
              o += `
` + h.slice(g);
            else {
              if (x || p.search(/[^ ]/) >= 4 || C.test(p) || v.test(p) || R.test(p))
                break;
              o += `
` + h;
            }
            !x && !h.trim() && (x = !0), l += P + `
`, t = t.substring(P.length + 1), p = h.slice(g);
          }
        }
        i.loose || (c ? i.loose = !0 : /\n *\n *$/.test(l) && (c = !0));
        let b = null, A;
        this.options.gfm && (b = /^\[[ xX]\] /.exec(o), b && (A = b[0] !== "[ ] ", o = o.replace(/^\[[ xX]\] +/, ""))), i.items.push({
          type: "list_item",
          raw: l,
          task: !!b,
          checked: A,
          loose: !1,
          text: o,
          tokens: []
        }), i.raw += l;
      }
      i.items[i.items.length - 1].raw = l.trimEnd(), i.items[i.items.length - 1].text = o.trimEnd(), i.raw = i.raw.trimEnd();
      for (let d = 0; d < i.items.length; d++)
        if (this.lexer.state.top = !1, i.items[d].tokens = this.lexer.blockTokens(i.items[d].text, []), !i.loose) {
          const p = i.items[d].tokens.filter((g) => g.type === "space"), h = p.length > 0 && p.some((g) => /\n.*\n/.test(g.raw));
          i.loose = h;
        }
      if (i.loose)
        for (let d = 0; d < i.items.length; d++)
          i.items[d].loose = !0;
      return i;
    }
  }
  html(t) {
    const e = this.rules.block.html.exec(t);
    if (e)
      return {
        type: "html",
        block: !0,
        raw: e[0],
        pre: e[1] === "pre" || e[1] === "script" || e[1] === "style",
        text: e[0]
      };
  }
  def(t) {
    const e = this.rules.block.def.exec(t);
    if (e) {
      const a = e[1].toLowerCase().replace(/\s+/g, " "), n = e[2] ? e[2].replace(/^<(.*)>$/, "$1").replace(this.rules.inline.anyPunctuation, "$1") : "", i = e[3] ? e[3].substring(1, e[3].length - 1).replace(this.rules.inline.anyPunctuation, "$1") : e[3];
      return {
        type: "def",
        tag: a,
        raw: e[0],
        href: n,
        title: i
      };
    }
  }
  table(t) {
    const e = this.rules.block.table.exec(t);
    if (!e || !/[:|]/.test(e[2]))
      return;
    const a = v0(e[1]), n = e[2].replace(/^\||\| *$/g, "").split("|"), i = e[3] && e[3].trim() ? e[3].replace(/\n[ \t]*$/, "").split(`
`) : [], r = {
      type: "table",
      raw: e[0],
      header: [],
      align: [],
      rows: []
    };
    if (a.length === n.length) {
      for (const l of n)
        /^ *-+: *$/.test(l) ? r.align.push("right") : /^ *:-+: *$/.test(l) ? r.align.push("center") : /^ *:-+ *$/.test(l) ? r.align.push("left") : r.align.push(null);
      for (const l of a)
        r.header.push({
          text: l,
          tokens: this.lexer.inline(l)
        });
      for (const l of i)
        r.rows.push(v0(l, r.header.length).map((o) => ({
          text: o,
          tokens: this.lexer.inline(o)
        })));
      return r;
    }
  }
  lheading(t) {
    const e = this.rules.block.lheading.exec(t);
    if (e)
      return {
        type: "heading",
        raw: e[0],
        depth: e[2].charAt(0) === "=" ? 1 : 2,
        text: e[1],
        tokens: this.lexer.inline(e[1])
      };
  }
  paragraph(t) {
    const e = this.rules.block.paragraph.exec(t);
    if (e) {
      const a = e[1].charAt(e[1].length - 1) === `
` ? e[1].slice(0, -1) : e[1];
      return {
        type: "paragraph",
        raw: e[0],
        text: a,
        tokens: this.lexer.inline(a)
      };
    }
  }
  text(t) {
    const e = this.rules.block.text.exec(t);
    if (e)
      return {
        type: "text",
        raw: e[0],
        text: e[0],
        tokens: this.lexer.inline(e[0])
      };
  }
  escape(t) {
    const e = this.rules.inline.escape.exec(t);
    if (e)
      return {
        type: "escape",
        raw: e[0],
        text: Ns(e[1])
      };
  }
  tag(t) {
    const e = this.rules.inline.tag.exec(t);
    if (e)
      return !this.lexer.state.inLink && /^<a /i.test(e[0]) ? this.lexer.state.inLink = !0 : this.lexer.state.inLink && /^<\/a>/i.test(e[0]) && (this.lexer.state.inLink = !1), !this.lexer.state.inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(e[0]) ? this.lexer.state.inRawBlock = !0 : this.lexer.state.inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(e[0]) && (this.lexer.state.inRawBlock = !1), {
        type: "html",
        raw: e[0],
        inLink: this.lexer.state.inLink,
        inRawBlock: this.lexer.state.inRawBlock,
        block: !1,
        text: e[0]
      };
  }
  link(t) {
    const e = this.rules.inline.link.exec(t);
    if (e) {
      const a = e[2].trim();
      if (!this.options.pedantic && /^</.test(a)) {
        if (!/>$/.test(a))
          return;
        const r = Eh(a.slice(0, -1), "\\");
        if ((a.length - r.length) % 2 === 0)
          return;
      } else {
        const r = BQ(e[2], "()");
        if (r > -1) {
          const o = (e[0].indexOf("!") === 0 ? 5 : 4) + e[1].length + r;
          e[2] = e[2].substring(0, r), e[0] = e[0].substring(0, o).trim(), e[3] = "";
        }
      }
      let n = e[2], i = "";
      if (this.options.pedantic) {
        const r = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(n);
        r && (n = r[1], i = r[3]);
      } else
        i = e[3] ? e[3].slice(1, -1) : "";
      return n = n.trim(), /^</.test(n) && (this.options.pedantic && !/>$/.test(a) ? n = n.slice(1) : n = n.slice(1, -1)), x0(e, {
        href: n && n.replace(this.rules.inline.anyPunctuation, "$1"),
        title: i && i.replace(this.rules.inline.anyPunctuation, "$1")
      }, e[0], this.lexer);
    }
  }
  reflink(t, e) {
    let a;
    if ((a = this.rules.inline.reflink.exec(t)) || (a = this.rules.inline.nolink.exec(t))) {
      const n = (a[2] || a[1]).replace(/\s+/g, " "), i = e[n.toLowerCase()];
      if (!i) {
        const r = a[0].charAt(0);
        return {
          type: "text",
          raw: r,
          text: r
        };
      }
      return x0(a, i, a[0], this.lexer);
    }
  }
  emStrong(t, e, a = "") {
    let n = this.rules.inline.emStrongLDelim.exec(t);
    if (!n || n[3] && a.match(/[\p{L}\p{N}]/u))
      return;
    if (!(n[1] || n[2] || "") || !a || this.rules.inline.punctuation.exec(a)) {
      const r = [...n[0]].length - 1;
      let l, o, c = r, d = 0;
      const p = n[0][0] === "*" ? this.rules.inline.emStrongRDelimAst : this.rules.inline.emStrongRDelimUnd;
      for (p.lastIndex = 0, e = e.slice(-1 * t.length + r); (n = p.exec(e)) != null; ) {
        if (l = n[1] || n[2] || n[3] || n[4] || n[5] || n[6], !l)
          continue;
        if (o = [...l].length, n[3] || n[4]) {
          c += o;
          continue;
        } else if ((n[5] || n[6]) && r % 3 && !((r + o) % 3)) {
          d += o;
          continue;
        }
        if (c -= o, c > 0)
          continue;
        o = Math.min(o, o + c + d);
        const h = [...n[0]][0].length, g = t.slice(0, r + n.index + h + o);
        if (Math.min(r, o) % 2) {
          const b = g.slice(1, -1);
          return {
            type: "em",
            raw: g,
            text: b,
            tokens: this.lexer.inlineTokens(b)
          };
        }
        const x = g.slice(2, -2);
        return {
          type: "strong",
          raw: g,
          text: x,
          tokens: this.lexer.inlineTokens(x)
        };
      }
    }
  }
  codespan(t) {
    const e = this.rules.inline.code.exec(t);
    if (e) {
      let a = e[2].replace(/\n/g, " ");
      const n = /[^ ]/.test(a), i = /^ /.test(a) && / $/.test(a);
      return n && i && (a = a.substring(1, a.length - 1)), a = Ns(a, !0), {
        type: "codespan",
        raw: e[0],
        text: a
      };
    }
  }
  br(t) {
    const e = this.rules.inline.br.exec(t);
    if (e)
      return {
        type: "br",
        raw: e[0]
      };
  }
  del(t) {
    const e = this.rules.inline.del.exec(t);
    if (e)
      return {
        type: "del",
        raw: e[0],
        text: e[2],
        tokens: this.lexer.inlineTokens(e[2])
      };
  }
  autolink(t) {
    const e = this.rules.inline.autolink.exec(t);
    if (e) {
      let a, n;
      return e[2] === "@" ? (a = Ns(e[1]), n = "mailto:" + a) : (a = Ns(e[1]), n = a), {
        type: "link",
        raw: e[0],
        text: a,
        href: n,
        tokens: [
          {
            type: "text",
            raw: a,
            text: a
          }
        ]
      };
    }
  }
  url(t) {
    let e;
    if (e = this.rules.inline.url.exec(t)) {
      let a, n;
      if (e[2] === "@")
        a = Ns(e[0]), n = "mailto:" + a;
      else {
        let i;
        do
          i = e[0], e[0] = this.rules.inline._backpedal.exec(e[0])?.[0] ?? "";
        while (i !== e[0]);
        a = Ns(e[0]), e[1] === "www." ? n = "http://" + e[0] : n = e[0];
      }
      return {
        type: "link",
        raw: e[0],
        text: a,
        href: n,
        tokens: [
          {
            type: "text",
            raw: a,
            text: a
          }
        ]
      };
    }
  }
  inlineText(t) {
    const e = this.rules.inline.text.exec(t);
    if (e) {
      let a;
      return this.lexer.state.inRawBlock ? a = e[0] : a = Ns(e[0]), {
        type: "text",
        raw: e[0],
        text: a
      };
    }
  }
}
const jQ = /^(?: *(?:\n|$))+/, VQ = /^( {4}[^\n]+(?:\n(?: *(?:\n|$))*)?)+/, qQ = /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/, dp = /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/, KQ = /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/, WR = /(?:[*+-]|\d{1,9}[.)])/, jR = Pa(/^(?!bull |blockCode|fences|blockquote|heading|html)((?:.|\n(?!\s*?\n|bull |blockCode|fences|blockquote|heading|html))+?)\n {0,3}(=+|-+) *(?:\n+|$)/).replace(/bull/g, WR).replace(/blockCode/g, / {4}/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).getRegex(), JA = /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/, JQ = /^[^\n]+/, QA = /(?!\s*\])(?:\\.|[^\[\]\\])+/, QQ = Pa(/^ {0,3}\[(label)\]: *(?:\n *)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n *)?| *\n *)(title))? *(?:\n+|$)/).replace("label", QA).replace("title", /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/).getRegex(), ZQ = Pa(/^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/).replace(/bull/g, WR).getRegex(), Tf = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|search|section|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul", ZA = /<!--(?:-?>|[\s\S]*?(?:-->|$))/, tZ = Pa("^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n *)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$))", "i").replace("comment", ZA).replace("tag", Tf).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex(), VR = Pa(JA).replace("hr", dp).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", Tf).getRegex(), eZ = Pa(/^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/).replace("paragraph", VR).getRegex(), tC = {
  blockquote: eZ,
  code: VQ,
  def: QQ,
  fences: qQ,
  heading: KQ,
  hr: dp,
  html: tZ,
  lheading: jR,
  list: ZQ,
  newline: jQ,
  paragraph: VR,
  table: Qd,
  text: JQ
}, w0 = Pa("^ *([^\\n ].*)\\n {0,3}((?:\\| *)?:?-+:? *(?:\\| *:?-+:? *)*(?:\\| *)?)(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)").replace("hr", dp).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("blockquote", " {0,3}>").replace("code", " {4}[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", Tf).getRegex(), aZ = {
  ...tC,
  table: w0,
  paragraph: Pa(JA).replace("hr", dp).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("table", w0).replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", Tf).getRegex()
}, nZ = {
  ...tC,
  html: Pa(`^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:"[^"]*"|'[^']*'|\\s[^'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))`).replace("comment", ZA).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
  def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
  heading: /^(#{1,6})(.*)(?:\n+|$)/,
  fences: Qd,
  // fences not supported
  lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
  paragraph: Pa(JA).replace("hr", dp).replace("heading", ` *#{1,6} *[^
]`).replace("lheading", jR).replace("|table", "").replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").replace("|tag", "").getRegex()
}, qR = /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/, sZ = /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/, KR = /^( {2,}|\\)\n(?!\s*$)/, iZ = /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/, up = "\\p{P}\\p{S}", rZ = Pa(/^((?![*_])[\spunctuation])/, "u").replace(/punctuation/g, up).getRegex(), lZ = /\[[^[\]]*?\]\([^\(\)]*?\)|`[^`]*?`|<[^<>]*?>/g, oZ = Pa(/^(?:\*+(?:((?!\*)[punct])|[^\s*]))|^_+(?:((?!_)[punct])|([^\s_]))/, "u").replace(/punct/g, up).getRegex(), cZ = Pa("^[^_*]*?__[^_*]*?\\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\\*)[punct](\\*+)(?=[\\s]|$)|[^punct\\s](\\*+)(?!\\*)(?=[punct\\s]|$)|(?!\\*)[punct\\s](\\*+)(?=[^punct\\s])|[\\s](\\*+)(?!\\*)(?=[punct])|(?!\\*)[punct](\\*+)(?!\\*)(?=[punct])|[^punct\\s](\\*+)(?=[^punct\\s])", "gu").replace(/punct/g, up).getRegex(), dZ = Pa("^[^_*]*?\\*\\*[^_*]*?_[^_*]*?(?=\\*\\*)|[^_]+(?=[^_])|(?!_)[punct](_+)(?=[\\s]|$)|[^punct\\s](_+)(?!_)(?=[punct\\s]|$)|(?!_)[punct\\s](_+)(?=[^punct\\s])|[\\s](_+)(?!_)(?=[punct])|(?!_)[punct](_+)(?!_)(?=[punct])", "gu").replace(/punct/g, up).getRegex(), uZ = Pa(/\\([punct])/, "gu").replace(/punct/g, up).getRegex(), pZ = Pa(/^<(scheme:[^\s\x00-\x1f<>]*|email)>/).replace("scheme", /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/).replace("email", /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/).getRegex(), hZ = Pa(ZA).replace("(?:-->|$)", "-->").getRegex(), mZ = Pa("^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>").replace("comment", hZ).replace("attribute", /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/).getRegex(), Py = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/, gZ = Pa(/^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/).replace("label", Py).replace("href", /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/).replace("title", /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/).getRegex(), JR = Pa(/^!?\[(label)\]\[(ref)\]/).replace("label", Py).replace("ref", QA).getRegex(), QR = Pa(/^!?\[(ref)\](?:\[\])?/).replace("ref", QA).getRegex(), yZ = Pa("reflink|nolink(?!\\()", "g").replace("reflink", JR).replace("nolink", QR).getRegex(), eC = {
  _backpedal: Qd,
  // only used for GFM url
  anyPunctuation: uZ,
  autolink: pZ,
  blockSkip: lZ,
  br: KR,
  code: sZ,
  del: Qd,
  emStrongLDelim: oZ,
  emStrongRDelimAst: cZ,
  emStrongRDelimUnd: dZ,
  escape: qR,
  link: gZ,
  nolink: QR,
  punctuation: rZ,
  reflink: JR,
  reflinkSearch: yZ,
  tag: mZ,
  text: iZ,
  url: Qd
}, fZ = {
  ...eC,
  link: Pa(/^!?\[(label)\]\((.*?)\)/).replace("label", Py).getRegex(),
  reflink: Pa(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", Py).getRegex()
}, vw = {
  ...eC,
  escape: Pa(qR).replace("])", "~|])").getRegex(),
  url: Pa(/^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/, "i").replace("email", /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/).getRegex(),
  _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
  del: /^(~~?)(?=[^\s~])([\s\S]*?[^\s~])\1(?=[^~]|$)/,
  text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
}, bZ = {
  ...vw,
  br: Pa(KR).replace("{2,}", "*").getRegex(),
  text: Pa(vw.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
}, Nh = {
  normal: tC,
  gfm: aZ,
  pedantic: nZ
}, Sd = {
  normal: eC,
  gfm: vw,
  breaks: bZ,
  pedantic: fZ
};
class Oi {
  constructor(t) {
    Jt(this, "tokens");
    Jt(this, "options");
    Jt(this, "state");
    Jt(this, "tokenizer");
    Jt(this, "inlineQueue");
    this.tokens = [], this.tokens.links = /* @__PURE__ */ Object.create(null), this.options = t || ho, this.options.tokenizer = this.options.tokenizer || new Iy(), this.tokenizer = this.options.tokenizer, this.tokenizer.options = this.options, this.tokenizer.lexer = this, this.inlineQueue = [], this.state = {
      inLink: !1,
      inRawBlock: !1,
      top: !0
    };
    const e = {
      block: Nh.normal,
      inline: Sd.normal
    };
    this.options.pedantic ? (e.block = Nh.pedantic, e.inline = Sd.pedantic) : this.options.gfm && (e.block = Nh.gfm, this.options.breaks ? e.inline = Sd.breaks : e.inline = Sd.gfm), this.tokenizer.rules = e;
  }
  /**
   * Expose Rules
   */
  static get rules() {
    return {
      block: Nh,
      inline: Sd
    };
  }
  /**
   * Static Lex Method
   */
  static lex(t, e) {
    return new Oi(e).lex(t);
  }
  /**
   * Static Lex Inline Method
   */
  static lexInline(t, e) {
    return new Oi(e).inlineTokens(t);
  }
  /**
   * Preprocessing
   */
  lex(t) {
    t = t.replace(/\r\n|\r/g, `
`), this.blockTokens(t, this.tokens);
    for (let e = 0; e < this.inlineQueue.length; e++) {
      const a = this.inlineQueue[e];
      this.inlineTokens(a.src, a.tokens);
    }
    return this.inlineQueue = [], this.tokens;
  }
  blockTokens(t, e = []) {
    this.options.pedantic ? t = t.replace(/\t/g, "    ").replace(/^ +$/gm, "") : t = t.replace(/^( *)(\t+)/gm, (l, o, c) => o + "    ".repeat(c.length));
    let a, n, i, r;
    for (; t; )
      if (!(this.options.extensions && this.options.extensions.block && this.options.extensions.block.some((l) => (a = l.call({ lexer: this }, t, e)) ? (t = t.substring(a.raw.length), e.push(a), !0) : !1))) {
        if (a = this.tokenizer.space(t)) {
          t = t.substring(a.raw.length), a.raw.length === 1 && e.length > 0 ? e[e.length - 1].raw += `
` : e.push(a);
          continue;
        }
        if (a = this.tokenizer.code(t)) {
          t = t.substring(a.raw.length), n = e[e.length - 1], n && (n.type === "paragraph" || n.type === "text") ? (n.raw += `
` + a.raw, n.text += `
` + a.text, this.inlineQueue[this.inlineQueue.length - 1].src = n.text) : e.push(a);
          continue;
        }
        if (a = this.tokenizer.fences(t)) {
          t = t.substring(a.raw.length), e.push(a);
          continue;
        }
        if (a = this.tokenizer.heading(t)) {
          t = t.substring(a.raw.length), e.push(a);
          continue;
        }
        if (a = this.tokenizer.hr(t)) {
          t = t.substring(a.raw.length), e.push(a);
          continue;
        }
        if (a = this.tokenizer.blockquote(t)) {
          t = t.substring(a.raw.length), e.push(a);
          continue;
        }
        if (a = this.tokenizer.list(t)) {
          t = t.substring(a.raw.length), e.push(a);
          continue;
        }
        if (a = this.tokenizer.html(t)) {
          t = t.substring(a.raw.length), e.push(a);
          continue;
        }
        if (a = this.tokenizer.def(t)) {
          t = t.substring(a.raw.length), n = e[e.length - 1], n && (n.type === "paragraph" || n.type === "text") ? (n.raw += `
` + a.raw, n.text += `
` + a.raw, this.inlineQueue[this.inlineQueue.length - 1].src = n.text) : this.tokens.links[a.tag] || (this.tokens.links[a.tag] = {
            href: a.href,
            title: a.title
          });
          continue;
        }
        if (a = this.tokenizer.table(t)) {
          t = t.substring(a.raw.length), e.push(a);
          continue;
        }
        if (a = this.tokenizer.lheading(t)) {
          t = t.substring(a.raw.length), e.push(a);
          continue;
        }
        if (i = t, this.options.extensions && this.options.extensions.startBlock) {
          let l = 1 / 0;
          const o = t.slice(1);
          let c;
          this.options.extensions.startBlock.forEach((d) => {
            c = d.call({ lexer: this }, o), typeof c == "number" && c >= 0 && (l = Math.min(l, c));
          }), l < 1 / 0 && l >= 0 && (i = t.substring(0, l + 1));
        }
        if (this.state.top && (a = this.tokenizer.paragraph(i))) {
          n = e[e.length - 1], r && n.type === "paragraph" ? (n.raw += `
` + a.raw, n.text += `
` + a.text, this.inlineQueue.pop(), this.inlineQueue[this.inlineQueue.length - 1].src = n.text) : e.push(a), r = i.length !== t.length, t = t.substring(a.raw.length);
          continue;
        }
        if (a = this.tokenizer.text(t)) {
          t = t.substring(a.raw.length), n = e[e.length - 1], n && n.type === "text" ? (n.raw += `
` + a.raw, n.text += `
` + a.text, this.inlineQueue.pop(), this.inlineQueue[this.inlineQueue.length - 1].src = n.text) : e.push(a);
          continue;
        }
        if (t) {
          const l = "Infinite loop on byte: " + t.charCodeAt(0);
          if (this.options.silent) {
            console.error(l);
            break;
          } else
            throw new Error(l);
        }
      }
    return this.state.top = !0, e;
  }
  inline(t, e = []) {
    return this.inlineQueue.push({ src: t, tokens: e }), e;
  }
  /**
   * Lexing/Compiling
   */
  inlineTokens(t, e = []) {
    let a, n, i, r = t, l, o, c;
    if (this.tokens.links) {
      const d = Object.keys(this.tokens.links);
      if (d.length > 0)
        for (; (l = this.tokenizer.rules.inline.reflinkSearch.exec(r)) != null; )
          d.includes(l[0].slice(l[0].lastIndexOf("[") + 1, -1)) && (r = r.slice(0, l.index) + "[" + "a".repeat(l[0].length - 2) + "]" + r.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex));
    }
    for (; (l = this.tokenizer.rules.inline.blockSkip.exec(r)) != null; )
      r = r.slice(0, l.index) + "[" + "a".repeat(l[0].length - 2) + "]" + r.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
    for (; (l = this.tokenizer.rules.inline.anyPunctuation.exec(r)) != null; )
      r = r.slice(0, l.index) + "++" + r.slice(this.tokenizer.rules.inline.anyPunctuation.lastIndex);
    for (; t; )
      if (o || (c = ""), o = !1, !(this.options.extensions && this.options.extensions.inline && this.options.extensions.inline.some((d) => (a = d.call({ lexer: this }, t, e)) ? (t = t.substring(a.raw.length), e.push(a), !0) : !1))) {
        if (a = this.tokenizer.escape(t)) {
          t = t.substring(a.raw.length), e.push(a);
          continue;
        }
        if (a = this.tokenizer.tag(t)) {
          t = t.substring(a.raw.length), n = e[e.length - 1], n && a.type === "text" && n.type === "text" ? (n.raw += a.raw, n.text += a.text) : e.push(a);
          continue;
        }
        if (a = this.tokenizer.link(t)) {
          t = t.substring(a.raw.length), e.push(a);
          continue;
        }
        if (a = this.tokenizer.reflink(t, this.tokens.links)) {
          t = t.substring(a.raw.length), n = e[e.length - 1], n && a.type === "text" && n.type === "text" ? (n.raw += a.raw, n.text += a.text) : e.push(a);
          continue;
        }
        if (a = this.tokenizer.emStrong(t, r, c)) {
          t = t.substring(a.raw.length), e.push(a);
          continue;
        }
        if (a = this.tokenizer.codespan(t)) {
          t = t.substring(a.raw.length), e.push(a);
          continue;
        }
        if (a = this.tokenizer.br(t)) {
          t = t.substring(a.raw.length), e.push(a);
          continue;
        }
        if (a = this.tokenizer.del(t)) {
          t = t.substring(a.raw.length), e.push(a);
          continue;
        }
        if (a = this.tokenizer.autolink(t)) {
          t = t.substring(a.raw.length), e.push(a);
          continue;
        }
        if (!this.state.inLink && (a = this.tokenizer.url(t))) {
          t = t.substring(a.raw.length), e.push(a);
          continue;
        }
        if (i = t, this.options.extensions && this.options.extensions.startInline) {
          let d = 1 / 0;
          const p = t.slice(1);
          let h;
          this.options.extensions.startInline.forEach((g) => {
            h = g.call({ lexer: this }, p), typeof h == "number" && h >= 0 && (d = Math.min(d, h));
          }), d < 1 / 0 && d >= 0 && (i = t.substring(0, d + 1));
        }
        if (a = this.tokenizer.inlineText(i)) {
          t = t.substring(a.raw.length), a.raw.slice(-1) !== "_" && (c = a.raw.slice(-1)), o = !0, n = e[e.length - 1], n && n.type === "text" ? (n.raw += a.raw, n.text += a.text) : e.push(a);
          continue;
        }
        if (t) {
          const d = "Infinite loop on byte: " + t.charCodeAt(0);
          if (this.options.silent) {
            console.error(d);
            break;
          } else
            throw new Error(d);
        }
      }
    return e;
  }
}
class Ey {
  constructor(t) {
    Jt(this, "options");
    this.options = t || ho;
  }
  code(t, e, a) {
    const n = (e || "").match(/^\S*/)?.[0];
    return t = t.replace(/\n$/, "") + `
`, n ? '<pre><code class="language-' + Ns(n) + '">' + (a ? t : Ns(t, !0)) + `</code></pre>
` : "<pre><code>" + (a ? t : Ns(t, !0)) + `</code></pre>
`;
  }
  blockquote(t) {
    return `<blockquote>
${t}</blockquote>
`;
  }
  html(t, e) {
    return t;
  }
  heading(t, e, a) {
    return `<h${e}>${t}</h${e}>
`;
  }
  hr() {
    return `<hr>
`;
  }
  list(t, e, a) {
    const n = e ? "ol" : "ul", i = e && a !== 1 ? ' start="' + a + '"' : "";
    return "<" + n + i + `>
` + t + "</" + n + `>
`;
  }
  listitem(t, e, a) {
    return `<li>${t}</li>
`;
  }
  checkbox(t) {
    return "<input " + (t ? 'checked="" ' : "") + 'disabled="" type="checkbox">';
  }
  paragraph(t) {
    return `<p>${t}</p>
`;
  }
  table(t, e) {
    return e && (e = `<tbody>${e}</tbody>`), `<table>
<thead>
` + t + `</thead>
` + e + `</table>
`;
  }
  tablerow(t) {
    return `<tr>
${t}</tr>
`;
  }
  tablecell(t, e) {
    const a = e.header ? "th" : "td";
    return (e.align ? `<${a} align="${e.align}">` : `<${a}>`) + t + `</${a}>
`;
  }
  /**
   * span level renderer
   */
  strong(t) {
    return `<strong>${t}</strong>`;
  }
  em(t) {
    return `<em>${t}</em>`;
  }
  codespan(t) {
    return `<code>${t}</code>`;
  }
  br() {
    return "<br>";
  }
  del(t) {
    return `<del>${t}</del>`;
  }
  link(t, e, a) {
    const n = b0(t);
    if (n === null)
      return a;
    t = n;
    let i = '<a href="' + t + '"';
    return e && (i += ' title="' + e + '"'), i += ">" + a + "</a>", i;
  }
  image(t, e, a) {
    const n = b0(t);
    if (n === null)
      return a;
    t = n;
    let i = `<img src="${t}" alt="${a}"`;
    return e && (i += ` title="${e}"`), i += ">", i;
  }
  text(t) {
    return t;
  }
}
class aC {
  // no need for block level renderers
  strong(t) {
    return t;
  }
  em(t) {
    return t;
  }
  codespan(t) {
    return t;
  }
  del(t) {
    return t;
  }
  html(t) {
    return t;
  }
  text(t) {
    return t;
  }
  link(t, e, a) {
    return "" + a;
  }
  image(t, e, a) {
    return "" + a;
  }
  br() {
    return "";
  }
}
class Mi {
  constructor(t) {
    Jt(this, "options");
    Jt(this, "renderer");
    Jt(this, "textRenderer");
    this.options = t || ho, this.options.renderer = this.options.renderer || new Ey(), this.renderer = this.options.renderer, this.renderer.options = this.options, this.textRenderer = new aC();
  }
  /**
   * Static Parse Method
   */
  static parse(t, e) {
    return new Mi(e).parse(t);
  }
  /**
   * Static Parse Inline Method
   */
  static parseInline(t, e) {
    return new Mi(e).parseInline(t);
  }
  /**
   * Parse Loop
   */
  parse(t, e = !0) {
    let a = "";
    for (let n = 0; n < t.length; n++) {
      const i = t[n];
      if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[i.type]) {
        const r = i, l = this.options.extensions.renderers[r.type].call({ parser: this }, r);
        if (l !== !1 || !["space", "hr", "heading", "code", "table", "blockquote", "list", "html", "paragraph", "text"].includes(r.type)) {
          a += l || "";
          continue;
        }
      }
      switch (i.type) {
        case "space":
          continue;
        case "hr": {
          a += this.renderer.hr();
          continue;
        }
        case "heading": {
          const r = i;
          a += this.renderer.heading(this.parseInline(r.tokens), r.depth, FQ(this.parseInline(r.tokens, this.textRenderer)));
          continue;
        }
        case "code": {
          const r = i;
          a += this.renderer.code(r.text, r.lang, !!r.escaped);
          continue;
        }
        case "table": {
          const r = i;
          let l = "", o = "";
          for (let d = 0; d < r.header.length; d++)
            o += this.renderer.tablecell(this.parseInline(r.header[d].tokens), { header: !0, align: r.align[d] });
          l += this.renderer.tablerow(o);
          let c = "";
          for (let d = 0; d < r.rows.length; d++) {
            const p = r.rows[d];
            o = "";
            for (let h = 0; h < p.length; h++)
              o += this.renderer.tablecell(this.parseInline(p[h].tokens), { header: !1, align: r.align[h] });
            c += this.renderer.tablerow(o);
          }
          a += this.renderer.table(l, c);
          continue;
        }
        case "blockquote": {
          const r = i, l = this.parse(r.tokens);
          a += this.renderer.blockquote(l);
          continue;
        }
        case "list": {
          const r = i, l = r.ordered, o = r.start, c = r.loose;
          let d = "";
          for (let p = 0; p < r.items.length; p++) {
            const h = r.items[p], g = h.checked, x = h.task;
            let b = "";
            if (h.task) {
              const A = this.renderer.checkbox(!!g);
              c ? h.tokens.length > 0 && h.tokens[0].type === "paragraph" ? (h.tokens[0].text = A + " " + h.tokens[0].text, h.tokens[0].tokens && h.tokens[0].tokens.length > 0 && h.tokens[0].tokens[0].type === "text" && (h.tokens[0].tokens[0].text = A + " " + h.tokens[0].tokens[0].text)) : h.tokens.unshift({
                type: "text",
                text: A + " "
              }) : b += A + " ";
            }
            b += this.parse(h.tokens, c), d += this.renderer.listitem(b, x, !!g);
          }
          a += this.renderer.list(d, l, o);
          continue;
        }
        case "html": {
          const r = i;
          a += this.renderer.html(r.text, r.block);
          continue;
        }
        case "paragraph": {
          const r = i;
          a += this.renderer.paragraph(this.parseInline(r.tokens));
          continue;
        }
        case "text": {
          let r = i, l = r.tokens ? this.parseInline(r.tokens) : r.text;
          for (; n + 1 < t.length && t[n + 1].type === "text"; )
            r = t[++n], l += `
` + (r.tokens ? this.parseInline(r.tokens) : r.text);
          a += e ? this.renderer.paragraph(l) : l;
          continue;
        }
        default: {
          const r = 'Token with "' + i.type + '" type was not found.';
          if (this.options.silent)
            return console.error(r), "";
          throw new Error(r);
        }
      }
    }
    return a;
  }
  /**
   * Parse Inline Tokens
   */
  parseInline(t, e) {
    e = e || this.renderer;
    let a = "";
    for (let n = 0; n < t.length; n++) {
      const i = t[n];
      if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[i.type]) {
        const r = this.options.extensions.renderers[i.type].call({ parser: this }, i);
        if (r !== !1 || !["escape", "html", "link", "image", "strong", "em", "codespan", "br", "del", "text"].includes(i.type)) {
          a += r || "";
          continue;
        }
      }
      switch (i.type) {
        case "escape": {
          const r = i;
          a += e.text(r.text);
          break;
        }
        case "html": {
          const r = i;
          a += e.html(r.text);
          break;
        }
        case "link": {
          const r = i;
          a += e.link(r.href, r.title, this.parseInline(r.tokens, e));
          break;
        }
        case "image": {
          const r = i;
          a += e.image(r.href, r.title, r.text);
          break;
        }
        case "strong": {
          const r = i;
          a += e.strong(this.parseInline(r.tokens, e));
          break;
        }
        case "em": {
          const r = i;
          a += e.em(this.parseInline(r.tokens, e));
          break;
        }
        case "codespan": {
          const r = i;
          a += e.codespan(r.text);
          break;
        }
        case "br": {
          a += e.br();
          break;
        }
        case "del": {
          const r = i;
          a += e.del(this.parseInline(r.tokens, e));
          break;
        }
        case "text": {
          const r = i;
          a += e.text(r.text);
          break;
        }
        default: {
          const r = 'Token with "' + i.type + '" type was not found.';
          if (this.options.silent)
            return console.error(r), "";
          throw new Error(r);
        }
      }
    }
    return a;
  }
}
class Zd {
  constructor(t) {
    Jt(this, "options");
    this.options = t || ho;
  }
  /**
   * Process markdown before marked
   */
  preprocess(t) {
    return t;
  }
  /**
   * Process HTML after marked is finished
   */
  postprocess(t) {
    return t;
  }
  /**
   * Process all tokens before walk tokens
   */
  processAllTokens(t) {
    return t;
  }
}
Jt(Zd, "passThroughHooks", /* @__PURE__ */ new Set([
  "preprocess",
  "postprocess",
  "processAllTokens"
]));
var Yu, xw, jy, ZR;
class vZ {
  constructor(...t) {
    wb(this, Yu);
    wb(this, jy);
    Jt(this, "defaults", KA());
    Jt(this, "options", this.setOptions);
    Jt(this, "parse", Vp(this, Yu, xw).call(this, Oi.lex, Mi.parse));
    Jt(this, "parseInline", Vp(this, Yu, xw).call(this, Oi.lexInline, Mi.parseInline));
    Jt(this, "Parser", Mi);
    Jt(this, "Renderer", Ey);
    Jt(this, "TextRenderer", aC);
    Jt(this, "Lexer", Oi);
    Jt(this, "Tokenizer", Iy);
    Jt(this, "Hooks", Zd);
    this.use(...t);
  }
  /**
   * Run callback for every token
   */
  walkTokens(t, e) {
    let a = [];
    for (const n of t)
      switch (a = a.concat(e.call(this, n)), n.type) {
        case "table": {
          const i = n;
          for (const r of i.header)
            a = a.concat(this.walkTokens(r.tokens, e));
          for (const r of i.rows)
            for (const l of r)
              a = a.concat(this.walkTokens(l.tokens, e));
          break;
        }
        case "list": {
          const i = n;
          a = a.concat(this.walkTokens(i.items, e));
          break;
        }
        default: {
          const i = n;
          this.defaults.extensions?.childTokens?.[i.type] ? this.defaults.extensions.childTokens[i.type].forEach((r) => {
            const l = i[r].flat(1 / 0);
            a = a.concat(this.walkTokens(l, e));
          }) : i.tokens && (a = a.concat(this.walkTokens(i.tokens, e)));
        }
      }
    return a;
  }
  use(...t) {
    const e = this.defaults.extensions || { renderers: {}, childTokens: {} };
    return t.forEach((a) => {
      const n = { ...a };
      if (n.async = this.defaults.async || n.async || !1, a.extensions && (a.extensions.forEach((i) => {
        if (!i.name)
          throw new Error("extension name required");
        if ("renderer" in i) {
          const r = e.renderers[i.name];
          r ? e.renderers[i.name] = function(...l) {
            let o = i.renderer.apply(this, l);
            return o === !1 && (o = r.apply(this, l)), o;
          } : e.renderers[i.name] = i.renderer;
        }
        if ("tokenizer" in i) {
          if (!i.level || i.level !== "block" && i.level !== "inline")
            throw new Error("extension level must be 'block' or 'inline'");
          const r = e[i.level];
          r ? r.unshift(i.tokenizer) : e[i.level] = [i.tokenizer], i.start && (i.level === "block" ? e.startBlock ? e.startBlock.push(i.start) : e.startBlock = [i.start] : i.level === "inline" && (e.startInline ? e.startInline.push(i.start) : e.startInline = [i.start]));
        }
        "childTokens" in i && i.childTokens && (e.childTokens[i.name] = i.childTokens);
      }), n.extensions = e), a.renderer) {
        const i = this.defaults.renderer || new Ey(this.defaults);
        for (const r in a.renderer) {
          if (!(r in i))
            throw new Error(`renderer '${r}' does not exist`);
          if (r === "options")
            continue;
          const l = r, o = a.renderer[l], c = i[l];
          i[l] = (...d) => {
            let p = o.apply(i, d);
            return p === !1 && (p = c.apply(i, d)), p || "";
          };
        }
        n.renderer = i;
      }
      if (a.tokenizer) {
        const i = this.defaults.tokenizer || new Iy(this.defaults);
        for (const r in a.tokenizer) {
          if (!(r in i))
            throw new Error(`tokenizer '${r}' does not exist`);
          if (["options", "rules", "lexer"].includes(r))
            continue;
          const l = r, o = a.tokenizer[l], c = i[l];
          i[l] = (...d) => {
            let p = o.apply(i, d);
            return p === !1 && (p = c.apply(i, d)), p;
          };
        }
        n.tokenizer = i;
      }
      if (a.hooks) {
        const i = this.defaults.hooks || new Zd();
        for (const r in a.hooks) {
          if (!(r in i))
            throw new Error(`hook '${r}' does not exist`);
          if (r === "options")
            continue;
          const l = r, o = a.hooks[l], c = i[l];
          Zd.passThroughHooks.has(r) ? i[l] = (d) => {
            if (this.defaults.async)
              return Promise.resolve(o.call(i, d)).then((h) => c.call(i, h));
            const p = o.call(i, d);
            return c.call(i, p);
          } : i[l] = (...d) => {
            let p = o.apply(i, d);
            return p === !1 && (p = c.apply(i, d)), p;
          };
        }
        n.hooks = i;
      }
      if (a.walkTokens) {
        const i = this.defaults.walkTokens, r = a.walkTokens;
        n.walkTokens = function(l) {
          let o = [];
          return o.push(r.call(this, l)), i && (o = o.concat(i.call(this, l))), o;
        };
      }
      this.defaults = { ...this.defaults, ...n };
    }), this;
  }
  setOptions(t) {
    return this.defaults = { ...this.defaults, ...t }, this;
  }
  lexer(t, e) {
    return Oi.lex(t, e ?? this.defaults);
  }
  parser(t, e) {
    return Mi.parse(t, e ?? this.defaults);
  }
}
Yu = new WeakSet(), xw = function(t, e) {
  return (a, n) => {
    const i = { ...n }, r = { ...this.defaults, ...i };
    this.defaults.async === !0 && i.async === !1 && (r.silent || console.warn("marked(): The async option was set to true by an extension. The async: false option sent to parse will be ignored."), r.async = !0);
    const l = Vp(this, jy, ZR).call(this, !!r.silent, !!r.async);
    if (typeof a > "u" || a === null)
      return l(new Error("marked(): input parameter is undefined or null"));
    if (typeof a != "string")
      return l(new Error("marked(): input parameter is of type " + Object.prototype.toString.call(a) + ", string expected"));
    if (r.hooks && (r.hooks.options = r), r.async)
      return Promise.resolve(r.hooks ? r.hooks.preprocess(a) : a).then((o) => t(o, r)).then((o) => r.hooks ? r.hooks.processAllTokens(o) : o).then((o) => r.walkTokens ? Promise.all(this.walkTokens(o, r.walkTokens)).then(() => o) : o).then((o) => e(o, r)).then((o) => r.hooks ? r.hooks.postprocess(o) : o).catch(l);
    try {
      r.hooks && (a = r.hooks.preprocess(a));
      let o = t(a, r);
      r.hooks && (o = r.hooks.processAllTokens(o)), r.walkTokens && this.walkTokens(o, r.walkTokens);
      let c = e(o, r);
      return r.hooks && (c = r.hooks.postprocess(c)), c;
    } catch (o) {
      return l(o);
    }
  };
}, jy = new WeakSet(), ZR = function(t, e) {
  return (a) => {
    if (a.message += `
Please report this to https://github.com/markedjs/marked.`, t) {
      const n = "<p>An error occurred:</p><pre>" + Ns(a.message + "", !0) + "</pre>";
      return e ? Promise.resolve(n) : n;
    }
    if (e)
      return Promise.reject(a);
    throw a;
  };
};
const so = new vZ();
function xa(s, t) {
  return so.parse(s, t);
}
xa.options = xa.setOptions = function(s) {
  return so.setOptions(s), xa.defaults = so.defaults, FR(xa.defaults), xa;
};
xa.getDefaults = KA;
xa.defaults = ho;
xa.use = function(...s) {
  return so.use(...s), xa.defaults = so.defaults, FR(xa.defaults), xa;
};
xa.walkTokens = function(s, t) {
  return so.walkTokens(s, t);
};
xa.parseInline = so.parseInline;
xa.Parser = Mi;
xa.parser = Mi.parse;
xa.Renderer = Ey;
xa.TextRenderer = aC;
xa.Lexer = Oi;
xa.lexer = Oi.lex;
xa.Tokenizer = Iy;
xa.Hooks = Zd;
xa.parse = xa;
xa.options;
xa.setOptions;
xa.use;
xa.walkTokens;
xa.parseInline;
Mi.parse;
Oi.lex;
class nC {
  /**
   * Creates a new instance of the directive.
   */
  constructor(t) {
    this.$sce = t, this.restrict = "A";
  }
  /**
   * Factory method for the directive creation.
   * @ignore
   */
  static sxyHtml() {
    const t = (e) => new nC(e);
    return t.$inject = ["$sce"], t;
  }
  /**
   * Compile function for the directive.
   * @ignore
   */
  compile(t, e) {
    return (a, n, i) => {
      const r = (c, d) => c.substring(c.length - d.length, c.length) === d, l = () => a.$eval(i.params), o = () => i.sxyHtml;
      a.$watch(() => o() + JSON.stringify(l()), () => {
        let c = L.get(o(), l());
        r(o(), ".md") && (c = xa(c)), n.html(this.$sce.getTrustedHtml(c));
      });
    };
  }
}
class sC {
  constructor() {
    this.restrict = "A";
  }
  /**
   * Factory method for the directive creation.
   * @ignore
   */
  static sxyText() {
    return () => new sC();
  }
  /**
   * Compile function for the directive.
   * @ignore
   */
  compile(t, e) {
    return (a, n, i) => {
      const r = (c, d) => {
        const p = L.get(c, d);
        return c.trim() === p ? c : p;
      }, l = (c) => (n[0].attributes[c] || { value: "" }).value, o = () => a.$eval(i.params);
      a.$watch(() => l("pre") + l("sxy-text") + JSON.stringify(o()) + l("ps"), () => {
        n.text(r(l("pre")) + r(l("sxy-text"), o()) + r(l("ps")));
      });
    };
  }
}
class xZ {
  /** Gets the directives for Module registration. */
  static getDirectives() {
    return {
      // TODO: Remove depency to directives starting with "salaxy-" => "sxy-".
      salaxyIfRole: Dy.sxyIfRole(),
      // TODO: Go through: are these needed? If so => "sxy-"
      salaxyAppendNode: XA.salaxyAppendNode(),
      // Useful? Used in tabs, are tabs really used?
      salaxyDatepickerInputValidation: qA.salaxyDatepickerInputValidation(),
      // Could this be in ValidatorFunctions or is there special functionality? This is used only in date picker.
      // TODO: Move as <salaxy-loader> component instead of directive (removes unnecessary HTML from the views).
      //       Also evaluate relation to salaxy-spinner: There should be only one if possible with different layout options.
      salaxyLoader: jA.salaxyLoader(),
      // All new directives should start with "sxy-"
      sxyBs5Tooltip: zA.salaxyBs5Tooltip(),
      sxyBs5Popover: BA.salaxyBs5Popover(),
      sxyIfRole: Dy.sxyIfRole(),
      sxyIfSitemap: WA.sxyIfSitemap(),
      sxyOrderby: VA.sxyOrderby(),
      // Validator functions
      sxyTaxPercent: aa.sxyTaxPercent(),
      sxyCurrency: aa.sxyCurrency(),
      sxyIban: aa.sxyIban(),
      sxyEmail: aa.sxyEmail(),
      sxyEnumAsBoolean: sc.sxyEnumAsBoolean(),
      sxyMobilePhone: aa.sxyMobilePhone(),
      sxyExcludeUnknowns: aa.sxyExcludeUnknowns(),
      sxyBankReferenceFi: aa.sxyBankReferenceFi(),
      sxyPersonalIdFi: aa.sxyPersonalIdFi(),
      sxyCompanyIdFi: aa.sxyCompanyIdFi(),
      sxyOfficialIdFi: aa.sxyOfficialIdFi(),
      sxyPostalCodeFi: aa.sxyPostalCodeFi(),
      sxyNumber: aa.sxyNumber(),
      sxyInteger: aa.sxyInteger(),
      sxyMax: aa.sxyMax(),
      sxyMin: aa.sxyMin(),
      sxyMultipleOf: aa.sxyMultipleOf(),
      sxyPensionContractNumber: aa.sxyPensionContractNumber(),
      sxyHtml: nC.sxyHtml(),
      sxyText: sC.sxyText()
    };
  }
}
const cr = class cr {
  static toWorkflowEvent(t) {
    if (!t)
      return {};
    const e = t.indexOf("(Ui"), a = t.indexOf("):", e + 3), n = t.substring(0, e - 1) || "", i = t.substring(e + 3, a).toLowerCase();
    let r = t.substring(a + 3);
    const l = r.lastIndexOf("("), o = r.substring(0, l).trim();
    r = r.substring(l + 1), r = r.substring(0, r.length - 1);
    let c = "";
    const d = r.lastIndexOf(" id ");
    d >= 0 && (c = r.substring(d + 4), r = r.substring(0, d));
    let p = "";
    const h = r.lastIndexOf(" to ");
    h >= 0 && (p = r.substring(h + 4), r = r.substring(0, h));
    let g = "";
    const x = r.lastIndexOf(" at ");
    return x >= 0 && (g = r.substring(x + 4), r = r.substring(0, x), g = g.replace(" ", "T") + "Z"), {
      id: c,
      type: n,
      ui: i,
      user: r,
      assignedTo: p,
      message: o,
      time: g
    };
  }
  /**
   * Returns the label for an enumeration.
   *
   * Parameters of the filter are:
   *
   * - input: Enumeration in format "[EnumType].[EnumName]". First letter is case-insensitive so you can use lowerCamelCase or UpperCamelCase.
   * - defaultValue: Optional default value when language version is not available.
   * Special values "name" and "#name", may be used to return the enum member name either with hash or without it.
   * Default is "#name", which returns "#[MemberName]" if the translation is not found.
   * @example
   * ```html
   * <p>{{ 'CalculationStatus.Draft' | sxyEnum }} - The enum full name</p>
   * <p>{{ 'CalculationStatus.paymentSucceeded' | sxyEnum }} - you may also use JSON value where first letter is lower-case.</p>
   * <p>{{ 'CalculationStatus.' + calc.status | sxyEnum }} - ...which makes it easy to use with data.</p>
   * ```
   */
  static sxyEnum() {
    return (t, e = "#name") => {
      const a = (t || "").split(".");
      return a.length !== 2 ? "#ERR: sxyEnum" : a[1] ? He.getEnumLabel(a[0], a[1], e) : null;
    };
  }
  /**
   * Returns the description for an enumeration value in current language.
   *
   * Parameters of the filter are:
   *
   * - input: Enumeration in format "[EnumType].[EnumName]". First letter is case-insensitive so you can use lowerCamelCase or UpperCamelCase.
   * - defaultValue: Optional default value when language version is not available. Default is null
   * Special values "name" and "#name", may be used to return the enum member name either with hash or without it.
   * @example
   * ```html
   * <p>{{ 'CalculationStatus.Draft' | sxyEnumDescr }} - The enum full name</p>
   * <p>{{ 'CalculationStatus.paymentSucceeded' | sxyEnumDescr }} - you may also use JSON value where first letter is lower-case.</p>
   * <p>{{ 'CalculationStatus.' + calc.status | sxyEnumDescr }} - ...which makes it easy to use with data.</p>
   * ```
   */
  static sxyEnumDescr() {
    return (t, e) => {
      const a = (t || "").split(".");
      return a.length !== 2 ? "#ERR: sxyEnumDescr" : a[1] ? He.getEnumDescr(a[0], a[1], e) : null;
    };
  }
  /**
   * Formats the date with Dates.getFormattedDate in core project.
   * If the input is not recognized as date or if it is empty or less than year 1900, shows a dash.
   *
   * Parameters of the filter are:
   *
   * - input: Input to format
   * @example
   * ```html
   * <p>{{ calc.workflow.paidAt | sxyDate }}</p>
   * ```
   */
  static sxyDate() {
    return (t) => {
      const e = I.getYear(t);
      return !e || e < 1900 ? "-" : I.getFormattedDate(t);
    };
  }
  /**
   * Formats a DateRange with Dates.getFormattedRange() in core project.
   * If input is null, shows a dash.
   * Also supports the ApiListItem (startAt, endAt), CalcInfo type in Calculation.info property (workStartDate and workEndDate) and EmploymentData (startDate and endDate)
   *
   * Parameters of the filter are:
   *
   * - input: Input to format
   *
   */
  static sxyDateRange() {
    return (t) => {
      if (!t)
        return "-";
      const e = t;
      if (e.workStartDate || e.workEndDate)
        return I.getFormattedRange(e.workStartDate, e.workEndDate);
      const a = t;
      if (a.startAt || a.endAt)
        return I.getFormattedRange(a.startAt, a.endAt);
      const n = t;
      return n.startDate || n.endDate ? I.getFormattedRange(n.startDate, n.endDate) : I.getFormattedRange(t.start, t.end);
    };
  }
  /**
   * Iban formatting filter.
   *
   * Parameters of the filter are:
   *
   * - input: Input text to format as IBAN.
   *
   */
  static sxyIban() {
    return (t) => t ? Sw.formatIban(t) : null;
  }
  /**
   * Formats a number as count optionally taking into account the related unit
   *
   * Parameters of the filter are:
   *
   * - input: Input to format
   * - unit: Unit that is used in formatting.
   * - decimals: Number of decimals to show.
   * - nullText: Text to show if the value is null / undefined. By default returns null, which can then be cought by another filter or logical or ("||").
   * - zeroText: If specified, will use this text without the Unit formatting if the value is zero. By default zero is formatted as "0 [unitText]".
   */
  static sxyCount() {
    return (t, e = null, a = null, n = null, i = null) => {
      if (t == null)
        return n;
      if (i != null && t === 0)
        return i;
      const r = se.round(t, a || 2);
      switch (e) {
        case as.One:
          return "";
        case as.Period:
          return r + L.get("SALAXY.NG1.FilterFunctions.sxyCount.period" + (r === 1 ? "" : "s"));
        case as.Percent:
          return se.round(t * 100, a || 2) + "%";
        case as.Hours:
        case as.Days:
        case as.Weeks:
        case as.Count:
        case as.Kilometers:
        case as.Undefined:
        default:
          return r + " " + (Gi.getUnitIndicator(e) || "");
      }
    };
  }
  /**
   * Formats a datetime ISO string (or other DayJS-object compatible time)
   * As time with texts "Today", "Yesterday", "D.M. HH:mm" for this year
   * and "D.M.YYYY" for other years (if necessary, add option for adding time to previous years).
   *
   * Parameters of the filter are:
   *
   * - time: Input to format
   *
   */
  static sxyTime() {
    return (t) => ys.format(t);
  }
  /**
   * Calls the Salaxy standard Dates.asDate to convert a DatelyObject to ISO date string (without time).
   * ISO dates can then be used in comparison and equality.
   * Also note that, DatelyObject can be constants like "today" | "yesterday" | "tomorrow". See documentation for details.
   *
   * Parameters of the filter are:
   *
   * - input: Input to format as DatelyObject
   * - addWorkDays: If set, adds the number of workdays to the input.
   * May also be zero (0) to return input if it is a workday or next workday if input is not a workday.
   *
   */
  static sxyAsDate() {
    return (t, e) => e != null ? I.addWorkdays(t, e) : I.asDate(t);
  }
  /**
   * Formats a date/time range to an end-user friendly duration text.
   * Input may be Duration as ISO duration string (e.g. P3Y6M4DT12H30M5S) or .Net timespan (e.g. '7.23:59:59.999').
   */
  static sxyDuration() {
    return (t) => ys.formatDuration(t);
  }
  /**
   * Converts the occupation to a language versioned string.
   *
   * Parameters of the filter are:
   *
   * - input: The occupation code as stored / returned from the API.
   * - format: Default is just the label for the occupation. "code-label" is in format "[code]: [label]`
   *
   */
  static sxyOccupation() {
    return (t, e) => {
      const a = dc.getById(t);
      return a ? e === "code-label" ? `${a.code}: ${a.label}` : a.label : L.get("SALAXY.NG1.FilterFunctions.sxyOccupation.occupationMissing");
    };
  }
  /**
   * Formats a time (input) to an end-user friendly totaltime (12:34 or 12:34:56) text.
   * Input may be Duration as ISO duration string (e.g. P3Y6M4DT12H30M5S) or .Net timespan (e.g. '7.23:59:59.999').
   */
  static sxyTotalTime() {
    return (t, e) => {
      const a = (n) => n.toString().padStart(2, "0");
      switch (t = se.isNumber(t) ? t : 0, e) {
        case "minutes": {
          const n = Math.floor(t / 60), i = t % 60;
          return `${a(n)}:${a(i)}`;
        }
        case "seconds": {
          const n = Math.floor(t / 3600), i = Math.floor(t % 3600 / 60), r = t % 60;
          return `${a(n)}:${a(i)}:${a(r)}`;
        }
      }
    };
  }
};
cr.sxyWorkflowMessage = ["$sce", (t) => (e, a) => {
  if (!e)
    return t.getTrustedHtml("<span></span>");
  const n = (a || "").split(","), i = e.indexOf("(Ui"), r = e.indexOf("):", i + 3), l = e.substring(0, i - 1) || "UnknownEvent";
  if (n.length > 0 && !n.some((o) => o.trim() === l))
    return t.getTrustedHtml("<span></span>");
  if (l.startsWith("SystemMessage")) {
    const o = cr.toWorkflowEvent(e), c = o.time ? I.format(o.time, "D.M.YYYY HH:mm") : "";
    let d = l.substring(13);
    d = d.substring(0, 1).toLowerCase() + d.substring(1), d = L.get("SALAXY.ENUM.SystemMessage." + d + ".label");
    const p = (o.message + " " + c).trim();
    return t.getTrustedHtml(`<span class="badge bg-${o.ui}" title="${p}">${d}</span>`);
  } else {
    const o = e.substring(i + 3, r).toLowerCase();
    let c = e.substring(r + 3);
    const d = /([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1]) (2[0-3]|[01][0-9]):([0-5][0-9])/g;
    c = c.replace(d, (h, g, x, b, A, T) => {
      const R = Date.UTC(parseInt(g, 10), parseInt(x, 10) - 1, parseInt(b, 10), parseInt(A, 10), parseInt(T, 10));
      return I.format(R, "D.M.YYYY HH:mm");
    });
    const p = c.substring(0, c.lastIndexOf("("));
    return t.getTrustedHtml(`<span class="badge bg-${o}" title="${c}">${p}</span>`);
  }
}], cr.sxyShow = ["NaviService", (t) => (e, a) => {
  if (!e || !a)
    return !0;
  const n = a.split(".");
  let i = t.getSitemap();
  const r = i.find((o) => o.id === "company-site");
  r && (i = [r]);
  let l;
  if (n.length >= 3) {
    let o = i;
    for (const c of n) {
      const d = ws.getSection(o, c);
      c === n[n.length - 1] ? l = d : o = d.children;
    }
  } else
    n.length === 2 ? l = ws.getNode(i, n[0], n[1]) : l = ws.getSection(i, n[0]);
  return l ? !(l?.hidden ?? []).includes(e) : !0;
}], cr.sxyTranslate = ["$sce", (t) => (e, a) => {
  const n = (r, l) => r.substring(r.length - l.length, r.length) === l, i = L.get(e, a);
  if (e) {
    if (n(e, ".html"))
      return t.getTrustedHtml(i);
    if (n(e, ".md"))
      return t.getTrustedHtml(xa(i));
  }
  return i;
}], cr.sxyMarkdown = ["$sce", (t) => (e) => e == null ? null : t.getTrustedHtml(xa(e))], cr.sxyIsInRole = ["SessionService", (t) => (e) => t.isInSomeRole(e)], cr.sxyIsVisibility = ["NaviService", (t) => (e) => t.current.getVisibility(e)];
let Cn = cr;
class wZ {
  /** Gets the filters for Module registration. */
  static getFilters() {
    return {
      sxyAsDate: Cn.sxyAsDate,
      sxyCount: Cn.sxyCount,
      sxyDate: Cn.sxyDate,
      sxyDateRange: Cn.sxyDateRange,
      sxyDuration: Cn.sxyDuration,
      sxyEnum: Cn.sxyEnum,
      sxyEnumDescr: Cn.sxyEnumDescr,
      sxyIban: Cn.sxyIban,
      sxyMarkdown: Cn.sxyMarkdown,
      sxyOccupation: Cn.sxyOccupation,
      sxyTime: Cn.sxyTime,
      sxyTranslate: Cn.sxyTranslate,
      sxyIsInRole: Cn.sxyIsInRole,
      sxyIsVisibility: Cn.sxyIsVisibility,
      sxyWorkflowMessage: Cn.sxyWorkflowMessage,
      sxyTotalTime: Cn.sxyTotalTime,
      sxyShow: Cn.sxyShow
    };
  }
}
class ic {
  /**
   * Constructor creating a new interceptor.
   * @param  $q - $q service.
   * @param  $rootScope - Angular root scope.
   */
  constructor(t, e) {
    this.$q = t, this.$rootScope = e, this.loadingCount = 0, this.request = (a) => (this.loadingCount++, this.$rootScope.$broadcast("salaxy-loader-show"), a || this.$q.when(a)), this.response = (a) => (--this.loadingCount === 0 && this.$rootScope.$broadcast("salaxy-loader-hide"), a || this.$q.when(a)), this.responseError = (a) => (--this.loadingCount === 0 && this.$rootScope.$broadcast("salaxy-loader-hide"), this.$q.reject(a));
  }
  /**
   * Factory method for creating the interceptor.
   */
  static factory() {
    const t = (e, a) => (ic.instance == null && (ic.instance = new ic(e, a)), ic.instance);
    return t.$inject = ["$q", "$rootScope"], t;
  }
}
class iC {
  /**
   * Constructor for creating a new interceptor.
   */
  constructor(t, e) {
    this.views = t, this.format = e, this.request = (a) => (a && a.url && this.views.test(a.url) && (a.url = `${a.url}${a.url.indexOf("?") < 0 ? "?" : "&"}v=${I.format(/* @__PURE__ */ new Date(), this.format)}`), a);
  }
  /**
   * Factory method for creating the interceptor.
   * Interceptor for enabling non-cached views.
   * The interceptor adds a 'v'-query parameter to the template path.
   * The value of the v-parameter is a timestamp formatted by the given format.
   * @param views - Regex for views folders (template paths), default is /views\//
   * @param format - DayJs format for the current time based timestamp. default is "YYYYMMDDHH"
   */
  static factory(t = /views\//, e = "YYYYMMDDHH") {
    const a = () => new iC(t, e);
    return a.$inject = [], a;
  }
}
class A0 {
  /** Gets the services for Module registration. */
  static getServices() {
    return {
      AjaxNg1: sm,
      AlertService: Lv,
      AuthorizedAccountService: qv,
      CacheService: a2,
      CertificateService: Kv,
      CredentialService: Jv,
      CustomerInvoices: sX,
      FileService: Xv,
      InvoicesService: Qv,
      JsonSchemaService: Gv,
      NaviService: Bv,
      OnboardingService: Zv,
      PartnerService: tx,
      ReportsService: ex,
      RowTypeService: ax,
      SessionService: nx,
      SettingsService: sx,
      SignatureService: ix,
      UiCrudHelpers: Wv,
      UiHelpers: jv,
      UiTranslatorService: n2,
      UploadService: rx,
      UsecasesService: lx,
      UserSettingsService: s2,
      VarmaPensionService: ox,
      WizardService: Vv,
      WorkflowService: cx
    };
  }
  /** Gets the services from the @salaxy/core project that need to be registered for NG1 dependency injection. */
  static getCoreServices() {
    return {
      Absences: iX,
      AccountingTargets: I0,
      Accounts: rX,
      AccountSettings: lX,
      AuthorizedAccounts: oX,
      BeneficialOwnersApi: cX,
      Calculations: nm,
      Calculator: dX,
      CalendarEvents: uX,
      Certificates: pX,
      Client: hX,
      Credentials: mX,
      Datasets: gX,
      Employments: yX,
      Files: fX,
      HolidayYears: bX,
      Imports: vX,
      Invoices: xX,
      IrEarningsPayments: wX,
      IrPayerSummaries: AX,
      MessageThreads: CX,
      OAuth2: $X,
      Onboardings: SX,
      Overview: kX,
      PartnerServices: TX,
      PaymentChannelApi: wv,
      Payrolls: Cw,
      Payrolls4: Pl,
      ProApi: LX,
      Records: DX,
      ReferenceObjects: IX,
      Reports: PX,
      Session: EX,
      Taxcards: NX,
      Templates: io,
      Test: RX,
      Usecases: YX,
      Workers: _X,
      ServiceModels: OX,
      HouseholdYears: MX
    };
  }
}
const MZ = wt.module("salaxy.ng1.components.all", [
  "salaxy.ng1.templates.bootstrap",
  "ui.bootstrap",
  "ngRoute",
  "ngSanitize",
  "ngFileUpload",
  "pascalprecht.translate"
]).config([() => {
  console.debug(`@salaxy/ng1 init with ${[g9, f9, v9, w9, C9].length} modules.`);
}]).provider("RouteHelper", zv).service(A0.getCoreServices()).service(A0.getServices()).controller($9.getControllers()).directive(xZ.getDirectives()).component(h9.getComponents()).filter(wZ.getFilters()).constant("data", { isNotDefined: !0 }).constant("EditDialogParameters", { isNotDefined: !0 }).config(["$httpProvider", (s) => {
  s.interceptors.push(ic.factory());
}]).config(["$provide", "$translateProvider", (s, t) => {
  t.useSanitizeValueStrategy(null), s.value("$translateProvider", t);
}]).config(["$locationProvider", (s) => {
  s.hashPrefix("");
}]).run(Fv), XZ = wt.module("salaxy.ng1.templates.bootstrap", []).run(["$templateCache", function(s) {
  !Ne.current?.noCache && (s.put("salaxy-components/account/AccountAvatarEdit.html", `<div class="salaxy-component salaxy-account-contact-edit" ng-if="$ctrl.isAuthenticated">
  <div ng-if="$ctrl.session.currentAccount.entityType == 'company'" ng-controller="CompanyAccountController as $accountCtrl">
    <ng-include src="'AvatarEditor.html'"></ng-include>
  </div>
  <div ng-if="$ctrl.session.currentAccount.entityType != 'company'" ng-controller="PersonAccountController as $accountCtrl">
    <ng-include src="'AvatarEditor.html'"></ng-include>
  </div>
  <script type="text/ng-template" id="AvatarEditor.html">
    <form name="avatarForm" class="form-horizontal" ng-if="$accountCtrl.current">
      <div class="form-group">
        <div class="col-12 col-sm-4">
          <label for="avatarPreview" class="control-label" style="text-align:left" sxy-text="SALAXY.NG1.AccountAvatarEditPersonComponent.avatarLabel"></label>
        </div>
        <div class="col-12 col-sm-8">
          <div class="worker-avatar-col">
            <salaxy-avatar style="font-size: 130px" avatar="$accountCtrl.current.avatar"></salaxy-avatar>
          </div>
        </div>
      </div>
      <div class="form-group">
        <div class="col-12 col-sm-4">
          <label for="avatarPictureType" class="control-label" style="text-align:left" sxy-text="SALAXY.NG1.AccountAvatarEditPersonComponent.avatarTypeLabel"></label>
        </div>
        <div class="col-12 col-sm-8">
          <select class="form-select" id="avatarPictureType" ng-model="$accountCtrl.current.avatar.pictureType" ng-change="$accountCtrl.typeForAvatarChanged()">
            <option value="" disabled sxy-text="SALAXY.NG1.AccountAvatarEditPersonComponent.optionChoose"></option>
            <option value="icon" sxy-text="SALAXY.NG1.AccountAvatarEditPersonComponent.optionIcon"></option>
            <option value="uploaded" sxy-text="SALAXY.NG1.AccountAvatarEditPersonComponent.optionUploaded"></option>
            <option value="gravatar" sxy-text="SALAXY.NG1.AccountAvatarEditPersonComponent.optionGravatar"></option>
          </select>
        </div>
      </div>
      <div ng-if="$accountCtrl.current.avatar.pictureType == 'gravatar'" class="row">
        <div class="input-info col-sm-8 offset-sm-4">
          <div class="input-info-icon"><i class="bi bi-info-circle-fill text-default"></i></div>
          <p class="small input-info-text with-icon " sxy-html="SALAXY.NG1.AccountAvatarEditPersonComponent.gravatarInfo.html"></p>
        </div>
      </div>
      <div ng-if="$accountCtrl.current.avatar.pictureType == 'icon'">
        <salaxy-input name="avatarInitials" label="SALAXY.NG1.AccountAvatarEditPersonComponent.initialsLabel" ng-model="$accountCtrl.current.avatar.initials" max-length="2"></salaxy-input>
        <salaxy-input-enum ng-model="$accountCtrl.current.avatar.color" name="avatarColor" label="SALAXY.NG1.AccountAvatarEditPersonComponent.colorLabel" options="{
          '#009FD8': '#009FD8',
          '#91D214': '#91D214',
          '#D10074': '#D10074',
          '#3C3C3C': '#3C3C3C',
          '#61703B': '#61703B',
          '#7F2C2A': '#7F2C2A',
          '#FF911E': '#FF911E',
          '#289548': '#289548',
          'blue': 'blue',
          'lime': 'lime',
          'pink': 'pink',
          'gray': 'gray',
          'darkgreen': 'darkgreen',
          'brown': 'brown',
          'yellow': 'yellow',
          'orange': 'orange',
          'green': 'green',
          'black': 'black'         
          }">
        </salaxy-input-enum>
      </div>
      <div class="form-group">
        <div ng-if="$accountCtrl.current.avatar.pictureType == 'uploaded'">
          <div class="col-12 col-sm-4">
            <label for="avatarImageUpload" sxy-text="SALAXY.NG1.AccountAvatarEditPersonComponent.uploadImageLabel"></label>
          </div>
          <div class="col-12 col-sm-8">
            <div name="avatarImageUpload" ng-model="avatarImage" ngf-drop="$accountCtrl.uploadAvatarImage($file)" ngf-select="$accountCtrl.uploadAvatarImage($file)" class="salaxy-drop-box" ngf-drag-over-class="'salaxy-drag-over'" ngf-multiple="false" ngf-min-size="5KB" ngf-max-size="10MB"
              ngf-pattern="'image/*'" ngf-model-invalid="invalidFile" ng-class="invalidFile.$error != null ? 'error' : ''">
              <span sxy-html="SALAXY.NG1.AccountAvatarEditPersonComponent.uploadImage.html"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="text-end">
        <button ng-click="$accountCtrl.saveCurrent()" ng-disabled="avatarForm.$invalid" class="btn btn-primary" sxy-text="SALAXY.UI_Terms.save"></button>
      </div>
    </form>
  <\/script>
</div>`), s.put("salaxy-components/account/AccountContactEdit.html", `<div class="salaxy-component salaxy-account-contact-edit" ng-if="$ctrl.isAuthenticated">
  <div ng-if="$ctrl.session.currentAccount.entityType == 'company'" ng-controller="CompanyAccountController as $accountCtrl">
    <ng-include src="'ContactEditor.html'"></ng-include>
  </div>
  <div ng-if="$ctrl.session.currentAccount.entityType != 'company'" ng-controller="PersonAccountController as $accountCtrl">
    <ng-include src="'ContactEditor.html'"></ng-include>
  </div>
  <script type="text/ng-template" id="ContactEditor.html">
    <form name="contactForm" class="form-horizontal" ng-if="$accountCtrl.current">
      <div class="row">
        <div class="col-12">
          <salaxy-input name="email" label="SALAXY.MODEL.PersonAccount.contact.email.title" sxy-email ng-model="$accountCtrl.current.contact.email" ng-change="$accountCtrl.emailForAvatarChanged()">
          </salaxy-input>
          <salaxy-input name="telephone" label="SALAXY.MODEL.PersonAccount.contact.telephone.title" sxy-mobile-phone ng-model="$accountCtrl.current.contact.telephone"></salaxy-input>
          <salaxy-input name="street" label="SALAXY.MODEL.PersonAccount.contact.street.title" ng-model="$accountCtrl.current.contact.street" ng-required="('household' | sxyIsInRole) || ('company' | sxyIsInRole)"></salaxy-input>
          <salaxy-input name="postalCode" label="SALAXY.MODEL.PersonAccount.contact.postalCode.title" sxy-postal-code-fi ng-model="$accountCtrl.current.contact.postalCode" ng-required="('household' | sxyIsInRole) || ('company' | sxyIsInRole)"></salaxy-input>
          <salaxy-input name="city" label="SALAXY.MODEL.PersonAccount.contact.city.title" ng-model="$accountCtrl.current.contact.city" ng-required="('household' | sxyIsInRole) || ('company' | sxyIsInRole)"></salaxy-input>
          <salaxy-input-enum type="select" label="SALAXY.MODEL.PersonAccount.contact.countryCode.title" ng-model="$accountCtrl.current.contact.countryCode"
          name="country" read-only="true" enum="Country"></salaxy-input-enum>
        </div>
      </div>
      <div class="text-end">
        <button ng-click="$accountCtrl.saveCurrent()" ng-disabled="contactForm.$invalid" class="btn btn-primary" sxy-text="SALAXY.UI_Terms.save"></button>
      </div>
    </form>
  <\/script>
</div>`), s.put("salaxy-components/account/AccountInfo.html", `\uFEFF<div class="container-fixed salaxy-component salaxy-account-info" ng-controller="CompanyAccountController as $companyCtrl">
  <div class="d-flex flex-column flex-md-row">
    <div>
      <salaxy-avatar avatar="$ctrl.company.avatar" class="avatar-xl mb-4 me-4"></salaxy-avatar>
      <button type="button" style="margin-bottom: 5px;" class="btn btn-sm btn-default mb-2" ng-click="$companyCtrl.openEditDialog('avatar')" sxy-text="SALAXY.NG1.AccountInfoComponent.changeAvatar"></button>
    </div>   
    <p class="lead" ng-controller="CompanyOnboardingController as $onBoarding">
      {{'SALAXY.NG1.AccountInfoComponent.lead.infoText' | sxyTranslate}} <a ng-click="$onBoarding.openSigningWizardDialog()">{{'SALAXY.NG1.AccountInfoComponent.lead.buttonText' | sxyTranslate}}</a> {{'SALAXY.NG1.AccountInfoComponent.lead.infoTextAlt' | sxyTranslate}}
    </p>
  </div>
  <div class="table-responsive">
    <table class="table">
      <tr>
        <th sxy-text="SALAXY.NG1.AccountInfoComponent.palkkausAccount" ps=":"></th>
        <td>{{ $ctrl.company.id | sxyIban }}</td>
        <th sxy-text="SALAXY.NG1.AccountInfoComponent.email" ps=":"></th>
        <td>{{ $ctrl.company.contact.email }}</td>
      </tr>
      <tr>
        <th sxy-text="SALAXY.NG1.AccountInfoComponent.companyName" ps=":"></th>
        <td>{{ $ctrl.company.avatar.displayName }}</td>
        <th sxy-text="SALAXY.NG1.AccountInfoComponent.phone" ps=":"></th>
        <td>{{ $ctrl.company.contact.telephone }}</td>
      </tr>
      <tr>
        <th sxy-text="SALAXY.NG1.AccountInfoComponent.officialId" ps=":"></th>
        <td>{{ $ctrl.company.identity.officialId }}</td>
        <th sxy-text="SALAXY.NG1.AccountInfoComponent.address" ps=":"></th>
        <td>
          {{ $ctrl.company.contact.street }}<br /> {{ $ctrl.company.contact.postalCode }} {{ $ctrl.company.contact.city }}
        </td>
      </tr>
      <tr>
        <th sxy-text="SALAXY.NG1.AccountInfoComponent.companyType" ps=":"></th>
        <td>{{ 'CompanyType.' + $ctrl.company.companyType | sxyEnum }}</td>
        <th sxy-text="SALAXY.NG1.AccountInfoComponent.ibanNumber" ps=":"></th>
        <td>{{ $ctrl.company.identity.ibanNumber | sxyIban }}</td>
      </tr>
      <tr>
        <th sxy-text="SALAXY.NG1.AccountInfoComponent.authorizationType" ps=":"></th>
        <td>
          {{ 'AuthorizationType.' + $ctrl.company.identity.contract.authorizationType | sxyEnum }}
          <span ng-if="$ctrl.company.identity.contract.authorizationType == 'companyContract' || $ctrl.company.identity.contract.authorizationType == 'employerAuthorization'">
            (<a class="" ng-href="{{$ctrl.authorizationPdfUrl}}" target="_blank" sxy-text="SALAXY.UI_Terms.seePreview"></a>)
          </span>
        </td>
        <th><button type="button" class="btn btn-sm btn-default mb-1" ng-click="$companyCtrl.openEditDialog('contactInfo')" sxy-text="SALAXY.NG1.AccountInfoComponent.editContactInfo"></button></th>
        <td></td>
      </tr>
      <tr>
        <th sxy-text="Asiakkaan tunnistaminen tehty" ps=":"></th>
        <td>
          <span ng-if="$ctrl.kycState == 'ignored'"></span>
          <span ng-if="$ctrl.kycState == 'valid'" class="text-success">KYC OK {{ $ctrl.kycUpdatedAt | sxyDate }}</span>
          <span ng-if="$ctrl.kycState == 'missing'" class="text-danger">Päivitä KYC</span>
          <span ng-if="$ctrl.kycState == 'expired'" class="text-warning">KYC vanhenee {{ $ctrl.kycExpiresAt | sxyDate }}</span>
        </td>
        <th>
          <a ng-href="{{('test' | sxyIsInRole) ? 'https://rc-iam.palkkaus.fi/wizard/index.html' : 'https://iam.palkkaus.fi/wizard/index.html'}}" target="_blank" class="btn btn-sm btn-default" role="button">Päivitä asiakkaan tunnistaminen</a>
        </th>
        <td></td>
      </tr>
    </table>
  </div>
</div>`), s.put("salaxy-components/account/AssurePartner.html", `<div class="salaxy-assure-partner salaxy-component" ng-controller="SessionController as $sessionCtrl">
  <div ng-if="$sessionCtrl.session.settings.partner.accountId">
    <ng-transclude ng-transclude-slot="header">
      <!-- Further information of the partner etc. -->
    </ng-transclude>
    <ng-transclude ng-transclude-slot="main">
      <!-- Content to assure -->
    </ng-transclude>
  </div>
  <div ng-if="!$sessionCtrl.session.settings.partner.accountId">
    <div class="row">
      <div class="col-12">
        <div class="content settings">
          <salaxy-accountant></salaxy-accountant>
        </div>
      </div>
    </div>
  </div>
</div>`), s.put("salaxy-components/account/AuthCard.html", `<div class="salaxy-component salaxy-product-card p-3 d-flex flex-column" ng-click="$ctrl.showPartnerSiteDialog($ctrl.authId)">
  <div class="d-flex row flex-grow-1">
    <div class="col-4">
      <i class="salaxy-avatar avatar-lg"><img ng-src="{{$ctrl.getPartnerSite($ctrl.authId).img}}" /></i>
    </div>
    <div class="col-8 ps-4">
      <div class="salaxy-product-title text-break">{{ $ctrl.getPartnerSite($ctrl.authId).title }}</div>
      <div class="salaxy-product-descr text-break">{{ $ctrl.getPartnerSite($ctrl.authId).status }}</div>
    </div>
  </div>
  <div class="d-flex justify-content-end">
    <salaxy-input-boolean type="switch" ng-if="$ctrl.isInRole('auth') && !$ctrl.hideSwitch" id="salaxyService" name="salaxyService" ng-model="$ctrl.getPartnerSite($ctrl.authId).enabled" label-type="no-label" label-true="Aktivoitu" label-false="Aktivoi"></salaxy-input-boolean>
  </div>
</div>`), s.put("salaxy-components/account/AuthorizedAccounts.html", `<div class="card card-default" ng-controller="AccountAuthorizationController as $ctrl">
  <div class="card-header">
    <h2 sxy-text="SALAXY.NG1.AuthoringAccountComponent.authorizeIntro"></h2>
    <p><small sxy-text="SALAXY.NG1.AuthoringAccountComponent.authorizeDescription"></small></p>
  </div>
  <div class="card-body">
    <div class="salaxy-component salaxy-authorized-accounts">
      <div class="table-responsive">
        <table class="table table-striped">
          <thead>
            <tr>
              <th colspan="2" sxy-text="SALAXY.NG1.AuthoringAccountComponent.palkkausAccount"></th>
              <th ng-if="('admin' | sxyIsInRole)">Partnerin antama ID</th>
              <th class="right" sxy-text="SALAXY.NG1.AuthoringAccountComponent.date"></th>
              <th class="right">
                <ng-transclude ng-transclude-slot="header">
                  <button class="btn btn-sm btn-default" ng-click="$ctrl.showAuthorizedAccountAddDialog()" sxy-text="SALAXY.UI_Terms.createNew"></button>
                </ng-transclude>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr ng-repeat="avatar in $ctrl.list">
              <td>
                <salaxy-avatar class="avatar-sm" avatar="avatar"></salaxy-avatar>
              </td>
              <td>
                <strong>{{avatar.displayName}}</strong><br/>
                <small>{{avatar.id | sxyIban}}</small>
              </td>
              <td  ng-if="('admin' | sxyIsInRole)">{{avatar.partnerKey}}</td>
              <td class="right">{{avatar.createdAt | date}}</td>
              <td class="right">
                <button ng-click="$ctrl.delete(avatar.id)" class="btn btn-danger btn-sm" sxy-text="SALAXY.UI_Terms.delete"></button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>`), s.put("salaxy-components/account/AuthorizingAccounts.html", `<div class="salaxy-component salaxy-authorizing-accounts">
  <div class="table-responsive" ng-controller="CustomerOnboardingController as wizard">
    <table class="table table-striped">
      <thead>
        <tr>
          <th colspan="2" sxy-text="SALAXY.NG1.AuthoringAccountComponent.palkkausAccount"></th>
          <th sxy-text="SALAXY.NG1.AuthoringAccountComponent.status"></th>
          <th class="right" sxy-text="SALAXY.NG1.AuthoringAccountComponent.date"></th>
          <th class="right" colspan="3">
            <ng-transclude ng-transclude-slot="header">
              <button class="btn btn-sm btn-default" ng-click="wizard.launch()" sxy-text="SALAXY.UI_Terms.createNew"></button>
            </ng-transclude>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="account in $ctrl.authorizingAccounts">
          <td>
            <salaxy-avatar class="avatar-sm" avatar="account.avatar"></salaxy-avatar>
          </td>
          <td>
            <strong>{{account.avatar.displayName}}</strong><br/>
            <small>{{account.id | sxyIban }}</small>
          </td>
          <td>
            <small class="text-success" ng-if="account.identity.contract.isSigned" sxy-text="SALAXY.NG1.AuthoringAccountComponent.signeratureOk"></small>
            <small class="text-danger" ng-if="!account.identity.contract.isSigned" sxy-text="SALAXY.NG1.AuthoringAccountComponent.signeratureNo"></small>
          </td>
          <td class="right">{{account.createdAt | date }}</td>
          <td>
            <button ng-if="!account.identity.contract.isSigned && account.entityType == 'company'" ng-click="wizard.launch(account.id)" class="btn btn-default btn-block" sxy-text="SALAXY.NG1.AuthoringAccountComponent.invite"></button>
          </td>
          <td>
            <a ng-href="{{$ctrl.getLoginAsUrl(account.id)}}" target="_blank" class="btn btn-primary btn-block" sxy-text="SALAXY.NG1.AuthoringAccountComponent.signIn"></a>
          </td>
          <td>
            <button salaxy-if-role="test" ng-click="$ctrl.deleteAccount(account.id)" class="btn btn-danger btn-block" sxy-text="SALAXY.UI_Terms.delete"></button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>`), s.put("salaxy-components/account/Certificates.html", `<div class="card card-default">
  <div class="card-header">
    <h2 sxy-text="SALAXY.NG1.CertificatesComponent.title"></h2>    
  </div>
  <div class="card-body">
    <div class="salaxy-component salaxy-certificates">
      <div class="table-responsive">
        <table class="table table-striped">
          <thead>
            <tr>
              <th sxy-text="SALAXY.NG1.CertificatesComponent.name"></th>
              <th sxy-text="SALAXY.NG1.CertificatesComponent.id"></th>
              <th class="right" sxy-text="SALAXY.NG1.AuthoringAccountComponent.date"></th>
              <th class="right">
                <ng-transclude ng-transclude-slot="header">
                  <button class="btn btn-default btn-sm" ng-click="$ctrl.showCertificateAddDialog()" sxy-text="SALAXY.UI_Terms.createNew"></button>
                </ng-transclude>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr ng-repeat="certificate in $ctrl.list">
              <td>{{certificate.title || '-'}}</td>
              <td>{{certificate.thumbprint}}</td>
              <td class="right">{{certificate.createdAt | date}}</td>
              <td class="right">
                <button ng-click="$ctrl.delete(certificate.thumbprint)" class="btn btn-danger btn-sm" sxy-text="SALAXY.UI_Terms.delete"></button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>`), s.put("salaxy-components/account/Credentials.html", `<div class="card card-secondary">

  <div class="card-header">
    <h2 sxy-text="SALAXY.NG1.CredentialsComponent.title"></h2>
    <p>
      <!--<small sxy-text="SALAXY.NG1.CredentialsComponent.intro"></small>--></p>
  </div>
  <div class="card-body">
    <div class="salaxy-component salaxy-credentials">
      <div class="table-responsive">
        <table class="table table-striped">
          <thead>
            <tr>
              <th sxy-text="SALAXY.NG1.CredentialsComponent.userId"></th>
              <th sxy-text="SALAXY.NG1.CredentialsComponent.authenticationMethod"></th>
              <th class="right" sxy-text="SALAXY.NG1.AuthoringAccountComponent.date"></th>
              <th class="right">
                <ng-transclude ng-transclude-slot="header"></ng-transclude>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr ng-repeat="credential in $ctrl.list">
              <td>{{credential.email}}</td>
              <td>{{ 'AuthenticationMethod.' + credential.authenticationMethod | sxyEnum}}</td>
              <td class="right">{{credential.createdAt | date}}</td>
              <td class="right">

                <button ng-if="$ctrl.showEdit" ng-click="$ctrl.setCurrent(credential)" class="btn btn-primary btn-sm" sxy-text="SALAXY.UI_Terms.select"></button>
                <button ng-if="$ctrl.showEdit && !('admin' | sxyIsInRole)" ng-disabled="$ctrl.list.length &lt;= 1" ng-click="$ctrl.delete(credential.id)" class="btn btn-danger btn-sm" sxy-text="SALAXY.UI_Terms.delete"></button>
                <button ng-if="$ctrl.showEdit && ('admin' | sxyIsInRole)" ng-click="$ctrl.delete(credential.id)" class="btn btn-danger btn-sm" sxy-text="SALAXY.UI_Terms.delete"></button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <form name="credentialsForm" class="form-horizontal" ng-if="$ctrl.current && $ctrl.showEdit">
        <div class="row">
          <div class="col-12">
            <salaxy-input name="firstName" label="SALAXY.NG1.CredentialsComponent.firstName" ng-model="$ctrl.current.avatar.firstName"></salaxy-input>
            <salaxy-input name="lastName" label="SALAXY.NG1.CredentialsComponent.lastName" ng-model="$ctrl.current.avatar.lastName"></salaxy-input>
            <salaxy-input name="email" label="SALAXY.NG1.CredentialsComponent.email" ng-model="$ctrl.current.email" ng-change="$ctrl.emailForAvatarChanged()"></salaxy-input>
            <!-- <salaxy-input name="telephone" label="SALAXY.NG1.CredentialsComponent.telephone" ng-model="$ctrl.current.telephone"></salaxy-input>-->
            <div class="form-group">
              <div class="col-12 col-sm-4">
                <strong sxy-text="SALAXY.NG1.CredentialsComponent.authenticationMethod"></strong>
              </div>
              <div class="col-12 col-sm-8">
                {{ 'AuthenticationMethod.' + $ctrl.current.authenticationMethod | sxyEnum}}
              </div>
            </div>

          </div>
        </div>

        <div class="form-group">

          <div class="col-12 col-sm-4">
            <label for="avatarPictureType" class="control-label" style="text-align:left" sxy-text="SALAXY.NG1.CredentialsComponent.avatar.label"></label>
          </div>
          <div class="col-12 col-sm-6">
            <select class="form-select" style="margin-bottom:15px;" id="avatarPictureType" ng-model="$ctrl.current.avatar.pictureType" ng-change="$ctrl.typeForAvatarChanged()">
              <option value="" disabled sxy-text="SALAXY.NG1.CredentialsComponent.avatar.optionChoose"></option>
              <option value="icon" sxy-text="SALAXY.NG1.CredentialsComponent.avatar.optionIcon"></option>
              <option value="uploaded" sxy-text="SALAXY.NG1.CredentialsComponent.avatar.optionUploaded"></option>
              <option value="gravatar" sxy-text="SALAXY.NG1.CredentialsComponent.avatar.optionGravatar"></option>
            </select>
            <div ng-if="$ctrl.current.avatar.pictureType == 'gravatar'" class="input-info">
              <div class="input-info-icon"><i class="bi bi-info-circle-fill text-default"></i></div>
              <p class="small input-info-text with-icon " sxy-html="SALAXY.NG1.CredentialsComponent.avatar.gravatarInfo.html"></p>
            </div>
            <div ng-if="$ctrl.current.avatar.pictureType == 'icon'">
              <salaxy-input name="avatarInitials" label="SALAXY.NG1.CredentialsComponent.avatar.labelInitials" ng-model="$ctrl.current.avatar.initials" max-length="2"></salaxy-input>
              <salaxy-input-enum name="avatarColor" label="SALAXY.NG1.CredentialsComponent.avatar.labelColor" ng-model="$ctrl.current.avatar.color" options="$ctrl.colorOptions">
              </salaxy-input-enum>
            </div>
            <div ng-if="$ctrl.current.avatar.pictureType == 'uploaded'" class="form-group">
              <div class="col-12 col-sm-4">
                <label for="avatarImageUpload" sxy-text="SALAXY.NG1.CredentialsComponent.avatar.labelUploadImage"></label>
              </div>
              <div class="col-12 col-sm-8">
                <div name="avatarImageUpload" ng-model="avatarImage" ngf-drop="$ctrl.uploadAvatarImage($file)" ngf-select="$ctrl.uploadAvatarImage($file)" class="salaxy-drop-box" ngf-drag-over-class="'salaxy-drag-over'" ngf-multiple="false" ngf-min-size="5KB" ngf-max-size="10MB"
                  ngf-pattern="'image/*'" ngf-model-invalid="invalidFile" ng-class="invalidFile.$error != null ? 'error' : ''">
                  <span sxy-html="SALAXY.NG1.CredentialsComponent.avatar.uploadImage.html"></span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-2 col-12 text-center">
            <salaxy-avatar avatar="$ctrl.current.avatar" style="font-size:70px;"></salaxy-avatar>
          </div>
        </div>

        <div class="row">
          <div class="col-12 text-end">
            <button ng-click="$ctrl.saveCurrent()" ng-disabled="credentialsForm.$invalid" class="btn btn-primary" sxy-text="SALAXY.UI_Terms.save"></button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>`), s.put("salaxy-components/account/LanguageSelector.html", `<div class="salaxy-component salaxy-language-selector" ng-controller="CompanyAccountController as $accountCtrl">
  <div class="card language-selection card-secondary">
    <div class="card-header">
      <h2>{{'SALAXY.NG1.LanguageSelectionComponent.panelTitle' | sxyTranslate}}</h2>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-sm-6">
          <fieldset>
            <legend sxy-text="SALAXY.NG1.LanguageSelectionComponent.changeLanguage"></legend>
            <p sxy-text="SALAXY.NG1.LanguageSelectionComponent.changeLanguageInfo"></p>
            <div class="btn-group">
              <button type="button" class="btn" ng-class="$ctrl.getLanguage() == 'fi' ? 'btn-primary disabled' : 'btn-default'" ng-click="$ctrl.setLanguage('fi')" sxy-text="SALAXY.ENUM.Language.fi.label"></button>
              <button type="button" class="btn" ng-class="$ctrl.getLanguage() == 'en' ? 'btn-primary disabled' : 'btn-default'" ng-click="$ctrl.setLanguage('en')" sxy-text="SALAXY.ENUM.Language.en.label"></button>
              <button type="button" class="btn" ng-class="$ctrl.getLanguage() == 'sv' ? 'btn-primary disabled' : 'btn-default'" ng-click="$ctrl.setLanguage('sv')" sxy-text="SALAXY.ENUM.Language.sv.label"></button>
            </div>
          </fieldset>
        </div>
        <div class="col-sm-6">
          <fieldset>
            <legend sxy-text="SALAXY.NG1.LanguageSelectionComponent.changeCompanyDefaultLanguage"></legend>
            <p sxy-text="SALAXY.NG1.LanguageSelectionComponent.changeCompanyDefaultLanguageInfo"></p>
            <div class="btn-group">
              <button type="button" class="btn" ng-class="$accountCtrl.getAccountLanguage() == 'fi' ? 'btn-primary active disabled' : 'btn-default'" ng-click="$accountCtrl.current.language = 'fi'" sxy-text="SALAXY.ENUM.Language.fi.label"></button>
              <button type="button" class="btn" ng-class="$accountCtrl.getAccountLanguage() == 'en' ? 'btn-primary active disabled' : 'btn-default'" ng-click="$accountCtrl.current.language = 'en'" sxy-text="SALAXY.ENUM.Language.en.label"></button>
              <button type="button" class="btn" ng-class="$accountCtrl.getAccountLanguage() == 'sv' ? 'btn-primary active disabled' : 'btn-default'" ng-click="$accountCtrl.current.language = 'sv'" sxy-text="SALAXY.ENUM.Language.sv.label"></button>
            </div>
            <div>&nbsp;</div>
            <div class="alert alert-warning" sxy-html="SALAXY.NG1.LanguageSelectionComponent.warning.html"></div>
          </fieldset>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="row">
        <div class="col text-end">
          <button class="btn btn-primary" ng-click="$accountCtrl.saveCurrent()" sxy-text="SALAXY.UI_Terms.save"></button>
        </div>
      </div>
    </div>
  </div>
</div>`), s.put("salaxy-components/account/LoginButton.html", `<div class="salaxy-login-button salaxy-component d-flex" sxy-if-role="!worker">
  <button ng-hide="$ctrl.isAuthenticated" ng-click="$ctrl.signIn()" class="btn salaxy-login-button-login" ng-class="$ctrl.btnClass || 'btn-default'">
    <span class="bi bi-lock-fill me-2"></span>
    <span class="salaxy-login-button-text">{{ $ctrl.isSessionChecking ?  ('SALAXY.NG1.LoginButtonComponent.searching' | sxyTranslate) : ($ctrl.loginText || 'SALAXY.UI_Terms.login' | sxyTranslate) }}</span>
  </button>
  <div ng-show="$ctrl.isAuthenticated" class="btn-group dropdown salaxy-login-button-logout">
    <button type="button" id="loginBtn" class="btn dropdown-toggle" ng-class="$ctrl.btnClass || 'btn-default'" data-bs-toggle="dropdown" aria-expanded="false">
      <salaxy-avatar class="me-2" avatar="$ctrl.avatar"></salaxy-avatar>
      <span class="salaxy-login-button-text">{{ $ctrl.isAuthenticated ? $ctrl.avatar.displayName : ('SALAXY.NG1.LoginButtonComponent.authenticating' | sxyTranslate) }}</span>
    </button>
    <ul class="dropdown-menu" aria-labelledby="loginBtn" ng-controller="NaviController as $navi">
      <li>
        <a href="#" class="dropdown-item" ng-click="$ctrl.signOut()" sxy-text="SALAXY.UI_Terms.logout"></a>
      </li>
      <li role="separator" class="divider"></li>
      <li>
        <a href="#/settings/service-settings" class="dropdown-item" sxy-text="SALAXY.NG1.LoginButtonComponent.accountSettings" ng-click="$navi.toggleNavi()"></a>
      </li>
      <li>
        <a href="#/settings/authorizations" class="dropdown-item" sxy-text="SALAXY.NG1.LoginButtonComponent.authAndCerti" ng-click="$navi.toggleNavi()"></a>
      </li>
      <li ng-if="$ctrl.ownedPaymentChannel">
        <a href="#/payment-channel" class="dropdown-item" sxy-text="SALAXY.NG1.LoginButtonComponent.paymentChannel" ng-click="$navi.toggleNavi()"></a>
      </li>
    </ul>
  </div>
</div>
<div class="salaxy-login-button" sxy-if-role="worker" ng-controller="NaviController as $navi">
  <div ng-show="$ctrl.isAuthenticated" class="dropdown salaxy-login-button-logout">
    <button type="button" class="btn dropdown-toggle btn-transparent" data-bs-toggle="dropdown">
      <salaxy-avatar avatar="$ctrl.avatar" class="me-2"></salaxy-avatar>
      <span class="salaxy-login-button-text">{{ $ctrl.isAuthenticated ? $ctrl.avatar.displayName : ('SALAXY.NG1.LoginButtonComponent.authenticating' | sxyTranslate) }}
      </span>
    </button>
    <ul class="dropdown-menu" role="menu" aria-labelledby="account-menu">
      <li>
        <a href="#" ng-click="$ctrl.signOut()" class="dropdown-item" sxy-text="SALAXY.UI_Terms.logout"></a>
      </li>
      <li role="separator" class="dropdown-divider"></li>
      <li>
        <a href="#/account/account-info" sxy-text="SALAXY.NG1.LoginButtonComponent.accountSettings" ng-click="$navi.toggleNavi()" class="dropdown-item"></a>
      </li>
      <li>
        <a href="#/settings/authorizations" sxy-text="SALAXY.NG1.LoginButtonComponent.authAndCerti" ng-click="$navi.toggleNavi()" class="dropdown-item"></a>
      </li>
    </ul>
  </div>
</div>`), s.put("salaxy-components/account/Signing.html", `<div class="salaxy-component salaxy-signing">
  <div salaxy-if-role="init">
    <salaxy-spinner heading="SALAXY.UI_Terms.loading"></salaxy-spinner>
    <p>&nbsp;</p>
  </div>
  <div ng-if="$ctrl.isSigningRequired || $ctrl.showAlways">
    <form name="signingForm" class="form-horizontal">
      <h2 sxy-text="SALAXY.NG1.SigningComponent.heading"></h2>
      <div class="row">
        <div class="col-md-6">
          <fieldset>
            <legend sxy-text="SALAXY.NG1.SigningComponent.signerInformation"></legend>
            <salaxy-input name="sign_personName" label="SALAXY.NG1.SigningComponent.name" ng-model="$ctrl.model.signature.personName" ng-required="true"></salaxy-input>
            <salaxy-input name="sign_email" label="SALAXY.NG1.SigningComponent.email" sxy-email ng-model="$ctrl.model.signature.email" ng-required="true"></salaxy-input>
            <salaxy-input name="sign_telephone" label="SALAXY.NG1.SigningComponent.tel" sxy-mobile-phone ng-model="$ctrl.model.signature.telephone" ng-required="true">
            </salaxy-input>
            <salaxy-input name="sign_personalId" label="SALAXY.NG1.SigningComponent.ssNumber" sxy-personal-id-fi ng-model="$ctrl.model.signature.personalId" ng-required="true">
            </salaxy-input>
            <div class="text-right text-danger" style="margin-top: -14px; font-weight: bold;" sxy-if-role="test"> TEST ONLY: Ota hetu täältä ==></div>
            <salaxy-input-boolean type="checkbox" name="isProcura" required ng-model="$ctrl.model.signature.isProcura" label="SALAXY.NG1.SigningComponent.isProcuraLabel"
              label-true="SALAXY.NG1.SigningComponent.isProcuraLabelTrue"></salaxy-input-boolean>
          </fieldset>
        </div>
        <div class="col-md-6">
          <legend sxy-text="SALAXY.NG1.SigningComponent.attorney.info"></legend>
          <p>
            <span sxy-text="SALAXY.NG1.SigningComponent.attorney.infoText"></span>

            <a ng-href="{{ $ctrl.getPdfPreviewAddress() }}" target="_blank">{{'SALAXY.NG1.SigningComponent.attorney.linkText' | sxyTranslate}}</a>.
            {{'SALAXY.NG1.SigningComponent.attorney.linkTextInfo' | sxyTranslate}}
          </p>
          <p sxy-text="SALAXY.NG1.SigningComponent.attorney.signingConfirmationInfo"></p>
          <div sxy-if-role="test" class="alert alert-danger">
            <p>
              Allekirjoitus ohjaa nyt testiympäristöön, jossa
              <strong>HETU tarkistetaan</strong>.
              Katso testiympäristön
              <a href="https://gist.github.com/ykarikos/e43e567eb7b9e05432d4bd9d0b51ef35" target="_blank">HETU:t täältä</a>
              (valitse validi hetu).
            </p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <fieldset>
            <legend sxy-text="SALAXY.NG1.SigningComponent.salaryPaymentContactInformation"></legend>
            <p sxy-text="SALAXY.NG1.SigningComponent.salaryPaymentContanctInformationToAuthoritiesInfo"></p>
            <salaxy-input-boolean type="checkbox" name="isContactPersonSigner" ng-model="$ctrl.isContactPersonSigner" label="SALAXY.NG1.SigningComponent.contactPersonLabel"
              label-true="SALAXY.NG1.SigningComponent.contactPersonLabelTrue"></salaxy-input-boolean>
            <div ng-if="!$ctrl.isContactPersonSigner">
              <salaxy-input name="contact_email" label="SALAXY.NG1.SigningComponent.email" sxy-email ng-model="$ctrl.model.company.contact.email" ng-required="true">
              </salaxy-input>
              <salaxy-input name="contact_telephone" label="SALAXY.NG1.SigningComponent.tel" sxy-mobile-phone ng-model="$ctrl.model.company.contact.telephone" ng-required="true">
              </salaxy-input>
            </div>
          </fieldset>
        </div>
        <div class="col-md-6">
          <fieldset>
            <legend sxy-text="SALAXY.NG1.SigningComponent.postalAddress"></legend>
            <salaxy-input label="SALAXY.NG1.SigningComponent.streetAddress" name="Katuosoite" ng-model="$ctrl.model.company.contact.street" ng-required="true"></salaxy-input>
            <salaxy-input label="SALAXY.NG1.SigningComponent.postalNumber" name="Postinumero" sxy-postal-code-fi ng-model="$ctrl.model.company.contact.postalCode"
              ng-required="true"></salaxy-input>
            <salaxy-input label="SALAXY.NG1.SigningComponent.postOffice" name="Postitoimipaikka" ng-model="$ctrl.model.company.contact.city" ng-required="true"></salaxy-input>
          </fieldset>
        </div>
      </div>
      <p sxy-html="SALAXY.NG1.SigningComponent.authoritativeQuestions.bySigningAcceptTermsOfUse.html"></p>
      <div class="mb-2">
        <div>
          <button class="btn btn-primary" ng-disabled="!signingForm.$valid || $ctrl.isSigninStarted" ng-click="signingForm.$valid ? $ctrl.startDigitalSignature() : null"
            sxy-text="SALAXY.NG1.SigningComponent.signBtn"></button> &nbsp; &nbsp;
          <span ng-if="!signingForm.$valid" class="text-danger" sxy-text="SALAXY.NG1.SigningComponent.authoritativeQuestions.error"></span>
        </div>
      </div>
      <p sxy-text="SALAXY.NG1.SigningComponent.authoritativeQuestions.usePersonalMobileBanking"></p>
      <hr />
      <div>
        <div class="d-flex justify-content-between">
          <h3 sxy-text="SALAXY.NG1.SigningComponent.authoritativeQuestions.previewAttorney"></h3>
          <div>
            <small><a ng-href="{{ $ctrl.getPdfPreviewAddress() }}" target="_blank" sxy-text="SALAXY.NG1.SigningComponent.authoritativeQuestions.downloadPDF"></a>&nbsp;&nbsp;</small>
            <button ng-click="$ctrl.save()" ng-disabled="!signingForm.$valid" class="btn btn-primary"
              sxy-text="SALAXY.NG1.SigningComponent.authoritativeQuestions.updateForPreview"></button>
          </div>
        </div>
        <iframe id="preview-power-of-attorney-pdf" ng-src="{{ $ctrl.getPdfPreviewAddress() }}" class="w-100"></iframe>
      </div>
    </form>
  </div>
</div>`), s.put("salaxy-components/account/UserInfo.html", `\uFEFF<div class="salaxy-component salaxy-user-info">
  <div class="d-flex flex-column flex-md-row">
    <salaxy-avatar class="avatar-xl mb-1 me-4" avatar="$ctrl.session.currentCredential.avatar"></salaxy-avatar>
    <p class="lead" sxy-html="SALAXY.NG1.UserInfoComponent.description.html"></p>
  </div>
   
  <div class="table-responsive">
    <table class="table">
      <tr>
        <th colspan="2">
          <h3 sxy-text="SALAXY.NG1.UserInfoComponent.userNameTitle"></h3>
        </th>
      </tr>
      <tr>
        <th sxy-text="SALAXY.NG1.UserInfoComponent.authType" ps=":"></th>
        <td>{{ 'AuthenticationMethod.' + $ctrl.session.currentCredential.authenticationMethod | sxyEnum }}</td>
      </tr>
      <tr>
        <th sxy-text="SALAXY.NG1.UserInfoComponent.userName" ps=":"></th>
        <td>{{ $ctrl.session.currentCredential.id }}</td>
      </tr>
      <tr ng-if="$ctrl.session.currentCredential.authenticationMethod != 'salaxy' && $ctrl.session.currentCredential.authenticationMethod != 'x509'">
        <th sxy-text="SALAXY.NG1.UserInfoComponent.email" ps=":"></th>
        <td>{{ $ctrl.session.currentCredential.email }}</td>
      </tr>
      <tr>
        <th sxy-text="SALAXY.NG1.UserInfoComponent.name" ps=":"></th>
        <td>{{ $ctrl.session.currentCredential.avatar.displayName }}</td>
      </tr>
    </table>
  </div>
</div>`), s.put("salaxy-components/calc/2022/CalcEmployment.html", `<div class="salaxy-component salaxy-calc-employment">
  <div ng-if="!$ctrl.current.worker.employmentId" class="alert alert-danger">
    <strong>Error: Not supported</strong>
    <p>Tämä komponentti ei tue uuden Työntekijän valintaa (implement EmploymentSelect)</p>
  </div>
  <div ng-if="$ctrl.current.worker.employmentId">
    <salaxy-form-group class="select-worker" name="worker" label="SALAXY.NG1_Pages.Calc.History.workerLabel">
      <!--
        TODO: Need to create Employment relation selection component!
        <button class="btn btn-default float-end" ng-click="$ctrl.current.worker=null;todo()">Vaihda...</button>
      -->
      <div class="salaxy-worker-item">
        <salaxy-avatar class="salaxy-calc-row-type-avatar float-start" avatar="$ctrl.current.worker.avatar"></salaxy-avatar>
        <b>{{ $ctrl.current.worker.avatar.displayName }} ({{$ctrl.current.worker.paymentData.socialSecurityNumberValid}}) </b> <br />
        <small>
          <div>IBAN: {{ $ctrl.current.worker.paymentData.ibanNumber | sxyIban }}</div>
        </small>
      </div>
    </salaxy-form-group>
  </div>
</div>`), s.put("salaxy-components/calc/2022/CalcRowsEditor.html", `<div class="salaxy-component salaxy-calc-rows-editor salaxy-calc-rows-2022-editor" ng-switch="$ctrl.type">
  <div ng-switch-when="salary-defaults" class="salaxy-calc-rows-editor-worktime-import">
    <!-- TODO: Will be replaced by new row type editors -->
    <table class="table table-sm align-middle">
      <thead>
        <tr>
          <th sxy-text="SALAXY.NG1.CalcRowsComponent.editor.action"></th>
          <th colspan="2">{{ $ctrl.title | sxyTranslate }}</th>
          <th class="right" sxy-text="SALAXY.NG1.DateRange.labelStartAndEndDate"></th>
          <th class="right" sxy-text="SALAXY.NG1.CalcRowsComponent.editor.totals.total"></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.filteredList track by $index">
          <td style="width: 25%;">
            <salaxy-input-enum type="select" label-type="plain" ng-model="row.source"
              filter="{{$ctrl.rowSources}}" hidden-options="''"
              name="{{ 'source' + $index }}" enum="CalculationRowSource"></salaxy-input-enum>
          </td>
          <td style="width: 32px;">
            <salaxy-avatar ng-if="row.rowType" class="salaxy-calc-row-type-avatar"
              avatar="{ color: $ctrl.getConfig(row).color, initials: $ctrl.getConfig(row).iconText, entityType: 'company' }"></salaxy-avatar>
          </td>
          <td style="width: 40%;">
            <div>{{row.message || ( "CalculationRowType." + row.rowType | sxyEnum) }}</div>
            <div ng-if="row.count && row.count != 1"><small class="text-muted">{{row.count | sxyCount : row.unit }} * {{ row.price | currency }}</small></div>
            <small class="" ng-if="$ctrl.getValidation(row).type == 'default'">
              {{ $ctrl.getValidation(row).msg | sxyTranslate }}
            </small>
            <span ng-if="$ctrl.getValidation(row).type == 'error'">
              <span class="label label-danger" sxy-text="SALAXY.NG1.CalcRowsComponent.editor.validation.note"></span>
              <small class="alert-danger">{{ $ctrl.getValidation(row).msg | sxyTranslate }}
                <a href="" ng-click="$ctrl.showEdit(row, 'auto')" sxy-text="SALAXY.NG1.CalcRowsComponent.editor.validation.edit" ps="..."></a>
              </small>
            </span>
          </td>
          <td class="right">
            <div>{{ row.period | sxyDateRange }}&nbsp;&nbsp;</div>
          </td>
          <td style="width: 32px;">
            <div class="float-end">{{ $ctrl.getRowTotal(row) | currency }}</div>
          </td>
          <td class="right">
            <button type="button" class="edit btn btn-info" ng-click="$ctrl.showEdit(row, 'auto')"
              title="{{'SALAXY.NG1.CalcRowsComponent.editor.buttons.infoIcon' | sxyTranslate}}">
              <i class="bi bi-info-circle-fill" ng-class="$ctrl.current == row ? 'bi-arrow-right-circle-fill' : 'bi-info-circle'"></i></button>
          </td>
        </tr>
      </tbody>
    </table>
    <ng-transclude ng-transclude-slot="footer">
      <footer>
        <p><b>{{'SALAXY.NG1.CalcRowsComponent.editor.addNewRow' | sxyTranslate}}:</b></p>
        <table>
          <tbody>
            <tr>
              <td style="width: 40%;">
                <salaxy-input-enum type="select" label-type="plain" ng-model="$ctrl.newRow.source"
                  filter="{{$ctrl.rowSources}}" hidden-options="''"
                  name="newRowSource" enum="CalculationRowSource"></salaxy-input-enum>
              </td>
              <td style="width: 40%;">
                <salaxy-calc-row-type name="newRowType" model="$ctrl.newRow" placeholder="SALAXY.NG1.CalcRowsComponent.editor.calcRowTypePlaceholder"
                  on-row-changed="$ctrl.commitNewRow(true)" row-types="$ctrl.rowTypes" categories="$ctrl.categories"></salaxy-calc-row-type>
              </td>
              <td>
                <button type="button" class="btn btn-default w-100" ng-click="$ctrl.showRowTypeSelectionDialog()"><i class="bi bi-info-circle-fill text-primary me-2"></i> <span
                    sxy-text="SALAXY.NG1.CalcRowsComponent.editor.buttons.readMore" ps="..."></span></button>
              </td>
            </tr>
          </tbody>
        </table>
      </footer>
    </ng-transclude>
  </div>
  <div ng-switch-when="salary-defaults-temp2" class="salaxy-calc-rows-editor-worktime-import">
    <!-- TODO: Will be replaced by new row type editors -->
    <table class="table table-condensed">
      <thead>
        <tr>
          <th colspan="2">{{ $ctrl.title | sxyTranslate }}</th>
          <th class="right" sxy-text="SALAXY.NG1.DateRange.labelStartAndEndDate"></th>
          <th class="right" sxy-text="SALAXY.NG1.CalcRowsComponent.editor.totals.total"></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.filteredList track by $index">
          <td style="width: 32px;">
            <salaxy-avatar ng-if="row.rowType" class="salaxy-calc-row-type-avatar"
              avatar="{ color: $ctrl.getConfig(row).color, initials: $ctrl.getConfig(row).iconText, entityType: 'company' }"></salaxy-avatar>
          </td>
          <td style="width: 40%;">
            <div>{{row.message || ( "CalculationRowType." + row.rowType | sxyEnum) }}</div>
            <div ng-if="row.count && row.count != 1"><small class="text-muted">{{row.count | sxyCount : row.unit }} * {{ row.price | currency }}</small></div>
            <small class="" ng-if="$ctrl.getValidation(row).type == 'default'">
              {{ $ctrl.getValidation(row).msg | sxyTranslate }}
            </small>
            <span ng-if="$ctrl.getValidation(row).type == 'error'">
              <span class="label label-danger" sxy-text="SALAXY.NG1.CalcRowsComponent.editor.validation.note"></span>
              <small class="alert-danger">{{ $ctrl.getValidation(row).msg | sxyTranslate }}
                <a href="" ng-click="$ctrl.showEdit(row, 'auto')" sxy-text="SALAXY.NG1.CalcRowsComponent.editor.validation.edit" ps="..."></a>
              </small>
            </span>
          </td>
          <td class="right">
            <div>{{ row.period | sxyDateRange }}&nbsp;&nbsp;</div>
          </td>
          <td style="width: 32px;">
            <div class="float-end">{{ $ctrl.getRowTotal(row) | currency }}</div>
          </td>
          <td class="right">
            <button type="button" class="edit btn btn-info" ng-click="$ctrl.showEdit(row, 'auto')"
              title="{{'SALAXY.NG1.CalcRowsComponent.editor.buttons.infoIcon' | sxyTranslate}}">
              <i class="bi bi-info-circle-fill" ng-class="$ctrl.current == row ? 'bi-arrow-right-circle-fill' : 'bi-info-circle'"></i></button>
          </td>
        </tr>
      </tbody>
    </table>
    <ng-transclude ng-transclude-slot="footer">
      <footer>
        <table>
          <tbody>
            <tr>
              <td><b>{{'SALAXY.NG1.CalcRowsComponent.editor.addNewRow' | sxyTranslate}}:</b></td>
              <td>
                <salaxy-calc-row-type name="newRowType" model="$ctrl.newRow" placeholder="SALAXY.NG1.CalcRowsComponent.editor.calcRowTypePlaceholder"
                  on-row-changed="$ctrl.commitNewRow(true)" row-types="$ctrl.rowTypes" categories="$ctrl.categories" clear-on-select="true"></salaxy-calc-row-type>
              </td>
              <td>
                <button type="button" class="btn btn-default" ng-click="$ctrl.showRowTypeSelectionDialog()"><i class="bi bi-info-circle-fill text-primary me-2"></i> <span
                    sxy-text="SALAXY.NG1.CalcRowsComponent.editor.buttons.readMore" ps="..."></span></button>
              </td>
            </tr>
          </tbody>
        </table>
      </footer>
    </ng-transclude>
  </div>
  <div ng-switch-when="worktime-import" class="salaxy-calc-rows-editor-worktime-import">
    <table class="table table-condensed">
      <thead>
        <tr>
          <th>Validointi</th>
          <th colspan="2">
            <div>Työsuhteen ID</div>
            <div>Henkilötunnus</div>
          </th>
          <th colspan="2">{{ $ctrl.title | sxyTranslate }}</th>
          <th>
            <div>Palkkalaji</div>
            <div>Alalaji</div>
          </th>
          <th class="right" sxy-text="SALAXY.NG1.CalcRowsComponent.editor.totals.total"></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.filteredList track by $index">
          <td ng-if="row.validation.isValid">
            <div class="text-success"><b>OK</b></div>
          </td>
          <td ng-if="row.validation.isValid == null">
            <div class="text-muted">Ei validointia</div>
          </td>
          <td ng-if="row.validation.isValid === false">
            <div class="text-danger"><salaxy-validation-summary api-validation="row.validation" layout="minimal"></salaxy-validation-summary></div>
          </td>
          <td style="width: 32px;">
            <salaxy-avatar class="salaxy-calc-row-type-avatar"
              avatar="row.$avatar"></salaxy-avatar>
          </td>
          <td ng-if="row.$avatar">
            <div>{{ row.$avatar.sortableName }}</div>
            <div>{{ row.personalId || "-" }} ({{ row.employmentType || "-" }})</div>
          </td>
          <td ng-if="!row.$avatar">
            <div>{{ row.employmentId || "-" }}</div>
            <div>{{ row.personalId || "-" }} ({{ row.employmentType || "-" }})</div>
          </td>
          <td style="width: 32px;">
            <salaxy-avatar ng-if="row.rowType" class="salaxy-calc-row-type-avatar"
              avatar="{ color: $ctrl.getConfig(row).color, initials: $ctrl.getConfig(row).iconText, entityType: 'company' }"></salaxy-avatar>
          </td>
          <td>
            <div>{{row.message || ( "CalculationRowType." + row.rowType | sxyEnum) }}</div>
            <div ng-if="row.count && row.count != 1"><small class="text-muted">{{row.count | sxyCount : row.unit }} * {{ row.price | currency }}</small></div>
            <small class="" ng-if="$ctrl.getValidation(row).type == 'default'">
              {{ $ctrl.getValidation(row).msg | sxyTranslate }}
            </small>
            <span ng-if="$ctrl.getValidation(row).type == 'error'">
              <span class="label label-danger" sxy-text="SALAXY.NG1.CalcRowsComponent.editor.validation.note"></span>
              <small class="alert-danger">{{ $ctrl.getValidation(row).msg | sxyTranslate }}
                <a href="" ng-click="$ctrl.showEdit(row, 'auto')" sxy-text="SALAXY.NG1.CalcRowsComponent.editor.validation.edit" ps="..."></a>
              </small>
            </span>
          </td>
          <td>
            <div>{{ ("CalculationRowType." + row.rowType | sxyEnum ) || "-" }}</div>
            <div>{{ row.data.kind || "-" }}</div>
          </td>
          <td>
            <div class="float-end">{{ $ctrl.getRowTotal(row) | currency }}</div>
          </td>
          <td class="right">
            <button type="button" class="edit btn btn-info" ng-click="$ctrl.showEdit(row, 'auto')"
              title="{{'SALAXY.NG1.CalcRowsComponent.editor.buttons.infoIcon' | sxyTranslate}}">
              <i class="bi bi-info-circle-fill" ng-class="$ctrl.current == row ? 'bi-arrow-right-circle-fill' : 'bi-info-circle'"></i></button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div ng-switch-when="worktime-import-employment" class="salaxy-calc-rows-editor-worktime-import">
    <table class="table table-condensed">
      <thead>
        <tr>
          <th>Valiointi</th>
          <th class="right">
            <div>Palkkakausi</div>
            <div>Tila</div>
          </th>
          <th colspan="2">{{ $ctrl.title | sxyTranslate }}</th>
          <th>
            <div>Palkkalaji</div>
            <div>Alalaji</div>
          </th>
          <th class="right" sxy-text="SALAXY.NG1.CalcRowsComponent.editor.totals.total"></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.filteredList track by $index">
          <td ng-if="row.validation.isValid">
            <div class="text-success">
              <b>OK</b>
              <a ng-href="{{ '#/payroll/details/' + row.data.payrollId }}" ng-if="row.data.payrollId">Palkkalista</a>
            </div>
            <div ng-if="row.data.originalPayrollId" style="padding-left: 22px;">
              <a ng-href="{{ '#/payroll/details/' + row.data.originalPayrollId }}" ng-if="row.data.originalPayrollId">Siirretty palkkalistasta</a>
            </div>
          </td>
          <td ng-if="row.validation.isValid == null">
            <div class="text-muted">Ei validointia</div>
          </td>
          <td ng-if="row.validation.isValid === false">
            <div class="text-danger"><salaxy-validation-summary api-validation="row.validation" layout="minimal"></salaxy-validation-summary></div>
          </td>
          <td class="right" ng-switch="row.status">
            <div>{{ row.period | sxyDateRange }}</div>
            <div ng-switch-when="preview" class="text-warning"><b>Esikatselu</b></div>
            <div ng-switch-when="new" class="text-primary"><b>Uusi (hyväksytty)</b></div>
            <div ng-switch-when="deleted" class="text-danger"><s>Poistettu</s></div>
            <div ng-switch-when="error" class="text-danger"><b>Virheitä</b></div>
            <div ng-switch-when="committed" class="text-success"><b>Lähetetty</b></div>
            <div ng-switch-when="ignored" class="text-muted"><s>Ei huomioida</s></div>
            <div ng-switch-when="edited" class="text-primary">Käsin syötetty</div>
            <div ng-switch-default>{{ row.status }}</div>
          </td>
          <td style="width: 32px;">
            <salaxy-avatar ng-if="row.rowType" class="salaxy-calc-row-type-avatar"
              avatar="{ color: $ctrl.getConfig(row).color, initials: $ctrl.getConfig(row).iconText, entityType: 'company' }"></salaxy-avatar>
          </td>
          <td>
            <div>{{row.message || ( "CalculationRowType." + row.rowType | sxyEnum) }}</div>
            <div ng-if="row.count && row.count != 1"><small class="text-muted">{{row.count | sxyCount : row.unit }} * {{ row.price | currency }}</small></div>
            <small class="" ng-if="$ctrl.getValidation(row).type == 'default'">
              {{ $ctrl.getValidation(row).msg | sxyTranslate }}
            </small>
            <span ng-if="$ctrl.getValidation(row).type == 'error'">
              <span class="label label-danger" sxy-text="SALAXY.NG1.CalcRowsComponent.editor.validation.note"></span>
              <small class="alert-danger">{{ $ctrl.getValidation(row).msg | sxyTranslate }}
                <a href="" ng-click="$ctrl.showEdit(row, 'auto')" sxy-text="SALAXY.NG1.CalcRowsComponent.editor.validation.edit" ps="..."></a>
              </small>
            </span>
          </td>
          <td>
            <div>{{ (row.rowType || 'unknown') == "unknown" ? "-" : ("CalculationRowType." + row.rowType | sxyEnum) }}</div>
            <div>{{ row.data.kind || "-" }}</div>
          </td>
          <td>
            <div class="float-end">{{ $ctrl.getRowTotal(row) ? ($ctrl.getRowTotal(row) | currency) : "-" }}</div>
          </td>
          <td class="right">
            <input type="checkbox" ng-model="row.data.isSelected" ng-if="$ctrl.showRowSelection" style="margin-right: 8px;margin-top: 10px;" />
            <button type="button" class="edit btn btn-info" ng-click="$ctrl.showEdit(row, 'auto')"
              title="{{'SALAXY.NG1.CalcRowsComponent.editor.buttons.infoIcon' | sxyTranslate}}">
              <i class="bi bi-info-circle-fill" ng-class="$ctrl.current == row ? 'bi-arrow-right-circle-fill' : 'bi-info-circle'"></i></button>
            <salaxy-json-formatter key="'js'" json="row" open="2" type="dialog" btn-class="btn btn-default" ></salaxy-json-formatter>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div ng-switch-default class="row">
    <div class="col-sm-6">
      <table class="table table-sm">
        <thead>
          <tr>
            <th colspan="2" class="uppercase">{{ $ctrl.title || ('SALAXY.NG1.CalcRowsComponent.editor.calcRow' | sxyTranslate) }}</th>
            <th class="right" sxy-text="SALAXY.NG1.CalcRowsComponent.editor.totals.total"></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="row in $ctrl.filteredList track by $index">
            <td width="42px">
              <salaxy-avatar ng-if="row.rowType" class="salaxy-calc-row-type-avatar"
                avatar="{ color: $ctrl.getConfig(row).color, initials: $ctrl.getConfig(row).iconText, entityType: 'company' }"></salaxy-avatar>
            </td>
            <td width="100%">
              <div class="float-end">{{ $ctrl.getRowTotal(row) | currency }}</div>
              <div>{{row.message || ( "CalculationRowType." + row.rowType | sxyEnum) }}</div>
              <div ng-if="row.count && row.count != 1"><small class="text-muted">{{row.count | sxyCount : row.unit }} * {{ row.price | currency }}</small></div>
              <small class="" ng-if="$ctrl.getValidation(row).type == 'default'">
                {{ $ctrl.getValidation(row).msg | sxyTranslate }}
              </small>
              <span ng-if="$ctrl.getValidation(row).type == 'error'">
                <span class="label label-danger" sxy-text="SALAXY.NG1.CalcRowsComponent.editor.validation.note"></span>
                <small class="alert-danger">{{ $ctrl.getValidation(row).msg | sxyTranslate }}
                  <a href="" ng-click="$ctrl.showEdit(row, 'auto')" sxy-text="SALAXY.NG1.CalcRowsComponent.editor.validation.edit" ps="..."></a>
                </small>
              </span>
            </td>
            <td class="right">
              <button type="button" class="edit btn btn-info" ng-click="$ctrl.showEdit(row, 'auto')"
                title="{{'SALAXY.NG1.CalcRowsComponent.editor.buttons.infoIcon' | sxyTranslate}}">
                <i class="bi bi-info-circle-fill" ng-class="$ctrl.current == row ? 'bi-arrow-right-circle-fill' : 'bi-info-circle'"></i></button>
            </td>
          </tr>
        </tbody>
      </table>
      <ng-transclude ng-transclude-slot="footer">
        <footer>
          <p><b>{{'SALAXY.NG1.CalcRowsComponent.editor.addNewRow' | sxyTranslate}}:</b></p>
          <table>
            <tbody>
              <tr>
                <td style="width: 100%;">
                  <salaxy-calc-row-type name="newRowType" model="$ctrl.newRow" placeholder="SALAXY.NG1.CalcRowsComponent.editor.calcRowTypePlaceholder"
                    on-row-changed="$ctrl.commitNewRow(true)" row-types="$ctrl.rowTypes" categories="$ctrl.categories"></salaxy-calc-row-type>
                </td>
                <td>
                  <button type="button" class="btn btn-default" ng-click="$ctrl.showRowTypeSelectionDialog()"><i class="bi bi-info-circle-fill text-primary me-2"></i> <span
                      sxy-text="SALAXY.NG1.CalcRowsComponent.editor.buttons.readMore" ps="..."></span></button>
                </td>
              </tr>
            </tbody>
          </table>
        </footer>
      </ng-transclude>
    </div>
    <div class="col-sm-6 d-none d-sm-block salaxy-calc-rows-editor-details-container">
      <ng-include ng-if="$ctrl.current" src="'salaxy-components/calc/rows/CalcRows2019EditDialog.html'"></ng-include>
    </div>
  </div>
</div>`), s.put("salaxy-components/calc/2022/CalcUsecase.html", `<div class="salaxy-component salaxy-calc-usecase" ng-controller="NaviController as $naviCtrl">

  <salaxy-spinner ng-if="$ctrl.isLoading"></salaxy-spinner>
  <div class="btn-toolbar calc-toolbar" ng-if="$ctrl.current">
    <div class="btn-group dropdown" ng-if="$ctrl.current.worker.employmentId">
      <button id="workerBtn" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown">
        <salaxy-avatar avatar="$ctrl.current.worker.avatar" style="font-size: 2em; margin: -5px 5px -5px -10px; width: 1em; height: 1em;"></salaxy-avatar>  
        {{ $ctrl.current.worker.avatar.displayName }}
      </button>
      <ul class="dropdown-menu" role="menu" aria-labelledby="workerBtn">
        
        <li role="menuitem"><a href="" ng-click="$ctrl.isWorkerInfoOpen = true" data-bs-toggle="collapse" data-bs-target="#workerInfo" class="dropdown-item" sxy-text="SALAXY.NG1.CalcUsecase.showAdditionalInfo"></a></li>
        <li role="menuitem"><a href="" ng-click="$ctrl.showWorkerEditDialog()" class="dropdown-item" sxy-text="SALAXY.NG1.CalcUsecase.editWorker"></a></li>
        <li role="menuitem"><a href="" ng-click="$ctrl.showRefreshAutoTaxcardDialog()" class="dropdown-item" sxy-text="SALAXY.NG1.CalcUsecase.checkAutomaticTaxCard"></a></li>
      </ul>
    </div>
   
    <div class="ms-auto d-flex calc-actions" ng-if="$ctrl.current.worker.employmentId && !$ctrl.usecases">
      <salaxy-calc-sharing-receipt-action ng-if="$ctrl.showAction('reject')" button-class="btn btn-danger" model="$ctrl" type="'reject'"></salaxy-calc-sharing-receipt-action>
      <salaxy-calc-sharing-receipt-action ng-if="$ctrl.showAction('approve')"  button-class="btn btn-success" model="$ctrl" type="'approve'"></salaxy-calc-sharing-receipt-action>
      <button ng-if="$ctrl.showAction('save')" ng-disabled="$ctrl.isActionDisabled('save')" type="button" class="btn btn-primary" ng-click="$ctrl.save()" sxy-text="SALAXY.UI_Terms.save"></button>
      <salaxy-pay-button ng-if="$ctrl.showAction('pay')" model="$ctrl.current" mode="pay-button" style="display: inline-block" ng-ref="$payButton" disabled="!$payButton.isChannelDefined"></salaxy-pay-button>
      <salaxy-pay-button ng-if="$ctrl.showAction('pay')" model="$ctrl.current" mode="channel-select" style="display: inline-block"></salaxy-pay-button>
    
      <div class="btn-group dropdown">
        <button id="actionsBtn" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown">
          <i class="bi bi-three-dots"></i>
        </button>
        <ul class="dropdown-menu dropdown-menu-end" role="menu" aria-labelledby="actionsBtn">
          <li role="menuitem" ng-if="$ctrl.showAction('recalculate')">
            <a href="" ng-click="$ctrl.recalculate()" class="dropdown-item" sxy-text="SALAXY.NG1.CalcUsecase.recalculate"></a>
          </li>
          <li role="menuitem"><a href="" ng-click="$ctrl.showReportDialog('salarySlip')" class="dropdown-item" sxy-text="SALAXY.NG1.CalcUsecase.reports" ps="..."></a></li>
          <li role="menuitem"><a href="" ng-click="$ctrl.showUsecaseInfo()" class="dropdown-item" sxy-text="SALAXY.NG1.CalcUsecase.usecase"></a></li>
          
          <li role="menuitem" ng-if="$ctrl.showAction('cancel')">
            <a href="" ng-click="$ctrl.cancel()" class="dropdown-item" sxy-text="SALAXY.NG1.CalcUsecase.cancelPayment"></a>
          </li>
          <li role="menuitem" ng-if="$ctrl.showAction('copyAsNew')">
            <a href="" ng-click="$ctrl.showCopyAsNew($ctrl.current)" class="dropdown-item" sxy-text="SALAXY.NG1.CalcUsecase.copy"></a>
          </li>
          <li role="menuitem" ng-if="$ctrl.showAction('showPaymentDialog')">
            <a href="" ng-click="$ctrl.showPaymentDialog()" class="dropdown-item" sxy-text="SALAXY.NG1.CalcUsecase.showPaymentInfo"></a>
          </li>

          <li role="menuitem" ng-if="$ctrl.showAction('delete')">
            <a href="" ng-click="$ctrl.delete()" ng-disabled="$ctrl.isActionDisabled('delete')" class="dropdown-item" sxy-text="SALAXY.NG1.CalcUsecase.deleteCalc"></a>
          </li>
          <li role="menuitem" style="margin: 5px 20px;">
            <salaxy-json-formatter key="'JSON Data'" json="$ctrl.current" open="2" type="dialog"></salaxy-json-formatter>
          </li>
        </ul>
      </div>
    </div>
  </div>
  
  <div class="worker-info-wrapper collapse" id="workerInfo">
    <button class="btn btn-transparent close-btn btn-sm" data-bs-toggle="collapse" data-bs-target="#workerInfo"><i class="bi bi-x-lg"></i></button>
    <salaxy-calc-worker-info model="$ctrl.current"></salaxy-calc-worker-info>
  </div>
  <div ng-if="$ctrl.usecases">
    <h2 sxy-text="SALAXY.NG1.CalcUsecase.selectCalculationType" class="mt-3"></h2>
    <div class="row g-4">
      <div class="col-sm-6 col-md-4" ng-repeat="usecase in $ctrl.usecases">
        <div class="card">
          <div class="text-center  card-pic-fixed clickable" style="height: 150px;position: relative;" ng-click="$ctrl.setUsecase(usecase.uri)">
            <img ng-if="usecase.data.icon[0] == 'h'" ng-src="{{usecase.data.icon}}">
            <div ng-if="usecase.data.icon[0] != 'h'" class="bg-primary card-pic-icon">
              <i class="fa" ng-class="(usecase.data.icon || 'fa') == 'fa' ? 'bi-currency-euro' : usecase.data.icon" aria-hidden="true"></i>
            </div>
            <span class="badge float-end bg-info" ng-if="usecase.status=='default'" sxy-text="SALAXY.NG1.CalcUsecase.default"></span>
            <salaxy-avatar avatar="usecase.ownerInfo.avatar" style="font-size: 2em; position: absolute; right: 10px; bottom: 10px"></salaxy-avatar>
          </div>
          <div class="card-body p-3">
            <h3 class="truncate">{{ usecase.shortText }}</h3>
            <p style="height: 80px;overflow: hidden">{{ usecase.data.description }}</p>
            <button type="button" class="btn btn-primary mb-2" ng-click="$ctrl.setUsecase(usecase.uri)" sxy-text="SALAXY.UI_Terms.select"></button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div ng-if="$ctrl.current && !$ctrl.usecases">
    
    <div ng-if="!$ctrl.usecase.defaultView" style="margin-top: 6px">
      <salaxy-calc model="$ctrl"></salaxy-calc>
    </div>
    <div ng-if="$ctrl.usecase.defaultView">
      <div ng-if="!$ctrl.current.worker.employmentId">
        <div class="row">
          <div class="col-12 col-sm-7">
            <div class="intro-text">
              <h1 sxy-text="SALAXY.NG1.CalcDetailsWorkerComponent.selectWorker"></h1>
              <p sxy-html="SALAXY.NG1.CalcDetailsWorkerComponent.myWorkers.description.html"></p>
            </div>
          </div>
          <div class="col-12 col-sm-5">
            <button type="button" class="btn add-new-worker btn-primary float-end-sm" style="margin-bottom:5px;" ng-click="$ctrl.showNewWorkerDialog()" sxy-text="SALAXY.NG1.CalcDetailsWorkerComponent.newWorker.cta"></button>
          </div>
          <div class="col-12">
            <div class="table-responsive">
              <salaxy-employment-list mode="select" on-list-select="$ctrl.updateFromEmployment(item.id, true)"></salaxy-employment-list>
            </div>
          </div>
        </div>
      </div>
      <div>
        
        <ng-include src="$ctrl.usecase.defaultView"></ng-include>
      </div>
    </div>
  </div>
</div>`), s.put("salaxy-components/calc/Calc.html", `<div class="salaxy-component salaxy-calc">
  <div class="salaxy-calc-overview" ng-if="!$ctrl.current">
    <salaxy-spinner ng-if="$ctrl.isLoading"></salaxy-spinner>
  </div>

  <!--salaxy-varma-banner calc="$ctrl.current" ng-if="('auth' | sxyIsInRole) && ('company' | sxyIsInRole) && $ctrl.current.workflow.status == 'draft'"></salaxy-varma-banner-->
  <div class="row" sxy-if-role="worker">
    <div class="col-12 mb-2" ng-if="$ctrl.current.workflow.status == 'draft' || $ctrl.current.id == null">
      <p class="lead text-center" sxy-text="SALAXY.NG1.CalcComponent.introWorker"></p>
    </div>
  </div>
  <div ng-if="!$ctrl.isReadOnly && $ctrl.current" class="btn-toolbar calc-toolbar w-100">
    <div class="btn-group" role="group" ng-if="!$ctrl.isReadOnly">
      <div ng-if="'company' | sxyIsInRole" ng-controller="CompanyAccountController as $company" style="padding: 8px;">
        <salaxy-workflow-badge ng-if="$company.current" mode="horizontal" model="$company.current" api-ctrl="$company" wf-types="'EmployerMessageRecord'"></salaxy-workflow-badge>
      </div>
    </div>
  </div>
  <div class="salaxy-calc-overview" ng-if="$ctrl.current">
    <div sxy-if-role="worker" class="visible-xxs">
      <div class="mb-2" ng-if="$ctrl.current.workflow.status == 'draft' || $ctrl.current.workflow.status == 'workerRequested' || $ctrl.current.workflow.status == 'workerRequestAccepted' || $ctrl.current.workflow.status == 'workerRequestDeclined' || $ctrl.current.workflow.status == 'paymentWorkerCopy'">
        <salaxy-calc-sharing-info model="$ctrl"></salaxy-calc-sharing-info>
      </div>
    </div>
    <div class="calc-container" style="display:block;">
      <div class="salaxy-calc-step-container step1" ng-class="{ 'active': $ctrl.calcSections.get('worker').isActive }">
        <div class="card overview-worker salaxy-calc-overview-card">
          <div class="card-header" ng-click="$ctrl.calcSections.toggleActive('worker')">
            <i class="bi bi-x-lg float-end close"></i> <span class="overview-title" sxy-text="SALAXY.NG1.CalcComponent.panelWorker.heading"></span>
          </div>
          <div class="card-body">
            <div class="content-overview" ng-click="$ctrl.calcSections.toggleActive('worker')">
              <div ng-if="!$ctrl.calcSections.get('worker').isSelectionDone">
                <a href="">
                  <h3 class="text-center" sxy-html="SALAXY.NG1.CalcComponent.panelWorker.overview.html"></h3>
                </a>
              </div>
              <div class="salaxy-calc-overview-worker h-100" ng-if="$ctrl.calcSections.get('worker').isSelectionDone">
                <salaxy-avatar ng-if="$ctrl.current.worker.avatar.displayName" avatar="$ctrl.current.worker.avatar"></salaxy-avatar>
                <strong>{{$ctrl.current.worker.avatar.displayName || ("SALAXY.NG1.CalcComponent.panelWorker.noSelection" | sxyTranslate) }}</strong><br />
                <div ng-if="!$ctrl.isReadOnly" ng-controller="EmploymentCrudController as $employment"
                  ng-init="$employment.queryResult={};$employment.getOData({ '$filter': 'id eq \\'' +  $ctrl.current.worker.employmentId + '\\''}, $employment.queryResult)">
                  <salaxy-workflow-badge mode="horizontal" ng-if="$employment.queryResult.items.length > 0" model="$employment.queryResult.items[0]" api-ctrl="$employment"
                    wf-types="'EmployerMessageRecord'"></salaxy-workflow-badge>
                </div>
                <div class="salaxy-calc-worker-info-texts" ng-if="$ctrl.current.worker.avatar.displayName">
                  <div class="text-danger" ng-if="$ctrl.taxUi.status == 'missing'">
                    {{ $ctrl.taxUi.shortText }}

                  </div>
                  <div ng-if="$ctrl.taxUi.status == 'ok'">{{ $ctrl.taxUi.shortText }}</div>
                  <div>{{ $ctrl.current.worker.paymentData.ibanNumber ? ('SALAXY.NG1.WorkerInfo.ibanOk'|sxyTranslate) : ('SALAXY.NG1.WorkerInfo.noIbanNumber' | sxyTranslate) }}
                  </div>
                  <div class="truncate">{{ $ctrl.current.info.occupationCode | sxyOccupation : "code-label" }}</div>
                  <div class="truncate">{{ $ctrl.getPensionText(true) }}</div>
                </div>
              </div>
            </div>
            <div class="content-details">
              <div ng-if="!$ctrl.isReadOnly" ng-controller="EmploymentCrudController as $employment" class="text-end" style="padding: 8px;"
                ng-init="$employment.queryResult={};$employment.getOData({ '$filter': 'id eq \\'' +  $ctrl.current.worker.employmentId + '\\''}, $employment.queryResult)">
                <salaxy-workflow-badge mode="horizontal" ng-if="$employment.queryResult.items.length > 0" model="$employment.queryResult.items[0]" api-ctrl="$employment"
                  wf-types="'EmployerMessageRecord'"></salaxy-workflow-badge>
              </div>
              <ng-include src="'salaxy-components/calc/details/worker.html'"></ng-include>
            </div>
          </div>
        </div>
      </div>
      <div ng-if="$ctrl.isHousehold" class="salaxy-calc-step-container step2" ng-class="{ 'active': $ctrl.calcSections.get('household-usecase').isActive }">
        <div class="card card-warning salaxy-calc-overview-card">
          <div class="card-header" ng-click="$ctrl.calcSections.toggleActive('household-usecase')">
            <i class="bi bi-x-lg float-end close"></i><span class="overview-title" sxy-text="SALAXY.NG1.CalcComponent.panelHouseHold.heading"></span>
          </div>
          <div class="card-body">
            <div class="content-overview" ng-click="$ctrl.calcSections.toggleActive('household-usecase')">
              <div ng-show="!$ctrl.calcSections.get('household-usecase').isSelectionDone">
                <a href="">
                  <h3 class="text-center" sxy-html="SALAXY.NG1.CalcComponent.panelHouseHold.overview.html"></h3>
                </a>
              </div>
              <div ng-show="$ctrl.calcSections.get('household-usecase').isSelectionDone">
                <div>{{ $ctrl.getUsecaseText() | sxyTranslate}}</div>
              </div>
            </div>
            <div class="content-details">
              <salaxy-calc-household-usecase ng-if="$ctrl.currentCalc" calc="$ctrl.currentCalc"></salaxy-calc-household-usecase>
            </div>
          </div>
        </div>
      </div>
      <div ng-if="!$ctrl.isHousehold" class="salaxy-calc-step-container step2" ng-class="{ 'active': $ctrl.calcSections.get('worktime').isActive }">
        <div class="card overview-worktime salaxy-calc-overview-card">
          <div class="card-header " ng-click="$ctrl.calcSections.toggleActive('worktime');$ctrl.worktimeCtrl.loadEmployment()">
            <i class="bi bi-x-lg float-end close"></i><span class="overview-title" sxy-text="SALAXY.NG1.CalcComponent.panelWorkTime.heading"></span>
          </div>
          <div class="card-body">
            <div class="content-overview" ng-click="$ctrl.calcSections.toggleActive('worktime');$ctrl.worktimeCtrl.loadEmployment()">
              <div ng-show="!$ctrl.calcSections.get('worktime').isSelectionDone">
                <a href="">
                  <h3 class="text-center" sxy-html="SALAXY.NG1.CalcComponent.panelWorkTime.overview.html"></h3>
                </a>
              </div>
              <div ng-show="$ctrl.calcSections.get('worktime').isSelectionDone">
                <div><strong>{{ $ctrl.getDatesRangeText() | sxyTranslate }}</strong></div>
                <table>
                  <tbody>
                    <tr>
                      <td sxy-text="SALAXY.NG1.CalcComponent.panelWorkTime.overview.salaryDate"></td>
                      <td class="right" ng-if="!$ctrl.currentCalc.workflow.requestedSalaryDate" sxy-text="SALAXY.NG1.CalcComponent.panelWorkTime.overview.now"></td>
                      <td class="right" ng-if="$ctrl.currentCalc.workflow.requestedSalaryDate">{{ $ctrl.currentCalc.workflow.salaryDate | sxyDate }}</td>
                    </tr>
                  </tbody>
                </table>
                <table>
                  <tbody>
                    <tr>
                      <td sxy-text="SALAXY.NG1.CalcComponent.panelWorkTime.overview.leavesDays"></td>
                      <td class="right">{{ $ctrl.calculatePeriodDays('leavesDays') | sxyCount : 'day' }}</td>
                    </tr>
                    <tr>
                      <td sxy-text="SALAXY.NG1.CalcComponent.panelWorkTime.overview.absencesDays"></td>
                      <td class="right">{{ $ctrl.calculatePeriodDays('absencesDays') | sxyCount : 'day' }}</td>
                    </tr>
                    <tr>
                      <td sxy-text="SALAXY.NG1.CalcComponent.panelWorkTime.overview.paidAbsencesDays"></td>
                      <td class="right">{{ $ctrl.calculatePeriodDays('paidAbsencesDays') | sxyCount : 'day' }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="content-details">
              <salaxy-calc-worktime ng-ref="$ctrl.worktimeCtrl" ng-if="$ctrl.currentCalc" calc="$ctrl.currentCalc"></salaxy-calc-worktime>
            </div>
          </div>
        </div>
      </div>
      <div class="salaxy-calc-step-container step3" ng-class="{ 'active': $ctrl.calcSections.get('salary').isActive }">
        <div class="card overview-salary salaxy-calc-overview-card">
          <div class="card-header" ng-click="$ctrl.calcSections.toggleActive('salary')">
            <i class="bi bi-x-lg float-end close"></i><span class="overview-title" sxy-text="SALAXY.NG1.CalcComponent.panelSalary.heading"></span>
          </div>
          <div class="card-body">
            <div class="content-overview" ng-click="$ctrl.calcSections.toggleActive('salary')">
              <table>
                <tbody>
                  <tr>
                    <td>
                      {{ $ctrl.calcLogic.hasCompensation ? ('SALAXY.NG1.CalcDetailsExpensesComponent.foreclosurePayment.infoCompensation' | sxyTranslate) :
                      ('SALAXY.NG1.CalcDetailsExpensesComponent.foreclosurePayment.infoSalary' | sxyTranslate) }}
                    </td>
                    <td class="right">{{$ctrl.currentCalc.result.totals.totalBaseSalary || 0 | currency : "" : 2}} €</td>
                  </tr>
                  <tr>
                    <td sxy-text="SALAXY.NG1.CalcDetailsExpensesComponent.titleAdditions"></td>
                    <td class="right">{{ ($ctrl.currentCalc.result.totals.totalGrossSalary - $ctrl.currentCalc.result.totals.totalBaseSalary) || 0 | currency : "" : 2}} €</td>
                  </tr>
                  <tr class="total">
                    <td sxy-text="SALAXY.NG1.GeneralCalcDetailLabels.total"></td>
                    <td class="right">{{$ctrl.currentCalc.result.totals.totalGrossSalary || 0 | currency : "" : 2}} €</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="content-details">
              <ng-include src="'salaxy-components/calc/details/salary.html'"></ng-include>
            </div>
          </div>
        </div>
      </div>
      <div class="salaxy-calc-step-container step4" ng-class="{ 'active': $ctrl.calcSections.get('expenses').isActive }">
        <div class="card overview-expenses salaxy-calc-overview-card">
          <div class="card-header" ng-click="$ctrl.calcSections.toggleActive('expenses')">
            <i class="bi bi-x-lg float-end close"></i> <span class="overview-title" sxy-text="SALAXY.NG1.CalcComponent.panelExpenses.heading"></span>
          </div>
          <div class="card-body">
            <div class="content-overview" ng-click="$ctrl.calcSections.toggleActive('expenses')">
              <table>
                <tbody>
                  <tr>
                    <td sxy-text="SALAXY.NG1.CalcDetailsExpensesComponent.compensations.title"></td>
                    <td class="right">{{ $ctrl.currentCalc.result.totals.totalExpenses || 0 | currency : '' : 2}}€</td>
                  </tr>
                  <tr>
                    <td sxy-text="SALAXY.NG1.CalcDetailsExpensesComponent.benefits.title"></td>
                    <td class="right">{{ $ctrl.currentCalc.result.workerCalc.benefits || 0 | currency : '' : 2}}€</td>
                  </tr>
                  <tr>
                    <td sxy-text="SALAXY.NG1.CalcDetailsExpensesComponent.deductions"></td>
                    <td class="right">{{ $ctrl.calcLogic.expensesTotal || 0 | currency : '' : 2}}€</td>
                  </tr>
                  <tr ng-if="$ctrl.isHousehold">
                    <td ng-if="$ctrl.calcLogic.childCareSubsidy">Yks. hoid. tuki</td>
                    <td ng-if="$ctrl.calcLogic.childCareSubsidy" class="right">{{ $ctrl.calcLogic.childCareSubsidy || 0 | currency : '' : 2}}€</td>
                    <td colspan="2" class="text-end" ng-if="!$ctrl.calcLogic.childCareSubsidy">
                      <small>{{ $ctrl.isHouseholdDeductible ? ("SALAXY.NG1.CalcComponent.panelExpenses.householdExpense" | sxyTranslate) :
                        ("SALAXY.NG1.CalcComponent.panelExpenses.noHouseholdExpenses" | sxyTranslate) }}</small>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="content-details">
              <ng-include src="'salaxy-components/calc/details/expenses.html'"></ng-include>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <salaxy-calc-new-intro model="$ctrl"></salaxy-calc-new-intro>
  <salaxy-calc-results model="$ctrl"></salaxy-calc-results>
</div>`), s.put("salaxy-components/calc/CalcChart.html", `<!-- <div class="d-none">{{$ctrl.refresh($ctrl.chart)}}</div> -->
<div ng-if="$ctrl.calc" ng-init="$ctrl.init()" class="salaxy-component salaxy-calc-chart chart-container w-100 d-flex justify-content-center" ng-class="'salaxy-calc-chart-' + $ctrl.role + 'salaxy-calc-chart-' + $ctrl.chartType">
  <canvas class="chart" ng-class="$ctrl.chartType ==='bar' ? 'chart-bar' : 'chart-pie'"></canvas>
</div>`), s.put("salaxy-components/calc/CalcCostAccounting.html", `<div class="salaxy-component salaxy-calc-cost-accounting">

  <div ng-if="$ctrl.isLegacy">

    <fieldset>
      <legend sxy-text="SALAXY.NG1.CalcCostAccountingComponent.title"></legend>
      <table class="table">
        <thead>
          <tr>
            <th>{{('SALAXY.NG1.CalcCostAccountingComponent.defaultLabel') | sxyTranslate}}</th>
            <th class="right">{{"SALAXY.NG1.CalcCostAccountingComponent.percent" | sxyTranslate}}</th>
            <th class="right">
              <button type="button" class="btn btn-primary btn-xs" ng-if="!$ctrl.isReadOnly" ng-click="$ctrl.costCenter.push({})" sxy-text="SALAXY.UI_Terms.addRow"></button>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="item in $ctrl.costCenter">
            <td>
              <salaxy-input-typeahead ng-if="$ctrl.getOptions('costCenter').length" ng-model="item.id" label-format="text-value" get-options="$ctrl.getOptions('costCenter')" name="{{ 'id' + $index }}" label-type="plain" read-only="$ctrl.isReadOnly"></salaxy-input-typeahead>
              <salaxy-input ng-if="!$ctrl.getOptions('costCenter').length" ng-model="item.id" name="{{ 'id' + $index }}" label-type="plain" read-only="$ctrl.isReadOnly">
              </salaxy-input>
            </td>
            <td>
              <salaxy-input-number ng-model="item.percent" name="{{ 'percent' + $index }}" label-type="plain" read-only="$ctrl.isReadOnly" unit="percent"></salaxy-input-number>
            </td>
            <td class="text-end">
              <button ng-if="!$ctrl.isReadOnly" type="button" class="btn btn-danger" ng-click="$ctrl.costCenter.splice($index, 1)">
                <i class="bi bi-trash" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}"></i>
              </button>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="total">
            <td>{{"SALAXY.UI_Terms.total" | sxyTranslate}}</td>
            <td class="right">{{ $ctrl.getLegacySum() | sxyCount : 'percent' }}</td>
            <td class="right"></td>
          </tr>
        </tfoot>
      </table>
    </fieldset>
  </div>

  <div ng-if="!$ctrl.isLegacy && ( $ctrl.calc.accounting.dimensions.length > 0 || $ctrl.definitions.length > 0 )">
    <salaxy-cost-accounting ng-init="$ctrl.calc.accounting = ($ctrl.calc.accounting  || $ctrl.isReadOnly) ? $ctrl.calc.accounting : { dimensions: []}" current="$ctrl.calc.accounting.dimensions" scope="calculation" dimensions="$ctrl.dimensions" read-only="$ctrl.isReadOnly"></salaxy-cost-accounting>
  </div>
  <div ng-if="!$ctrl.isLegacy && !( $ctrl.calc.accounting.dimensions.length > 0 || $ctrl.definitions.length > 0 )">
    <salaxy-input name="costCenter" ng-model="$ctrl.calc.info.costCenter" label="SALAXY.NG1.CalcDetailsWorkerComponent.costCenter" read-only="$ctrl.isReadOnly" input-mode="{{$ctrl.inputMode}}"></salaxy-input>
  </div>
</div>`), s.put("salaxy-components/calc/CalcDashboard.html", `<div class="salaxy-component salaxy-calc-dashboard">
  <div class="row">
    <div class="col-12 mb-4" ng-if="!$ctrl.hideButton">
      <salaxy-action-button action="'newCalc'" label="SALAXY.NG1.ActionButtonComponent.newCalculation"></salaxy-action-button>
    </div>
    <div class="col-12 col-sm-6">
      <salaxy-calc-list category="paid" mode="panel" limit-to="5" read-only="$ctrl.readOnly"></salaxy-calc-list>
    </div>
    <div class="col-12 col-sm-6">
      <salaxy-calc-list category="draft" mode="panel" limit-to="5" read-only="$ctrl.readOnly"></salaxy-calc-list>
    </div>
  </div>
</div>`), s.put("salaxy-components/calc/CalcEditor.html", `<div>
  <salaxy-validation-summary api-validation="$ctrl.validation"></salaxy-validation-summary>
</div>
<div style="margin-top:30px; margin-bottom:30px;">
  
  <h2 class="mb-2" sxy-text="SALAXY.NG1.CalcEditorComponent.title"></h2>
  <!-- spinning icon or similar?-->
  <button class="btn btn-primary btn-labeled-right" ng-click="$ctrl.saveEdited()"><span sxy-text="SALAXY.UI_Terms.save"></span><i class="bi bi-floppy"></i></button>
  <!-- spinning icon or similar?-->
  <button class="btn btn-default btn-labeled-right" ng-click="$ctrl.refresh()"><span sxy-text="SALAXY.UI_Terms.refresh"></span><i class="bi bi-arrow-repeat" ng-class="{'bi-spin' : $ctrl.loaders['default'] }"></i></button>

  <div class="float-end">Alkuperäinen: {{$ctrl.base.updatedAt | date: 'd.M.yyyy HH:mm:ss'}} <button class="btn btn-xs btn-default" ng-click="$ctrl.changeBase()">Vaihda...</button></div>
</div>
<div ng-if="$ctrl.current" class="salaxy-component salaxy-calc-editor">
  <div class="row">
    <div class="col-12 col-xl-6 " style="margin-top:20px;">
      <div class="row mb-2">
        <div class="col-md-6 col-12 calc-editor-worker-details mb-2">
          <legend>
            <span sxy-text="SALAXY.NG1.CalcEditorComponent.workerTitle"></span>
            <button ng-if="'admin' | sxyIsInRole" class="btn btn-xs btn-default float-end" ng-click="$ctrl.refresh('worker')" title="Päivitä työntekijän tiedot"><i class="" ng-class="$ctrl.loaders['worker']  ? 'bi bi-arrow-repeat bi-spin' : 'bi bi-upload'"></i></button>
            <a class="btn btn-xs btn-default float-end btn-details" href="#/employments/details/{{$ctrl.current.worker.employmentId}}" ng-click="$ctrl.isRightSidebarOpen = true" title="Tiedot / Muokkaa" style="margin-right:2px;"><i class="bi bi-info-circle-fill"></i></a>

          </legend>
          <div class="row">
            <div class="col-3">
              <div class="avatar-container">
                <salaxy-avatar class="avatar-sm" avatar="$ctrl.current.worker.avatar"></salaxy-avatar>
              </div>
            </div>
            <div class="col-9">
              <strong>{{$ctrl.current.worker.avatar.displayName}}</strong>
              <br>
              <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="socialSecurityNumber" ng-model="$ctrl.current.worker.paymentData.socialSecurityNumber"></salaxy-input>
              <div>&nbsp;</div>
              <br>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="firstName" ng-model="$ctrl.current.worker.avatar.firstName"></salaxy-input>
              <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="lastName" ng-model="$ctrl.current.worker.avatar.lastName"></salaxy-input>
              <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="ibanNumber" ng-model="$ctrl.current.worker.paymentData.ibanNumber" sxy-iban></salaxy-input>
              <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="email" ng-model="$ctrl.current.worker.contact.email" sxy-email></salaxy-input>
              <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="telephone" ng-model="$ctrl.current.worker.contact.telephone" sxy-mobile-phone></salaxy-input>
              <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="street" ng-model="$ctrl.current.worker.contact.street"></salaxy-input>
              <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="postalCode" ng-model="$ctrl.current.worker.contact.postalCode" sxy-postal-code-fi></salaxy-input>
              <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="city" ng-model="$ctrl.current.worker.contact.city"></salaxy-input>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-12 calc-editor-employer-details mb-2">
          <legend>
            <span sxy-text="SALAXY.NG1.CalcEditorComponent.employerTitle"></span>
            <button ng-if="'admin' | sxyIsInRole" class="btn btn-xs btn-default float-end" ng-click="$ctrl.refresh('employer')" title="Päivitä omat tiedot"><i class=""  ng-class="$ctrl.loaders['employer']  ? 'bi bi-arrow-repeat bi-spin' : 'bi bi-upload'"></i></button></legend>
          <div class="row">
            <div class="col-3">
              <div class="avatar-container">
                <salaxy-avatar class="avatar-sm" avatar="$ctrl.current.employer.avatar"></salaxy-avatar>
              </div>
            </div>
            <div class="col-9">
              <strong>{{$ctrl.current.employer.avatar.displayName}}</strong>
              <br>
              <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="employerOfficialId" ng-model="$ctrl.current.employer.officialId"></salaxy-input>
              <div>&nbsp;</div>
              <br>
            </div>
          </div>
          <div class="row">
            <div class="col-12">       
              <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="employerEmail" ng-model="$ctrl.current.employer.contact.email" sxy-email></salaxy-input>
              <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="employerTelephone" ng-model="$ctrl.current.employer.contact.telephone"></salaxy-input>
              <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="employerStreet" ng-model="$ctrl.current.employer.contact.street"></salaxy-input>
              <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="employerPostalCode" ng-model="$ctrl.current.employer.contact.postalCode"></salaxy-input>
              <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="employerCiy" ng-model="$ctrl.current.employer.contact.city"></salaxy-input>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-md-6 col-12 mb-2">
          <form class="form-horizontal" >
            <fieldset>
              <legend>
                <span sxy-text="Työsuhteen tiedot"></span>

                <button ng-if="'admin' | sxyIsInRole" class="btn btn-xs btn-default float-end" ng-click="$ctrl.refresh('employment')" title="Päivitä työsuhdetiedot"><i ng-class="$ctrl.loaders['employment']  ? 'bi bi-arrow-repeat bi-spin' : 'bi bi-upload'"></i></button>
                <a class="btn btn-xs btn-default float-end btn-details" href="#/employments/details/{{$ctrl.current.worker.employmentId}}#employment" ng-click="$ctrl.isRightSidebarOpen = true" title="Tiedot / Muokkaa" style="margin-right:2px;"><i class="bi bi-info-circle-fill"></i></a>
              </legend>
              <salaxy-input-enum input-mode="openClose"  enum="PensionCalculation" name="PensionCalculation" label="Sovellettava eläketurva" ng-model="$ctrl.current.result.responsibilities.pensionCalculation"></salaxy-input-enum>
              <salaxy-input-enum input-mode="openClose"  enum="PensionRule" name="PensionRule" label="Eläkemaksun laskentasääntö" ng-model="$ctrl.current.result.responsibilities.pensionRule"></salaxy-input-enum>
              <salaxy-input-enum input-mode="openClose"  enum="EmploymentRelationType" name="EmploymentRelationType" label="Työsuhde" ng-model="$ctrl.current.result.responsibilities.employmentType"></salaxy-input-enum>
              
              <salaxy-date-range input-mode="openClose" ng-model="$ctrl.current.worktime.employmentPeriod" label="Työsuhteen kesto" name="employmentPeriod"></salaxy-date-range>
              <salaxy-input-enum input-mode="openClose" ng-if="$ctrl.current.result.responsibilities.pensionCalculation == 'publicSector'"  type="select" name="employmentRegCodes" disable-cache="true"
        options="$ctrl.getEmploymentRegCodeOptions()" label="SALAXY.NG1.WorkerWizardComponent.employment.employmentRegCode" ng-model="$ctrl.current.result.responsibilities.employmentRegCode"></salaxy-input-enum>
              <salaxy-input-enum input-mode="openClose" enum="TaxcardKind" name="TaxcardKind" label="Työsuhteessa käytettävä verokortti" ng-model="$ctrl.current.result.responsibilities.employmentTaxcard"></salaxy-input-enum>
              <salaxy-input-enum input-mode="openClose" enum="EmploymentRelationSalaryPaymentMethod" name="SalaryPaymentMethod" label="Palkanmaksutapa" ng-model="$ctrl.current.result.responsibilities.salaryPaymentMethod"></salaxy-input-enum>
              <div ng-repeat="irIncomeEarnerType in $ctrl.current.result.responsibilities.irIncomeEarnerTypes">
                <salaxy-input-enum input-mode="openClose" enum="IncomeEarnerType" name="IncomeEarnerType" label="Tulonsaajan tyyppi" ng-model="irIncomeEarnerType"></salaxy-input-enum>
              </div>

              <salaxy-input-occupation-type name="occupationCode" ng-model="$ctrl.current.info.occupationCode" label="Ammattiluokka vakuutukseen" read-only="false">
              </salaxy-input-occupation-type>
              <salaxy-input tooltip-html="&lt;a target=&#39;_blank&#39; href=&#39;https://www.keva.fi/tyonantajalle/elakemaksut/ammattinimikkeiden-haku/&#39;&gt;Info&lt;/a&gt;" ng-if="$ctrl.current.result.responsibilities.pensionCalculation == 'publicSector'"  input-mode="openClose" name="occupationCode2" ng-model="$ctrl.current.info.occupationCode2" label="Keva:n ammattiluokka" read-only="false">
              </salaxy-input>

            </fieldset>
          </form>
        </div>
      
        <div class="col-md-6 col-12 mb-2">
          <form class="form-horizontal" ng-readonly="true">
            <fieldset>
              <legend>
                <span sxy-text="Verokortin tiedot"></span>
                <button ng-if="'admin' | sxyIsInRole" class="btn btn-xs btn-default float-end" ng-click="$ctrl.refresh('taxcard')" title="Päivitä verokortti"><i  ng-class="$ctrl.loaders['taxcard']  ? 'bi bi-arrow-repeat bi-spin' : 'bi bi-upload'"></i></button>
                <a ng-if="'admin' | sxyIsInRole" class="btn btn-xs btn-default float-end btn-details" href="#/employments/details/{{$ctrl.current.worker.employmentId}}#taxcards" ng-click="$ctrl.isRightSidebarOpen = true" title="Tiedot / Muokkaa" style="margin-right:2px;"><i class="bi bi-info-circle-fill"></i></a>
              </legend>

              <salaxy-input-enum enum="TaxcardKind" name="TaxcardKind" label="Verokortti" ng-model="$ctrl.current.worker.tax.snapshot.kind"></salaxy-input-enum>
              <salaxy-input name="forYear" label="Vuodelle" ng-model="$ctrl.current.worker.tax.snapshot.forYear"></salaxy-input>
           
              <salaxy-form-group name="validity" class="salaxy-read-only" label="Voimassa">
                <div class="form-control-plaintext">
                  {{$ctrl.current.worker.tax.snapshot.validity.start | date}} - {{$ctrl.current.worker.tax.snapshot.validity.end | date}}
                </div>
              </salaxy-form-group>
              <salaxy-input label="veroprosentti" name="Veroprosentti" unit="percent" ng-model="$ctrl.current.worker.tax.snapshot.taxPercent" require="true"></salaxy-input>
              <salaxy-input-number label="Tuloraja" name="tuloraja" unit="euro" ng-model="$ctrl.current.worker.tax.snapshot.incomeLimit" maxlength="10"></salaxy-input-number>
              <salaxy-input label="Lisäveroprosentti" name="lisaveroprosentti" unit="percent" ng-model="$ctrl.current.worker.tax.snapshot.taxPercent2"></salaxy-input>
              <!--for admin, should be nullable-->
              <salaxy-input-number input-mode="openClose" name="fixedTaxAmount" ng-model="$ctrl.current.worker.tax.fixedTaxAmount" label="Kiinteä ennakonpidätyksen määrä" read-only="'!admin' | sxyIsInRole"></salaxy-input-number>
            </fieldset>
          </form>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-md-6 col-12 mb-2">
          <form class="form-horizontal">
            <fieldset>
              <legend>
                <span sxy-text="Vero, eläke- ja vakuutustiedot"></span>
                <button ng-if="'admin' | sxyIsInRole" class="btn btn-xs btn-default float-end" ng-click="$ctrl.refresh('insurances')" title="Päivitä vakuutustiedot"><i  ng-class="$ctrl.loaders['insurances']  ? 'bi bi-arrow-repeat bi-spin' : 'bi bi-upload'"></i></button>

                <a ng-if="'admin' | sxyIsInRole" class="btn btn-xs btn-default float-end btn-details" href="#/settings/pro-settings" title="Katso / Muokkaa" ng-click="$ctrl.isRightSidebarOpen = true" style="margin-right:2px;"><i class="bi bi-info-circle-fill"></i></a>

              </legend>

              <salaxy-input-boolean input-mode="openClose" label="Hoidan ennakonpidätyksen maksun itse" name="taxAndSocialSecuritySelfPayment" ng-model="$ctrl.current.result.responsibilities.taxAndSocialSecuritySelfPayment"></salaxy-input-boolean>
              
              <salaxy-input-enum input-mode="openClose" label="Työeläkeyhtiö" enum="PensionCompany" name="PensionCompany" ng-model="$ctrl.current.result.responsibilities.pensionCompany"></salaxy-input-enum>
              <salaxy-input input-mode="openClose" label="Sopimusnumero" name="PensionContractNumber" ng-model="$ctrl.current.result.responsibilities.pensionContractNumber" sxy-pension-contract-number></salaxy-input>
              <salaxy-input ng-if="$ctrl.current.result.responsibilities.pensionCalculation == 'publicSector'" input-mode="openClose" label="SALAXY.MODEL.PensionContract.subOrgCode.title" name="SubOrgCode" ng-model="$ctrl.current.result.responsibilities.subOrgCode"></salaxy-input>
              <salaxy-input-number input-mode="openClose" ng-model="$ctrl.current.result.responsibilities.pensionPercent" unit="percent" name="PensionPercent" label="SALAXY.MODEL.PensionContract.pensionPercent.title"></salaxy-input-number>
              <salaxy-input-number input-mode="openClose" ng-model="$ctrl.current.result.responsibilities.pensionDiscountPercent" unit="percent" name="PensionDiscount" label="SALAXY.MODEL.PensionContract.pensionDiscountPercent.title"></salaxy-input-number>
              <salaxy-input-boolean input-mode="openClose" ng-model="$ctrl.current.result.responsibilities.pensionSelfPayment" name="pensionSelfPayment" label="Hoitaa TyEl-maksut itse"></salaxy-input-boolean>

              <salaxy-input-enum input-mode="openClose" ng-model="$ctrl.current.result.responsibilities.insuranceCompany" label="Vakuutusyhtiö" enum="InsuranceCompany" name="InsuranceCompany"></salaxy-input-enum>
              <salaxy-input input-mode="openClose" ng-model="$ctrl.current.result.responsibilities.insuranceContractNumber" name="insuranceContractNumber" label="SALAXY.MODEL.InsuranceContract.contractNumber.title"></salaxy-input>
              <salaxy-input-number input-mode="openClose" label-cols="col-sm-6" ng-model="$ctrl.current.result.responsibilities.insurancePercent" label="Tapaturm.vak.maksun arvio-%" unit="percent" name="insurancePercent"></salaxy-input-number>
              <salaxy-input-number input-mode="openClose" label-cols="col-sm-6" ng-model="$ctrl.current.result.responsibilities.groupLifeInsurancePercent" label="SALAXY.MODEL.InsuranceContract.groupLifeInsurancePercent.title" unit="percent" name="groupLifeInsurancePercent"></salaxy-input-number>
              
              <salaxy-input-boolean input-mode="openClose" read-only="true" label-cols="col-sm-6" ng-model="$ctrl.current.result.responsibilities.unemploymentSelfPayment" name="unemploymentSelfPayment" label="Hoitaa työt.vak.maksut itse"></salaxy-input-boolean>
              <salaxy-input-enum input-mode="openClose" ng-model="$ctrl.current.result.responsibilities.unemploymentPayrollLimitStatus" label="Työt.vak.maksun palkkasummaraja" enum="UnemploymentPayrollLimitStatus" name="unemploymentPayrollLimitStatus">
              </salaxy-input-enum>

            </fieldset>
          </form>
        </div>
        <div class="col-md-6 col-12 calc-editor-payment-details mb-2">
          <!-- todo fix readOnly-->
          <form class="form-horizontal">
            <legend sxy-text="Palkanmaksu"></legend>
            <salaxy-input-boolean input-mode="openClose"  label="Hoitaa nettopalkan maksun itse" name="WorkerSelfPayment" ng-model="$ctrl.current.result.responsibilities.workerSelfPayment"></salaxy-input-boolean>
            <salaxy-input-enum  input-mode="openClose"  ng-model="$ctrl.current.workflow.salaryDateKind" name="salaryDateKind" enum="SalaryDateKind"  label="SALAXY.MODEL.CalcWorkflow.salaryDateKind.title"></salaxy-input-enum>
            <salaxy-datepicker-popup input-mode="openClose" name="salaryDate" ng-model="$ctrl.current.workflow.salaryDate" label="SALAXY.NG1.CalcEditorComponent.paymentInfo.salaryDateLabel"></salaxy-datepicker-popup>
            <salaxy-datepicker-popup input-mode="openClose" name="salaryPaidAt" ng-model="$ctrl.current.workflow.paidAt" label="SALAXY.NG1.CalcEditorComponent.paymentInfo.paymentDateLabel"></salaxy-datepicker-popup>  
            <salaxy-date-range input-mode="openClose" ng-model="$ctrl.dateRange" class="condensed" name="dateRange" on-change="$ctrl.dateRangeChange()" label="SALAXY.CORE.CalcWorktime.salaryPeriod" label-days-count="SALAXY.MODEL.CalcWorktime.workDays.title"></salaxy-date-range>            
            <salaxy-input-enum  input-mode="openClose"  ng-model="$ctrl.current.pricingModel" name="pricingModel" enum="PricingModel"  label="SALAXY.MODEL.ServiceModelPricing.pricingModel.title"></salaxy-input-enum>
            <salaxy-input-number input-mode="openClose" name="fixedFee" ng-model="$ctrl.current.fixedFee" label="SALAXY.MODEL.ServiceModelPricing.fixedFee.title"></salaxy-input-number>
            <salaxy-input-number input-mode="openClose" read-only="true" label="Maksu Palkkaus.fi-palvelulle" name="palkkausFee" ng-model="$ctrl.current.result.employerCalc.palkkaus" sxy-currency></salaxy-input-number>
            <salaxy-input-enum ng-if="'admin' | sxyIsInRole"  input-mode="openClose"  ng-model="$ctrl.current.info.paymentChannel" name="paymentChannel" enum="PaymentChannel"  label="SALAXY.NG1.CalcEditorComponent.paymentInfo.paymentChannel"></salaxy-input-enum>
          </form>
        </div>
      </div>

      <div class="row mb-2">
        <div class="col-md-6 col-12 mb-2">
          <form class="form-horizontal" ng-readonly="true">
            <fieldset>
              <legend sxy-text="SALAXY.NG1.CalcEditorComponent.messages.title"></legend>

              <salaxy-input input-mode="openClose" read-only="false" name="workDescription" ng-model="$ctrl.current.info.workDescription" label="SALAXY.NG1.CalcEditorComponent.messages.workDescriptionLabel"></salaxy-input>
              <salaxy-textarea input-mode="openClose" read-only="false" name="salarySlipMessage" ng-model="$ctrl.current.info.salarySlipMessage" label="SALAXY.NG1.CalcEditorComponent.messages.salarySlipMessageLabel"></salaxy-textarea>
            </fieldset>
          </form>
        </div>
        <div class="col-md-6 col-12" sxy-if-role="company">
          <div class="form-horizontal">
            <salaxy-calc-cost-accounting read-only="false" input-mode="openClose" calc="$ctrl.current"></salaxy-calc-cost-accounting>
          </div>
        </div>
        <div class="col-6" sxy-if-role="person">
          <legend sxy-text="SALAXY.NG1.CalcEditorComponent.householdDeduction.title"></legend>
          <div class="row form-horizontal">
            <div class="col-6">
              <salaxy-input-boolean type="checkbox" name="isHouseholdDeductible" ng-model="$ctrl.current.usecase.data.isHouseholdDeductible" label-type="no-label" />
            </div>
            <div class="col-6">
              <div ng-if="!$ctrl.current.usecase.data.isHouseholdDeductible" class="text-danger" style="padding-top:7px;" sxy-text="SALAXY.NG1.CalcEditorComponent.householdDeduction.noDeduction"></div>
              <div ng-if="$ctrl.current.usecase.data.isHouseholdDeductible">
                <select class="form-select" ng-model="$ctrl.current.usecase.data.taxDeductionCategories">
                  <option hidden value="" sxy-text="SALAXY.NG1.CalcEditorComponent.householdDeduction.deductionCategory.select"></option>
                  <option value="none" sxy-text="SALAXY.NG1.CalcEditorComponent.householdDeduction.deductionCategory.none"></option>
                  <option value="householdwork" sxy-text="SALAXY.NG1.CalcEditorComponent.householdDeduction.deductionCategory.householdwork"></option>
                  <option value="carework" sxy-text="SALAXY.NG1.CalcEditorComponent.householdDeduction.deductionCategory.carework"></option>
                  <option value="homeImprovement" sxy-text="SALAXY.NG1.CalcEditorComponent.householdDeduction.deductionCategory.homeImprovement"></option>
                  <option value="oilHeatingReplacementWork" sxy-text="SALAXY.NG1.CalcEditorComponent.householdDeduction.deductionCategory.oilHeatingReplacementWork"></option>
                </select>
              </div>
              <div ng-if="$ctrl.current.usecase.data.isHouseholdDeductible">
                <select class="form-select" ng-model="$ctrl.current.usecase.data.taxDeductionProperty">
                  <option hidden value="" sxy-text="SALAXY.NG1.CalcEditorComponent.householdDeduction.deductionProperty.select"></option>
                  <option value="none" sxy-text="SALAXY.NG1.CalcEditorComponent.householdDeduction.deductionProperty.none"></option>
                  <option value="ownProperty" sxy-text="SALAXY.NG1.CalcEditorComponent.householdDeduction.deductionProperty.ownProperty"></option>
                  <option value="relativesProperty" sxy-text="SALAXY.NG1.CalcEditorComponent.householdDeduction.deductionProperty.relativesProperty"></option>
                </select>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="row calc-editor-calc-rows">
        <div class="col-12">
          <fieldset>

            <legend sxy-text="SALAXY.NG1.CalcEditorComponent.calcRowsTitle"></legend>
            <salaxy-calc-rows-2019-editor parent="$ctrl.current" mode="edit" show-gross-totals="false">
            </salaxy-calc-rows-2019-editor>
          </fieldset>
        </div>
      </div>
    </div>
    <div class="col-12 col-xl-6">
      <salaxy-tab-buttons
        current-tab="$ctrl.currentTab"
        options="[
          { value: 'edited', text: 'SALAXY.NG1.CalcEditorComponent.editedHeading' },
          { value: 'default', text: 'SALAXY.NG1.CalcEditorComponent.originalHeading' },
          { value: 'paymentreport', text: 'SALAXY.NG1.CalcEditorComponent.diffHeading' },
          { value: 'accounting', text: 'SALAXY.NG1.CalcEditorComponent.diffAccountingHeading' },
          { value: 'cfa', text: 'SALAXY.NG1.CalcEditorComponent.diffCfa', hidden: !('admin' | sxyIsInRole) },
          { value: 'documentflow', text: 'Laskut ja ilmoitukset' }
        ]"
        tabs-id="calcEditor">
      </salaxy-tab-buttons>
      <div class="tab-content" id="tab-content-calcEditor">
        <div class="tab-pane" id="edited-tab">
          <salaxy-calc-reports calcs="[$ctrl.current]" report-type="'salarySlip'"></salaxy-calc-reports>
        </div>
        <div class="tab-pane" id="default-tab">
          <salaxy-calc-reports calcs="[$ctrl.base]" report-type="'salarySlip'"></salaxy-calc-reports>
        </div>
        <div class="tab-pane" id="paymentreport-tab">
          <div class="payroll-report payroll-report-partial-container">
            <salaxy-calc-report calc="$ctrl.diffCalc" report-type="'paymentReport'" template-name="'paymentTablesV2'" apply-site-styles="true">
          </div>
        </div>
        <div class="tab-pane" id="accounting-tab">
          <salaxy-accounting-report-tools any-expanded="$reportRows.anyExpanded" on-expand-change="$reportRows.expand(close)" on-target-change="$ctrl.loadAccountingDiffData(targetId)" reader="$ctrl.accountingDiffDataReader"></salaxy-accounting-report-tools>
          <salaxy-accounting-report-rows ng-ref="$reportRows" data="$ctrl.accountingDiffData"></salaxy-accounting-report-rows>
        </div>
        <div class="tab-pane" id="cfa-tab" ng-if="'admin' | sxyIsInRole">
          <fieldset>
            <legend>
              <span sxy-text="Asiakasmaksut"></span>
            </legend>
          </fieldset>
          <table class="table">
            <tr>
              <th>Erä</th>
              <th class="text-right">Nykyinen summa</th>
              <th class="text-right">Laskettu summa</th>
              <th class="text-right">Laskettu ero</th>
              <th class="text-right">Tallennettava summa</th>
              <th class="text-right">Tallennettava ero</th>
            </tr>
            <tr>
              <td>Nettopalkka</td>
              <td class="text-right">{{ $ctrl.base.cfa ? ($ctrl.base.cfa.net  | currency) : " - "}}</td>
              <td class="text-right">{{ ($ctrl.current.result.workerCalc.totalWorkerPayment - $ctrl.current.result.employerCalc.deductionWorkerSelfPayment) | currency}}</td>
              <td class="text-right">{{ (($ctrl.current.result.workerCalc.totalWorkerPayment - $ctrl.current.result.employerCalc.deductionWorkerSelfPayment) - ($ctrl.base.cfa ? $ctrl.base.cfa.net  : 0)) | currency }}</td>
              <td class="text-right">{{ $ctrl.current.cfa ? ($ctrl.current.cfa.net  | currency) : " - "}}</td>
              <td class="text-right">{{ $ctrl.current.cfa ? ( ($ctrl.current.cfa.net - $ctrl.base.cfa.net) | currency) : " - "}}</td>
            </tr>
            <tr>
              <td>Eläke</td>
              <td class="text-right">{{ $ctrl.base.cfa ? ($ctrl.base.cfa.pension  | currency) : " - "}}</td>
              <td class="text-right">{{ ($ctrl.current.result.totals.pension - $ctrl.current.result.employerCalc.deductionPensionSelfPayment) | currency}}</td>
              <td class="text-right">{{ (($ctrl.current.result.totals.pension - $ctrl.current.result.employerCalc.deductionPensionSelfPayment) - ($ctrl.base.cfa ? $ctrl.base.cfa.pension  : 0)) | currency }}</td>
              <td class="text-right">{{ $ctrl.current.cfa ? ($ctrl.current.cfa.pension  | currency) : " - "}}</td>
              <td class="text-right">{{ $ctrl.current.cfa ? ( ($ctrl.current.cfa.pension - $ctrl.base.cfa.pension) | currency) : " - "}}</td>
            </tr>
            <tr>
              <td>Vero</td>
              <td class="text-right">{{ $ctrl.base.cfa ? ($ctrl.base.cfa.tax  | currency) : " - "}}</td>
              <td class="text-right">{{ ($ctrl.current.result.workerCalc.tax + $ctrl.current.result.employerCalc.socialSecurity + $ctrl.current.result.workerCalc.taxAtSource +  $ctrl.current.result.workerCalc.socialSecurity - $ctrl.current.result.employerCalc.deductionTaxAndSocialSecuritySelfPayment) | currency}}</td>
              <td class="text-right">{{ (($ctrl.current.result.workerCalc.tax + $ctrl.current.result.employerCalc.socialSecurity + $ctrl.current.result.workerCalc.taxAtSource +  $ctrl.current.result.workerCalc.socialSecurity - $ctrl.current.result.employerCalc.deductionTaxAndSocialSecuritySelfPayment) - ($ctrl.base.cfa ? $ctrl.base.cfa.tax  : 0)) | currency }}</td>
              <td class="text-right">{{ $ctrl.current.cfa ? ($ctrl.current.cfa.tax  | currency) : " - "}}</td>
              <td class="text-right">{{ $ctrl.current.cfa ? ( ($ctrl.current.cfa.tax - $ctrl.base.cfa.tax) | currency) : " - "}}</td>
            </tr>
            <tr>
              <td>Palvelumaksu</td>
              <td class="text-right">{{ $ctrl.base.cfa ? ($ctrl.base.cfa.service  | currency) : " - "}}</td>
              <td class="text-right">{{ ($ctrl.current.result.employerCalc.service) | currency}}</td>
              <td class="text-right">{{ (($ctrl.current.result.employerCalc.service) - ($ctrl.base.cfa ? $ctrl.base.cfa.service  : 0)) | currency }}</td>
              <td class="text-right">{{ $ctrl.current.cfa ? ($ctrl.current.cfa.service  | currency) : " - "}}</td>
              <td class="text-right">{{ $ctrl.current.cfa ? ( ($ctrl.current.cfa.service - $ctrl.base.cfa.service) | currency) : " - "}}</td>
            </tr>
            <tr>
              <td>Palkkio</td>
              <td class="text-right">{{ $ctrl.base.cfa ? ($ctrl.base.cfa.fee  | currency) : " - "}}</td>
              <td class="text-right">{{ ($ctrl.current.result.employerCalc.palkkaus) | currency}}</td>
              <td class="text-right">{{ (($ctrl.current.result.employerCalc.palkkaus) - ($ctrl.base.cfa ? $ctrl.base.cfa.fee  : 0)) | currency }}</td>
              <td class="text-right">{{ $ctrl.current.cfa ? ($ctrl.current.cfa.fee  | currency) : " - "}}</td>
              <td class="text-right">{{ $ctrl.current.cfa ? ( ($ctrl.current.cfa.fee - $ctrl.base.cfa.fee) | currency) : " - "}}</td>
            </tr>
            <tr class="total">
              <td>Yhteensä</td>
              <td class="text-right">{{ $ctrl.base.cfa ? ($ctrl.base.cfa.total  | currency) : " - "}}</td>
              <td class="text-right">{{ (
                $ctrl.current.result.workerCalc.totalWorkerPayment - $ctrl.current.result.employerCalc.deductionWorkerSelfPayment +
                $ctrl.current.result.totals.pension - $ctrl.current.result.employerCalc.deductionPensionSelfPayment +
                $ctrl.current.result.workerCalc.tax + $ctrl.current.result.employerCalc.socialSecurity + $ctrl.current.result.workerCalc.taxAtSource +  $ctrl.current.result.workerCalc.socialSecurity - $ctrl.current.result.employerCalc.deductionTaxAndSocialSecuritySelfPayment +
                $ctrl.current.result.employerCalc.service +
                $ctrl.current.result.employerCalc.palkkaus
                ) | currency}}</td>
              <td class="text-right">{{ ((
                $ctrl.current.result.workerCalc.totalWorkerPayment - $ctrl.current.result.employerCalc.deductionWorkerSelfPayment +
                $ctrl.current.result.totals.pension - $ctrl.current.result.employerCalc.deductionPensionSelfPayment +
                $ctrl.current.result.workerCalc.tax + $ctrl.current.result.employerCalc.socialSecurity + $ctrl.current.result.workerCalc.taxAtSource +  $ctrl.current.result.workerCalc.socialSecurity - $ctrl.current.result.employerCalc.deductionTaxAndSocialSecuritySelfPayment +
                $ctrl.current.result.employerCalc.service +
                $ctrl.current.result.employerCalc.palkkaus
                ) - ($ctrl.base.cfa ? $ctrl.base.cfa.total  : 0)) | currency }}</td>
              <td class="text-right">{{ $ctrl.current.cfa ? ($ctrl.current.cfa.total  | currency) : " - "}}</td>
              <td class="text-right">{{ $ctrl.current.cfa ? ( ($ctrl.current.cfa.total - $ctrl.base.cfa.total) | currency) : " - "}}</td>
            </tr>
          </table>
        </div>
        <div class="tab-pane" id="documentflow-tab">
          <div ng-if="$ctrl.documentFlow.children">
            <table class="table table-striped">
              <tr ng-repeat="doc in $ctrl.documentFlow.children">
                <td>
                  <salaxy-avatar ng-if="doc.item.type != 'payerSummary' && doc.item.type != 'payrollDetails'" class="salaxy-calc-row-type-avatar" avatar="doc.item.otherPartyInfo.avatar"></salaxy-avatar>
                  <salaxy-avatar ng-if="doc.item.type == 'payerSummary' || doc.item.type == 'payrollDetails'" class="salaxy-calc-row-type-avatar" avatar="doc.item.ownerInfo.avatar"></salaxy-avatar>
                </td>
                <td class="middle">
                  <strong ng-if="doc.item.type == 'invoice'">{{doc.item.shortText}}</strong>
                  <strong ng-if="doc.item.type == 'earningsPayment'">{{'Palkkatietoilmoitus' |sxyTranslate}}</strong>
                  <strong ng-if="doc.item.type == 'payrollDetails'">{{'Palkkalista' |sxyTranslate}}</strong>
                  <strong ng-if="doc.item.type == 'payerSummary'">{{'Erillisilmoitus' |sxyTranslate}}</strong>
                  <strong ng-if="doc.item.type == 'taxcard'">{{'Verokortti' |sxyTranslate}}</strong>
                </td>
                <td>
                  <a ng-if="doc.item.type == 'earningsPayment'" class="btn btn-default btn-sm" ng-href="#/irepr/details/{{doc.item.id}}">Näytä</a>
                  <a ng-if="doc.item.type == 'invoice'" class="btn btn-default btn-sm" ng-href="#/invoices/details/{{doc.item.id}}">
                    {{ 'SALAXY.UI_Terms.show' | sxyTranslate}}</a>
                  <a ng-if="doc.item.type == 'payerSummary'" class="btn btn-default btn-sm" ng-href="#/irpsr/details/{{doc.item.id}}">Näytä</a>
                  <a ng-if="doc.item.type == 'payrollDetails'" class="btn btn-default btn-sm" ng-href="#/payroll/details/{{doc.item.id}}">Näytä</a>
                  <a ng-if="doc.item.type == 'taxcard'" class="btn btn-default btn-sm" ng-href="#/taxcards/details/{{doc.item.id}}">Näytä</a>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div ng-if="'admin' | sxyIsInRole" class="right-sidebar"  ng-class="{'is-open' : $ctrl.isRightSidebarOpen}">
      <button class="btn btn-transparent custom-close" ng-click="$ctrl.isRightSidebarOpen = false">
        <i class="bi bi-x-lg"></i>
      </button>
      <div ng-view></div>
    </div>
  </div>
 
</div>`), s.put("salaxy-components/calc/CalcLeaves.html", `<div class="row">
  <div class="col-12">
    <p class="lead" sxy-text="SALAXY.NG1.CalcWorktimeComponent.lists.details.lead"></p>
  </div>
</div>
<div class="row">
  <div class="col-sm-12">
    <table class="table table-sm">
      <thead>
        <th></th>
        <th class="right" sxy-text="SALAXY.NG1.CalcWorktimeComponent.lists.annualLeaves.holidaySalariesAndCompensations"></th>
        <th ng-if="$ctrl.logic.worktime.holidaySpec.bonusMethod != 'none'" class="right" sxy-text="SALAXY.NG1.CalcWorktimeComponent.lists.annualLeaves.bonuses"></th>
      </thead>
      <tbody>
        <tr>
          <td sxy-text="SALAXY.NG1.CalcWorktimeComponent.lists.annualLeaves.accrualRemaining"></td>
          <td class="right">{{$ctrl.worktime.holidayPayAccrualRemaining}}</td>
          <td ng-if="$ctrl.logic.worktime.holidaySpec.bonusMethod != 'none'" class="right">{{$ctrl.worktime.holidayBonusAccrualRemaining}}</td>
        </tr>
        <tr> 
          <td sxy-text="SALAXY.NG1.CalcWorktimeComponent.lists.annualLeaves.paidInThisSalary"></td>
          <td class="right">{{$ctrl.getAccrualRemaningsToBePaid('holidayPay')}}</td>
          <td ng-if="$ctrl.logic.worktime.holidaySpec.bonusMethod != 'none'" class="right">{{$ctrl.getAccrualRemaningsToBePaid('holidayBonus')}}</td>
        </tr>
        <tr>
          <td sxy-text="SALAXY.NG1.CalcWorktimeComponent.lists.annualLeaves.newAccrualRemaining"></td>
          <td class="right">{{$ctrl.worktime.holidayPayAccrualRemaining - $ctrl.getAccrualRemaningsToBePaid('holidayPay')}}</td>
          <td ng-if="$ctrl.logic.worktime.holidaySpec.bonusMethod != 'none'" class="right">{{$ctrl.worktime.holidayBonusAccrualRemaining - $ctrl.getAccrualRemaningsToBePaid('holidayBonus')}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="row">
  <div class="col-sm-6">
    <h4 sxy-text="SALAXY.NG1.CalcWorktimeComponent.lists.annualLeaves.paidInThisSalary"></h4>
    <table class="table table-sm" ng-if="$ctrl.annualLeavestoBePaid.length">
      <thead>
        <tr>
          <th width="60%" sxy-text="SALAXY.NG1.CalcWorktimeComponent.lists.annualLeaves.holidayPeriod"></th>
          <th class="right" sxy-text="SALAXY.NG1.CalcWorktimeComponent.lists.annualLeaves.days"></th>
          <th ng-if="$ctrl.logic.worktime.holidaySpec.bonusMethod != 'none'" class="right" sxy-text="SALAXY.NG1.CalcWorktimeComponent.lists.annualLeaves.bonusDays"></th>
          <th></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.annualLeavestoBePaid">
          <td width="60%">
            {{row.period | sxyDateRange}}
          </td>
          <td class="right">
            <salaxy-input-number name="daysCount" ng-model="row.period.daysCount" label-type="plain"></salaxy-input-number>
          </td>
          <td ng-if="$ctrl.logic.worktime.holidaySpec.bonusMethod != 'none'" class="right">
            <salaxy-input-number name="bonusDaysCount" ng-model="row.bonusDaysCount" label-type="plain"></salaxy-input-number>
          </td>
          <td>
            <button type="button" class="btn btn-default" ng-click="$ctrl.showEditDialog(row)">
              <span><i class="bi bi-calendar3"></i></span>
            </button>
          </td>
          <td>
            <button type="button" class="delete btn btn-danger" ng-click="$ctrl.moveItem(row, 'annualLeavesWaitingForPayment')">
              <span></span><i class="bi bi-trash-fill"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="col-sm-6">
    <h4 sxy-text="SALAXY.NG1.CalcWorktimeComponent.lists.annualLeaves.plannedHolidays"></h4>
    <table class="table table-sm" ng-if="$ctrl.annualLeavesWaitingForPayment.length">
      <thead>
        <tr>
          <th width="40%" sxy-text="SALAXY.NG1.CalcWorktimeComponent.lists.annualLeaves.startDate"></th>
          <th width="40%" sxy-text="SALAXY.NG1.CalcWorktimeComponent.lists.annualLeaves.endDate"></th>
          <th class="right" sxy-text="SALAXY.NG1.CalcWorktimeComponent.lists.annualLeaves.days"></th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.annualLeavesWaitingForPayment" ng-style="$ctrl.getDisabledStyle(row)">
          <td width="40%">
            <span>{{row.period.start | sxyDate}}</span>
          </td>
          <td width="40%">
            <span>{{row.period.end | sxyDate}}</span>
          </td>
          <td class="right">
            <span>{{row.period.daysCount}}</span>
          </td>
          <td>
            <button type="button" class="btn btn-primary" ng-click="$ctrl.moveItem(row,'annualLeavestoBePaid')" ng-disabled="$ctrl.isSelectedToBePaid(row)" sxy-text="SALAXY.UI_Terms.select">
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="row">
  <div class="col-sm-6">
    <h4 sxy-text="SALAXY.NG1.CalcWorktimeComponent.lists.absencePeriods.absencesToUse"></h4>
    <table class="table table-sm" ng-if="$ctrl.absencesToUse.length">
      <thead>
        <tr>
          <th width="60%" sxy-text="SALAXY.NG1.CalcWorktimeComponent.lists.absencePeriods.absenceTime"></th>
          <th sxy-text="SALAXY.NG1.CalcWorktimeComponent.lists.absencePeriods.cause"></th>
          <th class="right" sxy-text="SALAXY.NG1.CalcWorktimeComponent.lists.annualLeaves.days"></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.absencesToUse">
          <td width="60%">
            {{row.period | sxyDateRange}}
          </td>
          <td>{{ "AbsenceCauseCode." + row.causeCode | sxyEnum }}</td>
          <td class="right">{{row.period.daysCount}}</td>
          <td>
            <button type="button" class="delete btn btn-danger" ng-click="$ctrl.moveAbsenceItem(row, 'absencesToReject')">
              <span></span><i class="bi bi-trash-fill"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="col-6">
    <h4 sxy-text="SALAXY.NG1.CalcWorktimeComponent.lists.absencePeriods.absencesToReject"></h4>
    <table class="table table-sm" ng-if="$ctrl.absencesToReject.length">
      <thead>
        <tr>
          <th width="40%" sxy-text="SALAXY.NG1.CalcWorktimeComponent.lists.annualLeaves.startDate"></th>
          <th width="40%" sxy-text="SALAXY.NG1.CalcWorktimeComponent.lists.annualLeaves.endDate"></th>
          <th sxy-text="SALAXY.NG1.CalcWorktimeComponent.lists.absencePeriods.cause"></th>
          <th class="right" sxy-text="SALAXY.NG1.CalcWorktimeComponent.lists.annualLeaves.days"></th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.absencesToReject" ng-style="$ctrl.getAbsenceDisabledStyle(row)">
          <td width="40%">
            <span>{{row.period.start | sxyDate}}</span>
          </td>
          <td width="40%">
            <span>{{row.period.end | sxyDate}}</span>
          </td>
          <td>{{ "AbsenceCauseCode." + row.causeCode | sxyEnum }}</td>
          <td class="right">
            <span>{{row.period.daysCount}}</span>
          </td>
          <td>
            <button type="button" class="btn btn-primary" ng-click="$ctrl.moveAbsenceItem(row,'absencesToUse')" ng-disabled="$ctrl.isAbsenceSelectedToUse(row)" sxy-text="SALAXY.UI_Terms.select">
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>`), s.put("salaxy-components/calc/CalcList.html", `<div class="salaxy-component salaxy-calc-list">
  <div ng-if="($ctrl.mode || 'default') == 'default'">
    <salaxy-odata-table ng-if="$ctrl.category=='draft'" url="/v03/api/calculations/category/editable" crud-controller="CalculationCrudController as $crud" options="{$top:$ctrl.limitTo}" template-url="salaxy-components/odata/lists/CalculationsDrafts.html" read-only="$ctrl.readOnly">
    </salaxy-odata-table>
    <salaxy-odata-table ng-if="$ctrl.category=='paid'" url="/v03/api/calculations/category/readonly" crud-controller="CalculationCrudController as $crud" options="{$top:$ctrl.limitTo}" template-url="salaxy-components/odata/lists/CalculationsPaid.html" read-only="$ctrl.readOnly">
    </salaxy-odata-table>
    <div ng-if="$ctrl.category=='paidIr'">
      <salaxy-tab-buttons
        current-tab="$ctrl.currentTab"
        options="[
          { value: 'paymentsucceeded', text: 'SALAXY.ENUM.CalculationStatus.paymentSucceeded.label' },
          { value: 'paymentstarted', text: 'SALAXY.ENUM.CalculationStatus.paymentStarted.label' }
        ]"
        tabs-id="calcList">
      </salaxy-tab-buttons>
      <div class="tab-content" id="tab-content-calcList">
        <div class="tab-pane" id="paymentsucceeded-tab">
          <div ng-if="$ctrl.currentTab == 'paymentsucceeded'">
            <salaxy-odata-table url="/v03/api/calculations/category/readonly" crud-controller="CalculationCrudController as $crud" options="{$top:$ctrl.limitTo, $filter: 'status eq \\'paymentSucceeded\\'' }" template-url="salaxy-components/odata/lists/CalculationsPaidIr.html" read-only="$ctrl.readOnly"></salaxy-odata-table>
          </div>
        </div>
        <div class="tab-pane" id="paymentstarted-tab">
          <div ng-if="$ctrl.currentTab == 'paymentstarted'">
            <salaxy-odata-table url="/v03/api/calculations/category/readonly" crud-controller="CalculationCrudController as $crud" options="{$top:$ctrl.limitTo, $filter: 'status eq \\'paymentStarted\\'' }" template-url="salaxy-components/odata/lists/CalculationsPaidIr.html" read-only="$ctrl.readOnly"></salaxy-odata-table>
          </div>
        </div>
      </div>
    </div>    
    <salaxy-odata-table ng-if="$ctrl.category=='shared'" url="/v03/api/calculations/category/shared" crud-controller="CalculationCrudController as $crud" options="{$top: $ctrl.limitTo, $orderby:'createdAt desc'}" template-url="salaxy-components/odata/lists/CalculationsShared.html"
      read-only="$ctrl.readOnly">
    </salaxy-odata-table>
    <salaxy-odata-table ng-if="$ctrl.category=='sent'" url="/v03/api/calculations/category/sent" crud-controller="CalculationCrudController as $crud" options="{$top: $ctrl.limitTo}" template-url="salaxy-components/odata/lists/CalculationsSent.html" read-only="$ctrl.readOnly">
    </salaxy-odata-table>
    <salaxy-odata-table ng-if="$ctrl.category=='received'" url="/v03/api/calculations/category/received" crud-controller="CalculationCrudController as $crud" options="{$top: $ctrl.limitTo}" template-url="salaxy-components/odata/lists/CalculationsReceived.html"
      read-only="$ctrl.readOnly">
    </salaxy-odata-table>
    <salaxy-odata-table ng-if="$ctrl.category=='all'" crud-controller="CalculationCrudController as $crud" options="{$top: $ctrl.limitTo}" template-url="salaxy-components/odata/lists/CalculationsAll.html" read-only="$ctrl.readOnly">
    </salaxy-odata-table>
    <salaxy-odata-table ng-if="$ctrl.category=='error'" url="/v03/api/calculations/category/error" crud-controller="CalculationCrudController as $crud" options="{$top: $ctrl.limitTo}" template-url="salaxy-components/odata/lists/CalculationsAll.html" read-only="$ctrl.readOnly">
    </salaxy-odata-table>

    <salaxy-odata-table ng-if="$ctrl.category=='allEmployer'" url="/v03/api/calculations/category/all" crud-controller="CalculationCrudController as $crud" options="{ $top: $ctrl.limitTo, $filter: 'status eq \\'paymentWorkerCopy\\' or status eq \\'draft\\' or status eq \\'workerRequested\\' or status eq \\'workerRequestAccepted\\' or status eq \\'workerRequestDeclined\\' ' }"
      template-url="salaxy-components/odata/lists/CalculationsEmployerAll.html">
    </salaxy-odata-table>
  </div>
  <salaxy-odata-table ng-if="$ctrl.mode == 'panel'" url="{{ $ctrl.category == 'paid' ? '/v03/api/calculations/category/readonly' : $ctrl.category == 'sent' ? '/v03/api/calculations/category/sent' : $ctrl.category == 'received' ? '/v03/api/calculations/category/received' : $ctrl.category == 'shared' ? '/v03/api/calculations/category/shared' : '/v03/api/calculations/category/editable'}}"
    crud-controller="CalculationCrudController as $crud" options="{$top: $ctrl.limitTo, $filter: $ctrl.filter, $orderby: $ctrl.category == 'shared' ? 'createdAt desc' : null}" data="{ category: $ctrl.category }" template-url="salaxy-components/odata/lists/CalculationsPanel.html"
    read-only="$ctrl.readOnly">
  </salaxy-odata-table>
  <salaxy-odata-table ng-if="$ctrl.mode == 'select'" url="{{ $ctrl.category == 'paid' ? '/v03/api/calculations/category/readonly' : $ctrl.category == 'shared' ? '/v03/api/calculations/category/shared' : '/v03/api/calculations/category/editable'}}" template-url="salaxy-components/odata/lists/Calculations-select.html" options="$ctrl.options"
    selected-items="$ctrl.selectedItems" on-list-select="$ctrl.onListSelect({ value: value, item: item, allItems: allItems });" crud-controller="CalculationCrudController as $crud"></salaxy-odata-table>
</div>`), s.put("salaxy-components/calc/CalcNewIntro.html", `<div class="calc-start-instructions" ng-if="!$ctrl.calcSections.get('result').isSelectionDone">
  <h1 style="font-size: 2em" class="mt-2 text-center mb-5" sxy-text="SALAXY.NG1.CalcNewIntroComponent.title"></h1>
  <div class="row mb-4">
    <div class="col-6 col-sm-3 text-center" style="min-height: 200px; cursor: pointer;" ng-click="$ctrl.calcSections.toggle('worker');">
      <div class="bi-stack-icons bi-7x">
        <i class="bi bi-circle-fill text-info"></i>
        <span class="bi-text-on-top">1</span>
      </div>
      <strong class="uppercase" sxy-text="SALAXY.NG1.CalcNewIntroComponent.stepOne.title"></strong>
      <p sxy-text="SALAXY.NG1.CalcNewIntroComponent.stepOne.description"></p>
    </div>
    <div class="col-6 col-sm-3 text-center" style="min-height: 200px; cursor: pointer;" ng-click="$ctrl.calcSections.toggle('worktime');">
      <div class="bi-stack-icons bi-7x">
        <i class="bi bi-circle-fill text-warning"></i>
        <span class="bi-text-on-top">2</span>
      </div>
      <strong class="uppercase" sxy-text="SALAXY.NG1.CalcNewIntroComponent.stepTwo.title"></strong>
      <p sxy-text="SALAXY.NG1.CalcNewIntroComponent.stepTwo.description"></p>
    </div>
    <div class="col-6 col-sm-3 text-center" style="min-height: 200px; cursor: pointer;" ng-click="$ctrl.calcSections.toggle('salary');">
      <div class="bi-stack-icons bi-7x">
        <i class="bi bi-circle-fill text-success"></i>
        <span class="bi-text-on-top">3</span>
      </div>
      <strong class="uppercase" sxy-text="SALAXY.NG1.CalcNewIntroComponent.stepThree.title"></strong>
      <p sxy-text="SALAXY.NG1.CalcNewIntroComponent.stepThree.description"></p>
    </div>
    <div class="col-6 col-sm-3 text-center" style="min-height: 200px; cursor: pointer;" ng-click="$ctrl.calcSections.toggle('expenses');">
      <div class="bi-stack-icons bi-7x">
        <i class="bi bi-circle-fill text-danger"></i>
        <span class="bi-text-on-top">4</span>
      </div>
      <strong class="uppercase" sxy-text="SALAXY.NG1.CalcNewIntroComponent.stepFour.title"></strong>
      <p sxy-text="SALAXY.NG1.CalcNewIntroComponent.stepFour.description"></p>
    </div>
  </div>
</div>`), s.put("salaxy-components/calc/CalcRepair.html", `<div class="salaxy-component salaxy-calc-repair" ng-if="$ctrl.current && $ctrl.current.workflow.status == 'repair'">
  <div class="row">
    <div class="col-12 col-sm-12 col-md-12 col-lg-6 ">
      <div ng-if="$ctrl.current">
        <div class="btn-toolbar calc-toolbar">
          <div class="btn-group" role="group">
            <button class="btn btn-default" ng-click="$ctrl.recalculateRepair()" sxy-text="SALAXY.UI_Terms.recalculate"></button>
            <button class="btn btn-success" ng-click="$ctrl.saveRepair()" sxy-text="SALAXY.UI_Terms.save"></button>
            <button class="btn btn-danger"ng-click="$ctrl.deleteCalc('/calc/repairs')"  sxy-text="SALAXY.UI_Terms.delete"></button>
          </div>
          <div class="btn-group" role="group">
            <button class="btn btn-primary" type="button" ng-click="$ctrl.commitRepair()"  sxy-text="Korvaa alkuperäinen laskelma"></button>
          </div>
        </div>
        <div class="panel panel-primary" style="padding: 10px">
          <div class="panel-body">
            <salaxy-validation-summary api-validation="$ctrl.validation"></salaxy-validation-summary>
            <div class="row">
              <div class="row calc-editor-calc-rows">
                <div class="col-12">
                  <fieldset>
                    <legend sxy-text="SALAXY.NG1.CalcEditorComponent.calcRowsTitle"></legend>
                    <salaxy-calc-rows-2019-editor parent="$ctrl.current" mode="edit" show-gross-totals="false">
                    </salaxy-calc-rows-2019-editor>
                  </fieldset>
                </div>
              </div>
              <div class="row spacer-bottom salaxy-calc-editor">
                <div class="col-md-6 col-12 calc-editor-worker-details spacer-bottom">
                  <legend>
                    <span sxy-text="SALAXY.NG1.CalcEditorComponent.workerTitle"></span>
                  </legend>
                  <div class="row">
                    <div class="col-3">
                      <div class="avatar-container">
                        <salaxy-avatar avatar="$ctrl.current.worker.avatar"></salaxy-avatar>
                      </div>
                    </div>
                    <div class="col-9">
                      <strong>{{$ctrl.current.worker.avatar.displayName}}</strong>
                      <br>
                      <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="socialSecurityNumber"
                        ng-model="$ctrl.current.worker.paymentData.socialSecurityNumber"></salaxy-input>
                      <div>&nbsp;</div>
                      <br>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="firstName" ng-model="$ctrl.current.worker.avatar.firstName"></salaxy-input>
                      <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="lastName" ng-model="$ctrl.current.worker.avatar.lastName"></salaxy-input>
                      <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="ibanNumber" ng-model="$ctrl.current.worker.paymentData.ibanNumber"
                        sxy-iban></salaxy-input>
                      <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="email" ng-model="$ctrl.current.worker.contact.email" sxy-email></salaxy-input>
                      <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="telephone" ng-model="$ctrl.current.worker.contact.telephone"
                        sxy-mobile-phone></salaxy-input>
                      <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="street" ng-model="$ctrl.current.worker.contact.street"></salaxy-input>
                      <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="postalCode" ng-model="$ctrl.current.worker.contact.postalCode"
                        sxy-postal-code-fi></salaxy-input>
                      <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="city" ng-model="$ctrl.current.worker.contact.city"></salaxy-input>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-12 calc-editor-employer-details spacer-bottom">
                  <legend>
                    <span sxy-text="SALAXY.NG1.CalcEditorComponent.employerTitle"></span>
                  </legend>
                  <div class="row">
                    <div class="col-3 ">
                      <div class="avatar-container ">
                        <salaxy-avatar avatar="$ctrl.current.employer.avatar"></salaxy-avatar>
                      </div>
                    </div>
                    <div class="col-9">
                      <strong>{{$ctrl.current.employer.avatar.displayName}}</strong>
                      <br>
                      <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="employerOfficialId"
                        ng-model="$ctrl.current.employer.officialId"></salaxy-input>
                      <div>&nbsp;</div>
                      <br>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="employerEmail" ng-model="$ctrl.current.employer.contact.email"
                        sxy-email></salaxy-input>
                      <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="employerTelephone"
                        ng-model="$ctrl.current.employer.contact.telephone"></salaxy-input>
                      <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="employerStreet"
                        ng-model="$ctrl.current.employer.contact.street"></salaxy-input>
                      <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="employerPostalCode"
                        ng-model="$ctrl.current.employer.contact.postalCode"></salaxy-input>
                      <salaxy-input label-type="plain" input-mode="openClose" read-only="false" name="employerCiy" ng-model="$ctrl.current.employer.contact.city"></salaxy-input>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row spacer-bottom">
                <div class="col-md-6 col-12 spacer-bottom">
                  <form class="form-horizontal">
                    <fieldset>
                      <legend>
                        <span sxy-text="Työsuhteen tiedot"></span>
                      </legend>
                      <salaxy-input-enum input-mode="openClose" enum="PensionCalculation" name="PensionCalculation" label="Sovellettava eläketurva"
                        ng-model="$ctrl.current.result.responsibilities.pensionCalculation"></salaxy-input-enum>
                      <salaxy-input-enum input-mode="openClose" enum="PensionRule" name="PensionRule" label="Eläkemaksun laskentasääntö"
                        ng-model="$ctrl.current.result.responsibilities.pensionRule"></salaxy-input-enum>
                      <salaxy-input-enum input-mode="openClose" enum="EmploymentRelationType" name="EmploymentRelationType" label="Työsuhde"
                        ng-model="$ctrl.current.result.responsibilities.employmentType"></salaxy-input-enum>

                      <salaxy-date-range input-mode="openClose" ng-model="$ctrl.current.worktime.employmentPeriod" label="Työsuhteen kesto"
                        name="employmentPeriod"></salaxy-date-range>
                      <salaxy-input-enum input-mode="openClose" ng-if="$ctrl.current.result.responsibilities.pensionCalculation == 'publicSector'" type="select"
                        name="employmentRegCodes" disable-cache="true" options="$ctrl.getEmploymentRegCodeOptions()"
                        label="SALAXY.NG1.WorkerWizardComponent.employment.employmentRegCode"
                        ng-model="$ctrl.current.result.responsibilities.employmentRegCode"></salaxy-input-enum>
                      <salaxy-input-enum input-mode="openClose" enum="TaxcardKind" name="TaxcardKind" label="Työsuhteessa käytettävä verokortti"
                        ng-model="$ctrl.current.result.responsibilities.employmentTaxcard"></salaxy-input-enum>
                      <salaxy-input-enum input-mode="openClose" enum="EmploymentRelationSalaryPaymentMethod" name="SalaryPaymentMethod" label="Palkanmaksutapa"
                        ng-model="$ctrl.current.result.responsibilities.salaryPaymentMethod"></salaxy-input-enum>
                      <div ng-repeat="irIncomeEarnerType in $ctrl.current.result.responsibilities.irIncomeEarnerTypes">
                        <salaxy-input-enum input-mode="openClose" enum="IncomeEarnerType" name="IncomeEarnerType" label="Tulonsaajan tyyppi"
                          ng-model="irIncomeEarnerType"></salaxy-input-enum>
                      </div>

                      <salaxy-input-occupation-type input-mode="openClose" name="occupationCode" ng-model="$ctrl.current.info.occupationCode" label="Ammattiluokka vakuutukseen"
                        read-only="false">
                      </salaxy-input-occupation-type>
                      <salaxy-input
                        tooltip-html="&lt;a target=&#39;_blank&#39; href=&#39;https://www.keva.fi/tyonantajalle/elakemaksut/ammattinimikkeiden-haku/&#39;&gt;Info&lt;/a&gt;"
                        ng-if="$ctrl.current.result.responsibilities.pensionCalculation == 'publicSector'" input-mode="openClose" name="occupationCode2"
                        ng-model="$ctrl.current.info.occupationCode2" label="Keva:n ammattiluokka" read-only="false">
                      </salaxy-input>
                    </fieldset>
                  </form>
                </div>
                <div class="col-md-6 col-12 spacer-bottom">
                  <div class="col-12">
                    <!-- todo fix readOnly-->
                    <form class="form-horizontal">
                      <legend sxy-text="Palkanmaksu"></legend>
                      <salaxy-datepicker-popup input-mode="openClose" name="salaryDate" ng-model="$ctrl.current.workflow.salaryDate"
                        label="SALAXY.NG1.CalcEditorComponent.paymentInfo.salaryDateLabel"></salaxy-datepicker-popup>
                      <salaxy-datepicker-popup input-mode="openClose" name="salaryPaidAt" ng-model="$ctrl.current.workflow.paidAt"
                        label="SALAXY.NG1.CalcEditorComponent.paymentInfo.paymentDateLabel"></salaxy-datepicker-popup>
                      <salaxy-date-range input-mode="openClose" ng-model="$ctrl.dateRange" class="condensed" name="dateRange" on-change="$ctrl.dateRangeChange()"
                        label="SALAXY.CORE.CalcWorktime.salaryPeriod" label-days-count="SALAXY.MODEL.CalcWorktime.workDays.title"></salaxy-date-range>
                      <salaxy-input-enum  read-only="true" ng-model="$ctrl.current.info.paymentChannel" name="paymentChannel" enum="PaymentChannel"  label="SALAXY.NG1.CalcEditorComponent.paymentInfo.paymentChannel"></salaxy-input-enum>

                    </form>
                  </div>
                  <div class="col-12">
                    <form class="form-horizontal" ng-readonly="true">
                      <fieldset>
                        <legend>
                          <span sxy-text="Verokortin tiedot"></span>
                          <button class="btn btn-xs btn-default pull-right" ng-click="$ctrl.selectTaxcard()" sxy-text="SALAXY.UI_Terms.change"></button>
                        </legend>

                        <salaxy-input-enum enum="TaxcardKind" name="TaxcardKind" label="Verokortti" ng-model="$ctrl.current.worker.tax.snapshot.kind"></salaxy-input-enum>
                        <salaxy-input name="forYear" label="Vuodelle" ng-model="$ctrl.current.worker.tax.snapshot.forYear"></salaxy-input>

                        <salaxy-form-group name="validity" class="salaxy-read-only" label="Voimassa">
                          <div class="salaxy-read-only-value">
                            {{$ctrl.current.worker.tax.snapshot.validity.start | date}} - {{$ctrl.current.worker.tax.snapshot.validity.end | date}}
                          </div>
                        </salaxy-form-group>
                        <salaxy-input label="veroprosentti" name="Veroprosentti" unit="percent" ng-model="$ctrl.current.worker.tax.snapshot.taxPercent"
                          require="true"></salaxy-input>
                        <salaxy-input-number label="Tuloraja" name="tuloraja" unit="euro" ng-model="$ctrl.current.worker.tax.snapshot.incomeLimit"
                          maxlength="10"></salaxy-input-number>
                        <salaxy-input label="Lisäveroprosentti" name="lisaveroprosentti" unit="percent" ng-model="$ctrl.current.worker.tax.snapshot.taxPercent2"></salaxy-input>
                      </fieldset>
                    </form>
                  </div>
                </div>
              </div>
              <div class="row spacer-bottom">
                <div class="col-md-6 col-12 spacer-bottom">
                  <form class="form-horizontal">
                    <fieldset>
                      <legend>
                        <span sxy-text="Vero, eläke- ja vakuutustiedot"></span>
                      </legend>
                      <salaxy-input-enum input-mode="openClose" label="Työeläkeyhtiö" enum="PensionCompany" name="PensionCompany"
                        ng-model="$ctrl.current.result.responsibilities.pensionCompany"></salaxy-input-enum>
                      <salaxy-input input-mode="openClose" label="Sopimusnumero" name="PensionContractNumber" ng-model="$ctrl.current.result.responsibilities.pensionContractNumber"
                        sxy-pension-contract-number></salaxy-input>
                      <salaxy-input ng-if="$ctrl.current.result.responsibilities.pensionCalculation == 'publicSector'" input-mode="openClose"
                        label="SALAXY.MODEL.PensionContract.subOrgCode.title" name="SubOrgCode" ng-model="$ctrl.current.result.responsibilities.subOrgCode"></salaxy-input>
                      <salaxy-input-number input-mode="openClose" ng-model="$ctrl.current.result.responsibilities.pensionPercent" unit="percent" name="PensionPercent"
                        label="SALAXY.MODEL.PensionContract.pensionPercent.title"></salaxy-input-number>
                      <salaxy-input-number input-mode="openClose" ng-model="$ctrl.current.result.responsibilities.pensionDiscountPercent" unit="percent" name="PensionDiscount"
                        label="SALAXY.MODEL.PensionContract.pensionDiscountPercent.title"></salaxy-input-number>
                      <salaxy-input-boolean input-mode="openClose" ng-model="$ctrl.current.result.responsibilities.pensionSelfPayment" name="pensionSelfPayment"
                        label="Hoitaa TyEl-maksut itse"></salaxy-input-boolean>

                      <salaxy-input-enum input-mode="openClose" ng-model="$ctrl.current.result.responsibilities.insuranceCompany" label="Vakuutusyhtiö" enum="InsuranceCompany"
                        name="InsuranceCompany"></salaxy-input-enum>
                      <salaxy-input input-mode="openClose" ng-model="$ctrl.current.result.responsibilities.insuranceContractNumber" name="insuranceContractNumber"
                        label="SALAXY.MODEL.InsuranceContract.contractNumber.title"></salaxy-input>
                      <salaxy-input-number input-mode="openClose" label-cols="col-sm-6" ng-model="$ctrl.current.result.responsibilities.insurancePercent"
                        label="Tapaturm.vak.maksun arvio-%" unit="percent" name="insurancePercent"></salaxy-input-number>
                      <salaxy-input-number input-mode="openClose" label-cols="col-sm-6" ng-model="$ctrl.current.result.responsibilities.groupLifeInsurancePercent"
                        label="SALAXY.MODEL.InsuranceContract.groupLifeInsurancePercent.title" unit="percent" name="groupLifeInsurancePercent"></salaxy-input-number>

                      <salaxy-input-enum input-mode="openClose" ng-model="$ctrl.current.result.responsibilities.unemploymentPayrollLimitStatus"
                        label="Työt.vak.maksun palkkasummaraja" enum="UnemploymentPayrollLimitStatus" name="unemploymentPayrollLimitStatus">
                      </salaxy-input-enum>

                    </fieldset>
                  </form>
                </div>
                <div class="col-md-6 col-12 spacer-bottom">
                  <div class="col-12">
                    <form class="form-horizontal" ng-readonly="true">
                      <fieldset>
                        <legend sxy-text="SALAXY.NG1.CalcEditorComponent.messages.title"></legend>
                        <salaxy-input input-mode="openClose" read-only="false" name="workDescription" ng-model="$ctrl.current.info.workDescription"
                          label="SALAXY.NG1.CalcEditorComponent.messages.workDescriptionLabel"></salaxy-input>
                        <salaxy-textarea input-mode="openClose" read-only="false" name="salarySlipMessage" ng-model="$ctrl.current.info.salarySlipMessage"
                          label="SALAXY.NG1.CalcEditorComponent.messages.salarySlipMessageLabel"></salaxy-textarea>
                      </fieldset>
                    </form>
                  </div>
                  <div class="col-12">
                    <div class="form-horizontal">
                      <salaxy-calc-cost-accounting read-only="false" input-mode="openClose" calc="$ctrl.current"></salaxy-calc-cost-accounting>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-sm-12 col-md-12 col-lg-6 ">
      <salaxy-tab-buttons
        current-tab="$ctrl.currentTab"
        options="[
          { value: 'edited', text: 'SALAXY.NG1.CalcEditorComponent.editedHeading' },
          { value: 'default', text: 'SALAXY.NG1.CalcEditorComponent.originalHeading' },
          { value: 'paymentreport', text: 'SALAXY.NG1.CalcEditorComponent.diffHeading' },
          { value: 'accounting', text: 'SALAXY.NG1.CalcEditorComponent.diffAccountingHeading' },
          { value: 'documentflow', text: 'Laskut ja ilmoitukset' },
        ]"
        tabs-id="calcRepair">
      </salaxy-tab-buttons>
      <div class="tab-content" id="tab-content-calcRepair">
        <div class="tab-pane" id="edited-tab">
          <salaxy-calc-reports calcs="[$ctrl.current]" report-type="$ctrl.shared.reportType" on-report-type-change="$ctrl.shared.reportType=reportType"></salaxy-calc-reports>
        </div>
        <div class="tab-pane" id="default-tab">
          <salaxy-calc-reports ng-if="$ctrl.base" calcs="[$ctrl.base]" report-type="$ctrl.shared.reportType"
            on-report-type-change="$ctrl.shared.reportType=reportType"></salaxy-calc-reports>
        </div>
        <div class="tab-pane" id="paymentreport-tab">
          <div class="payroll-report payroll-report-partial-container">
            <salaxy-calc-report ng-if="$ctrl.base" calc="$ctrl.diffCalc" report-type="'paymentReport'" template-name="'paymentTablesV2'" apply-site-styles="true">
          </div>
        </div>
        <div class="tab-pane" id="accounting-tab">
          <salaxy-accounting-report-tools any-expanded="$reportRows.anyExpanded" on-expand-change="$reportRows.expand(close)" on-target-change="$ctrl.onTargetChange(targetId)"
            reader="$ctrl.accountingDiffDataReader"></salaxy-accounting-report-tools>
          <salaxy-accounting-report-rows ng-ref="$reportRows" data="$ctrl.accountingDiffData"></salaxy-accounting-report-rows>
        </div>
        <div class="tab-pane" id="documentflow-tab">
          <div ng-if="$ctrl.documentFlow.children">
            <table class="table table-striped">
              <tr ng-repeat="doc in $ctrl.documentFlow.children">
                <td>
                  <salaxy-avatar ng-if="doc.item.type != 'payerSummary' && doc.item.type != 'payrollDetails'" class="salaxy-calc-row-type-avatar"
                    avatar="doc.item.otherPartyInfo.avatar"></salaxy-avatar>
                  <salaxy-avatar ng-if="doc.item.type == 'payerSummary' || doc.item.type == 'payrollDetails'" class="salaxy-calc-row-type-avatar"
                    avatar="doc.item.ownerInfo.avatar"></salaxy-avatar>
                </td>
                <td class="middle">
                  <strong ng-if="doc.item.type == 'invoice'">{{doc.item.shortText}}</strong>
                  <strong ng-if="doc.item.type == 'earningsPayment'">{{'Palkkatietoilmoitus' |sxyTranslate}}</strong>
                  <strong ng-if="doc.item.type == 'payrollDetails'">{{'Palkkalista' |sxyTranslate}}</strong>
                  <strong ng-if="doc.item.type == 'payerSummary'">{{'Erillisilmoitus' |sxyTranslate}}</strong>
                  <strong ng-if="doc.item.type == 'taxcard'">{{'Verokortti' |sxyTranslate}}</strong>
                </td>
                <td>
                  <a ng-if="doc.item.type == 'earningsPayment'" class="btn btn-default btn-sm" ng-href="#/irepr/details/{{doc.item.id}}">Näytä</a>
                  <a ng-if="doc.item.type == 'invoice'" class="btn btn-default btn-sm" ng-href="#/invoices/details/{{doc.item.id}}">
                    {{ 'SALAXY.UI_Terms.show' | sxyTranslate}}</a>
                  <a ng-if="doc.item.type == 'payerSummary'" class="btn btn-default btn-sm" ng-href="#/irpsr/details/{{doc.item.id}}">Näytä</a>
                  <a ng-if="doc.item.type == 'payrollDetails'" class="btn btn-default btn-sm" ng-href="#/payroll/details/{{doc.item.id}}">Näytä</a>
                  <a ng-if="doc.item.type == 'taxcard'" class="btn btn-default btn-sm" ng-href="#/taxcards/details/{{doc.item.id}}">Näytä</a>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>`), s.put("salaxy-components/calc/CalcReport.html", `<div ng-if="$ctrl.reportType != 'totalsReport'" class="salaxy-component salaxy-calc-report">
  <div ng-class="{'report-table-html': $ctrl.applySiteStyles}">
    <div ng-bind-html="$ctrl.html" class="report-binder table-responsive"></div>
  </div>
  <p ng-if="('person' | sxyIsInRole) && $ctrl.calc.workflow.status !== 'paymentWorkerCopy'">{{'SALAXY.NG1.CalcReportComponent.palkkausFeeInfo' | sxyTranslate}}</p>
</div>
<div ng-if="$ctrl.reportType == 'totalsReport'" class="salaxy-component">
  <sxy-table ng-ref="$ctrl.$sxyTable" options="$ctrl.tableConfig.options" include="$ctrl.tableConfig.include" data="$ctrl.tableConfig.data"></sxy-table>
</div>`), s.put("salaxy-components/calc/CalcReports.html", `<div class="salaxy-component salaxy-calc-reports">
  <div class="btn-toolbar w-100 mb-3" role="toolbar" aria-label="Report options">
    <div class="btn-group btn-group-sm dropdown">
      <button id="single-button" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown" ng-disabled="disabled">
        <span ng-if="!($ctrl.reportType == 'irRows' || $ctrl.reportType == 'irFull' || $ctrl.reportType == 'rowsReport')">
          <span sxy-text="SALAXY.NG1.CalcReportsComponent.reportType" ps=":"></span>
          {{ "ReportType." + $ctrl.reportType | sxyEnum }} 
        </span>
        <span ng-if="$ctrl.reportType == 'irRows'" >
          <span sxy-text="SALAXY.NG1.CalcReportsComponent.reportType" ps=":"></span> {{"SALAXY.NG1.CalcReportsComponent.irRows" | sxyTranslate}}
        </span>
        <span ng-if="$ctrl.reportType == 'irFull'" >
          <span sxy-text="SALAXY.NG1.CalcReportsComponent.reportType" ps=":"></span> {{"SALAXY.NG1.CalcReportsComponent.irFull" | sxyTranslate}}
        </span>
        <span ng-if="$ctrl.reportType == 'rowsReport'" >
          <span sxy-text="SALAXY.NG1.CalcReportsComponent.reportType" ps=":"></span> {{"SALAXY.NG1.CalcReportsComponent.rowsReport" | sxyTranslate}}
        </span>
      </button>
      <ul class="dropdown-menu"  role="menu" aria-labelledby="single-button">
        <li role="menuitem"><a href="" ng-click="$ctrl.reportType = 'salarySlip'" class="dropdown-item">{{ "ReportType.salarySlip" | sxyEnum }}</a></li>
        <li role="menuitem"><a href="" ng-click="$ctrl.reportType = 'employerReport'" class="dropdown-item">{{ "ReportType.employerReport" | sxyEnum }}</a></li>
        <li role="menuitem"><a href="" ng-click="$ctrl.reportType = 'paymentReport'" class="dropdown-item" class="dropdown-item">{{ "ReportType.paymentReport" | sxyEnum }}</a></li>
        <li role="menuitem"><a href="" ng-click="$ctrl.reportType = 'paymentSummaryReport'" class="dropdown-item">{{ "ReportType.paymentSummaryReport" | sxyEnum }}</a></li>
        <li role="menuitem"><a href="" ng-click="$ctrl.reportType = 'accountingReport'" class="dropdown-item">{{ "ReportType.accountingReport" | sxyEnum }}</a></li>
        <li role="menuitem"><a href="" ng-click="$ctrl.reportType = 'totalsReport'" class="dropdown-item">{{ "ReportType.totalsReport" | sxyEnum }}</a></li>
        <li role="menuitem"><a href="" ng-click="$ctrl.reportType = 'rowsReport'" class="dropdown-item">{{"SALAXY.NG1.CalcReportsComponent.rowsReport" | sxyTranslate}}</a></li>
        <li role="menuitem"><a href="" ng-click="$ctrl.reportType = 'irRows'" class="dropdown-item">{{"SALAXY.NG1.CalcReportsComponent.irRows" | sxyTranslate}}</a></li>
        <li role="menuitem"><a href="" ng-click="$ctrl.reportType = 'irFull'" class="dropdown-item">{{"SALAXY.NG1.CalcReportsComponent.irFull" | sxyTranslate}}</a></li>
      </ul>
    </div>
    <!-- 
      TODO: When implementing, use <salaxy-input-enum type="ui-dropdown">
      Needs some fixes to the component (e.g. btn-group-sm support)
    -->
    <div class="btn-group ms-1 btn-group-sm dropdown">
      <button id="single-button2" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown" ng-disabled="disabled">
        <span sxy-text="SALAXY.NG1.CalcReportsComponent.reportLanguage" ps=":"></span> {{$ctrl.languageText | sxyTranslate}}
      </button>
      <ul class="dropdown-menu" role="menu" aria-labelledby="single-button2">
        <li ng-if="$ctrl.reportType == 'salarySlip' || $ctrl.reportType == 'employerReport' || $ctrl.reportType == 'paymentReport'" role="menuitem">
          <a href="" ng-click="$ctrl.setReportLang('default')" class="dropdown-item"  sxy-text="SALAXY.NG1.CalcReportsComponent.reportLanguageWorker"></a>
        </li>
        <li ng-if="!($ctrl.reportType == 'salarySlip' || $ctrl.reportType == 'employerReport' || $ctrl.reportType == 'paymentReport')" role="menuitem">
          <a href="" ng-click="$ctrl.setReportLang('default')" class="dropdown-item"  sxy-text="SALAXY.NG1.CalcReportsComponent.reportLanguageCompany"></a>
        </li>
        <li role="menuitem">
          <a href="" ng-click="$ctrl.setReportLang('fi')" class="dropdown-item" sxy-text="SALAXY.ENUM.Language.fi.label"></a>
        </li>
        <li role="menuitem">
          <a href="" ng-click="$ctrl.setReportLang('en')" class="dropdown-item" sxy-text="SALAXY.ENUM.Language.en.label"></a>
        </li>
        <li role="menuitem">
          <a href="" ng-click="$ctrl.setReportLang('sv')" class="dropdown-item" sxy-text="SALAXY.ENUM.Language.sv.label"></a>
        </li>
      </ul>
    </div>
    <salaxy-toggle-buttons ng-show="$ctrl.reportType !== 'eSalarySpecification' && $ctrl.reportType !== 'totalsReport' && $ctrl.reportType !== 'irRows' && $ctrl.reportType !== 'rowsReport'" ng-model="$ctrl.view" options="[
      { value: 'partial', label: 'SALAXY.NG1.CalcReportsComponent.reportViewPartial' },
      { value: 'page1', label: 'SALAXY.NG1.CalcReportsComponent.reportViewPage1', disabled: ($ctrl.reportType == 'accountingReport') },
      { value: 'full', label: 'SALAXY.NG1.CalcReportsComponent.reportViewFull' }
    ]" type="inline"></salaxy-toggle-buttons>
    <button ng-show="$ctrl.reportType !== 'eSalarySpecification' && $ctrl.reportType !== 'totalsReport' && $ctrl.reportType !== 'irRows' && $ctrl.reportType !== 'rowsReport'" class="btn btn-default btn-sm" ng-click="$ctrl.reload()"><i class="bi bi-arrow-repeat" aria-hidden="true"></i></button>

    <div ng-show="$ctrl.reportType !== 'eSalarySpecification' && $ctrl.reportType !== 'totalsReport' && $ctrl.reportType !== 'irRows' && $ctrl.reportType !== 'rowsReport' && $ctrl.reportType !== 'accountingReport'" class="btn-group btn-group-sm ms-auto" role="group" aria-label="Pdf">
      <button sxy-if-role="!anon" type="button" class="btn btn-default" ng-click="$ctrl.showDownloadDialog(true)">
        <span class="d-none d-md-inline-block" sxy-text="SALAXY.UI_Terms.print"></span>
        <i class="bi bi-printer" aria-hidden="true"></i>
      </button>
      <button sxy-if-role="!anon" type="button" class="btn btn-default" ng-click="$ctrl.showDownloadDialog(false)">
        <span class="d-none d-md-inline-block" sxy-text="SALAXY.UI_Terms.downloadPdf"></span>
        <i class="bi bi-file-earmark-pdf" aria-hidden="true"></i>
      </button>
    </div>
    <div ng-show="$ctrl.reportType == 'totalsReport' || $ctrl.reportType == 'irRows' || $ctrl.reportType == 'rowsReport'" class="btn-group btn-group-sm ms-auto" role="group" aria-label="Excel">
      <button sxy-if-role="!anon" type="button" class="btn btn-default" ng-click="$ctrl.downloadExcel()">
        <span class="d-none d-md-inline-block" sxy-text="SALAXY.UI_Terms.downloadExcel"></span>
        <i class="bi bi-file-earmark-excel" aria-hidden="true"></i>
      </button>
    </div>
  </div>

  <!-- Results view -->
  <div ng-switch="$ctrl.reportType || 'none'">
    <div ng-switch-when="accountingReport">
      <div class="payroll-report" ng-class="{'payroll-accounting-report-partial-container': $ctrl.view == 'partial'}">
        <salaxy-accounting-report-query ng-if="$ctrl.getEmployerLang() && $ctrl.getEmployerLang() !== 'default'" lang="$ctrl.getEmployerLang()" calcs="$ctrl.calcs"
          view="$ctrl.view">
          </salaxy-accouting-report-query>
      </div>
    </div>
    <div ng-switch-when="paymentSummaryReport">
      <!-- TODO: Below development of new summary report, cleaned/moved later -->
      <div class="payroll-report" ng-class="{'payroll-report-partial-container': $ctrl.view == 'partial'}">
        <salaxy-calc-report ng-if="$ctrl.getEmployerLang() && $ctrl.getEmployerLang() !== 'default'" lang="$ctrl.getEmployerLang()" calc="$ctrl.calcs"
          apply-site-styles="$ctrl.view == 'partial'" report-type="$ctrl.reportType" preview="$ctrl.preview" template-name="$ctrl.reports[$ctrl.reportType][$ctrl.view]">
        </salaxy-calc-report>
      </div>
    </div>
    <div ng-switch-when="totalsReport">
      <salaxy-calc-report ng-ref="$ctrl.$calcReports" ng-if="$ctrl.getEmployerLang() && $ctrl.getEmployerLang() !== 'default'" lang="$ctrl.getEmployerLang()" calc="$ctrl.calcs"
        apply-site-styles="$ctrl.view == 'partial'" report-type="$ctrl.reportType" preview="$ctrl.preview" template-name="$ctrl.reports[$ctrl.reportType][$ctrl.view]">
      </salaxy-calc-report>
    </div>
    <div ng-switch-when="rowsReport">
      <sxy-table ng-ref="$ctrl.$sxyTable" options="$ctrl.rowsReportTableConfig.options" include="$ctrl.rowsReportTableConfig.include"
        data="$ctrl.rowsReportTableConfig.data"></sxy-table>
    </div>
    <div ng-switch-when="irRows">
      <salaxy-calcs-ir-rows ng-ref="$ctrl.$calcsIrRows" calcs="$ctrl.calcs" lang="$ctrl.getEmployerLang()"></salaxy-calcs-ir-rows>
    </div>
    <div ng-switch-when="irFull">
      <div ng-repeat="calc in $ctrl.calcs">
        <salaxy-ir-earnings-payment ng-if="calc.workflow.status == 'paymentSucceeded'" calculation="calc"></salaxy-ir-earnings-payment>
        <salaxy-ir-earnings-payment ng-if="calc.workflow.status != 'paymentSucceeded' && $ctrl.loadEpr(calc)" calculation-for="calc" model="$ctrl.loadEpr(calc)" ></salaxy-ir-earnings-payment>
      </div>
    </div>
    <div ng-switch-when="none">
      <!-- Report type not selected -->
    </div>
    <div ng-switch-default="">
      <div ng-repeat="calc in $ctrl.calcs" class="payroll-report" ng-class="{'payroll-report-partial-container': $ctrl.view == 'partial'}">
        <salaxy-calc-worker-info model="calc" ng-if="$ctrl.view == 'partial'"></salaxy-calc-worker-info>
        <salaxy-calc-report ng-if="$ctrl.getWorkerLang(calc) && $ctrl.getWorkerLang(calc) !== 'default'" lang="$ctrl.getWorkerLang(calc)" calc="calc"
          apply-site-styles="$ctrl.view == 'partial'" report-type="$ctrl.reportType" preview="$ctrl.preview" template-name="$ctrl.reports[$ctrl.reportType][$ctrl.view]">
        </salaxy-calc-report>
      </div>
    </div>
  </div>
</div>`), s.put("salaxy-components/calc/CalcResults.html", `<div class="result-area" ng-if="$ctrl.currentCalc && $ctrl.calcSections.get('result').isSelectionDone">
  <div class="card border-primary" style="padding: 10px">
    <div class="card-body">
      <div class="row">
        <div class="col-12 col-md-4 order-1 order-md-2 calc-results-actions">
          <h2 class="text-center uppercase text-uppercase fw-normal"> {{ $ctrl.calcLogic.hasCompensation ? ("SALAXY.NG1.CalcResultsComponent.calculation" | sxyTranslate) : ("SALAXY.NG1.CalcResultsComponent.calculationSalary" | sxyTranslate) }}</h2>
          <div salaxy-if-role="anon">
            <button type="button" ng-click="$ctrl.register()" class="btn btn-info btn-block" sxy-text="SALAXY.UI_Terms.register"></button>
            <button type="button" ng-click="$ctrl.signIn()" class="btn btn-success btn-block" sxy-text="SALAXY.UI_Terms.login"></button>
          </div>
          
          <salaxy-validation-summary ng-if="$ctrl.currentCalc.workflow.status != 'sharedWaiting'" api-validation="$ctrl.validation"></salaxy-validation-summary>
            
          <p ng-if="$ctrl.currentCalc.workflow.status == 'payrollDraft'" class="text-center">
            <strong class="text-success" sxy-text="SALAXY.NG1.CalcResultsComponent.payrollDraft"></strong><br>
            <span sxy-text="SALAXY.NG1.CalcResultsComponent.payrollDraftInfo"></span>
          </p>
          <p ng-if="$ctrl.currentCalc.workflow.status == 'sharedWaiting'" class="text-center">
            <strong class="text-warning" sxy-text="SALAXY.NG1.CalcResultsComponent.sharedWaiting"></strong>
            <br> <span sxy-text="SALAXY.NG1.CalcResultsComponent.sharedWaitingInfo"></span>
          </p>
          <p ng-if="$ctrl.currentCalc.workflow.status == 'sharedApproved'" class="text-center">
            <strong class="text-success" sxy-text="SALAXY.NG1.CalcResultsComponent.sharedApproved"></strong>
            <br>
            <span ng-if="$ctrl.validation.isValid" sxy-text="SALAXY.NG1.CalcResultsComponent.draftInfo"></span>
          </p>
          <p ng-if="$ctrl.currentCalc.workflow.status == 'sharedRejected'" class="text-center">
            <strong class="text-danger" sxy-text="SALAXY.NG1.CalcResultsComponent.sharedRejected"></strong>
          </p>
          <p ng-if="$ctrl.currentCalc.workflow.status == 'paymentStarted'" class="text-center">
            <strong class="text-success" sxy-text="SALAXY.NG1.CalcResultsComponent.paymentStarted"></strong>
            <br>{{ $ctrl.currentCalc.workflow.paidAt | date }}
            <span ng-if="$ctrl.currentCalc.info.paymentChannel != 'undefined'">, <span sxy-text="SALAXY.NG1.CalcResultsComponent.paymentChannelTextPartial"></span> {{ "PaymentChannel." + $ctrl.currentCalc.info.paymentChannel | sxyEnum }}</span>.
            <span ng-if="$ctrl.currentCalc.workflow.salaryDateKind == 'inPast'">
              {{"SALAXY.ENUM.SalaryDateKind." + ($ctrl.currentCalc.workflow.salaryDateKind) + ".label" | sxyTranslate  }}.
            </span>
          </p>
          <p ng-if="$ctrl.currentCalc.workflow.status == 'paymentSucceeded' || $ctrl.currentCalc.workflow.status == 'paymentCanceled' || $ctrl.currentCalc.workflow.status == 'paymentRefunded' || $ctrl.currentCalc.workflow.status == 'paymentError'" class="text-center">
            <strong ng-if="$ctrl.currentCalc.workflow.status == 'paymentSucceeded'" class="text-success" sxy-text="SALAXY.NG1.CalcResultsComponent.isPaidDate"></strong>
            <strong ng-if="$ctrl.currentCalc.workflow.status == 'paymentError'" class="text-danger" sxy-text="SALAXY.NG1.CalcResultsComponent.paymentError"></strong>
            <strong ng-if="$ctrl.currentCalc.workflow.status == 'paymentRefunded'" class="" sxy-text="SALAXY.NG1.CalcResultsComponent.paymentRefunded"></strong>
            <strong  ng-if="$ctrl.currentCalc.workflow.status == 'paymentCanceled'" class="" sxy-text="SALAXY.NG1.CalcResultsComponent.paymentCanceled"></strong>
           
            <br>{{ $ctrl.currentCalc.workflow.paidAt | date }}
            <span ng-if="$ctrl.currentCalc.info.paymentChannel != 'undefined'">, <span sxy-text="SALAXY.NG1.CalcResultsComponent.paymentChannelTextPartial"></span> {{ "PaymentChannel." + $ctrl.currentCalc.info.paymentChannel | sxyEnum }}</span>.
            <span ng-if="$ctrl.currentCalc.workflow.salaryDateKind == 'inPast'">
              {{"SALAXY.ENUM.SalaryDateKind." + ($ctrl.currentCalc.workflow.salaryDateKind) + ".label" | sxyTranslate  }}.
            </span>
          </p>
          <p ng-if="$ctrl.currentCalc.workflow.status == 'draft'" class="text-center">
            <span ng-if="$ctrl.isReadOnly" sxy-text="SALAXY.NG1.CalcResultsComponent.draft"></span>
            <br>
            <span ng-if="$ctrl.validation.isValid  && ('!worker' | sxyIsInRole) && !$ctrl.isReadOnly" sxy-text="SALAXY.NG1.CalcResultsComponent.draftInfo"></span>
          </p>
          <div ng-if="('auth' | sxyIsInRole) && ('!worker' | sxyIsInRole)">
            <div ng-if="$ctrl.showAction('sendToPro')">
              <p  class="text-center">
                <strong class="text-success" sxy-text="SALAXY.NG1.CalcResultsComponent.waitingApproval"></strong>
                <br>
                <span sxy-text="SALAXY.NG1.CalcResultsComponent.waitingApprovalInfo"></span>
              </p>
              <div class="form-horizontal mb-1">
                <salaxy-textarea  name="workflowMessage" ng-model="$ctrl.workflowMessage" label="SALAXY.NG1.CalcResultsComponent.messageToAccountant" label-type="basic"></salaxy-textarea>
              </div>
              <div class="text-center">
                <button type="button" class="btn btn-primary" ng-click="$ctrl.sendToPro($ctrl.workflowMessage)" sxy-text="SALAXY.NG1.CalcResultsComponent.sendToProBtn" ps="»"></button>
              </div>
            </div>
            <div ng-if="$ctrl.showAction('showPaymentDialog')" class="text-center mb-1">
              <a href="" ng-click="$ctrl.showPaymentDialog()" sxy-text="SALAXY.NG1.CalcResultsComponent.showPaymentDialog"></a>.
            </div>
            <div ng-if="!$ctrl.validation.isValid">
              <salaxy-pay-button ng-if="$ctrl.showAction('allowForcePay')" label="SALAXY.UI_Terms.payAllShort" model="$ctrl.currentCalc" mode="button-and-channel" button-class="uppercase" ng-ref="$payButton" disabled="!$payButton.isChannelDefined" on-payment-channel-change="$ctrl.recalculate()"></salaxy-pay-button>
            </div>
            <div ng-if="$ctrl.validation.isValid">
              <div ng-if="$ctrl.showAction('pay')" class="mb-1">
                <salaxy-pay-button model="$ctrl.currentCalc" mode="button-and-channel" salaxy-if-role="employer" button-class="uppercase" ng-ref="$payButton" disabled="!$payButton.isChannelDefined" on-payment-channel-change="$ctrl.recalculate()"></salaxy-pay-button>
                <salaxy-salary-date-kind-button ng-if="$ctrl.showAction('setSalaryDateKind') && ('test,setSalaryDateKind' | sxyIsInRole) && ('employer' | sxyIsInRole)" button-class="btn-block" model="$ctrl.currentCalc" disabled="$ctrl.currentCalc.isReadOnly || $ctrl.isReadOnlyForced" on-salary-date-kind-change="$ctrl.recalculate()"></salaxy-salary-date-kind-button>
              </div>
            </div> 
            <div ng-if="$ctrl.showAction('save')" class="mb-1">
              <button type="button" ng-click="$ctrl.save()" class="btn btn-success btn-block" ng-disabled="$ctrl.isActionDisabled('save')" sxy-text="SALAXY.UI_Terms.save"></button>
            </div>
            <div ng-if="$ctrl.showAction('reject')" class="mb-1">
              <salaxy-calc-sharing-receipt-action button-class="btn btn-danger btn-block" model="$ctrl" type="'reject'"></salaxy-calc-sharing-receipt-action>
            </div>
            <div ng-if="$ctrl.showAction('approve')" class="mb-1">
              <salaxy-calc-sharing-receipt-action button-class="btn btn-success btn-block" model="$ctrl" type="'approve'"></salaxy-calc-sharing-receipt-action>
            </div>
            <button ng-if="$ctrl.showAction('delete')" type="button" ng-click="$ctrl.deleteCalc()" ng-disabled="$ctrl.isActionDisabled('delete')" class="btn btn-danger btn-block" sxy-text="SALAXY.UI_Terms.delete"></button>
            <button ng-if="$ctrl.showAction('cancel')" class="btn btn-default btn-sm btn-block" ng-click="$ctrl.cancel()" sxy-text="SALAXY.NG1.CalcResultsComponent.cancelPaymentOrChangeChannelBtn"></button>
            
            <button ng-if="$ctrl.showAction('copyAsNew')" type="button" ng-click="$ctrl.copyAsNew()" class="btn btn-primary btn-block" sxy-text="SALAXY.UI_Terms.copyAsNew" ps=" »"></button>
          </div>
          <div sxy-if-role="worker" class="row hidden-xxs">
            <div ng-if="$ctrl.showAction('save')" class="col-12">
              <button type="button" ng-click="$ctrl.save()" class="btn btn-success btn-block" ng-disabled="$ctrl.isActionDisabled('save')" sxy-text="SALAXY.UI_Terms.save"></button>
            </div>
            <div ng-if="$ctrl.currentCalc.workflow.status == 'draft' || $ctrl.currentCalc.workflow.status == 'workerRequested' || $ctrl.currentCalc.workflow.status == 'workerRequestAccepted' || $ctrl.currentCalc.workflow.status == 'workerRequestDeclined' || $ctrl.currentCalc.workflow.status == 'paymentWorkerCopy'" class="col-12">
              <salaxy-calc-sharing-info model="$ctrl"></salaxy-calc-sharing-info>
            </div>
            <div ng-if="$ctrl.showAction('delete')" class="col-12">
              <button ng-if="$ctrl.showAction('delete')" type="button" ng-click="$ctrl.deleteCalc()" ng-disabled="$ctrl.isActionDisabled('delete')" class="btn btn-danger btn-block" sxy-text="SALAXY.UI_Terms.delete"></button>
            </div>
          </div>
         
          <div class="text-center btn-group-chart">
            <a ng-click="$ctrl.chartType = 'bar'" class="btn-chart me-2" ng-class="{'active' : $ctrl.chartType == 'bar'}"><i class="bi bi-bar-chart-line-fill"></i></a>
            <a ng-click="$ctrl.chartType = 'pie'" class="btn-chart" ng-class="{'active' : $ctrl.chartType == 'pie'}"><i class="bi bi-pie-chart-fill"></i></a>
          </div>
        </div>

        <div class="col-12 col-sm-6 col-md-4 order-2 order-md-1">
          <h3 class="text-center fw-normal" sxy-text="SALAXY.NG1_Other.Roles.employer"></h3>
          <salaxy-calc-chart role="employer" scale-y-axis="true" chart-type="$ctrl.chartType" calc="$ctrl.currentCalc"></salaxy-calc-chart>
          <p class="text-center" ng-if="$ctrl.isHouseholdDeductible">
            <span sxy-text="SALAXY.NG1.CalcResultsComponent.nowPaying" ps=":"></span> {{ $ctrl.currentCalc.result.employerCalc.totalPayment | currency: "":2 }} €
            <br />
            <span sxy-text="SALAXY.NG1.CalcResultsComponent.finalCost" ps=":"></span> {{ $ctrl.currentCalc.result.employerCalc.finalCost | currency: "":2 }} €
          </p>
          <p class="text-center" ng-if="!$ctrl.isHouseholdDeductible">
            <span sxy-text="SALAXY.NG1.CalcDetailsSalaryComponent.paymentTotal.title" ps=":"></span> {{ $ctrl.currentCalc.result.employerCalc.finalCost | currency: "":2 }} €
          </p>
        </div>
        <div class="col-12 col-sm-6 col-md-4 order-3">
          <h3 class="text-center fw-normal" sxy-text="SALAXY.NG1_Other.Roles.worker"></h3>
          <salaxy-calc-chart role="worker" scale-y-axis="true" chart-type="$ctrl.chartType" calc="$ctrl.currentCalc"></salaxy-calc-chart>
          <p class="text-center">
            <span sxy-text="SALAXY.NG1.CalcResultsComponent.workerGetsPaid" ps=":"></span> {{ $ctrl.currentCalc.result.workerCalc.totalWorkerPayment | currency: "":2 }} €
          </p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-sm-4 d-flex justify-content-center">
        <a class="action-link" ng-click="$ctrl.showReportDialog('employerReport')" sxy-text="SALAXY.NG1.CalcResultsComponent.employerReport"></a>
      </div>
      <div class="col-12 col-sm-4 d-flex justify-content-center">
        <a class="action-link" ng-click="$ctrl.showReportDialog('paymentReport')" sxy-text="SALAXY.NG1.CalcResultsComponent.societyReport"></a>
      </div>
      <div class="col-12 col-sm-4 d-flex justify-content-center">
        <a class="action-link" ng-click="$ctrl.showReportDialog('salarySlip')" sxy-text="SALAXY.NG1.CalcResultsComponent.workerReport"></a>
      </div>
    </div>
  </div>
</div>`), s.put("salaxy-components/calc/CalcRowType.html", `<div class="salaxy-component salaxy-calc-row-type">
  <div ng-if="$ctrl.type == 'read-only'" class="salaxy-calc-row-type-read-only">
    {{ $ctrl.getRowLabel() | sxyTranslate }}
  </div>
  <div ng-if="$ctrl.type == 'typehead'" class="salaxy-calc-row-type-typehead" style="position: relative">
    <salaxy-input-typeahead
      label-type="no-label"
      ng-model="$ctrl.internalValue"
      name="{{ $ctrl.name }}"
      disable-cache="true"
      clear-on-select="$ctrl.clearOnSelect"
      value-as-object="true"
      placeholder="{{ $ctrl.placeholder || 'SALAXY.UI_Terms.select' | sxyTranslate }}"
      get-options="$ctrl.search">
    </salaxy-input-typeahead>
  </div>
  <div ng-if="$ctrl.type == 'list'" class="salaxy-calc-row-type-list">
    <div class="list-group">
      <div ng-repeat="item in $ctrl.getCachedSearch($ctrl.searchText, true)">
        <a ng-if="item.ui.iconText" class="list-group-item clickable d-flex" ng-click="$ctrl.internalValue = item" ng-class="{ 'active': $ctrl.internalValue == item }">
          <salaxy-avatar class="salaxy-calc-row-type-avatar" avatar="{ color: item.ui.color, initials: item.ui.iconText, entityType: 'company' }"></salaxy-avatar>
          <div>
            <b class="salaxy-highlight" ng-bind-html="item.text | uibTypeaheadHighlight:$ctrl.searchText"></b><br />
            <small class="salaxy-highlight">
              <div ng-bind-html="item.title | uibTypeaheadHighlight:$ctrl.searchText"></div>
            </small>
          </div>
        </a>
        <a ng-if="!item.ui.iconText" class="list-group-item clickable salaxy-highlight" ng-click="$ctrl.internalValue = item" ng-class="{ 'active': $ctrl.internalValue == item }" title="{{ enum.title }}" style="display: list-item; list-style-type: disc; list-style-position: inside; padding: 2px 2px 2px 60px">
          <span ng-bind-html="item.text | uibTypeaheadHighlight:query"></span>
        </a>
      </div>
    </div>
  </div>
  <div ng-if="$ctrl.type == 'table'" class="salaxy-calc-row-type-table">
    <table class="table table-sm">
      <thead>
        <tr class="active">
          <td>
            <salaxy-avatar class="salaxy-calc-row-type-avatar" avatar="{ color: 'rgb(79, 205, 196)', initials: 'type', entityType: 'company' }"></salaxy-avatar>
          </td>
          <td>
            <div><b sxy-text="SALAXY.NG1.CalcRowTypeComponent.rowType" ps=" (type)"></b></div>
            <div sxy-text="SALAXY.NG1.CalcRowTypeComponent.rowDescription"></div>
          </td>
          <td><b sxy-text="SALAXY.NG1.CalcRowTypeComponent.rowTypeEn"></b></td>
        </tr>
        <tr class="active">
          <td></td>
          <td sxy-text="SALAXY.NG1.CalcRowTypeComponent.rowKind" ps=" (kind)"></td>
          <td sxy-text="SALAXY.NG1.CalcRowTypeComponent.rowKindEn"></td>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat-start="item in $ctrl.getCachedSearch($ctrl.searchText, true)" ng-if="item.ui.iconText">
          <th rowspan="2">
            <salaxy-avatar class="salaxy-calc-row-type-avatar" avatar="{ color: item.ui.color, initials: item.ui.iconText, entityType: 'company' }"></salaxy-avatar>
          </th>
          <th>
            <div>
              <b class="salaxy-highlight" ng-bind-html="item.text | uibTypeaheadHighlight:$ctrl.searchText"></b>
              <button type="button" class="btn btn-xs btn-default" ng-click="$ctrl.showInfoScreen(item)" style="margin-left: 5px">edit</button>
            </div>
          </th>
          <th>
            <div class="salaxy-highlight" ng-bind-html="item.value | uibTypeaheadHighlight:$ctrl.searchText"></div>
          </th>
        </tr>
        <tr ng-if="item.ui.iconText" class="no-border">
          <td colspan="2" style="padding-top: 0;">
            <div style="padding-top: 0;" class="salaxy-highlight" ng-bind-html="item.title | uibTypeaheadHighlight:$ctrl.searchText"></div>
          </td>
        </tr>
        <tr ng-if="!item.ui.iconText">
          <td></td>
          <td>
            <div class="salaxy-highlight" ng-bind-html="item.text | uibTypeaheadHighlight:$ctrl.searchText"></div>
          </td>
          <td>
            <div class="salaxy-highlight" ng-bind-html="item.value.split('.')[1] | uibTypeaheadHighlight:$ctrl.searchText"></div>
          </td>
        </tr>
        <tr ng-repeat-end="item in $ctrl.getList()" ng-if="!item.ui.iconText" class="no-border">
          <td></td>
          <td colspan="2" style="padding-top: 0;">
            <div class="salaxy-highlight" ng-bind-html="item.title | uibTypeaheadHighlight:$ctrl.searchText"></div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>`), s.put("salaxy-components/calc/CalcRowTypeItem.html", `<a class="clickable d-flex" ng-if="match.model.ui.iconText">
  <salaxy-avatar class="salaxy-calc-row-type-avatar float-start" 
    avatar="{ color: match.model.ui.color, initials: match.model.ui.iconText, entityType: 'company' }"></salaxy-avatar>
  <div>
    <b class="salaxy-highlight" ng-bind-html="match.model.text | uibTypeaheadHighlight:query"></b><br />
    <small class="salaxy-highlight"><div ng-bind-html="match.model.title | uibTypeaheadHighlight:query"></div></small>
  </div>
</a>
<a class="clickable" ng-if="!match.model.ui.iconText"
style="display: list-item; list-style-type: disc; list-style-position: inside; padding: 2px 2px 2px 60px">
  <b class="salaxy-highlight" ng-bind-html="match.model.text | uibTypeaheadHighlight:query"></b> 
  <small class="salaxy-highlight"><span ng-bind-html="match.model.title || '' | uibTypeaheadHighlight:query"></span></small>
</a>`), s.put("salaxy-components/calc/CalcSharingReceiptAction.html", `<span ng-switch="$ctrl.type">
  <button ng-switch-when="approve" class="btn {{$ctrl.buttonClass || 'btn-success btn-block btn-sm' }}" type="button" id="approve" ng-disabled="$ctrl.disabled"
    ng-click="$ctrl.approve()" title="{{'SALAXY.NG1.CalcSharingReceiptActionComponent.approveBtnTitle' | sxyTranslate}}">
    <span ng-if="!$ctrl.iconOnly">{{'SALAXY.NG1.CalcSharingReceiptActionComponent.approveBtn' | sxyTranslate}}&nbsp;</span>
<span ng-show="!$ctrl.isLoading"><i class="bi bi-hand-thumbs-up"></i></span>
<span ng-show="$ctrl.isLoading"><i class="bi bi-arrow-repeat bi-spin"></i></span>
</button>
<button ng-switch-when="reject" class="btn {{$ctrl.buttonClass || 'btn-danger btn-block btn-sm' }}" type="button" id="reject" ng-disabled="$ctrl.disabled" ng-click="$ctrl.reject()" title="{{'SALAXY.NG1.CalcSharingReceiptActionComponent.rejectBtnTitle' | sxyTranslate}}">
    <span ng-if="!$ctrl.iconOnly"> {{'SALAXY.NG1.CalcSharingReceiptActionComponent.rejectBtn' | sxyTranslate}}&nbsp;</span>
    <span ng-show="!$ctrl.isLoading"><i class="bi bi-hand-thumbs-down"></i></span>
    <span ng-show="$ctrl.isLoading"><i class="bi bi-arrow-repeat bi-spin"></i></span>
  </button>
<span ng-switch-default class="alert alert-danger" sxy-text="SALAXY.NG1.CalcSharingReceiptActionComponent.alertUnknown"></span>
</span>`), s.put("salaxy-components/calc/CalcWorkerInfo.html", `<div class="salaxy-component salaxy-calc-worker-info">
  <div class="row">
    <div class="col-2 col-md-2 worker-info-avatar-container d-flex align-items-center justify-content-center">
      <salaxy-avatar avatar="$ctrl.current.worker.avatar"></salaxy-avatar>
    </div>
    <div class="col-10 col-md-10 worker-info-col">
      <h2>{{ $ctrl.current.worker.avatar.displayName || ("SALAXY.NG1.WorkerInfo.noSelection" | sxyTranslate) }}</h2>
      <div class="row">
        <div class="col-12 col-md-6">
          <div ng-class="{'text-danger': $ctrl.taxUi.status != 'ok'}">{{ $ctrl.taxUi.text || "&nbsp;" }}</div>
          <div ng-if="!$ctrl.current.worker.paymentData.ibanNumber" class="text-danger" sxy-text="SALAXY.NG1.WorkerInfo.noIbanNumber"></div>
          <div ng-if="$ctrl.current.worker.paymentData.ibanNumber">{{ $ctrl.current.worker.paymentData.ibanNumber | sxyIban }}</div>
          <div>{{ $ctrl.getPensionText() || "&nbsp;" }}</div>
        </div>
        <div class="col-12 col-md-6 ">
          <div ng-if="!$ctrl.current.worker.paymentData.socialSecurityNumberValid" class="text-danger">
            <span sxy-text="SALAXY.NG1.PaymentDialogComponent.noSSNumber"></span>
            <br />
          </div>
          <div ng-if="$ctrl.current.worker.paymentData.socialSecurityNumberValid">{{ $ctrl.current.worker.paymentData.socialSecurityNumberValid }}<br /></div>
          <span ng-if="$ctrl.current.worker.paymentData.telephone">
            {{ $ctrl.current.worker.paymentData.telephone ||  ('SALAXY.NG1.PaymentDialogComponent.noTel' | sxyTranslate) }}
          </span>
          <br />
          <a href="{{ 'mailto:' + $ctrl.current.worker.paymentData.email }}" ng-if="$ctrl.current.worker.paymentData.email">{{ $ctrl.current.worker.paymentData.email }}</a>
          <div ng-if="$ctrl.current && !$ctrl.current.worker.paymentData.email">
            <span sxy-text="SALAXY.NG1.PaymentDialogComponent.noEmail"></span> &nbsp;
            <span class="text-warning" sxy-text="SALAXY.NG1.PaymentDialogComponent.noEmailInfo"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>`), s.put("salaxy-components/calc/CalcWorktime.html", `<style type="text/css">
  .form-condensed .form-group {
    margin-bottom: 1px
  }

  .form-condensed .form-horizontal .control-label {
    padding-top: 0px;
  }
</style>
<div class="salaxy-component salaxy-calc-worktime" ng-if="$ctrl.currentCalc">
  <form ng-submit="$ctrl.submitWorktime()" name="detailsWork2" class="form-horizontal">
    <div class="salaxy-calc-dialog-body">
      <div class="salaxy-calc-dialog-container">
        <div class="row">
          <div class="col-md-6" >
            <h1 sxy-text="SALAXY.NG1.CalcWorktimeComponent.salaryDateTitle"></h1>
            <p sxy-html="SALAXY.NG1.CalcWorktimeComponent.salaryDateDescription.html"></p>
            <div class="form-horizontal">
              <salaxy-form-group ng-if="$ctrl.currentCalc.workflow.salaryDateKind == 'inPast'" name="salaryDateKind" class="salaxy-component salaxy-read-only" label-cols="col-sm-6" label="SALAXY.MODEL.CalcWorkflow.salaryDateKind.title">
                <div class="form-control-plaintext">{{"SALAXY.ENUM.SalaryDateKind." + ($ctrl.currentCalc.workflow.salaryDateKind) + ".label" | sxyTranslate  }}</div>
              </salaxy-form-group>           
              <salaxy-datepicker-popup name="requestedSalaryDate" ng-model="$ctrl.requestedSalaryDate" label="SALAXY.NG1.CalcWorktimeComponent.salaryDateLabel" label-cols="col-sm-6" date-disabled="disable-function" disable-function="$ctrl.isDisabledSalaryDate" placeholder="SALAXY.NG1.CalcWorktimeComponent.salaryDatePlaceholder"></salaxy-datepicker-popup>
            </div>
            <h1 sxy-text="SALAXY.NG1.CalcWorktimeComponent.worktime.title"></h1>
            <p ng-if="!$ctrl.dateRange.start || !$ctrl.dateRange.start" sxy-text="SALAXY.NG1.CalcWorktimeComponent.worktime.description"></p>
            <div class="form-horizontal">
              <salaxy-input-enum ng-model="$ctrl.periodShortcut" require="!!$ctrl.isWorkerHolidaysActive" name="periodShortcut" ng-if="!$ctrl.periodShortcut" label="SALAXY.CORE.CalcWorktime.salaryPeriod" label-cols="col-sm-6" type="radio" options="$ctrl.periodShortcuts"></salaxy-input-enum>
              <salaxy-input-enum ng-model="$ctrl.periodShortcut" require="!!$ctrl.isWorkerHolidaysActive" name="periodShortcut" ng-if="$ctrl.periodShortcut" label="SALAXY.CORE.CalcWorktime.salaryPeriod" label-cols="col-sm-6" type="select" options="$ctrl.periodShortcuts"></salaxy-input-enum>
              <salaxy-date-range ng-model="$ctrl.dateRange" require="!!$ctrl.isWorkerHolidaysActive" class="condensed" name="dateRange" ng-if="$ctrl.periodShortcut == 'other'" on-change="$ctrl.dateRangeChange()" label="SALAXY.CORE.CalcWorktime.salaryPeriod" label-days-count="SALAXY.MODEL.CalcWorktime.workDays.title"
                label-cols="col-sm-6" read-only="$ctrl.isReadOnly"></salaxy-date-range>
              <div ng-if="$ctrl.periodShortcut && $ctrl.periodShortcut != 'other'">
                <salaxy-form-group name="periodStartDate" label="SALAXY.MODEL.DateRange.start.title" label-cols="col-sm-6">
                  <input type="text" class="form-control" autocomplete="off" id="periodStartDate" name="periodStartDate" placeholder="{{'SALAXY.UI_Terms.dateFormats.dm' | sxyTranslate}}" ng-model="$ctrl.periodStartDate" ng-model-options="{allowInvalid: true, debounce: 250, updateOn: 'default' }"
                  />
                  <div ng-if="$ctrl.periodStartDateError" class="form-control-plaintext text-danger">{{ $ctrl.periodStartDateError |sxyTranslate}}</div>
                </salaxy-form-group>
                <salaxy-form-group name="formattedRange" label="SALAXY.CORE.CalcWorktime.startAndEndDates" label-cols="col-sm-6" class="salaxy-read-only">
                  <div class="form-control-plaintext">{{ $ctrl.dateRange | sxyDateRange }}</div>
                </salaxy-form-group>
                <salaxy-input-number name="labelDaysCount" ng-model="$ctrl.dateRange.daysCount" ng-change="$ctrl.dateRangeChange()" require="!!$ctrl.isWorkerHolidaysActive" label="SALAXY.MODEL.DateRange.daysCount.title" label-cols="col-sm-6">
                </salaxy-input-number>
              </div>
            </div>
          </div>
          <div class="col-md-6" ng-if="!(('worker' | sxyIsInRole) || ('disableHolidays' | sxyIsInRole))">
            <h1 sxy-text="SALAXY.NG1.CalcWorktimeComponent.absences.title"></h1>
            <div ng-switch="$ctrl.getHolidaysStatus()">
              <div ng-switch-when="noWorker" sxy-text="SALAXY.NG1.CalcWorktimeComponent.absences.descriptionNoWorker"></div>
              <div ng-switch-when="noPeriod" sxy-text="SALAXY.NG1.CalcWorktimeComponent.absences.descriptionNoPeriod"></div>
              <div ng-switch-when="loading">
                <salaxy-spinner full-screen="false" heading="SALAXY.UI_Terms.loading" text="SALAXY.NG1.CalcWorktimeComponent.absences.loadingText"></salaxy-spinner>
              </div>
              <div ng-switch-when="ok">
                <button class="btn btn-default float-end salaxy-button-pro" ng-click="$ctrl.showPeriodDetails()" type="button" title="{{'SALAXY.NG1.CalcWorktimeComponent.absences.proTabTitle' | sxyTranslate}}">Pro</button>
                <salaxy-tab-buttons
                  current-tab="$ctrl.currentTab"
                  options="[
                    { value: 'default', text: 'SALAXY.NG1.CalcWorktimeComponent.absences.calculationTabHeading', isDefault: true },
                    { value: 'absences', text: 'SALAXY.NG1.AbsencePeriodsComponent.headerAbsence' },
                    { value: 'leaves', text: 'SALAXY.NG1.CalcWorktimeComponent.absences.leavesTabHeading', hidden: !$ctrl.isHolidayAccrual }  
                  ]"
                  tabs-id="calcWorktime">
                </salaxy-tab-buttons>
                <div class="tab-content" id="tab-content-calcWorktime">
                  <div class="tab-pane" id="default-tab">
                    <fieldset ng-if="$ctrl.accruesHolidays">
                      <table class="table table-striped table-sm">
                        <thead>
                          <tr>
                            <th sxy-text="SALAXY.NG1.CalcWorktimeComponent.holidays.headerHolidays"></th>
                            <th class="right" sxy-text="SALAXY.NG1.CalcWorktimeComponent.holidays.headerDays"></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr ng-repeat="month in $ctrl.worktime.accruals">
                            <td>
                              <strong>{{ $ctrl.getAccrualMonthText('header', month) | sxyTranslate}}</strong><br>
                              <small>
                                <div>
                                  <a href="" ng-click="$ctrl.changeTab('absences')">
                                    <span sxy-text="SALAXY.NG1.CalcWorktimeComponent.absences.link"></span> {{ month.absencesDays | sxyCount : 'day' }}
                                  </a>
                                </div>
                              </small>
                            </td>
                            <td class="right">
                              <strong>{{ month.daysAccrued | sxyCount : 'day' }}</strong><br>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <small>
                        <p>{{ $ctrl.getAccrualMonthText("description") | sxyTranslate }}</p>
                      </small>
                    </fieldset>
                    <legend sxy-text="SALAXY.NG1.CalcWorktimeComponent.absences.calculationLegend"></legend>
                      <div>
                        <fieldset>
                          <table class="table table-striped table-sm" ng-if="$ctrl.getLogicForLists().getAbcencesForPeriod().length">
                            <thead>
                              <tr>
                                <th sxy-text="SALAXY.NG1.AbsencePeriodsComponent.headerAbsence"></th>
                                <th class="right" sxy-text="SALAXY.NG1.AbsencePeriodsComponent.headerDays"></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr ng-repeat="row in $ctrl.getLogicForLists().getAbcencesForPeriod()">
                                <td>
                                  <salaxy-avatar class="salaxy-calc-row-type-avatar float-start" avatar="{ color: '#2b507c', initials: (row.period.daysCount + 'pv'), entityType: 'company' }"></salaxy-avatar>
                                  <strong>{{ "AbsenceCauseCode." + row.causeCode | sxyEnum }}</strong><br />
                                  <div class="float-start" style="padding: 0px;">
                                    {{ row.isPaid ? ('SALAXY.NG1.AbsencePeriodsComponent.isPaid' | sxyTranslate) : ('SALAXY.NG1.AbsencePeriodsComponent.notPaid' |sxyTranslate) }}
                                    <span ng-if="row.isPaid != row.isHolidayAccrual"> {{ row.isHolidayAccrual ? ('SALAXY.NG1.AbsencePeriodsComponent.isAccrual' | sxyTranslate) : ('SALAXY.NG1.AbsencePeriodsComponent.notAccrual' | sxyTranslate) }}</span>
                                  </div>
                                  <div class="truncate" style="max-width: 250px; padding: 0px;">
                                    &nbsp;{{ row.notes }}
                                  </div>
                                </td>
                                <td class="right">
                                  <strong>{{ row.period.daysCount | sxyCount : "day" }}</strong><br /> {{ row.period | sxyDateRange }}
                                </td>
                              </tr>
                              <tr class="total">
                                <td>
                                  <salaxy-avatar class="salaxy-calc-row-type-avatar float-start" style="margin-bottom: 20px" avatar="{ color: '#2b507c', initials: 'sum', entityType: 'company' }"></salaxy-avatar>
                                  <strong>
                                    <span sxy-text="SALAXY.NG1.AbsencePeriodsComponent.totalUnpaid"></span><br />
                                    <span sxy-text="SALAXY.NG1.AbsencePeriodsComponent.totalPaid"></span><br />
                                    <span sxy-text="SALAXY.NG1.AbsencePeriodsComponent.totalNoHolidayAccrual"></span><br />
                                  <span sxy-text="SALAXY.NG1.AbsencePeriodsComponent.totalAll"></span><br />
                                  </strong>
                                </td>
                                <td class="right">
                                  <strong>
                                    {{ $ctrl.getLogicForLists().getAbcensePeriodsTotalDays("absencesUnpaid") | sxyCount : "day" }}<br />
                                    {{ $ctrl.getLogicForLists().getAbcensePeriodsTotalDays("absencesPaid") | sxyCount : "day" }}<br />
                                    {{ $ctrl.getLogicForLists().getAbcensePeriodsTotalDays("absencesNoHolidayAccrual") | sxyCount : "day" }}<br />
                                    {{ $ctrl.getLogicForLists().getAbcensePeriodsTotalDays("all") | sxyCount : "day" }}<br />
                                  </strong>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <p ng-if="!$ctrl.getLogicForLists().getAbcencesForPeriod().length" sxy-text="SALAXY.NG1.CalcWorktimeComponent.lists.absencePeriods.noAbsences"></p>
                        </fieldset>
                      </div>
                      <div ng-if="$ctrl.worktime.holidaySpec.code == 'noHolidays'">
                        <strong sxy-text="SALAXY.NG1.CalcWorktimeComponent.absences.calculationDescriptionNoHolidays"></strong>
                      </div>
                      <div ng-if="$ctrl.worktime.holidaySpec.code == 'holidayCompensation'">
  
                        <div style="margin-bottom: 8px; margin-right: 10px;">
                          <div class="float-end">{{ $ctrl.worktime.holidaySpec.compensation | sxyCount : 'percent' }}</div>
                          <strong sxy-text="SALAXY.NG1.CalcWorktimeComponent.absences.calculationDescriptionHolidayCompensation"></strong>
                        </div>
                        <div style="margin-bottom: 8px; margin-right: 10px;" ng-if="$ctrl.worktime.holidaySpec.bonus > 0">
  
                          <div class="float-end">{{ $ctrl.worktime.holidaySpec.bonus | sxyCount : 'percent' }}</div>
                          <strong sxy-text="SALAXY.NG1.CalcWorktimeComponent.absences.calculationDescriptionHolidayBonus" pre="+ "></strong>
                        </div>
                        <div ng-if="!$ctrl.worktime.holidaySpec.bonus" sxy-text="SALAXY.NG1.CalcWorktimeComponent.absences.calculationDescriptionNoHolidayBonus"></div>
                      </div>
                      <div ng-if="$ctrl.isHolidayAccrual">
                      <button ng-if="!$ctrl.currentCalc.isReadOnly" type="button" class="btn btn-default" ng-click="$ctrl.openCalcLeavesDialog()">{{"SALAXY.UI_Terms.edit" | sxyTranslate}}...</button> 
                      <fieldset >
                        <table class="table table-striped table-sm" ng-if="$ctrl.getLogicForLists().getAnnualLeavesForPeriod().length">
                          <thead>
                            <tr>
                              <th sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidays.tableHead.period"></th>
                              <th class="right" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidays.tableHead.daysCount"></th>
                            </tr>
                          </thead>
                          <tr ng-repeat="row in $ctrl.getLogicForLists().getAnnualLeavesForPeriod()">
                            <td>
                              <salaxy-avatar class="salaxy-calc-row-type-avatar float-start" avatar="{ color: '#2b507c', initials: (row.period.daysCount + 'pv'), entityType: 'company' }"></salaxy-avatar>
                              <strong>{{ row.period | sxyDateRange }}</strong>
                              <br />
                              <small>
                                <div class="truncate" style="max-width: 250px;">{{ $ctrl.getLogicForLists().getAnnualLeaveDescription(row) }}</div>
                              </small>
                            </td>
                            <td class="right">
                              <strong>{{ row.period.daysCount | sxyCount : "day"  }}</strong>
                            </td>
                          </tr>
                          <tr class="total">
                            <td>
                              <salaxy-avatar class="salaxy-calc-row-type-avatar float-start" avatar="{ color: '#2b507c', initials: 'sum', entityType: 'company' }"></salaxy-avatar>
                              <strong sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidays.tableBody.total"></strong>
                              <br />
                              <small>
                                <div class="truncate" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidays.tableBody.totalMore"></div>
                              </small>
                            </td>
                            <td class="right">
                              <strong>{{ $ctrl.getLogicForLists().getAnnualLeavesTotalDays() | sxyCount : "day" }}</strong>
                            </td>
                          </tr>
                        </table>
                        <p ng-if="!$ctrl.getLogicForLists().getAnnualLeavesForPeriod().length" sxy-text="SALAXY.NG1.CalcWorktimeComponent.lists.annualLeaves.noAnnualLeaves"></p>
                      </fieldset>  
                    </div>
                  </div>
                  <div class="tab-pane" id="absences-tab">
                    <div sxy-if-role="auth" ng-controller="WorkerAbsencesCrudController as $absencesCtrl" ng-init="$absencesCtrl.employmentId=$ctrl.currentCalc.worker.employmentId">
                      <salaxy-absence-periods parent="$absencesCtrl.current" condensed="true" on-commit="$ctrl.absencesChanged($absencesCtrl)" ng-if="$absencesCtrl.current" ></salaxy-absence-periods>
                    </div>
                    <div sxy-if-role="!auth">
                      <p sxy-html="SALAXY.NG1.CalcWorktimeComponent.anonDemoText.html"></p>
                      <salaxy-absence-periods parent="$ctrl.demoData.absences" condensed="true" on-commit="$ctrl.reloadHolidays()"></salaxy-absence-periods>
                    </div>
                    <p>&nbsp;</p>
                    <small>
                      <p sxy-text="SALAXY.NG1.CalcWorktimeComponent.absences.absencesAttention"></p>
                    </small>
                  </div>
                  <div class="tab-pane" id="leaves-tab">
                    <div ng-if="$ctrl.isHolidayAccrual">
                      <div ng-controller="HolidayYearCrudController as $holidaysCtrl" ng-init="$holidaysCtrl.employmentId=$ctrl.currentCalc.worker.employmentId;$holidaysCtrl.forDate=$ctrl.currentCalc.info.workStartDate">
                        <salaxy-holiday-year-holidays parent="$holidaysCtrl.current" condensed="true" on-commit="$ctrl.holidaysChanged($holidaysCtrl)" ng-if="$holidaysCtrl.current" ></salaxy-holiday-year-holidays>
                      </div>
                      <p>&nbsp;</p>
                      <small>
                        <p sxy-text="SALAXY.NG1.CalcWorktimeComponent.absences.absencesAttention"></p>
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <button ng-show="!$ctrl.currentCalc.isReadOnly" class="btn btn-warning btn-lg salaxy-calc-btn-recalculate" type="submit">{{ $ctrl.hasHolidaysOrAbsences() ?
      ('SALAXY.NG1.CalcWorktimeComponent.absences.calculateButtonText' | sxyTranslate) : ('SALAXY.UI_Terms.updateCalculation' |sxyTranslate) }}</button>
  </form>
</div>`), s.put("salaxy-components/calc/CostAccounting.html", `<div class="salaxy-component salaxy-cost-accounting">
  <div ng-if="$ctrl.current.length > 0 || $ctrl.definitions.length > 0">
    <fieldset>
      <legend sxy-text="SALAXY.NG1.CalcCostAccountingComponent.title"></legend>
      <div ng-repeat="dimension in $ctrl.definitions">
        <div ng-if="!dimension.allowCostSharing">
          <div class="form-horizontal">
            <div class="row">
              <div class="col-md-11">
                <salaxy-input-typeahead class="text-muted" ng-if="$ctrl.isInherited(dimension.id) && $ctrl.hasOptions(dimension.id, $ctrl.getInheritedSingleValue(dimension.id).value)" label="{{(dimension.label || 'SALAXY.NG1.CalcCostAccountingComponent.defaultLabel') | sxyTranslate}}" ng-model="$ctrl.getInheritedSingleValue(dimension.id).value"
                  label-format="text-value" get-options="$ctrl.getOptions(dimension.id)" name="single" read-only="true">
                </salaxy-input-typeahead>
                <salaxy-input class="text-muted" ng-if="$ctrl.isInherited(dimension.id) && !$ctrl.hasOptions(dimension.id, $ctrl.getInheritedSingleValue(dimension.id).value)" label="{{(dimension.label || 'SALAXY.NG1.CalcCostAccountingComponent.defaultLabel') | sxyTranslate}}" ng-model="$ctrl.getInheritedSingleValue(dimension.id).value" name="single"
                  read-only="true">
                </salaxy-input>

                <salaxy-input-typeahead ng-if="!$ctrl.isInherited(dimension.id) && $ctrl.hasOptions(dimension.id, $ctrl.getSingleValue(dimension.id).value)" label="{{(dimension.label || 'SALAXY.NG1.CalcCostAccountingComponent.defaultLabel') | sxyTranslate}}" ng-model="$ctrl.getSingleValue(dimension.id).value"
                  label-format="text-value" options="$ctrl.getOptions(dimension.id)" name="single" read-only="$ctrl.readOnly" input-mode="{{$ctrl.inputMode}}" ng-change="$ctrl.setSingleValue(dimension.id, $ctrl.getSingleValue(dimension.id).value)"></salaxy-input-typeahead>

                <salaxy-input ng-if="!$ctrl.isInherited(dimension.id) && !$ctrl.hasOptions(dimension.id, $ctrl.getSingleValue(dimension.id).value)" label="{{(dimension.label || 'SALAXY.NG1.CalcCostAccountingComponent.defaultLabel') | sxyTranslate}}" ng-model="$ctrl.getSingleValue(dimension.id).value" name="single"
                read-only="$ctrl.readOnly" input-mode="{{$ctrl.inputMode}}" ng-change="$ctrl.setSingleValue(dimension.id, $ctrl.getSingleValue(dimension.id).value)">
                </salaxy-input>
              </div>
              <div class="col-md-1">
                <div ng-if="!$ctrl.readOnly && $ctrl.isInherited(dimension.id)" class="btn float-end" ng-click="$ctrl.setSingleValue(dimension.id, $ctrl.getInheritedSingleValue(dimension.id).value)">
                  <i class="bi bi-pencil-fill clickable"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div ng-if="dimension.allowCostSharing">
          <div class="form-horizontal">
            <div class="row">
              <div class="col-md-11">    
                <table ng-if="$ctrl.isInherited(dimension.id)" class="table">
                  <thead>
                    <tr>
                      <th class="text-muted">{{(dimension.label || 'SALAXY.NG1.CalcCostAccountingComponent.defaultLabel') | sxyTranslate}}</th>
                      <th class="right text-muted">{{"SALAXY.NG1.CalcCostAccountingComponent.percent" | sxyTranslate}}</th>
                      <th class="right">
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr ng-repeat="item in $ctrl.getInheritedValues(dimension.id)">
                      <td>
                        <salaxy-input-typeahead class="text-muted" ng-if="$ctrl.hasOptions(item.id, item.value)" ng-model="item.value" label-format="text-value" get-options="$ctrl.getOptions(dimension.id)" name="{{ 'id' + $index }}" label-type="plain" read-only="true"></salaxy-input-typeahead>
                        <salaxy-input class="text-muted" ng-if="!$ctrl.hasOptions(item.id, item.value)" ng-model="item.value" name="{{ 'id' + $index }}" label-type="plain" read-only="true"></salaxy-input>
                      </td>
                      <td class="right">
                        <salaxy-input-number class="text-muted" ng-model="item.percent" name="{{ 'percent' + $index }}" label-type="plain" read-only="true" unit="percent"></salaxy-input-number>
                      </td>
                      <td class="text-right">
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr class="total">
                      <td class="text-muted">{{"SALAXY.UI_Terms.total" | sxyTranslate}}</td>
                      <td class="right text-muted">{{ $ctrl.getInheritedSum(dimension.id) | sxyCount : 'percent' }}</td>
                      <td class="right"></td>
                    </tr>
                  </tfoot>
                </table>
                <table ng-if="!$ctrl.isInherited(dimension.id)" class="table">
                  <thead>
                    <tr>
                      <th>{{(dimension.label || 'SALAXY.NG1.CalcCostAccountingComponent.defaultLabel') | sxyTranslate}}</th>
                      <th class="right">{{"SALAXY.NG1.CalcCostAccountingComponent.percent" | sxyTranslate}}</th>
                      <th class="right">
                        <button type="button" class="btn btn-primary btn-xs" ng-if="!$ctrl.readOnly" ng-click="$ctrl.current.push({'id': dimension.id})" sxy-text="SALAXY.UI_Terms.addRow"></button>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr ng-repeat="item in $ctrl.getValues(dimension.id)">
                      <td>
                        <salaxy-input-typeahead ng-if="$ctrl.hasOptions(item.id, item.value)" ng-model="item.value" label-format="text-value" options="$ctrl.getOptions(dimension.id)" name="{{ 'id' + $index }}" label-type="plain" read-only="$ctrl.readOnly"></salaxy-input-typeahead>
                        <salaxy-input ng-if="!$ctrl.hasOptions(item.id, item.value)" ng-model="item.value" name="{{ 'id' + $index }}" label-type="plain" read-only="$ctrl.readOnly"></salaxy-input>
                      </td>
                      <td class="right">
                        <salaxy-input-number ng-model="item.percent" name="{{ 'percent' + $index }}" label-type="plain" read-only="$ctrl.readOnly" unit="percent"></salaxy-input-number>
                      </td>
                      <td class="text-right">
                        <button ng-if="!$ctrl.readOnly" type="button" class="btn btn-danger" ng-click="$ctrl.deleteValue(item)">
                          <i class="bi bi-trash" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr class="total">
                      <td>{{"SALAXY.UI_Terms.total" | sxyTranslate}}</td>
                      <td class="right">{{ $ctrl.getSum(dimension.id) | sxyCount : 'percent' }}</td>
                      <td class="right"></td>
                    </tr>
                  </tfoot>
                </table>
              </div>
              <div class="col-md-1">
                <div class="btn btn-padding-right" ng-if="!$ctrl.readOnly && $ctrl.isInherited(dimension.id)">
                  <i ng-click="$ctrl.setValues($ctrl.getInheritedValues(dimension.id))" class="bi bi-pencil-fill clickable"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div ng-if="$ctrl.hasObsoleteValues">
        <table class="table">
          <thead>
            <tr>
              <th sxy-text="SALAXY.MODEL.CostAccountingDimensionDefinition.id.title"></th>
              <th sxy-text="SALAXY.MODEL.CostAccountingDimensionOption.value.title"></th>
              <th class="right">{{"SALAXY.NG1.CalcCostAccountingComponent.percent" | sxyTranslate}}</th>
              <th class="right"></th>
            </tr>
          </thead>
          <tbody>
            <tr ng-repeat="item in $ctrl.obsoleteValues">
              <td>
                <salaxy-input ng-model="item.id" name="{{ 'nameObsolete' + $index }}" label-type="plain" read-only="true"></salaxy-input>
              </td>
              <td>
                <salaxy-input ng-model="item.value" name="{{ 'idObsolete' + $index }}" label-type="plain" read-only="true"></salaxy-input-enum>
              </td>
              <td>
                <salaxy-input-number ng-if="item.percent" ng-model="item.percent" name="{{ 'percentObsolete' + $index }}" label-type="plain" read-only="true" unit="percent"></salaxy-input-number>
              </td>
              <td class="text-end">
                <button ng-if="!$ctrl.readOnly" type="button" class="btn btn-danger" ng-click="$ctrl.deleteValue(item)">
                    <i class="bi bi-trash" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}"></i>
                  </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </fieldset>
  </div>
</div>`), s.put("salaxy-components/calc/details/expenses.html", `<form ng-submit="$ctrl.recalculate()" name="detailsExpenses">
  <div class="salaxy-calc-dialog-body">
    <div class="salaxy-calc-dialog-container">
      <h1 sxy-text="SALAXY.NG1.CalcDetailsDialogComponent.allExpenses.title"></h1>
      <div class="form-horizontal" ng-if="$ctrl.isHousehold">
        <salaxy-input-boolean type="checkbox" name="isHouseholdDeductible" ng-model="$ctrl.isHouseholdDeductible" label="SALAXY.NG1.CalcDetailsDialogComponent.deductions.householdDetuction" label-true="{{'SALAXY.NG1.CalcDetailsDialogComponent.deductions.label' | sxyTranslate}}"></salaxy-input-boolean>
        <salaxy-input-enum label="SALAXY.NG1.CalcDetailsDialogComponent.workType" hidden-options="none" name="taxDeductionCategory" ng-if="$ctrl.isHouseholdDeductible" ng-model="$ctrl.taxDeductionCategory" enum="TaxDeductionWorkCategories" type="select" required></salaxy-input-enum>
      </div>
      <salaxy-calc-rows-2019-editor categories="['expenses']" row-type-select-help="expenses" parent="$ctrl.currentCalc" mode="{{$ctrl.isReadOnly ? 'read-only' : 'edit'}}" title="{{'SALAXY.NG1.CalcDetailsDialogComponent.expenses.title' | sxyTranslate}}"></salaxy-calc-rows-2019-editor>
      <salaxy-calc-rows-2019-editor categories="['benefits']" row-type-select-help="benefits" parent="$ctrl.currentCalc" mode="{{$ctrl.isReadOnly ? 'read-only' : 'edit'}}" title="{{ 'SALAXY.NG1.CalcDetailsDialogComponent.benefits.title2' | sxyTranslate}}"></salaxy-calc-rows-2019-editor>
      <salaxy-calc-rows-2019-editor categories="[ 'deductions']" row-type-select-help="deductions" parent="$ctrl.currentCalc" mode="{{$ctrl.isReadOnly ? 'read-only' : 'edit'}}" title="{{ 'SALAXY.NG1.CalcDetailsDialogComponent.deductions.title' |
        sxyTranslate}}"></salaxy-calc-rows-2019-editor>
      <p>&nbsp;</p>
    </div>
  </div>
  <button ng-if="!$ctrl.isReadOnly && $ctrl.currentCalc.workflow.status !='paymentStarted'" class="btn btn-danger btn-lg salaxy-calc-btn-recalculate" type="submit" sxy-text="SALAXY.UI_Terms.recalculate"></button>
</form>`), s.put("salaxy-components/calc/details/salary.html", `<form ng-submit="$ctrl.recalculate()" name="detailsSalary">
  <div class="salaxy-calc-dialog-body">
    <div class="salaxy-calc-dialog-container">
      <h1 sxy-text="SALAXY.NG1.CalcDetailsDialogComponent.allSalaries.title"></h1>
      <salaxy-calc-rows-2019-editor row-type-select-help="salaries" categories="['salary', 'salaryCalc', 'holidays', 'salaryAdditions']" parent="$ctrl.currentCalc" mode="{{$ctrl.isReadOnly ? 'read-only' : 'edit'}}" title="{{'SALAXY.NG1.CalcDetailsDialogComponent.salaries.title2' | sxyTranslate}}"></salaxy-calc-rows-2019-editor>
      <p>&nbsp;</p>

    </div>
  </div>

  <button ng-if="!$ctrl.isReadOnly && $ctrl.currentCalc.workflow.status != 'paymentStarted'" class="btn btn-success btn-lg salaxy-calc-btn-recalculate" type="submit" sxy-text="SALAXY.UI_Terms.recalculate"></button>
</form>`), s.put("salaxy-components/calc/details/worker.html", `<form ng-submit="$ctrl.recalculate()" name="detailsWork">
  <div class="salaxy-calc-dialog-body">
    <div class="salaxy-calc-dialog-container">
      <div ng-if="!$ctrl.calcSections.get('worker').isSelectionDone">

        <div sxy-if-role="auth">
          <div class="row">
            <div class="col-12 col-sm-7">
              <div class="intro-text">
                <h1 sxy-text="SALAXY.NG1.CalcDetailsWorkerComponent.selectWorker"></h1>
                <p sxy-html="SALAXY.NG1.CalcDetailsWorkerComponent.myWorkers.description.html"></p>
              </div>
            </div>
            <div class="col-12 col-sm-5">
              <button type="button" class="btn add-new-worker btn-primary float-sm-end mb-1" ng-click="$ctrl.showNewWorkerDialog()" sxy-text="SALAXY.NG1.CalcDetailsWorkerComponent.newWorker.cta"></button>
            </div>
            <div class="col-12">
              <div class="table-responsive">
                <salaxy-employment-list mode="select" on-list-select="$ctrl.updateFromEmployment(item.id, true)"></salaxy-employment-list>
              </div>
            </div>
          </div>
        </div>
        <div salaxy-if-role="anon">
          <h1 sxy-text="SALAXY.NG1.CalcDetailsWorkerComponent.selectWorker" ps=" (demo)"></h1>
          <p sxy-text="SALAXY.NG1.CalcDetailsWorkerComponent.notLoggedIn"></p>
          <p>Selecting an employment relation is not supported in the anonymous calculator. Implement if necessary.</p>
        </div>
      </div>
      <div ng-if="$ctrl.calcSections.get('worker').isSelectionDone">
        <salaxy-calc-worker-info model="$ctrl.currentCalc"></salaxy-calc-worker-info>
        <div class="row">
          <div class="col-md-6 col-12 form-horizontal">
            <fieldset>
              <legend sxy-text="SALAXY.NG1.CalcDetailsWorkerComponent.job"></legend>
              <salaxy-input-occupation-type name="occupationCode" ng-model="$ctrl.currentCalc.info.occupationCode" label="SALAXY.MODEL.CalcInfo.occupationCode.title" read-only="$ctrl.isReadOnly"></salaxy-input-occupation-type>
              <salaxy-input name="workDescription" ng-model="$ctrl.currentCalc.info.workDescription" label="SALAXY.MODEL.CalcInfo.workDescription.title" read-only="$ctrl.isReadOnly"></salaxy-input>
              <salaxy-input-collective-bargain-agreement read-only="$ctrl.isReadOnly" name="collectiveBargainAgreement" ng-model="$ctrl.currentCalc.info.cbaCode" label="SALAXY.NG1.WorkerWizardComponent.employment.info.cbaCode"></salaxy-input-collective-bargain-agreement>
              <salaxy-textarea sxy-if-role="!worker" name="salarySlipMessage" ng-model="$ctrl.currentCalc.info.salarySlipMessage" label="SALAXY.MODEL.CalcInfo.salarySlipMessage.title" read-only="$ctrl.isReadOnly"></salaxy-textarea>
            </fieldset>
          </div>
          <div class="col-md-6 col-12 form-horizontal">
              <salaxy-calc-cost-accounting salaxy-if-role="company" calc="$ctrl.current" read-only="$ctrl.isReadOnly"></salaxy-calc-cost-accounting>
          </div>
        </div>
        <div class="row" sxy-if-role="worker">
          <div class="col">
            <a href="#/taxcards" class="btn add-new-worker btn-info" sxy-text="SALAXY.NG1.CalcDetailsWorkerComponent.addSharedTaxCard"></a>
            <a href="#/account" class="btn btn-default" sxy-text="SALAXY.NG1.CalcDetailsWorkerComponent.editAccount"></a>
          </div>
        </div>
        <div class="row" sxy-if-role="!worker">
          <div class="col">
            <span sxy-if-role="auth">
              <span ng-if="$ctrl.currentCalc.worker.tax.snapshot.kind == 'auto'">
                <span class="text-info" ng-if="$ctrl.currentCalc.worker.tax.snapshot.lastChecked != '2000-01-01T00:00:00Z'"><small>{{'SALAXY.NG1.CalcDetailsWorkerComponent.taxCardChecked' | sxyTranslate}} {{$ctrl.currentCalc.worker.tax.snapshot.lastChecked | date: "dd.MM.yyyy HH:mm"}}</small></span>
                <br/>
                <button type="button" ng-disabled="$ctrl.loaders['showRefreshAutoTaxcardDialog']" ng-click="$ctrl.showRefreshAutoTaxcardDialog()" class="btn btn-info" sxy-text="SALAXY.NG1.CalcDetailsWorkerComponent.checkAutomaticTaxcard"></button>
              </span>
              <button type="button" ng-click="$ctrl.showWorkerEditDialog()" class="btn add-new-worker btn-default" sxy-text="SALAXY.NG1.CalcDetailsWorkerComponent.workerEdit"></button>
            </span>
            <button ng-if="!$ctrl.isReadOnly &&  $ctrl.currentCalc.workflow.status != 'paymentStarted'" ng-click="$ctrl.resetWorker()" type="button" class="btn add-new-worker btn-default" sxy-text="SALAXY.NG1.CalcDetailsWorkerComponent.resetWorker"></button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <button ng-if="!$ctrl.isReadOnly" ng-disabled="!$ctrl.calcSections.get('worker').isSelectionDone" class="btn btn-info btn-lg salaxy-calc-btn-recalculate" type="submit" sxy-text="SALAXY.UI_Terms.recalculate"></button>
</form>`), s.put("salaxy-components/calc/details/worktime-pro.html", `<div class="modal-header bg-primary d-flex">
  <h1 class="d-flex align-items-center m-0">
    <span class="badge bg-secondary text-dark me-2">Pro</span>
    <span sxy-text="SALAXY.NG1.CalcWorktimeComponent.absences.proTabTitle"></span>
  </h1>
  <button type="button" class="btn-close btn-close ms-auto" ng-click="$close('cancel')" aria-label="Close"></button>
</div>
<div class="modal-body">
  <div class="form-horizontal form-condensed">
    <p class="lead" sxy-text="SALAXY.NG1.CalcDetailsWorktimeProComponent.lead.text"></p>
    <div class="row">
      <div class="col-sm-6">
        <fieldset>
          <legend sxy-text="SALAXY.NG1.CalcDetailsWorktimeProComponent.basicInfo"></legend>
          <salaxy-date-range read-only="true" ng-model="$ctrl.data.worktime.workDays" name="workDays" label="SALAXY.NG1.CalcDetailsWorktimeProComponent.workDays"></salaxy-date-range>
        </fieldset>
        <fieldset>
          <salaxy-input-number ng-model="$ctrl.data.worktime.absencesDailySalary" name="absencesDailySalary" label="SALAXY.NG1.CalcWorktimeComponent.lists.absencePeriods.absencesDailySalary" label-cols="col-sm-6"></salaxy-input-number>
          <table class="table table-striped table-sm" ng-if="$ctrl.data.logic.getAbcencesForPeriod().length">
            <thead>
              <tr>
                <th sxy-text="SALAXY.NG1.AbsencePeriodsComponent.headerAbsence"></th>
                <th class="right" sxy-text="SALAXY.NG1.AbsencePeriodsComponent.headerDays"></th>
              </tr>
            </thead>
            <tbody>
              <tr ng-repeat="row in $ctrl.data.logic.getAbcencesForPeriod()">
                <td>
                  <salaxy-avatar class="salaxy-calc-row-type-avatar float-start" avatar="{ color: '#2b507c', initials: (row.period.daysCount + 'pv'), entityType: 'company' }"></salaxy-avatar>
                  <strong>{{ "AbsenceCauseCode." + row.causeCode | sxyEnum }}</strong><br />
                  <div class="float-start" style="padding: 0px;">
                    {{ row.isPaid ? ('SALAXY.NG1.AbsencePeriodsComponent.isPaid' | sxyTranslate) : ('SALAXY.NG1.AbsencePeriodsComponent.notPaid' |sxyTranslate) }}
                    <span ng-if="row.isPaid != row.isHolidayAccrual"> {{ row.isHolidayAccrual ? ('SALAXY.NG1.AbsencePeriodsComponent.isAccrual' | sxyTranslate) : ('SALAXY.NG1.AbsencePeriodsComponent.notAccrual' | sxyTranslate) }}</span>
                  </div>
                  <div class="truncate" style="max-width: 250px; padding: 0px;">
                    &nbsp;{{ row.notes }}
                  </div>
                </td>
                <td class="right">
                  <strong>{{ row.period.daysCount | sxyCount : "day" }}</strong><br /> {{ row.period | sxyDateRange }}
                </td>
              </tr>
              <tr class="total">
                <td>
                  <salaxy-avatar class="salaxy-calc-row-type-avatar float-start" style="margin-bottom: 20px" avatar="{ color: '#2b507c', initials: 'sum', entityType: 'company' }"></salaxy-avatar>
                  <strong>
                    <span sxy-text="SALAXY.NG1.AbsencePeriodsComponent.totalUnpaid"></span><br />
                                <span sxy-text="SALAXY.NG1.AbsencePeriodsComponent.totalNoHolidayAccrual"></span><br />
                                  <span sxy-text="SALAXY.NG1.AbsencePeriodsComponent.totalAll"></span><br />
                  </strong>
                </td>
                <td class="right">
                  <strong>
                    {{ $ctrl.data.logic.getAbcensePeriodsTotalDays("absencesUnpaid") | sxyCount : "day" }}<br />
                    {{ $ctrl.data.logic.getAbcensePeriodsTotalDays("absencesNoHolidayAccrual") | sxyCount : "day" }}<br />
                    {{ $ctrl.data.logic.getAbcensePeriodsTotalDays("all") | sxyCount : "day" }}<br />
                  </strong>
                </td>
              </tr>
            </tbody>
          </table>
          <p ng-if="!$ctrl.data.logic.getAbcencesForPeriod().length" sxy-text="SALAXY.NG1.CalcWorktimeComponent.lists.absencePeriods.noAbsences"></p>
        </fieldset>
          <fieldset  ng-if="$ctrl.data.worktime.holidaySpec.code == 'permanent14Days' || $ctrl.data.worktime.holidaySpec.code == 'permanent35Hours' || $ctrl.data.worktime.holidaySpec.code == 'temporaryTimeOff' || $ctrl.data.worktime.holidaySpec.code == 'other'">
          <table class="table table-striped table-sm" ng-if="$ctrl.data.logic.getAnnualLeavesForPeriod().length">
            <thead>
              <tr>
                <th sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidays.tableHead.period"></th>
                <th class="right" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidays.tableHead.daysCount"></th>
                <th class="right" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidays.tableHead.bonusDaysCount"></th>
              </tr>
            </thead>
            <tr ng-repeat="row in $ctrl.data.logic.getAnnualLeavesForPeriod()">
              <td>
                <salaxy-avatar class="salaxy-calc-row-type-avatar float-start" avatar="{ color: '#2b507c', initials: (row.period.daysCount + 'pv'), entityType: 'company' }"></salaxy-avatar>
                <strong>{{ row.period | sxyDateRange }}</strong>
                <br />
                <small>
                  <div class="truncate" style="max-width: 250px;">{{ $ctrl.data.logic.getAnnualLeaveDescription(row) }}</div>
                </small>
              </td>
              <td class="right">
                <strong>{{ row.period.daysCount | sxyCount : "day"  }}</strong>
              </td>
              <td class="right">
                <strong>{{ row.bonusDaysCount | sxyCount : "day"  }}</strong>
              </td>
            </tr>
            <tr class="total">
              <td>
                <salaxy-avatar class="salaxy-calc-row-type-avatar float-start" avatar="{ color: '#2b507c', initials: 'sum', entityType: 'company' }"></salaxy-avatar>
                <strong sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidays.tableBody.total"></strong>
                <br />
                <small>
                  <div class="truncate" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidays.tableBody.totalMore"></div>
                </small>
              </td>
              <td class="right">
                <strong>{{ $ctrl.data.logic.getAnnualLeavesTotalDays() | sxyCount : "day" }}</strong>
              </td>
              <td class="right">
                <strong>{{ $ctrl.data.logic.getAnnualLeavesBonusTotalDays() | sxyCount : "day" }}</strong>
              </td>
            </tr>
          </table>
          <p ng-if="!$ctrl.data.logic.getAnnualLeavesForPeriod().length" sxy-text="SALAXY.NG1.CalcWorktimeComponent.lists.annualLeaves.noAnnualLeaves"></p>
        </fieldset>      
      </div>
      <div class="col-sm-6">
          <fieldset ng-if="$ctrl.data.worktime.accrualSpec.code == 'permanent14Days' || $ctrl.data.worktime.accrualSpec.code == 'permanent35Hours' || $ctrl.data.worktime.accrualSpec.code == 'temporaryTimeOff' || $ctrl.data.worktime.accrualSpec.code == 'other'">
          <legend sxy-text="SALAXY.NG1.CalcDetailsWorktimeProComponent.holidays"></legend>
          <table class="table table-sm">
            <thead>
              <th sxy-text="SALAXY.NG1.CalcDetailsWorktimeProComponent.headerMonth"></th>
              <th sxy-text="SALAXY.NG1.CalcDetailsWorktimeProComponent.headerHolidays" class="right"></th>
              <th sxy-text="SALAXY.NG1.CalcDetailsWorktimeProComponent.headerAway" class="right"></th>
              <th sxy-text="SALAXY.NG1.CalcDetailsWorktimeProComponent.headerDate" class="right"></th>
              <th sxy-text="SALAXY.NG1.CalcDetailsWorktimeProComponent.headerHours" class="right"></th>
            </thead>
            <tbody>
              <tr ng-repeat="month in $ctrl.data.worktime.accruals">
                <td>{{ month.month | sxyDate }}</td>
                <td class="right">{{ month.daysAccrued | sxyCount : "days" }}</td>
                <td class="right">{{ month.absencesDays | sxyCount : "days" }}</td>
                <td class="right">{{ month.workDays | sxyCount : "days" }}</td>
                <td class="right">{{ month.workHours | sxyCount : "hours" }}</td>
              </tr>
            </tbody>
          </table>
        </fieldset>
        <fieldset ng-if="$ctrl.data.worktime.holidaySpec.code != 'undefined'">
          <legend sxy-text="SALAXY.NG1.CalcDetailsWorktimeProComponent.holidayYearSettings"></legend>
          <salaxy-form-group name="employmentPeriod" class="salaxy-read-only" label-cols="col-sm-6" label="SALAXY.NG1.CalcDetailsWorktimeProComponent.employmentPeriod">
            <div class="form-control-plaintext">
              {{$ctrl.data.worktime.holidaySpec.employmentPeriod | sxyDateRange }}
            </div>
          </salaxy-form-group>
          <salaxy-input-enum disabled="true" ng-model="$ctrl.data.worktime.holidaySpec.wageBasis" name="wageBasis" enum="WageBasis" hidden-options="other" label="SALAXY.NG1.CalcDetailsWorktimeProComponent.wageBasis" label-cols="col-sm-6"></salaxy-input-enum>
          <salaxy-input-enum disabled="true" name="holidayPayCalculation" ng-model="$ctrl.data.worktime.holidaySpec.holidayPayCalculation" label="SALAXY.MODEL.HolidaySpecificationForYear.holidayPayCalculation.title" options="$ctrl.data.logic.getholidayPayCalculationOptions()" disable-cache="true" label-cols="col-sm-6"></salaxy-input-enum>
          <salaxy-input-number ng-model="$ctrl.data.worktime.leavesDailySalary" name="leavesDailySalary" label="SALAXY.NG1.CalcDetailsWorktimeProComponent.leavesDailySalary" label-cols="col-sm-6"></salaxy-input-number>

          <salaxy-input-number ng-model="$ctrl.data.worktime.holidaySpec.compensation" name="compensation" ng-if="$ctrl.data.worktime.holidaySpec.code == 'holidayCompensation'" label-cols="col-sm-6" unit="percent" required label="SALAXY.MODEL.HolidaySpecificationForYear.compensation.label" ></salaxy-input-number>     
            <salaxy-input-number  ng-model="$ctrl.data.worktime.holidaySpec.compensation" name="compensation" ng-if="($ctrl.data.worktime.holidaySpec.code == 'temporaryTimeOff' || $ctrl.data.worktime.holidaySpec.code == 'other') && $ctrl.data.worktime.holidaySpec.holidayPayCalculation == 'holidayCompensation'" label-cols="col-sm-6" unit="percent" required label="SALAXY.MODEL.HolidaySpecificationForYear.compensation.title" ></salaxy-input-number>
        
          <!-- accruals or compensation -->
            <salaxy-input-enum ng-if="($ctrl.data.worktime.holidaySpec.code == 'permanent14Days' || $ctrl.data.worktime.holidaySpec.code == 'permanent35Hours' || $ctrl.data.worktime.holidaySpec.code == 'temporaryTimeOff' || $ctrl.data.worktime.holidaySpec.code == 'other')" ng-model="$ctrl.data.worktime.holidaySpec.bonusMethod" name="bonusMethod" filter="none,payForHolidaySalary,paySelectedDays" enum="HolidayBonusPaymentMethod" label="SALAXY.NG1.CalcDetailsWorktimeProComponent.bonusMethod" label-cols="col-sm-6"></salaxy-input-enum>
          <salaxy-input-enum ng-if="($ctrl.data.worktime.holidaySpec.code == 'holidayCompensation')" ng-model="$ctrl.data.worktime.holidaySpec.bonusMethod" name="bonusMethod" filter="none,payForHolidaySalary" enum="HolidayBonusPaymentMethod" label="SALAXY.NG1.CalcDetailsWorktimeProComponent.bonusMethod" label-cols="col-sm-6"></salaxy-input-enum>
            <salaxy-input-number ng-if="($ctrl.data.worktime.holidaySpec.code == 'holidayCompensation' || $ctrl.data.worktime.holidaySpec.code == 'permanent14Days' || $ctrl.data.worktime.holidaySpec.code == 'permanent35Hours' || $ctrl.data.worktime.holidaySpec.code == 'temporaryTimeOff' || $ctrl.data.worktime.holidaySpec.code == 'other')" ng-model="$ctrl.data.worktime.holidaySpec.bonus" name="bonus" label="SALAXY.NG1.CalcDetailsWorktimeProComponent.bonus" label-cols="col-sm-6" unit="percent"></salaxy-input-number>
        </fieldset>
          <fieldset ng-if="$ctrl.data.worktime.holidaySpec.code == 'permanent14Days' || $ctrl.data.worktime.holidaySpec.code == 'permanent35Hours' || $ctrl.data.worktime.holidaySpec.code == 'temporaryTimeOff' || $ctrl.data.worktime.holidaySpec.code == 'other'">
          <legend sxy-text="SALAXY.NG1.CalcWorktimeComponent.availableHolidays.legend"></legend>
          <salaxy-input-number ng-model="$ctrl.data.worktime.holidayPayAccrualRemaining" name="holidayPayAccrualRemaining" disabled="true" label="SALAXY.NG1.CalcWorktimeComponent.availableHolidays.holidayPayAccrualRemaining" label-cols="col-sm-7"></salaxy-input-number>
          <salaxy-input-number ng-if="$ctrl.data.worktime.holidaySpec.bonusMethod != 'none'" ng-model="$ctrl.data.worktime.holidayBonusAccrualRemaining" name="holidayBonusAccrualRemaining" disabled="true" label="SALAXY.NG1.CalcWorktimeComponent.availableHolidays.holidayBonusAccrualRemaining" label-cols="col-sm-7"></salaxy-input-number>
        </fieldset>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer"></div>`), s.put("salaxy-components/calc/PayButton.html", `<div class="salaxy-pay-button salaxy-component">
  <button ng-if="($ctrl.mode || 'pay-button') != 'channel-select'" ng-disabled="$ctrl.disabled" type="button" ng-click="$ctrl.goToInvoices()" class="btn btn-primary btn-labeled-right btn-pay" ng-class="$ctrl.buttonClass + ($ctrl.mode == 'button-and-channel' ? ' btn-block' : '')">
    {{ $ctrl.getPaymentButtonText() }} <i class="bi bi-currency-euro"></i>
  </button>
  <div>
    <div ng-if="$ctrl.mode == 'button-and-channel'" class="payment-channel-selection-label mt-4" sxy-text="SALAXY.NG1.PayButtonComponent.paymentChannelLabel" ps=":"></div>
    <div ng-if="($ctrl.mode || 'pay-button') != 'pay-button'" class="dropdown" ng-class="$ctrl.buttonClass + ($ctrl.mode == 'button-and-channel' ? ' btn-block' : '')">
      <button id="btnChannel" type="button" class="btn btn-default btn-block dropdown-toggle justify-content-start" data-bs-toggle="dropdown">
        <salaxy-avatar class="py-1" avatar="$ctrl.currentChannel"></salaxy-avatar>
        <span class="button-text">
          {{ $ctrl.currentChannel.displayName }}
        </span>
      </button>
      <ul class="dropdown-menu" role="menu" aria-labelledby="btnChannel">
        <li role="menuitem" ng-class="{ 'disabled': channel.id == 'zeroPayment' }" ng-repeat="channel in $ctrl.allChannels">
          <a href="" ng-click="$ctrl.setPaymentChannel(channel.id)" class="dropdown-item text-uppercase d-flex p-2" title="{{ channel.description }}">
            <salaxy-avatar style="font-size: 1.8em; margin: -2px 6px -2px 0px;" avatar="channel"></salaxy-avatar>
            <span class="button-text">{{ channel.displayName }}</span>
          </a>
        </li>
        <li>
          <a href="#/settings/payment-channel-settings" class="dropdown-item text-uppercase" sxy-text="SALAXY.NG1.PayButtonComponent.moreOptionsLink" ps="..."></a>
        </li>
      </ul>
    </div>
  </div>
</div>`), s.put("salaxy-components/calc/payroll/PayrollCalcs.html", `<div class="salaxy-component salaxy-calc-group-edit">
  <div class="payroll-calculations-container">

    <div class="dropdown toolbar-top" ng-if="$ctrl.hasCalculations">
      <ng-include src="'salaxy-components/calc/payroll/PayrollCalcs_toolbar.html'"></ng-include>
    </div>
    

    <div ng-if="!$ctrl.hasCalculations">
      <div class="salaxy-placeholder-empty placeholder-md placeholder-default text-center">
        <h4 sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.placeholder.title"></h4>
        <div ng-if="$ctrl.mode != 'service'" class="btn-group dropdown">
          <button type="button" class="btn btn-labeled-left btn-primary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false"><i class="bi bi-plus-lg"></i>
            <span sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.addCalculation"></span>
          </button>
          <ul class="dropdown-menu" role="menu" aria-labelledby="addcalculation">
            <li role="menuitem">
              <a ng-click="$ctrl.createNewCalc()" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.addWorker"></a>
            </li>
            <li role="menuitem">
              <a ng-click="$ctrl.addExistingCalc('draft')" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.addDraft"></a>
            </li>
            <li role="menuitem">
              <a ng-click="$ctrl.addExistingCalc('paid')" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.addCopy"></a>
            </li>
            <li role="menuitem">
              <a ng-click="$ctrl.mergePayroll(true)" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.addPayroll"></a>
            </li>
          </ul>
        </div>
        <button ng-if="$ctrl.mode == 'service'" type="button" class="btn btn-labeled-right btn-primary" ng-click="$ctrl.createNewCalc()">
          <span sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.addCalculation"></span><i class="bi bi-plus-lg"></i>
        </button>
      </div>
    </div>
    <div ng-repeat="calc in $ctrl.calcs | filter: {worker:{avatar:{displayName:$ctrl.searchByName}}}">
      
      <div class="payroll-single-calculation" ng-class="{'error-container': !$ctrl.getValidation(calc).isValid }">
        <div class="float-end icon-container btn-group">
          <button class="btn btn-transparent btn-xs toggle-details" ng-click="$ctrl.getUi(calc).isCollapsed = !$ctrl.getUi(calc).isCollapsed">
            <i class="bi" ng-class="{'bi-chevron-up' : !$ctrl.getUi(calc).isCollapsed,  'bi-chevron-down' : $ctrl.getUi(calc).isCollapsed}"
               title="{{'SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.toggle' | sxyTranslate}}">
            </i>
          </button>
          <div class="btn-group btn-group-sm">
            <button class="btn btn-transparent btn-xs options dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false" ng-if="!$ctrl.isReadOnly">
              <i class="bi bi-three-dots" title="{{'SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.options' | sxyTranslate}}"></i>
            </button>
            <ul class="dropdown-menu" role="menu" ng-if="!$ctrl.isReadOnly">
              <ng-include src="'salaxy-components/calc/payroll/PayrollCalcs_edit_dropdown.html'"></ng-include>
            </ul>
          </div>
        </div>
        <div class="payroll-worker-summary clickable" ng-if="$ctrl.getUi(calc).isCollapsed" ng-click="$ctrl.getUi(calc).isCollapsed = !$ctrl.getUi(calc).isCollapsed">
          <div class="avatar-container">
            <salaxy-avatar avatar="calc.worker.avatar"></salaxy-avatar>
            <span class="worker-name">{{calc.worker.avatar.displayName}}</span>
            <span class="calculation-summary">{{calc.result.totals.totalGrossSalary | currency }}</span>
            <span ng-if="!$ctrl.getValidation(calc).isValid" class="error-summary text-danger d-none d-sm-inline" sxy-text="{{'SALAXY.VALIDATION.' + $ctrl.getValidation(calc).errors[0].code + '.label'}}"></span>
            <span ng-if="!$ctrl.isReadOnly">
              <span ng-controller="EmploymentCrudController as $employment">
                <salaxy-workflow-badge ng-if="$ctrl.employments[calc.worker.employmentId]" mode="horizontal" model="$ctrl.employments[calc.worker.employmentId]" api-ctrl="$employment" wf-types="'EmployerMessageRecord'"></salaxy-workflow-badge>
              </span>
            </span>
          </div>
        </div>
        <div class="payroll-worker-details" ng-if="!$ctrl.getUi(calc).isCollapsed">
          <div class="row payroll-worker-info">
            <div class="col-2 col-sm-2">
              <div class="avatar-container">
                <salaxy-avatar avatar="calc.worker.avatar"></salaxy-avatar>
              </div>
            </div>
            <div class="col-9">
              <h3 class="worker-name clickable" ng-click="$ctrl.getUi(calc).isCollapsed = !$ctrl.getUi(calc).isCollapsed">{{calc.worker.avatar.displayName}}</h3>
              <div class="row">
                <div class="col-12 col-sm-5 worker-info-col">
                  {{calc.worker.paymentData.email}}<br> {{calc.worker.paymentData.telephone}}
                  <br>
                  <span ng-if="calc.worker.paymentData.ibanNumber">{{calc.worker.paymentData.ibanNumber | sxyIban}}</span>
                  <span ng-if="!calc.worker.paymentData.ibanNumber"><span class="text-danger"
                      sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.workerInfo.noIban"></span></span>
                  <br>
                  <button class="btn btn-secondary btn-xs btn-edit-worker" ng-click="$ctrl.showEditWorkerDialog(calc)" ng-class="{'btn-danger':!calc.worker.paymentData.ibanNumber}" ng-if="!$ctrl.isReadOnly" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.workerInfo.editWorker"></button>
                </div>
                <div class="col-12 col-sm-7 worker-info-col">
                  <span>
                    <span ng-class="{'text-danger': $ctrl.getTaxUi(calc).status != 'ok'}">{{ $ctrl.getTaxUi(calc).text }}</span>
                    <button ng-if="!$ctrl.isReadOnly && $ctrl.getTaxUi(calc).status != 'ok'" class="btn btn-xs btn-default" ng-click="$ctrl.commitCalc(calc, false, true)"><i class="bi bi-arrow-repeat"></i></button>
                    <button ng-if="!$ctrl.isReadOnly && $ctrl.getTaxUi(calc).status == 'missing'" class="btn btn-xs btn-default" ng-click="$ctrl.showAddNewTaxcard(calc)"><i class="bi bi-plus-lg"></i></button>
                  </span>
                  <span ng-if="calc.worker.tax.snapshot.kind == 'auto'">
                    <br />
                    <span class="text-info" ng-if="calc.worker.tax.snapshot.lastChecked != '2000-01-01T00:00:00Z'"><small>{{'SALAXY.NG1.PayrollComponent.payrollCalcs.taxCard.taxCardChecked' | sxyTranslate}} {{calc.worker.tax.snapshot.lastChecked | date: "dd.MM.yyyy HH:mm"}}</small></span>
                  <br/>
                  <button ng-if="!$ctrl.isReadOnly" class="btn btn-xs btn-info" ng-disabled="$ctrl.loaders['showRefreshAutoTaxcardDialog']" ng-click="$ctrl.showRefreshAutoTaxcardDialog(calc)" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.taxCard.refreshAutoTaxCard"></button>
                  </span>
                  <br> <strong sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.workerInfo.salaryPeriod"></strong>
                  <span>{{ calc.info | sxyDateRange }} ({{ calc.framework.numberOfDays }} <span
                      sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.workerInfo.salaryPeriodDaysCount"></span>)</span>
                  <button class="btn btn-transparent btn-xs" ng-click="$ctrl.showDateRangeForCalculation(calc)" ng-if="!$ctrl.isReadOnly"><i class="bi bi-pencil-fill"></i></button>
                  <div ng-if="$ctrl.isDateDifferent(calc)">
                    <del class="small">{{ $ctrl.current.input.period | sxyDateRange }} ({{ $ctrl.current.input.period.daysCount }} <span
                        sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.workerInfo.salaryPeriodDaysCount"></span>)</del>
                  </div>
                  <table ng-if="!('disableHolidays' | sxyIsInRole)" class="text-small">
                    <tbody>
                      <tr>
                        <td sxy-text="SALAXY.NG1.CalcComponent.panelWorkTime.overview.leavesDays"></td>
                        <td class="right">{{ $ctrl.calculatePeriodDays(calc,'leavesDays') | sxyCount : 'day' }}</td>
                      </tr>
                      <tr>
                        <td sxy-text="SALAXY.NG1.CalcComponent.panelWorkTime.overview.absencesDays"></td>
                        <td class="right">{{ $ctrl.calculatePeriodDays(calc,'absencesDays') | sxyCount : 'day' }}</td>
                      </tr>
                      <tr>
                        <td sxy-text="SALAXY.NG1.CalcComponent.panelWorkTime.overview.paidAbsencesDays"></td>
                        <td class="right">{{ $ctrl.calculatePeriodDays(calc,'paidAbsencesDays') | sxyCount : 'day' }}</td>
                      </tr>
                      <tr ng-if="$ctrl.showAccruals(calc)">
                        <td sxy-text="SALAXY.NG1.CalcComponent.panelWorkTime.overview.accruedDays"></td>
                        <td class="right">{{ $ctrl.calculatePeriodDays(calc,'accruedDays') | sxyCount : 'day' }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div ng-if="!$ctrl.isReadOnly">
                <span ng-controller="EmploymentCrudController as $employment">
                  <salaxy-workflow-badge ng-if="$ctrl.employments[calc.worker.employmentId]" mode="horizontal" model="$ctrl.employments[calc.worker.employmentId]" api-ctrl="$employment" wf-types="'EmployerMessageRecord'"></salaxy-workflow-badge>
                </span>
              </div>
            </div>
          </div>
          <div ng-if="!$ctrl.getValidation(calc).isValid" class="text-danger d-flex align-items-baseline">
            <ul class="small">
              <li ng-if="!$ctrl.getValidation(calc)" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.validation.noValidationFound"></li>
              <li ng-repeat="error in $ctrl.getValidation(calc).errors">
                <strong>{{ 'ApiValidationErrorType.' + error.type | sxyEnum }}:</strong>
                <span sxy-text="{{'SALAXY.VALIDATION.' + error.code + '.label'}}"></span>
              </li>
            </ul>
            <button ng-if="$ctrl.getValidation(calc)" ng-controller="ValidationSummaryController as $validation" class="btn btn-xs btn-danger ms-auto" ng-click="$validation.apiValidation=$ctrl.getValidation(calc);$validation.showDetails()" sxy-text="SALAXY.UI_Terms.readMore" ps="..."></button>
          </div>
          <div class="row worker-calculations-row">
            <div class="col-12 table-responsive">
              <salaxy-calc-rows-2019-editor parent="calc" title="{{'SALAXY.NG1.PayrollComponent.payrollCalcs.calcRowEditor.title' | sxyTranslate}}" mode="{{$ctrl.isReadOnly ? 'read-only' : 'read-edit'}}" show-edit-buttons="true" on-commit="$ctrl.commitCalc(calc)" on-reset="$ctrl.resetCalc(calc)"
                on-start-edit="$ctrl.getUi(calc).isInEdit = true" is-in-edit="$ctrl.getUi(calc).isInEdit" show-gross-totals="true">
              </salaxy-calc-rows-2019-editor>

            </div>
            <div class="col-12 payroll-calculation-footer">
              <div class="btn-group btn-group-sm dropup" ng-if="!$ctrl.isReadOnly">
                <button type="button" class="btn btn-secondary dropdown-toggle"  data-bs-toggle="dropdown" aria-expanded="false">
                  <span sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.edit"></span>
                </button>
                <ul class="dropdown-menu">
                  <ng-include src="'salaxy-components/calc/payroll/PayrollCalcs_edit_dropdown.html'"></ng-include>
                </ul>
              </div>
              <div ng-if="$ctrl.mode != 'service'" class="btn-group btn-group-sm float-start float-sm-end dropup">
                <button id="reports" type="button" class="btn btn-transparent dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                  <span sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.viewReports"></span>
                </button>
                <ul class="dropdown-menu dropdown-menu-end"  role="menu" aria-labelledby="reports">
                  <li role="menuitem">
                    <a href="" ng-click="$ctrl.showReport('employerReport', calc)" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.employerReport"></a>
                  </li>
                  <li role="menuitem">
                    <a href="" ng-click="$ctrl.showReport('paymentReport', calc)" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.paymentReport"></a>
                  </li>
                  <li role="menuitem">
                    <a href="" ng-click="$ctrl.showReport('salarySlip', calc)" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.salarySlip"></a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div ng-if="$ctrl.hasCalculations">
      <div class="payroll-totals col-padding">
        <div class="totals-container">
          <span class="total-label"><span sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.payrollTotals.finalCost"></span><br>
          <span sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.payrollTotals.grossSalary"></span><br>
          <span sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.payrollTotals.totalPayment"></span>
          </span>
          <span class="amount">
            {{ $ctrl.calcsResult.employerCalc.finalCost | currency }}<br>
            {{ $ctrl.info.totalGrossSalary | currency}}<br>
            {{ $ctrl.info.totalPayment | currency}}
          </span>
        </div>
      </div>
    </div>
    <div class="dropup toolbar-bottom" ng-if="$ctrl.hasCalculations">
      <ng-include src="'salaxy-components/calc/payroll/PayrollCalcs_toolbar.html'"></ng-include>
    </div>
  </div>
</div>`), s.put("salaxy-components/calc/payroll/PayrollCalcs_edit_dropdown.html", `<li class="dropdown-header" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.editCalculation"></li>
<li role="menuitem" ng-class="{ 'disabled': $ctrl.getUi(calc).isInEdit }">
  <a href="" ng-click="$ctrl.setRowsEditable(calc)" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.editRows"></a>
</li>
<li ng-if="$ctrl.mode != 'service'" role="menuitem">
  <a href="" ng-click="$ctrl.showEditCalcDialog(calc)" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.openCalculator"></a>
</li>
<li ng-if="$ctrl.mode != 'service'" role="menuitem">
  <a href="" ng-click="$ctrl.showEditCalcDialog(calc, 'ir')" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.openIrRows"></a>
</li>
<li role="menuitem">
  <a href="" ng-click="$ctrl.commitCalc(calc, false, true)" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.save"></a>
</li>
<li role="menuitem" ng-class="{ 'disabled': !$ctrl.hasCalcChanges(calc) && !$ctrl.getUi(calc).isInEdit }">
  <a href="" ng-click="$ctrl.resetCalc(calc)" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.cancel"></a>
</li>
<li role="separator" class="divider"></li>
<li class="dropdown-header" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.rowsEmployment"></li>
<li role="menuitem">
  <a href="" ng-click="$ctrl.importEmploymentData(calc)" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.import"></a>
</li>
<li role="separator" class="divider"></li>
<li role="menuitem">
  <a href="" ng-click="$ctrl.deleteCalc(calc)" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.delete"></a>
</li>
<li role="menuitem" ng-if="$ctrl.mode != 'service'">
  <a href="" ng-click="$ctrl.deleteCalc(calc, true)" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.unlink"></a>
</li>`), s.put("salaxy-components/calc/payroll/PayrollCalcs_toolbar.html", `<div class="btn-toolbar" role="toolbar" aria-label="Payroll actions">
  

  <div class="btn-group dropdown" ng-if="!$ctrl.isReadOnly && $ctrl.mode != 'service'">
    <button type="button" class="btn btn-sm btn-labeled-left btn-primary dropdown-toggle d-flex align-items-center" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      <i class="bi bi-plus-lg h-100"></i>
      <span sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.addCalculation"></span>
    </button>
    <ul class="dropdown-menu" role="menu" aria-labelledby="addcalculation">
      <li role="menuitem">
        <a ng-click="$ctrl.createNewCalc()" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.addWorker"></a>
      </li>
      <li role="menuitem">
        <a ng-click="$ctrl.addExistingCalc('draft')" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.addDraft"></a>
      </li>
      <li role="menuitem">
        <a ng-click="$ctrl.addExistingCalc('paid')" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.addCopy"></a>
      </li>
      <li role="menuitem">
        <a ng-click="$ctrl.mergePayroll(true)" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.addPayroll"></a>
      </li>
    </ul>
  </div>
  <input type="text" class="form-control input-sm payroll-search-input mx-1"  id="searchText" name="searchText" placeholder="{{'SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.searchByName' | sxyTranslate}}" ng-model="$ctrl.searchByName" />
 
  <button ng-if="!$ctrl.isReadOnly && $ctrl.mode == 'service'" type="button" class="btn btn-sm btn-labeled-right btn-primary" ng-click="$ctrl.createNewCalc()">
    <span sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.addCalculation"></span>
    <i class="bi bi-plus-lg"></i>
  </button>
  <div class="btn-group btn-group-sm toggle-all-buttons ms-auto">
    <button ng-if="!$ctrl.isReadOnly && !('disableHolidays' | sxyIsInRole)" class="btn btn-secondary toggle-all text-end" ng-click="$ctrl.recalculateWorktimes()">
      <span class="d-none d-sm-inline" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.saveWorktime"></span>
      <i class="bi bi-arrow-repeat" title="{{'SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.saveWorktime' | sxyTranslate}}"></i>
    </button>
    <button class="btn btn-secondary  toggle-all text-end" ng-click="$ctrl.setUiForAll('isCollapsed', false)">
      <span class="d-none d-sm-inline" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.open"></span>
      <i class="bi bi-chevron-down" title="{{'SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.open' | sxyTranslate}}"></i>
    </button>
    <button class="btn btn-secondary  toggle-all text-end" ng-if="!$ctrl.isReadOnly" ng-click="$ctrl.setRowsEditable('all')">
      <span class="d-none d-sm-inline" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.edit"></span>
      <i class="bi bi-pencil-fill" title="{{'SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.edit' | sxyTranslate}}"></i>
    </button>
    <button class="btn btn-secondary toggle-all text-end" ng-click="$ctrl.commitAllCalcs()" ng-if="$ctrl.changedCalcCount && !$ctrl.isReadOnly">
      <span class="d-none d-sm-inline" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.save"></span> ({{ $ctrl.changedCalcCountCache }}) 
      <i class="bi bi-floppy text-success" title="{{'SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.save' | sxyTranslate}}"></i>
    </button>
    <button class="btn btn-secondary toggle-all text-end" ng-click="$ctrl.resetAllCalcs()" ng-if="$ctrl.changedCalcCountCache && !$ctrl.isReadOnly">
      <span class="d-none d-sm-inline" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.cancel"></span> ({{ $ctrl.changedCalcCountCache }}) <i
        class="bi bi-x-lg text-danger" title="{{'SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.cancel' | sxyTranslate}}"></i>
    </button>
    <button class="btn btn-secondary  toggle-all text-end" ng-click="$ctrl.setUiForAll('isCollapsed', true);$ctrl.setUiForAll('isInEdit', false)" ng-if="!$ctrl.changedCalcCountCache">
      <span class="d-none d-sm-inline" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.close"></span>
      <i class="bi bi-chevron-up" title="{{'SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.close' | sxyTranslate}}"></i>
    </button>
  </div>
</div>`), s.put("salaxy-components/calc/payroll/PayrollEdit.html", `<div class="salaxy-component salaxy-payroll" ng-controller="NaviController as $naviCtrl">
  <salaxy-spinner ng-if="$ctrl.isLoading"></salaxy-spinner>
  <div sxy-if-role="auth">
    <div class="dropdown">
      <ng-include ng-if="$ctrl.isNew()" src="'salaxy-components/calc/payroll/PayrollNew.html'"></ng-include>
    </div>
    <div ng-if="!$ctrl.isNew() && $ctrl.current">
      <ng-include src="'salaxy-components/calc/payroll/PayrollEdit_toolbar.html'"></ng-include>
      <div class="row payroll-info-row">
        <div class="col-3 col-sm-2">
          <salaxy-avatar-placeholder class="payroll-avatar">
            <i class="salaxy-avatar bi bi-square-fill text-muted d-flex" ng-class="{'draft-invalid' : $ctrl.current.info.status == 'draft' && !$ctrl.current.info.isReadyForPayment, 'text-success' : $ctrl.current.info.status == 'paymentSucceeded', 'text-warning' : ($ctrl.current.info.status == 'paymentStarted' || $ctrl.current.info.status == 'waitingApproval') , 'text-danger' : $ctrl.current.info.status == 'paymentCancelled'}">
              <div class="avatar-text-wrapper">
                <strong>{{ $ctrl.calcs.length }}</strong>
                <small>{{ $ctrl.current.info.salaryDate | date : "d.M." }}</small>
              </div>
            </i>
          </salaxy-avatar-placeholder>
        </div>
        <div class="col-9 col-sm-10 payroll-info-col">
          <h3 class="payroll-title">{{ $ctrl.current.input.title }}</h3>
          <div class="row">
            <div class="col-12 col-sm-6">
              <div>
                <span>{{ 'PayrollStatus.' + $ctrl.current.info.status | sxyEnum }}</span>
                <span ng-if="$ctrl.current.info.status == 'draft'" ng-class="$ctrl.current.info.isReadyForPayment ? 'text-success' : 'text-danger'">
                  {{ $ctrl.current.info.isReadyForPayment ? (('SALAXY.NG1.PayrollComponent.payrollEdit.payrollInfo.readyForPayment' | sxyTranslate)) :
                  (('SALAXY.NG1.PayrollComponent.payrollEdit.payrollInfo.notReadyForPayment' | sxyTranslate)) }}
                </span>
              </div>
              <div>
                <span sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.payrollInfo.salaryPeriod" ps=":"></span> {{ $ctrl.current.input.period | sxyDateRange }} ({{$ctrl.current.input.period.daysCount}} <span sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.payrollInfo.salaryPeriodDaysCount"></span>)
              </div>
              <div>
                <span sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.payrollInfo.salaryDate" ps=":"></span> {{ $ctrl.current.info.salaryDate | date }}
                <span class="badge bg-info" ng-if="$ctrl.current.info.status != 'paymentSucceeded' && !$ctrl.current.input.salaryDate && $ctrl.current.info.salaryDate">{{'SALAXY.NG1.PayrollComponent.payrollEdit.payrollInfo.salaryDateEstimate' | sxyTranslate}}</span>
                <span ng-if="$ctrl.current.info.status != 'paymentSucceeded' &&  $ctrl.current.info.salaryDate && $ctrl.current.input.salaryDate && $ctrl.current.input.salaryDate != $ctrl.current.info.salaryDate"><s>{{ $ctrl.current.input.salaryDate | date }}</s> <span class="badge bg-warning">{{'SALAXY.NG1.PayrollComponent.payrollEdit.payrollInfo.salaryDateNote' | sxyTranslate}}</span></span>
              </div>
              <div>
                <span ng-if="$ctrl.current.input.template" sxy-html="SALAXY.NG1.PayrollComponent.payrollEdit.payrollInfo.template.html" params="{template: ($ctrl.current.input.template)}"></span>
              </div>
              <div>
                <small>ID: <code>{{ $ctrl.currentId }}</code></small>
              </div>
            </div>
            <div class="col-12 col-sm-6">
              <span><span sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.payrollInfo.calcCount" ps=":"></span> {{$ctrl.calcs.length}} </span><br />
              <span><span sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.payrollInfo.finalCost" ps=":"></span> {{ $ctrl.calcsResult.employerCalc.finalCost | currency }}
              </span><br />
              <span><span sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.payrollInfo.grossSalary" ps=":"></span> {{ $ctrl.info.totalGrossSalary | currency}}</span><br>
              <span><span sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.payrollInfo.totalPayment" ps=":"></span> {{ $ctrl.info.totalPayment | currency}}</span>
            </div>
          </div>
        </div>
      </div>
      <salaxy-tab-buttons
        current-tab="$ctrl.currentTab"
        options="[
          { value: 'properties', text: 'SALAXY.NG1.PayrollComponent.payrollEdit.tabs.editProperties' },
          { value: 'calculations', text: 'SALAXY.NG1.PayrollComponent.payrollEdit.tabs.calculations' },
          { value: 'reports', text: 'SALAXY.NG1.PayrollComponent.payrollEdit.tabs.reports', disabled: !$ctrl.hasCalculations },
          { value: 'additionalinformation', text: 'SALAXY.NG1.PayrollComponent.payrollCalcs.additionalInformation', disabled: !$ctrl.hasCalculations },
          { value: 'msg', text: 'Viestit / hyväksyntä', hidden: !('partnerMessaging' | sxyIsInRole) }
        ]"
        tabs-id="payrollEdit">
      </salaxy-tab-buttons>
      <div class="tab-content" id="tab-content-payrollEdit">
        <div class="tab-pane" id="properties-tab">
          <div ng-if="$ctrl.currentTab == 'properties'" class="row payroll-edit-properties-container">
            <form class="form-horizontal" ng-disabled="$ctrl.isDisabled" ng-readonly="$ctrl.isReadOnly">
              <div class="col-12 payroll-edit-properties-col">
                <salaxy-input name="title" label="SALAXY.NG1.PayrollComponent.payrollEdit.editProperties.title" ng-model="$ctrl.current.input.title"></salaxy-input>
                <div class="form-group" ng-if="$ctrl.current.info.status == 'paymentSucceeded'">
                  <label for="status" class="col-sm-4 text-start" sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.editProperties.status"></label>
                  <div class="col-sm-8">{{ 'PayrollStatus.' + $ctrl.current.info.status | sxyEnum | sxyTranslate }}</div>
                </div>
                 <div  ng-if="(!$ctrl.isReadOnly || $ctrl.showAction('pay')) && ('test,setSalaryDateKind' | sxyIsInRole)"  ng-switch="$ctrl.current.input.paymentChannel">
                  <div ng-switch-when="palkkausManual|talenomManual|palkkausInvoices|palkkausCfaTest|kitsas|briox|askelma|passeliMerit|ecom|hausvise" ng-switch-when-separator="|">
                    <salaxy-form-group name="salaryDateKind" label="SALAXY.MODEL.PayrollInput.salaryDateKind.title">       
                      <salaxy-salary-date-kind-button button-class="btn-block" model="$ctrl.current" on-salary-date-kind-change="$ctrl.save()"></salaxy-salary-date-kind-button>
                    </salaxy-form-group>
                  </div>
                </div>
                <salaxy-form-group ng-if="($ctrl.isReadOnly && !$ctrl.showAction('pay')) && $ctrl.current.input.salaryDateKind == 'inPast'" name="salaryDateKind" class="salaxy-component salaxy-read-only" label="SALAXY.MODEL.CalcWorkflow.salaryDateKind.title">
                  <div class="form-control-plaintext">{{"SALAXY.ENUM.SalaryDateKind." + ($ctrl.current.input.salaryDateKind) + ".label" | sxyTranslate  }}</div>
                </salaxy-form-group>
                <salaxy-datepicker-popup read-only="false" ng-if="!$ctrl.isReadOnly || $ctrl.showAction('pay')" label="SALAXY.NG1.PayrollComponent.payrollEdit.editProperties.salaryDate" name="salaryDate" ng-model="$ctrl.current.input.salaryDate" date-disabled="disable-function" disable-function="$ctrl.isDisabledSalaryDate"></salaxy-datepicker-popup>       
                <div class="row py-2" ng-if="$ctrl.isReadOnly && !$ctrl.showAction('pay')">
                  <div class="col-sm-4"><strong sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.editProperties.salaryDate" ps=":"></strong> </div>
                  <div class="col-sm-8">
                    {{ $ctrl.current.info.salaryDate | date }}
                    <span class="badge bg-info" ng-if="$ctrl.current.info.status != 'paymentSucceeded' && !$ctrl.current.input.salaryDate && $ctrl.current.info.salaryDate">{{'SALAXY.NG1.PayrollComponent.payrollEdit.payrollInfo.salaryDateEstimate' | sxyTranslate}}</span>
                    <span ng-if="$ctrl.current.info.status != 'paymentSucceeded' &&  $ctrl.current.info.salaryDate && $ctrl.current.input.salaryDate && $ctrl.current.input.salaryDate != $ctrl.current.info.salaryDate"><s>{{ $ctrl.current.input.salaryDate | date }}</s> <span class="badge bg-warning">{{'SALAXY.NG1.PayrollComponent.payrollEdit.payrollInfo.salaryDateNote' | sxyTranslate}}</span></span>    
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-sm-4"><strong sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.editProperties.salaryPeriod" ps=":"></strong> </div>
                  <div class="col-sm-8">
                    {{ $ctrl.current.input.period | sxyDateRange }} ({{$ctrl.current.input.period.daysCount}} <span sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.editProperties.salaryPeriodDaysCount"></span>)
                    <button class="btn btn-transparent btn-xs" ng-click="$ctrl.showDateRange()" ng-if="!$ctrl.isReadOnly || $ctrl.showAction('pay')"><i class="bi bi-pencil-fill "></i></button>
                  </div>
                </div>
                <salaxy-form-group name="paymentChannel" label="SALAXY.NG1.PayrollComponent.payrollEdit.editProperties.paymentChannel">
                  <salaxy-pay-button ng-if="!$ctrl.isReadOnly || $ctrl.showAction('pay')" model="$ctrl.current" mode="channel-select" ng-ref="$ctrl.$payButton" disabled="!$ctrl.$payButton.isChannelDefined" on-payment-channel-change="$ctrl.save()" button-class="btn-block"></salaxy-pay-button>
                  <div ng-if="$ctrl.isReadOnly && !$ctrl.showAction('pay')">{{ "PaymentChannel." + $ctrl.current.input.paymentChannel | sxyEnum }}</div>
                </salaxy-form-group>
              </div>
            </form>
          </div>
        </div>
        <div class="tab-pane" id="calculations-tab">
          <ng-include ng-if="$ctrl.currentTab == 'calculations'" src="'salaxy-components/calc/payroll/PayrollCalcs.html'"></ng-include>
        </div>
        <div class="tab-pane" id="reports-tab">
          <salaxy-calc-reports calcs="$ctrl.calcs" ng-if="$ctrl.currentTab == 'reports' && $ctrl.hasCalculations" report-type="'salarySlip'"></salaxy-calc-reports>
        </div>
        <div class="tab-pane" id="additionalinformation-tab">
          <div class="dropdown toolbar-top" ng-if="$ctrl.currentTab == 'additionalinformation' && $ctrl.hasCalculations">
            <ng-include src="'salaxy-components/calc/payroll/PayrollCalcs_toolbar.html'"></ng-include>
            <div ng-repeat="calc in $ctrl.calcs">
              <div class="payroll-single-calculation " ng-class="{'error-container': !$ctrl.getValidation(calc).isValid }">
                <div class="float-end icon-container btn-group">
                  <button class="btn btn-transparent btn-xs toggle-details" ng-click="$ctrl.getUi(calc).isCollapsed = !$ctrl.getUi(calc).isCollapsed"><i class="bi"
                      ng-class="{'bi-chevron-up' : !$ctrl.getUi(calc).isCollapsed,  'bi-chevron-down' : $ctrl.getUi(calc).isCollapsed}"
                      title="{{'SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.toggle' | sxyTranslate}}"></i></button>
                </div>
                <div class="payroll-worker-summary px-2-g clickable" ng-if="$ctrl.getUi(calc).isCollapsed" ng-click="$ctrl.getUi(calc).isCollapsed = !$ctrl.getUi(calc).isCollapsed">
                  <div class="avatar-container">
                    <salaxy-avatar avatar="calc.worker.avatar"></salaxy-avatar>
                    <span class="worker-name">{{calc.worker.avatar.displayName}}</span>
                    <span class="calculation-summary">{{calc.result.totals.total | currency }}</span>
                  </div>
                </div>
                <div class="payroll-worker-details" ng-if="!$ctrl.getUi(calc).isCollapsed">
                  <div class="row payroll-worker-info">
                    <div class="col-2 col-sm-2">
                      <div class="avatar-container">
                        <salaxy-avatar avatar="calc.worker.avatar"></salaxy-avatar>
                      </div>
                    </div>
                    <div class="col-10">
                      <h3 class="worker-name clickable" ng-click="$ctrl.getUi(calc).isCollapsed = !$ctrl.getUi(calc).isCollapsed">{{calc.worker.avatar.displayName}}</h3>
                      <div class="row">
                        <div class="col-12 col-sm-5 worker-info-col">
                          {{calc.worker.paymentData.email}}<br> {{calc.worker.paymentData.telephone}}
                        </div>
                        <div class="col-12 col-sm-7 worker-info-col">
                          <!-- additional info -->
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row worker-calculations-row">
                    <div class="col-sm-6">
                      <salaxy-calc-cost-accounting salaxy-if-role="company" calc="calc" read-only="$ctrl.isReadOnly"></salaxy-calc-cost-accounting>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-pane" id="msg-tab" ng-if="'partnerMessaging' | sxyIsInRole">
          <div ng-if="!$ctrl.current.info.messageThreadId" ng-controller="MessageThreadCrudController as $msg" ng-init="$msg.model='new'" class="form-horizontal" style="max-width: 600px;">
            <fieldset sxy-if-role="!pro">
              <p ng-if="!$ctrl.current.info.messageThreadId">Tähän palkkalistaan ei liity viestiketjua / työnkulkua.</p>
              <!--
              <legend>Lähetä tilitoimistolle</legend>
              <p>Luo tästä uusi viestiketju, jolla voit lähettää palkkalistan tilitoimiston käsittelyyn.</p>
              <salaxy-input-enum name="action" label="Pyydetään toimintaa" type="radio" ng-model="$msg.current.input.todoAction" options="$ctrl.messageActions"
                ng-change="$msg.current.title = $ctrl.getTitle($msg.current.input.todoAction)"></salaxy-input-enum>
              <salaxy-input name="title" label="SALAXY.NG1.MessageThreadComponent.title" require="true" disabled="!$msg.current.input.todoAction" ng-model="$msg.current.title"></salaxy-input>
              <salaxy-form-group name="msgSubmit" label-type="empty-label">
                <button type="button" class="btn btn-primary" ng-click="$ctrl.sendPayroll($msg)">Lähetä</button>
              </salaxy-form-group>
              -->
            </fieldset>
            <fieldset sxy-if-role="pro">
              <legend>Lähetä yritykselle</legend>
              <p>Luo tästä uusi viestiketju, jolla voit lähettää palkkalistan yritykselle hyväksyttäväksi / maksettavaksi.</p>
              <salaxy-input-enum name="action" label="Pyydetään toimintaa" type="radio" ng-model="$msg.current.input.todoAction" options="$ctrl.messageActions" ng-change="$msg.current.title = $ctrl.getTitle($msg.current.input.todoAction)"></salaxy-input-enum>
              <salaxy-input name="title" label="SALAXY.NG1.MessageThreadComponent.title" require="true" disabled="!$msg.current.input.todoAction" ng-model="$msg.current.title"></salaxy-input>
              <salaxy-form-group name="msgSubmit" label-type="empty-label">
                <button type="button" class="btn btn-primary" ng-click="$ctrl.sendPayroll($msg)">Lähetä</button>
              </salaxy-form-group>
            </fieldset>
          </div>
          <div ng-if="$ctrl.current.info.messageThreadId">
            <button type="button" class="btn btn-danger float-end" ng-click="$ctrl.deleteMessage($ctrl.$msg)"><i class="bi bi-trash-fill" aria-hidden="true"></i></button>
            <salaxy-message-thread model="$ctrl.current.info.messageThreadId" ng-ref="$ctrl.$msg" role="{{('pro' | sxyIsInRole) ? 'otherParty' : 'owner' }}" other-party="'partner'" mark-as-read="5"></salaxy-message-thread>
          </div>
        </div>
      </div>
      <div class="dropup">
        <ng-include src="'salaxy-components/calc/payroll/PayrollEdit_toolbar.html'"></ng-include>
      </div>
    </div>
  </div>
</div>`), s.put("salaxy-components/calc/payroll/PayrollEdit_toolbar.html", `<div>
  <div ng-if="$ctrl.isReadOnly" class="btn-toolbar w-100">
    <button ng-if="$ctrl.showAction('pay')" type="button" class="btn" ng-class="{ 'btn-primary': $ctrl.hasChanges, 'btn-default': !$ctrl.hasChanges }" ng-disabled="!$ctrl.hasChanges" ng-click="$ctrl.save()">
      {{ $ctrl.hasChanges ? ('SALAXY.NG1.PayrollComponent.payrollEdit.toolbar.save' | sxyTranslate) : ('SALAXY.NG1.PayrollComponent.payrollEdit.toolbar.saved' | sxyTranslate) }}
    </button>
    <button class="btn btn-secondary" ng-if="$ctrl.showAction('copy')" ng-click="$ctrl.showCopyAsNew($ctrl.current)" ng-style="{ visibility: $ctrl.isDisabled ? 'hidden' : 'visible' }" sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.toolbar.copyAsNew"></button>
    <div class="ms-sm-auto" >
      <salaxy-pay-button ng-if="$ctrl.showAction('pay')"
        model="$ctrl.current" mode="pay-button" label="SALAXY.NG1.PayrollComponent.payrollPayButton" ng-ref="$payButton" disabled="!$ctrl.current.info.isReadyForPayment || !$ctrl.calcs.length || !$payButton.isChannelDefined"
        on-payment-channel-change="$ctrl.save()"></salaxy-pay-button>
        <button ng-if="$ctrl.showAction('cancel') && ($ctrl.current.info.status == 'paymentStarted' && ($ctrl.current.input.paymentChannel == 'palkkausManual' || $ctrl.current.input.paymentChannel == 'talenomManual' || $ctrl.current.input.paymentChannel == 'palkkausInvoices' || $ctrl.current.input.paymentChannel == 'kitsas' || $ctrl.current.input.paymentChannel == 'palkkausPersonal' || $ctrl.current.input.paymentChannel == 'palkkausCfaPaytrail' || $ctrl.current.input.paymentChannel == 'palkkausEcfaPaytrail' || $ctrl.current.input.paymentChannel == 'palkkausCfaReference'|| $ctrl.current.input.paymentChannel == 'palkkausEcfaReference' || $ctrl.current.input.paymentChannel == 'palkkausCfaFinvoice' || $ctrl.current.input.paymentChannel == 'palkkausEcfaFinvoice' ||  $ctrl.current.input.paymentChannel == 'palkkausCfaTest'))" class="btn btn-secondary  btn-labeled-right" ng-click="$ctrl.cancel()"><span sxy-text="SALAXY.NG1.CalcResultsComponent.cancelPaymentOrChangeChannelBtn"></span><i class="bi bi-x-circle"></i></button>
        <button ng-if="$ctrl.current.info.status != 'waitingApproval' && $ctrl.current.info.status != 'draft'" class="btn btn-secondary  btn-labeled-right" ng-click="$ctrl.showPaymentDialog()"><span sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.toolbar.showPaymentInfo"></span><i class="bi bi-info-circle"></i></button>
    </div>
    <button type="button" ng-if="('partnerMessaging' | sxyIsInRole) && (!('pro' | sxyIsInRole) && $ctrl.current.info.messageThreadId )"  class="btn btn-default float-end" ng-click="$ctrl.activeTab = 'msg'">Kommentoi</button>
  </div>
  <div ng-if="!$ctrl.isReadOnly" class="btn-toolbar calc-toolbar w-100">
    <button type="button" class="btn" ng-class="{ 'btn-primary': $ctrl.hasChanges, 'btn-default': !$ctrl.hasChanges }" ng-disabled="!$ctrl.hasChanges" ng-click="$ctrl.save()">
      {{ $ctrl.hasChanges ? ('SALAXY.NG1.PayrollComponent.payrollEdit.toolbar.save' | sxyTranslate) : ('SALAXY.NG1.PayrollComponent.payrollEdit.toolbar.saved' | sxyTranslate) }}
    </button>
    <div class="btn-group dropdown"  ng-disabled="$ctrl.isDisabled">
      <button type="button" class="btn btn-secondary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
        <span sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.toolbar.options"></span>
      </button>
      <ul class="dropdown-menu"  role="menu" aria-labelledby="actions">
        <li role="menuitem">
          <a ng-click="$ctrl.importEmploymentDataAll()" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.toolbar.importEmploymentCalc"></a>
        </li>
        <li role="menuitem">
          <a ng-click="$ctrl.showCopyAsNew($ctrl.current)" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.toolbar.copyAsNew"></a>
        </li>
        <li ng-class="{ disabled: !$ctrl.hasChanges }" role="menuitem">
          <a ng-click="$ctrl.reset()" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.toolbar.cancel"></a>
        </li>
        <li role="menuitem">
          <a class="text-danger dropdown-item" ng-click="$ctrl.delete()" sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.toolbar.delete"></a>
        </li>
        <li role="menuitem" ng-if="( $ctrl.current.owner == 'FI90PRYL0001975846') && ('pro, test' | sxyIsInRole)">
          <a ng-href="#/payroll/import/{{$ctrl.current.id}}" class="dropdown-item">Import (BETA)</a>
        </li>
      </ul>
    </div>
    <div sxy-if-role="pro" class="btn-group">
      <div class="btn-group dropdown ms-1">
        <!-- HACK: Rewrite workflow buttons as components. Or make PRO calculator a component. -->
        <button class="btn btn-default dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false" style="font-weight: bold;">
          {{ "PayrollStatus." + $ctrl.current.info.status | sxyEnum }}
        </button>
        <ul class="dropdown-menu" >
          <li ng-class="{ disabled: $ctrl.current.info.status=='draft' }">
            <a href="" ng-click="$ctrl.current.info.status = 'draft';$ctrl.save()" class="dropdown-item">{{ "PayrollStatus.draft" | sxyEnum }}</a>
          </li>
          <li ng-class="{ disabled: $ctrl.current.info.status=='template' }">
            <a href="" ng-click="$ctrl.current.info.status = 'template';$ctrl.save()" class="dropdown-item">{{ "PayrollStatus.template" | sxyEnum }}</a>
          </li>
          <li ng-class="{ disabled: $ctrl.current.info.status=='handled' }">
            <a href="" ng-click="$ctrl.current.info.status = 'handled';$ctrl.save()" class="dropdown-item">{{ "PayrollStatus.handled" | sxyEnum }}</a>
          </li>
          <li ng-class="{ disabled: $ctrl.current.info.status=='waitingApproval' }">
            <a href="" ng-click="$ctrl.current.info.status = 'waitingApproval';$ctrl.save()" class="dropdown-item">{{ "PayrollStatus.waitingApproval" | sxyEnum }}</a>
          </li>
        </ul>
      </div>
      <salaxy-workflow-buttons api-ctrl="$ctrl"></salaxy-workflow-buttons>
    </div>
    <div class="btn-group ms-sm-auto">
      <salaxy-pay-button ng-if="$ctrl.current.info.status != 'template'" model="$ctrl.current" mode="pay-button"  label="SALAXY.NG1.PayrollComponent.payrollPayButton" ng-ref="$payButton" disabled="!$ctrl.current.info.isReadyForPayment || !$ctrl.calcs.length || !$payButton.isChannelDefined"
        on-payment-channel-change="$ctrl.save()"></salaxy-pay-button>
    </div>
  </div>
</div>
<div>
  <div ng-if="'company' | sxyIsInRole" ng-controller="CompanyAccountController as $company" style="padding: 8px">
    <salaxy-workflow-badge ng-if="$company.current" model="$company.current" mode="horizontal" api-ctrl="$company" wf-types="'EmployerMessageRecord'" ></salaxy-workflow-badge>
  </div>
</div>
<div class="row" ng-if="$ctrl.showWorkflowMessage" style="margin-top: 4px;margin-bottom: -50px">
  <div class="offset-sm-6 col-sm-6">
    <salaxy-textarea name="workflowMessage" ng-model="$ctrl.workflowMessage" placeholder="{{'SALAXY.NG1.PayrollComponent.payrollEdit.toolbar.workFlowMessage'}}" rows="2" label-type="plain"></salaxy-textarea>
  </div>
</div>`), s.put("salaxy-components/calc/payroll/PayrollList.html", `<div class="salaxy-component salaxy-payroll-list">
  <div class="row w-100" ng-if="!$ctrl.hideButton">
    <div class="col-12 action-button-container mb-3">
      <salaxy-action-button action="'newPayroll'" button-class="btn-primary" style="margin-bottom:30px;"></salaxy-action-button>
    </div>
  </div>
  <salaxy-tab-buttons
    current-tab="$ctrl.currentTab"
    options="[
      { value: 'default', text: 'SALAXY.NG1.PayrollComponent.payrollList.tabs.latest' },
      { value: 'templates', text: 'SALAXY.NG1.PayrollComponent.payrollList.tabs.repeated' },
      { value: 'paid', text: 'SALAXY.NG1.PayrollComponent.payrollList.tabs.paid' },
      { value: 'paidcalcs', text: 'SALAXY.NG1.PayrollComponent.payrollList.tabs.paidSalaries' },
      { value: 'draftcalcs', text: 'SALAXY.NG1.PayrollComponent.payrollList.tabs.draftCalcs' }
    ]"
    tabs-id="payrollList">
  </salaxy-tab-buttons>
  <div class="tab-content" id="tab-content-payrollList">
    <div class="tab-pane" id="default-tab">
      <salaxy-odata-table crud-controller="PayrollCrudController as $crud" options="{ $filter: 'status ne \\'paymentSucceeded\\' and status ne \\'paymentStarted\\' and status ne \\'template\\' and status ne \\'handled\\' and status ne \\'paymentCanceled\\'' }" read-only="$ctrl.isReadOnlyForced"></salaxy-odata-table>
    </div>
    <div class="tab-pane" id="templates-tab">
      <salaxy-odata-table crud-controller="PayrollCrudController as $crud" options="{ $filter: 'status eq \\'template\\'' }" read-only="$ctrl.isReadOnlyForced"></salaxy-odata-table>
    </div>
    <div class="tab-pane" id="paid-tab">
      <salaxy-odata-table crud-controller="PayrollCrudController as $crud" options="{ $filter: 'status eq \\'paymentSucceeded\\' or status eq \\'paymentStarted\\' or status eq \\'handled\\' or status eq \\'paymentCanceled\\'' }" read-only="$ctrl.isReadOnlyForced"></salaxy-odata-table>
    </div>
    <div class="tab-pane" id="paidcalcs-tab">
      <salaxy-odata-table url="/v03/api/calculations/category/readonly" crud-controller="CalculationCrudController as $crud" options="{ $filter: 'status eq \\'paymentSucceeded\\' and data/payrollId ne null' }" read-only="$ctrl.isReadOnlyForced"></salaxy-odata-table>
    </div>
    <div class="tab-pane" id="draftcalcs-tab">
      <salaxy-odata-table crud-controller="CalculationCrudController as $crud" options="{ $filter: 'status eq \\'payrollDraft\\'' }" read-only="$ctrl.isReadOnlyForced"></salaxy-odata-table>
    </div>
  </div>
</div>`), s.put("salaxy-components/calc/payroll/PayrollNew.html", `<div>
  <div class="h2" sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.editProperties.new.heading"></div>
  <div class="form-horizontal" ng-controller="NaviController as $naviCtrl">
    <form name="newPayrollForm">
      <salaxy-input name="title" label="SALAXY.NG1.PayrollComponent.payrollEdit.editProperties.title" require="true" ng-model="$ctrl.current.input.title"></salaxy-input>
      <div  ng-if="('test,setSalaryDateKind' | sxyIsInRole)" ng-switch="$ctrl.current.input.paymentChannel">
        <div ng-switch-when="palkkausManual|talenomManual|palkkausInvoices|palkkausCfaTest|kitsas|briox|askelma|passeliMerit|ecom|hausvise" ng-switch-when-separator="|">
          <salaxy-form-group name="salaryDateKind" label="SALAXY.MODEL.PayrollInput.salaryDateKind.title">       
            <salaxy-salary-date-kind-button button-class="btn-block" model="$ctrl.current" disabled="$ctrl.isReadOnly"></salaxy-salary-date-kind-button>
          </salaxy-form-group>
        </div>
      </div>
      <salaxy-datepicker-popup label="SALAXY.NG1.PayrollComponent.payrollEdit.editProperties.salaryDate" name="salaryDate" ng-model="$ctrl.current.input.salaryDate" date-disabled="disable-function" disable-function="$ctrl.isDisabledSalaryDate"></salaxy-datepicker-popup>
      <salaxy-date-range label="SALAXY.NG1.PayrollComponent.payrollEdit.editProperties.salaryPeriod" name="period" ng-model="$ctrl.current.input.period" mode="calc"></salaxy-date-range>
      <salaxy-form-group name="paymentChannel" label="SALAXY.NG1.PayrollComponent.payrollEdit.editProperties.paymentChannel">
        <salaxy-pay-button model="$ctrl.current" mode="channel-select" ng-ref="$ctrl.$payButton" disabled="!$ctrl.$payButton.isChannelDefined" button-class="btn-block"></salaxy-pay-button>
      </salaxy-form-group>
      <div ng-if="$ctrl.current.calcs.length">
        <salaxy-form-group label="SALAXY.NG1.PayrollComponent.payrollEdit.editProperties.new.copyingCalcs" name="calcCount">
          {{ $ctrl.current.calcs.length }} kpl
        </salaxy-form-group>
        <salaxy-input-boolean type="select" placeholder="SALAXY.UI_Terms.choose" name="noUpdateFromEmployment" ng-model="$ctrl.current.input.noUpdateFromEmployment" label="SALAXY.NG1.PayrollComponent.payrollEdit.editProperties.new.updateCalcs" label-false="SALAXY.NG1.PayrollComponent.payrollEdit.editProperties.new.updateCalcsFalse"
          label-true="SALAXY.NG1.PayrollComponent.payrollEdit.editProperties.new.updateCalcsTrue"></salaxy-input-boolean>
      </div>
      <salaxy-form-group label-type="empty-label" name="submit" class="no-colon">
        <button type="submit" class="btn btn-primary" ng-disabled="!newPayrollForm.$valid" ng-click="$ctrl.save()" sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.editProperties.new.createPayrollButton"></button>
      </salaxy-form-group>
    </form>
  </div>
</div>`), s.put("salaxy-components/calc/payroll/PayrollSelectList.html", `<div class="salaxy-component salaxy-payroll-select-list">
  <salaxy-odata-table ng-if="$ctrl.category=='paid'"  ng-if="$ctrl.mode == 'select'" template-url="salaxy-components/odata/lists/Payrolls-select.html"  options="{ $filter: 'status eq \\'paymentSucceeded\\' or status eq \\'paymentStarted\\'' }"
    selected-items="$ctrl.selectedItems" on-list-select="$ctrl.onListSelect({ value: value, item: item, allItems: allItems });" crud-controller="PayrollCrudController as $crud"></salaxy-odata-table>
  <salaxy-odata-table ng-if="$ctrl.category=='draft'"  ng-if="$ctrl.mode == 'select'" template-url="salaxy-components/odata/lists/Payrolls-select.html"  options="{ $filter: 'status eq \\'draft\\'' }"
    selected-items="$ctrl.selectedItems" on-list-select="$ctrl.onListSelect({ value: value, item: item, allItems: allItems });" crud-controller="PayrollCrudController as $crud"></salaxy-odata-table>
  </div>`), s.put("salaxy-components/calc/payrollV4/PayrollAssistant.html", `
<div class="salaxy-component salaxy-payroll-assistant salaxy-message-thread" ng-if="$ctrl.current">
  <div class="messages-container" >
    <div id="openairesponse" style="overflow-y: scroll;overflow-x: hidden; max-height: 300px;">
      <div class="text-end">
        <salaxy-avatar avatar="$ctrl.openAiAvatar" class="float-end"></salaxy-avatar>
        <div class="message-bubble right text"> 
          <div>
            Hei! Olen Palkkaus.fi:n tekoäly. Miten voin auttaa tämän palkkalistan luomisessa?
          </div>     
        </div>
      </div>
      <div  ng-repeat="item in $ctrl.messages | filter: {hidden: false}" ng-switch="item.type">
        <div ng-switch-when="file">
          <salaxy-avatar avatar="$ctrl.myAvatar" class="float-start"></salaxy-avatar>
          <div class="message-bubble left text"> 
            <span><i class="fa fa-file-excel-o"></i> {{item.file}}</span>    
          </div>
        </div>
        <div ng-switch-when="html"  class="text-end">
          <salaxy-avatar avatar="$ctrl.openAiAvatar" class="float-end"></salaxy-avatar>
          <div class="message-bubble right text"> 
            <span class="clickable"  ng-click="$ctrl.showReport(item)"><i class="fa fa-file-o"></i> {{item.file}}</span>    
          </div>
        </div>
        <div ng-switch-default ng-class="item.role == 'assistant' ? 'text-end' : ''">
          <salaxy-avatar ng-if="item.role != 'assistant'" avatar="$ctrl.myAvatar" class="float-start"></salaxy-avatar>
          <salaxy-avatar ng-if="item.role == 'assistant'" avatar="$ctrl.openAiAvatar" class="float-end"></salaxy-avatar>
          <div ng-if="item.role != 'assistant'" class="message-bubble left text"> 
            <div>
              {{item.content}}
            </div>     
          </div>
          <div ng-if="item.role == 'assistant'" class="message-bubble right text"> 
            <div>
              {{item.content}}
            </div>     
          </div>
        </div>
      </div>
      <div ng-if="$ctrl.loading" class="text-end">
        <salaxy-avatar avatar="$ctrl.openAiAvatar" class="float-end"></salaxy-avatar>
        <div class="message-bubble right text"> 
          <span ><span style="font-size: large;"><i class="fa fa-refresh fa-spin fa-fw"></i></span> Valmistellaan vastausta...</span>  
        </div>
      </div>
    </div>
      <div class="row  message-actions">
        <div class="col-8 col-sm-8">
          <textarea name="content" ng-model="$ctrl.content" placeholder="Kirjoita viesti OpenAI:lle" ></textarea>
        </div>
        <div class="col-4 col-sm-4 d-flex flex-column">
          <button type="button" class="btn btn-primary btn-labeled-left text-start mb-1" ng-click="$ctrl.chatForPayroll()">
            <i class="bi bi-pencil-fill"></i>
            <span>Pyydä muokkausta</span>
          </button>
          <button type="button" class="btn btn-default btn-labeled-left text-start mb-1" ng-click="$ctrl.chatForAdvise()">
            <i class="bi bi-question-circle-fill"></i>
            <span>Pyydä ohje</span>
          </button>
          <button type="button" class="btn btn-default btn-labeled-left text-start mb-1" ng-click="$ctrl.chatForReport()">
            <i class="bi bi-table"></i>
            <span>Pyydä raporttia</span>
          </button>
          <button type="button" class="btn btn-default btn-labeled-left text-start mb-1" ngf-select="$ctrl.readFile($file)" ngf-multiple="false"  ngf-max-size="10MB">
            <i class="bi bi-paperclip"></i>
            <span>Liitä Excel</span>
          </button>
      </div>
  </div>
  <div>&nbsp;</div>`), s.put("salaxy-components/calc/payrollV4/PayrollDetails.html", `<div class="salaxy-component salaxy-payroll-details" ng-if="$ctrl.current">
  <ng-include ng-show="!$ctrl.isNew()" src="'salaxy-components/calc/payrollV4/PayrollDetails_info.html'"></ng-include>
  <ng-include ng-show="!$ctrl.isNew()" src="'salaxy-components/calc/payrollV4/PayrollDetails_toolbar.html'"></ng-include>
  <salaxy-tab-buttons
    current-tab="$ctrl.payrollDetailsCurrentTab"
    ng-show="!$ctrl.isNew()"
    options="[
      { value: 'calculations', text: 'SALAXY.NG1.PayrollComponent.headerViews.calculations' },
      { value: 'rows', text: 'SALAXY.NG1.PayrollComponent.headerViews.rows' },
      { value: 'reports', text: 'SALAXY.NG1.PayrollComponent.headerViews.reports' },
      { value: 'messages', text: 'SALAXY.NG1.PayrollComponent.headerViews.messages', hidden: !('partnerMessaging' | sxyIsInRole) },
      { value: 'ports', text: 'SALAXY.NG1.PayrollComponent.headerViews.ports', disabled: !$ctrl.$import.isSupported },
      { value: 'debug', text: 'Debug', hidden: !('test' | sxyIsInRole) }
    ]"
    tabs-id="payrollDetails"
    class="d-block mt-3">
  </salaxy-tab-buttons>
  <div class="tab-content" id="tab-content-payrollDetails" ng-show="!$ctrl.isNew()">
    <div class="tab-pane" id="calculations-tab">
      <ng-include ng-if="$ctrl.payrollDetailsCurrentTab == 'calculations'" src="'salaxy-components/calc/payrollV4/PayrollDetails_calcs.html'"></ng-include>
    </div>
    <div class="tab-pane" id="rows-tab">
      <div ng-if="$ctrl.payrollDetailsCurrentTab == 'rows'" class="row">
        <div class="col" ng-class="$ctrl.hasAssistant ? 'col-8' : 'col-12'">
          <ng-include  ng-if="$ctrl.calcs && $ctrl.payrollDetailsCurrentTab == 'rows'" src="'salaxy-components/calc/payrollV4/PayrollDetails_calcs_paged.html'"></ng-include>
        </div>
        <div ng-show="$ctrl.hasAssistant" class="col" ng-class="$ctrl.hasAssistant ? 'col-4' : 'col-12'">
          <salaxy-payroll-assistant current="$ctrl.current" page="$ctrl.page"></salaxy-payroll-assistant>
        </div>
      </div>
    </div>
    <div class="tab-pane" id="reports-tab">
      <div class="tab-content-wrapper" ng-if="$ctrl.payrollDetailsCurrentTab == 'reports'">
        <div ng-show="false" ng-init="$ctrl.clearReports()"></div>
        <ng-include src="'salaxy-components/calc/payrollV4/PayrollDetails_reports.html'"></ng-include>
      </div>
    </div>
    <div class="tab-pane" id="messages-tab" ng-if="'partnerMessaging' | sxyIsInRole">
      <ng-include ng-if="$ctrl.payrollDetailsCurrentTab == 'messages'" src="'salaxy-components/calc/payrollV4/PayrollDetails_messages.html'"></ng-include>
    </div>
    <div class="tab-pane" id="ports-tab">
      <ng-include ng-show="$ctrl.payrollDetailsCurrentTab == 'ports'" src="'salaxy-components/calc/payrollV4/PayrollDetails_ports.html'"></ng-include>
    </div>
    <div class="tab-pane" id="debug-tab" ng-if="'test' | sxyIsInRole">
      <ng-include ng-if="$ctrl.payrollDetailsCurrentTab == 'debug'" src="'salaxy-components/calc/payrollV4/PayrollDetails_debug.html'"></ng-include>
    </div>
  </div>
  <ng-include src="'salaxy-components/calc/payrollV4/PayrollDetails_calc.html'"></ng-include>
  <ng-include src="'salaxy-components/calc/payrollV4/PayrollDetails_header.html'"></ng-include>
</div>`), s.put("salaxy-components/calc/payrollV4/PayrollDetailsList.html", `<div class="salaxy-component salaxy-payroll-details-list">
  <div class="row w-100" ng-if="!$ctrl.hideButton">
    <div class="col-12 action-button-container mb-3">
      <salaxy-action-button action="'newPayroll'" button-class="btn-primary" style="margin-bottom:30px;"></salaxy-action-button>
    </div>
  </div>
  <salaxy-tab-buttons
    current-tab="$ctrl.currentTab"
    options="[
      { value: 'default', text: 'SALAXY.NG1.PayrollComponent.payrollList.tabs.latest' },
      { value: 'templates', text: 'SALAXY.NG1.PayrollComponent.payrollList.tabs.repeated' },
      { value: 'paid', text: 'SALAXY.NG1.PayrollComponent.payrollList.tabs.paid' },
      { value: 'paidcalcs', text: 'SALAXY.NG1.PayrollComponent.payrollList.tabs.paidSalaries' },
      { value: 'draftcalcs', text: 'SALAXY.NG1.PayrollComponent.payrollList.tabs.draftCalcs' }
    ]"
    tabs-id="payrollDetailsList">
  </salaxy-tab-buttons>
  <div class="tab-content" id="tab-content-payrollDetailsList">
    <div class="tab-pane" id="default-tab">
      <salaxy-odata-table crud-controller="Payroll4CrudController as $crud" options="{ $filter: 'status ne \\'paymentSucceeded\\' and status ne \\'paymentStarted\\' and status ne \\'template\\' and status ne \\'handled\\' and status ne \\'paymentCanceled\\'' }" read-only="$ctrl.isReadOnlyForced"></salaxy-odata-table>
    </div>
    <div class="tab-pane" id="templates-tab">
      <salaxy-odata-table crud-controller="Payroll4CrudController as $crud" options="{ $filter: 'status eq \\'template\\'' }" read-only="$ctrl.isReadOnlyForced"></salaxy-odata-table>
    </div>
    <div class="tab-pane" id="paid-tab">
      <salaxy-odata-table crud-controller="Payroll4CrudController as $crud" options="{ $filter: 'status eq \\'paymentSucceeded\\' or status eq \\'paymentStarted\\' or status eq \\'handled\\' or status eq \\'paymentCanceled\\'' }" read-only="$ctrl.isReadOnlyForced"></salaxy-odata-table>
    </div>
    <div class="tab-pane" id="paidcalcs-tab">
      <salaxy-odata-table url="/v03/api/calculations/category/readonly" crud-controller="CalculationCrudController as $crud" options="{ $filter: 'status eq \\'paymentSucceeded\\' and data/payrollId ne null' }" read-only="$ctrl.isReadOnlyForced"></salaxy-odata-table>
    </div>
    <div class="tab-pane" id="draftcalcs-tab">
      <salaxy-odata-table crud-controller="CalculationCrudController as $crud" options="{ $filter: 'status eq \\'payrollDraft\\'' }" read-only="$ctrl.isReadOnlyForced"></salaxy-odata-table>
    </div>
  </div>
</div>`), s.put("salaxy-components/calc/payrollV4/PayrollDetailsSelectList.html", `<div class="salaxy-component salaxy-payroll-details-select-list">
  <salaxy-odata-table ng-if="$ctrl.category=='paid'"  ng-if="$ctrl.mode == 'select'" template-url="salaxy-components/odata/lists/Payrolls-select.html"  options="{ $filter: 'status eq \\'paymentSucceeded\\' or status eq \\'paymentStarted\\'' }"
    selected-items="$ctrl.selectedItems" on-list-select="$ctrl.onListSelect({ value: value, item: item, allItems: allItems });" crud-controller="Payroll4CrudController as $crud"></salaxy-odata-table>
  <salaxy-odata-table ng-if="$ctrl.category=='draft'"  ng-if="$ctrl.mode == 'select'" template-url="salaxy-components/odata/lists/Payrolls-select.html"  options="{ $filter: 'status eq \\'draft\\'' }"
    selected-items="$ctrl.selectedItems" on-list-select="$ctrl.onListSelect({ value: value, item: item, allItems: allItems });" crud-controller="Payroll4CrudController as $crud"></salaxy-odata-table>
  </div>`), s.put("salaxy-components/calc/payrollV4/PayrollDetails_calc.html", `<div class="salaxy-navi-page-container salaxy-payroll-details-calc salaxy-payroll-details-dialog " ng-style="{'max-width': '100%','width': $ctrl.userSettings.ng1Binder('payroll.calcDialogSize').val || '75%'}" ng-class="{ 'offcanvas-show': $ctrl.shouldShowCanvas('calc',$ctrl.calcId) }">
  <div class="modal-header bg-primary">
    <h3 class="modal-title">{{ $ctrl.calc ? ( $ctrl.calc.worker.avatar.displayName + ", " + ($ctrl.calc.result.totals.totalGrossSalary | currency) ) : ('SALAXY.UI_Terms.loading' | sxyTranslate) }}
      <span ng-if="$ctrl.calc && ('pro' | sxyIsInRole)" ng-controller="CalculationCrudController as $calcCrud" ng-init="$calcCrud.model = $ctrl.calc">
        <salaxy-workflow-buttons api-ctrl="$calcCrud" on-change="$ctrl.refreshAfterWorkflow()" show-workflow-assign="false"></salaxy-workflow-buttons>
      </span>
    </h3>
    <span class="ms-auto">
      <button type="button" class="btn btn-transparent"  ng-click="$ctrl.userSettings.ng1Binder('payroll.calcDialogSize').val = ($ctrl.userSettings.ng1Binder('payroll.calcDialogSize').val == '100%' ? '75%' : '100%')"><i ng-class="$ctrl.userSettings.ng1Binder('payroll.calcDialogSize').val == '100%' ? 'bi bi-arrows-angle-contract' : 'bi bi-arrows-angle-expand'"></i></button>
      <button type="button" class="btn btn-primary" aria-label="Close" ng-click="$ctrl.setCalc()"><span class="bi bi-x-lg"></span></button>
    </span>
  </div>
  <div class="modal-body">
    <salaxy-tab-buttons
      current-tab="$ctrl.calcTab"
      options="[
        { value: 'calcrows', text: 'SALAXY.NG1.PayrollComponent.calcViews.rows' },
        { value: 'calccalculator', text: 'SALAXY.NG1.PayrollComponent.calcViews.calculator' },
        { value: 'calccostaccounting', text: 'SALAXY.NG1.PayrollComponent.calcViews.costAccounting' },
        { value: 'calcemployment', text: 'SALAXY.NG1.PayrollComponent.calcViews.employment' },
        { value: 'calcreports', text: 'SALAXY.NG1.PayrollComponent.calcViews.reports' },
        { value: 'calcdebug', text: 'Debug', hidden: !('test' | sxyIsInRole) }
      ]"
      tabs-id="payrollDetailsCalc">
    </salaxy-tab-buttons>
    <div class="tab-content" id="tab-content-payrollDetailsCalc">
      <div class="tab-pane" id="calcrows-tab">
        <salaxy-calc-worker-info ng-if="$ctrl.calc" model="$ctrl.calc"></salaxy-calc-worker-info>
        <div ng-if="$ctrl.calc" class="my-2" ng-controller="EmploymentCrudController as $employment" ng-init="$employment.queryResult={};$employment.getOData({ '$filter': 'id eq \\'' +  $ctrl.calc.worker.employmentId + '\\''}, $employment.queryResult)">
          <salaxy-workflow-badge mode="horizontal" ng-if="$employment.queryResult.items.length > 0" model="$employment.queryResult.items[0]" api-ctrl="$employment" wf-types="'EmployerMessageRecord'"></salaxy-workflow-badge>
        </div>
        <salaxy-calc-rows-2019-editor ng-if="$ctrl.calc" parent="$ctrl.calc" title="{{'SALAXY.NG1.PayrollComponent.payrollCalcs.calcRowEditor.title' | sxyTranslate}}"
          mode="edit" show-edit-buttons="false" 
          show-gross-totals="true"></salaxy-calc-rows-2019-editor>
        <salaxy-spinner ng-if="!$ctrl.calc"></salaxy-spinner>
      </div>
      <div class="tab-pane" id="calccalculator-tab">
        <salaxy-calc ng-if="$ctrl.calc" model="$ctrl.calc"></salaxy-calc>
        <salaxy-spinner ng-if="!$ctrl.calc"></salaxy-spinner>
      </div>
      <div class="tab-pane" id="calccostaccounting-tab">
        <div ng-class="$ctrl.userSettings.ng1Binder('payroll.calcDialogSize').val == '100%' ? 'container' : ''">
          <salaxy-calc-cost-accounting ng-if="$ctrl.calc" calc="$ctrl.calc" read-only="$ctrl.isReadOnly || $ctrl.calc.isReadOnly"></salaxy-calc-cost-accounting>
          <salaxy-spinner ng-if="!$ctrl.calc"></salaxy-spinner>
      </div>
      </div>
      <div class="tab-pane" id="calcemployment-tab">
        <salaxy-employment-details ng-if="$ctrl.calc" ng-ref="$ctrl.$employment" model="$ctrl.calc.worker.employmentId" is-modal="true"></salaxy-employment-details>
        <salaxy-spinner ng-if="!$ctrl.calc"></salaxy-spinner>
      </div>
      <div class="tab-pane" id="calcreports-tab">
        <salaxy-calc-reports ng-if="$ctrl.calc" calcs="[$ctrl.calc]" report-type="'salarySlip'"></salaxy-calc-reports>
        <salaxy-spinner ng-if="!$ctrl.calc"></salaxy-spinner>
      </div>
      <div class="tab-pane" id="calcdebug-tab">
        <div class="row" ng-if="$ctrl.calc">
          <div class="col-sm-6">
            <salaxy-json-formatter ng-if="$ctrl.calc" key="'Calculation'" open="0" json="$ctrl.calc"></salaxy-json-formatter>
            <salaxy-json-formatter ng-if="$ctrl.calcListItem" key="'List item'" open="0" json="$ctrl.calcListItem"></salaxy-json-formatter>
          </div>
          <div class="col-sm-6">
            <fieldset ng-init="$ctrl.initRowsImportParams()">
              <legend>Vie rivit (Muoto: Työajan tuonti)</legend>
              <salaxy-input name="debugTitle" ng-model="$ctrl.rowsImportParams.title" label="Otsikko"></salaxy-input>
              <salaxy-input name="debugPersonalId" ng-model="$ctrl.rowsImportParams.personalId" label="Henkilötunnus"></salaxy-input>
              <salaxy-input name="debugEmploymentType" ng-model="$ctrl.rowsImportParams.employmentType" label="Työsuhteen tyyppi"></salaxy-input>
              <salaxy-input name="debugPayrollId" ng-model="$ctrl.rowsImportParams.payrollId" label="Palkkalistan ID"></salaxy-input>
              <salaxy-date-range name="debugPeriod" ng-model="$ctrl.rowsImportParams.period" label="Palkkakausi"></salaxy-date-range>
              <button type="button" class="btn btn-default" ng-click="$ctrl.copyRowsImportData()">Vie rivit</button>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer justify-content-end">
    <div class="me-1">
      <button type="button" class="btn btn-default" ng-click="$ctrl.setCalc()" sxy-text="SALAXY.UI_Terms.close"></button>
      <div ng-if="$ctrl.calcTab=='calcrows' || $ctrl.calcTab=='calccalculator' || $ctrl.calcTab=='calccostaccounting'" class="btn-group dropup">
        <button type="button" ng-disabled="$ctrl.loaders[$ctrl.calc.id]" class="btn btn-secondary dropdown-toggle" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <span sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.options"></span>
        </button>
        <ul class="dropdown-menu dropdown-menu-end" role="menu" aria-labelledby="actions">
          <li role="menuitem" ng-if="!$ctrl.isReadOnly || !$ctrl.calc.isReadOnly">
            <a href="" ng-click="$ctrl.deleteCalc()" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.deletePayrollCalc" class="dropdown-item"></a>
          </li>
          <li role="menuitem" ng-if="!$ctrl.isReadOnly || !$ctrl.calc.isReadOnly">
            <a href="" ng-click="$ctrl.deleteCalc(true)" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.unlink" class="dropdown-item"></a>
          </li>
          <li role="menuitem">
            <a href="" ng-click="$ctrl.copyCalc()" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.copyAsNew" class="dropdown-item"></a>
          </li>
          <li role="menuitem" ng-if="$ctrl.isReadOnly && !$ctrl.calc.isReadOnly && !$ctrl.isCfa">
            <a href="" ng-click="$ctrl.payCalc()" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.pay" class="dropdown-item"></a>
          </li>
        </ul>
      </div>
    </div>
    <div>
      <button ng-if="$ctrl.page.total > 1 && $ctrl.payrollDetailsCurrentTab !=='calculations'" type="button" class="btn btn-default" ng-click="$ctrl.goToPage(true)"><span><i class="bi bi-rewind-fill"></i></span> <span sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.previousPage"></span></button>
      <button type="button" class="btn btn-default" ng-click="$ctrl.goToCalc(true)"><span><i class="bi bi-caret-left-fill"></i></span> <span sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.previousCalc"></span></button>
      <button type="button" class="btn btn-default" ng-click="$ctrl.goToCalc(false)"><span sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.nextCalc"></span> <span><i class="bi bi-caret-right-fill"></i></span></button>
    </div>

    <button ng-if="$ctrl.page.total > 1 && $ctrl.payrollDetailsCurrentTab !=='calculations'" type="button" class="btn btn-default" ng-click="$ctrl.goToPage(false)"><span sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.nextPage"></span> <span><i class="bi bi-fast-forward-fill"></i></span></button>
    <button ng-if="$ctrl.calcTab=='calcrows' || $ctrl.calcTab=='calccalculator' || $ctrl.calcTab=='calccostaccounting'"  type="button" class="btn btn-primary" ng-click="$ctrl.saveCalc($ctrl.calc)" ng-disabled="$ctrl.calc.isReadOnly || $ctrl.loaders[$ctrl.calc.id]">
      <span ng-if="$ctrl.loaders[$ctrl.calc.id]"><i class="bi bi-arrow-repeat bi-spin"></i></span>
      <span sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.save"></span>
      <span ng-if="$ctrl.hasCalcChange"> <span class="badge">1<span></span>
    </button>

    <button ng-if="$ctrl.calcTab=='calcemployment'" type="button" class="btn btn-default" ng-click="$ctrl.addSalaryDefaultsToCalc($ctrl.calc)" ng-disabled="$ctrl.calc.isReadOnly || $ctrl.loaders[$ctrl.calc.id + '-add-salary-defaults']"><span ng-if="$ctrl.loaders[$ctrl.calc.id + '-add-salary-defaults']"><i class="bi bi-arrow-repeat bi-spin"></i></span> <span sxy-text="SALAXY.NG1.EmploymentTaxcardsComponent.workerEdit.addSalaryDefaults"></span></button>
    <button ng-if="$ctrl.calcTab=='calcemployment'" type="button" class="btn btn-danger" ng-click="$ctrl.saveEmployment($ctrl.$employment.current, true)" ng-disabled="$ctrl.calc.isReadOnly || $ctrl.loaders[$ctrl.calc.id + '-employment-true']"><span ng-if="$ctrl.loaders[$ctrl.calc.id + '-employment-true']"><i class="bi bi-arrow-repeat bi-spin"></i></span> <span sxy-text="SALAXY.NG1.EmploymentTaxcardsComponent.workerEdit.updateWorkerInfoAndSalaryRows"></span></button>
    <button ng-if="$ctrl.calcTab=='calcemployment'" type="button" class="btn btn-primary" ng-click="$ctrl.saveEmployment($ctrl.$employment.current)" ng-disabled="$ctrl.calc.isReadOnly || $ctrl.loaders[$ctrl.calc.id + '-employment-false']"><span ng-if="$ctrl.loaders[$ctrl.calc.id + '-employment-false']"><i class="bi bi-arrow-repeat bi-spin"></i></span> <span sxy-text="SALAXY.NG1.EmploymentTaxcardsComponent.workerEdit.updateWorkerInfo"></span><span ng-if="$ctrl.hasEmploymentChange"> <span class="badge">1<span></span></button>
    
  </div>
</div>`), s.put("salaxy-components/calc/payrollV4/PayrollDetails_calcs.html", `<div class="table-responsive">
  <table class="table table-striped">
    <thead>
      <tr>
        <th colspan="4" ng-click="$ctrl.orderBy('otherPartyInfo.avatar.sortableName')" class="clickable">
          <span><span sxy-text="SALAXY.NG1_Other.Roles.worker"></span> <i ng-if="$ctrl.orderField == 'otherPartyInfo.avatar.sortableName'" class="fa" ng-class="$ctrl.orderReverse  ? 'bi-sort-down' : 'bi-sort-up'"></i></span>
        </th>
        <th class="right clickable" ng-click="$ctrl.orderBy('grossSalary')">
          <span><span sxy-text="SALAXY.NG1.CalcListComponent.salary"></span> <i ng-if="$ctrl.orderField == 'grossSalary'" class="fa" ng-class="$ctrl.orderReverse  ? 'bi-sort-down' : 'bi-sort-up'"></i></span>
        </th>
        <th class="right clickable" ng-click="$ctrl.orderBy('data.workerPayment')">
          <span><span sxy-text="SALAXY.NG1.CalcListComponent.net"></span> <i ng-if="$ctrl.orderField == 'data.workerPayment'" class="fa" ng-class="$ctrl.orderReverse  ? 'bi-sort-down' : 'bi-sort-up'"></i></span>
        </th>
        <th class="clickable" ng-click="$ctrl.orderBy('status')">
          <span><span sxy-text="SALAXY.NG1.CalcListComponent.status.title"></span> <i ng-if="$ctrl.orderField == 'status'" class="fa" ng-class="$ctrl.orderReverse  ? 'bi-sort-down' : 'bi-sort-up'"></i></span>
        </th>
        <th>
          <span sxy-text="SALAXY.NG1.WorkerDetailsComponent.records.label"></span>
        </th>
        <th sxy-if-role="pro">
          <div class="d-flex align-items-end">
            <span sxy-text="SALAXY.NG1.CalcListComponent.checked" class="me-2"></span>
            <salaxy-input-enum class="column-filter" ng-model="calculationChecked" ng-change="calculationChecked != null && $ctrl.setColumnFilter('PartnerMessageClosed', calculationChecked)" placeholder="SALAXY.MODEL.PayrollListItem.messages.tableHeading" name="calculationCheckedStatus" options="{ '': 'SALAXY.UI_Terms.showAll', true: 'SALAXY.MODEL.PayrollListItem.messages.tableHeading', false: 'SALAXY.MODEL.PayrollListItem.messages.tableHeadingNotChecked' }" label-type="plain"></salaxy-input-enum>
          </div>
        </th>
        <th sxy-if-role="pro">
          <div class="d-flex align-items-end">
            <span sxy-text="SALAXY.NG1.CalcListComponent.issues" class="me-2"></span>
            <salaxy-input-enum class="column-filter" ng-model="calculationIssue" ng-change="calculationIssue != null && $ctrl.setColumnFilter('PartnerMessageIssue', calculationIssue)" placeholder="SALAXY.MODEL.PayrollListItem.messages.tableHeadingIssues" name="calculationIssuesStatus" options="{ '': 'SALAXY.UI_Terms.showAll', true: 'SALAXY.MODEL.PayrollListItem.messages.tableHeadingIssues', false: 'SALAXY.MODEL.PayrollListItem.messages.tableHeadingNoIssues' }" label-type="plain"></salaxy-input-enum>
          </div>
        </th>
        <th class="right clickable" ng-click="$ctrl.orderBy('data.workStartDate')" >
          <span><span sxy-text="SALAXY.NG1.CalcListComponent.salaryPeriod"></span> <i ng-if="$ctrl.orderField == 'data.workStartDate'" class="fa" ng-class="$ctrl.orderReverse  ? 'bi-sort-down' : 'bi-sort-up'"></i></span>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="row in $ctrl.calcs" class="clickable" ng-class="{ 'active-payroll-item': $ctrl.calcId == row.id }"  ng-click="$ctrl.toggleCalc(row.id)">
        <td class="td-avatar middle">
          <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
        </td>
        <td class="td-name middle">
          <div>
            <span ng-if="row.otherPartyInfo.avatar.displayName == ''" sxy-text="SALAXY.NG1.CalcListComponent.notSelected"></span>
            <strong>{{row.otherPartyInfo.avatar.displayName}}</strong>
          </div>
          <div>{{ row.otherPartyInfo.officialId }}</div>
        </td>
        <td colspan="2" class="middle">
          <span ng-if="$ctrl.getCalcValidity(row)" class="error-summary text-danger" sxy-text="{{'SALAXY.VALIDATION.' + $ctrl.getCalcValidity(row).errors[0].code + '.label'}}"></span>
          <span ng-if="$ctrl.getCalcValidity(row) && $ctrl.getCalcValidity(row).errors[0].code == 'Payroll.Calc.TaxCardType'">
            <button class="btn btn-xs btn-default" ng-click="$ctrl.showAddNewTaxcard($event, row)">{{ 'SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.workerInfo.addTaxcard' | sxyTranslate}} <i class="bi bi-plus-lg"></i></button>
          </span>
        </td>
        <td class="right middle">{{ row.grossSalary | currency }}</td>
        <td class="right middle">{{ row.data.workerPayment | currency }}</td>
        <td class="middle"><span ng-class="$ctrl.rowStatusWarning(row) ? 'badge bg-danger': ''">{{ "SALAXY.ENUM.CalculationStatus." + row.status + ".label" | sxyTranslate }}<span></td>
        <td>
          <salaxy-workflow-badge mode="horizontal" ng-if="$ctrl.employments[row.data.employmentId].messages.length > 0" model="$ctrl.employments[row.data.employmentId]" api-ctrl="$employment" wf-types="'EmployerMessageRecord'"></salaxy-workflow-badge>
        </td>
        <td sxy-if-role="pro">
          <div ng-repeat="message in row.messages" ng-bind-html="message | sxyWorkflowMessage: 'PartnerMessageClosed'"></div>
        </td>
        <td sxy-if-role="pro">
          <div ng-repeat="message in row.messages" ng-bind-html="message | sxyWorkflowMessage: 'PartnerMessageIssue'"></div>
        </td>
        <td class="right middle">
          <span>{{ { start: row.data.workStartDate, end: row.data.workEndDate, } | sxyDateRange }}</span>
          <div ng-if="$ctrl.isDateDifferent(row)">
            <del class="small">{{ $ctrl.current.input.period | sxyDateRange }}</del>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>`), s.put("salaxy-components/calc/payrollV4/PayrollDetails_calcs_paged.html", `<div class="text-end">
  <span class="float-start" ng-if="$ctrl.page.total > 1">{{$ctrl.page.calcRange}}/{{$ctrl.page.totalCalcCount}}</span>
  <button type="button" ng-if="!('disableHolidays' | sxyIsInRole)" class="btn btn-secondary" ng-click="$ctrl.saveWorktimes()" ng-disabled="$ctrl.isReadOnly || !$ctrl.current.id  || $ctrl.current.input.calculations.length == 0 || $ctrl.loaders['worktime' + $ctrl.current.id]"><span ng-if="$ctrl.loaders['worktime' + $ctrl.current.id]"><i class="bi bi-arrow-repeat bi-spin"></i></span> <span sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.saveWorktime"></span></button>
  <div class="btn-group">
   <salaxy-input-enum  style="display: inline-block" name="pageSize" ng-model="$ctrl.pageSizeOption" label-type="plain" options="$ctrl.pageSizeOptions" ng-change="$ctrl.setPageItems()"></salaxy-input-enum>
   <button ng-if="$ctrl.page.total > 1" type="button" class="btn btn-default" ng-click="$ctrl.goToPage(true)"><span><i class="bi bi-caret-left-fill"></i></span> <span sxy-text="SALAXY.UI_Terms.previous"></span></button>
   <button ng-if="$ctrl.page.total > 1" type="button" class="btn btn-default" ng-click="$ctrl.goToPage(false)"><span sxy-text="SALAXY.UI_Terms.next"></span> <span><i class="bi bi-caret-right-fill"></i></span></button>
  </div>
  <button type="button" class="btn btn-primary" ng-click="$ctrl.savePageCalcs()" ng-disabled="$ctrl.numOfChangedPageCalcs == 0 || $ctrl.loaders['pageCalcs' + $ctrl.page.current]"><span ng-if="$ctrl.loaders['pageCalcs' + $ctrl.page.current]"><i class="bi bi-arrow-repeat bi-spin"></i></span> <span sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.save"></span><span ng-if="$ctrl.numOfChangedPageCalcs > 0"> <span class="badge">{{$ctrl.numOfChangedPageCalcs}}<span></span></span></button>
</div>
<div class="table-responsive">
  <table class="table table-striped">
    <thead>
      <tr>
        <th colspan="4" sxy-text="SALAXY.NG1_Other.Roles.worker"></th>
        <th class="right" sxy-text="SALAXY.NG1.CalcListComponent.salary"></th>
        <th class="right" sxy-text="SALAXY.NG1.CalcListComponent.net"></th>
        <th class="" sxy-text="SALAXY.NG1.CalcListComponent.status.title"></th>
        <th sxy-text="SALAXY.NG1.WorkerDetailsComponent.records.label"></th>
        <th sxy-if-role="pro" sxy-text="SALAXY.NG1.CalcListComponent.checked"></th>
        <th sxy-if-role="pro" sxy-text="SALAXY.NG1.CalcListComponent.issues"></th>
        <th ng-if="!('disableHolidays' | sxyIsInRole)" class="right" sxy-text="SALAXY.NG1.CalcListComponent.worktime"></th>
        <th class="right" sxy-text="SALAXY.NG1.CalcListComponent.salaryPeriod"></th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat-start="row in $ctrl.page.items" class="clickable" ng-class="{ 'active-payroll-item': $ctrl.calcId == row.id }" ng-click="$ctrl.toggleCalc(row.id)">
        <td class="td-avatar middle">
          <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
        </td>
        <td class="td-name middle">
          <div>
            <span ng-if="row.otherPartyInfo.avatar.displayName == ''" sxy-text="SALAXY.NG1.CalcListComponent.notSelected"></span>
            <strong>{{row.otherPartyInfo.avatar.displayName}}</strong>
          </div>
          <div>{{ row.otherPartyInfo.officialId }}</div>
        </td>
        <td colspan="2" class="middle">
          <span ng-if="$ctrl.getCalcValidity(row)" class="error-summary text-danger" sxy-text="{{'SALAXY.VALIDATION.' + $ctrl.getCalcValidity(row).errors[0].code + '.label'}}"></span>
          <span ng-if="$ctrl.getCalcValidity(row) && $ctrl.getCalcValidity(row).errors[0].code == 'Payroll.Calc.TaxCardType'">
            <button class="btn btn-xs btn-default" ng-click="$ctrl.showAddNewTaxcard($event, row)">{{ 'SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.workerInfo.addTaxcard' | sxyTranslate}} <i class="bi bi-plus-lg"></i></button>
          </span>
        </td>
        <td class="right middle">{{ row.grossSalary | currency }}</td>
        <td class="right middle">{{ row.data.workerPayment | currency }}</td>
        <td class="middle"><span ng-class="$ctrl.rowStatusWarning(row) ? 'badge bg-danger': ''">{{ "SALAXY.ENUM.CalculationStatus." + row.status + ".label" | sxyTranslate }}<span></td>
        <td class="middle">
          <div ng-if="$ctrl.getPageCalc(row)" ng-controller="EmploymentCrudController as $employment" ng-init="$employment.queryResult={};$employment.getOData({ '$filter': 'id eq \\'' +  $ctrl.getPageCalc(row).worker.employmentId + '\\''}, $employment.queryResult)">
            <salaxy-workflow-badge mode="horizontal" ng-if="$employment.queryResult.items.length > 0" model="$employment.queryResult.items[0]" api-ctrl="$employment" wf-types="'EmployerMessageRecord'"></salaxy-workflow-badge>
          </div>
        </td>
        <td class="middle" sxy-if-role="pro">
          <div ng-repeat="message in row.messages" ng-bind-html="message | sxyWorkflowMessage: 'PartnerMessageClosed'"></div>
        </td>
        <td class="middle" sxy-if-role="pro">
          <div ng-repeat="message in row.messages" ng-bind-html="message | sxyWorkflowMessage: 'PartnerMessageIssue'"></div>
        </td>
        <td ng-if="!('disableHolidays' | sxyIsInRole)" class="right">
          <table class="text-small" ng-if="$ctrl.getPageCalc(row)">
            <tbody>
              <tr>
                <td sxy-text="SALAXY.NG1.CalcComponent.panelWorkTime.overview.leavesDays"></td>
                <td class="right">{{ $ctrl.calculatePeriodDays($ctrl.getPageCalc(row),'leavesDays') | sxyCount : 'day' }}</td>
              </tr>
              <tr>
                <td sxy-text="SALAXY.NG1.CalcComponent.panelWorkTime.overview.absencesDays"></td>
                <td class="right">{{ $ctrl.calculatePeriodDays($ctrl.getPageCalc(row),'absencesDays') | sxyCount : 'day' }}</td>
              </tr>
              <tr>
                <td sxy-text="SALAXY.NG1.CalcComponent.panelWorkTime.overview.paidAbsencesDays"></td>
                <td class="right">{{ $ctrl.calculatePeriodDays($ctrl.getPageCalc(row),'paidAbsencesDays') | sxyCount : 'day' }}</td>
              </tr>
              <tr ng-if="$ctrl.showAccruals($ctrl.getPageCalc(row))">
                <td sxy-text="SALAXY.NG1.CalcComponent.panelWorkTime.overview.accruedDays"></td>
                <td class="right">{{ $ctrl.calculatePeriodDays($ctrl.getPageCalc(row),'accruedDays') | sxyCount : 'day' }}</td>
              </tr>
            </tbody>
          </table>
        </td>
        <td class="right middle">
          <span>{{ { start: row.data.workStartDate, end: row.data.workEndDate, } | sxyDateRange }}</span>
          <div ng-if="$ctrl.isDateDifferent(row)">
            <del class="small">{{ $ctrl.current.input.period | sxyDateRange }}</del>
          </div>
        </td>
      </tr>
      <tr ng-repeat-end>
        <td colspan="12">
          <salaxy-spinner ng-if="!$ctrl.getPageCalc(row)"></salaxy-spinner>
          <salaxy-calc-rows-2019-editor ng-if="$ctrl.getPageCalc(row)" parent="$ctrl.getPageCalc(row)" title="{{'SALAXY.NG1.PayrollComponent.payrollCalcs.calcRowEditor.title' | sxyTranslate}}" mode="{{$ctrl.getPageCalc(row).isReadOnly ? 'read-only' : 'read-edit'}}" show-edit-buttons="false" is-in-edit="!$ctrl.getPageCalc(row).isReadOnly" show-gross-totals="true" dimension-count="2">
          </salaxy-calc-rows-2019-editor>
        </td>
      </tr>
    </tbody>
  </table>
</div>
<div class="text-right">
  <span class="float-start" ng-if="$ctrl.page.total > 1">{{$ctrl.page.calcRange}}/{{$ctrl.page.totalCalcCount}}</span>
  <button type="button" class="btn btn-default" ng-click="$ctrl.goToPage(true)"><span><i class="bi bi-rewind-fill me-2"></i></span> <span sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.previousPage"></span></button>
  <button type="button" class="btn btn-default" ng-click="$ctrl.goToPage(false)"><span sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.nextPage"></span> <span><i class="ms-2 bi bi-fast-forward-fill"></i></span></button>
  <button type="button" class="btn btn-primary" ng-click="$ctrl.savePageCalcs()" ng-disabled="$ctrl.numOfChangedPageCalcs == 0 || $ctrl.loaders['pageCalcs' + $ctrl.page.current]"><span ng-if="$ctrl.loaders['pageCalcs' + $ctrl.page.current]"><i class="bi bi-arrow-repeat bi-spin"></i></span> <span sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.calculation.actions.save"></span><span ng-if="$ctrl.numOfChangedPageCalcs > 0"> <span class="badge">{{$ctrl.numOfChangedPageCalcs}}<span></span></span></button>
</div>`), s.put("salaxy-components/calc/payrollV4/PayrollDetails_debug.html", `<salaxy-json-formatter ng-if="$ctrl.current" key="'PAYROLL'" json="$ctrl.current"></salaxy-json-formatter>`), s.put("salaxy-components/calc/payrollV4/PayrollDetails_header.html", `<div class="salaxy-navi-page-container salaxy-payroll-details-header salaxy-payroll-details-dialog" ng-style="{'max-width': '100%','width': $ctrl.userSettings.ng1Binder('payroll.headerDialogSize').val || '75%'}" ng-class="{ 'offcanvas-show': $ctrl.shouldShowCanvas('header',$ctrl.showHeader || $ctrl.isNew())}">
  <div class="modal-header bg-primary">
   
    <h3 ng-if="$ctrl.isNew()"  class="modal-title">{{$ctrl.current.input.title || ('SALAXY.NG1.PayrollComponent.payrollEdit.editProperties.new.heading' | sxyTranslate)}}</h3>
    <h3 ng-if="!$ctrl.isNew()"  class="modal-title">{{$ctrl.current.input.title}}</h3>
    <span class="ms-auto">
      <button type="button" class="btn btn-transparent"  ng-click="$ctrl.userSettings.ng1Binder('payroll.headerDialogSize').val = ($ctrl.userSettings.ng1Binder('payroll.headerDialogSize').val == '100%' ? '75%' : '100%')"><i ng-class="$ctrl.userSettings.ng1Binder('payroll.headerDialogSize').val == '100%' ? 'bi bi-arrows-angle-contract' : 'bi bi-arrows-angle-expand'" class="text-white"></i></button>
      <button type="button" class="btn btn-transparent" aria-label="Close" ng-click="$ctrl.closeHeader()"><span class="bi bi-x-lg text-white"></span></button>
    </span>
  </div>
  <div class="modal-body">
    <div ng-class="$ctrl.userSettings.ng1Binder('payroll.headerDialogSize').val == '100%' ? 'container' : ''">
      <ng-form name="$ctrl.payrollDetailsForm" class="form-horizontal" ng-readonly="$ctrl.isReadOnly">
        <div class="col-12 payroll-edit-properties-col">
          <salaxy-input name="title" label="SALAXY.NG1.PayrollComponent.payrollEdit.editProperties.title" required ng-model="$ctrl.current.input.title"></salaxy-input>
          <salaxy-form-group name="paymentChannel" label="SALAXY.NG1.PayrollComponent.payrollEdit.editProperties.paymentChannel">
            <salaxy-pay-button ng-if="!$ctrl.isReadOnly || $ctrl.showAction('pay')" model="$ctrl.current" mode="channel-select" button-class="btn-block"></salaxy-pay-button>
            <div ng-if="$ctrl.isReadOnly && !$ctrl.showAction('pay')">{{ "PaymentChannel." + $ctrl.current.input.paymentChannel | sxyEnum }}</div>
          </salaxy-form-group>
          <div ng-if="(!$ctrl.isReadOnly || $ctrl.showAction('pay')) && ('test,setSalaryDateKind' | sxyIsInRole)"  ng-switch="$ctrl.current.input.paymentChannel">
            <div ng-switch-when="palkkausManual|talenomManual|palkkausInvoices|palkkausCfaTest|kitsas|briox|askelma|passeliMerit|ecom|hausvise" ng-switch-when-separator="|">
              <salaxy-form-group name="salaryDateKind" label="SALAXY.MODEL.PayrollInput.salaryDateKind.title">       
                <salaxy-salary-date-kind-button button-class="btn-block" model="$ctrl.current" ></salaxy-salary-date-kind-button>
              </salaxy-form-group>
            </div>
          </div>
          <salaxy-form-group ng-if="($ctrl.isReadOnly && !$ctrl.showAction('pay')) && $ctrl.current.input.salaryDateKind == 'inPast'" name="salaryDateKind" class="salaxy-component salaxy-read-only" label="SALAXY.MODEL.CalcWorkflow.salaryDateKind.title">
            <div class="form-control-plaintext">{{"SALAXY.ENUM.SalaryDateKind." + ($ctrl.current.input.salaryDateKind) + ".label" | sxyTranslate  }}</div>
          </salaxy-form-group>
    
          <salaxy-datepicker-popup read-only="false" ng-if="!$ctrl.isReadOnly || $ctrl.showAction('pay')" label="SALAXY.NG1.PayrollComponent.payrollEdit.editProperties.salaryDate" name="salaryDate" ng-model="$ctrl.current.input.salaryDate" date-disabled="disable-function" disable-function="$ctrl.isDisabledSalaryDate"></salaxy-datepicker-popup>
          <div class="row py-2" ng-if="$ctrl.isReadOnly && !$ctrl.showAction('pay')">
            <div class="col-sm-4"><strong sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.editProperties.salaryDate" ps=":"></strong> </div>
            <div class="col-sm-8">
              {{ $ctrl.current.info.salaryDate | date }}
              <span class="badge bg-info" ng-if="$ctrl.current.info.status != 'paymentSucceeded' && !$ctrl.current.input.salaryDate && $ctrl.current.info.salaryDate">{{'SALAXY.NG1.PayrollComponent.payrollEdit.payrollInfo.salaryDateEstimate' | sxyTranslate}}</span>
              <span ng-if="$ctrl.current.info.status != 'paymentSucceeded' &&  $ctrl.current.info.salaryDate && $ctrl.current.input.salaryDate && $ctrl.current.input.salaryDate != $ctrl.current.info.salaryDate"><s>{{ $ctrl.current.input.salaryDate | date }}</s> <span class="badge bg-warning">{{'SALAXY.NG1.PayrollComponent.payrollEdit.payrollInfo.salaryDateNote' | sxyTranslate}}</span></span>    
            </div>
          </div>
          <salaxy-date-range read-only="$ctrl.isReadOnly && !$ctrl.showAction('pay')" label="SALAXY.NG1.PayrollComponent.payrollEdit.editProperties.salaryPeriod" name="period" ng-model="$ctrl.current.input.period" mode="calc"></salaxy-date-range>

          <salaxy-input name="sourceId" label="Source ID (import)" ng-model="$ctrl.current.input.sourceId"></salaxy-input>
          
          <salaxy-form-group ng-if="$ctrl.isNew() && $ctrl.current.input.calculations.length" label="SALAXY.NG1.PayrollComponent.payrollEdit.editProperties.new.copyingCalcs" name="calcCount">
            {{ $ctrl.current.input.calculations.length }} {{ 'SALAXY.UI_Terms.units.pce' | sxyTranslate}}
          </salaxy-form-group>
          <salaxy-input-boolean ng-if="$ctrl.isNew() && $ctrl.current.input.calculations.length" type="select" required placeholder="SALAXY.UI_Terms.choose" name="updateCalcsInCopy" ng-model="$ctrl.updateCalcsInCopy" label="SALAXY.NG1.PayrollComponent.payrollEdit.editProperties.new.updateCalcs" label-false="SALAXY.NG1.PayrollComponent.payrollEdit.editProperties.new.updateCalcsFalse"
            label-true="SALAXY.NG1.PayrollComponent.payrollEdit.editProperties.new.updateCalcsTrue"></salaxy-input-boolean>
        </div>
      </ng-form>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-default" ng-click="$ctrl.closeHeader()" sxy-text="SALAXY.UI_Terms.close"></button>

    <button type="button" ng-if="!$ctrl.isNew()" class="btn btn-primary ms-2" ng-click="$ctrl.save()" ng-disabled="($ctrl.isReadOnly && !$ctrl.showAction('pay')) || (!$ctrl.payrollDetailsForm.$valid || !$ctrl.current.input.paymentChannel || $ctrl.current.input.paymentChannel == 'undefined' )  || $ctrl.loaders[$ctrl.current.id || 'new']"><span
      ng-if="$ctrl.loaders[$ctrl.current.id || 'new']"><i class="bi bi-arrow-repeat bi-spin"></i></span> <span sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.toolbar.save"></span></button>
    <button type="button" ng-if="$ctrl.isNew()" class="btn btn-primary ms-2" ng-click="$ctrl.save({ 'applyEmploymentDefaultRows' : !$ctrl.updateCalcsInCopy})" ng-disabled="(!$ctrl.payrollDetailsForm.$valid || !$ctrl.current.input.paymentChannel || $ctrl.current.input.paymentChannel == 'undefined') || $ctrl.loaders[$ctrl.current.id || 'new']"><span
        ng-if="$ctrl.loaders[$ctrl.current.id || 'new']"><i class="bi bi-arrow-repeat bi-spin"></i></span> <span sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.editProperties.new.createPayrollButton"></span></button>
  </div>
</div>
`), s.put("salaxy-components/calc/payrollV4/PayrollDetails_import_debug.html", `<div ng-controller="ImportStagingController as $import">
  <div>
    <div class="row">
      <div class="col-12">
        <div class="btn-group" style="padding: 5px;">
          <button 
            class="btn btn-primary" 
            ng-click="$import.uploadTestJson($import.debugJson)"
            ng-disabled="!$import.debugJson">
            Send JSON
          </button>
          <button 
            class="btn btn-info" 
            ng-click="$import.formatDebugJson($import.debugJson)"
            ng-disabled="!$import.debugJson"
            style="margin-left: 5px;">
            Format JSON
          </button>
          <button 
            class="btn btn-info" 
            ng-click="$import.debugJsonAddBlank()"
            style="margin-left: 5px;">
            Add Blank WorktimeImport
          </button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-6 col-md-6">
          <sxy-code-editor ng-model="$import.debugJson" lang="json" height="600px"></sxy-code-editor>
      </div>
      <div class="col-6 col-md-6">
        <div ng-if="$import.uploadResults">
          <salaxy-json-formatter json="$import.uploadResults" key="'result'" open="10"></salaxy-json-formatter>
        </div>
        <div ng-if="!$import.uploadResults">
          <p class="text-center text-muted">
            Results will appear here after sending JSON
          </p>
        </div>
      </div>
    </div>
  </div>
</div>`), s.put("salaxy-components/calc/payrollV4/PayrollDetails_info.html", `<div class="row w-100 payroll-info-row">
  <div class="col-auto">
    <salaxy-avatar-placeholder class="payroll-avatar">
      <i class="salaxy-avatar bi bi-square-fill text-muted d-flex" ng-class="{'draft-invalid' : $ctrl.current.info.status == 'draft' && !$ctrl.current.info.isReadyForPayment, 'text-success' : $ctrl.current.info.status == 'paymentSucceeded', 'text-warning' : ($ctrl.current.info.status == 'paymentStarted' || $ctrl.current.info.status == 'waitingApproval') , 'text-danger' : $ctrl.current.info.status == 'paymentCancelled'}">
        <div class="avatar-text-wrapper">
          <strong>{{ $ctrl.current.info.calcCount }}</strong>
          <small>{{ $ctrl.current.info.salaryDate | date : "d.M." }}</small>
        </div>
      </i>
    </salaxy-avatar-placeholder>
  </div>
  <div class="col-auto payroll-info-col">
    <h3 class="payroll-title">{{ $ctrl.current.input.title }}</h3>
    <div class="row">
      <div class="col-12 col-sm-6">
        <div>
          <span>{{ 'PayrollStatus.' + $ctrl.current.info.status | sxyEnum }}</span>
          <span ng-if="$ctrl.current.info.status == 'draft'" ng-class="$ctrl.current.info.isReadyForPayment ? 'text-success' : 'text-danger'">
            {{ $ctrl.current.info.isReadyForPayment ? (('SALAXY.NG1.PayrollComponent.payrollEdit.payrollInfo.readyForPayment' | sxyTranslate)) :
            (('SALAXY.NG1.PayrollComponent.payrollEdit.payrollInfo.notReadyForPayment' | sxyTranslate)) }}
          </span>
        </div>
        <div>
          <span sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.payrollInfo.salaryPeriod" ps=":"></span> {{ $ctrl.current.input.period | sxyDateRange }} ({{$ctrl.current.input.period.daysCount}} <span sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.payrollInfo.salaryPeriodDaysCount"></span>)
        </div>
        <div>
          <span sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.payrollInfo.salaryDate" ps=":"></span> 
          {{ $ctrl.current.info.salaryDate | date }}
          <span class="badge bg-info" ng-if="$ctrl.current.info.status != 'paymentSucceeded' && !$ctrl.current.input.salaryDate && $ctrl.current.info.salaryDate">{{'SALAXY.NG1.PayrollComponent.payrollEdit.payrollInfo.salaryDateEstimate' | sxyTranslate}}</span>
          <span ng-if="$ctrl.current.info.status != 'paymentSucceeded' &&  $ctrl.current.info.salaryDate && $ctrl.current.input.salaryDate && $ctrl.current.input.salaryDate != $ctrl.current.info.salaryDate"><s>{{ $ctrl.current.input.salaryDate | date }}</s> <span class="badge bg-warning">{{'SALAXY.NG1.PayrollComponent.payrollEdit.payrollInfo.salaryDateNote' | sxyTranslate}}</span></span>
        </div>
        <div>
          <span ng-if="$ctrl.current.input.template" sxy-html="SALAXY.NG1.PayrollComponent.payrollEdit.payrollInfo.template.html" params="{template: ($ctrl.current.input.template)}"></span>
        </div>
        <div>
          <small>ID: <code>{{ $ctrl.currentId }}</code></small>
        </div>
      </div>
      <div class="col-12 col-sm-6">
        <span><span sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.payrollInfo.calcCount" ps=":"></span><span ng-style="$ctrl.getExceptionStyle($ctrl.info.calcCount.exception)"> {{ $ctrl.info.calcCount.original }}</span><span ng-if="$ctrl.info.calcCount.exception"> {{ $ctrl.info.calcCount.actual }}</span></span><br />
        <span><span sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.payrollInfo.grossSalary" ps=":"></span><span ng-style="$ctrl.getExceptionStyle($ctrl.info.totalGrossSalary.exception)"> {{ $ctrl.info.totalGrossSalary.original | currency }}</span><span ng-if="$ctrl.info.totalGrossSalary.exception"> {{ $ctrl.info.totalGrossSalary.actual | currency }}</span></span><br />
        <span><span sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.payrollInfo.totalPayment" ps=":"><span ng-style="$ctrl.getExceptionStyle($ctrl.info.totalPayment.exception)"> {{ $ctrl.info.totalPayment.original | currency }}</span><span ng-if="$ctrl.info.totalPayment.exception"> {{ $ctrl.info.totalGrossSalary.actual | currency }}</span></span><br />
        <button type="button" class="btn btn-xs btn-default" ng-click="$ctrl.showHeader = !$ctrl.showHeader" ><span sxy-text="{{$ctrl.isReadOnly ? 'SALAXY.UI_Terms.show' : 'SALAXY.UI_Terms.edit'}}"></span> <i ng-class="$ctrl.isReadOnly ? 'bi bi-info-circle' : 'bi bi-pencil-fill'"></i></button>
      </div>
    </div>
    <div ng-if="'company' | sxyIsInRole" ng-controller="CompanyAccountController as $company" style="padding: 8px">
      <salaxy-workflow-badge ng-if="$company.current" model="$company.current" mode="horizontal" api-ctrl="$company" wf-types="'EmployerMessageRecord'"></salaxy-workflow-badge>
    </div>
    <div ng-if="$ctrl.showWorkflowMessage" style="margin-bottom: 4px;">
      <!-- Only shown in Accountor / Finago -->
      <salaxy-textarea name="workflowMessage" ng-model="$ctrl.workflowMessage" placeholder="{{'SALAXY.NG1.PayrollComponent.payrollEdit.toolbar.workFlowMessage'}}" rows="2" label-type="plain"></salaxy-textarea>
    </div>
  </div>
  <div class="col ms-auto d-none d-sm-block" ng-if="$ctrl.$import.isSupported && $ctrl.$import.worktimeApi.list" style="max-width: 400px;">
    <button type="button" class="btn btn-primary btn-sm pull-right" ng-click="$ctrl.selectTab('ports')" sxy-text="SALAXY.NG1.ImportStagingComponent.payrollView.btnMoreInfo"></button>
    <h3 sxy-text="SALAXY.NG1.ImportStagingComponent.payrollView.title" style="margin-top: 0"></h3>
    <table style="width: 100%; ">
      <colgroup>
        <col style="width: 40%;">
        <col style="width: 10%;">
        <col style="width: 40%;">
        <col style="width: 10%;">
      </colgroup>
      <tbody>
        <tr>
          <td><div class="text-muted" sxy-text="SALAXY.NG1.ImportStagingComponent.status.preview"></div></td>
          <td class="right"><div class="text-muted">{{ $ctrl.$import.getTotals("all").rows.preview }}</div></td>
          <td style="padding-left: 6px;"><div class="" sxy-text="SALAXY.NG1.ImportStagingComponent.list.calcCount"></div></td>
          <td class="right">{{ $ctrl.$import.getTotals("all").rows.count }}</td>
        </tr>
        <tr>
          <td><div class="text-primary"><b sxy-text="SALAXY.NG1.ImportStagingComponent.status.new"></b></div></td>
          <td ng-if="$ctrl.$import.getTotals('all').rows.new" class="right"><div class="bg-primary badge">&nbsp;&nbsp;{{ $ctrl.$import.getTotals("all").rows.new }}&nbsp;</div></td>
          <td ng-if="!$ctrl.$import.getTotals('all').rows.new" class="right"><div class="text-primary">0</div></td>
          <td style="padding-left: 6px;"><div class=""><b sxy-text="SALAXY.NG1.ImportStagingComponent.status.committed"></b></div></td>
          <td class="right"><b>{{ $ctrl.$import.getTotals("all").rows.committed }}</b></td>
        </tr>
        <tr>
          <td><div class=""><s sxy-text="SALAXY.NG1.ImportStagingComponent.status.deleted"></s></div></td>
          <td class="right"><s>{{ $ctrl.$import.getTotals("all").rows.deleted }}</s></td>
          <td style="padding-left: 6px;"><div class="text-muted" sxy-text="SALAXY.NG1.ImportStagingComponent.status.ignored"></div></td>
          <td class="right"><div class="text-muted">{{ $ctrl.$import.getTotals("all").rows.ignored }}</div></td>
        </tr>
        <tr>
          <td><div class="text-danger" sxy-text="SALAXY.NG1.ImportStagingComponent.status.error"></div></td>
          <td ng-if="$ctrl.$import.getTotals('all').rows.error" class="right"><div class="bg-danger badge">&nbsp;&nbsp;{{ $ctrl.$import.getTotals("all").rows.error }}&nbsp;</div></td>
          <td ng-if="!$ctrl.$import.getTotals('all').rows.error" class="right"><div class="text-danger">0</div></td>
        </tr>
      </tbody>
    </table>
  </div>
</div>`), s.put("salaxy-components/calc/payrollV4/PayrollDetails_messages.html", `<div ng-if="!$ctrl.current.info.messageThreadId" ng-controller="MessageThreadCrudController as $msg" ng-init="$msg.model='new'" class="form-horizontal" style="max-width: 600px;">
  <fieldset sxy-if-role="!pro">
    <p ng-if="!$ctrl.current.info.messageThreadId">Tähän palkkalistaan ei liity viestiketjua / työnkulkua.</p>
    <!--
    <legend>Lähetä tilitoimistolle</legend>
    <p>Luo tästä uusi viestiketju, jolla voit lähettää palkkalistan tilitoimiston käsittelyyn.</p>
    <salaxy-input-enum name="action" label="Pyydetään toimintaa" type="radio" ng-model="$msg.current.input.todoAction" options="$ctrl.messageActions"
      ng-change="$msg.current.title = $ctrl.getMessageTitle($msg.current.input.todoAction)"></salaxy-input-enum>
    <salaxy-input name="title" label="SALAXY.NG1.MessageThreadComponent.title" require="true" disabled="!$msg.current.input.todoAction" ng-model="$msg.current.title"></salaxy-input>
    <salaxy-form-group name="msgSubmit" label-type="empty-label">
      <button type="button" class="btn btn-primary" ng-click="$ctrl.sendPayrollMessage($msg)">Lähetä</button>
    </salaxy-form-group>
    -->
  </fieldset>
  <fieldset sxy-if-role="pro">
    <legend>Lähetä yritykselle</legend>
    <p>Luo tästä uusi viestiketju, jolla voit lähettää palkkalistan yritykselle hyväksyttäväksi / maksettavaksi.</p>
    <salaxy-input-enum name="action" label="Pyydetään toimintaa" type="radio" ng-model="$msg.current.input.todoAction" options="$ctrl.messageActions"
      ng-change="$msg.current.title = $ctrl.getMessageTitle($msg.current.input.todoAction)"></salaxy-input-enum>
    <salaxy-input name="title" label="SALAXY.NG1.MessageThreadComponent.title" require="true" disabled="!$msg.current.input.todoAction"
      ng-model="$msg.current.title"></salaxy-input>
    <salaxy-form-group name="msgSubmit" label-type="empty-label">
      <button type="button" class="btn btn-primary" ng-click="$ctrl.sendPayrollMessage($msg)">Lähetä</button>
    </salaxy-form-group>
  </fieldset>
</div>
<div class="container" ng-if="$ctrl.current.info.messageThreadId">
  <button type="button" class="btn btn-danger float-end" ng-click="$ctrl.deleteMessage($ctrl.$msg)"><i class="bi bi-trash-fill" aria-hidden="true"></i></button>
  <salaxy-message-thread model="$ctrl.current.info.messageThreadId" ng-ref="$ctrl.$msg" role="{{('pro' | sxyIsInRole) ? 'otherParty' : 'owner' }}" other-party="'partner'"
    mark-as-read="5"></salaxy-message-thread>
</div>`), s.put("salaxy-components/calc/payrollV4/PayrollDetails_ports.html", `<div> 
  <salaxy-import-staging ng-ref="$ctrl.$import" payroll="$ctrl.current" payroll-calcs="$ctrl.calcs"></salaxy-import-staging>
</div>`), s.put("salaxy-components/calc/payrollV4/PayrollDetails_reports.html", `<div class="container" ng-if="$ctrl.calcs.length" ng-init="$ctrl.refreshReports()">
  <salaxy-calc-reports ng-if="$ctrl.reportCalcs.length" calcs="$ctrl.reportCalcs"  report-type="'salarySlip'"></salaxy-calc-reports>
</div>
`), s.put("salaxy-components/calc/payrollV4/PayrollDetails_toolbar.html", `<div ng-if="$ctrl.isReadOnly" class="btn-toolbar">
  <button class="btn btn-secondary" ng-if="$ctrl.showAction('copy')" ng-click="$ctrl.showCopyAsNew($ctrl.current)" sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.toolbar.copyAsNew"></button>
  <div class="ms-auto">
    <salaxy-pay-button ng-ref="$ctrl.$payButton" ng-if="$ctrl.showAction('pay')" model="$ctrl.current" mode="pay-button" button-class="float-sm-end"
      label="SALAXY.NG1.PayrollComponent.payrollPayButton" 
      disabled="!$ctrl.current.info.isReadyForPayment || !$ctrl.current.input.calculations.length || !$ctrl.$payButton.isChannelDefined" ></salaxy-pay-button>
    <button ng-if="$ctrl.showAction('cancel') && ($ctrl.current.info.status == 'paymentStarted' && ($ctrl.current.input.paymentChannel == 'palkkausManual' || $ctrl.current.input.paymentChannel == 'talenomManual' || $ctrl.current.input.paymentChannel == 'palkkausInvoices' || $ctrl.current.input.paymentChannel == 'kitsas' || $ctrl.current.input.paymentChannel == 'palkkausPersonal' || $ctrl.current.input.paymentChannel == 'palkkausCfaPaytrail' || $ctrl.current.input.paymentChannel == 'palkkausEcfaPaytrail' || $ctrl.current.input.paymentChannel == 'palkkausCfaReference' || $ctrl.current.input.paymentChannel == 'palkkausEcfaReference' || $ctrl.current.input.paymentChannel == 'palkkausCfaFinvoice' || $ctrl.current.input.paymentChannel == 'palkkausEcfaFinvoice' ||  $ctrl.current.input.paymentChannel == 'palkkausCfaTest'))"
      class="btn btn-secondary  btn-labeled-right" ng-click="$ctrl.cancelInvoices()"><span sxy-text="SALAXY.NG1.CalcResultsComponent.cancelPaymentOrChangeChannelBtn"></span><i
        class="bi bi-x-circle"></i></button>
    <button ng-if="$ctrl.current.info.status != 'waitingApproval' && $ctrl.current.info.status != 'draft'" class="btn btn-secondary btn-labeled-right"
      ng-click="$ctrl.showPaymentDialog()"><span sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.toolbar.showPaymentInfo"></span><i class="bi bi-info-circle"></i></button>
  </div>
  <button class="btn btn-default float-end" ng-if="('partnerMessaging' | sxyIsInRole) && (!('pro' | sxyIsInRole) && $ctrl.current.info.messageThreadId )" ng-click="$ctrl.selectTab('messages')" sxy-text="SALAXY.NG1.PayrollComponent.payrollCommentButton"></button>
</div>
<div ng-if="!$ctrl.isReadOnly" class="btn-toolbar calc-toolbar">
  <div class="btn-group dropdown">
    <button type="button" class="btn btn-labeled-left btn-primary dropdown-toggle" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="bi bi-plus-lg"></i>
      <span sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.addCalculation"></span>
    </button>
    <ul class="dropdown-menu" role="menu" aria-labelledby="addcalculation">
      <li role="menuitem">
        <a ng-click="$ctrl.addEmployments()" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.addWorker"></a>
      </li>
      <li role="menuitem">
        <a ng-click="$ctrl.addCalcs('draft')" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.addDraft"></a>
      </li>
      <li role="menuitem">
        <a ng-click="$ctrl.addCalcs('shared')" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.addShared"></a>
      </li>
      <li role="menuitem">
        <a ng-click="$ctrl.addCalcs('draft', true, true, true)" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.mergeDraft"></a>
      </li>
      <li role="menuitem">
        <a ng-click="$ctrl.addCalcs('shared', true, true, true)" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.mergeShared"></a>
      </li>
      <li role="menuitem">
        <a ng-click="$ctrl.addCalcs('paid')" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.addCopy"></a>
      </li>
      <li role="menuitem">
        <a ng-click="$ctrl.mergePayroll(true, true)" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollCalcs.toolbar.addPayroll"></a>
      </li>
    </ul>
  </div>
  <div class="btn-group dropdown ms-1" >
    <button type="button" class="btn btn-secondary dropdown-toggle" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      <span sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.toolbar.options"></span>
    </button>
    <ul class="dropdown-menu" role="menu" aria-labelledby="actions">
      <li role="menuitem">
        <a ng-click="$ctrl.importEmploymentDataAll()" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.toolbar.importEmploymentCalc"></a>
      </li>
      <li role="menuitem" salaxy-if-role="test">
        <a ng-click="$ctrl.addSalaryDefaultsToAllCalcs()" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.toolbar.addSalaryDefaults"></a>
      </li>
      <li role="menuitem">
        <a ng-click="$ctrl.showCopyAsNew($ctrl.current)" class="dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.toolbar.copyAsNew"></a>
      </li>
      <li role="menuitem">
        <a ng-click="$ctrl.delete()" class="text-danger dropdown-item" sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.toolbar.delete"></a>
      </li>
    </ul>
  </div>
  <button ng-if="$ctrl.hasAssistantKey" style="padding: 5px 10px 1px 8px" type="button" class="btn btn-default" ng-click="$ctrl.assist()"><svg xmlns="http://www.w3.org/2000/svg" width="80px"  viewBox="0 0 1180 320"><path d="m367.44 153.84c0 52.32 33.6 88.8 80.16 88.8s80.16-36.48 80.16-88.8-33.6-88.8-80.16-88.8-80.16 36.48-80.16 88.8zm129.6 0c0 37.44-20.4 61.68-49.44 61.68s-49.44-24.24-49.44-61.68 20.4-61.68 49.44-61.68 49.44 24.24 49.44 61.68z"/><path d="m614.27 242.64c35.28 0 55.44-29.76 55.44-65.52s-20.16-65.52-55.44-65.52c-16.32 0-28.32 6.48-36.24 15.84v-13.44h-28.8v169.2h28.8v-56.4c7.92 9.36 19.92 15.84 36.24 15.84zm-36.96-69.12c0-23.76 13.44-36.72 31.2-36.72 20.88 0 32.16 16.32 32.16 40.32s-11.28 40.32-32.16 40.32c-17.76 0-31.2-13.2-31.2-36.48z"/><path d="m747.65 242.64c25.2 0 45.12-13.2 54-35.28l-24.72-9.36c-3.84 12.96-15.12 20.16-29.28 20.16-18.48 0-31.44-13.2-33.6-34.8h88.32v-9.6c0-34.56-19.44-62.16-55.92-62.16s-60 28.56-60 65.52c0 38.88 25.2 65.52 61.2 65.52zm-1.44-106.8c18.24 0 26.88 12 27.12 25.92h-57.84c4.32-17.04 15.84-25.92 30.72-25.92z"/><path d="m823.98 240h28.8v-73.92c0-18 13.2-27.6 26.16-27.6 15.84 0 22.08 11.28 22.08 26.88v74.64h28.8v-83.04c0-27.12-15.84-45.36-42.24-45.36-16.32 0-27.6 7.44-34.8 15.84v-13.44h-28.8z"/><path d="m1014.17 67.68-65.28 172.32h30.48l14.64-39.36h74.4l14.88 39.36h30.96l-65.28-172.32zm16.8 34.08 27.36 72h-54.24z"/><path d="m1163.69 68.18h-30.72v172.32h30.72z"/><path d="m297.06 130.97c7.26-21.79 4.76-45.66-6.85-65.48-17.46-30.4-52.56-46.04-86.84-38.68-15.25-17.18-37.16-26.95-60.13-26.81-35.04-.08-66.13 22.48-76.91 55.82-22.51 4.61-41.94 18.7-53.31 38.67-17.59 30.32-13.58 68.54 9.92 94.54-7.26 21.79-4.76 45.66 6.85 65.48 17.46 30.4 52.56 46.04 86.84 38.68 15.24 17.18 37.16 26.95 60.13 26.8 35.06.09 66.16-22.49 76.94-55.86 22.51-4.61 41.94-18.7 53.31-38.67 17.57-30.32 13.55-68.51-9.94-94.51zm-120.28 168.11c-14.03.02-27.62-4.89-38.39-13.88.49-.26 1.34-.73 1.89-1.07l63.72-36.8c3.26-1.85 5.26-5.32 5.24-9.07v-89.83l26.93 15.55c.29.14.48.42.52.74v74.39c-.04 33.08-26.83 59.9-59.91 59.97zm-128.84-55.03c-7.03-12.14-9.56-26.37-7.15-40.18.47.28 1.3.79 1.89 1.13l63.72 36.8c3.23 1.89 7.23 1.89 10.47 0l77.79-44.92v31.1c.02.32-.13.63-.38.83l-64.41 37.19c-28.69 16.52-65.33 6.7-81.92-21.95zm-16.77-139.09c7-12.16 18.05-21.46 31.21-26.29 0 .55-.03 1.52-.03 2.2v73.61c-.02 3.74 1.98 7.21 5.23 9.06l77.79 44.91-26.93 15.55c-.27.18-.61.21-.91.08l-64.42-37.22c-28.63-16.58-38.45-53.21-21.95-81.89zm221.26 51.49-77.79-44.92 26.93-15.54c.27-.18.61-.21.91-.08l64.42 37.19c28.68 16.57 38.51 53.26 21.94 81.94-7.01 12.14-18.05 21.44-31.2 26.28v-75.81c.03-3.74-1.96-7.2-5.2-9.06zm26.8-40.34c-.47-.29-1.3-.79-1.89-1.13l-63.72-36.8c-3.23-1.89-7.23-1.89-10.47 0l-77.79 44.92v-31.1c-.02-.32.13-.63.38-.83l64.41-37.16c28.69-16.55 65.37-6.7 81.91 22 6.99 12.12 9.52 26.31 7.15 40.1zm-168.51 55.43-26.94-15.55c-.29-.14-.48-.42-.52-.74v-74.39c.02-33.12 26.89-59.96 60.01-59.94 14.01 0 27.57 4.92 38.34 13.88-.49.26-1.33.73-1.89 1.07l-63.72 36.8c-3.26 1.85-5.26 5.31-5.24 9.06l-.04 89.79zm14.63-31.54 34.65-20.01 34.65 20v40.01l-34.65 20-34.65-20z"/></svg></button>
  <div sxy-if-role="pro" class="btn-group">
    <div class="btn-group align-items-center ms-1 dropdown">
      <!-- HACK: Rewrite workflow buttons as components. Or make PRO calculator a component. -->
      <button class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown" type="button" aria-haspopup="true" aria-expanded="false" style="font-weight: bold;">
        {{ "PayrollStatus." + $ctrl.current.info.status | sxyEnum }}
      </button>
      <ul class="dropdown-menu" role="menu">
        <li ng-class="{ disabled: $ctrl.current.info.status=='draft' }">
          <a href="" ng-click="$ctrl.current.info.status = 'draft';$ctrl.save()" class="dropdown-item">{{ "PayrollStatus.draft" | sxyEnum }}</a>
        </li>
        <li ng-class="{ disabled: $ctrl.current.info.status=='template' }">
          <a href="" ng-click="$ctrl.current.info.status = 'template';$ctrl.save()" class="dropdown-item">{{ "PayrollStatus.template" | sxyEnum }}</a>
        </li>
        <li ng-class="{ disabled: $ctrl.current.info.status=='handled' }">
          <a href="" ng-click="$ctrl.current.info.status = 'handled';$ctrl.save()" class="dropdown-item">{{ "PayrollStatus.handled" | sxyEnum }}</a>
        </li>
        <li ng-class="{ disabled: $ctrl.current.info.status=='waitingApproval' }">
          <a href="" ng-click="$ctrl.current.info.status = 'waitingApproval';$ctrl.save()" class="dropdown-item">{{ "PayrollStatus.waitingApproval" | sxyEnum }}</a>
        </li>
        <li ng-class="{ disabled: $ctrl.current.info.status=='waitingPartnerApproval' }">
          <a href="" ng-click="$ctrl.current.info.status = 'waitingPartnerApproval';$ctrl.save()" class="dropdown-item">{{ "PayrollStatus.waitingPartnerApproval" | sxyEnum }}</a>
        </li>
        <li ng-class="{ disabled: $ctrl.current.info.status=='paymentAllowed' }">
          <a href="" ng-click="$ctrl.current.info.status = 'paymentAllowed';$ctrl.save()" class="dropdown-item">{{ "PayrollStatus.paymentAllowed" | sxyEnum }}</a>
        </li>
        <li ng-class="{ disabled: $ctrl.current.info.status=='waitingPartnerApproval' }">
          <a href="" ng-click="$ctrl.current.info.status = 'waitingPartnerApproval';$ctrl.save()" class="dropdown-item">{{ "PayrollStatus.waitingPartnerApproval" | sxyEnum }}</a>
        </li>
        <li ng-class="{ disabled: $ctrl.current.info.status=='paymentAllowed' }">
          <a href="" ng-click="$ctrl.current.info.status = 'paymentAllowed';$ctrl.save()" class="dropdown-item">{{ "PayrollStatus.paymentAllowed" | sxyEnum }}</a>
        </li>
      </ul>
    </div>
    <salaxy-workflow-buttons api-ctrl="$ctrl"></salaxy-workflow-buttons>
  </div>
  <div class="btn-group ms-auto">
     <salaxy-pay-button ng-ref="$ctrl.$payButton" ng-if="$ctrl.current.info.status != 'template'" model="$ctrl.current" mode="pay-button" button-class="float-sm-end"
      label="SALAXY.NG1.PayrollComponent.payrollPayButton" 
      disabled="!$ctrl.current.info.isReadyForPayment || !$ctrl.current.input.calculations.length || !$ctrl.$payButton.isChannelDefined" ></salaxy-pay-button>
  </div>
</div>`), s.put("salaxy-components/calc/rows/CalcIrRows.html", `<div class="salaxy-calc-ir-rows salaxy-component">
  <table class="table">
    <thead>
      <tr>
        <th sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.headerIrCode"></th>
        <th sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.headerRowDescription"></th>
        <th sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.headerCalc" class="right"></th>
        <th sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.headerSum" class="right"></th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="row in $ctrl.irRows">
        <td>
          <div class="d-flex">
            <salaxy-avatar class="salaxy-calc-row-type-avatar" avatar="{ color: '#2b507c', initials: row.irData.code, entityType: 'company' }"></salaxy-avatar>
            <div class="flex-column">
              <b>{{ $ctrl.getIncomeType(row).label }}</b><br />
              <small>
                <div class="truncate" style="max-width: 250px;">
                  {{$ctrl.getIncomeType(row).description}}
                </div>
              </small>
            </div>
          </div>
        </td>
        <td>{{ row.message }}</td>
        <td class="right">
          <span ng-if="row.unit != 'one'">
            {{ row.count | sxyCount : row.unit }} *
          </span> {{ row.price | currency }} =
        </td>
        <td class="right">{{ row.total | currency }}
        </td>
        <td class="salaxy-calc-rows-editor-btns" ng-if="row.type=='manual'">
          <button type="button" class="edit btn btn-info" ng-click="$ctrl.setCurrentIrRow(row)"><i class="bi bi-pencil-square"></i></button>
          <button type="button" class="delete btn btn-danger" ng-click="$ctrl.deleteIrRow(row)"><i class="bi bi-trash-fill"></i></button>
        </td>
        <td class="salaxy-calc-rows-editor-btns" ng-if="row.type!='manual'">
          <button type="button" class="edit btn btn-info" ng-click="$ctrl.setCurrentIrRow(row)"><i class="bi bi-info-circle"></i></button>
        </td>
      </tr>
    </tbody>
    <tfoot ng-if="!$ctrl.isReadOnly">
      <tr>
        <th colspan="6" class="text-end">
          <button type="button" class="btn btn-default" ng-click="$ctrl.recalculate()" sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.updateCalc"></button>
          <button type="button" class="btn btn-info" ng-click="$ctrl.addIrRow()" sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.addNewRow"></button>
        </th>
      </tr>
    </tfoot>
  </table>
  <h4 sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.chosenRowInfo"></h4>
  <div ng-if="!$ctrl.currentRow" sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.chooseRowOrAddNew"></div>
  <salaxy-tab-buttons
    ng-if="$ctrl.currentRow"
    current-tab="$ctrl.currentTab"
    options="[
      { value: 'irbasic', text: 'SALAXY.NG1.CalcRowsComponent.irRows.basicInfo' },
      { value: 'irincometype', text: 'SALAXY.NG1.CalcRowsComponent.irRows.irFlagsInfo' },
      { value: 'irsidecosts', text: 'SALAXY.NG1.CalcRowsComponent.irRows.taxAndSideCosts' },
      { value: 'irjson', text: 'JSON' }
    ]"
    tabs-id="calcIrRows">
  </salaxy-tab-buttons>
  <div class="tab-content" id="tab-content-calcIrRows">
    <div class="tab-pane" id="irbasic-tab">
      <div class="form-horizontal">
        <div class="row">
          <div class="col col-md-12 col-lg-6">
            <h2 sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.textAndType"></h2>
            <salaxy-input-income-type name="code" ng-model="$ctrl.currentRow.irData.code" hidden-codes="[1]" label="SALAXY.NG1.CalcRowsComponent.irRows.typeLabel" disabled="$ctrl.isIrRowReadOnly" ng-change="$ctrl.updateCurrentRowType()">
            </salaxy-input-income-type>
            <salaxy-input name="message" ng-model="$ctrl.currentRow.message" label="SALAXY.NG1.CalcRowsComponent.irRows.messageLabel" disabled="$ctrl.isIrRowReadOnly"></salaxy-input>
            <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.irRows.groupingLabel" disabled="$ctrl.isIrRowReadOnly"
              options="$ctrl.groupingOptions"
              name="calcGrouping" ng-model="$ctrl.currentRow.calcData.grouping" type="select"></salaxy-input-enum>
            <salaxy-form-group label="SALAXY.NG1.CalcRowsComponent.irRows.creditTransferLabel" name="paymentDefault">
              <div ng-if="$ctrl.currentRowType.paymentDefault == 1" sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.payment"></div>
              <div ng-if="$ctrl.currentRowType.paymentDefault == -1" sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.deduction"></div>
              <div ng-if="$ctrl.currentRowType.paymentDefault == 0" sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.noPayment"></div>
            </salaxy-form-group>
          </div>
          <div class="col col-md-12 col-lg-6">
            <h2 sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.calc"></h2>
            <salaxy-input-number name="count" ng-model="$ctrl.currentRow.count" disabled="$ctrl.isIrRowReadOnly" label="SALAXY.NG1.CalcRowsComponent.irRows.countLabel"></salaxy-input-number>
            <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.irRows.unitLabel" enum="Unit" name="Unit" disabled="$ctrl.isIrRowReadOnly" ng-model="$ctrl.currentRow.unit" type="select"></salaxy-input-enum>
            <salaxy-input-number name="price" ng-model="$ctrl.currentRow.price" disabled="$ctrl.isIrRowReadOnly" label="SALAXY.NG1.CalcRowsComponent.irRows.priceLabel"></salaxy-input-number>
            <salaxy-form-group name="total" label="SALAXY.NG1.CalcRowsComponent.irRows.totalLabel">
              <p>{{ $ctrl.currentRow.count * $ctrl.currentRow.price | currency }}</p>
            </salaxy-form-group>
          </div>
          <div class="col col-md-12 col-lg-6" ng-if="$ctrl.currentRow.irData.code == 304">
            <h2 sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.carBenefitInfo"></h2>
            <p sxy-html="SALAXY.NG1.CalcRowsComponent.irRows.carBenefitInfoHtml"></p>
            <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.irRows.carBenefitTypeLabel" disabled="$ctrl.isIrRowReadOnly" enum="CarBenefitCode" name="carBenefitCode"
              ng-model="$ctrl.currentRow.irData.carBenefit.carBenefitCode" disabled="$ctrl.isIrRowReadOnly" type="select"></salaxy-input-enum>
            <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.irRows.carBenefitAgeGroupLabel" enum="AgeGroupCode" name="ageGroupCode" disabled="$ctrl.isIrRowReadOnly" ng-model="$ctrl.currentRow.irData.carBenefit.ageGroupCode" type="select">
            </salaxy-input-enum>
            <salaxy-input-number label="SALAXY.NG1.CalcRowsComponent.irRows.carBenefitEmissionsValueLabel" name="emissionsValue" disabled="$ctrl.isIrRowReadOnly" minimum="0" maximum="100" ng-model="$ctrl.currentRow.irData.carBenefit.emissionsValue">
            </salaxy-input-number>
            <salaxy-input-number label="SALAXY.NG1.CalcRowsComponent.irRows.carBenefitKilometersLabel" name="kilometers" disabled="$ctrl.isIrRowReadOnly" ng-model="$ctrl.currentRow.irData.carBenefit.kilometers">
            </salaxy-input-number>
          </div>
          <div class="col col-md-12 col-lg-6" ng-if="$ctrl.currentRow.irData.code == 331">
            <h2 sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.dailyAllowanceAdditionalSelections"></h2>
            <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.irRows.dailyAllowanceTypeLabel" disabled="$ctrl.isIrRowReadOnly" enum="AllowanceCode" name="dailyAllowance" type="multi-select"
              ng-model="$ctrl.currentRow.irData.dailyAllowance"></salaxy-input-enum>
          </div>
          <div class="col col-md-12 col-lg-6" ng-if="$ctrl.currentRow.irData.code == 334">

            <h2 sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.mealBenefitAdditionalSelections"></h2>
            <p sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.mealBenefitTaxInfo"></p>

            <salaxy-input-boolean type="checkbox" name="mealBenefitIsTaxValue" ng-model="$ctrl.currentRow.irData.mealBenefitIsTaxValue" label-type="plain"
              label-true="SALAXY.NG1.CalcRowsComponent.irRows.mealBenefitIsTaxValueLabel" disabled="$ctrl.isIrRowReadOnly"></salaxy-input-boolean>

          </div>
        </div>
        <div class="text-end" ng-if="!$ctrl.isIrRowReadOnly">
          <button type="button" class="btn btn-default" ng-click="$ctrl.recalculate()" sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.updateCalc"></button>
          <button type="button" class="btn btn-info" ng-click="$ctrl.addIrRow()" sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.addNewRow"></button>
        </div>
      </div>
    </div>
    <div class="tab-pane" id="irincometype-tab">
      <div class="form-horizontal">
        <h2>{{ $ctrl.currentRowType.label }} ({{ $ctrl.currentRowType.code }})</h2>
        <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.irRows.irFlagsLabel" enum="IrFlags" name="flags" type="multi-select" disabled="$ctrl.isIrRowReadOnly" ng-model="$ctrl.currentRow.irData.flags">
        </salaxy-input-enum>
        <salaxy-form-group label="SALAXY.NG1.CalcRowsComponent.irRows.negativeSupportedLabel" name="isNegativeSupported">
          <div ng-if="$ctrl.currentRowType.isNegativeSupported" sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.allowed"></div>
          <div ng-if="!$ctrl.currentRowType.isNegativeSupported" sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.notAllowed"></div>
        </salaxy-form-group>
        <div style="white-space: pre-wrap">{{ $ctrl.currentRowType.description }}</div>

        <h2 sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.earningPeriod"></h2>
        <p sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.earningPeriodInfo"></p>
        <salaxy-datepicker-popup name="startDate" disabled="$ctrl.isIrRowReadOnly" label="SALAXY.NG1.CalcRowsComponent.irRows.earningPeriodStartDateLabel" ng-model="$ctrl.currentRow.earningPeriod.start"></salaxy-datepicker-popup>
        <salaxy-datepicker-popup name="endDate" disabled="$ctrl.isIrRowReadOnly" label="SALAXY.NG1.CalcRowsComponent.irRows.earningPeriodEndDateLabel" ng-model="$ctrl.currentRow.earningPeriod.end"></salaxy-datepicker-popup>
      </div>
    </div>
    <div class="tab-pane" id="irsidecosts-tab">
      <div class="form-horizontal">
        <h2>{{ $ctrl.currentRowType.label }}</h2>
        <div style="white-space: pre-wrap">{{ $ctrl.currentRowType.taxAndSidecostsDescr }}</div>
        <table class="table">
          <tbody>
            <tr>
              <th sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.tax"></th>
              <td>
                <div ng-if="$ctrl.currentRowType.taxDefault == 1" class="text-success" sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.withheld"></div>
                <div ng-if="$ctrl.currentRowType.taxDefault == -1" class="text-warning" sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.deductionAlt"></div>
                <div ng-if="$ctrl.currentRowType.taxDefault == 0" class="text-danger" sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.notwithheld"></div>
              </td>
              <td></td>
            </tr>
            <tr>
              <th sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.socialSecurityPayment"></th><th sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.socialSecurityPayment">
              <th sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.toBePaid"></th>
              <th>
                <!-- TODO: Lisää tähän srakkeeseen tieto poikkeuksen jälkeen-->
              </th>
            </tr>
            <tr>
              <th sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.occupationPension"></th>
              <td>
                <span ng-class="$ctrl.currentRowType.pensionInsurance ? 'text-success' : 'text-danger'">
                  {{ $ctrl.currentRowType.pensionInsurance ? ("SALAXY.UI_Terms.yes" | sxyTranslate) : ("SALAXY.UI_Terms.no" | sxyTranslate) }}
                </span>
              </td>
              <td>
              </td>
            </tr>
            <tr>
              <th sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.insurancePayment"></th>
              <td>
                <span ng-class="$ctrl.currentRowType.accidentInsurance ? 'text-success' : 'text-danger'">
                  {{ $ctrl.currentRowType.accidentInsurance ? ("SALAXY.UI_Terms.yes" | sxyTranslate) : ("SALAXY.UI_Terms.no" | sxyTranslate) }}
                </span>
              </td>
              <td></td>
            </tr>
            <tr>
              <th sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.unemploymentInsurancePayment"></th>
              <td>
                <span ng-class="$ctrl.currentRowType.unemploymentInsurance ? 'text-success' : 'text-danger'">
                  {{ $ctrl.currentRowType.unemploymentInsurance ? ("SALAXY.UI_Terms.yes" | sxyTranslate) : ("SALAXY.UI_Terms.no" | sxyTranslate) }}
                </span>
              </td>
              <td></td>
            </tr>
            <tr>
              <th sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.healtInsurancePayment"></th>
              <td>
                <span ng-class="$ctrl.currentRowType.healthInsurance ? 'text-success' : 'text-danger'">
                  {{ $ctrl.currentRowType.healthInsurance ? ("SALAXY.UI_Terms.yes" | sxyTranslate) : ("SALAXY.UI_Terms.no" | sxyTranslate) }}
                </span>
              </td>
              <td></td>
            </tr>
          </tbody>
        </table>
        <div ng-if="!$ctrl.currentRowType.insuranceInformationAllowed">
          <p sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.insuranceInformationAllowed"></p>
        </div>
        <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.irRows.IrInsuranceExceptions" enum="IrInsuranceExceptions" name="dailyAllowance" disabled="$ctrl.isIrRowReadOnly"
          ng-if="$ctrl.currentRowType.insuranceInformationAllowed" ng-model="$ctrl.currentRow.irData.insuranceExceptions" type="multi-select"></salaxy-input-enum>
      </div>
    </div>
    <div class="tab-pane" id="irjson-tab">
      <salaxy-json-formatter json="$ctrl.currentRow" open="2"></salaxy-json-formatter>
    </div>
  </div>
</div>`), s.put("salaxy-components/calc/rows/CalcRowCostAccounting.html", `<div class="salaxy-component salaxy-calc-cost-accounting">
  <div ng-if="$ctrl.isLegacy">
    <fieldset>
      <legend sxy-text="SALAXY.NG1.CalcCostAccountingComponent.title"></legend>
      <table class="table">
        <thead>
          <tr>
            <th>{{('SALAXY.NG1.CalcCostAccountingComponent.defaultLabel') | sxyTranslate}}</th>
            <th class="right">{{"SALAXY.NG1.CalcCostAccountingComponent.percent" | sxyTranslate}}</th>
            <th class="right">
              <button type="button" class="btn btn-primary btn-xs" ng-if="!$ctrl.isReadOnly" ng-click="$ctrl.costCenter.push({})" sxy-text="SALAXY.UI_Terms.addRow"></button>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="item in $ctrl.costCenter">
            <td>
              <salaxy-input-typeahead ng-if="$ctrl.getOptions('costCenter').length" ng-model="item.id" label-format="text-value"
                options="$ctrl.getOptions('costCenter')" name="{{ 'id' + $index }}" label-type="plain" read-only="$ctrl.isReadOnly"></salaxy-input-typeahead>
              <salaxy-input ng-if="!$ctrl.getOptions('costCenter').length" ng-model="item.id" name="{{ 'id' + $index }}" label-type="plain" read-only="$ctrl.isReadOnly">
              </salaxy-input>
            </td>
            <td>
              <salaxy-input-number ng-model="item.percent" name="{{ 'percent' + $index }}" label-type="plain" read-only="$ctrl.isReadOnly" unit="percent"></salaxy-input-number>
            </td>
            <td class="text-end" >
              <button ng-if="!$ctrl.isReadOnly" type="button" class="btn btn-danger" ng-click="$ctrl.costCenter.splice($index, 1)">
                <i class="bi bi-trash" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}"></i>
              </button>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="total">
            <td>{{"SALAXY.UI_Terms.total" | sxyTranslate}}</td>
            <td class="right">{{ $ctrl.getLegacySum() | sxyCount : 'percent' }}</td>
            <td class="right"></td>
          </tr>
        </tfoot>
      </table>
    </fieldset>
  </div>
  <div ng-if="!$ctrl.isLegacy && ($ctrl.row.accounting.dimensions.length > 0 || $ctrl.definitions.length > 0)">
    <salaxy-cost-accounting ng-init="$ctrl.row.accounting = ($ctrl.row.accounting || $ctrl.isReadOnly)  ? $ctrl.row.accounting : { dimensions: []}" current="$ctrl.row.accounting.dimensions" inherited="$ctrl.calc.accounting.dimensions" scope="row" dimensions="$ctrl.dimensions" read-only="$ctrl.isReadOnly" ></salaxy-cost-accounting>
  </div>
  <div style="margin-bottom: 10px;" sxy-if-role="test">
    <salaxy-json-formatter key="'All dimensions'" json="$ctrl.row.accounting.dimensions" open="0" xx-type="dialog" btn-class="btn btn-default" ></salaxy-json-formatter>
  </div>
</div>`), s.put("salaxy-components/calc/rows/CalcRowDimensionInput.html", `<div class="d-flex">
  <salaxy-input-typeahead 
    class="text-muted flex-grow-1" 
    style="flex-grow: 1;"
    ng-if="$ctrl.isInherited() && $ctrl.hasOptions() && !$ctrl.isCostSharingEnabled()" 
    label-type="plain"
    ng-model="$ctrl.getInheritedSingleValue().value"
    label-format="text-value" 
    options="$ctrl.getOptions()" 
    name="single" 
    read-only="true">
  </salaxy-input-typeahead>
  <salaxy-input 
    class="text-muted flex-grow-1"
    style="flex-grow: 1;"
    ng-if="$ctrl.isInherited() && !$ctrl.hasOptions() && !$ctrl.isCostSharingEnabled()"
    label-type="plain"
    ng-model="$ctrl.getInheritedSingleValue().value"
    name="single"
    read-only="true">
  </salaxy-input>
  <salaxy-input-typeahead 
    class="flex-grow-1"
    ng-if="!$ctrl.isInherited() && $ctrl.hasOptions() && !$ctrl.isCostSharingEnabled()"
    label-type="plain"
    ng-model="$ctrl.getSingleValue().value"
    ng-change="$ctrl.setSingleValue($ctrl.getSingleValue().value)"
    label-format="text-value"
    options="$ctrl.getOptions()"
    name="single"
    read-only="$ctrl.readOnly">
  </salaxy-input-typeahead>
  <salaxy-input
    class="flex-grow-1"
    ng-if="!$ctrl.isInherited() && !$ctrl.hasOptions() && !$ctrl.isCostSharingEnabled()"
    style="flex-grow: 1;"
    label-type="plain"
    ng-model="$ctrl.getSingleValue().value" 
    ng-change="$ctrl.setSingleValue($ctrl.getSingleValue().value)"
    name="single"
    read-only="$ctrl.readOnly">
  </salaxy-input>
  <div class="btn" ng-if="!$ctrl.readOnly && $ctrl.isInherited() && !$ctrl.isCostSharingEnabled()">
    <span> <i ng-click="$ctrl.setSingleValue($ctrl.getInheritedSingleValue().value)" class="bi bi-pencil-fill clickable"></i></span>
  </div>
  <table ng-if="$ctrl.isCostSharingEnabled()" class="text-small">
    <tbody>
      <tr ng-repeat="costCenter in $ctrl.getCostSharingValues()" ng-class="$ctrl.isInherited() ? 'text-muted' : ''" class="" style="line-height: 0.9em;">
        <td>{{costCenter.text}}</td>
        <td>{{costCenter.value | sxyCount: 'percent'}}</td>
      </tr>    
    </tbody>
  </table>
</div>
`), s.put("salaxy-components/calc/rows/CalcRowDocumentation.html", `<div ng-if="!$ctrl.showLoader()">
  <fieldset>
    <legend>
      <span>{{$ctrl.example.description}}</span>
    </legend>
    <salaxy-input-typeahead ng-if="$ctrl.row.config.kind.name" name="kind" label-type="horizontal" label="Kind for row" ng-change="$ctrl.generateExampleLocally()" ng-model="$ctrl.selectedKind" enum="{{$ctrl.row.config.kind.name}}" ></salaxy-input-typeahead>
  </fieldset>
  <div ng-if="$ctrl.exampleSamples.length > 0">
    <salaxy-tab-buttons
      current-tab="$ctrl.currentTab"
      options="$ctrl.tabOptions"
      tabs-id="calcRowDocumentation">
    </salaxy-tab-buttons>
    <div class="tab-content" id="tab-content-calcRowDocumentation">
      <div ng-repeat="sample in $ctrl.exampleSamples track by $index" class="tab-pane" id="tab{{ $index + 1 }}-tab">
        <p>{{sample.description}}</p>
        <sxy-code-editor ng-model="sample.code" editor="sample"></sxy-code-editor>
      </div>
    </div>
  </div>
</div>
<div ng-if="$ctrl.showLoader()">
  <salaxy-spinner></salaxy-spinner>
</div>`), s.put("salaxy-components/calc/rows/CalcRowFormula.html", `<div>
  <div ng-if="!$ctrl.editingScriptName">
    <div class="row">
      <div class="col-md-6">
        <salaxy-input-enum ng-model="$ctrl.selectedScriptName" options="$ctrl.scriptNames" name="scriptName" label="Laskukaavat" label-type="plain"></salaxy-input-enum>
      </div>
      <div class="col-md-6">
        <button class="btn btn-primary" ng-click="$ctrl.addScript()" ng-disabled="$ctrl.selectedScriptAdded">Lisää laskukaava</button>
      </div>
    </div>
    <table style="margin-top: 10px;">
      <thead>
        <tr>
          <th width="20%">Nimi</th>
          <th width="20%">Kuvaus</th>
          <th width="50%">Kaava</th>
          <th width="10%"></th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="prop in $ctrl.scriptingProperties">
          <td width="20%">{{ prop }}</td>
          <td width="20%">{{ $ctrl.getDescription(prop) }}</td>
          <td width="50%">
            <textarea class="form-control" style="width: 100%; height: 48px;" ng-model="$ctrl.row.data.scripting[prop]"></textarea>
          </td>
          <td width="10%">
            <button type="button" class="edit btn btn-info btn-sm" ng-click="$ctrl.editScript(prop)"
              title="{{'SALAXY.NG1.CalcRowsComponent.editor.buttons.infoIcon' | sxyTranslate}}"><i class="bi bi-pencil-fill"></i></button>
            <button type="button" class="delete btn btn-danger btn-sm" ng-click="$ctrl.removeScript(prop)"
              title="{{'SALAXY.NG1.CalcRowsComponent.editor.buttons.infoIcon' | sxyTranslate}}"><i class="bi bi-trash-fill"></i></button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div ng-if="$ctrl.editingScriptName">
    <div class="text-right">
      <button class="btn btn-default" ng-click="$ctrl.editScript(undefined)">Sulje</button>
    </div>
    <sxy-code-editor ng-model="$ctrl.row.data.scripting[$ctrl.editingScriptName]" editor="formula"></sxy-code-editor>
  </div>
</div>`), s.put("salaxy-components/calc/rows/CalcRows2019EditDialog-irIncomeType.html", `<salaxy-tab-buttons
  current-tab="$ctrl.currentTab"
  options="[
    { value: 'basic', text: 'Perustiedot' },
    { value: 'incometype', text: 'SALAXY.NG1.CalcRowsComponent.irRows.irFlagsInfo' },
    { value: 'sidecosts', text: 'SALAXY.NG1.CalcRowsComponent.irRows.taxAndSideCosts' }
  ]"
  tabs-id="irIncomeType">
</salaxy-tab-buttons>
<div class="tab-content" id="tab-content-irIncomeType">
  <div class="tab-pane" id="basic-tab">
    <div class="col">
      <fieldset>
        <legend sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.textAndIncomeType"></legend>
        <salaxy-input-income-type name="code" ng-model="$ctrl.current.data.irData.code"  hidden-codes="[1]" label="SALAXY.NG1.CalcRowsComponent.irRows.incomeTypeLabel" ng-change="$ctrl.updateUsecase($ctrl.current)">
        </salaxy-input-income-type>
        <salaxy-input name="message" ng-model="$ctrl.current.message" label="SALAXY.NG1.CalcRowsComponent.irRows.messageLabel" placeholder="{{$ctrl.getMessagePlaceholderText($ctrl.current)}}"></salaxy-input>

        <salaxy-form-group label="SALAXY.NG1.CalcRowsComponent.irRows.paymentToCreditTransferLabel" name="paymentDefault">
          <!--TODO -->
          <div ng-if="$ctrl.getIrCodeData().paymentDefault == 1" sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.payment"></div>
          <div ng-if="$ctrl.getIrCodeData().paymentDefault == -1" sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.deduction"></div>
          <div ng-if="$ctrl.getIrCodeData().paymentDefault == 0" sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.noPayment"></div>
        </salaxy-form-group>
      </fieldset>
    </div>
    <div class="col">
      <fieldset>
        <legend sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.calc"></legend>
        <salaxy-input-number name="count" ng-model="$ctrl.current.count" label="SALAXY.NG1.CalcRowsComponent.irRows.countLabel"></salaxy-input-number>
        <salaxy-input-enum name="unit" label="SALAXY.NG1.CalcRowsComponent.irRows.unitLabel" enum="Unit" ng-model="$ctrl.current.data.unit" type="select"></salaxy-input-enum>
        <salaxy-input-number name="price" ng-model="$ctrl.current.price" label="SALAXY.NG1.CalcRowsComponent.irRows.priceLabel"></salaxy-input-number>
        <salaxy-form-group name="total" label="SALAXY.NG1.CalcRowsComponent.irRows.totalLabel">
          <p>{{ $ctrl.current.count * $ctrl.current.price | currency }}</p>
        </salaxy-form-group>
      </fieldset>
    </div>
    <div class="col" ng-if="$ctrl.current.data.irData.code == 304">
      <fieldset>
        <legend sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.carBenefitInfo"></legend>
        <p sxy-html="SALAXY.NG1.CalcRowsComponent.irRows.carBenefitInfoHtml"></p>
        <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.irRows.carBenefitTypeLabel" enum="CarBenefitCode" name="carBenefitCode" ng-model="$ctrl.current.data.irData.carBenefit.carBenefitCode"
          type="select"></salaxy-input-enum>
        <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.irRows.carBenefitAgeGroupLabel" enum="AgeGroupCode" name="ageGroupCode" ng-model="$ctrl.current.data.irData.carBenefit.ageGroupCode" type="select">
        </salaxy-input-enum>
        <salaxy-input-number label="SALAXY.NG1.CalcRowsComponent.irRows.carBenefitEmissionsValueLabel" name="emissionsValue" minimum="0" maximum="100" ng-model="$ctrl.current.data.irData.carBenefit.emissionsValue"></salaxy-input-number>
        <salaxy-input-number label="SALAXY.NG1.CalcRowsComponent.irRows.carBenefitKilometersLabel" name="kilometers" ng-model="$ctrl.current.data.irData.carBenefit.kilometers"></salaxy-input-number>     
      </fieldset>
    </div>
    <div class="col" ng-if="$ctrl.current.data.irData.code == 331">
      <fieldset>
        <legend sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.dailyAllowanceAdditionalSelections"></legend>
        <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.irRows.dailyAllowanceTypeLabel" enum="AllowanceCode" name="dailyAllowance" type="multi-select"
          ng-model="$ctrl.current.data.irData.dailyAllowance" require="true"></salaxy-input-enum>
      </fieldset>
    </div>

    <div class="col" ng-if="$ctrl.current.data.irData.code == 334">
      <fieldset>
        <legend sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.mealBenefitAdditionalSelections"></legend>
        <p sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.mealBenefitTaxInfo"></p>
        <salaxy-input-boolean type="checkbox" name="mealBenefitIsTaxValue" ng-model="$ctrl.current.data.irData.mealBenefitIsTaxValue" label-type="plain"
          label-true="SALAXY.NG1.CalcRowsComponent.irRows.mealBenefitIsTaxValueLabel"></salaxy-input-boolean>
      </fieldset>
    </div>
  </div>
  <div class="tab-pane" id="incometype-tab">
    <div class="col">
      <fieldset>
        <legend>{{ $ctrl.getMessagePlaceholderText($ctrl.current) }} ({{ $ctrl.current.data.irData.code }})</legend>
        <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.irRows.irFlagsLabel" enum="IrFlags" name="flags" type="multi-select" ng-model="$ctrl.current.data.irData.flags"></salaxy-input-enum>
        <salaxy-form-group label="SALAXY.NG1.CalcRowsComponent.irRows.negativeSupportedLabel" name="isNegativeSupported">
          <div ng-if="$ctrl.getIrCodeData().isNegativeSupported" sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.allowed"></div>
          <div ng-if="!$ctrl.getIrCodeData().isNegativeSupported" sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.notAllowed"></div>
        </salaxy-form-group>
        <div style="white-space: pre-wrap">{{ $ctrl.getIrCodeData().description }}</div>
      </fieldset>
    </div>
    <div class="col">
      <fieldset>
        <legend sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.earningPeriod"></legend>
        <p sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.earningPeriodInfo"></p>
        <salaxy-datepicker-popup name="startDate" label="SALAXY.NG1.CalcRowsComponent.irRows.earningPeriodStartDateLabel" ng-model="$ctrl.current.data.earningPeriod.start"></salaxy-datepicker-popup>
        <salaxy-datepicker-popup name="endDate" label="SALAXY.NG1.CalcRowsComponent.irRows.earningPeriodEndDateLabel" ng-model="$ctrl.current.data.earningPeriod.end"></salaxy-datepicker-popup>
      </fieldset>
    </div>
  </div>
  <div class="tab-pane" id="sidecosts-tab">
    <div class="col">
      <fieldset>
        <legend>{{ $ctrl.getMessagePlaceholderText($ctrl.current) }}</legend>
        <div style="white-space: pre-wrap">{{ $ctrl.getIrCodeData().taxAndSidecostsDescr }}</div>
        <table class="table">
          <tbody>
            <tr>
              <th sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.tax"></th>
              <td>
                <div ng-if="$ctrl.getIrCodeData().taxDefault == 1" class="text-success" sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.withheld"></div>
                <div ng-if="$ctrl.getIrCodeData().taxDefault == -1" class="text-warning" sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.deductionAlt"></div>
                <div ng-if="$ctrl.getIrCodeData().taxDefault == 0" class="text-danger" sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.notwithheld"></div>
              </td>
              <td></td>
            </tr>
            <tr>
              <th sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.socialSecurityPayment"></th>
              <th sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.toBePaid"></th>
              <th>
                <!-- TODO: Lisää tähän srakkeeseen tieto poikkeuksen jälkeen-->
              </th>
            </tr>
            <tr>
              <th sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.occupationPension"></th>
              <td>
                <span ng-class="$ctrl.getIrCodeData().pensionInsurance ? 'text-success' : 'text-danger'">
                  {{ $ctrl.getIrCodeData().pensionInsurance ? ("SALAXY.UI_Terms.yes" | sxyTranslate) : ("SALAXY.UI_Terms.no" | sxyTranslate) }}
                </span>
              </td>
              <td>
              </td>
            </tr>
            <tr>
              <th sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.insurancePayment"></th>
              <td>
                <span ng-class="$ctrl.getIrCodeData().accidentInsurance ? 'text-success' : 'text-danger'">
                  {{ $ctrl.getIrCodeData().accidentInsurance ? ("SALAXY.UI_Terms.yes" | sxyTranslate) : ("SALAXY.UI_Terms.no" | sxyTranslate) }}
                </span>
              </td>
              <td></td>
            </tr>
            <tr>
              <th sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.unemploymentInsurancePayment"></th>
              <td>
                <span ng-class="$ctrl.getIrCodeData().unemploymentInsurance ? 'text-success' : 'text-danger'">
                  {{ $ctrl.getIrCodeData().unemploymentInsurance ? ("SALAXY.UI_Terms.yes" | sxyTranslate) : ("SALAXY.UI_Terms.no" | sxyTranslate) }}
                </span>
              </td>
              <td></td>
            </tr>
            <tr>
              <th sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.healtInsurancePayment"></th>
              <td>
                <span ng-class="$ctrl.getIrCodeData().healthInsurance ? 'text-success' : 'text-danger'">
                  {{ $ctrl.getIrCodeData().healthInsurance ? ("SALAXY.UI_Terms.yes" | sxyTranslate) : ("SALAXY.UI_Terms.no" | sxyTranslate) }}
                </span>
              </td>
              <td></td>
            </tr>
          </tbody>
        </table>
        <div ng-if="!$ctrl.getIrCodeData().insuranceInformationAllowed">
          <p sxy-text="SALAXY.NG1.CalcRowsComponent.irRows.insuranceInformationAllowed"></p>
        </div>
        <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.irRows.IrInsuranceExceptions" enum="IrInsuranceExceptions" name="dailyAllowance" disabled="$ctrl.isIrRowReadOnly"
          ng-if="$ctrl.getIrCodeData().insuranceInformationAllowed" ng-model="$ctrl.current.data.irData.insuranceExceptions" type="multi-select">
        </salaxy-input-enum>
      </fieldset>
    </div>
  </div>
</div>`), s.put("salaxy-components/calc/rows/CalcRows2019EditDialog.html", `<div class="salaxy-calc-details-dialog" ng-style="{ 'position': $ctrl.isDialog ? 'absolute' : 'initial' }">

  <div class="card card-detail" ng-style="{'border-color':$ctrl.getConfig().color}">

    <form class="form-horizontal" ng-readonly="!$ctrl.isEditable">
      <div class="card-header d-flex" ng-style="{'background-color':$ctrl.getConfig().color, 'border-color':$ctrl.getConfig().color}">
        <div class="avatar-container">
          <salaxy-avatar avatar="{ color: $ctrl.getConfig().color, initials: $ctrl.getConfig().iconText, entityType: 'company' }">
          </salaxy-avatar>
        </div>
        <div class="flex-grow">
          <h1 class="truncate">
            {{ $ctrl.getConfig().label }}
            <span class="smaller" ng-if="$ctrl.current.message"> - {{$ctrl.current.message}}</span>
          </h1>
          <p class="calc-text">{{$ctrl.current.count}} <span ng-if="$ctrl.current.count">&times;</span> {{$ctrl.current.price}}
            <span class="result-text">{{ $ctrl.getRowTotal($ctrl.current) | currency }}</span>
          </p>
        </div>
        <div class="d-flex justify-content-between flex-column ms-auto">
          <button type="button" class="btn-close align-self-end" ng-click="$ctrl.closeEditDialog('cancel', $close)" aria-label="Close"></button>
          <a ng-show="$ctrl.getConfig().moreInfo || $ctrl.getConfig().incomeTypes.length > 0" class="btn-link btn-showmore" ng-click="showInfo = !showInfo">{{!showInfo ?
            ('SALAXY.NG1.CalcRowsComponent.editDialog.showInfo' | sxyTranslate) : ('SALAXY.NG1.CalcRowsComponent.editDialog.hideInfo' | sxyTranslate)}}
            <i class="bi bi-info-circle-fill ms-1"></i>
          </a>
        </div>
      </div>
      <div class="card-body">
        <p>{{ $ctrl.getConfig().descr }}
          <!-- TODO: We should have full HTML formatting here instead of just white-space: pre-wrap -->
          <span class="collapse" ng-class="{show: showInfo}" style="white-space: pre-wrap;"><br>{{ $ctrl.getConfig().moreInfo }}</span>
        </p>
        <div ng-if="showInfo && $ctrl.getConfig().incomeTypes.length > 0" class="mb-3">
          <p>{{'SALAXY.NG1.CalcRowsComponent.editDialog.incomeTypesInfo' | sxyTranslate}}:</p>
          <div class="accordion accordion-flush salaxy-accordion" id="incomeTypes">
            <div ng-repeat="type in $ctrl.getConfig().incomeTypes track by $index" class="accordion-item">
              <h2 class="accordion-header">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#type{{$index}}">
                  {{$ctrl.getIrCodeDataWithCode(type).code}} {{$ctrl.getIrCodeDataWithCode(type).label}}
                </button>
              </h2>
              <div id="type{{$index}}" class="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#incomeTypes">
                <div class="accordion-body">
                  <p>{{$ctrl.getIrCodeDataWithCode(type).description}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <!-- TODO: The row specific UI's need to be refactored to a better structure soon. -->
          <div ng-switch="$ctrl.current.rowType">
            <div ng-switch-when="salary|paidSickLeaveSalary|trainingSalary|monthlySalary|paidSickLeaveMonthlySalary|trainingMonthlySalary|compensation"
              ng-switch-when-separator="|">
              <!-- Row types that have count hidden, but should be shown in edit -->
              <salaxy-input-number label="{{$ctrl.getConfig().amount.label}}" ng-model="$ctrl.current.count" name="count" label-type="horizontal"
                unit="{{$ctrl.getConfig().amount.unit}}" placeholder="{{ $ctrl.getPlaceholderText($ctrl.current, 'amount') }}"></salaxy-input-number>
              <salaxy-input-number label="{{$ctrl.getConfig().price.label}}" ng-model="$ctrl.current.price" name="price" label-type="horizontal" require="true"
                disabled="$ctrl.isDisabled($ctrl.current, 'price')" placeholder="{{ $ctrl.getPlaceholderText($ctrl.current, 'price') }}"  ng-if="$ctrl.getConfig().price.input != 'hidden'"></salaxy-input-number>
            </div>
            <div ng-switch-when="irIncomeType">
              <ng-include src="'salaxy-components/calc/rows/CalcRows2019EditDialog-irIncomeType.html'"></ng-include>
            </div>
            <div ng-switch-when="unionPayment">
              <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.editDialog.unionPaymentLabel" label-type="horizontal" enum="UnionPaymentKind" hidden-options="other,undefined"
                require="true" ng-change="$ctrl.updateUsecase($ctrl.current)" name="UnionPaymentKind" ng-model="$ctrl.current.data.kind" type="select">
              </salaxy-input-enum>
              <div class="alert alert-warning" ng-if="$ctrl.current.data.kind == 'raksaNormal' ||  $ctrl.current.data.kind == 'raksaUnemploymentOnly'">
                <p sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.raksaInfo"></p>
              </div>
              <salaxy-input-number ng-if="$ctrl.current.data.kind == 'percentage' || $ctrl.current.data.kind == 'raksaNormal' ||
                $ctrl.current.data.kind == 'raksaUnemploymentOnly'" required="true" ng-model="$ctrl.current.count" name="count" label-type="horizontal" unit="percent"
                label="SALAXY.NG1.CalcRowsComponent.editDialog.percentOfSalary"
                disabled="$ctrl.current.data.kind == 'raksaNormal' ||  $ctrl.current.data.kind == 'raksaUnemploymentOnly'" ng-change="$ctrl.updateUsecase($ctrl.current)">
              </salaxy-input-number>
              <salaxy-input-number ng-if="$ctrl.current.data.kind !='percentageAndLimits'" ng-model="$ctrl.current.price" name="price" label-type="horizontal" require="true"
                disabled="$ctrl.current.data.kind != 'fixed'"
                label="{{$ctrl.current.data.kind == 'fixed' ? ('SALAXY.NG1.CalcRowsComponent.editDialog.unionPaymentCount' | sxyTranslate) : ('SALAXY.NG1.CalcRowsComponent.editDialog.underTaxSalary' | sxyTranslate)}}"
                ng-change="$ctrl.updateUsecase($ctrl.current)">
              </salaxy-input-number>
              <salaxy-input-number ng-if="$ctrl.current.data.kind == 'percentageAndLimits'" required="true" ng-model="$ctrl.current.data.paymentPercentage" name="paymentPercentage"
                label-type="horizontal" unit="percent" label="SALAXY.NG1.CalcRowsComponent.editDialog.percentOfSalary" ng-change="$ctrl.updateUsecase($ctrl.current)">
              </salaxy-input-number>
              <salaxy-input-number ng-if="$ctrl.current.data.kind =='percentageAndLimits'" ng-model="$ctrl.current.data.minimumPayment" name="minimumPayment"
                label-type="horizontal" label="SALAXY.NG1.CalcRowsComponent.editDialog.unionPayment.minimumPayment" ng-change="$ctrl.updateUsecase($ctrl.current)">
              </salaxy-input-number>
              <salaxy-input-number ng-if="$ctrl.current.data.kind =='percentageAndLimits'" ng-model="$ctrl.current.data.maximumPayment" name="maximumPayment"
                label-type="horizontal" label="SALAXY.NG1.CalcRowsComponent.editDialog.unionPayment.maximumPayment" ng-change="$ctrl.updateUsecase($ctrl.current)">
              </salaxy-input-number>

              <div class="row">
                <div class="input-info offset-4 col-8">
                  <div class="input-info-icon"><i class="bi bi-info-circle-fill text-default"></i></div>
                  <p class="small input-info-text with-icon" sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.fillUnionPaymentInformation"></p>
                </div>
              </div>
              <salaxy-input ng-model="$ctrl.current.data.recipientFullName" name="unionFullName" label-type="horizontal" require="false"
                label="SALAXY.NG1.CalcRowsComponent.editDialog.unionLabel"></salaxy-input>
              <salaxy-input ng-model="$ctrl.current.data.iban" name="unionIban" label-type="horizontal" require="false"
                label="SALAXY.NG1.CalcRowsComponent.editDialog.unionIbanLabel" sxy-iban>
              </salaxy-input>
              <salaxy-input ng-model="$ctrl.current.data.referenceNumber" name="unionReferenceNumber" label-type="horizontal" require="false"
                label="SALAXY.NG1.CalcRowsComponent.editDialog.unionReferenceNumberLabel" sxy-bank-reference-fi></salaxy-input>
            </div>
            <div ng-switch-when="foreclosure">
              <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.editDialog.foreclosureKindLabel" label-type="horizontal" enum="ForeclosureKind" require="true"
                ng-change="$ctrl.updateUsecase($ctrl.current)" name="ForeclosureKind" ng-model="$ctrl.current.data.kind" type="select"></salaxy-input-enum>
              <salaxy-input-number ng-model="$ctrl.current.count" name="count" label-type="horizontal" unit="{{$ctrl.getConfig().amount.unit}}"
                disabled="$ctrl.isDisabled($ctrl.current, 'amount')" ng-if="$ctrl.getConfig().amount.input != 'hidden'" label="{{$ctrl.getConfig().amount.label}}"
                ng-change="$ctrl.updateUsecase($ctrl.current)"></salaxy-input-number>
              <salaxy-input-number ng-model="$ctrl.current.price" name="price" label-type="horizontal" require="true"
                disabled="$ctrl.current.data.kind == 'periodic' || $ctrl.current.data.kind == 'nonPeriodic'" label="{{$ctrl.getConfig().price.label}}"
                ng-change="$ctrl.updateUsecase($ctrl.current)"></salaxy-input-number>
              <salaxy-input-number ng-if="$ctrl.current.data.kind == 'periodic'" ng-model="$ctrl.current.data.periodLength" name="periodLength" label-type="horizontal"
                disabled="true" label="SALAXY.NG1.CalcRowsComponent.editDialog.foreclosurePeriodLengthLabel" ng-change="$ctrl.updateUsecase($ctrl.current)"></salaxy-input-number>
              <salaxy-input-number ng-if="$ctrl.current.data.kind == 'periodic'" ng-model="$ctrl.current.data.protectedPortionBase" name="protectedPortionBase"
                label-type="horizontal" require="true" label="SALAXY.NG1.CalcRowsComponent.editDialog.foreclosureprotectedPortionBaseLabel"
                ng-change="$ctrl.updateUsecase($ctrl.current)"></salaxy-input-number>
              <salaxy-input-number ng-if="$ctrl.current.data.kind == 'periodic'" ng-model="$ctrl.current.data.protectedPortionDependant" name="protectedPortionDependant"
                label-type="horizontal" label="SALAXY.NG1.CalcRowsComponent.editDialog.foreclosureprotectedPortionDependantLabel" ng-change="$ctrl.updateUsecase($ctrl.current)">
              </salaxy-input-number>
              <salaxy-input-number ng-if="$ctrl.current.data.kind == 'periodic'" sxy-integer ng-model="$ctrl.current.data.dependantsCount" name="dependantsCount"
                label-type="horizontal" label="SALAXY.NG1.CalcRowsComponent.editDialog.foreclosuredependantsCountLabel" ng-change="$ctrl.updateUsecase($ctrl.current)">
              </salaxy-input-number>
              <salaxy-input-number ng-if="$ctrl.current.data.kind == 'periodic'" ng-model="$ctrl.current.data.incomeFromOtherSources" name="incomeFromOtherSources"
                label-type="horizontal" label="SALAXY.NG1.CalcRowsComponent.editDialog.foreclosureincomeFromOtherSourcesLabel" ng-change="$ctrl.updateUsecase($ctrl.current)">
              </salaxy-input-number>
              <salaxy-input-number ng-if="$ctrl.current.data.kind == 'periodic'" ng-model="$ctrl.current.data.additionalAmountLeftToDebtor" name="additionalAmountLeftToDebtor"
                label-type="horizontal" label="SALAXY.NG1.CalcRowsComponent.editDialog.foreclosureadditionalAmountLeftToDebtorLabel" ng-change="$ctrl.updateUsecase($ctrl.current)">
              </salaxy-input-number>
              <div class="row">
                <div class="input-info offset-4 col-8">
                  <div class="input-info-icon"><i class="bi bi-info-circle-fill text-default"></i></div>
                  <p class="small input-info-text with-icon" sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.foreclosureReferenceNumberInfo"></p>
                </div>
              </div>
              <salaxy-input ng-model="$ctrl.current.data.referenceNumber" name="referenceNumber" label-type="horizontal" require="false"
                label="SALAXY.NG1.CalcRowsComponent.editDialog.foreclosureReferenceNumberLabel" sxy-bank-reference-fi></salaxy-input>
            </div>
            <div ng-switch-when="totalWorkerPayment">
              <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.editDialog.totalWorkerPaymentKindLabel" label-type="horizontal" enum="TotalWorkerPaymentKind" require="true"
                ng-change="$ctrl.updateUsecase($ctrl.current)" name="TotalWorkerPaymentKind" ng-model="$ctrl.current.data.kind" type="select"></salaxy-input-enum>
              <salaxy-input-number ng-model="$ctrl.current.price" name="price" label-type="horizontal" require="true"
                label="SALAXY.NG1.CalcRowsComponent.editDialog.totalWorkerSumLabel" ng-change="$ctrl.updateUsecase($ctrl.current)"></salaxy-input-number>
              <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.editDialog.totalWorkerCalculationRowTypeLabel" label-type="horizontal" enum="CalculationRowType" require="true"
                ng-change="$ctrl.updateUsecase($ctrl.current)" name="CalculationRowType" ng-model="$ctrl.current.data.rowType" filter="salary,monthlySalary" type="select">
              </salaxy-input-enum>
              <salaxy-input ng-model="$ctrl.current.data.message" name="message" label-type="horizontal" require="false"
                label="SALAXY.NG1.CalcRowsComponent.editDialog.totalWorkerCalculationMessage"></salaxy-input>
            </div>
            <div ng-switch-when="carBenefit">
              <salaxy-input-number label="{{$ctrl.getConfig().price.label}}" ng-model="$ctrl.current.price" name="price" label-type="horizontal" require="true"
                disabled="$ctrl.isDisabled($ctrl.current, 'price')" ng-if="$ctrl.getConfig().price.input != 'hidden'"></salaxy-input-number>
              <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.editDialog.carBenefit.carBenefitCode" label-type="horizontal" enum="CarBenefitCode" require="true"
                ng-change="$ctrl.updateUsecase($ctrl.current)" name="CarBenefitCode" ng-model="$ctrl.current.data.kind" type="select"></salaxy-input-enum>
              <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.editDialog.carBenefit.ageGroupCode" label-type="horizontal" enum="AgeGroupCode" require="true"
                ng-change="$ctrl.updateUsecase($ctrl.current)" hidden-options="undefined,u" name="AgeGroupCode" ng-model="$ctrl.current.data.ageGroup" type="select">
              </salaxy-input-enum>
              <salaxy-input-boolean type="checkbox" name="isKilometersBased" label="SALAXY.NG1.CalcRowsComponent.editDialog.carBenefit.kilometersBased"
                label-true="SALAXY.NG1.CalcRowsComponent.editDialog.carBenefit.kilometersBasedTrue" label-type="horizontal" ng-model="$ctrl.current.data.isKilometersBased">
              </salaxy-input-boolean>
              <salaxy-input-number label="SALAXY.NG1.CalcRowsComponent.editDialog.carBenefit.kilometers" ng-model="$ctrl.current.data.kilometers" name="kilometers"
                label-type="horizontal" require="true" ng-if="$ctrl.current.data.isKilometersBased"></salaxy-input-number>
              <salaxy-input-number label="SALAXY.NG1.CalcRowsComponent.editDialog.carBenefit.deduction" ng-model="$ctrl.current.data.deduction" name="deduction"
                label-type="horizontal"></salaxy-input-number>
              <salaxy-input-number label="SALAXY.NG1.CalcRowsComponent.editDialog.carBenefit.emissionsValue" ng-model="$ctrl.current.data.emissionsValue" name="emissionsValue"
                label-type="horizontal" minimum="0" maximum="100"></salaxy-input-number>
            </div>
            <div ng-switch-when="subsidisedCommute">
              <p sxy-html="SALAXY.NG1.CalcRowsComponent.editDialog.subsidisedCommute.info.html"></p>
              <div ng-init="$subsidisedCommute = $ctrl.getUsecaseLogic($ctrl.current)">
                <salaxy-input-number ng-change="$subsidisedCommute.updateUsecase()" label="{{$ctrl.getConfig().price.label}}" ng-model="$ctrl.current.price" name="price"
                  label-type="horizontal" require="true" disabled="$ctrl.isDisabled($ctrl.current, 'price')"
                  ng-if="$ctrl.getConfig().price.input != 'hidden'"></salaxy-input-number>
                <salaxy-input-enum ng-change="$subsidisedCommute.updateUsecase()" label="SALAXY.NG1.CalcRowsComponent.editDialog.subsidisedCommute.subsidisedCommuteKind"
                  label-type="horizontal" enum="SubsidisedCommuteKind" require="true" name="SubsidisedCommuteKind" ng-model="$ctrl.current.data.kind" type="select">
                </salaxy-input-enum>
                <salaxy-input-number ng-change="$subsidisedCommute.updateUsecase()" label="SALAXY.NG1.CalcRowsComponent.editDialog.subsidisedCommute.deduction"
                  ng-model="$ctrl.current.data.deduction" name="deduction" label-type="horizontal"
                  ng-if="$ctrl.current.data.kind == 'singleDeduction' || $ctrl.current.data.kind == 'periodicalDeduction'"></salaxy-input-number>
                <salaxy-input-number ng-change="$subsidisedCommute.updateUsecase()" ng-if="$ctrl.isEditable && !$subsidisedCommute.isBefore2021"
                  placeholder="{{$subsidisedCommute.calculatedTaxable | number : 2}}" label="SALAXY.NG1.CalcRowsComponent.editDialog.subsidisedCommute.taxable"
                  ng-model="$ctrl.current.data.taxable" name="taxable" label-type="horizontal"
                  ng-if="$ctrl.current.data.kind == 'noDeduction' || $ctrl.current.data.kind == 'singleDeduction' || $ctrl.current.data.kind == 'periodicalDeduction'"></salaxy-input-number>
                <salaxy-input-number ng-if="$ctrl.isEditable && !$subsidisedCommute.isBefore2021" placeholder="{{$subsidisedCommute.calculatedTaxfree | number : 2}}"
                  disabled="true" label="SALAXY.NG1.CalcRowsComponent.editDialog.subsidisedCommute.taxfree" ng-model="subsidisedCommuteForDisplayOnly" name="taxfree"
                  label-type="horizontal"
                  ng-if="$ctrl.current.data.kind == 'noDeduction' || $ctrl.current.data.kind == 'singleDeduction' || $ctrl.current.data.kind == 'periodicalDeduction'"></salaxy-input-number>
                <salaxy-input-number ng-if="!$ctrl.isEditable && !$subsidisedCommute.isBefore2021" label="SALAXY.NG1.CalcRowsComponent.editDialog.subsidisedCommute.taxable"
                  ng-model="$subsidisedCommute.calculatedTaxable" name="taxable" label-type="horizontal"
                  ng-if="$ctrl.current.data.kind == 'noDeduction' || $ctrl.current.data.kind == 'singleDeduction' || $ctrl.current.data.kind == 'periodicalDeduction'"></salaxy-input-number>
                <salaxy-input-number ng-if="!$ctrl.isEditable && !$subsidisedCommute.isBefore2021" label="SALAXY.NG1.CalcRowsComponent.editDialog.subsidisedCommute.taxfree"
                  ng-model="$subsidisedCommute.calculatedTaxfree" name="taxfree" label-type="horizontal"
                  ng-if="$ctrl.current.data.kind == 'noDeduction' || $ctrl.current.data.kind == 'singleDeduction' || $ctrl.current.data.kind == 'periodicalDeduction'"></salaxy-input-number>
                <salaxy-input-number ng-change="$subsidisedCommute.updateUsecase()" label="SALAXY.NG1.CalcRowsComponent.editDialog.subsidisedCommute.periodDivider"
                  ng-model="$ctrl.current.data.periodDivider" name="periodDivider" label-type="horizontal"
                  ng-if="$ctrl.current.data.kind == 'periodicalDeduction'"></salaxy-input-number>
              </div>
            </div>
            <div ng-switch-when="bicycleBenefit">
              <div ng-init="$bicycleBenefit = $ctrl.getUsecaseLogic($ctrl.current)">
                <salaxy-input-number ng-change="$bicycleBenefit.updateUsecase()" label="{{$ctrl.getConfig().price.label}}" ng-model="$ctrl.current.price" name="price"
                  label-type="horizontal" require="true" disabled="$ctrl.isDisabled($ctrl.current, 'price')"
                  ng-if="$ctrl.getConfig().price.input != 'hidden'"></salaxy-input-number>
                <salaxy-input-enum ng-change="$bicycleBenefit.updateUsecase()" label="SALAXY.NG1.CalcRowsComponent.editDialog.bicycleBenefit.bicycleBenefitKind"
                  label-type="horizontal" enum="BicycleBenefitKind" require="true" name="BicycleBenefitKind" ng-model="$ctrl.current.data.kind" type="select">
                </salaxy-input-enum>
                <salaxy-input-number ng-change="$bicycleBenefit.updateUsecase()" label="SALAXY.NG1.CalcRowsComponent.editDialog.bicycleBenefit.deduction"
                  ng-model="$ctrl.current.data.deduction" name="deduction" label-type="horizontal"
                  ng-if="$ctrl.current.data.kind == 'singleDeduction' || $ctrl.current.data.kind == 'periodicalDeduction'"></salaxy-input-number>
                <salaxy-input-number ng-change="$bicycleBenefit.updateUsecase()" ng-if="$ctrl.isEditable" placeholder="{{$bicycleBenefit.calculatedTaxable | number : 2}}"
                  label="SALAXY.NG1.CalcRowsComponent.editDialog.bicycleBenefit.taxable" ng-model="$ctrl.current.data.taxable" name="taxable" label-type="horizontal"
                  ng-if="$ctrl.current.data.kind == 'noDeduction' || $ctrl.current.data.kind == 'singleDeduction' || $ctrl.current.data.kind == 'periodicalDeduction'"></salaxy-input-number>
                <salaxy-input-number ng-if="$ctrl.isEditable" placeholder="{{$bicycleBenefit.calculatedTaxfree | number : 2}}" disabled="true"
                  label="SALAXY.NG1.CalcRowsComponent.editDialog.bicycleBenefit.taxfree" ng-model="bicycleBenefitForDisplayOnly" name="taxfree" label-type="horizontal"
                  ng-if="$ctrl.current.data.kind == 'noDeduction' || $ctrl.current.data.kind == 'singleDeduction' || $ctrl.current.data.kind == 'periodicalDeduction'"></salaxy-input-number>
                <salaxy-input-number ng-if="!$ctrl.isEditable" label="SALAXY.NG1.CalcRowsComponent.editDialog.bicycleBenefit.taxable" ng-model="$bicycleBenefit.calculatedTaxable"
                  name="taxable" label-type="horizontal"
                  ng-if="$ctrl.current.data.kind == 'noDeduction' || $ctrl.current.data.kind == 'singleDeduction' || $ctrl.current.data.kind == 'periodicalDeduction'"></salaxy-input-number>
                <salaxy-input-number ng-if="!$ctrl.isEditable" label="SALAXY.NG1.CalcRowsComponent.editDialog.bicycleBenefit.taxfree" ng-model="$bicycleBenefit.calculatedTaxfree"
                  name="taxfree" label-type="horizontal"
                  ng-if="$ctrl.current.data.kind == 'noDeduction' || $ctrl.current.data.kind == 'singleDeduction' || $ctrl.current.data.kind == 'periodicalDeduction'"></salaxy-input-number>
                <salaxy-input-number ng-change="$bicycleBenefit.updateUsecase()" label="SALAXY.NG1.CalcRowsComponent.editDialog.bicycleBenefit.periodDivider"
                  ng-model="$ctrl.current.data.periodDivider" name="periodDivider" label-type="horizontal"
                  ng-if="$ctrl.current.data.kind == 'periodicalDeduction'"></salaxy-input-number>
              </div>
            </div>
            <div ng-switch-when="nonProfitOrg">
              <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.editDialog.nonProfitOrg.profitOrgKind" label-type="horizontal" enum="NonProfitOrgKind" require="true"
                ng-change="$ctrl.updateUsecase($ctrl.current)" name="NonProfitOrgKind" ng-model="$ctrl.current.data.kind" type="select"></salaxy-input-enum>
              <salaxy-input-number label="{{$ctrl.getConfig().amount.label}}" ng-model="$ctrl.current.count" name="count" label-type="horizontal"
                unit="{{$ctrl.getConfig().amount.unit}}" placeholder="1" disabled="$ctrl.isDisabled($ctrl.current, 'amount')" ng-if="$ctrl.getConfig().amount.input != 'hidden'">
              </salaxy-input-number>
              <salaxy-input-number label="{{$ctrl.getConfig().price.label}}" ng-model="$ctrl.current.price" name="price" label-type="horizontal" require="true"
                disabled="$ctrl.isDisabled($ctrl.current, 'price')" ng-if="$ctrl.getConfig().price.input != 'hidden'"></salaxy-input-number>
            </div>
            <div ng-switch-when="dailyAllowance">
              <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.editDialog.dailyAllowance.allowanceKind" hidden-options="mealAllowance" label-type="horizontal"
                enum="DailyAllowanceKind" require="true" ng-change="$ctrl.updateUsecase($ctrl.current)" name="DailyAllowanceKind" ng-model="$ctrl.current.data.kind" type="select">
              </salaxy-input-enum>
              <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.editDialog.dailyAllowance.internationalDailyAllowanceCount" label-type="horizontal"
                ng-if="$ctrl.current.data.kind === 'internationalDailyAllowance'" options="$ctrl.dailyAllowanceRegions" ng-change="$ctrl.updateUsecase($ctrl.current)"
                name="country" ng-model="$ctrl.current.data.country" type="select">
              </salaxy-input-enum>
              <salaxy-input-number label="{{$ctrl.getConfig().amount.label}}" ng-model="$ctrl.current.count" name="count" label-type="horizontal"
                unit="{{$ctrl.getConfig().amount.unit}}" placeholder="1" disabled="$ctrl.isDisabled($ctrl.current, 'amount')" ng-if="$ctrl.getConfig().amount.input != 'hidden'">
              </salaxy-input-number>
              <salaxy-input-number label="{{$ctrl.getConfig().price.label}}" ng-model="$ctrl.current.price" name="price" label-type="horizontal" require="true"
                disabled="$ctrl.isDisabled($ctrl.current, 'price')" ng-if="$ctrl.getConfig().price.input != 'hidden'"></salaxy-input-number>
            </div>
            <div ng-switch-when="mealBenefit">
              <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.editDialog.mealBenefit.mealBenefitKind" label-type="horizontal" enum="MealBenefitKind" require="true"
                ng-change="$ctrl.updateUsecase($ctrl.current)" name="MealBenefitKind" ng-model="$ctrl.current.data.kind" type="select"></salaxy-input-enum>
              <p ng-if="$ctrl.current.data.kind" sxy-text="{{'SALAXY.ENUM.MealBenefitKind.' + $ctrl.current.data.kind + '.descriptionWithYearlyNumbers'}}"
                params="$ctrl.yearlySideCosts"></p>
              <salaxy-input-number label="{{$ctrl.getConfig().amount.label}}" ng-model="$ctrl.current.count" name="count" label-type="horizontal"
                unit="{{$ctrl.getConfig().amount.unit}}" placeholder="1" disabled="$ctrl.isDisabled($ctrl.current, 'amount')" ng-if="$ctrl.getConfig().amount.input != 'hidden'">
              </salaxy-input-number>
              <div ng-switch="$ctrl.current.data.kind">
                <div ng-switch-when="mealAllowance">
                  <salaxy-input-number label="SALAXY.NG1.CalcRowsComponent.editDialog.mealBenefit.mealPrice" ng-model="$ctrl.current.price" name="price" label-type="horizontal"
                    ng-change="$ctrl.updateUsecase($ctrl.current)" require="true" disabled="$ctrl.isDisabled($ctrl.current)"></salaxy-input-number>
                </div>
                <div ng-switch-when="taxableAmount|collectedReimbursement|undefined" ng-switch-when-separator="|">
                  <salaxy-input-number label="SALAXY.NG1.CalcRowsComponent.editDialog.mealBenefit.mealTaxablePrice" ng-model="$ctrl.current.price" name="price"
                    label-type="horizontal" ng-change="$ctrl.updateUsecase($ctrl.current)" require="true" disabled="$ctrl.isDisabled($ctrl.current)"></salaxy-input-number>
                </div>
                <div ng-switch-when="mealTicket">
                  <salaxy-input-number label="SALAXY.NG1.CalcRowsComponent.editDialog.mealBenefit.mealTicketPrice" ng-model="$ctrl.current.price" name="price"
                    label-type="horizontal" ng-change="$ctrl.updateUsecase($ctrl.current)" require="true" disabled="$ctrl.isDisabled($ctrl.current)"></salaxy-input-number>
                </div>
                <div ng-switch-when="cateringContract|institute|restaurantWorker|teacher" ng-switch-when-separator="|">
                  <salaxy-input-number disabled="true" label="SALAXY.NG1.CalcRowsComponent.editDialog.mealBenefit.mealTaxablePrice" ng-model="$ctrl.current.price" name="price"
                    label-type="horizontal"></salaxy-input-number>
                </div>
              </div>
              <div ng-if="$ctrl.current.data.kind != 'mealAllowance'">
                <salaxy-form-group ng-if="$ctrl.current.data.kind != 'collectedReimbursement'" label="SALAXY.NG1.CalcRowsComponent.editDialog.mealBenefit.mealPriceAmount"
                  name="taxablePrice" label-type="horizontal">
                  <label class="control-label">{{ $ctrl.current.data.taxablePrice * ($ctrl.current.count || 1.0) | currency }}</label>
                </salaxy-form-group>
                <salaxy-input-boolean ng-if="$ctrl.current.data.kind != 'collectedReimbursement'" label="SALAXY.NG1.CalcRowsComponent.editDialog.mealBenefit.workerDeduction"
                  label-true="SALAXY.NG1.CalcRowsComponent.editDialog.mealBenefit.taxValueTrue" label-false="SALAXY.NG1.CalcRowsComponent.editDialog.mealBenefit.taxValueFalse"
                  name="isTaxValue" type="radio" ng-model="$ctrl.current.data.isTaxValue" label-type="horizontal" ng-change="$ctrl.updateUsecase($ctrl.current)" require="true"
                  disabled="$ctrl.isDisabled($ctrl.current)"></salaxy-input-boolean>
                <salaxy-input-boolean ng-if="$ctrl.current.data.kind != 'collectedReimbursement' && $ctrl.current.data.isTaxValue"
                  label="SALAXY.NG1.CalcRowsComponent.editDialog.mealBenefit.isTaxValueDeductionDone"
                  label-true="SALAXY.NG1.CalcRowsComponent.editDialog.mealBenefit.isTaxValueDeductionDoneTrue"
                  label-false="SALAXY.NG1.CalcRowsComponent.editDialog.mealBenefit.isTaxValueDeductionDoneFalse" name="isTaxValueDeductionDone" type="radio"
                  ng-model="$ctrl.current.data.isTaxValueDeductionDone" label-type="horizontal" ng-change="$ctrl.updateUsecase($ctrl.current)" require="true"
                  disabled="$ctrl.isDisabled($ctrl.current)"></salaxy-input-boolean>
                <salaxy-form-group ng-if="$ctrl.current.data.isTaxValue" label="SALAXY.NG1.CalcRowsComponent.editDialog.mealBenefit.deduction" name="deductionWhenTaxValue"
                  label-type="horizontal">
                  <label class="control-label">{{ $ctrl.current.data.taxablePrice * ($ctrl.current.count || 1.0) | currency }}</label>
                </salaxy-form-group>
                <salaxy-input-number ng-if="$ctrl.current.data.kind != 'collectedReimbursement' && !$ctrl.current.data.isTaxValue"
                  label="SALAXY.NG1.CalcRowsComponent.editDialog.mealBenefit.deduction" ng-model="$ctrl.current.data.deduction" name="deduction" label-type="horizontal"
                  ng-change="$ctrl.updateUsecase($ctrl.current)" disabled="$ctrl.isDisabled($ctrl.current)"></salaxy-input-number>
              </div>
            </div>
            <div ng-switch-when="board">
              <salaxy-input-number label="{{$ctrl.getConfig().amount.label}}" ng-model="$ctrl.current.count" name="count" label-type="horizontal"
                unit="{{$ctrl.getConfig().amount.unit}}" placeholder="1" disabled="$ctrl.isDisabled($ctrl.current, 'amount')" ng-if="$ctrl.getConfig().amount.input != 'hidden'">
              </salaxy-input-number>
              <salaxy-input-number label="{{$ctrl.getConfig().price.label}}" ng-model="$ctrl.current.price" name="price" label-type="horizontal" require="true"
                disabled="$ctrl.isDisabled($ctrl.current, 'price')" ng-if="$ctrl.getConfig().price.input != 'hidden'"></salaxy-input-number>
            </div>
            <div ng-switch-when="remuneration">
              <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.editDialog.remuneration.remunerationKind" label-type="horizontal" enum="RemunerationKind" require="true"
                ng-change="$ctrl.updateUsecase($ctrl.current)" name="RemunerationKind" ng-model="$ctrl.current.data.kind" type="select"></salaxy-input-enum>
              <p>{{ "RemunerationKind." + $ctrl.current.data.kind | sxyEnumDescr }}</p>
              <salaxy-input-number ng-if="$ctrl.getConfig().amount.units.length > 1" on-unit-change="$ctrl.current.unit=unit" label="{{$ctrl.getConfig().amount.label}}"
                ng-model="$ctrl.current.count" name="count" label-type="horizontal" unit="{{$ctrl.ensureUnit($ctrl.current)}}" units="$ctrl.getConfig().amount.units"
                disabled="$ctrl.isDisabled($ctrl.current, 'amount')" ng-if="$ctrl.getConfig().amount.input != 'hidden'">
              </salaxy-input-number>
              <salaxy-input-number ng-if="!($ctrl.getConfig().amount.units.length > 1)" label="{{$ctrl.getConfig().amount.label}}" ng-model="$ctrl.current.count" name="count"
                label-type="horizontal" unit="{{$ctrl.getConfig().amount.unit}}" placeholder="1" disabled="$ctrl.isDisabled($ctrl.current, 'amount')"
                ng-if="$ctrl.getConfig().amount.input != 'hidden'">
              </salaxy-input-number>
              <salaxy-input-number label="{{$ctrl.getConfig().price.label}}" ng-model="$ctrl.current.price" name="price" label-type="horizontal" require="true"
                disabled="$ctrl.isDisabled($ctrl.current, 'price')" ng-if="$ctrl.getConfig().price.input != 'hidden'"></salaxy-input-number>
            </div>
            <div ng-switch-when="otherCompensation">
              <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.editDialog.otherCompensation.compensationKind" label-type="horizontal" enum="OtherCompensationKind"
                require="true" ng-change="$ctrl.updateUsecase($ctrl.current)" name="OtherCompensationKind" ng-model="$ctrl.current.data.kind" type="select">
              </salaxy-input-enum>
              <p>{{ "OtherCompensationKind." + $ctrl.current.data.kind | sxyEnumDescr }}</p>
              <salaxy-input-number label="{{$ctrl.getConfig().amount.label}}" ng-model="$ctrl.current.count" name="count" label-type="horizontal"
                unit="{{$ctrl.getConfig().amount.unit}}" placeholder="1" disabled="$ctrl.isDisabled($ctrl.current, 'amount')" ng-if="$ctrl.getConfig().amount.input != 'hidden'">
              </salaxy-input-number>
              <salaxy-input-number label="{{$ctrl.getConfig().price.label}}" ng-model="$ctrl.current.price" name="price" label-type="horizontal" require="true"
                disabled="$ctrl.isDisabled($ctrl.current, 'price')" ng-if="$ctrl.getConfig().price.input != 'hidden'"></salaxy-input-number>
            </div>
            <div ng-switch-when="workingTimeCompensation">
              <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.editDialog.workingTimeCompensation.compensationKind" label-type="horizontal" enum="WorkingTimeCompensationKind"
                require="true" ng-change="$ctrl.updateUsecase($ctrl.current)" name="WorkingTimeCompensation" ng-model="$ctrl.current.data.kind" type="select">
              </salaxy-input-enum>
              <p>{{ "WorkingTimeCompensationKind." + $ctrl.current.data.kind | sxyEnumDescr }}</p>
              <salaxy-input-number label="{{$ctrl.getConfig().amount.label}}" ng-model="$ctrl.current.count" name="count" label-type="horizontal"
                unit="{{$ctrl.getConfig().amount.unit}}" placeholder="1" disabled="$ctrl.isDisabled($ctrl.current, 'amount')" ng-if="$ctrl.getConfig().amount.input != 'hidden'">
              </salaxy-input-number>
              <salaxy-input-number label="{{$ctrl.getConfig().price.label}}" ng-model="$ctrl.current.price" name="price" label-type="horizontal" require="true"
                disabled="$ctrl.isDisabled($ctrl.current, 'price')" ng-if="$ctrl.getConfig().price.input != 'hidden'"></salaxy-input-number>
            </div>
            <div ng-switch-when="employmentTermination">
              <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.editDialog.employmentTermination.employmentTerminationKind" label-type="horizontal"
                enum="EmploymentTerminationKind" require="true" ng-change="$ctrl.updateUsecase($ctrl.current)" name="EmploymentTermination" ng-model="$ctrl.current.data.kind"
                type="select"></salaxy-input-enum>
              <p>{{ "EmploymentTerminationKind." + $ctrl.current.data.kind | sxyEnumDescr }}</p>
              <salaxy-input-number label="{{$ctrl.getConfig().amount.label}}" ng-model="$ctrl.current.count" name="count" label-type="horizontal"
                unit="{{$ctrl.getConfig().amount.unit}}" placeholder="1" disabled="$ctrl.isDisabled($ctrl.current, 'amount')" ng-if="$ctrl.getConfig().amount.input != 'hidden'">
              </salaxy-input-number>
              <salaxy-input-number label="{{$ctrl.getConfig().price.label}}" ng-model="$ctrl.current.price" name="price" label-type="horizontal" require="true"
                disabled="$ctrl.isDisabled($ctrl.current, 'price')" ng-if="$ctrl.getConfig().price.input != 'hidden'"></salaxy-input-number>
            </div>
            <div ng-switch-when="paidSickLeave">
              <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.editDialog.paidSickLeave.paidSickLeaveKind" label-type="horizontal" enum="PaidSickLeaveKind" require="true"
                ng-change="$ctrl.updateUsecase($ctrl.current)" name="PaidSickLeaveKind" ng-model="$ctrl.current.data.kind" type="select"></salaxy-input-enum>
              <p>{{ "PaidSickLeaveKind." + $ctrl.current.data.kind | sxyEnumDescr }}</p>
              <salaxy-input-number label="{{$ctrl.getConfig().amount.label}}" ng-model="$ctrl.current.count" name="count" label-type="horizontal"
                unit="{{$ctrl.getConfig().amount.unit}}" placeholder="1" disabled="$ctrl.isDisabled($ctrl.current, 'amount')" ng-if="$ctrl.getConfig().amount.input != 'hidden'">
              </salaxy-input-number>
              <salaxy-input-number label="{{$ctrl.getConfig().price.label}}" ng-model="$ctrl.current.price" name="price" label-type="horizontal" require="true"
                disabled="$ctrl.isDisabled($ctrl.current, 'price')" ng-if="$ctrl.getConfig().price.input != 'hidden'"></salaxy-input-number>
            </div>
            <div ng-switch-when="training">
              <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.editDialog.training.trainingKind" label-type="horizontal" enum="TrainingKind" require="true"
                ng-change="$ctrl.updateUsecase($ctrl.current)" name="TrainingKind" ng-model="$ctrl.current.data.kind" type="select"></salaxy-input-enum>
              <p>{{ "TrainingKind." + $ctrl.current.data.kind | sxyEnumDescr }}</p>
              <salaxy-input-number label="{{$ctrl.getConfig().amount.label}}" ng-model="$ctrl.current.count" name="count" label-type="horizontal"
                unit="{{$ctrl.getConfig().amount.unit}}" placeholder="1" disabled="$ctrl.isDisabled($ctrl.current, 'amount')" ng-if="$ctrl.getConfig().amount.input != 'hidden'">
              </salaxy-input-number>
              <salaxy-input-number label="{{$ctrl.getConfig().price.label}}" ng-model="$ctrl.current.price" name="price" label-type="horizontal" require="true"
                disabled="$ctrl.isDisabled($ctrl.current, 'price')" ng-if="$ctrl.getConfig().price.input != 'hidden'"></salaxy-input-number>
            </div>
            <div ng-switch-when="hourlySalaryWithWorkingTimeCompensation">
              <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.editDialog.WorkingTimeCompensationKind" label-type="horizontal" enum="WorkingTimeCompensationKind"
                require="true" ng-change="$ctrl.updateUsecase($ctrl.current)" name="HourlySalaryWithWorkingTimeCompensation" ng-model="$ctrl.current.data.kind" type="select">
              </salaxy-input-enum>
              <p>{{ "WorkingTimeCompensationKind." + $ctrl.current.data.kind | sxyEnumDescr }}</p>
              <salaxy-input-number label="{{$ctrl.getConfig().amount.label}}" ng-model="$ctrl.current.count" name="count" label-type="horizontal"
                unit="{{$ctrl.getConfig().amount.unit}}" placeholder="1" disabled="$ctrl.isDisabled($ctrl.current, 'amount')" ng-change="$ctrl.updateUsecase($ctrl.current)"
                ng-if="$ctrl.getConfig().amount.input != 'hidden'"></salaxy-input-number>
              <salaxy-input-number label="{{$ctrl.getConfig().price.label}}" ng-model="$ctrl.current.price" name="price" label-type="horizontal" require="true"
                disabled="$ctrl.isDisabled($ctrl.current, 'price')" ng-change="$ctrl.updateUsecase($ctrl.current)" ng-if="$ctrl.getConfig().price.input != 'hidden'">
              </salaxy-input-number>
              <style>
                div.input-group-addon {
                  display: none;
                }

                div.input-group {
                  width: 100%
                }
              </style>
              <div>
                <salaxy-input label="SALAXY.NG1.CalcRowsComponent.editDialog.additionalRows.description" label-type="horizontal" disabled="$ctrl.isDisabled($ctrl.current)"
                  ng-model="$ctrl.current.message" name="message" placeholder="{{$ctrl.getMessagePlaceholderText($ctrl.current)}}"></salaxy-input>
              </div>
              <hr>
              <div ng-repeat="cr in $ctrl.current.data.compensationRows">
                <salaxy-input-number label="SALAXY.NG1.CalcRowsComponent.editDialog.hourlySalaryWithWorkingTimeCompensationRowCountLabel" ng-model="cr.count" name="crCount" label-type="horizontal"
                unit="{{$ctrl.getConfig().amount.unit}}" placeholder="{{$ctrl.current.count || 1}}" disabled="$ctrl.isDisabled($ctrl.current, 'amount')" ng-change="$ctrl.updateUsecase($ctrl.current)"
                ng-if="$ctrl.getConfig().amount.input != 'hidden'"></salaxy-input-number>
                <salaxy-form-group name="compensationRow" label-type="form-horizontal" label="SALAXY.NG1.CalcRowsComponent.editDialog.hourlySalaryWithWorkingTimeCompensationRowLabel" required="true">
                  <div class="input-group">
                    <salaxy-input-number ng-if="$ctrl.current.data.pricing == 'percent'" ng-model="cr.percent" class="flex-grow-1" name="percent" label-type="plain" require="true" unit="percent"
                      ng-change="$ctrl.updateUsecase($ctrl.current)"></salaxy-input-number>
                    <salaxy-input-number ng-if="$ctrl.current.data.pricing != 'percent'" ng-model="cr.price" name="price" label-type="plain" require="true"
                      ng-change="$ctrl.updateUsecase($ctrl.current)"></salaxy-input-number>
                    <div class="btn-group">
                      <button id="compUnit" type="button" class="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                        {{ $ctrl.current.data.pricing == 'percent' ? "%" : "€" }}
                      </button>
                      <ul class="dropdown-menu" aria-labelledby="compUnit">
                        <li><a class="dropdown-item" href="" ng-click="$ctrl.current.data.pricing = 'percent'; $ctrl.updateUsecase($ctrl.current)">%</a></li>
                        <li><a class="dropdown-item" href="" ng-click="$ctrl.current.data.pricing = 'fixed'; $ctrl.updateUsecase($ctrl.current)">€</a></li>
                      </ul>
                    </div>
                  </div>
                </salaxy-form-group>
                <salaxy-input label="SALAXY.NG1.CalcRowsComponent.editDialog.hourlySalaryWithWorkingTimeCompensationRowMessageLabel" label-type="horizontal" disabled="$ctrl.isDisabled($ctrl.current)"
                  ng-model="cr.message" name="crMessage" placeholder="{{ 'WorkingTimeCompensationKind.' + $ctrl.current.data.kind | sxyEnum }}"></salaxy-input>
              </div>
            </div>
            <div ng-switch-when="milageOwnCar">
              <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.editDialog.milageOwnCar.vehicleType" label-type="horizontal" options="$ctrl.getVehicleTypeSelection()"
                ng-change="$ctrl.updateUsecase($ctrl.current)" name="vehicleType" ng-model="$ctrl.current.data.vehicleType" type="select"></salaxy-input-enum>
              <salaxy-input-enum ng-if="$ctrl.current.data.additionsAllowed" label="SALAXY.NG1.CalcRowsComponent.editDialog.milageOwnCar.additions" label-type="horizontal"
                options="$ctrl.getVehicleAdditions()" ng-change="$ctrl.updateUsecase($ctrl.current)" name="additions" ng-model="$ctrl.current.data.additions"
                type="select"></salaxy-input-enum>
              <salaxy-input-number ng-if="$ctrl.current.data.passengersAllowed" label="SALAXY.NG1.CalcRowsComponent.editDialog.milageOwnCar.passangerCount" unit="count"
                label-type="horizontal" ng-model="$ctrl.current.data.passengerCount" name="passengerCount" ng-change="$ctrl.updateUsecase($ctrl.current)"></salaxy-input-number>
              <salaxy-input-number label="{{$ctrl.getConfig().price.label}}" ng-model="$ctrl.current.price" name="price" label-type="horizontal"
                disabled="$ctrl.current.data.vehicleType != 'custom'" ng-change="$ctrl.updateUsecase($ctrl.current)"></salaxy-input-number>
              <salaxy-input-number label="{{$ctrl.getConfig().amount.label}}" ng-model="$ctrl.current.count" name="count" label-type="horizontal"
                unit="{{$ctrl.getConfig().amount.unit}}" ng-change="$ctrl.updateUsecase($ctrl.current)"></salaxy-input-number>
            </div>
            <div ng-switch-when="taxAtSource">
              <salaxy-input-number label="Palkkasumma ennen vähennystä" ng-model="$ctrl.current.data.totalTaxable" name="totalTaxable" label-type="horizontal"
                disabled="true"></salaxy-input-number>
              <salaxy-input-enum label="Vähennyksen tyyppi" filter="{{ $ctrl.current.data.allowedKinds }}" label-type="horizontal" enum="TaxAtSourceKind"
                ng-change="$ctrl.updateUsecase($ctrl.current)" name="taxAtSourceKind" ng-model="$ctrl.current.data.kind" type="select"></salaxy-input-enum>
              <div ng-if="$ctrl.current.data.kind == 'monthlyDeduction' || $ctrl.current.data.kind == 'dailyDeduction'" class="input-info offset-4 col-8">
                <p>{{ $ctrl.current.data.deductionCount | sxyCount }} * {{ $ctrl.current.data.deductionPrice | currency }} = {{ $ctrl.current.data.deduction | currency }}</p>
              </div>
              <div ng-if="$ctrl.current.data.kind == 'fixedValues'">
                <salaxy-input-number label="Kiinteä vähennys" ng-model="$ctrl.current.data.deduction" name="deduction" unit="eur" label-type="horizontal"
                  ng-change="$ctrl.updateUsecase($ctrl.current)"></salaxy-input-number>
                <salaxy-input-number label="Kiinteä lähdevero" ng-model="$ctrl.current.data.taxValue" name="taxValue" unit="eur" label-type="horizontal"
                  ng-change="$ctrl.updateUsecase($ctrl.current)"></salaxy-input-number>
              </div>
              <div ng-if="$ctrl.current.data.kind != 'fixedValues'">
                <salaxy-input-number label="{{$ctrl.getConfig().price.label}}" ng-model="$ctrl.current.price" name="price" label-type="horizontal"
                  ng-change="$ctrl.updateUsecase($ctrl.current)" disabled="true"></salaxy-input-number>
                <salaxy-input-number label="{{$ctrl.getConfig().amount.label}}" ng-model="$ctrl.current.count" name="count" label-type="horizontal"
                  unit="{{$ctrl.getConfig().amount.unit}}" disabled="true"></salaxy-input-number>
                <salaxy-input-number label="Lähdevero" ng-model="$ctrl.current.data.taxValue" name="taxValue" label-type="horizontal" unit="eur"
                  disabled="true"></salaxy-input-number>
              </div>
            </div>
            <div ng-switch-when="taxWithholding">
              <salaxy-input-enum label="SALAXY.ENUM.TaxWithholdingKind.label" label-type="horizontal" enum="TaxWithholdingKind" ng-change="$ctrl.updateUsecase($ctrl.current)"
                name="taxWithholdingKind" ng-model="$ctrl.current.data.kind" type="select"></salaxy-input-enum>
              <div ng-switch="$ctrl.current.data.kind">
                <salaxy-input-number ng-switch-when="percentage" label="SALAXY.ENUM.TaxWithholdingKind.percentage.label" ng-model="$ctrl.current.data.taxValue" name="percentage"
                  label-type="horizontal" ng-change="$ctrl.updateUsecase($ctrl.current)" require="true" unit="percent"></salaxy-input-number>
                <salaxy-input-number ng-switch-when="fixedValue" label="SALAXY.ENUM.TaxWithholdingKind.fixedValue.label" ng-model="$ctrl.current.data.taxValue" name="fixedvalue"
                  label-type="horizontal" ng-change="$ctrl.updateUsecase($ctrl.current)" require="true" unit="eur"></salaxy-input-number>
              </div>
            </div>
            <div ng-switch-when="absencePeriod" ng-init="$absencesLogic = $ctrl.getUsecaseLogic($ctrl.current)">
              <salaxy-input-enum name="causeCode" ng-model="$ctrl.current.data.kind" enum="AbsenceCauseCode" label="SALAXY.MODEL.WorkerAbsencePeriod.absencesId.title"
                type="select" ng-change="$absencesLogic.updateIsPaid($ctrl.current, true)" require="true"></salaxy-input-enum>
              <salaxy-datepicker-popup name="start" ng-model="$ctrl.current.period.start" ng-change="$absencesLogic.updatePeriodDays($ctrl.current)"
                label="SALAXY.MODEL.DateRange.start.title"></salaxy-datepicker-popup>
              <salaxy-datepicker-popup name="end" ng-model="$ctrl.current.period.end" ng-change="$absencesLogic.updatePeriodDays($ctrl.current)"
                label="SALAXY.MODEL.DateRange.end.title"></salaxy-datepicker-popup>
              <salaxy-form-group name="daysCount" label="SALAXY.MODEL.DateRange.daysCount.title" ng-if="$ctrl.current.period.days == null">
                <div class="input-group">
                  <input class="form-control" type="text" autocomplete="off" id="daysCount" name="daysCount" ng-model="$ctrl.current.period.daysCount" disabled>
                  <span class="input-group-btn">
                    <button type="button" class="btn btn-default" ng-click="$absencesLogic.setDaysSelection($ctrl.current)"
                      sxy-text="SALAXY.NG1.AbsencePeriodsEditDialog.editDatesButtonText"></button>
                  </span>
                </div>
              </salaxy-form-group>
              <salaxy-datepicker ng-model="$ctrl.current.period" name="days" is-multiple="true" ng-if="$ctrl.current.period.days.length > 0" watch-changes="true" label="SALAXY.MODEL.WorkerAbsencePeriod.period.title"></salaxy-datepicker>
              <salaxy-input-number ng-if="$ctrl.current.data.kind == 'annualLeave'" label="SALAXY.MODEL.WorkerAbsencePeriod.bonusDaysCount.title" ng-model="$ctrl.current.data.bonusDaysCount" name="bonusDaysCount" label-type="horizontal"></salaxy-input-number>
              <salaxy-input-boolean ng-init="$ctrl.current.data.applyPricing = ($ctrl.current.data.applyPricing || false)" type="radio" name="applyPricing" label="SALAXY.MODEL.AbsencePeriodUsecase.applyPricing.title"
                label-true="SALAXY.MODEL.AbsencePeriodUsecase.applyPricing.labelTrue"
                label-false="SALAXY.MODEL.AbsencePeriodUsecase.applyPricing.labelFalse"
                ng-model="$ctrl.current.data.applyPricing">
              </salaxy-input-boolean>
              <salaxy-input-number label="{{$ctrl.getConfig().price.label}}" ng-model="$ctrl.current.price" name="price" label-type="horizontal" require="true"
               placeholder="{{ $ctrl.getPlaceholderText($ctrl.current, 'price') }}"  ng-if="!$ctrl.current.data.applyPricing"></salaxy-input-number>
              <salaxy-input-boolean type="checkbox" name="isPaid" label="SALAXY.MODEL.WorkerAbsencePeriod.isPaid.title"
                label-true="SALAXY.NG1.AbsencePeriodsEditDialog.label.isPaidLabelTrue" disabled="!$absencesLogic.canSelectIsPaid($ctrl.current)" ng-model="$ctrl.current.data.isPaid"
                ng-change="$ctrl.logic.updateIsHolidayAccrual($ctrl.current)"></salaxy-input-boolean>

              <salaxy-input-boolean type="checkbox" name="isHolidayAccrual" label="SALAXY.MODEL.WorkerAbsencePeriod.isHolidayAccrual.title"
                label-true="SALAXY.NG1.AbsencePeriodsEditDialog.label.isAccrualLabelTrue" ng-model="$ctrl.current.data.isHolidayAccrual"></salaxy-input-boolean>
            </div>
            <div ng-switch-when="expenses" ng-init="$expenseLogic = $ctrl.getUsecaseLogic($ctrl.current)">
              <salaxy-input-number label="{{$ctrl.getConfig().price.label}}" ng-model="$ctrl.current.price" name="price" label-type="horizontal"
                require="true"></salaxy-input-number>
              <salaxy-input-enum label="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.vatPercent.label" label-type="horizontal" enum="ExpensesVatRate"
                hidden-options="undefined" require="true" ng-change="$expenseLogic.updateUsecase($ctrl.current)" name="ExpensesVatRate" ng-model="$ctrl.current.data.vatRate"
                type="select"></salaxy-input-enum>

              <div ng-switch="$ctrl.current.data.vatRate">
                <span ng-switch-when="tax255" class="text-success small" sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.vatPercents.p255.description"></span>
                <span ng-switch-when="tax24" class="text-success small" sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.vatPercents.p24.description"></span>
                <span ng-switch-when="tax14" class="text-success small" sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.vatPercents.p14.description"></span>
                <span ng-switch-when="tax10" class="text-success small" sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.vatPercents.p10.description"></span>
                <span ng-switch-when="tax0" class="text-success small" sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.vatPercents.p0.description"></span>
              </div>
              <div ng-if="$ctrl.current.data.vatRate == 'multiple'">
                <p class="mb-0" sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.vatPercentsTable.taxableAmountInPercent" ps=":"></p>
                <div class="row">
                  <salaxy-input-number class="col-sm-3" label="25,5%" label-type="basic" name="inpt5" ng-model="$ctrl.current.accounting.vatEntries[4].gross" ng-change="$expenseLogic.updateUsecase()"></salaxy-input-number>
                  <salaxy-input-number class="col-sm-3" label="24%" label-type="basic" name="inpt1" ng-model="$ctrl.current.accounting.vatEntries[0].gross"
                    ng-change="$expenseLogic.updateUsecase()"></salaxy-input-number>
                  <salaxy-input-number class="col-sm-3" label="14%" label-type="basic" name="inpt2" ng-model="$ctrl.current.accounting.vatEntries[1].gross"
                    ng-change="$expenseLogic.updateUsecase()"></salaxy-input-number>
                  <salaxy-input-number class="col-sm-3" label="10%" label-type="basic" name="inpt3" ng-model="$ctrl.current.accounting.vatEntries[2].gross"
                    ng-change="$expenseLogic.updateUsecase()"></salaxy-input-number>
                  <salaxy-input-number class="col-sm-3" label="0%" label-type="basic" name="inpt4" ng-model="$ctrl.current.accounting.vatEntries[3].gross"
                    ng-change="$expenseLogic.updateUsecase()"></salaxy-input-number>
                </div>
              </div>
              <salaxy-input-number ng-if="$ctrl.current.data.vatRate == 'other'" label="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.vatPercent.label" label-type="horizontal" name="vatRate" ng-model="$ctrl.current.accounting.vatPercent" unit="percent" ng-change="$expenseLogic.updateUsecase()"></salaxy-input-number>
              <div ng-if="$expenseLogic.hasGrossVatEntries">
                <div class="row">
                  <div class="col-12">
                    <table class="table table-sm table-striped" style="font-size: 0.8em">
                      <thead>
                        <tr>
                          <th sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.vatPercentsTable.vatRate"></th>
                          <th sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.vatPercentsTable.exemptFromTaxation" class="right"></th>
                          <th sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.vatPercentsTable.tax" class="right"></th>
                          <th sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.vatPercentsTable.taxable" class="right"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr ng-repeat="item in $ctrl.current.accounting.vatEntries">
                          <td ng-if="!!item.gross">{{ "VatRate." + item.vatRate | sxyEnum }}</td>
                          <td ng-if="!!item.gross" class="right">{{ item.net | currency }}</td>
                          <td ng-if="!!item.gross" class="right">{{ item.tax | currency }}</td>
                          <td ng-if="!!item.gross" class="right">{{ item.gross | currency }}</td>
                        </tr>
                        <tr ng-if="$ctrl.current.data.total" class="total">
                          <th sxy-text="SALAXY.UI_Terms.total"></th>
                          <td class="right">{{ $ctrl.current.data.total.net | currency}}</td>
                          <td class="right">{{ $ctrl.current.data.total.tax | currency}}</td>
                          <td class="right">{{ $ctrl.current.data.total.gross | currency}}</td>
                        </tr>
                      </tbody>
                    </table>

                  </div>
                </div>
                <salaxy-datepicker-popup name="startDate" label="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.date"
                  ng-model="$ctrl.current.data.date"></salaxy-datepicker-popup>
              </div>
              <salaxy-form-group name="receiptImage" label="SALAXY.NG1.CalcRowsComponent.editDialog.receiptUrlAddress">
                <div class="input-group">
                  <input class="form-control" type="text" autocomplete="off" id="file" name="file" ng-model="$ctrl.current.data.fileUrl">
                  <span class="input-group-btn">
                    <a class="btn btn-default" ng-disabled="!$ctrl.showImagePreview()" ng-href="{{$ctrl.current.data.fileUrl}}" target="_blank" sxy-text="SALAXY.UI_Terms.open"></a>
                  </span>
                </div>
              </salaxy-form-group>
              <div class="text-center" style="margin-bottom: 10px;" ng-if="$ctrl.showImagePreview()">
                <img style="max-width: 560px; max-height: 200px;" ng-src="{{$ctrl.current.data.fileUrl}}">
              </div>
            </div>
            <div ng-switch-when="holidayBonus|holidaySalary|holidayCompensation" ng-switch-when-separator="|" ng-init="$holidaysLogic = $ctrl.getUsecaseLogic($ctrl.current)">
              <salaxy-input-number ng-if="$ctrl.getConfig().amount.units.length > 1" label="SALAXY.UI_Terms.amount" ng-model="$ctrl.current.count" name="count" label-type="horizontal"
                unit="{{$ctrl.ensureUnit($ctrl.current)}}" units="$ctrl.getConfig().amount.units" on-unit-change="$ctrl.current.unit=unit" 
                disabled="$ctrl.isDisabled($ctrl.current, 'amount')" ng-if="$ctrl.getConfig().amount.input != 'hidden'">
              </salaxy-input-number>
              <salaxy-input-number  ng-if="!($ctrl.getConfig().amount.units.length > 1)" label="{{$ctrl.getConfig().price.label}}" ng-model="$ctrl.current.price" name="price" label-type="horizontal" require="true"
                disabled="$ctrl.isDisabled($ctrl.current, 'price')" placeholder="{{ $ctrl.getPlaceholderText($ctrl.current, 'price') }}" ng-if="$ctrl.getConfig().price.input != 'hidden'"></salaxy-input-number>
              <salaxy-input-number  ng-if="$ctrl.getConfig().amount.units.length > 1" label="SALAXY.UI_Terms.price" ng-model="$ctrl.current.price" name="price" label-type="horizontal" require="true"
                disabled="$ctrl.isDisabled($ctrl.current, 'price')" ng-if="$ctrl.getConfig().price.input != 'hidden'"></salaxy-input-number>
              <salaxy-datepicker-popup name="start" ng-model="$ctrl.current.period.start" ng-change="$holidaysLogic.updatePeriodDays($ctrl.current)"
                label="SALAXY.MODEL.DateRange.start.title"></salaxy-datepicker-popup>
              <salaxy-datepicker-popup name="end" ng-model="$ctrl.current.period.end" ng-change="$holidaysLogic.updatePeriodDays($ctrl.current)"
                label="SALAXY.MODEL.DateRange.end.title"></salaxy-datepicker-popup>
              <salaxy-form-group name="daysCount" label="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidaysEditDialog.labelHolidaysCount" ng-if="!$ctrl.current.period.days || $ctrl.current.period.days.length == 0">
                <div class="input-group">
                  <input class="form-control" type="text" autocomplete="off" id="daysCount" name="daysCount" ng-model="$ctrl.current.period.daysCount" disabled>
                  <span class="input-group-btn">
                    <button type="button" class="btn btn-default" ng-click="$holidaysLogic.setDaysSelection($ctrl.current)" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidaysEditDialog.editDatesButtonText"></button>
                  </span>
                </div>
              </salaxy-form-group>
              <salaxy-datepicker ng-model="$ctrl.current.period" name="days" is-multiple="true" label="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidaysEditDialog.labelHolidaysCount" min-date="$ctrl.current.period.start" max-date="$ctrl.current.period.end" ng-if="$ctrl.current.period.days.length > 0"></salaxy-date-range>
            </div>
            <div ng-switch-default>
              <salaxy-input-number ng-if="!($ctrl.getConfig().amount.units.length > 1)" label="{{$ctrl.getConfig().amount.label}}" ng-model="$ctrl.current.count" name="count" label-type="horizontal"
                unit="{{$ctrl.getConfig().amount.unit}}" placeholder="{{ $ctrl.getPlaceholderText($ctrl.current, 'amount') }}" disabled="$ctrl.isDisabled($ctrl.current, 'amount')" ng-if="$ctrl.getConfig().amount.input != 'hidden'">
              </salaxy-input-number>
              <salaxy-input-number ng-if="$ctrl.getConfig().amount.units.length > 1" label="SALAXY.UI_Terms.amount" ng-model="$ctrl.current.count" name="count" label-type="horizontal"
                unit="{{$ctrl.ensureUnit($ctrl.current)}}" units="$ctrl.getConfig().amount.units" on-unit-change="$ctrl.current.unit=unit" 
                 disabled="$ctrl.isDisabled($ctrl.current, 'amount')" ng-if="$ctrl.getConfig().amount.input != 'hidden'">
              </salaxy-input-number>
              <salaxy-input-number  ng-if="!($ctrl.getConfig().amount.units.length > 1)" label="{{$ctrl.getConfig().price.label}}" ng-model="$ctrl.current.price" name="price" label-type="horizontal" require="true"
                disabled="$ctrl.isDisabled($ctrl.current, 'price')" placeholder="{{ $ctrl.getPlaceholderText($ctrl.current, 'price') }}" ng-if="$ctrl.getConfig().price.input != 'hidden'"></salaxy-input-number>
              <salaxy-input-number  ng-if="$ctrl.getConfig().amount.units.length > 1" label="SALAXY.UI_Terms.price" ng-model="$ctrl.current.price" name="price" label-type="horizontal" require="true"
                  disabled="$ctrl.isDisabled($ctrl.current, 'price')" ng-if="$ctrl.getConfig().price.input != 'hidden'"></salaxy-input-number>
            </div>
          </div>
          <div ng-if="$ctrl.current.rowType == 'prepaidExpenses'">
            <salaxy-form-group name="vatPercentGroup" label="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.vatPercent.label" label-type="horizontal">
              <select id="vatPercent" name="vatPercent" ng-model="$ctrl.current.data.accounting.vatPercent" class="form-select" ng-change="$ctrl.updateUsecase($ctrl.current)">
                <option ng-value='' sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.vatPercents.pempty.label"></option>
                <option ng-value='0.255' sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.vatPercents.p255.label"></option>
                <option ng-value='0.24' sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.vatPercents.p24.label"></option>
                <option ng-value='0.14' sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.vatPercents.p14.label"></option>
                <option ng-value='0.1' sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.vatPercents.p10.label"></option>
                <option ng-value='0' sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.vatPercents.p0.label"></option>
              </select>
              <div ng-switch="$ctrl.current.data.accounting.vatPercent">
                <span ng-switch-when="0.255" class="text-success small" sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.vatPercents.p255.description"></span>
                <span ng-switch-when="0.24" class="text-success small" sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.vatPercents.p24.description"></span>
                <span ng-switch-when="0.14" class="text-success small" sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.vatPercents.p14.description"></span>
                <span ng-switch-when="0.1" class="text-success small" sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.vatPercents.p10.description"></span>
                <span ng-switch-when="0" class="text-success small" sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.vatPercents.p0.description"></span>
                <span ng-switch-default class="text-success small" sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.accounting.vatPercents.pempty.label"></span>
              </div>
            </salaxy-form-group>
          </div>
          <div ng-if="$ctrl.current.rowType != 'irIncomeType'">
            <hr>
            <salaxy-input ng-if="$ctrl.current.rowType != 'hourlySalaryWithWorkingTimeCompensation'" label="SALAXY.NG1.CalcRowsComponent.editDialog.additionalRows.description" label-type="horizontal" disabled="$ctrl.isDisabled($ctrl.current)"
              ng-model="$ctrl.current.message" name="message" placeholder="{{$ctrl.getMessagePlaceholderText($ctrl.current)}}"></salaxy-input>
            <salaxy-input label="SALAXY.NG1.CalcRowsComponent.editDialog.additionalRows.additionalRow" label-type="horizontal" disabled="$ctrl.isDisabled($ctrl.current)"
              ng-model="$ctrl.current.data.sxySalarySlipRowComment" name="sxySalarySlipRowComment"></salaxy-input>
          </div>
          <div ng-if="$ctrl.isStandAlone && $ctrl.current.rowType != 'absencePeriod'">
            <fieldset>
              <legend sxy-text="SALAXY.NG1.DateRange.labelStartAndEndDate"></legend>
              <salaxy-datepicker-popup label="SALAXY.MODEL.DateRange.start.title" name="salaryDate" ng-model="$ctrl.current.period.start"></salaxy-datepicker-popup>
              <salaxy-datepicker-popup label="SALAXY.MODEL.DateRange.end.title" name="salaryDate" ng-model="$ctrl.current.period.end"></salaxy-datepicker-popup>
            </fieldset>
          </div>
          <div ng-if="$ctrl.current.rowType != 'taxAtSource'">
            <salaxy-calc-row-cost-accounting calc="$ctrl.parent" row="$ctrl.current" dimensions="$ctrl.dimensions"></salaxy-calc-row-cost-accounting>
          </div>
        </div>
        <div class="text-right d-flex" ng-if="$ctrl.isEditable && !$ctrl.definitionEditor.mode">
          <button type="button" class="btn btn-danger float-start" ng-click="$ctrl.closeEditDialog('delete-no-save', $close)"
            sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.buttons.delete"></button>
          <button type="button" ng-if="$ctrl.isDialog" class="btn btn-default ms-auto me-1" ng-click="$ctrl.closeEditDialog('cancel', $close)"
            sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.buttons.cancel"></button>
          <button type="submit" class="btn btn-primary" ng-click="$ctrl.closeEditDialog('ok-no-save', $close)"
            sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.buttons.save"></button>
        </div>
        <div ng-if="!$ctrl.isEditable" class="text-end">
          <button type="button" class="btn btn-default" ng-click="$ctrl.closeEditDialog('cancel', $close)"
            sxy-text="SALAXY.NG1.CalcRowsComponent.editDialog.buttons.close"></button>
        </div>
      </div>
    </form>
  </div>
</div>`), s.put("salaxy-components/calc/rows/CalcRows2019Editor.html", `<div class="salaxy-component salaxy-calc-rows-editor salaxy-calc-rows-2019-editor">

  <div ng-if="$ctrl.isInEdit">
    <table class="table table-sm">
      <thead>
        <tr>
          <th width="42px" class="hidden-xxs th-avatar"></th>
          <th width="40%" class="uppercase th-calc-row-type">{{ $ctrl.title }}</th>
          <th ng-if="$ctrl.showDimension()" ng-repeat="definition in $ctrl.getDimensionsToShow()">{{definition.label}}</th>
          <th class="right" ng-if="$ctrl.hasRows" sxy-text="SALAXY.NG1.CalcRowsComponent.editor.amount"></th>
          <th class="right" ng-if="$ctrl.hasRows" sxy-text="SALAXY.NG1.CalcRowsComponent.editor.price"></th>
          <th class="right th-row-total" ng-if="$ctrl.hasRows" sxy-text="SALAXY.NG1.CalcRowsComponent.editor.total"></th>
          <th colspan="3" ng-if="!$ctrl.hasRows">&nbsp;</th>
          <th class="salaxy-calc-rows-editor-btns">
            <span ng-if="$ctrl.showEditButtons">
              <button class="btn btn-sm btn-transparent" ng-click="$ctrl.commit()" title="{{'SALAXY.NG1.CalcRowsComponent.editor.buttons.okIcon' | sxyTranslate}}">
                <i class="bi bi-check-lg text-success"></i>
              </button>
              <button class="btn btn-sm btn-transparent" ng-click="$ctrl.reset()" title="{{'SALAXY.NG1.CalcRowsComponent.editor.buttons.cancelIcon' | sxyTranslate}}">
                <i class="bi bi-x-lg"></i>
              </button>
            </span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat-start="row in $ctrl.filteredList track by $index" ng-class="$ctrl.getValidation(row).type ? 'row-before-validation' : ''">
          <td width="42px" class="hidden-xxs td-avatar" ng-class="{'td-no-avatar' : !row.rowType}">
            <salaxy-avatar ng-if="row.rowType" class="salaxy-calc-row-type-avatar" avatar="{ color: $ctrl.getConfig(row).color, initials: $ctrl.getConfig(row).iconText, entityType: 'company' }"></salaxy-avatar>
          </td>
          <td width="40%" class="td-calc-row-type" ng-class="{'td-add-new': !row.rowType}">
            <salaxy-calc-row-type ng-if="!row.rowType" name="rowType" model="row" row-types="$ctrl.rowTypes" categories="$ctrl.categories" placeholder="SALAXY.NG1.CalcRowsComponent.editor.calcRowTypePlaceholder" on-row-changed="$ctrl.rowTypeChanged(row)"></salaxy-calc-row-type>
            <input class="form-control" ng-if="row.rowType" name="message" type="text" ng-model="row.message" ng-disabled="$ctrl.isDisabled(row, 'message')" placeholder="{{$ctrl.getMessagePlaceholderText(row)}}" />
          </td>
          <td  ng-if="$ctrl.showDimension()" ng-repeat="definition in $ctrl.getDimensionsToShow()">
            <div class="truncate">
              <salaxy-calc-row-dimension-input row="row" definition="definition" inherited="$ctrl.parent.accounting.dimensions" read-only="$ctrl.mode == 'read-only'"></salaxy-calc-row-dimension-input>
            </div>
          </td>
          <td ng-if="row.rowType" class="right">
            <salaxy-input-number ng-if="$ctrl.getConfig(row).amount.units.length > 1" on-unit-change="row.unit=unit" name="{{ 'iptCount' + (row.rowIndex < 0 ? 'Salary' : row.rowIndex) }}" ng-model="row.count" label-type="plain" disabled="$ctrl.isDisabled(row, 'amount')" unit="{{$ctrl.ensureUnit(row)}}" units="$ctrl.getConfig(row).amount.units">
            </salaxy-input-number>
            <salaxy-input-number ng-if="!($ctrl.getConfig(row).amount.units.length > 1)" name="{{ 'iptCount' + (row.rowIndex < 0 ? 'Salary' : row.rowIndex) }}" ng-model="row.count" label-type="plain" placeholder="{{ $ctrl.getPlaceholderText(row, 'amount') }}" disabled="$ctrl.isDisabled(row, 'amount')" unit="{{$ctrl.getConfig(row).amount.unit}}">
            </salaxy-input-number>
          </td>
          <td ng-if="row.rowType" class="right">
            <salaxy-input-number ng-if="$ctrl.getConfig(row).amount.units.length > 1" name="{{ 'iptPrice' + (row.rowIndex < 0 ? 'Salary' : row.rowIndex) }}" ng-model="row.price" label-type="plain"  disabled="$ctrl.isDisabled(row, 'price')" require="true"></salaxy-input-number>
            <salaxy-input-number ng-if="!($ctrl.getConfig(row).amount.units.length > 1)" name="{{ 'iptPrice' + (row.rowIndex < 0 ? 'Salary' : row.rowIndex) }}" ng-change="row.rowType == 'hourlySalaryWithWorkingTimeCompensation' ? $ctrl.updateUsecase(row) : null" ng-model="row.price" label-type="plain" placeholder="{{ $ctrl.getPlaceholderText(row, 'price') }}" disabled="$ctrl.isDisabled(row, 'price')" require="true"></salaxy-input-number>
          </td>
          <td ng-if="row.rowType" class="right td-row-total">
            <div>{{ $ctrl.getRowTotal(row) | currency }}</div>
          </td>
          <td ng-if="row.rowType" class="salaxy-calc-rows-editor-btns">
            <button type="button" class="edit btn btn-info btn-sm" ng-disabled="!row.rowType" ng-click="$ctrl.showEditDialog(row)" title="{{'SALAXY.NG1.CalcRowsComponent.editor.buttons.editIcon' | sxyTranslate}}"><i class="bi bi-pencil-fill"></i></button>
            <button type="button" class="delete btn btn-danger btn-sm" ng-if="row.rowIndex >= 0" ng-click="$ctrl.delete(row)" title="{{'SALAXY.NG1.CalcRowsComponent.editor.buttons.deleteIcon' | sxyTranslate}}"><i class="bi bi-trash-fill"></i></button>
          </td>
          <td ng-if="!row.rowType" colspan="2" class="td-add-new-btn">
            <div>
              <button type="button" class="btn btn-default" ng-click="$ctrl.createNew()"><i class="bi bi-info-circle-fill text-primary me-2"></i><span
                  sxy-text="SALAXY.NG1.CalcRowsComponent.editor.buttons.readMore" ps="..."></span></button>
            </div>
          </td>
          <td ng-if="!row.rowType" colspan="2" class="td-no-btns">&nbsp;</td>
        </tr>
        <tr ng-if="row.rowType == 'hourlySalaryWithWorkingTimeCompensation' && $ctrl.getValidation(row).type != 'error'" ng-repeat="compensationRow in row.data.compensationRows track by $index" class="no-border">
          <td width="42px" class="hidden-xxs td-avatar">
          </td>
          <td width="40%" class="td-calc-row-type">
            <input class="form-control" name="message" type="text" readonly="true" value="{{ compensationRow.message || ('WorkingTimeCompensationKind.' + row.data.kind | sxyEnum) }}, {{ row.data.pricing == 'percent' ? (compensationRow.percent | sxyCount:'percent') : (compensationRow.price | currency) + ' / h' }}" />
          </td>
          <td  ng-if="$ctrl.showDimension()" ng-repeat="definition in $ctrl.getDimensionsToShow()">
            <div style="min-width: 100px" class="truncate">
              <salaxy-calc-row-dimension-input row="row" definition="definition" inherited="$ctrl.parent.accounting.dimensions" read-only="true"></salaxy-calc-row-dimension-input>
            </div>
          </td>
          <td class="right">
            <salaxy-input-number name="{{ 'iptCount' + (row.rowIndex < 0 ? 'Salary' : row.rowIndex) }}" ng-if="compensationRow.count != null" ng-model="compensationRow.count" label-type="plain" readonly="true">
            </salaxy-input-number>
            <salaxy-input-number name="{{ 'iptCount' + (row.rowIndex < 0 ? 'Salary' : row.rowIndex) }}" ng-if="compensationRow.count == null" ng-model="row.count" label-type="plain" readonly="true"></salaxy-input-number>
            </salaxy-input-number>
          </td>
          <td class="right">
            <salaxy-input-number name="{{ 'iptPrice' + (row.rowIndex < 0 ? 'Salary' : row.rowIndex) }}" ng-model="compensationRow.price" label-type="plain" readonly="true"></salaxy-input-number>
          </td>
          <td class="right td-row-total">
            <div>{{ (compensationRow.price * (compensationRow.count || row.count || 1)) | currency }}</div>
          </td>
          <td></td>
        </tr>
        <tr ng-repeat-end class="row-validation no-border" ng-if="row.rowType != 'hourlySalaryWithWorkingTimeCompensation' || $ctrl.getValidation(row).type == 'error'">
          <td></td>
          <td colspan="5">
            <small class="" ng-if="$ctrl.getValidation(row).type == 'default'">
              {{ $ctrl.getValidation(row).msg | sxyTranslate }}
              <a href="" ng-click="$ctrl.showEditDialog(row)" sxy-text="SALAXY.NG1.CalcRowsComponent.editor.validation.edit" ps="..."></a>
            </small>
            <span ng-if="$ctrl.getValidation(row).type == 'error'">
              <span class="label label-danger" sxy-text="SALAXY.NG1.CalcRowsComponent.editor.validation.note"></span>
            <small class="alert-danger">{{ $ctrl.getValidation(row).msg | sxyTranslate }}
                <a href="" ng-click="$ctrl.showEditDialog(row)" sxy-text="SALAXY.NG1.CalcRowsComponent.editor.validation.edit" ps="..."></a>
              </small>
            </span>
          </td>
        </tr>
        <tr class="new-row">
          <td width="42px" class="hidden-xxs td-avatar border-0" ng-class="{'td-no-avatar' : !row.rowType}">
          </td>
          <td width="40%" class="border-0">
            <salaxy-calc-row-type name="newRowType" model="$ctrl.newRow" placeholder="SALAXY.NG1.CalcRowsComponent.editor.calcRowTypePlaceholder" on-row-changed="$ctrl.commitNewRow()" row-types="$ctrl.rowTypes" categories="$ctrl.categories" clear-on-select="true"></salaxy-calc-row-type>
          </td>
          <td colspan="2" class="td-add-new-btn border-0">
            <button type="button" class="btn btn-default" ng-click="$ctrl.showRowTypeSelectionDialog()"><i class="bi bi-info-circle-fill text-primary me-2"></i> <span
                sxy-text="SALAXY.NG1.CalcRowsComponent.editor.buttons.readMore" ps="..."></span></button>
          </td>
          <td colspan="2" class="td-no-btns border-0">&nbsp;</td>
        </tr>
      </tbody>
      <tfoot ng-if="$ctrl.hasRows">
        <tr class="total">
          <th width="42px" class="hidden-xxs"></th>
          <td>
            <strong sxy-text="SALAXY.NG1.CalcRowsComponent.editor.totals.finalCost"></strong>
          </td>
          <td colspan="3" class="right">
            <strong>{{ $ctrl.getFinalCost() | currency }}
              <!--{{ $ctrl.getTotal() | currency }}--></strong>
          </td>
          <td colspan="2"></td>
        </tr>
      </tfoot>
    </table>

  </div>
  <div ng-if="!$ctrl.isInEdit">
    <table class="table table-sm">
      <thead>
        <tr>
          <th width="42px" class="hidden-xxs"></th>
          <th width="40%" class="uppercase">{{ $ctrl.title || ('SALAXY.NG1.CalcRowsComponent.editor.calcRow' | sxyTranslate) }}</th>
          <th></th>
          <th class="right" ng-if="$ctrl.hasRows" sxy-text="SALAXY.NG1.CalcRowsComponent.editor.totals.total"></th>
          <th class="salaxy-calc-rows-editor-btns text-end">
            <span ng-if="$ctrl.showEditButtons && $ctrl.mode != 'read-only'">
              <button ng-if="$ctrl.showEditButtons && $ctrl.mode != 'read-only'" ng-hide="$ctrl.parent.isReadOnly" ng-disabled="!$ctrl.isEditable" ng-click="$ctrl.startEdit()" type="button" class="edit btn btn-info btn-sm" title="{{'SALAXY.NG1.CalcRowsComponent.editor.buttons.editIcon' | sxyTranslate}}">
                <i class="bi bi-pencil-fill"></i>
              </button>
            </span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.filteredList track by $index">
          <td width="42px" class="hidden-xxs">
            <salaxy-avatar ng-if="row.rowType" class="salaxy-calc-row-type-avatar" avatar="{ color: $ctrl.getConfig(row).color, initials: $ctrl.getConfig(row).iconText, entityType: 'company' }"></salaxy-avatar>
          </td>
          <td width="50%">{{$ctrl.getMessagePlaceholderText(row)}}</td>
          <td ng-if="row.rowType" class="right">
            <small class="text-muted" ng-if="row.count && row.count != 1">{{row.count | sxyCount : row.unit }} * {{ row.price | currency }}</small>
          </td>
          <td ng-if="row.rowType" class="right">
            <div>{{ $ctrl.getRowTotal(row) | currency }}</div>
          </td>
          <td ng-if="row.rowType" class="salaxy-calc-rows-editor-btns text-end">
            <button type="button" class="edit btn btn-info btn-sm" ng-disabled="!row.rowType" ng-click="$ctrl.showEditDialog(row)" title="{{'SALAXY.NG1.CalcRowsComponent.editor.buttons.infoIcon' | sxyTranslate}}"><i class="bi bi-pencil-fill"></i></button>
          </td>
        </tr>
      </tbody>
      <tfoot ng-if="$ctrl.hasRows && $ctrl.hideFinalCostRow">
        <tr class="total">
          <td width="42px" class="hidden-xxs"></td>
          <td>
            <strong sxy-text="SALAXY.NG1.CalcRowsComponent.editor.totals.total"></strong>
          </td>
          <td></td>
          <td class="right">
            <strong>
              <!--{{ $ctrl.getTotal() | currency }}--></strong>
          </td>
          <td></td>
        </tr>
        <tr ng-if="$ctrl.showGrossTotals">
          <th width="42px" class="hidden-xxs"></th>
          <td>
            <span sxy-text="SALAXY.NG1.CalcRowsComponent.editor.totals.grossTotal"></span><br>
            <small class="text-muted" sxy-text="SALAXY.NG1.CalcRowsComponent.editor.totals.netSalary"></small>
          </td>
          <td>

          </td>
          <td class="right">
            {{ $ctrl.getGrossTotal() | currency }}<br>
            <small class="text-muted">{{ $ctrl.getNetSalary() | currency }}</small>
          </td>
          <td></td>
        </tr>
        <tr ng-if="$ctrl.showGrossTotals" class="total">
          <th width="42px" class="hidden-xxs"></th>
          <td>
            <strong sxy-text="SALAXY.NG1.CalcRowsComponent.editor.totals.finalCost"></strong>
            <br>
            <small class="text-muted" sxy-text="SALAXY.NG1.CalcRowsComponent.editor.totals.totalPayment"></small>
          </td>
          <td>
          </td>
          <td class="right">
            <strong>{{ $ctrl.getFinalCost() | currency }}</strong><br>
            <small class="text-muted">{{ $ctrl.getTotalPayment() | currency }}</small>
          </td>
          <td></td>
        </tr>
      </tfoot>
    </table>
  </div>
</div>`), s.put("salaxy-components/calc/rows/CalcsIrRows.html", `<div class="salaxy-calc-ir-rows salaxy-component">
  <sxy-table ng-ref="$ctrl.$sxyTable" options="$ctrl.tableConfig.options" include="$ctrl.tableConfig.include" data="$ctrl.tableConfig.data"></sxy-table>
</div>`), s.put("salaxy-components/calc/rows/RowTypeEditDialog.html", `<div class="modal-header">
  <h2 class="modal-title">Palkkalaji: {{ $ctrl.current.config.label }}</h2>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
</div>
<div class="modal-body" id="modal-body">
  <salaxy-tab-buttons
    current-tab="$ctrl.currentTab"
    options="[
      { 'value': 'default', 'text': 'SALAXY.NG1.WorkerDetailsComponent.workerInfo' },
      { 'value': 'defaultseditor', 'text': 'Oletusarvot' },
      { 'value': 'kinds', 'text': 'Alalajit', disabled: !$ctrl.current.config.kind.values.length },
      { 'value': 'editor', 'text': 'Esikatselu, UI' },
      { 'value': 'json', 'text': 'Esikatselu, data' },
      { 'value': 'formulas', 'text': 'Laskukaavat', 'hidden': !(('!prod' | sxyIsInRole) && $ctrl.definitionEditor.mode != 'builtIn') },
      { 'value': 'examples', 'text': 'Kehittäjälle', 'hidden': !(('!prod' | sxyIsInRole) && $ctrl.definitionEditor.mode == 'builtIn') }
    ]"
    tabs-id="rowTypeEditDialogTabs">
  </salaxy-tab-buttons>
  <div class="tab-content" id="tab-content-rowTypeEditDialogTabs">
    <div class="tab-pane" id="default-tab">
      <sxy-form open-api="salaxy-secure/schemas/v02.json" type="CalcRowConfig" auto-gen="false" debugger="false"
        model="$ctrl.current.config" read-only="{{ $ctrl.definitionEditor.mode == 'builtIn' }}">
        <div>
          <salaxy-form-group name="id" class="salaxy-read-only" label="Koodi">
            <div class="salaxy-read-only-value">
              <button type="button" class="btn btn-default" ng-click="$ctrl.copyToClipboard($ctrl.current.config.type)" title="Kopioi ID leikepöydälle">
                <i class="bi bi-clipboard" aria-hidden="true"></i></button>
              <code>{{ $ctrl.current.config.type }}</code>
            </div>
            <p>Kopioi tämä koodi esim. tuntiraportointijärjestelmään, jotta tiedot lähetetään Palkkaukseen oikealla koodilla.</p>
          </salaxy-form-group>
          <fieldset>
            <legend>Rivityypin kuvaus</legend>
            <sxy-input label="Teksti" id="label" model="form.label"></sxy-input>
            <sxy-input label="Kuvaus" id="descr" model="form.descr"></sxy-input>
            <sxy-input label="Kategoria" id="category" model="form.category" options="CalculationRowCategory"></sxy-input>
            <sxy-input label="Suosikki" id="favorite" model="form.favorite" type="integer"></sxy-input>
            <sxy-input label="Väri" id="color" model="form.color"></sxy-input>
            <sxy-input label="Ikonin teksti" id="iconText" model="form.iconText" format="color"></sxy-input>
          </fieldset>
          <div class="row">
            <div class="col-sm-6">
              <fieldset>
                <legend>Hinta</legend>
                <sxy-input label="Teksti" id="price.label" model="form.price.label"></sxy-input>
                <!-- TODO: Fix options to be drop-down -->
                <sxy-input label="Kentän tyyppi" id="price.input" model="form.price.input" options="['number','hidden','readOnly']" format="select"></sxy-input>
                <sxy-input label="Oletus" id="price.default" model="form.price.default"></sxy-input>
              </fieldset>
            </div>
            <div class="col-sm-6">
              <fieldset>
                <legend>Määrä</legend>
                <sxy-input label="Teksti" id="amount.label" model="form.amount.label"></sxy-input>
                <sxy-input label="Kentän tyyppi" id="amount.input" model="form.amount.input" options="['number','hidden','readOnly']" format="select"></sxy-input>
                <sxy-input label="Oletus" id="amount.default" model="form.amount.default"></sxy-input>
              </fieldset>
            </div>
          </div>
        </div>
      </sxy-form>
    </div>
    <div class="tab-pane" id="defaultseditor-tab">
      <div>
        <ng-include src="'salaxy-components/calc/rows/CalcRows2019EditDialog.html'"></ng-include>
      </div>
    </div>
    <div class="tab-pane" id="kinds-tab">
      <table>
        <thead>
          <tr>
            <th>Nro</th>
            <th>Teksti</th>
            <th>Kuvaus</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat-start="kind in $ctrl.current.config.kind.values">
            <td>{{ kind.order }}</td>
            <td>{{ kind.label }}</td>
            <td>{{ kind.descr }}</td>
            <td rowspan="2">
              <button type="button" class="btn btn-default" ng-click="$ctrl.copyToClipboard($ctrl.current.config.type + '/' + kind.name)" title="Kopioi ID leikepöydälle">
                <i class="bi bi-clipboard" aria-hidden="true"></i></button>
            </td>
          </tr>
          <tr ng-repeat-end>
            <td></td>
            <td colspan="2">
              <code>{{ $ctrl.current.config.type }}/{{ kind.name }}</code>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="tab-pane" id="editor-tab">
      <div>
        <div class="alert alert-warning">
          <strong>Huom!</strong> Tuotteen palkkalajeja ei voi muokata. Tämä näkymä on vain esikatselua varten.
        </div>
        <ng-include src="'salaxy-components/calc/rows/CalcRows2019EditDialog.html'"></ng-include>
      </div>
    </div>
    <div class="tab-pane" id="json-tab">
      <div ng-if="true || $ctrl.currentTab == 'json'">
        <salaxy-json-formatter key="'Data'" json="$ctrl.current" open="2"></salaxy-json-formatter>
      </div>
    </div>
    <div class="tab-pane" id="formulas-tab" heading="Laskukaavat">
      <div ng-if="$ctrl.currentTab == 'formulas'">
        <salaxy-calc-row-formula row="$ctrl.current"></salaxy-calc-row-formula>
      </div>
    </div>
    <div class="tab-pane" id="examples-tab">
      <div ng-if="$ctrl.currentTab == 'examples'">
        <salaxy-calc-row-documentation row="$ctrl.current"></salaxy-calc-row-documentation>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
  <button type="button" ng-if="$ctrl.definitionEditor.mode == 'custom'" class="btn btn-primary" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.save"></button>
</div>`), s.put("salaxy-components/calc/SalaryDateKindButton.html", `<div class="salaxy-date-kind-button salaxy-component">
  <div class="dropdown" ng-class="$ctrl.buttonClass">
    <button id="btnSalaryDateKind" type="button" ng-disabled="$ctrl.disabled" class="btn btn-default btn-block dropdown-toggle justify-content-start" data-bs-toggle="dropdown">
      <salaxy-avatar class="py-1" avatar="$ctrl.currentSalaryDateKind.avatar" template-url="iconAvatar.html"></salaxy-avatar>
      <span class="button-text">
        {{ $ctrl.currentSalaryDateKind.text | sxyTranslate}}
      </span>
    </button>
    <ul class="dropdown-menu" role="menu" aria-labelledby="btnSalaryDateKind">
      <li role="menuitem" ng-class="{ 'disabled': $ctrl.disabled }" ng-repeat="salaryDateKind in $ctrl.salaryDateKinds">
        <a href="" ng-click="$ctrl.setSalaryDateKind(salaryDateKind.value)" class="dropdown-item d-flex align-items-center">
          <salaxy-avatar avatar="salaryDateKind.avatar" class="me-2" template-url="iconAvatar.html"></salaxy-avatar>
          <span class="button-text">
            {{ salaryDateKind.text | sxyTranslate }}
          </span>
        </a>
      </li>
    </ul>
  </div>
</div>
<script type="text/ng-template" id="iconAvatar.html">
  <i class="salaxy-avatar bi" ng-class="$ctrl.avatar.icon" ng-style="{color: $ctrl.avatar.color }"></i>
<\/script>`), s.put("salaxy-components/calc/usecases/household-childCare.html", `<div>
  <div ng-if="$ctrl.usecaseData.id == 'childCare/mll'">
    <div class="card-header childcare">
      <span class="float-start">
        <div class="icon-wrapper salaxy-household-usecase-avatar">
          <div class="main-icon-wrapper" ng-if="$ctrl.usecaseData.icon">
            <img ng-src="{{$ctrl.usecaseData.icon}}">
          </div>
          <div ng-if="$ctrl.usecaseData.badge" class="badge-image-wrapper">
            <img ng-src="{{$ctrl.usecaseData.badge}}">
          </div>
        </div>
      </span>
      <h1>{{$ctrl.usecaseData.label}}</h1>
      <p class="calc-text">
        {{$ctrl.salaryRow.count || 0}} h x {{$ctrl.salaryRow.price || '9,5'}} € <span ng-if="$ctrl.usecaseData.isSunday" sxy-text="SALAXY.NG1.HouseholdUsecaseComponent.base.hoursPerPriceWithSunday"></span>
        <span class="result-text" ng-if="!$ctrl.usecaseData.isSunday">{{ ($ctrl.salaryRow.count || 0) * ($ctrl.salaryRow.price || 9.5) | currency }}</span>
        <span class="result-text" ng-if="$ctrl.usecaseData.isSunday">{{ ($ctrl.salaryRow.count || 0) * ($ctrl.salaryRow.price || 9.5) * 2 | currency }}</span>
      </p>
      <a class="btn-link btn-showmore" ng-click="showInfo = !showInfo"><span sxy-text="SALAXY.UI_Terms.showMore"></span><i class="bi bi-info-circle-fill"></i></a>
    </div>
    <div class="card-body">
      <p sxy-html="SALAXY.NG1.HouseholdUsecaseComponent.mll.shortInfoText.html"></p>
      <span class="collapse" ng-class="{show: showInfo}">
        <p sxy-html="SALAXY.NG1.HouseholdUsecaseComponent.mll.longInfoText.html"></p>
      </span>
      <div class="form-horizontal">
        <salaxy-input-number name="hours" label="SALAXY.NG1.HouseholdUsecaseComponent.base.hourCount" ng-model="$ctrl.salaryRow.count" label-cols="col-sm-6" required>
        </salaxy-input-number>
        <salaxy-input-boolean name="isSunday" label="SALAXY.NG1.HouseholdUsecaseComponent.base.isSunday" type="switch" ng-model="$ctrl.usecaseData.isSunday" label-true="SALAXY.UI_Terms.yes" label-false="SALAXY.UI_Terms.no" label-cols="col-sm-6"></salaxy-input-boolean>
        <salaxy-input-boolean name="useCustomPrice" label="SALAXY.NG1.HouseholdUsecaseComponent.mll.useCustomPrice" type="switch" ng-model="$ctrl.usecaseData.useCustomPrice" label-true="SALAXY.UI_Terms.yes" label-false="SALAXY.UI_Terms.no" label-cols="col-sm-6">
        </salaxy-input-boolean>
        <salaxy-input-number ng-if="$ctrl.usecaseData.useCustomPrice" name="price" label="SALAXY.NG1.HouseholdUsecaseComponent.base.eurPerH" ng-model="$ctrl.salaryRow.price" label-cols="col-sm-6"></salaxy-input-number>
      </div>
    </div>
  </div>
  <div ng-if="$ctrl.usecaseData.id != 'childCare/mll'">
    <div class="card-header childcare">
      <span class="float-start">
        <div class="icon-wrapper salaxy-household-usecase-avatar">
          <div class="main-icon-wrapper" ng-if="$ctrl.usecaseData.icon">
            <img ng-src="{{$ctrl.usecaseData.icon}}" type="image/svg+xml">
          </div>
          <div ng-if="$ctrl.usecaseData.badge" class="badge-image-wrapper">
            <img ng-src="{{$ctrl.usecaseData.badge}}">
          </div>
        </div>
      </span>

      <h1>{{$ctrl.usecaseData.label}}</h1>
      <p class="calc-text">
        <span ng-if="$ctrl.salaryRow.rowType=='hourlySalary' || $ctrl.salaryRow.rowType == 'unknown'">{{$ctrl.salaryRow.count || 0}} h x
          {{$ctrl.salaryRow.price || 0}} €</span>
        <span ng-if="$ctrl.salaryRow.rowType=='monthlySalary'">{{$ctrl.salaryRow.price || 0}} <span sxy-text="SALAXY.NG1.HouseholdUsecaseComponent.base.eurPerMonth"></span></span>
        <span ng-if="$ctrl.usecaseData.isChildcareSubsidy">+ {{ $ctrl.usecaseData.subsidyAmount || 0 }} <span
            sxy-test="SALAXY.NG1.HouseholdUsecaseComponent.childCare.isChildCareSubsidy"></span></span>
        <span ng-if="$ctrl.isHouseholdDeductible" sxy-text="SALAXY.NG1.HouseholdUsecaseComponent.base.isHouseholdDeductible"></span>
        <span class="result-text" ng-if="$ctrl.salaryRow.rowType=='hourlySalary' || $ctrl.salaryRow.rowType == 'unknown'">{{ ($ctrl.salaryRow.count || 0) * ($ctrl.salaryRow.price || 0) }}
          €</span>
        <span class="result-text" ng-if="$ctrl.salaryRow.rowType=='monthlySalary'">{{ $ctrl.salaryRow.price || 0}} €</span>
      </p>
      <a class="btn-link btn-showmore" ng-click="showInfo = !showInfo"><span sxy-text="SALAXY.UI_Terms.showMore"></span><i class="bi bi-info-circle-fill"></i></a>
    </div>
    <div class="card-body">
      <p sxy-text="SALAXY.NG1.HouseholdUsecaseComponent.childCare.shortInfoText.html"></p>
      <span class="collapse" ng-class="{show: showInfo}">

        <p ng-if="$ctrl.usecaseData.isChildcareSubsidy" sxy-html="SALAXY.NG1.HouseholdUsecaseComponent.childCare.longInfoTextIfchildCareSubsidy.html"></p>
        
        <p ng-if="!$ctrl.usecaseData.isChildcareSubsidy" sxy-html="SALAXY.NG1.HouseholdUsecaseComponent.childCare.longInfoTextIfNotchildCareSubsidy.html"></p>

        
      </span>
      <div class="form-horizontal">
        <salaxy-input-number ng-show="$ctrl.usecaseData.isChildcareSubsidy" name="subsidyAmount" label="SALAXY.NG1.HouseholdUsecaseComponent.childCare.childCareSubsidy" ng-model="$ctrl.usecaseData.subsidyAmount" label-cols="col-sm-6">
        </salaxy-input-number>
        <salaxy-input-enum type="select" name="mainRowType" label="SALAXY.NG1.HouseholdUsecaseComponent.base.salaryKind" ng-model="$ctrl.salaryRow.rowType" options="{'hourlySalary': ('SALAXY.ENUM.SalaryKind.hourlySalary.label' | sxyTranslate),'monthlySalary':('SALAXY.ENUM.SalaryKind.monthlySalary.label'| sxyTranslate)}"
          ng-change="$ctrl.changeRowType()" label-cols="col-sm-6" required></salaxy-input-enum>
        <salaxy-input-number name="price" label="{{$ctrl.usecaseData.isChildcareSubsidy ? $ctrl.priceLabel + ( 'SALAXY.NG1.HouseholdUsecaseComponent.childCare.inAdditionToBenefits'|sxyTranslate) : $ctrl.priceLabel}}" ng-model="$ctrl.salaryRow.price" label-cols="col-sm-6"></salaxy-input-number>
        <salaxy-input-number ng-if="$ctrl.salaryRow.rowType=='hourlySalary'" name="amount" label="SALAXY.NG1.HouseholdUsecaseComponent.base.hourCount" ng-model="$ctrl.salaryRow.count" required label-cols="col-sm-6"></salaxy-input-number>

        <salaxy-input-boolean ng-if="!$ctrl.usecaseData.isChildcareSubsidy" name="isHouseholdDeductible" label="SALAXY.NG1.HouseholdUsecaseComponent.base.householdDeduction" type="radio" ng-model="$ctrl.isHouseholdDeductible" label-true="SALAXY.NG1.HouseholdUsecaseComponent.base.householdDeductionTrue"
          label-false="SALAXY.NG1.HouseholdUsecaseComponent.base.householdDeductionFalse" label-cols="col-sm-6"></salaxy-input-boolean>
        <div class="form-group" ng-if="$ctrl.usecaseData.isChildcareSubsidy">
          <div class="col-sm-6"><strong sxy-text="SALAXY.NG1.HouseholdUsecaseComponent.childCare.workerTotalPayment"></strong></div>
          <div class="col-sm-6 text-end" ng-if="$ctrl.salaryRow.rowType=='hourlySalary'">
            {{ ($ctrl.salaryRow.price || 0) * ($ctrl.salaryRow.count || 0) + ($ctrl.usecaseData.subsidyAmount || 0) }}</div>
          <div class="col-sm-6 text-end" ng-if="$ctrl.salaryRow.rowType=='monthlySalary'">
            {{ ($ctrl.salaryRow.price || 0) + ($ctrl.usecaseData.subsidyAmount || 0) }}</div>
        </div>
      </div>
    </div>
  </div>
</div>`), s.put("salaxy-components/calc/usecases/household-cleaning.html", `<div>
  <div class="card-header cleaning">
    <span class="float-start">
      <div class="icon-wrapper salaxy-household-usecase-avatar">
        <div class="main-icon-wrapper">
          <img ng-src="{{$ctrl.usecaseData.icon}}">
        </div>
      </div>
    </span>
    <h1>{{$ctrl.usecaseData.label}}</h1>
    <p class="calc-text">

      <span ng-if="$ctrl.salaryRow.rowType=='hourlySalary' || $ctrl.salaryRow.rowType == 'unknown'">{{$ctrl.salaryRow.count || 0}} h x {{$ctrl.salaryRow.price || 0}}
        €</span>
      <span ng-if="$ctrl.salaryRow.rowType=='salary' || $ctrl.salaryRow.rowType=='monthlySalary'">{{$ctrl.salaryRow.price || 0}} € <span
          ng-if="$ctrl.salaryRow.rowType=='monthlySalary'" sxy-text="SALAXY.NG1.HouseholdUsecaseComponent.base.pricePerMonth"></span></span>

      <span ng-if="$ctrl.isHouseholdDeductible" sxy-text="SALAXY.NG1.HouseholdUsecaseComponent.base.isHouseholdDeductible"></span>

      <span class="result-text" ng-if="$ctrl.salaryRow.rowType=='hourlySalary' || $ctrl.salaryRow.rowType == 'unknown'">{{ ($ctrl.salaryRow.count || 0) * ($ctrl.salaryRow.price || 0) }}
        €</span>
      <span class="result-text" ng-if="$ctrl.salaryRow.rowType=='salary' || $ctrl.salaryRow.rowType=='monthlySalary'">{{ $ctrl.salaryRow.price || 0}} € </span>
    </p>
    <a class="btn-link btn-showmore" ng-click="showInfo = !showInfo"><span sxy-text="SALAXY.UI_Terms.showMore"></span><i class="bi bi-info-circle-fill"></i></a>
  </div>
  <div class="card-body">
    <p sxy-html="SALAXY.NG1.HouseholdUsecaseComponent.cleaning.shortInfoText.html"></p>
    <span class="collapse" ng-class="{show: showInfo}" sxy-html="SALAXY.NG1.HouseholdUsecaseComponent.cleaning.longInfoText.html"></span>
    <div class="form-horizontal">
      <salaxy-textarea ng-if="$ctrl.usecaseData.subType == 'other'" name="workTypeOtherMessage" label="SALAXY.NG1.HouseholdUsecaseComponent.base.workDescription" ng-model="$ctrl.usecaseData.workTypeOtherMessage" label-cols="col-sm-6"></salaxy-textarea>
      <salaxy-input-enum type="select" name="mainRowType" label="SALAXY.NG1.HouseholdUsecaseComponent.base.salaryKind" ng-model="$ctrl.salaryRow.rowType" options="{'salary':('SALAXY.ENUM.SalaryKind.salary.label'| sxyTranslate),'hourlySalary':('SALAXY.ENUM.SalaryKind.hourlySalary.label' | sxyTranslate),'monthlySalary':('SALAXY.ENUM.SalaryKind.monthlySalary.label' | sxyTranslate)}"
        ng-change="$ctrl.changeRowType()" label-cols="col-sm-6" required></salaxy-input-enum>
      <salaxy-input-number name="price" label="{{$ctrl.priceLabel}}" ng-model="$ctrl.salaryRow.price" label-cols="col-sm-6" required></salaxy-input-number>
      <salaxy-input-number ng-if="$ctrl.salaryRow.rowType == 'hourlySalary'" name="hours" label="SALAXY.NG1.HouseholdUsecaseComponent.base.hourCount" ng-model="$ctrl.salaryRow.count" required label-cols="col-sm-6"></salaxy-input-number>

      <salaxy-input-boolean name="isContractLessThanYear" label="SALAXY.NG1.HouseholdUsecaseComponent.cleaning.contractLastedLessThanYear" type="switch" ng-model="$ctrl.usecaseData.isContractLessThanYear" label-true="SALAXY.UI_Terms.yes" label-false="SALAXY.UI_Terms.no"
        label-cols="col-sm-6">
      </salaxy-input-boolean>
      <salaxy-input-boolean name="isFullTime" label="SALAXY.NG1.HouseholdUsecaseComponent.cleaning.fullTime" type="switch" ng-model="$ctrl.usecaseData.isFullTime" label-true="SALAXY.UI_Terms.yes" label-false="SALAXY.UI_Terms.no" label-cols="col-sm-6">
      </salaxy-input-boolean>

      <salaxy-input-boolean name="isHouseholdDeductible" label="SALAXY.NG1.HouseholdUsecaseComponent.base.householdDeduction" type="radio" ng-model="$ctrl.isHouseholdDeductible" label-true="SALAXY.NG1.HouseholdUsecaseComponent.base.householdDeductionTrue" label-false="SALAXY.NG1.HouseholdUsecaseComponent.base.householdDeductionFalse"
        label-cols="col-sm-6"></salaxy-input-boolean>
      <div ng-if="$ctrl.usecaseData.isFullTime" class="text-danger" sxy-html="SALAXY.NG1.HouseholdUsecaseComponent.cleaning.footnote.html"></div>
    </div>
  </div>

</div>`), s.put("salaxy-components/calc/usecases/household-construction.html", `<div>
  <div class="card-header construction">
    <span class="float-start">
      <div class="icon-wrapper salaxy-household-usecase-avatar">
        <div class="main-icon-wrapper">
          <img ng-src="{{$ctrl.usecaseData.icon}}">
        </div>
      </div>
    </span>
    <h1>{{$ctrl.usecaseData.label}}</h1>
    <p class="calc-text">
      <span ng-if="$ctrl.salaryRow.rowType=='hourlySalary' || $ctrl.salaryRow.rowType == 'unknown'">{{$ctrl.salaryRow.count || 0}} h x {{$ctrl.salaryRow.price || 0}}
        €</span>
      <span ng-if="$ctrl.salaryRow.rowType=='salary' || $ctrl.salaryRow.rowType=='monthlySalary'">{{$ctrl.salaryRow.price || 0}} € <span
          ng-if="$ctrl.salaryRow.rowType=='monthlySalary'"></span></span>
      <span sxy-text="SALAXY.NG1.HouseholdUsecaseComponent.construction.subtitlePlusExpenses"></span>
      <span ng-if="$ctrl.isHouseholdDeductible" sxy-text="SALAXY.NG1.HouseholdUsecaseComponent.base.isHouseholdDeductible"></span>
      <span class="result-text" ng-if="$ctrl.salaryRow.rowType=='hourlySalary' || $ctrl.salaryRow.rowType == 'unknown'">{{ ($ctrl.salaryRow.count || 0) * ($ctrl.salaryRow.price ||
        0) }}
        €</span>
      <span class="result-text" ng-if="$ctrl.salaryRow.rowType=='salary' || $ctrl.salaryRow.rowType=='monthlySalary'">{{ $ctrl.salaryRow.price || 0}} €</span>
    </p>
    <a class="btn-link btn-showmore" ng-click="showInfo = !showInfo"><span sxy-text="SALAXY.UI_Terms.showMore"></span><i class="bi bi-info-circle-fill"></i></a>
  </div>
  <div class="card-body">
    <p sxy-html="SALAXY.NG1.HouseholdUsecaseComponent.construction.shortInfoText.html"></p>
    <span class="collapse" ng-class="{show: showInfo}" sxy-html="SALAXY.NG1.HouseholdUsecaseComponent.construction.longInfoText.html"></span>
    <div class="form-horizontal">
      <salaxy-input-enum type="select" name="mainRowType" label="SALAXY.NG1.HouseholdUsecaseComponent.base.salaryKind" ng-model="$ctrl.salaryRow.rowType" options="{'salary':('SALAXY.ENUM.SalaryKind.salary.label'| sxyTranslate),'hourlySalary':('SALAXY.ENUM.CalculationRowType.hourlySalary.label' | sxyTranslate),'monthlySalary':('SALAXY.ENUM.CalculationRowType.monthlySalary.label' | sxyTranslate),'totalEmployerPayment':('SALAXY.ENUM.CalculationRowType.totalEmployerPayment.label' | sxyTranslate)}"
        ng-change="$ctrl.changeRowType()" label-cols="col-sm-6" required ng-change="$ctrl.submitHouseholdUsecase()"></salaxy-input-enum>
      <salaxy-input-number name="price" label="{{$ctrl.priceLabel}}" ng-model="$ctrl.salaryRow.price" label-cols="col-sm-6" required ng-change="$ctrl.submitHouseholdUsecase()"></salaxy-input-number>
      <salaxy-input-number ng-if="$ctrl.salaryRow.rowType == 'hourlySalary'" name="hours" label="SALAXY.NG1.HouseholdUsecaseComponent.base.hourCount" ng-model="$ctrl.salaryRow.count" required label-cols="col-sm-6" ng-change="$ctrl.submitHouseholdUsecase()"></salaxy-input-number>
      <salaxy-input-boolean name="isHouseholdDeductible" label="SALAXY.NG1.HouseholdUsecaseComponent.base.householdDeduction" type="radio" ng-model="$ctrl.isHouseholdDeductible" label-true="SALAXY.NG1.HouseholdUsecaseComponent.base.householdDeductionTrue" label-false="SALAXY.NG1.HouseholdUsecaseComponent.base.householdDeductionFalse"
        label-cols="col-sm-6" ng-change="$ctrl.submitHouseholdUsecase()"></salaxy-input-boolean>
      <div ng-if="$ctrl.salaryRow.rowType == 'totalEmployerPayment'" class="alert alert-info" sxy-text="SALAXY.NG1.HouseholdUsecaseComponent.base.totalEmployerPaymentAlert"></div>
      <div ng-if="$ctrl.salaryRow.rowType == 'salary'" class="alert alert-info" sxy-text="SALAXY.NG1.HouseholdUsecaseComponent.base.salaryAlert"></div>
      <div ng-if="$ctrl.salaryRow.rowType != 'totalEmployerPayment'">
        <salaxy-input-boolean name="isTesIncludedInSalary" label="SALAXY.NG1.HouseholdUsecaseComponent.base.tesInclusions" type="radio" ng-model="$ctrl.usecaseData.isTesIncludedInSalary" label-cols="col-sm-6" label-false="SALAXY.NG1.HouseholdUsecaseComponent.base.noCalcAuto"
          label-true="SALAXY.NG1.HouseholdUsecaseComponent.base.yesAgreedTotalPayment" ng-change="$ctrl.submitHouseholdUsecase()"></salaxy-input-boolean>
        <salaxy-input-boolean name="isExpensesCustom" label="SALAXY.NG1.HouseholdUsecaseComponent.construction.expensesCustom" type="radio" ng-model="$ctrl.usecaseData.isExpensesCustom" label-cols="col-sm-6" label-false="SALAXY.NG1.HouseholdUsecaseComponent.base.noByTes"
          label-true="SALAXY.NG1.HouseholdUsecaseComponent.base.yesAgreedPerDay" ng-change="$ctrl.submitHouseholdUsecase()"></salaxy-input-boolean>
        <salaxy-input-number ng-if="!$ctrl.usecaseData.isExpensesCustom" name="dailyTravelExpensesKm" label="SALAXY.NG1.HouseholdUsecaseComponent.construction.dailyTravelExpensesKm" ng-model="$ctrl.usecaseData.dailyTravelExpensesKm" label-cols="col-sm-6" ng-change="$ctrl.submitHouseholdUsecase()">
        </salaxy-input-number>
        <div ng-if="$ctrl.usecaseData.isExpensesCustom">
          <salaxy-input-number name="dailyExpenses" label="SALAXY.NG1.HouseholdUsecaseComponent.construction.dailyExpenses" ng-model="$ctrl.usecaseData.dailyExpenses" label-cols="col-sm-6" ng-change="$ctrl.submitHouseholdUsecase()"></salaxy-input-number>
          <salaxy-input-number name="dailyTravelExpenses" label="SALAXY.NG1.HouseholdUsecaseComponent.construction.dailyTravelExpenses" ng-model="$ctrl.usecaseData.dailyTravelExpenses" label-cols="col-sm-6" ng-change="$ctrl.submitHouseholdUsecase()"></salaxy-input-number>
          <div ng-if="!$ctrl.isReadOnly" class="alert alert-info" sxy-text="SALAXY.NG1.HouseholdUsecaseComponent.construction.taxFreeMilageAlert"></div>
        </div>
      </div>
      <salaxy-textarea ng-if="$ctrl.usecaseData.id == 'construction/new' || $ctrl.usecaseData.id == 'construction/renovation'" name="workTypeOtherMessage" label="SALAXY.NG1.HouseholdUsecaseComponent.base.workDescription" ng-model="$ctrl.usecaseData.workTypeOtherMessage"
        label-cols="col-sm-6">
      </salaxy-textarea>
    </div>
  </div>
</div>`), s.put("salaxy-components/calc/usecases/household-other.html", `<div>
  <div class="card-header cleaning">
    <span class="float-start">
      <div class="icon-wrapper salaxy-household-usecase-avatar">
        <div class="main-icon-wrapper">
          <img ng-src="{{$ctrl.usecaseData.icon}}">
        </div>
      </div>
    </span>
    <h1>{{$ctrl.usecaseData.label}}</h1>
    <p class="calc-text">
      <span ng-if="$ctrl.salaryRow.rowType=='hourlySalary' || $ctrl.salaryRow.rowType == 'unknown'">
        {{$ctrl.salaryRow.count || 0}} h x {{$ctrl.salaryRow.price || 0}} €</span>
      <span ng-if="!($ctrl.salaryRow.rowType=='hourlySalary' || $ctrl.salaryRow.rowType == 'unknown')">
        {{$ctrl.salaryRow.price || 0}} €
        <span ng-if="$ctrl.salaryRow.rowType=='monthlySalary'" sxy-text="SALAXY.NG1.HouseholdUsecaseComponent.base.pricePerMonth"></span>
      </span>
      <span ng-if="$ctrl.isHouseholdDeductible" sxy-text="SALAXY.NG1.HouseholdUsecaseComponent.base.isHouseholdDeductible"></span>
      <span class="result-text" ng-if="$ctrl.salaryRow.rowType=='hourlySalary' || $ctrl.salaryRow.rowType == 'unknown'">
        {{ ($ctrl.salaryRow.count || 0) * ($ctrl.salaryRow.price || 0) }} €
      </span>
      <span class="result-text" ng-if="!($ctrl.salaryRow.rowType=='hourlySalary' || $ctrl.salaryRow.rowType == 'unknown')">
        {{ $ctrl.salaryRow.price || 0}} €
      </span>
    </p>
    <a class="btn-link btn-showmore" ng-click="showInfo = !showInfo"><span sxy-text="SALAXY.UI_Terms.showMore"></span><i class="bi bi-info-circle-fill"></i></a>
  </div>
  <div class="card-body">
    <p sxy-html="SALAXY.NG1.HouseholdUsecaseComponent.base.shortInfoText.html"></p>
    <span class="collapse" ng-class="{show: showInfo}" sxy-html="SALAXY.NG1.HouseholdUsecaseComponent.base.longInfoText.html"></span>
    <div class="form-horizontal">

      <salaxy-input-enum type="select" name="mainRowType" label="SALAXY.NG1.HouseholdUsecaseComponent.base.salaryKind" placeholder="SALAXY.UI_Terms.select" ng-model="$ctrl.salaryRow.rowType" options="{salary:('SALAXY.ENUM.SalaryKind.salary.label'| sxyTranslate),hourlySalary:('SALAXY.ENUM.CalculationRowType.hourlySalary.label' | sxyTranslate),monthlySalary:('SALAXY.ENUM.CalculationRowType.monthlySalary.label' | sxyTranslate),totalEmployerPayment:('SALAXY.ENUM.CalculationRowType.totalEmployerPayment.label' | sxyTranslate)}"
        ng-change="$ctrl.changeRowType()" label-cols="col-sm-6" hidden-options="unknown" enum="CalculationRowType" required ng-change="$ctrl.submitHouseholdUsecase()"></salaxy-input-enum>


      <salaxy-input-number name="price" label="{{$ctrl.priceLabel}}" ng-model="$ctrl.salaryRow.price" label-cols="col-sm-6" required ng-change="$ctrl.submitHouseholdUsecase()"></salaxy-input-number>
      <salaxy-input-number ng-if="$ctrl.salaryRow.rowType == 'hourlySalary'" name="hours" label="SALAXY.NG1.HouseholdUsecaseComponent.base.hourCount" ng-model="$ctrl.salaryRow.count" required label-cols="col-sm-6" ng-change="$ctrl.submitHouseholdUsecase()"></salaxy-input-number>
      <salaxy-input-occupation-type name="occupationType" ng-model="$ctrl.usecaseData.occupation" label-cols="col-sm-6" label="SALAXY.NG1.WorkerWizardComponent.employment.work.occupationCode" require="$ctrl.usecaseData.id == 'construction/other'" ng-change="$ctrl.submitHouseholdUsecase()"></salaxy-input-occupation-type>

      <salaxy-input-boolean name="isHouseholdDeductible" label="SALAXY.NG1.HouseholdUsecaseComponent.base.householdDeduction" type="radio" ng-model="$ctrl.isHouseholdDeductible" label-true="SALAXY.NG1.HouseholdUsecaseComponent.base.householdDeductionTrue" label-false="SALAXY.NG1.HouseholdUsecaseComponent.base.householdDeductionFalse"
        label-cols="col-sm-6" ng-change="$ctrl.submitHouseholdUsecase()"></salaxy-input-boolean>
      <div ng-if="$ctrl.salaryRow.rowType == 'totalEmployerPayment'" class="alert alert-info" sxy-text="SALAXY.NG1.HouseholdUsecaseComponent.base.totalEmployerPaymentAlert"></div>
      <div ng-if="$ctrl.salaryRow.rowType == 'salary'" class="alert alert-info" sxy-text="SALAXY.NG1.HouseholdUsecaseComponent.base.salaryAlert"></div>
      <salaxy-input-enum label="SALAXY.NG1.HouseholdUsecaseComponent.base.taxDeductionCategories" hidden-options="none" label-cols="col-sm-6" name="taxDeductionCategories" ng-if="$ctrl.isHouseholdDeductible" ng-model="$ctrl.usecaseData.taxDeductionCategories"
        enum="TaxDeductionWorkCategories" type="select" required ng-change="$ctrl.submitHouseholdUsecase()"></salaxy-input-enum>

      <salaxy-textarea name="message" label="SALAXY.NG1.HouseholdUsecaseComponent.base.salaryMessage" ng-model="$ctrl.salaryRow.message" label-cols="col-sm-6">
      </salaxy-textarea>
    </div>
  </div>
</div>`), s.put("salaxy-components/communications/ContactInfo.html", `<div class="salaxy-component salaxy-contact-info">
  <div class="row contact-info-row">
    <div class="salaxy-alert col-12">
      <div class="alert alert-primary">
        <div class="icon-container hidden-xxs">
          <span class="icon">
            <i class="bi bi-question-lg"></i>
          </span>
        </div>
        <div class="contact-info-text" ng-if="!$ctrl.showShortContent">
          <p ng-if="!$ctrl.hideContactInfo" sxy-html="SALAXY.NG1.ContactInfoComponent.contactInfo.html"></p>
          <p sxy-html="SALAXY.NG1.ContactInfoComponent.defaultContent.html"></p>
        </div>
        <div class="contact-info-text" ng-if="$ctrl.showShortContent">
          <p sxy-html="SALAXY.NG1.ContactInfoComponent.shortContent.html"></p>
        </div>
      </div>
    </div>
  </div>
</div>`), s.put("salaxy-components/communications/messages/message-types/ExpenseReport.html", `<salaxy-calc-rows-editor dimensions="$ctrl.crudController.employingRelation.settings.costAccounting.dimensions" row-types="$ctrl.getRowTypes()" parent="$ctrl.getCalcRowMessage().contentData"></salaxy-calc-rows-editor>
<button type="button" ng-disabled="$ctrl.crudController.isNew()" class="btn btn-primary btn-labeled-left" style="width: 20%; text-align: left; margin-bottom: 4px" ngf-select="$ctrl.crudController.uploadFiles($files)" ngf-multiple="true" ngf-max-size="10MB" xxngf-pattern="$ctrl.crudController.supportedFilesPattern"><i class="bi bi-paperclip" style="width: 38px"></i>
  <span sxy-text="SALAXY.NG1.MessageThreadComponent.fileBtn"></span>
</button>
<div class="row" style="margin-top: 10px;" ng-repeat="item in $ctrl.list">
  <div ng-switch="item.type">
    <div ng-switch-when="blobFile" style="min-width: 600px">
      <div ng-if="item.showPreview">
        <div class="float-end">
          <button type="button" class="btn btn-default btn-xs" ng-click="item.showPreview=false" sxy-text="SALAXY.UI_Terms.close"></button>
          <a class="btn btn-default btn-xs" ng-href="{{$ctrl.crudController.getFileInfo(item).downloadUrl}}" target="_blank" sxy-text="SALAXY.UI_Terms.download"></a>
        </div>
        <div style="font-weight: bold;font-size: 1.5em;">{{ item.content }}</div>
        <img class="img-responsive img-thumbnail" ng-src="{{$ctrl.crudController.getFileInfo(item).previewUrl}}" />
      </div>
      <div ng-if="!item.showPreview">
        <div class="float-start" style="margin-right: 10px;max-height: 100px; overflow-y:hidden;" ng-if="$ctrl.crudController.getFileInfo(item).previewUrl">
          <img ng-src="{{$ctrl.crudController.getFileInfo(item).previewUrl}}" class="img-thumbnail" style="max-width: 200px;" />
        </div>
        <i ng-if="!$ctrl.crudController.getFileInfo(item).previewUrl" class="bi {{ $ctrl.crudController.getFileInfo(item).icon }} text-primary float-start" aria-hidden="true" style="font-size: 104px; font-weight: bold"></i>
        <div style="font-weight: bold; font-size: 1.5em;">{{ item.content }}</div>
        <div>
          <button type="button" class="btn btn-default btn-xs" ng-click="item.showPreview=true" ng-if="$ctrl.crudController.getFileInfo(item).previewUrl" sxy-text="SALAXY.UI_Terms.seePreviewAlt"></button>
          <a class="btn btn-default btn-xs" ng-href="{{$ctrl.crudController.getFileInfo(item).downloadUrl}}" target="_blank" sxy-text="SALAXY.UI_Terms.download"></a>
        </div>
      </div>
    </div>
  </div>
  
</div>`), s.put("salaxy-components/communications/messages/message-types/HourlyReport.html", `<div class="salaxy-component salaxy-hourly-report">
  <div class="list-group">
    <div class="list-group-item bg-primary">
      <h4 class="list-group-item-heading text-center">
        <div ng-if="$ctrl.reportType === 'hourlyReport'">Tuntiraportti</div>
        <div ng-if="$ctrl.reportType === 'timeReport'">Työaikaraportti</div>
        <i ng-click="$ctrl.changeWeek(false)" class="bi bi-arrow-left-circle-fill bi-2x float-start" aria-hidden="true"></i>
        <i ng-click="$ctrl.changeWeek(true)" class="bi bi-arrow-right-circle-fill bi-2x float-end" aria-hidden="true"></i>
        <div>Viikko {{$ctrl.currentWeekNumber}}</div>
        <div>{{$ctrl.firstDayOfCurrentWeekFormatted}} - {{$ctrl.lastDayOfCurrentWeekFormatted}}</div>
      </h4>
    </div>
    <div class="list-group-item" ng-repeat="day in $ctrl.currentWeek">
      <div class="text-center float-start text-uppercase week-icon" ng-class="$ctrl.getDateStyle(day.date)">
        {{ day.dayName }}<br> {{ day.displayDate }}
      </div>
      <div class="float-end" style="margin-top: 6px">
        <button ng-if="$ctrl.showExpandButton(day.date)" ng-click="$ctrl.setHourlyRecordsVisible(day.date)" type="button" class="btn btn-default">
          <i class="bi" ng-class="{'bi-chevron-up' : !day.isCollapsed,  'bi-chevron-down' : day.isCollapsed}"></i>
        </button>
        <button ng-click="$ctrl.showEditDialog($ctrl.getEditDialogItem(day.date), true)" type="button" class="btn btn-default"><i class="bi bi-plus-lg"></i></button>
      </div>
      <p class="list-group-item-text">{{$ctrl.countDailyHours(day.date) | sxyTotalTime : "minutes"}}</p>
      <div ng-if="!day.isCollapsed">
        <div ng-if="$ctrl.reportType == 'hourlyReport'" style="margin-bottom: 5px;" ng-repeat="message in $ctrl.list | filter: { contentData: {period: {start: day.date}} }">
          <div>
            <span style="padding-top: 2px;"><strong>{{$ctrl.getDimensionOptionText(message.contentData.project)}}</strong> ({{message.contentData.totalTime | sxyTotalTime : "minutes"}} h)</span><br>
            <span class="small text-overflow-80pc" style="padding-top: 2px;">{{message.contentData.projectText}}</span>
            <div class="float-end">
              <button ng-click="$ctrl.showEditDialog(message, false)" type="button" class="btn btn-default btn-xs"><i class="bi bi-pencil-fill"></i></button>
            </div>
          </div>
        </div>
        <div ng-if="$ctrl.reportType == 'timeReport'" style="margin-bottom: 5px;" ng-repeat="message in $ctrl.list | filter: { contentData: {period: {start: day.date}} }">
          <div>
            <span style="padding-top: 2px;"><strong>{{message.contentData.project}}</strong> ({{message.contentData.startTime | date:'HH:mm'}} - {{message.contentData.endTime | date:'HH:mm'}})</span><br>
            <span class="small text-overflow-80pc" style="padding-top: 2px;">{{message.contentData.projectText}}</span>
            <div class="float-end">
              <button ng-click="$ctrl.showEditDialog(message, false)" type="button" class="btn btn-default btn-xs"><i class="bi bi-pencil-fill"></i></button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="list-group-item">
      <h4 class="list-group-item-heading">
        <div class="text-center float-start text-uppercase btn btn-default week-icon">
          <small>Viikko</small><br> {{$ctrl.currentWeekNumber}}
        </div>
        <div class="float-end" style="margin-top: 10px">Yhteensä</div>
        <p class="list-group-item-text" style="height: 40px; padding-left: 80px; padding-top: 10px;">{{$ctrl.weeklyHours | sxyTotalTime : "minutes"}}</p>
      </h4>
    </div>
  </div>
</div>`), s.put("salaxy-components/communications/messages/message-types/Timer.html", `<div class="salaxy-component salaxy-timer">
  <div ng-if="$ctrl.timerMode == 'mini'">
    <div class="card card-panel panel-solid" ng-class="$ctrl.isTimerOnFromDayBefore ? 'panel-warning' : 'panel-primary'">
      <div class="card-header">
        <div class="float-start icon-container" style="padding-left: 0;">
          <i class="bi " ng-class="$ctrl.isTimerOn ? 'bi-exclamation-lg' : 'bi-clock'">
          </i>
        </div>
        <h3 class="card-title">Olet leimannut sisään kellokorttiin</h3>
        <div class="date">{{$ctrl.getTimerMessage().contentData.period.start | date : "d.M.yyyy"}}</div>
      </div>
      <div class="card-content card-body">
        <div class="text-center">
          <div class="otherparty-container">
            <salaxy-avatar avatar="$ctrl.parent.ownerInfo"></salaxy-avatar>
            <span>{{$ctrl.parent.ownerInfo.displayName}}</span>
          </div>
          <div class="clock-text card-main text-white">
            <i class="bi bi-clock" aria-hidden="true"></i> {{ $ctrl.getTimerMessage().contentData.totalTimeInSeconds | sxyTotalTime : "seconds"}}
          </div>
          <div class="card-details-title" ng-if="$ctrl.getTimerMessage().contentData.project">
            
            {{$ctrl.getDimensionOptionText($ctrl.getTimerMessage().contentData.project)}}
          </div>
          <span ng-if="$ctrl.getTimerMessage().contentData.projectText" class="card-details">
            {{$ctrl.getTimerMessage().contentData.projectText}}
          </span>
        </div>

      </div>
      <div class="card-footer">
        <button ng-click="$ctrl.crudController.showDetails($ctrl.parent)" class="btn btn-sm btn-white">Muokkaa</button>
      </div>
    </div>
  </div>

  <div ng-if="$ctrl.timerMode != 'mini' && $ctrl.timerMode != 'edit'">
    <div class="thumbnail thumbnail-timer">
      <form name="timerForm">

        <div class="text-center timer-container" ng-class="$ctrl.isTimerOnFromDayBefore ? 'bg-warning' : 'bg-primary'">
          <h3>Kellokortti</h3>
          <div class="clock-text">
            <i class="bi bi-clock" aria-hidden="true"></i> {{$ctrl.getTimerMessage().contentData.totalTimeInSeconds | sxyTotalTime : "seconds"}}
          </div>
          <div class="text-center form-inline">
            Aloitus:
            <span ng-if="!$ctrl.editStartTime" class="timer-time-input-read-only">{{ $ctrl.getTimerMessage().contentData.startTime}}</span>
            <salaxy-input-time ng-if="$ctrl.editStartTime" name="startTime" label="Työaika" type="time" ng-model="$ctrl.getTimerMessage().contentData.startTime"></salaxy-input-time>
            <button type="button" class="btn btn-sm btn-transparent" ng-click="$ctrl.editStartTime=!$ctrl.editStartTime"><i class="bi bi-pencil-fill"></i></button>
          </div>
          <div>Yhteensä tänään {{ $ctrl.getAndFormatTotal()}}</div>
          <div style="padding: 10px;">
            <div ng-if="$ctrl.crudController.employingRelation.settings.costAccounting.dimensions"  ng-controller="CostAccountingController as $cost" ng-init="$cost.dimensions=$ctrl.crudController.employingRelation.settings.costAccounting.dimensions">
              <salaxy-input-typeahead ng-if="$cost.getDefinition('lk1')"  label-type="plain" placeholder="{{($cost.getDefinition('lk1').label || 'SALAXY.NG1.CalcCostAccountingComponent.defaultLabel') | sxyTranslate}}" label-format="text-value" name="options_project" ng-model="$ctrl.getTimerMessage().contentData.project" options="$cost.getDefinition('lk1').options" required="true"></salaxy-input-typeahead>
            </div>
            <salaxy-input label-type="plain" placeholder="Kommentti"  name="comment" ng-model="$ctrl.getTimerMessage().contentData.projectText" class="timer-comment-input"></salaxy-input>
          </div>
          <div>
            <button ng-if="!$ctrl.isTimerOn" class="btn btn-lg btn-primary btn-timer-start" ng-click="$ctrl.startTimer()">
          <i class="bi bi-play-fill bi-2x"></i>
        </button>
            <button ng-if="$ctrl.isTimerOn" class="btn btn-lg btn-danger btn-timer-stop" ng-click="$ctrl.stopTimer()">
          <i class="bi bi-stop-fill bi-2x"></i>
        </button>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div ng-if="$ctrl.timerMode != 'mini' && $ctrl.list.length" class="list-group list-group-timer">
    <div class="list-group-item item-today">
      <div class="list-group-item-heading">
        TÄNÄÄN, {{ "today" | sxyDate }}
      </div>
    </div>
    <div class="list-group-item" ng-repeat="message in $ctrl.list">
      <div class="list-group-item-heading">
        <div class="float-end">
          {{ message.contentData.totalTime | sxyTotalTime : "minutes"}} h
          <button type="button" class="btn btn-xs btn-transparent" ng-click="$ctrl.showEditDialog(message, false)"><i class="bi bi-pencil-fill"></i></button>
        </div>
        {{ message.contentData.startTime}}-{{ message.contentData.endTime}}
        <br>
      </div>
     <!--  <div class="float-end">
        <button type="button" class="btn btn-xs btn-transparent" ng-click="$ctrl.showEditDialog(message, false)"><i class="bi bi-pencil-fill"></i></button>
      </div> -->
      <p class="list-group-item-text">{{ $ctrl.getDimensionOptionText(message.contentData.project) }}</p>
      <p class="list-group-item-text" ng-if="message.contentData.projectText">{{ message.contentData.projectText }}</p>
      <salaxy-validation-summary api-validation="message.validation" layout="minimal" class="text-danger"></salaxy-validation-summary>
    </div>
    <div class="list-group-item list-group-item-footer text-end">
      <button class="btn btn-sm btn-primary" ng-click="$ctrl.showEditDialog('new', true)">Lisää uusi merkintä <span class="bi bi-plus-lg"></span></button>
    </div>
    <div class="list-group-item list-group-item-footer">
      <div class="float-end">{{ $ctrl.getAndFormatTotal() }}</div>
      Yhteensä
    </div>
  </div>

</div>`), s.put("salaxy-components/communications/messages/MessageContent.html", `<div ng-switch="item.type">
  <div ng-switch-when="blobFile" style="min-width: 600px">
    <div ng-if="item.showPreview">
      <div class="float-end">
        <button type="button" class="btn btn-default btn-xs" ng-click="item.showPreview=false" sxy-text="SALAXY.UI_Terms.close"></button>
        <a class="btn btn-default btn-xs" ng-href="{{$ctrl.getFileInfo(item).downloadUrl}}" target="_blank" sxy-text="SALAXY.UI_Terms.download"></a>
      </div>
      <div style="font-weight: bold;font-size: 1.5em;">{{ item.content }}</div>
      <img class="img-fluid img-thumbnail" ng-src="{{$ctrl.getFileInfo(item).previewUrl}}" />
    </div>
    <div ng-if="!item.showPreview">
      <div class="float-start" style="margin-right: 10px;max-height: 100px; overflow-y:hidden;" ng-if="$ctrl.getFileInfo(item).previewUrl">
        <img ng-src="{{$ctrl.getFileInfo(item).previewUrl}}" class="img-thumbnail" style="max-width: 200px;" />
      </div>
      <i ng-if="!$ctrl.getFileInfo(item).previewUrl" class="bi {{ $ctrl.getFileInfo(item).icon }} text-primary float-start" aria-hidden="true" style="font-size: 104px; font-weight: bold"></i>
      <div style="font-weight: bold; font-size: 1.5em;">{{ item.content }}</div>
      <div>
        <button type="button" class="btn btn-default btn-xs" ng-click="item.showPreview=true" ng-if="$ctrl.getFileInfo(item).previewUrl" sxy-text="SALAXY.UI_Terms.seePreviewAlt"></button>
        <a class="btn btn-default btn-xs" ng-href="{{$ctrl.getFileInfo(item).downloadUrl}}" target="_blank" sxy-text="SALAXY.UI_Terms.download"></a>
      </div>
    </div>
  </div>
  <div ng-switch-when="calculation" ng-controller="CalculationCrudController as $calcCtrl" ng-init="$calcCtrl.model=(item.contentId || item.content)">
    <salaxy-spinner ng-if="$calcCtrl.isLoading"></salaxy-spinner>
    <div ng-if="$calcCtrl.current">
      <div>
        <table class="table table-borderless bg-transparent">
          <tbody>
            <tr>
              <td class="td-avatar middle">
                <salaxy-avatar avatar="$calcCtrl.current.worker.avatar"></salaxy-avatar>
              </td>
              <td class="td-name middle">
                <span ng-if="!$calcCtrl.current.worker.avatar.displayName" sxy-text="SALAXY.NG1.MessageThreadComponent.messageContent.notSelected"></span>
                <strong>{{$calcCtrl.current.worker.avatar.displayName}}</strong><br /> {{ "SALAXY.ENUM.CalculationStatus." + $calcCtrl.current.workflow.status + ".label" | sxyTranslate }} {{$calcCtrl.current.workflow.paidAt | date}}
              </td>
              <td class="right middle">
                <span sxy-text="SALAXY.NG1.MessageThreadComponent.messageContent.salary" ps=":"></span> {{ $calcCtrl.current.result.totals.totalGrossSalary | currency }}<br /> <span sxy-text="SALAXY.NG1.MessageThreadComponent.messageContent.payment" ps=":"></span>                {{ $calcCtrl.current.result.employerCalc.totalPayment | currency }}
              </td>
              <td class="middle">
                <a ng-href="{{$calcCtrl.getPdfUrl($calcCtrl.current)}}" target="_blank" class="btn btn-sm btn-primary btn-block" sxy-text="SALAXY.NG1.MessageThreadComponent.messageContent.report"></a>
              </td>
              <td class=" middle">
                <a ng-href="#/calc/details/{{ $calcCtrl.current.id }}" class="btn btn-sm btn-default btn-block">
                  {{ $calcCtrl.current.workflow.status == 'draft' ? ('SALAXY.NG1.MessageThreadComponent.messageContent.editPay' |sxyTranslate) : ('SALAXY.NG1.MessageThreadComponent.messageContent.showCalc' |sxyTranslate) }}
                </a>
                <a ng-if="$calcCtrl.current.data.payrollId" class="btn btn-sm btn-primary btn-block" ng-href="#/payroll/details/{{ $calcCtrl.current.data.payrollId }}">
                  <i class="bi bi-list-task d-sm-none d-inline-block"></i>
                  <span class="d-none d-sm-inline-block" sxy-text="SALAXY.NG1.MessageThreadComponent.messageContent.payroll"></span>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <!-- TODO: change the preview to be based on index not on actual object -->
  <div ng-switch-when="payroll" ng-controller="PayrollCrudController as $payrollCtrl" ng-init="$payrollCtrl.model=(item.contentId || item.content)">
    <salaxy-spinner ng-if="$payrollCtrl.isLoading"></salaxy-spinner>
    <div ng-if="$payrollCtrl.current">
      <div>
        <table class="table table-borderless bg-transparent">
          <tbody>
            <tr>
              <td class="middle salaxy-component salaxy-payroll">
                <div class="payroll-info-row" style="margin-top:0px">
                  <salaxy-avatar-placeholder class="payroll-avatar">
                    <i class="salaxy-avatar bi bi-square-fill d-flex" style="color:#FDC338;">
                      <div class="avatar-text-wrapper">
                        <strong>{{ $payrollCtrl.calcs.length }}</strong>
                        <small>{{ $payrollCtrl.current.info.salaryDate | date : "d.M." }}</small>
                      </div>
                    </i>
                  </salaxy-avatar-placeholder>
                </div>
              </td>
              <td class="td-name middle">
                <strong>{{$payrollCtrl.current.input.title}}</strong><br /> {{ "SALAXY.ENUM.PayrollStatus." + $payrollCtrl.current.info.status + ".label" | sxyTranslate }}
              </td>
              <td class="right middle">
                <span sxy-text="SALAXY.NG1.MessageThreadComponent.messageContent.salary" ps=":"></span> {{ $payrollCtrl.info.totalGrossSalary | currency }}<br /> <span sxy-text="SALAXY.NG1.MessageThreadComponent.messageContent.payment" ps=":"></span>                {{ $payrollCtrl.info.totalPayment | currency }}
              </td>
              <td class="middle">
                <a ng-href="{{$payrollCtrl.getPdfUrl()}}" target="_blank" class="btn btn-sm btn-default btn-block" sxy-text="PDF"></a>
              </td>
              <td class=" middle">
                <a ng-href="#/payroll/details/{{ $payrollCtrl.current.id }}" class="btn btn-sm btn-primary btn-block">
                  {{ $payrollCtrl.current.info.status == 'draft' ? ('SALAXY.UI_Terms.edit' |sxyTranslate) : ('SALAXY.UI_Terms.show' |sxyTranslate) + " &raquo;"   }}
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div ng-switch-when="text">
    <div class="message-content" ng-if="!$ctrl.isInEdit">{{ item.content }}</div>
    <div ng-if="$ctrl.isInEdit">
      <textarea ng-model="item.content"></textarea>
    </div>
  </div>
  <div ng-switch-when="email">
    <div class="message-content">
      <span sxy-text="SALAXY.NG1.MessageThreadComponent.messageContent.toEmail" ps=":"></span> <a href="mailto:{{ item.content }}">{{ item.content }}</a>
    </div>
  </div>
  <div ng-switch-when="absence">
    <salaxy-absence-periods parent="item.contentData" condensed="true"></salaxy-absence-periods>
  </div>
  <div ng-switch-default class="alert alert-danger">
    {{ item.type }}: {{ item.content }}
  </div>
  <div class="edit-toolbar btn-toolbar" role="toolbar" ng-if="$ctrl.isInEdit">
    <div class="btn-group" role="group">
      <button class="btn btn-xs btn-danger" ng-click="$ctrl.deleteMessage(item)" sxy-text="SALAXY.UI_Terms.delete"></button>
      <button class="btn btn-xs btn-primary" ng-click="$ctrl.markItemAsRead(item, true)" ng-if="!$ctrl.getReadTime(item)" sxy-text="SALAXY.NG1.MessageThreadComponent.markAsReadBtn"></button>
      <button class="btn btn-xs btn-primary" ng-click="$ctrl.markItemAsRead(item, false)" ng-if="$ctrl.getReadTime(item)" sxy-text="SALAXY.NG1.MessageThreadComponent.markAsUnreadBtn"></button>
    </div>
  </div>
</div>`), s.put("salaxy-components/communications/messages/proto-usecase/calc.html", "<h1>calc here</h1>"), s.put("salaxy-components/communications/messages/proto-usecase/default.html", `<div ng-if="$ctrl.isNew()">
  <salaxy-input name="title" label="SALAXY.NG1.MessageThreadComponent.title" require="true" ng-model="$ctrl.current.title"></salaxy-input>
  <salaxy-form-group label="" name="submit" class="no-colon">
    <button type="submit" class="btn btn-primary" ng-disabled="!newMessageThread.$valid" ng-click="$ctrl.save()"
      sxy-text="SALAXY.NG1.MessageThreadComponent.ui.newMessageThreadBtn"></button>
  </salaxy-form-group>
</div>
<div ng-if="!$ctrl.isNew()"> 
  <p ng-if="$ctrl.current.messages.length == 0">&nbsp;</p>
  <div class="messages-container" ng-if="$ctrl.current.messages">
    <div ng-repeat="item in $ctrl.current.messages" ng-switch="item.fromParty">
      <div ng-switch-when="owner,undefined" ng-switch-when-separator=",">
        <salaxy-avatar avatar="$ctrl.current.ownerInfo" class="float-start"></salaxy-avatar>
        <div class="message-bubble left" ng-class="{ 'in-edit': $ctrl.isInEdit, 'unread': !$ctrl.getReadTime(item)  }">
          <ng-include src="'salaxy-components/communications/messages/MessageContent.html'"></ng-include>
          <span class="updated-at">{{ item.time | sxyTime }}, {{ $ctrl.getReadTime(item) ? (('SALAXY.NG1.MessageThreadComponent.read' |sxyTranslate) + ' ' + ($ctrl.getReadTime(item) |
            sxyTime)) : ('SALAXY.NG1.MessageThreadComponent.unread' |sxyTranslate) }}</span>
        </div>
      </div>
      <div ng-switch-when="otherParty" class="text-end">
        <salaxy-avatar avatar="$ctrl.current.otherPartyInfo" class="float-end"></salaxy-avatar>
        <div class="message-bubble right {{item.type}}" ng-class="{ 'in-edit': $ctrl.isInEdit, 'unread': !$ctrl.getReadTime(item) }">
          <ng-include src="'salaxy-components/communications/messages/MessageContent.html'"></ng-include>
          <span class="updated-at" ng-if="item.type != 'email'">{{ item.time | sxyTime }}, {{ $ctrl.getReadTime(item) ? (('SALAXY.NG1.MessageThreadComponent.read' |sxyTranslate) + ' ' +
            ($ctrl.getReadTime(item) | sxyTime)) : ('SALAXY.NG1.MessageThreadComponent.unread' |sxyTranslate)}}</span>
          <span class="updated-at" ng-if="item.type == 'email'">{{ item.time | sxyTime }}</span>
        </div>
      </div>
      <div ng-switch-default class="alert alert-danger">
        <ng-include src="'salaxy-components/communications/MessageThread_MessageContent.html'"></ng-include>
      </div>
    </div>
    <div class="padding">
      <div ng-if="$ctrl.isReadOnly" class="alert alert-info">
        <p>
          <strong>Viestiketju on suljettu</strong>
          <!-- TODO: Onko reopen mahdollinen myös työntekijälle? -->
        </p>
      </div>
      <div class="row" ng-if="!$ctrl.isReadOnly">
        <div class="col-8 col-sm-9" ng-switch="$ctrl.newMessage.type">
          <div ng-switch-when="absence">
            <salaxy-absence-periods parent="$ctrl.newMessage.contentData" condensed="true"></salaxy-absence-periods>
          </div>
          <div ng-switch-when="annualLeave">
            <salaxy-holiday-year-holidays parent="$ctrl.newMessage.contentData" condensed="true"></salaxy-holiday-year-holidays>
          </div>
          <textarea ng-switch-default placeholder="{{'SALAXY.NG1.MessageThreadComponent.writeOrPaste' |sxyTranslate}}" ng-model="$ctrl.newMessage.content"></textarea>
        </div>
        <div class="col-4 col-sm-3" ng-if="!$ctrl.isReadOnly">
          <button type="button" class="btn btn-primary btn-labeled-left test-start" style="width: 100%;  margin-bottom: 4px" ng-click="$ctrl.sendMessage()"
            ng-disabled="!$ctrl.newMessage.content">
            <i class="bi bi-send-fill"></i>
            <span sxy-text="SALAXY.UI_Terms.send"></span>
          </button>
          <button type="button" class="btn btn-primary btn-labeled-left text-start" style="width: 100%;  margin-bottom: 4px" ngf-select="$ctrl.uploadFiles($files)"
            ngf-multiple="true" ngf-max-size="10MB">
            <i class="bi bi-paperclip"></i>
            <span sxy-text="SALAXY.NG1.MessageThreadComponent.fileBtn"></span>
          </button>
          <div class="btn-group btn-block dropup">
            <button type="button" class="btn btn-secondary dropdown-toggle btn-labeled-left text-start mt-1 w-100" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <i class="bi bi-chevron-up"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.NG1.MessageThreadComponent.moreFeaturesBtn"></span>
            </button>
            <ul class="dropdown-menu dropdown-menu-end" role="menu">
              <li role="menuitem">
                <a ng-click="$ctrl.delete(null, ('SALAXY.NG1.MessageThreadComponent.deleteThreadAlert' | sxyTranslate ))" class="dropdown-item" sxy-text="SALAXY.NG1.MessageThreadComponent.deleteThread"></a>
              </li>
              <li role="separator" class="divider"></li>
              <li role="menuitem">
                <a ng-click="$ctrl.setType('absence')" class="dropdown-item">Lisää poissaoloja</a>
              </li>
              <li role="menuitem">
                <a ng-click="$ctrl.setType('annualLeave')" class="dropdown-item">Lisää lomapyyntö</a>
              </li>
              <li role="menuitem">
                <a ng-click="$ctrl.setType('calcRow')" class="dropdown-item">Lisää palkkarivejä</a>
              </li>
              <li role="menuitem">
                <a ng-click="$ctrl.setType('text')" class="dropdown-item">Teksti tai tiedosto (oletus)</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div id="messageContainerBottom">&nbsp;</div>
  </div>
</div>
`), s.put("salaxy-components/communications/messages/proto-usecase/expenses.html", "<h1>Kulukorvaukset tänne</h1>"), s.put("salaxy-components/communications/messages/proto-usecase/timer.html", `<div>
  <h3>Kellokortti</h3>
    <div class="thumbnail" style="max-width:400px; height: 320px; margin: auto;" >
      <div style="width: 100%; height: 100%;" class="bg-primary text-center">
        <div style="font-size: 3.5em; padding-top: 20px;">
          <i class="bi bi-clock" aria-hidden="true"></i>
          {{ $ctrl.currentEntry.total | date : "HH:mm:ss" : "UTC" }}
        </div>
        <div class="d-flex justify-content-center">
          Aloitus: 
          <span ng-if="!$ctrl.editStartTime">{{ $ctrl.currentEntry.start | date : "HH:mm" }}</span>
          <input ng-if="$ctrl.editStartTime" class="form-control input-sm" style="display: inline;width: 100px;" type="time" id="appt" name="appt" ng-model="$ctrl.currentEntry.start" ng-model-options="{allowInvalid: true, debounce: 1000}" required>
          <button type="button" class="btn btn-xs btn-primary" ng-click="$ctrl.editStartTime=!$ctrl.editStartTime"><i class="bi bi-pencil-fill"></i></button>
        </div>
        <div>Yhteensä tänään 01:20</div>
        <div style="padding: 10px;">
          <salaxy-input-typeahead label="Valitse projekti" placeholder="Valitse projekti" label-type="plain" name="project" ng-model="$ctrl.currentEntry.project" options="$ctrl.projects"></salaxy-input-typeahead>
          <salaxy-input placeholder="Kommentti" label-type="plain" name="comment" ng-model="$ctrl.currentEntry.comment"></salaxy-input>
        </div>
        <div>
          <a ng-if="!$ctrl.currentEntry.isStarted" class="btn btn-lg btn-success" href="" ng-click="$ctrl.startTimer()">
            <i class="bi bi-play-fill bi-2x"></i>
          </a>
          <a ng-if="$ctrl.currentEntry.isStarted" class="btn btn-lg btn-danger" href="" ng-click="$ctrl.stopTimer()">
            <i class="bi bi-stop-fill bi-2x"></i>
          </a>
        </div>
      </div>
    </div>
    <div class="list-group">
      <div class="list-group-item" style="margin-top: 10px;padding-bottom: 0px" ng-if="$ctrl.entries.length">
        <div class="list-group-item-heading">
          TÄNÄÄN, {{ "today" | sxyDate }}
        </div>
      </div>
      <a href="" class="list-group-item" ng-repeat="entry in $ctrl.entries">
        <h4 class="list-group-item-heading">
          <div class="float-end">{{ entry.total | date : "HH:mm" : "UTC" }}</div>
          {{ entry.start | date : "HH:mm" }}-{{ entry.end | date : "HH:mm" }}
        </h4>
        <div class="float-end">
          <button type="button" class="btn btn-xs btn-primary"><i class="bi bi-pencil-fill"></i></button>
          <button type="button" class="btn btn-xs btn-danger"><i class="bi bi-trash-fill"></i></button>
        </div>
        <p class="list-group-item-text">{{ $ctrl.getProjectText(entry.project) }}</p>
        <p class="list-group-item-text" ng-if="entry.comment">{{ entry.comment }}</p>
      </a>
      <div class="list-group-item" style="" ng-if="$ctrl.entries.length">
        <div class="list-group-item-footer">
          <div class="float-end">{{ $ctrl.getTotal() | date : "HH:mm" : "UTC" }}</div>
          Yhteensä
        </div>
      </div>
    </div>
    <pre>{{ $ctrl.current | json }}</pre>
</div>`), s.put("salaxy-components/communications/messages/proto-usecase/timesheet.html", `<div>
  <h3>Tuntiraportti</h3>
  <div class="list-group">
    <div class="list-group-item bg-primary">
      <h4 class="list-group-item-heading text-center">
        <div>Viikko 18</div>
        <i class="bi bi-arrow-left-circle-fill float-start" aria-hidden="true"></i>
        <i class="bi bi-arrow-right-circle-fill float-end" aria-hidden="true"></i>
        <div>2.-8.5.2022</div>
      </h4>
    </div>
    <div class="list-group-item" ng-repeat="day in $ctrl.calendarDemoData">
      <h4 class="list-group-item-heading">
        <div class="text-center float-start text-uppercase" ng-class="day.isHoliday ? 'btn btn-default' : 'bg-primary'" style="margin-left: -10px;margin-top:-5px;height: 55px; padding-top: 10px;width: 60px;">
          {{ day.day }}<br>
          {{ day.date }}
        </div>
        <div class="float-end" style="margin-top: 6px">
          <button type="button" class="btn btn-default"><i class="bi bi-pencil-fill"></i></button>
          <button type="button" class="btn btn-default"><i class="bi bi-plus-lg"></i></button>
        </div>
        <p class="list-group-item-text" style="height: 40px; padding-left: 80px; padding-top: 10px;">{{ day.hours }}</p>
      </h4>
    </div>
    <div class="list-group-item">
      <h4 class="list-group-item-heading">
        <div class="text-center float-start text-uppercase btn btn-default" style="margin-left: -10px;margin-top:-5px;height: 55px; padding-top: 10px;width: 60px;">
          <small>Viikko</small><br>
          18
        </div>
        <div class="float-end" style="margin-top: 10px">yhteensä</div>
        <p class="list-group-item-text" style="height: 40px; padding-left: 80px; padding-top: 10px;">15:00 h</p>
      </h4>
    </div>
  </div>
</div>`), s.put("salaxy-components/communications/messages/proto-usecase/travel.html", "<h1>Travel here</h1>"), s.put("salaxy-components/communications/MessageThread.html", `<div class="salaxy-component salaxy-message-thread">
  <salaxy-spinner ng-if="$ctrl.isLoading"></salaxy-spinner>
  <div ng-if="$ctrl.status == 'loadError'" class="alert alert-danger" sxy-text="SALAXY.NG1.MessageThreadComponent.error"></div>
  <div>
    <!-- ng-transclude does not work in include -->
    <div ng-if="$ctrl.isNew()">
      <form name="newMessageThread" ng-readonly="$ctrl.isReadOnly" class="form-horizontal">
        <ng-transclude ng-transclude-slot="headerNew">
          <h1 sxy-text="SALAXY.NG1.MessageThreadComponent.newMessage.headerTitle"></h1>
          <p class="lead" sxy-html="SALAXY.NG1.MessageThreadComponent.newMessage.headerDescription.html"></p>
        </ng-transclude>
        <salaxy-input name="title" label="SALAXY.NG1.MessageThreadComponent.title" require="true" ng-model="$ctrl.current.title"></salaxy-input>
        <salaxy-input-enum name="otherParty" ng-model="$ctrl.otherParty" ng-if="$ctrl.otherPartyOptions" label="SALAXY.NG1.MessageThreadComponent.receiver" type="select" placeholder="SALAXY.UI_Terms.choose" required options="$ctrl.otherPartyOptions"></salaxy-input-enum>
        <salaxy-input-enum name="msgType" ng-model="$ctrl.msgType" label="SALAXY.NG1.MessageThreadComponent.subject" type="radio" ng-init="$ctrl.msgType = 'salary'" options="{ salary: ('SALAXY.NG1.MessageThreadComponent.subjectOptionSalary' | sxyTranslate), other:  ('SALAXY.NG1.MessageThreadComponent.subjectOptionOther' | sxyTranslate) }"></salaxy-input-enum>
        <salaxy-datepicker name="salaryDate" ng-model="$ctrl.current.ownerWorkflow.salaryDate" label="{{ $ctrl.msgType == 'salary' ? 'SALAXY.NG1.MessageThreadComponent.salaryDate' : 'SALAXY.NG1.MessageThreadComponent.replyDate'}}" date-disabled="next-weekday" require="$ctrl.msgType == 'salary'" show-buttons="false"></salaxy-datepicker>
        <salaxy-form-group label-type="empty-label" name="submit" class="no-colon">
          <button type="submit" class="btn btn-primary" ng-disabled="!newMessageThread.$valid" ng-click="$ctrl.save()" sxy-text="SALAXY.NG1.MessageThreadComponent.ui.newMessageThreadBtn"></button>
        </salaxy-form-group>
      </form>
    </div>
    <div ng-if="!$ctrl.isNew() && $ctrl.current">
      <ng-transclude ng-transclude-slot="header">
        <h2>
          {{ $ctrl.current.title }}<small>, <span sxy-text="SALAXY.NG1.MessageThreadComponent.salaryDate"></span> {{ $ctrl.current.ownerWorkflow.salaryDate | sxyDate }}</small>
        </h2>
      </ng-transclude>
      <p ng-if="$ctrl.current.messages.length == 0">&nbsp;</p>
      <div class="messages-container" ng-if="$ctrl.current.messages">
        <div ng-repeat="item in $ctrl.current.messages" ng-switch="item.fromParty">
          <div ng-switch-when="owner,undefined" ng-switch-when-separator=",">
            <salaxy-avatar avatar="$ctrl.current.ownerInfo" class="float-start"></salaxy-avatar>
            <div class="message-bubble left" ng-class="{ 'in-edit': $ctrl.isInEdit, 'unread': !$ctrl.getReadTime(item)  }">
              <ng-include src="'salaxy-components/communications/messages/MessageContent.html'"></ng-include>
              <span class="updated-at">{{ item.time | sxyTime }}, {{ $ctrl.getReadTime(item) ? (('SALAXY.NG1.MessageThreadComponent.read' |sxyTranslate) + ' ' + ($ctrl.getReadTime(item) | sxyTime)) : ('SALAXY.NG1.MessageThreadComponent.unread' |sxyTranslate) }}</span>
            </div>
          </div>
          <div ng-switch-when="otherParty" class="text-end">
            <salaxy-avatar avatar="$ctrl.current.otherPartyInfo" class="float-end"></salaxy-avatar>
            <div class="message-bubble right {{item.type}}" ng-class="{ 'in-edit': $ctrl.isInEdit, 'unread': !$ctrl.getReadTime(item) }">
              <ng-include src="'salaxy-components/communications/messages/MessageContent.html'"></ng-include>
              <span class="updated-at" ng-if="item.type != 'email'">{{ item.time | sxyTime }}, {{ $ctrl.getReadTime(item) ? (('SALAXY.NG1.MessageThreadComponent.read' |sxyTranslate) + ' ' + ($ctrl.getReadTime(item) | sxyTime)) : ('SALAXY.NG1.MessageThreadComponent.unread' |sxyTranslate)}}</span>
              <span class="updated-at" ng-if="item.type == 'email'">{{ item.time | sxyTime }}</span>
            </div>
          </div>
          <div ng-switch-default class="alert alert-danger">
            <ng-include src="'salaxy-components/communications/MessageThread_MessageContent.html'"></ng-include>
          </div>
        </div>
        <div class="padding message-actions">
          <div class="btn-toolbar mb-2" role="toolbar" ng-if="$ctrl.role == 'otherParty'">
            <salaxy-workflow-buttons api-ctrl="$ctrl"></salaxy-workflow-buttons>
            <div class="btn-group" role="group">
              <button class="btn btn-primary" ng-class="{ 'disabled': $ctrl.getReadTime()}" ng-click="$ctrl.markAllAsRead()" sxy-text="SALAXY.NG1.MessageThreadComponent.markAsReadBtn"></button>
            </div>
            <button ng-if="$ctrl.role == 'otherParty'" ng-click="$ctrl.sendNotification()" class="btn btn-default" sxy-text="SALAXY.NG1.MessageThreadComponent.sendtoEmailBtn"></button>
            <div class="btn-group" role="group">
              <button class="btn btn-default" ng-click="$ctrl.reload()" sxy-text="SALAXY.NG1.MessageThreadComponent.reloadBtn"></button>
              <button class="btn btn-default" ng-click="$ctrl.isInEdit=true" ng-class="{ 'disabled': $ctrl.isInEdit }" sxy-text="SALAXY.UI_Terms.edit"></button>
              <button class="btn" ng-click="$ctrl.save();$ctrl.isInEdit=false" ng-class="{ 'btn-primary': $ctrl.hasChanges, 'btn-default': !$ctrl.hasChanges }" sxy-text="SALAXY.UI_Terms.save"></button>
              <button class="btn btn-default" ng-class="{ 'disabled': !$ctrl.isInEdit }" ng-click="$ctrl.reset();$ctrl.isInEdit=false" sxy-text="SALAXY.UI_Terms.cancel"></button>
            </div>
            <div ng-if="$ctrl.current.status == 'active' || $ctrl.current.status == 'approved' || $ctrl.current.status == 'rejected'" class="btn-group btn-group-sm" role="group" aria-label="Approval toolbar">
              <button type="button" class="btn btn-success" ng-click="$ctrl.current.status = 'approved';$ctrl.save()"
                ng-disabled="$ctrl.current.status == 'approved'">Hyväksy</button>
              <button type="button" class="btn btn-danger" ng-click="$ctrl.current.status = 'rejected';$ctrl.save()"
                ng-disabled="$ctrl.current.status == 'rejected'">Hylkää</button>
              <button type="button" class="btn btn-danger" ng-click="$ctrl.current.status = 'active';$ctrl.save()"
                ng-disabled="$ctrl.current.status == 'active'">Poista hyväksyntä/hylkäys</button>
            </div>
          </div>
          <div ng-if="$ctrl.isReadOnly" class="alert alert-info">
            <p>
              <strong sxy-text="SALAXY.NG1.MessageThreadComponent.handledInfo"></strong>
              <br>
              <salaxy-workflow-reopen api-ctrl="$ctrl"></salaxy-workflow-reopen>
            </p>
          </div>
          <div class="row" ng-if="!$ctrl.isReadOnly">
            <div class="col-8 col-sm-9">
              <textarea placeholder="{{'SALAXY.NG1.MessageThreadComponent.writeOrPaste' |sxyTranslate}}" ng-model="$ctrl.newMessage.content"></textarea>
            </div>
            <div class="col-4 col-sm-3 d-flex flex-column" ng-if="!$ctrl.isReadOnly">
              <button type="button" class="btn btn-primary btn-labeled-left text-start mb-1" ng-click="$ctrl.sendMessage()" ng-disabled="!$ctrl.newMessage.content">
                <i class="bi bi-send-fill"></i>
                <span sxy-text="SALAXY.UI_Terms.send"></span>
              </button>
              <button type="button" class="btn btn-primary btn-labeled-left text-start mb-1" ng-disabled="$ctrl.newMessage.content.length > 0" ngf-select="$ctrl.uploadFiles($files)" ngf-multiple="true" ngf-max-size="10MB" xxngf-pattern="$ctrl.supportedFilesPattern">
                <i class="bi bi-paperclip"></i>
                <span sxy-text="SALAXY.NG1.MessageThreadComponent.fileBtn"></span>
              </button>
              <div class="btn-group btn-block dropup" ng-if="$ctrl.role == 'otherParty'">
                <button type="button" class="btn btn-secondary dropdown-toggle text-start w-100" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <span sxy-text="SALAXY.NG1.MessageThreadComponent.moreFeaturesBtn"></span>
                </button>
                <ul class="dropdown-menu dropdown-menu-end" role="menu">
                  <li role="menuitem">
                    <a ng-click="$ctrl.delete(null, ('SALAXY.NG1.MessageThreadComponent.deleteThreadAlert' | sxyTranslate ))" class="dropdown-item" sxy-text="SALAXY.NG1.MessageThreadComponent.deleteThread"></a>
                  </li>
                  <li role="separator" class="divider"></li>
                  <li role="menuitem">
                    <a ng-click="$ctrl.addExistingCalc('draft')" class="dropdown-item" sxy-text="SALAXY.NG1.MessageThreadComponent.addDraft"></a>
                  </li>
                  <li role="menuitem">
                    <a ng-click="$ctrl.addExistingCalc('paid')" class="dropdown-item" sxy-text="SALAXY.NG1.MessageThreadComponent.addPaid"></a>
                  </li>
                  <li role="separator" class="divider"  salaxy-if-role="test"></li>
                  <li role="menuitem" salaxy-if-role="test">
                    <a ng-click="$ctrl.addExistingPayroll('draft')" class="dropdown-item" sxy-text="Palkkalistaluonnos"></a>
                  </li>
                  <li role="menuitem"  salaxy-if-role="test">
                    <a ng-click="$ctrl.addExistingPayroll('paid')" class="dropdown-item" sxy-text="Maksettu palkkalista"></a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div id="messageContainerBottom">&nbsp;</div>
      </div>
    </div>
  </div>
</div>`), s.put("salaxy-components/communications/MessageThreadList.html", `<div class="salaxy-component salaxy-message-thread-list">
  <div class="btn-toolbar" role="toolbar">
    <div class="btn-group btn-group-sm">
      <button type="button" class="btn btn-default"
        ng-click="$ctrl.$odata.options.$filter = 'status eq \\'active\\' or ( status eq \\'draft\\' and data/otherPartyUnreadCount gt 0 )';$ctrl.$odata.searchChanged()"
        ng-class="{ active: $ctrl.$odata.options.$filter == 'status eq \\'active\\' or ( status eq \\'draft\\' and data/otherPartyUnreadCount gt 0 )' }">Aktiiviset</button>
      <button type="button" class="btn btn-default"
        ng-click="$ctrl.$odata.options.$filter = '(status eq \\'approved\\' or status eq \\'rejected\\' or status eq \\'active\\' or status eq \\'draft\\')';$ctrl.$odata.searchChanged()"
        ng-class="{ active: $ctrl.$odata.options.$filter == '(status eq \\'approved\\' or status eq \\'rejected\\' or status eq \\'active\\' or status eq \\'draft\\')' }">Kaikki</button>
    </div>
    <div class="btn-group btn-group-sm ms-1" ng-if="!$ctrl.readOnly" ng-controller="SessionController as $sessionCtrl">
        <salaxy-action-button button-class="btn-sm btn-primary" action="'newMessage'" label="SALAXY.NG1.ActionButtonComponent.startNewMessage" disabled="!$sessionCtrl.session.settings.partner.accountId">
        </salaxy-action-button>
    </div>
  </div>

  <salaxy-odata-table crud-controller="MessageThreadCrudController as $crud" ng-ref="$ctrl.$odata"
    options="{ $top: $ctrl.limitTo, $filter: 'status eq \\'active\\' or ( status eq \\'draft\\' and data/otherPartyUnreadCount gt 0 )' }" template-url="salaxy-components/odata/lists/MessageThreads.html">
  </salaxy-odata-table>
</div>`), s.put("salaxy-components/communications/VarmaBanner.html", `<div class="salaxy-component salaxy-varma-banner">
  <div ng-if="$ctrl.varmaPensionBanners.isReady" ng-init="$ctrl.showVarmaPopup()">


  </div>
</div>`), s.put("salaxy-components/communications/Welcome.html", `<div class="salaxy-component salaxy-welcome">
  <div ng-controller="SessionController as $sessionCtrl">
    <div ng-if="$ctrl.hasSystemAlert" class="salaxy-welcome-system-alert alert-has-system-alert" ng-bind-html="$ctrl.systemAlertHtml"></div>
    <salaxy-alert ng-if="$ctrl.tutorials.showAnon" type="danger" icon="bi-box-arrow-in-right" class="alert-anon">
      <main sxy-html="SALAXY.NG1.WelcomeComponent.showAnon.main.html"></main>
    </salaxy-alert>
    <salaxy-alert ng-if="$ctrl.tutorials.showInsurance || $ctrl.tutorials.showPension" type="warning" class="alert-insurance-and-pension">
      <main>
        <div class="row">
          <div class="col-sm-8 col-lg-9">
            <p class="lead lead-with-text" sxy-html="SALAXY.NG1.WelcomeComponent.showSettings.lead.html"></p>
            <p sxy-html="SALAXY.NG1.WelcomeComponent.showSettings.main"></p>
          </div>
          <div class="col-sm-4 col-lg-3">
            <a href="#/settings/insurances" class="btn btn-warning float-end-sm btn-block btn-edit-settings" style="margin-bottom:10px;" sxy-text="SALAXY.NG1.WelcomeComponent.showSettings.settings.cta"></a>
          </div>
        </div>
      </main>
    </salaxy-alert>
    <salaxy-alert ng-if="$ctrl.tutorials.showSign" class="alert-sign" type="warning">
      <main>
        <div class="row">
          <div class="col-sm-8 col-lg-9">
            <p class="lead lead-with-text" sxy-text="SALAXY.NG1.WelcomeComponent.showSign.lead"></p>
            <p sxy-html="SALAXY.NG1.WelcomeComponent.showSign.main.html"></p>
          </div>
          <div class="col-sm-4 col-lg-3">
            <button sxy-if-role="person" ng-controller="WorkerOnboardingController as wizard" class="btn btn-warning btn-add-signature float-end btn-block" ng-click="wizard.launch()" sxy-text="SALAXY.NG1.WelcomeComponent.showSign.main.cta"></button>
            <button sxy-if-role="company" ng-controller="CompanyOnboardingController as wizard" class="btn btn-warning btn-add-signature float-end btn-block" ng-click="wizard.launch()" sxy-text="SALAXY.NG1.WelcomeComponent.showSign.main.cta"></button>
          </div>
        </div>
      </main>
    </salaxy-alert>
    <salaxy-invoice-alerts ng-if="'auth' | sxyIsInRole" payment-channels="['palkkausManual', 'holvi', 'talenomOnline']"></salaxy-invoice-alerts>    
    <salaxy-alert ng-if="$ctrl.tutorials.showTryPayroll" type="primary" class="alert-try-payroll">
      <main>
        <div class="row">
          <div class="col-sm-8 col-lg-9">
            <p class="lead" sxy-text="SALAXY.NG1.WelcomeComponent.showTryPayroll.main"></p>
          </div>
          <div class="col-sm-4 col-lg-3">
            <a class="btn btn-info btn-block" href="#/payroll" sxy-text="SALAXY.NG1.WelcomeComponent.showTryPayroll.cta"></a>
          </div>
        </div>
      </main>
    </salaxy-alert>
    <salaxy-alert ng-if="$ctrl.showAutoTaxcardInfobox()" type="warning">
      <main>
        <div class="row">
          <div class="col-sm-8 col-lg-9">
            <p class="lead" sxy-html="SALAXY.NG1.WelcomeComponent.autoTaxcard.lead.html"></p>
          </div>
          <div class="col-sm-4 col-lg-3">
            <a ng-href="#/workers" class="btn btn-warning btn-add btn-add-taxcard btn-block" title="{{'SALAXY.NG1.WorkerListComponent.activeAutoTaxcard' | sxyTranslate}}" sxy-text="SALAXY.NG1.WorkerListComponent.autoTaxcard"></a>
          </div>
        </div>
      </main>
    </salaxy-alert>
    <salaxy-alert ng-if="$ctrl.tutorials.showAddCalculation" type="primary" class="alert-add-calculation">
      <main>
        <div class="row">
          <div class="col-sm-8 col-lg-9">
            <p class="lead" sxy-html="SALAXY.NG1.WelcomeComponent.showAddCalculation.main.html"></p>
            <salaxy-input-typeahead
              label-type="no-label"
              ng-model="$ctrl.employmentId"
              name="options_type"
              disable-cache="true"
              placeholder="{{'SALAXY.NG1.WelcomeComponent.showAddCalculation.selectWorkerPlaceholder' | sxyTranslate}}"
              get-options="$ctrl.filterWorkers"
              on-select-function="$ctrl.createNewCalculationFor"
              input-formatter="$ctrl.getWorkerName">
            </salaxy-input-typeahead>
          </div>
          <div class="col-sm-4 col-lg-3">
            <button class="btn btn-info btn-add btn-add-worker btn-block mb-2" ng-click="$ctrl.launchEmploymentWizard()" sxy-text="SALAXY.NG1.WelcomeComponent.showAddWorker.main.cta"></button>
            <a class="btn btn-default btn-block btn-try-payroll" href="#/payroll" sxy-text="SALAXY.NG1.WelcomeComponent.showAddWorker.tryPayroll.cta"></a>
          </div>
        </div>
      </main>
    </salaxy-alert>
  </div>
</div>`), s.put("salaxy-components/form-controls/Datepicker.html", `<salaxy-form-group ng-if="$ctrl.getReadOnly()" name="{{$ctrl.name}}" class="salaxy-component salaxy-read-only" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
  <div class="form-control-plaintext">{{ $ctrl.datepickerValue }} </div>
</salaxy-form-group>
<ng-form name="{{$ctrl.name}}Form" class="salaxy-component salaxy-datepicker" ng-if="!$ctrl.getReadOnly()">
  <salaxy-form-group ng-if="!$ctrl.getReadOnly()" name="{{$ctrl.name}}" require="$ctrl.require" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
    <div class="form-control datepicker-input" ng-model="$ctrl.datepickerValue" id="{{$ctrl.name}}" name="{{$ctrl.name}}" ng-change="$ctrl.onChange()" ng-required="$ctrl.require" ng-readonly="$ctrl.readonly" ng-disabled="$ctrl.getDisabled()"></div>
    <div ng-show="!$ctrl.disableValidationErrors && ($ctrl.validationErrors.length > 0 && ({{$ctrl.name}}Form.{{$ctrl.name}}.$touched || {{$ctrl.name}}Form.$$parentForm.$submitted))" class="input-errors">
      <span class="salaxy-validation-error text-danger small" ng-repeat="validationError in $ctrl.validationErrors" sxy-text="{{ validationError }}" params="{ minlength: $ctrl.minlength, maxlength: $ctrl.maxlength }"></span><br/>
    </div>
  </salaxy-form-group>
</ng-form>
<salaxy-form-group ng-if="$ctrl.isMultiple" name="{{$ctrl.name}}" class="salaxy-component salaxy-read-only" label="{{ $ctrl.labelDaysCount || 'SALAXY.NG1.DateRange.labelDaysCount' }}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
  <div class="form-control-plaintext">{{ $ctrl.datepickerValue.daysCount }}</div>
</salaxy-form-group>`), s.put("salaxy-components/form-controls/DatepickerPopup.html", `<salaxy-form-group ng-if="$ctrl.getReadOnly()" name="{{$ctrl.name}}" class="salaxy-component salaxy-read-only" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
  <div class="form-control-plaintext">{{ $ctrl.datepickerValue }} </div>
</salaxy-form-group>
<ng-form ng-show="!$ctrl.getReadOnly()" name="{{$ctrl.name}}Form" class="salaxy-component salaxy-datepicker-popup">
  <salaxy-form-group ng-if="$ctrl.inputMode == 'openClose' && !$ctrl.isOpen" name="{{$ctrl.name}}" class="salaxy-component salaxy-read-only" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
    <div class="form-control-plaintext">{{ $ctrl.datepickerValue }}
      <span class="float-end btn-padding-right">
          <i ng-click="$ctrl.isOpen = !$ctrl.isOpen" class="bi bi-pencil-fill clickable"></i>
      </span>
    </div>
  </salaxy-form-group>
  <salaxy-form-group ng-show="!$ctrl.inputMode || ($ctrl.inputMode == 'openClose' && $ctrl.isOpen)" name="{{$ctrl.name}}" require="$ctrl.require" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
    <div class="input-group">
      <input class="form-control datepicker-popup datepicker-input" type="text" autocomplete="off" name="datepicker-popup" placeholder="{{ $ctrl.placeholder | sxyTranslate  }}" ng-model="$ctrl.datepickerValue" on-change="$ctrl.onChange()" ng-required="$ctrl.require"
        ng-readonly="$ctrl.readonly" ng-disabled="$ctrl.disabled" salaxy-datepicker-input-validation>
      <span class="input-group-btn">
        <button ng-if="$ctrl.getToolTipHtml()" type="button" class="btn btn-default" data-bs-toggle="popover" data-bs-container="body" aria-label="Info" data-bs-html="true" data-bs-title="'Info'" data-bs-content="$ctrl.getToolTipHtml()" data-bs-placement="'{{$ctrl.tooltipPlacement}}'" sxy-bs5-popover>
          <span class="bi bi-question-circle-fill"></span>
        </button>
        <button ng-if="$ctrl.inputMode == 'openClose'" class="btn btn-transparent" ng-click="$ctrl.isOpen = !$ctrl.isOpen">
          <i class="bi bi-pencil-fill"></i>
        </button>
      </span>
    </div>
    <div ng-show="!$ctrl.disableValidationErrors && ($ctrl.validationErrors.length > 0 && ({{$ctrl.name}}Form.{{$ctrl.name}}.$touched || {{$ctrl.name}}Form.$$parentForm.$submitted))" class="input-errors">
      <span class="salaxy-validation-error text-danger small" ng-repeat="validationError in $ctrl.validationErrors" sxy-text="{{ validationError}}" params="{ minlength: $ctrl.minlength, maxlength: $ctrl.maxlength }"></span><br/>
    </div>
  </salaxy-form-group>
</ng-form>`), s.put("salaxy-components/form-controls/DateRange.html", `<salaxy-form-group ng-if="$ctrl.getReadOnly()" name="{{$ctrl.name}}" class="salaxy-component salaxy-read-only" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
  <div class="form-control-plaintext">{{ $ctrl.dateRangeValues.formattedRange || "-" }}</div>
</salaxy-form-group>
<ng-form ng-if="!$ctrl.getReadOnly()" name="{{$ctrl.name}}Form" class="salaxy-component salaxy-date-range mode-{{ $ctrl.mode || 'range' }}">
  <salaxy-form-group ng-if="$ctrl.inputMode == 'openClose' && !$ctrl.isOpen" name="{{$ctrl.name}}" class="salaxy-component salaxy-read-only" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
    <div class="form-control-plaintext">{{ $ctrl.dateRangeValues.formattedRange || "-" }}
      <span class="float-end btn-padding-right">
        <i ng-click="$ctrl.isOpen = !$ctrl.isOpen" class="bi bi-pencil-fill clickable"></i>
      </span>
    </div>
  </salaxy-form-group>
  <div ng-show="!$ctrl.inputMode || ($ctrl.inputMode == 'openClose' && $ctrl.isOpen)">
    <salaxy-input-enum ng-if="$ctrl.mode == 'calc' && !$ctrl.periodShortcut" ng-model="$ctrl.periodShortcut" name="periodShortcut" label="SALAXY.NG1.DateRange.salaryPeriod" label-cols="{{$ctrl.labelCols}}" type="radio" options="$ctrl.periodShortcuts"></salaxy-input-enum>
    <salaxy-input-enum ng-if="$ctrl.mode == 'calc' && $ctrl.periodShortcut" ng-model="$ctrl.periodShortcut" name="periodShortcut" label="SALAXY.NG1.DateRange.salaryPeriod" label-cols="{{$ctrl.labelCols}}" type="select" options="$ctrl.periodShortcuts"></salaxy-input-enum>
    <salaxy-form-group ng-show="$ctrl.mode != 'calc' || $ctrl.periodShortcut == 'other'" ng-init="$ctrl.selectedDates = []" name="{{ $ctrl.name + '_datepicker' }}" label="{{$ctrl.label}}" require="$ctrl.require" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
      <div class="salaxy-read-only">
        <div class="form-control-plaintext">
          {{ $ctrl.dateRangeValues.formattedRange || "-" }}
          <span class="float-end btn-padding-right" ng-if="$ctrl.inputMode == 'openClose'">
            <i ng-click="$ctrl.isOpen = !$ctrl.isOpen" class="bi bi-pencil-fill clickable"></i>
          </span>
        </div>
      </div>
      <div class="form-control input-daterange" ng-model="$ctrl.dateRangeValues" id="{{$ctrl.name}}" name="{{$ctrl.name}}" ng-required="$ctrl.require" ng-readonly="$ctrl.readonly" on-change="$ctrl.dateRangeChange()" ng-disabled="$ctrl.getDisabled()"></div>
    </salaxy-form-group>
    <div ng-if="$ctrl.mode == 'calc' && $ctrl.periodShortcut && $ctrl.periodShortcut != 'other'">
      <salaxy-form-group name="{{$ctrl.name}}_periodStartDate" label="SALAXY.NG1.DateRange.startDate" label-cols="{{$ctrl.labelCols}}">
        <input type="text" class="form-control" autocomplete="off" id="{{$ctrl.name}}_periodStartDate" name="{{$ctrl.name}}_periodStartDate" placeholder="{{'SALAXY.UI_Terms.dateFormats.dm' | sxyTranslate}}" ng-model="$ctrl.periodStartDate" ng-model-options="{allowInvalid: true, debounce: 250, updateOn: 'default' }"
        />
        <div ng-if="$ctrl.periodStartDateError" class="form-control-plaintext text-danger">{{ $ctrl.periodStartDateError | sxyTranslate }}</div>
      </salaxy-form-group>
      <salaxy-form-group name="formattedRange" label="SALAXY.NG1.DateRange.labelStartAndEndDate" label-cols="{{$ctrl.labelCols}}" class="salaxy-read-only">
        <div class="form-control-plaintext">{{ $ctrl.dateRangeValues.formattedRange }}</div>
      </salaxy-form-group>
    </div>
  </div>
  <div>
    <salaxy-form-group ng-if="$ctrl.inputMode == 'openClose' && !$ctrl.isOpen" name="{{$ctrl.name}}" label="{{ $ctrl.labelDaysCount || 'SALAXY.NG1.DateRange.labelDaysCount' }}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}" class="salaxy-read-only">
      <div class="form-control-plaintext">{{ $ctrl.dateRangeValues.daysCount }}
        <span class="float-end btn-padding-right">
          <i ng-click="$ctrl.isOpen = !$ctrl.isOpen" class="bi bi-pencil-fill clickable"></i>
        </span>
      </div>
    </salaxy-form-group>
    <salaxy-form-group ng-if="!$ctrl.inputMode || ($ctrl.inputMode == 'openClose' && $ctrl.isOpen)" name="{{$ctrl.name}}" require="$ctrl.require" label="{{ $ctrl.labelDaysCount || 'SALAXY.NG1.DateRange.labelDaysCount' }}" label-type="{{$ctrl.labelType}}"
      label-cols="{{$ctrl.labelCols}}">
      <div ng-class="{'input-group': $ctrl.inputMode == 'openClose'}">
        <input type="text" class="form-control" autocomplete="off" id="{{$ctrl.name}}" name="{{$ctrl.name}}" placeholder="{{ $ctrl.getPlaceholder() | sxyTranslate}}" ng-model="$ctrl.dateRangeValues.daysCount" ng-model-options="{allowInvalid: true, debounce: 250}" ng-change="$ctrl.onChange()"
          ng-pattern="$ctrl.pattern" ng-required="$ctrl.require" ng-readonly="$ctrl.readonly" ng-disabled="$ctrl.getDisabled()" ng-minlength="$ctrl.minlength" ng-maxlength="$ctrl.maxlength" maxlength="{{$ctrl.maxlength}}" />
        <div class="input-group-btn" ng-if="$ctrl.inputMode == 'openClose'">
          <button class="btn btn-transparent float-end" ng-click="$ctrl.isOpen = !$ctrl.isOpen">
            <i class="bi bi-pencil-fill"></i>
          </button>
        </div>
      </div>
    </salaxy-form-group>
  </div>
</ng-form>
<salaxy-form-group ng-if="$ctrl.getReadOnly()" name="{{$ctrl.name}}" class="salaxy-component salaxy-read-only" label="{{ $ctrl.labelDaysCount || 'SALAXY.NG1.DateRange.labelDaysCount' }}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
  <div class="form-control-plaintext">{{ $ctrl.dateRangeValues.daysCount }}</div>
</salaxy-form-group>`), s.put("salaxy-components/form-controls/FormGroup.html", `<div ng-if="$ctrl.getLabelType() == 'basic'" class="row">
  <label for="{{$ctrl.name}}" class="col-12 col-form-label"><span class="label-text">{{$ctrl.label | sxyTranslate}}</span><span class="salaxy-form-group-required-indicator"
    ng-show="!!$ctrl.require">*</span>
  </label>
  <div class="col-12">
    <ng-transclude></ng-transclude>
  </div>
</div>
<div ng-if="$ctrl.getLabelType() == 'empty-label'" class="row">
  <div class="{{ $ctrl.getLabelCols('label') }} col-form-label"></div>
  <div class="{{ $ctrl.getLabelCols('value') }}">
    <ng-transclude></ng-transclude>
  </div>
</div>
<div ng-if="$ctrl.getLabelType() == 'no-label'">
  <div class="{{ $ctrl.getLabelCols('no-label') }}">
    <ng-transclude></ng-transclude>
  </div>
</div>
<span ng-if="$ctrl.getLabelType() == 'plain'" class="salaxy-form-group-plain">
  <ng-transclude></ng-transclude>
</span>
<div ng-if="$ctrl.getLabelType() == 'horizontal'" class="row mb-1">
  <label for="{{$ctrl.name}}" class="{{ $ctrl.getLabelCols('label') }} col-form-label">
    <span class="label-text">{{$ctrl.label | sxyTranslate}}</span><span class="salaxy-form-group-required-indicator"
      ng-show="!!$ctrl.require">*</span>
  </label>
  <div class="{{ $ctrl.getLabelCols('value') }}">
    <ng-transclude class="w-100"></ng-transclude>
  </div>
</div>
<div ng-if="$ctrl.getLabelType() == 'inline'" class="row mb-1">
  <label for="{{$ctrl.name}}" class="{{ $ctrl.getLabelCols('label') }} col-form-label">
    <span class="label-text">{{$ctrl.label | sxyTranslate}}</span>
    <span class="salaxy-form-group-required-indicator" ng-show="!!$ctrl.require">*</span>
  </label>
  <ng-transclude class="inline-salaxy-input {{ $ctrl.getLabelCols('value') }}"></ng-transclude>
</div>`), s.put("salaxy-components/form-controls/Input.html", `<salaxy-form-group ng-if="$ctrl.getReadOnly()" name="{{$ctrl.name}}" class="salaxy-component salaxy-read-only" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
  <div class="form-control-plaintext">{{ $ctrl.value }}

  </div>

</salaxy-form-group>

<ng-form ng-if="!$ctrl.getReadOnly()" name="{{$ctrl.name}}Form" class="salaxy-component salaxy-input">
  <salaxy-form-group ng-if="$ctrl.inputMode == 'openClose' &&  !$ctrl.isOpen" name="{{$ctrl.name}}" class="salaxy-component salaxy-read-only" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
    <div class="form-control-plaintext">{{ $ctrl.value || "\\u00A0" }}
      <span class="float-end btn-padding-right">
          <i ng-click="$ctrl.isOpen = !$ctrl.isOpen" class="bi bi-pencil-fill clickable"></i>
      </span>
    </div>
  </salaxy-form-group>

  <salaxy-form-group ng-if="!$ctrl.inputMode || ($ctrl.inputMode == 'openClose' && $ctrl.isOpen)" name="{{$ctrl.name}}" label="{{$ctrl.label}}" require="$ctrl.require" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
    <div ng-if="$ctrl.getToolTipHtml()" class="input-group">
      <input type="{{$ctrl.type || 'text'}}" class="form-control" autocomplete="off" id="{{$ctrl.name}}" name="{{$ctrl.name}}" placeholder="{{ $ctrl.getPlaceholder() | sxyTranslate }}" ng-model="$ctrl.value" ng-model-options="{allowInvalid: true, debounce: 250, updateOn: 'default' }"
        ng-change="$ctrl.onChange()" ng-pattern="$ctrl.pattern" ng-required="$ctrl.require" ng-readonly="$ctrl.readonly" ng-disabled="$ctrl.getDisabled()" ng-minlength="$ctrl.minlength" ng-maxlength="$ctrl.maxlength" maxlength="{{$ctrl.maxlength}}" />
      <div class="input-group-btn">
        <button type="button" class="btn btn-default" data-bs-container="body" aria-label="Info" data-bs-toggle="popover" data-bs-html="true" data-bs-title="'Info'" data-bs-content="$ctrl.getToolTipHtml()" data-bs-placement="'{{$ctrl.tooltipPlacement}}'" sxy-bs5-popover>
          <span class="bi bi-question-circle-fill"></span>
        </button>
        <button ng-if="$ctrl.inputMode == 'openClose'" class="btn btn-transparent" ng-click="$ctrl.isOpen = !$ctrl.isOpen">
          <i class="bi bi-pencil-fill"></i>
        </button>
      </div>
    </div>
    <div ng-if="!$ctrl.getToolTipHtml()" ng-class="{'input-group': $ctrl.inputMode == 'openClose'}">
      <input type="{{$ctrl.type || 'text'}}" class="form-control" autocomplete="off" id="{{$ctrl.name}}" name="{{$ctrl.name}}" placeholder="{{ $ctrl.getPlaceholder() | sxyTranslate }}" ng-model="$ctrl.value" ng-model-options="{allowInvalid: true, debounce: 250, updateOn: 'default' }"
        ng-change="$ctrl.onChange()" ng-pattern="$ctrl.pattern" ng-required="$ctrl.require" ng-readonly="$ctrl.readonly" ng-disabled="$ctrl.getDisabled()" ng-minlength="$ctrl.minlength" ng-maxlength="$ctrl.maxlength" maxlength="{{$ctrl.maxlength}}" />
      <div class="input-group-btn" ng-if="$ctrl.inputMode == 'openClose'">
        <button class="btn btn-transparent float-end" ng-click="$ctrl.isOpen = !$ctrl.isOpen">
          <i class="bi bi-pencil-fill"></i>
        </button>
      </div>
    </div>

    <div ng-show="!$ctrl.disableValidationErrors && ($ctrl.validationErrors.length > 0 && ({{$ctrl.name}}Form.{{$ctrl.name}}.$touched || {{$ctrl.name}}Form.$$parentForm.$submitted))" class="input-errors">
      <span class="salaxy-validation-error text-danger small" ng-repeat="validationError in $ctrl.validationErrors" sxy-text="{{ validationError}}" params="{ minlength: $ctrl.minlength, maxlength: $ctrl.maxlength }"></span><br/>
    </div>
  </salaxy-form-group>

</ng-form>`), s.put("salaxy-components/form-controls/InputAccountingTarget.html", `<ng-form name="{{$ctrl.name}}Form" class="salaxy-component salaxy-input-accounting-target">
  <salaxy-form-group ng-if="$ctrl.getReadOnly()" name="{{$ctrl.name}}" class="salaxy-component salaxy-read-only" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
    <div class="form-control-plaintext">{{ $ctrl.value }}</div>
  </salaxy-form-group>
  <salaxy-form-group ng-if="!$ctrl.getReadOnly()" name="{{$ctrl.name}}" require="$ctrl.require" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}" ng-init="refresher = [0]">
    <div ng-repeat="item in refresher">
      <salaxy-input-typeahead
        label-type="no-label"
        ng-model="$ctrl.value"
        name="{{ $ctrl.name }}"
        disable-cache="true"
        placeholder="{{ $ctrl.placeholder }}"
        get-options="$ctrl.queryAccountingTargets($viewValue)"
        input-formatter="$ctrl.queryAccountingTargetDisplayName($model, refresher)">
      </salaxy-input-typeahead>
    </div>
  </salaxy-form-group>
</ng-form>`), s.put("salaxy-components/form-controls/InputBoolean.html", `<salaxy-form-group ng-if="$ctrl.getReadOnly()" name="{{$ctrl.name}}" class="salaxy-component salaxy-read-only" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
  <div class="form-control-plaintext">
    <span ng-if="$ctrl.value==true">{{$ctrl.labelTrue || 'SALAXY.UI_Terms.yes' | sxyTranslate}} </span>
    <span ng-if="$ctrl.value==false && $ctrl.labelType != 'no-label'">{{$ctrl.labelFalse || 'SALAXY.UI_Terms.no' | sxyTranslate}} </span>
  </div>
</salaxy-form-group>
<ng-form name="{{$ctrl.name}}Form" ng-if="!$ctrl.getReadOnly()">
  <salaxy-form-group ng-if="$ctrl.inputMode == 'openClose' &&  !$ctrl.isOpen && $ctrl.type != 'switch'" name="{{$ctrl.name}}" class="salaxy-component salaxy-read-only" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
    <div class="form-control-plaintext">
      <span ng-if="$ctrl.value==true">{{$ctrl.labelTrue || 'SALAXY.UI_Terms.yes' | sxyTranslate}} </span>
      <span ng-if="$ctrl.value==false">{{$ctrl.labelFalse || 'SALAXY.UI_Terms.no' | sxyTranslate}} </span>
      <span class="float-end btn-padding-right">
          <i ng-click="$ctrl.isOpen = !$ctrl.isOpen" class="bi bi-pencil-fill clickable"></i>
      </span>
    </div>
  </salaxy-form-group>
  <salaxy-form-group ng-if="($ctrl.type == 'radio' || !$ctrl.type) && (!$ctrl.inputMode || ($ctrl.inputMode == 'openClose' && $ctrl.isOpen))" name="{{$ctrl.name}}" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}" require="$ctrl.require" class="salaxy-component salaxy-input-boolean boolean-radio">
    <div ng-class="{'input-group': $ctrl.inputMode == 'openClose'}">
      <div class="radio form-check d-flex" ng-class="$ctrl.horizontal ? 'form-check-inline' : null">
        <input class="form-check-input me-2 mt-0.5" type="radio" ng-disabled="$ctrl.getDisabled()" name="{{$ctrl.name}}Radio" id="{{$ctrl.name}}True" ng-change="$ctrl.onChange()" ng-model="$ctrl.value" value="true" sxy-enum-as-boolean>
        <label class="form-check-label" for="{{$ctrl.name}}True">{{$ctrl.labelTrue || 'SALAXY.UI_Terms.yes' | sxyTranslate}}</label>
      </div>
      <div class="radio form-check d-flex" ng-class="$ctrl.horizontal ? 'form-check-inline' : null">
        <input class="form-check-input me-2 mt-0.5" type="radio" ng-disabled="$ctrl.getDisabled()" name="{{$ctrl.name}}Radio" id="{{$ctrl.name}}False" ng-change="$ctrl.onChange()" ng-model="$ctrl.value" value="false" sxy-enum-as-boolean>
        <label class="form-check-label" for="{{$ctrl.name}}False">{{$ctrl.labelFalse || 'SALAXY.UI_Terms.no' | sxyTranslate}}</label>
      </div>
      <div class="input-group-btn ms-auto" ng-if="$ctrl.inputMode == 'openClose'">
        <button class="btn btn-transparent" ng-click="$ctrl.isOpen = !$ctrl.isOpen">
          <i class="bi bi-pencil-fill"></i>
        </button>
      </div>
    </div>
    <div ng-show="!$ctrl.disableValidationErrors && ($ctrl.validationErrors.length > 0 && ({{$ctrl.name}}Form.{{$ctrl.name}}.$touched || {{$ctrl.name}}Form.$$parentForm.$submitted))" class="input-errors">
      <span class="salaxy-validation-error text-danger small" ng-repeat="validationError in $ctrl.validationErrors" sxy-text="{{ validationError}}" params="{ minlength: $ctrl.minlength, maxlength: $ctrl.maxlength }"></span><br />
    </div>
  </salaxy-form-group>
  <salaxy-form-group ng-if="$ctrl.type == 'checkbox' && (!$ctrl.inputMode || ($ctrl.inputMode == 'openClose' && $ctrl.isOpen))" name="{{$ctrl.name}}" label="{{$ctrl.label}}" require="$ctrl.require" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}" class="salaxy-component salaxy-input-boolean boolean-checkbox">
    <div ng-class="{'input-group': $ctrl.inputMode == 'openClose'}">
      <div class="checkbox">
        <div class="{{$ctrl.offsetCols}} form-check d-flex align-items-start" ng-class="{'col-offset' : $ctrl.offsetCols}">
          <label class="form-check-label">
            <input class="form-check-input me-2 mt-0.5" type="checkbox" ng-disabled="$ctrl.getDisabled()" ng-required="$ctrl.require" ng-model="$ctrl.value" ng-change="$ctrl.onChange()" name="{{$ctrl.name}}" id="{{$ctrl.name}}" title="true">
            {{$ctrl.labelTrue || 'SALAXY.UI_Terms.yes' | sxyTranslate}}
          </label>
        </div>
      </div>
      <div class="input-group-btn ms-auto" ng-if="$ctrl.inputMode == 'openClose'">
        <button class="btn btn-transparent" ng-click="$ctrl.isOpen = !$ctrl.isOpen">
          <i class="bi bi-pencil-fill"></i>
        </button>
      </div>
    </div>
    <div ng-show="!$ctrl.disableValidationErrors && ($ctrl.validationErrors.length > 0 && ({{$ctrl.name}}Form.{{$ctrl.name}}.$touched || {{$ctrl.name}}Form.$$parentForm.$submitted))" class="input-errors">
      <span class="salaxy-validation-error text-danger small" ng-repeat="validationError in $ctrl.validationErrors" sxy-text="{{ validationError}}" params="{ minlength: $ctrl.minlength, maxlength: $ctrl.maxlength }"></span><br />
    </div>
  </salaxy-form-group>
  <salaxy-form-group ng-if="$ctrl.type == 'switch'" name="{{$ctrl.name}}" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}" require="$ctrl.require" class="salaxy-component salaxy-input-boolean boolean-switch">
    <div class="form-check form-switch d-flex align-items-center">
      <input class="form-check-input ms-1 me-2" type="checkbox" id="{{$ctrl.name}}" name="{{$ctrl.name}}" ng-model="$ctrl.value" ng-change="$ctrl.onChange()" />
      <label class="form-check-label" for="{{$ctrl.name}}" ng-if="$ctrl.value">{{$ctrl.labelTrue || 'SALAXY.UI_Terms.yes' | sxyTranslate}}</label>
      <label class="form-check-label" for="{{$ctrl.name}}" ng-if="!$ctrl.value || $ctrl.value == false">{{$ctrl.labelFalse || 'SALAXY.UI_Terms.no' | sxyTranslate}}</label>
    </div>
    <div ng-show="!$ctrl.disableValidationErrors && ($ctrl.validationErrors.length > 0 && ({{$ctrl.name}}Form.{{$ctrl.name}}.$touched || {{$ctrl.name}}Form.$$parentForm.$submitted))" class="input-errors">
      <span class="salaxy-validation-error text-danger small" ng-repeat="validationError in $ctrl.validationErrors" sxy-text="{{ validationError}}" params="{ minlength: $ctrl.minlength, maxlength: $ctrl.maxlength }"></span><br />
    </div>
  </salaxy-form-group>
  <salaxy-form-group ng-if="$ctrl.type == 'switch-xl'" name="{{$ctrl.name}}" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}" require="$ctrl.require" class="salaxy-component salaxy-input-boolean boolean-switch">
    <div class="form-check form-switch fs-3">
      <input class="form-check-input" type="checkbox" id="{{$ctrl.id}}" name="{{$ctrl.name}}" ng-model="$ctrl.value" ng-disabled="$ctrl.getDisabled()" ng-change="$ctrl.onChange()">
    </div>
    <span class="switch-text"></span>
      <span class="on" ng-if="$ctrl.labelTrue"> {{$ctrl.labelTrue || 'SALAXY.UI_Terms.yes' | sxyTranslate}}</span>
      <span class="off" ng-if="$ctrl.labelFalse"> {{$ctrl.labelFalse || 'SALAXY.UI_Terms.no' | sxyTranslate}}</span>
    </span>
    <div ng-show="!$ctrl.disableValidationErrors && ($ctrl.validationErrors.length > 0 && ({{$ctrl.name}}Form.{{$ctrl.name}}.$touched || {{$ctrl.name}}Form.$$parentForm.$submitted))" class="input-errors">
      <span class="salaxy-validation-error text-danger small" ng-repeat="validationError in $ctrl.validationErrors" sxy-text="{{ validationError}}" params="{ minlength: $ctrl.minlength, maxlength: $ctrl.maxlength }"></span><br />
    </div>
  </salaxy-form-group>
  <salaxy-form-group ng-if="$ctrl.type=='select'" name="{{$ctrl.name}}" require="$ctrl.require" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}" class="salaxy-component salaxy-input-boolean boolean-select">
    <select ng-disabled="$ctrl.getDisabled()" id="{{$ctrl.name}}" name="{{$ctrl.name}}" ng-change="$ctrl.onChange()" ng-model="$ctrl.value" class="form-select" sxy-enum-as-boolean>
      <option ng-if="$ctrl.value == null" value="{{$ctrl.value}}" selected disabled>{{ $ctrl.placeholder || 'SALAXY.UI_Terms.select' | sxyTranslate }}</option>
      <option value="true" title="{{$ctrl.labelTrue}}">{{$ctrl.labelTrue || 'SALAXY.UI_Terms.yes' | sxyTranslate}}</option>
      <option value="false" title="{{$ctrl.labelFalse}}">{{$ctrl.labelFalse || 'SALAXY.UI_Terms.no' | sxyTranslate}}</option>
    </select>
    <div ng-show="!$ctrl.disableValidationErrors && ($ctrl.validationErrors.length > 0 && ({{$ctrl.name}}Form.{{$ctrl.name}}.$touched || {{$ctrl.name}}Form.$$parentForm.$submitted))" class="input-errors">
      <span class="salaxy-validation-error text-danger small" ng-repeat="validationError in $ctrl.validationErrors" sxy-text="{{ validationError}}" params="{ minlength: $ctrl.minlength, maxlength: $ctrl.maxlength }"></span><br />
    </div>
  </salaxy-form-group>
</ng-form>`), s.put("salaxy-components/form-controls/InputCollectiveBargainAgreement.html", `<salaxy-form-group ng-if="$ctrl.getReadOnly()" name="{{$ctrl.name}}" class="salaxy-component salaxy-read-only" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
  <div class="form-control-plaintext">{{ $ctrl.getCbaLabel($ctrl.value) }}</div>
</salaxy-form-group>
<ng-form ng-if="!$ctrl.getReadOnly()" name="{{$ctrl.name}}Form" class="salaxy-component salaxy-input-collective-bargain-agreement">
  <salaxy-form-group ng-if="$ctrl.inputMode == 'openClose' &&  !$ctrl.isOpen" name="{{$ctrl.name}}" class="salaxy-component salaxy-read-only" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
    <div class="form-control-plaintext">{{ $ctrl.getCbaLabel($ctrl.value) }}
      <span class="pull-right btn-padding-right">
          <i ng-click="$ctrl.isOpen = !$ctrl.isOpen" class="bi bi-pencil-fill clickable"></i>
      </span>
    </div>
  </salaxy-form-group>
  <salaxy-form-group name="{{$ctrl.name}}" require="$ctrl.require" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
    <salaxy-input-typeahead
      label-type="no-label"
      ng-model="$ctrl.value"
      ng-change="$ctrl.onChange()"
      name="{{ $ctrl.name }}"
      disable-cache="true"
      placeholder="{{ $ctrl.getPlaceholder() | sxyTranslate }}"
      get-options="$ctrl.getCbaCodes"
      input-formatter="$ctrl.getCbaLabel"
      tooltip-html="{{$ctrl.getToolTipHtml()}}">
    </salaxy-input-typeahead>
    <div ng-show="{{$ctrl.name}}Form.{{$ctrl.name}}.$invalid && $ctrl.validationError && ({{$ctrl.name}}Form.{{$ctrl.name}}.$touched || {{$ctrl.name}}Form.$$parentForm.$submitted)">
      {{$ctrl.validationError | sxyTranslate}}
    </div>
  </salaxy-form-group>
</ng-form>`), s.put("salaxy-components/form-controls/InputDuration.html", `<salaxy-form-group ng-if="$ctrl.getReadOnly()" name="{{$ctrl.name}}" class="salaxy-component salaxy-read-only" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
  <div class="form-control-plaintext">{{ $ctrl.value | sxyDuration }} </div>
</salaxy-form-group>
<ng-form name="{{$ctrl.name}}Form" class="salaxy-component salaxy-input-duration" ng-if="!$ctrl.getReadOnly()">
  <salaxy-form-group ng-if="!$ctrl.getReadOnly()" name="{{$ctrl.name}}" require="$ctrl.require" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
    <salaxy-input-number name="{{$ctrl.name}}Days" ng-model="$ctrl.innerValue.days" ng-change="$ctrl.onChange()" label-type="plain" unit="days"></salaxy-input-number>
    <salaxy-input-boolean type="select" name="{{$ctrl.name}}Negative" ng-model="$ctrl.innerValue.isNegative" ng-change="$ctrl.onChange()" label-true="SALAXY.NG1.InputDurationComponent.labelTrue" label-false="SALAXY.NG1.InputDurationComponent.labelFalse" label-type="plain"></salaxy-input-boolean>
    <div ng-show="!$ctrl.disableValidationErrors && ($ctrl.validationErrors.length > 0 && ({{$ctrl.name}}Form.{{$ctrl.name}}.$touched || {{$ctrl.name}}Form.$$parentForm.$submitted))" class="input-errors">
      <span class="salaxy-validation-error text-danger small" ng-repeat="validationError in $ctrl.validationErrors" sxy-text="{{ validationError}}" params="{ minlength: $ctrl.minlength, maxlength: $ctrl.maxlength }"></span><br/>
    </div>
  </salaxy-form-group>
</ng-form>`), s.put("salaxy-components/form-controls/InputEnum.html", `<salaxy-form-group ng-if="$ctrl.getReadOnly() && $ctrl.type != 'multi-select'" name="{{$ctrl.name}}" class="salaxy-component salaxy-read-only" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
  <div class="form-control-plaintext">{{ $ctrl.getEnumerationLabel($ctrl.value) }}</div>
</salaxy-form-group>
<salaxy-form-group ng-if="$ctrl.getReadOnly() && $ctrl.type == 'multi-select'" name="{{$ctrl.name}}" class="salaxy-component salaxy-read-only" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
  <div ng-repeat="x in $ctrl.value" class="form-control-plaintext">{{ $ctrl.getEnumerationLabel(x)}}</div>
</salaxy-form-group>
<ng-form name="{{$ctrl.name}}Form" ng-if="!$ctrl.getReadOnly()" class="salaxy-input-enum">
  <salaxy-form-group ng-if="$ctrl.inputMode == 'openClose' &&  !$ctrl.isOpen" name="{{$ctrl.name}}" class="salaxy-component salaxy-read-only" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
    <div class="form-control-plaintext">{{ $ctrl.getEnumerationLabel($ctrl.value) }}
      <span class="float-end btn-padding-right">
          <i ng-click="$ctrl.isOpen = !$ctrl.isOpen" class="bi bi-pencil-fill clickable"></i>
      </span>
    </div>
  </salaxy-form-group>
  <salaxy-form-group ng-if="($ctrl.type || 'select')=='select' && (!$ctrl.inputMode || ($ctrl.inputMode == 'openClose' && $ctrl.isOpen))" name="{{$ctrl.name}}" require="$ctrl.require" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
    <div ng-class="{'input-group': $ctrl.inputMode == 'openClose'}">
      <select ng-disabled="$ctrl.getDisabled()" id="{{$ctrl.name}}" name="{{$ctrl.name}}" ng-change="$ctrl.setStoredValue($ctrl.name, $ctrl.value);$ctrl.onChange()" ng-model="$ctrl.value" class="form-select" ng-required="$ctrl.require" sxy-exclude-unknowns="$ctrl.require ? $ctrl.invalidEnums : ''">
        <option ng-if="$ctrl.showPlaceholder" value="{{$ctrl.value}}" disabled selected>{{ $ctrl.placeholder || 'SALAXY.UI_Terms.select' | sxyTranslate }}</option>
        <option ng-repeat="x in $ctrl.getEnumerations()" value="{{x.value}}" title="{{x.title}}">{{$ctrl.formatLabel(x)}}</option>
      </select>
      <div class="input-group-btn ms-auto" ng-if="$ctrl.inputMode == 'openClose'">
        <button class="btn btn-transparent" ng-click="$ctrl.isOpen = !$ctrl.isOpen">
          <i class="bi bi-pencil-fill"></i>
        </button>
      </div>
    </div>
  </salaxy-form-group>
  <salaxy-form-group ng-if="$ctrl.type=='radio'" name="{{$ctrl.name}}" require="$ctrl.require" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}" class="enum-radio">
    <div class="radio form-check d-flex" ng-repeat="x in $ctrl.getEnumerations()">
      <input class="form-check-input me-2 mt-0.5" ng-disabled="$ctrl.getDisabled()" ng-required="$ctrl.require" type="radio" ng-model="$ctrl.value" ng-change="$ctrl.onChange()" name="{{$ctrl.label}}" id="{{x.value}}" value="{{x.value}}" title="{{x.title}}">
      <label class="form-check-label radio-label" for="{{x.value}}">{{$ctrl.formatLabel(x)}}</label>
    </div>
  </salaxy-form-group>
  <salaxy-form-group ng-if="$ctrl.type=='multi-select'" name="{{$ctrl.name}}" require="$ctrl.require" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
    <select ng-disabled="$ctrl.getDisabled()" id="{{$ctrl.name}}" name="{{$ctrl.name}}" multiple ng-change="$ctrl.onChange()" ng-model="$ctrl.value" class="form-select">
      <option ng-repeat="x in $ctrl.getEnumerations()" value="{{x.value}}" title="{{x.title}}">{{$ctrl.formatLabel(x)}}</option>
    </select>
  </salaxy-form-group>
  <salaxy-form-group ng-if="$ctrl.type=='dropdown'" name="{{$ctrl.name}}" require="$ctrl.require" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
    <div class="dropdown" role="group">
      <button id="{{$ctrl.name}}" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" ng-disabled="$ctrl.getDisabled()">
        {{ $ctrl.getEnumerationLabel($ctrl.value) || $ctrl.placeholder || 'SALAXY.UI_Terms.select' | sxyTranslate }}
      </button>
      <ul class="dropdown-menu" role="menu" aria-labelledby="{{$ctrl.name}}">
        <li><a href="" ng-click="$ctrl.value=x.value;$ctrl.setStoredValue($ctrl.name, $ctrl.value);$ctrl.onChange()" ng-repeat="x in $ctrl.getEnumerations()" class="dropdown-item">{{$ctrl.formatLabel(x)}}</a></li>
      </ul>
    </div>
  </salaxy-form-group>
</ng-form>`), s.put("salaxy-components/form-controls/InputEnumTypeaheadMatch.html", `<a ng-if="match.model.ui.avatar" class="clickable salaxy-component salaxy-worker-item" style="padding: 10px 10px 5px 10px;">
  <salaxy-avatar style="font-size: 30px; vertical-align: middle; margin-right: 10px;" avatar="match.model.ui.avatar"></salaxy-avatar>
  <b class="salaxy-highlight" ng-bind-html="match.label | uibTypeaheadHighlight:query"></b><br />
</a>
<a ng-if="!match.model.ui.avatar" href
   tabindex="-1"
   ng-bind-html="match.label | uibTypeaheadHighlight:query"
   ng-attr-title="{{match.model.title}}">
</a>`), s.put("salaxy-components/form-controls/InputHolidayMultipliers.html", `<salaxy-form-group ng-if="$ctrl.getReadOnly()" name="{{$ctrl.name}}" class="salaxy-component salaxy-read-only" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
  <div class="salaxy-read-only-value">
    <table ng-if="$ctrl.value" class="table table-condensed table-striped">
      <thead>
        <tr>
          <th class="right" sxy-terms="SALAXY.NG1.WorkerHolidaysComponent.UI.inputs.days"></th>
          <th class="right" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.inputs.multiplier"></th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="(key, value) in $ctrl.value track by $index">
          <td class="right">{{key}}</td>
          <td class="right">{{value}}</td>
        </tr>
    </table>
  </div>
</salaxy-form-group>

<ng-form ng-if="!$ctrl.getReadOnly()" name="{{$ctrl.name}}Form" class="salaxy-component salaxy-input form-condensed">
  <salaxy-form-group name="{{$ctrl.name}}" label="{{$ctrl.label}}" require="$ctrl.require" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
    <div>
      <table class="table table-condensed table-striped">
        <thead>
          <tr>
            <th class="right" sxy-terms="SALAXY.NG1.WorkerHolidaysComponent.UI.inputs.days"></th>
            <th class="right" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.inputs.multiplier"></th>
            <th class="text-right">
              <button type="button" class="btn btn-primary btn-xs"  ng-click="$ctrl.createNew({})" sxy-text="SALAXY.UI_Terms.addRow"></button>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="(key, value) in $ctrl.value">
            <td ng-init="editableKey=key" class="right"><salaxy-input-number name="Key{{key}}" label-type="no-label" ng-model="editableKey" ng-change="$ctrl.onKeyChanged(key, editableKey)" sxy-integer></salaxy-input-number></td>
            <td class="right"><salaxy-input-number name="Value{{key}}" label-type="no-label" ng-model="$ctrl.value[key]" ng-change="$ctrl.onChange()"></salaxy-input-number></td>
            <td class="text-right">
              <button type="button" class="btn btn-danger btn-xs" ng-click="$ctrl.delete(key)">
                <i class="bi bi-trash" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div ng-show="!$ctrl.disableValidationErrors && ($ctrl.validationErrors.length > 0 && ({{$ctrl.name}}Form.{{$ctrl.name}}.$touched || {{$ctrl.name}}Form.$$parentForm.$submitted))" class="input-errors">
      <span class="salaxy-validation-error text-danger small" ng-repeat="validationError in $ctrl.validationErrors" sxy-text="{{ validationError}}" params="{ minlength: $ctrl.minlength, maxlength: $ctrl.maxlength }"></span><br/>
    </div>
  </salaxy-form-group>
</ng-form>`), s.put("salaxy-components/form-controls/InputHolidayRowType.html", `<salaxy-form-group ng-if="$ctrl.getReadOnly()" name="{{$ctrl.name}}" class="salaxy-component salaxy-read-only" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
  <div class="salaxy-read-only-value">
    <span class="badge bg-default" ng-if="!$ctrl.isExclusive">{{ $ctrl.text }}</span>
    <span class="badge bg-danger" ng-if="$ctrl.isExclusive"><s>{{ $ctrl.text }}</s></span>
  </div>
</salaxy-form-group>

<ng-form ng-if="!$ctrl.getReadOnly()" name="{{$ctrl.name}}Form" class="salaxy-component salaxy-input">
  <salaxy-form-group name="{{$ctrl.name}}" label="{{$ctrl.label}}" require="$ctrl.require" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
    <div class="clickable" ng-click="$ctrl.edit()">
      <span class="badge bg-default" ng-if="!$ctrl.isExclusive">{{ $ctrl.text || ('SALAXY.UI_Terms.new' | sxyTranslate) }}</span> 
      <span class="badge bg-danger" ng-if="$ctrl.isExclusive"><s>{{ $ctrl.text || ('SALAXY.UI_Terms.new' | sxyTranslate)}}</s></span>
    </div>
    <div ng-show="!$ctrl.disableValidationErrors && ($ctrl.validationErrors.length > 0 && ({{$ctrl.name}}Form.{{$ctrl.name}}.$touched || {{$ctrl.name}}Form.$$parentForm.$submitted))" class="input-errors">
      <span class="salaxy-validation-error text-danger small" ng-repeat="validationError in $ctrl.validationErrors" sxy-text="{{ validationError}}" params="{ minlength: $ctrl.minlength, maxlength: $ctrl.maxlength }"></span><br/>
    </div>
  </salaxy-form-group>
</ng-form>`), s.put("salaxy-components/form-controls/InputIncomeType.html", `<salaxy-form-group ng-if="$ctrl.getReadOnly()" name="{{$ctrl.name}}" class="salaxy-component salaxy-read-only" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
  <div class="form-control-plaintext">{{ $ctrl.getRowLabel($ctrl.value) }}</div>
</salaxy-form-group>
<ng-form name="{{$ctrl.name}}Form" ng-if="!$ctrl.getReadOnly()">
  <salaxy-form-group name="{{$ctrl.name}}" ng-if="!$ctrl.type || $ctrl.type == 'typehead'" require="$ctrl.require" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
    <salaxy-input-typeahead
      ng-model="$ctrl.value"
      label-type="no-label"
      name="{{ $ctrl.name }}"
      get-options="$ctrl.getIncomeTypes"
      ng-change="$ctrl.onChange()"
      disable-cache="true"
      placeholder="{{ $ctrl.getPlaceholder() | sxyTranslate }}"
      ng-disabled="$ctrl.getDisabled()"
      input-formatter="$ctrl.getRowLabel">
    </salaxy-input-typeahead>
    <div ng-show="{{$ctrl.name}}Form.{{$ctrl.name}}.$invalid && $ctrl.validationError && ({{$ctrl.name}}Form.{{$ctrl.name}}.$touched || {{$ctrl.name}}Form.$$parentForm.$submitted)">
      {{$ctrl.validationError | sxyTranslate}}
    </div>
  </salaxy-form-group>
  <salaxy-form-group name="{{$ctrl.name}}" ng-if="$ctrl.type == 'list'" require="$ctrl.require" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
    <input type="hidden" ng-model="$ctrl.value" id="{{$ctrl.name}}" name="{{$ctrl.name}}" ng-required="$ctrl.require">
    <div class="list-group">
      <a ng-repeat="type in $ctrl.getIncomeTypes()" ng-click="$ctrl.selectionClicked(type.code)" class="list-group-item clickable" ng-class="{ 'active': $ctrl.value == type.code, 'clickable': !$ctrl.readonly && !$ctrl.disabled }">
        <salaxy-avatar class="salaxy-calc-row-type-avatar float-start" avatar="{ color: '#2b507c', initials: type.code, entityType: 'company' }"></salaxy-avatar>
        <b class="salaxy-highlight" ng-bind-html="$ctrl.getRowLabel(type.code) | uibTypeaheadHighlight:$ctrl.searchText"></b><br />
        <small class="salaxy-highlight">
          <div ng-bind-html="type.description | uibTypeaheadHighlight:$ctrl.searchText" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"></div>
        </small>
      </a>
    </div>
    <div ng-show="{{$ctrl.name}}Form.{{$ctrl.name}}.$invalid && $ctrl.validationError && ({{$ctrl.name}}Form.{{$ctrl.name}}.$touched || {{$ctrl.name}}Form.$$parentForm.$submitted)">
      {{$ctrl.validationError | sxyTranslate}}
    </div>
  </salaxy-form-group>
</ng-form>`), s.put("salaxy-components/form-controls/InputIncomeTypeItem.html", `<a class="clickable">
    <salaxy-avatar class="salaxy-calc-row-type-avatar float-start" 
    avatar="{ color: '#2b507c', initials: match.model.code, entityType: 'company' }"></salaxy-avatar>
    
    <b class="salaxy-highlight" ng-bind-html="(match.label + ' (' + match.model.code + ')') | uibTypeaheadHighlight:query"></b><br />
    <small class="salaxy-highlight"><div ng-bind-html="match.model.description | uibTypeaheadHighlight:query"></div></small>
</a>`), s.put("salaxy-components/form-controls/InputNumber.html", `<salaxy-form-group ng-if="$ctrl.getReadOnly()" name="{{$ctrl.name}}" class="salaxy-component salaxy-read-only" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
  <div class="form-control-plaintext ">{{ $ctrl.viewValue + ($ctrl.getUnitIndicator() ? " " + $ctrl.getUnitIndicator() : "") }}</div>
</salaxy-form-group>
<ng-form ng-if="!$ctrl.getReadOnly()" name="{{$ctrl.name}}Form" class="salaxy-component salaxy-read-only salaxy-input-number salaxy-input">
  <salaxy-form-group ng-if="(!$ctrl.type || $ctrl.type == 'default') && $ctrl.inputMode == 'openClose' &&  !$ctrl.isOpen" name="{{$ctrl.name}}" class="salaxy-component salaxy-read-only" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
    <div class="form-control-plaintext">{{ $ctrl.value }}
      <span class="float-end btn-padding-right">
          <i ng-click="$ctrl.isOpen = !$ctrl.isOpen" class="bi bi-pencil-fill clickable"></i>
      </span>
    </div>
  </salaxy-form-group>

  <salaxy-form-group ng-if="(!$ctrl.type || $ctrl.type == 'default') && !$ctrl.inputMode || ($ctrl.inputMode == 'openClose' && $ctrl.isOpen)" name="{{$ctrl.name}}" require="$ctrl.require" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
    <div ng-if="$ctrl.getUnitIndicator()" class="input-group">
      <div ng-if="!$ctrl.units" class="input-group-text">{{ $ctrl.getUnitIndicator() }}</div>
      <div ng-if="$ctrl.units" class="input-group-btn dropdown">
        <button id="units" type="button" class="btn btn-secondary dropdown-toggle" data-bs-toggle="dropdown">
          {{ $ctrl.getUnitIndicator() }}
        </button>
        <ul class="dropdown-menu" role="menu" aria-labelledby="units">
          <li ng-repeat="unit in $ctrl.units" role="menuitem">
            <a href="" ng-click="$ctrl.changeUnit(unit)" class="dropdown-item">{{$ctrl.getUnitIndicator(unit)}}</a>
          </li>
        </ul>
      </div>
      <input type="text" class="form-control text-end" autocomplete="off" id="{{$ctrl.name}}" name="{{$ctrl.name}}" placeholder="{{ $ctrl.getPlaceholder() | sxyTranslate}}" ng-model="$ctrl.viewValue" ng-model-options="{allowInvalid: true, updateOn: 'blur' }"
        ng-required="$ctrl.require" ng-readonly="$ctrl.readonly" ng-disabled="$ctrl.getDisabled()" sxy-min="$ctrl.minimum" sxy-max="$ctrl.maximum" />
      <div ng-if="$ctrl.getToolTipHtml() || $ctrl.inputMode == 'openClose'" class="input-group-btn">
        <a ng-if="$ctrl.getToolTipHtml()" tabindex="0" type="button" class="btn btn-default" data-bs-toggle="popover" data-bs-container="body" aria-label="Info" data-bs-html="true" data-bs-title="'Info'" data-bs-content="$ctrl.getToolTipHtml()" data-bs-placement="'{{$ctrl.tooltipPlacement}}'" sxy-bs5-popover>
          <span class="bi bi-question-circle-fill"></span>
        </a>
        <button ng-if="$ctrl.inputMode == 'openClose'" class="btn btn-transparent" ng-click="$ctrl.isOpen = !$ctrl.isOpen">
          <i class="bi bi-pencil-fill"></i>
        </button>
        
      </div>
    </div>
    <div ng-if="!$ctrl.getUnitIndicator() && !$ctrl.getToolTipHtml()" ng-class="{'input-group': $ctrl.inputMode == 'openClose'}">

      <input type="text" class="form-control text-end" autocomplete="off" id="{{$ctrl.name}}" name="{{$ctrl.name}}" placeholder="{{ $ctrl.getPlaceholder() | sxyTranslate}}" ng-model="$ctrl.viewValue" ng-model-options="{allowInvalid: true, updateOn: 'blur'}"
        ng-required="$ctrl.require" ng-readonly="$ctrl.readonly" ng-disabled="$ctrl.getDisabled()" sxy-min="$ctrl.minimum" sxy-max="$ctrl.maximum" />
      <div class="input-group-btn" ng-if="$ctrl.inputMode == 'openClose'">

        <button class="btn btn-transparent float-end" ng-click="$ctrl.isOpen = !$ctrl.isOpen">
          <i class="bi bi-pencil-fill"></i>
        </button>
      </div>
    </div>
    <div ng-if="!$ctrl.getUnitIndicator() && $ctrl.getToolTipHtml()" class="input-group">

      <input type="text" class="form-control text-end" autocomplete="off" id="{{$ctrl.name}}" name="{{$ctrl.name}}" placeholder="{{ $ctrl.getPlaceholder() | sxyTranslate}}" ng-model="$ctrl.viewValue" ng-model-options="{allowInvalid: true, updateOn: 'blur'}"
        ng-required="$ctrl.require" ng-readonly="$ctrl.readonly" ng-disabled="$ctrl.getDisabled()" sxy-min="$ctrl.minimum" sxy-max="$ctrl.maximum" sxy-multiple-of="$ctrl.multipleOf" />

      <div class="input-group-btn">
        <button type="button" class="btn btn-default" data-bs-container="body" aria-label="Info" data-bs-toggle="popover" data-bs-html="true" data-bs-title="'Info'" data-bs-content="$ctrl.getToolTipHtml()" data-bs-placement="'{{$ctrl.tooltipPlacement}}'" sxy-bs5-popover>
          <span class="bi bi-question-circle-fill"></span>
        </button>
        <button ng-if="$ctrl.inputMode == 'openClose'" class="btn btn-transparent" ng-click="$ctrl.isOpen = !$ctrl.isOpen">
          <i class="bi bi-pencil-fill"></i> 
        </button>
      </div>
    </div>
    <div ng-show="$ctrl.validationErrors.length > 0 && ({{$ctrl.name}}Form.{{$ctrl.name}}.$touched || {{$ctrl.name}}Form.$$parentForm.$submitted)" class="input-errors">
      <span class="salaxy-validation-error text-danger small" ng-repeat="validationError in $ctrl.validationErrors" sxy-text="{{ validationError}}" params="{ minlength: $ctrl.minlength, maxlength: $ctrl.maxlength }"></span><br/>
    </div>
  </salaxy-form-group>
  <salaxy-form-group ng-if="$ctrl.type == 'slider'" name="{{$ctrl.name}}" require="$ctrl.require" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
     <input type="range" class="form-control text-end" id="{{$ctrl.name}}" name="{{$ctrl.name}}" min="{{$ctrl.minimum}}" max="{{$ctrl.maximum}}" step="{{$ctrl.sliderStep}}" ng-model="$ctrl.value" ng-change="$ctrl.onChange()"/>
  </salaxy-form-group>
</ng-form>`), s.put("salaxy-components/form-controls/InputOccupationType.html", `<salaxy-form-group ng-if="$ctrl.getReadOnly()" name="{{$ctrl.name}}" class="salaxy-component salaxy-read-only" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
  <div class="form-control-plaintext">{{ $ctrl.getOccupationLabel($ctrl.value) }}</div>
</salaxy-form-group>
<ng-form ng-if="!$ctrl.getReadOnly()" name="{{$ctrl.name}}Form" class="salaxy-component salaxy-input-occupation-type">
  <salaxy-form-group name="{{$ctrl.name}}" require="$ctrl.require" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
    <salaxy-input-typeahead
      label-type="no-label"
      ng-model="$ctrl.value"
      ng-change="$ctrl.onChange()"
      name="{{ $ctrl.name }}"
      disable-cache="true"
      placeholder="{{ $ctrl.getPlaceholder() | sxyTranslate }}"
      get-options="$ctrl.getOccupations"
      input-formatter="$ctrl.getOccupationLabel">
    </salaxy-input-typeahead>
    <div ng-show="{{$ctrl.name}}Form.{{$ctrl.name}}.$invalid && $ctrl.validationError && ({{$ctrl.name}}Form.{{$ctrl.name}}.$touched || {{$ctrl.name}}Form.$$parentForm.$submitted)">
      {{$ctrl.validationError | sxyTranslate}}
    </div>
  </salaxy-form-group>
</ng-form>`), s.put("salaxy-components/form-controls/InputProfileItem.html", `<a class="clickable salaxy-component salaxy-avatar-item">
  <salaxy-avatar class="salaxy-calc-row-type-avatar float-start" 
  avatar="match.model"></salaxy-avatar>
  <b class="salaxy-highlight" ng-bind-html="match.label | uibTypeaheadHighlight:query"></b><br />
  <small class="salaxy-highlight"><div ng-bind-html="(match.model.description || '') | uibTypeaheadHighlight:query"></div></small>
</a>`), s.put("salaxy-components/form-controls/InputRrule.html", `<salaxy-form-group ng-if="$ctrl.getReadOnly()" name="{{$ctrl.name}}" class="salaxy-component salaxy-read-only" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
  <div class="form-control-plaintext">{{ $ctrl.getRRuleText($ctrl.value) }} </div>
</salaxy-form-group>
<ng-form name="{{$ctrl.name}}Form" class="salaxy-component salaxy-input-duration" ng-if="!$ctrl.getReadOnly()">
  <salaxy-form-group ng-if="!$ctrl.getReadOnly()" name="{{$ctrl.name}}" require="$ctrl.require" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}" class="salaxy-read-only">
    <!-- TODO: Better UI -->
    <div class="form-control-plaintext">
      <a href="" ng-click="$ctrl.showRRule = !$ctrl.showRRule">{{ $ctrl.getRRuleText($ctrl.value) }}</a>
      <salaxy-input ng-if="$ctrl.showRRule" name="{{$ctrl.name}}Inner" ng-model="$ctrl.value" ng-change="$ctrl.onChange()" label-type="plain"></salaxy-input>
    </div>
    <div ng-show="!$ctrl.disableValidationErrors && ($ctrl.validationErrors.length > 0 && ({{$ctrl.name}}Form.{{$ctrl.name}}.$touched || {{$ctrl.name}}Form.$$parentForm.$submitted))" class="input-errors">
      <span class="salaxy-validation-error text-danger small" ng-repeat="validationError in $ctrl.validationErrors" sxy-text="{{ validationError}}" params="{ minlength: $ctrl.minlength, maxlength: $ctrl.maxlength }"></span><br/>
    </div>
  </salaxy-form-group>
</ng-form>`), s.put("salaxy-components/form-controls/InputTime.html", `<salaxy-form-group ng-if="$ctrl.getReadOnly()" name="{{$ctrl.name}}" class="salaxy-component salaxy-read-only" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
  <div class="form-control-plaintext">{{ $ctrl.viewValue }}</div>
</salaxy-form-group>
<ng-form ng-if="!$ctrl.getReadOnly()" name="{{$ctrl.name}}Form" class="salaxy-component salaxy-input  salaxy-input-number salaxy-input-time">
  <salaxy-form-group ng-if="$ctrl.type == 'minutes'" name="{{$ctrl.name}}" require="$ctrl.require" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
    <input type="time" id="{{$ctrl.name}}" name="{{$ctrl.name}}" ng-model="$ctrl.viewValue" ng-model-options="{allowInvalid: true, debounce: 1000}" ng-required="$ctrl.require" class="form-control">
  </salaxy-form-group>
  <salaxy-form-group ng-if="$ctrl.type == 'time'" name="{{$ctrl.name}}" require="$ctrl.require" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
    <input type="time" id="{{$ctrl.name}}" name="{{$ctrl.name}}" ng-model="$ctrl.viewValue" ng-model-options="{allowInvalid: true, debounce: 1000}" ng-required="$ctrl.require" class="form-control">
  </salaxy-form-group>
</ng-form>`), s.put("salaxy-components/form-controls/InputTypeahead.html", `<salaxy-form-group ng-if="$ctrl.getReadOnly()" name="{{ $ctrl.name }}" class="salaxy-component salaxy-read-only" label="{{ $ctrl.label }}" label-type="{{ $ctrl.labelType }}" label-cols="{{ $ctrl.labelCols }}">
  <div class="form-control-plaintext">{{ $ctrl.getEnumerationLabel($ctrl.value) }}</div>
</salaxy-form-group>
<ng-form name="{{$ctrl.name}}Form" ng-if="!$ctrl.getReadOnly()" class="salaxy-input-typeahead">
  <salaxy-form-group name="{{ $ctrl.name }}" require="$ctrl.require" label="{{ $ctrl.label }}" label-type="{{ $ctrl.labelType }}" label-cols="{{ $ctrl.labelCols }}">
    <div class="typeahead-wrapper d-flex">
      <div class="position-relative w-100">
        <input
          type="text"
          name="{{ $ctrl.name }}"
          class="form-control typeahead-input"
          ng-model="$ctrl.displayText"
          placeholder="{{ $ctrl.placeholder }}"
          ng-change="$ctrl.onInputChange()"
          ng-click="$ctrl.showAllItems()"
          ng-blur="$ctrl.onBlur()"
          ng-model-options="{ allowInvalid: true, debounce: 250 }"
          ng-required="$ctrl.require"
          ng-disabled="$ctrl.getDisabled()"
          autocomplete="off"
          get-options="$ctrl.getOptions"/>
        <ul class="typeahead-menu dropdown-menu typeahead-result-list d-none">
          <li class="dropdown-item clickable px-2 input-typeahead-option d-flex align-items-center" ng-repeat="item in $ctrl.filteredItems" ng-click="$ctrl.selectItem(item)" ng-class="item.ui.isChild ? 'typeahead-child-result py-0' : 'py-1'">
            <salaxy-avatar ng-if="item.ui || item.ui.avatar" class="salaxy-calc-row-type-avatar" ng-class="item.ui.isChild ? 'invisible' : ''" avatar="item.ui"></salaxy-avatar>
            <div class="typeahead-result">
              <i ng-if="item.ui.isChild" class="bi bi-square-fill me-2"></i>
              <b ng-if="item.ui" class="salaxy-highlight display-block">{{ item.text }}</b>
              <div ng-if="!item.ui" class="salaxy-highlight">
                {{ item.text || item.value + ' (' + item.value + ')' }}
              </div>
              <small ng-if="item.title" class="salaxy-highlight">
                <div ng-if="!item.ui.isChild" ng-bind-html="item.title" class="text-truncate"></div>
                <span ng-if="item.ui.isChild" ng-bind-html="item.title" class="text-truncate"></span>
              </small>
            </div>
          </li>
        </ul>
        <button type="button" class="clear btn-close" ng-if="$ctrl.value && !$ctrl.getDisabled()" ng-click="$ctrl.clearValue()"></button>
      </div>
      <div class="input-group-btn">
        <button ng-if="$ctrl.getToolTipHtml()" type="button" class="btn btn-default" data-bs-toggle="popover" data-bs-container="body" aria-label="Info" data-bs-html="true" data-bs-title="'Info'" data-bs-content="$ctrl.getToolTipHtml()" sxy-bs5-popover>
          <span class="bi bi-question-circle-fill"></span>
        </button>
      </div>
    </div>
  </salaxy-form-group>
</ng-form>`), s.put("salaxy-components/form-controls/InputWorkerItem.html", `<a class="clickable salaxy-component salaxy-worker-item">
    <salaxy-avatar class="salaxy-calc-row-type-avatar pull-left" 
    avatar="match.model"></salaxy-avatar>
    <b class="salaxy-highlight" ng-bind-html="match.label + ' (' + match.model.displayId + ')' | uibTypeaheadHighlight:query"></b><br />
    <small class="salaxy-highlight"><div ng-bind-html="match.model.description | uibTypeaheadHighlight:query"></div></small>
</a>`), s.put("salaxy-components/form-controls/Textarea.html", `<salaxy-form-group ng-if="$ctrl.getReadOnly()" name="{{$ctrl.name}}" class="salaxy-component salaxy-read-only" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
  <div class="form-control-plaintext">{{ $ctrl.value }}</div>
</salaxy-form-group>
<ng-form ng-if="!$ctrl.getReadOnly()" name="{{$ctrl.name}}Form" class="salaxy-component salaxy-textarea">
  <salaxy-form-group ng-if="$ctrl.inputMode == 'openClose' &&  !$ctrl.isOpen" name="{{$ctrl.name}}" class="salaxy-component salaxy-read-only" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
    <div class="">
      <span class="form-control-plaintext" style="max-width:90%; display:inline-block;">{{ $ctrl.value }}</span>
      <span class="float-end btn-padding-right" style="padding-top:7px;">
        <i ng-click="$ctrl.isOpen = !$ctrl.isOpen" class="bi bi-pencil-fill clickable"></i>
      </span>
    </div>

  </salaxy-form-group>
  <salaxy-form-group ng-if="!$ctrl.inputMode || ($ctrl.inputMode == 'openClose' && $ctrl.isOpen)" name="{{$ctrl.name}}" label="{{$ctrl.label}}" require="$ctrl.require" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
    <div ng-if="$ctrl.getToolTipHtml()" class="input-group">
      <textarea class="form-control" autocomplete="off" id="{{$ctrl.name}}" name="{{$ctrl.name}}" placeholder="{{ $ctrl.getPlaceholder() | sxyTranslate }}" ng-model="$ctrl.value" ng-model-options="{allowInvalid: true, debounce: 250, updateOn: 'default' }" ng-change="$ctrl.onChange()"
        ng-pattern="$ctrl.pattern" ng-required="$ctrl.require" ng-readonly="$ctrl.readonly" ng-disabled="$ctrl.getDisabled()" ng-minlength="$ctrl.minlength" ng-maxlength="$ctrl.maxlength" maxlength="{{$ctrl.maxlength}}" rows="{{ $ctrl.rows || 3 }}"></textarea>
      <div class="input-group-btn">
        <button type="button" class="btn btn-default" data-bs-container="body" aria-label="Info" data-bs-toggle="popover" data-bs-html="true" data-bs-title="'Info'" data-bs-content="$ctrl.getToolTipHtml()" data-bs-placement="'{{$ctrl.tooltipPlacement}}'" sxy-bs5-popover>
          <span class="bi bi-question-circle-fill"></span>
        </button>
        <button ng-if="$ctrl.inputMode == 'openClose'" class="btn btn-transparent" ng-click="$ctrl.isOpen = !$ctrl.isOpen">
          <i class="bi bi-pencil-fill"></i>
        </button>
      </div>
    </div>
    <div ng-class="{'input-group': $ctrl.inputMode == 'openClose'}">
      <textarea ng-if="!$ctrl.getToolTipHtml()" class="form-control" autocomplete="off" id="{{$ctrl.name}}" name="{{$ctrl.name}}" placeholder="{{ $ctrl.getPlaceholder() | sxyTranslate }}" ng-model="$ctrl.value" ng-model-options="{allowInvalid: true, debounce: 250, updateOn: 'default' }"
        ng-change="$ctrl.onChange()" ng-pattern="$ctrl.pattern" ng-required="$ctrl.require" ng-readonly="$ctrl.readonly" ng-disabled="$ctrl.getDisabled()" ng-minlength="$ctrl.minlength" ng-maxlength="$ctrl.maxlength" maxlength="{{$ctrl.maxlength}}" rows="{{ $ctrl.rows || 3 }}"></textarea>
      <div class="input-group-btn" ng-if="$ctrl.inputMode == 'openClose'">
        <button class="btn btn-transparent float-end" ng-click="$ctrl.isOpen = !$ctrl.isOpen">
          <i class="bi bi-pencil-fill"></i>
        </button>
      </div>
    </div>
    <div ng-show="!$ctrl.disableValidationErrors && ($ctrl.validationErrors.length > 0 && ({{$ctrl.name}}Form.{{$ctrl.name}}.$touched || {{$ctrl.name}}Form.$$parentForm.$submitted))" class="input-errors">
      <span class="salaxy-validation-error text-danger small" ng-repeat="validationError in $ctrl.validationErrors" sxy-text="{{ validationError}}" params="{ minlength: $ctrl.minlength, maxlength: $ctrl.maxlength }"></span><br/>
    </div>
  </salaxy-form-group>
</ng-form>`), s.put("salaxy-components/form-controls/ToggleButtons.html", `<div class="salaxy-component salaxy-toggle-buttons btn-group" role="group" 
     ng-class="{
         'd-block': $ctrl.type === 'block',
         'row': $ctrl.type === 'row',
         'd-inline-block': $ctrl.type === 'inline'
     }">
  <div ng-repeat="item in $ctrl.options track by $index" index="$index" class="toggle-button-wrapper" ng-if="!item.hidden"
       ng-class="{
           'd-block': $ctrl.type === 'block',
           'col-2': $ctrl.type === 'row',
           'd-inline-block': $ctrl.type === 'inline'
       }">
    <input type="radio" class="btn-check" name="btn-toggle" id="btn-toggle-{{ item.value }}" autocomplete="off" ng-model="$ctrl.model.$viewValue" ng-value="item.value" ng-disabled="item.disabled">
    <label class="btn btn-sm btn-outline-primary toggle-button" for="btn-toggle-{{ item.value }}" ng-click="$ctrl.onClick(item.value)" 
           ng-class="{
               'btn-primary': $ctrl.model.$viewValue == item.value,
               'btn-default': $ctrl.model.$viewValue != item.value,
               'btn-block': $ctrl.type === 'block',
               'd-inline-block': $ctrl.type === 'inline',
               'flex-fill': $ctrl.type === 'row'
           }">
      <img ng-if="item.imgSrc" class="toggle-button-image me-2" ng-src="{{ item.imgSrc }}"/>
      <span class="toggle-button-label">{{ item.label | sxyTranslate }}</span>
    </label>
  </div>
</div>
`), s.put("salaxy-components/form-controls/ValidationSummary.html", `<div ng-if="!$ctrl.hasValidation" ng-bind-html="$ctrl.loadingHtml"></div>
<div ng-if="$ctrl.hasValidation" class="salaxy-component salaxy-validation-summary">
  <ng-transclude ng-if="$ctrl.isValid"></ng-transclude>
  <div ng-if="$ctrl.layout != 'minimal'">
    <div ng-if="!$ctrl.isValid" class="alert alert-danger">
      <div ng-if="$ctrl.hasValidationOrGeneralErrors">
        <h4 sxy-text="SALAXY.NG1.ValidationSummaryComponent.checkForErrors" ps=":"></h4>
        <ul class="validation-error-list">
          <li ng-repeat="error in $ctrl.getErrors('!required') | limitTo:3" ng-class="error.type">{{ $ctrl.getLabel(error) }}</li>
        </ul>
      </div>
      <div ng-if="!$ctrl.hasAllRequiredFields">
        <h4 sxy-text="SALAXY.NG1.ValidationSummaryComponent.missingRequired" ps=":"></h4>
        <ul class="validation-error-list">
          <li ng-repeat="error in $ctrl.getErrors('required') | limitTo:3" class="warning">{{ $ctrl.getLabel(error) }}</li>
        </ul>
      </div>
      <button class="btn btn-xs btn-danger float-end" ng-click="$ctrl.showDetails()" sxy-text="SALAXY.UI_Terms.readMore" ps="..."></button>
    </div>
    <div ng-if="$ctrl.hasWarningsOnly" class="alert alert-warning">
      <h4>Varoituksia:</h4>
      <ul>
        <li ng-repeat="error in $ctrl.getErrors('warning') | limitTo:3">{{ $ctrl.getLabel(error) }}</li>
      </ul>
      <button class="btn btn-xs btn-warning float-end" ng-click="$ctrl.showDetails()" sxy-text="SALAXY.UI_Terms.readMore" ps="..."></button>
    </div>
  </div>
  <span ng-if="$ctrl.layout == 'minimal' && (!$ctrl.isValid || $ctrl.hasWarningsOnly)" class="validation-container">
    <span ng-if="$ctrl.hasValidationOrGeneralErrors"><span ng-repeat="error in $ctrl.getErrors('!required') | limitTo:3" class="validation-error-item" ng-class="error.type">{{ $ctrl.getLabel(error) }}</span></span>
  <span ng-if="!$ctrl.hasAllRequiredFields"><span ng-repeat="error in $ctrl.getErrors('required') | limitTo:3" class="validation-error-item" ng-class="error.type">{{ $ctrl.getLabel(error) }}</span></span>
  <span ng-if="!$ctrl.hasWarningsOnly"><span ng-repeat="error in $ctrl.getErrors('warning') | limitTo:3" class="validation-error-item" ng-class="error.type">{{ $ctrl.getLabel(error) }}</span></span>
  </span>
</div>`), s.put("salaxy-components/form-controls/ValidationSummaryDetails.html", `<style type="text/css">
  .panel-validation {
    border-color: var(--salaxy-brand-danger);
  }
  
  .panel-heading-validation {
    border-color: var(--salaxy-brand-danger);
    background-color: var(--salaxy-brand-danger);
  }
</style>
<div class="salaxy-component salaxy-calc-details-dialog card-validation">
  <div class="modal-header card-header-validation">
    <h2 sxy-text="SALAXY.NG1.ValidationSummaryDetailsComponent.moreInfoTitle"></h2>
    <button type="button" class="btn-close float-end" ng-click="$close('cancel')" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <div ng-repeat="error in $ctrl.data.controller().getErrors()" class="alert" ng-class="error.type=='warning' ? 'alert-warning' : 'alert-danger'" role="alert">
      <b>{{$ctrl.data.controller().getLabel(error)}}</b>
      <br/>{{$ctrl.data.controller().getDescription(error)}}
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-primary float-end" ng-click="$close('ok')">OK</button>
  </div>
</div>`), s.put("salaxy-components/helpers/ActionButton.html", `<span class="d-flex" ng-switch="$ctrl.action">
  <a ng-switch-when="newCalc" href="#/calc/details/new" class="btn salaxy-action-button btn-new-calc btn-labeled-right" ng-class="$ctrl.buttonClass" ng-disabled="$ctrl.disabled"
    type="button" id="new-calc">
    {{$ctrl.label || 'SALAXY.NG1.ActionButtonComponent.newCalculation' | sxyTranslate}}<i class="bi bi-plus-lg"></i>
  </a>
  <span ng-switch-when="newRepair" ng-controller="CalculationCrudController as $calculationCtrl">
    <button ng-click="$calculationCtrl.launchCreateRepair($ctrl.onAfterAction)" class="btn salaxy-action-button btn-new-repair btn-labeled-right" ng-class="$ctrl.buttonClass"
      ng-disabled="$ctrl.disabled" type="button" id="new-repair">
      {{$ctrl.label || 'SALAXY.NG1.ActionButtonComponent.newRepair' | sxyTranslate}}<i class="bi bi-plus-lg"></i>
    </button>
  </span>
  <div ng-switch-when="newCalcForEmployment" class="btn-group btn-new-calc-for-employment dropdown" ng-class="$ctrl.buttonClass" id="new-calc-for-employment">
    <a class="btn btn-primary" href="#/calc/details/{{$ctrl.options.id}}/new-for-employment">{{$ctrl.label || 'SALAXY.NG1.ActionButtonComponent.newCalculation' | sxyTranslate}}</a>
    <button type="button" class="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      <span class="sr-only"sxy-text="SALAXY.NG1.ActionButtonComponent.addCalcTypes" ps="..."></span>
    </button>
    <ul class="dropdown-menu">
      <li><a href="#/calc/details/{{$ctrl.options.id}}/new-for-employment" class="dropdown-item" sxy-text="SALAXY.NG1.ActionButtonComponent.commonCalc"></a></li>
      <li><a href="#/calc/history/{{$ctrl.options.id}}/new-for-employment" class="dropdown-item" sxy-text="SALAXY.NG1.ActionButtonComponent.historicalCalc"></a></li>
    </ul>
  </div>
  <a ng-switch-when="newMessage" href="#/messages/details/new" class="btn salaxy-action-button btn-new-message btn-labeled-right" ng-class="$ctrl.buttonClass"
    ng-disabled="$ctrl.disabled" type="button" id="new-message">
    {{$ctrl.label || 'SALAXY.NG1.ActionButtonComponent.startNewMessage' | sxyTranslate}}<i class="bi bi-plus-lg"></i>
  </a>
  <a ng-switch-when="newPayroll" href="#/payroll/details/new" class="btn salaxy-action-button btn-new-payroll btn-labeled-right" ng-class="$ctrl.buttonClass"
    ng-disabled="$ctrl.disabled" type="button" id="new-payroll">
    {{$ctrl.label || 'SALAXY.NG1.ActionButtonComponent.newPayroll' | sxyTranslate}}<i class="bi bi-plus-lg"></i>
  </a>
  <span ng-switch-when="newWorker" ng-controller="EmploymentCrudController as $employmentCtrl">
    <button ng-click="$employmentCtrl.launchCreateEmploymentWizard()" class="btn salaxy-action-button btn-new-worker btn-labeled-right" ng-class="$ctrl.buttonClass"
      ng-disabled="$ctrl.disabled" type="button" id="new-worker">
      {{$ctrl.label || 'SALAXY.NG1.ActionButtonComponent.newWorker' | sxyTranslate}}<i class="bi bi-plus-lg"></i>
    </button>
  </span>
  <span ng-switch-when="newTaxcard">
    <a href="#/taxcards" class="btn salaxy-action-button btn-new-payroll btn-labeled-right" ng-class="$ctrl.buttonClass" ng-disabled="$ctrl.disabled" type="button"
      id="new-taxcard">
      {{$ctrl.label || 'SALAXY.NG1.ActionButtonComponent.sendTaxCard' | sxyTranslate}}<i class="bi bi-plus-lg"></i>
    </a>
  </span>
  <span ng-switch-default class="alert alert-danger" sxy-text="SALAXY.NG1.ActionButtonComponent.error"></span>
</span>`), s.put("salaxy-components/helpers/Alert.html", `<div class="salaxy-component salaxy-alert">
  <div ng-class="'alert alert-' + $ctrl.type">
    <div>
      <table style="width: 100%; border-collapse:separate;">
        <!-- TODO: Switch this to position:absolute & margins or flex-grid -->
        <tr>
          <td class="icon-container hidden-xxs" ng-if="$ctrl.getIcon()">
            <span class="icon"><i class="bi {{ $ctrl.getIcon() }}"></i></span>
          </td>
          <td>
            <div class="main ps-3">
              <ng-transclude ng-transclude-slot="main">
                <p>{{ $ctrl.text }}</p>
              </ng-transclude>
            </div>
          </td>
          <td ng-if="$ctrl.hasMoreInfo && !$ctrl.forceMoreInfo" class="text-end">
            <button class="btn btn-info btn-main" ng-click="$ctrl.showMoreInfo = !$ctrl.showMoreInfo" sxy-text="SALAXY.UI_Terms.learnMore"></button>
          </td>
        </tr>
      </table>
      <div class="collapse" ng-if="$ctrl.hasMoreInfo" ng-class="{ show: ($ctrl.showMoreInfo || $ctrl.forceMoreInfo) }">
        <ng-transclude ng-transclude-slot="aside"></ng-transclude>
      </div>
    </div>
  </div>
</div>`), s.put("salaxy-components/helpers/Avatar.html", `<i class="salaxy-avatar bi" ng-class="{'bi-person-fill': $ctrl.isPersonIcon, 'bi-square-fill': $ctrl.isCompanyIcon }" ng-style="{ color: $ctrl.color }">
  <img ng-src="{{ $ctrl.avatar.url }}" ng-show="$ctrl.isImage" />
  <strong ng-show="!$ctrl.isImage" ng-style="{'text-shadow': '1px 1px 0 ' + ($ctrl.color || 'black') + ', -1px -1px 0 ' + ($ctrl.color || 'black') + ', 1px -1px 0 ' + ($ctrl.color || 'black') + ', -1px 1px 0 ' + ($ctrl.color || 'black')}">
    {{ $ctrl.initials !== '-' ? $ctrl.initials : $ctrl.avatar.iconText }}
  </strong>
</i>`), s.put("salaxy-components/helpers/Calendar.html", `<div class="salaxy-component salaxy-calendar">
  <button ng-if="$ctrl.showExport" type="button" class="btn btn-default" ng-click="$ctrl.exportCalendarPdf()">
    <span class="d-none d-md-inline-block" sxy-text="SALAXY.UI_Terms.downloadPdf"></span>
    <i class="bi bi-file-earmark-pdf" aria-hidden="true"></i>
  </button>
  <button ng-if="$ctrl.showExport" type="button" class="btn btn-default" ng-click="$ctrl.exportCalendarExcel()">
    <span class="d-none d-md-inline-block" sxy-text="SALAXY.UI_Terms.downloadExcel"></span>
    <i class="bi bi-file-earmark-excel" aria-hidden="true"></i>
  </button>
  <div ng-if="$ctrl.mode == 'align-weekdays'">
    <table class="calendar">
      <thead>
        <tr>
          <th class="calendar-title">
            {{ $ctrl.start | date : "yyyy" }}
            <span ng-if="($ctrl.start | date : 'yyyy') != ($ctrl.end | date : 'yyyy')">- {{ $ctrl.end | date : "yyyy" }}</span>
          </th>
          <th class="day day-of-week-{{ day.weekday }}" ng-repeat="day in $ctrl.weekdaysForMonth track by $index">{{ day.text }}</th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="month in $ctrl.months">
          <td class="month-title">{{ month.title }}</td>
          <td class="beginning-spacer" ng-if="month.firstDayDayOfWeek > 1" colspan="{{ month.firstDayDayOfWeek - 1}}"></td>
          <td class="day day-of-week-{{ day.weekday }} day-type-{{ day.dayType }} clickable" ng-repeat="day in month.days" ng-click="$ctrl.dateClicked(day, $ctrl.series[0], $event)">
            <div ng-repeat="ev in day.periods[0]" ng-class="$ctrl.getCssClass(ev)" ng-click="$ctrl.eventClicked(ev, day, null, $event)" data-bs-toggle="tooltip" data-bs-title="'{{ ev.summary }}'" data-bs-container="body" ng-style="$ctrl.getEventStyle(ev, day.periods[0])" sxy-bs5-tooltip></div>
            <i ng-repeat="ev in day.singleDays[0]" ng-class="$ctrl.getCssClass(ev)" ng-style="$ctrl.getEventStyle(ev, day.singleDays[0])" ng-click="$ctrl.eventClicked(ev, day, null, $event)" data-bs-toggle="tooltip" data-bs-title="'{{ ev.summary }}'" data-bs-container="body" sxy-bs5-tooltip></i>
            <span class="day-number">{{ day.day }}</span><br />
          </td>
          <td class="day end-spacer" ng-if="(38 - month.firstDayDayOfWeek - month.daysInMonth) > 0" colspan="{{ 38 - month.firstDayDayOfWeek - month.daysInMonth  }}"></td>
        </tr>
      </tbody>
    </table>
  </div>
  <div ng-if="$ctrl.mode == 'align-left'">
    <table class="calendar">
      <thead>
        <tr>
          <th class="calendar-title">
            {{ $ctrl.start | date : "yyyy" }}
            <span ng-if="($ctrl.start | date : 'yyyy') != ($ctrl.end | date : 'yyyy')">- {{ $ctrl.end | date : "yyyy" }}</span>
          </th>
          <th class="day" ng-repeat="day in $ctrl.weekdaysForMonth track by $index">{{ day.text }}</th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="month in $ctrl.months">
          <td class="month-title">{{ month.title }}</td>
          <td class="day day-of-week-{{ day.weekday }} day-type-{{ day.dayType }} clickable" ng-repeat="day in month.days" ng-click="$ctrl.dateClicked(day, $ctrl.series[0], $event)">
            <div ng-repeat="ev in day.periods[0]" ng-class="$ctrl.getCssClass(ev)"  ng-style="$ctrl.getEventStyle(ev, day.periods[0])" ng-click="$ctrl.eventClicked(ev, day, null, $event)" data-bs-toggle="tooltip" data-bs-title="'{{ ev.summary }}'" data-bs-container="body" sxy-bs5-tooltip></div>
            <i ng-repeat="ev in day.singleDays[0]" ng-class="$ctrl.getCssClass(ev)" ng-style="$ctrl.getEventStyle(ev, day.singleDays[0])" ng-click="$ctrl.eventClicked(ev, day, null, $event)" data-bs-toggle="tooltip" data-bs-title="'{{ ev.summary }}'" data-bs-container="body" sxy-bs5-tooltip></i>
            <span class="day-number">{{ day.weekdayText }}</span><br />
          </td>
          <td class="day end-spacer" ng-if="(31 - month.daysInMonth) > 0" colspan="{{ 31 - month.daysInMonth }}"></td>
        </tr>
      </tbody>
    </table>
  </div>
  <div ng-if="$ctrl.mode == 'horizontal'" class="calendar-horizontal">
    <table class="calendar" style="width: max-content;margin-bottom: 10px;">
      <thead>
        <tr>
          <th class="calendar-title" rowspan="2">
            {{ $ctrl.start | date : "yyyy" }}
            <span ng-if="($ctrl.start | date : 'yyyy') != ($ctrl.end | date : 'yyyy')">- {{ $ctrl.end | date : "yyyy" }}</span>
          </th>
          <th class="month-title" ng-repeat="month in $ctrl.months" colspan="{{ month.daysInMonth }}">{{ month.title }} {{ month.year }}</th>
        </tr>
        <tr>
          <th class="day day-of-week-{{ day.weekday }} day-type-{{ day.dayType }}" ng-click="$ctrl.dateClicked(day, null, $event)" ng-repeat="day in $ctrl.allDays">
            {{ day.weekdayText }}<br />
            {{ day.day }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="series in $ctrl.series" ng-init="seriesIndex = $index">
          <td class="series-title clickable" ng-class="{ 'has-avatar': series.avatar }" ng-click="$ctrl.seriesClicked(series, $event)">
            <salaxy-avatar avatar="series.avatar" ng-if="series.avatar"
              style="font-size: 30px;left: 2px;position: absolute;top: 2px;"></salaxy-avatar>
            <div><strong>{{ series.title }}</strong></div>
            <div>{{ series.description }}</div>
          </td>
          <td class="day day-of-week-{{ day.weekday }} day-type-{{ day.dayType }} clickable"
            ng-repeat="day in $ctrl.allDays" ng-click="$ctrl.dateClicked(day, series, $event)">
            <div ng-repeat="ev in day.periods[seriesIndex]" ng-class="$ctrl.getCssClass(ev)" ng-style="$ctrl.getEventStyle(ev, day.periods[seriesIndex])" ng-click="$ctrl.eventClicked(ev, day, series, $event)" data-bs-toggle="tooltip" data-bs-title="'{{ ev.summary }}'" data-bs-container="body" sxy-bs5-tooltip></div>
            <i ng-repeat="ev in day.singleDays[seriesIndex]" ng-class="$ctrl.getCssClass(ev)" ng-style="$ctrl.getEventStyle(ev, day.singleDays[seriesIndex])"  ng-click="$ctrl.eventClicked(ev, day, series, $event)" data-bs-toggle="tooltip" data-bs-title="'{{ ev.summary }}'" data-bs-container="body" sxy-bs5-tooltip></i>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div ng-if="$ctrl.mode == 'list'">
    <h3>TODO: List layout</h3>
    <p>Period: {{ { start: $ctrl.start, end: $ctrl.end } | sxyDateRange }}</p>
    <fieldset ng-repeat="month in $ctrl.monthlyList">
      <legend>{{ month.title }} / {{ month.year }}</legend>
      <table class="table">
        <thead>
          <tr>
            <th>Date</th>
            <th>Weekday</th>
            <th>Events</th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="day in month.days">
            <td>{{ day.day }}</td>
            <td>
              {{ day.weekdayText }}
              <span ng-if="day.dayType != 'normal'">{{ day.dayType }}</span>
            </td>
            <td>
              <ul ng-repeat="eventArr in day.events" ng-init="seriesIndex = $index">
                <li ng-repeat="period in eventArr"><strong>{{ $ctrl.series[$index].title || $ctrl.series[$index].key }}: {{ period | sxyDateRange }}</strong> {{ period.title }}: {{ period.description }}</li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
    </fieldset>
  </div>
</div>`), s.put("salaxy-components/helpers/Chart.html", `
<div ng-if="$ctrl.config" ng-init="$ctrl.init()" class="salaxy-component salaxy-chart" ng-class="$ctrl.customClass" ng-style="{width: $ctrl.customWidth, height: $ctrl.customHeight}">
  <canvas class="chart" ng-class="$ctrl.chart.config.type ==='line' ? 'chart-line' : 'chart-pie'"></canvas>
</div>`), s.put("salaxy-components/helpers/DataMapper.html", `<div class="salaxy-component salaxy-data-mapper">
  <div ng-if="!$ctrl.model" class="alert alert-danger">Data mapper not found</div>
  <div ng-if="$ctrl.model" ng-switch="$ctrl.type || 'value-map'">
    <div ng-switch-when="value-map">
      <table class="table table-sm">
        <thead>
          <tr>
            <th ng-repeat="selector in $ctrl.model.map" style="padding: 0;">
              <salaxy-input readonly="true" label="header" label-type="plain" name="header" ng-model="selector.source"></salaxy-input>
            </th>
          </tr>
          <tr ng-if="$ctrl.model">
            <th ng-repeat="selector in $ctrl.model.map" style="padding: 0;">
              <salaxy-input-enum name="parserMapperSource" label-type="plain" options="$ctrl.model.target.allKeys" ng-model="selector.target" type="select"
                  ng-change="selector.resolve($ctrl.model.source.getSchema(), $ctrl.model.target.getSchema())"></salaxy-input-enum>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="row in $ctrl.model.source.value">
            <td ng-repeat="selector in $ctrl.model.map">{{row[selector.source]}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div ng-switch-when="debug">
      <salaxy-tab-buttons
        current-tab="$ctrl.currentTab"
        options="[
          { value: 'info', text: 'Basic info' },
          { value: 'mapping', text: 'Mapping' },
          { value: 'source', text: 'Source data' },
          { value: 'target', text: 'Target data' },
          { value: 'json', text: 'JSON' }
        ]"
        tabs-id="dataMapper">
      </salaxy-tab-buttons>
      <div class="tab-content" id="tab-content-dataMapper">
        <div class="tab-pane" id="info-tab">
          <fieldset class="form-horizontal" style="max-width: 800px;">
            <salaxy-input name="title" ng-model="$ctrl.model.title" label="Title"></salaxy-input>
            <salaxy-input name="uri" ng-model="$ctrl.model.uri" label="Uri"></salaxy-input>
            <salaxy-input-boolean name="isSourceAList" ng-model="$ctrl.model.isSourceAList" label="Source is a list"></salaxy-input-boolean>
            <button type="button" ng-click="$ctrl.model.doMap()" class="btn btn-default">Do map</button>
          </fieldset>
        </div>
        <div class="tab-pane" id="mapping-tab">
          <table class="table table-striped">
            <thead>
              <th>{{$ctrl.model.source.name || "Source unknown"}} ({{$ctrl.model.source.schema.format || "format unknown"}})</th>
              <th>Type / format</th>
              <th class="text-center">Mapping</th>
              <th>{{$ctrl.model.target.name || "Target unknown"}} ({{$ctrl.model.target.schema.format || "format unknown"}})</th>
              <th>Type / format</th>
            </thead>
            <tbody>
              <tr ng-repeat="selector in $ctrl.model.map">
                <td>
                  <salaxy-input-enum name="parserMapperSource" label-type="plain" options="$ctrl.model.source.allKeys" ng-model="selector.source" type="select"
                    ng-change="selector.resolve($ctrl.model.source.getSchema(), $ctrl.model.target.getSchema())"></salaxy-input-enum>
                </td>
                <td ng-if="selector.sourceProp">
                  <span>{{ selector.sourceProp.schema.type }} / {{ selector.sourceProp.schema.format || "-" }}</span>
                  <salaxy-json-formatter json="selector.sourceProp" key="'...'" type="dialog"></salaxy-json-formatter>
                </td>
                <td ng-if="!selector.sourceProp" class="text-danger">Not found!</td>
                <td class="text-center middle">
                  <i ng-if="selector.flatten.length" class="text-primary bi bi-diagram-3-fill" aria-hidden="true"></i>
                  <i ng-if="!selector.flatten.length && !selector.func" class="bi bi-arrow-left-circle-fill" aria-hidden="true"></i>
                  <i ng-if="!selector.flatten.length && selector.func" class="bi bi-gear-fill bi-spin text-primary" aria-hidden="true"></i>
                </td>
                <td ng-if="!selector.flatten.length">
                  <salaxy-input-enum name="parserMapperTarget" label-type="plain" options="$ctrl.model.target.allKeys" ng-model="selector.target" type="select"
                    ng-change="selector.resolve($ctrl.model.source.getSchema(), $ctrl.model.target.getSchema())"></salaxy-input-enum>
                </td>
                <td ng-if="!selector.flatten.length && selector.targetProp">
                  <span>{{ selector.targetProp.schema.type }} / {{ selector.targetProp.schema.format || "-" }}</span>
                  <salaxy-json-formatter json="selector.targetProp" key="'...'" type="dialog"></salaxy-json-formatter>
                </td>
                <td ng-if="!selector.flatten.length && !selector.targetProp" class="text-danger">Not found!</td>
                <td ng-if="selector.flatten.length" colspan="2">
                  <table>
                    <tr ng-repeat="flattenSelector in selector.flatten">
                      <td>
                        <salaxy-input-enum name="parserMapperTarget" label-type="plain" options="$ctrl.model.target.allKeys" ng-model="flattenSelector.target" type="select"
                          ng-change="flattenSelector.resolve(flattenSelector.sourceProp.schema.items, $ctrl.model.target.getSchema())"></salaxy-input-enum>
                      </td>
                      <td>
                        <span>{{ flattenSelector.targetProp.schema.type }} / {{ flattenSelector.targetProp.schema.format || "-" }}</span>
                        <salaxy-json-formatter json="flattenSelector.targetProp" key="'...'" type="dialog"></salaxy-json-formatter>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="tab-pane" id="source-tab">
          <salaxy-data-mapper model="$ctrl.model" type="source-value"></salaxy-data-mapper>
        </div>
        <div class="tab-pane" id="target-tab">
          <salaxy-data-mapper model="$ctrl.model" type="target-value"></salaxy-data-mapper>
        </div>
        <div class="tab-pane" id="json-tab">
          <div class="row">
            <div class="col-sm-4">
              <h3>Source</h3>
              <salaxy-json-formatter json="$ctrl.model.source" open="3"></salaxy-json-formatter>
            </div>
            <div class="col-sm-4">
              <h3>Mapper</h3>
              <salaxy-json-formatter json="$ctrl.model.map" open="3"></salaxy-json-formatter>
            </div>
            <div class="col-sm-4">
              <h3>Target</h3>
              <salaxy-json-formatter json="$ctrl.model.target" open="3"></salaxy-json-formatter>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div ng-switch-when="source-value">
      <table class="table table-sm">
        <thead>
          <tr>
            <th sxy-text="SALAXY.NG1.ODataImportComponent.step3.okey"></th>
            <th ng-repeat="header in $ctrl.model.source.keys">
              {{header}}
              (<span>{{ $ctrl.model.source.schema.properties[header].type || "-" }} / {{ $ctrl.model.source.schema.properties[header].format || "-" }}</span>
              <salaxy-json-formatter json="$ctrl.model.source.schema.properties[header]" key="'...'" type="dialog"></salaxy-json-formatter>)
            </th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="row in $ctrl.model.source.value">
            <td>
              <div ng-if="row.validation && row.validation.errors && row.validation.errors.length" ng-repeat="error in row.validation.errors">
                <button data-bs-toggle="popover" data-bs-content="{{ error.msg }}" data-bs-title="{{ error.code }}" type="button" class="btn btn-danger" sxy-bs5-popover>{{ error.type }}</button><br>
              </div>
              
              <div ng-if="row.validation && row.validation.isValid">
                <span class="text-success" sxy-text="SALAXY.NG1.ODataImportComponent.step3.okey"></span>
              </div>
            </td>
            <td ng-repeat="header in $ctrl.model.source.keys">{{row[header]}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div ng-switch-when="target-value">
      <table class="table table-sm">
        <thead>
          <tr>
            <th sxy-text="SALAXY.NG1.ODataImportComponent.step3.okey"></th>
            <th ng-repeat="header in $ctrl.model.target.keys">
              {{header}}
              (<span>{{ $ctrl.model.target.schema.properties[header].type || "-" }} / {{ $ctrl.model.target.schema.properties[header].format || "-" }}</span>
              <salaxy-json-formatter json="$ctrl.model.target.schema.properties[header]" key="'...'" type="dialog"></salaxy-json-formatter>)
            </th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="row in $ctrl.model.target.value">
            <td>
              <div ng-if="row.validation.errors.length" ng-repeat="error in row.validation.errors">
                <button data-bs-toggle="popover" data-bs-content="{{ error.msg }}" data-bs-title="{{ error.code }}" type="button" class="btn btn-danger" sxy-bs5-popover>{{ error.type }}</button><br>
              </div>
              <div ng-if="row.validation && row.validation.isValid">
                <span class="text-success" sxy-text="SALAXY.NG1.ODataImportComponent.step3.okey"></span>
              </div>
            </td>
            <td ng-repeat="header in $ctrl.model.target.keys">{{row[header]}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>`), s.put("salaxy-components/helpers/import/CalcImportOptions.html", `<div class="salaxy-component salaxy-calc-import-options">
  <div class="row">
    <form class="form-horizontal col-sm-6" name="$ctrl.optionsForm">
      <fieldset>
        <legend sxy-text="SALAXY.NG1.CalcImport.options.title"></legend>
        <div class="row">
          <div class="col col-sm-6">
            <salaxy-input-enum options="{
            addRows: 'SALAXY.NG1.CalcImport.options.addRows',
            removeAllRows: 'SALAXY.NG1.CalcImport.options.removeAllRows',
            removeImportedRows: 'SALAXY.NG1.CalcImport.options.removeImportedRows'}" label-type="plain" name="customOptions" ng-model="$ctrl.customOptions" type="radio"
              ng-change="$ctrl.updateOptions()"></salaxy-input-enum>
            <salaxy-input-boolean type="checkbox" name="applyEmploymentDefaultRows" label-type="plain" label-true="SALAXY.NG1.CalcImport.options.applyEmploymentDefaultRows"
              ng-model="$ctrl.options.applyEmploymentDefaultRows"></salaxy-input-boolean>
          </div>
          <div class="col col-sm-6">
            <salaxy-input ng-if="true" require="$ctrl.options.rowMergeOption == 'removeImportedRows'" ng-model="$ctrl.options.sourceId" name="sourceId"
              label="SALAXY.NG1.CalcImport.options.sourceId"></salaxy-input>
          </div>
        </div>
      </fieldset>
    </form>
  </div>
</div>`), s.put("salaxy-components/helpers/import/DataImport.html", `<div class="salaxy-component salaxy-data-import">
  <div class="salaxy-wizard">
    <div class="wizard-steps">
      <div class="wizard-step" ng-class="{'active': $ctrl.action == 'upload'}">
        <span class="salaxy-avatar">
          <div class="wizard-icons-wrapper">
            <i class="bi" ng-class="$ctrl.action == 'upload' ? 'bi-circle-fill' : 'bi-circle'"></i>
            <i class="bi bi-circle-fill"></i>
          </div>
          <strong class="number">1</strong>
        </span>
        <span class="step-text" sxy-text="SALAXY.NG1.DataImport.stepUpload.title"></span>
      </div>
      <div class="wizard-step" ng-class="{'active': $ctrl.action == 'validate'}">
        <span class="salaxy-avatar">
          <div class="wizard-icons-wrapper">
            <i class="bi" ng-class="$ctrl.action == 'validate' ? 'bi-circle-fill' : 'bi-circle'"></i>
            <i class="bi bi-circle-fill"></i>
          </div>
          <strong class="number">2</strong>
        </span>
        <span class="step-text" sxy-text="SALAXY.NG1.DataImport.stepValidate.title"></span>
      </div>
      <div class="wizard-step" ng-class="{'active': $ctrl.action == 'import'}">
        <span class="salaxy-avatar">
          <div class="wizard-icons-wrapper">
            <i class="bi" ng-class="$ctrl.action == 'import' ? 'bi-circle-fill' : 'bi-circle'"></i>
            <i class="bi bi-circle-fill"></i>
          </div>
          <strong class="number">3</strong>
        </span>
        <span class="step-text" sxy-text="SALAXY.NG1.DataImport.stepImport.title"></span>
      </div>
    </div>
    <div class="wizard-strikethrough"></div>
  </div>
  <ng-include ng-if="$ctrl.optionsTemplate" src="$ctrl.optionsTemplate"></ng-include>
  <div ng-switch="$ctrl.action">
    <div ng-switch-when="upload">
      <p sxy-text="SALAXY.NG1.DataImport.stepUpload.intro"></p>
      <p>
        <span class="badge bg-primary" ng-if="$ctrl.sourceData.length">{{'SALAXY.NG1.DataImport.badgeUploadedLabel' | sxyTranslate }} {{$ctrl.sourceData.length}} {{'SALAXY.NG1.DataImport.badgeUnit' | sxyTranslate }}</span>
      </p>
      <div class="modal-footer mb-3">
        <button id="info" ng-disabled="$ctrl.isImporting" type="button" class="btn btn-default" ng-click="$ctrl.help()">
          <span>{{'SALAXY.NG1.DataImport.stepUpload.buttonHelp' | sxyTranslate}} <i class="bi bi-info-circle"></i></span>
        </button>
        <button id="upload" ng-disabled="$ctrl.isImporting" type="button" class="btn btn-default" ngf-select="$ctrl.upload($files)" ngf-multiple="false" ngf-max-size="10MB">
          <span>{{'SALAXY.NG1.DataImport.stepUpload.buttonUpload' | sxyTranslate}} <i class="bi bi-file-earmark-excel"></i></span>
        </button>
        <button id="paste" ng-disabled="$ctrl.isImporting" type="button" class="btn btn-default" ng-click="$ctrl.paste()">
          <span>{{'SALAXY.NG1.DataImport.stepUpload.buttonPaste' | sxyTranslate}} <i class="bi bi-clipboard"></i></span>
        </button>
        <button id="reset" ng-disabled="$ctrl.isImporting" type="button" class="btn btn-default" ng-click="$ctrl.reset(true)">
          {{'SALAXY.NG1.DataImport.stepUpload.buttonReset' | sxyTranslate}}
        </button>
        <button class="btn btn-primary ms-auto" sxy-text="SALAXY.UI_Terms.next" ng-click="$ctrl.action='validate';$ctrl.validate()"></button>
      </div>
    </div>
    <div ng-switch-when="validate">
      <p sxy-text="SALAXY.NG1.DataImport.stepValidate.intro"></p>
      <p>
        <span ng-if="$ctrl.validationUndoneRows"><span class="badge bg-default">{{'SALAXY.NG1.DataImport.badgeUndoneLabel' | sxyTranslate }} {{$ctrl.validationUndoneRows}} {{'SALAXY.NG1.DataImport.badgeUnit' | sxyTranslate }}</span></span>
        <span ng-if="$ctrl.validationErrorRows"><span class="badge bg-danger">{{'SALAXY.NG1.DataImport.badgeErrorLabel' | sxyTranslate }} {{$ctrl.validationErrorRows}} {{'SALAXY.NG1.DataImport.badgeUnit' | sxyTranslate }}</span></span>
        <span ng-if="$ctrl.validationSuccessRows"><span class="badge bg-success">{{'SALAXY.NG1.DataImport.badgeSuccessLabel' | sxyTranslate }} {{$ctrl.validationSuccessRows}} {{'SALAXY.NG1.DataImport.badgeUnit' | sxyTranslate }}</span></span>
      </p>
      <div class="modal-footer mb-3">
        <button class="btn btn-default" sxy-text="SALAXY.UI_Terms.previous" ng-click="$ctrl.action='upload'"></button>
        <button id="validate" ng-disabled="$ctrl.isImporting" type="button" class="btn btn-default" ng-click="$ctrl.validate()">
          {{'SALAXY.NG1.DataImport.stepValidate.buttonValidate' | sxyTranslate}}
        </button>
        <button  ng-repeat="validator in $ctrl.getExtraValidators()"  ng-disabled="$ctrl.isImporting || $ctrl.isValidating" type="button" class="btn btn-default"
          ng-click="validator.validate()">
          {{ validator.buttonLabel }}
        </button>
        <button  ng-repeat="enricher in $ctrl.getDataEnrichers()"  ng-disabled="$ctrl.isImporting" type="button" class="btn btn-default"
        ng-click="enricher.enrich()">
        {{ enricher.buttonLabel }}
       </button>
        <button class="btn btn-primary ms-auto" sxy-text="SALAXY.UI_Terms.next" ng-click="$ctrl.action='import'"></button>
      </div>
    </div>
    <div ng-switch-when="import">
      <p sxy-text="SALAXY.NG1.DataImport.stepImport.intro"></p>
      <p>
      <div class="progress" ng-if="$ctrl.importTotal">
        <div style="min-width: 10em;" ng-style="{'width': ($ctrl.importCurrent * 100 / $ctrl.importTotal) + '%' }" class="progress-bar" role="progressbar"
          aria-valuenow="{{$ctrl.importCurrent}}" aria-valuemin="0" aria-valuemax="{{$ctrl.importTotal}}">
          <span><span ng-if="$ctrl.importCurrent != $ctrl.importTotal"><span ng-if="$ctrl.isImporting"><i class="bi bi-arrow-repeat bi-spin"></i></span></span>
            {{$ctrl.importCurrent}}/{{$ctrl.importTotal}}</span>
        </div>
      </div>
      <span ng-if="$ctrl.importIgnoredRows"><span class="badge bg-default">{{'SALAXY.NG1.DataImport.badgeIgnoredLabel' | sxyTranslate }} {{$ctrl.importIgnoredRows}} {{'SALAXY.NG1.DataImport.badgeUnit' | sxyTranslate }}</span></span>
      <span ng-if="$ctrl.importSuccessRows"><span class="badge bg-success">{{'SALAXY.NG1.DataImport.badgeFinishedLabel' | sxyTranslate }} {{$ctrl.importSuccessRows}} {{'SALAXY.NG1.DataImport.badgeUnit' | sxyTranslate }}</span></span>
      <span ng-if="$ctrl.importWarningRows"><span class="badge bg-warning">{{'SALAXY.NG1.DataImport.badgeWarningLabel' | sxyTranslate }} {{$ctrl.importWarningRows}} {{'SALAXY.NG1.DataImport.badgeUnit' | sxyTranslate }}</span></span>
      <span ng-if="$ctrl.importErrorRows"><span class="badge bg-danger">{{'SALAXY.NG1.DataImport.badgeErrorLabel' | sxyTranslate }} {{$ctrl.importErrorRows}} {{'SALAXY.NG1.DataImport.badgeUnit' | sxyTranslate }}</span></span>
      </p>
      <div class="modal-footer mb-3">
        <button class="btn btn-default" sxy-text="SALAXY.UI_Terms.previous" ng-click="$ctrl.action='validate';$ctrl.validate()"></button>
        <div class="ms-auto">
          <button id="cancel" ng-disabled="!$ctrl.isImporting" type="button" class="btn btn-danger" ng-click="$ctrl.cancel()">
            {{'SALAXY.NG1.DataImport.stepImport.buttonCancel' | sxyTranslate}}
          </button>
          <button id="import" ng-disabled="$ctrl.isImporting || $ctrl.hasInvalidOptions()" type="button" class="btn btn-primary" ng-click="$ctrl.import()">
            {{'SALAXY.NG1.DataImport.stepImport.buttonImport' | sxyTranslate}}
          </button>
        </div>
      </div>
    </div>
  </div>
  <div id="import-table"></div>
</div>`), s.put("salaxy-components/helpers/import/EInvoiceAddressSelect.html", `<div class="modal-eInvoiceAddress-select">
  <div class="modal-header">
    <h2 class="modal-title" sxy-text="SALAXY.NG1.CompanyImport.enrichEInvoiceAddressesSelectionMessage"></h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <div class="table-responsive" style="max-height: calc(100vh - 300px)">
      <table class="table table-striped">
        <thead>
          <tr>
            <th sxy-text="SALAXY.NG1.EInvoiceAddressListComponent.name"></th>
            <th sxy-text="SALAXY.NG1.EInvoiceAddressListComponent.receiver"></th>
            <th sxy-text="SALAXY.NG1.EInvoiceAddressListComponent.intermediator"></th>
            <th class="right">              
            </th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="row in $ctrl.logic.addresses">
            <td>
              <span>{{row.receiverName}}</span><br>
              <small>{{row.receiverOfficialId}}</small>
            </td>
            <td>
              <span>{{row.receiver}}</span><br>
            </td>
            <td>
              <span>{{row.intermediatorName}}</span><br>
              <small>{{row.intermediator}}</small>
            </td>
            <td class="right middle">
              <button class="btn btn-sm btn-default" type="button"
                ng-click="$ctrl.logic.select($ctrl.current, row, $close)">{{ 'SALAXY.UI_Terms.select' | sxyTranslate }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="modal-footer text-end">
    <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
  </div>
</div>`), s.put("salaxy-components/helpers/import/staging/ImportStaging.html", `<div class="salaxy-component salaxy-import-staging">
  <div class="pull-right"><small>{{ $ctrl.serverUrl }}</small></div>
  <div class="toolbar">
    <button type="button" class="btn btn-default" ng-click="$ctrl.reloadUi()"><i class="bi bi-arrow-repeat" aria-hidden="true"></i></button>
    <div style="display: inline-block; width: 240px; vertical-align: middle;" ng-if="$ctrl.worktimeApi.payrolls && !$ctrl.payroll">
      <salaxy-input-typeahead options="$ctrl.worktimeApi.payrolls" name="payrollId" label-type="plain"
        placeholder="{{ 'SALAXY.NG1.ImportStagingComponent.toolbar.selectPayroll' | sxyTranslate }}"
        ng-model="$ctrl.payrollId"></salaxy-input-typeahead>
    </div>
    <button type="button" class="btn btn-primary" ng-disabled="!$ctrl.payrollId" ng-click="$ctrl.commitPayroll('payroll')" sxy-text="SALAXY.NG1.ImportStagingComponent.toolbar.commitPayroll"></button>
    <button type="button" class="btn btn-default" ng-click="$ctrl.recalculateAllWorktimes()" sxy-text="SALAXY.NG1.ImportStagingComponent.toolbar.recalculateAll"></button>
  </div>
  <ng-include src="'salaxy-components/helpers/import/staging/ImportStaging_list.html'"></ng-include>
  <!-- TODO: Move to a dialog -->
  <ng-include src="'salaxy-components/helpers/import/staging/ImportStaging_test_data.html'"></ng-include>
</div>
<ng-include ng-if="$ctrl.worktimeApi.current" src="'salaxy-components/helpers/import/staging/ImportStaging_details.html'"></ng-include>`), s.put("salaxy-components/helpers/import/staging/ImportStaging_details.html", `<div class="salaxy-payroll-details-calc salaxy-payroll-details-dialog"
  ng-style="{'max-width': 'calc(100vw - 260px)','width': $ctrl.userSettings.ng1Binder('worktimeImport.calcDialogSize').val || '60%'}"
  ng-class="{ 'offcanvas-show': $ctrl.showOffcanvas }">
  <div class="modal-header bg-primary d-flex justify-content-between">
    <div ng-if="$ctrl.worktimeApi.current" class="d-flex">
      <salaxy-avatar class="align-self-center ms-2 me-3" avatar="$ctrl.worktimeApi.current.preview.employments[0].personalInfo.avatar"></salaxy-avatar>
      <div class="d-flex flex-column">
        <h3 class="modal-title">{{ $ctrl.worktimeApi.current.preview.employments[0].personalInfo.avatar.displayName }}</h3>
        <div>{{ $ctrl.worktimeApi.current.preview.employments[0].identity.personalId }} ({{ "EmploymentRelationType." + $ctrl.worktimeApi.current.preview.employments[0].info.type |
          sxyEnum }})
        </div>
      </div>
    </div>
    <div>
      <button type="button" class="btn btn-primary" ng-click="$ctrl.userSettings.ng1Binder('worktimeImport.calcDialogSize').val = ($ctrl.userSettings.ng1Binder('worktimeImport.calcDialogSize').val == '100%' ? '60%' : '100%')">
        <i ng-class="$ctrl.userSettings.ng1Binder('worktimeImport.calcDialogSize').val == '100%' ? 'bi bi-arrows-angle-contract' : 'bi bi-arrows-angle-expand'"></i>
      </button>
      <button type="button" class="btn btn-primary" aria-label="Close" ng-click="$ctrl.showDetails()"><span class="bi bi-x-lg"></span></button>
    </div>
  </div>
  <div class="modal-body">
    <table style="width: 100%">
      <tr>
        <td width="20%" sxy-text="SALAXY.NG1.ImportStagingComponent.details.payroll"></td>
        <td width="50%">
          <div>{{ $ctrl.worktimeApi.detailsPayroll.text || $ctrl.worktimeApi.detailsPayrollId || ("SALAXY.NG1.ImportStagingComponent.details.noPayroll" | sxyTranslate) }}</div>
          <div ng-if="$ctrl.payrollId && $ctrl.payrollId != $ctrl.worktimeApi.detailsPayrollId">
            <span class="text-danger" sxy-text="SALAXY.NG1.ImportStagingComponent.details.notTheSameAsSelectedPayroll"></span>
            <a href="" ng-click="$ctrl.worktimeApi.detailsPayrollId = $ctrl.payrollId">Takaisin</a>
          </div>
        </td>
        <td width="30%" rowspan="2">
          <salaxy-input-typeahead options="$ctrl.worktimeApi.payrolls" name="payrollId" label-type="plain"
            placeholder="{{ 'SALAXY.NG1.ImportStagingComponent.toolbar.selectPayroll' | sxyTranslate }}" ng-model="$ctrl.worktimeApi.detailsPayrollId"></salaxy-input-typeahead>
          <div class="text-danger" ng-if="$ctrl.worktimeApi.rowsOutsidePayrollCount">
            <small>
              Työntekijällä on {{ $ctrl.worktimeApi.rowsOutsidePayrollCount }} riviä palkkalistojen ulkopuolella.
              <a href="" ng-click="$ctrl.worktimeApi.detailsPayrollId = 'unknown'">Näytä</a>
            </small>
          </div>
        </td>
      </tr>
      <tr>
        <td sxy-text="SALAXY.NG1.ImportStagingComponent.details.period"></td>
        <td>
          <div>{{ $ctrl.worktimeApi.detailsPayroll.ui | sxyDateRange }} / {{ $ctrl.worktimeApi.detailsPayroll.ui.date | sxyDate }}</div>
          <div>{{ $ctrl.worktimeApi.detailsPayroll.ui.calcCount }} laskelmaa / {{ $ctrl.worktimeApi.detailsPayroll.ui.rowCount }} riviä</div>
        </td>
      </tr>
    </table>
    <salaxy-tab-buttons
      current-tab="$ctrl.currentTab"
      options="[
        { 'value': 'rawrows', 'text': 'SALAXY.NG1.ImportStagingComponent.details.rawRows' },
        { 'value': 'processrows', 'text': 'Muokkaa rivejä' },
        { 'value': 'manual', 'text': 'Käsin syötetyt rivit' },
        { 'value': 'reports', 'text': 'SALAXY.NG1.ImportStagingComponent.details.reports' },
        { 'value': 'preview', 'text': 'Esikatselu' },
        { 'value': 'salaryslips', 'text': 'SALAXY.NG1.ImportStagingComponent.details.salarySlips' },
        { 'value': 'debug', 'text': 'SALAXY.NG1.ImportStagingComponent.details.debug' }
      ]"
      tabs-id="importStagingDetails">
    </salaxy-tab-buttons>
    <div class="tab-content" id="tab-content-importStagingDetails">
      <div class="tab-pane" id="rawrows-tab">
        <div ng-if="$ctrl.currentTab == 'rawrows'">
          <ng-include src="'salaxy-components/helpers/import/staging/ImportStaging_rawRows.html'"></ng-include>
        </div>
      </div>
      <div class="tab-pane" id="manual-tab">
        <div ng-if="$ctrl.currentTab == 'manual'">
          <salaxy-calc-rows-2019-editor ng-if="$ctrl.worktimeApi.current" rows="$ctrl.worktimeApi.editableRows" mode="edit"
          title="Käsin muokattavat rivit"></salaxy-calc-rows-2019-editor>
          <button type="button" class="btn btn-primary" ng-click="$ctrl.saveManualRows()" sxy-text="SALAXY.UI_Terms.save"></button>
        </div>
      </div>
      <div class="tab-pane" id="preview-tab">
        <div ng-if="$ctrl.currentTab == 'preview'">
          <div ng-if="!$ctrl.worktimeApi.currentCalc">Tälle palkkalistalle ei ole esikatselulaskelmaa.</div>
          <div ng-if="$ctrl.worktimeApi.currentCalc">
            <div class="alert alert-warning">
              HUOM: Tämän välilehti on vain laskelman esikatselua varten. Rivejä ei voi muokata / et voi tallentaa muutoksia.
              Tee muutokset "Käsin syötetyt rivit"-välilehdellä.
            </div>
            <salaxy-tab-buttons
              current-tab="$ctrl.currentSubTab"
              options="[
                { 'value': 'rows', 'text': 'SALAXY.NG1.ImportStagingComponent.details.rows' },
                { 'value': 'calculator', 'text': 'SALAXY.NG1.ImportStagingComponent.details.calculator' }
              ]"
              tabs-id="importStagingDetailsPreview">
            </salaxy-tab-buttons>
            <div class="tab-content" id="tab-content-importStagingDetailsPreview">
              <div class="tab-pane" id="rows-tab">
                <div ng-if="$ctrl.currentSubTab == 'rows'">
                  <salaxy-calc-rows-2019-editor parent="$ctrl.worktimeApi.currentCalc" title="{{'SALAXY.NG1.PayrollComponent.payrollCalcs.calcRowEditor.title' | sxyTranslate}}"
                    mode="edit" show-edit-buttons="false" show-gross-totals="true"></salaxy-calc-rows-2019-editor>
                </div>
              </div>
              <div class="tab-pane" id="calculator-tab">
                <div ng-if="$ctrl.currentSubTab == 'calculator'">
                  <salaxy-calc ng-if="$ctrl.worktimeApi.currentCalc" model="$ctrl.worktimeApi.currentCalc"></salaxy-calc>
                </div>
              </div>
            </div>
            <div ng-switch="$ctrl.previewView">
              <div ng-switch-when="rows">
                <salaxy-calc-rows-2019-editor parent="$ctrl.worktimeApi.currentCalc" title="{{'SALAXY.NG1.PayrollComponent.payrollCalcs.calcRowEditor.title' | sxyTranslate}}"
                mode="edit" show-edit-buttons="false" show-gross-totals="true"></salaxy-calc-rows-2019-editor>
              </div>
              <div ng-switch-when="calculator">
                <salaxy-calc ng-if="$ctrl.worktimeApi.currentCalc" model="$ctrl.worktimeApi.currentCalc"></salaxy-calc>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="tab-pane" id="salaryslips-tab">
        <div ng-if="$ctrl.currentTab == 'salaryslips'">
          <ng-include src="'salaxy-components/helpers/import/staging/ImportStaging_salarySlipsList.html'"></ng-include>
        </div>
      </div>
      <div class="tab-pane" id="processrows-tab">
        <div ng-if="$ctrl.currentTab == 'processrows'">
          <ng-include src="'salaxy-components/helpers/import/staging/ImportStaging_processRows.html'"></ng-include>
        </div>
      </div>
      <div class="tab-pane" id="reports-tab">
        <div ng-if="$ctrl.currentTab == 'reports'">
          <div ng-if="!$ctrl.worktimeApi.currentCalc">Tälle palkkalistalle ei ole esikatselulaskelmaa.</div>
          <salaxy-calc-reports ng-if="$ctrl.worktimeApi.currentCalc" calcs="[$ctrl.worktimeApi.currentCalc]" preview="true" view="page1"
          report-type="'salarySlip'"></salaxy-calc-reports>
        </div>
      </div>
      <div class="tab-pane" id="debug-tab">
        <div ng-if="$ctrl.currentTab == 'debug' && $ctrl.worktimeApi.currentJson">
          <div class="toolbar">
            <button type="button" class="btn btn-default" ng-click="$ctrl.worktimeApi.saveJson()" sxy-text="SALAXY.UI_Terms.save"></button>
            <button type="button" class="btn btn-default" ng-click="$ctrl.deleteWorktime()" sxy-text="SALAXY.UI_Terms.delete"></button>
          </div>
          <div ng-if="$ctrl.worktimeApi.error">
            <h2 sxy-text="SALAXY.UI_Terms.error"></h2>
            <salaxy-json-formatter json="$ctrl.worktimeApi.error"></salaxy-json-formatter>
            <textarea style="width: 100%; height: 400px;">{{ $ctrl.worktimeApi.error | json }}</textarea>
            <button type="button" class="btn btn-default" ng-click="$ctrl.worktimeApi.error = ''" sxy-text="SALAXY.UI_Terms.clear"></button>
          </div>
          <sxy-code-editor ng-model="$ctrl.worktimeApi.currentJson" lang="json" height="calc(100vh - 372px)"></sxy-code-editor>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-default" ng-click="$ctrl.showDetails()" sxy-text="SALAXY.UI_Terms.close"></button>
  </div>
</div>`), s.put("salaxy-components/helpers/import/staging/ImportStaging_list.html", `<div>
  <table class="table">
    <thead>
      <tr>
        <th></th>
        <th>
          <div sxy-text="SALAXY.NG1.ImportStagingComponent.list.title"></div>
          <div sxy-text="SALAXY.NG1.ApiCrudObjectComponent.id"></div>
        </th>
        <th class="right">
          <div sxy-text="SALAXY.NG1.ImportStagingComponent.list.grossSalary"></div>
        </th>
        <th class="right">
          <div sxy-text="SALAXY.NG1.ImportStagingComponent.list.netSalary"></div>
        </th>
        <th class="right">
          <div sxy-text="SALAXY.UI_Terms.created"></div>
          <div sxy-text="SALAXY.UI_Terms.updated"></div>
        </th>
        <th class="right">
          <small>
            <div class="text-muted" sxy-text="SALAXY.NG1.ImportStagingComponent.status.preview"></div>
            <div class="text-primary" sxy-text="SALAXY.NG1.ImportStagingComponent.status.new"><b></b></div>
            <div class=""><s sxy-text="SALAXY.NG1.ImportStagingComponent.status.deleted"></s></div>
            <div class="text-danger" sxy-text="SALAXY.NG1.ImportStagingComponent.status.error"></div>
          </small>
        </th>
        <th class="right">
          <small>
            <div class="" sxy-text="SALAXY.NG1.ImportStagingComponent.list.total"></div>
            <div class="" sxy-text="SALAXY.NG1.ImportStagingComponent.status.committed"><b></b></div>
            <div class="text-muted" sxy-text="SALAXY.NG1.ImportStagingComponent.status.ignored"></div>
          </small>
        </th>
        <th class="right">
          <div sxy-text="SALAXY.NG1.ImportStagingComponent.list.calcCount"></div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="emp in $ctrl.worktimeApi.getFilteredList($ctrl.payrollId)" class="clickable" ng-click="$ctrl.showDetails(emp.id)">
        <td>
          <salaxy-avatar class="salaxy-calc-row-type-avatar float-start" avatar="emp.avatar"></salaxy-avatar>
        </td>
        <td>
          <div><b>{{ emp.sortableName }}</b></div>
          <div>{{ emp.personalId }} ({{ "EmploymentRelationType." + emp.employmentType | sxyEnum }})</div>
          <div ng-if="emp.payrolls.unknown" class="text-danger"><small>Palkkalistojen ulkopuolella {{ emp.payrolls.unknown.rows.count }} riviä.</small></div>
        </td>
        <td class="right">
          <div>{{ $ctrl.getTotals(emp).calcs.gross | currency }}</div>
          <div><s>{{ $ctrl.getTotals(emp).committed.gross | currency }}</s></div>
        </td>
        <td class="right">
          <div>{{ $ctrl.getTotals(emp).calcs.net | currency }}</div>
          <div><s>{{ $ctrl.getTotals(emp).committed.net | currency }}</s></div>
        </td>
        <td class="right">
          <div>{{ emp.createdAt | sxyTime }}</div>
          <div>{{ emp.updatedAt | sxyTime }}</div>
        </td>
        <td class="right">
          <small>
            <div class="text-muted">{{ $ctrl.getTotals(emp).rows.preview }}</div>
            <div ng-if="$ctrl.getTotals(emp).rows.new" class="bg-primary badge">&nbsp;&nbsp;<b>{{ $ctrl.getTotals(emp).rows.new }}</b>&nbsp;</div>
            <div ng-if="!$ctrl.getTotals(emp).rows.new" class="text-primary"><b>0</b></div>
            <div class=""><s>{{ $ctrl.getTotals(emp).rows.deleted || "&nbsp;" }}</s></div>
            <div ng-if="$ctrl.getTotals(emp).rows.error" class="bg-danger badge">&nbsp;&nbsp;<b>{{ $ctrl.getTotals(emp).rows.error }}</b>&nbsp;</div>
            <div ng-if="!$ctrl.getTotals(emp).rows.error" class="text-danger"><b>0</b></div>
          </small>
        </td>
        <td class="right">
          <small>
            <div class="">{{ $ctrl.getTotals(emp).rows.count }}</div>
            <div class=""><b>{{ $ctrl.getTotals(emp).rows.committed }}</b></div>
            <div class="text-muted">{{ $ctrl.getTotals(emp).rows.ignored }}</div>
          </small>
        </td>
        <td class="right">
          <div>{{ $ctrl.getTotals(emp).calcs.count }}</div>
        </td>
      </tr>
    </tbody>
  </table>
</div>`), s.put("salaxy-components/helpers/import/staging/ImportStaging_overview.html", `<div>
  <div ng-if="$ctrl.serverUrl">
    <salaxy-tab-buttons
      current-tab="$ctrl.currentTab"
      options="[
        { 'value': 'default', 'text': 'Overview' },
        { 'value': 'tests', 'text': 'Tests' }
      ]"
      tabs-id="importStagingOverview">
    </salaxy-tab-buttons>
    <div class="tab-content" id="tab-content-importStagingOverview">
      <div class="tab-pane" id="default-tab">
        <div ng-if="$ctrl.currentTab == 'default'">
          <div>Current staging server: <a ng-href="{{ $ctrl.serverUrl }}" target="_blank">{{ $ctrl.serverUrl }}</a></div>
        </div>
      </div>
      <div class="tab-pane" id="tests-tab">
        <div ng-if="$ctrl.currentTab == 'tests'">
          <fieldset>
            <legend>Upload test data</legend>
            <p class="lead">
              Upload a test file to the staging server.
              The file should be a JSON file with employment relations or rows: The same structure that an integration sends.
            </p>
            <div class="row">
              <div class="col-md-6">
                <form ng-submit="$ctrl.uploadTestFile($event)">
                  <input type="file" class="form-control" />
                  <button type="submit" class="btn btn-primary">Process uploaded file</button>
                <button type="submit" class="btn btn-default" ng-click="$ctrl.uploadTestFile('clipboard')">Process from clipboard</button>
                </form>
              </div>
              <div class="col-md-6">
                <p>Get demo files:</p>
                <ul>
                  <li>Rows: check the personal ID before processing</li>
                  <ul>
                    <li><a ng-href="{{ $ctrl.serverUrl + '/test-data/rows_2023-09-01_2023-12-22.json' }}" target="_blank">2023-09-01 - 2023-12-22</a></li>
                    <li><a ng-href="{{ $ctrl.serverUrl + '/test-data/rows_2023-11-01_2023-11-30.json' }}" target="_blank">2023-11-01 - 2023-11-30</a></li>
                  </ul>
                  <li><a ng-href="{{ $ctrl.serverUrl + '/test-data/employment-190372-942M.json' }}" target="_blank">Employment, Pauliina Palkkanen, 190372-942M</a>.</li>
                </ul>
              </div>
            </div>
            <salaxy-json-formatter json="$ctrl.uploadResults" key="'result'" open="0"></salaxy-json-formatter>
          </fieldset>
          <fieldset>
            <legend>Create a Payroll / Nepton Payment Period</legend>
            <div class="btn-toolbar">
              <div class="btn-goup">
                <p>TODO: Add possibility for setting the values and creating the Payroll</p>
                <button type="button" class="btn btn-default" ng-click="$ctrl.runTest('createUpdatePaymentPeriod')">Demo button (fixed ID)</button>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
    </div>
  </div>
  <div ng-if="!$ctrl.serverUrl" class="container">
    <div class="alert alert-info">
      Integrations has not been set up for this environment.
      Please specify the integration server in the settings (PRO settings => other)
      or contact customer services.
    </div>
  </div>
</div>`), s.put("salaxy-components/helpers/import/staging/ImportStaging_processRows.html", `<div class="btn-toolbar">
  <div class="btn-group">
    <button type="button" class="btn btn-default" ng-repeat="group in $ctrl.statusGroups" ng-click="$ctrl.statusGroup = group" ng-disabled="group.active">{{ group.text |
      sxyTranslate }}</button>
  </div>
  <div class="btn-group">
    <button id="single-button" type="button" class="btn dropdown-toggle" ng-class="$ctrl.$ctrlRows.getSelectedRows().length ? 'btn-primary' : 'btn-default'" data-bs-toggle="dropdown" aria-expanded="false">
      Valitut ({{ $ctrl.$ctrlRows.getSelectedRows().length }})
    </button>
    <ul class="dropdown-menu" aria-labelledby="single-button">
      <li><a class="dropdown-item" href="" ng-click="$ctrl.$ctrlRows.toggleSelectedRow('all', true)">Valitse kaikki</a></li>
      <li><a class="dropdown-item" href="" ng-click="$ctrl.$ctrlRows.toggleSelectedRow('all', false)">Poista valinnat</a></li>
    </ul>
  </div>
</div>
<div class="btn-toolbar">
  <div class="btn-group">
    <div style="width: 240px; vertical-align: middle;float: left;">
      <salaxy-input-typeahead options="$ctrl.worktimeApi.payrolls" name="payrollId" label-type="plain"
        placeholder="{{ 'SALAXY.NG1.ImportStagingComponent.toolbar.selectPayroll' | sxyTranslate }}" ng-model="$ctrl.payrollMoveTarget"></salaxy-input-typeahead>
    </div>
    <button type="button" class="btn btn-primary" ng-disabled="!$ctrl.$ctrlRows.getSelectedRows().length || !$ctrl.payrollMoveTarget"
      ng-click="$ctrl.moveToPayroll($ctrl.$ctrlRows.getSelectedRows(), $ctrl.payrollMoveTarget)">Siirrä palkkalistaan</button>
    <button type="button" class="btn btn-default" ng-disabled="!$ctrl.payrollMoveTarget"
      ng-click="$ctrl.$ctrlRows.toggleSelectedRow('all', true);$ctrl.moveToPayroll($ctrl.$ctrlRows.getSelectedRows(), $ctrl.payrollMoveTarget)">Valitse & siirrä</button>
  </div>
  <button type="button" class="btn btn-default" ng-disabled="!$ctrl.$ctrlRows.getSelectedRows().length" ng-click="$ctrl.deleteRows($ctrl.$ctrlRows.getSelectedRows())">Poista
    datasta</button>
  <div class="btn-group">
    <div style="vertical-align: middle;float: left;line-height: 26px; padding: 4px">Siirrä tilaan:</div>
    <button type="button" class="btn btn-default" ng-disabled="!$ctrl.$ctrlRows.getSelectedRows().length" ng-click="$ctrl.setStatus($ctrl.$ctrlRows.getSelectedRows(), 'ignored')"
      sxy-text="SALAXY.NG1.ImportStagingComponent.status.ignored"></button>
    <button type="button" class="btn btn-default" ng-disabled="!$ctrl.$ctrlRows.getSelectedRows().length" ng-click="$ctrl.setStatus($ctrl.$ctrlRows.getSelectedRows(), 'new')"
      sxy-text="SALAXY.NG1.ImportStagingComponent.statusGroup.todo"></button>
  </div>
</div>
<salaxy-calc-rows-editor ng-if="$ctrl.worktimeApi.current" type="worktime-import-employment" rows="$ctrl.worktimeApi.filteredRows" title="Rivit importissa" ng-ref="$ctrl.$ctrlRows"
  mode="read-only" statuses="$ctrl.statusGroup.statuses" show-row-selection="true"></salaxy-calc-rows-editor>`), s.put("salaxy-components/helpers/import/staging/ImportStaging_rawRows.html", `<div class="btn-toolbar">
  <div class="btn-group">
    <button type="button" class="btn btn-default" ng-repeat="group in $ctrl.statusGroups" ng-click="$ctrl.statusGroup = group"
      ng-disabled="group.active">{{ group.text | sxyTranslate }} <div class="badge">{{ group.count ? group.count : '' }}</div></button>
  </div>
  <button type="button" class="btn btn-default" ng-click="$ctrl.recalculateWorktime()" sxy-text="SALAXY.NG1.ImportStagingComponent.details.recalculate"></button>
  <button type="button" class="btn btn-primary" ng-disabled="!$ctrl.worktimeApi.detailsPayrollId" ng-click="$ctrl.commitPayroll('employment')"
    sxy-text="SALAXY.NG1.ImportStagingComponent.details.commitPayroll"></button>
</div>
<salaxy-calc-rows-editor ng-if="$ctrl.worktimeApi.current" type="worktime-import-employment"
  rows="$ctrl.worktimeApi.filteredRows" title="Rivit importissa" ng-ref="$ctrl.$ctrlRows"
  mode="read-only" statuses="$ctrl.statusGroup.statuses"></salaxy-calc-rows-editor>`), s.put("salaxy-components/helpers/import/staging/ImportStaging_salarySlipsList.html", `<div ng-if="!$ctrl.currentEmploymentPdf">
  <div class="btn-toolbar">
    <div class="btn-group">
      <button type="button" class="btn btn-default" ng-click="$ctrl.salarySlipListType = 'all'" ng-disabled="$ctrl.salarySlipListType == 'all'" sxy-text="SALAXY.NG1.ImportStagingComponent.salarySlipList.type.all"></button>
      <button type="button" class="btn btn-default" ng-click="$ctrl.salarySlipListType = 'preview'" ng-disabled="$ctrl.salarySlipListType == 'preview'" sxy-text="SALAXY.NG1.ImportStagingComponent.salarySlipList.type.preview"></button>
      <button type="button" class="btn btn-default" ng-click="$ctrl.salarySlipListType = 'committed'" ng-disabled="$ctrl.salarySlipListType == 'committed'" sxy-text="SALAXY.NG1.ImportStagingComponent.salarySlipList.type.committed"></button>
      <button type="button" class="btn btn-default" ng-click="$ctrl.salarySlipListType = 'distinct'" ng-disabled="$ctrl.salarySlipListType == 'distinct'" sxy-text="SALAXY.NG1.ImportStagingComponent.salarySlipList.type.distinct"></button>
    </div>
  </div>
  <table class="table table-condenced">
    <thead>
      <tr>
        <th>
          <div sxy-text="SALAXY.NG1.ImportStagingComponent.salarySlipList.status"></div>
          <div sxy-text="SALAXY.NG1.ImportStagingComponent.salarySlipList.id"></div>
        </th>
        <th class="right" style="font-size: 0.75em;">
          <div sxy-text="SALAXY.ENUM.CalcGroup.baseSalary.label"></div>
          <div sxy-text="SALAXY.ENUM.CalcGroup.salaryAdditions.label"></div>
          <div sxy-text="SALAXY.ENUM.CalcGroup.benefits.label"></div>
          <div sxy-text="SALAXY.ENUM.CalcGroup.deductions.label"></div>
          <div sxy-text="SALAXY.ENUM.CalcGroup.expenses.label"></div> 
        </th>
        <th class="right">
          <div sxy-text="SALAXY.NG1.ImportStagingComponent.salarySlipList.grossSalary"></div>
          <div sxy-text="SALAXY.NG1.ImportStagingComponent.salarySlipList.netSalary"></div>
        </th>
        <th class="right">
          <div sxy-text="SALAXY.NG1.ImportStagingComponent.salarySlipList.salaryDate"></div>
          <div sxy-text="SALAXY.NG1.ImportStagingComponent.salarySlipList.period"></div>
        </th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="calc in $ctrl.currentEmploymentCalcs">
        <td>
          <div>
            {{ "CalculationStatus." + calc.status | sxyEnum }}
            <span ng-if="calc.status == 'payrollDraft'"><a ng-href="{{ '#/payroll/details/' + calc.data.payrollId }}" sxy-text="SALAXY.NG1.ImportStagingComponent.salarySlipList.payrollLink"></a></span>
            <!-- TODO: Add links when paid etc. -->
          </div>
          <div class="small truncate" style="max-width: 256px;"><code>{{ calc.id }}</code></div>
        </td>
        <td class="right" style="font-size: 0.75em;">
          <div>{{ calc.data.salary | currency }}</div>
          <div>{{ calc.data.allowances | currency }}</div>
          <div>{{ calc.data.benefits | currency }}</div>
          <div>{{ calc.data.deductions | currency }}</div>
          <div>{{ calc.data.expenses | currency }}</div>
        </td>
        <td class="right">
          <div>{{ calc.grossSalary | currency }}</div>
          <div>{{ calc.data.workerPayment | currency }}</div>
        </td>
        <td class="right">
          <div>{{ calc.salaryDate | sxyDate }}</div>
          <div>{{ calc.data | sxyDateRange }}</div>
        </td>
        <td class="right">
          <button class="btn btn-primary" ng-click="$ctrl.showReportDialog(calc.id)"><i class="bi bi-search"></i> <span sxy-text="SALAXY.UI_Terms.show"></span></button>
          <button class="btn btn-default" ng-click="$ctrl.showSalarySlipPdf(calc.id)"><i class="bi bi-file-earmark-pdf"></i> <span sxy-text="SALAXY.UI_Terms.downloadPdf"></span></button>
          <button class="btn btn-default" sxy-if-role="test" ng-click="$ctrl.showSalarySlipHtml(calc.id)">TEST: html</span></button>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<div ng-if="$ctrl.currentEmploymentPdf">
  <div class="btn-toolbar">
    <button class="btn btn-default pull-right" ng-click="$ctrl.showSalarySlipPdf(undefined)"><i class="bi bi-x-lg"></i> <span sxy-text="SALAXY.UI_Terms.close"></span></button>
  </div>
  <salaxy-spinner ng-if="$ctrl.currentEmploymentPdf == 'loading'"></salaxy-spinner>
  <iframe ng-if="$ctrl.currentEmploymentPdf != 'loading'" style="width:100%;height:200vh" ng-src="{{ $ctrl.currentEmploymentPdf }}"></iframe>
</div>`), s.put("salaxy-components/helpers/import/staging/ImportStaging_test_data.html", `<div sxy-if-role="test">
  <p>&nbsp;</p>
  <hr />
  <button type="button" class="btn btn-default" ng-click="$ctrl.showDebug = !$ctrl.showDebug">TEST ONLY: show/hide debug upload</button>
  <div style="max-width: 800px;">
    <fieldset ng-if="$ctrl.showDebug">
      <legend>Upload test data</legend>
      <p class="lead">
        Upload a test file to the staging server.
        The file should be a JSON file with employment relations or rows: The same structure that an integration sends.
      </p>
      <div class="row">
        <div class="col-md-6">
          <form ng-submit="$ctrl.uploadTestFile($event)">
            <input type="file" class="form-control" />
            <button type="submit" class="btn btn-primary">Process uploaded file</button>
            <button type="submit" class="btn btn-default" ng-click="$ctrl.uploadTestFile('clipboard')">Process from clipboard</button>
          </form>
        </div>
        <div class="col-md-6">
          <p>Get demo files:</p>
          <ul>
            <li>Rows: check the personal ID before processing</li>
            <ul>
              <li><a ng-href="{{ $ctrl.serverUrl + '/test-data/rows_2023-09-01_2023-12-22.json' }}" target="_blank">2023-09-01 - 2023-12-22</a></li>
              <li><a ng-href="{{ $ctrl.serverUrl + '/test-data/rows_2023-11-01_2023-11-30.json' }}" target="_blank">2023-11-01 - 2023-11-30</a></li>
            </ul>
            <li><a ng-href="{{ $ctrl.serverUrl + '/test-data/employment-190372-942M.json' }}" target="_blank">Employment, Pauliina Palkkanen, 190372-942M</a>.</li>
          </ul>
        </div>
      </div>
      <salaxy-json-formatter json="$ctrl.uploadResults" key="'result'" open="0"></salaxy-json-formatter>
    </fieldset>
  </div>
</div>`), s.put("salaxy-components/helpers/import/WorktimeImport.html", `<div class="salaxy-component salaxy-worktime-import">
  <h1 sxy-text="SALAXY.NG1_Sitemap.pro-service.worktime-imports.details"></h1>
  <div ng-if="$ctrl.current">
    <div class="btn-toolbar" role="toolbar">
      <div class="btn-group" role="group">
        <button type="button" class="btn btn-default" ng-click="$ctrl.process('parse')">Parse</button>
        <button type="button" class="btn btn-default" ng-click="$ctrl.process('validate')">Validate</button>
        <button type="button" class="btn btn-default" ng-click="$ctrl.process('preview')">Preview</button>
        <button type="button" class="btn btn-default" ng-click="$ctrl.process('previewWithEmployments')">Preview (commit employments)</button>
        <button type="button" class="btn btn-default" ng-click="$ctrl.process('import')">Import</button>
      </div>
      <button type="button" class="btn btn-default" ng-click="$ctrl.save()">Save</button>
      <a href="#/worktime-imports" class="btn btn-default">Back to list</a>
    </div>
    <sxy-form ng-ref="$frm" open-api="http://localhost:82/schemas/v02.json" xx-open-api="salaxy-secure/schemas/v02.json" type="WorktimeImport" model="$ctrl.current">
      <div>
        <salaxy-tab-buttons
          current-tab="$ctrl.currentTab"
          options="[
            { value: 'default', text: 'Perustiedot' },
            { value: 'files', text: 'Tiedostot' },
            { value: 'employmentrelations', text: 'Employment relations' },
            { value: 'salaryrows', text: 'Salary rows' },
            { value: 'previewemployment', text: 'Preview: Employment' },
            { value: 'preview', text: 'Preview' },
            { value: 'debug', text: 'Debugger' }
          ]"
          tabs-id="worktimeImport">
        </salaxy-tab-buttons>
        <div class="tab-content" id="tab-content-worktimeImport">
          <div class="tab-pane" id="default-tab">
            <div class="row">
              <div class="col-sm-6">
                <fieldset>
                  <legend>Basic data</legend>
                  <sxy-input model="form.id"></sxy-input>
                  <sxy-input model="form.createdAt"></sxy-input>
                  <sxy-input model="form.updatedAt"></sxy-input>
                  <sxy-input model="form.header.status"></sxy-input>
                </fieldset>
              </div>
              <div class="col-sm-6">
                <fieldset>
                  <legend>Control data</legend>
                  <sxy-input model="form.header.payrollId" label="Palkkalistan ID"></sxy-input>
                  <sxy-input model="form.header.sourceId" label="ID (lähde)"></sxy-input>
                  <sxy-input model="form.header.salaryDate" format="date" label="Palkkapäivä"></sxy-input>
                  <sxy-input model="form.header.period" label="Palkkakausi"></sxy-input>
                </fieldset>
              </div>
            </div>
            <div class="tab-pane" id="files-tab"></div>
            <table class="table">
              <thead>
                <tr>
                  <th>
                    File<br />
                    File type (mime type)
                  </th>
                  <th>Data</th>
                </tr>
              </thead>
              <tbody>
                <tr ng-repeat="file in $ctrl.current.files">
                  <td style="width: 50%;">
                    <salaxy-input name="fileName" ng-model="file.name" label-type="plain"></salaxy-input>
                    <salaxy-input name="fileMimeType" ng-model="file.mimeType" label-type="plain"></salaxy-input>
                    <salaxy-input name="fileUsecaseUri" label="Usecase" ng-model="file.usecase.uri"></salaxy-input>
                  </td>
                  <td style="width: 50%;">
                    <salaxy-textarea name="fileData" ng-model="file.data" rows="5" label-type="plain"></salaxy-textarea>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="tab-pane" id="employmentrelations-tab">
            <sxy-table ng-if="!$ctrl.isLoading" doc="http://localhost:82/schemas/v02.json" schema="WorktimeImportEmployment"
            data="$ctrl.current.employments" include="$ctrl.employmentsCols"></sxy-table>
          </div>
          <div class="tab-pane" id="salaryrows-tab">
            <salaxy-calc-rows-editor ng-if="!$ctrl.isLoading" rows="$ctrl.current.rows" title="Import rows" type="worktime-import"></salaxy-calc-rows-editor>
          </div>
          <div class="tab-pane" id="previewemployment-tab">
            TODO: Employment preview UI here
          </div>
          <div class="tab-pane" id="preview-tab">
            TODO: Calc preview (also absences & holidays?)
          </div>
          <div class="tab-pane" id="debug-tab">
            <salaxy-json-formatter json="$ctrl.current"></salaxy-json-formatter>
          </div>
        </div>
      </div>
    </sxy-form>
  </div>
</div>`), s.put("salaxy-components/helpers/JsonFormatter.html", `<button ng-class="$ctrl.btnClass ? $ctrl.btnClass : 'btn btn-default btn-xs'" ng-if="$ctrl.type == 'dialog'" ng-click="$ctrl.showDialog()">
  <span ng-if="$ctrl.hasKey"><span class="key-text">{{ $ctrl.key }}</span></span>
  <span ng-if="!$ctrl.hasKey && $ctrl.isArray()"><span class="bracket">[</span><span class="number">{{$ctrl.json.length}}</span><span class="bracket">]</span></span>
  <span ng-if="!$ctrl.hasKey && !$ctrl.isArray()"><span class="bracket">{</span><span class="number">{{$ctrl.getKeys().length}}</span><span class="bracket">}</span></span>
</button>
<div class="json-formatter-row" ng-if="$ctrl.type != 'dialog'">
  <a ng-click="$ctrl.toggleOpen()">
    <span class="toggler {{ $ctrl.isOpen ? 'open' : ''}}" ng-if="$ctrl.isObject()"></span>
    <span class="key {{$ctrl.changes.type}}" ng-if="$ctrl.hasKey"><span class="key-text">{{ $ctrl.key }}</span><span ng-if="$ctrl.changes"> ({{ $ctrl.changes.icon }})</span><span class="colon">:</span></span>
    <span class="value">
      <span ng-if="$ctrl.isObject()">
        <span ng-if="$ctrl.isArray()"><span class="bracket">[</span><span class="number">{{$ctrl.json.length}}</span><span class="bracket">]</span></span>
        <span ng-if="!$ctrl.isArray()"><span class="bracket">{</span><span class="number">{{$ctrl.getKeys().length}}</span><span class="bracket">}</span></span>
      </span>
      <span ng-if="!$ctrl.isObject()" ng-click="$ctrl.openLink($ctrl.isUrl)" class="{{ $ctrl.jsonType }}"
        ng-class="{ date: $ctrl.isDate, url: $ctrl.isUrl }">{{$ctrl.parseValue($ctrl.json)}}<del
        ng-if="$ctrl.changes">{{$ctrl.changes.oldValue}}</del></span>
    </span>
    <span ng-if="$ctrl.showThumbnail()" class="thumbnail-text">{{$ctrl.getThumbnail()}}</span>
  </a>
  <div class="children" ng-if="$ctrl.getKeys().length && $ctrl.isOpen">
    <salaxy-json-formatter ng-repeat="key in $ctrl.getKeys() track by $index" key="key" open="$ctrl.childrenOpen()"
      json="$ctrl.json[key]" compare="$ctrl.compare" compare-to="$ctrl.compareTo[key]"></salaxy-json-formatter>
    <salaxy-json-formatter ng-repeat="key in $ctrl.deletedKeys track by $index" key="key" open="$ctrl.childrenOpen()"
      json="$ctrl.json[key]" compare="$ctrl.compare" compare-to="$ctrl.compareTo[key]"></salaxy-json-formatter>
  </div>
  <div class="children empty object" ng-if="$ctrl.isEmptyObject()"></div>
  <div class="children empty array" ng-if="$ctrl.getKeys() && !$ctrl.getKeys().length && $ctrl.isOpen && $ctrl.isArray()"></div>
</div>`), s.put("salaxy-components/helpers/JsonFormatterDialog.html", `<div class="modal-calc-list">
  <div class="modal-header">
    <h2 class="modal-title">{{ $ctrl.logic.title }}</h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

  </div>
  <div class="modal-body">
    <salaxy-json-formatter json="$ctrl.current" type="{{ $ctrl.logic.type }}" open="$ctrl.logic.open" compare="$ctrl.logic.compare" compare-to="$ctrl.logic.compareTo" key="$ctrl.logic.key"></salaxy-json-formatter>
    <div class="text-end">
      <button type="reset" class="btn btn-primary" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
    </div>
  </div>
</div>`), s.put("salaxy-components/helpers/NaviSitemap.html", `
<div class="salaxy-component salaxy-navi-sitemap" ng-if="$ctrl.mode != 'horizontal'">

  <ul class="list-group" ng-class="{'salaxy-navi-3-level': $ctrl.mode == '3-level'}">
    <li ng-repeat="section in $ctrl.filterHidden($ctrl.sitemap)" class="list-group-item">
      <a ng-href="{{section.url}}" ng-click="!$ctrl.hasChildren(section) ? $ctrl.toggleNavi() : return" ng-class="{ 'active' : $ctrl.isCurrent(section)}">
        <span ng-if="$ctrl.mode != 'default' && $ctrl.hasChildren(section)">
          <i aria-hidden="true" class="bi float-end" ng-class="$ctrl.isCurrent(section) ? 'bi-chevron-up' : 'bi-chevron-down' "></i>
        </span> {{section.title | sxyTranslate}} <span ng-if="$ctrl.isTest(section)" class="badge bg-primary float-end"><span class="small">test</span></span>
      </a>
      <ul ng-if="$ctrl.hasChildren(section) && ($ctrl.mode == 'default' || $ctrl.isCurrent(section))">
        <li ng-repeat="subNavi in $ctrl.filterHidden(section.children)">
          <a ng-href="{{ $ctrl.getUrl(subNavi) }}" ng-click="$ctrl.toggleNavi()" ng-class="{ 'active' : $ctrl.isCurrent(subNavi)}">{{subNavi.title | sxyTranslate}} <span ng-if="$ctrl.isTest(subNavi)" class="badge bg-primary"><span class="small">test</span></span></a>

          <ul ng-if="$ctrl.mode == '3-level' && $ctrl.isCurrent(subNavi) && $ctrl.hasChildren(subNavi)">
            <li ng-repeat="naviLevel3 in $ctrl.filterHidden(subNavi.children)">
              <a ng-href="{{ $ctrl.getUrl(naviLevel3) }}" ng-click="$ctrl.toggleNavi()" ng-class="{'active' : $ctrl.isCurrent(naviLevel3)}">{{naviLevel3.title | sxyTranslate}} <span ng-if="$ctrl.isTest(naviLevel3)" class="badge bg-primary"><span class="small">test</span></span></a>
            </li>
          </ul>
        </li>
      </ul>
    </li>
  </ul>
  <div class="poweredby">
    <span class="poweredby-image"></span>
  </div>
</div>

<div class="salaxy-component salaxy-navi-sitemap" ng-if="$ctrl.mode == 'horizontal'">
  <header class="salaxy-navi-header-horizontal">
    <div class="container-fluid">
      <div class="d-md-none align-items-center d-flex">
        <span class="page-title-sm">
          <span class="uppercase"><strong>{{ $ctrl.currentPath[0].title | sxyTranslate }}</strong></span>
          <span class="small" ng-if="$ctrl.hasChildren($ctrl.currentPath[0])">/ {{$ctrl.current.title | sxyTranslate}}</span>
        </span>
        <button type="button" class="navbar-toggle btn btn-lg ms-auto" data-bs-toggle="collapse" data-bs-target="#navbar-content">
          <i class="bi bi-list" aria-hidden="true"></i>
        </button>
      </div>
      <nav class="navbar navbar-expand-md">
        <div class="collapse navbar-collapse" id="navbar-content">
          <ul class="navbar-nav">
            <li ng-repeat="section in $ctrl.filterHidden($ctrl.sitemap)" class="nav-item dropdown" ng-class="{ 'active' : $ctrl.isCurrentSection(section)}">
              <a ng-if="!$ctrl.hasChildren(section)" ng-href="{{section.url}}" class="nav-link">{{section.title | sxyTranslate}}</a>
              <a ng-if="$ctrl.hasChildren(section)" class="nav-link dropdown-toggle" data-bs-toggle="dropdown" role="button">{{section.title | sxyTranslate}}</a>
              <ul ng-if="$ctrl.hasChildren(section)" class="dropdown-menu">
                <li ng-repeat="subNavi in $ctrl.filterHidden(section.children)">
                  <a ng-href="{{ $ctrl.getUrl(subNavi) }}" ng-click="$ctrl.toggleNavi()" class="dropdown-item" ng-class="{'active' : $ctrl.isCurrent(subNavi)}">
                    {{subNavi.title | sxyTranslate}} 
                    <span ng-if="$ctrl.isTest(subNavi)" class="badge bg-info"><span class="small">test</span></span>
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  </header>
  <div class="d-none d-sm-block breadcrumb-container mt-2 ps-5 mb-4">
    <span class="text-primary"><span class="text-uppercase"><strong>{{ $ctrl.currentPath[0].title | sxyTranslate }}</strong></span> <span class="small" ng-if="$ctrl.hasChildren($ctrl.currentPath[0])">/ {{$ctrl.current.title | sxyTranslate}}</span></span>
  </div>
</div>`), s.put("salaxy-components/helpers/NaviStarterLayout.html", `<salaxy-spinner ng-if="$ctrl.showFullPageLoader" full-screen="true" heading="SALAXY.UI_Terms.loading"></salaxy-spinner>
<div ng-if="!$ctrl.showFullPageLoader && (!$ctrl.layout || $ctrl.layout == 'default')" ng-cloak class="salaxy-component salaxy-navi-page-container" ng-class="{ 'salaxy-navi-sm-opened': $ctrl.isNaviOpen }">

  <ng-transclude ng-transclude-slot="nav">
    <nav class="salaxy-navi-sidebar d-print-none">
      <div class="salaxy-logo-container">
        <a href="/#/"></a>
      </div>
      <div class="d-block d-md-none mobile-login-container text-center">
        <salaxy-login-button></salaxy-login-button>
      </div>
      <salaxy-navi-sitemap mode="accordion"></salaxy-navi-sitemap>
    </nav>
  </ng-transclude>
  <header class="salaxy-navi-header-mobile d-block d-md-none">
    <button type="button" class="salaxy-navi-hamburger d-print-none btn btn-default float-end" ng-click="$ctrl.toggleNavi()">
      <span class="sr-only" sxy-text="SALAXY.UI_Terms.navigation"></span>
      <i class="bi bi-list" aria-hidden="true"></i>
    </button>
    <h1>{{ $ctrl.title | sxyTranslate }}</h1>
  </header>
  <div class="salaxy-navi-main-container">
    <content>
      <ng-transclude ng-transclude-slot="header">
        <header class="salaxy-navi-header-default d-none d-md-block">
          <div ng-class="$ctrl.current.isFullWidth ? 'container-fluid' : 'container-md'" class="h-100">
            <div class="d-flex justify-content-between align-items-center h-100">
              <h1 class="page-title m-0">
                {{ $ctrl.title | sxyTranslate }}
              </h1>
              <div class="d-print-none">
                <salaxy-login-button class='float-end'></salaxy-login-button>
              </div>
            </div>
          </div>
        </header>
      </ng-transclude>
      <div id="salaxy-alert-container"></div>
      <ng-transclude ng-transclude-slot="main">
        <main class="pt-3">
          <div ng-class="$ctrl.current.isFullWidth ? 'container-fluid' : 'container-md'" ng-if="!$ctrl.getDisabled()" ng-view autoscroll="true"></div>
          <div class="container" ng-if="$ctrl.getDisabled()">
            <div class="alert alert-info" sxy-text="SALAXY.UI_Terms.pageDisabledAlert"></div>
          </div>
        </main>
      </ng-transclude>
    </content>
  </div>
</div>

<div ng-if="!$ctrl.showFullPageLoader && $ctrl.layout == 'iframe'" ng-cloak class="salaxy-component salaxy-navi-page-container iframe-container">
  <div class="salaxy-navi-main-container">
    <content>
      <ng-transclude ng-transclude-slot="header" ng-if="$ctrl.mode != 'horizontal'">

        <header class="salaxy-navi-header-default">
          <div class="container-fluid">
            <div class="d-flex align-items-center">
              <h1 class="page-title">
                {{ $ctrl.title | sxyTranslate }}
              </h1>
              <div class="ms-auto" ng-if="$ctrl.hasChildren($ctrl.currentPath[0])" style="margin-left:10px;">
                <div class="btn-group dropdown">
                  <button class="btn btn-default dropdown-toggle btn-submenu" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span class="d-none d-sm-inline-block">{{ ($ctrl.currentPath[0].subMenuTitle || 'SALAXY.UI_Terms.menu') | sxyTranslate }}</span>
                    <i class="bi bi-list d-inline-block d-sm-none" aria-hidden="true"></i>
                  </button>
                  <ul class="dropdown-menu dropdown-menu-end" menu role="menu">
                    <li ng-repeat="subNavi in $ctrl.filterHidden($ctrl.currentPath[0].children)">
                      <a class="dropdown-item" ng-href="{{subNavi.url}}" class="dropdown-item">{{ subNavi.title | sxyTranslate }}</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </header>
      </ng-transclude>
      <ng-transclude ng-transclude-slot="nav" ng-if="$ctrl.mode == 'horizontal'">

        <salaxy-navi-sitemap mode="{{$ctrl.mode}}"></salaxy-navi-sitemap>
      </ng-transclude>


      <div id="salaxy-alert-container"></div>
      <ng-transclude ng-transclude-slot="main">
        <main salaxy-if-role="company">
          <div ng-class="$ctrl.current.isFullWidth ? 'container-fluid' : 'container-md'" ng-if="!$ctrl.getDisabled()" ng-view autoscroll="true"></div>
          <div class="container" ng-if="$ctrl.getDisabled()">
            <div class="alert alert-info" sxy-text="SALAXY.UI_Terms.pageDisabledAlert"></div>
          </div>
        </main>
        <main salaxy-if-role="!company">
          <div class="salaxy-navi-page-container salaxy-component salaxy-tpl-iframe-anon" style="padding-left: 0;">
            <div class="container" style="max-width: 600px; margin-top: 10vh;">
              <div class="alert alert-danger">
                <h2 sxy-text="SALAXY.UI_Terms.sessionExpired"></h2>
                <p class="lead text-muted" sxy-text="SALAXY.UI_Terms.sessionExpiredEmbedded"></p>
                <div sxy-if-role="person">
                  <p>&nbsp;</p>
                  <pre><small>ERROR: Authenticated as personal, not supported.</small></pre>
                </div>
                <div sxy-if-role="test">
                  
                  <small>Test only:</small> <salaxy-login-button></salaxy-login-button>
                </div>
              </div>
            </div>
          </div>
        </main>
      </ng-transclude>
    </content>
  </div>
</div>
<div ng-if="!$ctrl.showFullPageLoader && $ctrl.layout == 'pro-customer'" ng-cloak class="salaxy-component salaxy-navi-page-container iframe-container">
  <div class="salaxy-navi-main-container">
    <content>
      <ng-transclude ng-transclude-slot="header">
      </ng-transclude>
      <div id="salaxy-alert-container"></div>
      <ng-transclude ng-transclude-slot="main">
        <main class="pt-2">
          <div ng-class="$ctrl.current.isFullWidth ? 'container-fluid' : 'container-md'"  ng-if="!$ctrl.getDisabled()" ng-view autoscroll="true"></div>
          <div class="container-md" ng-if="$ctrl.getDisabled()">
            <div class="alert alert-info" sxy-text="SALAXY.UI_Terms.pageDisabledAlert"></div>
          </div>
        </main>
      </ng-transclude>
    </content>
  </div>
</div>
</div>
</main>
</ng-transclude>
</content>
</div>
</div>`), s.put("salaxy-components/helpers/Spinner.html", `<div ng-cloak ng-class="{'sxy-spinner-full-screen-container': $ctrl.fullScreen, 'salaxy-component': true, 'salaxy-spinner': true, }">
  <div class="sxy-spinner-container">
    <div class="sxy-spinner">
      <svg class="sxy-spinner-bg" viewBox="0 0 64 64"><circle cx="32" cy="32" r="26"></circle></svg>
      <svg class="sxy-spinner-spin" viewBox="0 0 64 64">
        <circle transform="translate(32,32)" r="26"></circle>
      </svg>
    </div>
    <h3 ng-if="$ctrl.heading" class="spinner-heading">{{$ctrl.getHeading()}}</h3>
    <p style="white-space: pre;" ng-if="$ctrl.text" class="spinner-text">{{$ctrl.text | sxyTranslate}}</p>
  </div>
</div>`), s.put("salaxy-components/helpers/Tab.html", `<div class="tabpane" ng-class="{ active: $ctrl.selected}" ng-show="$ctrl.selected" ng-transclude="content"></div>
<div ng-transclude="heading"></div>
`), s.put("salaxy-components/helpers/TabButtons.html", `<div class="tabs-buttons" id="tabs-buttons-{{$ctrl.tabsId}}">
  <ul class="nav nav-tabs">
    <li class="nav-item" ng-repeat="tab in $ctrl.options" ng-if="!tab.hidden">
      <button
        class="nav-link"
        id="{{ tab.value }}-tab-button"
        ng-disabled="tab.disabled"
        type="button"
        ng-click="$ctrl.showTab(tab.value)"
        ng-class="{ active: $ctrl.currentTab === tab.value }">
        {{ $ctrl.getTabText(tab.text) }}
      </button>
    </li>
  </ul>
</div>`), s.put("salaxy-components/helpers/Tabs.html", `<div>
    <ul class="nav nav-tabs">
        <li ng-repeat="tab in $ctrl.tabs" ng-class="{ active: tab.selected, disabled: tab.disable}" class="nav-item">
            <a href class="nav-link" ng-click="$ctrl.select(tab, $event)" salaxy-append-node="tab.headingElement">{{tab.heading}}</a>
        </li>
    </ul>
    <div class="tab-content">
        <ng-transclude></ng-transclude>
    </div>
</div>`), s.put("salaxy-components/helpers/UiTranslator.html", `<div class="salaxy-component salaxy-ui-translator">
  <salaxy-spinner ng-if="$ctrl.isLoading" heading="SALAXY.UI_Terms.loading" text="SALAXY.UI_Terms.pleaseWait"></salaxy-spinner>
  <div ng-if="!$ctrl.isLoading && $ctrl.allKeyValues.length &lt; 1" class="alert alert-danger">
    No rows for filter: {{$ctrl.filter}}
  </div>
  <div ng-if="$ctrl.allKeyValues.length > 0">
    <div ng-if="$ctrl.mode == 'fieldset'">
      <fieldset class="form-horizontal" ng-repeat="row in $ctrl.allKeyValues | limitTo: 10">
        <legend>
          <button ng-if="$ctrl.canDeleteFromText(row.fullKey)" ng-click="$ctrl.removeFromTexts(row.fullKey)" class="btn btn-danger btn-xs float-end"><i class="bi bi-trash"></i></button>
          {{row.fullKey}}
        </legend>
        <salaxy-input ng-if="$ctrl.checkIfExistsInTexts(row.fullKey, 'fi')" name="fi" ng-change="$ctrl.updateTexts()" placeholder="{{row.fi}}" ng-model="$ctrl.getEditableText(row.fullKey).fi" label="Suomi"></salaxy-input>
        <salaxy-input ng-if="!$ctrl.checkIfExistsInTexts(row.fullKey, 'fi')" name="fi" ng-click="$ctrl.addToTexts(row.fullKey, 'fi')" ng-model="row.fi" read-only="true" label="Suomi"></salaxy-input>
        <salaxy-input ng-if="$ctrl.checkIfExistsInTexts(row.fullKey, 'en')" name="en" ng-change="$ctrl.updateTexts()" placeholder="{{row.en}}" ng-model="$ctrl.getEditableText(row.fullKey).en" label="English"></salaxy-input>
        <salaxy-input ng-if="!$ctrl.checkIfExistsInTexts(row.fullKey, 'en')" name="en" ng-click="$ctrl.addToTexts(row.fullKey, 'en')" ng-model="row.en" read-only="true" label="English"></salaxy-input>
        <salaxy-input ng-if="$ctrl.checkIfExistsInTexts(row.fullKey, 'sv')" name="sv" ng-change="$ctrl.updateTexts()" placeholder="{{row.sv}}" ng-model="$ctrl.getEditableText(row.fullKey).sv" label="Svenska"></salaxy-input>
        <salaxy-input ng-if="!$ctrl.checkIfExistsInTexts(row.fullKey, 'sv')" name="sv" ng-click="$ctrl.addToTexts(row.fullKey, 'sv')" ng-model="row.sv" read-only="true" label="Svenska"></salaxy-input>
      </fieldset>
      <div class="alert alert-warning" ng-if="$ctrl.allKeyValues.length > 10">ERR: More than 10 translation key values, showing max 10.</div>
    </div>
    <div ng-if="$ctrl.mode != 'fieldset'">
      <div class="btn-toolbar" role="toolbar" aria-label="Report options">
        <div class="btn-group btn-group-sm dropdown">
          <button id="single-button" type="button" class="btn btn-secondary dropdown-toggle" data-bs-toggle="dropdown" ng-disabled="disabled">
            Avaimet:
          </button>
          <ul class="dropdown-menu" role="menu" aria-labelledby="single-button">
            <li role="menuitem">
              <a href="" ng-click="$ctrl.showCols.fullKey = !$ctrl.showCols.fullKey" class="dropdown-item">
                <i ng-if="$ctrl.showCols.fullKey" class="bi bi-x-lg" aria-hidden="true"></i>
                Koko avain
              </a>
            </li>
            <li role="menuitem">
              <a href="" ng-click="$ctrl.showCols.shortKey = !$ctrl.showCols.shortKey" class="dropdown-item">
                <i ng-if="$ctrl.showCols.shortKey" class="bi bi-x-lg" aria-hidden="true"></i>
                Lyhyt avain
              </a>
            </li>
            <li role="menuitem">
              <a href="" ng-click="$ctrl.showCols.fileName = !$ctrl.showCols.fileName" class="dropdown-item">
                <i ng-if="$ctrl.showCols.fileName" class="bi bi-x-lg" aria-hidden="true"></i>
                Käännöstiedosto / pääryhmä
              </a>
              </li>
            <li role="menuitem">
              <a href="" ng-click="$ctrl.showCols.keyComponent = !$ctrl.showCols.keyComponent" class="dropdown-item">
                <i ng-if="$ctrl.showCols.keyComponent" class="bi bi-x-lg" aria-hidden="true"></i>
                Komponentti / tiedoston ryhmittely
              </a>
            </li>
            <li role="menuitem">
              <a href="" ng-click="$ctrl.showCols.keyValue = !$ctrl.showCols.keyValue" class="dropdown-item">
                <i ng-if="$ctrl.showCols.keyValue" class="bi bi-x-lg" aria-hidden="true"></i>
                3. taso (1. avain)
              </a>
            </li>
          </ul>
        </div>
        <div class="btn-group btn-group-sm dropdown ms-1">
          <button id="single-button" type="button" class="btn btn-secondary dropdown-toggle" data-bs-toggle="dropdown" ng-disabled="disabled">
            Kieli:
          </button>
          <ul class="dropdown-menu" role="menu" aria-labelledby="single-button">
            <li role="menuitem">
              <a href="" ng-click="$ctrl.showCols.fi = !$ctrl.showCols.fi" class="dropdown-item">
                <i ng-if="$ctrl.showCols.fi" class="bi bi-x-lg" aria-hidden="true"></i> 
                Suomi
              </a>
            </li>
            <li role="menuitem">
              <a href="" ng-click="$ctrl.showCols.en = !$ctrl.showCols.en" class="dropdown-item">
                <i ng-if="$ctrl.showCols.en" class="bi bi-x-lg" aria-hidden="true"></i> 
                Englanti
              </a>
            </li>
            <li role="menuitem">
              <a href="" ng-click="$ctrl.showCols.sv = !$ctrl.showCols.sv" class="dropdown-item">
                <i ng-if="$ctrl.showCols.sv" class="bi bi-x-lg" aria-hidden="true"></i> 
                Ruotsi
              </a>
            </li>
          </ul>
        </div>
        <div class="btn-group btn-group-sm ms-sm-auto" role="group" aria-label="Json">
          <button sxy-if-role="!anon" type="button" class="btn btn-secondary" ng-click="$ctrl.downloadTexts()">
            <span class="d-none d-md-inline-block">Lataa muutos JSON</span>
            <i class="bi bi-file-earmark" aria-hidden="true"></i>
          </button>
        </div>
      </div>
      <table class="table table-striped">
        <thead>
          <tr>
            <th ng-if="$ctrl.showCols.fullKey">
              <salaxy-input label-type="basic" name="fullKey" label="Koko avain" ng-model="$ctrl.listFilter.fullKey"></salaxy-input>
            </th>
            <th ng-if="$ctrl.showCols.shortKey">
              <salaxy-input label-type="basic" name="shortKey" label="Lyhyt avain" ng-model="$ctrl.listFilter.shortKey"></salaxy-input>
            </th>
            <th ng-if="$ctrl.showCols.keyComponent">
              <salaxy-input label-type="basic" name="keyComponent" label="Komponenttiavain" ng-model="$ctrl.listFilter.keyComponent"></salaxy-input>
            </th>
            <th ng-if="$ctrl.showCols.fi">
              <salaxy-input label-type="basic" name="fi" label="Suomi" ng-model="$ctrl.listFilter.fi"></salaxy-input>
            </th>
            <th ng-if="$ctrl.showCols.en">
              <salaxy-input label-type="basic" name="en" label="Englanti" ng-model="$ctrl.listFilter.en"></salaxy-input>
            </th>
            <th ng-if="$ctrl.showCols.sv">
              <salaxy-input label-type="basic" name="sv" label="Ruotsi" ng-model="$ctrl.listFilter.sv"></salaxy-input>
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="row in $ctrl.allKeyValues | filter: $ctrl.listFilter | limitTo: 100 ">
            <td style="word-break:break-word;" ng-if="$ctrl.showCols.fullKey">{{row.fullKey}}</td>
            <td style="word-break:break-word;" ng-if="$ctrl.showCols.shortKey">{{row.shortKey}}</td>
            <td style="word-break:break-word;" ng-if="$ctrl.showCols.keyComponent">{{row.keyComponent}}</td>
            <td style="word-break:break-word;" ng-if="$ctrl.showCols.keyValue">{{row.keyValue}}</td>
            <td style="word-break:break-word;" ng-if="$ctrl.showCols.fi && $ctrl.checkIfExistsInTexts(row.fullKey, 'fi')">
              <salaxy-input name="fi" ng-change="$ctrl.updateTexts()" placeholder="{{row.fi}}" ng-model="$ctrl.getEditableText(row.fullKey).fi" label-type="plain"></salaxy-input>
            </td>
            <td style="word-break:break-word;" ng-if="$ctrl.showCols.fi && !$ctrl.checkIfExistsInTexts(row.fullKey, 'fi')" ng-click="$ctrl.addToTexts(row.fullKey, 'fi')">{{row.fi}}
            </td>
  
            <td style="word-break:break-word;" ng-if="$ctrl.showCols.en && $ctrl.checkIfExistsInTexts(row.fullKey, 'en')">
              <salaxy-input name="en" ng-change="$ctrl.updateTexts()" placeholder="{{row.en}}" ng-model="$ctrl.getEditableText(row.fullKey).en" label-type="plain"></salaxy-input>
            </td>
            <td style="word-break:break-word;" ng-if="$ctrl.showCols.en && !$ctrl.checkIfExistsInTexts(row.fullKey, 'en')" ng-click="$ctrl.addToTexts(row.fullKey, 'en')">{{row.en}}
            </td>
            <td style="word-break:break-word;" ng-if="$ctrl.showCols.sv && $ctrl.checkIfExistsInTexts(row.fullKey, 'sv')">
              <salaxy-input name="sv" ng-change="$ctrl.updateTexts()" placeholder="{{row.sv}}" ng-model="$ctrl.getEditableText(row.fullKey).sv" label-type="plain"></salaxy-input>
            </td>
            <td style="word-break:break-word;" ng-if="$ctrl.showCols.sv && !$ctrl.checkIfExistsInTexts(row.fullKey, 'sv')" ng-click="$ctrl.addToTexts(row.fullKey, 'sv')">{{row.sv}}
            </td>
            <td ng-if="$ctrl.canDeleteFromText(row.fullKey)"><button ng-click="$ctrl.removeFromTexts(row.fullKey)" class="btn btn-danger"><i class="bi bi-trash"></i></button>
            </td>
            <td ng-if="!$ctrl.canDeleteFromText(row.fullKey)"></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>`), s.put("salaxy-components/invoices/CompanyInvoices.html", `<div class="salaxy-component salaxy-company-invoices">
  <salaxy-odata-table crud-controller="CompanyInvoicesController as $crud" options="$ctrl.getListOptions()" crud-bindings="{ channel: $ctrl.channel }"
    template-url="salaxy-components/odata/lists/InvoicesCompany.html">
  </salaxy-odata-table>
</div>`), s.put("salaxy-components/invoices/CreditTransfer.html", `<div class="salaxy-component salaxy-credit-transfer">
  <div class="salaxy-credit-transfer-official" ng-if="$ctrl.mode != 'barcode-copy'">
    <div class="sct-row sct-row1">
      <div class="sct-col sct-col1">
        <div class="sct-row sct-row1" sxy-html="SALAXY.NG1.CreditTransferComponent.receiverIban.html"></div>
        <div class="sct-row sct-row2" sxy-html="SALAXY.NG1.CreditTransferComponent.receiver.html"></div>
        <div class="sct-row sct-row3">
          <div class="sct-label-payer" sxy-html="SALAXY.NG1.CreditTransferComponent.payerInfo.html"></div>
          <div class="sct-label-credit-transfer" sxy-text="SALAXY.NG1.CreditTransferComponent.creditTransfer"></div>
          <div class="sct-label-signature" sxy-html="SALAXY.NG1.CreditTransferComponent.signature.html"></div>
        </div>
        <div class="sct-row sct-row4" sxy-html="SALAXY.NG1.CreditTransferComponent.fromAccount.html"></div>
      </div>
      <div class="sct-col sct-col2">
        <div class="sct-row sct-row1">
          <!-- Recipient account numbers (IBAN), max 4 lines -->
          <div class="sct-label-iban" sxy-text="SALAXY.NG1.CreditTransferComponent.iban"></div>
          <div class="sct-filled-content">
            {{ $ctrl.invoice.recipient.iban | sxyIban }}
          </div>
          <div class="sct-label-iban" sxy-text="BIC"></div>
          <div class="sct-filled-content">
            {{ $ctrl.getBicForIban($ctrl.invoice.recipient.iban) }}
          </div>
        </div>
        <div class="sct-row sct-row2">
          <div class="sct-filled-content sct-filled-content-main">
            <!-- Recipient, max 3 lines -->
            {{ $ctrl.invoice.recipient.fullName }}<br> {{ $ctrl.invoice.recipient.contact.street }} {{ $ctrl.invoice.recipient.contact.postalCode }} {{ $ctrl.invoice.recipient.contact.city }}
          </div>
        </div>
        <div class="sct-row sct-row3">
          <div class="sct-filled-content sct-filled-content-main">
            <!-- Payer’s name and address -->
            {{ $ctrl.invoice.payer.avatar.displayName }}<br> {{ $ctrl.invoice.payer.contact.street }}<br> {{ $ctrl.invoice.payer.contact.postalCode }} {{ $ctrl.invoice.payer.contact.city }}
          </div>
          <div class="sct-filled-content sct-signature">
            <!-- Signature -->
          </div>
          <div class="sct-guideline-signature"></div>
        </div>
        <div class="sct-row sct-row4">
          <div class="sct-filled-content sct-filled-content-main">
            <!-- From account no. -->
          </div>
        </div>
      </div>
      <div class="sct-col sct-col3">
        <div class="sct-row sct-row1" ng-if="$ctrl.getQrCode(row) !== 'loading' && $ctrl.getQrCode(row) !== 'error'">
          <div class="sct-qrcode" >
            <div ng-bind-html="$ctrl.getQrCode(row)"></div>
          </div>
          <div class="sct-filled-content-message">
            <ng-transclude ng-transclude-slot="message">
              <span>{{ $ctrl.invoice.header.message }}</span>
            </ng-transclude>
          </div>
        </div>
        <div class="sct-row sct-row1" ng-if="$ctrl.getQrCode(row) === 'error'">
          <div class="sct-filled-content sct-filled-content-main">
            <ng-transclude ng-transclude-slot="message">
              <span>{{ $ctrl.invoice.header.message }}</span>
            </ng-transclude>
          </div>
        </div>
        <div class="sct-row sct-row2">
          <div class="sct-col sct-col1" sxy-html="SALAXY.NG1.CreditTransferComponent.refNumber.html"></div>
          <div class="sct-col sct-col2">
            <div class="sct-filled-content sct-filled-content-main">
              <!-- Ref. nr -->
              {{ $ctrl.invoice.header.referenceNumber | sxyIban }}
            </div>
          </div>
        </div>
        <div class="sct-row sct-row3">
          <div class="sct-col sct-col1" sxy-html="SALAXY.NG1.CreditTransferComponent.dueDate.html"></div>
          <div class="sct-col sct-col2">
            <div class="sct-filled-content sct-filled-content-main">
              <!-- Due date -->
              {{ $ctrl.invoice.header.dueDate | sxyDate }}
            </div>
          </div>
          <div class="sct-col sct-col3">
            <div class="sct-label-euro" sxy-text="SALAXY.NG1.CreditTransferComponent.euro"></div>
            <div class="sct-filled-content sct-filled-content-main">
              <!-- Euro amount -->
              {{ $ctrl.invoice.header.total | currency }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="sct-row sct-row2">
      <div id="barcode">
        <!-- Barcode can be shown only with FI IBAN -->
         <div ng-bind-html="$ctrl.getBarcode()"></div>
      </div>
      <!--
        NOTE: Terms of clearance is part of original specification: https://www.finanssiala.fi/wp-content/uploads/2021/03/Tilisiirto-opas.pdf.
        It is removed because it has no real value today and it makes reading barcode difficult.
      -->
      <!--
        <div id="terms-of-clearance">
          Maksu välitetään saajalle maksujenvälityksen ehtojen mukaisesti ja vain maksajan ilmoittaman tilinumeron perusteella.
          <br> Betalningen förmedlas till mottagaren engligt villkoren för betalningsförmedling och endast till det kontonummer som betalaren angivit.
        </div>
      -->
    </div>
  </div>
  <div class="barcodeform-container d-print-none" ng-if="$ctrl.mode != 'official'">
    <form name="barcodeForm" id="barcodeForm" class="form-horizontal">
      <p sxy-text="SALAXY.NG1.CreditTransferComponent.transferDescription" ng-if="$ctrl.mode != 'barcode-copy' && !$ctrl.isInternationalIban()"></p>
      <p ng-if="$ctrl.mode != 'barcode-copy' && $ctrl.isInternationalIban()">&nbsp;</p>    
      <div class="row" ng-if="!$ctrl.isInternationalIban()">
        <div class="col-sm-10">
          <salaxy-input name="{{ 'barcode' + $ctrl.getId() }}" label="SALAXY.NG1.CreditTransferComponent.barcodeLabel" readonly="true" label-cols="col-sm-4" ng-model="$ctrl.bcValue"></salaxy-input>
        </div>
        <div class="col-sm-2">
          <button class="btn btn-default btn-block" ng-click="$ctrl.copyBarcode()" sxy-text="SALAXY.UI_Terms.copyToClipboard"></button>
        </div>
      </div>
    </form>
  </div>
</div>`), s.put("salaxy-components/invoices/InvoiceAlerts.html", `<div class="row payment-started-alert">
  <div class="col-xs-12">
    <salaxy-alert type="warning" ng-repeat="paymentChannel in $ctrl.groupedPaymentChannelResult">
      <main>
        <div ng-bind-html="$ctrl.getpaymentChannelInfoHtml(paymentChannel)"></div>
      </main>
    </salaxy-alert>
  </div>
</div>`), s.put("salaxy-components/invoices/InvoiceEdit.html", `<div class="salaxy-component salaxy-invoice-edit">
  <salaxy-spinner ng-if="$ctrl.isLoading"></salaxy-spinner>
  <div class="alert alert-danger" ng-if="!$ctrl.isLoading && !$ctrl.current" sxy-text="SALAXY.NG1.InvoiceEditComponent.error"></div>
  <form name="statusForm" ng-if="$ctrl.current" ng-submit="$ctrl.requestStatusUpdate()">
    <div class="form-horizontal">
      <h2 sxy-text="SALAXY.NG1.InvoiceEditComponent.headingAlt"></h2>
      <p sxy-text="SALAXY.NG1.InvoiceEditComponent.headingInfoAlt"></p>
      <salaxy-input-enum label="SALAXY.NG1.InvoiceEditComponent.channel" read-only="true" name="paymentChannel" ng-model="$ctrl.current.header.channel" enum="PaymentChannel"></salaxy-input-enum>
      <salaxy-input-enum label="SALAXY.NG1.InvoiceEditComponent.invoiceStatus" read-only="!( ( ('test' | sxyIsInRole) || ('pro' | sxyIsInRole) ) && ($ctrl.current.header.channel == 'palkkausManual' || $ctrl.current.header.channel == 'talenomManual' || $ctrl.current.header.channel == 'palkkausInvoices' || $ctrl.current.header.channel == 'kitsas' || $ctrl.current.header.channel == 'palkkausWS' || $ctrl.current.header.channel == 'palkkausPSD'))" name="requestedStatus" ng-model="$ctrl.requestedStatus" enum="InvoiceStatus" required></salaxy-input-enum>
    </div>
    <div>
      <button type="submit" class="btn btn-primary float-end" ng-disabled="!statusForm.$valid || !( ( ('test' | sxyIsInRole) || ('pro' | sxyIsInRole) ) && ($ctrl.current.header.channel == 'palkkausManual' || $ctrl.current.header.channel == 'talenomManual' || $ctrl.current.header.channel == 'palkkausInvoices' || $ctrl.current.header.channel == 'kitsas' || $ctrl.current.header.channel == 'palkkausWS' || $ctrl.current.header.channel == 'palkkausPSD'))" sxy-text="SALAXY.NG1.InvoiceEditComponent.updateStatusBtn"></button>
      <button ng-if="'test' | sxyIsInRole" type="button" ng-click="$ctrl.delete()" class="btn btn-danger" sxy-text="SALAXY.NG1.InvoiceEditComponent.deleteInvoice" pre="(Test only): "></button>
      <button ng-if="'test' | sxyIsInRole" type="button" ng-click="$ctrl.deleteWithBusinessObjects()" class="btn btn-danger" sxy-text="SALAXY.NG1.InvoiceEditComponent.deleteInvoiceWithCals" pre="(Test only): "></button>
    </div>
  </form>
</div>`), s.put("salaxy-components/invoices/InvoiceList.html", `<div class="salaxy-component salaxy-invoice-list" ng-switch="$ctrl.mode">
  <salaxy-odata-table ng-switch-when="panel" crud-controller="InvoiceCrudController as $crud" options="$ctrl.getListOptions()"
    template-url="salaxy-components/odata/lists/InvoicesPanel.html">
  </salaxy-odata-table>

  <salaxy-odata-table ng-switch-when="sepa" crud-controller="InvoiceSepaController as $crud"
    template-url="salaxy-components/odata/lists/InvoicesSepa.html">
  </salaxy-odata-table>

  <salaxy-odata-table ng-switch-when="person" crud-controller="InvoiceCrudController as $crud" options="$ctrl.getListOptions()"
    template-url="salaxy-components/odata/lists/InvoicesPerson.html">
  </salaxy-odata-table>
  
  <div ng-switch-default>
    <salaxy-odata-table crud-controller="InvoiceCrudController as $crud" options="$ctrl.getListOptions()" template-url="salaxy-components/odata/lists/Invoices.html">
    </salaxy-odata-table>
  </div>

</div>`), s.put("salaxy-components/invoices/InvoicePaymentList.html", `<div class="salaxy-component salaxy-invoice-list">
  <salaxy-odata-table crud-controller="InvoicePaymentListController as $crud"
    template-url="salaxy-components/odata/lists/InvoicePaymentList.html">
  </salaxy-odata-table>
</div>`), s.put("salaxy-components/invoices/InvoicePreview.html", `<div ng-init="$ctrl.view = 'full'">
  <salaxy-spinner ng-if="!$ctrl.current && $ctrl.isLoading"></salaxy-spinner>
  <div class="alert alert-danger" ng-if="!$ctrl.isLoading && !$ctrl.current" sxy-text="SALAXY.NG1.InvoicePreviewComponent.error"></div>
  
  <div ng-if="$ctrl.current">
    <div class="mb-3">
      <div class="btn-group btn-group-sm" role="group">
        <salaxy-toggle-buttons
          ng-model="$ctrl.view"
          options="[
            { value: 'full', label: 'SALAXY.NG1.InvoicePreviewComponent.fullInvoice' },
            { value: 'partial', label: 'SALAXY.NG1.InvoicePreviewComponent.tableInvoice' }
          ]"
          type="inline"></salaxy-toggle-buttons>
      </div>
      <a ng-href="{{$ctrl.getContentUrl($ctrl.current.id, true)}}" target="_blank"class="btn btn-primary float-end">
        <i class="bi bi-file-earmark-pdf"></i> <span sxy-text="SALAXY.NG1.InvoicePreviewComponent.showFile"></span>
      </a>
    </div>
    <salaxy-invoice-report invoice="$ctrl.current" apply-site-styles="$ctrl.view == 'partial'"></salaxy-invoice-report>
  </div>
</div>`), s.put("salaxy-components/invoices/InvoiceReport.html", `<div class="salaxy-component salaxy-calc-report">
  <div class="row" ng-if="$ctrl.applySiteStyles">
    <div class="col-sm-6">
      <table>
        <tr>
          <td colspan="2"><small><strong sxy-text="SALAXY.NG1.InvoicePreviewComponent.recipient" ps=":"></strong></small></td>
        </tr>
        <tr>
          <td>
            <salaxy-avatar avatar="$ctrl.invoice.recipient.beneficiary.avatar" style="font-size: 64px;"></salaxy-avatar>
          </td>
          <td>
            <div><strong>{{ $ctrl.invoice.recipient.fullName }}</strong></div>
            <div>
              {{ $ctrl.invoice.recipient.contact.street }}<br /> {{ $ctrl.invoice.recipient.contact.postalCode }} {{ $ctrl.invoice.recipient.contact.city }}
            </div>
          </td>
        </tr>
        <tr>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <td colspan="2"><small><strong sxy-text="SALAXY.NG1.InvoicePreviewComponent.payer" ps=":"></strong></small></td>
        </tr>
        <tr>
          <td>
            <salaxy-avatar avatar="$ctrl.invoice.payer.avatar" style="font-size: 64px;"></salaxy-avatar>
          </td>
          <td>
            <div><strong>{{ $ctrl.invoice.payer.avatar.displayName }}</strong></div>
            <div>
              {{ $ctrl.invoice.payer.contact.street }}<br /> {{ $ctrl.invoice.payer.contact.postalCode }} {{ $ctrl.invoice.payer.contact.city }}
            </div>
          </td>
        </tr>
      </table>
    </div>
    <div class="col-sm-6">
      <p style="font-size: 24px; font-weight: bold; text-transform: uppercase;">{{ "SALAXY.NG1.InvoiceReportComponent.invoice.title" | sxyTranslate }}</p>
      <p style="font-size: 16px; font-weight: bold; text-transform: uppercase;">{{ ("SALAXY.ENUM.InvoiceType." + $ctrl.invoice.header.type + ".label") | sxyTranslate }}</p>
      <div > </div>
      <table>
        <tr>
          <td sxy-text="SALAXY.NG1.InvoicePreviewComponent.date" ps=":"></td>
          <td>{{ $ctrl.invoice.header.date | sxyDate }}</td>
        </tr>
        <tr>
          <td sxy-text="SALAXY.NG1.InvoicePreviewComponent.dueDate" ps=":"></td>
          <td>{{ $ctrl.invoice.header.dueDate | sxyDate }}</td>
        </tr>
        <tr>
          <td sxy-text="SALAXY.NG1.InvoicePreviewComponent.referenceNumber" ps=":"></td>
          <td>{{ $ctrl.invoice.header.referenceNumber || "-" }}</td>
        </tr>
        <tr>
          <td sxy-text="SALAXY.NG1.InvoicePreviewComponent.iban" ps=":"></td>
          <td ng-if="!$ctrl.isPreviewInvoice()">{{ $ctrl.invoice.recipient.iban | sxyIban }}</td>
          <td ng-if="$ctrl.isPreviewInvoice()">{{ 'SALAXY.REPORTS.invoice.heading.preview' | sxyTranslate }}</td>
        </tr>
        <tr>
          <td sxy-text="SALAXY.NG1.InvoicePreviewComponent.status" ps=":"></td>
          <td>{{ "InvoiceStatus." + $ctrl.invoice.header.status | sxyEnum }}</td>
        </tr>
      </table>
    </div>
  </div>
  <div ng-class="{'report-table-html': $ctrl.applySiteStyles}"></div>
    <div ng-bind-html="$ctrl.html" class="report-binder table-responsive"></div>
  </div>
</div>
`), s.put("salaxy-components/invoices/InvoicesCreate.html", `<div class="salaxy-component salaxy-invoices-create">
  <div ng-if="!$ctrl.currentType" class="alert alert-error">Error: {{ $ctrl.current ? "Invalid object" : "No object" }} bound in InvoicesCreateController</div>
  <div ng-if="$ctrl.currentType">
    <div ng-switch="$ctrl.uiStatus">
      <div ng-switch-when="invalid">
        <salaxy-validation-summary api-validation="$ctrl.current.result.validation">
          <div class="alert alert-danger" sxy-text="SALAXY.NG1.InvoicesCreateComponent.uiStatusInvalid"></div>
        </salaxy-validation-summary>
      </div>
      <div ng-switch-when="loading">
        <salaxy-spinner heading="SALAXY.NG1.InvoicesCreateComponent.uiStatusLoading"></salaxy-spinner>
      </div>
      <div ng-switch-when="created" ng-switch="$ctrl.paymentStatus">
        <p class="lead" ng-switch-when="inProgress" sxy-html="SALAXY.NG1.InvoicesCreateComponent.uiStatusCreated.inProgress.html"></p>
        <div class="alert alert-success" ng-switch-when="paid" sxy-text="SALAXY.NG1.InvoicesCreateComponent.uiStatusCreated.paid" ps="."></div>
        <div class="alert alert-danger" ng-switch-when="exceptions" sxy-text="SALAXY.NG1.InvoicesCreateComponent.uiStatusCreated.exceptions"></div>
        <div class="alert alert-danger" ng-switch-when="canceled" sxy-text="SALAXY.NG1.InvoicesCreateComponent.uiStatusCreated.canceled"></div>
        <ng-include src="'salaxy-components/invoices/InvoicesCreate_Table.html'"></ng-include>
      </div>
      <div ng-switch-when="supportedChannel">
        <div sxy-html="{{$ctrl.intro}}"></div>
        <ng-include src="'salaxy-components/invoices/InvoicesCreate_Table.html'"></ng-include>
      </div>
      <div ng-switch-when="undefined">
        <div class="alert alert-error" sxy-text="SALAXY.NG1.InvoicesCreateComponent.uiStatusDefault"></div>
      </div>
      <div ng-switch-when="userCanceled">
        <div class="alert alert-error" sxy-text="SALAXY.NG1.InvoicesCreateComponent.uiStatusUserCanceled"></div>
      </div>
      <div ng-switch-default>
        <div class="alert alert-error" sxy-text="SALAXY.NG1.InvoicesCreateComponent.uiStatusDefault"></div>
      </div>
    </div>
  </div>
</div>`), s.put("salaxy-components/invoices/InvoicesCreate_Table.html", `<table class="table">
  <thead>
    <tr>
      <th colspan="2" sxy-text="SALAXY.NG1.InvoicesCreateTableComponent.receiverInvoiceType"></th>
      <th sxy-text="SALAXY.NG1.InvoicesCreateTableComponent.comingToPay"></th>
      <th class="right" sxy-html="SALAXY.NG1.InvoicesCreateTableComponent.invoiceDate.html"></th>
      <th class="right" sxy-text="SALAXY.NG1.InvoicesCreateTableComponent.invoiceSum"></th>
    </tr>
  </thead>
  <tbody>
    <tr ng-repeat="row in $ctrl.invoices" ng-class="{ 'success': $ctrl.getDueDateType(row) == 'default' || $ctrl.getDueDateType(row) == 'paid' }">
      <td class="td-avatar middle">
        <salaxy-avatar class="salaxy-calc-row-type-avatar" avatar="row.invoice.otherPartyInfo.avatar"></salaxy-avatar>
      </td>
      <td class="middle">
        {{ row.invoice.otherPartyInfo.avatar.sortableName }}<br>
        <small class="hidden-xxs">{{("SALAXY.ENUM.InvoiceType." + row.invoice.entityType + ".label") | sxyTranslate}}</small>
      </td class="middle">
      <td class="middle">
        <div ng-switch="$ctrl.getDueDateType(row)">
          <span ng-switch-when="preview" class="disabled">{{$ctrl.getPreviewText(row)}}</span>
          <span ng-switch-when="zero" class="disabled" sxy-text="SALAXY.NG1.InvoicesCreateTableComponent.dueDateTypeZero" ps="."></span>
          <span ng-switch-when="estimation">{{$ctrl.getEstimationText(row)}}</span>
          <span ng-switch-when="forecast">{{ row.invoice.otherPartyInfo.avatar.sortableName }} {{'SALAXY.NG1.InvoicesCreateTableComponent.sendsInvoice' | sxyTranslate}}</span>
          <strong ng-switch-when="paid" sxy-text="SALAXY.NG1.InvoicesCreateTableComponent.dueDateTypePaid"></strong>
          <strong ng-switch-when="default" sxy-text="SALAXY.NG1.InvoicesCreateTableComponent.dueDateTypeDefault"></strong>
          <span ng-switch-when="unknown"></span>
        </div>
        <div ng-if="row.invoice.businessObjects.length > 1">
          {{'SALAXY.NG1.InvoicesCreateTableComponent.totalSalaries' | sxyTranslate}} {{ row.invoice.businessObjects.length }}
        </div>
      </td>
      <td class="middle right">
        <div>{{ row.invoice.startAt | sxyDate }}</div>
        <div ng-switch="$ctrl.getDueDateType(row)">
          <span ng-switch-when="estimation">{{ "SALAXY.ENUM.CalendarMonth.month" + (row.invoice.endAt | date : 'M') + ".label" | sxyTranslate }}</span>
          <span ng-switch-when="zero">-</span>
          <span ng-switch-when="preview">{{ row.invoice.endAt | sxyDate }}</span>
          <span ng-switch-when="forecast">{{ row.invoice.endAt | sxyDate }}</span>
          <span ng-switch-when="paid">{{ row.invoice.endAt | sxyDate }}</span>
          <span ng-switch-when="default">{{ row.invoice.endAt | sxyDate }}</span>
          <span ng-switch-when="unknown">{{ row.invoice.endAt | sxyDate }}</span>
        </div>
      </td>
      <td class="middle right">
        <strong>{{ row.invoice.payment | currency }}</strong>
      </td>
    </tr>
  </tbody>
</table>`), s.put("salaxy-components/invoices/InvoiceTools.html", `<div class="salaxy-component salaxy-invoice-tools">

  <div class="btn-toolbar" role="toolbar" aria-label="Invoice options">
    <div class="btn-group">
      <salaxy-input-enum type="dropdown" name="fileType" label-type="plain" ng-model="$ctrl.fileTypeId" options="$ctrl.fileTypeOptions" remember="invoice"></salaxy-input-enum>

    </div>
    <div class="btn-group">
      <button ng-disabled="$ctrl.reader.disabled()" id="reportExport" type="button" class="btn btn-default" ng-click="$ctrl.export()">
        {{ $ctrl.reader.exportLabel || ('SALAXY.NG1.AccountingReportToolsComponent.createExport' | sxyTranslate) }}
      </button>
    </div>

    <div ng-if="'test' | sxyIsInRole" class="btn-group">
      <salaxy-input-enum type="dropdown" name="channel" label-type="plain" ng-model="channel" enum="PaymentChannel" ></salaxy-input-enum>
      <button ng-disabled="!channel || channel=='undefined'" type="button" class="btn btn-default" ng-click="$ctrl.createSingleInvoice(channel,'verification')">Luo avauslasku</button>
      <button ng-disabled="!channel || channel=='undefined'" type="button" class="btn btn-default" ng-click="$ctrl.createSingleInvoice(channel, 'tax')">Luo verolasku kuluvalle kuulle</button>
    </div>

  </div>
</div>`), s.put("salaxy-components/modals/account/AccountAvatarEdit.html", `
<div class="modal-header">
  <h2 class="modal-title" sxy-text="SALAXY.NG1.AccountInfoComponent.changeAvatar"></h2>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
</div>
<div class="modal-body" id="modal-body">
  <form name="avatarForm" class="form-horizontal" ng-if="$ctrl.current" >
    <div class="row mb-2">
      <div class="col-12 col-sm-4">
        <label for="avatarPreview" class="col-form-label" sxy-text="SALAXY.NG1.AccountAvatarEditPersonComponent.avatarLabel"></label>
      </div>
      <div class="col-12 col-sm-8">
        <div class="worker-avatar-col">
          <salaxy-avatar class="avatar-xxl" avatar="$ctrl.current.avatar"></salaxy-avatar>
        </div>
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-12 col-sm-4">
        <label for="avatarPictureType" class="col-form-label" sxy-text="SALAXY.NG1.AccountAvatarEditPersonComponent.avatarTypeLabel"></label>
      </div>
      <div class="col-12 col-sm-8">
        <select class="form-select" id="avatarPictureType" ng-model="$ctrl.current.avatar.pictureType" ng-change="$ctrl.logic.typeForAvatarChanged($ctrl.current)">
          <option value="" disabled sxy-text="SALAXY.NG1.AccountAvatarEditPersonComponent.optionChoose"></option>
          <option value="icon" sxy-text="SALAXY.NG1.AccountAvatarEditPersonComponent.optionIcon"></option>
          <option value="uploaded" sxy-text="SALAXY.NG1.AccountAvatarEditPersonComponent.optionUploaded"></option>
          <option hidden value="gravatar" sxy-text="SALAXY.NG1.AccountAvatarEditPersonComponent.optionGravatar"></option>
        </select>
      </div>
    </div>
    <div ng-if="$ctrl.current.avatar.pictureType == 'gravatar'" class="row">
      <div class="input-info col-sm-8 offset-sm-4">
        <div class="input-info-icon"><i class="bi bi-info-circle-fill text-default"></i></div>
        <p class="small input-info-text with-icon" sxy-html="SALAXY.NG1.AccountAvatarEditPersonComponent.gravatarInfo.html"></p>
      </div>
    </div>
    <div ng-if="$ctrl.current.avatar.pictureType == 'icon'">
      <salaxy-input name="avatarInitials" label="SALAXY.NG1.AccountAvatarEditPersonComponent.initialsLabel" ng-model="$ctrl.current.avatar.initials" max-length="2"></salaxy-input>
      <div class="row">
        <div class="col-12 col-sm-4">
          <label for="avatarPictureColor" class="col-form-label"  sxy-text="SALAXY.NG1.AccountAvatarEditPersonComponent.colorLabel"></label>
        </div>
        <div class="col-12 col-sm-8">
          <input class="form-control" type="color" id="avatarPictureColor" ng-model="$ctrl.current.avatar.color" />
        </div>
      </div>
    </div>
    <div class="row" ng-if="$ctrl.current.avatar.pictureType == 'uploaded'">
      <div class="col-12 col-sm-4">
        <label for="avatarImageUpload" class="col-form-label" sxy-text="SALAXY.NG1.AccountAvatarEditPersonComponent.uploadImageLabel"></label>
      </div>
      <div class="col-12 col-sm-8">
        <div name="avatarImageUpload" ng-model="avatarImage" ngf-drop="$ctrl.logic.uploadAvatarImage($file, $ctrl.current)" ngf-select="$ctrl.logic.uploadAvatarImage($file, $ctrl.current)" class="salaxy-drop-box" ngf-drag-over-class="'salaxy-drag-over'" ngf-multiple="false" ngf-min-size="5KB" ngf-max-size="10MB"
          ngf-pattern="'image/*'" ngf-model-invalid="invalidFile" ng-class="invalidFile.$error != null ? 'error' : ''">
          <span sxy-html="SALAXY.NG1.AccountAvatarEditPersonComponent.uploadImage.html"></span>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
  <button type="button" class="btn btn-primary" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.save"></button>
</div>`), s.put("salaxy-components/modals/account/AccountContactEdit.html", `
<div class="modal-header">
  <h2 class="modal-title" sxy-text="SALAXY.NG1.AccountInfoComponent.editContactInfo"></h2>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

</div>
<div class="modal-body" id="modal-body">
  <form name="contactForm" class="form-horizontal" ng-if="$ctrl.current">
    <div class="row">
      <div class="col-12">
        <salaxy-input name="email" label="SALAXY.MODEL.PersonAccount.contact.email.title" sxy-email ng-model="$ctrl.current.contact.email" ng-change="$ctrl.logic.emailForAvatarChanged($ctrl.current)">
        </salaxy-input>
        <salaxy-input name="telephone" label="SALAXY.MODEL.PersonAccount.contact.telephone.title" sxy-mobile-phone ng-model="$ctrl.current.contact.telephone"></salaxy-input>
        <salaxy-input name="street" label="SALAXY.MODEL.PersonAccount.contact.street.title" ng-model="$ctrl.current.contact.street" ng-required="('household' | sxyIsInRole) || ('company' | sxyIsInRole)"></salaxy-input>
        <salaxy-input name="postalCode" label="SALAXY.MODEL.PersonAccount.contact.postalCode.title" sxy-postal-code-fi ng-model="$ctrl.current.contact.postalCode" ng-required="('household' | sxyIsInRole) || ('company' | sxyIsInRole)"></salaxy-input>
        <salaxy-input name="city" label="SALAXY.MODEL.PersonAccount.contact.city.title" ng-model="$ctrl.current.contact.city" ng-required="('household' | sxyIsInRole) || ('company' | sxyIsInRole)"></salaxy-input>
        <salaxy-input-enum type="select" label="SALAXY.MODEL.PersonAccount.contact.countryCode.title" ng-model="$ctrl.current.contact.countryCode" name="country" read-only="true" enum="Country"></salaxy-input-enum>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
  <button type="button" class="btn btn-primary" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.save"></button>
</div>`), s.put("salaxy-components/modals/account/Authorization.html", `<div class="modal-header">
  <div>
    <h2 class="modal-title" id="salaxyProductDialogLabel">{{ $ctrl.currentPartnerSite.title | sxyTranslate }}</h2>
    <h4 class="subtitle">{{ $ctrl.currentPartnerSite.status | sxyTranslate}}</h4>
  </div>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

</div>
<div class="modal-body">
  <div class="form-horizontal">
    <div class="salaxy-product-info-headers">
      <div class="row">
        <div class="col-12 col-sm-4">
          <i class="salaxy-avatar" style="font-size: 140px;">
            <img ng-src="{{$ctrl.currentPartnerSite.img}}" />
          </i>
        </div>
        <div class="col-12 col-sm-8">
          <div class="salaxy-product-description">
            <p>{{ 'SALAXY.NG1.AuthInfoHeadersComponent.' + $ctrl.currentPartnerSite.id + '.description' | sxyTranslate }}</p>
            <a class="btn btn-primary" target="_blank" href="{{'SALAXY.NG1.AuthInfoHeadersComponent.' + $ctrl.currentPartnerSite.id + '.link' | sxyTranslate}}">
              {{ 'SALAXY.NG1.AuthInfoHeadersComponent.' + $ctrl.currentPartnerSite.id + '.cta' | sxyTranslate }} »</a>
          </div>
        </div>
      </div>
    </div>
    <br />
    <div sxy-if-role="auth">
      <div ng-if="$ctrl.currentPartnerSite.id == 'holvi'" sxy-html="SALAXY.NG1.AuthorizationDialogsComponent.holvi.html"></div>
      <div ng-if="$ctrl.currentPartnerSite.id == 'isolta'" sxy-html="SALAXY.NG1.AuthorizationDialogsComponent.isolta.html"></div>
      <div ng-if="$ctrl.currentPartnerSite.id == 'accountor'" sxy-html="SALAXY.NG1.AuthorizationDialogsComponent.accountor.html"></div>
      <div ng-if="$ctrl.currentPartnerSite.id == 'finago'" sxy-html="SALAXY.NG1.AuthorizationDialogsComponent.finago.html"></div>
      <div ng-if="$ctrl.currentPartnerSite.id == 'briox'" sxy-html="SALAXY.NG1.AuthorizationDialogsComponent.briox.html"></div>
    </div>
    <div class="row">
      <div class="col-12 mb-2">
        <div class="d-flex justify-content-end">
          <salaxy-input-boolean class="authorization-switch" sxy-if-role="auth" ng-change="$ctrl.switchAuthorization()" name="{{$ctrl.currentPartnerSite.id}}" id="{{$ctrl.currentPartnerSite.id}}" type="switch" ng-model="$ctrl.currentPartnerSite.enabled" label-type="no-label" label-true="on" label-false="off"></salaxy-input-boolean>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer text-end">
  <button type="button" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
</div>`), s.put("salaxy-components/modals/account/AuthorizedAccountAdd.html", `<div class="modal-header">
  <h2 class="modal-title" sxy-text="SALAXY.NG1.AuthoringAccountComponent.authorize"></h2>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

</div>
<div class="modal-body" id="modal-body">
  <form name="authorizedAccountAddDialogForm">
    <div class="form-horizontal">
      <legend sxy-text="SALAXY.NG1.AuthoringAccountComponent.authorizeTitle"></legend>
      <p sxy-text="SALAXY.NG1.AuthoringAccountComponent.authorizeDescription"></p>
      <salaxy-input name="accountId" label="SALAXY.NG1.AuthoringAccountComponent.palkkausAccount" ng-model="$ctrl.current.id" require="true"></salaxy-input>
      <salaxy-input name="scope" label="SALAXY.NG1.AuthoringAccountComponent.scope" placeholder="SALAXY.NG1.AuthoringAccountComponent.defaultScope" ng-model="$ctrl.current.scope"></salaxy-input>
      <salaxy-input  ng-if="('admin' | sxyIsInRole)" name="partnerKey" label="Partnerin antama ID"  ng-model="$ctrl.current.partnerKey"></salaxy-input>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
  <button type="button" class="btn btn-primary" ng-disabled="!authorizedAccountAddDialogForm.$valid" ng-click="$ctrl.saveCurrent($close)" sxy-text="SALAXY.NG1.AuthoringAccountComponent.authorize"></button>
</div>`), s.put("salaxy-components/modals/account/CertificateAdd.html", `<div class="modal-header">
  <h2 class="modal-title" sxy-text="SALAXY.NG1.CertificateAddComponent.title"></h2>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
</div>
<div class="modal-body" id="modal-body">
  <div sxy-html="SALAXY.NG1.CertificateAddComponent.html"></div>
  <form name="certificateAddDialogForm">
    <div ng-if="!$ctrl.result.thumbprint" class="row">
      <div class="col-12">
        <salaxy-input name="title" label="SALAXY.NG1.CertificatesComponent.name" ng-model="$ctrl.current.title" require="true"></salaxy-input>
        <salaxy-input-enum name="certFormat" ng-model="$ctrl.certFormat" require="true" label="Sertifikaatin tyyppi"
        options="$ctrl.certFormats"></salaxy-input-enum>
        <div class="form-group row" ng-if="$ctrl.certFormat == 'pfx'">
          <label for="salasana" class="col-sm-4 col-form-label" style="text-align:left">
            <span sxy-text="SALAXY.NG1.CertificateAddComponent.password" ps="*"></span>
          </label>
          <div class="col-sm-8">
            <input type="password" class="form-control" id="password" name="password" placeholder="{{'SALAXY.NG1.CertificateAddComponent.password' | sxyTranslate}}" ng-model="$ctrl.current.password" ng-required="true" autocomplete="off" />
          </div>
        </div>
      </div>
    </div>
  </form>
  <div ng-if="$ctrl.result.thumbprint">
    <strong sxy-text="SALAXY.NG1.CertificateAddComponent.createdSertificate"></strong><br />
    <a ng-click="$ctrl.downloadCertFile()">{{ "SALAXY.NG1.CertificateAddComponent.downloadBase64" |sxyTranslate }} (.{{ $ctrl.certFormat == 'pem' ? 'zip' : $ctrl.certFormat }})</a><br />
    <b></b>{{ "SALAXY.NG1.CertificateAddComponent.base64" |sxyTranslate }} ({{ $ctrl.certFormat }})<br />
    <textarea readonly rows="15" id="certificate-bytes" style="width:100%;">{{$ctrl.result.text }}</textarea>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
  <button ng-if="$ctrl.result.thumbprint" type="button" class="btn btn-info" onclick='document.getElementById("certificate-bytes").select(); document.execCommand("copy");'
    sxy-text="SALAXY.NG1.CertificateAddComponent.copyBase64"></button>
  <button ng-if="!$ctrl.result.thumbprint" type="button" class="btn btn-primary" ng-disabled="!certificateAddDialogForm.$valid" ng-click="$ctrl.createCert()"
    sxy-text="SALAXY.NG1.CertificateAddComponent.createSertificate"></button>
</div>`), s.put("salaxy-components/modals/account/EInvoiceAddressList.html", `<div class="modal-worker-list">
  <div class="modal-header">
    <h2 class="modal-title">{{$ctrl.logic.title}}</h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <div class="table-responsive" style="max-height: calc(100vh - 300px)">
      <table class="table table-striped">
        <thead>
          <tr>
            <th sxy-text="SALAXY.NG1.EInvoiceAddressListComponent.name"></th>
            <th sxy-text="SALAXY.NG1.EInvoiceAddressListComponent.receiver"></th>
            <th sxy-text="SALAXY.NG1.EInvoiceAddressListComponent.intermediator"></th>
            <th class="right">
              <form name="searchForm">
                <salaxy-form-group name="search" label-type="plain">
                  <div class="input-group">
                    <input class="form-control" type="text" autocomplete="off" id="searchAddress" name="searchAddress" ng-model="$ctrl.logic.officialId" sxy-company-id-fi>
                    <span class="input-group-btn">
                      <button type="submit" ng-disabled="!searchForm.$valid" class="btn btn-default" ng-click="$ctrl.logic.search()">
                        <span ng-show="$ctrl.logic.isLoading">
                          <i class="bi bi-arrow-repeat bi-spin"></i>
                        </span>
                        <span ng-show="!$ctrl.logic.isLoading">
                          <i class="bi bi-search"></i>
                        </span>
                      </button>
                    </span>
                  </div>
              </form>
              </salaxy-form-group>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="row in $ctrl.logic.addresses">
            <td>
              <span>{{row.receiverName}}</span><br>
              <small>{{row.receiverOfficialId}}</small>
            </td>
            <td>
              <span>{{row.receiver}}</span><br>
            </td>
            <td>
              <span>{{row.intermediatorName}}</span><br>
              <small>{{row.intermediator}}</small>
            </td>
            <td class="right middle">
              <button class="btn btn-sm" type="button" ng-class="$ctrl.logic.isSelected($ctrl.current, row) ? 'btn-success' : 'btn-default'" ng-click="$ctrl.logic.setCurrent($ctrl.current, row)">
                {{ $ctrl.logic.isSelected($ctrl.current, row) ? ('SALAXY.UI_Terms.chosen' | sxyTranslate) : ('SALAXY.UI_Terms.select' | sxyTranslate) }}
              </button>
            </td>
          </tr>
          <tr ng-if="$ctrl.logic.addresses.length == 0">
            <td colspan="4" sxy-text="SALAXY.NG1.EInvoiceAddressListComponent.receiverNotFound"></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="modal-footer text-end">
    <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
    <button type="button" class="btn btn-danger" ng-click="$close('reset')" sxy-text="SALAXY.NG1.EInvoiceAddressListComponent.dontUseAnyAddress"></button>
    <button type="button" ng-disabled="!$ctrl.logic.isAnySelected($ctrl.current)" class="btn btn-primary" ng-click="$close('ok')" sxy-text="SALAXY.NG1.EInvoiceAddressListComponent.useSelectedAddress"></button>
  </div>
</div>`), s.put("salaxy-components/modals/account/Insurance.html", `<div class="localtapiola-modal-wrapper">
  <!-- Import LocalTapiola fonts -->
  <link rel="stylesheet" href="https://cdn.duetds.com/api/fonts/1.3.14/lib/localtapiola.css" integrity="sha384-5JYmtSD7nykpUvSmTW1CHMoBDkBZUpUmG0vuh+NUVtZag3F75Kr7+/JU3J7JV6Wq"
    crossorigin="anonymous" />
  <div class="localtapiola-modal">
    <div class="modal-header">
      <div class="logo-wrapper">
        <img src="https://cdn.salaxy.com/ng1/localtapiola-modal/localtapiola-white-logo.png" class="img-responsive logo-img" alt="LähiTapiola" />
      </div>
      <button class="btn-close ms-auto" ng-click="$close('cancel')" aria-label="Close">{{'SALAXY.UI_Terms.close' | sxyTranslate}}</button>
    </div>
    <div class="modal-body salaxy-wizard">
      <ng-include src="$ctrl.currentStep.view || 'salaxy-components/modals/localTapiola/Start.html'"></ng-include>
    </div>
    <div class="modal-footer" ng-if="$ctrl.currentStep.buttonsView">
      <div class="footer-content w-100">
        <ng-include src="$ctrl.currentStep.buttonsView || 'salaxy-components/modals/localTapiola/buttons-default.html'" class="d-flex justify-content-between"></ng-include>
      </div>
    </div>
  </div>
</div>
<style>
  .datepicker .datepicker-cell.focused {
    background-color: #0077b3;
    box-shadow: none;
    color: #fff;
  }
  
  .datepicker .today-button,
  .datepicker .today-button:hover,
  .datepicker .today-button:focus,
  .datepicker .clear-button,
  .datepicker .clear-button:hover,
  .datepicker .clear-button:focus {
    color: #009fd8 !important;
    border-color: transparent !important;
    background-color: transparent !important;
    font-family: "localtapiola-sans" !important;
    font-size: 14px !important;
    outline: none !important;
    font-weight: 600 !important;
  }
</style>`), s.put("salaxy-components/modals/account/PrimaryPartner.html", `<div class="modal-header">
  <div>
    <h2 class="modal-title" id="salaxyProductDialogLabel">{{ $ctrl.current.name }}</h2>
    <h4 class="subtitle">{{ $ctrl.current.description }}</h4>
  </div>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

</div>
<div class="modal-body">
  <div class="form-horizontal">
    <div class="salaxy-component salaxy-product-info-headers">
      <div class="row">
        <div class="col-12 col-sm-4">
          <i class="salaxy-avatar" style="font-size: 140px;">
            <img ng-src="{{ $ctrl.current.branding.logo }}" />
          </i>
        </div>
        <div class="col-12 col-sm-8">
          <div class="salaxy-product-description">
            <p>
              {{ $ctrl.current.branding.text }}
            </p>
            <a ng-if="$ctrl.current.branding.url" class="btn btn-primary" target="_blank" ng-href="{{$ctrl.current.branding.url}}">{{'SALAXY.NG1.PrimaryPartnerComponent.moreInfo' | sxyTranslate}} »</a>
          </div>
        </div>
      </div>
      <div class="row" ng-if="!$ctrl.current.isAuthorized">
        <div class="col-12 input-info">
          <div class="input-info-icon"><i class="bi bi-info-circle-fill text-default"></i></div>
          <p class="small input-info-text with-icon" sxy-html="SALAXY.NG1.PrimaryPartnerComponent.notAuthorized.html"></p>
        </div>
      </div>
      <div class="row" ng-if="!$ctrl.current.isAuthorized">
        <div class="col-12 input-info">
          <div class="input-info-icon"><i class="bi bi-info-circle-fill text-default"></i></div>
          <p class="small input-info-text with-icon" sxy-text="SALAXY.NG1.PrimaryPartnerComponent.notAuthorized.text"></p>
        </div>
      </div>

      <div class="row" ng-if="$ctrl.current.isAuthorized">
        <div class="col-12 input-info">
          <div class="input-info-icon"><i class="bi bi-info-circle-fill text-default"></i></div>
          <p class="small input-info-text with-icon" sxy-html="SALAXY.NG1.PrimaryPartnerComponent.authorized.html"></p>
        </div>
      </div>
      <div class="row" ng-if="$ctrl.current.isAuthorized">
        <div class="col-12 input-info">
          <div class="input-info-icon"><i class="bi bi-info-circle-fill text-default"></i></div>
          <p class="small input-info-text with-icon" sxy-text="SALAXY.NG1.PrimaryPartnerComponent.authorized.text"></p>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer text-end">
  <button type="button" class="btn btn-danger" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
  <button ng-if="!$ctrl.current.isAuthorized" type="button" class="btn btn-primary" ng-click="$close('ok')" sxy-text="SALAXY.NG1.PrimaryPartnerComponent.setPrimaryPartner"></button>
  <button ng-if="$ctrl.current.isAuthorized" type="button" class="btn btn-danger" ng-click="$close('ok')" sxy-text="SALAXY.NG1.PrimaryPartnerComponent.removePrimaryPartnerCredential"></button>
</div>`), s.put("salaxy-components/modals/account/VismaModal.html", `<div id="salaxyDialog" class="salaxy-component salaxy-dialog modal-dialog visma-modal {{size ? 'modal-' + size : ''}}" aria-labelledby="salaxyDialogLabel" role="dialog">
  <link href="https://fonts.googleapis.com/css?family=Exo:400,700" rel="stylesheet">
  <div class="modal-content" role="document" uib-modal-transclude></div>
</div>`), s.put("salaxy-components/modals/accounting-target/accounting-targets.html", `<div ng-class="$ctrl.getCssClass()">
  <div class="visible-xxs">
    <div class="table-filter-container-mobile">
      <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search" label-type="plain">
      </salaxy-input>
    </div>
  </div>
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th colspan="2">
            <div sxy-orderby="shortText" sxy-text="SALAXY.NG1.AccountingTargetsComponent.exportDefinition"></div>
            <div sxy-text="SALAXY.NG1.AccountingTargetsComponent.targetChannel"></div>
          </th>
          <th sxy-orderby="owner" colspan="2">
            <div sxy-text="SALAXY.NG1.AccountingTargetsComponent.owner"></div>
            <div sxy-text="SALAXY.NG1.AccountingTargetsComponent.status"></div>
          </th>

          <th class="right hidden-xxs" colspan="2">
            <div class="table-filter-container">
              <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" class="salaxy-odata-table-search" placeholder="SALAXY.UI_Terms.textSearch" label-type="plain"></salaxy-input>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="td-avatar middle">
            <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
          </td>
          <td class="middle">
            <div title="{{ row.shortText }} ({{ row.id }})">
              <strong>{{ row.otherPartyInfo.avatar.displayName }}</strong>
            </div>
          </td>
          <td class="td-avatar middle">
            <salaxy-avatar avatar="row.ownerInfo.avatar"></salaxy-avatar>
          </td>
          <td class="middle">
            <div>{{ row.ownerInfo.avatar.displayName }}</div>
            <div>{{ "AccountingTargetStatus." + row.status | sxyEnum }}</div>
          </td>
          <td class="right middle">
            <button class="btn btn-sm" type="button" ng-class="$ctrl.isSelected(row) ? 'btn-danger' : 'btn-info'" ng-click="$ctrl.setSelected(row, 'toggle')">
              {{ $ctrl.isSelected(row) ? ('SALAXY.UI_Terms.unselect' | sxyTranslate) : ('SALAXY.UI_Terms.select' | sxyTranslate) }}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`), s.put("salaxy-components/modals/batch/default.html", `\uFEFF<div class="salaxy-batch-default">
  <button ng-if="!$ctrl.autoStart" type="button" class="btn btn-primary" ng-disabled="$ctrl.isProcessStarted" ng-click="$ctrl.startProcess()">Aloita prosessi</button>
</div>`), s.put("salaxy-components/modals/batch/dialog.html", `<div class="modal-header">
  <h2 class="modal-title">{{ $ctrl.dialogHeader }}</h2>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

</div>
<div class="modal-body" id="modal-body">
  <div class="salaxy-batch-content" ng-include="$ctrl.batchTemplateUrl"></div>
  <hr/>
  <sxy-table ng-if="$ctrl.isReady" data="$ctrl.list" options="$ctrl.tableOptions" include="$ctrl.columns" ng-ref="$ctrl.$table"></sxy-table>
</div>
<div class="modal-footer">
  <h2 class="float-start" style="margin: 0" ng-if="$ctrl.processCounter.isProcessing || $ctrl.processCounter.isDone">
    {{ $ctrl.processCounter.isDone ? ('SALAXY.NG1.BatchProcessComponent.dialog.done' | sxyTranslate) : ('SALAXY.NG1.BatchProcessComponent.dialog.processing' | sxyTranslate) }}: {{ $ctrl.processCounter.processedCount }} / {{ $ctrl.processCounter.totalCount }}
    <span class="bg-danger" ng-if="$ctrl.processCounter.errorsCount">{{'SALAXY.NG1.BatchProcessComponent.dialog.errors' | sxyTranslate}}: {{ $ctrl.processCounter.errorsCount }}</span>
    <span class="bg-warning" ng-if="$ctrl.processCounter.canceling" sxy-text="SALAXY.NG1.BatchProcessComponent.dialog.canceling"></span>
  </h2>
  <h2 class="float-start" style="margin: 0" ng-if="!($ctrl.processCounter.isProcessing || $ctrl.processCounter.isDone)">
    {{'SALAXY.NG1.BatchProcessComponent.dialog.count' | sxyTranslate}}: {{ $ctrl.processCounter.totalCount }} ({{ $ctrl.list.length }})
  </h2>
  <button type="button" class="btn btn-danger" ng-click="$ctrl.cancelProcess()" ng-if="$ctrl.processCounter.isProcessing" sxy-text="SALAXY.NG1.BatchProcessComponent.dialog.stopProcessing"></button>
  <button type="button" class="btn btn-default" ng-click="$ctrl.close()" ng-if="!$ctrl.processCounter.isProcessing">{{'SALAXY.UI_Terms.close' | sxyTranslate}}</button>
</div>`), s.put("salaxy-components/modals/calc/Calc.html", `<div class="modal-calc-list">
  <div class="modal-header">
    <h2 class="modal-title">{{$ctrl.logic.title}}</h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

  </div>
  <div class="modal-body">
    <salaxy-calc model="$ctrl.current"></salaxy-calc>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" ng-click="$close('delete')" sxy-text="SALAXY.UI_Terms.delete"></button>
    <button type="reset" class="btn btn-default float-end" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
    <button type="submit" class="btn btn-primary float-end" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.save"></button>
  </div>
</div>`), s.put("salaxy-components/modals/calc/CalcIr.html", `<div class="modal-calc-list">
  <div class="modal-header">
    <h2 class="modal-title">{{$ctrl.logic.title}}</h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <salaxy-calc-ir-rows model="$ctrl.current"></salaxy-calc-ir-rows>
    <div>
      <button type="button" class="btn btn-danger" ng-click="$close('delete')" sxy-text="SALAXY.UI_Terms.delete"></button>
      <button type="reset" class="btn btn-default float-end" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
      <button type="submit" class="btn btn-primary float-end" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.save"></button>

    </div>
  </div>
</div>`), s.put("salaxy-components/modals/calc/CalcLeaves.html", `<div class="modal-header">
  <h2 class="modal-title" sxy-text="SALAXY.NG1.CalcWorktimeComponent.absences.calculationLegend"></h2>
  <button type="button" class="btn-close" ng-click="$close(null)" aria-label="Close"></button>
</div>
<div class="modal-body">
  <salaxy-calc-leaves ng-ref="$calcLeaves" calc="$ctrl.current.calc" worktime="$ctrl.current.worktime"></salaxy-calc-leaves>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-default float-end" ng-click="$close(null)" sxy-text="SALAXY.UI_Terms.close"></button>
  <button type="button" class="btn btn-primary float-end" ng-click="$close({absencesPeriods: $calcLeaves.getAbsencesPeriods()})" sxy-text="SALAXY.UI_Terms.save"></button>
</div>`), s.put("salaxy-components/modals/calc/CalcList.html", `<div class="modal-worker-list">
  <div class="modal-header">
    <h2 class="modal-title">{{$ctrl.logic.title | sxyTranslate}}</h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

  </div>
  <div class="modal-body">
    <div class="table-responsive" style="max-height: calc(100vh - 300px)">
      <salaxy-calc-list category="{{ $ctrl.logic.category || 'draft' }}" options="$ctrl.logic.options" mode="select" selected-items="$ctrl.current"></salaxy-calc-list>
    </div>
    <div class="text-end">
      <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="{{ $ctrl.logic.cancelButtonText || 'SALAXY.UI_Terms.cancel'}}"></button>
      <button type="submit" class="btn btn-primary" ng-click="$close('ok')" sxy-text="{{ $ctrl.logic.okButtonText || 'SALAXY.UI_Terms.save'}}"></button>
    </div>
  </div>
</div>`), s.put("salaxy-components/modals/calc/CalcReports.html", `<div class="modal-header">
  <h2 class="modal-title" sxy-text="SALAXY.NG1.CalcReportsComponent.calcReports" ></h2>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

</div>
<div class="modal-body ">
  <salaxy-calc-reports calcs="$ctrl.data.calcs" preview="$ctrl.data.preview" view="{{ $ctrl.data.view || 'page1' }}" report-type="$ctrl.data.reportType"></salaxy-calc-reports>
</div>`), s.put("salaxy-components/modals/calc/CfaPaymentOverview.html", `<div class="modal-calc-list">
  <div class="modal-header">
    <h2 class="modal-title">{{ $ctrl.logic.title }}</h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

  </div>
  <div class="modal-body">

    <style type="text/css">
      .left.carousel-control {
        background-image: none;
      }
      
      .right.carousel-control {
        background-image: none;
      }
      
      .right.carousel-control>span.glyphicon.glyphicon-chevron-right {
        color: var(--salaxy-brand-primary)
      }
      
      .left.carousel-control>span.glyphicon.glyphicon-chevron-left {
        color: var(--salaxy-brand-primary)
      }
      
      .carousel-indicators .active {
        background-color: var(--salaxy-brand-primary);
      }
      
      .carousel-indicators li {
        border-color: var(--salaxy-brand-primary);
      }
    </style>
      
    <p class="lead" sxy-text="SALAXY.NG1.CfaPaymentOverviewComponent.lead" ng-if="$ctrl.logic.isReadyForPayment"></p>
    <div class="alert alert-danger" ng-if="!$ctrl.logic.isReadyForPayment()">
      <p class="lead" sxy-html="SALAXY.NG1.PaymentDialogComponent.alert.html"></p>
    </div>
    <p class="lead" ng-if="$ctrl.logic.isReadyForPayment() && $ctrl.logic.instructions">
      {{ $ctrl.logic.instructions }}
    </p>
    <div ng-if="$ctrl.logic.type == 'calc'">
      <salaxy-calc-worker-info model="$ctrl.current"></salaxy-calc-worker-info>
      <p >
        <strong sxy-text="SALAXY.NG1.CalcDetailsWorkComponent.workEndStartDate" ps=":"></strong> {{$ctrl.current.info.workStartDate | date : 'dd.MM.yyyy'}}{{ $ctrl.current.info.workStartDate ? ' - ': ''}} {{$ctrl.current.info.workEndDate
        | date: 'dd.MM.yyyy'}}, {{$ctrl.current.framework.numberOfDays > 0 ? $ctrl.current.framework.numberOfDays : '?' }} {{'SALAXY.NG1.CfaPaymentOverviewComponent.days' | sxyTranslate}}.
      </p>
      <hr />
      <div class="table-responsive"> 
        <salaxy-calc-report apply-site-styles="true" calc="$ctrl.current" report-type="'paymentReport'" template-name="'paymentTablesV2'"></salaxy-calc-report>
      </div>
      <p sxy-html="SALAXY.NG1.PaymentDialogComponent.afterPayment.html" params="{totalPayment: ($ctrl.current.result.employerCalc.totalPayment | currency)}"></p>
      <p ng-if="$ctrl.current.result.employerCalc.householdDeduction > 0" sxy-html="SALAXY.NG1.PaymentDialogComponent.household.html" params="{householdDeduction: ($ctrl.current.result.employerCalc.householdDeduction | currency) }">
      </p>
    </div>
    <div ng-if="$ctrl.logic.type != 'calc'">
      <strong>{{'SALAXY.NG1.CfaPaymentOverviewComponent.totalPayments' | sxyTranslate}}: {{$ctrl.current.info.totalPayment | currency}}</strong><br />
      <strong>{{'SALAXY.NG1.CfaPaymentOverviewComponent.calculations' | sxyTranslate}}: {{$ctrl.current.calcs.length}}</strong><br />
      <hr />
      <div id="payroll-calcs-carousel" class="carousel carousel-dark slide" data-bs-interval="false">
        <div class="carousel-controls d-flex align-items-center justify-content-between mb-3">
          <button class="carousel-control-prev" type="button" data-bs-target="#payroll-calcs-carousel" data-bs-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          </button>
          <div class="carousel-indicators">
            <button ng-repeat="calc in $ctrl.current.calcs track by $index" index="$index" type="button" data-bs-target="#payroll-calcs-carousel" data-bs-slide-to="{{$index}}" ng-class="{'active': $index == 0}" aria-current="{{$index == 0 ? 'true' : 'false'}}" aria-label="Slide {{$index + 1}}"></button>
          </div>
          <button class="carousel-control-next" type="button" data-bs-target="#payroll-calcs-carousel" data-bs-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
          </button>
        </div>
        <div class="carousel-inner">
          <div ng-repeat="calc in $ctrl.current.calcs track by $index" index="$index" class="carousel-item" ng-class="{'active': $index == 0}">
            <strong>{{$index + 1}}/{{$ctrl.current.calcs.length}} {{calc.worker.avatar.sortableName}}</strong>
            <salaxy-calc-report calc="calc" apply-site-styles="true" report-type="'paymentReport'" template-name="'paymentTablesV2'"></salaxy-calc-report>
          </div>
        </div>
      </div>
      <p sxy-html="SALAXY.NG1.PaymentDialogComponent.afterPayment.html" params="{totalPayment: ($ctrl.current.info.totalPayment | currency)}"></p>
    </div>
    <div ng-if="$ctrl.logic.channel == 'palkkausCfaPaytrail' || $ctrl.logic.channel == 'palkkausEcfaPaytrail'">
      <p sxy-text="SALAXY.NG1.CfaPaymentOverviewComponent.palkkausCfaPaytrailInfo"></p>
      <p sxy-text="SALAXY.NG1.CfaPaymentOverviewComponent.palkkausCfaPaytrailInfoAlt"></p>
    </div>
  </div>
  <div class="modal-footer text-end">
    <button ng-if="$ctrl.logic.channel != 'palkkausCfaPaytrail' && $ctrl.logic.channel != 'palkkausEcfaPaytrail'" type="submit" class="btn btn-primary float-end" ng-disabled="!$ctrl.logic.isReadyForPayment()" ng-click="$close('ok')">
      {{ $ctrl.logic.okButtonText}}
    </button>
    <button ng-if="$ctrl.logic.channel == 'palkkausCfaPaytrail' || $ctrl.logic.channel == 'palkkausEcfaPaytrail'" type="submit" class="btn btn-primary float-end" ng-disabled="!$ctrl.logic.isReadyForPayment()" ng-click="$ctrl.logic.paymentFunc($ctrl.current);$close('ok')">
      {{ $ctrl.logic.okButtonText}}
    </button>
    <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
  </div>
</div>`), s.put("salaxy-components/modals/calc/EditorConfirm.html", `<div class="modal-editor-confirm">
  <div class="modal-header">
    <h2 class="modal-title" sxy-text="Oletko varma?"></h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

  </div>
  <div class="modal-body">
    <p sxy-text="Hyväksynnän jälkeen päivitämme tulosteet ja raportoimme muutokset tulorekisteriin."></p>
    <p>&nbsp;</p>
    <form name="snapshotForm" class="form-horizontal">
      <salaxy-input-enum label="Syykoodi" name="reasonCode" ng-model="$ctrl.current.reasonCode" options="{
        1: 'Asiakkaan korjauspyyntö',
        2: 'Virheellinen laskelma',
        3: 'Palkkaus ohjelmistovirhe',
        4: 'Uusi ilmoitus/peruminen tulorekisteriin',
        }"></salaxy-input-enum>
      <salaxy-input-enum label="Vakavuusaste" name="severityCode" type="radio" ng-model="$ctrl.current.severityCode" options="{ 1:'1', 2:'2', 3 :'3', 4 :'4', 5:'5' }">
      </salaxy-input-enum>
      <div class="row">
        <label for="" class="col-4 col-form-label">
          <span class="label-text">Kategoriat</span>
        </label>
        <div class="col-8">
          <table>
            <tr>
              <td colspan="2" class="text-end"><button type="button" class="btn btn-primary btn-xs" ng-click="$ctrl.current.categories.push('')">Uusi kategoria</button></td>
            </tr>
            <tr>
              <td colspan="2">&nbsp;</td>
            </tr>
            <tr ng-repeat="category in $ctrl.current.categories track by $index">
              <td>
                  <salaxy-form-group name="category{{$index}}" label-type="plain">
                      <div>
                          <salaxy-input-typeahead
                            label-type="no-label"
                            ng-model="$ctrl.current.categories[$index]"
                            name="worker"
                            disable-cache="true"
                            placeholder=""
                            options="$ctrl.logic.categories">
                          </salaxy-input-typeahead>
                      </div>
                  </salaxy-form-group>
              </td>
              <td>
                  <button type="button" class="btn btn-danger btn-sm" ng-click="$ctrl.current.categories.splice($index,1)" title="{{'SALAXY.UI_Terms.deleteRow' | sxyTranslate}}"><i class="bi bi-trash-fill"></i></button>
              </td>
          </tr>
          </table>
        </div>
      </div>

      <salaxy-textarea label="Kuvaus" name="description" ng-model="$ctrl.current.description"></salaxy-textarea>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
    <button type="submit" class="btn btn-primary" ng-disabled="!snapshotForm.$valid" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.ok"></button>
  </div>
</div>`), s.put("salaxy-components/modals/calc/EmailSharing.html", `<div class="modal-email-sharing">
  <div class="modal-header">
    <h2 class="modal-title" sxy-text="SALAXY.NG1.EmailSharingComponent.title"></h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <p sxy-html="SALAXY.NG1.EmailSharingComponent.body.html"></p>
    <form name="emailForm" class="form-horizontal">
      <salaxy-input label="SALAXY.NG1.EmailSharingComponent.emailTo" name="to" type="text" require="true" ng-model="$ctrl.current.to" sxy-email></salaxy-input>
      <salaxy-input label="SALAXY.NG1.EmailSharingComponent.emailCC" name="cc" type="text" ng-model="$ctrl.current.cc" sxy-email></salaxy-input>
      <salaxy-textarea label="SALAXY.NG1.EmailSharingComponent.message" name="message" ng-model="$ctrl.current.message"></salaxy-textarea>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
    <button type="submit" class="btn btn-primary" ng-disabled="!emailForm.$valid" ng-click="$close('ok')" sxy-text="SALAXY.NG1.EmailSharingComponent.sendEmail"></button>
  </div>
</div>`), s.put("salaxy-components/modals/calc/PalkkausPersonalPaymentOverview.html", `<div class="modal-header">
  <h2 class="modal-title">{{ $ctrl.editDialogParameters.logic.isInspectingPaidInvoices ? ('SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.titleInspect' | sxyTranslate) : ('SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.title' | sxyTranslate) }}</h2>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
</div>
<div class="modal-body" ng-controller="InvoicesCreateController as $invCreate">
  <div class="d-block d-md-none" ng-init="$invCreate.model=$ctrl.model">
    <h4><span sxy-text="SALAXY.NG1.WorkerWizardComponent.wizard.step"></span> {{$ctrl.currentStep.number}}/{{$ctrl.steps.length}}</h4>
  </div>
  <div class="salaxy-wizard">
    <div class="wizard-steps">
      <div class="wizard-step" ng-repeat="step in $ctrl.steps" ng-class="{'active': step.active, 'disabled': step.disabled}">
        <span class="salaxy-avatar">
          <div class="wizard-icons-wrapper">
            <i class="bi" ng-class="step.active ? 'bi-circle-fill' : 'bi-circle'"></i>
            <i class="bi bi-circle-fill"></i>
          </div>
          <strong class="number">{{ step.number }}</strong>
        </span>
        <span class="step-text">{{ step.title | sxyTranslate }}</span>
      </div>
    </div>
    <div class="wizard-strikethrough"></div>
  </div>
  <div class="worker-wizard-content">
    <ng-include src="$ctrl.currentStep.view"></ng-include>
  </div>
</div>
<div class="modal-footer">
  <button ng-if="$ctrl.step < 2 && !$ctrl.editDialogParameters.logic.isInspectingPaidInvoices" ng-click="$close('cancel')" class="btn float-start btn-default" sxy-text="SALAXY.UI_Terms.close"></button>
  <button ng-if="$ctrl.editDialogParameters.logic.isInspectingPaidInvoices && $ctrl.step == 3" ng-click="$close('cancel')" class="btn btn-default" sxy-text="SALAXY.UI_Terms.close"></button>
  <button ng-if="$ctrl.step >= 2" ng-click="$ctrl.goPrevious()" ng-disabled="!$ctrl.canGoPrevious" class="btn float-start btn-default" sxy-text="SALAXY.UI_Terms.previous"></button>
  <button ng-if="$ctrl.step &lt; $ctrl.steps.length" ng-click="$ctrl.goNext()" ng-disabled="!$ctrl.canGoNext" class="btn btn-primary" sxy-text="SALAXY.UI_Terms.next"></button>
</div>
`), s.put("salaxy-components/modals/calc/PaymentOverview.html", `<div class="modal-calc-list">
  <div class="modal-header">
    <h2 class="modal-title">{{ $ctrl.$invCreate.title }}</h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

  </div>
  <div class="modal-body">
    <salaxy-invoices-create model="$ctrl.current" ng-ref="$ctrl.$invCreate"></salaxy-invoices-create>
  </div>
  <div class="modal-footer text-start">
    <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
    <button type="submit" class="btn btn-primary float-end" ng-if="$ctrl.$invCreate.getOkBtn()" ng-click="$ctrl.$invCreate.createInvoices($close)">
      {{ $ctrl.$invCreate.getOkBtn() }}
    </button>
    <div ng-if="$ctrl.logic.channel == 'palkkausPersonal'">
      <div>
        <b>Debug</b><br>
        <salaxy-json-formatter json="$ctrl.$invCreate.invoices" open="1"></salaxy-json-formatter>
      </div>
      
    </div>`), s.put("salaxy-components/modals/calc/personal-payment/Approval.html", `<div ng-controller="InvoicesCreateController as $invCreate" ng-init="$invCreate.model=$ctrl.model">
  <section>
    <h3 sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.steps.step4.title"></h3>
    <p class="lead" sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.steps.step4.text"></p>      
  </section>
  <section>
    <h3 sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.steps.step4.buttonInfoText"></h3>
    <p class="lead" sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.steps.step4.irInfo"></p>
  </section>
  <section ng-if="$ctrl.eprPaymentWarning && $invCreate.primaryCalcNetInvoicePreview && $invCreate.primaryCalcNetInvoicePreview.invoice.status !== 'paid'">
    <p class="lead">{{$ctrl.eprPaymentWarning}}</p>
  </section>
  <section ng-if="$ctrl.eprCancelWarning && $invCreate.primaryCalcNetInvoicePreview && $invCreate.primaryCalcNetInvoicePreview.invoice.status === 'paid'">
    <p class="lead">{{$ctrl.eprCancelWarning}}</p>
  </section>
 
  <button ng-click="$close('paid')" ng-if="$invCreate.primaryCalcNetInvoicePreview && ( $invCreate.primaryCalcNetInvoicePreview.invoice.status == 'unread' || $invCreate.primaryCalcNetInvoicePreview.invoice.status == 'read' ||  $invCreate.primaryCalcNetInvoicePreview.invoice.status == 'waitingConfirmation' )"
  type="button" class="btn btn-success" sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.steps.step4.acceptButton"></button>
  <button ng-click="$close('cancel')" ng-if="$invCreate.primaryCalcNetInvoicePreview && $invCreate.primaryCalcNetInvoicePreview.exists == false" type="button" class="btn btn-danger"  sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.notPaidInfo"></button>
  <button ng-click="$close('canceled')" ng-if="$invCreate.primaryCalcNetInvoicePreview &&  $invCreate.primaryCalcNetInvoicePreview.exists == true && ( $invCreate.primaryCalcNetInvoicePreview.invoice.status == 'unread' || $invCreate.primaryCalcNetInvoicePreview.invoice.status == 'read' ||  $invCreate.primaryCalcNetInvoicePreview.invoice.status == 'waitingConfirmation' )"
    type="button" class="btn btn-danger"  sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.steps.step4.declineButton"></button>
  <button ng-click="$close('canceled')" ng-if="$invCreate.primaryCalcNetInvoicePreview && $invCreate.primaryCalcNetInvoicePreview.invoice.status == 'paid'" type="button" class="btn btn-danger"  sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.cancelInfo"></button>
</div>`), s.put("salaxy-components/modals/calc/personal-payment/SideCosts.html", `<section>
  <h3 sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.steps.step3.title"></h3>
  <p class="lead" sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.steps.step3.text"></p>   
  <ul>
    <li sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.steps.step3.listItem1"></li>
    <li sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.steps.step3.listItem2"></li>
    <li sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.steps.step3.listItem3"></li>
  </ul>
  <p class="lead" sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.steps.step3.textAlt"></p>
</section>`), s.put("salaxy-components/modals/calc/personal-payment/Tax.html", `<div ng-controller="InvoicesCreateController as $invCreate" ng-init="$invCreate.model=$ctrl.model">
  <div class="d-print-none" ng-if="$invCreate.primaryCalcNetInvoicePreview.invoice.status == 'paid'">
    <p class="lead">
      <button type="button" class="btn btn-primary float-end" onclick="window.print()" sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.printInvoices"></button> {{'SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.paid.paidInspectTax' |
      sxyTranslate}}
    </p>
    <div ng-if="$invCreate.primaryCalcTaxInvoicePreview" class="credit-transfer-container">
      <salaxy-credit-transfer invoice-preview="$invCreate.primaryCalcTaxInvoicePreview" mode="official">
        <message>
          <p sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.mobileBanking.tax"></p>
          <p style="text-transform: none;" sxy-html="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.mobileBanking.taxInfo.html"></p>
        </message>
      </salaxy-credit-transfer>
    </div>
  </div>
  <div class="d-print-none" ng-if="$invCreate.primaryCalcNetInvoicePreview && $invCreate.primaryCalcNetInvoicePreview.invoice.status != 'paid'">
    <section>
      <h3 sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.steps.step2.title"></h3>
      <button type="button" class="btn btn-primary float-end" onclick="window.print()" sxy-text="Tulosta"></button>
      <p class="lead" sxy-html="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.steps.step2.text.html"></p>
    </section>
    <table class="table">
      <thead>
        <tr>
          <th></th>
          <th sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.preview.receiver"></th>
          <th sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.preview.iban"></th>
          <th sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.preview.reference"></th>
          <th class="right" sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.preview.dueDate"></th>
          <th class="right" sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.preview.sum"></th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th rowspan="2" style="font-size: 2em;"></th>
          <th>{{ $invCreate.primaryCalcTaxInvoicePreview.invoice.otherPartyInfo.avatar.displayName }}</th>
          <th>{{ $invCreate.primaryCalcTaxInvoicePreview.invoice.otherPartyInfo.ibanNumber }}</th>
          <th sxy-if-role="test">{{ $invCreate.primaryCalcTaxInvoicePreview.invoice.reference || "RF02 TEST 1234" }}</th>
          <th sxy-if-role="!test">{{ $invCreate.primaryCalcTaxInvoicePreview.invoice.reference || ('SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.preview.checkReference' | sxyTranslate) }}</th>
          <th class="right">{{ $invCreate.primaryCalcTaxInvoicePreview.invoice.data.dueDate | sxyDate }}</th>
          <th class="right">{{ $invCreate.primaryCalcTaxInvoicePreview.invoice.payment | currency }}</th>
        </tr>
        <tr class="no-border">
          <td colspan="5">
            <salaxy-credit-transfer invoice-preview="$invCreate.primaryCalcTaxInvoicePreview" mode="barcode-copy">
          </td>
        </tr>
      </tbody>
    </table>
    <div ng-if="$invCreate.primaryCalcTaxInvoicePreview" class="credit-transfer-container">

      <salaxy-credit-transfer invoice-preview="$invCreate.primaryCalcTaxInvoicePreview" mode="official">
        <message>
          <p sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.mobileBanking.tax"></p>
          <p style="text-transform: none;" sxy-html="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.mobileBanking.taxInfo.html"></p>
        </message>
      </salaxy-credit-transfer>
    </div>
  </div>
  <div class="d-none d-print-block">
    <h1 ng-if="!$ctrl.editDialogParameters.logic.isInspectingPaidInvoices" sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.mobileBanking.heading"></h1>
    <div ng-if="$invCreate.primaryCalcTaxInvoicePreview" class="credit-transfer-container">
      <salaxy-credit-transfer invoice-preview="$invCreate.primaryCalcTaxInvoicePreview" mode="official">
        <message>
          <p>Ennakonpidätys</p>
          <p style="text-transform: none;" sxy-html="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.mobileBanking.taxInfo.html"></p>
        </message>
      </salaxy-credit-transfer>
    </div>
  </div>
</div>`), s.put("salaxy-components/modals/calc/personal-payment/TotalWorkerPayment.html", `<div ng-controller="InvoicesCreateController as $invCreate" ng-init="$invCreate.model=$ctrl.model">
  <div ng-if="!$invCreate.isValid">
    <p sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.invalidCalc"></p>
    <salaxy-validation-summary api-validation="$invCreate.current.result.validation"></salaxy-validation-summary>
  </div>
  <div ng-if="$invCreate.paymentStatus == 'canceled'">
    <p class="lead" sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.canceled.lead"></p>
    <p sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.canceled.salaryAlreadyPaid"></p>
    <ul>
      <li sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.canceled.salaryAlreadyPaidInfo1"></li>
      <li sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.canceled.salaryAlreadyPaidInfo2"></li>
      <li sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.canceled.salaryAlreadyPaidInfo3"></li>
      <li sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.canceled.salaryAlreadyPaidInfo4"></li>
    </ul>
  </div>
  <div class="d-print-none" ng-if="$invCreate.primaryCalcNetInvoicePreview.invoice.status == 'paid'">
    <p class="lead">
      <button type="button" class="btn btn-primary float-end" onclick="window.print()" sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.printInvoices"></button> {{'SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.paid.paidInspectNet' |
      sxyTranslate}}
    </p>
    <div ng-if="$invCreate.primaryCalcNetInvoicePreview" class="credit-transfer-container">
      <salaxy-credit-transfer invoice-preview="$invCreate.primaryCalcNetInvoicePreview" mode="official">
        <message>
          <p sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.mobileBanking.salary"></p>
          <p style="text-transform: none;" sxy-html="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.mobileBanking.salaryInfo.html"></p>
        </message>
      </salaxy-credit-transfer>
    </div>
  </div>
  <div class="d-print-none" ng-if="$invCreate.primaryCalcNetInvoicePreview && $invCreate.primaryCalcNetInvoicePreview.invoice.status != 'paid'">
    <section>
      <h3 sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.steps.step1.title"></h3>
      <button type="button" class="btn btn-primary float-end" onclick="window.print()" sxy-text="Tulosta"></button>
      <p class="lead" sxy-html="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.steps.step1.text.html"></p>
    </section>
    <table class="table">
      <thead>
        <tr>
          <th></th>
          <th sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.preview.receiver"></th>
          <th sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.preview.iban"></th>
          <th sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.preview.reference"></th>
          <th class="right" sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.preview.dueDate"></th>
          <th class="right" sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.preview.sum"></th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th rowspan="2" style="font-size: 2em;"></th>
          <th>{{ $invCreate.primaryCalcNetInvoicePreview.invoice.otherPartyInfo.avatar.displayName }}</th>
          <th>{{ $invCreate.primaryCalcNetInvoicePreview.invoice.otherPartyInfo.ibanNumber }}</th>
          <th sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.preview.salary"></th>
          <th class="right">{{ $invCreate.primaryCalcNetInvoicePreview.invoice.data.dueDate | sxyDate }}</th>
          <th class="right">{{ $invCreate.primaryCalcNetInvoicePreview.invoice.payment | currency }}</th>
        </tr>
        <tr class="no-border">
          <td colspan="5">
            <salaxy-credit-transfer invoice-preview="$invCreate.primaryCalcNetInvoicePreview" mode="barcode-copy">
          </td>
        </tr>
      </tbody>
    </table>
    <div ng-if="$invCreate.primaryCalcNetInvoicePreview" class="credit-transfer-container">
      <salaxy-credit-transfer invoice-preview="$invCreate.primaryCalcNetInvoicePreview" mode="official">
        <message>
          <p sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.mobileBanking.salary"></p>
          <p style="text-transform: none;" sxy-html="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.mobileBanking.salaryInfo.html"></p>
        </message>
      </salaxy-credit-transfer>
    </div>
  </div>
  <div class="d-print-none">
    <h1 ng-if="!$ctrl.editDialogParameters.logic.isInspectingPaidInvoices" sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.mobileBanking.heading"></h1>
    <div ng-if="$invCreate.primaryCalcNetInvoicePreview" class="credit-transfer-container">
      <salaxy-credit-transfer invoice-preview="$invCreate.primaryCalcNetInvoicePreview" mode="official">
        <message>
          <p>Palkka</p>
          <p style="text-transform: none;" sxy-html="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.statuses.mobileBanking.salaryInfo.html"></p>
        </message>
      </salaxy-credit-transfer>
    </div>
  </div>

</div>`), s.put("salaxy-components/modals/calc/PSDPaymentOverview.html", `<div class="modal-calc-list">
  <div class="modal-header">
    <h2 class="modal-title">{{ $ctrl.$invCreate.title }}</h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <salaxy-invoices-create model="$ctrl.current" ng-ref="$ctrl.$invCreate"></salaxy-invoices-create>
  </div>
  <div class="modal-footer">
    <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
    
    <button type="submit" class="btn btn-secondary ms-auto" ng-disabled="!$ctrl.logic.isReadyForPayment()" ng-click="$close('create-invoices-pay-later')">
      Luo maksut ja maksa myöhemmin
    </button>
    <button type="submit" class="btn btn-primary" ng-disabled="!$ctrl.logic.isReadyForPayment()" ng-click="$close('create-invoices-pay-now')">
      Maksa nyt
    </button>
</div>`), s.put("salaxy-components/modals/calc/row-type-select.html", `<div class="salaxy-component salaxy-calc-details-dialog">
  <div class="card card-list" ng-class="'card-' + ($ctrl.logic.rowTypeSelectHelp || 'primary')">
    <div class="card-header d-flex align-items-center p-3">
      <h1>{{ "SALAXY.NG1.CalcDetailsDialogComponent." + ($ctrl.logic.rowTypeSelectHelp || "all") + ".title" | sxyTranslate }}</h1>
      <button type="button" class="btn-close ms-auto" ng-click="$close('cancel')" aria-label="Close"></button>
    </div>
    <div class="card-body" ng-if="$ctrl.logic.rowTypeSelectHelp">
      <p>{{ "SALAXY.NG1.CalcDetailsDialogComponent." + ($ctrl.logic.rowTypeSelectHelp || "all") + ".intro" | sxyTranslate }}</p>
    </div>
    <salaxy-calc-row-type name="rowType" type="list" model="$ctrl.current"
      categories="$ctrl.logic.categories"
      row-types="$ctrl.logic.rowTypes"
      on-row-changed="$close('ok')" label-type="plain"></salaxy-calc-row-type>
  </div>
</div>`), s.put("salaxy-components/modals/calc/SalaryDateKind.html", `<div class="modal-body modal-salary-date-kind">
  <form class="mb-2 form-horizontal">
    <legend sxy-text="{{$ctrl.logic.text}}"></legend>
    <p sxy-html="{{$ctrl.logic.title}}"></p>
  </form>
  <div class="text-end">
    <button class="btn btn-sm btn-default" ng-click="$dismiss()" sxy-text="SALAXY.UI_Terms.close"></button>
    <button class="btn btn-sm btn-primary" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.select"></button>
  </div>
</div>`), s.put("salaxy-components/modals/calc/SalaryDateKindInputEnum.html", `<ng-form name="{{$ctrl.name}}Form" class="salaxy-input-enum">
  <salaxy-form-group ng-if="$ctrl.type=='radio'" name="{{$ctrl.name}}" require="$ctrl.require" label="{{$ctrl.label}}" label-type="{{$ctrl.labelType}}" label-cols="{{$ctrl.labelCols}}">
    <div class="radio" ng-repeat="x in $ctrl.getEnumerations()">
      <label class="control-label radio-label" for="{{x.value}}">
        <input ng-disabled="$ctrl.getDisabled()" type="radio" ng-model="$ctrl.value" ng-change="$ctrl.onChange()" class="" name="{{$ctrl.label}}" id="{{x.value}}" value="{{x.value}}"
          title="{{x.title | sxyTranslate}}">
          <strong>{{$ctrl.formatLabel(x)}}</strong>
          <p ng-if="x.title" class="text-small">{{ x.title | sxyTranslate }}</p>
      </label>
    </div>
  </salaxy-form-group>
</ng-form>`), s.put("salaxy-components/modals/calc/SelectVersion.html", `<div class="modal-version-list">
  <div class="modal-header">
    <h2 class="modal-title">{{"Valitse versio" | sxyTranslate}}</h2>

    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <style>
      .table-hover>tbody>tr:hover>td,
      .table-hover>tbody>tr:hover>th {
        background-color: var(--salaxy-brand-info);
        ;
        text-decoration: none;
      }
    </style>
    <table class="table table-sm table-hover">
      <thead>
        <tr>
          <th colspan="2" sxy-text="SALAXY.NG1.CalcComponent.versions.creator"></th>
          <th class="right" sxy-text="SALAXY.NG1.CalcComponent.versions.date"></th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.data.versions" class="clickable" ng-class="{ 'bg-success': $ctrl.data.versionId == row.versionId }" ng-click="$close(row)">
          <td class="align-middle td-avatar">
            <salaxy-avatar avatar="row.userAccount"></salaxy-avatar>
          </td>
          <td class="td-name">
            {{row.userAccount.displayName}}
          </td>
          <td class="right">
            <span>{{row.date | date: 'd.M.yyyy HH:mm:ss' }}</span><br />
          </td>
        </tr>
      </tbody>
    </table>
    <salaxy-spinner ng-if="!$ctrl.data.versions.length"></salaxy-spinner>
  </div>
  <div class="modal-footer text-end">
    <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
  </div>
</div>`), s.put("salaxy-components/modals/calc/TaxcardSelect.html", `<div class="modal-taxcard-list">
  <div class="modal-header">
    <h2 class="modal-title">{{$ctrl.logic.title | sxyTranslate}}</h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <div class="table-responsive" style="max-height: calc(100vh - 300px)">
      <salaxy-taxcard-list mode="select" selected-items="$ctrl.current" options="$ctrl.logic.options" ng-ref="$taxcardList" on-list-select="$taxcardList.selectedItems.splice(0, $taxcardList.selectedItems.length);(value == true ? $taxcardList.selectedItems.push(item) : null);"></salaxy-taxcard-list>
    </div>
    <div class="text-right">
      <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="{{ $ctrl.logic.cancelButtonText || 'SALAXY.UI_Terms.cancel'}}"></button>
      <button type="submit" ng-disabled="$taxcardList.selectedItems.length != 1" class="btn btn-primary" ng-click="$close('ok')" sxy-text="{{ $ctrl.logic.okButtonText || 'SALAXY.UI_Terms.save'}}"></button>
    </div>
  </div>
</div>`), s.put("salaxy-components/modals/calc/WorkerList.html", `<div class="modal-worker-list">
  <div class="modal-header">
    <h2 class="modal-title">{{$ctrl.logic.title | sxyTranslate}}</h2>

    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <span ng-if="$ctrl.logic.infoHtml" sxy-html="{{$ctrl.logic.infoHtml}}"></span>
    <div class="list-content">
      <salaxy-employment-list mode="multiselect" selected-items="$ctrl.current"></salaxy-employment-list>
    </div>
    <div class="text-end">
      <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
      <button type="submit" class="btn btn-primary" ng-click="$close('ok')">{{$ctrl.logic.okButtonText ? ($ctrl.logic.okButtonText | sxyTranslate) : ('SALAXY.UI_Terms.save' | sxyTranslate)}}</button>
    </div>
  </div>
</div>`), s.put("salaxy-components/modals/calc/WorkerSelect.html", `<div class="modal-worker-list">
  <div class="modal-header">
    <h2 class="modal-title">{{$ctrl.logic.title | sxyTranslate}}</h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <span ng-if="$ctrl.logic.infoHtml" sxy-html="{{$ctrl.logic.infoHtml}}"></span>
    <div class="list-content">
      <salaxy-employment-list mode="select" selected-items="$ctrl.current" ng-ref="$employmentsList" on-list-select="$employmentsList.selectedItems.splice(0, $employmentsList.selectedItems.length);(value == true ? $employmentsList.selectedItems.push(item) : null);"></salaxy-employment-list>
    </div>
    <div class="text-end">
      <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
      <button type="submit" class="btn btn-primary" ng-click="$close('ok')">{{$ctrl.logic.okButtonText ? ($ctrl.logic.okButtonText | sxyTranslate) : ('SALAXY.UI_Terms.save' | sxyTranslate)}}</button>
    </div>
  </div>
</div>`), s.put("salaxy-components/modals/calc/WSPaymentOverview.html", `<div class="modal-calc-list">
  <div class="modal-header">
    <h2 class="modal-title">{{ $ctrl.$invCreate.title }}</h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <salaxy-invoices-create model="$ctrl.current" ng-ref="$ctrl.$invCreate"></salaxy-invoices-create>
  </div>
  <div class="modal-footer">
    <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
    <button type="submit" class="btn btn-primary ms-auto" ng-if="$ctrl.$invCreate.getOkBtn()" ng-click="$ctrl.$invCreate.createInvoices($close)">
      {{ $ctrl.$invCreate.getOkBtn() }}     
    </button>
    
</div>`), s.put("salaxy-components/modals/communications/VarmaPopup.html", `<div class="modal-ui-translation">
  <div class="modal-header">
    <h2 class="modal-title">{{$ctrl.current.title}}</h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
  </div>

  <div class="modal-body">
    <p ng-bind-html="$ctrl.current.message"></p>
    <div class="row">
      <div class="col-12 mt-2">
        <button class="btn btn-default float-start" sxy-text="SALAXY.UI_Terms.close" ng-click="$close('cancel')"></button>
        <a class="btn btn-primary float-end" href="{{$ctrl.current.varmaShopLink}}" target="_blank" sxy-text="{{$ctrl.current.btnText}}"></a>
      </div>
    </div>
  </div>
</div>`), s.put("salaxy-components/modals/date-range/DateRange.html", `<div class="modal-body modal-date-range">
  <form class="mb-2 form-horizontal">
    <salaxy-date-range ng-model="$ctrl.current" label="{{ $ctrl.logic.title }}" name="dateRange" label-type="basic"></salaxy-date-range>
  </form>
  <div class="text-end">
    <button class="btn btn-sm btn-default" ng-click="$dismiss()" sxy-text="{{ $ctrl.logic.cancelText }}"></button>
    <button class="btn btn-sm btn-primary" ng-click="$close('ok')" sxy-text="{{ $ctrl.logic.okText }}"></button>
  </div>
</div>`), s.put("salaxy-components/modals/export/Export.html", `<div class="modal-header">
  <h2 class="modal-title" id="salaxyODataExportTitle">{{ 'SALAXY.NG1.ODataExportComponent.heading' | sxyTranslate }}</h2>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

</div>
<div class="modal-body" id="modal-body">
  <div class="btn-toolbar" role="toolbar" aria-label="Export options">
    <div class="btn-group dropdown">
      <button id="exportMapper" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown">
        {{ $ctrl.data.$parent.mapper.title }}
      </button>
      <ul class="dropdown-menu" role="menu" aria-labelledby="exportMapper">
        <li role="menuitem" ng-repeat="mapper in $ctrl.data.$parent.allMappers">
          <a href="" ng-click="$ctrl.data.$parent.setExportMapper(mapper)" class="dropdown-item">{{mapper.title}}</a></li>
      </ul>
    </div>
    <div class="btn-group dropdown ms-1">
      <button id="exportFileType" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown">
        {{ $ctrl.data.$parent.currentExporter.label }}
      </button>
      <ul class="dropdown-menu" role="menu" aria-labelledby="exportFileType">
        <li role="menuitem" ng-repeat="exporter in $ctrl.data.$parent.exporters">
          <a href="" ng-click="$ctrl.data.$parent.currentExporter = exporter" class="dropdown-item">{{ exporter.label }}</a></li>
      </ul>
    </div>
    <salaxy-input-enum name="localeId" type="dropdown" enum="Culture" label-type="plain" label-format="title" ng-model="$ctrl.data.$parent.localeId"
      ng-if="$ctrl.data.$parent.currentExporter.hasLocales"></salaxy-input-enum>
    <salaxy-input-enum name="maxCount" type="dropdown" label-type="plain" label-format="title" ng-model="$ctrl.data.$parent.maxCount"
      options="$ctrl.data.$parent.maxCountOptions"></salaxy-input-enum>
    <div class="btn-group ms-auto" sxy-if-role="test">
      <button type="button" class="btn btn-primary" ng-click="$ctrl.data.$parent.toggleDebug()">Debug <span class="badge">test</span></button>
    </div>
  </div>
  <div ng-if="$ctrl.data.$parent.isDebug">
    <salaxy-data-mapper model="$ctrl.data.$parent.mapper" type="debug"></salaxy-data-mapper>
  </div>
  <div class="table-responsive" style="padding-top: 5vh; text-align:center">
    <button id="exportNonQuick" type="button" class="btn btn-primary" ng-click="$ctrl.data.$parent.export()">
      <span ng-show="!$ctrl.data.$parent.isExporting">{{ 'SALAXY.NG1.ODataExportComponent.createMaterial' | sxyTranslate }} <i class="bi bi-download"></i></span>
      <span ng-show="$ctrl.data.$parent.isExporting">{{ 'SALAXY.NG1.ODataExportComponent.createMaterial' | sxyTranslate }} <i class="bi bi-arrow-repeat bi-spin"></i></span>
    </button>
    <div ng-show="$ctrl.data.$parent.isExporting"><small>&nbsp;{{$ctrl.data.$parent.exportMessage}}</small></div>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
</div>`), s.put("salaxy-components/modals/form-controls/HolidayRowTypeEdit.html", `<div class="modal-header">
  <h2 class="modal-title" id="holidayRowTypeHeader" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.inputs.type"></h2>
  <button type="button" class="btn-close" ng-click="$dismiss()" aria-label="Close"></button>
</div>
<div class="modal-body">
  <form name="holidayRowType" class="form-horizontal" ng-readonly="$ctrl.logic.readOnly">
    <salaxy-input-enum label="SALAXY.NG1.WorkerHolidaysComponent.UI.inputs.type" name="baseType" type="radio" options="{'incomeType': 'SALAXY.NG1.WorkerHolidaysComponent.UI.inputs.incomeType', 'rowType' : 'SALAXY.NG1.WorkerHolidaysComponent.UI.inputs.rowType', 'type': 'SALAXY.NG1.WorkerHolidaysComponent.UI.inputs.wageType'}" ng-model="$ctrl.current.baseType" require="true"></salaxy-input-enum>
    <salaxy-input-income-type ng-if="$ctrl.current.baseType == 'incomeType'" label="SALAXY.NG1.WorkerHolidaysComponent.UI.inputs.incomeType" name="code" ng-model="$ctrl.current.type" hidden-codes="[1]">
    </salaxy-input-income-type>
    <salaxy-form-group ng-if="$ctrl.current.baseType == 'rowType'" name="rowTypeLabel" label="SALAXY.NG1.WorkerHolidaysComponent.UI.inputs.rowType">
      <salaxy-calc-row-type label="SALAXY.NG1.WorkerHolidaysComponent.UI.inputs.rowType" name="rowType" model="$ctrl.logic.asUserDefinedRow($ctrl.current)" clear-on-select="false"></salaxy-calc-row-type>
    </salaxy-form-group>
    <salaxy-form-group ng-if="$ctrl.current.baseType == 'type'" name="type" label="SALAXY.NG1.WorkerHolidaysComponent.UI.inputs.wageType">
      <salaxy-calc-row-type label="SALAXY.NG1.WorkerHolidaysComponent.UI.inputs.wageType" name="type" model="$ctrl.logic.asUserDefinedRow($ctrl.current)" clear-on-select="false"></salaxy-calc-row-type>
    </salaxy-form-group>
    <salaxy-input-boolean label="SALAXY.NG1.WorkerHolidaysComponent.UI.inputs.exclusive" name="isExclusive" ng-model="$ctrl.current.isExclusive"></salaxy-input-boolean>
    <salaxy-input-enum ng-if="$ctrl.current.baseType == 'incomeType' && $ctrl.current.type == '201'" label="SALAXY.NG1.WorkerHolidaysComponent.UI.inputs.unit" enum="CalculationRowUnit" hidden-options="[]" filter="undefined,hours" name="unit" ng-model="$ctrl.current.unit"></salaxy-input-enum>
  </form>
</div>
<div class="modal-footer">
  <button type="reset" ng-if="!$ctrl.logic.readOnly" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
  <button type="button" ng-if="$ctrl.logic.readOnly" class="btn btn-primary" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
  <button type="button" ng-if="!$ctrl.logic.readOnly" class="btn btn-primary" ng-disabled="!holidayRowType.$valid" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.save"></button>
</div>
`), s.put("salaxy-components/modals/import/Import.html", `<div>
  <div class="modal-header">
    <h2 class="modal-title" id="salaxyODataExportTitle">{{'SALAXY.NG1.ODataImportComponent.heading' | sxyTranslate}} {{$ctrl.currentStep.number}}/{{$ctrl.steps.length}}</h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
  </div>
  <div class="modal-body" id="modal-body">
    <div class="salaxy-wizard">
      <div class="wizard-steps">
        <div class="wizard-step" ng-repeat="step in $ctrl.steps" ng-class="{'active': step.active, 'disabled': step.disabled}">
          <span class="salaxy-avatar">
            <div class="wizard-icons-wrapper">
              <i class="bi" ng-class="step.active ? 'bi-circle-fill' : 'bi-circle'"></i>
              <i class="bi bi-circle-fill"></i>
            </div>
            <strong class="number">{{ step.number }}</strong>
          </span>
          <span class="step-text">{{ step.title | sxyTranslate }}</span>
        </div>
      </div>
      <div class="wizard-strikethrough"></div>
    </div>
    <div class="wizard-content">
      <ng-include src="$ctrl.currentStep.view"></ng-include>
    </div>
  </div>
</div>`), s.put("salaxy-components/modals/import/ImportStep1.html", `<div ng-if="!$ctrl.data.$parent.api" class="alert alert-danger">
  ERROR: No API selected.
</div>
<div ng-if="$ctrl.data.$parent.api">
  <div ng-if="$ctrl.data.$parent.api" class="btn-toolbar" role="toolbar" aria-label="Data options">
    <div class="btn-group" role="group">
      <button type="button" class="btn btn-default" ng-click="$ctrl.data.$parent.pasteFromClipboard()">
        <span>{{'SALAXY.NG1.ODataImportComponent.step1.pasteFromDesktop' | sxyTranslate}} <i class="bi bi-clipboard"></i></span></button>
      <button type="button" class="btn btn-default" ngf-select="$ctrl.data.$parent.readFile($file)" ngf-multiple="false" ngf-max-size="10MB">
        <span>{{'SALAXY.NG1.ODataImportComponent.step1.downloadFile' | sxyTranslate}}... <i class="bi bi-file-earmark-text"></i></span>
      </button>
    </div>
  </div>
  <textarea ng-model="$ctrl.data.$parent.batch.rawData" style="width: 100%; height: 300px;" placeholder="{{'SALAXY.NG1.ODataImportComponent.step1.copyExcelFileFromClipboard' | sxyTranslate}}"></textarea>
</div>
<div class="modal-footer">
  <button ng-disabled="!$ctrl.data.$parent.batch.rawData" ng-click="$ctrl.data.$parent.readBatch();$ctrl.goNext()" class="btn btn-primary" sxy-text="SALAXY.UI_Terms.next"></button>
</div>`), s.put("salaxy-components/modals/import/ImportStep2.html", `<salaxy-validation-summary api-validation="$ctrl.data.$parent.lastResult"></salaxy-validation-summary>
<div class="btn-toolbar" role="toolbar" aria-label="Read options">
  <div class="btn-group dropdown">
    <button id="importMapper" type="button" class="btn dropdown-toggle" ng-class="$ctrl.data.$parent.mapper ? 'btn-primary' : 'btn-danger'" data-bs-toggle="dropdown">
      {{$ctrl.data.$parent.mapper ? $ctrl.data.$parent.mapper.title : ('SALAXY.NG1.ODataImportComponent.step2.chooseMaterial' | sxyTranslate) }}
    </button>
    <ul class="dropdown-menu" role="menu" aria-labelledby="importMapper">
      <li role="menuitem" ng-repeat="mapper in $ctrl.data.$parent.objectMappers">
        <a href="" ng-click="$ctrl.data.$parent.setMapper(mapper.value)" class="dropdown-item">{{mapper.text}}</a>
      </li>
    </ul>
  </div>
  <div class="btn-group dropdown ms-1">
    <button id="importFileType" type="button" class="btn dropdown-toggle" ng-class="$ctrl.data.$parent.currentFileParser ? 'btn-primary' : 'btn-danger'" data-bs-toggle="dropdown">
      {{ $ctrl.data.$parent.currentFileParser.label || ('SALAXY.NG1.ODataImportComponent.step2.chooseFiletype' | sxyTranslate) }}
    </button>
    <ul class="dropdown-menu" role="menu" aria-labelledby="importFileType">
      <li role="menuitem" ng-repeat="parser in $ctrl.data.$parent.fileParsers">
        <a href="" ng-click="$ctrl.data.$parent.currentFileParser = parser;$ctrl.data.$parent.readBatch()" class="dropdown-item">{{ parser.label }}</a>
      </li>
    </ul>
  </div>
  <salaxy-input-enum name="localeId" type="dropdown" enum="Culture" label-type="plain" label-format="title" ng-model="$ctrl.data.$parent.localeId"
    ng-change="$ctrl.data.$parent.readBatch()"
    ng-if="$ctrl.data.$parent.currentFileParser.hasLocales"></salaxy-input-enum>
  <div class="btn-group ms-auto" sxy-if-role="test">
    <button type="button" class="btn btn-primary" ng-click="$ctrl.data.$parent.toggleDebug()">Debug <span class="badge">test</span></button>
  </div>
</div>
<div ng-if="!$ctrl.data.$parent.batch.unmappedData.data.length" class="table-responsive" style="padding-top: 5vh; padding-bottom: 10vh; text-align:center">
  <span></span>
</div>
<div ng-if="$ctrl.data.$parent.batch.unmappedData.data.length" class="table-responsive" style="width: 100%; min-height: 300px; max-height: calc(100vh - 450px);">
  <salaxy-data-mapper ng-if="!$ctrl.data.$parent.isDebug" model="$ctrl.data.$parent.batch.parserMapper"></salaxy-data-mapper>
  <salaxy-data-mapper ng-if="$ctrl.data.$parent.isDebug" model="$ctrl.data.$parent.batch.parserMapper" type="debug"></salaxy-data-mapper>
</div>
<div class="modal-footer">
  <button ng-click="$ctrl.goPrevious()" class="btn float-start btn-default" sxy-text="SALAXY.UI_Terms.previous"></button>
  <button ng-click="$ctrl.data.$parent.mapBatch();$ctrl.goNext()" ng-disabled="!$ctrl.data.$parent.batch.unmappedData.data.length || !$ctrl.data.$parent.mapper" class="btn btn-primary" sxy-text="SALAXY.UI_Terms.next"></button>
</div>`), s.put("salaxy-components/modals/import/ImportStep3.html", `<div ng-init="$ctrl.data.$parent.validateBatch()">
  <div class="alert alert-danger" ng-if="$ctrl.data.$parent.batch.hasDataValidationErrors" sxy-text="SALAXY.NG1.ODataImportComponent.step3.error"></div>
  <div class="btn-toolbar" role="toolbar" aria-label="Validation options">
    <div class="btn-group" role="group">
      <button id="validate" type="button" class="btn btn-default" ng-click="$ctrl.data.$parent.validateBatch()">
        <span>{{ 'SALAXY.NG1.ODataImportComponent.step3.check' | sxyTranslate }}
          <i class="bi" ng-class="$ctrl.data.$parent.progress ? 'bi-arrow-repeat bi-spin' : 'bi-check-lg'"></i></span>
      </button>
      <div ng-show="$ctrl.data.$parent.progress"><small>&nbsp;{{$ctrl.data.$parent.progressMessage}}</small></div>
    </div>
    <div class="btn-group ms-1">
      <button class="btn btn-default" ng-click="$ctrl.showTarget = false" ng-class="{ active: !$ctrl.showTarget }">Lähdedata</button>
      <button class="btn btn-default" ng-click="$ctrl.showTarget = true" ng-class="{ active: $ctrl.showTarget }">Kohdedata</button>
    </div>
    <div class="btn-group ms-auto" sxy-if-role="test">
      <button type="button" class="btn btn-primary" ng-click="$ctrl.data.$parent.toggleDebug()">Debug <span class="badge">test</span></button>
    </div>
  </div>
  <div ng-if="$ctrl.data.$parent.isDebug">
    <salaxy-data-mapper model="$ctrl.data.$parent.batch.mapper" type="debug"></salaxy-data-mapper>
  </div>
  <div ng-if="$ctrl.showTarget && $ctrl.data.$parent.batch.data.length" class="table-responsive" style="width: 100%; min-height: 300px; max-height: calc(100vh - 450px);">
    <salaxy-data-mapper model="$ctrl.data.$parent.batch.mapper" type="target-value"></salaxy-data-mapper>
  </div>
  <div ng-if="!$ctrl.showTarget && $ctrl.data.$parent.batch.data.length" class="table-responsive" style="width: 100%; min-height: 300px; max-height: calc(100vh - 450px);">
    <salaxy-data-mapper model="$ctrl.data.$parent.batch.mapper" type="source-value"></salaxy-data-mapper>
  </div>
  <div class="modal-footer">
    <button ng-click="$ctrl.goPrevious()" class="btn float-start btn-default" sxy-text="SALAXY.UI_Terms.previous"></button>
    <button ng-click="$ctrl.data.$parent.clearLastResult();$ctrl.goNext()" ng-disabled="!$ctrl.data.$parent.batch.isDataValid" class="btn btn-primary ms-auto" sxy-text="SALAXY.UI_Terms.next"></button>
  </div>
</div>`), s.put("salaxy-components/modals/import/ImportStep4.html", `<div class="alert alert-danger" ng-if="$ctrl.data.$parent.batch.hasDataValidationErrors" sxy-text="SALAXY.NG1.ODataImportComponent.step4.error"></div>
<div class="btn-toolbar" role="toolbar" aria-label="Import options">
  <div class="btn-group" role="group">
    <div ng-show="$ctrl.data.$parent.progress"><small>&nbsp;{{$ctrl.data.$parent.progressMessage}}</small></div>
  </div>
</div>
<div ng-if="$ctrl.data.$parent.batch.data.length" class="table-responsive" style="width: 100%; min-height: 300px; max-height: calc(100vh - 450px);">
  <table class="table table-sm">
    <thead>
      <tr>
        <th sxy-text="SALAXY.NG1.ODataImportComponent.step4.okey"></th>
        <th ng-repeat="header in $ctrl.data.$parent.mapper.target.keys">{{header}}</th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="row in $ctrl.data.$parent.batch.data">
        <td>
          <div ng-if="row.validation && row.validation.errors && row.validation.errors.length" ng-repeat="error in row.validation.errors">
            <button type="button" class="btn btn-danger" data-bs-toggle="popover" data-bs-html="true" data-bs-content="{{ error.msg }}" data-bs-title="{{ error.code }}" sxy-bs5-popover>{{ error.code }}</button><br>
          </div>
          <div ng-if="row.validation && row.validation.isValid">
            <span class="text-success" sxy-text="SALAXY.NG1.ODataImportComponent.step4.okey"></span>
          </div>
        </td>
        <td ng-repeat="header in $ctrl.data.$parent.mapper.target.keys" ng-switch="header">
          <!-- HACK: use type information instead of field name to format (or use sxyGrid.) -->
          <span ng-switch-when="employment">
            <salaxy-avatar style="font-size: 18px;" avatar="row.employment.personalInfo.avatar"></salaxy-avatar>
            {{ row.employment.personalInfo.avatar.displayName }}
          </span>
          <span ng-switch-default>{{row[header]}}</span>
        </td>
      </tr>
    </tbody>
  </table>
</div>
<div class="modal-footer">
  <button id="import" type="button" class="btn btn-default ms-auto" ng-click="$ctrl.data.$parent.importBatch($close)">
    <span>{{ 'SALAXY.UI_Terms.save' | sxyTranslate }}
      <i class="bi" ng-class="$ctrl.data.$parent.progress ? 'bi-arrow-repeat bi-spin' : 'bi-upload'"></i>
    </span>
  </button>
  <button ng-click="$ctrl.data.$parent.clearLastResult();$ctrl.goPrevious()" class="btn float-start btn-default" sxy-text="SALAXY.UI_Terms.previous"></button>
</div>`), s.put("salaxy-components/modals/invoices/company-invoice-dialog.html", `<div class="modal-invoice-group-dialog" ng-controller="InvoiceToolsController as $invoiceTools" ng-init="$invoiceTools.setFileTypes(['pdfFile'])">
  <div class="modal-header">
    <h2 class="modal-title" sxy-text="SALAXY.NG1.InvoiceDialog.paymentInformation"></h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <h2 class="visible-print-block" sxy-text="SALAXY.NG1.InvoiceDialog.paymentInformation"></h2>
    <div class="row">
      <div class="col-sm-6">
        <fieldset>
          <legend sxy-text="SALAXY.NG1.InvoiceDialog.paymentReceiver"></legend>
          <salaxy-avatar avatar="$ctrl.current.otherPartyInfo.avatar" class="pull-left" style="font-size: 64px; border-bottom: 32px; margin-right:15px;"></salaxy-avatar>
          <div><strong>{{ $ctrl.current.otherPartyInfo.avatar.displayName }}</strong></div>
          <div>{{ $ctrl.current.otherPartyInfo.officialId }}</div>
          <div ng-if="$ctrl.current.otherPartyInfo.ibanNumber">{{ $ctrl.current.otherPartyInfo.ibanNumber | sxyIban }}</div>
          <div ng-if="!$ctrl.current.otherPartyInfo.ibanNumber" class="alert-danger" sxy-text="SALAXY.NG1.InvoiceDialog.noIban"></div>
        </fieldset>
        <fieldset>
          <legend sxy-text="SALAXY.NG1.InvoiceDialog.payer"></legend>
          <salaxy-avatar avatar="$ctrl.current.ownerInfo.avatar" class="pull-left" style="font-size: 64px; border-bottom: 32px; margin-right:15px;"></salaxy-avatar>
          <div><strong>{{ $ctrl.current.ownerInfo.avatar.displayName }}</strong></div>
          <div>{{ $ctrl.current.ownerInfo.officialId }}</div>
          <div ng-if="$ctrl.current.ownerInfo.ibanNumber">{{ $ctrl.current.ownerInfo.ibanNumber | sxyIban }}</div>
          <div ng-if="!$ctrl.current.ownerInfo.ibanNumber" class="alert-danger" sxy-text="SALAXY.NG1.InvoiceDialog.noIban"></div>
        </fieldset>
      </div>
      <div class="col-sm-6 form-horizontal">
        <fieldset>
          <legend>
            {{"SALAXY.NG1.InvoiceDialog.invoiceStatus" | sxyTranslate}}: {{ "InvoiceStatus." + $ctrl.current.status | sxyEnum }}
          </legend>
            <button ng-if="$ctrl.logic.parent.showMarkAsPaidButton($ctrl.current)" class="btn btn-primary" ng-click="$ctrl.logic.parent.updateInvoiceStatus($ctrl.current,'paid')">
              <i class="bi bi-check-lg visible-xs me-1"></i><span class="hidden-xs" sxy-text="SALAXY.NG1.InvoicesCompany.setAsPaid"></span>
            </button> 
            <button class="btn btn-danger" ng-if="$ctrl.logic.parent.showMarkAsCanceledButton($ctrl.current)" ng-click="$ctrl.logic.parent.updateInvoiceStatus($ctrl.current,'canceled')">
              <i class="bi bi-x-lg visible-xs me-1"></i><span class="hidden-xs" sxy-text="SALAXY.NG1.InvoicesCompany.cancelPayment"></span>
            </button>
            <p ng-if="$ctrl.logic.parent.showIrCancelInfoText($ctrl.current)" class="text-center" sxy-text="SALAXY.NG1.InvoicesCompany.cancelInfoText"></p>
        </fieldset>
        <div class="pull-right" style="width: 160px" ng-if="$ctrl.current.status != 'paid' && $ctrl.current.status != 'canceled' && $ctrl.logic.parent.getQrCode($ctrl.current) !== 'loading' && $ctrl.logic.parent.getQrCode($ctrl.current) !== 'error'">
          <div height="160px" ng-bind-html="$ctrl.logic.parent.getQrCode($ctrl.current)" ></div>
        </div>
        <div ng-if="$ctrl.current.data.totalPaid && $ctrl.current.data.totalPaid != $ctrl.current.payment">
          
            <h4 style="text-decoration: line-through;">{{'SALAXY.NG1.InvoicesCompany.sum' | sxyTranslate}} {{ $ctrl.current.payment | currency }}</h4>
            <h4>{{'SALAXY.NG1.InvoicesCompany.alreadyPaid' | sxyTranslate}} {{ $ctrl.current.data.totalPaid | currency }}</h4>
            <h4 class="total" style="font-weight: bold;">{{'SALAXY.NG1.InvoicesCompany.payable' | sxyTranslate}} {{ ($ctrl.current.payment - $ctrl.current.data.totalPaid) | currency }}</h4>
          
        </div>
      </div>
    </div>
    <div ng-switch="$ctrl.current.status">
      <div class="alert alert-info" ng-switch-when="paid|paymentStarted|read" ng-switch-when-separator="|" sxy-html="SALAXY.NG1.InvoiceDialog.statuses.paidPaymentStartedRead.html"></div>
      <div class="alert alert-info" ng-switch-when="canceled" sxy-html="SALAXY.NG1.InvoiceDialog.statuses.canceled.html"></div>
      <div class="alert alert-danger" ng-switch-when="preview" sxy-html="SALAXY.NG1.InvoiceDialog.statuses.preview.html"></div>
    </div>
    <div class="table-responsive" ng-if="$ctrl.current.status !== 'canceled'">
      <table class="table">
        <thead>
          <tr>
            <th sxy-text="SALAXY.NG1.InvoiceDialog.table.receiver"></th>
            <th sxy-text="SALAXY.NG1.InvoiceDialog.table.receiverIban"></th>
            <th sxy-text="SALAXY.NG1.InvoiceDialog.table.reference"></th>
            <th sxy-text="SALAXY.NG1.InvoiceDialog.table.message"></th>
            <th sxy-text="SALAXY.NG1.InvoiceDialog.table.amount" class="right"></th>
            <th sxy-text="SALAXY.NG1.InvoiceDialog.table.dueDate" class="right"></th>
            <th sxy-text="SALAXY.NG1.InvoiceDialog.table.barcode" class="d-print-none"></th>
            <th class="d-print-none">PDF</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ $ctrl.current.otherPartyInfo.avatar.displayName }}</td>
            <td>{{ $ctrl.current.otherPartyInfo.ibanNumber }}</td>
            <td>{{ $ctrl.current.entityType == 'net' ? '' : $ctrl.current.reference }}</td>
            <td>{{ ("SALAXY.ENUM.InvoiceType." + $ctrl.current.entityType + ".label") | sxyTranslate }}</td>
            <td class="right">{{ $ctrl.logic.parent.getInvoicePayment($ctrl.current) | currency }}</td>
            <td class="right">{{ $ctrl.current.data.dueDate | sxyDate }}</td>
            <td class="d-print-none">
              <a type="button" class="btn btn-default btn-block" ng-href="{{$ctrl.logic.parent.getPdfUrl($ctrl.current)}}"><i class="bi bi-file-earmark-pdf text-danger me-1" title="Lataa PDF"></i>pdf</a>
            </td>
          </tr>
          <tr>
            <td colspan="6" class="text-right" style="border-top: 0;padding: 0px;">
              <div ng-init="$ctrl.current.barcode = $ctrl.logic.parent.getBarcodeValue($ctrl.current)" ng-bind-html="$ctrl.logic.parent.getBarcode($ctrl.current)"></div>
            </td>
            <td class="d-print-none" style="border-top: 0;padding: 0px 8px;">
              <button type="button" class="btn btn-default btn-block" ng-click="$ctrl.logic.parent.copyBarcode($ctrl.current)" sxy-text="SALAXY.UI_Terms.copyToClipboard"></button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
    <button type="submit" class="btn btn-primary" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.ok"></button>
  </div>
</div>`), s.put("salaxy-components/modals/invoices/company-invoices-date-filter-dialog.html", `
<div class="modal-header">
  <h2 class="modal-title" sxy-text="SALAXY.NG1.InvoicesCompany.dateFilterDialogHeading"></h2>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
</div>
<div class="modal-body" id="modal-body">
<form name="dateFilterForm" class="form-horizontal">
  <div class="row">
    <div class="col-sm-12">
      <salaxy-datepicker-popup label="SALAXY.NG1.InvoicesCompany.dateFilterDialogStart" name="startDate" ng-model="$ctrl.logic.startDate"></salaxy-datepicker-popup>
      <salaxy-datepicker-popup label="SALAXY.NG1.InvoicesCompany.dateFilterDialogEnd" name="endDate" ng-model="$ctrl.logic.endDate"></salaxy-datepicker-popup>
    </div>
  </div>
</form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
  <button type="button" class="btn btn-primary" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.select"></button>
</div>`), s.put("salaxy-components/modals/invoices/invoice-dialog.html", `<div class="modal-invoice-group-dialog" ng-controller="InvoiceToolsController as $invoiceTools">
  <div class="modal-header">
    <h2 class="modal-title" sxy-text="SALAXY.NG1.InvoiceDialog.paymentInformation"></h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

  </div>
  <div class="modal-body">
    <h2 class="d-none d-print-block" sxy-text="SALAXY.NG1.InvoiceDialog.paymentInformation"></h2>
    <div class="row">
      <div class="col-sm-6">
        <fieldset>
          <legend sxy-text="SALAXY.NG1.InvoiceDialog.paymentReceiver"></legend>
          <salaxy-avatar avatar="$ctrl.current.otherPartyInfo.avatar" class="float-start" style="font-size: 64px; border-bottom: 32px; margin-right:15px;"></salaxy-avatar>
          <div><strong>{{ $ctrl.current.otherPartyInfo.avatar.displayName }}</strong></div>
          <div>{{ $ctrl.current.otherPartyInfo.officialId }}</div>
          <div ng-if="$ctrl.current.otherPartyInfo.ibanNumber">{{ $ctrl.current.otherPartyInfo.ibanNumber | sxyIban }}</div>
          <div ng-if="!$ctrl.current.otherPartyInfo.ibanNumber" class="alert-danger" sxy-text="SALAXY.NG1.InvoiceDialog.noIban"></div>
        </fieldset>
        <fieldset>
          <legend>Maksaja</legend>
          <salaxy-avatar avatar="$ctrl.current.ownerInfo.avatar" class="float-start" style="font-size: 64px; border-bottom: 32px; margin-right:15px;"></salaxy-avatar>
          <div><strong>{{ $ctrl.current.ownerInfo.avatar.displayName }}</strong></div>
          <div>{{ $ctrl.current.ownerInfo.officialId }}</div>
          <div ng-if="$ctrl.current.ownerInfo.ibanNumber">{{ $ctrl.current.ownerInfo.ibanNumber | sxyIban }}</div>
          <div ng-if="!$ctrl.current.ownerInfo.ibanNumber" class="alert-danger" sxy-text="SALAXY.NG1.InvoiceDialog.noIban"></div>
        </fieldset>
      </div>
      <div class="col-sm-6 form-horizontal">
        <fieldset>
          <legend>{{"SALAXY.NG1.InvoiceDialog.invoiceStatus" | sxyTranslate}}: {{ "InvoiceStatus." + $ctrl.current.status | sxyEnum }}</legend>
          <salaxy-form-group name="paymentChannel" label="{{'SALAXY.NG1.InvoiceDialog.paymentChannel' | sxyTranslate}}">
            <div style="height:100%">
              <div style="display: inline-block;vertical-align: middle;">
                <salaxy-avatar style="font-size: 2.8em" avatar="$ctrl.logic.parent.getChannelAvatar($ctrl.current.data.channel)"></salaxy-avatar>
              </div>
              <div style="display: inline-block;vertical-align: middle;">{{ $ctrl.logic.parent.getChannelAvatar($ctrl.current.data.channel).displayName }}</div>
            </div>
          </salaxy-form-group>
          <div class="d-print-none" ng-init="$ctrl.logic.newStatus = $ctrl.current.status">
            <salaxy-input-enum label="{{'SALAXY.NG1.InvoiceDialog.changeStatus' | sxyTranslate}}" name="requestedStatus" options="{'unread': ('SALAXY.ENUM.InvoiceStatus.unread.label' | sxyTranslate),'read': ('SALAXY.ENUM.InvoiceStatus.read.label' | sxyTranslate),'waitingConfirmation': ('SALAXY.ENUM.InvoiceStatus.waitingConfirmation.label' | sxyTranslate),'paid': ('SALAXY.ENUM.InvoiceStatus.paid.label' | sxyTranslate),'canceled': ('SALAXY.ENUM.InvoiceStatus.canceled.label' | sxyTranslate)}" ng-model="$ctrl.logic.newStatus" enum="InvoiceStatus">
            </salaxy-input-enum>
            <salaxy-form-group name="statusButton" label-type="empty-label">
              <button type="button" class="btn btn-default float-end" ng-click="$ctrl.logic.parent.updateInvoiceGroupItemStatus($ctrl.current,$ctrl.logic.newStatus)" sxy-text="SALAXY.NG1.InvoiceDialog.change"></button>
            </salaxy-form-group>

            <salaxy-input-enum name="fileType" label="{{'SALAXY.NG1.InvoiceDialog.downloadInvoice' | sxyTranslate}}" ng-model="$invoiceTools.fileTypeId" options="$invoiceTools.fileTypeOptions" remember="invoice"></salaxy-input-enum>

            <salaxy-form-group name="exportButton" label-type="empty-label">
              <button type="button" class="btn btn-default float-end" ng-disabled="!$invoiceTools.fileTypeId" ng-click="$invoiceTools.export($ctrl.logic.parent.getGroupItemDataReader($ctrl.current,null),false)" sxy-text="SALAXY.NG1.InvoiceDialog.download"></button>
            </salaxy-form-group>
          </div>
        </fieldset>
      </div>
    </div>
    <div ng-switch="$ctrl.current.status">
      <div class="alert alert-info" ng-switch-when="paid|paymentStarted|read" ng-switch-when-separator="|" sxy-html="SALAXY.NG1.InvoiceDialog.statuses.paidPaymentStartedRead.html"></div>
      <div class="alert alert-info" ng-switch-when="canceled" sxy-html="SALAXY.NG1.InvoiceDialog.statuses.canceled.html"></div>
      <div class="alert alert-danger" ng-switch-when="forecast" sxy-html="SALAXY.NG1.InvoiceDialog.statuses.forecast.html"></div>
      <div class="alert alert-danger" ng-switch-when="preview" sxy-html="SALAXY.NG1.InvoiceDialog.statuses.preview.html"></div>
    </div>
    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th sxy-text="SALAXY.NG1.InvoiceDialog.table.receiver"></th>
            <th sxy-text="SALAXY.NG1.InvoiceDialog.table.receiverIban"></th>
            <th sxy-text="SALAXY.NG1.InvoiceDialog.table.reference"></th>
            <th sxy-text="SALAXY.NG1.InvoiceDialog.table.message"></th>
            <th sxy-text="SALAXY.NG1.InvoiceDialog.table.amount" class="right"></th>
            <th sxy-text="SALAXY.NG1.InvoiceDialog.table.dueDate" class="right"></th>
            <th sxy-text="SALAXY.NG1.InvoiceDialog.table.barcode" class="d-print-none"></th>
            <th class="d-print-none">PDF</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ $ctrl.current.otherPartyInfo.avatar.displayName }}</td>
            <td ng-if="$ctrl.logic.parent.hideBarCode($ctrl.current)">{{ 'SALAXY.REPORTS.invoice.heading.preview' | sxyTranslate }}</td>
            <td ng-if="!$ctrl.logic.parent.hideBarCode($ctrl.current)">{{ $ctrl.current.otherPartyInfo.ibanNumber }}</td>
            <td>{{ $ctrl.current.reference }}</td>
            <td>{{ ("SALAXY.ENUM.InvoiceType." + $ctrl.current.entityType + ".label") | sxyTranslate }}</td>
            <td class="right">{{ $ctrl.current.payment | currency }}</td>
            <td class="right">{{ $ctrl.current.data.dueDate | sxyDate }}</td>
            <td class="d-print-none">
              <a type="button" class="btn btn-default btn-block" ng-href="{{$ctrl.logic.parent.getPdfUrl($ctrl.current)}}"><i class="bi bi-file-earmark-pdf text-danger me-1" title="Lataa PDF"></i>pdf</a>
            </td>
          </tr>
          <tr ng-if="!$ctrl.logic.parent.hideBarCode($ctrl.current)">
            <td class="qrCode-column" colspan="1" style="border-top: 0; padding: 0px; width: 150px;">
              <div class="text-end" ng-if="$ctrl.logic.parent.getQrCode($ctrl.current) !== 'loading' && $ctrl.logic.parent.getQrCode($ctrl.current) !== 'error'">
                <div ng-bind-html="$ctrl.logic.parent.getQrCode($ctrl.current)" ></div>
              </div>
            </td>
            <td colspan="5" class="text-end" style="border-top: 0;padding: 0px;">
              <span style="font-family: 'Courier New', Courier, monospace; font-size: 1.15em;">{{$ctrl.logic.parent.getBarcodeValue($ctrl.current)}}</span>
            </td>
            <td class="d-print-none" style="border-top: 0;padding: 0px 8px;">
              <button type="button" class="btn btn-default btn-block" ng-click="$ctrl.logic.parent.copyBarcode($ctrl.current)" sxy-text="SALAXY.UI_Terms.copyToClipboard"></button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="modal-footer d-print-none">
    <button type="button" class="btn btn-default float-start" onClick="window.print()" sxy-text="SALAXY.UI_Terms.print"></button>
    <button type="button" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
    <button type="submit" class="btn btn-primary" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.ok"></button>
  </div>
</div>`), s.put("salaxy-components/modals/invoices/invoice-group-dialog.html", `<div class="modal-invoice-group-dialog" ng-controller="InvoiceToolsController as $invoiceTools" ng-init="($ctrl.current.invoices[0].data.channel == 'palkkausInvoices' || $ctrl.current.invoices[0].data.channel == 'kitsas') ? $invoiceTools.setFileTypes(['pdfFile']) : null">
  <style>
    @media print {
      #launcher {
        display: none;
      }
      @page {
        margin-bottom: 20mm;
      }
    }
  </style>
  <div class="modal-header">
    <h2 class="modal-title">Maksuaineiston tiedot</h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

  </div>
  <div class="modal-body">
    <h2 class="d-none d-print-block">Maksuaineiston tiedot</h2>
    <div class="row">
      <div class="col-sm-6">
        <fieldset>
          <legend>Maksaja</legend>
          <salaxy-avatar avatar="$ctrl.current.ownerInfo.avatar" class="float-start" style="font-size: 64px; border-bottom: 32px; margin-right:15px;"></salaxy-avatar>
          <div><strong>{{ $ctrl.current.ownerInfo.avatar.displayName }}</strong></div>
          <div>{{ $ctrl.current.ownerInfo.officialId }}</div>
          <div ng-if="$ctrl.current.ownerInfo.ibanNumber">{{ $ctrl.current.ownerInfo.ibanNumber | sxyIban }}</div>
          <div ng-if="!$ctrl.current.ownerInfo.ibanNumber" class="alert-danger" sxy-text="SALAXY.NG1.WorkerInfo.noIbanNumber"></div>
        </fieldset>
      </div>
      <div class="col-sm-6 form-horizontal">
        <fieldset>
          <legend>Aineiston tila: {{ "InvoiceStatus." + $ctrl.current.status | sxyEnum }}</legend>
          <salaxy-form-group name="paymentChannel" label="Maksukanava">
            <div style="height:100%">
              <div style="display: inline-block;vertical-align: middle;">
                <salaxy-avatar style="font-size: 2.8em" avatar="$ctrl.logic.parent.getChannelAvatar($ctrl.current.invoices[0].data.channel)"></salaxy-avatar>
              </div>
              <div style="display: inline-block;vertical-align: middle;">{{ $ctrl.logic.parent.getChannelAvatar($ctrl.current.invoices[0].data.channel).displayName }}</div>
            </div>
          </salaxy-form-group>
          <div class="d-print-none" ng-init="$ctrl.logic.newStatus = $ctrl.current.status">
            <salaxy-input-enum label="Vaihda tilaa" name="requestedStatus" hidden-options="undefined,forecast,preview,waitingPalkkaus" ng-model="$ctrl.logic.newStatus" enum="InvoiceStatus">
            </salaxy-input-enum>
            <salaxy-form-group name="statusButton" label-type="empty-label">
              <button type="button" class="btn btn-default float-end" ng-click="$ctrl.logic.parent.updateInvoiceGroupStatus($ctrl.current,$ctrl.logic.newStatus)">Vaihda</button>
            </salaxy-form-group>

            <salaxy-input-enum name="fileType" label="Lataa aineisto" ng-model="$invoiceTools.fileTypeId" options="$invoiceTools.fileTypeOptions" remember="invoice"></salaxy-input-enum>

            <salaxy-form-group name="exportButton" label-type="empty-label">
              <button type="button" class="btn btn-default float-end" ng-disabled="!$invoiceTools.fileTypeId" ng-click="$invoiceTools.export($ctrl.logic.parent.getGroupDataReader($ctrl.current,null),false)">Lataa</button>
            </salaxy-form-group>
          </div>
        </fieldset>
      </div>
    </div>
    <div ng-switch="$ctrl.current.status">
      <div class="alert alert-info" ng-switch-when="paid|paymentStarted" ng-switch-when-separator="|">
        <strong>HUOM</strong>: Aineisto on jo merkitty maksetuksi!<br /> Jos maksat tai lähetät aineiston / maksun uudelleen, varmistathan, ettei maksua makseta kahteen kertaan.
      </div>
      <div class="alert alert-info" ng-switch-when="read">
        <strong>HUOM</strong>: Aineisto on jo merkitty lähetetyksi.<br /> Jos maksat tai lähetät aineiston / maksun uudelleen, varmistathan, ettei maksua makseta kahteen kertaan.
      </div>
      <div class="alert alert-info" ng-switch-when="canceled">
        Aineisto maksut on merkitty perutuksi.<br />
      </div>
      <div class="alert alert-info" ng-switch-when="canceled">
        Aineiston edellisessä maksussa on tapahtunut virheitä.<br />
      </div>
      <div class="alert alert-danger" ng-switch-when="forecast">
        <strong>HUOM</strong>: Aineisto on <strong>Arvio</strong> (forecast).<br /> Tyypillisesti nämä ainestot ovat vain kassavirran suunnittelua varten. Niitä ei ole tarkoitus maksaa, vaan lopullinen lasku tulee laskuttajalta (esim. Työllisyysrahasto).
      </div>
      <div class="alert alert-danger" ng-switch-when="preview">
        <strong>HUOM</strong>: Aineisto on <strong>Esikatselu</strong>-tilassa.<br /> Aineistoon (esim. ennakonpidätys) voi olla vielä tulossa muutoksia. Jos maksat aineiston, varmistathan ettei aineistoon tule enää muutoksia (esim. lisää palkkoja samassa
        kuussa).
      </div>
    </div>
    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th>Saajan nimi</th>
            <th>Saajan IBAN</th>
            <th>Viite</th>
            <th>Viesti</th>
            <th class="right">Summa</th>
            <th class="right">Eräpäivä</th>
            <th class="d-print-none"></th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat-start="invoice in $ctrl.current.invoices">
            <td>{{ invoice.otherPartyInfo.avatar.displayName }}</td>
            <td>{{ invoice.otherPartyInfo.ibanNumber }}</td>
            <td>{{ invoice.reference }}</td>
            <td>{{ ("SALAXY.ENUM.InvoiceType." + invoice.entityType + ".label") | sxyTranslate }}</td>
            <td class="right">{{ invoice.payment | currency }}</td>
            <td class="right">{{ invoice.data.dueDate | sxyDate }}</td>
            <td class="d-print-none"><a type="button" class="btn btn-default btn-block" ng-href="{{$ctrl.logic.parent.getPdfUrl(invoice)}}"><i class="bi bi-file-earmark-pdf text-danger me-1" title="Lataa PDF"></i>pdf</a></td>
          </tr>
          <tr ng-repeat-end>
            <td class="qrCode-column" colspan="1" style="border-top: 0;padding: 0px; width: 150px;">
              <div class="text-end"  ng-if="$ctrl.logic.parent.getQrCode(invoice) !== 'loading' && $ctrl.logic.parent.getQrCode(invoice) !== 'error'">
                <div ng-bind-html="$ctrl.logic.parent.getQrCode(invoice)" ></div>
              </div>
            </td>
            <td colspan="5" style="border-top: 0;padding: 0px;" class="text-end">
              <span style="font-family: 'Courier New', Courier, monospace; font-size: 1.15em;">{{$ctrl.logic.parent.getBarcodeValue(invoice)}}</span>
            </td>
            <td class="d-print-none" style="border-top: 0;padding: 0px 8px;">
              <button type="button" class="btn btn-default btn-block" ng-click="$ctrl.logic.parent.copyBarcode(invoice)">Kopioi</button>
            </td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td class="right">{{ $ctrl.logic.parent.sumInvoicePayments($ctrl.current.invoices) | currency }}</td>
            <td></td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="modal-footer d-print-none">
    <button type="button" class="btn btn-default float-start" onClick="window.print()" sxy-text="SALAXY.UI_Terms.print"></button>
    <button type="button" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
    <button type="submit" class="btn btn-primary" ng-click="$close('ok')">OK</button>
  </div>
</div>`), s.put("salaxy-components/modals/invoices/invoice-payment-list-dialog.html", `<div class="modal-invoice-group-dialog" ng-controller="InvoiceToolsController as $invoiceTools">
  <div class="modal-header">
    <h2 class="modal-title" sxy-text="SALAXY.NG1.InvoiceDialog.paymentInformation"></h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <h2 class="visible-print-block" sxy-text="SALAXY.NG1.InvoiceDialog.paymentInformation"></h2>
    <div class="row">
      <div class="col-sm-6">
        <fieldset>
          <legend sxy-text="SALAXY.NG1.InvoiceDialog.paymentReceiver"></legend>
          <salaxy-avatar avatar="$ctrl.current.otherPartyInfo.avatar" class="pull-left" style="font-size: 64px; border-bottom: 32px; margin-right:15px;"></salaxy-avatar>
          <div><strong>{{ $ctrl.current.otherPartyInfo.avatar.displayName }}</strong></div>
          <div>{{ $ctrl.current.otherPartyInfo.officialId }}</div>
          <div ng-if="$ctrl.current.otherPartyInfo.ibanNumber">{{ $ctrl.current.otherPartyInfo.ibanNumber | sxyIban }}</div>
          <div ng-if="!$ctrl.current.otherPartyInfo.ibanNumber" class="alert-danger" sxy-text="SALAXY.NG1.InvoiceDialog.noIban"></div>
        </fieldset>
        <fieldset>
          <legend>Maksaja</legend>
          <salaxy-avatar avatar="$ctrl.current.ownerInfo.avatar" class="pull-left" style="font-size: 64px; border-bottom: 32px; margin-right:15px;"></salaxy-avatar>
          <div><strong>{{ $ctrl.current.ownerInfo.avatar.displayName }}</strong></div>
          <div>{{ $ctrl.current.ownerInfo.officialId }}</div>
          <div ng-if="$ctrl.current.ownerInfo.ibanNumber">{{ $ctrl.current.ownerInfo.ibanNumber | sxyIban }}</div>
          <div ng-if="!$ctrl.current.ownerInfo.ibanNumber" class="alert-danger" sxy-text="SALAXY.NG1.InvoiceDialog.noIban"></div>
        </fieldset>
      </div>
      <div class="col-sm-6 form-horizontal">
        <fieldset>
          <legend>{{"SALAXY.NG1.InvoiceDialog.invoiceStatus" | sxyTranslate}}: {{ "InvoiceStatus." + $ctrl.current.status | sxyEnum }}</legend>
          <salaxy-form-group name="paymentChannel" label="{{'SALAXY.NG1.InvoiceDialog.paymentChannel' | sxyTranslate}}">
            <div style="height:100%">
              <div style="display: inline-block;vertical-align: middle;">
                <salaxy-avatar style="font-size: 2.8em" avatar="$ctrl.logic.parent.getChannelAvatar($ctrl.current.data.channel)"></salaxy-avatar>
              </div>
              <div style="display: inline-block;vertical-align: middle;">{{ $ctrl.logic.parent.getChannelAvatar($ctrl.current.data.channel).displayName }}</div>
            </div>
          </salaxy-form-group>
          <div class="d-print-none" ng-init="$ctrl.logic.newStatus = $ctrl.current.status">
            <salaxy-input-enum name="fileType" label="{{'SALAXY.NG1.InvoiceDialog.downloadInvoice' | sxyTranslate}}" ng-model="$invoiceTools.fileTypeId" options="$invoiceTools.fileTypeOptions" remember="invoice"></salaxy-input-enum>
            <salaxy-form-group name="exportButton" label-type="empty-label">
              <button type="button" class="btn btn-default pull-right" ng-disabled="!$invoiceTools.fileTypeId" ng-click="$invoiceTools.export($ctrl.logic.parent.getGroupItemDataReader($ctrl.current,null, $invoiceTools.fileTypeId),false)" sxy-text="SALAXY.NG1.InvoiceDialog.download"></button>
            </salaxy-form-group>
          </div>
        </fieldset>
      </div>
    </div>
    <div ng-switch="$ctrl.current.status">
      <div class="alert alert-info" ng-switch-when="paid|paymentStarted|read" ng-switch-when-separator="|" sxy-html="SALAXY.NG1.InvoiceDialog.statuses.paidPaymentStartedRead.html"></div>
      <div class="alert alert-info" ng-switch-when="canceled" sxy-html="SALAXY.NG1.InvoiceDialog.statuses.canceled.html"></div>
      <div class="alert alert-danger" ng-switch-when="forecast" sxy-html="SALAXY.NG1.InvoiceDialog.statuses.forecast.html"></div>
      <div class="alert alert-danger" ng-switch-when="preview" sxy-html="SALAXY.NG1.InvoiceDialog.statuses.preview.html"></div>
    </div>
    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th sxy-text="SALAXY.NG1.InvoiceDialog.table.receiver"></th>
            <th sxy-text="SALAXY.NG1.InvoiceDialog.table.receiverIban"></th>
            <th sxy-text="SALAXY.NG1.InvoiceDialog.table.reference"></th>
            <th sxy-text="SALAXY.NG1.InvoiceDialog.table.message"></th>
            <th sxy-text="SALAXY.NG1.InvoiceDialog.table.amount" class="right"></th>
            <th sxy-text="SALAXY.NG1.InvoiceDialog.table.dueDate" class="right"></th>
            <th sxy-text="SALAXY.NG1.InvoiceDialog.table.barcode" class="d-print-none"></th>
            <th class="d-print-none">PDF</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ $ctrl.current.otherPartyInfo.avatar.displayName }}</td>
            <td ng-if="$ctrl.logic.parent.hideBarCode($ctrl.current)">{{ 'SALAXY.REPORTS.invoice.heading.preview' | sxyTranslate }}</td>
            <td ng-if="!$ctrl.logic.parent.hideBarCode($ctrl.current)">{{ $ctrl.current.otherPartyInfo.ibanNumber }}</td>
            <td>{{ $ctrl.current.reference }}</td>
            <td>{{ ("SALAXY.ENUM.InvoiceType." + $ctrl.current.entityType + ".label") | sxyTranslate }}</td>
            <td class="right">{{ $ctrl.current.payment | currency }}</td>
            <td class="right">{{ $ctrl.current.data.dueDate | sxyDate }}</td>
            <td class="d-print-none">
              <a type="button" class="btn btn-default btn-block" ng-href="{{$ctrl.logic.parent.getPdfUrl($ctrl.current)}}"><i class="bi bi-file-earmark-pdf text-danger me-1" title="Lataa PDF"></i>pdf</a>
            </td>
          </tr>
          <tr ng-if="!$ctrl.logic.parent.hideBarCode($ctrl.current)">
            <td class="qrCode-column" colspan="1" style="border-top: 0; padding: 0px; width: 150px;">
              <div class="text-right"  ng-if="$ctrl.logic.parent.getQrCode($ctrl.current) !== 'loading' && $ctrl.logic.parent.getQrCode($ctrl.current) !== 'error'">
                <div ng-bind-html="$ctrl.logic.parent.getQrCode($ctrl.current)" ></div>
              </div>
            </td>
            <td colspan="5" style="border-top: 0;padding: 0px;" class="text-right">
              <span style="font-family: 'Courier New', Courier, monospace; font-size: 1.15em;">{{$ctrl.logic.parent.getBarcodeValue($ctrl.current)}}</span>
            </td>
            <td class="d-print-none" style="border-top: 0;padding: 0px 8px;">
              <button type="button" class="btn btn-default btn-block" ng-click="$ctrl.logic.parent.copyBarcode($ctrl.current)" sxy-text="SALAXY.UI_Terms.copyToClipboard"></button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
    <button type="button" class="btn btn-default ms-auto" onClick="window.print()" sxy-text="SALAXY.UI_Terms.print"></button>
    <button type="submit" class="btn btn-primary" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.ok"></button>
  </div>
</div>`), s.put("salaxy-components/modals/localTapiola/Beneficiary-info.html", `<form name="currentForm" class="form-horizontal" model="temp">
  <span class="d-none">{{ $ctrl.formDataValidity = currentForm.$valid }}</span>

  <div class="text-center intro-col">
    <h1>{{ $ctrl.currentStep.title }}</h1>
    <h2 class="subtitle" ng-if="$ctrl.currentStep.heading != ''">{{ $ctrl.currentStep.heading }}</h2>
    <p class="intro" ng-if="$ctrl.currentStep.intro != ''">{{ $ctrl.currentStep.intro }}</p>
  </div>

  <fieldset>
    <legend sxy-text="SALAXY.NG1.InsuranceComponent.beneficiaryInfo.wizard.label"></legend>
    <div class="row" ng-repeat="item in $ctrl.current.company.beneficiaries">

      <div class="col-sm-6">
        <salaxy-input ng-model="item.avatar.displayName" name="beneficiaryName{{$index}}" label="SALAXY.NG1.InsuranceComponent.common.name" label-type="basic"></salaxy-input>
      </div>
      <div class="col-sm-3">
        <salaxy-input ng-model="item.officialId" name="beneficiaryPersonalId{{$index}}" label="SALAXY.NG1.InsuranceComponent.common.ssNumber" sxy-personal-id-fi label-type="basic"></salaxy-input>
      </div>
      <div class="col-sm-3">
        <salaxy-input ng-model="item.nationality" name="beneficiaryNationality{{$index}}" label="SALAXY.NG1.InsuranceComponent.common.nationality" label-type="basic"></salaxy-input>
      </div>
      <div class="col-12 text-end">
        <button class="btn btn-lt btn-danger btn-sm" ng-click="$ctrl.current.company.beneficiaries.splice($index,1)"><i class="bi bi-trash-fill"></i> <span class="d-none d-sm-inline" sxy-text="SALAXY.UI_Terms.delete"></span></button>
      </div>
      <div class="col-12">
        <hr>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <button class="btn btn-lt btn-secondary btn-sm" ng-click="$ctrl.current.company.beneficiaries.push({ avatar: {}})"><i class="bi bi-plus-lg" style="margin-right:5px"></i> {{'SALAXY.NG1.InsuranceComponent.beneficiaryInfo.beneficiariesAdd' | sxyTranslate}}</button>
      </div>
    </div>
  </fieldset>


</form>`), s.put("salaxy-components/modals/localTapiola/buttons-default.html", `<div class="col-6 col-sm-4 text-start">
  <button ng-click="$ctrl.goPrevious()" class="btn btn-lt btn-sm btn-link navi-link"><i class="bi bi-chevron-left"></i> {{'SALAXY.UI_Terms.previous' | sxyTranslate}}</button>
</div>
<div class="col-sm-4 d-none d-sm-block text-center txt-index">
  <div>{{$ctrl.currentStep.number-1}}/{{$ctrl.steps.length-1}}</div>
</div>
<div class="col-6 col-sm-4 text-end">

  <button ng-click="$ctrl.goNext()" ng-disabled="!$ctrl.canGoNext" class="btn btn-lt btn-sm btn-link navi-link">{{'SALAXY.UI_Terms.next' | sxyTranslate}} <i class="bi bi-chevron-right"></i></button>
  <!--button ng-click="$ctrl.goNext()" ng-disabled="!$ctrl.canGoNext" class="btn-link navi-link">Seuraava <i class="bi bi-chevron-right"></i></button-->
</div>`), s.put("salaxy-components/modals/localTapiola/buttons-send.html", `<div class="col-6 col-sm-4 text-start">
  <button ng-click="$ctrl.goPrevious()" class="btn btn-lt btn-sm btn-link navi-link"><i class="bi bi-chevron-left"></i> {{'SALAXY.UI_Terms.previous' | sxyTranslate}}</button>
</div>
<div class="col-sm-4 d-none d-sm-block text-center txt-index">
  <div>{{$ctrl.currentStep.number-1}}/{{$ctrl.steps.length-1}}</div>

</div>
<div class="col-6 col-sm-4 text-end">

  <span>
    <button ng-click="$ctrl.send()" ng-disabled="!$ctrl.canGoNext" class="btn btn-lt btn-sm btn-primary" sxy-text="SALAXY.UI_Terms.send"></button>
  </span>
</div>`), s.put("salaxy-components/modals/localTapiola/ContactInfo-entrepreneur.html", `<form name="currentForm" class="form-horizontal" ng-model="temp">

  <span class="d-none">{{ $ctrl.formDataValidity = currentForm.$valid }}</span>

  <div class="text-center intro-col">
    <h1>{{ $ctrl.currentStep.title }}</h1>
    <h2 class="subtitle" ng-if="$ctrl.currentStep.heading != ''">{{ $ctrl.currentStep.heading }}
    </h2>

  </div>

  <fieldset>
    <legend sxy-text="SALAXY.NG1.InsuranceComponent.common.insuranceContactPerson"></legend>
    <div class="content row">
      <div class="col-sm-8">
        <salaxy-input ng-model="$ctrl.current.company.contactPerson.avatar.displayName" name="contactName" label="SALAXY.NG1.InsuranceComponent.common.name" required label-type="basic"></salaxy-input>
      </div>
      <div class="col-sm-4">
        <salaxy-input ng-model="$ctrl.current.company.contactPerson.officialId" name="contactSSNumber" label="SALAXY.NG1.InsuranceComponent.common.ssNumber" required sxy-personal-id-fi label-type="basic"></salaxy-input>

      </div>
      <div class="col-sm-4">
        <salaxy-input ng-model="$ctrl.current.company.contactPerson.telephone" name="contactTelephone" label="SALAXY.NG1.InsuranceComponent.common.telephone" required sxy-mobile-phone label-type="basic"></salaxy-input>
      </div>
      <div class="col-sm-4">
        <salaxy-input ng-model="$ctrl.current.company.contactPerson.email" name="contactEmail" label="SALAXY.NG1.InsuranceComponent.common.email" required sxy-email label-type="basic"> </salaxy-input>
      </div>
      <div class="col-sm-4">
        <salaxy-input-enum type="select" ng-model="$ctrl.current.company.contactPerson.authorizationType" options="{procuration: ('SALAXY.NG1.InsuranceComponent.enums.procurationEnum' | sxyTranslate), powerOfAttorney: ('SALAXY.NG1.InsuranceComponent.enums.powerOfAttorneyEnum' | sxyTranslate), apparentAuthority: ('SALAXY.NG1.InsuranceComponent.enums.apparentAuthorityEnum' | sxyTranslate), other: ('SALAXY.NG1.InsuranceComponent.enums.otherEnum' | sxyTranslate)}"
          name="DelegateType" enum="DelegateType" label="SALAXY.NG1.InsuranceComponent.enums.authorizationTypeLabel" required label-type="basic"></salaxy-input-enum>
      </div>
    </div>
  </fieldset>
  <fieldset>
    <legend sxy-html="SALAXY.NG1.InsuranceComponent.principalBusinessAddress.label.html"></legend>
    <button class="btn btn-lt btn-xs btn-secondary" ng-click="$ctrl.current.company.hasPrincipalBusinessAddress = !$ctrl.current.company.hasPrincipalBusinessAddress"><i class="bi" style="margin-right:5px" ng-class="!$ctrl.current.company.hasPrincipalBusinessAddress ? 'bi bi-plus-lg' : 'bi-x-lg'"></i> <span ng-if="!$ctrl.current.company.hasPrincipalBusinessAddress" sxy-text="SALAXY.NG1.InsuranceComponent.common.addAddressBtn"></span><span ng-if="$ctrl.current.company.hasPrincipalBusinessAddress" sxy-text="SALAXY.UI_Terms.cancelAlt">Peru</span></button>

    <div class="content row" ng-if="$ctrl.current.company.hasPrincipalBusinessAddress">
      <div class="col-sm-12">
        <salaxy-input ng-model="$ctrl.current.company.principalBusinessAddress.street" name="streetAddress" label="SALAXY.NG1.InsuranceComponent.common.streetAddress" label-type="basic"></salaxy-input>
      </div>
      <div class="col-sm-4">
        <salaxy-input ng-model="$ctrl.current.company.principalBusinessAddress.postalCode" name="postalCode" label="SALAXY.NG1.InsuranceComponent.common.postalCode" label-type="basic"></salaxy-input>
      </div>
      <div class="col-sm-4">
        <salaxy-input ng-model="$ctrl.current.company.principalBusinessAddress.city" name="city" label="SALAXY.NG1.InsuranceComponent.common.city" label-type="basic"></salaxy-input>
      </div>
      <div class="col-sm-4">
        <salaxy-input-enum options="$ctrl.countryCodes" ng-model="$ctrl.current.company.principalBusinessAddress.countryCode" name="country" label="SALAXY.NG1.InsuranceComponent.common.country" label-type="basic" disable-cache="true"></salaxy-input>
      </div>
    </div>
  </fieldset>

</form>`), s.put("salaxy-components/modals/localTapiola/ContactInfo.html", `<form name="currentForm" class="form-horizontal" ng-model="temp">

  <span class="d-none">{{ $ctrl.formDataValidity = currentForm.$valid }}</span>

  <div class="text-center intro-col">
    <h1>{{ $ctrl.currentStep.title }}</h1>
    <h2 class="subtitle" ng-if="$ctrl.currentStep.heading != ''">{{ $ctrl.currentStep.heading }}
    </h2>
    <p class="intro">
      <span ng-if="$ctrl.action == 'moveInsurance'" sxy-text="SALAXY.NG1.InsuranceComponent.contactInfo.moveInsuranceInfo"></span>
    </p>
  </div>


  <div class="content row">
    <div class="col-12 col-sm-6">
      <fieldset>
        <legend>Yrityksen tiedot</legend>
        <salaxy-input ng-model="$ctrl.current.company.details.avatar.displayName" name="companyName" label="SALAXY.NG1.InsuranceComponent.common.companyName" readonly="true" label-type="basic"> </salaxy-input>
        <salaxy-input ng-model="$ctrl.current.company.details.officialId" name="vatNumber" label="SALAXY.NG1.InsuranceComponent.common.vatNumber" readonly="true" label-type="basic"></salaxy-input>
        <salaxy-input ng-model="$ctrl.current.company.address.street" name="streetAddress" label="SALAXY.NG1.InsuranceComponent.common.streetAddress" readonly="true" label-type="basic"></salaxy-input>
        <salaxy-input ng-model="$ctrl.current.company.address.postalCode" name="postalCode" label="SALAXY.NG1.InsuranceComponent.common.postalCode" readonly="true" label-type="basic"></salaxy-input>
        <salaxy-input ng-model="$ctrl.current.company.address.city" name="city" label="SALAXY.NG1.InsuranceComponent.common.city" readonly="true" label-type="basic"></salaxy-input>
      </fieldset>
      <fieldset>
        <legend sxy-html="SALAXY.NG1.InsuranceComponent.principalBusinessAddress.label.html"></legend>
        <button class="btn btn-lt btn-xs btn-secondary" ng-click="$ctrl.current.company.hasPrincipalBusinessAddress = !$ctrl.current.company.hasPrincipalBusinessAddress"><i class="bi" style="margin-right:5px" ng-class="!$ctrl.current.company.hasPrincipalBusinessAddress ? 'bi bi-plus-lg' : 'bi-x-lg'"></i> <span ng-if="!$ctrl.current.company.hasPrincipalBusinessAddress" sxy-text="SALAXY.NG1.InsuranceComponent.common.addAddressBtn"></span><span ng-if="$ctrl.current.company.hasPrincipalBusinessAddress"  sxy-text="SALAXY.UI_Terms.cancelAlt">Peru</span></button>

        <div ng-if="$ctrl.current.company.hasPrincipalBusinessAddress">
          <salaxy-input ng-model="$ctrl.current.company.principalBusinessAddress.street" name="streetAddress" label="SALAXY.NG1.InsuranceComponent.common.streetAddress" label-type="basic"></salaxy-input>
          <salaxy-input ng-model="$ctrl.current.company.principalBusinessAddress.postalCode" name="postalCode" label="SALAXY.NG1.InsuranceComponent.common.postalCode" label-type="basic"></salaxy-input>
          <salaxy-input ng-model="$ctrl.current.company.principalBusinessAddress.city" name="city" label="SALAXY.NG1.InsuranceComponent.common.city" label-type="basic"></salaxy-input>
          <salaxy-input-typeahead options="$ctrl.countryCodes" ng-model="$ctrl.current.company.principalBusinessAddress.countryCode" name="country" label="SALAXY.NG1.InsuranceComponent.common.country" label-type="basic"></salaxy-typeahead>
        </div>
      </fieldset>

    </div>
    <div class="col-12 col-sm-6">
      <fieldset>
        <legend sxy-text="SALAXY.NG1.InsuranceComponent.common.insuranceContactPerson"></legend>
        <salaxy-input ng-model="$ctrl.current.company.contactPerson.avatar.displayName" name="contactName" label="SALAXY.NG1.InsuranceComponent.common.name" required label-type="basic"></salaxy-input>
        <salaxy-input ng-model="$ctrl.current.company.contactPerson.officialId" name="contactSSNumber" label="SALAXY.NG1.InsuranceComponent.common.ssNumber" required sxy-personal-id-fi label-type="basic"></salaxy-input>
        <salaxy-input ng-model="$ctrl.current.company.contactPerson.telephone" name="contactTelephone" label="SALAXY.NG1.InsuranceComponent.common.telephone" required sxy-mobile-phone label-type="basic"></salaxy-input>
        <salaxy-input ng-model="$ctrl.current.company.contactPerson.email" name="contactEmail" label="SALAXY.NG1.InsuranceComponent.common.email" required sxy-email label-type="basic"> </salaxy-input>
        <salaxy-input-enum type="select" ng-model="$ctrl.current.company.contactPerson.authorizationType" options="{procuration: ('SALAXY.NG1.InsuranceComponent.enums.procurationEnum' | sxyTranslate), powerOfAttorney: ('SALAXY.NG1.InsuranceComponent.enums.powerOfAttorneyEnum' | sxyTranslate), apparentAuthority: ('SALAXY.NG1.InsuranceComponent.enums.apparentAuthorityEnum' | sxyTranslate), other: ('SALAXY.NG1.InsuranceComponent.enums.otherEnum' | sxyTranslate)}"
          name="DelegateType" enum="DelegateType" label="SALAXY.NG1.InsuranceComponent.common.procura" required label-type="basic"></salaxy-input-enum>
      </fieldset>
    </div>
  </div>


</form>`), s.put("salaxy-components/modals/localTapiola/Entrepreneur.html", `<form name="currentForm" class="form-horizontal" ng-model="temp">

  <span class="d-none">{{ $ctrl.formDataValidity = currentForm.$valid }}</span>

  <div class="text-center intro-col">
    <h1>{{ $ctrl.currentStep.title }}</h1>
    <h2 class="subtitle" ng-if="$ctrl.currentStep.heading != ''">{{ $ctrl.currentStep.heading }}
      </h23>
      <p class="intro" ng-if="$ctrl.currentStep.intro != ''">{{ $ctrl.currentStep.intro }}
      </p>
  </div>
  <fieldset>
    <legend sxy-text="SALAXY.NG1.InsuranceComponent.entrepreneur.companyInfo"></legend>
    <div class="row">
      <div class="col-sm-8">
        <salaxy-input ng-model="$ctrl.current.company.details.avatar.displayName" name="companyName" label="SALAXY.NG1.InsuranceComponent.common.companyName" readonly="true" label-type="basic"> </salaxy-input>
      </div>
      <div class="col-sm-4">
        <salaxy-input ng-model="$ctrl.current.company.details.officialId" name="vatNumber" label="SALAXY.NG1.InsuranceComponent.common.vatNumber" readonly="true" label-type="basic" sxy-company-id-fi></salaxy-input>
      </div>
    </div>
  </fieldset>
  <fieldset>
    <legend sxy-text="SALAXY.NG1.InsuranceComponent.entrepreneur.entrepreneurInsuranceInfo"></legend>
    <div class="row" ng-repeat="item in $ctrl.current.items">
      <div class="col-sm-8">
        <salaxy-input ng-model="item.insuredName" name="entrepreneurName{{$index}}" label="SALAXY.NG1.InsuranceComponent.entrepreneur.entrepreneurName" required label-type="basic"></salaxy-input>
      </div>
      <div class="col-sm-4">
        <salaxy-input ng-model="item.insuredOfficialId" name="entrepreneurSSNumber{{$index}}" label="SALAXY.NG1.InsuranceComponent.common.ssNumber" required label-type="basic" sxy-personal-id-fi></salaxy-input>
      </div>
      <div class="col-sm-8">
        <salaxy-input-enum type="select" ng-model="item.orderType" options="{newEntrepreneurInsurance: ('SALAXY.NG1.InsuranceComponent.entrepreneur.newEntrepreneurInsuranceEnum' | sxyTranslate), moveEntrepreneurInsurance: ('SALAXY.NG1.InsuranceComponent.entrepreneur.moveEntrepreneurInsuranceEnum' | sxyTranslate)}"
          name="InsuranceOrder{{$index}}" enum="InsuranceOrder" label="SALAXY.NG1.InsuranceComponent.entrepreneur.insuranceLabel" required label-type="basic"></salaxy-input-enum>
      </div>
      <div class="col-sm-4">
        <salaxy-input ng-if="item.orderType == 'moveEntrepreneurInsurance'" ng-model="item.oldInsuranceCompany" label="SALAXY.NG1.InsuranceComponent.common.oldInsuranceCompany" name="insuranceCompany{{$index}}" label-type="basic" required></salaxy-input>
      </div>

      <div class="col-sm-8">
        <salaxy-datepicker-popup ng-if="item.orderType == 'newEntrepreneurInsurance'" ng-model="item.startDate" name="insuranceForEntrepreneurStartDate{{$index}}" placeholder="pp.kk.vvvv" label="SALAXY.NG1.InsuranceComponent.common.startDate"
          min-date="$ctrl.today" label-type="basic" tooltip-html="{{'SALAXY.NG1.InsuranceComponent.common.startDateToolTip' | sxyTranslate}}" require="true"></salaxy-datepicker-popup>
        <salaxy-input-enum ng-if="item.orderType == 'moveEntrepreneurInsurance'" label="SALAXY.NG1.InsuranceComponent.common.startDate" type="select" options="$ctrl.insuranceStartingPointDateOptions" placeholder="SALAXY.UI_Terms.select" ng-model="item.startDate"
          name="insuranceMoveForEntrepreneurStartDate{{$index}}" label-type="basic" required></salaxy-input-enum>
      </div>
      <div class="col-sm-4">
        <salaxy-input-enum label="SALAXY.NG1.InsuranceComponent.common.billingInterval" options="{1:'1', 2:'2', 3:'3', 4:'4'}" ng-model="item.billingInterval" name="billing{{$index}}" label-type="basic" required></salaxy-input-enum>
      </div>


      <div class="col-sm-8">
        <salaxy-input-occupation-type name="occupationType{{$index}}" ng-model="item.occupations[0].occupationCode" label="SALAXY.NG1.InsuranceComponent.common.occupationCode" label-type="basic" required></salaxy-input-occupation-type>
      </div>
      <div class="col-sm-4 ">
        <salaxy-input ng-model="item.occupations[0].estimatedIncome" name="YELincome{{$index}}" label="SALAXY.NG1.InsuranceComponent.entrepreneur.estimatedIncome" label-type="basic" required></salaxy-input>
      </div>
      <div class="col-12 text-end">
        <button class="btn-lt btn-sm btn-danger" ng-click="$ctrl.current.items.splice($index,1)"><i class="bi bi-trash-fill"></i> <span sxy-text="SALAXY.UI_Terms.delete"></span></button>
      </div>
      <div class="col-12">
        <hr>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <button class="btn btn-lt btn-secondary btn-sm" ng-click="$ctrl.current.items.push({ occupations: [{}]})"><i class="bi bi-plus-lg" style="margin-right:5px"></i> {{'SALAXY.NG1.InsuranceComponent.entrepreneur.addEntrepreneur' | sxyTranslate}}</button>
      </div>
    </div>
  </fieldset>

</form>`), s.put("salaxy-components/modals/localTapiola/InsuranceInfo-move.html", `<form name="currentForm" class="form-horizontal" ng-model="temp">

  <span class="d-none">{{ $ctrl.formDataValidity = currentForm.$valid }}</span>

  <div class=" text-center intro-col">
    <h1>{{ $ctrl.currentStep.title }}</h1>
    <h2 class="subtitle" ng-if="$ctrl.currentStep.heading != ''">{{ $ctrl.currentStep.heading }}
    </h2>
    <p class="intro" sxy-text="SALAXY.NG1.InsuranceComponent.insuranceMove.intro" ps="."></p>
  </div>

  <div class="row">
    <div class="col-sm-6">
      <salaxy-input-enum label="SALAXY.NG1.InsuranceComponent.common.startDate" type="select" options="$ctrl.insuranceStartingPointDateOptions" placeholder="SALAXY.UI_Terms.select" ng-model="$ctrl.current.items[0].startDate" name="insuranceStartDate" label-type="basic"
        required></salaxy-input-enum>
    </div>
    <div class="col-sm-6">
      <salaxy-input-enum label="SALAXY.NG1.InsuranceComponent.common.billingInterval" options="{1:'1', 2:'2', 3:'3', 4:'4'}" ng-model="$ctrl.current.items[0].billingInterval" name="billing" label-type="basic" required></salaxy-input-enum>
    </div>
    <div class="col-sm-6">
      <salaxy-input ng-model="$ctrl.current.items[0].oldInsuranceCompany" label="SALAXY.NG1.InsuranceComponent.common.oldInsuranceCompany" name="insuranceCompany" label-type="basic" required></salaxy-input>
    </div>
    <div class="col-sm-6">
      <salaxy-input ng-model="$ctrl.current.items[0].industry" name="industry" label="SALAXY.NG1.InsuranceComponent.common.industry.label" label-type="basic" required tooltip-html="{{'SALAXY.NG1.InsuranceComponent.common.industry.html' | sxyTranslate}}" tooltip-placement="right"></salaxy-input>

    </div>
  </div>
  <div class="row" ng-repeat="item in $ctrl.current.items[0].occupations">
    <div class="col-sm-6">
      <salaxy-input-occupation-type name="occupationType" ng-model="item.occupationCode" label="SALAXY.NG1.InsuranceComponent.common.occupationCode" label-type="basic" required></salaxy-input-occupation-type>
    </div>
    <div class="col-sm-4 col-9">
      <salaxy-input ng-model="item.estimatedIncome" name="salary" label="SALAXY.NG1.InsuranceComponent.common.salaryLabel" sxy-currency label-type="basic" required></salaxy-input>
    </div>
    <div class="col-sm-2 col-3 text-end delete-row-col">
      <button class="btn btn-lt btn-danger btn-sm" ng-click="$ctrl.current.items[0].occupations.splice($index,1)"><i class="bi bi-trash-fill"></i> <span class="d-none d-sm-inline" sxy-text="SALAXY.UI_Terms.delete"></span></button>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <button class="btn btn-lt btn-secondary btn-sm" ng-click="$ctrl.current.items[0].occupations.push({})"><i class="bi bi-plus-lg" style="margin-right:5px"></i> {{'SALAXY.NG1.InsuranceComponent.common.addOccupation' | sxyTranslate}}</button>
    </div>
  </div>


</form>`), s.put("salaxy-components/modals/localTapiola/InsuranceInfo-new.html", `<form name="currentForm" class="form-horizontal" model="temp">
  <span class="d-none">{{ $ctrl.formDataValidity = currentForm.$valid }}</span>
  <div class="text-center intro-col">
    <h1>{{ $ctrl.currentStep.title }}</h1>
    <h2 class="subtitle" ng-if="$ctrl.currentStep.heading != ''">{{ $ctrl.currentStep.heading }}
    </h2>
    <p class="intro" ng-if="$ctrl.currentStep.intro != ''">{{ $ctrl.currentStep.intro }}</p>
  </div>
  <div class="row">
    <div class="col-md-5">
      <salaxy-datepicker-popup ng-model="$ctrl.current.items[0].startDate" placeholder="pp.kk.vvvv" name="insuranceStartDate" label="SALAXY.NG1.InsuranceComponent.common.startDate" min-date="$ctrl.today"
        label-type="basic" require="true" tooltip-html="{{'SALAXY.NG1.InsuranceComponent.common.startDateToolTip' | sxyTranslate}}"></salaxy-datepicker-popup>
    </div>
    <div class="col-md-4">
      <salaxy-input-enum label="SALAXY.NG1.InsuranceComponent.common.billingInterval" options="{1:'1', 2:'2', 3:'3', 4:'4'}" ng-model="$ctrl.current.items[0].billingInterval" name="billing" label-type="basic" required></salaxy-input-enum>
    </div>
    <div class="col-md-3">
      <salaxy-input ng-model="$ctrl.current.items[0].industry" name="industry" label="SALAXY.NG1.InsuranceComponent.common.industry.label" label-type="basic" required tooltip-html="{{'SALAXY.NG1.InsuranceComponent.common.industry.html' | sxyTranslate}}" tooltip-placement="top-right"></salaxy-input>
    </div>
  </div>
  <div class="row" ng-repeat="item in $ctrl.current.items[0].occupations">
    <div class="col-md-6">
      <salaxy-input-occupation-type name="occupationType" ng-model="item.occupationCode" label="SALAXY.NG1.InsuranceComponent.common.occupationCode" label-type="basic" required></salaxy-input-occupation-type>
    </div>
    <div class="col-md-4 col-9">
      <salaxy-input ng-model="item.estimatedIncome" name="salary" label="SALAXY.NG1.InsuranceComponent.common.salaryLabel" sxy-currency label-type="basic" required></salaxy-input>
    </div>
    <div class="col-md-2 col-3 text-end delete-row-col">
      <button class="btn-lt btn-danger btn-sm" ng-click="$ctrl.current.items[0].occupations.splice($index,1)"><i class="bi bi-trash-fill" ></i> <span class="d-none d-sm-inline" sxy-text="SALAXY.UI_Terms.delete"></span></button>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <button class="btn btn-lt btn-secondary btn-sm" ng-click="$ctrl.current.items[0].occupations.push({})"><i class="bi bi-plus-lg" style="margin-right:5px"></i> {{'SALAXY.NG1.InsuranceComponent.common.addOccupation' | sxyTranslate}}</button>
    </div>
  </div>
</form>`), s.put("salaxy-components/modals/localTapiola/Owner-info.html", `<form name="currentForm" class="form-horizontal" model="temp">
  <span class="d-none">{{ $ctrl.formDataValidity = currentForm.$valid }}</span>

  <div class="text-center intro-col">
    <h1>{{ $ctrl.currentStep.title }}</h1>
    <h2 class="subtitle" ng-if="$ctrl.currentStep.heading != ''">{{ $ctrl.currentStep.heading }}
    </h2>
    <p class="intro" sxy-text="SALAXY.NG1.InsuranceComponent.ownerInfo.intro" ps="."></p>
    <p sxy-text="SALAXY.NG1.InsuranceComponent.ownerInfo.introInfo" ps="."></p>
  </div>



  <fieldset>
    <legend sxy-text="SALAXY.NG1.InsuranceComponent.ownerInfo.ownerInfo"></legend>

    <div class="row" ng-repeat="item in $ctrl.current.company.owners">
      <div class="col-sm-8">
        <salaxy-input ng-model="item.avatar.displayName" name="ownerName{{$index}}" label="SALAXY.NG1.InsuranceComponent.ownerInfo.displayName" label-type="basic"></salaxy-input>
      </div>
      <div class="col-sm-4">
        <salaxy-input ng-model="item.officialId" name="ownerPersonalId{{$index}}" label="SALAXY.NG1.InsuranceComponent.ownerInfo.officialId" label-type="basic"></salaxy-input>
      </div>
      <div class="col-sm-8">
        <salaxy-input ng-model="item.address" name="ownerAddress{{$index}}" label="SALAXY.NG1.InsuranceComponent.ownerInfo.address" label-type="basic"></salaxy-input>
      </div>
      <div class="col-sm-4">
        <salaxy-input ng-model="item.percentOfShares" name="ownerShare{{$index}}" label="SALAXY.NG1.InsuranceComponent.ownerInfo.percentOfShares" label-type="basic"></salaxy-input>
      </div>
      <div class="col-12 text-end">
        <button class="btn btn-lt btn-danger btn-sm" ng-click="$ctrl.current.company.owners.splice($index,1)"><i class="bi bi-trash-fill"></i> {{'SALAXY.UI_Terms.delete' | sxyTranslate}}</button>
      </div>
      <div class="col-12">
        <hr>
      </div>

    </div>

    <div class="row">
      <div class="col-12 ">
        <button class="btn btn-lt btn-secondary btn-sm" ng-click="$ctrl.current.company.owners.push({ avatar: {}})"><i class="bi bi-plus-lg" style="margin-right:5px"></i>{{'SALAXY.NG1.InsuranceComponent.ownerInfo.addOwner' | sxyTranslate}}</button>
      </div>
    </div>
  </fieldset>
  <fieldset>
    <legend sxy-text="SALAXY.NG1.InsuranceComponent.ownerInfo.additionalOwnerInfo"></legend>
    <salaxy-input-boolean ng-model="$ctrl.current.company.complexOwnerStructure" label-type="no-label" name="additionalOwnerInfo" type="checkbox" label-true="SALAXY.NG1.InsuranceComponent.ownerInfo.additionalOwnerInfoLabel"></salaxy-input-boolean>
  </fieldset>

</form>`), s.put("salaxy-components/modals/localTapiola/Start.html", `<div class="row row-video">
  <div class="col-sm-6">
    <h1 class="text-center" sxy-text="SALAXY.NG1.InsuranceComponent.start.wizard.title2"></h1>
  </div>
  <div class="col-sm-6" class="text-center">
    <div class="video-wrapper">
      <div class="videoWrapper">
        <iframe src="https://www.youtube.com/embed/LDuzMEsPz4o" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-12 mb-2">
    <h2 class="start-subtitle text-center" sxy-text="SALAXY.NG1.InsuranceComponent.start.heading"></h2>
    <p class="text-center" sxy-text="SALAXY.NG1.InsuranceComponent.start.infoText" ps="."></p>
  </div>
  <div class="col-12 col-sm-6 text-center mb-2">
    <button type="button" class="btn btn-lt btn-primary btn-sm" ng-click="$ctrl.setInsuranceAction('newInsurance'); $ctrl.goNext()" sxy-text="SALAXY.NG1.InsuranceComponent.start.newInsurance"></button>
  </div>
  <div class="col-12 col-sm-6 text-center mb-2">
    <button type="button" class="btn btn-lt btn-primary btn-sm" ng-click="$ctrl.setInsuranceAction('moveInsurance'); $ctrl.goNext()" sxy-text="SALAXY.NG1.InsuranceComponent.start.moveInsurance"></button>
  </div>
  <div class="col-12 text-center mb-2">
    <button type="button" class="btn btn-lt btn-primary btn-sm" ng-click="$ctrl.setInsuranceAction('newInsuranceForEntrepreneur'); $ctrl.goNext()" sxy-text="SALAXY.NG1.InsuranceComponent.start.newInsuranceForEntrepreneur"></button>
  </div>
</div>`), s.put("salaxy-components/modals/localTapiola/ThankYou.html", `<div class="text-center mb-2">
  <h1>
    {{ $ctrl.currentStep.title }}
  </h1>


  <p class="intro" sxy-text="SALAXY.NG1.InsuranceComponent.thankYou.intro" ps="."></p>

  <p ng-if="$ctrl.action == 'newInsurance' || $ctrl.action == 'moveInsurance'" sxy-html="SALAXY.NG1.InsuranceComponent.thankYou.notNewInsuranceForEntrepreneur.html"></p>
  <p ng-if="$ctrl.action == 'newInsuranceForEntrepreneur'" sxy-html="SALAXY.NG1.InsuranceComponent.thankYou.newInsuranceForEntrepreneur.html"></p>
</div>

<div class="row" ng-if="$ctrl.action == 'newInsurance' || $ctrl.action == 'moveInsurance'" style="margin-top:30px;">
  <div class="col-12 col-sm-6  mb-2 text-center">
    <button class="btn btn-lt btn-primary btn-sm" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
  </div>
  <div class="col-sm-6 mb-2 text-center">
    <button class="btn btn-lt btn-primary btn-sm" ng-click="$ctrl.setInsuranceAction('newInsuranceForEntrepreneur');  $ctrl.goNext()" sxy-text="SALAXY.NG1.InsuranceComponent.thankYou.newInsuranceForEntrepreneur.text"></button>
  </div>
</div>

<div class="row" ng-if="$ctrl.action == 'newInsuranceForEntrepreneur'" style="margin-top:30px;">
  <div class="col-12 col-sm-6 mb-2 text-center">
    <button class="btn btn-lt btn-primary btn-sm" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
  </div>
  <div class="col-sm-6 mb-2 text-center">
    <button class="btn btn-lt btn-primary btn-sm" ng-click="$ctrl.setInsuranceAction('newInsurance'); $ctrl.goNext()" sxy-text="SALAXY.NG1.InsuranceComponent.thankYou.notNewInsuranceForEntrepreneur.text"></button>
  </div>
</div>`), s.put("salaxy-components/modals/onboarding/company/company-legal.html", `\uFEFF<form name="companyLegalForm" class="form-horizontal">
  <!-- Updating formDataValidity to use in controller -->
  <span class="d-none">{{ wizard.formDataValidity = companyLegalForm.$valid && (wizard.showCompanySelection || wizard.model.signature.isProcura)}}</span>
  <div class="row">
    <div class="col-md-6">
      <legend sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyLegal.legalLegend"></legend>
      <div class="mb-4">
        <p>
          <span sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyLegal.pep" ps="*"></span>
          <i class="bi bi-info-circle-fill" type="button" data-bs-toggle="popover" data-bs-html="true" data-bs-title="'SALAXY.NG1.CompanyOnboardingComponent.stepCompanyLegal.pepTitle' | sxyTranslate" data-bs-content="'SALAXY.NG1.CompanyOnboardingComponent.stepCompanyLegal.pepPopOver' | sxyTranslate" data-bs-container="body"
            data-bs-placement="top" sxy-bs5-popover></i>
        </p>
        
        <salaxy-input-boolean type="radio" name="identityPep" label="" label-type="plain" label-true="SALAXY.UI_Terms.yes" label-false="SALAXY.UI_Terms.no" ng-model="wizard.model.signature.isPep" required></salaxy-input-boolean>
      </div>
      <div ng-if="wizard.model.company.companyType != 'fiRy'" class="mb-4">
        <p>
          <span sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyLegal.owner" ps="*"></span>
          <i class="bi bi-info-circle-fill" type="button" data-bs-toggle="popover" data-bs-html="true" data-bs-title="'SALAXY.NG1.CompanyOnboardingComponent.stepCompanyLegal.ownerTitle' | sxyTranslate" data-bs-content="'SALAXY.NG1.CompanyOnboardingComponent.stepCompanyLegal.ownerPopOver' | sxyTranslate" data-bs-container="body"
            data-bs-placement="top" sxy-bs5-popover></i>
        </p>
        <salaxy-input-boolean type="radio" name="Ownership.IsRequiredTracking" label="" label-type="plain" label-true="SALAXY.UI_Terms.yes" label-false="SALAXY.UI_Terms.no" ng-model="wizard.model.company.ownership.isRequiredTracking" required></salaxy-input-boolean>

      </div>
      <div ng-if="!wizard.showCompanySelection" class="mb-4">
        <p>
          <span sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyLegal.procura" ps="*"></span>
          <i class="bi bi-info-circle-fill" type="button" data-bs-toggle="popover" data-bs-html="true" data-bs-title="'SALAXY.NG1.CompanyOnboardingComponent.stepCompanyLegal.procuraTitle' | sxyTranslate" data-bs-content="'SALAXY.NG1.CompanyOnboardingComponent.stepCompanyLegal.procuraPopOver' | sxyTranslate" data-bs-container="body"
            data-bs-placement="top" sxy-bs5-popover></i>
           
        </p>
        <salaxy-input-boolean type="radio" name="procuraOptions" label="" label-type="plain" label-true="SALAXY.UI_Terms.yes" label-false="SALAXY.UI_Terms.no" ng-model="wizard.model.signature.isProcura" required></salaxy-input-boolean>
        <br />
        <div ng-if="!wizard.model.signature.isProcura" class="alert alert-danger">
          <p sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyLegal.procuraText"></p>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div ng-if="!wizard.model.company.ownership.isRequiredTracking">
        <legend sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyLegal.fiva"></legend>
        <p sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyLegal.fivaText"></p>
      </div>
      <div ng-if="wizard.model.company.ownership.isRequiredTracking">
        <fieldset class="form-horizontal">
          <legend sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyLegal.shareHolderTitle"></legend>
          <p sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyLegal.shareHolderText" ps=":"></p>
          <salaxy-input type="text" name="shareholder1" label="{{'SALAXY.NG1.CompanyOnboardingComponent.stepCompanyLegal.shareHolder' | sxyTranslate}} 1" label-cols="col-sm-4 col-md-3 col-lg-4" ng-model="wizard.model.company.ownership.shareHolders[0].name" require="true"></salaxy-input>
          <salaxy-input type="text" name="shareholder2" label="{{'SALAXY.NG1.CompanyOnboardingComponent.stepCompanyLegal.shareHolder' | sxyTranslate}} 2" label-cols="col-sm-4 col-md-3 col-lg-4" ng-model="wizard.model.company.ownership.shareHolders[1].name">
          </salaxy-input>
          <salaxy-input type="text" name="shareholder3" label="{{'SALAXY.NG1.CompanyOnboardingComponent.stepCompanyLegal.shareHolder' | sxyTranslate}} 3" label-cols="col-sm-4 col-md-3 col-lg-4" ng-model="wizard.model.company.ownership.shareHolders[2].name">
          </salaxy-input>
          <salaxy-input type="text" name="shareholder4" label="{{'SALAXY.NG1.CompanyOnboardingComponent.stepCompanyLegal.shareHolder' | sxyTranslate}} 4" label-cols="col-sm-4 col-md-3 col-lg-4" ng-model="wizard.model.company.ownership.shareHolders[3].name">
          </salaxy-input>
        </fieldset>
      </div>
    </div>
  </div>
</form>`), s.put("salaxy-components/modals/onboarding/company/company.html", `\uFEFF<form name="companyForm" class="form-horizontal">
  <!-- Updating formDataValidity to use in controller -->
  <span class="d-none">{{ wizard.formDataValidity = companyForm.$valid && ( wizard.showCompanySelection || (wizard.model.company.resolvedId == (sessionCtrl.session.hasCurrentAccount ? sessionCtrl.session.currentAccount.id:null)))}}</span>
  <div class="">
    <br />
    <p>{{wizard.currentStep.intro | sxyTranslate}}</p>
    <br />
  </div>
  <div>
    <div class="alert alert-danger" ng-if="wizard.showCompanySelection && wizard.existingCompanyAlert">
      <p sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.existingCompanyAlert"></p>
      <p>
        <a ng-href="{{wizard.model.ui.successUrl}}" sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.loginLink"></a>
      </p>
    </div>
  </div>
  <div ng-if="!wizard.showCompanySelection && ( wizard.model.company.resolvedId != (sessionCtrl.session.hasCurrentAccount ? sessionCtrl.session.currentAccount.id:null))">
    <div class="alert alert-danger">
      <p sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.existingBusinessIdAlert" params="{businessId: wizard.model.company.businessId}"></p>
      <p>
        <a ng-href="{{wizard.model.ui.successUrl}}" sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.loginLink2"></a>
      </p>
      <p sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.existingBusinessIdAlert2"></p>
    </div>
  </div>
  <div class="row">

    <div ng-if="wizard.showCompanySelection" class="col-md-6">
      <legend sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyInfo"></legend>
      <salaxy-input readonly="true" label="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyBusinessId" name="businessId" ng-model="wizard.model.company.businessId" tooltip-html="Tarvitset käyttäjätilin luomiseen Y-tunnuksen. Jos käytät palveluamme yhdistyksen palkanmaksuun, yhdistyksellä on oltava Y-tunnus. Yhdistys voi hakea Y-tunnuksen tekemällä perustamisilmoituksen Verohallintoon (lomakkeella Y1)." ng-required="true"></salaxy-input>
      <salaxy-input salaxy-if-role="!test" readonly="true" label="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyName" name="name" ng-model="wizard.model.company.name" ng-required="true"></salaxy-input>
      <salaxy-input salaxy-if-role="test" label="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyName" name="name" ng-model="wizard.model.company.name" ng-required="true"></salaxy-input>
      <div class="row mb-2" salaxy-if-role="!test">
        <label for="Yritysmuoto" class="col-sm-4 control-label" style="text-align:left">
          <span sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyType" ps="*"></span>
        </label>
        <div class="col-sm-8">
          <input type="text" class="form-control" id="Yritysmuoto" name="Yritysmuoto" placeholder="{{'SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyType' | sxyTranslate | lowercase}}" readonly="true" autocomplete="off" value="{{ !wizard.model.company.companyType ? '' : ('SALAXY.ENUM.CompanyType.' + wizard.model.company.companyType +'.label' | sxyTranslate) }}"/>
        </div>
      </div>
      <salaxy-input-enum salaxy-if-role="test" label="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyType" name="companyType" ng-model="wizard.model.company.companyType" enum="CompanyType" type="select" placeholder="SALAXY.UI_Terms.select" ng-required="true"></salaxy-input-enum>
    </div>

    <div ng-if="!wizard.showCompanySelection" class="col-md-6">
      <legend sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyInfo"></legend>
      <div class="row mb-2">
        <label for="businessId" class="col-sm-4 col-md-3 col-lg-4 control-label" style="text-align: left">
         <span sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyBusinessId" ps="*"></span>
          <i class="bi bi-info-circle-fill" 
            type="button" 
            data-bs-toggle="popover" 
            data-bs-html="true" 
            data-bs-title="'SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyBusinessId' | sxyTranslate" 
            data-bs-content="'SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.businessIdPopOver' | sxyTranslate" 
            data-bs-container="body" 
            data-bs-placement="top" sxy-bs5-popover>
          </i>
        </label>
        <div class="col-sm-8 col-md-9 col-lg-8">
          <div class="input-group">
            <input ng-disabled="sessionCtrl.session.hasCurrentAccount" type="text" id="businessId" class="form-control" ng-model="wizard.model.company.businessId" sxy-company-id-fi ng-required="true">
            <div class="input-group-btn">
              <button 
                ng-disabled="sessionCtrl.session.hasCurrentAccount" 
                ng-click="wizard.searchYtj('businessId')" 
                class="btn btn-default form-control" 
                type="button" 
                data-bs-toggle="popover" 
                data-bs-html="true" 
                data-bs-title="'SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.ytjSearchTitle' | sxyTranslate" 
                data-bs-content="'SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.ytjPopOver' | sxyTranslate" 
                data-bs-container="body" 
                data-bs-placement="top" 
                data-bs-trigger="hover"
                sxy-bs5-popover>
                <span sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.ytjSearchBtn"></span>
                <span class="d-none d-md-inline" sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.ytjSearchBtn2"></span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="row mb-2">
        <label for="name" class="col-sm-4 col-md-3 col-lg-4 control-label" style="text-align: left" sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyName" ps="*"></label>
        <div class="col-sm-8 col-md-9 col-lg-8">
          <div class="input-group">
            <input ng-disabled="sessionCtrl.session.hasCurrentAccount" type="text" class="form-control" id="name" ng-model="wizard.model.company.name" ng-required="true">
            <div class="input-group-btn">
              <button 
                ng-disabled="sessionCtrl.session.hasCurrentAccount" 
                class="btn btn-default form-control" 
                type="button" 
                ng-click="wizard.searchYtj('name')"
                data-bs-toggle="popover" 
                data-bs-html="true" 
                data-bs-title="{{'SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.ytjSearchTitle' | sxyTranslate}}"
                data-bs-content="{{'SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.ytjPopOver' | sxyTranslate}}" 
                data-bs-container="body" 
                data-bs-placement="top"  
                data-bs-trigger="hover"
                sxy-bs5-popover>
                <span sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.ytjSearchBtn"></span>
                <span class="d-none d-md-inline" sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.ytjSearchBtn2"></span>
              </button>
            </div>
          </div>

        </div>
      </div>
      <!-- HUOM! Tästä kentästä on mobiiliversio edempänä koodissa -->
      <salaxy-input-enum class="d-none d-sm-block" label="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyType2" label-cols="col-sm-4 col-md-3 col-lg-4" enum="CompanyType" options="{'fiOy':('SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyTypeFiOy' | sxyTranslate),'fiTm':('SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyTypeFiTm' | sxyTranslate),'fiRy':('SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyTypeFiRy' | sxyTranslate),'fiYy':('SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyTypeFiYy' | sxyTranslate)}" name="companyType" ng-model="wizard.model.company.companyType" disabled="sessionCtrl.session.hasCurrentAccount" require="true"></salaxy-input-enum>
    </div>

    <!-- MOBIILIVERSIO YTJ haun tulokset/virheet -->
    <div ng-if="!wizard.showCompanySelection" class="d-sm-none col-12">
      <!--Näytetään y-tunnuksesta johtuvat virheet, jos niitä on -->
      <div ng-if="wizard.getValidationError('Company.BusinessId') && wizard.getValidationError('Company.BusinessId').type=='invalid'">
        <h3 sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.ytjSearchResultTitle" ps=":"></h3>
        <p>{{ wizard.getValidationError('Company.BusinessId').msg | sxyTranslate}}</p>
      </div>

      <div ng-if="wizard.model.company.ytjSearch != null">
        <h3>
          <span sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.ytjSearchResultTitle" ps=":"></span>
          <span ng-if="wizard.model.company.ytjSearch && wizard.model.company.ytjSearch.result.length != 0">
            ({{wizard.model.company.ytjSearch.result.length}} kpl)
          </span>
        </h3>
        <!--Näytetään ytj-hausta johtuvat virheet, jos niitä on -->
        <div ng-if="wizard.model.company.ytjSearch.userMessage != null">
          <p>{{ wizard.model.company.ytjSearch.userMessage }}</p>
        </div>
        <div ng-if="wizard.model.company.ytjSearch.isSuccess">
          <!--Näytetään että tiedot syötetty jos yrityksiä oli tasan yksi -->
          <div ng-if="wizard.model.company.ytjSearch.result.length == 1">
            <p sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.ytjSearchResultText"></p>
          </div>
          <!--Näytetään viestit jos yrityksiä on nolla-->
          <div ng-if="wizard.model.company.ytjSearch.result.length == 0 && wizard.model.validation.isOfficialIdValid">
            <p>{{wizard.model.company.ytjSearch.userMessage}}</p>
          </div>
          <div ng-if="wizard.model.company.ytjSearch.result.length != 0">
            <div class="accordion accordion-flush salaxy-accordion" id="companies">
              <div ng-repeat="company in wizard.model.company.ytjSearch.result track by $index" class="accordion-item">
                <h2 class="accordion-header">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#company{{$index}}">
                    {{company.name}}
                  </button>
                </h2>
                <div id="company{{$index}}" class="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#companies">
                  <div class="accordion-body">
                    <p>{{company.businessId}}<br /> {{company.type}} <br />
                      <button class="btn btn-primary" ng-click="wizard.chooseBusinessId(company.businessId)" sxy-text="SALAXY.UI_Terms.select"></button>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-6">
      <legend sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyContact"></legend>
      <salaxy-input label="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyStreet" name="Katuosoite" ng-model="wizard.model.company.contact.street" ng-required="true"></salaxy-input>
      <salaxy-input label="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyPostalCode" name="Postinumero" sxy-postal-code-fi ng-model="wizard.model.company.contact.postalCode" ng-required="true"></salaxy-input>
      <salaxy-input label="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyCity" name="Postitoimipaikka" ng-model="wizard.model.company.contact.city" ng-required="true"></salaxy-input>
      <salaxy-input label="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyEmail" name="Sahkoposti" ng-model="wizard.model.company.contact.email" ng-required="true" sxy-email></salaxy-input>
      <salaxy-input label="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyPhone" name="Puhelinnumero" ng-model="wizard.model.company.contact.telephone" ng-required="true" sxy-mobile-phone></salaxy-input>
      <!-- HUOM! Tästä kentästä on mobiiliversio ylempänä koodissa -->
      <div ng-if="!wizard.showCompanySelection" class="d-block d-sm-none">
        <salaxy-input-enum label="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyType2" label-cols="col-sm-4 col-md-3 col-lg-4" enum="CompanyType" options="{'fiOy':('SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyTypeFiOy' | sxyTranslate),'fiTm':('SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyTypeFiTm' | sxyTranslate),'fiRy':('SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyTypeFiRy' | sxyTranslate),'fiYy':('SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyTypeFiYy' | sxyTranslate)}"
          name="companyTypeMobile" ng-model="wizard.model.company.companyType" disabled="sessionCtrl.session.hasCurrentAccount" require="true"></salaxy-input-enum>
      </div>
    </div>

    <!-- YTJ haun tulokset/virheet -->
    <div ng-if="!wizard.showCompanySelection" class="d-none d-sm-block col-12">
      <!-- Näytetään y-tunnuksesta johtuvat virheet, jos niitä on -->
      <div ng-if="wizard.getValidationError('Company.BusinessId') && wizard.getValidationError('Company.BusinessId').type=='invalid'">
        <h3 sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.ytjSearchResultTitle" ps=":"></h3>
        <p>{{ wizard.getValidationError('Company.BusinessId').msg | sxyTranslate}}</p>
      </div>

      <div ng-if="wizard.model.company.ytjSearch != null">
        <h3>
          <span sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.ytjSearchResultTitle" ps=":"></span>
          <span ng-if="wizard.model.company.ytjSearch && wizard.model.company.ytjSearch.result.length != 0">
            ({{wizard.model.company.ytjSearch.result.length}} kpl)
          </span>
        </h3>
        <!--Näytetään ytj-hausta johtuvat virheet, jos niitä on -->
        <div ng-if="wizard.model.company.ytjSearch.userMessage != null">
          <p>{{ wizard.model.company.ytjSearch.userMessage }}</p>
        </div>


        <!-- Haku onnistui -->
        <div ng-if="wizard.model.company.ytjSearch.isSuccess">
          <!--Näytetään viestit jos yrityksiä on nolla-->
          <div ng-if="wizard.model.company.ytjSearch.result.length == 0 && wizard.model.validation.isOfficialIdValid">
            <p>{{wizard.model.company.ytjSearch.userMessage}}</p>
          </div>
          <div ng-if="wizard.model.company.ytjSearch.result.length != 0" class="table-responsive" style="max-height: 300px; overflow-y: auto;">

            <table class="table table-hover table-bordered" style="overflow-wrap: break-word">
              <thead>
                <tr>
                  <th>
                    <span sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyName2"></span>
                    <br />
                    <span sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyBusinessId"></span>
                  </th>
                  <th class="d-none d-sm-table-cell" sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepCompanyInfo.companyType"></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr ng-repeat="company in wizard.model.company.ytjSearch.result">
                  <td>
                    {{company.name}}
                    <br /> {{company.businessId}}
                  </td>
                  <td class="d-none d-sm-table-cell">{{company.type}}</td>
                  <td>
                    <a class="btn btn-primary" ng-click="wizard.chooseBusinessId(company.businessId)" sxy-text="SALAXY.UI_Terms.select"></a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>`), s.put("salaxy-components/modals/onboarding/company/contract.html", `\uFEFF<form name="contractForm">
  <span class="d-none">{{ wizard.formDataValidity = contractForm.$valid}}</span>
  <p sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepContract.signatureText"></p>

  <p ng-if="wizard.showCompanySelection" sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepContract.selectBankText"></p>
  </p>

  <div class="row" ng-controller="SignatureController as sign">
    <div class="col-md-6">
      <fieldset ng-if="!wizard.showCompanySelection">
        <legend sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepContract.yourPersonalId"></legend>
        <div>
          <salaxy-input name="personalId" label-type="plain" type="text" style="width:150px" placeholder="SALAXY.NG1.CompanyOnboardingComponent.stepContract.personalIdExample" ng-model="wizard.model.signature.personalId" require="true" sxy-personal-id-fi></salaxy-input>
        </div>

      </fieldset>
      <div class="mb-2">
        <input ng-init="wizard.model.signature.terms = false" name="terms" type="checkbox" require="true" ng-model="wizard.model.signature.terms"></input>
        <span sxy-html="SALAXY.NG1.CompanyOnboardingComponent.stepContract.termsText.html"></span>
        <a ng-href="{{ wizard.getPdfPreviewAddress() }}" target="_blank" sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepContract.termsText2"></a> <span sxy-html="SALAXY.NG1.CompanyOnboardingComponent.stepContract.termsText3.html"></span>
      </div>

      <fieldset>
        <div ng-if="wizard.model.accountType == 'company'">
          <p sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepContract.usePersonalBank"></p>
        </div>
        <p sxy-html="SALAXY.NG1.CompanyOnboardingComponent.stepContract.privacyPolicy.html"></p>
        <div sxy-if-role="test">
          <h3>TEST: Huomaa HETU:sta!</h3>
          <p class="text-warning">
            Allekirjoitus ohjaa nyt testiympäristöön, jossa
            <strong>HETU tarkistetaan</strong>.
            Katso testiympäristön
            <a href="https://gist.github.com/ykarikos/e43e567eb7b9e05432d4bd9d0b51ef35" target="_blank">HETU:t täältä</a>
            (valitse validi hetu).
          </p>
        </div>
      </fieldset>
    </div>

    <div class="col-md-6 d-none d-sm-block">
      <fieldset>
        <legend sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepContract.pdfPreviewTitle"></legend>
        <small><a ng-href="{{ wizard.getPdfPreviewAddress() }}" target="_blank" sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepContract.downloadHereLink"></a></small>

        <iframe ng-src="{{ wizard.getPdfPreviewAddress() }}" style="width: 100%; height: 300px"></iframe>
      </fieldset>
    </div>
    <div class="col-md-6 d-block d-sm-none">
      <a ng-href="{{ wizard.getPdfPreviewAddress() }}" target="_blank" sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepContract.pdfPreviewLink"></a>
    </div>

  </div>

</form>`), s.put("salaxy-components/modals/onboarding/company/contractButtons.html", `\uFEFF<button ng-click="wizard.goPrevious()" ng-disabled="!wizard.canGoPrevious" class="btn btn-default" sxy-text="SALAXY.UI_Terms.previous"></button>
<div salaxy-loader class="spinner">
  <div class="bounce1"></div>
  <div class="bounce2"></div>
  <div class="bounce3"></div>
</div>

<button ng-if="wizard.model.signature.personalId == null || wizard.model.signature.terms == false" ng-disabled="true" class="btn btn-primary" sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepContract.signBtn"></button>
<a ng-if="!(wizard.model.signature.personalId == null || wizard.model.signature.terms == false)" ng-href="{{wizard.vismaSignUrl}}" target="_top" class="btn btn-primary" sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepContract.signBtn"></a>`), s.put("salaxy-components/modals/onboarding/company/defaultWizardButtons.html", `\uFEFF<button ng-click="wizard.goPrevious()" ng-disabled="!wizard.canGoPrevious" class="btn btn-default" sxy-text="SALAXY.UI_Terms.previous"></button>
<div salaxy-loader class="spinner">
  <div class="bounce1"></div>
  <div class="bounce2"></div>
  <div class="bounce3"></div>
</div>
<button ng-click="wizard.goNext()" ng-disabled="!wizard.canGoNext" class="btn btn-primary" sxy-text="SALAXY.UI_Terms.next"></button>`), s.put("salaxy-components/modals/onboarding/company/firstPageButtons.html", `\uFEFF<!--a ng-if="wizard.model.ui.cancelUrl" ng-href="{{wizard.model.ui.cancelUrl}}"  class="btn btn-default">Takaisin etusivulle</a-->
<button class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.backToFront"></button>
<div salaxy-loader class="spinner">
  <div class="bounce1"></div>
  <div class="bounce2"></div>
  <div class="bounce3"></div>
</div>
<button ng-click="wizard.goNext()" ng-disabled="!wizard.canGoNext" class="btn btn-primary" sxy-text="SALAXY.UI_Terms.next"></button>`), s.put("salaxy-components/modals/onboarding/company/index.html", `<div ng-controller="SessionController as sessionCtrl" class="company-onboarding">
  <div ng-controller="CompanyOnboardingController as wizard">
    <div ng-controller="NaviController as $naviCtrl">
      <div ng-if="!$naviCtrl.showFullPageLoader">
        <div class="modal-header bg-primary">
          <h2 class="modal-title" sxy-text="SALAXY.NG1.CompanyOnboardingComponent.modalTitle"></h2>
          <button type="button" class="btn-close btn-close-white" ng-click="$close('cancel')" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="d-block d-md-none">
            <h4><span sxy-text="SALAXY.NG1.CompanyOnboardingComponent.step"></span> {{wizard.currentStep.number}}/{{wizard.steps.length}}</h4>
          </div>
          <div class="salaxy-wizard">
            <div class="wizard-steps">
              <div class="wizard-step" ng-repeat="step in $ctrl.steps" ng-class="{'active': step.active, 'disabled': step.disabled}">
                <span class="salaxy-avatar">
                  <div class="wizard-icons-wrapper">
                    <i class="bi" ng-class="step.active ? 'bi-circle-fill' : 'bi-circle'"></i>
                    <i class="bi bi-circle-fill"></i>
                  </div>
                  <strong class="number">{{ step.number }}</strong>
                </span>
                <span class="step-text">{{ step.title | sxyTranslate }}</span>
              </div>
            </div>
            <div class="wizard-strikethrough"></div>
          </div>
          <ng-include src="wizard.currentStep.view"></ng-include>
        </div>
        <div class="modal-footer">
          <ng-include class="d-flex justify-content-between w-100" src="wizard.currentStep.buttonsView"></ng-include>
        </div>
      </div>
    </div>
  </div>
</div>`), s.put("salaxy-components/modals/onboarding/company/suomifi.html", `<form name="currentForm">
  <!-- Hidden ariable formDataValidity to use in controller -->
  <span class="d-none">{{ wizard.formDataValidity = currentForm.$valid }}</span>
  <div class="">
    <br />
    <p>{{wizard.currentStep.intro | sxyTranslate}}</p>
    <br />
  </div>
  <div class="row">
    <div class="col-md-6">
      <fieldset>
        <legend sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepSuomiFi.infoText"></legend>
        <div class="form-horizontal">
          <salaxy-input label="SALAXY.NG1.CompanyOnboardingComponent.stepSuomiFi.personalId" name="personalId" ng-model="wizard.model.signature.personalId" ng-required="true" sxy-personal-id-fi></salaxy-input>
        </div>
      </fieldset>
    </div>
    <div class="col-md-6">
      <img src="https://cdn.salaxy.com/ng1/img/onboarding/suomifi.png" class="img-responsive" alt="suomi.fi">
    </div>
  </div>
</form>`), s.put("salaxy-components/modals/onboarding/company/suomifiButtons.html", `\uFEFF<button ng-click="wizard.goPrevious()" ng-disabled="!wizard.canGoPrevious" class="btn btn-default" sxy-text="SALAXY.UI_Terms.previous"></button>
<div salaxy-loader class="spinner">
  <div class="bounce1"></div>
  <div class="bounce2"></div>
  <div class="bounce3"></div>
</div>
<button ng-click="wizard.goToSuomifi()" ng-disabled="!wizard.canGoNext" class="btn btn-primary" sxy-text="SALAXY.NG1.CompanyOnboardingComponent.stepSuomiFi.goToSuomiFiBtn"></button>`), s.put("salaxy-components/modals/onboarding/company/wizard_index.html", `\uFEFF<form name="currentForm" class="form-horizontal">
  <!-- Hidden ariable formDataValidity to use in controller -->
  <span class="d-none">{{ wizard.formDataValidity = currentForm.$valid }}</span>
  <div class="">
    <br />
    <p>{{wizard.currentStep.intro | sxyTranslate}}</p>
    <br />
  </div>
  <div class="row">
    <div class="col-md-6">
      <fieldset>
        <legend sxy-text="SALAXY.NG1.CompanyOnboardingComponent.step1.personInfo"></legend>
        <salaxy-input label="SALAXY.NG1.CompanyOnboardingComponent.step1.personFirstName" name="Etunimi" ng-model="wizard.model.person.firstName" ng-required="true"></salaxy-input>
        <salaxy-input label="SALAXY.NG1.CompanyOnboardingComponent.step1.personLastName" name="Sukunimi" ng-model="wizard.model.person.lastName" ng-required="true"></salaxy-input>
      </fieldset>
    </div>
    <div class="col-md-6">
      <fieldset>
        <legend sxy-text="SALAXY.NG1.CompanyOnboardingComponent.step1.personContact"></legend>
        <salaxy-input label="SALAXY.NG1.CompanyOnboardingComponent.step1.personEmail" name="Sahkoposti" ng-model="wizard.model.person.contact.email" ng-required="true" sxy-email></salaxy-input>
        <salaxy-input label="SALAXY.NG1.CompanyOnboardingComponent.step1.personPhone" name="Puhelinnumero" ng-model="wizard.model.person.contact.telephone" ng-required="true" sxy-mobile-phone></salaxy-input>
      </fieldset>
    </div>
  </div>
</form>`), s.put("salaxy-components/modals/onboarding/customer/buttons.html", `\uFEFF<button ng-click="wizard.goPrevious()" ng-disabled="!wizard.canGoPrevious" class="btn btn-default" sxy-text="SALAXY.UI_Terms.previous"></button>
<div salaxy-loader class="spinner">
  <div class="bounce1"></div>
  <div class="bounce2"></div>
  <div class="bounce3"></div>
</div>
<button ng-click="wizard.goNext()" ng-disabled="!wizard.canGoNext" class="btn btn-primary" sxy-text="SALAXY.UI_Terms.next"></button>`), s.put("salaxy-components/modals/onboarding/customer/commit-buttons.html", `<button ng-click="wizard.goPrevious()" ng-disabled="!wizard.canGoPrevious" class="btn btn-danger" sxy-text="SALAXY.UI_Terms.previous"></button>
<div salaxy-loader class="spinner">
  <div class="bounce1"></div>
  <div class="bounce2"></div>
  <div class="bounce3"></div>
</div>
<button ng-click="wizard.commit()" ng-disabled="!wizard.canGoNext" class="btn btn-primary" sxy-text="SALAXY.UI_Terms.next"></button>`), s.put("salaxy-components/modals/onboarding/customer/company-legal.html", `<form name="currentForm" class="form-horizontal">
  <span class="d-none">{{ wizard.formDataValidity = currentForm.$valid }}</span>
  <div class="row">
    <div class="col-12 col-md-6">
      <legend sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepCompanyLegal.legalTitle"></legend>
      <div class="mb-4">
        <p>
          <span sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepCompanyLegal.pep" ps="*"></span>
          <i class="bi bi-info-circle-fill"
            type="button" 
            data-bs-toggle="popover" 
            data-bs-html="true"
            data-bs-title="'SALAXY.NG1.CustomerOnboardingComponent.stepCompanyLegal.pepTitle' | sxyTranslate" 
            data-bs-content="'SALAXY.NG1.CustomerOnboardingComponent.stepCompanyLegal.pepPopOver' | sxyTranslate" 
            data-bs-container="body" 
            data-bs-placement="top" sxy-bs5-popover>
          </i>
        </p>
        <!-- TODO: test-->
        <salaxy-input-boolean type="radio" name="identityPep" label="" label-type="plain" label-true="SALAXY.UI_Terms.yes" label-false="SALAXY.UI_Terms.no" ng-model="wizard.model.signature.isPep" require="true"></salaxy-input-boolean>
      </div>
    
      <div cng-hide="!(wizard.model.company.companyType == 'fiOy' || wizard.model.company.companyType == 'fiYy')" class="mb-4">
        <p>
          <span sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepCompanyLegal.owner" ps="*"></span>
          <i class="bi bi-info-circle-fill"
            type="button" 
            data-bs-toggle="popover" 
            data-bs-html="true"
            data-bs-title="'SALAXY.NG1.CustomerOnboardingComponent.stepCompanyLegal.ownerTitle' | sxyTranslate" 
            data-bs-content="'SALAXY.NG1.CustomerOnboardingComponent.stepCompanyLegal.ownerPopOver' | sxyTranslate" 
            data-bs-container="body" 
            data-bs-placement="top" sxy-bs5-popover>
          </i>
        </p>
        <div class="radio">
          <label class="radio-inline" for="IsRequiredTracking-true">
            <input type="radio" id="IsRequiredTracking-true" name="Ownership.IsRequiredTracking" ng-value="true" ng-model="wizard.model.company.ownership.isRequiredTracking" required> <span sxy-text="SALAXY.UI_Terms.yes"></span>
          </label>
          <label class="radio-inline" for="IsRequiredTracking-false">
            <input type="radio" id="IsRequiredTracking-false" name="Ownership.IsRequiredTracking" ng-value="false" ng-model="wizard.model.company.ownership.isRequiredTracking" required><span sxy-text="SALAXY.UI_Terms.no"></span>
          </label>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-6">
      <div ng-hide="wizard.model.company.ownership.isRequiredTracking">
        <legend sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepCompanyLegal.fiva"></legend>
        <p sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepCompanyLegal.fivaText"></p>
      </div>
      <div ng-hide="!wizard.model.company.ownership.isRequiredTracking">
        <fieldset class="form-horizontal">
          <legend sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepCompanyLegal.shareHolderTitle"></legend>
          <p sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepCompanyLegal.shareHolderText"></p>
          <div class="row mb-2">
            <label class="col-sm-4 col-md-3 col-lg-4 col-form-label" for="shareholder1" sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepCompanyLegal.shareHolder" ps=" 1*"></label>
            <div class="col-sm-8 col-md-9 col-lg-8">
              <input class="form-control" id="shareholder1" name="shareholder1" type="text" ng-model="wizard.model.company.ownership.shareHolders[0].name" value="" ng-required="wizard.model.company.ownership.isRequiredTracking == true">
            </div>
          </div>
          <div class="row mb-2">
            <label class="col-sm-4 col-md-3 col-lg-4 col-form-label" for="shareholder2" sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepCompanyLegal.shareHolder" ps=" 2 "></label>
            <div class="col-sm-8 col-md-9 col-lg-8">
              <input class="form-control" id="shareholder2" name="shareholder2" type="text" ng-model="wizard.model.company.ownership.shareHolders[1].name" value="">
            </div>
          </div>
          <div class="row mb-2">
            <label class="col-sm-4 col-md-3 col-lg-4 col-form-label" for="shareholder3" sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepCompanyLegal.shareHolder" ps=" 3 "></label>
            <div class="col-sm-8 col-md-9 col-lg-8">
              <input class="form-control" id="shareholder3" name="shareholder3" type="text" ng-model="wizard.model.company.ownership.shareHolders[2].name" value="">
            </div>
          </div>
          <div class="row mb-2">
            <label class="col-sm-4 col-md-3 col-lg-4 col-form-label" for="shareholder4" sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepCompanyLegal.shareHolder" ps=" 4 "></label>
            <div class="col-sm-8 col-md-9 col-lg-8">
              <input class="form-control" id="shareholder4" name="shareholder4" type="text" ng-model="wizard.model.company.ownership.shareHolders[3].name" value="">
            </div>
          </div>
        </fieldset>
      </div>
    </div>
  </div>
  
</form>`), s.put("salaxy-components/modals/onboarding/customer/company.html", `<form name="currentForm">
  <span class="d-none">{{ wizard.formDataValidity = currentForm.$valid }}</span>
  <div>
    <div class="alert alert-danger" ng-if="wizard.existingCompanyAlert">
      <p sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepCompanyInfo.existingCompanyAlert"></p>
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-md-6">
      <legend sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepCompanyInfo.companyInfo"></legend>
      <div class="form-horizontal">
        <salaxy-input salaxy-if-role="!test" readonly="true" label="SALAXY.NG1.CustomerOnboardingComponent.stepCompanyInfo.companyBusinessId" name="Ytunnus" ng-required="true" ng-model="wizard.model.company.businessId"></salaxy-input>
        <salaxy-input salaxy-if-role="test" label="SALAXY.NG1.CustomerOnboardingComponent.stepCompanyInfo.companyBusinessId" name="Ytunnus" ng-required="true" ng-model="wizard.model.company.businessId"></salaxy-input>
        <salaxy-input salaxy-if-role="!test" readonly="true" label="SALAXY.NG1.CustomerOnboardingComponent.stepCompanyInfo.companyName" name="Nimi" ng-required="true" ng-model="wizard.model.company.name"></salaxy-input>
        <salaxy-input salaxy-if-role="test" label="SALAXY.NG1.CustomerOnboardingComponent.stepCompanyInfo.companyName" name="Nimi" ng-required="true" ng-model="wizard.model.company.name"></salaxy-input>
        <div class="row" salaxy-if-role="!test">
          <label for="Yritysmuoto" class="col-12 col-sm-4 col-form-label">
            <span sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepCompanyInfo.companyType" ps="*"></span>
          </label>
          <div class="col-12 col-sm-8">
            <input type="text" class="form-control" id="Yritysmuoto" name="Yritysmuoto" placeholder="{{'SALAXY.NG1.CustomerOnboardingComponent.stepCompanyInfo.companyType' | sxyTranslate | lowercase}}" readonly="true" autocomplete="off" value="{{ !wizard.model.company.companyType ? '' : ('SALAXY.ENUM.CompanyType.' + wizard.model.company.companyType +'.label' | sxyTranslate) }}"
            />
          </div>
        </div>
      </div>
      <salaxy-input-enum sxy-if-role="test" label="SALAXY.NG1.CustomerOnboardingComponent.stepCompanyInfo.companyType" name="companyType" ng-model="wizard.model.company.companyType" enum="CompanyType" type="select" placeholder="SALAXY.NG1.CustomerOnboardingComponent.stepCompanyInfo.companyType"
        required></salaxy-input-enum>
    </div>
    <div class="col-12 col-md-6">
      <legend sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepCompanyInfo.companyContact"></legend>
      <div class="form-horizontal">
        <salaxy-input label="SALAXY.NG1.CustomerOnboardingComponent.stepCompanyInfo.companyStreet" name="Katuosoite" ng-model="wizard.model.company.contact.street" ng-required="true"></salaxy-input>
        <salaxy-input label="SALAXY.NG1.CustomerOnboardingComponent.stepCompanyInfo.companyPostalCode" name="Postinumero" sxy-postal-code-fi ng-model="wizard.model.company.contact.postalCode" ng-required="true"></salaxy-input>
        <salaxy-input label="SALAXY.NG1.CustomerOnboardingComponent.stepCompanyInfo.companyCity" name="Postitoimipaikka" ng-model="wizard.model.company.contact.city" ng-required="true"></salaxy-input>
        <salaxy-input label="SALAXY.NG1.CustomerOnboardingComponent.stepCompanyInfo.companyEmail" name="Sahkoposti" ng-model="wizard.model.company.contact.email" ng-required="true" sxy-email></salaxy-input>
        <salaxy-input label="SALAXY.NG1.CustomerOnboardingComponent.stepCompanyInfo.companyPhone" name="Puhelinnumero" ng-model="wizard.model.company.contact.telephone" ng-required="true" sxy-mobile-phone></salaxy-input>
      </div>
    </div>
  </div>
</form>`), s.put("salaxy-components/modals/onboarding/customer/finish-buttons.html", `<div class="btn-group" role="group">
  <button ng-click="wizard.goPrevious()" ng-disabled="!wizard.canGoPrevious" class="btn btn-danger" sxy-text="SALAXY.UI_Terms.previous"></button>
</div>
<div salaxy-loader class="spinner">
  <div class="bounce1"></div>
  <div class="bounce2"></div>
  <div class="bounce3"></div>
</div>
<div class="btn-group">
  <button class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
  <button class="btn btn-success" ng-click="$close('ok');wizard.launch()" sxy-text="SALAXY.NG1.CustomerOnboardingComponent.newAccountBtn"></button>
</div>`), s.put("salaxy-components/modals/onboarding/customer/finish.html", `\uFEFF<form name="currentForm">
  <span class="d-none">{{ wizard.formDataValidity = currentForm.$valid }}</span>
  <div class="row">
    <div class="col-md-12" sxy-html="SALAXY.NG1.CustomerOnboardingComponent.stepInviteCompany.html" params="{sharingLink :wizard.sharingLink, mailToLink : wizard.mailtoLink}"></div>
  </div>
</form>`), s.put("salaxy-components/modals/onboarding/customer/index.html", `<div ng-controller="SessionController as sessionCtrl">
  <div ng-controller="CustomerOnboardingController as wizard">
    <div ng-controller="NaviController as $naviCtrl">
      <div ng-if="!$naviCtrl.showFullPageLoader">
        <div class="modal-header bg-primary">
          <h2 class="modal-title" sxy-text="SALAXY.NG1.CustomerOnboardingComponent.modalTitle"></h2>
          <button type="button" class="btn-close btn-close-white" ng-click="$close('cancel')" aria-label="Close"></button>
        </div>
        <div class="modal-body">       
          <div class="d-block d-md-none">
            <h4><span sxy-text="SALAXY.NG1.CustomerOnboardingComponent.step"></span> {{wizard.currentStep.number}}/{{wizard.steps.length}}</h4>
          </div>
          <div class="salaxy-wizard">
            <div class="wizard-steps">
              <div class="wizard-step" ng-repeat="step in $ctrl.steps" ng-class="{'active': step.active, 'disabled': step.disabled}">
                <span class="salaxy-avatar">
                  <div class="wizard-icons-wrapper">
                    <i class="bi" ng-class="step.active ? 'bi-circle-fill' : 'bi-circle'"></i>
                    <i class="bi bi-circle-fill"></i>
                  </div>
                  <strong class="number">{{ step.number }}</strong>
                </span>
                <span class="step-text">{{ step.title | sxyTranslate }}</span>
              </div>
            </div>
            <div class="wizard-strikethrough"></div>
          </div>
          <ng-include src="wizard.currentStep.view"></ng-include>
        </div>
        <div class="modal-footer">
          <ng-include class="d-flex justify-content-between w-100" src="wizard.currentStep.buttonsView"></ng-include>
        </div>
      </div>
    </div>
  </div>
</div>`), s.put("salaxy-components/modals/onboarding/customer/insurance.html", `<form name="currentForm">

  <span class="d-none">{{ wizard.formDataValidity = currentForm.$valid}}</span>

  <div class="row">
    <div class="col-md-6">
      <fieldset>
        <legend sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepInsurance.pensionTitle"></legend>
        <div class="form-horizontal">
          <salaxy-input-boolean label="SALAXY.NG1.CustomerOnboardingComponent.stepInsurance.pensionText" type="radio" name="isPensionContractDone" ng-model="wizard.model.products.pension.isPensionContractDone" label-type="basic" label-true="SALAXY.UI_Terms.yes"
            label-false="SALAXY.UI_Terms.no" ng-change="wizard.checkPensionCompanySelection()"></salaxy-input-boolean>
        </div>
        <div ng-if="!wizard.model.products.pension.isPensionContractDone">
          <p sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepInsurance.hasPension"></p>
        </div>
        <div ng-if="wizard.model.products.pension.isPensionContractDone" class="form-horizontal">
          <salaxy-input-enum label="SALAXY.NG1.CustomerOnboardingComponent.stepInsurance.pensionCompany" name="pensionCompany" enum="PensionCompany" filter="varma,elo,ilmarinen,veritas,apteekkien,verso,valio,kevaMunicipal,kevaAland,kevaChurch,kevaKela,kevaState" ng-model="wizard.model.products.pension.pensionCompany"
            ng-change="wizard.checkPensionCompanySelection(); wizard.model.products.pension.pensionContractNumber = null;" require="true"></salaxy-input-enum>

          <main salaxy-if-role="test" class="test-number">
            <div class="row" ng-if="wizard.model.products.pension.pensionCompany != 'null' && wizard.model.products.pension.pensionCompany != 'none'">
              <div class="col-sm-8 offset-sm-4 mb-2 text-end text-sm-start">
                <span><span sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepInsurance.testOnly"></span> <button class="btn btn-secondary  btn-xs" ng-click="wizard.setPensionNumberForTest()" sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepInsurance.testGenerateNumberBtn"></button></span>
              </div>
            </div>
          </main>
          <div ng-if="wizard.model.products.pension.pensionCompany != 'other'">
            <salaxy-input label="SALAXY.NG1.CustomerOnboardingComponent.stepInsurance.pensionContractNumber" require="true" type="text" name="pensionContractNumber" id="pensionContractNumber" ng-model="wizard.model.products.pension.pensionContractNumber" tooltip-html="{{'SALAXY.NG1.CustomerOnboardingComponent.stepInsurance.pensionContractNumberToolTip.html' | sxyTranslate}}"
              tooltip-placement="right" sxy-pension-contract-number="wizard.model.products.pension.pensionCompany"></salaxy-input>

            <div class="row" ng-show="currentForm.pensionContractNumber.$error.sxyTemporaryPensionContractNumber">
              <div class="col-12 input-info text-danger">
                <div class="input-info-icon"><i class="bi bi-exclamation-triangle-fill"></i></div>
                <p class="small input-info-text with-icon" sxy-html="SALAXY.NG1.CustomerOnboardingComponent.stepInsurance.pensionContractNumberTemporaryToolTip.html"></p>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
    </div>
    <div class="col-sm-6 col-12" ng-if="wizard.model.products.pension.isPensionContractDone">
      <fieldset>
        <legend sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepInsurance.pensionHandling"></legend>
        <div class="input-wrapper">
          <div class="form-group">
            <div>
              <p sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepInsurance.pensionSelfHandleDescription"></p>
            </div>
          </div>
        </div>
      </fieldset>
    </div>
  </div>
  <div class="row">
    <div class="col-md-6">
      <fieldset>
        <legend sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepInsurance.insuranceTitle"></legend>
        <div class="form-horizontal">
          <salaxy-input-boolean type="radio" label="SALAXY.NG1.CustomerOnboardingComponent.stepInsurance.insuranceText" label-type="basic" label-true="SALAXY.UI_Terms.yes" label-false="SALAXY.UI_Terms.no" ng-model="wizard.model.products.insurance.isInsuranceContractDone"
            name="isInsuranceContractDone" ng-change="wizard.checkInsuranceCompanySelection()"></salaxy-input-boolean>
        </div>
        <div ng-if="wizard.model.products.insurance.isInsuranceContractDone" class="form-horizontal">
          <salaxy-input-enum enum="InsuranceCompany" filter="if,fennia,lähiTapiola,pohjantähti,pohjola,turva,aVakuutus,folksam,alandia,ålands" name="InsuranceCompany" label="SALAXY.NG1.CustomerOnboardingComponent.stepInsurance.insuranceCompany" ng-model="wizard.model.products.insurance.insuranceCompany"
            require="true"></salaxy-input-enum>
          <salaxy-input label="SALAXY.NG1.CustomerOnboardingComponent.stepInsurance.insuranceContractNumber" require="true" name="insuranceContractNumber" ng-model="wizard.model.products.insurance.insuranceContractNumber"></salaxy-input>
        </div>
        <div ng-if="!wizard.model.products.insurance.isInsuranceContractDone && !wizard.model.products.insurance.isPartnerInsurance">
          <p sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepInsurance.noInsuranceAlert"></p>
        </div>
      </fieldset>
    </div>
    <div class="col-md-6">
      <fieldset>
        <legend sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepInsurance.taxTitle"></legend>

        <p sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepInsurance.taxText"></p>
        <div class="form-horizontal">
          <salaxy-input-enum ng-model="wizard.model.products.tax.irReporting" name="irReporting" label="SALAXY.NG1.CustomerOnboardingComponent.stepInsurance.irReporting" options="{ default: ('SALAXY.NG1.CustomerOnboardingComponent.stepInsurance.irReportingDefault' | sxyTranslate), noMonthlyReport: ('SALAXY.NG1.CustomerOnboardingComponent.stepInsurance.irReportingNoMonthlyReport' | sxyTranslate), always: ('SALAXY.NG1.CustomerOnboardingComponent.stepInsurance.irReportingAlways' | sxyTranslate)}"></salaxy-input-enum>
        </div>
      </fieldset>
    </div>
  </div>
  <div class="row">
    <div class="col-md-6">
      <fieldset>
        <legend sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepInsurance.employmentTitle"></legend>
        <p sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepInsurance.employmentText"></p>
      </fieldset>
    </div>
    <div class="col-md-6">
      <fieldset>
        <legend sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepInsurance.reportTitle"></legend>
        <p sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepInsurance.reportText"></p>
        <div class="form-horizontal">
          <salaxy-input label="SALAXY.NG1.CustomerOnboardingComponent.stepInsurance.accountantEmail" name="Sahkopostiosoite" ng-model="wizard.model.products.accounting.accountantEmail" sxy-email></salaxy-input>
        </div>
      </fieldset>
    </div>
  </div>
</form>`), s.put("salaxy-components/modals/onboarding/customer/invitation.html", `\uFEFF

<div ng-controller="SessionController as sessionCtrl">
  <div ng-controller="NaviController as $naviCtrl">
    <div ng-if="!$naviCtrl.showFullPageLoader">
        <div class="modal-header bg-primary">
          <h2 class="modal-title" sxy-text="SALAXY.NG1.CustomerOnboardingComponent.invitation.title"></h2>
          <button type="button" class="btn-close btn-close-white" ng-click="$close('cancel')" aria-label="Close"></button>
        </div>
        <div class="modal-body salaxy-wizard">
          <form name="currentForm">
            <div class="row">
              <div class="col-md-12" sxy-html="SALAXY.NG1.CustomerOnboardingComponent.invitation.html" params="{signingLink : $ctrl.signingLink}"></div>
              <div class="col-md-12 text-end">
                <button 
                  type="button" 
                  class="btn btn-primary" 
                  ng-click="$ctrl.copyLink($ctrl.signingLink)" 
                  data-bs-toggle="popover" 
                  data-bs-html="true" 
                  data-bs-title="Info"
                  data-bs-content="{{ !!$ctrl.linkCopied ? ('SALAXY.UI_Terms.copiedToClipboard' | sxyTranslate) : ('SALAXY.UI_Terms.copyToClipboard' | sxyTranslate)}}" 
                  data-bs-container="body" 
                  data-bs-placement="top" 
                  data-bs-trigger="hover"
                  sxy-bs5-popover>
                  <i class="bi bi-clipboard me-1"></i>
                  <span sxy-text="SALAXY.UI_Terms.copyToClipboard"></span>
                </button>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer text-start">
          <button class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
        </div>
    </div>
  </div>
</div>`), s.put("salaxy-components/modals/onboarding/customer/user-buttons.html", `<button ng-click="$close('cancel')" class="btn btn-default" sxy-text="SALAXY.UI_Terms.backToFront"></button>
<div salaxy-loader class="spinner">
  <div class="bounce1"></div>
  <div class="bounce2"></div>
  <div class="bounce3"></div>
</div>
<button ng-disabled="!wizard.canGoNext" ng-click="wizard.goToCompanySelection()" class="btn btn-primary" sxy-text="SALAXY.UI_Terms.next"></button>`), s.put("salaxy-components/modals/onboarding/customer/user.html", `\uFEFF<form name="currentForm" class="form-horizontal">
  <span class="d-none">{{ wizard.formDataValidity = currentForm.$valid }}</span>
  <div class="row">
    <div class="col-12 col-md-6">
      <legend sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepUserInfo.userInfo"></legend>
      <salaxy-input label="SALAXY.NG1.CustomerOnboardingComponent.stepUserInfo.userFirstName" name="Etunimi" ng-model="wizard.model.person.firstName" ng-required="true"></salaxy-input>
      <salaxy-input label="SALAXY.NG1.CustomerOnboardingComponent.stepUserInfo.userLastName" name="Sukunimi" ng-model="wizard.model.person.lastName" ng-required="true"></salaxy-input>
      <salaxy-input label="SALAXY.NG1.CustomerOnboardingComponent.stepUserInfo.userEmail" name="Sahkoposti" ng-model="wizard.model.person.contact.email" ng-required="true" sxy-email></salaxy-input>
      <salaxy-input label="SALAXY.NG1.CustomerOnboardingComponent.stepUserInfo.userPhone" name="Puhelinnumero" ng-model="wizard.model.person.contact.telephone" ng-required="true" sxy-mobile-phone></salaxy-input>
    </div>

    <div class="col-12 col-md-6">
      <legend sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepUserInfo.signeratureTitle"></legend>
      <p sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepUserInfo.signeratureText"></p>
      <div class="form-horizontal">
        <salaxy-input label="SALAXY.NG1.CustomerOnboardingComponent.stepUserInfo.userPersonalId" name="Henkilotunnus" sxy-personal-id-fi placeholder="SALAXY.NG1.CustomerOnboardingComponent.stepUserInfo.personalIdExample" ng-model="wizard.model.signature.personalId"
          ng-required="true"></salaxy-input>
      </div>
      <div class="alert alert-danger" sxy-text="SALAXY.NG1.CustomerOnboardingComponent.stepUserInfo.checkSignatureAlert"></div>

      <div class="form-horizontal">
        <salaxy-input label="SALAXY.NG1.CustomerOnboardingComponent.stepUserInfo.businessId" name="Ytunnus" ng-model="wizard.model.company.businessId" sxy-company-id-fi ng-required="true"></salaxy-input>
      </div>
    </div>
  </div>
</form>`), s.put("salaxy-components/modals/onboarding/generic/index.html", `<div ng-controller="SessionController as sessionCtrl">
  <div ng-controller="NaviController as $naviCtrl">
    <div ng-if="!$naviCtrl.showFullPageLoader">
      <div class="modal-header bg-primary">
        <img src="https://cdn.salaxy.com/img/palkkaus/logo/palkkaus-www-logo-white-border.png" class="img-responsive d-none d-sm-inline-block modal-logo" />
        <h2 class="modal-title" sxy-text="SALAXY.NG1.GenericOnboardingComponent.modalTitle"></h2>
        <button type="button" class="btn-close btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
      </div>
      <div class="modal-body salaxy-wizard">
        <div>
          <fieldset>
            <legend sxy-text="SALAXY.NG1.GenericOnboardingComponent.roleTitle" ps="*"></legend>
            <div class="form-horizontal">
              <div class="radio" ng-repeat="accountType in ['company', 'worker']">
                <label ng-if="accountType == 'company'">
                  <input type="radio" name="wizardType" ng-model="$ctrl.data.model.accountType" value="company" ng-disabled="sessionCtrl.session.hasCurrentAccount" /> 
                  <span sxy-text="SALAXY.NG1.GenericOnboardingComponent.roleCompany"></span>
                </label>
                <label ng-if="accountType == 'worker'">
                  <input type="radio" name="wizardType" ng-model="$ctrl.data.model.accountType" value="worker" ng-disabled="sessionCtrl.session.hasCurrentAccount" />
                  <span sxy-text="SALAXY.NG1.GenericOnboardingComponent.roleWorker"></span>
                </label>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
      <div class="modal-footer">
        <button ng-click="$ctrl.data.launch($close)" ng-disabled="!$ctrl.data.model.accountType || $ctrl.data.model.accountType == 'none'" class="btn btn-primary" sxy-text="SALAXY.NG1.GenericOnboardingComponent.launchBtn"></button>
      </div>
    </div>
  </div>
</div>`), s.put("salaxy-components/modals/onboarding/household/contract.html", `\uFEFF<form name="contractForm">
  <span class="d-none">{{ wizard.formDataValidity = contractForm.$valid}}</span>

  <h3>Palvelusopimus ja valtuutus</h3>
  <p>
    Rakennusliitto tarjoaa Palkkamylly-palvelun jäsenilleen ja heidän työnantajilleen. Palvelun tuottaa Suomen Palkanlaskenta Oy (Palkkaus.fi).
  </p>
  <p>
    Jotta Palkkamylly voi hoitaa puolestasi palkanmaksuun liittyviä velvoitteita, sinun täytyy allekirjoittaa <a ng-href="{{ wizard.getPdfPreviewAddress() }}" target="_blank">oheinen valtakirja</a>. Se pitää allekirjoittaa vain kerran.
  </p>
  <p>
    Kirjoita henkilötunnuksesi ja valitse pankkisi. Siirryt pankkisi verkkopalveluun, jossa varsinainen tunnistautuminen tapahtuu. Sen jälkeen palaat Palkkamylly-palveluun ja olet valmis aloittamaan käytön.
  </p>


  <div class="row" ng-controller="SignatureController as sign">
    <div class="col-md-6">
      <fieldset>
        <legend>Allekirjoita henkilötunnuksellasi</legend>
        <div class="mb-3">
          <salaxy-input name="personalId" label-type="plain" type="text" style="width:150px" placeholder="PPKKVV-NNNX" ng-model="wizard.model.signature.personalId" require="true" sxy-personal-id-fi></salaxy-input>
        </div>
      </fieldset>
      <fieldset>
        <legend>Valitse verkkopankkisi</legend>
        <div ng-if="wizard.model.accountType == 'company'">
          <p>
            Et voi käyttää yrityksen tai yhdistyksen verkkopankkitunnuksia valtakirjan allekirjoittamiseen. Sinun täytyy käyttää henkilökohtaisia verkkopankkitunnuksiasi
          </p>
        </div>
        <div id="bankButtonRow">
          <div class="btn-group" id="mostUsedBanks">
            <salaxy-toggle-buttons 
              ng-model="wizard.model.signature.method" 
              options="$ctrl.visibleSignatureMethods" 
              type="inline">
            </salaxy-toggle-buttons>
          </div>
          <div class="btn-group group-dropdown dropdown">
            <a class="btn btn-default dropdown-toggle" id="other-banks-button" data-bs-toggle="dropdown" ng-class="(wizard.model.signature.method != null && sign.getMethod(wizard.model.signature.method).isPopular == false) ? 'bank-chosen': ''">
              <span ng-if="wizard.model.signature.method == null || sign.getMethod(wizard.model.signature.method).isPopular == true">Muut verkkopankit</span>
              <span ng-if="wizard.model.signature.method != null && sign.getMethod(wizard.model.signature.method).isPopular == false">
                <img ng-src="{{ sign.getMethod(wizard.model.signature.method).img }}" style="max-height: 20px; max-width: 85px"/> {{sign.getMethod(wizard.model.signature.method).title}}
              </span> &nbsp; 
            </a>
            <ul class="dropdown-menu" role="menu" aria-labelledby="other-banks-button">
              <li ng-repeat="signMethod in sign.getMethods('telia') | filter: {isPopular:false}" role="menuitem" ng-class="wizard.model.signature.method == signMethod.value ? 'active' : ''">
                <a ng-click="wizard.model.signature.method = signMethod.value" class="dropdown-item">
                  <img ng-src="{{signMethod.img}}" style="max-height: 20px; max-width: 85px" /> {{signMethod.title}}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </fieldset>
      <p class="mt-3">

        <strong>HUOM:</strong> Palkkamyllyn tarjoaa Rakennusliitto ry, joka toimii henkilötietojen käsittelijänä ja vastaa myös asiakaspalvelusta. Palvelun tuottajana ja teknisenä toteuttajana ja myös henkilötietojen käsittelijä toimii Suomen Palkanlaskenta
        Oy (Palkkaus.fi).

      </p>
      <p>
        Tunnistautumalla hyväksyt:<br>
        <a href="https://storage.googleapis.com/rakennusliitto-production-uploads/content_management/documents/Palkkamylly_Kayttoehdot_Oct2021.pdf?Expires=1795336880&GoogleAccessId=cloud-run-service-account%40rakennusliitto.iam.gserviceaccount.com&Signature=dTZrDk4AgZv29ldlizR%2Bfe9uv5NgXtAU%2BZBr%2FgbO7p%2FWpoyc4rtUnbUyoRwqLE2OSJ2ZUIRvPucZt7jUhGiAmXEpsG7vsieoBHX9C1P%2F79VoJdIvLG9sqe4wOIQG0t0KUhNxv4I3dpymLV1F16T%2FKLN94vSGRLv6pNHblNqc3iGpoIw11d3dG3%2BhVL%2Fnajwcfirh7m7V7PLIn4fHNY6Q6PbfhbVRpeLprM37sUKTlCBLwdEihZJ7bNcoRvWG4CWfZMk9hRaV66YYadNxEEnBd6EOQZZ5%2B0S2%2F%2FSOLWT5d9amM%2F8S0IW7wOcwr3crCs%2BcroZ6aYSFrZ1H6TCTdRUkNA%3D%3D"
          target="_blank">Palkkamyllyn käyttöehdot</a><br>
        <a href="https://storage.googleapis.com/rakennusliitto-production-uploads/content_management/documents/Palkkamylly_Sopimus_henkilotietojen_kasittelysta_Oct2021.pdf?Expires=1795336940&GoogleAccessId=cloud-run-service-account%40rakennusliitto.iam.gserviceaccount.com&Signature=gcO62AB17YCjv5mVTtSP%2FtgG2RxGUSnaGpfK0GencENWGoq8FF1F5MlXEfyZ5pM6eW9tEubAWd8WkxP7WpmX63mtcvdnCViiz52TQjYiK%2BSjJw6ZD6QB%2F%2FPQRVQGsoKilFVJZ4HVshOWcsvOVrcR1ci6dlsFOQPnFQXQhalCaJHiFzGJzxsRtPEaD1GMtqANqzdcmZbqR6ULEE73G2WxYVJ4%2FeK1bpd0qAKlBvs%2Fh9DlDd8RDx5M3BSJj7q43KHP5kT8mOq2bky4xNnq7q31jgnub%2BVO1a4X7RAKzbKabW4D6y%2BlDKzK%2FJgnmbPsS8TzYFuSkH81aiqu5MGR2zfn9A%3D%3D"
          target="_blank">Sopimuksen henkilötietojen käsittelystä</a><br>
        <a href="https://storage.googleapis.com/rakennusliitto-production-uploads/content_management/documents/Palkkamylly_Tietosuojaseloste_Oct2021.pdf?Expires=1793455095&GoogleAccessId=cloud-run-service-account%40rakennusliitto.iam.gserviceaccount.com&Signature=dVqt3NenZZwBOPmmKz15jrIlgUOv2J2QE39Ltl7sK9t6iUC6YSXpnRifRoJLdcCrJpgt8KBpw%2FDXLm9olu5wzBFhSXKa1b4LRclyVjpzs27e9%2BMJceizLURvLWeKyZsyuYc%2BU3U7V0vkN0S%2B4nqkcDqskXCtvccmcBg0BgPYaslcSwLu4NUztiR2vA5qUj%2FL6hBelLqjKyqA%2FwDHahcTp07de6WqkEDud46W9Fv1oEJDioiho9W3%2F2W5kpVe2JxA3VB6D9j7Fwt45LBsDZC5opFiwnzWuahr7zEyn9UVuf4nLOJ83PcfYIsRo0pZWAPIgScsH%2BcAOXFgbnr5OkTu2A%3D%3D"
          target="_blank">Tietosuojaselosteen</a>
      </p>
    </div>

    <div class="col-md-6 d-none d-sm-block">
      <fieldset>
        <legend>Valtakirjan esikatselu</legend>

        <small><a ng-href="{{ wizard.getPdfPreviewAddress() }}" target="_blank">Lataa tästä, jos et näe esikatselua</a></small>

        <iframe ng-src="{{ wizard.getPdfPreviewAddress() }}" style="width: 100%; height: 300px"></iframe>
      </fieldset>
    </div>


  </div>
</form>`), s.put("salaxy-components/modals/onboarding/household/contractButtons.html", `\uFEFF<button ng-click="wizard.goPrevious()" ng-disabled="!wizard.canGoPrevious" class="btn btn-default">Edellinen</button>
<div salaxy-loader class="spinner">
    <div class="bounce1"></div>
    <div class="bounce2"></div>
    <div class="bounce3"></div>
</div>

<button ng-if="wizard.model.signature.personalId == null || wizard.model.signature.method == null"  ng-disabled="true" class="btn btn-primary">Allekirjoita valtakirja<span class="d-none d-sm-inline" ng-if="wizard.model.accountType != 'worker'"> ja voit maksaa palkkaa</span></button>
<a ng-if="!(wizard.model.signature.personalId == null || wizard.model.signature.method == null)" ng-href="{{wizard.vismaSignUrl}}" target="_top"  class="btn btn-primary">Allekirjoita valtakirja<span class="d-none d-sm-inline" ng-if="wizard.model.accountType != 'worker'"> ja voit maksaa palkkaa</span></a>`), s.put("salaxy-components/modals/onboarding/household/firstPageButtons.html", `\uFEFF<!--a ng-if="wizard.model.ui.cancelUrl" ng-href="{{wizard.model.ui.cancelUrl}}"  class="btn btn-default">Takaisin etusivulle</a-->

<div salaxy-loader class="spinner">
  <div class="bounce1"></div>
  <div class="bounce2"></div>
  <div class="bounce3"></div>
</div>
<button ng-click="wizard.goNext()" ng-disabled="!wizard.canGoNext" class="btn btn-primary">Seuraava</button>`), s.put("salaxy-components/modals/onboarding/household/household.html", `\uFEFF<form name="householdForm" class="form-horizontal">
  <!-- Hidden variable formDataValidity to use in controller -->
  <span class="d-none">{{ wizard.formDataValidity = householdForm.$valid}}</span>
  <div class="row">
    <div class="col-md-6">
      <fieldset>
        <legend> Yhteystiedot 
          <i class="bi bi-info-circle-fill"
            type="button" 
            data-bs-toggle="popover" 
            data-bs-title="'Miksi kysymme osoitetietojasi?'" 
            data-bs-content="'Lähetämme puolestasi tietoja ja erilaisia lomakkeita eri viranomaisille. Jotkut näistä viranomaisista vaativat joissain lomakkeissa osoitetiedot pakollisina tietoina.'"
            data-bs-container="body" 
            data-bs-placement="top" 
            sxy-bs5-popover>
          </i>
        </legend>
        <div class="form-horizontal">
          <salaxy-input label="Katuosoite" name="Katuosoite" ng-model="wizard.model.person.contact.street" require="true"></salaxy-input>
          <salaxy-input label="Postinumero" name="Postinumero" ng-model="wizard.model.person.contact.postalCode" require="true" sxy-postal-code-fi></salaxy-input>
          <salaxy-input label="Postitoimipaikka" name="Postitoimipaikka" ng-model="wizard.model.person.contact.city" require="true"></salaxy-input>
        </div>
      </fieldset>
    </div>
    <div class="col-md-6">
      <fieldset>
        <legend>Palkanmaksuun tarvittavat tiedot</legend>
        <p>
          Osoitetietojasi työnantajana tarvitaan tulorekisteri-ilmoitukseen, näin esim. työttömyysvakuutuslaskujen lähettäminen sinulle onnistuu.
        </p>
      </fieldset>
    </div>
  </div>
</form>`), s.put("salaxy-components/modals/onboarding/household/householdButtons.html", `\uFEFF
<button ng-click="wizard.goPrevious()" ng-disabled="!wizard.canGoPrevious" class="btn btn-default">Edellinen</button>
<div salaxy-loader class="spinner">
    <div class="bounce1"></div>
    <div class="bounce2"></div>
    <div class="bounce3"></div>
</div>
<button ng-click="wizard.goNext()" ng-disabled="!wizard.canGoNext" class="btn btn-primary">Seuraava</button>`), s.put("salaxy-components/modals/onboarding/household/index.html", `<div ng-controller="SessionController as sessionCtrl">
  <div ng-controller="HouseholdOnboardingController as wizard">
    <div ng-controller="NaviController as $naviCtrl">

      <div ng-if="!$naviCtrl.showFullPageLoader">
        <div class="modal-header bg-primary">
          <h2 class="modal-title">Palkkamylly / Käyttöönotto</h2>
          <button type="button" class="btn-close btn-close-white" ng-click="$close('cancel')" aria-label="Close"></button>

          <!--
        TODO: Consider adding back with skinning. But perhaps not needed?
        <img src="https://cdn.salaxy.com/img/palkkaus/logo/palkkaus-www-logo-white-border.png" class="img-responsive d-none d-sm-inline modal-logo" />
      -->
        </div>
        <div class="modal-body">
          <div class="d-block d-md-none">
            <h4>Vaihe {{wizard.currentStep.number}}/{{wizard.steps.length}}</h4>
          </div>
          <div class="salaxy-wizard">
            <div class="wizard-steps">
              <div class="wizard-step" ng-repeat="step in $ctrl.steps" ng-class="{'active': step.active, 'disabled': step.disabled}">
                <span class="salaxy-avatar">
                  <div class="wizard-icons-wrapper">
                    <i class="bi" ng-class="step.active ? 'bi-circle-fill' : 'bi-circle'"></i>
                    <i class="bi bi-circle-fill"></i>
                  </div>
                  <strong class="number">{{ step.number }}</strong>
                </span>
                <span class="step-text">{{ step.title | sxyTranslate }}</span>
              </div>
            </div>
            <div class="wizard-strikethrough"></div>
          </div>
          <ng-include src="wizard.currentStep.view"></ng-include>
        </div>
        <div class="modal-footer">
          <ng-include class="d-flex justify-content-between w-100" src="wizard.currentStep.buttonsView"></ng-include>
        </div>
      </div>
    </div>
  </div>
</div>`), s.put("salaxy-components/modals/onboarding/household/wizard_index.html", `\uFEFF<form name="currentForm" class="form-horizontal">
  <!-- Hidden ariable formDataValidity to use in controller -->
  <span class="d-none">{{ wizard.formDataValidity = currentForm.$valid }}</span>
  <div class="">
    <br/>
    <p>{{wizard.currentStep.intro | sxyTranslate}}</p>

    <br/>
  </div>
  <div class="row">
    <div class="col-md-6">
      <fieldset>
        <legend>Henkilötiedot</legend>
        <salaxy-input label="Etunimi" name="Etunimi" ng-model="wizard.model.person.firstName" ng-required="true"></salaxy-input>
        <salaxy-input label="Sukunimi" name="Sukunimi" ng-model="wizard.model.person.lastName" ng-required="true"></salaxy-input>
      </fieldset>
    </div>
    <div class="col-md-6">
      <fieldset>
        <legend>Yhteystiedot</legend>
        <salaxy-input label="Sähköposti" name="Sahkoposti" ng-model="wizard.model.person.contact.email" ng-required="true" sxy-email read-only="!!wizard.model.person.contact.email"></salaxy-input>
        <salaxy-input label="Puhelinnumero" name="Puhelinnumero" ng-model="wizard.model.person.contact.telephone" ng-required="true" sxy-mobile-phone></salaxy-input>
      </fieldset>
    </div>
  </div>
</form>`), s.put("salaxy-components/modals/onboarding/palkkamylly/federate-sign.html", `<div ng-controller="SessionController as sessionCtrl" class="worker-onboarding-wizard">
  <div ng-controller="WorkerOnboardingController as wizard">
    <div class="modal-header bg-primary">
      <h2 class="modal-title">Palkkamylly käyttöönotto</h2>
      <button type="button" class="btn-close btn-close-white" ng-click="$close('cancel')" aria-label="Close"></button>

    </div>
    <div class="modal-body salaxy-wizard">
      <form name="contractForm">
        <span class="d-none">{{ wizard.formDataValidity = contractForm.$valid && !wizard.model.signature.personalId && !wizard.model.signature.method}}</span>
        <div ng-controller="SignatureController as sign">
          <h3>Palvelusopimus ja valtuutus</h3>
          <p>
            Rakennusliitto tarjoaa Palkkamylly-palvelun jäsenilleen ja heidän työnantajilleen. Palvelun tuottaa Suomen Palkanlaskenta Oy (Palkkaus.fi).
          </p>
          <p>
            Jotta Palkkamylly voi hoitaa puolestasi palkanmaksuun liittyviä velvoitteita, sinun täytyy allekirjoittaa <a ng-href="{{ wizard.getPdfPreviewAddress() }}" target="_blank">oheinen valtakirja</a>. Se pitää allekirjoittaa vain kerran.
          </p>
          <p>Kirjoita henkilötunnuksesi, valitse pankkisi ja paina Tunnistaudu-nappia. Siirryt pankkisi verkkopalveluun, jossa varsinainen tunnistautuminen tapahtuu. Sen jälkeen palaat Palkkamylly-palveluun ja olet valmis aloittamaan käytön.</p>
          <div class="row form-horizontal" ng-init="ui.telephone = wizard.model.person.contact.telephone">
            <div class="" ng-init="wizard.model.signature.personalId = wizard.model.person.personalId" ng-class="{'col-sm-6': ui.telephone, 'col-sm-8': !ui.telephone}">
              <salaxy-input label="Tarkista henkilötunnuksesi" label-type="basic" name="personalId" placeholder="PPKKVV-NNNX" ng-model="wizard.model.signature.personalId" sxy-personal-id-fi ng-required="true"></salaxy-input>
            </div>
            <div ng-if="ui.telephone" class="col-sm-6">
              <salaxy-input label="Tarkista puhelinnumerosi" name="telephone" ng-model="wizard.model.person.contact.telephone" sxy-mobile-phone label-type="basic" ng-required="true"></salaxy-input>
            </div>
            <div ng-if="!ui.telephone" class="col-sm-4">
              <salaxy-input label="Puhelinnumero" name="telephone" ng-model="wizard.model.person.contact.telephone" sxy-mobile-phone label-type="basic" ng-required="true"></salaxy-input>
            </div>
          </div>

          <div class="row form-horizontal">
            <div class="col-sm-4">
              <salaxy-input label="Etunimi" name="firstName" ng-model="wizard.model.person.firstName" label-type="basic" readonly="true"></salaxy-input>
            </div>
            <div class="col-sm-4">
              <salaxy-input label="Sukunimi" name="lastName" ng-model="wizard.model.person.lastName" label-type="basic" readonly="true"></salaxy-input>
            </div>
            <div class="col-sm-4">
              <salaxy-input label="Sähköpostiosoite" name="email" ng-model="wizard.model.person.contact.email" label-type="basic" readonly="true"></salaxy-input>
            </div>
          </div>

          <div class="row mb-2" ng-if="wizard.isOtherIdentifier(wizard.model.signature.personalId)">
            <div class="col-12">
              <h5><strong>Osoite</strong></h5>
            </div>
            <salaxy-input ng-model="wizard.model.person.contact.street" placeholder="Katuosoite" name="street" class="col-sm-4" label-type="plain" ng-required="true"></salaxy-input>
            <salaxy-input ng-model="wizard.model.person.contact.postalCode" placeholder="Postinumero" name="postalCode" class="col-sm-4" label-type="plain" ng-required="true"></salaxy-input>
            <salaxy-input ng-model="wizard.model.person.contact.city" placeholder="Toimipaikka" name="city" class="col-sm-4" label-type="plain" ng-required="true"></salaxy-input>
          </div>

          <h4>
            Ja valitse verkkopankkisi
            <small>
              <i class="bi bi-info-circle-fill"
                type="button" 
                data-bs-toggle="popover" 
                data-bs-content="'Kun olet valinnut pankkisi ja painat \\'Tunnistaudu\\'- nappia, siirryt tekemään sähköisen allekirjoituksen verkkopankkitunnuksillasi. Tunnistautumisen jälkeen palaat Palkkaus.fi-palveluun.'"
                data-bs-container="body" 
                sxy-bs5-popover>
              </i>
            </small>
          </h4>
          <div id="bankButtonRow">
            <salaxy-toggle-buttons 
              ng-model="wizard.model.signature.method" 
              options="$ctrl.signatureMethods" 
              type="row">
            </salaxy-toggle-buttons>
          </div>
          <br/>
          <p class="mt-3">
            <strong>HUOM:</strong> Palkkamyllyn tarjoaa Rakennusliitto ry, joka toimii henkilötietojen käsittelijänä ja vastaa myös asiakaspalvelusta. Palvelun tuottajana ja teknisenä toteuttajana ja myös henkilötietojen käsittelijä toimii Suomen Palkanlaskenta
            Oy (Palkkaus.fi).
          </p>
          <p>Tunnistautumalla hyväksyt:<br>
            <a href="https://storage.googleapis.com/rakennusliitto-production-uploads/content_management/documents/Palkkamylly_Kayttoehdot_Oct2021.pdf?Expires=1795336880&GoogleAccessId=cloud-run-service-account%40rakennusliitto.iam.gserviceaccount.com&Signature=dTZrDk4AgZv29ldlizR%2Bfe9uv5NgXtAU%2BZBr%2FgbO7p%2FWpoyc4rtUnbUyoRwqLE2OSJ2ZUIRvPucZt7jUhGiAmXEpsG7vsieoBHX9C1P%2F79VoJdIvLG9sqe4wOIQG0t0KUhNxv4I3dpymLV1F16T%2FKLN94vSGRLv6pNHblNqc3iGpoIw11d3dG3%2BhVL%2Fnajwcfirh7m7V7PLIn4fHNY6Q6PbfhbVRpeLprM37sUKTlCBLwdEihZJ7bNcoRvWG4CWfZMk9hRaV66YYadNxEEnBd6EOQZZ5%2B0S2%2F%2FSOLWT5d9amM%2F8S0IW7wOcwr3crCs%2BcroZ6aYSFrZ1H6TCTdRUkNA%3D%3D"
              target="_blank">Palkkamyllyn käyttöehdot</a><br>
            <a href="https://storage.googleapis.com/rakennusliitto-production-uploads/content_management/documents/Palkkamylly_Sopimus_henkilotietojen_kasittelysta_Oct2021.pdf?Expires=1795336940&GoogleAccessId=cloud-run-service-account%40rakennusliitto.iam.gserviceaccount.com&Signature=gcO62AB17YCjv5mVTtSP%2FtgG2RxGUSnaGpfK0GencENWGoq8FF1F5MlXEfyZ5pM6eW9tEubAWd8WkxP7WpmX63mtcvdnCViiz52TQjYiK%2BSjJw6ZD6QB%2F%2FPQRVQGsoKilFVJZ4HVshOWcsvOVrcR1ci6dlsFOQPnFQXQhalCaJHiFzGJzxsRtPEaD1GMtqANqzdcmZbqR6ULEE73G2WxYVJ4%2FeK1bpd0qAKlBvs%2Fh9DlDd8RDx5M3BSJj7q43KHP5kT8mOq2bky4xNnq7q31jgnub%2BVO1a4X7RAKzbKabW4D6y%2BlDKzK%2FJgnmbPsS8TzYFuSkH81aiqu5MGR2zfn9A%3D%3D"
              target="_blank">Sopimuksen henkilötietojen käsittelystä</a><br>
            <a href="https://storage.googleapis.com/rakennusliitto-production-uploads/content_management/documents/Palkkamylly_Tietosuojaseloste_Oct2021.pdf?Expires=1793455095&GoogleAccessId=cloud-run-service-account%40rakennusliitto.iam.gserviceaccount.com&Signature=dVqt3NenZZwBOPmmKz15jrIlgUOv2J2QE39Ltl7sK9t6iUC6YSXpnRifRoJLdcCrJpgt8KBpw%2FDXLm9olu5wzBFhSXKa1b4LRclyVjpzs27e9%2BMJceizLURvLWeKyZsyuYc%2BU3U7V0vkN0S%2B4nqkcDqskXCtvccmcBg0BgPYaslcSwLu4NUztiR2vA5qUj%2FL6hBelLqjKyqA%2FwDHahcTp07de6WqkEDud46W9Fv1oEJDioiho9W3%2F2W5kpVe2JxA3VB6D9j7Fwt45LBsDZC5opFiwnzWuahr7zEyn9UVuf4nLOJ83PcfYIsRo0pZWAPIgScsH%2BcAOXFgbnr5OkTu2A%3D%3D"
              target="_blank">Tietosuojaselosteen</a>
          </p>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <div salaxy-loader class="spinner">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
      </div>
      <button ng-if="wizard.model.signature.personalId == null || wizard.model.signature.method == null" ng-disabled="true" class="btn btn-primary">Tunnistaudu</button>
      <a ng-if="!(wizard.model.signature.personalId == null || wizard.model.signature.method == null)" ng-href="{{wizard.vismaSignUrl}}" target="_top" class="btn btn-primary">Tunnistaudu</a>
    </div>
  </div>
</div>`), s.put("salaxy-components/modals/onboarding/worker/contract-worker.html", `\uFEFF<form name="contractForm">
  <span class="d-none">{{ wizard.formDataValidity = contractForm.$valid && !wizard.model.signature.personalId && !wizard.model.signature.method}}</span>
  <div ng-controller="SignatureController as sign">

    <h3 sxy-text="SALAXY.NG1.WorkerOnboardingComponent.stepContract.title"></h3>
    <p sxy-text="SALAXY.NG1.WorkerOnboardingComponent.stepContract.signatureText"></p>
    <p sxy-text="SALAXY.NG1.WorkerOnboardingComponent.stepContract.signatureText2"></p>
    <fieldset>
      <legend sxy-text="SALAXY.NG1.WorkerOnboardingComponent.stepContract.personalId"></legend>
      <div class="row" style="max-width:150px;">
        <salaxy-input name="personalId" label-type="plain" type="text" style="width:150px" sxy-personal-id-fi ng-required="true" placeholder="SALAXY.NG1.WorkerOnboardingComponent.stepContract.personalIdExample" ng-model="wizard.model.signature.personalId" sxy-personal-id-fi>
      </div>
      <div class="mb-2">
        <input ng-init="wizard.model.signature.terms = false" name="terms" type="checkbox" require="true" ng-model="wizard.model.signature.terms"></input>
        <span style="margin-left: 5px;" sxy-html="SALAXY.NG1.WorkerOnboardingComponent.stepContract.termsText.html"></span> <a ng-href="{{ wizard.getPdfPreviewAddress() }}" target="_blank"><span sxy-text="SALAXY.NG1.WorkerOnboardingComponent.stepContract.termsText2"></span></a>
        <span sxy-html="SALAXY.NG1.WorkerOnboardingComponent.stepContract.termsText3.html"></span>
      </div>
    </fieldset>
    <fieldset>
      <legend sxy-text="SALAXY.NG1.WorkerOnboardingComponent.stepContract.chooseBank"></legend>
      <div id="bankButtonRow">
        <salaxy-toggle-buttons 
          ng-model="wizard.model.signature.method" 
          options="$ctrl.signatureMethods" 
          type="row">
        </salaxy-toggle-buttons>
      </div>
    </fieldset>
    <p sxy-html="SALAXY.NG1.WorkerOnboardingComponent.stepContract.privacyPolicy.html"></p>

    <p>
      <span sxy-text="SALAXY.NG1.WorkerOnboardingComponent.stepContract.savePdfText"></span>
      <a ng-href="{{ wizard.getPdfPreviewAddress() }}" target="_blank">
        <span sxy-text="SALAXY.NG1.WorkerOnboardingComponent.stepContract.savePdfLink"></span>
      </a>
      <span sxy-text="SALAXY.NG1.WorkerOnboardingComponent.stepContract.savePdfText2"></span>
    </p>

  </div>
</form>`), s.put("salaxy-components/modals/onboarding/worker/contractButtons.html", `\uFEFF<button ng-click="wizard.goPrevious()" ng-disabled="!wizard.canGoPrevious" class="btn btn-default">{{'SALAXY.UI_Terms.previous' | sxyTranslate}}</button>
<div salaxy-loader class="spinner">
  <div class="bounce1"></div>
  <div class="bounce2"></div>
  <div class="bounce3"></div>
</div>
<button ng-if="wizard.model.signature.personalId == null || wizard.model.signature.method == null || wizard.model.signature.terms == false" ng-disabled="true" class="btn btn-primary">{{'SALAXY.NG1.WorkerOnboardingComponent.signBtn' | sxyTranslate}}</button>
<a ng-if="!(wizard.model.signature.personalId == null || wizard.model.signature.method == null || wizard.model.signature.terms == false)" ng-href="{{wizard.vismaSignUrl}}" target="_top" class="btn btn-primary">{{'SALAXY.NG1.WorkerOnboardingComponent.signBtn' | sxyTranslate}}</a>`), s.put("salaxy-components/modals/onboarding/worker/firstPageButtons.html", `\uFEFF<button class="btn btn-default" ng-click="$close('cancel')">{{'SALAXY.UI_Terms.backToFront' | sxyTranslate}}</button>
<div salaxy-loader class="spinner">
  <div class="bounce1"></div>
  <div class="bounce2"></div>
  <div class="bounce3"></div>
</div>

<button ng-click="wizard.goNext()" class="btn btn-primary" ng-disabled="!wizard.canGoNext">{{'SALAXY.UI_Terms.next' | sxyTranslate}}</button>`), s.put("salaxy-components/modals/onboarding/worker/index.html", `<div ng-controller="SessionController as sessionCtrl" class="worker-onboarding-wizard">
  <div ng-controller="WorkerOnboardingController as wizard">
    <div ng-controller="NaviController as $naviCtrl">
      <div ng-if="!$naviCtrl.showFullPageLoader">
        <div class="modal-header bg-primary">
          <img src="https://cdn.salaxy.com/img/palkkaus/logo/palkkaus-www-logo-white-border.png" class="img-responsive d-none b-sm-inline-block modal-logo" />
          <h2 class="modal-title" sxy-text="SALAXY.NG1.WorkerOnboardingComponent.title"></h2>
          <button type="button" class="btn-close btn-close-white" ng-click="$close('cancel')" aria-label="Close"></button>

          
        </div>
        <div class="modal-body">
          <div class="d-block d-md-none">
            <h4><span sxy-text="SALAXY.NG1.WorkerOnboardingComponent.step"></span> {{wizard.currentStep.number}}/{{wizard.steps.length}}</h4>
          </div>
          <div class="salaxy-wizard">
            <div class="wizard-steps">
              <div class="wizard-step" ng-repeat="step in $ctrl.steps" ng-class="{'active': step.active, 'disabled': step.disabled}">
                <span class="salaxy-avatar">
                  <div class="wizard-icons-wrapper">
                    <i class="bi" ng-class="step.active ? 'bi-circle-fill' : 'bi-circle'"></i>
                    <i class="bi bi-circle-fill"></i>
                  </div>
                  <strong class="number">{{ step.number }}</strong>
                </span>
                <span class="step-text">{{ step.title | sxyTranslate }}</span>
              </div>
            </div>
            <div class="wizard-strikethrough"></div>
          </div>
          <ng-include src="wizard.currentStep.view"></ng-include>
        </div>
        <div class="modal-footer">
          <ng-include class="d-flex justify-content-between w-100" src="wizard.currentStep.buttonsView"></ng-include>
        </div>
      </div>
    </div>
  </div>
</div>`), s.put("salaxy-components/modals/onboarding/worker/user-info.html", `\uFEFF<form name="currentForm">
  <!-- Hidden ariable formDataValidity to use in controller -->
  <span class="d-none">{{ wizard.formDataValidity = currentForm.$valid }}</span>

  <br/>
  <p sxy-text="SALAXY.NG1.WorkerOnboardingComponent.stepUserInfo.registerText"></p>
  <br>
  <div class="row">
    <div class="col-12 col-md-6">
      <div class="form-horizontal">
        <salaxy-input label="SALAXY.NG1.WorkerOnboardingComponent.stepUserInfo.firstName" name="Etunimi" ng-model="wizard.model.person.firstName" ng-required="true"></salaxy-input>
        <salaxy-input label="SALAXY.NG1.WorkerOnboardingComponent.stepUserInfo.lastName" name="Sukunimi" ng-model="wizard.model.person.lastName" ng-required="true"></salaxy-input>
        <salaxy-input label="SALAXY.NG1.WorkerOnboardingComponent.stepUserInfo.email" name="Sahkoposti" ng-model="wizard.model.person.contact.email" ng-required="true" sxy-email></salaxy-input>
      </div>
    </div>
    <div class="col-12 col-md-6">
      <div class="row language-selection mb-2" ng-controller="SessionController as $session">
        <div class="col-4 control-label"><strong class="" sxy-text="SALAXY.NG1.WorkerOnboardingComponent.stepUserInfo.language" ps=":"></strong></div>

        <div class="col-8">
          <div class="btn-group btn-group-sm float-end" role="group">
            <button class="btn btn-default" ng-class="{'active btn-primary' : $session.getLanguage() == 'fi'}" ng-click="$session.setLanguage('fi'); wizard.model.person.language = 'fi'">{{'SALAXY.ENUM.Language.fi.label' | sxyTranslate}}</button>
            <button class="btn btn-default " ng-class="{'active btn-primary' : $session.getLanguage() == 'en'}" ng-click="$session.setLanguage('en'); wizard.model.person.language = 'en'">{{'SALAXY.ENUM.Language.en.label' | sxyTranslate}}</button>
            <button class="btn btn-default" ng-class="{'active btn-primary' : $session.getLanguage() == 'sv'}" ng-click="$session.setLanguage('sv'); wizard.model.person.language = 'sv'">{{'SALAXY.ENUM.Language.sv.label' | sxyTranslate}}</button>
          </div>
        </div>

      </div>
      <div class="form-horizontal">
        <salaxy-input label="SALAXY.NG1.WorkerOnboardingComponent.stepUserInfo.phoneNumber" name="Puhelinnumero" ng-model="wizard.model.person.contact.telephone" ng-required="true" sxy-mobile-phone></salaxy-input>
      </div>
    </div>
  </div>
</form>`), s.put("salaxy-components/modals/payment/cfa/EInvoice.html", `<div class="modal-header">
  <h2 class="modal-title" id="salaxyEInvoiceLabel" sxy-text="SALAXY.NG1.NewPaymentComponent.einvoice.title"></h2>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

</div>
<div class="modal-body">
  <p sxy-text="SALAXY.NG1.NewPaymentComponent.einvoice.description"></p>
  <form name="address" class="form-horizontal">
    <salaxy-form-group name="eInvoiceReceiver" label="SALAXY.NG1.PaymentSettingsComponent.einvoice.invoiceAddress">
      <div class="input-group">
        <input required class="form-control" type="text" autocomplete="off" id="eInvoiceReceiver" name="eInvoiceReceiver" ng-disabled="true" ng-model="$ctrl.current.eInvoiceReceiver" >
        <span class="input-group-btn">
          <button type="button" class="btn btn-default" ng-click="$ctrl.logic.selectEInvoiceAddress($ctrl.current)" sxy-text="Valitse..."></button>
        </span>
      </div>
    </salaxy-form-group>
    <salaxy-input require="true" disabled="true" name="intermediator" ng-model="$ctrl.current.eInvoiceIntermediator" label="SALAXY.NG1.NewPaymentComponent.einvoice.intermediatorLabel"></salaxy-input>
  </form>
</div>
<div class="modal-footer text-start">
  <button type="submit" class="btn btn-primary float-end" ng-disabled="!address.$valid" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.send"></button>
  <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
</div>`), s.put("salaxy-components/modals/payment/cfa/Transfer.html", `<div class="modal-header">
  <h2 class="modal-title" id="salaxyTransferLabel" sxy-text="SALAXY.NG1.NewPaymentComponent.selection.creditTransferTitle"></h2>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
</div>
<div class="modal-body" id="modal-body">
  <div class="credit-transfer-container">
    <div class="text-end d-print-none">
      <button type="button" class="btn btn-default btn-sm" ng-click="$ctrl.logic.print('sxyFullPrint')" sxy-text="SALAXY.UI_Terms.print"></button>
      <button type="button" class="btn btn-default btn-sm" ng-click="$ctrl.logic.print('sxySecurePrint')" sxy-text="SALAXY.NG1.NewPaymentComponent.creditTransfer.securePrint"></button>
    </div>
    <salaxy-credit-transfer invoice="$ctrl.current">
      <message>
        <p sxy-text="SALAXY.NG1.NewPaymentComponent.creditTransfer.mainContent"></p>
      </message>
    </salaxy-credit-transfer>
    <div class="payment-per-worker-container table-responsive" ng-class="$ctrl.logic.printClass">
      <h4 sxy-text="SALAXY.NG1.NewPaymentComponent.creditTransfer.calcsBreakdown"></h4>
      <table>
        <thead>
          <tr>
            <th class="align-bottom" sxy-text="SALAXY.NG1.NewPaymentComponent.creditTransfer.worker"></th>
            <th class="right"><strong sxy-text="SALAXY.NG1.NewPaymentComponent.creditTransfer.totalGrossSalary"></strong></th>
            <th class="right"> <strong sxy-text="SALAXY.NG1.NewPaymentComponent.creditTransfer.payNow"></strong></th>
          </tr>
        </thead>
        <tbody>
          <tr class="payment-per-worker" ng-repeat="calc in $ctrl.logic.calculations">
            <td class="align-middle"> {{calc.worker.avatar.sortableName}}</td>
            <td class="right">{{calc.result.totals.totalGrossSalary | currency}}</td>
            <td class="right">
              {{calc.result.employerCalc.totalPayment| currency}}
            </td>
          </tr>
          <tr class="total">
            <td><strong sxy-text="SALAXY.NG1.NewPaymentComponent.creditTransfer.paymentPerWorkerTable.total"></strong><br><span sxy-text="SALAXY.NG1.NewPaymentComponent.creditTransfer.paymentPerWorkerTable.palkkausFee"></span></td>
            <td class="right">{{$ctrl.logic.totalResultCalculation.result.totals.totalGrossSalary | currency}}</td>
            <td class="right">
              {{$ctrl.logic.totalResultCalculation.result.employerCalc.totalPayment | currency}}<br>{{$ctrl.logic.totalResultCalculation.result.employerCalc.palkkaus | currency}}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div sxy-if-role="!household" class="table-responsive">
      <h4 sxy-text="SALAXY.NG1.NewPaymentComponent.creditTransfer.paymentTable"></h4>
      <salaxy-calc-report apply-site-styles="true" calc="$ctrl.logic.totalResultCalculation" report-type="'paymentReport'" template-name="'paymentTablesV2'"></salaxy-calc-report>
    </div>
  </div>
</div>
<div class="modal-footer text-start d-print-none">
  <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
</div>`), s.put("salaxy-components/modals/payment/PaymentCancel.html", `<div class="modal-header">
  <h2 class="modal-title" id="salaxyPaymentCancelDialogLabel" sxy-text="SALAXY.NG1.PaymentCancelDialogComponent.paymentCancelled"></h2>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
</div>
<div class="modal-body">
  <p sxy-text="SALAXY.NG1.PaymentCancelDialogComponent.paymentCancelledBank"></p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-danger" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
</div>`), s.put("salaxy-components/modals/payment/PaymentConfirm.html", `<div class="modal-header">
  <h2 class="modal-title" id="salaxyPaymentConfirmDialogLabel" sxy-text="SALAXY.NG1.PaymentConfirmDialogComponent.paymentConfirmed"></h2>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

</div>
<div class="modal-body">
  <p sxy-text="SALAXY.NG1.PaymentConfirmDialogComponent.paymentConfirmedInfo"></p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-danger" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
</div>`), s.put("salaxy-components/modals/payment/psd/BankSelection.html", `<div class="modal-header">
  <h2 class="modal-title" id="salaxyPaymentConfirmDialogLabel" sxy-text="Valitse pankki"></h2>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
</div>
<div class="modal-body">
  <div class="d-flex flex-column align-items-start">
    <p sxy-text="Valitse pankki, josta haluat suorittaa PSD-maksun"></p>
    <div ng-click="$ctrl.logic.selectBank(bank.id)" ng-repeat="bank in $ctrl.logic.banks" class="btn btn-default mb-2" style="width: 400px; height: 50px;" ng-class="{'active': $ctrl.logic.selectedBank === bank.id}" aria-label="{{bank.name}}">
      <img ng-src="{{bank.logo}}" style="max-height: 20px; max-width: 85px" />
        {{bank.name}}
    </div>
    <salaxy-input-boolean type="checkbox" name="forceAccountAuthorization" ng-model="$ctrl.logic.forceAccountAuthorization" label="Pakota uudelleen valtuutus" class="w-100"></salaxy-input-boolean>
  </div>
</div>
<div class="modal-footer">
  <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
  <button type="submit" class="btn btn-primary" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.select"></button>
</div>`), s.put("salaxy-components/modals/payroll/PayrollDetailsList.html", `<div class="modal-worker-list">
  <div class="modal-header">
    <h2 class="modal-title">{{$ctrl.logic.title}}</h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

  </div>
  <div class="modal-body">
    <div class="table-responsive" style="max-height: calc(100vh - 300px)">
      <salaxy-payroll-details-select-list category="{{ $ctrl.logic.category || 'draft' }}" mode="select" selected-items="$ctrl.current"></salaxy-payroll-details-select-list>
    </div>
    <div class="text-end">
      <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
      <button type="submit" class="btn btn-primary" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.save"></button>
    </div>
  </div>
</div>`), s.put("salaxy-components/modals/payroll/PayrollList.html", `<div class="modal-worker-list">
  <div class="modal-header">
    <h2 class="modal-title">{{$ctrl.logic.title}}</h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

  </div>
  <div class="modal-body">
    <div class="table-responsive" style="max-height: calc(100vh - 300px)">
      <salaxy-payroll-select-list category="{{ $ctrl.logic.category || 'draft' }}" mode="select" selected-items="$ctrl.current"></salaxy-payroll-select-list>
    </div>
    <div class="text-end">
      <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
      <button type="submit" class="btn btn-primary" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.save"></button>
    </div>
  </div>
</div>`), s.put("salaxy-components/modals/records/Record.html", `<div class="modal-header">
  <h2 class="modal-title">{{ $ctrl.logic.title }}</h2>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
</div>
<div class="modal-body">
  <form class="form-horizontal" name="record" ng-readonly="$ctrl.logic.readOnly">
    <fieldset>
      <div class="subtext">
        {{ 'SALAXY.NG1.WorkerDetailsComponent.records.createTypeInfo' | sxyTranslate }}
      </div>
      <salaxy-form-group ng-if="!$ctrl.logic.readOnly" name="recordType" label="SALAXY.NG1.WorkerDetailsComponent.records.recordType">
        <div class="input-group">
          <input ng-model="$ctrl.current.record.recordType" type="text" class="form-control">
          <div class="input-group-btn dropdown">
            <button type="button" class="btn btn-default dropdown-toggle h-100" data-bs-toggle="dropdown"></button>
            <ul class="dropdown-menu dropdown-menu-end">
              <li ng-repeat="recordType in $ctrl.logic.recordTypes">
                <a href="" ng-click="$ctrl.current.record.recordType = recordType" class="dropdown-item">{{recordType}}</a>
              </li>
              <li ng-if="!$ctrl.logic.recordTypes">
                <a href="" class="dropdown-item disabled" style="font-style: italic;">
                  {{ 'SALAXY.NG1.WorkerDetailsComponent.records.noTypes' | sxyTranslate }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </salaxy-form-group>
      <salaxy-input ng-if="$ctrl.logic.readOnly" ng-model="$ctrl.current.record.recordType" label="SALAXY.NG1.WorkerDetailsComponent.records.recordType" name="recordType"></salaxy-input>
      <salaxy-input ng-model="$ctrl.current.record.title" label="SALAXY.NG1.WorkerDetailsComponent.records.title" name="title"></salaxy-input>
      <salaxy-textarea ng-model="$ctrl.current.record.text" label="SALAXY.NG1.WorkerDetailsComponent.records.text" name="text"></salaxy-textarea>
      <salaxy-form-group name="attachments" label="SALAXY.NG1.WorkerDetailsComponent.records.attachments">
        <table>
          <tr ng-repeat="attachment in $ctrl.current.record.attachments">
            <td><i class="bi {{ $ctrl.logic.getAttachmentIcon(attachment) }} text-primary float-start me-1"></i> <a target="_blank"
                ng-href="{{$ctrl.logic.getAttachmentDownloadUrl(attachment)}}">{{attachment.fileName}}</a></td>
            <td class="text-end">
              <button type="button" class="btn btn-danger btn-xs" ng-if="!$ctrl.logic.readOnly" ng-click="$ctrl.current.record.attachments.splice($index, 1)"><i class="bi bi-trash"
                  title="{{'SALAXY.UI_Terms.removeAttachment' | sxyTranslate}}"></i></button>
            </td>
          </tr>
          <tr>
            <td></td>
            <td class="text-end">
              <button type="button" class="btn btn-primary btn-xs" ng-if="!$ctrl.logic.readOnly" ngf-select="$ctrl.logic.uploadAttachments($files, $ctrl.current.record.attachments)"
                ngf-multiple="true" ngf-max-size="10MB"><i class="bi bi-paperclip" title="{{'SALAXY.UI_Terms.addAttachment' | sxyTranslate}}"></i></button>
            </td>
          </tr>
        </table>
      </salaxy-form-group>
      <salaxy-datepicker-popup ng-model="$ctrl.current.record.startDate" label="SALAXY.NG1.WorkerDetailsComponent.records.startDate" name="startDate"></salaxy-datepicker-popup>
    </fieldset>
    <fieldset>
      <legend sxy-text="SALAXY.NG1.WorkerDetailsComponent.records.badge"></legend>
      <div class="subtext">
        {{ 'SALAXY.NG1.WorkerDetailsComponent.records.badgeInfo' | sxyTranslate }}
      </div>
      <salaxy-input label="SALAXY.NG1.WorkFlowEventEditComponent.description" name="message" ng-model="$ctrl.current.wfEvent.message"></salaxy-input>
      <salaxy-input-enum type="select" enum="BootstrapStyle" label="SALAXY.NG1.WorkFlowEventEditComponent.ui" name="ui" require="$ctrl.current.wfEvent.message" ng-model="$ctrl.current.wfEvent.ui"></salaxy-input-enum>
    </fieldset>
  </form>
</div>
<div class="modal-footer">
  <button type="reset" ng-if="!$ctrl.logic.readOnly" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
  <button type="button" ng-if="$ctrl.logic.readOnly" class="btn btn-primary" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
  <button type="button" ng-if="!$ctrl.logic.readOnly" class="btn btn-primary" ng-disabled="!record.$valid" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.save"></button>
</div>`), s.put("salaxy-components/modals/report/AccountingReport.html", `<div class="modal-header">
  <h2 class="modal-title" sxy-text="SALAXY.NG1.AccountingReportComponent.accountingReports"></h2>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

</div>
<div class="modal-body">
  <salaxy-accounting-report-tools any-expanded="$reportRows.anyExpanded" on-expand-change="$reportRows.expand(close)" on-target-change="$ctrl.data.loadCurrent(targetId)"  reader="$ctrl.data.reader"></salaxy-accounting-report-tools>
  <salaxy-accounting-report-rows ng-show="!$ctrl.data.isLoading" ng-ref="$reportRows" data="$ctrl.data.accountingData"></salaxy-accounting-report-rows>
  <salaxy-spinner ng-if="$ctrl.data.isLoading" full-screen="false" heading="SALAXY.UI_Terms.loading" text="SALAXY.NG1.AccountingReportComponent.loadingReport"></salaxy-spinner>
</div>`), s.put("salaxy-components/modals/report/SummaryReport.html", `<div class="modal-header">
  <h2 class="modal-title" sxy-text="SALAXY.NG1.SummaryReportComponent.summaryReport"></h2>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

</div>
<div class="modal-body ">
  <salaxy-spinner ng-if="$ctrl.data.isLoading" full-screen="false" heading="SALAXY.UI_Terms.loading" text="SALAXY.NG1.SummaryReportComponent.loadingReport"></salaxy-spinner>
  <salaxy-summary-report ng-if="!$ctrl.data.isLoading" data="$ctrl.data.summaryReportData"></salaxy-summary-report>
</div>`), s.put("salaxy-components/modals/report/WorkerSummaryReport.html", `<div class="modal-header">
  <h2 class="modal-title" sxy-text="SALAXY.NG1.SummaryReportComponent.summaryReport"></h2>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

</div>
<div class="modal-body">
  <salaxy-spinner ng-if="$ctrl.data.isLoading" full-screen="false" heading="SALAXY.UI_Terms.loading" text="SALAXY.NG1.SummaryReportComponent.loadingReport"></salaxy-spinner>
  <salaxy-worker-summary-report ng-if="!$ctrl.data.isLoading" data="$ctrl.data.workerSummaryReportData"></salaxy-worker-summary-report>
</div>`), s.put("salaxy-components/modals/settings/AccountantSelection.html", `<div class="modal-header">
  <h2 class="modal-title" sxy-text="SALAXY.NG1.AccountantSelectionComponent.heading"></h2>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
</div>

<div class="modal-body">
  <div ng-if="!$ctrl.logic.selected" class="row">
    <div class="col-12">
      <fieldset>
        <legend sxy-text="SALAXY.NG1.AccountantSelectionComponent.accountantType"></legend>
        <salaxy-input-enum ng-model="$ctrl.logic.type" type="radio" name="logicType" label="SALAXY.NG1.AccountantSelectionComponent.companyOrPerson" options="{ 
                          company: ('SALAXY.NG1.AccountantSelectionComponent.companyEnum' | sxyTranslate),
                          none: ('SALAXY.NG1.AccountantSelectionComponent.personEnum' | sxyTranslate)}">
        </salaxy-input-enum>
      </fieldset>
    </div>
  </div>
  <form name="personAccountantForm" class="form-horizontal">
    <div ng-if="$ctrl.logic.type == 'none'" class="row">
      <div class="col-12">
        <fieldset>
          <salaxy-input name="firstName" label="SALAXY.NG1.AccountantSelectionComponent.personAccountantForm.firstName" ng-model="$ctrl.current.info.avatar.firstName"></salaxy-input>
          <salaxy-input name="lastName" label="SALAXY.NG1.AccountantSelectionComponent.personAccountantForm.lastName"  ng-model="$ctrl.current.info.avatar.lastName"></salaxy-input>
          <salaxy-input name="email" label="SALAXY.NG1.AccountantSelectionComponent.personAccountantForm.email"  sxy-email ng-model="$ctrl.current.info.email"></salaxy-input>
          <salaxy-input name="telephone" label="SALAXY.NG1.AccountantSelectionComponent.personAccountantForm.telephone"  sxy-mobile-phone ng-model="$ctrl.current.info.telephone"></salaxy-input>
        </fieldset>
      </div>
    </div>
  </form>
  <div ng-if="!$ctrl.logic.selected && $ctrl.logic.type == 'company'" class="row">
    <div class="col-12">
      <legend sxy-text="SALAXY.NG1.AccountantSelectionComponent.searchAccountingFirm"></legend>
    </div>
  </div>
  <div ng-if="!$ctrl.logic.selected && $ctrl.logic.type == 'company'" class="table-responsive" style="max-height: calc(100vh - 200px)">
    <table class="table table-striped">
      <thead>
        <tr>
          <th colspan="2" sxy-text="SALAXY.NG1.AccountantSelectionComponent.name"></th>
          <th sxy-text="SALAXY.NG1.AccountantSelectionComponent.officialId"></th>
          <th class="right">
            <form name="searchForm">
              <salaxy-form-group name="search" label-type="plain">
                <div class="input-group">
                  <input class="form-control" type="text" autocomplete="off" id="searchAccountant" name="searchAccountant" ng-model="$ctrl.logic.searchInput" require="true" ng-minlength="3">
                  <span class="input-group-btn">
                    <button type="submit" ng-disabled="!searchForm.$valid" class="btn btn-default"
                      ng-click="$ctrl.logic.search($ctrl.logic.searchInput)"><span ng-show="$ctrl.logic.isLoading"><i
                          class="bi bi-arrow-repeat bi-spin"></i></span><span ng-show="!$ctrl.logic.isLoading"><i class="bi bi-search"></i></span></button>
                  </span>
                </div>
            </form>
            </salaxy-form-group>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.logic.searchResult">
          <td class="td-avatar middle">
            <salaxy-avatar avatar="row.avatar"></salaxy-avatar>
          </td>
          <td class="td-name  middle">
            <strong>{{row.avatar.displayName}}</strong><br />
          </td>
          <td class="td-name  middle">
            <strong>{{row.officialId}}</strong><br />
          </td>
          <td class="right middle">
            <button class="btn btn-sm btn-default" type="button" ng-click="$ctrl.logic.select($ctrl.current, row)">
              {{ 'SALAXY.UI_Terms.select' | sxyTranslate }}
            </button>
          </td>
        </tr>
        <tr ng-if="$ctrl.logic.searchResult.length == 0">
          <td colspan="4" sxy-text="SALAXY.NG1.AccountantSelectionComponent.noSearchResult"></td>
        </tr>
      </tbody>
    </table>
  </div>
  <form name="companyAccountantForm" class="form-horizontal">
    <div ng-if="$ctrl.logic.selected && $ctrl.logic.type == 'company'">
      <div class="container-fixed salaxy-component salaxy-accountant-info">
        <button ng-if="$ctrl.current.type != 'primaryPartner'" class="btn btn-default float-end" ng-click="$ctrl.logic.reset($ctrl.current)" sxy-text="SALAXY.NG1.AccountantSelectionComponent.companyAccountantForm.search"></button>
        <div class="table">
          <table>
            <tr class="border-0">
              <td>
                <salaxy-avatar style="margin-right: 40px;" class="avatar-xl" avatar="$ctrl.current.info.avatar"></salaxy-avatar>
              </td>
              <td ng-if="$ctrl.current.type != 'primaryPartner'">
                <p class="lead" sxy-text="SALAXY.NG1.AccountantSelectionComponent.companyAccountantForm.notPrimaryPartner.lead" ps="."></p>

                <div class="input-info">
                  <div class="input-info-icon"><i class="bi bi-info-circle-fill text-default"></i></div>
                  <p ng-if="$ctrl.current.info.avatar.id" class="input-info-text with-icon" sxy-text="SALAXY.NG1.AccountantSelectionComponent.companyAccountantForm.notPrimaryPartner.partnerInfo" ps="."></p>
                  <p ng-if="!$ctrl.current.info.avatar.id" class="input-info-text with-icon" sxy-text="SALAXY.NG1.AccountantSelectionComponent.companyAccountantForm.notPrimaryPartner.notPartnerInfo" ps="."></p>
                </div>
              </td>
              <td ng-if="$ctrl.current.type == 'primaryPartner'">
                <p class="lead" sxy-text="SALAXY.NG1.AccountantSelectionComponent.companyAccountantForm.primaryPartner.lead" ps="."></p>

                <div class="input-info">
                  <div class="input-info-icon"><i class="bi bi-info-circle-fill text-default"></i></div>
                  <p ng-if="$ctrl.current.info.avatar.id" class="input-info-text with-icon" sxy-text="SALAXY.NG1.AccountantSelectionComponent.companyAccountantForm.primaryPartner.partnerInfo" ps="."></p>
                </div>
              </td>
            </tr>
          </table>
        </div>
        <div class="table-responsive">
          <table class="table">
            <tr>
              <th sxy-text="Nimi" ps=":"></th>
              <td>{{ $ctrl.current.info.avatar.displayName}}</td>
            </tr>
            <tr>
              <th sxy-text="Y-tunnus" ps=":"></th>
              <td>{{ $ctrl.current.info.officialId}}</td>
            </tr>
            <tr ng-if="!$ctrl.current.info.avatar.id">
              <th sxy-text="SALAXY.NG1.AccountantSelectionComponent.companyAccountantForm.accountantPermissions" ps=":"></th>
              <td>
                <salaxy-input-enum disabled="true" ng-model="$ctrl.current.type" type="radio" name="partnerType" label="" label-type="plain" options="{ 
                unlinkedPrimaryPartner: ('SALAXY.NG1.AccountantSelectionComponent.companyAccountantForm.unlinkedPrimaryPartnerEnum' | sxyTranslate),
                unlinkedAccountingOnly: ('SALAXY.NG1.AccountantSelectionComponent.companyAccountantForm.unlinkedAccountingOnlyEnum' | sxyTranslate)}">
                </salaxy-input-enum>
              </td>
            </tr>
            <tr ng-if="$ctrl.current.info.avatar.id">
              <th sxy-text="SALAXY.NG1.AccountantSelectionComponent.companyAccountantForm.accountantPermissions" ps=":"></th>
              <td>
                <salaxy-input-enum  ng-if="$ctrl.current.type != 'primaryPartner'" ng-model="$ctrl.current.type" type="radio" name="partnerType" label="" label-type="plain" options="{ 
                pendingPrimaryPartner: ('SALAXY.NG1.AccountantSelectionComponent.companyAccountantForm.pendingPrimaryPartnerEnum' | sxyTranslate),
                unlinkedAccountingOnly: ('SALAXY.NG1.AccountantSelectionComponent.companyAccountantForm.unlinkedAccountingOnlyEnum' | sxyTranslate)}">
                </salaxy-input-enum>
                <salaxy-input-enum ng-if="$ctrl.current.type == 'primaryPartner'" read-only="true" ng-model="$ctrl.current.type" type="radio" name="partnerType" label="" label-type="plain" options="{ 
                  primaryPartner: ('SALAXY.NG1.AccountantSelectionComponent.companyAccountantForm.primaryPartnerEnum' | sxyTranslate)}">
                </salaxy-input-enum>
              </td>
            </tr>
            <tr>
              <th sxy-text="SALAXY.NG1.AccountantSelectionComponent.personAccountantForm.email" ps=":"></th>
              <td>
                <salaxy-input name="email" label="" label-type="plain" sxy-email ng-model="$ctrl.current.info.email"></salaxy-input>
              </td>
            </tr>
            <tr>
              <th sxy-text="SALAXY.NG1.AccountantSelectionComponent.personAccountantForm.telephone" ps=":"></th>
              <td>
                <salaxy-input name="telephone" label="" label-type="plain" sxy-mobile-phone ng-model="$ctrl.current.info.telephone"></salaxy-input>
              </td>
            </tr>
          </table>
        </div>

      </div>
    </div>
  </form>
</div>

<div class="modal-footer text-end">
  <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
  <button type="button" ng-if="$ctrl.current.type != 'primaryPartner'" class="btn btn-danger" ng-click="$close('remove')" sxy-text="SALAXY.UI_Terms.delete"></button>
  <button type="button" ng-if="$ctrl.current.type == 'primaryPartner' && !$ctrl.logic.removalDisabled" class="btn btn-danger" ng-click="$close('removePrimaryPartner')" sxy-text="SALAXY.NG1.AccountantSelectionComponent.companyAccountantForm.deletePrimaryPartner"></button>
  <button type="button" ng-disabled="(!$ctrl.logic.selected && $ctrl.logic.type == 'company') || personAccountantForm.$invalid || companyAccountantForm.$invalid" class="btn btn-primary" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.save"></button>
</div>
`), s.put("salaxy-components/modals/settings/BrandSelection.html", `<form name="brandForm" class="form-horizontal">
  <div class="modal-header">
    <h2 class="modal-title" sxy-text="SALAXY.NG1.BrandSelectionComponent.title"></h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

  </div>
  <div class="modal-body">
    <div class="table-responsive" style="max-height: calc(100vh - 300px)">
      <salaxy-odata-table 
        url="/v03/api/settings/brands" 
        template-url="salaxy-components/odata/lists/BrandList.html" 
        options="{ $filter: 'data/skin ne null and data/skin ne \\'\\'' }"
        selected-items="selectedItems"
        on-list-select="($ctrl.current.brand = value == true ? item : null);( selectedItems = value == true? [item ]: []);">
    </salaxy-odata-table>
    </div>
  </div>
  <div class="modal-footer">
      <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
      <button type="button" class="btn btn-default" ng-click="$close('set-default')" sxy-text="SALAXY.NG1.BrandSelectionComponent.useDefaultStyle"></button>
      <button type="submit" class="btn btn-primary" ng-disabled="!$ctrl.current.brand" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.save"></button>
  </div>
</form>`), s.put("salaxy-components/modals/settings/EntryCodes.html", `<div class="modal-header">
  <h2 class="modal-title" sxy-text="SALAXY.NG1.EntryCodesComponent.title"></h2>
  <button type="button" class="ms-auto btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
</div>
<div class="modal-body" id="modal-body">
  <form name="entryCodesForm" class="form-horizontal">
    <div class="row">
      <div class="col-12">
        <salaxy-input-typeahead label="SALAXY.NG1.EntryCodesComponent.entryCodeGroupLabel" name="EntryCodeGroup" ng-model="$ctrl.current.entryCodeGroup" options="$ctrl.logic.entryCodeGroups"></salaxy-input-typeahead>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <salaxy-input-typeahead label="SALAXY.NG1.EntryCodesComponent.incomeTypeLabel" ng-if="$ctrl.current.entryCodeGroup == 'incomeType'" name="IncomeType" ng-model="$ctrl.current.entryCode" options="$ctrl.logic.incomeTypes"></salaxy-input-typeahead>
        <salaxy-input-typeahead label="SALAXY.NG1.EntryCodesComponent.totalTypeLabel" ng-if="$ctrl.current.entryCodeGroup == 'totalType'" name="TotalType" ng-model="$ctrl.current.entryCode" options="$ctrl.logic.totalTypes"></salaxy-input-typeahead>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-default float-end" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
  <button type="button" class="btn btn-primary float-end" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.save"></button>
</div>`), s.put("salaxy-components/modals/settings/Flags.html", `<div class="modal-header">
  <h2 class="modal-title" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.additionalSelectionsHead"></h2>
  <button type="button" class="ms-auto btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
</div>
<div class="modal-body" id="modal-body">
  <div class="table-responsive" style="max-height: 40vh;">
    <table class="table table-sm">
      <thead>
        <tr>
          <th colspan="2" sxy-text="SALAXY.NG1.FlagsComponent.flag"></th>
          <th class="text-right">
            <button type="button" class="btn btn-primary btn-xs" ng-click="$ctrl.logic.addFlag($ctrl.current)" sxy-text="SALAXY.UI_Terms.addRow"></button>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="item in $ctrl.current.flags track by $index">
          <td><span class="badge" ng-class="$ctrl.logic.getFlagText(item).found ? 'bg-success' : 'bg-warning'">{{$ctrl.logic.getFlagText(item).text}}</span></td>
          <td>
            <salaxy-input ng-model="$ctrl.current.flags[$index]" name="{{ 'flag' + $index }}" label-type="plain"  ></salaxy-input>
          </td>
          <td class="text-right">
            <button type="button" class="btn btn-danger btn-xs" ng-click="$ctrl.current.flags.splice($index,1)" title="{{'SALAXY.UI_Terms.deleteRow' | sxyTranslate}}"><i class="bi bi-trash-fill"></i></button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-default float-end" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
  <button type="button" class="btn btn-primary float-end" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.save"></button>
</div>`), s.put("salaxy-components/modals/settings/FlagSelection.html", `<div class="modal-header">
  <h2 class="modal-title" sxy-text="SALAXY.NG1.FlagsComponent.title"></h2>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
</div>
<div class="modal-body" id="modal-body">
  <form name="FlagForm" class="form-horizontal">
    <div class="row">
      <div class="col-xs-12">
        <salaxy-input-enum require="true" label="SALAXY.NG1.FlagsComponent.prefix" name="Prefix" ng-model="$ctrl.current.prefix" options="$ctrl.logic.prefixOptions" type="radio"></salaxy-input-enum>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12" ng-switch="$ctrl.current.prefix">
        <salaxy-input-enum require="true" ng-switch-when="employmentType" label="SALAXY.NG1.EmploymentRelation.employmentRelation"  name="EmploymentType" ng-model="$ctrl.current.value" enum="EmploymentRelationType" type="select"></salaxy-input-enum>
        <salaxy-input-enum require="true" ng-switch-when="pensionCalculation" label="SALAXY.NG1.WorkerWizardComponent.employment.pension.title"  name="PensionCalculation" ng-model="$ctrl.current.value" options="$ctrl.logic.pensionCalculation" type="select"></salaxy-input-enum>
        <salaxy-calc-row-type ng-switch-when="rowType" label="SALAXY.NG1.CalcRowTypeComponent.rowType"  name="rowType" model="$ctrl.logic.asUserDefinedRow($ctrl.current)" ></salaxy-calc-row-type>
        <salaxy-calc-row-type ng-switch-when="type" label="SALAXY.NG1.CalcRowTypeComponent.wageType"  name="type" model="$ctrl.logic.asUserDefinedRow($ctrl.current)" ></salaxy-calc-row-type>
        <salaxy-input-enum require="true" ng-switch-when="dimension" label="SALAXY.MODEL.CostAccountingSettings.title"  name="Dimension" ng-model="$ctrl.current.value" options="$ctrl.logic.dimension" type="select"></salaxy-input-enum>
        <salaxy-input require="true" ng-switch-when="dimension" label="SALAXY.MODEL.CostAccountingDimensionOption.value.title"  name="dimensionValue" ng-model="$ctrl.current.dimensionValue"></salaxy-input>
        <salaxy-input-enum require="true" ng-switch-when="selfPayment" label="SelfPayment"  name="SelfPayment" ng-model="$ctrl.current.value" options="$ctrl.logic.selfPayment" type="select"></salaxy-input-enum>
        <salaxy-input-enum require="true" ng-switch-when="behavior" label="Behavior"  name="Behavior" ng-model="$ctrl.current.value" enum="CalculationFlag" type="select"></salaxy-input-enum>
        <salaxy-input require="true" ng-switch-when="regex" label="Regex"  name="regex" ng-model="$ctrl.current.value"></salaxy-input>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-default float-end" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
  <button type="button" class="btn btn-primary float-end" ng-disabled="!FlagForm.$valid || ( ($ctrl.current.prefix == 'rowType' || $ctrl.current.prefix == 'type' )  && !$ctrl.current.value)" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.save"></button>
</div>`), s.put("salaxy-components/modals/settings/PaymentChannel.html", `<form name="periodForm" class="form-horizontal">
  <div class="modal-header">
    <h2 class="modal-title">{{ $ctrl.logic.channelAvatar.displayName }}, asetukset</h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

  </div>
  <div class="modal-body">
    <div class="form-horizontal">
      <p class="lead">
        <strong>{{ $ctrl.logic.channelAvatar.displayName }}</strong>: {{ $ctrl.logic.channelAvatar.description }}
      </p>
      <div ng-switch="$ctrl.current.id">
        <fieldset ng-switch-when="palkkausCfaFinvoice|palkkausEcfaFinvoice"  ng-switch-when-separator="|">
          <legend sxy-text="SALAXY.NG1.PaymentChannelDialogComponent.palkkausCfaFinvoice.legend"></legend>
          <salaxy-form-group name="eInvoiceReceiver" label="SALAXY.NG1.PaymentChannelDialogComponent.palkkausCfaFinvoice.eInvoiceAddress">
            <div class="input-group">
              <input class="form-control" type="text" autocomplete="off" id="eInvoiceReceiver" name="eInvoiceReceiver" ng-disabled="true" ng-model="$ctrl.current.invoiceSettings.eInvoiceReceiver">
              <span class="input-group-btn">
                <button type="button" class="btn btn-default" ng-click="$ctrl.logic.selectEInvoiceAddress($ctrl.current.invoiceSettings)" sxy-text="SALAXY.UI_Terms.choose"></button>
              </span>
            </div>
          </salaxy-form-group>
          <salaxy-input disabled="true" name="intermediator" ng-model="$ctrl.current.invoiceSettings.eInvoiceIntermediator" label="SALAXY.NG1.PaymentChannelDialogComponent.palkkausCfaFinvoice.intermediator"></salaxy-input>
        </fieldset>
        <fieldset ng-switch-when="palkkausCfaPaytrail|palkkausEcfaPaytrail|palkkausCfaReference|palkkausEcfaReference|palkkausCfaFinvoice|palkkausEcfaFinvoice|palkkausCfaTest" ng-switch-when-separator="|">
          <fieldset>
            <legend sxy-text="SALAXY.NG1.PaymentChannelDialogComponent.palkkausCfaPaytrail.legend"></legend>
            <p sxy-text="SALAXY.NG1.PaymentChannelDialogComponent.palkkausCfaPaytrail.infoText"></p>
            <salaxy-input-boolean type="checkbox" name="isTaxAndSocialSecuritySelfHandling" label-type="plain" label-true="SALAXY.NG1.PaymentChannelDialogComponent.palkkausCfaPaytrail.isTaxAndSocialSecuritySelfHandling" ng-model="$ctrl.current.customerFundsSettings.isTaxAndSocialSecuritySelfHandling"></salaxy-input-boolean>
            <salaxy-input-boolean type="checkbox" name="isWorkerSelfHandling" label-type="plain" label-true="SALAXY.NG1.PaymentChannelDialogComponent.palkkausCfaPaytrail.isWorkerSelfHandling" ng-model="$ctrl.current.customerFundsSettings.isWorkerSelfHandling"></salaxy-input-boolean>
            <div>&nbsp;</div>
            <div class="alert alert-warning" sxy-html="SALAXY.NG1.PaymentChannelDialogComponent.palkkausCfaPaytrail.alert.html"></div>
          </fieldset>
        </fieldset>
        <fieldset ng-switch-when="palkkausManual|talenomManual|hausvise|passeliMerit" ng-switch-when-separator="|">
          <legend sxy-text="SALAXY.NG1.PaymentChannelDialogComponent.palkkausManual.legend"></legend>
          <salaxy-input label-cols="col-sm-6" name="ibanNumber" label="SALAXY.NG1.PaymentChannelDialogComponent.palkkausManual.ibanNumber" sxy-iban ng-model="$ctrl.current.invoiceSettings.ibanNumber"></salaxy-input>
          <salaxy-input label-cols="col-sm-6" name="sepaBankPartyId" label="SALAXY.NG1.PaymentChannelDialogComponent.palkkausManual.sepaBankPartyId" ng-model="$ctrl.current.invoiceSettings.sepaBankPartyId"></salaxy-input>
        </fieldset>
        <!--fieldset ng-switch-when="palkkausInvoices">
          <legend sxy-text="SALAXY.NG1.PaymentChannelDialogComponent.palkkausInvoices.legend"></legend>
          <salaxy-input name="creditCard" disabled="true" label="SALAXY.NG1.PaymentChannelDialogComponent.palkkausInvoices.creditCard" ng-model="dummy"></salaxy-input     
        </fieldset-->
        <fieldset ng-switch-default>
          <div class="alert alert-info" sxy-text="SALAXY.NG1.PaymentChannelDialogComponent.default.info"></div>
        </fieldset>
      </div>
    </div>
  </div>
  <div class="modal-footer d-flex">
    <button type="button" ng-if="$ctrl.current.settings.isEnabled && $ctrl.current.settings.isAvailable" class="btn btn-danger" ng-disabled="$ctrl.current.isReadOnly" ng-click="$close('delete')" sxy-text="SALAXY.UI_Terms.unenable"></button>
    <button type="reset" ng-click="$close('cancel')" class="btn btn-default ms-auto" sxy-text="SALAXY.UI_Terms.cancel"></button>
    <button type="button" ng-if="!$ctrl.current.isDefault  && $ctrl.current.settings.isAvailable" class="btn btn-default" ng-disabled="$ctrl.current.isReadOnly && !$ctrl.current.settings.isEnabled" ng-click="$close('set-default')" sxy-text="SALAXY.UI_Terms.setDefault"></button>
    <button type="submit" ng-if="$ctrl.current.settings.isEnabled  && $ctrl.current.settings.isAvailable" class="btn btn-primary" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.save"></button>
    <button type="button" ng-if="!$ctrl.current.settings.isEnabled  && $ctrl.current.settings.isAvailable" class="btn btn-primary" ng-disabled="$ctrl.current.isReadOnly" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.enable"></button>
  </div>
</form>`), s.put("salaxy-components/modals/settings/UiTranslator.html", `
<div class="modal-ui-translation">
  <div class="modal-header">
    <h2 class="modal-title">{{$ctrl.logic.title}}</h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

  </div>
  <div class="modal-body">
    <salaxy-ui-translator></salaxy-ui-translator>
    <div>
      <button type="submit" class="btn btn-primary float-end" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.save"></button>
      <button type="reset" class="btn btn-default float-end" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
    </div>
  </div>
</div>`), s.put("salaxy-components/modals/ui/Alert.html", `<div class="modal-header">
  <h3 class="modal-title" id="modal-title">{{$ctrl.data.heading | sxyTranslate}}</h3>
</div>
<div ng-if="$ctrl.data.text" class="modal-body salaxy-component" id="modal-body">
  <p class="pre-wrap">{{$ctrl.data.text | sxyTranslate}}</p>
</div>
<div class="modal-footer">
  <button class="btn btn-primary" type="button" ng-click="$close('ok')">{{$ctrl.data.okText | sxyTranslate}}</button>
</div>`), s.put("salaxy-components/modals/ui/Confirm.html", `<div class="modal-header">
  <h3 class="modal-title" id="modal-title">{{$ctrl.data.heading | sxyTranslate}}</h3>
</div>
<div ng-if="$ctrl.data.text || $ctrl.data.html" class="modal-body" id="modal-body">
  <p ng-if="!$ctrl.data.html" class="pre-wrap">{{$ctrl.data.text | sxyTranslate}}</p>
  <div ng-if="$ctrl.data.html" sxy-html="{{$ctrl.data.html}}"></div>
</div>
<div class="modal-footer">
  <button class="btn btn-default" type="button" ng-click="$close(false)">{{$ctrl.data.cancelText | sxyTranslate}}</button>
  <button class="btn btn-primary" type="button" ng-click="$close(true)">{{$ctrl.data.okText | sxyTranslate}}</button>
</div>`), s.put("salaxy-components/modals/ui/DialogWindow.html", `<div id="salaxyDialog" class="salaxy-component salaxy-dialog modal-dialog {{size ? 'modal-' + size : ''}}" aria-labelledby="salaxyDialogLabel" role="dialog">
        <div class="modal-content" role="document" uib-modal-transclude></div>
</div>`), s.put("salaxy-components/modals/ui/DocumentPreviewWindow.html", `<div class="salaxy-component container-document-print salaxy-rpt" role="dialog">
    <div class="document-preview" id="document-preview">
        <div style="height:auto;min-height:277mm" class="modal-content document a4portrait" role="document" uib-modal-transclude></div>
    </div>
</div>
`), s.put("salaxy-components/modals/ui/Download.html", `<div class="modal-body" id="modal-body">
  <div class="sxy-spinner" ng-if="!$ctrl.data.isReady">
      <svg class="sxy-spinner-bg" viewBox="0 0 64 64"><circle cx="32" cy="32" r="26"></circle></svg>
      <svg class="sxy-spinner-spin" viewBox="0 0 64 64">
          <circle transform="translate(32,32)" r="26"></circle>
      </svg>
  </div>
  
  <div style="text-align: center;">
      <h3 ng-if="!$ctrl.data.isReady" >{{$ctrl.data.waitHeading | sxyTranslate}}</h3>
      <h3 ng-if="$ctrl.data.isReady" >{{$ctrl.data.readyHeading | sxyTranslate}}</h3>
      <p  ng-if="!$ctrl.data.isReady" style="white-space: pre;">{{$ctrl.data.waitText | sxyTranslate}}</p>
      <p ng-if="$ctrl.data.isReady">
        {{$ctrl.data.readyText | sxyTranslate}} 
        <a ng-if="$ctrl.data.target" ng-click="$close('ok')" ng-href="{{$ctrl.data.url}}" target="{{$ctrl.data.target}}" >{{$ctrl.data.openText | sxyTranslate}}</a>
        <a ng-if="!$ctrl.data.target" ng-click="$close('ok')" ng-href="{{$ctrl.data.url}}" >{{$ctrl.data.openText | sxyTranslate}}</a>
      </div>
  </div>
</div>`), s.put("salaxy-components/modals/ui/Html.html", `<div class="modal-header">
  <h2 class="modal-title">{{$ctrl.data.title}}</h2>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

</div>
<div class="modal-body ">
  <div ng-bind-html="$ctrl.data.html"></div>
</div>`), s.put("salaxy-components/modals/ui/Loading.html", `<div class="modal-body" id="modal-body" style="text-align:center;">
  <div class="sxy-spinner">
    <svg class="sxy-spinner-bg" viewBox="0 0 64 64"><circle cx="32" cy="32" r="26"></circle></svg>
    <svg class="sxy-spinner-spin" viewBox="0 0 64 64">
            <circle transform="translate(32,32)" r="26"></circle>
        </svg>
  </div>
  <div style="text-align: center;">
    <h3 ng-if="$ctrl.data.heading">{{$ctrl.data.heading | sxyTranslate}}</h3>
    <p class="pre-wrap" ng-if="$ctrl.data.text">{{$ctrl.data.text | sxyTranslate}}</p>
  </div>
</div>`), s.put("salaxy-components/modals/ui/SelectListItem.html", `<div class="modal-worker-list">
  <div class="modal-header">
    <h2 class="modal-title">{{$ctrl.logic.title | sxyTranslate}}</h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <p ng-if="$ctrl.logic.infoHtml" sxy-html="{{$ctrl.logic.infoHtml}}"></p>
    <div class="table-responsive" style="max-height: calc(100vh - 300px)">
      <salaxy-odata-table
        template-url="salaxy-components/odata/lists/SelectListItem.html"
        selected-items="$ctrl.current" on-list-select="$close('ok')"
        crud-controller="DatasetsCrudController as $crud"></salaxy-odata-table>
    </div>
    <div class="text-end">
      <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
      <button type="submit" class="btn btn-primary" ng-click="$close('ok')">{{$ctrl.logic.okButtonText ? ($ctrl.logic.okButtonText | sxyTranslate) : ('SALAXY.UI_Terms.save' |
        sxyTranslate)}}</button>
    </div>
  </div>
</div>`), s.put("salaxy-components/modals/worker/taxcard-income-log.html", `<div class="modal-taxcard-new">
  <div class="modal-header">
    <h2 class="modal-title" sxy-text="SALAXY.NG1.EmploymentTaxcardsComponent.taxCardIncomeLog.addPaidSalaries"></h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <div class="alert alert-info" ng-if="$ctrl.$incomeLog.hasDiff">
      <button type="button" class="btn btn-primary float-end" ng-click="$close('ok')" sxy-text="SALAXY.NG1.EmploymentTaxcardsComponent.taxCardIncomeLog.addSalaries"></button>
      <span sxy-text="SALAXY.NG1.EmploymentTaxcardsComponent.taxCardIncomeLog.addSalariesToTaxCard" params="{validity: ($ctrl.current.card.validity | sxyDateRange)}">
      </span>
    </div>
    <salaxy-taxcard-income-log parent="$ctrl.current" editable="$ctrl.logic.editable" ng-ref="$ctrl.$incomeLog"></salaxy-taxcard-income-log>
  </div>
  <div class="modal-footer">
    <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
    <button type="submit" class="btn btn-primary" ng-click="$close('ok')" sxy-text="SALAXY.NG1.EmploymentTaxcardsComponent.taxCardIncomeLog.addSalaries"></button>
  </div>
</div>`), s.put("salaxy-components/modals/worker/taxcard-min-percent.html", `<div class="modal-taxcard-min-percent">
  <div class="modal-header">
    <h2 class="modal-title" sxy-text="SALAXY.NG1.EmploymentTaxcardsComponent.taxCardMinPercent.minimumPercent"></h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

  </div>
  <div class="modal-body form-horizontal">
    <p class="lead" sxy-html="SALAXY.NG1.EmploymentTaxcardsComponent.taxCardMinPercent.lead.html"></p>
    <p sxy-text="SALAXY.NG1.EmploymentTaxcardsComponent.taxCardMinPercent.biggerTaxPercentThanInTaxCard"></p>
    <p sxy-text="SALAXY.NG1.EmploymentTaxcardsComponent.taxCardMinPercent.taxPercentMinimum"></p>
    <salaxy-input-number name="taxPercentMin" ng-model="$ctrl.current.taxPercentMin" label="SALAXY.NG1.EmploymentTaxcardsComponent.taxCardMinPercent.minimumPercent"></salaxy-input-number>
  </div>
  <div class="modal-footer">
    <button class="btn btn-default" type="button" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
    <button class="btn btn-primary" type="button" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.save"></button>

  </div>
</div>`), s.put("salaxy-components/modals/worker/taxcard-new.html", `<div class="modal-taxcard-new">
  <div class="modal-header">
    <h2 class="modal-title" sxy-text="SALAXY.NG1.EmploymentTaxcardsComponent.taxCardNew.addTaxCard"></h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

  </div>
  <div style="min-height: 440px;" class="modal-body">
    <salaxy-taxcard-manual-edit ng-ref="$edit" current="$ctrl.current"></salaxy-taxcard-manual-edit>
  </div>
  <div class="modal-footer">
    <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.NG1.AbsencePeriodsEditDialog.cancelButtonText"></button>
    <button type="submit" class="btn btn-primary" ng-click="$close('ok')" ng-disabled="!$edit.isFormValid" sxy-text="SALAXY.UI_Terms.save"></button>
  </div>
</div>`), s.put("salaxy-components/modals/workflow/CalendarEventEdit.html", `<div class="modal-header">
  <h2 class="modal-title" id="salaxyWorkflowEventEditTitle">
    <i class="bi bi-calendar3" aria-hidden="true" style="padding-right: 20px"></i> {{ $ctrl.logic.title | sxyTranslate }}
  </h2>
  <button type="button" class="btn-close" ng-click="$dismiss()" aria-label="Close"></button>

</div>
<div class="modal-body">
  <form name="frmEvent" class="form-horizontal">
    <salaxy-calendar-event-details ng-ref="$ctrl.details" ng-if="$ctrl.logic.isSimplified" model="$ctrl.current" template-url="salaxy-components/workflow/CalendarEventDetails-simplified.html"></salaxy-calendar-event-details>
    <salaxy-calendar-event-details ng-if="!$ctrl.logic.isSimplified" model="$ctrl.current"></salaxy-calendar-event-details>
  </form>
</div>
<!--
<div class="modal-footer">
  <button class="btn btn-danger float-start" ng-disabled="!$ctrl.current.id" ng-click="$close('delete')" sxy-text="SALAXY.UI_Terms.delete"></button>
  <button class="btn btn-default" ng-click="$dismiss()" sxy-text="{{ $ctrl.logic.cancelText }}"></button>
  <button class="btn btn-primary" ng-disabled="!frmEvent.$valid" ng-click="$close('ok')" sxy-text="{{ $ctrl.logic.okText }}"></button>
</div>
-->
<div class="modal-footer">
  <button ng-if="$ctrl.details.step &lt; 2" ng-click="$close('cancel')" class="btn float-start btn-default" sxy-text="SALAXY.UI_Terms.close"></button>
  <button ng-if="$ctrl.details.step >= 2" ng-click="$ctrl.details.goPrevious()" ng-disabled="!$ctrl.details.canGoPrevious" class="btn float-start btn-default" sxy-text="SALAXY.UI_Terms.previous"></button>
  <button ng-if="$ctrl.details.step &lt; $ctrl.details.steps.length" ng-click="$ctrl.details.goNext()" ng-disabled="!$ctrl.details.canGoNext" class="btn btn-primary ms-auto" sxy-text="SALAXY.UI_Terms.next"></button>
  <button ng-if="$ctrl.details.step == $ctrl.details.steps.length" ng-click="$close('ok')" class="btn btn-primary ms-auto" xx-disabled="!$ctrl.details.formDataValidity" sxy-text="SALAXY.NG1.CalendarEventEditComponent.setTimingsAndCreatePayrolls"></button>
</div>`), s.put("salaxy-components/modals/workflow/UsecaseInfo.html", `<div class="modal-header">
  <h2 class="modal-title">
    <i ng-if="$ctrl.current.icon[0] == 'f'" class="bi" ng-class="$ctrl.current.icon" aria-hidden="true" style="padding-right: 20px"></i>
    Käyttötapaus: {{ $ctrl.current.label || $ctrl.logic.objUsecase.label || "Ei käyttötapausta" }}
  </h2>
  <button type="button" class="btn-close" ng-click="$dismiss()" aria-label="Close"></button>

</div>
<div class="modal-body">
  <p class="lead">{{ $ctrl.current.description || $ctrl.logic.objUsecase.description }}</p>
  <p><code>{{ $ctrl.logic.objUsecase.uri }}</code></p>
  <div class="alert alert-danger" ng-if="!$ctrl.current">
    <strong>Ei käyttötapausta!</strong>
    Tällä tietuella ei ole määritettyä käyttötapausta.
  </div>
  <div ng-if="$ctrl.current">
    <div class="row">
      <div class="col-sm-6">
        <fieldset>
          <legend>Käyttötapaus</legend>
          <div ng-if="!$ctrl.current.defaultView">Ei räätälöityä näkymää.</div>
          <div ng-if="$ctrl.current.defaultView">
            <p>Näkymät (<a href="{{ $ctrl.current.defaultView }}" target="_blank">linkki oletusnäkymään</a>)</p>
            <ul>
              <li ng-repeat="view in $ctrl.current.views">
                <strong>{{ view.label }}</strong> {{ view.description }}
              </li>
            </ul>
          </div>
          <!-- TODO: Show actions, schemas and workflowData / flow if necessary. -->
        </fieldset>
      </div>
      <div class="col-sm-6">
        <fieldset>
          <legend>Objektiin tallennettu data</legend>
          <salaxy-json-formatter json="$ctrl.logic.objUsecase.data" key="'JSON'"></salaxy-json-formatter>
        </fieldset>
      </div>
    </div>
    <salaxy-json-formatter json="$ctrl.current" key="'JSON'" open="0"></salaxy-json-formatter>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-danger float-start" ng-if="$ctrl.logic.canDelete" ng-click="$close('delete')" sxy-text="SALAXY.UI_Terms.delete"></button>
  <button class="btn btn-default ms-auto" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.ok"></button>
</div>`), s.put("salaxy-components/modals/workflow/WorkflowBadgeDetails.html", `<div class="modal-header">
  <h2 class="modal-title" id="salaxyWorkflowBadgeDetailsTitle" sxy-text="{{'SALAXY.ENUM.BootstrapStyle.' + $ctrl.current.event.ui + '.label' }}"></h2>
  <button type="button" class="btn-close" ng-click="$dismiss()" aria-label="Close"></button>
</div>
<div class="modal-body">

  <form class="form-horizontal" name="eventAndRecord" ng-readonly="true">
    <salaxy-form-group name="time" label="SALAXY.UI_Terms.updated">
      <span>{{$ctrl.current.event.time | sxyTime }}</span>
    </salaxy-form-group>
    <salaxy-input-enum type="select" enum="BootstrapStyle" label="SALAXY.NG1.WorkFlowEventEditComponent.ui" name="ui" ng-model="$ctrl.current.event.ui"></salaxy-input-enum>
    <salaxy-input label="SALAXY.NG1.WorkFlowEventEditComponent.description" name="message" require="true" ng-model="$ctrl.current.event.message"></salaxy-input>
    <div ng-if="$ctrl.current.record">
      <salaxy-input ng-if="$ctrl.current.record.recordType" ng-model="$ctrl.current.record.recordType" label="SALAXY.NG1.WorkerDetailsComponent.records.recordType" name="recordType"></salaxy-input>
      <salaxy-input ng-if="$ctrl.current.record.title" ng-model="$ctrl.current.record.title" label="SALAXY.NG1.WorkerDetailsComponent.records.title" name="title"></salaxy-input>
      <salaxy-textarea ng-if="$ctrl.current.record.text" ng-model="$ctrl.current.record.text" label="SALAXY.NG1.WorkerDetailsComponent.records.text" name="text"></salaxy-textarea>
      <salaxy-form-group ng-if="$ctrl.current.record.attachments.length > 0" name="attachments" label="SALAXY.NG1.WorkerDetailsComponent.records.attachments">
        <table>
          <tr ng-repeat="attachment in $ctrl.current.record.attachments">
            <td>
              <i class="bi {{ $ctrl.logic.getAttachmentIcon(attachment) }} text-primary float-start me-1"></i>
              <a target="_blank" ng-href="{{$ctrl.logic.getAttachmentDownloadUrl(attachment)}}">{{attachment.fileName}}</a>
            </td>
          </tr>
        </table>
      </salaxy-form-group>
      <salaxy-datepicker-popup ng-if="$ctrl.current.record.startDate" ng-model="$ctrl.current.record.startDate" label="SALAXY.NG1.WorkerDetailsComponent.records.startDate" name="startDate"></salaxy-datepicker-popup>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
</div>`), s.put("salaxy-components/modals/workflow/WorkflowEventEdit.html", `<div class="modal-header">
  <h2 class="modal-title" id="salaxyWorkflowEventEditTitle" sxy-text="{{$ctrl.logic.title}}"></h2>
  <button type="button" class="btn-close" ng-click="$dismiss()" aria-label="Close"></button>

</div>
<div class="modal-body">
  <form name="event" class="form-horizontal" ng-readonly="$ctrl.logic.readOnly">
    <salaxy-input label="SALAXY.NG1.WorkFlowEventEditComponent.description" name="message" require="true" ng-model="$ctrl.current.message"></salaxy-input>
    <salaxy-input-enum ng-if="$ctrl.logic.showUi" type="select" enum="BootstrapStyle" label="SALAXY.NG1.WorkFlowEventEditComponent.ui" name="ui" require="true" ng-model="$ctrl.current.ui"></salaxy-input-enum>
  </form>
</div>
<div class="modal-footer">
  <button type="reset" ng-if="!$ctrl.logic.readOnly" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
  <button type="button" ng-if="$ctrl.logic.readOnly" class="btn btn-primary" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
  <button type="button" ng-if="!$ctrl.logic.readOnly" class="btn btn-primary" ng-disabled="!event.$valid" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.save"></button>
</div>
`), s.put("salaxy-components/odata/lists/AbsencePeriods.html", `<div ng-class="$ctrl.getCssClass()">
  <!-- TODO: This list is currenlty not in use - may be taken to use (or remove Q1/2020) -->
  <table class="table">
    <thead>
      <tr>
        <th colspan="2" sxy-orderby="otherPartyInfo/avatar/displayName">
          <span sxy-text="SALAXY.NG1_Other.Roles.worker"></span>
        </th>
        <th sxy-orderby="causeCode">{{ "SALAXY.NG1.AbsencePeriodsComponent.headerAbsence" | sxyTranslate }}</th>
        <th sxy-orderby="period/start" class="right" sxy-text="SALAXY.NG1.AbsencePeriodsComponent.wholeAbsence"></th>
        <th sxy-orderby="period/daysCount" class="right" sxy-html="SALAXY.NG1.AbsencePeriodsComponent.periodDaysCount.html"></th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="row in $ctrl.items">
        <td class="align-middle td-avatar">
          <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
        </td>
        <td class="td-name middle">
          <strong>{{ row.otherPartyInfo.avatar.displayName }}</strong><br /> {{ row.worker.description }}
        </td>
        <td>
          <salaxy-avatar class="salaxy-calc-row-type-avatar float-start" avatar="{ color: '#2b507c', initials: (row.period.daysCount + 'pv'), entityType: 'company' }"></salaxy-avatar>
          <strong>{{ "AbsenceCauseCode." + row.causeCode | sxyEnum }}</strong><br />
          <div class="float-start" style="padding: 0px;">
            {{ row.isPaid ? ('SALAXY.NG1.AbsencePeriodsComponent.isPaid' | sxyTranslate) : ('SALAXY.NG1.AbsencePeriodsComponent.notPaid' | sxyTranslate) }}
            <span ng-if="row.isPaid != row.isHolidayAccrual"> {{ row.isHolidayAccrual ? ('SALAXY.NG1.AbsencePeriodsComponent.isAccrual' | sxyTranslate) : ('SALAXY.NG1.AbsencePeriodsComponent.notAccrual' | sxyTranslate) }}</span>
          </div>
          <div class="truncate" style="max-width: 250px; padding: 0px;">
            &nbsp;{{ row.notes }}
          </div>
        </td>
        <td class="right">
          <strong>{{ row.period.daysCount | sxyCount : "day" }}</strong><br /> {{ row.period.start | date : 'dd.MM.' }}-{{ row.period.end | date : 'dd.MM.' }}
        </td>
        <td class="right">
          <strong>{{ (row.isPaid ? 0 : row.period.daysCount) | sxyCount : "day" }}</strong><br />
          <strong>{{ (row.isHolidayAccrual ? 0 : row.period.daysCount) | sxyCount : "day" }}</strong><br />
        </td>
        <td class="hidden-xxs middle">
          <button ng-click="$ctrl.data.$payrollCtrl.showEditWorkerDialog(row.worker.id, 'absences')" title="{{ 'SALAXY.UI_Terms.edit' | sxyTranslate}}" class="btn btn-sm btn-primary btn-block">
            <i class="bi bi-pencil-fill d-inline d-sm-none"></i>
            <span class="d-none d-sm-inline" sxy-text="SALAXY.UI_Terms.edit"></span>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`), s.put("salaxy-components/odata/lists/Absences.html", `<div ng-class="$ctrl.getCssClass()">
  <table class="table">
    <thead>
      <tr>
        <th colspan="2" sxy-orderby="otherPartyInfo/avatar/displayName">
          <span sxy-text="SALAXY.NG1_Other.Roles.worker"></span>
        </th>
        <th class="right">
          <span sxy-orderby="startAt" sxy-text="SALAXY.NG1.AbsencesComponent.first"></span><br />
          <span sxy-orderby="endAt" sxy-text="SALAXY.NG1.AbsencesComponent.first">Viimeisin</span>
        </th>
        <th class="right" sxy-text="SALAXY.NG1.AbsencesComponent.salaried"></th>
        <th class="right" sxy-text="SALAXY.NG1.AbsencesComponent.unpaid">Palkattomat</th>
        <th>
          <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search" label-type="plain"></salaxy-input>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="row in $ctrl.items">
        <td class="align-middle td-avatar">
          <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
        </td>
        <td class="td-name middle">
          <strong>{{ row.otherPartyInfo.avatar.displayName }}</strong><br /> {{ row.data.count }} {{'SALAXY.NG1.AbsencesComponent.absence' | sxyTranslate}}, {{ row.data.days }} {{'SALAXY.NG1.AbsencesComponent.day' | sxyTranslate}}<br />
          <span ng-if="!row.data.employmentId" class="label label-danger" sxy-text="SALAXY.NG1.AbsencesComponent.error"></span>
        </td>
        <td class="right">
          {{ row.startAt | sxyDate }}<br /> {{ row.endAt | sxyDate }}
        </td>
        <td class="right">
          {{ row.data.paidCount }} {{'SALAXY.NG1.AbsencesComponent.pce' | sxyTranslate}}<br /> {{ row.data.paidDays }} {{'SALAXY.NG1.AbsencesComponent.d' | sxyTranslate}}
        </td>
        <td class="right">
          {{ row.data.unpaidCount }} {{'SALAXY.NG1.AbsencesComponent.pce' | sxyTranslate}}<br /> {{ row.data.unpaidDays }} {{'SALAXY.NG1.AbsencesComponent.d' | sxyTranslate}}
        </td>
        <td class="hidden-xxs middle">
          <button ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.edit' | sxyTranslate}}" class="btn btn-sm btn-primary btn-block">
            <i class="bi bi-pencil-fill d-sm-none d-inline"></i>
            <span class="d-none d-sm-inline" sxy-text="SALAXY.UI_Terms.edit"></span>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`), s.put("salaxy-components/odata/lists/AccountingReports.html", `<div ng-class="$ctrl.getCssClass()">

  <salaxy-accounting-report-tools ng-ref="$reportTools" reader="$crud.selectionDataReader"></salaxy-accounting-report-tools>

  <div class="visible-xxs">
    <div class="table-filter-container-mobile">
      <salaxy-datepicker-popup name="year" placeholder="{{'SALAXY.NG1.AccountingReportsComponent.year'}}" ng-change="$crud.logicalDateChanged()" format="year" ng-model="$crud.logicalDate" label-type="plain" require="true"></salaxy-datepicker-popup>
    </div>
  </div>
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th colspan="2" sxy-orderby="ownerInfo/avatar/displayName">
            <span>{{ 'SALAXY.NG1_Other.Roles.employer' | sxyTranslate }}</span>
          </th>
          <th>
            <span sxy-orderby="logicalDate">{{ 'SALAXY.NG1.AccountingReportsComponent.period' | sxyTranslate }}</span>
          </th>
          <th class="right ">
            <span sxy-orderby="grossSalary">{{ 'SALAXY.NG1.AccountingReportsComponent.salaries' | sxyTranslate }}</span><br />
            <span sxy-orderby="payment">{{ 'SALAXY.NG1.AccountingReportsComponent.payments' | sxyTranslate }}</span>
          </th>
          <th class="right ">
            <span>{{ 'SALAXY.NG1.AccountingReportsComponent.salariesAlt' | sxyTranslate }}</span><br />
            <span>{{ 'SALAXY.NG1.AccountingReportsComponent.workers' | sxyTranslate }}</span>
          </th>
          <th sxy-text="SALAXY.NG1.AccountingReportsComponent.material"></th>
          <th sxy-text="SALAXY.NG1.AccountingReportsComponent.responsiblePerson"></th>
          <th class="middle hidden-xxs">
            <salaxy-datepicker-popup ng-model="$crud.logicalDate" ng-change="$crud.logicalDateChanged()" name="year" placeholder="{{'SALAXY.NG1.AccountingReportsComponent.year'}}" format="year" label-type="plain" require="true"></salaxy-datepicker-popup>
          </th>
          <th class="middle hidden-xxs">
            <button title="{{'SALAXY.NG1.AccountingReportsComponent.chooseAll' | sxyTranslate}}" class="btn btn-block btn-transparent" type="button" ng-if="$ctrl.selectedItems.length == 0" ng-disabled="$ctrl.selectedItems.length == $ctrl.items.length" ng-click="$crud.selectAll()">
              <i class="bi bi-square"></i>
            </button>
            <button title="{{'SALAXY.UI_Terms.unselect' | sxyTranslate}}" class="btn btn-block btn-transparent" type="button" ng-if="$ctrl.selectedItems.length > 0" ng-disabled="$ctrl.selectedItems.length == 0" ng-click="$crud.unselectAll()">
              <i class="bi bi-check-square"></i>
            </button>
          </th>
          <th class="middle hidden-xxs"></th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="td-avatar middle">
            <salaxy-avatar avatar="row.ownerInfo.avatar"></salaxy-avatar>
          </td>
          <td class="td-name middle">
            <span ng-if="row.ownerInfo.avatar.displayName == ''">{{ 'SALAXY.NG1.AccountingReportsComponent.notSelected' | sxyTranslate }}</span>
            <strong>{{row.ownerInfo.avatar.displayName}}</strong><br /> {{row.data.officialId}}
          </td>
          <td class="middle">
            {{ row.logicalDate | date:'yyyy-MM' }}
          </td>
          <td class="right middle">
            {{ row.grossSalary | currency }}<br /> {{ row.payment | currency }}
          </td>
          <td class="right middle">
            {{ row.data.calculationCount }} {{'SALAXY.NG1.AccountingReportsComponent.pce' | sxyTranslate}}<br /> {{ row.data.workerCount }} {{'SALAXY.NG1.AccountingReportsComponent.pce' | sxyTranslate}}
          </td>
          <td class="middle">
            <div ng-repeat="message in row.messages" ng-bind-html="message | sxyWorkflowMessage: 'PartnerMessageIssue,PartnerMessageClosed'"></div>
          </td>
          <td class="middle">
            <span ng-if="row.data.partnerMessageAssignedTo" ng-controller="WorkflowController as $workflowCtrl" title="{{ $workflowCtrl.getCredential(row.data.partnerMessageAssignedTo).email || $workflowCtrl.getCredential(row.data.partnerMessageAssignedTo).avatar.displayName }}">
              <salaxy-avatar style="font-size:45px" avatar="$workflowCtrl.getCredential(row.data.partnerMessageAssignedTo).avatar"></salaxy-avatar>
            </span>
          </td>
          <td class="middle hidden-xxs">
            <button class="btn btn-sm btn-block btn-default" ng-disabled="row.isReading" type="button" ng-click="$reportTools.export($crud.getItemDataReader(row),true)">
              <span ng-show="row.isReading"><i class="bi bi-arrow-repeat bi-spin"></i></span>
              <span ng-show="!row.isReading">{{ 'SALAXY.NG1.AccountingReportsComponent.createMaterial' | sxyTranslate }}</span>
            </button>
          </td>
          <td class="middle hidden-xxs">
            <button title="{{'SALAXY.UI_Terms.select' | sxyTranslate}}" class="btn btn-block btn-transparent" type="button" ng-if="!$ctrl.isSelected(row)" ng-click="$ctrl.setSelected(row, 'toggle')">
              <i class="bi bi-square"></i>
            </button>
            <button title="{{'SALAXY.UI_Terms.unselect' | sxyTranslate}}" class="btn btn-block btn-transparent" type="button" ng-if="$ctrl.isSelected(row)" ng-click="$ctrl.setSelected(row, 'toggle')">
              <i class="bi bi-check-square"></i>
            </button>
          </td>
          <td class="middle hidden-xxs">
            <a href="" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
              <i class="bi bi-info-circle d-inline-block d-sm-none"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.show"></span></a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`), s.put("salaxy-components/odata/lists/AccountingReportsPanel.html", `<div class="salaxy-odata-card list-card report-list-card card card-sm card-secondary">
  <div class="card-header d-flex align-items-center">
    {{'SALAXY.NG1.AccountingReportsComponent.accountingReports' | sxyTranslate}}
    <button ng-style="{'visibility': $ctrl.items.length > 0 ? 'visible' : 'hidden'}" class="btn btn-secondary btn-xs ms-auto" ng-click="hideFilter = !hideFilter" title="{{'SALAXY.NG1.AccountingReportsComponent.showFilters' | sxyTranslate}}">
      <i class="bi bi-funnel-fill"></i>
    </button>
  </div>
  <div class="card-body filters text-end" ng-class="{'showfilters' : hideFilter}">
    <div class="filter-buttons">
      <button class="btn btn-xs btn-secondary text-end" sxy-orderby="logicalDate">{{'SALAXY.NG1.AccountingReportsComponent.mm' | sxyTranslate}}</button>
    </div>
    <salaxy-input name="search1cp{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search hidden-xxs" label-type="plain"></salaxy-input>
  </div>
  <div ng-class="$ctrl.getCssClass()">
    <div class="visible-xxs" ng-if="$ctrl.items.length > 0">
      <div class="table-filter-container-mobile">
        <salaxy-input name="search2cp{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search" label-type="plain">
        </salaxy-input>
      </div>
    </div>
    <div class="card-body text-center card-content lg-height align-middle" ng-show="$ctrl.items.length == 0 && !$ctrl.isLoading">
      <div>
        <h3 sxy-text="SALAXY.NG1.AccountingReportsComponent.noAccountingReports"></h3>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table" ng-if="$ctrl.items.length > 0">
        <tbody>
          <tr ng-repeat="row in $ctrl.items">
            <td class="middle">
              {{ row.logicalDate | date:'yyyy-MM' }}
            </td>
            <td class="middle right">
              {{ row.grossSalary | currency }}<br /> {{ row.payment | currency }}
            </td>
            <td class="middle right">
              {{row.data.calculationCount}} <i class="bi bi-list-task" title="{{'SALAXY.NG1.AccountingReportsComponent.calcs' | sxyTranslate}}"></i>
              <br/> {{row.data.workerCount}} <i class="bi bi-person-fill" title="{{'SALAXY.NG1.AccountingReportsComponent.workersAlt' | sxyTranslate}}"></i>
            </td>
            <td class="middle right">
              <a href="" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-sm btn-secondary"><i
              class="bi bi-info-circle "></i></a>
            </td>

          </tr>
        </tbody>
      </table>
      <div class="salaxy-odata-footer">
        <salaxy-spinner></salaxy-spinner>
      </div>
    </div>

  </div>
  <div class="card-footer text-center">
    <a ng-href="#{{$crud.getDefaults().listUrl}}" class="btn btn-primary btn-sm" sxy-text="SALAXY.UI_Terms.showAll"></a>
  </div>
</div>`), s.put("salaxy-components/odata/lists/AccountingTargets.html", `<div ng-class="$ctrl.getCssClass()">
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th colspan="2">
            <div sxy-orderby="shortText" sxy-text="SALAXY.NG1.AccountingTargetsComponent.exportDefinition"></div>
            <div sxy-text="SALAXY.NG1.AccountingTargetsComponent.targetChannel"></div>
          </th>
          <th colspan="2">
            <div sxy-orderby="ownerInfo/avatar/displayName" sxy-text="SALAXY.NG1.AccountingTargetsComponent.owner"></div>
            <div sxy-orderby="status" sxy-text="SALAXY.NG1.AccountingTargetsComponent.status"></div>
          </th>
          <th class="right">
            <div sxy-orderby="createdAt" sxy-text="SALAXY.UI_Terms.created"></div>
            <div sxy-orderby="updatedAt" sxy-text="SALAXY.UI_Terms.updated"></div>
          </th>
          <th class="right hidden-xxs" colspan="2">
            <div class="table-filter-container">
              <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" class="salaxy-odata-table-search" placeholder="SALAXY.UI_Terms.textSearch" label-type="plain"></salaxy-input>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="td-avatar middle">
            <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
          </td>
          <td class="middle">
            <div title="{{ row.shortText }} ({{ row.id }})">
              <strong>{{ row.otherPartyInfo.avatar.displayName }}</strong>
            </div>
          </td>
          <td class="td-avatar middle">
            <salaxy-avatar avatar="row.ownerInfo.avatar"></salaxy-avatar>
          </td>
          <td class="middle">
            <div>{{ row.ownerInfo.avatar.displayName }}</div>
            <div>{{ "AccountingTargetStatus." + row.status | sxyEnum }}</div>
          </td>
          <td class="right">
            <div title="{{ row.createdAt }}">{{ row.createdAt | sxyDate }}</div>
            <div title="{{ row.updatedAt }}">{{ row.updatedAt | sxyDate }}</div>
            <div></div>
          </td>
          <td class="middle hidden-xxs">
            <button ng-if="!row.isReadOnly" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.edit' | sxyTranslate}}" class="btn btn-sm btn-primary btn-block">
              <i class="bi bi-pencil-fill d-inline-block d-sm-none"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.edit"></span>
            </button>
            <button ng-if="row.isReadOnly" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
              <i class="bi bi-info-circle d-inline-block d-sm-none"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.show"></span>
            </button>
          </td>
          <td class="middle hidden-xxs">
            <button ng-if="!row.isReadOnly" ng-click="$crud.delete(row)" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}" class="btn btn-sm btn-danger btn-block">
              <i class="bi bi-trash-fill d-inline-block d-sm-none"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.delete"></span>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>
`), s.put("salaxy-components/odata/lists/AccountingTargetSelect.html", `<div ng-class="$ctrl.getCssClass()">
  <div class="visible-xxs">
    <div class="table-filter-container-mobile">
      <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search" label-type="plain">
      </salaxy-input>
    </div>
  </div>
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th colspan="2">
            <div sxy-orderby="shortText" sxy-text="SALAXY.NG1.AccountingTargetsComponent.exportDefinition"></div>
            <div sxy-text="SALAXY.NG1.AccountingTargetsComponent.targetChannel"></div>
          </th>
          <th sxy-orderby="owner" colspan="2">
            <div sxy-text="SALAXY.NG1.AccountingTargetsComponent.owner"></div>
          </th>
          <th class="right hidden-xxs" colspan="3">
            <div class="table-filter-container">
              <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" class="salaxy-odata-table-search" placeholder="SALAXY.UI_Terms.textSearch" label-type="plain"></salaxy-input>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="td-avatar middle">
            <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
          </td>
          <td class="middle">
            <div title="{{ row.shortText }} ({{ row.id }})">
              <strong>{{ row.otherPartyInfo.avatar.displayName }}</strong>
            </div>
          </td>
          <td class="td-avatar middle">
            <salaxy-avatar avatar="row.ownerInfo.avatar"></salaxy-avatar>
          </td>
          <td class="middle">
            <div>{{ row.ownerInfo.avatar.displayName }}</div>
          </td>
          <td></td>
          <td class="right middle">
            <button class="btn btn-sm" type="button" ng-class="$ctrl.isSelected(row) ? 'btn-danger' : 'btn-info'" ng-click="$ctrl.setSelected(row, 'toggle')">
              {{ $ctrl.isSelected(row) ? ('SALAXY.UI_Terms.unselect' | sxyTranslate) : ('SALAXY.UI_Terms.select' | sxyTranslate) }}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`), s.put("salaxy-components/odata/lists/ApiCrudObject.html", `<div ng-class="$ctrl.getCssClass()">
  <table class="table">
    <thead>
      <tr>
        <th sxy-orderby="id">
          <div sxy-text="SALAXY.NG1.ApiCrudObjectComponent.id"></div>
        </th>
        <th sxy-orderby="status"  sxy-text="SALAXY.UI_Terms.status"></th>
        <th class="right">
          <div sxy-orderby="createdAt" sxy-text="SALAXY.UI_Terms.created"></div>
          <div sxy-orderby="updatedAt" sxy-text="SALAXY.UI_Terms.updated"></div>
        </th>
        <th sxy-orderby="owner" sxy-text="SALAXY.NG1.ApiCrudObjectComponent.owner"></th>
        <th sxy-orderby="isReadOnly" sxy-text="SALAXY.NG1.ApiCrudObjectComponent.readOnly"></th>
        <th sxy-orderby="partner" sxy-text="SALAXY.NG1.ApiCrudObjectComponent.partner"></th>
        <th colspan="2"></th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="row in $ctrl.items">
        <td>
          <div>{{ row.shortText }}</div>
          <div><code><small>{{ row.id }}</small></code></div>
        </td>
        <td>{{ row.status }}</td>
        <td class="right">
          <div>{{ row.createdAt | sxyDate }}</div>
          <div>{{ row.updatedAt | sxyDate }}</div>
        </td>
        <td class="td-avatar">
          <salaxy-avatar avatar="row.ownerInfo.avatar" title="row.owner"></salaxy-avatar>
        </td>
        <td>{{ row.isReadOnly }}</td>
        <td>{{ row.partner }}</td>
        <td>
          <button ng-if="!row.isReadOnly" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.edit' | sxyTranslate}}" class="btn btn-sm btn-primary btn-block">
            <i class="bi bi-pencil-fill d-sm-none d-inline"></i>
            <span class="d-none d-sm-inline" sxy-text="SALAXY.UI_Terms.edit"></span>
          </button>
          <button ng-if="row.isReadOnly" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
            <i class="bi bi-info-circle d-sm-none d-inline"></i>
            <span class="d-none d-sm-inline" sxy-text="SALAXY.UI_Terms.show"></span>
          </button>
        </td>
        <td>
          <button ng-if="!row.isReadOnly" ng-click="$crud.delete(row)" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}" class="btn btn-sm btn-danger btn-block">
            <i class="bi bi-trash-fill d-sm-none d-inline"></i>
            <span class="d-none d-sm-inline" sxy-text="SALAXY.UI_Terms.delete"></span>
          </button>
          <button ng-if="row.isReadOnly" ng-click="$crud.showCopyAsNew(row)" title="{{ 'SALAXY.UI_Terms.copyAsNew' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
            <i class="bi bi-copy d-sm-none d-inline"></i>
            <span class="d-none d-sm-inline" sxy-text="SALAXY.UI_Terms.copyAsNew"></span>
           </button>
        </td>
      </tr>
    </tbody>
  </table>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`), s.put("salaxy-components/odata/lists/BrandList.html", `<div ng-class="$ctrl.getCssClass()">
  <div class="visible-xxs">
    <div class="table-filter-container-mobile">
      <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search" label-type="plain">
      </salaxy-input>
    </div>
  </div>
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th colspan="2" sxy-orderby="ownerInfo/avatar/displayName">
            <span sxy-text="SALAXY.NG1.BrandListComponent.partner"></span>
          </th>
          <th class="right" colspan="2">
            <div class="table-filter-container">
              <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" class="salaxy-odata-table-search" placeholder="SALAXY.UI_Terms.textSearch" label-type="plain"></salaxy-input>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="td-avatar middle">
            <i class="salaxy-avatar" style="font-size: 74px;"><img ng-src="{{ row.data.logo }}" /></i>
          </td>
          <td class="td-name middle">
            <strong>{{row.data.webAppName || row.ownerInfo.avatar.displayName}}</strong>
          </td>
          <td class="right middle">
            <button class="btn" ng-class="$ctrl.isSelected(row) ? 'btn-danger' : 'btn-info'" type="button" ng-click="$ctrl.setSelected(row, 'toggle')">
              {{ $ctrl.isSelected(row) ? ('SALAXY.UI_Terms.unselect' | sxyTranslate) : ('SALAXY.UI_Terms.select' | sxyTranslate) }}
            </button>

          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`), s.put("salaxy-components/odata/lists/Calculations-select.html", `<div ng-class="$ctrl.getCssClass()">
  <div class="visible-xxs">
    <div class="table-filter-container-mobile">
      <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search" label-type="plain">
      </salaxy-input>
    </div>
  </div>
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th colspan="2">
            <span sxy-orderby="otherPartyInfo/avatar/displayName" sxy-text="SALAXY.NG1_Other.Roles.worker"></span>
            <span class="label label-primary clickable" ng-if="$ctrl.selectedItems.length" ng-click="$ctrl.selectedItems.splice(0,$ctrl.selectedItems.length)"> {{'SALAXY.UI_Terms.chosen' | sxyTranslate}}: {{ $ctrl.selectedItems.length }} <i class="bi bi-x-circle"></i></span>
          </th>
          <th class="hidden-xxs">
            <span sxy-text="SALAXY.NG1.CalcListComponent.status.title"></span><br />
            <span sxy-orderby="endAt"><span sxy-text="SALAXY.NG1.CalcListComponent.date"></span></span>
          </th>
          <th class="right hidden-xxs" colspan="2">
            <div class="table-filter-container">
              <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" class="salaxy-odata-table-search" placeholder="SALAXY.UI_Terms.textSearch" label-type="plain"></salaxy-input>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="td-avatar visible-xxs middle">
            <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
          </td>
          <td class="td-name visible-xxs middle">
            <span ng-if="row.otherPartyInfo.avatar.displayName == ''" sxy-text="SALAXY.NG1.CalcListComponent.notSelected"></span>
            <strong>{{row.otherPartyInfo.avatar.displayName}}</strong><br /> {{ "SALAXY.ENUM.CalculationStatus." + row.status + ".label" | sxyTranslate }}
            <br /> {{ row.endAt | date }}
          </td>
          <td class="right visible-xxs bottom">
            <a href="" ng-click="$crud.showDetails(row)">
              {{ row.grossSalary | currency }}<br />
              {{ row.payment | currency }}
            </a>
          </td>
          <td class="td-avatar hidden-xxs middle">
            <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
          </td>
          <td class="td-name hidden-xxs middle">
            <span ng-if="row.otherPartyInfo.avatar.displayName == ''" sxy-text="SALAXY.NG1.CalcListComponent.notSelected"></span>
            <strong>{{row.otherPartyInfo.avatar.displayName}}</strong><br />
          </td>
          <td class="hidden-xxs middle">
            {{ row.status ? ("SALAXY.ENUM.CalculationStatus." + row.status + ".label" | sxyTranslate) : "#ERR" }}<br /> {{ row.endAt | date }}
          </td>
          <td class="right hidden-xxs middle">
            {{ row.grossSalary | currency }}<br /> {{ row.payment | currency }}
          </td>
          <td class="right middle">
            <button class="btn btn-sm" type="button" ng-class="$ctrl.isSelected(row) ? 'btn-danger' : 'btn-info'" ng-click="$ctrl.setSelected(row, 'toggle')">
              {{ $ctrl.isSelected(row) ? ('SALAXY.UI_Terms.unselect' | sxyTranslate) : ('SALAXY.UI_Terms.select' | sxyTranslate) }}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`), s.put("salaxy-components/odata/lists/CalculationsAll.html", `<div ng-class="$ctrl.getCssClass()">
  <div class="visible-xxs">
    <div class="table-header-container-mobile" ng-show="!$ctrl.readOnly">
      <a class="btn btn-sm btn-block btn-primary" href="#/calc/details/new" sxy-text="SALAXY.UI_Terms.createNew"></a>
    </div>
    <div class="table-filter-container-mobile">
      <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search" label-type="plain">
      </salaxy-input>
    </div>
  </div>
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th colspan="2" sxy-orderby="otherPartyInfo/avatar/displayName">
            <span sxy-text="SALAXY.NG1_Other.Roles.worker"></span>
          </th>
          <th class="hidden-xxs">
            <span sxy-orderby="status"><span sxy-text="SALAXY.NG1.CalcListComponent.status.title"></span></span><br />
            <span sxy-orderby="endAt"><span sxy-text="SALAXY.NG1.CalcListComponent.payment" ></span></span>
          </th>
          <th class="right ">
            <span sxy-orderby="grossSalary"><span sxy-text="SALAXY.NG1.CalcListComponent.salary"></span></span><br />
            <span sxy-orderby="payment"><span sxy-text="SALAXY.NG1.CalcListComponent.payment" ></span></span>
          </th>
          <th class="right hidden-xxs" colspan="2">
            <salaxy-odata-actions show-export="true"></salaxy-odata-actions>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="td-avatar visible-xxs middle">
            <a href="">
              <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
            </a>
          </td>
          <td class="td-name visible-xxs middle">
            <a href="" ng-click="$crud.showDetails(row)">
              <span ng-if="row.otherPartyInfo.avatar.displayName == ''" sxy-text="SALAXY.NG1.CalcListComponent.notSelected"></span>
              <strong>{{row.otherPartyInfo.avatar.displayName}}</strong>
              <br /> {{ "SALAXY.ENUM.CalculationStatus." + row.status + ".label" | sxyTranslate }}
              <br /> {{row.endAt | date}}
            </a>
          </td>
          <td class="right visible-xxs bottom">
            <a href="" ng-click="$crud.showDetails(row)">
              {{ row.grossSalary | currency }}
              <br />
              {{ row.payment | currency }}
            </a>
          </td>
          <td class="td-avatar hidden-xxs middle">
            <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
          </td>
          <td class="td-name hidden-xxs middle">
            <span ng-if="row.otherPartyInfo.avatar.displayName == ''" sxy-text="SALAXY.NG1.CalcListComponent.notSelected"></span>
            <strong>{{row.otherPartyInfo.avatar.displayName}}</strong><br />
          </td>
          <td class="hidden-xxs middle">
            {{ "SALAXY.ENUM.CalculationStatus." + row.status + ".label" | sxyTranslate }}
            <br /> {{row.endAt | date}}
          </td>
          <td class="right hidden-xxs middle">
            {{ row.grossSalary | currency }}<br /> {{ row.payment | currency }}
          </td>
          <td class="hidden-xxs middle">
            <button ng-click="$crud.showDetails(row)" ng-if="row.status == 'draft'" class="btn btn-sm btn-primary btn-block" title="{{ 'SALAXY.UI_Terms.edit' | sxyTranslate}}">
              <i class="bi bi-pencil-fill d-inline-block d-sm-none"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.edit"></span>
            </button>
            <button ng-click="$crud.showDetails(row)" ng-if="row.status != 'draft'" class="btn btn-sm btn-default btn-block" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}">
              <i class="bi bi-info-circle d-inline-block d-sm-none"></i></a>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.show" ng-if="!row.data.payrollId"></span>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.NG1.CalcListComponent.calculation" ng-if="row.data.payrollId"></span>
            </button>
          </td>
          <td class="hidden-xxs middle">
            <button ng-if="row.status == 'draft'" ng-click="$crud.delete(row)" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}" class="btn btn-sm btn-danger btn-block">
              <i class="bi bi-trash-fill d-inline-block d-sm-none"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.delete"></span>
            </button>
            <button ng-if="!row.data.payrollId && (row.status == 'paymentSucceeded' || row.status == 'paymentStarted')" ng-click="$crud.showCopyAsNew(row)" class="btn btn-sm btn-default btn-block" title="{{ 'SALAXY.UI_Terms.copyAsNew' | sxyTranslate}}">
              <i class="bi bi-copy d-inline-block d-sm-none"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.copyAsNew"></span>
            </button>
            <a ng-if="row.data.payrollId" class="btn btn-sm btn-primary btn-block" ng-href="#/payroll/details/{{ row.data.payrollId }}">
              <i class="bi bi-list-task d-inline-block d-sm-none"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.NG1.CalcListComponent.payroll"></span>
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`), s.put("salaxy-components/odata/lists/CalculationsDrafts.html", `<div ng-class="$ctrl.getCssClass()">


  <div class="visible-xxs">
    <div class="table-header-container-mobile" ng-show="!$ctrl.readOnly">
      <a class="btn btn-sm btn-block btn-primary" href="#/calc/details/new" sxy-text="SALAXY.UI_Terms.createNew"></a>
    </div>
    <div class="table-filter-container-mobile">
      <salaxy-input name="search1x{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search" label-type="plain">
      </salaxy-input>
    </div>
  </div>
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th colspan="2" sxy-if-role="!worker">
            <span sxy-orderby="otherPartyInfo/avatar/displayName" sxy-text="SALAXY.NG1_Other.Roles.worker"></span>
          </th>
          <th sxy-if-role="worker">
            <span sxy-orderby="endAt" sxy-text="SALAXY.NG1.CalcListComponent.date"></span>
          </th>
          <th class="hidden-xxs" sxy-if-role="!worker">
            <span sxy-text="SALAXY.NG1.CalcListComponent.status.title"></span><br />
            <span sxy-orderby="endAt"><span sxy-text="SALAXY.NG1.CalcListComponent.date"></span></span>
          </th>
          <th class="right ">
            <span sxy-orderby="grossSalary"><span sxy-text="SALAXY.NG1.CalcListComponent.salary" ></span></span><br />
            <span sxy-orderby="payment"><span sxy-text="SALAXY.NG1.CalcListComponent.payment" ></span></span>
          </th>
          <th class="right hidden-xxs" colspan="2">
            <salaxy-odata-actions show-export="true"></salaxy-odata-actions>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="td-avatar visible-xxs middle" sxy-if-role="!worker">
            <a href="" ng-click="$crud.showDetails(row)">
              <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
            </a>
          </td>
          <td class="td-name visible-xxs middle" sxy-if-role="!worker">
            <a href="" ng-click="$crud.showDetails(row)">
              <span ng-if="row.otherPartyInfo.avatar.displayName == ''" sxy-text="SALAXY.NG1.CalcListComponent.notSelected"></span>
              <strong>{{row.otherPartyInfo.avatar.displayName}}</strong><br /> {{ "SALAXY.ENUM.CalculationStatus." + row.status + ".label" | sxyTranslate }}
              <br />{{ row.endAt | date }}
            </a>
          </td>
          <td class="td-name visible-xxs middle" sxy-if-role="worker" ng-click="$crud.showDetails(row)">
            <a href="" ng-click="$crud.showDetails(row)">
              {{ row.endAt | date }}
            </a>
          </td>
          <td class="right visible-xxs bottom" ng-click="$crud.showDetails(row)">

            <a href="" ng-click="$crud.showDetails(row)">
              {{ row.grossSalary | currency }}<br />
              {{ row.payment | currency }}
            </a>
          </td>
          <td class="td-avatar hidden-xxs middle" sxy-if-role="!worker">
            <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
          </td>
          <td class="td-name hidden-xxs middle" sxy-if-role="!worker">
            <span ng-if="row.otherPartyInfo.avatar.displayName == ''" sxy-text="SALAXY.NG1.CalcListComponent.notSelected"></span>
            <strong>{{row.otherPartyInfo.avatar.displayName}}</strong><br />
          </td>
          <td class="hidden-xxs middle">
            {{ "SALAXY.ENUM.CalculationStatus." + row.status + ".label" | sxyTranslate }}<br /> {{ row.endAt | date }}
          </td>
          <td class="right hidden-xxs middle">
            {{ row.grossSalary | currency }}<br /> {{ row.payment | currency }}
          </td>
          <td class="hidden-xxs middle" colspan="{{$ctrl.readOnly ? 2 : 1}}">

            <button ng-if="!row.isReadOnly && !$ctrl.readOnly" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.edit' | sxyTranslate}}" class="btn btn-sm btn-primary btn-block">
              <i class="bi bi-pencil-fill d-inline-block d-sm-none"></i><span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.edit"></span>
            </button>
            <button ng-if="!row.isReadOnly && $ctrl.readOnly" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
              <i class="bi bi-info-circle d-inline-block d-sm-none"></i><span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.show"></span>
            </button>
          </td>
          <td class="hidden-xxs middle" ng-if="!$ctrl.readOnly">
            <button ng-click="$crud.delete(row)" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}" class="btn btn-sm btn-danger btn-block"><i
                class="bi bi-trash-fill d-inline-block d-sm-none"></i><span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.delete"></span></button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`), s.put("salaxy-components/odata/lists/CalculationsEmployer.html", `<div ng-class="$ctrl.getCssClass()">


  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>

          <th>
            <span sxy-orderby="status">
              <span sxy-text="SALAXY.NG1.WorkerDetailsComponent.calculationsWorker.status"></span>
            </span>
            <br />
            <span sxy-orderby="endAt">
              <span sxy-text="SALAXY.NG1.WorkerDetailsComponent.calculationsWorker.date"></span>
            </span>
          </th>
          <th class="right">
            <span sxy-orderby="grossSalary"><span sxy-text="SALAXY.NG1.WorkerDetailsComponent.calculationsWorker.salary"></span></span><br />
            <span sxy-orderby="payment"><span sxy-text="SALAXY.NG1.WorkerDetailsComponent.calculationsWorker.payment"></span></span>
          </th>
          <th class="right">


          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">

          <td>
            <div ng-switch="row.status">
              <span ng-switch-when="paymentWorkerCopy" class="text-success">
                Maksettu
              </span>
              <span ng-switch-when="workerRequested">
                Lähetetty
              </span>
              <span ng-switch-when="workerRequestAccepted">
                Hyväksytty
              </span>
              <span ng-switch-when="workerRequestDeclined" class="text-warning">
                Hylätty
              </span>

            </div>
            <!--TODO add better status descriptons-->
            <!--br> {{ "SALAXY.ENUM.CalculationStatus." + row.status + ".label" | sxyTranslate }}-->
            {{ (row.salaryDate || row.endAt) | date}}
          </td>
          <td class="right">
            {{ row.grossSalary | currency }}
            <br /> {{ row.payment | currency }}
          </td>
          <td class="right middle">
            <button ng-click="$crud.showDetails(row)" class="btn btn-sm btn-default" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}">
              <i class="bi bi-info-circle d-inline-block d-sm-none"></i>
              
              <span class="d-sm-inline-block d-none" sxy-text="SALAXY.UI_Terms.show"></span>
            </button>

            <a ng-href="{{$crud.getPdfUrl(row)}}" target="_blank" title="{{ 'SALAXY.UI_Terms.printable' | sxyTranslate}}" class="btn btn-sm btn-default">
              <i class="bi bi-file-earmark-pdf d-inline-block d-sm-none"></i>
              <span class="d-sm-inline-block d-none" sxy-text="SALAXY.UI_Terms.printable"></span>
            </a>
          </td>

        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`), s.put("salaxy-components/odata/lists/CalculationsEmployerAll.html", `<div ng-class="$ctrl.getCssClass()">


  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th colspan="2">
            <span sxy-text="SALAXY.NG1_Other.Roles.employer"></span>
          </th>
          <th>
            <span sxy-orderby="status">
              <span sxy-text="SALAXY.NG1.WorkerDetailsComponent.calculationsWorker.status"></span>
            </span>
            <br />
            <span sxy-orderby="endAt">
              <span sxy-text="SALAXY.NG1.WorkerDetailsComponent.calculationsWorker.date"></span>
            </span>
          </th>
          <th class="right">
            <span sxy-orderby="grossSalary"><span sxy-text="SALAXY.NG1.WorkerDetailsComponent.calculationsWorker.salary"></span></span><br />
            <span sxy-orderby="payment"><span sxy-text="SALAXY.NG1.WorkerDetailsComponent.calculationsWorker.payment"></span></span>
          </th>
          <th class="right">


          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="td-avatar  middle">
            <div ng-if="row.status != 'draft'">

              <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
            </div>
            <div ng-if="row.status == 'draft'">
              <i class="bi bi-question-circle-fill" style="font-size: 45px;color: #d0d0d0;"></i>
            </div>
          </td>
          <td class="td-name  middle">
            <div ng-if="row.status == 'draft'">
              <span class="small" sxy-html="Luonnoslaskelma<br>Ei työnantajaa"></span>
            </div>
            <div ng-if="row.status != 'draft'">

              <strong>{{row.otherPartyInfo.avatar.displayName}}</strong><br>
              <small>{{row.otherPartyInfo.email}}</small>
            </div>
          </td>
          <td>
            <div ng-switch="row.status">
              <span ng-switch-when="draft">
                Luonnos
              </span>
              <span ng-switch-when="paymentWorkerCopy" class="text-success">
                Maksettu
              </span>
              <span ng-switch-when="workerRequested">
                Lähetetty
              </span>
              <span ng-switch-when="workerRequestAccepted" class="text-warning">
                Hyväksytty
              </span>
              <span ng-switch-when="workerRequestDeclined" class="text-danger">
                Hylätty
              </span>

            </div>
            <!--TODO add better status descriptons-->
            <!--br> {{ "SALAXY.ENUM.CalculationStatus." + row.status + ".label" | sxyTranslate }}-->
            {{ (row.salaryDate || row.endAt) | date}}
          </td>
          <td class="right">
            {{ row.grossSalary | currency }}
            <br /> {{ row.payment | currency }}
          </td>
          <td class="right middle">
            <button ng-click="$crud.showDetails(row)" class="btn btn-sm btn-default" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}">
              <i class="bi bi-info-circle d-inline-block d-sm-none"></i>
              
              <span class="d-sm-inline-block d-none" sxy-text="SALAXY.UI_Terms.show"></span>
            </button>

            <a ng-href="{{$crud.getPdfUrl(row)}}" target="_blank" title="{{ 'SALAXY.UI_Terms.printable' | sxyTranslate}}" class="btn btn-sm btn-default">
              <i class="bi bi-file-earmark-pdf d-inline-block d-sm-none"></i>
              <span class="d-sm-inline-block d-none" sxy-text="SALAXY.UI_Terms.printable"></span>
            </a>
          </td>

        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`), s.put("salaxy-components/odata/lists/CalculationsPaid.html", `<div ng-class="$ctrl.getCssClass()">
  <div class="visible-xxs">
    <div class="table-header-container-mobile" ng-show="!$ctrl.readOnly">
      <a class="btn btn-sm btn-block btn-primary" href="#/calc/details/new" sxy-text="SALAXY.UI_Terms.createNew"></a>
    </div>
    <div class="table-filter-container-mobile">
      <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search" label-type="plain">
      </salaxy-input>
    </div>
  </div>
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th colspan="2" sxy-orderby="otherPartyInfo/avatar/displayName">
            <span sxy-text="SALAXY.NG1_Other.Roles.worker"></span>
          </th>
          <th class="hidden-xxs">
            <span sxy-orderby="status"><span sxy-text="SALAXY.NG1.CalcListComponent.status.title"></span></span><br />
            <span sxy-orderby="endAt"><span sxy-text="SALAXY.NG1.CalcListComponent.payment"></span></span>
          </th>
          <th class="right ">
            <span sxy-orderby="grossSalary"><span sxy-text="SALAXY.NG1.CalcListComponent.salary"></span></span><br />
            <span sxy-orderby="payment"><span sxy-text="SALAXY.NG1.CalcListComponent.payment"></span></span>
          </th>
          <th class="right hidden-xxs" colspan="3">
            <salaxy-odata-actions show-export="true"></salaxy-odata-actions>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="td-avatar visible-xxs middle">
            <a href="" ng-click="$crud.showDetails(row)">
              <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
            </a>
          </td>
          <td class="td-name visible-xxs middle">
            <a href="" ng-click="$crud.showDetails(row)">
              <span ng-if="row.otherPartyInfo.avatar.displayName == ''" sxy-text="SALAXY.NG1.CalcListComponent.notSelected"></span>
              <strong>{{row.otherPartyInfo.avatar.displayName}}</strong><br /> {{ "SALAXY.ENUM.CalculationStatus." + row.status + ".label" | sxyTranslate }}
              <br /> {{ row.endAt | date }}
            </a>
          </td>
          <td class="right visible-xxs bottom">
            <a href="" ng-click="$crud.showDetails(row)">
              {{ row.grossSalary | currency }}<br />
              {{ row.payment | currency }}
            </a>
          </td>
          <td class="td-avatar hidden-xxs middle">
            <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
          </td>
          <td class="td-name hidden-xxs middle">
            <span ng-if="row.otherPartyInfo.avatar.displayName == ''" sxy-text="SALAXY.NG1.CalcListComponent.notSelected"></span>
            <strong>{{row.otherPartyInfo.avatar.displayName}}</strong><br />
          </td>
          <td class="hidden-xxs middle">
            {{ "SALAXY.ENUM.CalculationStatus." + row.status + ".label" | sxyTranslate }}<br /> {{ row.endAt | date }}
          </td>
          <td class="right hidden-xxs middle">
            {{ row.grossSalary | currency }}<br /> {{ row.payment | currency }}
          </td>
          <td class="hidden-xxs middle" colspan="{{$ctrl.readOnly ? 2 : 1 }}">
            <a href="" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
              <i class="bi bi-info-circle d-inline-block d-sm-none"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.show"></span>
            </a>
          </td>
          <td class="hidden-xxs middle" ng-if="!$ctrl.readOnly">
            <button ng-click="$crud.showCopyAsNew(row)" title="{{ 'SALAXY.UI_Terms.copyAsNew' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
              <i class="bi bi-copy d-inline-block d-sm-none"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.copyAsNew"></span>
            </button>
          </td>
          <td class="hidden-xxs middle">
            <a ng-href="{{$crud.getPdfUrl(row)}}" target="_blank" title="{{ 'SALAXY.UI_Terms.printable' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
              <i class="bi bi-file-earmark-pdf d-inline-block d-sm-none"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.printable"></span>
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`), s.put("salaxy-components/odata/lists/CalculationsPaidIr.html", `<div ng-class="$ctrl.getCssClass()">
  <div class="visible-xxs">
    <div class="table-filter-container-mobile">
      <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search" label-type="plain">
      </salaxy-input>
    </div>
  </div>
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th colspan="2" sxy-orderby="otherPartyInfo/avatar/displayName">
            <span sxy-text="SALAXY.NG1_Other.Roles.worker"></span>
          </th>
          <th class="hidden-xxs">
            <span sxy-orderby="salaryDate"><span sxy-text="SALAXY.NG1.PayrollListComponent.salaryDate"></span></span><br />
          </th>
          <th class="right ">
            <span sxy-orderby="grossSalary"><span sxy-text="SALAXY.NG1.CalcListComponent.salary"></span></span><br />
          </th>
          <th class="hidden-xxs">
            <span sxy-orderby="endAt"><span sxy-text="SALAXY.NG1.PayrollListComponent.paymentDate"></span></span><br />
          </th>
          <th class="hidden-xxs">
            <span sxy-text="Ilmoitus"></span>
          </th>
          <th class="right hidden-xxs" colspan="4">
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="td-avatar visible-xxs middle">
            <a href="" ng-click="$crud.showDetails(row)">
              <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
            </a>
          </td>
          <td class="td-name visible-xxs middle">
            <a href="" ng-click="$crud.showDetails(row)">
              <span ng-if="row.otherPartyInfo.avatar.displayName == ''" sxy-text="SALAXY.NG1.CalcListComponent.notSelected"></span>
              <strong>{{row.otherPartyInfo.avatar.displayName}}</strong>
              <br /> {{ row.salaryDate | date }}
            </a>
          </td>
          <td class="right visible-xxs bottom">
            <a href="" ng-click="$crud.showDetails(row)">
              {{ row.grossSalary | currency }}
              <br /> {{ row.endAt | date }}
            </a>
          </td>
          <td class="td-avatar hidden-xxs middle">
            <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
          </td>
          <td class="td-name hidden-xxs middle">
            <span ng-if="row.otherPartyInfo.avatar.displayName == ''" sxy-text="SALAXY.NG1.CalcListComponent.notSelected"></span>
            <strong>{{row.otherPartyInfo.avatar.displayName}}</strong><br />
          </td>
          <td class="hidden-xxs middle">
            {{ row.salaryDate | date }}
          </td>
          <td class="right hidden-xxs middle">
            {{ row.grossSalary | currency }}
          </td>
          <td class="hidden-xxs middle">
            {{ row.endAt | date }}
          </td>
          <td class="hidden-xxs middle">
            <div ng-repeat="message in row.messages" ng-bind-html="message | sxyWorkflowMessage: 'SystemMessageReportChecked,SystemMessageReportInvalid,SystemMessageReportScheduled,SystemMessageReportDelivered,SystemMessageReportCanceled,SystemMessageReportError'"></div>
          </td>
          <td class="hidden-xxs middle" ng-show="row.status == 'paymentSucceeded'">
            <a href="" ng-click="$crud.showEpr(row)" title="{{ 'SALAXY.NG1.CalcReportsComponent.irFull' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
              <i class="bi bi-info-lg visible-xs me-1"></i><span class="hidden-xs" sxy-text="Ilmoitus"></span>
            </a>
          </td>
          <td class="hidden-xxs middle" colspan="{{$ctrl.readOnly ? 2 : 1 }}">
            <a href="" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
              <i class="bi bi-info-lg visible-xs me-1"></i><span class="hidden-xs" sxy-text="SALAXY.UI_Terms.show"></span>
            </a>
          </td>
          <td class="hidden-xxs middle" ng-if="!$ctrl.readOnly">
            <button ng-click="$crud.showCopyAsNew(row)" title="{{ 'SALAXY.UI_Terms.copyAsNew' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
              <i class="bi bi-copy visible-xs me-1"></i><span class="hidden-xs" sxy-text="SALAXY.UI_Terms.copy"></span>
            </button>
          </td>
          <td class="hidden-xxs middle">
            <a ng-href="{{$crud.getPdfUrl(row)}}" target="_blank" title="{{ 'SALAXY.UI_Terms.printable' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
              <i class="bi bi-file-earmark-pdf visible-xs me-1"></i><span class="hidden-xs" sxy-text="SALAXY.UI_Terms.printable"></span>
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>
`), s.put("salaxy-components/odata/lists/CalculationsPanel.html", `<div class="salaxy-odata-card card list-card calc-list-card  card-sm card-secondary" ng-init="hideFilter = false">
  

  <div class="card-header">
    {{'SALAXY.NG1.CalcListComponent.panel.' + $ctrl.data.category + '.heading' | sxyTranslate}}
    <div class="float-end" ng-show="$ctrl.data.category != 'sentAndDraft'">
      <button class="btn btn-secondary btn-xs" ng-click="hideFilter = !hideFilter" title="{{'SALAXY.NG1.CalculationsPanelComponent.showFilters' | sxyTranslate}}">
        <i class="bi bi-funnel-fill"></i>
      </button>
    </div>
    <div class="float-end" ng-if="$ctrl.data.category == 'sentAndDraft'">
      <salaxy-action-button action="'newCalc'" button-class="btn-primary btn-labeled-right btn-xs" label="{{'SALAXY.NG1.CalculationsPanelComponent.newCalc' | sxyTranslate}}"></salaxy-action-button>
    </div>
  </div>

  <div class="card-body filters text-end" ng-class="{showfilters: hideFilter}" ng-if="$ctrl.data.category != 'sentAndDraft'">
    <div class="">
      <div class="filter-buttons">
        <button class="btn btn-xs btn-secondary text-end" sxy-orderby="otherPartyInfo/avatar/displayName" sxy-text="SALAXY.UI_Terms.abc"></button>
        <button class="btn btn-xs btn-secondary text-end" sxy-orderby="endAt">
          <i class="bi bi-calendar3"></i>
        </button>
        <button ng-if="$ctrl.data.category == 'paid' || $ctrl.data.category == 'sent'" class="btn btn-xs btn-secondary text-end" sxy-orderby="status" sxy-text="SALAXY.NG1.CalculationsPanelComponent.status"></button>
        <button class="btn btn-xs btn-secondary text-end" sxy-orderby="grossSalary">
          €
        </button>
      </div>
      <salaxy-input name="search1cp{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search d-none d-sm-inline-block" label-type="plain">
      </salaxy-input>
    </div>

  </div>

  <div ng-class="$ctrl.getCssClass()" ng-if="$ctrl.data.category != 'shared' && $ctrl.data.category != 'sentAndDraft' ">
    <div class="d-block d-sm-none">
      <div class="table-filter-container-mobile">
        <salaxy-input name="search2cp{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search" label-type="plain">
        </salaxy-input>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table">
        <tbody>
          <tr ng-repeat="row in $ctrl.items">
            <td class="td-avatar middle hidden-xxs">
              <salaxy-avatar ng-if="$ctrl.data.category != 'sent'" avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
              <salaxy-avatar ng-if="$ctrl.data.category == 'sent'" avatar="row.ownerInfo.avatar"></salaxy-avatar>
            </td>
            <td class="middle">
              <strong ng-if="$ctrl.data.category != 'sent'">{{row.otherPartyInfo.avatar.displayName}}</strong>
              <strong ng-if="$ctrl.data.category == 'sent'">{{row.ownerInfo.avatar.displayName}}</strong>
              <br /> {{ row.endAt | date }}
            </td>
            <td class="middle right">
              {{ row.grossSalary | currency }}
              <br />
              <span ng-if="row.status != 'workerRequestAccepted' && row.status != 'workerRequestDeclined' && row.status != 'workerRequested' && row.status != 'paymentWorkerCopy'" class="row-status" ng-class="{'text-warning' : row.status == 'paymentStarted', 'text-success' : row.status == 'paymentSucceeded'}">{{ "SALAXY.ENUM.CalculationStatus." + row.status + ".label" | sxyTranslate }}</span>
              <span ng-if="row.status == 'workerRequestAccepted' " class="row-status text-success" sxy-text="SALAXY.NG1.CalculationsPanelComponent.accepted"></span>
              <span ng-if="row.status == 'workerRequestDeclined' " class="row-status text-danger" sxy-text="SALAXY.NG1.CalculationsPanelComponent.declined"></span>
            </td>
            <td class="right middle">
              <button ng-if="$ctrl.data.category == 'draft'" ng-click="$crud.showDetails(row)" title="{{'SALAXY.UI_Terms.edit' | sxyTranslate}}" class="btn btn-sm" ng-class="$ctrl.readOnly ? 'btn-secondary' : 'btn-primary'">
                <i class="bi" ng-class="$ctrl.readOnly ? 'bi-file-text' : 'bi-pencil-fill'"></i>
              </button>
              <button ng-if="$ctrl.data.category == 'paid' || $ctrl.data.category == 'sent' || $ctrl.data.category == 'received'" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-sm btn-secondary">
                <i class="bi bi-file-text"></i>
              </button>
              <button ng-if="$ctrl.data.category == 'paid' && !$ctrl.readOnly" ng-click="$crud.showCopyAsNew(row)" title="{{ 'SALAXY.UI_Terms.copyAsNew' | sxyTranslate}}" class="btn btn-sm btn-secondary">
                <i class="bi bi-copy"></i>
              </button>
              <a ng-if="$ctrl.data.category == 'paid' || $ctrl.data.category == 'sent' || $ctrl.data.category == 'received'" ng-href="{{$crud.getPdfUrl(row)}}" target="_blank" title="{{ 'SALAXY.UI_Terms.printable' | sxyTranslate}}" class="btn btn-sm btn-secondary">
                <i class="bi bi-file-earmark-pdf"></i>
              </a>
            </td>

          </tr>
        </tbody>

      </table>
      <div class="salaxy-odata-footer">
        <salaxy-spinner></salaxy-spinner>
      </div>
    </div>
  </div>
  <!-- IF category is Shared -->
  <div ng-class="$ctrl.getCssClass()" ng-if="$ctrl.data.category == 'shared' ">
    <div class="d-block d-sm-none">
      <div class="table-filter-container-mobile">
        <salaxy-input name="search2cp{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search" label-type="plain">
        </salaxy-input>
      </div>
    </div>

    <div class="table-responsive">
      <table class="table">
        <tbody>
          <tr ng-repeat="row in $ctrl.items">
            <td class="td-avatar middle hidden-xxs">
              <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
            </td>
            <td class="middle">
              <strong>{{row.otherPartyInfo.avatar.displayName}}</strong>
              <br /> {{ row.endAt | date }}
            </td>
            <td class="middle">
              <span class="text-success" ng-if="row.status == 'sharedApproved'" sxy-text="SALAXY.NG1.CalculationsPanelComponent.accepted"></span>
              <span class="text-warning" ng-if="row.status == 'sharedWaiting'" sxy-text="SALAXY.NG1.CalculationsPanelComponent.waiting" ps="..."></span>


            </td>
            <td class="middle right">
              {{ row.grossSalary | currency }}
              <br /> {{ row.payment | currency }}

            </td>
            <td class="right middle">
              <button ng-if="!$ctrl.readOnly" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.edit' | sxyTranslate}}" class="btn btn-sm btn-primary">
                <i class="bi bi-pencil-fill"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="salaxy-odata-footer">
        <salaxy-spinner></salaxy-spinner>
      </div>
    </div>
  </div>
  <!-- IF category is Sent or Draft-->
  <div ng-class="$ctrl.getCssClass()" ng-if="$ctrl.data.category == 'sentAndDraft'">


    <div class="table-responsive">
      <table class="table">
        <tbody>
          <tr ng-repeat="row in $ctrl.items">
            <td class="td-avatar middle hidden-xxs">
              <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
            </td>
            <td class="middle">
              <strong>{{row.otherPartyInfo.avatar ? row.otherPartyInfo.avatar.displayName : 'SALAXY.UI_Terms.notChosen' | sxyTranslate}}</strong>
              <br /> {{ row.endAt | date }}
            </td>
            <td class="middle">
              <span class="text-warning" ng-if="row.status == 'workerRequested'" sxy-text="SALAXY.NG1.CalculationsPanelComponent.sent"></span>

              <span ng-if="row.status == 'draft'" sxy-text="SALAXY.NG1.CalculationsPanelComponent.draft"></span>

            </td>
            <td class="middle right">
              {{ row.grossSalary | currency }}
              <br /> {{ row.payment | currency }}

            </td>
            <td class="right middle">
              <button ng-if="!$ctrl.readOnly" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.edit' | sxyTranslate}}" class="btn btn-sm btn-primary">
                <i class="bi bi-pencil-fill"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="salaxy-odata-footer">
        <salaxy-spinner></salaxy-spinner>
      </div>
    </div>
  </div>



  <!--TODO add binding showAllUrl -->

  <div class="card-footer text-center">
    <a ng-if="$ctrl.data.category != 'received' && $ctrl.data.category != 'sent' && $ctrl.data.category != 'sentAndDraft'" class="btn btn-primary btn-sm" href="#/calc/{{$ctrl.data.category}}" sxy-text="SALAXY.NG1.CalculationsPanelComponent.showWholeList"></a>

    <a ng-if="$ctrl.data.category == 'sent'" class="btn btn-primary btn-sm" href="#/calc/sent" sxy-text="SALAXY.NG1.CalculationsPanelComponent.sentAlt"></a>
    <a ng-if="$ctrl.data.category == 'sent'" class="btn btn-primary btn-sm" href="#/calc/draft" sxy-text="SALAXY.NG1.CalculationsPanelComponent.drafts"></a>
    <a ng-if="$ctrl.data.category == 'received'" class="btn btn-secondary btn-sm" href="#/calc/paid" sxy-text="SALAXY.NG1.CalculationsPanelComponent.allPaid"></a>
    <span class="" ng-if="$ctrl.data.category == 'sentAndDraft'">
      <a class="btn btn-secondary btn-sm" href="#/calc/sent" sxy-text="SALAXY.NG1.CalculationsPanelComponent.allSent"></a>
      <a class="btn btn-secondary btn-sm" href="#/calc/draft" sxy-text="SALAXY.NG1.CalculationsPanelComponent.allDrafts"></a>
    </span>
  </div>

</div>`), s.put("salaxy-components/odata/lists/CalculationsPaymentStartedPanel.html", `<div class="salaxy-odata-card card list-card with-footer calc-list-card card-sm card-secondary">
  <div class="card-header">
    {{'SALAXY.NG1.CalcListComponent.panel.paymentStarted.heading' | sxyTranslate}}
  </div>

  <div ng-class="$ctrl.getCssClass()">
    <div class="table-responsive">
      <table class="table table-striped">
        <tbody>
          <tr ng-repeat="row in $ctrl.items">
            <td class="td-avatar  middle">
              <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
            </td>
            <td class="td-name middle">
              <span ng-if="row.otherPartyInfo.avatar.displayName == ''" sxy-text="SALAXY.NG1.CalcListComponent.notSelected"></span>
              <strong>{{row.otherPartyInfo.avatar.displayName}}</strong><br />
              {{ row.salaryDate | date }}
            </td>
            <td class="right">
              {{ row.grossSalary | currency }}<br />
              <span class="text-warning">{{ "SALAXY.ENUM.CalculationStatus." + row.status + ".label" | sxyTranslate }}</span>              
            </td>
            <td class="middle right">
              <a href="" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-sm btn-secondary"><i class="bi bi-info-circle "></i></a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="card-footer text-center bg-secondary">
      <salaxy-odata-footer></salaxy-odata-footer>
    </div>
  </div>
</div>`), s.put("salaxy-components/odata/lists/CalculationsReceived.html", `<div ng-class="$ctrl.getCssClass()">
  <div class="visible-xxs">
    <div class="table-header-container-mobile" ng-show="!$ctrl.readOnly">
      <a class="btn btn-sm btn-block btn-primary" href="#/calc/details/new" sxy-text="SALAXY.UI_Terms.createNew"></a>
    </div>
    <div class="table-filter-container-mobile">
      <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search" label-type="plain">
      </salaxy-input>
    </div>
  </div>
  <div class="table-responsive light-bg">
    <table class="table table-striped">
      <thead>
        <tr>
          <th colspan="2" sxy-orderby="otherPartyInfo/avatar/displayName">
            <span sxy-text="SALAXY.NG1_Other.Roles.employer"></span>
          </th>
          <th class="hidden-xxs right">
            <span sxy-orderby="endAt"><span sxy-text="SALAXY.NG1.CalcListComponent.date"></span></span>
          </th>
          <th class="right">
            <span sxy-orderby="grossSalary"><span sxy-text="SALAXY.NG1.CalcListComponent.salary"></span></span><br />
            <span sxy-orderby="payment"><span sxy-text="SALAXY.NG1.CalcListComponent.payment"></span></span>
          </th>
          <th class="right hidden-xxs" colspan="2">
            <salaxy-odata-actions show-export="true"></salaxy-odata-actions>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="td-avatar visible-xxs middle">
            <a href="" ng-click="$crud.showDetails(row)">
              <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
            </a>
          </td>
          <td class="td-name visible-xxs middle">
            <a href="" ng-click="$crud.showDetails(row)">
              <span ng-if="row.otherPartyInfo.avatar.displayName == ''" sxy-text="SALAXY.NG1.CalcListComponent.notSelected"></span>
              <strong>{{row.otherPartyInfo.avatar.displayName}}</strong><br /> {{ "SALAXY.ENUM.CalculationStatus." + row.status + ".label" | sxyTranslate }}
              <br /> {{ row.endAt | date }}
            </a>
          </td>
          <td class="right visible-xxs bottom">
            <a href="" ng-click="$crud.showDetails(row)">
              {{ row.grossSalary | currency }}<br />
              {{ row.data.workerPayment | currency }}
            </a>
          </td>
          <td class="td-avatar hidden-xxs middle">
            <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
          </td>
          <td class="td-name hidden-xxs middle">
            <span ng-if="row.otherPartyInfo.avatar.displayName == ''" sxy-text="SALAXY.NG1.CalcListComponent.notSelected"></span>
            <strong>{{row.otherPartyInfo.avatar.displayName}}</strong><br />
            <a href="mailto:{{row.otherPartyInfo.email}}">{{row.otherPartyInfo.email}}</a><br /> Puh: {{row.otherPartyInfo.telephone || "-"}}<br />
          </td>
          <td class="hidden-xxs middle right">
            {{ row.endAt | date }}
          </td>
          <td class="right hidden-xxs middle">
            {{ row.grossSalary | currency }}<br /> {{ row.data.workerPayment | currency }}
          </td>
          <td class="hidden-xxs middle">
            <a href="" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
              <i class="bi bi-info-circle d-inline-block d-sm-none"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.show"></span>
            </a>
          </td>
          <td class="hidden-xxs middle">
            <a ng-href="{{$crud.getPdfUrl(row)}}" target="_blank" title="{{ 'SALAXY.UI_Terms.printable' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
              <i class="bi bi-file-earmark-pdf"></i>
              <span class="d-none d-sm-inline-block" pre=" " sxy-text="SALAXY.UI_Terms.printable"></span>
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`), s.put("salaxy-components/odata/lists/CalculationsRepairs.html", `<div ng-class="$ctrl.getCssClass()">
  <div class="visible-xxs">
    <div class="table-filter-container-mobile">
      <salaxy-input name="search1x{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search" label-type="plain">
      </salaxy-input>
    </div>
  </div>
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th colspan="2" sxy-if-role="!worker">
            <span sxy-orderby="otherPartyInfo/avatar/displayName" sxy-text="SALAXY.NG1_Other.Roles.worker"></span>
          </th>
          <th sxy-if-role="worker">
            <span sxy-orderby="endAt" sxy-text="SALAXY.NG1.CalcListComponent.date"></span>
          </th>
          <th class="hidden-xxs" sxy-if-role="!worker">
            <span sxy-text="SALAXY.NG1.CalcListComponent.status.title"></span><br />
            <span sxy-orderby="salaryDate"><span sxy-text="SALAXY.NG1.CalculationsWithSalaryDateSelectComponent.salaryDate"></span></span>
          </th>
          <th class="right ">
            <span sxy-orderby="grossSalary"><span sxy-text="SALAXY.NG1.CalcListComponent.salary" ></span></span><br />
          </th>
          <th class="right hidden-xxs" colspan="2">
            <salaxy-odata-actions></salaxy-odata-actions>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="td-avatar visible-xxs middle" sxy-if-role="!worker">
            <a href="" ng-click="$crud.showDetails(row)">
              <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
            </a>
          </td>
          <td class="td-name visible-xxs middle" sxy-if-role="!worker">
            <a href="" ng-click="$crud.showDetails(row)">
              <span ng-if="row.otherPartyInfo.avatar.displayName == ''" sxy-text="SALAXY.NG1.CalcListComponent.notSelected"></span>
              <strong>{{row.otherPartyInfo.avatar.displayName}}</strong><br /> {{ "SALAXY.ENUM.CalculationStatus." + row.status + ".label" | sxyTranslate }}
              <br />{{ row.endAt | date }}
            </a>
          </td>
          <td class="td-name visible-xxs middle" sxy-if-role="worker" ng-click="$crud.showDetails(row)">
            <a href="" ng-click="$crud.showDetails(row)">
              {{ row.endAt | date }}
            </a>
          </td>
          <td class="right visible-xxs bottom" ng-click="$crud.showDetails(row)">

            <a href="" ng-click="$crud.showDetails(row)">
              {{ row.grossSalary | currency }}
            </a>
          </td>
          <td class="td-avatar hidden-xxs middle" sxy-if-role="!worker">
            <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
          </td>
          <td class="td-name hidden-xxs middle" sxy-if-role="!worker">
            <span ng-if="row.otherPartyInfo.avatar.displayName == ''" sxy-text="SALAXY.NG1.CalcListComponent.notSelected"></span>
            <strong>{{row.otherPartyInfo.avatar.displayName}}</strong><br />
          </td>
          <td class="hidden-xxs middle">
            {{ "SALAXY.ENUM.CalculationStatus." + row.status + ".label" | sxyTranslate }}<br /> {{ row.salaryDate | date }}
          </td>
          <td class="right hidden-xxs middle">
            {{ row.grossSalary | currency }}
          </td>
          <td class="hidden-xxs middle" colspan="{{$ctrl.readOnly ? 2 : 1}}">
            <button ng-if="!row.isReadOnly && !$ctrl.readOnly" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.edit' | sxyTranslate}}" class="btn btn-sm btn-primary btn-block">
              <span class="hidden-xs" sxy-text="SALAXY.UI_Terms.edit"></span>
            </button>
            <button ng-if="!row.isReadOnly && $ctrl.readOnly" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
              <span class="hidden-xs" sxy-text="SALAXY.UI_Terms.show"></span>
            </button>
          </td>
          <td class="hidden-xxs middle" ng-if="!$ctrl.readOnly">
            <button ng-click="$crud.delete(row)" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}" class="btn btn-sm btn-danger btn-block">
              <span class="hidden-xs" sxy-text="SALAXY.UI_Terms.delete"></span></button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`), s.put("salaxy-components/odata/lists/CalculationsSent.html", `<div ng-class="$ctrl.getCssClass()">
  <div class="visible-xxs">
    <div class="table-header-container-mobile">
      <a class="btn btn-sm btn-block btn-primary" href="#/calc/details/new" sxy-text="SALAXY.UI_Terms.createNew"></a>
    </div>
    <div class="table-filter-container-mobile">
      <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search" label-type="plain">
      </salaxy-input>
    </div>
  </div>
  <div class="table-responsive light-bg">
    <table class="table table-striped">
      <thead>
        <tr>
          <th colspan="2" sxy-orderby="otherPartyInfo/avatar/displayName">
            <span sxy-text="SALAXY.NG1_Other.Roles.employer"></span>
          </th>
          <th class="hidden-xxs">
            <span sxy-orderby="status"><span sxy-text="SALAXY.NG1.CalcListComponent.status.title"></span></span><br />
            <span sxy-orderby="endAt"><span sxy-text="SALAXY.NG1.CalcListComponent.payment" ></span></span>
          </th>
          <th class="right ">
            <span sxy-orderby="grossSalary"><span sxy-text="SALAXY.NG1.CalcListComponent.salary" ></span></span><br />
            <span sxy-orderby="payment"><span sxy-text="SALAXY.NG1.CalcListComponent.payment" ></span></span>
          </th>
          <th class="right hidden-xxs" colspan="2">
            <div class="table-filter-container">
              <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" class="salaxy-odata-table-search" placeholder="SALAXY.UI_Terms.textSearch" label-type="plain"></salaxy-input>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="td-avatar visible-xxs middle">

            <a ng-click="$crud.showDetails(row)">
              <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
            </a>
          </td>
          <td class="td-name visible-xxs middle">
            <a ng-click="$crud.showDetails(row)">
              <span ng-if="row.otherPartyInfo.avatar.displayName == ''" sxy-text="(Ei työnantajaa)"></span>
              <strong>{{row.otherPartyInfo.avatar.displayName}}</strong>
              <br /> {{ "SALAXY.ENUM.CalculationStatus." + row.status + ".label" | sxyTranslate }}
              <br /> {{row.endAt | date}}
            </a>
          </td>
          <td class="right visible-xxs bottom">
            <a href="" ng-click="$crud.showDetails(row)">
              {{ row.grossSalary | currency }}
              <br />
              {{ row.payment | currency }}
            </a>
          </td>
          <td class="td-avatar hidden-xxs middle">

            <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
          </td>
          <td class="td-name hidden-xxs middle">
            <span ng-if="row.otherPartyInfo.avatar.displayName == ''" sxy-text="SALAXY.NG1.CalculationsSentComponent.noEmployee"></span>
            <strong>{{row.otherPartyInfo.avatar.displayName}}</strong><br />
          </td>
          <td class="hidden-xxs middle">
            <span ng-if="row.status == 'workerRequested'" class="text-warning" sxy-text="SALAXY.NG1.CalculationsSentComponent.waitingForAcception" ps="..."></span>
            <span ng-if="row.status == 'workerRequestDeclined'" class="text-danger" sxy-text="SALAXY.NG1.CalculationsSentComponent.declined"></span>
            <span ng-if="row.status == 'workerRequestAccepted'" class="text-success" sxy-text="SALAXY.NG1.CalculationsSentComponent.accepted"></span>
            <br /> {{row.endAt | date}}
          </td>
          <td class="right hidden-xxs middle">
            {{ row.grossSalary | currency }}<br /> {{ row.payment | currency }}
          </td>
          <td class="hidden-xxs middle">
            <button ng-click="$crud.showDetails(row)" ng-if="row.status == 'draft'" class="btn btn-sm btn-primary btn-block" title="{{ 'SALAXY.UI_Terms.edit' | sxyTranslate}}">
              <i class="bi bi-pencil-fill d-inline-block d-sm-none"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.edit"></span>
            </button>
            <button ng-click="$crud.showDetails(row)" ng-if="row.status != 'draft'" class="btn btn-sm btn-default btn-block" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}">
              <i class="bi bi-info-circle d-inline-block d-sm-none"></i></a>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.show" ng-if="!row.data.payrollId"></span>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.NG1.CalcListComponent.calculation" ng-if="row.data.payrollId"></span>
            </button>
          </td>
          <td class="hidden-xxs middle">
            <button ng-if="row.status == 'draft'" ng-click="$crud.delete(row)" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}" class="btn btn-sm btn-danger btn-block">
              <i class="bi bi-trash-fill d-inline-block d-sm-none"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.delete"></span></button>
            <button ng-if="!row.data.payrollId && (row.status == 'paymentSucceeded' || row.status == 'paymentStarted')" ng-click="$crud.showCopyAsNew(row)" class="btn btn-sm btn-default btn-block" title="{{ 'SALAXY.UI_Terms.copyAsNew' | sxyTranslate}}">
              <i class="bi bi-copy d-inline-block d-sm-none"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.copyAsNew"></span>
            </button>
            <a ng-if="row.data.payrollId" class="btn btn-sm btn-primary btn-block" ng-href="#/payroll/details/{{ row.data.payrollId }}">
              <i class="bi bi-list-task d-inline-block d-sm-none"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.NG1.CalcListComponent.payroll"></span>
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`), s.put("salaxy-components/odata/lists/CalculationsShared.html", `<div ng-class="$ctrl.getCssClass()">
  <div class="visible-xxs">

    <div class="table-filter-container-mobile">
      <salaxy-input name="search1x{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search" label-type="plain">
      </salaxy-input>
    </div>
  </div>
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th colspan="2" sxy-orderby="otherPartyInfo/avatar/displayName">
            <span sxy-text="SALAXY.NG1_Other.Roles.worker"></span>
          </th>
          <th class="hidden-xxs">
            <span sxy-text="SALAXY.NG1.CalcListComponent.status.title"></span><br />
            <span sxy-orderby="endAt"><span sxy-text="SALAXY.NG1.CalcListComponent.date"></span></span>
          </th>
          <th class="right ">
            <span sxy-orderby="grossSalary"><span sxy-text="SALAXY.NG1.CalcListComponent.salary" ></span></span><br />
            <span sxy-orderby="payment"><span sxy-text="SALAXY.NG1.CalcListComponent.payment" ></span></span>
          </th>
          <th class="right hidden-xxs">
            <salaxy-odata-actions show-export="true"></salaxy-odata-actions>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="td-avatar visible-xxs middle">
            <a href="" ng-click="$crud.showDetails(row)">
              <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
            </a>
          </td>
          <td class="td-name visible-xxs middle">
            <a href="" ng-click="$crud.showDetails(row)">
              <span ng-if="row.otherPartyInfo.avatar.displayName == ''" sxy-text="SALAXY.NG1.CalcListComponent.notSelected"></span>
              <strong>{{row.otherPartyInfo.avatar.displayName}}</strong><br />

              <span ng-switch="row.status">
               
              <span ng-switch-when="sharedApproved" class="status text-success small" sxy-text="SALAXY.NG1.CalculationsSharedComponent.accepted"></span>
              <span ng-switch-when="sharedWaiting" class="status text-warning small" sxy-text="SALAXY.NG1.CalculationsSharedComponent.waitingForHandling"></span>
              <span ng-switch-when="sharedRejected" class="status text-danger small" sxy-text="SALAXY.NG1.CalculationsSharedComponent.declined"></span>
              <br />{{ row.endAt | date }}
            </a>
          </td>
          <td class="right visible-xxs bottom">
            <a href="" ng-click="$crud.showDetails(row)">
              {{ row.grossSalary | currency }}<br />
              {{ row.payment | currency }}
            </a>
          </td>
          <td class="td-avatar hidden-xxs middle">
            <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
          </td>
          <td class="td-name hidden-xxs middle">
            <span ng-if="row.otherPartyInfo.avatar.displayName == ''" sxy-text="SALAXY.NG1.CalcListComponent.notSelected"></span>
            <strong>{{row.otherPartyInfo.avatar.displayName}}</strong><br />
          </td>
          <td class="hidden-xxs middle">
            <span ng-switch="row.status">
              <span ng-switch-when="sharedWaiting" class="status text-warning small" sxy-text="SALAXY.NG1.CalculationsSharedComponent.waitingForHandling"></span>
            <span ng-switch-when="sharedApproved" class="status text-success small" sxy-text="SALAXY.NG1.CalculationsSharedComponent.accepted"></span>
            
            <span ng-switch-when="sharedRejected" class="status text-danger small" sxy-text="SALAXY.NG1.CalculationsSharedComponent.declined"></span>
            <br /> {{ row.endAt | date }}
          </td>
          <td class="right hidden-xxs middle">
            {{ row.grossSalary | currency }}<br /> {{ row.payment | currency }}
          </td>
          <td class="middle right">
            <button ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.edit' | sxyTranslate}}" class="btn btn-sm btn-secondary">
              <i class="bi bi-info-circle d-inline-block d-sm-none"></i><span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.show"></span>
            </button>
          </td>
          <!-- <td class="hidden-xxs middle">
            <button ng-click="$crud.delete(row)" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}" class="btn btn-sm btn-danger btn-block"><i
                class="bi bi-trash-fill d-inline-block d-sm-none"></i><span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.delete"></span></button>
          </td>-->
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`), s.put("salaxy-components/odata/lists/CalculationsWithSalaryDate-select.html", `<div ng-class="$ctrl.getCssClass()">
  <div class="visible-xxs">
    <div class="table-filter-container-mobile">
      <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search" label-type="plain">
      </salaxy-input>
    </div>
  </div>
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th colspan="2">
            <span sxy-orderby="otherPartyInfo/avatar/displayName" sxy-text="SALAXY.NG1_Other.Roles.worker"></span>
            <span class="label label-primary clickable" ng-if="$ctrl.selectedItems.length" ng-click="$ctrl.selectedItems.splice(0,$ctrl.selectedItems.length)"> {{'SALAXY.UI_Terms.chosen' | sxyTranslate}}: {{ $ctrl.selectedItems.length }} <i class="bi bi-x-circle"></i></span>
          </th>
          <th class="hidden-xxs">
            <span sxy-text="SALAXY.NG1.CalcListComponent.status.title"></span><br />
            <span sxy-orderby="salaryDate"><span sxy-text="SALAXY.NG1.CalculationsWithSalaryDateSelectComponent.salaryDate"></span></span>
          </th>
          <th class="hidden-xxs">
            <span sxy-text="SALAXY.NG1.CalculationsWithSalaryDateSelectComponent.start"></span><br />
            <span sxy-text="SALAXY.NG1.CalculationsWithSalaryDateSelectComponent.end"></span>
          </th>
          <th class="right hidden-xxs" colspan="2">
            <div class="table-filter-container">
              <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" class="salaxy-odata-table-search" placeholder="SALAXY.UI_Terms.textSearch" label-type="plain"></salaxy-input>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="td-avatar visible-xxs middle">
            <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
          </td>
          <td class="td-name visible-xxs middle">
            <span ng-if="row.otherPartyInfo.avatar.displayName == ''" sxy-text="SALAXY.NG1.CalcListComponent.notSelected"></span>
            <strong>{{row.otherPartyInfo.avatar.displayName}}</strong><br /> {{ "SALAXY.ENUM.CalculationStatus." + row.status + ".label" | sxyTranslate }}
            <br /> {{ row.salaryDate | date }}
          </td>
          <td class="right visible-xxs bottom">
            <a href="" ng-click="$crud.showDetails(row)">
              {{ row.grossSalary | currency }}<br />
              {{ row.payment | currency }}
            </a>
          </td>
          <td class="td-avatar hidden-xxs middle">
            <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
          </td>
          <td class="td-name hidden-xxs middle">
            <span ng-if="row.otherPartyInfo.avatar.displayName == ''" sxy-text="SALAXY.NG1.CalcListComponent.notSelected"></span>
            <strong>{{row.otherPartyInfo.avatar.displayName}}</strong><br />
          </td>
          <td class="hidden-xxs middle">
            {{ row.status ? ("SALAXY.ENUM.CalculationStatus." + row.status + ".label" | sxyTranslate) : "#ERR" }}<br /> {{ row.salaryDate | date }}
          </td>
          <td class="hidden-xxs middle">
            {{ row.data.workStartDate | date}}<br /> {{ row.data.workEndDate | date }}
          </td>
          <td class="right hidden-xxs middle">
            {{ row.grossSalary | currency }}<br /> {{ row.payment | currency }}
          </td>
          <td class="right middle">
            <button class="btn btn-sm" type="button" ng-class="$ctrl.isSelected(row) ? 'btn-danger' : 'btn-info'" ng-click="$ctrl.setSelected(row, 'toggle')">
              {{ $ctrl.isSelected(row) ? ('SALAXY.UI_Terms.unselect' | sxyTranslate) : ('SALAXY.UI_Terms.select' | sxyTranslate) }}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`), s.put("salaxy-components/odata/lists/CalculationsWorker.html", `<div ng-class="$ctrl.getCssClass()">

  <div class="visible-xxs">
    <div class="table-header-container-mobile" ng-show="!$ctrl.readOnly">
      <a class="btn btn-sm btn-block btn-primary" href="#/calc/details/new" sxy-text="SALAXY.UI_Terms.createNew"></a>
    </div>
    <div class="table-filter-container-mobile">
      <salaxy-input name="searchMobile{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search" label-type="plain">
      </salaxy-input>
    </div>
  </div>
  <div id="calculations-worker-table" class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th>
            <span sxy-orderby="status">
              <span sxy-text="SALAXY.NG1.WorkerDetailsComponent.calculationsWorker.status"></span>
            </span>
            <br />
            <span sxy-orderby="endAt">
              <span sxy-text="SALAXY.NG1.WorkerDetailsComponent.calculationsWorker.date"></span>
            </span>
          </th>
          <th></th>
          <th class="right">
            <span sxy-orderby="grossSalary"><span sxy-text="SALAXY.NG1.WorkerDetailsComponent.calculationsWorker.salary"></span></span><br />
            <span sxy-orderby="payment"><span sxy-text="SALAXY.NG1.WorkerDetailsComponent.calculationsWorker.payment"></span></span>
          </th>
          <th class="right" colspan="{{$ctrl.readOnly ? 2 : 3}}">
            <salaxy-odata-actions show-export="true"></salaxy-odata-actions>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td>
            {{ "SALAXY.ENUM.CalculationStatus." + row.status + ".label" | sxyTranslate }}
            <br /> {{ (row.salaryDate || row.endAt) | date}}
          </td>
          <td>
            <div ng-if="$ctrl.logic.isNotCurrentEmployment(row)">
              Ei tämä työsuhde!<br />
              <a ng-href="#/employments/details/{{ row.data.employmentId }}" class="btn btn-xs btn-default">Näytä työsuhde...</a>
            </div>
          </td>
          <td class="right">
            {{ row.grossSalary | currency }}
            <br /> {{ row.payment | currency }}
          </td>
          <td class="middle">
            <button ng-click="$crud.showDetails(row)" ng-if="row.status == 'draft'" class="btn btn-sm btn-block" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" ng-class="$ctrl.readOnly ? 'btn-default' : 'btn-primary'">
              <i class="bi d-inline-block d-sm-none" ng-class="$ctrl.readOnly ? 'bi-info-lg' : 'bi-pencil-fill'"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.edit" ng-if="!$ctrl.readOnly"></span>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.show" ng-if="$ctrl.readOnly"></span>
            </button>
            <button ng-click="$crud.showDetails(row)" ng-if="row.status != 'draft'" class="btn btn-sm btn-default btn-block" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}">
              <i class="bi bi-info-circle d-inline-block d-sm-none"></i></a>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.show" ng-if="!row.data.payrollId"></span>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.NG1.WorkerDetailsComponent.calculationsWorker.calculation" ng-if="row.data.payrollId"></span>
            </button>
            
          </td>
          <td class="middle" ng-if="!$ctrl.readOnly">
            <button ng-if="row.status == 'draft' || row.status == 'history'" ng-click="$crud.delete(row)" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}" class="btn btn-sm btn-danger btn-block">
              <i class="bi bi-trash-fill d-inline-block d-sm-none"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.delete"></span>
            </button>
            <button ng-if="!row.data.payrollId && (row.status == 'paymentSucceeded' || row.status == 'paymentStarted') && ('employments.calcs.copyAsNew' | sxyShow: 'workers.details')" ng-click="$crud.showCopyAsNew(row)" class="btn btn-sm btn-default btn-block" title="{{ 'SALAXY.UI_Terms.copyAsNew' | sxyTranslate}}">
              <i class="bi bi-copy d-inline-block d-sm-none"></i><span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.copyAsNew"></span>
            </button>
            <a ng-if="row.data.payrollId" class="btn btn-sm btn-primary btn-block" ng-href="#/payroll/details/{{ row.data.payrollId }}">
              <i class="bi bi-list-task d-inline-block d-sm-none text-white"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.NG1.WorkerDetailsComponent.calculationsWorker.payroll"></span>
            </a>
          </td>
          <td class="middle">
            <a ng-href="{{$crud.getPdfUrl(row)}}" target="_blank" title="{{ 'SALAXY.UI_Terms.printable' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
              <i class="bi bi-file-earmark-pdf d-inline-block d-sm-none"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.printable"></span>
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`), s.put("salaxy-components/odata/lists/calendar/Events.html", `<div ng-class="$ctrl.getCssClass()">
  <table class="table">
    <thead>
      <tr>
        <th sxy-text="SALAXY.NG1.ODataCalendarEventComponent.description"></th>
        <th sxy-text="SALAXY.NG1.ODataCalendarEventComponent.categories"></th>
        <th sxy-orderby="logicalDate" sxy-text="SALAXY.NG1.ODataCalendarEventComponent.period"></th>
        <th sxy-text="SALAXY.NG1.ODataCalendarEventComponent.duration"></th>
        <th>
          <button type="button" ng-click="$crud.showDetailsDialog('new')" class="btn btn-primary" sxy-text="SALAXY.UI_Terms.addNew"></button>
          <button type="button" ng-click="$ctrl.reload()" class="btn btn-default">
            <i class="bi bi-arrow-repeat" aria-hidden="true"></i>
          </button>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="row in $ctrl.items">
        <td>{{ row.shortText }}</td>
        <td><small ng-repeat="cat in row.flags">{{ cat + ($last ? "" : ", ") }}</small></td>
        <td>{{ row.data | sxyDateRange }}</td>
        <td>{{ row.data.duration | sxyDuration }}</td>
        <td>
          <button type="button" ng-click="$crud.showDetailsDialog(row.id)" class="btn btn-default" sxy-text="SALAXY.UI_Terms.edit"></button>
          <a ng-href="{{'#/calendar/details/' + row.id}}" class="btn btn-default">Link</a>
          <button ng-click="$crud.delete(row)" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}" class="btn btn-danger">
            <i class="bi bi-trash-fill"></i>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`), s.put("salaxy-components/odata/lists/CustomerInvoices.html", `<div ng-class="$ctrl.getCssClass()">
  <table class="table">
    <thead>
      <tr>
        <th sxy-orderby="id" sxy-text="SALAXY.NG1.ApiCrudObjectComponent.id"></th>
        <th sxy-orderby="createdAt"  sxy-text="SALAXY.UI_Terms.created"></th>
        <th sxy-orderby="updatedAt" sxy-text="SALAXY.UI_Terms.updated"></th>
        <th sxy-orderby="owner" sxy-text="SALAXY.NG1.ApiCrudObjectComponent.owner"></th>
        <th sxy-orderby="isReadOnly" sxy-text="SALAXY.NG1.ApiCrudObjectComponent.readOnly"></th>
        <th sxy-orderby="partner" sxy-text="SALAXY.NG1.ApiCrudObjectComponent.partner"></th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="row in $ctrl.items">
        <td>{{ row.id }}</td>
        <td>{{ row.createdAt | sxyDate }}</td>
        <td>{{ row.updatedAt | sxyDate }}</td>
        <td>{{ row.owner }}</td>
        <td>{{ row.isReadOnly }}</td>
        <td>{{ row.partner }}</td>
        <td class="middle hidden-xxs">
          <button ng-if="!row.isReadOnly" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.edit' | sxyTranslate}}" class="btn btn-sm btn-primary btn-block">
            <i class="bi bi-pencil-fill d-inline-block d-sm-none"></i>
            <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.edit"></span>
          </button>
          <button ng-if="row.isReadOnly" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
            <i class="bi bi-info-circle d-inline-block d-sm-none"></i>
            <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.show"></span>
          </button>
        </td>
        <td class="middle hidden-xxs">
          <button ng-if="!row.isReadOnly" ng-click="$crud.delete(row)" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}" class="btn btn-sm btn-danger btn-block">
            <i class="bi bi-trash-fill d-inline-block d-sm-none"></i>
            <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.delete"></span>
          </button>
          <button ng-if="row.isReadOnly" ng-click="$crud.showCopyAsNew(row)" title="{{ 'SALAXY.UI_Terms.copyAsNew' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
            <i class="bi bi-copy d-inline-block d-sm-none"></i>
            <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.copyAsNew"></span>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`), s.put("salaxy-components/odata/lists/Datasets.html", `<div ng-class="$ctrl.getCssClass()">
  <table class="table">
    <thead>
      <tr>
        <th sxy-orderby="shortText" sxy-text="Teksti"></th>
        <th class="right">
          <div sxy-orderby="createdAt" sxy-text="SALAXY.UI_Terms.created"></div>
          <div sxy-orderby="updatedAt" sxy-text="SALAXY.UI_Terms.updated"></div>
        </th>
        <th sxy-orderby="isReadOnly" sxy-text="SALAXY.NG1.ApiCrudObjectComponent.readOnly"></th>
        <th class="right hidden-xxs" colspan="2">
          <div class="table-filter-container">
            <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" class="salaxy-odata-table-search" placeholder="SALAXY.UI_Terms.textSearch" label-type="plain"></salaxy-input>
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="row in $ctrl.items">
        <td>{{ row.shortText }}</td>
        <td class="right">
          <div>{{ row.createdAt | sxyDate }}</div>
          <div>{{ row.updatedAt | sxyDate }}</div>
        </td>
        <td>{{ row.isReadOnly }}</td>
        <td class="middle hidden-xxs">
          <button ng-if="!row.isReadOnly" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.edit' | sxyTranslate}}" class="btn btn-sm btn-primary btn-block">
            <i class="bi bi-pencil-fill d-inline-block d-sm-none"></i>
            <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.edit"></span>
            </button>
          <button ng-if="row.isReadOnly" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
            <i class="bi bi-info-circle d-inline-block d-sm-none"></i>
            <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.show"></span>
          </button>
        </td>
        <td class="middle hidden-xxs">
          <button ng-if="!row.isReadOnly" ng-click="$crud.delete(row)" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}" class="btn btn-sm btn-danger btn-block"><i
              class="bi bi-trash-fill d-inline-block d-sm-none"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.delete"></span>
          </button>
          <button ng-if="row.isReadOnly" ng-click="$crud.showCopyAsNew(row)" title="{{ 'SALAXY.UI_Terms.copyAsNew' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
            <i class="bi bi-copy d-inline-block d-sm-none"></i>
            <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.copyAsNew"></span>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`), s.put("salaxy-components/odata/lists/EarningsPayments.html", `<div ng-class="$ctrl.getCssClass()">
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th colspan="2" class="hidden-xxs">
            <span sxy-orderby="otherPartyInfo/avatar/displayName" class="clickable"><span sxy-text="SALAXY.NG1_Other.Roles.worker"></span><i ng-if="$odata.getColumnOrder('avatar/displayName')" class="bi bi-sort-{{ $odata.getColumnOrder('avatar/displayName') }}"
              aria-hidden="true"></i></span>
          </th>
          <th class="visible-xxs">
            <span sxy-orderby="otherPartyInfo/avatar/displayName" class="clickable"><span sxy-text="SALAXY.NG1_Other.Roles.worker"></span><i ng-if="$odata.getColumnOrder('avatar/displayName')" class="bi bi-sort-{{ $odata.getColumnOrder('avatar/displayName') }}"
              aria-hidden="true"></i></span>
          </th>
          <th>
            <span sxy-orderby="status" class="clickable"><span sxy-text="Tila"></span></span>
          </th>
          <th class="right">
            <span sxy-orderby="payment" class="clickable"><span sxy-text="Maksu"></span></span>

          </th>
          <th class="right">
            <span sxy-orderby="startAt" class="clickable"><span sxy-text="Kausi"></span></span>
          </th>
          <th class="right">
            <div class="table-filter-container">
              <salaxy-input name="searchx{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="sort-by-text" label-type="plain">
              </salaxy-input>
            </div>
          </th>
        </tr>
      </thead>

      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="td-avatar middle hidden-xxs">
            <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
          </td>
          <td class="td-name middle">
            <span ng-if="row.otherPartyInfo.avatar.displayName == ''">{{ 'SALAXY.NG1.CalcListComponent.notSelected' | sxyTranslate }}</span>
            <strong>{{row.otherPartyInfo.avatar.displayName}}</strong>
          </td>
          <td class="middle td-status">
            <span ng-if="row.status == 'new'" class="text-warning small status">
                Käsitelyssä
            </span>
            <span ng-if="row.status == 'succeeded'" class="text-success small status">
                Hyväksytty
            </span>
            <span ng-if="row.status == 'cancelled'" class="text-danger small status">
                Hylätty
            </span>
          </td>
          <td class="middle right">
            {{row.payment | currency}}<br>
            <span class="small">{{ row.endAt | date }}</span>
          </td>
          <td class="right">{{row.startAt | date}} - <br>{{row.endAt | date}}</td>
          <td class="middle right">
            <a ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-sm btn-secondary"><i
              class="bi bi-info-circle visible-xxs"></i><span class="hidden-xxs">Näytä</span></a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`), s.put("salaxy-components/odata/lists/EarningsPaymentsPanel.html", `<div class="card salaxy-odata-card list-card report-list-card  card-sm card-secondary">
  <div class="card-header">
    {{('Tulorekisteri-ilmoitukset' | sxyTranslate) }}
    <div class="float-end" ng-show="$ctrl.items.length > 0">
      <button class="btn btn-secondary btn-xs" ng-click="hideFilter = !hideFilter" title="Näytä suodattimet">
        <i class="bi bi-funnel-fill"></i>
      </button>
    </div>
  </div>
  <div class="card-body filters text-end" ng-class="{'showfilters' : hideFilter}">
    <div class="filter-buttons">
      <button class="btn btn-xs btn-secondary text-end" sxy-orderby="otherPartyInfo/avatar/displayName" sxy-text="SALAXY.UI_Terms.abc"></button>
      <button class="btn btn-xs btn-secondary text-end" sxy-orderby="status"> Tila</button>
      <button class="btn btn-xs btn-secondary text-end" sxy-orderby="endAt">
        <i class="bi bi-calendar3"></i>
      </button>
      <button class="btn btn-xs btn-secondary text-end" sxy-orderby="payment">€</button>
    </div>
    <salaxy-input name="search1cp{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search hidden-xxs" label-type="plain">
    </salaxy-input>
  </div>
  <div ng-class="$ctrl.getCssClass()">
    <div class="visible-xxs" ng-if="$ctrl.items.length > 0">
      <div class="table-filter-container-mobile">
        <salaxy-input name="search2cp{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search" label-type="plain">
        </salaxy-input>
      </div>
    </div>
    <div class="card-body text-center card-content lg-height align-middle" ng-show="$ctrl.items.length == 0 && !$ctrl.isLoading">
      <div>
        <h3>Ei Tulorekisteri-ilmoituksia</h3>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table" ng-if="$ctrl.items.length > 0">
        <tbody>
          <tr ng-repeat="row in $ctrl.items">
            <td class="d-none"><pre class="small">{{row | json}}</pre></td>
            <td class="td-avatar middle hidden-xxs">
              <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
            </td>
            <td class="td-name middle">
              <span ng-if="row.otherPartyInfo.avatar.displayName == ''">{{ 'SALAXY.NG1.CalcListComponent.notSelected' | sxyTranslate }}</span>
              <strong>{{row.otherPartyInfo.avatar.displayName}}</strong>
            </td>
            <td class="middle td-status">
              <span ng-if="row.status == 'new'" class="text-warning small status">
                Käsitelyssä
              </span>
              <span ng-if="row.status == 'succeeded'" class="text-success small status">
                Hyväksytty
              </span>
              <span ng-if="row.status == 'cancelled'" class="text-danger small status">
                Hylätty
              </span>
            </td>
            <td class="middle right">
              {{row.payment | currency}}<br>
              <span class="small">{{ row.endAt | date }}</span>
            </td>

            <td class="middle right">
              <a ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-sm btn-secondary"><i
              class="bi bi-info-circle"></i></a>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="salaxy-odata-footer">
        <salaxy-spinner></salaxy-spinner>
      </div>
    </div>
  </div>
  <div class="card-footer text-center">
    <a ng-href="#{{$crud.getDefaults().listUrl}}" class="btn btn-primary btn-sm">Näytä kaikki</a> {{$crud.listUrl}}
  </div>
</div>`), s.put("salaxy-components/odata/lists/Employments-select.html", `<div ng-class="$ctrl.getCssClass()">
  <div class="btn-toolbar" role="toolbar">
    <div class="btn-group btn-group-sm dropdown">
      <button id="single-button2" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown" ng-disabled="disabled">
       {{'SALAXY.NG1.WorkerListComponent.employments' | sxyTranslate}}:
       {{ ($ctrl.url == '/v03/api/employments' ? 'SALAXY.NG1.WorkerListComponent.all' : 'SALAXY.NG1.WorkerListComponent.active') | sxyTranslate }}
      </button>
      <ul class="dropdown-menu" role="menu" aria-labelledby="single-button2">
        <li role="menuitem">
          <a href="" ng-click="$ctrl.setUrl('/v03/api/employments')" class="dropdown-item" sxy-text="SALAXY.NG1.WorkerListComponent.all"></a>
        </li>
        <li role="menuitem">
          <a href="" ng-click="$ctrl.setUrl('/v03/api/employments?activeDate=today')" class="dropdown-item" sxy-text="SALAXY.NG1.WorkerListComponent.active"></a>
        </li>
      </ul>
    </div>
    <button ng-if="$ctrl.selectMode === 'multiselect'" ng-click="$ctrl.selectAll()" class="btn btn-default btn-sm" sxy-text="SALAXY.NG1.WorkerListComponent.selectAll"></button>
  </div>
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr class="">
          <th class="d-sm-none">
            <span sxy-orderby="otherPartyInfo/avatar/displayName" class="clickable"><span sxy-text="SALAXY.NG1_Other.Roles.worker"></span><i ng-if="$odata.getColumnOrder('avatar/displayName')" class="bi bi-sort-{{ $odata.getColumnOrder('avatar/displayName') }}"
              aria-hidden="true"></i></span>
            <span class="label label-primary clickable" ng-if="$ctrl.selectedItems.length" ng-click="$ctrl.selectedItems.splice(0,$ctrl.selectedItems.length)"> {{'SALAXY.UI_Terms.chosen' | sxyTranslate}}: {{ $ctrl.selectedItems.length }} <i class="bi bi-x-circle"></i></span>
          </th>
          <th colspan="2" class="d-none d-sm-table-cell">
            <span sxy-orderby="otherPartyInfo/avatar/displayName" class="clickable"><span sxy-text="SALAXY.NG1_Other.Roles.worker"></span><i ng-if="$odata.getColumnOrder('avatar/displayName')" class="bi bi-sort-{{ $odata.getColumnOrder('avatar/displayName') }}"
              aria-hidden="true"></i></span>
            <span class="label label-primary clickable" ng-if="$ctrl.selectedItems.length" ng-click="$ctrl.selectedItems.splice(0,$ctrl.selectedItems.length)"> {{'SALAXY.UI_Terms.chosen' | sxyTranslate}}: {{ $ctrl.selectedItems.length }} <i class="bi bi-x-circle"></i></span>
          </th>
          <th class="right hidden-xxs">
            <span sxy-text="SALAXY.NG1.WorkerListComponent.employment"></span><br/>
            <span sxy-orderby="updatedAt" class="clickable" sxy-text="SALAXY.UI_Terms.updated"></span>
          </th>
          <th class="right">
            <div class="table-filter-container">
              <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="sort-by-text" label-type="plain">
              </salaxy-input>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="td-avatar middle d-none d-sm-table-cell">
            <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
          </td>
          <td class="td-name middle">
            <div>
              <strong>{{row.otherPartyInfo.avatar.displayName}}</strong>
            </div>
            <div class="sm-description">
              {{$crud.getEmploymentDescription(row)}}
            </div>
          </td>
          <td class="middle right hidden-xxs">
            <div ng-class="{'text-danger': !row.data.isActive }">{{ row.data | sxyDateRange }}</div>
            <div>{{ row.updatedAt | date}}</div>
          </td>
          <td class="middle right">
            <button class="btn btn-sm" type="button" ng-class="$ctrl.isSelected(row) ? 'btn-danger' : 'btn-info'" ng-click="$ctrl.setSelected(row, 'toggle')">
              {{ $ctrl.isSelected(row) ? ("SALAXY.UI_Terms.unselect" | sxyTranslate) : ("SALAXY.UI_Terms.select" | sxyTranslate) }}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`), s.put("salaxy-components/odata/lists/Employments.html", `<div ng-class="$ctrl.getCssClass()">
  <div ng-if="$ctrl.logic.showToolbar" class="btn-toolbar" role="toolbar">
    <salaxy-action-button label="SALAXY.NG1_Pages.Workers.newWorker" action="'newWorker'" button-class="btn-sm btn-primary" ng-if="!$ctrl.readOnly && ('!assureWorkerAccount' | sxyIsInRole)"></salaxy-action-button>
    <div class="btn-group btn-group-sm dropdown">
      <button id="single-button2" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown" ng-disabled="disabled">
       {{'SALAXY.NG1.WorkerListComponent.employments' | sxyTranslate}}:
       {{ ($ctrl.url == '/v03/api/employments' ? 'SALAXY.NG1.WorkerListComponent.all' : 'SALAXY.NG1.WorkerListComponent.active') | sxyTranslate }}
      </button>
      <ul class="dropdown-menu" role="menu" aria-labelledby="single-button2">
        <li role="menuitem">
          <a href="" ng-click="$ctrl.setUrl('/v03/api/employments')" class="dropdown-item" sxy-text="SALAXY.NG1.WorkerListComponent.all"></a>
        </li>
        <li role="menuitem">
          <a href="" ng-click="$ctrl.setUrl('/v03/api/employments?activeDate=today')" class="dropdown-item" sxy-text="SALAXY.NG1.WorkerListComponent.active"></a>
        </li>
      </ul>
    </div>
    <div class="btn-group btn-group-sm ms-1" ng-controller="ExportController as $export" ng-init="$export.api = $crud.getExportable()">
      <button ng-repeat="mapper in $export.listItemMappers" class="btn btn-default " ng-click="$export.quickExport('copyExcel', null, mapper)">{{mapper.title}} {{'SALAXY.NG1.ODataActionsComponent.toExcel' | sxyTranslate}}</button>
      <button class="btn btn-default" ng-click="$export.showExport()" sxy-text="SALAXY.NG1.ODataActionsComponent.export"></button>
    </div>
    <button class="btn btn-default btn-sm ms-1" ng-click="$crud.selectAutoTaxcardForEmployments($ctrl.items)" title="{{'SALAXY.NG1.WorkerListComponent.activeAutoTaxcard' | sxyTranslate}}" sxy-text="SALAXY.NG1.WorkerListComponent.autoTaxcard"></button>
  </div>
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr class="">
          <th colspan="2">
            <span sxy-orderby="otherPartyInfo/avatar/displayName" class="clickable"><span sxy-text="SALAXY.NG1_Other.Roles.worker"></span><i ng-if="$odata.getColumnOrder('avatar/displayName')" class="bi bi-sort-{{ $odata.getColumnOrder('avatar/displayName') }}"
              aria-hidden="true"></i></span>
          </th>
          <th class="hidden-xxs">
            <span><span sxy-text="SALAXY.NG1.WorkerListComponent.employment"></span></span><br />
            <span sxy-orderby="updatedAt" class="clickable"><span sxy-text="SALAXY.UI_Terms.updated"></span></span>
          </th>
          <th ng-if="'workers.employments.records.badge' | sxyShow: 'workers.index'" sxy-text="SALAXY.NG1.WorkerDetailsComponent.records.badge"></th>
          <th ng-if="'workers.employments.taxcard' | sxyShow: 'workers.index'" sxy-text="SALAXY.NG1.WorkerListComponent.taxcard"></th>
          <th class="right hidden-xxs">
            <div>
              <div>
                <div>
                  <span class="salaxy-form-group-plain">
                    <input type="text" ng-model="$ctrl.rawSearchStringOther"  ng-change="$ctrl.searchChanged('other')" class="form-control" autocomplete="off"
                      id="searchx111" name="searchx111" placeholder="{{'SALAXY.UI_Terms.textSearch' | sxyTranslate}}"
                      ng-model-options="{allowInvalid: true, debounce: 250, updateOn: 'default' }" maxlength="1024">
                  </span>
                </div>
              </div>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="td-avatar middle">
            <a href="#/employments/details/{{row.id}}" class="cell-link" title="{{'SALAXY.NG1.WorkerListComponent.editWorker' | sxyTranslate}}">
              <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
            </a>
          </td>
          <td class="td-name d-none d-sm-table-cell middle">
            <div>
              <strong>{{row.otherPartyInfo.avatar.displayName}}</strong>
              <img ng-if="row.otherPartyInfo.avatar.owner == row.otherId" src="https://cdn.salaxy.com/img/elems/logo/square50x50logo.png"
                class="registered-user" style="width: 16px; position: relative; top: -6px;" title="{{'SALAXY.NG1.WorkerListComponent.registeredUser' | sxyTranslate}}">
            </div>
            <div class="sm-description">
              {{$crud.getEmploymentDescription(row)}}
            </div>
          </td>
          <td class="td-name d-table-cell d-sm-none  middle"> 
            <a href="#/employments/details/{{row.id}}" class="cell-link" title="{{'SALAXY.NG1.WorkerListComponent.editWorker' | sxyTranslate}}">
              <strong>{{row.otherPartyInfo.avatar.displayName}}</strong><br />
              <span class="sm-description" ng-if="row.otherPartyInfo.ibanNumber">{{$crud.getEmploymentDescription(row)}}</span>
              <span class="text-danger missing-info" ng-if="!row.otherPartyInfo.ibanNumber" sxy-text="SALAXY.NG1.WorkerListComponent.addIban"></span>
            </a>
          </td>
          <td class="hidden-xxs middle" colspan="{{$ctrl.readOnly ? 2 : ''}}" title="{{ $crud.getActiveText(row) }}">
          <div style="white-space: nowrap; overflow: hidden;text-overflow: ellipsis;" ng-class="{'text-danger': !row.data.isActive }">{{ row.data | sxyDateRange }}</div>
            <div>{{ row.updatedAt | date}}</div>
          </td>
          <td ng-if="'workers.employments.records.badge' | sxyShow: 'workers.index'" class="middle">
            <salaxy-workflow-badge model="row" api-ctrl="$crud"  wf-types="'EmployerMessageRecord'"></salaxy-workflow-badge>
          </td>
          <td ng-if="'workers.employments.taxcard' | sxyShow: 'workers.index'" class="middle">
            <span>{{ $crud.getTaxcardBadge(row.data.taxcard) }}</span>
          </td>
          <td class="right middle hidden-xxs" style="white-space: nowrap;">
            <a ng-if="'workers.employments.buttons.newCalc' | sxyShow: 'workers.index'" href="#/calc/details/{{row.id}}/new-for-employment" class="btn btn-default btn-sm" ng-if="!$ctrl.readOnly" sxy-text="SALAXY.UI_Terms.newCalculation"></a>
            <a href="#/employments/details/{{row.id}}?tab=calculations" class="btn btn-sm btn-default d-none d-sm-inline-block" title="{{'SALAXY.UI_Terms.calculations' | sxyTranslate}}">
              <i class="bi bi-list-task" aria-hidden="true"></i>
            </a>
            <a class="btn btn-sm btn-primary" href="#/employments/details/{{row.id}}" sxy-text="SALAXY.UI_Terms.edit"></a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`), s.put("salaxy-components/odata/lists/Holidays.html", `<div ng-class="$ctrl.getCssClass()">
  <table class="table">
    <thead>
      <tr>
        <th colspan="2" sxy-orderby="otherPartyInfo/avatar/displayName">
          <span sxy-text="SALAXY.NG1_Other.Roles.worker"></span>
        </th>
        <th sxy-html="SALAXY.NG1.HolidaysComponent.holidayType.html"></th>
        <th sxy-orderby="endAt" class="right" sxy-text="SALAXY.NG1.HolidaysComponent.year"></th>
        <th class="right" sxy-html="SALAXY.NG1.HolidaysComponent.holidays.html"></th>
        <th>
          <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search" label-type="plain"></salaxy-input>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="row in $ctrl.items">
        <td class="align-middle td-avatar">
          <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
        </td>
        <td class="td-workerSnapshot-name">
          <strong>{{ row.otherPartyInfo.avatar.displayName }}</strong><br /> {{ "WageBasis." + row.data.wageBasis | sxyEnum }}<br />
          <span ng-if="!row.data.employmentId" class="label label-danger" sxy-text="SALAXY.NG1.HolidaysComponent.error"></span>
        </td>
        <td>
          {{ "HolidayCode." + row.data.code | sxyEnum }}
          <span ng-if="row.data.code == 'holidayCompensation'">({{ row.data.compensation | sxyCount : 'percent' }})</span>
          <div ng-if="row.data.bonusMethod != 'none'">
            {{ "HolidayBonusPaymentMethod." + row.data.bonusMethod | sxyEnum }}
            <span>({{ row.data.bonus | sxyCount : 'percent' }})</span>
          </div>
        </td>
        <td class="right">{{ row.data.year }}</td>
        <td class="right">
          {{ row.data.plannedDays | sxyCount : 'days' }}<br /> {{ row.data.accrualDays | sxyCount : 'days' }}
        </td>
        <td class="hidden-xxs middle">
          <button ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.edit' | sxyTranslate}}" class="btn btn-sm btn-primary btn-block">
            <i class="bi bi-pencil-fill d-inline-block d-none"></i>
            <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.edit"></span></button>
        </td>
      </tr>
    </tbody>
  </table>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`), s.put("salaxy-components/odata/lists/HouseholdYears.html", `<div ng-class="$ctrl.getCssClass()">
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th sxy-orderby="logicalDate" class="right" sxy-text="SALAXY.NG1.HouseHoldYearsComponent.year"></th>
          <th sxy-orderby="status" sxy-text="SALAXY.NG1.HouseHoldYearsComponent.answer"></th>
          <th class="right" sxy-orderby="endAt" sxy-text="SALAXY.NG1.HouseHoldYearsComponent.latestSaving"></th>
          <th sxy-orderby="backOfficeStatus" sxy-text="SALAXY.NG1.HouseHoldYearsComponent.backOfficeStatus"></th>
          <th class="right">
            <div sxy-orderby="createdAt" sxy-text="SALAXY.UI_Terms.created"></div>
            <div sxy-orderby="updatedAt" sxy-text="SALAXY.UI_Terms.updated"></div>
          </th>
          <th class="right hidden-xxs" colspan="2">
            <div class="table-filter-container">
              <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" class="salaxy-odata-table-search" placeholder="SALAXY.UI_Terms.textSearch" label-type="plain"></salaxy-input>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="right">
            {{ row.logicalDate | date:'yyyy' }}
          </td>
          <td>
            {{ 'HouseholdYearStatus.' + row.status | sxyEnum }}
          </td>
          <td class="right">
            {{ row.endAt | sxyDate }}
          </td>
          <td>
            {{ 'HouseholdYearProcessingStatus.' + row.backOfficeStatus | sxyEnum }}
          </td>
          <td class="right">
            <div>{{ row.createdAt | sxyDate }}</div>
            <div>{{ row.updatedAt | sxyDate }}</div>
          </td>
          <td class="middle hidden-xxs">
            <button ng-if="row.isReadOnly" ng-click="$crud.showDetails(row)" class="btn btn-sm btn-primary btn-block" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}">
              <i class="bi bi-info-circle d-inline-block d-sm-none"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.show"></span>
            </button>
            <button ng-if="!row.isReadOnly" ng-click="$crud.showDetails(row)" class="btn btn-sm btn-primary btn-block" title="{{ 'SALAXY.UI_Terms.edit' | sxyTranslate}}">
              <i class="bi bi-pencil-fill d-inline-block d-sm-none"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.edit"></span>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`), s.put("salaxy-components/odata/lists/InvoicePaymentList.html", `<div ng-class="$ctrl.getCssClass()">
  <div ng-controller="InvoiceToolsController as $invoiceTools">
    <div class="btn-toolbar mb-3">
      <div class="btn-group dropdown">
        <button id="btnHide" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
          {{ ('SALAXY.MODEL.InvoiceListItem.status.title' | sxyTranslate) }}: {{$crud.statusFilter.text}}
        </button>
        <ul class="dropdown-menu" role="menu" aria-labelledby="btnHide">
          <li role="menuitem" ng-repeat="statusFilter in $crud.statusFilters">
            <a class="dropdown-item" href="" ng-click="$crud.statusFilter = statusFilter">{{statusFilter.text}}</a>
          </li>
        </ul>
      </div>
      <div class="btn-group">
        <salaxy-datepicker-popup style="width: 150px;" name="year" label-type="plain" format="year" ng-model="$crud.queryYear"></salaxy-datepicker-popup>
      </div>
      <button type="button" ng-click="$crud.loadData()" class="btn btn-primary">Hae</button>
      <button type="button" ng-if="$crud.supportItemMultiSelect()" ng-disabled="$crud.selectedInvoices.length === 0" ng-click="$crud.paymentChannelConfig.multiSelectAction().onClick()" class="btn btn-primary">{{$crud.paymentChannelConfig.multiSelectAction().text}}</button>
      <div sxy-if-role="test" class="btn-group dropdown">
        <button id="btnHide" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
          Maksukanava: {{$crud.paymentChannel}}
        </button>
        <ul class="dropdown-menu" role="menu" aria-labelledby="btnHide">
          <li role="menuitem">
            <a class="dropdown-item" href="" ng-click="$crud.paymentChannel = 'palkkausWS'; $crud.loadData()">WS</a>
          </li>
          <li role="menuitem">
            <a class="dropdown-item" href="" ng-click="$crud.paymentChannel = 'palkkausPSD'; $crud.loadData()">PSD</a>
          </li>
        </ul>
      </div>
    </div>
    <fieldset>
      <legend>Maksaja</legend>
      <div class="d-flex">
        <salaxy-avatar avatar="$crud.companyAccount.avatar" class="pull-left" style="font-size: 64px; border-bottom: 32px; margin-right:15px;"></salaxy-avatar>
        <div class="d-flex flex-column">
          <div><strong>{{ $crud.companyAccount.avatar.displayName }}</strong></div>
          <div>{{ $crud.companyAccount.identity.officialId }}</div>
          <div ng-if="$crud.companyAccount.ibanNumber">{{ $crud.companyAccount.ibanNumber | sxyIban }}</div>
          <div ng-if="!$crud.companyAccount.ibanNumber" class="alert-danger" sxy-text="SALAXY.NG1.InvoiceDialog.noIban"></div>
        </div>
      </div>
    </fieldset>
    <salaxy-tab-buttons
      current-tab="$crud.currentTab"
      options="[
        { value: 'netpaymentsandforeclosure', text: 'Nettopalkat ja ulosotot' },
        { value: 'monthlypayments', text: 'Kuukauden maksut' }
      ]"
      tabs-id="invoicePaymentList"
    ></salaxy-tab-buttons>
    <div class="tab-content" id="tab-content-invoicePaymentList">
      <div class="tab-pane" id="netpaymentsandforeclosure-tab" ng-click="$crud.selectTab('netpaymentsandforeclosure')">
        <div ng-if="$crud.currentTab === 'netpaymentsandforeclosure'">
          <ng-include src="'salaxy-components/odata/lists/InvoicePaymentListTable.html'"></ng-include>
        </div>
      </div>
      <div class="tab-pane" id="monthlypayments-tab" ng-click="$crud.selectTab('monthlypayments')">
        <div ng-if="$crud.currentTab === 'monthlypayments'">
          <ng-include src="'salaxy-components/odata/lists/InvoicePaymentListTable.html'"></ng-include>
        </div>
      </div>
    </div>
  </div>
</div>`), s.put("salaxy-components/odata/lists/InvoicePaymentListTable.html", `<table class="table" style="min-height: 250px;">
  <thead>
    <tr>
      <th ng-if="$crud.supportItemMultiSelect()">
        <span>Valittu</span>
      </th>
      <th colspan="2">
        <span>Ryhmä</span>
      </th>
      <th colspan="1">
        <span>                
          <input type="text" ng-model="$crud.otherPartyNameFilter" class="form-control" autocomplete="off" id="otherPartyName" name="otherPartyName" placeholder="{{'SALAXY.NG1.InvoicesComponent.receiver' | sxyTranslate}}">
        </span>
      </th>
      <th colspan="1">
        <span>                
          <input type="text" ng-model="$crud.ibanFilter" class="form-control" autocomplete="off" id="iban" name="iban" placeholder="{{'SALAXY.NG1.InvoicesComponent.iban' | sxyTranslate}}">
        </span>
      </th>
      <th>
        <div class="btn-group dropdown">
          <button id="btnHide" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
            {{ ('SALAXY.NG1.InvoicesComponent.invoiceType' | sxyTranslate) }}: {{$crud.invoiceEntityType.label}}
          </button>
          <ul class="dropdown-menu" role="menu" aria-labelledby="btnHide">
            <li role="menuitem" ng-repeat="invoiceEntityType in $crud.invoiceEntityTypes">
              <a class="dropdown-item" href="" ng-click="$crud.invoiceEntityType = invoiceEntityType">{{invoiceEntityType.label}}</a>
            </li>
          </ul>
        </div>
      </th>
      <th>
        <span sxy-text="SALAXY.MODEL.InvoiceListItem.status.title"></span>
      </th>
      <th ng-if="$crud.hasSystemMessagesEnabled()">
        <span sxy-text="Viestit"></span>
      </th>
      <th colspan="1">
        <span>                
          <input type="text" ng-model="$crud.referenceFilter" class="form-control" autocomplete="off" id="reference" name="reference" placeholder="{{'SALAXY.MODEL.InvoiceListItem.reference.title' | sxyTranslate}}">
        </span>
      </th>
      <th class="right clickable" ng-click="$crud.changeSortMode()">
        <span sxy-text="SALAXY.MODEL.InvoiceData.dueDate.tableHeading"></span>
        <i class="bi bi-sort-{{$crud.sortMode === 'asc' ? 'up' : 'down'}}"></i>
      </th>
      <th class="right">
        <span sxy-text="SALAXY.MODEL.InvoiceListItem.payment.title"></span>
      </th>
      <th colspan="2">
      </th>
    </tr>
  </thead>
  <tbody>
    <tr ng-repeat-start="group in $crud.getGroupedItems()" class="active">
      <td ng-if="$crud.supportItemMultiSelect()"></td>
      <td colspan="3">  
        <span>
            <a ng-if="group.groupType === 'payroll'" target="_blank" ng-href="#/payroll/details/{{ group.businessObjectId }}">
              {{group.title}}
            </a>
            <a ng-if="group.groupType === 'calculation'" target="_blank" ng-href="#/calc/details/{{ group.businessObjectId }}">
              {{group.title}}
            </a>
            <span ng-if="group.groupType === 'monthly'">
              {{group.title}}
            </span>
        </span>
      </td>
      <td ng-if="$crud.hasSystemMessagesEnabled()"></td>             
      <td colspan="7"></td>
      <td class="middle">
        <div ng-if="$crud.paymentChannelConfig.rowGroupActions(group).length > 0" class="btn-group btn-group-sm dropup dropdown">
          <button id="actionsButton" type="button" class="btn" ng-disabled="$crud.selectedInvoices.length > 0" style="background-color: transparent; border-color: transparent;" data-bs-toggle="dropdown" aria-expanded="false">
            <i class="bi bi-three-dots-vertical" style="font-size: 20px;"></i>
          </button>
          <ul class="dropdown-menu dropdown-menu-end" role="menu" aria-labelledby="actionsButton">
            <li role="menuitem" ng-repeat="action in $crud.paymentChannelConfig.rowGroupActions(group)">
              <a class="dropdown-item" href="" ng-click="action.onClick(group)">
                {{action.text}}
              </a>
            </li>
          </ul>
        </div>
      </td>
    </tr>
    <tr ng-repeat-end ng-repeat="invoice in group.invoices | filter: $crud.filterInvoices" >
      <td ng-if="$crud.supportItemMultiSelect()" class="left">
         <button title="{{'SALAXY.UI_Terms.select' | sxyTranslate}}" class="btn btn-transparent pull-right" type="button" ng-if="!$crud.isSelected(invoice)" ng-click="$crud.setSelected(invoice, 'toggle')">
            <i class="bi bi-square"></i>
          </button>
          <button title="{{'SALAXY.UI_Terms.unselect' | sxyTranslate}}" class="btn btn-transparent pull-right" type="button" ng-if="$crud.isSelected(invoice)" ng-click="$crud.setSelected(invoice, 'toggle')">
            <i class="bi bi-check-square"></i>
          </button>
      </td>
      <td></td>
      <td class="td-avatar-1line middle">
        <salaxy-avatar avatar="invoice.otherPartyInfo.avatar"></salaxy-avatar>
      </td>
      <td class="td-name middle">
        <div><strong>{{invoice.otherPartyInfo.avatar.displayName}}</strong></div>
        <small ng-switch="invoice.entityType">
        <span ng-switch-when="net|gross|foreclosure" ng-switch-when-separator="|">{{("SALAXY.ENUM.InvoiceType." + invoice.entityType + ".label") | sxyTranslate}} {{ invoice.logicalDate | sxyDate }}</span>
        <span ng-switch-when="unemployment">{{("SALAXY.ENUM.InvoiceType." + invoice.entityType + ".label") | sxyTranslate}}<br/>{{ { start: invoice.data.periodStart, end: invoice.data.periodEnd } | sxyDateRange }}</span>
        <span ng-switch-default>{{("SALAXY.ENUM.InvoiceType." + invoice.entityType + ".label") | sxyTranslate}} {{ { start: invoice.data.periodStart, end: invoice.data.periodEnd } | sxyDateRange }}</span>
      </small>
      </td>
      <td class="middle">
        <span ng-if="invoice.otherPartyInfo.ibanNumber">{{ invoice.otherPartyInfo.ibanNumber }}</span>
        <span ng-if="!invoice.otherPartyInfo.ibanNumber" class="alert-danger" sxy-text="SALAXY.NG1.InvoicesComponent.noIbanNumber"></span>
      </td>
      <td class="middle">
        {{("SALAXY.ENUM.InvoiceType." + invoice.entityType + ".label") | sxyTranslate}}
      </td>
      <td class="middle">
        <strong ng-class="{ 'bg-danger': invoice.status == 'canceled', 'bg-success': invoice.status == 'paid' }" title="{{ 'InvoiceStatus.' + invoice.status | sxyEnumDescr }}">
          {{ "InvoiceStatus." + invoice.status | sxyEnum }}
        </strong>
      </td>
      <td ng-if="$crud.hasSystemMessagesEnabled()">
        <span ng-repeat="message in invoice.messages" ng-bind-html="message | sxyWorkflowMessage: 'SystemMessageIssue'"></span>
      </td>
      <td class="middle">
        <span>{{ invoice.reference }}</span>
      </td>
      <td class="middle right">
        {{ invoice.data.dueDate | sxyDate }}
      </td>
      <td class="middle right">
        {{ invoice.payment | currency }}
      </td>
      <td class="middle">
        <button ng-click="$crud.showInvoiceDialog(invoice)" title="{{ 'SALAXY.NG1.InvoicesComponent.detailsBtn' | sxyTranslate}}" class="btn btn-xs btn-default btn-block" sxy-text="SALAXY.NG1.InvoicesComponent.detailsBtn">
        
      </button>
      </td>
      <td class="middle">
        <div ng-if="$crud.paymentChannelConfig.rowActions(invoice).length > 0" class="btn-group btn-group-sm dropup dropdown">
          <button id="actionsButton" type="button" class="btn" ng-disabled="$crud.selectedInvoices.length > 0" style="color: #000; background-color: transparent; border-color: transparent;" data-bs-toggle="dropdown" aria-expanded="false">
            <i class="bi bi-three-dots-vertical" style="font-size: 20px;"></i>
          </button>
          <ul class="dropdown-menu dropdown-menu-end" role="menu" aria-labelledby="actionsButton">
            <li role="menuitem" ng-repeat="action in $crud.paymentChannelConfig.rowActions(invoice)">
              <a class="dropdown-item" href="" ng-click="action.onClick(invoice)">
                {{action.text}}
              </a>
            </li>
          </ul>
        </div>
      </td>
    </tr>
  </tbody>
</table>`), s.put("salaxy-components/odata/lists/Invoices.html", `<div ng-class="$ctrl.getCssClass()">
  <table class="table">
    <thead>
      <tr>
        <th colspan="2"><span sxy-orderby="otherPartyInfo/avatar/displayName" sxy-text="SALAXY.NG1.InvoicesComponent.receiverAndType"></span></th>
        <th>
          <span sxy-orderby="status" sxy-text="SALAXY.NG1.InvoicesComponent.status"></span><br />
          <small sxy-text="SALAXY.NG1.InvoicesComponent.channel"></small>
        </th>
        <th class="right">
          <span sxy-orderby="startAt" sxy-text="SALAXY.NG1.InvoicesComponent.invoiceDate"></span><br/>
          <span sxy-orderby="endAt" sxy-text="SALAXY.NG1.InvoicesComponent.dueDate"></span>
        </th>
        <th class="right">
          <span sxy-orderby="createdAt" sxy-text="SALAXY.UI_Terms.created"></span><br />
          <span sxy-orderby="updatedAt" sxy-text="SALAXY.UI_Terms.updated"></span>
        </th>
        <th class="right"><span sxy-orderby="payment" sxy-text="SALAXY.NG1.InvoicesComponent.sum"></span></th>        
        <th class="right" colspan="2">
          <div class="table-filter-container hidden-xxs">
            <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" class="salaxy-odata-table-search" placeholder="SALAXY.UI_Terms.textSearch" label-type="plain"></salaxy-input>
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="row in $ctrl.items" ng-show="$ctrl.items.length > 0">
        <td class="td-avatar middle">
          <salaxy-avatar class="salaxy-calc-row-type-avatar" avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
        </td>
        <td class="middle">
          <div>{{ row.otherPartyInfo.avatar.displayName }}</div>
          <small class="hidden-xxs" ng-switch="row.entityType">
            <span ng-switch-when="net|gross|foreclosure|verification" ng-switch-when-separator="|">{{("SALAXY.ENUM.InvoiceType." + row.entityType + ".label") | sxyTranslate}} {{ row.logicalDate | sxyDate }}</span>
            <span ng-switch-when="unemployment">{{("SALAXY.ENUM.InvoiceType." + row.entityType + ".label") | sxyTranslate}}<br/>{{ { start: row.data.periodStart, end: row.data.periodEnd } | sxyDateRange }}</span>
            <span ng-switch-default>{{("SALAXY.ENUM.InvoiceType." + row.entityType + ".label") | sxyTranslate}} {{ { start: row.data.periodStart, end: row.data.periodEnd } | sxyDateRange }}</span>
          </small>
        </td class="middle">
        <td class="middle">
          <span ng-class="{ 'bg-danger': row.status == 'canceled', 'bg-success': row.status == 'paid' }" title="{{ 'InvoiceStatus.' + row.status | sxyEnumDescr }}">
            {{ "InvoiceStatus." + row.status | sxyEnum }}
          </span><br />
          <small>{{ "PaymentChannel." + row.data.channel | sxyEnum }}</small>
        </td>
        <td class="middle right">
          <div>{{ row.startAt | sxyDate }}</div>
          <div ng-switch="$crud.getDueDateType(row)">
            <span ng-switch-when="estimation">{{ row.endAt | date: 'MMMM' }}</span>
            <del ng-switch-when="canceled" class="">{{ row.endAt | sxyDate }}</del>
            <span ng-switch-when="overdue" class="bg-danger">{{ row.endAt | sxyDate }}</span>
            <em ng-switch-when="future" class="disabled">{{ row.endAt | sxyDate }}</em>
            <span ng-switch-when="default">{{ row.endAt | sxyDate }}</span>
            <span ng-switch-when="unknown">{{ row.endAt | sxyDate }}</span>
          </div>
        </td>
        <td class="middle right">
          {{ row.createdAt | sxyDate }}<br /> {{ row.updatedAt | sxyDate }}
        </td>
        <td class="middle right">
          {{ row.payment | currency }}
        </td>       
        <td class="middle right">
          <a href="" ng-click="$crud.showDetails(row)" class="btn btn-primary">
            {{ 'SALAXY.UI_Terms.show' | sxyTranslate}}
          </a>
        </td>
      </tr>
    </tbody>
  </table>
  <salaxy-odata-footer></salaxy-odata-footer>
  <div class="salaxy-odata-footer">
    <salaxy-spinner></salaxy-spinner>
  </div>
</div>`), s.put("salaxy-components/odata/lists/InvoicesCompany.html", `<div ng-class="$ctrl.getCssClass()">
  <h1 sxy-text="SALAXY.NG1.InvoicesCompany.heading"></h1>
  <style>
    .invoice-label {
      display: inline-block;
      width: 100px;
    }
  </style>
  <div class="btn-toolbar">
    <div class="btn-group dropdown">
      <button id="btnHide" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
        {{ $crud.queryOption.text }}
      </button>
      <ul class="dropdown-menu" aria-labelledby="btnHide">
        <li ng-repeat="queryOption in $crud.queryOptions">
          <a class="dropdown-item" href="" ng-click="$crud.queryOption = queryOption;$crud.doQuery()">{{queryOption.text}}</a>
        </li>
      </ul>
    </div>
    <button type="button" class="btn btn-secondary" ng-click="$crud.showloadPfd($ctrl.items)" sxy-text="SALAXY.UI_Terms.downloadPdf"></button>
    <div ng-if="$crud.queryOption.value != 'unpaid'" class="btn-group dropdown">
      <button id="btnHide" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
        {{ $crud.dateFilterQueryOption.text }}
      </button>
      <ul class="dropdown-menu" aria-labelledby="btnHide">
        <li ng-repeat="queryOption in $crud.queryDateFilterOptions">
          <a class="dropdown-item" href="" ng-click="$crud.setDateFilterQueryOption(queryOption)">{{queryOption.text}}</a>
        </li>
      </ul>
    </div>
    <div ng-if="$crud.queryOption.value == 'unpaid' && $ctrl.items.length > 0" class="btn-group dropdown float-end ms-auto">
      <button id="btnHide" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
        {{'SALAXY.NG1.InvoicesCompany.selectInvoices' | sxyTranslate}}
      </button>
      <ul class="dropdown-menu" aria-labelledby="btnHide">
        <li ng-repeat="option in $crud.getMarkAsPaidOptions($ctrl.items)">
          <a class="dropdown-item" href="" ng-click="$crud.selectInvoicesByType(option.value)">{{option.text}}</a>
        </li>
      </ul>
    </div>
    <button type="button" class="btn btn-primary pull-right" ng-if="$crud.queryOption.value == 'unpaid' && $ctrl.items.length > 0"
      ng-click="$crud.markInvoicesAsPaid()" ng-disabled="!$ctrl.selectedItems || $ctrl.selectedItems.length == 0" sxy-text="SALAXY.NG1.InvoicesCompany.setAsPaid">
    </button>
  </div>
  <table class="table">
    <thead>
      <tr>
        <th colspan="2"><span sxy-text="SALAXY.NG1.InvoicesCompany.receiverAndType"></span></th>
        <th ng-if="$crud.queryOption.value == 'unpaid'" class="right">
          <span sxy-text="SALAXY.NG1.InvoicesCompany.sum"></span>/ <br/>
          <span sxy-text="SALAXY.UI_Terms.chosen"></span>
        </th>
        <th ng-if="$crud.queryOption.value != 'unpaid'" class="right">
          <span sxy-text="SALAXY.NG1.InvoicesCompany.sum"></span>
        </th>          
        <th class="right" colspan="2">
          <div class="table-filter-container hidden-xxs">
            <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" class="salaxy-odata-table-search"
             placeholder="SALAXY.UI_Terms.textSearch" label-type="plain">
            </salaxy-input>
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat-start="row in $ctrl.items" ng-show="$ctrl.items.length > 0" class="active">
        <td class="middle" colspan="3">
          <div class="d-flex">
            <div class="flex-grow-1">
              <div class="d-flex align-items-center">
                <salaxy-avatar class="salaxy-calc-row-type-avatar" avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
                <span style="font-size: 1.4em; font-weight: bold;">
                  {{ row.otherPartyInfo.avatar.displayName }}:
                  <span ng-switch="row.entityType">
                    <span ng-switch-when="net|gross|foreclosure|verification" ng-switch-when-separator="|">{{("SALAXY.ENUM.InvoiceType." + row.entityType + ".label") | sxyTranslate}} {{ row.logicalDate | sxyDate }}</span>
                    <span ng-switch-default>{{("SALAXY.ENUM.InvoiceType." + row.entityType + ".label") | sxyTranslate}} {{ { start: row.data.periodStart, end: row.data.periodEnd } | sxyDateRange }}</span>
                  </span>
                </span>
              </div>
              <div ng-if="row.entityType == 'net'" class="mt-2" ng-switch="row.status">
                <span ng-switch-when="paid" class="text-success" ng-switch-when-separator="|" sxy-text="SALAXY.NG1.InvoicesCompany.paidNetPaymentInfo"></span>
                <span ng-switch-default  class="text-danger" sxy-text="SALAXY.NG1.InvoicesCompany.unPaidNetPaymentInfo"></span>
              </div>
            </div>
            <div class="row-buttons align-items-end">
              <button title="{{'SALAXY.UI_Terms.select' | sxyTranslate}}" class="btn btn-transparent pull-right" type="button" ng-if="!$ctrl.isSelected(row) && $crud.queryOption.value == 'unpaid' && $crud.showMarkAsPaidButton(row)" ng-click="$ctrl.setSelected(row, 'toggle')">
                <i class="bi bi-square"></i>
              </button>
              <button title="{{'SALAXY.UI_Terms.unselect' | sxyTranslate}}" class="btn btn-transparent pull-right" type="button" ng-if="$ctrl.isSelected(row) && $crud.queryOption.value == 'unpaid' && $crud.showMarkAsPaidButton(row)" ng-click="$ctrl.setSelected(row, 'toggle')">
                <i class="bi bi-check-square"></i>
              </button>
            </div>
          </div>
        </td>
        <td class="right">
          <button ng-if="row.status != 'canceled'" class="btn btn-default" ng-click="$crud.showInvoiceDialog(row)">
            <span class="hidden-xs" sxy-text="SALAXY.NG1.InvoicesCompany.showInvoiceDetails"></span>
          </button>
          <a ng-if="$crud.calculationHref(row)" ng-href="{{$crud.calculationHref(row)}}" class="btn btn-default" sxy-text="SALAXY.NG1.InvoicesCompany.openCalculation"></a>
        </td>
      </tr>
      <tr>
        <td class="td-avatar hidden-xxs" style="width: 160px;padding: 0px;" ng-if="row.status != 'paid' && row.status != 'canceled' && $crud.getQrCode(row) !== 'loading' && $crud.getQrCode(row) !== 'error'">
          <div style="margin: 8px;" height="160px" ng-bind-html="$crud.getQrCode(row)" ></div>
        </td>
        <td class="td-avatar hidden-xxs" style="min-width: 160px;vertical-align: middle; text-align: center; height: 160px;" ng-if="row.status != 'paid' && row.status != 'canceled' && $crud.getQrCode(row) === 'error'">
          <div style="height: 100%; display: flex;align-items: center;justify-content: center; background-color: #e9d310;">
            <div>
              <small sxy-text="SALAXY.NG1.InvoicesCompany.qrCodeNotAvailable"></small>
            </div>
          </div>
        </td>
        <td class="td-avatar hidden-xxs" style="vertical-align: middle; text-align: center; height: 160px; width: 160px;" ng-if="row.status == 'paid'">
          <div class="bg-success" style="height: 100%; display: flex;align-items: center;justify-content: center; font-size: 1.5em;">
            <div>
              <b>
                {{ "SALAXY.ENUM.InvoiceStatus." + row.status + ".label" | sxyTranslate}} <br/>
                {{(row.data.statusAt || row.updatedAt) | date}}
              </b>
            </div>
          </div>
        </td>
        <td class="td-avatar hidden-xxs" style="vertical-align: middle; text-align: center; height: 160px; width: 160px;" ng-if="row.status == 'canceled'">
          <div class="bg-danger" style="height: 100%; display: flex;align-items: center;justify-content: center; font-size: 1.5em;">
            <b>
              {{ "SALAXY.ENUM.InvoiceStatus." + row.status + ".label" | sxyTranslate}} <br/>
              {{(row.data.statusAt || row.updatedAt) | date}}
            </b>
          </div>
        </td>
        <td>
          <div class="row">
            <div class="col-3" sxy-text="SALAXY.NG1.InvoicesCompany.iban" ps=":"></div>
            <div class="col-9">
              {{ row.otherPartyInfo.ibanNumber  }}
            </div>
          </div>
          <div class="row">
            <div class="col-3" sxy-text="SALAXY.NG1.InvoicesCompany.name" ps=":"></div>
            <div class="col-9">
              {{ row.otherPartyInfo.avatar.displayName }}
            </div>
          </div>
          <div class="row">
            <div class="col-3" sxy-text="SALAXY.NG1.InvoicesCompany.dueDate" ps=":"></div>
            <div class="col-9" ng-switch="$crud.getDueDateType(row)">
              <span ng-switch-when="estimation">{{ row.endAt | sxyDate }}</span>
              <del ng-switch-when="canceled" class="">{{ row.endAt | sxyDate }}</del>
              <span ng-switch-when="overdue" class="bg-danger">{{ row.endAt | sxyDate }}</span>
              <em ng-switch-when="future" class="disabled">{{ row.endAt | sxyDate }}</em>
              <span ng-switch-when="default">{{ row.endAt | sxyDate }}</span>
              <span ng-switch-when="unknown">{{ row.endAt | sxyDate }}</span>
            </div>
          </div>
          <div class="row">
            <div class="col-3">
              {{row.entityType === 'net' || row.entityType === 'gross' ? ('SALAXY.NG1.InvoicesCompany.message' | sxyTranslate) : ('SALAXY.NG1.InvoicesCompany.reference' | sxyTranslate)}}
            </div>
            <div class="col-9">
              <span ng-if="row.entityType === 'net' || row.entityType === 'gross'">{{("SALAXY.ENUM.InvoiceType." + row.entityType + ".label") | sxyTranslate}} {{ { start: row.data.periodStart, end: row.data.periodEnd } | sxyDateRange }}</span>
              <span ng-if="row.entityType !== 'net' && row.entityType !== 'gross'">{{row.reference}}</span>
            </div>
          </div>
          <div class="row" ng-if="row.entityType == 'tax' || row.entityType == 'union'">
            <div class="col-3" sxy-text="SALAXY.NG1.InvoicesCompany.netPaymentCount" ps=":"></div>
            <div class="col-9">
              {{row.businessObjects.length}}
            </div>
          </div>
        </td>
        <td class="right" ng-if="!row.data.totalPaid">
          <h4 style="font-weight: bold;">{{ row.payment | currency }}</h4>
        </td>
        <td class="right" ng-if="row.data.totalPaid && row.data.totalPaid != row.payment">
          <h4 style="text-decoration: line-through;">{{'SALAXY.NG1.InvoicesCompany.sum' | sxyTranslate}} {{ row.payment | currency }}</h4>
          <h4>{{'SALAXY.NG1.InvoicesCompany.alreadyPaid' | sxyTranslate}} {{ row.data.totalPaid | currency }}</h4>
          <h4 class="total" style="font-weight: bold;">{{'SALAXY.NG1.InvoicesCompany.payable' | sxyTranslate}} {{ (row.payment - row.data.totalPaid) | currency }}</h4>
        </td>
        <td class="right" ng-if="row.data.totalPaid && row.payment == row.data.totalPaid">
          <h4 style="font-weight: bold;">{{ row.payment | currency }}</h4>
        </td>
        <td class="right">
          <button ng-if="$crud.showMarkAsPaidButton(row)" class="btn btn-primary" ng-click="$crud.updateInvoiceStatus(row,'paid')">
            <span class="hidden-xs" sxy-text="SALAXY.NG1.InvoicesCompany.setAsPaid"></span>
          </button> 
          <div style="height: 10px;" ng-if="$crud.showMarkAsPaidButton(row) && $crud.showMarkAsCanceledButton(row)"> <br/> </div>         
          <button class="btn btn-danger" ng-if="$crud.showMarkAsCanceledButton(row)" ng-click="$crud.updateInvoiceStatus(row,'canceled')">
            </i><span class="hidden-xs" sxy-text="SALAXY.NG1.InvoicesCompany.cancelPayment"></span>
          </button>
          <div ng-if="$crud.showIrCancelInfoText(row)" class="text-center" style="width: 140px; margin: auto; margin-top: 6px;" sxy-text="SALAXY.NG1.InvoicesCompany.cancelInfoText"></div>
          <div ng-if="row.status == 'preview'" class="text-center" style="width: 140px; margin: auto; margin-top: 6px;">
            {{(row.data.paidBusinessObjectsCount || 0) }} / {{row.businessObjects.length}} {{'SALAXY.NG1.InvoicesCompany.unpaidNetSalaries' | sxyTranslate}}<br/>
            {{ { start: row.data.periodStart, end: row.data.periodEnd } | sxyDateRange }}
          </div>
        </td>
      </tr>
      <tr ng-repeat-end ng-if="row.status != 'paid' && row.status != 'canceled'">
        <td colspan="4">
          <button type="button" class="btn btn-default btn-sm" ng-click="$crud.copyBarcode(row)">
            <span><i class="bi bi-clipboard"></i></span>
          </button>
          <span style="font-family: 'Courier New', Courier, monospace; font-size: 1.15em;">{{$crud.getBarcodeValue(row)}}</span>          
        </td>        
      </tr>
    </tbody>
  </table>
  <salaxy-odata-footer></salaxy-odata-footer>
  <div class="salaxy-odata-footer">
    <salaxy-spinner></salaxy-spinner>
  </div>
</div>`), s.put("salaxy-components/odata/lists/InvoicesPanel.html", `<div class="salaxy-odata-panel list-panel report-list-panel panel panel-sm panel-secondary">
  <div class="card-header">
    {{('SALAXY.NG1.InvoicesComponent.invoices' | sxyTranslate) }}
  </div>
  <div ng-class="$ctrl.getCssClass()">
    <div class="card-body text-center card-content lg-height align-middle" ng-show="$ctrl.items.length == 0 && !$ctrl.isLoading">
      <div>
        <h3 sxy-text="SALAXY.NG1.InvoicesComponent.noInvoices"></h3>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table">
        <tbody>
          <tr ng-repeat="row in $ctrl.items" ng-show="$ctrl.items.length > 0">
            <td class="td-avatar middle hidden-xxs">
              <salaxy-avatar class="salaxy-calc-row-type-avatar" avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
            </td>
            <td class="middle">
              {{ row.otherPartyInfo.avatar.displayName }}<br>
              <small class="hidden-xxs">{{("SALAXY.ENUM.InvoiceType." + row.entityType + ".label") | sxyTranslate}}</small>
            </td>
            <td class="middle right">
              {{ row.endAt | date }}
              <span ng-if="row.status=='paid'" class="text-success status small"><br>{{'SALAXY.NG1.InvoicesComponent.paid' | sxyTranslate}}</span>
            </td>
            <td class="middle right">
              {{ row.payment | currency }}
            </td>
            <td class="middle right">
              <a ng-href="{{$crud.getContentUrl(row.id, true)}}" target="_blank" title="{{ 'SALAXY.UI_Terms.printable' | sxyTranslate}}" class="btn btn-sm btn-secondary"><i
              class="bi bi-file-earmark-pdf"></i></a>
              <button href="" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-sm btn-secondary"><i class="bi bi-info-circle"></i></button>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="salaxy-odata-footer">
        <salaxy-spinner></salaxy-spinner>
      </div>
    </div>
  </div>
  <div class="card-footer text-center footer-empty">
    <a ng-href="#{{$crud.getDefaults().listUrl}}" title="Näytä kaikki" class="btn btn-primary btn-sm" sxy-text="SALAXY.UI_Terms.showAll"></a>
  </div>
</div>`), s.put("salaxy-components/odata/lists/InvoicesPaymentChannel.html", `<div ng-class="$ctrl.getCssClass()" ng-controller="InvoiceToolsController as $invoiceTools" ng-init="$invoiceTools.reader = $crud.selectionDataReader">
  <div ng-show="'test' | sxyIsInRole" class="salaxy-component salaxy-invoice-tools" >
    <div class="btn-toolbar" role="toolbar" aria-label="Invoice options">
      <div class="btn-group">
        <salaxy-input-enum type="dropdown" name="fileType" label-type="plain" ng-model="$invoiceTools.fileTypeId" options="$invoiceTools.fileTypeOptions" remember="invoice"></salaxy-input-enum>
      </div>
      <div class="btn-group">
        <button ng-disabled="$invoiceTools.reader.disabled()" id="reportExport" type="button" class="btn btn-default" ng-click="$invoiceTools.export()">
          {{ $invoiceTools.reader.exportLabel || ('SALAXY.NG1.AccountingReportToolsComponent.createExport' | sxyTranslate) }}
        </button>
      </div>
    </div>
  </div>
  <table class="table">
    <thead>
      <tr>
        <th colspan="2"><span sxy-orderby="otherPartyInfo/avatar/displayName" sxy-text="SALAXY.NG1.InvoicesComponent.receiverAndType"></span></th>
        <th>
          <span sxy-orderby="status" sxy-text="SALAXY.NG1.InvoicesComponent.status"></span><br />
          <small sxy-text="SALAXY.NG1.InvoicesComponent.channel"></small>
        </th>
        <th class="right">
          <span sxy-orderby="startAt" sxy-text="SALAXY.NG1.InvoicesComponent.invoiceDate"></span><br/>
          <span sxy-orderby="endAt" sxy-text="SALAXY.NG1.InvoicesComponent.dueDate"></span>
        </th>
        <th class="right">
          <span sxy-orderby="createdAt" sxy-text="SALAXY.UI_Terms.created"></span><br />
          <span sxy-orderby="updatedAt" sxy-text="SALAXY.UI_Terms.updated"></span>
        </th>
        <th class="right"><span sxy-orderby="payment" sxy-text="SALAXY.NG1.InvoicesComponent.sum"></span></th>
        <th class="middle" ng-if="'test' | sxyIsInRole">
          <button title="{{'SALAXY.UI_Terms.chooseAll' | sxyTranslate}}" class="btn btn-block btn-transparent" type="button" ng-if="$ctrl.selectedItems.length == 0" ng-disabled="$ctrl.selectedItems.length == $ctrl.items.length" ng-click="$crud.selectAll()">
            <i class="bi bi-square"></i>
          </button>
          <button title="{{'SALAXY.UI_Terms.unselectAll' | sxyTranslate}}" class="btn btn-block btn-transparent" type="button" ng-if="$ctrl.selectedItems.length > 0" ng-disabled="$ctrl.selectedItems.length == 0" ng-click="$crud.unselectAll()">
            <i class="bi bi-check-square"></i>
          </button>
        </th>
        <th class="right" colspan="2">
          <div class="table-filter-container hidden-xxs">
            <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" class="salaxy-odata-table-search" placeholder="SALAXY.UI_Terms.textSearch" label-type="plain"></salaxy-input>
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="row in $ctrl.items" ng-show="$ctrl.items.length > 0">
        <td class="td-avatar middle">
          <salaxy-avatar class="salaxy-calc-row-type-avatar" avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
        </td>
        <td class="middle">
          <div>{{ row.otherPartyInfo.avatar.displayName }}</div>
          <small class="hidden-xxs" ng-switch="row.entityType">
            <span ng-switch-when="net|gross|foreclosure|verification" ng-switch-when-separator="|">{{("SALAXY.ENUM.InvoiceType." + row.entityType + ".label") | sxyTranslate}} {{ row.logicalDate | sxyDate }}</span>
            <span ng-switch-when="unemployment">{{("SALAXY.ENUM.InvoiceType." + row.entityType + ".label") | sxyTranslate}}<br/>{{ { start: row.data.periodStart, end: row.data.periodEnd } | sxyDateRange }}</span>
            <span ng-switch-default>{{("SALAXY.ENUM.InvoiceType." + row.entityType + ".label") | sxyTranslate}} {{ { start: row.data.periodStart, end: row.data.periodEnd } | sxyDateRange }}</span>
          </small>
        </td class="middle">
        <td class="middle">
          <span ng-class="{ 'bg-danger': row.status == 'canceled', 'bg-success': row.status == 'paid' }" title="{{ 'InvoiceStatus.' + row.status | sxyEnumDescr }}">
            {{ "InvoiceStatus." + row.status | sxyEnum }}
          </span><br />
          <small>{{ "PaymentChannel." + row.data.channel | sxyEnum }}</small>
        </td>
        <td class="middle right">
          <div>{{ row.startAt | sxyDate }}</div>
          <div>{{ row.endAt | sxyDate }}</div>
        </td>
        <td class="middle right">
          {{ row.createdAt | sxyDate }}<br /> {{ row.updatedAt | sxyDate }}
        </td>
        <td class="middle right">
          {{ row.payment | currency }}
        </td>
        <td class="middle" ng-if="'test' | sxyIsInRole">
          <button title="{{'SALAXY.UI_Terms.select' | sxyTranslate}}" class="btn btn-block btn-transparent" type="button" ng-if="!$ctrl.isSelected(row)" ng-click="$ctrl.setSelected(row, 'toggle')">
            <i class="bi bi-square"></i>
          </button>
          <button title="{{'SALAXY.UI_Terms.unselect' | sxyTranslate}}" class="btn btn-block btn-transparent" type="button" ng-if="$ctrl.isSelected(row)" ng-click="$ctrl.setSelected(row, 'toggle')">
            <i class="bi bi-check-square"></i>
          </button>
        </td>
        <td class="middle" ng-if="'test' | sxyIsInRole">
          <button class="btn btn-sm btn-block btn-default" ng-disabled="row.isReading" type="button" ng-click="$invoiceTools.export($crud.getItemDataReader(row),true)">
            <span ng-show="row.isReading"><i class="bi bi-arrow-repeat bi-spin"></i></span>
            <span ng-show="!row.isReading">{{ 'SALAXY.NG1.AccountingReportToolsComponent.createExport' | sxyTranslate }}</span>
          </button>
        </td>
        <td class="middle right">
          <a href="" ng-click="$crud.showDetails(row)" class="btn btn-primary">
            {{ 'SALAXY.UI_Terms.show' | sxyTranslate}}
          </a>
        </td>
      </tr>
    </tbody>
  </table>
  <salaxy-odata-footer></salaxy-odata-footer>
  <div class="salaxy-odata-footer">
    <salaxy-spinner></salaxy-spinner>
  </div>
</div>`), s.put("salaxy-components/odata/lists/InvoicesPerson.html", `<div ng-class="$ctrl.getCssClass()">
  <div class="salaxy-component salaxy-invoice-tools" ng-controller="InvoiceToolsController as $invoiceTools" ng-init="$invoiceTools.reader = $crud.selectionDataReaderPerson">
    <div class="btn-toolbar" role="toolbar" aria-label="Invoice options">
      <div class="btn-group btn-group-sm dropdown">
        <button id="invoiceOptionsFileType" type="button" class="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown">
          <i class="bi bi-file-earmark-pdf"></i>&nbsp;{{'SALAXY.ENUM.ExportMethod.filePdf.label' | sxyTranslate}}
        </button>
      </div>
      <div class="btn-group btn-group-sm ms-1">
        <button ng-disabled="$crud.selectionDataReaderPerson.disabled()" id="reportExport" type="button" class="btn btn-default" ng-click="$invoiceTools.export()">
          {{'SALAXY.NG1.AccountingReportToolsComponent.createExport' | sxyTranslate}}
        </button>
      </div>
    </div>
  </div>

  <table class="table">
    <thead>
      <tr>
        <th colspan="2"><span sxy-orderby="otherPartyInfo/avatar/displayName" sxy-text="SALAXY.NG1.InvoicesComponent.receiverAndType"></span></th>
        <th>
          <span sxy-orderby="status" sxy-text="SALAXY.NG1.InvoicesComponent.status"></span><br />
        </th>
        <th class="right">
          <span sxy-orderby="startAt" sxy-text="SALAXY.NG1.InvoicesComponent.invoiceDate"></span><br/>
          <span sxy-orderby="endAt" sxy-text="SALAXY.NG1.InvoicesComponent.dueDate"></span>
        </th>
        <th class="right">
          <span sxy-orderby="createdAt" sxy-text="SALAXY.UI_Terms.created"></span><br />
          <span sxy-orderby="updatedAt" sxy-text="SALAXY.UI_Terms.updated"></span>
        </th>
        <th class="right"><span sxy-orderby="payment" sxy-text="SALAXY.NG1.InvoicesComponent.sum"></span></th>
        <th class="middle">
          <button title="{{'SALAXY.UI_Terms.chooseAll' | sxyTranslate}}" class="btn btn-block btn-transparent" type="button" ng-if="$ctrl.selectedItems.length == 0" ng-disabled="$ctrl.selectedItems.length == $ctrl.items.length" ng-click="$crud.selectAll()">
            <i class="bi bi-square"></i>
          </button>
          <button title="{{'SALAXY.UI_Terms.unselectAll' | sxyTranslate}}" class="btn btn-block btn-transparent" type="button" ng-if="$ctrl.selectedItems.length > 0" ng-disabled="$ctrl.selectedItems.length == 0" ng-click="$crud.unselectAll()">
            <i class="bi bi-check-square"></i>
          </button>
        </th>
        <th class="right" colspan="2">
          <div class="table-filter-container hidden-xxs">
            <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" class="salaxy-odata-table-search" placeholder="SALAXY.UI_Terms.textSearch" label-type="plain"></salaxy-input>
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="row in $ctrl.items" ng-show="$ctrl.items.length > 0">
        <td class="td-avatar middle">
          <salaxy-avatar class="salaxy-calc-row-type-avatar" avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
        </td>
        <td class="middle">
          <div>{{ row.otherPartyInfo.avatar.displayName }}</div>
          <small class="hidden-xxs" ng-switch="row.entityType">
            <span ng-switch-when="net|gross|foreclosure" ng-switch-when-separator="|">{{("SALAXY.ENUM.InvoiceType." + row.entityType + ".label") | sxyTranslate}} {{ row.logicalDate | sxyDate }}</span>
            <span ng-switch-when="unemployment">{{("SALAXY.ENUM.InvoiceType." + row.entityType + ".label") | sxyTranslate}}<br/>{{ { start: row.data.periodStart, end: row.data.periodEnd } | sxyDateRange }}</span>
            <span ng-switch-default>{{("SALAXY.ENUM.InvoiceType." + row.entityType + ".label") | sxyTranslate}} {{ { start: row.data.periodStart, end: row.data.periodEnd } | sxyDateRange }}</span>
          </small>
        </td class="middle">
        <td class="middle" ng-if="row.entityType !== 'tax' && row.entityType !== 'net'">
          <span title="{{ 'InvoiceStatus.' + row.status | sxyEnumDescr }}">
            {{ "InvoiceStatus.forecast" | sxyEnum }}
          </span><br />
          <small>{{ row.otherPartyInfo.avatar.displayName }} {{'SALAXY.NG1.InvoicesCreateTableComponent.sendsInvoice' | sxyTranslate}}</small>
        </td>
        <td class="middle" ng-if="row.entityType === 'tax' || row.entityType === 'net'">
          <span ng-class="{ 'bg-danger': row.status == 'canceled', 'bg-success': row.status == 'paid' }" title="{{ 'InvoiceStatus.' + row.status | sxyEnumDescr }}">
            {{ "InvoiceStatus." + row.status | sxyEnum }}
          </span><br />
          <small>{{ "PaymentChannel." + row.data.channel | sxyEnum }}</small>
        </td>
        <td class="middle right">
          <div>{{ row.startAt | sxyDate }}</div>
          <div ng-switch="$crud.getDueDateType(row)">
            <span ng-switch-when="estimation">{{ row.endAt | date: 'MMMM' }}</span>
            <del ng-switch-when="canceled" class="">{{ row.endAt | sxyDate }}</del>
            <span ng-switch-when="overdue" class="bg-danger">{{ row.endAt | sxyDate }}</span>
            <em ng-switch-when="future" class="disabled">{{ row.endAt | sxyDate }}</em>
            <span ng-switch-when="default">{{ row.endAt | sxyDate }}</span>
            <span ng-switch-when="unknown">{{ row.endAt | sxyDate }}</span>
          </div>
        </td>
        <td class="middle right">
          {{ row.createdAt | sxyDate }}<br /> {{ row.updatedAt | sxyDate }}
        </td>
        <td class="middle right">
          {{ row.payment | currency }}
        </td>
        <td class="middle" ng-if="row.entityType === 'tax' || row.entityType === 'net'">
          <button title="{{'SALAXY.UI_Terms.select' | sxyTranslate}}" class="btn btn-block btn-transparent" type="button" ng-if="!$ctrl.isSelected(row)" ng-click="$ctrl.setSelected(row, 'toggle')">
            <i class="bi bi-square"></i>
          </button>
          <button title="{{'SALAXY.UI_Terms.unselect' | sxyTranslate}}" class="btn btn-block btn-transparent" type="button" ng-if="$ctrl.isSelected(row)" ng-click="$ctrl.setSelected(row, 'toggle')">
            <i class="bi bi-check-square"></i>
          </button>
        </td>
        <td class="middle" ng-if="row.entityType !== 'tax' && row.entityType !== 'net'"></td>
        <td class="middle">
          <button ng-click="$crud.showPaymentDialog(row)" ng-if="row.entityType === 'net' && (row.status === 'paid' || row.status === 'unread')" class="btn btn-sm btn-block btn-default" ng-disabled="row.isReading" type="button">
            <span ng-if="row.status === 'paid'">{{ 'SALAXY.NG1.InvoicesCreateTableComponent.cancelInvoice' | sxyTranslate }}</span>
            <span ng-if="row.status === 'unread'">{{ 'SALAXY.NG1.InvoicesCreateTableComponent.payInvoice' | sxyTranslate }}</span>
          </button>
        </td>
        <td class="middle right">
          <a ng-if="row.entityType === 'tax' || row.entityType === 'net'" ng-href="{{$crud.getContentUrl(row.id, true)}}" target="_blank" title="{{ 'SALAXY.UI_Terms.printable' | sxyTranslate}}" class="btn btn-sm btn-secondary"><i
            class="bi bi-file-earmark-pdf"></i></a>
        </td>
      </tr>
    </tbody>
  </table>
  <salaxy-odata-footer></salaxy-odata-footer>
  <div class="salaxy-odata-footer">
    <salaxy-spinner></salaxy-spinner>
  </div>
</div>`), s.put("salaxy-components/odata/lists/InvoicesSepa.html", `<div ng-class="$ctrl.getCssClass()">
  <div ng-controller="InvoiceToolsController as $invoiceTools">
    <div class="btn-toolbar">
      <div class="btn-group">
        <salaxy-input-enum type="dropdown" name="fileType" label-type="plain" ng-model="$invoiceTools.fileTypeId" options="$invoiceTools.fileTypeOptions" remember="invoice"></salaxy-input-enum>
      </div>
      <div class="btn-group dropdown">
        <button id="btnHide" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown">
          {{ ('SALAXY.MODEL.InvoiceListItem.status.title' | sxyTranslate) }}: {{$crud.statusFilter.text}}
        </button>
        <ul class="dropdown-menu" role="menu" aria-labelledby="btnHide">
          <li role="menuitem" ng-repeat="statusFilter in $crud.statusFilters">
            <a href="" ng-click="$crud.statusFilter = statusFilter" class="dropdown-item">{{statusFilter.text}}</a>
          </li>
        </ul>
      </div>
      <div class="btn-group ms-1">
        <salaxy-datepicker-popup name="refDateMonth" label-type="plain" format="year" ng-model="$crud.queryYear"></salaxy-datepicker-popup>
      </div>
      <button type="button" ng-click="$crud.loadData()" class="btn btn-primary">Hae</button>
    </div>
    <div class="table-responsive">
      <table class="table" style="min-height: 250px;">
        <thead>
          <tr>
            <th colspan="1">
              <span sxy-text="SALAXY.NG1.InvoicesComponent.payer"></span>
            </th>
            <th colspan="2">
              <span>                
                <input type="text" ng-model="$crud.otherPartyNameFilter" class="form-control" autocomplete="off" id="otherPartyName" name="otherPartyName" placeholder="{{'SALAXY.NG1.InvoicesComponent.receiver' | sxyTranslate}}">
              </span>
            </th>
            <th>
              <span sxy-text="SALAXY.MODEL.InvoiceData.channel.title"></span><br />
              <span sxy-text="SALAXY.NG1.InvoicesComponent.iban"></span>
            </th>
            <th>
              <div class="btn-group dropdown">
                <button id="btnHide" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown">
                  {{ ('SALAXY.NG1.InvoicesComponent.invoiceType' | sxyTranslate) }}: {{$crud.invoiceEntityType.label}}
                </button>
                <ul class="dropdown-menu" role="menu" aria-labelledby="btnHide">
                  <li role="menuitem" ng-repeat="invoiceEntityType in $crud.invoiceEntityTypes">
                    <a href="" ng-click="$crud.invoiceEntityType = invoiceEntityType" class="dropdown-item">{{invoiceEntityType.label}}</a>
                  </li>
                </ul>
              </div>
            </th>
            <th>
              <span sxy-orderby="status" sxy-text="SALAXY.MODEL.InvoiceListItem.status.title"></span><br />
              <span sxy-text="SALAXY.MODEL.InvoiceListItem.reference.title"></span>/<span sxy-text="SALAXY.MODEL.InvoiceListItem.messages.title"></span>
            </th>
            <th class="right">
              <span sxy-orderby="endAt" sxy-text="SALAXY.MODEL.InvoiceData.dueDate.tableHeading"></span><br />
              <span sxy-text="SALAXY.MODEL.InvoiceData.date.title"></span>
            </th>
            <th class="right">
              <span sxy-text="SALAXY.MODEL.InvoiceListItem.payment.tableHeading"></span><br />
              <span sxy-text="SALAXY.MODEL.InvoiceListItem.payment.title"></span>
            </th>
            <th colspan="2">
              <span sxy-text="SALAXY.NG1.InvoicesComponent.createInvoices"></span><br />
              <span sxy-text="SALAXY.NG1.InvoicesComponent.markAsPaid"></span>
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat-start="group in $crud.getGroupedItems() | filter: $crud.invoiceFilter" class="active">
            <td class="td-avatar middle">
              <salaxy-avatar avatar="group.ownerInfo.avatar"></salaxy-avatar>
            </td>
            <td class="td-name middle" colspan="2">
              <strong>{{group.ownerInfo.avatar.displayName}}</strong><br />
              <span>{{group.ownerInfo.officialId}}</span>
            </td>
            <td class="middle">
              <span>{{ "PaymentChannel." + group.channel | sxyEnum }}</span>
            </td>
            <td>
              <span>{{("SALAXY.ENUM.InvoiceType." + group.invoiceType + ".label") | sxyTranslate}}</span>
            </td>
            <td class="middle">
              <strong ng-class="{ 'bg-danger': group.status == 'canceled', 'bg-success': group.status == 'paid' }" title="{{ 'InvoiceStatus.' + group.status | sxyEnumDescr }}">
              {{ "InvoiceStatus." + group.status | sxyEnum }}
            </strong>
            </td>
            <td class="middle right">
              <strong>{{ group.dueDate | sxyDate }}</strong>
            </td>
            <td class="middle right">
              <strong>{{ group.payment | currency }}</strong>
            </td>
            <td class="middle">
              <button class="btn btn-default btn-block" ng-if="group.status == 'unread' || group.status == 'read' || group.status== 'waitingConfirmation'" ng-disabled="group.isReadingread || group.isReadingpaid" ng-click="$invoiceTools.export($crud.getGroupDataReader(group,'waitingConfirmation'),true)">
              <span ng-show="group.isReadingwaitingConfirmation"><i class="bi bi-arrow-repeat bi-spin"></i></span>
              <span ng-show="!group.isReadingwaitingConformation" sxy-text="SALAXY.NG1.InvoicesComponent.createInvoiceBtn"></span>
            </button>
            </td>
            <td class="middle">
              <button class="btn btn-default btn-block" ng-if="group.status == 'unread' || group.status == 'read' || group.status== 'waitingConfirmation'" ng-disabled="group.isReadingread || group.isReadingpaid" ng-click="$invoiceTools.export($crud.getGroupDataReader(group,'paid'),true)">
              <span ng-show="group.isReadingpaid"><i class="bi bi-arrow-repeat bi-spin"></i></span>
              <span ng-show="!group.isReadingpaid" sxy-text="SALAXY.NG1.InvoicesComponent.markAsPaidBtn"></span>
            </button>
            </td>
            <td class="middle">
              <button class="btn btn-default btn-block" ng-click="$crud.showGroupDialog(group)" sxy-text="SALAXY.NG1.InvoicesComponent.detailsBtn"></button>
            </td>
          </tr>
          <tr ng-repeat-end ng-repeat="invoice in group.invoices | filter: {otherPartyInfo:{avatar:{displayName: $crud.otherPartyNameFilter}}}" >
            <td></td>
            <td class="td-avatar-1line middle">
              <salaxy-avatar avatar="invoice.otherPartyInfo.avatar"></salaxy-avatar>
            </td>
            <td class="td-name middle">
              <div><strong>{{invoice.otherPartyInfo.avatar.displayName}}</strong></div>
              <small ng-switch="invoice.entityType">
              <span ng-switch-when="net|gross|foreclosure" ng-switch-when-separator="|">{{("SALAXY.ENUM.InvoiceType." + invoice.entityType + ".label") | sxyTranslate}} {{ invoice.logicalDate | sxyDate }}</span>
              <span ng-switch-when="unemployment">{{("SALAXY.ENUM.InvoiceType." + invoice.entityType + ".label") | sxyTranslate}}<br/>{{ { start: invoice.data.periodStart, end: invoice.data.periodEnd } | sxyDateRange }}</span>
              <span ng-switch-default>{{("SALAXY.ENUM.InvoiceType." + invoice.entityType + ".label") | sxyTranslate}} {{ { start: invoice.data.periodStart, end: invoice.data.periodEnd } | sxyDateRange }}</span>
            </small>
            </td>
            <td class="middle">
              <span ng-if="invoice.otherPartyInfo.ibanNumber">{{ invoice.otherPartyInfo.ibanNumber }}</span>
              <span ng-if="!invoice.otherPartyInfo.ibanNumber" class="alert-danger" sxy-text="SALAXY.NG1.InvoicesComponent.noIbanNumber"></span>
            </td>
            <td class="middle">
              {{("SALAXY.ENUM.InvoiceType." + invoice.entityType + ".label") | sxyTranslate}}
            </td>
            <td class="middle">
              {{ invoice.reference || ("SALAXY.ENUM.InvoiceType." + invoice.entityType + ".label") | sxyTranslate }}
            </td>
            <td class="middle right">
              {{ invoice.data.date | sxyDate }}
            </td>
            <td class="middle right">
              {{ invoice.payment | currency }}
            </td>
            <td class="middle">
              <button class="btn btn-default btn-xs btn-block" ng-if="invoice.status == 'unread'  || invoice.status == 'read' || invoice.status== 'waitingConfirmation'" ng-disabled="invoice.isReadingwaitingConfirmation || invoice.isReadingpaid" ng-click="$invoiceTools.export($crud.getGroupItemDataReader(invoice,'waitingConfirmation'),true)">
              <span ng-show="invoice.isReadingwaitingConfirmation"><i class="bi bi-arrow-repeat bi-spin"></i></span>
              <span ng-show="!invoice.isReadingwaitingConfirmation" sxy-text="SALAXY.NG1.InvoicesComponent.createInvoiceBtn"></span>
            </button>
            </td>
            <td class="middle">
              <button class="btn btn-default btn-xs btn-block" ng-if="invoice.status == 'unread' || invoice.status == 'read' || invoice.status== 'waitingConfirmation'" ng-disabled="invoice.isReadingwaitingConfirmation || invoice.isReadingpaid" ng-click="$invoiceTools.export($crud.getGroupItemDataReader(invoice,'paid'),true)">
              <span ng-show="invoice.isReadingpaid"><i class="bi bi-arrow-repeat bi-spin"></i></span>
              <span ng-show="!invoice.isReadingpaid" sxy-text="SALAXY.NG1.InvoicesComponent.markAsPaidBtn"></span>
            </button>
            </td>
            <td class="middle">
              <button ng-click="$crud.showInvoiceDialog(invoice)" title="{{ 'SALAXY.NG1.InvoicesComponent.detailsBtn' | sxyTranslate}}" class="btn btn-xs btn-default btn-block" sxy-text="SALAXY.NG1.InvoicesComponent.detailsBtn">
              
            </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>`), s.put("salaxy-components/odata/lists/IrEpr.html", `<div ng-class="$ctrl.getCssClass()">  
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th colspan="2">
            <input type="text" ng-model="$ctrl.rawSearchStringOther"  ng-change="$ctrl.searchChanged('both')" class="form-control" autocomplete="off"
            id="searchx111" name="searchx111" placeholder="{{'SALAXY.NG1_Other.Roles.worker' | sxyTranslate}}"
            ng-model-options="{allowInvalid: true, debounce: 250, updateOn: 'default' }" maxlength="1024">
          </th>
          <th><salaxy-input-enum ng-model="irEprStatus" ng-change="$ctrl.setFilter('status', irEprStatus, 'eq', $ctrl.originalFilter)" placeholder="SALAXY.MODEL.EarningsPaymentListItem.status.title" name="status" enum="EarningsPaymentReportStatus" options="{ '': 'SALAXY.UI_Terms.showAll','new': 'SALAXY.ENUM_IR.EarningsPaymentReportStatus.new.label', 'succeeded': 'SALAXY.ENUM_IR.EarningsPaymentReportStatus.succeeded.label', 'canceled' : 'SALAXY.ENUM_IR.EarningsPaymentReportStatus.canceled.label' , 'error': 'SALAXY.ENUM_IR.EarningsPaymentReportStatus.error.label', 'invalid': 'SALAXY.ENUM_IR.EarningsPaymentReportStatus.invalid.label', 'scheduled': 'SALAXY.ENUM_IR.EarningsPaymentReportStatus.scheduled.label' }" label-type="plain"></salaxy-input-enum> </th>
          <th class="right"><span sxy-orderby="salaryDate" sxy-text="SALAXY.NG1.IrEprComponent.salaryDate"></span></th>
          <th class="right"><span sxy-orderby="endAt" sxy-text="SALAXY.NG1.IrEprComponent.sendTime"></span></th>
          <th class="right ">
            <span sxy-orderby="payment" sxy-text="SALAXY.NG1.IrEprComponent.payment"></span><br />
            <span sxy-orderby="grossSalary" sxy-text="SALAXY.NG1.IrEprComponent.grossSalary"></span>
          </th>
          <th class="right" colspan="2"></th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="td-avatar middle">
            <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
          </td>
          <td class="td-name middle">
            <strong>{{row.otherPartyInfo.avatar.displayName}}</strong><br />
            <span>{{row.otherPartyInfo.email}}</span>
          </td>
          <td class="middle">
            {{ "SALAXY.ENUM_IR.EarningsPaymentReportStatus." + row.status + ".label" | sxyTranslate }}
            <div ng-if="$crud.isIrModified(row)"><span class="badge bg-danger" title="{{'SALAXY.NG1.IrEprComponent.irModified' | sxyTranslate}}" sxy-text="SALAXY.NG1.IrEprComponent.modified" ps="!"></span></div>
            <div ng-if="$crud.isDelayed(row)"><span class="badge bg-danger" title="Myöhässä" sxy-text="SALAXY.NG1.IrEprComponent.delayed" ps="!"></span></div>
          </td>
          <td class="middle right">
            {{ row.salaryDate | date }}
          </td>
          <td class="middle right">
            <div title="{{'SALAXY.NG1.IrEprComponent.firstDelivery' | sxyTranslate}}" ng-if="row.data.firstDeliveredAt != row.data.lastDeliveredAt"><span ng-class="{'badge': row.data.scheduledFor && row.data.scheduledFor == row.data.firstDeliveredAt ,'bg-warning': row.data.scheduledFor && row.data.scheduledFor == row.data.firstDeliveredAt}">{{ row.data.firstDeliveredAt | date}}</span></div>
            <div title="{{'SALAXY.NG1.IrEprComponent.latestDelivery' | sxyTranslate}}"><span ng-class="{'badge': row.data.scheduledFor && row.data.scheduledFor == row.data.lastDeliveredAt ,'bg-warning': row.data.scheduledFor && row.data.scheduledFor == row.data.lastDeliveredAt}">{{ row.data.lastDeliveredAt | date}}</span></div>
          </td>
          <td class="right middle">
            {{ row.payment | currency }}<br /> {{ row.grossSalary | currency }}
          </td>
          <td class="middle">
            <a ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-default"><i
              class="bi bi-info-circle visible-xxs"></i><span class="hidden-xxs" sxy-text="SALAXY.UI_Terms.show"></span></a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`), s.put("salaxy-components/odata/lists/IrPsr.html", `<div ng-class="$ctrl.getCssClass()">  
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th sxy-text="SALAXY.NG1.IrPsrComponent.notificationType"></th>
          <th sxy-text="SALAXY.NG1.IrPsrComponent.status"></th>
          <th sxy-text="SALAXY.NG1.IrPsrComponent.month" class="right"><span sxy-orderby="logicalDate"></span></th>
          <th sxy-text="SALAXY.NG1.IrPsrComponent.sendTime" class="right"><span sxy-orderby="endAt"></span></th>
          <th sxy-text="SALAXY.NG1.IrPsrComponent.savaPayment" class="right"><span sxy-orderby="payment"></span></th>
          <th class="right" sxy-text="SALAXY.NG1.IrPsrComponent.expense"></th>
          <th class="right" colspan="2"></th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="middle">{{ "SALAXY.ENUM_IR.SummaryTransactionCode." + row.entityType + ".label" | sxyTranslate }}</td>
          <td class="middle">
            {{ "SALAXY.ENUM_IR.PayerSummaryReportStatus." + row.status + ".label" | sxyTranslate }}
            <div ng-if="$crud.isIrModified(row)"><span class="badge bg-danger" title="Ilmoitusta on muokattu käsin" sxy-text="SALAXY.NG1.IrPsrComponent.modified" ps="!"></span></div>
            <div ng-if="$crud.isDelayed(row)"><span class="badge bg-danger" title="Myöhässä" sxy-text="SALAXY.NG1.IrPsrComponent.delayed" ps="!"></span></div>
          </td>
          <td class="middle right">
            {{ row.logicalDate | date : 'MM/yyyy' }}
          </td>
          <td class="middle right">
            <div title="{{'SALAXY.NG1.IrPsrComponent.firstDelivery' | sxyTranslate}}" ng-if="row.data.firstDeliveredAt != row.data.lastDeliveredAt"><span ng-class="{'badge': row.data.scheduledFor && row.data.scheduledFor == row.data.firstDeliveredAt ,'bg-warning': row.data.scheduledFor && row.data.scheduledFor == row.data.firstDeliveredAt}">{{ row.data.firstDeliveredAt | date}}</span></div>
            <div title="{{'SALAXY.NG1.IrPsrComponent.latestDelivery' | sxyTranslate}}"><span ng-class="{'badge': row.data.scheduledFor && row.data.scheduledFor == row.data.lastDeliveredAt ,'bg-warning': row.data.scheduledFor && row.data.scheduledFor == row.data.lastDeliveredAt}">{{ row.data.lastDeliveredAt | date}}</span></div>
          </td>
          <td class="right middle">
            {{ row.payment | currency }}
          </td>
          <td class="right middle">{{ row.data.socialSecurityDeduction | currency }}</td>
          <td class="middle">
            <a ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-default"><i class="bi bi-info-circle visible-xxs"></i><span
              class="hidden-xxs" sxy-text="SALAXY.UI_Terms.show"></span></a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`), s.put("salaxy-components/odata/lists/MessageThreads.html", `<div ng-class="$ctrl.getCssClass()" class="table-responsive">
  <table class="table">
    <thead>
      <tr>
        <th>&nbsp;</th>
        <th>
          <span><span sxy-text="SALAXY.NG1.MessageThreadsComponent.title"></span></span><br/>
          <span sxy-orderby="otherPartyInfo/avatar/displayName"><span sxy-text="SALAXY.NG1.MessageThreadsComponent.sender"></span></span>
        </th>
        <th class="right">
          <span sxy-orderby="salaryDate"><span sxy-text="SALAXY.NG1.MessageThreadComponent.salaryDate"></span></span><br/>
          <span><span sxy-text="SALAXY.NG1_Pages.Service.ApprovePayrollList.period"></span></span><br/>
          <span><span sxy-text="SALAXY.NG1.MessageThreadsComponent.answered"></span></span>
        </th>
        <th class="right ">
          <span sxy-orderby="grossSalary"><span sxy-text="SALAXY.NG1_Pages.Service.ApproveCalculationList.salary" ></span></span><br />
          <span sxy-orderby="payment"><span sxy-text="SALAXY.NG1_Pages.Service.ApproveCalculationList.payment" ></span></span><br/>
          <span><span sxy-text="SALAXY.NG1_Pages.Service.ApprovePayrollList.calculations"></span></span>
        </th>
        <th class="right">
          <span sxy-orderby="status"><span sxy-text="SALAXY.NG1.MessageThreadsComponent.status"></span></span><br />
          <span sxy-orderby="createdAt"><span sxy-text="SALAXY.UI_Terms.created"></span></span><br />
          <span sxy-orderby="updatedAt"><span sxy-text="SALAXY.UI_Terms.updated"></span></span>
        </th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="row in $ctrl.items">
        <td class="td-avatar middle">
          <salaxy-avatar class="float-end" avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
        </td>
        <td class="middle">
          <span>
            <b>{{row.data.title}}</b>
          </span>
          <span class="label label-primary" ng-if="row.data.otherPartyUnreadCount">
            {{ row.data.otherPartyUnreadCount }}
            <i class="bi bi-chat-fill" aria-hidden="true"></i>
          </span>
          <div>{{row.otherPartyInfo.avatar.displayName}}</div>
          <div class="truncate" style="max-width: 300px; font-size: 0.9em;"><i>{{ row.data.otherPartyLastMessage }}</i></div>
        </td>
        <td class="right">
          {{ row.salaryDate | date }}<br /> {{ { start: row.data.periodStart, end: row.data.periodEnd } | sxyDateRange }}<br/> {{ row.data.otherPartyUpdatedAt | sxyTime }}
        </td>
        <td class="right">
          {{ row.grossSalary | currency }}<br /> {{ row.payment | currency }}<br/> {{ row.data.calcCount ? (row.data.calcCount + " " + ("SALAXY.NG1.MessageThreadsComponent.pce" | sxyTranslate)) : "-" }}
        </td>
        <td class="middle right">
          <div ng-class="{ 'text-success': row.status == 'approved', 'text-danger': row.status == 'rejected' }">
            <span ng-switch="row.status">
              <span ng-switch-when="draft" sxy-text="SALAXY.NG1.MessageThreadsComponent.message"></span>
            <span ng-switch-when="active" sxy-text="SALAXY.NG1.MessageThreadsComponent.waiting"></span>
            <span ng-switch-default>{{ "MessageThreadStatus." + row.status | sxyEnum }}</span>
            </span>
          </div>
          {{ row.createdAt | sxyTime }}<br /> {{ row.updatedAt | sxyTime }}
        </td>
        <td class="middle">
          <a href="#{{$crud.getDefaults().detailsUrl}}{{ row.id }}" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-sm btn-primary btn-block">
            <i class="bi bi-chat-fill d-inline-block d-sm-none"></i>
            <span sxy-text="SALAXY.UI_Terms.show"></span>
          </a>
        </td>
      </tr>
    </tbody>
  </table>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`), s.put("salaxy-components/odata/lists/MessageThreadsApproval.html", `<div ng-class="$ctrl.getCssClass()">
  <table class="table">
    <thead>
      <tr>
        <th>&nbsp;</th>
        <th sxy-orderby="data/title">
          <span sxy-text="SALAXY.NG1.MessageThreadsComponent.title"></span>
          <div>Lähettäjä</div>
        </th>
        <th class="right">Tila</th>
        <th class="right">
          <span sxy-orderby="createdAt"><span sxy-text="SALAXY.UI_Terms.created"></span></span><br />
          <span sxy-orderby="updatedAt"><span sxy-text="SALAXY.UI_Terms.updated"></span></span>
        </th>
        <th class="hidden-xxs"></th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="row in $ctrl.items">
        <td class="td-avatar middle">
          <salaxy-avatar class="float-end" avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
        </td>
        <td class="middle">
          <span ng-switch="row.data.usecaseUri">
            <b ng-switch-when="palkkaus.fi/testing/messages-proto/timer">Kellokortti</b>
            <b ng-switch-when="palkkaus.fi/testing/messages-proto/timeReport">Työaikaraportti</b>
            <b ng-switch-when="palkkaus.fi/testing/messages-proto/hourlyReport">Tuntiraportti</b>
            <b ng-switch-when="palkkaus.fi/testing/messages-proto/calcRow">Palkkarivit</b>
            <b ng-switch-default>{{ row.data.title || row.data.usecaseUri }}</b>
          </span>
          
          <span class="label label-primary" ng-if="row.data.otherPartyUnreadCount">
            {{ row.data.otherPartyUnreadCount }}
            <i class="bi bi-chat-fill" aria-hidden="true"></i>
          </span>

          <div>{{row.otherPartyInfo.avatar.displayName}}</div>
        </td>
        <td class="right">
          <div ng-class="{ 'text-success': row.status == 'approved', 'text-danger': row.status == 'rejected' }">{{ "MessageThreadStatus." + row.status | sxyEnum }}</div>
        </td>
        <td class="middle right">
          {{ row.createdAt | sxyTime }}<br /> {{ row.updatedAt | sxyTime }}
        </td>
        <td class="middle">
          <a href="#{{$crud.getDefaults().approvalUrl}}{{ row.id }}" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-sm btn-primary btn-block">
            <i class="bi bi-chat-fill d-inline-block d-sm-none"></i>
            <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.show"></span>
          </a>
        </td>
      </tr>
    </tbody>
  </table>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`), s.put("salaxy-components/odata/lists/PaymentChannelSelect.html", `<div ng-class="$ctrl.getCssClass()">
  <div class="visible-xxs">
    <div class="table-filter-container-mobile">
      <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search" label-type="plain">
      </salaxy-input>
    </div>
  </div>
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th colspan="2">
            <div sxy-orderby="shortText"><span sxy-text="SALAXY.NG1.PaymentChannelSelectComponent.exportDefinition"></span></div>
            <div sxy-text="SALAXY.NG1.PaymentChannelSelectComponent.targetChannel"></div>
          </th>
          <th sxy-orderby="owner" colspan="2">
            <div sxy-text="SALAXY.NG1.ApiCrudObjectComponent.owner"></div>
            <div sxy-text="SALAXY.NG1.ApiCrudObjectComponent.status"></div>
          </th>

          <th class="right hidden-xxs" colspan="2">
            <div class="table-filter-container">
              <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" class="salaxy-odata-table-search" placeholder="SALAXY.UI_Terms.textSearch" label-type="plain"></salaxy-input>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="td-avatar middle">
            <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
          </td>
          <td class="middle">
            <div title="{{ row.shortText }} ({{ row.id }})">
              <strong>{{ row.otherPartyInfo.avatar.displayName }}</strong>
            </div>
          </td>
          <td class="td-avatar middle">
            <salaxy-avatar avatar="row.ownerInfo.avatar"></salaxy-avatar>
          </td>
          <td class="middle">
            <div>{{ row.ownerInfo.avatar.displayName }}</div>
            <div>{{ "AccountingTargetStatus." + row.status | sxyEnum }}</div>
          </td>
          <td class="right middle">
            <button class="btn btn-sm" type="button" ng-class="$ctrl.isSelected(row) ? 'btn-danger' : 'btn-info'" ng-click="$ctrl.setSelected(row, 'toggle')">
              {{ $ctrl.isSelected(row) ? ('SALAXY.UI_Terms.unselect' | sxyTranslate) : ('SALAXY.NG1.UI_Terms.select' | sxyTranslate) }}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`), s.put("salaxy-components/odata/lists/Payrolls-select.html", `<div ng-class="$ctrl.getCssClass()">
  <div class="table-responsive">
    <div class="visible-xxs">
      <div class="table-filter-container-mobile">
        <salaxy-input name="search_xxs{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search" label-type="plain">
        </salaxy-input>
      </div>
    </div>
    <table class="table">
      <thead>
        <tr>
          <th>
            <span sxy-text="SALAXY.NG1.PayrollListComponent.description"></span>
            <span class="label label-primary clickable" ng-if="$ctrl.selectedItems.length" ng-click="$ctrl.selectedItems.splice(0,$ctrl.selectedItems.length)"> {{'SALAXY.UI_Terms.chosen' | sxyTranslate}}: {{ $ctrl.selectedItems.length }} <i class="bi bi-x-circle"></i></span>
            <div>
              <span sxy-text="SALAXY.NG1.PayrollListComponent.salaryDate"></span>
            </div>
          </th>
          <th sxy-orderby="status">
            <span sxy-text="SALAXY.NG1.PayrollListComponent.status"></span>
          </th>
          <th class="right">
            <div sxy-orderby="endAt">
              <span sxy-text="SALAXY.NG1.PayrollListComponent.period"></span>
            </div>
          </th>
          <th class="right">
            <span sxy-text="SALAXY.NG1.PayrollListComponent.paymentDate"></span>
          </th>
          <th class="right">
            <span sxy-text="SALAXY.NG1.PayrollListComponent.calculations"></span>
            <div sxy-orderby="grossSalary">
              <span sxy-text="SALAXY.NG1.PayrollListComponent.grossSalaries"></span>
            </div>
          </th>
          <th class="right" colspan="2">
            <div class="table-filter-container">
              <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" class="salaxy-odata-table-search" placeholder="SALAXY.UI_Terms.textSearch" label-type="plain"></salaxy-input>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="">
            <div class="payroll-title"><strong>{{ row.data.title }}</strong></div>
            <div class="payroll-info">{{ row.salaryDate | date }}</div>
          </td>
          <td class="">
            <div>
              {{ 'PayrollStatus.' + row.status | sxyEnum }}
              <span ng-if="row.data.calendarEvent" class="badge bg-primary">
                <i class="bi bi-calendar3" aria-hidden="true"></i>
                <span sxy-text="SALAXY.NG1.PayrollListComponent.calendarEvent"></span>
              </span>
              <i ng-if="row.data.calendarOccurence" class="bi bi-calendar3 text-primary" aria-hidden="true" title="{{ 'SALAXY.NG1.PayrollListComponent.calendarOccurence' | sxyTranslate }}"></i>
              <i ng-if="!row.data.calendarOccurence && row.data.template" class="bi bi-copy text-primary" aria-hidden="true" title="{{ 'SALAXY.NG1.PayrollListComponent.template' | sxyTranslate }}"></i>
            </div>
            <span ng-if="row.status == 'draft'" class="small" ng-class="{'text-danger' : !row.data.isReady }">
              {{ row.data.isReady ? ('SALAXY.NG1.PayrollListComponent.readyForPayment' | sxyTranslate) : ('SALAXY.NG1.PayrollListComponent.notReadyForPayment' | sxyTranslate)  }}
            </span>
          </td>
          <td class="right">
            {{ row.startAt | date }}<br /> {{ row.endAt | date }}
          </td>
          <td class="right">
            {{ row.data.paymentDate || row.data.dueDate | date }}
          </td>
          <td class="right">
            {{ row.data.calcCount ? (row.data.calcCount + " " + ("SALAXY.UI_Terms.pcs" | sxyTranslate)) : "-" }}<br /> {{ row.grossSalary | currency }}
          </td>
          <td class="middle right">
            <button class="btn btn-sm" type="button" ng-class="$ctrl.isSelected(row) ? 'btn-danger' : 'btn-info'" ng-click="$ctrl.setSelected(row, 'toggle')">
              {{ $ctrl.isSelected(row) ? ("SALAXY.UI_Terms.unselect" | sxyTranslate) : ("SALAXY.UI_Terms.select" | sxyTranslate) }}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`), s.put("salaxy-components/odata/lists/Payrolls.html", `<div ng-class="$ctrl.getCssClass()" class="table-responsive">

  <div class="visible-xxs">
    <div class="table-filter-container-mobile">
      <salaxy-input name="search_xxs{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search" label-type="plain">
      </salaxy-input>
    </div>
  </div>
  <table class="table">
    <thead>
      <tr>
        <th><span sxy-text="SALAXY.NG1.PayrollListComponent.description"></span></th>
        <th sxy-orderby="status"><span sxy-text="SALAXY.NG1.PayrollListComponent.status"></span></th>
        <th class="right">
          <span sxy-orderby="endAt">
            <span sxy-text="SALAXY.NG1.PayrollListComponent.period"></span>
          </span>
        </th>
        <th sxy-orderby="salaryDate" class="right"><span sxy-text="SALAXY.NG1.PayrollListComponent.salaryDate"></span></th>
        <th class="right"><span sxy-text="SALAXY.NG1.PayrollListComponent.dueDate"></span></th>
        <th class="right"><span sxy-text="SALAXY.NG1.PayrollListComponent.paymentDate"></span></th>
        <th class="right hidden-xxs">
          <span sxy-text="SALAXY.NG1.PayrollListComponent.calculations"></span>

          <div sxy-orderby="grossSalary">
            <span sxy-text="SALAXY.NG1.PayrollListComponent.grossSalaries"></span>
          </div>
        </th>
        <th class="right hidden-xxs" colspan="2">
          <div class="table-filter-container">
            <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" class="salaxy-odata-table-search" placeholder="SALAXY.UI_Terms.textSearch" label-type="plain"></salaxy-input>
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="row in $ctrl.items">
        <td ng-click="$crud.showDetails(row)" class="d-table-cell d-sm-none clickable" title="Siirry palkkalistaan">
          <span class="payroll-title"><strong>{{ row.data.title }}</strong></span>
        </td>
        <td class="d-none d-sm-table-cell">
          <span class="payroll-title"><strong>{{ row.data.title }}</strong></span>
        </td>
        <td class="">
          <div>
            {{ 'PayrollStatus.' + row.status | sxyEnum }}
            <span ng-if="row.data.calendarEvent" class="badge bg-primary">
              <i class="bi bi-calendar3" aria-hidden="true"></i>
              <span sxy-text="SALAXY.NG1.PayrollListComponent.calendarEvent"></span>
            </span>
            <i ng-if="row.data.calendarOccurence" class="bi bi-calendar3 text-primary" aria-hidden="true" title="{{ 'SALAXY.NG1.PayrollListComponent.calendarOccurence' | sxyTranslate }}"></i>
            <i ng-if="!row.data.calendarOccurence && row.data.template" class="bi bi-copy text-primary" aria-hidden="true" title="{{ 'SALAXY.NG1.PayrollListComponent.template' | sxyTranslate }}"></i>
          </div>
          <span ng-if="row.status == 'draft'" class="small" ng-class="{'text-danger' : !row.data.isReady }">
            {{ row.data.isReady ? ('SALAXY.NG1.PayrollListComponent.readyForPayment' | sxyTranslate) : ('SALAXY.NG1.PayrollListComponent.notReadyForPayment' | sxyTranslate)  }}
          </span>
        </td>
        <td class="right">
          {{ row.startAt | date }}<br /> {{ row.endAt | date }}
        </td>
        <td class="right">
          <span class="payroll-info">{{ row.salaryDate | date }}</span>
        </td>
        <td class="right">
          {{ row.status != 'paymentSucceeded' ? (row.data.dueDate | date) : '' }}
        </td>
        <td class="right">
          {{ ['paymentStarted', 'draft', 'waitingApproval', 'waitingPartnerApproval'].includes(row.status) ? '' : (row.data.paymentDate | date) }}
        </td>
        <td class="right hidden-xxs">
          {{ row.data.calcCount ? (row.data.calcCount + " " +("SALAXY.UI_Terms.pcs" | sxyTranslate)) : "-" }}<br /> {{ row.grossSalary | currency }}
        </td>

        <td class="middle hidden-xxs">
          <button ng-if="!(row.isReadOnly || row.status == 'paymentStarted') && !$ctrl.readOnly" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.edit' | sxyTranslate}}" class="btn btn-sm btn-primary btn-block">
            <i class="bi bi-pencil-fill d-inline-block d-sm-none"></i>
            <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.edit"></span>
          </button>
          <button ng-if="(row.isReadOnly || row.status == 'paymentStarted') || $ctrl.readOnly" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
            <i class="bi bi-info-circle d-inline-block d-sm-none"></i>
            <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.show"></span>
          </button>
        </td>
        <td class="middle hidden-xxs">
          <button ng-if="!(row.isReadOnly || row.status == 'paymentStarted') && !$ctrl.readOnly" ng-click="$crud.delete(row)" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}" class="btn btn-sm btn-danger btn-block">
            <i class="bi bi-trash-fill d-inline-block d-sm-none"></i>
            <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.delete"></span>
          </button>
          <button ng-if="(row.isReadOnly || row.status == 'paymentStarted') && !$ctrl.readOnly" ng-click="$crud.showCopyAsNew(row)" title="{{ 'SALAXY.UI_Terms.copyAsNew' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
            <i class="bi bi-copy d-inline-block d-sm-none"></i>
            <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.copyAsNew"></span>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`), s.put("salaxy-components/odata/lists/ReferenceObjects.html", `<div ng-class="$ctrl.getCssClass()">
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th></th>
          <th sxy-orderby="status">Status</th>
          <th sxy-orderby="shortText">Description</th>
          <th sxy-orderby="logicalDate">Reference date</th>
          <th class="right">
            <div sxy-orderby="createdAt" sxy-text="SALAXY.UI_Terms.created"></div>
            <div sxy-orderby="updatedAt" sxy-text="SALAXY.UI_Terms.updated"></div>
          </th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="middle">
            <img ng-if="row.data.icon || row.ownerInfo.avatar.url" ng-src="{{row.data.icon || row.ownerInfo.avatar.url}}" style="width: 45px; height: 45px;" />
          </td>
          <td class="middle">{{ row.status  }}</td>
          <td class="middle">{{ row.shortText  }}</td>
          <td class="middle">{{ row.logicalDate | sxyDate }}</td>
          <td class="right">
            <div title="{{ row.createdAt }}">{{ row.createdAt | sxyDate }}</div>
            <div title="{{ row.updatedAt }}">{{ row.updatedAt | sxyDate }}</div>
            <div></div>
          </td>
          <td class="middle hidden-xxs">
            <button ng-if="!row.isReadOnly" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.edit' | sxyTranslate}}" class="btn btn-sm btn-primary btn-block">
              <i class="bi bi-pencil-fill d-inline-block d-sm-none"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.edit"></span>
            </button>
            <button ng-if="row.isReadOnly" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
              <i class="bi bi-info-circle d-inline-block d-sm-none"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.show"></span>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`), s.put("salaxy-components/odata/lists/SalaryReports.html", `<div ng-class="$ctrl.getCssClass()">
  <div class="table-responsive">
    <div ng-controller="SalarySlipDownloadController as $downloadCtrl">
      <button type="button" class="btn btn-primary" ng-click="$downloadCtrl.export($ctrl.selectedItems)" ng-disabled="$ctrl.selectedItems.length == 0" sxy-text="SALAXY.UI_Terms.downloadSelected"></button>
    </div>
    <table class="table table-striped">
      <thead>
        <tr>
          <th colspan="2" class="hidden-xxs">
            <span sxy-orderby="otherPartyInfo/avatar/displayName" class="clickable"><span sxy-text="SALAXY.NG1_Other.Roles.worker"></span><i ng-if="$odata.getColumnOrder('avatar/displayName')" class="bi bi-sort-{{ $odata.getColumnOrder('avatar/displayName') }}"
              aria-hidden="true"></i></span>
          </th>
          <th class="visible-xxs">
            <span sxy-orderby="otherPartyInfo/avatar/displayName" class="clickable"><span sxy-text="SALAXY.NG1_Other.Roles.worker"></span><i ng-if="$odata.getColumnOrder('avatar/displayName')" class="bi bi-sort-{{ $odata.getColumnOrder('avatar/displayName') }}"
              aria-hidden="true"></i></span>
          </th>
          <th class="right">
            <span sxy-orderby="endAt" class="clickable"><span sxy-text="Pvm"></span></span>
          </th>
          <th class="right">
            <span sxy-orderby="payment" sxy-text="SALAXY.NG1.SalaryReportsComponent.payment"></span><br>
            <span sxy-orderby="grossSalary" sxy-text="SALAXY.NG1.SalaryReportsComponent.grossSalary"></span>
          </th>
          <th class="middle hidden-xxs">
            <button title="{{'SALAXY.NG1.AccountingReportsComponent.chooseAll' | sxyTranslate}}" class="btn btn-block btn-transparent" type="button" ng-if="$ctrl.selectedItems.length == 0" ng-disabled="$ctrl.selectedItems.length == $ctrl.items.length" ng-click="$crud.selectAll()">
              <i class="bi bi-square"></i>
            </button>
            <button title="{{'SALAXY.UI_Terms.unselect' | sxyTranslate}}" class="btn btn-block btn-transparent" type="button" ng-if="$ctrl.selectedItems.length > 0" ng-disabled="$ctrl.selectedItems.length == 0" ng-click="$crud.unselectAll()">
              <i class="bi bi-check-square"></i>
            </button>
          </th>
          <th class="right " colspan="2">
            <div class="table-filter-container">
              <salaxy-input name="searchx{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="sort-by-text" label-type="plain">
              </salaxy-input>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="td-avatar middle hidden-xxs">
            <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
          </td>
          <td class="td-name middle">
            <span ng-if="row.otherPartyInfo.avatar.displayName == ''">{{ 'SALAXY.NG1.SalaryReportsComponent.notSelected' | sxyTranslate }}</span>
            <strong>{{row.otherPartyInfo.avatar.displayName}}</strong>
          </td>
          <td class="right middle">{{ row.endAt | date }}</td>
          <td class="right">
            {{ row.payment | currency }}<br> {{ row.grossSalary | currency }}
          </td>
          <td class="middle hidden-xxs">
            <button title="{{'SALAXY.UI_Terms.select' | sxyTranslate}}" class="btn btn-block btn-transparent" type="button" ng-if="!$ctrl.isSelected(row)" ng-click="$ctrl.setSelected(row, 'toggle')">
              <i class="bi bi-square"></i>
            </button>
            <button title="{{'SALAXY.UI_Terms.unselect' | sxyTranslate}}" class="btn btn-block btn-transparent" type="button" ng-if="$ctrl.isSelected(row)" ng-click="$ctrl.setSelected(row, 'toggle')">
              <i class="bi bi-check-square"></i>
            </button>
          </td>
          <td class="middle ">
            <a ng-href="{{$crud.getPdfUrl(row)}}" target="_blank" title="{{ 'SALAXY.UI_Terms.printable' | sxyTranslate}}" class="btn btn-sm btn-block btn-default">
              <i class="bi bi-file-earmark-pdf d-sm-none d-inline-block"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.printable" pre=" "></span>
            </a>
          </td>
          <td class="middle ">
            <button ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-sm btn-block btn-default">
              <i class="bi bi-info-circle-fill d-inline-block d-sm-none"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.show" pre=" "></span>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`), s.put("salaxy-components/odata/lists/SalaryReportsPanel.html", `<div class="salaxy-odata-card list-card report-list-card card card-sm card-secondary" ng-init="hideFilter = false">
  <div class="card-header d-flex align-items-center">
    {{('SALAXY.NG1.SalaryReportsComponent.calculations' | sxyTranslate) }}
    <button ng-show="$ctrl.items.length > 0" class="btn btn-secondary btn-xs ms-auto" ng-click="hideFilter = !hideFilter" title="Näytä suodattimet">
      <i class="bi bi-funnel-fill"></i>
    </button>
  </div>
  <div class="card-body filters text-end" ng-class="{'showfilters' : hideFilter}">
    <div class="filter-buttons">
      <button class="btn btn-xs btn-secondary text-end" sxy-orderby="otherPartyInfo/avatar/displayName" sxy-text="SALAXY.UI_Terms.abc"></button>
      <button class="btn btn-xs btn-secondary text-end" sxy-orderby="endAt">
          <i class="bi bi-calendar3"></i>
      </button>
      <button class="btn btn-xs btn-secondary text-end" sxy-orderby="grossSalary">€</button>
    </div>
    <salaxy-input name="search1cp{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search hidden-xxs" label-type="plain">
    </salaxy-input>
  </div>
  <div ng-class="$ctrl.getCssClass()">
    <div class="visible-xxs" ng-if="$ctrl.items.length > 0">
      <div class="table-filter-container-mobile">
        <salaxy-input name="search2cp{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search" label-type="plain">
        </salaxy-input>
      </div>
    </div>
    <div class="card-body text-center card-content lg-height align-middle" ng-show="$ctrl.items.length == 0 && !$ctrl.isLoading">
      <div>
        <h3 sxy-text="SALAXY.NG1.SalaryReportsComponent.noCalculations"></h3>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table" ng-if="$ctrl.items.length > 0">
        <tbody>
          <tr ng-repeat="row in $ctrl.items">

            <td class="td-avatar middle  hidden-xxs">
              <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
            </td>
            <td class="td-name middle">
              <span ng-if="row.otherPartyInfo.avatar.displayName == ''">{{ 'SALAXY.NG1.SalaryReportsComponent.notSelected' | sxyTranslate }}</span>
              <strong>{{row.otherPartyInfo.avatar.displayName}}</strong>
            </td>
            <td class="right">
              {{ row.grossSalary | currency }}
              <br>
              <small>{{ row.endAt | date }}</small>
            </td>

            <td class="middle right">
              <a ng-href="{{$crud.getPdfUrl(row)}}" target="_blank" title="{{ 'SALAXY.UI_Terms.printable' | sxyTranslate}}" class="btn btn-sm btn-secondary"><i class="bi bi-file-earmark-pdf"></i></a>
              <button href="" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-sm btn-secondary"><i class="bi bi-info-circle"></i></button>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="salaxy-odata-footer">
        <salaxy-spinner></salaxy-spinner>
      </div>
    </div>
  </div>
  <div class="card-footer text-center">
    <a ng-href="#{{$crud.getDefaults().listUrl}}" title="Näytä kaikki" class="btn btn-primary btn-sm" sxy-text="SALAXY.UI_Terms.showAll"></a>
  </div>
</div>`), s.put("salaxy-components/odata/lists/SelectListItem.html", `<div ng-class="$ctrl.getCssClass()">
  <div class="visible-xxs">
    <div class="table-filter-container-mobile">
      <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="{{'SALAXY.UI_Terms.textSearch' |sxyTranslate}}" class="salaxy-odata-table-search" label-type="plain">
      </salaxy-input>
    </div>
  </div>
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th></th>
          <th>
            <div><span class="label label-primary clickable" ng-if="$ctrl.selectedItems.length" ng-click="$ctrl.selectedItems.splice(0,$ctrl.selectedItems.length)"> {{'SALAXY.UI_Terms.chosen' | sxyTranslate}}: {{ $ctrl.selectedItems.length }} <i class="bi bi-x-circle"></i></span></div>
            <div sxy-orderby="shortText">Teksti</div>
          </th>
          <th class="right">
            <div sxy-orderby="createdAt"  sxy-text="SALAXY.UI_Terms.created"></div>
            <div sxy-orderby="updatedAt"  sxy-text="SALAXY.UI_Terms.updated"></div>
          </th>
          <th>
            <div sxy-orderby="status">Tila</div>
          </th>
          <th class="right hidden-xxs" colspan="2">
            <div class="table-filter-container">
              <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" class="salaxy-odata-table-search" placeholder="{{'SALAXY.UI_Terms.textSearch' |sxyTranslate}}" label-type="plain"></salaxy-input>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="td-avatar middle">
            <salaxy-avatar ng-if="row.otherPartyInfo.avatar.displayName" avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
          </td>
          <td class="td-name middle">
            <div><strong>{{row.shortText }}</strong></div>
            <div>{{ row.otherPartyInfo.avatar.displayName }}</div>
          </td>
          <td class="right">
            <div>{{ row.createdAt | sxyDate }}</div>
            <div>{{ row.updatedAt | sxyDate }}</div>
          </td>
          <td class="middle">
            <div>{{ row.status }}</div>
          </td>
          <td class="right middle">
            <button class="btn btn-sm" type="button" ng-class="$ctrl.isSelected(row) ? 'btn-danger' : 'btn-info'" ng-click="$ctrl.setSelected(row, 'toggle')">
              {{ $ctrl.isSelected(row) ? ('SALAXY.UI_Terms.unselect' | sxyTranslate) : ('SALAXY.UI_Terms.select' | sxyTranslate) }}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`), s.put("salaxy-components/odata/lists/ServiceModels.html", `<div ng-class="$ctrl.getCssClass()">
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th></th>
          <th sxy-text="SALAXY.NG1.ServiceModelsComponent.serviceModel"></th>
          <th class="right">
            <div sxy-orderby="createdAt" sxy-text="SALAXY.UI_Terms.created"></div>
            <div sxy-orderby="updatedAt" sxy-text="SALAXY.UI_Terms.updated"></div>
          </th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="middle">
            <img ng-if="row.data.icon || row.ownerInfo.avatar.url" ng-src="{{row.data.icon || row.ownerInfo.avatar.url}}" style="width: 45px; height: 45px;" />
          </td>
          <td class="middle">
            <div ng-if="row.id == row.ownerInfo.avatar.id">
              <strong ng-if="!row.shortText">{{'SALAXY.NG1.ServiceModelsComponent.defaultModel' | sxyTranslate}}  {{ row.ownerInfo.avatar.displayName }}</strong>
              <strong ng-if="row.shortText">{{ row.shortText || ('SALAXY.NG1.ServiceModelsComponent.nameless' | sxyTranslate) }}</strong>
            </div>
            <div ng-if="row.id != row.ownerInfo.avatar.id">
              <strong>{{ row.shortText || ('SALAXY.NG1.ServiceModelsComponent.nameless' | sxyTranslate) }}</strong>
            </div>
          </td>
          <td class="right">
            <div title="{{ row.createdAt }}">{{ row.createdAt | sxyDate }}</div>
            <div title="{{ row.updatedAt }}">{{ row.updatedAt | sxyDate }}</div>
            <div></div>
          </td>
          <td class="middle hidden-xxs">
            <button ng-if="!row.isReadOnly" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.edit' | sxyTranslate}}" class="btn btn-sm btn-primary btn-block">
              <i class="bi bi-pencil-fill d-sm-none d-inline-block"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.edit"></span>
            </button>
            <button ng-if="row.isReadOnly" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
              <i class="bi bi-info-circle d-sm-none d-inline-block"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.show"></span></button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`), s.put("salaxy-components/odata/lists/Taxcards-select.html", `
<div ng-class="$ctrl.getCssClass()">
  <div class="table-responsive">
    <table class="table table-striped">
      <thead class="">
        <tr>
          <th colspan="2"><span sxy-orderby="otherPartyInfo/avatar/displayName" sxy-text="SALAXY.NG1.TaxcardsListComponent.worker"></span></th>
          <th class="right">
            <span sxy-orderby="endAt" sxy-text="SALAXY.NG1.TaxcardsListComponent.year"></span><br />
            </td>
            <th class="right">
              <span sxy-orderby="startAt" sxy-text="SALAXY.NG1.TaxcardsListComponent.valid"></span><br />
              <span sxy-orderby="endAt" sxy-text="SALAXY.NG1.TaxcardsListComponent.validTill"></span><br />
              </td>
              <th class="right">
                <span sxy-text="SALAXY.NG1.TaxcardsListComponent.paid"></span><br>
                <span sxy-text="SALAXY.NG1.TaxcardsListComponent.incomeLimit"></span>
              </th>
              <th>
              </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="align-middle td-avatar">
            <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
          </td>
          <td class="td-name">
            <strong ng-if="row.otherPartyInfo.avatar.displayName">{{row.otherPartyInfo.avatar.displayName}}</strong>
            <strong ng-if="!row.otherPartyInfo.avatar.displayName">{{'SALAXY.NG1.TaxcardsListComponent.unknown' | sxyTranslate}}</strong>
            <br /> {{ "SALAXY.ENUM.TaxcardKind." + row.data.kind + ".label" | sxyTranslate}}
            <span ng-if="row.data.kind !== 'noTaxCard' && row.data.kind !== 'noWithholdingHousehold' && row.data.kind !== 'undefined'">{{row.data.taxPercent}} %</span>
            <span ng-if="row.data.taxPercent2">
              <br />{{'SALAXY.NG1.TaxcardsListComponent.taxPercent2' | sxyTranslate}} {{row.data.taxPercent2}} %
            </span>
          </td>
          <td class="right">
            <span>{{row.data.forYear}}</span><br />
          </td>
          <td class="right">
            <span>{{row.data.start | sxyDate}}</span><br />
            <span>{{row.data.end | sxyDate}}</span><br />
          </td>
          <td class="right">
            <span class="small paidsalaries">{{ row.data.totalIncome | currency}}</span>
            <span class="small incomelimit">{{(row.data.incomeLimit | currency) || '-'}}</span>
          </td>
          <td class="middle right">
            <button class="btn btn-sm" type="button" ng-class="$ctrl.isSelected(row) ? 'btn-danger' : 'btn-info'" ng-click="$ctrl.setSelected(row, 'toggle')">
              {{ $ctrl.isSelected(row) ? ("SALAXY.UI_Terms.unselect" | sxyTranslate) : ("SALAXY.UI_Terms.select" | sxyTranslate) }}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`), s.put("salaxy-components/odata/lists/Taxcards.html", `<div ng-class="$ctrl.getCssClass()">
  <div class="table-responsive">
    <table class="table table-striped">
      <thead class="">
        <tr>
          <th colspan="2"><span sxy-orderby="otherPartyInfo/avatar/displayName" sxy-text="SALAXY.NG1.TaxcardsListComponent.worker"></span></th>
          <th class="right">
            <span sxy-orderby="endAt" sxy-text="SALAXY.NG1.TaxcardsListComponent.year"></span><br />
            </td>
            <th class="right">
              <span sxy-orderby="startAt" sxy-text="SALAXY.NG1.TaxcardsListComponent.valid"></span><br />
              <span sxy-orderby="endAt" sxy-text="SALAXY.NG1.TaxcardsListComponent.validTill"></span><br />
              </td>
              <th class="right">
                <span sxy-text="SALAXY.NG1.TaxcardsListComponent.paid"></span><br>
                <span sxy-text="SALAXY.NG1.TaxcardsListComponent.incomeLimit"></span>
              </th>
              <th>
                <!--div class="table-filter-container text-end">
                  <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" label-type="plain" placeholder="SALAXY.UI_Terms.textSearch"></salaxy-input>
                </div-->
              </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="align-middle td-avatar">
            <a href="#/employments/details/{{row.data.employmentId}}" class="cell-link" title="{{'SALAXY.NG1.WorkerListComponent.editWorker' | sxyTranslate}}">
              <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
            </a>
          </td>
          <td class="td-name">
            <strong ng-if="row.otherPartyInfo.avatar.displayName">{{row.otherPartyInfo.avatar.displayName}}</strong>
            <strong ng-if="!row.otherPartyInfo.avatar.displayName && row.otherPartyInfo.officialId">{{'SALAXY.NG1.TaxcardsListComponent.personalId' | sxyTranslate}} : {{row.otherPartyInfo.officialId}}</strong>
            <strong ng-if="!row.otherPartyInfo.avatar.displayName && !row.otherPartyInfo.officialId">{{'SALAXY.NG1.TaxcardsListComponent.unknown' | sxyTranslate}}</strong>
            <br /> {{ "SALAXY.ENUM.TaxcardKind." + row.data.kind + ".label" | sxyTranslate}}
            <span ng-if="row.data.kind !== 'noTaxCard' && row.data.kind !== 'noWithholdingHousehold' && row.data.kind !== 'undefined'">{{row.data.taxPercent}} %</span>
            <span ng-if="row.data.taxPercent2">
              <br />{{'SALAXY.NG1.TaxcardsListComponent.taxPercent2' | sxyTranslate}} {{row.data.taxPercent2}} %
            </span>
          </td>
          <td class="right">
            <span>{{row.data.forYear}}</span><br />
          </td>
          <td class="right">
            <span>{{row.data.start | sxyDate}}</span><br />
            <span>{{row.data.end | sxyDate}}</span><br />
          </td>
          <td class="right">
            <span class="small paidsalaries">{{ row.data.totalIncome | currency: ' €' : 0 }}</span>
            <span class="small incomelimit">{{(row.data.incomeLimit | currency: ' €' : 0) || '-'}}</span>
            <span class="d-inline d-md-none"></span>
          </td>
          <td class="right">
            <div class="btn-group-sm">
              <button class="btn btn-primary" ng-disabled="$ctrl.loaders['showTaxCardAddDialogForTaxCardsList']" ng-click="$crud.showTaxCardAddDialogForTaxCardsList(row);" ng-if="row.otherId && ('!household' | sxyIsInRole)" sxy-text="SALAXY.UI_Terms.addNew"></button>
              <button title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" ng-click="$crud.showDetails(row)" class="btn btn-default" ng-if="'!household' | sxyIsInRole">
                <i class="bi bi-pencil-fill d-sm-none d-inline-block"></i>
                <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.show"></span></button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`), s.put("salaxy-components/odata/lists/Usecases.html", `<div ng-class="$ctrl.getCssClass()">
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th></th>
          <th sxy-orderby="shortText" sxy-text="SALAXY.NG1.ApiCrudObjectComponent.description"></th>
          <th sxy-orderby="entityType" sxy-text="SALAXY.NG1.ApiCrudObjectComponent.entityType"></th>
          <th class="hidden-xxs" sxy-text="SALAXY.NG1.ApiCrudObjectComponent.owner"></th>
          <th class="right">
            <div sxy-orderby="createdAt" sxy-text="SALAXY.UI_Terms.created"></div>
            <div sxy-orderby="updatedAt" sxy-text="SALAXY.UI_Terms.updated"></div>
          </th>
          <th class="right hidden-xxs" colspan="2">
            <div class="table-filter-container">
              <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" class="salaxy-odata-table-search" placeholder="SALAXY.UI_Terms.textSearch" label-type="plain"></salaxy-input>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td style="width: 86px;">
            <div class="thumbnail" style="margin-bottom: 0;">
              <div class="text-center thumbnail-pic-fixed" style="width: 60px;height: 60px">
                <img ng-if="row.data.icon[0] == 'h'" ng-src="{{row.data.icon}}">
                <div ng-if="row.data.icon[0] != 'h'" class="bg-primary thumbnail-pic-icon" style="font-size: 32px">
                  <i class="fa" ng-class="row.data.icon || 'bi-currency-euro'" aria-hidden="true"></i>
                </div>
              </div>
            </div>
          </td>
          <td>
            <div><strong>{{ row.shortText }}</strong></div>
            <div>{{ row.data.description }}</div>
          </td>
          <td>
            <div>{{ "ApiItemType." + row.entityType | sxyEnum }}</div>
            <div ng-switch="row.status">
              <span class="badge" ng-class="$crud.getStatusBgColor(row.status)">{{ "UsecaseStatus." + row.status | sxyEnum }}</span>
            </div>
          </td>
          <td class="align-middle td-avatar hidden-xxs" title="{{ row.ownerInfo.avatar.displayName }}">
            <salaxy-avatar avatar="row.ownerInfo.avatar"></salaxy-avatar>
          </td>
          <td class="right">
            <div>{{ row.createdAt | sxyDate }}</div>
            <div>{{ row.updatedAt | sxyDate }}</div>
          </td>
          <td class="middle hidden-xxs">
            <button ng-if="!row.isReadOnly" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.edit' | sxyTranslate}}" class="btn btn-sm btn-primary btn-block">
              <i class="bi bi-pencil-fill d-sm-none d-inline-block"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.edit"></span>
            </button>
            <button ng-if="row.isReadOnly" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
              <i class="bi bi-info-circle d-sm-none d-inline-block"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.show"></span>
            </button>
          </td>
          <td class="middle hidden-xxs">
            <button ng-if="!row.isReadOnly" ng-click="$crud.delete(row)" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}" class="btn btn-sm btn-danger btn-block">
              <i class="bi bi-trash-fill d-sm-none d-inline-block"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.delete"></span>
            </button>
            <button ng-if="row.isReadOnly" ng-click="$crud.showCopyAsNew(row)" title="{{ 'SALAXY.UI_Terms.copyAsNew' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
              <i class="bi bi-copy d-sm-none d-inline-block"></i>
              <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.copyAsNew"></span>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`), s.put("salaxy-components/odata/lists/UsecasesAdHocReport.html", `<div ng-class="$ctrl.getCssClass()">
  <div class="row g-4">
    <div class="col" ng-repeat="row in $ctrl.items | orderBy: $crud.getOrder" ng-if="$crud.getActive(row) != 'inactive'">
      <div class="card">
        <div class="text-center card-pic-fixed">
          <img ng-if="row.data.icon[0] == 'h'" ng-src="{{row.data.icon}}">
          <div ng-if="row.data.icon[0] != 'h'" class="bg-primary card-pic-icon">
            <i class="fa" ng-class="row.data.icon || 'bi-currency-euro'" aria-hidden="true"></i>
          </div>
        </div>
        <div class="card-body">
          <h3 class="truncate">{{ row.shortText }}</h3>
          <p style="height: 80px;overflow: hidden">{{ row.data.description }}</p>
          <p ng-switch="row.entityType">
            <a ng-switch-when="dataset" ng-href="#/reports/ad-hoc/new?usecase=%2FUsecaseDefinition%2F{{ row.owner }}%2F{{ row.id }}" class="btn btn-primary" role="button" style="color: white" sxy-text="SALAXY.UI_Terms.select" ps="..."></a>
            <a ng-switch-default class="btn btn-primary" role="button" style="color: white" sxy-text="TODO" ps="..."></a>
          </p>
        </div>
      </div>
    </div>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`), s.put("salaxy-components/odata/lists/UsecasesCalc.html", `<div ng-class="$ctrl.getCssClass()">
  <div class="row g-4">
    <div class="col-sm-6 col-md-4" ng-repeat="row in $ctrl.items" ng-if="$crud.getActive(row) != 'inactive'">
      <div class="card">
        <div class="text-center card-pic-fixed" style="height: 150px;">
          <img ng-if="row.data.icon[0] == 'h'" ng-src="{{row.data.icon}}">
          <div ng-if="row.data.icon[0] != 'h'" class="bg-primary card-pic-icon">
            <i class="fa" ng-class="row.data.icon || 'bi-currency-euro'" aria-hidden="true"></i>
          </div>
          <span class="badge float-end" ng-class="$crud.getStatusBgColor($crud.getActive(row))">{{ "UsecaseStatus." + $crud.getActive(row) | sxyEnum }}</span>
        </div>
        <div class="card-body">
          <h3 class="truncate">{{ row.shortText }}</h3>
          <p style="height: 80px;overflow: hidden">{{ row.data.description }}</p>
          <p ng-switch="row.entityType">
            <a ng-switch-when="calculation" ng-href="#/calc/usecase/new?usecase=%2FUsecaseDefinition%2F{{ row.owner }}%2F{{ row.id }}" class="btn btn-primary" role="button" style="color: white" sxy-text="SALAXY.UI_Terms.createNew" ps="..."></a>
            <a ng-switch-default class="btn btn-primary" role="button" style="color: white" sxy-text="TODO" ps="..."></a>
          </p>
        </div>
      </div>
    </div>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`), s.put("salaxy-components/odata/lists/UsecaseSelect.html", `<div ng-class="$ctrl.getCssClass()">
  <div class="visible-xxs">
    <div class="table-filter-container-mobile">
      <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" placeholder="SALAXY.UI_Terms.textSearch" class="salaxy-odata-table-search" label-type="plain">
      </salaxy-input>
    </div>
  </div>
  <div class="table-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th colspan="2">
            <div sxy-orderby="shortText" sxy-text="SALAXY.NG1.ApiCrudObjectComponent.name"></div>
          </th>
          <th sxy-orderby="owner" colspan="2">
            <div sxy-text="SALAXY.NG1.ApiCrudObjectComponent.owner"></div>
          </th>
          <th class="right hidden-xxs" colspan="3">
            <div class="table-filter-container">
              <salaxy-input name="search{{::$id}}" ng-model="$ctrl.options.$search" ng-change="$ctrl.searchChanged()" class="salaxy-odata-table-search" placeholder="SALAXY.UI_Terms.textSearch" label-type="plain"></salaxy-input>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.items">
          <td class="td-avatar middle">
            <div>
              <strong>{{ row.shortText }}</strong>
            </div>
          </td>
          <td class="middle">
            <div title="{{ row.shortText }} ({{ row.id }})">
              <strong>{{ row.otherPartyInfo.avatar.displayName }}</strong>
            </div>
          </td>
          <td class="td-avatar middle">
            <salaxy-avatar avatar="row.ownerInfo.avatar"></salaxy-avatar>
          </td>
          <td class="middle">
            <div>{{ row.ownerInfo.avatar.displayName }}</div>
          </td>
          <td></td>
          <td class="right middle">
            <button class="btn btn-sm" type="button" ng-class="$ctrl.isSelected(row) ? 'btn-danger' : 'btn-info'" ng-click="$ctrl.setSelected(row, 'toggle')">
              {{ $ctrl.isSelected(row) ? ('SALAXY.UI_Terms.unselect' | sxyTranslate) : ('SALAXY.UI_Terms.select' | sxyTranslate) }}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`), s.put("salaxy-components/odata/lists/WorktimeImport.html", `<div ng-class="$ctrl.getCssClass()">
  <table class="table">
    <thead>
      <tr>
        <th sxy-orderby="id">
          <div>Title</div>
          <div sxy-text="SALAXY.NG1.ApiCrudObjectComponent.id"></div>
        </th>
        <th sxy-orderby="status"  sxy-text="SALAXY.UI_Terms.status"></th>
        <th class="right">
          <div sxy-orderby="createdAt" sxy-text="SALAXY.UI_Terms.created"></div>
          <div sxy-orderby="updatedAt" sxy-text="SALAXY.UI_Terms.updated"></div>
        </th>
        <th class="right">Files</th>
        <th class="right">
          <div>Empl.</div>
          <div>Rows</div>
        </th>
        <th class="right">
          Errors
        </th>
        <th class="right">
          <div>Period</div>
          <div>Salary date</div>
        </th>
        <th colspan="2"></th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="row in $ctrl.items">
        <td>
          <div>{{ row.shortText || "-" }}</div>
          <div><code><small>{{ row.id }}</small></code></div>
        </td>
        <td>{{ row.status }}</td>
        <td class="right">
          <div>{{ row.createdAt | sxyTime }}</div>
          <div>{{ row.updatedAt | sxyTime }}</div>
        </td>
        <td class="right">{{ row.data.filesCount || "-" }}</td>
        <td class="right">
          <div>{{ row.data.employmentsCount || "-" }}</div>
          <div>{{ row.data.rowsCount || "-" }}</div>
        </td>
        <td class="right">
          <div ng-class="row.data.employmentsErrors ? 'text-danger' : 'text-success'">{{ row.data.employmentsErrors || "OK" }}</div>
          <div ng-class="row.data.employmentsErrors ? 'text-danger' : 'text-success'">{{ row.data.rowsErrors || "OK" }}</div>
        </td>
        <td class="right">
          <div>{{ row | sxyDateRange }}</div>
          <div>{{ row.salaryDate | sxyDate }}</div>
        </td>
        <td>
          <button ng-if="!row.isReadOnly" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.edit' | sxyTranslate}}" class="btn btn-sm btn-primary btn-block">
            <i class="bi bi-pencil-fill d-s-none d-inline-block"></i>
            <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.edit"></span>
          </button>
          <button ng-if="row.isReadOnly" ng-click="$crud.showDetails(row)" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
            <i class="bi bi-info-circle d-sm-none d-inline-block"></i>
            <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.show"></span>
          </button>
        </td>
        <td>
          <button ng-if="!row.isReadOnly" ng-click="$crud.delete(row)" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}" class="btn btn-sm btn-danger btn-block">
            <i class="bi bi-trash-fill d-sm-none d-inline-block"></i>
            <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.delete"></span>
          </button>
          <button ng-if="row.isReadOnly" ng-click="$crud.showCopyAsNew(row)" title="{{ 'SALAXY.UI_Terms.copyAsNew' | sxyTranslate}}" class="btn btn-sm btn-default btn-block">
            <i class="bi bi-copy d-sm-none d-inline-block"></i>
            <span class="d-none d-sm-inline-block" sxy-text="SALAXY.UI_Terms.copyAsNew"></span>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
  <salaxy-odata-footer></salaxy-odata-footer>
</div>`), s.put("salaxy-components/odata/lists/_default.html", `<ng-include src="$ctrl.$crudController.getDefaults().oDataTemplateUrl || 'salaxy-components/odata/lists/ApiCrudObject.html'"></ng-include>`), s.put("salaxy-components/odata/OdataActions.html", `<div class="salaxy-component salaxy-odata-actions d-flex justify-content-end" ng-init="$ctrl.$crud = $ctrl.$odata.$crudController">
  <div class="me-2">
    <span class="salaxy-form-group-plain">
      <input type="text" ng-model="$ctrl.$odata.options.$search" ng-change="$ctrl.$odata.searchChanged()" class="form-control" autocomplete="off"
        id="searchx111" name="searchx111" placeholder="{{'SALAXY.UI_Terms.textSearch' | sxyTranslate}}"
        ng-model-options="{allowInvalid: true, debounce: 250, updateOn: 'default' }" maxlength="1024">
    </span>
  </div>
  <div ng-if="$ctrl.showExport" class="btn-group dropdown">
    <button id="single-button" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown">
      <i class="bi bi-three-dots" aria-hidden="true"></i>
    </button>
    <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="single-button">
      <li>
        <a href="" ng-controller="ExportController as $export" ng-click="$export.showExport($ctrl.getExportable())" sxy-text="SALAXY.NG1.ODataActionsComponent.export" class="dropdown-item"></a>
      </li>
    </ul>
  </div>
</div>`), s.put("salaxy-components/odata/OdataFooter.html", `<div class="salaxy-component salaxy-odata-footer">
  <salaxy-spinner></salaxy-spinner>
  <div ng-if="$ctrl.getNoItemsMessage()" class="salaxy-odata-no-data">
    <div ng-class="$ctrl.getNoItemsCssClass()">{{ $ctrl.getNoItemsMessage() | sxyTranslate }}</div>
  </div>
  <div ng-if="$ctrl.getPagingView() == 'nextPageLink'">
    {{'SALAXY.NG1.ODataFooterComponent.showing' | sxyTranslate}} {{ $ctrl.$odata.count ? ($ctrl.$odata.items.length + "/" + $ctrl.$odata.count) : $ctrl.$odata.items.length }} {{'SALAXY.NG1.ODataFooterComponent.rows' | sxyTranslate}}.
    <a href="" ng-click="$ctrl.$odata.loadNextPage(true)" sxy-text="SALAXY.NG1.ODataFooterComponent.downloadMore" ps="..."></a>
  </div>
  <div ng-if="$ctrl.getPagingView() == 'clientLimit'">
    {{'SALAXY.NG1.ODataFooterComponent.showing' | sxyTranslate}} {{ $ctrl.$odata.count ? ($ctrl.$odata.items.length + "/" + $ctrl.$odata.count) : $ctrl.$odata.items.length }} {{'SALAXY.NG1.ODataFooterComponent.rows' | sxyTranslate}}.
    <a href="" ng-click="$ctrl.$odata.options.$top = null; $ctrl.$odata.reload()" sxy-text="SALAXY.NG1.ODataFooterComponent.downloadMore" ps="..."></a>
  </div>
  <div ng-if="$ctrl.getPagingView() == 'url'">
    {{'SALAXY.NG1.ODataFooterComponent.showing' | sxyTranslate}} {{ $ctrl.$odata.count ? ($ctrl.$odata.items.length + "/" + $ctrl.$odata.count) : $ctrl.$odata.items.length }} {{'SALAXY.NG1.ODataFooterComponent.rows' | sxyTranslate}}.
    <a ng-href="{{$ctrl.nextPageUrl}}" sxy-text="SALAXY.NG1.ODataFooterComponent.showAll" ps="..."></a>
  </div>
  <div ng-if="$ctrl.getPagingView() == 'server'">
    {{'SALAXY.NG1.ODataFooterComponent.showingRows' | sxyTranslate}} rivit {{ ($ctrl.$odata.options.$skip || 0) + 1 }} - {{ ($ctrl.$odata.options.$skip || 0) + $ctrl.$odata.items.length }}
    <span ng-if="$ctrl.count"> {{'SALAXY.NG1.ODataFooterComponent.total' | sxyTranslate}} {{ $ctrl.$odata.count }} {{'SALAXY.NG1.ODataFooterComponent.rows' | sxyTranslate}}</span>
    <a href="" ng-click="$ctrl.loadNextPage(false)" sxy-text="SALAXY.NG1.ODataFooterComponent.nextPage" ps="..."></a>
  </div>
</div>`), s.put("salaxy-components/pages/accounting/details.html", `<main class="salaxy-content sxytpl-accounting-report-viewer">
  <section>
    <salaxy-accounting-report-viewer model="'url'"></salaxy-accounting-report-viewer>
  </section>
</main>`), s.put("salaxy-components/pages/accounting/holiday-pay-debt-query.html", `<main class="salaxy-content sxytpl-accounting-holiday-pay-debt-report-query">
  <section>
    <salaxy-accounting-holiday-pay-debt-report-query></salaxy-accounting-holiday-pay-debt-report-query>
  </section>
</main>`), s.put("salaxy-components/pages/accounting/index.html", `<main class="salaxy-content sxytpl-accounting-report-list">
  <section class="d-flex flex-column align-items-end">
    <a class="btn btn-default d-block mb-2" href="#/accounting/query" >{{ "SALAXY.NG1_Sitemap.reports.accountingQuery" | sxyTranslate}}...</a>
    <a ng-if="!('hideHolidayDebt' | sxyIsInRole)" class="btn btn-default d-block" href="#/accounting/holiday-pay-debt-query" >{{ "SALAXY.NG1_Sitemap.reports.accountingHolidayPayDebtQuery" | sxyTranslate}}...</a>
  </section>
  <section>
    <salaxy-accounting-report-list></salaxy-accounting-report-list>
  </section>
</main>`), s.put("salaxy-components/pages/accounting/query.html", `<main class="salaxy-content sxytpl-accounting-report-query">
  <section>
    <salaxy-accounting-report-query></salaxy-accounting-report-query>
  </section>
</main>`), s.put("salaxy-components/pages/accounting-targets/details.html", `<main class="salaxy-content sxytpl-accounting-target-details">
  <section class="pt-4">
    <salaxy-accounting-target-details model="'url'"></salaxy-accounting-target-details>
  </section>
</main>`), s.put("salaxy-components/pages/accounting-targets/index.html", `<main class="salaxy-content sxytpl-accounting-target-list">
  <section>
    <div class="salaxy-component salaxy-accounting-target-list">
      <salaxy-odata-table crud-controller="AccountingTargetCrudController as $crud">
      </salaxy-odata-table>
    </div>
  </section>
</main>
 
 `), s.put("salaxy-components/pages/calc/all.html", `<main class="salaxy-content sxytpl-calculations-all-list">
  <section>
    <salaxy-action-button action="'newCalc'" label="SALAXY.NG1.ActionButtonComponent.newCalculation"></salaxy-action-button>
    <salaxy-calc-list category="all"></salaxy-calc-list>
  </section>
</main>`), s.put("salaxy-components/pages/calc/details.html", `<main class="salaxy-content sxytpl-calc-details">
  <section>
    <salaxy-calc-usecase ng-if="'test' | sxyIsInRole" model="'url'" is-read-only-forced="$ctrl.route.readOnly"></salaxy-calc-usecase>
    <salaxy-calc ng-if="!('test' | sxyIsInRole)" model="'url'" is-read-only-forced="$ctrl.route.readOnly"></salaxy-calc>
  </section>
</main>`), s.put("salaxy-components/pages/calc/draft.html", `<main class="salaxy-content sxytpl-calculations-draft-list">
  <section>
    <salaxy-action-button ng-if="!$ctrl.route.readOnly" action="'newCalc'" label="SALAXY.NG1.ActionButtonComponent.newCalculation"></salaxy-action-button>
    <salaxy-calc-list category="draft" read-only="$ctrl.route.readOnly"></salaxy-calc-list>
  </section>
</main>`), s.put("salaxy-components/pages/calc/editor.html", `<salaxy-calc-editor model="'url'">
</salaxy-calc-editor>`), s.put("salaxy-components/pages/calc/error.html", `<main class="salaxy-content sxytpl-calculations-error-list">
  <section>
    <salaxy-calc-list category="error"></salaxy-calc-list>
  </section>
</main>`), s.put("salaxy-components/pages/calc/history.html", `<div ng-controller="Calculator2022Controller as $ctrl" ng-init="$ctrl.updateRows = false;$ctrl.model = 'url';">
  <!-- TODO: Move texts to the model as much as possible. -->
  <h2 sxy-text="SALAXY.NG1_Pages.Calc.History.heading"></h2>
  <p class="lead" sxy-text="SALAXY.NG1_Pages.Calc.History.lead"></p>
  <div ng-if="$ctrl.current">
    <sxy-form open-api="salaxy-secure/schemas/v02.json" type="Calculation" auto-gen="false" debugger="false" model="$ctrl.current">
      <div>
        <fieldset>
          <legend sxy-text="SALAXY.NG1_Pages.Calc.History.workerJobLabel"></legend>
          <salaxy-calc-employment model="$ctrl" update-rows="false"></salaxy-calc-employment>
        </fieldset>
        <fieldset>
          <legend sxy-text="SALAXY.NG1_Pages.Calc.History.payrollInfo"></legend>
          <sxy-input label="SALAXY.NG1_Pages.Calc.History.salaryDateLabel" model="form.workflow.salaryDate"></sxy-input>
          <sxy-input label="SALAXY.NG1_Pages.Calc.History.workStartDateLabel" model="form.info.workStartDate"></sxy-input>
          <sxy-input label="SALAXY.NG1_Pages.Calc.History.workEndDateLabel" model="form.info.workEndDate"></sxy-input>
          <sxy-input label="SALAXY.NG1_Pages.Calc.History.statusLabel" model="form.workflow.status" read-only="true"></sxy-input>
          <sxy-input label="SALAXY.NG1_Pages.Calc.History.fixedTaxAmountLabel" model="form.worker.tax.fixedTaxAmount" format="euro"></sxy-input>
        </fieldset>
        <fieldset>
          <legend sxy-text="SALAXY.NG1_Pages.Calc.History.rows"></legend>
          <salaxy-calc-rows-2019-editor parent="$ctrl.current" title="{{'SALAXY.NG1_Pages.Calc.History.payrollRows' | sxyTranslate}}" on-commit="$ctrl.historyUsecase.recalculate()" show-edit-buttons="false" show-gross-totals="false"
            is-in-edit="!$ctrl.current.isReadOnly"></salaxy-calc-rows-2019-editor>
        </fieldset>
        <div class="text-end">
          <button ng-if="$ctrl.showAction('recalculate')" type="button" class="btn btn-primary" ng-click="$ctrl.historyUsecase.recalculate()" sxy-text="SALAXY.NG1_Pages.Calc.History.reCalculate"></button>
        </div>
        <fieldset>
          <legend sxy-text="SALAXY.NG1_Pages.Calc.History.cumulativePayrollRows"></legend>
          <p sxy-html="SALAXY.NG1_Pages.Calc.History.cumulativePayrollInfo.html"></p>
          <table class="table">
            <colgroup>
              <col width="35%">
              <col width="15%">
              <col width="35%">
              <col width="15%">
            </colgroup>
            <tbody>
              <tr>
                <th sxy-text="SALAXY.NG1_Pages.Calc.History.totalGrossSalary"></th>
                <td class="right">{{ $ctrl.current.result.totals.totalGrossSalary | currency }}</td>
                <th sxy-text="SALAXY.NG1_Pages.Calc.History.benefits"></th>
                <td class="right">{{ $ctrl.current.result.workerCalc.benefits | currency }}</td>
              </tr>
              <tr>
                <th sxy-text="SALAXY.NG1_Pages.Calc.History.holidayCompensation" ps="*"></th>
                <td class="right">{{ $ctrl.getRowTotal("holidayCompensation") | currency }}</td>
                <th sxy-text="SALAXY.NG1_Pages.Calc.History.holidayBonus" ps="*"></th>
                <td class="right">{{ $ctrl.getRowTotal("holidayBonus") | currency }}</td>
              </tr>
              <tr>
                <th sxy-text="SALAXY.NG1_Pages.Calc.History.holidaySalary" ps="*"></th>
                <td class="right">{{ $ctrl.getRowTotal("holidaySalary") | currency }}</td>
                <th sxy-text="SALAXY.NG1_Pages.Calc.History.totalTaxable" ps="*"></th>
                <td class="right">{{ $ctrl.current.result.totals.totalTaxable | currency }}</td>
              </tr>
              <tr>
                <th sxy-text="SALAXY.NG1_Pages.Calc.History.tax" ps="*"></th>
                <td class="right">{{ $ctrl.current.result.workerCalc.tax | currency }}</td>
                <th sxy-text="SALAXY.NG1_Pages.Calc.History.pension"></th>
                <td class="right">{{ $ctrl.current.result.workerCalc.pension | currency }}</td>
              </tr>
              <tr>
                <th sxy-text="SALAXY.NG1_Pages.Calc.History.unemploymentInsurance"></th>
                <td class="right">{{ $ctrl.current.result.workerCalc.unemploymentInsurance | currency }}</td>
                <th sxy-text="SALAXY.NG1_Pages.Calc.History.deductions"></th>
                <td class="right">{{ $ctrl.current.result.workerCalc.deductions | currency }}</td>
              </tr>
              <tr>
                <th sxy-text="SALAXY.NG1_Pages.Calc.History.totalExpenses"></th>
                <td class="right">{{ $ctrl.current.result.totals.totalExpenses | currency }}</td>
                <th sxy-text="SALAXY.NG1_Pages.Calc.History.salaryPayment"></th>
                <td class="right">{{ $ctrl.current.result.workerCalc.salaryPayment | currency }}</td>
              </tr>
            </tbody>
          </table>
        </fieldset>
        <div class="text-end" ng-if="$ctrl.showAction('save')">
          <button type="button" class="btn btn-primary" ng-click="$ctrl.historyUsecase.save()" sxy-text="SALAXY.UI_Terms.save"></button>
        </div>
      </div>
    </sxy-form>
  </div>
</div>`), s.put("salaxy-components/pages/calc/import-calcs.html", `<main class="salaxy-content">
  <section>
    <!-- Forcing isFullWidth  -->
    <div style="display: none;" ng-init="$ctrl.current.isFullWidth = true"></div>
    <salaxy-tab-buttons
      current-tab="$ctrl.currentTab"
      options="[
        { value: 'default', text: 'Palkkalaskelmien tuonti' },
        { value: 'list', text: 'Palkkalistat' },
      ]"
      tabs-id="importCalcs">
    </salaxy-tab-buttons>
    <div class="tab-content" id="tab-content-importCalcs">
      <div class="tab-pane" id="default-tab">
        <salaxy-calc-import></salaxy-calc-import>
      </div>
      <div class="tab-pane" id="list-tab">
        <salaxy-payroll-list details-url="/payroll/details/" hide-button="$ctrl.route.readOnly" is-read-only-forced="$ctrl.route.readOnly"></salaxy-payroll-list>
      </div>
    </div>
  </section>
</main>`), s.put("salaxy-components/pages/calc/index.html", `<main class="salaxy-content sxytpl-calculations-dashboard">
  <section>
    <salaxy-calc-dashboard hide-button="$ctrl.route.readOnly" read-only="$ctrl.route.readOnly"></salaxy-calc-dashboard>
  </section>
</main>`), s.put("salaxy-components/pages/calc/ircalc.html", `<salaxy-ir-calc model="'url'"></salaxy-ir-calc>`), s.put("salaxy-components/pages/calc/paid-ir.html", `<main class="salaxy-content sxytpl-calculations-paid-list">
  <section>
    <salaxy-calc-list category="paidIr" read-only="$ctrl.route.readOnly" ></salaxy-calc-list>
  </section>
</main>`), s.put("salaxy-components/pages/calc/paid.html", `<main class="salaxy-content sxytpl-calculations-paid-list">
  <section>
    <salaxy-action-button ng-if="!$ctrl.route.readOnly" class="mb-3 d-block" action="'newCalc'" label="SALAXY.NG1.ActionButtonComponent.newCalculation"></salaxy-action-button>
    <salaxy-calc-list category="paid" read-only="$ctrl.route.readOnly"></salaxy-calc-list>
  </section>
</main>`), s.put("salaxy-components/pages/calc/payment.html", `<main class="salaxy-content sxytpl-calc-payment">
  <section>
    <div class="container" ng-controller="CalculationCrudController as $calc" ng-init="$calc.model='url'">
      <salaxy-invoices-create ng-if="$calc.current" model="$calc.current"></salaxy-invoices-create>
    </div>
  </section>
</main>
`), s.put("salaxy-components/pages/calc/repair.html", `<main class="salaxy-content sxytpl-calc-repair">
  <section>
    <salaxy-calc-repair model="'url'" is-read-only-forced="$ctrl.route.readOnly"></salaxy-calc-repair>
  </section>
</main>`), s.put("salaxy-components/pages/calc/repairs.html", `<main class="salaxy-content sxytpl-calc-repairs">
  <section>
    <salaxy-action-button action="'newRepair'" on-after-action="$list.reload()"></salaxy-action-button>
    <salaxy-odata-table ng-ref="$list" url="/v03/api/calculations/category/all" crud-controller="CalculationCrudController as $crud" options="{$filter: 'status eq \\'repair\\''}" template-url="salaxy-components/odata/lists/CalculationsRepairs.html" read-only="$ctrl.route.readOnly">
    </salaxy-odata-table>
  </section>
</main>`), s.put("salaxy-components/pages/calc/shared.html", `<main class="salaxy-content sxytpl-calculations-shared-list">
  <section>
    <salaxy-calc-list category="shared" read-only="$ctrl.route.readOnly"></salaxy-calc-list>
  </section>
</main>`), s.put("salaxy-components/pages/calc/travel.html", `<div ng-controller="Calculator2022Controller as $ctrl" ng-init="$ctrl.updateRows = false;$ctrl.model = 'url';">
  <!-- TODO: Move texts to the model as much as possible. -->
  <h2>Matkalasku</h2>
  <p class="lead"></p>
  <salaxy-spinner ng-if="!$ctrl.current"></salaxy-spinner>
  <div ng-if="$ctrl.current">
    <sxy-form open-api="salaxy-secure/schemas/v02.json" type="Calculation" auto-gen="false" debugger="false" model="$ctrl.current">
      <div>
        <fieldset>
          <legend sxy-text="SALAXY.NG1_Pages.Calc.History.workerJobLabel"></legend>
          <salaxy-calc-employment model="$ctrl" update-rows="false"></salaxy-calc-employment>
        </fieldset>
        <fieldset>
          <legend sxy-text="SALAXY.NG1_Pages.Calc.History.payrollInfo"></legend>
          <sxy-input label="Matkan alku" model="form.info.workStartDate"></sxy-input>
          <sxy-input label="SALAXY.NG1_Pages.Calc.History.workEndDateLabel" model="form.info.workEndDate"></sxy-input>
          <sxy-input label="SALAXY.NG1_Pages.Calc.History.statusLabel" model="form.workflow.status" read-only="true"></sxy-input>
        </fieldset>
        <salaxy-calc-rows-editor parent="$ctrl.current" title="Matkalaskun rivit" on-commit="$ctrl.recalculate()"
          show-edit-buttons="false" show-gross-totals="true" ng-ref="$rows"
          is-in-edit="!$ctrl.current.isReadOnly">
          <footer>
            <p>Lisää matkalaskun rivi:</p>
            <button class="btn btn-default" ng-click="$rows.showEdit({ rowType: 'expenses' })">Kulu</button>
            <button class="btn btn-default" ng-click="$rows.showEdit({ rowType: 'milageOwnCar' })">Kilometrikorvaus</button>
            <button class="btn btn-default" ng-click="$rows.showEdit({ rowType: 'dailyAllowance' })">Päiväraha</button>
          </footer>
        </salaxy-calc-rows-editor>
        <div class="text-end">
          <button type="button" class="btn btn-default" ng-click="$ctrl.recalculate()" sxy-text="SALAXY.NG1_Pages.Calc.History.reCalculate"></button>
          <button type="button" class="btn btn-primary" ng-click="$ctrl.save()" sxy-text="SALAXY.UI_Terms.send"></button>
        </div>
      </div>
    </sxy-form>
  </div>
</div>`), s.put("salaxy-components/pages/calendar/details.html", `<main class="salaxy-content sxytpl-calendar-details">
  <section>
    <form name="frmEvent">
      <h2 sxy-text="SALAXY.NG1_Pages.Calendar.heading"></h2>
      <salaxy-calendar-event-details ng-ref="$ctrl.$calendar" model="'url'"></salaxy-calendar-event-details>
      <hr />
      <div>
        <a href="#/calendar-events" class="btn btn-default" sxy-text="SALAXY.UI_Terms.back"></a>
        <button type="button" class="btn btn-primary float-end" ng-click="$ctrl.$calendar.save()" ng-disabled="!frmEvent.$valid" sxy-text="SALAXY.UI_Terms.save"></button>
      </div>
    </form>
  </section>
</main>`), s.put("salaxy-components/pages/calendar/index.html", `<main class="salaxy-content sxytpl-calendar-index">
  <section>
    <h1>TODO: Calendar front page</h1>
    <p>
      Todennäköisesti ei events-listaa, vaan occurences-kalenteri. Events-lista erillisenä sivuna.
    </p>
    <salaxy-odata-table crud-controller="CalendarEventsCrudController as $crud"></salaxy-odata-table>
  </section>
</main>`), s.put("salaxy-components/pages/calendar/occurences.html", `<div class="salaxy-component salaxy-calendar-event-list" ng-controller="CalendarOccurencesController as $ctrl">
  <h1 sxy-text="SALAXY.NG1_Pages.Calendar.Occurences.accountantCalendar"></h1>
  <div class="btn-toolbar mb-3 mt-3" role="toolbar" aria-label="Calendar buttons">
    <div class="btn-group" role="group" aria-label="Kategoriat 2">
        <salaxy-input-enum ng-model="$ctrl.categories" options="$ctrl.categorySelections" name="categories" label-type="no-label" label-cols="none"></salaxy-input-enum>
    </div>
    <div class="btn-group ms-1" role="group" aria-label="Periodi">
        <salaxy-datepicker-popup ng-model="$ctrl.range.start" name="start" label="SALAXY.NG1_Pages.Calendar.Occurences.periodLabel" label-type="inline"></salaxy-datepicker-popup>
        <salaxy-datepicker-popup ng-model="$ctrl.range.end" name="end" label-type="no-label" label-cols="none" class="ms-1"></salaxy-datepicker-popup>
    </div>
    <div class="btn-group ms-1" role="group" aria-label="Actions">
      <button type="button" class="btn btn-primary" ng-click="$ctrl.reload()" sxy-text="SALAXY.UI_Terms.download"></button>
    </div>
  </div>
  <salaxy-spinner ng-if="$ctrl.isLoading"></salaxy-spinner>
  <salaxy-tab-buttons
    ng-if="!$ctrl.isLoading"
    current-tab="$ctrl.currentTab"
    default-tab="'week'"
    options="[
      { value: 'list', text: 'SALAXY.NG1_Pages.Calendar.Occurences.listHeading' },
      { value: 'daily', text: 'SALAXY.NG1_Pages.Calendar.Occurences.dailyHeading' },
      { value: 'week', text: 'SALAXY.NG1_Pages.Calendar.Occurences.weekHeading', isDefault: true },
      { value: 'debug', text: 'Debugger' }
    ]"
    tabs-id="occurrences">
  </salaxy-tab-buttons>
  <div class="tab-content" id="tab-content-occurrences">
    <div class="tab-pane" id="list-tab">
      <ng-include src="'salaxy-components/workflow/calendar/Occurences-list.html'"></ng-include>
    </div>
    <div class="tab-pane" id="daily-tab">
      <ng-include src="'salaxy-components/workflow/calendar/Occurences-daily.html'"></ng-include>
    </div>
    <div class="tab-pane" id="week-tab">
      <ng-include src="'salaxy-components/workflow/calendar/Occurences-week.html'"></ng-include>
    </div>
    <div class="tab-pane" id="debug-tab">
      <salaxy-json-formatter json="$ctrl.list"></salaxy-json-formatter>
    </div>
  </div>
</div>`), s.put("salaxy-components/pages/customer-invoices/details.html", `<main class="salaxy-content sxytpl-datasets-details">
  <section>
    <h1>TODO: Laskunäkymä</h1>
    <div ng-controller="CustomerInvoiceCrudController as $ctrl" ng-init="$ctrl.model = 'url'">
      <salaxy-spinner ng-if="!$ctrl.current"></salaxy-spinner>
      <div ng-if="$ctrl.current">
        <button type="button" class="btn btn-primary" ng-click="$ctrl.save()">Tallenna</button>
        <sxy-form open-api="salaxy-secure/schemas/v02.json" type="CustomerInvoice" auto-gen="true" debugger="true" model="$ctrl.current">
      </div>
    </div>
  </section>
</main>`), s.put("salaxy-components/pages/customer-invoices/index.html", `<main class="salaxy-content sxytpl-datasets-list">
  <section>
    <a href="#/customer-invoices/details/new" class="btn btn-primary" sxy-text="Luo uusi"></a>
    <salaxy-odata-table crud-controller="CustomerInvoiceCrudController as $crud"></salaxy-odata-table>
  </section>
</main>`), s.put("salaxy-components/pages/datasets/details.html", `<main class="salaxy-content sxytpl-datasets-details">
  <section>
    <salaxy-dataset-details mode="full-edit" model="'url'"></salaxy-dataset-details>
  </section>
</main>`), s.put("salaxy-components/pages/datasets/index.html", `<main class="salaxy-content sxytpl-datasets-list">
  <section>
    <a href="#/datasets/details/new" class="btn btn-primary float-end" sxy-text="Luo uusi"></a>
    <h1>{{'Datasets' | sxyTranslate}}<span class="badge bg-primary">BETA</span></h1>
    <salaxy-odata-table crud-controller="DatasetsCrudController as $crud"></salaxy-odata-table>
  </section>
</main>`), s.put("salaxy-components/pages/employments/details.html", `<main class="salaxy-content sxytpl-workers-details">
  <section>
    <salaxy-employment-details model="'url'" list-url="/employments/index" is-read-only-forced="$ctrl.route.readOnly" hide-buttons="$ctrl.route.readOnly"></salaxy-employment-details>
  </section>
</main>`), s.put("salaxy-components/pages/employments/index.html", `<main class="salaxy-content sxytpl-workers-list">
  <section>
    <salaxy-employment-list show-toolbar="true" read-only="$ctrl.route.readOnly"></salaxy-employment-list>
  </section>
</main>`), s.put("salaxy-components/pages/employments/taxcards.html", `<main class="salaxy-content sxytpl-workers-taxcardslist">
  <section class="sxytpl-intro">
    <p class="lead" sxy-text="SALAXY.NG1_Pages.Workers.Taxcards.lead"></p>
  </section>
  <section class="sxytpl-list">
    <salaxy-tax-cards-list></salaxy-tax-cards-list>
  </section>
</main>`), s.put("salaxy-components/pages/home/error404.html", `<main class="salaxy-content sxytpl-home-error404">
  <section>
    <h1 class="page-header" sxy-text="SALAXY.NG1_Pages.Home.Error.pageNotFound"></h1>
    <p class="lead" sxy-html="SALAXY.NG1_Pages.Home.Error.lead.html"></p>
  </section>
</main>`), s.put("salaxy-components/pages/home/index.html", `<main class="salaxy-content sxytpl-home-index" salaxy-if-role="auth">
  <salaxy-signing ng-ref="$ctrl.$signing" show-in-popup="true"></salaxy-signing>
  
  <div ng-if="$ctrl.$signing.isSigningOk">
    <section ng-if="$ctrl.showKyc">
      <salaxy-alert type="warning" class="alert-insurance-and-pension" force-more-info="true">
        <main>
          <div class="row">
            <div class="col-sm-11">
              <p class="lead lead-with-text">Asiakkaan tuntemistiedot (KYC)</p>            
            </div>
          </div>
        </main>
        <aside>
          <div class="row">
            <div class="col-sm-11">
              <p>
                <span>
                 Asiakasvaratilin kautta maksaminen (esim. Paytrail, viitemaksu) edellyttää asiakkaan tuntemistietojen (KYC) päivittämisen. Päivityksen voi tehdä nimenkirjoitusoikeudellinen henkilö “Päivitä asiakkaan tuntemistiedot nyt” -linkin kautta. Sivulta “Lue ohjeet” löytyy tarkat ohjeet ja linkki päivityksen tekijälle toimitettavaksi, jos et itse voi tehdä päivitystä.
                </span>
              </p>
              <p>
                <span>
                  KYC-tietojen päivitys on voimassa vuoden kerrallaan ja tiedot voi käydä päivittämässä etukäteen. Näet tilin tiedoista (Asetukset → Tilin tiedot → Palkkaus.fi-tilin tiedot) milloin viimeistään tuntemistiedot (KYC) tulee päivittää.
                </span>
              </p>
            </div>
            <div class="col-sm-11">
              <a href="https://help.palkkaus.fi/hc/fi/articles/19590957330589-Asiakkaan-tuntemistietojen-päivitys-KYC" target="_blank" class="btn btn-primary" role="button">Lue ohjeet </a>
              <a ng-href="{{('test' | sxyIsInRole) ? 'https://rc-iam.palkkaus.fi/wizard/index.html' : 'https://iam.palkkaus.fi/wizard/index.html'}}" target="_blank" class="btn btn-primary" role="button">Päivitä asiakkaan tuntemistiedot nyt</a>
            </div>
          </div>
        </aside>
      </salaxy-alert>
    </section>
    <section ng-if="$ctrl.getRoute('#/').getFlag('features','welcome')" class="sxytpl-welcome">
      <salaxy-welcome settings-by-proxy="false"></salaxy-welcome>
    </section>
    <section ng-if="$ctrl.getRoute('#/').getFlag('features', 'messages')" class="sxytpl-list">
      <div>
        <h3 class="section-title list-title">Toimenpiteitä odottavat...</h3>
        <salaxy-message-thread-list limit-to="10" read-only="$ctrl.route.node.newMessageThreadDisabled"></salaxy-message-thread-list>
      </div>
    </section>
    <section ng-if="$ctrl.getRoute('#/').getFlag('features', 'workerList')" class="sxytpl-list">
      <salaxy-employment-list limit-to="10" read-only="$ctrl.route.node.newCalcDisabled"></salaxy-employment-list>
    </section>
  </div>
  <section ng-if="$ctrl.getRoute('#/').getFlag('features', 'contact')" class="sxytpl-contact-info">
    <p>&nbsp;</p>
    <salaxy-contact-info hide-contact-info="'contactInfoComponent.hideContactInfo' | sxyIsInRole"></salaxy-contact-info>
  </section>
  <p>&nbsp;</p>
  <p>&nbsp;</p>

  <p class="copyright-text"><small sxy-text="SALAXY.NG1_Pages.Home.copyRight"></small> <small class="copyright-year">{{$ctrl.getCurrentYear()}}</small></p>

</main>`), s.put("salaxy-components/pages/household-years/active.html", `
<div ng-controller="HouseholdYearCrudController as $ctrl" ng-init="$ctrl.setActiveYear()">
  <salaxy-household-year-details  model="$ctrl" ></salaxy-household-year-details>
</div>`), s.put("salaxy-components/pages/household-years/details.html", `<salaxy-household-year-details model="'url'" ></salaxy-household-year-details>`), s.put("salaxy-components/pages/household-years/index.html", "<salaxy-household-year-list></salaxy-household-year-list>"), s.put("salaxy-components/pages/info/abc.html", `<div class="row">
  <div class="col-12">
    <h3>Käyttöohjeet</h3>
    <p class="">
      Ohjelman käyttöohjeet löytyvät tukisivustolta osoitteesta <a href="https://help.palkkaus.fi/hc/fi" target="_blank">help.palkkaus.fi</a>.
    </p>
    <p>Pääset ohjeisiin myös oikean alakulman Apua-napin kautta. Kirjoita hakusana hakukenttään niin saat listauksen siihen liittyvistä ohjeista. Voit siirtyä tukisivustolle ohjeen yläkulmassa olevan nuoli-ikonin kautta. Jos et löydä sopivaa ohjetta, voit
      olla yhteydessä asiakaspalveluumme Apua-napin kautta, sähköpostitse tai puhelimitse, niin autamme sinua!
    </p>
  </div>

</div>`), s.put("salaxy-components/pages/info/index.html", `<div class="row mb-4">
  <div class="col-12">
    <h1 sxy-text="SALAXY.NG1_Pages.Info.instructions"></h1>
    <p class="" sxy-html="SALAXY.NG1_Pages.Info.infoText.html"></p>
    <p sxy-text="SALAXY.NG1_Pages.Info.infoText.info"></p>
  </div>

  <div class="col-12" ng-if="!$ctrl.route.node.hideButtons">
    <span sxy-html="SALAXY.NG1_Pages.Info.buttons.web.html"></span>
    <span sxy-html="SALAXY.NG1_Pages.Info.buttons.dataProtection.html"></span>
    <span sxy-html="SALAXY.NG1_Pages.Info.buttons.termsOfService.html"></span>
  </div>
</div>
<div class="row" ng-if="!$ctrl.route.node.hideContactInfo">
  <div class="col-12">
    <h2 sxy-text="SALAXY.NG1_Pages.Info.customerService.title"></h2>
  </div>
  <div class="col-12">

    <salaxy-contact-info hide-contact-info="'contactInfoComponent.hideContactInfo' | sxyIsInRole"></salaxy-contact-info>
  </div>
</div>`), s.put("salaxy-components/pages/invoices/company.html", `<main class="salaxy-content sxytpl-company-invoices">
  <section>  
    <salaxy-company-invoices></salaxy-company-invoices>
  </section>
</main>`), s.put("salaxy-components/pages/invoices/details.html", `<main class="salaxy-content sxytpl-invoice-details">

  <style>
    @media print {
      /*Move to less*/
      .nav-tabs,
      #launcher {
        display: none;
      }
    }
  </style>
  <section ng-controller="InvoiceCrudController as $invoice" ng-init="$invoice.model = 'url'">
    <salaxy-tab-buttons
      current-tab="$ctrl.currentTab"
      options="[
        { value: 'default', text: 'SALAXY.NG1_Pages.Invoices.preview', hidden: !$ctrl.route.getFlag('features', 'preview') },
        { value: 'calc', text: 'SALAXY.NG1_Pages.Invoices.calcs', hidden: !($invoice.current && $ctrl.route.getFlag('features', 'calc') && ($invoice.current.header.type == 'foreclosure' || $invoice.current.header.type == 'net' || $invoice.current.header.type == 'gross') && $invoice.getReportCalcs().length) },
        { value: 'printandbarcode', text: 'SALAXY.NG1_Pages.Invoices.printAndBarCode', hidden: !$ctrl.route.getFlag('features', 'printAndBarCode') },
        { value: 'actions', text: 'SALAXY.NG1_Pages.Invoices.actions', hidden: !(('test' | sxyIsInRole ) && ( $invoice.current.header.channel == 'palkkausWS' ||  $invoice.current.header.channel == 'palkkausPSD') || $ctrl.route.getFlag('features', 'actions')) },
        { value: 'debug', text: 'Debug', hidden: !('test' | sxyIsInRole) }
      ]"
      tabs-id="invoicesDetails">
    </salaxy-tab-buttons>
    <div class="tab-content" id="tab-content-invoicesDetails">
      <div class="tab-pane" id="default-tab">
        <salaxy-invoice-preview model="$invoice" ng-if="$ctrl.route.getFlag('features', 'preview')"></salaxy-invoice-preview>
      </div>
      <div class="tab-pane" id="calc-tab">
        <salaxy-calc-reports calcs="$invoice.getReportCalcs()" report-type="'salarySlip'" ng-if="$invoice.current && $ctrl.route.getFlag('features', 'calc') && ($invoice.current.header.type == 'foreclosure' || $invoice.current.header.type == 'net' || $invoice.current.header.type == 'gross') && $invoice.getReportCalcs().length"></salaxy-calc-reports>
      </div>
      <div class="tab-pane" id="printandbarcode-tab">
        <div ng-if="$ctrl.route.getFlag('features', 'printAndBarCode')">
          <p class="lead">
            <button type="button" class="btn btn-primary float-end" onclick="window.print()" sxy-text="SALAXY.NG1.PalkkausPersonalPaymentOverviewComponent.printInvoices"></button>
          </p>
          <div class="credit-transfer-container" ng-if="$invoice.current">
            <salaxy-credit-transfer invoice="$invoice.current"></salaxy-credit-transfer>
          </div>
        </div>
      </div>
      <div class='tab-pane' id='actions-tab'>
        <salaxy-invoice-edit model="$invoice" ng-if="('test' | sxyIsInRole ) && ( $invoice.current.header.channel == 'palkkausWS' ||  $invoice.current.header.channel == 'palkkausPSD') || $ctrl.route.getFlag('features', 'actions')"></salaxy-invoice-edit>
      </div>
      <div class="tab-pane" id="debug-tab">
        <p ng-if="'test' | sxyIsInRole">
          <span class="badge bg-primary">test</span> Debug-toiminnot vain testissä.
        </p>
        <salaxy-json-formatter json="$invoice.current" open="1"></salaxy-json-formatter>
      </div>
    </div>
  </section>
</main>`), s.put("salaxy-components/pages/invoices/index.html", `<main class="salaxy-content sxytpl-invoices-list">
  <section>  
    <salaxy-invoice-list ng-if="'!person' | sxyIsInRole"></salaxy-invoice-list>
    <salaxy-invoice-list ng-if="'person' | sxyIsInRole" mode="person"></salaxy-invoice-list>
  </section>
</main>`), s.put("salaxy-components/pages/invoices/payment-list.html", `<main class="salaxy-content sxytpl-payment-list">
  <section>  
    <salaxy-invoice-payment-list></salaxy-invoice-payment-list>
  </section>
</main>`), s.put("salaxy-components/pages/invoices/sepa.html", `<main class="salaxy-content sxytpl-invoices-list">
  <section>  
    <salaxy-invoice-list mode="sepa"></salaxy-invoice-list>
  </section>
</main>`), s.put("salaxy-components/pages/irepr/details.html", `<main class="salaxy-content sxytpl-ir-earnings-payment">
  <section>
    <salaxy-ir-earnings-payment model="'url'"></salaxy-ir-earnings-payment>
  </section>
</main>
`), s.put("salaxy-components/pages/irepr/index.html", `<main class="salaxy-content sxytpl-ir-earnings-payment-list">
  <section>
    <salaxy-ir-earnings-payment-list></salaxy-ir-earnings-payment-list>
  </section>
</main>
 
 `), s.put("salaxy-components/pages/irpsr/details.html", `<main class="salaxy-content sxytpl-ir-payer-summary">
  <section>
    <salaxy-ir-payer-summary model="'url'"></salaxy-ir-payer-summary>
  </section>
</main>`), s.put("salaxy-components/pages/irpsr/index.html", `<main class="salaxy-content sxytpl-ir-payer-summary-list">
  <section>
    <salaxy-ir-payer-summary-list></salaxy-ir-payer-summary-list>
  </section>
</main>`), s.put("salaxy-components/pages/messages/approval-list.html", `<div>
  <div class="btn-toolbar">
    <div class="btn-group">
      <button type="button" class="btn btn-default"
        ng-click="$ctrl.$odata.options.$filter = 'status eq \\'active\\'';$ctrl.$odata.searchChanged()"
        ng-class="{ active: $ctrl.$odata.options.$filter != null }">Aktiiviset</button>
      <button type="button" class="btn btn-default"
        ng-click="$ctrl.$odata.options.$filter = null;$ctrl.$odata.searchChanged()"
        ng-class="{ active: $ctrl.$odata.options.$filter == null }">Kaikki</button>
    </div>
  </div>
  <salaxy-odata-table crud-controller="MessageThreadCrudController as $crud" ng-ref="$ctrl.$odata"
    options="{ $filter: 'status eq \\'active\\'' }"
    template-url="salaxy-components/odata/lists/MessageThreadsApproval.html"></salaxy-odata-table>
</div>`), s.put("salaxy-components/pages/messages/approval.html", `<main class="salaxy-content sxytpl-messages-details">
  <section>
    <h3>Hyväksy / hylkää aineisto</h3>
    <main>
      <div ng-controller="MessageThreadCrudController as $ctrl" ng-init="$ctrl.createCalc=true;$ctrl.model = 'url'">
        <div class="row">
          <div class="col-sm-4">
            <div class="btn-toolbar" role="toolbar" aria-label="Incoming message toolbar">
              <div class="btn-group" role="group" aria-label="Approval toolbar">
                <button type="button" class="btn btn-success" ng-click="$ctrl.current.status = 'approved';$ctrl.save()"
                  ng-disabled="$ctrl.current.status == 'approved'">Hyväksy</button>
                <button type="button" class="btn btn-danger" ng-click="$ctrl.current.status = 'rejected';$ctrl.save()"
                  ng-disabled="$ctrl.current.status == 'rejected'">Hylkää</button>
              </div>
              <div class="btn-group" role="group" aria-label="Update toolbar">
                <button type="button" class="btn btn-primary" ng-click="$ctrl.save()">Tallenna</button>
              </div>
            </div>
            <div ng-switch="$ctrl.current.usecase.data.protoId">
              <div ng-switch-when="timer">
                <salaxy-timer ng-if="$ctrl.current" timer-mode="edit" parent="$ctrl.current" crud-controller="$ctrl"></salaxy-timer>
              </div>
              <div ng-switch-when="hourlyReport">
                <salaxy-hourly-report ng-if="$ctrl.current" parent="$ctrl.current" report-type="$ctrl.current.usecase.data.protoId" crud-controller="$ctrl"></salaxy-hourly-report>
              </div>
              <div ng-switch-when="timeReport">
                <salaxy-hourly-report ng-if="$ctrl.current" parent="$ctrl.current" report-type="$ctrl.current.usecase.data.protoId" crud-controller="$ctrl"></salaxy-hourly-report>
              </div>
              <div ng-switch-when="absence">
                <salaxy-absence-periods ng-if="$ctrl.current" parent="$ctrl.getMessage().contentData" condensed="true"></salaxy-absence-periods>
              </div>
              <div ng-switch-when="annualLeave">
                <salaxy-holiday-year-holidays ng-if="$ctrl.current" parent="$ctrl.getMessage().contentData" condensed="true"></salaxy-holiday-year-holidays>
              </div>
              <div ng-switch-when="calcRow">
                <salaxy-calc-rows-editor ng-if="$ctrl.current" parent="$ctrl.getMessage().contentData">
                </salaxy-calc-rows-editor>
              </div>
              <div ng-switch-when="expense">
                <salaxy-expense-report ng-if="$ctrl.current" parent="$ctrl.current" report-type="$ctrl.current.usecase.data.protoId" crud-controller="$ctrl">
                </salaxy-expense-report>
              </div>
              <div ng-switch-when="travel">
                <salaxy-expense-report ng-if="$ctrl.current" parent="$ctrl.current" report-type="$ctrl.current.usecase.data.protoId" crud-controller="$ctrl">
                </salaxy-expense-report>
              </div>
              <div ng-switch-when="default">
                <div ng-if="$ctrl.isNew()">
                  <h2>Temp UI: This will be replaced!</h2>
                  <salaxy-input name="title" label="SALAXY.NG1.MessageThreadComponent.title" require="true" ng-model="$ctrl.current.title"></salaxy-input>
                  <button type="button" class="btn btn-primary" ng-click="$ctrl.save()">
                    <span sxy-text="SALAXY.UI_Terms.save"></span>
                  </button>
                  <hr />
                </div>
                <div class="messages-container" ng-if="$ctrl.current.messages && !$ctrl.isNew()">
                  <h2>{{ $ctrl.current.title }}</h2>
                  <div ng-repeat="item in $ctrl.current.messages" ng-switch="item.fromParty">
                    <div ng-switch-when="owner,undefined" ng-switch-when-separator=",">
                      <salaxy-avatar avatar="$ctrl.current.ownerInfo" class="float-start"></salaxy-avatar>
                      <div class="message-bubble left" ng-class="{ 'in-edit': $ctrl.isInEdit, 'unread': !$ctrl.getReadTime(item)  }">
                        <ng-include src="'salaxy-components/communications/messages/MessageContent.html'"></ng-include>
                        <span class="updated-at">{{ item.time | sxyTime }}, {{ $ctrl.getReadTime(item) ? (('SALAXY.NG1.MessageThreadComponent.read' |sxyTranslate) + ' ' +
                          ($ctrl.getReadTime(item) | sxyTime)) : ('SALAXY.NG1.MessageThreadComponent.unread' |sxyTranslate) }}</span>
                      </div>
                    </div>
                    <div ng-switch-when="otherParty" class="text-end">
                      <salaxy-avatar avatar="$ctrl.current.otherPartyInfo" class="float-end"></salaxy-avatar>
                      <div class="message-bubble right {{item.type}}" ng-class="{ 'in-edit': $ctrl.isInEdit, 'unread': !$ctrl.getReadTime(item) }">
                        <ng-include src="'salaxy-components/communications/messages/MessageContent.html'"></ng-include>
                        <span class="updated-at" ng-if="item.type != 'email'">{{ item.time | sxyTime }}, {{ $ctrl.getReadTime(item) ? (('SALAXY.NG1.MessageThreadComponent.read'
                          |sxyTranslate) + ' ' + ($ctrl.getReadTime(item) | sxyTime)) : ('SALAXY.NG1.MessageThreadComponent.unread' |sxyTranslate)}}</span>
                        <span class="updated-at" ng-if="item.type == 'email'">{{ item.time | sxyTime }}</span>
                      </div>
                    </div>
                    <div ng-switch-default class="alert alert-danger">
                      <ng-include src="'salaxy-components/communications/MessageThread_MessageContent.html'"></ng-include>
                    </div>
                  </div>
                  <div>
                    <div ng-if="$ctrl.isReadOnly" class="alert alert-info">
                      <p><strong>Työnantaja on merkinnyt viestiketjun käsitellyksi.</strong></p>
                    </div>
                    <div class="row">
                      <div class="col-8 col-sm-9">
                        <textarea placeholder="{{'SALAXY.NG1.MessageThreadComponent.writeOrPaste' |sxyTranslate}}" ng-model="$ctrl.newMessage.content"></textarea>
                      </div>
                      <div class="col-4 col-sm-3">
                        <button type="button" class="btn btn-primary btn-labeled-left" style="width: 100%; text-align: left; margin-bottom: 4px" ng-click="$ctrl.sendMessage()"
                          ng-disabled="!$ctrl.newMessage.content">
                          <i class="bi bi-send-fill"></i>
                          <span sxy-text="SALAXY.UI_Terms.send"></span>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div id="messageContainerBottom">&nbsp;</div>
                </div>
              </div>
              <div ng-switch-default>
                TODO: Handle {{ $ctrl.current.usecase.uri }} / {{ $ctrl.current.usecase.data.protoId }}.
              </div>
            </div>
          </div>
          <div class="col-sm-8">
            <div class="btn-toolbar" role="toolbar" aria-label="Calculator toolbar">
              <div class="btn-group" role="group" aria-label="Update">
                <button type="button" class="btn btn-default" ng-click="$ctrl.updateCalc()">Päivitä rivit</button>
                <button type="button" class="btn btn-default" ng-click="$ctrl.recalculate()">Laske uudelleen</button>
              </div>
              <div class="btn-group" role="group" aria-label="Select calc / payroll">
                <button type="button" class="btn btn-default">Valitse palkkalista...</button>
                <button type="button" class="btn btn-default" ng-click="$ctrl.selectCalc()">...laskelma</button>
              </div>
              <div class="btn-group" role="group" aria-label="Process calculation">
                <button type="button" class="btn btn-default" ng-click="$ctrl.saveCalc()">Tallenna</button>
                <a ng-href="#/calc/details/{{ $ctrl.calc.id }}" ng-disabled="!$ctrl.calc.id" class="btn btn-default">Siirry laskelmaan</a>
              </div>
            </div>
            <salaxy-calc-rows-2019-editor parent="$ctrl.calc" mode="edit" title="Laskelman rivit"></salaxy-calc-rows-2019-editor>
            <div ng-if="$ctrl.calc.result.totals">
              <salaxy-calc-reports calcs="[$ctrl.calc]" report-type="'salarySlip'"></salaxy-calc-reports>
            </div>
          </div>
        </div>
      </div>
    </main>
  </section>
</main>`), s.put("salaxy-components/pages/messages/details-partner.html", `<main class="salaxy-content sxytpl-messages-details" ng-init="$ctrl.role = 'otherParty'">
  <section>
    <div class="container" ng-controller="SessionController as $sessionCtrl">
      <div ng-controller="MessageThreadCrudController as $msg" ng-init="$msg.model = 'url'">
        <salaxy-message-thread model="$msg" role="{{ $ctrl.role }}" other-party="$sessionCtrl.session.settings.partner.accountId" other-party-options="{ [$sessionCtrl.session.settings.partner.accountId]: $sessionCtrl.session.settings.partner.info.avatar.displayName }">
          <header-new>
            <h3 sxy-text="SALAXY.PRO_Pages.messages.details.newMessage"></h3>
            {{"SALAXY.PRO_Pages.messages.details.partner" | sxyTranslate}}: {{$sessionCtrl.session.settings.partner.info.avatar.displayName}}<br />
            <salaxy-input name="owner" label="SALAXY.PRO_Pages.messages.details.company" ng-model="$sessionCtrl.session.currentAccount.avatar.displayName" disabled="true"></salaxy-input>
          </header-new>
          <header>
            <h2 class="d-flex justify-content-between">
              <div>{{ $msg.current.ownerWorkflow.salaryDate | sxyDate }}</div>
              <div>{{ $msg.current.title }}</div>
            </h2>
            <div class="row">
              <div class="col-sm-6 d-flex">
                <salaxy-avatar avatar="$sessionCtrl.session.currentAccount.avatar" class=""></salaxy-avatar>
                <div class="ms-3">
                  <h3>{{ $sessionCtrl.session.currentAccount.avatar.displayName }}</h3>
                  <code>{{ $sessionCtrl.session.currentAccount.avatar.id | sxyIban }}</code><br />
                  <a href="mailto:{{ $sessionCtrl.session.currentAccount.contact.email }}">{{ $sessionCtrl.session.currentAccount.contact.email }}</a><br /> {{'SALAXY.PRO_Pages.messages.details.phone' | sxyTranslate}}: {{ $sessionCtrl.session.currentAccount.contact.telephone || "-" }}
                </div>
              </div>
              <div class="col-sm-6">
                <h3>{{ $sessionCtrl.session.currentAccount.identity.contract.authorizedBy.name || ('SALAXY.PRO_Pages.messages.details.noContactPerson' | sxyTranslate) }}</h3>
                <p>
                  <a href="mailto:{{ $sessionCtrl.session.currentAccount.identity.contract.authorizedBy.email }}">{{ $sessionCtrl.session.currentAccount.identity.contract.authorizedBy.email }}</a><br /> {{'SALAXY.PRO_Pages.messages.details.phone' | sxyTranslate}}: {{ $sessionCtrl.session.currentAccount.identity.contract.authorizedBy.telephone
                  || "-" }}<br /> {{ $sessionCtrl.session.currentAccount.identity.contract.isSigned ? ('SALAXY.PRO_Pages.messages.details.signed' | sxyTranslate) + ' ' + ($sessionCtrl.session.currentAccount.identity.contract.signedAt | sxyTime) : ('SALAXY.PRO_Pages.messages.details.notSigned' |
                  sxyTranslate) }}
                </p>
              </div>
            </div>
            <hr />
          </header>
        </salaxy-message-thread>
      </div>
    </div>
  </section>
</main>`), s.put("salaxy-components/pages/messages/details.html", `<main class="salaxy-content sxytpl-messages-details">
  <section>
    <salaxy-assure-partner>
      <main>
        <salaxy-message-thread model="'url'" role="owner" other-party="'partner'" mark-as-read="5">
          <header-new>
            <h2 sxy-text="SALAXY.NG1_Pages.Messages.newMessageDetails.title"></h2>
            <p class="lead" sxy-html="SALAXY.NG1_Pages.Messages.newMessageDetails.description.html"></p>
          </header-new>
        </salaxy-message-thread>
      </main>
    </salaxy-assure-partner>
  </section>
</main>`), s.put("salaxy-components/pages/messages/index.html", `<main class="salaxy-content sxytpl-message-thread-list">
  <section>
    <salaxy-message-thread-list read-only="$ctrl.route.readOnly"></salaxy-message-thread-list>
  </section>
</main>`), s.put("salaxy-components/pages/messages/omapalkka.html", `<div ng-controller="OmapalkkaController as $ctrl">
  <iframe ng-if="$ctrl.url" ng-src="{{$ctrl.url}}" style="width: 100%; height: calc(100vh - 180px); margin-bottom: -100px; border: 0;"></iframe>
</div>`), s.put("salaxy-components/pages/partners/assure-worker-account.html", `<main class="salaxy-content sxytpl-partners-worker-assure">
    <section>
        <salaxy-worker-assure></salaxy-worker-assure>
    </section>
</main>`), s.put("salaxy-components/pages/payment-channel/details.html", `<main class="salaxy-content sxytpl-invoices-list">
  <section ng-controller="PaymentChannelController as $ctrl" ng-init="$ctrl.model = 'url'">
    <div ng-if="$ctrl.channel">
      <salaxy-avatar class="salaxy-calc-row-type-avatar salaxy-input-enum-avatar float-start" avatar="$ctrl.getChannelAvatar()"></salaxy-avatar>
      <div class="salaxy-input-enum-text"><strong>{{"PaymentChannel." + $ctrl.channel | sxyEnum}}</strong></div>
      <div class="salaxy-input-enum-title">{{ "PaymentChannel." + $ctrl.channel | sxyEnumDescr }}</div>
      <salaxy-tab-buttons
        current-tab="$ctrl.currentTab"
        options="[
          { value: 'default', text: 'Esikatselu' },
          { value: 'status', text: 'Tilan päivitys', hidden: !('test' | sxyIsInRole) },
          { value: 'edit', text: 'Laskun muokkaus', hidden: !('test' | sxyIsInRole) },
          { value: 'debug', text: 'Debug', hidden: !('test' | sxyIsInRole) }
        ]"
        tabs-id="paymentChannelDetails">
      </salaxy-tab-buttons>
      <div class="tab-content" id="tab-content-paymentChannelDetails">
        <div class="tab-pane" id="default-tab">
          <salaxy-spinner ng-if="!$ctrl.current && $ctrl.isLoading"></salaxy-spinner>
          <salaxy-payment-channel-invoice-preview ng-if="$ctrl.current" model="$ctrl"></salaxy-payment-channel-invoice-preview>
        </div>
        <div class="tab-pane" id="status-tab" ng-if="'test' | sxyIsInRole">
          <div class="alert alert-danger" ng-if="!$ctrl.isLoading && !$ctrl.current">Laskua ei löydy</div>
            <form ng-if="$ctrl.current" ng-submit="$ctrl.updateStatus()">
              <div class="form-horizontal" ng-init="$ctrl.resetStatusData()">
                <h2>Päivitä tila</h2>
                <p>Testilomake tilan päivitykseen. Alta voit myös poistaa laskun.</p>
                <salaxy-input name="statusId" ng-model="$ctrl.statusData.id" label="Id" disabled="true"></salaxy-input>
                <salaxy-input name="statusExternalId" ng-model="$ctrl.statusData.externalId" label="ID maksukanavassa"></salaxy-input>
                <salaxy-input-enum label="Maksun tila" name="statusStatus" ng-model="$ctrl.statusData.status" enum="InvoiceStatus" required></salaxy-input-enum>
                <salaxy-datepicker-popup name="statusDate" ng-model="$ctrl.statusData.date" label="Maksupäivä"></salaxy-datepicker-popup>
                <salaxy-input-number name="statusAmount" ng-model="$ctrl.statusData.amount" label="Maksettu summa"></salaxy-input-number>
                <salaxy-input name="statusReceiverFullName" ng-model="$ctrl.statusData.receiverFullName" label="Vastaanottajan nimi"></salaxy-input>
                <salaxy-input name="statusReceiverIban" ng-model="$ctrl.statusData.receiverIban" label="Vastaanottajan tilinumero"></salaxy-input>
                <salaxy-input name="statusReferenceNumber" ng-model="$ctrl.statusData.referenceNumber" label="Viitenumero"></salaxy-input>
              </div>
              <div>
                <button type="submit" class="btn btn-primary float-end">Päivitä tila</button>
                <button type="button" ng-click="$ctrl.delete()" class="btn btn-danger">Poista lasku</button>
              </div>
            </form>
        </div>
        <div class="tab-pane" id="edit-tab" ng-if="'test' | sxyIsInRole">
          <div class="alert alert-danger" ng-if="!$ctrl.isLoading && !$ctrl.current">Laskua ei löydy</div>
            <form ng-if="$ctrl.current" ng-submit="$ctrl.save()">
              <div class="form-horizontal">
                <h2>Muokkaa laskua</h2>
                <p>Testilomake laskun muokkaukseen. Alta voit myös poistaa laskun.</p>
                <salaxy-datepicker-popup name="date" ng-model="$ctrl.current.header.date" label="Laskun päivä"></salaxy-datepicker-popup>
                <salaxy-datepicker-popup name="dueDate" ng-model="$ctrl.current.header.dueDate" label="Eräpäivä"></salaxy-datepicker-popup>
                <salaxy-datepicker-popup name="logicalDate" ng-model="$ctrl.current.header.logicalDate" label="Looginen päivä"></salaxy-datepicker-popup>
                <salaxy-input name="message" ng-model="$ctrl.current.header.message" label="Viesti"></salaxy-input>
              </div>
              <div>
                <button type="submit" class="btn btn-primary float-end">Tallenna</button>
                <button type="button" ng-click="$ctrl.delete()" class="btn btn-danger">Poista lasku</button>
              </div>
            </form>
        </div>
        <div class="tab-pane" id="debug-tab" ng-if="'test' | sxyIsInRole">
          <salaxy-json-formatter  ng-if="$ctrl.current" json="$ctrl.current" open="1"></salaxy-json-formatter>
        </div>
      </div>
    </div>
    <div ng-if="!$ctrl.channel && !$ctrl.isLoading">
      <div class="alert alert-danger">Käyttäjätilillä ei ole omaa maksukanavaa</div>
    </div>
  </section>
</main>`), s.put("salaxy-components/pages/payment-channel/index.html", `<main class="salaxy-content sxytpl-payment-channel">
  <section ng-controller="PaymentChannelController as $ctrl">
    <div ng-if="$ctrl.channel">
      <salaxy-avatar class="salaxy-calc-row-type-avatar salaxy-input-enum-avatar float-start" avatar="$ctrl.getChannelAvatar()"></salaxy-avatar>
      <div class="salaxy-input-enum-text"><strong>{{"PaymentChannel." + $ctrl.channel | sxyEnum}}</strong></div>
      <div class="salaxy-input-enum-title">{{ "PaymentChannel." + $ctrl.channel | sxyEnumDescr }}</div>
      <salaxy-tab-buttons
        current-tab="$ctrl.currentTab"
        options="[
          { value: 'odata', text: 'All items' },
          { value: 'fulldata', text: 'Unread items' },
        ]"
        tabs-id="paymentChannelIndex">
      </salaxy-tab-buttons>
      <div class="tab-content" id="tab-content-paymentChannelIndex">
        <div class="tab-pane" id="odata-tab">
          <salaxy-odata-table crud-controller="PaymentChannelController as $crud" options="{ $orderby: 'endAt desc'}" template-url="salaxy-components/odata/lists/InvoicesPaymentChannel.html"></salaxy-odata-table>
        </div>
        <div class="tab-pane" id="fulldata-tab">
          <div>
            <table class="table">
              <thead>
                <tr>
                  <th colspan="2">Payer</th>
                  <th colspan="2">
                    Receiver<br /> Payment type
                  </th>
                  <th class="right">
                    Date<br /> Due date
                  </th>
                  <th class="right">
                    Created<br /> Updated
                  </th>
                  <th class="right">Payment</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr ng-repeat="item in $ctrl.unreadInvoices">
                  <td class="td-avatar middle">
                    <salaxy-avatar class="salaxy-calc-row-type-avatar" avatar="item.payer.avatar"></salaxy-avatar>
                  </td>
                  <td class="middle">
                    {{ item.payer.avatar.displayName }}<br>
                    <small class="hidden-xxs">{{ item.payer.officialId }}, {{ item.payer.partnerKey }}</small>
                  </td class="middle">
                  <td class="td-avatar middle">
                    <salaxy-avatar class="salaxy-calc-row-type-avatar" avatar="item.recipient.beneficiary.avatar"></salaxy-avatar>
                  </td>
                  <td class="middle">
                    {{ item.recipient.beneficiary.avatar.displayName }}<br>
                    <small class="hidden-xxs">{{ item.header.message }}</small>
                  </td class="middle">
                  <td class="middle right">
                    {{ item.header.date | sxyDate }}<br /> {{ item.header.dueDate | sxyDate }}
                  </td>
                  <td class="right">
                    {{ item.createdAt | sxyDate }}<br /> {{ item.updatedAt | sxyDate }}
                  </td>
                  <td class="middle right">
                    {{ item.header.total | currency }}
                  </td>
                  <td class="middle right">
                    <a ng-href="#{{$ctrl.getDefaults().detailsUrl}}{{ item.id }}" class="btn btn-primary">
                      {{ 'SALAXY.UI_Terms.show' | sxyTranslate}}
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div ng-if="!$ctrl.channel">
      <div class="alert alert-danger">Käyttäjätilillä ei ole omaa maksukanavaa</div>
    </div>
  </section>
</main>`), s.put("salaxy-components/pages/payroll/details.html", `<main class="salaxy-content sxytpl-calculations-payroll-edit">
  <div ng-if="$ctrl.newPayrollVersion.show" class="d-none d-md-block salaxy-payroll-v4 form-horizontal">
    <salaxy-input-boolean name="newPayrollSwitch" type="switch" ng-model="$ctrl.newPayrollVersionUse" label="SALAXY.NG1.PayrollComponent.newVersion" label-cols="col-7" label-true="on" label-false="off"></salaxy-input-boolean>
  </div>
  <section ng-if="$ctrl.newPayrollVersion.use">
    <!-- Switching isFullWidth as long as the two UI are in same URL. -->
    <div style="display: none;" ng-init="$ctrl.current.isFullWidth = true"></div>
    <salaxy-payroll-details model="'url'" is-read-only-forced="$ctrl.route.readOnly" actions="$ctrl.route.getParam('actions')"></salaxy-payroll-details>
  </section>
  <section ng-if="!$ctrl.newPayrollVersion.use">
    <div style="display: none;" ng-init="$ctrl.current.isFullWidth = false"></div>
    <salaxy-payroll-edit model="'url'" is-read-only-forced="$ctrl.route.readOnly"
      actions="$ctrl.route.getParam('actions')"></salaxy-payroll-edit>
  </section>
</main>`), s.put("salaxy-components/pages/payroll/import.html", `<main class="salaxy-content sxytpl-calculations-payroll-import">
  <section>
    <div ng-controller="SalaryBasesController as $ctrl">
      <div ng-if="!$ctrl.datasets" class="container">
        <salaxy-spinner title="Ladataan määrittelyjä..."></salaxy-spinner>
      </div>
      <div ng-if="$ctrl.datasets && !$ctrl.datasets.length" class="alert alert-danger container">  
        <strong>BETA:</strong>
        Tietojen tuonti (import) on rajoitetussa testauksessa PRO-palvelussa ja tuodaan tuotantoon syksyllä.
        Kysy asiakaspalvelusta lisätietoja ennen kuin käytät tätä toimintoa.
      </div>
      <div ng-if="$ctrl.datasets.length && !$ctrl.dataset" class="container">
        <h3>Valitse Import-tyyppi</h3>
        <div style="max-width: 600px;">
          <label ng-repeat="ds in $ctrl.datasets" class="btn btn-block btn-default" ng-click="$ctrl.loadDataset(ds)">{{ ds.shortText }}</label>
        </div>
      </div>
      <div ng-if="$ctrl.dataset">
        <div class="btn-toolbar">
          <div class="btn-group">
            <button type="button" class="btn btn-default" ng-click="$ctrl.getEmployments()">1. Hae työsuhteet</button>
            <button type="button" class="btn btn-default" ng-controller="ImportController as $import" ng-click="$import.showImport($ctrl.getImportable())">2. Lataa data</button>
            <button type="button" class="btn btn-default" ng-click="$ctrl.processImport()">3. Käsittele data (mapper)</button>
            <button type="button" class="btn btn-default" ng-click="$ctrl.saveToPayroll()">4. Tallenna palkkalistaan</button>
          </div>
        </div>
        <salaxy-tab-buttons
          ng-if="$ctrl.current"
          current-tab="$ctrl.currentTab"
          options="[
            { value: 'payroll', text: 'Palkkalista' },
            { value: 'employments', text: 'Työsuhteet' },
            { value: 'rowtypemapnew', text: 'Säännöt (rivityypit)' },
            { value: 'rows', text: 'Rivit' },
            { value: 'src', text: 'Debug' }
          ]"
          tabs-id="payrollImport">
        </salaxy-tab-buttons>
        <div class="tab-content" id="tab-content-payrollImport">
          <div class="tab-pane" id="payroll-tab">
            <salaxy-payroll-edit model="'url'" ng-ref="$ctrl.payrollController"></salaxy-payroll-edit>
          </div>
          <div class="tab-pane" id="employments-tab">
            <table class="table table-sm">
              <thead>
                <tr>
                  <th></th>
                  <th>
                    <div>Työntekijän nimi (Palkkaus.fi)</div>
                    <div><small>Työsuhteen tyyppi</small></div>
                  </th>
                  <th class="right">
                    <div>ID lähteessä</div>
                    <div>Tuntia / kk</div>
                  </th>
                  <th>Rivit</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr ng-repeat="emp in $ctrl.employments">
                  <td>
                    <salaxy-avatar style="font-size: 50px;" avatar="emp.personalInfo.avatar"></salaxy-avatar>
                  </td>
                  <td>
                    <div><strong>{{ emp.personalInfo.avatar.displayName }}</strong> ({{ emp.personalInfo.officialId }})</div>
                    <div><small>{{ emp.work.wageBasis }}</small></div>
                    <div><small>{{ emp.updatedAt }}</small></div>
                  </td>
                  <td class="right">
                    <div>{{ emp.info.sourceId || "-" }}</div>
                    <div ng-if="emp.work.monthlyHours"><strong>{{ emp.work.monthlyHours }}</strong></div>
                    <div ng-if="!emp.work.monthlyHours" class="text-muted">160</div>
                  </td>
                  <td>
                    <table class="table table-sm">
                      <tr ng-repeat="row in emp.work.salaryDefaults">
                        <td>{{ "CalculationRowType." + row.rowType | sxyEnum }}</td>
                        <td class="right">{{ row.count | number }} * {{ row.price ? (row.price | currency) : "-" }}</td>
                      </tr>
                    </table>                  
                  </td>
                  <td>
                    <button type="button" class="btn btn-default" ng-click="$ctrl.editEmployment(emp)">Muokkaa</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="tab-pane" id="rowtypemapnew-tab">
            <div class="btn-toolbar">
              <button type="button" class="btn btn-default" ng-click="$ctrl.save()">Tallenna</button>
            </div>
            <table class="table" ng-controller="CalcRows2019Controller as $rows" ng-init="$rows.rows=$ctrl.getRowTypeMapper()">
              <thead>
                <tr>
                  <th colspan="2">Lähdedata</th>
                  <th></th>
                  <th colspan="2">Kohde</th>
                </tr>
                <tr>
                  <th>Haku</th>
                  <th>RegEx</th>
                  <th>Toiminto</th>
                  <th>
                    <div>Palkkalaji (rowType)</div>
                    <div>Alalaji (kind)</div>
                  </th>
                  <th class="right">
                    <div>Hinta/kerroin</div>
                    <div>Määrä</div>
                  </th>
                  <th>Viesti palkkalaskelmaan</th>
                  <th>Kommentti</th>
                  <th>
                    <button type="button" class="btn btn-default" ng-click="$rows.showRowTypeSelectionDialog()">Luo uusi</button>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr ng-repeat="match in $rows.list">
                  <td ng-if="!match.$edit">{{ match.search }}</td>
                  <td ng-if="!match.$edit">{{ match.searchType }}</td>
                  <td ng-if="!match.$edit">{{ match.type }}</td>
  
                  <td ng-if="match.$edit"><salaxy-input name="searh{{ $index }}" label-type="plain" ng-model="match.search"></salaxy-input></td>
                  <td ng-if="match.$edit"><input type="checkbox" ng-checked="match.searchType == 'regExp'" ng-click="match.searchType = (match.searchType != 'regExp' ? 'regExp' : 'string')"></td>
                  <td ng-if="match.$edit">
                    <salaxy-input-enum options="$ctrl.matchTypes" name="type{{ $index }}" label-type="plain" ng-model="match.type"></salaxy-input-enum>
                  </td>
                  
                  <td>
                    <div>{{ match.rowType }}</div>
                    <div>{{ match.data.kind }}</div>
                  </td>
                  <td class="right">
                    <div>{{ match.price || "-" }}</div>
                    <div>{{ match.count || "-" }}</div>
                  </td>
                  <td>{{ match.message }}</td>
  
                  <td ng-if="!match.$edit">{{ match.comment }}</td>
                  <td ng-if="match.$edit"><salaxy-input name="comment{{ $index }}" label-type="plain" ng-model="match.comment"></salaxy-input></td>
  
                  <td>
                    <button type="button" class="btn btn-default" ng-disabled="!match.rowType" ng-click="match.rowIndex = $index;$rows.showEdit(match)"><i class="bi bi-list-task" aria-hidden="true"></i></button>
                    <button type="button" class="btn btn-primary" ng-click="match.$edit = !match.$edit"><i class="bi bi-pencil-fill" aria-hidden="true"></i></button>
                    <button type="button" class="btn btn-danger" ng-click="$rows.delete(match)"><i class="bi bi-trash-fill" aria-hidden="true"></i></button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="tab-pane" id="rows-tab">
            <table class="table table-sm">
              <thead>
                <tr>
                  <th></th>
                  <th colspan="2">Lähde</th>
                  <th colspan="2">Palkkaus.fi</th>
                  <th colspan="3"></th>
                </tr>
                <tr>
                  <th>Päivä</th>
                  <th>Henk. nro</th>
                  <th>Rivikoodi</th>
                  <th>Työntekijä</th>
                  <th>Palkkalaji</th>
                  <th>Alalaji</th>
                  <th class="right">Määrä</th>
                  <th class="right">Hinta</th>
                  <th class="right">Kustannusp.</th>
                </tr>
              </thead>
              <tbody>
                <tr ng-repeat="row in $ctrl.current.rows">
                  <td>{{ row.date | sxyDate }}</td>
                  <td>{{ row.srcEmploymentId }}</td>
                  <td>{{ row.srcRowTypeId }}</td>
                  <td>
                    <div ng-if="row.employment">
                      <salaxy-avatar style="font-size: 18px;" avatar="row.employment.personalInfo.avatar"></salaxy-avatar>
                      {{ row.employment.personalInfo.avatar.displayName }}
                    </div>
                    <div ng-if="!row.employment" class="text-danger">{{ row.employmentId || "Puuttuu!" }}</div>
                  </td>
                  <td>{{ ("CalculationRowType." + (row.rowType || "") | sxyEnum) || "-" }}</td>
                  <td>{{ row.data.kind || row.message }}</td>
                  <td class="right">{{ row.count | sxyCount }}</td>
                  <td class="right">{{ row.price ? (row.price | currency) : "-" }}</td>
                  <td class="right">{{ row.costCenter }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="tab-pane" id="src-tab">
            <salaxy-json-formatter json="$ctrl.getRowTypeMapper()" key="'Source'"></salaxy-json-formatter>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>`), s.put("salaxy-components/pages/payroll/index.html", `<main class="salaxy-content sxytpl-calculations-payroll">
  <div ng-if="$ctrl.newPayrollVersion.show" class="d-none d-md-flex salaxy-payroll-v4 form-horizontal d-flex justify-content-end">
    <salaxy-input-boolean name="newPayrollSwitch" type="switch" ng-model="$ctrl.newPayrollVersionUse" label="SALAXY.NG1.PayrollComponent.newVersion" label-cols="col-7" label-true="on" label-false="off"></salaxy-input-boolean>
  </div>
  <section class="sxytpl-intro d-none d-md-block" ng-if="$ctrl.newPayrollVersion.show">
    <h3 sxy-text="SALAXY.NG1.PayrollComponent.payrollVersions.header"></h3>
    <p sxy-html="SALAXY.NG1.PayrollComponent.payrollVersions.html"></p>
  </section>
  <section class="sxytpl-list" ng-if="$ctrl.newPayrollVersion.use">
    <salaxy-payroll-details-list  details-url="/payroll/details/" hide-button="$ctrl.route.readOnly" is-read-only-forced="$ctrl.route.readOnly"></salaxy-payroll-details-list>
  </section>
  <section class="sxytpl-list" ng-if="!$ctrl.newPayrollVersion.use">
    <salaxy-payroll-list  details-url="/payroll/details/" hide-button="$ctrl.route.readOnly" is-read-only-forced="$ctrl.route.readOnly"></salaxy-payroll-list>
  </section>
</main>`), s.put("salaxy-components/pages/reference-objects/details.html", `<main class="salaxy-content sxytpl-reference-object-details">
  <section>
    <!-- This should be a component -->
    <!--salaxy-reference-object model="'url'"></salaxy-reference-object -->

    <div class="salaxy-component salaxy-reference-object" ng-controller="ReferenceObjectCrudController as $ctrl" ng-init="$ctrl.model='url'">
      <div ng-if="$ctrl.current">
        <sxy-form open-api="salaxy-secure/schemas/v02.json" type="ReferenceObject" auto-gen="false" debugger="false" model="$ctrl.current">
          <div class="col-12">
            <fieldset>
              <legend>Header</legend>
              <sxy-input  model="form.header.status"></sxy-input>
              <sxy-input model="form.header.referenceDate"></sxy-input>
              <sxy-input model="form.header.description"></sxy-input>
            </fieldset>
            <fieldset>
              <legend>Events</legend>
              <sxy-input model="form.events">
                <form>
                  <fieldset>
                    <legend>Event</legend>
                    <sxy-input model="form.name" ></sxy-input>
                    <sxy-input model="form.date" ></sxy-input>
                    <sxy-input model="form.result" ></sxy-input>
                  </fieldset>
                </form>
              </sxy-input>
            </fieldset>
          </div>
        </sxy-form>
        <div class="row">
          <div class="col-12 text-end">
            <button class="btn btn-danger" ng-click="$ctrl.delete($ctrl.current)">Poista</button>
            <button class="btn btn-primary" ng-click="$ctrl.save()">Tallenna</button>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>`), s.put("salaxy-components/pages/reference-objects/index.html", `<main class="salaxy-content sxytpl-reference-object-list">
  <div class="text-end">
    <a class="btn btn-primary" ng-href="#{{$odata.$crudController.getDefaults().detailsUrl}}new" sxy-text="Uusi"></a>
  </div>
  
  <section>
    <div ng-show="$odata.items.length" class="salaxy-component salaxy-service-model-list">
      <salaxy-odata-table ng-ref="$odata" crud-controller="ReferenceObjectCrudController as $crud">
      </salaxy-odata-table>
    </div>
  </section>
</main>`), s.put("salaxy-components/pages/reports/absences.html", `<div ng-controller="WorkerAbsencesCrudController as $ctrl" ng-init="$ctrl.testYear=2021;$ctrl.getAbsences()">
  <h1 class="d-print-none" sxy-text="SALAXY.NG1_Pages.Reports.Absences.heading"></h1>
  <h2 class="d-none d-print-block">{{'SALAXY.NG1_Pages.Reports.Absences.heading' | sxyTranslate}} ({{ $ctrl.reportParams | sxyDateRange }})</h2>
  <div class="btn-toolbar d-print-none mb-3 mt-3" role="toolbar" aria-label="Calendar buttons">
    <div class="btn-group" role="group" aria-label="Views">
      <button type="button" class="btn btn-default" ng-class="{ active: !$ctrl.view || $ctrl.reportView == 'calendar' }" ng-click="$ctrl.view = 'calendar'" sxy-text="SALAXY.NG1_Pages.Reports.Absences.calendar"></button>
      <button type="button" class="btn btn-default" ng-class="{ active: $ctrl.view == 'list' }" ng-click="$ctrl.view = 'list'" sxy-text="SALAXY.NG1_Pages.Reports.Absences.list"></button>
    </div>
    <div class="btn-group ms-1" role="group" aria-label="Periods">
      <button type="button" class="btn btn-default" ng-class="{ active: !$ctrl.reportView || $ctrl.reportView == 'thisYear' }" ng-click="$ctrl.reportView = 'thisYear'" sxy-text="SALAXY.NG1_Pages.Reports.Absences.thisYear"></button>
      <button type="button" class="btn btn-default" ng-class="{ active: $ctrl.reportView == 'lastYear' }" ng-click="$ctrl.reportView = 'lastYear'" sxy-text="SALAXY.NG1_Pages.Reports.Absences.lastYear"></button>
      <button type="button" class="btn btn-default" ng-class="{ active: $ctrl.reportView == 'thisMonth' }" ng-click="$ctrl.reportView = 'thisMonth'" sxy-text="SALAXY.NG1_Pages.Reports.Absences.thisMonth"></button>
      <button type="button" class="btn btn-default" ng-class="{ active: $ctrl.reportView == 'lastMonth' }" ng-click="$ctrl.reportView = 'lastMonth'" sxy-text="SALAXY.NG1_Pages.Reports.Absences.lastMonth"></button>
    </div>
    <div class="d-flex ms-1" aria-label="{{'SALAXY.NG1_Pages.Reports.Absences.dates' | sxyTranslate}}">
        <salaxy-datepicker-popup ng-model="$ctrl.reportParams.start" name="start" label="SALAXY.NG1_Pages.Reports.Absences.dates" label-type="inline"></salaxy-datepicker-popup>
        <salaxy-datepicker-popup ng-model="$ctrl.reportParams.end" name="end" label="" label-type="no-label" class="ms-1 "></salaxy-datepicker-popup>
    </div>
    
    <div class="btn-group ms-1" role="group" aria-label="Actions">
      <button ng-click="$ctrl.showAddWorker()" class="btn btn-default" sxy-text="SALAXY.NG1_Pages.Reports.Absences.addWorker"></button>
    </div>
  </div>
  <salaxy-spinner ng-if="!$ctrl.allAbsences"></salaxy-spinner>
  <div ng-if="$ctrl.allAbsences.length === 0" sxy-text="SALAXY.NG1_Pages.Reports.Absences.employeeNoAnsences"></div>
  <div ng-if="$ctrl.allAbsences.length &gt; 0">
    <salaxy-absence-periods style="display: none;" ng-ref="$ctrl.$periodList" on-commit="$ctrl.saveAbsences(parent)"></salaxy-absence-periods>
    <div ng-if="$ctrl.view != 'list'">
      <salaxy-calendar on-list-select="type == 'series' ? $ctrl.showEditDialog(series.data) : null" data="$ctrl.allAbsences" mode="horizontal" mapper="$ctrl.mapToCalendar" list-controller="$ctrl.$periodList" start="$ctrl.reportParams.start" end="$ctrl.reportParams.end"></salaxy-calendar>
    </div>
    <div ng-if="$ctrl.view == 'list'">
      <table class="table">
        <thead>
          <tr>
            <th colspan="2">
              <span sxy-text="SALAXY.NG1_Other.Roles.worker"></span>
            </th>
            <th class="right">
              <span sxy-text="SALAXY.NG1_Pages.Reports.Absences.first"></span><br />
              <span sxy-text="SALAXY.NG1_Pages.Reports.Absences.latest"></span>
            </th>
            <th class="right">
              <div sxy-text="SALAXY.NG1_Pages.Reports.Absences.absencesPaid"></div>
              <div sxy-text="SALAXY.NG1_Pages.Reports.Absences.absencesUnpaid"></div>
            </th>
            <th class="right">
              <div sxy-text="SALAXY.NG1_Pages.Reports.Absences.absencesHolidayAccrual"></div>
              <div sxy-text="SALAXY.NG1_Pages.Reports.Absences.absencesNoHolidayAccrual"></div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="row in $ctrl.allAbsences">
            <td class="align-middle td-avatar clickable"  ng-click="$ctrl.showEditDialog(row)">
              <salaxy-avatar avatar="row.workerSnapshot"></salaxy-avatar>
            </td>
            <td class="td-name middle clickable"  ng-click="$ctrl.showEditDialog(row)">
              <div><strong>{{ row.workerSnapshot.displayName }}</strong></div>
              <div>{{ $ctrl.getPeriodCalculation(row, "length") }} {{'SALAXY.NG1_Pages.Reports.Absences.absence' | sxyTranslate}}, {{ $ctrl.getPeriodCalculation(row, "all") | sxyCount : "day" }}</div>
            </td>
            <td class="right">
              <div>{{ $ctrl.getPeriodCalculation(row, "firstPeriod") | sxyDateRange }}</div>
              <div>{{ $ctrl.getPeriodCalculation(row, "lastPeriod") | sxyDateRange }}</div>
            </td>
            <td class="right">
              <div>{{ $ctrl.getPeriodCalculation(row, "absencesPaid") | sxyCount : "day" }}</div>
              <div>{{ $ctrl.getPeriodCalculation(row, "absencesUnpaid") | sxyCount : "day" }}</div>
            </td>
            <td class="right">
              <div>{{ $ctrl.getPeriodCalculation(row, "absencesHolidayAccrual") | sxyCount : "day" }}</div>
              <div>{{ $ctrl.getPeriodCalculation(row, "absencesNoHolidayAccrual") | sxyCount : "day" }}</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>`), s.put("salaxy-components/pages/reports/accounting-legacy.html", `<main class="salaxy-content sxytpl-reports-accounting">
  <section class="sxytpl-intro">
    <p class="lead"> {{ 'SALAXY.NG1_Pages.Reports.accountingIntro' | sxyTranslate }}
    </p>
  </section>
  <section class="sxytpl-list">
    <h2>{{ 'SALAXY.NG1_Pages.Reports.accountingMonthly' | sxyTranslate }}</h2>
    <salaxy-report-list report-type="'monthlyDetails'"></salaxy-report-list>
    <salaxy-report-list report-type="'monthlyLiikekirjuri'"></salaxy-report-list>
  </section>
  <section class="sxytpl-list">
    <h2>{{ 'SALAXY.NG1_Pages.Reports.accountingYearly' | sxyTranslate }}</h2>
    <salaxy-report-list report-type="'yearlyDetails'"></salaxy-report-list>
  </section>
  <section class="sxytpl-list">
    <h2>{{ 'SALAXY.NG1_Sitemap.reports.archive' | sxyTranslate }}</h2>
    <a href="#/reports/archive-2018">{{ 'SALAXY.UI_Terms.show' | sxyTranslate }}...</a>
  </section>
</main>`), s.put("salaxy-components/pages/reports/accounting-row-report.html", `<main class="salaxy-content sxytpl-accounting-row-report">
  <section style="height: calc(100vh - 150px)">
    <salaxy-accounting-row-report template-id="'holidays'"></salaxy-accounting-row-report>
  </section>
</main>`), s.put("salaxy-components/pages/reports/ad-hoc-list.html", `<salaxy-odata-table crud-controller="UsecasesCrudController as $crud" options="{ $filter: 'entityType eq \\'dataset\\'' }" template-url="salaxy-components/odata/lists/UsecasesAdHocReport.html"></salaxy-odata-table>`), s.put("salaxy-components/pages/reports/ad-hoc.html", `<main class="salaxy-content sxytpl-reports-ad-hoc">
  <section>
    <div ng-controller="DatasetsCrudController as $ctrl" ng-init="$ctrl.model='url'">
      <salaxy-spinner ng-if="!$ctrl.usecase"></salaxy-spinner>
      <div ng-if="$ctrl.usecase && !$ctrl.usecase.defaultView" class="alert alert-danger">
        ERROR: This usecase {{ $ctrl.usecase.uri }} does not have user interface (view) defined.
      </div>
      <div ng-if="$ctrl.usecase && $ctrl.usecase.defaultView">
        <ng-include src="$ctrl.usecase.defaultView"></ng-include>
      </div>
    </div>
  </section>
</main>`), s.put("salaxy-components/pages/reports/archive-2018.html", `<main class="salaxy-content sxytpl-reports-archive-2018">
  <section class="sxytpl-intro">
    <h2 sxy-text="SALAXY.NG1_Pages.Reports.Archive.heading"></h2>
    <p class="lead" sxy-text="SALAXY.NG1_Pages.Reports.Archive.lead"></p>
  </section>
  <h3 sxy-text="SALAXY.NG1_Pages.Reports.Archive.unemploymentInsuranceFund"></h3>
  <section class="sxytpl-list">
    <div ng-controller="ReportsController as $ctrl" ng-init="rptType = 'unemployment'">
      <salaxy-report-list report-type="'unemployment'"></salaxy-report-list>
    </div>
  </section>
  <h3 sxy-text="SALAXY.NG1_Pages.Reports.Archive.taxYearlyNotification"></h3>
  <section class="sxytpl-list">
    <salaxy-report-list report-type="'taxYearly7801'"></salaxy-report-list>
  </section>
  <h3 sxy-text="SALAXY.NG1_Pages.Reports.Archive.taxMonthlyNotification"></h3>
  <section class="sxytpl-list">
    <salaxy-report-list report-type="'taxMonthly4001'"></salaxy-report-list>
  </section>
  <h3 sxy-text="SALAXY.NG1_Pages.Reports.Archive.pension"></h3>
  <section class="sxytpl-list">
    <salaxy-report-list report-type="'insurance'"></salaxy-report-list>
  </section>
</main>`), s.put("salaxy-components/pages/reports/calculation-report.html", `<main class="salaxy-content sxytpl-calculation-report">
  <section style="height: calc(100vh - 150px)">
    <salaxy-calculation-report template-id="'incomeTypes'"></salaxy-calculation-report>
  </section>
</main>`), s.put("salaxy-components/pages/reports/holiday-pay-report-query.html", `<main class="salaxy-content sxytpl-holiday-pay-report-query">
  <section>
    <salaxy-holiday-pay-report-query></salaxy-holiday-pay-report-query>
  </section>
</main>`), s.put("salaxy-components/pages/reports/holiday-report.html", `<main class="salaxy-content sxytpl-holiday-report">
  <section>
    <salaxy-holiday-report></salaxy-holiday-report>
  </section>
</main>`), s.put("salaxy-components/pages/reports/holidays.html", `<div ng-controller="HolidayYearCrudController as $ctrl" ng-init="$ctrl.getHolidayYears()">
  <h1 class="d-print-none" sxy-text="SALAXY.NG1_Pages.Reports.Holidays.holidayList"></h1>
  <h2 class="d-none d-print-block">{{'SALAXY.NG1_Pages.Reports.Holidays.holidayYear' | sxyTranslate}} {{ $ctrl.reportYear }} ({{ $ctrl.reportParams | sxyDateRange }})</h2>
  <div class="btn-toolbar d-print-none  mb-3 mt-3" role="toolbar" aria-label="Calendar buttons">
    <div class="btn-group" role="group" aria-label="{{'SALAXY.NG1_Pages.Reports.Holidays.holidayYear' | sxyTranslate}}">
      <salaxy-form-group name="year" label="SALAXY.NG1_Pages.Reports.Holidays.holidayYear" class="me-2" label-type="inline">
        <select id="year" name="year" ng-model="$ctrl.reportYear" class="ms-2 form-select" ng-change="$ctrl.getHolidayYears()" ng-options="item as item for item in $ctrl.reportParams.years">
        </select>
      </salaxy-form-group>
    </div>
    <div class="d-flex ms-1" role="group" aria-label="{{'SALAXY.NG1_Pages.Reports.Holidays.show' | sxyTranslate}}">
        <salaxy-datepicker-popup ng-model="$ctrl.reportParams.start" name="start" label="SALAXY.NG1_Pages.Reports.Holidays.show" label-type="inline" min-date="$ctrl.reportParams.yearStart" max-date="$ctrl.reportParams.yearEnd"></salaxy-datepicker-popup>
        <salaxy-datepicker-popup ng-model="$ctrl.reportParams.end" name="end" label="" label-type="no-label" label-cols="none" min-date="$ctrl.reportParams.yearStart" max-date="$ctrl.reportParams.yearEnd" class="ms-1"></salaxy-datepicker-popup>
    </div>
    <div class="btn-group ms-1" role="group" aria-label="Views">
      
      <button type="button" class="btn btn-default" ng-class="{ active: $ctrl.reportView == 'summerPeriod' }" ng-click="$ctrl.reportView = 'summerPeriod'" sxy-text="SALAXY.NG1_Pages.Reports.Holidays.summerPeriod"></button>
      <button type="button" class="btn btn-default" ng-class="{ active: $ctrl.reportView == 'winterPeriod' }" ng-click="$ctrl.reportView = 'winterPeriod'" sxy-text="SALAXY.NG1_Pages.Reports.Holidays.winterPeriod"></button>
      <button type="button" class="btn btn-default" ng-class="{ active: $ctrl.reportView == 'otherPeriod' }" ng-click="$ctrl.reportView = 'otherPeriod'" sxy-text="Muu"></button>
      <button type="button" class="btn btn-default" ng-class="{ active: $ctrl.reportView == 'list' }" ng-click="$ctrl.reportView = 'list'" sxy-text="SALAXY.NG1_Pages.Reports.Holidays.list"></button>
      
    </div>
    <div class="btn-group ms-1" role="group" aria-label="Actions">
      <button ng-click="$ctrl.showAddWorker()" class="btn btn-default" sxy-text="SALAXY.NG1_Pages.Reports.Holidays.addWorker"></button>
    </div>
  </div>
  <salaxy-spinner ng-if="!$ctrl.allYears"></salaxy-spinner>
  <div ng-if="$ctrl.allYears.length === 0" sxy-text="SALAXY.NG1_Pages.Reports.Holidays.employeeNoHolidays"></div>
  <div ng-if="$ctrl.allYears.length &gt; 0">
    <salaxy-holiday-year-holidays style="display: none;" ng-ref="$ctrl.$holidayList" on-commit="$ctrl.saveYear(parent)"></salaxy-holiday-year-holidays>
    <div ng-if="$ctrl.reportView != 'list'">
      <salaxy-calendar show-export="true" on-list-select="type == 'series' ? $ctrl.showEditDialog(series.data) : null" data="$ctrl.allYears" mode="horizontal" mapper="$ctrl.mapToCalendar" list-controller="$ctrl.$holidayList" start="$ctrl.reportParams.start" end="$ctrl.reportParams.end"></salaxy-calendar>
    </div>
    <div ng-if="$ctrl.reportView == 'list'">
      <table class="table">
        <thead>
          <tr>
            <th colspan="2"><span sxy-text="SALAXY.NG1_Other.Roles.worker"></span></th>
            <th sxy-html="SALAXY.NG1_Pages.Reports.Holidays.holidayCompensation.html"></th>
            <th class="right" sxy-text="SALAXY.NG1_Pages.Reports.Holidays.year"></th>
            <th class="right" sxy-html="SALAXY.NG1_Pages.Reports.Holidays.planned.html"></th>
            <th class="right" sxy-html="SALAXY.NG1_Pages.Reports.Holidays.summerWinter.html"></th>
            <th class="right" sxy-text="SALAXY.NG1_Pages.Reports.Holidays.endSaldo"></th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="year in $ctrl.allYears">
            <td class="align-middle td-avatar clickable" ng-click="$ctrl.showEditDialog(year)">
              <salaxy-avatar avatar="year.workerSnapshot"></salaxy-avatar>
            </td>
            <td class="td-workerSnapshot-name clickable" ng-click="$ctrl.showEditDialog(year)">
              <strong>{{ year.workerSnapshot.displayName }}</strong><br /> {{ "WageBasis." + year.spec.wageBasis | sxyEnum }}<br />
            </td>
            <td>
              {{ "HolidayCode." + year.spec.code | sxyEnum }}
              <span ng-if="year.spec.code == 'holidayCompensation'">({{ year.spec.compensation | sxyCount : 'percent' }})</span>
              <div ng-if="year.spec.bonusMethod != 'none'">
                {{ "HolidayBonusPaymentMethod." + year.spec.bonusMethod | sxyEnum }}
                <span>({{ year.spec.bonus | sxyCount : 'percent' }})</span>
              </div>
            </td>
            <td class="right">{{ year.year }}</td>
            <td class="right">
              {{ $ctrl.getTotalDays("all", year) | sxyCount : 'days' }}<br /> {{ year.leaves.planned.length | sxyCount : 'count' }}
            </td>
            <td class="right">
              {{ $ctrl.getTotalDays("summer", year) | sxyCount : 'days' }}<br /> {{ $ctrl.getTotalDays("winter", year) | sxyCount : 'days' }}
            </td>
            <td class="right">
              {{ year.accrual.endSaldo | sxyCount : 'days' }}
            </td>
          </tr>
        </tbody>
      </table>
      <p>&nbsp;</p>
    </div>
  </div>
</div>`), s.put("salaxy-components/pages/reports/index.html", `<main class="salaxy-content sxytpl-reports-dashboard">
  <section class="sxytpl-intro">
    <p class="lead">
      {{ 'SALAXY.NG1_Pages.Reports.latestReports' | sxyTranslate }}
    </p>
  </section>
  <section class="sxytpl-report-panels">
    <div class="row">
      <div class="col-12 col-sm-6" ng-if="$ctrl.route.getFlag('features', 'salaryReportList')">
        <salaxy-salary-report-list mode="panel"></salaxy-salary-report-list>
      </div>
      <div class="col-12 col-sm-6" ng-if="$ctrl.route.getFlag('features', 'accountingReportList')">
        <salaxy-accounting-report-list mode="panel"></salaxy-accounting-report-list>
      </div>
      <div class="col-12 col-sm-6" ng-if="$ctrl.route.getFlag('features', 'invoiceList') || ('pro' | sxyIsInRole)">
        <salaxy-invoice-list mode="panel"></salaxy-invoice-list>
      </div>
    </div>
  </section>
</main>`), s.put("salaxy-components/pages/reports/pay-certificate.html", `<main class="salaxy-content sxytpl-pay-certificate">
  <section class="sxytpl-intro">
    <p sxy-text="SALAXY.NG1_Pages.Reports.PayCertificate.intro.text"></p>
    <p sxy-html="SALAXY.NG1_Pages.Reports.PayCertificate.intro.html"></p>
  </section>
  <section>
    <salaxy-pay-certificate></salaxy-pay-certificate>
  </section>
</main>`), s.put("salaxy-components/pages/reports/salary-reports.html", `<main class="salaxy-content sxytpl-salary-reports">
  <section class="sxytpl-list">
    <salaxy-salary-report-list>
    </salaxy-salary-report-list>
  </section>
</main>`), s.put("salaxy-components/pages/reports/summary-report-query.html", `<main class="salaxy-content sxytpl-summary-report-query">
  <section>
    <salaxy-summary-report-query></salaxy-summary-report-query>
  </section>
</main>`), s.put("salaxy-components/pages/reports/yearly-summary.html", `<main class="salaxy-content sxytpl-reports-yearly-summary">
  <section class="sxytpl-intro">
    <p class="lead">
      {{ 'SALAXY.NG1_Pages.Reports.yearlySummary' | sxyTranslate }}
    </p>

  </section>
  <section class="sxytpl-list">
    <h2>{{ 'SALAXY.NG1_Pages.Reports.yearlyTitle' | sxyTranslate }}</h2>
    <salaxy-report-list report-type="'yearlyWorkerSummary'"></salaxy-report-list>
  </section>
</main>`), s.put("salaxy-components/pages/service-models/current.html", `<main class="salaxy-content sxytpl-service-model-current">
  <section>
    <h1>TODO: Current service model</h1>
    <p class="lead" sxy-text="SALAXY.NG1_Pages.ServiceModels.Current.lead"></p>
  </section>
</main>`), s.put("salaxy-components/pages/service-models/details.html", `<main class="salaxy-content sxytpl-service-model-details">
  <section>
    <salaxy-service-model-details model="'url'"></salaxy-service-model-details>
  </section>
</main>`), s.put("salaxy-components/pages/service-models/index.html", `<main class="salaxy-content sxytpl-service-model-list">
  <a class="btn btn-primary float-end" ng-href="#{{$odata.$crudController.getDefaults().detailsUrl}}new" sxy-text="SALAXY.NG1_Pages.ServiceModels.addServiceModel"></a>
  <p class="lead">
    {{'SALAXY.NG1_Pages.ServiceModels.lead' | sxyTranslate}} <a href="">Ota yhteys myyntiimme</a>.
  </p>
  <section>
    <div ng-show="$odata.items.length" class="salaxy-component salaxy-service-model-list">
      <salaxy-odata-table ng-ref="$odata" crud-controller="ServiceModelCrudController as $crud">
      </salaxy-odata-table>
    </div>
    <div ng-if="$odata.status == 'loaded' && !$odata.items.length" class="salaxy-placeholder-empty placeholder-md placeholder-default text-center">
      <a class="btn btn-primary" ng-href="#{{$odata.$crudController.getDefaults().detailsUrl}}new" sxy-text="SALAXY.NG1_Pages.ServiceModels.addServiceModel"></a>
    </div>
  </section>
</main>`), s.put("salaxy-components/pages/service-models/read-only.html", `<main class="salaxy-content sxytpl-service-model-details">
  <section>
    <salaxy-service-model-details is-read-only-forced="true" model="'url'"></salaxy-service-model-details>
  </section>
</main>`), s.put("salaxy-components/pages/settings/account-reset.html", `<main class="salaxy-content sxytpl-settings-account-reset">
  <section class="sxytpl-account-reset">
    <salaxy-account-reset></salaxy-account-reset>
  </section>
</main>`), s.put("salaxy-components/pages/settings/accountants.html", `<main class="salaxy-content sxytpl-partners-accountants">
  <section>
    <div class="content settings">

      <salaxy-accountant removal-disabled="$ctrl.route.node.accountantRemovalDisabled || 'accountantComponent.removalDisabled' | sxyIsInRole"></salaxy-accountant>

    </div>
  </section>
  <section sxy-if-role="test">
    <div class="row" ng-controller="PartnerController as $partnerCtrl">
      <div class="col-md-6">
        <div class="alert alert-danger">
          <b>Testiympäristö</b>
          <p>Vaihda tyyli tätä sessiota varten!</p>
          <button id="style" type="button" class="btn btn-primary" ng-click="$partnerCtrl.showSwitchCss()">
            Vaihda tyyli (CDN)
          </button>
          <button id="style" type="button" class="btn btn-secondary" ng-click="$partnerCtrl.showSwitchCssDev()">
            Vaihda tyyli <span class="small">(DEV)</span>
          </button>
          <hr />
          <div>Brand ID: {{ $partnerCtrl.brandId || "-" }}</div>
          <div>Skin: {{ $partnerCtrl.skin || "-" }}</div>
          <a ng-href="{{ $partnerCtrl.getLoginUrl() }}" target="_blank" class="btn btn-default">Näytä login</a>
          <a ng-href="{{ $partnerCtrl.getOnboardingUrl() }}" target="_blank" class="btn btn-default">Näytä onboarding</a>
        </div>
      </div>
    </div>
  </section>
</main>`), s.put("salaxy-components/pages/settings/accounting-target-settings.html", `<main class="salaxy-content sxytpl-accounting-targets">
  <section>
    <salaxy-accounting-settings></salaxy-accounting-settings>
  </section>
  <section>
    <div>
      <salaxy-accountant template-url="salaxy-components/settings/AccountantInfo.html"></salaxy-accountant>
    </div>
  </section>
  <section>
    <salaxy-cost-accounting-settings></salaxy-cost-accounting-settings>
  </section>
  <section>
    <salaxy-holiday-settings></salaxy-holiday-settings>
  </section>
</main>`), s.put("salaxy-components/pages/settings/authorizations.html", `<main class="salaxy-content sxytpl-settings-certificates settings content">
  <section class="sxytpl-credentials mb-4">
    <salaxy-credentials></salaxy-credentials>
  </section>
  <section class="sxytpl-certificates mb-4">
    <salaxy-certificates></salaxy-certificates>
  </section>
  <section class="sxytpl-authorized-accounts mb-4">
    <!-- <p class="lead">{{ 'SALAXY.NG1_Pages.Settings.Authorizations.lead' | sxyTranslate}}</p> -->
    <salaxy-authorized-accounts></salaxy-authorized-accounts>
  </section>
</main>`), s.put("salaxy-components/pages/settings/index.html", `<main class="salaxy-content sxytpl-settings-dashboard" ng-controller="SessionController as $session">
  <section class="sxytpl-settings-panels">
    <div class="row">

      <div class="col-12 mb-4" ng-if="$ctrl.route.getFlag('features', 'account')">
        <div class="salaxy-odata-card list-card settings-list-card card card-sm card-secondary">
          <div class="card-header" sxy-text="SALAXY.NG1_Pages.Settings.accountTitle">

          </div>
          <div class="card-body card-content">
            <div class="row table-row">

              <div class="col-4">
                <span sxy-text="SALAXY.NG1_Pages.Settings.languageLabel" ps=":"></span>
              </div>

              <div class="col-8 text-end">
                {{("Language." + $session.session.currentAccount.language | sxyEnum) || "-" }}
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="row table-row">
                  <div class="col-12">
                    <strong sxy-text="SALAXY.NG1_Pages.Settings.contactLabel"></strong>
                  </div>
                </div>

                <div class="row table-row">
                  <div class="col-4">
                    <span sxy-text="SALAXY.NG1.AccountInfoComponent.email" ps=":"></span>

                  </div>
                  <div class="col-8 text-end">
                    {{ $session.company.contact.email }}
                  </div>
                </div>
                <div class="row table-row">
                  <div class="col-4">
                    <span sxy-text="SALAXY.NG1.AccountInfoComponent.phone" ps=":"></span>

                  </div>
                  <div class="col-8 text-end">
                    {{ $session.company.contact.telephone }}
                  </div>
                </div>
                <div class="row table-row">
                  <div class="col-4">
                    <span sxy-text="SALAXY.NG1.AccountInfoComponent.address" ps=":"></span>

                  </div>
                  <div class="col-8 text-end">
                    {{ $session.company.contact.street }}<br /> {{ $session.company.contact.postalCode }} {{ $session.company.contact.city }}
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="row table-row">
                  <div class="col-12">
                    <strong sxy-text="SALAXY.NG1_Pages.Settings.userLabel"></strong>
                  </div>
                </div>

                <div class="row table-row" ng-if="$session.session.currentCredential.authenticationMethod != 'salaxy' && $session.session.currentCredential.authenticationMethod != 'x509'">
                  <div class="col-4">
                    <span sxy-text="SALAXY.NG1.UserInfoComponent.email" ps=":"></span>

                  </div>
                  <div class="col-8 text-end">

                    {{ $session.session.currentCredential.email }}
                  </div>
                </div>
                <div class="row table-row">
                  <div class="col-4">
                    <span sxy-text="SALAXY.NG1.UserInfoComponent.name" ps=":"></span>
                  </div>
                  <div class="col-8 text-end">
                    {{ $session.session.currentCredential.avatar.displayName }}
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div class="card-footer text-center">
            <a href="#/settings/service-settings" title="{{'SALAXY.UI_Terms.edit' | sxyTranslate}}" class="btn btn-sm btn-primary" sxy-text="SALAXY.UI_Terms.edit"></a>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-12 mb-4" ng-if="$ctrl.route.getFlag('features', 'insurances')" ng-controller="CompanySettingsController as $settings">
        <div class="salaxy-odata-card list-card settings-list-card card card-sm card-secondary">
          <div class="card-header" sxy-text="SALAXY.NG1_Pages.Settings.insurancesTitle">

          </div>
          <div class="card-body card-content lg-height">

            <div class="row table-row">
              <div class="col-6" ng-class="$session.session.settings.pensionContracts == '' ? 'col-6' : 'col-12'">
                <strong sxy-text="SALAXY.NG1.InsuranceSettingsComponent.pension.titleLong"></strong>
              </div>

              <div class="col-6 text-end" ng-if="$session.session.settings.pensionContracts == ''">
                <a href="#/settings/payment-settings" class="btn btn-danger btn-xs" sxy-text="SALAXY.NG1_Pages.Settings.insuranceMissing"></a>
              </div>
            </div>
            <div class="row-wrapper" ng-repeat="item in $settings.pensionContracts" ng-if="$settings.isVisibleContract(item, $settings.pensionContracts)">
              <div class="row table-row">
                <div class="col-4" ps=":" sxy-text="SALAXY.MODEL.PensionContract.company.title">
  
                </div>
                <div class="col-8 text-end">
                  {{("PensionCompany." + item.company | sxyEnum) || '-'}}
                </div>
              </div>
              
              <div class="row table-row">
                <div class="col-4" sxy-text="SALAXY.MODEL.PensionContract.contractNumber.title" ps=":">
  
                </div>
                <div class="col-8 text-end">
                  {{item.contractNumber || '-'}}
                </div>
              </div>
            </div>
          
            <div class="row-wrapper" ng-repeat="item in $settings.insuranceContracts" ng-if="$settings.isVisibleContract(item, $settings.insuranceContracts)">
              <div class="row table-row">
                <div class="col-6" ng-class="$session.session.settings.insuranceContracts == '' ? 'col-6' : 'col-12'">
                  <strong sxy-text="SALAXY.NG1.InsuranceSettingsComponent.insurance.title"></strong>
                </div>

                <div class="col-6 text-end" ng-if="$session.session.settings.insuranceContracts == ''">
                  <a href="#/settings/payment-settings" class="btn btn-danger btn-xs" sxy-text="SALAXY.NG1_Pages.Settings.insuranceMissing"></a>
                </div>
              </div>
              <div class="row table-row">
                <div class="col-4" sxy-text="SALAXY.MODEL.InsuranceContract.company.title" ps=":">

                </div>
                <div class=" col-8 text-end">
                  {{("InsuranceCompany." + item.company | sxyEnum) || '-'}}
                </div>
              </div>
              <div class="row table-row">
                <div class="col-4" sxy-text="SALAXY.MODEL.InsuranceContract.contractNumber.title" ps=":">

                </div>
                <div class="col-8 text-end">
                  {{item.contractNumber || '-'}}
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer text-center">
            <a href="#/settings/insurances" title="{{ 'SALAXY.UI_Terms.edit' | sxyTranslate}}" class="btn btn-sm btn-primary" sxy-text="SALAXY.UI_Terms.edit"></a>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-12 mb-4" ng-if="$ctrl.route.getFlag('features', 'accountant')">
        <div class="salaxy-odata-card list-card settings-list-card card card-sm card-secondary">
          <div class="card-header">
            {{'SALAXY.NG1_Pages.Settings.accountantTitle' | sxyTranslate }}
          </div>
          <div class="card-body card-content lg-height text-center align-middle" ng-if="!$session.session.settings.partner">
            <div>
              <h3 sxy-text="SALAXY.NG1_Pages.Settings.noAccountant"></h3>
            </div>
          </div>
          <div class="card-body card-content lg-height" ng-if="$session.session.settings.partner">
            <div class="row table-row">
              <div class="col-4" sxy-text="SALAXY.NG1.AccountantComponent.name" ps=":">
              </div>
              <div class="col-8 d-flex align-items-center justify-content-end">
                <salaxy-avatar style="font-size: 20px; margin-right: 12px;" avatar="$session.session.settings.partner.info.avatar"></salaxy-avatar>
                <span>{{ $session.session.settings.partner.info.avatar.displayName}}</span>
              </div>
            </div>

            <div class="row table-row" ng-if="$session.session.settings.partner.info.officialId">
              <div class="col-4" sxy-text="SALAXY.NG1.AccountantComponent.officialId" ps=":"></div>
              <div class="col-8 text-end">{{ $session.session.settings.partner.info.officialId}}</div>
            </div>
            <div class="row table-row" ng-if="$session.session.settings.partner.info.email">
              <div class="col-4" sxy-text="SALAXY.NG1.AccountantComponent.email" ps=":"></div>
              <div class="col-8 text-end">{{ $session.session.settings.partner.info.email }}</div>
            </div>
            <div class="row table-row" ng-if="$session.session.settings.partner.info.telephone">
              <div class="col-4" sxy-text="SALAXY.NG1.AccountantComponent.phone" ps=":"></div>
              <div class="col-8 text-end">{{ $session.session.settings.partner.info.telephone }}</div>
            </div>
            <div class="row table-row" ng-if="$session.session.settings.partner.type=='primaryPartner' || $session.session.settings.partner.type=='pendingPrimaryPartner' || $session.session.settings.partner.type=='unlinkedPrimaryPartner' || $session.session.settings.partner.type=='unlinkedAccountingOnly'">
              <div class="col-4" sxy-text="SALAXY.NG1.AccountantComponent.accountantType" ps=":">
              </div>
              <div class="col-8 text-end">
                <span ng-if="$session.session.settings.partner.type=='primaryPartner'" sxy-text="SALAXY.NG1.AccountantComponent.primaryPartner"></span>
                <span ng-if="$session.session.settings.partner.type=='pendingPrimaryPartner'" sxy-text="SALAXY.NG1.AccountantComponent.pendingPrimaryPartner"></span>
                <span ng-if="$session.session.settings.partner.type=='unlinkedPrimaryPartner'" sxy-text="SALAXY.NG1.AccountantComponent.unlinkedPrimaryPartner"></span>
                <span ng-if="$session.session.settings.partner.type=='unlinkedAccountingOnly'" sxy-text="SALAXY.NG1.AccountantComponent.unlinkedAccountingOnly"></span>
              </div>
            </div>
          </div>

          <div class="card-footer text-center">
            <a href="#/settings/accountants" title="{{ 'SALAXY.UI_Terms.edit' | sxyTranslate}}" class="btn btn-sm btn-primary" sxy-text="SALAXY.UI_Terms.edit"></a>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-12 mb-4" ng-if="$session.session.settings.paymentChannels && $ctrl.route.getFlag('features', 'paymentChannels')">
        <div class="salaxy-odata-card list-card settings-list-card card card-sm card-secondary">
          <div class="card-header" sxy-text="SALAXY.NG1_Pages.Settings.paymentChannelsTitle">

          </div>
          <div class="card-body card-content lg-height">
            <div class="row table-row">
              <div class="col-6">
                <strong sxy-text="SALAXY.NG1_Pages.Settings.defaultChannelLabel" ps=":"></strong>
              </div>
              <div class="col-6 text-end">
                {{"PaymentChannel." + $session.session.settings.defaultPaymentChannel | sxyEnum}}
              </div>
            </div>
            <div class="row table-row">
              <div class="col-12">
                <strong sxy-text="SALAXY.NG1.PaymentChannelSettingsComponent.title" ps=":"></strong>
              </div>
            </div>
            <div class="row table-row" ng-repeat="channel in $session.session.settings.paymentChannels">

              <div class="col-12">

                {{"PaymentChannel." + channel | sxyEnum}}<br>
              </div>
            </div>
          </div>
          <div class="card-footer text-center">
            <a href="#/settings/payment-channel-settings" title="{{ 'SALAXY.UI_Terms.edit' | sxyTranslate}}" class="btn btn-sm btn-primary" sxy-text="SALAXY.UI_Terms.edit"></a>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>`), s.put("salaxy-components/pages/settings/insurances.html", `<main class="salaxy-content sxytpl-insurance-settings">
  <section>
    <salaxy-insurance-settings is-read-only-forced="$ctrl.route.readOnly"></salaxy-insurance-settings>
  </section>
</main>`), s.put("salaxy-components/pages/settings/integrations.html", `<main class="salaxy-content sxytpl-partners-integrations">
  <section class="sxytpl-intro">
    <p class="lead">
      {{ 'SALAXY.NG1_Pages.Settings.Integrations.lead' | sxyTranslate }}
    </p>
  </section>
  <section class="sxytpl-cards">
    <div ng-controller="AccountAuthorizationController as authCtrl">
      <div class="row align-items-stretch w-100">
        <div class="sxytpl-card col-12 col-sm-4 col-md-4 col-lg-3 m-3" ng-repeat="site in authCtrl.partnerIntegrationSites">
          <salaxy-auth-card class="d-flex h-100" auth-id="site.id"></salaxy-auth-card>
        </div>
      </div>
    </div>
  </section>
</main>`), s.put("salaxy-components/pages/settings/ir-delivery-settings.html", `<main class="salaxy-content sxytpl-ir-delivery-settings">
  <section>
    <salaxy-ir-delivery-settings is-read-only-forced="$ctrl.route.readOnly"></salaxy-ir-delivery-settings>
  </section>
</main>`), s.put("salaxy-components/pages/settings/open-ai.html", `<div class="content settings"  ng-controller="CompanySettingsController as $ctrl">
  <div class="panel open-ai-settings panel-default" ng-if="$ctrl.current">
    <div>
      <div class="panel-heading icon-panel">
        <h2 sxy-text="OPEN AI"></h2>
      </div>
      <div class="panel-body">
        <div class="row">
          <ng-form name="$openAi" class="form-horizontal">
            <div>
              <fieldset>
                <legend>API Avain</legend>
                <salaxy-input label="Avain" name="key"
                  ng-model="$ctrl.openAiKey"></salaxy-input>
              </fieldset>
            </div>
          </ng-form>
        </div>
      </div>
      <div class="panel-footer">
        <div class="row">
          <div class="col-xs-12 text-right">
            <button type="submit"
              class="btn btn-primary" ng-click="$ctrl.saveOpenAiKey()">
              <span sxy-text="SALAXY.UI_Terms.save"></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>`), s.put("salaxy-components/pages/settings/owner-settings.html", '<salaxy-owner-settings is-read-only-forced="$ctrl.route.readOnly"></salaxy-owner-settings>'), s.put("salaxy-components/pages/settings/payment-channel-settings.html", `<main class="salaxy-content sxytpl-payment-channel-settings">
  <section>
    <salaxy-payment-channel-settings></salaxy-payment-channel-settings>
  </section>
</main>`), s.put("salaxy-components/pages/settings/payment-settings.html", `<main class="salaxy-content sxytpl-payment-settings">

  <section>
    <salaxy-payment-settings is-read-only-forced="$ctrl.route.readOnly"></salaxy-payment-settings>
  </section>
</main>`), s.put("salaxy-components/pages/settings/pro-settings.html", `<main class="salaxy-content sxytpl-pro-settings">
  <section>
    <salaxy-pro-settings></salaxy-pro-settings>
  </section>
</main>`), s.put("salaxy-components/pages/settings/row-types-settings.html", `<main class="salaxy-content sxytpl-row-types-settings">
  <section>
    <salaxy-tab-buttons 
      current-tab="$ctrl.currentTab"
      options="[
        { value: 'builtin', text: 'Tuotteen palkkalajit' },
        { value: 'custom', text: 'Yrityskohtaiset palkkalajit' },
        { value: 'prices', text: 'Oletushinnat' },
        { value: 'copy', text: 'Kopioitavat rivit' },
        { value: 'json', text: 'Debug' }
      ]"
      tabs-id="rowTypesSettings">
    </salaxy-tab-buttons>
    <div class="tab-content" id="tab-content-rowTypesSettings">
      <div class="tab-pane" id="builtin-tab">
        <p>
          Tuotteen palkkalajit listaa kaikki palkkalajit, jotka on määritetty suoraan tuotteeseen.
          Niitä ei voi muokata. <strong>Klikkaa räätälöi luodaksesi uusi yrityskohtainen palkkalaji.</strong>
        </p>
        <salaxy-row-types-settings mode="builtIn"></salaxy-row-types-settings>
      </div>
      <div class="tab-pane" id="custom-tab">
        <p>
          Voit luoda uuden yrityskohtaisen palkkalajin valitsemalla tuotteen palkkalajin ensimmäiseltä välilehdeltä ja klikkaamalla "räätälöi".
          <br />
          <strong>HUOM: Tässä versiossa yrityskohtaiset palkkalajit toimivat vain tuntitiedon tuonnissa (esim. Nepton, EASoft).</strong>
          Myöhemmissä versioissa ne tulevat mukaan myös laskuriin.
        </p>
        <div>
          <salaxy-row-types-settings mode="custom"></salaxy-row-types-settings>
        </div>
      </div>
      <div class="tab-pane" id="prices-tab">
        <div class="float-end">
          <button class="btn btn-primary" ng-click="$ctrl.$prices.save()"></span> <span sxy-text="SALAXY.UI_Terms.save"></span></button>
        </div>
        <p style="min-height: 24px;">Hintoja käytetään tällä hetkellä tuntien sisään tuonnissa. Myöhemmissä versioissa oletushintoja käytetään myös laskurissa.</p>
        <salaxy-row-types-settings ng-ref="$ctrl.$prices" mode="prices"></salaxy-row-types-settings>
      </div>
      <div class="tab-pane" id="copy-tab">
        <div class="float-end">
          <button class="btn btn-primary" ng-click="$ctrl.$copyRows.save()"></span> <span sxy-text="SALAXY.UI_Terms.save"></span></button>
        </div>
        <p style="min-height: 24px;">Rivit päivitetään laskelmalle työsuhteen päivityksen yhteydessä.</p>
        <salaxy-row-types-settings ng-ref="$ctrl.$copyRows" mode="copy" ng-if="$ctrl.currentTab == 'copy'"></salaxy-row-types-settings>
      </div>
      <div class="tab-pane" id="json-tab">
        <salaxy-row-types-settings mode="debugger"></salaxy-row-types-settings>
      </div>
    </div>
  </section>
</main>`), s.put("salaxy-components/pages/settings/service-settings.html", `<main class="salaxy-content sxytpl-settings-service-settings settings content">
  <section class="sxytpl-language-selection mb-4">
    <salaxy-language-selector></salaxy-language-selector>
  </section>
  <section class="sxytpl-account-info mb-4">
    <div class="card account-info card-secondary">
      <div class="card-header">
        <h2>{{'SALAXY.NG1_Pages.Settings.ServiceSettings.heading' | sxyTranslate}}</h2>
      </div>
      <div class="card-body">
        <salaxy-account-info></salaxy-account-info>
      </div>
    </div>
  </section>
  <section class="sxytpl-user-info mb-4" salaxy-if-role="test">
    <div class="card user-info card-default">
      <div class="card-header">
        <h2>{{'SALAXY.NG1.UserInfoComponent.panelTitle' | sxyTranslate}} (TEST ONLY)</h2>
      </div>
      <div class="card-body">
        <salaxy-user-info></salaxy-user-info>
      </div>
    </div>
  </section>
  <section class="sxytpl-account-records">
    <div class="card account-records card-default">
      <div class="card-header">
        <h2>{{'SALAXY.NG1.WorkerDetailsComponent.records.label' | sxyTranslate}}</h2>
      </div>
      <div class="card-body">
        <div ng-if="'person' | sxyIsInRole" ng-controller="PersonAccountController as $person">
          <salaxy-records ng-if="$person.current" read-only="$ctrl.route.readOnly" api-ctrl="$person" entity-type="'account'"></salaxy-records>
        </div>
        <div ng-if="'company' | sxyIsInRole" ng-controller="CompanyAccountController as $company">
          <salaxy-records ng-if="$company.current" read-only="$ctrl.route.readOnly" api-ctrl="$company" entity-type="'account'"></salaxy-records>
        </div>
      </div>
    </div>
  </section>
</main>`), s.put("salaxy-components/pages/settings/signing-cancel.html", `<div class="text-center" style="height: 100vh; padding-top: 30vh;">
  <div>
    <h1>Allekirjoitus peruttu / Digital signature canceled / 
      Digital signatur avbröts</h1>
    <button type="button" class="btn btn-primary" onclick="closePopup()" sxy-text="SALAXY.UI_Terms.close"></button>
  </div>
</div>
`), s.put("salaxy-components/pages/settings/signing-new.html", `<main class="salaxy-content sxytpl-settings-signing">
  <h1>Signing tester</h1>
  <salaxy-signing ng-ref="$ctrl.$signing" show-in-popup="true" show-always="true"></salaxy-signing>
</div>`), s.put("salaxy-components/pages/settings/signing-success.html", `<div class="text-center" style="height: 100vh; padding-top: 30vh;">
  <div>
    <h1 sxy-text="SALAXY.NG1_Pages.Settings.SigningSuccess.success"></h1>
    <button type="button" class="btn btn-primary" onclick="closePopup()" sxy-text="SALAXY.UI_Terms.close"></button>
  </div>
</div>
`), s.put("salaxy-components/pages/settings/signing.html", `<div ng-cloak ng-controller="NaviController as $ctrl">
  <salaxy-spinner ng-if="$ctrl.showFullPageLoader" full-screen="true" heading="SALAXY.UI_Terms.loading">
  </salaxy-spinner>
  <div class="salaxy-component" ng-if="!$ctrl.showFullPageLoader">
    <div ng-controller="CompanyOnboardingController as $onBoarding">
      <div ng-if="'auth' | sxyIsInRole" ng-init="$onBoarding.launchSigningWizard()"></div>
      <div class="text-center" style="margin-top:100px;">
        <a onClick="window.opener.postMessage({ action: 'refresh' },'*');window.close()" href="#" sxy-text="SALAXY.UI_Terms.close"></a>
      </div>
    </div>
  </div>
</div>

   `), s.put("salaxy-components/pages/settings/translate.html", "<salaxy-ui-translator></salaxy-ui-translator>"), s.put("salaxy-components/pages/taxcards/details.html", `<div class="container">
  <h2>{{'SALAXY.NG1_Pages.Taxcards.Details.heading' | sxyTranslate}}: {{ $ctrl.$taxcardCtrl.current.worker.displayName }}</h2>
  <p class="lead" ng-if="$ctrl.$taxcardCtrl.current">
    <strong>{{ "TaxcardKind." + $ctrl.$taxcardCtrl.current.card.kind | sxyEnum }}, {{ $ctrl.$taxcardCtrl.current.card.validity | sxyDateRange }}</strong>. {{'SALAXY.NG1_Pages.Taxcards.Details.heading' | sxyTranslate}}
  </p>
  <salaxy-tab-buttons
    current-tab="$ctrl.currentTab"
    options="[
      { value: 'overview', text: 'SALAXY.NG1_Pages.Taxcards.Details.overview' },
      { value: 'pro', text: 'SALAXY.NG1_Pages.Taxcards.Details.editing' },
      { value: 'alltaxcards', text: 'SALAXY.NG1_Pages.Taxcards.Details.allTaxcards' },
      { value: 'debug', text: 'Json / debug' }
    ]"
    tabs-id="taxcardsDetails">
  </salaxy-tab-buttons>
  <div class="tab-content" id="tab-content-taxcardsDetails">
    <div class="tab-pane" id="overview-tab">
      <salaxy-spinner heading="SALAXY.UI_Terms.loading" ng-if="$ctrl.$taxcardCtrl.isLoading"></salaxy-spinner>
        <div ng-if="$ctrl.$taxcardCtrl.current && $ctrl.$taxcardCtrl.currentId">
          <salaxy-taxcard-details model="$ctrl.$taxcardCtrl.current" hide-buttons="true"></salaxy-taxcard-details>
          <div class="text-center" ng-if="!$ctrl.$taxcardCtrl.getTaxcardDownloadUrl()" sxy-text="SALAXY.NG1_Pages.Taxcards.Details.noAttachment"></div>
          <a ng-if="$ctrl.$taxcardCtrl.getTaxcardDownloadUrl()" ng-href="{{$ctrl.$taxcardCtrl.getTaxcardDownloadUrl()}}" target="_blank" class="btn btn-xs btn-primary float-end" sxy-text="SALAXY.NG1_Pages.Taxcards.Details.download">Download</a>
          <div ng-if="$ctrl.$taxcardCtrl.getTaxcardPreviewUrl()" class="document-preview text-center">
            <img ng-src="{{ $ctrl.$taxcardCtrl.getTaxcardPreviewUrl() }}" class="img-responsive" style="display: inline;" />
          </div>
        </div>
    </div>
    <div class="tab-pane" id="pro-tab">
      <salaxy-taxcard-details model="'url'" list-url="/taxcards" ng-ref="$ctrl.$taxcardCtrl" mode="pro"></salaxy-taxcard-details>
    </div>
    <div class="tab-pane" id="alltaxcards-tab">
      <div ng-if="$ctrl.currentTab == 'alltaxcards'">
        <salaxy-employment-taxcards employment-id="$ctrl.$taxcardCtrl.current.employmentId" ng-ref="$ctrl.$allTaxcardsCtrl" mode="list"></salaxy-employment-taxcards>
      </div>
    </div>
    <div class="tab-pane" id="debug-tab">
      <p class="clearfix" sxy-if-role="test">
        <button type="button" class="btn btn-danger float-end" ng-click="$ctrl.$taxcardCtrl.delete()" sxy-text="SALAXY.NG1_Pages.Taxcards.Details.deleteButton">Poista (test)</button> {{'SALAXY.NG1_Pages.Taxcards.Details.deleteButtonInfo' | sxyTranslate}}
      </p>
      <salaxy-json-formatter open="1" json="$ctrl.$taxcardCtrl.current"></salaxy-json-formatter>
    </div>
  </div>
</div>`), s.put("salaxy-components/pages/taxcards/index.html", `<div class="container">
  <h2 sxy-text="SALAXY.NG1_Pages.Taxcards.heading"></h2>
  <p class="lead" sxy-if-role="!worker" sxy-html="SALAXY.NG1_Pages.Taxcards.lead.noWorkerHtml"></p>
  <p class="lead" sxy-if-role="worker" sxy-html="SALAXY.NG1_Pages.Taxcards.lead.workerHtml"></p>
  <salaxy-odata-table crud-controller="TaxcardCrudController as $crud" crud-bindings="{ detailsUrl: '/taxcards/details/'}"></salaxy-odata-table>
</div>`), s.put("salaxy-components/pages/test/account-reset.html", `<main class="salaxy-content sxytpl-settings-account-reset">
  <section class="sxytpl-account-reset">
    <salaxy-account-reset></salaxy-account-reset>
  </section>
</main>`), s.put("salaxy-components/pages/test/smoke.html", `<main class="salaxy-content sxytpl-test-smoke">
  <section class="sxytpl-test-smoke">
    <h1>Salaxy tester page</h1>
      <p class="lead">
        This page tests whether <code>@salaxy</code> functionality is working.
        <br />
        <a href="/ng1/">Go to AngularJS Components</a>
      </p>
      <fieldset>
        <legend>AngularJS</legend>
        <p>Expressions: 1 + 2 = {{ 1 + 2 }} <i>(result should be "3")</i></p>
        <p>
          Ng-if: <span style="background-color: red; color: white;" ng-if="false">FAILURE</span>
          <i>(should NOT show text "failure" in red background).</i>
        </p>
        <p>
          Directive (ng-style): <span style="background-color: red; color: white;" ng-style="{ 'background-color': 'green' }">This text should be in GREEN backgroung</span>
        </p>
      </fieldset>
      <fieldset>
        <legend>Salaxy styles (LESS)</legend>
        <p>The following buttons should be in Bootstrap colors:</p>
        <div class="btn-toolbar">
          <button type="button" class="btn btn-default">Default</button>
          <button type="button" class="btn btn-primary">Primary</button>
          <a href="" class="btn btn-success">Success a-href</a>
          <button type="button" class="btn btn-info">Info</button>
          <a href="" class="btn btn-warning">Warning a-href</a>
          <button type="button" class="btn btn-danger">Danger</button>
          <button type="button" class="btn btn-link">Link</button>
        </div>
        <p style="margin-top: 10px;">...if this is not the case, rest of the tests may be difficult to read (no red / green etc.)</p>
      </fieldset>
      <p style="background-color: red; color: white; margin-top: 10px;" ng-if="false">
        FAILURE: Angular not available: Rest of tests will not show!
      </p>
      <salaxy-smoke-test mode="core"></salaxy-smoke-test>
      <salaxy-smoke-test mode="reports"></salaxy-smoke-test>
      <salaxy-smoke-test mode="ng1"></salaxy-smoke-test>
  </section>
</main>`), s.put("salaxy-components/pages/usecases/details.html", `<main class="salaxy-content sxytpl-usecase-details">
  <section>
    <salaxy-usecase-details model="'url'"></salaxy-usecase-details>
  </section>
</main>`), s.put("salaxy-components/pages/usecases/index.html", `<main class="salaxy-content sxytpl-usecase-list">
  <section>
    <a ng-href="#{{$ctrl.$odata.$crudController.getDefaults().detailsUrl}}new" class="btn btn-primary float-end" sxy-text="SALAXY.NG1_Pages.Usecases.createNewUsecase"></a>
    <h1>{{'SALAXY.NG1_Pages.Usecases.usecase' | sxyTranslate}}<span class="badge bg-primary">BETA</span></h1>
    <p class="lead" sxy-text="SALAXY.NG1_Pages.Usecases.lead"></p>
    <div class="btn-toolbar">
      <button type="button" class="btn btn-default" ng-click="$ctrl.$odata.setFilter(null)">Näytä kaikki</button>
      <button type="button" class="btn btn-default" ng-click="$ctrl.$odata.setFilter('entityType', 'calculation')">Laskelmat</button>
      <button type="button" class="btn btn-default" ng-click="$ctrl.$odata.setFilter('entityType', 'dataset')">Dataset</button>
    </div>
    <salaxy-odata-table crud-controller="UsecasesCrudController as $crud" ng-ref="$ctrl.$odata"></salaxy-odata-table>
  </section>
</main>`), s.put("salaxy-components/pages/workers/details.html", `<main class="salaxy-content sxytpl-workers-details">
  <section>
    <salaxy-worker-details model="'url'" is-read-only-forced="$ctrl.route.readOnly" hide-buttons="$ctrl.route.readOnly"></salaxy-worker-details>
  </section>
</main>`), s.put("salaxy-components/pages/workers/import-workers.html", `<main class="salaxy-content">
  <section>
    <!-- Forcing isFullWidth  -->
    <div style="display: none;" ng-init="$ctrl.current.isFullWidth = true"></div>
    <salaxy-tab-buttons
      current-tab="$ctrl.currentTab"
      options="[
        { value: 'default', text: 'Työntekijöiden tuonti' },
        { value: 'list', text: 'Työntekijät' },
      ]"
      tabs-id="importWorkers">
    </salaxy-tab-buttons>
    <div class="tab-content" id="tab-content-importWorkers">
      <div class="tab-pane" id="default-tab">
        <salaxy-worker-import></salaxy-worker-import>
      </div>
      <div class="tab-pane" id="list-tab">
        <salaxy-employment-list show-toolbar="true" read-only="$ctrl.route.readOnly"></salaxy-employment-list>
      </div>
    </div>
  </section>
</main>`), s.put("salaxy-components/pages/workers/index.html", `<main class="salaxy-content sxytpl-workers-list">
  <section>
    <salaxy-employment-list show-toolbar="true" read-only="$ctrl.route.readOnly" ng-ref="$odata"></salaxy-employment-list>
  </section>
</main>`), s.put("salaxy-components/pages/workers/taxcards.html", `<main class="salaxy-content sxytpl-workers-taxcardslist">
  <section class="sxytpl-intro">
    <p class="lead" sxy-text="SALAXY.NG1_Pages.Workers.Taxcards.lead"></p>
  </section>
  <section class="sxytpl-list">
    <salaxy-tax-cards-list></salaxy-tax-cards-list>
  </section>
</main>`), s.put("salaxy-components/pages/worktime-imports/index.html", `<main class="salaxy-content sxytpl-usecase-list">
  <section ng-controller="ImportStagingController as $ctrl">
    <div ng-if="$ctrl.isSupported">
      <salaxy-import-staging></salaxy-import-staging>
    </div>
    <div ng-if="!$ctrl.isSupported" class="container">
      <h1>Työajan tuonti ei käytössä</h1>
      <p class="lead">
        Työajan tuonti ei ole käytössä tälle asiakastilille.
        Ominaisuus on käytössä ensimmäisillä kumppaneilla.
        Kysy asiakaspalvelusta miten voit ottaa tuonnin käyttöön.
      </p>
      <p>
        <strong>HUOM:</strong>
        Jos tiedossasi on jo organisaatiosi Staging-palvelimen osoite
        ,<a href="#/settings/pro-settings">voit määrittää sen asetuksissa</a> => Välilehti   "Muut".
      </p>
    </div>
  </section>
</main>`), s.put("salaxy-components/pages-personal/account/authorizations.html", `<main class="salaxy-content sxytpl-settings-certificates settings content">
  <section class="sxytpl-credentials">
    <salaxy-credentials></salaxy-credentials>
  </section>
  <section class="sxytpl-certificates">
    <salaxy-certificates></salaxy-certificates>
  </section>
  <section class="sxytpl-authorized-accounts">
    <salaxy-authorized-accounts></salaxy-authorized-accounts>
  </section>
</main>`), s.put("salaxy-components/pages-personal/account/index.html", "<salaxy-account-details-person></salaxy-account-details-person>"), s.put("salaxy-components/pages-personal/archive/employer-archive.html", `<div>
  <p class="lead" sxy-html="SALAXY.NG1_PagesPersonal.employerArchive.intro.html"></p>
  <ul>
    <li><a href="#/archive/employer-paid" sxy-text="SALAXY.NG1_Sitemap.personalWeb.employerArchive.employerPaid"></a></li>
    <li><a href="#/archive/employer-report" sxy-text="SALAXY.NG1_Sitemap.personalWeb.employerArchive.employerReport"></a></li>
    <li><a href="#/household-years/active" sxy-text="SALAXY.NG1_Sitemap.personalWeb.employerArchive.householdYears.main"></a></li>
  </ul>
</div>`), s.put("salaxy-components/pages-personal/archive/employer-paid.html", '<salaxy-calc-list category="paid" read-only="true"></salaxy-calc-list>'), s.put("salaxy-components/pages-personal/archive/employer-report.html", "<salaxy-employer-report></salaxy-employer-report>"), s.put("salaxy-components/pages-personal/archive/household-deduction-report.html", `<div>
  <salaxy-household-deduction-report></salaxy-household-deduction-report>
</div>
`), s.put("salaxy-components/pages-personal/archive/index.html", `<div class="embed loader" salaxy-if-role="auth">
  <salaxy-spinner full-screen="true" id="iFrameLoader" heading="Ladataan tietoja arkistosta..."></salaxy-spinner>
  <iframe src="/Yearly" onload="document.getElementById('iFrameLoader').style.display = 'none'"></iframe>
</div>`), s.put("salaxy-components/pages-personal/archive/worker-report.html", "<salaxy-worker-report></salaxy-worker-report>"), s.put("salaxy-components/pages-personal/calc/details.html", `<div class="container-fixed">
  <salaxy-calc ng-ref="$calc" model="'url'" ng-hide="$calc.currentCalc.workflow.status == 'paymentStarted' || $calc.currentCalc.workflow.status == 'paymentSucceeded'"></salaxy-calc>
  <div class="light-bg" ng-if="$calc.currentCalc.workflow.status == 'paymentStarted' || $calc.currentCalc.workflow.status == 'paymentSucceeded'">
    <salaxy-calc-reports calcs="[$calc.currentCalc]" report-type="'salarySlip'"></salaxy-calc-reports>
  </div>
</div>`), s.put("salaxy-components/pages-personal/calc/draft.html", `<salaxy-action-button sxy-if-role="!household" action="'newCalc'" label="SALAXY.NG1.ActionButtonComponent.newCalculation" button-class="btn-primary mb-2 hidden-xxs"></salaxy-action-button>
<salaxy-calc-list category="draft" class="worker-drafts" read-only="'household' | sxyIsInRole"></salaxy-calc-list>`), s.put("salaxy-components/pages-personal/calc/error.html", '<salaxy-calc-list category="error"></salaxy-calc-list>'), s.put("salaxy-components/pages-personal/calc/index.html", `<div class="row d-sm-none d-block">
  <div class="col-xs-12" ng-if="!$ctrl.hideButton">
    <div style="margin-bottom:15px;">
      <salaxy-action-button action="'newCalc'" label="Luo uusi palkkalaskelma"></salaxy-action-button>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-sm-6 col-xs-12">
    <salaxy-calc-list category="received" mode="panel" limit-to="5" read-only="'household' | sxyIsInRole"></salaxy-calc-list>
  </div>
  <div class="col-sm-6 col-xs-12">
    <salaxy-odata-table url="/v03/api/calculations/category/all" crud-controller="CalculationCrudController as $crud" options="{$top: 5, $filter: 'status eq \\'workerRequested\\' or status eq \\'workerRequestAccepted\\' or status eq \\'workerRequestDeclined\\' or status eq \\'draft\\'', $orderby:  'createdAt desc'}"
      template-url="salaxy-components/odata/lists/CalculationsPanel.html" data="{ category: 'sentAndDraft' }">
    </salaxy-odata-table>
  </div>
</div>`), s.put("salaxy-components/pages-personal/calc/paid-household.html", `<salaxy-action-button action="'newCalc'" label="SALAXY.NG1.ActionButtonComponent.newCalculation" button-class="btn-primary mb-2 hidden-xxs" sxy-if-role="!household"></salaxy-action-button>
<div>
  <salaxy-calc-list category="paid" read-only="true"></salaxy-calc-list>
</div>`), s.put("salaxy-components/pages-personal/calc/paid-worker.html", `<salaxy-action-button action="'newCalc'" label="SALAXY.NG1.ActionButtonComponent.newCalculation" button-class="btn-primary mb-2 hidden-xxs" sxy-if-role="!household"></salaxy-action-button>
<div>
  <salaxy-calc-list category="received"></salaxy-calc-list>
</div>`), s.put("salaxy-components/pages-personal/calc/paid.html", `<salaxy-action-button action="'newCalc'" label="SALAXY.NG1.ActionButtonComponent.newCalculation" button-class="btn-primary mb-2 hidden-xxs"></salaxy-action-button>
<salaxy-calc-list category="received"></salaxy-calc-list>`), s.put("salaxy-components/pages-personal/calc/sent.html", `<p class="lead">
  Olet lähettänyt nämä palkkalaskelmat työnantajalle maksettavaksi.
</p>
<salaxy-action-button action="'newCalc'" label="SALAXY.NG1.ActionButtonComponent.newCalculation" button-class="btn-primary mb-2 hidden-xxs" sxy-if-role="!household"></salaxy-action-button>
<salaxy-calc-list category="sent"></salaxy-calc-list>`), s.put("salaxy-components/pages-personal/calc/shared.html", '<salaxy-calc-list category="shared" read-only="true"></salaxy-calc-list>'), s.put("salaxy-components/pages-personal/calc/sharing.html", `<salaxy-calc-sharing model="'url'"></salaxy-calc-sharing>`), s.put("salaxy-components/pages-personal/employers/index.html", `<!--
  This is currently in test only and Palkkamylly
  TODO: Move component to Palkkamylly and remove from NG1 (may be recreated in Omapalkka)
-->
<salaxy-employer-list></salaxy-employer-list>`), s.put("salaxy-components/pages-personal/home/error404.html", `<div class="alert alert-danger">
  <span sxy-text="SALAXY.NG1_PagesPersonal.error404"></span><br />
</div>`), s.put("salaxy-components/pages-personal/home/index.html", `<div ng-controller="WelcomeController as $welcomeCtrl">

  <div sxy-if-role="anon" class="alert alert-danger" sxy-html="SALAXY.NG1_PagesPersonal.index.alert.anon.html"></div>
  <div sxy-if-role="company" class="alert alert-danger" sxy-html="SALAXY.NG1_PagesPersonal.index.alert.company.html"></div>
  <div sxy-if-role="person">
    <div class="salaxy-component salaxy-component-welcome">
      <div class="" ng-if="!$welcomeCtrl.workerDataNew.timeline">
        <salaxy-spinner></salaxy-spinner>
      </div>

      <div class="timeline my-5 mx-auto px-2">
        <div ng-if="$welcomeCtrl.hasSystemAlert">
          <div>
            <div class="salaxy-welcome-system-alert alert-has-system-alert" ng-bind-html="$welcomeCtrl.systemAlertHtml"></div>
          </div>
        </div>
        <div ng-if="$welcomeCtrl.workerDataNew.timeline" class="d-sm-none d-block timeline-topbar">
          <div class="row mb-3">
            <div class="col-6">
              <salaxy-action-button action="'newTaxcard'" label="SALAXY.NG1.WelcomeComponent.taxcard" button-class="btn-labeled-right btn-primary btn-block"></salaxy-action-button>
            </div>
            <div class="col-6">
              <salaxy-action-button action="'newCalc'" label="SALAXY.NG1.ActionButtonComponent.newCalculationAlt" button-class="btn-labeled-right btn-secondary btn-block"></salaxy-action-button>
            </div>
          </div>
          <div class="list-panel panel panel-sm panel-secondary panel-own-taxcard panel-secondary">
            <div ng-show="$welcomeCtrl.workerUI.taxCardAdded" class="salaxy-component table-responsive panel-content md-height">
              <div class="panel-content md-height">
                <div class="panel-body no-vertical-padding salaxy-tax-card-chart chart-container" style="max-height:216px; padding-top:0; padding-bottom:0; padding-left:5px;padding-right:5px;">               
                  <salaxy-chart ng-if="$welcomeCtrl.taxcardChartData.limits.hasLimit == true" custom-height="210px" config="$welcomeCtrl.taxcardMobileChartData"></salaxy-chart>
                  <salaxy-chart ng-if="$welcomeCtrl.taxcardChartData.limits.hasLimit == false || !$welcomeCtrl.taxcardChartData.limits.hasLimit" custom-height="200px" config="$welcomeCtrl.taxcardChartData.config"></salaxy-chart>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div ng-repeat="item in $welcomeCtrl.workerDataNew.timeline" class="mb-3">
          <div class="card personal-timeline-card" ng-class="{'card-paid' : item.type == 'calculationPaid'}">
            <div class="card-header d-flex">
              <div class="icon-container d-flex justify-content-center align-items-center" ng-class="{
                'accepted': (item.status == 'workerRequestAccepted' || item.status == 'sharedApproved'), 
                'requested': (item.status == 'workerRequested'|| item.status == 'shared'), 
                'paid' : item.type == 'calculationPaid', 
                'rejected' : (item.status == 'workerRequestDeclined' || item.status == 'sharedRejected' || item.status == 'sharedRejectedWithoutOpen')
              }">
                <i class="bi" ng-class="{
                  'bi-person-vcard': item.type == 'employment', 
                  'bi-person-fill': item.type == 'personAccount', 
                  'bi-calculator-fill': (item.type == 'calculation' && item.status != 'workerRequestAccepted' && item.status != 'workerRequestDeclined' && item.status != 'workerRequested' ),
                  'bi-reply-fill' : (item.status == 'workerRequestAccepted' || item.status == 'sharedApproved'), 
                  'bi-file-earmark-text': (item.type == 'taxcard' && item.status != 'shared' && item.status != 'sharedApproved' && item.status != 'sharedRejected' && item.status != 'sharedRejectedWithoutOpen'), 
                  'bi-arrow-90deg-right' : (item.status == 'shared' || item.status == 'workerRequested'), 
                  'bi-check-lg' : item.type == 'calculationPaid',
                  'bi-x-lg' : (item.status == 'workerRequestDeclined' || item.status == 'sharedRejected' || item.status == 'sharedRejectedWithoutOpen'),
                }">
                </i>
              </div>
              <!--<div class="float-end actions-container clickable text-center">
              <i class="bi bi-three-dots" style="font-size:1.3em;"></i></div>-->
              <div>
                <h3 class="card-title mb-0">{{ item.shortText }}</h3>
                <div class="date">{{ item.logicalDate | sxyDate }}</div>
              </div>
            </div>
            <div class="card-body" ng-class="{'card-body' : !$welcomeCtrl.getPreviewUrl(item)}">
              <div ng-if="$welcomeCtrl.getPreviewUrl(item)" style="max-height: 200px; overflow: hidden;">
                <img ng-src="{{$welcomeCtrl.getPreviewUrl(item)}}" style="width: 100%;" />
              </div>
              <div ng-if="!$welcomeCtrl.getPreviewUrl(item)" ng-switch="item.type">
                <div ng-switch-when="calculation">
                  <div ng-if="item.status != 'draft'" class="otherparty-container">
                    <salaxy-avatar avatar="item.otherPartyInfo.avatar"></salaxy-avatar>
                    <span>{{item.otherPartyInfo.avatar.displayName}}</span>
                  </div>

                  <div class="card-main text-center" ng-class="{'accepted': item.status == 'workerRequestAccepted', 'requested' : item.status == 'workerRequested', 'rejected' : item.status == 'workerRequestDeclined' }">
                    <span class="">{{item.grossSalary | currency}}</span>
                  </div>
                  <div class="card-details-title" sxy-text="SALAXY.NG1_PagesPersonal.index.calculation.grossSalary"></div>
                  <div class="card-details text-center">
                    <span><span sxy-text="SALAXY.NG1_PagesPersonal.index.calculation.netSalary"></span>: {{ item.data.workerPayment | currency }}</span><br>
                    <span><span sxy-text="SALAXY.NG1_PagesPersonal.index.calculation.taxes"></span>: {{ item.data.taxPayment | currency }}</span>
                  </div>
                </div>
                <div ng-switch-when="calculationPaid">
                  <div class="otherparty-container">
                    <salaxy-avatar avatar="item.otherPartyInfo.avatar"></salaxy-avatar>
                    <span>{{item.otherPartyInfo.avatar.displayName}}</span>
                  </div>

                  <div class="card-main text-center paid-calc">
                    <span class="">{{item.grossSalary | currency}}</span>
                  </div>
                  <div class="card-details-title" sxy-text="SALAXY.NG1_PagesPersonal.index.calculation.grossSalary"></div>
                  <div class="card-details text-center">
                    <span><span sxy-text="SALAXY.NG1_PagesPersonal.index.calculation.netSalary"></span>: {{ item.data.workerPayment | currency }}</span><br>
                    <span><span sxy-text="SALAXY.NG1_PagesPersonal.index.calculation.taxes"></span>: {{ item.data.taxPayment | currency }}</span>
                  </div>
                </div>
                <div ng-switch-when="taxcard">
                  <div ng-if="item.status == 'sharedApproved' || item.status == 'sharedRejected' || item.status == 'sharedRejectedWithoutOpen'" class="otherparty-container">
                    <salaxy-avatar avatar="item.ownerInfo.avatar"></salaxy-avatar>
                    <span>{{item.ownerInfo.avatar.displayName}}</span>
                  </div>
                  <div ng-if="item.data.taxPercent" class="card-main text-center" ng-class="{'accepted' : item.status == 'sharedApproved', 'requested' : item.status == 'shared', 'rejected' : (item.status == 'sharedRejected' || item.status == 'sharedRejectedWithoutOpen') }">
                    <span class="">{{item.data.taxPercent || "-"}} %</span>
                  </div>
                  <div class="card-details-title" ng-if="item.data.taxPercent" sxy-text="SALAXY.NG1_PagesPersonal.index.taxcard.taxPercent"></div>
                  <div ng-if="item.data.taxPercent" class="card-details text-center">
                    <strong> {{ "TaxcardKind." + item.data.kind | sxyEnum }}</strong><br>
                    <span ng-if="item.data.incomeLimit"><span sxy-text="SALAXY.NG1_PagesPersonal.index.taxcard.incomeLimit"></span>: {{ item.data.incomeLimit | currency }}</span><br>
                    <span ng-if="item.data.taxPercent2"><span sxy-text="SALAXY.NG1_PagesPersonal.index.taxcard.taxPercent2"></span>: {{ item.data.taxPercent2 }} %</span>
                  </div>
                </div>
                <div ng-switch-when="personAccount">
                  <div class="text-primary">{{ item.ownerInfo.displayName }}</div>
                  <div><a href="mailto:{{ item.ownerInfo.email }}">{{ item.ownerInfo.email }}</a></div>
                  <div><span sxy-text="SALAXY.NG1_PagesPersonal.index.account.iban"></span>: {{ item.ownerInfo.ibanNumber | sxyIban }}</div>
                  <div><span sxy-text="SALAXY.NG1_PagesPersonal.index.account.phone"></span>: {{ item.ownerInfo.telephone }}</div>
                </div>
                <div ng-switch-when="employment">
                  <div class="row">
                    <div class="col-6 text-center">
                      <div class="otherparty-container">
                        <salaxy-avatar avatar="item.ownerInfo.avatar"></salaxy-avatar>
                      </div>
                      <span> {{ item.ownerInfo.avatar.displayName}}</span>
                    </div>
                    <div class="col-6 text-center">
                      <div class="otherparty-container">
                        <salaxy-avatar avatar="item.otherPartyInfo.avatar"></salaxy-avatar>
                      </div>
                      <span> {{ item.otherPartyInfo.avatar.displayName}}</span>
                    </div>
                  </div>
                </div>
                <div ng-switch-default>
                  <!--TODO: Handle {{ item.type }}-->
                </div>
              </div>
              <div class="collapse small" ng-class="{show: item.showInfo}">
                <pre>{{ item | json }}</pre>
              </div>
            </div>
            <div class="card-footer">
              <span ng-switch="item.type">
                <span ng-switch-when="calculationPaid">
                  <a class="btn btn-sm btn-white" target="_blank" ng-href="{{$welcomeCtrl.getPdfUrl(item, true)}}" sxy-text="SALAXY.NG1_PagesPersonal.index.calculation.buttons.openCalculationBtn"></a>
                  <a ng-href="{{$welcomeCtrl.getPdfUrl(item)}}" class="btn btn-sm btn-white" title="tuloste" sxy-text="SALAXY.NG1_PagesPersonal.index.calculation.buttons.downloadPdfBtn"></a>
                </span>
              <a ng-switch-when="calculation" href="#/calc/details/{{item.id}}" class="btn btn-secondary btn-sm" sxy-text="SALAXY.NG1_PagesPersonal.index.calculation.buttons.showCalculationBtn"></a>
              <a ng-switch-when="taxcard" href="#/taxcards" class="btn btn-secondary btn-sm" sxy-text="SALAXY.NG1_PagesPersonal.index.taxcard.buttons.showTaxcardsBtn"></a>
              <a ng-switch-when="personAccount" href="#/account" class="btn btn-secondary btn-sm" sxy-text="SALAXY.NG1_PagesPersonal.index.account.showAccountInfoBtn"></a>
              </span>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>`), s.put("salaxy-components/pages-personal/taxcards/household.html", `<div>
  <salaxy-tax-cards-list></salaxy-tax-cards-list>
</div>`), s.put("salaxy-components/pages-personal/taxcards/index.html", `<div class="salaxy-my-taxcards">
  <div ng-controller="MyTaxcardsController as $ctrl">
    <salaxy-spinner ng-if="!$ctrl.current"></salaxy-spinner>
    <div ng-if="$ctrl.current" class="light-bg mb-2">
      <div ng-if="!$ctrl.current.active">
        <p class="lead">
          <span sxy-html="SALAXY.NG1_PagesPersonal.taxcards.introGetAutoTaxcard.html"></span>
        </p>
        <div class="salaxy-placeholder-empty placeholder-md text-center">
          <button type="button" class="btn btn-primary" ng-click="$ctrl.setSharedAutoForSelf()"
            sxy-text="SALAXY.NG1_PagesPersonal.taxcards.buttons.getTaxPercentsBtn"></button>
        </div>
      </div>
      <div ng-if="$ctrl.current.active">
        <div ng-if="$ctrl.current.active.card.kind != 'auto'">
          <p class="lead">
            <span sxy-html="SALAXY.NG1_PagesPersonal.taxcards.introGetAutoTaxcard.html"></span>
            <a href="" ng-click="$ctrl.showMoreText = true" ng-if="!$ctrl.showMoreText" sxy-text="SALAXY.UI_Terms.readMore"></a>
          </p>
        </div>
        <div ng-if="$ctrl.current.active.card.kind == 'auto'" sxy-html="SALAXY.NG1_PagesPersonal.taxcards.intro.html"></div>
        <button type="button" class="btn btn-default float-end" ng-click="$ctrl.setSharedAutoForSelf()"
          sxy-text="SALAXY.NG1_PagesPersonal.taxcards.buttons.checkTaxPercentsBtn"></button>
        <h3 sxy-text="SALAXY.NG1.WorkerDetailsComponent.currentTaxCard"></h3>
        <ng-include src="'salaxy-components/pages-personal/taxcards/TaxcardDetails_Personal.html'"></ng-include>
      </div>
    </div>
    <div ng-if="$ctrl.current" class="light-bg">
      <salaxy-tab-buttons
        current-tab="$ctrl.currentTab"
        options="[
          { value: 'calc', text: 'SALAXY.NG1_PagesPersonal.taxcards.calcsPaidForCardTabHeading', hidden: !$ctrl.current.active },
          { value: 'employers', text: 'SALAXY.NG1_PagesPersonal.taxcards.employersTabHeading', hidden: !$ctrl.current.employers },
          { value: 'history', text: 'SALAXY.NG1_PagesPersonal.taxcards.earlierTaxCardsTabHeading', hidden: !$ctrl.current.list.length > 0 },
        ]"
        tabs-id="taxcardsIndex">
      </salaxy-tab-buttons>
      <div class="tab-content" id="tab-content-taxcardsIndex">
        <div class="tab-pane" id="calc-tab" ng-if="$ctrl.current.active">
          <salaxy-taxcard-income-log parent="$ctrl.current.active" ng-ref="$ctrl.$incomeLog"></salaxy-taxcard-income-log>
        </div>
        <div class="tab-pane" id="employers-tab" ng-if="$ctrl.current.employers">
          <table class="table table-striped">
            <thead>
              <tr>
                <th class="th-xxs" colspan="2">
                  <div sxy-text="SALAXY.NG1_PagesPersonal.taxcards.employerTableHeading"></div>
                  <div sxy-text="SALAXY.NG1_PagesPersonal.taxcards.typeTableHeading"></div>
                </th>
                <th class="d-none d-md-table-cell " sxy-text="SALAXY.NG1_PagesPersonal.taxcards.yearTableHeading"></th>
                <th class="d-none d-md-table-cell text-end">
                  <div sxy-text="SALAXY.MODEL.TaxcardData.taxPercent.title"></div>
                  <div sxy-text="SALAXY.MODEL.TaxcardData.taxPercent2.title"></div>
                </th>
                <th class="text-end">
                  <div sxy-text="SALAXY.NG1.CurrentTaxCardComponent.salariesPaid"></div>
                  <div sxy-text="SALAXY.NG1_PagesPersonal.taxcards.incomeLimitTableHeading"></div>
                </th>
                <th class="text-end">
                  <div sxy-text="SALAXY.NG1_PagesPersonal.taxcards.validDateTableHeading"></div>
                  <div sxy-text="SALAXY.NG1_PagesPersonal.taxcards.startDateTableHeading"></div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr ng-repeat="taxCard in $ctrl.current.employers">
                <td class="align-middle td-avatar">
                  <salaxy-avatar avatar="taxCard.ownerInfo.avatar"></salaxy-avatar>
                </td>
                <td>
                  <div class="d-md-none"><strong>{{taxCard.ownerInfo.avatar.displayName}}</strong></div>
                  <div class="d-md-none">
                    <strong>{{ "TaxcardKind." + taxCard.data.kind | sxyEnum }} {{ taxCard.data.forYear }}</strong>
                    {{taxCard.data.taxPercent}} %
                    <span ng-if="taxCard.data.taxPercent2 != null">({{ taxCard.data.taxPercent2 }} %)</span>
                  </div>
                  <div class="d-none d-md-block"><strong>{{taxCard.ownerInfo.avatar.displayName}}</strong></div>
                  <div class="d-none d-md-block">{{ "TaxcardKind." + taxCard.data.kind | sxyEnum }}</div>
                </td>
                <td class="d-none d-md-table-cell ">{{ taxCard.data.forYear }}</td>
                <td class="d-none d-md-table-cell text-end">
                  <div>{{taxCard.data.taxPercent}} %</div>
                  <div>{{taxCard.data.taxPercent2 != null ? (taxCard.data.taxPercent2 + ' %') : '-'}}</div>
                </td>
                <td class="text-end">
                  <div>{{ taxCard.data.totalIncome | currency: ' €' : 0 }}</div>
                  <div>{{(taxCard.data.incomeLimit | currency: ' €' : 0) || '-'}}</div>
                </td>
                <td class="text-end">
                  <div>{{ taxCard.data | sxyDateRange }}</div>
                  <div>{{ taxCard.createdAt | sxyTime }}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="tab-pane" id="history-tab" ng-if="$ctrl.current.list.length > 0">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>
                  <div sxy-text="SALAXY.NG1_PagesPersonal.taxcards.validDateTableHeading"></div>
                  <div sxy-text="SALAXY.NG1_PagesPersonal.taxcards.startDateTableHeading"></div>
                </th>
                <th sxy-text="SALAXY.NG1_PagesPersonal.taxcards.yearTableHeading"></th>
                <th class="d-none d-md-table-cell text-end">
                  <div sxy-text="SALAXY.MODEL.TaxcardData.taxPercent.title"></div>
                  <div sxy-text="SALAXY.MODEL.TaxcardData.taxPercent2.title"></div>
                </th>
                <th class="d-table-cell d-md-none text-end">%</th>
                <th class="d-table-cell d-md-none text-end" colspan="2">
                  <div sxy-text="SALAXY.NG1.CurrentTaxCardComponent.salariesPaid"></div>
                  <div sxy-text="SALAXY.NG1_PagesPersonal.taxcards.incomeLimitTableHeading"></div>
                </th>
                <th class="d-none d-md-table-cell text-end">
                  <div sxy-text="SALAXY.NG1.CurrentTaxCardComponent.salariesPaid"></div>
                  <div sxy-text="SALAXY.NG1_PagesPersonal.taxcards.incomeLimitTableHeading"></div>
                </th>
                <th class="d-none d-md-table-cell text-end"></th>
              </tr>
            </thead>
            <tbody>
              <tr ng-repeat="taxCard in $ctrl.current.list">
                <td>
                  <div>{{ taxCard.data | sxyDateRange }}</div>
                  <div>{{ taxCard.createdAt | sxyTime }}</div>
                </td>
                <td>{{ taxCard.data.forYear }}</td>
                <td class="text-end">
                  <div>{{taxCard.data.taxPercent}}&nbsp;%</div>
                  <div>{{taxCard.data.taxPercent2 != null ? (taxCard.data.taxPercent2 + '&nbsp;%') : '-'}}</div>
                </td>
                <td class="text-end">
                  <div>{{ taxCard.data.totalIncome | currency: ' €' : 0 }}</div>
                  <div>{{(taxCard.data.incomeLimit | currency: ' €' : 0) || '-'}}</div>
                </td>
                <td class="middle-align text-end" ng-if="!taxCard.isReadOnly">
                  <button class="btn btn-danger btn-sm" ng-click="$ctrl.deleteTaxCard(taxCard.id)">
                    <span title="{{'SALAXY.UI_Terms.delete' | sxyTranslate}}">&times;</span>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>`), s.put("salaxy-components/pages-personal/taxcards/TaxcardDetails_Personal.html", `<div>
  <div class="row">
    <div class="col-md-7 col-lg-7" ng-switch="$ctrl.chartType">
      <div ng-switch-when="full" class="salaxy-tax-card-chart chart-container">    
          <salaxy-chart custom-height="400px" config="$ctrl.getMainChartConfig($ctrl.current.active)"></salaxy-chart>
      </div>
      <div ng-switch-when="pie" class="salaxy-tax-card-chart chart-container text-center">      
          <salaxy-chart style="height: 400px; position: relative;" config="$ctrl.getPieChartConfig($ctrl.current.active)"></salaxy-chart>
      </div>
    </div>
    <div class="col-md-5 col-lg-5">
      <div class="row current-taxcard-row table-row">
        <div class="col-xs-12">
          <strong sxy-text="SALAXY.NG1.CurrentTaxCardComponent.taxCardKind"></strong><br /> {{ 'TaxcardKind.' + $ctrl.current.active.card.kind | sxyEnum }}
          ({{$ctrl.current.active.card.forYear}})
        </div>
      </div>
      <div class="row current-taxcard-row table-row">
        <div class="col-xs-8">
          <strong sxy-text="SALAXY.NG1.CurrentTaxCardComponent.validDate"></strong><br /> {{$ctrl.current.active.card.validity.start | date}} - {{$ctrl.current.active.card.validity.end | date}}
        </div>
        <div class="col-xs-4 text-right">
          <strong sxy-text="SALAXY.NG1.CurrentTaxCardComponent.taxCardAdded"></strong><br />
          <span title="{{ $ctrl.current.active.createdAt | date : 'short' }}">{{ $ctrl.current.active.createdAt | sxyDate }}</span>
        </div>
      </div>
      <table class="table table-sm" style="margin-bottom: 0; margin-top: 6px">
        <thead>
          <tr>
            <th colspan="2" style="padding-left: 0;"><span sxy-text="SALAXY.NG1.CurrentTaxCardComponent.mainTaxPercent2"></span></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td sxy-text="SALAXY.NG1.CurrentTaxCardComponent.basicPercent"></td>
            <td class="right">{{ $ctrl.current.active.card.taxPercent }} %</td>
          </tr>
          <tr ng-if="!$ctrl.current.active.card.incomeLimit">
            <td colspan="2"><span sxy-text="SALAXY.NG1.CurrentTaxCardComponent.noIncomeLimit"></span></td>
          </tr>
          <tr ng-if="$ctrl.current.active.card.incomeLimit">
            <td><span sxy-text="SALAXY.NG1.CurrentTaxCardComponent.taxPercent2.name"></span> <small>(tulorajan {{ $ctrl.current.active.card.incomeLimit | currency : '€' : 0 }}
                {{'SALAXY.NG1.CurrentTaxCardComponent.after' | sxyTranslate}})</small></td>
            <td class="right">{{ $ctrl.current.active.card.taxPercent2 || "-" }} %</td>
          </tr>
          <tr ng-if="$ctrl.current.active.card.taxPercentMin">
            <!-- Only needed if the view is used for showing Employer taxcards: Worker taxcards no longer can have a minimum. -->
            <td>
              <span sxy-text="SALAXY.NG1.CurrentTaxCardComponent.taxPercentMin.title"></span>
            </td>
            <td class="right">
              <span>{{ $ctrl.current.active.card.taxPercentMin || "-" }} %</span>
            </td>
          </tr>
          <tr ng-if="$ctrl.current.active.card.kind == 'auto'">
            <td colspan="2">
              <span class="text-info" ng-if="$ctrl.current.active.card.lastChecked != '2000-01-01T00:00:00Z'"><small>{{'SALAXY.NG1.CurrentTaxCardComponent.taxCardChecked' | sxyTranslate}}
                  {{$ctrl.current.active.card.lastChecked | date: "dd.MM.yyyy HH:mm"}}</small></span>
              <br />
              <button type="button" ng-click="$ctrl.setSharedAutoForSelf()"
                class="btn btn-info">{{'SALAXY.NG1.CurrentTaxCardComponent.checkAutomaticTaxCard' | sxyTranslate}}</button>
            </td>
          </tr>
        </tbody>
      </table>
      <table class="table table-sm" style="margin-top: 6px" ng-if="$ctrl.current.active.card.incomeLimit">
        <thead>
          <tr>
            <th colspan="2" style="padding-left: 0;"><strong sxy-text="SALAXY.NG1.CurrentTaxCardComponent.incomeLimit"></strong></th>
            <th class="right">{{ $ctrl.current.active.card.incomeLimit | currency : '€' : 0 }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="width: 20px;" class="text-center">-</td>
            <td><span sxy-text="SALAXY.NG1.CurrentTaxCardComponent.salariesPaid"></span></td>
            <td class="right">{{ $ctrl.current.active.result.totalIncome | currency }}</td>
          </tr>
          <tr ng-if="$ctrl.current.active.result.totalIncomeJanuary">
            <td></td>
            <td>...<span sxy-text="SALAXY.NG1.CurrentTaxCardComponent.inJanuary"></span></td>
            <td class="right">{{ $ctrl.current.active.result.totalIncomeJanuary | currency }}</td>
          </tr>
          <tr class="total">
            <td colspan="2"><span sxy-text="SALAXY.NG1.CurrentTaxCardComponent.beforeIncomeLimit"></span></td>
            <td class="right">{{ $ctrl.current.active.card.incomeLimit - $ctrl.current.active.result.totalIncome | currency }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>`), s.put("salaxy-components/pages-personal/templates/WorkerLayout.html", `<div ng-cloak class="salaxy-component salaxy-navi-page-container container-personal d-flex" ng-class="($ctrl.isNaviOpen ? 'salaxy-navi-sm-opened ' : '') + $ctrl.current.cssClass" ng-if="!$ctrl.showFullPageLoader">
  <div class="salaxy-navi-sidebar d-print-none" ng-if="!$ctrl.showFullPageLoader">
    <div class="salaxy-logo-container">
      <a href="/#/"><!--<img src="/img/navi-logo.png" />--></a>
    </div>
    <div ng-controller="SessionController as $session">
      <div class="salaxy-login-button text-center" style="padding:7px;" ng-hide="$session.isAuthenticated">
        <button ng-click="$session.signIn()" class="btn btn-default salaxy-login-button-login">
        <i class="bi bi-lock-fill me-2"></i>
        <span class="salaxy-login-button-text">{{ $session.isSessionChecking ?  ('SALAXY.NG1.LoginButtonComponent.searching' | sxyTranslate) : ('SALAXY.UI_Terms.login' | sxyTranslate) }}</span>
      </button>
      </div>
      <div class="salaxy-login-button-personal p-2" ng-controller="PersonalWebLegacyController as $legacy">
        <div ng-show="$session.isAuthenticated" class="salaxy-login-button-logout d-flex" ng-init="isNavCollapsed = true">
          <salaxy-avatar avatar="$session.avatar"></salaxy-avatar>
          <div class="login-text ms-2">
            <div class="salaxy-login-button-text">
            {{ $session.isAuthenticated ? $session.avatar.displayName : ('SALAXY.NG1.LoginButtonComponent.authenticating' | sxyTranslate) }}
            </div>
            <div class="d-flex flex-column align-items-start">
              <button ng-if="$session.isAuthenticated" ng-click="$legacy.signOut()" class="btn btn-transparent btn-xs"><i class="bi bi-box-arrow-right me-1" aria-hidden="true" style="font-size: 150%;"></i> <span class="" sxy-text="SALAXY.UI_Terms.logout"></span></button>
              <div class="btn-group language-selection btn-group-xs dropdown" ng-show="'test' | sxyIsInRole" ng-controller="PersonAccountController as $accountCtrl">
                <button type="button" class="btn btn-transparent dropdown-toggle" data-bs-toggle="dropdown">
                  <i class="bi bi-globe-americas me-1" style="font-size:1.1em;"></i>
                  <span> {{"SALAXY.ENUM.Language." + $accountCtrl.getAccountLanguage() + ".label" | sxyTranslate}}</span> 
                  <i class="bi bi-chevron-down"></i>
                </button>
                <ul class="dropdown-menu" role="menu" aria-labelledby="single-button">
                  <li role="menuitem" ng-if="$accountCtrl.getAccountLanguage() != 'fi'"><a ng-click="$accountCtrl.current.language = 'fi'; $accountCtrl.saveCurrent()">Suomi</a></li>
                  <li role="menuitem" ng-if="$accountCtrl.getAccountLanguage() != 'en'"><a ng-click="$accountCtrl.current.language = 'en'; $accountCtrl.saveCurrent()">English</a></li>
                  <li role="menuitem" ng-if="$accountCtrl.getAccountLanguage() != 'sv'"><a ng-click="$accountCtrl.current.language = 'sv';$accountCtrl.saveCurrent()">Svenska</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <salaxy-navi-sitemap template-url="salaxy-components/pages-personal/templates/WorkerSitemap.html" mode="accordion"></salaxy-navi-sitemap>
  </div>
  <header class="salaxy-navi-header-mobile align-items-center">
    <h1 class="d-inline">{{ $ctrl.title | sxyTranslate }}</h1>
    <div class="btn-group btn-group-login-button dropdown ms-auto" ng-controller="SessionController as $session">
      <button ng-hide="$session.isAuthenticated" ng-click="$session.signIn()" class="btn btn-default salaxy-login-button-login">
        <i class="bi bi-lock-fill me-2"></i>
        <span class="salaxy-login-button-text">{{ $ctrl.isSessionChecking ?  ('SALAXY.NG1.LoginButtonComponent.searching' | sxyTranslate) : ('SALAXY.UI_Terms.login' | sxyTranslate) }}</span>
      </button>
      <div class="login-button d-flex align-items-center dropdown-toggle" type="button" data-bs-toggle="dropdown" ng-show="$session.isAuthenticated">
        <salaxy-avatar avatar="$session.avatar" style="font-size: 2em;"></salaxy-avatar>
      </div>
      <ul ng-controller="PersonalWebLegacyController as $legacy" class="dropdown-menu" role="menu">
        <li>
          <a class="dropdown-item" href="#" ng-click="$legacy.signOut()" sxy-text="SALAXY.UI_Terms.logout"></a>
        </li>
      </ul>
    </div>
    <button type="button" class="salaxy-navi-hamburger btn btn-default ms-2" ng-click="$ctrl.toggleNavi()">
      <span class="sr-only" sxy-text="SALAXY.UI_Terms.navigation"></span>
      <i class="bi bi-list m-0" aria-hidden="true"></i>
    </button>
  </header>
  <div class="salaxy-navi-main-container pb-5">
    <content>
      <ng-transclude ng-transclude-slot="header">
      </ng-transclude>
      <div id="salaxy-alert-container"></div>
      <ng-transclude ng-transclude-slot="main">
        <main>
          <div class="d-none d-md-block">
            <div ng-class="$ctrl.current.isFullWidth ? 'container-fluid' : 'container'">

              <div class="row" ng-if="$ctrl.current.id != 'home'">
                <div class="col-xs-12">
                  <h1 class="page-title">
                    {{ $ctrl.title | sxyTranslate }}
                  </h1>
                </div>
              </div>
            </div>
          </div>
          <div ng-class="$ctrl.current.isFullWidth ? 'container-fluid' :  'container'" ng-view autoscroll="true"></div>
        </main>
      </ng-transclude>
    </content>
  </div>
  <div ng-if="$ctrl.current.id == 'home'">
    <div ng-controller="WelcomeController as $welcomeCtrl" sxy-if-role="worker">
      <div ng-if="$welcomeCtrl.workerDataNew.timeline" class="timeline-sidebar d-none d-sm-block position-fixed me-3 mt-3">
        <div class="list-card card card-sm card-secondary card-own-taxcard card-secondary mb-4">
          <div class="card-header" sxy-text="SALAXY.NG1.WelcomeComponent.taxcard"></div>
          <div ng-show="$welcomeCtrl.workerUI.taxCardAdded" class="salaxy-component table-responsive card-content md-height">
            <div class="card-content md-height">
              <div class="card-body no-vertical-padding salaxy-tax-card-chart chart-container" style="max-height:230px; padding-top:0; padding-bottom:0; padding-left:5px;padding-right:5px;">              
                <salaxy-chart ng-if="$welcomeCtrl.taxcardChartData.limits.hasLimit == true" custom-height="210px" config="$welcomeCtrl.taxcardChartData.config"></salaxy-chart>             
                <salaxy-chart ng-if="$welcomeCtrl.taxcardChartData.limits.hasLimit == false || !$welcomeCtrl.taxcardChartData.limits.hasLimit" config="$welcomeCtrl.taxcardChartData.config"></salaxy-chart>
              </div>
            </div>
          </div>
          <div ng-show="!$welcomeCtrl.workerUI.taxCardAdded" class="card-body card-content md-height align-middle">
            <div class="text-center">
              <p sxy-text="SALAXY.NG1_PagesPersonal.taxcards.buttons.getTaxPercentsBtn"></p>
            </div>
          </div>
          <div class="card-footer text-center">
            <a class="btn btn-primary btn-sm" href="#/taxcards" sxy-text="SALAXY.NG1.WelcomeComponent.taxcard"></a>

          </div>
        </div>
        <div class="list-card card card-sm card-secondary card-new-calculation">
          <div class="card-header" sxy-text="SALAXY.NG1_PagesPersonal.index.sendCalculation.panelHeading"></div>
          <div class="card-body card-content">
            <div class="text-center">
              <h3 class="text-warning" sxy-text="SALAXY.NG1_PagesPersonal.index.sendCalculation.panelTitle"></h3>
              <p sxy-text="SALAXY.NG1_PagesPersonal.index.sendCalculation.panelText"></p>
            </div>
          </div>
          <div class="card-footer text-center">
            <a class="btn btn-primary btn-sm" href="#/calc/details/new" sxy-text="SALAXY.NG1_PagesPersonal.index.sendCalculation.button"></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>`), s.put("salaxy-components/pages-personal/templates/WorkerSitemap.html", `<div class="salaxy-component salaxy-navi-sitemap">
  <ul class="list-group">
    <li ng-repeat="section in $ctrl.sitemap | filter:{ hidden: '!true' }" class="list-group-item">
      <a ng-href="{{section.id != 'abc' ? section.url : 'https://help.palkkaus.fi/hc/fi'}}" ng-attr-target="{{section.id == 'abc' ? '_blank' : undefined}}" ng-click="!section.children || !section.children.length ? $ctrl.toggleNavi() : return" ng-class="{ 'active' : $ctrl.isCurrent(section)}">
        <span ng-if="$ctrl.mode=='accordion' && section.children && section.children.length">
          <i class="bi bi-chevron-down float-end" ng-class="{'upside' : $ctrl.getSectionId() == section.id}" aria-hidden="true"></i>
        </span> {{section.title | sxyTranslate}}
      </a>
      <ul ng-hide="!section.children.length || ($ctrl.mode=='accordion' && $ctrl.getSectionId() != section.id)">
        <li class="d-sm-none d-block">
          <strong ng-show="$ctrl.isCurrent(section)">
            <a ng-href="{{section.url}}" ng-click="$ctrl.toggleNavi()">{{section.title | sxyTranslate}}</a>
          </strong>
          <span ng-hide="$ctrl.isCurrent(section)">
            <a ng-href="{{section.url}}" ng-click="$ctrl.toggleNavi()">{{section.title | sxyTranslate}}</a>
          </span>
        </li>
        <li ng-repeat="subNavi in section.children | filter:{ hidden: '!true' }">
          <strong ng-show="$ctrl.isCurrent(subNavi)">
            <a ng-href="{{subNavi.url}}" ng-click="$ctrl.toggleNavi()">{{subNavi.title | sxyTranslate}}</a>
          </strong>
          <span ng-hide="$ctrl.isCurrent(subNavi)">
            <a ng-href="{{subNavi.url}}" ng-click="$ctrl.toggleNavi()">{{subNavi.title | sxyTranslate}}</a>
          </span>
        </li>
      </ul>
    </li>
  </ul>

  <div class="poweredby">
    <span class="poweredby-image"></span>
  </div>
</div>`), s.put("salaxy-components/pages-personal/workers/details.html", `<salaxy-worker-details model="'url'" is-read-only-forced="$ctrl.route.readOnly" hide-button="$ctrl.route.readOnly"></salaxy-worker-details>`), s.put("salaxy-components/pages-personal/workers/index.html", `<salaxy-employment-list read-only="'household' | sxyIsInRole"></salaxy-employment-list>`), s.put("salaxy-components/personal/AccountAuthorizationPerson.html", `\uFEFF<div class="salaxy-component salaxy-account-authorization-person">
  <form name="accountAuthorization" sxy-if-role="auth">
    <div class="row">
      <div class="col-12 col-sm-6 col-md-12">
        <legend sxy-text="SALAXY.NG1.AccountAuthorizationPersonComponent.identificationTitle"></legend>
        <div class="row table-row" ng-if="!$ctrl.session.currentAccount.identity.contract.isSigned">
          <div class="col-12 " ng-controller="WorkerOnboardingController as $wizard">
            <strong sxy-text="SALAXY.NG1.AccountAuthorizationPersonComponent.notIdentified"></strong><br>
            <button class="btn btn-primary" ng-click="$wizard.launch()" sxy-text="SALAXY.NG1.AccountAuthorizationPersonComponent.identifyBtn"></button>
          </div>
        </div>
        <div class="row table-row" ng-if="$ctrl.session.currentAccount.identity.contract.isSigned">
          <div class="col-12">
            <strong><span sxy-text-="SALAXY.NG1.AccountAuthorizationPersonComponent.haveIdentified"></span> {{$ctrl.session.currentAccount.identity.contract.signedAt | date}}.</strong>
          </div>
        </div>
        <div class="row table-row">
          <div class="col-12 col-sm-4">
            <strong sxy-text="SALAXY.NG1.AccountAuthorizationPersonComponent.credentialLabel"></strong>
          </div>
          <div class="col-12 col-sm-8">
            {{$ctrl.session.currentCredential.avatar.id}}
          </div>
        </div>
        <div class="row table-row">
          <div class="col-12 col-sm-4">
            <strong sxy-text="SALAXY.NG1.AccountAuthorizationPersonComponent.authorizationTypeLabel"></strong>
          </div>
          <div class="col-12 col-sm-4">
            {{'SALAXY.ENUM.AuthorizationType.' + $ctrl.session.currentAccount.identity.contract.authorizationType + '.label' |sxyTranslate}}
          </div>
          <div class="col-12 col-sm-4  text-end" ng-if="$ctrl.session.currentAccount.identity.contract.authorizationType == 'employerAuthorization'">
            <a class="" ng-href="{{$ctrl.authorizationPdfUrl}}" target="_blank" sxy-text="SALAXY.UI_Terms.seePreview"></a>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-12 mt-4">
        <legend sxy-text="SALAXY.NG1.AccountAuthorizationPersonComponent.userInfoTitle"></legend>
        <div class="row table-row">
          <div class="col-12 col-sm-4">
            <strong sxy-text="SALAXY.NG1.AccountAuthorizationPersonComponent.userNameLabel"></strong>
          </div>
          <div class="col-12 col-sm-8">
            {{$ctrl.session.currentCredential.email}}
          </div>
        </div>
        <div class="row table-row">
          <div class="col-12 col-sm-4">
            <strong sxy-text="SALAXY.NG1.AccountAuthorizationPersonComponent.authMethodLabel"></strong>
          </div>
          <div class="col-12 col-sm-8">
            {{'SALAXY.ENUM.AuthenticationMethod.' + $ctrl.session.currentCredential.authenticationMethod + '.label' |sxyTranslate}}
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-12 mt-4">
        <legend sxy-text="SALAXY.NG1.AccountAuthorizationPersonComponent.termsAndPrivacyTitle"></legend>
        <div class="row table-row">
          <div class="col-12 col-sm-8">
            <strong sxy-text="SALAXY.NG1.AccountAuthorizationPersonComponent.termsLabel"></strong>
          </div>
          <div class="col-12 col-sm-4 text-end">
            <span sxy-html="SALAXY.NG1.AccountAuthorizationPersonComponent.termsBtn.html"></span>
          </div>
        </div>
        <div class="row table-row">
          <div class="col-12 col-sm-8">
            <strong sxy-text="SALAXY.NG1.AccountAuthorizationPersonComponent.privacyLabel"></strong>
          </div>
          <div class="col-12 col-sm-4 text-end">
            <span sxy-html="SALAXY.NG1.AccountAuthorizationPersonComponent.privacyBtn.html"></span>

          </div>
        </div>
        <div class="row table-row">
          <div class="col-12 col-sm-8">
            <strong sxy-text="SALAXY.NG1.AccountAuthorizationPersonComponent.privacyStatementLabel"></strong>
          </div>
          <div class="col-12 col-sm-4 text-end">

            <span sxy-html="SALAXY.NG1.AccountAuthorizationPersonComponent.privacyStatementBtn.html"></span>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>`), s.put("salaxy-components/personal/AccountAvatarEditPerson.html", `<div class="salaxy-component salaxy-account-avatar-edit-person">
  <form name="workerForm" class="form-horizontal" ng-if="$ctrl.current">
    <div class="form-group row">
      <div class="col-4">
        <label for="avatarPreview" class="control-label" style="text-align:left" sxy-text="SALAXY.NG1.AccountAvatarEditPersonComponent.avatarLabel"></label>
      </div>
      <div class="col-8">
        <div class="worker-avatar-col">
          <salaxy-avatar style="font-size: 130px" avatar="$ctrl.current.avatar"></salaxy-avatar>
        </div>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-4">
        <label for="avatarPictureType" class="control-label" style="text-align:left" sxy-text="SALAXY.NG1.AccountAvatarEditPersonComponent.avatarTypeLabel"></label>
      </div>
      <div class="col-8">
        <select class="form-select" id="avatarPictureType" ng-model="$ctrl.current.avatar.pictureType" ng-change="$ctrl.typeForAvatarChanged()">
          <option value="" disabled sxy-text="SALAXY.NG1.AccountAvatarEditPersonComponent.optionChoose"></option>
          <option value="icon" sxy-text="SALAXY.NG1.AccountAvatarEditPersonComponent.optionIcon"></option>
          <option value="uploaded" sxy-text="SALAXY.NG1.AccountAvatarEditPersonComponent.optionUploaded"></option>
          <option value="gravatar" sxy-text="SALAXY.NG1.AccountAvatarEditPersonComponent.optionGravatar"></option>
        </select>
      </div>
    </div>
    <div ng-if="$ctrl.current.avatar.pictureType == 'gravatar'" class="row">
      <div class="input-info col-sm-8 offset-sm-4">
        <div class="input-info-icon"><i class="bi bi-info-circle-fill text-default"></i></div>
        <p class="small input-info-text with-icon " sxy-html="SALAXY.NG1.AccountAvatarEditPersonComponent.gravatarInfo.html"></p>
      </div>
    </div>
    <div ng-if="$ctrl.current.avatar.pictureType == 'icon'">
      <salaxy-input name="avatarInitials" label="SALAXY.NG1.AccountAvatarEditPersonComponent.initialsLabel" ng-model="$ctrl.current.avatar.initials" max-length="2"></salaxy-input>
      <salaxy-input-enum ng-model="$ctrl.current.avatar.color" name="avatarColor" label="SALAXY.NG1.AccountAvatarEditPersonComponent.colorLabel" options="{ '#7F2C2A': ('SALAXY.NG1.AccountAvatarEditPersonComponent.colorBrown' | sxyTranslate), '#91D214': ('SALAXY.NG1.AccountAvatarEditPersonComponent.colorLime' | sxyTranslate), '#61703B': ('SALAXY.NG1.AccountAvatarEditPersonComponent.colorDarkGreen' | sxyTranslate), '#D10074': ('SALAXY.NG1.AccountAvatarEditPersonComponent.colorPink' | sxyTranslate)}">
      </salaxy-input-enum>
    </div>
    <div class="form-group">
      <div ng-if="$ctrl.current.avatar.pictureType == 'uploaded'" class="row">
        <div class="col-4">
          <label for="avatarImageUpload" sxy-text="SALAXY.NG1.AccountAvatarEditPersonComponent.uploadImageLabel"></label>
        </div>
        <div class="col-8">
          <div name="avatarImageUpload" ng-model="avatarImage" ngf-drop="$ctrl.uploadAvatarImage($file)" ngf-select="$ctrl.uploadAvatarImage($file)" class="salaxy-drop-box" ngf-drag-over-class="'salaxy-drag-over'" ngf-multiple="false" ngf-min-size="5KB" ngf-max-size="10MB"
            ngf-pattern="'image/*'" ngf-model-invalid="invalidFile" ng-class="invalidFile.$error != null ? 'error' : ''">
            <span sxy-html="SALAXY.NG1.AccountAvatarEditPersonComponent.uploadImage.html"></span>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-8 offset-sm-4 input-info">
        <div class="input-info-icon"><i class="bi bi-info-circle-fill text-default"></i></div>
        <p class="small input-info-text with-icon" sxy-html="SALAXY.NG1.AccountAvatarEditPersonComponent.avatarDescription.html" style="padding-top:0.4em;"></p>
      </div>
    </div>
    <div class="text-end">
      <button ng-click="$ctrl.saveCurrent()" ng-disabled="workerForm.$invalid" class="btn btn-primary" sxy-text="SALAXY.UI_Terms.save"></button>
    </div>
  </form>
</div>`), s.put("salaxy-components/personal/AccountContactEditPerson.html", `<div class="salaxy-component salaxy-account-contact-edit-person">
  <form name="workerForm" class="form-horizontal" ng-if="$ctrl.current">
    <div class="row">
      <div class="col-12">
        <salaxy-input name="email" label="SALAXY.MODEL.PersonAccount.contact.email.title" sxy-email ng-model="$ctrl.current.contact.email" ng-change="$ctrl.emailForAvatarChanged()">
        </salaxy-input>
        <salaxy-input name="telephone" label="SALAXY.MODEL.PersonAccount.contact.telephone.title" sxy-mobile-phone ng-model="$ctrl.current.contact.telephone"></salaxy-input>
        <salaxy-input name="street" label="SALAXY.MODEL.PersonAccount.contact.street.title" ng-model="$ctrl.current.contact.street" ng-required="'household' | sxyIsInRole"></salaxy-input>
        <div class="row">
          <div class="col-sm-8 offset-sm-4 input-info">
            <div class="input-info-icon"><i class="bi bi-info-circle-fill text-default"></i></div>
            <p class="small input-info-text with-icon" style="padding-top:0.4em;" sxy-text="SALAXY.NG1.AccountContactEditPersonComponent.addressInfo"></p>
          </div>
        </div>
        <salaxy-input name="postalCode" label="SALAXY.MODEL.PersonAccount.contact.postalCode.title" sxy-postal-code-fi ng-model="$ctrl.current.contact.postalCode" ng-required="'household' | sxyIsInRole"></salaxy-input>
        <salaxy-input name="city" label="SALAXY.MODEL.PersonAccount.contact.city.title" ng-model="$ctrl.current.contact.city" ng-required="'household' | sxyIsInRole"></salaxy-input>
      </div>
    </div>
    <div class="text-end">
      <button ng-click="$ctrl.saveCurrent()" ng-disabled="workerForm.$invalid" class="btn btn-primary" sxy-text="SALAXY.UI_Terms.save"></button>
    </div>
  </form>
</div>`), s.put("salaxy-components/personal/AccountDetailsEditPerson.html", `<div class="salaxy-component salaxy-account-details-edit-person">
  <form name="workerForm" class="form-horizontal" ng-if="$ctrl.current">
    <div class="row language-selection mb-2" ng-controller="SessionController as $session">
      <div class="col-4 control-label"><strong class="" sxy-text="SALAXY.NG1.LanguageSelectionComponent.languageSelectionLabel"></strong></div>
      <div class="col-8">

        <div class="btn-group btn-group-sm float-end" role="group">

          <button class="btn" ng-class="$ctrl.getAccountLanguage() == 'fi' ? 'active btn-primary disabled' : 'btn-default'" ng-click="$ctrl.current.language='fi'" sxy-text="SALAXY.ENUM.Language.fi.label"></button>
          <button class="btn" ng-class="$ctrl.getAccountLanguage() == 'en' ? 'active btn-primary disabled' : 'btn-default'" ng-click="$ctrl.current.language='en'" sxy-text="SALAXY.ENUM.Language.en.label"></button>
          <button class="btn" ng-class="$ctrl.getAccountLanguage() == 'sv' ? 'active btn-primary disabled' : 'btn-default'" ng-click="$ctrl.current.language='sv'" sxy-text="SALAXY.ENUM.Language.sv.label"></button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">

        <salaxy-input name="firstName" label="SALAXY.MODEL.PersonAccount.identity.firstName.title" readonly="true" ng-model="$ctrl.current.identity.firstName"></salaxy-input>
        <salaxy-input name="lastName" label="SALAXY.MODEL.PersonAccount.identity.lastName.title" readonly="true" ng-model="$ctrl.current.identity.lastName"></salaxy-input>
        <div class="row">
          <div class="col-sm-6 offset-sm-4 input-info">
            <div class="input-info-icon"><i class="bi bi-info-circle-fill text-default"></i></div>
            <p class="small input-info-text with-icon " sxy-html="SALAXY.NG1.AccountDetailsEditPersonComponent.nameDecription.html"></p>
          </div>
          <div class="col-sm-2">
            <button class="btn btn-default float-end btn-sm" ng-controller="WorkerOnboardingController as $wizard" ng-click="$wizard.launch()" sxy-text="SALAXY.NG1.AccountDetailsEditPersonComponent.launchWizardBtn"></button>
          </div>
        </div>
        <salaxy-input name="officialPersonId" label="SALAXY.MODEL.PersonAccount.identity.officialId.title" sxy-personal-id-fi readonly="true" ng-model="$ctrl.current.identity.officialId">
        </salaxy-input>
        <div class="row">
          <div class="col-sm-8 offset-sm-4 input-info">
            <div class="input-info-icon"><i class="bi bi-info-circle-fill text-default"></i></div>
            <p class="small input-info-text with-icon" sxy-html="SALAXY.NG1.AccountDetailsEditPersonComponent.personalIdDescription.html"></p>
          </div>
        </div>
        <salaxy-input name="ibanNumber" label="SALAXY.MODEL.PersonAccount.identity.ibanNumber.title" sxy-iban ng-model="$ctrl.current.identity.ibanNumber"></salaxy-input>
      </div>
      <div class="col-12 text-end">
        <button ng-click="$ctrl.saveCurrent()" ng-disabled="workerForm.$invalid" class="btn btn-primary" sxy-text="SALAXY.UI_Terms.save"></button>
      </div>
    </div>
  </form>
</div>`), s.put("salaxy-components/personal/AccountDetailsPerson.html", `<div class="salaxy-component salaxy-account-details-person">
  <div class="row">
    <div class="col-12  col-md-4 account-info-container">
      <div class="light-bg">
        <div class="worker-avatar-wrapper">
          <salaxy-account-info-person></salaxy-account-info-person>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-8" ng-if="$ctrl.current">
      <div>
        <salaxy-tab-buttons
          current-tab="$ctrl.currentTab"
          options="[
            { value: 'default', text: 'SALAXY.NG1.AccountDetailsPersonComponent.personalInfoTabHeading' },
            { value: 'contact', text: 'SALAXY.NG1.AccountDetailsPersonComponent.contactInfoTabHeading' },
            { value: 'avatar', text: 'SALAXY.NG1.AccountDetailsPersonComponent.avatarTabHeading' },
            { value: 'identity', text: 'SALAXY.NG1.AccountDetailsPersonComponent.authorizationTabHeading' },
            { value: 'insurance', text: 'SALAXY.NG1.AccountDetailsPersonComponent.insurancesTabHeading', hidden: !('household' | sxyIsInRole) }
          ]"
          tabs-id="accountDetailsPerson">
        </salaxy-tab-buttons>
        <div class="tab-content" id="tab-content-accountDetailsPerson">
          <div class="tab-pane" id="default-tab">
            <salaxy-account-details-edit-person current="$ctrl.current"></salaxy-account-details-edit-person>
          </div>
          <div class="tab-pane" id="contact-tab">
            <salaxy-account-contact-edit-person current="$ctrl.current"></salaxy-account-contact-edit-person>
          </div>
          <div class="tab-pane" id="avatar-tab">
            <salaxy-account-avatar-edit-person current="$ctrl.current"></salaxy-account-avatar-edit-person>
          </div>
          <div class="tab-pane" id="identity-tab">
            <salaxy-account-authorization-person></salaxy-account-authorization-person>
          </div>
          <div class="tab-pane" id="insurance-tab" ng-if="'household' | sxyIsInRole">
            <salaxy-account-insurance-edit-person></salaxy-account-insurance-edit-person>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12" sxy-if-role="test">
      <hr />
      <p>Test only:</p>
      <ul ng-controller="SessionController as $session">
        <li>
          Last login as (session):
          <strong>{{ $session.person.lastLoginAs }}</strong> (isEmployer: {{$session.person.isEmployer}}, isWorker: {{$session.person.isWorker}})
        </li>
        <li>
          Server-side:
          <strong>{{ $ctrl.current.lastLoginAs }}</strong> (isEmployer: {{$ctrl.current.isEmployer}}, isWorker: {{$ctrl.current.isWorker}})
        </li>
        <li>
          Vaihda roolia:
          <a ng-click="$session.switchRole('household')">Kotitalous</a>
          <a ng-click="$session.switchRole('worker')">Työntekijä</a>
        </li>
      </ul>
    </div>
  </div>
</div>`), s.put("salaxy-components/personal/AccountInfoPerson.html", `<div class="salaxy-component salaxy-account-info-person d-flex">
  <div class="worker-avatar-wrapper">
    <salaxy-avatar avatar="$ctrl.avatar"></salaxy-avatar>
  </div>
  <div class="info-wrapper w-100">
    <h2>{{ $ctrl.person.avatar.displayName || ("SALAXY.NG1.AccountInfoPersonComponent.noSelection" | sxyTranslate) }}</h2>
    <div class="account-info-contact-details">
      <span ng-if="$ctrl.person.contact.telephone">{{$ctrl.person.contact.telephone}}</span>
      <br /> {{ $ctrl.person.contact.email }}
      <br />
      <span ng-if="$ctrl.person.identity.ibanNumber">
        {{ $ctrl.person.identity.ibanNumber | sxyIban }}
      </span>
    </div>
  </div>
</div>`), s.put("salaxy-components/personal/AccountInsuranceEditPerson.html", `<div class="salaxy-component salaxy-account-insurance-edit-person">
  <form name="insuranceForm" class="form-horizontal">
    <legend>Tapaturmavakuutus</legend>
    <div class="input-info">
      <div class="input-info-icon"><i class="bi bi-info-circle-fill text-default"></i></div>
      <p class="small input-info-text with-icon">
        Lakisääteinen tapaturmavakuutus on työnantajalle pakollinen, jos maksat palkkaa kaikille työntekijöillesi yhteensä
        <strong>väh. 1400€</strong> kalenterivuoden aikana. Vakuutus on työnantajan vakuutus, joka kattaa kaikki hänen työntekijänsä.
      </p>
      <p class="small input-info-text with-icon" ng-if="($ctrl.personal.insurance.company || 'none') == 'none'">
        Saat hankittua työnantajan lakisääteisen työtapaturmavakuutuksen omasta vakuutusyhtiöstäsi.
        <strong>HUOM:</strong> Vakuutus pitää olla voimassa ennen töiden aloittamista.
      </p>
    </div>
    <div>
      <p>
        <b>Anna voimassa olevan vakuutuksen tiedot.</b> Valitse "Ei yhtiötä", jos sinulla ei ole vakuutusta.
      </p>
      <salaxy-input-enum ng-model="$ctrl.personal.insurance.company" type="select" enum="InsuranceCompany" filter="none,fennia,if,lähiTapiola,pohjantähti,pohjola,turva,aVakuutus,folksam,alandia,ålands" label="SALAXY.MODEL.InsuranceContract.company.editLabel"
        name="insurance-company" require="true"></salaxy-input-enum>
      <div ng-if="($ctrl.personal.insurance.company || 'none') != 'none'">
        <salaxy-input ng-model="$ctrl.personal.insurance.contractNumber" require="true" name="insuranceContractNumber" label="SALAXY.MODEL.InsuranceContract.contractNumber.title">
        </salaxy-input>
        <salaxy-form-group name="insuranceWarning" label-type="empty-label">
          <small>Tähän syötetyt vakuutustiedot näkyvät myös työntekijän palkkalaskelmassa.</small>
        </salaxy-form-group>
      </div>
    </div>
    <div class="text-end">
      <button ng-disabled="!$ctrl.personal.insurance.company || $ctrl.isSaving('insuranceContracts')" class="btn btn-primary" ng-click="$ctrl.save('insuranceContracts')"><i
          ng-if="$ctrl.isSaving('insuranceContracts')" class="bi bi-arrow-repeat bi-spin"></i>
        <span sxy-text="SALAXY.UI_Terms.save"></span></button>
    </div>
  </form>
  <form name="pensionForm" class="form-horizontal">
    <legend>TYEL-sopimus</legend>
    <div class="input-info">
      <div class="input-info-icon"><i class="bi bi-info-circle-fill text-default"></i></div>
      <p class="small input-info-text with-icon">
        Palkkaus.fi-palvelu ilmoittaa TyEL-ilmoitukset tulorekisteriin oletuksena suoraan työeläkeyhtiö Varman kautta ja Varma lähettää näistä laskun jälkikäteen.
        <strong>Tilapäinen työnantaja ei tarvitse siihen sopimusta.</strong>
        <br> Jos sinulla on jatkuva työsopimus tai maksat palkkaa yli {{ $ctrl.sideCosts.tyelContractEmployerLimit | currency}} puolessa vuodessa, suosittelemme tekemään sopimuksen työeläkeyhtiön kanssa.
      </p>
    </div>
    <div>
      <p>
        <b>Anna voimassa olevan sopimuksen tiedot.</b> Valitse "Ei yhtiötä", jos olet tilapäinen työnantaja.
      </p>
      <salaxy-input-enum ng-model="$ctrl.personal.pension.company" type="select" label="SALAXY.MODEL.PensionContract.company.editLabel" name="pensionCompany" enum="PensionCompany" filter="none,varma,elo,ilmarinen,veritas,apteekkien,verso,valio,kevaMunicipal,kevaAland,kevaChurch,kevaKela,kevaState" require="true"></salaxy-input-enum>
      <div salaxy-if-role="test" class="test-number">
        <div class="form-group" ng-if="$ctrl.personal.pension.company && $ctrl.personal.pension.company != 'none'">
          <div class="col-sm-8 offset-sm-4 text-sm-end">
            <span>Test only: <button class="btn btn-secondary btn-xs" ng-click="$ctrl.setPensionNumberForTest($ctrl.personal.pension)"> Generoi numero </button></span>
          </div>
        </div>
      </div>
      <salaxy-input ng-if="$ctrl.personal.pension.company && $ctrl.personal.pension.company != 'none'" require="true" name="pensionContractNumber" label="SALAXY.MODEL.PensionContract.contractNumber.title" ng-model="$ctrl.personal.pension.contractNumber" tooltip-html="{{'SALAXY.NG1.InsuranceSettingsComponent.pension.errors.sxyPensionContractNumber.html' | sxyTranslate}}"
        tooltip-placement="right" sxy-pension-contract-number></salaxy-input>
    </div>
    <div ng-show="pensionForm.pensionContractNumber.$error.sxyTemporaryPensionContractNumber">
      <div class="input-info text-danger">
        <div class="input-info-icon"><i class="bi bi-exclamation-triangle-fill "></i></div>
        <p class="small input-info-text with-icon" sxy-html="SALAXY.NG1.InsuranceSettingsComponent.pension.errors.sxyTemporaryPensionContractNumber.html"></p>
      </div>
    </div>
    <div class="text-end">
      <button ng-disabled="!$ctrl.personal.pension.company || pensionForm.$invalid || $ctrl.isSaving('pensionContracts')" class="btn btn-primary" ng-click="$ctrl.save('pensionContracts')"><i ng-if="$ctrl.isSaving('pensionContracts')" class="bi bi-arrow-repeat bi-spin"></i>
        <span sxy-text="SALAXY.UI_Terms.save"></span></button>
    </div>
  </form>
  <div>
    <legend>Työttömyysvakuutus</legend>
    <div class="input-info">
      <div class="input-info-icon"><i class="bi bi-info-circle-fill text-default"></i></div>
      <p class="small input-info-text with-icon">
        Työttömyysvakuutusmaksuja ei voi maksaa Palkkaus.fi-palvelun kautta, koska <a href="https://www.tyollisyysrahasto.fi/" target="_blank">Työllisyysrahasto</a> laskuttaa työnantajia suoraan neljännesvuosittain, jos työnantaja maksaa palkkaa vähintään
        1400€ kalenterivuoden aikana.
      </p>
      <p class="small input-info-text with-icon">
        Maksut näkyvät laskelmilla, ne ilmoitetaan tulorekisteriin eikä niiden takia tarvitse tehdä mitään muuta, kuin maksaa Työllisyysrahastolta aikanaan tulevat laskut.
      </p>
    </div>
  </div>
</div>`), s.put("salaxy-components/personal/CalcHouseholdUsecase.html", `<div class="salaxy-component salaxy-calc-household-usecase">
  <form ng-submit="$ctrl.submitHouseholdUsecase()" ng-readonly="$ctrl.isReadOnly" name="detailsUsecase" class="form-horizontal">
    <div class="salaxy-calc-dialog-body">
      <div class="salaxy-calc-dialog-container">
        <div class="row">
          <div class="col-md-5 col-12" ng-if="$ctrl.isReadOnly">
            <button type="button" class="btn btn-primary btn-sm" ng-click="$ctrl.startEdit()" sxy-text="SALAXY.UI_Terms.edit"></button>
          </div>
          <div class="col-md-5 col-12" ng-if="!$ctrl.isReadOnly">
            <h1 ng-if="!$ctrl.isUsecaseSelected" sxy-text="SALAXY.NG1.HouseholdUsecaseComponent.ui.selectionTitle" class="choose-usecase"></h1>
            <div ng-if="$ctrl.isUsecaseSelected" class="mb-2 ">
              <div ng-if="$ctrl.showSave" class="mb-2">
                <button type="button" class="btn btn-primary btn-sm" ng-click="$ctrl.saveEmployment()" sxy-text="SALAXY.UI_Terms.save"></button>
                <button type="button" class="btn btn-secondary btn-sm" ng-click="$ctrl.resetEmployment()" sxy-text="SALAXY.UI_Terms.cancel"></button>
                <button ng-if="$ctrl.isUsecaseSelected" class="btn btn-secondary btn-sm" type="button" ng-click="$ctrl.resetUsecase()"><span
                  HouseholdUsecaseComponent></span></button>
              </div>
              <button ng-if="$ctrl.isUsecaseSelected && !$ctrl.showSave" class="btn btn-secondary btn-sm btn-labeled-left" type="button" ng-click="$ctrl.resetUsecase()"><i
                  class="bi bi-chevron-left"></i><span sxy-text="SALAXY.NG1.HouseholdUsecaseComponent.ui.changeSelection"></span></button>
            </div>
            <div ng-if="$ctrl.isUsecaseSelected && !$ctrl.isEmployment" style="padding-top:15px;">
              <h1 sxy-text="SALAXY.NG1.HouseholdUsecaseComponent.ui.salaryDate"></h1>
              <p sxy-text="SALAXY.NG1.HouseholdUsecaseComponent.ui.salaxyDateInfo.html"></p>
              <div class="form-horizontal">
                <salaxy-datepicker-popup name="requestedSalaryDate" ng-model="$ctrl.requestedSalaryDate" label="SALAXY.NG1.CalcWorktimeComponent.salaryDateLabel" label-cols="col-sm-6" date-disabled="salary" placeholder="SALAXY.NG1.HouseholdUsecaseComponent.datePickerPlaceHolder"
                zero-payment="$ctrl.isCurrentZeroPayment" payment-channel="$ctrl.calc.info.paymentChannel"></salaxy-datepicker-popup>
              </div>
              <h1 sxy-text="SALAXY.NG1.CalcWorktimeComponent.worktime.title"></h1>
              <p ng-if="!$ctrl.dateRange.start || !$ctrl.dateRange.start" sxy-text="SALAXY.NG1.CalcWorktimeComponent.worktime.description"></p>
              <div class="form-horizontal">
                <salaxy-input-enum ng-model="$ctrl.periodShortcut" name="periodShortcut" ng-if="!$ctrl.periodShortcut" label="SALAXY.NG1.CalcWorktimeComponent.worktime.periodShortcut.label" label-cols="col-sm-6" type="radio" options="$ctrl.periodShortcuts"></salaxy-input-enum>
                <salaxy-input-enum ng-model="$ctrl.periodShortcut" name="periodShortcut" ng-if="$ctrl.periodShortcut" label="SALAXY.NG1.CalcWorktimeComponent.worktime.periodShortcut.label" label-cols="col-sm-6" type="select" options="$ctrl.periodShortcuts"></salaxy-input-enum>
                <salaxy-date-range ng-model="$ctrl.dateRange" class="condensed" name="dateRange" ng-if="$ctrl.periodShortcut == 'other'" on-change="$ctrl.dateRangeChange()" label="SALAXY.NG1.CalcWorktimeComponent.worktime.periodShortcut.label" label-days-count="SALAXY.NG1.CalcWorktimeComponent.worktime.periodShortcut.labelDaysCount"
                  label-cols="col-sm-6" read-only="$ctrl.isReadOnly"></salaxy-date-range>
                <div ng-if="$ctrl.periodShortcut && $ctrl.periodShortcut != 'other'">
                  <salaxy-form-group name="periodStartDate" label="SALAXY.NG1.CalcWorktimeComponent.worktime.periodShortcut.labelStartDate" label-cols="col-sm-6">
                    <input type="text" class="form-control" autocomplete="off" id="periodStartDate" name="periodStartDate" placeholder="{{'SALAXY.UI_Terms.dateFormats.dm' | sxyTranslate}}" ng-model="$ctrl.periodStartDate" ng-model-options="{allowInvalid: true, debounce: 250, updateOn: 'default' }"
                    />
                    <div ng-if="$ctrl.periodStartDateError" class="form-control-plaintext text-danger">{{ $ctrl.periodStartDateError | sxyTranslate }}</div>
                  </salaxy-form-group>
                  <salaxy-form-group name="formattedRange" label="SALAXY.NG1.CalcWorktimeComponent.worktime.periodShortcut.labelStartAndEndDate" label-cols="col-sm-6" class="salaxy-read-only">
                    <div class="form-control-plaintext">{{ $ctrl.dateRange | sxyDateRange }}</div>
                  </salaxy-form-group>
                  <salaxy-input-number name="labelDaysCount" ng-model="$ctrl.dateRange.daysCount" ng-change="$ctrl.dateRangeChange()" label="SALAXY.NG1.CalcWorktimeComponent.worktime.periodShortcut.labelWorkDaysCount" label-cols="col-sm-6">
                  </salaxy-input-number>
                </div>
              </div>
            </div>
            <div class="accordion salaxy-accordion" ng-if="!$ctrl.isUsecaseSelected">
              <div class="accordion-item" ng-repeat="group in $ctrl.tree">
                <h2 class="accordion-header">
                  <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#group{{ $index }}" aria-expanded="false">
                    {{group.label}} <i class="float-end bi" ng-class="{'bi-chevron-up': status.open, 'bi-chevron-down': !status.open}"></i>
                    <br><small>{{group.descr}}</small>
                  </button>
                </h2>
                <div id="group{{ $index }}" class="accordion-collapse collapse" ng-class="{'show': status.open}">
                  <div class="accordion-body" id="child-list">
                    <div ng-repeat="child in group.children" ng-click="$ctrl.selectUsecase(child)" class="clickable usecase-selection">
                      <div class="icon-wrapper salaxy-household-usecase-avatar">
                        <div class="main-icon-wrapper">
                          <img ng-src="{{child.icon}}">
                        </div>
                        <div ng-if="child.badge" class="badge-image-wrapper">
                          <img ng-src="{{child.badge}}">
                        </div>
                      </div>
                      <strong class="usecase-title">{{child.label}}</strong>
                      <small>{{child.descr |sxyTranslate}}</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-7 col-12 panel-detail usecase-details" ng-if="$ctrl.isUsecaseSelected">
            <ng-include src="$ctrl.getTemplate()"></ng-include>
          </div>
        </div>
      </div>
    </div>
    <button ng-if="!$ctrl.isReadOnly && !$ctrl.isEmployment" class="btn btn-warning btn-lg salaxy-calc-btn-recalculate" type="submit" sxy-text="SALAXY.UI_Terms.updateCalculation"></button>
  </form>
</div>`), s.put("salaxy-components/personal/CalcSharing.html", `<div class="salaxy-component salaxy-calc-sharing">
  <button class="btn btn-secondary btn-labeled-left btn-sm mb-2" ng-click="$ctrl.showDetails($ctrl.current)"><i class="bi bi-chevron-left"></i> <span sxy-text="SALAXY.NG1.CalcSharingComponent.backBtn"></span></button>
  <p ng-if="$ctrl.showLinkSharing" class="calc-sharing-instructions" sxy-html="SALAXY.NG1.CalcSharingComponent.intro.html"></p>
  <div class="mb-2" ng-if="$ctrl.showLinkSharing">

    <h3 sxy-text="SALAXY.NG1.CalcSharingComponent.sharing.title"></h3>
    <p class="mb-2" sxy-text="SALAXY.NG1.CalcSharingComponent.sharing.description"></p>
    <button ng-click="$ctrl.share('url')" class="btn btn-primary btn-sm">
      <span ng-show="$ctrl.isSharing('url')"><i class="bi bi-arrow-repeat bi-spin"></i></span> <span sxy-text="SALAXY.NG1.CalcSharingComponent.sharing.createLinkBtn"></span>
     </button>

  </div>

  <h3 sxy-text="SALAXY.NG1.CalcSharingComponent.select.title"></h3>
  <p sxy-text="SALAXY.NG1.CalcSharingComponent.select.description"></p>

  <div class="table-responsive salaxy-odata-table">
    <table class="table table-striped">
      <thead>
        <tr class="">
          <th colspan="2">
            <span sxy-text="SALAXY.NG1_Other.Roles.employer"></span>
          </th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.employingRelations">
          <td class="td-avatar middle">
            <salaxy-avatar avatar="row.ownerInfo.avatar"></salaxy-avatar>
          </td>
          <td class="middle">
            <strong>{{row.ownerInfo.avatar.displayName}}</strong><br />

          </td>
          <td class="middle right">
            <button class="btn btn-sm btn-primary" type="button" ng-click="$ctrl.share('employer', row)">
               <span sxy-text="SALAXY.UI_Terms.select"></span>  <span ng-show="$ctrl.isSharing('employer'+row.ownerId)"><i class="bi bi-arrow-repeat bi-spin"></i></span>
              </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>


</div>`), s.put("salaxy-components/personal/CalcSharingInfo.html", `<div class="salaxy-component salaxy-calc-sharing-info">
  <div ng-if="$ctrl.current.workflow.status == 'paymentWorkerCopy'">
    <p class="text-center">
      <span sxy-text="SALAXY.NG1.CalcSharingInfoComponent.paidDate"></span> {{ $ctrl.current.workflow.paidAt | date }}
    </p>
    <p>
      <button type="button" ng-click="$ctrl.showCopyAsNew($ctrl.current)" class="btn btn-primary btn-block" sxy-text="SALAXY.UI_Terms.copyAsNew"></button>
    </p>
  </div>
  <div ng-if="$ctrl.current.sharing.type == 'url'">
    <div ng-if="$ctrl.current.workflow.status == 'workerRequested'">
      <p class="text-center">
        <strong sxy-text="SALAXY.NG1.CalcSharingInfoComponent.sharedViaLink"></strong><br>
        <strong class="small" ng-if="$ctrl.current.sharing.lastSharedTo"><span sxy-text="SALAXY.NG1.CalcSharingInfoComponent.sharedViaEmail"></span> {{$ctrl.current.sharing.lastSharedTo}}</strong> <br>
        <span sxy-text="SALAXY.NG1.CalcSharingInfoComponent.shareToEmployer"></span>
      </p>
      <form class="form-inline mb-2">
        <div class="form-group copy-share-url">
          <div class="input-group " ng-class="{'has-success': $ctrl.uriCopied}">
            <div class="input-group-text clickable" title="{{'SALAXY.NG1.CalcSharingInfoComponent.copyToClipBoard' | sxyTranslate}}" type="button" ng-click="$ctrl.copyUri()">
              <i class="bi bi-clipboard"></i>
              <span class="text-success text-center text-indicate" ng-if="$ctrl.uriCopied"><br><span sxy-text="SALAXY.NG1.CalcSharingInfoComponent.linkCopied"></span></span>
            </div>
            <textarea class="form-control" rows="1" wrap="off">{{$ctrl.current.sharing.uri}}</textarea>
          </div>
        </div>
      </form>

      <div ng-if="!$ctrl.isMobileSharingEnabled" class="mb-2 text-center">
        <div ng-repeat="target in $ctrl.webSharingTargets" style="display:inline">
          <a ng-if="target.action" class="btn btn-transparent btn-share-calc" title="{{target.title}}" ng-click="target.action()"><i style="font-size: xx-large" class="fa" ng-class="target.icon"></i>
          </a>
          <a ng-if="!target.action" class="btn btn-transparent btn-share-calc" title="{{target.title}}" ng-href="{{target.getUrl()}}" target="_blank"><i style="font-size: xx-large" class="fa" ng-class="target.icon"></i>
         </a>
        </div>
      </div>
      <div ng-if="$ctrl.isMobileSharingEnabled" class="mb-2 text-center">
        <div ng-repeat="target in $ctrl.mobileSharingTargets" style="display:inline">
          <a ng-if="target.action" class="btn btn-transparent btn-share-calc" title="{{target.title}}" ng-click="target.action()"><i style="font-size: xx-large" class="fa" ng-class="target.icon"></i>
          {{target.title}}
          </a>
          <a ng-if="!target.action" class="btn btn-transparent btn-share-calc" title="{{target.title}}" ng-href="{{target.getUrl()}}" target="_blank"><i style="font-size: xx-large" class="fa" ng-class="target.icon"></i>
          {{target.title}}
         </a>
        </div>
      </div>
      <div class="text-center mb-2">
        <button class="btn btn-secondary btn-sm" ng-click="$ctrl.share('undefined')"><span sxy-text="SALAXY.NG1.CalcSharingInfoComponent.deleteLinkBtn"></span><span ng-show="$ctrl.isSharing('undefined')"><i class="bi bi-arrow-repeat bi-spin"></i></span></button>
        <button class="btn btn-primary btn-sm" ng-click="$ctrl.showCopyAsNew($ctrl.current)" sxy-text="SALAXY.UI_Terms.copyAsNew"></button>
      </div>
    </div>
    <div ng-if="$ctrl.current.workflow.status == 'workerRequestAccepted'">
      <p class="text-center">
        <strong class="text-success" sxy-text="SALAXY.NG1.CalcSharingInfoComponent.statusText.workerRequestAccepted"></strong>
      </p>
      <div ng-if="$ctrl.employer" class="mb-2">
        <salaxy-avatar style="font-size:45px;" avatar="$ctrl.employer.ownerInfo.avatar"></salaxy-avatar>
        <div>
          <strong>&nbsp;{{$ctrl.employer.ownerInfo.avatar.displayName}}</strong>
        </div>
      </div>
      <div class="text-center mb-2">

        <button class="btn btn-primary btn-sm" ng-click="$ctrl.showCopyAsNew($ctrl.current)" sxy-text="SALAXY.UI_Terms.copyAsNew"></button>
      </div>
    </div>
    <div ng-if="$ctrl.current.workflow.status == 'workerRequestDeclined'">
      <p class="text-center">
        <strong class="text-danger" sxy-text="SALAXY.NG1.CalcSharingInfoComponent.statusText.workerRequestDeclined"></strong>
      </p>
      <form ng-if="!$ctrl.isMobileSharingEnabled" class="form-inline mb-2">
        <div class="form-group copy-share-url">
          <div class="input-group " ng-class="{'has-success': $ctrl.uriCopied}">
            <div class="input-group-text clickable" title="{{'SALAXY.NG1.CalcSharingInfoComponent.copyToClipBoard' | sxyTranslate}}" type="button" ng-click="$ctrl.copyUri()">
              <i class="bi bi-clipboard"></i>
              <span class="text-success text-center text-indicate" ng-if="$ctrl.uriCopied"><br><span sxy-text="SALAXY.NG1.CalcSharingInfoComponent.linkCopied"></span></span>
            </div>
            <textarea class="form-control" rows="1" wrap="off">{{$ctrl.current.sharing.uri}}</textarea>
          </div>
        </div>
      </form>

      <div ng-if="!$ctrl.isMobileSharingEnabled" class="mb-2 text-center">
        <div ng-repeat="target in $ctrl.webSharingTargets" style="display:inline">
          <a ng-if="target.action" class="btn btn-transparent btn-share-calc" title="{{target.title}}" ng-click="target.action()"><i style="font-size: xx-large" class="fa" ng-class="target.icon"></i>
          </a>
          <a ng-if="!target.action" class="btn btn-transparent btn-share-calc" title="{{target.title}}" ng-href="{{target.getUrl()}}" target="_blank"><i style="font-size: xx-large" class="fa" ng-class="target.icon"></i>
         </a>
        </div>
      </div>
      <div ng-if="$ctrl.isMobileSharingEnabled" class="mb-2 text-center">
        <div ng-repeat="target in $ctrl.mobileSharingTargets" style="display:inline">
          <a ng-if="target.action" class="btn btn-transparent btn-share-calc" title="{{target.title}}" ng-click="target.action()"><i style="font-size: xx-large" class="fa" ng-class="target.icon"></i>
          {{target.title}}
          </a>
          <a ng-if="!target.action" class="btn btn-transparent btn-share-calc" title="{{target.title}}" ng-href="{{target.getUrl()}}" target="_blank"><i style="font-size: xx-large" class="fa" ng-class="target.icon"></i>
          {{target.title}} 
         </a>
        </div>
      </div>
      <div class="text-center mb-2">
        <button class="btn btn-secondary btn-sm" ng-click="$ctrl.share('undefined')"><span sxy-text="SALAXY.NG1.CalcSharingInfoComponent.deleteLinkBtn"></span><span ng-show="$ctrl.isSharing('undefined')"><i class="bi bi-arrow-repeat bi-spin"></i></span></button>
        <button class="btn btn-primary btn-sm" ng-click="$ctrl.showCopyAsNew($ctrl.current)" sxy-text="SALAXY.UI_Terms.copyAsNew"></button>
      </div>
    </div>
  </div>

  <div ng-if="$ctrl.current.sharing.type == 'employer'" class="text-center">
    <div ng-if="$ctrl.current.workflow.status == 'workerRequested'">
      <p class="text-center"><strong class="text-warning" sxy-text="SALAXY.NG1.CalcSharingInfoComponent.statusText.workerRequested"></strong></p>
      <div ng-if="$ctrl.employer" class="mb-2">
        <salaxy-avatar style="font-size:45px;" avatar="$ctrl.employer.ownerInfo.avatar"></salaxy-avatar>
        <div>
          <strong>&nbsp;{{$ctrl.employer.ownerInfo.avatar.displayName}}</strong>
        </div>
      </div>
      <button class="btn btn-secondary btn-sm" ng-click="$ctrl.share('undefined')"><span sxy-text="SALAXY.NG1.CalcSharingInfoComponent.cancelDeliveryBtn"></span> <span ng-show="$ctrl.isSharing('undefined')"><i class="bi bi-arrow-repeat bi-spin"></i></span></button>
      <button class="btn btn-primary btn-sm" ng-click="$ctrl.showCopyAsNew($ctrl.current)" sxy-text="SALAXY.UI_Terms.copyAsNew"></button>

    </div>
    <div ng-if="$ctrl.current.workflow.status == 'workerRequestAccepted'">
      <p class="text-center"><strong class="text-success" sxy-text="SALAXY.NG1.CalcSharingInfoComponent.statusText.workerRequestAccepted"></strong></p>
      <div ng-if="$ctrl.employer" class="mb-2">
        <salaxy-avatar style="font-size:45px;" avatar="$ctrl.employer.ownerInfo.avatar"></salaxy-avatar>
        <div>
          <strong>&nbsp;{{$ctrl.employer.ownerInfo.avatar.displayName}}</strong>
        </div>
      </div>

      <button class="btn btn-primary btn-sm" ng-click="$ctrl.showCopyAsNew($ctrl.current)" sxy-text="SALAXY.UI_Terms.copyAsNew"></button>
    </div>
    <div ng-if="$ctrl.current.workflow.status == 'workerRequestDeclined'">
      <p class="text-center"><strong class="text-danger" sxy-text="SALAXY.NG1.CalcSharingInfoComponent.statusText.workerRequestDeclined"></strong></p>
      <div ng-if="$ctrl.employer" class="mb-2">
        <salaxy-avatar style="font-size:45px;" avatar="$ctrl.employer.ownerInfo.avatar"></salaxy-avatar>
        <div>
          <strong>&nbsp;{{$ctrl.employer.ownerInfo.avatar.displayName}}</strong>
        </div>
      </div>
      <button class="btn btn-secondary btn-sm" ng-click="$ctrl.share('undefined')"><span sxy-text="SALAXY.NG1.CalcSharingInfoComponent.cancelDeliveryBtn"></span> <span ng-show="$ctrl.isSharing('undefined')"><i class="bi bi-arrow-repeat bi-spin"></i></span></button>
      <button class="btn btn-primary btn-sm" ng-click="$ctrl.showCopyAsNew($ctrl.current)" sxy-text="SALAXY.UI_Terms.copyAsNew"></button>
    </div>
  </div>
  <div ng-if="$ctrl.current.sharing.type == 'undefined'">
    <p ng-if="$ctrl.current.workflow.status == 'workerRequested'" class="text-center"><strong sxy-text="SALAXY.NG1.CalcSharingInfoComponent.statusText.workerRequestedAlt"></strong></p>
    <p ng-if="$ctrl.current.workflow.status == 'workerRequestAccepted'" class="text-center"><strong class="text-success" sxy-text="SALAXY.NG1.CalcSharingInfoComponent.statusText.workerRequestAccepted"></strong></p>
    <p ng-if="$ctrl.current.workflow.status == 'workerRequestDeclined'" class="text-center"><strong class="text-danger" sxy-text="SALAXY.NG1.CalcSharingInfoComponent.statusText.workerRequestDeclined"></strong></p>
    <button ng-if="$ctrl.validation.isValid && ( !$ctrl.current.isReadOnly || $ctrl.current.workflow.status == 'workerRequestDeclined')" class="btn btn-primary btn-block" ng-click="$ctrl.showSharing()" sxy-text="SALAXY.NG1.CalcSharingInfoComponent.sendToEmployerBtn"></button>
  </div>
</div>`), s.put("salaxy-components/personal/EmployerList.html", `<div class="salaxy-component salaxy-employer-list">
  <div class="list-group avatar-list-group">
    <div ng-repeat="row in $ctrl.selectedItems" class="list-group-item">
      <div class="list-group-item-content-wrapper d-flex flex-wrap align-items-center">
        <salaxy-avatar avatar="row.ownerInfo.avatar" class="icon-wrapper"></salaxy-avatar>
        <div class="list-group-item-text-wrapper ms-3 d-flex flex-column">
          <div class="list-group-item-heading">{{row.ownerInfo.avatar.displayName}}</div>
          <div class="list-group-item-text">{{row.ownerInfo.email}}</div>
        </div>
        <button ng-click="$ctrl.setEmployerSelected(row, false);" class="btn btn-sm btn-default ms-auto" sxy-text="SALAXY.UI_Terms.change"></button>
      </div>
    </div>
  </div>
  <div ng-if="!$ctrl.selectedItems.length">

    <div class="table-responsive">
      <table class="table table-striped">
        <thead>
          <tr class="">
            <th colspan="2">
              <span class="clickable" sxy-text="SALAXY.NG1_Other.Roles.employer"></span>
            </th>
            <th>
              <span sxy-text="SALAXY.NG1.WorkerListComponent.employment"></span><br />
              <span class="small"><span sxy-text="SALAXY.UI_Terms.updated"></span></span>
            </th>
            <!--th sxy-text="Palkkoja maksettu"></th-->
            <th class="right"> </th>
          </tr>
        </thead>

        <tbody>
          <tr ng-repeat="row in $ctrl.employingRelations">
            <td class="td-avatar middle">
              <salaxy-avatar avatar="row.ownerInfo.avatar"></salaxy-avatar>
            </td>
            <td class="td-name middle">
              <strong>{{row.ownerInfo.avatar.displayName}}</strong><br />
              <span class="sm-description">
              {{row.ownerInfo.email}}
            </span>
            </td>
            <td class="middle">
              {{ row.data | sxyDateRange }}<br /> <small>{{ row.updatedAt | date}}</small>
            
            </td>
            <!--td class="middle">
            <span class="">TODO: viimeisin palkka (pvm)</span><br>
            <span class="">TODO: tänä vuonna yht €</span>
          </td-->
            <td class="right middle">
              <button class="btn btn-sm btn-default" sxy-text="SALAXY.UI_Terms.calculations" ng-click="$ctrl.setEmployerSelected(row, true)"></button>
              <!-- TODO button class="btn btn-sm btn-default" sxy-text="SALAXY.UI_Terms.newCalculation"></button-->
            </td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>



  <salaxy-odata-table ng-if="$ctrl.selectedItems.length" url="/v03/api/calculations/category/all" crud-controller="CalculationCrudController as $crud" options="{ $filter: 'otherId eq \\'' + $ctrl.employerId + '\\' and (status eq \\'paymentWorkerCopy\\' or status eq \\'workerRequested\\' or status eq \\'workerRequestAccepted\\' or status eq \\'workerRequestDeclined\\') ' }"
    template-url="salaxy-components/odata/lists/CalculationsEmployer.html">
  </salaxy-odata-table>

</div>

<div class="salaxy-component salaxy-employer-list d-none">
  <div ng-if="!$ctrl.employingRelations.length" class="">
    <h2>Ei työnantajia</h2>
  </div>
  <div ng-if="$ctrl.employingRelations.length" class="">
    <div class="list-group avatar-list-group">
      <div class="list-group-item list-group-header">


        <div class="list-group-item-content-wrapper one-third">
          <div class="list-group-item-text-wrapper">
            <p class="list-group-item-heading">Työnantaja</p>
          </div>
        </div>
        <div class="list-group-item-content-wrapper one-fifth">
          <div class="list-group-item-text-wrapper">
            <p class="list-group-item-heading">Työsuhde alkanut<br>...päivitetty</p>

          </div>
        </div>
        <div class="list-group-item-content-wrapper one-fifth">
          <div class="list-group-item-text-wrapper">
            <p class="list-group-item-heading">Työsuhde alkanut<br> ...päivitetty
            </p>

          </div>
        </div>
      </div>



      <div ng-repeat="row in $ctrl.employingRelations" class="list-group-item">

        <div class="list-group-item-content-wrapper one-third">
          <salaxy-avatar avatar="row.ownerInfo.avatar" class="float-start icon-wrapper"></salaxy-avatar>
          <div class="list-group-item-text-wrapper">

            <h4 class="list-group-item-heading">{{row.ownerInfo.avatar.displayName}}</h4>
            <p class="list-group-item-text">{{row.ownerInfo.email}}</p>
          </div>
        </div>
        <div class="list-group-item-content-wrapper one-fifth">
          <div class="list-group-item-text-wrapper">
            <h4 class="list-group-item-heading">{{row.createdAt | date}}</h4>
            <p class="list-group-item-text">{{row.updatedAt | date}}</p>
          </div>
        </div>
        <div class="list-group-item-content-wrapper one-fifth">
          <div class="list-group-item-text-wrapper">
            <h4 class="list-group-item-heading">{{row.createdAt | date}}</h4>
            <p class="list-group-item-text">{{row.updatedAt | date}}</p>
          </div>
        </div>
      </div>
      <button ng-click="$ctrl.setEmployerSelected(row, true)" class="btn btn-xs btn-default" sxy-text="SALAXY.UI_Terms.select"></button>
    </div>
  </div>
</div>
</div>`), s.put("salaxy-components/personal/EmployerReport.html", `<div class="salaxy-component salaxy-employer-report mt-3">
  <salaxy-spinner heading="SALAXY.UI_Terms.loading" ng-if="!$ctrl.currentReport"></salaxy-spinner>
  <div class="d-flex align-items-center float-end">
    <label>Valitse vuosi: </label>
    <select class="form-select ms-2" ng-options="option.name for option in $ctrl.yearOptions track by option.value" ng-model="$ctrl.selectedYear" name="years" id="years"></select>
  </div>
  <div ng-if="$ctrl.currentReport.employerReports.length <= 0">
    <p>
      Sinulla ei ole Palkkaus.fi-palvelussa vuonna {{ $ctrl.selectedYear.value }} maksettuja palkkoja.
      Vetovalikosta voit vaihtaa raportointivuotta.
    </p>
    <hr />
    <h2>Ei palkanmaksuja vuonna {{ $ctrl.selectedYear.value }}</h2>
    <p>
      Kun maksat palkkoja kauttamme, edellisten vuosien palkat ja niistä tehdyt raportit jäävät arkistoon tälle sivulle.
      Muut raportit kohdassa voit esikatsella muutaman yleisen raportin
      ja sivun alalaidasta löydät lisätietoja työntekijäkohtaisista raporteista.
    </p>
  </div>
  <div ng-if="$ctrl.currentReport.employerReports.length > 0">
    <p>
      Alla näet kaikki palkanmaksut, jotka olet tehnyt Palkkaus.fi-palvelun kautta vuonna {{ $ctrl.selectedYear.value }}.
    </p>
    <hr />
    <h3>Raportit työntekijöittäin</h3>
    <p>
      Alla on listattu työntekijöittäin ja palkkalaskelmittain tärkeimmät tiedot ja raportit:
      Työntekijän yhteenveto ja Verottajan vuosi-ilmoitus (7801)<span ng-if="$ctrl.selectedYear.value < 2021"> sekä Kotitalousvähennyksen vuosi-ilmoitus (14B)</span>.
      Lisätietoja raporteista löydät sivun alalaidasta.
    </p>
    <table class="table" ng-controller="WorkerSummaryReportDisplayController as $displayCtrl">
      <thead>
        <tr>
          <th colspan="2">Työntekijä</th>
          <th class="right">
            Bruttopalkka<br />
            Verotettava
          </th>
          <th>Yhteenveto</th>
          <th>Vero (7801)</th>
          <th ng-if="$ctrl.selectedYear.value < 2021">KT-väh. (14B)</th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat-start="report in $ctrl.currentReport.employerReports">
          <td>
            <div style="font-size: 64px; line-height: 1" ng-init="avatar = $ctrl.avatarFrom(report.worker.avatar.url)">
              <i ng-if="!avatar.url" class="salaxy-avatar bi" ng-class="avatar.baseIcon" ng-style="{color: avatar.color }"><strong>{{ avatar.initials }}</strong></i>
              <i ng-if="avatar.url" class="salaxy-avatar bi"><img ng-src="{{avatar.url}}"></img></i>
            </div>
          </td>
          <td>
            {{ report.worker.fullName}}<br />
            <a ng-href="mailto:{{ $ctrl.workerEmailFrom(report) }}">{{ $ctrl.workerEmailFrom(report) }}</a><br />
            {{ report.worker.identity.socialSecurityNumberValid }}
          </td>
          <td class="right">
            {{ report.grossSalary | currency : "€" : 2}}<br />
            {{ report.totalTaxable | currency : "€" : 2}}
          </td>
          <td>
            <a ng-click="$displayCtrl.display($ctrl.selectedYear.value + '-01-01', report.worker.identity.socialSecurityNumberValid , $ctrl.employerId )"
              >Yhteenveto&nbsp;&raquo;
            </a>
          </td>
          <td>
            <a ng-if="$ctrl.isSelectedYearBeforeIncomesRegistry"
              href="{{ $ctrl.apiServerAddress }}/ReportPdf/TaxYearly7801/{{ report.worker.identity.socialSecurityNumberValid }}?year={{ $ctrl.selectedYear.value }}&access_token={{ $ctrl.token }}"
              target="_blank">Tuloste&nbsp;&raquo;
            </a>
          </td>
          <td ng-if="$ctrl.selectedYear.value < 2021">
            <a ng-if="report.totalTaxableDeductible > 0"
              ng-href="{{ $ctrl.apiServerAddress }}/ReportPdf/TaxHouseholdDeduction14B/{{ report.worker.identity.socialSecurityNumberValid }}?year={{ $ctrl.selectedYear.value }}&access_token={{ $ctrl.token }}"
              target="_blank" class="">Tuloste&nbsp;&raquo;
            </a>
            <p ng-if="report.totalTaxableDeductible <= 0">Ei merkitty koti&shy;talous&shy;vähen&shy;nykseen.</p>
          </td>
        </tr>
        <tr ng-repeat-end="" ng-repeat="calculation in report.underlyingCalculations">
          <td></td>
          <td>
            <b ng-if="!$ctrl.isSelectedYearBeforeIncomesRegistry">
              {{ calculation.salaryDate | date : "dd.MM" }}
            </b>
            <b ng-if="$ctrl.isSelectedYearBeforeIncomesRegistry">
              {{ calculation.paidAt | date : "dd.MM" }}
            </b>
          </td>
          <td class="right">
            {{ calculation.totals.totalGrossSalary | currency : "€" : 2 }}<br />
            {{ calculation.totals.totalTaxable | currency : "€" : 2 }}
          </td>
          <td ng-controller="CalcReportsDisplayController as $displayCtrl">
            <button  ng-click="$displayCtrl.displayForId('salarySlip', calculation.id)"
                    class="btn btn-primary btn-xs">Tuloste&nbsp;&raquo;</button><br />
          <td>
            {{ calculation.workerCalc.tax > 0 ? "Ennakonpidätys: " + (calculation.workerCalc.tax | currency : "€" : 2) : "Ei ennakonpidätystä" }}
          </td>
          <td ng-if="$ctrl.selectedYear.value < 2021">
            {{ calculation.salary.isDeductible ? "Kotitalousvähennys: " + (calculation.employerCalc.householdDeduction | currency : "€" : 2) : "Ei lasketa kotitalousväh." }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <hr />
  <br />
  <h3>Muut raportit</h3>
  <p>Raportit, jotka eivät ole työntekijäkohtaisia.</p>
  <div class="row">
    <div ng-if="$ctrl.isSelectedYearBeforeIncomesRegistry" class="col-sm-4">
      <h4>TVR Palkka&shy;summa&shy;ilmoitus</h4>
      <p>
        Työttömyys&shy;vakuutus&shy;rahastolle (TVR) ilmoitetaan
        yhteystiedot, palkkasumma sekä tilinumero mahdollisia takaisinmaksuja varten.
      </p>
      <p>
        <strong>
          Ilmoitettava palkkasumma on: {{ $ctrl.tvrSalaryAmount | currency : "" : 2 }} euroa.
        </strong>
      </p>
      <p>
        Avaa <a ng-href="{{ $ctrl.apiServerAddress }}/ReportPdf/Unemployment?year={{ $ctrl.selectedYear.value }}&access_token={{ $ctrl.token }}" target="_blank">PDF-dokumentti
          tästä linkistä</a>.
      </p>
    </div>
    <div class="col-sm-4">
      <h4>Vakuutusyhtiön vuosi-ilmoitus</h4>
      <p>
        Vakuutus- tai työeläkeyhtiö saattaa vaatia sinulta selvitystä maksetuista palkoista vuoden ajalta.
        Tämä raportti on tarkoitettu sitä varten.
      </p>
      <p>
        <strong>
          Jos olet ostanut tapaturmavakuutuksen Palkkaus.fi-palvelusta ja
          olet antanut Palkkaus.fi-palvelun hoitaa TyEL-vakuutuksen,
          ei tämä raportti ole tarpeellinen.
        </strong>
      </p>
      <p>
        Avaa <a ng-href="{{ $ctrl.apiServerAddress }}/ReportHtml/Insurance?year={{ $ctrl.selectedYear.value }}&access_token={{ $ctrl.token }}" target="_blank">Raportti tästä</a>.
      </p>
    </div>
    <div class="col-sm-4">
      <h4>Raportti kotitalous&shy;vähennyksistä</h4>
      <p>
        Yksityiskohtainen raportti näyttää yhdessä näkymässä kaikki
        kotitalousvähennysta varten Palkkauksen verottajalle ilmoittamat tiedot.
      </p>
      <p>
        Lisäksi tietoa miten ilmoitat Palkkaus.fi-palvelun ulkopuolella maksetut kotitalousvähennyksen alaiset kustannukset.
      </p>
      <p>
        Avaa <a  ng-href="{{$ctrl.selectedYear.value < 2021 ? '#/archive/household-deduction-report' : '#/household-years/active'}}">Raportti tästä</a>.
      </p>
    </div>
  </div>
  <hr />
  <br />
  <h3 id="more-info">Lisätietoja raporteista</h3>
  <p>
    Lisätietoja yllä listatutuista työntekijäkohtaisista raporteista.
  </p>
  <div class="row">
    <div class="col-sm-4">
      <h4>Työntekijän yhteenveto</h4>
      <p>
        Lain mukaan työnantajan pitää toimittaa työntekijälle yhteenveto kaikista palkoista, joita on maksanut vuoden aikana.
      </p>
      <p>
        <strong>Jos Palkkaus.fi-palvelussa on työntekijän sähköpostiosoite, lähetämme tähän linkin suoraan työntekijälle.</strong>
        Jos sähköpostiosoite ei ole oikein, voit tulostaa tämän yhteenvedon ja lähettää työntekijälle.
      </p>
      <ul ng-controller="WorkerSummaryReportDisplayController as $displayCtrl">
        <li ng-repeat="employerReport in $ctrl.currentReport.employerReports">
          <a ng-click="$displayCtrl.display($ctrl.selectedYear.value + '-01-01', employerReport.worker.identity.socialSecurityNumberValid , $ctrl.employerId )">{{
            employerReport.worker.fullName }}</a>
          {{ $ctrl.workerEmailFrom(employerReport) || 'Ei sähköpostia' }}
        </li>
      </ul>
    </div>
    <div ng-if="$ctrl.isSelectedYearBeforeIncomesRegistry" class="col-sm-4">
      <h4>Vuosi-ilmoitus verottajalle (7801)</h4>
      <p>
        <i>Verottajan lomake 7801: Työnantajan tai suorituksen maksajan vuosi-ilmoitus</i>
        Näitä lomakkeita tuotamme jokaista työntekijääsi kohden yhden.
      </p>
      <p>
        Jokaisen vuoden tammikuussa luomme edellisen vuoden ilmoitukset ja voit vielä tarkistaa lomakkeen tiedot.
        Tämän jälkeen <strong>lähetämme ilmoituksen verottajalle</strong> ja alkuperäinen ilmoitus jää Palkkaus.fi-arkistoon.
      </p>
      <ul>
        <li ng-repeat="employerReport in $ctrl.currentReport.employerReports">
          <a href="{{ $ctrl.apiServerAddress }}/ReportPdf/TaxYearly7801/{{ employerReport.worker.identity.socialSecurityNumberValid }}?year={{ $ctrl.selectedYear.value }}&access_token={{ $ctrl.token }}"
            target="_blank">{{
            employerReport.worker.fullName }}</a>
        </li>
      </ul>
    </div>
    <div class="col-sm-4" >
      <h4>Kotitalous&shy;vähennyksen vuosi-ilmoitus (14B)</h4>
      <p>
        <i>Verottajan lomake 14B / 3026: Kotitalousvähennys työntekijälle maksetusta palkasta</i>
        Yhteen lomakesivuun mahtuu tiedot kahdesta työntekijästä
      </p>
      <p>
        <strong>
          Lähetämme tiedot verottajalle tammikuun loppuun mennessä,
        </strong> kun olet käynyt tarkistamassa tietosi
      </p>
      <p>
        Huomaathan, että verottaja käsittelee kaikki lomakkeet 14B yhdellä kertaa veroilmoitusten kanssa kesäkuussa,
        joten nämä tiedot eivät näy vielä esitäytetyssä veroilmoituksessa.
      </p>

      <ul ng-if="$ctrl.selectedYear.value < 2021">
        <li ng-repeat="employerGroup in $ctrl.employers14BGroups">
          <a href="{{ $ctrl.apiServerAddress }}/ReportPdf/TaxHouseholdDeduction14B/{{ employerGroup.id1 }}?id2={{ employerGroup.id2 }}&year={{ $ctrl.selectedYear.value }}&access_token={{ $ctrl.token }}"
            target="_blank">
            {{ employerGroup.names }}
          </a>
        </li>
      </ul>
      <span ng-if="$ctrl.selectedYear.value >= 2021">Avaa <a href="#/household-years/active">Raportti tästä</a>.</span>
    </div>
  </div>
</div>`), s.put("salaxy-components/personal/EmployerSelect.html", `<div class="salaxy-component salaxy-employer-select">
  <div ng-if="!$ctrl.employingRelations.length" class="">
    <h2>Ei työnantajia</h2>
  </div>


  <div class="list-group avatar-list-group">
    <div ng-repeat="row in $ctrl.selectedItems" class="list-group-item">
      <div class="list-group-item-content-wrapper">
        <salaxy-avatar avatar="row.ownerInfo.avatar" class="float-start icon-wrapper"></salaxy-avatar>
        <div class="list-group-item-text-wrapper">
          <h4 class="list-group-item-heading">{{row.ownerInfo.avatar.displayName}}</h4>
          <p class="list-group-item-text">{{row.owner | sxyIban}}</p>
        </div>
      </div>

      <button ng-if="$ctrl.employingRelations.length > 1" ng-click="$ctrl.setEmployerSelected(row, false);" class="btn btn-xs btn-default" sxy-text="SALAXY.UI_Terms.change"></button>

    </div>
  </div>

  <div ng-if="$ctrl.employingRelations.length > 1 && !$ctrl.selectedItems.length">
    <div class="list-group avatar-list-group">
      <div ng-repeat="row in $ctrl.employingRelations" class="list-group-item">
        <div class="list-group-item-content-wrapper">
          <salaxy-avatar avatar="row.ownerInfo.avatar" class="float-start icon-wrapper"></salaxy-avatar>
          <div class="list-group-item-text-wrapper">
            <h4 class="list-group-item-heading">{{row.ownerInfo.avatar.displayName}}</h4>
            <p class="list-group-item-text">{{row.owner | sxyIban}}</p>
          </div>
        </div>
        <button ng-click="$ctrl.setEmployerSelected(row, true)" class="btn btn-xs btn-default" sxy-text="SALAXY.UI_Terms.select"></button>
      </div>
    </div>
  </div>
</div>`), s.put("salaxy-components/personal/HouseholdDeductionReport.html", `<div style="max-width: calc(100% - 45px); margin-left: 15px">
  <salaxy-spinner heading="SALAXY.UI_Terms.loading" ng-if="!$ctrl.currentReport"></salaxy-spinner>
  <div class="row">
    <div class="col-12 mb-2">
      <label>Valitse vuosi: </label>
      <select class="form-select" ng-options="option.name for option in $ctrl.yearOptions track by option.value" ng-model="$ctrl.selectedYear" name="years" id="years"></select>
    </div>
  </div>
  <h2>Palkkaus.fi-palvelussa maksetut palkat</h2>
  <h3 ng-repeat-start="yearlyReport in $ctrl.currentReport" ng-if="$index == 0">Nämä työt voit vähentää omassa verotuksessasi.</h3>
  <p ng-if="$index == 0">Kotitalousvähennys on enintään {{ $ctrl.deductionMaxAmount | currency : "" : 0 }} euroa vuodessa. Vähennyksen omavastuu on 100 euroa.</p>
  <h3 ng-if="$index == 1">Nämä työt voit vähentää mahdollisen puolisosi verotuksessa.</h3>
  <p ng-if="$index == 1">Kotitalousvähennys on henkilökohtainen, joten puolisot voivat saada yhteensä {{ (2 * $ctrl.deductionMaxAmount) | currency : "" : 0 }} euron vähennyksen. Jos {{ $ctrl.deductionMaxAmount | currency : "" : 0 }} euron raja ei ylity, vähennys kannattaa hakea
    vain toiselle puolisolle. Silloin omavastuu vähennetään vain yhden kerran.</p>
  <h3 ng-if="$index == 2">Näitä töitä et voi vähentää verotuksessa</h3>
  <p ng-if="$index == 2">Kotitalousvähennyksen maksimimäärä on {{ $ctrl.deductionMaxAmount | currency : "" : 0 }} yhdessä puolison kanssa.</p>
  <b>Työnantaja {{ yearlyReport.employer.fullName }}</b>
  <table class="table table-sm">
    <thead>
      <tr>
        <th>Työntekijä</th>
        <th>Työ: maksupäivä ja kuvaus</th>
        <th class="right" colspan="2">Luvut 14B-lomakkeessa</th>
        <th class="right">KT-vähennys</th>
      </tr>
    </thead>
    <tbody ng-repeat="employerReport in yearlyReport.employerReports">
      <tr ng-if-start="employerReport.isHouseholdDeductionWork">
        <td rowspan="4">
          {{ employerReport.worker.displayName }}<br /> {{ employerReport.worker.identity.socialSecurityNumberValid }}<br />
        </td>
        <td rowspan="4">
          {{ $ctrl.formatDateRange(employerReport.firstDeductiblePaymentDate, employerReport.lastDeductiblePaymentDate) }} {{ employerReport.deductionWorkDescription }}
          <div class="form-group form-group-display">
            <label class="col-sm-10 control-label">Kotitaloustyö</label>
            <div class="col-sm-2">
              <input ng-checked="employerReport.hasHouseholdWork" class="check-box" disabled="disabled" type="checkbox">
            </div>
          </div>
          <div class="form-group form-group-display">
            <label class="col-sm-10 control-label">Hoiva- ja hoitotyö</label>
            <div class="col-sm-2">
              <input ng-checked="employerReport.hasCareAndNurtureWork" class="check-box" disabled="disabled" type="checkbox">
            </div>
          </div>
          <div class="form-group form-group-display">
            <label class="col-sm-10 control-label">Asunnon kunnossapito- tai perusparannustyö</label>
            <div class="col-sm-2">
              <input ng-checked="employerReport.hasConstructionWork" class="check-box" disabled="disabled" type="checkbox">
            </div>
          </div>
        </td>
        <td>Palkka</td>
        <td class="right">{{ $ctrl.formatNumber(employerReport.totalTaxableDeductible) }}</td>
        <td class="right">{{ $ctrl.formatNumber(employerReport.totalTaxableDeduction) }}</td>
      </tr>

      <tr>
        <td>Sivukulut (TyEL+Sava+TVR)</td>
        <td class="right">{{ $ctrl.formatNumber(employerReport.totalMandatorySideCosts) }}</td>
        <td class="right">{{ $ctrl.formatNumber(employerReport.totalMandatorySideCosts) }}</td>
      </tr>
      <tr>
        <td>Vakuutus</td>
        <td class="right">{{ $ctrl.formatNumber(employerReport.deductionInsuranceEtc) }}</td>
        <td class="right">{{ $ctrl.formatNumber(employerReport.deductionInsuranceEtc) }}</td>
      </tr>
      <tr ng-if-end class="total">
        <td>Yhteensä</td>
        <td class="right">{{ $ctrl.formatNumber(employerReport.deduction14BFormTotal) }}</td>
        <td class="right">{{ $ctrl.employerDeductionsTotalAmount(employerReport) }}</td>
      </tr>
      <tr ng-if="!employerReport.isHouseholdDeductionWork">
        <td>
          {{ employerReport.worker.displayName }}<br /> {{ employerReport.worker.identity.socialSecurityNumberValid }}<br />
        </td>
        <td>
          {{ $ctrl.formatDateRange(employerReport.firstPaymentDate, employerReport.lastPaymentDate) }} Ei töitä merkittynä kotitalousvähennykseen.
        </td>
        <td>Palkka</td>
        <td class="right">{{ $ctrl.formatNumber(employerReport.totalTaxableDeductible) }}</td>
        <td class="right">-</td>
      </tr>
    </tbody>
    <tfoot>
      <tr>
        <td colspan="2">&nbsp;</td>
      </tr>
      <tr class="total">
        <th colspan="2">Yhteensä</th>
        <th colspan="2" class="right">{{ $ctrl.yearlyForm14BTotalAmount(yearlyReport) }}</th>
        <th class="right">{{ $ctrl.yearlyDeductionsTotalAmount(yearlyReport) }}</th>
      </tr>
      <tr>
        <td>Omavastuu</td>
        <td>Max. {{ $ctrl.deductionMaxAmount | currency : "" : 0 }} euroa / henkilö (pariskunta {{ (2 * $ctrl.deductionMaxAmount) | currency : "" : 0 }})</td>
        <td colspan="3" class="right">-100,00</td>
      </tr>
      <tr class="total">
        <th colspan="2">Kotitalousvähennys yhteensä</th>
        <th colspan="3" class="right">{{ $ctrl.yearlyDeductionTotal(yearlyReport) }}</th>
      </tr>
    </tfoot>
  </table>
  <p ng-repeat-end="">&nbsp;</p>

  <p>
    Verottaja käsittelee kaikki lomakkeet 14B yhdellä kertaa veroilmoitusten kanssa kesäkuussa, joten nämä tiedot
    <strong>eivät näy vielä esitäytetyssä veroilmoituksessa</strong>. Käymme aktiivista keskustelua verottajan kanssa, jotta ensi vuodeksi saisimme tiedot jo tähän esitäytettyyn veroilmoitukseen. Jos tämä on sinusta tärkeä juttu, lähetä meille palautetta
    osoitteeseen aspa@palkkaus.fi. Viemme mielellämme tätä tietoa eteenpäin verottajalle.
  </p>
  <p>
    Tulet saamaan <strong>elo-syyskuussa Verottajalta korjatun verotuspäätöksen</strong>, jossa kotitalousvähennys on huomioitu kokonaisuudessaan. Jos vielä silloin huomaat joitain puutteita, voit tehdä muutoksen lokakuun aikana. Lopullisesti verotus
    vahvistetaan lokakuun viimeinen päivä.
  </p>
  <hr />
  <h2 id="info14B">Palkkaus.fi-palvelun ulkopuolella maksetut palkat</h2>
  <p>
    Jos olet teettänyt työtä, jonka palkan olet maksanut Palkkaus.fi-palvelun ulkopuolella, muistathan ilmoittaa siitä erikseen verottajalle.
  </p>
  <p>
    Kotitalousvähennyksen alaisen työn voi ilmoittaa kahdella tavalla:
  </p>
  <ol>
    <li>
      Tulosta lomake
      <a href="https://www.vero.fi/fi-FI/Syventavat_veroohjeet/Lomakkeet/Henkiloasiakkaiden_lomakkeet/14B_Kotitalousvahennys_tyontekijalle_mak(12921)" target="_blank">
        14B tästä linkistä
      </a> ja lähetä se verottajalle.
    </li>
    <li>Sähköisellä veroilmoituksella <a href="https://www.vero.fi/veroilmoitus" target="_blank">https://www.vero.fi/veroilmoitus</a></li>
  </ol>
  <hr />
  <h2 id="info14A">Yrityksen laskuttama työ kotitalousvähennykseen</h2>
  <p>
    Jos olet teettänyt yrityksellä työtä, joka kelpaa kotitalousvähennykseen, muistathan ilmoittaa myös sen verottajalle.
  </p>
  <p>
    Laskulla teetetyn työn voi ilmoittaa kahdella tavalla:
  </p>
  <ol>
    <li>
      Tulosta lomake
      <a href="http://www.vero.fi/fi-FI/Syventavat_veroohjeet/Lomakkeet/Henkiloasiakkaiden_lomakkeet/14A_Kotitalousvahennys_yritykselle_makse(12918)" target="_blank">
        14A tästä linkistä
      </a> ja lähetä se verottajalle.
    </li>
    <li>Sähköisellä veroilmoituksella <a href="https://www.vero.fi/veroilmoitus" target="_blank">https://www.vero.fi/veroilmoitus</a></li>
  </ol>
  <p>
    Olemme suunnitelleet tähän myös työkalua Palkkaus.fi-sivustolle. Työkalulla voisi kirjata laskut jo etukäteen ja tallentaa kuitit arkistoon. Palkkaus.fi ilmoittaisi tiedot verottajalle vuoden lopussa. Jos tämä on sinusta tärkeä juttu, lähetä meille palautetta
    osoitteeseen aspa@palkkaus.fi.
  </p>
  <hr />
  <h2 id="info-kuuluuko">Mistä tiedän kuuluuko työ kotitalousvähennykseen?</h2>
  <p>Perusidea on, että työn pitää olla jotain seuraavista:</p>
  <ul>
    <li>kotitaloustyö</li>
    <li>hoiva- tai hoitotyö</li>
    <li>asunnon kunnossapito- tai perusparannustyö</li>
  </ul>
  <p>
    Lisäksi työ pitää tehdä omassa käytössä olevassa asunnossa tai vapaa-ajan asunnnossa. (Erikoistapauksena myös joidenkin lähisukulaisten käytössä olevat asunnot)
  </p>
  <p>
    Jos olet epävarma, niin <a href="http://www.vero.fi/fi-FI/Henkiloasiakkaat/Kotitalousvahennys" target="_blank">tällä verottajan sivulla on kuvattu</a> tarkemmin kotitalousvähennystä. Huomaa alalaidan linkit eri työtyyppeihin.
    <a href="http://www.vero.fi/fi-FI/Henkiloasiakkaat/Kotitalousvahennys/Taulukko_kysytyimmista_kotitalousvahenny(9231)" target="_blank">Tällä toisella sivulla on pitkä lista</a> eri töistä.
  </p>

  <p>Jos et vieläkään ole varma, voit kysyä mielipidettä Suomen Palkanlaskenta Oy:n asiantuntijoilta (yhteystiedot sivun alalaidassa).</p>

  <p>Me autamme mielellämme!</p>
</div>`), s.put("salaxy-components/personal/HouseholdYearDetails.html", `<div class="salaxy-component salaxy-household-year-details">

  <div class="btn-toolbar float-end" role="toolbar" salaxy-if-role="pro">
    <salaxy-workflow-buttons api-ctrl="$ctrl" disabled="!$ctrl.current || $ctrl.isNew() || $ctrl.current.isReadOnly"></salaxy-workflow-buttons>
  </div>

  <div class="table-responsive">
    <p class="lead">
      Palvelu tekee puolestasi kotitalousvähennysilmoitukset maksetuista palkoista, kun laskelmalla on kotitalousvähennysmerkintä. Tarkista valinnat ja täydennä tarvittavat tiedot.
    </p>
    <div ng-if="$ctrl.current && $ctrl.isOpen">
      <p>
        Alla on listattu vuoden {{ $ctrl.current.year || "" }} aikana palvelun kautta maksamasi palkat.
      </p>
      <ol>
        <li>Tarkista palkat</li>
        <li>Lisää tai poista kotitalousvähennys</li>
        <li>Hyväksy tarkistamasi tiedot</li>
      </ol>
      <p>
        <big>Kotitalousvähennys:</big> laita rasti ruutuun niiden palkkalaskelmien kohdalle, joista haluat kotitalousvähennyksen.
      </p>
    </div>
    <div ng-if="$ctrl.current && !$ctrl.isOpen">
      <h3>Tiedot on jo lähetetty</h3>
      <p>
        Olet lähettänyt alla olevat tiedot {{$ctrl.current.userFeedbackTime | date : 'dd.MM.yyyy HH:mm'}}
      </p>
      <p>
        Jos haluat avata tarkistuksen, ole yhteydessä asiakaspalveluun.
      </p>
    </div>
    <hr />
  </div>
  <form name="theForm" ng-if="$ctrl.current">
    <div class="table-responsive" ng-controller="WorkerSummaryReportDisplayController as $displayCtrl">
      <table class="table">
        <thead>
          <tr>
            <th colspan="7">
              <h3>Työntekijöiden palkkalaskelmat</h3>
            </th>
          </tr>
          <tr>
            <th colspan="2">Työntekijä</th>
            <th class="right">Bruttopalkka</th>
            <th class="right">Työnantaja&shy;kulut</th>
            <th colspan="3">Kotitalousvähennys <br>(laita rasti ruutuun)</th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat-start="workerSummary in $ctrl.yearlyCalculations.workers">
            <td style="font-size: 64px; line-height: 1">
              <salaxy-avatar avatar="workerSummary.worker.avatar"></salaxy-avatar>
            </td>
            <td>
              {{ workerSummary.worker.avatar.displayName }}<br />
              <a ng-href="mailto:{{ workerSummary.worker.paymentData.email }}"> {{ workerSummary.worker.paymentData.email }}</a><br /> {{ workerSummary.worker.paymentData.socialSecurityNumberValid }}<br />
            </td>
            <td class="right">
              {{ workerSummary.totalTaxable | number : 2 }}€
            </td>
            <td class="right">
              {{ workerSummary.mandatorySideCosts | number : 2 }}€
            </td>
            <td></td>
            <td></td>
            <td>
              Työntekijän raportit (esikatselu):
              <div>
                <a ng-click="$displayCtrl.display($ctrl.current.year + '-01-01', workerSummary.worker.paymentData.socialSecurityNumberValid , null)">Yhteenveto</a>
              </div>
            </td>
          </tr>
          <tr ng-repeat="calc in workerSummary.calculations">
            <td></td>
            <td class="valign-middle" ng-controller="CalcReportsDisplayController as $displayCtrl">
              <a ng-click="$displayCtrl.displayForId('salarySlip', calc.id)">Laskelma {{ calc.workflow.salaryDate | date : 'dd.MM.' }} &raquo;</a>
            </td>
            <td class="right valign-middle">
              {{ calc.result.totals.totalTaxable | number : 2 }}€
            </td>
            <td class="right valign-middle">
              {{ calc.result.employerCalc.mandatorySideCosts | number : 2 }}€
            </td>
            <td class="valign-middle" style="min-width: 40px;">
              <input type="checkbox" class="form-control" ng-disabled="!$ctrl.isOpen" ng-model="calc.usecase.data.isHouseholdDeductible" ng-change="$ctrl.calculationUpdated(calc)" />
            </td>
            <td class="right valign-middle tax-deduction-item" ng-class="{ 'text-disabled': !calc.usecase.data.isHouseholdDeductible }">
              {{ (calc.result.employerCalc.mandatorySideCosts + calc.result.totals.totalTaxable * $ctrl.getHouseholdDeduction(calc)) | number : 2 }}€
            </td>
            <td>
              <span ng-if="!calc.usecase.data.isHouseholdDeductible" class="text-danger">Ei kotitalousvähennystä</span>
              <div ng-if="calc.usecase.data.isHouseholdDeductible">
                <select class="form-select" ng-disabled="!$ctrl.isOpen" ng-model="calc.usecase.data.taxDeductionCategories" ng-change="$ctrl.calculationUpdated(calc)">
                  <option hidden value="">Valitse työn tyyppi...</option>
                  <option value="none">Ei valintaa</option>
                  <option value="householdwork">Kotitaloustyö</option>
                  <option value="carework">Hoiva- ja hoitotyö</option>
                  <option value="homeImprovement">Asunnon/loma-asunnon kunnossapito- tai korjaustyö</option>
                  <option value="oilHeatingReplacementWork">Öljylämmityksestä luopuminen</option>
                </select>
              </div>
              <div ng-if="calc.usecase.data.isHouseholdDeductible">
                <select class="form-select" ng-disabled="!$ctrl.isOpen" ng-model="calc.usecase.data.taxDeductionProperty" ng-change="$ctrl.calculationUpdated(calc)">
                  <option hidden value="">Valitse työn sijainti</option>
                  <option value="none">Ei valintaa</option>
                  <option value="ownProperty">Omassa käytössä oleva asunto tai vapaa-ajan asunto</option>
                  <option value="relativesProperty">Vanhempien, isovanhempien yms. käytössä oleva asunto tai vapaa-ajan asunto.</option>
                </select>
              </div>
            </td>
          </tr>
          <tr ng-repeat-end>
            <td colspan="7" style="border-top-color: rgb(145,210,20); line-height: 0; padding: 0;"></td>
          </tr>
          <tr>
            <th colspan="7">
              <h4>Tapaturmavakuutus kotitalousvähennykseen</h4>
            </th>
          </tr>
          <tr>
            <td></td>
            <td colspan="5">
              <div>
                Tapaturmavakuutus kelpaa kotitalousvähennykseen. Lisää maksamasi vakuutuksen summa tähän.
              </div>
            </td>
            <td>
              <salaxy-input-number name="insuranceAmount" disabled="!$ctrl.isOpen" label-type="plain" unit="euro" ng-model="$ctrl.current.insuranceAmount" />
            </td>
          </tr>
          <tr class="total">
            <th colspan="4">
              <h4>Kotitalousvähennys yhteensä</h4>
            </th>
            <th></th>
            <th class="right valign-middle">{{ $ctrl.getTaxDeductionTotal() + $ctrl.getTaxDeductionTotalExtended() + $ctrl.current.insuranceAmount  | number : 2 }}€</th>
            <th class="valign-middle">
              <small style="font-weight: normal">...josta vähennetään omavastuu.</small>
            </th>
          </tr>
        </tbody>
      </table>
      <p>
        Huomioi: kotitalousvähennyksesi ei näy kevään esitäytetyssä veroilmoituksessasi, koska verottaja käsittelee ilmoitukset niin hitaasti. Lopulliseen verotukseesi ne tulevat kuitenkin oikein.
      </p>
    </div>
    <div ng-show="$ctrl.canSplitWithSpouse()">
      <h3>Jaa kotitalousvähennys puolisosi kanssa</h3>
      <p>
        Kotitalousvähennystä voi saada {{ $ctrl.getGetSplittableMaxAmount() }}€ per henkilö ({{$ctrl.getHouseholdDeductionDeductible()}}€ omavastuun jälkeen).
      </p>
      <p>
        Jos sinulla on puoliso, niin lisää tähän hänen tietonsa. Näin voimme lähettää {{ $ctrl.getGetSplittableMaxAmount() + $ctrl.getHouseholdDeductionDeductible()}}€ ylittävän osan kotitalousvähennyksestä hänen veroilmoitukseensa.
      </p>
      <div class="form-group">
        <label for="spouseName" class="control-label">Puolison nimi:</label>
        <salaxy-input name="spouseName" disabled="!$ctrl.isOpen" placeholder="Koko nimi verottajalle" label-type="plain" ng-model="$ctrl.current.spouseName"></salaxy-input>
      </div>
      <div class="form-group">
        <label for="spousePersonalId" class="control-label">Puolison henkilötunnus:</label>
        <salaxy-input name="spousePersonalId" disabled="!$ctrl.isOpen" placeholder="ddmmyy-123X" label-type="plain" sxy-personal-id-fi ng-model="$ctrl.current.spousePersonalId"></salaxy-input>
      </div>
    </div>
    <div>
      <h3>Tietojen lähettäminen</h3>
      <p>Kun ole tarkistanut tiedot, valitse joku alla olevista vaihtoehdoista.</p>
      <table>
        <tr>
          <td>
            <label for="statusOk">
            <input id="statusOk" type="radio" ng-disabled="!$ctrl.isOpen" ng-model="$ctrl.current.status" value="ok">
            <span class="text-success">Kyllä, tiedot tarkistettu / korjattu</span>
            </label>
          </td>
          <td>
            <p>Palvelu lähettää kotitalousvähennysilmoituksen 14B-lomakkeen verottajalle</p>
          </td>
        </tr>
        <tr>
          <td>
            <label for="statusOkWithModifications">
            <input id="statusOkWithModifications" type="radio" ng-disabled="!$ctrl.isOpen" ng-model="$ctrl.current.status" value="okWithModifications">
            <span class="text-danger">Tiedoissa on puutteita / virheitä<span>
            </label>
          </td>
          <td>
            <p>Jos tiedoissa on puutteita, joita et voinut korjata tällä sivulla itse, listaa puutteet tähän. Palvelu on sinuun tarvittaessa yhteydessä.</p>
            <div ng-if="$ctrl.current.status == 'okWithModifications'">
              <textarea class="form-control" ng-disabled="!$ctrl.isOpen" ng-model="$ctrl.current.userFeedbackText" rows="2"></textarea>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <label for="statusWillHandleMyself">
            <input id="statusWillHandleMyself" type="radio" ng-disabled="!$ctrl.isOpen" ng-model="$ctrl.current.status" value="willHandleMyself">
            <span class="text-default">Teen kotitalous&shy;vähennysilmoituksen itse</span>
            </label>
          </td>
          <td>
            <p>
              Palvelu ei lähetä kotitalousvähennysilmoitusta (14B-lomake) verottajalle. Valitse tämä vaihtoehto, jos olet jo itse tehnyt kotitalousvähennysilmoitukset OmaVerossa tai et halua hakea kotitalousvähennystä.
            </p>
          </td>
        </tr>
      </table>
    </div>

    <div class="text-end">
      <button type="button" class="btn btn-default" ng-disabled="!$ctrl.current || !$ctrl.current.id" ng-click="$ctrl.export()">Lataa pdf(t)</button>
      <button type="button" class="btn btn-primary" ng-disabled="!$ctrl.current || !theForm.$valid || $ctrl.current.isReadOnly || !$ctrl.isOpen" ng-click="$ctrl.save()">Tallenna</button>
    </div>
  </form>
</div>`), s.put("salaxy-components/personal/HouseholdYearList.html", `<div class="salaxy-component household-year-list">
  <salaxy-odata-table ng-ref="$odata" crud-controller="HouseholdYearCrudController as $crud">
  </salaxy-odata-table>
</div>`), s.put("salaxy-components/personal/WorkerReport.html", `<div class="salaxy-component salaxy-worker-report">
  <salaxy-spinner heading="SALAXY.UI_Terms.loading" ng-if="!$ctrl.currentReport"></salaxy-spinner>
  <div class="d-flex align-items-center mb-3 d-flex">
    <label class="text-nowrap" sxy-text="SALAXY.NG1.WorkerReportComponent.selectYearLabel"></label>
    <select class="form-select ms-2 w-auto" ng-options="option.name for option in $ctrl.yearOptions track by option.value" ng-model="$ctrl.selectedYear" name="years" id="years"></select>
  </div>
  <div>
    <h2 ng-if-start="$ctrl.currentReport.length <= 0" sxy-text="SALAXY.NG1.WorkerReportComponent.noPaidSalaries.title" params="{year: $ctrl.selectedYear.value}"></h2>
    <p sxy-text="SALAXY.NG1.WorkerReportComponent.noPaidSalaries.description" params="{year: $ctrl.selectedYear.value}"></p>
    <p ng-if-end sxy-text="SALAXY.NG1.WorkerReportComponent.contactCustomerService" params="{year: $ctrl.selectedYear.value}"></p>
    <p ng-if-start="$ctrl.currentReport.length > 0" class="" sxy-text="SALAXY.NG1.WorkerReportComponent.paidSalariesText" params="{year: $ctrl.selectedYear.value}"></p>
    <div ng-if-end class="table-responsive light-bg">
      <table class="table table-striped table-sm">
        <thead>
          <tr>
            <th colspan="2" sxy-text="SALAXY.NG1.WorkerReportComponent.table.employer"></th>
            <th class="right">
              <span sxy-text="SALAXY.NG1.WorkerReportComponent.table.grossSalary"></span><br /><span sxy-text="SALAXY.NG1.WorkerReportComponent.table.totalTaxable"></span>
            </th>
            <th class="right" sxy-text="SALAXY.NG1.WorkerReportComponent.table.compensation"></th>
            <th sxy-text="SALAXY.NG1.WorkerReportComponent.table.summary"></th>
            <th class="right" sxy-text="SALAXY.NG1.WorkerReportComponent.table.taxPercent"></th>
            <th class="right" sxy-text="SALAXY.NG1.WorkerReportComponent.table.householdDeduction"></th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat-start="report in $ctrl.currentReport" ng-controller="WorkerSummaryReportDisplayController as $displayCtrl">
            <td>
              <div style="font-size: 64px; line-height: 1" ng-init="avatar = $ctrl.avatarFrom(report.employer.avatar.url)">
                <i ng-if="!avatar.url" class="salaxy-avatar bi" ng-class="avatar.baseIcon" ng-style="{color: avatar.color}"><strong>{{ avatar.initials }}</strong></i>
                <i ng-if="avatar.url" class="salaxy-avatar bi"><img ng-src="{{ avatar.url }}"></img></i>
              </div>
            </td>
            <td>
              {{ report.employer.fullName}}<br />
              <a ng-href="mailto:{{ $ctrl.workerEmailFrom(report) }}">{{ $ctrl.employerEmailFrom(report) }}</a><br /> {{ report.employer.identity.socialSecurityNumberValid }}
            </td>
            <td class="right">
              {{ report.grossSalary | currency : "€" : 2}}<br /> {{ report.totalTaxable | currency : "€" : 2}}
            </td>
            <td class="right">
              {{ report.totalExpenses | currency : "€" : 2}}
            </td>
            <td>
              <a ng-click="$displayCtrl.display($ctrl.selectedYear.value, 'self', report.employer.id)"
                class="btn btn-primary btn-xs"
                sxy-text="SALAXY.NG1.WorkerReportComponent.table.yearlyReport" post="&nbsp;&raquo;"
                ></a>
            </td>
            <td colspan="2">
              <p class="small">
                <strong sxy-text="SALAXY.NG1.WorkerReportComponent.table.workerYearlySummaryTitle"></strong><br />
                <a ng-click="$displayCtrl.display($ctrl.selectedYear.value, 'self', report.employer.id)">
                  <span sxy-text="SALAXY.NG1.WorkerReportComponent.table.workerYearlySummaryLink"></span></a> <span
                  sxy-text="SALAXY.NG1.WorkerReportComponent.table.workerYearlySummaryText"></span>
              </p>
            </td>
          </tr>
          <tr ng-repeat-end="" ng-repeat="calculation in report.underlyingCalculations">
            <td></td>
            <td>
              <b ng-if="!$ctrl.isSelectedYearBeforeIncomesRegistry">
                {{ calculation.salaryDate | date : "dd.MM" }}
              </b>
              <b ng-if="$ctrl.isSelectedYearBeforeIncomesRegistry">
                {{ calculation.paidAt | date : "dd.MM" }}
              </b>
            </td>
            <td class="right">
              {{ calculation.totals.totalGrossSalary | currency : "€" : 2 }}<br /> {{ calculation.totals.totalTaxable | currency : "€" : 2 }}
            </td>
            <td class="right">
              {{ calculation.totals.totalExpenses | currency : "€" : 2 }}
            </td>
            <td ng-controller="CalcReportsDisplayController as $displayCtrl">
              <a ng-href="#/calc/details/{{ calculation.id }}" class="btn btn-secondary btn-xs"><span
                  sxy-text="SALAXY.NG1.WorkerReportComponent.table.calculationBtn"></span>&nbsp;&raquo;</a><br />
              <button ng-click="$displayCtrl.displayForId('salarySlip', calculation.id)" class="btn btn-primary btn-xs"><span
                  sxy-text="SALAXY.NG1.WorkerReportComponent.table.printBtn"></span>&nbsp;&raquo;</button><br />
            </td>
            <td class="right">
              {{ calculation.workerCalc.tax > 0 ? (calculation.workerCalc.tax | currency : "€" : 2) : "-" }}
            </td>
            <td class="right">
              {{ calculation.salary.isDeductible ? (calculation.employerCalc.householdDeduction | currency : "€" : 2) : "-" }}
            </td>
          </tr>
        </tbody>
      </table>
      <br />
    </div>
  </div>
</div>`), s.put("salaxy-components/records/Records.html", `<div class="salaxy-component salaxy-records">
  <table class="table">
    <thead>
      <tr>
        <th>{{"SALAXY.NG1.WorkerDetailsComponent.records.recordType" | sxyTranslate}}</th>
        <th>{{"SALAXY.NG1.WorkerDetailsComponent.records.title" | sxyTranslate}}</th>
        <th>{{"SALAXY.NG1.WorkerDetailsComponent.records.text" | sxyTranslate}}</th>
        <th>{{"SALAXY.NG1.WorkerDetailsComponent.records.startDate" | sxyTranslate}}</th>
        <th>{{"SALAXY.NG1.WorkerDetailsComponent.records.badge" | sxyTranslate}}</th> 
        <th class="text-end">
          <button type="button" class="btn btn-primary btn-xs" ng-if="!$ctrl.readOnly" ng-click="$ctrl.showEditRecord({attachments: []})" sxy-text="SALAXY.UI_Terms.add"></button>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="item in $ctrl.records">
        <td>{{item.recordType}}</td>
        <td>{{item.title}}</td>
        <td>{{item.text}} <div ng-repeat="attachment in item.attachments">
          <a target="_blank" ng-href="{{$ctrl.getAttachmentDownloadUrl(attachment)}}">
            <i class="bi {{ $ctrl.getAttachmentIcon(attachment) }} text-primary me-1"></i>{{attachment.fileName}}
          </a>
        </td>
        <td>{{ item.startDate | date }}</td>
        <td>
          <div ng-repeat="wfEvent in $ctrl.getEvents(item)">
            <span  ng-class="'badge bg-' + wfEvent.ui">
              {{wfEvent.message}}
            </span>
          </div>
        </td>
        <td class="text-end" ng-if="!$ctrl.readOnly">
          <button type="button" class="btn btn-primary btn-xs" ng-click="$ctrl.showEditRecord(item, $index)">
            <i class="bi bi-pencil-fill" title="{{'SALAXY.UI_Terms.edit' | sxyTranslate}}"></i>
          </button>
          <button type="button" class="btn btn-danger btn-xs" ng-click="$ctrl.deleteRecord(item, $index)">
            <i class="bi bi-trash" title="{{'SALAXY.UI_Terms.deleteRow' | sxyTranslate}}"></i>
          </button>
        </td>
        <td class="text-end" ng-if="$ctrl.readOnly">
          <button type="button" class="btn btn-primary btn-xs" ng-click="$ctrl.showEditRecord(item, $index)">
            <i class="bi bi-info-circle" title="{{'SALAXY.UI_Terms.show' | sxyTranslate}}"></i>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</div>`), s.put("salaxy-components/report/AccountingHolidayPayDebtReportQuery.html", `<div class="salaxy-component salaxy-accounting-report-query">
  <form name="queryForm" class="form-horizontal">
    <div ng-show="false" ng-init="$ctrl.queryForm = queryForm"></div>
    <fieldset>
      <div class="col col-md-6">
        <salaxy-datepicker-popup name="refDate" ng-model="$ctrl.refDate" label="Velan päivämäärä" require="true" ng-change="$ctrl.query()"></salaxy-datepicker-popup>
      </div>
    </fieldset>
  </form>
  <div class="col col-md-12 text-right">
    <button class="btn btn-primary" ng-disabled="!$ctrl.queryForm.$valid" ng-click="$ctrl.queryData($reportTools.targetId)" sxy-text="SALAXY.NG1.AccountingReportQueryComponent.queryRows"></button>
  </div>

  <salaxy-accounting-report-tools ng-ref="$reportTools" any-expanded="$reportRows.anyExpanded" on-expand-change="$reportRows.expand(close)" on-target-change="$ctrl.queryData(targetId)" reader="$ctrl.dataReader" view="$ctrl.view"></salaxy-accounting-report-tools>
  <salaxy-accounting-report-rows lang="$ctrl.lang" ng-ref="$reportRows" data="$ctrl.data" view="$ctrl.view"></salaxy-accounting-report-rows>
</div>`), s.put("salaxy-components/report/AccountingReportList.html", `<div class="salaxy-component salaxy-accounting-report-list">
  <salaxy-odata-table ng-if="$ctrl.mode != 'panel'" crud-controller="AccountingReportCrudController as $crud" template-url="salaxy-components/odata/lists/AccountingReports.html" options="{ $filter: $ctrl.getODataFilter(), $orderby: 'logicalDate desc' }">
  </salaxy-odata-table>
  <salaxy-odata-table ng-if="$ctrl.mode == 'panel'" crud-controller="AccountingReportCrudController as $crud" template-url="salaxy-components/odata/lists/AccountingReportsPanel.html" options="$ctrl.panelQueryOptions">
  </salaxy-odata-table>
</div>`), s.put("salaxy-components/report/AccountingReportQuery.html", `<div class="salaxy-component salaxy-accounting-report-query">
  <form name="queryForm" ng-if="!$ctrl.calcs" class="form-horizontal">
    <div ng-show="false" ng-init="$ctrl.queryForm = queryForm"></div>
    <fieldset>
      <div class="row">
        <div class="col col-6">
          <salaxy-input-enum name="queryType" label="SALAXY.NG1.AccountingReportQueryComponent.reportCalcsLabel" options="{periodQuery: ('SALAXY.NG1.AccountingReportQueryComponent.periodQueryEnum' | sxyTranslate), selectionQuery: ('SALAXY.NG1.AccountingReportQueryComponent.selectionQueryEnum' | sxyTranslate) }"
          ng-model="$ctrl.queryType" type="radio" required></salaxy-input-enum>
        </div>
        <div class="col col-6" ng-if="$ctrl.queryType == 'selectionQuery'">
          <p>
            <span class="label label-primary" ng-if="$ctrl.calculations.length"> <span sxy-text="SALAXY.UI_Terms.chosen" ps=":"></span>{{ $ctrl.calculations.length }}</span>
          </p>
          <div class="btn-toolbar" role="toolbar">
            <button class="btn btn-default" ng-click="$ctrl.addCalcs('paid')" sxy-text="SALAXY.NG1.AccountingReportQueryComponent.addPaidCalcs"></button>
            <button class="btn btn-default" ng-click="$ctrl.addCalcs('draft')" sxy-text="SALAXY.NG1.AccountingReportQueryComponent.addDraftCalcs"></button>
          </div>
        </div>
        <div class="col col-6" ng-if="$ctrl.queryType == 'periodQuery'">
          <salaxy-input-enum name="periodDateKind" label="SALAXY.NG1.AccountingReportQueryComponent.periodDateKindLabel" enum="PeriodDateKind"
          ng-model="$ctrl.periodDateKind" type="radio" required></salaxy-input-enum>
        </div>
      </div>
      <div class="row">
        <div class="col col-6" ng-if="$ctrl.queryType == 'periodQuery'">
          <salaxy-input-enum name="period" label="SALAXY.NG1.AccountingReportQueryComponent.period" options="{month: ('SALAXY.NG1.AccountingReportQueryComponent.monthEnum' | sxyTranslate), custom: ('SALAXY.NG1.AccountingReportQueryComponent.customEnum' | sxyTranslate) }"
          ng-model="$ctrl.periodType" type="radio" required></salaxy-input-enum>
        </div>
        <div class="col col-6" ng-if="$ctrl.queryType == 'periodQuery'">
          <salaxy-datepicker-popup name="refDateMonth" placeholder="SALAXY.NG1.AccountingReportQueryComponent.monthPlaceHolder" ng-if="$ctrl.periodType == 'month'" format="month" ng-model="$ctrl.refDate"
            label="SALAXY.NG1.AccountingReportQueryComponent.refDateMonthLabel" require="true"></salaxy-datepicker-popup>
          <salaxy-datepicker-popup name="refDateQuarter" placeholder="SALAXY.NG1.AccountingReportQueryComponent.monthPlaceHolder" ng-if="$ctrl.periodType == 'quarter'" format="month" ng-model="$ctrl.refDate"
            label="SALAXY.NG1.AccountingReportQueryComponent.refDateQuarterLabel" require="true"></salaxy-datepicker-popup>
          <salaxy-datepicker-popup name="refDateYear" placeholder="SALAXY.NG1.AccountingReportQueryComponent.yearPlaceholder" ng-if="$ctrl.periodType == 'year'" format="year" ng-model="$ctrl.refDate"
            label="SALAXY.NG1.AccountingReportQueryComponent.refDateYearLabel" require="true"></salaxy-datepicker-popup>
          <salaxy-datepicker-popup name="refDateCustom" ng-if="$ctrl.periodType == 'custom'" ng-model="$ctrl.refDate" label="SALAXY.NG1.AccountingReportQueryComponent.refDateCustomLabel" require="true"></salaxy-datepicker-popup>
          <salaxy-datepicker-popup name="endDateCustom" ng-if="$ctrl.periodType == 'custom'" ng-model="$ctrl.endDate" label="SALAXY.NG1.AccountingReportQueryComponent.endDateCustomLabel"></salaxy-datepicker-popup>
        </div>
      </div>
    </fieldset>
    <div ng-if="$ctrl.queryType == 'selectionQuery'" class="col col-md-12">
      <div ng-if="$ctrl.calculations.length" class="table-responsive salaxy-odata-table">
        <table class="table table-striped">
          <thead>
            <tr>
              <th colspan="2">
                <span sxy-text="SALAXY.NG1_Other.Roles.worker"></span>
              </th>
              <th class="hidden-xxs">
                <span sxy-text="SALAXY.NG1.AccountingReportQueryComponent.status"></span><br />
                <span><span sxy-text="SALAXY.NG1.AccountingReportQueryComponent.date"></span></span>
              </th>
              <th class="right hidden-xxs">
                <span sxy-text="SALAXY.NG1.AccountingReportQueryComponent.salary"></span><br />
                <span><span sxy-text="SALAXY.NG1.AccountingReportQueryComponent.payment"></span></span>
              </th>
              <th class="hidden-xxs"></th>
            </tr>
          </thead>
          <tbody>
            <tr ng-repeat="row in $ctrl.calculations">
              <td class="td-avatar visible-xxs middle">
                <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
              </td>
              <td class="td-name visible-xxs middle">
                <span ng-if="row.otherPartyInfo.avatar.displayName == ''" sxy-text="SALAXY.NG1.AccountingReportQueryComponent.notSelected"></span>
                <strong>{{row.otherPartyInfo.avatar.displayName}}</strong><br /> {{ "SALAXY.ENUM.CalculationStatus." + row.status + ".label" | sxyTranslate }}
                <br /> {{ row.endAt | date }}
              </td>
              <td class="right visible-xxs bottom">
                <div>
                  {{ row.grossSalary | currency }}<br /> {{ row.payment | currency }}
                </div>
              </td>
              <td class="td-avatar hidden-xxs middle">
                <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
              </td>
              <td class="td-name hidden-xxs middle">
                <span ng-if="row.otherPartyInfo.avatar.displayName == ''" sxy-text="SALAXY.NG1.AccountingReportQueryComponent.notSelected"></span>
                <strong>{{row.otherPartyInfo.avatar.displayName}}</strong><br />
              </td>
              <td class="hidden-xxs middle">
                {{ row.status ? ("SALAXY.ENUM.CalculationStatus." + row.status + ".label" | sxyTranslate) : "#ERR" }}<br /> {{ row.endAt | date }}
              </td>
              <td class="right hidden-xxs middle">
                {{ row.grossSalary | currency }}<br /> {{ row.payment | currency }}
              </td>
              <td class="right middle">
                <button class="btn btn-sm  btn-danger" type="button" ng-click="$ctrl.removeCalc(row)">
                      {{ 'SALAXY.UI_Terms.unselect' | sxyTranslate }}
                    </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </form>
  <div ng-if="!$ctrl.calcs" class="col col-md-12 text-end">
    <button class="btn btn-primary" ng-disabled="!$ctrl.queryForm.$valid" ng-click="$ctrl.queryData($reportTools.targetId)" sxy-text="SALAXY.NG1.AccountingReportQueryComponent.queryRows"></button>
  </div>

  <salaxy-accounting-report-tools ng-ref="$reportTools" any-expanded="$reportRows.anyExpanded" on-expand-change="$reportRows.expand(close)" on-target-change="$ctrl.queryData(targetId)" reader="$ctrl.dataReader" view="$ctrl.view"></salaxy-accounting-report-tools>
  <salaxy-accounting-report-rows lang="$ctrl.lang" ng-ref="$reportRows" data="$ctrl.data" view="$ctrl.view"></salaxy-accounting-report-rows>
</div>`), s.put("salaxy-components/report/AccountingReportRows.html", `<div class="salaxy-component salaxy-accounting-report-rows">
  <table ng-if="$ctrl.view != 'full'" class="table table-sm">
    <thead style="display: table-header-group;">
      <tr>
        <th class="col-md-3" sxy-text="SALAXY.NG1.AccountingReportRowsComponent.accountNumber"></th>
        <th class="col-md-6" sxy-text="SALAXY.NG1.AccountingReportRowsComponent.accountName"></th>
        <th class="col-md-3 right" sxy-text="SALAXY.NG1.AccountingReportRowsComponent.saldo"></th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat-start="ledgerAccount in ($ctrl.data || {}).ledgerAccounts">
        <td>{{ledgerAccount.accountNumber }}</td>
        <td>{{ledgerAccount.accountName}}</td>
        <td class="right"><a ng-click="ledgerAccount.rowToggle = !ledgerAccount.rowToggle">{{ledgerAccount.saldo | currency}}</a></td>
      </tr>
      <tr ng-if="ledgerAccount.rowToggle" ng-repeat-end>
        <td colspan="3">
          <table class="table table-sm">
            <thead>
              <tr class="toggled-rows">
                <th class="col-md-3" sxy-text="SALAXY.NG1.AccountingReportRowsComponent.calculation"></th>
                <th class="col-md-6" sxy-text="SALAXY.NG1.AccountingReportRowsComponent.description"></th>
                <th class="col-md-1 right" sxy-text="SALAXY.NG1.AccountingReportRowsComponent.vatPercent"></th>
                <th class="col-md-2 right" sxy-text="SALAXY.NG1.AccountingReportRowsComponent.sum"></th>
              </tr>
            </thead>
            <tbody>
              <tr ng-repeat="entry in ledgerAccount.entries" class="toggled-rows">
                <td>
                  <a ng-if="entry.dimension.calculationId" ng-href="#/calc/details/{{entry.dimension.calculationId}}">{{entry.dimension.calculationTitle}}</a>
                  <a ng-if="!entry.dimension.calculationId && entry.dimension.employmentId" ng-href="#/employments/details/{{entry.dimension.employmentId}}">{{entry.dimension.workerName}}</a>
                </td>
                <td>{{entry.description}}
                  <div ng-if="entry.dimension.projectNumber">{{'SALAXY.NG1.AccountingReportRowsComponent.projectNumber' | sxyTranslate}}: {{entry.dimension.projectNumber}}</div>
                  <div ng-if="entry.dimension.costCenter">{{'SALAXY.NG1.AccountingReportRowsComponent.costCenter' | sxyTranslate}}: {{entry.dimension.costCenter}}</div>
                  <div ng-if="entry.dimension.dimensions" ng-repeat="(k,v) in entry.dimension.dimensions">
                    {{k}}: {{v}}
                  </div>
                </td>
                <td class="right"><span ng-if="entry.vatPercent >= 0">{{ entry.vatPercent | sxyCount : 'percent'}}</span></td>
                <td class="right">{{!entry.isDebit ? -1 * entry.amount : entry.amount | currency}}</td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  </table>
  <div ng-if="$ctrl.view == 'full'">
    <div ng-bind-html="$ctrl.html" class="report-binder table-responsive"></div>
  </div>
</div>`), s.put("salaxy-components/report/AccountingReportTools.html", `<div class="salaxy-component salaxy-accounting-report-tools">
  <div class="btn-toolbar" role="toolbar" aria-label="Report options">
    <div class="btn-group btn-group-sm dropdown">
      <button id="reportOptionsTarget" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown">
        {{'SALAXY.NG1.AccountingReportToolsComponent.target' | sxyTranslate}}: <img style="height: 15px;" ng-if="$ctrl.getTarget($ctrl.targetId).avatar.url" ng-src="{{$ctrl.getTarget($ctrl.targetId).avatar.url}}">&nbsp;{{$ctrl.getTarget($ctrl.targetId).avatar.displayName}}
      </button>
      <ul class="dropdown-menu" role="menu" aria-labelledby="reportOptionsTarget">
        <li ng-repeat="target in $ctrl.targets" role="menuitem">
          <a href="" ng-click="$ctrl.changeTarget(target.id)" class="dropdown-item"><img style="height: 20px;" ng-if="$ctrl.getTarget(target.id).avatar.url" ng-src="{{$ctrl.getTarget(target.id).avatar.url}}">&nbsp;{{$ctrl.getTarget(target.id).avatar.displayName}}</a>
        </li>
        <li role="menuitem"><button class="btn btn-link dropdown-item" ng-click="$ctrl.navigate('/settings/accounting-target-settings')" sxy-text="SALAXY.NG1.AccountingReportToolsComponent.settingsAddMoreTargets" ps="..."></button></li>
      </ul>
    </div>
    <div class="btn-group btn-group-sm dropdown ms-1" ng-if="$ctrl.getTarget($ctrl.targetId).schemes.length">
      <button id="reportOptionsScheme" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown">
        {{$ctrl.getScheme($ctrl.schemeId).label}}
      </button>
      <ul class="dropdown-menu"  role="menu" aria-labelledby="reportOptionsScheme">
        <li ng-repeat="scheme in $ctrl.getTarget($ctrl.targetId).schemes" role="menuitem">
          <a href="" ng-click="$ctrl.schemeId = scheme.id" class="dropdown-item">{{$ctrl.getScheme(scheme.id).label}}</a>
        </li>
      </ul>
    </div>
    <div class="btn-group btn-group-sm dropdown ms-1">
      <button id="reportOptionsExportMethod" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown">
        {{$ctrl.getExportMethod($ctrl.exportMethod).label}}
      </button>
      <ul class="dropdown-menu" role="menu" aria-labelledby="reportOptionsExportMethod">
        <li role="menuitem" ng-repeat="exportMethod in $ctrl.exportMethods">
          <a href="" ng-click="$ctrl.exportMethod = exportMethod.id" class="dropdown-item">{{$ctrl.getExportMethod(exportMethod.id).label}}</a>
        </li>
      </ul>
    </div>
    <div class="btn-group btn-group-sm dropdown ms-1">
      <button id="reportOptionsCulture" type="button" class="btn btn-default dropdown-toggle" ng-disabled="!$ctrl.getExportMethod($ctrl.exportMethod).hasLocales" data-bs-toggle="dropdown">
        {{$ctrl.getLocale($ctrl.localeId).label}}
      </button>
      <ul class="dropdown-menu" role="menu" aria-labelledby="reportOptionsCulture">
        <li role="menuitem">
          <a href="" ng-click="$ctrl.localeId = 'fi'" class="dropdown-item">{{$ctrl.getLocale('fi').description}}</a>
        </li>
        <li role="menuitem">
          <a href="" ng-click="$ctrl.localeId = 'en'" class="dropdown-item">{{$ctrl.getLocale('en').description}}</a>
        </li>
      </ul>
    </div>
    <div class="btn-group btn-group-sm ms-1">
      <button ng-disabled="$ctrl.reader.disabled()" id="reportExport" type="button" class="btn btn-primary" ng-click="$ctrl.export()">
        {{ $ctrl.reader.exportLabel || ('SALAXY.NG1.AccountingReportToolsComponent.createExport' | sxyTranslate) }}  
      </button>
    </div>
    <div class="ms-3" ng-if="$ctrl.reader.showExpand && $ctrl.view == 'partial'">
      <button ng-if="!$ctrl.anyExpanded" ng-disabled="$ctrl.reader.hasRows()" class="btn btn-block btn-transparent p-0" title="{{'SALAXY.NG1.AccountingReportToolsComponent.showRowsAndExports' | sxyTranslate}}" ng-click="$ctrl.expand()">
        <i class="bi bi-arrows-angle-expand"></i>
      </button>
      <button ng-if="$ctrl.anyExpanded" ng-disabled="$ctrl.reader.hasRows()" class="btn btn-block btn-transparent p-0" title="{{'SALAXY.NG1.AccountingReportToolsComponent.showOnlyRows' | sxyTranslate}}" ng-click="$ctrl.expand(true)">
        <i class="bi bi-arrows-angle-contract"></i>
      </button>
    </div>
  </div>
</div>`), s.put("salaxy-components/report/AccountingReportViewer.html", `<div class="btn-toolbar" role="toolbar" salaxy-if-role="test,pro">
  <salaxy-accounting-report-tools any-expanded="$reportRows.anyExpanded" on-expand-change="$reportRows.expand(close)" on-target-change="$ctrl.loadCurrentData(targetId)" reader="$ctrl.currentDataReader"></salaxy-accounting-report-tools>
  <salaxy-workflow-buttons class="ms-auto" disabled="!($ctrl.currentData && $ctrl.currentData.ledgerAccounts.length > 0)" api-ctrl="$ctrl"></salaxy-workflow-buttons>
</div>
<salaxy-accounting-report-rows ng-ref="$reportRows" data="$ctrl.currentData"></salaxy-accounting-report-rows>`), s.put("salaxy-components/report/AccountingRowReport.html", `<div class="salaxy-component salaxy-accounting-row-report" style="width:100%;height:100%;display:flex;flex-flow:column">
  <div class="btn-toolbar" role="toolbar">
    <div class="btn-group" role="group" aria-label="{{'SALAXY.NG1.CumulativeReportComponent.chooseData' | sxyTranslate}}">
      <button type="button" class="btn btn-primary" ng-click="$ctrl.showPeriodSelection()" sxy-text="SALAXY.NG1.CumulativeReportComponent.selectPeriod" ps="..."></button>
      <button type="button" class="btn btn-default" ng-click="$ctrl.showCalcsSelection()" sxy-text="SALAXY.NG1.CumulativeReportComponent.selectCalcs" ps="..."></button>
      <button type="button" class="btn btn-default" ng-click="$ctrl.showPayrollSelection()" sxy-text="SALAXY.NG1.CumulativeReportComponent.selectPayrolls" ps="..."></button>
    </div>
    <div class="btn-group ms-1" role="group" aria-label="{{'SALAXY.NG1.CumulativeReportComponent.reportTemplates' | sxyTranslate}}">
      <div class="btn-group btn-group dropdown">
        <button id="templateId" type="button" class="btn btn-default dropdown-toggle" ng-disabled="!$ctrl.data" data-bs-toggle="dropdown">
          <span ng-if="$ctrl.data">
            <salaxy-avatar style="font-size: 1.8em; margin: -2px 4px -2px -2px;" avatar="$ctrl.getTemplate($ctrl.templateId).avatar"></salaxy-avatar> {{$ctrl.getTemplate($ctrl.templateId).label}}
          </span>
          <span ng-if="!$ctrl.data" sxy-text="SALAXY.NG1.CumulativeReportComponent.reportTemplates"></span>
        </button>
        <ul class="dropdown-menu" role="menu" aria-labelledby="templateId">
          <li role="menuitem" ng-repeat="template in $ctrl.templates">
            <a href="" ng-click="$ctrl.selectTemplate(template.id)" class="dropdown-item">
               <salaxy-avatar style="font-size: 1.8em; margin: -2px 4px -2px -2px;" avatar="$ctrl.getTemplate(template.id).avatar"></salaxy-avatar> {{$ctrl.getTemplate(template.id).label}}
            </a>
          </li>
        </ul>
      </div>
      <button type="button" class="btn btn-default ms-1"  ng-disabled="!$ctrl.data" ng-click="$ctrl.showSaveTemplate()">{{'SALAXY.UI_Terms.edit' | sxyTranslate}}...</button>
    </div>
  </div>
  <div style="height:100%;flex-grow:1">
    <div id="dataGrid" class="ag-theme-balham" style="height:100%;overflow: hidden;"></div>
  </div>
</div>
`), s.put("salaxy-components/report/CalculationReport.html", `<div class="salaxy-component salaxy-calculation-report" style="width:100%;height:100%;display:flex;flex-flow:column">
  <div class="btn-toolbar" role="toolbar">
    <div class="btn-group" role="group" aria-label="{{'SALAXY.NG1.CumulativeReportComponent.chooseData' | sxyTranslate}}">
      <button type="button" class="btn btn-primary" ng-click="$ctrl.showPeriodSelection()" sxy-text="SALAXY.NG1.CumulativeReportComponent.selectPeriod" ps="..."></button>
      <button type="button" class="btn btn-default" ng-click="$ctrl.showCalcsSelection()" sxy-text="SALAXY.NG1.CumulativeReportComponent.selectCalcs" ps="..."></button>
      <button type="button" class="btn btn-default" ng-click="$ctrl.showPayrollSelection()" sxy-text="SALAXY.NG1.CumulativeReportComponent.selectPayrolls" ps="..."></button>
    </div>
    <div class="btn-group" role="group" aria-label="{{'SALAXY.NG1.CumulativeReportComponent.reportTemplates' | sxyTranslate}}">
      <div class="btn-group btn-group dropdown">
        <button id="templateId" type="button" class="btn btn-default dropdown-toggle" ng-disabled="!$ctrl.data" data-bs-toggle="dropdown">
          <span ng-if="$ctrl.data">
            <salaxy-avatar style="font-size: 1.8em; margin: -2px 4px -2px -2px;" avatar="$ctrl.getTemplate($ctrl.templateId).avatar"></salaxy-avatar> {{$ctrl.getTemplate($ctrl.templateId).label}}
          </span>
          <span ng-if="!$ctrl.data" sxy-text="SALAXY.NG1.CumulativeReportComponent.reportTemplates"></span>
        </button>
        <ul class="dropdown-menu" role="menu" aria-labelledby="templateId">
          <li role="menuitem" ng-repeat="template in $ctrl.templates">
            <a href="" ng-click="$ctrl.selectTemplate(template.id)" class="dropdown-item">
               <salaxy-avatar style="font-size: 1.8em; margin: -2px 4px -2px -2px;" avatar="$ctrl.getTemplate(template.id).avatar"></salaxy-avatar> {{$ctrl.getTemplate(template.id).label}}
            </a>
           </li>
        </ul>
      </div>
      <button type="button" class="btn btn-default ms-1"  ng-disabled="!$ctrl.data" ng-click="$ctrl.showSaveTemplate()">{{'SALAXY.UI_Terms.edit' | sxyTranslate}}...</button>
    </div>
  </div>
  <div style="height:100%;flex-grow:1">
    <div id="dataGrid" class="ag-theme-balham" style="height:100%;overflow: hidden;"></div>
  </div>
</div>
`), s.put("salaxy-components/report/HolidayPayReportQuery.html", `<div class="salaxy-component salaxy-holiday-pay-report-query">
  <div ng-if="$ctrl.data.holidayYear.employmentId" class="salaxy-calc-worker-info" ng-controller="EmploymentCrudController as $employmentCtrl" ng-init="$employmentCtrl.model=$ctrl.data.holidayYear.employmentId">
    <div class="row spacer-bottom" ng-if="$employmentCtrl.current">
      <div class="col-xs-3 col-sm-2 col-xxs-3">
        <salaxy-avatar avatar="$employmentCtrl.current.personalInfo.avatar"></salaxy-avatar>
      </div>
      <div class="col-xs-9 col-sm-10 col-xxs-9 worker-info-col">
        <h2>{{ $employmentCtrl.current.personalInfo.avatar.displayName || ("SALAXY.NG1.WorkerInfo.noSelection" | sxyTranslate) }}</h2>
        <div class="row" ng-if="$employmentCtrl.current">
          <div class="col-xs-12 col-sm-6 ">
            <div ng-class="$employmentCtrl.current.personalInfo.officialId ? '' : 'text-danger'">
              {{ $employmentCtrl.current.personalInfo.officialId || ( "SALAXY.NG1.PaymentDialogComponent.noSSNumber" | sxyTranslate ) }}
              &nbsp;
              <div class="btn-group" ng-if="$employmentCtrl.otherEmployments.length > 0">
                <button id="single-button" type="button" class="btn btn-default btn-xs dropdown-toggle" 
                  data-bs-toggle="dropdown" aria-expanded="false">
                  {{ $employmentCtrl.otherEmployments.length }} muuta työsuhdetta
                </button>
                <ul class="dropdown-menu" aria-labelledby="single-button">
                  <li ng-repeat="item in $employmentCtrl.otherEmployments">
                    <a class="dropdown-item" ng-href="{{$employmentCtrl.isModal ? '' : ('#/employments/details/' + item.id)}}">
                      {{ $employmentCtrl.getEmploymentDescription(item) }} 
                      ({{ $employmentCtrl.getActiveText(item) }})
                    </a>
                  </li>
                </ul>
              </div>
              <span ng-if="!$employmentCtrl.otherEmployments">Tarkistetaan muita työsuhteita...</span>
            </div>
            <div>{{ $employmentCtrl.getEmploymentDescription($employmentCtrl.current) }}</div>
            <div>{{ $employmentCtrl.getActiveText($employmentCtrl.current) }}</div>
            <div><small>{{ $employmentCtrl.current.id }}</small></div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6">
        <form class="form-horizontal">
            <salaxy-input-enum  name="year"  ng-model="$ctrl.year"   label="SALAXY.NG1.HolidayReportComponent.holidayYear" options="$ctrl.years" ng-change="$ctrl.query()"></salaxy-input-enum>
            <salaxy-input-enum ng-if="$ctrl.data.holidayYear.spec.code == 'permanent14Days' || $ctrl.data.holidayYear.spec.code == 'permanent35Hours' || $ctrl.data.holidayYear.spec.code == 'temporaryTimeOff' || $ctrl.data.holidayYear.spec.code == 'other'" name="holidayPayCalculation" ng-model="$ctrl.data.holidayYear.spec.holidayPayCalculation" disabled="true" label="SALAXY.MODEL.HolidaySpecificationForYear.holidayPayCalculation.title" enum="HolidayPayCalculation"></salaxy-input-enum>
            <salaxy-input-enum name="holidayCode" ng-model="$ctrl.data.holidayYear.spec.code" disabled="true" label="SALAXY.MODEL.HolidaySpecificationForYear.code.title" enum="HolidayCode"></salaxy-input-enum>
            <salaxy-input-enum name="wageBasis" ng-model="$ctrl.data.holidayYear.spec.wageBasis" disabled="true" label="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.wageBasis" enum="WageBasis"></salaxy-input-enum>   
        </form>
      </div>
      <div class="col-sm-6">
        <form class="form-horizontal" ng-if="$ctrl.data.holidayYear.spec.code == 'permanent14Days' || $ctrl.data.holidayYear.spec.code == 'permanent35Hours' || $ctrl.data.holidayYear.spec.code == 'temporaryTimeOff' || $ctrl.data.holidayYear.spec.code == 'other'">

            <salaxy-input-number ng-model="$ctrl.data.holidayYear.accrual.total" name="accrualTotal"   disabled="true" label="Lomavuoden kertymä" ></salaxy-input-number>

            <salaxy-input-number ng-model="$ctrl.data.holidayYear.holidayPay.otherPay" ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'otherPay'" name="otherPay"   disabled="true"  label="SALAXY.MODEL.HolidayPay.otherPay.title" ></salaxy-input-number>

            <salaxy-input-number ng-model="$ctrl.data.holidayYear.holidayPay.normalMonthlyPayDailySalary" name="normalMonthlyPayDailySalary" ng-if="($ctrl.data.holidayYear.spec.code == 'permanent14Days' || $ctrl.data.holidayYear.spec.code == 'permanent35Hours' || $ctrl.data.holidayYear.spec.code == 'other') && $ctrl.data.holidayYear.spec.wageBasis =='monthly' && $ctrl.data.holidayYear.spec.holidayPayCalculation == 'normalMonthlyPay'" disabled="true" label="SALAXY.MODEL.HolidayPay.normalMonthlyPayDailySalary.title" ></salaxy-input-number>
            <salaxy-input-number ng-model="$ctrl.data.holidayYear.holidayPay.normalMonthlyPayManual" name="normalMonthlyPayManual" ng-if="($ctrl.data.holidayYear.spec.code == 'permanent14Days' || $ctrl.data.holidayYear.spec.code == 'permanent35Hours' || $ctrl.data.holidayYear.spec.code == 'other') && $ctrl.data.holidayYear.spec.wageBasis =='monthly' && $ctrl.data.holidayYear.spec.holidayPayCalculation == 'normalMonthlyPay'"  disabled="true" label="SALAXY.MODEL.HolidayPay.normalMonthlyPayManual.title" ></salaxy-input-number>
            <salaxy-input-number ng-model="$ctrl.data.holidayYear.holidayPay.normalMonthlyPay" name="normalMonthlyPay" ng-if="($ctrl.data.holidayYear.spec.code == 'permanent14Days' || $ctrl.data.holidayYear.spec.code == 'permanent35Hours' || $ctrl.data.holidayYear.spec.code == 'other') && $ctrl.data.holidayYear.spec.wageBasis =='monthly' && $ctrl.data.holidayYear.spec.holidayPayCalculation == 'normalMonthlyPay'" disabled="true" label="SALAXY.MODEL.HolidayPay.normalMonthlyPay.title" ></salaxy-input-number>

            <salaxy-input-number ng-model="$ctrl.data.holidayYear.holidayPay.averageDailyPayDailySalary" name="averageDailyPayDailySalary" ng-if="($ctrl.data.holidayYear.spec.code == 'permanent14Days || $ctrl.data.holidayYear.spec.code == 'other') && ($ctrl.data.holidayYear.spec.wageBasis =='hourly' || $ctrl.data.holidayYear.spec.wageBasis =='performanceBased' || $ctrl.data.holidayYear.spec.wageBasis =='other') && $ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageDailyPay'" disabled="true" label="SALAXY.MODEL.HolidayPay.averageDailyPayDailySalary.title" ></salaxy-input-number>
            <salaxy-input-number ng-model="$ctrl.data.holidayYear.holidayPay.averageDailyPayManual" name="averageDailyPayManual" ng-if="($ctrl.data.holidayYear.spec.code == 'permanent14Days || $ctrl.data.holidayYear.spec.code == 'other') && ($ctrl.data.holidayYear.spec.wageBasis =='hourly' || $ctrl.data.holidayYear.spec.wageBasis =='performanceBased' || $ctrl.data.holidayYear.spec.wageBasis =='other') && $ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageDailyPay'"  disabled="true" label="SALAXY.MODEL.HolidayPay.averageDailyPayManual.title" ></salaxy-input-number>
            <salaxy-input-number ng-model="$ctrl.data.holidayYear.holidayPay.averageDailyPay" name="averageDailyPay" ng-if="($ctrl.data.holidayYear.spec.code == 'permanent14Days || $ctrl.data.holidayYear.spec.code == 'other') && ($ctrl.data.holidayYear.spec.wageBasis =='hourly' || $ctrl.data.holidayYear.spec.wageBasis =='performanceBased' || $ctrl.data.holidayYear.spec.wageBasis =='other') && $ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageDailyPay'" disabled="true" label="SALAXY.MODEL.HolidayPay.averageDailyPay.title" ></salaxy-input-number>
            <salaxy-input-number ng-model="$ctrl.data.holidayYear.holidayPay.averageDailyPayBase" name="averageDailyPayBase" ng-if="($ctrl.data.holidayYear.spec.code == 'permanent14Days || $ctrl.data.holidayYear.spec.code == 'other') && ($ctrl.data.holidayYear.spec.wageBasis =='hourly' || $ctrl.data.holidayYear.spec.wageBasis =='performanceBased' || $ctrl.data.holidayYear.spec.wageBasis =='other') && $ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageDailyPay'" disabled="true"  label="SALAXY.MODEL.HolidayPay.averageDailyPayBase.title" ></salaxy-input-number>
            <salaxy-input-number ng-model="$ctrl.data.holidayYear.holidayPay.averageDailyPayDays" name="averageDailyPayDays" ng-if="($ctrl.data.holidayYear.spec.code == 'permanent14Days || $ctrl.data.holidayYear.spec.code == 'other') && ($ctrl.data.holidayYear.spec.wageBasis =='hourly' || $ctrl.data.holidayYear.spec.wageBasis =='performanceBased' || $ctrl.data.holidayYear.spec.wageBasis =='other') && $ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageDailyPay'" disabled="true" label="SALAXY.MODEL.HolidayPay.averageDailyPayDays.title" ></salaxy-input-number>
            <salaxy-input-number ng-model="$ctrl.data.holidayYear.holidayPay.averageDailyPayMultiplier" name="averageDailyPayMultiplier" ng-if="($ctrl.data.holidayYear.spec.code == 'permanent14Days || $ctrl.data.holidayYear.spec.code == 'other') && ($ctrl.data.holidayYear.spec.wageBasis =='hourly' || $ctrl.data.holidayYear.spec.wageBasis =='performanceBased' || $ctrl.data.holidayYear.spec.wageBasis =='other') && $ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageDailyPay'" disabled="true" label="SALAXY.MODEL.HolidayPay.averageDailyPayMultiplier.title" ></salaxy-input-number>
  
            <salaxy-input-number ng-model="$ctrl.data.holidayYear.holidayPay.averageHourlyPayDailySalary" name="averageHourlyPayDailySalary" ng-if="($ctrl.data.holidayYear.spec.code == 'permanent14Days || $ctrl.data.holidayYear.spec.code == 'other') && ($ctrl.data.holidayYear.spec.wageBasis =='hourly' || $ctrl.data.holidayYear.spec.wageBasis =='performanceBased' || $ctrl.data.holidayYear.spec.wageBasis =='other') && $ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageHourlyPay'" disabled="true" label="SALAXY.MODEL.HolidayPay.averageHourlyPayDailySalary.title" ></salaxy-input-number>
            <salaxy-input-number ng-model="$ctrl.data.holidayYear.holidayPay.averageHourlyPayManual" name="averageHourlyPayManual" ng-if="($ctrl.data.holidayYear.spec.code == 'permanent14Days || $ctrl.data.holidayYear.spec.code == 'other') && ($ctrl.data.holidayYear.spec.wageBasis =='hourly' || $ctrl.data.holidayYear.spec.wageBasis =='performanceBased' || $ctrl.data.holidayYear.spec.wageBasis =='other') && $ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageHourlyPay'"  disabled="true" label="SALAXY.MODEL.HolidayPay.averageHourlyPayManual.title" ></salaxy-input-number>
            <salaxy-input-number ng-model="$ctrl.data.holidayYear.holidayPay.averageHourlyPay" name="averageHourlyPay" ng-if="($ctrl.data.holidayYear.spec.code == 'permanent14Days || $ctrl.data.holidayYear.spec.code == 'other') && ($ctrl.data.holidayYear.spec.wageBasis =='hourly' || $ctrl.data.holidayYear.spec.wageBasis =='performanceBased' || $ctrl.data.holidayYear.spec.wageBasis =='other') && $ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageHourlyPay'" disabled="true" label="SALAXY.MODEL.HolidayPay.averageHourlyPay.title" ></salaxy-input-number>
            <salaxy-input-number ng-model="$ctrl.data.holidayYear.holidayPay.averageHourlyPayBase" name="averageHourlyPayBase" ng-if="($ctrl.data.holidayYear.spec.code == 'permanent14Days || $ctrl.data.holidayYear.spec.code == 'other') && ($ctrl.data.holidayYear.spec.wageBasis =='hourly' || $ctrl.data.holidayYear.spec.wageBasis =='performanceBased' || $ctrl.data.holidayYear.spec.wageBasis =='other') && $ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageHourlyPay'" disabled="true"  label="SALAXY.MODEL.HolidayPay.averageHourlyPayBase.title" ></salaxy-input-number>
            <salaxy-input-number ng-model="$ctrl.data.holidayYear.holidayPay.averageHourlyPayHours" name="averageHourlyPayHours" ng-if="($ctrl.data.holidayYear.spec.code == 'permanent14Days || $ctrl.data.holidayYear.spec.code == 'other') && ($ctrl.data.holidayYear.spec.wageBasis =='hourly' || $ctrl.data.holidayYear.spec.wageBasis =='performanceBased' || $ctrl.data.holidayYear.spec.wageBasis =='other') && $ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageHourlyPay'" disabled="true" label="SALAXY.MODEL.HolidayPay.averageHourlyPayHours.title" ></salaxy-input-number>
            <salaxy-input-number ng-model="$ctrl.data.holidayYear.holidayPay.averageHourlyPayMultiplier" name="averageHourlyPayMultiplier" ng-if="($ctrl.data.holidayYear.spec.code == 'permanent14Days || $ctrl.data.holidayYear.spec.code == 'other') && ($ctrl.data.holidayYear.spec.wageBasis =='hourly' || $ctrl.data.holidayYear.spec.wageBasis =='performanceBased' || $ctrl.data.holidayYear.spec.wageBasis =='other') && $ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageHourlyPay'" disabled="true" label="SALAXY.MODEL.HolidayPay.averageHourlyPayMultiplier.title" ></salaxy-input-number>
      
            <salaxy-input-number ng-model="$ctrl.data.holidayYear.holidayPay.percentageBasedPayDailySalary" name="percentageBasedPayDailySalary" ng-if="($ctrl.data.holidayYear.spec.code == 'permanent35Hours' || $ctrl.data.holidayYear.spec.code == 'other') && $ctrl.data.holidayYear.spec.holidayPayCalculation == 'percentageBasedPay'" disabled="true" label="SALAXY.MODEL.HolidayPay.percentageBasedPayDailySalary.title" ></salaxy-input-number>
            <salaxy-input-number ng-model="$ctrl.data.holidayYear.holidayPay.percentageBasedPayManual" name="percentageBasedPayManual" ng-if="$($ctrl.data.holidayYear.spec.code == 'permanent35Hours' || $ctrl.data.holidayYear.spec.code == 'other') && $ctrl.data.holidayYear.spec.holidayPayCalculation == 'percentageBasedPay'"  disabled="true" label="SALAXY.MODEL.HolidayPay.percentageBasedPayManual.title" ></salaxy-input-number>
            <salaxy-input-number ng-model="$ctrl.data.holidayYear.holidayPay.percentageBasedPay" name="percentageBasedPay" ng-if="($ctrl.data.holidayYear.spec.code == 'permanent35Hours' || $ctrl.data.holidayYear.spec.code == 'other') && $ctrl.data.holidayYear.spec.holidayPayCalculation == 'percentageBasedPay'" disabled="true" label="SALAXY.MODEL.HolidayPay.percentageBasedPay.title" ></salaxy-input-number>
            <salaxy-input-number ng-model="$ctrl.data.holidayYear.holidayPay.percentageBasedPayBase" name="percentageBasedPayBase" ng-if="($ctrl.data.holidayYear.spec.code == 'permanent35Hours' || $ctrl.data.holidayYear.spec.code == 'other') && $ctrl.data.holidayYear.spec.holidayPayCalculation == 'percentageBasedPay'"  disabled="true" disabled="true" label="SALAXY.MODEL.HolidayPay.percentageBasedPayBase.title" ></salaxy-input-number>
            <salaxy-input-number ng-model="$ctrl.data.holidayYear.spec.holidayPayPercent" name="holidayPayPercent" ng-if="($ctrl.data.holidayYear.spec.code == 'permanent35Hours' || $ctrl.data.holidayYear.spec.code == 'other') && $ctrl.data.holidayYear.spec.holidayPayCalculation == 'percentageBasedPay'" required unit="percent"  disabled="true" label="SALAXY.MODEL.HolidaySpecificationForYear.holidayPayPercent.title" ></salaxy-input-number>

            <salaxy-input-number ng-model="$ctrl.data.holidayYear.holidayPay.compensationPayDailySalary" name="compensationPayDailySalary" ng-if="($ctrl.data.holidayYear.spec.code == 'temporaryTimeOff' || $ctrl.data.holidayYear.spec.code == 'other') && $ctrl.data.holidayYear.spec.holidayPayCalculation == 'holidayCompensation'"  disabled="true" label="SALAXY.MODEL.HolidayPay.compensationPayDailySalary.title" ></salaxy-input-number>
            <salaxy-input-number ng-model="$ctrl.data.holidayYear.holidayPay.compensationPayManual" name="compensationPayManual" ng-if="($ctrl.data.holidayYear.spec.code == 'temporaryTimeOff' || $ctrl.data.holidayYear.spec.code == 'other') && $ctrl.data.holidayYear.spec.holidayPayCalculation == 'holidayCompensation'"  disabled="true" label="SALAXY.MODEL.HolidayPay.compensationPayManual.title" ></salaxy-input-number>
            <salaxy-input-number ng-model="$ctrl.data.holidayYear.holidayPay.compensationPay" name="compensationPay" ng-if="($ctrl.data.holidayYear.spec.code == 'temporaryTimeOff' || $ctrl.data.holidayYear.spec.code == 'other') && $ctrl.data.holidayYear.spec.holidayPayCalculation == 'holidayCompensation'" disabled="true" label="SALAXY.MODEL.HolidayPay.compensationPay.title" ></salaxy-input-number>
            <salaxy-input-number ng-model="$ctrl.data.holidayYear.holidayPay.compensationPayBase" name="compensationPayBase" ng-if="($ctrl.data.holidayYear.spec.code == 'temporaryTimeOff' || $ctrl.data.holidayYear.spec.code == 'other') && $ctrl.data.holidayYear.spec.holidayPayCalculation == 'holidayCompensation'" disabled="true" label="SALAXY.MODEL.HolidayPay.compensationPayBase.title" ></salaxy-input-number>        
            <salaxy-input-number ng-model="$ctrl.data.holidayYear.spec.compensation" name="compensation" ng-if="($ctrl.data.holidayYear.spec.code == 'temporaryTimeOff' || $ctrl.data.holidayYear.spec.code == 'other') && $ctrl.data.holidayYear.spec.holidayPayCalculation == 'holidayCompensation'" unit="percent" required  disabled="true" label="SALAXY.MODEL.HolidaySpecificationForYear.compensation.title" ></salaxy-input-number>
 
        </form>
      </div>
    </div>
    <salaxy-tab-buttons
      current-tab="$ctrl.currentTab"
      options="[
        { 'value': 'calcs', 'text': 'SALAXY.NG1.HolidayPayReportQueryComponent.calculationsTab' },
        { 'value': 'parameters', 'text': 'SALAXY.NG1.HolidayPayReportQueryComponent.parametersTab' }
      ]"
      tabs-id="holidayPayReportQuery">
    </salaxy-tab-buttons>
    <div class="tab-content" id="tab-content-holidayPayReportQuery" ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageHourlyPay' || $ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageDailyPay' || $ctrl.data.holidayYear.spec.holidayPayCalculation == 'percentageBasedPay' || $ctrl.data.holidayYear.spec.holidayPayCalculation == 'holidayCompensation' || $ctrl.data.holidayYear.spec.holidayPayCalculation == 'normalMonthlyPay'">
      <div class="tab-pane" id="calcs-tab">
        <table ng-if="$ctrl.currentTab == 'calcs'" class="table table-striped">
          <thead>
            <tr>
              <th sxy-text="SALAXY.NG1.HolidayPayReportQueryComponent.calculation"></th>
              <th sxy-text="SALAXY.NG1.HolidayPayReportQueryComponent.description"></th>
              <th class="right" sxy-text="SALAXY.NG1.HolidayPayReportQueryComponent.count"></th>
              <th class="right" sxy-text="SALAXY.NG1.HolidayPayReportQueryComponent.price"></th>
              <th class="right" sxy-text="SALAXY.NG1.HolidayPayReportQueryComponent.toHolidayPay"></th>
              <th class="right" ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageHourlyPay'" sxy-text="SALAXY.NG1.HolidayPayReportQueryComponent.toWorkingHours"></th>
              <th class="right" ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageDailyPay'" sxy-text="SALAXY.NG1.HolidayPayReportQueryComponent.toOvertimeHours"></th>
              <th class="right" ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageDailyPay'" sxy-text="SALAXY.NG1.HolidayPayReportQueryComponent.workingDays"></th>
              <th class="right" ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageDailyPay'" sxy-text="SALAXY.NG1.HolidayPayReportQueryComponent.absenceDays"></th>
              <th sxy-text="SALAXY.NG1.HolidayPayReportQueryComponent.holidayPaySelection"></th>
              <th ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageHourlyPay'" sxy-text="SALAXY.NG1.HolidayPayReportQueryComponent.workingHoursSelection"></th>
              <th ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageDailyPay'" sxy-text="SALAXY.NG1.HolidayPayReportQueryComponent.overtimeHoursSelection"></th>
            </tr>
          </thead>
          <tbody>
            <tr ng-repeat-start="calc in $ctrl.data.calculations">
              <td><a ng-href="#/calc/details/{{calc.calculationId}}">{{calc.calculationTitle}} {{calc.salaryDate | date}}</a></td>
              <td>{{calc.workStartDate | date }} - {{calc.workEndDate | date}}</td>
              <td class="right"></td>
              <td class="right"></td>
              <td class="right"></td>
              <td ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageHourlyPay'" class="right"></td>
              <td ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageDailyPay'" class="right"></td>
              <td ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageDailyPay'" class="right">{{calc.workingDays}}</td>
              <td ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageDailyPay'" class="right">{{calc.absenceDays}}</td>
              <td></td>
              <td ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageHourlyPay'"></td>
              <td ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageDailyPay'"></td>
            </tr>
            <tr ng-repeat-end ng-repeat="row in calc.rows">
              <td></td>
              <td>{{$ctrl.getLabel(row.irRow)}}</td>
              <td class="right">{{row.irRow.count}}</td>
              <td class="right">{{row.irRow.price | currency}}</td>
              <td class="right">{{row.total | currency}}</td>
              <td ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageHourlyPay'" class="right">{{row.hours}}</td>
              <td ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageDailyPay'" class="right">{{row.overtimeHours}}</td>
              <td ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageDailyPay'" ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageDailyPay'" class="right"></td>
              <td ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageDailyPay'" class="right"></td>
              <td><salaxy-input-holiday-row-type name="salaryType" label-type="no-label" ng-model="row.salaryType" read-only="true"></salaxy-input-holiday-row-type></td>
              <td ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageHourlyPay'"><salaxy-input-holiday-row-type name="workingTimeType" label-type="no-label" ng-model="row.workingTimeType" read-only="true"></salaxy-input-holiday-row-type></td>
              <td ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageDailyPay'"><salaxy-input-holiday-row-type name="overtimeType" label-type="no-label" ng-model="row.overtimeType" read-only="true"></salaxy-input-holiday-row-type></td>
            </tr>
          </tbody>
          <tfoot>
            <th sxy-text="SALAXY.NG1.HolidayPayReportQueryComponent.total"></th>
            <th></th>
            <th class="right"></th>
            <th class="right"></th>
            <th class="right">{{$ctrl.totals.total | currency}}</th>
            <th ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageHourlyPay'" class="right">{{$ctrl.totals.hours}}</th>
            <th ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageDailyPay'" class="right">{{$ctrl.totals.overtimeHours}}</th>
            <th ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageDailyPay'" class="right">{{$ctrl.totals.workingDays}}</th>
            <th ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageDailyPay'" class="right">{{$ctrl.totals.absenceDays}}</th>
            <th></th>
            <th ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageHourlyPay'"></th>
            <th ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageDailyPay'"></th>
          </tfoot>
        </table>
      </div>
      <div class="tab-pane" id="parameters-tab">
        <div ng-if="$ctrl.currentTab == 'parameters'">
          <div class="row">
            <div class="col-sm-6">
              <form class="form-horizontal">
                <salaxy-form-group  name="salaryTypes" label="SALAXY.NG1.HolidayPayReportQueryComponent.holidayPayRowTypes">
                  <salaxy-input-holiday-row-type ng-repeat="rowType in $ctrl.data.holidayPaySettings.salaryTypes" name="salaryType" label-type="no-label" ng-model="rowType" read-only="true"></salaxy-input-holiday-row-type>
                </salaxy-form-group>
              </form>
            </div>
            <div class="col-sm-6">
              <form class="form-horizontal">
                <salaxy-form-group  ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageHourlyPay'" name="workingTimeTypes" label="SALAXY.NG1.HolidayPayReportQueryComponent.workingHoursRowTypes">
                  <salaxy-input-holiday-row-type ng-repeat="rowType in $ctrl.data.holidayPaySettings.workingTimeTypes" name="workingTimeType" label-type="no-label" ng-model="rowType" read-only="true"></salaxy-input-holiday-row-type>
                </salaxy-form-group>
                <salaxy-form-group  ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageDailyPay'" name="overtimeTypes" label="SALAXY.NG1.HolidayPayReportQueryComponent.overtimeHoursRowTypes">
                  <salaxy-input-holiday-row-type ng-repeat="rowType in $ctrl.data.holidayPaySettings.overtimeTypes" name="overtimeType" label-type="no-label" ng-model="rowType" read-only="true"></salaxy-input-holiday-row-type>
                </salaxy-form-group>
              <salaxy-form-group  ng-if="$ctrl.data.holidayYear.spec.code == 'permanent35Hours' || $ctrl.data.holidayYear.spec.code == 'other'"  name="accrualWorkingTimeTypes" label="SALAXY.NG1.HolidayPayReportQueryComponent.accrualWorkingTimeRowTypes">
                  <salaxy-input-holiday-row-type ng-repeat="rowType in $ctrl.data.holidayAccrualSettings.workingTimeTypes" name="accrualWorkingTimeType" label-type="no-label" ng-model="rowType" read-only="true"></salaxy-input-holiday-row-type>
                </salaxy-form-group>
              </form>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <form class="form-horizontal">
                <salaxy-input-holiday-multipliers ng-if="$ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageHourlyPay' || $ctrl.data.holidayYear.spec.holidayPayCalculation == 'averageDailyPay'" name="multipliers" label="SALAXY.MODEL.HolidayPaySettings.multipliers.title" ng-model="$ctrl.data.holidayPaySettings.multipliers" read-only="true"></salaxy-input-holiday-multipliers>
              </form>
            <div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`), s.put("salaxy-components/report/HolidayReport.html", `<div class="salaxy-component salaxy-holiday-report">
  <salaxy-tab-buttons
    current-tab="$ctrl.currentTab"
    options="[
      { value: 'years', text: 'SALAXY.NG1.HolidayReportComponent.holidayYears' },
      { value: 'debt', text: 'SALAXY.NG1.HolidayReportComponent.holidayPayDebt', hidden: ('hideHolidayDebt' | sxyIsInRole) }
    ]"
    tabs-id="holidayReport">
  </salaxy-tab-buttons>
  <div class="tab-content" id="tab-content-holidayReport">
    <div class="tab-pane" id="years-tab">
      <div class="row">
        <div class="form-horizontal col-sm-3">
          <salaxy-input-enum  name="year"  ng-model="$ctrl.year"   label="SALAXY.NG1.HolidayReportComponent.holidayYear" options="$ctrl.years"></salaxy-input-enum>
        </div>
        <div class="col-sm-3">
          <button type="button" class="btn btn-secondary" ng-click="$ctrl.exportToExcel()">
            <span class="hidden-sm hidden-xs" sxy-text="SALAXY.NG1.HolidayReportComponent.exportToExcel"></span>
            <i class="bi bi-file-earmark-pdf" aria-hidden="true"></i>
          </button>
        </div>
      </div>
      <table class="table table-striped">
        <thead>
          <tr>
            <th colspan="2"><span sxy-text="SALAXY.NG1_Other.Roles.worker"></span></th>
            <th sxy-text="SALAXY.NG1.HolidayReportComponent.table.startDate"></th>
            <th sxy-text="SALAXY.NG1.HolidayReportComponent.table.endDate"></th>
            <th sxy-text="SALAXY.NG1.HolidayReportComponent.table.employment"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.table.salary"></th>
            <th sxy-text="SALAXY.NG1.HolidayReportComponent.table.holidayCode"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.table.periodDefaultAccrual"></th>
            <th sxy-text="SALAXY.NG1.HolidayReportComponent.table.holidayPayCalculation"></th>        
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.startSaldo"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.total"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.paid"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.available"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.holidaySalary"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.holidayCompensation"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.paidBonus"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.availableBonus"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.holidayBonus"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.holidayPayDailySalary"></th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="row in $ctrl.resultRows | filter: { data : { holidayYear : { year: $ctrl.year } } } track by $index">
            <td class="align-middle td-avatar">
              <salaxy-avatar class="clickable" ng-click="$ctrl.showEditEmploymentDialog(row)" avatar="row.holidayYearReportRow.workerAvatar"></salaxy-avatar>
            </td>
            <td>{{row.holidayYearReportRow.workerAvatar.displayName}}</td>
            <td>{{row.holidayYearReportRow.startDate | sxyDate}}</td>
            <td>{{row.holidayYearReportRow.endDate | sxyDate}}</td>
            <td>{{row.holidayYearReportRow.employmentType}}</td>
            <td class="right">{{(row.holidayYearReportRow.grossSalary| currency) || "&nbsp;"}}</td>
            <td>{{row.holidayYearReportRow.holidayCode}}</td>
            <td class="right">{{(row.holidayYearReportRow.periodDefaultAccrual | sxyCount : 'day') || "&nbsp;"}}</td>
            <td>{{row.holidayYearReportRow.holidayPayCalculation}}</td>      
            <td class="right">{{(row.holidayYearReportRow.startSaldo | sxyCount : 'day') || "&nbsp;"}}</td>
            <td class="right">{{(row.holidayYearReportRow.total| sxyCount : 'day') || "&nbsp;"}}</td>
            <td class="right">{{(row.holidayYearReportRow.paid | sxyCount : 'day') || "&nbsp;"}}</td>
            <td class="right">{{(row.holidayYearReportRow.available | sxyCount : 'day') || "&nbsp;"}}</td>
            <td class="right">{{(row.holidayYearReportRow.holidaySalary | currency) || "&nbsp;"}}</td>
            <td class="right">{{(row.holidayYearReportRow.holidayCompensation| currency) || "&nbsp;"}}</td>
            <td class="right">{{(row.holidayYearReportRow.paidBonus | sxyCount : 'day') || "&nbsp;"}}</td>
            <td class="right">{{(row.holidayYearReportRow.availableBonus | sxyCount : 'day') || "&nbsp;"}}</td>
            <td class="right">{{(row.holidayYearReportRow.holidayBonus| currency) || "&nbsp;"}}</td>
            <td class="right"><a ng-href="#/reports/holiday-pay-report-query/{{row.data.holidayYear.year}}/{{row.employment.id}}">{{(row.holidayYearReportRow.holidayPayDailySalary | currency) || "&nbsp;"}}</a></td>      
          </tr>
        </tbody>
      </table>
    </div>
    <div class="tab-pane" id="debt-tab">
      <div class="row">
        <div class="form-horizontal col-sm-3">
          <salaxy-input-enum  name="year"  ng-model="$ctrl.year"   label="SALAXY.NG1.HolidayReportComponent.holidayYear" options="$ctrl.years"></salaxy-input-enum>
        </div>
        <div class="col-sm-3">
          <button type="button" class="btn btn-secondary" ng-click="$ctrl.exportToExcel()">
            <span class="hidden-sm hidden-xs" sxy-text="SALAXY.NG1.HolidayReportComponent.exportToExcel"></span>
            <i class="bi bi-file-earmark-pdf" aria-hidden="true"></i>
          </button>
        </div>
        <div class="form-horizontal  col-sm-3">
          <salaxy-datepicker-popup name="refDate" placeholder=""  ng-model="$ctrl.refDate"
          label="SALAXY.NG1.HolidayReportComponent.holidayPayDebtDate" require="true" ng-change="$ctrl.query(true)"></salaxy-datepicker-popup>
        </div>
        <div class="col-sm-3">
          <button type="button" class="btn btn-primary" ng-click="$ctrl.query(true)" sxy-text="SALAXY.NG1.HolidayReportComponent.calculateHolidayPayDebt"></button>
        </div>
      </div>
      <table class="table table-striped" ng-if="$ctrl.hasQueryedDebt">
        <thead>
          <tr>
            <th colspan="2"><span sxy-text="SALAXY.NG1_Other.Roles.worker"></span></th>
            <th sxy-text="SALAXY.NG1.HolidayReportComponent.table.startDate"></th>
            <th sxy-text="SALAXY.NG1.HolidayReportComponent.table.endDate"></th>
            <th sxy-text="SALAXY.NG1.HolidayReportComponent.table.employment"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.table.salary"></th>
            <th sxy-text="SALAXY.NG1.HolidayReportComponent.table.holidayCode"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.table.periodDefaultAccrual"></th>
            <th sxy-text="SALAXY.NG1.HolidayReportComponent.table.holidayPayCalculation"></th>         
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.startSaldo"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.total"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.paid"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.available"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.holidaySalary"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.holidayCompensation"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.paidBonus"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.availableBonus"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.holidayBonus"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.holidayPayDailySalary"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.totalAccruedHolidayPay"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.totalAccruedHolidayBonus"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.totalAccruedHolidaySocialSecurity"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.totalAccruedHolidayPension"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.totalAccruedHolidayUnemployment"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.totalAccruedHolidayAccidentInsurance"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.totalAccruedHolidayGroupLifeInsurance"></th>
            <th class="right" sxy-text="SALAXY.NG1.HolidayReportComponent.holidayYearReportRow.totalAccruedHolidayTotal"></th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="row in $ctrl.resultRows | filter: { data : { holidayYear : { year: $ctrl.year } } } track by $index">
            <td class="align-middle td-avatar">
              <salaxy-avatar class="clickable" ng-click="$ctrl.showEditEmploymentDialog(row)" avatar="row.holidayYearReportRow.workerAvatar"></salaxy-avatar>
            </td>
            <td>{{row.holidayYearReportRow.workerAvatar.displayName}}</td>
            <td>{{row.holidayYearReportRow.startDate | sxyDate}}</td>
            <td>{{row.holidayYearReportRow.endDate | sxyDate}}</td>
            <td>{{row.holidayYearReportRow.employmentType}}</td>
            <td class="right">{{(row.holidayYearReportRow.grossSalary| currency) || "&nbsp;"}}</td>
            <td>{{row.holidayYearReportRow.holidayCode}}</td>
            <td class="right">{{(row.holidayYearReportRow.periodDefaultAccrual | sxyCount : 'day') || "&nbsp;"}}</td>
            <td>{{row.holidayYearReportRow.holidayPayCalculation}}</td>       
            <td class="right">{{(row.holidayYearReportRow.startSaldo | sxyCount : 'day') || "&nbsp;"}}</td>
            <td class="right">{{(row.holidayYearReportRow.total| sxyCount : 'day') || "&nbsp;"}}</td>
            <td class="right">{{(row.holidayYearReportRow.paid | sxyCount : 'day') || "&nbsp;"}}</td>
            <td class="right">{{(row.holidayYearReportRow.available | sxyCount : 'day') || "&nbsp;"}}</td>
            <td class="right">{{(row.holidayYearReportRow.holidaySalary | currency) || "&nbsp;"}}</td>
            <td class="right">{{(row.holidayYearReportRow.holidayCompensation| currency) || "&nbsp;"}}</td>
            <td class="right">{{(row.holidayYearReportRow.paidBonus | sxyCount : 'day') || "&nbsp;"}}</td>
            <td class="right">{{(row.holidayYearReportRow.availableBonus | sxyCount : 'day') || "&nbsp;"}}</td>
            <td class="right">{{(row.holidayYearReportRow.holidayBonus| currency) || "&nbsp;"}}</td>
            <td class="right"><a ng-href="#/reports/holiday-pay-report-query/{{row.data.holidayYear.year}}/{{row.employment.id}}">{{(row.holidayYearReportRow.holidayPayDailySalary | currency) || "&nbsp;"}}</a></td>
            <td class="right">{{(row.holidayYearReportRow.totalAccruedHolidayPay| currency) || "&nbsp;"}}</td>
            <td class="right">{{(row.holidayYearReportRow.totalAccruedHolidayBonus| currency) || "&nbsp;"}}</td>
            <td class="right">{{(row.holidayYearReportRow.totalAccruedHolidaySocialSecurity | currency) || "&nbsp;"}}</td>
            <td class="right">{{(row.holidayYearReportRow.totalAccruedHolidayPension | currency) || "&nbsp;"}}</td>
            <td class="right">{{(row.holidayYearReportRow.totalAccruedHolidayUnemployment | currency) || "&nbsp;"}}</td>
            <td class="right">{{(row.holidayYearReportRow.totalAccruedHolidayAccidentInsurance| currency) || "&nbsp;"}}</td>
            <td class="right">{{(row.holidayYearReportRow.totalAccruedHolidayGroupLifeInsurance| currency) || "&nbsp;"}}</td>
            <td class="right">{{(row.holidayYearReportRow.totalAccruedHolidayTotal| currency) || "&nbsp;"}}</td>       
          </tr>
        </tbody>
        <tfoot>
          <tr>&nbsp;</tr>
          <tr>
            <th colspan="19">{{ "SALAXY.NG1.HolidayReportComponent.yearAccruedDebt" | sxyTranslate }} {{$ctrl.year}} </th>
            <th class="right">{{($ctrl.holidayCalc[$ctrl.year].totalAccruedHolidayPay| currency) || "&nbsp;"}}</th>
            <th class="right">{{($ctrl.holidayCalc[$ctrl.year].totalAccruedHolidayBonus| currency) || "&nbsp;"}}</th>
            <th class="right">{{($ctrl.holidayCalc[$ctrl.year].totalAccruedHolidaySocialSecurity | currency) || "&nbsp;"}}</th>
            <th class="right">{{($ctrl.holidayCalc[$ctrl.year].totalAccruedHolidayPension | currency) || "&nbsp;"}}</th>
            <th class="right">{{($ctrl.holidayCalc[$ctrl.year].totalAccruedHolidayUnemployment | currency) || "&nbsp;"}}</th>
            <th class="right">{{($ctrl.holidayCalc[$ctrl.year].totalAccruedHolidayAccidentInsurance| currency) || "&nbsp;"}}</th>
            <th class="right">{{($ctrl.holidayCalc[$ctrl.year].totalAccruedHolidayGroupLifeInsurance| currency) || "&nbsp;"}}</th>
            <th class="right">{{($ctrl.holidayCalcTotal[$ctrl.year] | currency) || "&nbsp;"}}</td>       
          </tr>
          <tr>
            <th colspan="19">{{ "SALAXY.NG1.HolidayReportComponent.allAccruedDebt" | sxyTranslate }}</th>
            <th class="right">{{($ctrl.holidayCalc['total'].totalAccruedHolidayPay| currency) || "&nbsp;"}}</th>
            <th class="right">{{($ctrl.holidayCalc['total'].totalAccruedHolidayBonus| currency) || "&nbsp;"}}</th>
            <th class="right">{{($ctrl.holidayCalc['total'].totalAccruedHolidaySocialSecurity | currency) || "&nbsp;"}}</th>
            <th class="right">{{($ctrl.holidayCalc['total'].totalAccruedHolidayPension | currency) || "&nbsp;"}}</th>
            <th class="right">{{($ctrl.holidayCalc['total'].totalAccruedHolidayUnemployment | currency) || "&nbsp;"}}</th>
            <th class="right">{{($ctrl.holidayCalc['total'].totalAccruedHolidayAccidentInsurance| currency) || "&nbsp;"}}</th>
            <th class="right">{{($ctrl.holidayCalc['total'].totalAccruedHolidayGroupLifeInsurance| currency) || "&nbsp;"}}</th>
            <th class="right">{{($ctrl.holidayCalcTotal['total'] | currency) || "&nbsp;"}}</td>       
          </tr>
        </tfoot>
      </table>
    </div>
  </div> 
</div>
`), s.put("salaxy-components/report/IrEarningsPayment.html", `<div class="salaxy-component salaxy salaxy-ir-earnings-payment">
  <salaxy-spinner ng-if="$ctrl.isLoading" full-screen="true" heading="SALAXY.UI_Terms.loading" text="SALAXY.UI_Terms.pleaseWait"></salaxy-spinner>
  <div ng-if="'test' | sxyIsInRole">
    <div ng-if="$ctrl.current.isReadOnly" class="alert alert-info" pre="VAIN TEST: " sxy-text="SALAXY.NG1.EarningsPaymentComponent.common.readOnlyInfo"></div>
    <div class="btn-toolbar" role="toolbar" ng-if="$ctrl.current && $ctrl.isReadOnly && !$ctrl.current.isReadOnly">
      <div class="btn-group" role="group" aria-label="Muokkaa">
        <button ng-click="$ctrl.tempShowEditInNonAdminMode = true" type="button" role="group" class="btn btn-primary">VAIN TEST: Muokkaa</button>
      </div>
    </div>
  </div>
  <div class="btn-toolbar" role="toolbar" ng-if="!$ctrl.isReadOnly">
    <div class="btn-group" role="group" aria-label="Tallenna">
      <button ng-click="$ctrl.saveChanges()" type="button" role="group" class="btn btn-primary" ng-disabled="!($ctrl.hasChanges || ( $ctrl.calcController && $ctrl.calcController.hasChanges)) || $ctrl.isReadOnly" sxy-text="SALAXY.UI_Terms.save"></button>
    </div>
    <div class="btn-group" role="group" aria-label="Lähetä/mitätöi">
      <button ng-click="$ctrl.sendToIncomesRegister()" type="button" role="group" class="btn btn-default" ng-disabled="$ctrl.isReadOnly" sxy-text="SALAXY.UI_Terms.send"></button>
      <button ng-click="$ctrl.openSetScheduleDialog()" type="button" role="group" class="btn btn-default" ng-disabled="$ctrl.isReadOnly" sxy-text="SALAXY.NG1.EarningsPaymentComponent.common.addScheduling"></button>
      <button ng-click="$ctrl.removeIrQueueItem()" type="button" role="group" class="btn btn-danger" ng-disabled="!$ctrl.current.scheduledFor || $ctrl.isReadOnly" sxy-text="SALAXY.NG1.EarningsPaymentComponent.common.removeScheduling"></button>
      <button ng-click="$ctrl.cancelToIncomesRegister()" type="button" role="group" class="btn btn-danger" ng-disabled="!$ctrl.isCancellable || $ctrl.isReadOnly" sxy-text="SALAXY.NG1.EarningsPaymentComponent.common.cancel"></button>
    </div>
  </div>
  <div ng-if="!$ctrl.isLoading && !$ctrl.current">
    <h3>Ei Palkkatietoilmoitusta</h3>
    <p>Palkkatietoilmoitus luodaan vasta, kun laskelma on merkitty maksetuksi.</p>
  </div>
  <div class="form-horizontal form-condensed" ng-if="$ctrl.current">
    <salaxy-tab-buttons
      current-tab="$ctrl.currentTab"
      options="[
        { value: 'default', text: 'SALAXY.NG1.EarningsPaymentComponent.common.basicInfo' },
        { value: 'payer', text: 'SALAXY.MODEL.Payer.title' },
        { value: 'incomeearner', text: 'SALAXY.MODEL.IncomeEarner.title' },
        { value: 'insurances', text: 'SALAXY.NG1.EarningsPaymentComponent.common.insurances' },
        { value: 'absenses', text: 'SALAXY.NG1.EarningsPaymentComponent.common.absences' },
        { value: 'calcrows', text: 'SALAXY.NG1.EarningsPaymentComponent.common.rows' },
        { value: 'history', text: 'SALAXY.NG1.EarningsPaymentComponent.common.history' },
      ]"
      tabs-id="irEarningsPayment">
    </salaxy-tab-buttons>
    <div class="tab-content" id="tab-content-irEarningsPayment"">
      <div class="tab-pane" id="default-tab">
        <div>
          <div class="label label-success float-end" style="font-size: 1.5em" ng-if="$ctrl.current.validation.isValid">{{'SALAXY.NG1.EarningsPaymentComponent.common.noErrors' | sxyTranslate}}</div>
          <!-- TODO: Check texts and add to language versioning. Consider could this be done with SXY-IPT infra. -->
          <h3 ng-switch="$ctrl.current.status">
            <span ng-switch-when="new">{{'SALAXY.NG1.EarningsPaymentComponent.statuses.new.text' | sxyTranslate}} <small sxy-text="SALAXY.NG1.EarningsPaymentComponent.statuses.new.smallText"></small></span>
            <span ng-switch-when="succeeded">{{'SALAXY.NG1.EarningsPaymentComponent.statuses.succeeded.text' | sxyTranslate}} <small>{{ $ctrl.current.lastDeliveredAt | sxyDate }} {{'SALAXY.NG1.EarningsPaymentComponent.common.time' | sxyTranslate}} {{ $ctrl.current.lastDeliveredAt | date : "hh:mm" }}</small></span>
            <span ng-switch-when="canceled">{{'SALAXY.NG1.EarningsPaymentComponent.statuses.canceled.text' | sxyTranslate}} <small sxy-text="SALAXY.NG1.EarningsPaymentComponent.statuses.canceled.smallText"></small> </span>
            <span ng-switch-when="error">{{'SALAXY.NG1.EarningsPaymentComponent.statuses.error.text' | sxyTranslate}} <small>{{'SALAXY.NG1.EarningsPaymentComponent.statuses.error.sending' | sxyTranslate}} {{ $ctrl.current.lastDeliveredAt | sxyDate }} {{'SALAXY.NG1.EarningsPaymentComponent.common.time' | sxyTranslate}} {{ $ctrl.current.lastDeliveredAt | date : "hh:mm" }} {{'SALAXY.NG1.EarningsPaymentComponent.statuses.error.gaveError' | sxyTranslate}}</small></span>
            <span ng-switch-when="invalid">{{'SALAXY.NG1.EarningsPaymentComponent.statuses.invalid.text' | sxyTranslate}} <small sxy-text="SALAXY.NG1.EarningsPaymentComponent.statuses.invalid.smallText"></small></span>
            <span ng-switch-when="scheduled">{{'SALAXY.NG1.EarningsPaymentComponent.statuses.scheduled.text' | sxyTranslate}} <small>{{ $ctrl.current.scheduledFor | sxyDate }} {{'SALAXY.NG1.EarningsPaymentComponent.common.time' | sxyTranslate}} {{ $ctrl.current.scheduledFor | date : "hh:mm" }}</small></span>
            <span ng-switch-default>{{'SALAXY.MODEL.EarningsPayment.status.title' | sxyTranslate}}: {{ "EarningsPaymentReportStatus." + $ctrl.current.status | sxyEnum }}</span>
          </h3>
          <salaxy-validation-summary api-validation="$ctrl.current.validation" ng-if="!$ctrl.current.validation.isValid">
          </salaxy-validation-summary>
          <salaxy-validation-summary api-validation="$ctrl.current.irErrors" ng-if="!$ctrl.current.irErrors.isValid">
          </salaxy-validation-summary>
        </div>
        <sxy-form open-api="salaxy-secure/schemas/irepr.json" read-only="{{ $ctrl.isReadOnly }}" model="$ctrl.current" type="EarningsPayment" debugger="false" auto-gen="false">
          <div>
            <div class="row">
              <div class="col-md-6">
                <fieldset>
                  <legend sxy-text="SALAXY.MODEL.PaymentPeriod.title"></legend>
                  <sxy-input model="form.deliveryData.paymentPeriod.startDate" format="date"></sxy-input>
                  <sxy-input model="form.deliveryData.paymentPeriod.endDate" format="date"></sxy-input>
                  <sxy-input model="form.deliveryData.paymentPeriod.paymentDate" format="date"></sxy-input>
                </fieldset>
              </div>
              <div class="col-md-6">
                <fieldset>
                  <legend sxy-text="SALAXY.NG1.EarningsPaymentComponent.common.worker"></legend>
                  <salaxy-avatar class="float-start" style="margin-right: 20px;font-size: 102px;" avatar="$ctrl.current.info.worker"></salaxy-avatar>
                  <div>{{ $ctrl.current.info.worker.sortableName }}</div>
                  <div>{{ $ctrl.current.deliveryData.reports[0].incomeEarner.incomeEarnerIds[0].code || "Ei henkilötunnusta" }}</div>
                </fieldset>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <fieldset>
                  <legend sxy-text="SALAXY.NG1.EarningsPaymentComponent.common.basicInfo"></legend>
                  <sxy-form open-api="salaxy-secure/schemas/irepr.json" model="$ctrl.current.deliveryData.reports[0].reportData" type="ReportData" debugger="false" auto-gen="false">
                    <div>
                      <sxy-input model="form.reportId" read-only="true"></sxy-input>
                      <!--sxy-input model="form.irReportId" read-only="true"></sxy-input-->
                    </div>
                  </sxy-form>
                  <sxy-input model="form.createdAt"></sxy-input>
                  <sxy-input model="form.updatedAt"></sxy-input>
                  <sxy-input model="form.irStatus" read-only="true"></sxy-input>
                  <sxy-input model="form.isModified" read-only="true"></sxy-input>
                  <sxy-input model="form.scheduledFor" read-only="true"></sxy-input>
                </fieldset>
              </div>
              <div class="col-md-6">
                <fieldset>
                  <legend sxy-text="SALAXY.NG1.EarningsPaymentComponent.deliveryData.title"></legend>
                  <sxy-input model="form.deliveryData.deliveryDataType" read-only="true"></sxy-input>
                  <sxy-input model="form.deliveryData.timestamp" read-only="true"></sxy-input>
                  <sxy-input model="form.deliveryData.deliveryDataCreator.code" label="SALAXY.NG1.EarningsPaymentComponent.deliveryData.deliveryDataCreator" read-only="true">
                  </sxy-input>
                  </sxy-input>
                  <sxy-input model="form.deliveryData.deliveryDataSender.code" label="SALAXY.NG1.EarningsPaymentComponent.deliveryData.deliveryDataSender" read-only="true">
                  </sxy-input>
                </fieldset>
              </div>
            </div>
            <sxy-input model="form.deliveryData.contactPersons" include="name,responsibilityCode"></sxy-input>
            <fieldset>
              <legend sxy-text="SALAXY.NG1.EarningsPaymentComponent.deliveryData.deliveryDataOwner"></legend>
              <sxy-input model="form.deliveryData.deliveryDataOwner.code"></sxy-input>
              <sxy-input model="form.deliveryData.deliveryDataOwner.type"></sxy-input>
              <sxy-input model="form.deliveryData.deliveryDataOwner.countryCode"></sxy-input>
              <sxy-input model="form.deliveryData.deliveryDataOwner.countryName"></sxy-input>
            </fieldset>
          </div>
        </sxy-form>
      </div>
      <div class="tab-pane" id="payer-tab">
        <sxy-form open-api="salaxy-secure/schemas/irepr.json" read-only="{{ $ctrl.isReadOnly }}" model="$ctrl.current.deliveryData.payer" type="Payer" debugger="false" auto-gen="false">
          <div>
            <fieldset>
              <legend sxy-text="SALAXY.NG1.EarningsPaymentComponent.payer.title"></legend>
              <sxy-input model="form.payerBasic.companyName"></sxy-input>
              <sxy-input model="form.payerBasic.missingId" format="checkbox"></sxy-input>
              <sxy-input model="form.payerIds"></sxy-input>
              <sxy-input model="form.payerOther.payerTypes"></sxy-input>
              <sxy-input model="form.subOrgs"></sxy-input>
            </fieldset>
            <fieldset>
              <legend sxy-text="SALAXY.NG1.EarningsPaymentComponent.address.title"></legend>
              <sxy-input model="form.address.co"></sxy-input>
              <sxy-input model="form.address.street"></sxy-input>
              <sxy-input model="form.address.poBox"></sxy-input>
              <sxy-input model="form.address.postalCode"></sxy-input>
              <sxy-input model="form.address.postOffice"></sxy-input>
              <sxy-input model="form.address.countryCode"></sxy-input>
              <sxy-input model="form.address.countryName"></sxy-input>
            </fieldset>
            <fieldset>
              <legend sxy-text="SALAXY.MODEL.SubstitutePayer.title"></legend>
              <sxy-input model="form.substitutePayer.acts"></sxy-input>
              <sxy-input model="form.substitutePayer.employerName"></sxy-input>
              <sxy-input model="form.substitutePayer.employerId.type" label="SALAXY.NG1.EarningsPaymentComponent.substitutePayer.employerIdType.title"></sxy-input>
              <sxy-input model="form.substitutePayer.employerId.code" label="SALAXY.NG1.EarningsPaymentComponent.substitutePayer.employerIdCode.title"></sxy-input>
              <sxy-input model="form.substitutePayer.employerId.countryCode" label="SALAXY.NG1.EarningsPaymentComponent.substitutePayer.employerIdCountryCode.title"></sxy-input>
              <sxy-input model="form.substitutePayer.employerId.countryName" label="SALAXY.NG1.EarningsPaymentComponent.substitutePayer.employerIdCountryName.title"></sxy-input>
              <sxy-input model="form.substitutePayer.wageSec"></sxy-input>
            </fieldset>
          </div>
        </sxy-form>
      </div>
      <div class="tab-pane" id="incomeearner-tab">
        <sxy-form open-api="salaxy-secure/schemas/irepr.json" read-only="{{ $ctrl.isReadOnly }}" model="$ctrl.current.deliveryData.reports[0].incomeEarner" type="IncomeEarner" debugger="false" auto-gen="false">
          <div>
            <fieldset>
              <sxy-input model="form.incomeEarnerIds" include="code,type,countryCode"></sxy-input>
              <sxy-input model="form.incomeEarnerBasic.missingId" format="checkbox"></sxy-input>
              <sxy-input model="form.incomeEarnerBasic.companyName"></sxy-input>
              <sxy-input model="form.incomeEarnerBasic.firstName"></sxy-input>
              <sxy-input model="form.incomeEarnerBasic.lastName"></sxy-input>
              <sxy-input model="form.incomeEarnerBasic.birthDate" format="date"></sxy-input>
              <sxy-input model="form.incomeEarnerBasic.gender"></sxy-input>
              <sxy-input model="form.addresses" include="street,postalCode,postOffice,countryCode"></sxy-input>
              <salaxy-custom-code>
                <sxy-input model="form.professions" template-url="epr-professions.html"></sxy-input>
              </salaxy-custom-code>
              <sxy-input model="form.employmentRegs"></sxy-input>
              <sxy-input ng-if="$ctrl.current.deliveryData.reports[0].incomeEarner.incomeEarnerOther != null && $ctrl.current.deliveryData.reports[0].incomeEarner.incomeEarnerOther.incomeEarnerTypes != null" model="form.incomeEarnerOther.incomeEarnerTypes"></sxy-input>
            </fieldset>
            <fieldset>
              <legend sxy-text="SALAXY.MODEL.Employment.title"></legend>
              <sxy-input model="form.employment.employed"></sxy-input>
              <sxy-input model="form.employment.employmentCode"></sxy-input>
              <sxy-input model="form.employment.termCode"></sxy-input>
              <sxy-input model="form.employment.partTime"></sxy-input>
              <sxy-input model="form.employment.hoursPerWeek"></sxy-input>
              <sxy-input model="form.employment.paymentTypes"></sxy-input>
              <sxy-input model="form.employment.employmentPeriods" include="startDate,endDate">
                <form>
                  <fieldset>
                    <legend sxy-text="SALAXY.MODEL_IR.Period.title"></legend>
                    
                    <sxy-input model="form.startDate" format="date"></sxy-input>
                    <sxy-input model="form.endDate" format="date"></sxy-input>
                  </fieldset>
                </form>
              </sxy-input>
              <sxy-input model="form.employment.employmentEndings"></sxy-input>
            </fieldset>
          </div>
        </sxy-form>
      </div>
      <div class="tab-pane" id="insurances-tab">
        <sxy-form open-api="salaxy-secure/schemas/irepr.json" read-only="{{ $ctrl.isReadOnly }}" model="$ctrl.current.deliveryData.reports[0].incomeEarner" type="IncomeEarner" debugger="false" auto-gen="false">
          <div>
            <fieldset>
              <legend sxy-text="SALAXY.MODEL.PensionInsurance.title"></legend>
              <sxy-input model="form.pensionInsurance.pensionActCode"></sxy-input>
              <sxy-input model="form.pensionInsurance.pensionProvIdCode"></sxy-input>
              <sxy-input model="form.pensionInsurance.pensionPolicyNo"></sxy-input>
              <sxy-input ng-if="$ctrl.current.deliveryData.reports[0].incomeEarner.incomeEarnerOther != null && $ctrl.current.deliveryData.reports[0].incomeEarner.incomeEarnerOther.payments != null" model="form.incomeEarnerOther.payments" include="paymentRef,paymentSpecifier"></sxy-input>
            </fieldset>
            <fieldset>
              <legend sxy-text="SALAXY.MODEL.AccidentInsurance.title"></legend>
              <sxy-input model="form.accidentInsurance.accInsPolicyNo"></sxy-input>
              <sxy-input model="form.accidentInsurance.accInsProvId.type"></sxy-input>
              <sxy-input model="form.accidentInsurance.accInsProvId.code"></sxy-input>
              <sxy-input model="form.accidentInsurance.accInsProvId.countryCode"></sxy-input>
              <sxy-input model="form.accidentInsurance.accInsProvId.countryName"></sxy-input>
            </fieldset>
          </div>
        </sxy-form>
      </div>
      <div class="tab-pane" id="absenses-tab">
        <salaxy-custom-code>
          <div class="text-end">
            <button type="button" class="btn btn-xs btn-primary" ng-if="!$ctrl.isReadOnly" ng-click="$ctrl.importAbsences()" sxy-text="SALAXY.NG1.EarningsPaymentComponent.common.selectAbsences"></button>
          </div>
        </salaxy-custom-code>
        <sxy-form open-api="salaxy-secure/schemas/irepr.json" read-only="{{ $ctrl.isReadOnly }}" model="$ctrl.current.deliveryData.reports[0].absence" type="Absence" debugger="false" auto-gen="false">
          <div>
            <sxy-input model="form.absenceRepStartDate" format="date"></sxy-input>
            <sxy-input model="form.absenceRepEndDate" format="date"></sxy-input>
            <sxy-input model="form.unpaidAbsence.unpaidAbsencePeriods" include="startDate,endDate,causeCode">
              <form>
                <fieldset>
                  <legend sxy-text="SALAXY.MODEL.UnpaidAbsencePeriod.title"></legend>
                  <sxy-input model="form.startDate" format="date"></sxy-input>
                  <sxy-input model="form.endDate" format="date"></sxy-input>
                  <sxy-input model="form.causeCode"></sxy-input>
                  <sxy-input model="form.absenceDays"></sxy-input>
                </fieldset>
              </form>
            </sxy-input>
            <sxy-input model="form.paidAbsence.paidAbsencePeriods" include="startDate,endDate,causeCode">
              <form>
                <fieldset>
                  <legend sxy-text="SALAXY.MODEL.PaidAbsencePeriod.title"></legend>
                  <sxy-input model="form.startDate" format="date"></sxy-input>
                  <sxy-input model="form.endDate" format="date"></sxy-input>
                  <sxy-input model="form.causeCode"></sxy-input>
                  <sxy-input model="form.absenceDays"></sxy-input>
                  <sxy-input model="form.absenceUntil" format="date"></sxy-input>
                  <sxy-input model="form.amount"></sxy-input>
                  <sxy-input model="form.paidAbsencePeriodInfo"></sxy-input>
                  <sxy-input model="form.reimbApp"></sxy-input>
                </fieldset>
              </form>
            </sxy-input>
          </div>
        </sxy-form>
      </div>
      <div class="tab-pane" id="calcrows-tab">
        <div ng-if="$ctrl.current.deliveryData.reports.length == 1">

          <fieldset>
            <legend sxy-text="SALAXY.NG1.EarningsPaymentComponent.common.calcRows"></legend>
            <salaxy-calc-ir-rows model="$ctrl.calculation" is-read-only-forced="true" ng-ref="$ctrl.calcController"></salaxy-calc-ir-rows>
          </fieldset>
          <hr/>

          <fieldset>
            <legend sxy-text="SALAXY.NG1.EarningsPaymentComponent.common.allRows"></legend>
            <sxy-form open-api="salaxy-secure/schemas/irepr.json" read-only="{{ $ctrl.isReadOnly }}" model="$ctrl.current.deliveryData.reports[0]" type="Report" debugger="false" auto-gen="false">
              <div>
                <fieldset>
                  <sxy-input model="form.transactions" read-only="true" template-url="epr-transactions.html"></sxy-input>
                </fieldset>
              </div>
            </sxy-form>
          </fieldset>
        </div>
      </div>
      <div class="tab-pane" id="history-tab">
        <sxy-form open-api="salaxy-secure/schemas/irepr.json" read-only="{{ $ctrl.isReadOnly }}" model="$ctrl.current" type="EarningsPayment" debugger="false" auto-gen="false">
          <div>
            <fieldset>
              <sxy-input model="form.reportLog" read-only="true" include="irTimestamp,eventType,reportId,irReportId,irVersion">
              </sxy-input>
            </fieldset>
          </div>
        </sxy-form>
      </div>
    </div>
  </div>
</div>
<script type="text/ng-template" id="epr-professions.html">
  <table class="table">
    <caption sxy-text="SALAXY.NG1.EarningsPaymentComponent.professions.caption"></caption>
    <thead>
      <tr>
        <th sxy-text="SALAXY.NG1.EarningsPaymentComponent.professions.type"></th>
        <th sxy-text="SALAXY.NG1.EarningsPaymentComponent.professions.code"></th>
        <th sxy-text="SALAXY.NG1.EarningsPaymentComponent.professions.title"></th>
        <th class="text-end">
          <button type="button" class="btn btn-xs btn-primary" ng-if="!$ctrl.getReadOnly()" ng-click="$ctrl.value.push({})" sxy-text="SALAXY.UI_Terms.addRow"></button>
        </th>
      </tr>
    </thead>
    <tbody class="form-horizontal">
      <tr ng-repeat="item in $ctrl.value">
        <td>
          <salaxy-input-enum name="professionType" label-type="plain" type="select" read-only="$ctrl.getReadOnly()" enum="SALAXY.ENUM_IR.ProfessionType" require="true" ng-model="item.type"></salaxy-input-enum>
        </td>
        <td>
          <div ng-if="$ctrl.getReadOnly() && item.type == 'statisticsFinland'">
            <salaxy-input-occupation-type style="display: inline-block" require="true" name="statCode" ng-model="item.code" label-type="plain" read-only="$ctrl.getReadOnly()"></salaxy-input-occupation-type>
            <span style="display: inline-block" ng-if="$ctrl.getReadOnly()">{{item.code}}</span>
          </div>
          <salaxy-input-occupation-type ng-if="!$ctrl.getReadOnly() && item.type == 'statisticsFinland'" require="true" name="statCode" ng-model="item.code" label-type="plain" read-only="$ctrl.getReadOnly()"></salaxy-input-occupation-type>
          <salaxy-input ng-if="item.type != 'statisticsFinland'" require="true" name="code" ng-model="item.code" label-type="plain" read-only="$ctrl.getReadOnly()"></salaxy-input>
        </td>
        <td>
          <salaxy-input name="title" ng-model="item.title" label-type="plain" read-only="$ctrl.getReadOnly()"></salaxy-input>
        </td>
        <td class="text-end">
          <button type="button" class="btn btn-xs btn-danger" ng-if="!$ctrl.getReadOnly()" ng-click="$ctrl.delete(item, $index)">
            <i class="bi bi-trash" title="Delete row"></i>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
<\/script>
<script type="text/ng-template" id="epr-transactions.html">
  <table class="table">
    <thead>
      <tr>
        <th sxy-text="SALAXY.NG1.EarningsPaymentComponent.transactions.code"></th>
        <th class="text-end" sxy-text="SALAXY.NG1.EarningsPaymentComponent.transactions.count"></th>
        <!--th class="text-end">Ansaintakauden<br> alku ja loppu</th -->
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="item in $ctrl.value">
        <td>
          <salaxy-input-income-type name="code" label-type="plain" ng-model="item.transactionBasic.transactionCode" read-only="true"></salaxy-input-income-type>
        </td>
        <td class="text-end">
          <salaxy-input-number name="amount" label-type="plain" ng-model="item.transactionBasic.amount" read-only="true">
        </td>
        <!--td class="text-end">
          <span ng-repeat="earningPeriod in item.earningPeriods">
            {{earningPeriod.startDate | sxyDate}} - {{earningPeriod.endDate | sxyDate}}
          </span>


        </td-->
      </tr>
    </tbody>
  </table>
<\/script>`), s.put("salaxy-components/report/IrEarningsPaymentList.html", `<div class="salaxy-component salaxy-ir-earnings-payment-list">
  <salaxy-odata-table crud-controller="IrEarningsPaymentCrudController as $crud" template-url="salaxy-components/odata/lists/IrEpr.html" options="$ctrl.queryOptions">
  </salaxy-odata-table>
</div>`), s.put("salaxy-components/report/IrPayerSummary.html", `<div class="salaxy-component salaxy salaxy-ir-payer-summary">
  <salaxy-spinner ng-if="$ctrl.isLoading" full-screen="true" heading="SALAXY.UI_Terms.loading" text="SALAXY.UI_Terms.pleaseWait"></salaxy-spinner>
  <div ng-if="'test' | sxyIsInRole">
    <div class="btn-toolbar" role="toolbar" ng-if="$ctrl.isReadOnly">
      <div class="btn-group" role="group" aria-label="Muokkaa">
        <button ng-click="$ctrl.tempShowEditInNonAdminMode = true" type="button" role="group" class="btn btn-primary">VAIN TEST: Muokkaa</button>
      </div>
    </div>
  </div>
  <div class="btn-toolbar" role="toolbar" ng-if="!$ctrl.isReadOnly">
    <div class="btn-group" role="group" aria-label="Tallenna">
      <button ng-click="$ctrl.save()" type="button" role="group" class="btn btn-primary" ng-disabled="!$ctrl.hasChanges" sxy-text="SALAXY.UI_Terms.save"></button>
    </div>
    <div class="btn-group" role="group" aria-label="Lähetä/mitätöi">
      <button ng-click="$ctrl.sendToIncomesRegister()" type="button" role="group" class="btn btn-default" sxy-text="SALAXY.UI_Terms.send"></button>
      <button ng-click="$ctrl.openSetScheduleDialog()" type="button" role="group" class="btn btn-default" sxy-text="SALAXY.NG1.PayerSummaryComponent.common.addScheduling"></button>
      <button ng-click="$ctrl.removeIrQueueItem()" type="button" role="group" class="btn btn-danger" ng-disabled="!$ctrl.current.scheduledFor" sxy-text="SALAXY.NG1.PayerSummaryComponent.common.removeScheduling"></button>
      <button ng-click="$ctrl.cancelToIncomesRegister()" type="button" role="group" class="btn btn-danger" ng-disabled="!$ctrl.isCancellable" sxy-text="SALAXY.NG1.PayerSummaryComponent.common.cancel"></button>
    </div>
  </div>
  <div class="form-horizontal">
    <salaxy-tab-buttons
      current-tab="$ctrl.currentTab"
      options="[
        { value: 'default', text: 'SALAXY.NG1.PayerSummaryComponent.common.basicInfo' },
        { value: 'payer', text: 'SALAXY.NG1.PayerSummaryComponent.common.payer' },
        { value: 'paymentmonth', text: 'SALAXY.NG1.PayerSummaryComponent.common.payerInfo' },
        { value: 'history', text: 'SALAXY.NG1.PayerSummaryComponent.common.historyTitle' },
        { value: 'calculations', text: 'SALAXY.NG1.PayerSummaryComponent.common.calculationsTitle', hidden: !$ctrl.current.info.calculationIds.length }
      ]"
      tabs-id="irPayerSummary">
    </salaxy-tab-buttons>
    <div class="tab-content" id="tab-content-irPayerSummary">
      <div class="tab-pane" id="default-tab">
        <div>
          <h3>
            {{'SALAXY.MODEL.PayerSummary.status.title' | sxyTranslate}}: {{ "SALAXY.ENUM_IR.PayerSummaryReportStatus." + $ctrl.current.status + ".label" | sxyTranslate }}
            <div class="label label-success float-end" ng-if="$ctrl.current.validation.isValid">{{SALAXY.NG1.PayerSummaryComponent.common.noErrors | sxyTranslate}}</div>
          </h3>
          <salaxy-validation-summary api-validation="$ctrl.current.validation" ng-if="!$ctrl.current.validation.isValid">
          </salaxy-validation-summary>
          <salaxy-validation-summary api-validation="$ctrl.current.irErrors" ng-if="!$ctrl.current.irErrors.isValid">
          </salaxy-validation-summary>
        </div>
        <sxy-form open-api="salaxy-secure/schemas/irpsr.json" model="$ctrl.current" type="PayerSummary" debugger="false" auto-gen="false" read-only="{{ $ctrl.isReadOnly }}">
          <div>
            <div class="row">
              <div class="col-md-6">
                <fieldset>
                  <legend sxy-text="SALAXY.NG1.PayerSummaryComponent.common.basicInfo"></legend>
                  <sxy-form open-api="salaxy-secure/schemas/irpsr.json" model="$ctrl.current.deliveryData.reports[0].reportData" type="ReportData" debugger="false" auto-gen="false" read-only="{{ $ctrl.isReadOnly }}">
                    <div>
                      <sxy-input model="form.reportId" read-only="true"></sxy-input>
                      <!--sxy-input model="form.irReportId" read-only="true"></sxy-input-->
                    </div>
                  </sxy-form>
                  <sxy-input model="form.createdAt"></sxy-input>
                  <sxy-input model="form.updatedAt"></sxy-input>
                  <sxy-input model="form.irStatus" read-only="true"></sxy-input>
                  <sxy-input model="form.isModified" read-only="true"></sxy-input>
                  <sxy-input model="form.scheduledFor" read-only="true"></sxy-input>
                </fieldset>
              </div>
              <div class="col-md-6">
                <fieldset>
                  <legend sxy-text="SALAXY.NG1.PayerSummaryComponent.common.deliveryDataTitle"></legend>
                  <sxy-input model="form.deliveryData.deliveryDataType" read-only="true"></sxy-input>
                  <sxy-input model="form.deliveryData.timestamp" read-only="true"></sxy-input>
                  <sxy-input model="form.deliveryData.reportDate" format="date" read-only="true"></sxy-input>
                  <sxy-input model="form.deliveryData.deliveryDataCreator.code" label="SALAXY.NG1.PayerSummaryComponent.common.deliveryDataCreator" read-only="true"></sxy-input>
                  <sxy-input model="form.deliveryData.deliveryDataSender.code" label="SALAXY.NG1.PayerSummaryComponent.common.deliveryDataSender" read-only="true"></sxy-input>
                </fieldset>
              </div>
            </div>
            <sxy-input model="form.deliveryData.contactPersons" include="name,responsibilityCode"></sxy-input>
            <fieldset>
              <legend sxy-text="SALAXY.NG1.PayerSummaryComponent.common.deliveryDataOwner"></legend>
              <sxy-input model="form.deliveryData.deliveryDataOwner.code"></sxy-input>
              <sxy-input model="form.deliveryData.deliveryDataOwner.type"></sxy-input>
              <sxy-input model="form.deliveryData.deliveryDataOwner.countryCode"></sxy-input>
              <sxy-input model="form.deliveryData.deliveryDataOwner.countryName"></sxy-input>
            </fieldset>
          </div>
        </sxy-form>
      </div>
      <div class="tab-pane" id="payer-tab">
        <sxy-form open-api="salaxy-secure/schemas/irpsr.json" model="$ctrl.current.deliveryData.payer" type="Payer" debugger="false" auto-gen="false" read-only="{{ $ctrl.isReadOnly }}">
          <div>
            <fieldset>
              <legend sxy-text="SALAXY.NG1.PayerSummaryComponent.common.payerTitle"></legend>
              <sxy-input model="form.payerBasic.companyName"></sxy-input>
              <sxy-input model="form.payerBasic.missingId"></sxy-input>
              <sxy-input model="form.payerIds"></sxy-input>
              <sxy-input model="form.payerOther.payerTypes"></sxy-input>
              <sxy-input model="form.subOrgs"></sxy-input>
              <sxy-input model="form.pensionInsurances"></sxy-input>
              <sxy-input model="form.accidentInsurances" include="accInsPolicyNo">
                <form>
                  <fieldset>
                    <legend sxy-text="SALAXY.MODEL.AccidentInsurance.title"></legend>
                    <sxy-input model="form.accInsPolicyNo"></sxy-input>
                    <sxy-input model="form.accInsProvId.code"></sxy-input>
                    <sxy-input model="form.accInsProvId.type"></sxy-input>
                    <sxy-input model="form.accInsProvId.countryCode"></sxy-input>
                    <sxy-input model="form.accInsProvId.countryName"></sxy-input>
                  </fieldset>
                </form>
              </sxy-input>
            </fieldset>
            <fieldset>
              <legend sxy-text="SALAXY.NG1.PayerSummaryComponent.common.payerAddressTitle"></legend>
              <sxy-input model="form.address.co"></sxy-input>
              <sxy-input model="form.address.street"></sxy-input>
              <sxy-input model="form.address.poBox"></sxy-input>
              <sxy-input model="form.address.postalCode"></sxy-input>
              <sxy-input model="form.address.postOffice"></sxy-input>
              <sxy-input model="form.address.countryCode"></sxy-input>
              <sxy-input model="form.address.countryName"></sxy-input>
            </fieldset>
          </div>
        </sxy-form>
      </div>
      <div class="tab-pane" id="paymentmonth-tab">
        <sxy-form open-api="salaxy-secure/schemas/irpsr.json" model="$ctrl.current.deliveryData.reports[0]" type="Report" debugger="false" auto-gen="false" read-only="{{ $ctrl.isReadOnly }}">
          <div>
            <fieldset>
              <sxy-input model="form.paymentMonth.year" read-only="true"></sxy-input>
              <sxy-input model="form.paymentMonth.month" read-only="true"></sxy-input>
            </fieldset>
            <fieldset>
              <salaxy-custom-code>
                <sxy-input model="form.transactions" template-url="psr-transactions.html"></sxy-input>
              </salaxy-custom-code>
            </fieldset>
          </div>
        </sxy-form>
      </div>
      <div class="tab-pane" id="history-tab">
        <sxy-form open-api="salaxy-secure/schemas/irpsr.json" model="$ctrl.current" type="PayerSummary" debugger="false" auto-gen="false" read-only="{{ $ctrl.isReadOnly }}">
          <div>
            <fieldset>
              <sxy-input model="form.reportLog" read-only="true" include="irTimestamp,eventType,reportId,irReportId,irVersion"></sxy-input>
            </fieldset>
          </div>
        </sxy-form>
      </div>
      <div class="tab-pane" id="calculations-tab">
        <sxy-form ng-if="$ctrl.calculationsOpened || $ctrl.currentTab == 'calculations'" ng-init="$ctrl.calculationsOpened=true" open-api="salaxy-secure/schemas/irpsr.json" model="$ctrl.current" type="PayerSummary" debugger="false" auto-gen="false" read-only="{{ $ctrl.isReadOnly }}">
          <div>
            <fieldset>
              <salaxy-custom-code>
                <sxy-input model="form.info.calculationIds" template-url="psr-calculations.html"></sxy-input>
              </salaxy-custom-code>
            </fieldset>
          </div>
        </sxy-form>
      </div>
  </div>
</div>
<script type="text/ng-template" id="psr-transactions.html">
  <table class="table">
    <caption sxy-text="SALAXY.NG1.PayerSummaryComponent.transactions.incomeTypes"></caption>
    <thead>
      <tr>
        <th sxy-text="SALAXY.NG1.PayerSummaryComponent.transactions.incomeType"></th>
        <th sxy-text="SALAXY.NG1.PayerSummaryComponent.transactions.count"></th>
        <th class="text-end">
          <button type="button" class="btn btn-xs btn-primary" ng-if="!$ctrl.getReadOnly()" ng-click="$ctrl.value.push({})" sxy-text="SALAXY.UI_Terms.addRow"></button>
        </th>
      </tr>
    </thead>
    <tbody class="form-horizontal">
      <tr ng-repeat="item in $ctrl.value">
        <td>
          <salaxy-input-enum name="transactionCode" label-type="plain" type="select" read-only="$ctrl.getReadOnly()" enum="SALAXY.ENUM_IR.SummaryTransactionCode" require="true" ng-model="item.transactionBasic.summaryTransactionCode"></salaxy-input-enum>
        </td>
        <td>
          <salaxy-input-number ng-if="item.transactionBasic.summaryTransactionCode != 'noWagesPayable'" require="true" name="transactionAmount" label-type="plain" read-only="$ctrl.getReadOnly()" ng-model="item.transactionBasic.amount"></salaxy-input-number>
          <div ng-if="item.transactionBasic.summaryTransactionCode == 'noWagesPayable'" class="form-control-plaintext" ng-init="item.transactionBasic.amount = null">-</div>
        </td>
        <td class="text-end">
          <button type="button" class="btn btn-xs btn-danger" ng-if="!$ctrl.getReadOnly()" ng-click="$ctrl.delete(item, $index)">
            <i class="bi bi-trash" title="Delete row"></i>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
<\/script>
<script type="text/ng-template" id="psr-calculations.html">
    <div class="table-responsive">
      <table class="table table-striped">
        <thead>
          <tr>
            <th colspan="2">
              <span sxy-text="SALAXY.NG1_Other.Roles.worker"></span>
            </th>
            <th>
              <span><span sxy-text="SALAXY.NG1.CalcListComponent.status.title"></span></span><br />
              <span><span sxy-text="SALAXY.NG1.CalcListComponent.payment"></span></span>
            </th>
            <th class="right">
              <span><span sxy-text="SALAXY.NG1.CalcListComponent.salary"></span></span><br />
              <span><span sxy-text="SALAXY.NG1.CalcListComponent.payment"></span></span>
            </th>
            <th class="right" colspan="2">
            </th>
          </tr>
        </thead>
        <tbody ng-controller="CalculationCrudController as $crud">
          <tr ng-repeat="id in $ctrl.value" ng-controller="ODataQueryController as $odata" ng-init="$odata.url='/v03/api/calculations/category/all?$filter=id eq \\'' + id + '\\'';$odata.reload()">
            <td ng-if="!$odata.items[0]" colspan="6"><span><i class="bi bi-arrow-repeat bi-spin"></i></span></td>
            <td ng-if="$odata.items[0]" class="td-avatar middle">
              <salaxy-avatar avatar="$odata.items[0].otherPartyInfo.avatar"></salaxy-avatar>
            </td>
            <td ng-if="$odata.items[0]"class="td-name middle">
              <span ng-if="$odata.items[0].otherPartyInfo.avatar.displayName == ''" sxy-text="SALAXY.NG1.CalcListComponent.notSelected"></span>
              <strong>{{$odata.items[0].otherPartyInfo.avatar.displayName}}</strong><br />
            </td>
            <td ng-if="$odata.items[0]" class="middle">
              {{ "SALAXY.ENUM.CalculationStatus." + $odata.items[0].status + ".label" | sxyTranslate }}<br /> {{ $odata.items[0].endAt | date }}
            </td>
            <td ng-if="$odata.items[0]" class="right middle">
              {{ $odata.items[0].grossSalary | currency }}<br /> {{ $odata.items[0].payment | currency }}
            </td>
            <td ng-if="$odata.items[0]" class="middle">
              <a href="" ng-click="$crud.showDetails($odata.items[0])" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate}}" class="btn btn-sm btn-default btn-block"><span sxy-text="SALAXY.UI_Terms.show"></span>
                </a>
            </td>    
            <td ng-if="$odata.items[0]" class="middle">
              <a ng-href="{{$crud.getPdfUrl($odata.items[0])}}" target="_blank" title="{{ 'SALAXY.UI_Terms.printable' | sxyTranslate}}" class="btn btn-sm btn-default btn-block"><span sxy-text="SALAXY.UI_Terms.printable"></span></a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
<\/script>
`), s.put("salaxy-components/report/IrPayerSummaryList.html", `<div class="salaxy-component salaxy-ir-payer-summary-list">
  <salaxy-odata-table crud-controller="IrPayerSummaryCrudController as $crud" template-url="salaxy-components/odata/lists/IrPsr.html" options="$ctrl.queryOptions">
  </salaxy-odata-table>
</div>`), s.put("salaxy-components/report/modals/AccountNumbers.html", `<div class="modal-header">
  <h2 class="modal-title" sxy-text="SALAXY.NG1.AccountNumbersComponent.title"></h2>
  <button type="button" class="ms-auto btn-close" ng-click="$close(null)" aria-label="Close"></button>
</div>
<div class="modal-body" id="modal-body">
  <div class="table-responsive" style="max-height: 40vh;">
    <table class="table table-sm">
      <thead>
        <tr>
          <th sxy-text="SALAXY.NG1.AccountNumbersComponent.accountNumber"></th>
          <th sxy-text="SALAXY.NG1.AccountNumbersComponent.description"></th>
          <th>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="account in $ctrl.data.accounts">
          <td>
            {{account.account}}
          </td>
          <td>
            {{account.text}}
          </td>
          <td class="right">
            <button ng-disabled="account.isSelected" title="Valitse" class="btn btn-success" type="button" ng-click="$close(account)" sxy-text="SALAXY.NG1.AccountNumbersComponent.choose"></button>
          </td>
        </tr>
      </tbody>
      <tfoot>
      </tfoot>
    </table>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-default float-end" ng-click="$close(null)" sxy-text="SALAXY.UI_Terms.close"></button>
</div>`), s.put("salaxy-components/report/modals/CalculationReportPeriodSelection.html", `<form name="periodForm" class="form-horizontal">
  <div class="modal-header">
    <h2 class="modal-title" sxy-text="SALAXY.NG1.CumulativeReportPeriodSelection.title"></h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <salaxy-input-enum name="period" label="SALAXY.NG1.CumulativeReportPeriodSelection.periodLabel" options="{year: ('SALAXY.NG1.CumulativeReportPeriodSelection.enumOptionYear' | sxyTranslate), month: ('SALAXY.NG1.CumulativeReportPeriodSelection.enumOptionMonth' | sxyTranslate), all: ('SALAXY.NG1.CumulativeReportPeriodSelection.enumOptionAll' | sxyTranslate), custom: ('SALAXY.NG1.CumulativeReportPeriodSelection.enumOptionCustom' | sxyTranslate)}"
      ng-model="$ctrl.current.periodType" type="radio" required>
    </salaxy-input-enum>
    <salaxy-input-enum name="periodDateKind" label="SALAXY.NG1.CumulativeReportPeriodSelection.periodDateKindLabel" enum="PeriodDateKind"
      ng-model="$ctrl.current.periodDateKind" type="radio" required>
    </salaxy-input-enum>
    <salaxy-datepicker-popup name="refDateMonth" placeholder="SALAXY.NG1.CumulativeReportPeriodSelection.month" ng-if="$ctrl.current.periodType == 'month'" format="month" ng-model="$ctrl.current.refDate"
      label="SALAXY.NG1.CumulativeReportPeriodSelection.chooseMonthLabel" require="true"></salaxy-datepicker-popup>
    <salaxy-datepicker-popup name="refDateYear" placeholder="SALAXY.NG1.CumulativeReportPeriodSelection.year" ng-if="$ctrl.current.periodType == 'year'" format="year" ng-model="$ctrl.current.refDate"
      label="SALAXY.NG1.CumulativeReportPeriodSelection.chooseYearLabel" require="true"></salaxy-datepicker-popup>
    <salaxy-datepicker-popup name="refDateCustom" ng-if="$ctrl.current.periodType == 'custom'" ng-model="$ctrl.current.refDate" label="SALAXY.NG1.CumulativeReportPeriodSelection.refDateCustomLabel" require="true">
    </salaxy-datepicker-popup>
    <salaxy-datepicker-popup name="endDateCustom" ng-if="$ctrl.current.periodType == 'custom'" ng-model="$ctrl.current.endDate" label="SALAXY.NG1.CumulativeReportPeriodSelection.endDateCustomLabel">
    </salaxy-datepicker-popup>
    <salaxy-form-group name="Workers" label="SALAXY.NG1.CumulativeReportPeriodSelection.workersLabel">
      <span ng-if="$ctrl.current.selectedWorkers.length"> {{'SALAXY.NG1.CumulativeReportPeriodSelection.chosen' | sxyTranslate}}: {{ $ctrl.current.selectedWorkers.length }} </span>
      <span ng-if="!$ctrl.current.selectedWorkers.length"> {{'SALAXY.NG1.CumulativeReportPeriodSelection.all' | sxyTranslate}} </span>
      <button type="button" class="btn btn-xs btn-default" ng-click="$ctrl.logic.showWorkerSelection($ctrl.current)" sxy-text="SALAXY.NG1.CumulativeReportPeriodSelection.more" ps="..."></button>
    </salaxy-form-group>
  </div>
  <div class="modal-footer">
    <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
    <button type="submit" class="btn btn-primary" ng-disabled="!periodForm.$valid" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.save"></button>
  </div>
</form>`), s.put("salaxy-components/report/modals/CalculationReportSaveTemplate.html", `<form name="templateForm" class="form-horizontal">
  <div class="modal-header">
    <h2 class="modal-title" sxy-text="SALAXY.NG1.CumulativeReportSaveTemplate.title"></h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <salaxy-input-boolean disabled="!$ctrl.current.isEditable" name="isNew" label="SALAXY.NG1.CumulativeReportSaveTemplate.isNewLabel" ng-model="$ctrl.current.isNew" type="radio" label-true="SALAXY.NG1.CumulativeReportSaveTemplate.isNewLabelTrue" label-false="SALAXY.NG1.CumulativeReportSaveTemplate.isNewLabelFalse" required>
    </salaxy-input-boolean>
    <salaxy-input name="label" label="SALAXY.NG1.CumulativeReportSaveTemplate.currentLabel" ng-model="$ctrl.current.label" required></salaxy-input>
  </div>
  <div class="modal-footer">
    <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
    <button type="button" ng-if="!$ctrl.current.isNew" class="btn btn-danger" ng-click="$close('delete')" sxy-text="SALAXY.UI_Terms.delete"></button>
    <button type="submit" class="btn btn-primary" ng-disabled="!templateForm.$valid" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.save"></button>
  </div>
</form>`), s.put("salaxy-components/report/modals/FivaldiPreview.html", `<div class="table-responsive">
  <table class="table table-sm table-striped text-small">
    <tbody>
      <tr>
        <th>voucherTypeId</th>
        <td>{{item.preview.voucherTypeId}}</td>
        <td colspan="7"></td>
      </tr>
      <tr>
        <th>originalVoucherNumber</th>
        <td>{{item.preview.originalVoucherNumber}}</td>
        <td colspan="7"></td>
      </tr>
      <tr>
        <th>voucherDate</th>
        <td>{{item.preview.voucherDate}}</td>
        <td colspan="7"></td>
      </tr>
      <tr>
        <th>bookkeepingMonth</th>
        <td>{{item.preview.bookkeepingMonth}}</td>
        <td colspan="7"></td>
      </tr>
      <tr>
        <th>validateEntrySum</th>
        <td>{{item.preview.validateEntrySum}}</td>
        <td colspan="7"></td>
      </tr>
      <tr>
        <th>vatType</th>
        <td>{{item.preview.vatType}}</td>
        <td colspan="7"></td>
      </tr>
      <tr>
        <th>amount</th>
        <th>accountNumber</th>
        <th>balanceCode</th>
        <th>dimensionValue1</th>
        <th>description</th>
        <th>vat.vatCode</th>
        <th>vat.vatAmount</th>
        <th>vat.account</th>
        <th>vat.account2</th>
      </tr>
      <tr ng-repeat="entry in item.preview.voucherEntries">
        <td class="right">{{ entry.amount }}</td>
        <td class="right">{{ entry.accountNumber}}</td>
        <td class="right">{{ entry.balanceCode }}</td>
        <td>{{ entry.dimensionValue1 }}</td>
        <td>{{ entry.description }}</td>      
        <td>{{entry.vat.vatCode}}</td>
        <td class="right">{{entry.vat.vatAmount}}</td>
        <td>{{entry.vat.account}}</td>
        <td>{{entry.vat.account2}}</td>
      </tr>
    </tbody>
  </table>
</div>`), s.put("salaxy-components/report/modals/IncomeTypeCodeEditor.html", `<div class="modal-header">
  <h2 class="modal-title" sxy-text="SALAXY.NG1.IncomeTypeCodeEditorComponent.title"></h2>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
</div>
<div class="modal-body" id="modal-body">
  <div class="row">
    <div class="col-6 form-horizontal">
      <salaxy-input-income-type name="Tulolaji"  ng-model="$ctrl.data.row.transactionBasic.transactionCode" ></salaxy-input-income-type>
      <salaxy-input-number name="Summa" ng-model="$ctrl.data.row.transactionBasic.amount"></salaxy-input-number>

      <salaxy-form-group name="carBenefit" label="SALAXY.NG1.IncomeTypeCodeEditorComponent.carBenefitTypeLabel" label-type="horizontal">
        <select class="form-select" ng-model="$ctrl.data.carBenefit" ng-model-options="{ getterSetter: true }">
          <option value="" sxy-text="SALAXY.NG1.IncomeTypeCodeEditorComponent.noSelection"></option>
          <option value="limitedCarBenefit" sxy-text="SALAXY.NG1.IncomeTypeCodeEditorComponent.carBenefitLimited"></option>
          <option value="fullCarBenefit" sxy-text="SALAXY.NG1.IncomeTypeCodeEditorComponent.carBenefitFull"></option>
        </select>
      </salaxy-form-group>

      <salaxy-input-enum ng-if="$ctrl.data.row.carBenefit" label="SALAXY.NG1.IncomeTypeCodeEditorComponent.carBenefitAgeGroupCodeLabel" name="ageGroupCode" ng-model="$ctrl.data.row.carBenefit.ageGroupCode" options="{ '': ('SALAXY.NG1.IncomeTypeCodeEditorComponent.noSelection' | sxyTranslate), 'a': 'A', 'b': 'B', 'c': 'C', 'u': 'U' }" type="select"></salaxy-input-enum>

      <salaxy-input-number ng-if="$ctrl.data.row.carBenefit" label="SALAXY.NG1.IncomeTypeCodeEditorComponent.carBenefitEmissionsValueLabel" name="emissionsValue" ng-model="$ctrl.data.row.carBenefit.emissionsValue" minimum="0" maximum="100" ></salaxy-input-number>

      <salaxy-form-group name="kilometers" label="SALAXY.NG1.IncomeTypeCodeEditorComponent.carBenefitKilometersLabel" label-type="horizontal">
        <label>
          {{ $ctrl.data.row.carBenefit.kilometers == null ? "-" : $ctrl.data.row.carBenefit.kilometers }}
        </label>
      </salaxy-form-group>

      <salaxy-form-group name="mealBenefit" label="SALAXY.NG1.IncomeTypeCodeEditorComponent.mealBenefitLabel" label-type="horizontal">
        <select class="form-select" ng-model="$ctrl.data.mealBenefit" ng-model-options="{ getterSetter: true }">
          <option value="" sxy-text="SALAXY.NG1.IncomeTypeCodeEditorComponent.noSelection">Ei valintaa</option>
          <option ng-value="true" sxy-text="SALAXY.NG1.IncomeTypeCodeEditorComponent.mealBenefitTrue">Kyllä</option>
          <option ng-value="false" sxy-text="SALAXY.NG1.IncomeTypeCodeEditorComponent.mealBenefitFalse">Ei</option>
        </select>
      </salaxy-form-group>

      <div class="form-group" ng-if="!$ctrl.data.row.dailyAllowance || $ctrl.data.row.dailyAllowance.length != 1">
        <label for="addDailyAllowance" class="col-sm-4 control-label">
              <span sxy-text="SALAXY.NG1.IncomeTypeCodeEditorComponent.dailyAllowanceTypeLabel"></span>
          </label>
        <div class="col-sm-8">
          <button type="button" class="btn btn-block btn-success" ng-click="$ctrl.data.row.dailyAllowance = ['fullDailyAllowance']"><i class="bi bi-plus-lg"></i> {{'SALAXY.NG1.IncomeTypeCodeEditorComponent.add' | sxyTranslate}}</button>
        </div>
      </div>

      <div ng-if="$ctrl.data.row.dailyAllowance && $ctrl.data.row.dailyAllowance.length == 1">
        <salaxy-input-enum label="SALAXY.NG1.IncomeTypeCodeEditorComponent.dailyAllowanceTypeLabel" name="dailyAllowance" ng-model="$ctrl.data.row.dailyAllowance[0]" options="{ '': ('SALAXY.NG1.IncomeTypeCodeEditorComponent.noSelection' | sxyTranslate), 'partialDailyAllowance': ('SALAXY.NG1.IncomeTypeCodeEditorComponent.partialDailyAllowanceEnum' | sxyTranslate), 'fullDailyAllowance': ('SALAXY.NG1.IncomeTypeCodeEditorComponent.fullDailyAllowanceEnum' | sxyTranslate), 'internationalDailyAllowance': ('SALAXY.NG1.IncomeTypeCodeEditorComponent.internationalDailyAllowanceEnum' | sxyTranslate) }"
          type="select"></salaxy-input-enum>
        <div class="row">
          <div class="col-sm-4"></div>
          <div class="col-sm-8">
            <button type="button" class="btn btn-block btn-danger" ng-click="$ctrl.data.row.dailyAllowance = null"><i class="bi bi-trash-fill"></i> {{'SALAXY.UI_Terms.delete' | sxyTranslate}}</button>
          </div>
        </div>
      </div>

    </div>
    <div class="col-6">
      <div style="width: 100%; overflow: auto">
        <pre>{{ $ctrl.data.row | json }}</pre>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
</div>`), s.put("salaxy-components/report/modals/IrImportAbsencesDialog.html", `<div class="card panel-primary">
  <div class="card-header ">
    <h2 sxy-text="SALAXY.NG1.IrImportAbsencesDialogComponent.heading"></h2>
    <button type="button" class="btn-close" ng-click="$dismiss()" aria-label="Close"></button>
  </div>
  <div class="card-body">
    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th>{{ "SALAXY.NG1.IrImportAbsencesDialogComponent.absences" | sxyTranslate }}</th>
            <th class="right" sxy-text="SALAXY.NG1.IrImportAbsencesDialogComponent.wholeAbsence"></th>
            <th class="right" sxy-html="SALAXY.NG1.IrImportAbsencesDialogComponent.isHolidayAccrual.html"></th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="row in $ctrl.current.periods">
            <td>
              <salaxy-avatar class="salaxy-calc-row-type-avatar float-start" avatar="{ color: '#2b507c', initials: (row.period.daysCount + 'pv'), entityType: 'company' }">
              </salaxy-avatar>
              <strong>{{ "AbsenceCauseCode." + row.causeCode | sxyEnum }}</strong><br />
              <div class="float-start" style="padding: 0px;">
                {{ row.isPaid ? ('SALAXY.NG1.IrImportAbsencesDialogComponent.isPaid' | sxyTranslate) : ('SALAXY.NG1.IrImportAbsencesDialogComponent.notPaid' | sxyTranslate) }}
                <span ng-if="row.isPaid != row.isHolidayAccrual"> {{ row.isHolidayAccrual ? ('SALAXY.NG1.IrImportAbsencesDialogComponent.isAccrual' | sxyTranslate) :
                  ('SALAXY.NG1.IrImportAbsencesDialogComponent.notAccrual' | sxyTranslate) }}</span>
              </div>
              <div class="truncate" style="max-width: 250px; padding: 0px;">
                &nbsp;{{ row.notes }}
              </div>
            </td>
            <td class="right">
              <strong>{{ row.period.daysCount | sxyCount : "day" }}</strong><br /> {{ row.period.start | date : 'dd.MM.' }}-{{ row.period.end | date : 'dd.MM.' }}
            </td>
            <td class="right">
              <strong>{{ (row.isPaid ? 0 : row.period.daysCount) | sxyCount : "day" }}</strong><br />
              <strong>{{ (row.isHolidayAccrual ? 0 : row.period.daysCount) | sxyCount : "day" }}</strong><br />
            </td>
            <td class="middle right">
              <button class="btn btn-xs" type="button" ng-class="row.selected ? 'btn-danger' : 'btn-info'" ng-click="row.selected = !row.selected">
                {{ row.selected ? ("SALAXY.UI_Terms.unselect" | sxyTranslate) : ("SALAXY.UI_Terms.select" | sxyTranslate) }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div>
      <button type="submit" class="btn btn-primary float-end" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.save"></button>
      <button type="reset" class="btn btn-default float-end" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
    </div>
  </div>
</div>`), s.put("salaxy-components/report/modals/IrRowsEditorDialog.html", `<div class="modal-calc-list">
  <div class="modal-header">
    <h2 class="modal-title">{{$ctrl.logic.title}}</h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>

  </div>
  <div class="card-body">
    <salaxy-calc-ir-rows model="$ctrl.current"></salaxy-calc-ir-rows>
    <div>
      <button type="submit" class="btn btn-primary float-end" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.save"></button>
      <button type="reset" class="btn btn-default float-end" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
    </div>
  </div>
</div>`), s.put("salaxy-components/report/modals/IrScheduleSendDialog.html", `  <div class="modal-header ">
    <h2 sxy-text="SALAXY.NG1.IrScheduleSendDialogComponent.heading"></h2>
    <button type="button" class="btn-close" ng-click="$dismiss()" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <form class="form-horizontal" name="schedulingDialog">
      <div class="col-12">
        <div class="salaxy-component salaxy-datepicker">
          <salaxy-datepicker ng-model="$ctrl.current.startAt" label="SALAXY.NG1.IrScheduleSendDialogComponent.dateLabel" name="date" timepicker="true"></salaxy-datepicker>
        </div>
      </div>
      <div class="col-12">
        <salaxy-form-group label="SALAXY.NG1.IrScheduleSendDialogComponent.dateTimeLabel" name="dateTime">
          <pre class="alert alert-danger d-inline-block">{{$ctrl.current.startAt | sxyTime }}</pre>
        </salaxy-form-group>
      </div>
      <div>
        <button type="submit" class="btn btn-primary float-end" ng-disabled="schedulingDialog.$invalid" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.send"></button>
        <button type="reset" class="btn btn-default float-end" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
      </div>
    </form>
  </div>
  <div class="modal-footer"></div>`), s.put("salaxy-components/report/modals/PostAccountingData.html", `<div class="modal-header">
  <h2 class="modal-title" sxy-text="SALAXY.UI_Terms.send"></h2>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
</div>
<div class="modal-body" id="modal-body"  style="max-height: calc(100vh - 300px); overflow-y: auto;">
  <div class="table-responsive">
    <table class="table table-sm">
      <thead>
        <tr>
          <th><span sxy-text="SALAXY.NG1.AccountingReportToolsComponent.accountingData"></span></th>
          <th><span sxy-text="SALAXY.NG1.AccountingReportToolsComponent.status"></span></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat-start="item in $ctrl.current">
          <td><a ng-click="item.rowToggle = !item.rowToggle">{{item.accountingData.employer.displayName}}/{{item.accountingData.period.start}}</a></td>
          <td>
            <span ng-if="item.error" class="text-danger">{{item.error}}</span>
            <span ng-if="item.result" class="text-success">{{item.result}}</span>
          </td>
          <td class="right">
            <button  class="btn btn-default" ng-click="$ctrl.logic.postData(item)" ng-disabled="item.isPosting" type="button">
              <span ng-show="!item.isPosting"><i class="bi bi-upload"></i></span>
              <span ng-show="item.isPosting"><i class="bi bi-arrow-repeat bi-spin"></i></span> <span sxy-text="SALAXY.UI_Terms.send"></span>
            </button>
          </td>
        </tr>
        <tr ng-if="item.rowToggle" ng-repeat-end>
          <td colspan="3">
            <ng-include src="$ctrl.logic.previewTemplateUrl" ></ng-include>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-default float-end" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
</div>`), s.put("salaxy-components/report/modals/SummaryReportPeriodSelection.html", `<form name="periodForm" class="form-horizontal">
  <div class="modal-header">
    <h2 class="modal-title" sxy-text="SALAXY.NG1.CumulativeReportPeriodSelection.title"></h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <salaxy-input-enum name="period" label="SALAXY.NG1.CumulativeReportPeriodSelection.periodLabel" options="{year: ('SALAXY.NG1.CumulativeReportPeriodSelection.enumOptionYear' | sxyTranslate), month: ('SALAXY.NG1.CumulativeReportPeriodSelection.enumOptionMonth' | sxyTranslate), all: ('SALAXY.NG1.CumulativeReportPeriodSelection.enumOptionAll' | sxyTranslate), custom: ('SALAXY.NG1.CumulativeReportPeriodSelection.enumOptionCustom' | sxyTranslate)}"
      ng-model="$ctrl.current.periodType" type="radio" required>
    </salaxy-input-enum>
    <salaxy-input-enum name="periodDateKind" label="SALAXY.NG1.CumulativeReportPeriodSelection.periodDateKindLabel" enum="PeriodDateKind"
      ng-model="$ctrl.current.periodDateKind" type="radio" required>
    </salaxy-input-enum>
    <salaxy-datepicker-popup name="refDateMonth" placeholder="SALAXY.NG1.CumulativeReportPeriodSelection.month" ng-if="$ctrl.current.periodType == 'month'" format="month" ng-model="$ctrl.current.refDate"
      label="SALAXY.NG1.CumulativeReportPeriodSelection.chooseMonthLabel" require="true"></salaxy-datepicker-popup>
    <salaxy-datepicker-popup name="refDateYear" placeholder="SALAXY.NG1.CumulativeReportPeriodSelection.year" ng-if="$ctrl.current.periodType == 'year'" format="year" ng-model="$ctrl.current.refDate"
      label="SALAXY.NG1.CumulativeReportPeriodSelection.chooseYearLabel" require="true"></salaxy-datepicker-popup>
    <salaxy-datepicker-popup name="refDateCustom" ng-if="$ctrl.current.periodType == 'custom'" ng-model="$ctrl.current.refDate" label="SALAXY.NG1.CumulativeReportPeriodSelection.refDateCustomLabel" require="true">
    </salaxy-datepicker-popup>
    <salaxy-datepicker-popup name="endDateCustom" ng-if="$ctrl.current.periodType == 'custom'" ng-model="$ctrl.current.endDate" label="SALAXY.NG1.CumulativeReportPeriodSelection.endDateCustomLabel">
    </salaxy-datepicker-popup>
  </div>
  <div class="modal-footer">
    <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
    <button type="submit" class="btn btn-primary" ng-disabled="!periodForm.$valid" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.select"></button>
  </div>
</form>`), s.put("salaxy-components/report/PayCertificate.html", `<div class="salaxy-component salaxy-pay-certificate">
  <div class="d-block d-md-none">
    <h4><span sxy-text="SALAXY.NG1.PayCertificateComponent.step"></span> {{$ctrl.currentStep.number}}/{{$ctrl.steps.length}}</h4>
  </div>
  <div class="salaxy-wizard">
    <div class="wizard-steps">
      <div class="wizard-step" ng-repeat="step in $ctrl.steps" ng-class="{'active': step.active, 'disabled': step.disabled}">
        <span class="salaxy-avatar">
          <div class="wizard-icons-wrapper">
            <i class="bi" ng-class="step.active ? 'bi-circle-fill' : 'bi-circle'"></i>
            <i class="bi bi-circle-fill"></i>
          </div>
          <strong class="number">{{ step.number }}</strong>
        </span>
        <span class="step-text">{{ step.title | sxyTranslate }}</span>
      </div>
    </div>
    <div class="wizard-strikethrough"></div>
  </div>
  <div class="wizard-content" style="height: 600px; overflow-y: auto;">
    <ng-include src="$ctrl.currentStep.view"></ng-include>
  </div>
  <div class="modal-footer">
    <button ng-if="$ctrl.step >= 2" ng-click="$ctrl.goPrevious()" ng-disabled="!$ctrl.canGoPrevious" class="btn btn-default" sxy-text="SALAXY.UI_Terms.previous"></button>
    <button ng-if="($ctrl.step < $ctrl.steps.length)" ng-click="$ctrl.goNext()" ng-disabled="!$ctrl.canGoNext" class="btn btn-primary ms-auto" sxy-text="SALAXY.UI_Terms.next"></button>
  </div>
</div>`), s.put("salaxy-components/report/PayCertificateStep1.html", `<div>
  <salaxy-employment-list mode="select" selected-items="$ctrl.selectedWorkers" on-list-select="$ctrl.selectWorker(item, value)"></salaxy-employment-list>
</div>`), s.put("salaxy-components/report/PayCertificateStep2.html", `<div>
  <div class="btn-toolbar mb-2" role="toolbar">
    <div class="btn-group" role="group">
      <button type="button" class="btn btn-sm btn-primary" ng-click="$ctrl.selectCalculations($odata.items, 26)" sxy-text="SALAXY.NG1.PayCertificateComponent.choose26Weeks"></button>
      <button type="button" class="btn btn-sm btn-primary" ng-click="$ctrl.selectCalculations($odata.items, 34)" sxy-text="SALAXY.NG1.PayCertificateComponent.choose34Weeks"></button>
      <button type="button" class="btn btn-sm btn-default" ng-click="$ctrl.unselectCalculations()" sxy-text="SALAXY.NG1.PayCertificateComponent.clear"></button>
    </div>
  </div>
  <salaxy-odata-table ng-ref="$odata" selected-items="$ctrl.periodCalculations" url="/v03/api/calculations/category/readonly"
    template-url="salaxy-components/odata/lists/CalculationsWithSalaryDate-select.html" crud-controller="CalculationCrudController as $crud"
    options="{$orderby: 'salaryDate desc', $filter: 'otherId eq \\'' + $ctrl.worker.otherId + '\\' and ( status eq \\'paymentSucceeded\\' )' }">
  </salaxy-odata-table>
</div>`), s.put("salaxy-components/report/PayCertificateStep3.html", `
<salaxy-spinner ng-show="!$ctrl.validation" heading="SALAXY.NG1.PayCertificateComponent.creatingPayCertificate"></salaxy-spinner>
<salaxy-validation-summary api-validation="$ctrl.validation" template-url="pay-certificate-validation.html">
  <p class="text-center">
    <b sxy-text="SALAXY.NG1.PayCertificateComponent.payCertificateReadyForDownload"></b>
  </p>
</salaxy-validation-summary>

<p>&nbsp;</p>
<p class="text-center" ng-show="$ctrl.validation && $ctrl.worker && $ctrl.periodCalculations.length > 0">{{'SALAXY.NG1.PayCertificateComponent.open' | sxyTranslate}} <a ng-href="{{$ctrl.getDownloadPdfUrl(true)}}" target="_blank>">{{'SALAXY.NG1.PayCertificateComponent.payCertificate' | sxyTranslate}}</a>. </p>


<button class="btn btn-default float-end" ng-click="$ctrl.startNew()" sxy-text="SALAXY.NG1.PayCertificateComponent.createNewPayCertificate"></button>



<script type="text/ng-template" id="pay-certificate-validation.html">
<div ng-if="!$ctrl.hasValidation" ng-bind-html="$ctrl.loadingHtml"></div>
<div ng-if="$ctrl.hasValidation">
  <ng-transclude ng-if="$ctrl.isValid"></ng-transclude>
  <div ng-if="!$ctrl.isValid" class="alert alert-danger">
      <h4 sxy-text="SALAXY.NG1.PayCertificateComponent.alertHeading" ps=":"></h4>
      <p style="display: block; font-family: monospace; white-space: pre;" ng-repeat="error in $ctrl.getErrors()">{{ error.msg }}</p>
  </div>
</div>
<\/script>`), s.put("salaxy-components/report/ReportList.html", `<div class="salaxy-component salaxy-report-list">
  <div ng-hide="$ctrl.getReports($ctrl.reportType).length > 0">
    <p sxy-text="SALAXY.NG1.ReportListComponent.noReportsToShow" ps="."></p>
  </div>
  <div class="table-responsive" ng-show="$ctrl.getReports($ctrl.reportType).length > 0">
    <table class="table">
      <thead>
        <tr>
          <th style="width: 100px"></th>
          <th sxy-text="SALAXY.NG1.ReportListComponent.report"></th>
          <th sxy-text="SALAXY.NG1.ReportListComponent.links"></th>
          <th sxy-text="SALAXY.NG1.ReportListComponent.reportDate"></th>
          <th sxy-text="SALAXY.NG1.ReportListComponent.updated"></th>
          <th sxy-text="SALAXY.NG1.ReportListComponent.note" ps="."></th>
        </tr>
      </thead>
      <tbody ng-if="$ctrl.reportType !== 'monthlyDetails' && $ctrl.reportType !== 'yearlyDetails' && $ctrl.reportType !== 'monthlyLiikekirjuri'" ng-controller="WorkerSummaryReportDisplayController as $displayCtrl">
        <tr ng-repeat="report in $ctrl.getReports($ctrl.reportType)">
          <td>
            <a ng-if="!report.isPreview" href="{{ report.pdfUrl || report.htmlUrl || report.jsonUrl }}" target="_blank">
              <img ng-src="{{ report.thumbnail }}" class="img-responsive img-thumbnail" />
            </a>
            <a ng-if="report.isPreview" ng-click="$displayCtrl.display(report.reportDate, $displayCtrl.parseWorkerID(report.htmlUrl), null)">
              <img ng-src="{{ report.thumbnail }}" class="img-responsive img-thumbnail" />
            </a>
          </td>
          <td>
            <a ng-if="!report.isPreview" href="{{ report.pdfUrl || report.htmlUrl || report.jsonUrl }}" target="_blank">{{ report.title }}</a>
            <a ng-if="report.isPreview" ng-click="$displayCtrl.display(report.reportDate, $displayCtrl.parseWorkerID(report.htmlUrl), null)">{{ report.title }} </a>
          </td>
          <td>
            <a ng-if="!report.isPreview && report.pdfUrl" href="{{ report.pdfUrl }}" target="_blank">PDF</a>
            <a ng-if="report.isPreview" ng-click="$displayCtrl.display(report.reportDate, $displayCtrl.parseWorkerID(report.htmlUrl), null)">HTML</a>
            <a ng-if="!report.isPreview && report.jsonUrl" href="{{ report.jsonUrl }}" target="_blank">JSON</a>
          </td>
          <td>{{ report.reportDate | date }}</td>
          <td>{{ report.updatedAt | date }}</td>
          <td>
            <span class="label label-info" ng-if="report.isPreview" sxy-text="SALAXY.NG1.ReportListComponent.preview"></span>
            <span class="label label-danger" ng-if="report.isDemoData">DEMO: demodataa</span>
          </td>
        </tr>
      </tbody>
      <tbody ng-if="$ctrl.reportType === 'monthlyDetails' || $ctrl.reportType === 'yearlyDetails'" ng-controller="SummaryReportDisplayController as $displayCtrl">
        <tr ng-repeat="report in $ctrl.getReports($ctrl.reportType)">
          <td>
            <a ng-if="!report.isPreview" href="{{ report.pdfUrl || report.htmlUrl || report.jsonUrl }}" target="_blank">
              <img ng-src="{{ report.thumbnail }}" class="img-responsive img-thumbnail" />
            </a>
            <a ng-if="report.isPreview" ng-click="$displayCtrl.display(report.reportDate,report.type)">
              <img ng-src="{{ report.thumbnail }}" class="img-responsive img-thumbnail" />
            </a>
          </td>
          <td>
            <a ng-if="!report.isPreview" href="{{ report.pdfUrl || report.htmlUrl || report.jsonUrl }}" target="_blank">{{ report.title }}</a>
            <a ng-if="report.isPreview" ng-click="$displayCtrl.display(report.reportDate,report.type)">{{ report.title }} </a>
          </td>
          <td>
            <a ng-if="!report.isPreview && report.pdfUrl" href="{{ report.pdfUrl }}" target="_blank">PDF</a>
            <a ng-if="report.isPreview" ng-click="$displayCtrl.display(report.reportDate,report.type)">HTML</a>
            <a ng-if="!report.isPreview && report.jsonUrl" href="{{ report.jsonUrl }}" target="_blank">JSON</a>
          </td>
          <td>{{ report.reportDate | date }}</td>
          <td>{{ report.updatedAt | date }}</td>
          <td>
            <span class="label label-info" ng-if="report.isPreview" sxy-text="SALAXY.NG1.ReportListComponent.preview"></span>
            <span class="label label-danger" ng-if="report.isDemoData">DEMO: demodataa</span>
          </td>
        </tr>
      
      </tbody>
      <tbody ng-if="$ctrl.reportType === 'monthlyLiikekirjuri'" ng-controller="AccountingReportDisplayController as $displayCtrl">
        <tr ng-repeat="report in $ctrl.getReports($ctrl.reportType)">
          <td>
            <a ng-if="!report.isPreview" href="{{ report.pdfUrl || report.htmlUrl || report.jsonUrl }}" target="_blank">
              <img ng-src="{{ report.thumbnail }}" class="img-responsive img-thumbnail" />
            </a>
            <a ng-if="report.isPreview" ng-click="$displayCtrl.display(report.reportDate,report.type, report)">
              <img ng-src="{{ report.thumbnail }}" class="img-responsive img-thumbnail" />
            </a>
          </td>
          <td>
            <a ng-if="!report.isPreview" href="{{ report.pdfUrl || report.htmlUrl || report.jsonUrl }}" target="_blank">{{ report.title }}</a>
            <a ng-if="report.isPreview" ng-click="$displayCtrl.display(report.reportDate,report.type)">{{ report.title }} </a>
          </td>
          <td>
            <a ng-if="!report.isPreview && report.pdfUrl" href="{{ report.pdfUrl }}" target="_blank">PDF</a>
            <a ng-if="report.isPreview" ng-click="$displayCtrl.display(report.reportDate)">HTML</a>
            <a ng-if="!report.isPreview && report.jsonUrl" href="{{ report.jsonUrl }}" target="_blank">JSON</a>
          </td>
          <td>{{ report.reportDate | date }}</td>
          <td>{{ report.updatedAt | date }}</td>
          <td>
            <span class="label label-info" ng-if="report.isPreview" sxy-text="SALAXY.NG1.ReportListComponent.preview"></span>
            <span class="label label-danger" ng-if="report.isDemoData">DEMO: demodataa</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>`), s.put("salaxy-components/report/SalaryReportList.html", `<div class="salaxy-component salaxy-salary-report-list">
  <salaxy-odata-table ng-if="$ctrl.mode != 'panel'" crud-controller="SalaryReportCrudController as $crud" template-url="salaxy-components/odata/lists/SalaryReports.html" options="$ctrl.queryOptions">
  </salaxy-odata-table>
  <salaxy-odata-table ng-if="$ctrl.mode == 'panel'" crud-controller="SalaryReportCrudController as $crud" template-url="salaxy-components/odata/lists/SalaryReportsPanel.html" options="$ctrl.panelQueryOptions">
  </salaxy-odata-table>
</div>`), s.put("salaxy-components/report/SummaryReport.html", `<div class="salaxy-component salaxy-summary-report">
  <div class="btn-toolbar" role="toolbar" aria-label="Report options">

    <div class="btn-group btn-group-sm dropdown">
      <button id="single-button2" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown" ng-disabled="disabled">
        <span sxy-text="SALAXY.NG1.CalcReportsComponent.reportLanguage" ps=":"></span> {{$ctrl.languageText | sxyTranslate}}
      </button>
      <ul class="dropdown-menu" role="menu" aria-labelledby="single-button2">
        <li ng-if="$ctrl.reportType === 'salarySlip'" role="menuitem">
          <a href="" ng-click="$ctrl.reportLang = 'default'" class="dropdown-item" sxy-text="SALAXY.NG1.CalcReportsComponent.reportLanguageWorker"></a>
        </li>
        <li ng-if="$ctrl.reportType !== 'salarySlip'" role="menuitem">
          <a href="" ng-click="$ctrl.reportLang = 'default'" class="dropdown-item" sxy-text="SALAXY.NG1.CalcReportsComponent.reportLanguageCompany"></a>
        </li>
        <li role="menuitem">
          <a href="" ng-click="$ctrl.reportLang = 'fi'" class="dropdown-item" sxy-text="SALAXY.ENUM.Language.fi.label"></a>
        </li>
        <li role="menuitem">
          <a href="" ng-click="$ctrl.reportLang = 'en'" class="dropdown-item" sxy-text="SALAXY.ENUM.Language.en.label"></a>
        </li>
        <li role="menuitem">
          <a href="" ng-click="$ctrl.reportLang = 'sv'" class="dropdown-item" sxy-text="SALAXY.ENUM.Language.sv.label"></a>
        </li>
      </ul>
    </div>
    <div class="btn-group btn-group-sm ms-sm-auto" role="group" aria-label="Pdf">
      <button sxy-if-role="!anon" type="button" class="btn btn-default" ng-click="$ctrl.showDownloadDialog(true)">
        <span class="d-none d-md-inline-block" sxy-text="SALAXY.UI_Terms.print"></span>
        <i class="bi bi-printer" aria-hidden="true"></i>
      </button>
      <button sxy-if-role="!anon" type="button" class="btn btn-default" ng-click="$ctrl.showDownloadDialog(false)">
        <span class="d-none d-md-inline-block" sxy-text="SALAXY.UI_Terms.downloadPdf"></span>
        <i class="bi bi-file-earmark-pdf" aria-hidden="true"></i>
      </button>
    </div>
  </div>
  <div class="" ng-class="{'report-table-html': $ctrl.applySiteStyles}">
    <div ng-bind-html="$ctrl.html" class="report-binder table-responsive"></div>
  </div>
</div>`), s.put("salaxy-components/report/SummaryReportQuery.html", `<div class="salaxy-component salaxy-summary-report-query">
  <div class="btn-toolbar" role="toolbar">
      <button type="button" class="btn btn-primary" ng-click="$ctrl.showPeriodSelection()" sxy-text="SALAXY.NG1.CumulativeReportComponent.selectPeriod" ps="..."></button>
      <button type="button" class="btn btn-secondary" ng-click="$ctrl.exportToExcel()">
        <span class="hidden-sm hidden-xs" sxy-text="SALAXY.NG1.HolidayReportComponent.exportToExcel"></span>
        <i class="bi bi-file-earmark-pdf" aria-hidden="true"></i>
      </button>
  </div>
  <p> {{ $ctrl.getQueryInfoText()}}</p>
  <salaxy-tab-buttons
    current-tab="$ctrl.currentTab"
    options="[
      { 'value': 'incomereport', 'text': 'SALAXY.NG1.HolidayReportComponent.irIncomeTypeReport' },
      { 'value': 'salarypaymentreport', 'text': 'SALAXY.NG1.HolidayReportComponent.salaryPaymentReport' }
    ]"
    tabs-id="summaryReportQuery">
  </salaxy-tab-buttons>
  <div class="tab-content" id="tab-content-summaryReportQuery">
    <div class="tab-pane" id="incomereport-tab">
      <div ng-if="$ctrl.currentTab == 'incomereport' && $ctrl.irReportRows.length > 0 && $ctrl.irReportRows[0].rows.length > 0">
        <table class="table table-striped">
          <thead>
            <tr>
              <th colspan="2"><span sxy-text="SALAXY.NG1_Other.Roles.worker"></span></th>
              <th ng-repeat="row in $ctrl.irReportRows[0].rows" class="right">{{row.label}}</th>             
            </tr>
          </thead>
          <tbody>
            <tr ng-repeat="row in $ctrl.irReportRows">
              <td class="align-middle td-avatar">
                <salaxy-avatar class="clickable" ng-click="$ctrl.showEditEmploymentDialog(row)" avatar="row.workerAvatar"></salaxy-avatar>
              </td>
              <td>{{row.workerAvatar.displayName}}</td>
              <td ng-repeat="r in row.rows" class="right">{{ r.isCount ?  r.total  : (r.total| currency) || "&nbsp;"}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="tab-pane" id="salarypaymentreport-tab">
      <div ng-if="$ctrl.currentTab == 'salarypaymentreport' && $ctrl.resultRows.length > 0 && ($ctrl.entrepreneurSummaryReportResults.length > 0 || $ctrl.workerSummaryReportResults.length > 0)">
        <table class="table table-striped">
          <thead>
            <tr>
              <th></th>             
              <th></th>             
              <th class="right">{{ "SALAXY.REPORTS.summary.table.totalGrossSalary" | sxyTranslate}}</th>
              <th class="right">{{ "SALAXY.REPORTS.summary.table.totalRowCategory" | sxyTranslate}}</th>
              <th class="right">{{ "SALAXY.REPORTS.summary.table.benefits" | sxyTranslate}}</th>
              <th class="right">{{ "SALAXY.REPORTS.summary.table.irCode" | sxyTranslate}}</th>
              <th class="right">{{ "SALAXY.REPORTS.summary.table.totalTaxable" | sxyTranslate}}</th>
              <th class="right">{{ "SALAXY.REPORTS.summary.table.tax" | sxyTranslate}}</th>
              <th class="right">{{ "SALAXY.REPORTS.summary.table.pension" | sxyTranslate}}</th>
              <th class="right">{{ "SALAXY.REPORTS.summary.table.unemploymentInsurance" | sxyTranslate}}</th>
              <th class="right">{{ "SALAXY.REPORTS.summary.table.unionPayment" | sxyTranslate}}</th>
              <th class="right">{{ "SALAXY.REPORTS.summary.table.foreclosure" | sxyTranslate}}</th>
              <th class="right">{{ "SALAXY.REPORTS.summary.table.otherDeductions" | sxyTranslate}}</th>
              <th class="right">{{ "SALAXY.REPORTS.summary.table.totalExpenses" | sxyTranslate}}</th>
              <th class="right" style="border-right: 1px solid #000">{{ "SALAXY.REPORTS.summary.table.totalWorkerPayment" | sxyTranslate}}</th>
              <th class="right">{{ "SALAXY.REPORTS.summary.table.totalPayment" | sxyTranslate}}</th>
              <th class="right">{{ "SALAXY.REPORTS.summary.table.palkkaus" | sxyTranslate}}</th>
              <th class="right">{{ "SALAXY.REPORTS.summary.table.service" | sxyTranslate}}</th>
              <th class="right">{{ "SALAXY.REPORTS.summary.table.socialSecurity" | sxyTranslate}}</th>
              <th class="right">{{ "SALAXY.REPORTS.summary.table.totalPensions" | sxyTranslate}}</th>
              <th class="right">{{ "SALAXY.REPORTS.summary.table.employerPension" | sxyTranslate}}</th>
              <th class="right">{{ "SALAXY.REPORTS.summary.table.unemployment" | sxyTranslate}}</th>
              <th class="right">{{ "SALAXY.REPORTS.summary.table.employerUnemployment" | sxyTranslate}}</th>
            </tr>
          </thead>
          <tbody ng-if="$ctrl.entrepreneurSummaryReportResults.length > 0">
            <tr >
              <td colspan="15" style="border-right: 1px solid #000"><strong>{{"SALAXY.REPORTS.summary.table.entrepreneurSalary" | sxyTranslate}}</strong></td>
              <td colspan="8"></td>
            </tr>
            <tr ng-repeat="row in $ctrl.entrepreneurSummaryReportResults">
              <td class="align-middle td-avatar">
                <salaxy-avatar class="clickable" ng-click="$ctrl.showEditEmploymentDialog(row)" avatar="row.avatar"></salaxy-avatar>
              </td>     
              <td>{{row.avatar.displayName}}</td>
              <td class="right">{{(row.totalGrossSalary | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.totalRowCategory | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.benefits | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.irCode | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.totalTaxable | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.tax | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.pension | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.unemploymentInsurance | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.unionPayment | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.foreclosure | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.otherDeductions | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.totalExpenses | currency) || "&nbsp;"}}</td>
              <td class="right" style="border-right: 1px solid #000">{{(row.totalWorkerPayment | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.totalPayment | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.palkkaus | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.service | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.socialSecurity | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.totalPensions | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.employerPension | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.unemployment | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.employerUnemployment | currency) || "&nbsp;"}}</td>
            </tr>
          </tbody>
          <tbody ng-if="$ctrl.workerSummaryReportResults.length > 0">
            <tr>
              <td colspan="15" style="border-right: 1px solid #000"><strong>{{"SALAXY.REPORTS.summary.table.workerSalary" | sxyTranslate}}</strong></td>
              <td colspan="8"></td>
            </tr>
            <tr ng-repeat="row in $ctrl.workerSummaryReportResults">
              <td class="align-middle td-avatar">
                <salaxy-avatar class="clickable" ng-click="$ctrl.showEditEmploymentDialog(row)" avatar="row.avatar"></salaxy-avatar>
              </td>     
              <td>{{row.avatar.displayName}}</td>
              <td class="right">{{(row.totalGrossSalary | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.totalRowCategory | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.benefits | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.irCode | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.totalTaxable | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.tax | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.pension | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.unemploymentInsurance | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.unionPayment | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.foreclosure | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.otherDeductions | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.totalExpenses | currency) || "&nbsp;"}}</td>
              <td class="right" style="border-right: 1px solid #000">{{(row.totalWorkerPayment | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.totalPayment | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.palkkaus | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.service | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.socialSecurity | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.totalPensions | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.employerPension | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.unemployment | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.employerUnemployment | currency) || "&nbsp;"}}</td>
            </tr>
          </tbody>
          <tbody ng-if="$ctrl.totalSummaryReportResults.length > 0">           
            <tr ng-repeat="row in $ctrl.totalSummaryReportResults">
              <td class="right"><strong>{{"SALAXY.REPORTS.summary.table.total" | sxyTranslate }}:</strong></td>
              <td></td>
              <td class="right">{{(row.totalGrossSalary | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.totalRowCategory | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.benefits | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.irCode | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.totalTaxable | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.tax | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.pension | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.unemploymentInsurance | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.unionPayment | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.foreclosure | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.otherDeductions | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.totalExpenses | currency) || "&nbsp;"}}</td>
              <td class="right" style="border-right: 1px solid #000">{{(row.totalWorkerPayment | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.totalPayment | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.palkkaus | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.service | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.socialSecurity | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.totalPensions | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.employerPension | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.unemployment | currency) || "&nbsp;"}}</td>
              <td class="right">{{(row.employerUnemployment | currency) || "&nbsp;"}}</td>
            </tr>
          </tbody>
        </table>
        <small>
          <small>
            <div>
              <span>{{"SALAXY.REPORTS.summary.infoText.tt" | sxyTranslate}}</span><br />
              <span>{{"SALAXY.REPORTS.summary.infoText.ta" | sxyTranslate}}</span><br />
              <span>{{"SALAXY.REPORTS.summary.infoText.lo" | sxyTranslate}}</span><br />
            </div>
          </small>
        </small>
      </div>
    </div>
  </div>
</div>`), s.put("salaxy-components/report/WorkerSummaryReport.html", `<div class="salaxy-component salaxy-summary-report">
  <div class="btn-toolbar" role="toolbar" aria-label="Report options">

    <div class="btn-group btn-group-sm dropdown">
      <button id="single-button2" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown" ng-disabled="disabled">
        <span sxy-text="SALAXY.NG1.CalcReportsComponent.reportLanguage" ps=":"></span> {{$ctrl.languageText | sxyTranslate}}
      </button>
      <ul class="dropdown-menu" role="menu" aria-labelledby="single-button2">
        <li ng-if="$ctrl.reportType === 'salarySlip'" role="menuitem">
          <a href="" ng-click="$ctrl.reportLang = 'default'" class="dropdown-item" sxy-text="SALAXY.NG1.CalcReportsComponent.reportLanguageWorker"></a>
        </li>
        <li ng-if="$ctrl.reportType !== 'salarySlip'" role="menuitem">
          <a href="" ng-click="$ctrl.reportLang = 'default'" class="dropdown-item" sxy-text="SALAXY.NG1.CalcReportsComponent.reportLanguageCompany"></a>
        </li>
        <li role="menuitem">
          <a href="" ng-click="$ctrl.reportLang = 'fi'" class="dropdown-item" sxy-text="SALAXY.ENUM.Language.fi.label"></a>
        </li>
        <li role="menuitem">
          <a href="" ng-click="$ctrl.reportLang = 'en'" class="dropdown-item" sxy-text="SALAXY.ENUM.Language.en.label"></a>
        </li>
        <li role="menuitem">
          <a href="" ng-click="$ctrl.reportLang = 'sv'" class="dropdown-item" sxy-text="SALAXY.ENUM.Language.sv.label"></a>
        </li>
      </ul>
    </div>
    <div class="btn-group btn-group-sm ms-sm-auto" role="group" aria-label="Pdf">
      <button sxy-if-role="!anon" type="button" class="btn btn-default" ng-click="$ctrl.showDownloadDialog(true)">
        <span class="d-none d-md-inline-block" sxy-text="SALAXY.UI_Terms.print"></span>
        <i class="bi bi-printer" aria-hidden="true"></i>
      </button>
      <button sxy-if-role="!anon" type="button" class="btn btn-default" ng-click="$ctrl.showDownloadDialog(false)">
        <span class="d-none d-md-inline-block" sxy-text="SALAXY.UI_Terms.downloadPdf"></span>
        <i class="bi bi-file-earmark-pdf" aria-hidden="true"></i>
      </button>
    </div>
  </div>
  <div class="" ng-class="{'report-table-html': $ctrl.applySiteStyles}">
    <div ng-bind-html="$ctrl.html" class="report-binder table-responsive"></div>
  </div>
</div>`), s.put("salaxy-components/settings/Accountant.html", `<div class="content settings">
  <div class="card card-secondary accountant" ng-if="$ctrl.accountant">
    <div class="card-header d-flex">
      <div class="flex-grow-1">
        <h2><span sxy-text="SALAXY.NG1.AccountantComponent.title"></span>
        </h2>
        <p>
          <small sxy-text="SALAXY.NG1.AccountantComponent.intro2"></small>
        </p>
      </div>
      <i class="bi bi-check-circle-fill text-success status-icon fs-1 d-block"></i>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-12 form-horizontal">
          <fieldset>
            <div class="salaxy-component salaxy-accountant-info">
              <div>
                <table>
                  <tr ng-if="$ctrl.accountant.info.avatar.displayName">
                    <td sxy-text="SALAXY.NG1.AccountantComponent.name" ps=":"></td>
                    <td>
                      <div class="d-flex align-items-center">
                        <salaxy-avatar class="me-2" style="font-size: 25px;" avatar="$ctrl.accountant.info.avatar"></salaxy-avatar>
                        <strong>{{ $ctrl.accountant.info.avatar.displayName}}<strong>
                      </div>
                    </td>
                  </tr>
                  <tr ng-if="$ctrl.accountant.info.officialId">
                    <td sxy-text="SALAXY.NG1.AccountantComponent.officialId" ps=":"></td>
                    <td>{{ $ctrl.accountant.info.officialId}}</td>
                  </tr>
                  <tr ng-if="$ctrl.accountant.info.email">
                    <td sxy-text="SALAXY.NG1.AccountantComponent.email" ps=":"></td>
                    <td>{{ $ctrl.accountant.info.email }}</td>
                  </tr>
                  <tr ng-if="$ctrl.accountant.info.telephone">
                    <td sxy-text="SALAXY.NG1.AccountantComponent.phone" ps=":"></td>
                    <td>{{ $ctrl.accountant.info.telephone }}</td>
                  </tr>
                  <tr ng-if="$ctrl.accountant.type == 'primaryPartner' || $ctrl.accountant.type == 'pendingPrimaryPartner' || $ctrl.accountant.type == 'unlinkedPrimaryPartner' || $ctrl.accountant.type == 'unlinkedAccountingOnly'">
                    <td sxy-text="SALAXY.NG1.AccountantComponent.accountantType" ps=":"></td>
                    <td>
                      <span ng-if="$ctrl.accountant.type == 'primaryPartner'" sxy-text="SALAXY.NG1.AccountantComponent.primaryPartner"></span>
                      <span ng-if="$ctrl.accountant.type == 'pendingPrimaryPartner'" sxy-text="SALAXY.NG1.AccountantComponent.pendingPrimaryPartner"></span>
                      <span ng-if="$ctrl.accountant.type == 'unlinkedPrimaryPartner'" sxy-text="SALAXY.NG1.AccountantComponent.unlinkedPrimaryPartner"></span>
                      <span ng-if="$ctrl.accountant.type == 'unlinkedAccountingOnly'" sxy-text="SALAXY.NG1.AccountantComponent.unlinkedAccountingOnly"></span>
                    </td>
                  </tr>
                  <tr ng-if="$ctrl.accountantMainType == 'none' && !($ctrl.accountant.info.avatar.firstName || $ctrl.accountant.info.avatar.lastName || $ctrl.accountant.info.email || $ctrl.accountant.info.telephone)">
                    <td colspan="2">
                      <span sxy-text="SALAXY.NG1.AccountantSelectionComponent.noAccountantEnum"></span>
                    </td>
                  </tr>
                </table>
              </div>
            </div>

          </fieldset>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="row">
        <div class="col-12">
          <button class="btn btn-primary float-end" ng-click="$ctrl.showEdit($ctrl.removalDisabled)" sxy-text="SALAXY.UI_Terms.edit"></button>
        </div>
      </div>
    </div>
  </div>
</div>`), s.put("salaxy-components/settings/AccountantEmails.html", `<div class="content settings">
  <div class="card card-secondary accountant" ng-if="$ctrl.accountant">
    <div class="card-header">
      <h2><span sxy-text="SALAXY.NG1.AccountantComponent.title"></span>
      </h2>
    </div>
    <div class="card-body">
      <div class="row">
        <form name="companyAccountantForm" class="form-horizontal">
          <div class="col">
            <fieldset ng-if="$ctrl.accountantMainType != 'none'">
              <div  class="container-fixed salaxy-component salaxy-accountant-info">
                <div class="table-responsive">
                  <table class="table">
                    <tr>
                      <th sxy-text="SALAXY.NG1.AccountantComponent.name" ps=":"></th>
                      <td>
                        <salaxy-avatar style="font-size: 20px; margin-right: 12px;" avatar="$ctrl.accountant.info.avatar"></salaxy-avatar><strong>{{ $ctrl.accountant.info.avatar.displayName}}<strong></td>
                  </tr>
                  <tr ng-if="$ctrl.accountant.info.officialId">
                    <th sxy-text="SALAXY.NG1.AccountantComponent.officialId" ps=":"></th>
                    <td>{{ $ctrl.accountant.info.officialId}}</td>
                  </tr>
                  <tr ng-if="$ctrl.accountant.type == 'primaryPartner' || $ctrl.accountant.type == 'pendingPrimaryPartner'">
                    <th sxy-text="SALAXY.NG1.AccountantSelectionComponent.companyAccountantForm.accountingDataEmail" ps=":"></th>
                    <td>
                      <salaxy-input-boolean ng-model="$ctrl.accountant.info.accountantEmailsOrdered" type="checkbox" name="order" label="" label-type="plain">
                        </salaxy-input-boolean>
                    </td>
                  </tr>
      
                  <tr ng-if="$ctrl.accountant.type == 'unlinkedAccountingOnly' || !$ctrl.accountant.info.avatar.id || $ctrl.accountant.type == 'pendingPrimaryPartner' || $ctrl.accountant.type == 'primaryPartner'">
                    <th sxy-text="SALAXY.NG1.AccountantSelectionComponent.personAccountantForm.email" ps=":"></th>
                    <td>
                      <salaxy-input name="email" label="" read-only="($ctrl.accountant.type == 'primaryPartner' || $ctrl.accountant.type == 'pendingPrimaryPartner') && !$ctrl.accountant.info.accountantEmailsOrdered" require="!(($ctrl.accountant.type == 'primaryPartner' || $ctrl.accountant.type == 'pendingPrimaryPartner') && !$ctrl.accountant.info.accountantEmailsOrdered)"
                        label-type="plain" sxy-email ng-model="$ctrl.accountant.info.email"></salaxy-input>
                    </td>
                  </tr>
                  <tr ng-if="$ctrl.accountant.type == 'unlinkedAccountingOnly' || !$ctrl.accountant.info.avatar.id || $ctrl.accountant.type == 'pendingPrimaryPartner' || $ctrl.accountant.type == 'primaryPartner'">
                    <th sxy-text="SALAXY.NG1.AccountantSelectionComponent.personAccountantForm.telephone" ps=":"></th>
                    <td>
                      <salaxy-input name="telephone" label="" read-only="($ctrl.accountant.type == 'primaryPartner' || $ctrl.accountant.type == 'pendingPrimaryPartner') && !$ctrl.accountant.info.accountantEmailsOrdered" require="!(($ctrl.accountant.type == 'primaryPartner' || $ctrl.accountant.type == 'pendingPrimaryPartner') && !$ctrl.accountant.info.accountantEmailsOrdered)"
                        label-type="plain" sxy-mobile-phone ng-model="$ctrl.accountant.info.telephone"></salaxy-input>
                    </td>
                  </tr>
                  <tr ng-if="$ctrl.accountant.type == 'primaryPartner' || $ctrl.accountant.type == 'pendingPrimaryPartner' || $ctrl.accountant.type == 'unlinkedPrimaryPartner' || $ctrl.accountant.type == 'unlinkedAccountingOnly'">
                    <th sxy-text="SALAXY.NG1.AccountantComponent.accountantType" ps=":"></th>
                    <td>
                      <span ng-if="$ctrl.accountant.type == 'primaryPartner'" sxy-text="SALAXY.NG1.AccountantComponent.primaryPartner"></span>
                      <span ng-if="$ctrl.accountant.type == 'pendingPrimaryPartner'" sxy-text="SALAXY.NG1.AccountantComponent.pendingPrimaryPartner"></span>
                      <span ng-if="$ctrl.accountant.type == 'unlinkedPrimaryPartner'" sxy-text="SALAXY.NG1.AccountantComponent.unlinkedPrimaryPartner"></span>
                      <span ng-if="$ctrl.accountant.type == 'unlinkedAccountingOnly'" sxy-text="SALAXY.NG1.AccountantComponent.unlinkedAccountingOnly"></span>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </fieldset>
          <fieldset ng-if="$ctrl.accountantMainType == 'none'">
            <salaxy-input name="firstName" label="SALAXY.NG1.AccountantSelectionComponent.personAccountantForm.firstName" ng-model="$ctrl.accountant.info.avatar.firstName"></salaxy-input>
            <salaxy-input name="lastName" label="SALAXY.NG1.AccountantSelectionComponent.personAccountantForm.lastName"  ng-model="$ctrl.accountant.info.avatar.lastName"></salaxy-input>
            <salaxy-input name="email" label="SALAXY.NG1.AccountantSelectionComponent.personAccountantForm.email"  sxy-email ng-model="$ctrl.accountant.info.email"></salaxy-input>
            <salaxy-input name="telephone" label="SALAXY.NG1.AccountantSelectionComponent.personAccountantForm.telephone"  sxy-mobile-phone ng-model="$ctrl.accountant.info.telephone"></salaxy-input>
          </fieldset>
        </div>
      </form>
      </div>
    </div>
    <div class="card-footer">
      <div class="row">
        <div class="col">
          <div class="text-end">
            <a ng-if="$ctrl.accountantMainType == 'none'" class="btn btn-default" href="#/settings/accountants" sxy-text="SALAXY.NG1.AccountantComponent.addPrimaryPartner"></a>
            <button ng-disabled="!companyAccountantForm.$valid" class="btn btn-primary" ng-click="$ctrl.save()" sxy-text="SALAXY.UI_Terms.save"></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>`), s.put("salaxy-components/settings/AccountantInfo.html", `<div class="content settings">
  <div class="card mb-4 card-secondary accountant" ng-if="$ctrl.accountant">
    <div class="card-header">
      <h2><span sxy-text="SALAXY.NG1.AccountantComponent.title"></span>
      </h2>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-12 form-horizontal">
          <fieldset>
            <div class="salaxy-component salaxy-accountant-info">
              <div >
                <table>
                  <tr ng-if="$ctrl.accountant.info.avatar.displayName">
                    <td sxy-text="SALAXY.NG1.AccountantComponent.name" ps=":"></td>
                    <td>
                      <div class="d-flex align-items-center">
                        <salaxy-avatar class="me-2" style="font-size: 25px;" avatar="$ctrl.accountant.info.avatar"></salaxy-avatar>
                        <strong>{{ $ctrl.accountant.info.avatar.displayName}}<strong>
                      </div>
                    </td>
                  </tr>
                  <tr ng-if="$ctrl.accountant.info.officialId">
                    <td sxy-text="SALAXY.NG1.AccountantComponent.officialId" ps=":"></td>
                    <td>{{ $ctrl.accountant.info.officialId}}</td>
                  </tr>
                  <tr ng-if="$ctrl.accountant.info.email">
                    <td sxy-text="SALAXY.NG1.AccountantComponent.email" ps=":"></td>
                    <td>{{ $ctrl.accountant.info.email }}</td>
                  </tr>
                  <tr ng-if="$ctrl.accountant.info.telephone">
                    <td sxy-text="SALAXY.NG1.AccountantComponent.phone" ps=":"></td>
                    <td>{{ $ctrl.accountant.info.telephone }}</td>
                  </tr>
                  <tr ng-if="$ctrl.accountant.type == 'primaryPartner' || $ctrl.accountant.type == 'pendingPrimaryPartner' || $ctrl.accountant.type == 'unlinkedPrimaryPartner' || $ctrl.accountant.type == 'unlinkedAccountingOnly'">
                    <td sxy-text="SALAXY.NG1.AccountantComponent.accountantType" ps=":"></td>
                    <td>
                      <span ng-if="$ctrl.accountant.type == 'primaryPartner'" sxy-text="SALAXY.NG1.AccountantComponent.primaryPartner"></span>
                      <span ng-if="$ctrl.accountant.type == 'pendingPrimaryPartner'" sxy-text="SALAXY.NG1.AccountantComponent.pendingPrimaryPartner"></span>
                      <span ng-if="$ctrl.accountant.type == 'unlinkedPrimaryPartner'" sxy-text="SALAXY.NG1.AccountantComponent.unlinkedPrimaryPartner"></span>
                      <span ng-if="$ctrl.accountant.type == 'unlinkedAccountingOnly'" sxy-text="SALAXY.NG1.AccountantComponent.unlinkedAccountingOnly"></span>
                    </td>
                  </tr>
                  <tr ng-if="$ctrl.accountantMainType == 'none' && !($ctrl.accountant.info.avatar.firstName || $ctrl.accountant.info.avatar.lastName || $ctrl.accountant.info.email || $ctrl.accountant.info.telephone)">
                    <td colspan="2">
                      <span sxy-text="SALAXY.NG1.AccountantSelectionComponent.noAccountantEnum"></span>
                    </td>
                  </tr>
                </table>
              </div>
            </div>

          </fieldset>
        </div>
      </div>
    </div>
    <div class="card-footer" ng-if="$ctrl.accountantMainType == 'none'">
      <div class="row">
        <div class="col-12">
          <div class="text-end">
            <a class="btn btn-default" href="#/settings/accountants" sxy-text="SALAXY.NG1.AccountantComponent.addPrimaryPartner"></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>`), s.put("salaxy-components/settings/AccountingSettings.html", `<div class="content settings" ng-if="$ctrl.current">
  <div class="card mb-4 accounting card-secondary">
    <div>
      <div class="card-header">
        <h2 sxy-text="SALAXY.MODEL.AccountingSettings.title"></h2>
        <p><small sxy-text="SALAXY.MODEL.AccountingSettings.descr"></small></p>
      </div>
      <div class="card-body">
        <div class="row">

          <sxy-form ng-ref="$frm" open-api="salaxy-secure/schemas/v02.json" type="CompanyAccountSettings" auto-gen="false" debugger="false" model="$ctrl.current" read-only="{{!$ctrl.current.accounting.denyServiceModel  && $ctrl.current.partner.serviceModel.features.accounting}}">
            <div class="col-12 form-horizontal">
              <fieldset>
                <salaxy-input-typeahead
                  label="SALAXY.MODEL.AccountingSettings.defaultTargetId.title"
                  ng-model="$ctrl.current.accounting.defaultTargetId"
                  name="options_type"
                  disable-cache="true"
                  options="$ctrl.getSelectableAccountingTargets()">
                </salaxy-input-typeahead>
                <salaxy-form-group name="targets" label="SALAXY.MODEL.AccountingSettings.targets.title">
                  <div>
                    <span>
                        <i ng-click="$ctrl.showTargets = !$ctrl.showTargets" class="clickable bi" ng-class="$frm.readOnly == 'true' ? 'bi-info-circle-fill' : 'bi-pencil-fill'"></i>
                    </span>
                  </div>
                </salaxy-form-group>

                  <sxy-input ng-if="$ctrl.showTargets" template-url="salaxy-components/sxy-form/custom-templates/array-accounting-targets.html" model="form.accounting.targets">
                    <form>
                      <fieldset ng-show="!$ctrl.logic.showDelete" ng-controller="CompanySettingsController as $companySettingsCtrl" ng-init="$ctrl.logic.isReadOnly = true">
                        <salaxy-odata-table crud-controller="AccountingTargetCrudController as $crud" template-url="salaxy-components/odata/lists/AccountingTargetSelect.html" selected-items="$ctrl.selectedItems" on-list-select="$companySettingsCtrl.onAccountingTargetSelect($ctrl.current, $ctrl.logic, value, item, allItems)">
                        </salaxy-odata-table>
                      </fieldset>
                      <fieldset ng-show="$ctrl.logic.showDelete" ng-init="$ctrl.logic.isReadOnly = false">
                        <salaxy-input-enum disabled="false" name="format" label="SALAXY.NG1.AccountingTargetDetailsComponent.excelCsvFormat" ng-model="$ctrl.current.format"
                          options="{
                            '36dff2e2-e181-4f0d-9004-0e4aa92f5e17': 'Palkkaus.fi',
                            '0db4e85f-93a8-46f1-b6d2-f7523d289d88': 'Fennoa',
                            '8613f133-3fce-4611-b372-51f6a2e007dd': 'Procountor',
                            'e62c10b0-222a-4170-b8b4-b1e02d9a7644': 'Passeli Merit',
                            '53fd3863-b8f9-4909-86c9-cb4597595181': 'Heeros',
                            '2fc7899c-7a3d-4d56-ad2f-05d52782bbbc': 'Asteri',
                            '0a2bd312-06da-4862-aef5-75166e0bf461': 'Maestro',
                            'c04e0757-63f3-420d-a183-3427710fc954': 'Visma Fivaldi',
                            'ba271dac-dd63-4036-9d70-053a09ca4d9e' :'Visma Netvisor',
                            '27e271d5-41f5-4319-ab29-4d5d9eb945c6': 'Lemonsoft',
                            'd311f9d3-8c3a-4fd8-a665-8e3698e41e87': 'Tampuuri',
                            'd58e95b7-d0b5-40ac-992b-6d3b29efc45e': 'Domus',
                            '54e93c5f-bd74-4157-8a74-3515be7f585d': 'Oscar Software',
                            '0e4f0a71-dcb9-43ba-9028-0239e674711f': 'Digia Enterprise',
                            '2ccefa46-7992-46c5-9d87-b88336935916': 'Digia Enterprise - VILPE'
                          }">
                        </salaxy-input-enum>
                        <sxy-input model="form.method" read-only="false"></sxy-input>
                        <salaxy-input-enum disabled="false" enum="ExportMethod" label="SALAXY.MODEL.AccountingTargetSettings.availableMethods.title" name="availableMethods" type="multi-select" ng-model="$ctrl.current.availableMethods"></salaxy-input-enum>
                      </fieldset>
                    </form>
                  </sxy-input>

                <sxy-input model="form.accounting.defaultPeriodDateKind"></sxy-input>
                <salaxy-input-enum ng-if="$ctrl.defaultAccountingTarget"
                  read-only="$frm.readOnly == 'true'" type="select" name="method"
                  ng-model="$ctrl.defaultAccountingTarget.method" enum="ExportMethod" label="SALAXY.MODEL.AccountingTargetSettings.method.title"></salaxy-input-enum>
              </fieldset>
              <fieldset>
                <legend sxy-text="SALAXY.MODEL.AccountingSettings.reportDelivery.title"></legend>
                <sxy-input read-only="false" format="checkbox" model="form.accounting.reportDelivery.isEnabled"></sxy-input>
                <sxy-input read-only="false"  format="email" model="form.accounting.reportDelivery.address" ng-if="$ctrl.current.accounting.reportDelivery.isEnabled"></sxy-input>
              </fieldset>
              <fieldset>
                <legend sxy-text="SALAXY.MODEL.AccountingSettings.accountantReportDelivery.title"></legend>
                <sxy-input read-only="false" format="checkbox" model="form.accounting.accountantReportDelivery.isEnabled"></sxy-input>
                <sxy-input read-only="false"  format="email" model="form.accounting.accountantReportDelivery.address" ng-if="$ctrl.current.accounting.accountantReportDelivery.isEnabled"></sxy-input>
           
              </fieldset>
            </div>
          </sxy-form>
        </div>
      </div>
      <div class="card-footer">
        <div class="row">
          <div class="col-12">
            <button type="submit" ng-disabled="!$frm.ngForm.$valid || $ctrl.isSaving('all')" class="btn btn-primary float-end" ng-click="$ctrl.save('all')">
              <span ng-if="$ctrl.isSaving('all')"><i class="bi bi-arrow-repeat bi-spin"></i></span>
              <span sxy-text="SALAXY.UI_Terms.save"></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>`), s.put("salaxy-components/settings/AccountingTargetDetails.html", `<div class="salaxy-component salaxy-accounting-target-editor">
  <div ng-if="!$ctrl.current">
    <salaxy-spinner heading="SALAXY.UI_Terms.loading"></salaxy-spinner>
  </div>
  <div class="row" ng-if="$ctrl.current">
    <div class="col-12 accounting-target-info-col">
      <div class="row mb-2">
        <div class="col-12">
          <div class="btn-toolbar float-end" role="toolbar" aria-label="Tilit">
            <div class="btn-group" role="group" aria-label="Save and load">
              <button class="btn btn-danger" ng-disabled="$ctrl.isReadOnly" ng-click="$ctrl.delete()" sxy-text="SALAXY.UI_Terms.delete"></button>
              <button class="btn btn-default" ng-click="$ctrl.showCopyAsNew($ctrl.current)" sxy-text="SALAXY.UI_Terms.copyAsNew"></button>
              <button class="btn btn-primary" ng-disabled="!$ctrl.hasChanges && !$ctrl.isNew()" ng-click="$ctrl.save()" sxy-text="SALAXY.UI_Terms.save"></button>
            </div>
          </div>
          <salaxy-avatar class="float-start" style="font-size: 58px; margin-right: 15px; margin-top: -15px;" avatar="$ctrl.current.info.target.avatar"></salaxy-avatar>
          <h2>{{ $ctrl.current.info.target.avatar.displayName}}</h2>

          <fieldset class="form-horizontal">
            <legend sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.accountingTargetLegend"></legend>
            <div ng-if="$ctrl.template">
              <div class="row">
                <div class="col-sm-4">
                  <salaxy-input read-only="true" name="template_name" label="SALAXY.NG1.AccountingTargetDetailsComponent.name"
                    ng-model="$ctrl.template.info.target.avatar.displayName"></salaxy-input>
                  <salaxy-input read-only="true" name="template_id" label="SALAXY.NG1.AccountingTargetDetailsComponent.id" ng-model="$ctrl.template.id"></salaxy-input>
                </div>
                <div class="col-sm-4">
                  <salaxy-input-enum read-only="true" name="format" label="SALAXY.NG1.AccountingTargetDetailsComponent.excelCsv" ng-model="$ctrl.template.info.format" options="{
                    '36dff2e2-e181-4f0d-9004-0e4aa92f5e17': 'Palkkaus.fi',
                    '0db4e85f-93a8-46f1-b6d2-f7523d289d88': 'Fennoa',
                    '8613f133-3fce-4611-b372-51f6a2e007dd': 'Procountor',
                    'e62c10b0-222a-4170-b8b4-b1e02d9a7644': 'Passeli Merit',
                    '53fd3863-b8f9-4909-86c9-cb4597595181': 'Heeros',
                    '2fc7899c-7a3d-4d56-ad2f-05d52782bbbc': 'Asteri',
                    '0a2bd312-06da-4862-aef5-75166e0bf461': 'Maestro',
                    'c04e0757-63f3-420d-a183-3427710fc954': 'Visma Fivaldi',
                    'ba271dac-dd63-4036-9d70-053a09ca4d9e': 'Visma Netvisor',
                    '27e271d5-41f5-4319-ab29-4d5d9eb945c6': 'Lemonsoft',
                    'd311f9d3-8c3a-4fd8-a665-8e3698e41e87': 'Tampuuri',
                    'd58e95b7-d0b5-40ac-992b-6d3b29efc45e': 'Domus',
                    '54e93c5f-bd74-4157-8a74-3515be7f585d': 'Oscar Software',
                    '0e4f0a71-dcb9-43ba-9028-0239e674711f': 'Digia Enterprise',
                    '2ccefa46-7992-46c5-9d87-b88336935916': 'Digia Enterprise - VILPE'
                  }"></salaxy-input-enum>
                </div>
                <div class="col-sm-4">
                  <salaxy-datepicker read-only="true" name="createdAt" ng-model="$ctrl.template.createdAt" label="SALAXY.UI_Terms.created"></salaxy-datepicker>
                  <salaxy-datepicker read-only="true" name="updatedAt" ng-model="$ctrl.template.updatedAt" label="SALAXY.UI_Terms.updated"></salaxy-datepicker>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
    </div>
  </div>
  <div ng-if="$ctrl.current">
    <salaxy-tab-buttons
      current-tab="$ctrl.currentTab"
      options="[
        { value: 'overview', text: 'SALAXY.NG1.AccountingTargetDetailsComponent.tabs.overview' },
        { value: 'coa', text: 'SALAXY.NG1.AccountingTargetDetailsComponent.tabs.chartOfAccounts' },
        { value: 'accounts', text: 'SALAXY.NG1.AccountingTargetDetailsComponent.tabs.usedAccounts', onClick: $ctrl.sortRulesetAccounts },
        { value: 'guidelines', text: 'SALAXY.NG1.AccountingTargetDetailsComponent.tabs.guidelines' },
        { value: 'rules', text: 'SALAXY.NG1.AccountingTargetDetailsComponent.tabs.rules' },
        { value: 'accountingquery', text: 'SALAXY.NG1.AccountingTargetDetailsComponent.tabs.accountingQuery' },
        { value: 'debugger', text: 'Debugger', hidden: !('test' | sxyIsInRole) }
      ]"
      tabs-id="accountingTargetDetails">
    </salaxy-tab-buttons>
    <div class="tab-content" id="tab-content-accountingTargetDetails">
      <div class="tab-pane" id="overview-tab">
        <form name="ruleSetForm" class="form-horizontal">
          <div class="row">
            <div class="col-6">
              <fieldset>
                <div ng-if="$ctrl.isReadOnly" class="alert alert-danger">
                  <span class="text-danger" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.readOnly"></span>
                </div>
                <salaxy-input disabled="$ctrl.isReadOnly" name="ruleSetName" label="SALAXY.NG1.AccountingTargetDetailsComponent.name"
                  ng-model="$ctrl.current.info.target.avatar.displayName"></salaxy-input>
                  <salaxy-input disabled="$ctrl.isReadOnly" name="logoUrl" label="SALAXY.NG1.AccountingTargetDetailsComponent.logoUrl"
                  ng-model="$ctrl.current.info.target.avatar.url"></salaxy-input>
                <salaxy-input-enum disabled="$ctrl.isReadOnly" name="channel" label="SALAXY.NG1.AccountingTargetDetailsComponent.channel" ng-model="$ctrl.current.info.channel" enum="AccountingChannel">
                </salaxy-input-enum>
                <salaxy-input-enum disabled="$ctrl.isReadOnly" name="format" label="SALAXY.NG1.AccountingTargetDetailsComponent.excelCsvFormat" ng-model="$ctrl.current.info.format"
                  options="{
                    '36dff2e2-e181-4f0d-9004-0e4aa92f5e17': 'Palkkaus.fi',
                    '0db4e85f-93a8-46f1-b6d2-f7523d289d88': 'Fennoa',
                    '8613f133-3fce-4611-b372-51f6a2e007dd': 'Procountor',
                    'e62c10b0-222a-4170-b8b4-b1e02d9a7644': 'Passeli Merit',
                    '53fd3863-b8f9-4909-86c9-cb4597595181': 'Heeros',
                    '2fc7899c-7a3d-4d56-ad2f-05d52782bbbc': 'Asteri',
                    '0a2bd312-06da-4862-aef5-75166e0bf461': 'Maestro',
                    'c04e0757-63f3-420d-a183-3427710fc954': 'Visma Fivaldi',
                    'ba271dac-dd63-4036-9d70-053a09ca4d9e' :'Visma Netvisor',
                    '27e271d5-41f5-4319-ab29-4d5d9eb945c6': 'Lemonsoft',
                    'd311f9d3-8c3a-4fd8-a665-8e3698e41e87': 'Tampuuri',
                    'd58e95b7-d0b5-40ac-992b-6d3b29efc45e': 'Domus',
                    '54e93c5f-bd74-4157-8a74-3515be7f585d': 'Oscar Software',
                    '0e4f0a71-dcb9-43ba-9028-0239e674711f': 'Digia Enterprise',
                    '2ccefa46-7992-46c5-9d87-b88336935916': 'Digia Enterprise - VILPE'
                  }">
                </salaxy-input-enum>
                <salaxy-form-group name="method" label="SALAXY.NG1.AccountingTargetDetailsComponent.exportMethod" label-type="horizontal">
                  <select class="form-select" ng-model="$ctrl.current.info.method">
                    <option ng-repeat="method in $ctrl.current.info.availableMethods"ng-value="method">{{'SALAXY.ENUM.ExportMethod.' + method + ".label" | sxyTranslate}}</option>
                  </select>
                </salaxy-form-group>
                <salaxy-input-enum label="SALAXY.NG1.AccountingTargetDetailsComponent.exportMethods" disabled="false" enum="ExportMethod"
                  name="availableMethods" type="multi-select" ng-model="$ctrl.current.info.availableMethods"></salaxy-input-enum>
              </fieldset>
            </div>
          </div>
        </form>
      </div>
      <div class="tab-pane" id="coa-tab">
        <div class="btn-toolbar" role="toolbar" aria-label="Data options">
          <div class="btn-group" role="group">
            <button ng-disabled="$ctrl.isReadOnly" type="button" class="btn btn-default" ng-click="$ctrl.pasteFromClipboard()">
              <span><span sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.pasteFromClipboard"></span> <i class="bi bi-clipboard"></i></span></button>
            <button ng-disabled="$ctrl.isReadOnly" type="button" class="btn btn-default" ngf-select="$ctrl.readFile($file)" ngf-multiple="false" ngf-max-size="10MB">
              <span><span sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.readFile" ps="..."></span><i class="bi bi-file-earmark-text"></i></span>
            </button>
          </div>
        </div>
        <div class="table-responsive" ng-if="$ctrl.hasTargetCoA">
          <table class="table table-sm">
            <thead>
              <tr>
                <th sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.accountNumber"></th>
                <th sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.name"></th>
                <th class="right">
                  <button title="{{'SALAXY.UI_Terms.addRow' | sxyTranslate}}" class="btn btn-primary btn-sm" type="button" ng-click="$ctrl.addTargetCoaAccount(false)"
                    sxy-text="SALAXY.UI_Terms.addRow"></button>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr ng-repeat="account in $ctrl.current.ruleSet.targetCoA">
                <td>
                  <salaxy-input read-only="$ctrl.isReadOnly" name="{{'accountAccount'+$index}}" ng-change="$ctrl.updateRuleSetAccount(account)" ng-model="account.account" label-type="plain"></salaxy-input>
                </td>
                <td>
                  <salaxy-input read-only="$ctrl.isReadOnly" name="{{'accountText'+$index}}" ng-change="$ctrl.updateRuleSetAccount(account)" ng-model="account.text"
                    label-type="plain"></salaxy-input>
                </td>
                <td class="right">
                  <button title="{{'SALAXY.UI_Terms.deleteRow' | sxyTranslate}}" class="btn btn-transparent" type="button" ng-if="!account.isReadOnly"
                    ng-click="$ctrl.removeAccount(account, true)">
                    <i class="bi bi-trash-fill"></i>
                  </button>
                </td>
              </tr>
              <tr ng-if="$ctrl.hasTargetCoA">
                <td></td>
                <td></td>
                <td class="right">
                  <button title="{{'SALAXY.UI_Terms.addRow' | sxyTranslate}}" class="btn btn-primary btn-sm" type="button" ng-click="$ctrl.addTargetCoaAccount(true)"
                    sxy-text="SALAXY.UI_Terms.addRow"></button>
                </td>
              </tr>
            </tbody>
            <tfoot>
            </tfoot>
          </table>
        </div>
      </div>
      <div class="tab-pane" id="accounts-tab">
        <div class="btn-group btn-group-sm dropdown">
          <button id="single-button2" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown" ng-disabled="disabled">
            <span sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.filters.rowsToShow" ps=":"></span> {{$ctrl.accountFilterText | sxyTranslate}}
          </button>
          <ul class="dropdown-menu" role="menu" aria-labelledby="single-button2">
            <li role="menuitem">
              <a href="" ng-click="$ctrl.accountFilter = 'all'" class="dropdown-item" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.filters.all"></a>
            </li>
            <li role="menuitem">
              <a href="" ng-click="$ctrl.accountFilter = 'includedAndEnabled'" class="dropdown-item" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.filters.includedAndEnabled"></a>
            </li>
            <li role="menuitem">
              <a href="" ng-click="$ctrl.accountFilter = 'error'" class="dropdown-item" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.filters.error"></a>
            </li>
          </ul>
        </div>
        <button class="btn btn-default btn-sm ms-1" ng-click="$ctrl.showDistinct = !$ctrl.showDistinct">{{$ctrl.showDistinct ?
          ('SALAXY.NG1.AccountingTargetDetailsComponent.filters.showNormal' | sxyTranslate) : "SALAXY.NG1.AccountingTargetDetailsComponent.filters.showDistinct" |
          sxyTranslate}}</button>
        <div ng-if="$ctrl.showDistinct && !$ctrl.distinctAccounts.length || !$ctrl.showDistinct && !$ctrl.filteredAccounts.length">
            <p sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.filters.noRows"></p>
        </div>
        <div class="table-responsive" ng-if="!$ctrl.showDistinct && $ctrl.filteredAccounts.length">
          <table class="table table-sm">
            <thead>
              <tr>
                <th></th>
                <th sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.accountNumber"></th>
                <th sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.name"></th>
                <th class="right">
                  <button ng-disabled="$ctrl.isReadOnly" title="{{'SALAXY.UI_Terms.addRow' | sxyTranslate}}" class="btn btn-primary btn-sm" type="button"
                    ng-click="$ctrl.addAccount(false)" sxy-text="SALAXY.UI_Terms.addRow"></button>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr ng-repeat="account in $ctrl.filteredAccounts">
                <td class="middle">
                  <div class="text-center" ng-if="!$ctrl.isValidAccount(account)" data-toggle="tooltip" data-placement="top" data-bs-title="'SALAXY.NG1.AccountingTargetDetailsComponent.noAccountNumberFound' | sxyTranslate" sxy-bs5-tooltip>
                    <i class="bi bi-exclamation-circle-fill text-danger"></i>
                  </div>
                </td>
                <td>
                  <salaxy-input read-only="$ctrl.isReadOnly" name="{{'accountAccount'+$index}}" ng-change="$ctrl.updateAccountToMatchTargetCoa(account)" ng-model="account.account" label-type="plain"></salaxy-input>
                </td>
                <td>
                  <salaxy-input read-only="true" name="{{'accountText'+$index}}" ng-model="account.text" label-type="plain"></salaxy-input>
                </td>
                <td class="right">
                  <button title="{{'SALAXY.UI_Terms.deleteRow' | sxyTranslate}}" class="btn btn-transparent" type="button" ng-if="!account.isReadOnly"
                    ng-click="$ctrl.removeAccount(account)">
                    <i class="bi bi-trash-fill"></i>
                  </button>
                  <button ng-disabled="$ctrl.isReadOnly" title="{{'SALAXY.NG1.AccountingTargetDetailsComponent.changeAccount' | sxyTranslate}}" class="btn btn-transparent"
                    type="button" ng-click="$ctrl.selectTargetAccount(account)" ng-if="$ctrl.hasTargetCoA">
                    <i class="bi bi-pencil-fill"></i>
                  </button>
                </td>
              </tr>
              <tr ng-if="$ctrl.current.ruleSet.accounts.length">
                <td></td>
                <td></td>
                <td></td>
                <td class="right">
                  <button ng-disabled="$ctrl.isReadOnly" title="{{'SALAXY.UI_Terms.addRow' | sxyTranslate}}" class="btn btn-primary btn-sm" type="button"
                    ng-click="$ctrl.addAccount(true)" sxy-text="SALAXY.UI_Terms.addRow"></button>
                </td>
              </tr>
            </tbody>
            <tfoot>
            </tfoot>
          </table>
        </div>
        <div class="table-responsive" ng-if="$ctrl.showDistinct && $ctrl.distinctAccounts.length">
          <table class="table table-sm">
            <thead>
              <tr>
                <th sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.accountNumber"></th>
                <th sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.name"></th>
                <th sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.ruleCount"></th>
              </tr>
            </thead>
            <tbody>
              <tr ng-repeat="account in $ctrl.distinctAccounts">
                <td>
                  <salaxy-input read-only="true" name="{{'accountAccount'+$index}}" ng-model="account.account" label-type="plain"></salaxy-input>
                </td>
                <td>
                  <salaxy-input read-only="true" name="{{'accountText'+$index}}" ng-model="account.text" label-type="plain">
                  </salaxy-input>
                </td>
                <td>{{$ctrl.getRulesCount(account.account)}}</td>
              </tr>
            </tbody>
            <tfoot>
            </tfoot>
          </table>
        </div>
      </div>
      <div class="tab-pane" id="guidelines-tab">
        <div sxy-html="SALAXY.NG1.AccountingTargetDetailsComponent.guidelinesInfo.html"></div>
      </div>
      <div class="tab-pane" id="rules-tab">
        <div class="btn-toolbar" role="toolbar" aria-label="{{'SALAXY.NG1.AccountingTargetDetailsComponent.accounts' | sxyTranslate}}">
          <div class="btn-group" role="group" aria-label="{{'SALAXY.NG1.AccountingTargetDetailsComponent.sorting' | sxyTranslate}}" ng-init="$ctrl.ruleViewSorting = 'default'">
            <salaxy-toggle-buttons ng-model="$ctrl.ruleViewSorting" options="[
              { value: 'default', label: 'SALAXY.NG1.AccountingTargetDetailsComponent.sortDefault' },
              { value: 'byAccountPairs', label: 'SALAXY.NG1.AccountingTargetDetailsComponent.sortByAccountPairs' },
              { value: 'byAccount', label: 'SALAXY.NG1.AccountingTargetDetailsComponent.sortByAccount' }
              ]" type="inline"></salaxy-toggle-buttons>
          </div>
        </div>
        <div ng-if="$ctrl.currentTab == 'rules'">
          <ng-include
            src="'salaxy-components/settings/AccountingTargetEditorRulesTable' + ($ctrl.ruleViewSorting == 'byAccountPairs' ? 2 : $ctrl.ruleViewSorting == 'byAccount' ? 3 : 1) + '.html'">
          </ng-include>
        </div>
      </div>
      <div class="tab-pane" id="accountingquery-tab">
        <ng-include src="'salaxy-components/settings/AccountingTargetEditorQuery.html'"></ng-include>
      </div>
      <div class="tab-pane" id="debugger-tab" ng-if="'test' | sxyIsInRole">
        <salaxy-json-formatter json="$ctrl.current"></salaxy-json-formatter>
      </div>
    </div>
  </div>
</div>`), s.put("salaxy-components/settings/AccountingTargetEditorQuery.html", `<div class="salaxy-component salaxy-accounting-report-query" ng-controller="AccountingReportQueryController as $ctrlQuery" ng-init="$ctrlQuery.queryType = 'selectionQuery'">
  <form name="queryForm" class="form-horizontal">
    <fieldset>
      <div class="col col-md-6">
        <p>
          <span class="label label-primary" ng-if="$ctrlQuery.calculations.length">
            <span sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.editorQuery.selectedAmount" ps=":"></span>{{ $ctrlQuery.calculations.length }}
          </span>
        </p>
        <div class="btn-toolbar" role="toolbar">
          <button class="btn btn-default" ng-click="$ctrlQuery.addCalcs('draft')" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.editorQuery.addDraftBtn"></button>
        </div>
      </div>
    </fieldset>
    <div class="col col-md-12">
      <div ng-if="$ctrlQuery.calculations.length" class="table-responsive salaxy-odata-table">
        <table class="table table-striped">
          <thead>
            <tr>
              <th colspan="2">
                <span sxy-text="SALAXY.NG1_Other.Roles.worker"></span>
              </th>
              <th class="hidden-xxs">
                <span sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.editorQuery.status"></span><br />
                <span sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.editorQuery.date"></span>
              </th>
              <th class="right hidden-xxs">
                <span sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.editorQuery.salary"></span><br />
                <span sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.editorQuery.payment"></span>
              </th>
              <th class="hidden-xxs"></th>
            </tr>
          </thead>
          <tbody>
            <tr ng-repeat="row in $ctrlQuery.calculations">
              <td class="td-avatar visible-xxs middle">
                <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
              </td>
              <td class="td-name visible-xxs middle">
                <span ng-if="row.otherPartyInfo.avatar.displayName == ''" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.editorQuery.notSelected"></span>
                <strong>{{row.otherPartyInfo.avatar.displayName}}</strong><br /> {{ "SALAXY.ENUM.CalculationStatus." + row.status + ".label" | sxyTranslate }}
                <br /> {{ row.endAt | date }}
              </td>
              <td class="right visible-xxs bottom">
                <div>
                  {{ row.grossSalary | currency }}<br /> {{ row.payment | currency }}
                </div>
              </td>
              <td class="td-avatar hidden-xxs middle">
                <salaxy-avatar avatar="row.otherPartyInfo.avatar"></salaxy-avatar>
              </td>
              <td class="td-name hidden-xxs middle">
                <span ng-if="row.otherPartyInfo.avatar.displayName == ''" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.editorQuery.notSelected"></span>
                <strong>{{row.otherPartyInfo.avatar.displayName}}</strong><br />
              </td>
              <td class="hidden-xxs middle">
                {{ row.status ? ("SALAXY.ENUM.CalculationStatus." + row.status + ".label" | sxyTranslate) : "#ERR" }}<br /> {{ row.endAt | date }}
              </td>
              <td class="right hidden-xxs middle">
                {{ row.grossSalary | currency }}<br /> {{ row.payment | currency }}
              </td>
              <td class="right middle">
                <button class="btn btn-sm  btn-danger" type="button" ng-click="$ctrlQuery.removeCalc(row)">
                        {{ 'SALAXY.NG1.AccountingTargetDetailsComponent.editorQuery.unselect' | sxyTranslate }}
                      </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </form>
  <div class="col col-md-12 text-end">
    <button class="btn btn-primary" ng-disabled="!queryForm.$valid || !$ctrlQuery.calculations.length" ng-click="$ctrlQuery.queryData($ctrl.current.id)" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.editorQuery.fetchRowsBtn"></button>
  </div>
  <salaxy-accounting-report-rows data="$ctrlQuery.data"></salaxy-accounting-report-rows>
</div>`), s.put("salaxy-components/settings/AccountingTargetEditorRulesTable1.html", `<div class="table-responsive">
  <table class="table table-sm">
    <thead>
      <tr>
        <th sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.incomeTypeHead"></th>
        <th sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.additionalSelectionsHead"></th>
        <th>
          <div sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.includeHead"></div>
          <div sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.enabledHead"></div>
        </th>
        <th sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.debetHead"></th>
        <th sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.creditHead"></th>
        <th class="right">
          <button ng-disabled="$ctrl.isReadOnly" title="{{'SALAXY.UI_Terms.addRow'| sxyTranslate}}" class="btn btn-primary btn-sm" type="button" ng-click="$ctrl.addRow(null, true)" sxy-text="SALAXY.UI_Terms.addRow"></button>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat-start="ruleSetRow in $ctrl.current.ruleSet.rows">
        <td>{{$ctrl.getEntryDescription(ruleSetRow)}}</td>
        <td>
          <div ng-repeat="flag in ruleSetRow.flags">
            <span class="badge" ng-class="$ctrl.getFlagText(flag).found ? 'bg-success' : 'bg-warning'">{{$ctrl.getFlagText(flag).text}}</span>
          </div>
        </td>
        <td>
          <div ng-class="{ 'text-danger': !ruleSetRow.isIncluded }">{{ ruleSetRow.isIncluded ? ('SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.included'| sxyTranslate) : ('SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.excluded'| sxyTranslate) }}</div>
          <div ng-class="{ 'text-danger': !ruleSetRow.enabled }">{{ ruleSetRow.enabled ? ('SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.enabled'| sxyTranslate) : ('SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.disabled'| sxyTranslate) }}</div>
        </td>
        <td ng-if="ruleSetRow.isIncluded">
          <div>
            {{ $ctrl.getAccount(ruleSetRow.debitId).account || ('SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.debitUndefined'| sxyTranslate) }}
            <span ng-if="ruleSetRow.debitGrouping">
              <span>{{ ruleSetRow.debitGrouping }}</span>
            <small style="text-decoration: line-through">{{ $ctrl.getAccount(ruleSetRow.debitId).text }}</small>
            </span>
            <span ng-if="!ruleSetRow.debitGrouping">
              <span>{{ $ctrl.getAccount(ruleSetRow.debitId).text }}</span>
            </span>
          </div>
        </td>
        <td ng-if="ruleSetRow.isIncluded">
          <div>
            {{ $ctrl.getAccount(ruleSetRow.creditId).account || ('SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.creditUndefined'| sxyTranslate) }}
            <span ng-if="ruleSetRow.creditGrouping">
              <span>{{ ruleSetRow.creditGrouping }}</span>
            <small style="text-decoration: line-through">{{ $ctrl.getAccount(ruleSetRow.creditId).text }}</small>
            </span>
            <span ng-if="!ruleSetRow.creditGrouping">
              <span>{{ $ctrl.getAccount(ruleSetRow.creditId).text }}</span>
            </span>
          </div>
        </td>
        <td colspan="2" ng-if="!ruleSetRow.isIncluded" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.notIncluded"></td>
        <td class="right">
          <div class="btn-group">
            <button ng-disabled="$ctrl.isReadOnly" title="{{'SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.editRule' | sxyTranslate}}" class="btn btn-sm" ng-class="{ 'btn-primary': !ruleSetRow.isInEdit, 'btn-default': ruleSetRow.isInEdit }" type="button"
              ng-click="ruleSetRow.isInEdit=!ruleSetRow.isInEdit">
              <i class="bi bi-pencil-square"></i>
            </button>
            <button ng-disabled="$ctrl.isReadOnly" title="{{'SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.copyAsNewRule' | sxyTranslate}}" class="btn btn-default btn-sm" type="button" ng-click="$ctrl.addRow(ruleSetRow)">
              <i class="bi bi-copy"></i>
            </button>
          </div>
        </td>
      </tr>
      <tr ng-repeat-end ng-if="ruleSetRow.isInEdit">
        <td>
          <button title="{{'SALAXY.UI_Terms.change' | sxyTranslate}}" class="btn btn-sm btn-default" type="button" ng-click="$ctrl.selectEntry(ruleSetRow)" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.changeIncomeTypeBtn"></button>
        </td>
        <td>
          <button title="{{'SALAXY.UI_Terms.edit' | sxyTranslate}}" class="btn btn-sm btn-default" type="button" ng-click="$ctrl.selectFlags(ruleSetRow)" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.editAdditionalsBtn"></button>
        </td>
        <td>
          <salaxy-input-boolean type="checkbox" name="{{'ruleSetIsIncluded'+$index}}" ng-model="ruleSetRow.isIncluded" label-type="plain" label-true="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.includeHead">
          </salaxy-input-boolean>
          <salaxy-input-boolean type="checkbox" name="{{'ruleSetEnabled'+$index}}" ng-model="ruleSetRow.enabled" label-type="plain" label-true="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.enabledHead"></salaxy-input-boolean>
        </td>
        <td>
          <div ng-if="ruleSetRow.isIncluded">
            <button title="{{'SALAXY.UI_Terms.change' | sxyTranslate}}" ng-disabled="!ruleSetRow.isIncluded" class="btn btn-default btn-sm btn-block" type="button" ng-click="$ctrl.selectAccount(ruleSetRow, false)" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.changeAccountBtn"></button>
            <salaxy-input name="{{'debitGrouping'+$index}}" placeholder="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.grouping" label-type="plain" ng-model="ruleSetRow.debitGrouping"></salaxy-input>
          </div>
        </td>
        <td>
          <div ng-if="ruleSetRow.isIncluded">
            <button title="{{'SALAXY.UI_Terms.change' | sxyTranslate}}" ng-disabled="!ruleSetRow.isIncluded" class="btn btn-default btn-sm btn-block" type="button" ng-click="$ctrl.selectAccount(ruleSetRow, true)" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.changeAccountBtn"></button>
            <salaxy-input name="{{'creditGrouping'+$index}}" placeholder="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.grouping" label-type="plain" ng-model="ruleSetRow.creditGrouping"></salaxy-input>
          </div>
        </td>
        <td class="right">
          <button title="{{'SALAXY.UI_Terms.deleteRow' | sxyTranslate}}" class="btn btn-danger btn-sm" type="button" ng-disabled="ruleSetRow.isReadOnly" ng-click="$ctrl.removeRow(ruleSetRow)" sxy-text="SALAXY.UI_Terms.deleteRow"></button>
        </td>
      </tr>
      <tr>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td class="right">
          <button ng-disabled="$ctrl.isReadOnly" title="{{'SALAXY.UI_Terms.addRow' | sxyTranslate}}" class="btn btn-primary btn-sm" type="button" ng-click="$ctrl.addRow(null)" sxy-text="SALAXY.UI_Terms.addRow"></button>
        </td>
      </tr>
    </tbody>
  </table>
</div>`), s.put("salaxy-components/settings/AccountingTargetEditorRulesTable2.html", `<div class="table-responsive">
  <table class="table table-sm">
    <thead>
      <tr>
        <th sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.debetHead"></th>
        <th sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.creditHead"></th>
        <th></th>
        <th></th>
        <th class="right">
          <button ng-disabled="true" title="{{'SALAXY.UI_Terms.addRow'| sxyTranslate}}" class="btn btn-primary btn-sm" type="button" ng-click="$ctrl.addRow(null, true)" sxy-text="SALAXY.UI_Terms.addRow"></button>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat-start="(key, ruleSetGroup) in $ctrl.groupedRows" class="primary">
        <td ng-if="ruleSetGroup[0].isIncluded">
          <div>
            {{ $ctrl.getAccount(ruleSetGroup[0].debitId).account || ('SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.debitUndefined'| sxyTranslate) }}
            <span ng-if="ruleSetGroup[0].debitGrouping">
              <span>{{ ruleSetGroup[0].debitGrouping }}</span>
            <small style="text-decoration: line-through">{{ $ctrl.getAccount(ruleSetGroup[0].debitId).text }}</small>
            </span>
            <span ng-if="!ruleSetGroup[0].debitGrouping">
              <span>{{ $ctrl.getAccount(ruleSetGroup[0].debitId).text }}</span>
            </span>
          </div>
        </td>
        <td ng-if="ruleSetGroup[0].isIncluded">
          <div>
            {{ $ctrl.getAccount(ruleSetGroup[0].creditId).account || ('SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.creditUndefined'| sxyTranslate) }}
            <span ng-if="ruleSetGroup[0].creditGrouping">
              <span>{{ ruleSetGroup[0].creditGrouping }}</span>
            <small style="text-decoration: line-through">{{ $ctrl.getAccount(ruleSetGroup[0].creditId).text }}</small>
            </span>
            <span ng-if="!ruleSetGroup[0].creditGrouping">
              <span>{{ $ctrl.getAccount(ruleSetGroup[0].creditId).text }}</span>
            </span>
          </div>
        </td>
        <td colspan="2" ng-if="!ruleSetGroup[0].isIncluded" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.notIncluded"></td>
        <td colspan="4"></td>
      </tr>
      <tr ng-repeat-start="ruleSetRow in ruleSetGroup">
        <td colspan="2">{{$ctrl.getEntryDescription(ruleSetRow)}}</td>
        <td>
          <div ng-repeat="flag in ruleSetRow.flags">
            <span class="badge" ng-class="$ctrl.getFlagText(flag).found ? 'bg-success' : 'bg-warning'">{{$ctrl.getFlagText(flag).text}}</span>
          </div>
        </td>
        <td>
          <div ng-class="{ 'text-danger': !ruleSetRow.enabled }">{{ ruleSetRow.enabled ? ('SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.enabled'| sxyTranslate) : ('SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.disabled'| sxyTranslate) }}</div>
        </td>
        <td class="right">
          <div class="btn-group">
            <button ng-disabled="$ctrl.isReadOnly" title="{{'SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.editRule' | sxyTranslate}}" class="btn btn-sm" ng-class="{ 'btn-primary': !ruleSetRow.isInEdit, 'btn-default': ruleSetRow.isInEdit }" type="button"
              ng-click="ruleSetRow.isInEdit=!ruleSetRow.isInEdit">
              <i class="bi bi-pencil-square"></i>
            </button>
            <button ng-disabled="$ctrl.isReadOnly" title="{{'SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.copyAsNewRule' | sxyTranslate}}" class="btn btn-default btn-sm" type="button" ng-click="$ctrl.addRow(ruleSetRow)">
              <i class="bi bi-copy"></i>
            </button>
          </div>
        </td>
      </tr>
      <tr ng-repeat-end ng-if="ruleSetRow.isInEdit" class="no-border">
        <td>
          <div ng-if="!ruleSetRow.isIncluded">
            <small sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.notIncluded"></small>
          </div>
          <div ng-if="ruleSetRow.isIncluded">
            <div class="input-group">
              <input type="text" class="form-control" ng-value="$ctrl.getAccount(ruleSetRow.debitId).account + ' ' + $ctrl.getAccount(ruleSetRow.debitId).text" disabled="true">
              <span class="input-group-btn">
                <button class="btn btn-default fixed-width-addon" type="button" ng-click="$ctrl.selectAccount(ruleSetRow, false)" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.changeAccountBtn"></button>
              </span>
            </div>
            <div class="input-group">
              <input type="text" class="form-control" ng-init="ruleSetRow.debitGroupingTemp = ruleSetRow.debitGrouping" ng-model="ruleSetRow.debitGroupingTemp" placeholder="{{'SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.addGrouping' | sxyTranslate}}">
              <span class="input-group-btn">
                <button class="btn btn-default fixed-width-addon" type="button" ng-click="ruleSetRow.debitGrouping = ruleSetRow.debitGroupingTemp" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.changeGroupingBtn"></button>
              </span>
            </div>
          </div>
        </td>
        <td>
          <div ng-if="!ruleSetRow.isIncluded">
            <small sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.notIncluded"></small>
          </div>
          <div ng-if="ruleSetRow.isIncluded">
            <div class="input-group">
              <input type="text" class="form-control" ng-value="$ctrl.getAccount(ruleSetRow.creditId).account + ' ' + $ctrl.getAccount(ruleSetRow.creditId).text" disabled="true">
              <span class="input-group-btn">
                <button class="btn btn-default fixed-width-addon" type="button" ng-click="$ctrl.selectAccount(ruleSetRow, true)" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.changeAccountBtn"></button>
              </span>
            </div>
            <div class="input-group">
              <input type="text" class="form-control" ng-init="ruleSetRow.creditGroupingTemp = ruleSetRow.creditGrouping" ng-model="ruleSetRow.creditGroupingTemp" placeholder="{{'SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.addGrouping' | sxyTranslate}}">
              <span class="input-group-btn">
                <button class="btn btn-default fixed-width-addon" type="button" ng-click="ruleSetRow.creditGrouping = ruleSetRow.creditGroupingTemp" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.changeGroupingBtn"></button>
              </span>
            </div>
          </div>
        </td>
        <td>
          <button title="{{'SALAXY.UI_Terms.change' | sxyTranslate}}" class="btn btn-default fixed-width-button" type="button" ng-click="$ctrl.selectEntry(ruleSetRow)">
            <span sxy-text="SALAXY.UI_Terms.change"></span> {{ ruleSetRow.entryCodeGroup == 'incomeType' ? ('SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.incomeTypeBtnPS' | sxyTranslate) : ('SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.calcRowBtnPS' | sxyTranslate) }}
          </button>
          <button title="{{'SALAXY.UI_Terms.edit' | sxyTranslate}}" class="btn btn-default fixed-width-button" type="button" ng-click="$ctrl.selectFlags(ruleSetRow)" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.editAdditionalsBtn"></button>
        </td>
        <td>
          <salaxy-input-boolean type="checkbox" name="{{'ruleSetIsIncluded'+$index}}" ng-model="ruleSetRow.isIncluded" label-type="plain" label-true="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.includeHead">
          </salaxy-input-boolean>
          <salaxy-input-boolean type="checkbox" name="{{'ruleSetEnabled'+$index}}" ng-model="ruleSetRow.enabled" label-type="plain" label-true="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.enabledHead"></salaxy-input-boolean>
        </td>
        <td class="right">
          <button title="{{'SALAXY.UI_Terms.deleteRow' | sxyTranslate}}" class="btn btn-danger btn-sm" ng-disabled="ruleSetRow.isReadOnly" type="button" ng-disabled="ruleSetRow.isReadOnly" ng-click="$ctrl.removeRow(ruleSetRow)" sxy-text="SALAXY.UI_Terms.deleteRow"></button>
        </td>
      </tr>
      <tr ng-repeat-end></tr>
      <tr>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td class="right">
          <button ng-disabled="true" title="{{'SALAXY.UI_Terms.addRow' | sxyTranslate}}" class="btn btn-primary btn-sm" type="button" ng-click="$ctrl.addRow(null)" sxy-text="SALAXY.UI_Terms.addRow"></button>
        </td>
      </tr>
    </tbody>
  </table>
</div>`), s.put("salaxy-components/settings/AccountingTargetEditorRulesTable3.html", `<div class="table-responsive">
  <table class="table table-sm">
    <thead>
      <tr>
        <th sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.accountsHead"></th>
        <th></th>
        <th></th>
      </tr>
      <tr>
        <th></th>
        <th sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.debetHead"></th>
        <th sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.creditHead"></th>
        <th></th>
        <th class="right">
          <button ng-disabled="true" title="{{'SALAXY.UI_Terms.addRow'| sxyTranslate}}" class="btn btn-primary btn-sm" type="button" ng-click="$ctrl.addRow(null, true)" sxy-text="SALAXY.UI_Terms.addRow"></button>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat-start="account in $ctrl.current.ruleSet.accounts" class="primary">
        <td>
          {{account.account}} {{account.text}}
        </td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
      <tr ng-repeat-start="ruleSetRow in $ctrl.getRulesetByAccount(account, true)">
        <td></td>
        <td>
          {{$ctrl.getEntryDescription(ruleSetRow)}}
        </td>
        <td></td>
        <td></td>
        <td class="right">
          <div class="btn-group">
            <button ng-disabled="$ctrl.isReadOnly" title="{{'SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.editRule' | sxyTranslate}}" class="btn btn-sm" ng-class="{ 'btn-primary': !ruleSetRow.isInEdit, 'btn-default': ruleSetRow.isInEdit }" type="button"
              ng-click="ruleSetRow.isInEdit=!ruleSetRow.isInEdit">
                <i class="bi bi-pencil-square"></i>
              </button>
            <button ng-disabled="$ctrl.isReadOnly" title="{{'SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.copyAsNewRule' | sxyTranslate}}" class="btn btn-default btn-sm" type="button" ng-click="$ctrl.addRow(ruleSetRow)">
                <i class="bi bi-copy"></i>
              </button>
          </div>
        </td>
      </tr>
      <tr ng-if="ruleSetRow.isInEdit">
        <td>
          <div ng-if="!ruleSetRow.isIncluded">
            <small sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.notIncluded"></small>
          </div>
          <div ng-if="ruleSetRow.isIncluded">
            <div class="input-group">
              <input type="text" class="form-control" ng-value="$ctrl.getAccount(ruleSetRow.debitId).account + ' ' + $ctrl.getAccount(ruleSetRow.debitId).text" disabled="true">
              <span class="input-group-btn">
                  <button class="btn btn-default fixed-width-addon" type="button" ng-click="$ctrl.selectAccount(ruleSetRow, false)" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.changeAccountBtn"></button>
                </span>
            </div>
            <div class="input-group">
              <input type="text" class="form-control" ng-init="ruleSetRow.debitGroupingTemp = ruleSetRow.debitGrouping" ng-model="ruleSetRow.debitGroupingTemp" placeholder="{{'SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.addGrouping' | sxyTranslate}}">
              <span class="input-group-btn">
                  <button class="btn btn-default fixed-width-addon" type="button" ng-click="ruleSetRow.debitGrouping = ruleSetRow.debitGroupingTemp" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.changeGroupingBtn"></button>
                </span>
            </div>
          </div>
        </td>
        <td>
          <div ng-if="!ruleSetRow.isIncluded">
            <small sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.notIncluded"></small>
          </div>
          <div ng-if="ruleSetRow.isIncluded">
            <div class="input-group">
              <input type="text" class="form-control" ng-value="$ctrl.getAccount(ruleSetRow.creditId).account + ' ' + $ctrl.getAccount(ruleSetRow.creditId).text" disabled="true">
              <span class="input-group-btn">
                  <button class="btn btn-default fixed-width-addon" type="button" ng-click="$ctrl.selectAccount(ruleSetRow, true)"  sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.changeAccountBtn"></button>
                </span>
            </div>
            <div class="input-group">
              <input type="text" class="form-control" ng-init="ruleSetRow.creditGroupingTemp = ruleSetRow.creditGrouping" ng-model="ruleSetRow.creditGroupingTemp" placeholder="{{'SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.addGrouping' | sxyTranslate}}">
              <span class="input-group-btn">
                  <button class="btn btn-default fixed-width-addon" type="button" ng-click="ruleSetRow.creditGrouping = ruleSetRow.creditGroupingTemp" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.changeGroupingBtn"></button>
                </span>
            </div>
          </div>
        </td>
        <td></td>
        <td>
          <button title="{{'SALAXY.UI_Terms.change' | sxyTranslate}}" class="btn btn-default fixed-width-button" type="button" ng-click="$ctrl.selectEntry(ruleSetRow)">
            <span sxy-text="SALAXY.UI_Terms.change"></span> {{ ruleSetRow.entryCodeGroup == 'incomeType' ? ('SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.incomeTypeBtnPS' | sxyTranslate) : ('SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.calcRowBtnPS' | sxyTranslate) }}
            </button>
          <button title="{{'SALAXY.UI_Terms.edit' | sxyTranslate}}" class="btn btn-default fixed-width-button" type="button" ng-click="$ctrl.selectFlags(ruleSetRow)" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.editAdditionalsBtn"></button>
        </td>
        <td>
          <salaxy-input-boolean type="checkbox" name="{{'ruleSetIsIncluded'+$index}}" ng-model="ruleSetRow.isIncluded" label-type="plain" label-true="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.includeHead">
          </salaxy-input-boolean>
          <salaxy-input-boolean type="checkbox" name="{{'ruleSetEnabled'+$index}}" ng-model="ruleSetRow.enabled" label-type="plain" label-true="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.enabledHead"></salaxy-input-boolean>
          <button title="Poista rivi" ng-disabled="ruleSetRow.isReadOnly" class="btn btn-danger btn-sm" type="button" ng-click="$ctrl.removeRow(ruleSetRow)" sxy-text="SALAXY.UI_Terms.deleteRow"></button>
        </td>
      </tr>
      <tr ng-repeat-end></tr>
      <tr ng-repeat-start="ruleSetRow in $ctrl.getRulesetByAccount(account, false)">
        <td></td>
        <td></td>
        <td>
          {{$ctrl.getEntryDescription(ruleSetRow)}}
        </td>
        <td></td>
        <td class="right">
          <div class="btn-group">
            <button ng-disabled="$ctrl.isReadOnly" ttitle="{{'SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.editRule' | sxyTranslate}}" class="btn btn-sm" ng-class="{ 'btn-primary': !ruleSetRow.isInEdit, 'btn-default': ruleSetRow.isInEdit }" type="button"
              ng-click="ruleSetRow.isInEdit=!ruleSetRow.isInEdit">
              <i class="bi bi-pencil-square"></i>
            </button>
            <button ng-disabled="$ctrl.isReadOnly" title="{{'SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.copyAsNewRule' | sxyTranslate}}" class="btn btn-default btn-sm" type="button" ng-click="$ctrl.addRow(ruleSetRow)">
              <i class="bi bi-copy"></i>
            </button>
          </div>
        </td>
      </tr>
      <tr ng-if="ruleSetRow.isInEdit">
        <td>
          <div ng-if="!ruleSetRow.isIncluded">
            <small sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.notIncluded"></small>
          </div>
          <div ng-if="ruleSetRow.isIncluded">
            <div class="input-group">
              <input type="text" class="form-control" ng-value="$ctrl.getAccount(ruleSetRow.debitId).account + ' ' + $ctrl.getAccount(ruleSetRow.debitId).text" disabled="true">
              <span class="input-group-btn">
                  <button class="btn btn-default fixed-width-addon" type="button" ng-click="$ctrl.selectAccount(ruleSetRow, false)" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.changeAccountBtn"></button>
                </span>
            </div>
            <div class="input-group">
              <input type="text" class="form-control" ng-init="ruleSetRow.debitGroupingTemp = ruleSetRow.debitGrouping" ng-model="ruleSetRow.debitGroupingTemp" placeholder="{{'SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.addGrouping' | sxyTranslate}}">
              <span class="input-group-btn">
                  <button class="btn btn-default fixed-width-addon" type="button" ng-click="ruleSetRow.debitGrouping = ruleSetRow.debitGroupingTemp" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.changeGroupingBtn"></button>
                </span>
            </div>
          </div>
        </td>
        <td>
          <div ng-if="!ruleSetRow.isIncluded">
            <small sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.notIncluded"></small>
          </div>
          <div ng-if="ruleSetRow.isIncluded">
            <div class="input-group">
              <input type="text" class="form-control" ng-value="$ctrl.getAccount(ruleSetRow.creditId).account + ' ' + $ctrl.getAccount(ruleSetRow.creditId).text" disabled="true">
              <span class="input-group-btn">
                  <button class="btn btn-default fixed-width-addon" type="button" ng-click="$ctrl.selectAccount(ruleSetRow, true)" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.changeAccountBtn"></button>
                </span>
            </div>
            <div class="input-group">
              <input type="text" class="form-control" ng-init="ruleSetRow.creditGroupingTemp = ruleSetRow.creditGrouping" ng-model="ruleSetRow.creditGroupingTemp" placeholder="{{'SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.addGrouping' | sxyTranslate}}">
              <span class="input-group-btn">
                  <button class="btn btn-default fixed-width-addon" type="button" ng-click="ruleSetRow.creditGrouping = ruleSetRow.creditGroupingTemp" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.changeGroupingBtn"></button>
                </span>
            </div>
          </div>
        </td>
        <td>
          <button title="{{'SALAXY.UI_Terms.change' | sxyTranslate}}" class="btn btn-default fixed-width-button" type="button" ng-click="$ctrl.selectEntry(ruleSetRow)">
            <span sxy-text="SALAXY.UI_Terms.change"></span> {{ ruleSetRow.entryCodeGroup == 'incomeType' ? ('SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.incomeTypeBtnPS' | sxyTranslate) : ('SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.calcRowBtnPS' | sxyTranslate) }}
            </button>
          <button title="{{'SALAXY.UI_Terms.edit' | sxyTranslate}}" class="btn btn-default fixed-width-button" type="button" ng-click="$ctrl.selectFlags(ruleSetRow)" sxy-text="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.editAdditionalsBtn"></button>
        </td>
        <td>
          <salaxy-input-boolean type="checkbox" name="{{'ruleSetIsIncluded'+$index}}" ng-model="ruleSetRow.isIncluded" label-type="plain" label-true="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.includeHead">
          </salaxy-input-boolean>
          <salaxy-input-boolean type="checkbox" name="{{'ruleSetEnabled'+$index}}" ng-model="ruleSetRow.enabled" label-type="plain" label-true="SALAXY.NG1.AccountingTargetDetailsComponent.rulesTables.enabledHead"></salaxy-input-boolean>
          <button title="{{'SALAXY.UI_Terms.deleteRow' | sxyTranslate}}" ng-disabled="ruleSetRow.isReadOnly" class="btn btn-danger btn-sm" type="button" ng-click="$ctrl.removeRow(ruleSetRow)">
              Poista rivi
            </button>
        </td>
      </tr>
      <tr ng-repeat-end>

      </tr>
      <tr ng-repeat-end></tr>
      <tr>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td class="right">
          <button ng-disabled="true" title="{{'SALAXY.UI_Terms.addRow' | sxyTranslate}}" class="btn btn-primary btn-sm" type="button" ng-click="$ctrl.addRow(null)" sxy-text="SALAXY.UI_Terms.addRow"></button>
        </td>
      </tr>
    </tbody>
  </table>
</div>`), s.put("salaxy-components/settings/AccountingTargetSettings.html", `<div class="content settings" ng-if="$ctrl.current">
  <div class="card accounting-target-settings card-default">
    <sxy-form open-api="salaxy-secure/schemas/v02.json" type="CompanyAccountSettings" auto-gen="false" debugger="false" model="$ctrl.current">
      <div class="card-header icon-card">
        <h2 sxy-text="SALAXY.NG1.AccountingTargetSettings.title"></h2>
        <p ng-if="!(!$ctrl.current.accounting.denyServiceModel  && $ctrl.current.partner.serviceModel.features.accounting)"><small sxy-text="SALAXY.NG1.AccountingTargetSettings.intro"></small></p>
      </div>
      <div class="card-body">
        <fieldset>
          <legend><span sxy-text="SALAXY.NG1.AccountingTargetSettings.accountingLegend"></span></legend>
          <salaxy-input-typeahead name="options_type" ng-model="$ctrl.current.accounting.defaultTargetId" options="$ctrl.getSelectableAccountingTargets()"
            disable-cache="true" label="SALAXY.NG1.AccountingTargetSettings.defaultTarget"></salaxy-input-typeahead>
          <sxy-input template-url="salaxy-components/sxy-form/custom-templates/array-accounting-targets.html" model="form.accounting.targets" read-only="{{!$ctrl.current.accounting.denyServiceModel && $ctrl.current.partner.serviceModel.features.accounting}}">
            <form>
              <fieldset ng-show="!$ctrl.logic.showDelete" ng-controller="CompanySettingsController as $companySettingsCtrl" ng-init="$ctrl.logic.isReadOnly = true">
                <salaxy-odata-table  crud-controller="AccountingTargetCrudController as $crud" template-url="salaxy-components/odata/lists/AccountingTargetSelect.html" selected-items="$ctrl.selectedItems" on-list-select="$companySettingsCtrl.onAccountingTargetSelect($ctrl.current, $ctrl.logic, value, item, allItems)">
                </salaxy-odata-table>
              </fieldset>
              <fieldset ng-show="$ctrl.logic.showDelete" ng-init="$ctrl.logic.isReadOnly = false">
                <salaxy-input-enum disabled="false" name="format" label="SALAXY.NG1.AccountingTargetDetailsComponent.excelCsvFormat" ng-model="$ctrl.current.format"
                options="{
                  '36dff2e2-e181-4f0d-9004-0e4aa92f5e17': 'Palkkaus.fi',
                  '0db4e85f-93a8-46f1-b6d2-f7523d289d88': 'Fennoa',
                  '8613f133-3fce-4611-b372-51f6a2e007dd': 'Procountor',
                  'e62c10b0-222a-4170-b8b4-b1e02d9a7644': 'Passeli Merit',
                  '53fd3863-b8f9-4909-86c9-cb4597595181': 'Heeros',
                  '2fc7899c-7a3d-4d56-ad2f-05d52782bbbc': 'Asteri',
                  '0a2bd312-06da-4862-aef5-75166e0bf461': 'Maestro',
                  'c04e0757-63f3-420d-a183-3427710fc954': 'Visma Fivaldi',
                  'ba271dac-dd63-4036-9d70-053a09ca4d9e' :'Visma Netvisor',
                  '27e271d5-41f5-4319-ab29-4d5d9eb945c6': 'Lemonsoft',
                  'd311f9d3-8c3a-4fd8-a665-8e3698e41e87': 'Tampuuri',
                  'd58e95b7-d0b5-40ac-992b-6d3b29efc45e': 'Domus',
                  '54e93c5f-bd74-4157-8a74-3515be7f585d': 'Oscar Software',
                  '0e4f0a71-dcb9-43ba-9028-0239e674711f': 'Digia Enterprise',
                  '2ccefa46-7992-46c5-9d87-b88336935916': 'Digia Enterprise - VILPE'
                }">
                </salaxy-input-enum>
                <sxy-input model="form.method" read-only="false"></sxy-input>
                <salaxy-input-enum disabled="false" enum="ExportMethod" label="SALAXY.MODEL.AccountingTargetSettings.availableMethods.title" name="availableMethods" type="multi-select" ng-model="$ctrl.current.availableMethods"></salaxy-input-enum>
              </fieldset>
            </form>
          </sxy-input>
          <sxy-input model="form.accounting.defaultPeriodDateKind" read-only="{{!$ctrl.current.accounting.denyServiceModel  && $ctrl.current.partner.serviceModel.features.accounting}}"></sxy-input>
        </fieldset>
      </div>
      <div class="card-footer">
        <div class="row">
          <div class="col-12 text-end">
            <button class="btn btn-primary" ng-click="$ctrl.save('all')" ng-disabled="$ctrl.isSaving('all')"><span ng-if="$ctrl.isSaving('all')"><i class="bi bi-arrow-repeat bi-spin"></i></span> <span sxy-text="SALAXY.UI_Terms.save"></span></button>
          </div>
        </div>
      </div>
    </sxy-form>
  </div>
</div>`), s.put("salaxy-components/settings/CostAccountingSettings.html", `<div class="content settings" ng-if="$ctrl.current">
  <div class="card mb-4 costAccounting card-secondary">
    <div>
      <div class="card-header">
        <h2 sxy-text="SALAXY.MODEL.CostAccountingSettings.title"></h2>
        <p><small sxy-text="SALAXY.MODEL.CostAccountingSettings.descr"></small></p>
      </div>
      <div class="card-body">
        <div class="row">

          <sxy-form open-api="salaxy-secure/schemas/v02.json" type="CompanyAccountSettings" auto-gen="false" debugger="false" model="$ctrl.current"
            read-only="{{(!$ctrl.current.costAccounting.denyServiceModel && $ctrl.current.partner.serviceModel.features.costAccounting) || $ctrl.isReadOnlyForced}}">
            
            <div class="col form-horizontal">
              
              <sxy-input model="form.costAccounting.dimensions" include="id,label,scope">
                <form>
                  <fieldset>
                    <legend sxy-text="SALAXY.MODEL.CostAccountingDimensionDefinition.title"></legend>
                    <sxy-input model="form.id" read-only="{{$ctrl.logic.showDelete}}"></sxy-input>
                    <sxy-input model="form.label"></sxy-input>
                    <sxy-input model="form.allowCostSharing"></sxy-input>
                    <sxy-input model="form.scope"></sxy-input>
                    <sxy-input model="form.options" template-url="salaxy-components/sxy-form/custom-templates/cost-accounting-options.html"></sxy-input>
                  </fieldset>
                </form>
              </sxy-input> 
              
            </div>
          </sxy-form>
        </div>
      </div>
      <div class="card-footer">
        <div class="row">
          <div class="col">
            <button type="submit" ng-disabled="(!$ctrl.current.costAccounting.denyServiceModel && $ctrl.current.partner.serviceModel.features.costAccounting) ||$ctrl.isSaving('all')" class="btn btn-primary float-end" ng-click="$ctrl.save('all')"><span ng-if="$ctrl.isSaving('all')"><i
                  class="bi bi-arrow-repeat bi-spin"></i></span> <span sxy-text="SALAXY.UI_Terms.save"></span></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>`), s.put("salaxy-components/settings/HolidaySettings.html", `<div class="content settings" ng-if="$ctrl.current">
  <div class="card mb-4 accounting card-secondary">
    <div>
      <div class="card-header icon-card">
        <h2 sxy-text="SALAXY.MODEL.HolidaySettings.title"></h2>
      </div>
      <div class="card-body">
        <div class="row">

          <sxy-form ng-ref="$frm" open-api="salaxy-secure/schemas/v02.json" type="CompanyAccountSettings" auto-gen="false" debugger="false" model="$ctrl.current" read-only="{{!$ctrl.current.holidays.denyServiceModel  && $ctrl.current.partner.serviceModel.features.holidays}}">
            <div>
              <sxy-input model="form.partner.serviceModel.features.holiday" label="SALAXY.NG1.ProSettingsComponent.customHoliday" read-only="true"></sxy-input>
              <salaxy-input-boolean label="SALAXY.NG1.ProSettingsComponent.overwriteServiceModel" name="uc6" ng-change="$ctrl.confirmServiceModelChange()"
                ng-if="$ctrl.current.partner.serviceModel.features.holiday" ng-model="$ctrl.current.holiday.denyServiceModel"></salaxy-input-boolean>
              <sxy-input model="form.holiday.holidayPaySettings"
                read-only="{{!$ctrl.current.holiday.denyServiceModel  && $ctrl.current.partner.serviceModel.features.holiday }}" include="holidayPayCalculation">
                <form>
                  <fieldset>
                    <legend sxy-text="SALAXY.MODEL.HolidayPaySettings.title"></legend>
                    <salaxy-input-enum enum="HolidayPayCalculation" label="SALAXY.MODEL.HolidayPaySettings.holidayPayCalculation.title" name="holidayPayCalculation" filter="averageDailyPay,averageHourlyPay,percentageBasedPay,holidayCompensation" require="true" ng-model="$ctrl.current.holidayPayCalculation" read-only="$ctrl.getReadOnly()"></salaxy-input-enum>
                    <legend sxy-text="SALAXY.MODEL.HolidayPaySettings.salaryTypes.title"></legend>
                    <sxy-input model="form.salaryTypes" template-url="salaxy-components/sxy-form/custom-templates/holiday-row-types.html"></sxy-input>
                    <legend ng-show="$ctrl.current.holidayPayCalculation == 'averageHourlyPay'" sxy-text="SALAXY.MODEL.HolidayPaySettings.workingTimeTypes.title"></legend>
                    <sxy-input ng-show="$ctrl.current.holidayPayCalculation == 'averageHourlyPay'" model="form.workingTimeTypes" template-url="salaxy-components/sxy-form/custom-templates/holiday-row-types.html"></sxy-input>
                    <legend ng-show="$ctrl.current.holidayPayCalculation == 'averageDailyPay'" sxy-text="SALAXY.MODEL.HolidayPaySettings.overtimeTypes.title"></legend>
                    <sxy-input  ng-show="$ctrl.current.holidayPayCalculation == 'averageDailyPay'" model="form.overtimeTypes" template-url="salaxy-components/sxy-form/custom-templates/holiday-row-types.html"></sxy-input>
                    <legend ng-show="$ctrl.current.holidayPayCalculation == 'averageHourlyPay' || $ctrl.current.holidayPayCalculation == 'averageDailyPay'" sxy-text="SALAXY.MODEL.HolidayPaySettings.multipliers.title"></legend>
                    <salaxy-input-holiday-multipliers ng-show="$ctrl.current.holidayPayCalculation == 'averageHourlyPay' || $ctrl.current.holidayPayCalculation == 'averageDailyPay'" name="multipliers" label="SALAXY.MODEL.HolidayPaySettings.multipliers.title" ng-model="$ctrl.current.multipliers" read-only="$ctrl.getReadOnly()"></salaxy-input-holiday-multipliers>
                  </fieldset>
                </form>
              </sxy-input>
              <sxy-input model="form.holiday.holidayAccrualSettings"
                read-only="{{!$ctrl.current.holiday.denyServiceModel  && $ctrl.current.partner.serviceModel.features.holiday }}" include="code">
                <form>
                  <fieldset>
                    <legend sxy-text="SALAXY.MODEL.HolidayAccrualSettings.title"></legend>
                    <salaxy-input-enum enum="HolidayCode" label="SALAXY.MODEL.HolidayAccrualSettings.code.title" name="code" filter="permanent35Hours,other" require="true" ng-model="$ctrl.current.code" read-only="$ctrl.getReadOnly()"></salaxy-input-enum>
                    <legend sxy-text="SALAXY.MODEL.HolidayAccrualSettings.workingTimeTypes.title"></legend>
                    <sxy-input model="form.workingTimeTypes" template-url="salaxy-components/sxy-form/custom-templates/holiday-row-types.html"></sxy-input>
                  </fieldset>
                </form>
              </sxy-input>
            </div>
           
          </sxy-form>
        </div>
      </div>
      <div class="card-footer">
        <div class="row">
          <div class="col-xs-12">
            <button type="submit" ng-disabled="(!$ctrl.current.holidays.denyServiceModel && $ctrl.current.partner.serviceModel.features.holidays) || !$frm.ngForm.$valid || $ctrl.isSaving('all')" class="btn btn-primary pull-right" ng-click="$ctrl.save('all')">
              <span ng-if="$ctrl.isSaving('all')"><i class="bi bi-arrow-repeat bi-spin"></i></span>
              <span sxy-text="SALAXY.UI_Terms.save"></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>`), s.put("salaxy-components/settings/Insurances.html", `<div class="content settings" ng-if="$ctrl.current" ng-controller="VarmaBannerController as $varma">
  <div class="card pension card-secondary my-4" ng-repeat="item in $ctrl.pensionContracts" ng-if="$ctrl.sections.indexOf('pensionContracts') >= 0 && $ctrl.isVisibleContract(item, $ctrl.pensionContracts)">
    <form name="pensionForm" class="pension-form" ng-readonly="$ctrl.isReadOnlyForced">
      <div class="card-header d-flex">
        <div class="flex-grow-1 pe-5">
          <h2 sxy-text="SALAXY.NG1.InsuranceSettingsComponent.pension.title"></h2>
          <p><small sxy-text="SALAXY.NG1.InsuranceSettingsComponent.pension.description"></small></p>
        </div>
        <i class="bi bi-check-circle-fill text-success status-icon fs-1 d-block"></i>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-sm-6 col-12">
            <div class="form-horizontal">
              <fieldset>
                <legend sxy-text="SALAXY.NG1.InsuranceSettingsComponent.pension.currentContractLegend"></legend>
                <salaxy-input-enum ng-model="item.company" type="select" label="SALAXY.MODEL.PensionContract.company.editLabel" name="pensionCompany" enum="PensionCompany" filter="none,varma,elo,ilmarinen,veritas,apteekkien,verso,valio,kevaMunicipal,kevaAland,kevaChurch,kevaKela,kevaState" require="true" ng-change="item.contractNumber = null"></salaxy-input-enum>
                <main salaxy-if-role="test" class="test-number">
                  <div class="form-group" ng-if="item.company && item.company != 'none'">
                    <div class="col-sm-8 offset-sm-4 text-sm-end">
                      <span>Test only: <button class="btn btn-secondary btn-xs" ng-click="$ctrl.setPensionNumberForTest(item)"> Generoi numero </button></span>
                    </div>
                  </div>
                </main>
                <salaxy-input ng-if="item.company && item.company != 'none'" require="true" name="pensionContractNumber" label="SALAXY.MODEL.PensionContract.contractNumber.title" ng-model="item.contractNumber" tooltip-html="{{'SALAXY.NG1.InsuranceSettingsComponent.pension.errors.sxyPensionContractNumber.html' | sxyTranslate}}"
                  tooltip-placement="right" sxy-pension-contract-number="item.company"></salaxy-input>
                <div class="row" ng-show="pensionForm.pensionContractNumber.$error.sxyTemporaryPensionContractNumber">
                  <div class="col-12 offset-sm-4 input-info text-danger">
                    <div class="input-info-icon"><i class="bi bi-exclamation-triangle-fill"></i></div>
                    <p class="small input-info-text with-icon" sxy-html="SALAXY.NG1.InsuranceSettingsComponent.pension.errors.sxyTemporaryPensionContractNumber.html"></p>
                  </div>
                </div>
                <salaxy-input-number disabled="true" ng-if="(item.company && item.company != 'none')" unit="percent" ng-model="item.pensionDefaultPercent" name="pensionDefaultPercent" label="SALAXY.MODEL.PensionContract.pensionDefaultPercent.title"></salaxy-input-number>
                <salaxy-input-number disabled="!('admin,pro' | sxyIsInRole)" ng-if="(item.company && item.company != 'none') && (('admin,pro' | sxyIsInRole) || item.pensionPercent)" unit="percent" ng-model="item.pensionPercent" name="pensionPercent" label="SALAXY.MODEL.PensionContract.pensionPercent.title"></salaxy-input-number>
              </fieldset>
            </div>
          </div>
          <div class="col-sm-6 col-12" ng-show="item.company && item.company != 'none' && item.company != 'varma'">
            <fieldset>
              <legend sxy-text="SALAXY.NG1.InsuranceSettingsComponent.pension.moveContractLegend"></legend>
              <p sxy-text="SALAXY.NG1.InsuranceSettingsComponent.pension.moveContractDescription"></p>
              <div>
                <a ng-href="{{$varma.getVarmaShopLink()}}" target="_blank" class="btn btn-primary" sxy-text="SALAXY.NG1.InsuranceSettingsComponent.pension.moveContractCta"></a>
              </div>
            </fieldset>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6 col-12" ng-show="!item.company || item.company == 'none'">
            <fieldset>
              <legend sxy-text="SALAXY.NG1.InsuranceSettingsComponent.pension.varmaLegend"></legend>
              <p sxy-text="SALAXY.NG1.InsuranceSettingsComponent.pension.varmaDescription"></p>
              <div>
                <a ng-href="{{$varma.getVarmaShopLink()}}" target="_blank" class="btn btn-primary" sxy-text="SALAXY.NG1.InsuranceSettingsComponent.pension.varmaCta"></a>
              </div>
            </fieldset>
          </div>
          <div class="col-sm-6 col-12" ng-show="!item.company || item.company == 'none'">
            <fieldset>
              <legend sxy-text="SALAXY.NG1.InsuranceSettingsComponent.pension.temporaryLegend"></legend>
              <p sxy-html="SALAXY.NG1.InsuranceSettingsComponent.pension.temporaryDescription.html"></p>
            </fieldset>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <div class="row">
          <div class="col-12">
            <button ng-if="!$ctrl.isReadOnlyForced" ng-disabled="!item.company || pensionForm.$invalid || $ctrl.isSaving('pensionContracts')" class="btn btn-primary float-end" ng-click="$ctrl.save('pensionContracts')"><span ng-if="$ctrl.isSaving('pensionContracts')"><i class="bi bi-arrow-repeat bi-spin"></i></span> <span sxy-text="SALAXY.UI_Terms.save"></span></button>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="card pension yel-pension card-secondary mb-4" ng-if="$ctrl.sections.indexOf('yelPensionContracts') >= 0">
    <div class="card-header">
      <h2 sxy-text="SALAXY.NG1.InsuranceSettingsComponent.yelPension.title"></h2>
    </div>
    <div class="card-body">
      <p sxy-text="SALAXY.NG1.InsuranceSettingsComponent.yelPension.description"></p>
    </div>
    <div class="card-footer text-end">
      <a class="btn btn-primary" ng-href="{{$varma.getVarmaShopLink()}}" target="_blank" sxy-text="SALAXY.NG1.InsuranceSettingsComponent.yelPension.takeInsuranceBtn"></a>
    </div>
  </div>
  <div class="card insurance card-secondary mb-4" ng-repeat="item in $ctrl.insuranceContracts" ng-if="$ctrl.sections.indexOf('insuranceContracts') >= 0 && $ctrl.isVisibleContract(item, $ctrl.insuranceContracts)">
    <form ng-if="item.status != 'pending'" name="insuranceForm" class="insurance-form" ng-readonly="$ctrl.isReadOnlyForced">
      <div class="card-header d-flex">
        <div class="flex-grow-1 pe-5">
          <h2 sxy-text="SALAXY.NG1.InsuranceSettingsComponent.insurance.title"></h2>
          <p><small sxy-text="SALAXY.NG1.InsuranceSettingsComponent.insurance.description"></small></p>
        </div>
        <i class="bi bi-check-circle-fill text-success status-icon fs-1 d-block"></i>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-sm-6 col-12">
            <fieldset>
              <legend sxy-text="SALAXY.NG1.InsuranceSettingsComponent.insurance.currentContractLegend"></legend>
              <div class="form-horizontal">
                <salaxy-input-enum ng-model="item.company" type="select" enum="InsuranceCompany" filter="none,fennia,if,lähiTapiola,pohjantähti,pohjola,turva,aVakuutus,folksam,alandia,ålands,protector" label="SALAXY.MODEL.InsuranceContract.company.editLabel" name="insurance-company"
                  require="true"></salaxy-input-enum>
              </div>
              <div class="form-horizontal" ng-if="item.company && item.company != 'none'">
                <salaxy-input ng-model="item.contractNumber" require="true" name="insuranceContractNumber" label="SALAXY.MODEL.InsuranceContract.contractNumber.title"></salaxy-input>
              </div>
              <div class="form-horizontal" ng-if="item.company">
                <salaxy-input-number unit="percent" tooltip-html="{{'SALAXY.MODEL.InsuranceContract.insurancePercent.descr' | sxyTranslate}}" ng-model="item.insurancePercent" name="insurancePercent" label="SALAXY.MODEL.InsuranceContract.insurancePercent.title"></salaxy-input-number>
              </div>
              <div class="form-horizontal" ng-if="item.company">
                <salaxy-input-number unit="percent" tooltip-html="{{'SALAXY.MODEL.InsuranceContract.groupLifeInsurancePercent.descr' | sxyTranslate}}" ng-model="item.groupLifeInsurancePercent" name="groupLifeInsurancePercent" label="SALAXY.MODEL.InsuranceContract.groupLifeInsurancePercent.title"></salaxy-input-number>
              </div>
            </fieldset>
          </div>
          <div class="col-sm-6 col-12" ng-if="!$ctrl.isReadOnlyForced">
            <fieldset ng-show="item.company && item.company != 'lähiTapiola' && item.company != 'none' ">
              <legend sxy-text="SALAXY.NG1.InsuranceSettingsComponent.insurance.moveToLocalTapiolaLegend"></legend>
              <div ng-controller="InsuranceWizardController as insuranceCtrl">
                <button class="btn btn-primary" ng-click="insuranceCtrl.openModal();" sxy-text="SALAXY.NG1.InsuranceSettingsComponent.insurance.moveToLocalTapiolaBtn"></button>
              </div>
            </fieldset>
            <fieldset ng-if="item.company == 'none' || !item.company">
              <legend sxy-text="SALAXY.NG1.InsuranceSettingsComponent.insurance.takeFromLocalTapiolaLegend"></legend>
              <div ng-controller="InsuranceWizardController as insuranceCtrl">
                <button class="btn btn-primary" ng-click="insuranceCtrl.openModal();" sxy-text="SALAXY.NG1.InsuranceSettingsComponent.insurance.takeFromLocalTapiolaBtn"></button>
              </div>
            </fieldset>
          </div>
        </div>
        <div class="row" style="margin-top:10px;">
          <div class="col-12 settings-alert">
            <div ng-if="item.company && item.company != 'none'">
              <div class="float-start">
                <i class="bi bi-info-circle-fill alert-icon text-info icon-info"></i>
              </div>
              <div class="alert-text">
                <p class="text-info " sxy-text="SALAXY.NG1.InsuranceSettingsComponent.insurance.insuranceComment"></p>
              </div>
            </div>
            <div ng-if="item.company == 'none'">
              <div class="float-start">
                <i class="bi bi-exclamation-lg alert-icon d-flex align-items-center justify-content-center text-danger icon-danger"></i>
              </div>
              <div class="alert-text">
                <p class="text-danger" sxy-text="SALAXY.NG1.InsuranceSettingsComponent.insurance.warning"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <div class="row">
          <div class="col-12">
            <button ng-if="!$ctrl.isReadOnlyForced" ng-disabled="!item.company || $ctrl.isSaving('insuranceContracts')" class="btn btn-primary float-end" ng-click="$ctrl.save('insuranceContracts')"><span ng-if="$ctrl.isSaving('insuranceContracts')"><i class="bi bi-arrow-repeat bi-spin"></i></span> <span sxy-text="SALAXY.UI_Terms.save"></span></button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>`), s.put("salaxy-components/settings/IrDeliverySettings.html", `<div class="content settings" ng-if="$ctrl.current">
  <div class="card ir-delivery card-secondary mb-4">
    <div class="card-header icon-card">
      <h2 sxy-text="Tulorekisteriraportoinnissa käytettävä varmenne"></h2>
    </div>
    <div class="card-body">
      <div class="row">
        <ng-form name="$frmDelivery" class="form-horizontal">
          <div>
            <fieldset>
              <legend>Tulorekisterivarmenteen omistaja</legend>
              <p
                sxy-text="Jos haluat käyttää tilitoimistovarmennetta Palkkaus.fi:n varmenteen sijasta, anna käytettävän varmenteen Y-tunnus.">
              </p>
              <salaxy-input label="Tulorekisterivarmenteen omistajan Y-tunnus" name="senderOfficialId"
                ng-model="$ctrl.current.calc.incomesRegister.irDelivery.senderOfficialId"></salaxy-input>
            </fieldset>
            <fieldset>
              <legend>Tulorekisteriraportin yhteyshenkilöt</legend>
              <table class="table">
                <thead>
                  <tr>
                    <th>{{('Nimi') | sxyTranslate}}</th>
                    <th>{{('Puhelin') | sxyTranslate}}</th>
                    <th>{{('Sähköposti') | sxyTranslate}}</th>
                    <th>{{('Vastuualue') | sxyTranslate}}</th>
                    <th class="right">
                      <button type="button" class="btn btn-primary btn-xs"
                        ng-click="$ctrl.current.calc.incomesRegister.irDelivery.contactPersons.push({})" sxy-text="SALAXY.UI_Terms.addRow"></button>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr ng-repeat="item in $ctrl.current.calc.incomesRegister.irDelivery.contactPersons">
                    <td>
                      <salaxy-input require="true" ng-model="item.name" name="{{ 'name' + $index }}" label-type="plain"></salaxy-input>
                    </td>
                    <td>
                      <salaxy-input require="true" ng-model="item.telephone" name="{{ 'telephone' + $index }}" label-type="plain" sxy-mobile-phone></salaxy-input>
                    </td>
                    <td>
                      <salaxy-input require="true" ng-model="item.email" name="{{ 'email' + $index }}" label-type="plain" sxy-email></salaxy-input>
                    </td>
                    <td>
                      <salaxy-input-enum require="true" ng-model="item.responsibilityCode" name="{{ 'responsibilityCode' + $index }}" label-type="plain" type="select"
                        options="{ contentIssues: 'Raporttien sisältö', technicalIssues: 'Tekniset asiat' }"></salaxy-input-enum>
                    </td>
                    <td class="text-right">
                      <button type="button" class="btn btn-danger" ng-click="$ctrl.current.calc.incomesRegister.irDelivery.contactPersons.splice($index, 1)">
                        <i class="bi bi-trash" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </fieldset>
          </div>
        </ng-form>
      </div>
    </div>
    <div class="card-footer">
      <div class="row">
        <div class="col-xs-12 text-right">
          <button type="submit" ng-disabled="!$frmDelivery.$valid || ($ctrl.current.calc.incomesRegister.irDelivery.senderOfficialId && !$ctrl.current.calc.incomesRegister.irDelivery.contactPersons[0].responsibilityCode ) || $ctrl.isSaving('all')"
            class="btn btn-primary" ng-click="$ctrl.save('all')">
            <span ng-if="$ctrl.isSaving('all')"><i class="bi bi-arrow-repeat bi-spin"></i></span>
            <span sxy-text="SALAXY.UI_Terms.save"></span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="card ir-certificate-actions card-secondary" ng-if="$ctrl.hasOwnIrCertificate()">
    <div class="card-header icon-card">
      <h2 sxy-text="Tulorekisterivarmenteen luonti/uusinta"></h2>
    </div>
    <div class="card-body">
      <div class="row">
        <ng-form name="$frmCert" class="form-horizontal">
          <div>
              <legend>Yrityksesi tulorekisterivarmenteen tila</legend>
              <table class="table">
                <tr>
                  <th>Luotu</th>
                  <th>Voimassaolo päättyy</th>
                </tr>
                <tr ng-if="!$ctrl.irCertificate.id">
                  <td colspan="2">Ei voimassa olevaa varmennetta</td>
                </tr>
                <tr ng-if="$ctrl.irCertificate.id">
                  <td>{{$ctrl.irCertificate.updatedAt | date}}</td>
                  <td>{{$ctrl.irCertificate.expiresAt | date}}</td>
                </tr>
              </table>
            </fieldset>
            <fieldset>
              <legend>Varmenteen luonti/uusinta</legend>
              <salaxy-input-enum ng-if="$ctrl.irCertificate.id" ng-init="$ctrl.irCertificateAction = 'renew'" label="Toimenpide" ng-model="$ctrl.irCertificateAction" name="certAction" type="radio"
                options="{ create: 'Luo uusi varmenne', renew: 'Uusi nykyinen varmenne' }"></salaxy-input-enum>
              <salaxy-input-enum ng-if="!$ctrl.irCertificate.id" ng-init="$ctrl.irCertificateAction = 'create'" label="Toimenpide" ng-model="$ctrl.irCertificateAction" name="certAction" type="radio"
                options="{ create: 'Luo uusi varmenne'}"></salaxy-input-enum>
              <salaxy-input ng-if="$ctrl.irCertificateAction == 'create'" require="true" label="Siirtotunnus" ng-model="$ctrl.irCertificateTransferId"
                name="transferId"></salaxy-input>
              <salaxy-input ng-if="$ctrl.irCertificateAction == 'create'" require="true" label="Kertakäyttösalasana" ng-model="$ctrl.irCertificateTransferPassword"
                name="transferPassword" type="password"></salaxy-input>
            </fieldset>
          </div>
        </ng-form>
      </div>
    </div>
    <div class="card-footer">
      <div class="row">
        <div class="col-xs-12 text-right">
          <button type="button" ng-if="$ctrl.irCertificateAction == 'create'" class="btn btn-primary" ng-disabled="$ctrl.isSaving('irCertificate') || !$frmCert.$valid"
            ng-click="$ctrl.createIrCertificate($ctrl.irCertificateTransferId, $ctrl.irCertificateTransferPassword)"><span ng-if="$ctrl.isSaving('irCertificate')"><i
                class="bi bi-arrow-repeat bi-spin"></i></span><span sxy-text="Luo uusi varmenne"></span></button>
          <button type="button" ng-if="$ctrl.irCertificateAction == 'renew'" class="btn btn-primary" ng-disabled="$ctrl.isSaving('irCertificate')  || !$frmCert.$valid"
            ng-click="$ctrl.renewIrCertificate()"><span ng-if="$ctrl.isSaving('irCertificate')"><i class="bi bi-arrow-repeat bi-spin"></i></span><span
              sxy-text="Uusi nykyinen varmenne"></span></button>
        </div>
      </div>
    </div>
  </div>
</div>`), s.put("salaxy-components/settings/OwnerSettings.html", `<div class="salaxy-component salaxy-owner-settings">

  <style>
    @media print {
      salaxy-tab {
        display: none !important;
      }
    }
  </style>
  <salaxy-tab-buttons
    current-tab="$ctrl.currentTab"
    options="[
      { value: 'default', text: 'SALAXY.NG1.OwnerSettingsComponent.tabs.editing' },
      { value: 'beneficiaries', text: 'SALAXY.NG1.OwnerSettingsComponent.tabs.beneficiaries' },
      { value: 'printable', text: 'SALAXY.NG1.OwnerSettingsComponent.tabs.printable' }
    ]"
    tabs-id="ownerSettings">
  </salaxy-tab-buttons>
  <div class="tab-content" id="tab-content-ownerSettings">
    <div class="tab-pane" id="default-tab">
      <form class="form-horizontal" ng-if="$ctrl.current" ng-readonly="$ctrl.isReadOnlyForced">
        <div class="row">
          <div class="col-12">
            <fieldset>
              <legend sxy-text="SALAXY.NG1.OwnerSettingsComponent.shareAmountTitle"></legend>
              <div class="row">
                <div class="col-md-6">
                  <salaxy-input-enum type="radio" options="{ byPercent: ('SALAXY.NG1.OwnerSettingsComponent.byPercent' | sxyTranslate), byAmount: ('SALAXY.NG1.OwnerSettingsComponent.byAmount' | sxyTranslate)}" ng-model="$ctrl.mode" name="editMode" label="SALAXY.NG1.OwnerSettingsComponent.sharesBy"
                    label-cols="col-md-6"></salaxy-input-enum>
                </div>
                <div class="col-md-6">
                  <salaxy-input-number ng-model="$ctrl.current.ownedCompanyDetails.totalNumberOfShares" name="numberOfShares" label="SALAXY.NG1.OwnerSettingsComponent.shareAmount" label-cols="col-md-6" ng-change="$ctrl.recalculateShares()"></salaxy-input-number>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
        <fieldset>
          <legend sxy-text="SALAXY.NG1.OwnerSettingsComponent.ownerInfoTitle"></legend>
          <div ng-if="!$ctrl.current.owners.length" class="salaxy-placeholder-empty placeholder-md placeholder-default text-center">
            <h4 sxy-text="SALAXY.NG1.OwnerSettingsComponent.noOwnersTitle"></h4>
            <p></p>
            <button class="btn btn-primary" ng-click="$ctrl.current.owners.push({numberOfShares:0,percentOfShares:0, avatar:{}});" ng-disabled="!$ctrl.mode" sxy-text="SALAXY.NG1.OwnerSettingsComponent.addOwnerBtn"></button>
          </div>
          <div class="row" ng-repeat="owner in $ctrl.current.owners">
            <div class="col-md-6">
              <salaxy-input ng-model="owner.avatar.displayName" name="ownerName{{$index}}" label="SALAXY.NG1.OwnerSettingsComponent.ownerName" label-type="basic"></salaxy-input>
            </div>
            <div class="col-md-3">
              <salaxy-input ng-model="owner.officialId" name="officialId{{$index}}" label="SALAXY.NG1.OwnerSettingsComponent.ownerOfficialId" label-type="basic"></salaxy-input>
            </div>
            <div class="col-md-3">
              <salaxy-input ng-model="owner.email" name="email{{$index}}" label="SALAXY.NG1.OwnerSettingsComponent.ownerEmail" label-type="basic" sxy-email></salaxy-input>
            </div>
            <div class="col-md-6">
              <salaxy-input ng-model="owner.address" name="address{{$index}}" label="SALAXY.NG1.OwnerSettingsComponent.ownerAddress" label-type="basic"></salaxy-input>
            </div>
            <div class="col-md-3 col-5">
              <salaxy-input-number ng-model="owner.numberOfShares" name="ownerShare{{$index}}" label="SALAXY.NG1.OwnerSettingsComponent.ownerShareAmount" label-type="basic" read-only="$ctrl.mode == 'byPercent' || $ctrl.isReadOnlyForced" ng-change="$ctrl.recalculateShares()"></salaxy-input-number>
            </div>
            <div class="col-md-2 col-5">
              <salaxy-input-number ng-model="owner.percentOfShares" name="ownerpercentOfShares{{$index}}" label="SALAXY.NG1.OwnerSettingsComponent.ownerSharePercent" label-type="basic" read-only="$ctrl.mode == 'byAmount' || $ctrl.isReadOnlyForced" ng-change="$ctrl.recalculateShares()"></salaxy-input-number>
            </div>
            <div class="col-md-1 col-2 text-end" style="padding-top:39px">
              <button ng-if="!$ctrl.isReadOnlyForced" class="btn btn-danger btn-sm" ng-click="$ctrl.current.owners.splice($index,1)" title="{{'SALAXY.UI_Terms.deleteRow' | sxyTranslate}}"><i class="bi bi-trash-fill"></i></button>
            </div>
            <div class="col-12">
              <hr>
            </div>
          </div>
          <div class="row total-row" ng-if="$ctrl.current.owners.length">
            <div class="col-6">
              <strong sxy-text="SALAXY.NG1.OwnerSettingsComponent.totalShares"></strong>
            </div>
            <div class="col-6 text-end" ng-if="$ctrl.mode == 'byAmount'" ng-class="{'text-danger' : $ctrl.getTotalAmount() > $ctrl.current.ownedCompanyDetails.totalNumberOfShares, 'text-warning' : $ctrl.getTotalAmount() < $ctrl.current.ownedCompanyDetails.totalNumberOfShares && $ctrl.getTotalAmount() > 0, 'text-success' : $ctrl.getTotalAmount() == $ctrl.current.ownedCompanyDetails.totalNumberOfShares}">
              <strong>{{$ctrl.getTotalAmount()}} / {{$ctrl.current.ownedCompanyDetails.totalNumberOfShares}} <span sxy-text="SALAXY.UI_Terms.units.pce"></span></strong>
            </div>
            <div class="col-6 text-end" ng-if="$ctrl.mode != 'byAmount'" ng-class="{'text-danger' : $ctrl.getTotalPercent() > 100, 'text-warning' : $ctrl.getTotalPercent() < 100 && $ctrl.getTotalPercent() > 0, 'text-success' : $ctrl.getTotalPercent() == 100}">
              <strong>{{$ctrl.getTotalPercent()}} / 100 %</strong>
            </div>
            <div class="col-12">
              <hr>
            </div>
          </div>
          <div class="row" ng-if="$ctrl.current.owners.length && !$ctrl.isReadOnlyForced">
            <div class="col-6">
              <button class="btn btn-secondary btn-sm" ng-click="$ctrl.current.owners.push({numberOfShares:0,percentOfShares:0, avatar: {}})"><i class="bi bi-plus-lg" style="margin-right:5px"></i><span sxy-text="SALAXY.NG1.OwnerSettingsComponent.addOwnerBtn"></span></button>
            </div>
            <div class="col-6 text-end">
              <button class="btn btn-primary btn-sm" ng-click="$ctrl.save('owners')" ng-disabled="$ctrl.isSaving('owners')"><span ng-if="$ctrl.isSaving('owners')"><i
                class="bi bi-arrow-repeat bi-spin"></i></span> <span sxy-text="SALAXY.UI_Terms.save"></span></button>
            </div>
          </div>
        </fieldset>
      </form>
    </div> 
    <div class="tab-pane" id="beneficiaries-tab">
      <form class="form-horizontal" ng-if="$ctrl.current" ng-readonly="$ctrl.isReadOnlyForced">
        <fieldset>
          <legend sxy-text="SALAXY.NG1.OwnerSettingsComponent.beneficiariesInfoTitle"></legend>
          <div ng-if="!$ctrl.current.beneficiaries.length" class="salaxy-placeholder-empty placeholder-md placeholder-default text-center">
            <h4 sxy-title="SALAXY.NG1.OwnerSettingsComponent.noBeneficiariesTitle">Edunsaajat</h4>
            <p></p>
            <button class="btn btn-primary" ng-click="$ctrl.current.beneficiaries.push({ avatar:{}});" sxy-text="SALAXY.NG1.OwnerSettingsComponent.addBeneficiaryBtn"></button>
          </div>
          <div class="row" ng-repeat="beneficiary in $ctrl.current.beneficiaries">
            <div class="col-md-5">
              <salaxy-input ng-model="beneficiary.avatar.displayName" name="beneficiaryName" label="SALAXY.NG1.OwnerSettingsComponent.beneficiaryName" label-type="basic"></salaxy-input>
            </div>
            <div class="col-md-3">
              <salaxy-input ng-model="beneficiary.officialId" name="beneficiaryOfficialId" label="SALAXY.NG1.OwnerSettingsComponent.beneficiaryOfficialId" label-type="basic"></salaxy-input>
            </div>
            <div class="col-md-3 col-10">
              <salaxy-input ng-model="beneficiary.nationality" name="beneficiaryNationality" label="SALAXY.NG1.OwnerSettingsComponent.beneficiaryNationality" label-type="basic"></salaxy-input>
            </div>
            <div class="col-md-1 col-2 text-end" style="padding-top:39px">
              <button ng-if="!$ctrl.isReadOnlyForced" class="btn btn-danger btn-sm" ng-click="$ctrl.current.beneficiaries.splice($index,1)" title="{{'SALAXY.UI_Terms.deleteRow' | sxyTranslate}}"><i class="bi bi-trash-fill"></i></button>
            </div>
            <div class="col-12">
              <hr>
            </div>
          </div>
          <div class="row" ng-if="$ctrl.current.beneficiaries.length && !$ctrl.isReadOnlyForced">
            <div class="col-6">
              <button class="btn btn-secondary btn-sm" ng-click="$ctrl.current.beneficiaries.push({avatar:{}})"><i class="bi bi-plus-lg" style="margin-right:5px"></i> <span sxy-text="SALAXY.NG1.OwnerSettingsComponent.addBeneficiaryBtn"></span></button>
            </div>
            <div class="col-6 text-end">
              <button class="btn btn-primary btn-sm" ng-click="$ctrl.save('beneficiaries')" ng-disabled="$ctrl.isSaving('beneficiaries')"><span ng-if="$ctrl.isSaving('beneficiaries')"><i class="bi bi-arrow-repeat bi-spin"></i></span> <span sxy-text="SALAXY.UI_Terms.save"></span></button>
            </div>
          </div>
        </fieldset>
      </form>
    </div> 
    <div class="tab-pane" id="printable-tab">
      <div class="report-table-html" ng-if="$ctrl.current">
        <div class="table-responsive">

          <h1 sxy-text="SALAXY.NG1.OwnerSettingsComponent.shareHoldersTitle"></h1>
          <table class="report-table columns-tree">
            <thead>
              <tr style="border-bottom:1px solid black;">
                <th sxy-text="SALAXY.NG1.OwnerSettingsComponent.shareHolder"></th>
                <th class="right" sxy-text="SALAXY.NG1.OwnerSettingsComponent.shares"></th>
                <th class="right" sxy-text="SALAXY.NG1.OwnerSettingsComponent.sharesPercent"></th>
              </tr>
            </thead>
            <tbody>
              <tr ng-repeat="owner in $ctrl.current.owners">
                <td>
                  {{owner.avatar.displayName}}
                </td>
                <td class="right">
                  {{owner.numberOfShares}}
                </td>
                <td class="right">
                  {{owner.percentOfShares}}
                </td>
              </tr>
              <tfoot class="">
                <tr class="total">
                  <td><strong sxy-text="SALAXY.NG1.OwnerSettingsComponent.totalShares"></strong></td>
                  <td class="right">{{$ctrl.getTotalAmount()}}</td>
                  <td class="right">{{$ctrl.getTotalPercent()}}</td>
                </tr>
              </tfoot>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>`), s.put("salaxy-components/settings/PaymentChannelSettings.html", `<div class="salaxy-component salaxy-payment-channel-settings">
  <div class="row">
    <div class="col-sm-6 max-h-600px mb-4">
      <h4 sxy-text="SALAXY.NG1.PaymentChannelSettingsComponent.title"></h4>
      <table class="table">
        <tbody>
          <tr ng-repeat="channel in $ctrl.getPaymentChannels('enabled')">
            <td>
              <salaxy-avatar avatar="$ctrl.getAvatar(channel.channel)" class="" style="font-size: 64px; border-bottom: 32px;"></salaxy-avatar>
            </td>
            <td>
              <div>
                <button class="btn btn-default float-end" ng-click="$ctrl.openChannelSetupDialog(channel.channel)" sxy-text="SALAXY.NG1.PaymentChannelSettingsComponent.settingsBtn" ps="..."></button>
                <strong>{{$ctrl.getAvatar(channel.channel).displayName}}</strong>
                <strong ng-if="channel.channel == $ctrl.defaultChannel" class="text-primary" sxy-text="SALAXY.NG1.PaymentChannelSettingsComponent.defaultChannel"></strong>
              </div>
              <div>{{$ctrl.getAvatar(channel.channel).description}}</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="col-sm-6 max-h-600px mb-4">
      <h4 sxy-text="SALAXY.NG1.PaymentChannelSettingsComponent.addNewTitle" ps=":"></h4>
      <table class="table">
        <tbody>
          <tr ng-repeat="channel in $ctrl.getPaymentChannels('available')">
            <td>
              <salaxy-avatar avatar="$ctrl.getAvatar(channel.channel)" class="" style="font-size: 64px; border-bottom: 32px;"></salaxy-avatar>
            </td>
            <td>
              <button class="btn btn-default float-end" ng-click="$ctrl.openChannelSetupDialog(channel.channel)" sxy-text="SALAXY.NG1.PaymentChannelSettingsComponent.addBtn" ps="..."></button>
              <div><strong>{{$ctrl.getAvatar(channel.channel).displayName}}</strong></div>
              <div>{{$ctrl.getAvatar(channel.channel).description}}</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="row" ng-if="'test' | sxyIsInRole">
    <div class="col-sm-12">
      <h4><span sxy-text="SALAXY.NG1.PaymentChannelSettingsComponent.notAvailableTitle"></span> <span class="badge bg-primary"><span class="small text-white" sxy-text="SALAXY.NG1.PaymentChannelSettingsComponent.test"></span></span>
      </h4>
      <p sxy-text="SALAXY.NG1.PaymentChannelSettingsComponent.notAvailableText"></p>
      <div class="table-wrapper">
        <table class="table table-sm">
          <tbody>
            <tr ng-repeat="channel in $ctrl.getPaymentChannels('unavailable') | filter: { id: '!undefined' }">
              <td>
                <salaxy-avatar avatar="$ctrl.getAvatar(channel.channel)" class="" style="font-size: 32px; border-bottom: 32px;"></salaxy-avatar>
              </td>
              <td>
                <div>
                  <strong>{{$ctrl.getAvatar(channel.channel).displayName}}</strong>:
                  <small>{{$ctrl.getAvatar(channel.channel).description}}</small>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>`), s.put("salaxy-components/settings/PaymentSettings.html", `<div class="content settings" ng-if="$ctrl.current">
  <div class="card tax card-secondary mb-4" ng-if="$ctrl.sections.indexOf('incomesRegister') >= 0">
    <div class="card-header icon-card d-flex">
      <div>
        <h2 sxy-text="SALAXY.NG1.PaymentSettingsComponent.tax.title"></h2>
        <p><small sxy-text="SALAXY.NG1.PaymentSettingsComponent.tax.intro"></small></p>
      </div>
      <i class="bi bi-check-circle-fill text-success status-icon fs-1 d-block"></i>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-12 form-horizontal">
          <fieldset>
            <salaxy-input-enum read-only="$ctrl.isReadOnlyForced" type="radio" ng-model="$ctrl.current.calc.incomesRegister.irReporting" name="irReporting" label="SALAXY.MODEL.IncomesRegisterSettings.irReporting.editLabel" options="{ 
                                default: ('SALAXY.ENUM.TaxReportHandling.default.label' | sxyTranslate),
                                noMonthlyReport: ('SALAXY.ENUM.TaxReportHandling.noMonthlyReport.label' | sxyTranslate),
                                always: ('SALAXY.ENUM.TaxReportHandling.always.label' | sxyTranslate)
                              }">
            </salaxy-input-enum>
          </fieldset>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="row">
        <div class="col-12">
          <button ng-if="!$ctrl.isReadOnlyForced" ng-disabled="$ctrl.isSaving('incomesRegister')" class="btn btn-primary float-end" ng-click="$ctrl.save('incomesRegister')"><span ng-if="$ctrl.isSaving('incomesRegister')"><i class="bi bi-arrow-repeat bi-spin"></i></span> <span sxy-text="SALAXY.UI_Terms.save"></span></button>
        </div>
      </div>
    </div>
  </div>
  <div class="card einvoice card-secondary mb-4" ng-if="$ctrl.sections.indexOf('eInvoice') >= 0">
    <div class="card-header">
      <h2 sxy-text="SALAXY.NG1.PaymentSettingsComponent.einvoice.title"></h2>
      <p><small sxy-text="SALAXY.NG1.PaymentSettingsComponent.einvoice.description"></small></p>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-12 form-horizontal">
          <form name="eInvoiceForm" class="einvoice-form" ng-readonly="$ctrl.isReadOnlyForced">
            <fieldset>
              <salaxy-form-group name="eInvoiceReceiver" label="SALAXY.NG1.PaymentSettingsComponent.einvoice.invoiceAddress">
                <div class="input-group">
                  <input class="form-control" type="text" autocomplete="off" id="eInvoiceReceiver" name="eInvoiceReceiver" ng-disabled="true" ng-model="$ctrl.current.payments.invoice.eInvoiceReceiver">
                  <span class="input-group-btn">
                    <button type="button" class="btn btn-default" ng-if="!$ctrl.isReadOnlyForced" ng-click="$ctrl.selectEInvoiceAddress()" sxy-text="SALAXY.UI_Terms.choose"></button>
                  </span>
                </div>
              </salaxy-form-group>
              <salaxy-input disabled="true" name="intermediator" ng-model="$ctrl.current.payments.invoice.eInvoiceIntermediator" label="SALAXY.NG1.NewPaymentComponent.einvoice.intermediatorLabel"></salaxy-input>

            </fieldset>
          </form>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="row">
        <div class="col-12">
          <button ng-if="!$ctrl.isReadOnlyForced" ng-disabled="$ctrl.isSaving('eInvoice')" class="btn btn-primary float-end" ng-click="$ctrl.save('eInvoice')"><span ng-if="$ctrl.isSaving('eInvoice')"><i class="bi bi-arrow-repeat bi-spin"></i></span> <span sxy-text="SALAXY.UI_Terms.save"></span></button>
        </div>
      </div>
    </div>
  </div>
  <div class="card sepa card-secondary mb-4" ng-if="$ctrl.sections.indexOf('sepa') >= 0">
    <form name="sepaForm" ng-readonly="$ctrl.isReadOnlyForced">
      <div class="card-header">
        <h2 sxy-text="SALAXY.NG1.PaymentSettingsComponent.sepa.title"></h2>
        <p><small sxy-text="SALAXY.NG1.PaymentSettingsComponent.sepa.title"></small></p>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-12 form-horizontal">
            <fieldset>
              <salaxy-input name="ibanNumber" label="SALAXY.NG1.PaymentSettingsComponent.sepa.iban" ng-model="$ctrl.current.payments.invoice.ibanNumber" sxy-iban></salaxy-input>
              <salaxy-input name="sepaBankPartyId" label="SALAXY.NG1.PaymentSettingsComponent.sepa.sepaId" ng-model="$ctrl.current.payments.invoice.sepaBankPartyId"></salaxy-input>
            </fieldset>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <div class="row">
          <div class="col-12">
            <button ng-if="!$ctrl.isReadOnlyForced" ng-disabled="sepaForm.$invalid || $ctrl.isSaving('sepa')" class="btn btn-primary float-end" ng-click="$ctrl.save('sepa')"><span ng-if="$ctrl.isSaving('sepa')"><i class="bi bi-arrow-repeat bi-spin"></i></span> <span sxy-text="SALAXY.UI_Terms.save"></span></button>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="card taxAndSocialSecuritySelfHandling card-secondary mb-4" ng-if="$ctrl.sections.indexOf('taxAndSocialSecuritySelfHandling') >= 0">
    <div class="card-header">
      <h2 sxy-text="SALAXY.NG1.PaymentSettingsComponent.taxSelfHandling.title"></h2>
      <p><small sxy-text="SALAXY.NG1.PaymentSettingsComponent.taxSelfHandling.intro"></small></p>
      <p><small sxy-text="SALAXY.NG1.PaymentSettingsComponent.taxSelfHandling.intro2"></small></p>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-12 form-horizontal">
          <fieldset>
            <salaxy-input-boolean read-only="$ctrl.isReadOnlyForced" type="checkbox" name="isTaxAndSocialSecuritySelfHandling" label-type="plain" label-true="SALAXY.NG1.PaymentSettingsComponent.taxSelfHandling.taxSelfHandlingTrue" ng-model="$ctrl.current.payments.customerFunds.isTaxAndSocialSecuritySelfHandling"></salaxy-input-boolean>
          </fieldset>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="row">
        <div class="col-12">
          <button ng-if="!$ctrl.isReadOnlyForced" ng-disabled="$ctrl.isSaving('taxAndSocialSecuritySelfHandling')" class="btn btn-primary float-end" ng-click="$ctrl.save('taxAndSocialSecuritySelfHandling')"><span ng-if="$ctrl.isSaving('taxAndSocialSecuritySelfHandling')"><i class="bi bi-arrow-repeat bi-spin"></i></span> <span sxy-text="SALAXY.UI_Terms.save"></span></button>
        </div>
      </div>
    </div>
  </div>
  <div class="card workerSelfHandling card-secondary mb-4" ng-if="$ctrl.sections.indexOf('workerSelfHandling') >= 0">
    <div class="card-header">
      <h2 sxy-text="SALAXY.NG1.PaymentSettingsComponent.workerSelfHandling.title"></h2>
      <p><small sxy-text="SALAXY.NG1.PaymentSettingsComponent.workerSelfHandling.intro"></small></p>
      <p><small sxy-text="SALAXY.NG1.PaymentSettingsComponent.workerSelfHandling.intro2"></small></p>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-12 form-horizontal">
          <fieldset>
            <salaxy-input-boolean read-only="$ctrl.isReadOnlyForced" type="checkbox" name="isWorkerSelfHandling" label-type="plain" label-true="SALAXY.NG1.PaymentSettingsComponent.workerSelfHandling.workerSelfHandlingTrue" ng-model="$ctrl.current.payments.customerFunds.isWorkerSelfHandling"></salaxy-input-boolean>
          </fieldset>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="row">
        <div class="col-12">
          <button ng-if="!$ctrl.isReadOnlyForced" ng-disabled="$ctrl.isSaving('workerSelfHandling')" class="btn btn-primary float-end" ng-click="$ctrl.save('workerSelfHandling')"><span ng-if="$ctrl.isSaving('workerSelfHandling')"><i class="bi bi-arrow-repeat bi-spin"></i></span> <span sxy-text="SALAXY.UI_Terms.save"></span></button>
        </div>
      </div>
    </div>
  </div>
  <div class="card unemployment card-secondary mb-4" ng-if="$ctrl.sections.indexOf('unemploymentSelfHandling') >= 0">
    <div class="card-header">
      <h2 sxy-text="SALAXY.NG1.PaymentSettingsComponent.unemployment.title"></h2>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-12">
          <fieldset>
            <p sxy-text="SALAXY.NG1.PaymentSettingsComponent.unemployment.intro"></p>
          </fieldset>
        </div>
      </div>
    </div>
  </div>
  <div class="card salarySlipDeliveryMethods card-secondary mb-4" ng-if="$ctrl.sections.indexOf('payslip') >= 0  && ('payslip' | sxyIsInRole)">
    <div class="card-header">
      <h2 sxy-text="SALAXY.NG1.PaymentSettingsComponent.salarySlipDeliveryMethods.payslip.title"></h2>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-12 form-horizontal">
          <form name="salarySlipDeliveryMethodsForm" class="salarySlipDeliveryMethods-form">
            <fieldset>
              <p><small sxy-text="SALAXY.NG1.PaymentSettingsComponent.salarySlipDeliveryMethods.payslip.description"></small></p>
              <salaxy-input-boolean label="SALAXY.ENUM.WorkerSalarySlipDeliveryMethod.payslip.label" name="payslip" type="checkbox" ng-model="$ctrl.payslip" disabled="$ctrl.disableSwitchInput()"></salaxy-input-boolean>
            </fieldset>
          </form>
        </div>
      </div>
    </div>
  </div>
  <div class="card omapalkka card-secondary mb-4" ng-if="$ctrl.sections.indexOf('omapalkka') >= 0 && ('test,admin' | sxyIsInRole)">
    <div class="card-header">
      <h2 sxy-text="SALAXY.NG1.PaymentSettingsComponent.salarySlipDeliveryMethods.omapalkka.title">
      </h2>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-12 form-horizontal">
          <form name="omapalkkaForm" class="omapalkka-form">
            <fieldset>
              <salaxy-input-boolean label="SALAXY.ENUM.WorkerSalarySlipDeliveryMethod.omapalkka.label" name="omapalkka" type="checkbox" ng-model="$ctrl.omapalkka" disabled="$ctrl.disableSwitchInput()"></salaxy-input-boolean>
            </fieldset>
          </form>
          <salaxy-form-group name="paidCalculationsToOmapalkka" label="SALAXY.NG1.PaymentSettingsComponent.salarySlipDeliveryMethods.omapalkka.label">
            <div class="input-group">
              <button type="button" class="btn btn-default float-end" ng-click="$ctrl.sendPaidCalculationsToOmapalkka()" sxy-text="SALAXY.NG1.PaymentSettingsComponent.salarySlipDeliveryMethods.omapalkka.sendToOmapalkkaButtonText"></button>
            </div>
          </salaxy-form-group>
        </div>
      </div>
    </div>
  </div>
</div>`), s.put("salaxy-components/settings/ProSettings.html", `<div class="salaxy-component salaxy-pro-settings">
  <div class="btn-toolbar d-flex justify-content-end">
    <button class="btn btn-primary" ng-click="$ctrl.save('all')" ng-disabled="$ctrl.isSaving('all')"><span ng-if="$ctrl.isSaving('all')"><i
      class="bi bi-arrow-repeat bi-spin"></i></span> <span sxy-text="SALAXY.UI_Terms.save"></span></button>
  </div>
  <div ng-if="$ctrl.current">
    <sxy-form open-api="salaxy-secure/schemas/v02.json" type="CompanyAccountSettings" auto-gen="false" debugger="false" model="$ctrl.current">
      <div>
        <salaxy-tab-buttons
          current-tab="$ctrl.currentTab"
          options="[
            { value: 'insurances', text: 'SALAXY.NG1.ProSettingsComponent.insurances' },
            { value: 'rows', text: 'SALAXY.NG1.ProSettingsComponent.tabs.defaultRows' },
            { value: 'coms', text: 'SALAXY.NG1.ProSettingsComponent.tabs.messagingAndLayout' },
            { value: 'paymentchannels', text: 'SALAXY.NG1.ProSettingsComponent.tabs.paymentChannels' },
            { value: 'dimensions', text: 'SALAXY.NG1.ProSettingsComponent.tabs.dimensions' },
            { value: 'accounting', text: 'SALAXY.NG1.ProSettingsComponent.tabs.accounting' },
            { value: 'holidays', text: 'Lomalaskenta' },
            { value: 'other', text: 'SALAXY.NG1.ProSettingsComponent.tabs.other' },
            { value: 'irdelivery', text: 'Tulorekisterin varmenne' },
            { value: 'readonly', text: 'SALAXY.NG1.ProSettingsComponent.tabs.read-only' }
          ]"
          tabs-id="proSettings">
        </salaxy-tab-buttons>
        <div class="tab-content" id="tab-content-proSettings">
          <div class="tab-pane" id="insurances-tab">
            <fieldset>
              <legend><span sxy-text="SALAXY.NG1.ProSettingsComponent.insurances"></span> </legend>
              <sxy-input model="form.calc.pensionContracts" template-url="salaxy-components/sxy-form/custom-templates/array-pension.html">
                <form>
                  <fieldset>
                    <sxy-input model="form.company"></sxy-input>
                    <sxy-input model="form.contractNumber" format="pension-contract-number"></sxy-input>
                    <sxy-input model="form.startDate" format="date"></sxy-input>
                    <sxy-input model="form.endDate" format="date"></sxy-input>
                    <sxy-input model="form.pensionDefaultPercent"></sxy-input>
                    <sxy-input model="form.pensionPercent"></sxy-input>
                    <sxy-input ng-show="['kevaMunicipal','kevaAland','kevaChurch','kevaKela','kevaState'].indexOf($ctrl.current.company) >= 0" model="form.subOrgCode"></sxy-input>
                    <sxy-input ng-show="'admin' | sxyIsInRole" model="form.pensionDiscountPercent"></sxy-input>
                    <sxy-input ng-show="'admin' | sxyIsInRole" model="form.status" read-only="false"></sxy-input>
                    <sxy-input ng-show="'!admin' | sxyIsInRole" model="form.status" read-only="true"></sxy-input>
                    <!--sxy-input model="form.id" read-only="true"></sxy-input-->
                  </fieldset>
                </form>
              </sxy-input>
              <sxy-input model="form.calc.insuranceContracts" template-url="salaxy-components/sxy-form/custom-templates/array-insurance.html">
                <form>
                  <fieldset>
                    <legend><span sxy-text="SALAXY.NG1.ProSettingsComponent.insurance"></span> </legend>
                    <sxy-input model="form.company"></sxy-input>
                    <sxy-input model="form.contractNumber"></sxy-input>
                    <sxy-input model="form.startDate" format="date"></sxy-input>
                    <sxy-input model="form.endDate" format="date"></sxy-input>
                    <sxy-input model="form.insurancePercent"></sxy-input>
                    <sxy-input model="form.groupLifeInsurancePercent"></sxy-input>
                    <sxy-input model="form.isPartnerInsurance"></sxy-input>
                    <sxy-input ng-show="'admin' | sxyIsInRole" model="form.status" read-only="false"></sxy-input>
                    <sxy-input ng-show="'!admin' | sxyIsInRole" model="form.status" read-only="true"></sxy-input>
                    <!--sxy-input model="form.id" read-only="true"></sxy-input-->
                  </fieldset>
                </form>
              </sxy-input>
            </fieldset>
            <fieldset>
              <legend><span sxy-text="SALAXY.NG1.ProSettingsComponent.unemploymentInsurance"></span> </legend>
              <sxy-input model="form.calc.unemploymentInsurance.payrollLimitStatus"></sxy-input>
            </fieldset>
          </div>
          <div class="tab-pane" id="rows-tab">
            <salaxy-calc-rows-editor ng-if="!$ctrl.isLoading" rows="$ctrl.current.calc.salaryDefaults"
              title="{{ 'SALAXY.NG1.WorkerDetailsComponent.defaultCalcRows' | sxyTranslate }}" type="salary-defaults"></salaxy-calc-rows-editor>
          </div>
          <div class="tab-pane" id="coms-tab">
            <fieldset>
              <legend><span sxy-text="SALAXY.NG1.ProSettingsComponent.messaging"></span> <span
                  ng-if="!$ctrl.current.messaging.denyServiceModel && $ctrl.current.partner.serviceModel.features.messaging" class="badge bg-danger float-end"
                  sxy-text="SALAXY.NG1.ProSettingsComponent.serviceModelBadge"></span></legend>
              <sxy-input model="form.partner.serviceModel.features.messaging" label="SALAXY.NG1.ProSettingsComponent.customMessages" read-only="true"></sxy-input>
              <salaxy-input-boolean label="SALAXY.NG1.ProSettingsComponent.overwriteServiceModel" name="messagingDeny" ng-change="$ctrl.confirmServiceModelChange()"
                ng-if="$ctrl.current.partner.serviceModel.features.messaging" ng-model="$ctrl.current.messaging.denyServiceModel"></salaxy-input-boolean>
              <salaxy-input-boolean ng-if="$ctrl.current.partner.serviceModel.features.messaging" read-only="!$ctrl.current.messaging.denyServiceModel"
                ng-model="$ctrl.current.messaging.partnerMessages" name="partnerMessages" label="SALAXY.NG1.ProSettingsComponent.messagesAccountant"></salaxy-input-boolean>
              <salaxy-input-enum read-only="!$ctrl.current.messaging.denyServiceModel && $ctrl.current.partner.serviceModel.features.messaging" type="multi-select"
                enum="WorkerSalaryNotification" ng-model="$ctrl.current.messaging.workerSalaryNotifications" name="workerSalaryNotifications"
                label="SALAXY.NG1.ProSettingsComponent.messagesPayment"></salaxy-input-enum>
              <salaxy-input-enum read-only="!$ctrl.current.messaging.denyServiceModel && $ctrl.current.partner.serviceModel.features.messaging" type="multi-select"
                enum="WorkerSalarySlipDeliveryMethod" ng-model="$ctrl.current.messaging.workerSalarySlipDeliveryMethods" name="workerSalarySlipDeliveryMethods"
                label="SALAXY.NG1.ProSettingsComponent.workerSalarySlipDeliveryMethods"></salaxy-input-enum>
            </fieldset>
            <fieldset ng-init="$ctrl.isReportLogoManuallyUploaded = false">
              <legend><span sxy-text="SALAXY.NG1.ProSettingsComponent.reporting"></span> <span
                  ng-if="!$ctrl.current.reporting.denyServiceModel && $ctrl.current.partner.serviceModel.features.reporting" class="badge bg-danger float-end"
                  sxy-text="SALAXY.NG1.ProSettingsComponent.serviceModelBadge"></span></legend>
              <sxy-input model="form.partner.serviceModel.features.reporting" label="SALAXY.NG1.ProSettingsComponent.customReporting" read-only="true"></sxy-input>
              <salaxy-input-boolean label="SALAXY.NG1.ProSettingsComponent.overwriteServiceModel" name="uc4" ng-change="$ctrl.confirmServiceModelChange()"
                ng-if="$ctrl.current.partner.serviceModel.features.reporting" ng-model="$ctrl.current.reporting.denyServiceModel"></salaxy-input-boolean>
              <salaxy-input-enum read-only="!$ctrl.current.reporting.denyServiceModel && $ctrl.current.partner.serviceModel.features.reporting"
                ng-model="$ctrl.current.reporting.layoutTemplateId" name="layputTemplateId" label="SALAXY.NG1.ProSettingsComponent.layoutTemplateId" options="{'palkkaus-report-options@FI53POYS0025543933': ('SALAXY.NG1.ProSettingsComponent.templateIdPalkkaus' | sxyTranslate),
                'no-logo-report-options@FI53POYS0025543933': ('SALAXY.NG1.ProSettingsComponent.templateIdNoLogo' | sxyTranslate),
                'logo-report-options@FI53POYS0025543933': ('SALAXY.NG1.ProSettingsComponent.templateIdLogo' | sxyTranslate)
               }"></salaxy-input-enum>
               <salaxy-input-boolean ng-if="$ctrl.current.reporting.layoutTemplateId == 'logo-report-options@FI53POYS0025543933'" type="radio" name="reportLogoUploadType" label="SALAXY.NG1.ProSettingsComponent.fileUpload.uploadMethod" ng-model="$ctrl.isReportLogoManuallyUploaded" label-true="SALAXY.NG1.ProSettingsComponent.fileUpload.manualUpload" label-false="SALAXY.NG1.ProSettingsComponent.fileUpload.uploadFromDevice"></salaxy-input-boolean>
               <div class="form-group row" ng-if="!$ctrl.isReportLogoManuallyUploaded && $ctrl.current.reporting.layoutTemplateId == 'logo-report-options@FI53POYS0025543933'">
                  <div class="col-xs-12 col-sm-4">
                    <label for="avatarImageUpload" sxy-text="SALAXY.NG1.ProSettingsComponent.fileUpload.previewLabel"></label>
                  </div>
                  <div class="col-xs-12 col-sm-8">
                    <div name="avatarImageUpload" ng-model="avatarImage" ngf-drop="$ctrl.createReportLogoDatauri($file)" ngf-select="$ctrl.createReportLogoDatauri($file)" class="salaxy-drop-box" ngf-drag-over-class="'salaxy-drag-over'" ngf-multiple="false" ngf-min-size="1KB" ngf-max-size="10MB"
                       ngf-model-invalid="invalidFile" ng-class="invalidFile.$error != null ? 'error' : ''">
                      <span sxy-html="SALAXY.NG1.AccountAvatarEditPersonComponent.uploadImage.html"></span>
                      <p sxy-text="SALAXY.NG1.AccountAvatarEditPersonComponent.preferredImageSize"></p>
                    </div>
                  </div>
                  
              </div>
              <salaxy-textarea maxlength="" read-only="!$ctrl.current.reporting.denyServiceModel && $ctrl.current.partner.serviceModel.features.reporting"
                label="SALAXY.NG1.ProSettingsComponent.customReportLogo" name="logo" ng-model="$ctrl.current.reporting.logo" rows="3"
                ng-if="$ctrl.current.reporting.layoutTemplateId == 'logo-report-options@FI53POYS0025543933' && $ctrl.isReportLogoManuallyUploaded">
              </salaxy-textarea>
              <div class="form-group row" ng-if="$ctrl.current.reporting.logo && $ctrl.current.reporting.layoutTemplateId == 'logo-report-options@FI53POYS0025543933'">
                <div class="col-xs-12 col-sm-4">
                  <label for="avatarImageUpload" sxy-text="Logo"></label>
                </div>
                <div class="col-xs-12 col-sm-8">
                  <div class="salaxy-report-logo-preview">
                    <div ng-bind-html="$ctrl.getReportLogo()" ></div>
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
          <div class="tab-pane" id="paymentchannels-tab">
            <fieldset>
              <legend><span sxy-text="SALAXY.NG1.ProSettingsComponent.selfHandling"></span> </legend>
              <sxy-input model="form.payments.customerFunds.isWorkerSelfHandling"></sxy-input>
              <sxy-input model="form.payments.customerFunds.isPensionSelfHandling"></sxy-input>
              <sxy-input model="form.payments.customerFunds.isTaxAndSocialSecuritySelfHandling"></sxy-input>
            </fieldset>
            <fieldset>
              <legend><span sxy-text="SALAXY.NG1.ProSettingsComponent.invoices"></span> </legend>
              <sxy-input model="form.payments.invoice.eInvoiceReceiver"></sxy-input>
              <sxy-input model="form.payments.invoice.eInvoiceIntermediator"></sxy-input>
              <sxy-input model="form.payments.invoice.sepaBankPartyId"></sxy-input>
              <sxy-input model="form.payments.invoice.ibanNumber"></sxy-input>
            </fieldset>
            <fieldset>
              <legend><span sxy-text="SALAXY.NG1.ProSettingsComponent.paymentChannels"></span> <span
                  ng-if="!$ctrl.current.payments.denyServiceModel && $ctrl.current.partner.serviceModel.features.payments" class="badge bg-danger float-end"
                  sxy-text="SALAXY.NG1.ProSettingsComponent.serviceModelBadge"></span></legend>
              <sxy-input model="form.partner.serviceModel.features.payments" label="SALAXY.NG1.ProSettingsComponent.customPaymentChannels" read-only="true"></sxy-input>
              <salaxy-input-boolean label="SALAXY.NG1.ProSettingsComponent.overwriteServiceModel" name="uc1" ng-change="$ctrl.confirmServiceModelChange()"
                ng-if="$ctrl.current.partner.serviceModel.features.payments" ng-model="$ctrl.current.payments.denyServiceModel"></salaxy-input-boolean>
  
              <salaxy-input-typeahead class="default-channel-input-enum" disabled="!$ctrl.current.payments.denyServiceModel && $ctrl.current.partner.serviceModel.features.payments"
                name="options_type" ng-model="$ctrl.current.payments.defaultChannel" options="$ctrl.getSelectablePaymenMethods()" disable-cache="true"
                label="SALAXY.NG1.ProSettingsComponent.defaultChannel"></salaxy-input-typeahead>
  
              <sxy-input class="payment-channels" template-url="salaxy-components/sxy-form/custom-templates/array-payment-channels.html" model="form.payments.channels"
                read-only="{{!$ctrl.current.payments.denyServiceModel && $ctrl.current.partner.serviceModel.features.payments}}">
                <form>
                  <fieldset ng-init="$ctrl.logic.showDelete = false">
                    <sxy-input model="form.channel" read-only="true"></sxy-input>
                    <sxy-input model="form.isAvailable" read-only="true"></sxy-input>
                    <sxy-input model="form.isEnabled" read-only="{{!$ctrl.current.isAvailable}}"></sxy-input>
                  </fieldset>
                </form>
              </sxy-input>
            </fieldset>
          </div>
          <div class="tab-pane" id="dimensions-tab">
            <fieldset>
              <legend><span sxy-text="SALAXY.MODEL.CostAccountingSettings.title"></span> <span
                  ng-if="!$ctrl.current.costAccounting.denyServiceModel && $ctrl.current.partner.serviceModel.features.costAccounting" class="badge bg-danger float-end"
                  sxy-text="SALAXY.NG1.ProSettingsComponent.serviceModelBadge"></span></legend>
              <sxy-input model="form.partner.serviceModel.features.costAccounting" label="SALAXY.NG1.ProSettingsComponent.customCostAccounting" read-only="true"></sxy-input>
              <salaxy-input-boolean label="SALAXY.NG1.ProSettingsComponent.overwriteServiceModel" name="uc5" ng-change="$ctrl.confirmServiceModelChange()"
                ng-if="$ctrl.current.partner.serviceModel.features.costAccounting" ng-model="$ctrl.current.costAccounting.denyServiceModel"></salaxy-input-boolean>
              <sxy-input model="form.costAccounting.dimensions"
                read-only="{{!$ctrl.current.costAccounting.denyServiceModel  && $ctrl.current.partner.serviceModel.features.costAccounting }}" include="id,label,scope">
                <form>
                  <fieldset>
                    <legend sxy-text="SALAXY.MODEL.CostAccountingDimensionDefinition.title"></legend>
                    <sxy-input model="form.id" read-only="{{$ctrl.logic.showDelete}}"></sxy-input>
                    <sxy-input model="form.label"></sxy-input>
                    <sxy-input model="form.allowCostSharing"></sxy-input>
                    <sxy-input model="form.scope"></sxy-input>
                    <sxy-input model="form.options" template-url="salaxy-components/sxy-form/custom-templates/cost-accounting-options.html"></sxy-input>
                  </fieldset>
                </form>
              </sxy-input>
            </fieldset>
          </div>
          <div class="tab-pane" id="accounting-tab">
            <fieldset>
              <legend><span sxy-text="SALAXY.NG1.ProSettingsComponent.accounting"></span> <span
                  ng-if="!$ctrl.current.accounting.denyServiceModel && $ctrl.current.partner.serviceModel.features.accounting" class="badge bg-danger float-end"
                  sxy-text="SALAXY.NG1.ProSettingsComponent.serviceModelBadge"></span></legend>
              <sxy-input model="form.partner.serviceModel.features.accounting" label="SALAXY.NG1.ProSettingsComponent.customAccounting" read-only="true"></sxy-input>
              <salaxy-input-boolean label="SALAXY.NG1.ProSettingsComponent.overwriteServiceModel" name="uc2" ng-change="$ctrl.confirmServiceModelChange()"
                ng-if="$ctrl.current.partner.serviceModel.features.accounting" ng-model="$ctrl.current.accounting.denyServiceModel"></salaxy-input-boolean>
              <salaxy-input-typeahead 
                name="options_type" ng-model="$ctrl.current.accounting.defaultTargetId" options="$ctrl.getSelectableAccountingTargets()" disable-cache="true"
                label="SALAXY.NG1.ProSettingsComponent.defaultTarget"></salaxy-input-typeahead>
              <sxy-input template-url="salaxy-components/sxy-form/custom-templates/array-accounting-targets.html" model="form.accounting.targets"
                read-only="{{!$ctrl.current.accounting.denyServiceModel  && $ctrl.current.partner.serviceModel.features.accounting}}">
                <form>
                  <fieldset ng-show="!$ctrl.logic.showDelete" ng-controller="CompanySettingsController as $companySettingsCtrl" ng-init="$ctrl.logic.isReadOnly = true">
                    <salaxy-odata-table url="/v03/api/accounting-target" template-url="salaxy-components/odata/lists/AccountingTargetSelect.html"
                      selected-items="$ctrl.selectedItems" on-list-select="$companySettingsCtrl.onAccountingTargetSelect($ctrl.current, $ctrl.logic, value, item, allItems)">
                    </salaxy-odata-table>
                  </fieldset>
                  <fieldset ng-show="$ctrl.logic.showDelete" ng-controller="AccountingChannelSettingsController as $settings" ng-init="$ctrl.logic.isReadOnly = false">
                    <salaxy-input-enum disabled="false" name="format" label="SALAXY.NG1.AccountingTargetDetailsComponent.excelCsvFormat" ng-model="$ctrl.current.format"
                      options="{
                        '36dff2e2-e181-4f0d-9004-0e4aa92f5e17': 'Palkkaus.fi',
                        '0db4e85f-93a8-46f1-b6d2-f7523d289d88': 'Fennoa',
                        '8613f133-3fce-4611-b372-51f6a2e007dd': 'Procountor',
                        'e62c10b0-222a-4170-b8b4-b1e02d9a7644': 'Passeli Merit',
                        '53fd3863-b8f9-4909-86c9-cb4597595181': 'Heeros',
                        '2fc7899c-7a3d-4d56-ad2f-05d52782bbbc': 'Asteri',
                        '0a2bd312-06da-4862-aef5-75166e0bf461': 'Maestro',
                        'c04e0757-63f3-420d-a183-3427710fc954': 'Visma Fivaldi',
                        'ba271dac-dd63-4036-9d70-053a09ca4d9e' :'Visma Netvisor',
                        '27e271d5-41f5-4319-ab29-4d5d9eb945c6': 'Lemonsoft',
                        'd311f9d3-8c3a-4fd8-a665-8e3698e41e87': 'Tampuuri',
                        'd58e95b7-d0b5-40ac-992b-6d3b29efc45e': 'Domus',
                        '54e93c5f-bd74-4157-8a74-3515be7f585d': 'Oscar Software',
                        '0e4f0a71-dcb9-43ba-9028-0239e674711f': 'Digia Enterprise',
                        '2ccefa46-7992-46c5-9d87-b88336935916': 'Digia Enterprise - VILPE'
                      }">
                    </salaxy-input-enum>
                    <sxy-input model="form.method" read-only="false"></sxy-input>
                    <salaxy-input-enum disabled="false" enum="ExportMethod" label="SALAXY.MODEL.AccountingTargetSettings.availableMethods.title" name="availableMethods"
                      type="multi-select" ng-model="$ctrl.current.availableMethods"></salaxy-input-enum>
                    <button ng-show="$settings.isApiIntegration($ctrl.current)" type="button" class="btn btn-sm btn-default"
                      ng-click="$settings.openChannelSetupDialog($ctrl.current, $close)">
                      Siirry APIn konfigurointiin <i class="bi bi-box-arrow-up-right"></i>
                    </button>
                    <button ng-show="$settings.isApiIntegration($ctrl.current)" type="button" class="btn btn-sm btn-default"
                      ng-click="$settings.configureCoa($ctrl.current, $close)">
                      Siirry tilikartan konfigurointiin <i class="bi bi-chevron-right"></i>
                    </button>
                  </fieldset>
                </form>
              </sxy-input>
              <sxy-input model="form.accounting.defaultPeriodDateKind"
                read-only="{{!$ctrl.current.accounting.denyServiceModel  && $ctrl.current.partner.serviceModel.features.accounting}}"></sxy-input>
              <salaxy-input-enum ng-if="$ctrl.defaultAccountingTarget"
                read-only="!$ctrl.current.accounting.denyServiceModel  && $ctrl.current.partner.serviceModel.features.accounting" type="select" name="method"
                ng-model="$ctrl.defaultAccountingTarget.method" enum="ExportMethod" label="SALAXY.MODEL.AccountingTargetSettings.method.title"></salaxy-input-enum>
              <legend sxy-text="SALAXY.MODEL.AccountingSettings.reportDelivery.title"></legend>
              <sxy-input model="form.accounting.reportDelivery.isEnabled"></sxy-input>
              <sxy-input model="form.accounting.reportDelivery.address"></sxy-input>
              <legend sxy-text="SALAXY.MODEL.AccountingSettings.accountantReportDelivery.title"></legend>
              <sxy-input model="form.accounting.accountantReportDelivery.isEnabled"></sxy-input>
              <sxy-input model="form.accounting.accountantReportDelivery.address"></sxy-input>
            </fieldset>
          </div>
          <div class="tab-pane" id="holidays-tab">
            <fieldset>
              <legend><span sxy-text="SALAXY.MODEL.HolidaySettings.title"></span> <span
                  ng-if="!$ctrl.current.costAccounting.denyServiceModel && $ctrl.current.partner.serviceModel.features.holiday" class="badge bg-danger float-end"
                  sxy-text="SALAXY.NG1.ProSettingsComponent.serviceModelBadge"></span></legend>
              <sxy-input model="form.partner.serviceModel.features.holiday" label="SALAXY.NG1.ProSettingsComponent.customHoliday" read-only="true"></sxy-input>
              <salaxy-input-boolean label="SALAXY.NG1.ProSettingsComponent.overwriteServiceModel" name="uc6" ng-change="$ctrl.confirmServiceModelChange()"
                ng-if="$ctrl.current.partner.serviceModel.features.holiday" ng-model="$ctrl.current.holiday.denyServiceModel"></salaxy-input-boolean>
              <sxy-input model="form.holiday.holidayPaySettings"
                read-only="{{!$ctrl.current.holiday.denyServiceModel  && $ctrl.current.partner.serviceModel.features.holiday }}" include="holidayPayCalculation">
                <form>
                  <fieldset>
                    <legend sxy-text="SALAXY.MODEL.HolidayPaySettings.title"></legend>
                    <salaxy-input-enum enum="HolidayPayCalculation" label="SALAXY.MODEL.HolidayPaySettings.holidayPayCalculation.title" name="holidayPayCalculation" filter="averageDailyPay,averageHourlyPay,percentageBasedPay,holidayCompensation" require="true" ng-model="$ctrl.current.holidayPayCalculation" read-only="$ctrl.getReadOnly()"></salaxy-input-enum>
                    <legend sxy-text="SALAXY.MODEL.HolidayPaySettings.salaryTypes.title"></legend>
                    <sxy-input model="form.salaryTypes" template-url="salaxy-components/sxy-form/custom-templates/holiday-row-types.html"></sxy-input>
                    <legend ng-show="$ctrl.current.holidayPayCalculation == 'averageHourlyPay'" sxy-text="SALAXY.MODEL.HolidayPaySettings.workingTimeTypes.title"></legend>
                    <sxy-input ng-show="$ctrl.current.holidayPayCalculation == 'averageHourlyPay'" model="form.workingTimeTypes" template-url="salaxy-components/sxy-form/custom-templates/holiday-row-types.html"></sxy-input>
                    <legend ng-show="$ctrl.current.holidayPayCalculation == 'averageDailyPay'" sxy-text="SALAXY.MODEL.HolidayPaySettings.overtimeTypes.title"></legend>
                    <sxy-input  ng-show="$ctrl.current.holidayPayCalculation == 'averageDailyPay'" model="form.overtimeTypes" template-url="salaxy-components/sxy-form/custom-templates/holiday-row-types.html"></sxy-input>
                    <legend ng-show="$ctrl.current.holidayPayCalculation == 'averageHourlyPay' || $ctrl.current.holidayPayCalculation == 'averageDailyPay'" sxy-text="SALAXY.MODEL.HolidayPaySettings.multipliers.title"></legend>
                    <salaxy-input-holiday-multipliers ng-show="$ctrl.current.holidayPayCalculation == 'averageHourlyPay' || $ctrl.current.holidayPayCalculation == 'averageDailyPay'" name="multipliers" label="SALAXY.MODEL.HolidayPaySettings.multipliers.title" ng-model="$ctrl.current.multipliers" read-only="$ctrl.getReadOnly()"></salaxy-input-holiday-multipliers>
                  </fieldset>
                </form>
              </sxy-input>
              <sxy-input model="form.holiday.holidayAccrualSettings"
                read-only="{{!$ctrl.current.holiday.denyServiceModel  && $ctrl.current.partner.serviceModel.features.holiday }}" include="code">
                <form>
                  <fieldset>
                    <legend sxy-text="SALAXY.MODEL.HolidayAccrualSettings.title"></legend>
                    <salaxy-input-enum enum="HolidayCode" label="SALAXY.MODEL.HolidayAccrualSettings.code.title" name="code" filter="permanent35Hours,other" require="true" ng-model="$ctrl.current.code" read-only="$ctrl.getReadOnly()"></salaxy-input-enum>
                    <legend sxy-text="SALAXY.MODEL.HolidayAccrualSettings.workingTimeTypes.title"></legend>
                    <sxy-input model="form.workingTimeTypes" template-url="salaxy-components/sxy-form/custom-templates/holiday-row-types.html"></sxy-input>
                  </fieldset>
                </form>
              </sxy-input>
            </fieldset>
          </div>
          <div class="tab-pane" id="other-tab">
            <fieldset>
              <legend><span sxy-text="SALAXY.NG1.ProSettingsComponent.incomesRegister"></span> </legend>
              <sxy-input model="form.calc.incomesRegister.irReporting"></sxy-input>
              <sxy-input model="form.calc.incomesRegister.taxReferenceNumber"></sxy-input>
            </fieldset>
            <fieldset>
              <legend><span sxy-text="SALAXY.NG1.ProSettingsComponent.usecases"></span> <span
                  ng-if="!$ctrl.current.usecase.denyServiceModel && $ctrl.current.partner.serviceModel.features.usecase" class="badge bg-danger float-end"
                  sxy-text="SALAXY.NG1.ProSettingsComponent.serviceModelBadge"></span></legend>
              <sxy-input model="form.usecase.serverUrl" label="Integration server (staging)"></sxy-input>
              <sxy-input model="form.partner.serviceModel.features.usecase" label="SALAXY.NG1.ProSettingsComponent.customUsecases" read-only="true"></sxy-input>
              <salaxy-input-boolean label="SALAXY.NG1.ProSettingsComponent.overwriteServiceModel" name="uc3" ng-change="$ctrl.confirmServiceModelChange()"
                ng-if="$ctrl.current.partner.serviceModel.features.usecase" ng-model="$ctrl.current.usecase.denyServiceModel"></salaxy-input-boolean>
              <sxy-input template-url="salaxy-components/sxy-form/custom-templates/array-usecase.html" model="form.usecase.usecases"
                read-only="{{!$ctrl.current.usecase.denyServiceModel  && $ctrl.current.partner.serviceModel.features.usecase}}">
                <form>
                  <fieldset ng-show="!$ctrl.logic.showDelete" ng-controller="CompanySettingsController as $companySettingsCtrl">
                    <salaxy-odata-table url="/v03/api/usecases" template-url="salaxy-components/odata/lists/UsecaseSelect.html" selected-items="$ctrl.selectedItems"
                      on-list-select="$companySettingsCtrl.onUsecaseSelect($ctrl.current, $ctrl.logic, value, item, allItems)">
                    </salaxy-odata-table>
                  </fieldset>
                  <fieldset ng-show="$ctrl.logic.showDelete">
                    <sxy-input model="form.uri" read-only="true"></sxy-input>
                    <sxy-input model="form.label" read-only="true"></sxy-input>
                    <sxy-input model="form.itemType" read-only="true"></sxy-input>
                    <sxy-input model="form.status"></sxy-input>
                    <sxy-input model="form.order"></sxy-input>
                  </fieldset>
                </form>
              </sxy-input>
            </fieldset>
          </div>
          <div class="tab-pane" id="irdelivery-tab">
            <fieldset>
              <legend>Tulorekisterivarmenteen omistaja</legend>
              <p
                sxy-text="Jos haluat käyttää tilitoimistovarmennetta Palkkaus.fi:n varmenteen sijasta, anna käytettävän varmenteen Y-tunnus.">
              </p>
              <salaxy-input label="Tulorekisterivarmenteen omistajan Y-tunnus" name="senderOfficialId"
                ng-model="$ctrl.current.calc.incomesRegister.irDelivery.senderOfficialId"></salaxy-input>
            </fieldset>
            <fieldset>
              <legend>Tulorekisteriraportin yhteyshenkilöt</legend>
              <table class="table">
                <thead>
                  <tr>
                    <th>{{('Nimi') | sxyTranslate}}</th>
                    <th>{{('Puhelin') | sxyTranslate}}</th>
                    <th>{{('Sähköposti') | sxyTranslate}}</th>
                    <th>{{('Vastuualue') | sxyTranslate}}</th>
                    <th class="right">
                      <button type="button" class="btn btn-primary btn-xs"
                        ng-click="$ctrl.current.calc.incomesRegister.irDelivery.contactPersons.push({})" sxy-text="SALAXY.UI_Terms.addRow"></button>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr ng-repeat="item in $ctrl.current.calc.incomesRegister.irDelivery.contactPersons">
                    <td>
                      <salaxy-input require="true" ng-model="item.name" name="{{ 'name' + $index }}" label-type="plain"></salaxy-input>
                    </td>
                    <td>
                      <salaxy-input require="true" ng-model="item.telephone" name="{{ 'telephone' + $index }}" label-type="plain" sxy-mobile-phone></salaxy-input>
                    </td>
                    <td>
                      <salaxy-input require="true" ng-model="item.email" name="{{ 'email' + $index }}" label-type="plain" sxy-email></salaxy-input>
                    </td>
                    <td>
                      <salaxy-input-enum require="true" ng-model="item.responsibilityCode" name="{{ 'responsibilityCode' + $index }}" label-type="plain" type="select"
                        options="{ contentIssues: 'Raporttien sisältö', technicalIssues: 'Tekniset asiat' }"></salaxy-input-enum>
                    </td>
                    <td class="text-right">
                      <button type="button" class="btn btn-danger" ng-click="$ctrl.current.calc.incomesRegister.irDelivery.contactPersons.splice($index, 1)">
                        <i class="bi bi-trash" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </fieldset>
            <legend>Yrityksesi tulorekisterivarmenteen tila</legend>
                <table class="table">
                  <tr>
                    <th>Luotu</th>
                    <th>Voimassaolo päättyy</th>
                  </tr>
                  <tr ng-if="!$ctrl.irCertificate.id">
                    <td colspan="2">Ei voimassa olevaa varmennetta</td>
                  </tr>
                  <tr ng-if="$ctrl.irCertificate.id">
                    <td>{{$ctrl.irCertificate.updatedAt | date}}</td>
                    <td>{{$ctrl.irCertificate.expiresAt | date}}</td>
                  </tr>
                </table>
              </fieldset>
              <fieldset>
                <legend>Varmenteen luonti/uusinta</legend>
                <salaxy-input-enum ng-if="$ctrl.irCertificate.id" ng-init="$ctrl.irCertificateAction = 'renew'" label="Toimenpide" ng-model="$ctrl.irCertificateAction" name="certAction" type="radio"
                  options="{ create: 'Luo uusi varmenne', renew: 'Uusi nykyinen varmenne' }"></salaxy-input-enum>
                <salaxy-input-enum ng-if="!$ctrl.irCertificate.id" ng-init="$ctrl.irCertificateAction = 'create'" label="Toimenpide" ng-model="$ctrl.irCertificateAction" name="certAction" type="radio"
                  options="{ create: 'Luo uusi varmenne'}"></salaxy-input-enum>
                <salaxy-input ng-if="$ctrl.irCertificateAction == 'create'" require="true" label="Siirtotunnus" ng-model="$ctrl.irCertificateTransferId"
                  name="transferId"></salaxy-input>
                <salaxy-input ng-if="$ctrl.irCertificateAction == 'create'" require="true" label="Kertakäyttösalasana" ng-model="$ctrl.irCertificateTransferPassword"
                  name="transferPassword" type="password"></salaxy-input>

                  <div class="row">
                    <div class="col-xs-12 text-right">
                      <button type="button" ng-if="$ctrl.irCertificateAction == 'create'" class="btn btn-primary" ng-disabled="$ctrl.isSaving('irCertificate')"
                        ng-click="$ctrl.createIrCertificate($ctrl.irCertificateTransferId, $ctrl.irCertificateTransferPassword)"><span ng-if="$ctrl.isSaving('irCertificate')"><i
                            class="bi bi-arrow-repeat bi-spin"></i></span><span sxy-text="Luo uusi varmenne"></span></button>
                      <button type="button" ng-if="$ctrl.irCertificateAction == 'renew'" class="btn btn-primary" ng-disabled="$ctrl.isSaving('irCertificate')"
                        ng-click="$ctrl.renewIrCertificate()"><span ng-if="$ctrl.isSaving('irCertificate')"><i class="bi bi-arrow-repeat bi-spin"></i></span><span
                          sxy-text="Uusi nykyinen varmenne"></span></button>
                    </div>
                  </div>
              </fieldset>
          </div>
          <div class="tab-pane" id="readonly-tab">
            <fieldset>
              <legend><span sxy-text="SALAXY.NG1.ProSettingsComponent.pricing"></span> <span ng-if="$ctrl.current.partner.accountId" class="badge bg-danger float-end"
                  sxy-text="SALAXY.NG1.ProSettingsComponent.serviceModelBadge"></span></legend>
              <sxy-input model="form.partner.serviceModel.pricing.pricingModel" read-only="true"></sxy-input>
              <sxy-input model="form.partner.serviceModel.pricing.fixedFee" read-only="true"></sxy-input>
            </fieldset>
            <fieldset>
              <legend><span sxy-text="SALAXY.NG1.ProSettingsComponent.webApp"></span> <span class="badge bg-danger float-end"
                  sxy-text="SALAXY.NG1.ProSettingsComponent.serviceModelBadge"></span></legend>
              <sxy-input model="form.partner.serviceModel.site.webApp" read-only="true"></sxy-input>
              <sxy-input model="form.partner.serviceModel.site.webAppUrl" read-only="true"></sxy-input>
              <sxy-input model="form.partner.serviceModel.site.webAppName" read-only="true"></sxy-input>
            </fieldset>
            <fieldset>
              <legend><span sxy-text="SALAXY.NG1.ProSettingsComponent.branding"></span> <span class="badge bg-danger float-end"
                  sxy-text="SALAXY.NG1.ProSettingsComponent.serviceModelBadge"></span></legend>
              <sxy-input model="form.partner.serviceModel.branding.logo" read-only="true"></sxy-input>
              <sxy-input model="form.partner.serviceModel.branding.skin" read-only="true"></sxy-input>
            </fieldset>
            <fieldset>
              <legend><span sxy-text="SALAXY.MODEL.FormsSettings.title"></span> <span
                  ng-if="!$ctrl.current.forms.denyServiceModel && $ctrl.current.partner.serviceModel.features.forms" class="badge bg-danger float-end"
                  sxy-text="SALAXY.NG1.ProSettingsComponent.serviceModelBadge"></span></legend>
              <sxy-input model="form.partner.serviceModel.features.forms" label="SALAXY.NG1.ProSettingsComponent.customForms" read-only="true"></sxy-input>
            </fieldset>
            <fieldset>
              <legend><span sxy-text="Tulorekisterin varmenne"></span> <span
                  ng-if="$ctrl.current.partner.serviceModel.features.irDelivery" class="badge bg-danger float-end"
                  sxy-text="SALAXY.NG1.ProSettingsComponent.serviceModelBadge"></span></legend>
              <sxy-input model="form.partner.serviceModel.features.irDelivery" label="Tilitoimiston asettama varmenne käytössä" read-only="true"></sxy-input>
            </fieldset>
          </div>
        </div>
      </div>
    </sxy-form>
  </div>
</div>`), s.put("salaxy-components/settings/RowTypesSettings.html", `<div class="salaxy-component salaxy-pro-settings" ng-class="'salaxy-pro-settings-' + $ctrl.mode"
  ng-if="$ctrl.current" ng-switch="$ctrl.mode">
  <div ng-switch-when="custom">
    <div class="d-flex mb-3 align-items-center">
      <div class="btn-group">
        <button id="categories" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false" ng-disabled="disabled">
          Kategoriat
        </button>
        <ul class="dropdown-menu" aria-labelledby="categories">
          <li><a class="dropdown-item" href="" ng-click="$ctrl.categories = null">All categories (no filter)</a></li>
          <li><a class="dropdown-item" href="" ng-click="$ctrl.categories = ['salary', 'salaryCalc', 'holidays', 'salaryAdditions']">Salaries and additions</a></li>
          <li><a class="dropdown-item" href="" ng-click="$ctrl.categories = ['benefits']">Benefits</a></li>
          <li><a class="dropdown-item" href="" ng-click="$ctrl.categories = ['expenses']">Expenses</a></li>
          <li><a class="dropdown-item" href="" ng-click="$ctrl.categories = ['deductions']">Deductions</a></li>
          <li><a class="dropdown-item" href="" ng-click="$ctrl.categories = ['other']">Other</a></li>
        </ul>
      </div>
      <div class="form-horizontal ms-2 flex-grow-1">
        <salaxy-input name="calcRowTypeSearch" ng-model="$ctrl.searchText" label="Search name and description"></salaxy-input>
      </div>
    </div>
    <ng-include src="'salaxy-components/settings/RowTypesSettings_table.html'"></ng-include>
  </div>
  <div ng-switch-when="prices">
    <table class="table table-condensed">
      <thead>
        <tr>
          <th colspan="2">Palkkalajien hinnat</th>
          <th class="right" sxy-text="SALAXY.NG1.DateRange.labelStartAndEndDate"></th>
          <th class="right" sxy-text="SALAXY.NG1.CalcRowsComponent.editor.price"></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.pricesList">
          <td style="width: 32px;">
            <salaxy-avatar ng-if="row.rowType" class="salaxy-calc-row-type-avatar"
              avatar="{ color: $ctrl.getConfig(row).color, initials: $ctrl.getConfig(row).iconText, entityType: 'company' }"></salaxy-avatar>
          </td>
          <td style="width: 40%;">
            <div>{{$ctrl.getMessagePlaceholderText(row)}}</div>
            <div><small><code>{{ row.type }}{{ row.data.kind ? "/" + row.data.kind : "" }}</code></small>  &nbsp;</div>
          </td>
          <td class="right middle">
            <div>{{ row.period | sxyDateRange }}&nbsp;&nbsp;</div>
          </td>
          <td class="right">
            <salaxy-input-number name="{{ 'iptPrice' + row.rowIndex }}" ng-model="row.price" label-type="plain"  disabled="$ctrl.isDisabled(row, 'price')" require="true"></salaxy-input-number>
          </td>
          <td class="right" style="width: 120px;">
            <button type="button" class="edit btn btn-info" ng-click="$ctrl.showEdit(row, 'auto')"
              title="{{'SALAXY.NG1.CalcRowsComponent.editor.buttons.infoIcon' | sxyTranslate}}"><i class="bi bi-pencil-fill"></i></button>
            <button type="button" class="btn btn-danger" ng-click="$ctrl.delete(row)"><i class="bi bi-trash-fill"></i>
            </button>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td></td>
          <td class="middle">
            Lisää hinta:
          </td>
          <td>
            <salaxy-calc-row-type name="newRowType" model="$ctrl.newRow" placeholder="SALAXY.NG1.CalcRowsComponent.editor.calcRowTypePlaceholder"
              on-row-changed="$ctrl.commitNewRow('price', false)" categories="$ctrl.categories" clear-on-select="true"></salaxy-calc-row-type>
          </td>
          <td>
            <button type="button" class="btn btn-default" ng-click="$ctrl.showRowTypeSelectionDialog()"><i class="bi bi-info-circle-fill text-primary me-2"></i> <span
                sxy-text="SALAXY.NG1.CalcRowsComponent.editor.buttons.readMore" ps="..."></span></button>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
  <div ng-switch-when="copy">
    <table class="table table-condensed">
      <thead>
        <tr>
          <th colspan="2">Laskelmalle kopioitavat rivit</th>
          <th class="right" sxy-text="SALAXY.NG1.DateRange.labelStartAndEndDate"></th>
          <th class="right" sxy-text="SALAXY.NG1.CalcRowsComponent.editor.price"></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.copyRowsList">
          <td style="width: 32px;">
            <salaxy-avatar ng-if="row.rowType" class="salaxy-calc-row-type-avatar"
              avatar="{ color: $ctrl.getConfig(row).color, initials: $ctrl.getConfig(row).iconText, entityType: 'company' }"></salaxy-avatar>
          </td>
          <td style="width: 40%;">
            <div>{{$ctrl.getMessagePlaceholderText(row)}}</div>
            <div><small><code>{{ row.type }}{{ row.data.kind ? "/" + row.data.kind : "" }}</code></small>  &nbsp;</div>
          </td>
          <td class="right middle">
            <div>{{ row.period | sxyDateRange }}&nbsp;&nbsp;</div>
          </td>
          <td class="right">
            <salaxy-input-number name="{{ 'iptPrice' + row.rowIndex }}" ng-model="row.price" label-type="plain"  disabled="$ctrl.isDisabled(row, 'price')" require="true"></salaxy-input-number>
          </td>
          <td class="right">
            <button type="button" class="edit btn btn-info" ng-click="$ctrl.showEdit(row, 'auto')"
              title="{{'SALAXY.NG1.CalcRowsComponent.editor.buttons.infoIcon' | sxyTranslate}}"><i class="bi bi-pencil-square"></i></button>
            <button type="button" class="btn btn-danger" ng-click="$ctrl.delete(row)"><i class="bi bi-trash-fill"></i>
            </button>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td></td>
          <td class="middle">
            Lisää kopioitava rivi:
          </td>
          <td>
            <salaxy-calc-row-type name="newRowType" model="$ctrl.newRow" placeholder="SALAXY.NG1.CalcRowsComponent.editor.calcRowTypePlaceholder"
              on-row-changed="$ctrl.commitNewRow('copy', false)" categories="$ctrl.categories"></salaxy-calc-row-type>
          </td>
          <td>
            <button type="button" class="btn btn-default" ng-click="$ctrl.showRowTypeSelectionDialog()"><i class="bi bi-info-lg text-primary"></i> <span
                sxy-text="SALAXY.NG1.CalcRowsComponent.editor.buttons.readMore" ps="..."></span></button>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
  <div ng-switch-when="defaults">
    <table class="table table-condensed">
      <thead>
        <tr>
          <th colspan="2">Oletusrivit</th>
          <th class="right" sxy-text="SALAXY.NG1.DateRange.labelStartAndEndDate"></th>
          <th class="right" sxy-text="SALAXY.NG1.CalcRowsComponent.editor.totals.total"></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.defaultsList">
          <td style="width: 32px;">
            <salaxy-avatar ng-if="row.rowType" class="salaxy-calc-row-type-avatar"
              avatar="{ color: $ctrl.getConfig(row).color, initials: $ctrl.getConfig(row).iconText, entityType: 'company' }"></salaxy-avatar>
          </td>
          <td style="width: 40%;">
            <div>{{row.message || ( "CalculationRowType." + row.rowType | sxyEnum) }}</div>
            <div>{{row.data.kind }}&nbsp;</div>
          </td>
          <td class="right middle">
            <div>{{ row.period | sxyDateRange }}&nbsp;&nbsp;</div>
          </td>
          <td class="right">
            <salaxy-input-number name="{{ 'iptPrice' + row.rowIndex }}" ng-model="row.price" label-type="plain"  disabled="$ctrl.isDisabled(row, 'price')" require="true"></salaxy-input-number>
          </td>
          <td class="right">
            <button type="button" class="edit btn btn-info" ng-click="$ctrl.showEdit(row, 'auto')"
              title="{{'SALAXY.NG1.CalcRowsComponent.editor.buttons.infoIcon' | sxyTranslate}}">
              <i class="bi bi-info-circle-fill" ng-class="$ctrl.current == row ? 'bi-arrow-right-circle-fill' : 'bi-info-circle'"></i></button>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td></td>
          <td class="middle">
            Lisää oletusrivi:
          </td>
          <td>
            <salaxy-calc-row-type name="newRowType" model="$ctrl.newRow" placeholder="SALAXY.NG1.CalcRowsComponent.editor.calcRowTypePlaceholder"
              on-row-changed="$ctrl.commitNewRow('manualRow', true)" categories="$ctrl.categories"></salaxy-calc-row-type>
          </td>
          <td>
            <button type="button" class="btn btn-default" ng-click="$ctrl.showRowTypeSelectionDialog()"><i class="bi bi-info-circle-fill text-primary me-2"></i> <span
                sxy-text="SALAXY.NG1.CalcRowsComponent.editor.buttons.readMore" ps="..."></span></button>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
  <div ng-switch-when="debugger">
    <salaxy-json-formatter key="'Rivit'" json="$ctrl.list" open="1"></salaxy-json-formatter>
    <hr />
    <salaxy-calc-rows-editor ng-if="!$ctrl.isLoading" rows="$ctrl.list"
      title="{{ 'SALAXY.NG1.WorkerDetailsComponent.defaultCalcRows' | sxyTranslate }}" type="salary-defaults"></salaxy-calc-rows-editor>
  </div>
  <div ng-switch-default>
    <div class="d-flex mb-3 align-items-center">
      <div class="btn-group">
        <button id="categories" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false" ng-disabled="disabled">
          Kategoriat
        </button>
        <ul class="dropdown-menu" aria-labelledby="categories">
          <li><a class="dropdown-item" href="" ng-click="$ctrl.categories = null">All categories (no filter)</a></li>
          <li><a class="dropdown-item" href="" ng-click="$ctrl.categories = ['salary', 'salaryCalc', 'holidays', 'salaryAdditions']">Salaries and additions</a></li>
          <li><a class="dropdown-item" href="" ng-click="$ctrl.categories = ['benefits']">Benefits</a></li>
          <li><a class="dropdown-item" href="" ng-click="$ctrl.categories = ['expenses']">Expenses</a></li>
          <li><a class="dropdown-item" href="" ng-click="$ctrl.categories = ['deductions']">Deductions</a></li>
          <li><a class="dropdown-item" href="" ng-click="$ctrl.categories = ['other']">Other</a></li>
        </ul>
      </div>
      <div class="form-horizontal ms-2 flex-grow-1">
        <salaxy-input name="calcRowTypeSearch" ng-model="$ctrl.searchText" label="Search name and description"></salaxy-input>
      </div>
    </div>
    <ng-include src="'salaxy-components/settings/RowTypesSettings_table.html'"></ng-include>
  </div>
</div>`), s.put("salaxy-components/settings/RowTypesSettings_table.html", `<div class="salaxy-calc-row-type-table">
  <div>
    <div class="d-flex my-1 py-1 border-bottom ps-2" style="background-color: #f5f5f5;">
      <salaxy-avatar class="salaxy-calc-row-type-avatar" avatar="{ color: 'rgb(79, 205, 196)', initials: 'type', entityType: 'company' }"></salaxy-avatar>
      <div class="description w-100">
        <div class="flex-grow-1 row">
          <strong class="col-6" sxy-text="SALAXY.NG1.CalcRowTypeComponent.rowType" ps=" (type)"></strong>
          <strong class="col-6" sxy-text="SALAXY.NG1.CalcRowTypeComponent.rowTypeEn"></strong>
        </div>
        <div sxy-text="SALAXY.NG1.CalcRowTypeComponent.rowDescription" class="border-bottom py-1 mb-1"></div>
        <div class="flex-grow-1 row">
          <div class="col-6" sxy-text="SALAXY.NG1.CalcRowTypeComponent.rowKind" ps=" (kind)"></div>
          <div class="col-6" sxy-text="SALAXY.NG1.CalcRowTypeComponent.rowKindEn"></div>
        </div>
      </div>
      <div style="width: 140px;"></div>
  </div>
  <div>
    <div class="d-flex my-1 py-1 border-bottom ps-2" ng-repeat="item in $ctrl.getCachedSearch($ctrl.searchText, true)">
      <salaxy-avatar ng-if="item.ui.iconText" class="salaxy-calc-row-type-avatar me-2" avatar="{ color: item.ui.color, initials: item.ui.iconText, entityType: 'company' }"></salaxy-avatar>
      <div class="description w-100">
        <div ng-if="item.ui.iconText" class="row">
          <strong class="col-6 salaxy-highlight" ng-bind-html="item.text | uibTypeaheadHighlight:$ctrl.searchText"></strong>
          <strong class="col-6 salaxy-highlight" ng-bind-html="item.value | uibTypeaheadHighlight:$ctrl.searchText"></strong>
        </div>
        <div ng-if="!item.ui.iconText">
          <div class="salaxy-highlight" ng-bind-html="item.text | uibTypeaheadHighlight:$ctrl.searchText"></div>
          <div class="salaxy-highlight" ng-bind-html="item.value.split('.')[1] | uibTypeaheadHighlight:$ctrl.searchText"></div>
        </div>
        <div class="salaxy-highlight" ng-bind-html="item.title | uibTypeaheadHighlight:$ctrl.searchText"></div>
      </div>
      <div class="actions" style="width: 140px;">
        <div class="btn-group" ng-if="item.ui.group == 'builtIn'">
          <button type="button" class="btn btn-primary" ng-click="$ctrl.showRowTypeDetails(item)" title="{{ 'SALAXY.UI_Terms.show' | sxyTranslate }}">
            <i class="bi bi-info-circle-fill" aria-hidden="true"></i>
          </button>
          <button type="button" class="btn btn-info" ng-click="$ctrl.createCustomRowType(item)" title="Räätälöi">
            <i class="bi bi-plus-square-fill" aria-hidden="true"></i>
          </button>
          <button type="button" class="btn btn-default" ng-click="$ctrl.copyToClipboard(item.ui.type)" title="Kopioi ID leikepöydälle">
            <i class="bi bi-clipboard" aria-hidden="true"></i>
          </button>
        </div>
        <div class="btn-group" ng-if="item.ui.group != 'builtIn'">
          <button type="button" class="btn btn-primary" ng-click="$ctrl.showRowTypeDetails(item)" title="{{ 'SALAXY.UI_Terms.edit' | sxyTranslate }}">
            <i class="bi bi-pencil-fill" aria-hidden="true"></i>
          </button>
          <button type="button" class="btn btn-danger" ng-click="$ctrl.deleteCustomRowType(item)" title="Poista">
            <i class="bi bi-trash-fill" aria-hidden="true"></i>
          </button>
          <button type="button" class="btn btn-default" ng-click="$ctrl.copyToClipboard(item.ui.type)" title="Kopioi ID leikepöydälle">
            <i class="bi bi-clipboard" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>`), s.put("salaxy-components/settings/ServiceModelDetails.html", `<style>
  /* TODO: Move to less */
  
  .salaxy-workspace {
    display: flex;
  }
  
  .salaxy-workspace-navi {
    flex: 0 0 200px;
  }
  
  .salaxy-workspace-content {
    flex: 1 1 100%;
    margin-left: -1px;
    height: calc(100vh - 200px);
    overflow-y: auto;
    border: solid 1px #009fd8;
    padding: 10px;
  }
  
  .salaxy-workspace-content .container {
    margin-left: 0px;
  }
</style>
<!--

TODO-lista:

Työnkulut:

- Itsepalvelu (Asiakas yksin)
- Tilitoimisto tekee laskelman => Hyväksyntä => Tilitoimisto maksaa
- Tilitoimisto tekee laskelman => Hyväksyntä => Asiakas maksaa
- Asiakas tekee laskelman => PRO Tarkistaa => Asiakas maksaa
- Asiakas tekee laskelman => PRO Tarkistaa => Tilitoimisto maksaa

Flagit:

- Aineiston lähetys: Näkyvissä / ei
- Yritys: Maksaako vai hyväksyykö?

Mietittävä:

- Entäs useita?
- Saako muokata (osana hyväksyntää)?
- Palkkalaskelman (Salary Slip) lähetys
  - Notifikaatiot

-->
<div class="salaxy-component salaxy-service-model-details">

  <div class="btn-toolbar" style="margin-left: 195px; margin-bottom: 2px;">
    <div class="btn-group">
      <button type="button" class="btn btn-primary" ng-disabled="!$ctrl.current || $ctrl.current.isReadOnly || $ctrl.isReadOnly" ng-click="$ctrl.saveServiceModel()" sxy-text="SALAXY.UI_Terms.save"></button>
      </button>
      <button type="button" class="btn btn-default" ng-disabled="$ctrl.isReadOnlyForced" ng-click="$ctrl.showCopyAsNew($ctrl.current)" sxy-text="SALAXY.UI_Terms.copyAsNew"> </button>
      <button class="btn btn-default" ng-click="$ctrl.reload()" title="{{ 'SALAXY.UI_Terms.refresh' | sxyTranslate}}"><i class="bi bi-arrow-repeat" aria-hidden="true"></i></button>
    </div>
    
    <div class="btn-group ms-1">
        <div class="d-flex" style="line-height: 34px;">
          <strong><span sxy-text="SALAXY.NG1.ServiceModelDetailsComponent.name" ps=":"></span></strong> {{$ctrl.current.name}}
        </div>
    </div>
    <div class="btn-group ms-auto">
      <button type="button" class="btn btn-danger" ng-disabled="!$ctrl.current || $ctrl.current.isReadOnly || $ctrl.isReadOnly" ng-click="$ctrl.delete($ctrl.current)" sxy-text="Poista (test)" ng-if="'test' | sxyIsInRole" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}"></button>
    </div>
  </div>
  <div ng-if="$ctrl.current">
    <sxy-form open-api="salaxy-secure/schemas/v02.json" type="ServiceModel" auto-gen="false" debugger="false" model="$ctrl.current" read-only="{{$ctrl.isReadOnly}}">
      <div ng-init="$ctrl.currentSection = 'basicInfo'" class="salaxy-workspace">
        <div class="salaxy-workspace-navi">
          <salaxy-toggle-buttons ng-model="$ctrl.currentSection" 
            options="[
              { value: 'basicInfo', label: 'SALAXY.NG1.ServiceModelDetailsComponent.basicInfo' },
              { value: 'exports', label: 'SALAXY.NG1.ServiceModelDetailsComponent.exports' },
              { value: 'branding', label: 'SALAXY.NG1.ServiceModelDetailsComponent.branding' },
              { value: 'sitemap', label: 'SALAXY.NG1.ServiceModelDetailsComponent.sitemap' },
              { value: 'messaging', label: 'SALAXY.NG1.ServiceModelDetailsComponent.messaging' },
              { value: 'i18n', label: 'SALAXY.NG1.ServiceModelDetailsComponent.i18n' },
              { value: 'workflow', label: 'SALAXY.NG1.ServiceModelDetailsComponent.workflow' },
              { value: 'usecases', label: 'SALAXY.NG1.ServiceModelDetailsComponent.usecases' },
              { value: 'irdelivery', label: 'Tulorekisterin varmenne' },
              { value: 'advanced', label: 'Tech' }
            ]"
            type="block">
          </salaxy-toggle-buttons>
        </div>
        <div class="salaxy-workspace-content">
          <div ng-if="$ctrl.currentSection == 'basicInfo'" class="form-horizontal container">
            <div class="row">
              <div class="col-sm-8">
                <fieldset>
                  <legend sxy-text="SALAXY.NG1.ServiceModelDetailsComponent.serviceModelTitle"></legend>
                  <p><strong sxy-text="SALAXY.NG1.ServiceModelDetailsComponent.serviceModelId" ps=":"></strong> {{ $ctrl.current.id + "@" + $ctrl.current.owner }}</p>
                  <sxy-input model="form.name"></sxy-input>
                  <sxy-input model="form.icon" label="SALAXY.NG1.ServiceModelDetailsComponent.serviceModelIcon"></sxy-input>
                </fieldset>
              </div>
              <div class="col-sm-4 text-center">
                <img ng-if="$ctrl.current.icon" ng-src="{{ $ctrl.current.icon }}" style="width: 100px; margin-top: 60px;" />
              </div>
            </div>
            <div class="row">
              <div class="col-sm-8">
                <fieldset>
                  <legend sxy-text="SALAXY.NG1.ServiceModelDetailsComponent.endUserPricing"></legend>
                  <sxy-input model="form.pricing.pricingModel"></sxy-input>
                  <sxy-input model="form.pricing.fixedFee" ng-if="$ctrl.current.pricing.pricingModel == 'fixedFee'"></sxy-input>
                </fieldset>
              </div>
              <div class="col-sm-4"></div>
            </div>
          </div>
          <div ng-if="$ctrl.currentSection == 'exports'" class="form-horizontal container">
            <fieldset>
              <legend sxy-text="SALAXY.NG1.ServiceModelDetailsComponent.paymentChannelsTitle"></legend>
              <sxy-input model="form.features.payments" format="switch" label="SALAXY.NG1.ServiceModelDetailsComponent.customPaymentChannels"></sxy-input>
              <div ng-if="$ctrl.current.features.payments">
                <sxy-input template-url="salaxy-components/sxy-form/custom-templates/array-service-model-payment-channels.html" model="form.payments.channels">
                  <form>
                    <fieldset>
                      <sxy-input model="form.channel"></sxy-input>
                      <sxy-input model="form.isAvailable"></sxy-input>
                      <sxy-input model="form.isEnabled"></sxy-input>
                    </fieldset>
                  </form>
                </sxy-input>
                <salaxy-input-typeahead read-only="$ctrl.isReadOnly" class="default-channel-input-enum" name="options_type" ng-model="$ctrl.current.payments.defaultChannel" options="$ctrl.getSelectablePaymentChannels()" ng-if="$ctrl.getSelectablePaymentChannels().length &gt; 1"
                  disable-cache="true" label="SALAXY.NG1.ServiceModelDetailsComponent.defaultChannel"></salaxy-input-typeahead>
              </div>
            </fieldset>
            <fieldset>
              <legend sxy-text="SALAXY.NG1.ServiceModelDetailsComponent.accountingTitle"></legend>
              <sxy-input model="form.features.accounting" format="switch" label="SALAXY.NG1.ServiceModelDetailsComponent.customAccounting"></sxy-input>
              <div ng-if="$ctrl.current.features.accounting">
                <sxy-input model="form.accounting.defaultPeriodDateKind"></sxy-input>
                <sxy-input template-url="salaxy-components/sxy-form/custom-templates/array-accounting-targets.html" model="form.accounting.targets">
                  <form>
                    <fieldset ng-show="!$ctrl.logic.showDelete" ng-controller="ServiceModelCrudController as $serviceModelController" ng-init="$ctrl.logic.isReadOnly = true">
                      <salaxy-odata-table crud-controller="AccountingTargetCrudController as $crud" template-url="salaxy-components/odata/lists/AccountingTargetSelect.html" selected-items="$ctrl.selectedItems" on-list-select="$serviceModelController.onAccountingTargetSelect($ctrl.current, $ctrl.logic, value, item, allItems)">
                      </salaxy-odata-table>
                    </fieldset>
                    <fieldset ng-show="$ctrl.logic.showDelete" ng-init="$ctrl.logic.isReadOnly = false">
                      <salaxy-input-enum disabled="false" name="format" label="SALAXY.NG1.AccountingTargetDetailsComponent.excelCsvFormat" ng-model="$ctrl.current.format"
                        options="{
                          '36dff2e2-e181-4f0d-9004-0e4aa92f5e17': 'Palkkaus.fi',
                          '0db4e85f-93a8-46f1-b6d2-f7523d289d88': 'Fennoa',
                          '8613f133-3fce-4611-b372-51f6a2e007dd': 'Procountor',
                          'e62c10b0-222a-4170-b8b4-b1e02d9a7644': 'Passeli Merit',
                          '53fd3863-b8f9-4909-86c9-cb4597595181': 'Heeros',
                          '2fc7899c-7a3d-4d56-ad2f-05d52782bbbc': 'Asteri',
                          '0a2bd312-06da-4862-aef5-75166e0bf461': 'Maestro',
                          'c04e0757-63f3-420d-a183-3427710fc954': 'Visma Fivaldi',
                          'ba271dac-dd63-4036-9d70-053a09ca4d9e' :'Visma Netvisor',
                          '27e271d5-41f5-4319-ab29-4d5d9eb945c6': 'Lemonsoft',
                          'd311f9d3-8c3a-4fd8-a665-8e3698e41e87': 'Tampuuri',
                          'd58e95b7-d0b5-40ac-992b-6d3b29efc45e': 'Domus',
                          '54e93c5f-bd74-4157-8a74-3515be7f585d': 'Oscar Software',
                          '0e4f0a71-dcb9-43ba-9028-0239e674711f': 'Digia Enterprise',
                          '2ccefa46-7992-46c5-9d87-b88336935916': 'Digia Enterprise - VILPE'
                        }">
                      </salaxy-input-enum>
                      <sxy-input model="form.method" read-only="false"></sxy-input>
                      <salaxy-input-enum disabled="false" enum="ExportMethod" label="SALAXY.MODEL.AccountingTargetSettings.availableMethods.title" name="availableMethods" type="multi-select" ng-model="$ctrl.current.availableMethods"></salaxy-input-enum>
                    </fieldset>
                  </form>
                </sxy-input>
                <salaxy-input-typeahead name="options_type" ng-model="$ctrl.current.accounting.defaultTargetId" options="$ctrl.getSelectableAccountingTargets()" disable-cache="true" ng-if="$ctrl.getSelectableAccountingTargets().length &gt; 1" label="SALAXY.NG1.ServiceModelDetailsComponent.defaultTarget"></salaxy-input-typeahead>
              </div>
            </fieldset>
            <fieldset>
              <legend sxy-text="SALAXY.MODEL.ServiceModelCostAccounting.title"></legend>
              <sxy-input model="form.features.costAccounting" format="switch" label="SALAXY.NG1.ServiceModelDetailsComponent.customCostAccounting"></sxy-input>
              <div ng-if="$ctrl.current.features.costAccounting">
                <sxy-input model="form.costAccounting.dimensions" include="id,label,scope">
                  <form>
                    <fieldset>
                      <legend sxy-text="SALAXY.MODEL.CostAccountingDimensionDefinition.title"></legend>
                      <sxy-input model="form.id" read-only="{{$ctrl.logic.showDelete}}"></sxy-input>
                      <sxy-input model="form.label"></sxy-input>
                      <sxy-input model="form.allowCostSharing"></sxy-input>
                      <sxy-input model="form.scope"></sxy-input>
                      <sxy-input model="form.options" template-url="salaxy-components/sxy-form/custom-templates/cost-accounting-options.html"></sxy-input>
                    </fieldset>
                  </form>
                </sxy-input>
              </div>
            </fieldset>
            <fieldset>
              <legend sxy-text="SALAXY.MODEL.ServiceModelHoliday.title"></legend>
              <sxy-input model="form.features.holiday" format="switch" label="SALAXY.NG1.ServiceModelDetailsComponent.customHoliday"></sxy-input>
              <div ng-if="$ctrl.current.features.holiday">
                <sxy-input model="form.holiday.holidayPaySettings" include="holidayPayCalculation">
                  <form>
                    <fieldset>
                      <legend sxy-text="SALAXY.MODEL.HolidayPaySettings.title"></legend>
                      <salaxy-input-enum enum="HolidayPayCalculation" label="SALAXY.MODEL.HolidayPaySettings.holidayPayCalculation.title" name="holidayPayCalculation" filter="averageDailyPay,averageHourlyPay,percentageBasedPay,holidayCompensation" require="true" ng-model="$ctrl.current.holidayPayCalculation" read-only="$ctrl.getReadOnly()"></salaxy-input-enum>
                      <legend sxy-text="SALAXY.MODEL.HolidayPaySettings.salaryTypes.title"></legend>
                      <sxy-input model="form.salaryTypes" template-url="salaxy-components/sxy-form/custom-templates/holiday-row-types.html"></sxy-input>
                      <legend ng-show="$ctrl.current.holidayPayCalculation == 'averageHourlyPay'" sxy-text="SALAXY.MODEL.HolidayPaySettings.workingTimeTypes.title"></legend>
                      <sxy-input ng-show="$ctrl.current.holidayPayCalculation == 'averageHourlyPay'" model="form.workingTimeTypes" template-url="salaxy-components/sxy-form/custom-templates/holiday-row-types.html"></sxy-input>
                      <legend ng-show="$ctrl.current.holidayPayCalculation == 'averageDailyPay'" sxy-text="SALAXY.MODEL.HolidayPaySettings.overtimeTypes.title"></legend>
                      <sxy-input  ng-show="$ctrl.current.holidayPayCalculation == 'averageDailyPay'" model="form.overtimeTypes" template-url="salaxy-components/sxy-form/custom-templates/holiday-row-types.html"></sxy-input>
                      <legend ng-show="$ctrl.current.holidayPayCalculation == 'averageHourlyPay' || $ctrl.current.holidayPayCalculation == 'averageDailyPay'" sxy-text="SALAXY.MODEL.HolidayPaySettings.multipliers.title"></legend>
                      <salaxy-input-holiday-multipliers ng-show="$ctrl.current.holidayPayCalculation == 'averageHourlyPay' || $ctrl.current.holidayPayCalculation == 'averageDailyPay'" name="multipliers" label="SALAXY.MODEL.HolidayPaySettings.multipliers.title" ng-model="$ctrl.current.multipliers" read-only="$ctrl.getReadOnly()"></salaxy-input-holiday-multipliers>
                    </fieldset>
                  </form>
                </sxy-input>
               <sxy-input model="form.holiday.holidayAccrualSettings" include="code">
                  <form>
                    <fieldset>
                      <legend sxy-text="SALAXY.MODEL.HolidayAccrualSettings.title"></legend>
                      <salaxy-input-enum enum="HolidayCode" label="SALAXY.MODEL.HolidayAccrualSettings.code.title" name="code" filter="permanent35Hours,other" require="true" ng-model="$ctrl.current.code" read-only="$ctrl.getReadOnly()"></salaxy-input-enum>
                      <legend sxy-text="SALAXY.MODEL.HolidayAccrualSettings.workingTimeTypes.title"></legend>
                      <sxy-input model="form.workingTimeTypes" template-url="salaxy-components/sxy-form/custom-templates/holiday-row-types.html"></sxy-input>
                    </fieldset>
                  </form>
                </sxy-input>
              </div>
            </fieldset>
          </div>
          <div ng-if="$ctrl.currentSection == 'branding'" class="form-horizontal container">
            <div class="row">
              <div class="col-sm-6">
                <fieldset>
                  <legend sxy-text="SALAXY.NG1.ServiceModelDetailsComponent.webAppTitle"></legend>
                  <sxy-input model="form.site.webApp"></sxy-input>
                  <sxy-input model="form.site.webAppUrl"></sxy-input>
                  <sxy-input model="form.site.webAppName"></sxy-input>
                </fieldset>
              </div>
              <div class="col-sm-6">
                <fieldset>
                  <legend sxy-text="SALAXY.NG1.ServiceModelDetailsComponent.reportingTitle"></legend>
                  <sxy-input model="form.features.reporting" label="SALAXY.NG1.ServiceModelDetailsComponent.customReporting"></sxy-input>
                  <salaxy-input-enum ng-model="$ctrl.current.reporting.layoutTemplateId" name="layputTemplateId" label="SALAXY.NG1.ServiceModelDetailsComponent.layoutTemplateId" options="{'palkkaus-report-options@FI53POYS0025543933': ('SALAXY.NG1.ServiceModelDetailsComponent.templateIdPalkkaus' | sxyTranslate),
                      'no-logo-report-options@FI53POYS0025543933': ('SALAXY.NG1.ServiceModelDetailsComponent.templateIdNoLogo' | sxyTranslate),
                      'logo-report-options@FI53POYS0025543933': ('SALAXY.NG1.ServiceModelDetailsComponent.templateIdLogo' | sxyTranslate),
                      'kevytyrittaja-report-options@FI06POYT0009439335': ('SALAXY.NG1.ServiceModelDetailsComponent.templateIdTalenom' | sxyTranslate),
                      'tilijaska-report-options@FI39POYT0025590211': ('SALAXY.NG1.ServiceModelDetailsComponent.templateIdTilijaska' | sxyTranslate),
                      'treamer-report-options@FI86POYI0028244891': ('SALAXY.NG1.ServiceModelDetailsComponent.templateIdTreamer' | sxyTranslate)}" read-only="$ctrl.isReadOnly"></salaxy-input-enum>
                  <salaxy-textarea maxlength="" label="SALAXY.NG1.ServiceModelDetailsComponent.customReportLogo" name="logo" ng-model="$ctrl.current.reporting.logo" rows="3" ng-if="$ctrl.current.reporting.layoutTemplateId == 'logo-report-options@FI53POYS0025543933'">
                  </salaxy-textarea>
                </fieldset>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-8">
                <fieldset>
                  <legend sxy-text="SALAXY.NG1.ServiceModelDetailsComponent.brandingTitle"></legend>
                  <sxy-input model="form.branding.logo"></sxy-input>
                  <sxy-input model="form.branding.skin"></sxy-input>
                </fieldset>
              </div>
              <div class="col-sm-4 text-center">
                <img ng-if="$ctrl.current.branding.logo" ng-src="{{ $ctrl.current.branding.logo }}" style="width: 100px; margin-top: 35px;" />
              </div>
            </div>
          </div>
          <div ng-if="$ctrl.currentSection == 'sitemap'" class="form-horizontal height100">
            <div class="row height100" style="width: 95%;">
              <div class="col-6 height100" style="width: 45%; overflow-y: auto">
                <div class="btn-toolbar">
                  <div class="btn-group">
                    <button type="button" class="btn btn-default" ng-click="$ctrl.showHideAll(true)">Avaa kaikki</button>
                    <button type="button" class="btn btn-default" ng-click="$ctrl.showHideAll(false)">Sulje kaikki</button>
                  </div>
                  <button type="button" ng-disabled="$ctrl.isReadOnly" class="btn btn-danger" ng-click="$ctrl.resetSitemapChanges()">Palauta kaikki</button>
                </div>
                <table class="table table-sm">
                  <thead>
                    <tr>
                      <th colspan="3">Title</th>
                      <th class="right">Flags</th>
                      <th class="right">Roles</th>
                      <th class="right">Changes</th>
                      <th colspan="2"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr ng-repeat-start="level1 in $ctrl.sitemap" class="clickable" ng-class="{ 'active': $ctrl.currentSitemapNode == level1 }">
                      <td colspan="3" ng-click="$ctrl.currentSitemapNode = level1">{{ $ctrl.translate(level1.title) }}</td>
                      <td class="right" ng-click="$ctrl.currentSitemapNode = level1">
                        <i ng-class="'bi ' + icon" ng-repeat="icon in level1.$edit.$faIcons" aria-hidden="true"></i>
                      </td>
                      <td class="right" ng-click="$ctrl.currentSitemapNode = level1">
                        <span ng-if="$ctrl.getIsTest(level1)" class="badge bg-primary"><span class="small">test</span></span>
                        <span>{{ $ctrl.getRoles(level1) }}</span>
                      </td>
                      <td class="right" ng-click="$ctrl.currentSitemapNode = level1">
                        <i class="bi bi-translate text-primary" ng-if="level1.$edit.$hasTextChanges" aria-hidden="true"></i>
                        <i class="bi bi-pencil-square text-primary" ng-if="level1.$edit.$hasChanges" aria-hidden="true"></i>
                        <i class="bi bi-pencil-square" ng-if="level1.$edit.$hasChildrenChanges" aria-hidden="true"></i>
                      </td>
                      <td colspan="2" class="right" ng-if="level1.children.length" ng-click="level1.$edit.$isOpen = !level1.$edit.$isOpen">
                        <i class="bi" ng-class="level1.$edit.$isOpen ? 'bi-chevron-up' : 'bi-chevron-down'" aria-hidden="true"></i>
                      </td>
                      <td colspan="2" ng-if="!level1.children.length"></td>
                    </tr>
                    <tr ng-if="level1.$edit.$isOpen" ng-repeat-start="level2 in level1.children" class="clickable" ng-class="{ 'active': $ctrl.currentSitemapNode == level2 }">
                      <td style="width: 10px;">-</td>
                      <td colspan="2" ng-click="$ctrl.currentSitemapNode = level2">{{ $ctrl.translate(level2.title) }}</td>
                      <td class="right" ng-click="$ctrl.currentSitemapNode = level2">
                        <i ng-class="'bi ' + icon" ng-repeat="icon in level2.$edit.$faIcons" aria-hidden="true"></i>
                      </td>
                      <td class="right" ng-click="$ctrl.currentSitemapNode = level2">
                        <span ng-if="$ctrl.getIsTest(level2)" class="badge bg-primary"><span class="small">test</span></span>
                        <span>{{ $ctrl.getRoles(level2) }}</span>
                      </td>
                      <td class="right" ng-click="$ctrl.currentSitemapNode = level2">
                        <i class="bi bi-translate text-primary" ng-if="level2.$edit.$hasTextChanges" aria-hidden="true"></i>
                        <i class="bi bi-pencil-square text-primary" ng-if="level2.$edit.$hasChanges" aria-hidden="true"></i>
                        <i class="bi bi-pencil-square" ng-if="level2.$edit.$hasChildrenChanges" aria-hidden="true"></i>
                      </td>
                      <td ng-if="level2.children.length" ng-click="level2.$edit.$isOpen = !level2.$edit.$isOpen">
                        <i class="bi" ng-class="level2.$edit.$isOpen ? 'bi-chevron-up' : 'bi-chevron-down'" aria-hidden="true"></i>
                      </td>
                      <td ng-if="!level2.children.length"></td>
                      <td></td>
                    </tr>
                    <tr ng-if="level1.$edit.$isOpen && level2.$edit.$isOpen" ng-repeat-end ng-repeat="level3 in level2.children" class="clickable" ng-click="$ctrl.currentSitemapNode = level3" ng-class="{ 'active': $ctrl.currentSitemapNode == level3 }">
                      <td style="width: 10px;">&nbsp;</td>
                      <td style="width: 10px;">-</td>
                      <td>{{ $ctrl.translate(level3.title) }}</td>
                      <td class="right">
                        <i ng-class="'bi ' + icon" ng-repeat="icon in level3.$edit.$faIcons" aria-hidden="true"></i>
                      </td>
                      <td class="right">
                        <span ng-if="$ctrl.getIsTest(level3)" class="badge bg-primary"><span class="small">test</span></span>
                        <span>{{ $ctrl.getRoles(level3) }}</span>
                      </td>
                      <td class="right">
                        <i class="bi bi-translate text-primary" ng-if="level3.$edit.$hasTextChanges" aria-hidden="true"></i>
                        <i class="bi bi-pencil-square text-primary" ng-if="level3.$edit.$hasChanges" aria-hidden="true"></i>
                        <i class="bi bi-pencil-square" ng-if="level3.$edit.$hasChildrenChanges" aria-hidden="true"></i>
                      </td>
                      <td colspan="2"></td>
                    </tr>
                    <tr ng-repeat-end ng-if=0></tr>
                  </tbody>
                </table>
              </div>
              <div class="col-6">
                <div class="btn-toolbar">
                  <button type="button" ng-disabled="$ctrl.isReadOnly" class="btn btn-danger" ng-click="$ctrl.resetSitemapNode(true)">Palauta muutokset</button>
                  <div class="btn-group ms-auto">
                    <button type="button" ng-disabled="$ctrl.isReadOnly" class="btn btn-default" ng-click="$ctrl.resetSitemapNode()">Peruuta</button>
                    <button type="button" ng-disabled="$ctrl.isReadOnly" class="btn btn-primary" ng-click="$ctrl.commitSitemapNode()">OK</button>
                  </div>
                </div>

                <h3>{{ $ctrl.translate($ctrl.currentSitemapNode.title) }} <small>({{ $ctrl.currentSitemapNode.$edit.$id }})</small></h3>
                <salaxy-tab-buttons
                  current-tab="$ctrl.SitemapActive"
                  options="[
                    { value: 'general', text: 'Perustiedot' },
                    { value: 'params', text: 'Parametrit' },
                    { value: 'i18n', text: 'Tekstit' },
                    { value: 'debug', text: 'Debug' }
                  ]"
                  tabs-id="serviceModelDetails">
                </salaxy-tab-buttons>
                <div class="tab-content" id="tab-content-serviceModelDetails">
                  <div class="tab-pane" id="general-tab">
                    <div class="form-horizontal">
                      <salaxy-input name="id" read-only="true" ng-model="$ctrl.currentSitemapNode.$edit.$id" label="Id"></salaxy-input>
                      <salaxy-input name="url" read-only="true" ng-model="$ctrl.currentSitemapNode.url" label="SALAXY.NG1.ServiceModelDetailsComponent.url"></salaxy-input>
                      <salaxy-input-enum name="visibility" enum="SitemapVisibility" label="Näkyvyys ({{ 'SitemapVisibility.' + ($ctrl.currentSitemapNode.visibility || 'visible') | sxyEnum }})" ng-model="$ctrl.currentSitemapNode.$edit.visibility" read-only="$ctrl.isReadOnly"></salaxy-input-enum>
                      <salaxy-input name="roles" ng-model="$ctrl.currentSitemapNode.$edit.roles" label="Roolit ({{ $ctrl.currentSitemapNode.roles || '-' }})" read-only="$ctrl.isReadOnly"></salaxy-input>
                      <salaxy-input-boolean name="isFullWidth" type="select" label="Leveä näyttö ({{ $ctrl.currentSitemapNode.isFullWidth ? 'Kyllä' : 'Ei' }})" ng-model="$ctrl.currentSitemapNode.$edit.isFullWidth" read-only="$ctrl.isReadOnly"></salaxy-input-boolean>
                      <div class="row">
                        <div ng-if="$ctrl.currentSitemapNode.$edit.isFullWidth != null" class="col-sm-6 offset-sm-4">
                          <button type="button" class="btn btn-default btn-xs" ng-click="$ctrl.currentSitemapNode.$edit.isFullWidth = null">Palauta oletus</button>
                        </div>
                      </div>
                      <fieldset>
                        <legend>Sivun otsikko</legend>
                        <small><p>Klikkaa muokataksesi kieliversioita. HUOM: Muutokset menevät suoraan kieliversiointiin, "Peruuta"/"OK"-nappuloila yllä ei ole vaikutusta. Käytä delete-nappia alla erikseen poistaaksesi muutokset.</p></small>
                        <div style="padding-left: 10px;">
                          <salaxy-ui-translator mode="fieldset" texts="$ctrl.current.site.texts" filter="$ctrl.currentSitemapNode.$edit.$i18nKey"></salaxy-ui-translator>
                        </div>
                      </fieldset>
                    </div>
                  </div>
                  <div class="tab-pane" id="params-tab">
                    <sxy-form open-api="SitemapParams" open-api-doc="$ctrl.getSitemapParamsSchema()" type="{{$ctrl.currentSitemapNode.$edit.$id}}" auto-gen="true" model="$ctrl.currentSitemapNode.$edit" read-only="{{$ctrl.isReadOnly}}"></sxy-form>
                  </div>
                  <div class="tab-pane" id="i18n-tab">
                    <div class="alert alert-info"><strong>HUOM!</strong> Suurin osa teksteistä on komponenttien tekstejä. Niiden muokkaaminen vaikuttaa kaikkiin sivuihin, joissa komponentti on käytössä: Ei pelkästään tähän sivuun.</div>
                      <div ng-if="!$ctrl.currentSitemapNode.i18n.length">Käännöstekstejä ei ole määritetty tälle sivulle.</div>
                      <salaxy-ui-translator ng-if="$ctrl.currentSitemapNode.i18n.length" texts="$ctrl.current.site.texts" filter="$ctrl.currentSitemapNode.i18n"></salaxy-ui-translator>
                  </div>
                  <div class="tab-pane" id="debug-tab">
                    <salaxy-json-formatter json="$ctrl.currentSitemapNode" key="'Node'"></salaxy-json-formatter>
                    <salaxy-json-formatter json="$ctrl.currentSitemapNode.$edit" key="'$edit'"></salaxy-json-formatter>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div ng-if="$ctrl.currentSection == 'messaging'" class="form-horizontal container">
            <fieldset>
              <legend sxy-text="SALAXY.NG1.ServiceModelDetailsComponent.messagingTitle"></legend>
              <sxy-input model="form.features.messaging" label="SALAXY.NG1.ServiceModelDetailsComponent.messagingActive"></sxy-input>
              <sxy-input model="form.messaging.partnerMessages"></sxy-input>
              <sxy-input model="form.messaging.workerSalaryNotifications"></sxy-input>
              <sxy-input model="form.messaging.workerSalarySlipDeliveryMethods"></sxy-input>
            </fieldset>
          </div>
          <div ng-if="$ctrl.currentSection == 'i18n'" class="form-horizontal" ng-init="$ctrl.current.site.texts = $ctrl.current.site.texts ? $ctrl.current.site.texts : {}">
            <salaxy-ui-translator texts="$ctrl.current.site.texts"></salaxy-ui-translator>
          </div>
          <div ng-if="$ctrl.currentSection == 'workflow'" class="form-horizontal">
            <div class="container">
              <sxy-input model="form.features.forms" legend="Aineiston lähetys käytössä"></sxy-input>
            </div>
          </div>
          <div ng-if="$ctrl.currentSection == 'usecases'" class="form-horizontal container">
            <fieldset>
              <sxy-input model="form.features.usecase" label="SALAXY.NG1.ServiceModelDetailsComponent.customUsecases"></sxy-input>
              <sxy-input template-url="salaxy-components/sxy-form/custom-templates/array-usecase.html" model="form.usecase.usecases">
                <form>
                  <fieldset ng-show="!$ctrl.logic.showDelete" ng-controller="ServiceModelCrudController as $serviceModelController">
                    <salaxy-odata-table url="/v03/api/usecases" template-url="salaxy-components/odata/lists/UsecaseSelect.html" selected-items="$ctrl.selectedItems" on-list-select="$serviceModelController.onUsecaseSelect($ctrl.current, $ctrl.logic, value, item, allItems)">
                    </salaxy-odata-table>
                  </fieldset>
                  <fieldset ng-show="$ctrl.logic.showDelete">
                    <sxy-input model="form.uri" read-only="true"></sxy-input>
                    <sxy-input model="form.label"></sxy-input>
                    <sxy-input model="form.itemType"></sxy-input>
                    <sxy-input model="form.status"></sxy-input>
                    <sxy-input model="form.order"></sxy-input>
                  </fieldset>
                </form>
              </sxy-input>
            </fieldset>
          </div>
          <div ng-if="$ctrl.currentSection == 'irdelivery'" class="form-horizontal container">
            <fieldset>
              <legend>Tulorekisterin varmenne</legend>
              <salaxy-input-boolean type="select" name="irDelivery" ng-model="$ctrl.current.features.irDelivery" label="Käytä tätä varmennetta asiakkaille"></salaxy-input-boolean>
              
              <salaxy-input label="Tulorekisterivarmenteen omistajan Y-tunnus" name="senderOfficialId"
                        ng-model="$ctrl.current.calc.irDelivery.senderOfficialId"></salaxy-input>
              <legend>Tulorekisteriraportin yhteyshenkilöt</legend>
              <table class="table">
                <thead>
                  <tr>
                    <th>{{('Nimi') | sxyTranslate}}</th>
                    <th>{{('Puhelin') | sxyTranslate}}</th>
                    <th>{{('Sähköposti') | sxyTranslate}}</th>
                    <th>{{('Vastuualue') | sxyTranslate}}</th>
                    <th class="right">
                      <button type="button" class="btn btn-primary btn-xs"
                        ng-click="$ctrl.current.calc.irDelivery.contactPersons.push({})" sxy-text="SALAXY.UI_Terms.addRow"></button>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr ng-repeat="item in $ctrl.current.calc.irDelivery.contactPersons">
                    <td>
                      <salaxy-input require="true" ng-model="item.name" name="{{ 'name' + $index }}" label-type="plain"></salaxy-input>
                    </td>
                    <td>
                      <salaxy-input require="true" ng-model="item.telephone" name="{{ 'telephone' + $index }}" label-type="plain" sxy-mobile-phone></salaxy-input>
                    </td>
                    <td>
                      <salaxy-input require="true" ng-model="item.email" name="{{ 'email' + $index }}" label-type="plain" sxy-email></salaxy-input>
                    </td>
                    <td>
                      <salaxy-input-enum require="true" ng-model="item.responsibilityCode" name="{{ 'responsibilityCode' + $index }}" label-type="plain" type="select"
                        options="{ contentIssues: 'Raporttien sisältö', technicalIssues: 'Tekniset asiat' }"></salaxy-input-enum>
                    </td>
                    <td class="text-right">
                      <button type="button" class="btn btn-danger" ng-click="$ctrl.current.calc.irDelivery.contactPersons.splice($index, 1)">
                        <i class="bi bi-trash" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </fieldset>
          </div>
          <div ng-if="$ctrl.currentSection == 'advanced'">
            <div class="container" ng-init="$ctrl.exportJson()">
              <h3>Tuonti ja vienti</h3>
              <div class="btn-toolbar">
                <div class="btn-group">
                  <button type="button" class="btn btn-default" ng-click="$ctrl.importJson()">Import JSON to this service model</button>
                </div>
              </div>
              <sxy-code-editor read-only="$ctrl.current.isReadOnly" lang="json" ng-model="$ctrl.json"></sxy-code-editor>
            </div>
          </div>
        </div>
      </div>
    </sxy-form>
  </div>
</div>`), s.put("salaxy-components/sxy-form/array/default.html", `<div ng-switch="$ctrl.schemaModel.items.type">
  <div ng-switch-when="object">
    <table class="table">
      <caption>{{ $ctrl.getLabel() }}</caption>
      <thead>
        <tr>
          <th ng-repeat="itemInput in $ctrl.getChildInputs(3)">{{ $ctrl.getLabel(itemInput.name) }}</th>
          <th class="text-end">
            <button type="button" class="btn btn-primary btn-xs" ng-if="!$ctrl.getReadOnly()" ng-click="$ctrl.createNew()" sxy-text="SALAXY.UI_Terms.addRow"></button>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="item in $ctrl.value">
          <td ng-repeat="itemInput in $ctrl.getChildInputs(3)">{{ $ctrl.formatValue(itemInput.name, $parent.$index) }}</td>
          <td class="text-end" ng-if="!$ctrl.getReadOnly()">
            <button type="button" class="btn btn-primary btn-xs" ng-click="$ctrl.edit(item, $index)">
              <i class="bi bi-pencil-fill" title="Edit row"></i>
            </button>
            <button type="button" class="btn btn-danger btn-xs" ng-click="$ctrl.delete(item, $index)">
              <i class="bi bi-trash" title="Delete row"></i>
            </button>
          </td>
          <td class="text-end" ng-if="$ctrl.getReadOnly()">
            <button type="button" class="btn btn-primary btn-xs" ng-click="$ctrl.edit(item, $index)">
              <i class="bi bi-info-circle" title="Show row"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div ng-switch-when="string">
    <salaxy-input-enum ng-if="$ctrl.schemaModel.items.enum.length" ng-model="$ctrl.value" name="{{ $ctrl.id }}" label="{{ $ctrl.getLabel() }}" tooltip-html="{{ $ctrl.getDescr() }}" read-only="$ctrl.getReadOnly()" disabled="$ctrl.getDisable()" require="$ctrl.getRequire()"
      type="multi-select" options="$ctrl.getEnumOptions()"></salaxy-input-enum>
    <salaxy-form-group ng-if="!$ctrl.schemaModel.items.enum.length" name="{{ $ctrl.id }}" label="{{ $ctrl.getLabel() }}" tooltip-html="{{ $ctrl.getDescr() }}" read-only="$ctrl.getReadOnly()" disabled="$ctrl.getDisable()" require="$ctrl.getRequire()">
      <div class="input-group" ng-repeat="item in $ctrl.value track by $index">
        <input type="text" class="form-control" ng-model="$ctrl.value[$index]" name="{{ $ctrl.id + '_' + $index }}" id="{{ $ctrl.id + '_' + $index }}" ng-readonly="$ctrl.getReadOnly()" ng-disabled="$ctrl.getDisable()">
        <div class="input-group-btn">
          <button type="button" class="btn btn-danger" ng-click="$ctrl.delete(item, $index)">
            <i class="bi bi-trash" title="Delete row"></i>
          </button>
        </div>
      </div>
      <div class="text-end">
        <button type="button" class="btn btn-primary" ng-click="$ctrl.value.push('')">Add new</button>
      </div>
    </salaxy-form-group>
  </div>
  <div ng-switch-default>
    <salaxy-form-group name="{{ $ctrl.id }}" label="{{ $ctrl.getLabel() }}" tooltip-html="{{ $ctrl.getDescr() }}" read-only="$ctrl.getReadOnly()" disabled="$ctrl.getDisable()" require="$ctrl.getRequire()">
      <p>Unhandled array type: {{ $ctrl.schemaModel.items.type }}</p>
    </salaxy-form-group>
  </div>
</div>`), s.put("salaxy-components/sxy-form/array/PercentDimension.html", `<table class="table">
  <caption>{{ $ctrl.getLabel() }}</caption>
  <thead>
    <tr>
      <th>{{"SALAXY.MODEL.PercentDimension.id.title" | sxyTranslate}}</th>
      <th class="right">{{"SALAXY.MODEL.PercentDimension.percent.title" | sxyTranslate}}</th>
      <th class="right">
        <button type="button" class="btn btn-primary btn-xs" ng-if="!$ctrl.getReadOnly()" ng-click="$ctrl.createNew({})" sxy-text="SALAXY.UI_Terms.addRow"></button>
      </th>
    </tr>
  </thead>
  <tbody>
    <tr ng-repeat="item in $ctrl.value">
      <td>
        <salaxy-input ng-model="item.id" name="{{ 'id' + $index }}" label-type="plain" read-only="$ctrl.getReadOnly()" disabled="$ctrl.getDisable()"></salaxy-input>
      </td>
      <td>
        <salaxy-input-number ng-model="item.percent" name="{{ 'percent' + $index }}" label-type="plain" read-only="$ctrl.getReadOnly()" disabled="$ctrl.getDisable()" unit="percent"></salaxy-input-number>
      </td>
      <td class="text-end">
        <button  ng-if="!$ctrl.getReadOnly()" type="button" class="btn btn-danger" ng-click="$ctrl.delete(item, $index)">
          <i class="bi bi-trash" title="Delete row"></i>
        </button>
      </td>
    </tr>
  </tbody>
  <tfoot>
    <tr class="total">
      <td>{{"SALAXY.UI_Terms.total" | sxyTranslate}}</td>
      <td class="right">{{ ($ctrl.getTotal('percent') || ($ctrl.value.length == 1 ? 1 : "-")) | sxyCount : 'percent' }}</td>
      <td></td>
    </tr>
  </tfoot>
</table>`), s.put("salaxy-components/sxy-form/boolean/checkbox.html", `<salaxy-input-boolean ng-model="$ctrl.value" name="{{ $ctrl.id }}" label="{{ $ctrl.getLabel() }}" tooltip-html="{{ $ctrl.getDescr() }}" read-only="$ctrl.getReadOnly()" disabled="$ctrl.getDisable()" ng-require="$ctrl.getRequire()" type="checkbox">

</salaxy-input-boolean>`), s.put("salaxy-components/sxy-form/boolean/default.html", `<salaxy-input-boolean ng-model="$ctrl.value" name="{{ $ctrl.id }}" label="{{ $ctrl.getLabel() }}" tooltip-html="{{ $ctrl.getDescr() }}" read-only="$ctrl.getReadOnly()"
  disabled="$ctrl.getDisable()" require="$ctrl.getRequire()" type="select"></salaxy-input-boolean>`), s.put("salaxy-components/sxy-form/boolean/radio.html", `<salaxy-input-boolean ng-model="$ctrl.value" name="{{ $ctrl.id }}" label="{{ $ctrl.getLabel() }}" tooltip-html="{{ $ctrl.getDescr() }}" read-only="$ctrl.getReadOnly()"
  disabled="$ctrl.getDisable()" require="$ctrl.getRequire()" type="radio"></salaxy-input-boolean>`), s.put("salaxy-components/sxy-form/boolean/switch.html", `<salaxy-input-boolean ng-model="$ctrl.value" name="{{ $ctrl.id }}" label="{{ $ctrl.getLabel() }}" tooltip-html="{{ $ctrl.getDescr() }}" read-only="$ctrl.getReadOnly()"
  disabled="$ctrl.getDisable()" require="$ctrl.getRequire()" type="switch"></salaxy-input-boolean>`), s.put("salaxy-components/sxy-form/custom-templates/array-accounting-targets.html", `
<table class="table">
  <thead>
    <tr>
      <th sxy-text="SALAXY.MODEL.AccountingSettings.targets.title" colspan="2"></th>
      <th></th>
      <th class="text-end">
        <button type="button" class="btn btn-primary btn-xs" ng-if="!$ctrl.getReadOnly()" ng-click="$ctrl.createNew()" sxy-text="SALAXY.UI_Terms.addRow"></button>
      </th>
    </tr>
  </thead>
  <tbody>
    <tr ng-repeat="item in $ctrl.value">
      <td>
        <salaxy-avatar avatar="item.avatar"></salaxy-avatar>
      </td>
      <td>{{item.avatar.displayName}}</td>
      <td></td>
      <td class="text-end" ng-if="!$ctrl.getReadOnly()">
        <button type="button" class="btn btn-primary btn-xs" ng-click="$ctrl.edit(item, $index)">
          <i class="bi bi-pencil-fill" title="Edit row"></i>
        </button>
        <button type="button" class="btn btn-danger btn-xs" ng-click="$ctrl.delete(item, $index)">
            <i class="bi bi-trash" title="Delete row"></i>
          </button>
      </td>

    </tr>
  </tbody>
</table>`), s.put("salaxy-components/sxy-form/custom-templates/array-insurance.html", `<p sxy-text="SALAXY.MODEL.CalculationSettings.insuranceContracts.title" class="table-title"></p>
<table class="table">

  <thead>
    <tr>
      <th sxy-text="SALAXY.MODEL.InsuranceContract.company.title"></th>
      <th sxy-text="SALAXY.MODEL.InsuranceContract.contractNumber.title"></th>
      <th sxy-text="SALAXY.MODEL.InsuranceContract.status.title"></th>
      <th class="right" sxy-text="SALAXY.MODEL.InsuranceContract.startDate.title"></th>
      <th class="text-end">
        <button type="button" class="btn btn-primary btn-xs" ng-if="!$ctrl.getReadOnly()" ng-click="$ctrl.createNew()" sxy-text="SALAXY.UI_Terms.addRow"></button>
      </th>
    </tr>
  </thead>
  <tbody>
    <tr ng-repeat="item in $ctrl.value">
      <td>{{'SALAXY.ENUM.InsuranceCompany.' + item.company + '.label' | sxyTranslate}}</td>
      <td>{{item.contractNumber}}</td>
      <td>{{'SALAXY.ENUM.SettingsStatus.' + item.status + '.label' | sxyTranslate}}</td>
      <td class="right">{{item.startDate | date}}
        <span class="" ng-if="item.endDate">
          <br><small>(päättyy {{item.endDate | date}})</small>
        </span>
      </td>

      <td class="text-end" ng-if="!$ctrl.getReadOnly()">
        <button type="button" class="btn btn-primary btn-xs" ng-click="$ctrl.edit(item, $index)">
            <i class="bi bi-pencil-fill" title="Edit row"></i>
          </button>
        <button type="button" class="btn btn-danger btn-xs" ng-click="$ctrl.delete(item, $index)">
            <i class="bi bi-trash" title="Delete row"></i>
          </button>
      </td>
      <td class="text-end" ng-if="$ctrl.getReadOnly()">
        <button type="button" class="btn btn-primary btn-xs" ng-click="$ctrl.edit(item, $index)">
            <i class="bi bi-info-circle" title="Show row"></i>
          </button>
      </td>
    </tr>
  </tbody>
</table>`), s.put("salaxy-components/sxy-form/custom-templates/array-payment-channels.html", `<table class="table">
  <thead>
    <tr>
      <th sxy-text="SALAXY.MODEL.PaymentSettings.channels.title" colspan="2"></th>
      <th>Käytössä</th>
      <th>Valittavissa</th>
      <th class="text-end"></th>

    </tr>
  </thead>
  <tbody ng-controller="CompanySettingsController as $settingsCtrl">
    <tr ng-repeat="item in $ctrl.value">
      <td>
        <salaxy-avatar avatar="$settingsCtrl.getPaymentChannelAvatar(item)"></salaxy-avatar>
      </td>
      <td>
        {{$settingsCtrl.getPaymentChannelAvatar(item).displayName}}
      </td>
      <td>
        <span ng-if="item.isAvailable">{{'SALAXY.UI_Terms.yes' | sxyTranslate}} </span>
        <span ng-if="!item.isAvailable">{{'SALAXY.UI_Terms.no' | sxyTranslate}} </span>
      </td>
      <td>
        <span ng-if="item.isEnabled">{{'SALAXY.UI_Terms.yes' | sxyTranslate}} </span>
        <span ng-if="!item.isEnabled">{{'SALAXY.UI_Terms.no' | sxyTranslate}} </span>
      </td>
      <td class="text-end" ng-if="!$ctrl.getReadOnly()">
        <button type="button" class="btn btn-primary btn-xs" ng-click="$ctrl.edit(item, $index)">
            <i class="bi bi-pencil-fill" title="Edit row"></i>
          </button>
      </td>
    </tr>
  </tbody>
</table>`), s.put("salaxy-components/sxy-form/custom-templates/array-pension.html", `<p sxy-text="SALAXY.MODEL.CalculationSettings.pensionContracts.title" class="table-title"></p>
<table class="table">

  <thead>
    <tr>
      <th sxy-text="SALAXY.MODEL.PensionContract.company.title"></th>
      <th sxy-text="SALAXY.MODEL.PensionContract.contractNumber.title"></th>
      <th sxy-text="SALAXY.MODEL.PensionContract.status.title"></th>
      <th class="right" sxy-text="SALAXY.MODEL.PensionContract.startDate.title"></th>
      <th class="text-end">
        <button type="button" class="btn btn-primary btn-xs" ng-if="!$ctrl.getReadOnly()" ng-click="$ctrl.createNew()" sxy-text="SALAXY.UI_Terms.addRow"></button>
      </th>
    </tr>
  </thead>
  <tbody>
    <tr ng-repeat="item in $ctrl.value">
      <td>{{'SALAXY.ENUM.PensionCompany.' + item.company + '.label' | sxyTranslate}}</td>
      <td>{{ item.contractNumber}}</td>
      <td>{{'SALAXY.ENUM.SettingsStatus.' + item.status + '.label' | sxyTranslate}}</td>
      <td class="right">{{item.startDate | date}}
        <span class="" ng-if="item.endDate">
          <br><small>(päättyy {{item.endDate | date}})</small>
        </span>
      </td>

      <td class="text-end" ng-if="!$ctrl.getReadOnly()">
        <button type="button" class="btn btn-primary btn-xs" ng-click="$ctrl.edit(item, $index)">
            <i class="bi bi-pencil-fill" title="Edit row"></i>
          </button>
        <button type="button" class="btn btn-danger btn-xs" ng-click="$ctrl.delete(item, $index)">
            <i class="bi bi-trash" title="Delete row"></i>
          </button>
      </td>
      <td class="text-end" ng-if="$ctrl.getReadOnly()">
        <button type="button" class="btn btn-primary btn-xs" ng-click="$ctrl.edit(item, $index)">
            <i class="bi bi-info-circle" title="Show row"></i>
          </button>
      </td>
    </tr>
  </tbody>
</table>`), s.put("salaxy-components/sxy-form/custom-templates/array-service-model-payment-channels.html", `<table class="table">
  <thead>
    <tr>
      <th sxy-text="SALAXY.MODEL.PaymentSettings.channels.title" colspan="2"></th>
      <th>Käytössä</th>
      <th>Valittavissa</th>
      <th class="text-end">
        <button type="button" class="btn btn-primary btn-xs" ng-if="!$ctrl.getReadOnly()" ng-click="$ctrl.createNew()" sxy-text="SALAXY.UI_Terms.addRow"></button>
      </th>

    </tr>
  </thead>
  <tbody ng-controller="CompanySettingsController as $settingsCtrl">
    <tr ng-repeat="item in $ctrl.value">
      <td>
        <salaxy-avatar avatar="$settingsCtrl.getPaymentChannelAvatar(item)"></salaxy-avatar>
      </td>
      <td>
        {{$settingsCtrl.getPaymentChannelAvatar(item).displayName}}
      </td>
      <td>
        <span ng-if="item.isAvailable">{{'SALAXY.UI_Terms.yes' | sxyTranslate}} </span>
        <span ng-if="!item.isAvailable">{{'SALAXY.UI_Terms.no' | sxyTranslate}} </span>
      </td>
      <td>
        <span ng-if="item.isEnabled">{{'SALAXY.UI_Terms.yes' | sxyTranslate}} </span>
        <span ng-if="!item.isEnabled">{{'SALAXY.UI_Terms.no' | sxyTranslate}} </span>
      </td>
      <td class="text-end" ng-if="!$ctrl.getReadOnly()">
        <button type="button" class="btn btn-primary btn-xs" ng-click="$ctrl.edit(item, $index)">
            <i class="bi bi-pencil-fill" title="Edit row"></i>
          </button>
      </td>
    </tr>
  </tbody>
</table>`), s.put("salaxy-components/sxy-form/custom-templates/array-usecase.html", `<table class="table">
  <thead>
    <tr>
      <th sxy-text="SALAXY.NG1.ArrayUsecase.table.usecaseLabel" colspan="2"></th>
      <th></th>

      <th class="text-end">
        <button type="button" class="btn btn-primary btn-xs" ng-if="!$ctrl.getReadOnly()" ng-click="$ctrl.createNew()" sxy-text="SALAXY.UI_Terms.addRow"></button>
      </th>
    </tr>
  </thead>
  <tbody>
    <tr ng-repeat="item in $ctrl.value">
      <td>
        {{item.label}}
      </td>
      <td>{{'SALAXY.NG1.CalcListComponent.' + item.itemType | sxyTranslate}}</td>
      <td></td>
      <td class="text-end" ng-if="!$ctrl.getReadOnly()">
        <button type="button" class="btn btn-primary btn-xs" ng-click="$ctrl.edit(item, $index)">
          <i class="bi bi-pencil-fill" title="Edit row"></i>
        </button>
      </td>
    </tr>
  </tbody>
</table>`), s.put("salaxy-components/sxy-form/custom-templates/cost-accounting-options.html", `<table class="table" ng-if="$ctrl.form">
  <thead>
    <tr>
      <th sxy-text="SALAXY.MODEL.CostAccountingDimensionOption.value.title"></th>
      <th sxy-text="SALAXY.MODEL.CostAccountingDimensionOption.text.title"></th>
      <th sxy-text="SALAXY.MODEL.CostAccountingDimensionOption.scope.title"></th>
      <th colspan="2">
        <div class="btn-group btn-xs float-end dropdown">
          <button id="single-button" type="button" class="btn btn-default btn-xs dropdown-toggle" data-bs-toggle="dropdown">
            <i class="bi bi-three-dots" aria-hidden="true"></i>
          </button>
          <ul class="dropdown-menu" role="menu" aria-labelledby="single-button">
            <li role="menuitem">
              <a href="" ng-controller="ExportController as $export" ng-click="$export.showExport($ctrl.getExportable())" class="dropdown-item" sxy-text="SALAXY.NG1.ODataActionsComponent.export"></a>
            </li>
            <!--
              <li role="menuitem">
                <a href="" ng-controller="ImportController as $import" ng-click="$import.showImport($ctrl.getImportable())" class="dropdown-item" sxy-text="SALAXY.NG1.ODataActionsComponent.import"></a>
              </li> --> 
          </ul>
        </div>
        <button type="button" class="btn btn-default btn-xs float-end" ng-if="!$ctrl.getReadOnly()" ng-click="$ctrl.createNew({})" sxy-text="SALAXY.UI_Terms.addRow"></button>
      </th>
    </tr>
  </thead>
  <tbody>
    <tr ng-repeat="item in $ctrl.value">
      <td>
        <salaxy-input ng-model="item.value" name="{{ 'value' + $index }}" label-type="plain" read-only="$ctrl.getReadOnly()" ></salaxy-input>
      </td>
      <td>
        <salaxy-input ng-model="item.text" name="{{ 'text' + $index }}" label-type="plain" read-only="$ctrl.getReadOnly()" ></salaxy-input>
      </td>
      <td>
        <salaxy-input-enum enum="CostAccountingDimensionScope" ng-model="item.scope" name="{{ 'scope' + $index }}" label-type="plain" read-only="$ctrl.getReadOnly()" ></salaxy-input-enum>
      </td>
      <td colspan="2" class="text-end">
        <button ng-if="!$ctrl.getReadOnly()" type="button" class="btn btn-danger" ng-click="$ctrl.delete(item, $index)">
          <i class="bi bi-trash" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}"></i>
        </button>
      </td>
    </tr>
  </tbody>
</table>`), s.put("salaxy-components/sxy-form/custom-templates/holiday-row-types.html", `<table class="table" ng-if="$ctrl.form">
  <thead>
    <tr>
      <th sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.inputs.type"></th>
      <th class="text-right">
        <button type="button" class="btn btn-primary btn-xs" ng-if="!$ctrl.getReadOnly()" ng-click="$ctrl.value=($ctrl.value || []);$ctrl.value.push('')" sxy-text="SALAXY.UI_Terms.addRow"></button>
      </th>
    </tr>
  </thead>
  <tbody>
    <tr ng-repeat="item in $ctrl.value track by $index">
      <td>
        <salaxy-input-holiday-row-type ng-ref="$row" ng-model="$ctrl.value[$index]" name="{{ 'rowType' + $index }}" label-type="plain" read-only="$ctrl.getReadOnly()" ></salaxy-input-holiday-row-type>
      </td>
      <td class="text-right" ng-if="!$ctrl.getReadOnly()">
        <button type="button" class="btn btn-primary btn-xs" ng-click="$row.edit()">
          <i class="bi bi-pencil-fill" title="Edit row"></i>
        </button>
        <button type="button" class="btn btn-danger btn-xs" ng-click="$ctrl.delete(item, $index)">
          <i class="bi bi-trash" title="Delete row"></i>
        </button>
      </td>
      <td class="text-right" ng-if="$ctrl.getReadOnly()">
        <button type="button" class="btn btn-primary btn-xs" ng-click="$row.edit()">
          <i class="bi bi-info-circle" title="Show row"></i>
        </button>
      </td>
    </tr>
  </tbody>
</table>`), s.put("salaxy-components/sxy-form/custom-templates/select-accounting-target-item.html", `<a class="clickable salaxy-component salaxy-avatar-item">
  <salaxy-avatar style="font-size: 30px; vertical-align: middle;"
  avatar="match.model.otherPartyInfo.avatar"></salaxy-avatar>
  <b class="salaxy-highlight" ng-bind-html="match.label | uibTypeaheadHighlight:query"></b>
</a>
`), s.put("salaxy-components/sxy-form/error/default.html", `<salaxy-form-group name="{{ $ctrl.id }}" label="{{ $ctrl.getLabel() }}" tooltip-html="{{ $ctrl.getDescr() }}" read-only="$ctrl.getReadOnly()" disabled="$ctrl.getDisable()"
  require="$ctrl.getRequire()">
  <sxy-alert type="error">
    <div ng-if="$ctrl.input.content">{{ $ctrl.input.content }}</div>
    <div ng-if="!$ctrl.input.content">No UI for model "{{ $ctrl.model }}",  type "{{ $ctrl.type }}", format "{{ $ctrl.format }}".</div>
    <div>
      <salaxy-json-formatter key="'See input json'" json="$ctrl.input" type="dialog"></salaxy-json-formatter>
      <salaxy-json-formatter key="'See schema'" json="$ctrl.schemaModel" type="dialog"></salaxy-json-formatter>
    </div>
  </sxy-alert>
</salaxy-form-group>`), s.put("salaxy-components/sxy-form/integer/default.html", `<salaxy-input-number ng-model="$ctrl.value" name="{{ $ctrl.id }}" label="{{ $ctrl.getLabel() }}" tooltip-html="{{ $ctrl.getDescr() }}" read-only="$ctrl.getReadOnly()" disabled="$ctrl.getDisable()" require="$ctrl.getRequire()" sxy-integer>
</salaxy-input-number>`), s.put("salaxy-components/sxy-form/number/default.html", `<salaxy-input-number ng-model="$ctrl.value" name="{{ $ctrl.id }}" label="{{ $ctrl.getLabel() }}" tooltip-html="{{ $ctrl.getDescr() }}" read-only="$ctrl.getReadOnly()" disabled="$ctrl.getDisable()" require="$ctrl.getRequire()" unit="{{ $ctrl.input.format }}"
  minimum="{{$ctrl.getMinimum()}}" maximum="{{$ctrl.getMaximum()}}" multiple-of="{{$ctrl.getMultipleOf()}}">
</salaxy-input-number>`), s.put("salaxy-components/sxy-form/object/Avatar.html", `<salaxy-form-group name="{{ $ctrl.id }}" label="{{ $ctrl.getLabel() }}" tooltip-html="{{ $ctrl.getDescr() }}" read-only="$ctrl.getReadOnly()" disabled="$ctrl.getDisable()" require="$ctrl.getRequire()">
  <table>
    <tr>
      <td class="td-avatar middle">
        <salaxy-avatar avatar="$ctrl.value"></salaxy-avatar>
      </td>
      <td class="td-name middle">
        <strong>{{$ctrl.value.displayName}}</strong><br />
        <span class="">{{ $ctrl.value.id | sxyIban }}</span>
      </td>
    </tr>
  </table>
</salaxy-form-group>`), s.put("salaxy-components/sxy-form/object/DateRange.html", `<salaxy-date-range ng-model="$ctrl.value" name="{{ $ctrl.id }}" label="{{ $ctrl.getLabel() }}" tooltip-html="{{ $ctrl.getDescr() }}" read-only="$ctrl.getReadOnly()"
  disabled="$ctrl.getDisable()" require="$ctrl.getRequire()">
</salaxy-date-range>`), s.put("salaxy-components/sxy-form/object/default.html", `<salaxy-form-group name="{{ $ctrl.id }}" label="{{ $ctrl.getLabel() }}" tooltip-html="{{ $ctrl.getDescr() }}" read-only="$ctrl.getReadOnly()" disabled="$ctrl.getDisable()"
  require="$ctrl.getRequire()">
  <div>
    <button type="button" class="btn btn-default" ng-click="$ctrl.isInEdit[$ctrl.id] = !$ctrl.isInEdit[$ctrl.id]">{{ $ctrl.isInEdit[$ctrl.id] ? "Hide" : "Edit" }}</button>
  </div>
</salaxy-form-group>
<div ng-if="$ctrl.isInEdit[$ctrl.id]" class="row">
  <div class="col-md-offset-1 col-11">
    <sxy-fieldset model="{{ $ctrl.model }}"></sxy-fieldset>
  </div>
</div>`), s.put("salaxy-components/sxy-form/string/date-time.html", `<salaxy-form-group name="{{$ctrl.id}}" class="salaxy-component salaxy-read-only" label="{{$ctrl.getLabel()}}">
  <div class="form-control-plaintext">{{ $ctrl.value | date : "dd.MM.yyyy HH:mm" }}</div>
</salaxy-form-group>
`), s.put("salaxy-components/sxy-form/string/date.html", '<salaxy-datepicker-popup ng-model="$ctrl.value" name="{{ $ctrl.id }}" label="{{ $ctrl.getLabel() }}" tooltip-html="{{ $ctrl.getDescr() }}" read-only="$ctrl.getReadOnly()" disabled="$ctrl.getDisable()" require="$ctrl.getRequire()"></salaxy-datepicker-popup>'), s.put("salaxy-components/sxy-form/string/default.html", `<salaxy-input ng-model="$ctrl.value" name="{{ $ctrl.id }}" label="{{ $ctrl.getLabel() }}" tooltip-html="{{ $ctrl.getDescr() }}" read-only="$ctrl.getReadOnly()" disabled="$ctrl.getDisable()" require="$ctrl.getRequire()" minlength="{{$ctrl.getMinLength()}}"
  maxlength="{{$ctrl.getMaxLength()}}" pattern="{{$ctrl.getPattern()}}">
</salaxy-input>`), s.put("salaxy-components/sxy-form/string/email.html", `<salaxy-input ng-model="$ctrl.value" name="{{ $ctrl.id }}" label="{{ $ctrl.getLabel() }}" tooltip-html="{{ $ctrl.getDescr() }}" read-only="$ctrl.getReadOnly()"
  disabled="$ctrl.getDisable()" require="$ctrl.getRequire()" sxy-email>
</salaxy-input>`), s.put("salaxy-components/sxy-form/string/enum.html", `<salaxy-input-enum ng-model="$ctrl.value" name="{{ $ctrl.id }}" label="{{ $ctrl.getLabel() }}" tooltip-html="{{ $ctrl.getDescr() }}" read-only="$ctrl.getReadOnly()"
  disabled="$ctrl.getDisable()" require="$ctrl.getRequire()" type="{{ $ctrl.getFormat() }}" options="$ctrl.getEnumOptions()"></salaxy-input-enum>`), s.put("salaxy-components/sxy-form/string/multiline.html", `<salaxy-textarea ng-model="$ctrl.value" name="{{ $ctrl.id }}" label="{{ $ctrl.getLabel() }}" tooltip-html="{{ $ctrl.getDescr() }}" read-only="$ctrl.getReadOnly()"
  disabled="$ctrl.getDisable()" require="$ctrl.getRequire()" maxlength="10000">
</salaxy-textarea>`), s.put("salaxy-components/sxy-form/string/password.html", `<salaxy-input ng-model="$ctrl.value" name="{{ $ctrl.id }}" label="{{ $ctrl.getLabel() }}" tooltip-html="{{ $ctrl.getDescr() }}" read-only="$ctrl.getReadOnly()"
  disabled="$ctrl.getDisable()" require="$ctrl.getRequire()" type="password"></salaxy-input>`), s.put("salaxy-components/sxy-form/string/pension-contract-number.html", `<salaxy-input  ng-if="'!admin' | sxyIsInRole" ng-model="$ctrl.value" name="{{ $ctrl.id }}" label="{{ $ctrl.getLabel() }}" tooltip-html="{{ $ctrl.getDescr() }}" read-only="$ctrl.getReadOnly()" disabled="$ctrl.getDisable()" require="$ctrl.getRequire()" type="pension-contract-number" sxy-pension-contract-number>
</salaxy-input>
<salaxy-input  ng-if="'admin' | sxyIsInRole" ng-model="$ctrl.value" name="{{ $ctrl.id }}" label="{{ $ctrl.getLabel() }}" tooltip-html="{{ $ctrl.getDescr() }}" read-only="$ctrl.getReadOnly()" disabled="$ctrl.getDisable()" require="$ctrl.getRequire()" type="pension-contract-number">
</salaxy-input>`), s.put("salaxy-components/sxy-form/string/telephone.html", `<salaxy-input ng-model="$ctrl.value" name="{{ $ctrl.id }}" label="{{ $ctrl.getLabel() }}" tooltip-html="{{ $ctrl.getDescr() }}" read-only="$ctrl.getReadOnly()"
  disabled="$ctrl.getDisable()" require="$ctrl.getRequire()" sxy-mobile-phone></salaxy-input>`), s.put("salaxy-components/sxy-form/SxyAlert.html", `<div class="salaxy-component salaxy-alert">
  <!-- TODO: Switch styling to "sxy-component sxy-alert" -->
  <div ng-class="$ctrl.getAlertClasses()">
    <div>
      <table style="width: 100%; border-collapse:separate;">
        <!-- TODO: Switch this to position:absolute & margins or flex-grid -->
        <tr>
          <td class="icon-container hidden-xxs" ng-if="$ctrl.getAlertIcon()">
            <span class="icon"><i class="bi {{ $ctrl.getAlertIcon() }}"></i></span>
          </td>
          <td>
            <div class="main">
              <ng-transclude>
                <div sxy-html="{{$ctrl.msg}}"></div>
              </ng-transclude>
            </div>
          </td>
          <td ng-if="$ctrl.aside" class="text-end">
            <button class="btn btn-info btn-main" ng-click="$ctrl.showMoreInfo = !$ctrl.showMoreInfo" sxy-text="SALAXY.UI_Terms.learnMore"></button>
          </td>
        </tr>
      </table>
      <div class="collapse" ng-if="$ctrl.aside" ng-class="{ show: $ctrl.showMoreInfo }">
        <div sxy-html="$ctrl.aside"></div>
      </div>
    </div>
  </div>
</div>`), s.put("salaxy-components/sxy-form/SxyCodeEditor.html", `<div class="salaxy-component sxy-code-editor">
  <div ng-if="$ctrl.mode == 'basic'">
    <pre ng-if="$ctrl.readOnly" style="padding: 10px; background-color: #1e1e1e; color: #d4d4d4">{{ $ctrl.code }}</pre>
    <textarea ng-if="!$ctrl.readOnly"
      style="font-family: 'Courier New', Courier, monospace; background-color: #1e1e1e; color: #d4d4d4; padding: 10px; width: 100%;"
      ng-model="$ctrl.value" ng-model-options="{allowInvalid: true, debounce: 250, updateOn: 'default' }" ng-change="$ctrl.onChange()"
      name="actionContent" rows="10"></textarea>
  </div>
  <div ng-if="$ctrl.mode != 'basic'">
    <iframe ng-src="{{ $ctrl.codeEditorUrl }}" style="width: 100%;" ng-style="{ height: $ctrl.height || '400px' }"></iframe>
  </div>
</div>


`), s.put("salaxy-components/sxy-form/SxyFieldset.html", `<div ng-switch="$ctrl.format" ng-if="$ctrl.form">
  <fieldset ng-switch-when="source">
    <legend>Form inputs source code (auto-gen)</legend>
    <pre>&lt;fieldset&gt;
  &lt;legend&gt;{{ $ctrl.label }}&lt;/legend&gt;
<span ng-repeat="input in $ctrl.getChildInputs()">  &lt;sxy-input model="{{ input.path }}"&gt;&lt;/sxy-input&gt;<br /></span>&lt;/fieldset&gt;
</pre>
  </fieldset>
  <fieldset ng-switch-default>
    <legend>{{ $ctrl.getLabel() }}</legend>
    <p>{{ $ctrl.getDescr() }}</p>
    <sxy-input model="{{ input.path }}" ng-repeat="input in $ctrl.getChildInputs()"></sxy-input>
  </fieldset>
</div>`), s.put("salaxy-components/sxy-form/SxyForm.html", `<div class="salaxy-component sxy-form form-horizontal">
  <h2 ng-if="$ctrl.legend">{{ $ctrl.legend }}</h2>
  <ng-form name="$ctrl.ngForm">
    <div ng-if="!$ctrl.isReady">
      <p>Ladataan...</p>
    </div>
    <div ng-if="$ctrl.isReady">
      <div ng-if="!$ctrl.autoGen" ng-transclude="div">
        <div class="alert alert-info">
          Either set <code>auto-gen</code> attribute to true or add a
          <code>DIV</code> element with your form sxy-input definitions.
        </div>
      </div>
      <div ng-if="$ctrl.autoGen">
        <sxy-fieldset model="form" label="{{ $ctrl.label }}"></sxy-fieldset>
      </div>
      <div ng-if="$ctrl.debugger">
        <salaxy-tab-buttons
          current-tab="$ctrl.currentTab"
          options="[
            { value: 'data', text: 'Data' },
            { value: 'schema', text: 'Auto-gen' },
            { value: 'codegen', text: 'Code-gen' },
            { value: 'registrations', text: 'Components' },
            { value: 'validation', text: 'Validation' }
          ]"
          tabs-id="sxyForm">
        </salaxy-tab-buttons>
        <div class="tab-content" id="tab-content-sxyForm">
          <div class="tab-pane" id="data-tab">
            <salaxy-json-formatter key="'data'" json="$ctrl.model" open="2"></salaxy-json-formatter>
          </div>
          <div class="tab-pane" id="schema-tab">
            <salaxy-json-formatter key="$ctrl.type" json="$ctrl.schemaModel" open="2"></salaxy-json-formatter>
          </div>
          <div class="tab-pane" id="codegen-tab">
            <sxy-fieldset model="form" format="source" label="{{ $ctrl.label }}"></sxy-fieldset>
          </div>
          <div class="tab-pane" id="registrations-tab">
            <p>
              This is a list of component registrations. Note that debugger "Code-gen" tab currently makes one registration for the form (with name "[Parent][n1]_form[n2]"). This might be removed later.
            </p>
            <ul>
              <li ng-repeat="(key, value) in $ctrl.registeredInputs">{{ key }}</li>
            </ul>
          </div>
          <div class="tab-pane" id="validation-tab">
            <salaxy-validation-summary api-validation="$ctrl.getValidation()"></salaxy-validation-summary>
          </div>
        </div>
      </div>
    </div>
  </ng-form>
</div>`), s.put("salaxy-components/sxy-form/SxyGrid.html", `<div class="salaxy-component sxy-grid height100">
  <div class="btn-toolbar">
    <div class="btn-group">
      <button type="button" class="btn btn-default" ng-click="$ctrl.addRow()">Add row</button>
      <button type="button" class="btn btn-danger" ng-disabled="!$ctrl.selection.length" ng-click="$ctrl.deleteSelectedRows()">Delete rows ({{ $ctrl.selection.length }})</button>
    </div>
    <div class="btn-group" ng-if="$ctrl">
      <button type="button" class="btn btn-default" ng-controller="ExportController as $export" ng-click="$export.showExport($ctrl.getExportable())">Export</button>
    </div>
  </div>
  <div id="dataGrid" class="ag-theme-balham height100" style="height: calc(100% - 34px);overflow: hidden;"></div>
</div>`), s.put("salaxy-components/sxy-form/SxyInput-dialog-edit.html", `<div class="modal-header">
  <h2 class="modal-title">{{ $ctrl.logic.title }}</h2>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
</div>
<div class="modal-body">
  <sxy-form open-api="{{ $ctrl.logic.openApi }}" type="{{ $ctrl.logic.type }}" auto-gen="true" debugger="$ctrl.logic.debugger" model="$ctrl.current" read-only="{{$ctrl.logic.isReadOnly ? 'true' : ''}}"></sxy-form>
</div>
<div class="modal-footer">
  <button type="button" ng-if="$ctrl.logic.showDelete" class="btn btn-danger float-start" ng-click="$close('delete-no-save')" sxy-text="SALAXY.UI_Terms.delete"></button>
  <button type="reset" ng-if="!$ctrl.logic.isReadOnly" class="btn btn-default ms-auto" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
  <button type="button" ng-if="!$ctrl.logic.isReadOnly" class="btn btn-primary" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.ok"></button>
  <button type="button" ng-if="$ctrl.logic.isReadOnly" class="btn btn-primary" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
</div>`), s.put("salaxy-components/sxy-form/SxyInput.html", '<ng-include src="$ctrl.templateUrl" ng-if="$ctrl.form"></ng-include>'), s.put("salaxy-components/sxy-form/SxySchemaEditor.html", `<div class="row">
  <div class="col-md-6" ng-repeat="(key, value) in $ctrl.model">
    <fieldset>
      <legend>
        <button type="button" class="btn btn-danger btn-xs float-end" ng-click="$ctrl.deleteProperty(key)">Poista</button>
        {{ $index + 1 }}. {{ key }}
      </legend>
      <salaxy-input label="Teksti" name="title" ng-model="value.title"></salaxy-input>
      <salaxy-input label="Kuvaus" name="description" ng-model="value.description"></salaxy-input>
      <salaxy-input-enum label="Tietotyyppi" name="type" ng-model="value.type"
        options="$ctrl.types"></salaxy-input-enum>
      <salaxy-input-enum ng-if="value.type" label="Käyttöliittymä" name="type" ng-model="value.format"
        disable-cache="true" options="$ctrl.getFormats(value.type)"></salaxy-input-enum>
<!--
- Lisää esikatselu
- Lisää Array: Prosenttipohjainen jako, ehkä myös string ja number
-->
    </fieldset>
  </div>
  <div class="col-md-6">
    <button type="button" class="btn btn-primary btn-block" ng-click="$ctrl.addProperty()">Lisää uusi</button>
  </div>
</div>`), s.put("salaxy-components/sxy-table/SxyTable.html", '<div style="margin-top: 10px; margin-bottom: 10px;"></div>'), s.put("salaxy-components/test/AccountReset.html", `<div class="salaxy-component salaxy-account-reset">
  <hr />
  <h2>Vain testiympäristö</h2>
  <p class="lead">
    Nämä toiminnallisuudet ovat näkyvissä vain testiympäristössä. Voit käyttää näitä toimintoja testataksesi työnantajan tiliä eri tiloissa.
  </p>
  <div class="table-responsive">
    <table class="table">
      <tr>
        <td>Poista kaikki laskelmat.</td>
        <td><button class="btn btn-danger btn-block" ng-click="$ctrl.deleteCalculations()">Poista laskelmat</button></td>
      </tr>
      <tr>
        <td>Poista kaikki työntekijät. Tämä poistaa myös laskelmat, jos niitä on.</td>
        <td><button class="btn btn-danger btn-block" ng-click="$ctrl.deleteWorkers()">Poista työntekijät</button></td>
      </tr>
      <tr>
        <td>Poista loma- ja poissaolokirjanpito kaikilta työntekijöiltä.</td>
        <td><button class="btn btn-danger btn-block" ng-click="$ctrl.deleteHolidays()">Poista lomat ja poissaolot</button></td>
      </tr>
      <tr>
        <td>Poista kaikki data: Laskelmien ja työntekijöiden lisäksi myös mahd. työsopimukset, raportit jne. Asetukset ja allekirjoitus pysyvät ennallaan.</td>
        <td><button class="btn btn-danger btn-block" ng-click="$ctrl.deleteData()">Poista kaikki data</button></td>
      </tr>
      <tr>
        <td>Poista TyEL ja Tapavak: Käyttäjällä on puutteita palkanmaksun asetuksissa.</td>
        <td><button class="btn btn-danger btn-block" ng-click="$ctrl.deletePensionAndInsurance()">Poista TyEL ja Tapavak</button></td>
      </tr>
      <tr>
        <td>Poista Allekirjoitus: Käyttäjä keskeyttänyt Onboarding-wizardin ennen digitaalista allekirjoitusta.</td>
        <td><button class="btn btn-danger btn-block" ng-click="$ctrl.deleteSignature()">Poista Allekirjoitus</button></td>
      </tr>
      <tr>
        <td>Poista luodut tilit. Tämän tilin luomat uudet tilit, joilla ei ole maksettuja laskelmia tai allekirjoituksia, poistetaan.</td>
        <td><button class="btn btn-danger btn-block" ng-click="$ctrl.deleteAuthorizingAccounts()">Poista luodut tilit</button></td>
      </tr>
      <tr>
        <td>Tuhoa tili: Tuhoa koko tili. Voit aloittaa Onboarding-prosessin alusta.</td>
        <td><button class="btn btn-danger btn-block" ng-click="$ctrl.deleteCurrent()">Tuhoa tili</button></td>
      </tr>
      <tr>
        <td>{{$ctrl.isKycMissing() ? 'Aktivoi tilin KYC' : 'Poista tilin KYC'}}</td>
        <td>
          <button ng-class="$ctrl.isKycMissing() ? 'btn-info' : 'btn-danger'" class="btn btn-block" ng-click="$ctrl.handleKyc()">{{$ctrl.isKycMissing() ? 'Aktivoi KYC' : 'Poista KYC'}}</button>
        </td>
      </tr>
    </table>
  </div>
</div>`), s.put("salaxy-components/test/SmokeTest.html", `<div ng-switch="$ctrl.mode">
  <fieldset ng-switch-when="reports">
    <legend><code>@salaxy/reports</code> functionality</legend>
    <p>
      Library loaded:
      <span class="label" ng-class="$ctrl.reportsTests.loaded ? 'label-success' : 'label-danger'">{{ $ctrl.reportsTests.loaded ? "OK" : "ERROR" }}</span>
    </p>
    <p>
      Basic functionality:
      <span class="label" ng-class="$ctrl.reportsTests.mapper ? 'label-success' : 'label-danger'">{{ $ctrl.reportsTests.mapper ? "OK" : "ERROR" }}</span>
    </p>
    <p>
      Report templates <small>(Handlebars)</small>:
      <span class="label" ng-class="$ctrl.reportsTests.handlebars ? 'label-success' : 'label-danger'">{{ $ctrl.reportsTests.handlebars ? "OK" : "ERROR" }}</span>
    </p>
  </fieldset>
  <fieldset ng-switch-default>
    <legend><code>@salaxy/core</code> functionality</legend>
    <p>
      Basic functionality:
      <span class="label" ng-class="$ctrl.getNumber() ? 'label-success' : 'label-danger'">{{ $ctrl.getNumber() ? "OK" : "ERROR" }}</span>
    </p>
    <p>
      Dates <small>(MomentJS loaded)</small>:
      <span class="label" ng-class="$ctrl.getADate() == '20.02.2020' ? 'label-success' : 'label-danger'">
        {{ $ctrl.getADate() == '20.02.2020' ? "OK" : "ERROR" }}</span>
    </p>
    <p>
      Token <small>(Base64)</small>:
      <span class="label" ng-class="$ctrl.readToken() ? 'label-success' : 'label-danger'">{{ $ctrl.readToken() ? "OK" : "ERROR" }}</span>
    </p>
    <p>
      Text from json: {{ $ctrl.getJson() }}
      <span class="label" ng-class="$ctrl.getJson() == 'This text is in json' ? 'label-success' : 'label-danger'">{{ $ctrl.getJson() == 'This text is in json' ? "OK" : "ERROR" }}</span>
    </p>
  </fieldset>
  <fieldset ng-switch-when="ng1">
    <legend><code>@salaxy/ng1</code> functionality</legend>
    <p>
      Library loaded:
      <span class="label" ng-class="$ctrl.sessionSrv ? 'label-success' : 'label-danger'">{{ $ctrl.sessionSrv ? "OK" : "ERROR" }}</span>
    </p>
    <p>
      Basic functionality:
      <span class="label" ng-class="$ctrl.sessionSrv.isInSomeRole('auth,anon,init') ? 'label-success' : 'label-danger'">{{ $ctrl.sessionSrv.isInSomeRole('auth,anon,init') ? "OK" : "ERROR" }}</span>
    </p>
    <div>
      <p>Component with template: You should see a drop-down menu with insurance companies below.</p>
      <salaxy-input-enum enum="InsuranceCompany" name="InsuranceCompany" label="SALAXY.NG1.ProductDialogsComponent.company" ng-model="$ctrl.temp.insuranceCompany"></salaxy-input-enum>
    </div>
  </fieldset>
  <fieldset ng-switch-when="ng1">
    <legend><code>@salaxy/ng1</code> AngularJS Modules</legend>
    <div>
      <b>angular-i18n (angular-locale_fi):</b><br /> The following sums should have the same euro currency format: {{ 1234 | currency }} == 1 234,00€<br /> Date should be in Finnish format: 20.12.2021 == {{ "2021-12-20" | date }}
    </div>
    <div>
      <b>angular-route:</b>
      <span class="label label-warning">TODO</span>
    </div>
    <div>
      <b>angular-sanitize:</b>
      <div sxy-html="&lt;span class='label label-success'&gt;This text should be in GREEN background&lt;/span&gt;"></div>
    </div>
    <div>
      <b>angular-translate:</b><br />
      <p>This text should be "Kyllä" / "Yes": <strong sxy-text="SALAXY.UI_Terms.yes">ERROR</strong> <small>(ng1)</small></p>
      <p>This text should be "OK": <strong sxy-text="SALAXY.UI_Terms.ok">ERROR</strong> <small>(core)</small></p>
    </div>
    <div>
      <b>angular-ui-bootstrap:</b> You should see a progress bar below:<br />
      <div class="progress">
        <div class="progress-bar-striped bg-danger" role="progressbar" style="width: 83%">83 %</div>
      </div>
    </div>
    <!-- <div>
      <b>Chart <small>Chart.js, angular-chart.js and chartjs-plugin-annotation</small>:</b> You should see a chart below with annotation.
      <div class="salaxy-tax-card-chart chart-container">
        <canvas id="line" class="chart chart-line" chart-data="$ctrl.chartData.data" chart-dataset-override="$ctrl.chartData.datasets" chart-labels="$ctrl.chartData.labels" chart-fill="$ctrl.chartData.fill" chart-colors="$ctrl.chartData.colors" chart-options="$ctrl.chartData.options"></canvas>
      </div>
    </div> -->
    <div>
      <b>ng-file-upload:</b><br />
      <button type="button" class="btn btn-default" ngf-select="upload($file)">Click me to show Upload dialog</button> (Open/Cancel does nothing)
    </div>
    <hr />
    <legend><code>@salaxy/ng1</code> Imported Modules</legend>
    <div>
      <b>file-saver:</b>
      <button type="button" class="btn btn-default" ng-click="$ctrl.saveAs()">Click me to download a text file.</button>
    </div>
    <div>
      <b>jszip:</b>
      <span class="label label-warning">TODO</span>
    </div>
    <div>
      <b>marked: The following text should be formatted:</b>
      <div ng-bind-html="'_italic_, **bold**, 'monospace', ~~strikethrough~~, [link](http://example.com)' | sxyMarkdown"></div>
    </div>
    <div>
      <b>rrule:</b>
      <span class="label label-warning">TODO</span>
    </div>
    <hr />
    <legend>Removed</legend>
    <p>The following dependencies have been dropped from this version:</p>
    <ul>
      <li>Babel (was in core): Babel was obsolete and we can target 2015. If necesssary, consider https://github.com/ryanelian/ts-polyfill or https://polyfill.io/v3/url-builder/ instead of js-core 3 (it has advertising issues).</li>
      <li>js-base64: Moved from NG1 to Core (so not really removed)</li>
      <li>angular-i18n: Not currently in use. Contains angular locales, e.g. </li>
      <li>angular-animate: Removed as not used. Search for "ngAnimate" in projects.</li>
      <li>angular-touch: Removed. Project marked as obsolete ages ago.</li>
    </ul>
  </fieldset>
</div>`), s.put("salaxy-components/worker/AbsencePeriods.html", `<div class="salaxy-component salaxy-holiday-year-absences">
  <div ng-if="!$ctrl.list" class="alert alert-info">
    <p sxy-text="SALAXY.NG1.AbsencePeriodsComponent.selectWorker"></p>
  </div>
  <div ng-if="$ctrl.list && $ctrl.mode == 'calendar'">
    <salaxy-calendar data="$ctrl.parent" on-list-select="$ctrl.calendarClick(type, date, calEvent)"
      start="$ctrl.filterStart" end="$ctrl.filterEnd" mapper="$ctrl.mapToCalendar"></salaxy-calendar>
    <div class="text-end">
      &nbsp;<br/>
      <button type="button" class="btn btn-default" ng-click="$ctrl.showEditDialog('new')" sxy-text="SALAXY.NG1.AbsencePeriodsComponent.addAbsenceButtonText"></button>
    </div>
  </div>
  <div ng-if="$ctrl.list && $ctrl.mode != 'calendar'">
    <table class="table table-striped {{ $ctrl.condensed ? 'table-sm' : '' }}">
      <thead>
        <tr>
          <th sxy-text="SALAXY.NG1.AbsencePeriodsComponent.headerAbsence"></th>
          <th class="right" sxy-text="SALAXY.NG1.AbsencePeriodsComponent.headerDays"></th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="row in $ctrl.list | filter: $ctrl.filter" ng-click="$ctrl.showEditDialog(row)" class="clickable">
          <td>
            <salaxy-avatar class="salaxy-calc-row-type-avatar float-start" avatar="{ color: '#2b507c', initials: (row.period.daysCount + 'pv'), entityType: 'company' }"></salaxy-avatar>
            <strong>{{ "AbsenceCauseCode." + row.causeCode | sxyEnum }}</strong><br />
            <div class="float-start" style="padding: 0px;">
              {{ row.isPaid ? ('SALAXY.NG1.AbsencePeriodsComponent.isPaid' | sxyTranslate) : ('SALAXY.NG1.AbsencePeriodsComponent.notPaid' |sxyTranslate) }}
              <span ng-if="row.isPaid != row.isHolidayAccrual"> {{ row.isHolidayAccrual ? ('SALAXY.NG1.AbsencePeriodsComponent.isAccrual' | sxyTranslate) : ('SALAXY.NG1.AbsencePeriodsComponent.notAccrual' | sxyTranslate) }}</span>
            </div>
            <div class="truncate" style="max-width: 250px; padding: 0px;">
              &nbsp;{{ row.notes }}
            </div>
          </td>
          <td class="right">
            <strong>{{ row.period.daysCount | sxyCount : "day" }}</strong><br /> {{ row.period | sxyDateRange }}
          </td>
        </tr>
        <tr ng-if="$ctrl.filteredList.length == 0">
          <td colspan="2">
            <h3 sxy-text="SALAXY.NG1.AbsencePeriodsComponent.noAbsences"></h3>
            <p sxy-text="SALAXY.NG1.AbsencePeriodsComponent.noAbsencesDescription"></p>
            <p sxy-text="SALAXY.NG1.AbsencePeriodsComponent.noAbsencesDescription2"></p>
          </td>
        </tr>
        <tr class="total">
          <td>
            <salaxy-avatar class="salaxy-calc-row-type-avatar float-start" style="margin-bottom: 20px" avatar="{ color: '#2b507c', initials: 'sum', entityType: 'company' }"></salaxy-avatar>
            <strong>
             <span sxy-text="SALAXY.NG1.AbsencePeriodsComponent.totalUnpaid"></span><br />
                         <span sxy-text="SALAXY.NG1.AbsencePeriodsComponent.totalNoHolidayAccrual"></span><br />
                           <span sxy-text="SALAXY.NG1.AbsencePeriodsComponent.totalAll"></span><br />
            </strong>
          </td>
          <td class="right">
            <strong>
              {{ $ctrl.getTotalDays("absencesUnpaid") | sxyCount : "day" }}<br />
              {{ $ctrl.getTotalDays("absencesNoHolidayAccrual") | sxyCount : "day" }}<br />
              {{ $ctrl.getTotalDays("all") | sxyCount : "day" }}<br />
            </strong>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="text-end">
      <button type="button" class="btn btn-default" ng-click="$ctrl.showEditDialog('new')" sxy-text="SALAXY.NG1.AbsencePeriodsComponent.addAbsenceButtonText"></button>
    </div>
  </div>
</div>`), s.put("salaxy-components/worker/AbsencePeriodsEditDialog.html", `  <div class="modal-header">
    <h1 class="modal-title" sxy-text="SALAXY.NG1.AbsencePeriodsEditDialog.panelHeading"></h1>
    <button type="button" class="btn-close" ng-click="$dismiss()" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <form class="form-horizontal" name="absencePeriodsForm">
      <salaxy-input-typeahead name="causeCode" ng-model="$ctrl.current.causeCode" enum="AbsenceCauseCode" label="SALAXY.MODEL.WorkerAbsencePeriod.absencesId.title" ng-change="$ctrl.logic.updateIsPaid($ctrl.current)" require="true" options="$ctrl.getCauseCodes()"></salaxy-input-typeahead>
      <salaxy-datepicker-popup name="start" ng-model="$ctrl.current.period.start" ng-change="$ctrl.logic.updatePeriodDays($ctrl.current)" label="SALAXY.MODEL.DateRange.start.title"></salaxy-datepicker-popup>
      <salaxy-datepicker-popup name="end" ng-model="$ctrl.current.period.end" ng-change="$ctrl.logic.updatePeriodDays($ctrl.current)" label="SALAXY.MODEL.DateRange.end.title"></salaxy-datepicker-popup>
      <salaxy-form-group name="daysCount" label="SALAXY.MODEL.DateRange.daysCount.title" ng-if="$ctrl.current.period.days == null">
        <div class="input-group">
          <input class="form-control" type="text" autocomplete="off" id="daysCount" name="daysCount" ng-model="$ctrl.current.period.daysCount" disabled>
          <span class="input-group-btn">
            <button type="button" class="btn btn-default" ng-click="$ctrl.logic.setDaysSelection($ctrl.current);" sxy-text="SALAXY.NG1.AbsencePeriodsEditDialog.editDatesButtonText"></button>
          </span>
        </div>
      </salaxy-form-group>
      <salaxy-datepicker ng-show="$ctrl.current.period.days != null" name="days" is-multiple="true" ng-model="$ctrl.current.period" watch-changes="true" label="SALAXY.MODEL.WorkerAbsencePeriod.period.title" min-date="$ctrl.current.period.start" max-date="$ctrl.current.period.end"></salaxy-datepicker>
      <salaxy-input-boolean type="checkbox" name="isPaid" label="SALAXY.MODEL.WorkerAbsencePeriod.isPaid.title" label-true="SALAXY.NG1.AbsencePeriodsEditDialog.label.isPaidLabelTrue" disabled="!$ctrl.logic.canSelectIsPaid($ctrl.current)" ng-model="$ctrl.current.isPaid"
        ng-change="$ctrl.logic.updateIsHolidayAccrual($ctrl.current)"></salaxy-input-boolean>
      <salaxy-input-boolean type="checkbox" name="isHolidayAccrual" label="SALAXY.MODEL.WorkerAbsencePeriod.isHolidayAccrual.title" label-true="SALAXY.NG1.AbsencePeriodsEditDialog.label.isAccrualLabelTrue" ng-model="$ctrl.current.isHolidayAccrual"></salaxy-input-boolean>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" ng-click="$close('delete')" sxy-text="SALAXY.NG1.AbsencePeriodsEditDialog.deleteButtonText"></button>
    <button type="reset" class="btn btn-default ms-auto" ng-click="$close('cancel')" sxy-text="SALAXY.NG1.AbsencePeriodsEditDialog.cancelButtonText"></button>
    <button type="submit" ng-disabled="absencePeriodsForm.$invalid" class="btn btn-primary" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.ok"></button>
  </div>`), s.put("salaxy-components/worker/employment/Details.html", `<ng-include src="'salaxy-components/worker/employment/Details_Header.html'"></ng-include>
<div ng-if="$ctrl.status == 'initialLoading'">
  <p sxy-text="SALAXY.UI_Terms.loading"></p>
</div>
<div>
  <salaxy-tab-buttons
    ng-if="$ctrl.current"
    current-tab="$ctrl.currentTab"
    options="[
      { value: 'default', text: 'SALAXY.NG1.WorkerDetailsComponent.workerInfo', isDefault: true },
      { value: 'employment', text: 'SALAXY.NG1.WorkerDetailsComponent.employment' },
      { value: 'calcrows', text: 'SALAXY.NG1.WorkerDetailsComponent.defaultCalcRows' },
      { value: 'calculations', text: 'SALAXY.NG1.WorkerDetailsComponent.calculations' },
      { value: 'taxcards', text: 'SALAXY.NG1.WorkerDetailsComponent.taxcards' },
      { value: 'holidays', text: 'SALAXY.NG1.WorkerDetailsComponent.holidays', hidden: ('disableHolidays' | sxyIsInRole) },
      { value: 'absences', text: 'SALAXY.NG1.WorkerDetailsComponent.absences', hidden: ('disableHolidays' | sxyIsInRole) },
      { value: 'records', text: 'SALAXY.NG1.WorkerDetailsComponent.records.label', hidden: $ctrl.isModal && isHousehold },
      { value: 'debugger', text: 'DEBUG', hidden: !('disabled-test' | sxyIsInRole) }
    ]"
    tabs-id="employmentDetails">
  </salaxy-tab-buttons>
  <div class="tab-content" id="tab-content-employmentDetails">
    <div class="tab-pane" id="default-tab">
      <ng-include src="'salaxy-components/worker/employment/Details_Basic.html'" ng-if="$ctrl.currentTab == 'default'"></ng-include>
    </div>
    <div class="tab-pane" id="employment-tab">
      <ng-include src="'salaxy-components/worker/employment/Details_EmploymentRelation.html'" ng-if="$ctrl.currentTab == 'employment'"></ng-include>
    </div>
    <div class="tab-pane" id="calcrows-tab">
      <ng-include src="'salaxy-components/worker/employment/Details_Calc.html'" ng-if="$ctrl.currentTab == 'calcrows'"></ng-include>
    </div>
    <div class="tab-pane" id="calculations-tab">
      <salaxy-odata-table ng-if="$ctrl.current.personalInfo" read-only="$ctrl.isReadOnlyForced" crud-controller="CalculationCrudController as $crud"
        options="{ $filter: 'otherPartyInfo/officialId eq \\'' + $ctrl.current.personalInfo.officialId + '\\' and ( status ne \\'proDraft\\' and status ne \\'payrollDraft\\')' }"
        template-url="salaxy-components/odata/lists/CalculationsWorker.html" logic="$ctrl.calcListLogic" ng-if="$ctrl.currentTab == 'calculations'">
      </salaxy-odata-table>
    </div>
    <div class="tab-pane" id="taxcards-tab">
      <ng-include src="'salaxy-components/worker/employment/Details_Tax.html'" ng-if="$ctrl.currentTab == 'taxcards'"></ng-include>
    </div>
    <div class="tab-pane" id="holidays-tab">
      <salaxy-worker-holidays employment-id="$ctrl.current.id" ng-if="$ctrl.currentTab == 'holidays'"></salaxy-worker-holidays>
    </div>
    <div class="tab-pane" id="absences-tab">
      <salaxy-worker-absences employment-id="$ctrl.current.id" ng-if="$ctrl.currentTab == 'absences'"></salaxy-worker-absences>
    </div>
    <div class="tab-pane" id="records-tab">
      <salaxy-records ng-if="$ctrl.current" read-only="$ctrl.isReadOnlyForced" api-ctrl="$ctrl" entity-type="'employment'" ng-if="(!$ctrl.isModal || !isHousehold) && $ctrl.currentTab == 'records'"></salaxy-records>
    </div>
    <div class="tab-pane" id="debugger-tab">
      <div ng-if="('disabled-test' | sxyIsInRole) && $ctrl.currentTab == 'debugger'">
        <p><a ng-href="{{'#/workers/details/' + $ctrl.current.info.workerAccountId}}">Old version (Worker ID {{ $ctrl.current.info.workerAccountId }})</a></p>
        <salaxy-json-formatter json="$ctrl.current" open="1" key="'Employment'"></salaxy-json-formatter>
      </div>
    </div>
  </div>
</div>
`), s.put("salaxy-components/worker/employment/Details_Basic.html", `<div class="salaxy-component salaxy-worker-employment">
  <form name="basicForm" class="form-horizontal" ng-readonly="$ctrl.isReadOnlyForced">
    <div class="row">
      <div class="col-md-6">
        <fieldset ng-if="$ctrl.isNew()">
          <legend sxy-text="SALAXY.NG1.WorkerDetailsComponent.details"></legend>
          <salaxy-input name="firstName" label="SALAXY.NG1.WorkerDetailsComponent.firstName" ng-required="true" ng-model="$ctrl.current.identity.firstName"></salaxy-input>
          <salaxy-input name="lastName" label="SALAXY.NG1.WorkerDetailsComponent.lastName" ng-required="true" ng-model="$ctrl.current.identity.lastName"></salaxy-input>
          <salaxy-input name="officialPersonId" label="SALAXY.NG1.WorkerDetailsComponent.ssNumber" sxy-personal-id-fi ng-required="true" ng-model="$ctrl.current.identity.personalId"></salaxy-input>
          <salaxy-input-enum enum="Language" ng-model="$ctrl.current.identity.language" name="workerLanguage" label="SALAXY.NG1.WorkerDetailsComponent.language"></salaxy-input-enum>
        </fieldset>
        <fieldset ng-if="!$ctrl.isNew()">
          <legend sxy-text="SALAXY.NG1.WorkerDetailsComponent.details"></legend>
          <salaxy-input read-only="$ctrl.current.isRegistered" name="firstName" label="SALAXY.NG1.WorkerDetailsComponent.firstName" ng-required="true" ng-model="$ctrl.current.identity.firstName"></salaxy-input>
          <salaxy-input read-only="$ctrl.current.isRegistered" name="lastName" label="SALAXY.NG1.WorkerDetailsComponent.lastName" ng-required="true" ng-model="$ctrl.current.identity.lastName"></salaxy-input>
          <salaxy-input name="officialPersonId" label="SALAXY.NG1.WorkerDetailsComponent.ssNumber" sxy-personal-id-fi read-only="true" ng-required="true" ng-model="$ctrl.current.identity.personalId"></salaxy-input>
          <salaxy-form-group ng-if="'workers.employments.employmentId' | sxyShow: 'workers.index'" label="SALAXY.NG1.WorkerDetailsComponent.workerId" name="workerId">
            <div class="salaxy-read-only-value">
              <small ng-if="!$ctrl.current.isRegistered">{{ $ctrl.current.info.workerAccountId | sxyIban }}</small>
              <code ng-if="$ctrl.current.isRegistered">{{ $ctrl.current.info.workerAccountId | sxyIban }}</code><br/>
              <small>({{ $ctrl.current.isRegistered ? "Rekisteröitynyt, pysyvä ID" : "Ei rekisteröitynyt, tilapäinen ID" }})</small>
            </div>
          </salaxy-form-group>
          <salaxy-input-enum enum="Language" ng-model="$ctrl.current.identity.language" read-only="$ctrl.current.isRegistered" name="workerLanguage" label="SALAXY.NG1.WorkerDetailsComponent.language"></salaxy-input-enum>
        </fieldset>
        <fieldset>
          <legend sxy-text="SALAXY.NG1.WorkerDetailsComponent.paymentDetails"></legend>
          <salaxy-input-enum ng-if="!('hideSalaryPaymentMethod' | sxyIsInRole)" label="SALAXY.NG1.WorkerDetailsComponent.salaryPaymentMethod" name="employmentRelationSalaryPaymentMethod" ng-model="$ctrl.current.info.salaryPaymentMethod" enum="EmploymentRelationSalaryPaymentMethod" required placeholder="SALAXY.UI_Terms.selectAlt"></salaxy-input-enum>
          <salaxy-input ng-if="$ctrl.current.info.salaryPaymentMethod === 'bankAccount'" name="ibanNumber" label="SALAXY.NG1.WorkerDetailsComponent.ibanNumber" sxy-iban
            require="$ctrl.isRequired('ibanNumber')" ng-model="$ctrl.current.info.ibanNumber" tooltip-html="{{ $ctrl.getInputTooltip('ibanNumber') }}"></salaxy-input>
        </fieldset>
      </div>
      <div class="col-md-6">
        <fieldset>
          <legend sxy-text="SALAXY.NG1.WorkerDetailsComponent.contactInfo"></legend>
          <salaxy-input name="email" label="SALAXY.NG1.WorkerDetailsComponent.email" sxy-email ng-model="$ctrl.getContact().email" tooltip-html="{{ $ctrl.getInputTooltip('email') }}"></salaxy-input>
          <salaxy-input name="telephone" label="SALAXY.NG1.WorkerDetailsComponent.tel" sxy-mobile-phone ng-model="$ctrl.getContact().telephone" tooltip-html="{{ $ctrl.getInputTooltip('telephone') }}"></salaxy-input>
        </fieldset>
        <fieldset>
          <legend sxy-text="SALAXY.NG1.WorkerDetailsComponent.address"></legend>
          <p ng-if="!$ctrl.isOtherIdentifier" sxy-text="SALAXY.NG1.WorkerDetailsComponent.addressInfo"></p>
          <p ng-if="$ctrl.isOtherIdentifier" sxy-text="SALAXY.NG1.WorkerDetailsComponent.addressInfoOtherIdentifier"></p>
          <salaxy-input name="street" label="SALAXY.NG1.WorkerDetailsComponent.street" require="$ctrl.isRequired('street')" ng-model="$ctrl.getContact().street" tooltip-html="{{ $ctrl.getInputTooltip('street') }}">
          </salaxy-input>
          <salaxy-input name="postalCode" label="SALAXY.NG1.WorkerDetailsComponent.postalCode" require="$ctrl.isRequired('postalCode')" ng-model="$ctrl.getContact().postalCode" tooltip-html="{{ $ctrl.getInputTooltip('postalCode') }}">
          </salaxy-input>
          <salaxy-input name="city" label="SALAXY.NG1.WorkerDetailsComponent.city" require="$ctrl.isRequired('city')" ng-model="$ctrl.getContact().city" tooltip-html="{{ $ctrl.getInputTooltip('city') }}">
          </salaxy-input>
        </fieldset>
      </div>
    </div>
    <div ng-if="!$ctrl.isModal">
      <button ng-click="$ctrl.deleteEmployment()" type="button" class="btn btn-danger" sxy-text="SALAXY.UI_Terms.delete"></button>
      <button ng-click="$ctrl.save()" ng-disabled="basicForm.$invalid" class="btn btn-primary float-end" sxy-text="SALAXY.UI_Terms.save"></button>
    </div>
  </form>
</div>`), s.put("salaxy-components/worker/employment/Details_Calc.html", `<div>
  <div class="float-end" ng-if="!$ctrl.isModal">
    <salaxy-json-formatter key="'Debug'" sxy-if-role="test" json="$ctrl.current.work.salaryDefaults" open="1" type="dialog"></salaxy-json-formatter>
    <button ng-click="$ctrl.save()" ng-disabled="workerForm.$invalid" class="btn btn-primary" sxy-text="SALAXY.UI_Terms.save"></button>
  </div>
  <p>Oletuspalkkarivit kopioidaan uudelle laskelmalle sellaisenaan. Päivämäärärajaukset huomioidaan vain tuntien sisääntuonnissa.</p>  
  <salaxy-calc-rows-editor rows="$ctrl.current.work.salaryDefaults" row-sources="thisproperty will be removed, just a marker until refactoring"
    title="{{ 'SALAXY.NG1.WorkerDetailsComponent.defaultCalcRows' | sxyTranslate }}" type="salary-defaults-temp2" mode="{{ $ctrl.isReadOnlyForced ? 'read-only' : 'edit'}}"></salaxy-calc-rows-editor>
  <hr>
  <p>Hintoja käytetään tällä hetkellä tuntien sisään tuonnissa. Myöhemmissä versioissa oletushintoja käytetään myös laskurissa.</p>
  <salaxy-row-types-settings ng-ref="$ctrl.$prices" mode="prices" model="$ctrl.current"></salaxy-row-types-settings>
</div>

<p>&nbsp;</p>

<div class="row form-horizontal" ng-if="!$ctrl.isHousehold && ('employments.defaultCalcRows.features' | sxyShow: 'workers.details')">
  <div class="col-sm-6">
    <fieldset>
      <legend sxy-text="SALAXY.NG1.WorkerDetailsCalc.payrollDetails"></legend>
      <salaxy-input-enum label="SALAXY.NG1.WorkerDetailsCalc.wageBasis" name="wageBases" ng-model="$ctrl.current.work.wageBasis" enum="WageBasis" type="select" read-only="$ctrl.isReadOnlyForced"></salaxy-input-enum>
      <salaxy-input-number label="SALAXY.NG1.WorkerDetailsCalc.monthlyHours" name="monthlyHours" unit="hour" ng-model="$ctrl.current.work.monthlyHours" read-only="$ctrl.isReadOnlyForced"></salaxy-input-number>
      <salaxy-input-enum label="SALAXY.NG1.WorkerDetailsCalc.irIncomeEarnerTypes" label-type="basic" name="wageBases" ng-model="$ctrl.current.info.irIncomeEarnerTypes" enum="IncomeEarnerType" type="multi-select" read-only="$ctrl.isReadOnlyForced"></salaxy-input-enum>
    </fieldset>
  </div>
  <div class="col-sm-6">
    <fieldset>
      <legend sxy-text="SALAXY.NG1.WorkerDetailsCalc.integrations"></legend>
      <salaxy-input label="SALAXY.NG1.WorkerDetailsCalc.ssNumber" name="sourceId" ng-model="$ctrl.current.info.sourceId" read-only="$ctrl.isReadOnlyForced"></salaxy-input>
    </fieldset>
    <salaxy-cost-accounting read-only="$ctrl.isReadOnlyForced" ng-init="$ctrl.current.work.accounting = $ctrl.current.work.accounting ? $ctrl.current.work.accounting : { dimensions: []}" current="$ctrl.current.work.accounting.dimensions"
      scope="calculation"></salaxy-cost-accounting>
  </div>
</div>
<div class="text-end" ng-if="!$ctrl.isModal">
  <button ng-click="$ctrl.save()" ng-disabled="workerForm.$invalid" class="btn btn-primary" sxy-text="SALAXY.UI_Terms.save"></button>
</div>`), s.put("salaxy-components/worker/employment/Details_EmploymentRelation.html", `\uFEFF<div class="salaxy-component salaxy-worker-employment">
  <form name="employmentForm" class="form-horizontal" ng-readonly="$ctrl.isReadOnlyForced">
    <ng-include src="'salaxy-components/worker/employment/shared-EmploymentRelation.html'"></ng-include>
    <div class="text-end" ng-if="!$ctrl.isModal">
      <button ng-click="$ctrl.save()" class="btn btn-primary" ng-disabled="employmentForm.$invalid" sxy-text="SALAXY.UI_Terms.save"></button>
    </div>
  </form>
</div>`), s.put("salaxy-components/worker/employment/Details_Header.html", `<div class="salaxy-calc-worker-info">
  <div ng-if="$ctrl.status == 'initialLoading'">
    <div class="col-3 col-sm-2">
      <salaxy-spinner></salaxy-spinner>
    </div>
    <div class="col-9 col-sm-10 worker-info-col">
      <h2 sxy-text="SALAXY.UI_Terms.loading"></h2>
      <div class="row">
        <div class="col-12 col-sm-6">
          &nbsp;<br /> &nbsp;
          <br /> &nbsp;
        </div>
        <div class="col-12 col-sm-6">
          &nbsp;<br />
          <div>&nbsp;</div>
          <div>&nbsp;</div>
        </div>
      </div>
    </div>
  </div>
  <div class="row" ng-if="$ctrl.status !== 'initialLoading'">
    <div class="col-3 col-md-2 align-items-center justify-content-center d-flex">
      <salaxy-avatar avatar="$ctrl.current.personalInfo.avatar"></salaxy-avatar>
    </div>
    <div class="col-9 col-md-10 worker-info-col">
      <div class="d-flex justify-content-between">
        <h2>{{ $ctrl.current.personalInfo.avatar.displayName || ("SALAXY.NG1.WorkerInfo.noSelection" | sxyTranslate) }}</h2>
        <salaxy-action-button label="SALAXY.NG1.WorkerDetailsComponent.newCalculation" action="'newCalcForEmployment'" ng-if="!$ctrl.isModal" options="{'id': $ctrl.currentId }" button-class="btn-default float-start float-sm-end"></salaxy-action-button>
      </div>
      <div class="row" ng-if="$ctrl.current">
        <div class="col-12 col-md-6">
          <div ng-class="$ctrl.current.personalInfo.officialId ? '' : 'text-danger'">
            {{ $ctrl.current.personalInfo.officialId || ( "SALAXY.NG1.PaymentDialogComponent.noSSNumber" | sxyTranslate ) }}
            &nbsp;
            <div class="btn-group dropdown" ng-if="$ctrl.otherEmployments.length > 0">
              <button id="single-button" type="button" class="btn btn-default btn-xs dropdown-toggle" data-bs-toggle="dropdown">
                {{ $ctrl.otherEmployments.length }} muuta työsuhdetta
              </button>
              <ul class="dropdown-menu" role="menu" aria-labelledby="single-button">
                <li role="menuitem" ng-repeat="item in $ctrl.otherEmployments">
                  <a ng-href="{{$ctrl.isModal ? '' : ('#/employments/details/' + item.id)}}" class="dropdown-item">
                    {{ $ctrl.getEmploymentDescription(item) }}
                    ({{ $ctrl.getActiveText(item) }})
                  </a>
                </li>
              </ul>
            </div>
            <span ng-if="!$ctrl.otherEmployments">Tarkistetaan muita työsuhteita...</span>
          </div>
          <div>{{ $ctrl.getEmploymentDescription($ctrl.current) }}</div>
          <div>{{ $ctrl.getActiveText($ctrl.current) }}</div>
          <div><small>{{ $ctrl.current.id }}</small></div>
        </div>
        <div class="col-12 col-md-6 ">
          
          <div ng-if="$ctrl.readOnlyDefaultContact.email">
            <a href="{{ 'mailto:' + $ctrl.readOnlyDefaultContact.email }}">{{ $ctrl.readOnlyDefaultContact.email }}</a>
          </div>
          <div ng-if="!$ctrl.readOnlyDefaultContact.email">
            <span sxy-text="SALAXY.NG1.PaymentDialogComponent.noEmail"></span>
            <span class="text-warning" sxy-text="SALAXY.NG1.PaymentDialogComponent.noEmailInfo"></span>
          </div>
          <div ng-if="!$ctrl.current.info.ibanNumber" class="text-danger" sxy-text="SALAXY.NG1.WorkerInfo.noIbanNumber"></div>
          <div ng-if="$ctrl.current.info.ibanNumber">IBAN: {{ $ctrl.current.info.ibanNumber | sxyIban }}</div>
          <div ng-class="{ 'text-danger': $ctrl.getTaxCardInfo().isMissing }">
            {{ $ctrl.getTaxCardInfo().text }}</div>
        </div>
      </div>
    </div>
  </div>
</div>`), s.put("salaxy-components/worker/employment/Details_Tax.html", `<form name="employmentTaxcardForm" class="form-horizontal" ng-readonly="$ctrl.isReadOnlyForced">
  <salaxy-input-enum label="SALAXY.NG1.WorkerDetailsComponent.employmentTaxcard" name="employmentTaxcard" ng-model="$ctrl.taxcardType"
    enum="EmploymentRelationTaxcard" label-cols="col-sm-5"></salaxy-input-enum>
</form>
<div ng-switch="$ctrl.current.info.taxcard">
  <div ng-switch-when="taxAtSource">
    <fieldset>
      <legend>{{'SALAXY.NG1.EmploymentDetails.taxAtSource.title' | sxyTranslate}}</legend>
      <div class="alert alert-danger" ng-if="!$ctrl.socSec.isInternational" sxy-html="SALAXY.NG1.EmploymentDetails.taxAtSource.info.html"></div>
      <salaxy-input-number name="percent" unit="percent" minimum="0" maximum="100" label="SALAXY.NG1.EmploymentDetails.percent" label-cols="col-sm-8" ng-model="$ctrl.current.international.taxAtSource.percent" require="true"></salaxy-input-number>
      <salaxy-input-number name="deductionMonthly" unit="eur" label="SALAXY.NG1.EmploymentDetails.monthlyDeduction" label-cols="col-sm-8" ng-model="$ctrl.current.international.taxAtSource.deductionMonthly"></salaxy-input-number>
      <salaxy-input-number name="deductionDaily" unit="eur" label="SALAXY.NG1.EmploymentDetails.deductionDaily" label-cols="col-sm-8" ng-model="$ctrl.current.international.taxAtSource.deductionDaily"></salaxy-input-number>
    </fieldset>
    <div class="text-right">
      <button ng-click="$ctrl.save()" class="btn btn-primary" sxy-text="SALAXY.UI_Terms.save"></button>
    </div>
  </div>
  <div ng-switch-when="noTaxCard">
    <fieldset>
      <legend sxy-text="SALAXY.NG1.WorkerDetailsComponent.taxCard.noTaxCard"></legend>
      <p sxy-text="SALAXY.NG1.WorkerDetailsComponent.taxCard.noTaxCardText"></p>
    </fieldset>
  </div>
  <div ng-switch-default>
    <salaxy-employment-taxcards employment-id="$ctrl.current.id" on-save="$ctrl.reload()" is-read-only-forced="$ctrl.isReadOnlyForced" hide-buttons="$ctrl.isReadOnlyForced"
      ng-ref="$ctrl.taxcardsController"></salaxy-employment-taxcards>
  </div>
</div>`), s.put("salaxy-components/worker/employment/shared-EmploymentRelation.html", `<div class="row">
  <div class="col-md-6" ng-if="!$ctrl.isHousehold">
    <salaxy-input-enum ng-required="true" hidden-options="undefined" name="type" ng-model="$ctrl.current.info.type" ng-change="$ctrl.employmentTypeChange()"
      enum="EmploymentRelationType" type="{{ $ctrl.socSec.isInternational ? 'select' : 'radio'}}" label="Työsuhteen tyyppi"
      label-type="{{ $ctrl.current.info.type == 'foreignWorker' ? 'basic' : 'plain'}}"
      filter="entrepreneur,farmer,monthlySalary,hourlySalary,salary,employedByStateEmploymentFund,compensation,boardMember,athlete,performingArtist,foreignWorker"></salaxy-input-enum>
    <p>&nbsp;</p>
    <div ng-if="( $ctrl.current.info.type == 'entrepreneur' ||  $ctrl.current.employment.type == 'farmer')">
      <div class="alert alert-danger" ng-if="$ctrl.session.currentAccount.companyType =='fiTm'" sxy-text="SALAXY.NG1.WorkerWizardComponent.workerType.entrepreneurTmiWarning"></div>
      <div class="alert alert-danger" ng-if="$ctrl.session.currentAccount.companyType =='fiRy'" sxy-text="SALAXY.NG1.WorkerWizardComponent.workerType.entrepreneurRyWarning"></div>
      <div class="alert alert-danger" ng-if="$ctrl.session.currentAccount.entityType !='company'" sxy-text="SALAXY.NG1.WorkerWizardComponent.workerType.entrepreneurPrivateWarning"></div>
    </div>
    <fieldset ng-if="$ctrl.current.info.type == 'compensation'">
      <legend sxy-text="SALAXY.ENUM.EmploymentRelationType.compensation.label"></legend>
      <p>
        <span sxy-text="SALAXY.NG1.WorkerWizardComponent.workerType.compensationDescription"></span><br>
        <a href="{{'SALAXY.NG1.WorkerWizardComponent.workerType.compensationLink' | sxyTranslate}}" target="_blank" sxy-text="SALAXY.NG1.WorkerWizardComponent.workerType.compensationCta"></a>
      </p>
    </fieldset>
    <fieldset ng-if="$ctrl.socSec.isInternational">
      <legend>{{'SALAXY.NG1.EmploymentRelation.isInternational.title' | sxyTranslate}}</legend>
      <p sxy-html="SALAXY.NG1.EmploymentRelation.isInternational.info.html"></p>
      <salaxy-input-enum type="select" ng-model="$ctrl.country" label="SALAXY.MODEL.EmploymentRelationInternational.country.title" name="country" require="true" enum="Country"
        hidden-options="fi"></salaxy-input-enum>
      <salaxy-input-enum type="select" ng-model="$ctrl.current.international.idType" label="SALAXY.MODEL.EmploymentRelationInternational.idType.title" name="idType" require="true"
        enum="InternationalIdentifier"></salaxy-input-enum>
      <salaxy-input ng-model="$ctrl.current.international.foreignId" label="SALAXY.MODEL.EmploymentRelationInternational.foreignId.title" name="foreignId"
        require="true"></salaxy-input>
      <salaxy-input name="street" label="SALAXY.NG1.WorkerDetailsComponent.street" ng-model="$ctrl.getContact('foreign').street" require="true"></salaxy-input>
      <salaxy-input name="postalCode" label="SALAXY.NG1.WorkerDetailsComponent.postalCode" ng-model="$ctrl.getContact('foreign').postalCode" require="true"></salaxy-input>
      <salaxy-input name="city" label="SALAXY.NG1.WorkerDetailsComponent.city" ng-model="$ctrl.getContact('foreign').city" require="true"></salaxy-input>
      <salaxy-input-enum type="select" ng-model="$ctrl.getContact('foreign').country" label="SALAXY.MODEL.EmploymentRelationInternational.contactCountry.title"
        name="contactCountry" read-only="true" enum="Country"></salaxy-input-enum>
      <salaxy-input ng-if="$ctrl.getContact('foreign').country == 'other'" ng-model="$ctrl.getContact('foreign').countryOtherName"
        label="SALAXY.MODEL.EmploymentRelationInternational.country.title" name="countryOtherName" require="true"></salaxy-input>
      <salaxy-input-enum type="select" name="taxation"
        options="{ taxAtSource: ('SALAXY.NG1.EmploymentRelation.taxation.taxAtSource' | sxyTranslate), auto: ('SALAXY.NG1.EmploymentRelation.taxation.auto' | sxyTranslate), manual: ('SALAXY.NG1.EmploymentRelation.taxation.manual' | sxyTranslate) }"
        label="SALAXY.NG1.EmploymentRelation.taxation.label" ng-model="$ctrl.current.info.taxcard"></salaxy-input-enum>
    </fieldset>
    <fieldset ng-if="false && $ctrl.current.info.taxcard == 'taxAtSource'">
      <legend>{{'SALAXY.NG1.EmploymentRelation.taxAtSourceInfo' | sxyTranslate}}</legend>
      <salaxy-input-number name="percent" unit="percent" minimum="0" maximum="100" label="SALAXY.NG1.EmploymentRelation.percent" label-cols="col-sm-8"
        ng-model="$ctrl.current.international.taxAtSource.percent" require="true"></salaxy-input-number>
      <salaxy-input-number name="deductionMonthly" unit="eur" label="SALAXY.NG1.EmploymentRelation.monthlyDeduction" label-cols="col-sm-8"
        ng-model="$ctrl.current.international.taxAtSource.deductionMonthly"></salaxy-input-number>
      <salaxy-input-number name="deductionDaily" unit="eur" label="SALAXY.NG1.EmploymentRelation.deductionDaily" label-cols="col-sm-8"
        ng-model="$ctrl.current.international.taxAtSource.deductionDaily"></salaxy-input-number>
    </fieldset>
  </div>
  <div class="col-md-6">
    <fieldset ng-if="!$ctrl.isHousehold">
      <legend>{{'SALAXY.NG1.EmploymentRelation.socSec'|sxyTranslate}}</legend>
      <salaxy-input-enum type="select" name="socialSecurity" ng-if="$ctrl.socSec.isInternational" enum="InternationalSocialSecurityType"
        label="SALAXY.MODEL.EmploymentRelationInternational.socialSecurity.title" ng-model="$ctrl.current.international.socialSecurity"></salaxy-input-enum>
      <salaxy-input-enum ng-if="$ctrl.current.international.socialSecurity == 'mixed'" type="multi-select" name="irIncomeEarnerTypes" disable-cache="true"
        enum="InternationalSocialSecurityException" label="SALAXY.MODEL.EmploymentRelationInternational.socialSecurityExceptions.title"
        ng-model="$ctrl.current.international.socialSecurityExceptions" label-type="basic" hidden-options="voluntaryEarningsRelatedPensionInsurance"></salaxy-input-enum>
      <salaxy-input-enum ng-if="$ctrl.socSec.pensionCalculationOptions" type="select" name="pensionCalculation" disable-cache="true"
        options="$ctrl.socSec.pensionCalculationOptions" label="SALAXY.NG1.WorkerWizardComponent.employment.pension.title" ng-model="$ctrl.current.info.pensionCalculation"
        ng-change="$ctrl.pensionCalculationChange()"></salaxy-input-enum>
      <salaxy-input-enum ng-if="$ctrl.socSec.showPensionCompanySelection" type="select" name="pensionCompany" placeholder="SALAXY.UI_Terms.notChosen" disable-cache="true"
        options="$ctrl.socSec.pensionCompanies" label="SALAXY.MODEL.PensionContract.title" ng-model="$ctrl.current.info.pensionCompany"></salaxy-input-enum>
      <salaxy-input-enum ng-if="$ctrl.socSec.pensionContractNumbers" type="select" name="pensionContractNumber" placeholder="SALAXY.UI_Terms.notChosen" disable-cache="true"
        options="$ctrl.socSec.pensionContractNumbers" label="SALAXY.MODEL.PensionContract.contractNumber.title"
        ng-model="$ctrl.current.info.pensionContractNumber"></salaxy-input-enum>
      <salaxy-input-enum ng-if="$ctrl.socSec.showPension && ('test,admin,pro' | sxyIsInRole)" type="select" name="pensionRule" enum="PensionRule"
        label="SALAXY.NG1.WorkerWizardComponent.employment.pensionRule" ng-model="$ctrl.current.info.pensionRule"></salaxy-input-enum>
      <salaxy-input-enum ng-if="$ctrl.socSec.showInsuranceCompanySelection" type="select" name="insuranceCompany" placeholder="SALAXY.UI_Terms.notChosen" disable-cache="true"
        options="$ctrl.socSec.insuranceCompanies" label="SALAXY.NG1.InsuranceSettingsComponent.insurance.title" ng-model="$ctrl.current.info.insuranceCompany"></salaxy-input-enum>
      <salaxy-input-enum ng-if="$ctrl.socSec.insuranceContractNumbers" type="select" name="insuranceContractNumber" placeholder="SALAXY.UI_Terms.notChosen" disable-cache="true"
        options="$ctrl.socSec.insuranceContractNumbers" label="SALAXY.MODEL.InsuranceContract.contractNumber.title"
        ng-model="$ctrl.current.info.insuranceContractNumber"></salaxy-input-enum>
    </fieldset>
    <fieldset>
      <legend ng-if="!$ctrl.isHousehold">{{'SALAXY.NG1.EmploymentRelation.employmentRelation'|sxyTranslate}}</legend>
      <salaxy-input ng-model="$ctrl.current.work.description" label="SALAXY.NG1.WorkerWizardComponent.employment.work.description" name="description"></salaxy-input>
      <salaxy-input-occupation-type  name="occupationType" ng-model="$ctrl.current.work.occupationCode"
        label="SALAXY.NG1.WorkerWizardComponent.employment.work.occupationCode"></salaxy-input-occupation-type>
      <salaxy-input-collective-bargain-agreement name="collectiveBargainAgreement" ng-model="$ctrl.current.info.cbaCode" label="SALAXY.NG1.WorkerWizardComponent.employment.info.cbaCode"></salaxy-input-collective-bargain-agreement>
      <salaxy-input tooltip-html="&lt;a target=&#39;_blank&#39; href=&#39;https://www.keva.fi/tyonantajalle/elakemaksut/ammattinimikkeiden-haku/&#39;&gt;Info&lt;/a&gt;" ng-if="$ctrl.current.info.pensionCalculation == 'publicSector'" name="occupationCode2" ng-model="$ctrl.current.work.occupationCode2"
        label="SALAXY.NG1.WorkerWizardComponent.employment.work.occupationCode2"></salaxy-input>
      <salaxy-form-group label="SALAXY.NG1.WorkerWizardComponent.employment.group.title" name="contract">
        <salaxy-datepicker-popup name="startDate" label="SALAXY.NG1.WorkerWizardComponent.employment.group.startDate"
          ng-model="$ctrl.current.info.startDate"></salaxy-datepicker-popup>
        <salaxy-datepicker-popup name="endDate" label="SALAXY.NG1.WorkerWizardComponent.employment.group.endDate"
          disabled="!$ctrl.current.info.isFixedTerm && !$ctrl.current.info.isTerminated" ng-model="$ctrl.current.info.endDate"></salaxy-datepicker-popup>
        <salaxy-input-boolean type="checkbox" ng-model="$ctrl.current.info.isFixedTerm" name="isFixedTerm" id="isFixedTerm" label-type="no-label" label-true="SALAXY.NG1.WorkerWizardComponent.employment.isFixedTerm"></salaxy-input-boolean>
        <salaxy-input-boolean type="checkbox" ng-model="$ctrl.current.info.isTerminated" name="isTerminated" id="isTerminated" label-type="no-label" label-true="SALAXY.NG1.WorkerWizardComponent.employment.isTerminated"></salaxy-input-boolean>

      </salaxy-form-group>
      <salaxy-input-enum ng-if="$ctrl.current.info.pensionCalculation == 'publicSector'" type="select" name="employmentRegCodes" disable-cache="true"
      options="$ctrl.socSec.employmentRegCodes" label="SALAXY.NG1.WorkerWizardComponent.employment.employmentRegCode" ng-model="$ctrl.current.info.employmentRegCode"></salaxy-input-enum>
      <salaxy-input-enum ng-if="$ctrl.current.isReadOnly" label="SALAXY.NG1.WorkerDetailsComponent.salaryPaymentMethod" name="employmentRelationSalaryPaymentMethod"
        ng-model="$ctrl.current.info.salaryPaymentMethod" enum="EmploymentRelationSalaryPaymentMethod" required placeholder="SALAXY.UI_Terms.selectAlt"></salaxy-input-enum>
    </fieldset>
  </div>
</div>`), s.put("salaxy-components/worker/EmploymentEditModal.html", `\uFEFF<div class="modal-worker-edit">
  <div class="modal-header">
    <h2 class="modal-title">{{$ctrl.logic.title}}</h2>
    <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
  </div>
  <div class="modal-body">
    <salaxy-employment-details model="$ctrl.current" current-tab="{{$ctrl.logic.initialTab}}" is-read-only-forced="$ctrl.route.readOnly" is-modal="true"></salaxy-employment-details>
  </div>
  <div class="modal-footer text-end">
    <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.NG1.AbsencePeriodsEditDialog.cancelButtonText"></button>
    <button type="submit" class="btn btn-primary" ng-click="$close('ok')" ng-if="$ctrl.logic.buttonTypes != 'updateCalc'" sxy-text="SALAXY.UI_Terms.save"></button>
    <button type="submit" class="btn btn-default" ng-click="$close('ok-no-rows')" ng-if="$ctrl.logic.buttonTypes == 'updateCalc'" sxy-text="SALAXY.NG1.EmploymentTaxcardsComponent.workerEdit.updateWorkerInfo"></button>
    <button type="submit" class="btn btn-primary" ng-click="$close('ok')" ng-if="$ctrl.logic.buttonTypes == 'updateCalc'" sxy-text="SALAXY.NG1.EmploymentTaxcardsComponent.workerEdit.updateWorkerInfoAndSalaryRows"></button>
  </div>
</div>
`), s.put("salaxy-components/worker/EmploymentList.html", `<div class="salaxy-component salaxy-worker-list">
  <salaxy-odata-table logic="{showToolbar: $ctrl.showToolbar}" url="/v03/api/employments?activeDate=today"
    options="{$top: $ctrl.limitTo}"
    ng-if="($ctrl.mode || 'default') == 'default'"
    read-only="$ctrl.readOnly" crud-controller="EmploymentCrudController as $crud"
    template-url="salaxy-components/odata/lists/Employments.html"></salaxy-odata-table>
  <salaxy-odata-table select-mode="$ctrl.mode" url="/v03/api/employments?activeDate=today"
    options="{$top: $ctrl.limitTo }"
    ng-if="$ctrl.mode == 'select' || $ctrl.mode == 'multiselect'"
     template-url="salaxy-components/odata/lists/Employments-select.html"
    items="$ctrl.items" selected-items="$ctrl.selectedItems"
    on-list-select="$ctrl.onListSelect({ value: value, item: item, allItems: allItems });"
    crud-controller="EmploymentCrudController as $crud"></salaxy-odata-table>
</div>`), s.put("salaxy-components/worker/EmploymentWizard/identity.html", `<form name="currentForm" class="form-horizontal">
  <span class="d-none">{{ $ctrl.formDataValidity = currentForm.$valid  }}</span>
  <div class="row">
    <div class="col-12 col-sm-6 margin-top-sm margin-xs">
      <fieldset>
        <legend sxy-text="SALAXY.NG1.WorkerDetailsComponent.details"></legend>
        <salaxy-input name="officialPersonId" label="SALAXY.NG1.WorkerDetailsComponent.ssNumber" sxy-personal-id-fi ng-required="true" ng-model="$ctrl.current.identity.personalId">
        </salaxy-input>
        <salaxy-input name="firstName" label="SALAXY.NG1.WorkerDetailsComponent.firstName" ng-required="true" ng-model="$ctrl.current.identity.firstName"></salaxy-input>
        <salaxy-input name="lastName" label="SALAXY.NG1.WorkerDetailsComponent.lastName" ng-required="true" ng-model="$ctrl.current.identity.lastName"></salaxy-input>
      </fieldset>
    </div>
    <div class="col-12 col-sm-6 margin-top-sm margin-xs">
      <fieldset ng-if="$ctrl.otherEmployments.length > 0">
        <legend>Henkilötunnuksella on jo {{ $ctrl.otherEmployments.length }} työsuhdetta</legend>
        <div class="list-group">
          <a ng-href="#/employments/details/{{ item.id }}" ng-click="$close()" class="list-group-item" ng-repeat="item in $ctrl.otherEmployments">
            <strong>{{ $ctrl.getEmploymentDescription(item) }}</strong><br>
            {{ $ctrl.getActiveText(item) }}
          </a>
        </div>
      </fieldset>
      <fieldset salaxy-if-role="test">
        <legend>Vain TESTI</legend>
        <p>
          <strong>Vain testiympäristö:</strong> Täytä loput tiedot nimen perusteella (syötä ensin etu- ja sukunimi).
        </p>
        <div class="text-end">
          <button ng-disabled="!$ctrl.current.identity.firstName || !$ctrl.current.identity.lastName" ng-click="$ctrl.populateWithTestData(true)" class="btn btn-danger">
            Täytä tiedot</button>
          <button ng-disabled="!$ctrl.current.identity.firstName || !$ctrl.current.identity.lastName" ng-click="$ctrl.populateWithTestData(false)" class="btn btn-default">...keinohetu</button>
        </div>
      </fieldset>
    </div>
  </div>
</form>`), s.put("salaxy-components/worker/EmploymentWizard/index.html", `<div class="modal-header">
  <h2 class="modal-title" sxy-text="SALAXY.NG1.WorkerWizardComponent.wizard.title"></h2>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
</div>
<div class="modal-body">
  <div class="d-block d-md-none">
    <h4><span sxy-text="SALAXY.NG1.WorkerWizardComponent.wizard.step"></span> {{$ctrl.currentStep.number}}/{{$ctrl.steps.length}}</h4>
  </div>
  <div class="salaxy-wizard">
    <div class="wizard-steps">
      <div class="wizard-step" ng-repeat="step in $ctrl.steps" ng-class="{'active': step.active, 'disabled': step.disabled}">
        <span class="salaxy-avatar">
          <div class="wizard-icons-wrapper">
            <i class="bi" ng-class="step.active ? 'bi-circle-fill' : 'bi-circle'"></i>
            <i class="bi bi-circle-fill"></i>
          </div>
          <strong class="number">{{ step.number }}</strong>
        </span>
        <span class="step-text">{{ step.title | sxyTranslate }}</span>
      </div>
    </div>
    <div class="wizard-strikethrough"></div>
  </div>
  <div class="worker-wizard-content">
    <ng-include src="$ctrl.currentStep.view"></ng-include>
  </div>
</div>
<div class="modal-footer">
  <div>
    <button ng-if="$ctrl.step &lt; 2" ng-click="$close('cancel')" class="btn btn-default" sxy-text="SALAXY.UI_Terms.close"></button>
    <button ng-if="$ctrl.step >= 2" ng-click="$ctrl.goPrevious()" ng-disabled="!$ctrl.canGoPrevious" class="btn btn-default" sxy-text="SALAXY.UI_Terms.previous"></button>
  </div>
  <div class="ms-auto">
    <button ng-if="$ctrl.step &lt; $ctrl.steps.length" ng-click="$ctrl.goNext()" ng-disabled="!$ctrl.canGoNext" class="btn btn-primary" sxy-text="SALAXY.UI_Terms.next"></button>
    <button ng-if="$ctrl.step == $ctrl.steps.length" ng-click="$ctrl.saveAndClose($close)" class="btn btn-primary" ng-disabled="!$ctrl.formDataValidity" sxy-text="SALAXY.UI_Terms.done"></button>
  </div>
  
</div>`), s.put("salaxy-components/worker/EmploymentWizard/person.html", `<form name="currentForm" class="form-horizontal">
  <span class="d-none">{{ $ctrl.formDataValidity = currentForm.$valid  }}</span>
    <div class="row">
    <div class="col-12 col-sm-6 margin-top-sm margin-xs">
      <fieldset>
        <legend>Yhteystiedot</legend>
        <salaxy-input name="email" label="SALAXY.NG1.WorkerDetailsComponent.email" sxy-email ng-model="$ctrl.getContact().email"></salaxy-input>
        <salaxy-input name="telephone" label="SALAXY.NG1.WorkerDetailsComponent.tel" sxy-mobile-phone ng-model="$ctrl.getContact().telephone"></salaxy-input>
      </fieldset>
      <fieldset ng-if="$ctrl.isOtherIdentifier">
        <legend sxy-text="SALAXY.NG1.WorkerDetailsComponent.address"></legend>
        <p class="small" sxy-text="SALAXY.NG1.WorkerDetailsComponent.unRealPersonalIndenficationNumer"></p>
        <salaxy-input name="street" label="SALAXY.NG1.WorkerDetailsComponent.street" ng-required="true" ng-model="$ctrl.getContact().street">
        </salaxy-input>
        <salaxy-input name="postalCode" label="SALAXY.NG1.WorkerDetailsComponent.postalCode" ng-required="true" ng-model="$ctrl.getContact().postalCode">
        </salaxy-input>
        <salaxy-input name="city" label="SALAXY.NG1.WorkerDetailsComponent.city" ng-required="true" ng-model="$ctrl.getContact().city">
        </salaxy-input>
      </fieldset>
    </div>
    <div class="col-12 col-sm-6 margin-top-sm margin-xs">
      <fieldset>
        <legend sxy-text="SALAXY.NG1.WorkerDetailsComponent.paymentDetails"></legend>
        <salaxy-input-enum label="SALAXY.NG1.WorkerDetailsComponent.salaryPaymentMethod" name="employmentRelationSalaryPaymentMethod" ng-model="$ctrl.current.info.salaryPaymentMethod" enum="EmploymentRelationSalaryPaymentMethod" required placeholder="SALAXY.UI_Terms.selectAlt"></salaxy-input-enum>
        <salaxy-input ng-if="$ctrl.current.info.salaryPaymentMethod === 'bankAccount'" name="ibanNumber" label="SALAXY.NG1.WorkerDetailsComponent.ibanNumber" sxy-iban ng-required="true" ng-model="$ctrl.current.info.ibanNumber"></salaxy-input>
      </fieldset>
    </div>
  </div>
</form>`), s.put("salaxy-components/worker/EmploymentWizard/tax.html", `<form name="currentForm" class="form-horizontal">
  <span class="d-none">{{ $ctrl.formDataValidity = currentForm.$valid }}</span>
  <div class="row">
    <div class="col-6">
      <fieldset>
        <legend sxy-text="SALAXY.NG1.WorkerDetailsComponent.employmentTaxcard"></legend>
        <salaxy-input-enum label="" name="employmentTaxcard" ng-model="$ctrl.current.info.taxcard" enum="EmploymentRelationTaxcard"
          label-cols="col-sm-5" label-type="plain" type="radio"></salaxy-input-enum>
      </fieldset>
    </div>
    <div ng-switch="$ctrl.current.info.taxcard" class="col-6">
      <fieldset ng-switch-when="taxAtSource">
        <legend>{{'SALAXY.NG1.EmploymentDetails.taxAtSource.title' | sxyTranslate}}</legend>
        <div class="alert alert-danger" ng-if="!$ctrl.socSec.isInternational" sxy-html="SALAXY.NG1.EmploymentDetails.taxAtSource.info.html"></div>
        <salaxy-input-number name="percent" unit="percent" minimum="0" maximum="100" label="SALAXY.NG1.EmploymentDetails.percent" label-cols="col-sm-8"
          ng-model="$ctrl.current.international.taxAtSource.percent" require="true"></salaxy-input-number>
        <salaxy-input-number name="deductionMonthly" unit="eur" label="SALAXY.NG1.EmploymentDetails.monthlyDeduction" label-cols="col-sm-8"
          ng-model="$ctrl.current.international.taxAtSource.deductionMonthly"></salaxy-input-number>
        <salaxy-input-number name="deductionDaily" unit="eur" label="SALAXY.NG1.EmploymentDetails.deductionDaily" label-cols="col-sm-8"
          ng-model="$ctrl.current.international.taxAtSource.deductionDaily"></salaxy-input-number>
      </fieldset>
      <fieldset ng-switch-when="noTaxCard">
        <legend>Ei verokorttia (60%)</legend>
        <p class="lead">Ennakonpidätys tehdään 60%:n mukaan.</p>
      </fieldset>
      <fieldset ng-switch-when="auto">
        <legend sxy-text="SALAXY.NG1.CurrentTaxCardComponent.taxCards.taxCardDetails.automaticTaxcard.legend"></legend>
        <!--
        TODO: Consider implementing this
        <button class="btn btn-default float-end" ng-click="$ctrl.getTaxCard()">Hae verokortti</button>
        -->
        <p sxy-text="SALAXY.NG1.CurrentTaxCardComponent.taxCards.taxCardDetails.automaticTaxcard.mainTaxPercentApi"></p>
        <span sxy-html="SALAXY.NG1.CurrentTaxCardComponent.taxCards.taxCardDetails.automaticTaxcard.taxPercentInfoText.html"></span>
      </fieldset>
      <div ng-switch-default>
        <span class="d-none">{{ $ctrl.formDataValidity = $edit.isFormValid  }}</span>
        <salaxy-taxcard-manual-edit ng-ref="$edit" current="$ctrl.taxcard"></salaxy-taxcard-manual-edit>
      </div>
    </div>
  </div>
</form>`), s.put("salaxy-components/worker/EmploymentWizard/type.html", `<form name="currentForm" class="form-horizontal">
  <span class="d-none">{{ $ctrl.formDataValidity = currentForm.$valid }}</span>
  <ng-include src="'salaxy-components/worker/employment/shared-EmploymentRelation.html'"></ng-include>
</form>`), s.put("salaxy-components/worker/EmploymentWizard/work.html", `<form name="currentForm" class="form-horizontal">
  <span class="d-none">{{ $ctrl.formDataValidity = currentForm.$valid  }}</span>
  <div class="row">
    <div class="col-12 margin-top-sm margin-xs">
      <fieldset>
        <legend sxy-text="SALAXY.NG1.WorkerWizardComponent.employment.work.salaryDefaults.title"></legend>
        <div sxy-html="SALAXY.NG1.WorkerWizardComponent.employment.work.salaryDefaults.info.md"></div>
        <div class="table-responsive">
          <salaxy-calc-rows-2019-editor rows="$ctrl.current.work.salaryDefaults" title="{{ 'SALAXY.NG1.WorkerDetailsComponent.defaultCalcRows' | sxyTranslate }}" condensed="true" mode="edit"></salaxy-calc-rows-2019-editor>
        </div>
      </fieldset>
    </div>
  </div>
</form>`), s.put("salaxy-components/worker/holidays/HolidayParametersForm.html", `<form class="form-horizontal" name="holidayForm">
  <div class="row form-horizontal">
    <div class="col-sm-4">
      <fieldset>
        <legend sxy-text="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.legendSelectHolidayType"></legend>
        <div class="radio mb-1">
          <label class="d-flex align-items-start">
            <input type="radio" ng-model="$ctrl.current.spec.code" name="code" id="permanent14Days" value="permanent14Days" class="mt-1 me-2"> 
            <span sxy-html="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.permanent14Days.html"></span>
          </label>
        </div>
        <div class="radio mb-1">
          <label class="d-flex align-items-start">
            <input type="radio" ng-model="$ctrl.current.spec.code" name="code" id="permanent35Hours" value="permanent35Hours" class="mt-1 me-2">
            <span sxy-html="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.permanent35Hours.html"></span>
          </label>
        </div>
        <div class="radio mb-1">
          <label class="d-flex align-items-start">
            <input type="radio" ng-model="$ctrl.current.spec.code" name="code" id="holidayCompensation" value="holidayCompensation" class="mt-1 me-2">
            <span sxy-html="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.holidayCompensation.html"></span>
          </label>
        </div>
        <div class="radio mb-1">
          <label class="d-flex align-items-start">
            <input type="radio" ng-model="$ctrl.current.spec.code" name="code" id="temporaryTimeOff" value="temporaryTimeOff" class="mt-1 me-2">
            <span sxy-html="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.temporaryTimeOff.html"></span>
          </label>
        </div>
        <div class="radio mb-1">
          <label class="d-flex align-items-start">
            <input type="radio" ng-model="$ctrl.current.spec.code" name="code" id="other" value="other" class="mt-1 me-2">
            <span sxy-html="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.other.html"></span>
          </label>
        </div>
        <div class="radio mb-1">
          <label class="d-flex align-items-start">
            <input type="radio" ng-model="$ctrl.current.spec.code" name="code" id="noHolidays" value="noHolidays" class="mt-1 me-2">
            <span sxy-html="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.noHolidays.html"></span>
          </label>
        </div>
      </fieldset>
    </div>
    <div class="col-sm-8">
      <fieldset >
        <legend sxy-text="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.legendDetails"></legend>
        <div ng-if="$ctrl.getHolidayLogic($ctrl.current.spec).getVisibility($ctrl.current.spec, 'accrualFixed')" ng-init="$holidayLogic = $ctrl.getHolidayLogic($ctrl.current.spec)">
          <salaxy-input-boolean type="checkbox" name="accrualByLaw" label="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.accrualByLaw" label-true="{{ 'SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.accrualByLawLabelTrue' + ($ctrl.current.spec.code == 'temporaryTimeOff' ? '2' : '') }}"
            ng-change="$holidayLogic.accrualByLawChanged($ctrl.current.spec)" ng-model="$holidayLogic.accrualByLaw"></salaxy-input-boolean>
          <salaxy-input-number ng-model="$ctrl.current.spec.accrualFixed" name="accrualFixed" ng-if="$ctrl.current.spec.accrualFixed" ng-change="$holidayLogic.accrualFixedChanged($ctrl.current.spec)" label="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.accrualFixed" unit="days">
          </salaxy-input-number>
        </div>
        <salaxy-input-number ng-model="$ctrl.current.spec.compensation" name="compensation" ng-if="$ctrl.getHolidayLogic($ctrl.current.spec).getVisibility($ctrl.current.spec, 'compensation')" required label="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.compensation" unit="percent"></salaxy-input-number>
        <salaxy-input-enum name="bonusMethod" ng-model="$ctrl.current.spec.bonusMethod" ng-if="$ctrl.getHolidayLogic($ctrl.current.spec).getVisibility($ctrl.current.spec, 'bonusMethod')" label="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.bonusMethod" filter="none,payForHolidaySalary,paySelectedDays" enum="HolidayBonusPaymentMethod"></salaxy-input-enum>
        <salaxy-input-enum name="bonusMethod" ng-model="$ctrl.current.spec.bonusMethod" ng-if="$ctrl.getHolidayLogic($ctrl.current.spec).getVisibility($ctrl.current.spec, 'compensation')" label="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.bonusMethod" options="{ 'none': ('SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.bonusMethodNone' | sxyTranslate), 'payForHolidaySalary': ('SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.bonusMethodPayForHolidaySalary' | sxyTranslate)  }">
        </salaxy-input-enum>
        <salaxy-input-number ng-model="$ctrl.current.spec.bonus" name="bonus" ng-if="$ctrl.getHolidayLogic($ctrl.current.spec).getVisibility($ctrl.current.spec, 'bonusPercent')" label="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.bonusPercent" unit="percent"></salaxy-input-number>
        <div ng-if="$ctrl.getHolidayLogic($ctrl.current.spec).getVisibility($ctrl.current.spec, 'accruesHolidays')">
          <salaxy-input-enum  required name="wageBasis" ng-model="$ctrl.current.spec.wageBasis" label="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.wageBasis" enum="WageBasis" hidden-options="undefined,other"></salaxy-input-enum>
          <salaxy-input-enum name="holidayPayCalculation" ng-model="$ctrl.current.spec.holidayPayCalculation" label="SALAXY.MODEL.HolidaySpecificationForYear.holidayPayCalculation.title" options="$ctrl.getHolidayLogic($ctrl.current.spec).getholidayPayCalculationOptions($ctrl.current.spec)" required disable-cache="true"></salaxy-input-enum>
          <salaxy-form-group name="holidayPayReport" ng-if="$ctrl.current.spec.holidayPayCalculation && $ctrl.current.spec.holidayPayCalculation != 'undefined' && $ctrl.current.spec.holidayPayCalculation != 'otherPay'" label="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.holidayPayCalculationReport">
            <a ng-href="#/reports/holiday-pay-report-query/{{$ctrl.current.year}}/{{$ctrl.current.employmentId}}" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.calculationReport"></a>
          </salaxy-form-group>
          <salaxy-input-number ng-model="$ctrl.current.holidayPay.otherPay" ng-if="$ctrl.current.spec.holidayPayCalculation == 'otherPay'" name="otherPay"  label="SALAXY.MODEL.HolidayPay.otherPay.title" ></salaxy-input-number>
  
          <salaxy-input-number ng-model="$ctrl.current.holidayPay.normalMonthlyPayDailySalary" name="normalMonthlyPayDailySalary" ng-if="($ctrl.current.spec.code == 'permanent14Days' || $ctrl.current.spec.code == 'permanent35Hours' || $ctrl.current.spec.code == 'other') && $ctrl.current.spec.wageBasis =='monthly' && $ctrl.current.spec.holidayPayCalculation == 'normalMonthlyPay'" disabled="true" label="SALAXY.MODEL.HolidayPay.normalMonthlyPayDailySalary.title" ></salaxy-input-number>
          <salaxy-input-number ng-model="$ctrl.current.holidayPay.normalMonthlyPayManual" name="normalMonthlyPayManual" ng-if="($ctrl.current.spec.code == 'permanent14Days' || $ctrl.current.spec.code == 'permanent35Hours' || $ctrl.current.spec.code == 'other') && $ctrl.current.spec.wageBasis =='monthly' && $ctrl.current.spec.holidayPayCalculation == 'normalMonthlyPay'" label="SALAXY.MODEL.HolidayPay.normalMonthlyPayManual.title" ></salaxy-input-number>
          <salaxy-input-number ng-model="$ctrl.current.holidayPay.normalMonthlyPay" name="normalMonthlyPay" ng-if="($ctrl.current.spec.code == 'permanent14Days' || $ctrl.current.spec.code == 'permanent35Hours' || $ctrl.current.spec.code == 'other') && $ctrl.current.spec.wageBasis =='monthly' && $ctrl.current.spec.holidayPayCalculation == 'normalMonthlyPay'" disabled="true" label="SALAXY.MODEL.HolidayPay.normalMonthlyPay.title" ></salaxy-input-number>

          <salaxy-input-number ng-model="$ctrl.current.holidayPay.averageDailyPayDailySalary" name="averageDailyPayDailySalary" ng-if="($ctrl.current.spec.code == 'permanent14Days' || $ctrl.current.spec.code == 'other') && ($ctrl.current.spec.wageBasis =='hourly' || $ctrl.current.spec.wageBasis =='performanceBased' || $ctrl.current.spec.wageBasis =='other') && $ctrl.current.spec.holidayPayCalculation == 'averageDailyPay'" disabled="true" label="SALAXY.MODEL.HolidayPay.averageDailyPayDailySalary.title" ></salaxy-input-number>
          <salaxy-input-number ng-model="$ctrl.current.holidayPay.averageDailyPayManual" name="averageDailyPayManual" ng-if="($ctrl.current.spec.code == 'permanent14Days' || $ctrl.current.spec.code == 'other') && ($ctrl.current.spec.wageBasis =='hourly' || $ctrl.current.spec.wageBasis =='performanceBased' || $ctrl.current.spec.wageBasis =='other') && $ctrl.current.spec.holidayPayCalculation == 'averageDailyPay'" label="SALAXY.MODEL.HolidayPay.averageDailyPayManual.title" ></salaxy-input-number>
          <salaxy-input-number ng-model="$ctrl.current.holidayPay.averageDailyPay" name="averageDailyPay" ng-if="($ctrl.current.spec.code == 'permanent14Days' || $ctrl.current.spec.code == 'other') && ($ctrl.current.spec.wageBasis =='hourly' || $ctrl.current.spec.wageBasis =='performanceBased' || $ctrl.current.spec.wageBasis =='other') && $ctrl.current.spec.holidayPayCalculation == 'averageDailyPay'" disabled="true" label="SALAXY.MODEL.HolidayPay.averageDailyPay.title" ></salaxy-input-number>
          <salaxy-input-number ng-model="$ctrl.current.holidayPay.averageDailyPayBase" name="averageDailyPayBase" ng-if="($ctrl.current.spec.code == 'permanent14Days' || $ctrl.current.spec.code == 'other') && ($ctrl.current.spec.wageBasis =='hourly' || $ctrl.current.spec.wageBasis =='performanceBased' || $ctrl.current.spec.wageBasis =='other') && $ctrl.current.spec.holidayPayCalculation == 'averageDailyPay'" disabled="true" label="SALAXY.MODEL.HolidayPay.averageDailyPayBase.title" ></salaxy-input-number>
          <salaxy-input-number ng-model="$ctrl.current.holidayPay.averageDailyPayDays" name="averageDailyPayDays" ng-if="($ctrl.current.spec.code == 'permanent14Days' || $ctrl.current.spec.code == 'other') && ($ctrl.current.spec.wageBasis =='hourly' || $ctrl.current.spec.wageBasis =='performanceBased' || $ctrl.current.spec.wageBasis =='other') && $ctrl.current.spec.holidayPayCalculation == 'averageDailyPay'" disabled="true" label="SALAXY.MODEL.HolidayPay.averageDailyPayDays.title" ></salaxy-input-number>
          <salaxy-input-number ng-model="$ctrl.current.holidayPay.averageDailyPayMultiplier" name="averageDailyPayMultiplier" ng-if="($ctrl.current.spec.code == 'permanent14Days' || $ctrl.current.spec.code == 'other') && ($ctrl.current.spec.wageBasis =='hourly' || $ctrl.current.spec.wageBasis =='performanceBased' || $ctrl.current.spec.wageBasis =='other') && $ctrl.current.spec.holidayPayCalculation == 'averageDailyPay'" disabled="true" label="SALAXY.MODEL.HolidayPay.averageDailyPayMultiplier.title" ></salaxy-input-number>
          <salaxy-input-number ng-model="$ctrl.current.holidayPay.accrual" name="averageDailyPayAccrual" ng-if="($ctrl.current.spec.code == 'permanent14Days' || $ctrl.current.spec.code == 'other') && ($ctrl.current.spec.wageBasis =='hourly' || $ctrl.current.spec.wageBasis =='performanceBased' || $ctrl.current.spec.wageBasis =='other') && $ctrl.current.spec.holidayPayCalculation == 'averageDailyPay'"disabled="true" label="SALAXY.MODEL.HolidayPay.accrual.title" ></salaxy-input-number>

          <salaxy-input-number ng-model="$ctrl.current.holidayPay.averageHourlyPayDailySalary" name="averageHourlyPayDailySalary" ng-if="($ctrl.current.spec.code == 'permanent14Days' || $ctrl.current.spec.code == 'other') && ($ctrl.current.spec.wageBasis =='hourly' || $ctrl.current.spec.wageBasis =='performanceBased' || $ctrl.current.spec.wageBasis =='other') && $ctrl.current.spec.holidayPayCalculation == 'averageHourlyPay'" disabled="true" label="SALAXY.MODEL.HolidayPay.averageHourlyPayDailySalary.title" ></salaxy-input-number>
          <salaxy-input-number ng-model="$ctrl.current.holidayPay.averageHourlyPayManual" name="averageHourlyPayManual" ng-if="($ctrl.current.spec.code == 'permanent14Days' || $ctrl.current.spec.code == 'other') && ($ctrl.current.spec.wageBasis =='hourly' || $ctrl.current.spec.wageBasis =='performanceBased' || $ctrl.current.spec.wageBasis =='other') && $ctrl.current.spec.holidayPayCalculation == 'averageHourlyPay'" label="SALAXY.MODEL.HolidayPay.averageHourlyPayManual.title" ></salaxy-input-number>
          <salaxy-input-number ng-model="$ctrl.current.holidayPay.averageHourlyPay" name="averageHourlyPay" ng-if="($ctrl.current.spec.code == 'permanent14Days' || $ctrl.current.spec.code == 'other') && ($ctrl.current.spec.wageBasis =='hourly' || $ctrl.current.spec.wageBasis =='performanceBased' || $ctrl.current.spec.wageBasis =='other') && $ctrl.current.spec.holidayPayCalculation == 'averageHourlyPay'" disabled="true" label="SALAXY.MODEL.HolidayPay.averageHourlyPay.title" ></salaxy-input-number>
          <salaxy-input-number ng-model="$ctrl.current.holidayPay.averageHourlyPayBase" name="averageHourlyPayBase" ng-if="($ctrl.current.spec.code == 'permanent14Days' || $ctrl.current.spec.code == 'other') && ($ctrl.current.spec.wageBasis =='hourly' || $ctrl.current.spec.wageBasis =='performanceBased' || $ctrl.current.spec.wageBasis =='other') && $ctrl.current.spec.holidayPayCalculation == 'averageHourlyPay'" disabled="true"  label="SALAXY.MODEL.HolidayPay.averageHourlyPayBase.title" ></salaxy-input-number>
          <salaxy-input-number ng-model="$ctrl.current.holidayPay.averageHourlyPayHours" name="averageHourlyPayHours" ng-if="($ctrl.current.spec.code == 'permanent14Days' || $ctrl.current.spec.code == 'other') && ($ctrl.current.spec.wageBasis =='hourly' || $ctrl.current.spec.wageBasis =='performanceBased' || $ctrl.current.spec.wageBasis =='other') && $ctrl.current.spec.holidayPayCalculation == 'averageHourlyPay'" disabled="true" label="SALAXY.MODEL.HolidayPay.averageHourlyPayHours.title" ></salaxy-input-number>
          <salaxy-input-number ng-model="$ctrl.current.holidayPay.averageHourlyPayMultiplier" name="averageHourlyPayMultiplier" ng-if="($ctrl.current.spec.code == 'permanent14Days' || $ctrl.current.spec.code == 'other') && ($ctrl.current.spec.wageBasis =='hourly' || $ctrl.current.spec.wageBasis =='performanceBased' || $ctrl.current.spec.wageBasis =='other') && $ctrl.current.spec.holidayPayCalculation == 'averageHourlyPay'" disabled="true" label="SALAXY.MODEL.HolidayPay.averageHourlyPayMultiplier.title" ></salaxy-input-number>
          <salaxy-input-number ng-model="$ctrl.current.holidayPay.accrual" name="averageHourlyPayAccrual" ng-if="($ctrl.current.spec.code == 'permanent14Days' || $ctrl.current.spec.code == 'other') && ($ctrl.current.spec.wageBasis =='hourly' || $ctrl.current.spec.wageBasis =='performanceBased' || $ctrl.current.spec.wageBasis =='other') && $ctrl.current.spec.holidayPayCalculation == 'averageHourlyPay'" disabled="true" label="SALAXY.MODEL.HolidayPay.accrual.title"></salaxy-input-number>

          <salaxy-input-number ng-model="$ctrl.current.holidayPay.percentageBasedPayDailySalary" name="percentageBasedPayDailySalary" ng-if="($ctrl.current.spec.code == 'permanent35Hours' || $ctrl.current.spec.code == 'other') && $ctrl.current.spec.holidayPayCalculation == 'percentageBasedPay'" disabled="true" label="SALAXY.MODEL.HolidayPay.percentageBasedPayDailySalary.title" ></salaxy-input-number>
          <salaxy-input-number ng-model="$ctrl.current.holidayPay.percentageBasedPayManual" name="percentageBasedPayManual" ng-if="($ctrl.current.spec.code == 'permanent35Hours' || $ctrl.current.spec.code == 'other') && $ctrl.current.spec.holidayPayCalculation == 'percentageBasedPay'" label="SALAXY.MODEL.HolidayPay.percentageBasedPayManual.title" ></salaxy-input-number>
          <salaxy-input-number ng-model="$ctrl.current.holidayPay.percentageBasedPay" name="percentageBasedPay" ng-if="($ctrl.current.spec.code == 'permanent35Hours' || $ctrl.current.spec.code == 'other') && $ctrl.current.spec.holidayPayCalculation == 'percentageBasedPay'" disabled="true" label="SALAXY.MODEL.HolidayPay.percentageBasedPay.title" ></salaxy-input-number>
          <salaxy-input-number ng-model="$ctrl.current.holidayPay.percentageBasedPayBase" name="percentageBasedPayBase" ng-if="($ctrl.current.spec.code == 'permanent35Hours' || $ctrl.current.spec.code == 'other') && $ctrl.current.spec.holidayPayCalculation == 'percentageBasedPay'"  disabled="true" label="SALAXY.MODEL.HolidayPay.percentageBasedPayBase.title" ></salaxy-input-number>
          <salaxy-input-number ng-model="$ctrl.current.spec.holidayPayPercent" name="holidayPayPercent" ng-if="($ctrl.current.spec.code == 'permanent35Hours' || $ctrl.current.spec.code == 'other') && $ctrl.current.spec.holidayPayCalculation == 'percentageBasedPay'" required unit="percent" label="SALAXY.MODEL.HolidaySpecificationForYear.holidayPayPercent.title" ></salaxy-input-number>
          <salaxy-input-number ng-model="$ctrl.current.holidayPay.accrual" name="percentageBasedPayAccrual" ng-if="($ctrl.current.spec.code == 'permanent35Hours' || $ctrl.current.spec.code == 'other') && $ctrl.current.spec.holidayPayCalculation == 'percentageBasedPay'" disabled="true" label="SALAXY.MODEL.HolidayPay.accrual.title"></salaxy-input-number>

          <salaxy-input-number ng-model="$ctrl.current.holidayPay.compensationPayDailySalary" name="compensationPayDailySalary" ng-if="($ctrl.current.spec.code == 'temporaryTimeOff'|| $ctrl.current.spec.code == 'other') && $ctrl.current.spec.holidayPayCalculation == 'holidayCompensation'" disabled="true" label="SALAXY.MODEL.HolidayPay.compensationPayDailySalary.title" ></salaxy-input-number>
          <salaxy-input-number ng-model="$ctrl.current.holidayPay.compensationPayManual" name="compensationPayManual" ng-if="($ctrl.current.spec.code == 'temporaryTimeOff'|| $ctrl.current.spec.code == 'other') && $ctrl.current.spec.holidayPayCalculation == 'holidayCompensation'" label="SALAXY.MODEL.HolidayPay.compensationPayManual.title" ></salaxy-input-number>
          <salaxy-input-number ng-model="$ctrl.current.holidayPay.compensationPay" name="compensationPay" ng-if="$($ctrl.current.spec.code == 'temporaryTimeOff'|| $ctrl.current.spec.code == 'other') && $ctrl.current.spec.holidayPayCalculation == 'holidayCompensation'" disabled="true" label="SALAXY.MODEL.HolidayPay.compensationPay.title" ></salaxy-input-number>
          <salaxy-input-number ng-model="$ctrl.current.holidayPay.compensationPayBase" name="compensationPayBase" ng-if="($ctrl.current.spec.code == 'temporaryTimeOff'|| $ctrl.current.spec.code == 'other') && $ctrl.current.spec.holidayPayCalculation == 'holidayCompensation'" disabled="true" label="SALAXY.MODEL.HolidayPay.compensationPayBase.title" ></salaxy-input-number>          
          <salaxy-input-number ng-model="$ctrl.current.spec.compensation" name="compensation" ng-if="($ctrl.current.spec.code == 'temporaryTimeOff'|| $ctrl.current.spec.code == 'other') && $ctrl.current.spec.holidayPayCalculation == 'holidayCompensation'" unit="percent" required label="SALAXY.MODEL.HolidaySpecificationForYear.compensation.title" ></salaxy-input-number>
          <salaxy-input-number ng-model="$ctrl.current.holidayPay.accrual" name="compensationPayAccrual" ng-if="($ctrl.current.spec.code == 'temporaryTimeOff'|| $ctrl.current.spec.code == 'other') && $ctrl.current.spec.holidayPayCalculation == 'holidayCompensation'" disabled="true" label="SALAXY.MODEL.HolidayPay.accrual.title"></salaxy-input-number>          


          <salaxy-form-group label="SALAXY.MODEL.HolidaySpecificationForYear.employmentPeriod.title" name="contract">
            <salaxy-datepicker-popup require="true" name="startDate" label="SALAXY.NG1.WorkerWizardComponent.employment.group.startDate" ng-model="$ctrl.current.spec.employmentPeriod.start"></salaxy-datepicker-popup>
            <salaxy-datepicker-popup name="endDate" label="SALAXY.NG1.WorkerWizardComponent.employment.group.endDate" ng-model="$ctrl.current.spec.employmentPeriod.end"></salaxy-datepicker-popup>
          </salaxy-form-group>
        </div>
      </fieldset>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-12">
      <button class="btn btn-primary float-end" ng-disabled="holidayForm.$invalid" ng-click="$ctrl.saveYear($ctrl.current)" sxy-text="SALAXY.UI_Terms.save"></button>
    </div>
</form>`), s.put("salaxy-components/worker/holidays/HolidayYearAccrual.html", `<salaxy-chart config="$ctrl.getChartConfig($ctrl.list)"></salaxy-chart>
<table class="table table-striped table-sm">
  <thead>
    <tr>
      <th sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearAccrual.tableHead.month"></th>
      <th class="right" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearAccrual.tableHead.daysCount"></th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>
        <salaxy-avatar class="salaxy-calc-row-type-avatar float-start" avatar="{ color: $ctrl.getRowColor('start'), initials: 'saldo', entityType: 'company' }"></salaxy-avatar>
        <strong sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearAccrual.tableBody.startSaldo"></strong>
        <br />
        <small>
          <div class="truncate" style="max-width: 300px;" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearAccrual.tableBody.startSaldoMore"></div>
        </small>
      </td>
      <td class="right" style="width: 100px">
        <salaxy-input-number name="startSaldo" label="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearAccrual.tableBody.startSaldo" label-type="plain" unit="days" ng-model="$ctrl.parent.accrual.startSaldo"></salaxy-input-number>
      </td>
    </tr>
    <tr ng-repeat="row in $ctrl.list">
      <td>
        <salaxy-avatar class="salaxy-calc-row-type-avatar float-start" avatar="{ color: $ctrl.getRowColor(row), initials: (row.month | date : 'MM'), entityType: 'company' }"></salaxy-avatar>
        <strong>{{ "SALAXY.ENUM.CalendarMonth.month" + (row.month | date : 'M') + ".label" | sxyTranslate }}</strong>
        <br />
        <small>
          <div class="truncate" style="max-width: 300px;">{{ $ctrl.getAccrualNotes(row) }}</div>
        </small>
      </td>
      <td class="right" style="width: 100px">
        <salaxy-input-number name="{{ 'daysAccrued' + $index }}" label="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearAccrual.tableBody.daysAccruedLabel" label-type="plain" unit="days" ng-model="row.daysAccrued" ng-change="row.daysAccrued == null ? row.source='initial': row.source = 'manual'"></salaxy-input-number>
      </td>
    </tr>
    <tr class="total">
      <td>
        <salaxy-avatar class="salaxy-calc-row-type-avatar float-start" avatar="{ color: $ctrl.getRowColor('total'), initials: 'Yht.', entityType: 'company' }"></salaxy-avatar>
        <strong sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearAccrual.tableBody.daysAccrued"></strong><br />
        <strong ng-if="$ctrl.getAccrualCalculations().totalToday != $ctrl.getAccrualCalculations().accrualToday" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearAccrual.tableBody.total"></strong>
        <div ng-if="$ctrl.getAccrualCalculations().total != $ctrl.getAccrualCalculations().totalToday" class="truncate" style="max-width: 300px;" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearAccrual.tableBody.estimatedHolidaysNexYear"></div>
      </td>
      <td class="right" style="width: 100px">
        <strong>{{ $ctrl.getAccrualCalculations().accrualToday | sxyCount : 'day' }}</strong><br />
        <strong ng-if="$ctrl.getAccrualCalculations().totalToday != $ctrl.getAccrualCalculations().accrualToday">{{ $ctrl.getAccrualCalculations().totalToday | sxyCount : 'day' }}</strong>
        <div ng-if="$ctrl.getAccrualCalculations().total != $ctrl.getAccrualCalculations().totalToday">{{ $ctrl.getAccrualCalculations().total | sxyCount : 'day' }}</div>
      </td>
    </tr>
  </tbody>
</table>
<div class="text-end">
  <button type="button" class="btn btn-primary" ng-click="$ctrl.saveParent()" sxy-text="SALAXY.UI_Terms.save"></button>
</div>`), s.put("salaxy-components/worker/holidays/HolidayYearHolidays.html", `<div class="salaxy-component salaxy-holiday-year-holidays">
  <table class="table table-striped {{ $ctrl.condensed ? 'table-sm' : ''}}">
    <thead>
      <tr>
        <th sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidays.tableHead.period"></th>
        <th class="right" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidays.tableHead.daysCount"></th>
      </tr>
    </thead>
    <tbody>
      <tr ng-if="!$ctrl.condensed">
        <td>
          <salaxy-avatar class="salaxy-calc-row-type-avatar float-start" avatar="{ color: '#2b507c', initials: 'saldo', entityType: 'company' }"></salaxy-avatar>
          <strong sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidays.tableBody.availableHolidays"></strong>
          <br />
          <small>
            <div class="truncate" style="max-width: 250px;" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidays.tableBody.availableHolidaysMore"></div>
          </small>
        </td>
        <td class="right">
          <strong>{{ $ctrl.getTotalDays("holidaysSaldoStart") | sxyCount : "day" }}</strong>
        </td>
      </tr>
      <tr ng-repeat="row in $ctrl.list | filter : $ctrl.filter" ng-click="$ctrl.showEditDialog(row)" class="clickable">
        <td>
          <salaxy-avatar class="salaxy-calc-row-type-avatar float-start" avatar="{ color: '#2b507c', initials: (row.period.daysCount + 'pv'), entityType: 'company' }"></salaxy-avatar>
          <strong>{{ row.period | sxyDateRange }}</strong>
          <br />
          <small>
            <div class="truncate" style="max-width: 250px;">{{ $ctrl.getDescription(row) }}</div>
          </small>
        </td>
        <td class="right">
          <strong>{{ row.period.daysCount | sxyCount : "day"  }}</strong>
        </td>
      </tr>
      <tr class="total" ng-if="$ctrl.condensed">
        <td>
          <salaxy-avatar class="salaxy-calc-row-type-avatar float-start" avatar="{ color: '#2b507c', initials: 'sum', entityType: 'company' }"></salaxy-avatar>
          <strong sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidays.tableBody.total"></strong>
        </td>
        <td class="right">
          <strong>{{ $ctrl.getTotalDays("filtered") | sxyCount : "day" }}</strong>
        </td>
      </tr>
      <tr ng-if="$ctrl.list.length == 0 && !$ctrl.condensed">
        <td colspan="2" style="padding-left: 48px">
          <h3 sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidays.tableBody.noHolidaysTitle"></h3>
          <p sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidays.tableBody.noHolidaysDescription"></p>
          <p sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidays.tableBody.noHolidaysDescription2"></p>
          <button type="button" class="btn btn-primary btn-block" ng-click="$ctrl.showEditDialog('new')" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidays.tableBody.addFirstHolidayButtonText"></button>
        </td>
      </tr>
      <tr class="total" ng-if="!$ctrl.condensed">
        <td>
          <salaxy-avatar class="salaxy-calc-row-type-avatar float-start" avatar="{ color: '#2b507c', initials: 'sum', entityType: 'company' }"></salaxy-avatar>
          <strong sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidays.tableBody.total2"></strong>
          <br />
          <small>
            <div class="truncate" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidays.tableBody.total2More"></div>
          </small>
        </td>
        <td class="right">
          <strong>{{ $ctrl.getTotalDays("all") | sxyCount : "day" }}</strong>
        </td>
      </tr>
      <tr ng-if="!$ctrl.condensed">
        <td>
          <salaxy-avatar class="salaxy-calc-row-type-avatar float-start" avatar="{ color: '#2b507c', initials: 'saldo', entityType: 'company' }"></salaxy-avatar>
          <strong sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidays.tableBody.unusedHolidays"></strong>
          <br />
          <small>
            <div class="truncate" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidays.tableBody.unusedHolidaysMore"></div>
          </small>
        </td>
        <td class="right">
          <strong>{{ $ctrl.getTotalDays("holidaysSaldoEnd") | sxyCount : "day" }}</strong>
        </td>
      </tr>
    </tbody>
  </table>
  <div class="text-end">
    <button type="button" class="btn btn-primary" ng-click="$ctrl.showEditDialog('new')" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidays.addHolidayButtonText"></button>
  </div>
</div>`), s.put("salaxy-components/worker/holidays/HolidayYearHolidaysEditDialog.html", `<div class="modal-header d-flex">
  <h1 sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidaysEditDialog.panelHeading"></h1>
  <button type="button" class="btn-close btn-close ms-auto" ng-click="$close('cancel')" aria-label="Close"></button>
</div>
<div class="modal-body">
  <form class="form-horizontal">
    <salaxy-datepicker-popup name="start" min-date="$ctrl.logic.minDate" max-date="$ctrl.logic.maxDate" ng-model="$ctrl.current.period.start" ng-change="$ctrl.logic.updatePeriodDays($ctrl.current)" label="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidaysEditDialog.labelStartDate"></salaxy-datepicker-popup>
    <salaxy-datepicker-popup name="end" min-date="$ctrl.logic.minDate" max-date="$ctrl.logic.maxDate" ng-model="$ctrl.current.period.end" ng-change="$ctrl.logic.updatePeriodDays($ctrl.current)" label="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidaysEditDialog.labelEndDate"></salaxy-datepicker-popup>
    <salaxy-form-group name="daysCount" label="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidaysEditDialog.labelHolidaysCount" ng-if="!$ctrl.current.period.days || $ctrl.current.period.days.length == 0">
      <div class="input-group">
        <input class="form-control" type="text" autocomplete="off" id="daysCount" name="daysCount" ng-model="$ctrl.current.period.daysCount" disabled>
        <span class="input-group-btn">
          <button type="button" class="btn btn-default" ng-click="$ctrl.logic.setDaysSelection($ctrl.current)" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidaysEditDialog.editDatesButtonText"></button>
        </span>
      </div>
    </salaxy-form-group>
    <salaxy-datepicker ng-model="$ctrl.current.period" name="days" is-multiple="true" watch-changes="true" label="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidaysEditDialog.labelHolidaysCount" min-date="$ctrl.current.period.start" max-date="$ctrl.current.period.end" ng-if="$ctrl.current.period.days.length > 0"></salaxy-datepicker>
    <salaxy-input name="notes" label="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearHolidaysEditDialog.labelDescription" ng-model="$ctrl.current.notes"></salaxy-input>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-danger" ng-click="$close('delete')" sxy-text="SALAXY.UI_Terms.delete"></button>
  <button type="reset" class="btn btn-default ms-auto" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
  <button type="submit" class="btn btn-primary" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.ok"></button>
</div>`), s.put("salaxy-components/worker/holidays/HolidayYearPaid.html", `<div class="salaxy-component salaxy-holiday-year-paid">
  <div ng-if="!$ctrl.list">
    <salaxy-spinner></salaxy-spinner>
  </div>
  <div ng-if="$ctrl.list">
    <table class="table table-sm">
      <thead>
        <tr>
          <th colspan="2">
            &nbsp; <br />
            <span class="uppercase" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaid.tableHead.paidHolidays"></span>
          </th>
          <th class="right">
            <span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaid.tableHead.holidaysCount"></span>
            <br />
            <span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaid.tableHead.holidaySalary"></span>
          </th>
          <th class="right">
            <span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaid.tableHead.compensation"></span>
            <br />
            <span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaid.tableHead.bonus"></span>
          </th>
        </tr>
      </thead>
      <tbody>

        <tr ng-repeat="row in $ctrl.list" class="clickable" ng-click="$ctrl.showEditDialog(row)" ng-style="row.isDisabled ? {opacity: 0.5, 'text-decoration': 'line-through'}: ''">
          <td width="42px">
            <salaxy-avatar class="salaxy-calc-row-type-avatar" avatar="row.avatar"></salaxy-avatar>
          </td>
          <td>
            <strong>{{ row.avatar.displayName }}</strong>
            <span ng-if="row.kind =='manualSalary' || row.kind =='manualCompensation' || row.kind =='manualBonus'" class="badge bg-primary" sxy-text="Manual"></span>
            <div>{{ row.avatar.description }}</div>
          </td>
         
          <td class="right">
            <div>{{ (row.holidayDays | sxyCount : 'day') || "&nbsp;" }}</div>
            <div>{{ (row.holidaySalary | currency) || "&nbsp;" }}</div>
          </td>
          <td class="right">
            <div>{{ (row.holidayCompensation | currency) || "&nbsp;" }}</div>
            <div>{{ (row.holidayBonus | currency) || "&nbsp;" }}</div>
          </td>
        </tr>
        
        <tr>
          <th colspan="4">
            &nbsp; <br />
            <span class="uppercase"> <span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaid.tableHead.holidaySalary"></span>, <span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaid.tableHead.compensation"></span></span>
          </th>
        </tr>
        <tr>
          <td width="42px">
            <salaxy-avatar class="salaxy-calc-row-type-avatar" avatar="$ctrl.totals.startSaldo.avatar"></salaxy-avatar>
          </td>
          <td>
            <strong>{{ $ctrl.totals.startSaldo.avatar.displayName }}</strong>
            <div>{{ $ctrl.totals.startSaldo.avatar.description }}</div>
          </td>
          <td class="right">
            <div>{{ ($ctrl.totals.startSaldo.holidayDays | sxyCount : 'day') || "&nbsp;" }}</div>
            <div>{{ ($ctrl.totals.startSaldo.holidaySalary | currency) || "&nbsp;" }}</div>
          </td>
          <td class="right">
            <div>{{ ($ctrl.totals.startSaldo.holidayCompensation | currency) || "&nbsp;" }}</div>
            <div>{{ ($ctrl.totals.startSaldo.holidayBonus | currency) || "&nbsp;" }}</div>
          </td>
        </tr>
        <tr class="total">
          <td width="42px">
            <salaxy-avatar class="salaxy-calc-row-type-avatar" avatar="$ctrl.totals.total.avatar"></salaxy-avatar>
          </td>
          <td>
            <strong>{{ $ctrl.totals.total.avatar.displayName }}</strong>
            <div>{{ $ctrl.totals.total.avatar.description }}</div>
          </td>
          <td class="right">
            <div>{{ ($ctrl.totals.total.holidayDays | sxyCount : 'day') || "&nbsp;" }}</div>
            <div>{{ ($ctrl.totals.total.holidaySalary | currency) || "&nbsp;" }}</div>
          </td>
          <td class="right">
            <div>{{ ($ctrl.totals.total.holidayCompensation | currency) || "&nbsp;" }}</div>
            <div>{{ ($ctrl.totals.total.holidayBonus | currency) || "&nbsp;" }}</div>
          </td>
        </tr>
        <tr>
          <td width="42px">
            <salaxy-avatar class="salaxy-calc-row-type-avatar" avatar="$ctrl.totals.endSaldo.avatar"></salaxy-avatar>
          </td>
          <td>
            <strong>{{ $ctrl.totals.endSaldo.avatar.displayName }}</strong>
            <div>{{ $ctrl.totals.endSaldo.avatar.description }}</div>
          </td>
          <td class="right">
            <div>{{ ($ctrl.totals.endSaldo.holidayDays | sxyCount : 'day') || "&nbsp;" }}</div>
            <div>{{ ($ctrl.totals.endSaldo.holidaySalary | currency) || "&nbsp;" }}</div>
          </td>
          <td class="right">
            <div>{{ ($ctrl.totals.endSaldo.holidayCompensation | currency) || "&nbsp;" }}</div>
            <div>{{ ($ctrl.totals.endSaldo.holidayBonus | currency) || "&nbsp;" }}</div>
          </td>
        </tr>
        <tr>
          <th colspan="4">
            &nbsp; <br />
            <span class="uppercase"> <span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaid.tableHead.bonus"></span></span>
          </th>
        </tr>
        <tr ng-if="$ctrl.shoudPayBonus">
          <td width="42px">
            <salaxy-avatar class="salaxy-calc-row-type-avatar" avatar="$ctrl.bonusTotals.startSaldo.avatar"></salaxy-avatar>
          </td>
          <td>
            <strong>{{ $ctrl.bonusTotals.startSaldo.avatar.displayName }}</strong>
            <div>{{ $ctrl.bonusTotals.startSaldo.avatar.description }}</div>
          </td>
          <td class="right">
            <div>{{ ($ctrl.bonusTotals.startSaldo.holidayDays | sxyCount : 'day') || "&nbsp;" }}</div>
            <div>{{ ($ctrl.bonusTotals.startSaldo.holidaySalary | currency) || "&nbsp;" }}</div>
          </td>
          <td class="right">
            <div>{{ ($ctrl.bonusTotals.startSaldo.holidayCompensation | currency) || "&nbsp;" }}</div>
            <div>{{ ($ctrl.bonusTotals.startSaldo.holidayBonus | currency) || "&nbsp;" }}</div>
          </td>
        </tr>
        <tr class="total">
          <td width="42px">
            <salaxy-avatar class="salaxy-calc-row-type-avatar" avatar="$ctrl.bonusTotals.total.avatar"></salaxy-avatar>
          </td>
          <td>
            <strong>{{ $ctrl.bonusTotals.total.avatar.displayName }}</strong>
            <div>{{ $ctrl.bonusTotals.total.avatar.description }}</div>
          </td>
          <td class="right">
            <div>{{ ($ctrl.bonusTotals.total.holidayDays | sxyCount : 'day') || "&nbsp;" }}</div>
            <div>{{ ($ctrl.bonusTotals.total.holidaySalary | currency) || "&nbsp;" }}</div>
          </td>
          <td class="right">
            <div>{{ ($ctrl.bonusTotals.total.holidayCompensation | currency) || "&nbsp;" }}</div>
            <div>{{ ($ctrl.bonusTotals.total.holidayBonus | currency) || "&nbsp;" }}</div>
          </td>
        </tr>
        <tr ng-if="$ctrl.shoudPayBonus">
          <td width="42px">
            <salaxy-avatar class="salaxy-calc-row-type-avatar" avatar="$ctrl.bonusTotals.endSaldo.avatar"></salaxy-avatar>
          </td>
          <td>
            <strong>{{ $ctrl.bonusTotals.endSaldo.avatar.displayName }}</strong>
            <div>{{ $ctrl.bonusTotals.endSaldo.avatar.description }}</div>
          </td>
          <td class="right">
            <div>{{ ($ctrl.bonusTotals.endSaldo.holidayDays | sxyCount : 'day') || "&nbsp;" }}</div>
            <div>{{ ($ctrl.bonusTotals.endSaldo.holidaySalary | currency) || "&nbsp;" }}</div>
          </td>
          <td class="right">
            <div>{{ ($ctrl.bonusTotals.endSaldo.holidayCompensation | currency) || "&nbsp;" }}</div>
            <div>{{ ($ctrl.bonusTotals.endSaldo.holidayBonus | currency) || "&nbsp;" }}</div>
          </td>
        </tr>
      </tbody>
    </table>
    <button type="button" class="btn btn-primary pull-right" ng-click="$ctrl.showEditDialog('new', true)" sxy-text="SALAXY.UI_Terms.add"></button>
  </div>
</div>`), s.put("salaxy-components/worker/holidays/HolidayYearPaidEditDialog.html", `<div class="card card-primary">
  <div class="card-header ">
    <h2 sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaidEditDialog.panelHeading"></h2>
    <button type="button" class="btn-close" ng-click="$dismiss()" aria-label="Close"></button>
  </div>
  <div class="card-body">
    <form class="form-horizontal">      
      <div ng-switch="$ctrl.current.kind">
        <div ng-switch-when="manualSalary">
          <h3 sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaidEditDialog.manualSalary.title"></h3>
          <p sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaidEditDialog.manualSalary.description"></p>
        </div>
        <div ng-switch-when="manualCompensation">
          <h3 sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaidEditDialog.manualCompensation.title"></h3>
          <p sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaidEditDialog.manualCompensation.description"></p>
        </div>
        <div ng-switch-when="manualBonus">
          <h3 sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaidEditDialog.manualBonus.title"></h3>
          <p sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaidEditDialog.manualBonus.description"></p>
        </div>
        <div ng-switch-when="paidCalc">
          <h3 sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaidEditDialog.paidCalc.title"></h3>
          <p sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaidEditDialog.paidCalc.description"></p>
        </div>
      </div>
      <div ng-if="$ctrl.current.kind == 'undefined'">
        <p class="lead" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaidEditDialog.undefined.labelAnnualLeavePaymentKind"></p>
        <salaxy-input-enum ng-model="$ctrl.current.kind" name="typeRadio" enum="AnnualLeavePaymentKind" type="radio" filter="manualSalary,manualCompensation,manualBonus" label-type="plain"></salaxy-input-enum>
        <p>&nbsp;</p>
      </div>
      <div ng-if="$ctrl.current.kind != 'undefined'">
        <salaxy-input-enum  disabled="true" ng-if="$ctrl.current.kind == 'paidCalc'" ng-model="$ctrl.current.kind" enum="AnnualLeavePaymentKind" label="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaidEditDialog.kind" filter="paidCalc" name="typeSelect" type="select"></salaxy-input-enum>
        <salaxy-input-enum  ng-if="$ctrl.current.kind != 'paidCalc'" ng-model="$ctrl.current.kind" enum="AnnualLeavePaymentKind" label="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaidEditDialog.kind" filter="manualSalary,manualCompensation,manualBonus" name="typeSelect" type="select"></salaxy-input-enum>
 
        <salaxy-datepicker-popup disabled="$ctrl.current.kind =='paidCalc'" name="date" ng-model="$ctrl.current.date" label="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaidEditDialog.manualSalary.labelPaidAt" ></salaxy-datepicker-popup>
        <salaxy-datepicker-popup disabled="$ctrl.current.kind =='paidCalc'" name="myDatepickerPopup" ng-model="$ctrl.current.period.start" ng-change="$ctrl.logic.updatePeriodDays($ctrl.current)" label="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaidEditDialog.manualSalary.labelStartDate" >
        </salaxy-datepicker-popup>
        <salaxy-datepicker-popup disabled="$ctrl.current.kind =='paidCalc'" name="myDatepickerPopup" ng-model="$ctrl.current.period.end" ng-change="$ctrl.logic.updatePeriodDays($ctrl.current)" label="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaidEditDialog.manualSalary.labelEndDate">
        </salaxy-datepicker-popup>
        <salaxy-input-number disabled="true" name="days" label="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaidEditDialog.manualSalary.labelDaysCount" ng-model="$ctrl.current.period.daysCount" ></salaxy-input-number>
        <salaxy-input-number disabled="$ctrl.current.kind =='paidCalc'" name="holidayDays" label="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaidEditDialog.manualSalary.labelUsedHolidays" ng-model="$ctrl.current.holidayDays" ng-change="$ctrl.logic.updateDaysCount($ctrl.current)"></salaxy-input-number>
        <salaxy-input-number disabled="$ctrl.current.kind =='paidCalc'" ng-if="$ctrl.current.kind =='paidCalc' || $ctrl.current.kind =='manualSalary'" name="holidaySalary" label="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaidEditDialog.manualSalary.labelHolidaySalary" ng-model="$ctrl.current.holidaySalary" ></salaxy-input-number>
        <salaxy-input-number disabled="$ctrl.current.kind =='paidCalc'" ng-if="$ctrl.current.kind =='paidCalc' || $ctrl.current.kind =='manualCompensation'" name="holidayCompensation" label="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaidEditDialog.manualCompensation.labelCompensation" ng-model="$ctrl.current.holidayCompensation"></salaxy-input-number>
        <salaxy-input-number disabled="$ctrl.current.kind =='paidCalc'" ng-if="$ctrl.current.kind =='paidCalc' || $ctrl.current.kind =='manualBonus'" name="holidayBonus" label="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaidEditDialog.manualSalary.labelBonus" ng-model="$ctrl.current.holidayBonus"></salaxy-input-number>
        <salaxy-input-boolean ng-if="$ctrl.current.kind =='paidCalc'" type="switch" name="isDisabled" ng-model="$ctrl.current.isDisabled" label="Poista käytöstä" label-true="on"
          label-false="off"></salaxy-input-boolean>
        <salaxy-form-group name="calc" label="SALAXY.ENUM.AnnualLeavePaymentKind.paidCalc.label" ng-if="$ctrl.current.calcId">
            <a ng-href="{{$ctrl.logic.getPdfUrl($ctrl.current.calcId)}}" target="_blank" title="{{ 'SALAXY.UI_Terms.printable' | sxyTranslate}}" class="btn btn-sm btn-secondary"><i class="bi bi-file-earmark-pdf"></i></a>
        </salaxy-form-group>
        <salaxy-input disabled="$ctrl.current.kind =='paidCalc'" name="notes" label="SALAXY.NG1.WorkerHolidaysComponent.HolidayYearPaidEditDialog.manualSalary.labelDescription" ng-model="$ctrl.current.notes"></salaxy-input>
      </div>
      <div>
        <button ng-disabled="$ctrl.current.kind == 'undefined'" type="submit" class="btn btn-primary float-end" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.save"></button>
        <button type="reset" class="btn btn-default float-end" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
        <button ng-disabled="$ctrl.current.kind == 'paidCalc' || $ctrl.current.kind == 'undefined'" type="button" class="btn btn-danger" ng-click="$close('delete')" sxy-text="SALAXY.UI_Terms.delete"></button>
      </div>
    </form>
  </div>
</div>`), s.put("salaxy-components/worker/holidays/WorkerHolidays-accrual.html", `<div class="row">
  <div class="col-sm-9">
    <fieldset ng-if="$ctrl.viewType == 'overview'">
      <legend><span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.accrual.overview.legend"></span> {{ $ctrl.current.year }}</legend>
      <table class="salaxy-holidays-overview-table">
        <thead>
          <tr>
            <th class="year bg-{{year.style}}" ng-repeat="year in $ctrl.getYearVisualisation().years" colspan="{{ year.months }}">{{ year.text }}</th>
          </tr>
          <tr>
            <th ng-class="{ 'month': true, 'bg-primary': month%2, 'bg-danger': $index == $ctrl.getYearVisualisation().currentMonthIx }" ng-repeat="month in $ctrl.getYearVisualisation().months track by $index" class="text-end">{{ month }}</th>
          </tr>
        </thead>
        <tr ng-repeat="item in $ctrl.getYearVisualisation().items">
          <td class="month-empty" ng-repeat="x in [].constructor(item.start) track by $index"></td>
          <td colspan="{{ item.months }}">
            <button class="btn btn-{{ item.style }} btn-block btn-sm" ng-click="$ctrl.viewType = item.view">{{ item.text }}</button>
          </td>
          <td class="month-empty" ng-repeat="x in [].constructor(25 - item.start - item.months) track by $index"></td>
        </tr>
      </table>
      <h3 sxy-text="SALAXY.NG1.WorkerHolidaysComponent.accrual.overview.introTitle"></h3>
      <ol class="lead">
        <li sxy-html="SALAXY.NG1.WorkerHolidaysComponent.accrual.overview.introList.html"></li>
        <li sxy-html="SALAXY.NG1.WorkerHolidaysComponent.accrual.overview.introList2.html"></li>
        <li ng-if="$ctrl.getVisibility('hourly')" sxy-html="SALAXY.NG1.WorkerHolidaysComponent.accrual.overview.introList3.html"></li>
        <li sxy-html="SALAXY.NG1.WorkerHolidaysComponent.accrual.overview.introList4.html"></li>
      </ol>
    </fieldset>
    <fieldset ng-if="$ctrl.viewType == 'parameters'">
      <ng-include src="'salaxy-components/worker/holidays/HolidayParametersForm.html'"></ng-include>
    </fieldset>
    <fieldset ng-if="$ctrl.viewType == 'holidays'">
      <legend>
        <button class="btn btn-primary btn-sm float-end" ng-click="$ctrl.viewType = 'holidays-summer'" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.buttonSummer"></button>
        <span class="float-end">&nbsp;</span>
        <button class="btn btn-primary btn-sm float-end" ng-click="$ctrl.viewType = 'holidays-winter'" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.buttonWinter"></button>
        <span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.calendarTitle"></span> {{ $ctrl.current.year}}
      </legend>
      <salaxy-holiday-year-holidays on-commit="$ctrl.save()" parent="$ctrl.current"></salaxy-holiday-year-holidays>
    </fieldset>
    <fieldset ng-if="$ctrl.viewType == 'holidays-summer'">
      <legend>
        <button class="btn btn-primary btn-sm float-end" ng-click="$ctrl.viewType = 'holidays'" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.buttonAll"></button>
        <span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.summerHolidaysTitle"></span> {{ $ctrl.current.year}}
      </legend>
      <salaxy-calendar data="[$ctrl.current]" mapper="$ctrl.mapToCalendar" on-list-select="$ctrl.calendarClick(type, date, calEvent)" start="$ctrl.current.year + '-05-01'" end="$ctrl.current.year + '-09-01'"></salaxy-calendar>
    </fieldset>
    <fieldset ng-if="$ctrl.viewType == 'holidays-winter'">
      <legend>
        <button class="btn btn-primary btn-sm float-end" ng-click="$ctrl.viewType = 'holidays'" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.buttonAll"></button>
        <span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.winterHolidaysTitle"></span> {{ $ctrl.current.year}}
      </legend>
      <salaxy-calendar data="[$ctrl.current]" mapper="$ctrl.mapToCalendar" on-list-select="$ctrl.calendarClick(type, date, calEvent)" start="$ctrl.current.year + '-10-01'" end="(1 * $ctrl.current.year + 1) + '-04-01'"></salaxy-calendar>
    </fieldset>

    <fieldset ng-if="$ctrl.viewType == 'paidHolidays'">
      <legend>
        <span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.accrual.paidSalaries.legend"></span> {{ $ctrl.current.period | sxyDateRange }}
      </legend>
      <p sxy-text="SALAXY.NG1.WorkerHolidaysComponent.accrual.paidSalaries.description"></p>

      <ul sxy-html="SALAXY.NG1.WorkerHolidaysComponent.accrual.paidSalaries.descriptionList.html"></ul>
      <salaxy-holiday-year-paid parent="$ctrl.current" on-commit="$ctrl.save()"></salaxy-holiday-year-paid>
    </fieldset>
    <fieldset ng-if="$ctrl.viewType == 'accrual'">
      <legend>
        <span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.accrual.accrualHolidays.legend"></span> {{ $ctrl.current.accrual.period | sxyDateRange }}
      </legend>
      <p>
        <span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.accrual.accrualHolidays.description"></span> {{ $ctrl.current.year - 1 }}.
        <span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.accrual.accrualHolidays.description2"></span> {{ $ctrl.current.year }}.
      </p>
      <salaxy-holiday-year-accrual parent="$ctrl.current"></salaxy-holiday-year-accrual>
    </fieldset>
    <fieldset ng-if="$ctrl.viewType == 'hourlySalaries'">
      <legend>
        <span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.accrual.hourlySalaries.legend"></span> {{ $ctrl.current.period | sxyDateRange }}
      </legend>
      <p sxy-text="SALAXY.NG1.WorkerHolidaysComponent.accrual.hourlySalaries.description"></p>
      <ul sxy-html="SALAXY.NG1.WorkerHolidaysComponent.accrual.hourlySalaries.descriptionList.html"></ul>
      <p sxy-text="SALAXY.NG1.WorkerHolidaysComponent.accrual.hourlySalaries.description2"></p>
    </fieldset>
  </div>
  <div class="col-sm-3">
    <div class="btn-group btn-block dropdown mb-4">
      <button id="year-selection" type="button" class="btn btn-primary btn-block dropdown-toggle" data-bs-toggle="dropdown">
        {{ $ctrl.current ? ('SALAXY.NG1.WorkerHolidaysComponent.UI.dropdown.selectedYear' | sxyTranslate) + " " + $ctrl.current.year : ('SALAXY.NG1.WorkerHolidaysComponent.UI.dropdown.selectYear' | sxyTranslate)  }}
      </button>
      <ul class="dropdown-menu" role="menu" aria-labelledby="single-button">
        <li role="menuitem" ng-repeat="year in $ctrl.employmentHolidayYears">
          <a href="" ng-click="$ctrl.model = year" class="dropdown-item" >{{ year.year }}</a>
        </li>
        <li role="menuitem">
          <a ng-href="#{{ $ctrl.getDefaults().listUrl }}" class="dropdown-item" ng-if="!($ctrl.employmentHolidayYears.length > 0)" sxy-text="SALAXY.UI_Terms.back"></a>
        </li>
        <li class="divider"></li>
        <li role="menuitem" ng-if="$ctrl.missingHolidayYear">
          <a href="" ng-click="$ctrl.showInitHolidays()" class="dropdown-item">{{"SALAXY.UI_Terms.add" | sxyTranslate}} {{"SALAXY.NG1.WorkerHolidaysComponent.holidayCompensation.overview.legendYear" | sxyTranslate}} {{$ctrl.missingHolidayYear}}</a>
        </li>
      </ul>
    </div>
    <salaxy-toggle-buttons ng-model="$ctrl.viewType" 
      options="[
        { value: 'overview', label: 'SALAXY.NG1.WorkerHolidaysComponent.UI.sidebar.buttonOverview' },
        { value: 'parameters', label: 'SALAXY.NG1.WorkerHolidaysComponent.UI.sidebar.buttonSettings' },
        { value: 'accrual', label: 'SALAXY.NG1.WorkerHolidaysComponent.UI.sidebar.buttonAccrual' },
        { value: 'holidays', label: 'SALAXY.NG1.WorkerHolidaysComponent.UI.sidebar.buttonHolidays' },
        { value: 'paidHolidays', label: 'SALAXY.NG1.WorkerHolidaysComponent.UI.sidebar.buttonPaidHolidays' }
        ]" 
      type="block">
    </salaxy-toggle-buttons>
    <p>&nbsp;</p>
    <fieldset ng-if="$ctrl.current">
      <legend sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.sidebar.info"></legend>
      <div>{{ "WageBasis." + $ctrl.current.spec.wageBasis | sxyEnum }}</div>
      <div>{{ "HolidayCode." + $ctrl.current.spec.code | sxyEnum }}</div>
      <div ng-if="$ctrl.getVisibility('accrual')">
        {{'SALAXY.NG1.WorkerHolidaysComponent.UI.sidebar.periodAccrual' | sxyTranslate}}<br />{{ $ctrl.current.accrual.period | sxyDateRange }}</div>
      <div><span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.sidebar.periodSelectedYear"></span>
        <br />{{ $ctrl.current.period | sxyDateRange }}
      </div>
      <div ng-if="$ctrl.getVisibility('accrual')">
        <span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.sidebar.periodDefaultAccrual"></span> {{ $ctrl.current.accrual.defaultAccrual | sxyCount : 'day' }}
      </div>
      <div ng-if="$ctrl.getVisibility('compensation')">
        <span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.sidebar.compensation"></span> {{ $ctrl.current.spec.compensation | sxyCount : 'percent' }}
      </div>
      <div ng-if="$ctrl.current.spec.bonusMethod != 'none'">
        <span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.sidebar.bonus"></span> {{ $ctrl.current.spec.bonus | sxyCount : 'percent' }}
      </div>
      <div ng-if="$ctrl.current.spec.bonusMethod == 'none'">{{ "HolidayBonusPaymentMethod." + $ctrl.current.spec.bonusMethod | sxyEnum }} </div>
    </fieldset>
  </div>
</div>`), s.put("salaxy-components/worker/holidays/WorkerHolidays-holidayCompensation.html", `<div class="row">
  <div class="col-sm-9">
    <fieldset ng-if="$ctrl.viewType == 'overview'">
      <legend>
        <span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.holidayCompensation.overview.legend"></span> (
        <span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.holidayCompensation.overview.legendYear"></span> {{$ctrl.current.year}})
      </legend>
      <p class="lead" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.holidayCompensation.overview.intro"></p>
      <ul class="lead">
        <li>
          <strong sxy-text="SALAXY.NG1.WorkerHolidaysComponent.holidayCompensation.overview.intro2"></strong>
          <ul>
            <li> <span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.holidayCompensation.overview.introCompensation"></span>{{ $ctrl.current.spec.compensation | sxyCount : 'percent' }}</li>
            <li ng-if="$ctrl.current.spec.bonusMethod != 'none'"><span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.holidayCompensation.overview.introBonus"></span> {{ $ctrl.current.spec.bonus | sxyCount : 'percent' }}</li>
            <li ng-if="$ctrl.current.spec.bonusMethod == 'none'" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.holidayCompensation.overview.introNoBonus"></li>
          </ul>
        </li>
      </ul>
    </fieldset>
    <fieldset ng-if="$ctrl.viewType == 'parameters'">
      <ng-include src="'salaxy-components/worker/holidays/HolidayParametersForm.html'"></ng-include>
    </fieldset>
    <fieldset ng-if="$ctrl.viewType == 'holidays'">
      <legend>
        <button class="btn btn-primary btn-sm float-end" ng-click="$ctrl.viewType = 'holidays-summer'" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.buttonSummer"></button>
        <span class="float-end">&nbsp;</span>
        <button class="btn btn-primary btn-sm float-end" ng-click="$ctrl.viewType = 'holidays-winter'" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.buttonWinter"></button>
        <span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.calendarTitle"></span> {{ $ctrl.current.year}}
      </legend>
      <salaxy-holiday-year-holidays on-commit="$ctrl.save()" parent="$ctrl.current"></salaxy-holiday-year-holidays>
    </fieldset>
    <fieldset ng-if="$ctrl.viewType == 'holidays-summer'">
      <legend>
        <button class="btn btn-primary btn-sm float-end" ng-click="$ctrl.viewType = 'holidays'" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.buttonAll"></button>
        <span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.summerHolidaysTitle"></span> {{ $ctrl.current.year}}
      </legend>
      <salaxy-calendar data="[$ctrl.current]" mapper="$ctrl.mapToCalendar" on-list-select="$ctrl.calendarClick(type, date, calEvent)" start="$ctrl.current + '-05-01'" end="$ctrl.current + '-09-01'"></salaxy-calendar>
    </fieldset>
    <fieldset ng-if="$ctrl.viewType == 'holidays-winter'">
      <legend>
        <button class="btn btn-primary btn-sm float-end" ng-click="$ctrl.viewType = 'holidays'" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.buttonAll"></button>
        <span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.winterHolidaysTitle"></span> {{ $ctrl.current.year}}
      </legend>
      <salaxy-calendar data="[$ctrl.current]" mapper="$ctrl.mapToCalendar" on-list-select="$ctrl.calendarClick(type, date, calEvent)" start="$ctrl.current + '-10-01'" end="(1 * $ctrl.current + 1) + '-04-01'"></salaxy-calendar>
    </fieldset>
  </div>
  <div class="col-sm-3">
    <div class="btn-group btn-block dropdown">
      <button id="year-selection" type="button" class="btn btn-primary btn-block dropdown-toggle" data-bs-toggle="dropdown">
        {{ $ctrl.current ? ('SALAXY.NG1.WorkerHolidaysComponent.UI.dropdown.selectedYear' | sxyTranslate) + " " +  $ctrl.current.year : ('SALAXY.NG1.WorkerHolidaysComponent.UI.dropdown.selectYear' | sxyTranslate) }}
      </button>
      <ul class="dropdown-menu" role="menu" aria-labelledby="single-button">
        <li role="menuitem"  ng-repeat="year in $ctrl.employmentHolidayYears" >
          <a href="" ng-click="$ctrl.model = year" class="dropdown-item">{{ year.year }}</a></li>
        <li role="menuitem">
          <a ng-href="#{{ $ctrl.getDefaults().listUrl }}" ng-if="!($ctrl.employmentHolidayYears.length > 0)" class="dropdown-item" sxy-text="SALAXY.UI_Terms.back"></a></li>
        <li class="divider"></li>
        <li role="menuitem" ng-if="$ctrl.missingHolidayYear">
          <a href="" ng-click="$ctrl.showInitHolidays()" class="dropdown-item">{{"SALAXY.UI_Terms.add" | sxyTranslate}} {{"SALAXY.NG1.WorkerHolidaysComponent.holidayCompensation.overview.legendYear" | sxyTranslate}} {{$ctrl.missingHolidayYear}}</a>
        </li>
      </ul>
    </div>
    <p>&nbsp;</p>
    <salaxy-toggle-buttons ng-model="$ctrl.viewType" options="[
      { value: 'overview', label: 'SALAXY.NG1.WorkerHolidaysComponent.UI.sidebar.buttonOverview' },
      { value: 'parameters', label: 'SALAXY.NG1.WorkerHolidaysComponent.UI.sidebar.buttonSettings' },
      ]" type="block"></salaxy-toggle-buttons>
    <p>&nbsp;</p>
    <fieldset ng-if="$ctrl.current">
      <legend sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.sidebar.info"></legend>
      <div>{{ "HolidayCode." + $ctrl.current.spec.code | sxyEnum }}</div>
      <div><span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.sidebar.periodSelectedYear"></span><br />{{ $ctrl.current.period | sxyDateRange }}</div>
      <div><span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.sidebar.compensation"></span> {{ $ctrl.current.spec.compensation | sxyCount : 'percent' }}</div>
      <div ng-if="$ctrl.current.spec.bonusMethod != 'none'">
        <span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.sidebar.bonus"></span> {{ $ctrl.current.spec.bonus | sxyCount : 'percent' }}
      </div>
      <div ng-if="$ctrl.current.spec.bonusMethod == 'none'">{{ "HolidayBonusPaymentMethod." + $ctrl.current.spec.bonusMethod | sxyEnum }} </div>
    </fieldset>
  </div>
</div>`), s.put("salaxy-components/worker/holidays/WorkerHolidays-noHolidays.html", `<div class="row">
  <div class="col-sm-9">
    <fieldset ng-if="$ctrl.viewType == 'overview'">
      <legend><span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.noHolidays.legend"></span>{{ $ctrl.current.year }}</legend>
      <p class="lead" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.noHolidays.intro"></p>
    </fieldset>
    <fieldset ng-if="$ctrl.viewType == 'parameters'">
      <ng-include src="'salaxy-components/worker/holidays/HolidayParametersForm.html'"></ng-include>
    </fieldset>
  </div>
  <div class="col-sm-3">
    <div class="btn-group btn-block dropdown">
      <button id="year-selection" type="button" class="btn btn-primary btn-block dropdown-toggle" data-bs-toggle="dropdown">
        {{ $ctrl.current ? ('SALAXY.NG1.WorkerHolidaysComponent.UI.dropdown.selectedYear' | sxyTranslate) + " " + $ctrl.current.year : ('SALAXY.NG1.WorkerHolidaysComponent.UI.dropdown.selectYear' | sxyTranslate) }}
      </button>
      <ul class="dropdown-menu"  role="menu" aria-labelledby="single-button">
        <li role="menuitem" ng-repeat="year in $ctrl.employmentHolidayYears">
          <a href="" ng-click="$ctrl.model = year" class="dropdown-item">{{ year.year }}</a>
        </li>
        <li role="menuitem">
          <a ng-href="#{{ $ctrl.getDefaults().listUrl }}" ng-if="!($ctrl.employmentHolidayYears.length > 0)" class="dropdown-item" sxy-text="SALAXY.UI_Terms.back"></a>
        </li>
        <li class="divider"></li>
        <li role="menuitem" ng-if="$ctrl.missingHolidayYear">
          <a href="" ng-click="$ctrl.showInitHolidays()" class="dropdown-item">{{"SALAXY.UI_Terms.add" | sxyTranslate}} {{"SALAXY.NG1.WorkerHolidaysComponent.holidayCompensation.overview.legendYear" | sxyTranslate}} {{$ctrl.missingHolidayYear}}</a>
        </li>
      </ul>
    </div>
    <p>&nbsp;</p>
    <salaxy-toggle-buttons ng-model="$ctrl.viewType" options="[{ value: 'parameters', label: 'SALAXY.NG1.WorkerHolidaysComponent.UI.sidebar.buttonSettings' }]" type="block"></salaxy-toggle-buttons>
    <fieldset ng-if="$ctrl.current">
      <legend sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.sidebar.info"></legend>
      <div>{{ "HolidayCode." + $ctrl.current.spec.code | sxyEnum }}</div>
      <div><span sxy-text="SALAXY.NG1.WorkerHolidaysComponent.UI.sidebar.periodSelectedYear"></span><br />{{ $ctrl.current.period | sxyDateRange }}</div>
    </fieldset>
  </div>
</div>`), s.put("salaxy-components/worker/holidays/WorkerHolidays-undefined.html", `<div class="salaxy-placeholder-empty placeholder-md">
  <h3 sxy-text="SALAXY.NG1.WorkerHolidaysComponent.undefined.title"></h3>
  <button class="btn btn-primary" ng-click="$ctrl.showInitHolidays()" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.undefined.showInitHolidaysButtonText"></button>
</div>`), s.put("salaxy-components/worker/holidays/WorkerHolidays.html", `<div class="salaxy-component salaxy-worker-holidays">
  <ng-include ng-if="!$ctrl.current" src="'salaxy-components/worker/holidays/WorkerHolidays-undefined.html'"></ng-include>
  <ng-include ng-if="$ctrl.current.spec.code == 'holidayCompensation'" src="'salaxy-components/worker/holidays/WorkerHolidays-holidayCompensation.html'"></ng-include>
  <ng-include ng-if="($ctrl.current && !$ctrl.current.spec.code) || $ctrl.current.spec.code == 'undefined' || $ctrl.current.spec.code == 'permanent14Days' || $ctrl.current.spec.code == 'permanent35Hours' || $ctrl.current.spec.code == 'temporaryTimeOff' || $ctrl.current.spec.code == 'other'" src="'salaxy-components/worker/holidays/WorkerHolidays-accrual.html'"></ng-include>
  <ng-include ng-if="$ctrl.current.spec.code == 'noHolidays'" src="'salaxy-components/worker/holidays/WorkerHolidays-noHolidays.html'"></ng-include>
</div>`), s.put("salaxy-components/worker/holidays/WorkerHolidaysInitDialog.html", `<div class="salaxy-component salaxy-holidays-init-dialog">
  <form class="form-horizontal" name="holidayForm">
    <div class="modal-content card-primary">
      <div class="modal-header d-flex">
        <div>
          <h2 sxy-text="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.panelHeading"></h2>
          <p sxy-text="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.intro"></p>
        </div>
        <button type="button" class="btn-close ms-auto align-self-start" data-dismiss="alert" ng-click="$close('cancel')" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="row form-horizontal">
          <div class="col-sm-6">
            <fieldset>
              <legend sxy-text="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.legendSelectHolidayType"></legend>
              <div class="radio mb-1">
                <label class="d-flex align-items-start">
                  <input type="radio" ng-init="$ctrl.current.spec.code = 'permanent14Days'" ng-checked="true" ng-model="$ctrl.current.spec.code" name="code" id="permanent14Days" ng-value="permanent14Days" class="mt-1 me-2"> 
                  <span sxy-html="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.permanent14Days.html"></span>
                </label>
              </div>
              <div class="radio mb-1">
                <label class="d-flex align-items-start">
                  <input type="radio" ng-model="$ctrl.current.spec.code" name="code" id="permanent35Hours" value="permanent35Hours" class="mt-1 me-2">
                  <span sxy-html="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.permanent35Hours.html"></span>
                </label>
              </div>
              <div class="radio mb-1">
                <label class="d-flex align-items-start">
                  <input type="radio" ng-model="$ctrl.current.spec.code" name="code" id="holidayCompensation" value="holidayCompensation" class="mt-1 me-2">
                  <span sxy-html="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.holidayCompensation.html"></span>
                </label>
              </div>
              <div class="radio mb-1">
                <label class="d-flex align-items-start">
                  <input type="radio" ng-model="$ctrl.current.spec.code" name="code" id="temporaryTimeOff" value="temporaryTimeOff" class="mt-1 me-2">
                  <span sxy-html="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.temporaryTimeOff.html"></span>
                </label>
              </div>
              <div class="radio mb-1">
                <label class="d-flex align-items-start">
                  <input type="radio" ng-model="$ctrl.current.spec.code" name="code" id="other" value="other" class="mt-1 me-2">
                  <span sxy-html="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.other.html"></span>
                </label>
              </div>
              <div class="radio mb-1">
                <label class="d-flex align-items-start">
                  <input type="radio" ng-model="$ctrl.current.spec.code" name="code" id="noHolidays" value="noHolidays" class="mt-1 me-2">
                  <span sxy-html="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.noHolidays.html"></span>
                </label>
              </div>
            </fieldset>
          </div>
          <div class="col-sm-6">
            <fieldset>
              <legend sxy-text="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.legendDetails"></legend>
              <div ng-if="$ctrl.logic.getVisibility($ctrl.current, 'accrualFixed')">
                <salaxy-input-boolean type="checkbox" name="accrualByLaw" label="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.accrualByLaw" label-true="{{ 'SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.accrualByLawLabelTrue' + ($ctrl.current.code == 'temporaryTimeOff' ? '2' : '') }}"
                  ng-change="$ctrl.logic.accrualByLawChanged($ctrl.current)" ng-model="$ctrl.logic.accrualByLaw"></salaxy-input-boolean>
                <salaxy-input-number ng-model="$ctrl.current.accrualFixed" name="accrualFixed" ng-if="$ctrl.current.accrualFixed" ng-change="$ctrl.logic.accrualFixedChanged($ctrl.current)" label="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.accrualFixed" unit="days">
                </salaxy-input-number>
              </div>
              <salaxy-input-number ng-model="$ctrl.current.compensation" name="compensation" ng-if="$ctrl.logic.getVisibility($ctrl.current, 'compensation')" required label="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.compensation" unit="percent"></salaxy-input-number>
              <salaxy-input-enum name="bonusMethod" ng-model="$ctrl.current.bonusMethod" ng-if="$ctrl.logic.getVisibility($ctrl.current, 'bonusMethod')" label="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.bonusMethod" filter="none,payForHolidaySalary,paySelectedDays" enum="HolidayBonusPaymentMethod"></salaxy-input-enum>
              <salaxy-input-enum name="bonusMethod" ng-model="$ctrl.current.bonusMethod" ng-if="$ctrl.logic.getVisibility($ctrl.current, 'compensation')" label="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.bonusMethod" options="{ 'none': ('SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.bonusMethodNone' | sxyTranslate), 'payForHolidaySalary': ('SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.bonusMethodPayForHolidaySalary' | sxyTranslate)  }">
              </salaxy-input-enum>
              <salaxy-input-number ng-model="$ctrl.current.bonus" name="bonus" ng-if="$ctrl.logic.getVisibility($ctrl.current, 'bonusPercent')" label="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.bonusPercent" unit="percent"></salaxy-input-number>
              <div ng-if="$ctrl.logic.getVisibility($ctrl.current, 'accruesHolidays')">
                <salaxy-input-enum required name="wageBasis" ng-model="$ctrl.current.wageBasis" label="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.label.wageBasis" enum="WageBasis" hidden-options="undefined,other"></salaxy-input-enum>
                <salaxy-input-enum name="holidayPayCalculation" ng-model="$ctrl.current.holidayPayCalculation" label="SALAXY.MODEL.HolidaySpecificationForYear.holidayPayCalculation.title" options="$ctrl.logic.getholidayPayCalculationOptions($ctrl.current)" required disable-cache="true"></salaxy-input-enum>

                <salaxy-input-number ng-model="$ctrl.current.compensation" name="compensation" ng-if="($ctrl.current.code == 'temporaryTimeOff' || $ctrl.current.code == 'other')  && $ctrl.current.holidayPayCalculation == 'holidayCompensation'" unit="percent" required label="SALAXY.MODEL.HolidaySpecificationForYear.compensation.title" ></salaxy-input-number>
                <salaxy-input-number ng-model="$ctrl.current.holidayPayPercent" name="holidayPayPercent" ng-if="($ctrl.current.code == 'permanent35Hours' || $ctrl.current.code == 'other') && $ctrl.current.holidayPayCalculation == 'percentageBasedPay'" required unit="percent" label="SALAXY.MODEL.HolidaySpecificationForYear.holidayPayPercent.title" ></salaxy-input-number>
              
                <salaxy-form-group label="SALAXY.MODEL.HolidaySpecificationForYear.employmentPeriod.title" name="contract">
                  <salaxy-datepicker-popup require="true" name="startDate" label="SALAXY.NG1.WorkerWizardComponent.employment.group.startDate" ng-model="$ctrl.current.employmentPeriod.start"></salaxy-datepicker-popup>
                  <salaxy-datepicker-popup name="endDate" label="SALAXY.NG1.WorkerWizardComponent.employment.group.endDate" ng-model="$ctrl.current.employmentPeriod.end"></salaxy-datepicker-popup>
                </salaxy-form-group>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="submit" class="btn btn-primary float-end" ng-disabled="holidayForm.$invalid" ng-click="$close('ok')" sxy-text="SALAXY.NG1.WorkerHolidaysComponent.InitDialog.submitButtonText"></button>
        <button type="button" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.cancel"></button>
      </div>
    </div>
  </form>
</div>`), s.put("salaxy-components/worker/HourlyReportEditDialog.html", `<div class="salaxy-component salaxy-timer-dialog">
  <div>
    <div class="modal-header">
      <h2 sxy-text="Muokkaa tuntikirjausta"></h2>
      <button type="button" class="btn-close" ng-click="$dismiss()" aria-label="Close"></button>
    </div>
    <div class="modal-body">
      <form class="form-horizontal">
        <div class="row">
          <div class="col-sm-6 col-12">
            <salaxy-input-typeahead ng-if="$ctrl.logic.costAccountingSettings" label-format="text-value" name="options_project" ng-model="$ctrl.current.contentData.project" options="$ctrl.logic.costAccountingSettings.options" label="{{($ctrl.logic.costAccountingSettings.label || 'SALAXY.NG1.CalcCostAccountingComponent.defaultLabel') | sxyTranslate}}" required="true"></salaxy-input-typeahead>
          </div>
          <div class="col-sm-6 col-12">
            <salaxy-input name="message" ng-model="$ctrl.current.contentData.projectText" label="Kommentti"></salaxy-input>
          </div>
          <div class="col-sm-6 col-12">
            <salaxy-input-time name="startTime" label="Työaika" type="minutes" ng-model="$ctrl.current.contentData.totalTime"></salaxy-input-time>
          </div>
          <div class="col-sm-6 col-12">
            <salaxy-input-number label="Työaika" type="slider" name="slider" minimum="10" maximum="720" slider-step="5" ng-model="$ctrl.current.contentData.totalTime"></salaxy-input-number>
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.NG1.AbsencePeriodsEditDialog.cancelButtonText"></button>
      <button type="submit" class="btn btn-primary" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.ok"></button>

      <button type="button" class="btn btn-danger float-start" ng-click="$close('delete')" sxy-text="SALAXY.NG1.AbsencePeriodsEditDialog.deleteButtonText"></button>
    </div>
  </div>
</div>`), s.put("salaxy-components/worker/taxcard/EmploymentTaxcards.html", `\uFEFF<div class="salaxy-component salaxy-employment-taxcards">
  <div ng-if="!$ctrl.current">
    <div class="alert alert-warning" ng-if="!$ctrl.employmentId">
      <p sxy-text="SALAXY.NG1.WorkerTaxCardsComponent.instruction"></p>
    </div>
    <salaxy-spinner ng-if="$ctrl.employmentId"></salaxy-spinner>
  </div>
  <div ng-if="$ctrl.current">
    <div class="alert alert-warning" ng-if="!$ctrl.current.personalId">
      <p sxy-text="SALAXY.NG1.WorkerTaxCardsComponent.error"></p>
    </div>
    <div ng-if="$ctrl.mode != 'list'">
      <salaxy-tab-buttons
        current-tab="$ctrl.currentTab"
        options="[
          { value: 'taxcarddetails', text: 'SALAXY.NG1.WorkerDetailsComponent.currentTaxCard' },
          { value: 'taxcardcalcs', text: 'SALAXY.NG1_PagesPersonal.taxcards.calcsPaidForCardTabHeading', hidden: !$ctrl.current.active },
        ]"
        tabs-id="employmentTaxcards">
      </salaxy-tab-buttons>
      <div class="tab-content" id="tab-content-employmentTaxcards">
        <div class="tab-pane" id="taxcarddetails-tab">
          <salaxy-taxcard-details model="$ctrl.current.active" ng-ref="$ctrl.$active" personal-id="$ctrl.current.personalId" on-save="$ctrl.reload();$ctrl.onSave()" hide-buttons="$ctrl.hideButtons" employment-relation-taxcard-type="$ctrl.current.employmentTaxcard"></salaxy-taxcard-details>
        </div>
        <div class="tab-pane" id="taxcardcalcs-tab" ng-if="$ctrl.current.active">
          <div class="alert alert-info" ng-if="$ctrl.$incomeLog.hasDiff">
            <button type="button" class="btn btn-primary float-end" ng-click="$ctrl.$active.commitDiff()" sxy-text="SALAXY.NG1.EmploymentTaxcardsComponent.taxCardIncomeLog.addSalaries"></button>
            <span sxy-text="SALAXY.NG1.EmploymentTaxcardsComponent.taxCardIncomeLog.addSalariesToTaxCard" params="{validity: ($ctrl.current.active.card.validity | sxyDateRange)}">
            </span>
          </div>
          <salaxy-taxcard-income-log parent="$ctrl.current.active" editable="false" ng-ref="$ctrl.$incomeLog"></salaxy-taxcard-income-log>
          <div class="text-end">
            <button type="button" class="btn btn-default btn-xs" ng-click="$ctrl.editIncomeLog()" sxy-text="SALAXY.NG1.CurrentTaxCardComponent.edit"></button>
          </div>
        </div>
      </div>
    </div>
    <div class="row form-horizontal" sxy-if-role="test">
      <div class="col-8">
        <salaxy-datepicker-popup name="today" ng-model="$ctrl.today" label="Maksupäivän testaus" ng-change=""></salaxy-datepicker-popup>
      </div>
      <div class="col-4">
        <button type="button" class="btn btn-primary" ng-click="$ctrl.reload()">Vaihda (TEST)</button>
      </div>
    </div>
    <div ng-if="$ctrl.mode != 'active' && $ctrl.list.length > 0">
      <h3 ng-if="$ctrl.mode != 'list'" sxy-text="SALAXY.NG1.WorkerDetailsComponent.historyTaxCard"></h3>
      <div class="table-responsive">
        <table class="table table-striped">
          <thead>
            <tr>
              <th class="th-xxs">
                <span sxy-text="SALAXY.NG1.WorkerTaxCardsComponent.type"></span>
                <span class="d-inline d-md-none" sxy-text="SALAXY.NG1.WorkerDetailsComponent.taxPercent"></span>
                <span class="d-inline d-md-none" sxy-text="SALAXY.NG1.WorkerTaxCardsComponent.percentAfterIncomeLimit"></span>
              </th>
              <th class="d-none d-md-table-cell" sxy-text="SALAXY.NG1.WorkerDetailsComponent.year"></th>
              <th class="d-none d-md-table-cell tax-percentage right" sxy-text="SALAXY.NG1.WorkerDetailsComponent.taxPercent"></th>
              <th class="th-xxs salaries-paid right">
                <span sxy-text="SALAXY.NG1.CurrentTaxCardComponent.salariesPaid"></span>
                <span class="d-inline d-md-none" sxy-text="SALAXY.NG1.CurrentTaxCardComponent.incomeLimit"></span>
              </th>
              <th class="d-none d-md-table-cell income-limit right">
                <span sxy-text="SALAXY.NG1.WorkerTaxCardsComponent.incomeLimit"></span><br /><span sxy-text="SALAXY.NG1.WorkerTaxCardsComponent.incomeLimitSpan"></span>

              </th>
              <th class="th-xxs right" sxy-html="SALAXY.NG1.WorkerDetailsComponent.validHtml"></th>
              <th></th>
              <th sxy-if-role="test,admin"></th>
            </tr>
          </thead>
          <tbody>
            <tr ng-repeat="taxCard in $ctrl.list">
              <td>
                <span class="d-inline d-md-none">
                  <i>{{ "TaxcardKind." + taxCard.data.kind | sxyEnum }} {{ taxCard.data.forYear }}</i>
                  {{taxCard.data.taxPercent}} %
                  <span ng-if="taxCard.data.taxPercent2 != null">({{ taxCard.data.taxPercent2 }} %)</span>
                </span>
                <span class="d-none d-md-table-cell">
                  <b>{{ "TaxcardKind." + taxCard.data.kind | sxyEnum }}</b>
                </span>
              </td>
              <td class="d-none d-md-table-cell">{{ taxCard.data.forYear }}</td>
              <td class="d-none d-md-table-cell tax-percentage right">{{taxCard.data.taxPercent}} %</td>
              <td class="salaries-paid right">
                {{ taxCard.data.totalIncome | currency: ' €' : 0 }}
                <span class="d-inline d-md-none">{{(taxCard.data.incomeLimit | currency: ' €' : 0) || '-'}}</span>
              </td>
              <td class="d-none d-md-table-cell income-limit right">
                {{(taxCard.data.incomeLimit | currency: '€' : 0) || '-'}}<br />
                <span>{{taxCard.data.taxPercent2 != null ? (taxCard.data.taxPercent2 + ' %') : '-'}}</span>
              </td>
              <td class="right">
                {{ taxCard.data | sxyDateRange }}<br /> {{ taxCard.createdAt | sxyDate }}
              </td>
              <td class="middle text-center">
                <span ng-if="!taxCard.isReadOnly && !$ctrl.hideButtons">
                  <button class="btn btn-danger btn-sm" ng-click="$ctrl.deleteTaxCard(taxCard.id)">
                    <span class="d-none d-sm-inline" sxy-text="SALAXY.UI_Terms.delete"></span>
                    <span class="d-inline d-sm-none">&times;</span>
                  </button>
                </span>
              </td>
              <td class="middle text-center" sxy-if-role="test,admin,pro">
                <a type="button" class="edit btn btn-sm btn-default" href="#/taxcards/details/{{taxCard.id}}"><i class="bi bi-pencil-square"></i></a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>`), s.put("salaxy-components/worker/taxcard/TaxcardDetails.html", `<div class="salaxy-component salaxy-taxcard-details">

  <form name="editForm">
    <div ng-show="false" ng-init="$ctrl.editForm = editForm"></div>
    <!-- TODO: See if this is in use in pro. It is probably in use in Admin. -->
    <div ng-if="$ctrl.getMode() == 'pro'" ng-include="'salaxy-components/worker/taxcard/TaxcardDetails_Pro.html'"></div>
    <div ng-if="$ctrl.getMode() == 'new'" class="alert alert-danger">
      <h3>Error: Disabled</h3>
      <p>Adding a new taxcard in details view is diabled.</p>
    </div>
    <div ng-if="$ctrl.getMode() == 'default'" ng-include="'salaxy-components/worker/taxcard/TaxcardDetails_Info.html'"></div>
    <div ng-if="$ctrl.getMode() == 'null'" class="salaxy-placeholder-empty placeholder-md text-center">
      <div ng-if="$ctrl.employmentRelationTaxcardType != 'auto'">
        <h4 sxy-text="SALAXY.NG1.CurrentTaxCardComponent.noTaxCardAddedWorker" ng-if="$ctrl.employmentId == 'self'"></h4>
        <h4 sxy-text="SALAXY.NG1.CurrentTaxCardComponent.noTaxCardAdded" ng-if="$ctrl.employmentId != 'self'"></h4>
        <button class="btn btn-primary" ng-if="!$ctrl.hideButtons" ng-disabled="$ctrl.loaders['showAddNew']" ng-click="$ctrl.showAddNew()" sxy-text="SALAXY.NG1.CurrentTaxCardComponent.addTaxCard"></button>
      </div>
      <div ng-if="$ctrl.employmentRelationTaxcardType == 'auto'">
        <button class="btn btn-primary" ng-if="!$ctrl.hideButtons" ng-disabled="$ctrl.loaders['showSetAuto']" ng-click="$ctrl.setAuto()" sxy-text="SALAXY.NG1.CurrentTaxCardComponent.searchTaxCard"></button>  
      </div>
    </div>
    <div ng-if="$ctrl.getMode() == 'no-personal-id'" class="alert alert-danger" sxy-text="SALAXY.NG1.CurrentTaxCardComponent.noPersonalIdError"></div>
  </form>
</div>`), s.put("salaxy-components/worker/taxcard/TaxcardDetails_Info.html", `<div>
  <div ng-if="$ctrl.isTaxCardExpired($ctrl.current)" class="salaxy-placeholder-empty placeholder-md placeholder-danger text-center">
    <h4 sxy-text="SALAXY.NG1.CurrentTaxCardComponent.taxCardExpired"></h4>
    <button class="btn btn-primary" ng-if="!$ctrl.hideButtons" ng-disabled="$ctrl.loaders['showAddNew']" ng-click="$ctrl.showAddNew()"
      sxy-text="SALAXY.NG1.CurrentTaxCardComponent.newTaxCard"></button>
  </div>
  <div class="row">

    <div class="col-md-7 col-lg-7" ng-switch="$ctrl.chartType">
      <div ng-switch-when="full" class="salaxy-tax-card-chart chart-container">    
          <salaxy-chart custom-height="400px" config="$ctrl.getMainChartConfig($ctrl.current)"></salaxy-chart>
      </div>

      <div ng-switch-when="pie" class="salaxy-tax-card-chart chart-container text-center">      
          <salaxy-chart style="height: 400px; position: relative;" config="$ctrl.getPieChartConfig($ctrl.current)"></salaxy-chart>
      </div>
    </div>
    <div class="col-md-5 col-lg-5">
      <div class="row current-taxcard-row table-row">
        <div class="col-12">
          <div class="btn-group float-end">
            <a ng-if="$ctrl.getTaxcardPreviewUrl($ctrl.current)" ng-href="{{$ctrl.getTaxcardPreviewUrl($ctrl.current)}}" target="_blank" class="btn btn-xs btn-default"
              sxy-text="SALAXY.UI_Terms.open"></a>
            <a ng-if="$ctrl.getTaxcardDownloadUrl($ctrl.current)" ng-href="{{$ctrl.getTaxcardDownloadUrl($ctrl.current)}}" target="_blank" class="btn btn-xs btn-default"
              sxy-text="SALAXY.UI_Terms.download"></a>
          </div>
          <strong sxy-text="SALAXY.NG1.CurrentTaxCardComponent.taxCardKind"></strong><br /> {{ 'TaxcardKind.' + $ctrl.current.card.kind | sxyEnum }}
          ({{$ctrl.current.card.forYear}})
        </div>
      </div>
      <div class="row current-taxcard-row table-row">
        <div class="col-8">
          <strong sxy-text="SALAXY.NG1.CurrentTaxCardComponent.validDate"></strong><br /> {{$ctrl.current.card.validity.start | date}} - {{$ctrl.current.card.validity.end | date}}
        </div>
        <div class="col-4 text-end">
          <strong sxy-text="SALAXY.NG1.CurrentTaxCardComponent.taxCardAdded"></strong><br />
          <span title="{{ $ctrl.current.createdAt | date : 'short' }}">{{ $ctrl.current.createdAt | sxyDate }}</span>
        </div>
      </div>
      <table class="table table-sm" style="margin-bottom: 0; margin-top: 6px">
        <thead>
          <tr>
            <th colspan="2" style="padding-left: 0;"><span sxy-text="SALAXY.NG1.CurrentTaxCardComponent.mainTaxPercent2"></span></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td sxy-text="SALAXY.NG1.CurrentTaxCardComponent.basicPercent"></td>
            <td class="right">{{ $ctrl.current.card.taxPercent }} %</td>
          </tr>
          <tr ng-if="!$ctrl.current.card.incomeLimit">
            <td colspan="2"><span sxy-text="SALAXY.NG1.CurrentTaxCardComponent.noIncomeLimit"></span></td>
          </tr>
          <tr ng-if="$ctrl.current.card.incomeLimit">
            <td><span sxy-text="SALAXY.NG1.CurrentTaxCardComponent.taxPercent2.name"></span> <small>(tulorajan {{ $ctrl.current.card.incomeLimit | currency : '€' : 0 }}
                {{'SALAXY.NG1.CurrentTaxCardComponent.after' | sxyTranslate}})</small></td>
            <td class="right">{{ $ctrl.current.card.taxPercent2 || "-" }} %</td>
          </tr>
          <tr>
            <td>
              <span sxy-text="SALAXY.NG1.CurrentTaxCardComponent.taxPercentMin.title"></span>
              <button
                ng-if="$ctrl.current.card.kind == 'auto' && ( $ctrl.current.card.state == 'shared' || $ctrl.current.card.state == 'employerAdded' || $ctrl.current.card.state == 'verifiedVero' || $ctrl.current.card.state == 'sharedApproved')"
                type="button" class="btn btn-default btn-xs" ng-click="$ctrl.editTaxPercentMin()" sxy-text="SALAXY.NG1.CurrentTaxCardComponent.edit"></button>
            </td>
            <td class="right">
              <span>{{ $ctrl.current.card.taxPercentMin || "-" }} %</span>
            </td>
          </tr>
          <tr ng-if="$ctrl.current.card.kind == 'auto'">
            <td colspan="2">
              <span class="text-info" ng-if="$ctrl.current.card.lastChecked != '2000-01-01T00:00:00Z'"><small>{{'SALAXY.NG1.CurrentTaxCardComponent.taxCardChecked' | sxyTranslate}}
                  {{$ctrl.current.card.lastChecked | date: "dd.MM.yyyy HH:mm"}}</small></span>
              <br />
              <button type="button" ng-disabled="$ctrl.loaders['showRefreshAutoTaxcardDialog']" ng-click="$ctrl.showRefreshAutoTaxcardDialog()"
                class="btn btn-info">{{'SALAXY.NG1.CurrentTaxCardComponent.checkAutomaticTaxCard' | sxyTranslate}}</button>
            </td>
          </tr>
          <tr ng-if="$ctrl.current.card.kind != 'auto'">
            <td colspan="2">
              <button class="btn btn-primary" ng-if="!$ctrl.isTaxCardExpired($ctrl.current) && !$ctrl.hideButtons" ng-disabled="$ctrl.loaders['showAddNew']"
                ng-click="$ctrl.showAddNew()" sxy-text="SALAXY.NG1.CurrentTaxCardComponent.newTaxCard"></button>
            </td>
          </tr>
        </tbody>
      </table>
      <table class="table table-sm" style="margin-top: 6px" ng-if="$ctrl.current.card.incomeLimit">
        <thead>
          <tr>
            <th colspan="2" style="padding-left: 0;"><strong sxy-text="SALAXY.NG1.CurrentTaxCardComponent.incomeLimit"></strong></th>
            <th class="right">{{ $ctrl.current.card.incomeLimit | currency : '€' : 0 }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style="width: 20px;" class="text-center">-</td>
            <td>
              <span sxy-text="SALAXY.NG1.CurrentTaxCardComponent.salariesPaid"></span>
              <button type="button" class="btn btn-default btn-xs" ng-click="$ctrl.editIncomeLog()" sxy-text="SALAXY.NG1.CurrentTaxCardComponent.edit"></button>
            </td>
            <td class="right">{{ $ctrl.current.result.totalIncome | currency }}</td>
          </tr>
          <tr ng-if="$ctrl.current.result.totalIncomeJanuary">
            <td></td>
            <td>...<span sxy-text="SALAXY.NG1.CurrentTaxCardComponent.inJanuary"></span></td>
            <td class="right">{{ $ctrl.current.result.totalIncomeJanuary | currency }}</td>
          </tr>
          <tr>
            <td></td>
            <td><span sxy-text="SALAXY.NG1.CurrentTaxCardComponent.inPalkkaus"></span></td>
            <td class="right">{{ $ctrl.current.result.payment | currency }}</td>
          </tr>
          <tr ng-if="$ctrl.current.result.paymentJanuary">
            <td></td>
            <td>...<span sxy-text="SALAXY.NG1.CurrentTaxCardComponent.inJanuary"></span></td>
            <td class="right">{{ $ctrl.current.result.paymentJanuary | currency }}</td>
          </tr>
          <tr class="total">
            <td colspan="2"><span sxy-text="SALAXY.NG1.CurrentTaxCardComponent.beforeIncomeLimit"></span></td>
            <td class="right">{{ $ctrl.current.card.incomeLimit - $ctrl.current.result.totalIncome | currency }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>`), s.put("salaxy-components/worker/taxcard/TaxcardDetails_Pro.html", `<div class="salaxy-calc-worker-info row" ng-if="$ctrl.status !== 'initialLoading'">
  <div class="col-3 col-sm-2 col-xxs-3 ">
    <salaxy-avatar avatar="$ctrl.current.worker"></salaxy-avatar>
  </div>
  <div class="col-9 col-sm-10 col-xxs-9 worker-info-col">
    <button class="btn btn-primary float-end" ng-click="$ctrl.save()" ng-disabled="!$ctrl.hasChanges" sxy-text="SALAXY.UI_Terms.save"></button>
    <button class="btn btn-default float-end" ng-disabled="$ctrl.loaders['showAddNew']" ng-click="$ctrl.showAddNew()" sxy-text="SALAXY.NG1.CurrentTaxCardComponent.newTaxCard"></button>
    <h2>{{ $ctrl.current.worker.displayName || ('SALAXY.NG1.WorkerInfo.noSelection'| sxyTranslate) }}</h2>
    <div class="row">
      <div class="col-12 col-sm-6 ">
        <span ng-if="!$ctrl.current.card.personalId" sxy-text="SALAXY.NG1.PaymentDialogComponent.noSSNumber" class="text-danger"></span>
        <span ng-if="$ctrl.current.card.personalId">{{ $ctrl.current.card.personalId }}</span>
      </div>
    </div>
  </div>
</div>
<hr />
<div ng-if="$ctrl.current">
  <div class="row">
    <div class="col-sm-6">
      <div class="form-horizontal">
        <salaxy-input-enum disabled="true" label="SALAXY.NG1.WorkerDetailsComponent.taxCard.cardType" ng-required="true" name="kind" enum="TaxcardKind" ng-model="$ctrl.current.card.kind">
        </salaxy-input-enum>
        <salaxy-input-number disabled="$ctrl.current.card.kind == 'auto'" label="SALAXY.NG1.CurrentTaxCardComponent.taxCards.year" name="year" ng-model="$ctrl.current.card.forYear" require="true"></salaxy-input-number>
        <salaxy-datepicker-popup disabled="$ctrl.current.card.kind == 'auto'" name="validityStart" ng-model="$ctrl.current.card.validity.start" require="true" label="SALAXY.NG1.CurrentTaxCardComponent.validFromDate2">
        </salaxy-datepicker-popup>
        <salaxy-datepicker-popup disabled="$ctrl.current.card.kind == 'auto'" name="validityEnd" ng-model="$ctrl.current.card.validity.end" require="true" label="SALAXY.NG1.CurrentTaxCardComponent.validTillDate"></salaxy-datepicker-popup>
        <salaxy-input-number disabled="$ctrl.current.card.kind == 'auto'" label="SALAXY.NG1.CurrentTaxCardComponent.mainTaxPercent" name="taxPercent" ng-model="$ctrl.current.card.taxPercent" require="true" sxy-tax-percent></salaxy-input-number>
        <salaxy-input-number disabled="$ctrl.current.card.kind == 'auto'" name="incomeLimit" label="SALAXY.NG1.CurrentTaxCardComponent.incomeLimit2" ng-model="$ctrl.current.card.incomeLimit" sxy-currency></salaxy-input-number>
        <salaxy-input-number disabled="$ctrl.current.card.kind == 'auto'" name="taxPercent2" label="SALAXY.NG1.CurrentTaxCardComponent.taxPercent2.name" ng-model="$ctrl.current.card.taxPercent2" sxy-tax-percent></salaxy-input-number>
        <div class="row" ng-if="$ctrl.current.card.kind != 'auto'">
          <div class="col-12">
            <div class="float-end">
              <a ng-href="{{ $ctrl.getTaxcardDownloadUrl($ctrl.current) }}" ng-if="$ctrl.getTaxcardDownloadUrl($ctrl.current)" target="_blank" sxy-text="SALAXY.UI_Terms.download"></a>
            </div>
            <legend style="text-align:left" sxy-text="SALAXY.NG1.CurrentTaxCardComponent.taxCardAsFile"></legend>
            <div ng-include="'salaxy-components/worker/taxcard/TaxcardDetails_Upload.html'"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-6">
      <div class="alert alert-info" ng-if="$ctrl.$incomeLog.hasDiff">
        <button type="button" class="btn btn-primary float-end" ng-click="$ctrl.commitDiff()" sxy-text="SALAXY.NG1.CurrentTaxCardComponent.commitDiffBtn"></button>
        <span sxy-text="SALAXY.NG1.CurrentTaxCardComponent.commitDiffNote"></span>
      </div>
      <salaxy-taxcard-income-log parent="$ctrl.current" editable="false" ng-ref="$ctrl.$incomeLog"></salaxy-taxcard-income-log>
      <div class="text-end">
        <button type="button" class="btn btn-default btn-xs" ng-click="$ctrl.editIncomeLog()" sxy-text="SALAXY.NG1.CurrentTaxCardComponent.edit"></button>
      </div>
    </div>
  </div>
</div>`), s.put("salaxy-components/worker/taxcard/TaxcardDetails_Upload.html", `<div name="taxCardFile" ng-model="taxCardFile" ngf-drop="$ctrl.uploadTaxCard($file)" 
  ngf-select="$ctrl.uploadTaxCard($file)" class="salaxy-drop-box" ngf-drag-over-class="'salaxy-drag-over'" 
  ngf-multiple="false" ngf-min-size="5KB" ngf-max-size="10MB"
  ngf-pattern="'image/*,application/pdf'" ngf-model-invalid="invalidFile" ng-class="invalidFile.$error != null ? 'error' : ''"
  ng-required="$ctrl.addNewUi.upload == 'required'">
  <span ng-if="$ctrl.uploadProgress && $ctrl.uploadProgress != 100">
    <span sxy-text="SALAXY.NG1.CurrentTaxCardComponent.loading"></span> {{ $ctrl.uploadProgress }}% {{'SALAXY.NG1.CurrentTaxCardComponent.taxCards.taxCardDetails.downloaded' | sxyTranslate}}
  </span>
  <span ng-if="$ctrl.uploadProgress == 100" sxy-text="SALAXY.NG1.CurrentTaxCardComponent.progressPreview"></span>
  <span class="text-danger" ng-if="$ctrl.getInvalidFileDescription(invalidFile)">{{$ctrl.getInvalidFileDescription(invalidFile)}}</span>
  <span ng-if="!$ctrl.uploadProgress && !$ctrl.current.card.fileUri" sxy-html="SALAXY.NG1.CurrentTaxCardComponent.uploadTaxCard.html"></span>
  <span ng-if="!$ctrl.uploadProgress && $ctrl.current.card.fileUri">
    <img class="img-responsive" ng-src="{{$ctrl.getUploadPreviewUrl($ctrl.current)}}" />
  </span>
</div>`), s.put("salaxy-components/worker/taxcard/TaxcardIncomeLog.html", `<div class="salaxy-component salaxy-taxcard-income-log">
  <table class="table table-sm">
    <thead>
      <tr>
        <th>
          <strong sxy-text="SALAXY.NG1.TaxCardIncomeLogComponent.addedForTaxCard"></strong><br />
          <span sxy-text="SALAXY.NG1.TaxCardIncomeLogComponent.salaryPeriod"></span>
        </th>
        <th class="right">
          <strong sxy-text="SALAXY.NG1.TaxCardIncomeLogComponent.mainTaxPercent"></strong><br />
          <span sxy-text="SALAXY.NG1.TaxCardIncomeLogComponent.salaryAmount"></span>
        </th>
        <th ng-if="$ctrl.editable" style="width: 20px;"></th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="row in $ctrl.list" class="" ng-style="row.diff == 'removed' ? 'text-decoration: line-through' : ''" ng-class="{ 'success': row.diff == 'new', 'text-primary': row.diff == 'changed', 'text-danger': row.diff == 'removed' }">
        <td>
          <strong>
            <span ng-if="row.id && row.diff != 'removed'" sxy-text="SALAXY.NG1.TaxCardIncomeLogComponent.calculation"></span>
            <span ng-if="row.id && row.diff == 'removed'" sxy-text="SALAXY.NG1.TaxCardIncomeLogComponent.removedCalc"></span>
            <span ng-if="!row.id">{{ "TaxCardIncomeType." + row.type | sxyEnum }}</span ng-if="row.id">
            {{ row.paidAt | sxyDate }}
            <button ng-if="row.diff == 'new'"
              type="button" 
              class="btn btn-xs btn-success" 
              data-bs-toggle="popover" 
              data-bs-html="true" 
              data-bs-title="Info" 
              data-bs-content="'SALAXY.NG1.TaxCardIncomeLogComponent.newCalcPopover'| sxyTranslate" 
              data-bs-trigger="hover"
              sxy-text="SALAXY.NG1.TaxCardIncomeLogComponent.newCalcBtn" 
              sxy-bs5-popover></button>

            <button ng-if="row.diff == 'changed' && row.type != 'diff'" 
              type="button" 
              class="btn btn-xs btn-primary"
              data-bs-toggle="popover" 
              data-bs-html="true" 
              data-bs-title="Info"
              data-bs-content="'SALAXY.NG1.TaxCardIncomeLogComponent.taxCardChangedPopover'| sxyTranslate" 
              data-bs-trigger="hover" 
              sxy-text="SALAXY.NG1.TaxCardIncomeLogComponent.taxCardChangedBtn" 
              sxy-bs5-popover></button>

            <button ng-if="row.diff == 'changed' && row.type == 'diff'" 
              type="button" 
              class="btn btn-xs btn-primary"
              data-bs-toggle="popover" 
              data-bs-html="true" 
              data-bs-title="'Info'"  
              data-bs-content="'SALAXY.NG1.TaxCardIncomeLogComponent.calcChangedPopover'| sxyTranslate"
              data-bs-trigger="hover" 
              sxy-text="SALAXY.NG1.TaxCardIncomeLogComponent.calcChangedBtn"
              sxy-bs5-popover></button>

            <button ng-if="row.diff == 'removed'" 
              type="button" 
              class="btn btn-xs btn-danger" 
              data-bs-toggle="popover" 
              data-bs-html="true" 
              data-bs-title="'Info'" 
              data-bs-content="'SALAXY.NG1.TaxCardIncomeLogComponent.calcRemovedPopover'| sxyTranslate" 
              data-bs-trigger="hover" 
              sxy-text="SALAXY.NG1.TaxCardIncomeLogComponent.calcRemovedBtn"
              sxy-bs5-popover></button>
          </strong><br />
          <div class="float-start" style="padding: 0px;">
            {{ { start: row.startDate, end: row.endDate } | sxyDateRange }}
          </div>
          <div class="truncate" style="max-width: 250px; padding: 0px;">
            &nbsp;{{ row.description }}
          </div>
        </td>
        <td class="right">
          <strong>{{ row.tax ? (row.tax | currency) : "-" }}</strong><br /> {{ row.income | currency }}
        </td>
        <td ng-if="$ctrl.editable" style="width: 20px;">
          <button type="button" class="btn btn-default" ng-if="!$ctrl.isReadOnly(row)" ng-click="$ctrl.showEditDialog(row)"><i class="bi bi-pencil-square"></i></button>
        </td>
      </tr>
      <tr ng-if="!($ctrl.list.length > 0)">
        <td colspan="2">
          <h3 sxy-text="SALAXY.NG1.TaxCardIncomeLogComponent.noCalcsTitle"></h3>
          <p sxy-text="SALAXY.NG1.TaxCardIncomeLogComponent.noCalcsDescription"></p>
        </td>
      </tr>
      <tr class="total">
        <td>
          <strong>
         <span sxy-text="SALAXY.NG1.TaxCardIncomeLogComponent.totalTaxes"></span> <br />
            <span sxy-text="SALAXY.NG1.TaxCardIncomeLogComponent.totalIncome"></span>
          </strong>
        </td>
        <td class="right">
          <strong>
            {{ $ctrl.getSum("tax") | currency }}<br />
            {{ $ctrl.getSum("income") | currency }}
          </strong>
        </td>
        <td ng-if="$ctrl.editable" style="width: 20px;"></td>
      </tr>
    </tbody>
  </table>
  <div class="text-end" ng-if="$ctrl.editable">
    <button type="button" class="btn btn-default" ng-click="$ctrl.showEditDialog('new')" sxy-text="SALAXY.NG1.EmploymentTaxcardsComponent.taxCardIncomeLog.addElseWherePaidSalary"></button>
  </div>
</div>`), s.put("salaxy-components/worker/taxcard/TaxcardIncomeLogEditDialog.html", `<div class="card card-primary">
  <div class="card-header ">
    <h2 sxy-text="SALAXY.NG1.TaxCardIncomeLogEditDialogComponent.title"></h2>
    <button type="button" class="btn-close" ng-click="$dismiss()" aria-label="Close"></button>
  </div>
  <div class="card-body">
    <form class="form-horizontal">
      <fieldset>
        <legend>Tulorajaan vaikuttavat tiedot</legend>
        <salaxy-input-enum name="causeCode" ng-model="$ctrl.current.type" read-only="true" enum="TaxCardIncomeType" filter="externalSalaries" label="SALAXY.NG1.TaxCardIncomeLogEditDialogComponent.incomeType" type="select"></salaxy-input-enum>
        <salaxy-datepicker-popup name="paidAt" ng-model="$ctrl.current.paidAt" label="SALAXY.NG1.TaxCardIncomeLogEditDialogComponent.paymentDate"></salaxy-datepicker-popup>
        <salaxy-input-number name="income" label="SALAXY.NG1.TaxCardIncomeLogEditDialogComponent.taxableIncome" ng-model="$ctrl.current.income"></salaxy-input-number>
      </fieldset>
      <fieldset>
        <legend>Lisätiedot</legend>
        <salaxy-datepicker-popup name="startDate" ng-model="$ctrl.current.startDate" label="SALAXY.NG1.TaxCardIncomeLogEditDialogComponent.periodStart"></salaxy-datepicker-popup>
        <salaxy-datepicker-popup name="endDate" ng-model="$ctrl.current.endDate" label="SALAXY.NG1.TaxCardIncomeLogEditDialogComponent.periodEnd"></salaxy-datepicker-popup>
        <salaxy-input-number name="tax" label="SALAXY.NG1.TaxCardIncomeLogEditDialogComponent.tax" ng-model="$ctrl.current.tax"></salaxy-input-number>
        <salaxy-input name="description" label="SALAXY.NG1.TaxCardIncomeLogEditDialogComponent.notes" ng-model="$ctrl.current.description"></salaxy-input>
        <salaxy-input name="id" read-only="true" label="SALAXY.NG1.TaxCardIncomeLogEditDialogComponent.calcId" ng-model="$ctrl.current.id"></salaxy-input>
      </fieldset>
      <div>
        <button type="submit" class="btn btn-primary float-end" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.ok"></button>
        <button type="reset" class="btn btn-default float-end" ng-click="$close('cancel')" sxy-text="SALAXY.NG1.AbsencePeriodsEditDialog.cancelButtonText"></button>
        <button type="button" class="btn btn-danger" ng-click="$close('delete')" sxy-text="SALAXY.NG1.AbsencePeriodsEditDialog.deleteButtonText"></button>
      </div>
    </form>
  </div>
</div>`), s.put("salaxy-components/worker/taxcard/TaxcardList.html", `<div class="salaxy-component salaxy-taxcard-list">
  <salaxy-odata-table select-mode="$ctrl.mode" url="/v03/api/taxcards"
    options="$ctrl.options"
    ng-if="$ctrl.mode == 'select' || $ctrl.mode == 'multiselect'"
    template-url="salaxy-components/odata/lists/Taxcards-select.html"
    items="$ctrl.items" selected-items="$ctrl.selectedItems"
    on-list-select="$ctrl.onListSelect({ value: value, item: item, allItems: allItems });"
    crud-controller="TaxcardCrudController as $crud"></salaxy-odata-table>
</div>`), s.put("salaxy-components/worker/taxcard/TaxcardManualEdit.html", `<div class="salaxy-component salaxy-manual-edit">
  <form name="editForm">
    <div ng-show="false" ng-init="$ctrl.editForm = editForm"></div>
    <div class="form-horizontal">
      <legend>
        <span sxy-text="SALAXY.NG1.CurrentTaxCardComponent.newTaxCardTitle"></span>
        <button class="btn btn-primary btn-xs float-end" sxy-if-role="test" ng-click="$ctrl.showToday=!$ctrl.showToday">test</button>
      </legend>
      <salaxy-datepicker-popup ng-if="$ctrl.showToday" name="todayTest" ng-model="$ctrl.today" ng-change="$ctrl.current.card.forYear = null;$ctrl.resetAsNew()" label-cols="col-sm-7"
        label="SALAXY.NG1.CurrentTaxCardComponent.taxCards.taxCardDetails.changeThisDate"></salaxy-datepicker-popup>
      <salaxy-input-enum label="SALAXY.NG1.CurrentTaxCardComponent.taxCardKind" label-cols="col-sm-7" require="true" name="verokortinTyyppi" enum="TaxcardKind"
        type="{{ (!$ctrl.current.card.kind || $ctrl.current.card.kind == 'undefined' || $ctrl.current.card.kind == 'auto') ? 'radio' : 'select' }}"
        ng-model="$ctrl.current.card.kind" ng-change="$ctrl.resetAsNew($ctrl.current.card.kind)" options="$ctrl.taxcardKindOptions"
        placeholder="SALAXY.NG1.CurrentTaxCardComponent.selectCardKind">
      </salaxy-input-enum>
      <p ng-if="$ctrl.current.card.kind == 'noTaxCard'" class="text-danger" style="margin-top:5px; margin-bottom:0;"
        sxy-text="SALAXY.NG1.CurrentTaxCardComponent.noTaxCard.description"></p>
      <p ng-if="$ctrl.current.card.kind == 'noWithholdingHousehold'" class="text-danger" style="margin-top:5px; margin-bottom:0;"
        sxy-text="SALAXY.NG1.CurrentTaxCardComponent.noWithholdingHousehold.description"></p>
      <salaxy-form-group label="SALAXY.NG1.CurrentTaxCardComponent.year" require="true" name="year" label-cols="col-sm-7" ng-if="$ctrl.addNewUi.yearsAllowed">
        <select class="form-select" ng-model="$ctrl.current.card.forYear" ng-options="i for i in $ctrl.addNewUi.yearsAllowed" ng-change="$ctrl.yearChanged()"></select>
      </salaxy-form-group>
      <salaxy-input label="SALAXY.NG1.CurrentTaxCardComponent.mainTaxPercent3" name="veroprosentti" label-cols="col-sm-7" ng-model="$ctrl.current.card.taxPercent"
        disabled="$ctrl.addNewUi.readonly" require="true" sxy-tax-percent ng-if="$ctrl.addNewUi.showTaxPercent"></salaxy-input>
      <salaxy-input name="tuloraja" label="SALAXY.NG1.CurrentTaxCardComponent.incomeLimit2" ng-model="$ctrl.current.card.incomeLimit" maxlength="10"
        ng-if="$ctrl.addNewUi.showIncomeLimit" label-cols="col-sm-7" require="$ctrl.addNewUi.requireIncomeLimit || $ctrl.current.card.taxPercent2" sxy-currency></salaxy-input>
      <salaxy-input name="lisaveroprosentti" label="SALAXY.NG1.CurrentTaxCardComponent.taxPercent2.name" label-cols="col-sm-7" ng-model="$ctrl.current.card.taxPercent2"
        ng-if="$ctrl.addNewUi.showIncomeLimit" require="$ctrl.addNewUi.requireIncomeLimit || $ctrl.current.card.incomeLimit" sxy-tax-percent></salaxy-input>
      <salaxy-form-group label-cols="col-sm-5" label="SALAXY.NG1.CurrentTaxCardComponent.validDate" name="validityStart" class="salaxy-read-only"
        ng-if="$ctrl.current.card.kind =='defaultYearly' || $ctrl.current.card.kind == 'replacement'">
        <div class="form-control-plaintext text-end">{{ $ctrl.current.card.validity.start | date : "dd.MM.yyyy" }} – {{ $ctrl.current.card.validity.end | date :
          "dd.MM.yyyy" }}</div>
      </salaxy-form-group>
      <salaxy-datepicker-popup name="voimaantuloPvm" ng-model="$ctrl.current.card.validity.start" ng-if="$ctrl.addNewUi.startDateOptions"
        min-date="$ctrl.addNewUi.startDateOptions.minDate" max-date="$ctrl.addNewUi.startDateOptions.maxDate" label-cols="col-sm-7" require="true"
        label="SALAXY.NG1.CurrentTaxCardComponent.validFromDate2"></salaxy-datepicker-popup>
      <salaxy-input name="previousSalariesRow" label="SALAXY.NG1.CurrentTaxCardComponent.previousSalariesForTaxCard.label" ng-model="$ctrl.previousSalariesRow.income"
        ng-if="$ctrl.addNewUi.showPreviousSalariesPaid" tooltip-html="{{'SALAXY.NG1.CurrentTaxCardComponent.previousSalariesForTaxCard.tooltip' | sxyTranslate}}"
        tooltip-placement="right" label-cols="col-sm-7" sxy-currency></salaxy-input>
    </div>
  </form>
</div>`), s.put("salaxy-components/worker/taxcard/TaxCardsList.html", `<div class="salaxy-component salaxy-tax-cards-list">
  <div class="row form-horizontal" sxy-if-role="test" ng-init="$ctrl.today = 'today'">
    <div class="col-6">
      <salaxy-datepicker-popup name="today" ng-model="$ctrl.today" label="SALAXY.NG1.CurrentTaxCardComponent.salaryDate"
        ng-change=""></salaxy-datepicker-popup>
    </div>
    <div class="col-6">
      <button type="button" class="btn btn-primary" 
        ng-click="$ctrl.$odata.setUrl('/v03/api/taxcards/current/' + $ctrl.today || 'null')" sxy-text="SALAXY.NG1.CurrentTaxCardComponent.changePaymentDate"></button>
    </div>
  </div>
  <salaxy-odata-table url="/v03/api/taxcards/current/null" crud-controller="TaxcardCrudController as $crud"
    ng-ref="$ctrl.$odata"
    template-url="salaxy-components/odata/lists/Taxcards.html"></salaxy-odata-table>
</div>`), s.put("salaxy-components/worker/TimerEditDialog.html", `<div class="salaxy-component salaxy-timer-dialog">
  <div>
    <div class="modal-header">
      <h2 sxy-text="Muokkaa kellokorttimerkintää"></h2>
      <button type="button" class="btn-close" ng-click="$dismiss()" aria-label="Close"></button>
    </div>
    <div class="modal-body">
      <form class="form-horizontal">
        <div class="row">
          <div class="col-sm-6 col-12">
            <salaxy-datepicker-popup name="start" ng-model="$ctrl.current.contentData.period.start" label="Aloituspäivä"></salaxy-datepicker-popup>
          </div>
          <div class="col-sm-6  col-12">
            <salaxy-input-time name="startTime" label="Alkoi" type="time" ng-model="$ctrl.current.contentData.startTime"></salaxy-input-time>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6  col-12">
            <salaxy-datepicker-popup name="start" ng-model="$ctrl.current.contentData.period.end" label="Lopetuspäivä"></salaxy-datepicker-popup>
          </div>
          <div class="col-sm-6  col-12">
            <salaxy-input-time name="endTime" label="Loppui" type="time" ng-model="$ctrl.current.contentData.endTime"></salaxy-input-time>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6 col-12">
            <salaxy-input-typeahead ng-if="$ctrl.logic.costAccountingSettings" label-format="text-value"
              name="options_project" ng-model="$ctrl.current.contentData.project" options="$ctrl.logic.costAccountingSettings.options"
              label="{{($ctrl.logic.costAccountingSettings.label || 'SALAXY.NG1.CalcCostAccountingComponent.defaultLabel') | sxyTranslate}}" required="true"></salaxy-input-typeahead>
          </div>
          <div class="col-sm-6 col-12">
            <salaxy-input label="Kommentti" placeholder="Kommentti"  name="comment" ng-model="$ctrl.current.contentData.projectText">
            </salaxy-input>
          </div>
        </div>
    </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.NG1.AbsencePeriodsEditDialog.cancelButtonText"></button>
    <button type="submit" class="btn btn-primary" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.ok"></button>

    <button type="button" class="btn btn-danger float-start" ng-click="$close('delete')" sxy-text="SALAXY.NG1.AbsencePeriodsEditDialog.deleteButtonText"></button>
  </div>
</div>
</div>`), s.put("salaxy-components/worker/TimeReportEditDialog.html", `<div class="salaxy-component salaxy-timer-dialog">
  <div>
    <div class="modal-header">
      <h2 sxy-text="Muokkaa aikakirjausta"></h2>
      <button type="button" class="btn-close" ng-click="$dismiss()" aria-label="Close"></button>
    </div>
    <div class="modal-body">
      <form class="form-horizontal">
        <div class="row">
          <div class="col-sm-6 col-12">
            <salaxy-input-typeahead ng-if="$ctrl.logic.costAccountingSettings" label-format="text-value" name="options_project" ng-model="$ctrl.current.contentData.project" options="$ctrl.logic.costAccountingSettings.options" label="{{($ctrl.logic.costAccountingSettings.label || 'SALAXY.NG1.CalcCostAccountingComponent.defaultLabel') | sxyTranslate}}" required="true"></salaxy-input-typeahead>
          </div>
          <div class="col-sm-6 col-12">
            <salaxy-input name="message" ng-model="$ctrl.current.contentData.projectText" label="Kommentti"></salaxy-input>
          </div>
          <div class="col-sm-6 col-12">
            <salaxy-input-time name="startTime" label="Aloitusaika" type="time" ng-model="$ctrl.current.contentData.startTime"></salaxy-input-time>
          </div>
          <div class="col-sm-6 col-12">
            <salaxy-input-time name="endTime" label="Lopetusaika" type="time" ng-model="$ctrl.current.contentData.endTime"></salaxy-input-time>
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="reset" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.NG1.AbsencePeriodsEditDialog.cancelButtonText"></button>
      <button type="submit" class="btn btn-primary" ng-click="$close('ok')" sxy-text="SALAXY.UI_Terms.ok"></button>

      <button type="button" class="btn btn-danger float-start" ng-click="$close('delete')" sxy-text="SALAXY.NG1.AbsencePeriodsEditDialog.deleteButtonText"></button>
    </div>
  </div>
</div>`), s.put("salaxy-components/worker/WorkerAbsences.html", `<div class="salaxy-component salaxy-worker-absences">
  <salaxy-spinner ng-if="$ctrl.isLoading"></salaxy-spinner>
  <div class="row">
    <div class="col-sm-8">
      <fieldset ng-if="$ctrl.viewType == 'overview'">
        <salaxy-absence-periods on-commit="$ctrl.save()" parent="$ctrl.current" mode="calendar"
          filter-start="$ctrl.currentYear + '-01-01'" filter-end="$ctrl.currentYear + '-12-31'"
          ></salaxy-absence-periods>
      </fieldset>
      <fieldset ng-if="$ctrl.viewType == 'list'">
        <salaxy-absence-periods on-commit="$ctrl.save()" parent="$ctrl.current"></salaxy-absence-periods>
      </fieldset>
    </div>
    <div class="col-sm-4">
      <div class="btn-group btn-block dropdown mb-4">
        <button id="year-selection" type="button" class="btn btn-primary btn-block dropdown-toggle" data-bs-toggle="dropdown">
          {{ $ctrl.currentYear  }}
        </button>
        <ul class="dropdown-menu" role="menu" aria-labelledby="single-button">
          <li role="menuitem"  ng-repeat="year in $ctrl.years">
            <a href="" ng-click="$ctrl.currentYear = year" class="dropdown-item">{{ year }}</a>
          </li>
        </ul>
      </div>
      <salaxy-toggle-buttons ng-model="$ctrl.viewType" options="[
        { value: 'overview', label: 'SALAXY.NG1.WorkerAbsencesComponent.calendarButtonText' },
        { value: 'list', label: 'SALAXY.NG1.WorkerAbsencesComponent.listButtonText' }
      ]" type="block"></salaxy-toggle-buttons>
      <p>&nbsp;</p>
      <fieldset>
        <legend sxy-text="SALAXY.NG1.WorkerAbsencesComponent.legendInstructions"></legend>
        <div sxy-html="SALAXY.NG1.WorkerAbsencesComponent.instructions.html"></div>
      </fieldset>
    </div>
  </div>
</div>`), s.put("salaxy-components/worker/WorkerAssure.html", `<div class="salaxy-component salaxy-worker-assure">
  <div class="col">
    <form name="assureWorkerForm" class="form-horizontal">
      <h3>Luo uusi työntekijä (Partner, BETA)</h3>
      <salaxy-input sxy-personal-id-fi ng-model="$ctrl.assureWorkerAccountReq.officialId" label="Henkilötunnus" name="officialId" require="true"></salaxy-input>
      <salaxy-input ng-model="$ctrl.assureWorkerAccountReq.firstName" label="Etunimi" name="firstName" require="true"></salaxy-input>
      <salaxy-input ng-model="$ctrl.assureWorkerAccountReq.lastName" label="Sukunimi" name="lastName" require="true"></salaxy-input>
      <salaxy-input sxy-email ng-model="$ctrl.assureWorkerAccountReq.email" label="Sähköposti" name="email" require="true"></salaxy-input>
      <salaxy-input sxy-mobile-phone ng-model="$ctrl.assureWorkerAccountReq.telephone" label="Puhelin" name="telephone" require="true"></salaxy-input>
      <salaxy-input sxy-iban ng-model="$ctrl.assureWorkerAccountReq.bankAccountIban" label="Pankkitili" name="bankAccountIban" require="true"></salaxy-input>
      <salaxy-datepicker-popup name="startDate" label="Työsuhteen alkamispäivä" ng-model="$ctrl.assureWorkerAccountReq.startDate"></salaxy-datepicker-popup>
      <salaxy-datepicker-popup name="endDate" label="Työsuhteen päättymispäivä" ng-model="$ctrl.assureWorkerAccountReq.endDate"></salaxy-datepicker-popup>

      <div class="text-end">
        <button type="reset" ng-click="assureWorkerForm.$setPristine(); $ctrl.resetAssureWorkerAccount()" class="btn btn-default">Tyhjennä</button>
        <button ng-click="assureWorkerForm.$setPristine(); $ctrl.submitAssureWorkerAccount($employmentDetails, $employmentsList);" ng-disabled="assureWorkerForm.$invalid" class="btn btn-primary" sxy-text="SALAXY.UI_Terms.save"></button>
      </div>
    </form>
  </div>

  <div class="col col-md-5 col-lg-5">
    <hr />
    <salaxy-employment-list limit-to="10" ng-ref="$employmentsList" mode="select" on-list-select="$employmentDetails.model = (value == true ? item.id : null); $employmentsList.selectedItems = []"></salaxy-employment-list>
  </div>
  <div class="col-md-7 col-lg-7">
    <hr />
    <salaxy-employment-details ng-ref="$employmentDetails"></salaxy-employment-details>
  </div>
</div>`), s.put("salaxy-components/worker/WorkerDetails.html", `<div ng-if="$ctrl.status == 'initialLoading'">
  <p sxy-text="SALAXY.UI_Terms.loading"></p>
</div>
<div ng-if="$ctrl.current">
  <div class="alert alert-warning">
    <div><strong>WARNING: This page is depricated!</strong></div>
    <div>Tämä on vanha sivu, joka ei pitäisi enää olle näkyvissä. 
      <strong>Ilmoita asiakaspalvelulle</strong>, jos tämä sivu on vielä näkyvissä sivustollasi.</div>
  </div>
  <salaxy-employment-details model="$ctrl.current.employmentId"></salaxy-employment-details>
</div>`), s.put("salaxy-components/workflow/calendar/Occurences-daily.html", `<salaxy-calendar data="$ctrl.calendarPeriods" on-list-select="$ctrl.currentDay = date"
  today="$ctrl.currentDay" start="$ctrl.range.start" end="$ctrl.range.end"></salaxy-calendar>
<div>
  <table class="table">
    <thead>
      <tr>
        <th>Otsikko</th>
        <th>Tyyppi</th>
        <th class="right">Periodi</th>
        <th class="right">Kesto</th>
        <th class="right">{{ $ctrl.todayOccurences.length | sxyCount : "count" }}</th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="row in $ctrl.todayOccurences">
        <td>
          <i ng-if="row.data.actionId" class="bi bi-bell-fill" aria-hidden="true"></i>
          <i ng-if="row.data.isRecurring" class="bi bi-arrow-repeat" aria-hidden="true"></i>
          {{ row.shortText }}
        </td>
        <td>
          <small ng-if="row.data.type != 'undefined'">{{ "ApiItemType." + row.data.type | sxyEnum }}</small>
          <small ng-if="row.data.type == 'undefined'">-</small>
          <i ng-if="row.data.isRecurring" class="bi bi-arrow-clockwise" aria-hidden="true" title="Toistuva"></i>
        </td>
        <td class="right">{{ row | sxyDateRange }}</td>
        <td class="right">{{ row.data.duration | sxyDuration }}</td>
        <td class="right">
          <button type="button" ng-click="$ctrl.showEditDialog(row)" class="btn btn-default">Näytä</button>
        </td>
      </tr>
    </tbody>
  </table>
</div>`), s.put("salaxy-components/workflow/calendar/Occurences-details.html", `<div class="modal-header">
  <h2 class="modal-title">{{ $ctrl.current.shortText }}</h2>
  <button type="button" class="btn-close" ng-click="$close('cancel')" aria-label="Close"></button>
</div>
<div class="modal-body">
  <salaxy-tab-buttons
    current-tab="$ctrl.currentTab"
    options="[
      { value: 'basic', text: 'Perustiedot' },
      { value: 'debug', text: 'Debug' },
    ]"
    tabs-id="occurencesDetails">
  </salaxy-tab-buttons>
  <div class="tab-content" id="tab-content-occurencesDetails">
    <div class="tab-pane" id="basic-tab">
      <div class="row form-horizontal">
        <div class="col-sm-6">
          <fieldset>
            <legend>Kalenteritapahtuma</legend>
            <salaxy-form-group name="start" class="salaxy-component salaxy-read-only" label="Alku">
              <div class="form-control-plaintext">{{ $ctrl.current.startAt | sxyDate }}</div>
            </salaxy-form-group>
            <salaxy-form-group name="duration" class="salaxy-component salaxy-read-only" label="Kesto">
              <div class="form-control-plaintext">{{ $ctrl.current.data.duration | sxyDuration }}</div>
            </salaxy-form-group>
            <salaxy-form-group name="end" class="salaxy-component salaxy-read-only" label="Loppu">
              <div class="form-control-plaintext">{{ $ctrl.current.endAt | sxyDate }}</div>
            </salaxy-form-group>
            <salaxy-input-boolean name="isAllDay" ng-model="$ctrl.current.data.isAllDay" type="checkbox" label="Koko päivän" read-only="true"></salaxy-input-boolean>
          </fieldset>
        </div>
        <div class="col-sm-6">
          <fieldset>
            <legend>Lisätietoja</legend>
            <salaxy-input-enum name="priority" enum="CalendarEventStatus" ng-model="$ctrl.current.status" label="Status" read-only="true"></salaxy-input-enum>
            <salaxy-form-group name="start" class="salaxy-component salaxy-read-only" label="Kategoriat">
              <div class="form-control-plaintext">
                <div ng-repeat="cat in $ctrl.current.flags"><span>{{ cat + ($last ? "" : ", ") }}</span></div>
                <div ng-if="!$ctrl.current.flags.length">-</div>
              </div>
            </salaxy-form-group>
            <salaxy-input-number name="priority" ng-model="$ctrl.current.data.priority" label="Prioriteetti" read-only="true"></salaxy-input-number>
          </fieldset>
        </div>
      </div>
    </div>
    <div class="tab-pane" id="debug-tab">
      <salaxy-json-formatter key="'Occurence'" json="$ctrl.current" open="1"></salaxy-json-formatter>
    </div>
  </div>
</div>
<div class="modal-footer text-start">
  <button type="button" class="btn btn-default" ng-click="$close('cancel')" sxy-text="SALAXY.UI_Terms.close"></button>
</div>`), s.put("salaxy-components/workflow/calendar/Occurences-list.html", `<div>
  <table class="table">
    <thead>
      <tr>
        <th>Otsikko</th>
        <th>Tyyppi</th>
        <th class="right">Periodi</th>
        <th class="right">Kesto</th>
        <th class="right">{{ $ctrl.list.length | sxyCount : "count" }}</th>
      </tr>
    </thead>
    <tbody>
      <tr ng-repeat="row in $ctrl.list">
        <td>{{ row.shortText }}</td>
        <td>
          <small ng-if="row.data.type != 'undefined'">{{ "ApiItemType." + row.data.type | sxyEnum }}</small>
          <small ng-if="row.data.type == 'undefined'">-</small>
          <i ng-if="row.data.isRecurring" class="bi bi-arrow-clockwise" aria-hidden="true" title="Toistuva"></i>
        </td>
        <td class="right">{{ row | sxyDateRange }}</td>
        <td class="right">{{ row.data.duration | sxyDuration }}</td>
        <td class="right"><button type="button" ng-click="$ctrl.showEditDialog(row)" class="btn btn-default">Näytä</button></td>
      </tr>
    </tbody>
  </table>
</div>`), s.put("salaxy-components/workflow/calendar/Occurences-week.html", `<style>
  .salaxy-calendar-weekly .list-group.weekend {
    min-height: 165px;
  }

  .salaxy-calendar-weekly .list-group-item {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 4px 8px;
  }

  .salaxy-calendar-weekly .list-group-item.active {
    font-weight: bold;
  }

  .salaxy-calendar-week-header {
    height: 32px;
    background-color: #009fd8;
    color: white;
    font-weight: bold;
  }

  .salaxy-calendar-weekend-day {
    min-height: 150px;
    border: lightgrey solid 1px;
  }
</style>
<salaxy-calendar data="$ctrl.calendarPeriods" on-list-select="$ctrl.currentDay = date"
  today="$ctrl.currentDay" start="$ctrl.range.start" end="$ctrl.range.end"></salaxy-calendar>
  <div class="salaxy-component salaxy-calendar-weekly">
    <div class="row">
      <div class="col-sm-2 col-4" ng-repeat="day in $ctrl.currentWeek.slice(0, 5)">
        <div class="list-group">
          <button type="button" class="list-group-item active"
            ng-click="$ctrl.currentDay = day.date;$ctrl.currentTab = 'daily'">{{ "SALAXY.ENUM.Weekday.day" + ($index + 1) + ".label" | sxyTranslate }} {{ day.date | date : "d.M." }}</button>
          <button type="button" class="list-group-item" ng-click="$ctrl.showEditDialog(occ)"
            ng-repeat="occ in day.occurences | limitTo: 10 " title="{{ occ.shortText }}">
            <i ng-if="occ.data.actionId" class="bi bi-bell-fill" aria-hidden="true"></i>
            <i ng-if="occ.data.isRecurring" class="bi bi-arrow-repeat" aria-hidden="true"></i>
            {{ occ.shortText }}</button>
          <button type="button" class="list-group-item" ng-click="$ctrl.currentDay = day.date;$ctrl.currentTab = 'daily'"
            ng-if="day.occurences.length > 10" title="{{ occ.shorttext }}">+ {{ day.occurences.length - 10 }} tapahtumaa...</button>
        </div>
      </div>

      <div class="col-sm-2 col-4">
        <div class="list-group weekend" ng-repeat="day in $ctrl.currentWeek.slice(5, 7)">
          <button type="button" class="list-group-item active"
            ng-click="$ctrl.currentDay = day.date;$ctrl.currentTab = 'daily'">{{ "SALAXY.ENUM.Weekday.day" + ($index + 6) + ".label" | sxyTranslate }} {{ day.date | date : "d.M." }}</button>
          <button type="button" class="list-group-item" ng-click="$ctrl.showEditDialog(occ)"
            ng-repeat="occ in day.occurences | limitTo: 10 " title="{{ occ.shortText }}">
            <i ng-if="occ.data.actionId" class="bi bi-bell-fill" aria-hidden="true"></i>
            <i ng-if="occ.data.isRecurring" class="bi bi-arrow-repeat" aria-hidden="true"></i>
            {{ occ.shortText }}</button>
          <button type="button" class="list-group-item" ng-click="$ctrl.currentDay = day.date;$ctrl.currentTab = 'daily'"
            ng-if="day.occurences.length > 10" title="{{ occ.shorttext }}">+ {{ day.occurences.length - 10 }} tapahtumaa...</button>
        </div>
      </div>
    </div>
  </div>`), s.put("salaxy-components/workflow/CalendarEventDetails-payroll.html", `<div class="salaxy-component salaxy-calendar-event-details">
  <div ng-if="$ctrl.current">
    <div ng-if="!$ctrl.current.occurenceInfo.isRecurring">
      <div class="alert alert-info">
        <button style="margin-top: -7px;" class="btn btn-default btn-labeled-right float-end" ng-click="$ctrl.showEditEvent()">
          <span sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.toolbar.createSchedule"></span>
          <i class="bi bi-calendar3"></i>
        </button>
        Tämä tietue ei ole ajastettu toistuvaksi
      </div>
      <salaxy-calendar data="$ctrl.current" mapper="$ctrl.calendarMapper" on-list-select="$ctrl.calendarClick(type, date, calEvent)" today="$ctrl.currentDay"
        start="$ctrl.calendarView.start" end="$ctrl.calendarView.end"></salaxy-calendar>
    </div>
    <div ng-if="$ctrl.current.occurenceInfo.isRecurring">
      <div class="btn-toolbar">
        <button class="btn btn-default btn-labeled-right" ng-click="$ctrl.showEditEvent()">
          <span sxy-text="SALAXY.NG1.PayrollComponent.payrollEdit.toolbar.editSchedule"></span>
          <i class="bi bi-calendar3"></i>
        </button>
        <button type="button" class="btn btn-danger" ng-click="$ctrl.delete(null, 'Haluatko varmasti poistaa ajastuksen?')">Poista ajastus</button>
      </div>
      <div ng-init="$ctrl.reloadPreview()" class="row">
        <div class="col-sm-9">
          <salaxy-spinner ng-if="!$ctrl.preview"></salaxy-spinner>
          <salaxy-calendar data="$ctrl.preview" ng-if="$ctrl.preview" mapper="$ctrl.calendarMapper" on-list-select="$ctrl.calendarClick(type, date, calEvent)"
            today="$ctrl.currentDay" start="$ctrl.preview.start" end="$ctrl.preview.end"></salaxy-calendar>
        </div>
        <div class="col-sm-3">
          <table>
            <tr>
              <td><i class="bi bi-star-fill event-single-day"></i></td>
              <td>Palkkalista luodaan</td>
            </tr>
            <tr>
              <td><i class="bi bi-envelope-fill event-single-day"></i></td>
              <td>Viesti / muistutus</td>
            </tr>
            <tr>
              <td>
                <div style="width: 14px; background-color: #333333; margin: 1px 2px; font-size: 0.9em">&nbsp;</div>
              </td>
              <td>Palkkapäivä</td>
            </tr>
            <tr>
              <td>
                <div style="width: 14px; background-color: #d55552; margin: 1px 2px; font-size: 0.9em">&nbsp;</div>
              </td>
              <td>Tänään</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <!--
    <hr />
    <salaxy-json-formatter key="'Event'" json="$ctrl.current" open="1"></salaxy-json-formatter>
    -->
  </div>
</div>`), s.put("salaxy-components/workflow/CalendarEventDetails-simplified.html", `<div class="salaxy-component salaxy-calendar-event-details">
  <div class="salaxy-wizard">
    <div class="wizard-steps">
      <div class="wizard-step" ng-repeat="step in $ctrl.steps" ng-class="{'active': step.active, 'disabled': step.disabled}">
        <span class="salaxy-avatar">
          <div class="wizard-icons-wrapper">
            <i class="bi" ng-class="step.active ? 'bi-circle-fill' : 'bi-circle'"></i>
            <i class="bi bi-circle-fill"></i>
          </div>
          <strong class="number">{{ step.number }}</strong>
        </span>
        <span class="step-text">{{ step.title | sxyTranslate }}</span>
      </div>
    </div>
    <div class="wizard-strikethrough"></div>
  </div>
  <div class="worker-wizard-content" style="min-height: 360px">
    <div ng-if="$ctrl.step == 1">
      <div class="row">
        <div class="col-sm-6 form-horizontal">
          <fieldset>
            <legend>Toistuvuus</legend>
            <salaxy-datepicker-popup ng-model="$ctrl.current.event.start" name="start" label="Palkkakauden alku" require="true"
              ng-change="$ctrl.current.event.end = $ctrl.current.event.start" label-cols="col-sm-6">
            </salaxy-datepicker-popup>
            <salaxy-form-group name="duration" class="salaxy-component salaxy-read-only" label="Kesto" label-cols="col-sm-6">
              <div class="form-control-plaintext">{{ $ctrl.current.event.duration | sxyDuration }}</div>
            </salaxy-form-group>
            <div ng-repeat="rule in $ctrl.current.event.recurrenceRules track by $index">
              <salaxy-input-rrule name="rule{{$index}}" ng-model="$ctrl.current.event.recurrenceRules[$index]" label="Toistuvuus {{ $index ? ($index + 1) : '' }}">
              </salaxy-input-rrule>
            </div>
          </fieldset>
        </div>
        <div class="col-sm-6">
          <fieldset class="form-horizontal">
            <legend>Tapahtumat</legend>
            <p>Palkkalistan luonti ja palkkapäivän määrittely tehdään suhteessa palkkakauden alkuun (päiviä ennen/jälkeen).</p>
            <salaxy-input-duration ng-model="$ctrl.current.event.actions[0].triggerDuration" name="payrollCreateDays" label="{{ $ctrl.current.event.actions[0].summary }}"
              label-cols="col-sm-6"></salaxy-input-duration>
            <salaxy-input-duration ng-model="$ctrl.current.event.actions[1].triggerDuration" name="payrollCreateDays" label="{{ $ctrl.current.event.actions[1].summary }}"
              label-cols="col-sm-6"></salaxy-input-duration>
          </fieldset>
        </div>
      </div>
    </div>
    <div ng-if="$ctrl.step == 2">
      <p class="lead">
        Voit määrittää muistutusviestin sähköpostilla.
        Viestin lähetys määritetään päivinä palkkakauden alusta.
      </p>
      <salaxy-input-boolean ng-model="$ctrl.notificationEnabled" type="switch" label-true="on" label-false="off" name="notificationEnabled" label="Muistutus sähköpostilla">
      </salaxy-input-boolean>
      <div ng-if="$ctrl.notificationEnabled">
        <salaxy-input-duration ng-model="$ctrl.notification.triggerDuration" name="notificationDays" label="Ajastus, päiviä palkkakauden alusta"></salaxy-input-duration>
        <salaxy-input ng-model="$ctrl.notification.attendees[0].email" require="true" name="notificationEmail" label="Vastaanottajan sähköposti" sxy-email></salaxy-input>
        <salaxy-input name="title" label="Sähköpostin otsikko" require="true" ng-model="$ctrl.notification.summary"></salaxy-input>
        <salaxy-textarea ng-model="$ctrl.notification.description" name="notificationText" label="Muistutuksen teksti"></salaxy-textarea>
      </div>
      <div ng-if="!$ctrl.notificationEnabled">
        <salaxy-input-number ng-model="none1" name="notificationDays" label="Ajastus, päivää ennen" negative="true" unit="day" disabled="true"></salaxy-input-number>
        <salaxy-input ng-model="none2" name="notificationEmail" label="Vastaanottajan sähköposti" sxy-email disabled="true"></salaxy-input>
        <salaxy-input name="title" label="Sähköpostin otsikko" ng-model="none3" disabled="true"></salaxy-input>
        <salaxy-textarea ng-model="none4" name="notificationText" label="Muistutuksen teksti" disabled="true"></salaxy-textarea>
      </div>
    </div>
    <div ng-if="$ctrl.step == 3">
      <div ng-init="$ctrl.reloadPreview()" class="row">
        <div class="col-sm-9">
          <salaxy-spinner ng-if="!$ctrl.preview"></salaxy-spinner>
          <salaxy-calendar data="$ctrl.preview" ng-if="$ctrl.preview" mapper="$ctrl.calendarMapper" on-list-select="$ctrl.calendarClick(type, date, calEvent)"
            today="$ctrl.currentDay" start="$ctrl.preview.start" end="$ctrl.preview.end"></salaxy-calendar>
        </div>
        <div class="col-sm-3">
          <table>
            <tr>
              <td><i class="bi bi-file-earmark-fill event-single-day text-warning"></i></td>
              <td>Palkkalista luodaan heti</td>
            </tr>
            <tr>
              <td><i class="bi bi-file-earmark-fill event-single-day text-info"></i></td>
              <td>...luodaan ajastuksella</td>
            </tr>
            <tr>
              <td><i class="bi bi-envelope-fill event-single-day text-warning"></i></td>
              <td>Viesti / muistutus heti</td>
            </tr>
            <tr>
              <td><i class="bi bi-envelope-fill event-single-day text-info"></i></td>
              <td>...ajastuksella</td>
            </tr>
            <tr>
              <td>
                <div style="width: 14px; background-color: #009fd8; margin: 1px 2px; font-size: 0.9em">&nbsp;</div>
              </td>
              <td>Palkkapäivä</td>
            </tr>
            <tr>
              <td>
                <div style="width: 14px; background-color: #d55552; margin: 1px 2px; font-size: 0.9em">&nbsp;</div>
              </td>
              <td>Tänään</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <!--
      <salaxy-json-formatter key="'Event'" json="$ctrl.current" open="1"></salaxy-json-formatter>
    -->
  </div>
</div>`), s.put("salaxy-components/workflow/CalendarEventDetails.html", `<div class="salaxy-component salaxy-calendar-event-details">
  <salaxy-tab-buttons
    current-tab="$ctrl.currentTab"
    options="$ctrl.tabOptions"
    tabs-id="calendarEventDetails">
  </salaxy-tab-buttons>
  <div class="tab-content" id="tab-content-calendarEventDetails" style="min-height: 360px">
    <div class="tab-pane" id="basic-tab">
      <div class="row">
        <div class="col-sm-6 form-horizontal">
          <fieldset>
            <legend>Tapahtuma-aika</legend>
            <salaxy-datepicker-popup ng-model="$ctrl.current.event.start" name="start" label="Alku" require="true" ng-change="$ctrl.current.event.end = $ctrl.current.event.start">
            </salaxy-datepicker-popup>
            <salaxy-datepicker-popup ng-model="$ctrl.current.event.end" name="end" label="Loppu" ng-change="$ctrl.current.event.duration = null" min-date="$ctrl.current.event.start"></salaxy-datepicker-popup>
            <salaxy-form-group name="duration" class="salaxy-component salaxy-read-only" label="Kesto">
              <div class="form-control-plaintext">{{ $ctrl.getEventDuration() }}</div>
            </salaxy-form-group>
            <div class="alert alert-warning" ng-if="!$ctrl.current.event.isAllDay">
              Kalenteritapahtuma määrittää kellonaikoja. Tämä käyttöliittymä on suunniteltu vain koko päivän kestäviin tapahtumiin ja muokkaukset saattavat johtaa virheellisiin tuloksiin.
            </div>
          </fieldset>
          <fieldset>
            <legend>Lisätietoja</legend>
            <salaxy-input-enum name="status" enum="CalendarEventStatus" ng-model="$ctrl.current.event.status" label="Status" read-only="true"></salaxy-input-enum>
            <salaxy-form-group name="categories" class="salaxy-component salaxy-read-only" label="Kategoriat">
              <div class="form-control-plaintext">
                <div ng-repeat="cat in $ctrl.current.event.categories"><span>{{ cat + ($last ? "" : ", ") }}</span></div>
                <div ng-if="!$ctrl.current.event.categories.length">-</div>
              </div>
            </salaxy-form-group>
            <salaxy-input-number name="priority" ng-model="$ctrl.current.event.priority" label="Prioriteetti" read-only="true"></salaxy-input-number>
          </fieldset>
        </div>
        <div class="col-sm-6">
          <fieldset class="form-horizontal">
            <legend>Kuvaus</legend>
            <salaxy-input ng-model="$ctrl.current.event.summary" name="summary" required="true" label="Lyhyt kuvaus"></salaxy-input>
            <salaxy-textarea ng-model="$ctrl.current.event.description" name="description" label="Kuvaus" rows="5" label-type="basic"></salaxy-textarea>
          </fieldset>
        </div>
      </div>
    </div>
    <div class="tab-pane" id="recurrence-tab">
      <p class="lead">
        <button type="button" class="btn btn-primary float-end" ng-click="$ctrl.addRecurrenceRule()">Lisää sääntö</button> Voit määrittää tapahtumalle toistuvuussääntöjä: Esim. kuukausittain, viikottain jne. Toistuvuus perustuu alkupäivämäärään <strong>{{ $ctrl.current.event.start | sxyDate }}</strong>        aivan kuten Outlookissa tai Google kalenterissa.
      </p>
      <fieldset ng-repeat="rule in $ctrl.current.event.recurrenceRules track by $index">
        <legend>
          <button ng-click="$ctrl.deleteRecurrence($index)" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}" class="btn btn-danger btn-sm float-end">
            <i class="bi bi-trash-fill"></i>
          </button> Toistuvuus {{ $index + 1 }}
        </legend>
        <salaxy-input ng-model="$ctrl.current.event.recurrenceRules[$index]" name="rule{{$index}}" required="true" label="iCalendar sääntö (rrule)"></salaxy-input>
      </fieldset>
    </div>
    <div class="tab-pane" id="actions-tab">
      <p class="lead">
        <button type="button" class="btn btn-primary float-end" ng-click="$ctrl.addAction()">Lisää tehtävä / muistutus</button> Voit määrittää sähköpostihälytyksiä tai notifikaatioita tapahtumalle. Samoin voit määrittää, että laskelma tai palkkalista
        luodaan tiettynä aikana. Säännöt määritetään päivinä ennen tai jälkeen alkupäivän <strong>{{ $ctrl.current.event.start | sxyDate }}</strong> (+ mahd. toistuvuus).
      </p>
      <fieldset ng-repeat="action in $ctrl.current.event.actions | orderBy: 'triggerDuration'" class="form-horizontal" ng-switch="action.type">
        <div class="row">
          <div class="col-2 text-center">
            <div style="font-size:5em; font-weight: bold">{{ $index + 1 }}.</div>
          </div>
          <div ng-switch-when="createItem" class="col-10">
            <legend>
              <button ng-click="$ctrl.deleteAction($index)" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}" class="btn btn-danger btn-sm float-end">
                <i class="bi bi-trash-fill"></i>
              </button> Tietue syntyy
            </legend>
            <salaxy-input-enum name="boType" enum="ApiItemType" ng-model="$ctrl.current.bo.type" label="Tyyppi"></salaxy-input-enum>
            <div ng-switch="$ctrl.current.bo.type || 'undefined'">
              <div ng-switch-when="undefined">
                <div class="alert alert-info">
                  Luodaksesi uuden tietueen ajastetusti, valitse tietueen tyyppi.
                </div>
              </div>
              <div ng-switch-when="calculation|calculationPaid" ng-switch-when-separator="|">
                <div class="alert alert-info">
                  Laskelmasta tehdään kopio ja alkupäivämäärästä (+toistuvuus) tulee uuden laskelman palkkapäivä. Valitse laskelma alta.
                </div>
                <salaxy-form-group name="start" class="salaxy-component salaxy-read-only" label="Malli (template)">
                  <button type="button" class="btn btn-default" ng-click="$ctrl.selectBo()">Valitse...</button>
                </salaxy-form-group>
                <salaxy-input ng-model="$ctrl.current.bo.id" name="boId" required="true" label="Template ID" read-only="true"></salaxy-input>
                <salaxy-input-number name="duration" ng-model="action.triggerDuration" label="Luodaan päivää ennen" unit="day" negative="true"></salaxy-input-number>
              </div>
              <div ng-switch-when="payrollDetails">
                <div class="alert alert-info">
                  Palkkalistan voit ajastaa Palkkalistat-osiosta => Uusi palkkalista.
                </div>
                <salaxy-input ng-model="$ctrl.current.bo.id" name="boId" required="true" label="Template ID" read-only="true"></salaxy-input>
                <salaxy-input-number name="duration" ng-model="action.triggerDuration" label="Luodaan päivää ennen" unit="day" negative="true"></salaxy-input-number>
              </div>
              <div class="alert alert-info" ng-switch-default>
                Näiden tietueiden ajastaminen on tulossa vast myöhemmin syksyllä. Kerro meille mikä käyttötapauksesi on, jotta osaamme kehittää toiminnallisuutta pidemmälle.
              </div>
            </div>
          </div>
          <div ng-switch-when="email" class="col-10">
            <legend>
              <button ng-click="$ctrl.deleteAction($index)" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}" class="btn btn-danger btn-sm float-end">
                <i class="bi bi-trash-fill"></i>
              </button> Sähköpostin lähetys
            </legend>
            <salaxy-input-enum name="type" enum="CalendarActionType" ng-model="action.type" label="Tyyppi" hidden-options="undefined,createItem,audio"></salaxy-input-enum>
            <salaxy-input-boolean name="isAfter" ng-model="action.triggerIsAfterTemp" ng-init="action.triggerIsAfterTemp = action.triggerDuration > 0" ng-change="action.triggerDuration = action.triggerDuration * -1" type="radio" label="Ennen vai jälkeen" label-true="Jälkeen"
              label-false="Ennen">
            </salaxy-input-boolean>
            <salaxy-input-number name="duration" ng-model="action.triggerDuration" label="Päiviä {{ action.triggerIsAfterTemp ? ' jälkeen' : ' ennen' }}" unit="day" negative="!action.triggerIsAfterTemp"></salaxy-input-number>
            <!--
                TODO: Ei vaikuta toimivan. Fiksaa tai poista mallista.
                <salaxy-input-number name="repeat" ng-model="action.repeat" label="Toistuu (kpl)"></salaxy-input-number>
              -->
            <salaxy-input name="title" label="Sähköpostin otsikko" require="true" ng-model="action.summary"></salaxy-input>
            <salaxy-textarea ng-model="action.description" name="notificationText" label="Sisältöteksti"></salaxy-textarea>
            <salaxy-input ng-model="action.attendees[0].email" name="notificationEmail" label="Vastaanottajan sähköposti" sxy-email></salaxy-input>
          </div>
          <div ng-switch-when="display" class="col-10">
            <legend>
              <button ng-click="$ctrl.deleteAction($index)" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}" class="btn btn-danger btn-sm float-end">
                <i class="bi bi-trash-fill"></i>
              </button> Notifikaatio
            </legend>
            <div class="alert alert-info">
              <strong>HUOM: </strong> Tässä vaiheessa muistutukset tulevat aina tilitoimistolle / palkanlaskijalle. Loppuvuonna julkaistavassa versiossa on tarkoitus mahdollistaa notifikaation kohteen valinta (yritys, työntekijä jne.)
            </div>
            <salaxy-input-enum name="type" enum="CalendarActionType" ng-model="action.type" label="Tyyppi" hidden-options="undefined,createItem,audio"></salaxy-input-enum>
            <salaxy-input-boolean name="isAfter" ng-model="action.triggerIsAfterTemp" ng-init="action.triggerIsAfterTemp = action.triggerDuration > 0" ng-change="action.triggerDuration = action.triggerDuration * -1" type="radio" label="Ennen vai jälkeen" label-true="Jälkeen"
              label-false="Ennen">
            </salaxy-input-boolean>
            <salaxy-input-number name="duration" ng-model="action.triggerDuration" label="Päiviä {{ action.triggerIsAfterTemp ? ' jälkeen' : ' ennen' }}" unit="day" negative="!action.triggerIsAfterTemp"></salaxy-input-number>
            <salaxy-input-number name="repeat" ng-model="action.repeat" label="Toistuu (kpl)"></salaxy-input-number>
            <salaxy-textarea ng-model="action.description" name="notificationText" label="Muistutuksen teksti"></salaxy-textarea>
          </div>
          <div ng-switch-when="script" class="col-10">
            <legend>
              <button ng-click="$ctrl.deleteAction($index)" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}" class="btn btn-danger btn-sm float-end">
                <i class="bi bi-trash-fill"></i>
              </button> Skripti
            </legend>
            <salaxy-input-enum name="type" enum="CalendarActionType" ng-model="action.type" label="Tyyppi" hidden-options="undefined,createItem,audio"></salaxy-input-enum>
            <div class="alert alert-danger">
              <strong>HUOM: </strong> Skriptit ovat rajatussa testikäytössä. Ota yhteyttä asiakaspalveluun, jos tarvitse skriptejä.
            </div>
          </div>
          <div ng-switch-default>
            <legend>
              <button ng-click="$ctrl.deleteAction($index)" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}" class="btn btn-danger btn-sm float-end">
                <i class="bi bi-trash-fill"></i>
              </button> Tehtävätyyppi ei tuettu
            </legend>
            <div class="alert alert-danger">
              Tehtävätyyppi ei tuettu: {{ "CalendarActionType." + action.type | sxyEnum }}
            </div>
            <salaxy-input-enum name="type" enum="CalendarActionType" ng-model="action.type" label="Tyyppi"></salaxy-input-enum>
          </div>
        </div>
      </fieldset>
    </div>
    <div class="tab-pane" id="preview-tab">
      <div ng-init="$ctrl.reloadPreview()">
        <salaxy-spinner ng-if="!$ctrl.preview"></salaxy-spinner>
        <salaxy-calendar data="$ctrl.preview" ng-if="$ctrl.preview" mapper="$ctrl.calendarMapper" on-list-select="$ctrl.calendarClick(type, date, calEvent)" today="$ctrl.currentDay" start="$ctrl.preview.start" end="$ctrl.preview.end"></salaxy-calendar>
      </div>
    </div>
    <div class="tab-pane" id="attendees-tab">
      <ul class="list-group">
        <li ng-repeat="avatar in $ctrl.current.event.attendees" class="list-group-item">
          <salaxy-avatar style="font-size: 3em" class="float-start" avatar="avatar"></salaxy-avatar>
          <div>{{ avatar.displayName }}</div>
          <div><a ng-if="avatar.email" ng-href="{{'mailto:' + avatar.email}}" target="_blank">{{ avatar.email }}</a></div>
        </li>
      </ul>
      <div ng-if="!$ctrl.current.event.attendees.length">Ei henkilöitä</div>
    </div>
    <div class="tab-pane" id="attachments-tab">
      <ul>
        <li ng-repeat="attach in $ctrl.current.event.attachments">TODO: {{ attach.uri || attach.formatType || attach.valueEncoding }}</li>
      </ul>
    </div>
    <div class="tab-pane" id="debug-tab">
      <salaxy-json-formatter key="'Event'" json="$ctrl.current" open="1"></salaxy-json-formatter>
    </div>
  </div>
</div>`), s.put("salaxy-components/workflow/dataset/DatasetDetails.html", `<div class="salaxy-component salaxy-dataset-details" ng-switch="$ctrl.getMode()">
  <salaxy-spinner ng-switch-when="loading"></salaxy-spinner>
  <div ng-switch-when="usecase">
    <div ng-if="$ctrl.usecase && !$ctrl.usecase.defaultView" class="alert alert-danger">
      ERROR: This usecase {{ $ctrl.usecase.uri }} does not have user interface (view) defined.
    </div>
    <div ng-if="$ctrl.usecase.defaultView">
      <ng-include src="$ctrl.usecase.defaultView"></ng-include>
    </div>
  </div>
  <div ng-switch-when="data-edit">
    <ng-include src="'salaxy-components/workflow/dataset/DatasetDetails_data.html'"></ng-include>
  </div>
  <div ng-switch-when="full-edit">
    <ng-include src="'salaxy-components/workflow/dataset/DatasetDetails_full.html'"></ng-include>
  </div>
  <div ng-switch-default class="alert alert-danger">ERROR: Unable to load Dataset</div>
</div>`), s.put("salaxy-components/workflow/dataset/DatasetDetails_data.html", `<div>
  <div class="btn-toolbar">
    <div class="btn-group">
      <button type="button" class="btn btn-primary" ng-disabled="!$ctrl.current || $ctrl.current.isReadOnly" ng-click="$ctrl.save()" sxy-text="SALAXY.UI_Terms.save"></button>
      </button>
    </div>
    <div class="btn-group">
      
        <div class="form-group" style="line-height: 34px;">
          <strong> &nbsp; Nimi:</strong> {{$ctrl.current.info.label}}
        </div>
     
    </div>
    <div class="btn-group ms-1">
      <button type="button" class="btn" ng-class="'btn-' + (action.uiColor || 'default')" ng-repeat="action in $ctrl.usecase.actions" ng-click="$ctrl.executeAction(action)">{{
        action.uiText }}</button>
    </div>
  </div>
  <div style="height: calc(100vh - 200px);" class="form-horizontal">
    <style>
      /* TODO: Move to less */
      .salaxy-tab-height100 {
        height: 100%;
      }

      .salaxy-tab-height100 .tab-content {
        height: calc(100% - 43px);
      }

      .salaxy-tab-height100 .height100 {
        height: 100%;
      }
    </style>
    <salaxy-tab-buttons
      currentTab="$ctrl.currentTab"
      options="$ctrl.generateTabOptions()"
      tabs-id="datasetDetailsData">
    </salaxy-tab-buttons>

    <div class="tab-content" id="tab-content-datasetDetailsData">
      <div class="tab-pane" ng-repeat="table in $ctrl.current.data" id="{{ $ctrl.generateTabOptions()[$index].value }}">
        <div class="height100">
          <sxy-grid
            ng-if="$ctrl.getSchamaDef($index)"
            data="table.content"
            schema-def="$ctrl.getSchamaDef($index)"
            schema="table.schema"
            ng-ref="grid">
          </sxy-grid>
        </div>
      </div>
    </div>
  </div>
</div>`), s.put("salaxy-components/workflow/dataset/DatasetDetails_full.html", `<div>
  <div class="btn-toolbar" style="margin-left: 195px; margin-bottom: 2px;">
    <div class="btn-group">
      <button type="button" class="btn btn-primary" ng-disabled="!$ctrl.current || $ctrl.current.isReadOnly" ng-click="$ctrl.save()" sxy-text="SALAXY.UI_Terms.save"></button>
      </button>
      <button type="button" class="btn btn-default" ng-click="$ctrl.showCopyAsNew($ctrl.current)" sxy-text="SALAXY.UI_Terms.copyAsNew"></button>
      <button class="btn btn-default" ng-click="$ctrl.reload()"><i class="bi bi-arrow-repeat" aria-hidden="true"></i></button>
    </div>
    <div class="btn-group ms-1">
      <button type="button" class="btn btn-default" ng-click="$ctrl.addDataObject()" sxy-text="Lisää dataobjekti"></button>
    </div>
    <div class="btn-group ms-1">
      
        <div class="form-group" style="line-height: 34px;">
          <strong> &nbsp; Nimi:</strong> {{$ctrl.current.info.label}}
        </div>
      
    </div>
    <div class="btn-group ms-1">
      <button type="button" class="btn" ng-class="'btn-' + (action.uiColor || 'default')" ng-repeat="action in $ctrl.usecase.actions" ng-click="$ctrl.executeAction(action)">{{ action.uiText }}</button>
    </div>
    <div class="btn-group ms-auto">
      <button type="button" class="btn btn-danger" ng-disabled="!$ctrl.current || $ctrl.current.isReadOnly" ng-click="$ctrl.delete($ctrl.current)"
        sxy-text="SALAXY.UI_Terms.delete" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}">
    </div>
  </div>
  <div ng-init="$ctrl.currentSection = 'basicInfo'" style="display: flex">
    <div style="flex: 0 0 200px;">
      <salaxy-toggle-buttons ng-model="$ctrl.currentSection" options="[{ value: 'basicInfo', label: 'Perustiedot' }]" type="block"></salaxy-toggle-buttons>
      <div style="margin-top: 8px;">Dataobjektit:</div>
      <salaxy-toggle-buttons ng-repeat="table in $ctrl.current.data" ng-model="$ctrl.currentSection" options="[{ value: 'table' + $index, label: table.label }]" type="block"></salaxy-toggle-buttons>
      <div>&nbsp;</div>
      <salaxy-toggle-buttons ng-model="$ctrl.currentSection" options="[{ value: 'debugger', label: 'Debugger' }]" type="block"></salaxy-toggle-buttons>
    </div>
    <div ng-if="$ctrl.current" style="flex: 1 1 100%;margin-left: -1px; height: calc(100vh - 200px); overflow-y: auto; border: solid 1px #009fd8; padding: 10px;">
      <div ng-if="$ctrl.currentSection == 'basicInfo'" class="form-horizontal">
        <sxy-form open-api="salaxy-secure/schemas/v02.json" type="Dataset" auto-gen="false" debugger="false" model="$ctrl.current">
          <div class="row">
            <div class="col-sm-6">
              <fieldset>
                <legend>Perustiedot</legend>
                <sxy-input label="Id" model="form.id"></sxy-input>
                <sxy-input label="Nimi" model="form.info.label"></sxy-input>
                <sxy-input label="Status" model="form.info.status"></sxy-input>
                <sxy-input label="Tyyppi" model="form.info.type"></sxy-input>
              </fieldset>
            </div>
            <div class="col-sm-6">
              <fieldset>
                <legend>Räätälöinti</legend>
                <div ng-if="$ctrl.usecase == 'none'">
                  <salaxy-input-enum label="Valitse räätälöinti" ng-if="$ctrl.usecases" name="uri" ng-model="$ctrl.current.usecase.uri" options="$ctrl.usecases"></salaxy-input-enum>
                  <div ng-if="!$ctrl.current.usecase.uri" class="alert alert-danger">
                    Tälle datasetille ei ole määritetty räätälöintiä (datamalli ja toiminnallisuudet).
                  </div>
                  <div ng-if="$ctrl.current.usecase.uri" class="alert alert-info">
                    <p>
                      Räätälöintiä ei löytynyt tai ei vielä ladattu (tallenna ladataksesi): {{ $ctrl.current.usecase.uri }}
                    </p>
                  </div>
                </div>
                <div ng-if="$ctrl.usecase != 'none'">
                  <p><strong>URI:</strong> <code>{{ $ctrl.current.usecase.uri }}</code></p>
                  <sxy-input label="Nimi" model="form.usecase.label" read-only="true"></sxy-input>
                  <sxy-input label="Kuvaus" model="form.usecase.description" read-only="true"></sxy-input>
                  <salaxy-form-group name="btnEdit" label="Muokkaa">
                    <a ng-href="#/usecases/details/{{ $ctrl.usecase.id }}@{{ $ctrl.usecase.owner }}" target="_blank" ng-disabled="!$ctrl.usecase || $ctrl.usecase.isReadOnly"
                      class="btn btn-default btn-sm">Muokkaa (uuteen ikkunaan)...</a>
                  </salaxy-form-group>
                  <salaxy-json-formatter json="$ctrl.usecase" key="'Yksityiskohdat...'" open="0"></salaxy-json-formatter>
                </div>
              </fieldset>
            </div>
          </div>
        </sxy-form>
      </div>
      <div ng-repeat="dataObj in $ctrl.current.data" ng-if="$ctrl.currentSection == ('table' + $index)" class="height100 form-horizontal">
        <style>
          /* TODO: Move to less */
          .salaxy-tab-height100 {
            height: 100%;
          }

          .salaxy-tab-height100 .tab-content {
            height: calc(100% - 43px);
          }

          .salaxy-tab-height100 .tab-pane {
            height: 100%;
          }
        </style>
        <salaxy-tab-buttons
          current-tab="$ctrl.currentTab"
          options="[
            { value: 'grid', text: 'Grid' },
            { value: 'properties', text: 'Ominaisuudet' },
            { value: 'validation', text: 'Validation' }
          ]"
          tabs-id="datasetDetailsFull">
        </salaxy-tab-buttons>
        <div class="tab-content" id="tab-content-datasetDetailsFull">
          <div class="tab-pane" id="grid-tab">
            <div style="height: 100%">
              <sxy-grid data="dataObj.content" schema-def="$ctrl.getSchamaDef($index)"
                schema="{{$ctrl.current.data[$index].schema}}"
                include="dataObj.views[0].include"
                exclude="dataObj.views[0].exclude"></sxy-grid>
            </div>
          </div>
          <div class="tab-pane" id="properties-tab">
            <div class="row">
              <div class="col-sm-6">
                <salaxy-input label="Label" name="label" ng-model="dataObj.label"></salaxy-input>
                <salaxy-input label="Technical name" name="name" ng-model="dataObj.name"></salaxy-input>
                <salaxy-form-group name="btnDeleteIndex" label="Remove">
                  <button type="button" ng-click="$ctrl.deleteObject($index)" class="btn btn-danger btn-sm" ng-disabled="$ctrl.usecase.isReadOnly">Remove object</button>
                </salaxy-form-group>
              </div>
              <div class="col-sm-6">
                <salaxy-input-enum label="Schema document" name="schemaDoc" ng-model="dataObj.schemaDoc" disable-cache="true"
                  options="$ctrl.getSchemaDocs()"></salaxy-input-enum>
                <salaxy-input-typeahead label="Schema" name="schema" ng-model="dataObj.schema" disable-cache="true"
                  options="$ctrl.getSchemas(dataObj.schemaDoc)" disabled="(dataObj.schemaDoc || 'any') == 'any'"></salaxy-input-typeahead>
                <!-- TODO: isArray -->
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <fieldset>
                  <legend>Include fields (default view)</legend>
                  <ul class="list-group">
                    <li class="list-group-item" ng-repeat="incl in dataObj.views[0].include track by $index">
                      {{ incl }}
                      <div class="float-end">
                        <button class="btn btn-primary btn-xs" title="Move up" ng-click="$ctrl.arraymove($ctrl.current.data[$parent.$index].views[0].include, $index, -1)">&#9650;</button>
                        <button class="btn btn-primary btn-xs" title="Move down" ng-click="$ctrl.arraymove($ctrl.current.data[$parent.$index].views[0].include, $index, +1)">&#9660;</button>
                        <button class="btn btn-default btn-xs" title="Delete" ng-click="$ctrl.current.data[$parent.$index].views[0].include.splice($index, 1)">&#10060;</button>
                      </div>
                    </li>
                    <li class="list-group-item" ng-if="!dataObj.views[0].include.length">No rows selected: All columns</li>
                  </ul>
                  <div style="display: inline-block;">
                    <salaxy-input-typeahead label="Add new property" name="addProp" label-type="plain"
                      ng-model="$ctrl.tempNewProperty" disable-cache="true"
                      ng-change="$ctrl.addViewItem($index, 'include', $ctrl.tempNewProperty);$ctrl.tempNewProperty=null"
                      options="$ctrl.getAllPropertiesOfSchema($index)"></salaxy-input-typeahead>
                  </div>
                  <button type="button" class="btn btn-default btn-sm" ng-click="$ctrl.addViewItem($index, 'include', $ctrl.tempNewProperty);$ctrl.tempNewProperty=null">Add</button>
                </fieldset>
              </div>
              <div class="col-sm-6">
                <fieldset>
                  <legend>Exclude fields (default view)</legend>
                  <ul class="list-group">
                    <li class="list-group-item" ng-repeat="incl in dataObj.views[0].exclude track by $index">
                      {{ incl }}
                      <div class="float-end">
                        <button class="btn btn-primary btn-xs" title="Move up" ng-click="$ctrl.arraymove($ctrl.current.data[$parent.$index].views[0].exclude, $index, -1)">&#9650;</button>
                        <button class="btn btn-primary btn-xs" title="Move down" ng-click="$ctrl.arraymove($ctrl.current.data[$parent.$index].views[0].exclude, $index, +1)">&#9660;</button>
                        <button class="btn btn-default btn-xs" title="Delete" ng-click="$ctrl.current.data[$parent.$index].views[0].exclude.splice($index, 1)">&#10060;</button>
                      </div>
                    </li>
                    <li class="list-group-item" ng-if="!dataObj.views[0].exclude.length">No rows selected: All columns</li>
                  </ul>
                  <div style="display: inline-block;">
                    <salaxy-input-typeahead label="Add new property" name="addProp" label-type="plain"
                      ng-model="$ctrl.tempNewProperty" disable-cache="true"
                      ng-change="$ctrl.addViewItem($index, 'exclude', $ctrl.tempNewProperty);$ctrl.tempNewProperty=null"
                      options="$ctrl.getAllPropertiesOfSchema($index)"></salaxy-input-typeahead>
                  </div>
                  <button type="button" class="btn btn-default btn-sm" ng-click="$ctrl.addViewItem($index, 'exclude', $ctrl.tempNewProperty);$ctrl.tempNewProperty=null">Add</button>
                </fieldset>
              </div>
            </div>
          </div>
          <div class="tab-pane" id="validation-tab">
            <p>TODO: Validation</p>
          </div>
        </div>
      </div>
      <div ng-if="$ctrl.currentSection == 'debugger'">
        <salaxy-json-formatter json="$ctrl.current" key="'Data'" open="1"></salaxy-json-formatter>
      </div>
    </div>
  </div>
</div>`), s.put("salaxy-components/workflow/usecases/UsecaseDetails.html", `<main class="salaxy-content sxytpl-usecases-details">
  <div class="btn-toolbar" style="margin-left: 195px; margin-bottom: 2px;">
    <div class="btn-group">
      <button type="button" class="btn btn-primary" ng-disabled="!$ctrl.current || $ctrl.current.isReadOnly" ng-click="$ctrl.save()" sxy-text="SALAXY.UI_Terms.save"></button>
      </button>
      <button type="button" class="btn btn-default" ng-click="$ctrl.showCopyAsNew($ctrl.current)" sxy-text="SALAXY.UI_Terms.copyAsNew"></button>
      <button class="btn btn-default" ng-click="$ctrl.reload()"><i class="bi bi-arrow-repeat" aria-hidden="true"></i></button>
    </div>
   
    <div class="btn-group ms-1">
      <div class="form-group" style="line-height: 34px;">
        <strong> &nbsp; Nimi:</strong> {{$ctrl.current.label}}
      </div>
    </div>
    <div class="btn-group ms-auto">
      <button type="button" class="btn btn-danger" ng-disabled="!$ctrl.current || $ctrl.current.isReadOnly" ng-click="$ctrl.delete($ctrl.current)" sxy-text="SALAXY.UI_Terms.delete" title="{{ 'SALAXY.UI_Terms.delete' | sxyTranslate}}"></button>
    </div>
  </div>
  <div ng-init="$ctrl.currentSection = 'basicInfo'" style="display: flex">
    <div style="flex: 0 0 200px;">
      <salaxy-toggle-buttons ng-model="$ctrl.currentSection" 
        options="[
            { value: 'basicInfo', label: 'Perustiedot' },
            { value: 'schemas', label: 'Datamalli' },
            { value: 'scripts', label: 'Skriptit' },
            { value: 'schema', label: 'Schema' },
            { value: 'views', label: 'Käyttöliittymä' },
            { value: 'tester', label: 'Testaa' },
            { value: 'debugger', label: 'Debugger' }
        ]" 
        type="block">
      </salaxy-toggle-buttons>
    </div>
    <div ng-if="$ctrl.current" style="flex: 1 1 100%;margin-left: -1px; height: calc(100vh - 200px); overflow-y: auto; border: solid 1px #009fd8; padding: 10px;">
      <div ng-if="$ctrl.currentSection == 'basicInfo'" class="form-horizontal">
        <div class="row">
          <div class="col-sm-6">
            <sxy-form open-api="salaxy-secure/schemas/v02.json" type="Usecase" auto-gen="false" debugger="false" model="$ctrl.current">
              <div>
                <fieldset>
                  <legend>Perustiedot</legend>
                  <p ng-if="$ctrl.current.id"><strong>URI:</strong> <code>{{ $ctrl.current.uri }}</code></p>
                  <sxy-input label="Id" model="form.id"></sxy-input>
                  <sxy-input label="Nimi" model="form.label"></sxy-input>
                  <sxy-input label="Kuvaus" model="form.description"></sxy-input>
                  <sxy-input label="Ikoni / kuva" model="form.icon"></sxy-input>
                  <sxy-input label="Objektin tyyppi" model="form.itemType"></sxy-input>
                  <sxy-input label="Tila" model="form.status"></sxy-input>
                  <sxy-input label="Järjestysnumero" model="form.order"></sxy-input>
                </fieldset>
              </div>
            </sxy-form>
          </div>
          <div class="col-sm-6 col-md-4">
            <fieldset>
              <legend>Perustietojen esikatselu</legend>
              <div class="card">
                <div class="text-center card-pic-fixed" style="height: 150px;">
                  <img ng-if="$ctrl.current.icon[0] == 'h'" ng-src="{{$ctrl.current.icon}}">
                  <div ng-if="$ctrl.current.icon[0] != 'h'" class="bg-primary card-pic-icon">
                    <i class="bi" ng-class="($ctrl.current.icon || 'bi') == 'bi' ? 'bi-currency-euro' : $ctrl.current.icon" aria-hidden="true"></i>
                  </div>
                  <span class="badge float-end" ng-class="$ctrl.getStatusBgColor($ctrl.current.status)">{{ "UsecaseStatus." + $ctrl.current.status | sxyEnum }}</span>
                </div>
                <div class="card-body">
                  <h3 class="truncate">{{ $ctrl.current.label }}</h3>
                  <p style="height: 80px;overflow: hidden">{{ $ctrl.current.description }}</p>
                  <p>
                    <a ng-href="#/calc/usecase/new?usecase=%2FUsecaseDefinition%2F{{ $ctrl.current.owner }}%2F{{ $ctrl.current.id }}" class="btn btn-primary" role="button" style="color: white" sxy-text="SALAXY.UI_Terms.createNew" ps="..."></a>
                  </p>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
      <ng-include src="'salaxy-components/workflow/usecases/UsecaseDetails_schemas.html'"></ng-include>
      <ng-include src="'salaxy-components/workflow/usecases/UsecaseDetails_scripts.html'"></ng-include>
      <ng-include src="'salaxy-components/workflow/usecases/UsecaseDetails_views.html'"></ng-include>
      <div ng-if="$ctrl.currentSection == 'schema'" class="height100">
        <sxy-code-editor read-only="$ctrl.current.isReadOnly" lang="json" ng-model="$ctrl.editableSchema"></sxy-code-editor>
      </div>
      <ng-include src="'salaxy-components/workflow/usecases/UsecaseDetails_tester.html'"></ng-include>
      <div ng-if="$ctrl.currentSection == 'debugger'">
        <div class="row">
          <div class="col-sm-6">
            <salaxy-json-formatter json="$ctrl.current" key="'Usecase'" open="1"></salaxy-json-formatter>
          </div>
          <div class="col-sm-6">
            <salaxy-json-formatter json="$ctrl.currentItem" key="'Current item'" open="1"></salaxy-json-formatter>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>`), s.put("salaxy-components/workflow/usecases/UsecaseDetails_schemas.html", `<div ng-if="$ctrl.currentSection == 'schemas'">
  <div class="btn-toolbar" role="toolbar">
    <button type="button" ng-click="$ctrl.createSchema()" class="btn btn-primary">Lisää uusi</button>
    <div class="btn-group dropdown">
      <button id="selectAction" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown">
        <span ng-if="!$ctrl.currentSchema">Valitse datamalli...</span>
        <span ng-if="$ctrl.currentSchema">{{ $ctrl.currentSchema.title || ("Ei nimeä " + ($index + 1)) }}</span>
      </button>
      <ul class="dropdown-menu" role="menu" aria-labelledby="selectAction">
        <li ng-repeat="(key, schema) in $ctrl.current.schema.components.schemas" ng-click="$ctrl.setCurrentSchema(key)" role="menuitem">
          <a href="" class="dropdown-item">{{ schema.title || ("Ei nimeä " + ($index + 1)) }} ({{ key }})</a>
        </li>
      </ul>
    </div>
    <button type="button" ng-click="$ctrl.deleteSchema($ctrl.currentSchemaKey)" ng-disabled="!$ctrl.currentSchema" class="btn btn-danger">Poista</button>
  </div>
  <hr />
  <div ng-if="!$ctrl.currentSchema" class="alert alert-info">
    Lisää uusi datamalli tai valitse yksi muokattavista.
  </div>
  <div class="row form-horizontal" ng-if="$ctrl.currentSchema">
    <div class="col-sm-6">
      <salaxy-input label="Nimi" name="{{ 'schemaTitle' + $index }}" ng-model="$ctrl.currentSchema.title"></salaxy-input>
    </div>
    <div class="col-sm-6">
      <salaxy-input label="Tekninen nimi" name="{{ 'schemaKey' + $index }}" ng-model="$ctrl.currentSchemaKey" readonly="true"></salaxy-input>
    </div>
    <div class="col-12">
      <h4>Datamallin muokkaus</h4>
      <sxy-schema-editor model="$ctrl.currentSchema.properties"></sxy-schema-editor>
    </div>
  </div>
</div>`), s.put("salaxy-components/workflow/usecases/UsecaseDetails_scripts.html", `<div ng-if="$ctrl.currentSection == 'scripts'">
  <div class="btn-toolbar" role="toolbar">
    <button type="button" ng-click="$ctrl.createAction()" class="btn btn-primary">Lisää uusi</button>
    <div class="btn-group dropdown">
      <button id="selectAction" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown" ng-disabled="$ctrl.current.actions.length == 0">
        <span ng-if="!$ctrl.currentAction">Valitse skripti...</span>
        <span ng-if="$ctrl.currentAction">{{ $ctrl.currentAction.label || ("Ei nimeä " + ($index + 1)) }}</span>
      </button>
      <ul class="dropdown-menu" role="menu" aria-labelledby="selectAction">
        <li ng-repeat="action in $ctrl.current.actions" ng-click="$ctrl.currentAction = action" role="menuitem">
          <a href="" class="dropdown-item">{{ action.label || ("Ei nimeä " + ($index + 1)) }}</a>
        </li>
      </ul>
    </div>
    <button type="button" ng-click="$ctrl.deleteAction($ctrl.currentAction)" ng-disabled="!$ctrl.currentAction" class="btn btn-danger">Poista</button>
    <button type="button" ng-click="$ctrl.executeAction()" class="btn float-end" ng-class="'btn-' + ($ctrl.currentAction.uiColor || 'default')"
      ng-disabled="!$ctrl.currentAction.content">
      {{ $ctrl.currentAction.uiText || "Käynnistä" }}
    </button>
  </div>
  <hr />
  <div ng-if="!$ctrl.currentAction" class="alert alert-info">
    Lisää uusi skripti tai valitse yksi muokattavista.
  </div>
  <div class="row" ng-if="$ctrl.currentAction">
    <div class="col-sm-6">
      <salaxy-input label="Nimi" name="actionTitle" ng-model="$ctrl.currentAction.label"></salaxy-input>
      <salaxy-input label="Kuvaus" name="actionDescription" ng-model="$ctrl.currentAction.description"></salaxy-input>
      <salaxy-input-enum label="Tyyppi" name="actionType" ng-model="$ctrl.currentAction.actionType" enum="UsecaseActionType"></salaxy-input-enum>
    </div>
    <div class="col-sm-6">
      <salaxy-input label="Napin teksti" name="actionUiText" ng-model="$ctrl.currentAction.uiText"></salaxy-input>
      <salaxy-input-enum label="Napin väri" name="actionUiColor" ng-model="$ctrl.currentAction.uiColor" enum="WorkflowEventUi"></salaxy-input-enum>
    </div>
    <div class="col-12">
      <div><small>Globals in this script:
          <code>item: <span>{{ $ctrl.itemType || 'any / unknown' }}</span></code>,
          <code>session: UserSession</code>, <code>core: @salaxy/core</code>
          <span ng-if="$ctrl.currentExecutor.isAsync">, <code>ajax: Ajax</code></span>
        </small></div>
      <sxy-code-editor read-only="$ctrl.current.isReadOnly" item-type="$ctrl.itemType || 'any'" ng-model="$ctrl.currentAction.content"></sxy-code-editor>
      <pre class="alert" ng-class="'alert-' + ($ctrl.currentExecutor.status || 'default')">{{ $ctrl.currentExecutor.result | json }}</pre>
    </div>
  </div>
</div>`), s.put("salaxy-components/workflow/usecases/UsecaseDetails_tester.html", `<div ng-if="$ctrl.currentSection == 'tester'" ng-init="$ctrl.refreshCurrentInCache();$ctrl.currentView=$ctrl.currentView">
  <div>
    <div class="btn-toolbar">
      <div class="btn-group">
        <button type="button" class="btn btn-primary" ng-click="$ctrl.selectItem('new')">Luo uusi</button>
        <button type="button" class="btn btn-default" ng-click="$ctrl.selectItem('select')">Valitse testitietue..</button>
        <button type="button" class="btn btn-default float-end" ng-click="$ctrl.selectItem(null)">Tyhjennä</button>
      </div>
      <div class="btn-group dropdown">
        <button id="selectView" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown" ng-disabled="$ctrl.current.views.length == 0">
          <span ng-if="!$ctrl.currentView">Oletusnäkymä</span>
          <span ng-if="$ctrl.currentView">{{ $ctrl.currentView.label || ("Ei nimeä " + ($index + 1)) }}</span>
        </button>
        <ul class="dropdown-menu"  role="menu" aria-labelledby="selectView">
          <li ng-click="$ctrl.currentView = null" role="menuitem">
            <a href=""  class="dropdown-item">Oletusnäkymä</a>
          </li>
          <li ng-repeat="view in $ctrl.current.views" ng-click="$ctrl.currentView = view" role="menuitem">
            <a href="" class="dropdown-item">{{ view.label || ("Ei nimeä " + ($index + 1)) }}</a>
          </li>
        </ul>
      </div>
    </div>
    <div ng-if="!$ctrl.currentItem" class="container alert alert-info">
      <p>Valitse testitietue ja näkymä, jota haluat testata.</p>
    </div>
    <div class="container" ng-if="$ctrl.currentItem" ng-switch="$ctrl.current.itemType" ng-init="temp = $ctrl.currentItem">
      <div ng-switch-when="calculation">
        <div ng-if="$ctrl.currentView">
          <div ng-controller="Calculator2022Controller as $ctrl" ng-init="$ctrl.model = temp">
            <ng-include src="'salaxy-dynamic-templates/usecase-custom-view.html'"></ng-include>
          </div>
        </div>
        <div ng-if="!$ctrl.currentView">
          <salaxy-calc model="$ctrl.currentItem"></salaxy-calc>
        </div>
      </div>
      <div ng-switch-when="dataset">
        <div ng-if="$ctrl.currentView">
          <div ng-controller="DatasetsCrudController as $ctrl" ng-init="$ctrl.model = temp">
            <ng-include src="'salaxy-dynamic-templates/usecase-custom-view.html'"></ng-include>
          </div>
        </div>
        <div ng-if="!$ctrl.currentView">
          <salaxy-dataset-details mode="data-edit" model="$ctrl.currentItem"></salaxy-dataset-details>
        </div>
      </div>
      <div ng-switch-default>
        <p>
          TODO: Testinäkymää ei ole toteutettu datatyypille
          <strong>{{$ctrl.current.itemType}}</strong>.
        </p>
      </div>
    </div>
  </div>
</div>`), s.put("salaxy-components/workflow/usecases/UsecaseDetails_views.html", `<div ng-if="$ctrl.currentSection == 'views'">
  <div class="btn-toolbar" role="toolbar">
    <button type="button" ng-click="$ctrl.createView()" class="btn btn-primary">Lisää uusi</button>
    <div class="btn-group dropdown">
      <button id="selectView" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown" ng-disabled="$ctrl.current.views.length == 0">
        <span ng-if="!$ctrl.currentView">Valitse käyttöliittymä...</span>
        <span ng-if="$ctrl.currentView">{{ $ctrl.currentView.label || ("Ei nimeä " + ($index + 1)) }}</span>
      </button>
      <ul class="dropdown-menu"role="menu" aria-labelledby="selectView">
        <li ng-repeat="view in $ctrl.current.views" ng-click="$ctrl.currentView = view" role="menuitem">
          <a href="" class="dropdown-item">{{ view.label || ("Ei nimeä " + ($index + 1)) }}</a>
        </li>
      </ul>
    </div>
    <button type="button" ng-click="$ctrl.deleteView($ctrl.currentView)" ng-disabled="!$ctrl.currentView" class="btn btn-danger">Poista</button>
  </div>
  <hr />
  <div ng-if="!$ctrl.currentView" class="alert alert-info">
    Lisää uusi näkymä tai valitse yksi muokattavista.
  </div>
  <div class="row" ng-if="$ctrl.currentView">
    <div class="col-sm-6">
      <salaxy-input label="Nimi" name="viewTitle" ng-model="$ctrl.currentView.label"></salaxy-input>
      <salaxy-input label="Kuvaus" name="viewDescription" ng-model="$ctrl.currentView.description"></salaxy-input>
    </div>
    <div class="col-sm-6"></div>
    <div class="col-12">
      <sxy-code-editor read-only="$ctrl.current.isReadOnly" lang="html" ng-model="$ctrl.currentView.content"></sxy-code-editor>
    </div>
  </div>
</div>`), s.put("salaxy-components/workflow/WorkflowBadge.html", `<div ng-if="$ctrl.mode != 'horizontal'" class="salaxy-component salaxy-workflow-badge">
  <div ng-repeat="event in $ctrl.events">
    <span ng-click="$ctrl.showEventDetails(event)" class="clickable" ng-class="'badge bg-' + event.ui" title="{{ event.message + ' (' + (event.time | sxyTime)  + ')' }}">
      {{event.message}}
    </span>
  </div>
</div>
<span ng-if="$ctrl.mode == 'horizontal' && $ctrl.events.length" class="salaxy-component salaxy-workflow-badge">
  <span ng-repeat="event in $ctrl.events" ng-click="$ctrl.showEventDetails(event)" class="clickable" ng-class="'badge bg-' + event.ui"
    title="{{ event.message + ' (' + (event.time | sxyTime)  + ')' }}" style="margin-right: 4px;">{{event.message}}</span>
</span>`), s.put("salaxy-components/workflow/WorkflowButtons.html", `<div class="btn-group salaxy-workflow-buttons">
  <button class="btn btn-icon btn-transparent" ng-class="$ctrl.hasWorkflowEvent('PartnerMessageClosed') ? 'text-success' : 'text-muted'" ng-disabled="$ctrl.disabled"
    ng-click="$ctrl.buttonClick('close')" title="{{ $ctrl.getWorkflowEvent('PartnerMessageClosed').message || ('SALAXY.UI_Terms.markChecked' | sxyTranslate)}}">
    <span ng-if="$ctrl.getWorkflowEvent('PartnerMessageClosed').message" class="badge bg-success">{{$ctrl.getWorkflowEvent('PartnerMessageClosed').message}}</span>
    <i ng-if="!$ctrl.getWorkflowEvent('PartnerMessageClosed').message" class="bi bi-check-circle-fill bi-2x" ng-class="{ 'text-muted': $ctrl.isUpdating }"></i>
  </button>
  <button ng-disabled="$ctrl.disabled"
    title="{{ $ctrl.getWorkflowEvent('PartnerMessageIssue').message || ('SALAXY.NG1.WorkFlowIssueComponent.buttons.showEditor' | sxyTranslate) }}"
    ng-click="$ctrl.buttonClick('issue')" class="btn btn-icon btn-transparent" ng-class="$ctrl.hasWorkflowEvent('PartnerMessageIssue') ? 'text-danger' : 'text-muted'">
    <span ng-if="$ctrl.getWorkflowEvent('PartnerMessageIssue').message" class="badge bg-danger">{{$ctrl.getWorkflowEvent('PartnerMessageIssue').message}}</span>
    <i ng-if="!$ctrl.getWorkflowEvent('PartnerMessageIssue').message" class="bi bi-exclamation-circle-fill bi-2x" ng-class="{ 'text-muted': $ctrl.isUpdating }"></i>
  </button>
  <div ng-if="$ctrl.showWorkflowAssign" class="btn-group workflow-assign dropdown d-flex align-items-center">
    <button id="workflowAssign" type="button" class="btn btn-default dropdown-toggle" data-bs-toggle="dropdown" ng-disabled="$ctrl.disabled">
      <salaxy-avatar ng-if="$ctrl.getAssignedTo().id" avatar="$ctrl.getAssignedTo().avatar"></salaxy-avatar>
      <span class="workflow-assign-title">{{ $ctrl.getAssignedTo().email ||
        $ctrl.getAssignedTo().avatar.displayName || "Osoita henkilölle..." }}</span>
    </button>
    <ul class="dropdown-menu"  role="menu" aria-labelledby="workflowAssign">
      <li role="menuitem" ng-if="$ctrl.getAssignedTo().id">
        <a href=""ng-click="$ctrl.buttonClick('assign', undefined)" class="dropdown-item">Poista valinta</a>
      </li>
      <li role="menuitem" ng-repeat="credential in $ctrl.credentials" ng-class="{ active: credential == $ctrl.getAssignedTo() }">
        <a href="" ng-click="$ctrl.buttonClick('assign', credential)" class="dropdown-item d-flex align-items-center">
          <salaxy-avatar avatar="credential.avatar"></salaxy-avatar>
          <span>&nbsp; {{ credential.email || credential.avatar.displayName }}</span>
        </a>
      </li>
    </ul>
  </div>
</div>`), s.put("salaxy-components/workflow/WorkflowReopen.html", `<button class="btn btn-sm btn-secondary" ng-disabled="$ctrl.disabled" ng-class="{muted : $ctrl.isUpdating}" ng-if="$ctrl.hasWorkflowEvent('PartnerMessageClosed') && $ctrl.apiCtrl.role === 'owner'" ng-click="$ctrl.deleteWorkflowEvent('PartnerMessageClosed')">
  Avaa keskustelu
</button>`));
}]), Lk = class Lk {
  constructor(t, e, a, n, i, r) {
    this.ajax = t, this.$sce = e, this.$window = a, this.$location = n, this.$timeout = i, this.sessionService = r;
  }
  /**
   * Implement IController
   */
  $onInit() {
    this.$window.addEventListener("message", (t) => this.receiveUrl(t), !1);
  }
  /** Get Archive page (in iframe) */
  getArchivePage() {
    const t = `${salaxy.config.wwwServer}/YearlyLegacy/Open?access_token=${this.ajax.getCurrentToken()}`;
    return this.$sce.trustAsResourceUrl(t);
  }
  /** TODO */
  receiveUrl(t) {
    t && t.data && t.data.eventType === "legacyRedirect" && t.data.calcId && this.$timeout(() => {
      this.$location.path("/calc/details/" + t.data.calcId);
    });
  }
  /** Get logout url */
  signOut() {
    const t = `${salaxy.config.wwwServer}`;
    this.sessionService.signOut(t);
  }
};
Lk.$inject = [
  "AjaxNg1",
  "$sce",
  "$window",
  "$location",
  "$timeout",
  "SessionService"
];
let ww = Lk;
const Dk = class Dk {
};
Dk.sitemap = [
  {
    title: "SALAXY.NG1_Sitemap.personalWeb.home",
    url: "#/",
    id: "home",
    isFullWidth: !0,
    cssClass: "double-sidebar"
  },
  {
    title: "SALAXY.NG1_Sitemap.personalWeb.taxcards",
    url: "#/taxcards",
    id: "taxcards"
  },
  {
    title: "SALAXY.NG1_Sitemap.personalWeb.calculations.main",
    url: "#/calc",
    id: "calc",
    children: [
      {
        title: "SALAXY.NG1_Sitemap.personalWeb.calculations.paid",
        url: "#/calc/paid"
      },
      {
        title: "SALAXY.NG1_Sitemap.personalWeb.calculations.sent",
        url: "#/calc/sent"
      },
      {
        title: "SALAXY.NG1_Sitemap.personalWeb.calculations.draft",
        url: "#/calc/draft"
      },
      {
        title: "SALAXY.NG1_Sitemap.personalWeb.calculations.error",
        url: "#/calc/error",
        id: "error"
      },
      {
        title: "SALAXY.NG1_Sitemap.personalWeb.calculations.new",
        url: "#/calc/details/new",
        id: "new",
        visibility: "hidden"
      },
      {
        title: "SALAXY.NG1_Sitemap.personalWeb.calculations.calc",
        url: "#/calc/details/*",
        id: "calc",
        visibility: "hidden"
      },
      {
        title: "SALAXY.NG1_Sitemap.personalWeb.calculations.share",
        url: "#/calc/sharing/*",
        id: "calcSharing",
        visibility: "hidden"
      }
    ]
  },
  {
    title: "Työnantajat",
    url: "#/employers",
    id: "employers",
    roles: "test"
  },
  {
    title: "SALAXY.NG1_Sitemap.personalWeb.archive.main",
    url: "#/archive/worker-report",
    id: "archive",
    children: [
      {
        title: "SALAXY.NG1_Sitemap.personalWeb.archive.workerReport",
        url: "#/archive/worker-report"
      },
      {
        title: "SALAXY.NG1_Sitemap.personalWeb.employerArchive.main",
        url: "#/archive/employer-archive",
        id: "employer-archive",
        children: [
          {
            title: "SALAXY.NG1_Sitemap.personalWeb.employerArchive.employerPaid",
            url: "#/archive/employer-paid"
          },
          {
            title: "SALAXY.NG1_Sitemap.personalWeb.employerArchive.employerReport",
            url: "#/archive/employer-report"
          },
          {
            title: "SALAXY.NG1_Sitemap.personalWeb.employerArchive.householdYears.main",
            url: "#/household-years/active",
            id: "householdYears",
            children: [
              {
                title: "SALAXY.NG1_Sitemap.personalWeb.employerArchive.householdYears.details",
                url: "#/household-years/details/*",
                visibility: "hidden",
                id: "details"
              }
            ]
          },
          {
            title: "SALAXY.NG1_Sitemap.personalWeb.archive.householdDeductionReport",
            url: "#/archive/household-deduction-report",
            id: "householdDeductionReport",
            visibility: "hidden"
          }
        ]
      }
    ]
  },
  {
    title: "SALAXY.NG1_Sitemap.personalWeb.account",
    url: "#/account",
    id: "account"
  },
  {
    title: "SALAXY.NG1_Sitemap.personalWeb.abc",
    url: "https://help.palkkaus.fi/hc/fi",
    id: "abc",
    isFullWidth: !0
  }
];
let Aw = Dk;
wt.module("palkkaus.web.personal", ["ngRoute", "salaxy.ng1.components.all"]).constant("SITEMAP", Aw.sitemap).config(["RouteHelperProvider", (s) => {
  const t = "salaxy-components/pages-personal/";
  s.setCustomSectionRoot("salaxy-components/pages-personal").homeDefault("home").defaultSection("home", ["timeline-tester"], "./app/views/ng1/pages-undercon", t + "home").defaultSection("calc", [], "./app/views/ng1/pages-undercon", t + "calc").defaultSection("workers", [], "./app/views/ng1/pages-undercon", t + "workers").defaultSection("account", [], "./app/views/ng1/pages-undercon", t + "account").defaultSection("archive", [], "./app/views/ng1/pages-undercon", t + "archive").defaultSection("taxcards", [], "./app/views/ng1/pages-undercon", t + "taxcards").defaultSection("employers", [], "./app/views/ng1/pages-undercon", t + "employers").defaultSection("employment", [], "./app/views/ng1/pages-undercon", t + "employment").defaultSection("calc-household", [], "./app/views/ng1/pages-undercon", t + "calc").defaultSection("workers-household", [], "./app/views/ng1/pages-undercon", t + "workers").defaultSection("account-household", [], "./app/views/ng1/pages-undercon", t + "account").defaultSection("taxcards-household", [], "./app/views/ng1/pages-undercon", t + "taxcards").defaultSection("payroll").customSection("messages").defaultSection("reports").otherwiseDefault();
}]).config(Hv).config(["$httpProvider", (s) => {
  s.interceptors.push(iC.factory(/views\//, "YYYYMMDDHH"));
}]).controller({ PersonalWebLegacyController: ww }).run(["UiHelpers", (s) => {
}]).run(["SessionService", "$rootScope", (s, t) => {
  L.setLocalesPath("/locales"), s.onAuthenticatedSession(t, () => {
    s.isInRole("household") && (s.personAccount.lastLoginAsServer = s.personAccount.lastLoginAs, s.personAccount.lastLoginAs = Ws.Worker);
  });
}]);
export {
  a9 as AbsencePeriods,
  Du as AbsencePeriodsController,
  Hl as AccountAuthorizationController,
  O5 as AccountAuthorizationPerson,
  z6 as AccountAvatarEdit,
  M5 as AccountAvatarEditPerson,
  B6 as AccountContactEdit,
  X5 as AccountContactEditPerson,
  H5 as AccountDetailsEditPerson,
  G5 as AccountDetailsPerson,
  N6 as AccountInfo,
  U5 as AccountInfoPerson,
  F5 as AccountInsuranceEditPerson,
  F8 as AccountReset,
  uy as AccountResetController,
  x8 as Accountant,
  Zg as AccountantController,
  dw as AccountingChannelSettingsController,
  f8 as AccountingHolidayPayDebtReportQuery,
  Kg as AccountingHolidayPayDebtReportQueryController,
  Su as AccountingReportCrudController,
  lw as AccountingReportDisplayController,
  t8 as AccountingReportList,
  e8 as AccountingReportQuery,
  Xg as AccountingReportQueryController,
  a8 as AccountingReportRows,
  Gg as AccountingReportRowsController,
  n8 as AccountingReportTools,
  Hg as AccountingReportToolsController,
  s8 as AccountingReportViewer,
  m8 as AccountingRowReport,
  Wg as AccountingRowReportController,
  w8 as AccountingSettings,
  ty as AccountingTargetCrudController,
  A8 as AccountingTargetDetails,
  C8 as AccountingTargetSettings,
  s5 as ActionButton,
  lg as ActionButtonController,
  sm as AjaxNg1,
  i5 as Alert,
  og as AlertController,
  Lv as AlertService,
  nn as ApiCrudObjectController,
  fa as ApiCrudObjectControllerBindings,
  Hv as AppInsightExceptionTracking,
  XA as AppendNodeDirective,
  R6 as AssurePartner,
  Y6 as AuthCard,
  qv as AuthorizedAccountService,
  _6 as AuthorizedAccounts,
  O6 as AuthorizingAccounts,
  r5 as Avatar,
  cg as AvatarController,
  zx as BatchProcessController,
  BA as Bs5Popover,
  zA as Bs5Tooltip,
  a2 as CacheService,
  cq as Calc,
  dq as CalcChart,
  $m as CalcChartController,
  $q as CalcCostAccounting,
  Om as CalcCostAccountingController,
  uq as CalcDashboard,
  Cq as CalcEditor,
  W6 as CalcEmployment,
  mm as CalcEmploymentController,
  j5 as CalcHouseholdUsecase,
  Sm as CalcHouseholdUsecaseController,
  b5 as CalcImport,
  wg as CalcImportController,
  aq as CalcIrRows,
  km as CalcIrRowsController,
  vq as CalcLeaves,
  Gm as CalcLeavesController,
  pq as CalcList,
  hq as CalcNewIntro,
  Tq as CalcRepair,
  Hm as CalcRepairController,
  mq as CalcReport,
  Tm as CalcReportController,
  gq as CalcReports,
  Lm as CalcReportsController,
  Tx as CalcReportsDisplayController,
  yq as CalcResults,
  sq as CalcRowCostAccounting,
  Mm as CalcRowCostAccountingController,
  iq as CalcRowDimensionInput,
  Pm as CalcRowDimensionInputController,
  lq as CalcRowDocumentation,
  Em as CalcRowDocumentationController,
  oq as CalcRowFormula,
  TE as CalcRowFormulaController,
  fq as CalcRowType,
  Dm as CalcRowTypeController,
  Vl as CalcRows2019Controller,
  nq as CalcRows2019Editor,
  j6 as CalcRowsEditor,
  V5 as CalcSharing,
  wu as CalcSharingController,
  q5 as CalcSharingInfo,
  bq as CalcSharingReceiptAction,
  Nm as CalcSharingReceiptActionController,
  V6 as CalcUsecase,
  xq as CalcWorkerInfo,
  wq as CalcWorktime,
  Im as CalcWorktimeController,
  rq as CalcsIrRows,
  Rm as CalcsIrRowsController,
  wr as CalculationCrudController,
  _m as CalculationEditorController,
  i8 as CalculationReport,
  Bg as CalculationReportController,
  $s as Calculator2019Controller,
  lu as Calculator2022Controller,
  NZ as CalculatorPanels,
  Xo as CalculatorSection,
  kE as CalculatorSections,
  l5 as Calendar,
  dg as CalendarController,
  r9 as CalendarEventDetails,
  Ay as CalendarEventsCrudController,
  TZ as CalendarHelper,
  mw as CalendarOccurencesController,
  au as CertificateController,
  OL as CertificateCrudController,
  Kv as CertificateService,
  M6 as Certificates,
  o5 as Chart,
  pg as ChartController,
  ux as CompanyAccountController,
  v5 as CompanyImport,
  xg as CompanyImportController,
  P5 as CompanyInvoices,
  Dg as CompanyInvoicesController,
  kv as CompanyOnboardingController,
  ii as CompanySettingsController,
  Ct as ComponentBase,
  h9 as ComponentsRegistration,
  uR as ConfigurableGridReportControllerBase,
  Lq as ContactInfo,
  LE as ContactInfoController,
  $9 as ControllersRegistration,
  Sq as CostAccounting,
  Cc as CostAccountingController,
  $8 as CostAccountingSettings,
  pm as CredentialController,
  Jv as CredentialService,
  X6 as Credentials,
  A5 as CreditTransfer,
  Ym as CreditTransferController,
  fc as CrudControllerBase,
  Uv as CurrentRoute,
  aw as CustomerInvoiceCrudController,
  Cv as CustomerOnboardingController,
  MA as DataImportComponentBase,
  OA as DataImportControllerBase,
  c5 as DataMapper,
  l9 as DatasetDetails,
  Cy as DatasetsCrudController,
  Xq as DateRange,
  Wm as DateRangeController,
  Oq as Datepicker,
  bu as DatepickerController,
  qA as DatepickerInputValidationDirective,
  Mq as DatepickerPopup,
  Bm as DatepickerPopupController,
  xZ as DirectivesRegistration,
  sw as EditDialogController,
  We as EditDialogKnownActions,
  SZ as EditDialogParameters,
  kZ as EditDialogResult,
  dx as EmbeddedUiController,
  z5 as EmployerList,
  Eg as EmployerListController,
  B5 as EmployerReport,
  Ng as EmployerReportController,
  W5 as EmployerSelect,
  Rg as EmployerSelectController,
  hy as EmploymentCrudController,
  n9 as EmploymentDetails,
  UI as EmploymentList,
  q8 as EmploymentTaxcards,
  my as EmploymentTaxcardsController,
  pw as EmploymentWizardController,
  sc as EnumParserFunctions,
  xr as ExcelHelpers,
  Yq as ExpenseReport,
  Zx as ExportController,
  Xv as FileService,
  Cn as FilterFunctions,
  wZ as FiltersRegistration,
  Gq as FormGroup,
  Px as FormGroupController,
  Zs as GravatarHelpers,
  b8 as HolidayPayReportQuery,
  Jg as HolidayPayReportQueryController,
  r8 as HolidayReport,
  qg as HolidayReportController,
  S8 as HolidaySettings,
  B8 as HolidayYearAccrual,
  Iu as HolidayYearAccrualController,
  gy as HolidayYearCrudController,
  W8 as HolidayYearHolidays,
  Pu as HolidayYearHolidaysController,
  j8 as HolidayYearPaid,
  Eu as HolidayYearPaidController,
  Eq as HourlyReport,
  K5 as HouseholdDeductionReport,
  Yg as HouseholdDeductionReportController,
  Sv as HouseholdOnboardingController,
  Au as HouseholdYearCrudController,
  Z5 as HouseholdYearDetails,
  Q5 as HouseholdYearList,
  nC as HtmlDirective,
  Dy as IfRoleDirective,
  WA as IfSitemapDirective,
  Qx as ImportController,
  x5 as ImportStaging,
  Ag as ImportStagingController,
  Hq as Input,
  Uq as InputAccountingTarget,
  Ex as InputAccountingTargetController,
  Ia as InputBase,
  Fq as InputBoolean,
  jm as InputBooleanController,
  zq as InputCollectiveBargainAgreement,
  Vm as InputCollectiveBargainAgreementController,
  xi as InputController,
  Bq as InputCredential,
  qm as InputCredentialController,
  Wq as InputDuration,
  Km as InputDurationController,
  pR as InputEnum,
  rA as InputEnumController,
  n5 as InputHolidayMultipliers,
  mN as InputHolidayMultipliersController,
  a5 as InputHolidayRowType,
  rg as InputHolidayRowTypeController,
  jq as InputIncomeType,
  Jm as InputIncomeTypeController,
  Vq as InputNumber,
  PE as InputNumberController,
  qq as InputOccupationType,
  Nx as InputOccupationTypeController,
  Kq as InputRrule,
  ag as InputRruleController,
  Jq as InputTime,
  HE as InputTimeController,
  e5 as InputTypeahead,
  sg as InputTypeaheadController,
  k8 as Insurance,
  T8 as InsuranceSettings,
  ey as InsuranceWizardController,
  E5 as InvoiceAlerts,
  Ig as InvoiceAlertsController,
  Cr as InvoiceCrudController,
  C5 as InvoiceEdit,
  $5 as InvoiceList,
  S5 as InvoicePaymentList,
  $g as InvoicePaymentListController,
  k5 as InvoicePreview,
  I5 as InvoiceReport,
  Lg as InvoiceReportController,
  nw as InvoiceSepaController,
  D5 as InvoiceTools,
  Tg as InvoiceToolsController,
  T5 as InvoicesCreate,
  Sg as InvoicesCreateController,
  Qv as InvoicesService,
  R8 as IrDeliverySettings,
  l8 as IrEarningsPayment,
  ku as IrEarningsPaymentCrudController,
  o8 as IrEarningsPaymentList,
  c8 as IrPayerSummary,
  Tu as IrPayerSummaryCrudController,
  d8 as IrPayerSummaryList,
  d5 as JsonFormatter,
  hg as JsonFormatterController,
  Gv as JsonSchemaService,
  G6 as LanguageSelector,
  Ki as ListControllerBase,
  $r as ListControllerBaseBindings,
  jA as LoaderDirective,
  ic as LoaderInterceptor,
  H6 as LoginButton,
  Dq as MessageThread,
  yu as MessageThreadCrudController,
  _q as MessageThreadList,
  Pg as ModalGenericDialogController,
  hw as MyTaxcardsController,
  xu as NaviController,
  Bv as NaviService,
  u5 as NaviSitemap,
  p5 as NaviStarterLayout,
  vg as ODataActionsController,
  rm as ODataHelperController,
  ni as ODataQueryController,
  _5 as OdataActions,
  R5 as OdataFooter,
  Y5 as OdataTable,
  Ix as OmapalkkaController,
  Zv as OnboardingService,
  VA as OrderbyDirective,
  L8 as OwnerSettings,
  ay as OwnerSettingsController,
  Dx as PalkkausPersonalPaymentOverviewController,
  hm as PartnerController,
  tx as PartnerService,
  Aq as PayButton,
  u8 as PayCertificate,
  zg as PayCertificateController,
  kg as PaymentChannelController,
  L5 as PaymentChannelInvoicePreview,
  D8 as PaymentChannelSettings,
  ny as PaymentChannelSettingsController,
  Lx as PaymentController,
  I8 as PaymentSettings,
  Um as Payroll4AssistantController,
  gu as Payroll4CrudController,
  eq as PayrollAssistant,
  mu as PayrollCrudController,
  q6 as PayrollDetails,
  K6 as PayrollDetailsList,
  tq as PayrollDetailsSelectList,
  J6 as PayrollEdit,
  Q6 as PayrollList,
  Fh as PayrollLogic,
  Z6 as PayrollSelectList,
  ao as PersonAccountController,
  Aw as PersonalWebSiteMap,
  P8 as ProSettings,
  Fv as PromisePolyfill,
  k1 as RRuleFinnish,
  c9 as Records,
  Mg as RecordsController,
  uw as ReferenceObjectCrudController,
  p8 as ReportList,
  Ug as ReportsController,
  ex as ReportsService,
  zv as RouteHelperProvider,
  ax as RowTypeService,
  E8 as RowTypesSettings,
  sy as RowTypesSettingsController,
  px as SalaryBasesController,
  kq as SalaryDateKindButton,
  Xm as SalaryDateKindController,
  Fg as SalaryReportCrudController,
  h8 as SalaryReportList,
  cw as SalarySlipDownloadController,
  XZ as SalaxyNg1BootstrapTemplatesModule,
  MZ as SalaxyNg1ComponentsModule,
  iy as ServiceModelCrudController,
  N8 as ServiceModelDetails,
  vi as SessionController,
  nx as SessionService,
  sx as SettingsService,
  Tv as SignatureController,
  LZ as SignatureMethod,
  ix as SignatureService,
  U6 as Signing,
  im as SigningController,
  ws as SitemapHelper,
  z8 as SmokeTest,
  py as SmokeTestController,
  h5 as Spinner,
  mg as SpinnerController,
  g8 as SummaryReport,
  jg as SummaryReportController,
  rw as SummaryReportDisplayController,
  v8 as SummaryReportQuery,
  Qg as SummaryReportQueryController,
  Y8 as SxyAlert,
  _8 as SxyCodeEditor,
  ry as SxyCodeEditorController,
  O8 as SxyFieldset,
  M8 as SxyForm,
  ly as SxyFormController,
  oy as SxyFormElementController,
  X8 as SxyGrid,
  Lu as SxyGridController,
  G8 as SxyInput,
  no as SxyInputController,
  H8 as SxySchemaEditor,
  cy as SxySchemaEditorController,
  U8 as SxyTable,
  dy as SxyTableController,
  m5 as Tab,
  y5 as TabButtons,
  fg as TabButtonsController,
  gg as TabController,
  g5 as Tabs,
  yg as TabsController,
  t9 as TaxCardsList,
  fy as TaxcardCrudController,
  K8 as TaxcardDetails,
  Q8 as TaxcardIncomeLog,
  by as TaxcardIncomeLogController,
  e9 as TaxcardList,
  Z8 as TaxcardManualEdit,
  yy as TaxcardManualEditController,
  iC as TemplateInterceptor,
  sC as TextDirective,
  Zq as Textarea,
  Rq as Timer,
  iw as TimesheetWorkerDemoController,
  Qq as ToggleButtons,
  hN as ToggleButtonsController,
  Wv as UiCrudHelpers,
  jv as UiHelpers,
  f5 as UiTranslator,
  bg as UiTranslatorController,
  n2 as UiTranslatorService,
  rx as UploadService,
  o9 as UsecaseDetails,
  $y as UsecasesCrudController,
  lx as UsecasesService,
  F6 as UserInfo,
  s2 as UserSettingsService,
  t5 as ValidationSummary,
  ig as ValidationSummaryController,
  aa as ValidatorFunctions,
  Iq as VarmaBanner,
  Fm as VarmaBannerController,
  ox as VarmaPensionService,
  Pq as Welcome,
  zm as WelcomeController,
  bi as WizardController,
  Vv as WizardService,
  s9 as WorkerAbsences,
  vy as WorkerAbsencesCrudController,
  xy as WorkerAccountCrudController,
  N5 as WorkerAssure,
  wy as WorkerAssureController,
  i9 as WorkerDetails,
  $u as WorkerExpenseReportController,
  V8 as WorkerHolidays,
  Cu as WorkerHourlyReportController,
  w5 as WorkerImport,
  Cg as WorkerImportController,
  $v as WorkerOnboardingController,
  J5 as WorkerReport,
  _g as WorkerReportController,
  y8 as WorkerSummaryReport,
  Vg as WorkerSummaryReportController,
  ow as WorkerSummaryReportDisplayController,
  Og as WorkerTimerController,
  p9 as WorkflowBadge,
  Sy as WorkflowBadgeController,
  d9 as WorkflowButtons,
  Nu as WorkflowController,
  u9 as WorkflowReopen,
  cx as WorkflowService
};
//# sourceMappingURL=salaxy-lib-ng1.js.map
